import { defineComponent as $, inject as d, computed as k, openBlock as s, createElementBlock as r, mergeProps as w, unref as o, renderSlot as f, createElementVNode as e, createCommentVNode as g, createStaticVNode as j } from "vue";
const m = ["width", "height", "fill", "transform"], M = { key: 0 }, v = ["stroke"], S = { key: 1 }, H = ["stroke"], A = { key: 2 }, V = /* @__PURE__ */ e("path", { d: "M160,216h-.4a8.1,8.1,0,0,1-7.1-5.2L95.4,60.8,63.3,131.3A8,8,0,0,1,56,136H24a8,8,0,0,1,0-16H50.9L88.7,36.7A8.2,8.2,0,0,1,96.3,32a8,8,0,0,1,7.2,5.2L161,188.1l31.8-63.7A8.2,8.2,0,0,1,200,120h32a8,8,0,0,1,0,16H204.9l-37.7,75.6A8.2,8.2,0,0,1,160,216Z" }, null, -1), z = [
  V
], Z = { key: 3 }, C = ["stroke"], b = { key: 4 }, L = ["stroke"], B = { key: 5 }, P = ["stroke"], W = {
  name: "PhActivity"
}, cF1 = /* @__PURE__ */ $({
  ...W,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", M, [
        e("polyline", {
          points: "24 128 56 128 96 40 160 208 200 128 232 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, v)
      ])) : o(i) === "duotone" ? (s(), r("g", S, [
        e("polyline", {
          points: "24 128 56 128 96 40 160 208 200 128 232 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H)
      ])) : o(i) === "fill" ? (s(), r("g", A, z)) : o(i) === "light" ? (s(), r("g", Z, [
        e("polyline", {
          points: "24 128 56 128 96 40 160 208 200 128 232 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, C)
      ])) : o(i) === "thin" ? (s(), r("g", b, [
        e("polyline", {
          points: "24 128 56 128 96 40 160 208 200 128 232 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, L)
      ])) : o(i) === "regular" ? (s(), r("g", B, [
        e("polyline", {
          points: "24 128 56 128 96 40 160 208 200 128 232 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P)
      ])) : g("", !0)
    ], 16, m));
  }
}), N = ["width", "height", "fill", "transform"], F = { key: 0 }, T = ["stroke"], D = ["stroke"], R = ["stroke"], U = ["stroke"], q = ["stroke"], G = ["stroke"], E = ["stroke"], O = { key: 1 }, I = ["stroke"], K = /* @__PURE__ */ e("path", {
  d: "M208,32H64a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V40A8,8,0,0,0,208,32ZM136,144a32,32,0,1,1,32-32A32,32,0,0,1,136,144Z",
  opacity: "0.2"
}, null, -1), X = ["stroke"], J = ["stroke"], Q = ["stroke"], Y = ["stroke"], oo = ["stroke"], eo = ["stroke"], to = { key: 2 }, no = /* @__PURE__ */ e("path", { d: "M160,112a24,24,0,1,1-24-24A24.1,24.1,0,0,1,160,112Zm64-72V216a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V196H32a8,8,0,0,1,0-16H48V156H32a8,8,0,0,1,0-16H48V116H32a8,8,0,0,1,0-16H48V76H32a8,8,0,0,1,0-16H48V40A16,16,0,0,1,64,24H208A16,16,0,0,1,224,40ZM190.4,163.2A67.8,67.8,0,0,0,163,141.5a40,40,0,1,0-54,0,67.8,67.8,0,0,0-27.4,21.7,8,8,0,0,0,1.6,11.2A7.7,7.7,0,0,0,88,176a8,8,0,0,0,6.4-3.2,52,52,0,0,1,83.2,0,8.1,8.1,0,0,0,11.2,1.6A8,8,0,0,0,190.4,163.2Z" }, null, -1), so = [
  no
], ro = { key: 3 }, io = ["stroke"], lo = ["stroke"], ko = ["stroke"], co = ["stroke"], ho = ["stroke"], uo = ["stroke"], ao = ["stroke"], _o = { key: 4 }, po = ["stroke"], yo = ["stroke"], $o = ["stroke"], wo = ["stroke"], fo = ["stroke"], go = ["stroke"], xo = ["stroke"], jo = { key: 5 }, mo = ["stroke"], Mo = ["stroke"], vo = ["stroke"], So = ["stroke"], Ho = ["stroke"], Ao = ["stroke"], Vo = ["stroke"], zo = {
  name: "PhAddressBook"
}, hF1 = /* @__PURE__ */ $({
  ...zo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", F, [
        e("circle", {
          cx: "136",
          cy: "116",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, T),
        e("line", {
          x1: "32",
          y1: "108",
          x2: "56",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, D),
        e("line", {
          x1: "32",
          y1: "68",
          x2: "56",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, R),
        e("line", {
          x1: "32",
          y1: "148",
          x2: "56",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, U),
        e("line", {
          x1: "32",
          y1: "188",
          x2: "56",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, q),
        e("rect", {
          x: "40",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          transform: "translate(264 -8) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, G),
        e("path", {
          d: "M92,167.2a60,60,0,0,1,88,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, E)
      ])) : o(i) === "duotone" ? (s(), r("g", O, [
        e("circle", {
          cx: "136",
          cy: "112",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I),
        K,
        e("line", {
          x1: "32",
          y1: "108",
          x2: "56",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X),
        e("line", {
          x1: "32",
          y1: "68",
          x2: "56",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J),
        e("line", {
          x1: "32",
          y1: "148",
          x2: "56",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q),
        e("line", {
          x1: "32",
          y1: "188",
          x2: "56",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y),
        e("path", {
          d: "M88,168a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oo),
        e("rect", {
          x: "40",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          transform: "translate(264 -8) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eo)
      ])) : o(i) === "fill" ? (s(), r("g", to, so)) : o(i) === "light" ? (s(), r("g", ro, [
        e("circle", {
          cx: "136",
          cy: "112",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, io),
        e("line", {
          x1: "32",
          y1: "108",
          x2: "56",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lo),
        e("line", {
          x1: "32",
          y1: "68",
          x2: "56",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ko),
        e("line", {
          x1: "32",
          y1: "148",
          x2: "56",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, co),
        e("line", {
          x1: "32",
          y1: "188",
          x2: "56",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ho),
        e("path", {
          d: "M88,168a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uo),
        e("rect", {
          x: "40",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          transform: "translate(264 -8) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ao)
      ])) : o(i) === "thin" ? (s(), r("g", _o, [
        e("circle", {
          cx: "136",
          cy: "112",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, po),
        e("line", {
          x1: "32",
          y1: "108",
          x2: "56",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yo),
        e("line", {
          x1: "32",
          y1: "68",
          x2: "56",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $o),
        e("line", {
          x1: "32",
          y1: "148",
          x2: "56",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wo),
        e("line", {
          x1: "32",
          y1: "188",
          x2: "56",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fo),
        e("path", {
          d: "M88,168a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, go),
        e("rect", {
          x: "40",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          transform: "translate(264 -8) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xo)
      ])) : o(i) === "regular" ? (s(), r("g", jo, [
        e("circle", {
          cx: "136",
          cy: "112",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mo),
        e("line", {
          x1: "32",
          y1: "108",
          x2: "56",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mo),
        e("line", {
          x1: "32",
          y1: "68",
          x2: "56",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vo),
        e("line", {
          x1: "32",
          y1: "148",
          x2: "56",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, So),
        e("line", {
          x1: "32",
          y1: "188",
          x2: "56",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ho),
        e("path", {
          d: "M88,168a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ao),
        e("rect", {
          x: "40",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          transform: "translate(264 -8) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vo)
      ])) : g("", !0)
    ], 16, N));
  }
}), Zo = ["width", "height", "fill", "transform"], Co = { key: 0 }, bo = ["stroke"], Lo = { key: 1 }, Bo = /* @__PURE__ */ e("path", {
  d: "M128,216,88,232V200l16-16V152L24,168V136l80-40V48a24,24,0,0,1,48,0V96l80,40v32l-80-16v32L168,200v32Z",
  opacity: "0.2"
}, null, -1), Po = ["stroke"], Wo = { key: 2 }, No = /* @__PURE__ */ e("path", { d: "M240.2,136v32a7.8,7.8,0,0,1-2.9,6.2,7.9,7.9,0,0,1-6.6,1.6l-70.5-14v26.9l13.5,13.7A7.9,7.9,0,0,1,176,208v24a7.9,7.9,0,0,1-3.5,6.6A8.2,8.2,0,0,1,168,240a8,8,0,0,1-3-.6l-37-14.8L91,239.4a8,8,0,0,1-7.5-.8A7.9,7.9,0,0,1,80,232V208a8.1,8.1,0,0,1,2.3-5.7L96,188.7V161.8l-70.4,14A7.9,7.9,0,0,1,16,168V136a8.2,8.2,0,0,1,4.4-7.2L96,91V48a32,32,0,0,1,64,0V91l75.6,37.8A8.2,8.2,0,0,1,240.2,136Z" }, null, -1), Fo = [
  No
], To = { key: 3 }, Do = ["stroke"], Ro = { key: 4 }, Uo = ["stroke"], qo = { key: 5 }, Go = ["stroke"], Eo = {
  name: "PhAirplane"
}, uF1 = /* @__PURE__ */ $({
  ...Eo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Co, [
        e("path", {
          d: "M128,216,88,232V200l16-16V152L24,168V136l80-40V48a24,24,0,0,1,48,0V96l80,40v32l-80-16v32L168,200v32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bo)
      ])) : o(i) === "duotone" ? (s(), r("g", Lo, [
        Bo,
        e("path", {
          d: "M128,216,88,232V200l16-16V152L24,168V136l80-40V48a24,24,0,0,1,48,0V96l80,40v32l-80-16v32L168,200v32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Po)
      ])) : o(i) === "fill" ? (s(), r("g", Wo, Fo)) : o(i) === "light" ? (s(), r("g", To, [
        e("path", {
          d: "M128,216,88,232V200l16-16V152L24,168V136l80-40V48a24,24,0,0,1,48,0V96l80,40v32l-80-16v32L168,200v32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Do)
      ])) : o(i) === "thin" ? (s(), r("g", Ro, [
        e("path", {
          d: "M128,216,88,232V200l16-16V152L24,168V136l80-40V48a24,24,0,0,1,48,0V96l80,40v32l-80-16v32L168,200v32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Uo)
      ])) : o(i) === "regular" ? (s(), r("g", qo, [
        e("path", {
          d: "M128,216,88,232V200l16-16V152L24,168V136l80-40V48a24,24,0,0,1,48,0V96l80,40v32l-80-16v32L168,200v32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Go)
      ])) : g("", !0)
    ], 16, Zo));
  }
}), Oo = ["width", "height", "fill", "transform"], Io = { key: 0 }, Ko = ["stroke"], Xo = ["stroke"], Jo = { key: 1 }, Qo = /* @__PURE__ */ e("path", {
  d: "M26.8,80H44l20,24H96L83.5,66.5A8,8,0,0,1,91.1,56H108l44,48h56a32,32,0,0,1,32,32v24H63.8a32,32,0,0,1-30.6-22.8L19.1,90.3A8,8,0,0,1,26.8,80Z",
  opacity: "0.2"
}, null, -1), Yo = ["stroke"], oe = ["stroke"], ee = { key: 2 }, te = /* @__PURE__ */ e("path", { d: "M224,216a8,8,0,0,1-8,8H72a8,8,0,0,1,0-16H216A8,8,0,0,1,224,216ZM208,100H153.8L110.9,53.3A3.9,3.9,0,0,0,108,52H91.1a11.6,11.6,0,0,0-9.7,5,11.9,11.9,0,0,0-1.7,10.8L90.5,100H65.9L47.1,77.4A4.1,4.1,0,0,0,44,76H26.8a12.1,12.1,0,0,0-9.7,4.8,11.9,11.9,0,0,0-1.8,10.6l14,46.9A35.8,35.8,0,0,0,63.8,164H240a4,4,0,0,0,4-4V136A36,36,0,0,0,208,100Z" }, null, -1), ne = [
  te
], se = { key: 3 }, re = ["stroke"], ie = ["stroke"], le = { key: 4 }, de = ["stroke"], ke = ["stroke"], ce = { key: 5 }, he = ["stroke"], ue = ["stroke"], ae = {
  name: "PhAirplaneInFlight"
}, aF1 = /* @__PURE__ */ $({
  ...ae,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Io, [
        e("line", {
          x1: "72",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ko),
        e("path", {
          d: "M26.8,80H44l20,24H96L83.5,66.5A8,8,0,0,1,91.1,56H108l44,48h56a32,32,0,0,1,32,32v24H63.8a32,32,0,0,1-30.6-22.8L19.1,90.3A8,8,0,0,1,26.8,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xo)
      ])) : o(i) === "duotone" ? (s(), r("g", Jo, [
        Qo,
        e("line", {
          x1: "72",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yo),
        e("path", {
          d: "M26.8,80H44l20,24H96L83.5,66.5A8,8,0,0,1,91.1,56H108l44,48h56a32,32,0,0,1,32,32v24H63.8a32,32,0,0,1-30.6-22.8L19.1,90.3A8,8,0,0,1,26.8,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oe)
      ])) : o(i) === "fill" ? (s(), r("g", ee, ne)) : o(i) === "light" ? (s(), r("g", se, [
        e("line", {
          x1: "72",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, re),
        e("path", {
          d: "M26.8,80H44l20,24H96L83.5,66.5A8,8,0,0,1,91.1,56H108l44,48h56a32,32,0,0,1,32,32v24H63.8a32,32,0,0,1-30.6-22.8L19.1,90.3A8,8,0,0,1,26.8,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ie)
      ])) : o(i) === "thin" ? (s(), r("g", le, [
        e("line", {
          x1: "72",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, de),
        e("path", {
          d: "M26.8,80H44l20,24H96L83.5,66.5A8,8,0,0,1,91.1,56H108l44,48h56a32,32,0,0,1,32,32v24H63.8a32,32,0,0,1-30.6-22.8L19.1,90.3A8,8,0,0,1,26.8,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ke)
      ])) : o(i) === "regular" ? (s(), r("g", ce, [
        e("line", {
          x1: "72",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, he),
        e("path", {
          d: "M26.8,80H44l20,24H96L83.5,66.5A8,8,0,0,1,91.1,56H108l44,48h56a32,32,0,0,1,32,32v24H63.8a32,32,0,0,1-30.6-22.8L19.1,90.3A8,8,0,0,1,26.8,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ue)
      ])) : g("", !0)
    ], 16, Oo));
  }
}), _e = ["width", "height", "fill", "transform"], pe = { key: 0 }, ye = ["stroke"], $e = ["stroke"], we = { key: 1 }, fe = /* @__PURE__ */ e("path", {
  d: "M24,103.7V51.1a8,8,0,0,1,10.5-7.6L48,48,64,78,96,88V51.1a8,8,0,0,1,10.5-7.6L120,48l32,56,48.6,13.5A31.9,31.9,0,0,1,224,148.3V184L47.4,134.5A31.9,31.9,0,0,1,24,103.7Z",
  opacity: "0.2"
}, null, -1), ge = ["stroke"], xe = ["stroke"], je = { key: 2 }, me = /* @__PURE__ */ e("path", { d: "M248,216a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16H240A8,8,0,0,1,248,216Zm-24-28a4.1,4.1,0,0,0,2.4-.8A4,4,0,0,0,228,184V148.3a36.1,36.1,0,0,0-26.4-34.7l-46.9-13L123.5,46a4.3,4.3,0,0,0-2.2-1.8l-13.5-4.5A11.9,11.9,0,0,0,97,41.4a11.6,11.6,0,0,0-5,9.7V82.6L66.8,74.7,51.5,46.1a4.1,4.1,0,0,0-2.2-1.9L35.8,39.7A11.9,11.9,0,0,0,25,41.4a11.6,11.6,0,0,0-5,9.7v52.6a36.1,36.1,0,0,0,26.3,34.7l176.6,49.5Z" }, null, -1), Me = [
  me
], ve = { key: 3 }, Se = ["stroke"], He = ["stroke"], Ae = { key: 4 }, Ve = ["stroke"], ze = ["stroke"], Ze = { key: 5 }, Ce = ["stroke"], be = ["stroke"], Le = {
  name: "PhAirplaneLanding"
}, _F1 = /* @__PURE__ */ $({
  ...Le,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", pe, [
        e("line", {
          x1: "96",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ye),
        e("path", {
          d: "M24,103.7V51.1a8,8,0,0,1,10.5-7.6L48,48,64,78,96,88V51.1a8,8,0,0,1,10.5-7.6L120,48l32,56,48.6,13.5A31.9,31.9,0,0,1,224,148.3V184L47.4,134.5A31.9,31.9,0,0,1,24,103.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $e)
      ])) : o(i) === "duotone" ? (s(), r("g", we, [
        fe,
        e("line", {
          x1: "96",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ge),
        e("path", {
          d: "M24,103.7V51.1a8,8,0,0,1,10.5-7.6L48,48,64,78,96,88V51.1a8,8,0,0,1,10.5-7.6L120,48l32,56,48.6,13.5A31.9,31.9,0,0,1,224,148.3V184L47.4,134.5A31.9,31.9,0,0,1,24,103.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xe)
      ])) : o(i) === "fill" ? (s(), r("g", je, Me)) : o(i) === "light" ? (s(), r("g", ve, [
        e("line", {
          x1: "96",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Se),
        e("path", {
          d: "M24,103.7V51.1a8,8,0,0,1,10.5-7.6L48,48,64,78,96,88V51.1a8,8,0,0,1,10.5-7.6L120,48l32,56,48.6,13.5A31.9,31.9,0,0,1,224,148.3V184L47.4,134.5A31.9,31.9,0,0,1,24,103.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, He)
      ])) : o(i) === "thin" ? (s(), r("g", Ae, [
        e("line", {
          x1: "96",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ve),
        e("path", {
          d: "M24,103.7V51.1a8,8,0,0,1,10.5-7.6L48,48,64,78,96,88V51.1a8,8,0,0,1,10.5-7.6L120,48l32,56,48.6,13.5A31.9,31.9,0,0,1,224,148.3V184L47.4,134.5A31.9,31.9,0,0,1,24,103.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ze)
      ])) : o(i) === "regular" ? (s(), r("g", Ze, [
        e("line", {
          x1: "96",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ce),
        e("path", {
          d: "M24,103.7V51.1a8,8,0,0,1,10.5-7.6L48,48,64,78,96,88V51.1a8,8,0,0,1,10.5-7.6L120,48l32,56,48.6,13.5A31.9,31.9,0,0,1,224,148.3V184L47.4,134.5A31.9,31.9,0,0,1,24,103.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, be)
      ])) : g("", !0)
    ], 16, _e));
  }
}), Be = ["width", "height", "fill", "transform"], Pe = { key: 0 }, We = ["stroke"], Ne = ["stroke"], Fe = { key: 1 }, Te = /* @__PURE__ */ e("path", {
  d: "M16.9,140.4l37.7,35.3a32,32,0,0,0,38,4.3L244,92,225.4,69.2a32,32,0,0,0-41-7.3L140,88,80,68,63.5,75.1a8,8,0,0,0-2.2,13.3L92,116,64,132,36,120l-16.8,7.2A8,8,0,0,0,16.9,140.4Z",
  opacity: "0.2"
}, null, -1), De = ["stroke"], Re = ["stroke"], Ue = { key: 2 }, qe = /* @__PURE__ */ e("path", { d: "M176,216a8,8,0,0,1-8,8H24a8,8,0,0,1,0-16H168A8,8,0,0,1,176,216ZM247.1,89.5,228.5,66.7a35.9,35.9,0,0,0-46.2-8.2L139.5,83.6,81.3,64.2a4.1,4.1,0,0,0-2.9.1L61.9,71.4a12,12,0,0,0-3.3,19.9l26.6,24L63.7,127.5,37.6,116.3a4.4,4.4,0,0,0-3.2,0l-16.7,7.2a12,12,0,0,0-3.5,19.8h0l37.7,35.3a35.8,35.8,0,0,0,42.7,4.9L246,95.5a4,4,0,0,0,1.9-2.8A4.1,4.1,0,0,0,247.1,89.5Z" }, null, -1), Ge = [
  qe
], Ee = { key: 3 }, Oe = ["stroke"], Ie = ["stroke"], Ke = { key: 4 }, Xe = ["stroke"], Je = ["stroke"], Qe = { key: 5 }, Ye = ["stroke"], ot = ["stroke"], et = {
  name: "PhAirplaneTakeoff"
}, pF1 = /* @__PURE__ */ $({
  ...et,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Pe, [
        e("line", {
          x1: "24",
          y1: "216",
          x2: "168",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, We),
        e("path", {
          d: "M16.9,140.4l37.7,35.3a32,32,0,0,0,38,4.3L244,92,225.4,69.2a32,32,0,0,0-41-7.3L140,88,80,68,63.5,75.1a8,8,0,0,0-2.2,13.3L92,116,64,132,36,120l-16.8,7.2A8,8,0,0,0,16.9,140.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ne)
      ])) : o(i) === "duotone" ? (s(), r("g", Fe, [
        Te,
        e("line", {
          x1: "24",
          y1: "216",
          x2: "168",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, De),
        e("path", {
          d: "M16.9,140.4l37.7,35.3a32,32,0,0,0,38,4.3L244,92,225.4,69.2a32,32,0,0,0-41-7.3L140,88,80,68,63.5,75.1a8,8,0,0,0-2.2,13.3L92,116,64,132,36,120l-16.8,7.2A8,8,0,0,0,16.9,140.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Re)
      ])) : o(i) === "fill" ? (s(), r("g", Ue, Ge)) : o(i) === "light" ? (s(), r("g", Ee, [
        e("line", {
          x1: "24",
          y1: "216",
          x2: "168",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Oe),
        e("path", {
          d: "M16.9,140.4l37.7,35.3a32,32,0,0,0,38,4.3L244,92,225.4,69.2a32,32,0,0,0-41-7.3L140,88,80,68,63.5,75.1a8,8,0,0,0-2.2,13.3L92,116,64,132,36,120l-16.8,7.2A8,8,0,0,0,16.9,140.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ie)
      ])) : o(i) === "thin" ? (s(), r("g", Ke, [
        e("line", {
          x1: "24",
          y1: "216",
          x2: "168",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xe),
        e("path", {
          d: "M16.9,140.4l37.7,35.3a32,32,0,0,0,38,4.3L244,92,225.4,69.2a32,32,0,0,0-41-7.3L140,88,80,68,63.5,75.1a8,8,0,0,0-2.2,13.3L92,116,64,132,36,120l-16.8,7.2A8,8,0,0,0,16.9,140.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Je)
      ])) : o(i) === "regular" ? (s(), r("g", Qe, [
        e("line", {
          x1: "24",
          y1: "216",
          x2: "168",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ye),
        e("path", {
          d: "M16.9,140.4l37.7,35.3a32,32,0,0,0,38,4.3L244,92,225.4,69.2a32,32,0,0,0-41-7.3L140,88,80,68,63.5,75.1a8,8,0,0,0-2.2,13.3L92,116,64,132,36,120l-16.8,7.2A8,8,0,0,0,16.9,140.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ot)
      ])) : g("", !0)
    ], 16, Be));
  }
}), tt = ["width", "height", "fill", "transform"], nt = { key: 0 }, st = ["stroke"], rt = { key: 1 }, it = /* @__PURE__ */ e("path", {
  d: "M209.5,80.4,175.9,112l32,88-24,24-47.8-70-24.2,22v24l-24,24L73.7,182.1,31.9,168l24-24h24l24-24-72-48,24-24,88,32,31.7-33.5-.7.5a24,24,0,0,1,34,34Z",
  opacity: "0.2"
}, null, -1), lt = ["stroke"], dt = { key: 2 }, kt = /* @__PURE__ */ e("path", { d: "M215,86.2l-29.8,28,30.2,83.1a8,8,0,0,1-1.9,8.4l-24,24a8.2,8.2,0,0,1-6.4,2.3,8.1,8.1,0,0,1-5.8-3.5l-42.6-62.3-18.8,17.3V204a8.2,8.2,0,0,1-2.4,5.7l-20,20a7.9,7.9,0,0,1-5.6,2.3l-1.8-.2a8,8,0,0,1-5.8-5.2L67.4,188.5,29.3,175.6a8,8,0,0,1-5.2-5.8,8.3,8.3,0,0,1,2.1-7.5l20-20a8.1,8.1,0,0,1,5.7-2.3H72.6l18.7-18.8L27.4,78.7a8.7,8.7,0,0,1-3.5-5.9,8.2,8.2,0,0,1,2.3-6.5l24-24a7.9,7.9,0,0,1,8.4-1.8l83.1,30.2,26.6-28.2a5.2,5.2,0,0,1,1-1.1,32,32,0,0,1,47,43.3A6.4,6.4,0,0,1,215,86.2Z" }, null, -1), ct = [
  kt
], ht = { key: 3 }, ut = ["stroke"], at = { key: 4 }, _t = ["stroke"], pt = { key: 5 }, yt = ["stroke"], $t = {
  name: "PhAirplaneTilt"
}, yF1 = /* @__PURE__ */ $({
  ...$t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", nt, [
        e("path", {
          d: "M209.5,80.4,175.9,112l32,88-24,24-47.8-70-24.2,22v24l-24,24L73.7,182.1,31.9,168l24-24h24l24-24-72-48,24-24,88,32,31.7-33.5-.7.5a24,24,0,0,1,34,34Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, st)
      ])) : o(i) === "duotone" ? (s(), r("g", rt, [
        it,
        e("path", {
          d: "M209.5,80.4,175.9,112l32,88-24,24-47.8-70-24.2,22v24l-24,24L73.7,182.1,31.9,168l24-24h24l24-24-72-48,24-24,88,32,31.7-33.5-.7.5a24,24,0,0,1,34,34Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lt)
      ])) : o(i) === "fill" ? (s(), r("g", dt, ct)) : o(i) === "light" ? (s(), r("g", ht, [
        e("path", {
          d: "M209.5,80.4,175.9,112l32,88-24,24-47.8-70-24.2,22v24l-24,24L73.7,182.1,31.9,168l24-24h24l24-24-72-48,24-24,88,32,31.7-33.5-.7.5a24,24,0,0,1,34,34Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ut)
      ])) : o(i) === "thin" ? (s(), r("g", at, [
        e("path", {
          d: "M209.5,80.4,175.9,112l32,88-24,24-47.8-70-24.2,22v24l-24,24L73.7,182.1,31.9,168l24-24h24l24-24-72-48,24-24,88,32,31.7-33.5-.7.5a24,24,0,0,1,34,34Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _t)
      ])) : o(i) === "regular" ? (s(), r("g", pt, [
        e("path", {
          d: "M209.5,80.4,175.9,112l32,88-24,24-47.8-70-24.2,22v24l-24,24L73.7,182.1,31.9,168l24-24h24l24-24-72-48,24-24,88,32,31.7-33.5-.7.5a24,24,0,0,1,34,34Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yt)
      ])) : g("", !0)
    ], 16, tt));
  }
}), wt = ["width", "height", "fill", "transform"], ft = { key: 0 }, gt = ["stroke"], xt = ["stroke"], jt = { key: 1 }, mt = /* @__PURE__ */ e("path", {
  d: "M208,48H48A16,16,0,0,0,32,64V176a16,16,0,0,0,16,16h52.6L128,160l27.4,32H208a16,16,0,0,0,16-16V64A16,16,0,0,0,208,48Z",
  opacity: "0.2"
}, null, -1), Mt = ["stroke"], vt = ["stroke"], St = { key: 2 }, Ht = /* @__PURE__ */ e("path", { d: "M182.1,210.8A8,8,0,0,1,176,224H80a8,8,0,0,1-6.1-13.2l48-56a8,8,0,0,1,12.2,0ZM208,40H48A23.9,23.9,0,0,0,24,64V176a23.9,23.9,0,0,0,24,24H60.3a4.1,4.1,0,0,0,3-1.4l46.5-54.2a23.9,23.9,0,0,1,36.4,0l46.5,54.2a4.1,4.1,0,0,0,3,1.4H208a23.9,23.9,0,0,0,24-24V64A23.9,23.9,0,0,0,208,40Z" }, null, -1), At = [
  Ht
], Vt = { key: 3 }, zt = ["stroke"], Zt = ["stroke"], Ct = { key: 4 }, bt = ["stroke"], Lt = ["stroke"], Bt = { key: 5 }, Pt = ["stroke"], Wt = ["stroke"], Nt = {
  name: "PhAirplay"
}, $F1 = /* @__PURE__ */ $({
  ...Nt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ft, [
        e("polygon", {
          points: "128 160 176 216 80 216 128 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gt),
        e("path", {
          d: "M48,192a16,16,0,0,1-16-16V64A16,16,0,0,1,48,48H208a16,16,0,0,1,16,16V176a16,16,0,0,1-16,16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xt)
      ])) : o(i) === "duotone" ? (s(), r("g", jt, [
        mt,
        e("polygon", {
          points: "128 160 176 216 80 216 128 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mt),
        e("path", {
          d: "M64,192H48a16,16,0,0,1-16-16V64A16,16,0,0,1,48,48H208a16,16,0,0,1,16,16V176a16,16,0,0,1-16,16H192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vt)
      ])) : o(i) === "fill" ? (s(), r("g", St, At)) : o(i) === "light" ? (s(), r("g", Vt, [
        e("polygon", {
          points: "128 160 176 216 80 216 128 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zt),
        e("path", {
          d: "M64,192H48a16,16,0,0,1-16-16V64A16,16,0,0,1,48,48H208a16,16,0,0,1,16,16V176a16,16,0,0,1-16,16H192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zt)
      ])) : o(i) === "thin" ? (s(), r("g", Ct, [
        e("polygon", {
          points: "128 160 176 216 80 216 128 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bt),
        e("path", {
          d: "M64,192H48a16,16,0,0,1-16-16V64A16,16,0,0,1,48,48H208a16,16,0,0,1,16,16V176a16,16,0,0,1-16,16H192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lt)
      ])) : o(i) === "regular" ? (s(), r("g", Bt, [
        e("polygon", {
          points: "128 160 176 216 80 216 128 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pt),
        e("path", {
          d: "M64,192H48a16,16,0,0,1-16-16V64A16,16,0,0,1,48,48H208a16,16,0,0,1,16,16V176a16,16,0,0,1-16,16H192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wt)
      ])) : g("", !0)
    ], 16, wt));
  }
}), Ft = ["width", "height", "fill", "transform"], Tt = { key: 0 }, Dt = ["stroke"], Rt = ["stroke"], Ut = ["stroke"], qt = ["stroke"], Gt = { key: 1 }, Et = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "88",
  opacity: "0.2"
}, null, -1), Ot = ["stroke"], It = ["stroke"], Kt = ["stroke"], Xt = ["stroke"], Jt = { key: 2 }, Qt = /* @__PURE__ */ e("path", { d: "M235.5,54.5l-34-34a8,8,0,1,0-11.3,11.3l34,34a8,8,0,0,0,5.6,2.3,8.3,8.3,0,0,0,5.7-2.3A8,8,0,0,0,235.5,54.5Z" }, null, -1), Yt = /* @__PURE__ */ e("path", { d: "M65.8,20.5a8,8,0,0,0-11.3,0l-34,34a8,8,0,0,0,0,11.3,8.3,8.3,0,0,0,5.7,2.3,8,8,0,0,0,5.6-2.3l34-34A8,8,0,0,0,65.8,20.5Z" }, null, -1), on = /* @__PURE__ */ e("path", { d: "M224,125.2a14.8,14.8,0,0,1-.1-2.1h0A96,96,0,0,0,133,32.1H123A96,96,0,0,0,32.1,123h0a14.8,14.8,0,0,1-.1,2.1v5.6a14.8,14.8,0,0,1,.1,2.1h0A96,96,0,0,0,123,223.9h10A96,96,0,0,0,223.9,133h0a14.8,14.8,0,0,1,.1-2.1v-5.6ZM184,136H128a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48a8,8,0,0,1,0,16Z" }, null, -1), en = [
  Qt,
  Yt,
  on
], tn = { key: 3 }, nn = ["stroke"], sn = ["stroke"], rn = ["stroke"], ln = ["stroke"], dn = { key: 4 }, kn = ["stroke"], cn = ["stroke"], hn = ["stroke"], un = ["stroke"], an = { key: 5 }, _n = ["stroke"], pn = ["stroke"], yn = ["stroke"], $n = ["stroke"], wn = {
  name: "PhAlarm"
}, wF1 = /* @__PURE__ */ $({
  ...wn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Tt, [
        e("polyline", {
          points: "128 80 128 128 176 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Dt),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rt),
        e("line", {
          x1: "201.5",
          y1: "20.5",
          x2: "235.5",
          y2: "54.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ut),
        e("line", {
          x1: "20.5",
          y1: "54.5",
          x2: "54.5",
          y2: "20.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qt)
      ])) : o(i) === "duotone" ? (s(), r("g", Gt, [
        Et,
        e("polyline", {
          points: "128 72 128 128 184 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ot),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, It),
        e("line", {
          x1: "195.9",
          y1: "26.2",
          x2: "229.8",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kt),
        e("line", {
          x1: "26.2",
          y1: "60.1",
          x2: "60.1",
          y2: "26.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xt)
      ])) : o(i) === "fill" ? (s(), r("g", Jt, en)) : o(i) === "light" ? (s(), r("g", tn, [
        e("polyline", {
          points: "128 72 128 128 184 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nn),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sn),
        e("line", {
          x1: "195.9",
          y1: "26.2",
          x2: "229.8",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rn),
        e("line", {
          x1: "26.2",
          y1: "60.1",
          x2: "60.1",
          y2: "26.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ln)
      ])) : o(i) === "thin" ? (s(), r("g", dn, [
        e("polyline", {
          points: "128 72 128 128 184 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kn),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cn),
        e("line", {
          x1: "195.9",
          y1: "26.2",
          x2: "229.8",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hn),
        e("line", {
          x1: "26.2",
          y1: "60.1",
          x2: "60.1",
          y2: "26.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, un)
      ])) : o(i) === "regular" ? (s(), r("g", an, [
        e("polyline", {
          points: "128 72 128 128 184 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _n),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, pn),
        e("line", {
          x1: "195.9",
          y1: "26.2",
          x2: "229.8",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yn),
        e("line", {
          x1: "26.2",
          y1: "60.1",
          x2: "60.1",
          y2: "26.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $n)
      ])) : g("", !0)
    ], 16, Ft));
  }
}), fn = ["width", "height", "fill", "transform"], gn = { key: 0 }, xn = ["stroke"], jn = ["stroke"], mn = ["stroke"], Mn = ["stroke"], vn = { key: 1 }, Sn = /* @__PURE__ */ e("path", {
  d: "M128,24a88,88,0,0,0-88,88c0,48.6,56,120,88,120s88-71.4,88-120A88,88,0,0,0,128,24ZM112,140a8,8,0,0,1-8,8,32,32,0,0,1-32-32v-4a8,8,0,0,1,8-8,32,32,0,0,1,32,32Zm72-24a32,32,0,0,1-32,32,8,8,0,0,1-8-8v-4a32,32,0,0,1,32-32,8,8,0,0,1,8,8Z",
  opacity: "0.2"
}, null, -1), Hn = ["stroke"], An = ["stroke"], Vn = ["stroke"], zn = ["stroke"], Zn = { key: 2 }, Cn = /* @__PURE__ */ e("path", { d: "M128,16a96.2,96.2,0,0,0-96,96c0,24,12.6,55.1,33.6,83s44.5,45,62.4,45,41.2-16.8,62.4-45S224,136,224,112A96.2,96.2,0,0,0,128,16ZM64,116v-4a12,12,0,0,1,12-12,36,36,0,0,1,36,36v4a12,12,0,0,1-12,12A36,36,0,0,1,64,116Zm80,84H112a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16Zm48-84a36,36,0,0,1-36,36,12,12,0,0,1-12-12v-4a36,36,0,0,1,36-36,12,12,0,0,1,12,12Z" }, null, -1), bn = [
  Cn
], Ln = { key: 3 }, Bn = ["stroke"], Pn = ["stroke"], Wn = ["stroke"], Nn = ["stroke"], Fn = { key: 4 }, Tn = ["stroke"], Dn = ["stroke"], Rn = ["stroke"], Un = ["stroke"], qn = { key: 5 }, Gn = ["stroke"], En = ["stroke"], On = ["stroke"], In = ["stroke"], Kn = {
  name: "PhAlien"
}, fF1 = /* @__PURE__ */ $({
  ...Kn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", gn, [
        e("path", {
          d: "M216,112c0,48.6-56,120-88,120S40,160.6,40,112a88,88,0,0,1,176,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xn),
        e("path", {
          d: "M104,140a24.1,24.1,0,0,1-24-24v-4a24.1,24.1,0,0,1,24,24Z",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jn),
        e("path", {
          d: "M152,140v-4a24.1,24.1,0,0,1,24-24v4a24.1,24.1,0,0,1-24,24Z",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mn),
        e("line", {
          x1: "116",
          y1: "184",
          x2: "140",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mn)
      ])) : o(i) === "duotone" ? (s(), r("g", vn, [
        Sn,
        e("path", {
          d: "M216,112c0,48.6-56,120-88,120S40,160.6,40,112a88,88,0,0,1,176,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hn),
        e("path", {
          d: "M80,104h0a32,32,0,0,1,32,32v4a8,8,0,0,1-8,8h0a32,32,0,0,1-32-32v-4a8,8,0,0,1,8-8Z",
          transform: "translate(184 252) rotate(-180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, An),
        e("path", {
          d: "M176,104h0a8,8,0,0,1,8,8v4a32,32,0,0,1-32,32h0a8,8,0,0,1-8-8v-4A32,32,0,0,1,176,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vn),
        e("line", {
          x1: "112",
          y1: "184",
          x2: "144",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zn)
      ])) : o(i) === "fill" ? (s(), r("g", Zn, bn)) : o(i) === "light" ? (s(), r("g", Ln, [
        e("path", {
          d: "M216,112c0,48.6-56,120-88,120S40,160.6,40,112a88,88,0,0,1,176,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bn),
        e("path", {
          d: "M80,104h0a32,32,0,0,1,32,32v4a8,8,0,0,1-8,8h0a32,32,0,0,1-32-32v-4A8,8,0,0,1,80,104Z",
          transform: "translate(184 252) rotate(-180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pn),
        e("path", {
          d: "M176,104h0a8,8,0,0,1,8,8v4a32,32,0,0,1-32,32h0a8,8,0,0,1-8-8v-4a32,32,0,0,1,32-32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wn),
        e("line", {
          x1: "112",
          y1: "184",
          x2: "144",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Nn)
      ])) : o(i) === "thin" ? (s(), r("g", Fn, [
        e("path", {
          d: "M216,112c0,48.6-56,120-88,120S40,160.6,40,112a88,88,0,0,1,176,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Tn),
        e("path", {
          d: "M80,104h0a32,32,0,0,1,32,32v4a8,8,0,0,1-8,8h0a32,32,0,0,1-32-32v-4a8,8,0,0,1,8-8Z",
          transform: "translate(184 252) rotate(-180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Dn),
        e("path", {
          d: "M176,104h0a8,8,0,0,1,8,8v4a32,32,0,0,1-32,32h0a8,8,0,0,1-8-8v-4a32,32,0,0,1,32-32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Rn),
        e("line", {
          x1: "112",
          y1: "184",
          x2: "144",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Un)
      ])) : o(i) === "regular" ? (s(), r("g", qn, [
        e("path", {
          d: "M216,112c0,48.6-56,120-88,120S40,160.6,40,112a88,88,0,0,1,176,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gn),
        e("path", {
          d: "M80,104h0a32,32,0,0,1,32,32v4a8,8,0,0,1-8,8h0a32,32,0,0,1-32-32v-4a8,8,0,0,1,8-8Z",
          transform: "translate(184 252) rotate(-180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, En),
        e("path", {
          d: "M176,104h0a8,8,0,0,1,8,8v4a32,32,0,0,1-32,32h0a8,8,0,0,1-8-8v-4a32,32,0,0,1,32-32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, On),
        e("line", {
          x1: "112",
          y1: "184",
          x2: "144",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, In)
      ])) : g("", !0)
    ], 16, fn));
  }
}), Xn = ["width", "height", "fill", "transform"], Jn = { key: 0 }, Qn = ["stroke"], Yn = ["stroke"], os = ["stroke"], es = { key: 1 }, ts = /* @__PURE__ */ e("rect", {
  x: "116",
  y: "100",
  width: "112",
  height: "56",
  rx: "8",
  transform: "translate(44 300) rotate(-90)",
  opacity: "0.2"
}, null, -1), ns = /* @__PURE__ */ e("rect", {
  x: "56",
  y: "32",
  width: "56",
  height: "152",
  rx: "8",
  opacity: "0.2"
}, null, -1), ss = ["stroke"], rs = ["stroke"], is = ["stroke"], ls = { key: 2 }, ds = /* @__PURE__ */ e("path", { d: "M224,216a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,216Zm-72-24h40a16,16,0,0,0,16-16V80a16,16,0,0,0-16-16H152a16,16,0,0,0-16,16v96A16,16,0,0,0,152,192Zm-88,0h40a16,16,0,0,0,16-16V40a16,16,0,0,0-16-16H64A16,16,0,0,0,48,40V176A16,16,0,0,0,64,192Z" }, null, -1), ks = [
  ds
], cs = { key: 3 }, hs = ["stroke"], us = ["stroke"], as = ["stroke"], _s = { key: 4 }, ps = ["stroke"], ys = ["stroke"], $s = ["stroke"], ws = { key: 5 }, fs = ["stroke"], gs = ["stroke"], xs = ["stroke"], js = {
  name: "PhAlignBottom"
}, gF1 = /* @__PURE__ */ $({
  ...js,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Jn, [
        e("line", {
          x1: "216",
          y1: "216",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qn),
        e("rect", {
          x: "122",
          y: "98",
          width: "104",
          height: "52",
          rx: "8",
          transform: "translate(50 298) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Yn),
        e("rect", {
          x: "56",
          y: "32",
          width: "52",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, os)
      ])) : o(i) === "duotone" ? (s(), r("g", es, [
        ts,
        ns,
        e("line", {
          x1: "216",
          y1: "216",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ss),
        e("rect", {
          x: "116",
          y: "100",
          width: "112",
          height: "56",
          rx: "8",
          transform: "translate(44 300) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rs),
        e("rect", {
          x: "56",
          y: "32",
          width: "56",
          height: "152",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, is)
      ])) : o(i) === "fill" ? (s(), r("g", ls, ks)) : o(i) === "light" ? (s(), r("g", cs, [
        e("line", {
          x1: "216",
          y1: "216",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hs),
        e("rect", {
          x: "116",
          y: "100",
          width: "112",
          height: "56",
          rx: "8",
          transform: "translate(44 300) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, us),
        e("rect", {
          x: "56",
          y: "32",
          width: "56",
          height: "152",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, as)
      ])) : o(i) === "thin" ? (s(), r("g", _s, [
        e("line", {
          x1: "216",
          y1: "216",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ps),
        e("rect", {
          x: "116",
          y: "100",
          width: "112",
          height: "56",
          rx: "8",
          transform: "translate(44 300) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ys),
        e("rect", {
          x: "56",
          y: "32",
          width: "56",
          height: "152",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $s)
      ])) : o(i) === "regular" ? (s(), r("g", ws, [
        e("line", {
          x1: "216",
          y1: "216",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fs),
        e("rect", {
          x: "116",
          y: "100",
          width: "112",
          height: "56",
          rx: "8",
          transform: "translate(44 300) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gs),
        e("rect", {
          x: "56",
          y: "32",
          width: "56",
          height: "152",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xs)
      ])) : g("", !0)
    ], 16, Xn));
  }
}), ms = ["width", "height", "fill", "transform"], Ms = { key: 0 }, vs = ["stroke"], Ss = ["stroke"], Hs = { key: 1 }, As = /* @__PURE__ */ e("rect", {
  x: "88",
  y: "32",
  width: "80",
  height: "168",
  rx: "8",
  opacity: "0.2"
}, null, -1), Vs = ["stroke"], zs = ["stroke"], Zs = { key: 2 }, Cs = /* @__PURE__ */ e("path", { d: "M208,232a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16H200A8,8,0,0,1,208,232ZM96,208h64a16,16,0,0,0,16-16V40a16,16,0,0,0-16-16H96A16,16,0,0,0,80,40V192A16,16,0,0,0,96,208Z" }, null, -1), bs = [
  Cs
], Ls = { key: 3 }, Bs = ["stroke"], Ps = ["stroke"], Ws = { key: 4 }, Ns = ["stroke"], Fs = ["stroke"], Ts = { key: 5 }, Ds = ["stroke"], Rs = ["stroke"], Us = {
  name: "PhAlignBottomSimple"
}, xF1 = /* @__PURE__ */ $({
  ...Us,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ms, [
        e("line", {
          x1: "56",
          y1: "232",
          x2: "200",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vs),
        e("rect", {
          x: "88",
          y: "32",
          width: "80",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ss)
      ])) : o(i) === "duotone" ? (s(), r("g", Hs, [
        As,
        e("line", {
          x1: "56",
          y1: "232",
          x2: "200",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vs),
        e("rect", {
          x: "88",
          y: "32",
          width: "80",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zs)
      ])) : o(i) === "fill" ? (s(), r("g", Zs, bs)) : o(i) === "light" ? (s(), r("g", Ls, [
        e("line", {
          x1: "56",
          y1: "232",
          x2: "200",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bs),
        e("rect", {
          x: "88",
          y: "32",
          width: "80",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ps)
      ])) : o(i) === "thin" ? (s(), r("g", Ws, [
        e("line", {
          x1: "56",
          y1: "232",
          x2: "200",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ns),
        e("rect", {
          x: "88",
          y: "32",
          width: "80",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fs)
      ])) : o(i) === "regular" ? (s(), r("g", Ts, [
        e("line", {
          x1: "56",
          y1: "232",
          x2: "200",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ds),
        e("rect", {
          x: "88",
          y: "32",
          width: "80",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rs)
      ])) : g("", !0)
    ], 16, ms));
  }
}), qs = ["width", "height", "fill", "transform"], Gs = { key: 0 }, Es = ["stroke"], Os = ["stroke"], Is = ["stroke"], Ks = ["stroke"], Xs = ["stroke"], Js = { key: 1 }, Qs = /* @__PURE__ */ e("rect", {
  x: "64",
  y: "56",
  width: "128",
  height: "56",
  rx: "8",
  opacity: "0.2"
}, null, -1), Ys = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "144",
  width: "176",
  height: "56",
  rx: "8",
  opacity: "0.2"
}, null, -1), or = ["stroke"], er = ["stroke"], tr = ["stroke"], nr = ["stroke"], sr = ["stroke"], rr = { key: 2 }, ir = /* @__PURE__ */ e("path", { d: "M224,152v40a16,16,0,0,1-16,16H136v16a8,8,0,0,1-16,0V208H48a16,16,0,0,1-16-16V152a16,16,0,0,1,16-16h72V120H72a16,16,0,0,1-16-16V64A16,16,0,0,1,72,48h48V32a8,8,0,0,1,16,0V48h48a16,16,0,0,1,16,16v40a16,16,0,0,1-16,16H136v16h72A16,16,0,0,1,224,152Z" }, null, -1), lr = [
  ir
], dr = { key: 3 }, kr = ["stroke"], cr = ["stroke"], hr = ["stroke"], ur = ["stroke"], ar = ["stroke"], _r = { key: 4 }, pr = ["stroke"], yr = ["stroke"], $r = ["stroke"], wr = ["stroke"], fr = ["stroke"], gr = { key: 5 }, xr = ["stroke"], jr = ["stroke"], mr = ["stroke"], Mr = ["stroke"], vr = ["stroke"], Sr = {
  name: "PhAlignCenterHorizontal"
}, jF1 = /* @__PURE__ */ $({
  ...Sr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Gs, [
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "52",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Es),
        e("line", {
          x1: "128",
          y1: "204",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Os),
        e("line", {
          x1: "128",
          y1: "108",
          x2: "128",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Is),
        e("rect", {
          x: "64",
          y: "52",
          width: "128",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ks),
        e("rect", {
          x: "40",
          y: "148",
          width: "176",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xs)
      ])) : o(i) === "duotone" ? (s(), r("g", Js, [
        Qs,
        Ys,
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, or),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, er),
        e("line", {
          x1: "128",
          y1: "112",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tr),
        e("rect", {
          x: "64",
          y: "56",
          width: "128",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nr),
        e("rect", {
          x: "40",
          y: "144",
          width: "176",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sr)
      ])) : o(i) === "fill" ? (s(), r("g", rr, lr)) : o(i) === "light" ? (s(), r("g", dr, [
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kr),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cr),
        e("line", {
          x1: "128",
          y1: "112",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hr),
        e("rect", {
          x: "64",
          y: "56",
          width: "128",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ur),
        e("rect", {
          x: "40",
          y: "144",
          width: "176",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ar)
      ])) : o(i) === "thin" ? (s(), r("g", _r, [
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pr),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yr),
        e("line", {
          x1: "128",
          y1: "112",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $r),
        e("rect", {
          x: "64",
          y: "56",
          width: "128",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wr),
        e("rect", {
          x: "40",
          y: "144",
          width: "176",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fr)
      ])) : o(i) === "regular" ? (s(), r("g", gr, [
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xr),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jr),
        e("line", {
          x1: "128",
          y1: "112",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mr),
        e("rect", {
          x: "64",
          y: "56",
          width: "128",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mr),
        e("rect", {
          x: "40",
          y: "144",
          width: "176",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vr)
      ])) : g("", !0)
    ], 16, qs));
  }
}), Hr = ["width", "height", "fill", "transform"], Ar = { key: 0 }, Vr = ["stroke"], zr = ["stroke"], Zr = ["stroke"], Cr = { key: 1 }, br = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "88",
  width: "176",
  height: "80",
  rx: "8",
  opacity: "0.2"
}, null, -1), Lr = ["stroke"], Br = ["stroke"], Pr = ["stroke"], Wr = { key: 2 }, Nr = /* @__PURE__ */ e("path", { d: "M224,96v64a16,16,0,0,1-16,16H136v32a8,8,0,0,1-16,0V176H48a16,16,0,0,1-16-16V96A16,16,0,0,1,48,80h72V48a8,8,0,0,1,16,0V80h72A16,16,0,0,1,224,96Z" }, null, -1), Fr = [
  Nr
], Tr = { key: 3 }, Dr = ["stroke"], Rr = ["stroke"], Ur = ["stroke"], qr = { key: 4 }, Gr = ["stroke"], Er = ["stroke"], Or = ["stroke"], Ir = { key: 5 }, Kr = ["stroke"], Xr = ["stroke"], Jr = ["stroke"], Qr = {
  name: "PhAlignCenterHorizontalSimple"
}, mF1 = /* @__PURE__ */ $({
  ...Qr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ar, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "80",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vr),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zr),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zr)
      ])) : o(i) === "duotone" ? (s(), r("g", Cr, [
        br,
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "80",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lr),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Br),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pr)
      ])) : o(i) === "fill" ? (s(), r("g", Wr, Fr)) : o(i) === "light" ? (s(), r("g", Tr, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "80",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dr),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rr),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ur)
      ])) : o(i) === "thin" ? (s(), r("g", qr, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "80",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gr),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Er),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Or)
      ])) : o(i) === "regular" ? (s(), r("g", Ir, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "80",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kr),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xr),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jr)
      ])) : g("", !0)
    ], 16, Hr));
  }
}), Yr = ["width", "height", "fill", "transform"], oi = { key: 0 }, ei = ["stroke"], ti = ["stroke"], ni = ["stroke"], si = ["stroke"], ri = ["stroke"], ii = { key: 1 }, li = ["stroke"], di = /* @__PURE__ */ e("rect", {
  x: "108",
  y: "100",
  width: "128",
  height: "56",
  rx: "8",
  transform: "translate(300 -44) rotate(90)",
  opacity: "0.2"
}, null, -1), ki = /* @__PURE__ */ e("rect", {
  x: "56",
  y: "40",
  width: "56",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), ci = ["stroke"], hi = ["stroke"], ui = ["stroke"], ai = ["stroke"], _i = { key: 2 }, pi = /* @__PURE__ */ e("path", { d: "M232,128a8,8,0,0,1-8,8H208v48a16,16,0,0,1-16,16H152a16,16,0,0,1-16-16V136H120v72a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V136H32a8,8,0,0,1,0-16H48V48A16,16,0,0,1,64,32h40a16,16,0,0,1,16,16v72h16V72a16,16,0,0,1,16-16h40a16,16,0,0,1,16,16v48h16A8,8,0,0,1,232,128Z" }, null, -1), yi = [
  pi
], $i = { key: 3 }, wi = ["stroke"], fi = ["stroke"], gi = ["stroke"], xi = ["stroke"], ji = ["stroke"], mi = { key: 4 }, Mi = ["stroke"], vi = ["stroke"], Si = ["stroke"], Hi = ["stroke"], Ai = ["stroke"], Vi = { key: 5 }, zi = ["stroke"], Zi = ["stroke"], Ci = ["stroke"], bi = ["stroke"], Li = ["stroke"], Bi = {
  name: "PhAlignCenterVertical"
}, MF1 = /* @__PURE__ */ $({
  ...Bi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", oi, [
        e("line", {
          x1: "224",
          y1: "128",
          x2: "204",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ei),
        e("line", {
          x1: "52",
          y1: "128",
          x2: "32",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ti),
        e("line", {
          x1: "148",
          y1: "128",
          x2: "108",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ni),
        e("rect", {
          x: "112",
          y: "100",
          width: "128",
          height: "56",
          rx: "8",
          transform: "translate(304 -48) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, si),
        e("rect", {
          x: "52",
          y: "40",
          width: "56",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ri)
      ])) : o(i) === "duotone" ? (s(), r("g", ii, [
        e("line", {
          x1: "224",
          y1: "128",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, li),
        di,
        ki,
        e("line", {
          x1: "56",
          y1: "128",
          x2: "32",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ci),
        e("line", {
          x1: "144",
          y1: "128",
          x2: "112",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hi),
        e("rect", {
          x: "108",
          y: "100",
          width: "128",
          height: "56",
          rx: "8",
          transform: "translate(300 -44) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ui),
        e("rect", {
          x: "56",
          y: "40",
          width: "56",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ai)
      ])) : o(i) === "fill" ? (s(), r("g", _i, yi)) : o(i) === "light" ? (s(), r("g", $i, [
        e("line", {
          x1: "224",
          y1: "128",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wi),
        e("line", {
          x1: "56",
          y1: "128",
          x2: "32",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fi),
        e("line", {
          x1: "144",
          y1: "128",
          x2: "112",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gi),
        e("rect", {
          x: "108",
          y: "100",
          width: "128",
          height: "56",
          rx: "8",
          transform: "translate(300 -44) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xi),
        e("rect", {
          x: "56",
          y: "40",
          width: "56",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ji)
      ])) : o(i) === "thin" ? (s(), r("g", mi, [
        e("line", {
          x1: "224",
          y1: "128",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Mi),
        e("line", {
          x1: "56",
          y1: "128",
          x2: "32",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vi),
        e("line", {
          x1: "144",
          y1: "128",
          x2: "112",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Si),
        e("rect", {
          x: "108",
          y: "100",
          width: "128",
          height: "56",
          rx: "8",
          transform: "translate(300 -44) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hi),
        e("rect", {
          x: "56",
          y: "40",
          width: "56",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ai)
      ])) : o(i) === "regular" ? (s(), r("g", Vi, [
        e("line", {
          x1: "224",
          y1: "128",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zi),
        e("line", {
          x1: "56",
          y1: "128",
          x2: "32",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zi),
        e("line", {
          x1: "144",
          y1: "128",
          x2: "112",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ci),
        e("rect", {
          x: "108",
          y: "100",
          width: "128",
          height: "56",
          rx: "8",
          transform: "translate(300 -44) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bi),
        e("rect", {
          x: "56",
          y: "40",
          width: "56",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Li)
      ])) : g("", !0)
    ], 16, Yr));
  }
}), Pi = ["width", "height", "fill", "transform"], Wi = { key: 0 }, Ni = ["stroke"], Fi = ["stroke"], Ti = ["stroke"], Di = { key: 1 }, Ri = /* @__PURE__ */ e("rect", {
  x: "88",
  y: "40",
  width: "80",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), Ui = ["stroke"], qi = ["stroke"], Gi = ["stroke"], Ei = { key: 2 }, Oi = /* @__PURE__ */ e("path", { d: "M216,128a8,8,0,0,1-8,8H176v72a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16V136H48a8,8,0,0,1,0-16H80V48A16,16,0,0,1,96,32h64a16,16,0,0,1,16,16v72h32A8,8,0,0,1,216,128Z" }, null, -1), Ii = [
  Oi
], Ki = { key: 3 }, Xi = ["stroke"], Ji = ["stroke"], Qi = ["stroke"], Yi = { key: 4 }, o1 = ["stroke"], e1 = ["stroke"], t1 = ["stroke"], n1 = { key: 5 }, s1 = ["stroke"], r1 = ["stroke"], i1 = ["stroke"], l1 = {
  name: "PhAlignCenterVerticalSimple"
}, vF1 = /* @__PURE__ */ $({
  ...l1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Wi, [
        e("rect", {
          x: "88",
          y: "40",
          width: "80",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ni),
        e("line", {
          x1: "208",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fi),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "48",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ti)
      ])) : o(i) === "duotone" ? (s(), r("g", Di, [
        Ri,
        e("rect", {
          x: "88",
          y: "40",
          width: "80",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ui),
        e("line", {
          x1: "208",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qi),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "48",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gi)
      ])) : o(i) === "fill" ? (s(), r("g", Ei, Ii)) : o(i) === "light" ? (s(), r("g", Ki, [
        e("rect", {
          x: "88",
          y: "40",
          width: "80",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xi),
        e("line", {
          x1: "208",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ji),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "48",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qi)
      ])) : o(i) === "thin" ? (s(), r("g", Yi, [
        e("rect", {
          x: "88",
          y: "40",
          width: "80",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, o1),
        e("line", {
          x1: "208",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, e1),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "48",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, t1)
      ])) : o(i) === "regular" ? (s(), r("g", n1, [
        e("rect", {
          x: "88",
          y: "40",
          width: "80",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s1),
        e("line", {
          x1: "208",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r1),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "48",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, i1)
      ])) : g("", !0)
    ], 16, Pi));
  }
}), d1 = ["width", "height", "fill", "transform"], k1 = { key: 0 }, c1 = ["stroke"], h1 = ["stroke"], u1 = ["stroke"], a1 = { key: 1 }, _1 = /* @__PURE__ */ e("rect", {
  x: "72",
  y: "56",
  width: "112",
  height: "56",
  rx: "8",
  opacity: "0.2"
}, null, -1), p1 = /* @__PURE__ */ e("rect", {
  x: "72",
  y: "144",
  width: "152",
  height: "56",
  rx: "8",
  opacity: "0.2"
}, null, -1), y1 = ["stroke"], $1 = ["stroke"], w1 = ["stroke"], f1 = { key: 2 }, g1 = /* @__PURE__ */ e("path", { d: "M48,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0Zm32,80h96a16,16,0,0,0,16-16V64a16,16,0,0,0-16-16H80A16,16,0,0,0,64,64v40A16,16,0,0,0,80,120Zm136,16H80a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V152A16,16,0,0,0,216,136Z" }, null, -1), x1 = [
  g1
], j1 = { key: 3 }, m1 = ["stroke"], M1 = ["stroke"], v1 = ["stroke"], S1 = { key: 4 }, H1 = ["stroke"], A1 = ["stroke"], V1 = ["stroke"], z1 = { key: 5 }, Z1 = ["stroke"], C1 = ["stroke"], b1 = ["stroke"], L1 = {
  name: "PhAlignLeft"
}, SF1 = /* @__PURE__ */ $({
  ...L1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", k1, [
        e("line", {
          x1: "40",
          y1: "40",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, c1),
        e("rect", {
          x: "80",
          y: "56",
          width: "104",
          height: "52",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, h1),
        e("rect", {
          x: "80",
          y: "148",
          width: "144",
          height: "52",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, u1)
      ])) : o(i) === "duotone" ? (s(), r("g", a1, [
        _1,
        p1,
        e("rect", {
          x: "72",
          y: "144",
          width: "152",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y1),
        e("line", {
          x1: "40",
          y1: "40",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $1),
        e("rect", {
          x: "72",
          y: "56",
          width: "112",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w1)
      ])) : o(i) === "fill" ? (s(), r("g", f1, x1)) : o(i) === "light" ? (s(), r("g", j1, [
        e("line", {
          x1: "40",
          y1: "40",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, m1),
        e("rect", {
          x: "72",
          y: "56",
          width: "112",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, M1),
        e("rect", {
          x: "72",
          y: "144",
          width: "152",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, v1)
      ])) : o(i) === "thin" ? (s(), r("g", S1, [
        e("line", {
          x1: "40",
          y1: "40",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, H1),
        e("rect", {
          x: "72",
          y: "56",
          width: "112",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, A1),
        e("rect", {
          x: "72",
          y: "144",
          width: "152",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, V1)
      ])) : o(i) === "regular" ? (s(), r("g", z1, [
        e("line", {
          x1: "40",
          y1: "40",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z1),
        e("rect", {
          x: "72",
          y: "56",
          width: "112",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C1),
        e("rect", {
          x: "72",
          y: "144",
          width: "152",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b1)
      ])) : g("", !0)
    ], 16, d1));
  }
}), B1 = ["width", "height", "fill", "transform"], P1 = { key: 0 }, W1 = ["stroke"], N1 = ["stroke"], F1 = { key: 1 }, T1 = /* @__PURE__ */ e("rect", {
  x: "64",
  y: "88",
  width: "168",
  height: "80",
  rx: "8",
  opacity: "0.2"
}, null, -1), D1 = ["stroke"], R1 = ["stroke"], U1 = { key: 2 }, q1 = /* @__PURE__ */ e("path", { d: "M40,56V200a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0ZM224,80H72A16,16,0,0,0,56,96v64a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V96A16,16,0,0,0,224,80Z" }, null, -1), G1 = [
  q1
], E1 = { key: 3 }, O1 = ["stroke"], I1 = ["stroke"], K1 = { key: 4 }, X1 = ["stroke"], J1 = ["stroke"], Q1 = { key: 5 }, Y1 = ["stroke"], ol = ["stroke"], el = {
  name: "PhAlignLeftSimple"
}, HF1 = /* @__PURE__ */ $({
  ...el,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", P1, [
        e("line", {
          x1: "32",
          y1: "56",
          x2: "32",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, W1),
        e("rect", {
          x: "72",
          y: "88",
          width: "160",
          height: "80",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, N1)
      ])) : o(i) === "duotone" ? (s(), r("g", F1, [
        T1,
        e("line", {
          x1: "32",
          y1: "56",
          x2: "32",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D1),
        e("rect", {
          x: "64",
          y: "88",
          width: "168",
          height: "80",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R1)
      ])) : o(i) === "fill" ? (s(), r("g", U1, G1)) : o(i) === "light" ? (s(), r("g", E1, [
        e("line", {
          x1: "32",
          y1: "56",
          x2: "32",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, O1),
        e("rect", {
          x: "64",
          y: "88",
          width: "168",
          height: "80",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, I1)
      ])) : o(i) === "thin" ? (s(), r("g", K1, [
        e("line", {
          x1: "32",
          y1: "56",
          x2: "32",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, X1),
        e("rect", {
          x: "64",
          y: "88",
          width: "168",
          height: "80",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, J1)
      ])) : o(i) === "regular" ? (s(), r("g", Q1, [
        e("line", {
          x1: "32",
          y1: "56",
          x2: "32",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y1),
        e("rect", {
          x: "64",
          y: "88",
          width: "168",
          height: "80",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ol)
      ])) : g("", !0)
    ], 16, B1));
  }
}), tl = ["width", "height", "fill", "transform"], nl = { key: 0 }, sl = ["stroke"], rl = ["stroke"], il = ["stroke"], ll = { key: 1 }, dl = /* @__PURE__ */ e("rect", {
  x: "72",
  y: "56",
  width: "112",
  height: "56",
  rx: "8",
  transform: "translate(256 168) rotate(180)",
  opacity: "0.2"
}, null, -1), kl = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "144",
  width: "152",
  height: "56",
  rx: "8",
  opacity: "0.2"
}, null, -1), cl = ["stroke"], hl = ["stroke"], ul = ["stroke"], al = { key: 2 }, _l = /* @__PURE__ */ e("path", { d: "M224,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0Zm-48,8H80A16,16,0,0,0,64,64v40a16,16,0,0,0,16,16h96a16,16,0,0,0,16-16V64A16,16,0,0,0,176,48Zm0,88H40a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V152A16,16,0,0,0,176,136Z" }, null, -1), pl = [
  _l
], yl = { key: 3 }, $l = ["stroke"], wl = ["stroke"], fl = ["stroke"], gl = { key: 4 }, xl = ["stroke"], jl = ["stroke"], ml = ["stroke"], Ml = { key: 5 }, vl = ["stroke"], Sl = ["stroke"], Hl = ["stroke"], Al = {
  name: "PhAlignRight"
}, AF1 = /* @__PURE__ */ $({
  ...Al,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", nl, [
        e("line", {
          x1: "216",
          y1: "40",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sl),
        e("rect", {
          x: "72",
          y: "56",
          width: "104",
          height: "52",
          rx: "8",
          transform: "translate(248 164) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rl),
        e("rect", {
          x: "32",
          y: "148",
          width: "144",
          height: "52",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, il)
      ])) : o(i) === "duotone" ? (s(), r("g", ll, [
        dl,
        kl,
        e("line", {
          x1: "216",
          y1: "40",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cl),
        e("rect", {
          x: "72",
          y: "56",
          width: "112",
          height: "56",
          rx: "8",
          transform: "translate(256 168) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hl),
        e("rect", {
          x: "32",
          y: "144",
          width: "152",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ul)
      ])) : o(i) === "fill" ? (s(), r("g", al, pl)) : o(i) === "light" ? (s(), r("g", yl, [
        e("line", {
          x1: "216",
          y1: "40",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $l),
        e("rect", {
          x: "72",
          y: "56",
          width: "112",
          height: "56",
          rx: "8",
          transform: "translate(256 168) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wl),
        e("rect", {
          x: "32",
          y: "144",
          width: "152",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fl)
      ])) : o(i) === "thin" ? (s(), r("g", gl, [
        e("line", {
          x1: "216",
          y1: "40",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xl),
        e("rect", {
          x: "72",
          y: "56",
          width: "112",
          height: "56",
          rx: "8",
          transform: "translate(256 168) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jl),
        e("rect", {
          x: "32",
          y: "144",
          width: "152",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ml)
      ])) : o(i) === "regular" ? (s(), r("g", Ml, [
        e("line", {
          x1: "216",
          y1: "40",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vl),
        e("rect", {
          x: "72",
          y: "56",
          width: "112",
          height: "56",
          rx: "8",
          transform: "translate(256 168) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sl),
        e("rect", {
          x: "32",
          y: "144",
          width: "152",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hl)
      ])) : g("", !0)
    ], 16, tl));
  }
}), Vl = ["width", "height", "fill", "transform"], zl = { key: 0 }, Zl = ["stroke"], Cl = ["stroke"], bl = { key: 1 }, Ll = /* @__PURE__ */ e("rect", {
  x: "24",
  y: "88",
  width: "168",
  height: "80",
  rx: "8",
  opacity: "0.2"
}, null, -1), Bl = ["stroke"], Pl = ["stroke"], Wl = { key: 2 }, Nl = /* @__PURE__ */ e("path", { d: "M232,56V200a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0ZM184,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V96A16,16,0,0,0,184,80Z" }, null, -1), Fl = [
  Nl
], Tl = { key: 3 }, Dl = ["stroke"], Rl = ["stroke"], Ul = { key: 4 }, ql = ["stroke"], Gl = ["stroke"], El = { key: 5 }, Ol = ["stroke"], Il = ["stroke"], Kl = {
  name: "PhAlignRightSimple"
}, VF1 = /* @__PURE__ */ $({
  ...Kl,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", zl, [
        e("line", {
          x1: "224",
          y1: "56",
          x2: "224",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zl),
        e("rect", {
          x: "24",
          y: "88",
          width: "160",
          height: "80",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cl)
      ])) : o(i) === "duotone" ? (s(), r("g", bl, [
        Ll,
        e("line", {
          x1: "224",
          y1: "56",
          x2: "224",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bl),
        e("rect", {
          x: "24",
          y: "88",
          width: "168",
          height: "80",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pl)
      ])) : o(i) === "fill" ? (s(), r("g", Wl, Fl)) : o(i) === "light" ? (s(), r("g", Tl, [
        e("line", {
          x1: "224",
          y1: "56",
          x2: "224",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dl),
        e("rect", {
          x: "24",
          y: "88",
          width: "168",
          height: "80",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rl)
      ])) : o(i) === "thin" ? (s(), r("g", Ul, [
        e("line", {
          x1: "224",
          y1: "56",
          x2: "224",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ql),
        e("rect", {
          x: "24",
          y: "88",
          width: "168",
          height: "80",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gl)
      ])) : o(i) === "regular" ? (s(), r("g", El, [
        e("line", {
          x1: "224",
          y1: "56",
          x2: "224",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ol),
        e("rect", {
          x: "24",
          y: "88",
          width: "168",
          height: "80",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Il)
      ])) : g("", !0)
    ], 16, Vl));
  }
}), Xl = ["width", "height", "fill", "transform"], Jl = { key: 0 }, Ql = ["stroke"], Yl = ["stroke"], o2 = ["stroke"], e2 = { key: 1 }, t2 = /* @__PURE__ */ e("rect", {
  x: "116",
  y: "100",
  width: "112",
  height: "56",
  rx: "8",
  transform: "translate(300 -44) rotate(90)",
  opacity: "0.2"
}, null, -1), n2 = /* @__PURE__ */ e("rect", {
  x: "56",
  y: "72",
  width: "56",
  height: "152",
  rx: "8",
  opacity: "0.2"
}, null, -1), s2 = ["stroke"], r2 = ["stroke"], i2 = ["stroke"], l2 = { key: 2 }, d2 = /* @__PURE__ */ e("path", { d: "M224,40a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,40ZM192,64H152a16,16,0,0,0-16,16v96a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V80A16,16,0,0,0,192,64Zm-88,0H64A16,16,0,0,0,48,80V216a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V80A16,16,0,0,0,104,64Z" }, null, -1), k2 = [
  d2
], c2 = { key: 3 }, h2 = ["stroke"], u2 = ["stroke"], a2 = ["stroke"], _2 = { key: 4 }, p2 = ["stroke"], y2 = ["stroke"], $2 = ["stroke"], w2 = { key: 5 }, f2 = ["stroke"], g2 = ["stroke"], x2 = ["stroke"], j2 = {
  name: "PhAlignTop"
}, zF1 = /* @__PURE__ */ $({
  ...j2,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Jl, [
        e("line", {
          x1: "216",
          y1: "40",
          x2: "40",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ql),
        e("rect", {
          x: "122",
          y: "106",
          width: "104",
          height: "52",
          rx: "8",
          transform: "translate(306 -42) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Yl),
        e("rect", {
          x: "56",
          y: "80",
          width: "52",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, o2)
      ])) : o(i) === "duotone" ? (s(), r("g", e2, [
        t2,
        n2,
        e("line", {
          x1: "216",
          y1: "40",
          x2: "40",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s2),
        e("rect", {
          x: "116",
          y: "100",
          width: "112",
          height: "56",
          rx: "8",
          transform: "translate(300 -44) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r2),
        e("rect", {
          x: "56",
          y: "72",
          width: "56",
          height: "152",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, i2)
      ])) : o(i) === "fill" ? (s(), r("g", l2, k2)) : o(i) === "light" ? (s(), r("g", c2, [
        e("line", {
          x1: "216",
          y1: "40",
          x2: "40",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, h2),
        e("rect", {
          x: "116",
          y: "100",
          width: "112",
          height: "56",
          rx: "8",
          transform: "translate(300 -44) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u2),
        e("rect", {
          x: "56",
          y: "72",
          width: "56",
          height: "152",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, a2)
      ])) : o(i) === "thin" ? (s(), r("g", _2, [
        e("line", {
          x1: "216",
          y1: "40",
          x2: "40",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, p2),
        e("rect", {
          x: "116",
          y: "100",
          width: "112",
          height: "56",
          rx: "8",
          transform: "translate(300 -44) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, y2),
        e("rect", {
          x: "56",
          y: "72",
          width: "56",
          height: "152",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $2)
      ])) : o(i) === "regular" ? (s(), r("g", w2, [
        e("line", {
          x1: "216",
          y1: "40",
          x2: "40",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f2),
        e("rect", {
          x: "116",
          y: "100",
          width: "112",
          height: "56",
          rx: "8",
          transform: "translate(300 -44) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g2),
        e("rect", {
          x: "56",
          y: "72",
          width: "56",
          height: "152",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, x2)
      ])) : g("", !0)
    ], 16, Xl));
  }
}), m2 = ["width", "height", "fill", "transform"], M2 = { key: 0 }, v2 = ["stroke"], S2 = ["stroke"], H2 = { key: 1 }, A2 = /* @__PURE__ */ e("rect", {
  x: "88",
  y: "64",
  width: "80",
  height: "168",
  rx: "8",
  opacity: "0.2"
}, null, -1), V2 = ["stroke"], z2 = ["stroke"], Z2 = { key: 2 }, C2 = /* @__PURE__ */ e("path", { d: "M208,32a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16H200A8,8,0,0,1,208,32ZM160,56H96A16,16,0,0,0,80,72V224a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16V72A16,16,0,0,0,160,56Z" }, null, -1), b2 = [
  C2
], L2 = { key: 3 }, B2 = ["stroke"], P2 = ["stroke"], W2 = { key: 4 }, N2 = ["stroke"], F2 = ["stroke"], T2 = { key: 5 }, D2 = ["stroke"], R2 = ["stroke"], U2 = {
  name: "PhAlignTopSimple"
}, ZF1 = /* @__PURE__ */ $({
  ...U2,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", M2, [
        e("line", {
          x1: "56",
          y1: "32",
          x2: "200",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, v2),
        e("rect", {
          x: "88",
          y: "72",
          width: "80",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, S2)
      ])) : o(i) === "duotone" ? (s(), r("g", H2, [
        A2,
        e("line", {
          x1: "56",
          y1: "32",
          x2: "200",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, V2),
        e("rect", {
          x: "88",
          y: "64",
          width: "80",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, z2)
      ])) : o(i) === "fill" ? (s(), r("g", Z2, b2)) : o(i) === "light" ? (s(), r("g", L2, [
        e("line", {
          x1: "56",
          y1: "32",
          x2: "200",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, B2),
        e("rect", {
          x: "88",
          y: "64",
          width: "80",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, P2)
      ])) : o(i) === "thin" ? (s(), r("g", W2, [
        e("line", {
          x1: "56",
          y1: "32",
          x2: "200",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, N2),
        e("rect", {
          x: "88",
          y: "64",
          width: "80",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, F2)
      ])) : o(i) === "regular" ? (s(), r("g", T2, [
        e("line", {
          x1: "56",
          y1: "32",
          x2: "200",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D2),
        e("rect", {
          x: "88",
          y: "64",
          width: "80",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R2)
      ])) : g("", !0)
    ], 16, m2));
  }
}), q2 = ["width", "height", "fill", "transform"], G2 = { key: 0 }, E2 = ["stroke"], O2 = ["stroke"], I2 = ["stroke"], K2 = ["stroke"], X2 = { key: 1 }, J2 = ["stroke"], Q2 = ["stroke"], Y2 = ["stroke"], o0 = ["stroke"], e0 = { key: 2 }, t0 = /* @__PURE__ */ e("path", { d: "M216,136a8,8,0,0,0-8,8,40,40,0,0,1-40,40,47.9,47.9,0,0,0-32,12.3V120h32a8,8,0,0,0,0-16H136V78.8a28,28,0,1,0-16,0V104H88a8,8,0,0,0,0,16h32v76.3A47.9,47.9,0,0,0,88,184a40,40,0,0,1-40-40,8,8,0,0,0-16,0,56,56,0,0,0,56,56,32.1,32.1,0,0,1,32,32,8,8,0,0,0,16,0,32.1,32.1,0,0,1,32-32,56,56,0,0,0,56-56A8,8,0,0,0,216,136ZM116,52a12,12,0,1,1,12,12A12,12,0,0,1,116,52Z" }, null, -1), n0 = [
  t0
], s0 = { key: 3 }, r0 = ["stroke"], i0 = ["stroke"], l0 = ["stroke"], d0 = ["stroke"], k0 = { key: 4 }, c0 = ["stroke"], h0 = ["stroke"], u0 = ["stroke"], a0 = ["stroke"], _0 = { key: 5 }, p0 = ["stroke"], y0 = ["stroke"], $0 = ["stroke"], w0 = ["stroke"], f0 = {
  name: "PhAnchor"
}, CF1 = /* @__PURE__ */ $({
  ...f0,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", G2, [
        e("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, E2),
        e("circle", {
          cx: "128",
          cy: "52",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, O2),
        e("line", {
          x1: "88",
          y1: "112",
          x2: "168",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, I2),
        e("path", {
          d: "M40,144a48,48,0,0,0,48,48,40,40,0,0,1,40,40,40,40,0,0,1,40-40,48,48,0,0,0,48-48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, K2)
      ])) : o(i) === "duotone" ? (s(), r("g", X2, [
        e("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J2),
        e("circle", {
          cx: "128",
          cy: "52",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q2),
        e("line", {
          x1: "88",
          y1: "112",
          x2: "168",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y2),
        e("path", {
          d: "M40,144a48,48,0,0,0,48,48,40,40,0,0,1,40,40,40,40,0,0,1,40-40,48,48,0,0,0,48-48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o0)
      ])) : o(i) === "fill" ? (s(), r("g", e0, n0)) : o(i) === "light" ? (s(), r("g", s0, [
        e("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, r0),
        e("circle", {
          cx: "128",
          cy: "52",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, i0),
        e("line", {
          x1: "88",
          y1: "112",
          x2: "168",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, l0),
        e("path", {
          d: "M40,144a48,48,0,0,0,48,48,40,40,0,0,1,40,40,40,40,0,0,1,40-40,48,48,0,0,0,48-48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, d0)
      ])) : o(i) === "thin" ? (s(), r("g", k0, [
        e("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, c0),
        e("circle", {
          cx: "128",
          cy: "52",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, h0),
        e("line", {
          x1: "88",
          y1: "112",
          x2: "168",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, u0),
        e("path", {
          d: "M40,144a48,48,0,0,0,48,48,40,40,0,0,1,40,40,40,40,0,0,1,40-40,48,48,0,0,0,48-48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, a0)
      ])) : o(i) === "regular" ? (s(), r("g", _0, [
        e("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p0),
        e("circle", {
          cx: "128",
          cy: "52",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y0),
        e("line", {
          x1: "88",
          y1: "112",
          x2: "168",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $0),
        e("path", {
          d: "M40,144a48,48,0,0,0,48,48,40,40,0,0,1,40,40,40,40,0,0,1,40-40,48,48,0,0,0,48-48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w0)
      ])) : g("", !0)
    ], 16, q2));
  }
}), g0 = ["width", "height", "fill", "transform"], x0 = { key: 0 }, j0 = ["stroke"], m0 = ["stroke"], M0 = ["stroke"], v0 = { key: 1 }, S0 = ["stroke"], H0 = ["stroke"], A0 = ["stroke"], V0 = { key: 2 }, z0 = /* @__PURE__ */ e("path", { d: "M224,112H200a8,8,0,0,0,0,16h15.6A88,88,0,0,1,136,207.6V95a32,32,0,1,0-16,0V207.6A88,88,0,0,1,40.4,128H56a8,8,0,0,0,0-16H32a8,8,0,0,0-8,8,104,104,0,0,0,208,0A8,8,0,0,0,224,112ZM112,64a16,16,0,1,1,16,16A16,16,0,0,1,112,64Z" }, null, -1), Z0 = [
  z0
], C0 = { key: 3 }, b0 = ["stroke"], L0 = ["stroke"], B0 = ["stroke"], P0 = { key: 4 }, W0 = ["stroke"], N0 = ["stroke"], F0 = ["stroke"], T0 = { key: 5 }, D0 = ["stroke"], R0 = ["stroke"], U0 = ["stroke"], q0 = {
  name: "PhAnchorSimple"
}, bF1 = /* @__PURE__ */ $({
  ...q0,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", x0, [
        e("circle", {
          cx: "128",
          cy: "64",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, j0),
        e("line", {
          x1: "128",
          y1: "216",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, m0),
        e("path", {
          d: "M56,120H32a96,96,0,0,0,192,0H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, M0)
      ])) : o(i) === "duotone" ? (s(), r("g", v0, [
        e("circle", {
          cx: "128",
          cy: "64",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S0),
        e("line", {
          x1: "128",
          y1: "216",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H0),
        e("path", {
          d: "M56,120H32a96,96,0,0,0,192,0H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A0)
      ])) : o(i) === "fill" ? (s(), r("g", V0, Z0)) : o(i) === "light" ? (s(), r("g", C0, [
        e("circle", {
          cx: "128",
          cy: "64",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b0),
        e("line", {
          x1: "128",
          y1: "216",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, L0),
        e("path", {
          d: "M56,120H32a96,96,0,0,0,192,0H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, B0)
      ])) : o(i) === "thin" ? (s(), r("g", P0, [
        e("circle", {
          cx: "128",
          cy: "64",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, W0),
        e("line", {
          x1: "128",
          y1: "216",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, N0),
        e("path", {
          d: "M56,120H32a96,96,0,0,0,192,0H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, F0)
      ])) : o(i) === "regular" ? (s(), r("g", T0, [
        e("circle", {
          cx: "128",
          cy: "64",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D0),
        e("line", {
          x1: "128",
          y1: "216",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R0),
        e("path", {
          d: "M56,120H32a96,96,0,0,0,192,0H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U0)
      ])) : g("", !0)
    ], 16, g0));
  }
}), G0 = ["width", "height", "fill", "transform"], E0 = { key: 0 }, O0 = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "156",
  r: "16"
}, null, -1), I0 = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "156",
  r: "16"
}, null, -1), K0 = ["stroke"], X0 = ["stroke"], J0 = ["stroke"], Q0 = { key: 1 }, Y0 = /* @__PURE__ */ e("path", {
  d: "M24,192V169.1C24,111.6,70.2,64.2,127.6,64A104,104,0,0,1,232,168v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,192Z",
  opacity: "0.2"
}, null, -1), o8 = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "156",
  r: "12"
}, null, -1), e8 = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "156",
  r: "12"
}, null, -1), t8 = ["stroke"], n8 = ["stroke"], s8 = ["stroke"], r8 = { key: 2 }, i8 = /* @__PURE__ */ e("path", { d: "M207.1,88.7l-2.3-2.2,24.9-24.8a8.1,8.1,0,0,0-11.4-11.4l-25.9,26a111.5,111.5,0,0,0-128.6.2L37.7,50.3A8.1,8.1,0,0,0,26.3,61.7l25.1,25A113.4,113.4,0,0,0,16,169.1V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V168A111.2,111.2,0,0,0,207.1,88.7ZM92,168a12,12,0,1,1,12-12A12,12,0,0,1,92,168Zm72,0a12,12,0,1,1,12-12A12,12,0,0,1,164,168Z" }, null, -1), l8 = [
  i8
], d8 = { key: 3 }, k8 = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "156",
  r: "10"
}, null, -1), c8 = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "156",
  r: "10"
}, null, -1), h8 = ["stroke"], u8 = ["stroke"], a8 = ["stroke"], _8 = { key: 4 }, p8 = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "156",
  r: "8"
}, null, -1), y8 = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "156",
  r: "8"
}, null, -1), $8 = ["stroke"], w8 = ["stroke"], f8 = ["stroke"], g8 = { key: 5 }, x8 = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "156",
  r: "12"
}, null, -1), j8 = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "156",
  r: "12"
}, null, -1), m8 = ["stroke"], M8 = ["stroke"], v8 = ["stroke"], S8 = {
  name: "PhAndroidLogo"
}, LF1 = /* @__PURE__ */ $({
  ...S8,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", E0, [
        O0,
        I0,
        e("path", {
          d: "M24,192V169.1C24,111.6,70.2,64.2,127.6,64A104,104,0,0,1,232,168v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,192Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, K0),
        e("line", {
          x1: "32",
          y1: "56",
          x2: "63.1",
          y2: "87.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X0),
        e("line", {
          x1: "224",
          y1: "56",
          x2: "193.1",
          y2: "86.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, J0)
      ])) : o(i) === "duotone" ? (s(), r("g", Q0, [
        Y0,
        o8,
        e8,
        e("path", {
          d: "M24,192V169.1C24,111.6,70.2,64.2,127.6,64A104,104,0,0,1,232,168v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,192Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t8),
        e("line", {
          x1: "32",
          y1: "56",
          x2: "63.1",
          y2: "87.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n8),
        e("line", {
          x1: "224",
          y1: "56",
          x2: "193.1",
          y2: "86.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s8)
      ])) : o(i) === "fill" ? (s(), r("g", r8, l8)) : o(i) === "light" ? (s(), r("g", d8, [
        k8,
        c8,
        e("path", {
          d: "M24,192V169.1C24,111.6,70.2,64.2,127.6,64A104,104,0,0,1,232,168v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,192Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, h8),
        e("line", {
          x1: "32",
          y1: "56",
          x2: "63.1",
          y2: "87.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u8),
        e("line", {
          x1: "224",
          y1: "56",
          x2: "193.1",
          y2: "86.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, a8)
      ])) : o(i) === "thin" ? (s(), r("g", _8, [
        p8,
        y8,
        e("path", {
          d: "M24,192V169.1C24,111.6,70.2,64.2,127.6,64A104,104,0,0,1,232,168v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,192Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $8),
        e("line", {
          x1: "32",
          y1: "56",
          x2: "63.1",
          y2: "87.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, w8),
        e("line", {
          x1: "224",
          y1: "56",
          x2: "193.1",
          y2: "86.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, f8)
      ])) : o(i) === "regular" ? (s(), r("g", g8, [
        x8,
        j8,
        e("path", {
          d: "M24,192V169.1C24,111.6,70.2,64.2,127.6,64A104,104,0,0,1,232,168v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,192Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m8),
        e("line", {
          x1: "32",
          y1: "56",
          x2: "63.1",
          y2: "87.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M8),
        e("line", {
          x1: "224",
          y1: "56",
          x2: "193.1",
          y2: "86.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v8)
      ])) : g("", !0)
    ], 16, G0));
  }
}), H8 = ["width", "height", "fill", "transform"], A8 = { key: 0 }, V8 = ["stroke"], z8 = ["stroke"], Z8 = ["stroke"], C8 = { key: 1 }, b8 = /* @__PURE__ */ e("polygon", {
  points: "128 232 208 192 224 72 128 32 32 72 48 192 128 232",
  opacity: "0.2"
}, null, -1), L8 = ["stroke"], B8 = ["stroke"], P8 = ["stroke"], W8 = { key: 2 }, N8 = /* @__PURE__ */ e("path", { d: "M227.1,64.6l-96-40a8.3,8.3,0,0,0-6.2,0l-96,40a8.1,8.1,0,0,0-4.8,8.5l16,120a8.1,8.1,0,0,0,4.3,6.1l80,40a8.5,8.5,0,0,0,7.2,0l80-40a8.1,8.1,0,0,0,4.3-6.1l16-120A8.1,8.1,0,0,0,227.1,64.6ZM167.6,167.2a9.4,9.4,0,0,1-3.6.8,8.1,8.1,0,0,1-7.2-4.4l-8.4-16.9H107.6l-8.4,16.9a8,8,0,0,1-14.4-7.2l36-72a8.1,8.1,0,0,1,14.4,0l36,72A8.2,8.2,0,0,1,167.6,167.2ZM128,105.9l12.4,24.8H115.6Z" }, null, -1), F8 = [
  N8
], T8 = { key: 3 }, D8 = ["stroke"], R8 = ["stroke"], U8 = ["stroke"], q8 = { key: 4 }, G8 = ["stroke"], E8 = ["stroke"], O8 = ["stroke"], I8 = { key: 5 }, K8 = ["stroke"], X8 = ["stroke"], J8 = ["stroke"], Q8 = {
  name: "PhAngularLogo"
}, BF1 = /* @__PURE__ */ $({
  ...Q8,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", A8, [
        e("polygon", {
          points: "128 232 208 192 224 72 128 32 32 72 48 192 128 232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, V8),
        e("polyline", {
          points: "164 160 128 88 92 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, z8),
        e("line", {
          x1: "100.7",
          y1: "142.7",
          x2: "155.3",
          y2: "142.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Z8)
      ])) : o(i) === "duotone" ? (s(), r("g", C8, [
        b8,
        e("polygon", {
          points: "128 232 208 192 224 72 128 32 32 72 48 192 128 232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L8),
        e("polyline", {
          points: "164 160 128 88 92 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B8),
        e("line", {
          x1: "102.7",
          y1: "138.7",
          x2: "153.3",
          y2: "138.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P8)
      ])) : o(i) === "fill" ? (s(), r("g", W8, F8)) : o(i) === "light" ? (s(), r("g", T8, [
        e("polygon", {
          points: "128 232 208 192 224 72 128 32 32 72 48 192 128 232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, D8),
        e("polyline", {
          points: "164 160 128 88 92 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, R8),
        e("line", {
          x1: "102.7",
          y1: "138.7",
          x2: "153.3",
          y2: "138.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, U8)
      ])) : o(i) === "thin" ? (s(), r("g", q8, [
        e("polygon", {
          points: "128 232 208 192 224 72 128 32 32 72 48 192 128 232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, G8),
        e("polyline", {
          points: "164 160 128 88 92 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, E8),
        e("line", {
          x1: "102.7",
          y1: "138.7",
          x2: "153.3",
          y2: "138.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, O8)
      ])) : o(i) === "regular" ? (s(), r("g", I8, [
        e("polygon", {
          points: "128 232 208 192 224 72 128 32 32 72 48 192 128 232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K8),
        e("polyline", {
          points: "164 160 128 88 92 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X8),
        e("line", {
          x1: "102.7",
          y1: "138.7",
          x2: "153.3",
          y2: "138.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J8)
      ])) : g("", !0)
    ], 16, H8));
  }
}), Y8 = ["width", "height", "fill", "transform"], od = { key: 0 }, ed = ["stroke"], td = ["stroke"], nd = ["stroke"], sd = ["stroke"], rd = ["stroke"], id = ["stroke"], ld = ["stroke"], dd = { key: 1 }, kd = /* @__PURE__ */ e("path", {
  d: "M195.9,60.1a96,96,0,1,0,0,135.8A96,96,0,0,0,195.9,60.1Zm-31.2,74.6-24.2,28.4h0l-36.6-6.7h0L91.3,121.3h0l24.2-28.4h0l36.6,6.7h0l12.6,35.1Z",
  opacity: "0.2"
}, null, -1), cd = ["stroke"], hd = ["stroke"], ud = ["stroke"], ad = ["stroke"], _d = ["stroke"], pd = ["stroke"], yd = ["stroke"], $d = { key: 2 }, wd = /* @__PURE__ */ e("path", { d: "M232,128A104.1,104.1,0,0,0,128,24,104.1,104.1,0,0,0,24,128,104.1,104.1,0,0,0,128,232h.1A104.1,104.1,0,0,0,232,128ZM49.2,88.9l51.2,9.4L46.7,161.5A88,88,0,0,1,49.2,88.9Zm160.1,5.6a88,88,0,0,1-2.5,72.6l-51.2-9.4Zm-8-15.2L167.6,119l-28-78.2a86.8,86.8,0,0,1,50.6,25A88.5,88.5,0,0,1,201.3,79.3ZM122.4,40.2l17.5,49L58.3,74.3a99.2,99.2,0,0,1,7.5-8.5A87.1,87.1,0,0,1,122.4,40.2ZM54.7,176.7,88.4,137l28,78.2a86.8,86.8,0,0,1-50.6-25A88.5,88.5,0,0,1,54.7,176.7Zm78.9,39.1-17.5-49,23,4.2h.1l58.5,10.7a99.2,99.2,0,0,1-7.5,8.5A87.1,87.1,0,0,1,133.6,215.8Z" }, null, -1), fd = [
  wd
], gd = { key: 3 }, xd = ["stroke"], jd = ["stroke"], md = ["stroke"], Md = ["stroke"], vd = ["stroke"], Sd = ["stroke"], Hd = ["stroke"], Ad = { key: 4 }, Vd = ["stroke"], zd = ["stroke"], Zd = ["stroke"], Cd = ["stroke"], bd = ["stroke"], Ld = ["stroke"], Bd = ["stroke"], Pd = { key: 5 }, Wd = ["stroke"], Nd = ["stroke"], Fd = ["stroke"], Td = ["stroke"], Dd = ["stroke"], Rd = ["stroke"], Ud = ["stroke"], qd = {
  name: "PhAperture"
}, PF1 = /* @__PURE__ */ $({
  ...qd,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", od, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ed),
        e("line", {
          x1: "128",
          y1: "32",
          x2: "164.7",
          y2: "134.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, td),
        e("line", {
          x1: "44.9",
          y1: "80",
          x2: "152.1",
          y2: "99.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nd),
        e("line", {
          x1: "44.9",
          y1: "176",
          x2: "115.5",
          y2: "92.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sd),
        e("line", {
          x1: "128",
          y1: "224",
          x2: "91.3",
          y2: "121.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rd),
        e("line", {
          x1: "211.1",
          y1: "176",
          x2: "103.9",
          y2: "156.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, id),
        e("line", {
          x1: "211.1",
          y1: "80",
          x2: "140.5",
          y2: "163.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ld)
      ])) : o(i) === "duotone" ? (s(), r("g", dd, [
        kd,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cd),
        e("line", {
          x1: "128",
          y1: "32",
          x2: "164.7",
          y2: "134.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hd),
        e("line", {
          x1: "44.9",
          y1: "80",
          x2: "152.1",
          y2: "99.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ud),
        e("line", {
          x1: "44.9",
          y1: "176",
          x2: "115.5",
          y2: "92.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ad),
        e("line", {
          x1: "128",
          y1: "224",
          x2: "91.3",
          y2: "121.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _d),
        e("line", {
          x1: "211.1",
          y1: "176",
          x2: "103.9",
          y2: "156.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pd),
        e("line", {
          x1: "211.1",
          y1: "80",
          x2: "140.5",
          y2: "163.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yd)
      ])) : o(i) === "fill" ? (s(), r("g", $d, fd)) : o(i) === "light" ? (s(), r("g", gd, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xd),
        e("line", {
          x1: "128",
          y1: "32",
          x2: "164.7",
          y2: "134.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jd),
        e("line", {
          x1: "44.9",
          y1: "80",
          x2: "152.1",
          y2: "99.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, md),
        e("line", {
          x1: "44.9",
          y1: "176",
          x2: "115.5",
          y2: "92.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Md),
        e("line", {
          x1: "128",
          y1: "224",
          x2: "91.3",
          y2: "121.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vd),
        e("line", {
          x1: "211.1",
          y1: "176",
          x2: "103.9",
          y2: "156.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Sd),
        e("line", {
          x1: "211.1",
          y1: "80",
          x2: "140.5",
          y2: "163.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hd)
      ])) : o(i) === "thin" ? (s(), r("g", Ad, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vd),
        e("line", {
          x1: "128",
          y1: "32",
          x2: "164.7",
          y2: "134.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zd),
        e("line", {
          x1: "44.9",
          y1: "80",
          x2: "152.1",
          y2: "99.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zd),
        e("line", {
          x1: "44.9",
          y1: "176",
          x2: "115.5",
          y2: "92.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cd),
        e("line", {
          x1: "128",
          y1: "224",
          x2: "91.3",
          y2: "121.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bd),
        e("line", {
          x1: "211.1",
          y1: "176",
          x2: "103.9",
          y2: "156.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ld),
        e("line", {
          x1: "211.1",
          y1: "80",
          x2: "140.5",
          y2: "163.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bd)
      ])) : o(i) === "regular" ? (s(), r("g", Pd, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wd),
        e("line", {
          x1: "128",
          y1: "32",
          x2: "164.7",
          y2: "134.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nd),
        e("line", {
          x1: "44.9",
          y1: "80",
          x2: "152.1",
          y2: "99.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fd),
        e("line", {
          x1: "44.9",
          y1: "176",
          x2: "115.5",
          y2: "92.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Td),
        e("line", {
          x1: "128",
          y1: "224",
          x2: "91.3",
          y2: "121.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dd),
        e("line", {
          x1: "211.1",
          y1: "176",
          x2: "103.9",
          y2: "156.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rd),
        e("line", {
          x1: "211.1",
          y1: "80",
          x2: "140.5",
          y2: "163.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ud)
      ])) : g("", !0)
    ], 16, Y8));
  }
}), Gd = ["width", "height", "fill", "transform"], Ed = { key: 0 }, Od = ["stroke"], Id = ["stroke"], Kd = ["stroke"], Xd = ["stroke"], Jd = ["stroke"], Qd = ["stroke"], Yd = { key: 1 }, ok = ["stroke"], ek = ["stroke"], tk = ["stroke"], nk = ["stroke"], sk = ["stroke"], rk = ["stroke"], ik = { key: 2 }, lk = /* @__PURE__ */ e("path", { d: "M64.3,204.1l-9.4,16A8.1,8.1,0,0,1,48,224a8.7,8.7,0,0,1-4.1-1.1,8.1,8.1,0,0,1-2.8-11l9.5-16a8,8,0,1,1,13.7,8.2ZM232,160H184.2l-30.7-52a8,8,0,0,0-11-2.8,7.9,7.9,0,0,0-2.8,10.9l61.4,104A8.1,8.1,0,0,0,208,224a8.7,8.7,0,0,0,4.1-1.1,8.1,8.1,0,0,0,2.8-11L193.7,176H232a8,8,0,0,0,0-16Zm-89.5,0H90.4l44.4-75.2h.1l24-40.6a8,8,0,0,0-13.8-8.2L128,64.9l-17.1-29a8,8,0,1,0-13.8,8.2l21.6,36.5L71.8,160H24a8,8,0,0,0,0,16H142.5a8,8,0,0,0,0-16Z" }, null, -1), dk = [
  lk
], kk = { key: 3 }, ck = ["stroke"], hk = ["stroke"], uk = ["stroke"], ak = ["stroke"], _k = ["stroke"], pk = ["stroke"], yk = { key: 4 }, $k = ["stroke"], wk = ["stroke"], fk = ["stroke"], gk = ["stroke"], xk = ["stroke"], jk = ["stroke"], mk = { key: 5 }, Mk = ["stroke"], vk = ["stroke"], Sk = ["stroke"], Hk = ["stroke"], Ak = ["stroke"], Vk = ["stroke"], zk = {
  name: "PhAppStoreLogo"
}, WF1 = /* @__PURE__ */ $({
  ...zk,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ed, [
        e("line", {
          x1: "104",
          y1: "40",
          x2: "128",
          y2: "80.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Od),
        e("line", {
          x1: "152",
          y1: "40",
          x2: "76.4",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Id),
        e("line", {
          x1: "179.6",
          y1: "168",
          x2: "232",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kd),
        e("line", {
          x1: "151.2",
          y1: "119.9",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xd),
        e("line", {
          x1: "24",
          y1: "168",
          x2: "133.2",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jd),
        e("line", {
          x1: "52.7",
          y1: "208",
          x2: "48",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qd)
      ])) : o(i) === "duotone" ? (s(), r("g", Yd, [
        e("line", {
          x1: "146.6",
          y1: "112.1",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ok),
        e("line", {
          x1: "104",
          y1: "40",
          x2: "128",
          y2: "80.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ek),
        e("line", {
          x1: "57.5",
          y1: "200",
          x2: "48",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tk),
        e("line", {
          x1: "152",
          y1: "40",
          x2: "76.4",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nk),
        e("line", {
          x1: "179.6",
          y1: "168",
          x2: "232",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sk),
        e("line", {
          x1: "24",
          y1: "168",
          x2: "142.5",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rk)
      ])) : o(i) === "fill" ? (s(), r("g", ik, dk)) : o(i) === "light" ? (s(), r("g", kk, [
        e("line", {
          x1: "146.6",
          y1: "112.1",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ck),
        e("line", {
          x1: "104",
          y1: "40",
          x2: "128",
          y2: "80.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hk),
        e("line", {
          x1: "57.5",
          y1: "200",
          x2: "48",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uk),
        e("line", {
          x1: "152",
          y1: "40",
          x2: "76.4",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ak),
        e("line", {
          x1: "179.6",
          y1: "168",
          x2: "232",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _k),
        e("line", {
          x1: "24",
          y1: "168",
          x2: "142.5",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pk)
      ])) : o(i) === "thin" ? (s(), r("g", yk, [
        e("line", {
          x1: "146.6",
          y1: "112.1",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $k),
        e("line", {
          x1: "104",
          y1: "40",
          x2: "128",
          y2: "80.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wk),
        e("line", {
          x1: "57.5",
          y1: "200",
          x2: "48",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fk),
        e("line", {
          x1: "152",
          y1: "40",
          x2: "76.4",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gk),
        e("line", {
          x1: "179.6",
          y1: "168",
          x2: "232",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xk),
        e("line", {
          x1: "24",
          y1: "168",
          x2: "142.5",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jk)
      ])) : o(i) === "regular" ? (s(), r("g", mk, [
        e("line", {
          x1: "146.6",
          y1: "112.1",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mk),
        e("line", {
          x1: "104",
          y1: "40",
          x2: "128",
          y2: "80.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vk),
        e("line", {
          x1: "57.5",
          y1: "200",
          x2: "48",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sk),
        e("line", {
          x1: "152",
          y1: "40",
          x2: "76.4",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hk),
        e("line", {
          x1: "179.6",
          y1: "168",
          x2: "232",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ak),
        e("line", {
          x1: "24",
          y1: "168",
          x2: "142.5",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vk)
      ])) : g("", !0)
    ], 16, Gd));
  }
}), Zk = ["width", "height", "fill", "transform"], Ck = { key: 0 }, bk = ["stroke"], Lk = /* @__PURE__ */ e("circle", {
  cx: "76",
  cy: "92",
  r: "16"
}, null, -1), Bk = /* @__PURE__ */ e("circle", {
  cx: "124",
  cy: "92",
  r: "16"
}, null, -1), Pk = { key: 1 }, Wk = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "48",
  width: "192",
  height: "160",
  rx: "8",
  opacity: "0.2"
}, null, -1), Nk = ["stroke"], Fk = /* @__PURE__ */ e("circle", {
  cx: "68",
  cy: "84",
  r: "12"
}, null, -1), Tk = /* @__PURE__ */ e("circle", {
  cx: "108",
  cy: "84",
  r: "12"
}, null, -1), Dk = { key: 2 }, Rk = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM68,96A12,12,0,1,1,80,84,12,12,0,0,1,68,96Zm40,0a12,12,0,1,1,12-12A12,12,0,0,1,108,96Z" }, null, -1), Uk = [
  Rk
], qk = { key: 3 }, Gk = ["stroke"], Ek = /* @__PURE__ */ e("circle", {
  cx: "68",
  cy: "84",
  r: "10"
}, null, -1), Ok = /* @__PURE__ */ e("circle", {
  cx: "108",
  cy: "84",
  r: "10"
}, null, -1), Ik = { key: 4 }, Kk = ["stroke"], Xk = /* @__PURE__ */ e("circle", {
  cx: "68",
  cy: "84",
  r: "8"
}, null, -1), Jk = /* @__PURE__ */ e("circle", {
  cx: "108",
  cy: "84",
  r: "8"
}, null, -1), Qk = { key: 5 }, Yk = ["stroke"], oc = /* @__PURE__ */ e("circle", {
  cx: "68",
  cy: "84",
  r: "12"
}, null, -1), ec = /* @__PURE__ */ e("circle", {
  cx: "108",
  cy: "84",
  r: "12"
}, null, -1), tc = {
  name: "PhAppWindow"
}, NF1 = /* @__PURE__ */ $({
  ...tc,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ck, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bk),
        Lk,
        Bk
      ])) : o(i) === "duotone" ? (s(), r("g", Pk, [
        Wk,
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nk),
        Fk,
        Tk
      ])) : o(i) === "fill" ? (s(), r("g", Dk, Uk)) : o(i) === "light" ? (s(), r("g", qk, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gk),
        Ek,
        Ok
      ])) : o(i) === "thin" ? (s(), r("g", Ik, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kk),
        Xk,
        Jk
      ])) : o(i) === "regular" ? (s(), r("g", Qk, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yk),
        oc,
        ec
      ])) : g("", !0)
    ], 16, Zk));
  }
}), nc = ["width", "height", "fill", "transform"], sc = { key: 0 }, rc = ["stroke"], ic = ["stroke"], lc = ["stroke"], dc = { key: 1 }, kc = /* @__PURE__ */ e("path", {
  d: "M218.5,162.9C205.9,193.7,183.1,216,164,216H92c-28,0-64-48-64-100A60,60,0,0,1,128,71.3h0a60,60,0,0,1,87.2,7.6h0a48,48,0,0,0,3.3,84Z",
  opacity: "0.2"
}, null, -1), cc = ["stroke"], hc = ["stroke"], uc = { key: 2 }, ac = /* @__PURE__ */ e("path", { d: "M130.7,29.6A40.2,40.2,0,0,1,168,4a8,8,0,0,1,0,16,24.1,24.1,0,0,0-22.4,15.4,8,8,0,0,1-7.5,5.1,9.2,9.2,0,0,1-2.8-.5A8,8,0,0,1,130.7,29.6ZM222,155.8a40,40,0,0,1-2.7-70A8.2,8.2,0,0,0,221.5,74,68,68,0,0,0,128,61,68,68,0,0,0,20,116a135,135,0,0,0,22.9,74c14.4,21.3,32.7,34,49.1,34h72c22.5,0,47.9-23.9,61.9-58A7.9,7.9,0,0,0,222,155.8Z" }, null, -1), _c = [
  ac
], pc = { key: 3 }, yc = ["stroke"], $c = ["stroke"], wc = { key: 4 }, fc = ["stroke"], gc = ["stroke"], xc = { key: 5 }, jc = ["stroke"], mc = ["stroke"], Mc = {
  name: "PhAppleLogo"
}, FF1 = /* @__PURE__ */ $({
  ...Mc,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", sc, [
        e("path", {
          d: "M218.5,162.9C205.9,193.7,183.1,216,164,216H92c-28,0-64-48-64-100A60,60,0,0,1,128,71.3h0a60,60,0,0,1,87.2,7.6h0a48,48,0,0,0,3.3,84Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rc),
        e("path", {
          d: "M218.5,162.9C205.9,193.7,183.1,216,164,216H92c-28,0-64-48-64-100A60,60,0,0,1,128,71.3h0a60,60,0,0,1,87.2,7.6h0a48,48,0,0,0,3.3,84Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ic),
        e("path", {
          d: "M143.5,23.4A31.9,31.9,0,0,1,168,12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lc)
      ])) : o(i) === "duotone" ? (s(), r("g", dc, [
        kc,
        e("path", {
          d: "M138.1,32.5A32,32,0,0,1,168,12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cc),
        e("path", {
          d: "M218.5,162.9C205.9,193.7,183.1,216,164,216H92c-28,0-64-48-64-100A60,60,0,0,1,128,71.3h0a60,60,0,0,1,87.2,7.6h0a48,48,0,0,0,3.3,84Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hc)
      ])) : o(i) === "fill" ? (s(), r("g", uc, _c)) : o(i) === "light" ? (s(), r("g", pc, [
        e("path", {
          d: "M138.1,32.5A32,32,0,0,1,168,12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yc),
        e("path", {
          d: "M218.5,162.9C205.9,193.7,183.1,216,164,216H92c-28,0-64-48-64-100A60,60,0,0,1,128,71.3h0a60,60,0,0,1,87.2,7.6h0a48,48,0,0,0,3.3,84Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $c)
      ])) : o(i) === "thin" ? (s(), r("g", wc, [
        e("path", {
          d: "M138.1,32.5A32,32,0,0,1,168,12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fc),
        e("path", {
          d: "M218.5,162.9C205.9,193.7,183.1,216,164,216H92c-28,0-64-48-64-100A60,60,0,0,1,128,71.3h0a60,60,0,0,1,87.2,7.6h0a48,48,0,0,0,3.3,84Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gc)
      ])) : o(i) === "regular" ? (s(), r("g", xc, [
        e("path", {
          d: "M138.1,32.5A32,32,0,0,1,168,12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jc),
        e("path", {
          d: "M218.5,162.9C205.9,193.7,183.1,216,164,216H92c-28,0-64-48-64-100A60,60,0,0,1,128,71.3h0a60,60,0,0,1,87.2,7.6h0a48,48,0,0,0,3.3,84Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mc)
      ])) : g("", !0)
    ], 16, nc));
  }
}), vc = ["width", "height", "fill", "transform"], Sc = { key: 0 }, Hc = ["stroke"], Ac = ["stroke"], Vc = ["stroke"], zc = ["stroke"], Zc = { key: 1 }, Cc = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "120",
  r: "24",
  opacity: "0.2"
}, null, -1), bc = /* @__PURE__ */ e("path", {
  d: "M130.9,224h-5.8a16,16,0,0,1-15.7-12.9l-9.6-48A16,16,0,0,1,115.5,144h25a16,16,0,0,1,15.7,19.1l-9.6,48A16,16,0,0,1,130.9,224Z",
  opacity: "0.2"
}, null, -1), Lc = ["stroke"], Bc = ["stroke"], Pc = ["stroke"], Wc = ["stroke"], Nc = { key: 2 }, Fc = /* @__PURE__ */ e("path", { d: "M128,144a28,28,0,1,1,28-28A28.1,28.1,0,0,1,128,144Zm12.5,0h-25a19.9,19.9,0,0,0-15.4,7.3,19.6,19.6,0,0,0-4.2,16.6l9.6,48A20.1,20.1,0,0,0,125.1,232h5.8a20.1,20.1,0,0,0,19.6-16.1l9.6-48a19.6,19.6,0,0,0-4.2-16.6A19.9,19.9,0,0,0,140.5,144Zm39.7,4.3a8,8,0,0,0,14.9,5.8A70.7,70.7,0,0,0,200,128a72,72,0,0,0-144,0,70.3,70.3,0,0,0,4.9,26.1,8,8,0,0,0,7.4,5.1,7.2,7.2,0,0,0,2.9-.6,8,8,0,0,0,4.6-10.3,56,56,0,1,1,104.4,0ZM128,24A104,104,0,0,0,72,215.7a8,8,0,0,0,8.7-13.5,88,88,0,1,1,94.6,0,8,8,0,0,0,4.4,14.7,8.8,8.8,0,0,0,4.3-1.2A104,104,0,0,0,128,24Z" }, null, -1), Tc = [
  Fc
], Dc = { key: 3 }, Rc = ["stroke"], Uc = ["stroke"], qc = ["stroke"], Gc = ["stroke"], Ec = { key: 4 }, Oc = ["stroke"], Ic = ["stroke"], Kc = ["stroke"], Xc = ["stroke"], Jc = { key: 5 }, Qc = ["stroke"], Yc = ["stroke"], oh = ["stroke"], eh = ["stroke"], th = {
  name: "PhApplePodcastsLogo"
}, TF1 = /* @__PURE__ */ $({
  ...th,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Sc, [
        e("circle", {
          cx: "128",
          cy: "108",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hc),
        e("path", {
          d: "M134.6,224H121.4a16,16,0,0,1-15.8-13.1l-10.2-56A16,16,0,0,1,111.2,136h33.6a16,16,0,0,1,15.8,18.9l-10.2,56A16,16,0,0,1,134.6,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ac),
        e("path", {
          d: "M134.6,224H121.4a16,16,0,0,1-15.8-13.1l-10.2-56A16,16,0,0,1,111.2,136h33.6a16,16,0,0,1,15.8,18.9l-10.2,56A16,16,0,0,1,134.6,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vc),
        e("path", {
          d: "M62.7,198.4a96,96,0,1,1,130.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zc)
      ])) : o(i) === "duotone" ? (s(), r("g", Zc, [
        Cc,
        bc,
        e("circle", {
          cx: "128",
          cy: "120",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lc),
        e("path", {
          d: "M130.9,224h-5.8a16,16,0,0,1-15.7-12.9l-9.6-48A16,16,0,0,1,115.5,144h25a16,16,0,0,1,15.7,19.1l-9.6,48A16,16,0,0,1,130.9,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bc),
        e("path", {
          d: "M68.3,151.2a64,64,0,1,1,119.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pc),
        e("path", {
          d: "M76.4,208.9a96,96,0,1,1,103.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wc)
      ])) : o(i) === "fill" ? (s(), r("g", Nc, Tc)) : o(i) === "light" ? (s(), r("g", Dc, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rc),
        e("path", {
          d: "M130.9,224h-5.8a16,16,0,0,1-15.7-12.9l-9.6-48A16,16,0,0,1,115.5,144h25a16,16,0,0,1,15.7,19.1l-9.6,48A16,16,0,0,1,130.9,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Uc),
        e("path", {
          d: "M68.3,151.2a64,64,0,1,1,119.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qc),
        e("path", {
          d: "M76.4,208.9a96,96,0,1,1,103.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gc)
      ])) : o(i) === "thin" ? (s(), r("g", Ec, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Oc),
        e("path", {
          d: "M130.9,224h-5.8a16,16,0,0,1-15.7-12.9l-9.6-48A16,16,0,0,1,115.5,144h25a16,16,0,0,1,15.7,19.1l-9.6,48A16,16,0,0,1,130.9,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ic),
        e("path", {
          d: "M68.3,151.2a64,64,0,1,1,119.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kc),
        e("path", {
          d: "M76.4,208.9a96,96,0,1,1,103.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xc)
      ])) : o(i) === "regular" ? (s(), r("g", Jc, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qc),
        e("path", {
          d: "M130.9,224h-5.8a16,16,0,0,1-15.7-12.9l-9.6-48A16,16,0,0,1,115.5,144h25a16,16,0,0,1,15.7,19.1l-9.6,48A16,16,0,0,1,130.9,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yc),
        e("path", {
          d: "M68.3,151.2a64,64,0,1,1,119.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oh),
        e("path", {
          d: "M76.4,208.9a96,96,0,1,1,103.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eh)
      ])) : g("", !0)
    ], 16, vc));
  }
}), nh = ["width", "height", "fill", "transform"], sh = { key: 0 }, rh = ["stroke"], ih = ["stroke"], lh = ["stroke"], dh = { key: 1 }, kh = /* @__PURE__ */ e("path", {
  d: "M216,96v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96Z",
  opacity: "0.2"
}, null, -1), ch = ["stroke"], hh = ["stroke"], uh = ["stroke"], ah = { key: 2 }, _h = /* @__PURE__ */ e("path", { d: "M224,48H32A16,16,0,0,0,16,64V88a16,16,0,0,0,16,16v88a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V104a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm-72,96H104a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm72-56H32V64H224V88Z" }, null, -1), ph = [
  _h
], yh = { key: 3 }, $h = ["stroke"], wh = ["stroke"], fh = ["stroke"], gh = { key: 4 }, xh = ["stroke"], jh = ["stroke"], mh = ["stroke"], Mh = { key: 5 }, vh = ["stroke"], Sh = ["stroke"], Hh = ["stroke"], Ah = {
  name: "PhArchive"
}, DF1 = /* @__PURE__ */ $({
  ...Ah,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", sh, [
        e("rect", {
          x: "24",
          y: "56",
          width: "208",
          height: "40",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rh),
        e("path", {
          d: "M216,96v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ih),
        e("line", {
          x1: "104",
          y1: "136",
          x2: "152",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lh)
      ])) : o(i) === "duotone" ? (s(), r("g", dh, [
        kh,
        e("rect", {
          x: "24",
          y: "56",
          width: "208",
          height: "40",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ch),
        e("path", {
          d: "M216,96v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hh),
        e("line", {
          x1: "104",
          y1: "136",
          x2: "152",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uh)
      ])) : o(i) === "fill" ? (s(), r("g", ah, ph)) : o(i) === "light" ? (s(), r("g", yh, [
        e("rect", {
          x: "24",
          y: "56",
          width: "208",
          height: "40",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $h),
        e("path", {
          d: "M216,96v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wh),
        e("line", {
          x1: "104",
          y1: "136",
          x2: "152",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fh)
      ])) : o(i) === "thin" ? (s(), r("g", gh, [
        e("rect", {
          x: "24",
          y: "56",
          width: "208",
          height: "40",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xh),
        e("path", {
          d: "M216,96v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jh),
        e("line", {
          x1: "104",
          y1: "136",
          x2: "152",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mh)
      ])) : o(i) === "regular" ? (s(), r("g", Mh, [
        e("rect", {
          x: "24",
          y: "56",
          width: "208",
          height: "40",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vh),
        e("path", {
          d: "M216,96v96a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sh),
        e("line", {
          x1: "104",
          y1: "136",
          x2: "152",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hh)
      ])) : g("", !0)
    ], 16, nh));
  }
}), Vh = ["width", "height", "fill", "transform"], zh = { key: 0 }, Zh = ["stroke"], Ch = ["stroke"], bh = ["stroke"], Lh = ["stroke"], Bh = { key: 1 }, Ph = /* @__PURE__ */ e("path", {
  d: "M216,72V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V72Z",
  opacity: "0.2"
}, null, -1), Wh = ["stroke"], Nh = ["stroke"], Fh = ["stroke"], Th = ["stroke"], Dh = { key: 2 }, Rh = /* @__PURE__ */ e("path", { d: "M223.2,68.4l-16-32A8.2,8.2,0,0,0,200,32H56a8.2,8.2,0,0,0-7.2,4.4l-16,32A9,9,0,0,0,32,72V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V72A9,9,0,0,0,223.2,68.4Zm-55.6,87.3-33.9,34a8.2,8.2,0,0,1-11.4,0l-33.9-34a8,8,0,0,1,11.3-11.3L120,164.7V104a8,8,0,0,1,16,0v60.7l20.3-20.3a8,8,0,0,1,11.3,11.3ZM52.9,64l8-16H195.1l8,16Z" }, null, -1), Uh = [
  Rh
], qh = { key: 3 }, Gh = ["stroke"], Eh = ["stroke"], Oh = ["stroke"], Ih = ["stroke"], Kh = { key: 4 }, Xh = ["stroke"], Jh = ["stroke"], Qh = ["stroke"], Yh = ["stroke"], o6 = { key: 5 }, e6 = ["stroke"], t6 = ["stroke"], n6 = ["stroke"], s6 = ["stroke"], r6 = {
  name: "PhArchiveBox"
}, RF1 = /* @__PURE__ */ $({
  ...r6,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", zh, [
        e("path", {
          d: "M208,216H48a8,8,0,0,1-8-8V76L56,40H200l16,36V208A8,8,0,0,1,208,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zh),
        e("line", {
          x1: "40",
          y1: "76",
          x2: "216",
          y2: "76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ch),
        e("polyline", {
          points: "99.7 151.7 128 180 156.3 151.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bh),
        e("line", {
          x1: "128",
          y1: "112",
          x2: "128",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lh)
      ])) : o(i) === "duotone" ? (s(), r("g", Bh, [
        Ph,
        e("path", {
          d: "M208,216H48a8,8,0,0,1-8-8V72L56,40H200l16,32V208A8,8,0,0,1,208,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wh),
        e("polyline", {
          points: "94.1 150.1 128 184 161.9 150.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nh),
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fh),
        e("line", {
          x1: "40",
          y1: "72",
          x2: "216",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Th)
      ])) : o(i) === "fill" ? (s(), r("g", Dh, Uh)) : o(i) === "light" ? (s(), r("g", qh, [
        e("path", {
          d: "M208,216H48a8,8,0,0,1-8-8V72L56,40H200l16,32V208A8,8,0,0,1,208,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gh),
        e("polyline", {
          points: "94.1 150.1 128 184 161.9 150.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Eh),
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Oh),
        e("line", {
          x1: "40",
          y1: "72",
          x2: "216",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ih)
      ])) : o(i) === "thin" ? (s(), r("g", Kh, [
        e("path", {
          d: "M208,216H48a8,8,0,0,1-8-8V72L56,40H200l16,32V208A8,8,0,0,1,208,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xh),
        e("polyline", {
          points: "94.1 150.1 128 184 161.9 150.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jh),
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qh),
        e("line", {
          x1: "40",
          y1: "72",
          x2: "216",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Yh)
      ])) : o(i) === "regular" ? (s(), r("g", o6, [
        e("path", {
          d: "M208,216H48a8,8,0,0,1-8-8V72L56,40H200l16,32V208A8,8,0,0,1,208,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e6),
        e("polyline", {
          points: "94.1 150.1 128 184 161.9 150.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t6),
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n6),
        e("line", {
          x1: "40",
          y1: "72",
          x2: "216",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s6)
      ])) : g("", !0)
    ], 16, Vh));
  }
}), i6 = ["width", "height", "fill", "transform"], l6 = { key: 0 }, d6 = ["stroke"], k6 = ["stroke"], c6 = ["stroke"], h6 = ["stroke"], u6 = { key: 1 }, a6 = /* @__PURE__ */ e("path", {
  d: "M76.7,160a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V160Z",
  opacity: "0.2"
}, null, -1), _6 = ["stroke"], p6 = ["stroke"], y6 = ["stroke"], $6 = ["stroke"], w6 = { key: 2 }, f6 = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V159.9h0V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM88.4,112.4a8,8,0,0,1,11.3,0L120,132.7V72a8,8,0,0,1,16,0v60.7l20.3-20.3a8,8,0,0,1,11.3,11.3l-33.9,34h-.2l-.4.4h-.2l-.5.3c0,.1-.1.1-.1.2l-.5.3h-.2l-.5.3H131l-.7.3h-4.6l-.7-.3h-.1l-.5-.3h-.2l-.5-.3c0-.1-.1-.1-.1-.2l-.5-.3h-.2l-.4-.4h-.2l-33.9-34A8,8,0,0,1,88.4,112.4ZM208,208H48V168H76.7L96,187.3a15.9,15.9,0,0,0,11.3,4.7h41.4a15.9,15.9,0,0,0,11.3-4.7L179.3,168H208v40Z" }, null, -1), g6 = [
  f6
], x6 = { key: 3 }, j6 = ["stroke"], m6 = ["stroke"], M6 = ["stroke"], v6 = ["stroke"], S6 = { key: 4 }, H6 = ["stroke"], A6 = ["stroke"], V6 = ["stroke"], z6 = ["stroke"], Z6 = { key: 5 }, C6 = ["stroke"], b6 = ["stroke"], L6 = ["stroke"], B6 = ["stroke"], P6 = {
  name: "PhArchiveTray"
}, UF1 = /* @__PURE__ */ $({
  ...P6,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", l6, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, d6),
        e("polyline", {
          points: "99.7 115.7 128 144 156.3 115.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, k6),
        e("line", {
          x1: "128",
          y1: "76",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, c6),
        e("path", {
          d: "M40,156H76.7a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, h6)
      ])) : o(i) === "duotone" ? (s(), r("g", u6, [
        a6,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _6),
        e("polyline", {
          points: "94.1 118.1 128 152 161.9 118.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p6),
        e("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y6),
        e("path", {
          d: "M40,160H76.7a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $6)
      ])) : o(i) === "fill" ? (s(), r("g", w6, g6)) : o(i) === "light" ? (s(), r("g", x6, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, j6),
        e("polyline", {
          points: "94.1 118.1 128 152 161.9 118.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, m6),
        e("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, M6),
        e("path", {
          d: "M40,160H76.7a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, v6)
      ])) : o(i) === "thin" ? (s(), r("g", S6, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, H6),
        e("polyline", {
          points: "94.1 118.1 128 152 161.9 118.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, A6),
        e("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, V6),
        e("path", {
          d: "M40,160H76.7a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, z6)
      ])) : o(i) === "regular" ? (s(), r("g", Z6, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C6),
        e("polyline", {
          points: "94.1 118.1 128 152 161.9 118.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b6),
        e("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L6),
        e("path", {
          d: "M40,160H76.7a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B6)
      ])) : g("", !0)
    ], 16, i6));
  }
}), W6 = ["width", "height", "fill", "transform"], N6 = { key: 0 }, F6 = ["stroke"], T6 = ["stroke"], D6 = ["stroke"], R6 = { key: 1 }, U6 = /* @__PURE__ */ e("path", {
  d: "M208,160v40a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V160h0a32,32,0,0,1,0-64V72A32,32,0,0,1,80,40h96a32,32,0,0,1,32,32V96a32,32,0,0,1,0,64Z",
  opacity: "0.2"
}, null, -1), q6 = ["stroke"], G6 = ["stroke"], E6 = ["stroke"], O6 = { key: 2 }, I6 = /* @__PURE__ */ e("path", { d: "M216,159v41a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V159a32,32,0,1,1,40-31v40a8,8,0,0,0,16,0V136h64v32a8,8,0,0,0,16,0V128a32,32,0,1,1,40,31ZM95.3,120h65.4A48,48,0,0,1,208,80h3.7a3.9,3.9,0,0,0,4.3-3.9V72a40,40,0,0,0-40-40H80A40,40,0,0,0,40,72v4.2a3.9,3.9,0,0,0,4.3,3.9H48A48,48,0,0,1,95.3,120Z" }, null, -1), K6 = [
  I6
], X6 = { key: 3 }, J6 = ["stroke"], Q6 = ["stroke"], Y6 = ["stroke"], ou = { key: 4 }, eu = ["stroke"], tu = ["stroke"], nu = ["stroke"], su = { key: 5 }, ru = ["stroke"], iu = ["stroke"], lu = ["stroke"], du = {
  name: "PhArmchair"
}, qF1 = /* @__PURE__ */ $({
  ...du,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", N6, [
        e("line", {
          x1: "92",
          y1: "136",
          x2: "164",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, F6),
        e("path", {
          d: "M164,164V128a40,40,0,1,1,44,39.8V200a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V167.8A40,40,0,1,1,92,128v36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, T6),
        e("path", {
          d: "M48,88.2V72A32,32,0,0,1,80,40h96a32,32,0,0,1,32,32V88.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, D6)
      ])) : o(i) === "duotone" ? (s(), r("g", R6, [
        U6,
        e("line", {
          x1: "80",
          y1: "136",
          x2: "176",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q6),
        e("path", {
          d: "M48,96V72A32,32,0,0,1,80,40h96a32,32,0,0,1,32,32V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G6),
        e("path", {
          d: "M80,168V128a32,32,0,1,0-32,32h0v40a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V160h0a32,32,0,1,0-32-32v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E6)
      ])) : o(i) === "fill" ? (s(), r("g", O6, K6)) : o(i) === "light" ? (s(), r("g", X6, [
        e("line", {
          x1: "80",
          y1: "136",
          x2: "176",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, J6),
        e("path", {
          d: "M48,96V72A32,32,0,0,1,80,40h96a32,32,0,0,1,32,32V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Q6),
        e("path", {
          d: "M80,168V128a32,32,0,1,0-32,32h0v40a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V160h0a32,32,0,1,0-32-32v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Y6)
      ])) : o(i) === "thin" ? (s(), r("g", ou, [
        e("line", {
          x1: "80",
          y1: "136",
          x2: "176",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eu),
        e("path", {
          d: "M48,96V72A32,32,0,0,1,80,40h96a32,32,0,0,1,32,32V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tu),
        e("path", {
          d: "M80,168V128a32,32,0,1,0-32,32h0v40a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V160h0a32,32,0,1,0-32-32v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nu)
      ])) : o(i) === "regular" ? (s(), r("g", su, [
        e("line", {
          x1: "80",
          y1: "136",
          x2: "176",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ru),
        e("path", {
          d: "M48,96V72A32,32,0,0,1,80,40h96a32,32,0,0,1,32,32V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iu),
        e("path", {
          d: "M80,168V128a32,32,0,1,0-32,32h0v40a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V160h0a32,32,0,1,0-32-32v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lu)
      ])) : g("", !0)
    ], 16, W6));
  }
}), ku = ["width", "height", "fill", "transform"], cu = { key: 0 }, hu = ["stroke"], uu = ["stroke"], au = { key: 1 }, _u = ["stroke"], pu = ["stroke"], yu = { key: 2 }, $u = /* @__PURE__ */ e("path", { d: "M232,184a8,8,0,0,1-16,0A88,88,0,0,0,71.7,116.4l26.1,26.1a8,8,0,0,1,1.7,8.7,7.9,7.9,0,0,1-7.4,4.9h-64a8,8,0,0,1-8-8v-64a8,8,0,0,1,13.7-5.6L60.3,105a104,104,0,0,1,141.2,5.5A102.9,102.9,0,0,1,232,184Z" }, null, -1), wu = [
  $u
], fu = { key: 3 }, gu = ["stroke"], xu = ["stroke"], ju = { key: 4 }, mu = ["stroke"], Mu = ["stroke"], vu = { key: 5 }, Su = ["stroke"], Hu = ["stroke"], Au = {
  name: "PhArrowArcLeft"
}, GF1 = /* @__PURE__ */ $({
  ...Au,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", cu, [
        e("polyline", {
          points: "92.1 148.1 28.1 148.1 28.1 84.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hu),
        e("path", {
          d: "M224,184A96,96,0,0,0,60.1,116.1l-32,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uu)
      ])) : o(i) === "duotone" ? (s(), r("g", au, [
        e("polyline", {
          points: "92.1 148.1 28.1 148.1 28.1 84.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _u),
        e("path", {
          d: "M224,184A96,96,0,0,0,60.1,116.1l-32,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pu)
      ])) : o(i) === "fill" ? (s(), r("g", yu, wu)) : o(i) === "light" ? (s(), r("g", fu, [
        e("polyline", {
          points: "92.1 148.1 28.1 148.1 28.1 84.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gu),
        e("path", {
          d: "M224,184A96,96,0,0,0,60.1,116.1l-32,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xu)
      ])) : o(i) === "thin" ? (s(), r("g", ju, [
        e("polyline", {
          points: "92.1 148.1 28.1 148.1 28.1 84.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mu),
        e("path", {
          d: "M224,184A96,96,0,0,0,60.1,116.1l-32,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Mu)
      ])) : o(i) === "regular" ? (s(), r("g", vu, [
        e("polyline", {
          points: "92.1 148.1 28.1 148.1 28.1 84.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Su),
        e("path", {
          d: "M224,184A96,96,0,0,0,60.1,116.1l-32,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hu)
      ])) : g("", !0)
    ], 16, ku));
  }
}), Vu = ["width", "height", "fill", "transform"], zu = { key: 0 }, Zu = ["stroke"], Cu = ["stroke"], bu = { key: 1 }, Lu = ["stroke"], Bu = ["stroke"], Pu = { key: 2 }, Wu = /* @__PURE__ */ e("path", { d: "M235.9,84.1v64a8,8,0,0,1-8,8h-64a7.9,7.9,0,0,1-7.4-4.9,8,8,0,0,1,1.7-8.7l26.1-26.1A88,88,0,0,0,40,184a8,8,0,0,1-16,0A104.1,104.1,0,0,1,128,80a103.3,103.3,0,0,1,67.7,25l26.5-26.5a8,8,0,0,1,13.7,5.6Z" }, null, -1), Nu = [
  Wu
], Fu = { key: 3 }, Tu = ["stroke"], Du = ["stroke"], Ru = { key: 4 }, Uu = ["stroke"], qu = ["stroke"], Gu = { key: 5 }, Eu = ["stroke"], Ou = ["stroke"], Iu = {
  name: "PhArrowArcRight"
}, EF1 = /* @__PURE__ */ $({
  ...Iu,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", zu, [
        e("polyline", {
          points: "163.9 148.1 227.9 148.1 227.9 84.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zu),
        e("path", {
          d: "M32,184a96,96,0,0,1,163.9-67.9l32,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cu)
      ])) : o(i) === "duotone" ? (s(), r("g", bu, [
        e("polyline", {
          points: "163.9 148.1 227.9 148.1 227.9 84.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lu),
        e("path", {
          d: "M32,184a96,96,0,0,1,163.9-67.9l32,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bu)
      ])) : o(i) === "fill" ? (s(), r("g", Pu, Nu)) : o(i) === "light" ? (s(), r("g", Fu, [
        e("polyline", {
          points: "163.9 148.1 227.9 148.1 227.9 84.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Tu),
        e("path", {
          d: "M32,184a96,96,0,0,1,163.9-67.9l32,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Du)
      ])) : o(i) === "thin" ? (s(), r("g", Ru, [
        e("polyline", {
          points: "163.9 148.1 227.9 148.1 227.9 84.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Uu),
        e("path", {
          d: "M32,184a96,96,0,0,1,163.9-67.9l32,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qu)
      ])) : o(i) === "regular" ? (s(), r("g", Gu, [
        e("polyline", {
          points: "163.9 148.1 227.9 148.1 227.9 84.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Eu),
        e("path", {
          d: "M32,184a96,96,0,0,1,163.9-67.9l32,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ou)
      ])) : g("", !0)
    ], 16, Vu));
  }
}), Ku = ["width", "height", "fill", "transform"], Xu = { key: 0 }, Ju = ["stroke"], Qu = ["stroke"], Yu = ["stroke"], o4 = { key: 1 }, e4 = ["stroke"], t4 = ["stroke"], n4 = ["stroke"], s4 = { key: 2 }, r4 = /* @__PURE__ */ e("path", { d: "M85.7,146.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0l-48-48a8.1,8.1,0,0,1,0-11.4l48-48A8.1,8.1,0,0,1,85.7,61.7L43.3,104Zm50.3-50V56a8,8,0,0,0-4.9-7.4,8.4,8.4,0,0,0-8.8,1.7l-48,48a8.1,8.1,0,0,0,0,11.4l48,48A8.3,8.3,0,0,0,128,160a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,136,152V112.4A88.1,88.1,0,0,1,216,200a8,8,0,0,0,16,0A104.1,104.1,0,0,0,136,96.3Z" }, null, -1), i4 = [
  r4
], l4 = { key: 3 }, d4 = ["stroke"], k4 = ["stroke"], c4 = ["stroke"], h4 = { key: 4 }, u4 = ["stroke"], a4 = ["stroke"], _4 = ["stroke"], p4 = { key: 5 }, y4 = ["stroke"], $4 = ["stroke"], w4 = ["stroke"], f4 = {
  name: "PhArrowBendDoubleUpLeft"
}, OF1 = /* @__PURE__ */ $({
  ...f4,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Xu, [
        e("polyline", {
          points: "80 152 32 104 80 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ju),
        e("polyline", {
          points: "136 152 88 104 136 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qu),
        e("path", {
          d: "M224,200a96,96,0,0,0-96-96H88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Yu)
      ])) : o(i) === "duotone" ? (s(), r("g", o4, [
        e("polyline", {
          points: "80 152 32 104 80 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e4),
        e("polyline", {
          points: "128 152 80 104 128 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t4),
        e("path", {
          d: "M224,200a96,96,0,0,0-96-96H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n4)
      ])) : o(i) === "fill" ? (s(), r("g", s4, i4)) : o(i) === "light" ? (s(), r("g", l4, [
        e("polyline", {
          points: "80 152 32 104 80 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, d4),
        e("polyline", {
          points: "128 152 80 104 128 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, k4),
        e("path", {
          d: "M224,200a96,96,0,0,0-96-96H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, c4)
      ])) : o(i) === "thin" ? (s(), r("g", h4, [
        e("polyline", {
          points: "80 152 32 104 80 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, u4),
        e("polyline", {
          points: "128 152 80 104 128 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, a4),
        e("path", {
          d: "M224,200a96,96,0,0,0-96-96H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _4)
      ])) : o(i) === "regular" ? (s(), r("g", p4, [
        e("polyline", {
          points: "80 152 32 104 80 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y4),
        e("polyline", {
          points: "128 152 80 104 128 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $4),
        e("path", {
          d: "M224,200a96,96,0,0,0-96-96H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w4)
      ])) : g("", !0)
    ], 16, Ku));
  }
}), g4 = ["width", "height", "fill", "transform"], x4 = { key: 0 }, j4 = ["stroke"], m4 = ["stroke"], M4 = ["stroke"], v4 = { key: 1 }, S4 = ["stroke"], H4 = ["stroke"], A4 = ["stroke"], V4 = { key: 2 }, z4 = /* @__PURE__ */ e("path", { d: "M229.7,109.7l-48,48a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L212.7,104,170.3,61.7a8.1,8.1,0,0,1,11.4-11.4l48,48A8.1,8.1,0,0,1,229.7,109.7Zm-48-11.4-48-48a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,120,56V96.3A104.1,104.1,0,0,0,24,200a8,8,0,0,0,16,0,88.1,88.1,0,0,1,80-87.6V152a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l48-48A8.1,8.1,0,0,0,181.7,98.3Z" }, null, -1), Z4 = [
  z4
], C4 = { key: 3 }, b4 = ["stroke"], L4 = ["stroke"], B4 = ["stroke"], P4 = { key: 4 }, W4 = ["stroke"], N4 = ["stroke"], F4 = ["stroke"], T4 = { key: 5 }, D4 = ["stroke"], R4 = ["stroke"], U4 = ["stroke"], q4 = {
  name: "PhArrowBendDoubleUpRight"
}, IF1 = /* @__PURE__ */ $({
  ...q4,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", x4, [
        e("polyline", {
          points: "176 152 224 104 176 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, j4),
        e("polyline", {
          points: "120 152 168 104 120 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, m4),
        e("path", {
          d: "M32,200a96,96,0,0,1,96-96h40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, M4)
      ])) : o(i) === "duotone" ? (s(), r("g", v4, [
        e("polyline", {
          points: "176 152 224 104 176 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S4),
        e("polyline", {
          points: "128 152 176 104 128 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H4),
        e("path", {
          d: "M32,200a96,96,0,0,1,96-96h48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A4)
      ])) : o(i) === "fill" ? (s(), r("g", V4, Z4)) : o(i) === "light" ? (s(), r("g", C4, [
        e("polyline", {
          points: "176 152 224 104 176 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b4),
        e("polyline", {
          points: "128 152 176 104 128 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, L4),
        e("path", {
          d: "M32,200a96,96,0,0,1,96-96h48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, B4)
      ])) : o(i) === "thin" ? (s(), r("g", P4, [
        e("polyline", {
          points: "176 152 224 104 176 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, W4),
        e("polyline", {
          points: "128 152 176 104 128 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, N4),
        e("path", {
          d: "M32,200a96,96,0,0,1,96-96h48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, F4)
      ])) : o(i) === "regular" ? (s(), r("g", T4, [
        e("polyline", {
          points: "176 152 224 104 176 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D4),
        e("polyline", {
          points: "128 152 176 104 128 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R4),
        e("path", {
          d: "M32,200a96,96,0,0,1,96-96h48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U4)
      ])) : g("", !0)
    ], 16, g4));
  }
}), G4 = ["width", "height", "fill", "transform"], E4 = { key: 0 }, O4 = ["stroke"], I4 = ["stroke"], K4 = { key: 1 }, X4 = ["stroke"], J4 = ["stroke"], Q4 = { key: 2 }, Y4 = /* @__PURE__ */ e("path", { d: "M232,56A104.2,104.2,0,0,1,128,160H88v40a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-48-48a8.1,8.1,0,0,1,0-11.4l48-48a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,88,104v40h40a88.1,88.1,0,0,0,88-88,8,8,0,0,1,16,0Z" }, null, -1), oa = [
  Y4
], ea = { key: 3 }, ta = ["stroke"], na = ["stroke"], sa = { key: 4 }, ra = ["stroke"], ia = ["stroke"], la = { key: 5 }, da = ["stroke"], ka = ["stroke"], ca = {
  name: "PhArrowBendDownLeft"
}, KF1 = /* @__PURE__ */ $({
  ...ca,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", E4, [
        e("polyline", {
          points: "80 104 32 152 80 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, O4),
        e("path", {
          d: "M224,56a96,96,0,0,1-96,96H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, I4)
      ])) : o(i) === "duotone" ? (s(), r("g", K4, [
        e("polyline", {
          points: "80 104 32 152 80 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X4),
        e("path", {
          d: "M224,56a96,96,0,0,1-96,96H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J4)
      ])) : o(i) === "fill" ? (s(), r("g", Q4, oa)) : o(i) === "light" ? (s(), r("g", ea, [
        e("polyline", {
          points: "80 104 32 152 80 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ta),
        e("path", {
          d: "M224,56a96,96,0,0,1-96,96H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, na)
      ])) : o(i) === "thin" ? (s(), r("g", sa, [
        e("polyline", {
          points: "80 104 32 152 80 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ra),
        e("path", {
          d: "M224,56a96,96,0,0,1-96,96H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ia)
      ])) : o(i) === "regular" ? (s(), r("g", la, [
        e("polyline", {
          points: "80 104 32 152 80 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, da),
        e("path", {
          d: "M224,56a96,96,0,0,1-96,96H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ka)
      ])) : g("", !0)
    ], 16, G4));
  }
}), ha = ["width", "height", "fill", "transform"], ua = { key: 0 }, aa = ["stroke"], _a = ["stroke"], pa = { key: 1 }, ya = ["stroke"], $a = ["stroke"], wa = { key: 2 }, fa = /* @__PURE__ */ e("path", { d: "M229.7,157.7l-48,48A8.3,8.3,0,0,1,176,208a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,168,200V160H128A104.2,104.2,0,0,1,24,56a8,8,0,0,1,16,0,88.1,88.1,0,0,0,88,88h40V104a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l48,48A8.1,8.1,0,0,1,229.7,157.7Z" }, null, -1), ga = [
  fa
], xa = { key: 3 }, ja = ["stroke"], ma = ["stroke"], Ma = { key: 4 }, va = ["stroke"], Sa = ["stroke"], Ha = { key: 5 }, Aa = ["stroke"], Va = ["stroke"], za = {
  name: "PhArrowBendDownRight"
}, XF1 = /* @__PURE__ */ $({
  ...za,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ua, [
        e("polyline", {
          points: "176 104 224 152 176 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aa),
        e("path", {
          d: "M32,56a96,96,0,0,0,96,96h96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _a)
      ])) : o(i) === "duotone" ? (s(), r("g", pa, [
        e("polyline", {
          points: "176 104 224 152 176 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ya),
        e("path", {
          d: "M32,56a96,96,0,0,0,96,96h96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $a)
      ])) : o(i) === "fill" ? (s(), r("g", wa, ga)) : o(i) === "light" ? (s(), r("g", xa, [
        e("polyline", {
          points: "176 104 224 152 176 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ja),
        e("path", {
          d: "M32,56a96,96,0,0,0,96,96h96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ma)
      ])) : o(i) === "thin" ? (s(), r("g", Ma, [
        e("polyline", {
          points: "176 104 224 152 176 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, va),
        e("path", {
          d: "M32,56a96,96,0,0,0,96,96h96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Sa)
      ])) : o(i) === "regular" ? (s(), r("g", Ha, [
        e("polyline", {
          points: "176 104 224 152 176 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Aa),
        e("path", {
          d: "M32,56a96,96,0,0,0,96,96h96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Va)
      ])) : g("", !0)
    ], 16, ha));
  }
}), Za = ["width", "height", "fill", "transform"], Ca = { key: 0 }, ba = ["stroke"], La = ["stroke"], Ba = { key: 1 }, Pa = ["stroke"], Wa = ["stroke"], Na = { key: 2 }, Fa = /* @__PURE__ */ e("path", { d: "M208,32a8,8,0,0,1-8,8,88.1,88.1,0,0,0-88,88v40h40a8,8,0,0,1,7.4,4.9,8.4,8.4,0,0,1-1.7,8.8l-48,48a8.2,8.2,0,0,1-11.4,0l-48-48a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,56,168H96V128A104.2,104.2,0,0,1,200,24,8,8,0,0,1,208,32Z" }, null, -1), Ta = [
  Fa
], Da = { key: 3 }, Ra = ["stroke"], Ua = ["stroke"], qa = { key: 4 }, Ga = ["stroke"], Ea = ["stroke"], Oa = { key: 5 }, Ia = ["stroke"], Ka = ["stroke"], Xa = {
  name: "PhArrowBendLeftDown"
}, JF1 = /* @__PURE__ */ $({
  ...Xa,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ca, [
        e("polyline", {
          points: "152 176 104 224 56 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ba),
        e("path", {
          d: "M200,32a96,96,0,0,0-96,96v96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, La)
      ])) : o(i) === "duotone" ? (s(), r("g", Ba, [
        e("polyline", {
          points: "152 176 104 224 56 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pa),
        e("path", {
          d: "M200,32a96,96,0,0,0-96,96v96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wa)
      ])) : o(i) === "fill" ? (s(), r("g", Na, Ta)) : o(i) === "light" ? (s(), r("g", Da, [
        e("polyline", {
          points: "152 176 104 224 56 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ra),
        e("path", {
          d: "M200,32a96,96,0,0,0-96,96v96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ua)
      ])) : o(i) === "thin" ? (s(), r("g", qa, [
        e("polyline", {
          points: "152 176 104 224 56 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ga),
        e("path", {
          d: "M200,32a96,96,0,0,0-96,96v96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ea)
      ])) : o(i) === "regular" ? (s(), r("g", Oa, [
        e("polyline", {
          points: "152 176 104 224 56 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ia),
        e("path", {
          d: "M200,32a96,96,0,0,0-96,96v96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ka)
      ])) : g("", !0)
    ], 16, Za));
  }
}), Ja = ["width", "height", "fill", "transform"], Qa = { key: 0 }, Ya = ["stroke"], o_ = ["stroke"], e_ = { key: 1 }, t_ = ["stroke"], n_ = ["stroke"], s_ = { key: 2 }, r_ = /* @__PURE__ */ e("path", { d: "M208,224a8,8,0,0,1-8,8A104.2,104.2,0,0,1,96,128V88H56a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l48-48a8.1,8.1,0,0,1,11.4,0l48,48a8.4,8.4,0,0,1,1.7,8.8A8,8,0,0,1,152,88H112v40a88.1,88.1,0,0,0,88,88A8,8,0,0,1,208,224Z" }, null, -1), i_ = [
  r_
], l_ = { key: 3 }, d_ = ["stroke"], k_ = ["stroke"], c_ = { key: 4 }, h_ = ["stroke"], u_ = ["stroke"], a_ = { key: 5 }, __ = ["stroke"], p_ = ["stroke"], y_ = {
  name: "PhArrowBendLeftUp"
}, QF1 = /* @__PURE__ */ $({
  ...y_,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Qa, [
        e("polyline", {
          points: "152 80 104 32 56 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ya),
        e("path", {
          d: "M200,224a96,96,0,0,1-96-96V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, o_)
      ])) : o(i) === "duotone" ? (s(), r("g", e_, [
        e("polyline", {
          points: "152 80 104 32 56 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t_),
        e("path", {
          d: "M200,224a96,96,0,0,1-96-96V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n_)
      ])) : o(i) === "fill" ? (s(), r("g", s_, i_)) : o(i) === "light" ? (s(), r("g", l_, [
        e("polyline", {
          points: "152 80 104 32 56 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, d_),
        e("path", {
          d: "M200,224a96,96,0,0,1-96-96V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, k_)
      ])) : o(i) === "thin" ? (s(), r("g", c_, [
        e("polyline", {
          points: "152 80 104 32 56 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, h_),
        e("path", {
          d: "M200,224a96,96,0,0,1-96-96V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, u_)
      ])) : o(i) === "regular" ? (s(), r("g", a_, [
        e("polyline", {
          points: "152 80 104 32 56 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, __),
        e("path", {
          d: "M200,224a96,96,0,0,1-96-96V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p_)
      ])) : g("", !0)
    ], 16, Ja));
  }
}), $_ = ["width", "height", "fill", "transform"], w_ = { key: 0 }, f_ = ["stroke"], g_ = ["stroke"], x_ = { key: 1 }, j_ = ["stroke"], m_ = ["stroke"], M_ = { key: 2 }, v_ = /* @__PURE__ */ e("path", { d: "M205.7,181.7l-48,48a8.2,8.2,0,0,1-11.4,0l-48-48a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,104,168h40V128A88.1,88.1,0,0,0,56,40a8,8,0,0,1,0-16A104.2,104.2,0,0,1,160,128v40h40a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,205.7,181.7Z" }, null, -1), S_ = [
  v_
], H_ = { key: 3 }, A_ = ["stroke"], V_ = ["stroke"], z_ = { key: 4 }, Z_ = ["stroke"], C_ = ["stroke"], b_ = { key: 5 }, L_ = ["stroke"], B_ = ["stroke"], P_ = {
  name: "PhArrowBendRightDown"
}, YF1 = /* @__PURE__ */ $({
  ...P_,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", w_, [
        e("polyline", {
          points: "104 176 152 224 200 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f_),
        e("path", {
          d: "M56,32a96,96,0,0,1,96,96v96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g_)
      ])) : o(i) === "duotone" ? (s(), r("g", x_, [
        e("polyline", {
          points: "104 176 152 224 200 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j_),
        e("path", {
          d: "M56,32a96,96,0,0,1,96,96v96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m_)
      ])) : o(i) === "fill" ? (s(), r("g", M_, S_)) : o(i) === "light" ? (s(), r("g", H_, [
        e("polyline", {
          points: "104 176 152 224 200 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, A_),
        e("path", {
          d: "M56,32a96,96,0,0,1,96,96v96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, V_)
      ])) : o(i) === "thin" ? (s(), r("g", z_, [
        e("polyline", {
          points: "104 176 152 224 200 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Z_),
        e("path", {
          d: "M56,32a96,96,0,0,1,96,96v96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, C_)
      ])) : o(i) === "regular" ? (s(), r("g", b_, [
        e("polyline", {
          points: "104 176 152 224 200 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L_),
        e("path", {
          d: "M56,32a96,96,0,0,1,96,96v96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B_)
      ])) : g("", !0)
    ], 16, $_));
  }
}), W_ = ["width", "height", "fill", "transform"], N_ = { key: 0 }, F_ = ["stroke"], T_ = ["stroke"], D_ = { key: 1 }, R_ = ["stroke"], U_ = ["stroke"], q_ = { key: 2 }, G_ = /* @__PURE__ */ e("path", { d: "M207.4,83.1A8,8,0,0,1,200,88H160v40A104.2,104.2,0,0,1,56,232a8,8,0,0,1,0-16,88.1,88.1,0,0,0,88-88V88H104a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l48-48a8.1,8.1,0,0,1,11.4,0l48,48A8.4,8.4,0,0,1,207.4,83.1Z" }, null, -1), E_ = [
  G_
], O_ = { key: 3 }, I_ = ["stroke"], K_ = ["stroke"], X_ = { key: 4 }, J_ = ["stroke"], Q_ = ["stroke"], Y_ = { key: 5 }, op = ["stroke"], ep = ["stroke"], tp = {
  name: "PhArrowBendRightUp"
}, oT1 = /* @__PURE__ */ $({
  ...tp,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", N_, [
        e("polyline", {
          points: "104 80 152 32 200 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, F_),
        e("path", {
          d: "M56,224a96,96,0,0,0,96-96V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, T_)
      ])) : o(i) === "duotone" ? (s(), r("g", D_, [
        e("polyline", {
          points: "104 80 152 32 200 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R_),
        e("path", {
          d: "M56,224a96,96,0,0,0,96-96V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U_)
      ])) : o(i) === "fill" ? (s(), r("g", q_, E_)) : o(i) === "light" ? (s(), r("g", O_, [
        e("polyline", {
          points: "104 80 152 32 200 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, I_),
        e("path", {
          d: "M56,224a96,96,0,0,0,96-96V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, K_)
      ])) : o(i) === "thin" ? (s(), r("g", X_, [
        e("polyline", {
          points: "104 80 152 32 200 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, J_),
        e("path", {
          d: "M56,224a96,96,0,0,0,96-96V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Q_)
      ])) : o(i) === "regular" ? (s(), r("g", Y_, [
        e("polyline", {
          points: "104 80 152 32 200 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, op),
        e("path", {
          d: "M56,224a96,96,0,0,0,96-96V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ep)
      ])) : g("", !0)
    ], 16, W_));
  }
}), np = ["width", "height", "fill", "transform"], sp = { key: 0 }, rp = ["stroke"], ip = ["stroke"], lp = { key: 1 }, dp = ["stroke"], kp = ["stroke"], cp = { key: 2 }, hp = /* @__PURE__ */ e("path", { d: "M232,200a8,8,0,0,1-16,0,88.1,88.1,0,0,0-88-88H88v40a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-48-48a8.1,8.1,0,0,1,0-11.4l48-48a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,88,56V96h40A104.2,104.2,0,0,1,232,200Z" }, null, -1), up = [
  hp
], ap = { key: 3 }, _p = ["stroke"], pp = ["stroke"], yp = { key: 4 }, $p = ["stroke"], wp = ["stroke"], fp = { key: 5 }, gp = ["stroke"], xp = ["stroke"], jp = {
  name: "PhArrowBendUpLeft"
}, eT1 = /* @__PURE__ */ $({
  ...jp,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", sp, [
        e("polyline", {
          points: "80 152 32 104 80 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rp),
        e("path", {
          d: "M224,200a96,96,0,0,0-96-96H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ip)
      ])) : o(i) === "duotone" ? (s(), r("g", lp, [
        e("polyline", {
          points: "80 152 32 104 80 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dp),
        e("path", {
          d: "M224,200a96,96,0,0,0-96-96H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kp)
      ])) : o(i) === "fill" ? (s(), r("g", cp, up)) : o(i) === "light" ? (s(), r("g", ap, [
        e("polyline", {
          points: "80 152 32 104 80 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _p),
        e("path", {
          d: "M224,200a96,96,0,0,0-96-96H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pp)
      ])) : o(i) === "thin" ? (s(), r("g", yp, [
        e("polyline", {
          points: "80 152 32 104 80 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $p),
        e("path", {
          d: "M224,200a96,96,0,0,0-96-96H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wp)
      ])) : o(i) === "regular" ? (s(), r("g", fp, [
        e("polyline", {
          points: "80 152 32 104 80 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gp),
        e("path", {
          d: "M224,200a96,96,0,0,0-96-96H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xp)
      ])) : g("", !0)
    ], 16, np));
  }
}), mp = ["width", "height", "fill", "transform"], Mp = { key: 0 }, vp = ["stroke"], Sp = ["stroke"], Hp = { key: 1 }, Ap = ["stroke"], Vp = ["stroke"], zp = { key: 2 }, Zp = /* @__PURE__ */ e("path", { d: "M229.7,109.7l-48,48A8.3,8.3,0,0,1,176,160a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,168,152V112H128a88.1,88.1,0,0,0-88,88,8,8,0,0,1-16,0A104.2,104.2,0,0,1,128,96h40V56a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l48,48A8.1,8.1,0,0,1,229.7,109.7Z" }, null, -1), Cp = [
  Zp
], bp = { key: 3 }, Lp = ["stroke"], Bp = ["stroke"], Pp = { key: 4 }, Wp = ["stroke"], Np = ["stroke"], Fp = { key: 5 }, Tp = ["stroke"], Dp = ["stroke"], Rp = {
  name: "PhArrowBendUpRight"
}, tT1 = /* @__PURE__ */ $({
  ...Rp,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Mp, [
        e("polyline", {
          points: "176 152 224 104 176 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vp),
        e("path", {
          d: "M32,200a96,96,0,0,1,96-96h96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Sp)
      ])) : o(i) === "duotone" ? (s(), r("g", Hp, [
        e("polyline", {
          points: "176 152 224 104 176 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ap),
        e("path", {
          d: "M32,200a96,96,0,0,1,96-96h96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vp)
      ])) : o(i) === "fill" ? (s(), r("g", zp, Cp)) : o(i) === "light" ? (s(), r("g", bp, [
        e("polyline", {
          points: "176 152 224 104 176 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lp),
        e("path", {
          d: "M32,200a96,96,0,0,1,96-96h96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bp)
      ])) : o(i) === "thin" ? (s(), r("g", Pp, [
        e("polyline", {
          points: "176 152 224 104 176 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wp),
        e("path", {
          d: "M32,200a96,96,0,0,1,96-96h96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Np)
      ])) : o(i) === "regular" ? (s(), r("g", Fp, [
        e("polyline", {
          points: "176 152 224 104 176 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tp),
        e("path", {
          d: "M32,200a96,96,0,0,1,96-96h96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dp)
      ])) : g("", !0)
    ], 16, mp));
  }
}), Up = ["width", "height", "fill", "transform"], qp = { key: 0 }, Gp = ["stroke"], Ep = ["stroke"], Op = ["stroke"], Ip = { key: 1 }, Kp = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), Xp = ["stroke"], Jp = ["stroke"], Qp = ["stroke"], Yp = { key: 2 }, o3 = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm39.6,115.7-33.9,34a8.2,8.2,0,0,1-11.4,0l-33.9-34a8,8,0,0,1,11.3-11.3L120,148.7V88a8,8,0,0,1,16,0v60.7l20.3-20.3a8,8,0,0,1,11.3,11.3Z" }, null, -1), e3 = [
  o3
], t3 = { key: 3 }, n3 = ["stroke"], s3 = ["stroke"], r3 = ["stroke"], i3 = { key: 4 }, l3 = ["stroke"], d3 = ["stroke"], k3 = ["stroke"], c3 = { key: 5 }, h3 = ["stroke"], u3 = ["stroke"], a3 = ["stroke"], _3 = {
  name: "PhArrowCircleDown"
}, nT1 = /* @__PURE__ */ $({
  ..._3,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", qp, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gp),
        e("polyline", {
          points: "94.1 134.1 128 168 161.9 134.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ep),
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Op)
      ])) : o(i) === "duotone" ? (s(), r("g", Ip, [
        Kp,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Xp),
        e("polyline", {
          points: "94.1 134.1 128 168 161.9 134.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jp),
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qp)
      ])) : o(i) === "fill" ? (s(), r("g", Yp, e3)) : o(i) === "light" ? (s(), r("g", t3, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, n3),
        e("polyline", {
          points: "94.1 134.1 128 168 161.9 134.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, s3),
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, r3)
      ])) : o(i) === "thin" ? (s(), r("g", i3, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, l3),
        e("polyline", {
          points: "94.1 134.1 128 168 161.9 134.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, d3),
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, k3)
      ])) : o(i) === "regular" ? (s(), r("g", c3, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, h3),
        e("polyline", {
          points: "94.1 134.1 128 168 161.9 134.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u3),
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a3)
      ])) : g("", !0)
    ], 16, Up));
  }
}), p3 = ["width", "height", "fill", "transform"], y3 = { key: 0 }, $3 = ["stroke"], w3 = ["stroke"], f3 = ["stroke"], g3 = { key: 1 }, x3 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), j3 = ["stroke"], m3 = ["stroke"], M3 = ["stroke"], v3 = { key: 2 }, S3 = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm33.7,81.7L119.3,148H148a8,8,0,0,1,0,16H100a8.5,8.5,0,0,1-3.1-.6,8.2,8.2,0,0,1-4.3-4.3A8.5,8.5,0,0,1,92,156V108a8,8,0,0,1,16,0v28.7l42.3-42.4a8.1,8.1,0,0,1,11.4,11.4Z" }, null, -1), H3 = [
  S3
], A3 = { key: 3 }, V3 = ["stroke"], z3 = ["stroke"], Z3 = ["stroke"], C3 = { key: 4 }, b3 = ["stroke"], L3 = ["stroke"], B3 = ["stroke"], P3 = { key: 5 }, W3 = ["stroke"], N3 = ["stroke"], F3 = ["stroke"], T3 = {
  name: "PhArrowCircleDownLeft"
}, sT1 = /* @__PURE__ */ $({
  ...T3,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", y3, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $3),
        e("polyline", {
          points: "100 108 100 156 148 156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, w3),
        e("line", {
          x1: "156",
          y1: "100",
          x2: "100",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f3)
      ])) : o(i) === "duotone" ? (s(), r("g", g3, [
        x3,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, j3),
        e("polyline", {
          points: "100 108 100 156 148 156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m3),
        e("line", {
          x1: "156",
          y1: "100",
          x2: "100",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M3)
      ])) : o(i) === "fill" ? (s(), r("g", v3, H3)) : o(i) === "light" ? (s(), r("g", A3, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, V3),
        e("polyline", {
          points: "100 108 100 156 148 156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, z3),
        e("line", {
          x1: "156",
          y1: "100",
          x2: "100",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Z3)
      ])) : o(i) === "thin" ? (s(), r("g", C3, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, b3),
        e("polyline", {
          points: "100 108 100 156 148 156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, L3),
        e("line", {
          x1: "156",
          y1: "100",
          x2: "100",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, B3)
      ])) : o(i) === "regular" ? (s(), r("g", P3, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, W3),
        e("polyline", {
          points: "100 108 100 156 148 156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N3),
        e("line", {
          x1: "156",
          y1: "100",
          x2: "100",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F3)
      ])) : g("", !0)
    ], 16, p3));
  }
}), D3 = ["width", "height", "fill", "transform"], R3 = { key: 0 }, U3 = ["stroke"], q3 = ["stroke"], G3 = ["stroke"], E3 = { key: 1 }, O3 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), I3 = ["stroke"], K3 = ["stroke"], X3 = ["stroke"], J3 = { key: 2 }, Q3 = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm36,132a8.5,8.5,0,0,1-.6,3.1,8.2,8.2,0,0,1-4.3,4.3,8.5,8.5,0,0,1-3.1.6H108a8,8,0,0,1,0-16h28.7L94.3,105.7a8.1,8.1,0,0,1,11.4-11.4L148,136.7V108a8,8,0,0,1,16,0Z" }, null, -1), Y3 = [
  Q3
], oy = { key: 3 }, ey = ["stroke"], ty = ["stroke"], ny = ["stroke"], sy = { key: 4 }, ry = ["stroke"], iy = ["stroke"], ly = ["stroke"], dy = { key: 5 }, ky = ["stroke"], cy = ["stroke"], hy = ["stroke"], uy = {
  name: "PhArrowCircleDownRight"
}, rT1 = /* @__PURE__ */ $({
  ...uy,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", R3, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, U3),
        e("polyline", {
          points: "108 156 156 156 156 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, q3),
        e("line", {
          x1: "100",
          y1: "100",
          x2: "156",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, G3)
      ])) : o(i) === "duotone" ? (s(), r("g", E3, [
        O3,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, I3),
        e("polyline", {
          points: "108 156 156 156 156 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K3),
        e("line", {
          x1: "100",
          y1: "100",
          x2: "156",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X3)
      ])) : o(i) === "fill" ? (s(), r("g", J3, Y3)) : o(i) === "light" ? (s(), r("g", oy, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ey),
        e("polyline", {
          points: "108 156 156 156 156 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ty),
        e("line", {
          x1: "100",
          y1: "100",
          x2: "156",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ny)
      ])) : o(i) === "thin" ? (s(), r("g", sy, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ry),
        e("polyline", {
          points: "108 156 156 156 156 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iy),
        e("line", {
          x1: "100",
          y1: "100",
          x2: "156",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ly)
      ])) : o(i) === "regular" ? (s(), r("g", dy, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, ky),
        e("polyline", {
          points: "108 156 156 156 156 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cy),
        e("line", {
          x1: "100",
          y1: "100",
          x2: "156",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hy)
      ])) : g("", !0)
    ], 16, D3));
  }
}), ay = ["width", "height", "fill", "transform"], _y = { key: 0 }, py = ["stroke"], yy = ["stroke"], $y = ["stroke"], wy = { key: 1 }, fy = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), gy = ["stroke"], xy = ["stroke"], jy = ["stroke"], my = { key: 2 }, My = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm40,112H107.3l20.3,20.3a8,8,0,0,1,0,11.3,7.8,7.8,0,0,1-5.7,2.3,7.6,7.6,0,0,1-5.6-2.3L82.4,133.7a8.7,8.7,0,0,1-1.8-2.6,8.3,8.3,0,0,1,0-6.2,8.7,8.7,0,0,1,1.8-2.6l33.9-33.9a8,8,0,0,1,11.3,11.3L107.3,120H168a8,8,0,0,1,0,16Z" }, null, -1), vy = [
  My
], Sy = { key: 3 }, Hy = ["stroke"], Ay = ["stroke"], Vy = ["stroke"], zy = { key: 4 }, Zy = ["stroke"], Cy = ["stroke"], by = ["stroke"], Ly = { key: 5 }, By = ["stroke"], Py = ["stroke"], Wy = ["stroke"], Ny = {
  name: "PhArrowCircleLeft"
}, iT1 = /* @__PURE__ */ $({
  ...Ny,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", _y, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, py),
        e("polyline", {
          points: "121.9 161.9 88 128 121.9 94.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yy),
        e("line", {
          x1: "168",
          y1: "128",
          x2: "88",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $y)
      ])) : o(i) === "duotone" ? (s(), r("g", wy, [
        fy,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, gy),
        e("polyline", {
          points: "121.9 161.9 88 128 121.9 94.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xy),
        e("line", {
          x1: "168",
          y1: "128",
          x2: "88",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jy)
      ])) : o(i) === "fill" ? (s(), r("g", my, vy)) : o(i) === "light" ? (s(), r("g", Sy, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hy),
        e("polyline", {
          points: "121.9 161.9 88 128 121.9 94.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ay),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vy)
      ])) : o(i) === "thin" ? (s(), r("g", zy, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zy),
        e("polyline", {
          points: "121.9 161.9 88 128 121.9 94.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cy),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, by)
      ])) : o(i) === "regular" ? (s(), r("g", Ly, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, By),
        e("polyline", {
          points: "121.9 161.9 88 128 121.9 94.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Py),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wy)
      ])) : g("", !0)
    ], 16, ay));
  }
}), Fy = ["width", "height", "fill", "transform"], Ty = { key: 0 }, Dy = ["stroke"], Ry = ["stroke"], Uy = ["stroke"], qy = { key: 1 }, Gy = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), Ey = ["stroke"], Oy = ["stroke"], Iy = ["stroke"], Ky = { key: 2 }, Xy = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm47.4,107.1a8.7,8.7,0,0,1-1.8,2.6l-33.9,33.9a7.6,7.6,0,0,1-5.6,2.3,7.8,7.8,0,0,1-5.7-2.3,8,8,0,0,1,0-11.3L148.7,136H88a8,8,0,0,1,0-16h60.7L128.4,99.7a8,8,0,0,1,11.3-11.3l33.9,33.9a8.7,8.7,0,0,1,1.8,2.6A8.3,8.3,0,0,1,175.4,131.1Z" }, null, -1), Jy = [
  Xy
], Qy = { key: 3 }, Yy = ["stroke"], o5 = ["stroke"], e5 = ["stroke"], t5 = { key: 4 }, n5 = ["stroke"], s5 = ["stroke"], r5 = ["stroke"], i5 = { key: 5 }, l5 = ["stroke"], d5 = ["stroke"], k5 = ["stroke"], c5 = {
  name: "PhArrowCircleRight"
}, lT1 = /* @__PURE__ */ $({
  ...c5,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ty, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Dy),
        e("polyline", {
          points: "134.1 161.9 168 128 134.1 94.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ry),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Uy)
      ])) : o(i) === "duotone" ? (s(), r("g", qy, [
        Gy,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Ey),
        e("polyline", {
          points: "134.1 161.9 168 128 134.1 94.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Oy),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Iy)
      ])) : o(i) === "fill" ? (s(), r("g", Ky, Jy)) : o(i) === "light" ? (s(), r("g", Qy, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Yy),
        e("polyline", {
          points: "134.1 161.9 168 128 134.1 94.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, o5),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, e5)
      ])) : o(i) === "thin" ? (s(), r("g", t5, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, n5),
        e("polyline", {
          points: "134.1 161.9 168 128 134.1 94.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, s5),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, r5)
      ])) : o(i) === "regular" ? (s(), r("g", i5, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, l5),
        e("polyline", {
          points: "134.1 161.9 168 128 134.1 94.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, d5),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k5)
      ])) : g("", !0)
    ], 16, Fy));
  }
}), h5 = ["width", "height", "fill", "transform"], u5 = { key: 0 }, a5 = ["stroke"], _5 = ["stroke"], p5 = ["stroke"], y5 = { key: 1 }, $5 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), w5 = ["stroke"], f5 = ["stroke"], g5 = ["stroke"], x5 = { key: 2 }, j5 = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm39.6,103.6a7.8,7.8,0,0,1-5.7,2.3,7.6,7.6,0,0,1-5.6-2.3L136,107.3V168a8,8,0,0,1-16,0V107.3L99.7,127.6a8,8,0,0,1-11.3-11.3l33.9-33.9a8.7,8.7,0,0,1,2.6-1.8,8.3,8.3,0,0,1,6.2,0,8.7,8.7,0,0,1,2.6,1.8l33.9,33.9A8,8,0,0,1,167.6,127.6Z" }, null, -1), m5 = [
  j5
], M5 = { key: 3 }, v5 = ["stroke"], S5 = ["stroke"], H5 = ["stroke"], A5 = { key: 4 }, V5 = ["stroke"], z5 = ["stroke"], Z5 = ["stroke"], C5 = { key: 5 }, b5 = ["stroke"], L5 = ["stroke"], B5 = ["stroke"], P5 = {
  name: "PhArrowCircleUp"
}, dT1 = /* @__PURE__ */ $({
  ...P5,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", u5, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, a5),
        e("polyline", {
          points: "94.1 121.9 128 88 161.9 121.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _5),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, p5)
      ])) : o(i) === "duotone" ? (s(), r("g", y5, [
        $5,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, w5),
        e("polyline", {
          points: "94.1 121.9 128 88 161.9 121.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f5),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g5)
      ])) : o(i) === "fill" ? (s(), r("g", x5, m5)) : o(i) === "light" ? (s(), r("g", M5, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, v5),
        e("polyline", {
          points: "94.1 121.9 128 88 161.9 121.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, S5),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, H5)
      ])) : o(i) === "thin" ? (s(), r("g", A5, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, V5),
        e("polyline", {
          points: "94.1 121.9 128 88 161.9 121.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, z5),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Z5)
      ])) : o(i) === "regular" ? (s(), r("g", C5, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, b5),
        e("polyline", {
          points: "94.1 121.9 128 88 161.9 121.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L5),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B5)
      ])) : g("", !0)
    ], 16, h5));
  }
}), W5 = ["width", "height", "fill", "transform"], N5 = { key: 0 }, F5 = ["stroke"], T5 = ["stroke"], D5 = ["stroke"], R5 = { key: 1 }, U5 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), q5 = ["stroke"], G5 = ["stroke"], E5 = ["stroke"], O5 = { key: 2 }, I5 = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm33.7,137.7a8.2,8.2,0,0,1-11.4,0L108,119.3V148a8,8,0,0,1-16,0V100a8.5,8.5,0,0,1,.6-3.1,8.2,8.2,0,0,1,4.3-4.3A8.5,8.5,0,0,1,100,92h48a8,8,0,0,1,0,16H119.3l42.4,42.3A8.1,8.1,0,0,1,161.7,161.7Z" }, null, -1), K5 = [
  I5
], X5 = { key: 3 }, J5 = ["stroke"], Q5 = ["stroke"], Y5 = ["stroke"], o7 = { key: 4 }, e7 = ["stroke"], t7 = ["stroke"], n7 = ["stroke"], s7 = { key: 5 }, r7 = ["stroke"], i7 = ["stroke"], l7 = ["stroke"], d7 = {
  name: "PhArrowCircleUpLeft"
}, kT1 = /* @__PURE__ */ $({
  ...d7,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", N5, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, F5),
        e("polyline", {
          points: "148 100 100 100 100 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, T5),
        e("line", {
          x1: "156",
          y1: "156",
          x2: "100",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, D5)
      ])) : o(i) === "duotone" ? (s(), r("g", R5, [
        U5,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, q5),
        e("polyline", {
          points: "148 100 100 100 100 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G5),
        e("line", {
          x1: "156",
          y1: "156",
          x2: "100",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E5)
      ])) : o(i) === "fill" ? (s(), r("g", O5, K5)) : o(i) === "light" ? (s(), r("g", X5, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, J5),
        e("polyline", {
          points: "148 100 100 100 100 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Q5),
        e("line", {
          x1: "156",
          y1: "156",
          x2: "100",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Y5)
      ])) : o(i) === "thin" ? (s(), r("g", o7, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, e7),
        e("polyline", {
          points: "148 100 100 100 100 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, t7),
        e("line", {
          x1: "156",
          y1: "156",
          x2: "100",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, n7)
      ])) : o(i) === "regular" ? (s(), r("g", s7, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, r7),
        e("polyline", {
          points: "148 100 100 100 100 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, i7),
        e("line", {
          x1: "156",
          y1: "156",
          x2: "100",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l7)
      ])) : g("", !0)
    ], 16, W5));
  }
}), k7 = ["width", "height", "fill", "transform"], c7 = { key: 0 }, h7 = ["stroke"], u7 = ["stroke"], a7 = ["stroke"], _7 = { key: 1 }, p7 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), y7 = ["stroke"], $7 = ["stroke"], w7 = ["stroke"], f7 = { key: 2 }, g7 = /* @__PURE__ */ e("path", { d: "M201.5,54.5a104,104,0,1,0,0,147A103.9,103.9,0,0,0,201.5,54.5ZM164,148a8,8,0,0,1-16,0V119.3l-42.3,42.4A8.5,8.5,0,0,1,100,164a8.3,8.3,0,0,1-5.7-2.3,8.1,8.1,0,0,1,0-11.4L136.7,108H108a8,8,0,0,1,0-16h48a7.7,7.7,0,0,1,3,.6,8.1,8.1,0,0,1,4.4,4.3,8.5,8.5,0,0,1,.6,3.1Z" }, null, -1), x7 = [
  g7
], j7 = { key: 3 }, m7 = ["stroke"], M7 = ["stroke"], v7 = ["stroke"], S7 = { key: 4 }, H7 = ["stroke"], A7 = ["stroke"], V7 = ["stroke"], z7 = { key: 5 }, Z7 = ["stroke"], C7 = ["stroke"], b7 = ["stroke"], L7 = {
  name: "PhArrowCircleUpRight"
}, cT1 = /* @__PURE__ */ $({
  ...L7,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", c7, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, h7),
        e("polyline", {
          points: "108 100 156 100 156 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, u7),
        e("line", {
          x1: "100",
          y1: "156",
          x2: "156",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, a7)
      ])) : o(i) === "duotone" ? (s(), r("g", _7, [
        p7,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, y7),
        e("polyline", {
          points: "108 100 156 100 156 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $7),
        e("line", {
          x1: "100",
          y1: "156",
          x2: "156",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w7)
      ])) : o(i) === "fill" ? (s(), r("g", f7, x7)) : o(i) === "light" ? (s(), r("g", j7, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, m7),
        e("polyline", {
          points: "108 100 156 100 156 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, M7),
        e("line", {
          x1: "100",
          y1: "156",
          x2: "156",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, v7)
      ])) : o(i) === "thin" ? (s(), r("g", S7, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, H7),
        e("polyline", {
          points: "108 100 156 100 156 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, A7),
        e("line", {
          x1: "100",
          y1: "156",
          x2: "156",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, V7)
      ])) : o(i) === "regular" ? (s(), r("g", z7, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Z7),
        e("polyline", {
          points: "108 100 156 100 156 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C7),
        e("line", {
          x1: "100",
          y1: "156",
          x2: "156",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b7)
      ])) : g("", !0)
    ], 16, k7));
  }
}), B7 = ["width", "height", "fill", "transform"], P7 = { key: 0 }, W7 = ["stroke"], N7 = ["stroke"], F7 = { key: 1 }, T7 = ["stroke"], D7 = ["stroke"], R7 = { key: 2 }, U7 = /* @__PURE__ */ e("path", { d: "M232.2,51.7v48a8,8,0,0,1-8,8h-48a8,8,0,0,1-5.7-13.6l18.4-18.4-4.3-4.3a80,80,0,1,0,0,113.2,7.9,7.9,0,0,1,11.3,0,8,8,0,0,1,0,11.3,96,96,0,1,1,0-135.8l4.3,4.3,18.3-18.3a8,8,0,0,1,8.7-1.8A8.2,8.2,0,0,1,232.2,51.7Z" }, null, -1), q7 = [
  U7
], G7 = { key: 3 }, E7 = ["stroke"], O7 = ["stroke"], I7 = { key: 4 }, K7 = ["stroke"], X7 = ["stroke"], J7 = { key: 5 }, Q7 = ["stroke"], Y7 = ["stroke"], o9 = {
  name: "PhArrowClockwise"
}, hT1 = /* @__PURE__ */ $({
  ...o9,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", P7, [
        e("polyline", {
          points: "176.2 99.7 224.2 99.7 224.2 51.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, W7),
        e("path", {
          d: "M190.2,190.2a88,88,0,1,1,0-124.4l34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, N7)
      ])) : o(i) === "duotone" ? (s(), r("g", F7, [
        e("polyline", {
          points: "176.2 99.7 224.2 99.7 224.2 51.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T7),
        e("path", {
          d: "M190.2,190.2a88,88,0,1,1,0-124.4l34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D7)
      ])) : o(i) === "fill" ? (s(), r("g", R7, q7)) : o(i) === "light" ? (s(), r("g", G7, [
        e("polyline", {
          points: "176.2 99.7 224.2 99.7 224.2 51.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, E7),
        e("path", {
          d: "M190.2,190.2a88,88,0,1,1,0-124.4l34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, O7)
      ])) : o(i) === "thin" ? (s(), r("g", I7, [
        e("polyline", {
          points: "176.2 99.7 224.2 99.7 224.2 51.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, K7),
        e("path", {
          d: "M190.2,190.2a88,88,0,1,1,0-124.4l34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, X7)
      ])) : o(i) === "regular" ? (s(), r("g", J7, [
        e("polyline", {
          points: "176.2 99.7 224.2 99.7 224.2 51.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q7),
        e("path", {
          d: "M190.2,190.2a88,88,0,1,1,0-124.4l34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y7)
      ])) : g("", !0)
    ], 16, B7));
  }
}), e9 = ["width", "height", "fill", "transform"], t9 = { key: 0 }, n9 = ["stroke"], s9 = ["stroke"], r9 = { key: 1 }, i9 = ["stroke"], l9 = ["stroke"], d9 = { key: 2 }, k9 = /* @__PURE__ */ e("path", { d: "M195.9,195.9a96.1,96.1,0,0,1-135.8,0,8,8,0,0,1,0-11.3,7.9,7.9,0,0,1,11.3,0,80,80,0,1,0,0-113.2l-4.3,4.3L85.5,94.1a8,8,0,0,1-5.7,13.6h-48a8,8,0,0,1-8-8v-48a8.2,8.2,0,0,1,5-7.4,8,8,0,0,1,8.7,1.8L55.8,64.4l4.3-4.3A96,96,0,0,1,195.9,195.9Z" }, null, -1), c9 = [
  k9
], h9 = { key: 3 }, u9 = ["stroke"], a9 = ["stroke"], _9 = { key: 4 }, p9 = ["stroke"], y9 = ["stroke"], $9 = { key: 5 }, w9 = ["stroke"], f9 = ["stroke"], g9 = {
  name: "PhArrowCounterClockwise"
}, uT1 = /* @__PURE__ */ $({
  ...g9,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", t9, [
        e("polyline", {
          points: "79.8 99.7 31.8 99.7 31.8 51.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, n9),
        e("path", {
          d: "M65.8,190.2a88,88,0,1,0,0-124.4l-34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, s9)
      ])) : o(i) === "duotone" ? (s(), r("g", r9, [
        e("polyline", {
          points: "79.8 99.7 31.8 99.7 31.8 51.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, i9),
        e("path", {
          d: "M65.8,190.2a88,88,0,1,0,0-124.4l-34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l9)
      ])) : o(i) === "fill" ? (s(), r("g", d9, c9)) : o(i) === "light" ? (s(), r("g", h9, [
        e("polyline", {
          points: "79.8 99.7 31.8 99.7 31.8 51.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u9),
        e("path", {
          d: "M65.8,190.2a88,88,0,1,0,0-124.4l-34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, a9)
      ])) : o(i) === "thin" ? (s(), r("g", _9, [
        e("polyline", {
          points: "79.8 99.7 31.8 99.7 31.8 51.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, p9),
        e("path", {
          d: "M65.8,190.2a88,88,0,1,0,0-124.4l-34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, y9)
      ])) : o(i) === "regular" ? (s(), r("g", $9, [
        e("polyline", {
          points: "79.8 99.7 31.8 99.7 31.8 51.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w9),
        e("path", {
          d: "M65.8,190.2a88,88,0,1,0,0-124.4l-34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f9)
      ])) : g("", !0)
    ], 16, e9));
  }
}), x9 = ["width", "height", "fill", "transform"], j9 = { key: 0 }, m9 = ["stroke"], M9 = ["stroke"], v9 = { key: 1 }, S9 = ["stroke"], H9 = ["stroke"], A9 = { key: 2 }, V9 = /* @__PURE__ */ e("path", { d: "M205.7,149.7l-72,72a8.2,8.2,0,0,1-11.4,0l-72-72a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,56,136h64V40a8,8,0,0,1,16,0v96h64a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,205.7,149.7Z" }, null, -1), z9 = [
  V9
], Z9 = { key: 3 }, C9 = ["stroke"], b9 = ["stroke"], L9 = { key: 4 }, B9 = ["stroke"], P9 = ["stroke"], W9 = { key: 5 }, N9 = ["stroke"], F9 = ["stroke"], T9 = {
  name: "PhArrowDown"
}, aT1 = /* @__PURE__ */ $({
  ...T9,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", j9, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, m9),
        e("polyline", {
          points: "56 144 128 216 200 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, M9)
      ])) : o(i) === "duotone" ? (s(), r("g", v9, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S9),
        e("polyline", {
          points: "56 144 128 216 200 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H9)
      ])) : o(i) === "fill" ? (s(), r("g", A9, z9)) : o(i) === "light" ? (s(), r("g", Z9, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, C9),
        e("polyline", {
          points: "56 144 128 216 200 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b9)
      ])) : o(i) === "thin" ? (s(), r("g", L9, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, B9),
        e("polyline", {
          points: "56 144 128 216 200 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, P9)
      ])) : o(i) === "regular" ? (s(), r("g", W9, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N9),
        e("polyline", {
          points: "56 144 128 216 200 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F9)
      ])) : g("", !0)
    ], 16, x9));
  }
}), D9 = ["width", "height", "fill", "transform"], R9 = { key: 0 }, U9 = ["stroke"], q9 = ["stroke"], G9 = { key: 1 }, E9 = ["stroke"], O9 = ["stroke"], I9 = { key: 2 }, K9 = /* @__PURE__ */ e("path", { d: "M197.7,69.7,127.3,140l46.4,46.3a8.4,8.4,0,0,1,1.7,8.8A8,8,0,0,1,168,200H64a8,8,0,0,1-8-8V88a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7L116,128.7l70.3-70.4a8.1,8.1,0,0,1,11.4,11.4Z" }, null, -1), X9 = [
  K9
], J9 = { key: 3 }, Q9 = ["stroke"], Y9 = ["stroke"], o$ = { key: 4 }, e$ = ["stroke"], t$ = ["stroke"], n$ = { key: 5 }, s$ = ["stroke"], r$ = ["stroke"], i$ = {
  name: "PhArrowDownLeft"
}, _T1 = /* @__PURE__ */ $({
  ...i$,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", R9, [
        e("line", {
          x1: "192",
          y1: "64",
          x2: "64",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, U9),
        e("polyline", {
          points: "168 192 64 192 64 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, q9)
      ])) : o(i) === "duotone" ? (s(), r("g", G9, [
        e("line", {
          x1: "192",
          y1: "64",
          x2: "64",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E9),
        e("polyline", {
          points: "168 192 64 192 64 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O9)
      ])) : o(i) === "fill" ? (s(), r("g", I9, X9)) : o(i) === "light" ? (s(), r("g", J9, [
        e("line", {
          x1: "192",
          y1: "64",
          x2: "64",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Q9),
        e("polyline", {
          points: "168 192 64 192 64 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Y9)
      ])) : o(i) === "thin" ? (s(), r("g", o$, [
        e("line", {
          x1: "192",
          y1: "64",
          x2: "64",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, e$),
        e("polyline", {
          points: "168 192 64 192 64 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, t$)
      ])) : o(i) === "regular" ? (s(), r("g", n$, [
        e("line", {
          x1: "192",
          y1: "64",
          x2: "64",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s$),
        e("polyline", {
          points: "168 192 64 192 64 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r$)
      ])) : g("", !0)
    ], 16, D9));
  }
}), l$ = ["width", "height", "fill", "transform"], d$ = { key: 0 }, k$ = ["stroke"], c$ = ["stroke"], h$ = { key: 1 }, u$ = ["stroke"], a$ = ["stroke"], _$ = { key: 2 }, p$ = /* @__PURE__ */ e("path", { d: "M200,88V192a8,8,0,0,1-8,8H88a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8L128.7,140,58.3,69.7A8.1,8.1,0,0,1,69.7,58.3L140,128.7l46.3-46.4a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,200,88Z" }, null, -1), y$ = [
  p$
], $$ = { key: 3 }, w$ = ["stroke"], f$ = ["stroke"], g$ = { key: 4 }, x$ = ["stroke"], j$ = ["stroke"], m$ = { key: 5 }, M$ = ["stroke"], v$ = ["stroke"], S$ = {
  name: "PhArrowDownRight"
}, pT1 = /* @__PURE__ */ $({
  ...S$,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", d$, [
        e("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, k$),
        e("polyline", {
          points: "88 192 192 192 192 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, c$)
      ])) : o(i) === "duotone" ? (s(), r("g", h$, [
        e("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u$),
        e("polyline", {
          points: "88 192 192 192 192 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a$)
      ])) : o(i) === "fill" ? (s(), r("g", _$, y$)) : o(i) === "light" ? (s(), r("g", $$, [
        e("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, w$),
        e("polyline", {
          points: "88 192 192 192 192 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, f$)
      ])) : o(i) === "thin" ? (s(), r("g", g$, [
        e("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, x$),
        e("polyline", {
          points: "88 192 192 192 192 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, j$)
      ])) : o(i) === "regular" ? (s(), r("g", m$, [
        e("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M$),
        e("polyline", {
          points: "88 192 192 192 192 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v$)
      ])) : g("", !0)
    ], 16, l$));
  }
}), H$ = ["width", "height", "fill", "transform"], A$ = { key: 0 }, V$ = ["stroke"], z$ = ["stroke"], Z$ = { key: 1 }, C$ = ["stroke"], b$ = ["stroke"], L$ = { key: 2 }, B$ = /* @__PURE__ */ e("path", { d: "M200,32V176a8,8,0,0,1-8,8H104v40a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-48-48a8.1,8.1,0,0,1,0-11.4l48-48a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,104,128v40h80V32a8,8,0,0,1,16,0Z" }, null, -1), P$ = [
  B$
], W$ = { key: 3 }, N$ = ["stroke"], F$ = ["stroke"], T$ = { key: 4 }, D$ = ["stroke"], R$ = ["stroke"], U$ = { key: 5 }, q$ = ["stroke"], G$ = ["stroke"], E$ = {
  name: "PhArrowElbowDownLeft"
}, yT1 = /* @__PURE__ */ $({
  ...E$,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", A$, [
        e("polyline", {
          points: "96 128 48 176 96 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, V$),
        e("polyline", {
          points: "192 32 192 176 48 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, z$)
      ])) : o(i) === "duotone" ? (s(), r("g", Z$, [
        e("polyline", {
          points: "96 128 48 176 96 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C$),
        e("polyline", {
          points: "192 32 192 176 48 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b$)
      ])) : o(i) === "fill" ? (s(), r("g", L$, P$)) : o(i) === "light" ? (s(), r("g", W$, [
        e("polyline", {
          points: "96 128 48 176 96 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, N$),
        e("polyline", {
          points: "192 32 192 176 48 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, F$)
      ])) : o(i) === "thin" ? (s(), r("g", T$, [
        e("polyline", {
          points: "96 128 48 176 96 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, D$),
        e("polyline", {
          points: "192 32 192 176 48 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, R$)
      ])) : o(i) === "regular" ? (s(), r("g", U$, [
        e("polyline", {
          points: "96 128 48 176 96 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q$),
        e("polyline", {
          points: "192 32 192 176 48 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G$)
      ])) : g("", !0)
    ], 16, H$));
  }
}), O$ = ["width", "height", "fill", "transform"], I$ = { key: 0 }, K$ = ["stroke"], X$ = ["stroke"], J$ = { key: 1 }, Q$ = ["stroke"], Y$ = ["stroke"], ow = { key: 2 }, ew = /* @__PURE__ */ e("path", { d: "M213.7,181.7l-48,48A8.3,8.3,0,0,1,160,232a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,152,224V184H64a8,8,0,0,1-8-8V32a8,8,0,0,1,16,0V168h80V128a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l48,48A8.1,8.1,0,0,1,213.7,181.7Z" }, null, -1), tw = [
  ew
], nw = { key: 3 }, sw = ["stroke"], rw = ["stroke"], iw = { key: 4 }, lw = ["stroke"], dw = ["stroke"], kw = { key: 5 }, cw = ["stroke"], hw = ["stroke"], uw = {
  name: "PhArrowElbowDownRight"
}, $T1 = /* @__PURE__ */ $({
  ...uw,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", I$, [
        e("polyline", {
          points: "160 128 208 176 160 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, K$),
        e("polyline", {
          points: "64 32 64 176 208 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X$)
      ])) : o(i) === "duotone" ? (s(), r("g", J$, [
        e("polyline", {
          points: "160 128 208 176 160 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q$),
        e("polyline", {
          points: "64 32 64 176 208 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y$)
      ])) : o(i) === "fill" ? (s(), r("g", ow, tw)) : o(i) === "light" ? (s(), r("g", nw, [
        e("polyline", {
          points: "160 128 208 176 160 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sw),
        e("polyline", {
          points: "64 32 64 176 208 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rw)
      ])) : o(i) === "thin" ? (s(), r("g", iw, [
        e("polyline", {
          points: "160 128 208 176 160 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lw),
        e("polyline", {
          points: "64 32 64 176 208 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dw)
      ])) : o(i) === "regular" ? (s(), r("g", kw, [
        e("polyline", {
          points: "160 128 208 176 160 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cw),
        e("polyline", {
          points: "64 32 64 176 208 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hw)
      ])) : g("", !0)
    ], 16, O$));
  }
}), aw = ["width", "height", "fill", "transform"], _w = { key: 0 }, pw = ["stroke"], yw = ["stroke"], $w = { key: 1 }, ww = ["stroke"], fw = ["stroke"], gw = { key: 2 }, xw = /* @__PURE__ */ e("path", { d: "M237.7,101.7l-96,96a8.2,8.2,0,0,1-11.4,0L60,127.3,29.7,157.7A8.3,8.3,0,0,1,24,160a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,16,152V80a8,8,0,0,1,8-8H96a8,8,0,0,1,7.4,4.9,8.4,8.4,0,0,1-1.7,8.8L71.3,116,136,180.7l90.3-90.4a8.1,8.1,0,0,1,11.4,11.4Z" }, null, -1), jw = [
  xw
], mw = { key: 3 }, Mw = ["stroke"], vw = ["stroke"], Sw = { key: 4 }, Hw = ["stroke"], Aw = ["stroke"], Vw = { key: 5 }, zw = ["stroke"], Zw = ["stroke"], Cw = {
  name: "PhArrowElbowLeft"
}, wT1 = /* @__PURE__ */ $({
  ...Cw,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", _w, [
        e("polyline", {
          points: "96 80 24 80 24 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pw),
        e("polyline", {
          points: "232 96 136 192 24 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yw)
      ])) : o(i) === "duotone" ? (s(), r("g", $w, [
        e("polyline", {
          points: "96 80 24 80 24 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ww),
        e("polyline", {
          points: "232 96 136 192 24 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fw)
      ])) : o(i) === "fill" ? (s(), r("g", gw, jw)) : o(i) === "light" ? (s(), r("g", mw, [
        e("polyline", {
          points: "96 80 24 80 24 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mw),
        e("polyline", {
          points: "232 96 136 192 24 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vw)
      ])) : o(i) === "thin" ? (s(), r("g", Sw, [
        e("polyline", {
          points: "96 80 24 80 24 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hw),
        e("polyline", {
          points: "232 96 136 192 24 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Aw)
      ])) : o(i) === "regular" ? (s(), r("g", Vw, [
        e("polyline", {
          points: "96 80 24 80 24 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zw),
        e("polyline", {
          points: "232 96 136 192 24 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zw)
      ])) : g("", !0)
    ], 16, aw));
  }
}), bw = ["width", "height", "fill", "transform"], Lw = { key: 0 }, Bw = ["stroke"], Pw = ["stroke"], Ww = { key: 1 }, Nw = ["stroke"], Fw = ["stroke"], Tw = { key: 2 }, Dw = /* @__PURE__ */ e("path", { d: "M232,64a8,8,0,0,1-8,8H88v80h40a8,8,0,0,1,7.4,4.9,8.4,8.4,0,0,1-1.7,8.8l-48,48a8.2,8.2,0,0,1-11.4,0l-48-48a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,32,152H72V64a8,8,0,0,1,8-8H224A8,8,0,0,1,232,64Z" }, null, -1), Rw = [
  Dw
], Uw = { key: 3 }, qw = ["stroke"], Gw = ["stroke"], Ew = { key: 4 }, Ow = ["stroke"], Iw = ["stroke"], Kw = { key: 5 }, Xw = ["stroke"], Jw = ["stroke"], Qw = {
  name: "PhArrowElbowLeftDown"
}, fT1 = /* @__PURE__ */ $({
  ...Qw,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Lw, [
        e("polyline", {
          points: "128 160 80 208 32 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bw),
        e("polyline", {
          points: "224 64 80 64 80 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pw)
      ])) : o(i) === "duotone" ? (s(), r("g", Ww, [
        e("polyline", {
          points: "128 160 80 208 32 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nw),
        e("polyline", {
          points: "224 64 80 64 80 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fw)
      ])) : o(i) === "fill" ? (s(), r("g", Tw, Rw)) : o(i) === "light" ? (s(), r("g", Uw, [
        e("polyline", {
          points: "128 160 80 208 32 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qw),
        e("polyline", {
          points: "224 64 80 64 80 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gw)
      ])) : o(i) === "thin" ? (s(), r("g", Ew, [
        e("polyline", {
          points: "128 160 80 208 32 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ow),
        e("polyline", {
          points: "224 64 80 64 80 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Iw)
      ])) : o(i) === "regular" ? (s(), r("g", Kw, [
        e("polyline", {
          points: "128 160 80 208 32 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xw),
        e("polyline", {
          points: "224 64 80 64 80 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jw)
      ])) : g("", !0)
    ], 16, bw));
  }
}), Yw = ["width", "height", "fill", "transform"], of = { key: 0 }, ef = ["stroke"], tf = ["stroke"], nf = { key: 1 }, sf = ["stroke"], rf = ["stroke"], lf = { key: 2 }, df = /* @__PURE__ */ e("path", { d: "M232,192a8,8,0,0,1-8,8H80a8,8,0,0,1-8-8V104H32a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l48-48a8.1,8.1,0,0,1,11.4,0l48,48a8.4,8.4,0,0,1,1.7,8.8A8,8,0,0,1,128,104H88v80H224A8,8,0,0,1,232,192Z" }, null, -1), kf = [
  df
], cf = { key: 3 }, hf = ["stroke"], uf = ["stroke"], af = { key: 4 }, _f = ["stroke"], pf = ["stroke"], yf = { key: 5 }, $f = ["stroke"], wf = ["stroke"], ff = {
  name: "PhArrowElbowLeftUp"
}, gT1 = /* @__PURE__ */ $({
  ...ff,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", of, [
        e("polyline", {
          points: "128 96 80 48 32 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ef),
        e("polyline", {
          points: "224 192 80 192 80 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tf)
      ])) : o(i) === "duotone" ? (s(), r("g", nf, [
        e("polyline", {
          points: "128 96 80 48 32 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sf),
        e("polyline", {
          points: "224 192 80 192 80 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rf)
      ])) : o(i) === "fill" ? (s(), r("g", lf, kf)) : o(i) === "light" ? (s(), r("g", cf, [
        e("polyline", {
          points: "128 96 80 48 32 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hf),
        e("polyline", {
          points: "224 192 80 192 80 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uf)
      ])) : o(i) === "thin" ? (s(), r("g", af, [
        e("polyline", {
          points: "128 96 80 48 32 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _f),
        e("polyline", {
          points: "224 192 80 192 80 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pf)
      ])) : o(i) === "regular" ? (s(), r("g", yf, [
        e("polyline", {
          points: "128 96 80 48 32 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $f),
        e("polyline", {
          points: "224 192 80 192 80 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wf)
      ])) : g("", !0)
    ], 16, Yw));
  }
}), gf = ["width", "height", "fill", "transform"], xf = { key: 0 }, jf = ["stroke"], mf = ["stroke"], Mf = { key: 1 }, vf = ["stroke"], Sf = ["stroke"], Hf = { key: 2 }, Af = /* @__PURE__ */ e("path", { d: "M240,80v72a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3L196,127.3l-70.3,70.4a8.2,8.2,0,0,1-11.4,0l-96-96A8.1,8.1,0,0,1,29.7,90.3L120,180.7,184.7,116,154.3,85.7a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,160,72h72A8,8,0,0,1,240,80Z" }, null, -1), Vf = [
  Af
], zf = { key: 3 }, Zf = ["stroke"], Cf = ["stroke"], bf = { key: 4 }, Lf = ["stroke"], Bf = ["stroke"], Pf = { key: 5 }, Wf = ["stroke"], Nf = ["stroke"], Ff = {
  name: "PhArrowElbowRight"
}, xT1 = /* @__PURE__ */ $({
  ...Ff,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xf, [
        e("polyline", {
          points: "160 80 232 80 232 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jf),
        e("polyline", {
          points: "24 96 120 192 232 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mf)
      ])) : o(i) === "duotone" ? (s(), r("g", Mf, [
        e("polyline", {
          points: "160 80 232 80 232 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vf),
        e("polyline", {
          points: "24 96 120 192 232 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sf)
      ])) : o(i) === "fill" ? (s(), r("g", Hf, Vf)) : o(i) === "light" ? (s(), r("g", zf, [
        e("polyline", {
          points: "160 80 232 80 232 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zf),
        e("polyline", {
          points: "24 96 120 192 232 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cf)
      ])) : o(i) === "thin" ? (s(), r("g", bf, [
        e("polyline", {
          points: "160 80 232 80 232 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lf),
        e("polyline", {
          points: "24 96 120 192 232 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bf)
      ])) : o(i) === "regular" ? (s(), r("g", Pf, [
        e("polyline", {
          points: "160 80 232 80 232 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wf),
        e("polyline", {
          points: "24 96 120 192 232 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nf)
      ])) : g("", !0)
    ], 16, gf));
  }
}), Tf = ["width", "height", "fill", "transform"], Df = { key: 0 }, Rf = ["stroke"], Uf = ["stroke"], qf = { key: 1 }, Gf = ["stroke"], Ef = ["stroke"], Of = { key: 2 }, If = /* @__PURE__ */ e("path", { d: "M229.7,165.7l-48,48a8.2,8.2,0,0,1-11.4,0l-48-48a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,128,152h40V72H32a8,8,0,0,1,0-16H176a8,8,0,0,1,8,8v88h40a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,229.7,165.7Z" }, null, -1), Kf = [
  If
], Xf = { key: 3 }, Jf = ["stroke"], Qf = ["stroke"], Yf = { key: 4 }, og = ["stroke"], eg = ["stroke"], tg = { key: 5 }, ng = ["stroke"], sg = ["stroke"], rg = {
  name: "PhArrowElbowRightDown"
}, jT1 = /* @__PURE__ */ $({
  ...rg,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Df, [
        e("polyline", {
          points: "128 160 176 208 224 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rf),
        e("polyline", {
          points: "32 64 176 64 176 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Uf)
      ])) : o(i) === "duotone" ? (s(), r("g", qf, [
        e("polyline", {
          points: "128 160 176 208 224 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gf),
        e("polyline", {
          points: "32 64 176 64 176 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ef)
      ])) : o(i) === "fill" ? (s(), r("g", Of, Kf)) : o(i) === "light" ? (s(), r("g", Xf, [
        e("polyline", {
          points: "128 160 176 208 224 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jf),
        e("polyline", {
          points: "32 64 176 64 176 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qf)
      ])) : o(i) === "thin" ? (s(), r("g", Yf, [
        e("polyline", {
          points: "128 160 176 208 224 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, og),
        e("polyline", {
          points: "32 64 176 64 176 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eg)
      ])) : o(i) === "regular" ? (s(), r("g", tg, [
        e("polyline", {
          points: "128 160 176 208 224 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ng),
        e("polyline", {
          points: "32 64 176 64 176 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sg)
      ])) : g("", !0)
    ], 16, Tf));
  }
}), ig = ["width", "height", "fill", "transform"], lg = { key: 0 }, dg = ["stroke"], kg = ["stroke"], cg = { key: 1 }, hg = ["stroke"], ug = ["stroke"], ag = { key: 2 }, _g = /* @__PURE__ */ e("path", { d: "M231.4,99.1A8,8,0,0,1,224,104H184v88a8,8,0,0,1-8,8H32a8,8,0,0,1,0-16H168V104H128a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l48-48a8.1,8.1,0,0,1,11.4,0l48,48A8.4,8.4,0,0,1,231.4,99.1Z" }, null, -1), pg = [
  _g
], yg = { key: 3 }, $g = ["stroke"], wg = ["stroke"], fg = { key: 4 }, gg = ["stroke"], xg = ["stroke"], jg = { key: 5 }, mg = ["stroke"], Mg = ["stroke"], vg = {
  name: "PhArrowElbowRightUp"
}, mT1 = /* @__PURE__ */ $({
  ...vg,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", lg, [
        e("polyline", {
          points: "128 96 176 48 224 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dg),
        e("polyline", {
          points: "32 192 176 192 176 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kg)
      ])) : o(i) === "duotone" ? (s(), r("g", cg, [
        e("polyline", {
          points: "128 96 176 48 224 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hg),
        e("polyline", {
          points: "32 192 176 192 176 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ug)
      ])) : o(i) === "fill" ? (s(), r("g", ag, pg)) : o(i) === "light" ? (s(), r("g", yg, [
        e("polyline", {
          points: "128 96 176 48 224 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $g),
        e("polyline", {
          points: "32 192 176 192 176 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wg)
      ])) : o(i) === "thin" ? (s(), r("g", fg, [
        e("polyline", {
          points: "128 96 176 48 224 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gg),
        e("polyline", {
          points: "32 192 176 192 176 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xg)
      ])) : o(i) === "regular" ? (s(), r("g", jg, [
        e("polyline", {
          points: "128 96 176 48 224 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mg),
        e("polyline", {
          points: "32 192 176 192 176 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mg)
      ])) : g("", !0)
    ], 16, ig));
  }
}), Sg = ["width", "height", "fill", "transform"], Hg = { key: 0 }, Ag = ["stroke"], Vg = ["stroke"], zg = { key: 1 }, Zg = ["stroke"], Cg = ["stroke"], bg = { key: 2 }, Lg = /* @__PURE__ */ e("path", { d: "M200,80V224a8,8,0,0,1-16,0V88H104v40a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-48-48a8.1,8.1,0,0,1,0-11.4l48-48a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,104,32V72h88A8,8,0,0,1,200,80Z" }, null, -1), Bg = [
  Lg
], Pg = { key: 3 }, Wg = ["stroke"], Ng = ["stroke"], Fg = { key: 4 }, Tg = ["stroke"], Dg = ["stroke"], Rg = { key: 5 }, Ug = ["stroke"], qg = ["stroke"], Gg = ["stroke"], Eg = {
  name: "PhArrowElbowUpLeft"
}, MT1 = /* @__PURE__ */ $({
  ...Eg,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Hg, [
        e("polyline", {
          points: "96 128 48 80 96 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ag),
        e("polyline", {
          points: "192 224 192 80 48 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vg)
      ])) : o(i) === "duotone" ? (s(), r("g", zg, [
        e("polyline", {
          points: "96 128 48 80 96 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zg),
        e("polyline", {
          points: "192 224 192 80 48 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cg)
      ])) : o(i) === "fill" ? (s(), r("g", bg, Bg)) : o(i) === "light" ? (s(), r("g", Pg, [
        e("polyline", {
          points: "96 128 48 80 96 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wg),
        e("polyline", {
          points: "192 224 192 80 48 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ng)
      ])) : o(i) === "thin" ? (s(), r("g", Fg, [
        e("polyline", {
          points: "96 128 48 80 96 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Tg),
        e("polyline", {
          points: "192 224 192 80 48 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Dg)
      ])) : o(i) === "regular" ? (s(), r("g", Rg, [
        e("polyline", {
          points: "192 224 192 80 48 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ug),
        e("polyline", {
          points: "96 128 48 80 96 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qg),
        e("polyline", {
          points: "192 224 192 80 48 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gg)
      ])) : g("", !0)
    ], 16, Sg));
  }
}), Og = ["width", "height", "fill", "transform"], Ig = { key: 0 }, Kg = ["stroke"], Xg = ["stroke"], Jg = { key: 1 }, Qg = ["stroke"], Yg = ["stroke"], ox = { key: 2 }, ex = /* @__PURE__ */ e("path", { d: "M213.7,85.7l-48,48A8.3,8.3,0,0,1,160,136a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,152,128V88H72V224a8,8,0,0,1-16,0V80a8,8,0,0,1,8-8h88V32a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l48,48A8.1,8.1,0,0,1,213.7,85.7Z" }, null, -1), tx = [
  ex
], nx = { key: 3 }, sx = ["stroke"], rx = ["stroke"], ix = { key: 4 }, lx = ["stroke"], dx = ["stroke"], kx = { key: 5 }, cx = ["stroke"], hx = ["stroke"], ux = {
  name: "PhArrowElbowUpRight"
}, vT1 = /* @__PURE__ */ $({
  ...ux,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ig, [
        e("polyline", {
          points: "160 128 208 80 160 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kg),
        e("polyline", {
          points: "64 224 64 80 208 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xg)
      ])) : o(i) === "duotone" ? (s(), r("g", Jg, [
        e("polyline", {
          points: "160 128 208 80 160 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qg),
        e("polyline", {
          points: "64 224 64 80 208 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yg)
      ])) : o(i) === "fill" ? (s(), r("g", ox, tx)) : o(i) === "light" ? (s(), r("g", nx, [
        e("polyline", {
          points: "160 128 208 80 160 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sx),
        e("polyline", {
          points: "64 224 64 80 208 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rx)
      ])) : o(i) === "thin" ? (s(), r("g", ix, [
        e("polyline", {
          points: "160 128 208 80 160 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lx),
        e("polyline", {
          points: "64 224 64 80 208 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dx)
      ])) : o(i) === "regular" ? (s(), r("g", kx, [
        e("polyline", {
          points: "160 128 208 80 160 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cx),
        e("polyline", {
          points: "64 224 64 80 208 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hx)
      ])) : g("", !0)
    ], 16, Og));
  }
}), ax = ["width", "height", "fill", "transform"], _x = { key: 0 }, px = ["stroke"], yx = { key: 1 }, $x = /* @__PURE__ */ e("path", {
  d: "M32,136l96,96,96-96H176V48a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v88Z",
  opacity: "0.2"
}, null, -1), wx = ["stroke"], fx = { key: 2 }, gx = /* @__PURE__ */ e("path", { d: "M229.7,141.7l-96,96a8.1,8.1,0,0,1-11.4,0l-96-96a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,32,128H72V48A16,16,0,0,1,88,32h80a16,16,0,0,1,16,16v80h40a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,229.7,141.7Z" }, null, -1), xx = [
  gx
], jx = { key: 3 }, mx = ["stroke"], Mx = { key: 4 }, vx = ["stroke"], Sx = { key: 5 }, Hx = ["stroke"], Ax = {
  name: "PhArrowFatDown"
}, ST1 = /* @__PURE__ */ $({
  ...Ax,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", _x, [
        e("path", {
          d: "M32,136l96,96,96-96H176V48a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, px)
      ])) : o(i) === "duotone" ? (s(), r("g", yx, [
        $x,
        e("path", {
          d: "M32,136l96,96,96-96H176V48a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wx)
      ])) : o(i) === "fill" ? (s(), r("g", fx, xx)) : o(i) === "light" ? (s(), r("g", jx, [
        e("path", {
          d: "M32,136l96,96,96-96H176V48a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mx)
      ])) : o(i) === "thin" ? (s(), r("g", Mx, [
        e("path", {
          d: "M32,136l96,96,96-96H176V48a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vx)
      ])) : o(i) === "regular" ? (s(), r("g", Sx, [
        e("path", {
          d: "M32,136l96,96,96-96H176V48a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hx)
      ])) : g("", !0)
    ], 16, ax));
  }
}), Vx = ["width", "height", "fill", "transform"], zx = { key: 0 }, Zx = ["stroke"], Cx = { key: 1 }, bx = /* @__PURE__ */ e("path", {
  d: "M120,32,24,128l96,96V176h88a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H120Z",
  opacity: "0.2"
}, null, -1), Lx = ["stroke"], Bx = { key: 2 }, Px = /* @__PURE__ */ e("path", { d: "M114.3,229.7l-96-96a8.1,8.1,0,0,1,0-11.4l96-96a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,128,32V72h80a16,16,0,0,1,16,16v80a16,16,0,0,1-16,16H128v40a8,8,0,0,1-4.9,7.4A8.4,8.4,0,0,1,114.3,229.7Z" }, null, -1), Wx = [
  Px
], Nx = { key: 3 }, Fx = ["stroke"], Tx = { key: 4 }, Dx = ["stroke"], Rx = { key: 5 }, Ux = ["stroke"], qx = {
  name: "PhArrowFatLeft"
}, HT1 = /* @__PURE__ */ $({
  ...qx,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", zx, [
        e("path", {
          d: "M120,32,24,128l96,96V176h88a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H120Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zx)
      ])) : o(i) === "duotone" ? (s(), r("g", Cx, [
        bx,
        e("path", {
          d: "M120,32,24,128l96,96V176h88a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H120Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lx)
      ])) : o(i) === "fill" ? (s(), r("g", Bx, Wx)) : o(i) === "light" ? (s(), r("g", Nx, [
        e("path", {
          d: "M120,32,24,128l96,96V176h88a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H120Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fx)
      ])) : o(i) === "thin" ? (s(), r("g", Tx, [
        e("path", {
          d: "M120,32,24,128l96,96V176h88a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H120Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Dx)
      ])) : o(i) === "regular" ? (s(), r("g", Rx, [
        e("path", {
          d: "M120,32,24,128l96,96V176h88a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H120Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ux)
      ])) : g("", !0)
    ], 16, Vx));
  }
}), Gx = ["width", "height", "fill", "transform"], Ex = { key: 0 }, Ox = ["stroke"], Ix = ["stroke"], Kx = { key: 1 }, Xx = /* @__PURE__ */ e("polygon", {
  points: "32 136 128 232 224 136 176 136 176 72 80 72 80 136 32 136",
  opacity: "0.2"
}, null, -1), Jx = ["stroke"], Qx = ["stroke"], Yx = { key: 2 }, oj = /* @__PURE__ */ e("path", { d: "M229.7,141.7l-96,96a8.1,8.1,0,0,1-11.4,0l-96-96a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,32,128H72V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8v56h40a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,229.7,141.7ZM184,40a8,8,0,0,0-8-8H80a8,8,0,0,0,0,16h96A8,8,0,0,0,184,40Z" }, null, -1), ej = [
  oj
], tj = { key: 3 }, nj = ["stroke"], sj = ["stroke"], rj = { key: 4 }, ij = ["stroke"], lj = ["stroke"], dj = { key: 5 }, kj = ["stroke"], cj = ["stroke"], hj = {
  name: "PhArrowFatLineDown"
}, AT1 = /* @__PURE__ */ $({
  ...hj,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ex, [
        e("polygon", {
          points: "32 136 128 232 224 136 176 136 176 80 80 80 80 136 32 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ox),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ix)
      ])) : o(i) === "duotone" ? (s(), r("g", Kx, [
        Xx,
        e("polygon", {
          points: "32 136 128 232 224 136 176 136 176 72 80 72 80 136 32 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jx),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qx)
      ])) : o(i) === "fill" ? (s(), r("g", Yx, ej)) : o(i) === "light" ? (s(), r("g", tj, [
        e("polygon", {
          points: "32 136 128 232 224 136 176 136 176 72 80 72 80 136 32 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nj),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sj)
      ])) : o(i) === "thin" ? (s(), r("g", rj, [
        e("polygon", {
          points: "32 136 128 232 224 136 176 136 176 72 80 72 80 136 32 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ij),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lj)
      ])) : o(i) === "regular" ? (s(), r("g", dj, [
        e("polygon", {
          points: "32 136 128 232 224 136 176 136 176 72 80 72 80 136 32 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kj),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cj)
      ])) : g("", !0)
    ], 16, Gx));
  }
}), uj = ["width", "height", "fill", "transform"], aj = { key: 0 }, _j = ["stroke"], pj = ["stroke"], yj = { key: 1 }, $j = /* @__PURE__ */ e("polygon", {
  points: "120 32 24 128 120 224 120 176 184 176 184 80 120 80 120 32",
  opacity: "0.2"
}, null, -1), wj = ["stroke"], fj = ["stroke"], gj = { key: 2 }, xj = /* @__PURE__ */ e("path", { d: "M114.3,229.7l-96-96a8.1,8.1,0,0,1,0-11.4l96-96a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,128,32V72h56a8,8,0,0,1,8,8v96a8,8,0,0,1-8,8H128v40a8,8,0,0,1-4.9,7.4A8.4,8.4,0,0,1,114.3,229.7ZM216,184a8,8,0,0,0,8-8V80a8,8,0,0,0-16,0v96A8,8,0,0,0,216,184Z" }, null, -1), jj = [
  xj
], mj = { key: 3 }, Mj = ["stroke"], vj = ["stroke"], Sj = { key: 4 }, Hj = ["stroke"], Aj = ["stroke"], Vj = { key: 5 }, zj = ["stroke"], Zj = ["stroke"], Cj = {
  name: "PhArrowFatLineLeft"
}, VT1 = /* @__PURE__ */ $({
  ...Cj,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", aj, [
        e("polygon", {
          points: "120 32 24 128 120 224 120 176 176 176 176 80 120 80 120 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _j),
        e("line", {
          x1: "216",
          y1: "176",
          x2: "216",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pj)
      ])) : o(i) === "duotone" ? (s(), r("g", yj, [
        $j,
        e("polygon", {
          points: "120 32 24 128 120 224 120 176 184 176 184 80 120 80 120 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wj),
        e("line", {
          x1: "216",
          y1: "176",
          x2: "216",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fj)
      ])) : o(i) === "fill" ? (s(), r("g", gj, jj)) : o(i) === "light" ? (s(), r("g", mj, [
        e("polygon", {
          points: "120 32 24 128 120 224 120 176 184 176 184 80 120 80 120 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mj),
        e("line", {
          x1: "216",
          y1: "176",
          x2: "216",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vj)
      ])) : o(i) === "thin" ? (s(), r("g", Sj, [
        e("polygon", {
          points: "120 32 24 128 120 224 120 176 184 176 184 80 120 80 120 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hj),
        e("line", {
          x1: "216",
          y1: "176",
          x2: "216",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Aj)
      ])) : o(i) === "regular" ? (s(), r("g", Vj, [
        e("polygon", {
          points: "120 32 24 128 120 224 120 176 184 176 184 80 120 80 120 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zj),
        e("line", {
          x1: "216",
          y1: "176",
          x2: "216",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zj)
      ])) : g("", !0)
    ], 16, uj));
  }
}), bj = ["width", "height", "fill", "transform"], Lj = { key: 0 }, Bj = ["stroke"], Pj = ["stroke"], Wj = { key: 1 }, Nj = /* @__PURE__ */ e("polygon", {
  points: "136 32 232 128 136 224 136 176 72 176 72 80 136 80 136 32",
  opacity: "0.2"
}, null, -1), Fj = ["stroke"], Tj = ["stroke"], Dj = { key: 2 }, Rj = /* @__PURE__ */ e("path", { d: "M132.9,231.4A8,8,0,0,1,128,224V184H72a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h56V32a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l96,96a8.1,8.1,0,0,1,0,11.4l-96,96A8.4,8.4,0,0,1,132.9,231.4ZM48,176V80a8,8,0,0,0-16,0v96a8,8,0,0,0,16,0Z" }, null, -1), Uj = [
  Rj
], qj = { key: 3 }, Gj = ["stroke"], Ej = ["stroke"], Oj = { key: 4 }, Ij = ["stroke"], Kj = ["stroke"], Xj = { key: 5 }, Jj = ["stroke"], Qj = ["stroke"], Yj = {
  name: "PhArrowFatLineRight"
}, zT1 = /* @__PURE__ */ $({
  ...Yj,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Lj, [
        e("polygon", {
          points: "136 32 232 128 136 224 136 176 80 176 80 80 136 80 136 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bj),
        e("line", {
          x1: "40",
          y1: "176",
          x2: "40",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pj)
      ])) : o(i) === "duotone" ? (s(), r("g", Wj, [
        Nj,
        e("polygon", {
          points: "136 32 232 128 136 224 136 176 72 176 72 80 136 80 136 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fj),
        e("line", {
          x1: "40",
          y1: "176",
          x2: "40",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tj)
      ])) : o(i) === "fill" ? (s(), r("g", Dj, Uj)) : o(i) === "light" ? (s(), r("g", qj, [
        e("polygon", {
          points: "136 32 232 128 136 224 136 176 72 176 72 80 136 80 136 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gj),
        e("line", {
          x1: "40",
          y1: "176",
          x2: "40",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ej)
      ])) : o(i) === "thin" ? (s(), r("g", Oj, [
        e("polygon", {
          points: "136 32 232 128 136 224 136 176 72 176 72 80 136 80 136 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ij),
        e("line", {
          x1: "40",
          y1: "176",
          x2: "40",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kj)
      ])) : o(i) === "regular" ? (s(), r("g", Xj, [
        e("polygon", {
          points: "136 32 232 128 136 224 136 176 72 176 72 80 136 80 136 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jj),
        e("line", {
          x1: "40",
          y1: "176",
          x2: "40",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qj)
      ])) : g("", !0)
    ], 16, bj));
  }
}), om = ["width", "height", "fill", "transform"], em = { key: 0 }, tm = ["stroke"], nm = ["stroke"], sm = { key: 1 }, rm = /* @__PURE__ */ e("polygon", {
  points: "32 120 128 24 224 120 176 120 176 184 80 184 80 120 32 120",
  opacity: "0.2"
}, null, -1), im = ["stroke"], lm = ["stroke"], dm = { key: 2 }, km = /* @__PURE__ */ e("path", { d: "M231.4,123.1A8,8,0,0,1,224,128H184v56a8,8,0,0,1-8,8H80a8,8,0,0,1-8-8V128H32a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l96-96a8.1,8.1,0,0,1,11.4,0l96,96A8.4,8.4,0,0,1,231.4,123.1ZM176,208H80a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z" }, null, -1), cm = [
  km
], hm = { key: 3 }, um = ["stroke"], am = ["stroke"], _m = { key: 4 }, pm = ["stroke"], ym = ["stroke"], $m = { key: 5 }, wm = ["stroke"], fm = ["stroke"], gm = {
  name: "PhArrowFatLineUp"
}, ZT1 = /* @__PURE__ */ $({
  ...gm,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", em, [
        e("polygon", {
          points: "32 120 128 24 224 120 176 120 176 176 80 176 80 120 32 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tm),
        e("line", {
          x1: "176",
          y1: "216",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nm)
      ])) : o(i) === "duotone" ? (s(), r("g", sm, [
        rm,
        e("polygon", {
          points: "32 120 128 24 224 120 176 120 176 184 80 184 80 120 32 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, im),
        e("line", {
          x1: "176",
          y1: "216",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lm)
      ])) : o(i) === "fill" ? (s(), r("g", dm, cm)) : o(i) === "light" ? (s(), r("g", hm, [
        e("polygon", {
          points: "32 120 128 24 224 120 176 120 176 184 80 184 80 120 32 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, um),
        e("line", {
          x1: "176",
          y1: "216",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, am)
      ])) : o(i) === "thin" ? (s(), r("g", _m, [
        e("polygon", {
          points: "32 120 128 24 224 120 176 120 176 184 80 184 80 120 32 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pm),
        e("line", {
          x1: "176",
          y1: "216",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ym)
      ])) : o(i) === "regular" ? (s(), r("g", $m, [
        e("polygon", {
          points: "32 120 128 24 224 120 176 120 176 184 80 184 80 120 32 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wm),
        e("line", {
          x1: "176",
          y1: "216",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fm)
      ])) : g("", !0)
    ], 16, om));
  }
}), xm = ["width", "height", "fill", "transform"], jm = { key: 0 }, mm = ["stroke"], Mm = ["stroke"], vm = ["stroke"], Sm = { key: 1 }, Hm = /* @__PURE__ */ e("polygon", {
  points: "32 136 128 232 224 136 176 136 176 104 80 104 80 136 32 136",
  opacity: "0.2"
}, null, -1), Am = ["stroke"], Vm = ["stroke"], zm = ["stroke"], Zm = { key: 2 }, Cm = /* @__PURE__ */ e("path", { d: "M229.7,141.7l-96,96a8.1,8.1,0,0,1-11.4,0l-96-96a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,32,128H72V104a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8v24h40a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,229.7,141.7ZM184,40a8,8,0,0,0-8-8H80a8,8,0,0,0,0,16h96A8,8,0,0,0,184,40Zm0,32a8,8,0,0,0-8-8H80a8,8,0,0,0,0,16h96A8,8,0,0,0,184,72Z" }, null, -1), bm = [
  Cm
], Lm = { key: 3 }, Bm = ["stroke"], Pm = ["stroke"], Wm = ["stroke"], Nm = { key: 4 }, Fm = ["stroke"], Tm = ["stroke"], Dm = ["stroke"], Rm = { key: 5 }, Um = ["stroke"], qm = ["stroke"], Gm = ["stroke"], Em = {
  name: "PhArrowFatLinesDown"
}, CT1 = /* @__PURE__ */ $({
  ...Em,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", jm, [
        e("polygon", {
          points: "32 136 128 232 224 136 176 136 176 116 80 116 80 136 32 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mm),
        e("line", {
          x1: "176",
          y1: "44",
          x2: "80",
          y2: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mm),
        e("line", {
          x1: "176",
          y1: "80",
          x2: "80",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vm)
      ])) : o(i) === "duotone" ? (s(), r("g", Sm, [
        Hm,
        e("polygon", {
          points: "32 136 128 232 224 136 176 136 176 104 80 104 80 136 32 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Am),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vm),
        e("line", {
          x1: "176",
          y1: "72",
          x2: "80",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zm)
      ])) : o(i) === "fill" ? (s(), r("g", Zm, bm)) : o(i) === "light" ? (s(), r("g", Lm, [
        e("polygon", {
          points: "32 136 128 232 224 136 176 136 176 104 80 104 80 136 32 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bm),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pm),
        e("line", {
          x1: "176",
          y1: "72",
          x2: "80",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wm)
      ])) : o(i) === "thin" ? (s(), r("g", Nm, [
        e("polygon", {
          points: "32 136 128 232 224 136 176 136 176 104 80 104 80 136 32 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fm),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Tm),
        e("line", {
          x1: "176",
          y1: "72",
          x2: "80",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Dm)
      ])) : o(i) === "regular" ? (s(), r("g", Rm, [
        e("polygon", {
          points: "32 136 128 232 224 136 176 136 176 104 80 104 80 136 32 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Um),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qm),
        e("line", {
          x1: "176",
          y1: "72",
          x2: "80",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gm)
      ])) : g("", !0)
    ], 16, xm));
  }
}), Om = ["width", "height", "fill", "transform"], Im = { key: 0 }, Km = ["stroke"], Xm = ["stroke"], Jm = ["stroke"], Qm = { key: 1 }, Ym = /* @__PURE__ */ e("polygon", {
  points: "120 32 24 128 120 224 120 176 152 176 152 80 120 80 120 32",
  opacity: "0.2"
}, null, -1), oM = ["stroke"], eM = ["stroke"], tM = ["stroke"], nM = { key: 2 }, sM = /* @__PURE__ */ e("path", { d: "M114.3,229.7l-96-96a8.1,8.1,0,0,1,0-11.4l96-96a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,128,32V72h24a8,8,0,0,1,8,8v96a8,8,0,0,1-8,8H128v40a8,8,0,0,1-4.9,7.4A8.4,8.4,0,0,1,114.3,229.7ZM216,184a8,8,0,0,0,8-8V80a8,8,0,0,0-16,0v96A8,8,0,0,0,216,184Zm-32,0a8,8,0,0,0,8-8V80a8,8,0,0,0-16,0v96A8,8,0,0,0,184,184Z" }, null, -1), rM = [
  sM
], iM = { key: 3 }, lM = ["stroke"], dM = ["stroke"], kM = ["stroke"], cM = { key: 4 }, hM = ["stroke"], uM = ["stroke"], aM = ["stroke"], _M = { key: 5 }, pM = ["stroke"], yM = ["stroke"], $M = ["stroke"], wM = {
  name: "PhArrowFatLinesLeft"
}, bT1 = /* @__PURE__ */ $({
  ...wM,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Im, [
        e("polygon", {
          points: "120 32 24 128 120 224 120 176 140 176 140 80 120 80 120 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Km),
        e("line", {
          x1: "212",
          y1: "176",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xm),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "176",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jm)
      ])) : o(i) === "duotone" ? (s(), r("g", Qm, [
        Ym,
        e("polygon", {
          points: "120 32 24 128 120 224 120 176 152 176 152 80 120 80 120 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oM),
        e("line", {
          x1: "216",
          y1: "176",
          x2: "216",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eM),
        e("line", {
          x1: "184",
          y1: "176",
          x2: "184",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tM)
      ])) : o(i) === "fill" ? (s(), r("g", nM, rM)) : o(i) === "light" ? (s(), r("g", iM, [
        e("polygon", {
          points: "120 32 24 128 120 224 120 176 152 176 152 80 120 80 120 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lM),
        e("line", {
          x1: "216",
          y1: "176",
          x2: "216",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dM),
        e("line", {
          x1: "184",
          y1: "176",
          x2: "184",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kM)
      ])) : o(i) === "thin" ? (s(), r("g", cM, [
        e("polygon", {
          points: "120 32 24 128 120 224 120 176 152 176 152 80 120 80 120 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hM),
        e("line", {
          x1: "216",
          y1: "176",
          x2: "216",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uM),
        e("line", {
          x1: "184",
          y1: "176",
          x2: "184",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aM)
      ])) : o(i) === "regular" ? (s(), r("g", _M, [
        e("polygon", {
          points: "120 32 24 128 120 224 120 176 152 176 152 80 120 80 120 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pM),
        e("line", {
          x1: "216",
          y1: "176",
          x2: "216",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yM),
        e("line", {
          x1: "184",
          y1: "176",
          x2: "184",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $M)
      ])) : g("", !0)
    ], 16, Om));
  }
}), fM = ["width", "height", "fill", "transform"], gM = { key: 0 }, xM = ["stroke"], jM = ["stroke"], mM = ["stroke"], MM = { key: 1 }, vM = /* @__PURE__ */ e("polygon", {
  points: "136 32 232 128 136 224 136 176 104 176 104 80 136 80 136 32",
  opacity: "0.2"
}, null, -1), SM = ["stroke"], HM = ["stroke"], AM = ["stroke"], VM = { key: 2 }, zM = /* @__PURE__ */ e("path", { d: "M132.9,231.4A8,8,0,0,1,128,224V184H104a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h24V32a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l96,96a8.1,8.1,0,0,1,0,11.4l-96,96A8.4,8.4,0,0,1,132.9,231.4ZM48,176V80a8,8,0,0,0-16,0v96a8,8,0,0,0,16,0Zm32,0V80a8,8,0,0,0-16,0v96a8,8,0,0,0,16,0Z" }, null, -1), ZM = [
  zM
], CM = { key: 3 }, bM = ["stroke"], LM = ["stroke"], BM = ["stroke"], PM = { key: 4 }, WM = ["stroke"], NM = ["stroke"], FM = ["stroke"], TM = { key: 5 }, DM = ["stroke"], RM = ["stroke"], UM = ["stroke"], qM = {
  name: "PhArrowFatLinesRight"
}, LT1 = /* @__PURE__ */ $({
  ...qM,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", gM, [
        e("polygon", {
          points: "136 32 232 128 136 224 136 176 116 176 116 80 136 80 136 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xM),
        e("line", {
          x1: "44",
          y1: "176",
          x2: "44",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jM),
        e("line", {
          x1: "80",
          y1: "176",
          x2: "80",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mM)
      ])) : o(i) === "duotone" ? (s(), r("g", MM, [
        vM,
        e("polygon", {
          points: "136 32 232 128 136 224 136 176 104 176 104 80 136 80 136 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SM),
        e("line", {
          x1: "40",
          y1: "176",
          x2: "40",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HM),
        e("line", {
          x1: "72",
          y1: "176",
          x2: "72",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AM)
      ])) : o(i) === "fill" ? (s(), r("g", VM, ZM)) : o(i) === "light" ? (s(), r("g", CM, [
        e("polygon", {
          points: "136 32 232 128 136 224 136 176 104 176 104 80 136 80 136 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bM),
        e("line", {
          x1: "40",
          y1: "176",
          x2: "40",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LM),
        e("line", {
          x1: "72",
          y1: "176",
          x2: "72",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BM)
      ])) : o(i) === "thin" ? (s(), r("g", PM, [
        e("polygon", {
          points: "136 32 232 128 136 224 136 176 104 176 104 80 136 80 136 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WM),
        e("line", {
          x1: "40",
          y1: "176",
          x2: "40",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, NM),
        e("line", {
          x1: "72",
          y1: "176",
          x2: "72",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FM)
      ])) : o(i) === "regular" ? (s(), r("g", TM, [
        e("polygon", {
          points: "136 32 232 128 136 224 136 176 104 176 104 80 136 80 136 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DM),
        e("line", {
          x1: "40",
          y1: "176",
          x2: "40",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RM),
        e("line", {
          x1: "72",
          y1: "176",
          x2: "72",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UM)
      ])) : g("", !0)
    ], 16, fM));
  }
}), GM = ["width", "height", "fill", "transform"], EM = { key: 0 }, OM = ["stroke"], IM = ["stroke"], KM = ["stroke"], XM = { key: 1 }, JM = /* @__PURE__ */ e("polygon", {
  points: "32 120 128 24 224 120 176 120 176 152 80 152 80 120 32 120",
  opacity: "0.2"
}, null, -1), QM = ["stroke"], YM = ["stroke"], ov = ["stroke"], ev = { key: 2 }, tv = /* @__PURE__ */ e("path", { d: "M231.4,123.1A8,8,0,0,1,224,128H184v24a8,8,0,0,1-8,8H80a8,8,0,0,1-8-8V128H32a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l96-96a8.1,8.1,0,0,1,11.4,0l96,96A8.4,8.4,0,0,1,231.4,123.1ZM176,208H80a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm0-32H80a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z" }, null, -1), nv = [
  tv
], sv = { key: 3 }, rv = ["stroke"], iv = ["stroke"], lv = ["stroke"], dv = { key: 4 }, kv = ["stroke"], cv = ["stroke"], hv = ["stroke"], uv = { key: 5 }, av = ["stroke"], _v = ["stroke"], pv = ["stroke"], yv = {
  name: "PhArrowFatLinesUp"
}, BT1 = /* @__PURE__ */ $({
  ...yv,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", EM, [
        e("polygon", {
          points: "32 120 128 24 224 120 176 120 176 140 80 140 80 120 32 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OM),
        e("line", {
          x1: "176",
          y1: "212",
          x2: "80",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IM),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "80",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KM)
      ])) : o(i) === "duotone" ? (s(), r("g", XM, [
        JM,
        e("polygon", {
          points: "32 120 128 24 224 120 176 120 176 152 80 152 80 120 32 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QM),
        e("line", {
          x1: "176",
          y1: "216",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YM),
        e("line", {
          x1: "176",
          y1: "184",
          x2: "80",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ov)
      ])) : o(i) === "fill" ? (s(), r("g", ev, nv)) : o(i) === "light" ? (s(), r("g", sv, [
        e("polygon", {
          points: "32 120 128 24 224 120 176 120 176 152 80 152 80 120 32 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rv),
        e("line", {
          x1: "176",
          y1: "216",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iv),
        e("line", {
          x1: "176",
          y1: "184",
          x2: "80",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lv)
      ])) : o(i) === "thin" ? (s(), r("g", dv, [
        e("polygon", {
          points: "32 120 128 24 224 120 176 120 176 152 80 152 80 120 32 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kv),
        e("line", {
          x1: "176",
          y1: "216",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cv),
        e("line", {
          x1: "176",
          y1: "184",
          x2: "80",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hv)
      ])) : o(i) === "regular" ? (s(), r("g", uv, [
        e("polygon", {
          points: "32 120 128 24 224 120 176 120 176 152 80 152 80 120 32 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, av),
        e("line", {
          x1: "176",
          y1: "216",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _v),
        e("line", {
          x1: "176",
          y1: "184",
          x2: "80",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pv)
      ])) : g("", !0)
    ], 16, GM));
  }
}), $v = ["width", "height", "fill", "transform"], wv = { key: 0 }, fv = ["stroke"], gv = { key: 1 }, xv = /* @__PURE__ */ e("path", {
  d: "M136,32l96,96-96,96V176H48a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h88Z",
  opacity: "0.2"
}, null, -1), jv = ["stroke"], mv = { key: 2 }, Mv = /* @__PURE__ */ e("path", { d: "M132.9,231.4A8,8,0,0,1,128,224V184H48a16,16,0,0,1-16-16V88A16,16,0,0,1,48,72h80V32a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l96,96a8.1,8.1,0,0,1,0,11.4l-96,96A8.4,8.4,0,0,1,132.9,231.4Z" }, null, -1), vv = [
  Mv
], Sv = { key: 3 }, Hv = ["stroke"], Av = { key: 4 }, Vv = ["stroke"], zv = { key: 5 }, Zv = ["stroke"], Cv = {
  name: "PhArrowFatRight"
}, PT1 = /* @__PURE__ */ $({
  ...Cv,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", wv, [
        e("path", {
          d: "M136,32l96,96-96,96V176H48a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fv)
      ])) : o(i) === "duotone" ? (s(), r("g", gv, [
        xv,
        e("path", {
          d: "M136,32l96,96-96,96V176H48a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jv)
      ])) : o(i) === "fill" ? (s(), r("g", mv, vv)) : o(i) === "light" ? (s(), r("g", Sv, [
        e("path", {
          d: "M136,32l96,96-96,96V176H48a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hv)
      ])) : o(i) === "thin" ? (s(), r("g", Av, [
        e("path", {
          d: "M136,32l96,96-96,96V176H48a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vv)
      ])) : o(i) === "regular" ? (s(), r("g", zv, [
        e("path", {
          d: "M136,32l96,96-96,96V176H48a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zv)
      ])) : g("", !0)
    ], 16, $v));
  }
}), bv = ["width", "height", "fill", "transform"], Lv = { key: 0 }, Bv = ["stroke"], Pv = { key: 1 }, Wv = /* @__PURE__ */ e("path", {
  d: "M32,120l96-96,96,96H176v88a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V120Z",
  opacity: "0.2"
}, null, -1), Nv = ["stroke"], Fv = { key: 2 }, Tv = /* @__PURE__ */ e("path", { d: "M231.4,123.1A8,8,0,0,1,224,128H184v80a16,16,0,0,1-16,16H88a16,16,0,0,1-16-16V128H32a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l96-96a8.1,8.1,0,0,1,11.4,0l96,96A8.4,8.4,0,0,1,231.4,123.1Z" }, null, -1), Dv = [
  Tv
], Rv = { key: 3 }, Uv = ["stroke"], qv = { key: 4 }, Gv = ["stroke"], Ev = { key: 5 }, Ov = ["stroke"], Iv = {
  name: "PhArrowFatUp"
}, WT1 = /* @__PURE__ */ $({
  ...Iv,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Lv, [
        e("path", {
          d: "M32,120l96-96,96,96H176v88a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V120Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bv)
      ])) : o(i) === "duotone" ? (s(), r("g", Pv, [
        Wv,
        e("path", {
          d: "M32,120l96-96,96,96H176v88a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V120Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nv)
      ])) : o(i) === "fill" ? (s(), r("g", Fv, Dv)) : o(i) === "light" ? (s(), r("g", Rv, [
        e("path", {
          d: "M32,120l96-96,96,96H176v88a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V120Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Uv)
      ])) : o(i) === "thin" ? (s(), r("g", qv, [
        e("path", {
          d: "M32,120l96-96,96,96H176v88a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V120Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gv)
      ])) : o(i) === "regular" ? (s(), r("g", Ev, [
        e("path", {
          d: "M32,120l96-96,96,96H176v88a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V120Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ov)
      ])) : g("", !0)
    ], 16, bv));
  }
}), Kv = ["width", "height", "fill", "transform"], Xv = { key: 0 }, Jv = ["stroke"], Qv = ["stroke"], Yv = { key: 1 }, oS = ["stroke"], eS = ["stroke"], tS = { key: 2 }, nS = /* @__PURE__ */ e("path", { d: "M224,128a8,8,0,0,1-8,8H120v64a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-72-72a8.1,8.1,0,0,1,0-11.4l72-72a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,120,56v64h96A8,8,0,0,1,224,128Z" }, null, -1), sS = [
  nS
], rS = { key: 3 }, iS = ["stroke"], lS = ["stroke"], dS = { key: 4 }, kS = ["stroke"], cS = ["stroke"], hS = { key: 5 }, uS = ["stroke"], aS = ["stroke"], _S = {
  name: "PhArrowLeft"
}, NT1 = /* @__PURE__ */ $({
  ..._S,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Xv, [
        e("line", {
          x1: "216",
          y1: "128",
          x2: "40",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jv),
        e("polyline", {
          points: "112 56 40 128 112 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qv)
      ])) : o(i) === "duotone" ? (s(), r("g", Yv, [
        e("line", {
          x1: "216",
          y1: "128",
          x2: "40",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oS),
        e("polyline", {
          points: "112 56 40 128 112 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eS)
      ])) : o(i) === "fill" ? (s(), r("g", tS, sS)) : o(i) === "light" ? (s(), r("g", rS, [
        e("line", {
          x1: "216",
          y1: "128",
          x2: "40",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iS),
        e("polyline", {
          points: "112 56 40 128 112 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lS)
      ])) : o(i) === "thin" ? (s(), r("g", dS, [
        e("line", {
          x1: "216",
          y1: "128",
          x2: "40",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kS),
        e("polyline", {
          points: "112 56 40 128 112 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cS)
      ])) : o(i) === "regular" ? (s(), r("g", hS, [
        e("line", {
          x1: "216",
          y1: "128",
          x2: "40",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uS),
        e("polyline", {
          points: "112 56 40 128 112 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aS)
      ])) : g("", !0)
    ], 16, Kv));
  }
}), pS = ["width", "height", "fill", "transform"], yS = { key: 0 }, $S = ["stroke"], wS = ["stroke"], fS = ["stroke"], gS = { key: 1 }, xS = ["stroke"], jS = ["stroke"], mS = ["stroke"], MS = { key: 2 }, vS = /* @__PURE__ */ e("path", { d: "M50.3,117.7a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,56,104h64V32a8,8,0,0,1,16,0v72h64a8,8,0,0,1,7.4,4.9,8.4,8.4,0,0,1-1.7,8.8l-72,72a8.2,8.2,0,0,1-11.4,0ZM216,208H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1), SS = [
  vS
], HS = { key: 3 }, AS = ["stroke"], VS = ["stroke"], zS = ["stroke"], ZS = { key: 4 }, CS = ["stroke"], bS = ["stroke"], LS = ["stroke"], BS = { key: 5 }, PS = ["stroke"], WS = ["stroke"], NS = ["stroke"], FS = {
  name: "PhArrowLineDown"
}, FT1 = /* @__PURE__ */ $({
  ...FS,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", yS, [
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $S),
        e("polyline", {
          points: "56 104 128 176 200 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wS),
        e("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fS)
      ])) : o(i) === "duotone" ? (s(), r("g", gS, [
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xS),
        e("polyline", {
          points: "56 112 128 184 200 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jS),
        e("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mS)
      ])) : o(i) === "fill" ? (s(), r("g", MS, SS)) : o(i) === "light" ? (s(), r("g", HS, [
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, AS),
        e("polyline", {
          points: "56 112 128 184 200 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VS),
        e("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zS)
      ])) : o(i) === "thin" ? (s(), r("g", ZS, [
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CS),
        e("polyline", {
          points: "56 112 128 184 200 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bS),
        e("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LS)
      ])) : o(i) === "regular" ? (s(), r("g", BS, [
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PS),
        e("polyline", {
          points: "56 112 128 184 200 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WS),
        e("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NS)
      ])) : g("", !0)
    ], 16, pS));
  }
}), TS = ["width", "height", "fill", "transform"], DS = { key: 0 }, RS = ["stroke"], US = ["stroke"], qS = ["stroke"], GS = { key: 1 }, ES = ["stroke"], OS = ["stroke"], IS = ["stroke"], KS = { key: 2 }, XS = /* @__PURE__ */ e("path", { d: "M181.7,82.3a8.1,8.1,0,0,1,0,11.4L125.3,150l44.4,44.3a8.4,8.4,0,0,1,1.7,8.8A8,8,0,0,1,164,208H64a8,8,0,0,1-8-8V100a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7L114,138.7l56.3-56.4A8.1,8.1,0,0,1,181.7,82.3ZM216,32H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1), JS = [
  XS
], QS = { key: 3 }, YS = ["stroke"], oH = ["stroke"], eH = ["stroke"], tH = { key: 4 }, nH = ["stroke"], sH = ["stroke"], rH = ["stroke"], iH = { key: 5 }, lH = ["stroke"], dH = ["stroke"], kH = ["stroke"], cH = {
  name: "PhArrowLineDownLeft"
}, TT1 = /* @__PURE__ */ $({
  ...cH,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", DS, [
        e("line", {
          x1: "176",
          y1: "88",
          x2: "64",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RS),
        e("polyline", {
          points: "64 100 64 200 164 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, US),
        e("line", {
          x1: "216",
          y1: "40",
          x2: "40",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qS)
      ])) : o(i) === "duotone" ? (s(), r("g", GS, [
        e("line", {
          x1: "176",
          y1: "88",
          x2: "64",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ES),
        e("polyline", {
          points: "64 100 64 200 164 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OS),
        e("line", {
          x1: "216",
          y1: "40",
          x2: "40",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IS)
      ])) : o(i) === "fill" ? (s(), r("g", KS, JS)) : o(i) === "light" ? (s(), r("g", QS, [
        e("line", {
          x1: "176",
          y1: "88",
          x2: "64",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YS),
        e("polyline", {
          points: "64 100 64 200 164 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oH),
        e("line", {
          x1: "216",
          y1: "40",
          x2: "40",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eH)
      ])) : o(i) === "thin" ? (s(), r("g", tH, [
        e("line", {
          x1: "176",
          y1: "88",
          x2: "64",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nH),
        e("polyline", {
          points: "64 100 64 200 164 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sH),
        e("line", {
          x1: "216",
          y1: "40",
          x2: "40",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rH)
      ])) : o(i) === "regular" ? (s(), r("g", iH, [
        e("line", {
          x1: "176",
          y1: "88",
          x2: "64",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lH),
        e("polyline", {
          points: "64 100 64 200 164 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dH),
        e("line", {
          x1: "216",
          y1: "40",
          x2: "40",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kH)
      ])) : g("", !0)
    ], 16, TS));
  }
}), hH = ["width", "height", "fill", "transform"], uH = { key: 0 }, aH = ["stroke"], _H = ["stroke"], pH = ["stroke"], yH = { key: 1 }, $H = ["stroke"], wH = ["stroke"], fH = ["stroke"], gH = { key: 2 }, xH = /* @__PURE__ */ e("path", { d: "M200,100V200a8,8,0,0,1-8,8H92a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8L130.7,150,74.3,93.7A8.1,8.1,0,0,1,85.7,82.3L142,138.7l44.3-44.4a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,200,100Zm16-68H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1), jH = [
  xH
], mH = { key: 3 }, MH = ["stroke"], vH = ["stroke"], SH = ["stroke"], HH = { key: 4 }, AH = ["stroke"], VH = ["stroke"], zH = ["stroke"], ZH = { key: 5 }, CH = ["stroke"], bH = ["stroke"], LH = ["stroke"], BH = {
  name: "PhArrowLineDownRight"
}, DT1 = /* @__PURE__ */ $({
  ...BH,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", uH, [
        e("line", {
          x1: "80",
          y1: "88",
          x2: "192",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aH),
        e("polyline", {
          points: "192 100 192 200 92 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _H),
        e("line", {
          x1: "40",
          y1: "40",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pH)
      ])) : o(i) === "duotone" ? (s(), r("g", yH, [
        e("line", {
          x1: "80",
          y1: "88",
          x2: "192",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $H),
        e("polyline", {
          points: "192 100 192 200 92 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wH),
        e("line", {
          x1: "40",
          y1: "40",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fH)
      ])) : o(i) === "fill" ? (s(), r("g", gH, jH)) : o(i) === "light" ? (s(), r("g", mH, [
        e("line", {
          x1: "80",
          y1: "88",
          x2: "192",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, MH),
        e("polyline", {
          points: "192 100 192 200 92 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vH),
        e("line", {
          x1: "40",
          y1: "40",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, SH)
      ])) : o(i) === "thin" ? (s(), r("g", HH, [
        e("line", {
          x1: "80",
          y1: "88",
          x2: "192",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, AH),
        e("polyline", {
          points: "192 100 192 200 92 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VH),
        e("line", {
          x1: "40",
          y1: "40",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zH)
      ])) : o(i) === "regular" ? (s(), r("g", ZH, [
        e("line", {
          x1: "80",
          y1: "88",
          x2: "192",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CH),
        e("polyline", {
          points: "192 100 192 200 92 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bH),
        e("line", {
          x1: "40",
          y1: "40",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LH)
      ])) : g("", !0)
    ], 16, hH));
  }
}), PH = ["width", "height", "fill", "transform"], WH = { key: 0 }, NH = ["stroke"], FH = ["stroke"], TH = ["stroke"], DH = { key: 1 }, RH = ["stroke"], UH = ["stroke"], qH = ["stroke"], GH = { key: 2 }, EH = /* @__PURE__ */ e("path", { d: "M232,128a8,8,0,0,1-8,8H152v64a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-72-72a8.1,8.1,0,0,1,0-11.4l72-72a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,152,56v64h72A8,8,0,0,1,232,128ZM40,32a8,8,0,0,0-8,8V216a8,8,0,0,0,16,0V40A8,8,0,0,0,40,32Z" }, null, -1), OH = [
  EH
], IH = { key: 3 }, KH = ["stroke"], XH = ["stroke"], JH = ["stroke"], QH = { key: 4 }, YH = ["stroke"], oA = ["stroke"], eA = ["stroke"], tA = { key: 5 }, nA = ["stroke"], sA = ["stroke"], rA = ["stroke"], iA = {
  name: "PhArrowLineLeft"
}, RT1 = /* @__PURE__ */ $({
  ...iA,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", WH, [
        e("line", {
          x1: "224",
          y1: "128",
          x2: "80",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NH),
        e("polyline", {
          points: "152 56 80 128 152 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FH),
        e("line", {
          x1: "40",
          y1: "40",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TH)
      ])) : o(i) === "duotone" ? (s(), r("g", DH, [
        e("line", {
          x1: "224",
          y1: "128",
          x2: "72",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RH),
        e("polyline", {
          points: "144 56 72 128 144 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UH),
        e("line", {
          x1: "40",
          y1: "40",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qH)
      ])) : o(i) === "fill" ? (s(), r("g", GH, OH)) : o(i) === "light" ? (s(), r("g", IH, [
        e("line", {
          x1: "224",
          y1: "128",
          x2: "72",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KH),
        e("polyline", {
          points: "144 56 72 128 144 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XH),
        e("line", {
          x1: "40",
          y1: "40",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JH)
      ])) : o(i) === "thin" ? (s(), r("g", QH, [
        e("line", {
          x1: "224",
          y1: "128",
          x2: "72",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YH),
        e("polyline", {
          points: "144 56 72 128 144 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oA),
        e("line", {
          x1: "40",
          y1: "40",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eA)
      ])) : o(i) === "regular" ? (s(), r("g", tA, [
        e("line", {
          x1: "224",
          y1: "128",
          x2: "72",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nA),
        e("polyline", {
          points: "144 56 72 128 144 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sA),
        e("line", {
          x1: "40",
          y1: "40",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rA)
      ])) : g("", !0)
    ], 16, PH));
  }
}), lA = ["width", "height", "fill", "transform"], dA = { key: 0 }, kA = ["stroke"], cA = ["stroke"], hA = ["stroke"], uA = { key: 1 }, aA = ["stroke"], _A = ["stroke"], pA = ["stroke"], yA = { key: 2 }, $A = /* @__PURE__ */ e("path", { d: "M189.7,122.3a8.1,8.1,0,0,1,0,11.4l-72,72A8.3,8.3,0,0,1,112,208a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,104,200V136H32a8,8,0,0,1,0-16h72V56a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7ZM216,32a8,8,0,0,0-8,8V216a8,8,0,0,0,16,0V40A8,8,0,0,0,216,32Z" }, null, -1), wA = [
  $A
], fA = { key: 3 }, gA = ["stroke"], xA = ["stroke"], jA = ["stroke"], mA = { key: 4 }, MA = ["stroke"], vA = ["stroke"], SA = ["stroke"], HA = { key: 5 }, AA = ["stroke"], VA = ["stroke"], zA = ["stroke"], ZA = {
  name: "PhArrowLineRight"
}, UT1 = /* @__PURE__ */ $({
  ...ZA,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", dA, [
        e("line", {
          x1: "32",
          y1: "128",
          x2: "176",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kA),
        e("polyline", {
          points: "104 56 176 128 104 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cA),
        e("line", {
          x1: "216",
          y1: "40",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hA)
      ])) : o(i) === "duotone" ? (s(), r("g", uA, [
        e("line", {
          x1: "32",
          y1: "128",
          x2: "184",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aA),
        e("polyline", {
          points: "112 56 184 128 112 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _A),
        e("line", {
          x1: "216",
          y1: "40",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pA)
      ])) : o(i) === "fill" ? (s(), r("g", yA, wA)) : o(i) === "light" ? (s(), r("g", fA, [
        e("line", {
          x1: "32",
          y1: "128",
          x2: "184",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gA),
        e("polyline", {
          points: "112 56 184 128 112 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xA),
        e("line", {
          x1: "216",
          y1: "40",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jA)
      ])) : o(i) === "thin" ? (s(), r("g", mA, [
        e("line", {
          x1: "32",
          y1: "128",
          x2: "184",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MA),
        e("polyline", {
          points: "112 56 184 128 112 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vA),
        e("line", {
          x1: "216",
          y1: "40",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SA)
      ])) : o(i) === "regular" ? (s(), r("g", HA, [
        e("line", {
          x1: "32",
          y1: "128",
          x2: "184",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AA),
        e("polyline", {
          points: "112 56 184 128 112 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VA),
        e("line", {
          x1: "216",
          y1: "40",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zA)
      ])) : g("", !0)
    ], 16, lA));
  }
}), CA = ["width", "height", "fill", "transform"], bA = { key: 0 }, LA = ["stroke"], BA = ["stroke"], PA = ["stroke"], WA = { key: 1 }, NA = ["stroke"], FA = ["stroke"], TA = ["stroke"], DA = { key: 2 }, RA = /* @__PURE__ */ e("path", { d: "M205.7,138.3a8.4,8.4,0,0,1,1.7,8.8A8,8,0,0,1,200,152H136v72a8,8,0,0,1-16,0V152H56a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l72-72a8.1,8.1,0,0,1,11.4,0ZM216,32H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1), UA = [
  RA
], qA = { key: 3 }, GA = ["stroke"], EA = ["stroke"], OA = ["stroke"], IA = { key: 4 }, KA = ["stroke"], XA = ["stroke"], JA = ["stroke"], QA = { key: 5 }, YA = ["stroke"], oV = ["stroke"], eV = ["stroke"], tV = {
  name: "PhArrowLineUp"
}, qT1 = /* @__PURE__ */ $({
  ...tV,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", bA, [
        e("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LA),
        e("polyline", {
          points: "56 152 128 80 200 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BA),
        e("line", {
          x1: "40",
          y1: "40",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PA)
      ])) : o(i) === "duotone" ? (s(), r("g", WA, [
        e("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NA),
        e("polyline", {
          points: "56 144 128 72 200 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FA),
        e("line", {
          x1: "40",
          y1: "40",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TA)
      ])) : o(i) === "fill" ? (s(), r("g", DA, UA)) : o(i) === "light" ? (s(), r("g", qA, [
        e("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GA),
        e("polyline", {
          points: "56 144 128 72 200 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, EA),
        e("line", {
          x1: "40",
          y1: "40",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OA)
      ])) : o(i) === "thin" ? (s(), r("g", IA, [
        e("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KA),
        e("polyline", {
          points: "56 144 128 72 200 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XA),
        e("line", {
          x1: "40",
          y1: "40",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, JA)
      ])) : o(i) === "regular" ? (s(), r("g", QA, [
        e("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YA),
        e("polyline", {
          points: "56 144 128 72 200 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oV),
        e("line", {
          x1: "40",
          y1: "40",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eV)
      ])) : g("", !0)
    ], 16, CA));
  }
}), nV = ["width", "height", "fill", "transform"], sV = { key: 0 }, rV = ["stroke"], iV = ["stroke"], lV = ["stroke"], dV = { key: 1 }, kV = ["stroke"], cV = ["stroke"], hV = ["stroke"], uV = { key: 2 }, aV = /* @__PURE__ */ e("path", { d: "M56,156V56a8,8,0,0,1,8-8H164a8,8,0,0,1,7.4,4.9,8.4,8.4,0,0,1-1.7,8.8L125.3,106l56.4,56.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0L114,117.3,69.7,161.7A8.3,8.3,0,0,1,64,164a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,56,156Zm160,52H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1), _V = [
  aV
], pV = { key: 3 }, yV = ["stroke"], $V = ["stroke"], wV = ["stroke"], fV = { key: 4 }, gV = ["stroke"], xV = ["stroke"], jV = ["stroke"], mV = { key: 5 }, MV = ["stroke"], vV = ["stroke"], SV = ["stroke"], HV = {
  name: "PhArrowLineUpLeft"
}, GT1 = /* @__PURE__ */ $({
  ...HV,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", sV, [
        e("line", {
          x1: "176",
          y1: "168",
          x2: "64",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rV),
        e("polyline", {
          points: "64 156 64 56 164 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iV),
        e("line", {
          x1: "216",
          y1: "216",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lV)
      ])) : o(i) === "duotone" ? (s(), r("g", dV, [
        e("line", {
          x1: "176",
          y1: "168",
          x2: "64",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kV),
        e("polyline", {
          points: "64 156 64 56 164 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cV),
        e("line", {
          x1: "216",
          y1: "216",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hV)
      ])) : o(i) === "fill" ? (s(), r("g", uV, _V)) : o(i) === "light" ? (s(), r("g", pV, [
        e("line", {
          x1: "176",
          y1: "168",
          x2: "64",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yV),
        e("polyline", {
          points: "64 156 64 56 164 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $V),
        e("line", {
          x1: "216",
          y1: "216",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wV)
      ])) : o(i) === "thin" ? (s(), r("g", fV, [
        e("line", {
          x1: "176",
          y1: "168",
          x2: "64",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gV),
        e("polyline", {
          points: "64 156 64 56 164 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xV),
        e("line", {
          x1: "216",
          y1: "216",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jV)
      ])) : o(i) === "regular" ? (s(), r("g", mV, [
        e("line", {
          x1: "176",
          y1: "168",
          x2: "64",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MV),
        e("polyline", {
          points: "64 156 64 56 164 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vV),
        e("line", {
          x1: "216",
          y1: "216",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SV)
      ])) : g("", !0)
    ], 16, nV));
  }
}), AV = ["width", "height", "fill", "transform"], VV = { key: 0 }, zV = ["stroke"], ZV = ["stroke"], CV = ["stroke"], bV = { key: 1 }, LV = ["stroke"], BV = ["stroke"], PV = ["stroke"], WV = { key: 2 }, NV = /* @__PURE__ */ e("path", { d: "M74.3,173.7a8.1,8.1,0,0,1,0-11.4L130.7,106,86.3,61.7a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,92,48H192a8,8,0,0,1,8,8V156a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3L142,117.3,85.7,173.7a8.2,8.2,0,0,1-11.4,0ZM216,208H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1), FV = [
  NV
], TV = { key: 3 }, DV = ["stroke"], RV = ["stroke"], UV = ["stroke"], qV = { key: 4 }, GV = ["stroke"], EV = ["stroke"], OV = ["stroke"], IV = { key: 5 }, KV = ["stroke"], XV = ["stroke"], JV = ["stroke"], QV = {
  name: "PhArrowLineUpRight"
}, ET1 = /* @__PURE__ */ $({
  ...QV,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", VV, [
        e("line", {
          x1: "80",
          y1: "168",
          x2: "192",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zV),
        e("polyline", {
          points: "192 156 192 56 92 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZV),
        e("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CV)
      ])) : o(i) === "duotone" ? (s(), r("g", bV, [
        e("line", {
          x1: "80",
          y1: "168",
          x2: "192",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LV),
        e("polyline", {
          points: "192 156 192 56 92 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BV),
        e("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PV)
      ])) : o(i) === "fill" ? (s(), r("g", WV, FV)) : o(i) === "light" ? (s(), r("g", TV, [
        e("line", {
          x1: "80",
          y1: "168",
          x2: "192",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DV),
        e("polyline", {
          points: "192 156 192 56 92 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RV),
        e("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UV)
      ])) : o(i) === "thin" ? (s(), r("g", qV, [
        e("line", {
          x1: "80",
          y1: "168",
          x2: "192",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GV),
        e("polyline", {
          points: "192 156 192 56 92 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, EV),
        e("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OV)
      ])) : o(i) === "regular" ? (s(), r("g", IV, [
        e("line", {
          x1: "80",
          y1: "168",
          x2: "192",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KV),
        e("polyline", {
          points: "192 156 192 56 92 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XV),
        e("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JV)
      ])) : g("", !0)
    ], 16, AV));
  }
}), YV = ["width", "height", "fill", "transform"], oz = { key: 0 }, ez = ["stroke"], tz = ["stroke"], nz = { key: 1 }, sz = ["stroke"], rz = ["stroke"], iz = { key: 2 }, lz = /* @__PURE__ */ e("path", { d: "M221.7,133.7l-72,72A8.3,8.3,0,0,1,144,208a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,136,200V136H40a8,8,0,0,1,0-16h96V56a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l72,72A8.1,8.1,0,0,1,221.7,133.7Z" }, null, -1), dz = [
  lz
], kz = { key: 3 }, cz = ["stroke"], hz = ["stroke"], uz = { key: 4 }, az = ["stroke"], _z = ["stroke"], pz = { key: 5 }, yz = ["stroke"], $z = ["stroke"], wz = {
  name: "PhArrowRight"
}, OT1 = /* @__PURE__ */ $({
  ...wz,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", oz, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ez),
        e("polyline", {
          points: "144 56 216 128 144 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tz)
      ])) : o(i) === "duotone" ? (s(), r("g", nz, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sz),
        e("polyline", {
          points: "144 56 216 128 144 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rz)
      ])) : o(i) === "fill" ? (s(), r("g", iz, dz)) : o(i) === "light" ? (s(), r("g", kz, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cz),
        e("polyline", {
          points: "144 56 216 128 144 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hz)
      ])) : o(i) === "thin" ? (s(), r("g", uz, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, az),
        e("polyline", {
          points: "144 56 216 128 144 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _z)
      ])) : o(i) === "regular" ? (s(), r("g", pz, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yz),
        e("polyline", {
          points: "144 56 216 128 144 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $z)
      ])) : g("", !0)
    ], 16, YV));
  }
}), fz = ["width", "height", "fill", "transform"], gz = { key: 0 }, xz = ["stroke"], jz = ["stroke"], mz = ["stroke"], Mz = { key: 1 }, vz = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), Sz = ["stroke"], Hz = ["stroke"], Az = ["stroke"], Vz = { key: 2 }, zz = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM167.6,139.7l-33.9,33.9a8,8,0,0,1-2.7,1.8,7.7,7.7,0,0,1-3,.6,8.5,8.5,0,0,1-3.1-.6,8.7,8.7,0,0,1-2.6-1.8L88.4,139.7a8,8,0,0,1,11.3-11.3L120,148.7V88a8,8,0,0,1,16,0v60.7l20.3-20.3a8,8,0,0,1,11.3,11.3Z" }, null, -1), Zz = [
  zz
], Cz = { key: 3 }, bz = ["stroke"], Lz = ["stroke"], Bz = ["stroke"], Pz = { key: 4 }, Wz = ["stroke"], Nz = ["stroke"], Fz = ["stroke"], Tz = { key: 5 }, Dz = ["stroke"], Rz = ["stroke"], Uz = ["stroke"], qz = {
  name: "PhArrowSquareDown"
}, IT1 = /* @__PURE__ */ $({
  ...qz,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", gz, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xz),
        e("polyline", {
          points: "94.1 134.1 128 168 161.9 134.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jz),
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mz)
      ])) : o(i) === "duotone" ? (s(), r("g", Mz, [
        vz,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sz),
        e("polyline", {
          points: "94.1 134.1 128 168 161.9 134.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hz),
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Az)
      ])) : o(i) === "fill" ? (s(), r("g", Vz, Zz)) : o(i) === "light" ? (s(), r("g", Cz, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bz),
        e("polyline", {
          points: "94.1 134.1 128 168 161.9 134.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lz),
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bz)
      ])) : o(i) === "thin" ? (s(), r("g", Pz, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wz),
        e("polyline", {
          points: "94.1 134.1 128 168 161.9 134.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nz),
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fz)
      ])) : o(i) === "regular" ? (s(), r("g", Tz, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dz),
        e("polyline", {
          points: "94.1 134.1 128 168 161.9 134.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rz),
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uz)
      ])) : g("", !0)
    ], 16, fz));
  }
}), Gz = ["width", "height", "fill", "transform"], Ez = { key: 0 }, Oz = ["stroke"], Iz = ["stroke"], Kz = ["stroke"], Xz = { key: 1 }, Jz = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  transform: "translate(0 256) rotate(-90)",
  opacity: "0.2"
}, null, -1), Qz = ["stroke"], Yz = ["stroke"], oZ = ["stroke"], eZ = { key: 2 }, tZ = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm-46.3,73.7L119.3,148H148a8,8,0,0,1,0,16H100a8,8,0,0,1-8-8V108a8,8,0,0,1,16,0v28.7l42.3-42.4a8.1,8.1,0,0,1,11.4,11.4Z" }, null, -1), nZ = [
  tZ
], sZ = { key: 3 }, rZ = ["stroke"], iZ = ["stroke"], lZ = ["stroke"], dZ = { key: 4 }, kZ = ["stroke"], cZ = ["stroke"], hZ = ["stroke"], uZ = { key: 5 }, aZ = ["stroke"], _Z = ["stroke"], pZ = ["stroke"], yZ = {
  name: "PhArrowSquareDownLeft"
}, KT1 = /* @__PURE__ */ $({
  ...yZ,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ez, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(0 256) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Oz),
        e("polyline", {
          points: "148 156 100 156 100 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Iz),
        e("line", {
          x1: "156",
          y1: "100",
          x2: "100",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kz)
      ])) : o(i) === "duotone" ? (s(), r("g", Xz, [
        Jz,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(0 256) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qz),
        e("polyline", {
          points: "148 156 100 156 100 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yz),
        e("line", {
          x1: "156",
          y1: "100",
          x2: "100",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oZ)
      ])) : o(i) === "fill" ? (s(), r("g", eZ, nZ)) : o(i) === "light" ? (s(), r("g", sZ, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(0 256) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rZ),
        e("polyline", {
          points: "148 156 100 156 100 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iZ),
        e("line", {
          x1: "156",
          y1: "100",
          x2: "100",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lZ)
      ])) : o(i) === "thin" ? (s(), r("g", dZ, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(0 256) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kZ),
        e("polyline", {
          points: "148 156 100 156 100 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cZ),
        e("line", {
          x1: "156",
          y1: "100",
          x2: "100",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hZ)
      ])) : o(i) === "regular" ? (s(), r("g", uZ, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(0 256) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aZ),
        e("polyline", {
          points: "148 156 100 156 100 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Z),
        e("line", {
          x1: "156",
          y1: "100",
          x2: "100",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pZ)
      ])) : g("", !0)
    ], 16, Gz));
  }
}), $Z = ["width", "height", "fill", "transform"], wZ = { key: 0 }, fZ = ["stroke"], gZ = ["stroke"], xZ = ["stroke"], jZ = { key: 1 }, mZ = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  transform: "translate(256 0) rotate(90)",
  opacity: "0.2"
}, null, -1), MZ = ["stroke"], vZ = ["stroke"], SZ = ["stroke"], HZ = { key: 2 }, AZ = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM164,156a8,8,0,0,1-8,8H108a8,8,0,0,1,0-16h28.7L94.3,105.7a8.1,8.1,0,0,1,11.4-11.4L148,136.7V108a8,8,0,0,1,16,0Z" }, null, -1), VZ = [
  AZ
], zZ = { key: 3 }, ZZ = ["stroke"], CZ = ["stroke"], bZ = ["stroke"], LZ = { key: 4 }, BZ = ["stroke"], PZ = ["stroke"], WZ = ["stroke"], NZ = { key: 5 }, FZ = ["stroke"], TZ = ["stroke"], DZ = ["stroke"], RZ = {
  name: "PhArrowSquareDownRight"
}, XT1 = /* @__PURE__ */ $({
  ...RZ,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", wZ, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fZ),
        e("polyline", {
          points: "108 156 156 156 156 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gZ),
        e("line", {
          x1: "100",
          y1: "100",
          x2: "156",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xZ)
      ])) : o(i) === "duotone" ? (s(), r("g", jZ, [
        mZ,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MZ),
        e("polyline", {
          points: "108 156 156 156 156 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vZ),
        e("line", {
          x1: "100",
          y1: "100",
          x2: "156",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SZ)
      ])) : o(i) === "fill" ? (s(), r("g", HZ, VZ)) : o(i) === "light" ? (s(), r("g", zZ, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZZ),
        e("polyline", {
          points: "108 156 156 156 156 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, CZ),
        e("line", {
          x1: "100",
          y1: "100",
          x2: "156",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bZ)
      ])) : o(i) === "thin" ? (s(), r("g", LZ, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, BZ),
        e("polyline", {
          points: "108 156 156 156 156 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PZ),
        e("line", {
          x1: "100",
          y1: "100",
          x2: "156",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WZ)
      ])) : o(i) === "regular" ? (s(), r("g", NZ, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FZ),
        e("polyline", {
          points: "108 156 156 156 156 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TZ),
        e("line", {
          x1: "100",
          y1: "100",
          x2: "156",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DZ)
      ])) : g("", !0)
    ], 16, $Z));
  }
}), UZ = ["width", "height", "fill", "transform"], qZ = { key: 0 }, GZ = ["stroke"], EZ = ["stroke"], OZ = ["stroke"], IZ = { key: 1 }, KZ = /* @__PURE__ */ e("rect", {
  x: "64",
  y: "40",
  width: "152",
  height: "152",
  rx: "8",
  opacity: "0.2"
}, null, -1), XZ = ["stroke"], JZ = ["stroke"], QZ = ["stroke"], YZ = { key: 2 }, oC = /* @__PURE__ */ e("path", { d: "M120,144v60a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3L82,185.3,45.6,221.7A8,8,0,0,1,40,224a8.3,8.3,0,0,1-5.7-2.3,8,8,0,0,1,0-11.3L70.7,174,46.3,149.7a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,52,136h60A8,8,0,0,1,120,144ZM208,32H72A16,16,0,0,0,56,48V96a8,8,0,0,0,16,0V48H208V184H160a8,8,0,0,0,0,16h48a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Z" }, null, -1), eC = [
  oC
], tC = { key: 3 }, nC = ["stroke"], sC = ["stroke"], rC = ["stroke"], iC = { key: 4 }, lC = ["stroke"], dC = ["stroke"], kC = ["stroke"], cC = { key: 5 }, hC = ["stroke"], uC = ["stroke"], aC = ["stroke"], _C = {
  name: "PhArrowSquareIn"
}, JT1 = /* @__PURE__ */ $({
  ..._C,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", qZ, [
        e("polyline", {
          points: "112 204 112 144 52 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GZ),
        e("line", {
          x1: "40",
          y1: "216",
          x2: "112",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, EZ),
        e("path", {
          d: "M160,192h48a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OZ)
      ])) : o(i) === "duotone" ? (s(), r("g", IZ, [
        KZ,
        e("polyline", {
          points: "112 204 112 144 52 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XZ),
        e("line", {
          x1: "40",
          y1: "216",
          x2: "112",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JZ),
        e("path", {
          d: "M160,192h48a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QZ)
      ])) : o(i) === "fill" ? (s(), r("g", YZ, eC)) : o(i) === "light" ? (s(), r("g", tC, [
        e("polyline", {
          points: "112 204 112 144 52 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nC),
        e("line", {
          x1: "40",
          y1: "216",
          x2: "112",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sC),
        e("path", {
          d: "M160,192h48a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rC)
      ])) : o(i) === "thin" ? (s(), r("g", iC, [
        e("polyline", {
          points: "112 204 112 144 52 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lC),
        e("line", {
          x1: "40",
          y1: "216",
          x2: "112",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dC),
        e("path", {
          d: "M160,192h48a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kC)
      ])) : o(i) === "regular" ? (s(), r("g", cC, [
        e("polyline", {
          points: "112 204 112 144 52 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hC),
        e("line", {
          x1: "40",
          y1: "216",
          x2: "112",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uC),
        e("path", {
          d: "M160,192h48a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H72a8,8,0,0,0-8,8V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aC)
      ])) : g("", !0)
    ], 16, UZ));
  }
}), pC = ["width", "height", "fill", "transform"], yC = { key: 0 }, $C = ["stroke"], wC = ["stroke"], fC = ["stroke"], gC = { key: 1 }, xC = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  transform: "translate(256 0) rotate(90)",
  opacity: "0.2"
}, null, -1), jC = ["stroke"], mC = ["stroke"], MC = ["stroke"], vC = { key: 2 }, SC = /* @__PURE__ */ e("path", { d: "M224,208V48a16,16,0,0,0-16-16H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208A16,16,0,0,0,224,208ZM116.3,167.6,82.4,133.7a8,8,0,0,1-1.8-2.7,7.7,7.7,0,0,1-.6-3,8.5,8.5,0,0,1,.6-3.1,8.7,8.7,0,0,1,1.8-2.6l33.9-33.9a8,8,0,0,1,11.3,11.3L107.3,120H168a8,8,0,0,1,0,16H107.3l20.3,20.3a8,8,0,0,1-11.3,11.3Z" }, null, -1), HC = [
  SC
], AC = { key: 3 }, VC = ["stroke"], zC = ["stroke"], ZC = ["stroke"], CC = { key: 4 }, bC = ["stroke"], LC = ["stroke"], BC = ["stroke"], PC = { key: 5 }, WC = ["stroke"], NC = ["stroke"], FC = ["stroke"], TC = {
  name: "PhArrowSquareLeft"
}, QT1 = /* @__PURE__ */ $({
  ...TC,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", yC, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $C),
        e("polyline", {
          points: "121.9 94.1 88 128 121.9 161.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wC),
        e("line", {
          x1: "168",
          y1: "128",
          x2: "88",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fC)
      ])) : o(i) === "duotone" ? (s(), r("g", gC, [
        xC,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jC),
        e("polyline", {
          points: "121.9 94.1 88 128 121.9 161.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mC),
        e("line", {
          x1: "168",
          y1: "128",
          x2: "88",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MC)
      ])) : o(i) === "fill" ? (s(), r("g", vC, HC)) : o(i) === "light" ? (s(), r("g", AC, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VC),
        e("polyline", {
          points: "121.9 94.1 88 128 121.9 161.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zC),
        e("line", {
          x1: "168",
          y1: "128",
          x2: "88",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZC)
      ])) : o(i) === "thin" ? (s(), r("g", CC, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bC),
        e("polyline", {
          points: "121.9 94.1 88 128 121.9 161.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LC),
        e("line", {
          x1: "168",
          y1: "128",
          x2: "88",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, BC)
      ])) : o(i) === "regular" ? (s(), r("g", PC, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WC),
        e("polyline", {
          points: "121.9 94.1 88 128 121.9 161.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NC),
        e("line", {
          x1: "168",
          y1: "128",
          x2: "88",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FC)
      ])) : g("", !0)
    ], 16, pC));
  }
}), DC = ["width", "height", "fill", "transform"], RC = { key: 0 }, UC = ["stroke"], qC = ["stroke"], GC = ["stroke"], EC = { key: 1 }, OC = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "72",
  width: "144",
  height: "144",
  rx: "8",
  opacity: "0.2"
}, null, -1), IC = ["stroke"], KC = ["stroke"], XC = ["stroke"], JC = { key: 2 }, QC = /* @__PURE__ */ e("path", { d: "M224,100a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3L186,81.3l-36.4,36.4A8,8,0,0,1,144,120a8.3,8.3,0,0,1-5.7-2.3,8,8,0,0,1,0-11.3L174.7,70,150.3,45.7a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,156,32h60a8,8,0,0,1,8,8Zm-40,36a8,8,0,0,0-8,8v64H48V80h64a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V144A8,8,0,0,0,184,136Z" }, null, -1), YC = [
  QC
], ob = { key: 3 }, eb = ["stroke"], tb = ["stroke"], nb = ["stroke"], sb = { key: 4 }, rb = ["stroke"], ib = ["stroke"], lb = ["stroke"], db = { key: 5 }, kb = ["stroke"], cb = ["stroke"], hb = ["stroke"], ub = {
  name: "PhArrowSquareOut"
}, YT1 = /* @__PURE__ */ $({
  ...ub,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", RC, [
        e("polyline", {
          points: "216 100 216 40 156 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, UC),
        e("line", {
          x1: "144",
          y1: "112",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qC),
        e("path", {
          d: "M184,144v64a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GC)
      ])) : o(i) === "duotone" ? (s(), r("g", EC, [
        OC,
        e("polyline", {
          points: "216 100 216 40 156 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IC),
        e("line", {
          x1: "144",
          y1: "112",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KC),
        e("path", {
          d: "M184,144v64a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XC)
      ])) : o(i) === "fill" ? (s(), r("g", JC, YC)) : o(i) === "light" ? (s(), r("g", ob, [
        e("polyline", {
          points: "216 100 216 40 156 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eb),
        e("line", {
          x1: "144",
          y1: "112",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tb),
        e("path", {
          d: "M184,144v64a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nb)
      ])) : o(i) === "thin" ? (s(), r("g", sb, [
        e("polyline", {
          points: "216 100 216 40 156 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rb),
        e("line", {
          x1: "144",
          y1: "112",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ib),
        e("path", {
          d: "M184,144v64a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lb)
      ])) : o(i) === "regular" ? (s(), r("g", db, [
        e("polyline", {
          points: "216 100 216 40 156 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kb),
        e("line", {
          x1: "144",
          y1: "112",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cb),
        e("path", {
          d: "M184,144v64a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hb)
      ])) : g("", !0)
    ], 16, DC));
  }
}), ab = ["width", "height", "fill", "transform"], _b = { key: 0 }, pb = ["stroke"], yb = ["stroke"], $b = ["stroke"], wb = { key: 1 }, fb = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  transform: "translate(256) rotate(90)",
  opacity: "0.2"
}, null, -1), gb = ["stroke"], xb = ["stroke"], jb = ["stroke"], mb = { key: 2 }, Mb = /* @__PURE__ */ e("path", { d: "M48,224H208a16,16,0,0,0,16-16V48a16,16,0,0,0-16-16H48A16,16,0,0,0,32,48V208A16,16,0,0,0,48,224Zm80.4-56.4a8,8,0,0,1,0-11.3L148.7,136H88a8,8,0,0,1,0-16h60.7L128.4,99.7a8,8,0,0,1,11.3-11.3l33.9,33.9a8.7,8.7,0,0,1,1.8,2.6,8.5,8.5,0,0,1,.6,3.1,7.7,7.7,0,0,1-.6,3,8,8,0,0,1-1.8,2.7l-33.9,33.9A8,8,0,0,1,128.4,167.6Z" }, null, -1), vb = [
  Mb
], Sb = { key: 3 }, Hb = ["stroke"], Ab = ["stroke"], Vb = ["stroke"], zb = { key: 4 }, Zb = ["stroke"], Cb = ["stroke"], bb = ["stroke"], Lb = { key: 5 }, Bb = ["stroke"], Pb = ["stroke"], Wb = ["stroke"], Nb = {
  name: "PhArrowSquareRight"
}, oD1 = /* @__PURE__ */ $({
  ...Nb,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", _b, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pb),
        e("polyline", {
          points: "134.1 94.1 168 128 134.1 161.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yb),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $b)
      ])) : o(i) === "duotone" ? (s(), r("g", wb, [
        fb,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gb),
        e("polyline", {
          points: "134.1 94.1 168 128 134.1 161.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xb),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jb)
      ])) : o(i) === "fill" ? (s(), r("g", mb, vb)) : o(i) === "light" ? (s(), r("g", Sb, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hb),
        e("polyline", {
          points: "134.1 94.1 168 128 134.1 161.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ab),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vb)
      ])) : o(i) === "thin" ? (s(), r("g", zb, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zb),
        e("polyline", {
          points: "134.1 94.1 168 128 134.1 161.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cb),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bb)
      ])) : o(i) === "regular" ? (s(), r("g", Lb, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bb),
        e("polyline", {
          points: "134.1 94.1 168 128 134.1 161.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pb),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wb)
      ])) : g("", !0)
    ], 16, ab));
  }
}), Fb = ["width", "height", "fill", "transform"], Tb = { key: 0 }, Db = ["stroke"], Rb = ["stroke"], Ub = ["stroke"], qb = { key: 1 }, Gb = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), Eb = ["stroke"], Ob = ["stroke"], Ib = ["stroke"], Kb = { key: 2 }, Xb = /* @__PURE__ */ e("path", { d: "M224,208V48a16,16,0,0,0-16-16H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208A16,16,0,0,0,224,208Zm-56.4-80.4a8,8,0,0,1-11.3,0L136,107.3V168a8,8,0,0,1-16,0V107.3L99.7,127.6a8,8,0,0,1-11.3-11.3l33.9-33.9a8.7,8.7,0,0,1,2.6-1.8A8.5,8.5,0,0,1,128,80a7.7,7.7,0,0,1,3,.6,8,8,0,0,1,2.7,1.8l33.9,33.9A8,8,0,0,1,167.6,127.6Z" }, null, -1), Jb = [
  Xb
], Qb = { key: 3 }, Yb = ["stroke"], oL = ["stroke"], eL = ["stroke"], tL = { key: 4 }, nL = ["stroke"], sL = ["stroke"], rL = ["stroke"], iL = { key: 5 }, lL = ["stroke"], dL = ["stroke"], kL = ["stroke"], cL = {
  name: "PhArrowSquareUp"
}, eD1 = /* @__PURE__ */ $({
  ...cL,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Tb, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Db),
        e("polyline", {
          points: "94.1 121.9 128 88 161.9 121.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rb),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ub)
      ])) : o(i) === "duotone" ? (s(), r("g", qb, [
        Gb,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Eb),
        e("polyline", {
          points: "94.1 121.9 128 88 161.9 121.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ob),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ib)
      ])) : o(i) === "fill" ? (s(), r("g", Kb, Jb)) : o(i) === "light" ? (s(), r("g", Qb, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Yb),
        e("polyline", {
          points: "94.1 121.9 128 88 161.9 121.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oL),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eL)
      ])) : o(i) === "thin" ? (s(), r("g", tL, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nL),
        e("polyline", {
          points: "94.1 121.9 128 88 161.9 121.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sL),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rL)
      ])) : o(i) === "regular" ? (s(), r("g", iL, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lL),
        e("polyline", {
          points: "94.1 121.9 128 88 161.9 121.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dL),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kL)
      ])) : g("", !0)
    ], 16, Fb));
  }
}), hL = ["width", "height", "fill", "transform"], uL = { key: 0 }, aL = ["stroke"], _L = ["stroke"], pL = ["stroke"], yL = { key: 1 }, $L = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  transform: "translate(256 0) rotate(90)",
  opacity: "0.2"
}, null, -1), wL = ["stroke"], fL = ["stroke"], gL = ["stroke"], xL = { key: 2 }, jL = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM161.7,161.7a8.2,8.2,0,0,1-11.4,0L108,119.3V148a8,8,0,0,1-16,0V100a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H119.3l42.4,42.3A8.1,8.1,0,0,1,161.7,161.7Z" }, null, -1), mL = [
  jL
], ML = { key: 3 }, vL = ["stroke"], SL = ["stroke"], HL = ["stroke"], AL = { key: 4 }, VL = ["stroke"], zL = ["stroke"], ZL = ["stroke"], CL = { key: 5 }, bL = ["stroke"], LL = ["stroke"], BL = ["stroke"], PL = {
  name: "PhArrowSquareUpLeft"
}, tD1 = /* @__PURE__ */ $({
  ...PL,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", uL, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aL),
        e("polyline", {
          points: "148 100 100 100 100 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _L),
        e("line", {
          x1: "156",
          y1: "156",
          x2: "100",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pL)
      ])) : o(i) === "duotone" ? (s(), r("g", yL, [
        $L,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wL),
        e("polyline", {
          points: "148 100 100 100 100 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fL),
        e("line", {
          x1: "156",
          y1: "156",
          x2: "100",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gL)
      ])) : o(i) === "fill" ? (s(), r("g", xL, mL)) : o(i) === "light" ? (s(), r("g", ML, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vL),
        e("polyline", {
          points: "148 100 100 100 100 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, SL),
        e("line", {
          x1: "156",
          y1: "156",
          x2: "100",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HL)
      ])) : o(i) === "thin" ? (s(), r("g", AL, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VL),
        e("polyline", {
          points: "148 100 100 100 100 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zL),
        e("line", {
          x1: "156",
          y1: "156",
          x2: "100",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZL)
      ])) : o(i) === "regular" ? (s(), r("g", CL, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bL),
        e("polyline", {
          points: "148 100 100 100 100 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LL),
        e("line", {
          x1: "156",
          y1: "156",
          x2: "100",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BL)
      ])) : g("", !0)
    ], 16, hL));
  }
}), WL = ["width", "height", "fill", "transform"], NL = { key: 0 }, FL = ["stroke"], TL = ["stroke"], DL = ["stroke"], RL = { key: 1 }, UL = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  transform: "translate(0 256) rotate(-90)",
  opacity: "0.2"
}, null, -1), qL = ["stroke"], GL = ["stroke"], EL = ["stroke"], OL = { key: 2 }, IL = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM164,148a8,8,0,0,1-16,0V119.3l-42.3,42.4a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L136.7,108H108a8,8,0,0,1,0-16h48a8,8,0,0,1,8,8Z" }, null, -1), KL = [
  IL
], XL = { key: 3 }, JL = ["stroke"], QL = ["stroke"], YL = ["stroke"], oB = { key: 4 }, eB = ["stroke"], tB = ["stroke"], nB = ["stroke"], sB = { key: 5 }, rB = ["stroke"], iB = ["stroke"], lB = ["stroke"], dB = {
  name: "PhArrowSquareUpRight"
}, nD1 = /* @__PURE__ */ $({
  ...dB,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", NL, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(0 256) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FL),
        e("polyline", {
          points: "108 100 156 100 156 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TL),
        e("line", {
          x1: "100",
          y1: "156",
          x2: "156",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DL)
      ])) : o(i) === "duotone" ? (s(), r("g", RL, [
        UL,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(0 256) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qL),
        e("polyline", {
          points: "108 100 156 100 156 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GL),
        e("line", {
          x1: "100",
          y1: "156",
          x2: "156",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EL)
      ])) : o(i) === "fill" ? (s(), r("g", OL, KL)) : o(i) === "light" ? (s(), r("g", XL, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(0 256) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JL),
        e("polyline", {
          points: "108 100 156 100 156 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QL),
        e("line", {
          x1: "100",
          y1: "156",
          x2: "156",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YL)
      ])) : o(i) === "thin" ? (s(), r("g", oB, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(0 256) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eB),
        e("polyline", {
          points: "108 100 156 100 156 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tB),
        e("line", {
          x1: "100",
          y1: "156",
          x2: "156",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nB)
      ])) : o(i) === "regular" ? (s(), r("g", sB, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          transform: "translate(0 256) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rB),
        e("polyline", {
          points: "108 100 156 100 156 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iB),
        e("line", {
          x1: "100",
          y1: "156",
          x2: "156",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lB)
      ])) : g("", !0)
    ], 16, WL));
  }
}), kB = ["width", "height", "fill", "transform"], cB = { key: 0 }, hB = ["stroke"], uB = ["stroke"], aB = { key: 1 }, _B = ["stroke"], pB = ["stroke"], yB = { key: 2 }, $B = /* @__PURE__ */ e("path", { d: "M232,112a64.1,64.1,0,0,1-64,64H88v40a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-48-48a8.1,8.1,0,0,1,0-11.4l48-48a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,88,120v40h80a48,48,0,0,0,0-96H80a8,8,0,0,1,0-16h88A64.1,64.1,0,0,1,232,112Z" }, null, -1), wB = [
  $B
], fB = { key: 3 }, gB = ["stroke"], xB = ["stroke"], jB = { key: 4 }, mB = ["stroke"], MB = ["stroke"], vB = { key: 5 }, SB = ["stroke"], HB = ["stroke"], AB = {
  name: "PhArrowUDownLeft"
}, sD1 = /* @__PURE__ */ $({
  ...AB,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", cB, [
        e("polyline", {
          points: "80 120 32 168 80 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hB),
        e("path", {
          d: "M80,56h88a56,56,0,0,1,56,56h0a56,56,0,0,1-56,56H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uB)
      ])) : o(i) === "duotone" ? (s(), r("g", aB, [
        e("polyline", {
          points: "80 120 32 168 80 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _B),
        e("path", {
          d: "M80,56h88a56,56,0,0,1,56,56h0a56,56,0,0,1-56,56H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pB)
      ])) : o(i) === "fill" ? (s(), r("g", yB, wB)) : o(i) === "light" ? (s(), r("g", fB, [
        e("polyline", {
          points: "80 120 32 168 80 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gB),
        e("path", {
          d: "M80,56h88a56,56,0,0,1,56,56h0a56,56,0,0,1-56,56H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xB)
      ])) : o(i) === "thin" ? (s(), r("g", jB, [
        e("polyline", {
          points: "80 120 32 168 80 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mB),
        e("path", {
          d: "M80,56h88a56,56,0,0,1,56,56h0a56,56,0,0,1-56,56H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MB)
      ])) : o(i) === "regular" ? (s(), r("g", vB, [
        e("polyline", {
          points: "80 120 32 168 80 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SB),
        e("path", {
          d: "M80,56h88a56,56,0,0,1,56,56h0a56,56,0,0,1-56,56H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HB)
      ])) : g("", !0)
    ], 16, kB));
  }
}), VB = ["width", "height", "fill", "transform"], zB = { key: 0 }, ZB = ["stroke"], CB = ["stroke"], bB = { key: 1 }, LB = ["stroke"], BB = ["stroke"], PB = { key: 2 }, WB = /* @__PURE__ */ e("path", { d: "M229.7,173.7l-48,48A8.3,8.3,0,0,1,176,224a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,168,216V176H88A64,64,0,0,1,88,48h88a8,8,0,0,1,0,16H88a48,48,0,0,0,0,96h80V120a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l48,48A8.1,8.1,0,0,1,229.7,173.7Z" }, null, -1), NB = [
  WB
], FB = { key: 3 }, TB = ["stroke"], DB = ["stroke"], RB = { key: 4 }, UB = ["stroke"], qB = ["stroke"], GB = { key: 5 }, EB = ["stroke"], OB = ["stroke"], IB = {
  name: "PhArrowUDownRight"
}, rD1 = /* @__PURE__ */ $({
  ...IB,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", zB, [
        e("polyline", {
          points: "176 120 224 168 176 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZB),
        e("path", {
          d: "M176,56H88a56,56,0,0,0-56,56h0a56,56,0,0,0,56,56H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CB)
      ])) : o(i) === "duotone" ? (s(), r("g", bB, [
        e("polyline", {
          points: "176 120 224 168 176 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LB),
        e("path", {
          d: "M176,56H88a56,56,0,0,0-56,56h0a56,56,0,0,0,56,56H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BB)
      ])) : o(i) === "fill" ? (s(), r("g", PB, NB)) : o(i) === "light" ? (s(), r("g", FB, [
        e("polyline", {
          points: "176 120 224 168 176 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TB),
        e("path", {
          d: "M176,56H88a56,56,0,0,0-56,56h0a56,56,0,0,0,56,56H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DB)
      ])) : o(i) === "thin" ? (s(), r("g", RB, [
        e("polyline", {
          points: "176 120 224 168 176 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, UB),
        e("path", {
          d: "M176,56H88a56,56,0,0,0-56,56h0a56,56,0,0,0,56,56H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qB)
      ])) : o(i) === "regular" ? (s(), r("g", GB, [
        e("polyline", {
          points: "176 120 224 168 176 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EB),
        e("path", {
          d: "M176,56H88a56,56,0,0,0-56,56h0a56,56,0,0,0,56,56H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OB)
      ])) : g("", !0)
    ], 16, VB));
  }
}), KB = ["width", "height", "fill", "transform"], XB = { key: 0 }, JB = ["stroke"], QB = ["stroke"], YB = { key: 1 }, oP = ["stroke"], eP = ["stroke"], tP = { key: 2 }, nP = /* @__PURE__ */ e("path", { d: "M208,88v88a8,8,0,0,1-16,0V88a48,48,0,0,0-96,0v80h40a8,8,0,0,1,7.4,4.9,8.4,8.4,0,0,1-1.7,8.8l-48,48a8.2,8.2,0,0,1-11.4,0l-48-48a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,40,168H80V88a64,64,0,0,1,128,0Z" }, null, -1), sP = [
  nP
], rP = { key: 3 }, iP = ["stroke"], lP = ["stroke"], dP = { key: 4 }, kP = ["stroke"], cP = ["stroke"], hP = { key: 5 }, uP = ["stroke"], aP = ["stroke"], _P = {
  name: "PhArrowULeftDown"
}, iD1 = /* @__PURE__ */ $({
  ..._P,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", XB, [
        e("polyline", {
          points: "136 176 88 224 40 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, JB),
        e("path", {
          d: "M200,176V88a56,56,0,0,0-56-56h0A56,56,0,0,0,88,88V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, QB)
      ])) : o(i) === "duotone" ? (s(), r("g", YB, [
        e("polyline", {
          points: "136 176 88 224 40 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oP),
        e("path", {
          d: "M200,176V88a56,56,0,0,0-56-56h0A56,56,0,0,0,88,88V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eP)
      ])) : o(i) === "fill" ? (s(), r("g", tP, sP)) : o(i) === "light" ? (s(), r("g", rP, [
        e("polyline", {
          points: "136 176 88 224 40 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iP),
        e("path", {
          d: "M200,176V88a56,56,0,0,0-56-56h0A56,56,0,0,0,88,88V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lP)
      ])) : o(i) === "thin" ? (s(), r("g", dP, [
        e("polyline", {
          points: "136 176 88 224 40 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kP),
        e("path", {
          d: "M200,176V88a56,56,0,0,0-56-56h0A56,56,0,0,0,88,88V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cP)
      ])) : o(i) === "regular" ? (s(), r("g", hP, [
        e("polyline", {
          points: "136 176 88 224 40 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uP),
        e("path", {
          d: "M200,176V88a56,56,0,0,0-56-56h0A56,56,0,0,0,88,88V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aP)
      ])) : g("", !0)
    ], 16, KB));
  }
}), pP = ["width", "height", "fill", "transform"], yP = { key: 0 }, $P = ["stroke"], wP = ["stroke"], fP = { key: 1 }, gP = ["stroke"], xP = ["stroke"], jP = { key: 2 }, mP = /* @__PURE__ */ e("path", { d: "M208,80v88a64,64,0,0,1-128,0V88H40a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l48-48a8.1,8.1,0,0,1,11.4,0l48,48a8.4,8.4,0,0,1,1.7,8.8A8,8,0,0,1,136,88H96v80a48,48,0,0,0,96,0V80a8,8,0,0,1,16,0Z" }, null, -1), MP = [
  mP
], vP = { key: 3 }, SP = ["stroke"], HP = ["stroke"], AP = { key: 4 }, VP = ["stroke"], zP = ["stroke"], ZP = { key: 5 }, CP = ["stroke"], bP = ["stroke"], LP = {
  name: "PhArrowULeftUp"
}, lD1 = /* @__PURE__ */ $({
  ...LP,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", yP, [
        e("polyline", {
          points: "136 80 88 32 40 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $P),
        e("path", {
          d: "M200,80v88a56,56,0,0,1-56,56h0a56,56,0,0,1-56-56V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wP)
      ])) : o(i) === "duotone" ? (s(), r("g", fP, [
        e("polyline", {
          points: "136 80 88 32 40 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gP),
        e("path", {
          d: "M200,80v88a56,56,0,0,1-56,56h0a56,56,0,0,1-56-56V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xP)
      ])) : o(i) === "fill" ? (s(), r("g", jP, MP)) : o(i) === "light" ? (s(), r("g", vP, [
        e("polyline", {
          points: "136 80 88 32 40 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, SP),
        e("path", {
          d: "M200,80v88a56,56,0,0,1-56,56h0a56,56,0,0,1-56-56V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HP)
      ])) : o(i) === "thin" ? (s(), r("g", AP, [
        e("polyline", {
          points: "136 80 88 32 40 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VP),
        e("path", {
          d: "M200,80v88a56,56,0,0,1-56,56h0a56,56,0,0,1-56-56V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zP)
      ])) : o(i) === "regular" ? (s(), r("g", ZP, [
        e("polyline", {
          points: "136 80 88 32 40 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CP),
        e("path", {
          d: "M200,80v88a56,56,0,0,1-56,56h0a56,56,0,0,1-56-56V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bP)
      ])) : g("", !0)
    ], 16, pP));
  }
}), BP = ["width", "height", "fill", "transform"], PP = { key: 0 }, WP = ["stroke"], NP = ["stroke"], FP = { key: 1 }, TP = ["stroke"], DP = ["stroke"], RP = { key: 2 }, UP = /* @__PURE__ */ e("path", { d: "M221.7,181.7l-48,48a8.2,8.2,0,0,1-11.4,0l-48-48a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,120,168h40V88a48,48,0,0,0-96,0v88a8,8,0,0,1-16,0V88a64,64,0,0,1,128,0v80h40a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,221.7,181.7Z" }, null, -1), qP = [
  UP
], GP = { key: 3 }, EP = ["stroke"], OP = ["stroke"], IP = { key: 4 }, KP = ["stroke"], XP = ["stroke"], JP = { key: 5 }, QP = ["stroke"], YP = ["stroke"], oW = {
  name: "PhArrowURightDown"
}, dD1 = /* @__PURE__ */ $({
  ...oW,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", PP, [
        e("polyline", {
          points: "120 176 168 224 216 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WP),
        e("path", {
          d: "M56,176V88a56,56,0,0,1,56-56h0a56,56,0,0,1,56,56V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NP)
      ])) : o(i) === "duotone" ? (s(), r("g", FP, [
        e("polyline", {
          points: "120 176 168 224 216 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TP),
        e("path", {
          d: "M56,176V88a56,56,0,0,1,56-56h0a56,56,0,0,1,56,56V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DP)
      ])) : o(i) === "fill" ? (s(), r("g", RP, qP)) : o(i) === "light" ? (s(), r("g", GP, [
        e("polyline", {
          points: "120 176 168 224 216 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, EP),
        e("path", {
          d: "M56,176V88a56,56,0,0,1,56-56h0a56,56,0,0,1,56,56V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OP)
      ])) : o(i) === "thin" ? (s(), r("g", IP, [
        e("polyline", {
          points: "120 176 168 224 216 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KP),
        e("path", {
          d: "M56,176V88a56,56,0,0,1,56-56h0a56,56,0,0,1,56,56V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XP)
      ])) : o(i) === "regular" ? (s(), r("g", JP, [
        e("polyline", {
          points: "120 176 168 224 216 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QP),
        e("path", {
          d: "M56,176V88a56,56,0,0,1,56-56h0a56,56,0,0,1,56,56V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YP)
      ])) : g("", !0)
    ], 16, BP));
  }
}), eW = ["width", "height", "fill", "transform"], tW = { key: 0 }, nW = ["stroke"], sW = ["stroke"], rW = { key: 1 }, iW = ["stroke"], lW = ["stroke"], dW = { key: 2 }, kW = /* @__PURE__ */ e("path", { d: "M223.4,83.1A8,8,0,0,1,216,88H176v80a64,64,0,0,1-128,0V80a8,8,0,0,1,16,0v88a48,48,0,0,0,96,0V88H120a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l48-48a8.1,8.1,0,0,1,11.4,0l48,48A8.4,8.4,0,0,1,223.4,83.1Z" }, null, -1), cW = [
  kW
], hW = { key: 3 }, uW = ["stroke"], aW = ["stroke"], _W = { key: 4 }, pW = ["stroke"], yW = ["stroke"], $W = { key: 5 }, wW = ["stroke"], fW = ["stroke"], gW = {
  name: "PhArrowURightUp"
}, kD1 = /* @__PURE__ */ $({
  ...gW,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", tW, [
        e("polyline", {
          points: "120 80 168 32 216 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nW),
        e("path", {
          d: "M56,80v88a56,56,0,0,0,56,56h0a56,56,0,0,0,56-56V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sW)
      ])) : o(i) === "duotone" ? (s(), r("g", rW, [
        e("polyline", {
          points: "120 80 168 32 216 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iW),
        e("path", {
          d: "M56,80v88a56,56,0,0,0,56,56h0a56,56,0,0,0,56-56V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lW)
      ])) : o(i) === "fill" ? (s(), r("g", dW, cW)) : o(i) === "light" ? (s(), r("g", hW, [
        e("polyline", {
          points: "120 80 168 32 216 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uW),
        e("path", {
          d: "M56,80v88a56,56,0,0,0,56,56h0a56,56,0,0,0,56-56V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aW)
      ])) : o(i) === "thin" ? (s(), r("g", _W, [
        e("polyline", {
          points: "120 80 168 32 216 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pW),
        e("path", {
          d: "M56,80v88a56,56,0,0,0,56,56h0a56,56,0,0,0,56-56V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yW)
      ])) : o(i) === "regular" ? (s(), r("g", $W, [
        e("polyline", {
          points: "120 80 168 32 216 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wW),
        e("path", {
          d: "M56,80v88a56,56,0,0,0,56,56h0a56,56,0,0,0,56-56V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fW)
      ])) : g("", !0)
    ], 16, eW));
  }
}), xW = ["width", "height", "fill", "transform"], jW = { key: 0 }, mW = ["stroke"], MW = ["stroke"], vW = { key: 1 }, SW = ["stroke"], HW = ["stroke"], AW = { key: 2 }, VW = /* @__PURE__ */ e("path", { d: "M232,144a64.1,64.1,0,0,1-64,64H80a8,8,0,0,1,0-16h88a48,48,0,0,0,0-96H88v40a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-48-48a8.1,8.1,0,0,1,0-11.4l48-48a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,88,40V80h80A64.1,64.1,0,0,1,232,144Z" }, null, -1), zW = [
  VW
], ZW = { key: 3 }, CW = ["stroke"], bW = ["stroke"], LW = { key: 4 }, BW = ["stroke"], PW = ["stroke"], WW = { key: 5 }, NW = ["stroke"], FW = ["stroke"], TW = {
  name: "PhArrowUUpLeft"
}, cD1 = /* @__PURE__ */ $({
  ...TW,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", jW, [
        e("polyline", {
          points: "80 136 32 88 80 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mW),
        e("path", {
          d: "M80,200h88a56,56,0,0,0,56-56h0a56,56,0,0,0-56-56H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MW)
      ])) : o(i) === "duotone" ? (s(), r("g", vW, [
        e("polyline", {
          points: "80 136 32 88 80 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SW),
        e("path", {
          d: "M80,200h88a56,56,0,0,0,56-56h0a56,56,0,0,0-56-56H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HW)
      ])) : o(i) === "fill" ? (s(), r("g", AW, zW)) : o(i) === "light" ? (s(), r("g", ZW, [
        e("polyline", {
          points: "80 136 32 88 80 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, CW),
        e("path", {
          d: "M80,200h88a56,56,0,0,0,56-56h0a56,56,0,0,0-56-56H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bW)
      ])) : o(i) === "thin" ? (s(), r("g", LW, [
        e("polyline", {
          points: "80 136 32 88 80 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, BW),
        e("path", {
          d: "M80,200h88a56,56,0,0,0,56-56h0a56,56,0,0,0-56-56H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PW)
      ])) : o(i) === "regular" ? (s(), r("g", WW, [
        e("polyline", {
          points: "80 136 32 88 80 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NW),
        e("path", {
          d: "M80,200h88a56,56,0,0,0,56-56h0a56,56,0,0,0-56-56H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FW)
      ])) : g("", !0)
    ], 16, xW));
  }
}), DW = ["width", "height", "fill", "transform"], RW = { key: 0 }, UW = ["stroke"], qW = ["stroke"], GW = { key: 1 }, EW = ["stroke"], OW = ["stroke"], IW = { key: 2 }, KW = /* @__PURE__ */ e("path", { d: "M168,136V96H88a48,48,0,0,0,0,96h88a8,8,0,0,1,0,16H88A64,64,0,0,1,88,80h80V40a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l48,48a8.1,8.1,0,0,1,0,11.4l-48,48A8.3,8.3,0,0,1,176,144a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,168,136Z" }, null, -1), XW = [
  KW
], JW = { key: 3 }, QW = ["stroke"], YW = ["stroke"], oN = { key: 4 }, eN = ["stroke"], tN = ["stroke"], nN = { key: 5 }, sN = ["stroke"], rN = ["stroke"], iN = {
  name: "PhArrowUUpRight"
}, hD1 = /* @__PURE__ */ $({
  ...iN,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", RW, [
        e("polyline", {
          points: "176 136 224 88 176 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, UW),
        e("path", {
          d: "M176,200H88a56,56,0,0,1-56-56h0A56,56,0,0,1,88,88H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qW)
      ])) : o(i) === "duotone" ? (s(), r("g", GW, [
        e("polyline", {
          points: "176 136 224 88 176 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EW),
        e("path", {
          d: "M176,200H88a56,56,0,0,1-56-56h0A56,56,0,0,1,88,88H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OW)
      ])) : o(i) === "fill" ? (s(), r("g", IW, XW)) : o(i) === "light" ? (s(), r("g", JW, [
        e("polyline", {
          points: "176 136 224 88 176 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QW),
        e("path", {
          d: "M176,200H88a56,56,0,0,1-56-56h0A56,56,0,0,1,88,88H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YW)
      ])) : o(i) === "thin" ? (s(), r("g", oN, [
        e("polyline", {
          points: "176 136 224 88 176 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eN),
        e("path", {
          d: "M176,200H88a56,56,0,0,1-56-56h0A56,56,0,0,1,88,88H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tN)
      ])) : o(i) === "regular" ? (s(), r("g", nN, [
        e("polyline", {
          points: "176 136 224 88 176 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sN),
        e("path", {
          d: "M176,200H88a56,56,0,0,1-56-56h0A56,56,0,0,1,88,88H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rN)
      ])) : g("", !0)
    ], 16, DW));
  }
}), lN = ["width", "height", "fill", "transform"], dN = { key: 0 }, kN = ["stroke"], cN = ["stroke"], hN = { key: 1 }, uN = ["stroke"], aN = ["stroke"], _N = { key: 2 }, pN = /* @__PURE__ */ e("path", { d: "M207.4,115.1A8,8,0,0,1,200,120H136v96a8,8,0,0,1-16,0V120H56a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l72-72a8.1,8.1,0,0,1,11.4,0l72,72A8.4,8.4,0,0,1,207.4,115.1Z" }, null, -1), yN = [
  pN
], $N = { key: 3 }, wN = ["stroke"], fN = ["stroke"], gN = { key: 4 }, xN = ["stroke"], jN = ["stroke"], mN = { key: 5 }, MN = ["stroke"], vN = ["stroke"], SN = {
  name: "PhArrowUp"
}, uD1 = /* @__PURE__ */ $({
  ...SN,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", dN, [
        e("line", {
          x1: "128",
          y1: "216",
          x2: "128",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kN),
        e("polyline", {
          points: "56 112 128 40 200 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cN)
      ])) : o(i) === "duotone" ? (s(), r("g", hN, [
        e("line", {
          x1: "128",
          y1: "216",
          x2: "128",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uN),
        e("polyline", {
          points: "56 112 128 40 200 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aN)
      ])) : o(i) === "fill" ? (s(), r("g", _N, yN)) : o(i) === "light" ? (s(), r("g", $N, [
        e("line", {
          x1: "128",
          y1: "216",
          x2: "128",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wN),
        e("polyline", {
          points: "56 112 128 40 200 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fN)
      ])) : o(i) === "thin" ? (s(), r("g", gN, [
        e("line", {
          x1: "128",
          y1: "216",
          x2: "128",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xN),
        e("polyline", {
          points: "56 112 128 40 200 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jN)
      ])) : o(i) === "regular" ? (s(), r("g", mN, [
        e("line", {
          x1: "128",
          y1: "216",
          x2: "128",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MN),
        e("polyline", {
          points: "56 112 128 40 200 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vN)
      ])) : g("", !0)
    ], 16, lN));
  }
}), HN = ["width", "height", "fill", "transform"], AN = { key: 0 }, VN = ["stroke"], zN = ["stroke"], ZN = { key: 1 }, CN = ["stroke"], bN = ["stroke"], LN = { key: 2 }, BN = /* @__PURE__ */ e("path", { d: "M197.7,197.7a8.2,8.2,0,0,1-11.4,0L116,127.3,69.7,173.7A8.3,8.3,0,0,1,64,176a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,56,168V64a8,8,0,0,1,8-8H168a8,8,0,0,1,7.4,4.9,8.4,8.4,0,0,1-1.7,8.8L127.3,116l70.4,70.3A8.1,8.1,0,0,1,197.7,197.7Z" }, null, -1), PN = [
  BN
], WN = { key: 3 }, NN = ["stroke"], FN = ["stroke"], TN = { key: 4 }, DN = ["stroke"], RN = ["stroke"], UN = { key: 5 }, qN = ["stroke"], GN = ["stroke"], EN = {
  name: "PhArrowUpLeft"
}, aD1 = /* @__PURE__ */ $({
  ...EN,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", AN, [
        e("line", {
          x1: "192",
          y1: "192",
          x2: "64",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VN),
        e("polyline", {
          points: "168 64 64 64 64 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zN)
      ])) : o(i) === "duotone" ? (s(), r("g", ZN, [
        e("line", {
          x1: "192",
          y1: "192",
          x2: "64",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CN),
        e("polyline", {
          points: "168 64 64 64 64 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bN)
      ])) : o(i) === "fill" ? (s(), r("g", LN, PN)) : o(i) === "light" ? (s(), r("g", WN, [
        e("line", {
          x1: "192",
          y1: "192",
          x2: "64",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, NN),
        e("polyline", {
          points: "168 64 64 64 64 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FN)
      ])) : o(i) === "thin" ? (s(), r("g", TN, [
        e("line", {
          x1: "192",
          y1: "192",
          x2: "64",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, DN),
        e("polyline", {
          points: "168 64 64 64 64 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RN)
      ])) : o(i) === "regular" ? (s(), r("g", UN, [
        e("line", {
          x1: "192",
          y1: "192",
          x2: "64",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qN),
        e("polyline", {
          points: "168 64 64 64 64 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GN)
      ])) : g("", !0)
    ], 16, HN));
  }
}), ON = ["width", "height", "fill", "transform"], IN = { key: 0 }, KN = ["stroke"], XN = ["stroke"], JN = { key: 1 }, QN = ["stroke"], YN = ["stroke"], oF = { key: 2 }, eF = /* @__PURE__ */ e("path", { d: "M200,64V168a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3L140,127.3,69.7,197.7a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L128.7,116,82.3,69.7a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,88,56H192A8,8,0,0,1,200,64Z" }, null, -1), tF = [
  eF
], nF = { key: 3 }, sF = ["stroke"], rF = ["stroke"], iF = { key: 4 }, lF = ["stroke"], dF = ["stroke"], kF = { key: 5 }, cF = ["stroke"], hF = ["stroke"], uF = {
  name: "PhArrowUpRight"
}, _D1 = /* @__PURE__ */ $({
  ...uF,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", IN, [
        e("line", {
          x1: "64",
          y1: "192",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KN),
        e("polyline", {
          points: "88 64 192 64 192 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XN)
      ])) : o(i) === "duotone" ? (s(), r("g", JN, [
        e("line", {
          x1: "64",
          y1: "192",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QN),
        e("polyline", {
          points: "88 64 192 64 192 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YN)
      ])) : o(i) === "fill" ? (s(), r("g", oF, tF)) : o(i) === "light" ? (s(), r("g", nF, [
        e("line", {
          x1: "64",
          y1: "192",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sF),
        e("polyline", {
          points: "88 64 192 64 192 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rF)
      ])) : o(i) === "thin" ? (s(), r("g", iF, [
        e("line", {
          x1: "64",
          y1: "192",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lF),
        e("polyline", {
          points: "88 64 192 64 192 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dF)
      ])) : o(i) === "regular" ? (s(), r("g", kF, [
        e("line", {
          x1: "64",
          y1: "192",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cF),
        e("polyline", {
          points: "88 64 192 64 192 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hF)
      ])) : g("", !0)
    ], 16, ON));
  }
}), aF = ["width", "height", "fill", "transform"], _F = { key: 0 }, pF = ["stroke"], yF = ["stroke"], $F = ["stroke"], wF = ["stroke"], fF = { key: 1 }, gF = ["stroke"], xF = ["stroke"], jF = ["stroke"], mF = ["stroke"], MF = { key: 2 }, vF = /* @__PURE__ */ e("path", { d: "M232.2,51.7v48a8,8,0,0,1-8,8h-48a8,8,0,0,1-5.7-13.6l18.4-18.4-4.3-4.3a80.2,80.2,0,0,0-113.2,0,7.9,7.9,0,0,1-11.3,0,8,8,0,0,1,0-11.3,96.2,96.2,0,0,1,135.8,0l4.3,4.3,18.3-18.3a8,8,0,0,1,8.7-1.8A8.2,8.2,0,0,1,232.2,51.7ZM184.6,184.6a80.2,80.2,0,0,1-113.2,0l-4.3-4.3,18.4-18.4a8,8,0,0,0-5.7-13.6h-48a8,8,0,0,0-8,8v48a8.2,8.2,0,0,0,5,7.4,8,8,0,0,0,3,.6,7.8,7.8,0,0,0,5.7-2.4l18.3-18.3,4.3,4.3a96.1,96.1,0,0,0,135.8,0,8,8,0,0,0,0-11.3A7.9,7.9,0,0,0,184.6,184.6Z" }, null, -1), SF = [
  vF
], HF = { key: 3 }, AF = ["stroke"], VF = ["stroke"], zF = ["stroke"], ZF = ["stroke"], CF = { key: 4 }, bF = ["stroke"], LF = ["stroke"], BF = ["stroke"], PF = ["stroke"], WF = { key: 5 }, NF = ["stroke"], FF = ["stroke"], TF = ["stroke"], DF = ["stroke"], RF = {
  name: "PhArrowsClockwise"
}, pD1 = /* @__PURE__ */ $({
  ...RF,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", _F, [
        e("polyline", {
          points: "176.2 99.7 224.2 99.7 224.2 51.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pF),
        e("path", {
          d: "M65.8,65.8a87.9,87.9,0,0,1,124.4,0l34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yF),
        e("polyline", {
          points: "79.8 156.3 31.8 156.3 31.8 204.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $F),
        e("path", {
          d: "M190.2,190.2a87.9,87.9,0,0,1-124.4,0l-34-33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wF)
      ])) : o(i) === "duotone" ? (s(), r("g", fF, [
        e("polyline", {
          points: "176.2 99.7 224.2 99.7 224.2 51.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gF),
        e("path", {
          d: "M65.8,65.8a87.9,87.9,0,0,1,124.4,0l34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xF),
        e("polyline", {
          points: "79.8 156.3 31.8 156.3 31.8 204.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jF),
        e("path", {
          d: "M190.2,190.2a87.9,87.9,0,0,1-124.4,0l-34-33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mF)
      ])) : o(i) === "fill" ? (s(), r("g", MF, SF)) : o(i) === "light" ? (s(), r("g", HF, [
        e("polyline", {
          points: "176.2 99.7 224.2 99.7 224.2 51.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, AF),
        e("path", {
          d: "M65.8,65.8a87.9,87.9,0,0,1,124.4,0l34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VF),
        e("polyline", {
          points: "79.8 156.3 31.8 156.3 31.8 204.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zF),
        e("path", {
          d: "M190.2,190.2a87.9,87.9,0,0,1-124.4,0l-34-33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZF)
      ])) : o(i) === "thin" ? (s(), r("g", CF, [
        e("polyline", {
          points: "176.2 99.7 224.2 99.7 224.2 51.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bF),
        e("path", {
          d: "M65.8,65.8a87.9,87.9,0,0,1,124.4,0l34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LF),
        e("polyline", {
          points: "79.8 156.3 31.8 156.3 31.8 204.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, BF),
        e("path", {
          d: "M190.2,190.2a87.9,87.9,0,0,1-124.4,0l-34-33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PF)
      ])) : o(i) === "regular" ? (s(), r("g", WF, [
        e("polyline", {
          points: "176.2 99.7 224.2 99.7 224.2 51.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NF),
        e("path", {
          d: "M65.8,65.8a87.9,87.9,0,0,1,124.4,0l34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FF),
        e("polyline", {
          points: "79.8 156.3 31.8 156.3 31.8 204.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TF),
        e("path", {
          d: "M190.2,190.2a87.9,87.9,0,0,1-124.4,0l-34-33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DF)
      ])) : g("", !0)
    ], 16, aF));
  }
}), UF = ["width", "height", "fill", "transform"], qF = { key: 0 }, GF = ["stroke"], EF = ["stroke"], OF = ["stroke"], IF = ["stroke"], KF = { key: 1 }, XF = ["stroke"], JF = ["stroke"], QF = ["stroke"], YF = ["stroke"], oT = { key: 2 }, eT = /* @__PURE__ */ e("path", { d: "M79.8,107.7h-48a8,8,0,0,1-8-8v-48a8.2,8.2,0,0,1,5-7.4,8,8,0,0,1,8.7,1.8L55.8,64.4l4.3-4.3a96.2,96.2,0,0,1,135.8,0,8,8,0,0,1,0,11.3,7.9,7.9,0,0,1-11.3,0,80.2,80.2,0,0,0-113.2,0l-4.3,4.3L85.5,94.1a8,8,0,0,1-5.7,13.6Zm144.4,40.6h-48a8,8,0,0,0-5.7,13.6l18.4,18.4-4.3,4.3a80.2,80.2,0,0,1-113.2,0,7.9,7.9,0,0,0-11.3,0,8,8,0,0,0,0,11.3,96.1,96.1,0,0,0,135.8,0l4.3-4.3,18.3,18.3a7.8,7.8,0,0,0,5.7,2.4,8,8,0,0,0,3-.6,8.2,8.2,0,0,0,5-7.4v-48A8,8,0,0,0,224.2,148.3Z" }, null, -1), tT = [
  eT
], nT = { key: 3 }, sT = ["stroke"], rT = ["stroke"], iT = ["stroke"], lT = ["stroke"], dT = { key: 4 }, kT = ["stroke"], cT = ["stroke"], hT = ["stroke"], uT = ["stroke"], aT = { key: 5 }, _T = ["stroke"], pT = ["stroke"], yT = ["stroke"], $T = ["stroke"], wT = {
  name: "PhArrowsCounterClockwise"
}, yD1 = /* @__PURE__ */ $({
  ...wT,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", qF, [
        e("polyline", {
          points: "79.8 99.7 31.8 99.7 31.8 51.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GF),
        e("path", {
          d: "M190.2,65.8a87.9,87.9,0,0,0-124.4,0l-34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, EF),
        e("polyline", {
          points: "176.2 156.3 224.2 156.3 224.2 204.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OF),
        e("path", {
          d: "M65.8,190.2a87.9,87.9,0,0,0,124.4,0l34-33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IF)
      ])) : o(i) === "duotone" ? (s(), r("g", KF, [
        e("polyline", {
          points: "79.8 99.7 31.8 99.7 31.8 51.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XF),
        e("path", {
          d: "M190.2,65.8a87.9,87.9,0,0,0-124.4,0l-34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JF),
        e("polyline", {
          points: "176.2 156.3 224.2 156.3 224.2 204.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QF),
        e("path", {
          d: "M65.8,190.2a87.9,87.9,0,0,0,124.4,0l34-33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YF)
      ])) : o(i) === "fill" ? (s(), r("g", oT, tT)) : o(i) === "light" ? (s(), r("g", nT, [
        e("polyline", {
          points: "79.8 99.7 31.8 99.7 31.8 51.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sT),
        e("path", {
          d: "M190.2,65.8a87.9,87.9,0,0,0-124.4,0l-34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rT),
        e("polyline", {
          points: "176.2 156.3 224.2 156.3 224.2 204.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iT),
        e("path", {
          d: "M65.8,190.2a87.9,87.9,0,0,0,124.4,0l34-33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lT)
      ])) : o(i) === "thin" ? (s(), r("g", dT, [
        e("polyline", {
          points: "79.8 99.7 31.8 99.7 31.8 51.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kT),
        e("path", {
          d: "M190.2,65.8a87.9,87.9,0,0,0-124.4,0l-34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cT),
        e("polyline", {
          points: "176.2 156.3 224.2 156.3 224.2 204.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hT),
        e("path", {
          d: "M65.8,190.2a87.9,87.9,0,0,0,124.4,0l34-33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uT)
      ])) : o(i) === "regular" ? (s(), r("g", aT, [
        e("polyline", {
          points: "79.8 99.7 31.8 99.7 31.8 51.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _T),
        e("path", {
          d: "M190.2,65.8a87.9,87.9,0,0,0-124.4,0l-34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pT),
        e("polyline", {
          points: "176.2 156.3 224.2 156.3 224.2 204.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yT),
        e("path", {
          d: "M65.8,190.2a87.9,87.9,0,0,0,124.4,0l34-33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $T)
      ])) : g("", !0)
    ], 16, UF));
  }
}), fT = ["width", "height", "fill", "transform"], gT = { key: 0 }, xT = ["stroke"], jT = ["stroke"], mT = ["stroke"], MT = ["stroke"], vT = { key: 1 }, ST = ["stroke"], HT = ["stroke"], AT = ["stroke"], VT = ["stroke"], zT = { key: 2 }, ZT = /* @__PURE__ */ e("path", { d: "M119.4,172.9a8.4,8.4,0,0,1-1.7,8.8l-32,32a8.2,8.2,0,0,1-11.4,0l-32-32a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,48,168H72V48a8,8,0,0,1,16,0V168h24A8,8,0,0,1,119.4,172.9Zm94.3-98.6-32-32a8.1,8.1,0,0,0-11.4,0l-32,32a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,144,88h24V208a8,8,0,0,0,16,0V88h24a8,8,0,0,0,7.4-4.9A8.4,8.4,0,0,0,213.7,74.3Z" }, null, -1), CT = [
  ZT
], bT = { key: 3 }, LT = ["stroke"], BT = ["stroke"], PT = ["stroke"], WT = ["stroke"], NT = { key: 4 }, FT = ["stroke"], TT = ["stroke"], DT = ["stroke"], RT = ["stroke"], UT = { key: 5 }, qT = ["stroke"], GT = ["stroke"], ET = ["stroke"], OT = ["stroke"], IT = {
  name: "PhArrowsDownUp"
}, $D1 = /* @__PURE__ */ $({
  ...IT,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", gT, [
        e("polyline", {
          points: "112 176 80 208 48 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xT),
        e("line", {
          x1: "80",
          y1: "48",
          x2: "80",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jT),
        e("polyline", {
          points: "144 80 176 48 208 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mT),
        e("line", {
          x1: "176",
          y1: "208",
          x2: "176",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MT)
      ])) : o(i) === "duotone" ? (s(), r("g", vT, [
        e("polyline", {
          points: "112 176 80 208 48 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ST),
        e("line", {
          x1: "80",
          y1: "48",
          x2: "80",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HT),
        e("polyline", {
          points: "144 80 176 48 208 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AT),
        e("line", {
          x1: "176",
          y1: "208",
          x2: "176",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VT)
      ])) : o(i) === "fill" ? (s(), r("g", zT, CT)) : o(i) === "light" ? (s(), r("g", bT, [
        e("polyline", {
          points: "112 176 80 208 48 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LT),
        e("line", {
          x1: "80",
          y1: "48",
          x2: "80",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BT),
        e("polyline", {
          points: "144 80 176 48 208 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PT),
        e("line", {
          x1: "176",
          y1: "208",
          x2: "176",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WT)
      ])) : o(i) === "thin" ? (s(), r("g", NT, [
        e("polyline", {
          points: "112 176 80 208 48 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FT),
        e("line", {
          x1: "80",
          y1: "48",
          x2: "80",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, TT),
        e("polyline", {
          points: "144 80 176 48 208 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, DT),
        e("line", {
          x1: "176",
          y1: "208",
          x2: "176",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RT)
      ])) : o(i) === "regular" ? (s(), r("g", UT, [
        e("polyline", {
          points: "112 176 80 208 48 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qT),
        e("line", {
          x1: "80",
          y1: "48",
          x2: "80",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GT),
        e("polyline", {
          points: "144 80 176 48 208 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ET),
        e("line", {
          x1: "176",
          y1: "208",
          x2: "176",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OT)
      ])) : g("", !0)
    ], 16, fT));
  }
}), KT = ["width", "height", "fill", "transform"], XT = { key: 0 }, JT = ["stroke"], QT = ["stroke"], YT = ["stroke"], oD = { key: 1 }, eD = ["stroke"], tD = ["stroke"], nD = ["stroke"], sD = { key: 2 }, rD = /* @__PURE__ */ e("path", { d: "M237.7,133.7l-32,32A8.3,8.3,0,0,1,200,168a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,192,160V136H64v24a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-32-32a8.1,8.1,0,0,1,0-11.4l32-32a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,64,96v24H192V96a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l32,32A8.1,8.1,0,0,1,237.7,133.7Z" }, null, -1), iD = [
  rD
], lD = { key: 3 }, dD = ["stroke"], kD = ["stroke"], cD = ["stroke"], hD = { key: 4 }, uD = ["stroke"], aD = ["stroke"], _D = ["stroke"], pD = { key: 5 }, yD = ["stroke"], $D = ["stroke"], wD = ["stroke"], fD = {
  name: "PhArrowsHorizontal"
}, wD1 = /* @__PURE__ */ $({
  ...fD,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", XT, [
        e("polyline", {
          points: "60 96 28 128 60 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, JT),
        e("polyline", {
          points: "196 96 228 128 196 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, QT),
        e("line", {
          x1: "28",
          y1: "128",
          x2: "228",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, YT)
      ])) : o(i) === "duotone" ? (s(), r("g", oD, [
        e("polyline", {
          points: "56 96 24 128 56 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eD),
        e("polyline", {
          points: "200 96 232 128 200 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tD),
        e("line", {
          x1: "24",
          y1: "128",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nD)
      ])) : o(i) === "fill" ? (s(), r("g", sD, iD)) : o(i) === "light" ? (s(), r("g", lD, [
        e("polyline", {
          points: "56 96 24 128 56 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dD),
        e("polyline", {
          points: "200 96 232 128 200 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kD),
        e("line", {
          x1: "24",
          y1: "128",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cD)
      ])) : o(i) === "thin" ? (s(), r("g", hD, [
        e("polyline", {
          points: "56 96 24 128 56 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uD),
        e("polyline", {
          points: "200 96 232 128 200 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aD),
        e("line", {
          x1: "24",
          y1: "128",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _D)
      ])) : o(i) === "regular" ? (s(), r("g", pD, [
        e("polyline", {
          points: "56 96 24 128 56 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yD),
        e("polyline", {
          points: "200 96 232 128 200 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $D),
        e("line", {
          x1: "24",
          y1: "128",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wD)
      ])) : g("", !0)
    ], 16, KT));
  }
}), gD = ["width", "height", "fill", "transform"], xD = { key: 0 }, jD = ["stroke"], mD = ["stroke"], MD = ["stroke"], vD = ["stroke"], SD = ["stroke"], HD = ["stroke"], AD = ["stroke"], VD = ["stroke"], zD = { key: 1 }, ZD = ["stroke"], CD = ["stroke"], bD = ["stroke"], LD = ["stroke"], BD = ["stroke"], PD = ["stroke"], WD = ["stroke"], ND = ["stroke"], FD = { key: 2 }, TD = /* @__PURE__ */ e("path", { d: "M144,104V64a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7L172,72.7l30.3-30.4a8.1,8.1,0,0,1,11.4,11.4L183.3,84l14.4,14.3a8.4,8.4,0,0,1,1.7,8.8A8,8,0,0,1,192,112H152A8,8,0,0,1,144,104Zm-40,40H64a8,8,0,0,0-7.4,4.9,8.4,8.4,0,0,0,1.7,8.8L72.7,172,42.3,202.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L84,183.3l14.3,14.4A8.3,8.3,0,0,0,104,200a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,112,192V152A8,8,0,0,0,104,144Zm79.3,28,14.4-14.3a8.4,8.4,0,0,0,1.7-8.8A8,8,0,0,0,192,144H152a8,8,0,0,0-8,8v40a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3L172,183.3l30.3,30.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4ZM107.1,56.6a8.4,8.4,0,0,0-8.8,1.7L84,72.7,53.7,42.3A8.1,8.1,0,0,0,42.3,53.7L72.7,84,58.3,98.3a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,64,112h40a8,8,0,0,0,8-8V64A8,8,0,0,0,107.1,56.6Z" }, null, -1), DD = [
  TD
], RD = { key: 3 }, UD = ["stroke"], qD = ["stroke"], GD = ["stroke"], ED = ["stroke"], OD = ["stroke"], ID = ["stroke"], KD = ["stroke"], XD = ["stroke"], JD = { key: 4 }, QD = ["stroke"], YD = ["stroke"], oR = ["stroke"], eR = ["stroke"], tR = ["stroke"], nR = ["stroke"], sR = ["stroke"], rR = ["stroke"], iR = { key: 5 }, lR = ["stroke"], dR = ["stroke"], kR = ["stroke"], cR = ["stroke"], hR = ["stroke"], uR = ["stroke"], aR = ["stroke"], _R = ["stroke"], pR = {
  name: "PhArrowsIn"
}, fD1 = /* @__PURE__ */ $({
  ...pR,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xD, [
        e("polyline", {
          points: "192 104 152 104 152 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jD),
        e("line", {
          x1: "208",
          y1: "48",
          x2: "152",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mD),
        e("polyline", {
          points: "64 152 104 152 104 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MD),
        e("line", {
          x1: "48",
          y1: "208",
          x2: "104",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vD),
        e("polyline", {
          points: "152 192 152 152 192 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SD),
        e("line", {
          x1: "208",
          y1: "208",
          x2: "152",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HD),
        e("polyline", {
          points: "104 64 104 104 64 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, AD),
        e("line", {
          x1: "48",
          y1: "48",
          x2: "104",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VD)
      ])) : o(i) === "duotone" ? (s(), r("g", zD, [
        e("polyline", {
          points: "192 104 152 104 152 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZD),
        e("line", {
          x1: "208",
          y1: "48",
          x2: "152",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CD),
        e("polyline", {
          points: "64 152 104 152 104 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bD),
        e("line", {
          x1: "48",
          y1: "208",
          x2: "104",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LD),
        e("polyline", {
          points: "152 192 152 152 192 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BD),
        e("line", {
          x1: "208",
          y1: "208",
          x2: "152",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PD),
        e("polyline", {
          points: "104 64 104 104 64 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WD),
        e("line", {
          x1: "48",
          y1: "48",
          x2: "104",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ND)
      ])) : o(i) === "fill" ? (s(), r("g", FD, DD)) : o(i) === "light" ? (s(), r("g", RD, [
        e("polyline", {
          points: "192 104 152 104 152 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UD),
        e("line", {
          x1: "208",
          y1: "48",
          x2: "152",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qD),
        e("polyline", {
          points: "64 152 104 152 104 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GD),
        e("line", {
          x1: "48",
          y1: "208",
          x2: "104",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ED),
        e("polyline", {
          points: "152 192 152 152 192 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OD),
        e("line", {
          x1: "208",
          y1: "208",
          x2: "152",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ID),
        e("polyline", {
          points: "104 64 104 104 64 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KD),
        e("line", {
          x1: "48",
          y1: "48",
          x2: "104",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XD)
      ])) : o(i) === "thin" ? (s(), r("g", JD, [
        e("polyline", {
          points: "192 104 152 104 152 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QD),
        e("line", {
          x1: "208",
          y1: "48",
          x2: "152",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YD),
        e("polyline", {
          points: "64 152 104 152 104 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oR),
        e("line", {
          x1: "48",
          y1: "208",
          x2: "104",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eR),
        e("polyline", {
          points: "152 192 152 152 192 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tR),
        e("line", {
          x1: "208",
          y1: "208",
          x2: "152",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nR),
        e("polyline", {
          points: "104 64 104 104 64 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sR),
        e("line", {
          x1: "48",
          y1: "48",
          x2: "104",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rR)
      ])) : o(i) === "regular" ? (s(), r("g", iR, [
        e("polyline", {
          points: "192 104 152 104 152 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lR),
        e("line", {
          x1: "208",
          y1: "48",
          x2: "152",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dR),
        e("polyline", {
          points: "64 152 104 152 104 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kR),
        e("line", {
          x1: "48",
          y1: "208",
          x2: "104",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cR),
        e("polyline", {
          points: "152 192 152 152 192 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hR),
        e("line", {
          x1: "208",
          y1: "208",
          x2: "152",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uR),
        e("polyline", {
          points: "104 64 104 104 64 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aR),
        e("line", {
          x1: "48",
          y1: "48",
          x2: "104",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _R)
      ])) : g("", !0)
    ], 16, gD));
  }
}), yR = ["width", "height", "fill", "transform"], $R = { key: 0 }, wR = ["stroke"], fR = ["stroke"], gR = ["stroke"], xR = ["stroke"], jR = ["stroke"], mR = ["stroke"], MR = ["stroke"], vR = ["stroke"], SR = { key: 1 }, HR = ["stroke"], AR = ["stroke"], VR = ["stroke"], zR = ["stroke"], ZR = ["stroke"], CR = ["stroke"], bR = ["stroke"], LR = ["stroke"], BR = { key: 2 }, PR = /* @__PURE__ */ e("path", { d: "M161.9,182.6a8,8,0,0,1-5.6,13.7H136V232a8,8,0,0,1-16,0V196.3H99.7a8,8,0,0,1-5.6-13.7l28.2-28.3a8.1,8.1,0,0,1,11.4,0Zm-39.6-80.9a8.2,8.2,0,0,0,11.4,0l28.2-28.3a8,8,0,0,0-5.6-13.7H136V24a8,8,0,0,0-16,0V59.7H99.7a8,8,0,0,0-5.6,13.7Zm-20.6,20.6L73.4,94.1a8,8,0,0,0-13.7,5.6V120H24a8,8,0,0,0,0,16H59.7v20.3a8.2,8.2,0,0,0,5,7.4,7.7,7.7,0,0,0,3,.6,8,8,0,0,0,5.7-2.4l28.3-28.2A8.1,8.1,0,0,0,101.7,122.3ZM232,120H196.3V99.7a8,8,0,0,0-13.7-5.6l-28.3,28.2a8.1,8.1,0,0,0,0,11.4l28.3,28.2a8,8,0,0,0,5.7,2.4,7.7,7.7,0,0,0,3-.6,8.2,8.2,0,0,0,5-7.4V136H232a8,8,0,0,0,0-16Z" }, null, -1), WR = [
  PR
], NR = { key: 3 }, FR = ["stroke"], TR = ["stroke"], DR = ["stroke"], RR = ["stroke"], UR = ["stroke"], qR = ["stroke"], GR = ["stroke"], ER = ["stroke"], OR = { key: 4 }, IR = ["stroke"], KR = ["stroke"], XR = ["stroke"], JR = ["stroke"], QR = ["stroke"], YR = ["stroke"], oU = ["stroke"], eU = ["stroke"], tU = { key: 5 }, nU = ["stroke"], sU = ["stroke"], rU = ["stroke"], iU = ["stroke"], lU = ["stroke"], dU = ["stroke"], kU = ["stroke"], cU = ["stroke"], hU = {
  name: "PhArrowsInCardinal"
}, gD1 = /* @__PURE__ */ $({
  ...hU,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $R, [
        e("polyline", {
          points: "156.3 188.3 128 160 99.7 188.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wR),
        e("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fR),
        e("polyline", {
          points: "99.7 67.7 128 96 156.3 67.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gR),
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xR),
        e("polyline", {
          points: "67.7 156.3 96 128 67.7 99.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jR),
        e("line", {
          x1: "24",
          y1: "128",
          x2: "96",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mR),
        e("polyline", {
          points: "188.3 99.7 160 128 188.3 156.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MR),
        e("line", {
          x1: "232",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vR)
      ])) : o(i) === "duotone" ? (s(), r("g", SR, [
        e("polyline", {
          points: "156.3 188.3 128 160 99.7 188.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HR),
        e("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AR),
        e("polyline", {
          points: "99.7 67.7 128 96 156.3 67.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VR),
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zR),
        e("polyline", {
          points: "67.7 156.3 96 128 67.7 99.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZR),
        e("line", {
          x1: "24",
          y1: "128",
          x2: "96",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CR),
        e("polyline", {
          points: "188.3 99.7 160 128 188.3 156.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bR),
        e("line", {
          x1: "232",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LR)
      ])) : o(i) === "fill" ? (s(), r("g", BR, WR)) : o(i) === "light" ? (s(), r("g", NR, [
        e("polyline", {
          points: "156.3 188.3 128 160 99.7 188.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FR),
        e("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TR),
        e("polyline", {
          points: "99.7 67.7 128 96 156.3 67.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DR),
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RR),
        e("polyline", {
          points: "67.7 156.3 96 128 67.7 99.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UR),
        e("line", {
          x1: "24",
          y1: "128",
          x2: "96",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qR),
        e("polyline", {
          points: "188.3 99.7 160 128 188.3 156.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GR),
        e("line", {
          x1: "232",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ER)
      ])) : o(i) === "thin" ? (s(), r("g", OR, [
        e("polyline", {
          points: "156.3 188.3 128 160 99.7 188.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, IR),
        e("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KR),
        e("polyline", {
          points: "99.7 67.7 128 96 156.3 67.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XR),
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, JR),
        e("polyline", {
          points: "67.7 156.3 96 128 67.7 99.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QR),
        e("line", {
          x1: "24",
          y1: "128",
          x2: "96",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YR),
        e("polyline", {
          points: "188.3 99.7 160 128 188.3 156.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oU),
        e("line", {
          x1: "232",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eU)
      ])) : o(i) === "regular" ? (s(), r("g", tU, [
        e("polyline", {
          points: "156.3 188.3 128 160 99.7 188.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nU),
        e("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sU),
        e("polyline", {
          points: "99.7 67.7 128 96 156.3 67.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rU),
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iU),
        e("polyline", {
          points: "67.7 156.3 96 128 67.7 99.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lU),
        e("line", {
          x1: "24",
          y1: "128",
          x2: "96",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dU),
        e("polyline", {
          points: "188.3 99.7 160 128 188.3 156.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kU),
        e("line", {
          x1: "232",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cU)
      ])) : g("", !0)
    ], 16, yR));
  }
}), uU = ["width", "height", "fill", "transform"], aU = { key: 0 }, _U = ["stroke"], pU = ["stroke"], yU = ["stroke"], $U = ["stroke"], wU = ["stroke"], fU = { key: 1 }, gU = ["stroke"], xU = ["stroke"], jU = ["stroke"], mU = ["stroke"], MU = ["stroke"], vU = { key: 2 }, SU = /* @__PURE__ */ e("path", { d: "M136,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0ZM69.7,90.3a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,56,96v24H16a8,8,0,0,0,0,16H56v24a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l32-32a8.1,8.1,0,0,0,0-11.4ZM240,120H200V96a8,8,0,0,0-4.9-7.4,8.4,8.4,0,0,0-8.8,1.7l-32,32a8.1,8.1,0,0,0,0,11.4l32,32A8.3,8.3,0,0,0,192,168a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,200,160V136h40a8,8,0,0,0,0-16Z" }, null, -1), HU = [
  SU
], AU = { key: 3 }, VU = ["stroke"], zU = ["stroke"], ZU = ["stroke"], CU = ["stroke"], bU = ["stroke"], LU = { key: 4 }, BU = ["stroke"], PU = ["stroke"], WU = ["stroke"], NU = ["stroke"], FU = ["stroke"], TU = { key: 5 }, DU = ["stroke"], RU = ["stroke"], UU = ["stroke"], qU = ["stroke"], GU = ["stroke"], EU = {
  name: "PhArrowsInLineHorizontal"
}, xD1 = /* @__PURE__ */ $({
  ...EU,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", aU, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _U),
        e("line", {
          x1: "12",
          y1: "128",
          x2: "88",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pU),
        e("polyline", {
          points: "56 96 88 128 56 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yU),
        e("line", {
          x1: "244",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $U),
        e("polyline", {
          points: "200 160 168 128 200 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wU)
      ])) : o(i) === "duotone" ? (s(), r("g", fU, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gU),
        e("line", {
          x1: "16",
          y1: "128",
          x2: "96",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xU),
        e("polyline", {
          points: "64 96 96 128 64 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jU),
        e("line", {
          x1: "240",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mU),
        e("polyline", {
          points: "192 160 160 128 192 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MU)
      ])) : o(i) === "fill" ? (s(), r("g", vU, HU)) : o(i) === "light" ? (s(), r("g", AU, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VU),
        e("line", {
          x1: "16",
          y1: "128",
          x2: "96",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zU),
        e("polyline", {
          points: "64 96 96 128 64 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZU),
        e("line", {
          x1: "240",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, CU),
        e("polyline", {
          points: "192 160 160 128 192 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bU)
      ])) : o(i) === "thin" ? (s(), r("g", LU, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, BU),
        e("line", {
          x1: "16",
          y1: "128",
          x2: "96",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PU),
        e("polyline", {
          points: "64 96 96 128 64 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WU),
        e("line", {
          x1: "240",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, NU),
        e("polyline", {
          points: "192 160 160 128 192 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FU)
      ])) : o(i) === "regular" ? (s(), r("g", TU, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DU),
        e("line", {
          x1: "16",
          y1: "128",
          x2: "96",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RU),
        e("polyline", {
          points: "64 96 96 128 64 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UU),
        e("line", {
          x1: "240",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qU),
        e("polyline", {
          points: "192 160 160 128 192 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GU)
      ])) : g("", !0)
    ], 16, uU));
  }
}), OU = ["width", "height", "fill", "transform"], IU = { key: 0 }, KU = ["stroke"], XU = ["stroke"], JU = ["stroke"], QU = ["stroke"], YU = ["stroke"], oq = { key: 1 }, eq = ["stroke"], tq = ["stroke"], nq = ["stroke"], sq = ["stroke"], rq = ["stroke"], iq = { key: 2 }, lq = /* @__PURE__ */ e("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM122.3,101.7a8.2,8.2,0,0,0,11.4,0l32-32a8.4,8.4,0,0,0,1.7-8.8A8,8,0,0,0,160,56H136V16a8,8,0,0,0-16,0V56H96a8,8,0,0,0-7.4,4.9,8.4,8.4,0,0,0,1.7,8.8Zm11.4,52.6a8.1,8.1,0,0,0-11.4,0l-32,32a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,96,200h24v40a8,8,0,0,0,16,0V200h24a8,8,0,0,0,7.4-4.9,8.4,8.4,0,0,0-1.7-8.8Z" }, null, -1), dq = [
  lq
], kq = { key: 3 }, cq = ["stroke"], hq = ["stroke"], uq = ["stroke"], aq = ["stroke"], _q = ["stroke"], pq = { key: 4 }, yq = ["stroke"], $q = ["stroke"], wq = ["stroke"], fq = ["stroke"], gq = ["stroke"], xq = { key: 5 }, jq = ["stroke"], mq = ["stroke"], Mq = ["stroke"], vq = ["stroke"], Sq = ["stroke"], Hq = {
  name: "PhArrowsInLineVertical"
}, jD1 = /* @__PURE__ */ $({
  ...Hq,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", IU, [
        e("line", {
          x1: "216",
          y1: "128",
          x2: "40",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KU),
        e("line", {
          x1: "128",
          y1: "12",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XU),
        e("polyline", {
          points: "160 56 128 88 96 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, JU),
        e("line", {
          x1: "128",
          y1: "244",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, QU),
        e("polyline", {
          points: "96 200 128 168 160 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, YU)
      ])) : o(i) === "duotone" ? (s(), r("g", oq, [
        e("line", {
          x1: "216",
          y1: "128",
          x2: "40",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eq),
        e("line", {
          x1: "128",
          y1: "16",
          x2: "128",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tq),
        e("polyline", {
          points: "160 64 128 96 96 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nq),
        e("line", {
          x1: "128",
          y1: "240",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sq),
        e("polyline", {
          points: "96 192 128 160 160 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rq)
      ])) : o(i) === "fill" ? (s(), r("g", iq, dq)) : o(i) === "light" ? (s(), r("g", kq, [
        e("line", {
          x1: "216",
          y1: "128",
          x2: "40",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cq),
        e("line", {
          x1: "128",
          y1: "16",
          x2: "128",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hq),
        e("polyline", {
          points: "160 64 128 96 96 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uq),
        e("line", {
          x1: "128",
          y1: "240",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aq),
        e("polyline", {
          points: "96 192 128 160 160 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _q)
      ])) : o(i) === "thin" ? (s(), r("g", pq, [
        e("line", {
          x1: "216",
          y1: "128",
          x2: "40",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yq),
        e("line", {
          x1: "128",
          y1: "16",
          x2: "128",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $q),
        e("polyline", {
          points: "160 64 128 96 96 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wq),
        e("line", {
          x1: "128",
          y1: "240",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fq),
        e("polyline", {
          points: "96 192 128 160 160 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gq)
      ])) : o(i) === "regular" ? (s(), r("g", xq, [
        e("line", {
          x1: "216",
          y1: "128",
          x2: "40",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jq),
        e("line", {
          x1: "128",
          y1: "16",
          x2: "128",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mq),
        e("polyline", {
          points: "160 64 128 96 96 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mq),
        e("line", {
          x1: "128",
          y1: "240",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vq),
        e("polyline", {
          points: "96 192 128 160 160 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sq)
      ])) : g("", !0)
    ], 16, OU));
  }
}), Aq = ["width", "height", "fill", "transform"], Vq = { key: 0 }, zq = ["stroke"], Zq = ["stroke"], Cq = ["stroke"], bq = ["stroke"], Lq = { key: 1 }, Bq = ["stroke"], Pq = ["stroke"], Wq = ["stroke"], Nq = ["stroke"], Fq = { key: 2 }, Tq = /* @__PURE__ */ e("path", { d: "M213.7,53.7,187.3,80l18.4,18.3a8.4,8.4,0,0,1,1.7,8.8A8,8,0,0,1,200,112H152a8,8,0,0,1-8-8V56a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7L176,68.7l26.3-26.4a8.1,8.1,0,0,1,11.4,11.4ZM104,144H56a8,8,0,0,0-7.4,4.9,8.4,8.4,0,0,0,1.7,8.8L68.7,176,42.3,202.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L80,187.3l18.3,18.4A8.3,8.3,0,0,0,104,208a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,112,200V152A8,8,0,0,0,104,144Z" }, null, -1), Dq = [
  Tq
], Rq = { key: 3 }, Uq = ["stroke"], qq = ["stroke"], Gq = ["stroke"], Eq = ["stroke"], Oq = { key: 4 }, Iq = ["stroke"], Kq = ["stroke"], Xq = ["stroke"], Jq = ["stroke"], Qq = { key: 5 }, Yq = ["stroke"], oG = ["stroke"], eG = ["stroke"], tG = ["stroke"], nG = {
  name: "PhArrowsInSimple"
}, mD1 = /* @__PURE__ */ $({
  ...nG,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Vq, [
        e("polyline", {
          points: "152 56 152 104 200 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zq),
        e("line", {
          x1: "208",
          y1: "48",
          x2: "152",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zq),
        e("polyline", {
          points: "56 152 104 152 104 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cq),
        e("line", {
          x1: "48",
          y1: "208",
          x2: "104",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bq)
      ])) : o(i) === "duotone" ? (s(), r("g", Lq, [
        e("polyline", {
          points: "152 56 152 104 200 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bq),
        e("line", {
          x1: "208",
          y1: "48",
          x2: "152",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pq),
        e("polyline", {
          points: "56 152 104 152 104 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wq),
        e("line", {
          x1: "48",
          y1: "208",
          x2: "104",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nq)
      ])) : o(i) === "fill" ? (s(), r("g", Fq, Dq)) : o(i) === "light" ? (s(), r("g", Rq, [
        e("polyline", {
          points: "152 56 152 104 200 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Uq),
        e("line", {
          x1: "208",
          y1: "48",
          x2: "152",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qq),
        e("polyline", {
          points: "56 152 104 152 104 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gq),
        e("line", {
          x1: "48",
          y1: "208",
          x2: "104",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Eq)
      ])) : o(i) === "thin" ? (s(), r("g", Oq, [
        e("polyline", {
          points: "152 56 152 104 200 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Iq),
        e("line", {
          x1: "208",
          y1: "48",
          x2: "152",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kq),
        e("polyline", {
          points: "56 152 104 152 104 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xq),
        e("line", {
          x1: "48",
          y1: "208",
          x2: "104",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jq)
      ])) : o(i) === "regular" ? (s(), r("g", Qq, [
        e("polyline", {
          points: "152 56 152 104 200 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yq),
        e("line", {
          x1: "208",
          y1: "48",
          x2: "152",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oG),
        e("polyline", {
          points: "56 152 104 152 104 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eG),
        e("line", {
          x1: "48",
          y1: "208",
          x2: "104",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tG)
      ])) : g("", !0)
    ], 16, Aq));
  }
}), sG = ["width", "height", "fill", "transform"], rG = { key: 0 }, iG = ["stroke"], lG = ["stroke"], dG = ["stroke"], kG = ["stroke"], cG = { key: 1 }, hG = ["stroke"], uG = ["stroke"], aG = ["stroke"], _G = ["stroke"], pG = { key: 2 }, yG = /* @__PURE__ */ e("path", { d: "M213.7,181.7l-32,32A8.3,8.3,0,0,1,176,216a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,168,208V184H48a8,8,0,0,1,0-16H168V144a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l32,32A8.1,8.1,0,0,1,213.7,181.7Zm-139.4-64A8.3,8.3,0,0,0,80,120a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,88,112V88H208a8,8,0,0,0,0-16H88V48a8,8,0,0,0-4.9-7.4,8.4,8.4,0,0,0-8.8,1.7l-32,32a8.1,8.1,0,0,0,0,11.4Z" }, null, -1), $G = [
  yG
], wG = { key: 3 }, fG = ["stroke"], gG = ["stroke"], xG = ["stroke"], jG = ["stroke"], mG = { key: 4 }, MG = ["stroke"], vG = ["stroke"], SG = ["stroke"], HG = ["stroke"], AG = { key: 5 }, VG = ["stroke"], zG = ["stroke"], ZG = ["stroke"], CG = ["stroke"], bG = {
  name: "PhArrowsLeftRight"
}, MD1 = /* @__PURE__ */ $({
  ...bG,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", rG, [
        e("polyline", {
          points: "176 144 208 176 176 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iG),
        e("line", {
          x1: "48",
          y1: "176",
          x2: "208",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lG),
        e("polyline", {
          points: "80 112 48 80 80 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dG),
        e("line", {
          x1: "208",
          y1: "80",
          x2: "48",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kG)
      ])) : o(i) === "duotone" ? (s(), r("g", cG, [
        e("polyline", {
          points: "176 144 208 176 176 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hG),
        e("line", {
          x1: "48",
          y1: "176",
          x2: "208",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uG),
        e("polyline", {
          points: "80 112 48 80 80 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aG),
        e("line", {
          x1: "208",
          y1: "80",
          x2: "48",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _G)
      ])) : o(i) === "fill" ? (s(), r("g", pG, $G)) : o(i) === "light" ? (s(), r("g", wG, [
        e("polyline", {
          points: "176 144 208 176 176 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fG),
        e("line", {
          x1: "48",
          y1: "176",
          x2: "208",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gG),
        e("polyline", {
          points: "80 112 48 80 80 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xG),
        e("line", {
          x1: "208",
          y1: "80",
          x2: "48",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jG)
      ])) : o(i) === "thin" ? (s(), r("g", mG, [
        e("polyline", {
          points: "176 144 208 176 176 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MG),
        e("line", {
          x1: "48",
          y1: "176",
          x2: "208",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vG),
        e("polyline", {
          points: "80 112 48 80 80 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SG),
        e("line", {
          x1: "208",
          y1: "80",
          x2: "48",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HG)
      ])) : o(i) === "regular" ? (s(), r("g", AG, [
        e("polyline", {
          points: "176 144 208 176 176 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VG),
        e("line", {
          x1: "48",
          y1: "176",
          x2: "208",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zG),
        e("polyline", {
          points: "80 112 48 80 80 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZG),
        e("line", {
          x1: "208",
          y1: "80",
          x2: "48",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CG)
      ])) : g("", !0)
    ], 16, sG));
  }
}), LG = ["width", "height", "fill", "transform"], BG = { key: 0 }, PG = ["stroke"], WG = ["stroke"], NG = ["stroke"], FG = ["stroke"], TG = ["stroke"], DG = ["stroke"], RG = ["stroke"], UG = ["stroke"], qG = { key: 1 }, GG = ["stroke"], EG = ["stroke"], OG = ["stroke"], IG = ["stroke"], KG = ["stroke"], XG = ["stroke"], JG = ["stroke"], QG = ["stroke"], YG = { key: 2 }, oE = /* @__PURE__ */ e("path", { d: "M216,48V88a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3L188,79.3l-30.3,30.4a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L176.7,68,162.3,53.7a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,168,40h40A8,8,0,0,1,216,48ZM98.3,146.3,68,176.7,53.7,162.3a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,40,168v40a8,8,0,0,0,8,8H88a8,8,0,0,0,7.4-4.9,8.4,8.4,0,0,0-1.7-8.8L79.3,188l30.4-30.3a8.1,8.1,0,0,0-11.4-11.4Zm112.8,14.3a8.4,8.4,0,0,0-8.8,1.7L188,176.7l-30.3-30.4a8.1,8.1,0,0,0-11.4,11.4L176.7,188l-14.4,14.3a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,168,216h40a8,8,0,0,0,8-8V168A8,8,0,0,0,211.1,160.6ZM79.3,68,93.7,53.7a8.4,8.4,0,0,0,1.7-8.8A8,8,0,0,0,88,40H48a8,8,0,0,0-8,8V88a8,8,0,0,0,4.9,7.4A8.5,8.5,0,0,0,48,96a8.3,8.3,0,0,0,5.7-2.3L68,79.3l30.3,30.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4Z" }, null, -1), eE = [
  oE
], tE = { key: 3 }, nE = ["stroke"], sE = ["stroke"], rE = ["stroke"], iE = ["stroke"], lE = ["stroke"], dE = ["stroke"], kE = ["stroke"], cE = ["stroke"], hE = { key: 4 }, uE = ["stroke"], aE = ["stroke"], _E = ["stroke"], pE = ["stroke"], yE = ["stroke"], $E = ["stroke"], wE = ["stroke"], fE = ["stroke"], gE = { key: 5 }, xE = ["stroke"], jE = ["stroke"], mE = ["stroke"], ME = ["stroke"], vE = ["stroke"], SE = ["stroke"], HE = ["stroke"], AE = ["stroke"], VE = {
  name: "PhArrowsOut"
}, vD1 = /* @__PURE__ */ $({
  ...VE,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", BG, [
        e("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PG),
        e("line", {
          x1: "152",
          y1: "104",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WG),
        e("polyline", {
          points: "88 208 48 208 48 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NG),
        e("line", {
          x1: "104",
          y1: "152",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FG),
        e("polyline", {
          points: "208 168 208 208 168 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TG),
        e("line", {
          x1: "152",
          y1: "152",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DG),
        e("polyline", {
          points: "48 88 48 48 88 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RG),
        e("line", {
          x1: "104",
          y1: "104",
          x2: "48",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, UG)
      ])) : o(i) === "duotone" ? (s(), r("g", qG, [
        e("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GG),
        e("line", {
          x1: "152",
          y1: "104",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EG),
        e("polyline", {
          points: "88 208 48 208 48 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OG),
        e("line", {
          x1: "104",
          y1: "152",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IG),
        e("polyline", {
          points: "208 168 208 208 168 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KG),
        e("line", {
          x1: "152",
          y1: "152",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XG),
        e("polyline", {
          points: "48 88 48 48 88 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JG),
        e("line", {
          x1: "104",
          y1: "104",
          x2: "48",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QG)
      ])) : o(i) === "fill" ? (s(), r("g", YG, eE)) : o(i) === "light" ? (s(), r("g", tE, [
        e("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nE),
        e("line", {
          x1: "152",
          y1: "104",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sE),
        e("polyline", {
          points: "88 208 48 208 48 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rE),
        e("line", {
          x1: "104",
          y1: "152",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iE),
        e("polyline", {
          points: "208 168 208 208 168 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lE),
        e("line", {
          x1: "152",
          y1: "152",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dE),
        e("polyline", {
          points: "48 88 48 48 88 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kE),
        e("line", {
          x1: "104",
          y1: "104",
          x2: "48",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cE)
      ])) : o(i) === "thin" ? (s(), r("g", hE, [
        e("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uE),
        e("line", {
          x1: "152",
          y1: "104",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aE),
        e("polyline", {
          points: "88 208 48 208 48 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _E),
        e("line", {
          x1: "104",
          y1: "152",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pE),
        e("polyline", {
          points: "208 168 208 208 168 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yE),
        e("line", {
          x1: "152",
          y1: "152",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $E),
        e("polyline", {
          points: "48 88 48 48 88 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wE),
        e("line", {
          x1: "104",
          y1: "104",
          x2: "48",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fE)
      ])) : o(i) === "regular" ? (s(), r("g", gE, [
        e("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xE),
        e("line", {
          x1: "152",
          y1: "104",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jE),
        e("polyline", {
          points: "88 208 48 208 48 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mE),
        e("line", {
          x1: "104",
          y1: "152",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ME),
        e("polyline", {
          points: "208 168 208 208 168 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vE),
        e("line", {
          x1: "152",
          y1: "152",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SE),
        e("polyline", {
          points: "48 88 48 48 88 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HE),
        e("line", {
          x1: "104",
          y1: "104",
          x2: "48",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AE)
      ])) : g("", !0)
    ], 16, LG));
  }
}), zE = ["width", "height", "fill", "transform"], ZE = { key: 0 }, CE = ["stroke"], bE = ["stroke"], LE = ["stroke"], BE = ["stroke"], PE = ["stroke"], WE = ["stroke"], NE = ["stroke"], FE = ["stroke"], TE = { key: 1 }, DE = ["stroke"], RE = ["stroke"], UE = ["stroke"], qE = ["stroke"], GE = ["stroke"], EE = ["stroke"], OE = ["stroke"], IE = ["stroke"], KE = { key: 2 }, XE = /* @__PURE__ */ e("path", { d: "M163.7,200.7a8.1,8.1,0,0,1-1.8,8.7l-28.2,28.3a8.2,8.2,0,0,1-11.4,0L94.1,209.4a8,8,0,0,1,5.6-13.7H120V160a8,8,0,0,1,16,0v35.7h20.3A8.2,8.2,0,0,1,163.7,200.7ZM99.7,60.3H120V96a8,8,0,0,0,16,0V60.3h20.3a8,8,0,0,0,5.6-13.7L133.7,18.3a8.2,8.2,0,0,0-11.4,0L94.1,46.6a8,8,0,0,0,5.6,13.7ZM96,136a8,8,0,0,0,0-16H60.3V99.7a8,8,0,0,0-13.7-5.6L18.3,122.3a8.1,8.1,0,0,0,0,11.4l28.3,28.2a8,8,0,0,0,5.7,2.4,7.7,7.7,0,0,0,3-.6,8.2,8.2,0,0,0,5-7.4V136Zm141.7-13.7L209.4,94.1a8,8,0,0,0-13.7,5.6V120H160a8,8,0,0,0,0,16h35.7v20.3a8.2,8.2,0,0,0,5,7.4,7.7,7.7,0,0,0,3,.6,8,8,0,0,0,5.7-2.4l28.3-28.2A8.1,8.1,0,0,0,237.7,122.3Z" }, null, -1), JE = [
  XE
], QE = { key: 3 }, YE = ["stroke"], oO = ["stroke"], eO = ["stroke"], tO = ["stroke"], nO = ["stroke"], sO = ["stroke"], rO = ["stroke"], iO = ["stroke"], lO = { key: 4 }, dO = ["stroke"], kO = ["stroke"], cO = ["stroke"], hO = ["stroke"], uO = ["stroke"], aO = ["stroke"], _O = ["stroke"], pO = ["stroke"], yO = { key: 5 }, $O = ["stroke"], wO = ["stroke"], fO = ["stroke"], gO = ["stroke"], xO = ["stroke"], jO = ["stroke"], mO = ["stroke"], MO = ["stroke"], vO = {
  name: "PhArrowsOutCardinal"
}, SD1 = /* @__PURE__ */ $({
  ...vO,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ZE, [
        e("polyline", {
          points: "156.3 203.7 128 232 99.7 203.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CE),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bE),
        e("polyline", {
          points: "99.7 52.3 128 24 156.3 52.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LE),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BE),
        e("polyline", {
          points: "52.3 156.3 24 128 52.3 99.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PE),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "24",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WE),
        e("polyline", {
          points: "203.7 99.7 232 128 203.7 156.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NE),
        e("line", {
          x1: "160",
          y1: "128",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FE)
      ])) : o(i) === "duotone" ? (s(), r("g", TE, [
        e("polyline", {
          points: "156.3 203.7 128 232 99.7 203.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DE),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RE),
        e("polyline", {
          points: "99.7 52.3 128 24 156.3 52.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UE),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qE),
        e("polyline", {
          points: "52.3 156.3 24 128 52.3 99.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GE),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "24",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EE),
        e("polyline", {
          points: "203.7 99.7 232 128 203.7 156.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OE),
        e("line", {
          x1: "160",
          y1: "128",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IE)
      ])) : o(i) === "fill" ? (s(), r("g", KE, JE)) : o(i) === "light" ? (s(), r("g", QE, [
        e("polyline", {
          points: "156.3 203.7 128 232 99.7 203.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YE),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oO),
        e("polyline", {
          points: "99.7 52.3 128 24 156.3 52.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eO),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tO),
        e("polyline", {
          points: "52.3 156.3 24 128 52.3 99.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nO),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "24",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sO),
        e("polyline", {
          points: "203.7 99.7 232 128 203.7 156.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rO),
        e("line", {
          x1: "160",
          y1: "128",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iO)
      ])) : o(i) === "thin" ? (s(), r("g", lO, [
        e("polyline", {
          points: "156.3 203.7 128 232 99.7 203.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dO),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kO),
        e("polyline", {
          points: "99.7 52.3 128 24 156.3 52.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cO),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hO),
        e("polyline", {
          points: "52.3 156.3 24 128 52.3 99.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uO),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "24",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aO),
        e("polyline", {
          points: "203.7 99.7 232 128 203.7 156.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _O),
        e("line", {
          x1: "160",
          y1: "128",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pO)
      ])) : o(i) === "regular" ? (s(), r("g", yO, [
        e("polyline", {
          points: "156.3 203.7 128 232 99.7 203.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $O),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wO),
        e("polyline", {
          points: "99.7 52.3 128 24 156.3 52.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fO),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gO),
        e("polyline", {
          points: "52.3 156.3 24 128 52.3 99.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xO),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "24",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jO),
        e("polyline", {
          points: "203.7 99.7 232 128 203.7 156.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mO),
        e("line", {
          x1: "160",
          y1: "128",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MO)
      ])) : g("", !0)
    ], 16, zE));
  }
}), SO = ["width", "height", "fill", "transform"], HO = { key: 0 }, AO = ["stroke"], VO = ["stroke"], zO = ["stroke"], ZO = ["stroke"], CO = ["stroke"], bO = { key: 1 }, LO = ["stroke"], BO = ["stroke"], PO = ["stroke"], WO = ["stroke"], NO = ["stroke"], FO = { key: 2 }, TO = /* @__PURE__ */ e("path", { d: "M136,40V216a8,8,0,0,1-16,0V40a8,8,0,0,1,16,0ZM96,120H56V96a8,8,0,0,0-4.9-7.4,8.4,8.4,0,0,0-8.8,1.7l-32,32a8.1,8.1,0,0,0,0,11.4l32,32A8.3,8.3,0,0,0,48,168a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,56,160V136H96a8,8,0,0,0,0-16Zm149.7,2.3-32-32a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,200,96v24H160a8,8,0,0,0,0,16h40v24a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l32-32A8.1,8.1,0,0,0,245.7,122.3Z" }, null, -1), DO = [
  TO
], RO = { key: 3 }, UO = ["stroke"], qO = ["stroke"], GO = ["stroke"], EO = ["stroke"], OO = ["stroke"], IO = { key: 4 }, KO = ["stroke"], XO = ["stroke"], JO = ["stroke"], QO = ["stroke"], YO = ["stroke"], oI = { key: 5 }, eI = ["stroke"], tI = ["stroke"], nI = ["stroke"], sI = ["stroke"], rI = ["stroke"], iI = {
  name: "PhArrowsOutLineHorizontal"
}, HD1 = /* @__PURE__ */ $({
  ...iI,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", HO, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, AO),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "12",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VO),
        e("polyline", {
          points: "44 96 12 128 44 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zO),
        e("line", {
          x1: "168",
          y1: "128",
          x2: "244",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZO),
        e("polyline", {
          points: "212 160 244 128 212 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CO)
      ])) : o(i) === "duotone" ? (s(), r("g", bO, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LO),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "16",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BO),
        e("polyline", {
          points: "48 160 16 128 48 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PO),
        e("line", {
          x1: "160",
          y1: "128",
          x2: "240",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WO),
        e("polyline", {
          points: "208 96 240 128 208 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NO)
      ])) : o(i) === "fill" ? (s(), r("g", FO, DO)) : o(i) === "light" ? (s(), r("g", RO, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UO),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "16",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qO),
        e("polyline", {
          points: "48 160 16 128 48 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GO),
        e("line", {
          x1: "160",
          y1: "128",
          x2: "240",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, EO),
        e("polyline", {
          points: "208 96 240 128 208 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OO)
      ])) : o(i) === "thin" ? (s(), r("g", IO, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KO),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "16",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XO),
        e("polyline", {
          points: "48 160 16 128 48 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, JO),
        e("line", {
          x1: "160",
          y1: "128",
          x2: "240",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QO),
        e("polyline", {
          points: "208 96 240 128 208 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YO)
      ])) : o(i) === "regular" ? (s(), r("g", oI, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eI),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "16",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tI),
        e("polyline", {
          points: "48 160 16 128 48 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nI),
        e("line", {
          x1: "160",
          y1: "128",
          x2: "240",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sI),
        e("polyline", {
          points: "208 96 240 128 208 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rI)
      ])) : g("", !0)
    ], 16, SO));
  }
}), lI = ["width", "height", "fill", "transform"], dI = { key: 0 }, kI = ["stroke"], cI = ["stroke"], hI = ["stroke"], uI = ["stroke"], aI = ["stroke"], _I = { key: 1 }, pI = ["stroke"], yI = ["stroke"], $I = ["stroke"], wI = ["stroke"], fI = ["stroke"], gI = { key: 2 }, xI = /* @__PURE__ */ e("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM96,56h24V96a8,8,0,0,0,16,0V56h24a8,8,0,0,0,7.4-4.9,8.4,8.4,0,0,0-1.7-8.8l-32-32a8.1,8.1,0,0,0-11.4,0l-32,32a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,96,56Zm64,144H136V160a8,8,0,0,0-16,0v40H96a8,8,0,0,0-7.4,4.9,8.4,8.4,0,0,0,1.7,8.8l32,32a8.2,8.2,0,0,0,11.4,0l32-32a8.4,8.4,0,0,0,1.7-8.8A8,8,0,0,0,160,200Z" }, null, -1), jI = [
  xI
], mI = { key: 3 }, MI = ["stroke"], vI = ["stroke"], SI = ["stroke"], HI = ["stroke"], AI = ["stroke"], VI = { key: 4 }, zI = ["stroke"], ZI = ["stroke"], CI = ["stroke"], bI = ["stroke"], LI = ["stroke"], BI = { key: 5 }, PI = ["stroke"], WI = ["stroke"], NI = ["stroke"], FI = ["stroke"], TI = ["stroke"], DI = {
  name: "PhArrowsOutLineVertical"
}, AD1 = /* @__PURE__ */ $({
  ...DI,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", dI, [
        e("line", {
          x1: "216",
          y1: "128",
          x2: "40",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kI),
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cI),
        e("polyline", {
          points: "160 44 128 12 96 44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hI),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "244",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uI),
        e("polyline", {
          points: "96 212 128 244 160 212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aI)
      ])) : o(i) === "duotone" ? (s(), r("g", _I, [
        e("line", {
          x1: "216",
          y1: "128",
          x2: "40",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pI),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yI),
        e("polyline", {
          points: "96 48 128 16 160 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $I),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wI),
        e("polyline", {
          points: "160 208 128 240 96 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fI)
      ])) : o(i) === "fill" ? (s(), r("g", gI, jI)) : o(i) === "light" ? (s(), r("g", mI, [
        e("line", {
          x1: "216",
          y1: "128",
          x2: "40",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, MI),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vI),
        e("polyline", {
          points: "96 48 128 16 160 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, SI),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HI),
        e("polyline", {
          points: "160 208 128 240 96 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, AI)
      ])) : o(i) === "thin" ? (s(), r("g", VI, [
        e("line", {
          x1: "216",
          y1: "128",
          x2: "40",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zI),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZI),
        e("polyline", {
          points: "96 48 128 16 160 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CI),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bI),
        e("polyline", {
          points: "160 208 128 240 96 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LI)
      ])) : o(i) === "regular" ? (s(), r("g", BI, [
        e("line", {
          x1: "216",
          y1: "128",
          x2: "40",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PI),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WI),
        e("polyline", {
          points: "96 48 128 16 160 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NI),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FI),
        e("polyline", {
          points: "160 208 128 240 96 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TI)
      ])) : g("", !0)
    ], 16, lI));
  }
}), RI = ["width", "height", "fill", "transform"], UI = { key: 0 }, qI = ["stroke"], GI = ["stroke"], EI = ["stroke"], OI = ["stroke"], II = { key: 1 }, KI = ["stroke"], XI = ["stroke"], JI = ["stroke"], QI = ["stroke"], YI = { key: 2 }, oK = /* @__PURE__ */ e("path", { d: "M216,48V96a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3L184,83.3l-26.3,26.4a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L172.7,72,154.3,53.7a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,160,40h48A8,8,0,0,1,216,48ZM98.3,146.3,72,172.7,53.7,154.3a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,40,160v48a8,8,0,0,0,8,8H96a8,8,0,0,0,7.4-4.9,8.4,8.4,0,0,0-1.7-8.8L83.3,184l26.4-26.3a8.1,8.1,0,0,0-11.4-11.4Z" }, null, -1), eK = [
  oK
], tK = { key: 3 }, nK = ["stroke"], sK = ["stroke"], rK = ["stroke"], iK = ["stroke"], lK = { key: 4 }, dK = ["stroke"], kK = ["stroke"], cK = ["stroke"], hK = ["stroke"], uK = { key: 5 }, aK = ["stroke"], _K = ["stroke"], pK = ["stroke"], yK = ["stroke"], $K = {
  name: "PhArrowsOutSimple"
}, VD1 = /* @__PURE__ */ $({
  ...$K,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", UI, [
        e("polyline", {
          points: "160 48 208 48 208 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qI),
        e("line", {
          x1: "152",
          y1: "104",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GI),
        e("polyline", {
          points: "96 208 48 208 48 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, EI),
        e("line", {
          x1: "104",
          y1: "152",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OI)
      ])) : o(i) === "duotone" ? (s(), r("g", II, [
        e("polyline", {
          points: "160 48 208 48 208 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KI),
        e("line", {
          x1: "152",
          y1: "104",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XI),
        e("polyline", {
          points: "96 208 48 208 48 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JI),
        e("line", {
          x1: "104",
          y1: "152",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QI)
      ])) : o(i) === "fill" ? (s(), r("g", YI, eK)) : o(i) === "light" ? (s(), r("g", tK, [
        e("polyline", {
          points: "160 48 208 48 208 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nK),
        e("line", {
          x1: "152",
          y1: "104",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sK),
        e("polyline", {
          points: "96 208 48 208 48 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rK),
        e("line", {
          x1: "104",
          y1: "152",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iK)
      ])) : o(i) === "thin" ? (s(), r("g", lK, [
        e("polyline", {
          points: "160 48 208 48 208 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dK),
        e("line", {
          x1: "152",
          y1: "104",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kK),
        e("polyline", {
          points: "96 208 48 208 48 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cK),
        e("line", {
          x1: "104",
          y1: "152",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hK)
      ])) : o(i) === "regular" ? (s(), r("g", uK, [
        e("polyline", {
          points: "160 48 208 48 208 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aK),
        e("line", {
          x1: "152",
          y1: "104",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _K),
        e("polyline", {
          points: "96 208 48 208 48 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pK),
        e("line", {
          x1: "104",
          y1: "152",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yK)
      ])) : g("", !0)
    ], 16, RI));
  }
}), wK = ["width", "height", "fill", "transform"], fK = { key: 0 }, gK = ["stroke"], xK = ["stroke"], jK = ["stroke"], mK = { key: 1 }, MK = ["stroke"], vK = ["stroke"], SK = ["stroke"], HK = { key: 2 }, AK = /* @__PURE__ */ e("path", { d: "M167.4,196.9a8.4,8.4,0,0,1-1.7,8.8l-32,32a8.2,8.2,0,0,1-11.4,0l-32-32a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,96,192h24V64H96a8,8,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l32-32a8.1,8.1,0,0,1,11.4,0l32,32a8.4,8.4,0,0,1,1.7,8.8A8,8,0,0,1,160,64H136V192h24A8,8,0,0,1,167.4,196.9Z" }, null, -1), VK = [
  AK
], zK = { key: 3 }, ZK = ["stroke"], CK = ["stroke"], bK = ["stroke"], LK = { key: 4 }, BK = ["stroke"], PK = ["stroke"], WK = ["stroke"], NK = { key: 5 }, FK = ["stroke"], TK = ["stroke"], DK = ["stroke"], RK = {
  name: "PhArrowsVertical"
}, zD1 = /* @__PURE__ */ $({
  ...RK,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", fK, [
        e("polyline", {
          points: "96 60 128 28 160 60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gK),
        e("line", {
          x1: "128",
          y1: "228",
          x2: "128",
          y2: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xK),
        e("polyline", {
          points: "160 196 128 228 96 196",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jK)
      ])) : o(i) === "duotone" ? (s(), r("g", mK, [
        e("polyline", {
          points: "96 56 128 24 160 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MK),
        e("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vK),
        e("polyline", {
          points: "160 200 128 232 96 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SK)
      ])) : o(i) === "fill" ? (s(), r("g", HK, VK)) : o(i) === "light" ? (s(), r("g", zK, [
        e("polyline", {
          points: "96 56 128 24 160 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZK),
        e("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, CK),
        e("polyline", {
          points: "160 200 128 232 96 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bK)
      ])) : o(i) === "thin" ? (s(), r("g", LK, [
        e("polyline", {
          points: "96 56 128 24 160 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, BK),
        e("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PK),
        e("polyline", {
          points: "160 200 128 232 96 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WK)
      ])) : o(i) === "regular" ? (s(), r("g", NK, [
        e("polyline", {
          points: "96 56 128 24 160 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FK),
        e("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TK),
        e("polyline", {
          points: "160 200 128 232 96 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DK)
      ])) : g("", !0)
    ], 16, wK));
  }
}), UK = ["width", "height", "fill", "transform"], qK = { key: 0 }, GK = ["stroke"], EK = ["stroke"], OK = ["stroke"], IK = ["stroke"], KK = { key: 1 }, XK = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "48",
  width: "192",
  height: "160",
  rx: "8",
  opacity: "0.2"
}, null, -1), JK = ["stroke"], QK = ["stroke"], YK = ["stroke"], oX = ["stroke"], eX = { key: 2 }, tX = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM180,168H76a8,8,0,0,1,0-16H180a8,8,0,0,1,0,16Zm0-32H76a8,8,0,0,1,0-16H180a8,8,0,0,1,0,16Zm0-32H76a8,8,0,0,1,0-16H180a8,8,0,0,1,0,16Z" }, null, -1), nX = [
  tX
], sX = { key: 3 }, rX = ["stroke"], iX = ["stroke"], lX = ["stroke"], dX = ["stroke"], kX = { key: 4 }, cX = ["stroke"], hX = ["stroke"], uX = ["stroke"], aX = ["stroke"], _X = { key: 5 }, pX = ["stroke"], yX = ["stroke"], $X = ["stroke"], wX = ["stroke"], fX = {
  name: "PhArticle"
}, ZD1 = /* @__PURE__ */ $({
  ...fX,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", qK, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GK),
        e("line", {
          x1: "76",
          y1: "92",
          x2: "180",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, EK),
        e("line", {
          x1: "76",
          y1: "128",
          x2: "180",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OK),
        e("line", {
          x1: "76",
          y1: "164",
          x2: "180",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IK)
      ])) : o(i) === "duotone" ? (s(), r("g", KK, [
        XK,
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JK),
        e("line", {
          x1: "76",
          y1: "96",
          x2: "180",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QK),
        e("line", {
          x1: "76",
          y1: "128",
          x2: "180",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YK),
        e("line", {
          x1: "76",
          y1: "160",
          x2: "180",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oX)
      ])) : o(i) === "fill" ? (s(), r("g", eX, nX)) : o(i) === "light" ? (s(), r("g", sX, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rX),
        e("line", {
          x1: "76",
          y1: "96",
          x2: "180",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iX),
        e("line", {
          x1: "76",
          y1: "128",
          x2: "180",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lX),
        e("line", {
          x1: "76",
          y1: "160",
          x2: "180",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dX)
      ])) : o(i) === "thin" ? (s(), r("g", kX, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cX),
        e("line", {
          x1: "76",
          y1: "96",
          x2: "180",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hX),
        e("line", {
          x1: "76",
          y1: "128",
          x2: "180",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uX),
        e("line", {
          x1: "76",
          y1: "160",
          x2: "180",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aX)
      ])) : o(i) === "regular" ? (s(), r("g", _X, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pX),
        e("line", {
          x1: "76",
          y1: "96",
          x2: "180",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yX),
        e("line", {
          x1: "76",
          y1: "128",
          x2: "180",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $X),
        e("line", {
          x1: "76",
          y1: "160",
          x2: "180",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wX)
      ])) : g("", !0)
    ], 16, UK));
  }
}), gX = ["width", "height", "fill", "transform"], xX = { key: 0 }, jX = ["stroke"], mX = ["stroke"], MX = ["stroke"], vX = ["stroke"], SX = ["stroke"], HX = ["stroke"], AX = ["stroke"], VX = ["stroke"], zX = ["stroke"], ZX = { key: 1 }, CX = ["stroke"], bX = ["stroke"], LX = ["stroke"], BX = ["stroke"], PX = ["stroke"], WX = ["stroke"], NX = ["stroke"], FX = ["stroke"], TX = ["stroke"], DX = { key: 2 }, RX = /* @__PURE__ */ e("path", { d: "M56,136a8,8,0,0,1-8,8H24a8,8,0,0,1,0-16h8V64H24a8,8,0,0,1,0-16H40a8,8,0,0,1,6.8,3.8L80,104.9l33.2-53.1A8,8,0,0,1,120,48h16a8,8,0,0,1,0,16h-8v64h8a8,8,0,0,1,0,16H112a8,8,0,0,1,0-16V83.9L86.8,124.2a8,8,0,0,1-13.6,0L48,83.9V128A8,8,0,0,1,56,136Zm112-24h72a8,8,0,0,0,0-16H168a8,8,0,0,0,0,16Zm72,16H168a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0,32H72a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Zm0,32H72a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Z" }, null, -1), UX = [
  RX
], qX = { key: 3 }, GX = ["stroke"], EX = ["stroke"], OX = ["stroke"], IX = ["stroke"], KX = ["stroke"], XX = ["stroke"], JX = ["stroke"], QX = ["stroke"], YX = ["stroke"], oJ = { key: 4 }, eJ = ["stroke"], tJ = ["stroke"], nJ = ["stroke"], sJ = ["stroke"], rJ = ["stroke"], iJ = ["stroke"], lJ = ["stroke"], dJ = ["stroke"], kJ = ["stroke"], cJ = { key: 5 }, hJ = ["stroke"], uJ = ["stroke"], aJ = ["stroke"], _J = ["stroke"], pJ = ["stroke"], yJ = ["stroke"], $J = ["stroke"], wJ = ["stroke"], fJ = ["stroke"], gJ = ["stroke"], xJ = ["stroke"], jJ = ["stroke"], mJ = ["stroke"], MJ = ["stroke"], vJ = ["stroke"], SJ = ["stroke"], HJ = ["stroke"], AJ = ["stroke"], VJ = {
  name: "PhArticleMedium"
}, CD1 = /* @__PURE__ */ $({
  ...VJ,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xX, [
        e("line", {
          x1: "24",
          y1: "48",
          x2: "40",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jX),
        e("line", {
          x1: "120",
          y1: "48",
          x2: "136",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mX),
        e("line", {
          x1: "24",
          y1: "128",
          x2: "48",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MX),
        e("line", {
          x1: "112",
          y1: "128",
          x2: "136",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vX),
        e("line", {
          x1: "176",
          y1: "88",
          x2: "240",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SX),
        e("line", {
          x1: "176",
          y1: "128",
          x2: "240",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HX),
        e("line", {
          x1: "72",
          y1: "168",
          x2: "240",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, AX),
        e("line", {
          x1: "72",
          y1: "208",
          x2: "240",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VX),
        e("polyline", {
          points: "40 128 40 48 80 112 120 48 120 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zX)
      ])) : o(i) === "duotone" ? (s(), r("g", ZX, [
        e("line", {
          x1: "24",
          y1: "56",
          x2: "40",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CX),
        e("line", {
          x1: "120",
          y1: "56",
          x2: "136",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bX),
        e("line", {
          x1: "24",
          y1: "136",
          x2: "48",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LX),
        e("line", {
          x1: "112",
          y1: "136",
          x2: "136",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BX),
        e("line", {
          x1: "168",
          y1: "104",
          x2: "240",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PX),
        e("line", {
          x1: "168",
          y1: "136",
          x2: "240",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WX),
        e("line", {
          x1: "72",
          y1: "168",
          x2: "240",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NX),
        e("line", {
          x1: "72",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FX),
        e("polyline", {
          points: "40 136 40 56 80 120 120 56 120 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TX)
      ])) : o(i) === "fill" ? (s(), r("g", DX, UX)) : o(i) === "light" ? (s(), r("g", qX, [
        e("line", {
          x1: "24",
          y1: "56",
          x2: "40",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GX),
        e("line", {
          x1: "120",
          y1: "56",
          x2: "136",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, EX),
        e("line", {
          x1: "24",
          y1: "136",
          x2: "48",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OX),
        e("line", {
          x1: "112",
          y1: "136",
          x2: "136",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IX),
        e("line", {
          x1: "168",
          y1: "104",
          x2: "240",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KX),
        e("line", {
          x1: "168",
          y1: "136",
          x2: "240",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XX),
        e("line", {
          x1: "72",
          y1: "168",
          x2: "240",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JX),
        e("line", {
          x1: "72",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QX),
        e("polyline", {
          points: "40 136 40 56 80 120 120 56 120 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YX)
      ])) : o(i) === "thin" ? (s(), r("g", oJ, [
        e("line", {
          x1: "24",
          y1: "56",
          x2: "40",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eJ),
        e("line", {
          x1: "120",
          y1: "56",
          x2: "136",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tJ),
        e("line", {
          x1: "24",
          y1: "136",
          x2: "48",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nJ),
        e("line", {
          x1: "112",
          y1: "136",
          x2: "136",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sJ),
        e("line", {
          x1: "168",
          y1: "104",
          x2: "240",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rJ),
        e("line", {
          x1: "168",
          y1: "136",
          x2: "240",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iJ),
        e("line", {
          x1: "72",
          y1: "168",
          x2: "240",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lJ),
        e("line", {
          x1: "72",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dJ),
        e("polyline", {
          points: "40 136 40 56 80 120 120 56 120 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kJ)
      ])) : o(i) === "regular" ? (s(), r("g", cJ, [
        e("line", {
          x1: "24.1",
          y1: "56",
          x2: "40.1",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hJ),
        e("line", {
          x1: "120.1",
          y1: "56",
          x2: "136.1",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uJ),
        e("line", {
          x1: "24.1",
          y1: "136",
          x2: "48.1",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aJ),
        e("line", {
          x1: "112.1",
          y1: "136",
          x2: "136.1",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _J),
        e("line", {
          x1: "168",
          y1: "104",
          x2: "240",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pJ),
        e("line", {
          x1: "168.1",
          y1: "136",
          x2: "240.1",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yJ),
        e("line", {
          x1: "72",
          y1: "168",
          x2: "240",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $J),
        e("line", {
          x1: "72",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wJ),
        e("polyline", {
          points: "40.1 136 40.1 56 80.1 120 120.1 56 120.1 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fJ),
        e("line", {
          x1: "24",
          y1: "56",
          x2: "40",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gJ),
        e("line", {
          x1: "120",
          y1: "56",
          x2: "136",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xJ),
        e("line", {
          x1: "24",
          y1: "136",
          x2: "48",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jJ),
        e("line", {
          x1: "112",
          y1: "136",
          x2: "136",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mJ),
        e("line", {
          x1: "168",
          y1: "104",
          x2: "240",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MJ),
        e("line", {
          x1: "168",
          y1: "136",
          x2: "240",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vJ),
        e("line", {
          x1: "72",
          y1: "168",
          x2: "240",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SJ),
        e("line", {
          x1: "72",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HJ),
        e("polyline", {
          points: "40 136 40 56 80 120 120 56 120 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AJ)
      ])) : g("", !0)
    ], 16, gX));
  }
}), zJ = ["width", "height", "fill", "transform"], ZJ = { key: 0 }, CJ = ["stroke"], bJ = ["stroke"], LJ = ["stroke"], BJ = ["stroke"], PJ = ["stroke"], WJ = ["stroke"], NJ = ["stroke"], FJ = { key: 1 }, TJ = ["stroke"], DJ = ["stroke"], RJ = ["stroke"], UJ = ["stroke"], qJ = ["stroke"], GJ = ["stroke"], EJ = ["stroke"], OJ = { key: 2 }, IJ = /* @__PURE__ */ e("path", { d: "M152,104a8,8,0,0,1,8-8h80a8,8,0,0,1,0,16H160A8,8,0,0,1,152,104Zm88,24H160a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Zm0,32H160a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Zm0,32H72a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM79.9,176A55.9,55.9,0,0,1,30.4,93.9,28,28,0,0,1,47.9,44a8.2,8.2,0,0,1,4.3,1.2L114,83.8A12,12,0,0,0,111.9,60a8,8,0,0,1,0-16,28,28,0,0,1,0,56,7.9,7.9,0,0,1-4.2-1.2l-30-18.7a40,40,0,0,0-5.8,79.1V114.5a8,8,0,0,1,8-8h0a8,8,0,0,1,8,8v44.7a40,40,0,0,0,30.9-29.5,7.9,7.9,0,0,1,9.6-5.8,8,8,0,0,1,5.9,9.6A56,56,0,0,1,79.9,176Zm-40-95.1A56.3,56.3,0,0,1,58.7,68.2l-12.8-8A12,12,0,0,0,35.9,72,11.8,11.8,0,0,0,39.9,80.9Z" }, null, -1), KJ = [
  IJ
], XJ = { key: 3 }, JJ = ["stroke"], QJ = ["stroke"], YJ = ["stroke"], oQ = ["stroke"], eQ = ["stroke"], tQ = ["stroke"], nQ = ["stroke"], sQ = { key: 4 }, rQ = ["stroke"], iQ = ["stroke"], lQ = ["stroke"], dQ = ["stroke"], kQ = ["stroke"], cQ = ["stroke"], hQ = ["stroke"], uQ = { key: 5 }, aQ = ["stroke"], _Q = ["stroke"], pQ = ["stroke"], yQ = ["stroke"], $Q = ["stroke"], wQ = ["stroke"], fQ = ["stroke"], gQ = {
  name: "PhArticleNyTimes"
}, bD1 = /* @__PURE__ */ $({
  ...gQ,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ZJ, [
        e("line", {
          x1: "176",
          y1: "88",
          x2: "240",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CJ),
        e("line", {
          x1: "176",
          y1: "128",
          x2: "240",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bJ),
        e("line", {
          x1: "176",
          y1: "168",
          x2: "240",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LJ),
        e("line", {
          x1: "72",
          y1: "208",
          x2: "240",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BJ),
        e("path", {
          d: "M126.5,131.6A48,48,0,1,1,79.9,72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PJ),
        e("line", {
          x1: "79.9",
          y1: "114.5",
          x2: "79.9",
          y2: "167.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WJ),
        e("path", {
          d: "M111.9,52a20,20,0,0,1,0,40l-64-40a20,20,0,0,0-6.2,39",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NJ)
      ])) : o(i) === "duotone" ? (s(), r("g", FJ, [
        e("line", {
          x1: "160",
          y1: "104",
          x2: "240",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TJ),
        e("line", {
          x1: "160",
          y1: "136",
          x2: "240",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DJ),
        e("line", {
          x1: "160",
          y1: "168",
          x2: "240",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RJ),
        e("line", {
          x1: "72",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UJ),
        e("path", {
          d: "M126.5,131.6A48,48,0,1,1,79.9,72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qJ),
        e("line", {
          x1: "79.9",
          y1: "114.5",
          x2: "79.9",
          y2: "167.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GJ),
        e("path", {
          d: "M111.9,52a20,20,0,0,1,0,40l-64-40a20,20,0,0,0-6.2,39",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EJ)
      ])) : o(i) === "fill" ? (s(), r("g", OJ, KJ)) : o(i) === "light" ? (s(), r("g", XJ, [
        e("line", {
          x1: "160",
          y1: "104",
          x2: "240",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JJ),
        e("line", {
          x1: "160",
          y1: "136",
          x2: "240",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QJ),
        e("line", {
          x1: "160",
          y1: "168",
          x2: "240",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YJ),
        e("line", {
          x1: "72",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oQ),
        e("path", {
          d: "M126.5,131.6A48,48,0,1,1,79.9,72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eQ),
        e("line", {
          x1: "79.9",
          y1: "114.5",
          x2: "79.9",
          y2: "167.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tQ),
        e("path", {
          d: "M111.9,52a20,20,0,0,1,0,40l-64-40a20,20,0,0,0-6.2,39",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nQ)
      ])) : o(i) === "thin" ? (s(), r("g", sQ, [
        e("line", {
          x1: "160",
          y1: "104",
          x2: "240",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rQ),
        e("line", {
          x1: "160",
          y1: "136",
          x2: "240",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iQ),
        e("line", {
          x1: "160",
          y1: "168",
          x2: "240",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lQ),
        e("line", {
          x1: "72",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dQ),
        e("path", {
          d: "M126.5,131.6A48,48,0,1,1,79.9,72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kQ),
        e("line", {
          x1: "79.9",
          y1: "114.5",
          x2: "79.9",
          y2: "167.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cQ),
        e("path", {
          d: "M111.9,52a20,20,0,0,1,0,40l-64-40a20,20,0,0,0-6.2,39",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hQ)
      ])) : o(i) === "regular" ? (s(), r("g", uQ, [
        e("line", {
          x1: "160",
          y1: "104",
          x2: "240",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aQ),
        e("line", {
          x1: "160",
          y1: "136",
          x2: "240",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Q),
        e("line", {
          x1: "160",
          y1: "168",
          x2: "240",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pQ),
        e("line", {
          x1: "72",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yQ),
        e("path", {
          d: "M126.5,131.6A48,48,0,1,1,79.9,72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Q),
        e("line", {
          x1: "79.9",
          y1: "114.5",
          x2: "79.9",
          y2: "167.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wQ),
        e("path", {
          d: "M111.9,52a20,20,0,0,1,0,40l-64-40a20,20,0,0,0-6.2,39",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fQ)
      ])) : g("", !0)
    ], 16, zJ));
  }
}), xQ = ["width", "height", "fill", "transform"], jQ = { key: 0 }, mQ = ["stroke"], MQ = ["stroke"], vQ = ["stroke"], SQ = { key: 1 }, HQ = ["stroke"], AQ = ["stroke"], VQ = ["stroke"], zQ = { key: 2 }, ZQ = /* @__PURE__ */ e("path", { d: "M208.2,165.1,144,128l64.2-37.1a8,8,0,1,0-8-13.8l-64.2,37V40a8,8,0,0,0-16,0v74.1l-64.2-37a8,8,0,0,0-8,13.8L112,128,47.8,165.1A8,8,0,0,0,44.9,176a7.7,7.7,0,0,0,6.9,4,7.3,7.3,0,0,0,4-1.1l64.2-37V216a8,8,0,0,0,16,0V141.9l64.2,37a7.3,7.3,0,0,0,4,1.1,7.7,7.7,0,0,0,6.9-4A8,8,0,0,0,208.2,165.1Z" }, null, -1), CQ = [
  ZQ
], bQ = { key: 3 }, LQ = ["stroke"], BQ = ["stroke"], PQ = ["stroke"], WQ = { key: 4 }, NQ = ["stroke"], FQ = ["stroke"], TQ = ["stroke"], DQ = { key: 5 }, RQ = ["stroke"], UQ = ["stroke"], qQ = ["stroke"], GQ = {
  name: "PhAsterisk"
}, LD1 = /* @__PURE__ */ $({
  ...GQ,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", jQ, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mQ),
        e("line", {
          x1: "51.8",
          y1: "84",
          x2: "204.2",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MQ),
        e("line", {
          x1: "51.8",
          y1: "172",
          x2: "204.2",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vQ)
      ])) : o(i) === "duotone" ? (s(), r("g", SQ, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HQ),
        e("line", {
          x1: "51.8",
          y1: "84",
          x2: "204.2",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AQ),
        e("line", {
          x1: "51.8",
          y1: "172",
          x2: "204.2",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VQ)
      ])) : o(i) === "fill" ? (s(), r("g", zQ, CQ)) : o(i) === "light" ? (s(), r("g", bQ, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LQ),
        e("line", {
          x1: "51.8",
          y1: "84",
          x2: "204.2",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BQ),
        e("line", {
          x1: "51.8",
          y1: "172",
          x2: "204.2",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PQ)
      ])) : o(i) === "thin" ? (s(), r("g", WQ, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, NQ),
        e("line", {
          x1: "51.8",
          y1: "84",
          x2: "204.2",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FQ),
        e("line", {
          x1: "51.8",
          y1: "172",
          x2: "204.2",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, TQ)
      ])) : o(i) === "regular" ? (s(), r("g", DQ, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RQ),
        e("line", {
          x1: "51.8",
          y1: "84",
          x2: "204.2",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UQ),
        e("line", {
          x1: "51.8",
          y1: "172",
          x2: "204.2",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qQ)
      ])) : g("", !0)
    ], 16, xQ));
  }
}), EQ = ["width", "height", "fill", "transform"], OQ = { key: 0 }, IQ = ["stroke"], KQ = ["stroke"], XQ = ["stroke"], JQ = ["stroke"], QQ = ["stroke"], YQ = { key: 1 }, oY = ["stroke"], eY = ["stroke"], tY = ["stroke"], nY = ["stroke"], sY = ["stroke"], rY = { key: 2 }, iY = /* @__PURE__ */ e("path", { d: "M214.2,108.4l-73.3,23.8,45.3,62.3a8,8,0,1,1-12.9,9.4L128,141.6,82.7,203.9a8,8,0,1,1-12.9-9.4l45.3-62.3L41.8,108.4a8,8,0,0,1,5-15.2L120,117V40a8,8,0,0,1,16,0v77l73.2-23.8a8,8,0,0,1,5,15.2Z" }, null, -1), lY = [
  iY
], dY = { key: 3 }, kY = ["stroke"], cY = ["stroke"], hY = ["stroke"], uY = ["stroke"], aY = ["stroke"], _Y = { key: 4 }, pY = ["stroke"], yY = ["stroke"], $Y = ["stroke"], wY = ["stroke"], fY = ["stroke"], gY = { key: 5 }, xY = ["stroke"], jY = ["stroke"], mY = ["stroke"], MY = ["stroke"], vY = ["stroke"], SY = {
  name: "PhAsteriskSimple"
}, BD1 = /* @__PURE__ */ $({
  ...SY,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", OQ, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IQ),
        e("line", {
          x1: "44.3",
          y1: "100.8",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KQ),
        e("line", {
          x1: "76.3",
          y1: "199.2",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XQ),
        e("line", {
          x1: "179.7",
          y1: "199.2",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, JQ),
        e("line", {
          x1: "211.7",
          y1: "100.8",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, QQ)
      ])) : o(i) === "duotone" ? (s(), r("g", YQ, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oY),
        e("line", {
          x1: "44.3",
          y1: "100.8",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eY),
        e("line", {
          x1: "76.3",
          y1: "199.2",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tY),
        e("line", {
          x1: "179.7",
          y1: "199.2",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nY),
        e("line", {
          x1: "211.7",
          y1: "100.8",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sY)
      ])) : o(i) === "fill" ? (s(), r("g", rY, lY)) : o(i) === "light" ? (s(), r("g", dY, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kY),
        e("line", {
          x1: "44.3",
          y1: "100.8",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cY),
        e("line", {
          x1: "76.3",
          y1: "199.2",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hY),
        e("line", {
          x1: "179.7",
          y1: "199.2",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uY),
        e("line", {
          x1: "211.7",
          y1: "100.8",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aY)
      ])) : o(i) === "thin" ? (s(), r("g", _Y, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pY),
        e("line", {
          x1: "44.3",
          y1: "100.8",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yY),
        e("line", {
          x1: "76.3",
          y1: "199.2",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $Y),
        e("line", {
          x1: "179.7",
          y1: "199.2",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wY),
        e("line", {
          x1: "211.7",
          y1: "100.8",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fY)
      ])) : o(i) === "regular" ? (s(), r("g", gY, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xY),
        e("line", {
          x1: "44.3",
          y1: "100.8",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jY),
        e("line", {
          x1: "76.3",
          y1: "199.2",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mY),
        e("line", {
          x1: "179.7",
          y1: "199.2",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MY),
        e("line", {
          x1: "211.7",
          y1: "100.8",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vY)
      ])) : g("", !0)
    ], 16, EQ));
  }
}), HY = ["width", "height", "fill", "transform"], AY = { key: 0 }, VY = ["stroke"], zY = ["stroke"], ZY = { key: 1 }, CY = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), bY = ["stroke"], LY = ["stroke"], BY = { key: 2 }, PY = /* @__PURE__ */ e("path", { d: "M128,24A104.1,104.1,0,0,0,24.1,132.1c2.1,54.7,47,98.8,101.8,99.9a104,104,0,0,0,91.4-50.8,4,4,0,0,0-4.1-6,52.5,52.5,0,0,1-9.2.8c-18.3,0-28.5-8-33.9-14.7a43.9,43.9,0,0,1-3.4-5A48,48,0,1,1,128,80a47.4,47.4,0,0,1,32,12.3v-4a8.2,8.2,0,0,1,7.5-8.3,8,8,0,0,1,8.5,8v40c0,14.6,4.9,32,28,32s27.6-16.2,28-30.5V128A104.1,104.1,0,0,0,128,24Z" }, null, -1), WY = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "32"
}, null, -1), NY = [
  PY,
  WY
], FY = { key: 3 }, TY = ["stroke"], DY = ["stroke"], RY = { key: 4 }, UY = ["stroke"], qY = ["stroke"], GY = { key: 5 }, EY = ["stroke"], OY = ["stroke"], IY = {
  name: "PhAt"
}, PD1 = /* @__PURE__ */ $({
  ...IY,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", AY, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VY),
        e("path", {
          d: "M181.1,208A96,96,0,1,1,224,128c0,22.1-8,40-28,40s-28-17.9-28-40V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zY)
      ])) : o(i) === "duotone" ? (s(), r("g", ZY, [
        CY,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bY),
        e("path", {
          d: "M181.1,208A96,96,0,1,1,224,128c0,22.1-8,40-28,40s-28-17.9-28-40V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LY)
      ])) : o(i) === "fill" ? (s(), r("g", BY, NY)) : o(i) === "light" ? (s(), r("g", FY, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TY),
        e("path", {
          d: "M181.1,208A96,96,0,1,1,224,128c0,22.1-8,40-28,40s-28-17.9-28-40V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DY)
      ])) : o(i) === "thin" ? (s(), r("g", RY, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, UY),
        e("path", {
          d: "M181.1,208A96,96,0,1,1,224,128c0,22.1-8,40-28,40s-28-17.9-28-40V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qY)
      ])) : o(i) === "regular" ? (s(), r("g", GY, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EY),
        e("path", {
          d: "M181.1,208A96,96,0,1,1,224,128c0,22.1-8,40-28,40s-28-17.9-28-40V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OY)
      ])) : g("", !0)
    ], 16, HY));
  }
}), KY = ["width", "height", "fill", "transform"], XY = { key: 0 }, JY = ["stroke"], QY = ["stroke"], YY = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "16"
}, null, -1), ooo = { key: 1 }, eoo = /* @__PURE__ */ e("ellipse", {
  cx: "128",
  cy: "128",
  rx: "44",
  ry: "116",
  transform: "translate(-53 128) rotate(-45)",
  opacity: "0.2"
}, null, -1), too = ["stroke"], noo = ["stroke"], soo = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), roo = { key: 2 }, ioo = /* @__PURE__ */ e("path", { d: "M196.1,128a195.3,195.3,0,0,0,19.2-32.7c11.1-24.6,11.2-44.2.4-55C198.2,22.9,162.5,35.4,128,60,93.5,35.4,57.8,22.9,40.3,40.3c-10.8,10.8-10.7,30.4.4,55A195.3,195.3,0,0,0,59.9,128a195.3,195.3,0,0,0-19.2,32.7c-11.1,24.6-11.2,44.2-.4,55,5.6,5.6,13.1,8.1,21.9,8.1,18.4,0,42.4-11.1,65.8-27.8,23.4,16.7,47.4,27.8,65.8,27.8,8.8,0,16.3-2.5,21.9-8.1,10.8-10.8,10.7-30.4-.4-55A195.3,195.3,0,0,0,196.1,128Zm-2.3-79.7c4.8,0,8.4,1.1,10.6,3.3,5.6,5.7,4.2,19.5-3.7,37.1a169.7,169.7,0,0,1-14.8,25.9c-6.4-7.9-13.5-15.7-21.1-23.4s-15.4-14.5-23.5-21.1C163.2,55.2,182,48.3,193.8,48.3ZM176.1,128a277.3,277.3,0,0,1-22.6,25.5A314.1,314.1,0,0,1,128,176.2a314.1,314.1,0,0,1-25.5-22.7A277.3,277.3,0,0,1,79.9,128a277.3,277.3,0,0,1,22.6-25.5A314.1,314.1,0,0,1,128,79.8a314.1,314.1,0,0,1,25.5,22.7A277.3,277.3,0,0,1,176.1,128ZM55.3,88.7C47.4,71.1,46,57.3,51.6,51.6c2.2-2.2,5.8-3.3,10.6-3.3,11.8,0,30.6,6.9,52.5,21.8-8.1,6.6-16,13.7-23.5,21.1s-14.7,15.5-21.1,23.4A169.7,169.7,0,0,1,55.3,88.7ZM51.6,204.4c-5.6-5.7-4.2-19.5,3.7-37.1a169.7,169.7,0,0,1,14.8-25.9c6.4,7.9,13.5,15.7,21.1,23.4s15.4,14.5,23.5,21.1C83.9,206.8,59.2,212,51.6,204.4Zm152.8,0c-2.2,2.2-5.8,3.3-10.6,3.3-11.8,0-30.6-6.9-52.5-21.8,8.1-6.6,16-13.7,23.5-21.1s14.7-15.5,21.1-23.4a169.7,169.7,0,0,1,14.8,25.9C208.6,184.9,210,198.7,204.4,204.4ZM140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Z" }, null, -1), loo = [
  ioo
], doo = { key: 3 }, koo = ["stroke"], coo = ["stroke"], hoo = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "10"
}, null, -1), uoo = { key: 4 }, aoo = ["stroke"], _oo = ["stroke"], poo = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "8"
}, null, -1), yoo = { key: 5 }, $oo = ["stroke"], woo = ["stroke"], foo = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), goo = {
  name: "PhAtom"
}, WD1 = /* @__PURE__ */ $({
  ...goo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", XY, [
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "44",
          ry: "116",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, JY),
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "116",
          ry: "44",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, QY),
        YY
      ])) : o(i) === "duotone" ? (s(), r("g", ooo, [
        eoo,
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "44",
          ry: "116",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, too),
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "116",
          ry: "44",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, noo),
        soo
      ])) : o(i) === "fill" ? (s(), r("g", roo, loo)) : o(i) === "light" ? (s(), r("g", doo, [
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "44",
          ry: "116",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, koo),
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "116",
          ry: "44",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, coo),
        hoo
      ])) : o(i) === "thin" ? (s(), r("g", uoo, [
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "44",
          ry: "116",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aoo),
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "116",
          ry: "44",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _oo),
        poo
      ])) : o(i) === "regular" ? (s(), r("g", yoo, [
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "44",
          ry: "116",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $oo),
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "116",
          ry: "44",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, woo),
        foo
      ])) : g("", !0)
    ], 16, KY));
  }
}), xoo = ["width", "height", "fill", "transform"], joo = { key: 0 }, moo = ["stroke"], Moo = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "128",
  r: "16"
}, null, -1), voo = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "128",
  r: "16"
}, null, -1), Soo = ["stroke"], Hoo = ["stroke"], Aoo = { key: 1 }, Voo = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), zoo = ["stroke"], Zoo = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "128",
  r: "12"
}, null, -1), Coo = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "128",
  r: "12"
}, null, -1), boo = ["stroke"], Loo = ["stroke"], Boo = { key: 2 }, Poo = /* @__PURE__ */ e("path", { d: "M134.2,24.2a3.9,3.9,0,0,0-3.6,1.8C120.3,41.6,120,55.9,120,56a7.9,7.9,0,0,0,9.7,7.8c3.7-.7,6.2-4.2,6.3-8a8.1,8.1,0,0,1,8.8-7.8,8.2,8.2,0,0,1,7.2,8.3,24,24,0,0,1-48-.3c0-.6.1-10.8,5.4-24a4,4,0,0,0-4.6-5.4A104.1,104.1,0,0,0,24.1,131.7C26,186.8,71.2,231.1,126.3,232a104,104,0,0,0,7.9-207.8ZM80,128a12,12,0,1,1,12,12A12,12,0,0,1,80,128Zm79,46.7a56.3,56.3,0,0,1-62,0,8.1,8.1,0,0,1-2.2-11.1,8,8,0,0,1,11.1-2.3,39.8,39.8,0,0,0,44.2,0,8,8,0,0,1,11.1,2.3A8.1,8.1,0,0,1,159,174.7Zm5-34.7a12,12,0,1,1,12-12A12,12,0,0,1,164,140Z" }, null, -1), Woo = [
  Poo
], Noo = { key: 3 }, Foo = ["stroke"], Too = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "128",
  r: "10"
}, null, -1), Doo = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "128",
  r: "10"
}, null, -1), Roo = ["stroke"], Uoo = ["stroke"], qoo = { key: 4 }, Goo = ["stroke"], Eoo = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "128",
  r: "8"
}, null, -1), Ooo = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "128",
  r: "8"
}, null, -1), Ioo = ["stroke"], Koo = ["stroke"], Xoo = { key: 5 }, Joo = ["stroke"], Qoo = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "128",
  r: "12"
}, null, -1), Yoo = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "128",
  r: "12"
}, null, -1), oeo = ["stroke"], eeo = ["stroke"], teo = {
  name: "PhBaby"
}, ND1 = /* @__PURE__ */ $({
  ...teo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", joo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, moo),
        Moo,
        voo,
        e("path", {
          d: "M154.5,168a47.9,47.9,0,0,1-53,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Soo),
        e("path", {
          d: "M128,32c-16,20-16,40-16,40a16,16,0,0,0,16,16,16.7,16.7,0,0,0,8-2.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hoo)
      ])) : o(i) === "duotone" ? (s(), r("g", Aoo, [
        Voo,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zoo),
        Zoo,
        Coo,
        e("path", {
          d: "M154.5,168a47.9,47.9,0,0,1-53,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, boo),
        e("path", {
          d: "M128,32c-16,20-16,40-16,40a16,16,0,0,0,32,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Loo)
      ])) : o(i) === "fill" ? (s(), r("g", Boo, Woo)) : o(i) === "light" ? (s(), r("g", Noo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Foo),
        Too,
        Doo,
        e("path", {
          d: "M154.5,168a47.9,47.9,0,0,1-53,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Roo),
        e("path", {
          d: "M128,32c-16,20-16,40-16,40a16,16,0,0,0,32,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Uoo)
      ])) : o(i) === "thin" ? (s(), r("g", qoo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Goo),
        Eoo,
        Ooo,
        e("path", {
          d: "M154.5,168a47.9,47.9,0,0,1-53,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ioo),
        e("path", {
          d: "M128,32c-16,20-16,40-16,40a16,16,0,0,0,32,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Koo)
      ])) : o(i) === "regular" ? (s(), r("g", Xoo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Joo),
        Qoo,
        Yoo,
        e("path", {
          d: "M154.5,168a47.9,47.9,0,0,1-53,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oeo),
        e("path", {
          d: "M128,32c-16,20-16,40-16,40a16,16,0,0,0,32,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eeo)
      ])) : g("", !0)
    ], 16, xoo));
  }
}), neo = ["width", "height", "fill", "transform"], seo = { key: 0 }, reo = ["stroke"], ieo = ["stroke"], leo = ["stroke"], deo = ["stroke"], keo = ["stroke"], ceo = ["stroke"], heo = { key: 1 }, ueo = /* @__PURE__ */ e("path", {
  d: "M160,48H96A48,48,0,0,0,48,96V216a8,8,0,0,0,8,8H80V152a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v72h24a8,8,0,0,0,8-8V96A48,48,0,0,0,160,48Z",
  opacity: "0.2"
}, null, -1), aeo = ["stroke"], _eo = ["stroke"], peo = ["stroke"], yeo = ["stroke"], $eo = ["stroke"], weo = ["stroke"], feo = { key: 2 }, geo = /* @__PURE__ */ e("path", { d: "M168,40.6V32A24.1,24.1,0,0,0,144,8H112A24.1,24.1,0,0,0,88,32v8.6A56,56,0,0,0,40,96V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V96A56,56,0,0,0,168,40.6ZM104,32a8,8,0,0,1,8-8h32a8,8,0,0,1,8,8v8H104Zm8,40h32a8,8,0,0,1,0,16H112a8,8,0,0,1,0-16Zm64,144H80V176h56v8a8,8,0,0,0,16,0v-8h24Zm0-56H80v-8a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16Z" }, null, -1), xeo = [
  geo
], jeo = { key: 3 }, meo = ["stroke"], Meo = ["stroke"], veo = ["stroke"], Seo = ["stroke"], Heo = ["stroke"], Aeo = ["stroke"], Veo = { key: 4 }, zeo = ["stroke"], Zeo = ["stroke"], Ceo = ["stroke"], beo = ["stroke"], Leo = ["stroke"], Beo = ["stroke"], Peo = { key: 5 }, Weo = ["stroke"], Neo = ["stroke"], Feo = ["stroke"], Teo = ["stroke"], Deo = ["stroke"], Reo = ["stroke"], Ueo = {
  name: "PhBackpack"
}, FD1 = /* @__PURE__ */ $({
  ...Ueo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", seo, [
        e("path", {
          d: "M92,60h72a48,48,0,0,1,48,48V220a8,8,0,0,1-8,8H52a8,8,0,0,1-8-8V108A48,48,0,0,1,92,60Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, reo),
        e("path", {
          d: "M84,228V152a16,16,0,0,1,16-16h56a16,16,0,0,1,16,16v76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ieo),
        e("path", {
          d: "M96,60V36a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, leo),
        e("line", {
          x1: "108",
          y1: "100",
          x2: "148",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, deo),
        e("line", {
          x1: "84",
          y1: "172",
          x2: "172",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, keo),
        e("line", {
          x1: "140",
          y1: "172",
          x2: "140",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ceo)
      ])) : o(i) === "duotone" ? (s(), r("g", heo, [
        ueo,
        e("path", {
          d: "M96,48h64a48,48,0,0,1,48,48V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V96A48,48,0,0,1,96,48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aeo),
        e("path", {
          d: "M80,224V152a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _eo),
        e("path", {
          d: "M96,48V32a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, peo),
        e("line", {
          x1: "112",
          y1: "88",
          x2: "144",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yeo),
        e("line", {
          x1: "80",
          y1: "168",
          x2: "176",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $eo),
        e("line", {
          x1: "144",
          y1: "168",
          x2: "144",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, weo)
      ])) : o(i) === "fill" ? (s(), r("g", feo, xeo)) : o(i) === "light" ? (s(), r("g", jeo, [
        e("path", {
          d: "M96,48h64a48,48,0,0,1,48,48V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V96A48,48,0,0,1,96,48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, meo),
        e("path", {
          d: "M80,224V152a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Meo),
        e("path", {
          d: "M96,48V32a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, veo),
        e("line", {
          x1: "112",
          y1: "88",
          x2: "144",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Seo),
        e("line", {
          x1: "80",
          y1: "168",
          x2: "176",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Heo),
        e("line", {
          x1: "144",
          y1: "168",
          x2: "144",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Aeo)
      ])) : o(i) === "thin" ? (s(), r("g", Veo, [
        e("path", {
          d: "M96,48h64a48,48,0,0,1,48,48V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V96A48,48,0,0,1,96,48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zeo),
        e("path", {
          d: "M80,224V152a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zeo),
        e("path", {
          d: "M96,48V32a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ceo),
        e("line", {
          x1: "112",
          y1: "88",
          x2: "144",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, beo),
        e("line", {
          x1: "80",
          y1: "168",
          x2: "176",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Leo),
        e("line", {
          x1: "144",
          y1: "168",
          x2: "144",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Beo)
      ])) : o(i) === "regular" ? (s(), r("g", Peo, [
        e("path", {
          d: "M96,48h64a48,48,0,0,1,48,48V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V96A48,48,0,0,1,96,48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Weo),
        e("path", {
          d: "M80,224V152a16,16,0,0,1,16-16h64a16,16,0,0,1,16,16v72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Neo),
        e("path", {
          d: "M96,48V32a16,16,0,0,1,16-16h32a16,16,0,0,1,16,16V48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Feo),
        e("line", {
          x1: "112",
          y1: "88",
          x2: "144",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Teo),
        e("line", {
          x1: "80",
          y1: "168",
          x2: "176",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Deo),
        e("line", {
          x1: "144",
          y1: "168",
          x2: "144",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Reo)
      ])) : g("", !0)
    ], 16, neo));
  }
}), qeo = ["width", "height", "fill", "transform"], Geo = { key: 0 }, Eeo = ["stroke"], Oeo = ["stroke"], Ieo = ["stroke"], Keo = { key: 1 }, Xeo = /* @__PURE__ */ e("path", {
  d: "M61.7,204.1,16,128,61.7,51.9A7.9,7.9,0,0,1,68.5,48H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H68.5A7.9,7.9,0,0,1,61.7,204.1Z",
  opacity: "0.2"
}, null, -1), Jeo = ["stroke"], Qeo = ["stroke"], Yeo = ["stroke"], oto = { key: 2 }, eto = /* @__PURE__ */ e("path", { d: "M216,40H68.5a16.2,16.2,0,0,0-13.7,7.8L9.1,123.9a8,8,0,0,0,0,8.2l45.7,76.1h0A16.1,16.1,0,0,0,68.5,216H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM165.7,146.3a8.1,8.1,0,0,1,0,11.4A8.5,8.5,0,0,1,160,160a8.3,8.3,0,0,1-5.7-2.3L136,139.3l-18.3,18.4A8.5,8.5,0,0,1,112,160a8.3,8.3,0,0,1-5.7-2.3,8.1,8.1,0,0,1,0-11.4L124.7,128l-18.4-18.3a8.1,8.1,0,0,1,11.4-11.4L136,116.7l18.3-18.4a8.1,8.1,0,0,1,11.4,11.4L147.3,128Z" }, null, -1), tto = [
  eto
], nto = { key: 3 }, sto = ["stroke"], rto = ["stroke"], ito = ["stroke"], lto = { key: 4 }, dto = ["stroke"], kto = ["stroke"], cto = ["stroke"], hto = { key: 5 }, uto = ["stroke"], ato = ["stroke"], _to = ["stroke"], pto = {
  name: "PhBackspace"
}, TD1 = /* @__PURE__ */ $({
  ...pto,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Geo, [
        e("path", {
          d: "M61.7,204.1,16,128,61.7,51.9A7.9,7.9,0,0,1,68.5,48H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H68.5A7.9,7.9,0,0,1,61.7,204.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Eeo),
        e("line", {
          x1: "160",
          y1: "104",
          x2: "112",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Oeo),
        e("line", {
          x1: "160",
          y1: "152",
          x2: "112",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ieo)
      ])) : o(i) === "duotone" ? (s(), r("g", Keo, [
        Xeo,
        e("path", {
          d: "M61.7,204.1,16,128,61.7,51.9A7.9,7.9,0,0,1,68.5,48H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H68.5A7.9,7.9,0,0,1,61.7,204.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jeo),
        e("line", {
          x1: "160",
          y1: "104",
          x2: "112",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qeo),
        e("line", {
          x1: "160",
          y1: "152",
          x2: "112",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yeo)
      ])) : o(i) === "fill" ? (s(), r("g", oto, tto)) : o(i) === "light" ? (s(), r("g", nto, [
        e("path", {
          d: "M61.7,204.1,16,128,61.7,51.9A7.9,7.9,0,0,1,68.5,48H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H68.5A7.9,7.9,0,0,1,61.7,204.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sto),
        e("line", {
          x1: "160",
          y1: "104",
          x2: "112",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rto),
        e("line", {
          x1: "160",
          y1: "152",
          x2: "112",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ito)
      ])) : o(i) === "thin" ? (s(), r("g", lto, [
        e("path", {
          d: "M61.7,204.1,16,128,61.7,51.9A7.9,7.9,0,0,1,68.5,48H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H68.5A7.9,7.9,0,0,1,61.7,204.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dto),
        e("line", {
          x1: "160",
          y1: "104",
          x2: "112",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kto),
        e("line", {
          x1: "160",
          y1: "152",
          x2: "112",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cto)
      ])) : o(i) === "regular" ? (s(), r("g", hto, [
        e("path", {
          d: "M61.7,204.1,16,128,61.7,51.9A7.9,7.9,0,0,1,68.5,48H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H68.5A7.9,7.9,0,0,1,61.7,204.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uto),
        e("line", {
          x1: "160",
          y1: "104",
          x2: "112",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ato),
        e("line", {
          x1: "160",
          y1: "152",
          x2: "112",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _to)
      ])) : g("", !0)
    ], 16, qeo));
  }
}), yto = ["width", "height", "fill", "transform"], $to = { key: 0 }, wto = ["stroke"], fto = ["stroke"], gto = { key: 1 }, xto = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "72",
  width: "192",
  height: "144",
  rx: "8",
  opacity: "0.2"
}, null, -1), jto = ["stroke"], mto = ["stroke"], Mto = { key: 2 }, vto = /* @__PURE__ */ e("path", { d: "M216,64H175.3a48,48,0,0,0-94.6,0H40A16,16,0,0,0,24,80V208a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64ZM96,104a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Zm1-40a32,32,0,0,1,62,0Zm79,40a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z" }, null, -1), Sto = [
  vto
], Hto = { key: 3 }, Ato = ["stroke"], Vto = ["stroke"], zto = { key: 4 }, Zto = ["stroke"], Cto = ["stroke"], bto = { key: 5 }, Lto = ["stroke"], Bto = ["stroke"], Pto = {
  name: "PhBag"
}, DD1 = /* @__PURE__ */ $({
  ...Pto,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $to, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wto),
        e("path", {
          d: "M88,104V72a40,40,0,0,1,80,0v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fto)
      ])) : o(i) === "duotone" ? (s(), r("g", gto, [
        xto,
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jto),
        e("path", {
          d: "M88,104V72a40,40,0,0,1,80,0v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mto)
      ])) : o(i) === "fill" ? (s(), r("g", Mto, Sto)) : o(i) === "light" ? (s(), r("g", Hto, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ato),
        e("path", {
          d: "M88,104V72a40,40,0,0,1,80,0v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vto)
      ])) : o(i) === "thin" ? (s(), r("g", zto, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zto),
        e("path", {
          d: "M88,104V72a40,40,0,0,1,80,0v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cto)
      ])) : o(i) === "regular" ? (s(), r("g", bto, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lto),
        e("path", {
          d: "M88,104V72a40,40,0,0,1,80,0v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bto)
      ])) : g("", !0)
    ], 16, yto));
  }
}), Wto = ["width", "height", "fill", "transform"], Nto = { key: 0 }, Fto = ["stroke"], Tto = ["stroke"], Dto = { key: 1 }, Rto = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "72",
  width: "192",
  height: "144",
  rx: "8",
  opacity: "0.2"
}, null, -1), Uto = ["stroke"], qto = ["stroke"], Gto = { key: 2 }, Eto = /* @__PURE__ */ e("path", { d: "M216,64H175.3a48,48,0,0,0-94.6,0H40A16,16,0,0,0,24,80V208a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64ZM128,40a32.1,32.1,0,0,1,31,24H97A32.1,32.1,0,0,1,128,40Z" }, null, -1), Oto = [
  Eto
], Ito = { key: 3 }, Kto = ["stroke"], Xto = ["stroke"], Jto = { key: 4 }, Qto = ["stroke"], Yto = ["stroke"], ono = { key: 5 }, eno = ["stroke"], tno = ["stroke"], nno = {
  name: "PhBagSimple"
}, RD1 = /* @__PURE__ */ $({
  ...nno,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Nto, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fto),
        e("path", {
          d: "M88,72a40,40,0,0,1,80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Tto)
      ])) : o(i) === "duotone" ? (s(), r("g", Dto, [
        Rto,
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uto),
        e("path", {
          d: "M88,72a40,40,0,0,1,80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qto)
      ])) : o(i) === "fill" ? (s(), r("g", Gto, Oto)) : o(i) === "light" ? (s(), r("g", Ito, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kto),
        e("path", {
          d: "M88,72a40,40,0,0,1,80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xto)
      ])) : o(i) === "thin" ? (s(), r("g", Jto, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qto),
        e("path", {
          d: "M88,72a40,40,0,0,1,80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Yto)
      ])) : o(i) === "regular" ? (s(), r("g", ono, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eno),
        e("path", {
          d: "M88,72a40,40,0,0,1,80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tno)
      ])) : g("", !0)
    ], 16, Wto));
  }
}), sno = ["width", "height", "fill", "transform"], rno = { key: 0 }, ino = ["stroke"], lno = ["stroke"], dno = ["stroke"], kno = { key: 1 }, cno = /* @__PURE__ */ e("path", {
  d: "M208,104a80,80,0,0,0-160,0c0,40.5,30.1,87.5,69.2,95h0L104,232h48l-13.2-33h0C177.9,191.5,208,144.5,208,104Z",
  opacity: "0.2"
}, null, -1), hno = ["stroke"], uno = ["stroke"], ano = ["stroke"], _no = { key: 2 }, pno = /* @__PURE__ */ e("path", { d: "M128,16a88.1,88.1,0,0,0-88,88c0,23.4,9.4,49.4,25.1,69.5,11.9,15.2,26.2,25.7,41.3,30.9L96.6,229a8,8,0,0,0,.8,7.5A7.9,7.9,0,0,0,104,240h48a7.9,7.9,0,0,0,6.6-3.5,8,8,0,0,0,.8-7.5l-9.8-24.6c15.1-5.2,29.4-15.7,41.3-30.9C206.6,153.4,216,127.4,216,104A88.1,88.1,0,0,0,128,16Zm48.7,87.9h-1.4a8.1,8.1,0,0,1-7.9-6.7,39.7,39.7,0,0,0-32.7-32.7,8.1,8.1,0,0,1-6.6-9.3,7.9,7.9,0,0,1,9.2-6.5,55.9,55.9,0,0,1,45.9,45.9A7.9,7.9,0,0,1,176.7,103.9Z" }, null, -1), yno = [
  pno
], $no = { key: 3 }, wno = ["stroke"], fno = ["stroke"], gno = ["stroke"], xno = { key: 4 }, jno = ["stroke"], mno = ["stroke"], Mno = ["stroke"], vno = { key: 5 }, Sno = ["stroke"], Hno = ["stroke"], Ano = ["stroke"], Vno = {
  name: "PhBalloon"
}, UD1 = /* @__PURE__ */ $({
  ...Vno,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", rno, [
        e("path", {
          d: "M208,104c0,44.2-35.8,92-80,92s-80-47.8-80-92a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ino),
        e("polyline", {
          points: "144.7 193.7 160 232 96 232 111.3 193.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lno),
        e("path", {
          d: "M140,70a36.8,36.8,0,0,1,22,22",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dno)
      ])) : o(i) === "duotone" ? (s(), r("g", kno, [
        cno,
        e("path", {
          d: "M208,104c0,44.2-35.8,96-80,96s-80-51.8-80-96a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hno),
        e("polyline", {
          points: "138.8 199 152 232 104 232 117.2 199",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uno),
        e("path", {
          d: "M136,56.7A47.8,47.8,0,0,1,175.3,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ano)
      ])) : o(i) === "fill" ? (s(), r("g", _no, yno)) : o(i) === "light" ? (s(), r("g", $no, [
        e("path", {
          d: "M208,104c0,44.2-35.8,96-80,96s-80-51.8-80-96a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wno),
        e("polyline", {
          points: "138.8 199 152 232 104 232 117.2 199",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fno),
        e("path", {
          d: "M136,56.7A47.8,47.8,0,0,1,175.3,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gno)
      ])) : o(i) === "thin" ? (s(), r("g", xno, [
        e("path", {
          d: "M208,104c0,44.2-35.8,96-80,96s-80-51.8-80-96a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jno),
        e("polyline", {
          points: "138.8 199 152 232 104 232 117.2 199",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mno),
        e("path", {
          d: "M136,56.7A47.8,47.8,0,0,1,175.3,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Mno)
      ])) : o(i) === "regular" ? (s(), r("g", vno, [
        e("path", {
          d: "M208,104c0,44.2-35.8,96-80,96s-80-51.8-80-96a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sno),
        e("polyline", {
          points: "138.8 199 152 232 104 232 117.2 199",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hno),
        e("path", {
          d: "M136,56.7A47.8,47.8,0,0,1,175.3,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ano)
      ])) : g("", !0)
    ], 16, sno));
  }
}), zno = ["width", "height", "fill", "transform"], Zno = { key: 0 }, Cno = ["stroke"], bno = ["stroke"], Lno = { key: 1 }, Bno = /* @__PURE__ */ e("path", {
  d: "M206.6,94.6a32,32,0,0,0-45.2-45.2L128,82.7,173.3,128Z",
  opacity: "0.2"
}, null, -1), Pno = /* @__PURE__ */ e("path", {
  d: "M49.4,161.4a32,32,0,0,0,45.2,45.2L128,173.3,82.7,128Z",
  opacity: "0.2"
}, null, -1), Wno = /* @__PURE__ */ e("path", {
  d: "M94.6,49.4A32,32,0,0,0,49.4,94.6L82.7,128,128,82.7Z",
  opacity: "0.2"
}, null, -1), Nno = /* @__PURE__ */ e("path", {
  d: "M173.3,128,128,173.3l33.4,33.3a32,32,0,0,0,45.2-45.2Z",
  opacity: "0.2"
}, null, -1), Fno = ["stroke"], Tno = ["stroke"], Dno = ["stroke"], Rno = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), Uno = { key: 2 }, qno = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), Gno = /* @__PURE__ */ e("path", { d: "M184.6,128l27.7-27.7a40,40,0,0,0-56.6-56.6L128,71.4,100.3,43.7a40,40,0,0,0-56.6,56.6L71.4,128,43.7,155.7a40,40,0,0,0,56.6,56.6L128,184.6l27.7,27.7a40,40,0,0,0,56.6-56.6ZM128,94.1,161.9,128,128,161.9,94.1,128ZM167,55a24,24,0,0,1,34,34l-27.7,27.7-34-34ZM89,201a24,24,0,0,1-34-34l27.7-27.7,34,34Z" }, null, -1), Eno = [
  qno,
  Gno
], Ono = { key: 3 }, Ino = ["stroke"], Kno = ["stroke"], Xno = ["stroke"], Jno = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "10"
}, null, -1), Qno = { key: 4 }, Yno = ["stroke"], oso = ["stroke"], eso = ["stroke"], tso = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "8"
}, null, -1), nso = { key: 5 }, sso = ["stroke"], rso = ["stroke"], iso = ["stroke"], lso = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), dso = {
  name: "PhBandaids"
}, qD1 = /* @__PURE__ */ $({
  ...dso,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Zno, [
        e("path", {
          d: "M49.4,94.6A32,32,0,0,1,94.6,49.4l112,112a32,32,0,0,1-45.2,45.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cno),
        e("path", {
          d: "M161.4,49.4a32,32,0,0,1,45.2,45.2l-112,112a32,32,0,0,1-45.2-45.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bno)
      ])) : o(i) === "duotone" ? (s(), r("g", Lno, [
        Bno,
        Pno,
        Wno,
        Nno,
        e("path", {
          d: "M49.4,94.6A32,32,0,0,1,94.6,49.4l112,112a32,32,0,0,1-45.2,45.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fno),
        e("path", {
          d: "M161.4,49.4a32,32,0,0,1,45.2,45.2l-112,112a32,32,0,0,1-45.2-45.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tno),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16",
          opacity: "0.5"
        }, null, 8, Dno),
        Rno
      ])) : o(i) === "fill" ? (s(), r("g", Uno, Eno)) : o(i) === "light" ? (s(), r("g", Ono, [
        e("path", {
          d: "M49.4,94.6A32,32,0,0,1,94.6,49.4l112,112a32,32,0,0,1-45.2,45.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ino),
        e("path", {
          d: "M161.4,49.4a32,32,0,0,1,45.2,45.2l-112,112a32,32,0,0,1-45.2-45.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kno),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12",
          opacity: "0.5"
        }, null, 8, Xno),
        Jno
      ])) : o(i) === "thin" ? (s(), r("g", Qno, [
        e("path", {
          d: "M161.4,49.4a32,32,0,0,1,45.2,45.2l-112,112a32,32,0,0,1-45.2-45.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Yno),
        e("path", {
          d: "M49.4,94.6A32,32,0,0,1,94.6,49.4l112,112a32,32,0,0,1-45.2,45.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oso),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8",
          opacity: "0.5"
        }, null, 8, eso),
        tso
      ])) : o(i) === "regular" ? (s(), r("g", nso, [
        e("path", {
          d: "M49.4,94.6A32,32,0,0,1,94.6,49.4l112,112a32,32,0,0,1-45.2,45.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sso),
        e("path", {
          d: "M161.4,49.4a32,32,0,0,1,45.2,45.2l-112,112a32,32,0,0,1-45.2-45.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rso),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16",
          opacity: "0.5"
        }, null, 8, iso),
        lso
      ])) : g("", !0)
    ], 16, zno));
  }
}), kso = ["width", "height", "fill", "transform"], cso = { key: 0 }, hso = ["stroke"], uso = ["stroke"], aso = ["stroke"], _so = ["stroke"], pso = ["stroke"], yso = ["stroke"], $so = ["stroke"], wso = { key: 1 }, fso = /* @__PURE__ */ e("polygon", {
  points: "24 96 232 96 128 32 24 96",
  opacity: "0.2"
}, null, -1), gso = ["stroke"], xso = ["stroke"], jso = ["stroke"], mso = ["stroke"], Mso = ["stroke"], vso = ["stroke"], Sso = ["stroke"], Hso = { key: 2 }, Aso = /* @__PURE__ */ e("path", { d: "M248,208a8,8,0,0,1-8,8H16a8,8,0,0,1,0-16H240A8,8,0,0,1,248,208ZM16.3,98.2a8,8,0,0,1,3.5-9l104-64a7.9,7.9,0,0,1,8.4,0l104,64A8,8,0,0,1,232,104H208v64h16a8,8,0,0,1,0,16H32a8,8,0,0,1,0-16H48V104H24A8,8,0,0,1,16.3,98.2ZM144,160a8,8,0,0,0,16,0V112a8,8,0,0,0-16,0Zm-48,0a8,8,0,0,0,16,0V112a8,8,0,0,0-16,0Z" }, null, -1), Vso = [
  Aso
], zso = { key: 3 }, Zso = ["stroke"], Cso = ["stroke"], bso = ["stroke"], Lso = ["stroke"], Bso = ["stroke"], Pso = ["stroke"], Wso = ["stroke"], Nso = { key: 4 }, Fso = ["stroke"], Tso = ["stroke"], Dso = ["stroke"], Rso = ["stroke"], Uso = ["stroke"], qso = ["stroke"], Gso = ["stroke"], Eso = { key: 5 }, Oso = ["stroke"], Iso = ["stroke"], Kso = ["stroke"], Xso = ["stroke"], Jso = ["stroke"], Qso = ["stroke"], Yso = ["stroke"], oro = {
  name: "PhBank"
}, GD1 = /* @__PURE__ */ $({
  ...oro,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", cso, [
        e("polygon", {
          points: "24 96 232 96 128 32 24 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hso),
        e("line", {
          x1: "56",
          y1: "96",
          x2: "56",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uso),
        e("line", {
          x1: "104",
          y1: "96",
          x2: "104",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aso),
        e("line", {
          x1: "152",
          y1: "96",
          x2: "152",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _so),
        e("line", {
          x1: "200",
          y1: "96",
          x2: "200",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pso),
        e("line", {
          x1: "32",
          y1: "168",
          x2: "224",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yso),
        e("line", {
          x1: "16",
          y1: "208",
          x2: "240",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $so)
      ])) : o(i) === "duotone" ? (s(), r("g", wso, [
        fso,
        e("polygon", {
          points: "24 96 232 96 128 32 24 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gso),
        e("line", {
          x1: "56",
          y1: "96",
          x2: "56",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xso),
        e("line", {
          x1: "104",
          y1: "96",
          x2: "104",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jso),
        e("line", {
          x1: "152",
          y1: "96",
          x2: "152",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mso),
        e("line", {
          x1: "200",
          y1: "96",
          x2: "200",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mso),
        e("line", {
          x1: "32",
          y1: "176",
          x2: "224",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vso),
        e("line", {
          x1: "16",
          y1: "208",
          x2: "240",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sso)
      ])) : o(i) === "fill" ? (s(), r("g", Hso, Vso)) : o(i) === "light" ? (s(), r("g", zso, [
        e("polygon", {
          points: "24 96 232 96 128 32 24 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zso),
        e("line", {
          x1: "56",
          y1: "96",
          x2: "56",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cso),
        e("line", {
          x1: "104",
          y1: "96",
          x2: "104",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bso),
        e("line", {
          x1: "152",
          y1: "96",
          x2: "152",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lso),
        e("line", {
          x1: "200",
          y1: "96",
          x2: "200",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bso),
        e("line", {
          x1: "32",
          y1: "176",
          x2: "224",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pso),
        e("line", {
          x1: "16",
          y1: "208",
          x2: "240",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wso)
      ])) : o(i) === "thin" ? (s(), r("g", Nso, [
        e("polygon", {
          points: "24 96 232 96 128 32 24 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fso),
        e("line", {
          x1: "56",
          y1: "96",
          x2: "56",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Tso),
        e("line", {
          x1: "104",
          y1: "96",
          x2: "104",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Dso),
        e("line", {
          x1: "152",
          y1: "96",
          x2: "152",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Rso),
        e("line", {
          x1: "200",
          y1: "96",
          x2: "200",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Uso),
        e("line", {
          x1: "32",
          y1: "176",
          x2: "224",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qso),
        e("line", {
          x1: "16",
          y1: "208",
          x2: "240",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gso)
      ])) : o(i) === "regular" ? (s(), r("g", Eso, [
        e("polygon", {
          points: "24 96 232 96 128 32 24 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Oso),
        e("line", {
          x1: "56",
          y1: "96",
          x2: "56",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Iso),
        e("line", {
          x1: "104",
          y1: "96",
          x2: "104",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kso),
        e("line", {
          x1: "152",
          y1: "96",
          x2: "152",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xso),
        e("line", {
          x1: "200",
          y1: "96",
          x2: "200",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jso),
        e("line", {
          x1: "32",
          y1: "176",
          x2: "224",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qso),
        e("line", {
          x1: "16",
          y1: "208",
          x2: "240",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yso)
      ])) : g("", !0)
    ], 16, kso));
  }
}), ero = ["width", "height", "fill", "transform"], tro = { key: 0 }, nro = ["stroke"], sro = ["stroke"], rro = ["stroke"], iro = ["stroke"], lro = ["stroke"], dro = ["stroke"], kro = ["stroke"], cro = { key: 1 }, hro = /* @__PURE__ */ e("rect", {
  x: "56",
  y: "56",
  width: "40",
  height: "144",
  rx: "8",
  opacity: "0.2"
}, null, -1), uro = /* @__PURE__ */ e("rect", {
  x: "160",
  y: "56",
  width: "40",
  height: "144",
  rx: "8",
  opacity: "0.2"
}, null, -1), aro = ["stroke"], _ro = ["stroke"], pro = ["stroke"], yro = ["stroke"], $ro = ["stroke"], wro = ["stroke"], fro = ["stroke"], gro = { key: 2 }, xro = /* @__PURE__ */ e("path", { d: "M248,120h-8V88a16,16,0,0,0-16-16H208V64a16,16,0,0,0-16-16H168a16,16,0,0,0-16,16v56H104V64A16,16,0,0,0,88,48H64A16,16,0,0,0,48,64v8H32A16,16,0,0,0,16,88v32H8a8,8,0,0,0,0,16h8v32a16,16,0,0,0,16,16H48v8a16,16,0,0,0,16,16H88a16,16,0,0,0,16-16V136h48v56a16,16,0,0,0,16,16h24a16,16,0,0,0,16-16v-8h16a16,16,0,0,0,16-16V136h8a8,8,0,0,0,0-16ZM32,168V88H48v80Zm192,0H208V88h16Z" }, null, -1), jro = [
  xro
], mro = { key: 3 }, Mro = ["stroke"], vro = ["stroke"], Sro = ["stroke"], Hro = ["stroke"], Aro = ["stroke"], Vro = ["stroke"], zro = ["stroke"], Zro = { key: 4 }, Cro = ["stroke"], bro = ["stroke"], Lro = ["stroke"], Bro = ["stroke"], Pro = ["stroke"], Wro = ["stroke"], Nro = ["stroke"], Fro = { key: 5 }, Tro = ["stroke"], Dro = ["stroke"], Rro = ["stroke"], Uro = ["stroke"], qro = ["stroke"], Gro = ["stroke"], Ero = ["stroke"], Oro = {
  name: "PhBarbell"
}, ED1 = /* @__PURE__ */ $({
  ...Oro,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", tro, [
        e("rect", {
          x: "60",
          y: "56",
          width: "40",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nro),
        e("rect", {
          x: "156",
          y: "56",
          width: "40",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sro),
        e("path", {
          d: "M196,80h28a8,8,0,0,1,8,8v80a8,8,0,0,1-8,8H196",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rro),
        e("path", {
          d: "M60,176H32a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iro),
        e("line", {
          x1: "100",
          y1: "128",
          x2: "156",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lro),
        e("line", {
          x1: "232",
          y1: "128",
          x2: "244",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dro),
        e("line", {
          x1: "12",
          y1: "128",
          x2: "24",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kro)
      ])) : o(i) === "duotone" ? (s(), r("g", cro, [
        hro,
        uro,
        e("rect", {
          x: "56",
          y: "56",
          width: "40",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aro),
        e("rect", {
          x: "160",
          y: "56",
          width: "40",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _ro),
        e("path", {
          d: "M200,80h24a8,8,0,0,1,8,8v80a8,8,0,0,1-8,8H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pro),
        e("path", {
          d: "M56,176H32a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yro),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $ro),
        e("line", {
          x1: "232",
          y1: "128",
          x2: "248",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wro),
        e("line", {
          x1: "8",
          y1: "128",
          x2: "24",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fro)
      ])) : o(i) === "fill" ? (s(), r("g", gro, jro)) : o(i) === "light" ? (s(), r("g", mro, [
        e("rect", {
          x: "56",
          y: "56",
          width: "40",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mro),
        e("rect", {
          x: "160",
          y: "56",
          width: "40",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vro),
        e("path", {
          d: "M200,80h24a8,8,0,0,1,8,8v80a8,8,0,0,1-8,8H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Sro),
        e("path", {
          d: "M56,176H32a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hro),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Aro),
        e("line", {
          x1: "232",
          y1: "128",
          x2: "248",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vro),
        e("line", {
          x1: "8",
          y1: "128",
          x2: "24",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zro)
      ])) : o(i) === "thin" ? (s(), r("g", Zro, [
        e("rect", {
          x: "56",
          y: "56",
          width: "40",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cro),
        e("rect", {
          x: "160",
          y: "56",
          width: "40",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bro),
        e("path", {
          d: "M200,80h24a8,8,0,0,1,8,8v80a8,8,0,0,1-8,8H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lro),
        e("path", {
          d: "M56,176H32a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bro),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pro),
        e("line", {
          x1: "232",
          y1: "128",
          x2: "248",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wro),
        e("line", {
          x1: "8",
          y1: "128",
          x2: "24",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nro)
      ])) : o(i) === "regular" ? (s(), r("g", Fro, [
        e("rect", {
          x: "56",
          y: "56",
          width: "40",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tro),
        e("rect", {
          x: "160",
          y: "56",
          width: "40",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dro),
        e("path", {
          d: "M200,80h24a8,8,0,0,1,8,8v80a8,8,0,0,1-8,8H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rro),
        e("path", {
          d: "M56,176H32a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uro),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qro),
        e("line", {
          x1: "232",
          y1: "128",
          x2: "248",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gro),
        e("line", {
          x1: "8",
          y1: "128",
          x2: "24",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ero)
      ])) : g("", !0)
    ], 16, ero));
  }
}), Iro = ["width", "height", "fill", "transform"], Kro = { key: 0 }, Xro = ["stroke"], Jro = ["stroke"], Qro = ["stroke"], Yro = ["stroke"], oio = ["stroke"], eio = ["stroke"], tio = ["stroke"], nio = { key: 1 }, sio = ["stroke"], rio = ["stroke"], iio = ["stroke"], lio = ["stroke"], dio = ["stroke"], kio = ["stroke"], cio = ["stroke"], hio = ["stroke"], uio = { key: 2 }, aio = /* @__PURE__ */ j('<path d="M224,40H184a8,8,0,0,0,0,16h32V88a8,8,0,0,0,16,0V48A8,8,0,0,0,224,40Z"></path><path d="M72,200H40V168a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16Z"></path><path d="M224,160a8,8,0,0,0-8,8v32H184a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V168A8,8,0,0,0,224,160Z"></path><path d="M32,96a8,8,0,0,0,8-8V56H72a8,8,0,0,0,0-16H32a8,8,0,0,0-8,8V88A8,8,0,0,0,32,96Z"></path><path d="M80,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,80,80Z"></path><path d="M184,168V88a8,8,0,0,0-16,0v80a8,8,0,0,0,16,0Z"></path><path d="M144,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,144,80Z"></path><path d="M112,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,112,80Z"></path>', 8), _io = [
  aio
], pio = { key: 3 }, yio = ["stroke"], $io = ["stroke"], wio = ["stroke"], fio = ["stroke"], gio = ["stroke"], xio = ["stroke"], jio = ["stroke"], mio = ["stroke"], Mio = { key: 4 }, vio = ["stroke"], Sio = ["stroke"], Hio = ["stroke"], Aio = ["stroke"], Vio = ["stroke"], zio = ["stroke"], Zio = ["stroke"], Cio = ["stroke"], bio = { key: 5 }, Lio = ["stroke"], Bio = ["stroke"], Pio = ["stroke"], Wio = ["stroke"], Nio = ["stroke"], Fio = ["stroke"], Tio = ["stroke"], Dio = ["stroke"], Rio = {
  name: "PhBarcode"
}, OD1 = /* @__PURE__ */ $({
  ...Rio,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Kro, [
        e("polyline", {
          points: "180 52 220 52 220 92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xro),
        e("polyline", {
          points: "76 204 36 204 36 164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jro),
        e("polyline", {
          points: "220 164 220 204 180 204",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qro),
        e("polyline", {
          points: "36 92 36 52 76 52",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Yro),
        e("line", {
          x1: "88",
          y1: "92",
          x2: "88",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oio),
        e("line", {
          x1: "168",
          y1: "92",
          x2: "168",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eio),
        e("line", {
          x1: "128",
          y1: "92",
          x2: "128",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tio)
      ])) : o(i) === "duotone" ? (s(), r("g", nio, [
        e("polyline", {
          points: "184 48 224 48 224 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sio),
        e("polyline", {
          points: "72 208 32 208 32 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rio),
        e("polyline", {
          points: "224 168 224 208 184 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iio),
        e("polyline", {
          points: "32 88 32 48 72 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lio),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dio),
        e("line", {
          x1: "176",
          y1: "88",
          x2: "176",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kio),
        e("line", {
          x1: "144",
          y1: "88",
          x2: "144",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cio),
        e("line", {
          x1: "112",
          y1: "88",
          x2: "112",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hio)
      ])) : o(i) === "fill" ? (s(), r("g", uio, _io)) : o(i) === "light" ? (s(), r("g", pio, [
        e("polyline", {
          points: "184 48 224 48 224 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yio),
        e("polyline", {
          points: "72 208 32 208 32 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $io),
        e("polyline", {
          points: "224 168 224 208 184 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wio),
        e("polyline", {
          points: "32 88 32 48 72 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fio),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gio),
        e("line", {
          x1: "176",
          y1: "88",
          x2: "176",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xio),
        e("line", {
          x1: "144",
          y1: "88",
          x2: "144",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jio),
        e("line", {
          x1: "112",
          y1: "88",
          x2: "112",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mio)
      ])) : o(i) === "thin" ? (s(), r("g", Mio, [
        e("polyline", {
          points: "184 48 224 48 224 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vio),
        e("polyline", {
          points: "72 208 32 208 32 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Sio),
        e("polyline", {
          points: "224 168 224 208 184 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hio),
        e("polyline", {
          points: "32 88 32 48 72 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Aio),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vio),
        e("line", {
          x1: "176",
          y1: "88",
          x2: "176",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zio),
        e("line", {
          x1: "144",
          y1: "88",
          x2: "144",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zio),
        e("line", {
          x1: "112",
          y1: "88",
          x2: "112",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cio)
      ])) : o(i) === "regular" ? (s(), r("g", bio, [
        e("polyline", {
          points: "184 48 224 48 224 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lio),
        e("polyline", {
          points: "72 208 32 208 32 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bio),
        e("polyline", {
          points: "224 168 224 208 184 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pio),
        e("polyline", {
          points: "32 88 32 48 72 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wio),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nio),
        e("line", {
          x1: "176",
          y1: "88",
          x2: "176",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fio),
        e("line", {
          x1: "144",
          y1: "88",
          x2: "144",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tio),
        e("line", {
          x1: "112",
          y1: "88",
          x2: "112",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dio)
      ])) : g("", !0)
    ], 16, Iro));
  }
}), Uio = ["width", "height", "fill", "transform"], qio = { key: 0 }, Gio = ["stroke"], Eio = ["stroke"], Oio = ["stroke"], Iio = ["stroke"], Kio = ["stroke"], Xio = ["stroke"], Jio = { key: 1 }, Qio = /* @__PURE__ */ e("path", {
  d: "M156,72l76,76V80a8,8,0,0,0-8-8Z",
  opacity: "0.2"
}, null, -1), Yio = /* @__PURE__ */ e("path", {
  d: "M84,72l88,88H100L24,84V80a8,8,0,0,1,8-8Z",
  opacity: "0.2"
}, null, -1), o1o = ["stroke"], e1o = ["stroke"], t1o = ["stroke"], n1o = ["stroke"], s1o = ["stroke"], r1o = ["stroke"], i1o = { key: 2 }, l1o = /* @__PURE__ */ e("path", { d: "M224,64H32A16,16,0,0,0,16,80v72a16,16,0,0,0,16,16H56v32a8,8,0,0,0,16,0V168H184v32a8,8,0,0,0,16,0V168h24a16,16,0,0,0,16-16V80A16,16,0,0,0,224,64ZM32,92l60,60H32Zm192,60H164L92,80h72l60,60v12Z" }, null, -1), d1o = [
  l1o
], k1o = { key: 3 }, c1o = ["stroke"], h1o = ["stroke"], u1o = ["stroke"], a1o = ["stroke"], _1o = ["stroke"], p1o = ["stroke"], y1o = { key: 4 }, $1o = ["stroke"], w1o = ["stroke"], f1o = ["stroke"], g1o = ["stroke"], x1o = ["stroke"], j1o = ["stroke"], m1o = { key: 5 }, M1o = ["stroke"], v1o = ["stroke"], S1o = ["stroke"], H1o = ["stroke"], A1o = ["stroke"], V1o = ["stroke"], z1o = {
  name: "PhBarricade"
}, ID1 = /* @__PURE__ */ $({
  ...z1o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", qio, [
        e("rect", {
          x: "24",
          y: "72",
          width: "208",
          height: "88",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gio),
        e("line", {
          x1: "84",
          y1: "72",
          x2: "172",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Eio),
        e("line", {
          x1: "156",
          y1: "72",
          x2: "232",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Oio),
        e("line", {
          x1: "24",
          y1: "84",
          x2: "100",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Iio),
        e("line", {
          x1: "192",
          y1: "160",
          x2: "192",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kio),
        e("line", {
          x1: "64",
          y1: "160",
          x2: "64",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xio)
      ])) : o(i) === "duotone" ? (s(), r("g", Jio, [
        Qio,
        Yio,
        e("rect", {
          x: "24",
          y: "72",
          width: "208",
          height: "88",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o1o),
        e("line", {
          x1: "84",
          y1: "72",
          x2: "172",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e1o),
        e("line", {
          x1: "156",
          y1: "72",
          x2: "232",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t1o),
        e("line", {
          x1: "24",
          y1: "84",
          x2: "100",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n1o),
        e("line", {
          x1: "192",
          y1: "160",
          x2: "192",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s1o),
        e("line", {
          x1: "64",
          y1: "160",
          x2: "64",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r1o)
      ])) : o(i) === "fill" ? (s(), r("g", i1o, d1o)) : o(i) === "light" ? (s(), r("g", k1o, [
        e("rect", {
          x: "24",
          y: "72",
          width: "208",
          height: "88",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, c1o),
        e("line", {
          x1: "84",
          y1: "72",
          x2: "172",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, h1o),
        e("line", {
          x1: "156",
          y1: "72",
          x2: "232",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u1o),
        e("line", {
          x1: "24",
          y1: "84",
          x2: "100",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, a1o),
        e("line", {
          x1: "192",
          y1: "160",
          x2: "192",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _1o),
        e("line", {
          x1: "64",
          y1: "160",
          x2: "64",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, p1o)
      ])) : o(i) === "thin" ? (s(), r("g", y1o, [
        e("rect", {
          x: "24",
          y: "72",
          width: "208",
          height: "88",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $1o),
        e("line", {
          x1: "84",
          y1: "72",
          x2: "172",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, w1o),
        e("line", {
          x1: "156",
          y1: "72",
          x2: "232",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, f1o),
        e("line", {
          x1: "24",
          y1: "84",
          x2: "100",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, g1o),
        e("line", {
          x1: "192",
          y1: "160",
          x2: "192",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, x1o),
        e("line", {
          x1: "64",
          y1: "160",
          x2: "64",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, j1o)
      ])) : o(i) === "regular" ? (s(), r("g", m1o, [
        e("rect", {
          x: "24",
          y: "72",
          width: "208",
          height: "88",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M1o),
        e("line", {
          x1: "84",
          y1: "72",
          x2: "172",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v1o),
        e("line", {
          x1: "156",
          y1: "72",
          x2: "232",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S1o),
        e("line", {
          x1: "24",
          y1: "84",
          x2: "100",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H1o),
        e("line", {
          x1: "192",
          y1: "160",
          x2: "192",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A1o),
        e("line", {
          x1: "64",
          y1: "160",
          x2: "64",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, V1o)
      ])) : g("", !0)
    ], 16, Uio));
  }
}), Z1o = ["width", "height", "fill", "transform"], C1o = { key: 0 }, b1o = ["stroke"], L1o = ["stroke"], B1o = ["stroke"], P1o = ["stroke"], W1o = ["stroke"], N1o = ["stroke"], F1o = ["stroke"], T1o = { key: 1 }, D1o = /* @__PURE__ */ e("path", {
  d: "M60.1,195.9a95.8,95.8,0,0,1-.2-135.6h0a95.5,95.5,0,0,1,28,67.7,95.8,95.8,0,0,1-28,67.8Z",
  opacity: "0.2"
}, null, -1), R1o = /* @__PURE__ */ e("path", {
  d: "M196.1,195.9a95.8,95.8,0,0,1-.2-135.6h0a96,96,0,0,1,0,135.5Z",
  opacity: "0.2"
}, null, -1), U1o = ["stroke"], q1o = ["stroke"], G1o = ["stroke"], E1o = ["stroke"], O1o = ["stroke"], I1o = ["stroke"], K1o = ["stroke"], X1o = ["stroke"], J1o = ["stroke"], Q1o = { key: 2 }, Y1o = /* @__PURE__ */ e("path", { d: "M51.9,63.9a4,4,0,0,0-6,.3,103.9,103.9,0,0,0,0,127.6,4,4,0,0,0,6,.3l7.3-7.3a8,8,0,0,1,6.2-2.8,7.9,7.9,0,0,1,5.2,2,8.2,8.2,0,0,1,.6,11.4,99.9,99.9,0,0,1-7.8,8.2,3.9,3.9,0,0,0,.2,6,103.8,103.8,0,0,0,128.8,0,3.9,3.9,0,0,0,.2-6,103.3,103.3,0,0,1-7.9-8.3,8,8,0,1,1,12.1-10.5l7.3,7.3a4,4,0,0,0,6-.3,103.9,103.9,0,0,0,0-127.6,4,4,0,0,0-6-.3l-7.3,7.3a8.1,8.1,0,0,1-6.1,2.8,7.6,7.6,0,0,1-5.3-2,8.2,8.2,0,0,1-.6-11.4,99.9,99.9,0,0,1,7.8-8.2,3.9,3.9,0,0,0-.2-6,103.8,103.8,0,0,0-128.8,0,3.9,3.9,0,0,0-.2,6,99.9,99.9,0,0,1,7.8,8.2A8,8,0,0,1,65.3,74h0a8.1,8.1,0,0,1-6.1-2.8ZM79.2,88.2a9.6,9.6,0,0,1,2.8-.7,8.1,8.1,0,0,1,7.9,5.3,105.7,105.7,0,0,1,4.4,16.5,8,8,0,0,1-5.9,9.4,6.3,6.3,0,0,1-1.9.3h0a8,8,0,0,1-7.9-6.6,83.8,83.8,0,0,0-3.7-13.9C73.5,94.5,75.2,89.8,79.2,88.2Zm15.1,58.5a105.7,105.7,0,0,1-4.4,16.5,8.1,8.1,0,0,1-7.6,5.3h0a7,7,0,0,1-3.1-.7,8.2,8.2,0,0,1-4.3-10.3,83.8,83.8,0,0,0,3.7-13.9,8.1,8.1,0,0,1,7.7-6.6l2,.2A8.2,8.2,0,0,1,94.3,146.7Zm82.5,21.1a7,7,0,0,1-3.1.7,8.1,8.1,0,0,1-7.6-5.3,105.7,105.7,0,0,1-4.4-16.5,8.2,8.2,0,0,1,5.4-9.3,8.1,8.1,0,0,1,10.3,6.2,83.8,83.8,0,0,0,3.7,13.9A8.2,8.2,0,0,1,176.8,167.8Zm3.6-68a23.6,23.6,0,0,0-2.9,11.4,8,8,0,0,1-8,7.8l-1.4-.2c-4.3-.7-7.2-5.3-6.4-9.6A109,109,0,0,1,166,93.1a8.3,8.3,0,0,1,9.8-5.3A8,8,0,0,1,180.4,99.8Z" }, null, -1), olo = [
  Y1o
], elo = { key: 3 }, tlo = ["stroke"], nlo = ["stroke"], slo = ["stroke"], rlo = ["stroke"], ilo = ["stroke"], llo = ["stroke"], dlo = ["stroke"], klo = ["stroke"], clo = ["stroke"], hlo = { key: 4 }, ulo = ["stroke"], alo = ["stroke"], _lo = ["stroke"], plo = ["stroke"], ylo = ["stroke"], $lo = ["stroke"], wlo = ["stroke"], flo = ["stroke"], glo = ["stroke"], xlo = { key: 5 }, jlo = ["stroke"], mlo = ["stroke"], Mlo = ["stroke"], vlo = ["stroke"], Slo = ["stroke"], Hlo = ["stroke"], Alo = ["stroke"], Vlo = ["stroke"], zlo = ["stroke"], Zlo = {
  name: "PhBaseball"
}, KD1 = /* @__PURE__ */ $({
  ...Zlo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", C1o, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, b1o),
        e("path", {
          d: "M181.2,79.4A98.3,98.3,0,0,1,196,60.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, L1o),
        e("path", {
          d: "M196,195.8a98.3,98.3,0,0,1-14.8-19.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, B1o),
        e("path", {
          d: "M168.7,140a117.3,117.3,0,0,1-.7-12,117.3,117.3,0,0,1,.7-12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, P1o),
        e("path", {
          d: "M74.8,79.4A98.3,98.3,0,0,0,60,60.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, W1o),
        e("path", {
          d: "M60,195.8a98.3,98.3,0,0,0,14.8-19.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, N1o),
        e("path", {
          d: "M87.3,140a117.3,117.3,0,0,0,.7-12,117.3,117.3,0,0,0-.7-12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, F1o)
      ])) : o(i) === "duotone" ? (s(), r("g", T1o, [
        D1o,
        R1o,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U1o),
        e("path", {
          d: "M169.2,113A94.7,94.7,0,0,1,173,97.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q1o),
        e("path", {
          d: "M173,158.5a94.7,94.7,0,0,1-3.8-15.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G1o),
        e("path", {
          d: "M86.8,113A94.7,94.7,0,0,0,83,97.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E1o),
        e("path", {
          d: "M83,158.5A94.7,94.7,0,0,0,86.8,143",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O1o),
        e("path", {
          d: "M186.8,70.9A103.8,103.8,0,0,1,196,60.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I1o),
        e("path", {
          d: "M196,195.8a115.6,115.6,0,0,1-9.2-10.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K1o),
        e("path", {
          d: "M60,195.8a115.6,115.6,0,0,0,9.2-10.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X1o),
        e("path", {
          d: "M69.2,70.9A103.8,103.8,0,0,0,60,60.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J1o)
      ])) : o(i) === "fill" ? (s(), r("g", Q1o, olo)) : o(i) === "light" ? (s(), r("g", elo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tlo),
        e("path", {
          d: "M169.2,113A94.7,94.7,0,0,1,173,97.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nlo),
        e("path", {
          d: "M173,158.5a94.7,94.7,0,0,1-3.8-15.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, slo),
        e("path", {
          d: "M86.8,113A94.7,94.7,0,0,0,83,97.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rlo),
        e("path", {
          d: "M83,158.5A94.7,94.7,0,0,0,86.8,143",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ilo),
        e("path", {
          d: "M186.8,70.9A103.8,103.8,0,0,1,196,60.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, llo),
        e("path", {
          d: "M196,195.8a115.6,115.6,0,0,1-9.2-10.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dlo),
        e("path", {
          d: "M60,195.8a115.6,115.6,0,0,0,9.2-10.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, klo),
        e("path", {
          d: "M69.2,70.9A103.8,103.8,0,0,0,60,60.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, clo)
      ])) : o(i) === "thin" ? (s(), r("g", hlo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ulo),
        e("path", {
          d: "M169.2,113A94.7,94.7,0,0,1,173,97.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, alo),
        e("path", {
          d: "M173,158.5a94.7,94.7,0,0,1-3.8-15.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _lo),
        e("path", {
          d: "M86.8,113A94.7,94.7,0,0,0,83,97.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, plo),
        e("path", {
          d: "M83,158.5A94.7,94.7,0,0,0,86.8,143",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ylo),
        e("path", {
          d: "M186.8,70.9A103.8,103.8,0,0,1,196,60.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $lo),
        e("path", {
          d: "M196,195.8a115.6,115.6,0,0,1-9.2-10.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wlo),
        e("path", {
          d: "M60,195.8a115.6,115.6,0,0,0,9.2-10.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, flo),
        e("path", {
          d: "M69.2,70.9A103.8,103.8,0,0,0,60,60.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, glo)
      ])) : o(i) === "regular" ? (s(), r("g", xlo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jlo),
        e("path", {
          d: "M169.2,113A94.7,94.7,0,0,1,173,97.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mlo),
        e("path", {
          d: "M173,158.5a94.7,94.7,0,0,1-3.8-15.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mlo),
        e("path", {
          d: "M86.8,113A94.7,94.7,0,0,0,83,97.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vlo),
        e("path", {
          d: "M83,158.5A94.7,94.7,0,0,0,86.8,143",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Slo),
        e("path", {
          d: "M186.8,70.9A103.8,103.8,0,0,1,196,60.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hlo),
        e("path", {
          d: "M196,195.8a115.6,115.6,0,0,1-9.2-10.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Alo),
        e("path", {
          d: "M60,195.8a115.6,115.6,0,0,0,9.2-10.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vlo),
        e("path", {
          d: "M69.2,70.9A103.8,103.8,0,0,0,60,60.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zlo)
      ])) : g("", !0)
    ], 16, Z1o));
  }
}), Clo = ["width", "height", "fill", "transform"], blo = { key: 0 }, Llo = ["stroke"], Blo = ["stroke"], Plo = ["stroke"], Wlo = ["stroke"], Nlo = ["stroke"], Flo = { key: 1 }, Tlo = /* @__PURE__ */ e("path", {
  d: "M60.1,195.9a95.8,95.8,0,0,1-.2-135.6h0a95.5,95.5,0,0,1,28,67.7,95.8,95.8,0,0,1-28,67.8Z",
  opacity: "0.2"
}, null, -1), Dlo = /* @__PURE__ */ e("path", {
  d: "M196.1,195.9a95.8,95.8,0,0,1-.2-135.6h0a96,96,0,0,1,0,135.5Z",
  opacity: "0.2"
}, null, -1), Rlo = ["stroke"], Ulo = ["stroke"], qlo = ["stroke"], Glo = ["stroke"], Elo = ["stroke"], Olo = { key: 2 }, Ilo = /* @__PURE__ */ e("path", { d: "M63.6,46.4a104.3,104.3,0,0,1,52-21.7,4,4,0,0,1,4.4,4V120H95.7A104.1,104.1,0,0,0,63.4,52.4,3.9,3.9,0,0,1,63.6,46.4ZM46,64.1a104.8,104.8,0,0,0-21.3,51.4,4.1,4.1,0,0,0,4,4.5H79.6A88,88,0,0,0,51.9,63.6,4,4,0,0,0,46,64.1ZM192.4,46.4a104.3,104.3,0,0,0-52-21.7,4,4,0,0,0-4.4,4V120h24.3a104.1,104.1,0,0,1,32.3-67.6A3.9,3.9,0,0,0,192.4,46.4Zm38.9,69.1A104.8,104.8,0,0,0,210,64.1a4,4,0,0,0-5.9-.5A88,88,0,0,0,176.4,120h50.9A4.1,4.1,0,0,0,231.3,115.5Zm-206.6,25A104.8,104.8,0,0,0,46,191.9a4,4,0,0,0,5.9.5A88,88,0,0,0,79.6,136H28.7A4.1,4.1,0,0,0,24.7,140.5ZM210,191.9a104.8,104.8,0,0,0,21.3-51.4,4.1,4.1,0,0,0-4-4.5H176.4a88,88,0,0,0,27.7,56.4A4,4,0,0,0,210,191.9ZM63.6,209.6a104.3,104.3,0,0,0,52,21.7,4,4,0,0,0,4.4-4V136H95.7a104.1,104.1,0,0,1-32.3,67.6A3.9,3.9,0,0,0,63.6,209.6ZM160.3,136H136v91.3a4,4,0,0,0,4.4,4,104.3,104.3,0,0,0,52-21.7,3.9,3.9,0,0,0,.2-6A104.1,104.1,0,0,1,160.3,136Z" }, null, -1), Klo = [
  Ilo
], Xlo = { key: 3 }, Jlo = ["stroke"], Qlo = ["stroke"], Ylo = ["stroke"], o2o = ["stroke"], e2o = ["stroke"], t2o = { key: 4 }, n2o = ["stroke"], s2o = ["stroke"], r2o = ["stroke"], i2o = ["stroke"], l2o = ["stroke"], d2o = { key: 5 }, k2o = ["stroke"], c2o = ["stroke"], h2o = ["stroke"], u2o = ["stroke"], a2o = ["stroke"], _2o = {
  name: "PhBasketball"
}, XD1 = /* @__PURE__ */ $({
  ..._2o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", blo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Llo),
        e("path", {
          d: "M60,60.2A95.9,95.9,0,0,1,88,128a95.9,95.9,0,0,1-28,67.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Blo),
        e("path", {
          d: "M196,60.2a96.1,96.1,0,0,0,0,135.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Plo),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wlo),
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nlo)
      ])) : o(i) === "duotone" ? (s(), r("g", Flo, [
        Tlo,
        Dlo,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rlo),
        e("path", {
          d: "M60,60.2A95.9,95.9,0,0,1,88,128a95.9,95.9,0,0,1-28,67.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ulo),
        e("path", {
          d: "M196,60.2a96.1,96.1,0,0,0,0,135.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qlo),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Glo),
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Elo)
      ])) : o(i) === "fill" ? (s(), r("g", Olo, Klo)) : o(i) === "light" ? (s(), r("g", Xlo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jlo),
        e("path", {
          d: "M60,60.2A95.9,95.9,0,0,1,88,128a95.9,95.9,0,0,1-28,67.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qlo),
        e("path", {
          d: "M196,60.2a96.1,96.1,0,0,0,0,135.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ylo),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, o2o),
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, e2o)
      ])) : o(i) === "thin" ? (s(), r("g", t2o, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, n2o),
        e("path", {
          d: "M60,60.2A95.9,95.9,0,0,1,88,128a95.9,95.9,0,0,1-28,67.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, s2o),
        e("path", {
          d: "M196,60.2a96.1,96.1,0,0,0,0,135.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, r2o),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, i2o),
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, l2o)
      ])) : o(i) === "regular" ? (s(), r("g", d2o, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k2o),
        e("path", {
          d: "M60,60.2A95.9,95.9,0,0,1,88,128a95.9,95.9,0,0,1-28,67.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c2o),
        e("path", {
          d: "M196,60.2a96.1,96.1,0,0,0,0,135.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h2o),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u2o),
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a2o)
      ])) : g("", !0)
    ], 16, Clo));
  }
}), p2o = ["width", "height", "fill", "transform"], y2o = { key: 0 }, $2o = ["stroke"], w2o = ["stroke"], f2o = ["stroke"], g2o = ["stroke"], x2o = ["stroke"], j2o = { key: 1 }, m2o = /* @__PURE__ */ e("path", {
  d: "M232,104H200v40H136V104H24a8,8,0,0,0-8,8v32a48,48,0,0,0,48,48H192a48,48,0,0,0,48-48V112A8,8,0,0,0,232,104Z",
  opacity: "0.2"
}, null, -1), M2o = ["stroke"], v2o = ["stroke"], S2o = ["stroke"], H2o = ["stroke"], A2o = ["stroke"], V2o = { key: 2 }, z2o = /* @__PURE__ */ e("path", { d: "M232,96H212a8,8,0,0,0-8-8H132a8,8,0,0,0-8,8H64V52a12,12,0,0,1,24,0,8,8,0,0,0,16,0,28,28,0,0,0-56,0V96H24A16,16,0,0,0,8,112v32a56,56,0,0,0,56,56v16a8,8,0,0,0,16,0V200h96v16a8,8,0,0,0,16,0V200a56,56,0,0,0,56-56V112A16,16,0,0,0,232,96Zm-36,8v36H140V104Z" }, null, -1), Z2o = [
  z2o
], C2o = { key: 3 }, b2o = ["stroke"], L2o = ["stroke"], B2o = ["stroke"], P2o = ["stroke"], W2o = ["stroke"], N2o = { key: 4 }, F2o = ["stroke"], T2o = ["stroke"], D2o = ["stroke"], R2o = ["stroke"], U2o = ["stroke"], q2o = { key: 5 }, G2o = ["stroke"], E2o = ["stroke"], O2o = ["stroke"], I2o = ["stroke"], K2o = ["stroke"], X2o = {
  name: "PhBathtub"
}, JD1 = /* @__PURE__ */ $({
  ...X2o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", y2o, [
        e("line", {
          x1: "72",
          y1: "192",
          x2: "72",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $2o),
        e("line", {
          x1: "184",
          y1: "192",
          x2: "184",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, w2o),
        e("path", {
          d: "M56,104V52a20,20,0,0,1,40,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f2o),
        e("rect", {
          x: "136",
          y: "96",
          width: "64",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g2o),
        e("path", {
          d: "M200,104h32a8,8,0,0,1,8,8v32a48,48,0,0,1-48,48H64a48,48,0,0,1-48-48V112a8,8,0,0,1,8-8H136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, x2o)
      ])) : o(i) === "duotone" ? (s(), r("g", j2o, [
        m2o,
        e("line", {
          x1: "72",
          y1: "192",
          x2: "72",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M2o),
        e("line", {
          x1: "184",
          y1: "192",
          x2: "184",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v2o),
        e("path", {
          d: "M56,104V52a20,20,0,0,1,40,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S2o),
        e("rect", {
          x: "136",
          y: "96",
          width: "64",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H2o),
        e("path", {
          d: "M200,104h32a8,8,0,0,1,8,8v32a48,48,0,0,1-48,48H64a48,48,0,0,1-48-48V112a8,8,0,0,1,8-8H136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A2o)
      ])) : o(i) === "fill" ? (s(), r("g", V2o, Z2o)) : o(i) === "light" ? (s(), r("g", C2o, [
        e("line", {
          x1: "72",
          y1: "192",
          x2: "72",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b2o),
        e("line", {
          x1: "184",
          y1: "192",
          x2: "184",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, L2o),
        e("path", {
          d: "M56,104V52a20,20,0,0,1,40,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, B2o),
        e("rect", {
          x: "136",
          y: "96",
          width: "64",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, P2o),
        e("path", {
          d: "M200,104h32a8,8,0,0,1,8,8v32a48,48,0,0,1-48,48H64a48,48,0,0,1-48-48V112a8,8,0,0,1,8-8H136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, W2o)
      ])) : o(i) === "thin" ? (s(), r("g", N2o, [
        e("line", {
          x1: "72",
          y1: "192",
          x2: "72",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, F2o),
        e("line", {
          x1: "184",
          y1: "192",
          x2: "184",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, T2o),
        e("path", {
          d: "M56,104V52a20,20,0,0,1,40,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, D2o),
        e("rect", {
          x: "136",
          y: "96",
          width: "64",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, R2o),
        e("path", {
          d: "M200,104h32a8,8,0,0,1,8,8v32a48,48,0,0,1-48,48H64a48,48,0,0,1-48-48V112a8,8,0,0,1,8-8H136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, U2o)
      ])) : o(i) === "regular" ? (s(), r("g", q2o, [
        e("line", {
          x1: "72",
          y1: "192",
          x2: "72",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G2o),
        e("line", {
          x1: "184",
          y1: "192",
          x2: "184",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E2o),
        e("path", {
          d: "M56,104V52a20,20,0,0,1,40,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O2o),
        e("rect", {
          x: "136",
          y: "96",
          width: "64",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I2o),
        e("path", {
          d: "M200,104h32a8,8,0,0,1,8,8v32a48,48,0,0,1-48,48H64a48,48,0,0,1-48-48V112a8,8,0,0,1,8-8H136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K2o)
      ])) : g("", !0)
    ], 16, p2o));
  }
}), J2o = ["width", "height", "fill", "transform"], Q2o = { key: 0 }, Y2o = ["stroke"], o0o = ["stroke"], e0o = ["stroke"], t0o = { key: 1 }, n0o = /* @__PURE__ */ e("rect", {
  x: "52",
  y: "36",
  width: "144",
  height: "184",
  rx: "16",
  transform: "translate(252 4) rotate(90)",
  opacity: "0.2"
}, null, -1), s0o = ["stroke"], r0o = ["stroke"], i0o = ["stroke"], l0o = { key: 2 }, d0o = /* @__PURE__ */ e("path", { d: "M248,88a8,8,0,0,0-8,8v64a8,8,0,0,0,16,0V96A8,8,0,0,0,248,88Z" }, null, -1), k0o = /* @__PURE__ */ e("path", { d: "M200,48H48A24.1,24.1,0,0,0,24,72V184a24.1,24.1,0,0,0,24,24H200a24.1,24.1,0,0,0,24-24V72A24.1,24.1,0,0,0,200,48Zm-52.6,83-16,40a7.9,7.9,0,0,1-7.4,5,8,8,0,0,1-3-.6,7.9,7.9,0,0,1-4.4-10.4l11.6-29H108a7.9,7.9,0,0,1-6.6-3.5,8,8,0,0,1-.8-7.5l16-40a8,8,0,1,1,14.8,6l-11.6,29H140a7.9,7.9,0,0,1,6.6,3.5A8,8,0,0,1,147.4,131Z" }, null, -1), c0o = [
  d0o,
  k0o
], h0o = { key: 3 }, u0o = ["stroke"], a0o = ["stroke"], _0o = ["stroke"], p0o = { key: 4 }, y0o = ["stroke"], $0o = ["stroke"], w0o = ["stroke"], f0o = { key: 5 }, g0o = ["stroke"], x0o = ["stroke"], j0o = ["stroke"], m0o = {
  name: "PhBatteryCharging"
}, QD1 = /* @__PURE__ */ $({
  ...m0o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Q2o, [
        e("rect", {
          x: "46",
          y: "38",
          width: "144",
          height: "180",
          rx: "16",
          transform: "translate(246 10) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Y2o),
        e("line", {
          x1: "244",
          y1: "96",
          x2: "244",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, o0o),
        e("polyline", {
          points: "118 168 134 128 102 128 118 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, e0o)
      ])) : o(i) === "duotone" ? (s(), r("g", t0o, [
        n0o,
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s0o),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r0o),
        e("polyline", {
          points: "124 168 140 128 108 128 124 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, i0o)
      ])) : o(i) === "fill" ? (s(), r("g", l0o, c0o)) : o(i) === "light" ? (s(), r("g", h0o, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u0o),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, a0o),
        e("polyline", {
          points: "124 168 140 128 108 128 124 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _0o)
      ])) : o(i) === "thin" ? (s(), r("g", p0o, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, y0o),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $0o),
        e("polyline", {
          points: "124 168 140 128 108 128 124 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, w0o)
      ])) : o(i) === "regular" ? (s(), r("g", f0o, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g0o),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, x0o),
        e("polyline", {
          points: "124 168 140 128 108 128 124 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j0o)
      ])) : g("", !0)
    ], 16, J2o));
  }
}), M0o = ["width", "height", "fill", "transform"], v0o = { key: 0 }, S0o = ["stroke"], H0o = ["stroke"], A0o = ["stroke"], V0o = { key: 1 }, z0o = /* @__PURE__ */ e("rect", {
  x: "56",
  y: "40",
  width: "144",
  height: "184",
  rx: "16",
  opacity: "0.2"
}, null, -1), Z0o = ["stroke"], C0o = ["stroke"], b0o = ["stroke"], L0o = { key: 2 }, B0o = /* @__PURE__ */ e("path", { d: "M96,16h64a8,8,0,0,0,0-16H96a8,8,0,0,0,0,16Z" }, null, -1), P0o = /* @__PURE__ */ e("path", { d: "M184,32H72A24.1,24.1,0,0,0,48,56V208a24.1,24.1,0,0,0,24,24H184a24.1,24.1,0,0,0,24-24V56A24.1,24.1,0,0,0,184,32ZM151.4,135l-16,40a7.9,7.9,0,0,1-7.4,5,8,8,0,0,1-3-.6,7.9,7.9,0,0,1-4.4-10.4l11.6-29H112a7.9,7.9,0,0,1-6.6-3.5,8,8,0,0,1-.8-7.5l16-40a8,8,0,1,1,14.8,6l-11.6,29H144a7.9,7.9,0,0,1,6.6,3.5A8,8,0,0,1,151.4,135Z" }, null, -1), W0o = [
  B0o,
  P0o
], N0o = { key: 3 }, F0o = ["stroke"], T0o = ["stroke"], D0o = ["stroke"], R0o = { key: 4 }, U0o = ["stroke"], q0o = ["stroke"], G0o = ["stroke"], E0o = { key: 5 }, O0o = ["stroke"], I0o = ["stroke"], K0o = ["stroke"], X0o = {
  name: "PhBatteryChargingVertical"
}, YD1 = /* @__PURE__ */ $({
  ...X0o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", v0o, [
        e("line", {
          x1: "100",
          y1: "12",
          x2: "156",
          y2: "12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, S0o),
        e("rect", {
          x: "56",
          y: "48",
          width: "144",
          height: "180",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, H0o),
        e("polyline", {
          points: "128 178 144 138 112 138 128 98",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, A0o)
      ])) : o(i) === "duotone" ? (s(), r("g", V0o, [
        z0o,
        e("line", {
          x1: "96",
          y1: "8",
          x2: "160",
          y2: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z0o),
        e("rect", {
          x: "56",
          y: "40",
          width: "144",
          height: "184",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C0o),
        e("polyline", {
          points: "128 172 144 132 112 132 128 92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b0o)
      ])) : o(i) === "fill" ? (s(), r("g", L0o, W0o)) : o(i) === "light" ? (s(), r("g", N0o, [
        e("line", {
          x1: "96",
          y1: "8",
          x2: "160",
          y2: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, F0o),
        e("rect", {
          x: "56",
          y: "40",
          width: "144",
          height: "184",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, T0o),
        e("polyline", {
          points: "128 172 144 132 112 132 128 92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, D0o)
      ])) : o(i) === "thin" ? (s(), r("g", R0o, [
        e("line", {
          x1: "96",
          y1: "8",
          x2: "160",
          y2: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, U0o),
        e("rect", {
          x: "56",
          y: "40",
          width: "144",
          height: "184",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, q0o),
        e("polyline", {
          points: "128 172 144 132 112 132 128 92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, G0o)
      ])) : o(i) === "regular" ? (s(), r("g", E0o, [
        e("line", {
          x1: "96",
          y1: "8",
          x2: "160",
          y2: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O0o),
        e("rect", {
          x: "56",
          y: "40",
          width: "144",
          height: "184",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I0o),
        e("polyline", {
          points: "128 172 144 132 112 132 128 92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K0o)
      ])) : g("", !0)
    ], 16, M0o));
  }
}), J0o = ["width", "height", "fill", "transform"], Q0o = { key: 0 }, Y0o = ["stroke"], o8o = ["stroke"], e8o = { key: 1 }, t8o = /* @__PURE__ */ e("rect", {
  x: "52",
  y: "36",
  width: "144",
  height: "184",
  rx: "16",
  transform: "translate(252 4) rotate(90)",
  opacity: "0.2"
}, null, -1), n8o = ["stroke"], s8o = ["stroke"], r8o = { key: 2 }, i8o = /* @__PURE__ */ e("path", { d: "M248,88a8,8,0,0,0-8,8v64a8,8,0,0,0,16,0V96A8,8,0,0,0,248,88Z" }, null, -1), l8o = /* @__PURE__ */ e("path", { d: "M200,48H48A24.1,24.1,0,0,0,24,72V184a24.1,24.1,0,0,0,24,24H200a24.1,24.1,0,0,0,24-24V72A24.1,24.1,0,0,0,200,48Zm8,136a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8Z" }, null, -1), d8o = [
  i8o,
  l8o
], k8o = { key: 3 }, c8o = ["stroke"], h8o = ["stroke"], u8o = { key: 4 }, a8o = ["stroke"], _8o = ["stroke"], p8o = { key: 5 }, y8o = ["stroke"], $8o = ["stroke"], w8o = {
  name: "PhBatteryEmpty"
}, oR1 = /* @__PURE__ */ $({
  ...w8o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Q0o, [
        e("rect", {
          x: "46",
          y: "38",
          width: "144",
          height: "180",
          rx: "16",
          transform: "translate(246 10) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Y0o),
        e("line", {
          x1: "244",
          y1: "96",
          x2: "244",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, o8o)
      ])) : o(i) === "duotone" ? (s(), r("g", e8o, [
        t8o,
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n8o),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s8o)
      ])) : o(i) === "fill" ? (s(), r("g", r8o, d8o)) : o(i) === "light" ? (s(), r("g", k8o, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, c8o),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, h8o)
      ])) : o(i) === "thin" ? (s(), r("g", u8o, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, a8o),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _8o)
      ])) : o(i) === "regular" ? (s(), r("g", p8o, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y8o),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $8o)
      ])) : g("", !0)
    ], 16, J0o));
  }
}), f8o = ["width", "height", "fill", "transform"], g8o = { key: 0 }, x8o = ["stroke"], j8o = ["stroke"], m8o = ["stroke"], M8o = ["stroke"], v8o = ["stroke"], S8o = ["stroke"], H8o = { key: 1 }, A8o = /* @__PURE__ */ e("rect", {
  x: "52",
  y: "36",
  width: "144",
  height: "184",
  rx: "16",
  transform: "translate(252 4) rotate(90)",
  opacity: "0.2"
}, null, -1), V8o = ["stroke"], z8o = ["stroke"], Z8o = ["stroke"], C8o = ["stroke"], b8o = ["stroke"], L8o = ["stroke"], B8o = { key: 2 }, P8o = /* @__PURE__ */ e("path", { d: "M248,88a8,8,0,0,0-8,8v64a8,8,0,0,0,16,0V96A8,8,0,0,0,248,88Z" }, null, -1), W8o = /* @__PURE__ */ e("path", { d: "M200,48H48A24.1,24.1,0,0,0,24,72V184a24.1,24.1,0,0,0,24,24H200a24.1,24.1,0,0,0,24-24V72A24.1,24.1,0,0,0,200,48Zm8,136a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8Z" }, null, -1), N8o = /* @__PURE__ */ e("rect", {
  x: "56",
  y: "80",
  width: "136",
  height: "96",
  rx: "8"
}, null, -1), F8o = [
  P8o,
  W8o,
  N8o
], T8o = { key: 3 }, D8o = ["stroke"], R8o = ["stroke"], U8o = ["stroke"], q8o = ["stroke"], G8o = ["stroke"], E8o = ["stroke"], O8o = { key: 4 }, I8o = ["stroke"], K8o = ["stroke"], X8o = ["stroke"], J8o = ["stroke"], Q8o = ["stroke"], Y8o = ["stroke"], odo = { key: 5 }, edo = ["stroke"], tdo = ["stroke"], ndo = ["stroke"], sdo = ["stroke"], rdo = ["stroke"], ido = ["stroke"], ldo = {
  name: "PhBatteryFull"
}, eR1 = /* @__PURE__ */ $({
  ...ldo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", g8o, [
        e("rect", {
          x: "46",
          y: "38",
          width: "144",
          height: "180",
          rx: "16",
          transform: "translate(246 10) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, x8o),
        e("line", {
          x1: "64",
          y1: "164",
          x2: "64",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, j8o),
        e("line", {
          x1: "100",
          y1: "164",
          x2: "100",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, m8o),
        e("line", {
          x1: "136",
          y1: "164",
          x2: "136",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, M8o),
        e("line", {
          x1: "172",
          y1: "164",
          x2: "172",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, v8o),
        e("line", {
          x1: "244",
          y1: "96",
          x2: "244",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, S8o)
      ])) : o(i) === "duotone" ? (s(), r("g", H8o, [
        A8o,
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, V8o),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, z8o),
        e("line", {
          x1: "142.4",
          y1: "168",
          x2: "142.4",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z8o),
        e("line", {
          x1: "105.6",
          y1: "168",
          x2: "105.6",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C8o),
        e("line", {
          x1: "68.8",
          y1: "168",
          x2: "68.8",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b8o),
        e("line", {
          x1: "179.2",
          y1: "168",
          x2: "179.2",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L8o)
      ])) : o(i) === "fill" ? (s(), r("g", B8o, F8o)) : o(i) === "light" ? (s(), r("g", T8o, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, D8o),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, R8o),
        e("line", {
          x1: "142.4",
          y1: "168",
          x2: "142.4",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, U8o),
        e("line", {
          x1: "105.6",
          y1: "168",
          x2: "105.6",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, q8o),
        e("line", {
          x1: "68.8",
          y1: "168",
          x2: "68.8",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, G8o),
        e("line", {
          x1: "179.2",
          y1: "168",
          x2: "179.2",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, E8o)
      ])) : o(i) === "thin" ? (s(), r("g", O8o, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, I8o),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, K8o),
        e("line", {
          x1: "142.4",
          y1: "168",
          x2: "142.4",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, X8o),
        e("line", {
          x1: "105.6",
          y1: "168",
          x2: "105.6",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, J8o),
        e("line", {
          x1: "68.8",
          y1: "168",
          x2: "68.8",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Q8o),
        e("line", {
          x1: "179.2",
          y1: "168",
          x2: "179.2",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Y8o)
      ])) : o(i) === "regular" ? (s(), r("g", odo, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, edo),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tdo),
        e("line", {
          x1: "142.4",
          y1: "168",
          x2: "142.4",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ndo),
        e("line", {
          x1: "105.6",
          y1: "168",
          x2: "105.6",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sdo),
        e("line", {
          x1: "68.8",
          y1: "168",
          x2: "68.8",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rdo),
        e("line", {
          x1: "179.2",
          y1: "168",
          x2: "179.2",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ido)
      ])) : g("", !0)
    ], 16, f8o));
  }
}), ddo = ["width", "height", "fill", "transform"], kdo = { key: 0 }, cdo = ["stroke"], hdo = ["stroke"], udo = ["stroke"], ado = ["stroke"], _do = ["stroke"], pdo = { key: 1 }, ydo = /* @__PURE__ */ e("rect", {
  x: "52",
  y: "36",
  width: "144",
  height: "184",
  rx: "16",
  transform: "translate(252 4) rotate(90)",
  opacity: "0.2"
}, null, -1), $do = ["stroke"], wdo = ["stroke"], fdo = ["stroke"], gdo = ["stroke"], xdo = ["stroke"], jdo = { key: 2 }, mdo = /* @__PURE__ */ e("path", { d: "M248,88a8,8,0,0,0-8,8v64a8,8,0,0,0,16,0V96A8,8,0,0,0,248,88Z" }, null, -1), Mdo = /* @__PURE__ */ e("path", { d: "M200,48H48A24.1,24.1,0,0,0,24,72V184a24.1,24.1,0,0,0,24,24H200a24.1,24.1,0,0,0,24-24V72A24.1,24.1,0,0,0,200,48Zm8,136a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8Z" }, null, -1), vdo = /* @__PURE__ */ e("rect", {
  x: "56",
  y: "80",
  width: "96",
  height: "96",
  rx: "8"
}, null, -1), Sdo = [
  mdo,
  Mdo,
  vdo
], Hdo = { key: 3 }, Ado = ["stroke"], Vdo = ["stroke"], zdo = ["stroke"], Zdo = ["stroke"], Cdo = ["stroke"], bdo = { key: 4 }, Ldo = ["stroke"], Bdo = ["stroke"], Pdo = ["stroke"], Wdo = ["stroke"], Ndo = ["stroke"], Fdo = { key: 5 }, Tdo = ["stroke"], Ddo = ["stroke"], Rdo = ["stroke"], Udo = ["stroke"], qdo = ["stroke"], Gdo = {
  name: "PhBatteryHigh"
}, tR1 = /* @__PURE__ */ $({
  ...Gdo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", kdo, [
        e("rect", {
          x: "46",
          y: "38",
          width: "144",
          height: "180",
          rx: "16",
          transform: "translate(246 10) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cdo),
        e("line", {
          x1: "64",
          y1: "164",
          x2: "64",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hdo),
        e("line", {
          x1: "100",
          y1: "164",
          x2: "100",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, udo),
        e("line", {
          x1: "136",
          y1: "164",
          x2: "136",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ado),
        e("line", {
          x1: "244",
          y1: "96",
          x2: "244",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _do)
      ])) : o(i) === "duotone" ? (s(), r("g", pdo, [
        ydo,
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $do),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wdo),
        e("line", {
          x1: "142.4",
          y1: "168",
          x2: "142.4",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fdo),
        e("line", {
          x1: "105.6",
          y1: "168",
          x2: "105.6",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gdo),
        e("line", {
          x1: "68.8",
          y1: "168",
          x2: "68.8",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xdo)
      ])) : o(i) === "fill" ? (s(), r("g", jdo, Sdo)) : o(i) === "light" ? (s(), r("g", Hdo, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ado),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vdo),
        e("line", {
          x1: "142.4",
          y1: "168",
          x2: "142.4",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zdo),
        e("line", {
          x1: "105.6",
          y1: "168",
          x2: "105.6",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zdo),
        e("line", {
          x1: "68.8",
          y1: "168",
          x2: "68.8",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cdo)
      ])) : o(i) === "thin" ? (s(), r("g", bdo, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ldo),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bdo),
        e("line", {
          x1: "142.4",
          y1: "168",
          x2: "142.4",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pdo),
        e("line", {
          x1: "105.6",
          y1: "168",
          x2: "105.6",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wdo),
        e("line", {
          x1: "68.8",
          y1: "168",
          x2: "68.8",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ndo)
      ])) : o(i) === "regular" ? (s(), r("g", Fdo, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tdo),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ddo),
        e("line", {
          x1: "142.4",
          y1: "168",
          x2: "142.4",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rdo),
        e("line", {
          x1: "105.6",
          y1: "168",
          x2: "105.6",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Udo),
        e("line", {
          x1: "68.8",
          y1: "168",
          x2: "68.8",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qdo)
      ])) : g("", !0)
    ], 16, ddo));
  }
}), Edo = ["width", "height", "fill", "transform"], Odo = { key: 0 }, Ido = ["stroke"], Kdo = ["stroke"], Xdo = ["stroke"], Jdo = { key: 1 }, Qdo = /* @__PURE__ */ e("rect", {
  x: "52",
  y: "36",
  width: "144",
  height: "184",
  rx: "16",
  transform: "translate(252 4) rotate(90)",
  opacity: "0.2"
}, null, -1), Ydo = ["stroke"], oko = ["stroke"], eko = ["stroke"], tko = { key: 2 }, nko = /* @__PURE__ */ e("path", { d: "M248,88a8,8,0,0,0-8,8v64a8,8,0,0,0,16,0V96A8,8,0,0,0,248,88Z" }, null, -1), sko = /* @__PURE__ */ e("path", { d: "M200,48H48A24.1,24.1,0,0,0,24,72V184a24.1,24.1,0,0,0,24,24H200a24.1,24.1,0,0,0,24-24V72A24.1,24.1,0,0,0,200,48Zm8,136a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8Z" }, null, -1), rko = /* @__PURE__ */ e("rect", {
  x: "56",
  y: "80",
  width: "32",
  height: "96",
  rx: "8"
}, null, -1), iko = [
  nko,
  sko,
  rko
], lko = { key: 3 }, dko = ["stroke"], kko = ["stroke"], cko = ["stroke"], hko = { key: 4 }, uko = ["stroke"], ako = ["stroke"], _ko = ["stroke"], pko = { key: 5 }, yko = ["stroke"], $ko = ["stroke"], wko = ["stroke"], fko = {
  name: "PhBatteryLow"
}, nR1 = /* @__PURE__ */ $({
  ...fko,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Odo, [
        e("rect", {
          x: "46",
          y: "38",
          width: "144",
          height: "180",
          rx: "16",
          transform: "translate(246 10) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ido),
        e("line", {
          x1: "64",
          y1: "164",
          x2: "64",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kdo),
        e("line", {
          x1: "244",
          y1: "96",
          x2: "244",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xdo)
      ])) : o(i) === "duotone" ? (s(), r("g", Jdo, [
        Qdo,
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ydo),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oko),
        e("line", {
          x1: "68.8",
          y1: "168",
          x2: "68.8",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eko)
      ])) : o(i) === "fill" ? (s(), r("g", tko, iko)) : o(i) === "light" ? (s(), r("g", lko, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dko),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kko),
        e("line", {
          x1: "68.8",
          y1: "168",
          x2: "68.8",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cko)
      ])) : o(i) === "thin" ? (s(), r("g", hko, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uko),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ako),
        e("line", {
          x1: "68.8",
          y1: "168",
          x2: "68.8",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _ko)
      ])) : o(i) === "regular" ? (s(), r("g", pko, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yko),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $ko),
        e("line", {
          x1: "68.8",
          y1: "168",
          x2: "68.8",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wko)
      ])) : g("", !0)
    ], 16, Edo));
  }
}), gko = ["width", "height", "fill", "transform"], xko = { key: 0 }, jko = ["stroke"], mko = ["stroke"], Mko = ["stroke"], vko = ["stroke"], Sko = { key: 1 }, Hko = /* @__PURE__ */ e("rect", {
  x: "52",
  y: "36",
  width: "144",
  height: "184",
  rx: "16",
  transform: "translate(252 4) rotate(90)",
  opacity: "0.2"
}, null, -1), Ako = ["stroke"], Vko = ["stroke"], zko = ["stroke"], Zko = ["stroke"], Cko = { key: 2 }, bko = /* @__PURE__ */ e("path", { d: "M248,88a8,8,0,0,0-8,8v64a8,8,0,0,0,16,0V96A8,8,0,0,0,248,88Z" }, null, -1), Lko = /* @__PURE__ */ e("path", { d: "M200,48H48A24.1,24.1,0,0,0,24,72V184a24.1,24.1,0,0,0,24,24H200a24.1,24.1,0,0,0,24-24V72A24.1,24.1,0,0,0,200,48Zm8,136a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8Z" }, null, -1), Bko = /* @__PURE__ */ e("rect", {
  x: "56",
  y: "80",
  width: "72",
  height: "96",
  rx: "8"
}, null, -1), Pko = [
  bko,
  Lko,
  Bko
], Wko = { key: 3 }, Nko = ["stroke"], Fko = ["stroke"], Tko = ["stroke"], Dko = ["stroke"], Rko = { key: 4 }, Uko = ["stroke"], qko = ["stroke"], Gko = ["stroke"], Eko = ["stroke"], Oko = { key: 5 }, Iko = ["stroke"], Kko = ["stroke"], Xko = ["stroke"], Jko = ["stroke"], Qko = {
  name: "PhBatteryMedium"
}, sR1 = /* @__PURE__ */ $({
  ...Qko,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xko, [
        e("rect", {
          x: "46",
          y: "38",
          width: "144",
          height: "180",
          rx: "16",
          transform: "translate(246 10) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jko),
        e("line", {
          x1: "64",
          y1: "164",
          x2: "64",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mko),
        e("line", {
          x1: "100",
          y1: "164",
          x2: "100",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mko),
        e("line", {
          x1: "244",
          y1: "96",
          x2: "244",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vko)
      ])) : o(i) === "duotone" ? (s(), r("g", Sko, [
        Hko,
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ako),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vko),
        e("line", {
          x1: "105.6",
          y1: "168",
          x2: "105.6",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zko),
        e("line", {
          x1: "68.8",
          y1: "168",
          x2: "68.8",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zko)
      ])) : o(i) === "fill" ? (s(), r("g", Cko, Pko)) : o(i) === "light" ? (s(), r("g", Wko, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Nko),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fko),
        e("line", {
          x1: "105.6",
          y1: "168",
          x2: "105.6",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Tko),
        e("line", {
          x1: "68.8",
          y1: "168",
          x2: "68.8",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dko)
      ])) : o(i) === "thin" ? (s(), r("g", Rko, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Uko),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qko),
        e("line", {
          x1: "105.6",
          y1: "168",
          x2: "105.6",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gko),
        e("line", {
          x1: "68.8",
          y1: "168",
          x2: "68.8",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Eko)
      ])) : o(i) === "regular" ? (s(), r("g", Oko, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Iko),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kko),
        e("line", {
          x1: "105.6",
          y1: "168",
          x2: "105.6",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xko),
        e("line", {
          x1: "68.8",
          y1: "168",
          x2: "68.8",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jko)
      ])) : g("", !0)
    ], 16, gko));
  }
}), Yko = ["width", "height", "fill", "transform"], oco = { key: 0 }, eco = ["stroke"], tco = ["stroke"], nco = ["stroke"], sco = ["stroke"], rco = { key: 1 }, ico = /* @__PURE__ */ e("rect", {
  x: "52",
  y: "36",
  width: "144",
  height: "184",
  rx: "16",
  transform: "translate(252 4) rotate(90)",
  opacity: "0.2"
}, null, -1), lco = ["stroke"], dco = ["stroke"], kco = ["stroke"], cco = ["stroke"], hco = { key: 2 }, uco = /* @__PURE__ */ e("path", { d: "M256,96v64a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0ZM224,72V184a24.1,24.1,0,0,1-24,24H48a24.1,24.1,0,0,1-24-24V72A24.1,24.1,0,0,1,48,48H200A24.1,24.1,0,0,1,224,72Zm-68,56a8,8,0,0,0-8-8H132V104a8,8,0,0,0-16,0v16H100a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V136h16A8,8,0,0,0,156,128Z" }, null, -1), aco = [
  uco
], _co = { key: 3 }, pco = ["stroke"], yco = ["stroke"], $co = ["stroke"], wco = ["stroke"], fco = { key: 4 }, gco = ["stroke"], xco = ["stroke"], jco = ["stroke"], mco = ["stroke"], Mco = { key: 5 }, vco = ["stroke"], Sco = ["stroke"], Hco = ["stroke"], Aco = ["stroke"], Vco = {
  name: "PhBatteryPlus"
}, rR1 = /* @__PURE__ */ $({
  ...Vco,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", oco, [
        e("rect", {
          x: "46",
          y: "38",
          width: "144",
          height: "180",
          rx: "16",
          transform: "translate(246 10) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eco),
        e("line", {
          x1: "244",
          y1: "96",
          x2: "244",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tco),
        e("line", {
          x1: "124",
          y1: "104",
          x2: "124",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nco),
        e("line", {
          x1: "100",
          y1: "128",
          x2: "148",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sco)
      ])) : o(i) === "duotone" ? (s(), r("g", rco, [
        ico,
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lco),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dco),
        e("line", {
          x1: "124",
          y1: "104",
          x2: "124",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kco),
        e("line", {
          x1: "100",
          y1: "128",
          x2: "148",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cco)
      ])) : o(i) === "fill" ? (s(), r("g", hco, aco)) : o(i) === "light" ? (s(), r("g", _co, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pco),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yco),
        e("line", {
          x1: "124",
          y1: "104",
          x2: "124",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $co),
        e("line", {
          x1: "100",
          y1: "128",
          x2: "148",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wco)
      ])) : o(i) === "thin" ? (s(), r("g", fco, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gco),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xco),
        e("line", {
          x1: "124",
          y1: "104",
          x2: "124",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jco),
        e("line", {
          x1: "100",
          y1: "128",
          x2: "148",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mco)
      ])) : o(i) === "regular" ? (s(), r("g", Mco, [
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vco),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sco),
        e("line", {
          x1: "124",
          y1: "104",
          x2: "124",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hco),
        e("line", {
          x1: "100",
          y1: "128",
          x2: "148",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Aco)
      ])) : g("", !0)
    ], 16, Yko));
  }
}), zco = ["width", "height", "fill", "transform"], Zco = { key: 0 }, Cco = ["stroke"], bco = ["stroke"], Lco = ["stroke"], Bco = /* @__PURE__ */ e("circle", {
  cx: "116",
  cy: "160",
  r: "16"
}, null, -1), Pco = { key: 1 }, Wco = /* @__PURE__ */ e("rect", {
  x: "52",
  y: "36",
  width: "144",
  height: "184",
  rx: "16",
  transform: "translate(252 4) rotate(90)",
  opacity: "0.2"
}, null, -1), Nco = ["stroke"], Fco = ["stroke"], Tco = ["stroke"], Dco = /* @__PURE__ */ e("circle", {
  cx: "124",
  cy: "164",
  r: "12"
}, null, -1), Rco = { key: 2 }, Uco = /* @__PURE__ */ e("path", { d: "M256,96v64a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0ZM224,72V184a24.1,24.1,0,0,1-24,24H48a24.1,24.1,0,0,1-24-24V72A24.1,24.1,0,0,1,48,48H200A24.1,24.1,0,0,1,224,72ZM116,128a8,8,0,0,0,16,0V88a8,8,0,0,0-16,0Zm20,36a12,12,0,1,0-12,12A12,12,0,0,0,136,164Z" }, null, -1), qco = [
  Uco
], Gco = { key: 3 }, Eco = ["stroke"], Oco = ["stroke"], Ico = ["stroke"], Kco = /* @__PURE__ */ e("circle", {
  cx: "124",
  cy: "164",
  r: "10"
}, null, -1), Xco = { key: 4 }, Jco = ["stroke"], Qco = ["stroke"], Yco = ["stroke"], oho = /* @__PURE__ */ e("circle", {
  cx: "124",
  cy: "164",
  r: "8"
}, null, -1), eho = { key: 5 }, tho = ["stroke"], nho = ["stroke"], sho = ["stroke"], rho = /* @__PURE__ */ e("circle", {
  cx: "124",
  cy: "164",
  r: "12"
}, null, -1), iho = {
  name: "PhBatteryWarning"
}, iR1 = /* @__PURE__ */ $({
  ...iho,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Zco, [
        e("rect", {
          x: "46",
          y: "38",
          width: "144",
          height: "180",
          rx: "16",
          transform: "translate(246 10) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cco),
        e("line", {
          x1: "244",
          y1: "96",
          x2: "244",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bco),
        e("line", {
          x1: "116",
          y1: "92",
          x2: "116",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lco),
        Bco
      ])) : o(i) === "duotone" ? (s(), r("g", Pco, [
        Wco,
        e("line", {
          x1: "124",
          y1: "88",
          x2: "124",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nco),
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fco),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tco),
        Dco
      ])) : o(i) === "fill" ? (s(), r("g", Rco, qco)) : o(i) === "light" ? (s(), r("g", Gco, [
        e("line", {
          x1: "124",
          y1: "88",
          x2: "124",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Eco),
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Oco),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ico),
        Kco
      ])) : o(i) === "thin" ? (s(), r("g", Xco, [
        e("line", {
          x1: "124",
          y1: "88",
          x2: "124",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jco),
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qco),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Yco),
        oho
      ])) : o(i) === "regular" ? (s(), r("g", eho, [
        e("line", {
          x1: "124",
          y1: "88",
          x2: "124",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tho),
        e("line", {
          x1: "248",
          y1: "96",
          x2: "248",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nho),
        e("rect", {
          x: "52",
          y: "36",
          width: "144",
          height: "184",
          rx: "16",
          transform: "translate(252 4) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sho),
        rho
      ])) : g("", !0)
    ], 16, zco));
  }
}), lho = ["width", "height", "fill", "transform"], dho = { key: 0 }, kho = ["stroke"], cho = ["stroke"], hho = ["stroke"], uho = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "176",
  r: "16"
}, null, -1), aho = { key: 1 }, _ho = /* @__PURE__ */ e("rect", {
  x: "56",
  y: "40",
  width: "144",
  height: "184",
  rx: "16",
  opacity: "0.2"
}, null, -1), pho = ["stroke"], yho = ["stroke"], $ho = ["stroke"], who = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "168",
  r: "12"
}, null, -1), fho = { key: 2 }, gho = /* @__PURE__ */ e("path", { d: "M88,8a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H96A8,8,0,0,1,88,8ZM208,56V208a24.1,24.1,0,0,1-24,24H72a24.1,24.1,0,0,1-24-24V56A24.1,24.1,0,0,1,72,32H184A24.1,24.1,0,0,1,208,56Zm-88,76a8,8,0,0,0,16,0V92a8,8,0,0,0-16,0Zm20,36a12,12,0,1,0-12,12A12,12,0,0,0,140,168Z" }, null, -1), xho = [
  gho
], jho = { key: 3 }, mho = ["stroke"], Mho = ["stroke"], vho = ["stroke"], Sho = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "168",
  r: "10"
}, null, -1), Hho = { key: 4 }, Aho = ["stroke"], Vho = ["stroke"], zho = ["stroke"], Zho = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "168",
  r: "8"
}, null, -1), Cho = { key: 5 }, bho = ["stroke"], Lho = ["stroke"], Bho = ["stroke"], Pho = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "168",
  r: "12"
}, null, -1), Who = {
  name: "PhBatteryWarningVertical"
}, lR1 = /* @__PURE__ */ $({
  ...Who,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", dho, [
        e("line", {
          x1: "100",
          y1: "12",
          x2: "156",
          y2: "12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kho),
        e("rect", {
          x: "56",
          y: "48",
          width: "144",
          height: "180",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cho),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hho),
        uho
      ])) : o(i) === "duotone" ? (s(), r("g", aho, [
        _ho,
        e("line", {
          x1: "128",
          y1: "92",
          x2: "128",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pho),
        e("line", {
          x1: "96",
          y1: "8",
          x2: "160",
          y2: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yho),
        e("rect", {
          x: "56",
          y: "40",
          width: "144",
          height: "184",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $ho),
        who
      ])) : o(i) === "fill" ? (s(), r("g", fho, xho)) : o(i) === "light" ? (s(), r("g", jho, [
        e("line", {
          x1: "128",
          y1: "92",
          x2: "128",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mho),
        e("line", {
          x1: "96",
          y1: "8",
          x2: "160",
          y2: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mho),
        e("rect", {
          x: "56",
          y: "40",
          width: "144",
          height: "184",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vho),
        Sho
      ])) : o(i) === "thin" ? (s(), r("g", Hho, [
        e("line", {
          x1: "128",
          y1: "92",
          x2: "128",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Aho),
        e("line", {
          x1: "96",
          y1: "8",
          x2: "160",
          y2: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vho),
        e("rect", {
          x: "56",
          y: "40",
          width: "144",
          height: "184",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zho),
        Zho
      ])) : o(i) === "regular" ? (s(), r("g", Cho, [
        e("line", {
          x1: "128",
          y1: "92",
          x2: "128",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bho),
        e("line", {
          x1: "96",
          y1: "8",
          x2: "160",
          y2: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lho),
        e("rect", {
          x: "56",
          y: "40",
          width: "144",
          height: "184",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bho),
        Pho
      ])) : g("", !0)
    ], 16, lho));
  }
}), Nho = ["width", "height", "fill", "transform"], Fho = { key: 0 }, Tho = ["stroke"], Dho = ["stroke"], Rho = ["stroke"], Uho = ["stroke"], qho = { key: 1 }, Gho = /* @__PURE__ */ e("path", {
  d: "M104,80H208a32,32,0,0,1,32,32v56a0,0,0,0,1,0,0H104a0,0,0,0,1,0,0V80A0,0,0,0,1,104,80Z",
  opacity: "0.2"
}, null, -1), Eho = ["stroke"], Oho = ["stroke"], Iho = ["stroke"], Kho = ["stroke"], Xho = { key: 2 }, Jho = /* @__PURE__ */ e("path", { d: "M208,72H24V48A8,8,0,0,0,8,48V208a8,8,0,0,0,16,0V176H232v32a8,8,0,0,0,16,0V112A40,40,0,0,0,208,72ZM24,88H96v72H24Z" }, null, -1), Qho = [
  Jho
], Yho = { key: 3 }, o6o = ["stroke"], e6o = ["stroke"], t6o = ["stroke"], n6o = ["stroke"], s6o = { key: 4 }, r6o = ["stroke"], i6o = ["stroke"], l6o = ["stroke"], d6o = ["stroke"], k6o = { key: 5 }, c6o = ["stroke"], h6o = ["stroke"], u6o = ["stroke"], a6o = ["stroke"], _6o = {
  name: "PhBed"
}, dR1 = /* @__PURE__ */ $({
  ..._6o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Fho, [
        e("path", {
          d: "M104,168V80H208a32,32,0,0,1,32,32v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Tho),
        e("line", {
          x1: "16",
          y1: "208",
          x2: "16",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Dho),
        e("polyline", {
          points: "16 168 240 168 240 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rho),
        e("line", {
          x1: "104",
          y1: "80",
          x2: "16",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Uho)
      ])) : o(i) === "duotone" ? (s(), r("g", qho, [
        Gho,
        e("path", {
          d: "M104,168V80H208a32,32,0,0,1,32,32v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Eho),
        e("line", {
          x1: "16",
          y1: "208",
          x2: "16",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Oho),
        e("polyline", {
          points: "16 168 240 168 240 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Iho),
        e("line", {
          x1: "104",
          y1: "80",
          x2: "16",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kho)
      ])) : o(i) === "fill" ? (s(), r("g", Xho, Qho)) : o(i) === "light" ? (s(), r("g", Yho, [
        e("path", {
          d: "M104,168V80H208a32,32,0,0,1,32,32v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, o6o),
        e("line", {
          x1: "16",
          y1: "208",
          x2: "16",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, e6o),
        e("polyline", {
          points: "16 168 240 168 240 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, t6o),
        e("line", {
          x1: "104",
          y1: "80",
          x2: "16",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, n6o)
      ])) : o(i) === "thin" ? (s(), r("g", s6o, [
        e("path", {
          d: "M104,168V80H208a32,32,0,0,1,32,32v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, r6o),
        e("line", {
          x1: "16",
          y1: "208",
          x2: "16",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, i6o),
        e("polyline", {
          points: "16 168 240 168 240 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, l6o),
        e("line", {
          x1: "104",
          y1: "80",
          x2: "16",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, d6o)
      ])) : o(i) === "regular" ? (s(), r("g", k6o, [
        e("path", {
          d: "M104,168V80H208a32,32,0,0,1,32,32v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c6o),
        e("line", {
          x1: "16",
          y1: "208",
          x2: "16",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h6o),
        e("polyline", {
          points: "16 168 240 168 240 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u6o),
        e("line", {
          x1: "104",
          y1: "80",
          x2: "16",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a6o)
      ])) : g("", !0)
    ], 16, Nho));
  }
}), p6o = ["width", "height", "fill", "transform"], y6o = { key: 0 }, $6o = ["stroke"], w6o = ["stroke"], f6o = ["stroke"], g6o = ["stroke"], x6o = { key: 1 }, j6o = /* @__PURE__ */ e("rect", {
  x: "60.4",
  y: "110.7",
  width: "79.2",
  height: "90.51",
  transform: "translate(-81 116.4) rotate(-45)",
  opacity: "0.2"
}, null, -1), m6o = ["stroke"], M6o = ["stroke"], v6o = ["stroke"], S6o = ["stroke"], H6o = { key: 2 }, A6o = /* @__PURE__ */ e("path", { d: "M245.7,42.3l-32-32a8.1,8.1,0,0,0-11.4,11.4l1.5,1.4L148.7,64.5l-38.3,7.7a8.5,8.5,0,0,0-4.1,2.1l-16,16h0l-56,56h0L21.7,159a23.9,23.9,0,0,0,0,34L63,234.3a23.9,23.9,0,0,0,34,0l12.7-12.6h0l56-56h0l16-16a8.5,8.5,0,0,0,2.1-4.1l7.7-38.3,41.4-55.1,1.4,1.5a8.2,8.2,0,0,0,11.4,0A8.1,8.1,0,0,0,245.7,42.3ZM74.3,223,33,181.7a8,8,0,0,1,0-11.4l7-7L92.7,216l-7,7A8.1,8.1,0,0,1,74.3,223ZM177.6,99.2a8.3,8.3,0,0,0-1.4,3.2l-7.6,37.7-8.6,8.6L107.3,96l8.6-8.6,37.7-7.6a8.3,8.3,0,0,0,3.2-1.4l58.4-43.8,6.2,6.2Z" }, null, -1), V6o = [
  A6o
], z6o = { key: 3 }, Z6o = ["stroke"], C6o = ["stroke"], b6o = ["stroke"], L6o = ["stroke"], B6o = { key: 4 }, P6o = ["stroke"], W6o = ["stroke"], N6o = ["stroke"], F6o = ["stroke"], T6o = { key: 5 }, D6o = ["stroke"], R6o = ["stroke"], U6o = ["stroke"], q6o = ["stroke"], G6o = {
  name: "PhBeerBottle"
}, kR1 = /* @__PURE__ */ $({
  ...G6o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", y6o, [
        e("line", {
          x1: "208",
          y1: "16",
          x2: "240",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $6o),
        e("path", {
          d: "M216,24,152,72l-40,8L27.3,164.7a16.1,16.1,0,0,0,0,22.6l41.4,41.4a16.1,16.1,0,0,0,22.6,0L176,144l8-40,48-64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, w6o),
        e("line", {
          x1: "96",
          y1: "96",
          x2: "160",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f6o),
        e("line", {
          x1: "108",
          y1: "212",
          x2: "44",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g6o)
      ])) : o(i) === "duotone" ? (s(), r("g", x6o, [
        j6o,
        e("line", {
          x1: "208",
          y1: "16",
          x2: "240",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m6o),
        e("path", {
          d: "M216,24,152,72l-40,8L27.3,164.7a16.1,16.1,0,0,0,0,22.6l41.4,41.4a16.1,16.1,0,0,0,22.6,0L176,144l8-40,48-64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M6o),
        e("line", {
          x1: "96",
          y1: "96",
          x2: "160",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v6o),
        e("line", {
          x1: "104",
          y1: "216",
          x2: "40",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S6o)
      ])) : o(i) === "fill" ? (s(), r("g", H6o, V6o)) : o(i) === "light" ? (s(), r("g", z6o, [
        e("line", {
          x1: "208",
          y1: "16",
          x2: "240",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Z6o),
        e("path", {
          d: "M216,24,152,72l-40,8L27.3,164.7a16.1,16.1,0,0,0,0,22.6l41.4,41.4a16.1,16.1,0,0,0,22.6,0L176,144l8-40,48-64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, C6o),
        e("line", {
          x1: "96",
          y1: "96",
          x2: "160",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b6o),
        e("line", {
          x1: "104",
          y1: "216",
          x2: "40",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, L6o)
      ])) : o(i) === "thin" ? (s(), r("g", B6o, [
        e("line", {
          x1: "208",
          y1: "16",
          x2: "240",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, P6o),
        e("path", {
          d: "M216,24,152,72l-40,8L27.3,164.7a16.1,16.1,0,0,0,0,22.6l41.4,41.4a16.1,16.1,0,0,0,22.6,0L176,144l8-40,48-64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, W6o),
        e("line", {
          x1: "96",
          y1: "96",
          x2: "160",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, N6o),
        e("line", {
          x1: "104",
          y1: "216",
          x2: "40",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, F6o)
      ])) : o(i) === "regular" ? (s(), r("g", T6o, [
        e("line", {
          x1: "208",
          y1: "16",
          x2: "240",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D6o),
        e("path", {
          d: "M216,24,152,72l-40,8L27.3,164.7a16.1,16.1,0,0,0,0,22.6l41.4,41.4a16.1,16.1,0,0,0,22.6,0L176,144l8-40,48-64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R6o),
        e("line", {
          x1: "96",
          y1: "96",
          x2: "160",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U6o),
        e("line", {
          x1: "104",
          y1: "216",
          x2: "40",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q6o)
      ])) : g("", !0)
    ], 16, p6o));
  }
}), E6o = ["width", "height", "fill", "transform"], O6o = { key: 0 }, I6o = ["stroke"], K6o = ["stroke"], X6o = ["stroke"], J6o = { key: 1 }, Q6o = ["stroke"], Y6o = ["stroke"], ouo = ["stroke"], euo = { key: 2 }, tuo = /* @__PURE__ */ e("path", { d: "M160,80a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H168A8,8,0,0,1,160,80Zm88,72a8,8,0,0,1-8,8H169a32.1,32.1,0,0,0,31,24,31.5,31.5,0,0,0,22.6-9.4,8,8,0,0,1,11.3,0,7.9,7.9,0,0,1,0,11.3A47.4,47.4,0,0,1,200,200a48,48,0,1,1,48-48Zm-17-8a32,32,0,0,0-62,0Zm-91,14a42,42,0,0,1-42,42H32a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H86a38,38,0,0,1,28.3,63.3A42,42,0,0,1,140,158ZM40,116H86a22,22,0,0,0,0-44H40Zm84,42a26.1,26.1,0,0,0-26-26H40v52H98A26.1,26.1,0,0,0,124,158Z" }, null, -1), nuo = [
  tuo
], suo = { key: 3 }, ruo = ["stroke"], iuo = ["stroke"], luo = ["stroke"], duo = { key: 4 }, kuo = ["stroke"], cuo = ["stroke"], huo = ["stroke"], uuo = { key: 5 }, auo = ["stroke"], _uo = ["stroke"], puo = ["stroke"], yuo = {
  name: "PhBehanceLogo"
}, cR1 = /* @__PURE__ */ $({
  ...yuo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", O6o, [
        e("line", {
          x1: "168",
          y1: "76",
          x2: "232",
          y2: "76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, I6o),
        e("path", {
          d: "M28,124H90a34,34,0,0,1,0,68H28V64H78a30,30,0,0,1,0,60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, K6o),
        e("path", {
          d: "M160,152h80a40,40,0,1,0-40,40,39.5,39.5,0,0,0,17.5-4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X6o)
      ])) : o(i) === "duotone" ? (s(), r("g", J6o, [
        e("line", {
          x1: "168",
          y1: "80",
          x2: "232",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q6o),
        e("path", {
          d: "M160,152h80a39.9,39.9,0,1,0-11.7,28.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y6o),
        e("path", {
          d: "M32,124H98a34,34,0,0,1,0,68H32V64H86a30,30,0,0,1,0,60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ouo)
      ])) : o(i) === "fill" ? (s(), r("g", euo, nuo)) : o(i) === "light" ? (s(), r("g", suo, [
        e("line", {
          x1: "168",
          y1: "80",
          x2: "232",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ruo),
        e("path", {
          d: "M160,152h80a39.9,39.9,0,1,0-11.7,28.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iuo),
        e("path", {
          d: "M32,124H98a34,34,0,0,1,0,68H32V64H86a30,30,0,0,1,0,60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, luo)
      ])) : o(i) === "thin" ? (s(), r("g", duo, [
        e("line", {
          x1: "168",
          y1: "80",
          x2: "232",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kuo),
        e("path", {
          d: "M160,152h80a39.9,39.9,0,1,0-11.7,28.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cuo),
        e("path", {
          d: "M32,124H98a34,34,0,0,1,0,68H32V64H86a30,30,0,0,1,0,60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, huo)
      ])) : o(i) === "regular" ? (s(), r("g", uuo, [
        e("line", {
          x1: "168",
          y1: "80",
          x2: "232",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, auo),
        e("path", {
          d: "M160,152h80a39.9,39.9,0,1,0-11.7,28.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _uo),
        e("path", {
          d: "M32,124H98a34,34,0,0,1,0,68H32V64H86a30,30,0,0,1,0,60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, puo)
      ])) : g("", !0)
    ], 16, E6o));
  }
}), $uo = ["width", "height", "fill", "transform"], wuo = { key: 0 }, fuo = ["stroke"], guo = ["stroke"], xuo = { key: 1 }, juo = /* @__PURE__ */ e("path", {
  d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
  opacity: "0.2"
}, null, -1), muo = ["stroke"], Muo = ["stroke"], vuo = { key: 2 }, Suo = /* @__PURE__ */ e("path", { d: "M220.8,175.9c-5.9-10.2-13-29.6-13-63.9v-7.1c0-44.3-35.5-80.6-79.2-80.9H128a79.9,79.9,0,0,0-79.8,80v8c0,34.3-7.1,53.7-13,63.9A16,16,0,0,0,49,200H88a40,40,0,0,0,80,0h39a15.9,15.9,0,0,0,13.9-8A16.2,16.2,0,0,0,220.8,175.9ZM128,224a24.1,24.1,0,0,1-24-24h48A24.1,24.1,0,0,1,128,224Z" }, null, -1), Huo = [
  Suo
], Auo = { key: 3 }, Vuo = ["stroke"], zuo = ["stroke"], Zuo = { key: 4 }, Cuo = ["stroke"], buo = ["stroke"], Luo = { key: 5 }, Buo = ["stroke"], Puo = ["stroke"], Wuo = {
  name: "PhBell"
}, hR1 = /* @__PURE__ */ $({
  ...Wuo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", wuo, [
        e("path", {
          d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fuo),
        e("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, guo)
      ])) : o(i) === "duotone" ? (s(), r("g", xuo, [
        juo,
        e("path", {
          d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, muo),
        e("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Muo)
      ])) : o(i) === "fill" ? (s(), r("g", vuo, Huo)) : o(i) === "light" ? (s(), r("g", Auo, [
        e("path", {
          d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vuo),
        e("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zuo)
      ])) : o(i) === "thin" ? (s(), r("g", Zuo, [
        e("path", {
          d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cuo),
        e("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, buo)
      ])) : o(i) === "regular" ? (s(), r("g", Luo, [
        e("path", {
          d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Buo),
        e("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Puo)
      ])) : g("", !0)
    ], 16, $uo));
  }
}), Nuo = ["width", "height", "fill", "transform"], Fuo = { key: 0 }, Tuo = ["stroke"], Duo = ["stroke"], Ruo = ["stroke"], Uuo = ["stroke"], quo = { key: 1 }, Guo = /* @__PURE__ */ e("path", {
  d: "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
  opacity: "0.2"
}, null, -1), Euo = ["stroke"], Ouo = ["stroke"], Iuo = ["stroke"], Kuo = ["stroke"], Xuo = { key: 2 }, Juo = /* @__PURE__ */ e("path", { d: "M207.8,112a79.7,79.7,0,0,0-79.2-80H128a79.9,79.9,0,0,0-79.8,80c0,34.3-7.1,53.7-13,63.9a16.2,16.2,0,0,0-.1,16.1A15.9,15.9,0,0,0,49,200H88a40,40,0,0,0,80,0h39a15.9,15.9,0,0,0,13.9-8,16.2,16.2,0,0,0-.1-16.1C214.9,165.7,207.8,146.3,207.8,112ZM128,224a24.1,24.1,0,0,1-24-24h48A24.1,24.1,0,0,1,128,224ZM224.9,73.3a9.3,9.3,0,0,1-3.5.8,7.9,7.9,0,0,1-7.2-4.5,97,97,0,0,0-35-38.8,8,8,0,0,1,8.5-13.6,111.7,111.7,0,0,1,40.8,45.4A8,8,0,0,1,224.9,73.3Zm-190.3.8a9.3,9.3,0,0,1-3.5-.8,8,8,0,0,1-3.6-10.7A111.7,111.7,0,0,1,68.3,17.2a8,8,0,0,1,8.5,13.6,97,97,0,0,0-35,38.8A7.9,7.9,0,0,1,34.6,74.1Z" }, null, -1), Quo = [
  Juo
], Yuo = { key: 3 }, o4o = ["stroke"], e4o = ["stroke"], t4o = ["stroke"], n4o = ["stroke"], s4o = { key: 4 }, r4o = ["stroke"], i4o = ["stroke"], l4o = ["stroke"], d4o = ["stroke"], k4o = { key: 5 }, c4o = ["stroke"], h4o = ["stroke"], u4o = ["stroke"], a4o = ["stroke"], _4o = {
  name: "PhBellRinging"
}, uR1 = /* @__PURE__ */ $({
  ..._4o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Fuo, [
        e("path", {
          d: "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Tuo),
        e("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Duo),
        e("path", {
          d: "M187.7,17.2a111.1,111.1,0,0,1,40.8,45.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ruo),
        e("path", {
          d: "M27.5,62.6A111.1,111.1,0,0,1,68.3,17.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Uuo)
      ])) : o(i) === "duotone" ? (s(), r("g", quo, [
        Guo,
        e("path", {
          d: "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Euo),
        e("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ouo),
        e("path", {
          d: "M183.4,24a105,105,0,0,1,38,42.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Iuo),
        e("path", {
          d: "M34.6,66.1A105,105,0,0,1,72.6,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kuo)
      ])) : o(i) === "fill" ? (s(), r("g", Xuo, Quo)) : o(i) === "light" ? (s(), r("g", Yuo, [
        e("path", {
          d: "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, o4o),
        e("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, e4o),
        e("path", {
          d: "M183.4,24a105,105,0,0,1,38,42.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, t4o),
        e("path", {
          d: "M34.6,66.1A105,105,0,0,1,72.6,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, n4o)
      ])) : o(i) === "thin" ? (s(), r("g", s4o, [
        e("path", {
          d: "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, r4o),
        e("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, i4o),
        e("path", {
          d: "M183.4,24a105,105,0,0,1,38,42.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, l4o),
        e("path", {
          d: "M34.6,66.1A105,105,0,0,1,72.6,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, d4o)
      ])) : o(i) === "regular" ? (s(), r("g", k4o, [
        e("path", {
          d: "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c4o),
        e("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h4o),
        e("path", {
          d: "M183.4,24a105,105,0,0,1,38,42.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u4o),
        e("path", {
          d: "M34.6,66.1A105,105,0,0,1,72.6,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a4o)
      ])) : g("", !0)
    ], 16, Nuo));
  }
}), p4o = ["width", "height", "fill", "transform"], y4o = { key: 0 }, $4o = ["stroke"], w4o = ["stroke"], f4o = { key: 1 }, g4o = /* @__PURE__ */ e("path", {
  d: "M56,104a72,72,0,0,1,72.5-72c39.8.3,71.5,33.2,71.5,72.9V112c0,35.8,7.5,56.6,14.1,68a7.9,7.9,0,0,1-6.9,12H48.8a7.9,7.9,0,0,1-6.9-12C48.5,168.6,56,147.8,56,112Z",
  opacity: "0.2"
}, null, -1), x4o = ["stroke"], j4o = ["stroke"], m4o = { key: 2 }, M4o = /* @__PURE__ */ e("path", { d: "M221,175.9c-5.9-10.2-13-29.6-13-63.9v-7.1c0-44.3-35.6-80.6-79.4-80.9H128a79.9,79.9,0,0,0-80,80v8c0,34.3-7.1,53.7-13,63.9a15.8,15.8,0,0,0-.1,16.1,15.9,15.9,0,0,0,13.9,8H207.2a15.9,15.9,0,0,0,13.9-8A15.8,15.8,0,0,0,221,175.9Z" }, null, -1), v4o = /* @__PURE__ */ e("path", { d: "M159.9,216h-64a8,8,0,1,0,0,16h64a8,8,0,0,0,0-16Z" }, null, -1), S4o = [
  M4o,
  v4o
], H4o = { key: 3 }, A4o = ["stroke"], V4o = ["stroke"], z4o = { key: 4 }, Z4o = ["stroke"], C4o = ["stroke"], b4o = { key: 5 }, L4o = ["stroke"], B4o = ["stroke"], P4o = {
  name: "PhBellSimple"
}, aR1 = /* @__PURE__ */ $({
  ...P4o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", y4o, [
        e("line", {
          x1: "96",
          y1: "228",
          x2: "160",
          y2: "228",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $4o),
        e("path", {
          d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V108c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, w4o)
      ])) : o(i) === "duotone" ? (s(), r("g", f4o, [
        g4o,
        e("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, x4o),
        e("path", {
          d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j4o)
      ])) : o(i) === "fill" ? (s(), r("g", m4o, S4o)) : o(i) === "light" ? (s(), r("g", H4o, [
        e("line", {
          x1: "95.9",
          y1: "224",
          x2: "159.9",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, A4o),
        e("path", {
          d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, V4o)
      ])) : o(i) === "thin" ? (s(), r("g", z4o, [
        e("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Z4o),
        e("path", {
          d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, C4o)
      ])) : o(i) === "regular" ? (s(), r("g", b4o, [
        e("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L4o),
        e("path", {
          d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B4o)
      ])) : g("", !0)
    ], 16, p4o));
  }
}), W4o = ["width", "height", "fill", "transform"], N4o = { key: 0 }, F4o = ["stroke"], T4o = ["stroke"], D4o = ["stroke"], R4o = ["stroke"], U4o = { key: 1 }, q4o = /* @__PURE__ */ e("path", {
  d: "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
  opacity: "0.2"
}, null, -1), G4o = ["stroke"], E4o = ["stroke"], O4o = ["stroke"], I4o = ["stroke"], K4o = { key: 2 }, X4o = /* @__PURE__ */ e("path", { d: "M168,224a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,224Zm39.8-112a79.7,79.7,0,0,0-79.2-80H128a79.9,79.9,0,0,0-79.8,80c0,34.3-7.1,53.7-13,63.9a16.2,16.2,0,0,0-.1,16.1A15.9,15.9,0,0,0,49,200H207a15.9,15.9,0,0,0,13.9-8,16.2,16.2,0,0,0-.1-16.1C214.9,165.7,207.8,146.3,207.8,112Zm20.7-49.4a111.7,111.7,0,0,0-40.8-45.4,8,8,0,0,0-8.5,13.6,97,97,0,0,1,35,38.8,7.9,7.9,0,0,0,7.2,4.5,9.3,9.3,0,0,0,3.5-.8A8,8,0,0,0,228.5,62.6Zm-186.7,7a97,97,0,0,1,35-38.8,8,8,0,0,0-8.5-13.6A111.7,111.7,0,0,0,27.5,62.6a8,8,0,0,0,3.6,10.7,9.3,9.3,0,0,0,3.5.8A7.9,7.9,0,0,0,41.8,69.6Z" }, null, -1), J4o = [
  X4o
], Q4o = { key: 3 }, Y4o = ["stroke"], oao = ["stroke"], eao = ["stroke"], tao = ["stroke"], nao = { key: 4 }, sao = ["stroke"], rao = ["stroke"], iao = ["stroke"], lao = ["stroke"], dao = { key: 5 }, kao = ["stroke"], cao = ["stroke"], hao = ["stroke"], uao = ["stroke"], aao = {
  name: "PhBellSimpleRinging"
}, _R1 = /* @__PURE__ */ $({
  ...aao,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", N4o, [
        e("line", {
          x1: "96",
          y1: "228",
          x2: "160",
          y2: "228",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, F4o),
        e("path", {
          d: "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,52.6,14.1,64a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-28.2,14.1-64Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, T4o),
        e("path", {
          d: "M187.7,17.2a111.1,111.1,0,0,1,40.8,45.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, D4o),
        e("path", {
          d: "M27.5,62.6A111.1,111.1,0,0,1,68.3,17.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, R4o)
      ])) : o(i) === "duotone" ? (s(), r("g", U4o, [
        q4o,
        e("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G4o),
        e("path", {
          d: "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E4o),
        e("path", {
          d: "M183.4,24a105,105,0,0,1,38,42.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O4o),
        e("path", {
          d: "M34.6,66.1A105,105,0,0,1,72.6,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I4o)
      ])) : o(i) === "fill" ? (s(), r("g", K4o, J4o)) : o(i) === "light" ? (s(), r("g", Q4o, [
        e("line", {
          x1: "95.9",
          y1: "224",
          x2: "159.9",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Y4o),
        e("path", {
          d: "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oao),
        e("path", {
          d: "M183.4,24a105,105,0,0,1,38,42.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eao),
        e("path", {
          d: "M34.6,66.1A105,105,0,0,1,72.6,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tao)
      ])) : o(i) === "thin" ? (s(), r("g", nao, [
        e("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sao),
        e("path", {
          d: "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rao),
        e("path", {
          d: "M183.4,24a105,105,0,0,1,38,42.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iao),
        e("path", {
          d: "M34.6,66.1A105,105,0,0,1,72.6,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lao)
      ])) : o(i) === "regular" ? (s(), r("g", dao, [
        e("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kao),
        e("path", {
          d: "M56.2,112a71.8,71.8,0,1,1,143.6,0h0c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cao),
        e("path", {
          d: "M183.4,24a105,105,0,0,1,38,42.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hao),
        e("path", {
          d: "M34.6,66.1A105,105,0,0,1,72.6,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uao)
      ])) : g("", !0)
    ], 16, W4o));
  }
}), _ao = ["width", "height", "fill", "transform"], pao = { key: 0 }, yao = ["stroke"], $ao = ["stroke"], wao = ["stroke"], fao = ["stroke"], gao = { key: 1 }, xao = /* @__PURE__ */ e("path", {
  d: "M56,104a72,72,0,0,1,72.5-72c39.8.3,71.5,33.2,71.5,72.9V112c0,35.8,7.5,56.6,14.1,68a7.9,7.9,0,0,1-6.9,12H48.8a7.9,7.9,0,0,1-6.9-12C48.5,168.6,56,147.8,56,112Z",
  opacity: "0.2"
}, null, -1), jao = ["stroke"], mao = ["stroke"], Mao = ["stroke"], vao = ["stroke"], Sao = { key: 2 }, Hao = /* @__PURE__ */ e("path", { d: "M213.9,210.6a7.9,7.9,0,0,1-.5,11.3A8.2,8.2,0,0,1,208,224a8,8,0,0,1-5.9-2.6L182.6,200H49a16,16,0,0,1-13.8-24.1c5.9-10.2,13-29.6,13-63.9v-8A80.2,80.2,0,0,1,58.9,63.9L42.1,45.4A8,8,0,0,1,53.9,34.6ZM160,216H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm42.9-41.3a8,8,0,0,0,5.9,2.6,7.9,7.9,0,0,0,4.2-1.2,8,8,0,0,0,3.3-9.7c-5.6-14.2-8.5-32.6-8.5-54.4v-7.1c0-44.3-35.5-80.6-79.2-80.9A80.2,80.2,0,0,0,88.5,34.4a8,8,0,0,0-3.9,5.7,8.2,8.2,0,0,0,2,6.7Z" }, null, -1), Aao = [
  Hao
], Vao = { key: 3 }, zao = ["stroke"], Zao = ["stroke"], Cao = ["stroke"], bao = ["stroke"], Lao = { key: 4 }, Bao = ["stroke"], Pao = ["stroke"], Wao = ["stroke"], Nao = ["stroke"], Fao = { key: 5 }, Tao = ["stroke"], Dao = ["stroke"], Rao = ["stroke"], Uao = ["stroke"], qao = {
  name: "PhBellSimpleSlash"
}, pR1 = /* @__PURE__ */ $({
  ...qao,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", pao, [
        e("line", {
          x1: "96",
          y1: "228",
          x2: "160",
          y2: "228",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yao),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $ao),
        e("path", {
          d: "M182.5,188H49a8,8,0,0,1-6.9-12.1c6.6-11.3,14.1-32.1,14.1-67.9v-4A72.4,72.4,0,0,1,68.9,63",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wao),
        e("path", {
          d: "M100,37.7A69.4,69.4,0,0,1,128.5,32c39.6.3,71.3,33.2,71.3,72.9V108c0,19,2.1,33.7,5.1,45.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fao)
      ])) : o(i) === "duotone" ? (s(), r("g", gao, [
        xao,
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jao),
        e("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mao),
        e("path", {
          d: "M92.5,41.4a70.8,70.8,0,0,1,36-9.4c39.6.3,71.3,33.2,71.3,72.9V112c0,26.7,4.2,45,9,57.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mao),
        e("path", {
          d: "M186.2,192H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68v-8A71.8,71.8,0,0,1,68.9,63.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vao)
      ])) : o(i) === "fill" ? (s(), r("g", Sao, Aao)) : o(i) === "light" ? (s(), r("g", Vao, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zao),
        e("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zao),
        e("path", {
          d: "M92.5,41.4a70.8,70.8,0,0,1,36-9.4c39.6.3,71.3,33.2,71.3,72.9V112c0,26.7,4.2,45,9,57.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cao),
        e("path", {
          d: "M186.2,192H49a8,8,0,0,1-6.9-12.1c6.6-11.3,14.1-32.1,14.1-67.9v-8A72.4,72.4,0,0,1,68.9,63",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bao)
      ])) : o(i) === "thin" ? (s(), r("g", Lao, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bao),
        e("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pao),
        e("path", {
          d: "M92.5,41.4a70.8,70.8,0,0,1,36-9.4c39.6.3,71.3,33.2,71.3,72.9V112c0,26.7,4.2,45,9,57.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wao),
        e("path", {
          d: "M186.2,192H49a8,8,0,0,1-6.9-12.1c6.6-11.3,14.1-32.1,14.1-67.9v-8A72.4,72.4,0,0,1,68.9,63",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nao)
      ])) : o(i) === "regular" ? (s(), r("g", Fao, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tao),
        e("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dao),
        e("path", {
          d: "M92.5,41.4a70.8,70.8,0,0,1,36-9.4c39.6.3,71.3,33.2,71.3,72.9V112c0,26.7,4.2,45,9,57.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rao),
        e("path", {
          d: "M186.2,192H49a8,8,0,0,1-6.9-12.1c6.6-11.3,14.1-32.1,14.1-67.9v-8A72.4,72.4,0,0,1,68.9,63",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uao)
      ])) : g("", !0)
    ], 16, _ao));
  }
}), Gao = ["width", "height", "fill", "transform"], Eao = { key: 0 }, Oao = ["stroke"], Iao = ["stroke"], Kao = ["stroke"], Xao = { key: 1 }, Jao = /* @__PURE__ */ e("path", {
  d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
  opacity: "0.2"
}, null, -1), Qao = ["stroke"], Yao = ["stroke"], o_o = ["stroke"], e_o = { key: 2 }, t_o = /* @__PURE__ */ e("path", { d: "M168,224a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,224Zm52.9-32a15.9,15.9,0,0,1-13.9,8H49a15.9,15.9,0,0,1-13.9-8,16.2,16.2,0,0,1,.1-16.1c5.9-10.2,13-29.6,13-63.9v-8A79.9,79.9,0,0,1,128,24h.6c43.7.3,79.2,36.6,79.2,80.9V112c0,34.3,7.1,53.7,13,63.9A16.2,16.2,0,0,1,220.9,192ZM156,144a8,8,0,0,0-8-8H125.1l29-34.9a7.8,7.8,0,0,0,1.1-8.5A7.9,7.9,0,0,0,148,88H108a8,8,0,0,0,0,16h22.9l-29,34.9a7.8,7.8,0,0,0-1.1,8.5A7.9,7.9,0,0,0,108,152h40A8,8,0,0,0,156,144Z" }, null, -1), n_o = [
  t_o
], s_o = { key: 3 }, r_o = ["stroke"], i_o = ["stroke"], l_o = ["stroke"], d_o = { key: 4 }, k_o = ["stroke"], c_o = ["stroke"], h_o = ["stroke"], u_o = { key: 5 }, a_o = ["stroke"], __o = ["stroke"], p_o = ["stroke"], y_o = {
  name: "PhBellSimpleZ"
}, yR1 = /* @__PURE__ */ $({
  ...y_o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Eao, [
        e("polyline", {
          points: "108 96 148 96 108 144 148 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Oao),
        e("line", {
          x1: "96",
          y1: "228",
          x2: "160",
          y2: "228",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Iao),
        e("path", {
          d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V108c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kao)
      ])) : o(i) === "duotone" ? (s(), r("g", Xao, [
        Jao,
        e("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qao),
        e("path", {
          d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yao),
        e("polyline", {
          points: "108 96 148 96 108 144 148 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o_o)
      ])) : o(i) === "fill" ? (s(), r("g", e_o, n_o)) : o(i) === "light" ? (s(), r("g", s_o, [
        e("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, r_o),
        e("path", {
          d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, i_o),
        e("polyline", {
          points: "108 96 148 96 108 144 148 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, l_o)
      ])) : o(i) === "thin" ? (s(), r("g", d_o, [
        e("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, k_o),
        e("path", {
          d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, c_o),
        e("polyline", {
          points: "108 96 148 96 108 144 148 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, h_o)
      ])) : o(i) === "regular" ? (s(), r("g", u_o, [
        e("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a_o),
        e("path", {
          d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, __o),
        e("polyline", {
          points: "108 96 148 96 108 144 148 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p_o)
      ])) : g("", !0)
    ], 16, Gao));
  }
}), $_o = ["width", "height", "fill", "transform"], w_o = { key: 0 }, f_o = ["stroke"], g_o = ["stroke"], x_o = ["stroke"], j_o = ["stroke"], m_o = { key: 1 }, M_o = /* @__PURE__ */ e("path", {
  d: "M56.2,104a71.8,71.8,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,67.9A8,8,0,0,1,207,192H49a8,8,0,0,1-6.9-12.1c6.6-11.3,14.1-32.1,14.1-67.9Z",
  opacity: "0.2"
}, null, -1), v_o = ["stroke"], S_o = ["stroke"], H_o = ["stroke"], A_o = ["stroke"], V_o = { key: 2 }, z_o = /* @__PURE__ */ e("path", { d: "M53.9,34.6A8,8,0,0,0,42.1,45.4L58.9,63.9A80.2,80.2,0,0,0,48.2,104v8c0,34.3-7.1,53.7-13,63.9A16,16,0,0,0,49,200H88a40,40,0,0,0,80,0h14.6l19.5,21.4A8,8,0,0,0,208,224a8.2,8.2,0,0,0,5.4-2.1,7.9,7.9,0,0,0,.5-11.3ZM128,224a24.1,24.1,0,0,1-24-24h48A24.1,24.1,0,0,1,128,224ZM86.6,46.8a8.1,8.1,0,0,1,1.9-12.4A80.2,80.2,0,0,1,128.6,24c43.7.3,79.2,36.6,79.2,80.9V112c0,21.9,2.8,40.1,8.4,54.4a8,8,0,0,1-13.3,8.3Z" }, null, -1), Z_o = [
  z_o
], C_o = { key: 3 }, b_o = ["stroke"], L_o = ["stroke"], B_o = ["stroke"], P_o = ["stroke"], W_o = { key: 4 }, N_o = ["stroke"], F_o = ["stroke"], T_o = ["stroke"], D_o = ["stroke"], R_o = { key: 5 }, U_o = ["stroke"], q_o = ["stroke"], G_o = ["stroke"], E_o = ["stroke"], O_o = {
  name: "PhBellSlash"
}, $R1 = /* @__PURE__ */ $({
  ...O_o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", w_o, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f_o),
        e("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g_o),
        e("path", {
          d: "M186.2,192H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68v-8A72.4,72.4,0,0,1,68.9,63",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, x_o),
        e("path", {
          d: "M100,37.7A71.1,71.1,0,0,1,128.5,32c39.6.3,71.3,33.2,71.3,72.9V112a187.1,187.1,0,0,0,3.8,39.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, j_o)
      ])) : o(i) === "duotone" ? (s(), r("g", m_o, [
        M_o,
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v_o),
        e("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S_o),
        e("path", {
          d: "M186.2,192H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68v-8A72.4,72.4,0,0,1,68.9,63",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H_o),
        e("path", {
          d: "M92.5,41.4a70.8,70.8,0,0,1,36-9.4c39.6.3,71.3,33.2,71.3,72.9V112c0,26.7,4.2,45,9,57.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A_o)
      ])) : o(i) === "fill" ? (s(), r("g", V_o, Z_o)) : o(i) === "light" ? (s(), r("g", C_o, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b_o),
        e("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, L_o),
        e("path", {
          d: "M186.2,192H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68v-8A72.4,72.4,0,0,1,68.9,63",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, B_o),
        e("path", {
          d: "M92.5,41.4a70.8,70.8,0,0,1,36-9.4c39.6.3,71.3,33.2,71.3,72.9V112c0,26.7,4.2,45,9,57.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, P_o)
      ])) : o(i) === "thin" ? (s(), r("g", W_o, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, N_o),
        e("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, F_o),
        e("path", {
          d: "M186.2,192H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68v-8A72.4,72.4,0,0,1,68.9,63",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, T_o),
        e("path", {
          d: "M92.5,41.4a70.8,70.8,0,0,1,36-9.4c39.6.3,71.3,33.2,71.3,72.9V112c0,26.7,4.2,45,9,57.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, D_o)
      ])) : o(i) === "regular" ? (s(), r("g", R_o, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U_o),
        e("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q_o),
        e("path", {
          d: "M186.2,192H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68v-8A72.4,72.4,0,0,1,68.9,63",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G_o),
        e("path", {
          d: "M92.5,41.4a70.8,70.8,0,0,1,36-9.4c39.6.3,71.3,33.2,71.3,72.9V112c0,26.7,4.2,45,9,57.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E_o)
      ])) : g("", !0)
    ], 16, $_o));
  }
}), I_o = ["width", "height", "fill", "transform"], K_o = { key: 0 }, X_o = ["stroke"], J_o = ["stroke"], Q_o = ["stroke"], Y_o = { key: 1 }, opo = /* @__PURE__ */ e("path", {
  d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
  opacity: "0.2"
}, null, -1), epo = ["stroke"], tpo = ["stroke"], npo = ["stroke"], spo = { key: 2 }, rpo = /* @__PURE__ */ e("path", { d: "M220.8,175.9c-5.9-10.2-13-29.6-13-63.9v-7.1c0-44.3-35.5-80.6-79.2-80.9H128a79.9,79.9,0,0,0-79.8,80v8c0,34.3-7.1,53.7-13,63.9a16.2,16.2,0,0,0-.1,16.1A15.9,15.9,0,0,0,49,200H88a40,40,0,0,0,80,0h39a15.9,15.9,0,0,0,13.9-8A16.2,16.2,0,0,0,220.8,175.9ZM128,224a24.1,24.1,0,0,1-24-24h48A24.1,24.1,0,0,1,128,224Zm20-72H108a7.9,7.9,0,0,1-7.2-4.6,7.8,7.8,0,0,1,1.1-8.5l29-34.9H108a8,8,0,0,1,0-16h40a7.9,7.9,0,0,1,7.2,4.6,7.8,7.8,0,0,1-1.1,8.5l-29,34.9H148a8,8,0,0,1,0,16Z" }, null, -1), ipo = [
  rpo
], lpo = { key: 3 }, dpo = ["stroke"], kpo = ["stroke"], cpo = ["stroke"], hpo = { key: 4 }, upo = ["stroke"], apo = ["stroke"], _po = ["stroke"], ppo = { key: 5 }, ypo = ["stroke"], $po = ["stroke"], wpo = ["stroke"], fpo = {
  name: "PhBellZ"
}, wR1 = /* @__PURE__ */ $({
  ...fpo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", K_o, [
        e("polyline", {
          points: "108 96 148 96 108 144 148 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X_o),
        e("path", {
          d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, J_o),
        e("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Q_o)
      ])) : o(i) === "duotone" ? (s(), r("g", Y_o, [
        opo,
        e("path", {
          d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, epo),
        e("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tpo),
        e("polyline", {
          points: "108 96 148 96 108 144 148 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, npo)
      ])) : o(i) === "fill" ? (s(), r("g", spo, ipo)) : o(i) === "light" ? (s(), r("g", lpo, [
        e("path", {
          d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dpo),
        e("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kpo),
        e("polyline", {
          points: "108 96 148 96 108 144 148 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cpo)
      ])) : o(i) === "thin" ? (s(), r("g", hpo, [
        e("path", {
          d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, upo),
        e("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, apo),
        e("polyline", {
          points: "108 96 148 96 108 144 148 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _po)
      ])) : o(i) === "regular" ? (s(), r("g", ppo, [
        e("path", {
          d: "M56.2,104a71.9,71.9,0,0,1,72.3-72c39.6.3,71.3,33.2,71.3,72.9V112c0,35.8,7.5,56.6,14.1,68a8,8,0,0,1-6.9,12H49a8,8,0,0,1-6.9-12c6.6-11.4,14.1-32.2,14.1-68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ypo),
        e("path", {
          d: "M96,192v8a32,32,0,0,0,64,0v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $po),
        e("polyline", {
          points: "108 96 148 96 108 144 148 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wpo)
      ])) : g("", !0)
    ], 16, I_o));
  }
}), gpo = ["width", "height", "fill", "transform"], xpo = { key: 0 }, jpo = ["stroke"], mpo = ["stroke"], Mpo = ["stroke"], vpo = ["stroke"], Spo = ["stroke"], Hpo = ["stroke"], Apo = ["stroke"], Vpo = { key: 1 }, zpo = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "80",
  r: "24",
  opacity: "0.2"
}, null, -1), Zpo = /* @__PURE__ */ e("circle", {
  cx: "40",
  cy: "176",
  r: "24",
  opacity: "0.2"
}, null, -1), Cpo = /* @__PURE__ */ e("circle", {
  cx: "216",
  cy: "176",
  r: "24",
  opacity: "0.2"
}, null, -1), bpo = ["stroke"], Lpo = ["stroke"], Bpo = ["stroke"], Ppo = ["stroke"], Wpo = ["stroke"], Npo = ["stroke"], Fpo = ["stroke"], Tpo = { key: 2 }, Dpo = /* @__PURE__ */ e("path", { d: "M221,144.4A95.9,95.9,0,0,0,181,88h59a8,8,0,0,0,0-16H159a32,32,0,0,0-62,0H16a8,8,0,0,0,0,16H75a95.9,95.9,0,0,0-40,56.4A32,32,0,1,0,71,184H185a32,32,0,1,0,36-39.6ZM40,192a16,16,0,1,1,16-16A16,16,0,0,1,40,192ZM128,64a16,16,0,1,1-16,16A16,16,0,0,1,128,64Zm88,128a16,16,0,1,1,16-16A16,16,0,0,1,216,192Z" }, null, -1), Rpo = [
  Dpo
], Upo = { key: 3 }, qpo = ["stroke"], Gpo = ["stroke"], Epo = ["stroke"], Opo = ["stroke"], Ipo = ["stroke"], Kpo = ["stroke"], Xpo = ["stroke"], Jpo = { key: 4 }, Qpo = ["stroke"], Ypo = ["stroke"], o3o = ["stroke"], e3o = ["stroke"], t3o = ["stroke"], n3o = ["stroke"], s3o = ["stroke"], r3o = { key: 5 }, i3o = ["stroke"], l3o = ["stroke"], d3o = ["stroke"], k3o = ["stroke"], c3o = ["stroke"], h3o = ["stroke"], u3o = ["stroke"], a3o = {
  name: "PhBezierCurve"
}, fR1 = /* @__PURE__ */ $({
  ...a3o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xpo, [
        e("line", {
          x1: "16",
          y1: "80",
          x2: "104",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jpo),
        e("line", {
          x1: "152",
          y1: "80",
          x2: "240",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mpo),
        e("circle", {
          cx: "128",
          cy: "80",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mpo),
        e("circle", {
          cx: "40",
          cy: "176",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vpo),
        e("circle", {
          cx: "216",
          cy: "176",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Spo),
        e("path", {
          d: "M151.8,83.3A88.1,88.1,0,0,1,214.6,152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hpo),
        e("path", {
          d: "M41.4,152a88.1,88.1,0,0,1,62.8-68.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Apo)
      ])) : o(i) === "duotone" ? (s(), r("g", Vpo, [
        zpo,
        Zpo,
        Cpo,
        e("line", {
          x1: "16",
          y1: "80",
          x2: "104",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bpo),
        e("line", {
          x1: "152",
          y1: "80",
          x2: "240",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lpo),
        e("circle", {
          cx: "128",
          cy: "80",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bpo),
        e("circle", {
          cx: "40",
          cy: "176",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ppo),
        e("circle", {
          cx: "216",
          cy: "176",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wpo),
        e("path", {
          d: "M151.8,83.3A88.1,88.1,0,0,1,214.6,152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Npo),
        e("path", {
          d: "M41.4,152a88.1,88.1,0,0,1,62.8-68.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fpo)
      ])) : o(i) === "fill" ? (s(), r("g", Tpo, Rpo)) : o(i) === "light" ? (s(), r("g", Upo, [
        e("line", {
          x1: "16",
          y1: "80",
          x2: "104",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qpo),
        e("line", {
          x1: "152",
          y1: "80",
          x2: "240",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gpo),
        e("circle", {
          cx: "128",
          cy: "80",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Epo),
        e("circle", {
          cx: "40",
          cy: "176",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Opo),
        e("circle", {
          cx: "216",
          cy: "176",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ipo),
        e("path", {
          d: "M151.8,83.3A88.1,88.1,0,0,1,214.6,152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kpo),
        e("path", {
          d: "M41.4,152a88.1,88.1,0,0,1,62.8-68.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xpo)
      ])) : o(i) === "thin" ? (s(), r("g", Jpo, [
        e("line", {
          x1: "16",
          y1: "80",
          x2: "104",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qpo),
        e("line", {
          x1: "152",
          y1: "80",
          x2: "240",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ypo),
        e("circle", {
          cx: "128",
          cy: "80",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, o3o),
        e("circle", {
          cx: "40",
          cy: "176",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, e3o),
        e("circle", {
          cx: "216",
          cy: "176",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, t3o),
        e("path", {
          d: "M151.8,83.3A88.1,88.1,0,0,1,214.6,152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, n3o),
        e("path", {
          d: "M41.4,152a88.1,88.1,0,0,1,62.8-68.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, s3o)
      ])) : o(i) === "regular" ? (s(), r("g", r3o, [
        e("line", {
          x1: "16",
          y1: "80",
          x2: "104",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, i3o),
        e("line", {
          x1: "152",
          y1: "80",
          x2: "240",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l3o),
        e("circle", {
          cx: "128",
          cy: "80",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, d3o),
        e("circle", {
          cx: "40",
          cy: "176",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k3o),
        e("circle", {
          cx: "216",
          cy: "176",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c3o),
        e("path", {
          d: "M151.8,83.3A88.1,88.1,0,0,1,214.6,152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h3o),
        e("path", {
          d: "M41.4,152a88.1,88.1,0,0,1,62.8-68.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u3o)
      ])) : g("", !0)
    ], 16, gpo));
  }
}), _3o = ["width", "height", "fill", "transform"], p3o = { key: 0 }, y3o = ["stroke"], $3o = ["stroke"], w3o = ["stroke"], f3o = ["stroke"], g3o = ["stroke"], x3o = { key: 1 }, j3o = /* @__PURE__ */ e("circle", {
  cx: "208",
  cy: "160",
  r: "40",
  opacity: "0.2"
}, null, -1), m3o = /* @__PURE__ */ e("circle", {
  cx: "48",
  cy: "160",
  r: "40",
  opacity: "0.2"
}, null, -1), M3o = ["stroke"], v3o = ["stroke"], S3o = ["stroke"], H3o = ["stroke"], A3o = ["stroke"], V3o = { key: 2 }, z3o = /* @__PURE__ */ e("path", { d: "M256,160a48,48,0,1,1-78.7-36.8L201.1,164a8,8,0,1,0,13.8-8l-23.8-40.9A47,47,0,0,1,208,112,48,48,0,0,1,256,160ZM48,168a8.2,8.2,0,0,1-4.7-1.5,8,8,0,0,1-1.8-11.2l27.9-38.2A46.6,46.6,0,0,0,48,112a48.1,48.1,0,1,0,34.3,14.5L54.5,164.7A7.9,7.9,0,0,1,48,168ZM165.9,72H192a8,8,0,0,1,8,8,8,8,0,0,0,16,0,24.1,24.1,0,0,0-24-24H152a7.8,7.8,0,0,0-6.9,4,7.7,7.7,0,0,0,0,8l11.6,20H99.3L82.9,60A7.9,7.9,0,0,0,76,56H48a8,8,0,0,0,0,16H71.4L85.1,95.5,69.4,117.1a48.1,48.1,0,0,1,12.9,9.4l11.6-15.9L125.1,164a8,8,0,1,0,13.8-8l-30.3-52h57.5l11.2,19.2a46.5,46.5,0,0,1,13.8-8.1Z" }, null, -1), Z3o = [
  z3o
], C3o = { key: 3 }, b3o = ["stroke"], L3o = ["stroke"], B3o = ["stroke"], P3o = ["stroke"], W3o = ["stroke"], N3o = { key: 4 }, F3o = ["stroke"], T3o = ["stroke"], D3o = ["stroke"], R3o = ["stroke"], U3o = ["stroke"], q3o = { key: 5 }, G3o = ["stroke"], E3o = ["stroke"], O3o = ["stroke"], I3o = ["stroke"], K3o = ["stroke"], X3o = {
  name: "PhBicycle"
}, gR1 = /* @__PURE__ */ $({
  ...X3o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", p3o, [
        e("path", {
          d: "M208,80a16,16,0,0,0-16-16H148l56,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, y3o),
        e("circle", {
          cx: "204",
          cy: "160",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $3o),
        e("circle", {
          cx: "52",
          cy: "160",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, w3o),
        e("polyline", {
          points: "166.7 96 102.7 96 52 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f3o),
        e("polyline", {
          points: "52 64 84 64 128.3 140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g3o)
      ])) : o(i) === "duotone" ? (s(), r("g", x3o, [
        j3o,
        m3o,
        e("path", {
          d: "M208,80a16,16,0,0,0-16-16H152l56,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M3o),
        e("circle", {
          cx: "208",
          cy: "160",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v3o),
        e("circle", {
          cx: "48",
          cy: "160",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S3o),
        e("polyline", {
          points: "48 64 76 64 132 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H3o),
        e("polyline", {
          points: "170.1 96 94.7 96 48 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A3o)
      ])) : o(i) === "fill" ? (s(), r("g", V3o, Z3o)) : o(i) === "light" ? (s(), r("g", C3o, [
        e("path", {
          d: "M208,80a16,16,0,0,0-16-16H152l56,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b3o),
        e("circle", {
          cx: "208",
          cy: "160",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, L3o),
        e("circle", {
          cx: "48",
          cy: "160",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, B3o),
        e("polyline", {
          points: "48 64 76 64 132 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, P3o),
        e("polyline", {
          points: "170.1 96 94.7 96 48 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, W3o)
      ])) : o(i) === "thin" ? (s(), r("g", N3o, [
        e("path", {
          d: "M208,80a16,16,0,0,0-16-16H152l56,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, F3o),
        e("circle", {
          cx: "208",
          cy: "160",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, T3o),
        e("circle", {
          cx: "48",
          cy: "160",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, D3o),
        e("polyline", {
          points: "48 64 76 64 132 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, R3o),
        e("polyline", {
          points: "170.1 96 94.7 96 48 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, U3o)
      ])) : o(i) === "regular" ? (s(), r("g", q3o, [
        e("path", {
          d: "M208,80a16,16,0,0,0-16-16H152l56,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G3o),
        e("circle", {
          cx: "208",
          cy: "160",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E3o),
        e("circle", {
          cx: "48",
          cy: "160",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O3o),
        e("polyline", {
          points: "48 64 76 64 132 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I3o),
        e("polyline", {
          points: "170.1 96 94.7 96 48 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K3o)
      ])) : g("", !0)
    ], 16, _3o));
  }
}), J3o = ["width", "height", "fill", "transform"], Q3o = { key: 0 }, Y3o = ["stroke"], oyo = ["stroke"], eyo = ["stroke"], tyo = ["stroke"], nyo = ["stroke"], syo = { key: 1 }, ryo = /* @__PURE__ */ e("circle", {
  cx: "64",
  cy: "168",
  r: "40",
  opacity: "0.2"
}, null, -1), iyo = /* @__PURE__ */ e("circle", {
  cx: "192",
  cy: "168",
  r: "40",
  opacity: "0.2"
}, null, -1), lyo = ["stroke"], dyo = ["stroke"], kyo = ["stroke"], cyo = ["stroke"], hyo = ["stroke"], uyo = { key: 2 }, ayo = /* @__PURE__ */ e("path", { d: "M237.2,151.9h0c0-.1-.1-.1-.1-.2a42.3,42.3,0,0,0-2.3-5.3L193.3,51.8a8.1,8.1,0,0,0-1.7-2.4,32,32,0,0,0-45.3,0A7.9,7.9,0,0,0,144,55V84H112V55a7.9,7.9,0,0,0-2.3-5.6,32,32,0,0,0-45.3,0,8.1,8.1,0,0,0-1.7,2.4L21.2,146.3a42.3,42.3,0,0,0-2.3,5.3c0,.1-.1.1-.1.2h0A48,48,0,1,0,112,167.8V100h32v67.8a48,48,0,1,0,93.2-15.9Zm-143.1,27a32,32,0,0,1-60.2-21.7l1.8-4.1A32,32,0,0,1,96,167.9h0A32.1,32.1,0,0,1,94.1,178.9Zm108.8,19.2A32,32,0,0,1,160,168h0a32,32,0,0,1,60.3-14.8l1.8,4.1A32,32,0,0,1,202.9,198.1Z" }, null, -1), _yo = [
  ayo
], pyo = { key: 3 }, yyo = ["stroke"], $yo = ["stroke"], wyo = ["stroke"], fyo = ["stroke"], gyo = ["stroke"], xyo = { key: 4 }, jyo = ["stroke"], myo = ["stroke"], Myo = ["stroke"], vyo = ["stroke"], Syo = ["stroke"], Hyo = { key: 5 }, Ayo = ["stroke"], Vyo = ["stroke"], zyo = ["stroke"], Zyo = ["stroke"], Cyo = ["stroke"], byo = {
  name: "PhBinoculars"
}, xR1 = /* @__PURE__ */ $({
  ...byo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Q3o, [
        e("line", {
          x1: "104",
          y1: "92",
          x2: "152",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Y3o),
        e("path", {
          d: "M229.6,154.3,185.9,55A24.1,24.1,0,0,0,152,55V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oyo),
        e("path", {
          d: "M104,168V55a24.1,24.1,0,0,0-33.9,0L26.4,154.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eyo),
        e("circle", {
          cx: "64",
          cy: "168",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tyo),
        e("circle", {
          cx: "192",
          cy: "168",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nyo)
      ])) : o(i) === "duotone" ? (s(), r("g", syo, [
        ryo,
        iyo,
        e("line", {
          x1: "104",
          y1: "92",
          x2: "152",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lyo),
        e("path", {
          d: "M229.6,154.3,185.9,55A24.1,24.1,0,0,0,152,55V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dyo),
        e("path", {
          d: "M104,168V55a24.1,24.1,0,0,0-33.9,0L26.4,154.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kyo),
        e("circle", {
          cx: "64",
          cy: "168",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cyo),
        e("circle", {
          cx: "192",
          cy: "168",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hyo)
      ])) : o(i) === "fill" ? (s(), r("g", uyo, _yo)) : o(i) === "light" ? (s(), r("g", pyo, [
        e("line", {
          x1: "104",
          y1: "92",
          x2: "152",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yyo),
        e("path", {
          d: "M229.6,154.3,185.9,55A24.1,24.1,0,0,0,152,55V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $yo),
        e("path", {
          d: "M104,168V55a24.1,24.1,0,0,0-33.9,0L26.4,154.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wyo),
        e("circle", {
          cx: "64",
          cy: "168",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fyo),
        e("circle", {
          cx: "192",
          cy: "168",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gyo)
      ])) : o(i) === "thin" ? (s(), r("g", xyo, [
        e("line", {
          x1: "104",
          y1: "92",
          x2: "152",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jyo),
        e("path", {
          d: "M229.6,154.3,185.9,55A24.1,24.1,0,0,0,152,55V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, myo),
        e("path", {
          d: "M104,168V55a24.1,24.1,0,0,0-33.9,0L26.4,154.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Myo),
        e("circle", {
          cx: "64",
          cy: "168",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vyo),
        e("circle", {
          cx: "192",
          cy: "168",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Syo)
      ])) : o(i) === "regular" ? (s(), r("g", Hyo, [
        e("line", {
          x1: "104",
          y1: "92",
          x2: "152",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ayo),
        e("path", {
          d: "M229.6,154.3,185.9,55A24.1,24.1,0,0,0,152,55V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vyo),
        e("path", {
          d: "M104,168V55a24.1,24.1,0,0,0-33.9,0L26.4,154.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zyo),
        e("circle", {
          cx: "64",
          cy: "168",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zyo),
        e("circle", {
          cx: "192",
          cy: "168",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cyo)
      ])) : g("", !0)
    ], 16, J3o));
  }
}), Lyo = ["width", "height", "fill", "transform"], Byo = { key: 0 }, Pyo = /* @__PURE__ */ e("circle", {
  cx: "160",
  cy: "72",
  r: "16"
}, null, -1), Wyo = ["stroke"], Nyo = ["stroke"], Fyo = { key: 1 }, Tyo = /* @__PURE__ */ e("path", {
  d: "M208,96v24a96,96,0,0,1-96,96H8L104,96V76A52,52,0,0,1,206.3,62.9L232,80Z",
  opacity: "0.2"
}, null, -1), Dyo = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "68",
  r: "12"
}, null, -1), Ryo = ["stroke"], Uyo = ["stroke"], qyo = { key: 2 }, Gyo = /* @__PURE__ */ e("path", { d: "M236.4,73.3,213.2,57.9A60,60,0,0,0,96,76V93.2L1.8,211A8,8,0,0,0,8,224H112A104.2,104.2,0,0,0,216,120V100.3l20.4-13.6a8,8,0,0,0,0-13.4ZM110.1,141.1l-40,48a8,8,0,0,1-12.2-10.2l40-48a8,8,0,1,1,12.2,10.2ZM164,80a12,12,0,1,1,12-12A12,12,0,0,1,164,80Z" }, null, -1), Eyo = [
  Gyo
], Oyo = { key: 3 }, Iyo = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "68",
  r: "10"
}, null, -1), Kyo = ["stroke"], Xyo = ["stroke"], Jyo = { key: 4 }, Qyo = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "68",
  r: "8"
}, null, -1), Yyo = ["stroke"], o5o = ["stroke"], e5o = { key: 5 }, t5o = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "68",
  r: "12"
}, null, -1), n5o = ["stroke"], s5o = ["stroke"], r5o = {
  name: "PhBird"
}, jR1 = /* @__PURE__ */ $({
  ...r5o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Byo, [
        Pyo,
        e("path", {
          d: "M208,96v24a96,96,0,0,1-96,96H12L104,96V76A52,52,0,0,1,206.3,62.9L232,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wyo),
        e("line", {
          x1: "90.7",
          y1: "176",
          x2: "121.3",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nyo)
      ])) : o(i) === "duotone" ? (s(), r("g", Fyo, [
        Tyo,
        Dyo,
        e("line", {
          x1: "120",
          y1: "136",
          x2: "80",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ryo),
        e("path", {
          d: "M208,96v24a96,96,0,0,1-96,96H8L104,96V76A52,52,0,0,1,206.3,62.9L232,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uyo)
      ])) : o(i) === "fill" ? (s(), r("g", qyo, Eyo)) : o(i) === "light" ? (s(), r("g", Oyo, [
        Iyo,
        e("line", {
          x1: "120",
          y1: "136",
          x2: "80",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kyo),
        e("path", {
          d: "M208,96v24a96,96,0,0,1-96,96H8L104,96V76A52,52,0,0,1,206.3,62.9L232,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xyo)
      ])) : o(i) === "thin" ? (s(), r("g", Jyo, [
        Qyo,
        e("line", {
          x1: "120",
          y1: "136",
          x2: "80",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Yyo),
        e("path", {
          d: "M208,96v24a96,96,0,0,1-96,96H8L104,96V76A52,52,0,0,1,206.3,62.9L232,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, o5o)
      ])) : o(i) === "regular" ? (s(), r("g", e5o, [
        t5o,
        e("line", {
          x1: "120",
          y1: "136",
          x2: "80",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n5o),
        e("path", {
          d: "M208,96v24a96,96,0,0,1-96,96H8L104,96V76A52,52,0,0,1,206.3,62.9L232,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s5o)
      ])) : g("", !0)
    ], 16, Lyo));
  }
}), i5o = ["width", "height", "fill", "transform"], l5o = { key: 0 }, d5o = ["stroke"], k5o = ["stroke"], c5o = ["stroke"], h5o = ["stroke"], u5o = { key: 1 }, a5o = /* @__PURE__ */ e("polygon", {
  points: "120 32 184 80 120 128 120 32",
  opacity: "0.2"
}, null, -1), _5o = /* @__PURE__ */ e("polygon", {
  points: "120 128 184 176 120 224 120 128",
  opacity: "0.2"
}, null, -1), p5o = ["stroke"], y5o = ["stroke"], $5o = ["stroke"], w5o = ["stroke"], f5o = { key: 2 }, g5o = /* @__PURE__ */ e("path", { d: "M188.8,169.6,133.3,128l55.5-41.6a8,8,0,0,0,0-12.8l-64-48A8,8,0,0,0,112,32v80L60.8,73.6a8.1,8.1,0,0,0-11.2,1.6,8,8,0,0,0,1.6,11.2L106.7,128,51.2,169.6A8,8,0,0,0,56,184a7.7,7.7,0,0,0,4.8-1.6L112,144v80a8.2,8.2,0,0,0,4.4,7.2,9.4,9.4,0,0,0,3.6.8,7.7,7.7,0,0,0,4.8-1.6l64-48a8,8,0,0,0,0-12.8ZM128,48l42.7,32L128,112Zm0,160V144l42.7,32Z" }, null, -1), x5o = [
  g5o
], j5o = { key: 3 }, m5o = ["stroke"], M5o = ["stroke"], v5o = ["stroke"], S5o = ["stroke"], H5o = { key: 4 }, A5o = ["stroke"], V5o = ["stroke"], z5o = ["stroke"], Z5o = ["stroke"], C5o = { key: 5 }, b5o = ["stroke"], L5o = ["stroke"], B5o = ["stroke"], P5o = ["stroke"], W5o = {
  name: "PhBluetooth"
}, mR1 = /* @__PURE__ */ $({
  ...W5o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", l5o, [
        e("polygon", {
          points: "120 32 184 80 120 128 120 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, d5o),
        e("polygon", {
          points: "120 128 184 176 120 224 120 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, k5o),
        e("line", {
          x1: "56",
          y1: "80",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, c5o),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, h5o)
      ])) : o(i) === "duotone" ? (s(), r("g", u5o, [
        a5o,
        _5o,
        e("polygon", {
          points: "120 128 184 176 120 224 120 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p5o),
        e("polygon", {
          points: "120 32 184 80 120 128 120 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y5o),
        e("line", {
          x1: "56",
          y1: "80",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $5o),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w5o)
      ])) : o(i) === "fill" ? (s(), r("g", f5o, x5o)) : o(i) === "light" ? (s(), r("g", j5o, [
        e("polygon", {
          points: "120 32 184 80 120 128 120 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, m5o),
        e("polygon", {
          points: "120 128 184 176 120 224 120 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, M5o),
        e("line", {
          x1: "56",
          y1: "80",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, v5o),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, S5o)
      ])) : o(i) === "thin" ? (s(), r("g", H5o, [
        e("polygon", {
          points: "120 32 184 80 120 128 120 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, A5o),
        e("polygon", {
          points: "120 128 184 176 120 224 120 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, V5o),
        e("line", {
          x1: "56",
          y1: "80",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, z5o),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Z5o)
      ])) : o(i) === "regular" ? (s(), r("g", C5o, [
        e("polygon", {
          points: "120 32 184 80 120 128 120 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b5o),
        e("polygon", {
          points: "120 128 184 176 120 224 120 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L5o),
        e("line", {
          x1: "56",
          y1: "80",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B5o),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P5o)
      ])) : g("", !0)
    ], 16, i5o));
  }
}), N5o = ["width", "height", "fill", "transform"], F5o = { key: 0 }, T5o = ["stroke"], D5o = ["stroke"], R5o = ["stroke"], U5o = ["stroke"], q5o = /* @__PURE__ */ e("circle", {
  cx: "52",
  cy: "128",
  r: "16"
}, null, -1), G5o = /* @__PURE__ */ e("circle", {
  cx: "196",
  cy: "128",
  r: "16"
}, null, -1), E5o = { key: 1 }, O5o = /* @__PURE__ */ e("polygon", {
  points: "120 32 184 80 120 128 120 32",
  opacity: "0.2"
}, null, -1), I5o = /* @__PURE__ */ e("polygon", {
  points: "120 128 184 176 120 224 120 128",
  opacity: "0.2"
}, null, -1), K5o = ["stroke"], X5o = ["stroke"], J5o = ["stroke"], Q5o = ["stroke"], Y5o = /* @__PURE__ */ e("circle", {
  cx: "52",
  cy: "128",
  r: "12"
}, null, -1), o7o = /* @__PURE__ */ e("circle", {
  cx: "196",
  cy: "128",
  r: "12"
}, null, -1), e7o = { key: 2 }, t7o = /* @__PURE__ */ e("path", { d: "M188.8,169.6,133.3,128l55.5-41.6a8,8,0,0,0,0-12.8l-64-48A8,8,0,0,0,112,32v80L60.8,73.6a8,8,0,0,0-9.6,12.8L106.7,128,51.2,169.6A8,8,0,0,0,56,184a7.7,7.7,0,0,0,4.8-1.6L112,144v80a8.2,8.2,0,0,0,4.4,7.2,9.4,9.4,0,0,0,3.6.8,7.7,7.7,0,0,0,4.8-1.6l64-48a8,8,0,0,0,0-12.8ZM128,48l42.7,32L128,112Zm0,160V144l42.7,32Zm80-80a12,12,0,1,1-12-12A12,12,0,0,1,208,128ZM52,140a12,12,0,1,1,12-12A12,12,0,0,1,52,140Z" }, null, -1), n7o = [
  t7o
], s7o = { key: 3 }, r7o = ["stroke"], i7o = ["stroke"], l7o = ["stroke"], d7o = ["stroke"], k7o = /* @__PURE__ */ e("circle", {
  cx: "52",
  cy: "128",
  r: "10"
}, null, -1), c7o = /* @__PURE__ */ e("circle", {
  cx: "196",
  cy: "128",
  r: "10"
}, null, -1), h7o = { key: 4 }, u7o = ["stroke"], a7o = ["stroke"], _7o = ["stroke"], p7o = ["stroke"], y7o = /* @__PURE__ */ e("circle", {
  cx: "52",
  cy: "128",
  r: "8"
}, null, -1), $7o = /* @__PURE__ */ e("circle", {
  cx: "196",
  cy: "128",
  r: "8"
}, null, -1), w7o = { key: 5 }, f7o = ["stroke"], g7o = ["stroke"], x7o = ["stroke"], j7o = ["stroke"], m7o = /* @__PURE__ */ e("circle", {
  cx: "52",
  cy: "128",
  r: "12"
}, null, -1), M7o = /* @__PURE__ */ e("circle", {
  cx: "196",
  cy: "128",
  r: "12"
}, null, -1), v7o = {
  name: "PhBluetoothConnected"
}, MR1 = /* @__PURE__ */ $({
  ...v7o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", F5o, [
        e("polygon", {
          points: "120 32 184 80 120 128 120 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, T5o),
        e("polygon", {
          points: "120 128 184 176 120 224 120 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, D5o),
        e("line", {
          x1: "56",
          y1: "80",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, R5o),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, U5o),
        q5o,
        G5o
      ])) : o(i) === "duotone" ? (s(), r("g", E5o, [
        O5o,
        I5o,
        e("polygon", {
          points: "120 32 184 80 120 128 120 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K5o),
        e("polygon", {
          points: "120 128 184 176 120 224 120 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X5o),
        e("line", {
          x1: "56",
          y1: "80",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J5o),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q5o),
        Y5o,
        o7o
      ])) : o(i) === "fill" ? (s(), r("g", e7o, n7o)) : o(i) === "light" ? (s(), r("g", s7o, [
        e("polygon", {
          points: "120 32 184 80 120 128 120 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, r7o),
        e("polygon", {
          points: "120 128 184 176 120 224 120 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, i7o),
        e("line", {
          x1: "56",
          y1: "80",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, l7o),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, d7o),
        k7o,
        c7o
      ])) : o(i) === "thin" ? (s(), r("g", h7o, [
        e("polygon", {
          points: "120 32 184 80 120 128 120 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, u7o),
        e("polygon", {
          points: "120 128 184 176 120 224 120 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, a7o),
        e("line", {
          x1: "56",
          y1: "80",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _7o),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, p7o),
        y7o,
        $7o
      ])) : o(i) === "regular" ? (s(), r("g", w7o, [
        e("polygon", {
          points: "120 32 184 80 120 128 120 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f7o),
        e("polygon", {
          points: "120 128 184 176 120 224 120 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g7o),
        e("line", {
          x1: "56",
          y1: "80",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, x7o),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j7o),
        m7o,
        M7o
      ])) : g("", !0)
    ], 16, N5o));
  }
}), S7o = ["width", "height", "fill", "transform"], H7o = { key: 0 }, A7o = ["stroke"], V7o = ["stroke"], z7o = ["stroke"], Z7o = ["stroke"], C7o = { key: 1 }, b7o = /* @__PURE__ */ e("polygon", {
  points: "120 32 184 80 120 128 120 32",
  opacity: "0.2"
}, null, -1), L7o = /* @__PURE__ */ e("polygon", {
  points: "120 128 184 176 120 224 120 128",
  opacity: "0.2"
}, null, -1), B7o = ["stroke"], P7o = ["stroke"], W7o = ["stroke"], N7o = ["stroke"], F7o = { key: 2 }, T7o = /* @__PURE__ */ e("path", { d: "M213.9,210.6l-31.4-34.5h0l-31.3-34.5h-.1L53.9,34.6A8,8,0,0,0,42.1,45.4l70.8,77.9L51.2,169.6A8,8,0,0,0,56,184a7.7,7.7,0,0,0,4.8-1.6L112,144v80a8.2,8.2,0,0,0,4.4,7.2,9,9,0,0,0,3.6.8,7.7,7.7,0,0,0,4.8-1.6l50.8-38.1,26.5,29.1A8,8,0,0,0,208,224a8.2,8.2,0,0,0,5.4-2.1A7.9,7.9,0,0,0,213.9,210.6ZM128,208V144l11.8,8.8,25,27.6Z" }, null, -1), D7o = /* @__PURE__ */ e("path", { d: "M120,79.6a8,8,0,0,0,8-8V48l42.7,32-25,18.7a7.9,7.9,0,0,0-1.6,11.2,7.8,7.8,0,0,0,6.4,3.2,8.1,8.1,0,0,0,4.8-1.6l33.5-25.1a8,8,0,0,0,0-12.8l-64-48A8,8,0,0,0,112,32V71.6A8,8,0,0,0,120,79.6Z" }, null, -1), R7o = [
  T7o,
  D7o
], U7o = { key: 3 }, q7o = ["stroke"], G7o = ["stroke"], E7o = ["stroke"], O7o = ["stroke"], I7o = { key: 4 }, K7o = ["stroke"], X7o = ["stroke"], J7o = ["stroke"], Q7o = ["stroke"], Y7o = { key: 5 }, o9o = ["stroke"], e9o = ["stroke"], t9o = ["stroke"], n9o = ["stroke"], s9o = {
  name: "PhBluetoothSlash"
}, vR1 = /* @__PURE__ */ $({
  ...s9o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", H7o, [
        e("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, A7o),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, V7o),
        e("polyline", {
          points: "176.6 181.5 120 224 120 119.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, z7o),
        e("polyline", {
          points: "120 59.7 120 32 184 80 156.9 100.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Z7o)
      ])) : o(i) === "duotone" ? (s(), r("g", C7o, [
        b7o,
        L7o,
        e("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B7o),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P7o),
        e("polyline", {
          points: "120 71.6 120 32 184 80 150.5 105.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W7o),
        e("polyline", {
          points: "176.7 181.5 120 224 120 128 145.2 146.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N7o)
      ])) : o(i) === "fill" ? (s(), r("g", F7o, R7o)) : o(i) === "light" ? (s(), r("g", U7o, [
        e("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, q7o),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, G7o),
        e("polyline", {
          points: "120 71.6 120 32 184 80 150.5 105.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, E7o),
        e("polyline", {
          points: "176.6 181.5 120 224 120 128 145.2 146.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, O7o)
      ])) : o(i) === "thin" ? (s(), r("g", I7o, [
        e("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, K7o),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, X7o),
        e("polyline", {
          points: "120 71.6 120 32 184 80 150.5 105.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, J7o),
        e("polyline", {
          points: "176.6 181.5 120 224 120 128 145.2 146.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Q7o)
      ])) : o(i) === "regular" ? (s(), r("g", Y7o, [
        e("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o9o),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e9o),
        e("polyline", {
          points: "120 71.6 120 32 184 80 150.5 105.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t9o),
        e("polyline", {
          points: "176.6 181.5 120 224 120 128 145.2 146.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n9o)
      ])) : g("", !0)
    ], 16, S7o));
  }
}), r9o = ["width", "height", "fill", "transform"], i9o = { key: 0 }, l9o = ["stroke"], d9o = ["stroke"], k9o = ["stroke"], c9o = ["stroke"], h9o = ["stroke"], u9o = ["stroke"], a9o = { key: 1 }, _9o = /* @__PURE__ */ e("polygon", {
  points: "120 32 184 80 120 128 120 32",
  opacity: "0.2"
}, null, -1), p9o = /* @__PURE__ */ e("polygon", {
  points: "120 128 184 176 120 224 120 128",
  opacity: "0.2"
}, null, -1), y9o = ["stroke"], $9o = ["stroke"], w9o = ["stroke"], f9o = ["stroke"], g9o = ["stroke"], x9o = ["stroke"], j9o = { key: 2 }, m9o = /* @__PURE__ */ e("path", { d: "M188.8,169.6,133.3,128l23.5-17.6a8,8,0,0,0,1.6-11.2,8.1,8.1,0,0,0-11.2-1.6L128,112V48l19.2,14.4a8,8,0,0,0,11.2-1.6,8.1,8.1,0,0,0-1.6-11.2l-32-24A8,8,0,0,0,112,32v80L60.8,73.6a8.1,8.1,0,0,0-11.2,1.6,8,8,0,0,0,1.6,11.2L106.7,128,51.2,169.6A8,8,0,0,0,56,184a7.7,7.7,0,0,0,4.8-1.6L112,144v80a8.2,8.2,0,0,0,4.4,7.2,9.4,9.4,0,0,0,3.6.8,7.7,7.7,0,0,0,4.8-1.6l64-48a8,8,0,0,0,0-12.8ZM128,208V144l42.7,32Z" }, null, -1), M9o = /* @__PURE__ */ e("path", { d: "M219.3,80l18.4-18.3a8.1,8.1,0,0,0-11.4-11.4L208,68.7,189.7,50.3a8.1,8.1,0,0,0-11.4,11.4L196.7,80,178.3,98.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L208,91.3l18.3,18.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4Z" }, null, -1), v9o = [
  m9o,
  M9o
], S9o = { key: 3 }, H9o = ["stroke"], A9o = ["stroke"], V9o = ["stroke"], z9o = ["stroke"], Z9o = ["stroke"], C9o = ["stroke"], b9o = { key: 4 }, L9o = ["stroke"], B9o = ["stroke"], P9o = ["stroke"], W9o = ["stroke"], N9o = ["stroke"], F9o = ["stroke"], T9o = { key: 5 }, D9o = ["stroke"], R9o = ["stroke"], U9o = ["stroke"], q9o = ["stroke"], G9o = ["stroke"], E9o = ["stroke"], O9o = {
  name: "PhBluetoothX"
}, SR1 = /* @__PURE__ */ $({
  ...O9o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", i9o, [
        e("polygon", {
          points: "120 128 184 176 120 224 120 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, l9o),
        e("line", {
          x1: "56",
          y1: "80",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, d9o),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, k9o),
        e("line", {
          x1: "232",
          y1: "56",
          x2: "184",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, c9o),
        e("line", {
          x1: "232",
          y1: "104",
          x2: "184",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, h9o),
        e("polyline", {
          points: "144.4 109.7 120 128 120 32 144.4 50.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, u9o)
      ])) : o(i) === "duotone" ? (s(), r("g", a9o, [
        _9o,
        p9o,
        e("polygon", {
          points: "120 128 184 176 120 224 120 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y9o),
        e("line", {
          x1: "56",
          y1: "80",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $9o),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w9o),
        e("line", {
          x1: "232",
          y1: "56",
          x2: "184",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f9o),
        e("line", {
          x1: "232",
          y1: "104",
          x2: "184",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g9o),
        e("polyline", {
          points: "152 104 120 128 120 32 152 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, x9o)
      ])) : o(i) === "fill" ? (s(), r("g", j9o, v9o)) : o(i) === "light" ? (s(), r("g", S9o, [
        e("polygon", {
          points: "120 128 184 176 120 224 120 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, H9o),
        e("line", {
          x1: "56",
          y1: "80",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, A9o),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, V9o),
        e("line", {
          x1: "232",
          y1: "56",
          x2: "184",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, z9o),
        e("line", {
          x1: "232",
          y1: "104",
          x2: "184",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Z9o),
        e("polyline", {
          points: "152 104 120 128 120 32 152 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, C9o)
      ])) : o(i) === "thin" ? (s(), r("g", b9o, [
        e("polygon", {
          points: "120 128 184 176 120 224 120 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, L9o),
        e("line", {
          x1: "56",
          y1: "80",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, B9o),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, P9o),
        e("line", {
          x1: "232",
          y1: "56",
          x2: "184",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, W9o),
        e("line", {
          x1: "232",
          y1: "104",
          x2: "184",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, N9o),
        e("polyline", {
          points: "152 104 120 128 120 32 152 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, F9o)
      ])) : o(i) === "regular" ? (s(), r("g", T9o, [
        e("polygon", {
          points: "120 128 184 176 120 224 120 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D9o),
        e("line", {
          x1: "56",
          y1: "80",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R9o),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U9o),
        e("line", {
          x1: "232",
          y1: "56",
          x2: "184",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q9o),
        e("line", {
          x1: "232",
          y1: "104",
          x2: "184",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G9o),
        e("polyline", {
          points: "152 104 120 128 120 32 152 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E9o)
      ])) : g("", !0)
    ], 16, r9o));
  }
}), I9o = ["width", "height", "fill", "transform"], K9o = { key: 0 }, X9o = ["stroke"], J9o = ["stroke"], Q9o = ["stroke"], Y9o = ["stroke"], o$o = { key: 1 }, e$o = /* @__PURE__ */ e("path", {
  d: "M224,160c-14.6,51-82.2,68.8-94.2,71.6a7.3,7.3,0,0,1-3.6,0C114.2,228.8,46.6,211,32,160V125.8a8,8,0,0,1,5.5-7.6l88-29.4a8.5,8.5,0,0,1,5,0l88,29.4a8,8,0,0,1,5.5,7.6Z",
  opacity: "0.2"
}, null, -1), t$o = ["stroke"], n$o = ["stroke"], s$o = ["stroke"], r$o = ["stroke"], i$o = { key: 2 }, l$o = /* @__PURE__ */ e("path", { d: "M221.1,110.6,208,106.2V56a16,16,0,0,0-16-16H136V24a8,8,0,0,0-16,0V40H64A16,16,0,0,0,48,56v50.2l-13.1,4.4A16,16,0,0,0,24,125.8V160a8.3,8.3,0,0,0,.3,2.2c15.7,55,86.1,74,100.1,77.2a16.4,16.4,0,0,0,7.2,0c14-3.2,84.4-22.2,100.1-77.2a8.3,8.3,0,0,0,.3-2.2V125.8A16,16,0,0,0,221.1,110.6ZM136,168a8,8,0,0,1-16,0V112.4a8,8,0,0,1,16,0Zm56-67.1L133.1,81.3a16.2,16.2,0,0,0-10.2,0L64,100.9V56H192Z" }, null, -1), d$o = [
  l$o
], k$o = { key: 3 }, c$o = ["stroke"], h$o = ["stroke"], u$o = ["stroke"], a$o = ["stroke"], _$o = { key: 4 }, p$o = ["stroke"], y$o = ["stroke"], $$o = ["stroke"], w$o = ["stroke"], f$o = { key: 5 }, g$o = ["stroke"], x$o = ["stroke"], j$o = ["stroke"], m$o = ["stroke"], M$o = {
  name: "PhBoat"
}, HR1 = /* @__PURE__ */ $({
  ...M$o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", K9o, [
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X9o),
        e("path", {
          d: "M224,160c-14.6,51-82.2,68.8-94.2,71.6a7.3,7.3,0,0,1-3.6,0C114.2,228.8,46.6,211,32,160V125.8a8,8,0,0,1,5.5-7.6l88-29.4a8.5,8.5,0,0,1,5,0l88,29.4a8,8,0,0,1,5.5,7.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, J9o),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Q9o),
        e("path", {
          d: "M56,112V56a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Y9o)
      ])) : o(i) === "duotone" ? (s(), r("g", o$o, [
        e$o,
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t$o),
        e("path", {
          d: "M224,160c-14.6,51-82.2,68.8-94.2,71.6a7.3,7.3,0,0,1-3.6,0C114.2,228.8,46.6,211,32,160V125.8a8,8,0,0,1,5.5-7.6l88-29.4a8.5,8.5,0,0,1,5,0l88,29.4a8,8,0,0,1,5.5,7.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n$o),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s$o),
        e("path", {
          d: "M56,112V56a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r$o)
      ])) : o(i) === "fill" ? (s(), r("g", i$o, d$o)) : o(i) === "light" ? (s(), r("g", k$o, [
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, c$o),
        e("path", {
          d: "M224,160c-14.6,51-82.2,68.8-94.2,71.6a7.3,7.3,0,0,1-3.6,0C114.2,228.8,46.6,211,32,160V125.8a8,8,0,0,1,5.5-7.6l88-29.4a8.5,8.5,0,0,1,5,0l88,29.4a8,8,0,0,1,5.5,7.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, h$o),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u$o),
        e("path", {
          d: "M56,112V56a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, a$o)
      ])) : o(i) === "thin" ? (s(), r("g", _$o, [
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, p$o),
        e("path", {
          d: "M224,160c-14.6,51-82.2,68.8-94.2,71.6a7.3,7.3,0,0,1-3.6,0C114.2,228.8,46.6,211,32,160V125.8a8,8,0,0,1,5.5-7.6l88-29.4a8.5,8.5,0,0,1,5,0l88,29.4a8,8,0,0,1,5.5,7.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, y$o),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $$o),
        e("path", {
          d: "M56,112V56a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, w$o)
      ])) : o(i) === "regular" ? (s(), r("g", f$o, [
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g$o),
        e("path", {
          d: "M224,160c-14.6,51-82.2,68.8-94.2,71.6a7.3,7.3,0,0,1-3.6,0C114.2,228.8,46.6,211,32,160V125.8a8,8,0,0,1,5.5-7.6l88-29.4a8.5,8.5,0,0,1,5,0l88,29.4a8,8,0,0,1,5.5,7.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, x$o),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j$o),
        e("path", {
          d: "M56,112V56a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m$o)
      ])) : g("", !0)
    ], 16, I9o));
  }
}), v$o = ["width", "height", "fill", "transform"], S$o = { key: 0 }, H$o = ["stroke"], A$o = ["stroke"], V$o = { key: 1 }, z$o = /* @__PURE__ */ e("path", {
  d: "M48,216a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
  opacity: "0.2"
}, null, -1), Z$o = ["stroke"], C$o = ["stroke"], b$o = { key: 2 }, L$o = /* @__PURE__ */ e("path", { d: "M216,32V192a8,8,0,0,1-8,8H72a16,16,0,0,0-16,16H192a8,8,0,0,1,0,16H48a8,8,0,0,1-8-8V56A32.1,32.1,0,0,1,72,24H208A8,8,0,0,1,216,32Z" }, null, -1), B$o = [
  L$o
], P$o = { key: 3 }, W$o = ["stroke"], N$o = ["stroke"], F$o = { key: 4 }, T$o = ["stroke"], D$o = ["stroke"], R$o = { key: 5 }, U$o = ["stroke"], q$o = ["stroke"], G$o = {
  name: "PhBook"
}, AR1 = /* @__PURE__ */ $({
  ...G$o,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", S$o, [
        e("path", {
          d: "M48,208a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, H$o),
        e("polyline", {
          points: "48 208 48 224 192 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, A$o)
      ])) : o(i) === "duotone" ? (s(), r("g", V$o, [
        z$o,
        e("path", {
          d: "M48,216a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z$o),
        e("polyline", {
          points: "48 216 48 224 192 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C$o)
      ])) : o(i) === "fill" ? (s(), r("g", b$o, B$o)) : o(i) === "light" ? (s(), r("g", P$o, [
        e("path", {
          d: "M48,216a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, W$o),
        e("polyline", {
          points: "48 216 48 224 192 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, N$o)
      ])) : o(i) === "thin" ? (s(), r("g", F$o, [
        e("path", {
          d: "M48,216a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, T$o),
        e("polyline", {
          points: "48 216 48 224 192 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, D$o)
      ])) : o(i) === "regular" ? (s(), r("g", R$o, [
        e("path", {
          d: "M48,216a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U$o),
        e("polyline", {
          points: "48 216 48 224 192 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q$o)
      ])) : g("", !0)
    ], 16, v$o));
  }
}), E$o = ["width", "height", "fill", "transform"], O$o = { key: 0 }, I$o = ["stroke"], K$o = ["stroke"], X$o = ["stroke"], J$o = { key: 1 }, Q$o = /* @__PURE__ */ e("path", {
  d: "M176,32v96l-32-24-32,24V32H72A23.9,23.9,0,0,0,48,56V216a23.9,23.9,0,0,1,24-24H208V32Z",
  opacity: "0.2"
}, null, -1), Y$o = ["stroke"], owo = ["stroke"], ewo = ["stroke"], two = { key: 2 }, nwo = /* @__PURE__ */ e("path", { d: "M208,24H72A32.1,32.1,0,0,0,40,56V224a8,8,0,0,0,8,8H192a8,8,0,0,0,0-16H56a16,16,0,0,1,16-16H208a8,8,0,0,0,8-8V32A8,8,0,0,0,208,24Zm-24,96-25.6-19.2a3.9,3.9,0,0,0-4.8,0L128,120V40h56Z" }, null, -1), swo = [
  nwo
], rwo = { key: 3 }, iwo = ["stroke"], lwo = ["stroke"], dwo = ["stroke"], kwo = { key: 4 }, cwo = ["stroke"], hwo = ["stroke"], uwo = ["stroke"], awo = { key: 5 }, _wo = ["stroke"], pwo = ["stroke"], ywo = ["stroke"], $wo = {
  name: "PhBookBookmark"
}, VR1 = /* @__PURE__ */ $({
  ...$wo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", O$o, [
        e("polyline", {
          points: "172 32 172 128 140 104 108 128 108 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, I$o),
        e("path", {
          d: "M48,208a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, K$o),
        e("polyline", {
          points: "48 208 48 224 192 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X$o)
      ])) : o(i) === "duotone" ? (s(), r("g", J$o, [
        Q$o,
        e("polyline", {
          points: "48 216 48 224 192 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y$o),
        e("polyline", {
          points: "176 32 176 128 144 104 112 128 112 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, owo),
        e("path", {
          d: "M48,216a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ewo)
      ])) : o(i) === "fill" ? (s(), r("g", two, swo)) : o(i) === "light" ? (s(), r("g", rwo, [
        e("polyline", {
          points: "176 32 176 128 144 104 112 128 112 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iwo),
        e("path", {
          d: "M48,216a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lwo),
        e("polyline", {
          points: "48 216 48 224 192 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dwo)
      ])) : o(i) === "thin" ? (s(), r("g", kwo, [
        e("polyline", {
          points: "176 32 176 128 144 104 112 128 112 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cwo),
        e("path", {
          d: "M48,216a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hwo),
        e("polyline", {
          points: "48 216 48 224 192 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uwo)
      ])) : o(i) === "regular" ? (s(), r("g", awo, [
        e("polyline", {
          points: "176 32 176 128 144 104 112 128 112 32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _wo),
        e("path", {
          d: "M48,216a23.9,23.9,0,0,1,24-24H208V32H72A23.9,23.9,0,0,0,48,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pwo),
        e("polyline", {
          points: "48 216 48 224 192 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ywo)
      ])) : g("", !0)
    ], 16, E$o));
  }
}), wwo = ["width", "height", "fill", "transform"], fwo = { key: 0 }, gwo = ["stroke"], xwo = ["stroke"], jwo = { key: 1 }, mwo = /* @__PURE__ */ e("path", {
  d: "M224,56H160a32,32,0,0,0-32,32A32,32,0,0,0,96,56H32a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H96a32,32,0,0,1,32,32,32,32,0,0,1,32-32h64a8,8,0,0,0,8-8V64A8,8,0,0,0,224,56Z",
  opacity: "0.2"
}, null, -1), Mwo = ["stroke"], vwo = ["stroke"], Swo = { key: 2 }, Hwo = /* @__PURE__ */ e("path", { d: "M96,208a24.1,24.1,0,0,1,24,24,8,8,0,0,0,16,0,24.1,24.1,0,0,1,24-24h64a16,16,0,0,0,16-16V64a16,16,0,0,0-16-16H176a40,40,0,0,0-40,40v80a8,8,0,0,1-16,0V88A40,40,0,0,0,80,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16Z" }, null, -1), Awo = [
  Hwo
], Vwo = { key: 3 }, zwo = ["stroke"], Zwo = ["stroke"], Cwo = { key: 4 }, bwo = ["stroke"], Lwo = ["stroke"], Bwo = { key: 5 }, Pwo = ["stroke"], Wwo = ["stroke"], Nwo = {
  name: "PhBookOpen"
}, zR1 = /* @__PURE__ */ $({
  ...Nwo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", fwo, [
        e("path", {
          d: "M128,88a32,32,0,0,1,32-32h64a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H160a32,32,0,0,0-32,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gwo),
        e("path", {
          d: "M24,192a8,8,0,0,0,8,8H96a32,32,0,0,1,32,32V88A32,32,0,0,0,96,56H32a8,8,0,0,0-8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xwo)
      ])) : o(i) === "duotone" ? (s(), r("g", jwo, [
        mwo,
        e("path", {
          d: "M128,88a32,32,0,0,1,32-32h64a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H160a32,32,0,0,0-32,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mwo),
        e("path", {
          d: "M24,192a8,8,0,0,0,8,8H96a32,32,0,0,1,32,32V88A32,32,0,0,0,96,56H32a8,8,0,0,0-8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vwo)
      ])) : o(i) === "fill" ? (s(), r("g", Swo, Awo)) : o(i) === "light" ? (s(), r("g", Vwo, [
        e("path", {
          d: "M128,88a32,32,0,0,1,32-32h64a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H160a32,32,0,0,0-32,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zwo),
        e("path", {
          d: "M24,192a8,8,0,0,0,8,8H96a32,32,0,0,1,32,32V88A32,32,0,0,0,96,56H32a8,8,0,0,0-8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zwo)
      ])) : o(i) === "thin" ? (s(), r("g", Cwo, [
        e("path", {
          d: "M128,88a32,32,0,0,1,32-32h64a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H160a32,32,0,0,0-32,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bwo),
        e("path", {
          d: "M24,192a8,8,0,0,0,8,8H96a32,32,0,0,1,32,32V88A32,32,0,0,0,96,56H32a8,8,0,0,0-8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lwo)
      ])) : o(i) === "regular" ? (s(), r("g", Bwo, [
        e("path", {
          d: "M128,88a32,32,0,0,1,32-32h64a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H160a32,32,0,0,0-32,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pwo),
        e("path", {
          d: "M24,192a8,8,0,0,0,8,8H96a32,32,0,0,1,32,32V88A32,32,0,0,0,96,56H32a8,8,0,0,0-8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wwo)
      ])) : g("", !0)
    ], 16, wwo));
  }
}), Fwo = ["width", "height", "fill", "transform"], Two = { key: 0 }, Dwo = ["stroke"], Rwo = ["stroke"], Uwo = { key: 1 }, qwo = /* @__PURE__ */ e("polygon", {
  points: "192 176 128 136 64 176 64 224 128 184 192 224 192 176",
  opacity: "0.2"
}, null, -1), Gwo = ["stroke"], Ewo = ["stroke"], Owo = { key: 2 }, Iwo = /* @__PURE__ */ e("path", { d: "M184,32H72A16,16,0,0,0,56,48V224a8.1,8.1,0,0,0,4.1,7,7.6,7.6,0,0,0,3.9,1,7.9,7.9,0,0,0,4.2-1.2L128,193.4l59.7,37.4a8.3,8.3,0,0,0,8.2.2,8.1,8.1,0,0,0,4.1-7V48A16,16,0,0,0,184,32ZM132.2,177.2A8.1,8.1,0,0,0,128,176a8.2,8.2,0,0,0-4.3,1.2L72,209.6V180.4l56-35,56,35v29.2Z" }, null, -1), Kwo = [
  Iwo
], Xwo = { key: 3 }, Jwo = ["stroke"], Qwo = ["stroke"], Ywo = { key: 4 }, ofo = ["stroke"], efo = ["stroke"], tfo = { key: 5 }, nfo = ["stroke"], sfo = ["stroke"], rfo = {
  name: "PhBookmark"
}, ZR1 = /* @__PURE__ */ $({
  ...rfo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Two, [
        e("path", {
          d: "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Dwo),
        e("polyline", {
          points: "192 176 128 136 64 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rwo)
      ])) : o(i) === "duotone" ? (s(), r("g", Uwo, [
        qwo,
        e("path", {
          d: "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gwo),
        e("polyline", {
          points: "192 176 128 136 64 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ewo)
      ])) : o(i) === "fill" ? (s(), r("g", Owo, Kwo)) : o(i) === "light" ? (s(), r("g", Xwo, [
        e("path", {
          d: "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jwo),
        e("polyline", {
          points: "192 176 128 136 64 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qwo)
      ])) : o(i) === "thin" ? (s(), r("g", Ywo, [
        e("path", {
          d: "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ofo),
        e("polyline", {
          points: "192 176 128 136 64 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, efo)
      ])) : o(i) === "regular" ? (s(), r("g", tfo, [
        e("path", {
          d: "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nfo),
        e("polyline", {
          points: "192 176 128 136 64 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sfo)
      ])) : g("", !0)
    ], 16, Fwo));
  }
}), ifo = ["width", "height", "fill", "transform"], lfo = { key: 0 }, dfo = ["stroke"], kfo = { key: 1 }, cfo = /* @__PURE__ */ e("path", {
  d: "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
  opacity: "0.2"
}, null, -1), hfo = ["stroke"], ufo = { key: 2 }, afo = /* @__PURE__ */ e("path", { d: "M184,32H72A16,16,0,0,0,56,48V224a8.1,8.1,0,0,0,4.1,7,7.6,7.6,0,0,0,3.9,1,7.9,7.9,0,0,0,4.2-1.2L128,193.4l59.7,37.4a8.3,8.3,0,0,0,8.2.2,8.1,8.1,0,0,0,4.1-7V48A16,16,0,0,0,184,32Z" }, null, -1), _fo = [
  afo
], pfo = { key: 3 }, yfo = ["stroke"], $fo = { key: 4 }, wfo = ["stroke"], ffo = { key: 5 }, gfo = ["stroke"], xfo = {
  name: "PhBookmarkSimple"
}, CR1 = /* @__PURE__ */ $({
  ...xfo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", lfo, [
        e("path", {
          d: "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dfo)
      ])) : o(i) === "duotone" ? (s(), r("g", kfo, [
        cfo,
        e("path", {
          d: "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hfo)
      ])) : o(i) === "fill" ? (s(), r("g", ufo, _fo)) : o(i) === "light" ? (s(), r("g", pfo, [
        e("path", {
          d: "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yfo)
      ])) : o(i) === "thin" ? (s(), r("g", $fo, [
        e("path", {
          d: "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wfo)
      ])) : o(i) === "regular" ? (s(), r("g", ffo, [
        e("path", {
          d: "M192,224l-64-40L64,224V48a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gfo)
      ])) : g("", !0)
    ], 16, ifo));
  }
}), jfo = ["width", "height", "fill", "transform"], mfo = { key: 0 }, Mfo = ["stroke"], vfo = ["stroke"], Sfo = { key: 1 }, Hfo = /* @__PURE__ */ e("path", {
  d: "M192,32H96a8,8,0,0,0-8,8V64h72a8,8,0,0,1,8,8v97.1L200,192V40A8,8,0,0,0,192,32Z",
  opacity: "0.2"
}, null, -1), Afo = ["stroke"], Vfo = ["stroke"], zfo = { key: 2 }, Zfo = /* @__PURE__ */ e("path", { d: "M192,24H96A16,16,0,0,0,80,40V56H64A16,16,0,0,0,48,72V224a8,8,0,0,0,8,8,8.2,8.2,0,0,0,4.7-1.5L112,193.8l51.4,36.7a7.8,7.8,0,0,0,8.3.6A8.1,8.1,0,0,0,176,224V184.7l19.4,13.8A7.7,7.7,0,0,0,200,200a8,8,0,0,0,8-8V40A16,16,0,0,0,192,24Zm0,152.5L176,165V72a16,16,0,0,0-16-16H96V40h96Z" }, null, -1), Cfo = [
  Zfo
], bfo = { key: 3 }, Lfo = ["stroke"], Bfo = ["stroke"], Pfo = { key: 4 }, Wfo = ["stroke"], Nfo = ["stroke"], Ffo = { key: 5 }, Tfo = ["stroke"], Dfo = ["stroke"], Rfo = {
  name: "PhBookmarks"
}, bR1 = /* @__PURE__ */ $({
  ...Rfo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", mfo, [
        e("path", {
          d: "M160,224l-52-40L56,224V80a8,8,0,0,1,8-8h88a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mfo),
        e("path", {
          d: "M88,72V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V184l-40-30.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vfo)
      ])) : o(i) === "duotone" ? (s(), r("g", Sfo, [
        Hfo,
        e("path", {
          d: "M168,224l-56-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Afo),
        e("path", {
          d: "M88,64V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V192l-32-22.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vfo)
      ])) : o(i) === "fill" ? (s(), r("g", zfo, Cfo)) : o(i) === "light" ? (s(), r("g", bfo, [
        e("path", {
          d: "M168,224l-56-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lfo),
        e("path", {
          d: "M88,64V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V192l-32-22.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bfo)
      ])) : o(i) === "thin" ? (s(), r("g", Pfo, [
        e("path", {
          d: "M168,224l-56-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wfo),
        e("path", {
          d: "M88,64V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V192l-32-22.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nfo)
      ])) : o(i) === "regular" ? (s(), r("g", Ffo, [
        e("path", {
          d: "M168,224l-56-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tfo),
        e("path", {
          d: "M88,64V40a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V192l-32-22.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dfo)
      ])) : g("", !0)
    ], 16, jfo));
  }
}), Ufo = ["width", "height", "fill", "transform"], qfo = { key: 0 }, Gfo = ["stroke"], Efo = ["stroke"], Ofo = { key: 1 }, Ifo = /* @__PURE__ */ e("path", {
  d: "M168,224l-56-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
  opacity: "0.2"
}, null, -1), Kfo = ["stroke"], Xfo = ["stroke"], Jfo = { key: 2 }, Qfo = /* @__PURE__ */ e("path", { d: "M160,56H64A16,16,0,0,0,48,72V224a8.1,8.1,0,0,0,4.3,7.1,8.4,8.4,0,0,0,3.7.9,8.2,8.2,0,0,0,4.7-1.5L112,193.8l51.4,36.7a7.8,7.8,0,0,0,8.3.6A8.1,8.1,0,0,0,176,224V72A16,16,0,0,0,160,56Z" }, null, -1), Yfo = /* @__PURE__ */ e("path", { d: "M192,24H88a8,8,0,0,0,0,16H192V192a8,8,0,0,0,16,0V40A16,16,0,0,0,192,24Z" }, null, -1), ogo = [
  Qfo,
  Yfo
], ego = { key: 3 }, tgo = ["stroke"], ngo = ["stroke"], sgo = { key: 4 }, rgo = ["stroke"], igo = ["stroke"], lgo = { key: 5 }, dgo = ["stroke"], kgo = ["stroke"], cgo = {
  name: "PhBookmarksSimple"
}, LR1 = /* @__PURE__ */ $({
  ...cgo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", qfo, [
        e("path", {
          d: "M164,228l-56-40L52,228V76a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gfo),
        e("path", {
          d: "M92,28H196a8,8,0,0,1,8,8V188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Efo)
      ])) : o(i) === "duotone" ? (s(), r("g", Ofo, [
        Ifo,
        e("path", {
          d: "M168,224l-56-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kfo),
        e("path", {
          d: "M88,32H192a8,8,0,0,1,8,8V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xfo)
      ])) : o(i) === "fill" ? (s(), r("g", Jfo, ogo)) : o(i) === "light" ? (s(), r("g", ego, [
        e("path", {
          d: "M168,224l-56-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tgo),
        e("path", {
          d: "M88,32H192a8,8,0,0,1,8,8V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ngo)
      ])) : o(i) === "thin" ? (s(), r("g", sgo, [
        e("path", {
          d: "M168,224l-56-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rgo),
        e("path", {
          d: "M88,32H192a8,8,0,0,1,8,8V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, igo)
      ])) : o(i) === "regular" ? (s(), r("g", lgo, [
        e("path", {
          d: "M168,224l-56-40L56,224V72a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dgo),
        e("path", {
          d: "M88,32H192a8,8,0,0,1,8,8V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kgo)
      ])) : g("", !0)
    ], 16, Ufo));
  }
}), hgo = ["width", "height", "fill", "transform"], ugo = { key: 0 }, ago = ["stroke"], _go = ["stroke"], pgo = ["stroke"], ygo = ["stroke"], $go = ["stroke"], wgo = ["stroke"], fgo = ["stroke"], ggo = { key: 1 }, xgo = /* @__PURE__ */ e("path", {
  d: "M40,80H88V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8Z",
  opacity: "0.2"
}, null, -1), jgo = /* @__PURE__ */ e("path", {
  d: "M88,176h48V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8Z",
  opacity: "0.2"
}, null, -1), mgo = /* @__PURE__ */ e("path", {
  d: "M171.2,179.2l46.4-12.5,8.3,30.9a8,8,0,0,1-5.7,9.8l-30.9,8.3a8,8,0,0,1-9.8-5.6Z",
  opacity: "0.2"
}, null, -1), Mgo = /* @__PURE__ */ e("path", {
  d: "M146.4,86.4,192.8,74l-8.3-30.9a8.1,8.1,0,0,0-9.8-5.7l-30.9,8.3a8.1,8.1,0,0,0-5.7,9.8Z",
  opacity: "0.2"
}, null, -1), vgo = ["stroke"], Sgo = ["stroke"], Hgo = ["stroke"], Ago = ["stroke"], Vgo = ["stroke"], zgo = ["stroke"], Zgo = ["stroke"], Cgo = { key: 2 }, bgo = /* @__PURE__ */ e("path", { d: "M233.6,195.6,192.2,41a16,16,0,0,0-19.6-11.3L141.7,38l-1,.3A16,16,0,0,0,128,32H96a15.8,15.8,0,0,0-8,2.2A15.8,15.8,0,0,0,80,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H80a15.8,15.8,0,0,0,8-2.2,15.8,15.8,0,0,0,8,2.2h32a16,16,0,0,0,16-16V108.4l27.8,103.7A16,16,0,0,0,187.3,224a19.9,19.9,0,0,0,4.1-.5l30.9-8.3A16,16,0,0,0,233.6,195.6ZM176.7,45.2,183,68.3l-30.9,8.3-6.3-23.1ZM128,48V168H96V48ZM80,48V72H48V48Zm48,160H96V184h32v24Zm90.2-8.3L187.3,208,181,184.8l31-8.3,6.2,23.2Z" }, null, -1), Lgo = [
  bgo
], Bgo = { key: 3 }, Pgo = ["stroke"], Wgo = ["stroke"], Ngo = ["stroke"], Fgo = ["stroke"], Tgo = ["stroke"], Dgo = ["stroke"], Rgo = ["stroke"], Ugo = { key: 4 }, qgo = ["stroke"], Ggo = ["stroke"], Ego = ["stroke"], Ogo = ["stroke"], Igo = ["stroke"], Kgo = ["stroke"], Xgo = ["stroke"], Jgo = { key: 5 }, Qgo = ["stroke"], Ygo = ["stroke"], oxo = ["stroke"], exo = ["stroke"], txo = ["stroke"], nxo = ["stroke"], sxo = ["stroke"], rxo = {
  name: "PhBooks"
}, BR1 = /* @__PURE__ */ $({
  ...rxo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ugo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "48",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ago),
        e("line", {
          x1: "40",
          y1: "80",
          x2: "88",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _go),
        e("rect", {
          x: "88",
          y: "40",
          width: "48",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pgo),
        e("line", {
          x1: "88",
          y1: "176",
          x2: "136",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ygo),
        e("rect", {
          x: "158",
          y: "38.6",
          width: "48",
          height: "176",
          rx: "8",
          transform: "translate(-26.6 51.4) rotate(-15)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $go),
        e("line", {
          x1: "171.2",
          y1: "179.2",
          x2: "217.6",
          y2: "166.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wgo),
        e("line", {
          x1: "146.4",
          y1: "86.4",
          x2: "192.8",
          y2: "74",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fgo)
      ])) : o(i) === "duotone" ? (s(), r("g", ggo, [
        xgo,
        jgo,
        mgo,
        Mgo,
        e("rect", {
          x: "40",
          y: "40",
          width: "48",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vgo),
        e("line", {
          x1: "40",
          y1: "80",
          x2: "88",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sgo),
        e("rect", {
          x: "88",
          y: "40",
          width: "48",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hgo),
        e("line", {
          x1: "88",
          y1: "176",
          x2: "136",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ago),
        e("rect", {
          x: "158",
          y: "38.6",
          width: "48",
          height: "176",
          rx: "8",
          transform: "translate(-26.6 51.4) rotate(-15)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vgo),
        e("line", {
          x1: "171.2",
          y1: "179.2",
          x2: "217.6",
          y2: "166.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zgo),
        e("line", {
          x1: "146.4",
          y1: "86.4",
          x2: "192.8",
          y2: "74",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zgo)
      ])) : o(i) === "fill" ? (s(), r("g", Cgo, Lgo)) : o(i) === "light" ? (s(), r("g", Bgo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "48",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pgo),
        e("line", {
          x1: "40",
          y1: "80",
          x2: "88",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wgo),
        e("rect", {
          x: "88",
          y: "40",
          width: "48",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ngo),
        e("line", {
          x1: "88",
          y1: "176",
          x2: "136",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fgo),
        e("rect", {
          x: "158",
          y: "38.6",
          width: "48",
          height: "176",
          rx: "8",
          transform: "matrix(0.97, -0.26, 0.26, 0.97, -26.56, 51.42)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Tgo),
        e("line", {
          x1: "171.2",
          y1: "179.2",
          x2: "217.6",
          y2: "166.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dgo),
        e("line", {
          x1: "146.4",
          y1: "86.4",
          x2: "192.8",
          y2: "74",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rgo)
      ])) : o(i) === "thin" ? (s(), r("g", Ugo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "48",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qgo),
        e("line", {
          x1: "40",
          y1: "80",
          x2: "88",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ggo),
        e("rect", {
          x: "88",
          y: "40",
          width: "48",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ego),
        e("line", {
          x1: "88",
          y1: "176",
          x2: "136",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ogo),
        e("rect", {
          x: "158",
          y: "38.6",
          width: "48",
          height: "176",
          rx: "8",
          transform: "translate(-26.6 51.4) rotate(-15)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Igo),
        e("line", {
          x1: "171.2",
          y1: "179.2",
          x2: "217.6",
          y2: "166.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kgo),
        e("line", {
          x1: "146.4",
          y1: "86.4",
          x2: "192.8",
          y2: "74",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xgo)
      ])) : o(i) === "regular" ? (s(), r("g", Jgo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "48",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qgo),
        e("line", {
          x1: "40",
          y1: "80",
          x2: "88",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ygo),
        e("rect", {
          x: "88",
          y: "40",
          width: "48",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oxo),
        e("line", {
          x1: "88",
          y1: "176",
          x2: "136",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, exo),
        e("rect", {
          x: "158",
          y: "38.6",
          width: "48",
          height: "176",
          rx: "8",
          transform: "matrix(0.97, -0.26, 0.26, 0.97, -26.56, 51.42)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, txo),
        e("line", {
          x1: "171.2",
          y1: "179.2",
          x2: "217.6",
          y2: "166.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nxo),
        e("line", {
          x1: "146.4",
          y1: "86.4",
          x2: "192.8",
          y2: "74",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sxo)
      ])) : g("", !0)
    ], 16, hgo));
  }
}), ixo = ["width", "height", "fill", "transform"], lxo = { key: 0 }, dxo = ["stroke"], kxo = ["stroke"], cxo = ["stroke"], hxo = ["stroke"], uxo = ["stroke"], axo = ["stroke"], _xo = ["stroke"], pxo = ["stroke"], yxo = { key: 1 }, $xo = /* @__PURE__ */ e("rect", {
  x: "168",
  y: "40",
  width: "48",
  height: "48",
  rx: "8",
  opacity: "0.2"
}, null, -1), wxo = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "48",
  height: "48",
  rx: "8",
  opacity: "0.2"
}, null, -1), fxo = /* @__PURE__ */ e("rect", {
  x: "168",
  y: "168",
  width: "48",
  height: "48",
  rx: "8",
  opacity: "0.2"
}, null, -1), gxo = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "168",
  width: "48",
  height: "48",
  rx: "8",
  opacity: "0.2"
}, null, -1), xxo = ["stroke"], jxo = ["stroke"], mxo = ["stroke"], Mxo = ["stroke"], vxo = ["stroke"], Sxo = ["stroke"], Hxo = ["stroke"], Axo = ["stroke"], Vxo = { key: 2 }, zxo = /* @__PURE__ */ e("path", { d: "M208,96a16,16,0,0,0,16-16V48a16,16,0,0,0-16-16H176a16,16,0,0,0-16,16v8H96V48A16,16,0,0,0,80,32H48A16,16,0,0,0,32,48V80A16,16,0,0,0,48,96h8v64H48a16,16,0,0,0-16,16v32a16,16,0,0,0,16,16H80a16,16,0,0,0,16-16v-8h64v8a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V176a16,16,0,0,0-16-16h-8V96Zm-24,64h-8a16,16,0,0,0-16,16v8H96v-8a16,16,0,0,0-16-16H72V96h8A16,16,0,0,0,96,80V72h64v8a16,16,0,0,0,16,16h8Z" }, null, -1), Zxo = [
  zxo
], Cxo = { key: 3 }, bxo = ["stroke"], Lxo = ["stroke"], Bxo = ["stroke"], Pxo = ["stroke"], Wxo = ["stroke"], Nxo = ["stroke"], Fxo = ["stroke"], Txo = ["stroke"], Dxo = { key: 4 }, Rxo = ["stroke"], Uxo = ["stroke"], qxo = ["stroke"], Gxo = ["stroke"], Exo = ["stroke"], Oxo = ["stroke"], Ixo = ["stroke"], Kxo = ["stroke"], Xxo = { key: 5 }, Jxo = ["stroke"], Qxo = ["stroke"], Yxo = ["stroke"], ojo = ["stroke"], ejo = ["stroke"], tjo = ["stroke"], njo = ["stroke"], sjo = ["stroke"], rjo = {
  name: "PhBoundingBox"
}, PR1 = /* @__PURE__ */ $({
  ...rjo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", lxo, [
        e("rect", {
          x: "168",
          y: "40",
          width: "48",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dxo),
        e("rect", {
          x: "40",
          y: "40",
          width: "48",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kxo),
        e("rect", {
          x: "168",
          y: "168",
          width: "48",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cxo),
        e("rect", {
          x: "40",
          y: "168",
          width: "48",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hxo),
        e("line", {
          x1: "64",
          y1: "168",
          x2: "64",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uxo),
        e("line", {
          x1: "168",
          y1: "192",
          x2: "88",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, axo),
        e("line", {
          x1: "192",
          y1: "88",
          x2: "192",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _xo),
        e("line", {
          x1: "88",
          y1: "64",
          x2: "168",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pxo)
      ])) : o(i) === "duotone" ? (s(), r("g", yxo, [
        $xo,
        wxo,
        fxo,
        gxo,
        e("rect", {
          x: "168",
          y: "40",
          width: "48",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xxo),
        e("rect", {
          x: "40",
          y: "40",
          width: "48",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jxo),
        e("rect", {
          x: "168",
          y: "168",
          width: "48",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mxo),
        e("rect", {
          x: "40",
          y: "168",
          width: "48",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mxo),
        e("line", {
          x1: "64",
          y1: "168",
          x2: "64",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vxo),
        e("line", {
          x1: "168",
          y1: "192",
          x2: "88",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sxo),
        e("line", {
          x1: "192",
          y1: "88",
          x2: "192",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hxo),
        e("line", {
          x1: "88",
          y1: "64",
          x2: "168",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Axo)
      ])) : o(i) === "fill" ? (s(), r("g", Vxo, Zxo)) : o(i) === "light" ? (s(), r("g", Cxo, [
        e("rect", {
          x: "168",
          y: "40",
          width: "48",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bxo),
        e("rect", {
          x: "40",
          y: "40",
          width: "48",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lxo),
        e("rect", {
          x: "168",
          y: "168",
          width: "48",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bxo),
        e("rect", {
          x: "40",
          y: "168",
          width: "48",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pxo),
        e("line", {
          x1: "64",
          y1: "168",
          x2: "64",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wxo),
        e("line", {
          x1: "168",
          y1: "192",
          x2: "88",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Nxo),
        e("line", {
          x1: "192",
          y1: "88",
          x2: "192",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fxo),
        e("line", {
          x1: "88",
          y1: "64",
          x2: "168",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Txo)
      ])) : o(i) === "thin" ? (s(), r("g", Dxo, [
        e("rect", {
          x: "168",
          y: "40",
          width: "48",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Rxo),
        e("rect", {
          x: "40",
          y: "40",
          width: "48",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Uxo),
        e("rect", {
          x: "168",
          y: "168",
          width: "48",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qxo),
        e("rect", {
          x: "40",
          y: "168",
          width: "48",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gxo),
        e("line", {
          x1: "64",
          y1: "168",
          x2: "64",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Exo),
        e("line", {
          x1: "168",
          y1: "192",
          x2: "88",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Oxo),
        e("line", {
          x1: "192",
          y1: "88",
          x2: "192",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ixo),
        e("line", {
          x1: "88",
          y1: "64",
          x2: "168",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kxo)
      ])) : o(i) === "regular" ? (s(), r("g", Xxo, [
        e("rect", {
          x: "168",
          y: "40",
          width: "48",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jxo),
        e("rect", {
          x: "40",
          y: "40",
          width: "48",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qxo),
        e("rect", {
          x: "168",
          y: "168",
          width: "48",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yxo),
        e("rect", {
          x: "40",
          y: "168",
          width: "48",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ojo),
        e("line", {
          x1: "64",
          y1: "168",
          x2: "64",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ejo),
        e("line", {
          x1: "168",
          y1: "192",
          x2: "88",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tjo),
        e("line", {
          x1: "192",
          y1: "88",
          x2: "192",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, njo),
        e("line", {
          x1: "88",
          y1: "64",
          x2: "168",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sjo)
      ])) : g("", !0)
    ], 16, ixo));
  }
}), ijo = ["width", "height", "fill", "transform"], ljo = { key: 0 }, djo = ["stroke"], kjo = ["stroke"], cjo = { key: 1 }, hjo = ["stroke"], ujo = ["stroke"], ajo = { key: 2 }, _jo = /* @__PURE__ */ e("path", { d: "M86.7,44.3,33.5,128l53.2,83.7a7.9,7.9,0,0,1-2.4,11A7.5,7.5,0,0,1,80,224a7.9,7.9,0,0,1-6.7-3.7l-56-88a7.9,7.9,0,0,1,0-8.6l56-88a8,8,0,1,1,13.4,8.6Zm152,79.4-56-88a8,8,0,1,0-13.4,8.6L222.5,128l-53.2,83.7a7.9,7.9,0,0,0,2.4,11A7.5,7.5,0,0,0,176,224a7.9,7.9,0,0,0,6.7-3.7l56-88A7.9,7.9,0,0,0,238.7,123.7Z" }, null, -1), pjo = [
  _jo
], yjo = { key: 3 }, $jo = ["stroke"], wjo = ["stroke"], fjo = { key: 4 }, gjo = ["stroke"], xjo = ["stroke"], jjo = { key: 5 }, mjo = ["stroke"], Mjo = ["stroke"], vjo = {
  name: "PhBracketsAngle"
}, WR1 = /* @__PURE__ */ $({
  ...vjo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ljo, [
        e("polyline", {
          points: "80 40 24 128 80 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, djo),
        e("polyline", {
          points: "176 40 232 128 176 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kjo)
      ])) : o(i) === "duotone" ? (s(), r("g", cjo, [
        e("polyline", {
          points: "80 40 24 128 80 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hjo),
        e("polyline", {
          points: "176 40 232 128 176 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ujo)
      ])) : o(i) === "fill" ? (s(), r("g", ajo, pjo)) : o(i) === "light" ? (s(), r("g", yjo, [
        e("polyline", {
          points: "80 40 24 128 80 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $jo),
        e("polyline", {
          points: "176 40 232 128 176 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wjo)
      ])) : o(i) === "thin" ? (s(), r("g", fjo, [
        e("polyline", {
          points: "80 40 24 128 80 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gjo),
        e("polyline", {
          points: "176 40 232 128 176 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xjo)
      ])) : o(i) === "regular" ? (s(), r("g", jjo, [
        e("polyline", {
          points: "80 40 24 128 80 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mjo),
        e("polyline", {
          points: "176 40 232 128 176 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mjo)
      ])) : g("", !0)
    ], 16, ijo));
  }
}), Sjo = ["width", "height", "fill", "transform"], Hjo = { key: 0 }, Ajo = ["stroke"], Vjo = ["stroke"], zjo = { key: 1 }, Zjo = ["stroke"], Cjo = ["stroke"], bjo = { key: 2 }, Ljo = /* @__PURE__ */ e("path", { d: "M43.2,128a30.4,30.4,0,0,1,8,10.3c4.8,9.9,4.8,22,4.8,33.7,0,24.3,1,36,24,36a8,8,0,0,1,0,16c-17.5,0-29.3-6.1-35.2-18.3C40,195.8,40,183.7,40,172c0-24.3-1-36-24-36a8,8,0,0,1,0-16c23,0,24-11.7,24-36,0-11.7,0-23.8,4.8-33.7C50.7,38.1,62.5,32,80,32a8,8,0,0,1,0,16C57,48,56,59.7,56,84c0,11.7,0,23.8-4.8,33.7A30.4,30.4,0,0,1,43.2,128ZM240,120c-23,0-24-11.7-24-36,0-11.7,0-23.8-4.8-33.7C205.3,38.1,193.5,32,176,32a8,8,0,0,0,0,16c23,0,24,11.7,24,36,0,11.7,0,23.8,4.8,33.7a30.4,30.4,0,0,0,8,10.3,30.4,30.4,0,0,0-8,10.3c-4.8,9.9-4.8,22-4.8,33.7,0,24.3-1,36-24,36a8,8,0,0,0,0,16c17.5,0,29.3-6.1,35.2-18.3,4.8-9.9,4.8-22,4.8-33.7,0-24.3,1-36,24-36a8,8,0,0,0,0-16Z" }, null, -1), Bjo = [
  Ljo
], Pjo = { key: 3 }, Wjo = ["stroke"], Njo = ["stroke"], Fjo = { key: 4 }, Tjo = ["stroke"], Djo = ["stroke"], Rjo = { key: 5 }, Ujo = ["stroke"], qjo = ["stroke"], Gjo = {
  name: "PhBracketsCurly"
}, NR1 = /* @__PURE__ */ $({
  ...Gjo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Hjo, [
        e("path", {
          d: "M80,40c-64,0,0,88-64,88,64,0,0,88,64,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ajo),
        e("path", {
          d: "M176,40c64,0,0,88,64,88-64,0,0,88-64,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vjo)
      ])) : o(i) === "duotone" ? (s(), r("g", zjo, [
        e("path", {
          d: "M80,40c-64,0,0,88-64,88,64,0,0,88,64,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zjo),
        e("path", {
          d: "M176,40c64,0,0,88,64,88-64,0,0,88-64,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cjo)
      ])) : o(i) === "fill" ? (s(), r("g", bjo, Bjo)) : o(i) === "light" ? (s(), r("g", Pjo, [
        e("path", {
          d: "M80,40c-64,0,0,88-64,88,64,0,0,88,64,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wjo),
        e("path", {
          d: "M176,40c64,0,0,88,64,88-64,0,0,88-64,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Njo)
      ])) : o(i) === "thin" ? (s(), r("g", Fjo, [
        e("path", {
          d: "M80,40c-64,0,0,88-64,88,64,0,0,88,64,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Tjo),
        e("path", {
          d: "M176,40c64,0,0,88,64,88-64,0,0,88-64,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Djo)
      ])) : o(i) === "regular" ? (s(), r("g", Rjo, [
        e("path", {
          d: "M80,40c-64,0,0,88-64,88,64,0,0,88,64,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ujo),
        e("path", {
          d: "M176,40c64,0,0,88,64,88-64,0,0,88-64,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qjo)
      ])) : g("", !0)
    ], 16, Sjo));
  }
}), Ejo = ["width", "height", "fill", "transform"], Ojo = { key: 0 }, Ijo = ["stroke"], Kjo = ["stroke"], Xjo = { key: 1 }, Jjo = ["stroke"], Qjo = ["stroke"], Yjo = { key: 2 }, omo = /* @__PURE__ */ e("path", { d: "M40,128c0,58.3,34.7,80.3,36.2,81.2A8,8,0,0,1,72,224a8.7,8.7,0,0,1-4.1-1.1C66.1,221.8,24,195.8,24,128S66.1,34.2,67.9,33.1a8.1,8.1,0,0,1,11,2.8,8,8,0,0,1-2.8,10.9C74.5,47.8,40,69.8,40,128ZM188.1,33.1a8,8,0,0,0-8.3,13.7c1.5.9,36.2,22.9,36.2,81.2s-34.7,80.3-36.1,81.1A8,8,0,0,0,184,224a8.7,8.7,0,0,0,4.1-1.1c1.8-1.1,43.9-27.1,43.9-94.9S189.9,34.2,188.1,33.1Z" }, null, -1), emo = [
  omo
], tmo = { key: 3 }, nmo = ["stroke"], smo = ["stroke"], rmo = { key: 4 }, imo = ["stroke"], lmo = ["stroke"], dmo = { key: 5 }, kmo = ["stroke"], cmo = ["stroke"], hmo = {
  name: "PhBracketsRound"
}, FR1 = /* @__PURE__ */ $({
  ...hmo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ojo, [
        e("path", {
          d: "M72,40S32,64,32,128s40,88,40,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ijo),
        e("path", {
          d: "M184,40s40,24,40,88-40,88-40,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kjo)
      ])) : o(i) === "duotone" ? (s(), r("g", Xjo, [
        e("path", {
          d: "M72,40S32,64,32,128s40,88,40,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jjo),
        e("path", {
          d: "M184,40s40,24,40,88-40,88-40,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qjo)
      ])) : o(i) === "fill" ? (s(), r("g", Yjo, emo)) : o(i) === "light" ? (s(), r("g", tmo, [
        e("path", {
          d: "M72,40S32,64,32,128s40,88,40,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nmo),
        e("path", {
          d: "M184,40s40,24,40,88-40,88-40,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, smo)
      ])) : o(i) === "thin" ? (s(), r("g", rmo, [
        e("path", {
          d: "M72,40S32,64,32,128s40,88,40,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, imo),
        e("path", {
          d: "M184,40s40,24,40,88-40,88-40,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lmo)
      ])) : o(i) === "regular" ? (s(), r("g", dmo, [
        e("path", {
          d: "M72,40S32,64,32,128s40,88,40,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kmo),
        e("path", {
          d: "M184,40s40,24,40,88-40,88-40,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cmo)
      ])) : g("", !0)
    ], 16, Ejo));
  }
}), umo = ["width", "height", "fill", "transform"], amo = { key: 0 }, _mo = ["stroke"], pmo = ["stroke"], ymo = { key: 1 }, $mo = ["stroke"], wmo = ["stroke"], fmo = { key: 2 }, gmo = /* @__PURE__ */ e("path", { d: "M48,48V208H80a8,8,0,0,1,0,16H40a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8H80a8,8,0,0,1,0,16ZM216,32H176a8,8,0,0,0,0,16h32V208H176a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32Z" }, null, -1), xmo = [
  gmo
], jmo = { key: 3 }, mmo = ["stroke"], Mmo = ["stroke"], vmo = { key: 4 }, Smo = ["stroke"], Hmo = ["stroke"], Amo = { key: 5 }, Vmo = ["stroke"], zmo = ["stroke"], Zmo = {
  name: "PhBracketsSquare"
}, TR1 = /* @__PURE__ */ $({
  ...Zmo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", amo, [
        e("polyline", {
          points: "80 40 40 40 40 216 80 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _mo),
        e("polyline", {
          points: "176 40 216 40 216 216 176 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pmo)
      ])) : o(i) === "duotone" ? (s(), r("g", ymo, [
        e("polyline", {
          points: "80 40 40 40 40 216 80 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $mo),
        e("polyline", {
          points: "176 40 216 40 216 216 176 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wmo)
      ])) : o(i) === "fill" ? (s(), r("g", fmo, xmo)) : o(i) === "light" ? (s(), r("g", jmo, [
        e("polyline", {
          points: "80 40 40 40 40 216 80 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mmo),
        e("polyline", {
          points: "176 40 216 40 216 216 176 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mmo)
      ])) : o(i) === "thin" ? (s(), r("g", vmo, [
        e("polyline", {
          points: "80 40 40 40 40 216 80 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Smo),
        e("polyline", {
          points: "176 40 216 40 216 216 176 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hmo)
      ])) : o(i) === "regular" ? (s(), r("g", Amo, [
        e("polyline", {
          points: "80 40 40 40 40 216 80 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vmo),
        e("polyline", {
          points: "176 40 216 40 216 216 176 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zmo)
      ])) : g("", !0)
    ], 16, umo));
  }
}), Cmo = ["width", "height", "fill", "transform"], bmo = { key: 0 }, Lmo = ["stroke"], Bmo = ["stroke"], Pmo = ["stroke"], Wmo = ["stroke"], Nmo = ["stroke"], Fmo = ["stroke"], Tmo = ["stroke"], Dmo = { key: 1 }, Rmo = /* @__PURE__ */ e("path", {
  d: "M208,86.7V72a40,40,0,0,0-80,0,40,40,0,0,0-80,0V86.7a48.1,48.1,0,0,0,0,90.6h0V184a40,40,0,0,0,80,0,40,40,0,0,0,80,0v-6.7h0a48.1,48.1,0,0,0,0-90.6Z",
  opacity: "0.2"
}, null, -1), Umo = ["stroke"], qmo = ["stroke"], Gmo = ["stroke"], Emo = ["stroke"], Omo = ["stroke"], Imo = ["stroke"], Kmo = ["stroke"], Xmo = { key: 2 }, Jmo = /* @__PURE__ */ e("path", { d: "M248,132a56,56,0,0,0-32-50.6V72a48,48,0,0,0-88-26.5A48,48,0,0,0,40,72v9.4a56,56,0,0,0,0,101.2V184a48,48,0,0,0,88,26.5A48,48,0,0,0,216,184v-1.4A56.1,56.1,0,0,0,248,132ZM88,216a32,32,0,0,1-31.8-28.6,49.3,49.3,0,0,0,7.8.6h8a8,8,0,0,0,0-16H64A40,40,0,0,1,50.7,94.3,8.1,8.1,0,0,0,56,86.7V72a32,32,0,0,1,64,0v76.3A47.4,47.4,0,0,0,88,136a8,8,0,0,0,0,16,32,32,0,0,1,0,64Zm104-44h-8a8,8,0,0,0,0,16h8a49.3,49.3,0,0,0,7.8-.6A32,32,0,1,1,168,152a8,8,0,0,0,0-16,47.4,47.4,0,0,0-32,12.3V72a32,32,0,0,1,64,0V86.7a8.1,8.1,0,0,0,5.3,7.6A40,40,0,0,1,192,172ZM60,128a8,8,0,0,1,0-16A20.1,20.1,0,0,0,80,92V84a8,8,0,0,1,16,0v8A36,36,0,0,1,60,128Zm144-8a8,8,0,0,1-8,8,36,36,0,0,1-36-36V84a8,8,0,0,1,16,0v8a20.1,20.1,0,0,0,20,20A8,8,0,0,1,204,120Z" }, null, -1), Qmo = [
  Jmo
], Ymo = { key: 3 }, oMo = ["stroke"], eMo = ["stroke"], tMo = ["stroke"], nMo = ["stroke"], sMo = ["stroke"], rMo = ["stroke"], iMo = ["stroke"], lMo = { key: 4 }, dMo = ["stroke"], kMo = ["stroke"], cMo = ["stroke"], hMo = ["stroke"], uMo = ["stroke"], aMo = ["stroke"], _Mo = ["stroke"], pMo = { key: 5 }, yMo = ["stroke"], $Mo = ["stroke"], wMo = ["stroke"], fMo = ["stroke"], gMo = ["stroke"], xMo = ["stroke"], jMo = ["stroke"], mMo = {
  name: "PhBrain"
}, DR1 = /* @__PURE__ */ $({
  ...mMo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", bmo, [
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lmo),
        e("path", {
          d: "M72,180H64A48,48,0,0,1,48,86.7V72a40,40,0,0,1,80,0V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bmo),
        e("path", {
          d: "M184,180h8a48,48,0,0,0,16-93.3V72a40,40,0,0,0-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pmo),
        e("path", {
          d: "M88,88v8a28,28,0,0,1-28,28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wmo),
        e("path", {
          d: "M168,88v8a28,28,0,0,0,28,28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nmo),
        e("path", {
          d: "M104,147.3A40,40,0,1,1,48,184v-6.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fmo),
        e("path", {
          d: "M152,147.3A40,40,0,1,0,208,184v-6.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Tmo)
      ])) : o(i) === "duotone" ? (s(), r("g", Dmo, [
        Rmo,
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Umo),
        e("path", {
          d: "M88,144a40,40,0,1,1-40,40v-6.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qmo),
        e("path", {
          d: "M168,144a40,40,0,1,0,40,40v-6.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gmo),
        e("path", {
          d: "M72,180H64A48,48,0,0,1,48,86.7V72a40,40,0,0,1,80,0V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Emo),
        e("path", {
          d: "M184,180h8a48,48,0,0,0,16-93.3V72a40,40,0,0,0-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Omo),
        e("path", {
          d: "M88,84v8a28,28,0,0,1-28,28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Imo),
        e("path", {
          d: "M168,84v8a28,28,0,0,0,28,28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kmo)
      ])) : o(i) === "fill" ? (s(), r("g", Xmo, Qmo)) : o(i) === "light" ? (s(), r("g", Ymo, [
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oMo),
        e("path", {
          d: "M88,144a40,40,0,1,1-40,40v-6.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eMo),
        e("path", {
          d: "M168,144a40,40,0,1,0,40,40v-6.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tMo),
        e("path", {
          d: "M72,180H64A48,48,0,0,1,48,86.7V72a40,40,0,0,1,80,0V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nMo),
        e("path", {
          d: "M184,180h8a48,48,0,0,0,16-93.3V72a40,40,0,0,0-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sMo),
        e("path", {
          d: "M88,84v8a28,28,0,0,1-28,28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rMo),
        e("path", {
          d: "M168,84v8a28,28,0,0,0,28,28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iMo)
      ])) : o(i) === "thin" ? (s(), r("g", lMo, [
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dMo),
        e("path", {
          d: "M88,144a40,40,0,1,1-40,40v-6.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kMo),
        e("path", {
          d: "M168,144a40,40,0,1,0,40,40v-6.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cMo),
        e("path", {
          d: "M72,180H64A48,48,0,0,1,48,86.7V72a40,40,0,0,1,80,0V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hMo),
        e("path", {
          d: "M184,180h8a48,48,0,0,0,16-93.3V72a40,40,0,0,0-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uMo),
        e("path", {
          d: "M88,84v8a28,28,0,0,1-28,28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aMo),
        e("path", {
          d: "M168,84v8a28,28,0,0,0,28,28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _Mo)
      ])) : o(i) === "regular" ? (s(), r("g", pMo, [
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yMo),
        e("path", {
          d: "M88,144a40,40,0,1,1-40,40v-6.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Mo),
        e("path", {
          d: "M168,144a40,40,0,1,0,40,40v-6.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wMo),
        e("path", {
          d: "M72,180H64A48,48,0,0,1,48,86.7V72a40,40,0,0,1,80,0V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fMo),
        e("path", {
          d: "M184,180h8a48,48,0,0,0,16-93.3V72a40,40,0,0,0-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gMo),
        e("path", {
          d: "M88,84v8a28,28,0,0,1-28,28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xMo),
        e("path", {
          d: "M168,84v8a28,28,0,0,0,28,28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jMo)
      ])) : g("", !0)
    ], 16, Cmo));
  }
}), MMo = ["width", "height", "fill", "transform"], vMo = { key: 0 }, SMo = ["stroke"], HMo = ["stroke"], AMo = ["stroke"], VMo = ["stroke"], zMo = { key: 1 }, ZMo = /* @__PURE__ */ e("path", {
  d: "M216,88A88,88,0,0,1,40,88Z",
  opacity: "0.2"
}, null, -1), CMo = ["stroke"], bMo = ["stroke"], LMo = ["stroke"], BMo = ["stroke"], PMo = { key: 2 }, WMo = /* @__PURE__ */ e("path", { d: "M224,88a96.2,96.2,0,0,0-15.5-52.4,8.2,8.2,0,0,0-6.7-3.6H54.2a8.2,8.2,0,0,0-6.7,3.6A96.1,96.1,0,0,0,120,183.7V216H88a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16H136V183.7A96.2,96.2,0,0,0,224,88ZM58.7,48H197.3a78.8,78.8,0,0,1,10.3,32H48.4A78.8,78.8,0,0,1,58.7,48Z" }, null, -1), NMo = [
  WMo
], FMo = { key: 3 }, TMo = ["stroke"], DMo = ["stroke"], RMo = ["stroke"], UMo = ["stroke"], qMo = { key: 4 }, GMo = ["stroke"], EMo = ["stroke"], OMo = ["stroke"], IMo = ["stroke"], KMo = { key: 5 }, XMo = ["stroke"], JMo = ["stroke"], QMo = ["stroke"], YMo = ["stroke"], ovo = {
  name: "PhBrandy"
}, RR1 = /* @__PURE__ */ $({
  ...ovo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", vMo, [
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SMo),
        e("line", {
          x1: "88",
          y1: "224",
          x2: "168",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HMo),
        e("path", {
          d: "M201.8,40A88,88,0,1,1,54.2,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, AMo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VMo)
      ])) : o(i) === "duotone" ? (s(), r("g", zMo, [
        ZMo,
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CMo),
        e("line", {
          x1: "88",
          y1: "224",
          x2: "168",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bMo),
        e("path", {
          d: "M201.8,40A88,88,0,1,1,54.2,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LMo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BMo)
      ])) : o(i) === "fill" ? (s(), r("g", PMo, NMo)) : o(i) === "light" ? (s(), r("g", FMo, [
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TMo),
        e("line", {
          x1: "88",
          y1: "224",
          x2: "168",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DMo),
        e("path", {
          d: "M201.8,40A88,88,0,1,1,54.2,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RMo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UMo)
      ])) : o(i) === "thin" ? (s(), r("g", qMo, [
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GMo),
        e("line", {
          x1: "88",
          y1: "224",
          x2: "168",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, EMo),
        e("path", {
          d: "M201.8,40A88,88,0,1,1,54.2,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OMo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, IMo)
      ])) : o(i) === "regular" ? (s(), r("g", KMo, [
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XMo),
        e("line", {
          x1: "88",
          y1: "224",
          x2: "168",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JMo),
        e("path", {
          d: "M201.8,40A88,88,0,1,1,54.2,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QMo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YMo)
      ])) : g("", !0)
    ], 16, MMo));
  }
}), evo = ["width", "height", "fill", "transform"], tvo = { key: 0 }, nvo = ["stroke"], svo = ["stroke"], rvo = ["stroke"], ivo = ["stroke"], lvo = { key: 1 }, dvo = /* @__PURE__ */ e("path", {
  d: "M128,152a190.3,190.3,0,0,1-96-25.7V208a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V126.3A191.3,191.3,0,0,1,128,152Z",
  opacity: "0.2"
}, null, -1), kvo = ["stroke"], cvo = ["stroke"], hvo = ["stroke"], uvo = ["stroke"], avo = { key: 2 }, _vo = /* @__PURE__ */ e("path", { d: "M216,64H176V56a24.1,24.1,0,0,0-24-24H104A24.1,24.1,0,0,0,80,56v8H40A16,16,0,0,0,24,80V208a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64ZM96,56a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96ZM216,80v41.6A183.6,183.6,0,0,1,128,144a183.6,183.6,0,0,1-88-22.4V80ZM108,120a8,8,0,0,1,8-8h24a8,8,0,0,1,0,16H116A8,8,0,0,1,108,120Z" }, null, -1), pvo = [
  _vo
], yvo = { key: 3 }, $vo = ["stroke"], wvo = ["stroke"], fvo = ["stroke"], gvo = ["stroke"], xvo = { key: 4 }, jvo = ["stroke"], mvo = ["stroke"], Mvo = ["stroke"], vvo = ["stroke"], Svo = { key: 5 }, Hvo = ["stroke"], Avo = ["stroke"], Vvo = ["stroke"], zvo = ["stroke"], Zvo = {
  name: "PhBriefcase"
}, UR1 = /* @__PURE__ */ $({
  ...Zvo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", tvo, [
        e("rect", {
          x: "32",
          y: "68",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nvo),
        e("path", {
          d: "M168,68V48a16,16,0,0,0-16-16H104A16,16,0,0,0,88,48V68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, svo),
        e("path", {
          d: "M224,122.3A191.3,191.3,0,0,1,128,148a190.3,190.3,0,0,1-96-25.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rvo),
        e("line", {
          x1: "116",
          y1: "112",
          x2: "140",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ivo)
      ])) : o(i) === "duotone" ? (s(), r("g", lvo, [
        dvo,
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kvo),
        e("path", {
          d: "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cvo),
        e("path", {
          d: "M224,126.3A191.3,191.3,0,0,1,128,152a190.3,190.3,0,0,1-96-25.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hvo),
        e("line", {
          x1: "116",
          y1: "120",
          x2: "140",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uvo)
      ])) : o(i) === "fill" ? (s(), r("g", avo, pvo)) : o(i) === "light" ? (s(), r("g", yvo, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $vo),
        e("path", {
          d: "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wvo),
        e("path", {
          d: "M224,126.3A191.3,191.3,0,0,1,128,152a190.3,190.3,0,0,1-96-25.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fvo),
        e("line", {
          x1: "116",
          y1: "120",
          x2: "140",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gvo)
      ])) : o(i) === "thin" ? (s(), r("g", xvo, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jvo),
        e("path", {
          d: "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mvo),
        e("path", {
          d: "M224,126.3A191.3,191.3,0,0,1,128,152a190.3,190.3,0,0,1-96-25.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Mvo),
        e("line", {
          x1: "116",
          y1: "120",
          x2: "140",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vvo)
      ])) : o(i) === "regular" ? (s(), r("g", Svo, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hvo),
        e("path", {
          d: "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Avo),
        e("path", {
          d: "M224,126.3A191.3,191.3,0,0,1,128,152a190.3,190.3,0,0,1-96-25.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vvo),
        e("line", {
          x1: "116",
          y1: "120",
          x2: "140",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zvo)
      ])) : g("", !0)
    ], 16, evo));
  }
}), Cvo = ["width", "height", "fill", "transform"], bvo = { key: 0 }, Lvo = ["stroke"], Bvo = ["stroke"], Pvo = ["stroke"], Wvo = ["stroke"], Nvo = { key: 1 }, Fvo = /* @__PURE__ */ e("path", {
  d: "M32,112H224V80a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8Z",
  opacity: "0.2"
}, null, -1), Tvo = /* @__PURE__ */ e("path", {
  d: "M32,176H224v32a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8Z",
  opacity: "0.2"
}, null, -1), Dvo = ["stroke"], Rvo = ["stroke"], Uvo = ["stroke"], qvo = ["stroke"], Gvo = { key: 2 }, Evo = /* @__PURE__ */ e("path", { d: "M28,120H228a4,4,0,0,1,4,4v40a4,4,0,0,1-4,4H28a4,4,0,0,1-4-4V124A4,4,0,0,1,28,120Zm-4,88a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V188a4,4,0,0,0-4-4H28a4,4,0,0,0-4,4ZM232,80v20a4,4,0,0,1-4,4H28a4,4,0,0,1-4-4V80A16,16,0,0,1,40,64H80V56a23.9,23.9,0,0,1,24-24h48a23.9,23.9,0,0,1,24,24v8h40A16,16,0,0,1,232,80ZM160,56a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v8h64Z" }, null, -1), Ovo = [
  Evo
], Ivo = { key: 3 }, Kvo = ["stroke"], Xvo = ["stroke"], Jvo = ["stroke"], Qvo = ["stroke"], Yvo = { key: 4 }, oSo = ["stroke"], eSo = ["stroke"], tSo = ["stroke"], nSo = ["stroke"], sSo = { key: 5 }, rSo = ["stroke"], iSo = ["stroke"], lSo = ["stroke"], dSo = ["stroke"], kSo = {
  name: "PhBriefcaseMetal"
}, qR1 = /* @__PURE__ */ $({
  ...kSo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", bvo, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lvo),
        e("line", {
          x1: "32",
          y1: "176",
          x2: "224",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bvo),
        e("line", {
          x1: "32",
          y1: "112",
          x2: "224",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pvo),
        e("path", {
          d: "M168,68V48a16,16,0,0,0-16-16H104A16,16,0,0,0,88,48V68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wvo)
      ])) : o(i) === "duotone" ? (s(), r("g", Nvo, [
        Fvo,
        Tvo,
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dvo),
        e("path", {
          d: "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rvo),
        e("line", {
          x1: "32",
          y1: "176",
          x2: "224",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uvo),
        e("line", {
          x1: "32",
          y1: "112",
          x2: "224",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qvo)
      ])) : o(i) === "fill" ? (s(), r("g", Gvo, Ovo)) : o(i) === "light" ? (s(), r("g", Ivo, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kvo),
        e("path", {
          d: "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xvo),
        e("line", {
          x1: "32",
          y1: "176",
          x2: "224",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jvo),
        e("line", {
          x1: "32",
          y1: "112",
          x2: "224",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qvo)
      ])) : o(i) === "thin" ? (s(), r("g", Yvo, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oSo),
        e("path", {
          d: "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eSo),
        e("line", {
          x1: "32",
          y1: "176",
          x2: "224",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tSo),
        e("line", {
          x1: "32",
          y1: "112",
          x2: "224",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nSo)
      ])) : o(i) === "regular" ? (s(), r("g", sSo, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rSo),
        e("path", {
          d: "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iSo),
        e("line", {
          x1: "32",
          y1: "176",
          x2: "224",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lSo),
        e("line", {
          x1: "32",
          y1: "112",
          x2: "224",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dSo)
      ])) : g("", !0)
    ], 16, Cvo));
  }
}), cSo = ["width", "height", "fill", "transform"], hSo = { key: 0 }, uSo = ["stroke"], aSo = ["stroke"], _So = ["stroke"], pSo = ["stroke"], ySo = ["stroke"], $So = { key: 1 }, wSo = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "32",
  opacity: "0.2"
}, null, -1), fSo = ["stroke"], gSo = ["stroke"], xSo = ["stroke"], jSo = ["stroke"], mSo = ["stroke"], MSo = { key: 2 }, vSo = /* @__PURE__ */ j('<circle cx="128" cy="128" r="40"></circle><path d="M82.7,82.7a7.9,7.9,0,0,0,0-11.3,8,8,0,0,0-11.3,0A80,80,0,0,0,54.3,96.9a79.9,79.9,0,0,0,0,62.2,80,80,0,0,0,17.1,25.5,8.3,8.3,0,0,0,5.7,2.3,8,8,0,0,0,5.6-2.3,7.9,7.9,0,0,0,0-11.3A65.4,65.4,0,0,1,69,152.9a64.5,64.5,0,0,1,0-49.8A65.4,65.4,0,0,1,82.7,82.7Z"></path><path d="M208,128a78.6,78.6,0,0,0-6.3-31.1,80,80,0,0,0-17.1-25.5,8,8,0,0,0-11.3,0,7.9,7.9,0,0,0,0,11.3A65.4,65.4,0,0,1,187,103.1a64.5,64.5,0,0,1,0,49.8,65.4,65.4,0,0,1-13.7,20.4,7.9,7.9,0,0,0,0,11.3,8,8,0,0,0,5.6,2.3,8.3,8.3,0,0,0,5.7-2.3,80,80,0,0,0,17.1-25.5A78.6,78.6,0,0,0,208,128Z"></path><path d="M32.2,168.5a104.1,104.1,0,0,1,0-81,101.3,101.3,0,0,1,22.3-33A8.1,8.1,0,0,0,43.1,43.1,121.8,121.8,0,0,0,17.4,81.3a120.7,120.7,0,0,0,0,93.4,121.8,121.8,0,0,0,25.7,38.2,8.5,8.5,0,0,0,5.7,2.3,8.3,8.3,0,0,0,5.7-2.3,8.1,8.1,0,0,0,0-11.4A101.3,101.3,0,0,1,32.2,168.5Z"></path><path d="M238.6,81.3a121.8,121.8,0,0,0-25.7-38.2,8.1,8.1,0,1,0-11.4,11.4A103.5,103.5,0,0,1,232,128a103.5,103.5,0,0,1-30.5,73.5,8.1,8.1,0,0,0,0,11.4,8.3,8.3,0,0,0,5.7,2.3,8.5,8.5,0,0,0,5.7-2.3,121.8,121.8,0,0,0,25.7-38.2,120.7,120.7,0,0,0,0-93.4Z"></path>', 5), SSo = [
  vSo
], HSo = { key: 3 }, ASo = ["stroke"], VSo = ["stroke"], zSo = ["stroke"], ZSo = ["stroke"], CSo = ["stroke"], bSo = { key: 4 }, LSo = ["stroke"], BSo = ["stroke"], PSo = ["stroke"], WSo = ["stroke"], NSo = ["stroke"], FSo = { key: 5 }, TSo = ["stroke"], DSo = ["stroke"], RSo = ["stroke"], USo = ["stroke"], qSo = ["stroke"], GSo = {
  name: "PhBroadcast"
}, GR1 = /* @__PURE__ */ $({
  ...GSo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", hSo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uSo),
        e("path", {
          d: "M77.1,178.9A71.6,71.6,0,0,1,61.7,156a71.6,71.6,0,0,1,0-56A71.6,71.6,0,0,1,77.1,77.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aSo),
        e("path", {
          d: "M178.9,77.1A71.6,71.6,0,0,1,194.3,100a71.6,71.6,0,0,1,0,56,71.6,71.6,0,0,1-15.4,22.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _So),
        e("path", {
          d: "M48.8,207.2a112.9,112.9,0,0,1-24-35.6,112.4,112.4,0,0,1,0-87.2,112.9,112.9,0,0,1,24-35.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pSo),
        e("path", {
          d: "M207.2,48.8a112.9,112.9,0,0,1,24,35.6,112.4,112.4,0,0,1,0,87.2,112.9,112.9,0,0,1-24,35.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ySo)
      ])) : o(i) === "duotone" ? (s(), r("g", $So, [
        wSo,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fSo),
        e("path", {
          d: "M77.1,178.9A71.6,71.6,0,0,1,61.7,156a71.6,71.6,0,0,1,0-56A71.6,71.6,0,0,1,77.1,77.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gSo),
        e("path", {
          d: "M178.9,77.1A71.6,71.6,0,0,1,194.3,100a71.6,71.6,0,0,1,0,56,71.6,71.6,0,0,1-15.4,22.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xSo),
        e("path", {
          d: "M48.8,207.2a112.9,112.9,0,0,1-24-35.6,112.4,112.4,0,0,1,0-87.2,112.9,112.9,0,0,1,24-35.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jSo),
        e("path", {
          d: "M207.2,48.8a112.9,112.9,0,0,1,24,35.6,112.4,112.4,0,0,1,0,87.2,112.9,112.9,0,0,1-24,35.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mSo)
      ])) : o(i) === "fill" ? (s(), r("g", MSo, SSo)) : o(i) === "light" ? (s(), r("g", HSo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ASo),
        e("path", {
          d: "M77.1,178.9A71.6,71.6,0,0,1,61.7,156a71.6,71.6,0,0,1,0-56A71.6,71.6,0,0,1,77.1,77.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VSo),
        e("path", {
          d: "M178.9,77.1A71.6,71.6,0,0,1,194.3,100a71.6,71.6,0,0,1,0,56,71.6,71.6,0,0,1-15.4,22.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zSo),
        e("path", {
          d: "M48.8,207.2a112.9,112.9,0,0,1-24-35.6,112.4,112.4,0,0,1,0-87.2,112.9,112.9,0,0,1,24-35.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZSo),
        e("path", {
          d: "M207.2,48.8a112.9,112.9,0,0,1,24,35.6,112.4,112.4,0,0,1,0,87.2,112.9,112.9,0,0,1-24,35.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, CSo)
      ])) : o(i) === "thin" ? (s(), r("g", bSo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LSo),
        e("path", {
          d: "M77.1,178.9A71.6,71.6,0,0,1,61.7,156a71.6,71.6,0,0,1,0-56A71.6,71.6,0,0,1,77.1,77.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, BSo),
        e("path", {
          d: "M178.9,77.1A71.6,71.6,0,0,1,194.3,100a71.6,71.6,0,0,1,0,56,71.6,71.6,0,0,1-15.4,22.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PSo),
        e("path", {
          d: "M48.8,207.2a112.9,112.9,0,0,1-24-35.6,112.4,112.4,0,0,1,0-87.2,112.9,112.9,0,0,1,24-35.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WSo),
        e("path", {
          d: "M207.2,48.8a112.9,112.9,0,0,1,24,35.6,112.4,112.4,0,0,1,0,87.2,112.9,112.9,0,0,1-24,35.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, NSo)
      ])) : o(i) === "regular" ? (s(), r("g", FSo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TSo),
        e("path", {
          d: "M77.1,178.9A71.6,71.6,0,0,1,61.7,156a71.6,71.6,0,0,1,0-56A71.6,71.6,0,0,1,77.1,77.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DSo),
        e("path", {
          d: "M178.9,77.1A71.6,71.6,0,0,1,194.3,100a71.6,71.6,0,0,1,0,56,71.6,71.6,0,0,1-15.4,22.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RSo),
        e("path", {
          d: "M48.8,207.2a112.9,112.9,0,0,1-24-35.6,112.4,112.4,0,0,1,0-87.2,112.9,112.9,0,0,1,24-35.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, USo),
        e("path", {
          d: "M207.2,48.8a112.9,112.9,0,0,1,24,35.6,112.4,112.4,0,0,1,0,87.2,112.9,112.9,0,0,1-24,35.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qSo)
      ])) : g("", !0)
    ], 16, cSo));
  }
}), ESo = ["width", "height", "fill", "transform"], OSo = { key: 0 }, ISo = ["stroke"], KSo = ["stroke"], XSo = { key: 1 }, JSo = /* @__PURE__ */ e("path", {
  d: "M32,96H224V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8Z",
  opacity: "0.2"
}, null, -1), QSo = ["stroke"], YSo = ["stroke"], oHo = { key: 2 }, eHo = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16V88H40V56Z" }, null, -1), tHo = [
  eHo
], nHo = { key: 3 }, sHo = ["stroke"], rHo = ["stroke"], iHo = { key: 4 }, lHo = ["stroke"], dHo = ["stroke"], kHo = { key: 5 }, cHo = ["stroke"], hHo = ["stroke"], uHo = {
  name: "PhBrowser"
}, ER1 = /* @__PURE__ */ $({
  ...uHo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", OSo, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ISo),
        e("line", {
          x1: "32",
          y1: "96",
          x2: "224",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KSo)
      ])) : o(i) === "duotone" ? (s(), r("g", XSo, [
        JSo,
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QSo),
        e("line", {
          x1: "32",
          y1: "96",
          x2: "224",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YSo)
      ])) : o(i) === "fill" ? (s(), r("g", oHo, tHo)) : o(i) === "light" ? (s(), r("g", nHo, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sHo),
        e("line", {
          x1: "32",
          y1: "96",
          x2: "224",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rHo)
      ])) : o(i) === "thin" ? (s(), r("g", iHo, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lHo),
        e("line", {
          x1: "32",
          y1: "96",
          x2: "224",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dHo)
      ])) : o(i) === "regular" ? (s(), r("g", kHo, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cHo),
        e("line", {
          x1: "32",
          y1: "96",
          x2: "224",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hHo)
      ])) : g("", !0)
    ], 16, ESo));
  }
}), aHo = ["width", "height", "fill", "transform"], _Ho = { key: 0 }, pHo = ["stroke"], yHo = ["stroke"], $Ho = ["stroke"], wHo = { key: 1 }, fHo = /* @__PURE__ */ e("path", {
  d: "M216,48H72a8,8,0,0,0-8,8V80H184a8,8,0,0,1,8,8v88h24a8,8,0,0,0,8-8V56A8,8,0,0,0,216,48Z",
  opacity: "0.2"
}, null, -1), gHo = ["stroke"], xHo = ["stroke"], jHo = ["stroke"], mHo = { key: 2 }, MHo = /* @__PURE__ */ e("path", { d: "M216,40H72A16,16,0,0,0,56,56V72H40A16,16,0,0,0,24,88V200a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V184h16a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM184,88v16H40V88Zm32,80H200V88a16,16,0,0,0-16-16H72V56H216Z" }, null, -1), vHo = [
  MHo
], SHo = { key: 3 }, HHo = ["stroke"], AHo = ["stroke"], VHo = ["stroke"], zHo = { key: 4 }, ZHo = ["stroke"], CHo = ["stroke"], bHo = ["stroke"], LHo = { key: 5 }, BHo = ["stroke"], PHo = ["stroke"], WHo = ["stroke"], NHo = {
  name: "PhBrowsers"
}, OR1 = /* @__PURE__ */ $({
  ...NHo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", _Ho, [
        e("rect", {
          x: "28",
          y: "84",
          width: "160",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pHo),
        e("path", {
          d: "M68,84V52a8,8,0,0,1,8-8H220a8,8,0,0,1,8,8V164a8,8,0,0,1-8,8H188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yHo),
        e("line", {
          x1: "28",
          y1: "124",
          x2: "188",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $Ho)
      ])) : o(i) === "duotone" ? (s(), r("g", wHo, [
        fHo,
        e("rect", {
          x: "32",
          y: "80",
          width: "160",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gHo),
        e("path", {
          d: "M64,80V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168a8,8,0,0,1-8,8H192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xHo),
        e("line", {
          x1: "32",
          y1: "112",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jHo)
      ])) : o(i) === "fill" ? (s(), r("g", mHo, vHo)) : o(i) === "light" ? (s(), r("g", SHo, [
        e("rect", {
          x: "32",
          y: "80",
          width: "160",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HHo),
        e("path", {
          d: "M64,80V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168a8,8,0,0,1-8,8H192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, AHo),
        e("line", {
          x1: "32",
          y1: "112",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VHo)
      ])) : o(i) === "thin" ? (s(), r("g", zHo, [
        e("rect", {
          x: "32",
          y: "80",
          width: "160",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZHo),
        e("path", {
          d: "M64,80V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168a8,8,0,0,1-8,8H192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CHo),
        e("line", {
          x1: "32",
          y1: "112",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bHo)
      ])) : o(i) === "regular" ? (s(), r("g", LHo, [
        e("rect", {
          x: "32",
          y: "80",
          width: "160",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BHo),
        e("path", {
          d: "M64,80V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168a8,8,0,0,1-8,8H192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PHo),
        e("line", {
          x1: "32",
          y1: "112",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WHo)
      ])) : g("", !0)
    ], 16, aHo));
  }
}), FHo = ["width", "height", "fill", "transform"], THo = { key: 0 }, DHo = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "88",
  r: "16"
}, null, -1), RHo = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "88",
  r: "16"
}, null, -1), UHo = ["stroke"], qHo = ["stroke"], GHo = ["stroke"], EHo = ["stroke"], OHo = ["stroke"], IHo = ["stroke"], KHo = ["stroke"], XHo = { key: 1 }, JHo = /* @__PURE__ */ e("path", {
  d: "M208,128v16a80,80,0,0,1-160,0V128Z",
  opacity: "0.2"
}, null, -1), QHo = /* @__PURE__ */ e("circle", {
  cx: "155.9",
  cy: "92",
  r: "12"
}, null, -1), YHo = /* @__PURE__ */ e("circle", {
  cx: "99.9",
  cy: "92",
  r: "12"
}, null, -1), oAo = ["stroke"], eAo = ["stroke"], tAo = ["stroke"], nAo = ["stroke"], sAo = ["stroke"], rAo = ["stroke"], iAo = ["stroke"], lAo = { key: 2 }, dAo = /* @__PURE__ */ e("path", { d: "M167.9,92a12,12,0,1,1-12-12A12,12,0,0,1,167.9,92Zm-68-12a12,12,0,1,0,12,12A12,12,0,0,0,99.9,80ZM252,128a8,8,0,0,1-8,8H216v8a88.1,88.1,0,0,1-3.2,23.7l23.1,13.4a8,8,0,0,1-4,14.9,7.6,7.6,0,0,1-4-1.1L207,182.8a88,88,0,0,1-158,0L28.1,194.9a7.6,7.6,0,0,1-4,1.1,8,8,0,0,1-4-14.9l23.1-13.4A88.1,88.1,0,0,1,40,144v-8H12a8,8,0,0,1,0-16H40v-8a88.1,88.1,0,0,1,3.2-23.7L20.1,74.9a8,8,0,0,1-3-10.9,8.1,8.1,0,0,1,11-2.9L49,73.2a88,88,0,0,1,158,0l20.9-12.1a8.1,8.1,0,0,1,11,2.9,8,8,0,0,1-3,10.9L212.8,88.3A88.1,88.1,0,0,1,216,112v8h28A8,8,0,0,1,252,128ZM136,144a8,8,0,0,0-16,0v64a8,8,0,0,0,16,0Zm64-32a72,72,0,0,0-144,0v8H200Z" }, null, -1), kAo = [
  dAo
], cAo = { key: 3 }, hAo = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "92",
  r: "10"
}, null, -1), uAo = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "92",
  r: "10"
}, null, -1), aAo = ["stroke"], _Ao = ["stroke"], pAo = ["stroke"], yAo = ["stroke"], $Ao = ["stroke"], wAo = ["stroke"], fAo = ["stroke"], gAo = { key: 4 }, xAo = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "92",
  r: "8"
}, null, -1), jAo = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "92",
  r: "8"
}, null, -1), mAo = ["stroke"], MAo = ["stroke"], vAo = ["stroke"], SAo = ["stroke"], HAo = ["stroke"], AAo = ["stroke"], VAo = ["stroke"], zAo = { key: 5 }, ZAo = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "92",
  r: "12"
}, null, -1), CAo = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "92",
  r: "12"
}, null, -1), bAo = ["stroke"], LAo = ["stroke"], BAo = ["stroke"], PAo = ["stroke"], WAo = ["stroke"], NAo = ["stroke"], FAo = ["stroke"], TAo = {
  name: "PhBug"
}, IR1 = /* @__PURE__ */ $({
  ...TAo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", THo, [
        DHo,
        RHo,
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, UHo),
        e("line", {
          x1: "244",
          y1: "128",
          x2: "12",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qHo),
        e("path", {
          d: "M208,144a80,80,0,0,1-160,0V112a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GHo),
        e("line", {
          x1: "231.9",
          y1: "188",
          x2: "203.2",
          y2: "171.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, EHo),
        e("line", {
          x1: "231.9",
          y1: "68",
          x2: "203.2",
          y2: "84.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OHo),
        e("line", {
          x1: "24.1",
          y1: "68",
          x2: "52.8",
          y2: "84.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IHo),
        e("line", {
          x1: "24.1",
          y1: "188",
          x2: "52.8",
          y2: "171.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KHo)
      ])) : o(i) === "duotone" ? (s(), r("g", XHo, [
        JHo,
        QHo,
        YHo,
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oAo),
        e("line", {
          x1: "244",
          y1: "128",
          x2: "12",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eAo),
        e("path", {
          d: "M208,144a80,80,0,0,1-160,0V112a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tAo),
        e("line", {
          x1: "231.9",
          y1: "188",
          x2: "203.2",
          y2: "171.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nAo),
        e("line", {
          x1: "231.9",
          y1: "68",
          x2: "203.2",
          y2: "84.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sAo),
        e("line", {
          x1: "24.1",
          y1: "68",
          x2: "52.8",
          y2: "84.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rAo),
        e("line", {
          x1: "24.1",
          y1: "188",
          x2: "52.8",
          y2: "171.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iAo)
      ])) : o(i) === "fill" ? (s(), r("g", lAo, kAo)) : o(i) === "light" ? (s(), r("g", cAo, [
        hAo,
        uAo,
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aAo),
        e("line", {
          x1: "244",
          y1: "128",
          x2: "12",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _Ao),
        e("path", {
          d: "M208,144a80,80,0,0,1-160,0V112a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pAo),
        e("line", {
          x1: "231.9",
          y1: "188",
          x2: "203.2",
          y2: "171.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yAo),
        e("line", {
          x1: "231.9",
          y1: "68",
          x2: "203.2",
          y2: "84.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $Ao),
        e("line", {
          x1: "24.1",
          y1: "68",
          x2: "52.8",
          y2: "84.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wAo),
        e("line", {
          x1: "24.1",
          y1: "188",
          x2: "52.8",
          y2: "171.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fAo)
      ])) : o(i) === "thin" ? (s(), r("g", gAo, [
        xAo,
        jAo,
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mAo),
        e("line", {
          x1: "244",
          y1: "128",
          x2: "12",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MAo),
        e("path", {
          d: "M208,144a80,80,0,0,1-160,0V112a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vAo),
        e("line", {
          x1: "231.9",
          y1: "188",
          x2: "203.2",
          y2: "171.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SAo),
        e("line", {
          x1: "231.9",
          y1: "68",
          x2: "203.2",
          y2: "84.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HAo),
        e("line", {
          x1: "24.1",
          y1: "68",
          x2: "52.8",
          y2: "84.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, AAo),
        e("line", {
          x1: "24.1",
          y1: "188",
          x2: "52.8",
          y2: "171.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VAo)
      ])) : o(i) === "regular" ? (s(), r("g", zAo, [
        ZAo,
        CAo,
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bAo),
        e("line", {
          x1: "244",
          y1: "128",
          x2: "12",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LAo),
        e("path", {
          d: "M208,144a80,80,0,0,1-160,0V112a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BAo),
        e("line", {
          x1: "231.9",
          y1: "188",
          x2: "203.2",
          y2: "171.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PAo),
        e("line", {
          x1: "231.9",
          y1: "68",
          x2: "203.2",
          y2: "84.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WAo),
        e("line", {
          x1: "24.1",
          y1: "68",
          x2: "52.8",
          y2: "84.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NAo),
        e("line", {
          x1: "24.1",
          y1: "188",
          x2: "52.8",
          y2: "171.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FAo)
      ])) : g("", !0)
    ], 16, FHo));
  }
}), DAo = ["width", "height", "fill", "transform"], RAo = { key: 0 }, UAo = ["stroke"], qAo = ["stroke"], GAo = ["stroke"], EAo = ["stroke"], OAo = ["stroke"], IAo = ["stroke"], KAo = ["stroke"], XAo = ["stroke"], JAo = ["stroke"], QAo = { key: 1 }, YAo = /* @__PURE__ */ e("path", {
  d: "M200,104v48a72,72,0,0,1-72,72h0a72,72,0,0,1-72-72V104Z",
  opacity: "0.2"
}, null, -1), oVo = ["stroke"], eVo = ["stroke"], tVo = ["stroke"], nVo = ["stroke"], sVo = ["stroke"], rVo = ["stroke"], iVo = ["stroke"], lVo = ["stroke"], dVo = ["stroke"], kVo = { key: 2 }, cVo = /* @__PURE__ */ e("path", { d: "M50.4,33.8a8,8,0,0,1,11-11.6L80.1,40a79.8,79.8,0,0,1,95.7-.1l18.6-17.7a8,8,0,0,1,11.3.3,7.9,7.9,0,0,1-.3,11.3L187.6,50.7a79.6,79.6,0,0,1,20,45.3H48.4A79.9,79.9,0,0,1,68.3,50.8ZM32,96a8,8,0,0,0,0,16H48V96Zm176,56a70.3,70.3,0,0,1-.4,8H224a8,8,0,0,1,0,16H204.3a80,80,0,0,1-152.6,0H32a8,8,0,0,1,0-16H48.4a70.3,70.3,0,0,1-.4-8v-8H32a8,8,0,0,1,0-16H48V112H208v16h16a8,8,0,0,1,0,16H208Zm-72-16a8,8,0,0,0-16,0v64a8,8,0,0,0,16,0Zm96-32a8,8,0,0,0-8-8H208v16h16A8,8,0,0,0,232,104Z" }, null, -1), hVo = [
  cVo
], uVo = { key: 3 }, aVo = ["stroke"], _Vo = ["stroke"], pVo = ["stroke"], yVo = ["stroke"], $Vo = ["stroke"], wVo = ["stroke"], fVo = ["stroke"], gVo = ["stroke"], xVo = ["stroke"], jVo = { key: 4 }, mVo = ["stroke"], MVo = ["stroke"], vVo = ["stroke"], SVo = ["stroke"], HVo = ["stroke"], AVo = ["stroke"], VVo = ["stroke"], zVo = ["stroke"], ZVo = ["stroke"], CVo = { key: 5 }, bVo = ["stroke"], LVo = ["stroke"], BVo = ["stroke"], PVo = ["stroke"], WVo = ["stroke"], NVo = ["stroke"], FVo = ["stroke"], TVo = ["stroke"], DVo = ["stroke"], RVo = {
  name: "PhBugBeetle"
}, KR1 = /* @__PURE__ */ $({
  ...RVo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", RAo, [
        e("rect", {
          x: "56",
          y: "32",
          width: "144",
          height: "192",
          rx: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, UAo),
        e("line", {
          x1: "200",
          y1: "144",
          x2: "224",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qAo),
        e("line", {
          x1: "32",
          y1: "144",
          x2: "56",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GAo),
        e("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, EAo),
        e("line", {
          x1: "128",
          y1: "144",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OAo),
        e("line", {
          x1: "55.9",
          y1: "28",
          x2: "79.7",
          y2: "50.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IAo),
        e("line", {
          x1: "199.9",
          y1: "28",
          x2: "176.2",
          y2: "50.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KAo),
        e("line", {
          x1: "32",
          y1: "184",
          x2: "63.5",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XAo),
        e("line", {
          x1: "192.5",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, JAo)
      ])) : o(i) === "duotone" ? (s(), r("g", QAo, [
        YAo,
        e("rect", {
          x: "56",
          y: "32",
          width: "144",
          height: "192",
          rx: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oVo),
        e("line", {
          x1: "200",
          y1: "136",
          x2: "224",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eVo),
        e("line", {
          x1: "32",
          y1: "136",
          x2: "56",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tVo),
        e("line", {
          x1: "32",
          y1: "168",
          x2: "57.8",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nVo),
        e("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sVo),
        e("line", {
          x1: "128",
          y1: "136",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rVo),
        e("line", {
          x1: "198.2",
          y1: "168",
          x2: "224",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iVo),
        e("line", {
          x1: "55.9",
          y1: "28",
          x2: "79.7",
          y2: "50.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lVo),
        e("line", {
          x1: "199.9",
          y1: "28",
          x2: "176.2",
          y2: "50.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dVo)
      ])) : o(i) === "fill" ? (s(), r("g", kVo, hVo)) : o(i) === "light" ? (s(), r("g", uVo, [
        e("rect", {
          x: "56",
          y: "32",
          width: "144",
          height: "192",
          rx: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aVo),
        e("line", {
          x1: "200",
          y1: "136",
          x2: "224",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _Vo),
        e("line", {
          x1: "32",
          y1: "136",
          x2: "56",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pVo),
        e("line", {
          x1: "32",
          y1: "168",
          x2: "57.8",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yVo),
        e("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $Vo),
        e("line", {
          x1: "128",
          y1: "136",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wVo),
        e("line", {
          x1: "198.2",
          y1: "168",
          x2: "224",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fVo),
        e("line", {
          x1: "55.9",
          y1: "28",
          x2: "79.7",
          y2: "50.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gVo),
        e("line", {
          x1: "199.9",
          y1: "28",
          x2: "176.2",
          y2: "50.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xVo)
      ])) : o(i) === "thin" ? (s(), r("g", jVo, [
        e("rect", {
          x: "56",
          y: "32",
          width: "144",
          height: "192",
          rx: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mVo),
        e("line", {
          x1: "200",
          y1: "136",
          x2: "224",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MVo),
        e("line", {
          x1: "32",
          y1: "136",
          x2: "56",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vVo),
        e("line", {
          x1: "32",
          y1: "168",
          x2: "57.8",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SVo),
        e("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HVo),
        e("line", {
          x1: "128",
          y1: "136",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, AVo),
        e("line", {
          x1: "198.2",
          y1: "168",
          x2: "224",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VVo),
        e("line", {
          x1: "55.9",
          y1: "28",
          x2: "79.7",
          y2: "50.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zVo),
        e("line", {
          x1: "199.9",
          y1: "28",
          x2: "176.2",
          y2: "50.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZVo)
      ])) : o(i) === "regular" ? (s(), r("g", CVo, [
        e("rect", {
          x: "56",
          y: "32",
          width: "144",
          height: "192",
          rx: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bVo),
        e("line", {
          x1: "200",
          y1: "136",
          x2: "224",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LVo),
        e("line", {
          x1: "32",
          y1: "136",
          x2: "56",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BVo),
        e("line", {
          x1: "32",
          y1: "168",
          x2: "57.8",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PVo),
        e("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WVo),
        e("line", {
          x1: "128",
          y1: "136",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NVo),
        e("line", {
          x1: "198.2",
          y1: "168",
          x2: "224",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FVo),
        e("line", {
          x1: "55.9",
          y1: "28",
          x2: "79.7",
          y2: "50.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TVo),
        e("line", {
          x1: "199.9",
          y1: "28",
          x2: "176.2",
          y2: "50.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DVo)
      ])) : g("", !0)
    ], 16, DAo));
  }
}), UVo = ["width", "height", "fill", "transform"], qVo = { key: 0 }, GVo = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "84",
  r: "16"
}, null, -1), EVo = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "84",
  r: "16"
}, null, -1), OVo = ["stroke"], IVo = ["stroke"], KVo = ["stroke"], XVo = ["stroke"], JVo = { key: 1 }, QVo = /* @__PURE__ */ e("path", {
  d: "M47.9,128h160v20a80,80,0,0,1-160,0Z",
  opacity: "0.2"
}, null, -1), YVo = ["stroke"], ozo = ["stroke"], ezo = /* @__PURE__ */ e("circle", {
  cx: "155.9",
  cy: "92",
  r: "12"
}, null, -1), tzo = /* @__PURE__ */ e("circle", {
  cx: "99.9",
  cy: "92",
  r: "12"
}, null, -1), nzo = ["stroke"], szo = ["stroke"], rzo = { key: 2 }, izo = /* @__PURE__ */ e("path", { d: "M191.3,47l14.1-13.1a8.2,8.2,0,0,0,.4-11.4,8,8,0,0,0-11.3-.4L179.1,36.5a87.7,87.7,0,0,0-102.4,0L61.4,22.1A8,8,0,0,0,50.5,33.9L64.6,47a87.4,87.4,0,0,0-24.7,61v40a88,88,0,0,0,176,0V108A87.7,87.7,0,0,0,191.3,47ZM127.9,36a72.1,72.1,0,0,1,72,72v12H55.9V108A72.1,72.1,0,0,1,127.9,36Zm16,56a12,12,0,1,1,12,12A12,12,0,0,1,143.9,92Zm-56,0a12,12,0,1,1,12,12A12,12,0,0,1,87.9,92Z" }, null, -1), lzo = [
  izo
], dzo = { key: 3 }, kzo = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "84",
  r: "10"
}, null, -1), czo = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "84",
  r: "10"
}, null, -1), hzo = ["stroke"], uzo = ["stroke"], azo = ["stroke"], _zo = ["stroke"], pzo = { key: 4 }, yzo = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "84",
  r: "8"
}, null, -1), $zo = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "84",
  r: "8"
}, null, -1), wzo = ["stroke"], fzo = ["stroke"], gzo = ["stroke"], xzo = ["stroke"], jzo = { key: 5 }, mzo = ["stroke"], Mzo = ["stroke"], vzo = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "92",
  r: "12"
}, null, -1), Szo = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "92",
  r: "12"
}, null, -1), Hzo = ["stroke"], Azo = ["stroke"], Vzo = {
  name: "PhBugDroid"
}, XR1 = /* @__PURE__ */ $({
  ...Vzo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", qVo, [
        GVo,
        EVo,
        e("path", {
          d: "M207.9,148a80,80,0,0,1-160,0V108a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OVo),
        e("line", {
          x1: "207.9",
          y1: "128",
          x2: "47.9",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IVo),
        e("line", {
          x1: "55.9",
          y1: "28",
          x2: "76.2",
          y2: "46.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KVo),
        e("line", {
          x1: "199.9",
          y1: "28",
          x2: "179.6",
          y2: "46.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XVo)
      ])) : o(i) === "duotone" ? (s(), r("g", JVo, [
        QVo,
        e("path", {
          d: "M207.9,148a80,80,0,0,1-160,0V108a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YVo),
        e("line", {
          x1: "207.9",
          y1: "128",
          x2: "47.9",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ozo),
        ezo,
        tzo,
        e("line", {
          x1: "55.9",
          y1: "28",
          x2: "76.2",
          y2: "46.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nzo),
        e("line", {
          x1: "199.9",
          y1: "28",
          x2: "179.6",
          y2: "46.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, szo)
      ])) : o(i) === "fill" ? (s(), r("g", rzo, lzo)) : o(i) === "light" ? (s(), r("g", dzo, [
        kzo,
        czo,
        e("path", {
          d: "M207.9,148a80,80,0,0,1-160,0V108a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hzo),
        e("line", {
          x1: "207.9",
          y1: "128",
          x2: "47.9",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uzo),
        e("line", {
          x1: "55.9",
          y1: "28",
          x2: "76.2",
          y2: "46.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, azo),
        e("line", {
          x1: "199.9",
          y1: "28",
          x2: "179.6",
          y2: "46.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _zo)
      ])) : o(i) === "thin" ? (s(), r("g", pzo, [
        yzo,
        $zo,
        e("path", {
          d: "M207.9,148a80,80,0,0,1-160,0V108a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wzo),
        e("line", {
          x1: "207.9",
          y1: "128",
          x2: "47.9",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fzo),
        e("line", {
          x1: "55.9",
          y1: "28",
          x2: "76.2",
          y2: "46.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gzo),
        e("line", {
          x1: "199.9",
          y1: "28",
          x2: "179.6",
          y2: "46.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xzo)
      ])) : o(i) === "regular" ? (s(), r("g", jzo, [
        e("path", {
          d: "M208,148a80,80,0,0,1-160,0V108a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mzo),
        e("line", {
          x1: "208",
          y1: "128",
          x2: "48",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mzo),
        vzo,
        Szo,
        e("line", {
          x1: "56",
          y1: "28",
          x2: "76.3",
          y2: "46.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hzo),
        e("line", {
          x1: "200",
          y1: "28",
          x2: "179.7",
          y2: "46.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Azo)
      ])) : g("", !0)
    ], 16, UVo));
  }
}), zzo = ["width", "height", "fill", "transform"], Zzo = { key: 0 }, Czo = ["stroke"], bzo = ["stroke"], Lzo = ["stroke"], Bzo = ["stroke"], Pzo = ["stroke"], Wzo = ["stroke"], Nzo = ["stroke"], Fzo = ["stroke"], Tzo = { key: 1 }, Dzo = /* @__PURE__ */ e("path", {
  d: "M144,216V40a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V216",
  opacity: "0.2"
}, null, -1), Rzo = ["stroke"], Uzo = ["stroke"], qzo = ["stroke"], Gzo = ["stroke"], Ezo = ["stroke"], Ozo = ["stroke"], Izo = ["stroke"], Kzo = ["stroke"], Xzo = { key: 2 }, Jzo = /* @__PURE__ */ e("path", { d: "M240,208h-8V104a16,16,0,0,0-16-16H152V40a16,16,0,0,0-16-16H40A16,16,0,0,0,24,40V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM120,136a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h32A8,8,0,0,1,120,136ZM64,64H96a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16Zm0,104H96a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16Zm88-64h64V208H152Z" }, null, -1), Qzo = /* @__PURE__ */ e("path", { d: "M192,168H176a8,8,0,0,0,0,16h16a8,8,0,0,0,0-16Z" }, null, -1), Yzo = /* @__PURE__ */ e("path", { d: "M176,144h16a8,8,0,0,0,0-16H176a8,8,0,0,0,0,16Z" }, null, -1), oZo = [
  Jzo,
  Qzo,
  Yzo
], eZo = { key: 3 }, tZo = ["stroke"], nZo = ["stroke"], sZo = ["stroke"], rZo = ["stroke"], iZo = ["stroke"], lZo = ["stroke"], dZo = ["stroke"], kZo = ["stroke"], cZo = { key: 4 }, hZo = ["stroke"], uZo = ["stroke"], aZo = ["stroke"], _Zo = ["stroke"], pZo = ["stroke"], yZo = ["stroke"], $Zo = ["stroke"], wZo = ["stroke"], fZo = { key: 5 }, gZo = ["stroke"], xZo = ["stroke"], jZo = ["stroke"], mZo = ["stroke"], MZo = ["stroke"], vZo = ["stroke"], SZo = ["stroke"], HZo = ["stroke"], AZo = {
  name: "PhBuildings"
}, JR1 = /* @__PURE__ */ $({
  ...AZo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Zzo, [
        e("line", {
          x1: "16",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Czo),
        e("path", {
          d: "M144,216V40a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bzo),
        e("path", {
          d: "M224,216V104a8,8,0,0,0-8-8H144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lzo),
        e("line", {
          x1: "68",
          y1: "72",
          x2: "96",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bzo),
        e("line", {
          x1: "80",
          y1: "136",
          x2: "108",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pzo),
        e("line", {
          x1: "68",
          y1: "176",
          x2: "96",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wzo),
        e("line", {
          x1: "180",
          y1: "176",
          x2: "188",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nzo),
        e("line", {
          x1: "180",
          y1: "136",
          x2: "188",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fzo)
      ])) : o(i) === "duotone" ? (s(), r("g", Tzo, [
        Dzo,
        e("line", {
          x1: "16",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rzo),
        e("path", {
          d: "M144,216V40a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uzo),
        e("path", {
          d: "M224,216V104a8,8,0,0,0-8-8H144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qzo),
        e("line", {
          x1: "64",
          y1: "72",
          x2: "96",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gzo),
        e("line", {
          x1: "80",
          y1: "136",
          x2: "112",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ezo),
        e("line", {
          x1: "64",
          y1: "176",
          x2: "96",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ozo),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "192",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Izo),
        e("line", {
          x1: "176",
          y1: "136",
          x2: "192",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kzo)
      ])) : o(i) === "fill" ? (s(), r("g", Xzo, oZo)) : o(i) === "light" ? (s(), r("g", eZo, [
        e("line", {
          x1: "16",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tZo),
        e("path", {
          d: "M144,216V40a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nZo),
        e("path", {
          d: "M224,216V104a8,8,0,0,0-8-8H144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sZo),
        e("line", {
          x1: "64",
          y1: "72",
          x2: "96",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rZo),
        e("line", {
          x1: "80",
          y1: "136",
          x2: "112",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iZo),
        e("line", {
          x1: "64",
          y1: "176",
          x2: "96",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lZo),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "192",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dZo),
        e("line", {
          x1: "176",
          y1: "136",
          x2: "192",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kZo)
      ])) : o(i) === "thin" ? (s(), r("g", cZo, [
        e("line", {
          x1: "16",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hZo),
        e("path", {
          d: "M144,216V40a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uZo),
        e("path", {
          d: "M224,216V104a8,8,0,0,0-8-8H144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aZo),
        e("line", {
          x1: "64",
          y1: "72",
          x2: "96",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _Zo),
        e("line", {
          x1: "80",
          y1: "136",
          x2: "112",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pZo),
        e("line", {
          x1: "64",
          y1: "176",
          x2: "96",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yZo),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "192",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $Zo),
        e("line", {
          x1: "176",
          y1: "136",
          x2: "192",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wZo)
      ])) : o(i) === "regular" ? (s(), r("g", fZo, [
        e("line", {
          x1: "16",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gZo),
        e("path", {
          d: "M144,216V40a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xZo),
        e("path", {
          d: "M224,216V104a8,8,0,0,0-8-8H144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jZo),
        e("line", {
          x1: "64",
          y1: "72",
          x2: "96",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mZo),
        e("line", {
          x1: "80",
          y1: "136",
          x2: "112",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MZo),
        e("line", {
          x1: "64",
          y1: "176",
          x2: "96",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vZo),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "192",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SZo),
        e("line", {
          x1: "176",
          y1: "136",
          x2: "192",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HZo)
      ])) : g("", !0)
    ], 16, zzo));
  }
}), VZo = ["width", "height", "fill", "transform"], zZo = { key: 0 }, ZZo = ["stroke"], CZo = ["stroke"], bZo = ["stroke"], LZo = ["stroke"], BZo = ["stroke"], PZo = { key: 1 }, WZo = /* @__PURE__ */ e("path", {
  d: "M214,192v24a8,8,0,0,1-8,8H182a8,8,0,0,1-8-8V192Z",
  opacity: "0.3"
}, null, -1), NZo = /* @__PURE__ */ e("path", {
  d: "M82,192v24a8,8,0,0,1-8,8H50a8,8,0,0,1-8-8V192Z",
  opacity: "0.3"
}, null, -1), FZo = /* @__PURE__ */ e("rect", {
  x: "42",
  y: "72",
  width: "172",
  height: "48",
  opacity: "0.2"
}, null, -1), TZo = ["stroke"], DZo = ["stroke"], RZo = ["stroke"], UZo = ["stroke"], qZo = ["stroke"], GZo = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "156",
  r: "12"
}, null, -1), EZo = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "156",
  r: "12"
}, null, -1), OZo = { key: 2 }, IZo = /* @__PURE__ */ e("path", { d: "M190,32H66A32.1,32.1,0,0,0,34,64V216a16,16,0,0,0,16,16H74a16,16,0,0,0,16-16V200h76v16a16,16,0,0,0,16,16h24a16,16,0,0,0,16-16V64A32.1,32.1,0,0,0,190,32ZM82,168a12,12,0,1,1,12-12A12,12,0,0,1,82,168Zm92,0a12,12,0,1,1,12-12A12,12,0,0,1,174,168Zm32-48H50V72H206Z" }, null, -1), KZo = [
  IZo
], XZo = { key: 3 }, JZo = ["stroke"], QZo = ["stroke"], YZo = ["stroke"], oCo = ["stroke"], eCo = ["stroke"], tCo = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "156",
  r: "10"
}, null, -1), nCo = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "156",
  r: "10"
}, null, -1), sCo = { key: 4 }, rCo = ["stroke"], iCo = ["stroke"], lCo = ["stroke"], dCo = ["stroke"], kCo = ["stroke"], cCo = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "156",
  r: "8"
}, null, -1), hCo = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "156",
  r: "8"
}, null, -1), uCo = { key: 5 }, aCo = ["stroke"], _Co = ["stroke"], pCo = ["stroke"], yCo = ["stroke"], $Co = ["stroke"], wCo = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "156",
  r: "12"
}, null, -1), fCo = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "156",
  r: "12"
}, null, -1), gCo = {
  name: "PhBus"
}, QR1 = /* @__PURE__ */ $({
  ...gCo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", zZo, [
        e("line", {
          x1: "42",
          y1: "80",
          x2: "214",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZZo),
        e("line", {
          x1: "42",
          y1: "132",
          x2: "214",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CZo),
        e("path", {
          d: "M214,184H42V64A23.9,23.9,0,0,1,66,40H190a23.9,23.9,0,0,1,24,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bZo),
        e("path", {
          d: "M214,184v32a8,8,0,0,1-8,8H182a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LZo),
        e("path", {
          d: "M82,184v32a8,8,0,0,1-8,8H50a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BZo)
      ])) : o(i) === "duotone" ? (s(), r("g", PZo, [
        WZo,
        NZo,
        FZo,
        e("line", {
          x1: "42",
          y1: "72",
          x2: "214",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TZo),
        e("line", {
          x1: "42",
          y1: "120",
          x2: "214",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DZo),
        e("path", {
          d: "M214,192H42V64A23.9,23.9,0,0,1,66,40H190a23.9,23.9,0,0,1,24,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RZo),
        e("path", {
          d: "M214,192v24a8,8,0,0,1-8,8H182a8,8,0,0,1-8-8V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UZo),
        e("path", {
          d: "M82,192v24a8,8,0,0,1-8,8H50a8,8,0,0,1-8-8V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qZo),
        GZo,
        EZo
      ])) : o(i) === "fill" ? (s(), r("g", OZo, KZo)) : o(i) === "light" ? (s(), r("g", XZo, [
        e("line", {
          x1: "42",
          y1: "72",
          x2: "214",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JZo),
        e("line", {
          x1: "42",
          y1: "120",
          x2: "214",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QZo),
        e("path", {
          d: "M214,192H42V64A23.9,23.9,0,0,1,66,40H190a23.9,23.9,0,0,1,24,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YZo),
        e("path", {
          d: "M214,192v24a8,8,0,0,1-8,8H182a8,8,0,0,1-8-8V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oCo),
        e("path", {
          d: "M82,192v24a8,8,0,0,1-8,8H50a8,8,0,0,1-8-8V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eCo),
        tCo,
        nCo
      ])) : o(i) === "thin" ? (s(), r("g", sCo, [
        e("line", {
          x1: "42",
          y1: "72",
          x2: "214",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rCo),
        e("line", {
          x1: "42",
          y1: "120",
          x2: "214",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iCo),
        e("path", {
          d: "M214,192H42V64A23.9,23.9,0,0,1,66,40H190a23.9,23.9,0,0,1,24,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lCo),
        e("path", {
          d: "M214,192v24a8,8,0,0,1-8,8H182a8,8,0,0,1-8-8V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dCo),
        e("path", {
          d: "M82,192v24a8,8,0,0,1-8,8H50a8,8,0,0,1-8-8V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kCo),
        cCo,
        hCo
      ])) : o(i) === "regular" ? (s(), r("g", uCo, [
        e("line", {
          x1: "42",
          y1: "72",
          x2: "214",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aCo),
        e("line", {
          x1: "42",
          y1: "120",
          x2: "214",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Co),
        e("path", {
          d: "M214,192H42V64A23.9,23.9,0,0,1,66,40H190a23.9,23.9,0,0,1,24,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pCo),
        e("path", {
          d: "M214,192v24a8,8,0,0,1-8,8H182a8,8,0,0,1-8-8V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yCo),
        e("path", {
          d: "M82,192v24a8,8,0,0,1-8,8H50a8,8,0,0,1-8-8V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Co),
        wCo,
        fCo
      ])) : g("", !0)
    ], 16, VZo));
  }
}), xCo = ["width", "height", "fill", "transform"], jCo = { key: 0 }, mCo = ["stroke"], MCo = ["stroke"], vCo = ["stroke"], SCo = { key: 1 }, HCo = /* @__PURE__ */ e("path", {
  d: "M224,120c-7.8,31.1-29,32.8-36.9,32.4h0A36,36,0,1,1,128,180a36,36,0,1,1-59.1-27.6h0c-7.9.4-29.1-1.3-36.9-32.4S17.1,48,48,48s80,48,80,80c0-32,49.1-80,80-80S232,88,224,120Z",
  opacity: "0.2"
}, null, -1), ACo = ["stroke"], VCo = ["stroke"], zCo = ["stroke"], ZCo = { key: 2 }, CCo = /* @__PURE__ */ e("path", { d: "M136,87.5V56a8,8,0,0,0-16,0V87.5a98.7,98.7,0,0,1,8,12.7A98.7,98.7,0,0,1,136,87.5Z" }, null, -1), bCo = /* @__PURE__ */ e("path", { d: "M231.4,50.4C227.7,45.6,220.7,40,208,40c-16.7,0-38.1,11.3-57.2,30.3A144.2,144.2,0,0,0,136,87.5V172a8,8,0,0,1-16,0V87.5a144.2,144.2,0,0,0-14.8-17.2C86.1,51.3,64.7,40,48,40c-12.7,0-19.7,5.6-23.4,10.4-6.8,8.7-12.2,24.1-.4,71.5,6.6,26.3,22,34.9,33.5,37.5a40,40,0,1,0,70.3,38,40,40,0,1,0,70.3-38c11.5-2.6,26.9-11.2,33.5-37.5S243.6,66,231.4,50.4Z" }, null, -1), LCo = [
  CCo,
  bCo
], BCo = { key: 3 }, PCo = ["stroke"], WCo = ["stroke"], NCo = ["stroke"], FCo = { key: 4 }, TCo = ["stroke"], DCo = ["stroke"], RCo = ["stroke"], UCo = { key: 5 }, qCo = ["stroke"], GCo = ["stroke"], ECo = ["stroke"], OCo = {
  name: "PhButterfly"
}, YR1 = /* @__PURE__ */ $({
  ...OCo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", jCo, [
        e("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mCo),
        e("path", {
          d: "M187.1,152.4c7.9.4,29.1-1.3,36.9-32.4s14.9-72-16-72-80,48-80,80c0-32-49.1-80-80-80S24,88,32,120s29,32.8,36.9,32.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MCo),
        e("path", {
          d: "M88,144.2A36,36,0,1,0,128,180a36,36,0,1,0,40-35.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vCo)
      ])) : o(i) === "duotone" ? (s(), r("g", SCo, [
        HCo,
        e("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ACo),
        e("path", {
          d: "M187.1,152.4c7.9.4,29.1-1.3,36.9-32.4s14.9-72-16-72-80,48-80,80c0-32-49.1-80-80-80S24,88,32,120s29,32.8,36.9,32.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VCo),
        e("path", {
          d: "M88,144.2A36,36,0,1,0,128,180a36,36,0,1,0,40-35.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zCo)
      ])) : o(i) === "fill" ? (s(), r("g", ZCo, LCo)) : o(i) === "light" ? (s(), r("g", BCo, [
        e("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PCo),
        e("path", {
          d: "M187.1,152.4c7.9.4,29.1-1.3,36.9-32.4s14.9-72-16-72-80,48-80,80c0-32-49.1-80-80-80S24,88,32,120s29,32.8,36.9,32.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WCo),
        e("path", {
          d: "M88,144.2A36,36,0,1,0,128,180a36,36,0,1,0,40-35.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, NCo)
      ])) : o(i) === "thin" ? (s(), r("g", FCo, [
        e("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, TCo),
        e("path", {
          d: "M187.1,152.4c7.9.4,29.1-1.3,36.9-32.4s14.9-72-16-72-80,48-80,80c0-32-49.1-80-80-80S24,88,32,120s29,32.8,36.9,32.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, DCo),
        e("path", {
          d: "M88,144.2A36,36,0,1,0,128,180a36,36,0,1,0,40-35.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RCo)
      ])) : o(i) === "regular" ? (s(), r("g", UCo, [
        e("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qCo),
        e("path", {
          d: "M187.1,152.4c7.9.4,29.1-1.3,36.9-32.4s14.9-72-16-72-80,48-80,80c0-32-49.1-80-80-80S24,88,32,120s29,32.8,36.9,32.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GCo),
        e("path", {
          d: "M88,144.2A36,36,0,1,0,128,180a36,36,0,1,0,40-35.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ECo)
      ])) : g("", !0)
    ], 16, xCo));
  }
}), ICo = ["width", "height", "fill", "transform"], KCo = { key: 0 }, XCo = ["stroke"], JCo = ["stroke"], QCo = { key: 1 }, YCo = /* @__PURE__ */ e("path", {
  d: "M96,216V132H84A60,60,0,0,1,24,72h0A20.1,20.1,0,0,1,44,52h0A20.1,20.1,0,0,1,64,72h0A20.1,20.1,0,0,0,84,92H96V56a32,32,0,0,1,32-32h0a32,32,0,0,1,32,32v76h12a20.1,20.1,0,0,0,20-20h0a20.1,20.1,0,0,1,20-20h0a20.1,20.1,0,0,1,20,20h0a60,60,0,0,1-60,60H160v44Z",
  opacity: "0.2"
}, null, -1), obo = ["stroke"], ebo = ["stroke"], tbo = { key: 2 }, nbo = /* @__PURE__ */ e("path", { d: "M224,216a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H88V140H84A68.1,68.1,0,0,1,16,72a28,28,0,0,1,56,0A12,12,0,0,0,84,84h4V56a40,40,0,0,1,80,0v68h4a12,12,0,0,0,12-12,28,28,0,0,1,56,0,68.1,68.1,0,0,1-68,68h-4v28h48A8,8,0,0,1,224,216Z" }, null, -1), sbo = [
  nbo
], rbo = { key: 3 }, ibo = ["stroke"], lbo = ["stroke"], dbo = { key: 4 }, kbo = ["stroke"], cbo = ["stroke"], hbo = { key: 5 }, ubo = ["stroke"], abo = ["stroke"], _bo = {
  name: "PhCactus"
}, oU1 = /* @__PURE__ */ $({
  ..._bo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", KCo, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XCo),
        e("path", {
          d: "M96,216V132H84A60,60,0,0,1,24,72h0A20.1,20.1,0,0,1,44,52h0A20.1,20.1,0,0,1,64,72h0A20.1,20.1,0,0,0,84,92H96V56a32,32,0,0,1,32-32h0a32,32,0,0,1,32,32v76h12a20.1,20.1,0,0,0,20-20h0a20.1,20.1,0,0,1,20-20h0a20.1,20.1,0,0,1,20,20h0a60,60,0,0,1-60,60H160v44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, JCo)
      ])) : o(i) === "duotone" ? (s(), r("g", QCo, [
        YCo,
        e("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, obo),
        e("path", {
          d: "M96,216V132H84A60,60,0,0,1,24,72h0A20.1,20.1,0,0,1,44,52h0A20.1,20.1,0,0,1,64,72h0A20.1,20.1,0,0,0,84,92H96V56a32,32,0,0,1,32-32h0a32,32,0,0,1,32,32v76h12a20.1,20.1,0,0,0,20-20h0a20.1,20.1,0,0,1,20-20h0a20.1,20.1,0,0,1,20,20h0a60,60,0,0,1-60,60H160v44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ebo)
      ])) : o(i) === "fill" ? (s(), r("g", tbo, sbo)) : o(i) === "light" ? (s(), r("g", rbo, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ibo),
        e("path", {
          d: "M96,216V132H84A60,60,0,0,1,24,72h0A20.1,20.1,0,0,1,44,52h0A20.1,20.1,0,0,1,64,72h0A20.1,20.1,0,0,0,84,92H96V56a32,32,0,0,1,32-32h0a32,32,0,0,1,32,32v76h12a20.1,20.1,0,0,0,20-20h0a20.1,20.1,0,0,1,20-20h0a20.1,20.1,0,0,1,20,20h0a60,60,0,0,1-60,60H160v44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lbo)
      ])) : o(i) === "thin" ? (s(), r("g", dbo, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kbo),
        e("path", {
          d: "M96,216V132H84A60,60,0,0,1,24,72h0A20.1,20.1,0,0,1,44,52h0A20.1,20.1,0,0,1,64,72h0A20.1,20.1,0,0,0,84,92H96V56a32,32,0,0,1,32-32h0a32,32,0,0,1,32,32v76h12a20.1,20.1,0,0,0,20-20h0a20.1,20.1,0,0,1,20-20h0a20.1,20.1,0,0,1,20,20h0a60,60,0,0,1-60,60H160v44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cbo)
      ])) : o(i) === "regular" ? (s(), r("g", hbo, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ubo),
        e("path", {
          d: "M96,216V132H84A60,60,0,0,1,24,72h0A20.1,20.1,0,0,1,44,52h0A20.1,20.1,0,0,1,64,72h0A20.1,20.1,0,0,0,84,92H96V56a32,32,0,0,1,32-32h0a32,32,0,0,1,32,32v76h12a20.1,20.1,0,0,0,20-20h0a20.1,20.1,0,0,1,20-20h0a20.1,20.1,0,0,1,20,20h0a60,60,0,0,1-60,60H160v44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, abo)
      ])) : g("", !0)
    ], 16, ICo));
  }
}), pbo = ["width", "height", "fill", "transform"], ybo = { key: 0 }, $bo = ["stroke"], wbo = ["stroke"], fbo = ["stroke"], gbo = ["stroke"], xbo = { key: 1 }, jbo = /* @__PURE__ */ e("path", {
  d: "M162,126a34,34,0,0,1-68,0,34,34,0,0,1-33.3,34c-19.1.4-34.7-15.6-34.7-34.7V112A23.9,23.9,0,0,1,50,88H206a23.9,23.9,0,0,1,24,24v13.3c0,19.1-15.6,35.1-34.7,34.7A34,34,0,0,1,162,126Z",
  opacity: "0.2"
}, null, -1), mbo = /* @__PURE__ */ e("path", {
  d: "M128,64c46.2-16,0-56,0-56S80,48,128,64Z",
  opacity: "0.2"
}, null, -1), Mbo = ["stroke"], vbo = ["stroke"], Sbo = ["stroke"], Hbo = ["stroke"], Abo = ["stroke"], Vbo = { key: 2 }, zbo = /* @__PURE__ */ e("path", { d: "M206,80H136V69.4c11.5-5.1,18.2-12.5,20.1-22C160.2,26,136,4.3,133.2,2a7.8,7.8,0,0,0-10.3-.1C120,4.2,95.1,25.7,99.1,47.2c1.8,9.7,8.9,17.2,20.9,22.3V80H50a32.1,32.1,0,0,0-32,32v13.3A43.3,43.3,0,0,0,30.9,156l1.1,1v51a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V157l1.1-1A43.3,43.3,0,0,0,238,125.3V112A32.1,32.1,0,0,0,206,80Zm2,128H48V166.2A39.3,39.3,0,0,0,60.8,168,42.2,42.2,0,0,0,94,150.6a41.9,41.9,0,0,0,68,0A42.2,42.2,0,0,0,195.2,168h.8a40.6,40.6,0,0,0,12-1.8Z" }, null, -1), Zbo = [
  zbo
], Cbo = { key: 3 }, bbo = ["stroke"], Lbo = ["stroke"], Bbo = ["stroke"], Pbo = ["stroke"], Wbo = ["stroke"], Nbo = { key: 4 }, Fbo = ["stroke"], Tbo = ["stroke"], Dbo = ["stroke"], Rbo = ["stroke"], Ubo = ["stroke"], qbo = { key: 5 }, Gbo = ["stroke"], Ebo = ["stroke"], Obo = ["stroke"], Ibo = ["stroke"], Kbo = ["stroke"], Xbo = {
  name: "PhCake"
}, eU1 = /* @__PURE__ */ $({
  ...Xbo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ybo, [
        e("path", {
          d: "M128,88c56-24,0-76,0-76S72,64,128,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $bo),
        e("path", {
          d: "M162,126a34,34,0,0,1-68,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wbo),
        e("path", {
          d: "M94,126a34,34,0,0,1-33.3,34c-19.1.4-34.7-15.6-34.7-34.7V112A23.9,23.9,0,0,1,50,88H206a23.9,23.9,0,0,1,24,24v13.3c0,19.1-15.6,35.1-34.7,34.7A34,34,0,0,1,162,126",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fbo),
        e("path", {
          d: "M216,153.3V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V153.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gbo)
      ])) : o(i) === "duotone" ? (s(), r("g", xbo, [
        jbo,
        mbo,
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mbo),
        e("path", {
          d: "M128,64c46.2-16,0-56,0-56S80,48,128,64Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vbo),
        e("path", {
          d: "M162,126a34,34,0,0,1-68,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sbo),
        e("path", {
          d: "M94,126a34,34,0,0,1-33.3,34c-19.1.4-34.7-15.6-34.7-34.7V112A23.9,23.9,0,0,1,50,88H206a23.9,23.9,0,0,1,24,24v13.3c0,19.1-15.6,35.1-34.7,34.7A34,34,0,0,1,162,126",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hbo),
        e("path", {
          d: "M216,153.3V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V153.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Abo)
      ])) : o(i) === "fill" ? (s(), r("g", Vbo, Zbo)) : o(i) === "light" ? (s(), r("g", Cbo, [
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bbo),
        e("path", {
          d: "M128,64c46.2-16,0-56,0-56S80,48,128,64Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lbo),
        e("path", {
          d: "M162,126a34,34,0,0,1-68,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bbo),
        e("path", {
          d: "M94,126a34,34,0,0,1-33.3,34c-19.1.4-34.7-15.6-34.7-34.7V112A23.9,23.9,0,0,1,50,88H206a23.9,23.9,0,0,1,24,24v13.3c0,19.1-15.6,35.1-34.7,34.7A34,34,0,0,1,162,126",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pbo),
        e("path", {
          d: "M216,153.3V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V153.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wbo)
      ])) : o(i) === "thin" ? (s(), r("g", Nbo, [
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fbo),
        e("path", {
          d: "M128,64c46.2-16,0-56,0-56S80,48,128,64Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Tbo),
        e("path", {
          d: "M162,126a34,34,0,0,1-68,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Dbo),
        e("path", {
          d: "M94,126a34,34,0,0,1-33.3,34c-19.1.4-34.7-15.6-34.7-34.7V112A23.9,23.9,0,0,1,50,88H206a23.9,23.9,0,0,1,24,24v13.3c0,19.1-15.6,35.1-34.7,34.7A34,34,0,0,1,162,126",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Rbo),
        e("path", {
          d: "M216,153.3V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V153.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ubo)
      ])) : o(i) === "regular" ? (s(), r("g", qbo, [
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gbo),
        e("path", {
          d: "M128,64c46.2-16,0-56,0-56S80,48,128,64Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ebo),
        e("path", {
          d: "M162,126a34,34,0,0,1-68,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Obo),
        e("path", {
          d: "M94,126a34,34,0,0,1-33.3,34c-19.1.4-34.7-15.6-34.7-34.7V112A23.9,23.9,0,0,1,50,88H206a23.9,23.9,0,0,1,24,24v13.3c0,19.1-15.6,35.1-34.7,34.7A34,34,0,0,1,162,126",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ibo),
        e("path", {
          d: "M216,153.3V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V153.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kbo)
      ])) : g("", !0)
    ], 16, pbo));
  }
}), Jbo = ["width", "height", "fill", "transform"], Qbo = { key: 0 }, Ybo = ["stroke"], oLo = ["stroke"], eLo = /* @__PURE__ */ e("circle", {
  cx: "104",
  cy: "128",
  r: "16"
}, null, -1), tLo = /* @__PURE__ */ e("circle", {
  cx: "152",
  cy: "128",
  r: "16"
}, null, -1), nLo = /* @__PURE__ */ e("circle", {
  cx: "104",
  cy: "176",
  r: "16"
}, null, -1), sLo = /* @__PURE__ */ e("circle", {
  cx: "152",
  cy: "176",
  r: "16"
}, null, -1), rLo = { key: 1 }, iLo = /* @__PURE__ */ e("rect", {
  x: "80",
  y: "64",
  width: "96",
  height: "48",
  opacity: "0.2"
}, null, -1), lLo = ["stroke"], dLo = ["stroke"], kLo = /* @__PURE__ */ j('<circle cx="88" cy="148" r="12"></circle><circle cx="128" cy="148" r="12"></circle><circle cx="168" cy="148" r="12"></circle><circle cx="88" cy="188" r="12"></circle><circle cx="128" cy="188" r="12"></circle><circle cx="168" cy="188" r="12"></circle>', 6), cLo = { key: 2 }, hLo = /* @__PURE__ */ e("path", { d: "M200,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24ZM88,200a12,12,0,1,1,12-12A12,12,0,0,1,88,200Zm0-40a12,12,0,1,1,12-12A12,12,0,0,1,88,160Zm40,40a12,12,0,1,1,12-12A12,12,0,0,1,128,200Zm0-40a12,12,0,1,1,12-12A12,12,0,0,1,128,160Zm40,40a12,12,0,1,1,12-12A12,12,0,0,1,168,200Zm0-40a12,12,0,1,1,12-12A12,12,0,0,1,168,160Zm16-56a8,8,0,0,1-8,8H80a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8Z" }, null, -1), uLo = [
  hLo
], aLo = { key: 3 }, _Lo = ["stroke"], pLo = ["stroke"], yLo = /* @__PURE__ */ j('<circle cx="88" cy="148" r="10"></circle><circle cx="128" cy="148" r="10"></circle><circle cx="168" cy="148" r="10"></circle><circle cx="88" cy="188" r="10"></circle><circle cx="128" cy="188" r="10"></circle><circle cx="168" cy="188" r="10"></circle>', 6), $Lo = { key: 4 }, wLo = ["stroke"], fLo = ["stroke"], gLo = /* @__PURE__ */ j('<circle cx="88" cy="148" r="8"></circle><circle cx="128" cy="148" r="8"></circle><circle cx="168" cy="148" r="8"></circle><circle cx="88" cy="188" r="8"></circle><circle cx="128" cy="188" r="8"></circle><circle cx="168" cy="188" r="8"></circle>', 6), xLo = { key: 5 }, jLo = ["stroke"], mLo = ["stroke"], MLo = /* @__PURE__ */ j('<circle cx="88" cy="148" r="12"></circle><circle cx="128" cy="148" r="12"></circle><circle cx="168" cy="148" r="12"></circle><circle cx="88" cy="188" r="12"></circle><circle cx="128" cy="188" r="12"></circle><circle cx="168" cy="188" r="12"></circle>', 6), vLo = {
  name: "PhCalculator"
}, tU1 = /* @__PURE__ */ $({
  ...vLo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Qbo, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ybo),
        e("line", {
          x1: "92",
          y1: "76",
          x2: "164",
          y2: "76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oLo),
        eLo,
        tLo,
        nLo,
        sLo
      ])) : o(i) === "duotone" ? (s(), r("g", rLo, [
        iLo,
        e("rect", {
          x: "80",
          y: "64",
          width: "96",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lLo),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dLo),
        kLo
      ])) : o(i) === "fill" ? (s(), r("g", cLo, uLo)) : o(i) === "light" ? (s(), r("g", aLo, [
        e("rect", {
          x: "80",
          y: "64",
          width: "96",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _Lo),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pLo),
        yLo
      ])) : o(i) === "thin" ? (s(), r("g", $Lo, [
        e("rect", {
          x: "80",
          y: "64",
          width: "96",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wLo),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fLo),
        gLo
      ])) : o(i) === "regular" ? (s(), r("g", xLo, [
        e("rect", {
          x: "80",
          y: "64",
          width: "96",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jLo),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mLo),
        MLo
      ])) : g("", !0)
    ], 16, Jbo));
  }
}), SLo = ["width", "height", "fill", "transform"], HLo = { key: 0 }, ALo = ["stroke"], VLo = ["stroke"], zLo = ["stroke"], ZLo = ["stroke"], CLo = ["stroke"], bLo = ["stroke"], LLo = { key: 1 }, BLo = /* @__PURE__ */ e("path", {
  d: "M40,88H216V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8Z",
  opacity: "0.2"
}, null, -1), PLo = ["stroke"], WLo = ["stroke"], NLo = ["stroke"], FLo = ["stroke"], TLo = ["stroke"], DLo = ["stroke"], RLo = { key: 2 }, ULo = /* @__PURE__ */ e("path", { d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM104,188a24.2,24.2,0,0,1-17-7,8,8,0,0,1,0-11.3,7.9,7.9,0,0,1,11.3,0A8.3,8.3,0,0,0,104,172a8,8,0,0,0,0-16h-2.5l-.4-.2h-.3l-.5-.2h-.1l-.6-.4h-.2l-.4-.3h0l-.4-.3-.2-.2-.3-.3a8.6,8.6,0,0,1-1.3-2,5.8,5.8,0,0,1-.6-1.7h0c-.1-.1-.1-.2-.1-.4a.4.4,0,0,0-.1-.3V148h0v-.7c0-.2.1-.3.1-.4v-.4a.6.6,0,0,0,.1-.4c.1-.1.1-.2.1-.4l.2-.3c0-.2,0-.3.1-.4l.2-.4v-.3l.2-.4.2-.3.3-.4.2-.2,5.6-7H92a8,8,0,0,1,0-16h28a8,8,0,0,1,6.2,13l-8.8,11.1A24,24,0,0,1,104,188Zm64-8a8,8,0,0,1-16,0V144l-3.2,2.4a8.1,8.1,0,0,1-11.2-1.6,8,8,0,0,1,1.6-11.2l16-12A8,8,0,0,1,168,128ZM208,80H48V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24Z" }, null, -1), qLo = [
  ULo
], GLo = { key: 3 }, ELo = ["stroke"], OLo = ["stroke"], ILo = ["stroke"], KLo = ["stroke"], XLo = ["stroke"], JLo = ["stroke"], QLo = { key: 4 }, YLo = ["stroke"], oBo = ["stroke"], eBo = ["stroke"], tBo = ["stroke"], nBo = ["stroke"], sBo = ["stroke"], rBo = { key: 5 }, iBo = ["stroke"], lBo = ["stroke"], dBo = ["stroke"], kBo = ["stroke"], cBo = ["stroke"], hBo = ["stroke"], uBo = {
  name: "PhCalendar"
}, nU1 = /* @__PURE__ */ $({
  ...uBo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", HLo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ALo),
        e("line", {
          x1: "176",
          y1: "20",
          x2: "176",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VLo),
        e("line", {
          x1: "80",
          y1: "20",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zLo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZLo),
        e("path", {
          d: "M88,128h28l-16,20a16,16,0,1,1-11.3,27.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CLo),
        e("polyline", {
          points: "148 140 164 128 164 180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bLo)
      ])) : o(i) === "duotone" ? (s(), r("g", LLo, [
        BLo,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PLo),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WLo),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NLo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FLo),
        e("path", {
          d: "M92,128h28l-16,20a16,16,0,1,1-11.3,27.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TLo),
        e("polyline", {
          points: "144 140 160 128 160 180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DLo)
      ])) : o(i) === "fill" ? (s(), r("g", RLo, qLo)) : o(i) === "light" ? (s(), r("g", GLo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ELo),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OLo),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ILo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KLo),
        e("path", {
          d: "M92,128h28l-16,20a16,16,0,1,1-11.3,27.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XLo),
        e("polyline", {
          points: "144 140 160 128 160 180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JLo)
      ])) : o(i) === "thin" ? (s(), r("g", QLo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YLo),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oBo),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eBo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tBo),
        e("path", {
          d: "M92,128h28l-16,20a16,16,0,1,1-11.3,27.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nBo),
        e("polyline", {
          points: "144 140 160 128 160 180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sBo)
      ])) : o(i) === "regular" ? (s(), r("g", rBo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iBo),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lBo),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dBo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kBo),
        e("path", {
          d: "M92,128h28l-16,20a16,16,0,1,1-11.3,27.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cBo),
        e("polyline", {
          points: "144 140 160 128 160 180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hBo)
      ])) : g("", !0)
    ], 16, SLo));
  }
}), aBo = ["width", "height", "fill", "transform"], _Bo = { key: 0 }, pBo = ["stroke"], yBo = ["stroke"], $Bo = ["stroke"], wBo = ["stroke"], fBo = { key: 1 }, gBo = /* @__PURE__ */ e("path", {
  d: "M40,88H216V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8Z",
  opacity: "0.2"
}, null, -1), xBo = ["stroke"], jBo = ["stroke"], mBo = ["stroke"], MBo = ["stroke"], vBo = { key: 2 }, SBo = /* @__PURE__ */ e("path", { d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,48H48V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24Z" }, null, -1), HBo = [
  SBo
], ABo = { key: 3 }, VBo = ["stroke"], zBo = ["stroke"], ZBo = ["stroke"], CBo = ["stroke"], bBo = { key: 4 }, LBo = ["stroke"], BBo = ["stroke"], PBo = ["stroke"], WBo = ["stroke"], NBo = { key: 5 }, FBo = ["stroke"], TBo = ["stroke"], DBo = ["stroke"], RBo = ["stroke"], UBo = {
  name: "PhCalendarBlank"
}, sU1 = /* @__PURE__ */ $({
  ...UBo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", _Bo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pBo),
        e("line", {
          x1: "176",
          y1: "20",
          x2: "176",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yBo),
        e("line", {
          x1: "80",
          y1: "20",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $Bo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wBo)
      ])) : o(i) === "duotone" ? (s(), r("g", fBo, [
        gBo,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xBo),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jBo),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mBo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MBo)
      ])) : o(i) === "fill" ? (s(), r("g", vBo, HBo)) : o(i) === "light" ? (s(), r("g", ABo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VBo),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zBo),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZBo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, CBo)
      ])) : o(i) === "thin" ? (s(), r("g", bBo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LBo),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, BBo),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PBo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WBo)
      ])) : o(i) === "regular" ? (s(), r("g", NBo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FBo),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TBo),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DBo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RBo)
      ])) : g("", !0)
    ], 16, aBo));
  }
}), qBo = ["width", "height", "fill", "transform"], GBo = { key: 0 }, EBo = ["stroke"], OBo = ["stroke"], IBo = ["stroke"], KBo = ["stroke"], XBo = ["stroke"], JBo = { key: 1 }, QBo = /* @__PURE__ */ e("path", {
  d: "M40,88H216V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8Z",
  opacity: "0.2"
}, null, -1), YBo = ["stroke"], oPo = ["stroke"], ePo = ["stroke"], tPo = ["stroke"], nPo = ["stroke"], sPo = { key: 2 }, rPo = /* @__PURE__ */ e("path", { d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM169.5,133.8l-46.7,44a7.7,7.7,0,0,1-5.5,2.2,7.9,7.9,0,0,1-5.5-2.2l-25.3-24a8,8,0,1,1,11-11.6L117.3,161l41.2-38.8a7.9,7.9,0,0,1,11.3.3A8,8,0,0,1,169.5,133.8ZM208,80H48V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24Z" }, null, -1), iPo = [
  rPo
], lPo = { key: 3 }, dPo = ["stroke"], kPo = ["stroke"], cPo = ["stroke"], hPo = ["stroke"], uPo = ["stroke"], aPo = { key: 4 }, _Po = ["stroke"], pPo = ["stroke"], yPo = ["stroke"], $Po = ["stroke"], wPo = ["stroke"], fPo = { key: 5 }, gPo = ["stroke"], xPo = ["stroke"], jPo = ["stroke"], mPo = ["stroke"], MPo = ["stroke"], vPo = {
  name: "PhCalendarCheck"
}, rU1 = /* @__PURE__ */ $({
  ...vPo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", GBo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, EBo),
        e("line", {
          x1: "176",
          y1: "20",
          x2: "176",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OBo),
        e("line", {
          x1: "80",
          y1: "20",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IBo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KBo),
        e("polyline", {
          points: "164 128 117.3 172 92 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XBo)
      ])) : o(i) === "duotone" ? (s(), r("g", JBo, [
        QBo,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YBo),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oPo),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ePo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tPo),
        e("polyline", {
          points: "164 128 117.3 172 92 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nPo)
      ])) : o(i) === "fill" ? (s(), r("g", sPo, iPo)) : o(i) === "light" ? (s(), r("g", lPo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dPo),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kPo),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cPo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hPo),
        e("polyline", {
          points: "164 128 117.3 172 92 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uPo)
      ])) : o(i) === "thin" ? (s(), r("g", aPo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _Po),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pPo),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yPo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $Po),
        e("polyline", {
          points: "164 128 117.3 172 92 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wPo)
      ])) : o(i) === "regular" ? (s(), r("g", fPo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gPo),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xPo),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jPo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mPo),
        e("polyline", {
          points: "164 128 117.3 172 92 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MPo)
      ])) : g("", !0)
    ], 16, qBo));
  }
}), SPo = ["width", "height", "fill", "transform"], HPo = { key: 0 }, APo = ["stroke"], VPo = ["stroke"], zPo = ["stroke"], ZPo = ["stroke"], CPo = ["stroke"], bPo = ["stroke"], LPo = { key: 1 }, BPo = /* @__PURE__ */ e("path", {
  d: "M40,88H216V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8Z",
  opacity: "0.2"
}, null, -1), PPo = ["stroke"], WPo = ["stroke"], NPo = ["stroke"], FPo = ["stroke"], TPo = ["stroke"], DPo = ["stroke"], RPo = { key: 2 }, UPo = /* @__PURE__ */ e("path", { d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM156,160H136v20a8,8,0,0,1-16,0V160H100a8,8,0,0,1,0-16h20V124a8,8,0,0,1,16,0v20h20a8,8,0,0,1,0,16Zm52-80H48V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24Z" }, null, -1), qPo = [
  UPo
], GPo = { key: 3 }, EPo = ["stroke"], OPo = ["stroke"], IPo = ["stroke"], KPo = ["stroke"], XPo = ["stroke"], JPo = ["stroke"], QPo = { key: 4 }, YPo = ["stroke"], oWo = ["stroke"], eWo = ["stroke"], tWo = ["stroke"], nWo = ["stroke"], sWo = ["stroke"], rWo = { key: 5 }, iWo = ["stroke"], lWo = ["stroke"], dWo = ["stroke"], kWo = ["stroke"], cWo = ["stroke"], hWo = ["stroke"], uWo = {
  name: "PhCalendarPlus"
}, iU1 = /* @__PURE__ */ $({
  ...uWo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", HPo, [
        e("line", {
          x1: "156",
          y1: "152",
          x2: "100",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, APo),
        e("line", {
          x1: "128",
          y1: "124",
          x2: "128",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VPo),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zPo),
        e("line", {
          x1: "176",
          y1: "20",
          x2: "176",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZPo),
        e("line", {
          x1: "80",
          y1: "20",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CPo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bPo)
      ])) : o(i) === "duotone" ? (s(), r("g", LPo, [
        BPo,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PPo),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WPo),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NPo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FPo),
        e("line", {
          x1: "156",
          y1: "152",
          x2: "100",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TPo),
        e("line", {
          x1: "128",
          y1: "124",
          x2: "128",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DPo)
      ])) : o(i) === "fill" ? (s(), r("g", RPo, qPo)) : o(i) === "light" ? (s(), r("g", GPo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, EPo),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OPo),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IPo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KPo),
        e("line", {
          x1: "156",
          y1: "152",
          x2: "100",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XPo),
        e("line", {
          x1: "128",
          y1: "124",
          x2: "128",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JPo)
      ])) : o(i) === "thin" ? (s(), r("g", QPo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YPo),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oWo),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eWo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tWo),
        e("line", {
          x1: "156",
          y1: "152",
          x2: "100",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nWo),
        e("line", {
          x1: "128",
          y1: "124",
          x2: "128",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sWo)
      ])) : o(i) === "regular" ? (s(), r("g", rWo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iWo),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lWo),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dWo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kWo),
        e("line", {
          x1: "156",
          y1: "152",
          x2: "100",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cWo),
        e("line", {
          x1: "128",
          y1: "124",
          x2: "128",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hWo)
      ])) : g("", !0)
    ], 16, SPo));
  }
}), aWo = ["width", "height", "fill", "transform"], _Wo = { key: 0 }, pWo = ["stroke"], yWo = ["stroke"], $Wo = ["stroke"], wWo = ["stroke"], fWo = ["stroke"], gWo = ["stroke"], xWo = { key: 1 }, jWo = /* @__PURE__ */ e("path", {
  d: "M40,88H216V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8Z",
  opacity: "0.2"
}, null, -1), mWo = ["stroke"], MWo = ["stroke"], vWo = ["stroke"], SWo = ["stroke"], HWo = ["stroke"], AWo = ["stroke"], VWo = { key: 2 }, zWo = /* @__PURE__ */ e("path", { d: "M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM157.7,170.3a8.1,8.1,0,0,1,0,11.4A8.5,8.5,0,0,1,152,184a8.3,8.3,0,0,1-5.7-2.3L128,163.3l-18.3,18.4A8.5,8.5,0,0,1,104,184a8.3,8.3,0,0,1-5.7-2.3,8.1,8.1,0,0,1,0-11.4L116.7,152,98.3,133.7a8.1,8.1,0,0,1,11.4-11.4L128,140.7l18.3-18.4a8.1,8.1,0,0,1,11.4,11.4L139.3,152ZM208,80H48V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24Z" }, null, -1), ZWo = [
  zWo
], CWo = { key: 3 }, bWo = ["stroke"], LWo = ["stroke"], BWo = ["stroke"], PWo = ["stroke"], WWo = ["stroke"], NWo = ["stroke"], FWo = { key: 4 }, TWo = ["stroke"], DWo = ["stroke"], RWo = ["stroke"], UWo = ["stroke"], qWo = ["stroke"], GWo = ["stroke"], EWo = { key: 5 }, OWo = ["stroke"], IWo = ["stroke"], KWo = ["stroke"], XWo = ["stroke"], JWo = ["stroke"], QWo = ["stroke"], YWo = {
  name: "PhCalendarX"
}, lU1 = /* @__PURE__ */ $({
  ...YWo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", _Wo, [
        e("line", {
          x1: "152",
          y1: "128",
          x2: "104",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pWo),
        e("line", {
          x1: "152",
          y1: "176",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yWo),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $Wo),
        e("line", {
          x1: "176",
          y1: "20",
          x2: "176",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wWo),
        e("line", {
          x1: "80",
          y1: "20",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fWo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gWo)
      ])) : o(i) === "duotone" ? (s(), r("g", xWo, [
        jWo,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mWo),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MWo),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vWo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SWo),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "104",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HWo),
        e("line", {
          x1: "152",
          y1: "176",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AWo)
      ])) : o(i) === "fill" ? (s(), r("g", VWo, ZWo)) : o(i) === "light" ? (s(), r("g", CWo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bWo),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LWo),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BWo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PWo),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "104",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WWo),
        e("line", {
          x1: "152",
          y1: "176",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, NWo)
      ])) : o(i) === "thin" ? (s(), r("g", FWo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, TWo),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, DWo),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RWo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, UWo),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "104",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qWo),
        e("line", {
          x1: "152",
          y1: "176",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GWo)
      ])) : o(i) === "regular" ? (s(), r("g", EWo, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OWo),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IWo),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KWo),
        e("line", {
          x1: "40",
          y1: "88",
          x2: "216",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XWo),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "104",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JWo),
        e("line", {
          x1: "152",
          y1: "176",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QWo)
      ])) : g("", !0)
    ], 16, aWo));
  }
}), oNo = ["width", "height", "fill", "transform"], eNo = { key: 0 }, tNo = ["stroke"], nNo = ["stroke"], sNo = { key: 1 }, rNo = /* @__PURE__ */ e("path", {
  d: "M208,64H176L160,40H96L80,64H48A16,16,0,0,0,32,80V192a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V80A16,16,0,0,0,208,64ZM128,168a36,36,0,1,1,36-36A36,36,0,0,1,128,168Z",
  opacity: "0.2"
}, null, -1), iNo = ["stroke"], lNo = ["stroke"], dNo = { key: 2 }, kNo = /* @__PURE__ */ e("path", { d: "M208,56H180.3L166.7,35.6A7.9,7.9,0,0,0,160,32H96a7.9,7.9,0,0,0-6.7,3.6L75.7,56H48A24.1,24.1,0,0,0,24,80V192a24.1,24.1,0,0,0,24,24H208a24.1,24.1,0,0,0,24-24V80A24.1,24.1,0,0,0,208,56Zm-44,76a36,36,0,1,1-36-36A36,36,0,0,1,164,132Z" }, null, -1), cNo = [
  kNo
], hNo = { key: 3 }, uNo = ["stroke"], aNo = ["stroke"], _No = { key: 4 }, pNo = ["stroke"], yNo = ["stroke"], $No = { key: 5 }, wNo = ["stroke"], fNo = ["stroke"], gNo = {
  name: "PhCamera"
}, dU1 = /* @__PURE__ */ $({
  ...gNo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", eNo, [
        e("path", {
          d: "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tNo),
        e("circle", {
          cx: "128",
          cy: "132",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nNo)
      ])) : o(i) === "duotone" ? (s(), r("g", sNo, [
        rNo,
        e("path", {
          d: "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iNo),
        e("circle", {
          cx: "128",
          cy: "132",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lNo)
      ])) : o(i) === "fill" ? (s(), r("g", dNo, cNo)) : o(i) === "light" ? (s(), r("g", hNo, [
        e("path", {
          d: "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uNo),
        e("circle", {
          cx: "128",
          cy: "132",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aNo)
      ])) : o(i) === "thin" ? (s(), r("g", _No, [
        e("path", {
          d: "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pNo),
        e("circle", {
          cx: "128",
          cy: "132",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yNo)
      ])) : o(i) === "regular" ? (s(), r("g", $No, [
        e("path", {
          d: "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wNo),
        e("circle", {
          cx: "128",
          cy: "132",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fNo)
      ])) : g("", !0)
    ], 16, oNo));
  }
}), xNo = ["width", "height", "fill", "transform"], jNo = { key: 0 }, mNo = ["stroke"], MNo = ["stroke"], vNo = ["stroke"], SNo = ["stroke"], HNo = ["stroke"], ANo = { key: 1 }, VNo = /* @__PURE__ */ e("path", {
  d: "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
  opacity: "0.2"
}, null, -1), zNo = ["stroke"], ZNo = ["stroke"], CNo = ["stroke"], bNo = ["stroke"], LNo = ["stroke"], BNo = { key: 2 }, PNo = /* @__PURE__ */ e("path", { d: "M208,56H180.3L166.7,35.6A7.9,7.9,0,0,0,160,32H96a7.9,7.9,0,0,0-6.7,3.6L75.7,56H48A24.1,24.1,0,0,0,24,80V192a24.1,24.1,0,0,0,24,24H208a24.1,24.1,0,0,0,24-24V80A24.1,24.1,0,0,0,208,56ZM161.9,165.9a47.8,47.8,0,0,1-67.8,0H94L89.3,161l-1.4,8.3A8.1,8.1,0,0,1,80,176H78.7a8,8,0,0,1-6.6-9.2l4-24a8.1,8.1,0,0,1,6.6-6.6l24-4a8,8,0,1,1,2.6,15.8l-9,1.5,5.1,5.3A32,32,0,0,0,128,164a31.5,31.5,0,0,0,22.6-9.4,8,8,0,0,1,11.3,0A7.9,7.9,0,0,1,161.9,165.9Zm22-68.6-4,24a8.1,8.1,0,0,1-6.6,6.6l-24,4H148a8.1,8.1,0,0,1-7.9-6.7,8,8,0,0,1,6.6-9.2l9-1.5-5.1-5.3A32,32,0,0,0,128,100a31.5,31.5,0,0,0-22.6,9.4,8,8,0,0,1-11.3,0,7.9,7.9,0,0,1,0-11.3,47.8,47.8,0,0,1,67.8,0c.1,0,.1,0,.1.1l4.7,4.8,1.4-8.3a8,8,0,0,1,15.8,2.6Z" }, null, -1), WNo = [
  PNo
], NNo = { key: 3 }, FNo = ["stroke"], TNo = ["stroke"], DNo = ["stroke"], RNo = ["stroke"], UNo = ["stroke"], qNo = { key: 4 }, GNo = ["stroke"], ENo = ["stroke"], ONo = ["stroke"], INo = ["stroke"], KNo = ["stroke"], XNo = { key: 5 }, JNo = ["stroke"], QNo = ["stroke"], YNo = ["stroke"], oFo = ["stroke"], eFo = ["stroke"], tFo = {
  name: "PhCameraRotate"
}, kU1 = /* @__PURE__ */ $({
  ...tFo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", jNo, [
        e("path", {
          d: "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mNo),
        e("path", {
          d: "M172,120l-15.7-16.3a40.1,40.1,0,0,0-56.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MNo),
        e("path", {
          d: "M156.3,160.3a40.1,40.1,0,0,1-56.6,0L84,144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vNo),
        e("polyline", {
          points: "176 96 172 120 148 124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SNo),
        e("polyline", {
          points: "108 140 84 144 80 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HNo)
      ])) : o(i) === "duotone" ? (s(), r("g", ANo, [
        VNo,
        e("path", {
          d: "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zNo),
        e("path", {
          d: "M172,120l-15.7-16.3a40.1,40.1,0,0,0-56.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZNo),
        e("path", {
          d: "M156.3,160.3a40.1,40.1,0,0,1-56.6,0L84,144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CNo),
        e("polyline", {
          points: "176 96 172 120 148 124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bNo),
        e("polyline", {
          points: "108 140 84 144 80 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LNo)
      ])) : o(i) === "fill" ? (s(), r("g", BNo, WNo)) : o(i) === "light" ? (s(), r("g", NNo, [
        e("path", {
          d: "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FNo),
        e("path", {
          d: "M172,120l-15.7-16.3a40.1,40.1,0,0,0-56.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TNo),
        e("path", {
          d: "M156.3,160.3a40.1,40.1,0,0,1-56.6,0L84,144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DNo),
        e("polyline", {
          points: "176 96 172 120 148 124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RNo),
        e("polyline", {
          points: "108 140 84 144 80 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UNo)
      ])) : o(i) === "thin" ? (s(), r("g", qNo, [
        e("path", {
          d: "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GNo),
        e("path", {
          d: "M172,120l-15.7-16.3a40.1,40.1,0,0,0-56.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ENo),
        e("path", {
          d: "M156.3,160.3a40.1,40.1,0,0,1-56.6,0L84,144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ONo),
        e("polyline", {
          points: "176 96 172 120 148 124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, INo),
        e("polyline", {
          points: "108 140 84 144 80 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KNo)
      ])) : o(i) === "regular" ? (s(), r("g", XNo, [
        e("path", {
          d: "M208,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H80L96,40h64l16,24h32a16,16,0,0,1,16,16V192A16,16,0,0,1,208,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JNo),
        e("path", {
          d: "M172,120l-15.7-16.3a40.1,40.1,0,0,0-56.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QNo),
        e("path", {
          d: "M156.3,160.3a40.1,40.1,0,0,1-56.6,0L84,144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YNo),
        e("polyline", {
          points: "176 96 172 120 148 124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oFo),
        e("polyline", {
          points: "108 140 84 144 80 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eFo)
      ])) : g("", !0)
    ], 16, xNo));
  }
}), nFo = ["width", "height", "fill", "transform"], sFo = { key: 0 }, rFo = ["stroke"], iFo = ["stroke"], lFo = ["stroke"], dFo = ["stroke"], kFo = { key: 1 }, cFo = /* @__PURE__ */ e("path", {
  d: "M208,64H176L160,40H96L80,64H48A16,16,0,0,0,32,80V192a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V80A16,16,0,0,0,208,64ZM128,168a36,36,0,1,1,36-36A36,36,0,0,1,128,168Z",
  opacity: "0.2"
}, null, -1), hFo = ["stroke"], uFo = ["stroke"], aFo = ["stroke"], _Fo = ["stroke"], pFo = { key: 2 }, yFo = /* @__PURE__ */ e("path", { d: "M39.4,18.6a7.9,7.9,0,0,0-11.3-.5,8,8,0,0,0-.6,11.3L51.7,56H48A24.1,24.1,0,0,0,24,80V192a24.1,24.1,0,0,0,24,24H197.2l19.4,21.4a8.2,8.2,0,0,0,5.9,2.6,7.8,7.8,0,0,0,5.4-2.1,8,8,0,0,0,.6-11.3ZM128,168a36,36,0,0,1-36-36,36.4,36.4,0,0,1,8.1-22.8L148,161.9A35.3,35.3,0,0,1,128,168Z" }, null, -1), $Fo = /* @__PURE__ */ e("path", { d: "M208,56H180.3L166.6,35.6A7.6,7.6,0,0,0,160,32H96a7.9,7.9,0,0,0-6.7,3.6l-2,3a8,8,0,0,0,.8,9.8l130,143A7.9,7.9,0,0,0,224,194a7.4,7.4,0,0,0,2.9-.5A8,8,0,0,0,232,186V80A24.1,24.1,0,0,0,208,56Z" }, null, -1), wFo = [
  yFo,
  $Fo
], fFo = { key: 3 }, gFo = ["stroke"], xFo = ["stroke"], jFo = ["stroke"], mFo = ["stroke"], MFo = { key: 4 }, vFo = ["stroke"], SFo = ["stroke"], HFo = ["stroke"], AFo = ["stroke"], VFo = { key: 5 }, zFo = ["stroke"], ZFo = ["stroke"], CFo = ["stroke"], bFo = ["stroke"], LFo = {
  name: "PhCameraSlash"
}, cU1 = /* @__PURE__ */ $({
  ...LFo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", sFo, [
        e("line", {
          x1: "33.5",
          y1: "24",
          x2: "222.5",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rFo),
        e("path", {
          d: "M200.7,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H69.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iFo),
        e("path", {
          d: "M154.1,156.8a36,36,0,1,1-48.3-53.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lFo),
        e("path", {
          d: "M102.1,40H160l16,24h32a16,16,0,0,1,16,16v94.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dFo)
      ])) : o(i) === "duotone" ? (s(), r("g", kFo, [
        cFo,
        e("line", {
          x1: "33.5",
          y1: "24",
          x2: "222.5",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hFo),
        e("path", {
          d: "M94,43l2-3h64l16,24h32a16,16,0,0,1,16,16V186",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uFo),
        e("path", {
          d: "M200.7,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H69.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aFo),
        e("path", {
          d: "M154.1,156.8a36,36,0,1,1-48.3-53.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Fo)
      ])) : o(i) === "fill" ? (s(), r("g", pFo, wFo)) : o(i) === "light" ? (s(), r("g", fFo, [
        e("line", {
          x1: "33.5",
          y1: "24",
          x2: "222.5",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gFo),
        e("path", {
          d: "M94,43l2-3h64l16,24h32a16,16,0,0,1,16,16V186",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xFo),
        e("path", {
          d: "M200.7,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H69.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jFo),
        e("path", {
          d: "M154.1,156.8a36,36,0,1,1-48.3-53.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mFo)
      ])) : o(i) === "thin" ? (s(), r("g", MFo, [
        e("line", {
          x1: "33.5",
          y1: "24",
          x2: "222.5",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vFo),
        e("path", {
          d: "M94,43l2-3h64l16,24h32a16,16,0,0,1,16,16V186",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SFo),
        e("path", {
          d: "M200.7,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H69.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HFo),
        e("path", {
          d: "M154.1,156.8a36,36,0,1,1-48.3-53.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, AFo)
      ])) : o(i) === "regular" ? (s(), r("g", VFo, [
        e("line", {
          x1: "33.5",
          y1: "24",
          x2: "222.5",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zFo),
        e("path", {
          d: "M94,43l2-3h64l16,24h32a16,16,0,0,1,16,16V186",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZFo),
        e("path", {
          d: "M200.7,208H48a16,16,0,0,1-16-16V80A16,16,0,0,1,48,64H69.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CFo),
        e("path", {
          d: "M154.1,156.8a36,36,0,1,1-48.3-53.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bFo)
      ])) : g("", !0)
    ], 16, nFo));
  }
}), BFo = ["width", "height", "fill", "transform"], PFo = { key: 0 }, WFo = ["stroke"], NFo = ["stroke"], FFo = ["stroke"], TFo = ["stroke"], DFo = { key: 1 }, RFo = /* @__PURE__ */ e("path", {
  d: "M128,32S76,64,76,108a52,52,0,0,0,52,52,23.9,23.9,0,0,1-24-24c0-24,24-40,24-40s24,16,24,40a23.9,23.9,0,0,1-24,24,52,52,0,0,0,52-52C180,64,128,32,128,32Z",
  opacity: "0.2"
}, null, -1), UFo = ["stroke"], qFo = ["stroke"], GFo = ["stroke"], EFo = ["stroke"], OFo = { key: 2 }, IFo = /* @__PURE__ */ e("path", { d: "M132.2,25.2a7.9,7.9,0,0,0-8.4,0A153.5,153.5,0,0,0,96.2,48C77.8,67.1,68,87.9,68,108a60,60,0,0,0,120,0C188,60.1,134.5,26.6,132.2,25.2ZM128,152a23.9,23.9,0,0,1-24-24c0-24,24-40,24-40s24,16,24,40A23.9,23.9,0,0,1,128,152Zm95.6,74.4A8,8,0,0,1,216,232a6.7,6.7,0,0,1-2.4-.4L128,204.4,42.4,231.6a6.7,6.7,0,0,1-2.4.4,8,8,0,0,1-7.6-5.6,7.9,7.9,0,0,1,5.2-10l64-20.4-64-20.4a8,8,0,1,1,4.8-15.2L128,187.6l85.6-27.2a8,8,0,1,1,4.8,15.2l-64,20.4,64,20.4A7.9,7.9,0,0,1,223.6,226.4Z" }, null, -1), KFo = [
  IFo
], XFo = { key: 3 }, JFo = ["stroke"], QFo = ["stroke"], YFo = ["stroke"], oTo = ["stroke"], eTo = { key: 4 }, tTo = ["stroke"], nTo = ["stroke"], sTo = ["stroke"], rTo = ["stroke"], iTo = { key: 5 }, lTo = ["stroke"], dTo = ["stroke"], kTo = ["stroke"], cTo = ["stroke"], hTo = {
  name: "PhCampfire"
}, hU1 = /* @__PURE__ */ $({
  ...hTo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", PFo, [
        e("line", {
          x1: "40",
          y1: "168",
          x2: "216",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WFo),
        e("line", {
          x1: "216",
          y1: "168",
          x2: "40",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NFo),
        e("path", {
          d: "M152,136a24,24,0,0,1-48,0c0-24,24-40,24-40S152,112,152,136Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FFo),
        e("path", {
          d: "M180,108a52,52,0,0,1-104,0c0-44,52-76,52-76S180,64,180,108Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TFo)
      ])) : o(i) === "duotone" ? (s(), r("g", DFo, [
        RFo,
        e("path", {
          d: "M180,108a52,52,0,0,1-104,0c0-44,52-76,52-76S180,64,180,108Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UFo),
        e("line", {
          x1: "40",
          y1: "168",
          x2: "216",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qFo),
        e("line", {
          x1: "216",
          y1: "168",
          x2: "40",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GFo),
        e("path", {
          d: "M152,136a24,24,0,0,1-48,0c0-24,24-40,24-40S152,112,152,136Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EFo)
      ])) : o(i) === "fill" ? (s(), r("g", OFo, KFo)) : o(i) === "light" ? (s(), r("g", XFo, [
        e("line", {
          x1: "40",
          y1: "168",
          x2: "216",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JFo),
        e("line", {
          x1: "216",
          y1: "168",
          x2: "40",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QFo),
        e("path", {
          d: "M152,136a24,24,0,0,1-48,0c0-24,24-40,24-40S152,112,152,136Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YFo),
        e("path", {
          d: "M180,108a52,52,0,0,1-104,0c0-44,52-76,52-76S180,64,180,108Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oTo)
      ])) : o(i) === "thin" ? (s(), r("g", eTo, [
        e("line", {
          x1: "40",
          y1: "168",
          x2: "216",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tTo),
        e("line", {
          x1: "216",
          y1: "168",
          x2: "40",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nTo),
        e("path", {
          d: "M152,136a24,24,0,0,1-48,0c0-24,24-40,24-40S152,112,152,136Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sTo),
        e("path", {
          d: "M180,108a52,52,0,0,1-104,0c0-44,52-76,52-76S180,64,180,108Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rTo)
      ])) : o(i) === "regular" ? (s(), r("g", iTo, [
        e("line", {
          x1: "40",
          y1: "168",
          x2: "216",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lTo),
        e("line", {
          x1: "216",
          y1: "168",
          x2: "40",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dTo),
        e("path", {
          d: "M152,136a24,24,0,0,1-48,0c0-24,24-40,24-40S152,112,152,136Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kTo),
        e("path", {
          d: "M180,108a52,52,0,0,1-104,0c0-44,52-76,52-76S180,64,180,108Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cTo)
      ])) : g("", !0)
    ], 16, BFo));
  }
}), uTo = ["width", "height", "fill", "transform"], aTo = { key: 0 }, _To = ["stroke"], pTo = ["stroke"], yTo = ["stroke"], $To = ["stroke"], wTo = { key: 1 }, fTo = /* @__PURE__ */ e("path", {
  d: "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184Z",
  opacity: "0.2"
}, null, -1), gTo = /* @__PURE__ */ e("path", {
  d: "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184Z",
  opacity: "0.2"
}, null, -1), xTo = /* @__PURE__ */ e("path", {
  d: "M224,120,194.1,52.8a8,8,0,0,0-7.3-4.8H69.2a8,8,0,0,0-7.3,4.8L32,120Z",
  opacity: "0.2"
}, null, -1), jTo = ["stroke"], mTo = ["stroke"], MTo = ["stroke"], vTo = ["stroke"], STo = ["stroke"], HTo = ["stroke"], ATo = { key: 2 }, VTo = /* @__PURE__ */ e("path", { d: "M240,112H229.2L201.4,49.5A15.9,15.9,0,0,0,186.8,40H69.2a15.9,15.9,0,0,0-14.6,9.5L26.8,112H16a8,8,0,0,0,0,16h8v80a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V192h96v16a16,16,0,0,0,16,16h24a16,16,0,0,0,16-16V128h8a8,8,0,0,0,0-16ZM80,160H64a8,8,0,0,1,0-16H80a8,8,0,0,1,0,16Zm96,0a8,8,0,0,1,0-16h16a8,8,0,0,1,0,16Z" }, null, -1), zTo = [
  VTo
], ZTo = { key: 3 }, CTo = ["stroke"], bTo = ["stroke"], LTo = ["stroke"], BTo = ["stroke"], PTo = ["stroke"], WTo = ["stroke"], NTo = { key: 4 }, FTo = ["stroke"], TTo = ["stroke"], DTo = ["stroke"], RTo = ["stroke"], UTo = ["stroke"], qTo = ["stroke"], GTo = { key: 5 }, ETo = ["stroke"], OTo = ["stroke"], ITo = ["stroke"], KTo = ["stroke"], XTo = ["stroke"], JTo = ["stroke"], QTo = {
  name: "PhCar"
}, uU1 = /* @__PURE__ */ $({
  ...QTo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", aTo, [
        e("line", {
          x1: "16",
          y1: "120",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _To),
        e("path", {
          d: "M224,176v32a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pTo),
        e("path", {
          d: "M72,176v32a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yTo),
        e("path", {
          d: "M224,120,194.1,52.8a8,8,0,0,0-7.3-4.8H69.2a8,8,0,0,0-7.3,4.8L32,120v56H224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $To)
      ])) : o(i) === "duotone" ? (s(), r("g", wTo, [
        fTo,
        gTo,
        xTo,
        e("line", {
          x1: "16",
          y1: "120",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jTo),
        e("path", {
          d: "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mTo),
        e("path", {
          d: "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MTo),
        e("line", {
          x1: "64",
          y1: "152",
          x2: "80",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vTo),
        e("line", {
          x1: "176",
          y1: "152",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, STo),
        e("path", {
          d: "M224,120,194.1,52.8a8,8,0,0,0-7.3-4.8H69.2a8,8,0,0,0-7.3,4.8L32,120v64H224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HTo)
      ])) : o(i) === "fill" ? (s(), r("g", ATo, zTo)) : o(i) === "light" ? (s(), r("g", ZTo, [
        e("line", {
          x1: "16",
          y1: "120",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, CTo),
        e("path", {
          d: "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bTo),
        e("path", {
          d: "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LTo),
        e("line", {
          x1: "64",
          y1: "152",
          x2: "80",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BTo),
        e("line", {
          x1: "176",
          y1: "152",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PTo),
        e("path", {
          d: "M224,120,194.1,52.8a8,8,0,0,0-7.3-4.8H69.2a8,8,0,0,0-7.3,4.8L32,120v64H224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WTo)
      ])) : o(i) === "thin" ? (s(), r("g", NTo, [
        e("line", {
          x1: "16",
          y1: "120",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FTo),
        e("path", {
          d: "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, TTo),
        e("path", {
          d: "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, DTo),
        e("line", {
          x1: "64",
          y1: "152",
          x2: "80",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RTo),
        e("line", {
          x1: "176",
          y1: "152",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, UTo),
        e("path", {
          d: "M224,120,194.1,52.8a8,8,0,0,0-7.3-4.8H69.2a8,8,0,0,0-7.3,4.8L32,120v64H224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qTo)
      ])) : o(i) === "regular" ? (s(), r("g", GTo, [
        e("line", {
          x1: "16",
          y1: "120",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ETo),
        e("path", {
          d: "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OTo),
        e("path", {
          d: "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ITo),
        e("line", {
          x1: "64",
          y1: "152",
          x2: "80",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KTo),
        e("line", {
          x1: "176",
          y1: "152",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XTo),
        e("path", {
          d: "M224,120,194.1,52.8a8,8,0,0,0-7.3-4.8H69.2a8,8,0,0,0-7.3,4.8L32,120v64H224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JTo)
      ])) : g("", !0)
    ], 16, uTo));
  }
}), YTo = ["width", "height", "fill", "transform"], oDo = { key: 0 }, eDo = ["stroke"], tDo = ["stroke"], nDo = { key: 1 }, sDo = /* @__PURE__ */ e("path", {
  d: "M32,120,61.9,52.8A8,8,0,0,1,69.2,48H186.8a8,8,0,0,1,7.3,4.8L224,120Z",
  opacity: "0.2"
}, null, -1), rDo = ["stroke"], iDo = ["stroke"], lDo = { key: 2 }, dDo = /* @__PURE__ */ e("path", { d: "M240,112H229.2L201.4,49.5A15.9,15.9,0,0,0,186.8,40H69.2a15.9,15.9,0,0,0-14.6,9.5L26.8,112H16a8,8,0,0,0,0,16h8v80a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V192h96v16a16,16,0,0,0,16,16h24a16,16,0,0,0,16-16V128h8a8,8,0,0,0,0-16Z" }, null, -1), kDo = [
  dDo
], cDo = { key: 3 }, hDo = ["stroke"], uDo = ["stroke"], aDo = { key: 4 }, _Do = ["stroke"], pDo = ["stroke"], yDo = { key: 5 }, $Do = ["stroke"], wDo = ["stroke"], fDo = {
  name: "PhCarSimple"
}, aU1 = /* @__PURE__ */ $({
  ...fDo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", oDo, [
        e("line", {
          x1: "16",
          y1: "120",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eDo),
        e("path", {
          d: "M216,216H192a8,8,0,0,1-8-8V184H72v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120L61.9,52.8A8,8,0,0,1,69.2,48H186.8a8,8,0,0,1,7.3,4.8L224,120v88A8,8,0,0,1,216,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tDo)
      ])) : o(i) === "duotone" ? (s(), r("g", nDo, [
        sDo,
        e("line", {
          x1: "16",
          y1: "120",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rDo),
        e("path", {
          d: "M216,216H192a8,8,0,0,1-8-8V184H72v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120L61.9,52.8A8,8,0,0,1,69.2,48H186.8a8,8,0,0,1,7.3,4.8L224,120v88A8,8,0,0,1,216,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iDo)
      ])) : o(i) === "fill" ? (s(), r("g", lDo, kDo)) : o(i) === "light" ? (s(), r("g", cDo, [
        e("line", {
          x1: "16",
          y1: "120",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hDo),
        e("path", {
          d: "M216,216H192a8,8,0,0,1-8-8V184H72v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120L61.9,52.8A8,8,0,0,1,69.2,48H186.8a8,8,0,0,1,7.3,4.8L224,120v88A8,8,0,0,1,216,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uDo)
      ])) : o(i) === "thin" ? (s(), r("g", aDo, [
        e("line", {
          x1: "16",
          y1: "120",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _Do),
        e("path", {
          d: "M216,216H192a8,8,0,0,1-8-8V184H72v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120L61.9,52.8A8,8,0,0,1,69.2,48H186.8a8,8,0,0,1,7.3,4.8L224,120v88A8,8,0,0,1,216,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pDo)
      ])) : o(i) === "regular" ? (s(), r("g", yDo, [
        e("line", {
          x1: "16",
          y1: "120",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Do),
        e("path", {
          d: "M216,216H192a8,8,0,0,1-8-8V184H72v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V120L61.9,52.8A8,8,0,0,1,69.2,48H186.8a8,8,0,0,1,7.3,4.8L224,120v88A8,8,0,0,1,216,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wDo)
      ])) : g("", !0)
    ], 16, YTo));
  }
}), gDo = ["width", "height", "fill", "transform"], xDo = { key: 0 }, jDo = ["stroke"], mDo = ["stroke"], MDo = { key: 1 }, vDo = /* @__PURE__ */ e("path", {
  d: "M32,120H88.8a7.9,7.9,0,0,1,7.8,6.4,32.1,32.1,0,0,0,62.8,0,7.9,7.9,0,0,1,7.8-6.4H224V72a16,16,0,0,0-16-16H48A16,16,0,0,0,32,72Z",
  opacity: "0.2"
}, null, -1), SDo = ["stroke"], HDo = ["stroke"], ADo = ["stroke"], VDo = { key: 2 }, zDo = /* @__PURE__ */ e("path", { d: "M208,48H48A24.1,24.1,0,0,0,24,72V184a24.1,24.1,0,0,0,24,24H208a24.1,24.1,0,0,0,24-24V72A24.1,24.1,0,0,0,208,48Zm-56.5,76.8a24,24,0,0,1-47,0A16.1,16.1,0,0,0,88.8,112H40V96H216v16H167.2A16.1,16.1,0,0,0,151.5,124.8ZM48,64H208a8,8,0,0,1,8,8v8H40V72A8,8,0,0,1,48,64Z" }, null, -1), ZDo = [
  zDo
], CDo = { key: 3 }, bDo = ["stroke"], LDo = ["stroke"], BDo = ["stroke"], PDo = { key: 4 }, WDo = ["stroke"], NDo = ["stroke"], FDo = ["stroke"], TDo = { key: 5 }, DDo = ["stroke"], RDo = ["stroke"], UDo = ["stroke"], qDo = {
  name: "PhCardholder"
}, _U1 = /* @__PURE__ */ $({
  ...qDo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xDo, [
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jDo),
        e("path", {
          d: "M32,100H88.8a7.9,7.9,0,0,1,7.8,6.4,32.1,32.1,0,0,0,62.8,0,7.9,7.9,0,0,1,7.8-6.4H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mDo)
      ])) : o(i) === "duotone" ? (s(), r("g", MDo, [
        vDo,
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SDo),
        e("path", {
          d: "M32,120H88.8a7.9,7.9,0,0,1,7.8,6.4,32.1,32.1,0,0,0,62.8,0,7.9,7.9,0,0,1,7.8-6.4H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HDo),
        e("line", {
          x1: "32",
          y1: "88",
          x2: "224",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ADo)
      ])) : o(i) === "fill" ? (s(), r("g", VDo, ZDo)) : o(i) === "light" ? (s(), r("g", CDo, [
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bDo),
        e("path", {
          d: "M32,120H88.8a7.9,7.9,0,0,1,7.8,6.4,32.1,32.1,0,0,0,62.8,0,7.9,7.9,0,0,1,7.8-6.4H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LDo),
        e("line", {
          x1: "32",
          y1: "88",
          x2: "224",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BDo)
      ])) : o(i) === "thin" ? (s(), r("g", PDo, [
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WDo),
        e("path", {
          d: "M32,120H88.8a7.9,7.9,0,0,1,7.8,6.4,32.1,32.1,0,0,0,62.8,0,7.9,7.9,0,0,1,7.8-6.4H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, NDo),
        e("line", {
          x1: "32",
          y1: "88",
          x2: "224",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FDo)
      ])) : o(i) === "regular" ? (s(), r("g", TDo, [
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DDo),
        e("path", {
          d: "M32,120H88.8a7.9,7.9,0,0,1,7.8,6.4,32.1,32.1,0,0,0,62.8,0,7.9,7.9,0,0,1,7.8-6.4H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RDo),
        e("line", {
          x1: "32",
          y1: "88",
          x2: "224",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UDo)
      ])) : g("", !0)
    ], 16, gDo));
  }
}), GDo = ["width", "height", "fill", "transform"], EDo = { key: 0 }, ODo = ["stroke"], IDo = ["stroke"], KDo = { key: 1 }, XDo = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "80",
  width: "160",
  height: "128",
  rx: "8",
  opacity: "0.2"
}, null, -1), JDo = ["stroke"], QDo = ["stroke"], YDo = { key: 2 }, oRo = /* @__PURE__ */ e("rect", {
  x: "24",
  y: "72",
  width: "176",
  height: "144",
  rx: "16"
}, null, -1), eRo = /* @__PURE__ */ e("path", { d: "M216,40H64a8,8,0,0,0,0,16H216V176a8,8,0,0,0,16,0V56A16,16,0,0,0,216,40Z" }, null, -1), tRo = [
  oRo,
  eRo
], nRo = { key: 3 }, sRo = ["stroke"], rRo = ["stroke"], iRo = { key: 4 }, lRo = ["stroke"], dRo = ["stroke"], kRo = { key: 5 }, cRo = ["stroke"], hRo = ["stroke"], uRo = {
  name: "PhCards"
}, pU1 = /* @__PURE__ */ $({
  ...uRo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", EDo, [
        e("rect", {
          x: "28",
          y: "84",
          width: "160",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ODo),
        e("path", {
          d: "M64,44H220a8,8,0,0,1,8,8V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IDo)
      ])) : o(i) === "duotone" ? (s(), r("g", KDo, [
        XDo,
        e("rect", {
          x: "32",
          y: "80",
          width: "160",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JDo),
        e("path", {
          d: "M64,48H216a8,8,0,0,1,8,8V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QDo)
      ])) : o(i) === "fill" ? (s(), r("g", YDo, tRo)) : o(i) === "light" ? (s(), r("g", nRo, [
        e("rect", {
          x: "32",
          y: "80",
          width: "160",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sRo),
        e("path", {
          d: "M64,48H216a8,8,0,0,1,8,8V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rRo)
      ])) : o(i) === "thin" ? (s(), r("g", iRo, [
        e("rect", {
          x: "32",
          y: "80",
          width: "160",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lRo),
        e("path", {
          d: "M64,48H216a8,8,0,0,1,8,8V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dRo)
      ])) : o(i) === "regular" ? (s(), r("g", kRo, [
        e("rect", {
          x: "32",
          y: "80",
          width: "160",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cRo),
        e("path", {
          d: "M64,48H216a8,8,0,0,1,8,8V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hRo)
      ])) : g("", !0)
    ], 16, GDo));
  }
}), aRo = ["width", "height", "fill", "transform"], _Ro = { key: 0 }, pRo = ["stroke"], yRo = ["stroke"], $Ro = ["stroke"], wRo = { key: 1 }, fRo = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), gRo = ["stroke"], xRo = ["stroke"], jRo = ["stroke"], mRo = { key: 2 }, MRo = /* @__PURE__ */ e("path", { d: "M54.5,54.5a104,104,0,1,0,147,0A103.9,103.9,0,0,0,54.5,54.5Zm99.8,83.8a8.1,8.1,0,0,1,11.4,0,8.2,8.2,0,0,1,0,11.4l-32,32a8.1,8.1,0,0,1-11.4,0l-32-32a8.1,8.1,0,0,1,11.4-11.4L128,164.7Zm0-56a8.1,8.1,0,0,1,11.4,0,8.2,8.2,0,0,1,0,11.4l-32,32a8.1,8.1,0,0,1-11.4,0l-32-32a8.1,8.1,0,0,1,11.4-11.4L128,108.7Z" }, null, -1), vRo = [
  MRo
], SRo = { key: 3 }, HRo = ["stroke"], ARo = ["stroke"], VRo = ["stroke"], zRo = { key: 4 }, ZRo = ["stroke"], CRo = ["stroke"], bRo = ["stroke"], LRo = { key: 5 }, BRo = ["stroke"], PRo = ["stroke"], WRo = ["stroke"], NRo = {
  name: "PhCaretCircleDoubleDown"
}, yU1 = /* @__PURE__ */ $({
  ...NRo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", _Ro, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pRo),
        e("polyline", {
          points: "160 88 128 120 96 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yRo),
        e("polyline", {
          points: "160 144 128 176 96 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $Ro)
      ])) : o(i) === "duotone" ? (s(), r("g", wRo, [
        fRo,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gRo),
        e("polyline", {
          points: "160 88 128 120 96 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xRo),
        e("polyline", {
          points: "160 144 128 176 96 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jRo)
      ])) : o(i) === "fill" ? (s(), r("g", mRo, vRo)) : o(i) === "light" ? (s(), r("g", SRo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HRo),
        e("polyline", {
          points: "160 88 128 120 96 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ARo),
        e("polyline", {
          points: "160 144 128 176 96 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VRo)
      ])) : o(i) === "thin" ? (s(), r("g", zRo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZRo),
        e("polyline", {
          points: "160 88 128 120 96 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CRo),
        e("polyline", {
          points: "160 144 128 176 96 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bRo)
      ])) : o(i) === "regular" ? (s(), r("g", LRo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BRo),
        e("polyline", {
          points: "160 88 128 120 96 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PRo),
        e("polyline", {
          points: "160 144 128 176 96 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WRo)
      ])) : g("", !0)
    ], 16, aRo));
  }
}), FRo = ["width", "height", "fill", "transform"], TRo = { key: 0 }, DRo = ["stroke"], RRo = ["stroke"], URo = ["stroke"], qRo = { key: 1 }, GRo = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), ERo = ["stroke"], ORo = ["stroke"], IRo = ["stroke"], KRo = { key: 2 }, XRo = /* @__PURE__ */ e("path", { d: "M201.5,54.5a104,104,0,1,0,0,147A103.9,103.9,0,0,0,201.5,54.5Zm-83.8,99.8a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0l-32-32a8.1,8.1,0,0,1,0-11.4l32-32a8.1,8.1,0,0,1,11.4,11.4L91.3,128Zm56,0a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0l-32-32a8.1,8.1,0,0,1,0-11.4l32-32a8.1,8.1,0,0,1,11.4,11.4L147.3,128Z" }, null, -1), JRo = [
  XRo
], QRo = { key: 3 }, YRo = ["stroke"], oUo = ["stroke"], eUo = ["stroke"], tUo = { key: 4 }, nUo = ["stroke"], sUo = ["stroke"], rUo = ["stroke"], iUo = { key: 5 }, lUo = ["stroke"], dUo = ["stroke"], kUo = ["stroke"], cUo = {
  name: "PhCaretCircleDoubleLeft"
}, $U1 = /* @__PURE__ */ $({
  ...cUo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", TRo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DRo),
        e("polyline", {
          points: "168 160 136 128 168 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RRo),
        e("polyline", {
          points: "112 160 80 128 112 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, URo)
      ])) : o(i) === "duotone" ? (s(), r("g", qRo, [
        GRo,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ERo),
        e("polyline", {
          points: "168 160 136 128 168 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ORo),
        e("polyline", {
          points: "112 160 80 128 112 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IRo)
      ])) : o(i) === "fill" ? (s(), r("g", KRo, JRo)) : o(i) === "light" ? (s(), r("g", QRo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YRo),
        e("polyline", {
          points: "168 160 136 128 168 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oUo),
        e("polyline", {
          points: "112 160 80 128 112 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eUo)
      ])) : o(i) === "thin" ? (s(), r("g", tUo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nUo),
        e("polyline", {
          points: "168 160 136 128 168 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sUo),
        e("polyline", {
          points: "112 160 80 128 112 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rUo)
      ])) : o(i) === "regular" ? (s(), r("g", iUo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lUo),
        e("polyline", {
          points: "168 160 136 128 168 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dUo),
        e("polyline", {
          points: "112 160 80 128 112 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kUo)
      ])) : g("", !0)
    ], 16, FRo));
  }
}), hUo = ["width", "height", "fill", "transform"], uUo = { key: 0 }, aUo = ["stroke"], _Uo = ["stroke"], pUo = ["stroke"], yUo = { key: 1 }, $Uo = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), wUo = ["stroke"], fUo = ["stroke"], gUo = ["stroke"], xUo = { key: 2 }, jUo = /* @__PURE__ */ e("path", { d: "M201.5,54.5a104,104,0,1,0,0,147A103.9,103.9,0,0,0,201.5,54.5Zm-75.8,79.2-32,32a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L108.7,128,82.3,101.7A8.1,8.1,0,0,1,93.7,90.3l32,32A8.1,8.1,0,0,1,125.7,133.7Zm56,0-32,32a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L164.7,128l-26.4-26.3a8.1,8.1,0,0,1,11.4-11.4l32,32A8.1,8.1,0,0,1,181.7,133.7Z" }, null, -1), mUo = [
  jUo
], MUo = { key: 3 }, vUo = ["stroke"], SUo = ["stroke"], HUo = ["stroke"], AUo = { key: 4 }, VUo = ["stroke"], zUo = ["stroke"], ZUo = ["stroke"], CUo = { key: 5 }, bUo = ["stroke"], LUo = ["stroke"], BUo = ["stroke"], PUo = {
  name: "PhCaretCircleDoubleRight"
}, wU1 = /* @__PURE__ */ $({
  ...PUo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", uUo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aUo),
        e("polyline", {
          points: "88 160 120 128 88 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Uo),
        e("polyline", {
          points: "144 160 176 128 144 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pUo)
      ])) : o(i) === "duotone" ? (s(), r("g", yUo, [
        $Uo,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wUo),
        e("polyline", {
          points: "88 160 120 128 88 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fUo),
        e("polyline", {
          points: "144 160 176 128 144 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gUo)
      ])) : o(i) === "fill" ? (s(), r("g", xUo, mUo)) : o(i) === "light" ? (s(), r("g", MUo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vUo),
        e("polyline", {
          points: "88 160 120 128 88 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, SUo),
        e("polyline", {
          points: "144 160 176 128 144 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HUo)
      ])) : o(i) === "thin" ? (s(), r("g", AUo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VUo),
        e("polyline", {
          points: "88 160 120 128 88 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zUo),
        e("polyline", {
          points: "144 160 176 128 144 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZUo)
      ])) : o(i) === "regular" ? (s(), r("g", CUo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bUo),
        e("polyline", {
          points: "88 160 120 128 88 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LUo),
        e("polyline", {
          points: "144 160 176 128 144 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BUo)
      ])) : g("", !0)
    ], 16, hUo));
  }
}), WUo = ["width", "height", "fill", "transform"], NUo = { key: 0 }, FUo = ["stroke"], TUo = ["stroke"], DUo = ["stroke"], RUo = { key: 1 }, UUo = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), qUo = ["stroke"], GUo = ["stroke"], EUo = ["stroke"], OUo = { key: 2 }, IUo = /* @__PURE__ */ e("path", { d: "M201.5,201.5a104,104,0,1,0-147,0A103.9,103.9,0,0,0,201.5,201.5Zm-99.8-83.8a8.1,8.1,0,0,1-11.4,0,8.2,8.2,0,0,1,0-11.4l32-32a8.1,8.1,0,0,1,11.4,0l32,32a8.1,8.1,0,0,1-11.4,11.4L128,91.3Zm0,56a8.1,8.1,0,0,1-11.4,0,8.2,8.2,0,0,1,0-11.4l32-32a8.1,8.1,0,0,1,11.4,0l32,32a8.1,8.1,0,0,1-11.4,11.4L128,147.3Z" }, null, -1), KUo = [
  IUo
], XUo = { key: 3 }, JUo = ["stroke"], QUo = ["stroke"], YUo = ["stroke"], oqo = { key: 4 }, eqo = ["stroke"], tqo = ["stroke"], nqo = ["stroke"], sqo = { key: 5 }, rqo = ["stroke"], iqo = ["stroke"], lqo = ["stroke"], dqo = {
  name: "PhCaretCircleDoubleUp"
}, fU1 = /* @__PURE__ */ $({
  ...dqo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", NUo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FUo),
        e("polyline", {
          points: "96 168 128 136 160 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TUo),
        e("polyline", {
          points: "96 112 128 80 160 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DUo)
      ])) : o(i) === "duotone" ? (s(), r("g", RUo, [
        UUo,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qUo),
        e("polyline", {
          points: "96 168 128 136 160 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GUo),
        e("polyline", {
          points: "96 112 128 80 160 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EUo)
      ])) : o(i) === "fill" ? (s(), r("g", OUo, KUo)) : o(i) === "light" ? (s(), r("g", XUo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JUo),
        e("polyline", {
          points: "96 168 128 136 160 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QUo),
        e("polyline", {
          points: "96 112 128 80 160 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YUo)
      ])) : o(i) === "thin" ? (s(), r("g", oqo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eqo),
        e("polyline", {
          points: "96 168 128 136 160 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tqo),
        e("polyline", {
          points: "96 112 128 80 160 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nqo)
      ])) : o(i) === "regular" ? (s(), r("g", sqo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rqo),
        e("polyline", {
          points: "96 168 128 136 160 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iqo),
        e("polyline", {
          points: "96 112 128 80 160 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lqo)
      ])) : g("", !0)
    ], 16, WUo));
  }
}), kqo = ["width", "height", "fill", "transform"], cqo = { key: 0 }, hqo = ["stroke"], uqo = ["stroke"], aqo = { key: 1 }, _qo = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), pqo = ["stroke"], yqo = ["stroke"], $qo = { key: 2 }, wqo = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm41.9,97.4-36,40a8,8,0,0,1-11.8,0l-36-40a8,8,0,0,1,11.8-10.8L128,144l30.1-33.4a8,8,0,1,1,11.8,10.8Z" }, null, -1), fqo = [
  wqo
], gqo = { key: 3 }, xqo = ["stroke"], jqo = ["stroke"], mqo = { key: 4 }, Mqo = ["stroke"], vqo = ["stroke"], Sqo = { key: 5 }, Hqo = ["stroke"], Aqo = ["stroke"], Vqo = {
  name: "PhCaretCircleDown"
}, gU1 = /* @__PURE__ */ $({
  ...Vqo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", cqo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hqo),
        e("polyline", {
          points: "164 116 128 156 92 116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uqo)
      ])) : o(i) === "duotone" ? (s(), r("g", aqo, [
        _qo,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, pqo),
        e("polyline", {
          points: "164 116 128 156 92 116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yqo)
      ])) : o(i) === "fill" ? (s(), r("g", $qo, fqo)) : o(i) === "light" ? (s(), r("g", gqo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "12"
        }, null, 8, xqo),
        e("polyline", {
          points: "164 116 128 156 92 116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jqo)
      ])) : o(i) === "thin" ? (s(), r("g", mqo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "8"
        }, null, 8, Mqo),
        e("polyline", {
          points: "164 116 128 156 92 116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vqo)
      ])) : o(i) === "regular" ? (s(), r("g", Sqo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Hqo),
        e("polyline", {
          points: "164 116 128 156 92 116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Aqo)
      ])) : g("", !0)
    ], 16, kqo));
  }
}), zqo = ["width", "height", "fill", "transform"], Zqo = { key: 0 }, Cqo = ["stroke"], bqo = ["stroke"], Lqo = { key: 1 }, Bqo = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), Pqo = ["stroke"], Wqo = ["stroke"], Nqo = { key: 2 }, Fqo = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm21.4,134.1a8,8,0,0,1,.5,11.3A7.9,7.9,0,0,1,144,172a8.2,8.2,0,0,1-5.4-2.1l-40-36a8,8,0,0,1,0-11.8l40-36a8,8,0,1,1,10.8,11.8L116,128Z" }, null, -1), Tqo = [
  Fqo
], Dqo = { key: 3 }, Rqo = ["stroke"], Uqo = ["stroke"], qqo = { key: 4 }, Gqo = ["stroke"], Eqo = ["stroke"], Oqo = { key: 5 }, Iqo = ["stroke"], Kqo = ["stroke"], Xqo = {
  name: "PhCaretCircleLeft"
}, xU1 = /* @__PURE__ */ $({
  ...Xqo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Zqo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "24"
        }, null, 8, Cqo),
        e("polyline", {
          points: "144 92 104 128 144 164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bqo)
      ])) : o(i) === "duotone" ? (s(), r("g", Lqo, [
        Bqo,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Pqo),
        e("polyline", {
          points: "144 92 104 128 144 164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wqo)
      ])) : o(i) === "fill" ? (s(), r("g", Nqo, Tqo)) : o(i) === "light" ? (s(), r("g", Dqo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "12"
        }, null, 8, Rqo),
        e("polyline", {
          points: "144 92 104 128 144 164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Uqo)
      ])) : o(i) === "thin" ? (s(), r("g", qqo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "8"
        }, null, 8, Gqo),
        e("polyline", {
          points: "144 92 104 128 144 164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Eqo)
      ])) : o(i) === "regular" ? (s(), r("g", Oqo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Iqo),
        e("polyline", {
          points: "144 92 104 128 144 164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kqo)
      ])) : g("", !0)
    ], 16, zqo));
  }
}), Jqo = ["width", "height", "fill", "transform"], Qqo = { key: 0 }, Yqo = ["stroke"], oGo = ["stroke"], eGo = { key: 1 }, tGo = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), nGo = ["stroke"], sGo = ["stroke"], rGo = { key: 2 }, iGo = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm33.4,109.9-40,36A8.2,8.2,0,0,1,116,172a7.9,7.9,0,0,1-5.9-2.6,8,8,0,0,1,.5-11.3L144,128,110.6,97.9a8,8,0,0,1,10.8-11.8l40,36a8,8,0,0,1,0,11.8Z" }, null, -1), lGo = [
  iGo
], dGo = { key: 3 }, kGo = ["stroke"], cGo = ["stroke"], hGo = { key: 4 }, uGo = ["stroke"], aGo = ["stroke"], _Go = { key: 5 }, pGo = ["stroke"], yGo = ["stroke"], $Go = {
  name: "PhCaretCircleRight"
}, jU1 = /* @__PURE__ */ $({
  ...$Go,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Qqo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "24"
        }, null, 8, Yqo),
        e("polyline", {
          points: "116 92 156 128 116 164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oGo)
      ])) : o(i) === "duotone" ? (s(), r("g", eGo, [
        tGo,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, nGo),
        e("polyline", {
          points: "116 92 156 128 116 164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sGo)
      ])) : o(i) === "fill" ? (s(), r("g", rGo, lGo)) : o(i) === "light" ? (s(), r("g", dGo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "12"
        }, null, 8, kGo),
        e("polyline", {
          points: "116 92 156 128 116 164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cGo)
      ])) : o(i) === "thin" ? (s(), r("g", hGo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "8"
        }, null, 8, uGo),
        e("polyline", {
          points: "116 92 156 128 116 164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aGo)
      ])) : o(i) === "regular" ? (s(), r("g", _Go, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, pGo),
        e("polyline", {
          points: "116 92 156 128 116 164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yGo)
      ])) : g("", !0)
    ], 16, Jqo));
  }
}), wGo = ["width", "height", "fill", "transform"], fGo = { key: 0 }, gGo = ["stroke"], xGo = ["stroke"], jGo = { key: 1 }, mGo = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), MGo = ["stroke"], vGo = ["stroke"], SGo = { key: 2 }, HGo = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm41.4,125.9A8.2,8.2,0,0,1,164,152a7.9,7.9,0,0,1-5.9-2.6L128,116,97.9,149.4a8,8,0,0,1-11.8-10.8l36-40a8.3,8.3,0,0,1,11.8,0l36,40A8,8,0,0,1,169.4,149.9Z" }, null, -1), AGo = [
  HGo
], VGo = { key: 3 }, zGo = ["stroke"], ZGo = ["stroke"], CGo = { key: 4 }, bGo = ["stroke"], LGo = ["stroke"], BGo = { key: 5 }, PGo = ["stroke"], WGo = ["stroke"], NGo = {
  name: "PhCaretCircleUp"
}, mU1 = /* @__PURE__ */ $({
  ...NGo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", fGo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "24"
        }, null, 8, gGo),
        e("polyline", {
          points: "164 144 128 104 92 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xGo)
      ])) : o(i) === "duotone" ? (s(), r("g", jGo, [
        mGo,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, MGo),
        e("polyline", {
          points: "164 144 128 104 92 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vGo)
      ])) : o(i) === "fill" ? (s(), r("g", SGo, AGo)) : o(i) === "light" ? (s(), r("g", VGo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "12"
        }, null, 8, zGo),
        e("polyline", {
          points: "164 144 128 104 92 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZGo)
      ])) : o(i) === "thin" ? (s(), r("g", CGo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "8"
        }, null, 8, bGo),
        e("polyline", {
          points: "164 144 128 104 92 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LGo)
      ])) : o(i) === "regular" ? (s(), r("g", BGo, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, PGo),
        e("polyline", {
          points: "164 144 128 104 92 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WGo)
      ])) : g("", !0)
    ], 16, wGo));
  }
}), FGo = ["width", "height", "fill", "transform"], TGo = { key: 0 }, DGo = ["stroke"], RGo = ["stroke"], UGo = { key: 1 }, qGo = /* @__PURE__ */ e("polygon", {
  points: "208 48 128 128 48 48 208 48",
  opacity: "0.2"
}, null, -1), GGo = ["stroke"], EGo = ["stroke"], OGo = { key: 2 }, IGo = /* @__PURE__ */ e("path", { d: "M208,120H147.3l66.4-66.3a8.4,8.4,0,0,0,1.7-8.8A8,8,0,0,0,208,40H48a8,8,0,0,0-7.4,4.9,8.4,8.4,0,0,0,1.7,8.8L108.7,120H48a8,8,0,0,0-7.4,4.9,8.4,8.4,0,0,0,1.7,8.8l80,80a8.2,8.2,0,0,0,11.4,0l80-80a8.4,8.4,0,0,0,1.7-8.8A8,8,0,0,0,208,120Z" }, null, -1), KGo = [
  IGo
], XGo = { key: 3 }, JGo = ["stroke"], QGo = ["stroke"], YGo = { key: 4 }, oEo = ["stroke"], eEo = ["stroke"], tEo = { key: 5 }, nEo = ["stroke"], sEo = ["stroke"], rEo = {
  name: "PhCaretDoubleDown"
}, MU1 = /* @__PURE__ */ $({
  ...rEo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", TGo, [
        e("polyline", {
          points: "208 128 128 208 48 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DGo),
        e("polyline", {
          points: "208 48 128 128 48 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RGo)
      ])) : o(i) === "duotone" ? (s(), r("g", UGo, [
        qGo,
        e("polyline", {
          points: "208 128 128 208 48 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GGo),
        e("polygon", {
          points: "208 48 128 128 48 48 208 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EGo)
      ])) : o(i) === "fill" ? (s(), r("g", OGo, KGo)) : o(i) === "light" ? (s(), r("g", XGo, [
        e("polyline", {
          points: "208 128 128 208 48 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JGo),
        e("polyline", {
          points: "208 48 128 128 48 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QGo)
      ])) : o(i) === "thin" ? (s(), r("g", YGo, [
        e("polyline", {
          points: "208 128 128 208 48 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oEo),
        e("polyline", {
          points: "208 48 128 128 48 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eEo)
      ])) : o(i) === "regular" ? (s(), r("g", tEo, [
        e("polyline", {
          points: "208 128 128 208 48 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nEo),
        e("polyline", {
          points: "208 48 128 128 48 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sEo)
      ])) : g("", !0)
    ], 16, FGo));
  }
}), iEo = ["width", "height", "fill", "transform"], lEo = { key: 0 }, dEo = ["stroke"], kEo = ["stroke"], cEo = { key: 1 }, hEo = /* @__PURE__ */ e("polygon", {
  points: "200 208 120 128 200 48 200 208",
  opacity: "0.2"
}, null, -1), uEo = ["stroke"], aEo = ["stroke"], _Eo = { key: 2 }, pEo = /* @__PURE__ */ e("path", { d: "M203.1,40.6a8.4,8.4,0,0,0-8.8,1.7L128,108.7V48a8,8,0,0,0-4.9-7.4,8.4,8.4,0,0,0-8.8,1.7l-80,80a8.1,8.1,0,0,0,0,11.4l80,80A8.3,8.3,0,0,0,120,216a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,128,208V147.3l66.3,66.4A8.3,8.3,0,0,0,200,216a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,208,208V48A8,8,0,0,0,203.1,40.6Z" }, null, -1), yEo = [
  pEo
], $Eo = { key: 3 }, wEo = ["stroke"], fEo = ["stroke"], gEo = { key: 4 }, xEo = ["stroke"], jEo = ["stroke"], mEo = { key: 5 }, MEo = ["stroke"], vEo = ["stroke"], SEo = {
  name: "PhCaretDoubleLeft"
}, vU1 = /* @__PURE__ */ $({
  ...SEo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", lEo, [
        e("polyline", {
          points: "200 208 120 128 200 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dEo),
        e("polyline", {
          points: "120 208 40 128 120 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kEo)
      ])) : o(i) === "duotone" ? (s(), r("g", cEo, [
        hEo,
        e("polygon", {
          points: "200 208 120 128 200 48 200 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uEo),
        e("polyline", {
          points: "120 208 40 128 120 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aEo)
      ])) : o(i) === "fill" ? (s(), r("g", _Eo, yEo)) : o(i) === "light" ? (s(), r("g", $Eo, [
        e("polyline", {
          points: "200 208 120 128 200 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wEo),
        e("polyline", {
          points: "120 208 40 128 120 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fEo)
      ])) : o(i) === "thin" ? (s(), r("g", gEo, [
        e("polyline", {
          points: "200 208 120 128 200 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xEo),
        e("polyline", {
          points: "120 208 40 128 120 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jEo)
      ])) : o(i) === "regular" ? (s(), r("g", mEo, [
        e("polyline", {
          points: "200 208 120 128 200 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MEo),
        e("polyline", {
          points: "120 208 40 128 120 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vEo)
      ])) : g("", !0)
    ], 16, iEo));
  }
}), HEo = ["width", "height", "fill", "transform"], AEo = { key: 0 }, VEo = ["stroke"], zEo = ["stroke"], ZEo = { key: 1 }, CEo = /* @__PURE__ */ e("polygon", {
  points: "56 48 136 128 56 208 56 48",
  opacity: "0.2"
}, null, -1), bEo = ["stroke"], LEo = ["stroke"], BEo = { key: 2 }, PEo = /* @__PURE__ */ e("path", { d: "M221.7,122.3l-80-80a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,128,48v60.7L61.7,42.3a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,48,48V208a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3L128,147.3V208a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l80-80A8.1,8.1,0,0,0,221.7,122.3Z" }, null, -1), WEo = [
  PEo
], NEo = { key: 3 }, FEo = ["stroke"], TEo = ["stroke"], DEo = { key: 4 }, REo = ["stroke"], UEo = ["stroke"], qEo = { key: 5 }, GEo = ["stroke"], EEo = ["stroke"], OEo = {
  name: "PhCaretDoubleRight"
}, SU1 = /* @__PURE__ */ $({
  ...OEo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", AEo, [
        e("polyline", {
          points: "56 48 136 128 56 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VEo),
        e("polyline", {
          points: "136 48 216 128 136 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zEo)
      ])) : o(i) === "duotone" ? (s(), r("g", ZEo, [
        CEo,
        e("polygon", {
          points: "56 48 136 128 56 208 56 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bEo),
        e("polyline", {
          points: "136 48 216 128 136 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LEo)
      ])) : o(i) === "fill" ? (s(), r("g", BEo, WEo)) : o(i) === "light" ? (s(), r("g", NEo, [
        e("polyline", {
          points: "56 48 136 128 56 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FEo),
        e("polyline", {
          points: "136 48 216 128 136 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TEo)
      ])) : o(i) === "thin" ? (s(), r("g", DEo, [
        e("polyline", {
          points: "56 48 136 128 56 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, REo),
        e("polyline", {
          points: "136 48 216 128 136 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, UEo)
      ])) : o(i) === "regular" ? (s(), r("g", qEo, [
        e("polyline", {
          points: "56 48 136 128 56 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GEo),
        e("polyline", {
          points: "136 48 216 128 136 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EEo)
      ])) : g("", !0)
    ], 16, HEo));
  }
}), IEo = ["width", "height", "fill", "transform"], KEo = { key: 0 }, XEo = ["stroke"], JEo = ["stroke"], QEo = { key: 1 }, YEo = /* @__PURE__ */ e("polygon", {
  points: "48 208 128 128 208 208 48 208",
  opacity: "0.2"
}, null, -1), oOo = ["stroke"], eOo = ["stroke"], tOo = { key: 2 }, nOo = /* @__PURE__ */ e("path", { d: "M147.3,136H208a8,8,0,0,0,7.4-4.9,8.4,8.4,0,0,0-1.7-8.8l-80-80a8.1,8.1,0,0,0-11.4,0l-80,80a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,48,136h60.7L42.3,202.3a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,48,216H208a8,8,0,0,0,7.4-4.9,8.4,8.4,0,0,0-1.7-8.8Z" }, null, -1), sOo = [
  nOo
], rOo = { key: 3 }, iOo = ["stroke"], lOo = ["stroke"], dOo = { key: 4 }, kOo = ["stroke"], cOo = ["stroke"], hOo = { key: 5 }, uOo = ["stroke"], aOo = ["stroke"], _Oo = {
  name: "PhCaretDoubleUp"
}, HU1 = /* @__PURE__ */ $({
  ..._Oo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", KEo, [
        e("polyline", {
          points: "48 208 128 128 208 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XEo),
        e("polyline", {
          points: "48 128 128 48 208 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, JEo)
      ])) : o(i) === "duotone" ? (s(), r("g", QEo, [
        YEo,
        e("polygon", {
          points: "48 208 128 128 208 208 48 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oOo),
        e("polyline", {
          points: "48 128 128 48 208 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eOo)
      ])) : o(i) === "fill" ? (s(), r("g", tOo, sOo)) : o(i) === "light" ? (s(), r("g", rOo, [
        e("polyline", {
          points: "48 208 128 128 208 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iOo),
        e("polyline", {
          points: "48 128 128 48 208 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lOo)
      ])) : o(i) === "thin" ? (s(), r("g", dOo, [
        e("polyline", {
          points: "48 208 128 128 208 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kOo),
        e("polyline", {
          points: "48 128 128 48 208 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cOo)
      ])) : o(i) === "regular" ? (s(), r("g", hOo, [
        e("polyline", {
          points: "48 208 128 128 208 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uOo),
        e("polyline", {
          points: "48 128 128 48 208 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aOo)
      ])) : g("", !0)
    ], 16, IEo));
  }
}), pOo = ["width", "height", "fill", "transform"], yOo = { key: 0 }, $Oo = ["stroke"], wOo = { key: 1 }, fOo = /* @__PURE__ */ e("polygon", {
  points: "208 96 128 176 48 96 208 96",
  opacity: "0.2"
}, null, -1), gOo = ["stroke"], xOo = { key: 2 }, jOo = /* @__PURE__ */ e("path", { d: "M215.4,92.9A8,8,0,0,0,208,88H48a8,8,0,0,0-7.4,4.9,8.4,8.4,0,0,0,1.7,8.8l80,80a8.2,8.2,0,0,0,11.4,0l80-80A8.4,8.4,0,0,0,215.4,92.9Z" }, null, -1), mOo = [
  jOo
], MOo = { key: 3 }, vOo = ["stroke"], SOo = { key: 4 }, HOo = ["stroke"], AOo = { key: 5 }, VOo = ["stroke"], zOo = {
  name: "PhCaretDown"
}, AU1 = /* @__PURE__ */ $({
  ...zOo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", yOo, [
        e("polyline", {
          points: "208 96 128 176 48 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $Oo)
      ])) : o(i) === "duotone" ? (s(), r("g", wOo, [
        fOo,
        e("polygon", {
          points: "208 96 128 176 48 96 208 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gOo)
      ])) : o(i) === "fill" ? (s(), r("g", xOo, mOo)) : o(i) === "light" ? (s(), r("g", MOo, [
        e("polyline", {
          points: "208 96 128 176 48 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vOo)
      ])) : o(i) === "thin" ? (s(), r("g", SOo, [
        e("polyline", {
          points: "208 96 128 176 48 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HOo)
      ])) : o(i) === "regular" ? (s(), r("g", AOo, [
        e("polyline", {
          points: "208 96 128 176 48 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VOo)
      ])) : g("", !0)
    ], 16, pOo));
  }
}), ZOo = ["width", "height", "fill", "transform"], COo = { key: 0 }, bOo = ["stroke"], LOo = { key: 1 }, BOo = /* @__PURE__ */ e("polygon", {
  points: "160 208 80 128 160 48 160 208",
  opacity: "0.2"
}, null, -1), POo = ["stroke"], WOo = { key: 2 }, NOo = /* @__PURE__ */ e("path", { d: "M163.1,40.6a8.4,8.4,0,0,0-8.8,1.7l-80,80a8.1,8.1,0,0,0,0,11.4l80,80A8.3,8.3,0,0,0,160,216a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,168,208V48A8,8,0,0,0,163.1,40.6Z" }, null, -1), FOo = [
  NOo
], TOo = { key: 3 }, DOo = ["stroke"], ROo = { key: 4 }, UOo = ["stroke"], qOo = { key: 5 }, GOo = ["stroke"], EOo = {
  name: "PhCaretLeft"
}, VU1 = /* @__PURE__ */ $({
  ...EOo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", COo, [
        e("polyline", {
          points: "160 208 80 128 160 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bOo)
      ])) : o(i) === "duotone" ? (s(), r("g", LOo, [
        BOo,
        e("polygon", {
          points: "160 208 80 128 160 48 160 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, POo)
      ])) : o(i) === "fill" ? (s(), r("g", WOo, FOo)) : o(i) === "light" ? (s(), r("g", TOo, [
        e("polyline", {
          points: "160 208 80 128 160 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DOo)
      ])) : o(i) === "thin" ? (s(), r("g", ROo, [
        e("polyline", {
          points: "160 208 80 128 160 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, UOo)
      ])) : o(i) === "regular" ? (s(), r("g", qOo, [
        e("polyline", {
          points: "160 208 80 128 160 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GOo)
      ])) : g("", !0)
    ], 16, ZOo));
  }
}), OOo = ["width", "height", "fill", "transform"], IOo = { key: 0 }, KOo = ["stroke"], XOo = { key: 1 }, JOo = /* @__PURE__ */ e("polygon", {
  points: "96 48 176 128 96 208 96 48",
  opacity: "0.2"
}, null, -1), QOo = ["stroke"], YOo = { key: 2 }, oIo = /* @__PURE__ */ e("path", { d: "M181.7,122.3l-80-80a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,88,48V208a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l80-80A8.1,8.1,0,0,0,181.7,122.3Z" }, null, -1), eIo = [
  oIo
], tIo = { key: 3 }, nIo = ["stroke"], sIo = { key: 4 }, rIo = ["stroke"], iIo = { key: 5 }, lIo = ["stroke"], dIo = {
  name: "PhCaretRight"
}, zU1 = /* @__PURE__ */ $({
  ...dIo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", IOo, [
        e("polyline", {
          points: "96 48 176 128 96 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KOo)
      ])) : o(i) === "duotone" ? (s(), r("g", XOo, [
        JOo,
        e("polygon", {
          points: "96 48 176 128 96 208 96 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QOo)
      ])) : o(i) === "fill" ? (s(), r("g", YOo, eIo)) : o(i) === "light" ? (s(), r("g", tIo, [
        e("polyline", {
          points: "96 48 176 128 96 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nIo)
      ])) : o(i) === "thin" ? (s(), r("g", sIo, [
        e("polyline", {
          points: "96 48 176 128 96 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rIo)
      ])) : o(i) === "regular" ? (s(), r("g", iIo, [
        e("polyline", {
          points: "96 48 176 128 96 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lIo)
      ])) : g("", !0)
    ], 16, OOo));
  }
}), kIo = ["width", "height", "fill", "transform"], cIo = { key: 0 }, hIo = ["stroke"], uIo = { key: 1 }, aIo = /* @__PURE__ */ e("polygon", {
  points: "48 160 128 80 208 160 48 160",
  opacity: "0.2"
}, null, -1), _Io = ["stroke"], pIo = { key: 2 }, yIo = /* @__PURE__ */ e("path", { d: "M213.7,154.3l-80-80a8.1,8.1,0,0,0-11.4,0l-80,80a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,48,168H208a8,8,0,0,0,7.4-4.9A8.4,8.4,0,0,0,213.7,154.3Z" }, null, -1), $Io = [
  yIo
], wIo = { key: 3 }, fIo = ["stroke"], gIo = { key: 4 }, xIo = ["stroke"], jIo = { key: 5 }, mIo = ["stroke"], MIo = {
  name: "PhCaretUp"
}, ZU1 = /* @__PURE__ */ $({
  ...MIo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", cIo, [
        e("polyline", {
          points: "48 160 128 80 208 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hIo)
      ])) : o(i) === "duotone" ? (s(), r("g", uIo, [
        aIo,
        e("polygon", {
          points: "48 160 128 80 208 160 48 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Io)
      ])) : o(i) === "fill" ? (s(), r("g", pIo, $Io)) : o(i) === "light" ? (s(), r("g", wIo, [
        e("polyline", {
          points: "48 160 128 80 208 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fIo)
      ])) : o(i) === "thin" ? (s(), r("g", gIo, [
        e("polyline", {
          points: "48 160 128 80 208 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xIo)
      ])) : o(i) === "regular" ? (s(), r("g", jIo, [
        e("polyline", {
          points: "48 160 128 80 208 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mIo)
      ])) : g("", !0)
    ], 16, kIo));
  }
}), vIo = ["width", "height", "fill", "transform"], SIo = { key: 0 }, HIo = ["stroke"], AIo = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "140",
  r: "16"
}, null, -1), VIo = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "140",
  r: "16"
}, null, -1), zIo = ["stroke"], ZIo = ["stroke"], CIo = ["stroke"], bIo = ["stroke"], LIo = { key: 1 }, BIo = /* @__PURE__ */ e("path", {
  d: "M32,136V51.3a8,8,0,0,1,13.7-5.6L67.6,67.6h0A100.8,100.8,0,0,1,128,48a100.8,100.8,0,0,1,60.4,19.6h0l21.9-21.9A8,8,0,0,1,224,51.3V136c0,48.6-43,88-96,88S32,184.6,32,136Z",
  opacity: "0.2"
}, null, -1), PIo = ["stroke"], WIo = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "140",
  r: "12"
}, null, -1), NIo = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "140",
  r: "12"
}, null, -1), FIo = ["stroke"], TIo = ["stroke"], DIo = ["stroke"], RIo = ["stroke"], UIo = ["stroke"], qIo = { key: 2 }, GIo = /* @__PURE__ */ e("path", { d: "M221.4,36.3a16.3,16.3,0,0,0-17,4L187.5,57.2a111.5,111.5,0,0,0-119,0L51.6,40.3a16.3,16.3,0,0,0-17-4A15.9,15.9,0,0,0,24,51.3V136c0,49.1,40.1,89.6,91.6,95.3a4,4,0,0,0,4.4-4v-32l-13.4-13.4a8.3,8.3,0,0,1-.4-11.4,8.1,8.1,0,0,1,11.5-.2L128,180.7l10.3-10.4a8.1,8.1,0,0,1,11.5.2,8.3,8.3,0,0,1-.4,11.4L136,195.3v32a4,4,0,0,0,4.4,4c51.5-5.7,91.6-46.2,91.6-95.3V51.3A15.9,15.9,0,0,0,221.4,36.3ZM84,152a12,12,0,1,1,12-12A12,12,0,0,1,84,152Zm20-64a8,8,0,0,1-16,0V69a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V64a8,8,0,0,1,16,0Zm16,0V69a8,8,0,0,1,16,0V88a8,8,0,0,1-16,0Zm20,64a12,12,0,1,1,12-12A12,12,0,0,1,172,152Z" }, null, -1), EIo = [
  GIo
], OIo = { key: 3 }, IIo = ["stroke"], KIo = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "140",
  r: "10"
}, null, -1), XIo = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "140",
  r: "10"
}, null, -1), JIo = ["stroke"], QIo = ["stroke"], YIo = ["stroke"], oKo = ["stroke"], eKo = ["stroke"], tKo = { key: 4 }, nKo = ["stroke"], sKo = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "140",
  r: "8"
}, null, -1), rKo = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "140",
  r: "8"
}, null, -1), iKo = ["stroke"], lKo = ["stroke"], dKo = ["stroke"], kKo = ["stroke"], cKo = ["stroke"], hKo = { key: 5 }, uKo = ["stroke"], aKo = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "140",
  r: "12"
}, null, -1), _Ko = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "140",
  r: "12"
}, null, -1), pKo = ["stroke"], yKo = ["stroke"], $Ko = ["stroke"], wKo = ["stroke"], fKo = ["stroke"], gKo = {
  name: "PhCat"
}, CU1 = /* @__PURE__ */ $({
  ...gKo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", SIo, [
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HIo),
        AIo,
        VIo,
        e("polyline", {
          points: "144 176 128 192 112 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zIo),
        e("path", {
          d: "M32,136V51.3a8,8,0,0,1,13.7-5.6L67.6,67.6h0A100.8,100.8,0,0,1,128,48a100.8,100.8,0,0,1,60.4,19.6h0l21.9-21.9A8,8,0,0,1,224,51.3V136c0,48.6-43,88-96,88S32,184.6,32,136Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZIo),
        e("line", {
          x1: "108",
          y1: "49.9",
          x2: "108",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CIo),
        e("line", {
          x1: "148",
          y1: "49.9",
          x2: "148",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bIo)
      ])) : o(i) === "duotone" ? (s(), r("g", LIo, [
        BIo,
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PIo),
        WIo,
        NIo,
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FIo),
        e("polyline", {
          points: "144 176 128 192 112 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TIo),
        e("line", {
          x1: "96",
          y1: "53",
          x2: "96",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DIo),
        e("line", {
          x1: "160",
          y1: "53",
          x2: "160",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RIo),
        e("path", {
          d: "M32,136V51.3a8,8,0,0,1,13.7-5.6L67.6,67.6h0A100.8,100.8,0,0,1,128,48a100.8,100.8,0,0,1,60.4,19.6h0l21.9-21.9A8,8,0,0,1,224,51.3V136c0,48.6-43,88-96,88S32,184.6,32,136Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UIo)
      ])) : o(i) === "fill" ? (s(), r("g", qIo, EIo)) : o(i) === "light" ? (s(), r("g", OIo, [
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IIo),
        KIo,
        XIo,
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JIo),
        e("polyline", {
          points: "144 176 128 192 112 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QIo),
        e("line", {
          x1: "96",
          y1: "53",
          x2: "96",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YIo),
        e("line", {
          x1: "160",
          y1: "53",
          x2: "160",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oKo),
        e("path", {
          d: "M32,136V51.3a8,8,0,0,1,13.7-5.6L67.6,67.6h0A100.8,100.8,0,0,1,128,48a100.8,100.8,0,0,1,60.4,19.6h0l21.9-21.9A8,8,0,0,1,224,51.3V136c0,48.6-43,88-96,88S32,184.6,32,136Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eKo)
      ])) : o(i) === "thin" ? (s(), r("g", tKo, [
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nKo),
        sKo,
        rKo,
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iKo),
        e("polyline", {
          points: "144 176 128 192 112 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lKo),
        e("line", {
          x1: "96",
          y1: "53",
          x2: "96",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dKo),
        e("line", {
          x1: "160",
          y1: "53",
          x2: "160",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kKo),
        e("path", {
          d: "M32,136V51.3a8,8,0,0,1,13.7-5.6L67.6,67.6h0A100.8,100.8,0,0,1,128,48a100.8,100.8,0,0,1,60.4,19.6h0l21.9-21.9A8,8,0,0,1,224,51.3V136c0,48.6-43,88-96,88S32,184.6,32,136Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cKo)
      ])) : o(i) === "regular" ? (s(), r("g", hKo, [
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uKo),
        aKo,
        _Ko,
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pKo),
        e("polyline", {
          points: "144 176 128 192 112 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yKo),
        e("line", {
          x1: "96",
          y1: "53",
          x2: "96",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Ko),
        e("line", {
          x1: "160",
          y1: "53",
          x2: "160",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wKo),
        e("path", {
          d: "M32,136V51.3a8,8,0,0,1,13.7-5.6L67.6,67.6h0A100.8,100.8,0,0,1,128,48a100.8,100.8,0,0,1,60.4,19.6h0l21.9-21.9A8,8,0,0,1,224,51.3V136c0,48.6-43,88-96,88S32,184.6,32,136Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fKo)
      ])) : g("", !0)
    ], 16, vIo));
  }
}), xKo = ["width", "height", "fill", "transform"], jKo = { key: 0 }, mKo = ["stroke"], MKo = ["stroke"], vKo = ["stroke"], SKo = ["stroke"], HKo = { key: 1 }, AKo = /* @__PURE__ */ e("path", {
  d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
  opacity: "0.2"
}, null, -1), VKo = ["stroke"], zKo = { key: 2 }, ZKo = /* @__PURE__ */ e("path", { d: "M198.1,28.5A15.9,15.9,0,0,0,180.7,32L16,196.7A16,16,0,0,0,27.3,224H192a16,16,0,0,0,16-16V43.3A16,16,0,0,0,198.1,28.5Z" }, null, -1), CKo = [
  ZKo
], bKo = { key: 3 }, LKo = ["stroke"], BKo = ["stroke"], PKo = ["stroke"], WKo = ["stroke"], NKo = { key: 4 }, FKo = ["stroke"], TKo = ["stroke"], DKo = ["stroke"], RKo = ["stroke"], UKo = { key: 5 }, qKo = ["stroke"], GKo = ["stroke"], EKo = ["stroke"], OKo = ["stroke"], IKo = {
  name: "PhCellSignalFull"
}, bU1 = /* @__PURE__ */ $({
  ...IKo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", jKo, [
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mKo),
        e("line", {
          x1: "160",
          y1: "64",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MKo),
        e("line", {
          x1: "120",
          y1: "104",
          x2: "120",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vKo),
        e("line", {
          x1: "80",
          y1: "144",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SKo)
      ])) : o(i) === "duotone" ? (s(), r("g", HKo, [
        AKo,
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VKo)
      ])) : o(i) === "fill" ? (s(), r("g", zKo, CKo)) : o(i) === "light" ? (s(), r("g", bKo, [
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LKo),
        e("line", {
          x1: "160",
          y1: "64",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BKo),
        e("line", {
          x1: "120",
          y1: "104",
          x2: "120",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PKo),
        e("line", {
          x1: "80",
          y1: "144",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WKo)
      ])) : o(i) === "thin" ? (s(), r("g", NKo, [
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FKo),
        e("line", {
          x1: "160",
          y1: "64",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, TKo),
        e("line", {
          x1: "120",
          y1: "104",
          x2: "120",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, DKo),
        e("line", {
          x1: "80",
          y1: "144",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RKo)
      ])) : o(i) === "regular" ? (s(), r("g", UKo, [
        e("line", {
          x1: "160",
          y1: "64",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qKo),
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GKo),
        e("line", {
          x1: "120",
          y1: "104",
          x2: "120",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EKo),
        e("line", {
          x1: "80",
          y1: "144",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OKo)
      ])) : g("", !0)
    ], 16, xKo));
  }
}), KKo = ["width", "height", "fill", "transform"], XKo = { key: 0 }, JKo = ["stroke"], QKo = ["stroke"], YKo = { key: 1 }, oXo = /* @__PURE__ */ e("path", {
  d: "M160,216H27.3a8,8,0,0,1-5.6-13.7L160,64Z",
  opacity: "0.2"
}, null, -1), eXo = ["stroke"], tXo = ["stroke"], nXo = { key: 2 }, sXo = /* @__PURE__ */ e("path", { d: "M198.1,28.5A15.9,15.9,0,0,0,180.7,32L16,196.7a15.7,15.7,0,0,0-4.7,11.6,4.9,4.9,0,0,0,.1,1.2,14.7,14.7,0,0,0,1.1,4.6,16,16,0,0,0,6.9,7.8l1,.6,2.2.8a14.9,14.9,0,0,0,4.7.7H192a16,16,0,0,0,16-16V43.3A16,16,0,0,0,198.1,28.5ZM192,208H168V67.3l24-24Z" }, null, -1), rXo = [
  sXo
], iXo = { key: 3 }, lXo = ["stroke"], dXo = ["stroke"], kXo = { key: 4 }, cXo = ["stroke"], hXo = ["stroke"], uXo = { key: 5 }, aXo = ["stroke"], _Xo = ["stroke"], pXo = {
  name: "PhCellSignalHigh"
}, LU1 = /* @__PURE__ */ $({
  ...pXo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", XKo, [
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, JKo),
        e("line", {
          x1: "160",
          y1: "64",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, QKo)
      ])) : o(i) === "duotone" ? (s(), r("g", YKo, [
        oXo,
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eXo),
        e("line", {
          x1: "160",
          y1: "64",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tXo)
      ])) : o(i) === "fill" ? (s(), r("g", nXo, rXo)) : o(i) === "light" ? (s(), r("g", iXo, [
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lXo),
        e("line", {
          x1: "160",
          y1: "64",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dXo)
      ])) : o(i) === "thin" ? (s(), r("g", kXo, [
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cXo),
        e("line", {
          x1: "160",
          y1: "64",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hXo)
      ])) : o(i) === "regular" ? (s(), r("g", uXo, [
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aXo),
        e("line", {
          x1: "160",
          y1: "64",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Xo)
      ])) : g("", !0)
    ], 16, KKo));
  }
}), yXo = ["width", "height", "fill", "transform"], $Xo = { key: 0 }, wXo = ["stroke"], fXo = ["stroke"], gXo = { key: 1 }, xXo = /* @__PURE__ */ e("path", {
  d: "M80,216H27.3a8,8,0,0,1-5.6-13.7L80,144Z",
  opacity: "0.2"
}, null, -1), jXo = ["stroke"], mXo = ["stroke"], MXo = { key: 2 }, vXo = /* @__PURE__ */ e("path", { d: "M198.1,28.5A15.9,15.9,0,0,0,180.7,32L74.3,138.3h0L16,196.7A16,16,0,0,0,27.3,224H192a16,16,0,0,0,16-16V43.3A16,16,0,0,0,198.1,28.5ZM192,208H88V147.3l104-104Z" }, null, -1), SXo = [
  vXo
], HXo = { key: 3 }, AXo = ["stroke"], VXo = ["stroke"], zXo = { key: 4 }, ZXo = ["stroke"], CXo = ["stroke"], bXo = { key: 5 }, LXo = ["stroke"], BXo = ["stroke"], PXo = {
  name: "PhCellSignalLow"
}, BU1 = /* @__PURE__ */ $({
  ...PXo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $Xo, [
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wXo),
        e("line", {
          x1: "80",
          y1: "144",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fXo)
      ])) : o(i) === "duotone" ? (s(), r("g", gXo, [
        xXo,
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jXo),
        e("line", {
          x1: "80",
          y1: "144",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mXo)
      ])) : o(i) === "fill" ? (s(), r("g", MXo, SXo)) : o(i) === "light" ? (s(), r("g", HXo, [
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, AXo),
        e("line", {
          x1: "80",
          y1: "144",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VXo)
      ])) : o(i) === "thin" ? (s(), r("g", zXo, [
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZXo),
        e("line", {
          x1: "80",
          y1: "144",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CXo)
      ])) : o(i) === "regular" ? (s(), r("g", bXo, [
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LXo),
        e("line", {
          x1: "80",
          y1: "144",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BXo)
      ])) : g("", !0)
    ], 16, yXo));
  }
}), WXo = ["width", "height", "fill", "transform"], NXo = { key: 0 }, FXo = ["stroke"], TXo = ["stroke"], DXo = { key: 1 }, RXo = /* @__PURE__ */ e("path", {
  d: "M120,216H27.3a8,8,0,0,1-5.6-13.7L120,104Z",
  opacity: "0.2"
}, null, -1), UXo = ["stroke"], qXo = ["stroke"], GXo = { key: 2 }, EXo = /* @__PURE__ */ e("path", { d: "M198.1,28.5A15.9,15.9,0,0,0,180.7,32L114.3,98.3h0L16,196.7a15.7,15.7,0,0,0-4.7,11.6,4.9,4.9,0,0,0,.1,1.2,14.7,14.7,0,0,0,1.1,4.6,16,16,0,0,0,6.9,7.8l1,.6,2.2.8a14.9,14.9,0,0,0,4.7.7H192a16,16,0,0,0,16-16V43.3A16,16,0,0,0,198.1,28.5ZM192,208H128V107.3l64-64Z" }, null, -1), OXo = [
  EXo
], IXo = { key: 3 }, KXo = ["stroke"], XXo = ["stroke"], JXo = { key: 4 }, QXo = ["stroke"], YXo = ["stroke"], oJo = { key: 5 }, eJo = ["stroke"], tJo = ["stroke"], nJo = {
  name: "PhCellSignalMedium"
}, PU1 = /* @__PURE__ */ $({
  ...nJo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", NXo, [
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FXo),
        e("line", {
          x1: "120",
          y1: "104",
          x2: "120",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TXo)
      ])) : o(i) === "duotone" ? (s(), r("g", DXo, [
        RXo,
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UXo),
        e("line", {
          x1: "120",
          y1: "104",
          x2: "120",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qXo)
      ])) : o(i) === "fill" ? (s(), r("g", GXo, OXo)) : o(i) === "light" ? (s(), r("g", IXo, [
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KXo),
        e("line", {
          x1: "120",
          y1: "104",
          x2: "120",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XXo)
      ])) : o(i) === "thin" ? (s(), r("g", JXo, [
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QXo),
        e("line", {
          x1: "120",
          y1: "104",
          x2: "120",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YXo)
      ])) : o(i) === "regular" ? (s(), r("g", oJo, [
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eJo),
        e("line", {
          x1: "120",
          y1: "104",
          x2: "120",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tJo)
      ])) : g("", !0)
    ], 16, WXo));
  }
}), sJo = ["width", "height", "fill", "transform"], rJo = { key: 0 }, iJo = ["stroke"], lJo = { key: 1 }, dJo = ["stroke"], kJo = { key: 2 }, cJo = /* @__PURE__ */ e("path", { d: "M192,224H27.3A16,16,0,0,1,16,196.7L180.7,32A16,16,0,0,1,208,43.3V208A16,16,0,0,1,192,224ZM27.3,208H192V43.3L27.3,208Z" }, null, -1), hJo = [
  cJo
], uJo = { key: 3 }, aJo = ["stroke"], _Jo = { key: 4 }, pJo = ["stroke"], yJo = { key: 5 }, $Jo = ["stroke"], wJo = {
  name: "PhCellSignalNone"
}, WU1 = /* @__PURE__ */ $({
  ...wJo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", rJo, [
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iJo)
      ])) : o(i) === "duotone" ? (s(), r("g", lJo, [
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dJo)
      ])) : o(i) === "fill" ? (s(), r("g", kJo, hJo)) : o(i) === "light" ? (s(), r("g", uJo, [
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aJo)
      ])) : o(i) === "thin" ? (s(), r("g", _Jo, [
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pJo)
      ])) : o(i) === "regular" ? (s(), r("g", yJo, [
        e("path", {
          d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Jo)
      ])) : g("", !0)
    ], 16, sJo));
  }
}), fJo = ["width", "height", "fill", "transform"], gJo = { key: 0 }, xJo = ["stroke"], jJo = ["stroke"], mJo = ["stroke"], MJo = { key: 1 }, vJo = /* @__PURE__ */ e("path", {
  d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a7.9,7.9,0,0,1-5.6-13.6L186.3,37.7A8,8,0,0,1,200,43.3Z",
  opacity: "0.2"
}, null, -1), SJo = ["stroke"], HJo = ["stroke"], AJo = ["stroke"], VJo = { key: 2 }, zJo = /* @__PURE__ */ e("path", { d: "M129.5,94a8,8,0,0,1,.3-11.1L180.7,32A16,16,0,0,1,208,43.3V159.6a8,8,0,0,1-5.1,7.5,7.4,7.4,0,0,1-2.9.5,7.9,7.9,0,0,1-5.9-2.6Zm84.4,116.6-160-176a8,8,0,0,0-11.3-.5,7.9,7.9,0,0,0-.5,11.3L101.7,111,16,196.7A16,16,0,0,0,27.3,224H208a8.2,8.2,0,0,0,5.4-2.1A8,8,0,0,0,213.9,210.6Z" }, null, -1), ZJo = [
  zJo
], CJo = { key: 3 }, bJo = ["stroke"], LJo = ["stroke"], BJo = ["stroke"], PJo = { key: 4 }, WJo = ["stroke"], NJo = ["stroke"], FJo = ["stroke"], TJo = { key: 5 }, DJo = ["stroke"], RJo = ["stroke"], UJo = ["stroke"], qJo = {
  name: "PhCellSignalSlash"
}, NU1 = /* @__PURE__ */ $({
  ...qJo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", gJo, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xJo),
        e("path", {
          d: "M208,216H27.3a8,8,0,0,1-5.6-13.7l91.1-91.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jJo),
        e("path", {
          d: "M141.1,82.9l45.2-45.2A8,8,0,0,1,200,43.3V147.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mJo)
      ])) : o(i) === "duotone" ? (s(), r("g", MJo, [
        vJo,
        e("path", {
          d: "M135.4,88.6l50.9-50.9A8,8,0,0,1,200,43.3V159.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SJo),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HJo),
        e("path", {
          d: "M208,216H27.3a8,8,0,0,1-5.6-13.7l91.1-91.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AJo)
      ])) : o(i) === "fill" ? (s(), r("g", VJo, ZJo)) : o(i) === "light" ? (s(), r("g", CJo, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bJo),
        e("path", {
          d: "M135.4,88.6l50.9-50.9A8,8,0,0,1,200,43.3V159.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LJo),
        e("path", {
          d: "M208,216H27.3a8,8,0,0,1-5.6-13.7l91.1-91.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BJo)
      ])) : o(i) === "thin" ? (s(), r("g", PJo, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WJo),
        e("path", {
          d: "M135.4,88.6l50.9-50.9A8,8,0,0,1,200,43.3V159.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, NJo),
        e("path", {
          d: "M208,216H27.3a8,8,0,0,1-5.6-13.7l91.1-91.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FJo)
      ])) : o(i) === "regular" ? (s(), r("g", TJo, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DJo),
        e("path", {
          d: "M135.4,88.6l50.9-50.9A8,8,0,0,1,200,43.3V159.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RJo),
        e("path", {
          d: "M208,216H27.3a8,8,0,0,1-5.6-13.7l91.1-91.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UJo)
      ])) : g("", !0)
    ], 16, fJo));
  }
}), GJo = ["width", "height", "fill", "transform"], EJo = { key: 0 }, OJo = ["stroke"], IJo = ["stroke"], KJo = ["stroke"], XJo = { key: 1 }, JJo = /* @__PURE__ */ e("path", {
  d: "M200,43.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3Z",
  opacity: "0.2"
}, null, -1), QJo = ["stroke"], YJo = ["stroke"], oQo = ["stroke"], eQo = { key: 2 }, tQo = /* @__PURE__ */ e("path", { d: "M229.7,146.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0L200,139.3l-18.3,18.4a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L188.7,128l-18.4-18.3a8.1,8.1,0,0,1,11.4-11.4L200,116.7l18.3-18.4a8.1,8.1,0,0,1,11.4,11.4L211.3,128Zm-26.9,18.5a3.9,3.9,0,0,0-5.6,0L193,169a24,24,0,0,1-17,7,23.6,23.6,0,0,1-17.2-7.3c-9.2-9.5-8.7-24.7.6-34.1l6.7-6.6-6.7-6.6c-9.5-9.6-9.7-25.4,0-34.7A24.1,24.1,0,0,1,193,87l4.2,4.2a3.9,3.9,0,0,0,5.6,0L207,87h0a2.9,2.9,0,0,0,1-2.3V43.8a16.6,16.6,0,0,0-9.2-15A15.9,15.9,0,0,0,180.7,32L16.3,196.4a16.3,16.3,0,0,0-4,17,15.9,15.9,0,0,0,15,10.6H192a16,16,0,0,0,16-16V171.2a3,3,0,0,0-1-2.2h0Z" }, null, -1), nQo = [
  tQo
], sQo = { key: 3 }, rQo = ["stroke"], iQo = ["stroke"], lQo = ["stroke"], dQo = { key: 4 }, kQo = ["stroke"], cQo = ["stroke"], hQo = ["stroke"], uQo = { key: 5 }, aQo = ["stroke"], _Qo = ["stroke"], pQo = ["stroke"], yQo = {
  name: "PhCellSignalX"
}, FU1 = /* @__PURE__ */ $({
  ...yQo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", EJo, [
        e("line", {
          x1: "224",
          y1: "104",
          x2: "176",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OJo),
        e("line", {
          x1: "224",
          y1: "152",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IJo),
        e("path", {
          d: "M200,184v24a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KJo)
      ])) : o(i) === "duotone" ? (s(), r("g", XJo, [
        JJo,
        e("line", {
          x1: "224",
          y1: "104",
          x2: "176",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QJo),
        e("line", {
          x1: "224",
          y1: "152",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YJo),
        e("path", {
          d: "M200,173.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3V82.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oQo)
      ])) : o(i) === "fill" ? (s(), r("g", eQo, nQo)) : o(i) === "light" ? (s(), r("g", sQo, [
        e("line", {
          x1: "224",
          y1: "104",
          x2: "176",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rQo),
        e("line", {
          x1: "224",
          y1: "152",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iQo),
        e("path", {
          d: "M200,173.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3V82.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lQo)
      ])) : o(i) === "thin" ? (s(), r("g", dQo, [
        e("line", {
          x1: "224",
          y1: "104",
          x2: "176",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kQo),
        e("line", {
          x1: "224",
          y1: "152",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cQo),
        e("path", {
          d: "M200,173.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3V82.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hQo)
      ])) : o(i) === "regular" ? (s(), r("g", uQo, [
        e("line", {
          x1: "224",
          y1: "104",
          x2: "176",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aQo),
        e("line", {
          x1: "224",
          y1: "152",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Qo),
        e("path", {
          d: "M200,173.3V208a8,8,0,0,1-8,8H27.3a8,8,0,0,1-5.6-13.7L186.3,37.7A8,8,0,0,1,200,43.3V82.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pQo)
      ])) : g("", !0)
    ], 16, GJo));
  }
}), $Qo = ["width", "height", "fill", "transform"], wQo = { key: 0 }, fQo = ["stroke"], gQo = ["stroke"], xQo = ["stroke"], jQo = ["stroke"], mQo = { key: 1 }, MQo = /* @__PURE__ */ e("polygon", {
  points: "120 168 192 168 192 80 64 80 64 200 120 200 120 168",
  opacity: "0.2"
}, null, -1), vQo = ["stroke"], SQo = ["stroke"], HQo = ["stroke"], AQo = ["stroke"], VQo = { key: 2 }, zQo = /* @__PURE__ */ e("path", { d: "M240,192h-8V56a16,16,0,0,0-16-16H40A16,16,0,0,0,24,56V192H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Zm-24,0H144V176a8,8,0,0,1,8-8h56a8,8,0,0,1,8,8Zm0-48a8,8,0,0,1-16,0V72H56V184a8,8,0,0,1-16,0V64a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8Z" }, null, -1), ZQo = [
  zQo
], CQo = { key: 3 }, bQo = ["stroke"], LQo = ["stroke"], BQo = ["stroke"], PQo = ["stroke"], WQo = { key: 4 }, NQo = ["stroke"], FQo = ["stroke"], TQo = ["stroke"], DQo = ["stroke"], RQo = { key: 5 }, UQo = ["stroke"], qQo = ["stroke"], GQo = ["stroke"], EQo = ["stroke"], OQo = {
  name: "PhChalkboard"
}, TU1 = /* @__PURE__ */ $({
  ...OQo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", wQo, [
        e("path", {
          d: "M32,200V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fQo),
        e("line", {
          x1: "16",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gQo),
        e("polyline", {
          points: "120 200 120 160 184 160 184 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xQo),
        e("polyline", {
          points: "72 200 72 88 184 88 184 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jQo)
      ])) : o(i) === "duotone" ? (s(), r("g", mQo, [
        MQo,
        e("path", {
          d: "M32,200V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vQo),
        e("line", {
          x1: "16",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SQo),
        e("polyline", {
          points: "120 200 120 168 192 168 192 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HQo),
        e("polyline", {
          points: "64 200 64 80 192 80 192 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AQo)
      ])) : o(i) === "fill" ? (s(), r("g", VQo, ZQo)) : o(i) === "light" ? (s(), r("g", CQo, [
        e("path", {
          d: "M32,200V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bQo),
        e("line", {
          x1: "16",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LQo),
        e("polyline", {
          points: "120 200 120 168 192 168 192 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BQo),
        e("polyline", {
          points: "64 200 64 80 192 80 192 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PQo)
      ])) : o(i) === "thin" ? (s(), r("g", WQo, [
        e("path", {
          d: "M32,200V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, NQo),
        e("line", {
          x1: "16",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FQo),
        e("polyline", {
          points: "120 200 120 168 192 168 192 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, TQo),
        e("polyline", {
          points: "64 200 64 80 192 80 192 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, DQo)
      ])) : o(i) === "regular" ? (s(), r("g", RQo, [
        e("path", {
          d: "M32,200V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UQo),
        e("line", {
          x1: "16",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qQo),
        e("polyline", {
          points: "120 200 120 168 192 168 192 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GQo),
        e("polyline", {
          points: "64 200 64 80 192 80 192 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EQo)
      ])) : g("", !0)
    ], 16, $Qo));
  }
}), IQo = ["width", "height", "fill", "transform"], KQo = { key: 0 }, XQo = ["stroke"], JQo = ["stroke"], QQo = ["stroke"], YQo = { key: 1 }, oYo = /* @__PURE__ */ e("rect", {
  x: "120",
  y: "168",
  width: "64",
  height: "32",
  opacity: "0.2"
}, null, -1), eYo = ["stroke"], tYo = ["stroke"], nYo = ["stroke"], sYo = { key: 2 }, rYo = /* @__PURE__ */ e("path", { d: "M240,192h-8V56a16,16,0,0,0-16-16H40A16,16,0,0,0,24,56V192H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Zm-40,0H128V176a8,8,0,0,1,8-8h56a8,8,0,0,1,8,8Z" }, null, -1), iYo = [
  rYo
], lYo = { key: 3 }, dYo = ["stroke"], kYo = ["stroke"], cYo = ["stroke"], hYo = { key: 4 }, uYo = ["stroke"], aYo = ["stroke"], _Yo = ["stroke"], pYo = { key: 5 }, yYo = ["stroke"], $Yo = ["stroke"], wYo = ["stroke"], fYo = {
  name: "PhChalkboardSimple"
}, DU1 = /* @__PURE__ */ $({
  ...fYo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", KQo, [
        e("path", {
          d: "M32,160V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XQo),
        e("line", {
          x1: "16",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, JQo),
        e("polyline", {
          points: "120 200 120 160 184 160 184 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, QQo)
      ])) : o(i) === "duotone" ? (s(), r("g", YQo, [
        oYo,
        e("path", {
          d: "M32,168V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eYo),
        e("line", {
          x1: "16",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tYo),
        e("polyline", {
          points: "120 200 120 168 184 168 184 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nYo)
      ])) : o(i) === "fill" ? (s(), r("g", sYo, iYo)) : o(i) === "light" ? (s(), r("g", lYo, [
        e("path", {
          d: "M32,168V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dYo),
        e("line", {
          x1: "16",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kYo),
        e("polyline", {
          points: "120 200 120 168 184 168 184 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cYo)
      ])) : o(i) === "thin" ? (s(), r("g", hYo, [
        e("path", {
          d: "M32,168V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uYo),
        e("line", {
          x1: "16",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aYo),
        e("polyline", {
          points: "120 200 120 168 184 168 184 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _Yo)
      ])) : o(i) === "regular" ? (s(), r("g", pYo, [
        e("path", {
          d: "M32,168V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yYo),
        e("line", {
          x1: "16",
          y1: "200",
          x2: "240",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Yo),
        e("polyline", {
          points: "120 200 120 168 184 168 184 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wYo)
      ])) : g("", !0)
    ], 16, IQo));
  }
}), gYo = ["width", "height", "fill", "transform"], xYo = { key: 0 }, jYo = ["stroke"], mYo = ["stroke"], MYo = ["stroke"], vYo = { key: 1 }, SYo = ["stroke"], HYo = /* @__PURE__ */ e("path", {
  d: "M72,144a32,32,0,1,1,32,32h88V80H64v64Z",
  opacity: "0.2"
}, null, -1), AYo = ["stroke"], VYo = ["stroke"], zYo = { key: 2 }, ZYo = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H53.4a7.9,7.9,0,0,0,7.2-4.6,48.1,48.1,0,0,1,86.8,0,7.9,7.9,0,0,0,7.2,4.6H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM104,168a32,32,0,1,1,32-32A32.1,32.1,0,0,1,104,168Zm112,32H159.4a63.7,63.7,0,0,0-13.1-16H192a8,8,0,0,0,8-8V80a8,8,0,0,0-8-8H64a8,8,0,0,0-8,8v96a8,8,0,0,0,6,7.7A64.2,64.2,0,0,0,48.6,200H40V56H216Z" }, null, -1), CYo = [
  ZYo
], bYo = { key: 3 }, LYo = ["stroke"], BYo = ["stroke"], PYo = ["stroke"], WYo = { key: 4 }, NYo = ["stroke"], FYo = ["stroke"], TYo = ["stroke"], DYo = { key: 5 }, RYo = ["stroke"], UYo = ["stroke"], qYo = ["stroke"], GYo = {
  name: "PhChalkboardTeacher"
}, RU1 = /* @__PURE__ */ $({
  ...GYo,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xYo, [
        e("circle", {
          cx: "104",
          cy: "148",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jYo),
        e("polyline", {
          points: "188 172 188 84 68 84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mYo),
        e("path", {
          d: "M149.3,208H216a8,8,0,0,0,8-8V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H58.7a48.1,48.1,0,0,1,90.6,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MYo)
      ])) : o(i) === "duotone" ? (s(), r("g", vYo, [
        e("circle", {
          cx: "104",
          cy: "144",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SYo),
        HYo,
        e("path", {
          d: "M53.4,208a56,56,0,0,1,101.2,0H216a8,8,0,0,0,8-8V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AYo),
        e("polyline", {
          points: "176 176 192 176 192 80 64 80 64 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VYo)
      ])) : o(i) === "fill" ? (s(), r("g", zYo, CYo)) : o(i) === "light" ? (s(), r("g", bYo, [
        e("circle", {
          cx: "104",
          cy: "144",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LYo),
        e("path", {
          d: "M53.4,208a56,56,0,0,1,101.2,0H216a8,8,0,0,0,8-8V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BYo),
        e("polyline", {
          points: "176 176 192 176 192 80 64 80 64 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PYo)
      ])) : o(i) === "thin" ? (s(), r("g", WYo, [
        e("circle", {
          cx: "104",
          cy: "144",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, NYo),
        e("path", {
          d: "M53.4,208a56,56,0,0,1,101.2,0H216a8,8,0,0,0,8-8V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FYo),
        e("polyline", {
          points: "176 176 192 176 192 80 64 80 64 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, TYo)
      ])) : o(i) === "regular" ? (s(), r("g", DYo, [
        e("circle", {
          cx: "104",
          cy: "144",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RYo),
        e("path", {
          d: "M53.4,208a56,56,0,0,1,101.2,0H216a8,8,0,0,0,8-8V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UYo),
        e("polyline", {
          points: "176 176 192 176 192 80 64 80 64 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qYo)
      ])) : g("", !0)
    ], 16, gYo));
  }
}), EYo = ["width", "height", "fill", "transform"], OYo = { key: 0 }, IYo = ["stroke"], KYo = ["stroke"], XYo = ["stroke"], JYo = ["stroke"], QYo = { key: 1 }, YYo = /* @__PURE__ */ e("rect", {
  x: "156",
  y: "40",
  width: "56",
  height: "168",
  opacity: "0.2"
}, null, -1), ooe = ["stroke"], eoe = ["stroke"], toe = ["stroke"], noe = ["stroke"], soe = { key: 2 }, roe = /* @__PURE__ */ e("path", { d: "M228,200h-8V40a8,8,0,0,0-8-8H156a8,8,0,0,0-8,8V80H100a8,8,0,0,0-8,8v40H44a8,8,0,0,0-8,8v64H28a8,8,0,0,0,0,16H228a8,8,0,0,0,0-16ZM108,96h40V200H108ZM52,144H92v56H52Z" }, null, -1), ioe = [
  roe
], loe = { key: 3 }, doe = ["stroke"], koe = ["stroke"], coe = ["stroke"], hoe = ["stroke"], uoe = { key: 4 }, aoe = ["stroke"], _oe = ["stroke"], poe = ["stroke"], yoe = ["stroke"], $oe = { key: 5 }, woe = ["stroke"], foe = ["stroke"], goe = ["stroke"], xoe = ["stroke"], joe = {
  name: "PhChartBar"
}, UU1 = /* @__PURE__ */ $({
  ...joe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", OYo, [
        e("line", {
          x1: "228",
          y1: "208",
          x2: "28",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IYo),
        e("polyline", {
          points: "100 208 100 88 156 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KYo),
        e("rect", {
          x: "156",
          y: "40",
          width: "56",
          height: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XYo),
        e("polyline", {
          points: "44 208 44 136 100 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, JYo)
      ])) : o(i) === "duotone" ? (s(), r("g", QYo, [
        YYo,
        e("line", {
          x1: "228",
          y1: "208",
          x2: "28",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ooe),
        e("polyline", {
          points: "100 208 100 88 156 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eoe),
        e("rect", {
          x: "156",
          y: "40",
          width: "56",
          height: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, toe),
        e("polyline", {
          points: "44 208 44 136 100 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, noe)
      ])) : o(i) === "fill" ? (s(), r("g", soe, ioe)) : o(i) === "light" ? (s(), r("g", loe, [
        e("line", {
          x1: "228",
          y1: "208",
          x2: "28",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, doe),
        e("polyline", {
          points: "100 208 100 88 156 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, koe),
        e("rect", {
          x: "156",
          y: "40",
          width: "56",
          height: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, coe),
        e("polyline", {
          points: "44 208 44 136 100 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hoe)
      ])) : o(i) === "thin" ? (s(), r("g", uoe, [
        e("line", {
          x1: "228",
          y1: "208",
          x2: "28",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aoe),
        e("polyline", {
          points: "100 208 100 88 156 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _oe),
        e("rect", {
          x: "156",
          y: "40",
          width: "56",
          height: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, poe),
        e("polyline", {
          points: "44 208 44 136 100 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yoe)
      ])) : o(i) === "regular" ? (s(), r("g", $oe, [
        e("polyline", {
          points: "44 208 44 136 100 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, woe),
        e("line", {
          x1: "228",
          y1: "208",
          x2: "28",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, foe),
        e("polyline", {
          points: "100 208 100 88 156 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, goe),
        e("rect", {
          x: "156",
          y: "40",
          width: "56",
          height: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xoe)
      ])) : g("", !0)
    ], 16, EYo));
  }
}), moe = ["width", "height", "fill", "transform"], Moe = { key: 0 }, voe = ["stroke"], Soe = ["stroke"], Hoe = ["stroke"], Aoe = ["stroke"], Voe = { key: 1 }, zoe = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "104",
  width: "176",
  height: "48",
  opacity: "0.2"
}, null, -1), Zoe = ["stroke"], Coe = ["stroke"], boe = ["stroke"], Loe = ["stroke"], Boe = { key: 2 }, Poe = /* @__PURE__ */ e("path", { d: "M216,96H176V56a8,8,0,0,0-8-8H48V40a8,8,0,0,0-16,0V216a8,8,0,0,0,16,0v-8h88a8,8,0,0,0,8-8V160h72a8,8,0,0,0,8-8V104A8,8,0,0,0,216,96ZM160,64V96H48V64ZM128,192H48V160h80Z" }, null, -1), Woe = [
  Poe
], Noe = { key: 3 }, Foe = ["stroke"], Toe = ["stroke"], Doe = ["stroke"], Roe = ["stroke"], Uoe = { key: 4 }, qoe = ["stroke"], Goe = ["stroke"], Eoe = ["stroke"], Ooe = ["stroke"], Ioe = { key: 5 }, Koe = ["stroke"], Xoe = ["stroke"], Joe = ["stroke"], Qoe = ["stroke"], Yoe = {
  name: "PhChartBarHorizontal"
}, qU1 = /* @__PURE__ */ $({
  ...Yoe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Moe, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "40",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, voe),
        e("polyline", {
          points: "40 56 168 56 168 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Soe),
        e("rect", {
          x: "40",
          y: "104",
          width: "176",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hoe),
        e("polyline", {
          points: "136 152 136 200 40 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Aoe)
      ])) : o(i) === "duotone" ? (s(), r("g", Voe, [
        zoe,
        e("line", {
          x1: "40",
          y1: "216",
          x2: "40",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zoe),
        e("polyline", {
          points: "40 56 168 56 168 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Coe),
        e("rect", {
          x: "40",
          y: "104",
          width: "176",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, boe),
        e("polyline", {
          points: "136 152 136 200 40 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Loe)
      ])) : o(i) === "fill" ? (s(), r("g", Boe, Woe)) : o(i) === "light" ? (s(), r("g", Noe, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "40",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Foe),
        e("polyline", {
          points: "40 56 168 56 168 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Toe),
        e("rect", {
          x: "40",
          y: "104",
          width: "176",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Doe),
        e("polyline", {
          points: "136 152 136 200 40 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Roe)
      ])) : o(i) === "thin" ? (s(), r("g", Uoe, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "40",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qoe),
        e("polyline", {
          points: "40 56 168 56 168 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Goe),
        e("rect", {
          x: "40",
          y: "104",
          width: "176",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Eoe),
        e("polyline", {
          points: "136 152 136 200 40 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ooe)
      ])) : o(i) === "regular" ? (s(), r("g", Ioe, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "40",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Koe),
        e("polyline", {
          points: "40 56 168 56 168 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xoe),
        e("rect", {
          x: "40",
          y: "104",
          width: "176",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Joe),
        e("polyline", {
          points: "136 152 136 200 40 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qoe)
      ])) : g("", !0)
    ], 16, moe));
  }
}), oee = ["width", "height", "fill", "transform"], eee = { key: 0 }, tee = ["stroke"], nee = ["stroke"], see = { key: 1 }, ree = ["stroke"], iee = ["stroke"], lee = { key: 2 }, dee = /* @__PURE__ */ e("path", { d: "M224,200H40V163.6l56.4-49.3,58.8,44.1a8,8,0,0,0,10.1-.4l64-56a8,8,0,1,0-10.6-12l-59.1,51.7L100.8,97.6a8,8,0,0,0-10.1.4L40,142.4V48a8,8,0,0,0-16,0V208a8,8,0,0,0,8,8H224a8,8,0,0,0,0-16Z" }, null, -1), kee = [
  dee
], cee = { key: 3 }, hee = ["stroke"], uee = ["stroke"], aee = { key: 4 }, _ee = ["stroke"], pee = ["stroke"], yee = { key: 5 }, $ee = ["stroke"], wee = ["stroke"], fee = {
  name: "PhChartLine"
}, GU1 = /* @__PURE__ */ $({
  ...fee,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", eee, [
        e("polyline", {
          points: "224 208 32 208 32 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tee),
        e("polyline", {
          points: "224 96 160 152 96 104 32 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nee)
      ])) : o(i) === "duotone" ? (s(), r("g", see, [
        e("polyline", {
          points: "224 208 32 208 32 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ree),
        e("polyline", {
          points: "224 96 160 152 96 104 32 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iee)
      ])) : o(i) === "fill" ? (s(), r("g", lee, kee)) : o(i) === "light" ? (s(), r("g", cee, [
        e("polyline", {
          points: "224 208 32 208 32 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hee),
        e("polyline", {
          points: "224 96 160 152 96 104 32 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uee)
      ])) : o(i) === "thin" ? (s(), r("g", aee, [
        e("polyline", {
          points: "224 208 32 208 32 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _ee),
        e("polyline", {
          points: "224 96 160 152 96 104 32 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pee)
      ])) : o(i) === "regular" ? (s(), r("g", yee, [
        e("polyline", {
          points: "224 208 32 208 32 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $ee),
        e("polyline", {
          points: "224 96 160 152 96 104 32 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wee)
      ])) : g("", !0)
    ], 16, oee));
  }
}), gee = ["width", "height", "fill", "transform"], xee = { key: 0 }, jee = ["stroke"], mee = ["stroke"], Mee = ["stroke"], vee = { key: 1 }, See = ["stroke"], Hee = ["stroke"], Aee = ["stroke"], Vee = { key: 2 }, zee = /* @__PURE__ */ e("path", { d: "M232,208a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V48a8,8,0,0,1,16,0V156.7l50.3-50.4a8.1,8.1,0,0,1,11.4,0L128,132.7,176.7,84,162.3,69.7a8.4,8.4,0,0,1-1.7-8.8A8.1,8.1,0,0,1,168,56h40a8,8,0,0,1,8,8v40a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3L188,95.3l-54.3,54.4a8.1,8.1,0,0,1-11.4,0L96,123.3l-56,56V200H224A8,8,0,0,1,232,208Z" }, null, -1), Zee = [
  zee
], Cee = { key: 3 }, bee = ["stroke"], Lee = ["stroke"], Bee = ["stroke"], Pee = { key: 4 }, Wee = ["stroke"], Nee = ["stroke"], Fee = ["stroke"], Tee = { key: 5 }, Dee = ["stroke"], Ree = ["stroke"], Uee = ["stroke"], qee = {
  name: "PhChartLineUp"
}, EU1 = /* @__PURE__ */ $({
  ...qee,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xee, [
        e("polyline", {
          points: "224 208 32 208 32 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jee),
        e("polyline", {
          points: "208 64 128 144 96 112 32 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mee),
        e("polyline", {
          points: "208 104 208 64 168 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mee)
      ])) : o(i) === "duotone" ? (s(), r("g", vee, [
        e("polyline", {
          points: "224 208 32 208 32 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, See),
        e("polyline", {
          points: "208 64 128 144 96 112 32 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hee),
        e("polyline", {
          points: "208 104 208 64 168 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Aee)
      ])) : o(i) === "fill" ? (s(), r("g", Vee, Zee)) : o(i) === "light" ? (s(), r("g", Cee, [
        e("polyline", {
          points: "224 208 32 208 32 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bee),
        e("polyline", {
          points: "208 64 128 144 96 112 32 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lee),
        e("polyline", {
          points: "208 104 208 64 168 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bee)
      ])) : o(i) === "thin" ? (s(), r("g", Pee, [
        e("polyline", {
          points: "224 208 32 208 32 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wee),
        e("polyline", {
          points: "208 64 128 144 96 112 32 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nee),
        e("polyline", {
          points: "208 104 208 64 168 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fee)
      ])) : o(i) === "regular" ? (s(), r("g", Tee, [
        e("polyline", {
          points: "224 208 32 208 32 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dee),
        e("polyline", {
          points: "208 64 128 144 96 112 32 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ree),
        e("polyline", {
          points: "208 104 208 64 168 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uee)
      ])) : g("", !0)
    ], 16, gee));
  }
}), Gee = ["width", "height", "fill", "transform"], Eee = { key: 0 }, Oee = ["stroke"], Iee = ["stroke"], Kee = ["stroke"], Xee = { key: 1 }, Jee = /* @__PURE__ */ e("path", {
  d: "M128,128,44.9,176h-.1A96.1,96.1,0,0,1,128,32Z",
  opacity: "0.2"
}, null, -1), Qee = ["stroke"], Yee = ["stroke"], ote = ["stroke"], ete = { key: 2 }, tte = /* @__PURE__ */ e("path", { d: "M218.3,76.4a.8.8,0,0,1-.2-.4l-.4-.5a104,104,0,0,0-180,104.1l.2.4.3.4a104,104,0,0,0,180.1-104Zm-18.4.9L136,114.1V40.4A88.2,88.2,0,0,1,199.9,77.3ZM128,216a88,88,0,0,1-71.9-37.3L207.9,91.1A88,88,0,0,1,128,216Z" }, null, -1), nte = [
  tte
], ste = { key: 3 }, rte = ["stroke"], ite = ["stroke"], lte = ["stroke"], dte = { key: 4 }, kte = ["stroke"], cte = ["stroke"], hte = ["stroke"], ute = { key: 5 }, ate = ["stroke"], _te = ["stroke"], pte = ["stroke"], yte = {
  name: "PhChartPie"
}, OU1 = /* @__PURE__ */ $({
  ...yte,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Eee, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Oee),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Iee),
        e("line", {
          x1: "211.1",
          y1: "80",
          x2: "44.9",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kee)
      ])) : o(i) === "duotone" ? (s(), r("g", Xee, [
        Jee,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qee),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yee),
        e("line", {
          x1: "211.1",
          y1: "80",
          x2: "44.9",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ote)
      ])) : o(i) === "fill" ? (s(), r("g", ete, nte)) : o(i) === "light" ? (s(), r("g", ste, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rte),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ite),
        e("line", {
          x1: "211.1",
          y1: "80",
          x2: "44.9",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lte)
      ])) : o(i) === "thin" ? (s(), r("g", dte, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kte),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cte),
        e("line", {
          x1: "211.1",
          y1: "80",
          x2: "44.9",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hte)
      ])) : o(i) === "regular" ? (s(), r("g", ute, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ate),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _te),
        e("line", {
          x1: "211.1",
          y1: "80",
          x2: "44.9",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pte)
      ])) : g("", !0)
    ], 16, Gee));
  }
}), $te = ["width", "height", "fill", "transform"], wte = { key: 0 }, fte = ["stroke"], gte = ["stroke"], xte = ["stroke"], jte = ["stroke"], mte = { key: 1 }, Mte = /* @__PURE__ */ e("path", {
  d: "M33.6,145.6A92.9,92.9,0,0,1,32,128,95.9,95.9,0,0,1,96,37.5v72Z",
  opacity: "0.2"
}, null, -1), vte = ["stroke"], Ste = ["stroke"], Hte = ["stroke"], Ate = ["stroke"], Vte = { key: 2 }, zte = /* @__PURE__ */ e("path", { d: "M100,116.5a8.1,8.1,0,0,0,4-7v-72a8,8,0,0,0-10.7-7.6A104.3,104.3,0,0,0,24,128a109.1,109.1,0,0,0,1.7,19,8.1,8.1,0,0,0,4.5,5.8,8.4,8.4,0,0,0,3.4.8,8,8,0,0,0,4-1.1ZM88,49.6v55.3L40.1,132.6c-.1-1.6-.1-3.1-.1-4.6A88.3,88.3,0,0,1,88,49.6Z" }, null, -1), Zte = /* @__PURE__ */ e("path", { d: "M218.3,76.4a.8.8,0,0,1-.2-.4l-.4-.5A103.9,103.9,0,0,0,128,24a8,8,0,0,0-8,8v91.4L40.9,169.1a7.9,7.9,0,0,0-3,10.9v.2l.3.5A104,104,0,0,0,232,128,103.5,103.5,0,0,0,218.3,76.4Z" }, null, -1), Cte = [
  zte,
  Zte
], bte = { key: 3 }, Lte = ["stroke"], Bte = ["stroke"], Pte = ["stroke"], Wte = ["stroke"], Nte = { key: 4 }, Fte = ["stroke"], Tte = ["stroke"], Dte = ["stroke"], Rte = ["stroke"], Ute = { key: 5 }, qte = ["stroke"], Gte = ["stroke"], Ete = ["stroke"], Ote = ["stroke"], Ite = {
  name: "PhChartPieSlice"
}, IU1 = /* @__PURE__ */ $({
  ...Ite,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", wte, [
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fte),
        e("line", {
          x1: "211.1",
          y1: "80",
          x2: "44.9",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gte),
        e("path", {
          d: "M128,32A96,96,0,1,1,45.2,176.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xte),
        e("path", {
          d: "M88,106.1,32.5,138.2c-.3-3.4-.5-6.8-.5-10.2A96,96,0,0,1,88,40.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jte)
      ])) : o(i) === "duotone" ? (s(), r("g", mte, [
        Mte,
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vte),
        e("line", {
          x1: "211.1",
          y1: "80",
          x2: "44.9",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ste),
        e("path", {
          d: "M33.6,145.6A92.9,92.9,0,0,1,32,128,95.9,95.9,0,0,1,96,37.5v72Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hte),
        e("path", {
          d: "M128,32A96,96,0,1,1,45.2,176.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ate)
      ])) : o(i) === "fill" ? (s(), r("g", Vte, Cte)) : o(i) === "light" ? (s(), r("g", bte, [
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lte),
        e("line", {
          x1: "211.1",
          y1: "80",
          x2: "44.9",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bte),
        e("path", {
          d: "M33.6,145.6A92.9,92.9,0,0,1,32,128,95.9,95.9,0,0,1,96,37.5v72Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pte),
        e("path", {
          d: "M128,32A96,96,0,1,1,45.2,176.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wte)
      ])) : o(i) === "thin" ? (s(), r("g", Nte, [
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fte),
        e("line", {
          x1: "211.1",
          y1: "80",
          x2: "44.9",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Tte),
        e("path", {
          d: "M33.6,145.6A92.9,92.9,0,0,1,32,128,95.9,95.9,0,0,1,96,37.5v72Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Dte),
        e("path", {
          d: "M128,32A96,96,0,1,1,45.2,176.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Rte)
      ])) : o(i) === "regular" ? (s(), r("g", Ute, [
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qte),
        e("line", {
          x1: "211.1",
          y1: "80",
          x2: "44.9",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gte),
        e("path", {
          d: "M33.6,145.6A92.9,92.9,0,0,1,32,128,95.9,95.9,0,0,1,96,37.5v72Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ete),
        e("path", {
          d: "M128,32A96,96,0,1,1,45.2,176.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ote)
      ])) : g("", !0)
    ], 16, $te));
  }
}), Kte = ["width", "height", "fill", "transform"], Xte = { key: 0 }, Jte = ["stroke"], Qte = { key: 1 }, Yte = /* @__PURE__ */ e("path", {
  d: "M78,201.3,45.1,228.9A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H81.7Z",
  opacity: "0.2"
}, null, -1), one = ["stroke"], ene = { key: 2 }, tne = /* @__PURE__ */ e("path", { d: "M216,48H40A16,16,0,0,0,24,64V222.8a15.7,15.7,0,0,0,9.3,14.5,16,16,0,0,0,17-2.2L82,208.4l134-.4a16,16,0,0,0,16-16V64A16,16,0,0,0,216,48Z" }, null, -1), nne = [
  tne
], sne = { key: 3 }, rne = ["stroke"], ine = { key: 4 }, lne = ["stroke"], dne = { key: 5 }, kne = ["stroke"], cne = {
  name: "PhChat"
}, KU1 = /* @__PURE__ */ $({
  ...cne,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Xte, [
        e("path", {
          d: "M77.4,201.9l-32.3,27A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H82.5A7.8,7.8,0,0,0,77.4,201.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jte)
      ])) : o(i) === "duotone" ? (s(), r("g", Qte, [
        Yte,
        e("path", {
          d: "M77.4,201.9l-32.3,27A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H82.5A7.8,7.8,0,0,0,77.4,201.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, one)
      ])) : o(i) === "fill" ? (s(), r("g", ene, nne)) : o(i) === "light" ? (s(), r("g", sne, [
        e("path", {
          d: "M77.4,201.9l-32.3,27A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H82.5A7.8,7.8,0,0,0,77.4,201.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rne)
      ])) : o(i) === "thin" ? (s(), r("g", ine, [
        e("path", {
          d: "M77.4,201.9l-32.3,27A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H82.5A7.8,7.8,0,0,0,77.4,201.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lne)
      ])) : o(i) === "regular" ? (s(), r("g", dne, [
        e("path", {
          d: "M77.4,201.9l-32.3,27A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H82.5A7.8,7.8,0,0,0,77.4,201.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kne)
      ])) : g("", !0)
    ], 16, Kte));
  }
}), hne = ["width", "height", "fill", "transform"], une = { key: 0 }, ane = ["stroke"], _ne = { key: 1 }, pne = /* @__PURE__ */ e("path", {
  d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
  opacity: "0.2"
}, null, -1), yne = ["stroke"], $ne = { key: 2 }, wne = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V184a16,16,0,0,0,16,16H99.5l14.8,24.7a16,16,0,0,0,27.4,0L156.5,200H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Z" }, null, -1), fne = [
  wne
], gne = { key: 3 }, xne = ["stroke"], jne = { key: 4 }, mne = ["stroke"], Mne = { key: 5 }, vne = ["stroke"], Sne = {
  name: "PhChatCentered"
}, XU1 = /* @__PURE__ */ $({
  ...Sne,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", une, [
        e("path", {
          d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ane)
      ])) : o(i) === "duotone" ? (s(), r("g", _ne, [
        pne,
        e("path", {
          d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yne)
      ])) : o(i) === "fill" ? (s(), r("g", $ne, fne)) : o(i) === "light" ? (s(), r("g", gne, [
        e("path", {
          d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xne)
      ])) : o(i) === "thin" ? (s(), r("g", jne, [
        e("path", {
          d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mne)
      ])) : o(i) === "regular" ? (s(), r("g", Mne, [
        e("path", {
          d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vne)
      ])) : g("", !0)
    ], 16, hne));
  }
}), Hne = ["width", "height", "fill", "transform"], Ane = { key: 0 }, Vne = ["stroke"], zne = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "120",
  r: "16"
}, null, -1), Zne = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "120",
  r: "16"
}, null, -1), Cne = { key: 1 }, bne = /* @__PURE__ */ e("path", {
  d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
  opacity: "0.2"
}, null, -1), Lne = ["stroke"], Bne = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "120",
  r: "12"
}, null, -1), Pne = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "120",
  r: "12"
}, null, -1), Wne = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "120",
  r: "12"
}, null, -1), Nne = { key: 2 }, Fne = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V184a16,16,0,0,0,16,16H99.5l14.8,24.7a16,16,0,0,0,27.4,0L156.5,200H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM80,132a12,12,0,1,1,12-12A12,12,0,0,1,80,132Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,128,132Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,176,132Z" }, null, -1), Tne = [
  Fne
], Dne = { key: 3 }, Rne = ["stroke"], Une = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "120",
  r: "10"
}, null, -1), qne = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "120",
  r: "10"
}, null, -1), Gne = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "120",
  r: "10"
}, null, -1), Ene = { key: 4 }, One = ["stroke"], Ine = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "120",
  r: "8"
}, null, -1), Kne = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "120",
  r: "8"
}, null, -1), Xne = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "120",
  r: "8"
}, null, -1), Jne = { key: 5 }, Qne = ["stroke"], Yne = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "120",
  r: "12"
}, null, -1), ose = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "120",
  r: "12"
}, null, -1), ese = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "120",
  r: "12"
}, null, -1), tse = {
  name: "PhChatCenteredDots"
}, JU1 = /* @__PURE__ */ $({
  ...tse,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ane, [
        e("path", {
          d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vne),
        zne,
        Zne
      ])) : o(i) === "duotone" ? (s(), r("g", Cne, [
        bne,
        e("path", {
          d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lne),
        Bne,
        Pne,
        Wne
      ])) : o(i) === "fill" ? (s(), r("g", Nne, Tne)) : o(i) === "light" ? (s(), r("g", Dne, [
        e("path", {
          d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rne),
        Une,
        qne,
        Gne
      ])) : o(i) === "thin" ? (s(), r("g", Ene, [
        e("path", {
          d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, One),
        Ine,
        Kne,
        Xne
      ])) : o(i) === "regular" ? (s(), r("g", Jne, [
        e("path", {
          d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qne),
        Yne,
        ose,
        ese
      ])) : g("", !0)
    ], 16, Hne));
  }
}), nse = ["width", "height", "fill", "transform"], sse = { key: 0 }, rse = ["stroke"], ise = ["stroke"], lse = ["stroke"], dse = { key: 1 }, kse = /* @__PURE__ */ e("path", {
  d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
  opacity: "0.2"
}, null, -1), cse = ["stroke"], hse = ["stroke"], use = ["stroke"], ase = { key: 2 }, _se = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V184a16,16,0,0,0,16,16H99.5l14.8,24.7a16,16,0,0,0,27.4,0L156.5,200H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM160,144H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z" }, null, -1), pse = [
  _se
], yse = { key: 3 }, $se = ["stroke"], wse = ["stroke"], fse = ["stroke"], gse = { key: 4 }, xse = ["stroke"], jse = ["stroke"], mse = ["stroke"], Mse = { key: 5 }, vse = ["stroke"], Sse = ["stroke"], Hse = ["stroke"], Ase = {
  name: "PhChatCenteredText"
}, QU1 = /* @__PURE__ */ $({
  ...Ase,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", sse, [
        e("line", {
          x1: "96",
          y1: "100",
          x2: "160",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rse),
        e("line", {
          x1: "96",
          y1: "140",
          x2: "160",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ise),
        e("path", {
          d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lse)
      ])) : o(i) === "duotone" ? (s(), r("g", dse, [
        kse,
        e("line", {
          x1: "96",
          y1: "104",
          x2: "160",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cse),
        e("line", {
          x1: "96",
          y1: "136",
          x2: "160",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hse),
        e("path", {
          d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, use)
      ])) : o(i) === "fill" ? (s(), r("g", ase, pse)) : o(i) === "light" ? (s(), r("g", yse, [
        e("line", {
          x1: "96",
          y1: "104",
          x2: "160",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $se),
        e("line", {
          x1: "96",
          y1: "136",
          x2: "160",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wse),
        e("path", {
          d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fse)
      ])) : o(i) === "thin" ? (s(), r("g", gse, [
        e("line", {
          x1: "96",
          y1: "104",
          x2: "160",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xse),
        e("line", {
          x1: "96",
          y1: "136",
          x2: "160",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jse),
        e("path", {
          d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mse)
      ])) : o(i) === "regular" ? (s(), r("g", Mse, [
        e("line", {
          x1: "96",
          y1: "104",
          x2: "160",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vse),
        e("line", {
          x1: "96",
          y1: "136",
          x2: "160",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sse),
        e("path", {
          d: "M149.7,195.9l-14.8,24.7a8.1,8.1,0,0,1-13.8,0l-14.8-24.7a7.9,7.9,0,0,0-6.8-3.9H40a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a8,8,0,0,1-8,8H156.5A7.9,7.9,0,0,0,149.7,195.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hse)
      ])) : g("", !0)
    ], 16, nse));
  }
}), Vse = ["width", "height", "fill", "transform"], zse = { key: 0 }, Zse = ["stroke"], Cse = { key: 1 }, bse = /* @__PURE__ */ e("path", {
  d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
  opacity: "0.2"
}, null, -1), Lse = ["stroke"], Bse = { key: 2 }, Pse = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,0,0,36.8,178l-8.5,30A15.9,15.9,0,0,0,48,227.7l30-8.5A104,104,0,1,0,128,24Z" }, null, -1), Wse = [
  Pse
], Nse = { key: 3 }, Fse = ["stroke"], Tse = { key: 4 }, Dse = ["stroke"], Rse = { key: 5 }, Use = ["stroke"], qse = {
  name: "PhChatCircle"
}, YU1 = /* @__PURE__ */ $({
  ...qse,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", zse, [
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zse)
      ])) : o(i) === "duotone" ? (s(), r("g", Cse, [
        bse,
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lse)
      ])) : o(i) === "fill" ? (s(), r("g", Bse, Wse)) : o(i) === "light" ? (s(), r("g", Nse, [
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fse)
      ])) : o(i) === "thin" ? (s(), r("g", Tse, [
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Dse)
      ])) : o(i) === "regular" ? (s(), r("g", Rse, [
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Use)
      ])) : g("", !0)
    ], 16, Vse));
  }
}), Gse = ["width", "height", "fill", "transform"], Ese = { key: 0 }, Ose = ["stroke"], Ise = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "128",
  r: "16"
}, null, -1), Kse = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "128",
  r: "16"
}, null, -1), Xse = { key: 1 }, Jse = /* @__PURE__ */ e("path", {
  d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
  opacity: "0.2"
}, null, -1), Qse = ["stroke"], Yse = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), ore = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "128",
  r: "12"
}, null, -1), ere = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "128",
  r: "12"
}, null, -1), tre = { key: 2 }, nre = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,0,0,36.8,178l-8.5,29.9a16.1,16.1,0,0,0,4,15.8,15.8,15.8,0,0,0,15.7,4l30-8.5A104,104,0,1,0,128,24ZM80,140a12,12,0,1,1,12-12A12,12,0,0,1,80,140Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,176,140Z" }, null, -1), sre = [
  nre
], rre = { key: 3 }, ire = ["stroke"], lre = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "10"
}, null, -1), dre = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "128",
  r: "10"
}, null, -1), kre = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "128",
  r: "10"
}, null, -1), cre = { key: 4 }, hre = ["stroke"], ure = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "8"
}, null, -1), are = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "128",
  r: "8"
}, null, -1), _re = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "128",
  r: "8"
}, null, -1), pre = { key: 5 }, yre = ["stroke"], $re = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), wre = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "128",
  r: "12"
}, null, -1), fre = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "128",
  r: "12"
}, null, -1), gre = {
  name: "PhChatCircleDots"
}, oq1 = /* @__PURE__ */ $({
  ...gre,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ese, [
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ose),
        Ise,
        Kse
      ])) : o(i) === "duotone" ? (s(), r("g", Xse, [
        Jse,
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qse),
        Yse,
        ore,
        ere
      ])) : o(i) === "fill" ? (s(), r("g", tre, sre)) : o(i) === "light" ? (s(), r("g", rre, [
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ire),
        lre,
        dre,
        kre
      ])) : o(i) === "thin" ? (s(), r("g", cre, [
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hre),
        ure,
        are,
        _re
      ])) : o(i) === "regular" ? (s(), r("g", pre, [
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yre),
        $re,
        wre,
        fre
      ])) : g("", !0)
    ], 16, Gse));
  }
}), xre = ["width", "height", "fill", "transform"], jre = { key: 0 }, mre = ["stroke"], Mre = ["stroke"], vre = ["stroke"], Sre = { key: 1 }, Hre = /* @__PURE__ */ e("path", {
  d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
  opacity: "0.2"
}, null, -1), Are = ["stroke"], Vre = ["stroke"], zre = ["stroke"], Zre = { key: 2 }, Cre = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,0,0,36.8,178l-8.5,29.9a16.1,16.1,0,0,0,4,15.8,15.8,15.8,0,0,0,15.7,4l30-8.5A104,104,0,1,0,128,24Zm32,128H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z" }, null, -1), bre = [
  Cre
], Lre = { key: 3 }, Bre = ["stroke"], Pre = ["stroke"], Wre = ["stroke"], Nre = { key: 4 }, Fre = ["stroke"], Tre = ["stroke"], Dre = ["stroke"], Rre = { key: 5 }, Ure = ["stroke"], qre = ["stroke"], Gre = ["stroke"], Ere = {
  name: "PhChatCircleText"
}, eq1 = /* @__PURE__ */ $({
  ...Ere,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", jre, [
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mre),
        e("line", {
          x1: "96",
          y1: "108",
          x2: "160",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mre),
        e("line", {
          x1: "96",
          y1: "148",
          x2: "160",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vre)
      ])) : o(i) === "duotone" ? (s(), r("g", Sre, [
        Hre,
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Are),
        e("line", {
          x1: "96",
          y1: "112",
          x2: "160",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vre),
        e("line", {
          x1: "96",
          y1: "144",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zre)
      ])) : o(i) === "fill" ? (s(), r("g", Zre, bre)) : o(i) === "light" ? (s(), r("g", Lre, [
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bre),
        e("line", {
          x1: "96",
          y1: "112",
          x2: "160",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pre),
        e("line", {
          x1: "96",
          y1: "144",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wre)
      ])) : o(i) === "thin" ? (s(), r("g", Nre, [
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fre),
        e("line", {
          x1: "96",
          y1: "112",
          x2: "160",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Tre),
        e("line", {
          x1: "96",
          y1: "144",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Dre)
      ])) : o(i) === "regular" ? (s(), r("g", Rre, [
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ure),
        e("line", {
          x1: "96",
          y1: "112",
          x2: "160",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qre),
        e("line", {
          x1: "96",
          y1: "144",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gre)
      ])) : g("", !0)
    ], 16, xre));
  }
}), Ore = ["width", "height", "fill", "transform"], Ire = { key: 0 }, Kre = ["stroke"], Xre = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "128",
  r: "16"
}, null, -1), Jre = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "128",
  r: "16"
}, null, -1), Qre = { key: 1 }, Yre = /* @__PURE__ */ e("path", {
  d: "M78,201.3,45.1,228.9A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H81.7Z",
  opacity: "0.2"
}, null, -1), oie = ["stroke"], eie = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), tie = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "128",
  r: "12"
}, null, -1), nie = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "128",
  r: "12"
}, null, -1), sie = { key: 2 }, rie = /* @__PURE__ */ e("path", { d: "M216,48H40A16,16,0,0,0,24,64V222.8a15.7,15.7,0,0,0,9.3,14.5,14.7,14.7,0,0,0,6.7,1.6,16,16,0,0,0,10.3-3.8l31.8-26.7L216,208a16,16,0,0,0,16-16V64A16,16,0,0,0,216,48ZM80,140a12,12,0,1,1,12-12A12,12,0,0,1,80,140Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,176,140Z" }, null, -1), iie = [
  rie
], lie = { key: 3 }, die = ["stroke"], kie = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "10"
}, null, -1), cie = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "128",
  r: "10"
}, null, -1), hie = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "128",
  r: "10"
}, null, -1), uie = { key: 4 }, aie = ["stroke"], _ie = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "8"
}, null, -1), pie = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "128",
  r: "8"
}, null, -1), yie = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "128",
  r: "8"
}, null, -1), $ie = { key: 5 }, wie = ["stroke"], fie = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), gie = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "128",
  r: "12"
}, null, -1), xie = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "128",
  r: "12"
}, null, -1), jie = {
  name: "PhChatDots"
}, tq1 = /* @__PURE__ */ $({
  ...jie,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ire, [
        e("path", {
          d: "M77.4,201.9l-32.3,27A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H82.5A7.8,7.8,0,0,0,77.4,201.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kre),
        Xre,
        Jre
      ])) : o(i) === "duotone" ? (s(), r("g", Qre, [
        Yre,
        e("path", {
          d: "M77.4,201.9l-32.3,27A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H82.5A7.8,7.8,0,0,0,77.4,201.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oie),
        eie,
        tie,
        nie
      ])) : o(i) === "fill" ? (s(), r("g", sie, iie)) : o(i) === "light" ? (s(), r("g", lie, [
        e("path", {
          d: "M77.4,201.9l-32.3,27A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H82.5A7.8,7.8,0,0,0,77.4,201.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, die),
        kie,
        cie,
        hie
      ])) : o(i) === "thin" ? (s(), r("g", uie, [
        e("path", {
          d: "M77.4,201.9l-32.3,27A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H82.5A7.8,7.8,0,0,0,77.4,201.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aie),
        _ie,
        pie,
        yie
      ])) : o(i) === "regular" ? (s(), r("g", $ie, [
        e("path", {
          d: "M77.4,201.9l-32.3,27A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H82.5A7.8,7.8,0,0,0,77.4,201.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wie),
        fie,
        gie,
        xie
      ])) : g("", !0)
    ], 16, Ore));
  }
}), mie = ["width", "height", "fill", "transform"], Mie = { key: 0 }, vie = ["stroke"], Sie = { key: 1 }, Hie = /* @__PURE__ */ e("path", {
  d: "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
  opacity: "0.2"
}, null, -1), Aie = ["stroke"], Vie = { key: 2 }, zie = /* @__PURE__ */ e("path", { d: "M132,24A100.2,100.2,0,0,0,32,124v84.3A15.7,15.7,0,0,0,47.7,224H132a100,100,0,0,0,0-200Z" }, null, -1), Zie = [
  zie
], Cie = { key: 3 }, bie = ["stroke"], Lie = { key: 4 }, Bie = ["stroke"], Pie = { key: 5 }, Wie = ["stroke"], Nie = {
  name: "PhChatTeardrop"
}, nq1 = /* @__PURE__ */ $({
  ...Nie,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Mie, [
        e("path", {
          d: "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vie)
      ])) : o(i) === "duotone" ? (s(), r("g", Sie, [
        Hie,
        e("path", {
          d: "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Aie)
      ])) : o(i) === "fill" ? (s(), r("g", Vie, Zie)) : o(i) === "light" ? (s(), r("g", Cie, [
        e("path", {
          d: "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bie)
      ])) : o(i) === "thin" ? (s(), r("g", Lie, [
        e("path", {
          d: "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bie)
      ])) : o(i) === "regular" ? (s(), r("g", Pie, [
        e("path", {
          d: "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wie)
      ])) : g("", !0)
    ], 16, mie));
  }
}), Fie = ["width", "height", "fill", "transform"], Tie = { key: 0 }, Die = ["stroke"], Rie = /* @__PURE__ */ e("circle", {
  cx: "132",
  cy: "128",
  r: "16"
}, null, -1), Uie = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "128",
  r: "16"
}, null, -1), qie = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "128",
  r: "16"
}, null, -1), Gie = { key: 1 }, Eie = /* @__PURE__ */ e("path", {
  d: "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
  opacity: "0.2"
}, null, -1), Oie = ["stroke"], Iie = /* @__PURE__ */ e("circle", {
  cx: "132",
  cy: "128",
  r: "12"
}, null, -1), Kie = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "128",
  r: "12"
}, null, -1), Xie = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "128",
  r: "12"
}, null, -1), Jie = { key: 2 }, Qie = /* @__PURE__ */ e("path", { d: "M132,24A100.2,100.2,0,0,0,32,124v84.3A15.7,15.7,0,0,0,47.7,224H132a100,100,0,0,0,0-200ZM84,140a12,12,0,1,1,12-12A12,12,0,0,1,84,140Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,132,140Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,180,140Z" }, null, -1), Yie = [
  Qie
], o1e = { key: 3 }, e1e = ["stroke"], t1e = /* @__PURE__ */ e("circle", {
  cx: "132",
  cy: "128",
  r: "10"
}, null, -1), n1e = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "128",
  r: "10"
}, null, -1), s1e = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "128",
  r: "10"
}, null, -1), r1e = { key: 4 }, i1e = ["stroke"], l1e = /* @__PURE__ */ e("circle", {
  cx: "132",
  cy: "128",
  r: "8"
}, null, -1), d1e = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "128",
  r: "8"
}, null, -1), k1e = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "128",
  r: "8"
}, null, -1), c1e = { key: 5 }, h1e = ["stroke"], u1e = /* @__PURE__ */ e("circle", {
  cx: "132",
  cy: "128",
  r: "12"
}, null, -1), a1e = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "128",
  r: "12"
}, null, -1), _1e = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "128",
  r: "12"
}, null, -1), p1e = {
  name: "PhChatTeardropDots"
}, sq1 = /* @__PURE__ */ $({
  ...p1e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Tie, [
        e("path", {
          d: "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Die),
        Rie,
        Uie,
        qie
      ])) : o(i) === "duotone" ? (s(), r("g", Gie, [
        Eie,
        e("path", {
          d: "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Oie),
        Iie,
        Kie,
        Xie
      ])) : o(i) === "fill" ? (s(), r("g", Jie, Yie)) : o(i) === "light" ? (s(), r("g", o1e, [
        e("path", {
          d: "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, e1e),
        t1e,
        n1e,
        s1e
      ])) : o(i) === "thin" ? (s(), r("g", r1e, [
        e("path", {
          d: "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, i1e),
        l1e,
        d1e,
        k1e
      ])) : o(i) === "regular" ? (s(), r("g", c1e, [
        e("path", {
          d: "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h1e),
        u1e,
        a1e,
        _1e
      ])) : g("", !0)
    ], 16, Fie));
  }
}), y1e = ["width", "height", "fill", "transform"], $1e = { key: 0 }, w1e = ["stroke"], f1e = ["stroke"], g1e = ["stroke"], x1e = { key: 1 }, j1e = /* @__PURE__ */ e("path", {
  d: "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
  opacity: "0.2"
}, null, -1), m1e = ["stroke"], M1e = ["stroke"], v1e = ["stroke"], S1e = { key: 2 }, H1e = /* @__PURE__ */ e("path", { d: "M132,24A100.2,100.2,0,0,0,32,124v84.3A15.7,15.7,0,0,0,47.7,224H132a100,100,0,0,0,0-200Zm28,128H100a8,8,0,0,1,0-16h60a8,8,0,0,1,0,16Zm0-32H100a8,8,0,0,1,0-16h60a8,8,0,0,1,0,16Z" }, null, -1), A1e = [
  H1e
], V1e = { key: 3 }, z1e = ["stroke"], Z1e = ["stroke"], C1e = ["stroke"], b1e = { key: 4 }, L1e = ["stroke"], B1e = ["stroke"], P1e = ["stroke"], W1e = { key: 5 }, N1e = ["stroke"], F1e = ["stroke"], T1e = ["stroke"], D1e = {
  name: "PhChatTeardropText"
}, rq1 = /* @__PURE__ */ $({
  ...D1e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $1e, [
        e("path", {
          d: "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, w1e),
        e("line", {
          x1: "100",
          y1: "108",
          x2: "160",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f1e),
        e("line", {
          x1: "100",
          y1: "148",
          x2: "160",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g1e)
      ])) : o(i) === "duotone" ? (s(), r("g", x1e, [
        j1e,
        e("path", {
          d: "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m1e),
        e("line", {
          x1: "100",
          y1: "112",
          x2: "160",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M1e),
        e("line", {
          x1: "100",
          y1: "144",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v1e)
      ])) : o(i) === "fill" ? (s(), r("g", S1e, A1e)) : o(i) === "light" ? (s(), r("g", V1e, [
        e("path", {
          d: "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, z1e),
        e("line", {
          x1: "100",
          y1: "112",
          x2: "160",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Z1e),
        e("line", {
          x1: "100",
          y1: "144",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, C1e)
      ])) : o(i) === "thin" ? (s(), r("g", b1e, [
        e("path", {
          d: "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, L1e),
        e("line", {
          x1: "100",
          y1: "112",
          x2: "160",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, B1e),
        e("line", {
          x1: "100",
          y1: "144",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, P1e)
      ])) : o(i) === "regular" ? (s(), r("g", W1e, [
        e("path", {
          d: "M132,216H47.7a7.6,7.6,0,0,1-7.7-7.7V124a92,92,0,0,1,92-92h0a92,92,0,0,1,92,92h0A92,92,0,0,1,132,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N1e),
        e("line", {
          x1: "100",
          y1: "112",
          x2: "160",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F1e),
        e("line", {
          x1: "100",
          y1: "144",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T1e)
      ])) : g("", !0)
    ], 16, y1e));
  }
}), R1e = ["width", "height", "fill", "transform"], U1e = { key: 0 }, q1e = ["stroke"], G1e = ["stroke"], E1e = ["stroke"], O1e = { key: 1 }, I1e = /* @__PURE__ */ e("path", {
  d: "M78,201.3,45.1,228.9A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H81.7Z",
  opacity: "0.2"
}, null, -1), K1e = ["stroke"], X1e = ["stroke"], J1e = ["stroke"], Q1e = { key: 2 }, Y1e = /* @__PURE__ */ e("path", { d: "M216,48H40A16,16,0,0,0,24,64V222.8a15.7,15.7,0,0,0,9.3,14.5,16,16,0,0,0,17-2.2L82,208.4l134-.4a16,16,0,0,0,16-16V64A16,16,0,0,0,216,48ZM160,152H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z" }, null, -1), ole = [
  Y1e
], ele = { key: 3 }, tle = ["stroke"], nle = ["stroke"], sle = ["stroke"], rle = { key: 4 }, ile = ["stroke"], lle = ["stroke"], dle = ["stroke"], kle = { key: 5 }, cle = ["stroke"], hle = ["stroke"], ule = ["stroke"], ale = {
  name: "PhChatText"
}, iq1 = /* @__PURE__ */ $({
  ...ale,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", U1e, [
        e("path", {
          d: "M78,201.3,45.1,228.9A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H81.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, q1e),
        e("line", {
          x1: "96",
          y1: "108",
          x2: "160",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, G1e),
        e("line", {
          x1: "96",
          y1: "148",
          x2: "160",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, E1e)
      ])) : o(i) === "duotone" ? (s(), r("g", O1e, [
        I1e,
        e("path", {
          d: "M78,201.3,45.1,228.9A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H81.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K1e),
        e("line", {
          x1: "96",
          y1: "112",
          x2: "160",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X1e),
        e("line", {
          x1: "96",
          y1: "144",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J1e)
      ])) : o(i) === "fill" ? (s(), r("g", Q1e, ole)) : o(i) === "light" ? (s(), r("g", ele, [
        e("path", {
          d: "M78,201.3,45.1,228.9A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H81.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tle),
        e("line", {
          x1: "96",
          y1: "112",
          x2: "160",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nle),
        e("line", {
          x1: "96",
          y1: "144",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sle)
      ])) : o(i) === "thin" ? (s(), r("g", rle, [
        e("path", {
          d: "M78,201.3,45.1,228.9A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H81.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ile),
        e("line", {
          x1: "96",
          y1: "112",
          x2: "160",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lle),
        e("line", {
          x1: "96",
          y1: "144",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dle)
      ])) : o(i) === "regular" ? (s(), r("g", kle, [
        e("path", {
          d: "M78,201.3,45.1,228.9A8,8,0,0,1,32,222.8V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8H81.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cle),
        e("line", {
          x1: "96",
          y1: "112",
          x2: "160",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hle),
        e("line", {
          x1: "96",
          y1: "144",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ule)
      ])) : g("", !0)
    ], 16, R1e));
  }
}), _le = ["width", "height", "fill", "transform"], ple = { key: 0 }, yle = ["stroke"], $le = ["stroke"], wle = { key: 1 }, fle = /* @__PURE__ */ e("path", {
  d: "M80,144v40a8,8,0,0,0,8,8h96.4L224,224V96a8,8,0,0,0-8-8H176v48a8,8,0,0,1-8,8Z",
  opacity: "0.2"
}, null, -1), gle = ["stroke"], xle = ["stroke"], jle = { key: 2 }, mle = /* @__PURE__ */ e("path", { d: "M232,96a16,16,0,0,0-16-16H184V48a16,16,0,0,0-16-16H40A16,16,0,0,0,24,48V176a7.9,7.9,0,0,0,4.6,7.2,7.8,7.8,0,0,0,8.4-1l35-28.3V184a16,16,0,0,0,16,16h93.6L219,230.2a7.8,7.8,0,0,0,8.4,1A7.9,7.9,0,0,0,232,224Zm-42.6,89.8a7.7,7.7,0,0,0-5-1.8H88V152h80a16,16,0,0,0,16-16V96h32V207.2Z" }, null, -1), Mle = [
  mle
], vle = { key: 3 }, Sle = ["stroke"], Hle = ["stroke"], Ale = { key: 4 }, Vle = ["stroke"], zle = ["stroke"], Zle = { key: 5 }, Cle = ["stroke"], ble = ["stroke"], Lle = {
  name: "PhChats"
}, lq1 = /* @__PURE__ */ $({
  ...Lle,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ple, [
        e("path", {
          d: "M71.6,144,32,176V48a8,8,0,0,1,8-8H168a8,8,0,0,1,8,8v88a8,8,0,0,1-8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yle),
        e("path", {
          d: "M80,144v40a8,8,0,0,0,8,8h96.4L224,224V96a8,8,0,0,0-8-8H176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $le)
      ])) : o(i) === "duotone" ? (s(), r("g", wle, [
        fle,
        e("path", {
          d: "M71.6,144,32,176V48a8,8,0,0,1,8-8H168a8,8,0,0,1,8,8v88a8,8,0,0,1-8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gle),
        e("path", {
          d: "M80,144v40a8,8,0,0,0,8,8h96.4L224,224V96a8,8,0,0,0-8-8H176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xle)
      ])) : o(i) === "fill" ? (s(), r("g", jle, Mle)) : o(i) === "light" ? (s(), r("g", vle, [
        e("path", {
          d: "M71.6,144,32,176V48a8,8,0,0,1,8-8H168a8,8,0,0,1,8,8v88a8,8,0,0,1-8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Sle),
        e("path", {
          d: "M80,144v40a8,8,0,0,0,8,8h96.4L224,224V96a8,8,0,0,0-8-8H176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hle)
      ])) : o(i) === "thin" ? (s(), r("g", Ale, [
        e("path", {
          d: "M71.6,144,32,176V48a8,8,0,0,1,8-8H168a8,8,0,0,1,8,8v88a8,8,0,0,1-8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vle),
        e("path", {
          d: "M80,144v40a8,8,0,0,0,8,8h96.4L224,224V96a8,8,0,0,0-8-8H176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zle)
      ])) : o(i) === "regular" ? (s(), r("g", Zle, [
        e("path", {
          d: "M71.6,144,32,176V48a8,8,0,0,1,8-8H168a8,8,0,0,1,8,8v88a8,8,0,0,1-8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cle),
        e("path", {
          d: "M80,144v40a8,8,0,0,0,8,8h96.4L224,224V96a8,8,0,0,0-8-8H176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ble)
      ])) : g("", !0)
    ], 16, _le));
  }
}), Ble = ["width", "height", "fill", "transform"], Ple = { key: 0 }, Wle = ["stroke"], Nle = ["stroke"], Fle = { key: 1 }, Tle = /* @__PURE__ */ e("path", {
  d: "M92.1,175.9a71.9,71.9,0,0,0,104.6,38h0l24.9,7.1a6,6,0,0,0,7.4-7.4l-7.1-24.9h0a71.9,71.9,0,0,0-58-108.6h0A70.2,70.2,0,0,1,168,104a72,72,0,0,1-72,72Z",
  opacity: "0.2"
}, null, -1), Dle = ["stroke"], Rle = ["stroke"], Ule = { key: 2 }, qle = /* @__PURE__ */ e("path", { d: "M230.5,189.8A80,80,0,0,0,169.6,72.6,80,80,0,1,0,25.5,141.8l-6.2,21.6a13.9,13.9,0,0,0,17.3,17.3l21.6-6.2a80.8,80.8,0,0,0,28.2,8.9,80,80,0,0,0,111.4,39.1l21.6,6.2a13.9,13.9,0,0,0,17.3-17.3Zm-15.4-5.1a7.6,7.6,0,0,0-.9,6.2l6.2,21.5-21.5-6.2a7.6,7.6,0,0,0-6.2.9,64.2,64.2,0,0,1-88.4-23.5A80.2,80.2,0,0,0,176,104a83.6,83.6,0,0,0-1.3-14.3A64,64,0,0,1,224,152,64.8,64.8,0,0,1,215.1,184.7Z" }, null, -1), Gle = [
  qle
], Ele = { key: 3 }, Ole = ["stroke"], Ile = ["stroke"], Kle = { key: 4 }, Xle = ["stroke"], Jle = ["stroke"], Qle = { key: 5 }, Yle = ["stroke"], o2e = ["stroke"], e2e = {
  name: "PhChatsCircle"
}, dq1 = /* @__PURE__ */ $({
  ...e2e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ple, [
        e("path", {
          d: "M34.1,140.7a72.1,72.1,0,1,1,25.2,25.2h0L34.4,173a6,6,0,0,1-7.4-7.4l7.1-24.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wle),
        e("path", {
          d: "M92.1,175.9a71.9,71.9,0,0,0,104.6,38h0l24.9,7.1a6,6,0,0,0,7.4-7.4l-7.1-24.9h0a71.9,71.9,0,0,0-58-108.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nle)
      ])) : o(i) === "duotone" ? (s(), r("g", Fle, [
        Tle,
        e("path", {
          d: "M34.1,140.7a72.1,72.1,0,1,1,25.2,25.2h0L34.4,173a6,6,0,0,1-7.4-7.4l7.1-24.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dle),
        e("path", {
          d: "M92.1,175.9a71.9,71.9,0,0,0,104.6,38h0l24.9,7.1a6,6,0,0,0,7.4-7.4l-7.1-24.9h0a71.9,71.9,0,0,0-58-108.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rle)
      ])) : o(i) === "fill" ? (s(), r("g", Ule, Gle)) : o(i) === "light" ? (s(), r("g", Ele, [
        e("path", {
          d: "M34.1,140.7a72.1,72.1,0,1,1,25.2,25.2h0L34.4,173a6,6,0,0,1-7.4-7.4l7.1-24.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ole),
        e("path", {
          d: "M92.1,175.9a71.9,71.9,0,0,0,104.6,38h0l24.9,7.1a6,6,0,0,0,7.4-7.4l-7.1-24.9h0a71.9,71.9,0,0,0-58-108.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ile)
      ])) : o(i) === "thin" ? (s(), r("g", Kle, [
        e("path", {
          d: "M34.1,140.7a72.1,72.1,0,1,1,25.2,25.2h0L34.4,173a6,6,0,0,1-7.4-7.4l7.1-24.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xle),
        e("path", {
          d: "M92.1,175.9a71.9,71.9,0,0,0,104.6,38h0l24.9,7.1a6,6,0,0,0,7.4-7.4l-7.1-24.9h0a71.9,71.9,0,0,0-58-108.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jle)
      ])) : o(i) === "regular" ? (s(), r("g", Qle, [
        e("path", {
          d: "M34.1,140.7a72.1,72.1,0,1,1,25.2,25.2h0L34.4,173a6,6,0,0,1-7.4-7.4l7.1-24.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yle),
        e("path", {
          d: "M92.1,175.9a71.9,71.9,0,0,0,104.6,38h0l24.9,7.1a6,6,0,0,0,7.4-7.4l-7.1-24.9h0a71.9,71.9,0,0,0-58-108.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o2e)
      ])) : g("", !0)
    ], 16, Ble));
  }
}), t2e = ["width", "height", "fill", "transform"], n2e = { key: 0 }, s2e = ["stroke"], r2e = ["stroke"], i2e = { key: 1 }, l2e = /* @__PURE__ */ e("path", {
  d: "M163.9,80.1A70.2,70.2,0,0,1,168,104h0a72,72,0,0,1-72,72H92.1A72,72,0,0,0,160,224h66a6,6,0,0,0,6-6V152a71.9,71.9,0,0,0-68.1-71.9Z",
  opacity: "0.2"
}, null, -1), d2e = ["stroke"], k2e = ["stroke"], c2e = { key: 2 }, h2e = /* @__PURE__ */ e("path", { d: "M169.6,72.6A80,80,0,0,0,16,104v66a14,14,0,0,0,14,14H86.7A80.2,80.2,0,0,0,160,232h66a14,14,0,0,0,14-14V152A79.8,79.8,0,0,0,169.6,72.6ZM224,216H160a64.2,64.2,0,0,1-55.7-32.4A80.2,80.2,0,0,0,176,104a83.6,83.6,0,0,0-1.3-14.3A64,64,0,0,1,224,152Z" }, null, -1), u2e = [
  h2e
], a2e = { key: 3 }, _2e = ["stroke"], p2e = ["stroke"], y2e = { key: 4 }, $2e = ["stroke"], w2e = ["stroke"], f2e = { key: 5 }, g2e = ["stroke"], x2e = ["stroke"], j2e = {
  name: "PhChatsTeardrop"
}, kq1 = /* @__PURE__ */ $({
  ...j2e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", n2e, [
        e("path", {
          d: "M96,176H30a6,6,0,0,1-6-6V104A72,72,0,0,1,96,32h0a72,72,0,0,1,72,72h0A72,72,0,0,1,96,176Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, s2e),
        e("path", {
          d: "M92.1,176A72,72,0,0,0,160,224h66a6,6,0,0,0,6-6V152a71.9,71.9,0,0,0-68.1-71.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, r2e)
      ])) : o(i) === "duotone" ? (s(), r("g", i2e, [
        l2e,
        e("path", {
          d: "M96,176H30a6,6,0,0,1-6-6V104A72,72,0,0,1,96,32h0a72,72,0,0,1,72,72h0A72,72,0,0,1,96,176Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, d2e),
        e("path", {
          d: "M92.1,176A72,72,0,0,0,160,224h66a6,6,0,0,0,6-6V152a71.9,71.9,0,0,0-68.1-71.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k2e)
      ])) : o(i) === "fill" ? (s(), r("g", c2e, u2e)) : o(i) === "light" ? (s(), r("g", a2e, [
        e("path", {
          d: "M96,176H30a6,6,0,0,1-6-6V104A72,72,0,0,1,96,32h0a72,72,0,0,1,72,72h0A72,72,0,0,1,96,176Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _2e),
        e("path", {
          d: "M92.1,176A72,72,0,0,0,160,224h66a6,6,0,0,0,6-6V152a71.9,71.9,0,0,0-68.1-71.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, p2e)
      ])) : o(i) === "thin" ? (s(), r("g", y2e, [
        e("path", {
          d: "M96,176H30a6,6,0,0,1-6-6V104A72,72,0,0,1,96,32h0a72,72,0,0,1,72,72h0A72,72,0,0,1,96,176Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $2e),
        e("path", {
          d: "M92.1,176A72,72,0,0,0,160,224h66a6,6,0,0,0,6-6V152a71.9,71.9,0,0,0-68.1-71.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, w2e)
      ])) : o(i) === "regular" ? (s(), r("g", f2e, [
        e("path", {
          d: "M96,176H30a6,6,0,0,1-6-6V104A72,72,0,0,1,96,32h0a72,72,0,0,1,72,72h0A72,72,0,0,1,96,176Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g2e),
        e("path", {
          d: "M92.1,176A72,72,0,0,0,160,224h66a6,6,0,0,0,6-6V152a71.9,71.9,0,0,0-68.1-71.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, x2e)
      ])) : g("", !0)
    ], 16, t2e));
  }
}), m2e = ["width", "height", "fill", "transform"], M2e = { key: 0 }, v2e = ["stroke"], S2e = { key: 1 }, H2e = ["stroke"], A2e = { key: 2 }, V2e = /* @__PURE__ */ e("path", { d: "M104,192a8.5,8.5,0,0,1-5.7-2.3l-56-56a8.1,8.1,0,0,1,11.4-11.4L104,172.7,210.3,66.3a8.1,8.1,0,0,1,11.4,11.4l-112,112A8.5,8.5,0,0,1,104,192Z" }, null, -1), z2e = [
  V2e
], Z2e = { key: 3 }, C2e = ["stroke"], b2e = { key: 4 }, L2e = ["stroke"], B2e = { key: 5 }, P2e = ["stroke"], W2e = {
  name: "PhCheck"
}, cq1 = /* @__PURE__ */ $({
  ...W2e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", M2e, [
        e("polyline", {
          points: "216 72 104 184 48 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, v2e)
      ])) : o(i) === "duotone" ? (s(), r("g", S2e, [
        e("polyline", {
          points: "216 72 104 184 48 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H2e)
      ])) : o(i) === "fill" ? (s(), r("g", A2e, z2e)) : o(i) === "light" ? (s(), r("g", Z2e, [
        e("polyline", {
          points: "216 72 104 184 48 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, C2e)
      ])) : o(i) === "thin" ? (s(), r("g", b2e, [
        e("polyline", {
          points: "216 72 104 184 48 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, L2e)
      ])) : o(i) === "regular" ? (s(), r("g", B2e, [
        e("polyline", {
          points: "216 72 104 184 48 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P2e)
      ])) : g("", !0)
    ], 16, m2e));
  }
}), N2e = ["width", "height", "fill", "transform"], F2e = { key: 0 }, T2e = ["stroke"], D2e = ["stroke"], R2e = { key: 1 }, U2e = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), q2e = ["stroke"], G2e = ["stroke"], E2e = { key: 2 }, O2e = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm49.5,85.8-58.6,56a8.1,8.1,0,0,1-5.6,2.2,7.7,7.7,0,0,1-5.5-2.2l-29.3-28a8,8,0,1,1,11-11.6l23.8,22.7,53.2-50.7a8,8,0,0,1,11,11.6Z" }, null, -1), I2e = [
  O2e
], K2e = { key: 3 }, X2e = ["stroke"], J2e = ["stroke"], Q2e = { key: 4 }, Y2e = ["stroke"], o0e = ["stroke"], e0e = { key: 5 }, t0e = ["stroke"], n0e = ["stroke"], s0e = {
  name: "PhCheckCircle"
}, hq1 = /* @__PURE__ */ $({
  ...s0e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", F2e, [
        e("polyline", {
          points: "172 104 113.3 160 84 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, T2e),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, D2e)
      ])) : o(i) === "duotone" ? (s(), r("g", R2e, [
        U2e,
        e("polyline", {
          points: "172 104 113.3 160 84 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q2e),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G2e)
      ])) : o(i) === "fill" ? (s(), r("g", E2e, I2e)) : o(i) === "light" ? (s(), r("g", K2e, [
        e("polyline", {
          points: "172 104 113.3 160 84 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, X2e),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, J2e)
      ])) : o(i) === "thin" ? (s(), r("g", Q2e, [
        e("polyline", {
          points: "172 104 113.3 160 84 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Y2e),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, o0e)
      ])) : o(i) === "regular" ? (s(), r("g", e0e, [
        e("polyline", {
          points: "172 104 113.3 160 84 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t0e),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n0e)
      ])) : g("", !0)
    ], 16, N2e));
  }
}), r0e = ["width", "height", "fill", "transform"], i0e = { key: 0 }, l0e = ["stroke"], d0e = ["stroke"], k0e = { key: 1 }, c0e = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), h0e = ["stroke"], u0e = ["stroke"], a0e = { key: 2 }, _0e = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm-30.5,77.8-58.6,56a8.1,8.1,0,0,1-5.6,2.2,7.9,7.9,0,0,1-5.5-2.2l-29.3-28a8,8,0,1,1,11-11.6l23.8,22.7,53.2-50.7a8,8,0,0,1,11,11.6Z" }, null, -1), p0e = [
  _0e
], y0e = { key: 3 }, $0e = ["stroke"], w0e = ["stroke"], f0e = { key: 4 }, g0e = ["stroke"], x0e = ["stroke"], j0e = { key: 5 }, m0e = ["stroke"], M0e = ["stroke"], v0e = {
  name: "PhCheckSquare"
}, uq1 = /* @__PURE__ */ $({
  ...v0e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", i0e, [
        e("polyline", {
          points: "172 104 113.3 160 84 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, l0e),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, d0e)
      ])) : o(i) === "duotone" ? (s(), r("g", k0e, [
        c0e,
        e("polyline", {
          points: "172 104 113.3 160 84 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h0e),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u0e)
      ])) : o(i) === "fill" ? (s(), r("g", a0e, p0e)) : o(i) === "light" ? (s(), r("g", y0e, [
        e("polyline", {
          points: "172 104 113.3 160 84 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $0e),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, w0e)
      ])) : o(i) === "thin" ? (s(), r("g", f0e, [
        e("polyline", {
          points: "172 104 113.3 160 84 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, g0e),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, x0e)
      ])) : o(i) === "regular" ? (s(), r("g", j0e, [
        e("polyline", {
          points: "172 104 113.3 160 84 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m0e),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M0e)
      ])) : g("", !0)
    ], 16, r0e));
  }
}), S0e = ["width", "height", "fill", "transform"], H0e = { key: 0 }, A0e = ["stroke"], V0e = ["stroke"], z0e = { key: 1 }, Z0e = /* @__PURE__ */ e("polygon", {
  points: "44 44 44 196 60 212 212 212 212 44 44 44",
  opacity: "0.2"
}, null, -1), C0e = ["stroke"], b0e = ["stroke"], L0e = { key: 2 }, B0e = /* @__PURE__ */ e("path", { d: "M204,36H52A16,16,0,0,0,36,52v91.3a8,8,0,0,0,16,0V52H204V204H135.6a8,8,0,0,0,0,16H204a16,16,0,0,0,16-16V52A16,16,0,0,0,204,36Z" }, null, -1), P0e = /* @__PURE__ */ e("path", { d: "M133.7,146.3a8.1,8.1,0,0,0-11.4,0L64,204.7,37.7,178.3a8.1,8.1,0,0,0-11.4,11.4l32,32a8.2,8.2,0,0,0,11.4,0l64-64A8.1,8.1,0,0,0,133.7,146.3Z" }, null, -1), W0e = [
  B0e,
  P0e
], N0e = { key: 3 }, F0e = ["stroke"], T0e = ["stroke"], D0e = { key: 4 }, R0e = ["stroke"], U0e = ["stroke"], q0e = { key: 5 }, G0e = ["stroke"], E0e = ["stroke"], O0e = {
  name: "PhCheckSquareOffset"
}, aq1 = /* @__PURE__ */ $({
  ...O0e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", H0e, [
        e("path", {
          d: "M44,143.3V52a8,8,0,0,1,8-8H204a8,8,0,0,1,8,8V204a8,8,0,0,1-8,8H135.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, A0e),
        e("polyline", {
          points: "128 152 64 216 32 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, V0e)
      ])) : o(i) === "duotone" ? (s(), r("g", z0e, [
        Z0e,
        e("path", {
          d: "M44,143.3V52a8,8,0,0,1,8-8H204a8,8,0,0,1,8,8V204a8,8,0,0,1-8,8H135.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C0e),
        e("polyline", {
          points: "128 152 64 216 32 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b0e)
      ])) : o(i) === "fill" ? (s(), r("g", L0e, W0e)) : o(i) === "light" ? (s(), r("g", N0e, [
        e("path", {
          d: "M44,143.3V52a8,8,0,0,1,8-8H204a8,8,0,0,1,8,8V204a8,8,0,0,1-8,8H135.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, F0e),
        e("polyline", {
          points: "128 152 64 216 32 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, T0e)
      ])) : o(i) === "thin" ? (s(), r("g", D0e, [
        e("path", {
          d: "M44,143.3V52a8,8,0,0,1,8-8H204a8,8,0,0,1,8,8V204a8,8,0,0,1-8,8H135.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, R0e),
        e("polyline", {
          points: "128 152 64 216 32 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, U0e)
      ])) : o(i) === "regular" ? (s(), r("g", q0e, [
        e("path", {
          d: "M44,143.3V52a8,8,0,0,1,8-8H204a8,8,0,0,1,8,8V204a8,8,0,0,1-8,8H135.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G0e),
        e("polyline", {
          points: "128 152 64 216 32 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E0e)
      ])) : g("", !0)
    ], 16, S0e));
  }
}), I0e = ["width", "height", "fill", "transform"], K0e = { key: 0 }, X0e = ["stroke"], J0e = ["stroke"], Q0e = { key: 1 }, Y0e = ["stroke"], o8e = ["stroke"], e8e = { key: 2 }, t8e = /* @__PURE__ */ e("path", { d: "M153.7,89.7l-88,88a8.2,8.2,0,0,1-11.4,0l-44-44a8.1,8.1,0,0,1,11.4-11.4L60,160.7l82.3-82.4a8.1,8.1,0,0,1,11.4,11.4Zm92-11.4a8.1,8.1,0,0,0-11.4,0L152,160.7,134.3,143A8,8,0,0,0,123,154.3l23.3,23.4a8.2,8.2,0,0,0,11.4,0l88-88A8.1,8.1,0,0,0,245.7,78.3Z" }, null, -1), n8e = [
  t8e
], s8e = { key: 3 }, r8e = ["stroke"], i8e = ["stroke"], l8e = { key: 4 }, d8e = ["stroke"], k8e = ["stroke"], c8e = { key: 5 }, h8e = ["stroke"], u8e = ["stroke"], a8e = {
  name: "PhChecks"
}, _q1 = /* @__PURE__ */ $({
  ...a8e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", K0e, [
        e("polyline", {
          points: "144 84 56 172 12 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X0e),
        e("polyline", {
          points: "244 84 156 172 139.9 155.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, J0e)
      ])) : o(i) === "duotone" ? (s(), r("g", Q0e, [
        e("polyline", {
          points: "148 84 60 172 16 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y0e),
        e("polyline", {
          points: "240 84 152 172 128.6 148.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o8e)
      ])) : o(i) === "fill" ? (s(), r("g", e8e, n8e)) : o(i) === "light" ? (s(), r("g", s8e, [
        e("polyline", {
          points: "148 84 60 172 16 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, r8e),
        e("polyline", {
          points: "240 84 152 172 128.6 148.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, i8e)
      ])) : o(i) === "thin" ? (s(), r("g", l8e, [
        e("polyline", {
          points: "148 84 60 172 16 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, d8e),
        e("polyline", {
          points: "240 84 152 172 128.6 148.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, k8e)
      ])) : o(i) === "regular" ? (s(), r("g", c8e, [
        e("polyline", {
          points: "148 84 60 172 16 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h8e),
        e("polyline", {
          points: "240 84 152 172 128.6 148.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u8e)
      ])) : g("", !0)
    ], 16, I0e));
  }
}), _8e = ["width", "height", "fill", "transform"], p8e = { key: 0 }, y8e = ["stroke"], $8e = { key: 1 }, w8e = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), f8e = ["stroke"], g8e = { key: 2 }, x8e = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "104"
}, null, -1), j8e = [
  x8e
], m8e = { key: 3 }, M8e = ["stroke"], v8e = { key: 4 }, S8e = ["stroke"], H8e = { key: 5 }, A8e = ["stroke"], V8e = {
  name: "PhCircle"
}, pq1 = /* @__PURE__ */ $({
  ...V8e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", p8e, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, y8e)
      ])) : o(i) === "duotone" ? (s(), r("g", $8e, [
        w8e,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f8e)
      ])) : o(i) === "fill" ? (s(), r("g", g8e, j8e)) : o(i) === "light" ? (s(), r("g", m8e, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, M8e)
      ])) : o(i) === "thin" ? (s(), r("g", v8e, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, S8e)
      ])) : o(i) === "regular" ? (s(), r("g", H8e, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A8e)
      ])) : g("", !0)
    ], 16, _8e));
  }
}), z8e = ["width", "height", "fill", "transform"], Z8e = { key: 0 }, C8e = ["stroke"], b8e = ["stroke"], L8e = ["stroke"], B8e = ["stroke"], P8e = ["stroke"], W8e = ["stroke"], N8e = { key: 1 }, F8e = ["stroke"], T8e = ["stroke"], D8e = ["stroke"], R8e = ["stroke"], U8e = ["stroke"], q8e = ["stroke"], G8e = { key: 2 }, E8e = /* @__PURE__ */ e("path", { d: "M65.8,54.5a8,8,0,0,1,0,11.3A87.7,87.7,0,0,0,43,105.2a8.1,8.1,0,0,1-7.7,6l-2.1-.3a8,8,0,0,1-5.7-9.8,103.2,103.2,0,0,1,27-46.6A7.9,7.9,0,0,1,65.8,54.5ZM43,150.8a8,8,0,0,0-15.5,4.1,104.8,104.8,0,0,0,27,46.7,8,8,0,0,0,5.6,2.3,8.1,8.1,0,0,0,5.7-13.7A87.6,87.6,0,0,1,43,150.8ZM150.8,213a88.1,88.1,0,0,1-45.6,0,8,8,0,0,0-4.1,15.5,107,107,0,0,0,27,3.5,105.4,105.4,0,0,0,26.8-3.5,8,8,0,0,0-4.1-15.5Zm72-67.9a8,8,0,0,0-9.8,5.7,87.7,87.7,0,0,1-22.8,39.4,8.1,8.1,0,0,0,5.7,13.7,7.7,7.7,0,0,0,5.6-2.4,103.2,103.2,0,0,0,27-46.6A8,8,0,0,0,222.8,145.1ZM213,105.2a8.1,8.1,0,0,0,7.7,6l2.1-.3a8,8,0,0,0,5.7-9.8,104.8,104.8,0,0,0-27-46.7,7.9,7.9,0,0,0-11.3.1,8,8,0,0,0,0,11.3A87.6,87.6,0,0,1,213,105.2ZM105.2,43a88.1,88.1,0,0,1,45.6,0,7.6,7.6,0,0,0,2.1.3,8,8,0,0,0,2-15.8,104.4,104.4,0,0,0-53.8,0A8,8,0,0,0,105.2,43Z" }, null, -1), O8e = [
  E8e
], I8e = { key: 3 }, K8e = ["stroke"], X8e = ["stroke"], J8e = ["stroke"], Q8e = ["stroke"], Y8e = ["stroke"], ode = ["stroke"], ede = { key: 4 }, tde = ["stroke"], nde = ["stroke"], sde = ["stroke"], rde = ["stroke"], ide = ["stroke"], lde = ["stroke"], dde = { key: 5 }, kde = ["stroke"], cde = ["stroke"], hde = ["stroke"], ude = ["stroke"], ade = ["stroke"], _de = ["stroke"], pde = {
  name: "PhCircleDashed"
}, yq1 = /* @__PURE__ */ $({
  ...pde,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Z8e, [
        e("path", {
          d: "M35.3,103.1a96.4,96.4,0,0,1,24.8-43",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, C8e),
        e("path", {
          d: "M60.1,195.9a95.7,95.7,0,0,1-24.8-43.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, b8e),
        e("path", {
          d: "M152.9,220.7a94.2,94.2,0,0,1-49.7,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, L8e),
        e("path", {
          d: "M220.7,152.9a96.4,96.4,0,0,1-24.8,43",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, B8e),
        e("path", {
          d: "M195.9,60.1a95.7,95.7,0,0,1,24.8,43.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, P8e),
        e("path", {
          d: "M103.1,35.3a94.2,94.2,0,0,1,49.7,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, W8e)
      ])) : o(i) === "duotone" ? (s(), r("g", N8e, [
        e("path", {
          d: "M35.3,103.1a96.4,96.4,0,0,1,24.8-43",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F8e),
        e("path", {
          d: "M60.1,195.9a95.7,95.7,0,0,1-24.8-43.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T8e),
        e("path", {
          d: "M152.9,220.7a94.2,94.2,0,0,1-49.7,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D8e),
        e("path", {
          d: "M220.7,152.9a96.4,96.4,0,0,1-24.8,43",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R8e),
        e("path", {
          d: "M195.9,60.1a95.7,95.7,0,0,1,24.8,43.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U8e),
        e("path", {
          d: "M103.1,35.3a94.2,94.2,0,0,1,49.7,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q8e)
      ])) : o(i) === "fill" ? (s(), r("g", G8e, O8e)) : o(i) === "light" ? (s(), r("g", I8e, [
        e("path", {
          d: "M35.3,103.1a96.4,96.4,0,0,1,24.8-43",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, K8e),
        e("path", {
          d: "M60.1,195.9a95.7,95.7,0,0,1-24.8-43.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, X8e),
        e("path", {
          d: "M152.9,220.7a94.2,94.2,0,0,1-49.7,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, J8e),
        e("path", {
          d: "M220.7,152.9a96.4,96.4,0,0,1-24.8,43",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Q8e),
        e("path", {
          d: "M195.9,60.1a95.7,95.7,0,0,1,24.8,43.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Y8e),
        e("path", {
          d: "M103.1,35.3a94.2,94.2,0,0,1,49.7,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ode)
      ])) : o(i) === "thin" ? (s(), r("g", ede, [
        e("path", {
          d: "M35.3,103.1a96.4,96.4,0,0,1,24.8-43",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tde),
        e("path", {
          d: "M60.1,195.9a95.7,95.7,0,0,1-24.8-43.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nde),
        e("path", {
          d: "M152.9,220.7a94.2,94.2,0,0,1-49.7,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sde),
        e("path", {
          d: "M220.7,152.9a96.4,96.4,0,0,1-24.8,43",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rde),
        e("path", {
          d: "M195.9,60.1a95.7,95.7,0,0,1,24.8,43.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ide),
        e("path", {
          d: "M103.1,35.3a94.2,94.2,0,0,1,49.7,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lde)
      ])) : o(i) === "regular" ? (s(), r("g", dde, [
        e("path", {
          d: "M35.3,103.1a96.4,96.4,0,0,1,24.8-43",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kde),
        e("path", {
          d: "M60.1,195.9a95.7,95.7,0,0,1-24.8-43.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cde),
        e("path", {
          d: "M152.9,220.7a94.2,94.2,0,0,1-49.7,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hde),
        e("path", {
          d: "M220.7,152.9a96.4,96.4,0,0,1-24.8,43",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ude),
        e("path", {
          d: "M195.9,60.1a95.7,95.7,0,0,1,24.8,43.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ade),
        e("path", {
          d: "M103.1,35.3a94.2,94.2,0,0,1,49.7,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _de)
      ])) : g("", !0)
    ], 16, z8e));
  }
}), yde = ["width", "height", "fill", "transform"], $de = { key: 0 }, wde = ["stroke"], fde = ["stroke"], gde = ["stroke"], xde = { key: 1 }, jde = /* @__PURE__ */ e("path", {
  d: "M128,32a96,96,0,0,1,0,192",
  opacity: "0.2"
}, null, -1), mde = ["stroke"], Mde = ["stroke"], vde = { key: 2 }, Sde = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24ZM40,128a88.1,88.1,0,0,1,88-88V216A88.1,88.1,0,0,1,40,128Z" }, null, -1), Hde = [
  Sde
], Ade = { key: 3 }, Vde = ["stroke"], zde = ["stroke"], Zde = ["stroke"], Cde = ["stroke"], bde = { key: 4 }, Lde = ["stroke"], Bde = ["stroke"], Pde = ["stroke"], Wde = ["stroke"], Nde = { key: 5 }, Fde = ["stroke"], Tde = ["stroke"], Dde = ["stroke"], Rde = ["stroke"], Ude = {
  name: "PhCircleHalf"
}, $q1 = /* @__PURE__ */ $({
  ...Ude,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $de, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wde),
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fde),
        e("line", {
          x1: "176",
          y1: "44.8",
          x2: "176",
          y2: "211.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gde)
      ])) : o(i) === "duotone" ? (s(), r("g", xde, [
        jde,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mde),
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mde)
      ])) : o(i) === "fill" ? (s(), r("g", vde, Hde)) : o(i) === "light" ? (s(), r("g", Ade, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vde),
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zde),
        e("line", {
          x1: "192",
          y1: "56.5",
          x2: "192",
          y2: "199.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zde),
        e("line", {
          x1: "160",
          y1: "37.5",
          x2: "160",
          y2: "218.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cde)
      ])) : o(i) === "thin" ? (s(), r("g", bde, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lde),
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bde),
        e("line", {
          x1: "192",
          y1: "56.5",
          x2: "192",
          y2: "199.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pde),
        e("line", {
          x1: "160",
          y1: "37.5",
          x2: "160",
          y2: "218.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wde)
      ])) : o(i) === "regular" ? (s(), r("g", Nde, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fde),
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tde),
        e("line", {
          x1: "192",
          y1: "56.5",
          x2: "192",
          y2: "199.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dde),
        e("line", {
          x1: "160",
          y1: "37.5",
          x2: "160",
          y2: "218.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rde)
      ])) : g("", !0)
    ], 16, yde));
  }
}), qde = ["width", "height", "fill", "transform"], Gde = { key: 0 }, Ede = ["stroke"], Ode = ["stroke"], Ide = ["stroke"], Kde = ["stroke"], Xde = ["stroke"], Jde = { key: 1 }, Qde = /* @__PURE__ */ e("path", {
  d: "M195.9,60.1A96,96,0,0,1,60.1,195.9Z",
  opacity: "0.2"
}, null, -1), Yde = ["stroke"], oke = ["stroke"], eke = { key: 2 }, tke = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24ZM40,128A88,88,0,0,1,190.2,65.8L65.8,190.2A87.7,87.7,0,0,1,40,128Z" }, null, -1), nke = [
  tke
], ske = { key: 3 }, rke = ["stroke"], ike = ["stroke"], lke = ["stroke"], dke = ["stroke"], kke = ["stroke"], cke = ["stroke"], hke = { key: 4 }, uke = ["stroke"], ake = ["stroke"], _ke = ["stroke"], pke = ["stroke"], yke = ["stroke"], $ke = ["stroke"], wke = { key: 5 }, fke = ["stroke"], gke = ["stroke"], xke = ["stroke"], jke = ["stroke"], mke = ["stroke"], Mke = ["stroke"], vke = {
  name: "PhCircleHalfTilt"
}, wq1 = /* @__PURE__ */ $({
  ...vke,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Gde, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ede),
        e("line", {
          x1: "195.9",
          y1: "60.1",
          x2: "60.1",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ode),
        e("line", {
          x1: "188",
          y1: "68",
          x2: "188",
          y2: "202.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ide),
        e("line", {
          x1: "148",
          y1: "108",
          x2: "148",
          y2: "221.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kde),
        e("line", {
          x1: "108",
          y1: "148",
          x2: "108",
          y2: "221.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xde)
      ])) : o(i) === "duotone" ? (s(), r("g", Jde, [
        Qde,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yde),
        e("line", {
          x1: "195.9",
          y1: "60.1",
          x2: "60.1",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oke)
      ])) : o(i) === "fill" ? (s(), r("g", eke, nke)) : o(i) === "light" ? (s(), r("g", ske, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rke),
        e("line", {
          x1: "195.9",
          y1: "60.1",
          x2: "60.1",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ike),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lke),
        e("line", {
          x1: "192",
          y1: "64",
          x2: "192",
          y2: "199.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dke),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "160",
          y2: "218.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kke),
        e("line", {
          x1: "96",
          y1: "160",
          x2: "96",
          y2: "218.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cke)
      ])) : o(i) === "thin" ? (s(), r("g", hke, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uke),
        e("line", {
          x1: "195.9",
          y1: "60.1",
          x2: "60.1",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ake),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _ke),
        e("line", {
          x1: "192",
          y1: "64",
          x2: "192",
          y2: "199.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pke),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "160",
          y2: "218.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yke),
        e("line", {
          x1: "96",
          y1: "160",
          x2: "96",
          y2: "218.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $ke)
      ])) : o(i) === "regular" ? (s(), r("g", wke, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fke),
        e("line", {
          x1: "195.9",
          y1: "60.1",
          x2: "60.1",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gke),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xke),
        e("line", {
          x1: "192",
          y1: "64",
          x2: "192",
          y2: "199.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jke),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "160",
          y2: "218.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mke),
        e("line", {
          x1: "96",
          y1: "160",
          x2: "96",
          y2: "218.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mke)
      ])) : g("", !0)
    ], 16, qde));
  }
}), Ske = ["width", "height", "fill", "transform"], Hke = { key: 0 }, Ake = ["stroke"], Vke = { key: 1 }, zke = ["stroke"], Zke = { key: 2 }, Cke = /* @__PURE__ */ e("path", { d: "M232,128A104,104,0,1,1,84.7,33.4a8.1,8.1,0,0,1,10.6,4,8,8,0,0,1-4,10.6,88,88,0,1,0,73.4,0,8,8,0,0,1-4-10.6,8.1,8.1,0,0,1,10.6-4A104.4,104.4,0,0,1,232,128Z" }, null, -1), bke = [
  Cke
], Lke = { key: 3 }, Bke = ["stroke"], Pke = { key: 4 }, Wke = ["stroke"], Nke = { key: 5 }, Fke = ["stroke"], Tke = {
  name: "PhCircleNotch"
}, fq1 = /* @__PURE__ */ $({
  ...Tke,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Hke, [
        e("path", {
          d: "M168,40.7a96,96,0,1,1-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ake)
      ])) : o(i) === "duotone" ? (s(), r("g", Vke, [
        e("path", {
          d: "M168,40.7a96,96,0,1,1-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zke)
      ])) : o(i) === "fill" ? (s(), r("g", Zke, bke)) : o(i) === "light" ? (s(), r("g", Lke, [
        e("path", {
          d: "M168,40.7a96,96,0,1,1-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bke)
      ])) : o(i) === "thin" ? (s(), r("g", Pke, [
        e("path", {
          d: "M168,40.7a96,96,0,1,1-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wke)
      ])) : o(i) === "regular" ? (s(), r("g", Nke, [
        e("path", {
          d: "M168,40.7a96,96,0,1,1-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fke)
      ])) : g("", !0)
    ], 16, Ske));
  }
}), Dke = ["width", "height", "fill", "transform"], Rke = { key: 0 }, Uke = ["stroke"], qke = { key: 1 }, Gke = /* @__PURE__ */ e("path", {
  d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
  opacity: "0.2"
}, null, -1), Eke = ["stroke"], Oke = { key: 2 }, Ike = /* @__PURE__ */ e("path", { d: "M240,128c0,10.4-7.5,18.3-14.1,25.2-3.8,3.9-7.7,8-9.2,11.5s-1.4,8.7-1.5,14c-.1,9.7-.3,20.8-8,28.5s-18.8,7.9-28.5,8c-5.3.1-10.7.2-14,1.5s-7.6,5.4-11.5,9.2c-6.9,6.6-14.8,14.1-25.2,14.1s-18.3-7.5-25.2-14.1c-3.9-3.8-8-7.7-11.5-9.2s-8.7-1.4-14-1.5c-9.7-.1-20.8-.3-28.5-8s-7.9-18.8-8-28.5c-.1-5.3-.2-10.7-1.5-14s-5.4-7.6-9.2-11.5C23.5,146.3,16,138.4,16,128s7.5-18.3,14.1-25.2c3.8-3.9,7.7-8,9.2-11.5s1.4-8.7,1.5-14c.1-9.7.3-20.8,8-28.5s18.8-7.9,28.5-8c5.3-.1,10.7-.2,14-1.5s7.6-5.4,11.5-9.2C109.7,23.5,117.6,16,128,16s18.3,7.5,25.2,14.1c3.9,3.8,8,7.7,11.5,9.2s8.7,1.4,14,1.5c9.7.1,20.8.3,28.5,8s7.9,18.8,8,28.5c.1,5.3.2,10.7,1.5,14s5.4,7.6,9.2,11.5C232.5,109.7,240,117.6,240,128Z" }, null, -1), Kke = [
  Ike
], Xke = { key: 3 }, Jke = ["stroke"], Qke = { key: 4 }, Yke = ["stroke"], oce = { key: 5 }, ece = ["stroke"], tce = {
  name: "PhCircleWavy"
}, gq1 = /* @__PURE__ */ $({
  ...tce,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Rke, [
        e("path", {
          d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Uke)
      ])) : o(i) === "duotone" ? (s(), r("g", qke, [
        Gke,
        e("path", {
          d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Eke)
      ])) : o(i) === "fill" ? (s(), r("g", Oke, Kke)) : o(i) === "light" ? (s(), r("g", Xke, [
        e("path", {
          d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jke)
      ])) : o(i) === "thin" ? (s(), r("g", Qke, [
        e("path", {
          d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Yke)
      ])) : o(i) === "regular" ? (s(), r("g", oce, [
        e("path", {
          d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ece)
      ])) : g("", !0)
    ], 16, Dke));
  }
}), nce = ["width", "height", "fill", "transform"], sce = { key: 0 }, rce = ["stroke"], ice = ["stroke"], lce = { key: 1 }, dce = /* @__PURE__ */ e("path", {
  d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
  opacity: "0.2"
}, null, -1), kce = ["stroke"], cce = ["stroke"], hce = { key: 2 }, uce = /* @__PURE__ */ e("path", { d: "M225.9,102.8c-3.8-3.9-7.7-8-9.2-11.5s-1.4-8.7-1.5-14c-.1-9.7-.3-20.8-8-28.5s-18.8-7.9-28.5-8c-5.3-.1-10.7-.2-14-1.5s-7.6-5.4-11.5-9.2C146.3,23.5,138.4,16,128,16s-18.3,7.5-25.2,14.1c-3.9,3.8-8,7.7-11.5,9.2s-8.7,1.4-14,1.5c-9.7.1-20.8.3-28.5,8s-7.9,18.8-8,28.5c-.1,5.3-.2,10.7-1.5,14s-5.4,7.6-9.2,11.5C23.5,109.7,16,117.6,16,128s7.5,18.3,14.1,25.2c3.8,3.9,7.7,8,9.2,11.5s1.4,8.7,1.5,14c.1,9.7.3,20.8,8,28.5s18.8,7.9,28.5,8c5.3.1,10.7.2,14,1.5s7.6,5.4,11.5,9.2c6.9,6.6,14.8,14.1,25.2,14.1s18.3-7.5,25.2-14.1c3.9-3.8,8-7.7,11.5-9.2s8.7-1.4,14-1.5c9.7-.1,20.8-.3,28.5-8s7.9-18.8,8-28.5c.1-5.3.2-10.7,1.5-14s5.4-7.6,9.2-11.5c6.6-6.9,14.1-14.8,14.1-25.2S232.5,109.7,225.9,102.8Zm-48.4,7-58.6,56a8.1,8.1,0,0,1-5.6,2.2,7.9,7.9,0,0,1-5.5-2.2l-29.3-28a8,8,0,1,1,11-11.6l23.8,22.7,53.2-50.7a8,8,0,0,1,11,11.6Z" }, null, -1), ace = [
  uce
], _ce = { key: 3 }, pce = ["stroke"], yce = ["stroke"], $ce = { key: 4 }, wce = ["stroke"], fce = ["stroke"], gce = { key: 5 }, xce = ["stroke"], jce = ["stroke"], mce = {
  name: "PhCircleWavyCheck"
}, xq1 = /* @__PURE__ */ $({
  ...mce,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", sce, [
        e("path", {
          d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rce),
        e("polyline", {
          points: "172 104 113.3 160 84 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ice)
      ])) : o(i) === "duotone" ? (s(), r("g", lce, [
        dce,
        e("path", {
          d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kce),
        e("polyline", {
          points: "172 104 113.3 160 84 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cce)
      ])) : o(i) === "fill" ? (s(), r("g", hce, ace)) : o(i) === "light" ? (s(), r("g", _ce, [
        e("path", {
          d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pce),
        e("polyline", {
          points: "172 104 113.3 160 84 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yce)
      ])) : o(i) === "thin" ? (s(), r("g", $ce, [
        e("path", {
          d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wce),
        e("polyline", {
          points: "172 104 113.3 160 84 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fce)
      ])) : o(i) === "regular" ? (s(), r("g", gce, [
        e("path", {
          d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xce),
        e("polyline", {
          points: "172 104 113.3 160 84 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jce)
      ])) : g("", !0)
    ], 16, nce));
  }
}), Mce = ["width", "height", "fill", "transform"], vce = { key: 0 }, Sce = ["stroke"], Hce = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "176",
  r: "16"
}, null, -1), Ace = ["stroke"], Vce = { key: 1 }, zce = /* @__PURE__ */ e("path", {
  d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
  opacity: "0.2"
}, null, -1), Zce = ["stroke"], Cce = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "12"
}, null, -1), bce = ["stroke"], Lce = { key: 2 }, Bce = /* @__PURE__ */ e("path", { d: "M225.9,102.8c-3.8-3.9-7.7-8-9.2-11.5s-1.4-8.7-1.5-14c-.1-9.7-.3-20.8-8-28.5s-18.8-7.9-28.5-8c-5.3-.1-10.7-.2-14-1.5s-7.6-5.4-11.5-9.2C146.3,23.5,138.4,16,128,16s-18.3,7.5-25.2,14.1c-3.9,3.8-8,7.7-11.5,9.2s-8.7,1.4-14,1.5c-9.7.1-20.8.3-28.5,8s-7.9,18.8-8,28.5c-.1,5.3-.2,10.7-1.5,14s-5.4,7.6-9.2,11.5C23.5,109.7,16,117.6,16,128s7.5,18.3,14.1,25.2c3.8,3.9,7.7,8,9.2,11.5s1.4,8.7,1.5,14c.1,9.7.3,20.8,8,28.5s18.8,7.9,28.5,8c5.3.1,10.7.2,14,1.5s7.6,5.4,11.5,9.2c6.9,6.6,14.8,14.1,25.2,14.1s18.3-7.5,25.2-14.1c3.9-3.8,8-7.7,11.5-9.2s8.7-1.4,14-1.5c9.7-.1,20.8-.3,28.5-8s7.9-18.8,8-28.5c.1-5.3.2-10.7,1.5-14s5.4-7.6,9.2-11.5c6.6-6.9,14.1-14.8,14.1-25.2S232.5,109.7,225.9,102.8ZM128,192a12,12,0,1,1,12-12A12,12,0,0,1,128,192Zm8-48.9v.9a8,8,0,0,1-16,0v-8a8,8,0,0,1,8-8,20,20,0,1,0-20-20,8,8,0,0,1-16,0,36,36,0,1,1,44,35.1Z" }, null, -1), Pce = [
  Bce
], Wce = { key: 3 }, Nce = ["stroke"], Fce = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "10"
}, null, -1), Tce = ["stroke"], Dce = { key: 4 }, Rce = ["stroke"], Uce = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "8"
}, null, -1), qce = ["stroke"], Gce = { key: 5 }, Ece = ["stroke"], Oce = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "12"
}, null, -1), Ice = ["stroke"], Kce = {
  name: "PhCircleWavyQuestion"
}, jq1 = /* @__PURE__ */ $({
  ...Kce,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", vce, [
        e("path", {
          d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Sce),
        Hce,
        e("path", {
          d: "M128,136a28,28,0,1,0-28-28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ace)
      ])) : o(i) === "duotone" ? (s(), r("g", Vce, [
        zce,
        e("path", {
          d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zce),
        Cce,
        e("path", {
          d: "M128,144v-8a28,28,0,1,0-28-28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bce)
      ])) : o(i) === "fill" ? (s(), r("g", Lce, Pce)) : o(i) === "light" ? (s(), r("g", Wce, [
        e("path", {
          d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Nce),
        Fce,
        e("path", {
          d: "M128,144v-8a28,28,0,1,0-28-28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Tce)
      ])) : o(i) === "thin" ? (s(), r("g", Dce, [
        e("path", {
          d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Rce),
        Uce,
        e("path", {
          d: "M128,144v-8a28,28,0,1,0-28-28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qce)
      ])) : o(i) === "regular" ? (s(), r("g", Gce, [
        e("path", {
          d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ece),
        Oce,
        e("path", {
          d: "M128,144v-8a28,28,0,1,0-28-28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ice)
      ])) : g("", !0)
    ], 16, Mce));
  }
}), Xce = ["width", "height", "fill", "transform"], Jce = { key: 0 }, Qce = ["stroke"], Yce = ["stroke"], ohe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "172",
  r: "16"
}, null, -1), ehe = { key: 1 }, the = /* @__PURE__ */ e("path", {
  d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
  opacity: "0.2"
}, null, -1), nhe = ["stroke"], she = ["stroke"], rhe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "172",
  r: "12"
}, null, -1), ihe = { key: 2 }, lhe = /* @__PURE__ */ e("path", { d: "M225.9,102.8c-3.8-3.9-7.7-8-9.2-11.5s-1.4-8.7-1.5-14c-.1-9.7-.3-20.8-8-28.5s-18.8-7.9-28.5-8c-5.3-.1-10.7-.2-14-1.5s-7.6-5.4-11.5-9.2C146.3,23.5,138.4,16,128,16s-18.3,7.5-25.2,14.1c-3.9,3.8-8,7.7-11.5,9.2s-8.7,1.4-14,1.5c-9.7.1-20.8.3-28.5,8s-7.9,18.8-8,28.5c-.1,5.3-.2,10.7-1.5,14s-5.4,7.6-9.2,11.5C23.5,109.7,16,117.6,16,128s7.5,18.3,14.1,25.2c3.8,3.9,7.7,8,9.2,11.5s1.4,8.7,1.5,14c.1,9.7.3,20.8,8,28.5s18.8,7.9,28.5,8c5.3.1,10.7.2,14,1.5s7.6,5.4,11.5,9.2c6.9,6.6,14.8,14.1,25.2,14.1s18.3-7.5,25.2-14.1c3.9-3.8,8-7.7,11.5-9.2s8.7-1.4,14-1.5c9.7-.1,20.8-.3,28.5-8s7.9-18.8,8-28.5c.1-5.3.2-10.7,1.5-14s5.4-7.6,9.2-11.5c6.6-6.9,14.1-14.8,14.1-25.2S232.5,109.7,225.9,102.8ZM120,80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z" }, null, -1), dhe = [
  lhe
], khe = { key: 3 }, che = ["stroke"], hhe = ["stroke"], uhe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "172",
  r: "10"
}, null, -1), ahe = { key: 4 }, _he = ["stroke"], phe = ["stroke"], yhe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "172",
  r: "8"
}, null, -1), $he = { key: 5 }, whe = ["stroke"], fhe = ["stroke"], ghe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "172",
  r: "12"
}, null, -1), xhe = {
  name: "PhCircleWavyWarning"
}, mq1 = /* @__PURE__ */ $({
  ...xhe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Jce, [
        e("path", {
          d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qce),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Yce),
        ohe
      ])) : o(i) === "duotone" ? (s(), r("g", ehe, [
        the,
        e("path", {
          d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nhe),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, she),
        rhe
      ])) : o(i) === "fill" ? (s(), r("g", ihe, dhe)) : o(i) === "light" ? (s(), r("g", khe, [
        e("path", {
          d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, che),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hhe),
        uhe
      ])) : o(i) === "thin" ? (s(), r("g", ahe, [
        e("path", {
          d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _he),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, phe),
        yhe
      ])) : o(i) === "regular" ? (s(), r("g", $he, [
        e("path", {
          d: "M54.5,201.5c-9.2-9.2-3.1-28.5-7.8-39.8S24,140.5,24,128s17.8-22,22.7-33.7-1.4-30.6,7.8-39.8S83,51.4,94.3,46.7,115.5,24,128,24s22,17.8,33.7,22.7,30.6-1.4,39.8,7.8,3.1,28.5,7.8,39.8S232,115.5,232,128s-17.8,22-22.7,33.7,1.4,30.6-7.8,39.8-28.5,3.1-39.8,7.8S140.5,232,128,232s-22-17.8-33.7-22.7S63.7,210.7,54.5,201.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, whe),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fhe),
        ghe
      ])) : g("", !0)
    ], 16, Xce));
  }
}), jhe = ["width", "height", "fill", "transform"], mhe = { key: 0 }, Mhe = ["stroke"], vhe = ["stroke"], She = ["stroke"], Hhe = ["stroke"], Ahe = { key: 1 }, Vhe = /* @__PURE__ */ e("circle", {
  cx: "76",
  cy: "180",
  r: "36",
  opacity: "0.2"
}, null, -1), zhe = /* @__PURE__ */ e("circle", {
  cx: "76",
  cy: "76",
  r: "36",
  opacity: "0.2"
}, null, -1), Zhe = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "76",
  r: "36",
  opacity: "0.2"
}, null, -1), Che = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "180",
  r: "36",
  opacity: "0.2"
}, null, -1), bhe = ["stroke"], Lhe = ["stroke"], Bhe = ["stroke"], Phe = ["stroke"], Whe = { key: 2 }, Nhe = /* @__PURE__ */ e("circle", {
  cx: "76",
  cy: "76",
  r: "44"
}, null, -1), Fhe = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "76",
  r: "44"
}, null, -1), The = /* @__PURE__ */ e("circle", {
  cx: "76",
  cy: "180",
  r: "44"
}, null, -1), Dhe = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "180",
  r: "44"
}, null, -1), Rhe = [
  Nhe,
  Fhe,
  The,
  Dhe
], Uhe = { key: 3 }, qhe = ["stroke"], Ghe = ["stroke"], Ehe = ["stroke"], Ohe = ["stroke"], Ihe = { key: 4 }, Khe = ["stroke"], Xhe = ["stroke"], Jhe = ["stroke"], Qhe = ["stroke"], Yhe = { key: 5 }, o6e = ["stroke"], e6e = ["stroke"], t6e = ["stroke"], n6e = ["stroke"], s6e = {
  name: "PhCirclesFour"
}, Mq1 = /* @__PURE__ */ $({
  ...s6e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", mhe, [
        e("circle", {
          cx: "74",
          cy: "74",
          r: "34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mhe),
        e("circle", {
          cx: "182",
          cy: "74",
          r: "34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vhe),
        e("circle", {
          cx: "74",
          cy: "182",
          r: "34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, She),
        e("circle", {
          cx: "182",
          cy: "182",
          r: "34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hhe)
      ])) : o(i) === "duotone" ? (s(), r("g", Ahe, [
        Vhe,
        zhe,
        Zhe,
        Che,
        e("circle", {
          cx: "76",
          cy: "76",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bhe),
        e("circle", {
          cx: "180",
          cy: "76",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lhe),
        e("circle", {
          cx: "180",
          cy: "180",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bhe),
        e("circle", {
          cx: "76",
          cy: "180",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Phe)
      ])) : o(i) === "fill" ? (s(), r("g", Whe, Rhe)) : o(i) === "light" ? (s(), r("g", Uhe, [
        e("circle", {
          cx: "76",
          cy: "76",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qhe),
        e("circle", {
          cx: "180",
          cy: "76",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ghe),
        e("circle", {
          cx: "76",
          cy: "180",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ehe),
        e("circle", {
          cx: "180",
          cy: "180",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ohe)
      ])) : o(i) === "thin" ? (s(), r("g", Ihe, [
        e("circle", {
          cx: "76",
          cy: "76",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Khe),
        e("circle", {
          cx: "180",
          cy: "76",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xhe),
        e("circle", {
          cx: "76",
          cy: "180",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jhe),
        e("circle", {
          cx: "180",
          cy: "180",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qhe)
      ])) : o(i) === "regular" ? (s(), r("g", Yhe, [
        e("circle", {
          cx: "76",
          cy: "76",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o6e),
        e("circle", {
          cx: "180",
          cy: "76",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e6e),
        e("circle", {
          cx: "76",
          cy: "180",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t6e),
        e("circle", {
          cx: "180",
          cy: "180",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n6e)
      ])) : g("", !0)
    ], 16, jhe));
  }
}), r6e = ["width", "height", "fill", "transform"], i6e = { key: 0 }, l6e = ["stroke"], d6e = ["stroke"], k6e = ["stroke"], c6e = { key: 1 }, h6e = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "68",
  r: "40",
  opacity: "0.2"
}, null, -1), u6e = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "172",
  r: "40",
  opacity: "0.2"
}, null, -1), a6e = /* @__PURE__ */ e("circle", {
  cx: "68",
  cy: "172",
  r: "40",
  opacity: "0.2"
}, null, -1), _6e = ["stroke"], p6e = ["stroke"], y6e = ["stroke"], $6e = { key: 2 }, w6e = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "68",
  r: "48"
}, null, -1), f6e = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "172",
  r: "48"
}, null, -1), g6e = /* @__PURE__ */ e("circle", {
  cx: "68",
  cy: "172",
  r: "48"
}, null, -1), x6e = [
  w6e,
  f6e,
  g6e
], j6e = { key: 3 }, m6e = ["stroke"], M6e = ["stroke"], v6e = ["stroke"], S6e = { key: 4 }, H6e = ["stroke"], A6e = ["stroke"], V6e = ["stroke"], z6e = { key: 5 }, Z6e = ["stroke"], C6e = ["stroke"], b6e = ["stroke"], L6e = {
  name: "PhCirclesThree"
}, vq1 = /* @__PURE__ */ $({
  ...L6e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", i6e, [
        e("circle", {
          cx: "128",
          cy: "68",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, l6e),
        e("circle", {
          cx: "188",
          cy: "172",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, d6e),
        e("circle", {
          cx: "68",
          cy: "172",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, k6e)
      ])) : o(i) === "duotone" ? (s(), r("g", c6e, [
        h6e,
        u6e,
        a6e,
        e("circle", {
          cx: "128",
          cy: "68",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _6e),
        e("circle", {
          cx: "188",
          cy: "172",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p6e),
        e("circle", {
          cx: "68",
          cy: "172",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y6e)
      ])) : o(i) === "fill" ? (s(), r("g", $6e, x6e)) : o(i) === "light" ? (s(), r("g", j6e, [
        e("circle", {
          cx: "128",
          cy: "68",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, m6e),
        e("circle", {
          cx: "188",
          cy: "172",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, M6e),
        e("circle", {
          cx: "68",
          cy: "172",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, v6e)
      ])) : o(i) === "thin" ? (s(), r("g", S6e, [
        e("circle", {
          cx: "128",
          cy: "68",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, H6e),
        e("circle", {
          cx: "188",
          cy: "172",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, A6e),
        e("circle", {
          cx: "68",
          cy: "172",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, V6e)
      ])) : o(i) === "regular" ? (s(), r("g", z6e, [
        e("circle", {
          cx: "128",
          cy: "68",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z6e),
        e("circle", {
          cx: "188",
          cy: "172",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C6e),
        e("circle", {
          cx: "68",
          cy: "172",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b6e)
      ])) : g("", !0)
    ], 16, r6e));
  }
}), B6e = ["width", "height", "fill", "transform"], P6e = { key: 0 }, W6e = ["stroke"], N6e = ["stroke"], F6e = ["stroke"], T6e = ["stroke"], D6e = ["stroke"], R6e = { key: 1 }, U6e = /* @__PURE__ */ e("circle", {
  cx: "76",
  cy: "76",
  r: "36",
  opacity: "0.2"
}, null, -1), q6e = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "76",
  r: "36",
  opacity: "0.2"
}, null, -1), G6e = /* @__PURE__ */ e("circle", {
  cx: "76",
  cy: "180",
  r: "36",
  opacity: "0.2"
}, null, -1), E6e = ["stroke"], O6e = ["stroke"], I6e = ["stroke"], K6e = ["stroke"], X6e = ["stroke"], J6e = { key: 2 }, Q6e = /* @__PURE__ */ e("circle", {
  cx: "76",
  cy: "76",
  r: "44"
}, null, -1), Y6e = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "76",
  r: "44"
}, null, -1), oue = /* @__PURE__ */ e("circle", {
  cx: "76",
  cy: "180",
  r: "44"
}, null, -1), eue = /* @__PURE__ */ e("path", { d: "M208,172H188V152a8,8,0,0,0-16,0v20H152a8,8,0,0,0,0,16h20v20a8,8,0,0,0,16,0V188h20a8,8,0,0,0,0-16Z" }, null, -1), tue = [
  Q6e,
  Y6e,
  oue,
  eue
], nue = { key: 3 }, sue = ["stroke"], rue = ["stroke"], iue = ["stroke"], lue = ["stroke"], due = ["stroke"], kue = { key: 4 }, cue = ["stroke"], hue = ["stroke"], uue = ["stroke"], aue = ["stroke"], _ue = ["stroke"], pue = { key: 5 }, yue = ["stroke"], $ue = ["stroke"], wue = ["stroke"], fue = ["stroke"], gue = ["stroke"], xue = {
  name: "PhCirclesThreePlus"
}, Sq1 = /* @__PURE__ */ $({
  ...xue,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", P6e, [
        e("circle", {
          cx: "74",
          cy: "74",
          r: "34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, W6e),
        e("circle", {
          cx: "182",
          cy: "74",
          r: "34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, N6e),
        e("circle", {
          cx: "74",
          cy: "182",
          r: "34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, F6e),
        e("line", {
          x1: "182",
          y1: "156",
          x2: "182",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, T6e),
        e("line", {
          x1: "208",
          y1: "182",
          x2: "156",
          y2: "182",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, D6e)
      ])) : o(i) === "duotone" ? (s(), r("g", R6e, [
        U6e,
        q6e,
        G6e,
        e("circle", {
          cx: "76",
          cy: "76",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E6e),
        e("circle", {
          cx: "180",
          cy: "76",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O6e),
        e("circle", {
          cx: "76",
          cy: "180",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I6e),
        e("line", {
          x1: "180",
          y1: "152",
          x2: "180",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K6e),
        e("line", {
          x1: "208",
          y1: "180",
          x2: "152",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X6e)
      ])) : o(i) === "fill" ? (s(), r("g", J6e, tue)) : o(i) === "light" ? (s(), r("g", nue, [
        e("circle", {
          cx: "76",
          cy: "76",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sue),
        e("circle", {
          cx: "180",
          cy: "76",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rue),
        e("circle", {
          cx: "76",
          cy: "180",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iue),
        e("line", {
          x1: "180",
          y1: "152",
          x2: "180",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lue),
        e("line", {
          x1: "208",
          y1: "180",
          x2: "152",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, due)
      ])) : o(i) === "thin" ? (s(), r("g", kue, [
        e("circle", {
          cx: "76",
          cy: "76",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cue),
        e("circle", {
          cx: "180",
          cy: "76",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hue),
        e("circle", {
          cx: "76",
          cy: "180",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uue),
        e("line", {
          x1: "180",
          y1: "152",
          x2: "180",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aue),
        e("line", {
          x1: "208",
          y1: "180",
          x2: "152",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _ue)
      ])) : o(i) === "regular" ? (s(), r("g", pue, [
        e("circle", {
          cx: "76",
          cy: "76",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yue),
        e("circle", {
          cx: "180",
          cy: "76",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $ue),
        e("circle", {
          cx: "76",
          cy: "180",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wue),
        e("line", {
          x1: "180",
          y1: "152",
          x2: "180",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fue),
        e("line", {
          x1: "208",
          y1: "180",
          x2: "152",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gue)
      ])) : g("", !0)
    ], 16, B6e));
  }
}), jue = ["width", "height", "fill", "transform"], mue = { key: 0 }, Mue = ["stroke"], vue = ["stroke"], Sue = { key: 1 }, Hue = /* @__PURE__ */ e("path", {
  d: "M160,40a40,40,0,0,1,8,24v8H88V64a40,40,0,0,1,8-24H56a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8Z",
  opacity: "0.2"
}, null, -1), Aue = ["stroke"], Vue = ["stroke"], zue = { key: 2 }, Zue = /* @__PURE__ */ e("path", { d: "M200,32H163.7a47.8,47.8,0,0,0-71.4,0H56A16,16,0,0,0,40,48V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm-72,0a32.1,32.1,0,0,1,32,32H96A32.1,32.1,0,0,1,128,32Z" }, null, -1), Cue = [
  Zue
], bue = { key: 3 }, Lue = ["stroke"], Bue = ["stroke"], Pue = { key: 4 }, Wue = ["stroke"], Nue = ["stroke"], Fue = { key: 5 }, Tue = ["stroke"], Due = ["stroke"], Rue = {
  name: "PhClipboard"
}, Hq1 = /* @__PURE__ */ $({
  ...Rue,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", mue, [
        e("path", {
          d: "M160,40h40a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mue),
        e("path", {
          d: "M88,72V64a40,40,0,0,1,80,0v8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vue)
      ])) : o(i) === "duotone" ? (s(), r("g", Sue, [
        Hue,
        e("path", {
          d: "M160,40h40a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Aue),
        e("path", {
          d: "M88,72V64a40,40,0,0,1,80,0v8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vue)
      ])) : o(i) === "fill" ? (s(), r("g", zue, Cue)) : o(i) === "light" ? (s(), r("g", bue, [
        e("path", {
          d: "M160,40h40a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lue),
        e("path", {
          d: "M88,72V64a40,40,0,0,1,80,0v8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bue)
      ])) : o(i) === "thin" ? (s(), r("g", Pue, [
        e("path", {
          d: "M160,40h40a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wue),
        e("path", {
          d: "M88,72V64a40,40,0,0,1,80,0v8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nue)
      ])) : o(i) === "regular" ? (s(), r("g", Fue, [
        e("path", {
          d: "M160,40h40a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tue),
        e("path", {
          d: "M88,72V64a40,40,0,0,1,80,0v8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Due)
      ])) : g("", !0)
    ], 16, jue));
  }
}), Uue = ["width", "height", "fill", "transform"], que = { key: 0 }, Gue = ["stroke"], Eue = ["stroke"], Oue = ["stroke"], Iue = ["stroke"], Kue = { key: 1 }, Xue = /* @__PURE__ */ e("path", {
  d: "M160,40a40,40,0,0,1,8,24v8H88V64a40,40,0,0,1,8-24H56a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8Z",
  opacity: "0.2"
}, null, -1), Jue = ["stroke"], Que = ["stroke"], Yue = ["stroke"], o4e = ["stroke"], e4e = { key: 2 }, t4e = /* @__PURE__ */ e("path", { d: "M200,32H163.7a47.8,47.8,0,0,0-71.4,0H56A16,16,0,0,0,40,48V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm-72,0a32.1,32.1,0,0,1,32,32H96A32.1,32.1,0,0,1,128,32Zm32,128H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z" }, null, -1), n4e = [
  t4e
], s4e = { key: 3 }, r4e = ["stroke"], i4e = ["stroke"], l4e = ["stroke"], d4e = ["stroke"], k4e = { key: 4 }, c4e = ["stroke"], h4e = ["stroke"], u4e = ["stroke"], a4e = ["stroke"], _4e = { key: 5 }, p4e = ["stroke"], y4e = ["stroke"], $4e = ["stroke"], w4e = ["stroke"], f4e = {
  name: "PhClipboardText"
}, Aq1 = /* @__PURE__ */ $({
  ...f4e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", que, [
        e("line", {
          x1: "96",
          y1: "156",
          x2: "160",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gue),
        e("line", {
          x1: "96",
          y1: "116",
          x2: "160",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Eue),
        e("path", {
          d: "M160,40h40a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Oue),
        e("path", {
          d: "M88,72V64a40,40,0,0,1,80,0v8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Iue)
      ])) : o(i) === "duotone" ? (s(), r("g", Kue, [
        Xue,
        e("line", {
          x1: "96",
          y1: "152",
          x2: "160",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jue),
        e("line", {
          x1: "96",
          y1: "120",
          x2: "160",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Que),
        e("path", {
          d: "M160,40h40a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yue),
        e("path", {
          d: "M88,72V64a40,40,0,0,1,80,0v8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o4e)
      ])) : o(i) === "fill" ? (s(), r("g", e4e, n4e)) : o(i) === "light" ? (s(), r("g", s4e, [
        e("line", {
          x1: "96",
          y1: "152",
          x2: "160",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, r4e),
        e("line", {
          x1: "96",
          y1: "120",
          x2: "160",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, i4e),
        e("path", {
          d: "M160,40h40a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, l4e),
        e("path", {
          d: "M88,72V64a40,40,0,0,1,80,0v8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, d4e)
      ])) : o(i) === "thin" ? (s(), r("g", k4e, [
        e("line", {
          x1: "96",
          y1: "152",
          x2: "160",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, c4e),
        e("line", {
          x1: "96",
          y1: "120",
          x2: "160",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, h4e),
        e("path", {
          d: "M160,40h40a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, u4e),
        e("path", {
          d: "M88,72V64a40,40,0,0,1,80,0v8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, a4e)
      ])) : o(i) === "regular" ? (s(), r("g", _4e, [
        e("line", {
          x1: "96",
          y1: "152",
          x2: "160",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p4e),
        e("line", {
          x1: "96",
          y1: "120",
          x2: "160",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y4e),
        e("path", {
          d: "M160,40h40a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $4e),
        e("path", {
          d: "M88,72V64a40,40,0,0,1,80,0v8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w4e)
      ])) : g("", !0)
    ], 16, Uue));
  }
}), g4e = ["width", "height", "fill", "transform"], x4e = { key: 0 }, j4e = ["stroke"], m4e = ["stroke"], M4e = { key: 1 }, v4e = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), S4e = ["stroke"], H4e = ["stroke"], A4e = { key: 2 }, V4e = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm56,112H128a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48a8,8,0,0,1,0,16Z" }, null, -1), z4e = [
  V4e
], Z4e = { key: 3 }, C4e = ["stroke"], b4e = ["stroke"], L4e = { key: 4 }, B4e = ["stroke"], P4e = ["stroke"], W4e = { key: 5 }, N4e = ["stroke"], F4e = ["stroke"], T4e = {
  name: "PhClock"
}, Vq1 = /* @__PURE__ */ $({
  ...T4e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", x4e, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, j4e),
        e("polyline", {
          points: "128 72 128 128 184 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, m4e)
      ])) : o(i) === "duotone" ? (s(), r("g", M4e, [
        v4e,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, S4e),
        e("polyline", {
          points: "128 72 128 128 184 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H4e)
      ])) : o(i) === "fill" ? (s(), r("g", A4e, z4e)) : o(i) === "light" ? (s(), r("g", Z4e, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, C4e),
        e("polyline", {
          points: "128 72 128 128 184 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b4e)
      ])) : o(i) === "thin" ? (s(), r("g", L4e, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, B4e),
        e("polyline", {
          points: "128 72 128 128 184 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, P4e)
      ])) : o(i) === "regular" ? (s(), r("g", W4e, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, N4e),
        e("polyline", {
          points: "128 72 128 128 184 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F4e)
      ])) : g("", !0)
    ], 16, g4e));
  }
}), D4e = ["width", "height", "fill", "transform"], R4e = { key: 0 }, U4e = ["stroke"], q4e = ["stroke"], G4e = ["stroke"], E4e = { key: 1 }, O4e = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), I4e = ["stroke"], K4e = ["stroke"], X4e = ["stroke"], J4e = { key: 2 }, Q4e = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm56,112H147.3l26,25.9a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0l-39.6-39.6A8.4,8.4,0,0,1,120,128a8,8,0,0,1,8-8h56a8,8,0,0,1,0,16Z" }, null, -1), Y4e = [
  Q4e
], oae = { key: 3 }, eae = ["stroke"], tae = ["stroke"], nae = ["stroke"], sae = { key: 4 }, rae = ["stroke"], iae = ["stroke"], lae = ["stroke"], dae = { key: 5 }, kae = ["stroke"], cae = ["stroke"], hae = ["stroke"], uae = {
  name: "PhClockAfternoon"
}, zq1 = /* @__PURE__ */ $({
  ...uae,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", R4e, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, U4e),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "184",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, q4e),
        e("line", {
          x1: "167.6",
          y1: "167.6",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, G4e)
      ])) : o(i) === "duotone" ? (s(), r("g", E4e, [
        O4e,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, I4e),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "184",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K4e),
        e("line", {
          x1: "167.6",
          y1: "167.6",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X4e)
      ])) : o(i) === "fill" ? (s(), r("g", J4e, Y4e)) : o(i) === "light" ? (s(), r("g", oae, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eae),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "184",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tae),
        e("line", {
          x1: "167.6",
          y1: "167.6",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nae)
      ])) : o(i) === "thin" ? (s(), r("g", sae, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rae),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "184",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iae),
        e("line", {
          x1: "167.6",
          y1: "167.6",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lae)
      ])) : o(i) === "regular" ? (s(), r("g", dae, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, kae),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "184",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cae),
        e("line", {
          x1: "167.6",
          y1: "167.6",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hae)
      ])) : g("", !0)
    ], 16, D4e));
  }
}), aae = ["width", "height", "fill", "transform"], _ae = { key: 0 }, pae = ["stroke"], yae = ["stroke"], $ae = ["stroke"], wae = ["stroke"], fae = { key: 1 }, gae = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "88",
  opacity: "0.2"
}, null, -1), xae = ["stroke"], jae = ["stroke"], mae = ["stroke"], Mae = ["stroke"], vae = { key: 2 }, Sae = /* @__PURE__ */ e("path", { d: "M136,80v43.4l37.6,21.7a8,8,0,0,1-4,14.9,7.1,7.1,0,0,1-4-1.1l-41.6-24h-.2l-.4-.2-.3-.3-.3-.2-.3-.3-.2-.2c-.2-.1-.3-.3-.4-.4l-.2-.2-.2-.4-.2-.3-.2-.3a.5.5,0,0,1-.2-.4l-.2-.3c0-.1-.1-.2-.1-.4a.4.4,0,0,1-.1-.3l-.2-.4a.4.4,0,0,0-.1-.3c0-.2,0-.3-.1-.4v-.4c0-.2-.1-.3-.1-.4V80a8,8,0,0,1,16,0Zm91.2-27.7a8,8,0,0,0-8.7,1.8L204.2,68.4l-8.3-8.3a96,96,0,1,0,0,135.8,8,8,0,0,0,0-11.3,7.9,7.9,0,0,0-11.3,0,80,80,0,1,1,0-113.2l8.3,8.3L178.5,94.1a8,8,0,0,0,5.7,13.6h40a8,8,0,0,0,8-8v-40A8.2,8.2,0,0,0,227.2,52.3Z" }, null, -1), Hae = [
  Sae
], Aae = { key: 3 }, Vae = ["stroke"], zae = ["stroke"], Zae = ["stroke"], Cae = ["stroke"], bae = { key: 4 }, Lae = ["stroke"], Bae = ["stroke"], Pae = ["stroke"], Wae = ["stroke"], Nae = { key: 5 }, Fae = ["stroke"], Tae = ["stroke"], Dae = ["stroke"], Rae = ["stroke"], Uae = {
  name: "PhClockClockwise"
}, Zq1 = /* @__PURE__ */ $({
  ...Uae,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", _ae, [
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pae),
        e("line", {
          x1: "169.6",
          y1: "152",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yae),
        e("polyline", {
          points: "184.2 99.7 224.2 99.7 224.2 59.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $ae),
        e("path", {
          d: "M190.2,190.2a88,88,0,1,1,0-124.4l34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wae)
      ])) : o(i) === "duotone" ? (s(), r("g", fae, [
        gae,
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xae),
        e("line", {
          x1: "169.6",
          y1: "152",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jae),
        e("polyline", {
          points: "184.2 99.7 224.2 99.7 224.2 59.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mae),
        e("path", {
          d: "M190.2,190.2a88,88,0,1,1,0-124.4l34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mae)
      ])) : o(i) === "fill" ? (s(), r("g", vae, Hae)) : o(i) === "light" ? (s(), r("g", Aae, [
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vae),
        e("line", {
          x1: "169.6",
          y1: "152",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zae),
        e("polyline", {
          points: "184.2 99.7 224.2 99.7 224.2 59.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zae),
        e("path", {
          d: "M190.2,190.2a88,88,0,1,1,0-124.4l34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cae)
      ])) : o(i) === "thin" ? (s(), r("g", bae, [
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lae),
        e("line", {
          x1: "169.6",
          y1: "152",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bae),
        e("polyline", {
          points: "184.2 99.7 224.2 99.7 224.2 59.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pae),
        e("path", {
          d: "M190.2,190.2a88,88,0,1,1,0-124.4l34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wae)
      ])) : o(i) === "regular" ? (s(), r("g", Nae, [
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fae),
        e("line", {
          x1: "169.6",
          y1: "152",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tae),
        e("polyline", {
          points: "184.2 99.7 224.2 99.7 224.2 59.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dae),
        e("path", {
          d: "M190.2,190.2a88,88,0,1,1,0-124.4l34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rae)
      ])) : g("", !0)
    ], 16, aae));
  }
}), qae = ["width", "height", "fill", "transform"], Gae = { key: 0 }, Eae = ["stroke"], Oae = ["stroke"], Iae = ["stroke"], Kae = ["stroke"], Xae = { key: 1 }, Jae = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "88",
  opacity: "0.2"
}, null, -1), Qae = ["stroke"], Yae = ["stroke"], o_e = ["stroke"], e_e = ["stroke"], t_e = { key: 2 }, n_e = /* @__PURE__ */ e("path", { d: "M136,80v43.4l37.6,21.7a8,8,0,0,1-4,14.9,7.1,7.1,0,0,1-4-1.1l-41.6-24h-.2l-.4-.2-.3-.3-.3-.2-.3-.3-.2-.2c-.2-.1-.3-.3-.4-.4l-.2-.2-.2-.4-.2-.3-.2-.3a.5.5,0,0,1-.2-.4l-.2-.3c0-.1-.1-.2-.1-.4a.4.4,0,0,1-.1-.3l-.2-.4a.4.4,0,0,0-.1-.3c0-.2,0-.3-.1-.4v-.4c0-.2-.1-.3-.1-.4V80a8,8,0,0,1,16,0Zm59.9-19.9a96.2,96.2,0,0,0-135.8,0l-8.3,8.3L37.5,54.1a8,8,0,0,0-8.7-1.8,8.2,8.2,0,0,0-5,7.4v40a8,8,0,0,0,8,8h40a8,8,0,0,0,5.7-13.6L63.1,79.7l8.3-8.3a80,80,0,1,1,0,113.2,7.9,7.9,0,0,0-11.3,0,8,8,0,0,0,0,11.3A96,96,0,0,0,195.9,60.1Z" }, null, -1), s_e = [
  n_e
], r_e = { key: 3 }, i_e = ["stroke"], l_e = ["stroke"], d_e = ["stroke"], k_e = ["stroke"], c_e = { key: 4 }, h_e = ["stroke"], u_e = ["stroke"], a_e = ["stroke"], __e = ["stroke"], p_e = { key: 5 }, y_e = ["stroke"], $_e = ["stroke"], w_e = ["stroke"], f_e = ["stroke"], g_e = {
  name: "PhClockCounterClockwise"
}, Cq1 = /* @__PURE__ */ $({
  ...g_e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Gae, [
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Eae),
        e("line", {
          x1: "169.6",
          y1: "152",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Oae),
        e("polyline", {
          points: "71.8 99.7 31.8 99.7 31.8 59.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Iae),
        e("path", {
          d: "M65.8,190.2a88,88,0,1,0,0-124.4l-34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kae)
      ])) : o(i) === "duotone" ? (s(), r("g", Xae, [
        Jae,
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qae),
        e("line", {
          x1: "169.6",
          y1: "152",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yae),
        e("polyline", {
          points: "71.8 99.7 31.8 99.7 31.8 59.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o_e),
        e("path", {
          d: "M65.8,190.2a88,88,0,1,0,0-124.4l-34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e_e)
      ])) : o(i) === "fill" ? (s(), r("g", t_e, s_e)) : o(i) === "light" ? (s(), r("g", r_e, [
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, i_e),
        e("line", {
          x1: "169.6",
          y1: "152",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, l_e),
        e("polyline", {
          points: "71.8 99.7 31.8 99.7 31.8 59.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, d_e),
        e("path", {
          d: "M65.8,190.2a88,88,0,1,0,0-124.4l-34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, k_e)
      ])) : o(i) === "thin" ? (s(), r("g", c_e, [
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, h_e),
        e("line", {
          x1: "169.6",
          y1: "152",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, u_e),
        e("polyline", {
          points: "71.8 99.7 31.8 99.7 31.8 59.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, a_e),
        e("path", {
          d: "M65.8,190.2a88,88,0,1,0,0-124.4l-34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, __e)
      ])) : o(i) === "regular" ? (s(), r("g", p_e, [
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y_e),
        e("line", {
          x1: "169.6",
          y1: "152",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $_e),
        e("polyline", {
          points: "71.8 99.7 31.8 99.7 31.8 59.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w_e),
        e("path", {
          d: "M65.8,190.2a88,88,0,1,0,0-124.4l-34,33.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f_e)
      ])) : g("", !0)
    ], 16, qae));
  }
}), x_e = ["width", "height", "fill", "transform"], j_e = { key: 0 }, m_e = ["stroke"], M_e = ["stroke"], v_e = ["stroke"], S_e = { key: 1 }, H_e = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "48",
  width: "192",
  height: "160",
  rx: "8",
  opacity: "0.2"
}, null, -1), A_e = ["stroke"], V_e = ["stroke"], z_e = ["stroke"], Z_e = { key: 2 }, C_e = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM96,148a19.8,19.8,0,0,0,14.3-6,8,8,0,0,1,11.4,11.2A35.4,35.4,0,0,1,96,164a36,36,0,0,1,0-72,35.4,35.4,0,0,1,25.7,10.8A8,8,0,0,1,110.3,114,19.8,19.8,0,0,0,96,108a20,20,0,0,0,0,40Zm72,0a19.8,19.8,0,0,0,14.3-6,8,8,0,0,1,11.4,11.2A35.4,35.4,0,0,1,168,164a36,36,0,0,1,0-72,35.4,35.4,0,0,1,25.7,10.8A8,8,0,0,1,182.3,114a19.8,19.8,0,0,0-14.3-6,20,20,0,0,0,0,40Z" }, null, -1), b_e = [
  C_e
], L_e = { key: 3 }, B_e = ["stroke"], P_e = ["stroke"], W_e = ["stroke"], N_e = { key: 4 }, F_e = ["stroke"], T_e = ["stroke"], D_e = ["stroke"], R_e = { key: 5 }, U_e = ["stroke"], q_e = ["stroke"], G_e = ["stroke"], E_e = {
  name: "PhClosedCaptioning"
}, bq1 = /* @__PURE__ */ $({
  ...E_e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", j_e, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, m_e),
        e("path", {
          d: "M113,152.8a28.4,28.4,0,0,1-13,3.2,28,28,0,0,1,0-56,28.4,28.4,0,0,1,13,3.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, M_e),
        e("path", {
          d: "M185,152.8a28.4,28.4,0,0,1-13,3.2,28,28,0,0,1,0-56,28.4,28.4,0,0,1,13,3.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, v_e)
      ])) : o(i) === "duotone" ? (s(), r("g", S_e, [
        H_e,
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A_e),
        e("path", {
          d: "M116,147.6a28,28,0,1,1,0-39.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, V_e),
        e("path", {
          d: "M188,147.6a28,28,0,1,1,0-39.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, z_e)
      ])) : o(i) === "fill" ? (s(), r("g", Z_e, b_e)) : o(i) === "light" ? (s(), r("g", L_e, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, B_e),
        e("path", {
          d: "M116,147.6a28,28,0,1,1,0-39.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, P_e),
        e("path", {
          d: "M188,147.6a28,28,0,1,1,0-39.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, W_e)
      ])) : o(i) === "thin" ? (s(), r("g", N_e, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, F_e),
        e("path", {
          d: "M116,147.6a28,28,0,1,1,0-39.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, T_e),
        e("path", {
          d: "M188,147.6a28,28,0,1,1,0-39.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, D_e)
      ])) : o(i) === "regular" ? (s(), r("g", R_e, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U_e),
        e("path", {
          d: "M116,147.6a28,28,0,1,1,0-39.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q_e),
        e("path", {
          d: "M188,147.6a28,28,0,1,1,0-39.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G_e)
      ])) : g("", !0)
    ], 16, x_e));
  }
}), O_e = ["width", "height", "fill", "transform"], I_e = { key: 0 }, K_e = ["stroke"], X_e = { key: 1 }, J_e = /* @__PURE__ */ e("path", {
  d: "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
  opacity: "0.2"
}, null, -1), Q_e = ["stroke"], Y_e = { key: 2 }, ope = /* @__PURE__ */ e("path", { d: "M160.1,40A88.1,88.1,0,0,0,81.3,88.7h0a86.6,86.6,0,0,0-9.3,39,8.2,8.2,0,0,1-7.4,8.3,8,8,0,0,1-8.6-8,105,105,0,0,1,5.3-32.9,4,4,0,0,0-4.7-5.2A64,64,0,0,0,8,152c0,35.2,29.8,64,64.9,64H160a88,88,0,0,0,.1-176Z" }, null, -1), epe = [
  ope
], tpe = { key: 3 }, npe = ["stroke"], spe = { key: 4 }, rpe = ["stroke"], ipe = { key: 5 }, lpe = ["stroke"], dpe = {
  name: "PhCloud"
}, Lq1 = /* @__PURE__ */ $({
  ...dpe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", I_e, [
        e("path", {
          d: "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, K_e)
      ])) : o(i) === "duotone" ? (s(), r("g", X_e, [
        J_e,
        e("path", {
          d: "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q_e)
      ])) : o(i) === "fill" ? (s(), r("g", Y_e, epe)) : o(i) === "light" ? (s(), r("g", tpe, [
        e("path", {
          d: "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, npe)
      ])) : o(i) === "thin" ? (s(), r("g", spe, [
        e("path", {
          d: "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rpe)
      ])) : o(i) === "regular" ? (s(), r("g", ipe, [
        e("path", {
          d: "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lpe)
      ])) : g("", !0)
    ], 16, O_e));
  }
}), kpe = ["width", "height", "fill", "transform"], cpe = { key: 0 }, hpe = ["stroke"], upe = ["stroke"], ape = ["stroke"], _pe = ["stroke"], ppe = { key: 1 }, ype = /* @__PURE__ */ e("path", {
  d: "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
  opacity: "0.2"
}, null, -1), $pe = ["stroke"], wpe = ["stroke"], fpe = ["stroke"], gpe = ["stroke"], xpe = { key: 2 }, jpe = /* @__PURE__ */ e("path", { d: "M160.1,40A88.1,88.1,0,0,0,81.3,88.7h0a86.6,86.6,0,0,0-9.3,39,8.2,8.2,0,0,1-7.4,8.3,8,8,0,0,1-8.6-8,105,105,0,0,1,5.3-32.9,4,4,0,0,0-4.7-5.2A64,64,0,0,0,8,152c0,35.2,29.8,64,64.9,64H160a88,88,0,0,0,.1-176Zm31.5,123.7-33.9,34A8.5,8.5,0,0,1,152,200a8.3,8.3,0,0,1-5.7-2.3l-33.9-34a8,8,0,0,1,11.3-11.3L144,172.7V112a8,8,0,0,1,16,0v60.7l20.3-20.3a8,8,0,0,1,11.3,11.3Z" }, null, -1), mpe = [
  jpe
], Mpe = { key: 3 }, vpe = ["stroke"], Spe = ["stroke"], Hpe = ["stroke"], Ape = ["stroke"], Vpe = { key: 4 }, zpe = ["stroke"], Zpe = ["stroke"], Cpe = ["stroke"], bpe = ["stroke"], Lpe = { key: 5 }, Bpe = ["stroke"], Ppe = ["stroke"], Wpe = ["stroke"], Npe = ["stroke"], Fpe = {
  name: "PhCloudArrowDown"
}, Bq1 = /* @__PURE__ */ $({
  ...Fpe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", cpe, [
        e("polyline", {
          points: "118.1 174.1 152 208 185.9 174.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hpe),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "152",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, upe),
        e("path", {
          d: "M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ape),
        e("path", {
          d: "M80,128a80,80,0,1,1,144,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _pe)
      ])) : o(i) === "duotone" ? (s(), r("g", ppe, [
        ype,
        e("polyline", {
          points: "118.1 174.1 152 208 185.9 174.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $pe),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "152",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wpe),
        e("path", {
          d: "M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fpe),
        e("path", {
          d: "M80,128a80,80,0,1,1,144,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gpe)
      ])) : o(i) === "fill" ? (s(), r("g", xpe, mpe)) : o(i) === "light" ? (s(), r("g", Mpe, [
        e("polyline", {
          points: "118.1 174.1 152 208 185.9 174.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vpe),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "152",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Spe),
        e("path", {
          d: "M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hpe),
        e("path", {
          d: "M80,128a80,80,0,1,1,144,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ape)
      ])) : o(i) === "thin" ? (s(), r("g", Vpe, [
        e("polyline", {
          points: "118.1 174.1 152 208 185.9 174.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zpe),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "152",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zpe),
        e("path", {
          d: "M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cpe),
        e("path", {
          d: "M80,128a80,80,0,1,1,144,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bpe)
      ])) : o(i) === "regular" ? (s(), r("g", Lpe, [
        e("polyline", {
          points: "118.1 174.1 152 208 185.9 174.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bpe),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "152",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ppe),
        e("path", {
          d: "M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wpe),
        e("path", {
          d: "M80,128a80,80,0,1,1,144,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Npe)
      ])) : g("", !0)
    ], 16, kpe));
  }
}), Tpe = ["width", "height", "fill", "transform"], Dpe = { key: 0 }, Rpe = ["stroke"], Upe = ["stroke"], qpe = ["stroke"], Gpe = ["stroke"], Epe = { key: 1 }, Ope = /* @__PURE__ */ e("path", {
  d: "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
  opacity: "0.2"
}, null, -1), Ipe = ["stroke"], Kpe = ["stroke"], Xpe = ["stroke"], Jpe = ["stroke"], Qpe = { key: 2 }, Ype = /* @__PURE__ */ e("path", { d: "M160.1,40A88.1,88.1,0,0,0,81.3,88.7h0a86.6,86.6,0,0,0-9.3,39,8.2,8.2,0,0,1-7.4,8.3,8,8,0,0,1-8.6-8,105,105,0,0,1,5.3-32.9,4,4,0,0,0-4.7-5.2A64,64,0,0,0,8,152c0,35.2,29.8,64,64.9,64H160a88,88,0,0,0,.1-176Zm31.5,111.6a8.3,8.3,0,0,1-5.7,2.3,8,8,0,0,1-5.6-2.3L160,131.3V192a8,8,0,0,1-16,0V131.3l-20.3,20.3a8,8,0,0,1-11.3-11.3l33.9-34a8.1,8.1,0,0,1,11.4,0l33.9,34A8,8,0,0,1,191.6,151.6Z" }, null, -1), o3e = [
  Ype
], e3e = { key: 3 }, t3e = ["stroke"], n3e = ["stroke"], s3e = ["stroke"], r3e = ["stroke"], i3e = { key: 4 }, l3e = ["stroke"], d3e = ["stroke"], k3e = ["stroke"], c3e = ["stroke"], h3e = { key: 5 }, u3e = ["stroke"], a3e = ["stroke"], _3e = ["stroke"], p3e = ["stroke"], y3e = {
  name: "PhCloudArrowUp"
}, Pq1 = /* @__PURE__ */ $({
  ...y3e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Dpe, [
        e("path", {
          d: "M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rpe),
        e("path", {
          d: "M80,128a80,80,0,1,1,144,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Upe),
        e("polyline", {
          points: "118.1 161.9 152 128 185.9 161.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qpe),
        e("line", {
          x1: "152",
          y1: "208",
          x2: "152",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gpe)
      ])) : o(i) === "duotone" ? (s(), r("g", Epe, [
        Ope,
        e("path", {
          d: "M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ipe),
        e("path", {
          d: "M80,128a80,80,0,1,1,144,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kpe),
        e("polyline", {
          points: "118.1 161.9 152 128 185.9 161.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xpe),
        e("line", {
          x1: "152",
          y1: "208",
          x2: "152",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jpe)
      ])) : o(i) === "fill" ? (s(), r("g", Qpe, o3e)) : o(i) === "light" ? (s(), r("g", e3e, [
        e("path", {
          d: "M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, t3e),
        e("path", {
          d: "M80,128a80,80,0,1,1,144,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, n3e),
        e("polyline", {
          points: "118.1 161.9 152 128 185.9 161.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, s3e),
        e("line", {
          x1: "152",
          y1: "208",
          x2: "152",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, r3e)
      ])) : o(i) === "thin" ? (s(), r("g", i3e, [
        e("path", {
          d: "M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, l3e),
        e("path", {
          d: "M80,128a80,80,0,1,1,144,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, d3e),
        e("polyline", {
          points: "118.1 161.9 152 128 185.9 161.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, k3e),
        e("line", {
          x1: "152",
          y1: "208",
          x2: "152",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, c3e)
      ])) : o(i) === "regular" ? (s(), r("g", h3e, [
        e("path", {
          d: "M96,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u3e),
        e("path", {
          d: "M80,128a80,80,0,1,1,144,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a3e),
        e("polyline", {
          points: "118.1 161.9 152 128 185.9 161.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _3e),
        e("line", {
          x1: "152",
          y1: "208",
          x2: "152",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p3e)
      ])) : g("", !0)
    ], 16, Tpe));
  }
}), $3e = ["width", "height", "fill", "transform"], w3e = { key: 0 }, f3e = ["stroke"], g3e = ["stroke"], x3e = { key: 1 }, j3e = /* @__PURE__ */ e("path", {
  d: "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
  opacity: "0.2"
}, null, -1), m3e = ["stroke"], M3e = ["stroke"], v3e = { key: 2 }, S3e = /* @__PURE__ */ e("path", { d: "M160.1,40A88.1,88.1,0,0,0,81.3,88.7h0a86.6,86.6,0,0,0-9.3,39,8.2,8.2,0,0,1-7.4,8.3,8,8,0,0,1-8.6-8,105,105,0,0,1,5.3-32.9,4,4,0,0,0-4.7-5.2A64,64,0,0,0,8,152c0,35.2,29.8,64,64.9,64H160a88,88,0,0,0,.1-176Zm37.6,81.7-48,48a8.2,8.2,0,0,1-11.4,0l-24-24a8.1,8.1,0,0,1,11.4-11.4L144,152.7l42.3-42.4a8.1,8.1,0,0,1,11.4,11.4Z" }, null, -1), H3e = [
  S3e
], A3e = { key: 3 }, V3e = ["stroke"], z3e = ["stroke"], Z3e = { key: 4 }, C3e = ["stroke"], b3e = ["stroke"], L3e = { key: 5 }, B3e = ["stroke"], P3e = ["stroke"], W3e = {
  name: "PhCloudCheck"
}, Wq1 = /* @__PURE__ */ $({
  ...W3e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", w3e, [
        e("path", {
          d: "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f3e),
        e("polyline", {
          points: "192 116 144 164 120 140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g3e)
      ])) : o(i) === "duotone" ? (s(), r("g", x3e, [
        j3e,
        e("path", {
          d: "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m3e),
        e("polyline", {
          points: "192 116 144 164 120 140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M3e)
      ])) : o(i) === "fill" ? (s(), r("g", v3e, H3e)) : o(i) === "light" ? (s(), r("g", A3e, [
        e("path", {
          d: "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, V3e),
        e("polyline", {
          points: "192 116 144 164 120 140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, z3e)
      ])) : o(i) === "thin" ? (s(), r("g", Z3e, [
        e("path", {
          d: "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, C3e),
        e("polyline", {
          points: "192 116 144 164 120 140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, b3e)
      ])) : o(i) === "regular" ? (s(), r("g", L3e, [
        e("path", {
          d: "M80,128a80,80,0,1,1,80,80H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B3e),
        e("polyline", {
          points: "192 116 144 164 120 140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P3e)
      ])) : g("", !0)
    ], 16, $3e));
  }
}), N3e = ["width", "height", "fill", "transform"], F3e = { key: 0 }, T3e = ["stroke"], D3e = ["stroke"], R3e = ["stroke"], U3e = ["stroke"], q3e = { key: 1 }, G3e = /* @__PURE__ */ e("path", {
  d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
  opacity: "0.2"
}, null, -1), E3e = ["stroke"], O3e = ["stroke"], I3e = ["stroke"], K3e = ["stroke"], X3e = { key: 2 }, J3e = /* @__PURE__ */ e("path", { d: "M168,224a8,8,0,0,1-8,8H104a8,8,0,0,1,0-16h56A8,8,0,0,1,168,224Zm-40-32a8,8,0,0,0-8-8H72a8,8,0,0,0,0,16h48A8,8,0,0,0,128,192Zm56-8H160a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16ZM159.3,16.1A76.1,76.1,0,0,0,85,64.8h0a76.4,76.4,0,0,0-5,26.9,8.3,8.3,0,0,1-7.4,8.3A8,8,0,0,1,64,92a88.2,88.2,0,0,1,2.5-21.1,4,4,0,0,0-5-4.8A52,52,0,0,0,24,116.3C24.2,145,48.1,168,76.8,168H156a76,76,0,0,0,3.3-151.9Z" }, null, -1), Q3e = [
  J3e
], Y3e = { key: 3 }, oye = ["stroke"], eye = ["stroke"], tye = ["stroke"], nye = ["stroke"], sye = { key: 4 }, rye = ["stroke"], iye = ["stroke"], lye = ["stroke"], dye = ["stroke"], kye = { key: 5 }, cye = ["stroke"], hye = ["stroke"], uye = ["stroke"], aye = ["stroke"], _ye = {
  name: "PhCloudFog"
}, Nq1 = /* @__PURE__ */ $({
  ..._ye,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", F3e, [
        e("line", {
          x1: "120",
          y1: "200",
          x2: "72",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, T3e),
        e("line", {
          x1: "184",
          y1: "200",
          x2: "160",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, D3e),
        e("line", {
          x1: "160",
          y1: "240",
          x2: "104",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, R3e),
        e("path", {
          d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, U3e)
      ])) : o(i) === "duotone" ? (s(), r("g", q3e, [
        G3e,
        e("line", {
          x1: "120",
          y1: "192",
          x2: "72",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E3e),
        e("line", {
          x1: "184",
          y1: "192",
          x2: "160",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O3e),
        e("line", {
          x1: "160",
          y1: "224",
          x2: "104",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I3e),
        e("path", {
          d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K3e)
      ])) : o(i) === "fill" ? (s(), r("g", X3e, Q3e)) : o(i) === "light" ? (s(), r("g", Y3e, [
        e("line", {
          x1: "120",
          y1: "192",
          x2: "72",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oye),
        e("line", {
          x1: "184",
          y1: "192",
          x2: "160",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eye),
        e("line", {
          x1: "160",
          y1: "224",
          x2: "104",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tye),
        e("path", {
          d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nye)
      ])) : o(i) === "thin" ? (s(), r("g", sye, [
        e("line", {
          x1: "120",
          y1: "192",
          x2: "72",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rye),
        e("line", {
          x1: "184",
          y1: "192",
          x2: "160",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iye),
        e("line", {
          x1: "160",
          y1: "224",
          x2: "104",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lye),
        e("path", {
          d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dye)
      ])) : o(i) === "regular" ? (s(), r("g", kye, [
        e("line", {
          x1: "120",
          y1: "192",
          x2: "72",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cye),
        e("line", {
          x1: "184",
          y1: "192",
          x2: "160",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hye),
        e("line", {
          x1: "160",
          y1: "224",
          x2: "104",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uye),
        e("path", {
          d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aye)
      ])) : g("", !0)
    ], 16, N3e));
  }
}), pye = ["width", "height", "fill", "transform"], yye = { key: 0 }, $ye = ["stroke"], wye = ["stroke"], fye = { key: 1 }, gye = /* @__PURE__ */ e("path", {
  d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
  opacity: "0.2"
}, null, -1), xye = ["stroke"], jye = ["stroke"], mye = { key: 2 }, Mye = /* @__PURE__ */ e("path", { d: "M134.6,168l-15.8,24H154a8,8,0,0,1,6.2,2.7,7.8,7.8,0,0,1,.7,9.7l-26.2,40A8.2,8.2,0,0,1,128,248a8.4,8.4,0,0,1-5.1-1.8,8.3,8.3,0,0,1-1.5-10.8l18-27.4H104.2a8.3,8.3,0,0,1-6.2-2.7,8.1,8.1,0,0,1-.7-9.7L115.4,168H76.8c-28.7,0-52.6-23-52.8-51.7A52,52,0,0,1,61.5,66.1a4,4,0,0,1,5,4.7,91.4,91.4,0,0,0-2.5,21,8.3,8.3,0,0,0,7.5,8.2A8,8,0,0,0,80,92a76.4,76.4,0,0,1,5-27.2h0A76,76,0,1,1,156,168Z" }, null, -1), vye = [
  Mye
], Sye = { key: 3 }, Hye = ["stroke"], Aye = ["stroke"], Vye = { key: 4 }, zye = ["stroke"], Zye = ["stroke"], Cye = { key: 5 }, bye = ["stroke"], Lye = ["stroke"], Bye = {
  name: "PhCloudLightning"
}, Fq1 = /* @__PURE__ */ $({
  ...Bye,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", yye, [
        e("polyline", {
          points: "128 240 154.3 200 104 200 130.3 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $ye),
        e("path", {
          d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wye)
      ])) : o(i) === "duotone" ? (s(), r("g", fye, [
        gye,
        e("polyline", {
          points: "128 240 154.3 200 104 200 130.3 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xye),
        e("path", {
          d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jye)
      ])) : o(i) === "fill" ? (s(), r("g", mye, vye)) : o(i) === "light" ? (s(), r("g", Sye, [
        e("polyline", {
          points: "128 240 154.3 200 104 200 130.3 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hye),
        e("path", {
          d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Aye)
      ])) : o(i) === "thin" ? (s(), r("g", Vye, [
        e("polyline", {
          points: "128 240 154.3 200 104 200 130.3 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zye),
        e("path", {
          d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zye)
      ])) : o(i) === "regular" ? (s(), r("g", Cye, [
        e("polyline", {
          points: "128 240 154.3 200 104 200 130.3 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bye),
        e("path", {
          d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lye)
      ])) : g("", !0)
    ], 16, pye));
  }
}), Pye = ["width", "height", "fill", "transform"], Wye = { key: 0 }, Nye = ["stroke"], Fye = ["stroke"], Tye = { key: 1 }, Dye = /* @__PURE__ */ e("path", {
  d: "M90.3,130.4a67.9,67.9,0,0,1,45.5-47.3h.1c.1-1,.1-2,.1-3A64,64,0,0,0,86.4,17.6h0A68.3,68.3,0,0,1,88,32,64.1,64.1,0,0,1,24,96,68.3,68.3,0,0,1,9.6,94.4h0A64.1,64.1,0,0,0,47,138.9h0A43.7,43.7,0,0,1,76,128a42.5,42.5,0,0,1,14.3,2.4Z",
  opacity: "0.2"
}, null, -1), Rye = ["stroke"], Uye = ["stroke"], qye = { key: 2 }, Gye = /* @__PURE__ */ e("path", { d: "M156,72a85.2,85.2,0,0,0-12.4,1A71.8,71.8,0,0,0,88.2,9.8a8,8,0,0,0-9.6,9.6A58.6,58.6,0,0,1,80,32,56,56,0,0,1,24,88a58.6,58.6,0,0,1-12.6-1.4,8,8,0,0,0-9.6,9.6,71.9,71.9,0,0,0,32.3,45A52,52,0,0,0,76,224h80a76,76,0,0,0,0-152ZM21.4,104H24A72.1,72.1,0,0,0,96,32V29.3a55.6,55.6,0,0,1,31.9,48.1A76.3,76.3,0,0,0,85,120.8a53.8,53.8,0,0,0-9-.8,51.8,51.8,0,0,0-30,9.6A55.9,55.9,0,0,1,21.4,104Z" }, null, -1), Eye = [
  Gye
], Oye = { key: 3 }, Iye = ["stroke"], Kye = ["stroke"], Xye = { key: 4 }, Jye = ["stroke"], Qye = ["stroke"], Yye = { key: 5 }, o5e = ["stroke"], e5e = ["stroke"], t5e = {
  name: "PhCloudMoon"
}, Tq1 = /* @__PURE__ */ $({
  ...t5e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Wye, [
        e("path", {
          d: "M88,148a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nye),
        e("path", {
          d: "M50,136.5A63.9,63.9,0,0,1,17.6,94.4h0A68.3,68.3,0,0,0,32,96,64.1,64.1,0,0,0,96,32a68.3,68.3,0,0,0-1.6-14.4h0A64,64,0,0,1,144,80v1.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fye)
      ])) : o(i) === "duotone" ? (s(), r("g", Tye, [
        Dye,
        e("path", {
          d: "M88,148a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rye),
        e("path", {
          d: "M47,138.9A64.1,64.1,0,0,1,9.6,94.4h0A68.3,68.3,0,0,0,24,96,64.1,64.1,0,0,0,88,32a68.3,68.3,0,0,0-1.6-14.4h0A64,64,0,0,1,136,80c0,1,0,2-.1,3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uye)
      ])) : o(i) === "fill" ? (s(), r("g", qye, Eye)) : o(i) === "light" ? (s(), r("g", Oye, [
        e("path", {
          d: "M88,148a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Iye),
        e("path", {
          d: "M47,138.9A64.1,64.1,0,0,1,9.6,94.4h0A68.3,68.3,0,0,0,24,96,64.1,64.1,0,0,0,88,32a68.3,68.3,0,0,0-1.6-14.4h0A64,64,0,0,1,136,80c0,1,0,2-.1,3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kye)
      ])) : o(i) === "thin" ? (s(), r("g", Xye, [
        e("path", {
          d: "M88,148a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jye),
        e("path", {
          d: "M47,138.9A64.1,64.1,0,0,1,9.6,94.4h0A68.3,68.3,0,0,0,24,96,64.1,64.1,0,0,0,88,32a68.3,68.3,0,0,0-1.6-14.4h0A64,64,0,0,1,136,80c0,1,0,2-.1,3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qye)
      ])) : o(i) === "regular" ? (s(), r("g", Yye, [
        e("path", {
          d: "M88,148a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o5e),
        e("path", {
          d: "M47,138.9A64.1,64.1,0,0,1,9.6,94.4h0A68.3,68.3,0,0,0,24,96,64.1,64.1,0,0,0,88,32a68.3,68.3,0,0,0-1.6-14.4h0A64,64,0,0,1,136,80c0,1,0,2-.1,3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e5e)
      ])) : g("", !0)
    ], 16, Pye));
  }
}), n5e = ["width", "height", "fill", "transform"], s5e = { key: 0 }, r5e = ["stroke"], i5e = ["stroke"], l5e = ["stroke"], d5e = { key: 1 }, k5e = /* @__PURE__ */ e("path", {
  d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
  opacity: "0.2"
}, null, -1), c5e = ["stroke"], h5e = ["stroke"], u5e = ["stroke"], a5e = { key: 2 }, _5e = /* @__PURE__ */ e("path", { d: "M160.9,204.4l-26.2,40A8.2,8.2,0,0,1,128,248a8,8,0,0,1-6.7-12.4l26.3-40a8,8,0,1,1,13.3,8.8ZM159.3,16.1A76.1,76.1,0,0,0,85,64.8h0a74.8,74.8,0,0,0-5,26.9,8.3,8.3,0,0,1-7.4,8.3A8,8,0,0,1,64,92a91.6,91.6,0,0,1,2.4-21.1,4,4,0,0,0-5-4.8A52.1,52.1,0,0,0,24,116.3C24.2,145,48.1,168,76.8,168h38.6L92.2,203.4A8,8,0,0,0,98.7,216a8,8,0,0,0,6.7-3.6L134.6,168H156a76,76,0,0,0,3.3-151.9Z" }, null, -1), p5e = [
  _5e
], y5e = { key: 3 }, $5e = ["stroke"], w5e = ["stroke"], f5e = ["stroke"], g5e = { key: 4 }, x5e = ["stroke"], j5e = ["stroke"], m5e = ["stroke"], M5e = { key: 5 }, v5e = ["stroke"], S5e = ["stroke"], H5e = ["stroke"], A5e = {
  name: "PhCloudRain"
}, Dq1 = /* @__PURE__ */ $({
  ...A5e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", s5e, [
        e("line", {
          x1: "128",
          y1: "240",
          x2: "154.3",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, r5e),
        e("line", {
          x1: "98.7",
          y1: "208",
          x2: "130.3",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, i5e),
        e("path", {
          d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, l5e)
      ])) : o(i) === "duotone" ? (s(), r("g", d5e, [
        k5e,
        e("line", {
          x1: "128",
          y1: "240",
          x2: "154.3",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c5e),
        e("line", {
          x1: "98.7",
          y1: "208",
          x2: "130.3",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h5e),
        e("path", {
          d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u5e)
      ])) : o(i) === "fill" ? (s(), r("g", a5e, p5e)) : o(i) === "light" ? (s(), r("g", y5e, [
        e("line", {
          x1: "128",
          y1: "240",
          x2: "154.3",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $5e),
        e("line", {
          x1: "98.7",
          y1: "208",
          x2: "130.3",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, w5e),
        e("path", {
          d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, f5e)
      ])) : o(i) === "thin" ? (s(), r("g", g5e, [
        e("line", {
          x1: "128",
          y1: "240",
          x2: "154.3",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, x5e),
        e("line", {
          x1: "98.7",
          y1: "208",
          x2: "130.3",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, j5e),
        e("path", {
          d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, m5e)
      ])) : o(i) === "regular" ? (s(), r("g", M5e, [
        e("line", {
          x1: "128",
          y1: "240",
          x2: "154.3",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v5e),
        e("line", {
          x1: "98.7",
          y1: "208",
          x2: "130.3",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S5e),
        e("path", {
          d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H5e)
      ])) : g("", !0)
    ], 16, n5e));
  }
}), V5e = ["width", "height", "fill", "transform"], z5e = { key: 0 }, Z5e = ["stroke"], C5e = ["stroke"], b5e = ["stroke"], L5e = ["stroke"], B5e = { key: 1 }, P5e = /* @__PURE__ */ e("path", {
  d: "M80,127.6a80,80,0,1,1,80,80H72a56,56,0,0,1,0-112,53,53,0,0,1,13.9,1.8",
  opacity: "0.2"
}, null, -1), W5e = ["stroke"], N5e = ["stroke"], F5e = ["stroke"], T5e = ["stroke"], D5e = { key: 2 }, R5e = /* @__PURE__ */ e("path", { d: "M53.9,34.6A8,8,0,0,0,42.1,45.4L81.3,88.5v.2A58.2,58.2,0,0,0,72,88a64,64,0,0,0,0,128h88a87.9,87.9,0,0,0,31.8-5.9l10.3,11.3A8,8,0,0,0,208,224a8.2,8.2,0,0,0,5.4-2.1,7.9,7.9,0,0,0,.5-11.3Z" }, null, -1), U5e = /* @__PURE__ */ e("path", { d: "M160,40a87.2,87.2,0,0,0-52.1,17.1,7.9,7.9,0,0,0-3.2,5.6,7.8,7.8,0,0,0,2,6.2L213.8,186.7a8.1,8.1,0,0,0,5.9,2.6h0a7.8,7.8,0,0,0,5.9-2.7A88,88,0,0,0,160,40Z" }, null, -1), q5e = [
  R5e,
  U5e
], G5e = { key: 3 }, E5e = ["stroke"], O5e = ["stroke"], I5e = ["stroke"], K5e = ["stroke"], X5e = { key: 4 }, J5e = ["stroke"], Q5e = ["stroke"], Y5e = ["stroke"], o7e = ["stroke"], e7e = { key: 5 }, t7e = ["stroke"], n7e = ["stroke"], s7e = ["stroke"], r7e = ["stroke"], i7e = {
  name: "PhCloudSlash"
}, Rq1 = /* @__PURE__ */ $({
  ...i7e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", z5e, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Z5e),
        e("path", {
          d: "M193.9,200.5A80.1,80.1,0,0,1,160,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, C5e),
        e("path", {
          d: "M80,128A79,79,0,0,1,91.1,87.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, b5e),
        e("path", {
          d: "M119.4,59.1A79,79,0,0,1,160,48a80.1,80.1,0,0,1,64.8,127",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, L5e)
      ])) : o(i) === "duotone" ? (s(), r("g", B5e, [
        P5e,
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W5e),
        e("path", {
          d: "M193.9,200.5A80.1,80.1,0,0,1,160,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N5e),
        e("path", {
          d: "M112.6,63.5A80,80,0,0,1,219.7,181.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F5e),
        e("path", {
          d: "M80,128A79,79,0,0,1,91.1,87.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T5e)
      ])) : o(i) === "fill" ? (s(), r("g", D5e, q5e)) : o(i) === "light" ? (s(), r("g", G5e, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, E5e),
        e("path", {
          d: "M193.9,200.5A80.1,80.1,0,0,1,160,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, O5e),
        e("path", {
          d: "M112.6,63.5A80,80,0,0,1,219.7,181.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, I5e),
        e("path", {
          d: "M80,128A79,79,0,0,1,91.1,87.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, K5e)
      ])) : o(i) === "thin" ? (s(), r("g", X5e, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, J5e),
        e("path", {
          d: "M193.9,200.5A80.1,80.1,0,0,1,160,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Q5e),
        e("path", {
          d: "M112.6,63.5A80,80,0,0,1,219.7,181.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Y5e),
        e("path", {
          d: "M80,128A79,79,0,0,1,91.1,87.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, o7e)
      ])) : o(i) === "regular" ? (s(), r("g", e7e, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t7e),
        e("path", {
          d: "M193.9,200.5A80.1,80.1,0,0,1,160,208H72A56,56,0,0,1,72,96a57.5,57.5,0,0,1,13.9,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n7e),
        e("path", {
          d: "M112.6,63.5A80,80,0,0,1,219.7,181.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s7e),
        e("path", {
          d: "M80,128A79,79,0,0,1,91.1,87.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r7e)
      ])) : g("", !0)
    ], 16, V5e));
  }
}), l7e = ["width", "height", "fill", "transform"], d7e = { key: 0 }, k7e = ["stroke"], c7e = /* @__PURE__ */ e("circle", {
  cx: "160",
  cy: "216",
  r: "16"
}, null, -1), h7e = /* @__PURE__ */ e("circle", {
  cx: "112",
  cy: "216",
  r: "16"
}, null, -1), u7e = /* @__PURE__ */ e("circle", {
  cx: "64",
  cy: "216",
  r: "16"
}, null, -1), a7e = { key: 1 }, _7e = /* @__PURE__ */ e("path", {
  d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
  opacity: "0.2"
}, null, -1), p7e = ["stroke"], y7e = /* @__PURE__ */ j('<circle cx="76" cy="196" r="12"></circle><circle cx="116" cy="212" r="12"></circle><circle cx="164" cy="196" r="12"></circle><circle cx="68" cy="236" r="12"></circle><circle cx="156" cy="236" r="12"></circle>', 5), $7e = { key: 2 }, w7e = /* @__PURE__ */ e("path", { d: "M176,196a12,12,0,1,1-12-12A12,12,0,0,1,176,196ZM76,184a12,12,0,1,0,12,12A12,12,0,0,0,76,184Zm40,16a12,12,0,1,0,12,12A12,12,0,0,0,116,200ZM68,224a12,12,0,1,0,12,12A12,12,0,0,0,68,224Zm88,0a12,12,0,1,0,12,12A12,12,0,0,0,156,224Zm3.3-207.9A76.1,76.1,0,0,0,85,64.8h0a74.8,74.8,0,0,0-5,26.9,8.3,8.3,0,0,1-7.4,8.3A8,8,0,0,1,64,92a91.6,91.6,0,0,1,2.4-21.1,4,4,0,0,0-5-4.8A52.1,52.1,0,0,0,24,116.3C24.2,145,48.1,168,76.8,168H156a76,76,0,0,0,3.3-151.9Z" }, null, -1), f7e = [
  w7e
], g7e = { key: 3 }, x7e = ["stroke"], j7e = /* @__PURE__ */ j('<circle cx="76" cy="196" r="10"></circle><circle cx="116" cy="212" r="10"></circle><circle cx="164" cy="196" r="10"></circle><circle cx="68" cy="236" r="10"></circle><circle cx="156" cy="236" r="10"></circle>', 5), m7e = { key: 4 }, M7e = ["stroke"], v7e = /* @__PURE__ */ j('<circle cx="76" cy="196" r="8"></circle><circle cx="116" cy="212" r="8"></circle><circle cx="164" cy="196" r="8"></circle><circle cx="68" cy="236" r="8"></circle><circle cx="156" cy="236" r="8"></circle>', 5), S7e = { key: 5 }, H7e = ["stroke"], A7e = /* @__PURE__ */ j('<circle cx="76" cy="196" r="12"></circle><circle cx="116" cy="212" r="12"></circle><circle cx="164" cy="196" r="12"></circle><circle cx="68" cy="236" r="12"></circle><circle cx="156" cy="236" r="12"></circle>', 5), V7e = {
  name: "PhCloudSnow"
}, Uq1 = /* @__PURE__ */ $({
  ...V7e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", d7e, [
        e("path", {
          d: "M88,96a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, k7e),
        c7e,
        h7e,
        u7e
      ])) : o(i) === "duotone" ? (s(), r("g", a7e, [
        _7e,
        e("path", {
          d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p7e),
        y7e
      ])) : o(i) === "fill" ? (s(), r("g", $7e, f7e)) : o(i) === "light" ? (s(), r("g", g7e, [
        e("path", {
          d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, x7e),
        j7e
      ])) : o(i) === "thin" ? (s(), r("g", m7e, [
        e("path", {
          d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, M7e),
        v7e
      ])) : o(i) === "regular" ? (s(), r("g", S7e, [
        e("path", {
          d: "M88,92a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H7e),
        A7e
      ])) : g("", !0)
    ], 16, l7e));
  }
}), z7e = ["width", "height", "fill", "transform"], Z7e = { key: 0 }, C7e = ["stroke"], b7e = ["stroke"], L7e = ["stroke"], B7e = ["stroke"], P7e = ["stroke"], W7e = ["stroke"], N7e = { key: 1 }, F7e = /* @__PURE__ */ e("path", {
  d: "M131.8,84.4a48,48,0,0,0-91.1,27.9,49.1,49.1,0,0,0,10.9,23.1h0A43.6,43.6,0,0,1,76,128a42.5,42.5,0,0,1,14.3,2.4h0a68.3,68.3,0,0,1,41.5-46Z",
  opacity: "0.2"
}, null, -1), T7e = ["stroke"], D7e = ["stroke"], R7e = ["stroke"], U7e = ["stroke"], q7e = ["stroke"], G7e = ["stroke"], E7e = { key: 2 }, O7e = /* @__PURE__ */ e("path", { d: "M156,72a78.8,78.8,0,0,0-20.2,2.7,58.9,58.9,0,0,0-9.4-11.5l9.4-13.6a7.9,7.9,0,0,0-1.9-11.1,8,8,0,0,0-11.2,1.9L113.2,54a55,55,0,0,0-26.9-6L83.4,31.7a8,8,0,1,0-15.8,2.8l2.9,16.3A55.7,55.7,0,0,0,47.2,65.6L33.6,56.1a8,8,0,0,0-11.1,2,7.9,7.9,0,0,0,1.9,11.1L38,78.7a55.1,55.1,0,0,0-6,27l-16.3,2.9a8,8,0,0,0,1.4,15.9h1.4l16.3-2.9a52.3,52.3,0,0,0,5.9,12.4A51.9,51.9,0,0,0,76,224h80a76,76,0,0,0,0-152ZM48.6,111.1v-.4a39.6,39.6,0,0,1,6.5-29.5V81h.1A40.1,40.1,0,0,1,80.8,64.6h.5a39.5,39.5,0,0,1,29.1,6.3l.5.3.4.3a37.4,37.4,0,0,1,9.3,9.3,76.6,76.6,0,0,0-35.6,40,53.8,53.8,0,0,0-9-.8,52.6,52.6,0,0,0-22.1,4.9A40,40,0,0,1,48.6,111.1Z" }, null, -1), I7e = [
  O7e
], K7e = { key: 3 }, X7e = ["stroke"], J7e = ["stroke"], Q7e = ["stroke"], Y7e = ["stroke"], o9e = ["stroke"], e9e = ["stroke"], t9e = { key: 4 }, n9e = ["stroke"], s9e = ["stroke"], r9e = ["stroke"], i9e = ["stroke"], l9e = ["stroke"], d9e = ["stroke"], k9e = { key: 5 }, c9e = ["stroke"], h9e = ["stroke"], u9e = ["stroke"], a9e = ["stroke"], _9e = ["stroke"], p9e = ["stroke"], y9e = {
  name: "PhCloudSun"
}, qq1 = /* @__PURE__ */ $({
  ...y9e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Z7e, [
        e("path", {
          d: "M88,148a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, C7e),
        e("line", {
          x1: "79.7",
          y1: "56.7",
          x2: "75.5",
          y2: "33.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, b7e),
        e("line", {
          x1: "48.7",
          y1: "76.5",
          x2: "29",
          y2: "62.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, L7e),
        e("line", {
          x1: "40.7",
          y1: "112.3",
          x2: "17.1",
          y2: "116.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, B7e),
        e("line", {
          x1: "115.5",
          y1: "64.7",
          x2: "129.3",
          y2: "45",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, P7e),
        e("path", {
          d: "M51.6,135.4a49.1,49.1,0,0,1-10.9-23.1,48,48,0,0,1,91.1-27.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, W7e)
      ])) : o(i) === "duotone" ? (s(), r("g", N7e, [
        F7e,
        e("path", {
          d: "M88,148a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T7e),
        e("line", {
          x1: "79.7",
          y1: "56.7",
          x2: "75.5",
          y2: "33.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D7e),
        e("line", {
          x1: "48.7",
          y1: "76.5",
          x2: "29",
          y2: "62.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R7e),
        e("line", {
          x1: "40.7",
          y1: "112.3",
          x2: "17.1",
          y2: "116.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U7e),
        e("line", {
          x1: "115.5",
          y1: "64.7",
          x2: "129.3",
          y2: "45",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q7e),
        e("path", {
          d: "M51.6,135.4a49.1,49.1,0,0,1-10.9-23.1,48,48,0,0,1,91.1-27.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G7e)
      ])) : o(i) === "fill" ? (s(), r("g", E7e, I7e)) : o(i) === "light" ? (s(), r("g", K7e, [
        e("path", {
          d: "M88,148a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, X7e),
        e("line", {
          x1: "79.7",
          y1: "56.7",
          x2: "75.5",
          y2: "33.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, J7e),
        e("line", {
          x1: "48.7",
          y1: "76.5",
          x2: "29",
          y2: "62.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Q7e),
        e("line", {
          x1: "40.7",
          y1: "112.3",
          x2: "17.1",
          y2: "116.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Y7e),
        e("line", {
          x1: "115.5",
          y1: "64.7",
          x2: "129.3",
          y2: "45",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, o9e),
        e("path", {
          d: "M51.6,135.4a49.1,49.1,0,0,1-10.9-23.1,48,48,0,0,1,91.1-27.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, e9e)
      ])) : o(i) === "thin" ? (s(), r("g", t9e, [
        e("path", {
          d: "M88,148a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, n9e),
        e("line", {
          x1: "79.7",
          y1: "56.7",
          x2: "75.5",
          y2: "33.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, s9e),
        e("line", {
          x1: "48.7",
          y1: "76.5",
          x2: "29",
          y2: "62.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, r9e),
        e("line", {
          x1: "40.7",
          y1: "112.3",
          x2: "17.1",
          y2: "116.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, i9e),
        e("line", {
          x1: "115.5",
          y1: "64.7",
          x2: "129.3",
          y2: "45",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, l9e),
        e("path", {
          d: "M51.6,135.4a49.1,49.1,0,0,1-10.9-23.1,48,48,0,0,1,91.1-27.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, d9e)
      ])) : o(i) === "regular" ? (s(), r("g", k9e, [
        e("path", {
          d: "M88,148a68,68,0,1,1,68,68H76a44,44,0,0,1,0-88,42.5,42.5,0,0,1,14.3,2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c9e),
        e("line", {
          x1: "79.7",
          y1: "56.7",
          x2: "75.5",
          y2: "33.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h9e),
        e("line", {
          x1: "48.7",
          y1: "76.5",
          x2: "29",
          y2: "62.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u9e),
        e("line", {
          x1: "40.7",
          y1: "112.3",
          x2: "17.1",
          y2: "116.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a9e),
        e("line", {
          x1: "115.5",
          y1: "64.7",
          x2: "129.3",
          y2: "45",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _9e),
        e("path", {
          d: "M51.6,135.4a49.1,49.1,0,0,1-10.9-23.1,48,48,0,0,1,91.1-27.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p9e)
      ])) : g("", !0)
    ], 16, z7e));
  }
}), $9e = ["width", "height", "fill", "transform"], w9e = { key: 0 }, f9e = ["stroke"], g9e = { key: 1 }, x9e = /* @__PURE__ */ e("path", {
  d: "M112.5,179.2A48,48,0,1,1,76,100a51.2,51.2,0,0,1,11.2,1.3h0A47.3,47.3,0,0,1,80,76a48,48,0,0,1,96,0,47.3,47.3,0,0,1-7.2,25.3h0A51.2,51.2,0,0,1,180,100a48,48,0,1,1-36.5,79.2L160,232H96Z",
  opacity: "0.2"
}, null, -1), j9e = ["stroke"], m9e = { key: 2 }, M9e = /* @__PURE__ */ e("path", { d: "M232,148a52,52,0,0,1-80.5,43.5l10.7,34.1a7.8,7.8,0,0,1-1.2,7.1,7.9,7.9,0,0,1-6.4,3.3H101.4a7.9,7.9,0,0,1-6.4-3.3,7.8,7.8,0,0,1-1.2-7.1l10.7-34.1a51.7,51.7,0,0,1-30,8.5c-27.7-.8-50.4-24-50.5-51.8A52.1,52.1,0,0,1,76,96l4,.2a53.3,53.3,0,0,1-3.9-23.4,52,52,0,1,1,99.8,23.4A51.5,51.5,0,0,1,232,148Z" }, null, -1), v9e = [
  M9e
], S9e = { key: 3 }, H9e = ["stroke"], A9e = { key: 4 }, V9e = ["stroke"], z9e = { key: 5 }, Z9e = ["stroke"], C9e = {
  name: "PhClub"
}, Gq1 = /* @__PURE__ */ $({
  ...C9e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", w9e, [
        e("path", {
          d: "M104.5,186.6A48,48,0,1,1,76,100a51.2,51.2,0,0,1,11.2,1.3h0A47.3,47.3,0,0,1,80,76a48,48,0,0,1,96,0,47.3,47.3,0,0,1-7.2,25.3h0A51.2,51.2,0,0,1,180,100a48,48,0,1,1-28.5,86.6L160,232H96Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f9e)
      ])) : o(i) === "duotone" ? (s(), r("g", g9e, [
        x9e,
        e("path", {
          d: "M112.5,179.2A48,48,0,1,1,76,100a51.2,51.2,0,0,1,11.2,1.3h0A47.3,47.3,0,0,1,80,76a48,48,0,0,1,96,0,47.3,47.3,0,0,1-7.2,25.3h0A51.2,51.2,0,0,1,180,100a48,48,0,1,1-36.5,79.2L160,232H96Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j9e)
      ])) : o(i) === "fill" ? (s(), r("g", m9e, v9e)) : o(i) === "light" ? (s(), r("g", S9e, [
        e("path", {
          d: "M112.5,179.2A48,48,0,1,1,76,100a51.2,51.2,0,0,1,11.2,1.3h0A47.3,47.3,0,0,1,80,76a48,48,0,0,1,96,0,47.3,47.3,0,0,1-7.2,25.3h0A51.2,51.2,0,0,1,180,100a48,48,0,1,1-36.5,79.2L160,232H96Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, H9e)
      ])) : o(i) === "thin" ? (s(), r("g", A9e, [
        e("path", {
          d: "M112.5,179.2A48,48,0,1,1,76,100a51.2,51.2,0,0,1,11.2,1.3h0A47.3,47.3,0,0,1,80,76a48,48,0,0,1,96,0,47.3,47.3,0,0,1-7.2,25.3h0A51.2,51.2,0,0,1,180,100a48,48,0,1,1-36.5,79.2L160,232H96Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, V9e)
      ])) : o(i) === "regular" ? (s(), r("g", z9e, [
        e("path", {
          d: "M112.5,179.2A48,48,0,1,1,76,100a51.2,51.2,0,0,1,11.2,1.3h0A47.3,47.3,0,0,1,80,76a48,48,0,0,1,96,0,47.3,47.3,0,0,1-7.2,25.3h0A51.2,51.2,0,0,1,180,100a48,48,0,1,1-36.5,79.2L160,232H96Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z9e)
      ])) : g("", !0)
    ], 16, $9e));
  }
}), b9e = ["width", "height", "fill", "transform"], L9e = { key: 0 }, B9e = ["stroke"], P9e = { key: 1 }, W9e = ["stroke"], N9e = { key: 2 }, F9e = /* @__PURE__ */ e("path", { d: "M241.6,171.2,141.3,96l23.5-17.6A8.1,8.1,0,0,0,168,72a40,40,0,0,0-80,0,8,8,0,0,0,16,0,24,24,0,0,1,47.7-3.8L123.3,89.5l-.2.2L14.4,171.2A16,16,0,0,0,24,200H232a16,16,0,0,0,9.6-28.8ZM24,184l104-78,104,78H24Z" }, null, -1), T9e = [
  F9e
], D9e = { key: 3 }, R9e = ["stroke"], U9e = { key: 4 }, q9e = ["stroke"], G9e = { key: 5 }, E9e = ["stroke"], O9e = {
  name: "PhCoatHanger"
}, Eq1 = /* @__PURE__ */ $({
  ...O9e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", L9e, [
        e("path", {
          d: "M96,72a32,32,0,0,1,64,0L19.2,177.6A8,8,0,0,0,24,192H232a8,8,0,0,0,4.8-14.4L128,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, B9e)
      ])) : o(i) === "duotone" ? (s(), r("g", P9e, [
        e("path", {
          d: "M96,72a32,32,0,0,1,64,0L19.2,177.6A8,8,0,0,0,24,192H232a8,8,0,0,0,4.8-14.4L128,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W9e)
      ])) : o(i) === "fill" ? (s(), r("g", N9e, T9e)) : o(i) === "light" ? (s(), r("g", D9e, [
        e("path", {
          d: "M96,72a32,32,0,0,1,64,0L19.2,177.6A8,8,0,0,0,24,192H232a8,8,0,0,0,4.8-14.4L128,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, R9e)
      ])) : o(i) === "thin" ? (s(), r("g", U9e, [
        e("path", {
          d: "M96,72a32,32,0,0,1,64,0L19.2,177.6A8,8,0,0,0,24,192H232a8,8,0,0,0,4.8-14.4L128,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, q9e)
      ])) : o(i) === "regular" ? (s(), r("g", G9e, [
        e("path", {
          d: "M96,72a32,32,0,0,1,64,0L19.2,177.6A8,8,0,0,0,24,192H232a8,8,0,0,0,4.8-14.4L128,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E9e)
      ])) : g("", !0)
    ], 16, b9e));
  }
}), I9e = ["width", "height", "fill", "transform"], K9e = { key: 0 }, X9e = ["stroke"], J9e = ["stroke"], Q9e = ["stroke"], Y9e = { key: 1 }, o$e = ["stroke"], e$e = ["stroke"], t$e = ["stroke"], n$e = { key: 2 }, s$e = /* @__PURE__ */ e("path", { d: "M70.1,82.9a7.8,7.8,0,0,0-11.2-1l-48,40a7.9,7.9,0,0,0,0,12.2l48,40a7.8,7.8,0,0,0,11.2-1,7.8,7.8,0,0,0-1-11.2L28.5,128,69.1,94.1A7.8,7.8,0,0,0,70.1,82.9Z" }, null, -1), r$e = /* @__PURE__ */ e("path", { d: "M245.1,121.9l-48-40a8,8,0,0,0-10.2,12.2L227.5,128l-40.6,33.9A8,8,0,0,0,192,176a7.7,7.7,0,0,0,5.1-1.9l48-40a7.9,7.9,0,0,0,0-12.2Z" }, null, -1), i$e = /* @__PURE__ */ e("path", { d: "M162.7,32.5a7.9,7.9,0,0,0-10.2,4.8l-64,176a7.9,7.9,0,0,0,4.8,10.2,8.6,8.6,0,0,0,2.7.5,7.9,7.9,0,0,0,7.5-5.3l64-176A7.9,7.9,0,0,0,162.7,32.5Z" }, null, -1), l$e = [
  s$e,
  r$e,
  i$e
], d$e = { key: 3 }, k$e = ["stroke"], c$e = ["stroke"], h$e = ["stroke"], u$e = { key: 4 }, a$e = ["stroke"], _$e = ["stroke"], p$e = ["stroke"], y$e = { key: 5 }, $$e = ["stroke"], w$e = ["stroke"], f$e = ["stroke"], g$e = {
  name: "PhCode"
}, Oq1 = /* @__PURE__ */ $({
  ...g$e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", K9e, [
        e("polyline", {
          points: "64 88 16 128 64 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X9e),
        e("polyline", {
          points: "192 88 240 128 192 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, J9e),
        e("line", {
          x1: "160",
          y1: "40",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Q9e)
      ])) : o(i) === "duotone" ? (s(), r("g", Y9e, [
        e("polyline", {
          points: "64 88 16 128 64 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o$e),
        e("polyline", {
          points: "192 88 240 128 192 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e$e),
        e("line", {
          x1: "160",
          y1: "40",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t$e)
      ])) : o(i) === "fill" ? (s(), r("g", n$e, l$e)) : o(i) === "light" ? (s(), r("g", d$e, [
        e("polyline", {
          points: "64 88 16 128 64 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, k$e),
        e("polyline", {
          points: "192 88 240 128 192 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, c$e),
        e("line", {
          x1: "160",
          y1: "40",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, h$e)
      ])) : o(i) === "thin" ? (s(), r("g", u$e, [
        e("polyline", {
          points: "64 88 16 128 64 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, a$e),
        e("polyline", {
          points: "192 88 240 128 192 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _$e),
        e("line", {
          x1: "160",
          y1: "40",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, p$e)
      ])) : o(i) === "regular" ? (s(), r("g", y$e, [
        e("polyline", {
          points: "64 88 16 128 64 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $$e),
        e("polyline", {
          points: "192 88 240 128 192 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w$e),
        e("line", {
          x1: "160",
          y1: "40",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f$e)
      ])) : g("", !0)
    ], 16, I9e));
  }
}), x$e = ["width", "height", "fill", "transform"], j$e = { key: 0 }, m$e = ["stroke"], M$e = ["stroke"], v$e = { key: 1 }, S$e = ["stroke"], H$e = ["stroke"], A$e = { key: 2 }, V$e = /* @__PURE__ */ e("path", { d: "M94,58.7A8,8,0,0,0,82.7,58l-72,64a8,8,0,0,0,0,12l72,64a8.1,8.1,0,0,0,5.3,2,8,8,0,0,0,5.3-14L28,128,93.3,70A8,8,0,0,0,94,58.7Z" }, null, -1), z$e = /* @__PURE__ */ e("path", { d: "M245.3,122l-72-64a8,8,0,0,0-10.6,12L228,128l-65.3,58a8,8,0,0,0,5.3,14,8.1,8.1,0,0,0,5.3-2l72-64a8,8,0,0,0,0-12Z" }, null, -1), Z$e = [
  V$e,
  z$e
], C$e = { key: 3 }, b$e = ["stroke"], L$e = ["stroke"], B$e = { key: 4 }, P$e = ["stroke"], W$e = ["stroke"], N$e = { key: 5 }, F$e = ["stroke"], T$e = ["stroke"], D$e = {
  name: "PhCodeSimple"
}, Iq1 = /* @__PURE__ */ $({
  ...D$e,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", j$e, [
        e("polyline", {
          points: "88 64 16 128 88 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, m$e),
        e("polyline", {
          points: "168 64 240 128 168 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, M$e)
      ])) : o(i) === "duotone" ? (s(), r("g", v$e, [
        e("polyline", {
          points: "88 64 16 128 88 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S$e),
        e("polyline", {
          points: "168 64 240 128 168 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H$e)
      ])) : o(i) === "fill" ? (s(), r("g", A$e, Z$e)) : o(i) === "light" ? (s(), r("g", C$e, [
        e("polyline", {
          points: "88 64 16 128 88 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b$e),
        e("polyline", {
          points: "168 64 240 128 168 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, L$e)
      ])) : o(i) === "thin" ? (s(), r("g", B$e, [
        e("polyline", {
          points: "88 64 16 128 88 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, P$e),
        e("polyline", {
          points: "168 64 240 128 168 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, W$e)
      ])) : o(i) === "regular" ? (s(), r("g", N$e, [
        e("polyline", {
          points: "88 64 16 128 88 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F$e),
        e("polyline", {
          points: "168 64 240 128 168 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T$e)
      ])) : g("", !0)
    ], 16, x$e));
  }
}), R$e = ["width", "height", "fill", "transform"], U$e = { key: 0 }, q$e = ["stroke"], G$e = ["stroke"], E$e = ["stroke"], O$e = ["stroke"], I$e = ["stroke"], K$e = ["stroke"], X$e = { key: 1 }, J$e = /* @__PURE__ */ e("path", {
  d: "M232,165,131.9,221.8a8.3,8.3,0,0,1-7.8,0L24,165l104-59Z",
  opacity: "0.2"
}, null, -1), Q$e = ["stroke"], Y$e = ["stroke"], owe = ["stroke"], ewe = ["stroke"], twe = ["stroke"], nwe = ["stroke"], swe = { key: 2 }, rwe = /* @__PURE__ */ e("path", { d: "M240,101v64a8,8,0,0,1-4.1,7L142,225.3a4,4,0,0,1-6-3.5V164.7L191.8,133,224,151.3V114.7L191.8,133l-16.2-9.2L215.8,101,136,55.7v45.6l39.6,22.5-47.6,27-47.6-27L120,101.3V55.7L40.2,101l40.2,22.8L64.2,133,32,114.7v36.6L64.2,133,120,164.7v57.1a4,4,0,0,1-6,3.5L20.1,172a8,8,0,0,1-4.1-7V101a8,8,0,0,1,4.1-7l100-56.7a15.9,15.9,0,0,1,15.8,0L235.9,94A8,8,0,0,1,240,101Z" }, null, -1), iwe = [
  rwe
], lwe = { key: 3 }, dwe = ["stroke"], kwe = ["stroke"], cwe = ["stroke"], hwe = ["stroke"], uwe = ["stroke"], awe = ["stroke"], _we = { key: 4 }, pwe = ["stroke"], ywe = ["stroke"], $we = ["stroke"], wwe = ["stroke"], fwe = ["stroke"], gwe = ["stroke"], xwe = { key: 5 }, jwe = ["stroke"], mwe = ["stroke"], Mwe = ["stroke"], vwe = ["stroke"], Swe = ["stroke"], Hwe = ["stroke"], Awe = {
  name: "PhCodepenLogo"
}, Kq1 = /* @__PURE__ */ $({
  ...Awe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", U$e, [
        e("path", {
          d: "M232,101,128,160,24,101,124.1,44.2a8.3,8.3,0,0,1,7.8,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, q$e),
        e("path", {
          d: "M232,165,131.9,221.8a8.3,8.3,0,0,1-7.8,0L24,165l104-59Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, G$e),
        e("line", {
          x1: "232",
          y1: "101",
          x2: "232",
          y2: "165",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, E$e),
        e("line", {
          x1: "24",
          y1: "101",
          x2: "24",
          y2: "165",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, O$e),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "222.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, I$e),
        e("line", {
          x1: "128",
          y1: "43.2",
          x2: "128",
          y2: "106",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, K$e)
      ])) : o(i) === "duotone" ? (s(), r("g", X$e, [
        J$e,
        e("path", {
          d: "M232,101,128,160,24,101,124.1,44.2a8.3,8.3,0,0,1,7.8,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q$e),
        e("path", {
          d: "M232,165,131.9,221.8a8.3,8.3,0,0,1-7.8,0L24,165l104-59Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y$e),
        e("line", {
          x1: "232",
          y1: "101",
          x2: "232",
          y2: "165",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, owe),
        e("line", {
          x1: "24",
          y1: "101",
          x2: "24",
          y2: "165",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ewe),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "222.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, twe),
        e("line", {
          x1: "128",
          y1: "43.2",
          x2: "128",
          y2: "106",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nwe)
      ])) : o(i) === "fill" ? (s(), r("g", swe, iwe)) : o(i) === "light" ? (s(), r("g", lwe, [
        e("path", {
          d: "M232,101,128,160,24,101,124.1,44.2a8.3,8.3,0,0,1,7.8,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dwe),
        e("path", {
          d: "M232,165,131.9,221.8a8.3,8.3,0,0,1-7.8,0L24,165l104-59Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kwe),
        e("line", {
          x1: "232",
          y1: "101",
          x2: "232",
          y2: "165",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cwe),
        e("line", {
          x1: "24",
          y1: "101",
          x2: "24",
          y2: "165",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hwe),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "222.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uwe),
        e("line", {
          x1: "128",
          y1: "43.2",
          x2: "128",
          y2: "106",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, awe)
      ])) : o(i) === "thin" ? (s(), r("g", _we, [
        e("path", {
          d: "M232,101,128,160,24,101,124.1,44.2a8.3,8.3,0,0,1,7.8,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pwe),
        e("path", {
          d: "M232,165,131.9,221.8a8.3,8.3,0,0,1-7.8,0L24,165l104-59Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ywe),
        e("line", {
          x1: "232",
          y1: "101",
          x2: "232",
          y2: "165",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $we),
        e("line", {
          x1: "24",
          y1: "101",
          x2: "24",
          y2: "165",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wwe),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "222.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fwe),
        e("line", {
          x1: "128",
          y1: "43.2",
          x2: "128",
          y2: "106",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gwe)
      ])) : o(i) === "regular" ? (s(), r("g", xwe, [
        e("path", {
          d: "M232,101,128,160,24,101,124.1,44.2a8.3,8.3,0,0,1,7.8,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jwe),
        e("path", {
          d: "M232,165,131.9,221.8a8.3,8.3,0,0,1-7.8,0L24,165l104-59Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mwe),
        e("line", {
          x1: "232",
          y1: "101",
          x2: "232",
          y2: "165",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mwe),
        e("line", {
          x1: "24",
          y1: "101",
          x2: "24",
          y2: "165",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vwe),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "222.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Swe),
        e("line", {
          x1: "128",
          y1: "43.2",
          x2: "128",
          y2: "106",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hwe)
      ])) : g("", !0)
    ], 16, R$e));
  }
}), Vwe = ["width", "height", "fill", "transform"], zwe = { key: 0 }, Zwe = ["stroke"], Cwe = ["stroke"], bwe = ["stroke"], Lwe = ["stroke"], Bwe = ["stroke"], Pwe = ["stroke"], Wwe = { key: 1 }, Nwe = /* @__PURE__ */ e("path", {
  d: "M79,47.5l49,27.6,49-27.6L131.9,22.2a7.8,7.8,0,0,0-7.8,0Z",
  opacity: "0.2"
}, null, -1), Fwe = /* @__PURE__ */ e("path", {
  d: "M176,209V153.9l48-27v50.4a8.1,8.1,0,0,1-4.1,7Z",
  opacity: "0.2"
}, null, -1), Twe = /* @__PURE__ */ e("path", {
  d: "M80,209V153.9l-48-27v50.4a8.1,8.1,0,0,0,4.1,7Z",
  opacity: "0.2"
}, null, -1), Dwe = ["stroke"], Rwe = ["stroke"], Uwe = ["stroke"], qwe = ["stroke"], Gwe = ["stroke"], Ewe = ["stroke"], Owe = { key: 2 }, Iwe = /* @__PURE__ */ e("path", { d: "M232,126.8V78.7a15.6,15.6,0,0,0-2.1-7.9h-.1a15.5,15.5,0,0,0-6-5.9l-88-49.5a16,16,0,0,0-15.6,0l-88,49.5a16.2,16.2,0,0,0-6,5.9.1.1,0,0,1-.1.1v.2A15,15,0,0,0,24,78.7v48.1h0v50.5a16.1,16.1,0,0,0,8.2,14l44,24.7h0l44,24.8a16.5,16.5,0,0,0,7.2,2h1.3a16.1,16.1,0,0,0,7.1-2l44-24.8h0l44-24.7a16.1,16.1,0,0,0,8.2-14V126.8ZM83.9,147,40,122.2V87.6l80.9,45.1-.8,89.7L88,204.3V153.9A7.9,7.9,0,0,0,83.9,147ZM79,56.7,124.1,82a7.5,7.5,0,0,0,7.8,0L177,56.7,207.7,74l-78.8,44.8L48.4,74Zm57.9,76,79.1-45v34.5L172.1,147a7.9,7.9,0,0,0-4.1,6.9v50.4l-31.9,18Z" }, null, -1), Kwe = [
  Iwe
], Xwe = { key: 3 }, Jwe = ["stroke"], Qwe = ["stroke"], Ywe = ["stroke"], ofe = ["stroke"], efe = ["stroke"], tfe = ["stroke"], nfe = { key: 4 }, sfe = ["stroke"], rfe = ["stroke"], ife = ["stroke"], lfe = ["stroke"], dfe = ["stroke"], kfe = ["stroke"], cfe = { key: 5 }, hfe = ["stroke"], ufe = ["stroke"], afe = ["stroke"], _fe = ["stroke"], pfe = ["stroke"], yfe = ["stroke"], $fe = {
  name: "PhCodesandboxLogo"
}, Xq1 = /* @__PURE__ */ $({
  ...$fe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", zwe, [
        e("path", {
          d: "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zwe),
        e("polyline", {
          points: "222.9 74.6 128.9 128 33.1 74.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cwe),
        e("line", {
          x1: "128.9",
          y1: "128",
          x2: "128",
          y2: "234.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bwe),
        e("polyline", {
          points: "177 47.5 128 75.1 79 47.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lwe),
        e("polyline", {
          points: "176 209 176 153.9 224 126.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bwe),
        e("polyline", {
          points: "80 209 80 153.9 32 126.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pwe)
      ])) : o(i) === "duotone" ? (s(), r("g", Wwe, [
        Nwe,
        Fwe,
        Twe,
        e("path", {
          d: "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dwe),
        e("polyline", {
          points: "222.9 74.6 128.9 128 33.1 74.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rwe),
        e("line", {
          x1: "128.9",
          y1: "128",
          x2: "128",
          y2: "234.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uwe),
        e("polyline", {
          points: "177 47.5 128 75.1 79 47.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qwe),
        e("polyline", {
          points: "176 209 176 153.9 224 126.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gwe),
        e("polyline", {
          points: "80 209 80 153.9 32 126.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ewe)
      ])) : o(i) === "fill" ? (s(), r("g", Owe, Kwe)) : o(i) === "light" ? (s(), r("g", Xwe, [
        e("path", {
          d: "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jwe),
        e("polyline", {
          points: "222.9 74.6 128.9 128 33.1 74.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qwe),
        e("line", {
          x1: "128.9",
          y1: "128",
          x2: "128",
          y2: "234.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ywe),
        e("polyline", {
          points: "177 47.5 128 75.1 79 47.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ofe),
        e("polyline", {
          points: "176 209 176 153.9 224 126.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, efe),
        e("polyline", {
          points: "80 209 80 153.9 32 126.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tfe)
      ])) : o(i) === "thin" ? (s(), r("g", nfe, [
        e("path", {
          d: "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sfe),
        e("polyline", {
          points: "222.9 74.6 128.9 128 33.1 74.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rfe),
        e("line", {
          x1: "128.9",
          y1: "128",
          x2: "128",
          y2: "234.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ife),
        e("polyline", {
          points: "177 47.5 128 75.1 79 47.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lfe),
        e("polyline", {
          points: "176 209 176 153.9 224 126.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dfe),
        e("polyline", {
          points: "80 209 80 153.9 32 126.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kfe)
      ])) : o(i) === "regular" ? (s(), r("g", cfe, [
        e("path", {
          d: "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hfe),
        e("polyline", {
          points: "222.9 74.6 128.9 128 33.1 74.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ufe),
        e("line", {
          x1: "128.9",
          y1: "128",
          x2: "128",
          y2: "234.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, afe),
        e("polyline", {
          points: "177 47.5 128 75.1 79 47.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _fe),
        e("polyline", {
          points: "176 209 176 153.9 224 126.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pfe),
        e("polyline", {
          points: "80 209 80 153.9 32 126.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yfe)
      ])) : g("", !0)
    ], 16, Vwe));
  }
}), wfe = ["width", "height", "fill", "transform"], ffe = { key: 0 }, gfe = ["stroke"], xfe = ["stroke"], jfe = ["stroke"], mfe = ["stroke"], Mfe = ["stroke"], vfe = ["stroke"], Sfe = { key: 1 }, Hfe = /* @__PURE__ */ e("path", {
  d: "M83.3,216A88,88,0,0,1,32,136V88H208v48a88,88,0,0,1-51.3,80Z",
  opacity: "0.2"
}, null, -1), Afe = ["stroke"], Vfe = ["stroke"], zfe = ["stroke"], Zfe = ["stroke"], Cfe = ["stroke"], bfe = ["stroke"], Lfe = { key: 2 }, Bfe = /* @__PURE__ */ e("path", { d: "M80,56V24a8,8,0,0,1,16,0V56a8,8,0,0,1-16,0Zm40,8a8,8,0,0,0,8-8V24a8,8,0,0,0-16,0V56A8,8,0,0,0,120,64Zm32,0a8,8,0,0,0,8-8V24a8,8,0,0,0-16,0V56A8,8,0,0,0,152,64Zm96,56v8a40,40,0,0,1-37.5,39.9,98,98,0,0,1-27,40.1H208a8,8,0,0,1,0,16H32a8,8,0,0,1,0-16H56.5A96.4,96.4,0,0,1,24,136V88a8,8,0,0,1,8-8H208A40,40,0,0,1,248,120Zm-16,0a24,24,0,0,0-16-22.6V136a92.9,92.9,0,0,1-1.2,15A24,24,0,0,0,232,128Z" }, null, -1), Pfe = [
  Bfe
], Wfe = { key: 3 }, Nfe = ["stroke"], Ffe = ["stroke"], Tfe = ["stroke"], Dfe = ["stroke"], Rfe = ["stroke"], Ufe = ["stroke"], qfe = { key: 4 }, Gfe = ["stroke"], Efe = ["stroke"], Ofe = ["stroke"], Ife = ["stroke"], Kfe = ["stroke"], Xfe = ["stroke"], Jfe = { key: 5 }, Qfe = ["stroke"], Yfe = ["stroke"], oge = ["stroke"], ege = ["stroke"], tge = ["stroke"], nge = ["stroke"], sge = {
  name: "PhCoffee"
}, Jq1 = /* @__PURE__ */ $({
  ...sge,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ffe, [
        e("line", {
          x1: "32",
          y1: "216",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gfe),
        e("path", {
          d: "M83.3,216A88,88,0,0,1,32,136V88H208v48a88,88,0,0,1-51.3,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xfe),
        e("path", {
          d: "M208,88h4a32,32,0,0,1,32,32v8a32,32,0,0,1-32,32h-7.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jfe),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mfe),
        e("line", {
          x1: "120",
          y1: "24",
          x2: "120",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mfe),
        e("line", {
          x1: "160",
          y1: "24",
          x2: "160",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vfe)
      ])) : o(i) === "duotone" ? (s(), r("g", Sfe, [
        Hfe,
        e("line", {
          x1: "88",
          y1: "24",
          x2: "88",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Afe),
        e("line", {
          x1: "120",
          y1: "24",
          x2: "120",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vfe),
        e("line", {
          x1: "152",
          y1: "24",
          x2: "152",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zfe),
        e("line", {
          x1: "32",
          y1: "216",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zfe),
        e("path", {
          d: "M83.3,216A88,88,0,0,1,32,136V88H208v48a88,88,0,0,1-51.3,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cfe),
        e("path", {
          d: "M208,88h0a32,32,0,0,1,32,32v8a32,32,0,0,1-32,32h-3.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bfe)
      ])) : o(i) === "fill" ? (s(), r("g", Lfe, Pfe)) : o(i) === "light" ? (s(), r("g", Wfe, [
        e("line", {
          x1: "88",
          y1: "24",
          x2: "88",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Nfe),
        e("line", {
          x1: "120",
          y1: "24",
          x2: "120",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ffe),
        e("line", {
          x1: "152",
          y1: "24",
          x2: "152",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Tfe),
        e("line", {
          x1: "32",
          y1: "216",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dfe),
        e("path", {
          d: "M83.3,216A88,88,0,0,1,32,136V88H208v48a88,88,0,0,1-51.3,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rfe),
        e("path", {
          d: "M208,88h0a32,32,0,0,1,32,32v8a32,32,0,0,1-32,32h-3.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ufe)
      ])) : o(i) === "thin" ? (s(), r("g", qfe, [
        e("line", {
          x1: "88",
          y1: "24",
          x2: "88",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gfe),
        e("line", {
          x1: "120",
          y1: "24",
          x2: "120",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Efe),
        e("line", {
          x1: "152",
          y1: "24",
          x2: "152",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ofe),
        e("line", {
          x1: "32",
          y1: "216",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ife),
        e("path", {
          d: "M83.3,216A88,88,0,0,1,32,136V88H208v48a88,88,0,0,1-51.3,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kfe),
        e("path", {
          d: "M208,88h0a32,32,0,0,1,32,32v8a32,32,0,0,1-32,32h-3.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xfe)
      ])) : o(i) === "regular" ? (s(), r("g", Jfe, [
        e("line", {
          x1: "88",
          y1: "24",
          x2: "88",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qfe),
        e("line", {
          x1: "120",
          y1: "24",
          x2: "120",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yfe),
        e("line", {
          x1: "152",
          y1: "24",
          x2: "152",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oge),
        e("line", {
          x1: "32",
          y1: "216",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ege),
        e("path", {
          d: "M83.3,216A88,88,0,0,1,32,136V88H208v48a88,88,0,0,1-51.3,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tge),
        e("path", {
          d: "M208,88h0a32,32,0,0,1,32,32v8a32,32,0,0,1-32,32h-3.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nge)
      ])) : g("", !0)
    ], 16, wfe));
  }
}), rge = ["width", "height", "fill", "transform"], ige = { key: 0 }, lge = ["stroke"], dge = ["stroke"], kge = ["stroke"], cge = ["stroke"], hge = ["stroke"], uge = { key: 1 }, age = /* @__PURE__ */ e("ellipse", {
  cx: "128",
  cy: "104",
  rx: "104",
  ry: "48",
  opacity: "0.2"
}, null, -1), _ge = ["stroke"], pge = ["stroke"], yge = ["stroke"], $ge = ["stroke"], wge = ["stroke"], fge = { key: 2 }, gge = /* @__PURE__ */ e("path", { d: "M207.6,63.8C186.8,53.5,159.3,48,128,48S69.2,53.5,48.4,63.8,16,88.8,16,104v48c0,15.2,11.8,29.9,32.4,40.2S96.7,208,128,208s58.8-5.5,79.6-15.8S240,167.2,240,152V104C240,88.8,228.2,74.1,207.6,63.8ZM120,159.9v32c-19-.7-35-3.5-48-7.5V153C86.3,157,102.5,159.3,120,159.9Zm16,0c17.5-.6,33.7-2.9,48-6.9v31.4c-13,4-29,6.8-48,7.5ZM32,152V133.5a84.5,84.5,0,0,0,16.4,10.7l7.6,3.4V178C40.2,170.2,32,160.3,32,152Zm168,26V147.6l7.6-3.4A84.5,84.5,0,0,0,224,133.5V152C224,160.3,215.8,170.2,200,178Z" }, null, -1), xge = [
  gge
], jge = { key: 3 }, mge = ["stroke"], Mge = ["stroke"], vge = ["stroke"], Sge = ["stroke"], Hge = ["stroke"], Age = { key: 4 }, Vge = ["stroke"], zge = ["stroke"], Zge = ["stroke"], Cge = ["stroke"], bge = ["stroke"], Lge = { key: 5 }, Bge = ["stroke"], Pge = ["stroke"], Wge = ["stroke"], Nge = ["stroke"], Fge = ["stroke"], Tge = {
  name: "PhCoin"
}, Qq1 = /* @__PURE__ */ $({
  ...Tge,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ige, [
        e("ellipse", {
          cx: "128",
          cy: "104",
          rx: "104",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lge),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dge),
        e("path", {
          d: "M24,104v48c0,24,40,48,104,48s104-24,104-48V104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kge),
        e("line", {
          x1: "192",
          y1: "142.1",
          x2: "192",
          y2: "190.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cge),
        e("line", {
          x1: "64",
          y1: "142.1",
          x2: "64",
          y2: "190.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hge)
      ])) : o(i) === "duotone" ? (s(), r("g", uge, [
        age,
        e("ellipse", {
          cx: "128",
          cy: "104",
          rx: "104",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _ge),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pge),
        e("path", {
          d: "M24,104v48c0,24,40,48,104,48s104-24,104-48V104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yge),
        e("line", {
          x1: "192",
          y1: "142.1",
          x2: "192",
          y2: "190.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $ge),
        e("line", {
          x1: "64",
          y1: "142.1",
          x2: "64",
          y2: "190.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wge)
      ])) : o(i) === "fill" ? (s(), r("g", fge, xge)) : o(i) === "light" ? (s(), r("g", jge, [
        e("ellipse", {
          cx: "128",
          cy: "104",
          rx: "104",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mge),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mge),
        e("path", {
          d: "M24,104v48c0,24,40,48,104,48s104-24,104-48V104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vge),
        e("line", {
          x1: "192",
          y1: "142.1",
          x2: "192",
          y2: "190.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Sge),
        e("line", {
          x1: "64",
          y1: "142.1",
          x2: "64",
          y2: "190.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hge)
      ])) : o(i) === "thin" ? (s(), r("g", Age, [
        e("ellipse", {
          cx: "128",
          cy: "104",
          rx: "104",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vge),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zge),
        e("path", {
          d: "M24,104v48c0,24,40,48,104,48s104-24,104-48V104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zge),
        e("line", {
          x1: "192",
          y1: "142.1",
          x2: "192",
          y2: "190.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cge),
        e("line", {
          x1: "64",
          y1: "142.1",
          x2: "64",
          y2: "190.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bge)
      ])) : o(i) === "regular" ? (s(), r("g", Lge, [
        e("ellipse", {
          cx: "128",
          cy: "104",
          rx: "104",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bge),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pge),
        e("path", {
          d: "M24,104v48c0,24,40,48,104,48s104-24,104-48V104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wge),
        e("line", {
          x1: "192",
          y1: "142.1",
          x2: "192",
          y2: "190.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nge),
        e("line", {
          x1: "64",
          y1: "142.1",
          x2: "64",
          y2: "190.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fge)
      ])) : g("", !0)
    ], 16, rge));
  }
}), Dge = ["width", "height", "fill", "transform"], Rge = { key: 0 }, Uge = ["stroke"], qge = ["stroke"], Gge = ["stroke"], Ege = ["stroke"], Oge = ["stroke"], Ige = { key: 1 }, Kge = /* @__PURE__ */ e("ellipse", {
  cx: "104",
  cy: "128",
  rx: "56",
  ry: "96",
  opacity: "0.2"
}, null, -1), Xge = ["stroke"], Jge = ["stroke"], Qge = ["stroke"], Yge = ["stroke"], oxe = ["stroke"], exe = { key: 2 }, txe = /* @__PURE__ */ e("path", { d: "M198.5,56.1C186.4,35.4,169.9,24,152,24H104C86.1,24,69.6,35.4,57.5,56.1S40,101,40,128s6.2,52.6,17.5,71.9S86.1,232,104,232h48c17.9,0,34.4-11.4,46.5-32.1S216,155,216,128,209.8,75.4,198.5,56.1Zm1.3,63.9h-32c-.8-17.2-4.1-33.7-9.7-48h30.6C194.8,85.4,198.9,102,199.8,120ZM179.2,56H150.5a89,89,0,0,0-12-16H152C162,40,171.4,46,179.2,56ZM152,216H138.5a89,89,0,0,0,12-16h28.7C171.4,210,162,216,152,216Zm36.7-32H158.1c5.6-14.3,8.9-30.8,9.7-48h32C198.9,154,194.8,170.6,188.7,184Z" }, null, -1), nxe = [
  txe
], sxe = { key: 3 }, rxe = ["stroke"], ixe = ["stroke"], lxe = ["stroke"], dxe = ["stroke"], kxe = ["stroke"], cxe = { key: 4 }, hxe = ["stroke"], uxe = ["stroke"], axe = ["stroke"], _xe = ["stroke"], pxe = ["stroke"], yxe = { key: 5 }, $xe = ["stroke"], wxe = ["stroke"], fxe = ["stroke"], gxe = ["stroke"], xxe = ["stroke"], jxe = {
  name: "PhCoinVertical"
}, Yq1 = /* @__PURE__ */ $({
  ...jxe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Rge, [
        e("ellipse", {
          cx: "104",
          cy: "128",
          rx: "56",
          ry: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Uge),
        e("path", {
          d: "M104,32h48c30.9,0,56,43,56,96s-25.1,96-56,96H104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qge),
        e("line", {
          x1: "160",
          y1: "128",
          x2: "208",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gge),
        e("line", {
          x1: "149.5",
          y1: "184",
          x2: "197.5",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ege),
        e("line", {
          x1: "149.5",
          y1: "72",
          x2: "197.5",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Oge)
      ])) : o(i) === "duotone" ? (s(), r("g", Ige, [
        Kge,
        e("ellipse", {
          cx: "104",
          cy: "128",
          rx: "56",
          ry: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xge),
        e("path", {
          d: "M104,32h48c30.9,0,56,43,56,96s-25.1,96-56,96H104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jge),
        e("line", {
          x1: "145.7",
          y1: "64",
          x2: "193.7",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qge),
        e("line", {
          x1: "160",
          y1: "128",
          x2: "208",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yge),
        e("line", {
          x1: "145.7",
          y1: "192",
          x2: "193.7",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oxe)
      ])) : o(i) === "fill" ? (s(), r("g", exe, nxe)) : o(i) === "light" ? (s(), r("g", sxe, [
        e("ellipse", {
          cx: "104",
          cy: "128",
          rx: "56",
          ry: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rxe),
        e("path", {
          d: "M104,32h48c30.9,0,56,43,56,96s-25.1,96-56,96H104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ixe),
        e("line", {
          x1: "145.7",
          y1: "64",
          x2: "193.7",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lxe),
        e("line", {
          x1: "160",
          y1: "128",
          x2: "208",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dxe),
        e("line", {
          x1: "145.7",
          y1: "192",
          x2: "193.7",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kxe)
      ])) : o(i) === "thin" ? (s(), r("g", cxe, [
        e("ellipse", {
          cx: "104",
          cy: "128",
          rx: "56",
          ry: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hxe),
        e("path", {
          d: "M104,32h48c30.9,0,56,43,56,96s-25.1,96-56,96H104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uxe),
        e("line", {
          x1: "145.7",
          y1: "64",
          x2: "193.7",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, axe),
        e("line", {
          x1: "160",
          y1: "128",
          x2: "208",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _xe),
        e("line", {
          x1: "145.7",
          y1: "192",
          x2: "193.7",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pxe)
      ])) : o(i) === "regular" ? (s(), r("g", yxe, [
        e("ellipse", {
          cx: "104",
          cy: "128",
          rx: "56",
          ry: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $xe),
        e("path", {
          d: "M104,32h48c30.9,0,56,43,56,96s-25.1,96-56,96H104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wxe),
        e("line", {
          x1: "145.7",
          y1: "64",
          x2: "193.7",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fxe),
        e("line", {
          x1: "160",
          y1: "128",
          x2: "208",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gxe),
        e("line", {
          x1: "145.7",
          y1: "192",
          x2: "193.7",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xxe)
      ])) : g("", !0)
    ], 16, Dge));
  }
}), mxe = ["width", "height", "fill", "transform"], Mxe = { key: 0 }, vxe = ["stroke"], Sxe = ["stroke"], Hxe = ["stroke"], Axe = ["stroke"], Vxe = ["stroke"], zxe = ["stroke"], Zxe = ["stroke"], Cxe = { key: 1 }, bxe = /* @__PURE__ */ e("ellipse", {
  cx: "96",
  cy: "84",
  rx: "80",
  ry: "36",
  opacity: "0.2"
}, null, -1), Lxe = /* @__PURE__ */ e("path", {
  d: "M176,96.7c36.5,3.4,64,17.9,64,35.3,0,19.9-35.8,36-80,36-19.6,0-37.6-3.2-51.5-8.4h0C146.8,156.9,176,142,176,124Z",
  opacity: "0.2"
}, null, -1), Bxe = ["stroke"], Pxe = ["stroke"], Wxe = ["stroke"], Nxe = ["stroke"], Fxe = ["stroke"], Txe = ["stroke"], Dxe = ["stroke"], Rxe = { key: 2 }, Uxe = /* @__PURE__ */ e("path", { d: "M184,89.6V84c0-25.1-37.8-44-88-44S8,58.9,8,84v40c0,20.9,26.2,37.5,64,42.5V172c0,25.1,37.8,44,88,44s88-18.9,88-44V132C248,111.3,222.6,94.7,184,89.6ZM72,150.2V126.5A184,184,0,0,0,96,128a184,184,0,0,0,24-1.5v23.7A151.1,151.1,0,0,1,96,152,151.1,151.1,0,0,1,72,150.2Zm96-40.3V124c0,8.4-12.4,17.4-32,22.9V123.5C148.9,120.4,159.8,115.7,168,109.9ZM24,124V109.9c8.2,5.8,19.1,10.5,32,13.6v23.4C36.4,141.4,24,132.4,24,124Zm64,48v-4.2l8,.2q5.9,0,11.4-.3c4,1.4,8.2,2.6,12.6,3.7v23.5C100.4,189.4,88,180.4,88,172Zm48,26.2V174.4a188.4,188.4,0,0,0,24,1.6,184,184,0,0,0,24-1.5v23.7a160.9,160.9,0,0,1-48,0Zm64-3.3V171.5c12.9-3.1,23.8-7.8,32-13.6V172C232,180.4,219.6,189.4,200,194.9Z" }, null, -1), qxe = [
  Uxe
], Gxe = { key: 3 }, Exe = ["stroke"], Oxe = ["stroke"], Ixe = ["stroke"], Kxe = ["stroke"], Xxe = ["stroke"], Jxe = ["stroke"], Qxe = ["stroke"], Yxe = { key: 4 }, oje = ["stroke"], eje = ["stroke"], tje = ["stroke"], nje = ["stroke"], sje = ["stroke"], rje = ["stroke"], ije = ["stroke"], lje = { key: 5 }, dje = ["stroke"], kje = ["stroke"], cje = ["stroke"], hje = ["stroke"], uje = ["stroke"], aje = ["stroke"], _je = ["stroke"], pje = {
  name: "PhCoins"
}, oG1 = /* @__PURE__ */ $({
  ...pje,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Mxe, [
        e("ellipse", {
          cx: "96",
          cy: "84",
          rx: "80",
          ry: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vxe),
        e("path", {
          d: "M16,84v40c0,19.9,35.8,36,80,36s80-16.1,80-36V84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Sxe),
        e("line", {
          x1: "64",
          y1: "117",
          x2: "64",
          y2: "157",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hxe),
        e("path", {
          d: "M176,96.7c36.5,3.4,64,17.9,64,35.3,0,19.9-35.8,36-80,36-19.6,0-37.6-3.2-51.5-8.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Axe),
        e("path", {
          d: "M80,159.3V172c0,19.9,35.8,36,80,36s80-16.1,80-36V132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vxe),
        e("line", {
          x1: "192",
          y1: "165",
          x2: "192",
          y2: "205",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zxe),
        e("line", {
          x1: "128",
          y1: "117",
          x2: "128",
          y2: "205",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zxe)
      ])) : o(i) === "duotone" ? (s(), r("g", Cxe, [
        bxe,
        Lxe,
        e("ellipse", {
          cx: "96",
          cy: "84",
          rx: "80",
          ry: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bxe),
        e("path", {
          d: "M16,84v40c0,19.9,35.8,36,80,36s80-16.1,80-36V84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pxe),
        e("line", {
          x1: "64",
          y1: "117",
          x2: "64",
          y2: "157",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wxe),
        e("path", {
          d: "M176,96.7c36.5,3.4,64,17.9,64,35.3,0,19.9-35.8,36-80,36-19.6,0-37.6-3.2-51.5-8.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nxe),
        e("path", {
          d: "M80,159.3V172c0,19.9,35.8,36,80,36s80-16.1,80-36V132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fxe),
        e("line", {
          x1: "192",
          y1: "165",
          x2: "192",
          y2: "205",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Txe),
        e("line", {
          x1: "128",
          y1: "117",
          x2: "128",
          y2: "205",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dxe)
      ])) : o(i) === "fill" ? (s(), r("g", Rxe, qxe)) : o(i) === "light" ? (s(), r("g", Gxe, [
        e("ellipse", {
          cx: "96",
          cy: "84",
          rx: "80",
          ry: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Exe),
        e("path", {
          d: "M16,84v40c0,19.9,35.8,36,80,36s80-16.1,80-36V84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Oxe),
        e("line", {
          x1: "64",
          y1: "117",
          x2: "64",
          y2: "157",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ixe),
        e("path", {
          d: "M176,96.7c36.5,3.4,64,17.9,64,35.3,0,19.9-35.8,36-80,36-19.6,0-37.6-3.2-51.5-8.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kxe),
        e("path", {
          d: "M80,159.3V172c0,19.9,35.8,36,80,36s80-16.1,80-36V132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xxe),
        e("line", {
          x1: "192",
          y1: "165",
          x2: "192",
          y2: "205",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jxe),
        e("line", {
          x1: "128",
          y1: "117",
          x2: "128",
          y2: "205",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qxe)
      ])) : o(i) === "thin" ? (s(), r("g", Yxe, [
        e("ellipse", {
          cx: "96",
          cy: "84",
          rx: "80",
          ry: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oje),
        e("path", {
          d: "M16,84v40c0,19.9,35.8,36,80,36s80-16.1,80-36V84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eje),
        e("line", {
          x1: "64",
          y1: "117",
          x2: "64",
          y2: "157",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tje),
        e("path", {
          d: "M176,96.7c36.5,3.4,64,17.9,64,35.3,0,19.9-35.8,36-80,36-19.6,0-37.6-3.2-51.5-8.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nje),
        e("path", {
          d: "M80,159.3V172c0,19.9,35.8,36,80,36s80-16.1,80-36V132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sje),
        e("line", {
          x1: "192",
          y1: "165",
          x2: "192",
          y2: "205",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rje),
        e("line", {
          x1: "128",
          y1: "117",
          x2: "128",
          y2: "205",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ije)
      ])) : o(i) === "regular" ? (s(), r("g", lje, [
        e("ellipse", {
          cx: "96",
          cy: "84",
          rx: "80",
          ry: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dje),
        e("path", {
          d: "M16,84v40c0,19.9,35.8,36,80,36s80-16.1,80-36V84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kje),
        e("line", {
          x1: "64",
          y1: "117",
          x2: "64",
          y2: "157",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cje),
        e("path", {
          d: "M176,96.7c36.5,3.4,64,17.9,64,35.3,0,19.9-35.8,36-80,36-19.6,0-37.6-3.2-51.5-8.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hje),
        e("path", {
          d: "M80,159.3V172c0,19.9,35.8,36,80,36s80-16.1,80-36V132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uje),
        e("line", {
          x1: "192",
          y1: "165",
          x2: "192",
          y2: "205",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aje),
        e("line", {
          x1: "128",
          y1: "117",
          x2: "128",
          y2: "205",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _je)
      ])) : g("", !0)
    ], 16, mxe));
  }
}), yje = ["width", "height", "fill", "transform"], $je = { key: 0 }, wje = ["stroke"], fje = ["stroke"], gje = { key: 1 }, xje = /* @__PURE__ */ e("rect", {
  x: "-4",
  y: "100",
  width: "176",
  height: "56",
  rx: "8",
  transform: "translate(212 44) rotate(90)",
  opacity: "0.2"
}, null, -1), jje = /* @__PURE__ */ e("rect", {
  x: "84",
  y: "100",
  width: "176",
  height: "56",
  rx: "8",
  transform: "translate(300 -44) rotate(90)",
  opacity: "0.2"
}, null, -1), mje = ["stroke"], Mje = ["stroke"], vje = { key: 2 }, Sje = /* @__PURE__ */ e("path", { d: "M120,48V208a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V48A16,16,0,0,1,64,32h40A16,16,0,0,1,120,48Zm72-16H152a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V48A16,16,0,0,0,192,32Z" }, null, -1), Hje = [
  Sje
], Aje = { key: 3 }, Vje = ["stroke"], zje = ["stroke"], Zje = { key: 4 }, Cje = ["stroke"], bje = ["stroke"], Lje = { key: 5 }, Bje = ["stroke"], Pje = ["stroke"], Wje = {
  name: "PhColumns"
}, eG1 = /* @__PURE__ */ $({
  ...Wje,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $je, [
        e("rect", {
          x: "-6",
          y: "102",
          width: "176",
          height: "52",
          rx: "8",
          transform: "translate(210 46) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wje),
        e("rect", {
          x: "86",
          y: "102",
          width: "176",
          height: "52",
          rx: "8",
          transform: "translate(302 -46) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fje)
      ])) : o(i) === "duotone" ? (s(), r("g", gje, [
        xje,
        jje,
        e("rect", {
          x: "-4",
          y: "100",
          width: "176",
          height: "56",
          rx: "8",
          transform: "translate(212 44) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mje),
        e("rect", {
          x: "84",
          y: "100",
          width: "176",
          height: "56",
          rx: "8",
          transform: "translate(300 -44) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mje)
      ])) : o(i) === "fill" ? (s(), r("g", vje, Hje)) : o(i) === "light" ? (s(), r("g", Aje, [
        e("rect", {
          x: "-4",
          y: "100",
          width: "176",
          height: "56",
          rx: "8",
          transform: "translate(212 44) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vje),
        e("rect", {
          x: "84",
          y: "100",
          width: "176",
          height: "56",
          rx: "8",
          transform: "translate(300 -44) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zje)
      ])) : o(i) === "thin" ? (s(), r("g", Zje, [
        e("rect", {
          x: "-4",
          y: "100",
          width: "176",
          height: "56",
          rx: "8",
          transform: "translate(212 44) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cje),
        e("rect", {
          x: "84",
          y: "100",
          width: "176",
          height: "56",
          rx: "8",
          transform: "translate(300 -44) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bje)
      ])) : o(i) === "regular" ? (s(), r("g", Lje, [
        e("rect", {
          x: "-4",
          y: "100",
          width: "176",
          height: "56",
          rx: "8",
          transform: "translate(212 44) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bje),
        e("rect", {
          x: "84",
          y: "100",
          width: "176",
          height: "56",
          rx: "8",
          transform: "translate(300 -44) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pje)
      ])) : g("", !0)
    ], 16, yje));
  }
}), Nje = ["width", "height", "fill", "transform"], Fje = { key: 0 }, Tje = ["stroke"], Dje = ["stroke"], Rje = ["stroke"], Uje = ["stroke"], qje = ["stroke"], Gje = { key: 1 }, Eje = /* @__PURE__ */ e("path", {
  d: "M180,48h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H152a0,0,0,0,1,0,0V76A28,28,0,0,1,180,48Z",
  opacity: "0.2"
}, null, -1), Oje = /* @__PURE__ */ e("path", {
  d: "M48,48H76a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0A28,28,0,0,1,48,76V48A0,0,0,0,1,48,48Z",
  transform: "translate(152 152) rotate(180)",
  opacity: "0.2"
}, null, -1), Ije = /* @__PURE__ */ e("path", {
  d: "M152,152h28a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0a28,28,0,0,1-28-28V152A0,0,0,0,1,152,152Z",
  opacity: "0.2"
}, null, -1), Kje = /* @__PURE__ */ e("path", {
  d: "M76,152h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H48a0,0,0,0,1,0,0V180A28,28,0,0,1,76,152Z",
  transform: "translate(152 360) rotate(-180)",
  opacity: "0.2"
}, null, -1), Xje = ["stroke"], Jje = ["stroke"], Qje = ["stroke"], Yje = ["stroke"], ome = ["stroke"], eme = { key: 2 }, tme = /* @__PURE__ */ e("path", { d: "M180,144H160V112h20a36,36,0,1,0-36-36V96H112V76a36,36,0,1,0-36,36H96v32H76a36,36,0,1,0,36,36V160h32v20a36,36,0,1,0,36-36ZM160,76a20,20,0,1,1,20,20H160ZM56,76a20,20,0,0,1,40,0V96H76A20.1,20.1,0,0,1,56,76ZM96,180a20,20,0,1,1-20-20H96Zm16-68h32v32H112Zm68,88a20.1,20.1,0,0,1-20-20V160h20a20,20,0,0,1,0,40Z" }, null, -1), nme = [
  tme
], sme = { key: 3 }, rme = ["stroke"], ime = ["stroke"], lme = ["stroke"], dme = ["stroke"], kme = ["stroke"], cme = { key: 4 }, hme = ["stroke"], ume = ["stroke"], ame = ["stroke"], _me = ["stroke"], pme = ["stroke"], yme = { key: 5 }, $me = ["stroke"], wme = ["stroke"], fme = ["stroke"], gme = ["stroke"], xme = ["stroke"], jme = {
  name: "PhCommand"
}, tG1 = /* @__PURE__ */ $({
  ...jme,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Fje, [
        e("path", {
          d: "M180,48h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H152a0,0,0,0,1,0,0V76a28,28,0,0,1,28-28Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Tje),
        e("path", {
          d: "M48,48H76a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0A28,28,0,0,1,48,76V48A0,0,0,0,1,48,48Z",
          transform: "translate(152 152) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Dje),
        e("path", {
          d: "M152,152h28a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0a28,28,0,0,1-28-28V152A0,0,0,0,1,152,152Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rje),
        e("path", {
          d: "M76,152h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H48a0,0,0,0,1,0,0V180A28,28,0,0,1,76,152Z",
          transform: "translate(152 360) rotate(-180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Uje),
        e("rect", {
          x: "104",
          y: "104",
          width: "48",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qje)
      ])) : o(i) === "duotone" ? (s(), r("g", Gje, [
        Eje,
        Oje,
        Ije,
        Kje,
        e("path", {
          d: "M76,152h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H48a0,0,0,0,1,0,0V180A28,28,0,0,1,76,152Z",
          transform: "translate(152 360) rotate(-180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xje),
        e("path", {
          d: "M180,48h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H152a0,0,0,0,1,0,0V76A28,28,0,0,1,180,48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jje),
        e("path", {
          d: "M48,48H76a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0A28,28,0,0,1,48,76V48A0,0,0,0,1,48,48Z",
          transform: "translate(152 152) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qje),
        e("path", {
          d: "M152,152h28a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0a28,28,0,0,1-28-28V152A0,0,0,0,1,152,152Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yje),
        e("rect", {
          x: "104",
          y: "104",
          width: "48",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ome)
      ])) : o(i) === "fill" ? (s(), r("g", eme, nme)) : o(i) === "light" ? (s(), r("g", sme, [
        e("path", {
          d: "M180,48h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H152a0,0,0,0,1,0,0V76a28,28,0,0,1,28-28Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rme),
        e("path", {
          d: "M48,48H76a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0A28,28,0,0,1,48,76V48A0,0,0,0,1,48,48Z",
          transform: "translate(152 152) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ime),
        e("path", {
          d: "M152,152h28a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0a28,28,0,0,1-28-28V152A0,0,0,0,1,152,152Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lme),
        e("path", {
          d: "M76,152h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H48a0,0,0,0,1,0,0V180A28,28,0,0,1,76,152Z",
          transform: "translate(152 360) rotate(-180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dme),
        e("rect", {
          x: "104",
          y: "104",
          width: "48",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kme)
      ])) : o(i) === "thin" ? (s(), r("g", cme, [
        e("path", {
          d: "M180,48h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H152a0,0,0,0,1,0,0V76a28,28,0,0,1,28-28Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hme),
        e("path", {
          d: "M48,48H76a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0A28,28,0,0,1,48,76V48A0,0,0,0,1,48,48Z",
          transform: "translate(152 152) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ume),
        e("path", {
          d: "M152,152h28a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0a28,28,0,0,1-28-28V152A0,0,0,0,1,152,152Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ame),
        e("path", {
          d: "M76,152h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H48a0,0,0,0,1,0,0V180A28,28,0,0,1,76,152Z",
          transform: "translate(152 360) rotate(-180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _me),
        e("rect", {
          x: "104",
          y: "104",
          width: "48",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pme)
      ])) : o(i) === "regular" ? (s(), r("g", yme, [
        e("path", {
          d: "M180,48h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H152a0,0,0,0,1,0,0V76a28,28,0,0,1,28-28Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $me),
        e("path", {
          d: "M48,48H76a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0A28,28,0,0,1,48,76V48A0,0,0,0,1,48,48Z",
          transform: "translate(152 152) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wme),
        e("path", {
          d: "M152,152h28a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28h0a28,28,0,0,1-28-28V152A0,0,0,0,1,152,152Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fme),
        e("path", {
          d: "M76,152h0a28,28,0,0,1,28,28v0a28,28,0,0,1-28,28H48a0,0,0,0,1,0,0V180A28,28,0,0,1,76,152Z",
          transform: "translate(152 360) rotate(-180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gme),
        e("rect", {
          x: "104",
          y: "104",
          width: "48",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xme)
      ])) : g("", !0)
    ], 16, Nje));
  }
}), mme = ["width", "height", "fill", "transform"], Mme = { key: 0 }, vme = ["stroke"], Sme = ["stroke"], Hme = { key: 1 }, Ame = /* @__PURE__ */ e("path", {
  d: "M128,32a96,96,0,1,0,96,96A96,96,0,0,0,128,32Zm17,113L85.6,170.4,111,111l62.1-28.2Z",
  opacity: "0.2"
}, null, -1), Vme = ["stroke"], zme = ["stroke"], Zme = { key: 2 }, Cme = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm52.3,62.1-28,62.2a8.2,8.2,0,0,1-4.2,4L88.7,177.8a8.5,8.5,0,0,1-3.1.6,8.1,8.1,0,0,1-5.7-2.3,8,8,0,0,1-1.7-8.8l25.5-59.4a8.2,8.2,0,0,1,4-4.2l62-28.2a8.1,8.1,0,0,1,9,1.7A7.8,7.8,0,0,1,180.3,86.1Z" }, null, -1), bme = [
  Cme
], Lme = { key: 3 }, Bme = ["stroke"], Pme = ["stroke"], Wme = { key: 4 }, Nme = ["stroke"], Fme = ["stroke"], Tme = { key: 5 }, Dme = ["stroke"], Rme = ["stroke"], Ume = {
  name: "PhCompass"
}, nG1 = /* @__PURE__ */ $({
  ...Ume,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Mme, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vme),
        e("polygon", {
          points: "145 145 167.4 88.5 111 111 88.4 167.6 145 145",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Sme)
      ])) : o(i) === "duotone" ? (s(), r("g", Hme, [
        Ame,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Vme),
        e("polygon", {
          points: "145 145 173.1 82.8 111 111 85.6 170.4 145 145",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zme)
      ])) : o(i) === "fill" ? (s(), r("g", Zme, bme)) : o(i) === "light" ? (s(), r("g", Lme, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bme),
        e("polygon", {
          points: "145 145 173.1 82.8 111 111 85.6 170.4 145 145",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pme)
      ])) : o(i) === "thin" ? (s(), r("g", Wme, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nme),
        e("polygon", {
          points: "145 145 173.1 82.8 111 111 85.6 170.4 145 145",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fme)
      ])) : o(i) === "regular" ? (s(), r("g", Tme, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Dme),
        e("polygon", {
          points: "145 145 173.1 82.8 111 111 85.6 170.4 145 145",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rme)
      ])) : g("", !0)
    ], 16, mme));
  }
}), qme = ["width", "height", "fill", "transform"], Gme = { key: 0 }, Eme = ["stroke"], Ome = ["stroke"], Ime = ["stroke"], Kme = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "184",
  r: "16"
}, null, -1), Xme = { key: 1 }, Jme = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "56",
  width: "192",
  height: "144",
  rx: "8",
  transform: "translate(256 0) rotate(90)",
  opacity: "0.2"
}, null, -1), Qme = ["stroke"], Yme = ["stroke"], oMe = ["stroke"], eMe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "12"
}, null, -1), tMe = { key: 2 }, nMe = /* @__PURE__ */ e("path", { d: "M192,24H64A16,16,0,0,0,48,40V216a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V40A16,16,0,0,0,192,24ZM128,192a12,12,0,1,1,12-12A12,12,0,0,1,128,192Zm32-80H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z" }, null, -1), sMe = [
  nMe
], rMe = { key: 3 }, iMe = ["stroke"], lMe = ["stroke"], dMe = ["stroke"], kMe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "10"
}, null, -1), cMe = { key: 4 }, hMe = ["stroke"], uMe = ["stroke"], aMe = ["stroke"], _Me = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "8"
}, null, -1), pMe = { key: 5 }, yMe = ["stroke"], $Me = ["stroke"], wMe = ["stroke"], fMe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "12"
}, null, -1), gMe = {
  name: "PhComputerTower"
}, sG1 = /* @__PURE__ */ $({
  ...gMe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Gme, [
        e("line", {
          x1: "160",
          y1: "76",
          x2: "96",
          y2: "76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Eme),
        e("line", {
          x1: "160",
          y1: "116",
          x2: "96",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ome),
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ime),
        Kme
      ])) : o(i) === "duotone" ? (s(), r("g", Xme, [
        Jme,
        e("line", {
          x1: "160",
          y1: "72",
          x2: "96",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qme),
        e("line", {
          x1: "160",
          y1: "104",
          x2: "96",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yme),
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oMe),
        eMe
      ])) : o(i) === "fill" ? (s(), r("g", tMe, sMe)) : o(i) === "light" ? (s(), r("g", rMe, [
        e("line", {
          x1: "160",
          y1: "72",
          x2: "96",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iMe),
        e("line", {
          x1: "160",
          y1: "104",
          x2: "96",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lMe),
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dMe),
        kMe
      ])) : o(i) === "thin" ? (s(), r("g", cMe, [
        e("line", {
          x1: "160",
          y1: "72",
          x2: "96",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hMe),
        e("line", {
          x1: "160",
          y1: "104",
          x2: "96",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uMe),
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aMe),
        _Me
      ])) : o(i) === "regular" ? (s(), r("g", pMe, [
        e("line", {
          x1: "160",
          y1: "72",
          x2: "96",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yMe),
        e("line", {
          x1: "160",
          y1: "104",
          x2: "96",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Me),
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          rx: "8",
          transform: "translate(256 0) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wMe),
        fMe
      ])) : g("", !0)
    ], 16, qme));
  }
}), xMe = ["width", "height", "fill", "transform"], jMe = { key: 0 }, mMe = ["stroke"], MMe = ["stroke"], vMe = ["stroke"], SMe = ["stroke"], HMe = ["stroke"], AMe = ["stroke"], VMe = ["stroke"], zMe = { key: 1 }, ZMe = /* @__PURE__ */ e("g", { opacity: "0.2" }, [
  /* @__PURE__ */ e("path", { d: "M102.4,198.4,57.6,153.6,37.9,207.9a7.9,7.9,0,0,0,10.2,10.2Z" })
], -1), CMe = /* @__PURE__ */ e("path", {
  d: "M76.8,100.8l78.4,78.4,41-14.9a8,8,0,0,0,2.9-13.2L104.9,56.9a8,8,0,0,0-13.2,2.9Z",
  opacity: "0.2"
}, null, -1), bMe = ["stroke"], LMe = ["stroke"], BMe = ["stroke"], PMe = ["stroke"], WMe = ["stroke"], NMe = ["stroke"], FMe = ["stroke"], TMe = { key: 2 }, DMe = /* @__PURE__ */ e("path", { d: "M110.5,51.2a15.7,15.7,0,0,0-14.7-4.3A16,16,0,0,0,84.2,57.1L30.3,205.2h0a16.1,16.1,0,0,0,15,21.4,17.1,17.1,0,0,0,5.5-.9l148.1-53.9a16,16,0,0,0,10.2-11.6,15.7,15.7,0,0,0-4.3-14.7ZM63.8,159.8,83,107l66,66L96.2,192.2ZM160,72a38.2,38.2,0,0,1,3.8-15.6C169.1,45.8,179.1,40,192,40c6.7,0,11-2.3,13.7-7.2a22.3,22.3,0,0,0,2.3-8.9,7.9,7.9,0,0,1,8-7.9,8,8,0,0,1,8,8c0,12.9-8.5,32-32,32-6.7,0-11,2.3-13.7,7.2a22.3,22.3,0,0,0-2.3,8.9,7.9,7.9,0,0,1-8,7.9A8,8,0,0,1,160,72ZM136,40V16a8,8,0,0,1,16,0V40a8,8,0,0,1-16,0Zm101.7,82.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0l-16-16a8.1,8.1,0,0,1,11.4-11.4Zm4.8-42.7-24,8a7.3,7.3,0,0,1-2.5.4,8,8,0,0,1-2.5-15.6l24-8a8,8,0,0,1,5,15.2Z" }, null, -1), RMe = [
  DMe
], UMe = { key: 3 }, qMe = ["stroke"], GMe = ["stroke"], EMe = ["stroke"], OMe = ["stroke"], IMe = ["stroke"], KMe = ["stroke"], XMe = ["stroke"], JMe = { key: 4 }, QMe = ["stroke"], YMe = ["stroke"], ove = ["stroke"], eve = ["stroke"], tve = ["stroke"], nve = ["stroke"], sve = ["stroke"], rve = { key: 5 }, ive = ["stroke"], lve = ["stroke"], dve = ["stroke"], kve = ["stroke"], cve = ["stroke"], hve = ["stroke"], uve = ["stroke"], ave = {
  name: "PhConfetti"
}, rG1 = /* @__PURE__ */ $({
  ...ave,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", jMe, [
        e("path", {
          d: "M184.5,168.6,48.1,218.1a7.9,7.9,0,0,1-10.2-10.2L87.4,71.5a8,8,0,0,1,13.2-2.9l86.8,86.8A8,8,0,0,1,184.5,168.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mMe),
        e("path", {
          d: "M164,76s0-24,24-24,24-24,24-24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MMe),
        e("line", {
          x1: "102.4",
          y1: "198.4",
          x2: "57.6",
          y2: "153.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vMe),
        e("line", {
          x1: "136",
          y1: "16",
          x2: "136",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SMe),
        e("line", {
          x1: "216",
          y1: "120",
          x2: "232",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HMe),
        e("line", {
          x1: "216",
          y1: "84",
          x2: "240",
          y2: "76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, AMe),
        e("line", {
          x1: "74.7",
          y1: "106.7",
          x2: "149.3",
          y2: "181.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VMe)
      ])) : o(i) === "duotone" ? (s(), r("g", zMe, [
        ZMe,
        CMe,
        e("path", {
          d: "M37.9,207.9,91.7,59.8a8,8,0,0,1,13.2-2.9l94.2,94.2a8,8,0,0,1-2.9,13.2L48.1,218.1A7.9,7.9,0,0,1,37.9,207.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bMe),
        e("path", {
          d: "M168,72s0-24,24-24,24-24,24-24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LMe),
        e("line", {
          x1: "102.4",
          y1: "198.4",
          x2: "57.6",
          y2: "153.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BMe),
        e("line", {
          x1: "144",
          y1: "16",
          x2: "144",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PMe),
        e("line", {
          x1: "216",
          y1: "112",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WMe),
        e("line", {
          x1: "216",
          y1: "80",
          x2: "240",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NMe),
        e("line", {
          x1: "76.8",
          y1: "100.8",
          x2: "155.2",
          y2: "179.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FMe)
      ])) : o(i) === "fill" ? (s(), r("g", TMe, RMe)) : o(i) === "light" ? (s(), r("g", UMe, [
        e("path", {
          d: "M37.9,207.9,91.7,59.8a8,8,0,0,1,13.2-2.9l94.2,94.2a8,8,0,0,1-2.9,13.2L48.1,218.1A7.9,7.9,0,0,1,37.9,207.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qMe),
        e("path", {
          d: "M168,72s0-24,24-24,24-24,24-24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GMe),
        e("line", {
          x1: "102.4",
          y1: "198.4",
          x2: "57.6",
          y2: "153.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, EMe),
        e("line", {
          x1: "144",
          y1: "16",
          x2: "144",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OMe),
        e("line", {
          x1: "216",
          y1: "112",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IMe),
        e("line", {
          x1: "216",
          y1: "80",
          x2: "240",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KMe),
        e("line", {
          x1: "76.8",
          y1: "100.8",
          x2: "155.2",
          y2: "179.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XMe)
      ])) : o(i) === "thin" ? (s(), r("g", JMe, [
        e("path", {
          d: "M37.9,207.9,91.7,59.8a8,8,0,0,1,13.2-2.9l94.2,94.2a8,8,0,0,1-2.9,13.2L48.1,218.1A7.9,7.9,0,0,1,37.9,207.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QMe),
        e("path", {
          d: "M168,72s0-24,24-24,24-24,24-24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YMe),
        e("line", {
          x1: "102.4",
          y1: "198.4",
          x2: "57.6",
          y2: "153.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ove),
        e("line", {
          x1: "144",
          y1: "16",
          x2: "144",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eve),
        e("line", {
          x1: "216",
          y1: "112",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tve),
        e("line", {
          x1: "216",
          y1: "80",
          x2: "240",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nve),
        e("line", {
          x1: "76.8",
          y1: "100.8",
          x2: "155.2",
          y2: "179.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sve)
      ])) : o(i) === "regular" ? (s(), r("g", rve, [
        e("path", {
          d: "M37.9,207.9,91.7,59.8a8,8,0,0,1,13.2-2.9l94.2,94.2a8,8,0,0,1-2.9,13.2L48.1,218.1A7.9,7.9,0,0,1,37.9,207.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ive),
        e("path", {
          d: "M168,72s0-24,24-24,24-24,24-24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lve),
        e("line", {
          x1: "102.4",
          y1: "198.4",
          x2: "57.6",
          y2: "153.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dve),
        e("line", {
          x1: "144",
          y1: "16",
          x2: "144",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kve),
        e("line", {
          x1: "216",
          y1: "112",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cve),
        e("line", {
          x1: "216",
          y1: "80",
          x2: "240",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hve),
        e("line", {
          x1: "76.8",
          y1: "100.8",
          x2: "155.2",
          y2: "179.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uve)
      ])) : g("", !0)
    ], 16, xMe));
  }
}), _ve = ["width", "height", "fill", "transform"], pve = { key: 0 }, yve = ["stroke"], $ve = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "172",
  r: "16"
}, null, -1), wve = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "164",
  r: "16"
}, null, -1), fve = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "108",
  r: "16"
}, null, -1), gve = /* @__PURE__ */ e("circle", {
  cx: "136",
  cy: "124",
  r: "16"
}, null, -1), xve = { key: 1 }, jve = /* @__PURE__ */ e("path", {
  d: "M224,127.4a95.6,95.6,0,0,1-28.2,68.5c-36.9,36.9-97.3,37.3-134.7.9A96,96,0,0,1,128.6,32a8.1,8.1,0,0,1,7.8,9.8,32,32,0,0,0,30.8,39,8,8,0,0,1,8,8,32,32,0,0,0,39,30.8A8.1,8.1,0,0,1,224,127.4Z",
  opacity: "0.2"
}, null, -1), mve = ["stroke"], Mve = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "172",
  r: "12"
}, null, -1), vve = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "164",
  r: "12"
}, null, -1), Sve = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "108",
  r: "12"
}, null, -1), Hve = /* @__PURE__ */ e("circle", {
  cx: "136",
  cy: "124",
  r: "12"
}, null, -1), Ave = { key: 2 }, Vve = /* @__PURE__ */ e("path", { d: "M225.9,114.9a15.8,15.8,0,0,0-13.4-3.1,23.9,23.9,0,0,1-29.3-23.1,16,16,0,0,0-15.9-15.9,23.9,23.9,0,0,1-23.1-29.3A16.1,16.1,0,0,0,128.6,24H128A104.1,104.1,0,0,0,24,128.7a104,104,0,0,0,208-1.3h0A15.7,15.7,0,0,0,225.9,114.9ZM75.5,99.5a12,12,0,1,1,0,17A12,12,0,0,1,75.5,99.5Zm25,73a12,12,0,1,1,0-17A12,12,0,0,1,100.5,172.5Zm27-40a12,12,0,1,1,17,0A12,12,0,0,1,127.5,132.5Zm37,48a12,12,0,1,1,0-17A12,12,0,0,1,164.5,180.5Z" }, null, -1), zve = [
  Vve
], Zve = { key: 3 }, Cve = ["stroke"], bve = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "172",
  r: "10"
}, null, -1), Lve = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "164",
  r: "10"
}, null, -1), Bve = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "108",
  r: "10"
}, null, -1), Pve = /* @__PURE__ */ e("circle", {
  cx: "136",
  cy: "124",
  r: "10"
}, null, -1), Wve = { key: 4 }, Nve = ["stroke"], Fve = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "172",
  r: "8"
}, null, -1), Tve = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "164",
  r: "8"
}, null, -1), Dve = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "108",
  r: "8"
}, null, -1), Rve = /* @__PURE__ */ e("circle", {
  cx: "136",
  cy: "124",
  r: "8"
}, null, -1), Uve = { key: 5 }, qve = ["stroke"], Gve = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "172",
  r: "12"
}, null, -1), Eve = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "164",
  r: "12"
}, null, -1), Ove = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "108",
  r: "12"
}, null, -1), Ive = /* @__PURE__ */ e("circle", {
  cx: "136",
  cy: "124",
  r: "12"
}, null, -1), Kve = {
  name: "PhCookie"
}, iG1 = /* @__PURE__ */ $({
  ...Kve,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", pve, [
        e("path", {
          d: "M224,127.4a95.6,95.6,0,0,1-28.2,68.5c-36.9,36.9-97.3,37.3-134.7.9A96,96,0,0,1,128.6,32a8.1,8.1,0,0,1,7.8,9.8,32,32,0,0,0,30.8,39,8,8,0,0,1,8,8,32,32,0,0,0,39,30.8A8.1,8.1,0,0,1,224,127.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yve),
        $ve,
        wve,
        fve,
        gve
      ])) : o(i) === "duotone" ? (s(), r("g", xve, [
        jve,
        e("path", {
          d: "M224,127.4a95.6,95.6,0,0,1-28.2,68.5c-36.9,36.9-97.3,37.3-134.7.9A96,96,0,0,1,128.6,32a8.1,8.1,0,0,1,7.8,9.8,32,32,0,0,0,30.8,39,8,8,0,0,1,8,8,32,32,0,0,0,39,30.8A8.1,8.1,0,0,1,224,127.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mve),
        Mve,
        vve,
        Sve,
        Hve
      ])) : o(i) === "fill" ? (s(), r("g", Ave, zve)) : o(i) === "light" ? (s(), r("g", Zve, [
        e("path", {
          d: "M224,127.4a95.6,95.6,0,0,1-28.2,68.5c-36.9,36.9-97.3,37.3-134.7.9A96,96,0,0,1,128.6,32a8.1,8.1,0,0,1,7.8,9.8,32,32,0,0,0,30.8,39,8,8,0,0,1,8,8,32,32,0,0,0,39,30.8A8.1,8.1,0,0,1,224,127.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cve),
        bve,
        Lve,
        Bve,
        Pve
      ])) : o(i) === "thin" ? (s(), r("g", Wve, [
        e("path", {
          d: "M224,127.4a95.6,95.6,0,0,1-28.2,68.5c-36.9,36.9-97.3,37.3-134.7.9A96,96,0,0,1,128.6,32a8.1,8.1,0,0,1,7.8,9.8,32,32,0,0,0,30.8,39,8,8,0,0,1,8,8,32,32,0,0,0,39,30.8A8.1,8.1,0,0,1,224,127.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nve),
        Fve,
        Tve,
        Dve,
        Rve
      ])) : o(i) === "regular" ? (s(), r("g", Uve, [
        e("path", {
          d: "M224,127.4a95.6,95.6,0,0,1-28.2,68.5c-36.9,36.9-97.3,37.3-134.7.9A96,96,0,0,1,128.6,32a8.1,8.1,0,0,1,7.8,9.8,32,32,0,0,0,30.8,39,8,8,0,0,1,8,8,32,32,0,0,0,39,30.8A8.1,8.1,0,0,1,224,127.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qve),
        Gve,
        Eve,
        Ove,
        Ive
      ])) : g("", !0)
    ], 16, _ve));
  }
}), Xve = ["width", "height", "fill", "transform"], Jve = { key: 0 }, Qve = ["stroke"], Yve = ["stroke"], oSe = ["stroke"], eSe = ["stroke"], tSe = ["stroke"], nSe = ["stroke"], sSe = { key: 1 }, rSe = /* @__PURE__ */ e("path", {
  d: "M48,80H208a8,8,0,0,1,8,8v96a23.9,23.9,0,0,1-24,24H64a23.9,23.9,0,0,1-24-24V88A8,8,0,0,1,48,80Z",
  opacity: "0.2"
}, null, -1), iSe = ["stroke"], lSe = ["stroke"], dSe = ["stroke"], kSe = ["stroke"], cSe = ["stroke"], hSe = ["stroke"], uSe = { key: 2 }, aSe = /* @__PURE__ */ e("path", { d: "M88,48V16a8,8,0,0,1,16,0V48a8,8,0,0,1-16,0Zm40,8a8,8,0,0,0,8-8V16a8,8,0,0,0-16,0V48A8,8,0,0,0,128,56Zm32,0a8,8,0,0,0,8-8V16a8,8,0,0,0-16,0V48A8,8,0,0,0,160,56Zm94.4,35.2a8,8,0,0,0-11.2-1.6L224,104V88a16,16,0,0,0-16-16H48A16,16,0,0,0,32,88v16L12.8,89.6a8,8,0,0,0-9.6,12.8L32,124v60a32.1,32.1,0,0,0,32,32H192a32.1,32.1,0,0,0,32-32V124l28.8-21.6A8,8,0,0,0,254.4,91.2Z" }, null, -1), _Se = [
  aSe
], pSe = { key: 3 }, ySe = ["stroke"], $Se = ["stroke"], wSe = ["stroke"], fSe = ["stroke"], gSe = ["stroke"], xSe = ["stroke"], jSe = { key: 4 }, mSe = ["stroke"], MSe = ["stroke"], vSe = ["stroke"], SSe = ["stroke"], HSe = ["stroke"], ASe = ["stroke"], VSe = { key: 5 }, zSe = ["stroke"], ZSe = ["stroke"], CSe = ["stroke"], bSe = ["stroke"], LSe = ["stroke"], BSe = ["stroke"], PSe = {
  name: "PhCookingPot"
}, lG1 = /* @__PURE__ */ $({
  ...PSe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Jve, [
        e("line", {
          x1: "88",
          y1: "16",
          x2: "88",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qve),
        e("line", {
          x1: "128",
          y1: "16",
          x2: "128",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Yve),
        e("line", {
          x1: "168",
          y1: "16",
          x2: "168",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oSe),
        e("path", {
          d: "M52,80H204a8,8,0,0,1,8,8v96a23.9,23.9,0,0,1-24,24H68a23.9,23.9,0,0,1-24-24V88A8,8,0,0,1,52,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eSe),
        e("line", {
          x1: "244",
          y1: "96",
          x2: "212",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tSe),
        e("line", {
          x1: "12",
          y1: "96",
          x2: "44",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nSe)
      ])) : o(i) === "duotone" ? (s(), r("g", sSe, [
        rSe,
        e("line", {
          x1: "96",
          y1: "16",
          x2: "96",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iSe),
        e("line", {
          x1: "128",
          y1: "16",
          x2: "128",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lSe),
        e("line", {
          x1: "160",
          y1: "16",
          x2: "160",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dSe),
        e("path", {
          d: "M48,80H208a8,8,0,0,1,8,8v96a23.9,23.9,0,0,1-24,24H64a23.9,23.9,0,0,1-24-24V88A8,8,0,0,1,48,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kSe),
        e("line", {
          x1: "248",
          y1: "96",
          x2: "216",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cSe),
        e("line", {
          x1: "8",
          y1: "96",
          x2: "40",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hSe)
      ])) : o(i) === "fill" ? (s(), r("g", uSe, _Se)) : o(i) === "light" ? (s(), r("g", pSe, [
        e("line", {
          x1: "96",
          y1: "16",
          x2: "96",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ySe),
        e("line", {
          x1: "128",
          y1: "16",
          x2: "128",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $Se),
        e("line", {
          x1: "160",
          y1: "16",
          x2: "160",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wSe),
        e("path", {
          d: "M48,80H208a8,8,0,0,1,8,8v96a23.9,23.9,0,0,1-24,24H64a23.9,23.9,0,0,1-24-24V88A8,8,0,0,1,48,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fSe),
        e("line", {
          x1: "248",
          y1: "96",
          x2: "216",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gSe),
        e("line", {
          x1: "8",
          y1: "96",
          x2: "40",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xSe)
      ])) : o(i) === "thin" ? (s(), r("g", jSe, [
        e("line", {
          x1: "96",
          y1: "16",
          x2: "96",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mSe),
        e("line", {
          x1: "128",
          y1: "16",
          x2: "128",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MSe),
        e("line", {
          x1: "160",
          y1: "16",
          x2: "160",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vSe),
        e("path", {
          d: "M48,80H208a8,8,0,0,1,8,8v96a23.9,23.9,0,0,1-24,24H64a23.9,23.9,0,0,1-24-24V88A8,8,0,0,1,48,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SSe),
        e("line", {
          x1: "248",
          y1: "96",
          x2: "216",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HSe),
        e("line", {
          x1: "8",
          y1: "96",
          x2: "40",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ASe)
      ])) : o(i) === "regular" ? (s(), r("g", VSe, [
        e("line", {
          x1: "96",
          y1: "16",
          x2: "96",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zSe),
        e("line", {
          x1: "128",
          y1: "16",
          x2: "128",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZSe),
        e("line", {
          x1: "160",
          y1: "16",
          x2: "160",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CSe),
        e("path", {
          d: "M48,80H208a8,8,0,0,1,8,8v96a23.9,23.9,0,0,1-24,24H64a23.9,23.9,0,0,1-24-24V88A8,8,0,0,1,48,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bSe),
        e("line", {
          x1: "248",
          y1: "96",
          x2: "216",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LSe),
        e("line", {
          x1: "8",
          y1: "96",
          x2: "40",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BSe)
      ])) : g("", !0)
    ], 16, Xve));
  }
}), WSe = ["width", "height", "fill", "transform"], NSe = { key: 0 }, FSe = ["stroke"], TSe = ["stroke"], DSe = { key: 1 }, RSe = /* @__PURE__ */ e("polygon", {
  points: "168 88 168 168 216 168 216 40 88 40 88 88 168 88",
  opacity: "0.2"
}, null, -1), USe = ["stroke"], qSe = ["stroke"], GSe = { key: 2 }, ESe = /* @__PURE__ */ e("path", { d: "M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32Zm-8,128H176V88a8,8,0,0,0-8-8H96V48H208Z" }, null, -1), OSe = [
  ESe
], ISe = { key: 3 }, KSe = ["stroke"], XSe = ["stroke"], JSe = { key: 4 }, QSe = ["stroke"], YSe = ["stroke"], oHe = { key: 5 }, eHe = ["stroke"], tHe = ["stroke"], nHe = {
  name: "PhCopy"
}, dG1 = /* @__PURE__ */ $({
  ...nHe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", NSe, [
        e("polyline", {
          points: "168 168 216 168 216 40 88 40 88 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FSe),
        e("rect", {
          x: "40",
          y: "88",
          width: "128",
          height: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TSe)
      ])) : o(i) === "duotone" ? (s(), r("g", DSe, [
        RSe,
        e("polyline", {
          points: "168 168 216 168 216 40 88 40 88 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, USe),
        e("rect", {
          x: "40",
          y: "88",
          width: "128",
          height: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qSe)
      ])) : o(i) === "fill" ? (s(), r("g", GSe, OSe)) : o(i) === "light" ? (s(), r("g", ISe, [
        e("polyline", {
          points: "168 168 216 168 216 40 88 40 88 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KSe),
        e("rect", {
          x: "40",
          y: "88",
          width: "128",
          height: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XSe)
      ])) : o(i) === "thin" ? (s(), r("g", JSe, [
        e("polyline", {
          points: "168 168 216 168 216 40 88 40 88 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QSe),
        e("rect", {
          x: "40",
          y: "88",
          width: "128",
          height: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YSe)
      ])) : o(i) === "regular" ? (s(), r("g", oHe, [
        e("polyline", {
          points: "168 168 216 168 216 40 88 40 88 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eHe),
        e("rect", {
          x: "40",
          y: "88",
          width: "128",
          height: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tHe)
      ])) : g("", !0)
    ], 16, WSe));
  }
}), sHe = ["width", "height", "fill", "transform"], rHe = { key: 0 }, iHe = ["stroke"], lHe = ["stroke"], dHe = { key: 1 }, kHe = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "72",
  width: "144",
  height: "144",
  opacity: "0.2"
}, null, -1), cHe = ["stroke"], hHe = ["stroke"], uHe = { key: 2 }, aHe = /* @__PURE__ */ e("path", { d: "M216,32H72a8,8,0,0,0,0,16H208V184a8,8,0,0,0,16,0V40A8,8,0,0,0,216,32Z" }, null, -1), _He = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "64",
  width: "160",
  height: "160",
  rx: "8"
}, null, -1), pHe = [
  aHe,
  _He
], yHe = { key: 3 }, $He = ["stroke"], wHe = ["stroke"], fHe = { key: 4 }, gHe = ["stroke"], xHe = ["stroke"], jHe = { key: 5 }, mHe = ["stroke"], MHe = ["stroke"], vHe = {
  name: "PhCopySimple"
}, kG1 = /* @__PURE__ */ $({
  ...vHe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", rHe, [
        e("polyline", {
          points: "220 176 220 36 80 36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iHe),
        e("rect", {
          x: "40",
          y: "76",
          width: "140",
          height: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lHe)
      ])) : o(i) === "duotone" ? (s(), r("g", dHe, [
        kHe,
        e("polyline", {
          points: "216 184 216 40 72 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cHe),
        e("rect", {
          x: "40",
          y: "72",
          width: "144",
          height: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hHe)
      ])) : o(i) === "fill" ? (s(), r("g", uHe, pHe)) : o(i) === "light" ? (s(), r("g", yHe, [
        e("polyline", {
          points: "216 184 216 40 72 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $He),
        e("rect", {
          x: "40",
          y: "72",
          width: "144",
          height: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wHe)
      ])) : o(i) === "thin" ? (s(), r("g", fHe, [
        e("polyline", {
          points: "216 184 216 40 72 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gHe),
        e("rect", {
          x: "40",
          y: "72",
          width: "144",
          height: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xHe)
      ])) : o(i) === "regular" ? (s(), r("g", jHe, [
        e("polyline", {
          points: "216 184 216 40 72 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mHe),
        e("rect", {
          x: "40",
          y: "72",
          width: "144",
          height: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MHe)
      ])) : g("", !0)
    ], 16, sHe));
  }
}), SHe = ["width", "height", "fill", "transform"], HHe = { key: 0 }, AHe = ["stroke"], VHe = ["stroke"], zHe = { key: 1 }, ZHe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), CHe = ["stroke"], bHe = ["stroke"], LHe = { key: 2 }, BHe = /* @__PURE__ */ e("path", { d: "M128,56a72,72,0,1,0,72,72A72.1,72.1,0,0,0,128,56Zm0,120a47.7,47.7,0,0,1-38.4-19.2,8,8,0,1,1,12.8-9.6,32,32,0,1,0,0-38.4,8.1,8.1,0,0,1-11.2,1.6,8,8,0,0,1-1.6-11.2A48,48,0,1,1,128,176Zm0-156A108,108,0,1,0,236,128,108.1,108.1,0,0,0,128,20Zm0,196a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z" }, null, -1), PHe = [
  BHe
], WHe = { key: 3 }, NHe = ["stroke"], FHe = ["stroke"], THe = { key: 4 }, DHe = ["stroke"], RHe = ["stroke"], UHe = { key: 5 }, qHe = ["stroke"], GHe = ["stroke"], EHe = {
  name: "PhCopyleft"
}, cG1 = /* @__PURE__ */ $({
  ...EHe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", HHe, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, AHe),
        e("path", {
          d: "M96,104a40,40,0,1,1,0,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VHe)
      ])) : o(i) === "duotone" ? (s(), r("g", zHe, [
        ZHe,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CHe),
        e("path", {
          d: "M96,104a40,40,0,1,1,0,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bHe)
      ])) : o(i) === "fill" ? (s(), r("g", LHe, PHe)) : o(i) === "light" ? (s(), r("g", WHe, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, NHe),
        e("path", {
          d: "M96,104a40,40,0,1,1,0,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FHe)
      ])) : o(i) === "thin" ? (s(), r("g", THe, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, DHe),
        e("path", {
          d: "M96,104a40,40,0,1,1,0,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RHe)
      ])) : o(i) === "regular" ? (s(), r("g", UHe, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qHe),
        e("path", {
          d: "M96,104a40,40,0,1,1,0,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GHe)
      ])) : g("", !0)
    ], 16, SHe));
  }
}), OHe = ["width", "height", "fill", "transform"], IHe = { key: 0 }, KHe = ["stroke"], XHe = ["stroke"], JHe = { key: 1 }, QHe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), YHe = ["stroke"], oAe = ["stroke"], eAe = { key: 2 }, tAe = /* @__PURE__ */ e("path", { d: "M128,20A108,108,0,1,0,236,128,108.1,108.1,0,0,0,128,20Zm0,196a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm0-160a72,72,0,1,0,72,72A72.1,72.1,0,0,0,128,56Zm0,104a31.8,31.8,0,0,0,25.6-12.8,8.1,8.1,0,0,1,11.2-1.6,8,8,0,0,1,1.6,11.2,48,48,0,1,1,0-57.6,8,8,0,0,1-1.6,11.2,8.1,8.1,0,0,1-11.2-1.6A32,32,0,1,0,128,160Z" }, null, -1), nAe = [
  tAe
], sAe = { key: 3 }, rAe = ["stroke"], iAe = ["stroke"], lAe = { key: 4 }, dAe = ["stroke"], kAe = ["stroke"], cAe = { key: 5 }, hAe = ["stroke"], uAe = ["stroke"], aAe = {
  name: "PhCopyright"
}, hG1 = /* @__PURE__ */ $({
  ...aAe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", IHe, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KHe),
        e("path", {
          d: "M160,152a40,40,0,1,1,0-48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XHe)
      ])) : o(i) === "duotone" ? (s(), r("g", JHe, [
        QHe,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YHe),
        e("path", {
          d: "M160,152a40,40,0,1,1,0-48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oAe)
      ])) : o(i) === "fill" ? (s(), r("g", eAe, nAe)) : o(i) === "light" ? (s(), r("g", sAe, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rAe),
        e("path", {
          d: "M160,152a40,40,0,1,1,0-48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iAe)
      ])) : o(i) === "thin" ? (s(), r("g", lAe, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dAe),
        e("path", {
          d: "M160,152a40,40,0,1,1,0-48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kAe)
      ])) : o(i) === "regular" ? (s(), r("g", cAe, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hAe),
        e("path", {
          d: "M160,152a40,40,0,1,1,0-48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uAe)
      ])) : g("", !0)
    ], 16, OHe));
  }
}), _Ae = ["width", "height", "fill", "transform"], pAe = { key: 0 }, yAe = ["stroke"], $Ae = ["stroke"], wAe = ["stroke"], fAe = ["stroke"], gAe = { key: 1 }, xAe = ["stroke"], jAe = ["stroke"], mAe = ["stroke"], MAe = ["stroke"], vAe = { key: 2 }, SAe = /* @__PURE__ */ e("path", { d: "M152,96V48a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l48,48a8.4,8.4,0,0,1,1.7,8.8A8,8,0,0,1,208,104H160A8,8,0,0,1,152,96ZM96,152H48a8,8,0,0,0-7.4,4.9,8.4,8.4,0,0,0,1.7,8.8l48,48A8.3,8.3,0,0,0,96,216a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,104,208V160A8,8,0,0,0,96,152ZM99.1,40.6a8.4,8.4,0,0,0-8.8,1.7l-48,48a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,48,104H96a8,8,0,0,0,8-8V48A8,8,0,0,0,99.1,40.6ZM208,152H160a8,8,0,0,0-8,8v48a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l48-48a8.4,8.4,0,0,0,1.7-8.8A8,8,0,0,0,208,152Z" }, null, -1), HAe = [
  SAe
], AAe = { key: 3 }, VAe = ["stroke"], zAe = ["stroke"], ZAe = ["stroke"], CAe = ["stroke"], bAe = { key: 4 }, LAe = ["stroke"], BAe = ["stroke"], PAe = ["stroke"], WAe = ["stroke"], NAe = { key: 5 }, FAe = ["stroke"], TAe = ["stroke"], DAe = ["stroke"], RAe = ["stroke"], UAe = {
  name: "PhCornersIn"
}, uG1 = /* @__PURE__ */ $({
  ...UAe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", pAe, [
        e("polyline", {
          points: "208 96 160 96 160 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yAe),
        e("polyline", {
          points: "48 160 96 160 96 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $Ae),
        e("polyline", {
          points: "160 208 160 160 208 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wAe),
        e("polyline", {
          points: "96 48 96 96 48 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fAe)
      ])) : o(i) === "duotone" ? (s(), r("g", gAe, [
        e("polyline", {
          points: "208 96 160 96 160 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xAe),
        e("polyline", {
          points: "48 160 96 160 96 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jAe),
        e("polyline", {
          points: "160 208 160 160 208 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mAe),
        e("polyline", {
          points: "96 48 96 96 48 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MAe)
      ])) : o(i) === "fill" ? (s(), r("g", vAe, HAe)) : o(i) === "light" ? (s(), r("g", AAe, [
        e("polyline", {
          points: "208 96 160 96 160 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VAe),
        e("polyline", {
          points: "48 160 96 160 96 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zAe),
        e("polyline", {
          points: "160 208 160 160 208 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZAe),
        e("polyline", {
          points: "96 48 96 96 48 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, CAe)
      ])) : o(i) === "thin" ? (s(), r("g", bAe, [
        e("polyline", {
          points: "208 96 160 96 160 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LAe),
        e("polyline", {
          points: "48 160 96 160 96 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, BAe),
        e("polyline", {
          points: "160 208 160 160 208 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PAe),
        e("polyline", {
          points: "96 48 96 96 48 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WAe)
      ])) : o(i) === "regular" ? (s(), r("g", NAe, [
        e("polyline", {
          points: "208 96 160 96 160 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FAe),
        e("polyline", {
          points: "48 160 96 160 96 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TAe),
        e("polyline", {
          points: "160 208 160 160 208 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DAe),
        e("polyline", {
          points: "96 48 96 96 48 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RAe)
      ])) : g("", !0)
    ], 16, _Ae));
  }
}), qAe = ["width", "height", "fill", "transform"], GAe = { key: 0 }, EAe = ["stroke"], OAe = ["stroke"], IAe = ["stroke"], KAe = ["stroke"], XAe = { key: 1 }, JAe = ["stroke"], QAe = ["stroke"], YAe = ["stroke"], oVe = ["stroke"], eVe = { key: 2 }, tVe = /* @__PURE__ */ e("path", { d: "M216,48V88a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-40-40a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,168,40h40A8,8,0,0,1,216,48ZM53.7,162.3a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,40,168v40a8,8,0,0,0,8,8H88a8,8,0,0,0,7.4-4.9,8.4,8.4,0,0,0-1.7-8.8Zm157.4-1.7a8.4,8.4,0,0,0-8.8,1.7l-40,40a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,168,216h40a8,8,0,0,0,8-8V168A8,8,0,0,0,211.1,160.6ZM88,40H48a8,8,0,0,0-8,8V88a8,8,0,0,0,4.9,7.4A8.5,8.5,0,0,0,48,96a8.3,8.3,0,0,0,5.7-2.3l40-40a8.4,8.4,0,0,0,1.7-8.8A8,8,0,0,0,88,40Z" }, null, -1), nVe = [
  tVe
], sVe = { key: 3 }, rVe = ["stroke"], iVe = ["stroke"], lVe = ["stroke"], dVe = ["stroke"], kVe = { key: 4 }, cVe = ["stroke"], hVe = ["stroke"], uVe = ["stroke"], aVe = ["stroke"], _Ve = { key: 5 }, pVe = ["stroke"], yVe = ["stroke"], $Ve = ["stroke"], wVe = ["stroke"], fVe = {
  name: "PhCornersOut"
}, aG1 = /* @__PURE__ */ $({
  ...fVe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", GAe, [
        e("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, EAe),
        e("polyline", {
          points: "88 208 48 208 48 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OAe),
        e("polyline", {
          points: "208 168 208 208 168 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IAe),
        e("polyline", {
          points: "48 88 48 48 88 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KAe)
      ])) : o(i) === "duotone" ? (s(), r("g", XAe, [
        e("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JAe),
        e("polyline", {
          points: "88 208 48 208 48 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QAe),
        e("polyline", {
          points: "208 168 208 208 168 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YAe),
        e("polyline", {
          points: "48 88 48 48 88 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oVe)
      ])) : o(i) === "fill" ? (s(), r("g", eVe, nVe)) : o(i) === "light" ? (s(), r("g", sVe, [
        e("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rVe),
        e("polyline", {
          points: "88 208 48 208 48 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iVe),
        e("polyline", {
          points: "208 168 208 208 168 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lVe),
        e("polyline", {
          points: "48 88 48 48 88 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dVe)
      ])) : o(i) === "thin" ? (s(), r("g", kVe, [
        e("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cVe),
        e("polyline", {
          points: "88 208 48 208 48 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hVe),
        e("polyline", {
          points: "208 168 208 208 168 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uVe),
        e("polyline", {
          points: "48 88 48 48 88 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aVe)
      ])) : o(i) === "regular" ? (s(), r("g", _Ve, [
        e("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pVe),
        e("polyline", {
          points: "88 208 48 208 48 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yVe),
        e("polyline", {
          points: "208 168 208 208 168 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Ve),
        e("polyline", {
          points: "48 88 48 48 88 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wVe)
      ])) : g("", !0)
    ], 16, qAe));
  }
}), gVe = ["width", "height", "fill", "transform"], xVe = { key: 0 }, jVe = ["stroke"], mVe = ["stroke"], MVe = ["stroke"], vVe = ["stroke"], SVe = ["stroke"], HVe = ["stroke"], AVe = ["stroke"], VVe = ["stroke"], zVe = ["stroke"], ZVe = ["stroke"], CVe = { key: 1 }, bVe = /* @__PURE__ */ e("path", {
  d: "M200,48H56a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V56A8,8,0,0,0,200,48ZM156,156H100V100h56Z",
  opacity: "0.2"
}, null, -1), LVe = ["stroke"], BVe = ["stroke"], PVe = ["stroke"], WVe = ["stroke"], NVe = ["stroke"], FVe = ["stroke"], TVe = ["stroke"], DVe = ["stroke"], RVe = ["stroke"], UVe = ["stroke"], qVe = { key: 2 }, GVe = /* @__PURE__ */ e("path", { d: "M232,144H216V112h16a8,8,0,0,0,0-16H216V56a16,16,0,0,0-16-16H160V24a8,8,0,0,0-16,0V40H112V24a8,8,0,0,0-16,0V40H56A16,16,0,0,0,40,56V96H24a8,8,0,0,0,0,16H40v32H24a8,8,0,0,0,0,16H40v40a16,16,0,0,0,16,16H96v16a8,8,0,0,0,16,0V216h32v16a8,8,0,0,0,16,0V216h40a16,16,0,0,0,16-16V160h16a8,8,0,0,0,0-16Zm-68,12a8,8,0,0,1-8,8H100a8,8,0,0,1-8-8V100a8,8,0,0,1,8-8h56a8,8,0,0,1,8,8Zm-56-48h40v40H108Z" }, null, -1), EVe = [
  GVe
], OVe = { key: 3 }, IVe = ["stroke"], KVe = ["stroke"], XVe = ["stroke"], JVe = ["stroke"], QVe = ["stroke"], YVe = ["stroke"], oze = ["stroke"], eze = ["stroke"], tze = ["stroke"], nze = ["stroke"], sze = { key: 4 }, rze = ["stroke"], ize = ["stroke"], lze = ["stroke"], dze = ["stroke"], kze = ["stroke"], cze = ["stroke"], hze = ["stroke"], uze = ["stroke"], aze = ["stroke"], _ze = ["stroke"], pze = { key: 5 }, yze = ["stroke"], $ze = ["stroke"], wze = ["stroke"], fze = ["stroke"], gze = ["stroke"], xze = ["stroke"], jze = ["stroke"], mze = ["stroke"], Mze = ["stroke"], vze = ["stroke"], Sze = {
  name: "PhCpu"
}, _G1 = /* @__PURE__ */ $({
  ...Sze,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xVe, [
        e("rect", {
          x: "100",
          y: "100",
          width: "56",
          height: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jVe),
        e("rect", {
          x: "48",
          y: "48",
          width: "160",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mVe),
        e("line", {
          x1: "208",
          y1: "104",
          x2: "232",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MVe),
        e("line", {
          x1: "208",
          y1: "152",
          x2: "232",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vVe),
        e("line", {
          x1: "24",
          y1: "104",
          x2: "48",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SVe),
        e("line", {
          x1: "24",
          y1: "152",
          x2: "48",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HVe),
        e("line", {
          x1: "152",
          y1: "208",
          x2: "152",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, AVe),
        e("line", {
          x1: "104",
          y1: "208",
          x2: "104",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VVe),
        e("line", {
          x1: "152",
          y1: "24",
          x2: "152",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zVe),
        e("line", {
          x1: "104",
          y1: "24",
          x2: "104",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZVe)
      ])) : o(i) === "duotone" ? (s(), r("g", CVe, [
        bVe,
        e("rect", {
          x: "100",
          y: "100",
          width: "56",
          height: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LVe),
        e("rect", {
          x: "48",
          y: "48",
          width: "160",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BVe),
        e("line", {
          x1: "208",
          y1: "104",
          x2: "232",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PVe),
        e("line", {
          x1: "208",
          y1: "152",
          x2: "232",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WVe),
        e("line", {
          x1: "24",
          y1: "104",
          x2: "48",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NVe),
        e("line", {
          x1: "24",
          y1: "152",
          x2: "48",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FVe),
        e("line", {
          x1: "152",
          y1: "208",
          x2: "152",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TVe),
        e("line", {
          x1: "104",
          y1: "208",
          x2: "104",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DVe),
        e("line", {
          x1: "152",
          y1: "24",
          x2: "152",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RVe),
        e("line", {
          x1: "104",
          y1: "24",
          x2: "104",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UVe)
      ])) : o(i) === "fill" ? (s(), r("g", qVe, EVe)) : o(i) === "light" ? (s(), r("g", OVe, [
        e("rect", {
          x: "100",
          y: "100",
          width: "56",
          height: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IVe),
        e("rect", {
          x: "48",
          y: "48",
          width: "160",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KVe),
        e("line", {
          x1: "208",
          y1: "104",
          x2: "232",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XVe),
        e("line", {
          x1: "208",
          y1: "152",
          x2: "232",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JVe),
        e("line", {
          x1: "24",
          y1: "104",
          x2: "48",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QVe),
        e("line", {
          x1: "24",
          y1: "152",
          x2: "48",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YVe),
        e("line", {
          x1: "152",
          y1: "208",
          x2: "152",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oze),
        e("line", {
          x1: "104",
          y1: "208",
          x2: "104",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eze),
        e("line", {
          x1: "152",
          y1: "24",
          x2: "152",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tze),
        e("line", {
          x1: "104",
          y1: "24",
          x2: "104",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nze)
      ])) : o(i) === "thin" ? (s(), r("g", sze, [
        e("rect", {
          x: "100",
          y: "100",
          width: "56",
          height: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rze),
        e("rect", {
          x: "48",
          y: "48",
          width: "160",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ize),
        e("line", {
          x1: "208",
          y1: "104",
          x2: "232",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lze),
        e("line", {
          x1: "208",
          y1: "152",
          x2: "232",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dze),
        e("line", {
          x1: "24",
          y1: "104",
          x2: "48",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kze),
        e("line", {
          x1: "24",
          y1: "152",
          x2: "48",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cze),
        e("line", {
          x1: "152",
          y1: "208",
          x2: "152",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hze),
        e("line", {
          x1: "104",
          y1: "208",
          x2: "104",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uze),
        e("line", {
          x1: "152",
          y1: "24",
          x2: "152",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aze),
        e("line", {
          x1: "104",
          y1: "24",
          x2: "104",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _ze)
      ])) : o(i) === "regular" ? (s(), r("g", pze, [
        e("rect", {
          x: "100",
          y: "100",
          width: "56",
          height: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yze),
        e("rect", {
          x: "48",
          y: "48",
          width: "160",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $ze),
        e("line", {
          x1: "208",
          y1: "104",
          x2: "232",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wze),
        e("line", {
          x1: "208",
          y1: "152",
          x2: "232",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fze),
        e("line", {
          x1: "24",
          y1: "104",
          x2: "48",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gze),
        e("line", {
          x1: "24",
          y1: "152",
          x2: "48",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xze),
        e("line", {
          x1: "152",
          y1: "208",
          x2: "152",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jze),
        e("line", {
          x1: "104",
          y1: "208",
          x2: "104",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mze),
        e("line", {
          x1: "152",
          y1: "24",
          x2: "152",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mze),
        e("line", {
          x1: "104",
          y1: "24",
          x2: "104",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vze)
      ])) : g("", !0)
    ], 16, gVe));
  }
}), Hze = ["width", "height", "fill", "transform"], Aze = { key: 0 }, Vze = ["stroke"], zze = ["stroke"], Zze = ["stroke"], Cze = ["stroke"], bze = { key: 1 }, Lze = /* @__PURE__ */ e("path", {
  d: "M24,96.9H232V192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8Z",
  opacity: "0.2"
}, null, -1), Bze = ["stroke"], Pze = ["stroke"], Wze = ["stroke"], Nze = ["stroke"], Fze = { key: 2 }, Tze = /* @__PURE__ */ e("path", { d: "M224,48H32A16,16,0,0,0,16,64V96.9h0v95a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48ZM136,176H120a8,8,0,0,1,0-16h16a8,8,0,0,1,0,16Zm64,0H168a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM32,88.9V64H224V88.9Z" }, null, -1), Dze = [
  Tze
], Rze = { key: 3 }, Uze = ["stroke"], qze = ["stroke"], Gze = ["stroke"], Eze = ["stroke"], Oze = { key: 4 }, Ize = ["stroke"], Kze = ["stroke"], Xze = ["stroke"], Jze = ["stroke"], Qze = { key: 5 }, Yze = ["stroke"], oZe = ["stroke"], eZe = ["stroke"], tZe = ["stroke"], nZe = {
  name: "PhCreditCard"
}, pG1 = /* @__PURE__ */ $({
  ...nZe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Aze, [
        e("rect", {
          x: "24",
          y: "56",
          width: "208",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vze),
        e("line", {
          x1: "164",
          y1: "164",
          x2: "196",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zze),
        e("line", {
          x1: "108",
          y1: "164",
          x2: "124",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zze),
        e("line", {
          x1: "24",
          y1: "96.9",
          x2: "232",
          y2: "96.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cze)
      ])) : o(i) === "duotone" ? (s(), r("g", bze, [
        Lze,
        e("rect", {
          x: "24",
          y: "56",
          width: "208",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bze),
        e("line", {
          x1: "168",
          y1: "168",
          x2: "200",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pze),
        e("line", {
          x1: "120",
          y1: "168",
          x2: "136",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wze),
        e("line", {
          x1: "24",
          y1: "96.9",
          x2: "232",
          y2: "96.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nze)
      ])) : o(i) === "fill" ? (s(), r("g", Fze, Dze)) : o(i) === "light" ? (s(), r("g", Rze, [
        e("rect", {
          x: "24",
          y: "56",
          width: "208",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Uze),
        e("line", {
          x1: "168",
          y1: "168",
          x2: "200",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qze),
        e("line", {
          x1: "120",
          y1: "168",
          x2: "136",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gze),
        e("line", {
          x1: "24",
          y1: "96.9",
          x2: "232",
          y2: "96.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Eze)
      ])) : o(i) === "thin" ? (s(), r("g", Oze, [
        e("rect", {
          x: "24",
          y: "56",
          width: "208",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ize),
        e("line", {
          x1: "168",
          y1: "168",
          x2: "200",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kze),
        e("line", {
          x1: "120",
          y1: "168",
          x2: "136",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xze),
        e("line", {
          x1: "24",
          y1: "96.9",
          x2: "232",
          y2: "96.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jze)
      ])) : o(i) === "regular" ? (s(), r("g", Qze, [
        e("rect", {
          x: "24",
          y: "56",
          width: "208",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yze),
        e("line", {
          x1: "168",
          y1: "168",
          x2: "200",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oZe),
        e("line", {
          x1: "120",
          y1: "168",
          x2: "136",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eZe),
        e("line", {
          x1: "24",
          y1: "96.9",
          x2: "232",
          y2: "96.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tZe)
      ])) : g("", !0)
    ], 16, Hze));
  }
}), sZe = ["width", "height", "fill", "transform"], rZe = { key: 0 }, iZe = ["stroke"], lZe = ["stroke"], dZe = ["stroke"], kZe = ["stroke"], cZe = { key: 1 }, hZe = ["stroke"], uZe = ["stroke"], aZe = ["stroke"], _Ze = ["stroke"], pZe = { key: 2 }, yZe = /* @__PURE__ */ e("path", { d: "M240,192a8,8,0,0,1-8,8H200v32a8,8,0,0,1-16,0V200H64a8,8,0,0,1-8-8V72H24a8,8,0,0,1,0-16H56V24a8,8,0,0,1,16,0V184H232A8,8,0,0,1,240,192ZM96,72h88v88a8,8,0,0,0,16,0V64a8,8,0,0,0-8-8H96a8,8,0,0,0,0,16Z" }, null, -1), $Ze = [
  yZe
], wZe = { key: 3 }, fZe = ["stroke"], gZe = ["stroke"], xZe = ["stroke"], jZe = ["stroke"], mZe = { key: 4 }, MZe = ["stroke"], vZe = ["stroke"], SZe = ["stroke"], HZe = ["stroke"], AZe = { key: 5 }, VZe = ["stroke"], zZe = ["stroke"], ZZe = ["stroke"], CZe = ["stroke"], bZe = {
  name: "PhCrop"
}, yG1 = /* @__PURE__ */ $({
  ...bZe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", rZe, [
        e("line", {
          x1: "64",
          y1: "64",
          x2: "24",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iZe),
        e("polyline", {
          points: "64 24 64 192 232 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lZe),
        e("polyline", {
          points: "192 152 192 64 104 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dZe),
        e("line", {
          x1: "192",
          y1: "232",
          x2: "192",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kZe)
      ])) : o(i) === "duotone" ? (s(), r("g", cZe, [
        e("line", {
          x1: "64",
          y1: "64",
          x2: "24",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hZe),
        e("polyline", {
          points: "64 24 64 192 232 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uZe),
        e("polyline", {
          points: "192 160 192 64 96 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aZe),
        e("line", {
          x1: "192",
          y1: "232",
          x2: "192",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Ze)
      ])) : o(i) === "fill" ? (s(), r("g", pZe, $Ze)) : o(i) === "light" ? (s(), r("g", wZe, [
        e("line", {
          x1: "64",
          y1: "64",
          x2: "24",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fZe),
        e("polyline", {
          points: "64 24 64 192 232 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gZe),
        e("polyline", {
          points: "192 160 192 64 96 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xZe),
        e("line", {
          x1: "192",
          y1: "232",
          x2: "192",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jZe)
      ])) : o(i) === "thin" ? (s(), r("g", mZe, [
        e("line", {
          x1: "64",
          y1: "64",
          x2: "24",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MZe),
        e("polyline", {
          points: "64 24 64 192 232 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vZe),
        e("polyline", {
          points: "192 160 192 64 96 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SZe),
        e("line", {
          x1: "192",
          y1: "232",
          x2: "192",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HZe)
      ])) : o(i) === "regular" ? (s(), r("g", AZe, [
        e("line", {
          x1: "64",
          y1: "64",
          x2: "24",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VZe),
        e("polyline", {
          points: "64 24 64 192 232 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zZe),
        e("polyline", {
          points: "192 160 192 64 96 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZZe),
        e("line", {
          x1: "192",
          y1: "232",
          x2: "192",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CZe)
      ])) : g("", !0)
    ], 16, sZe));
  }
}), LZe = ["width", "height", "fill", "transform"], BZe = { key: 0 }, PZe = ["stroke"], WZe = ["stroke"], NZe = ["stroke"], FZe = ["stroke"], TZe = ["stroke"], DZe = ["stroke"], RZe = { key: 1 }, UZe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "32",
  opacity: "0.2"
}, null, -1), qZe = ["stroke"], GZe = ["stroke"], EZe = ["stroke"], OZe = ["stroke"], IZe = ["stroke"], KZe = ["stroke"], XZe = { key: 2 }, JZe = /* @__PURE__ */ e("path", { d: "M236,120H223.7A96.2,96.2,0,0,0,136,32.3V20a8,8,0,0,0-16,0V32.3A96.2,96.2,0,0,0,32.3,120H20a8,8,0,0,0,0,16H32.3A96.2,96.2,0,0,0,120,223.7V236a8,8,0,0,0,16,0V223.7A96.2,96.2,0,0,0,223.7,136H236a8,8,0,0,0,0-16Zm-40,16h11.6A80.3,80.3,0,0,1,136,207.6V196a8,8,0,0,0-16,0v11.6A80.3,80.3,0,0,1,48.4,136H60a8,8,0,0,0,0-16H48.4A80.3,80.3,0,0,1,120,48.4V60a8,8,0,0,0,16,0V48.4A80.3,80.3,0,0,1,207.6,120H196a8,8,0,0,0,0,16Z" }, null, -1), QZe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "40"
}, null, -1), YZe = [
  JZe,
  QZe
], oCe = { key: 3 }, eCe = ["stroke"], tCe = ["stroke"], nCe = ["stroke"], sCe = ["stroke"], rCe = ["stroke"], iCe = ["stroke"], lCe = { key: 4 }, dCe = ["stroke"], kCe = ["stroke"], cCe = ["stroke"], hCe = ["stroke"], uCe = ["stroke"], aCe = ["stroke"], _Ce = { key: 5 }, pCe = ["stroke"], yCe = ["stroke"], $Ce = ["stroke"], wCe = ["stroke"], fCe = ["stroke"], gCe = ["stroke"], xCe = {
  name: "PhCrosshair"
}, $G1 = /* @__PURE__ */ $({
  ...xCe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", BZe, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PZe),
        e("line", {
          x1: "128",
          y1: "20",
          x2: "128",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WZe),
        e("line", {
          x1: "20",
          y1: "128",
          x2: "56",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NZe),
        e("line", {
          x1: "128",
          y1: "236",
          x2: "128",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FZe),
        e("line", {
          x1: "236",
          y1: "128",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TZe),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DZe)
      ])) : o(i) === "duotone" ? (s(), r("g", RZe, [
        UZe,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qZe),
        e("line", {
          x1: "128",
          y1: "20",
          x2: "128",
          y2: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GZe),
        e("line", {
          x1: "20",
          y1: "128",
          x2: "60",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EZe),
        e("line", {
          x1: "128",
          y1: "236",
          x2: "128",
          y2: "196",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OZe),
        e("line", {
          x1: "236",
          y1: "128",
          x2: "196",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IZe),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KZe)
      ])) : o(i) === "fill" ? (s(), r("g", XZe, YZe)) : o(i) === "light" ? (s(), r("g", oCe, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eCe),
        e("line", {
          x1: "128",
          y1: "20",
          x2: "128",
          y2: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tCe),
        e("line", {
          x1: "20",
          y1: "128",
          x2: "60",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nCe),
        e("line", {
          x1: "128",
          y1: "236",
          x2: "128",
          y2: "196",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sCe),
        e("line", {
          x1: "236",
          y1: "128",
          x2: "196",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rCe),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iCe)
      ])) : o(i) === "thin" ? (s(), r("g", lCe, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dCe),
        e("line", {
          x1: "128",
          y1: "20",
          x2: "128",
          y2: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kCe),
        e("line", {
          x1: "20",
          y1: "128",
          x2: "60",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cCe),
        e("line", {
          x1: "128",
          y1: "236",
          x2: "128",
          y2: "196",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hCe),
        e("line", {
          x1: "236",
          y1: "128",
          x2: "196",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uCe),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aCe)
      ])) : o(i) === "regular" ? (s(), r("g", _Ce, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pCe),
        e("line", {
          x1: "128",
          y1: "20",
          x2: "128",
          y2: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yCe),
        e("line", {
          x1: "20",
          y1: "128",
          x2: "60",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Ce),
        e("line", {
          x1: "128",
          y1: "236",
          x2: "128",
          y2: "196",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wCe),
        e("line", {
          x1: "236",
          y1: "128",
          x2: "196",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fCe),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gCe)
      ])) : g("", !0)
    ], 16, LZe));
  }
}), jCe = ["width", "height", "fill", "transform"], mCe = { key: 0 }, MCe = ["stroke"], vCe = ["stroke"], SCe = ["stroke"], HCe = ["stroke"], ACe = ["stroke"], VCe = { key: 1 }, zCe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "92",
  opacity: "0.2"
}, null, -1), ZCe = ["stroke"], CCe = ["stroke"], bCe = ["stroke"], LCe = ["stroke"], BCe = ["stroke"], PCe = { key: 2 }, WCe = /* @__PURE__ */ e("path", { d: "M128,28A100,100,0,1,0,228,128,100.2,100.2,0,0,0,128,28Zm8,183.6V180a8,8,0,0,0-16,0v31.6A84.2,84.2,0,0,1,44.4,136H76a8,8,0,0,0,0-16H44.4A84.2,84.2,0,0,1,120,44.4V76a8,8,0,0,0,16,0V44.4A84.2,84.2,0,0,1,211.6,120H180a8,8,0,0,0,0,16h31.6A84.2,84.2,0,0,1,136,211.6Z" }, null, -1), NCe = [
  WCe
], FCe = { key: 3 }, TCe = ["stroke"], DCe = ["stroke"], RCe = ["stroke"], UCe = ["stroke"], qCe = ["stroke"], GCe = { key: 4 }, ECe = ["stroke"], OCe = ["stroke"], ICe = ["stroke"], KCe = ["stroke"], XCe = ["stroke"], JCe = { key: 5 }, QCe = ["stroke"], YCe = ["stroke"], obe = ["stroke"], ebe = ["stroke"], tbe = ["stroke"], nbe = {
  name: "PhCrosshairSimple"
}, wG1 = /* @__PURE__ */ $({
  ...nbe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", mCe, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MCe),
        e("line", {
          x1: "128",
          y1: "36",
          x2: "128",
          y2: "76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vCe),
        e("line", {
          x1: "36",
          y1: "128",
          x2: "76",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SCe),
        e("line", {
          x1: "128",
          y1: "220",
          x2: "128",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HCe),
        e("line", {
          x1: "220",
          y1: "128",
          x2: "180",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ACe)
      ])) : o(i) === "duotone" ? (s(), r("g", VCe, [
        zCe,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZCe),
        e("line", {
          x1: "128",
          y1: "36",
          x2: "128",
          y2: "76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CCe),
        e("line", {
          x1: "36",
          y1: "128",
          x2: "76",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bCe),
        e("line", {
          x1: "128",
          y1: "220",
          x2: "128",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LCe),
        e("line", {
          x1: "220",
          y1: "128",
          x2: "180",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BCe)
      ])) : o(i) === "fill" ? (s(), r("g", PCe, NCe)) : o(i) === "light" ? (s(), r("g", FCe, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TCe),
        e("line", {
          x1: "128",
          y1: "36",
          x2: "128",
          y2: "76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DCe),
        e("line", {
          x1: "36",
          y1: "128",
          x2: "76",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RCe),
        e("line", {
          x1: "128",
          y1: "220",
          x2: "128",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UCe),
        e("line", {
          x1: "220",
          y1: "128",
          x2: "180",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qCe)
      ])) : o(i) === "thin" ? (s(), r("g", GCe, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ECe),
        e("line", {
          x1: "128",
          y1: "36",
          x2: "128",
          y2: "76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OCe),
        e("line", {
          x1: "36",
          y1: "128",
          x2: "76",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ICe),
        e("line", {
          x1: "128",
          y1: "220",
          x2: "128",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KCe),
        e("line", {
          x1: "220",
          y1: "128",
          x2: "180",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XCe)
      ])) : o(i) === "regular" ? (s(), r("g", JCe, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QCe),
        e("line", {
          x1: "128",
          y1: "36",
          x2: "128",
          y2: "76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YCe),
        e("line", {
          x1: "36",
          y1: "128",
          x2: "76",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, obe),
        e("line", {
          x1: "128",
          y1: "220",
          x2: "128",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ebe),
        e("line", {
          x1: "220",
          y1: "128",
          x2: "180",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tbe)
      ])) : g("", !0)
    ], 16, jCe));
  }
}), sbe = ["width", "height", "fill", "transform"], rbe = { key: 0 }, ibe = ["stroke"], lbe = ["stroke"], dbe = { key: 1 }, kbe = /* @__PURE__ */ e("path", {
  d: "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
  opacity: "0.2"
}, null, -1), cbe = ["stroke"], hbe = ["stroke"], ube = { key: 2 }, abe = /* @__PURE__ */ e("path", { d: "M238.7,73.5A15.9,15.9,0,0,0,222,71.2L171.4,93.7,142,40.7a16.1,16.1,0,0,0-28,0l-29.4,53L34,71.2A16,16,0,0,0,11.9,89.5L37.3,197.8a15.9,15.9,0,0,0,7.4,10.1,16.2,16.2,0,0,0,8.3,2.3,15.2,15.2,0,0,0,4.2-.6,265.5,265.5,0,0,1,141.5,0,16.5,16.5,0,0,0,12.5-1.7,15.6,15.6,0,0,0,7.4-10.1L244.1,89.5A16,16,0,0,0,238.7,73.5Zm-70.7,89a8.1,8.1,0,0,1-8,7.2h-.8a309.8,309.8,0,0,0-62.4,0,8,8,0,0,1-8.8-7.1,8.1,8.1,0,0,1,7.2-8.8,312.7,312.7,0,0,1,65.6,0A8.1,8.1,0,0,1,168,162.5Z" }, null, -1), _be = [
  abe
], pbe = { key: 3 }, ybe = ["stroke"], $be = ["stroke"], wbe = { key: 4 }, fbe = ["stroke"], gbe = ["stroke"], xbe = { key: 5 }, jbe = ["stroke"], mbe = ["stroke"], Mbe = {
  name: "PhCrown"
}, fG1 = /* @__PURE__ */ $({
  ...Mbe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", rbe, [
        e("path", {
          d: "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ibe),
        e("path", {
          d: "M96,153.6a325.9,325.9,0,0,1,64,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lbe)
      ])) : o(i) === "duotone" ? (s(), r("g", dbe, [
        kbe,
        e("path", {
          d: "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cbe),
        e("path", {
          d: "M96,161.7a297.7,297.7,0,0,1,64,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hbe)
      ])) : o(i) === "fill" ? (s(), r("g", ube, _be)) : o(i) === "light" ? (s(), r("g", pbe, [
        e("path", {
          d: "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ybe),
        e("path", {
          d: "M96,161.7a297.7,297.7,0,0,1,64,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $be)
      ])) : o(i) === "thin" ? (s(), r("g", wbe, [
        e("path", {
          d: "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fbe),
        e("path", {
          d: "M96,161.7a297.7,297.7,0,0,1,64,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gbe)
      ])) : o(i) === "regular" ? (s(), r("g", xbe, [
        e("path", {
          d: "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jbe),
        e("path", {
          d: "M96,161.7a297.7,297.7,0,0,1,64,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mbe)
      ])) : g("", !0)
    ], 16, sbe));
  }
}), vbe = ["width", "height", "fill", "transform"], Sbe = { key: 0 }, Hbe = ["stroke"], Abe = { key: 1 }, Vbe = /* @__PURE__ */ e("path", {
  d: "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
  opacity: "0.2"
}, null, -1), zbe = ["stroke"], Zbe = { key: 2 }, Cbe = /* @__PURE__ */ e("path", { d: "M238.7,73.5A15.9,15.9,0,0,0,222,71.2L171.4,93.7,142,40.7a16.1,16.1,0,0,0-28,0l-29.4,53L34,71.2A16,16,0,0,0,11.9,89.5L37.3,197.8a15.9,15.9,0,0,0,7.4,10.1,16.2,16.2,0,0,0,8.3,2.3,15.2,15.2,0,0,0,4.2-.6,265.5,265.5,0,0,1,141.5,0,16.5,16.5,0,0,0,12.5-1.7,15.6,15.6,0,0,0,7.4-10.1L244.1,89.5A16,16,0,0,0,238.7,73.5Z" }, null, -1), bbe = [
  Cbe
], Lbe = { key: 3 }, Bbe = ["stroke"], Pbe = { key: 4 }, Wbe = ["stroke"], Nbe = { key: 5 }, Fbe = ["stroke"], Tbe = {
  name: "PhCrownSimple"
}, gG1 = /* @__PURE__ */ $({
  ...Tbe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Sbe, [
        e("path", {
          d: "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hbe)
      ])) : o(i) === "duotone" ? (s(), r("g", Abe, [
        Vbe,
        e("path", {
          d: "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zbe)
      ])) : o(i) === "fill" ? (s(), r("g", Zbe, bbe)) : o(i) === "light" ? (s(), r("g", Lbe, [
        e("path", {
          d: "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bbe)
      ])) : o(i) === "thin" ? (s(), r("g", Pbe, [
        e("path", {
          d: "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wbe)
      ])) : o(i) === "regular" ? (s(), r("g", Nbe, [
        e("path", {
          d: "M45.1,196a8.1,8.1,0,0,0,10,5.9,273,273,0,0,1,145.7,0,8.1,8.1,0,0,0,10-5.9L236.3,87.7a8,8,0,0,0-11-9.2L174.7,101a8.1,8.1,0,0,1-10.3-3.4L135,44.6a8,8,0,0,0-14,0l-29.4,53A8.1,8.1,0,0,1,81.3,101L30.7,78.5a8,8,0,0,0-11,9.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fbe)
      ])) : g("", !0)
    ], 16, vbe));
  }
}), Dbe = ["width", "height", "fill", "transform"], Rbe = { key: 0 }, Ube = ["stroke"], qbe = ["stroke"], Gbe = ["stroke"], Ebe = { key: 1 }, Obe = /* @__PURE__ */ e("path", {
  d: "M33.1,74.6A8.1,8.1,0,0,0,32,78.7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.6,7.6,0,0,0,3.9,1h0l.9-106.8L33.1,74.6Z",
  opacity: "0.2"
}, null, -1), Ibe = ["stroke"], Kbe = ["stroke"], Xbe = ["stroke"], Jbe = { key: 2 }, Qbe = /* @__PURE__ */ e("path", { d: "M229.9,70.8h0a.1.1,0,0,1-.1-.1,16.2,16.2,0,0,0-6-5.9l-88-49.5a16,16,0,0,0-15.6,0l-88,49.5a16.2,16.2,0,0,0-6,5.9.1.1,0,0,1-.1.1v.2A15,15,0,0,0,24,78.7v98.6a16.1,16.1,0,0,0,8.2,14l88,49.5a16.5,16.5,0,0,0,7.2,2h1.4a16.1,16.1,0,0,0,7-2l88-49.5a16.1,16.1,0,0,0,8.2-14V78.7A15.6,15.6,0,0,0,229.9,70.8Zm-101,48L48.4,74,128,29.2,207.7,74ZM216,177.3l-79.9,45,.8-89.6,79.1-45Z" }, null, -1), Ybe = [
  Qbe
], oLe = { key: 3 }, eLe = ["stroke"], tLe = ["stroke"], nLe = ["stroke"], sLe = { key: 4 }, rLe = ["stroke"], iLe = ["stroke"], lLe = ["stroke"], dLe = { key: 5 }, kLe = ["stroke"], cLe = ["stroke"], hLe = ["stroke"], uLe = {
  name: "PhCube"
}, xG1 = /* @__PURE__ */ $({
  ...uLe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Rbe, [
        e("path", {
          d: "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ube),
        e("polyline", {
          points: "222.9 74.6 128.9 128 33.1 74.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qbe),
        e("line", {
          x1: "128.9",
          y1: "128",
          x2: "128",
          y2: "234.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gbe)
      ])) : o(i) === "duotone" ? (s(), r("g", Ebe, [
        Obe,
        e("path", {
          d: "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ibe),
        e("polyline", {
          points: "222.9 74.6 128.9 128 33.1 74.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kbe),
        e("line", {
          x1: "128.9",
          y1: "128",
          x2: "128",
          y2: "234.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xbe)
      ])) : o(i) === "fill" ? (s(), r("g", Jbe, Ybe)) : o(i) === "light" ? (s(), r("g", oLe, [
        e("path", {
          d: "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eLe),
        e("polyline", {
          points: "222.9 74.6 128.9 128 33.1 74.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tLe),
        e("line", {
          x1: "128.9",
          y1: "128",
          x2: "128",
          y2: "234.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nLe)
      ])) : o(i) === "thin" ? (s(), r("g", sLe, [
        e("path", {
          d: "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rLe),
        e("polyline", {
          points: "222.9 74.6 128.9 128 33.1 74.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iLe),
        e("line", {
          x1: "128.9",
          y1: "128",
          x2: "128",
          y2: "234.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lLe)
      ])) : o(i) === "regular" ? (s(), r("g", dLe, [
        e("path", {
          d: "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kLe),
        e("polyline", {
          points: "222.9 74.6 128.9 128 33.1 74.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cLe),
        e("line", {
          x1: "128.9",
          y1: "128",
          x2: "128",
          y2: "234.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hLe)
      ])) : g("", !0)
    ], 16, Dbe));
  }
}), aLe = ["width", "height", "fill", "transform"], _Le = { key: 0 }, pLe = ["stroke"], yLe = ["stroke"], $Le = ["stroke"], wLe = ["stroke"], fLe = ["stroke"], gLe = ["stroke"], xLe = ["stroke"], jLe = { key: 1 }, mLe = ["stroke"], MLe = ["stroke"], vLe = ["stroke"], SLe = ["stroke"], HLe = ["stroke"], ALe = ["stroke"], VLe = ["stroke"], zLe = { key: 2 }, ZLe = /* @__PURE__ */ e("path", { d: "M170.5,115.7A44,44,0,0,0,144,40.2V24a8,8,0,0,0-16,0V40H112V24a8,8,0,0,0-16,0V40H64a8,8,0,0,0,0,16h8V192H64a8,8,0,0,0,0,16H96v16a8,8,0,0,0,16,0V208h16v16a8,8,0,0,0,16,0V208h8a48,48,0,0,0,18.5-92.3ZM168,84a28.1,28.1,0,0,1-28,28H88V56h52A28.1,28.1,0,0,1,168,84ZM152,192H88V128h64a32,32,0,0,1,0,64Z" }, null, -1), CLe = [
  ZLe
], bLe = { key: 3 }, LLe = ["stroke"], BLe = ["stroke"], PLe = ["stroke"], WLe = ["stroke"], NLe = ["stroke"], FLe = ["stroke"], TLe = ["stroke"], DLe = { key: 4 }, RLe = ["stroke"], ULe = ["stroke"], qLe = ["stroke"], GLe = ["stroke"], ELe = ["stroke"], OLe = ["stroke"], ILe = ["stroke"], KLe = { key: 5 }, XLe = ["stroke"], JLe = ["stroke"], QLe = ["stroke"], YLe = ["stroke"], oBe = ["stroke"], eBe = ["stroke"], tBe = ["stroke"], nBe = {
  name: "PhCurrencyBtc"
}, jG1 = /* @__PURE__ */ $({
  ...nBe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", _Le, [
        e("path", {
          d: "M80,120h72a40,40,0,0,1,0,80H80V48h60a36,36,0,0,1,0,72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pLe),
        e("line", {
          x1: "64",
          y1: "48",
          x2: "80",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yLe),
        e("line", {
          x1: "64",
          y1: "200",
          x2: "80",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $Le),
        e("line", {
          x1: "100",
          y1: "48",
          x2: "100",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wLe),
        e("line", {
          x1: "140",
          y1: "48",
          x2: "140",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fLe),
        e("line", {
          x1: "100",
          y1: "224",
          x2: "100",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gLe),
        e("line", {
          x1: "140",
          y1: "224",
          x2: "140",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xLe)
      ])) : o(i) === "duotone" ? (s(), r("g", jLe, [
        e("path", {
          d: "M80,120h72a40,40,0,0,1,0,80H80V48h60a36,36,0,0,1,0,72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mLe),
        e("line", {
          x1: "64",
          y1: "48",
          x2: "80",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MLe),
        e("line", {
          x1: "64",
          y1: "200",
          x2: "80",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vLe),
        e("line", {
          x1: "104",
          y1: "48",
          x2: "104",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SLe),
        e("line", {
          x1: "136",
          y1: "48",
          x2: "136",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HLe),
        e("line", {
          x1: "104",
          y1: "224",
          x2: "104",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ALe),
        e("line", {
          x1: "136",
          y1: "224",
          x2: "136",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VLe)
      ])) : o(i) === "fill" ? (s(), r("g", zLe, CLe)) : o(i) === "light" ? (s(), r("g", bLe, [
        e("path", {
          d: "M80,120h72a40,40,0,0,1,0,80H80V48h60a36,36,0,0,1,0,72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LLe),
        e("line", {
          x1: "64",
          y1: "48",
          x2: "80",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BLe),
        e("line", {
          x1: "64",
          y1: "200",
          x2: "80",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PLe),
        e("line", {
          x1: "104",
          y1: "48",
          x2: "104",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WLe),
        e("line", {
          x1: "136",
          y1: "48",
          x2: "136",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, NLe),
        e("line", {
          x1: "104",
          y1: "224",
          x2: "104",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FLe),
        e("line", {
          x1: "136",
          y1: "224",
          x2: "136",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TLe)
      ])) : o(i) === "thin" ? (s(), r("g", DLe, [
        e("path", {
          d: "M80,120h72a40,40,0,0,1,0,80H80V48h60a36,36,0,0,1,0,72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RLe),
        e("line", {
          x1: "64",
          y1: "48",
          x2: "80",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ULe),
        e("line", {
          x1: "64",
          y1: "200",
          x2: "80",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qLe),
        e("line", {
          x1: "104",
          y1: "48",
          x2: "104",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GLe),
        e("line", {
          x1: "136",
          y1: "48",
          x2: "136",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ELe),
        e("line", {
          x1: "104",
          y1: "224",
          x2: "104",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OLe),
        e("line", {
          x1: "136",
          y1: "224",
          x2: "136",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ILe)
      ])) : o(i) === "regular" ? (s(), r("g", KLe, [
        e("path", {
          d: "M80,120h72a40,40,0,0,1,0,80H80V48h60a36,36,0,0,1,0,72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XLe),
        e("line", {
          x1: "64",
          y1: "48",
          x2: "80",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JLe),
        e("line", {
          x1: "64",
          y1: "200",
          x2: "80",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QLe),
        e("line", {
          x1: "104",
          y1: "48",
          x2: "104",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YLe),
        e("line", {
          x1: "136",
          y1: "48",
          x2: "136",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oBe),
        e("line", {
          x1: "104",
          y1: "224",
          x2: "104",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eBe),
        e("line", {
          x1: "136",
          y1: "224",
          x2: "136",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tBe)
      ])) : g("", !0)
    ], 16, aLe));
  }
}), sBe = ["width", "height", "fill", "transform"], rBe = { key: 0 }, iBe = ["stroke"], lBe = ["stroke"], dBe = ["stroke"], kBe = ["stroke"], cBe = { key: 1 }, hBe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), uBe = ["stroke"], aBe = ["stroke"], _Be = ["stroke"], pBe = ["stroke"], yBe = { key: 2 }, $Be = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm12,152h-4v8a8,8,0,0,1-16,0v-8H104a8,8,0,0,1,0-16h36a12,12,0,0,0,0-24H116a28,28,0,0,1,0-56h4V72a8,8,0,0,1,16,0v8h16a8,8,0,0,1,0,16H116a12,12,0,0,0,0,24h24a28,28,0,0,1,0,56Z" }, null, -1), wBe = [
  $Be
], fBe = { key: 3 }, gBe = ["stroke"], xBe = ["stroke"], jBe = ["stroke"], mBe = ["stroke"], MBe = { key: 4 }, vBe = ["stroke"], SBe = ["stroke"], HBe = ["stroke"], ABe = ["stroke"], VBe = { key: 5 }, zBe = ["stroke"], ZBe = ["stroke"], CBe = ["stroke"], bBe = ["stroke"], LBe = {
  name: "PhCurrencyCircleDollar"
}, mG1 = /* @__PURE__ */ $({
  ...LBe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", rBe, [
        e("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iBe),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lBe),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dBe),
        e("path", {
          d: "M104,168h36a20,20,0,0,0,0-40H116a20,20,0,0,1,0-40h36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kBe)
      ])) : o(i) === "duotone" ? (s(), r("g", cBe, [
        hBe,
        e("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uBe),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aBe),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Be),
        e("path", {
          d: "M104,168h36a20,20,0,0,0,0-40H116a20,20,0,0,1,0-40h36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pBe)
      ])) : o(i) === "fill" ? (s(), r("g", yBe, wBe)) : o(i) === "light" ? (s(), r("g", fBe, [
        e("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gBe),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xBe),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jBe),
        e("path", {
          d: "M104,168h36a20,20,0,0,0,0-40H116a20,20,0,0,1,0-40h36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mBe)
      ])) : o(i) === "thin" ? (s(), r("g", MBe, [
        e("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vBe),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SBe),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HBe),
        e("path", {
          d: "M104,168h36a20,20,0,0,0,0-40H116a20,20,0,0,1,0-40h36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ABe)
      ])) : o(i) === "regular" ? (s(), r("g", VBe, [
        e("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zBe),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZBe),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CBe),
        e("path", {
          d: "M104,168h36a20,20,0,0,0,0-40H116a20,20,0,0,1,0-40h36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bBe)
      ])) : g("", !0)
    ], 16, sBe));
  }
}), BBe = ["width", "height", "fill", "transform"], PBe = { key: 0 }, WBe = ["stroke"], NBe = ["stroke"], FBe = ["stroke"], TBe = ["stroke"], DBe = { key: 1 }, RBe = ["stroke"], UBe = ["stroke"], qBe = ["stroke"], GBe = ["stroke"], EBe = { key: 2 }, OBe = /* @__PURE__ */ e("path", { d: "M56,64a8,8,0,0,1,8-8H192a8,8,0,0,1,0,16H64A8,8,0,0,1,56,64ZM216,168a8,8,0,0,0-8,8v16H176a16,16,0,0,1-16-16V128h48a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16H96v8a56,56,0,0,1-56,56,8,8,0,0,0,0,16,72.1,72.1,0,0,0,72-72v-8h32v48a32.1,32.1,0,0,0,32,32h40a8,8,0,0,0,8-8V176A8,8,0,0,0,216,168Z" }, null, -1), IBe = [
  OBe
], KBe = { key: 3 }, XBe = ["stroke"], JBe = ["stroke"], QBe = ["stroke"], YBe = ["stroke"], oPe = { key: 4 }, ePe = ["stroke"], tPe = ["stroke"], nPe = ["stroke"], sPe = ["stroke"], rPe = { key: 5 }, iPe = ["stroke"], lPe = ["stroke"], dPe = ["stroke"], kPe = ["stroke"], cPe = {
  name: "PhCurrencyCny"
}, MG1 = /* @__PURE__ */ $({
  ...cPe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", PBe, [
        e("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WBe),
        e("line", {
          x1: "48",
          y1: "120",
          x2: "208",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NBe),
        e("path", {
          d: "M152,120v56a23.9,23.9,0,0,0,24,24h40V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FBe),
        e("path", {
          d: "M104,120v16a64.1,64.1,0,0,1-64,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TBe)
      ])) : o(i) === "duotone" ? (s(), r("g", DBe, [
        e("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RBe),
        e("line", {
          x1: "48",
          y1: "120",
          x2: "208",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UBe),
        e("path", {
          d: "M152,120v56a23.9,23.9,0,0,0,24,24h40V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qBe),
        e("path", {
          d: "M104,120v16a64.1,64.1,0,0,1-64,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GBe)
      ])) : o(i) === "fill" ? (s(), r("g", EBe, IBe)) : o(i) === "light" ? (s(), r("g", KBe, [
        e("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XBe),
        e("line", {
          x1: "48",
          y1: "120",
          x2: "208",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JBe),
        e("path", {
          d: "M152,120v56a23.9,23.9,0,0,0,24,24h40V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QBe),
        e("path", {
          d: "M104,120v16a64.1,64.1,0,0,1-64,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YBe)
      ])) : o(i) === "thin" ? (s(), r("g", oPe, [
        e("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ePe),
        e("line", {
          x1: "48",
          y1: "120",
          x2: "208",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tPe),
        e("path", {
          d: "M152,120v56a23.9,23.9,0,0,0,24,24h40V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nPe),
        e("path", {
          d: "M104,120v16a64.1,64.1,0,0,1-64,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sPe)
      ])) : o(i) === "regular" ? (s(), r("g", rPe, [
        e("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iPe),
        e("line", {
          x1: "48",
          y1: "120",
          x2: "208",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lPe),
        e("path", {
          d: "M152,120v56a23.9,23.9,0,0,0,24,24h40V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dPe),
        e("path", {
          d: "M104,120v16a64.1,64.1,0,0,1-64,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kPe)
      ])) : g("", !0)
    ], 16, BBe));
  }
}), hPe = ["width", "height", "fill", "transform"], uPe = { key: 0 }, aPe = ["stroke"], _Pe = ["stroke"], pPe = { key: 1 }, yPe = ["stroke"], $Pe = ["stroke"], wPe = { key: 2 }, fPe = /* @__PURE__ */ e("path", { d: "M152,120H136V56h8a32.1,32.1,0,0,1,32,32,8,8,0,0,0,16,0,48,48,0,0,0-48-48h-8V24a8,8,0,0,0-16,0V40H108a48,48,0,0,0,0,96h12v64H104a32.1,32.1,0,0,1-32-32,8,8,0,0,0-16,0,48,48,0,0,0,48,48h16v16a8,8,0,0,0,16,0V216h16a48,48,0,0,0,0-96Zm-32,0H108a32,32,0,0,1,0-64h12Zm32,80H136V136h16a32,32,0,0,1,0,64Z" }, null, -1), gPe = [
  fPe
], xPe = { key: 3 }, jPe = ["stroke"], mPe = ["stroke"], MPe = { key: 4 }, vPe = ["stroke"], SPe = ["stroke"], HPe = { key: 5 }, APe = ["stroke"], VPe = ["stroke"], zPe = {
  name: "PhCurrencyDollar"
}, vG1 = /* @__PURE__ */ $({
  ...zPe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", uPe, [
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aPe),
        e("path", {
          d: "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Pe)
      ])) : o(i) === "duotone" ? (s(), r("g", pPe, [
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yPe),
        e("path", {
          d: "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Pe)
      ])) : o(i) === "fill" ? (s(), r("g", wPe, gPe)) : o(i) === "light" ? (s(), r("g", xPe, [
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jPe),
        e("path", {
          d: "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mPe)
      ])) : o(i) === "thin" ? (s(), r("g", MPe, [
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vPe),
        e("path", {
          d: "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SPe)
      ])) : o(i) === "regular" ? (s(), r("g", HPe, [
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, APe),
        e("path", {
          d: "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VPe)
      ])) : g("", !0)
    ], 16, hPe));
  }
}), ZPe = ["width", "height", "fill", "transform"], CPe = { key: 0 }, bPe = ["stroke"], LPe = ["stroke"], BPe = ["stroke"], PPe = { key: 1 }, WPe = ["stroke"], NPe = ["stroke"], FPe = ["stroke"], TPe = { key: 2 }, DPe = /* @__PURE__ */ e("path", { d: "M200,168a48,48,0,0,1-48,48H136v16a8,8,0,0,1-16,0V216H104a48,48,0,0,1-48-48,8,8,0,0,1,16,0,32.1,32.1,0,0,0,32,32h48a32,32,0,0,0,0-64H108a48,48,0,0,1,0-96h12V24a8,8,0,0,1,16,0V40h8a48,48,0,0,1,48,48,8,8,0,0,1-16,0,32.1,32.1,0,0,0-32-32H108a32,32,0,0,0,0,64h44A48,48,0,0,1,200,168Z" }, null, -1), RPe = [
  DPe
], UPe = { key: 3 }, qPe = ["stroke"], GPe = ["stroke"], EPe = ["stroke"], OPe = { key: 4 }, IPe = ["stroke"], KPe = ["stroke"], XPe = ["stroke"], JPe = { key: 5 }, QPe = ["stroke"], YPe = ["stroke"], oWe = ["stroke"], eWe = {
  name: "PhCurrencyDollarSimple"
}, SG1 = /* @__PURE__ */ $({
  ...eWe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", CPe, [
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bPe),
        e("line", {
          x1: "128",
          y1: "208",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LPe),
        e("path", {
          d: "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BPe)
      ])) : o(i) === "duotone" ? (s(), r("g", PPe, [
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WPe),
        e("line", {
          x1: "128",
          y1: "208",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NPe),
        e("path", {
          d: "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FPe)
      ])) : o(i) === "fill" ? (s(), r("g", TPe, RPe)) : o(i) === "light" ? (s(), r("g", UPe, [
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qPe),
        e("line", {
          x1: "128",
          y1: "208",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GPe),
        e("path", {
          d: "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, EPe)
      ])) : o(i) === "thin" ? (s(), r("g", OPe, [
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, IPe),
        e("line", {
          x1: "128",
          y1: "208",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KPe),
        e("path", {
          d: "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XPe)
      ])) : o(i) === "regular" ? (s(), r("g", JPe, [
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QPe),
        e("line", {
          x1: "128",
          y1: "208",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YPe),
        e("path", {
          d: "M184,88a40,40,0,0,0-40-40H108a40,40,0,0,0,0,80h44a40,40,0,0,1,0,80H104a40,40,0,0,1-40-40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oWe)
      ])) : g("", !0)
    ], 16, ZPe));
  }
}), tWe = ["width", "height", "fill", "transform"], nWe = { key: 0 }, sWe = ["stroke"], rWe = ["stroke"], iWe = ["stroke"], lWe = { key: 1 }, dWe = /* @__PURE__ */ e("polygon", {
  points: "40 128 128 240 216 128 128 168 40 128",
  opacity: "0.2"
}, null, -1), kWe = ["stroke"], cWe = ["stroke"], hWe = ["stroke"], uWe = { key: 2 }, aWe = /* @__PURE__ */ e("path", { d: "M222.3,123.1l-88-112a8,8,0,0,0-12.6,0l-88,112a7.8,7.8,0,0,0,0,9.8l88,112a8,8,0,0,0,12.6,0l88-112A7.8,7.8,0,0,0,222.3,123.1ZM136,155.6V39.1l67.4,85.8Zm-16,0L52.6,124.9,120,39.1Zm0,17.6v43.7l-53.4-68Z" }, null, -1), _We = [
  aWe
], pWe = { key: 3 }, yWe = ["stroke"], $We = ["stroke"], wWe = ["stroke"], fWe = { key: 4 }, gWe = ["stroke"], xWe = ["stroke"], jWe = ["stroke"], mWe = { key: 5 }, MWe = ["stroke"], vWe = ["stroke"], SWe = ["stroke"], HWe = {
  name: "PhCurrencyEth"
}, HG1 = /* @__PURE__ */ $({
  ...HWe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", nWe, [
        e("line", {
          x1: "128",
          y1: "16",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sWe),
        e("polyline", {
          points: "216 128 128 168 40 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rWe),
        e("polygon", {
          points: "128 16 216 128 128 240 40 128 128 16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iWe)
      ])) : o(i) === "duotone" ? (s(), r("g", lWe, [
        dWe,
        e("line", {
          x1: "128",
          y1: "16",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kWe),
        e("polyline", {
          points: "216 128 128 168 40 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cWe),
        e("polygon", {
          points: "128 16 216 128 128 240 40 128 128 16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hWe)
      ])) : o(i) === "fill" ? (s(), r("g", uWe, _We)) : o(i) === "light" ? (s(), r("g", pWe, [
        e("line", {
          x1: "128",
          y1: "16",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yWe),
        e("polyline", {
          points: "216 128 128 168 40 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $We),
        e("polygon", {
          points: "128 16 216 128 128 240 40 128 128 16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wWe)
      ])) : o(i) === "thin" ? (s(), r("g", fWe, [
        e("line", {
          x1: "128",
          y1: "16",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gWe),
        e("polyline", {
          points: "216 128 128 168 40 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xWe),
        e("polygon", {
          points: "128 16 216 128 128 240 40 128 128 16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jWe)
      ])) : o(i) === "regular" ? (s(), r("g", mWe, [
        e("line", {
          x1: "128",
          y1: "16",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MWe),
        e("polyline", {
          points: "216 128 128 168 40 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vWe),
        e("polygon", {
          points: "128 16 216 128 128 240 40 128 128 16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SWe)
      ])) : g("", !0)
    ], 16, tWe));
  }
}), AWe = ["width", "height", "fill", "transform"], VWe = { key: 0 }, zWe = ["stroke"], ZWe = ["stroke"], CWe = ["stroke"], bWe = { key: 1 }, LWe = ["stroke"], BWe = ["stroke"], PWe = ["stroke"], WWe = { key: 2 }, NWe = /* @__PURE__ */ e("path", { d: "M192.6,189.3a8,8,0,0,1,0,11.3A80,80,0,0,1,56.4,152H40a8,8,0,0,1,0-16H56V120H40a8,8,0,0,1,0-16H56.4A80,80,0,0,1,192.6,55.4a8,8,0,0,1,0,11.3,7.9,7.9,0,0,1-11.3,0A64.1,64.1,0,0,0,72.5,104H136a8,8,0,0,1,0,16H72v16h48a8,8,0,0,1,0,16H72.5a64.1,64.1,0,0,0,108.8,37.3A7.9,7.9,0,0,1,192.6,189.3Z" }, null, -1), FWe = [
  NWe
], TWe = { key: 3 }, DWe = ["stroke"], RWe = ["stroke"], UWe = ["stroke"], qWe = { key: 4 }, GWe = ["stroke"], EWe = ["stroke"], OWe = ["stroke"], IWe = { key: 5 }, KWe = ["stroke"], XWe = ["stroke"], JWe = ["stroke"], QWe = {
  name: "PhCurrencyEur"
}, AG1 = /* @__PURE__ */ $({
  ...QWe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", VWe, [
        e("path", {
          d: "M186.9,194.9A72,72,0,0,1,64,144V112A72,72,0,0,1,186.9,61.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zWe),
        e("line", {
          x1: "40",
          y1: "108",
          x2: "136",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZWe),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "120",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CWe)
      ])) : o(i) === "duotone" ? (s(), r("g", bWe, [
        e("path", {
          d: "M186.9,194.9A72,72,0,0,1,64,144V112A72,72,0,0,1,186.9,61.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LWe),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "136",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BWe),
        e("line", {
          x1: "40",
          y1: "144",
          x2: "120",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PWe)
      ])) : o(i) === "fill" ? (s(), r("g", WWe, FWe)) : o(i) === "light" ? (s(), r("g", TWe, [
        e("path", {
          d: "M186.9,194.9A72,72,0,0,1,64,144V112A72,72,0,0,1,186.9,61.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DWe),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "136",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RWe),
        e("line", {
          x1: "40",
          y1: "144",
          x2: "120",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UWe)
      ])) : o(i) === "thin" ? (s(), r("g", qWe, [
        e("path", {
          d: "M186.9,194.9A72,72,0,0,1,64,144V112A72,72,0,0,1,186.9,61.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GWe),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "136",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, EWe),
        e("line", {
          x1: "40",
          y1: "144",
          x2: "120",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OWe)
      ])) : o(i) === "regular" ? (s(), r("g", IWe, [
        e("path", {
          d: "M186.9,194.9A72,72,0,0,1,64,144V112A72,72,0,0,1,186.9,61.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KWe),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "136",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XWe),
        e("line", {
          x1: "40",
          y1: "144",
          x2: "120",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JWe)
      ])) : g("", !0)
    ], 16, AWe));
  }
}), YWe = ["width", "height", "fill", "transform"], oNe = { key: 0 }, eNe = ["stroke"], tNe = ["stroke"], nNe = { key: 1 }, sNe = ["stroke"], rNe = ["stroke"], iNe = { key: 2 }, lNe = /* @__PURE__ */ e("path", { d: "M192,208a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16,28.1,28.1,0,0,0,28-28V140H56a8,8,0,0,1,0-16H84V84a52,52,0,0,1,88.8-36.8,8,8,0,0,1,0,11.3,7.9,7.9,0,0,1-11.3,0A36.1,36.1,0,0,0,100,84v40h36a8,8,0,0,1,0,16H100v32a43.8,43.8,0,0,1-10.1,28H184A8,8,0,0,1,192,208Z" }, null, -1), dNe = [
  lNe
], kNe = { key: 3 }, cNe = ["stroke"], hNe = ["stroke"], uNe = { key: 4 }, aNe = ["stroke"], _Ne = ["stroke"], pNe = { key: 5 }, yNe = ["stroke"], $Ne = ["stroke"], wNe = {
  name: "PhCurrencyGbp"
}, VG1 = /* @__PURE__ */ $({
  ...wNe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", oNe, [
        e("line", {
          x1: "56",
          y1: "132",
          x2: "136",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eNe),
        e("path", {
          d: "M184,208H56a36,36,0,0,0,36-36V84a44,44,0,0,1,44-44,43.5,43.5,0,0,1,31.1,12.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tNe)
      ])) : o(i) === "duotone" ? (s(), r("g", nNe, [
        e("line", {
          x1: "56",
          y1: "132",
          x2: "136",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sNe),
        e("path", {
          d: "M184,208H56a36,36,0,0,0,36-36V84a44,44,0,0,1,44-44,43.5,43.5,0,0,1,31.1,12.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rNe)
      ])) : o(i) === "fill" ? (s(), r("g", iNe, dNe)) : o(i) === "light" ? (s(), r("g", kNe, [
        e("line", {
          x1: "56",
          y1: "132",
          x2: "136",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cNe),
        e("path", {
          d: "M184,208H56a36,36,0,0,0,36-36V84a44,44,0,0,1,44-44,43.5,43.5,0,0,1,31.1,12.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hNe)
      ])) : o(i) === "thin" ? (s(), r("g", uNe, [
        e("line", {
          x1: "56",
          y1: "132",
          x2: "136",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aNe),
        e("path", {
          d: "M184,208H56a36,36,0,0,0,36-36V84a44,44,0,0,1,44-44,43.5,43.5,0,0,1,31.1,12.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _Ne)
      ])) : o(i) === "regular" ? (s(), r("g", pNe, [
        e("line", {
          x1: "56",
          y1: "132",
          x2: "136",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yNe),
        e("path", {
          d: "M184,208H56a36,36,0,0,0,36-36V84a44,44,0,0,1,44-44,43.5,43.5,0,0,1,31.1,12.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Ne)
      ])) : g("", !0)
    ], 16, YWe));
  }
}), fNe = ["width", "height", "fill", "transform"], gNe = { key: 0 }, xNe = ["stroke"], jNe = ["stroke"], mNe = ["stroke"], MNe = { key: 1 }, vNe = ["stroke"], SNe = ["stroke"], HNe = ["stroke"], ANe = { key: 2 }, VNe = /* @__PURE__ */ e("path", { d: "M208,80a8,8,0,0,1-8,8H167.9c0,1.3.1,2.7.1,4a60,60,0,0,1-60,60H92.7l72.7,66.1a7.9,7.9,0,0,1,.5,11.3A8,8,0,0,1,160,232a8.2,8.2,0,0,1-5.4-2.1l-88-80A8,8,0,0,1,72,136h36a44,44,0,0,0,44-44c0-1.3-.1-2.7-.2-4H72a8,8,0,0,1,0-16h75.2A44.1,44.1,0,0,0,108,48H72a8,8,0,0,1,0-16H200a8,8,0,0,1,0,16H148.7a60.2,60.2,0,0,1,15.9,24H200A8,8,0,0,1,208,80Z" }, null, -1), zNe = [
  VNe
], ZNe = { key: 3 }, CNe = ["stroke"], bNe = ["stroke"], LNe = ["stroke"], BNe = { key: 4 }, PNe = ["stroke"], WNe = ["stroke"], NNe = ["stroke"], FNe = { key: 5 }, TNe = ["stroke"], DNe = ["stroke"], RNe = ["stroke"], UNe = {
  name: "PhCurrencyInr"
}, zG1 = /* @__PURE__ */ $({
  ...UNe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", gNe, [
        e("line", {
          x1: "72",
          y1: "80",
          x2: "200",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xNe),
        e("line", {
          x1: "72",
          y1: "40",
          x2: "200",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jNe),
        e("path", {
          d: "M108,40a52,52,0,0,1,0,104H72l88,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mNe)
      ])) : o(i) === "duotone" ? (s(), r("g", MNe, [
        e("line", {
          x1: "72",
          y1: "80",
          x2: "200",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vNe),
        e("line", {
          x1: "72",
          y1: "40",
          x2: "200",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SNe),
        e("path", {
          d: "M108,40a52,52,0,0,1,0,104H72l88,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HNe)
      ])) : o(i) === "fill" ? (s(), r("g", ANe, zNe)) : o(i) === "light" ? (s(), r("g", ZNe, [
        e("line", {
          x1: "72",
          y1: "80",
          x2: "200",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, CNe),
        e("line", {
          x1: "72",
          y1: "40",
          x2: "200",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bNe),
        e("path", {
          d: "M108,40a52,52,0,0,1,0,104H72l88,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LNe)
      ])) : o(i) === "thin" ? (s(), r("g", BNe, [
        e("line", {
          x1: "72",
          y1: "80",
          x2: "200",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PNe),
        e("line", {
          x1: "72",
          y1: "40",
          x2: "200",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WNe),
        e("path", {
          d: "M108,40a52,52,0,0,1,0,104H72l88,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, NNe)
      ])) : o(i) === "regular" ? (s(), r("g", FNe, [
        e("line", {
          x1: "72",
          y1: "80",
          x2: "200",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TNe),
        e("line", {
          x1: "72",
          y1: "40",
          x2: "200",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DNe),
        e("path", {
          d: "M108,40a52,52,0,0,1,0,104H72l88,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RNe)
      ])) : g("", !0)
    ], 16, fNe));
  }
}), qNe = ["width", "height", "fill", "transform"], GNe = { key: 0 }, ENe = ["stroke"], ONe = ["stroke"], INe = ["stroke"], KNe = ["stroke"], XNe = { key: 1 }, JNe = ["stroke"], QNe = ["stroke"], YNe = ["stroke"], oFe = ["stroke"], eFe = { key: 2 }, tFe = /* @__PURE__ */ e("path", { d: "M206.2,53.1,144.9,128H176a8,8,0,0,1,0,16H136v16h40a8,8,0,0,1,0,16H136v40a8,8,0,0,1-16,0V176H80a8,8,0,0,1,0-16h40V144H80a8,8,0,0,1,0-16h31.1L49.8,53.1A8,8,0,0,1,62.2,42.9L128,123.4l65.8-80.5a8,8,0,0,1,12.4,10.2Z" }, null, -1), nFe = [
  tFe
], sFe = { key: 3 }, rFe = ["stroke"], iFe = ["stroke"], lFe = ["stroke"], dFe = ["stroke"], kFe = { key: 4 }, cFe = ["stroke"], hFe = ["stroke"], uFe = ["stroke"], aFe = ["stroke"], _Fe = { key: 5 }, pFe = ["stroke"], yFe = ["stroke"], $Fe = ["stroke"], wFe = ["stroke"], fFe = {
  name: "PhCurrencyJpy"
}, ZG1 = /* @__PURE__ */ $({
  ...fFe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", GNe, [
        e("line", {
          x1: "80",
          y1: "176",
          x2: "176",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ENe),
        e("line", {
          x1: "80",
          y1: "136",
          x2: "176",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ONe),
        e("line", {
          x1: "128",
          y1: "136",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, INe),
        e("polyline", {
          points: "200 48 128 136 56 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KNe)
      ])) : o(i) === "duotone" ? (s(), r("g", XNe, [
        e("line", {
          x1: "80",
          y1: "168",
          x2: "176",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JNe),
        e("line", {
          x1: "80",
          y1: "136",
          x2: "176",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QNe),
        e("line", {
          x1: "128",
          y1: "136",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YNe),
        e("polyline", {
          points: "200 48 128 136 56 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oFe)
      ])) : o(i) === "fill" ? (s(), r("g", eFe, nFe)) : o(i) === "light" ? (s(), r("g", sFe, [
        e("line", {
          x1: "80",
          y1: "168",
          x2: "176",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rFe),
        e("line", {
          x1: "80",
          y1: "136",
          x2: "176",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iFe),
        e("line", {
          x1: "128",
          y1: "136",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lFe),
        e("polyline", {
          points: "200 48 128 136 56 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dFe)
      ])) : o(i) === "thin" ? (s(), r("g", kFe, [
        e("line", {
          x1: "80",
          y1: "168",
          x2: "176",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cFe),
        e("line", {
          x1: "80",
          y1: "136",
          x2: "176",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hFe),
        e("line", {
          x1: "128",
          y1: "136",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uFe),
        e("polyline", {
          points: "200 48 128 136 56 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aFe)
      ])) : o(i) === "regular" ? (s(), r("g", _Fe, [
        e("line", {
          x1: "80",
          y1: "168",
          x2: "176",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pFe),
        e("line", {
          x1: "80",
          y1: "136",
          x2: "176",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yFe),
        e("line", {
          x1: "128",
          y1: "136",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Fe),
        e("polyline", {
          points: "200 48 128 136 56 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wFe)
      ])) : g("", !0)
    ], 16, qNe));
  }
}), gFe = ["width", "height", "fill", "transform"], xFe = { key: 0 }, jFe = ["stroke"], mFe = ["stroke"], MFe = { key: 1 }, vFe = ["stroke"], SFe = ["stroke"], HFe = { key: 2 }, AFe = /* @__PURE__ */ e("path", { d: "M240,128H217.9l21.5-53a8,8,0,1,0-14.8-6l-24,59H159.4l-24-59a8,8,0,0,0-14.8,0l-24,59H55.4l-24-59a8,8,0,1,0-14.8,6l21.5,53H16a8,8,0,0,0,0,16H44.6l24,59a8,8,0,0,0,14.8,0l24-59h41.2l24,59a8,8,0,0,0,14.8,0l24-59H240a8,8,0,0,0,0-16ZM76,178.7,61.9,144H90.1ZM113.9,128,128,93.3,142.1,128ZM180,178.7,165.9,144h28.2Z" }, null, -1), VFe = [
  AFe
], zFe = { key: 3 }, ZFe = ["stroke"], CFe = ["stroke"], bFe = { key: 4 }, LFe = ["stroke"], BFe = ["stroke"], PFe = { key: 5 }, WFe = ["stroke"], NFe = ["stroke"], FFe = {
  name: "PhCurrencyKrw"
}, CG1 = /* @__PURE__ */ $({
  ...FFe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xFe, [
        e("line", {
          x1: "16",
          y1: "136",
          x2: "240",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jFe),
        e("polyline", {
          points: "24 72 76 200 128 72 180 200 232 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mFe)
      ])) : o(i) === "duotone" ? (s(), r("g", MFe, [
        e("polyline", {
          points: "24 72 76 200 128 72 180 200 232 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vFe),
        e("line", {
          x1: "16",
          y1: "136",
          x2: "240",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SFe)
      ])) : o(i) === "fill" ? (s(), r("g", HFe, VFe)) : o(i) === "light" ? (s(), r("g", zFe, [
        e("line", {
          x1: "16",
          y1: "136",
          x2: "240",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZFe),
        e("polyline", {
          points: "24 72 76 200 128 72 180 200 232 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, CFe)
      ])) : o(i) === "thin" ? (s(), r("g", bFe, [
        e("line", {
          x1: "16",
          y1: "136",
          x2: "240",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LFe),
        e("polyline", {
          points: "24 72 76 200 128 72 180 200 232 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, BFe)
      ])) : o(i) === "regular" ? (s(), r("g", PFe, [
        e("polyline", {
          points: "24 72 76 200 128 72 180 200 232 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WFe),
        e("line", {
          x1: "16",
          y1: "136",
          x2: "240",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NFe)
      ])) : g("", !0)
    ], 16, gFe));
  }
}), TFe = ["width", "height", "fill", "transform"], DFe = { key: 0 }, RFe = ["stroke"], UFe = ["stroke"], qFe = ["stroke"], GFe = { key: 1 }, EFe = ["stroke"], OFe = ["stroke"], IFe = ["stroke"], KFe = { key: 2 }, XFe = /* @__PURE__ */ e("path", { d: "M208,96a8,8,0,0,1-8,8H136V216a8,8,0,0,1-16,0V104H56a8,8,0,0,1,0-16H200A8,8,0,0,1,208,96ZM56,64H200a8,8,0,0,0,0-16H56a8,8,0,0,0,0,16Z" }, null, -1), JFe = [
  XFe
], QFe = { key: 3 }, YFe = ["stroke"], oTe = ["stroke"], eTe = ["stroke"], tTe = { key: 4 }, nTe = ["stroke"], sTe = ["stroke"], rTe = ["stroke"], iTe = { key: 5 }, lTe = ["stroke"], dTe = ["stroke"], kTe = ["stroke"], cTe = {
  name: "PhCurrencyKzt"
}, bG1 = /* @__PURE__ */ $({
  ...cTe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", DFe, [
        e("line", {
          x1: "56",
          y1: "100",
          x2: "200",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RFe),
        e("line", {
          x1: "56",
          y1: "52",
          x2: "200",
          y2: "52",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, UFe),
        e("line", {
          x1: "128",
          y1: "100",
          x2: "128",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qFe)
      ])) : o(i) === "duotone" ? (s(), r("g", GFe, [
        e("line", {
          x1: "56",
          y1: "96",
          x2: "200",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EFe),
        e("line", {
          x1: "56",
          y1: "56",
          x2: "200",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OFe),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IFe)
      ])) : o(i) === "fill" ? (s(), r("g", KFe, JFe)) : o(i) === "light" ? (s(), r("g", QFe, [
        e("line", {
          x1: "56",
          y1: "96",
          x2: "200",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YFe),
        e("line", {
          x1: "56",
          y1: "56",
          x2: "200",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oTe),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eTe)
      ])) : o(i) === "thin" ? (s(), r("g", tTe, [
        e("line", {
          x1: "56",
          y1: "96",
          x2: "200",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nTe),
        e("line", {
          x1: "56",
          y1: "56",
          x2: "200",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sTe),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rTe)
      ])) : o(i) === "regular" ? (s(), r("g", iTe, [
        e("line", {
          x1: "56",
          y1: "96",
          x2: "200",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lTe),
        e("line", {
          x1: "56",
          y1: "56",
          x2: "200",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dTe),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kTe)
      ])) : g("", !0)
    ], 16, TFe));
  }
}), hTe = ["width", "height", "fill", "transform"], uTe = { key: 0 }, aTe = ["stroke"], _Te = ["stroke"], pTe = { key: 1 }, yTe = ["stroke"], $Te = ["stroke"], wTe = ["stroke"], fTe = { key: 2 }, gTe = /* @__PURE__ */ e("path", { d: "M216,136H200V120h16a8,8,0,0,0,0-16H200V46a8,8,0,0,0-16,0v58H119.4L70.3,41.1A8,8,0,0,0,56,46v58H40a8,8,0,0,0,0,16H56v16H40a8,8,0,0,0,0,16H56v58a8,8,0,0,0,16,0V152h64.6l49.1,62.9a8.1,8.1,0,0,0,8.9,2.7A8.1,8.1,0,0,0,200,210V152h16a8,8,0,0,0,0-16Zm-32-16v16H144.4l-12.5-16ZM72,69.3,99.1,104H72ZM72,136V120h39.6l12.5,16Zm112,50.7L156.9,152H184Z" }, null, -1), xTe = [
  gTe
], jTe = { key: 3 }, mTe = ["stroke"], MTe = ["stroke"], vTe = ["stroke"], STe = { key: 4 }, HTe = ["stroke"], ATe = ["stroke"], VTe = ["stroke"], zTe = { key: 5 }, ZTe = ["stroke"], CTe = ["stroke"], bTe = ["stroke"], LTe = {
  name: "PhCurrencyNgn"
}, LG1 = /* @__PURE__ */ $({
  ...LTe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", uTe, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aTe),
        e("polyline", {
          points: "64 210 64 46 192 210 192 46",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Te)
      ])) : o(i) === "duotone" ? (s(), r("g", pTe, [
        e("line", {
          x1: "40",
          y1: "144",
          x2: "216",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yTe),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Te),
        e("polyline", {
          points: "64 210 64 46 192 210 192 46",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wTe)
      ])) : o(i) === "fill" ? (s(), r("g", fTe, xTe)) : o(i) === "light" ? (s(), r("g", jTe, [
        e("line", {
          x1: "40",
          y1: "144",
          x2: "216",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mTe),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, MTe),
        e("polyline", {
          points: "64 210 64 46 192 210 192 46",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vTe)
      ])) : o(i) === "thin" ? (s(), r("g", STe, [
        e("line", {
          x1: "40",
          y1: "144",
          x2: "216",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HTe),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ATe),
        e("polyline", {
          points: "64 210 64 46 192 210 192 46",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VTe)
      ])) : o(i) === "regular" ? (s(), r("g", zTe, [
        e("line", {
          x1: "40",
          y1: "144",
          x2: "216",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZTe),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CTe),
        e("polyline", {
          points: "64 210 64 46 192 210 192 46",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bTe)
      ])) : g("", !0)
    ], 16, hTe));
  }
}), BTe = ["width", "height", "fill", "transform"], PTe = { key: 0 }, WTe = ["stroke"], NTe = ["stroke"], FTe = { key: 1 }, TTe = ["stroke"], DTe = ["stroke"], RTe = { key: 2 }, UTe = /* @__PURE__ */ e("path", { d: "M148,152a60,60,0,0,0,0-120H88a8,8,0,0,0-8,8v96H56a8,8,0,0,0,0,16H80v16H56a8,8,0,0,0,0,16H80v32a8,8,0,0,0,16,0V184h48a8,8,0,0,0,0-16H96V152ZM96,48h52a44,44,0,0,1,0,88H96Z" }, null, -1), qTe = [
  UTe
], GTe = { key: 3 }, ETe = ["stroke"], OTe = ["stroke"], ITe = { key: 4 }, KTe = ["stroke"], XTe = ["stroke"], JTe = { key: 5 }, QTe = ["stroke"], YTe = ["stroke"], oDe = {
  name: "PhCurrencyRub"
}, BG1 = /* @__PURE__ */ $({
  ...oDe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", PTe, [
        e("line", {
          x1: "56",
          y1: "184",
          x2: "144",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WTe),
        e("path", {
          d: "M88,216V40h60a52,52,0,0,1,0,104H56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NTe)
      ])) : o(i) === "duotone" ? (s(), r("g", FTe, [
        e("line", {
          x1: "56",
          y1: "176",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TTe),
        e("path", {
          d: "M88,216V40h60a52,52,0,0,1,0,104H56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DTe)
      ])) : o(i) === "fill" ? (s(), r("g", RTe, qTe)) : o(i) === "light" ? (s(), r("g", GTe, [
        e("line", {
          x1: "56",
          y1: "176",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ETe),
        e("path", {
          d: "M88,216V40h60a52,52,0,0,1,0,104H56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OTe)
      ])) : o(i) === "thin" ? (s(), r("g", ITe, [
        e("line", {
          x1: "56",
          y1: "176",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KTe),
        e("path", {
          d: "M88,216V40h60a52,52,0,0,1,0,104H56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XTe)
      ])) : o(i) === "regular" ? (s(), r("g", JTe, [
        e("line", {
          x1: "56",
          y1: "176",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QTe),
        e("path", {
          d: "M88,216V40h60a52,52,0,0,1,0,104H56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YTe)
      ])) : g("", !0)
    ], 16, BTe));
  }
}), eDe = ["width", "height", "fill", "transform"], tDe = { key: 0 }, nDe = ["stroke"], sDe = ["stroke"], rDe = { key: 1 }, iDe = /* @__PURE__ */ e("path", {
  d: "M38.2,48.5,96.4,203.7a8,8,0,0,0,15-.1l23.3-64.1a8.1,8.1,0,0,1,4.8-4.8l64.1-23.3a8,8,0,0,0,.1-15L48.5,38.2A8,8,0,0,0,38.2,48.5Z",
  opacity: "0.2"
}, null, -1), lDe = ["stroke"], dDe = ["stroke"], kDe = { key: 2 }, cDe = /* @__PURE__ */ e("path", { d: "M150.5,139.2l55.9-20.3a16,16,0,0,0,.1-30L51.3,30.7A16,16,0,0,0,30.7,51.3h0L88.9,206.5a15.9,15.9,0,0,0,15,10.4h.1a15.9,15.9,0,0,0,14.9-10.5l20.3-55.9,63.1,63.2A8.5,8.5,0,0,0,208,216a8.3,8.3,0,0,0,5.7-2.3,8.1,8.1,0,0,0,0-11.4Z" }, null, -1), hDe = [
  cDe
], uDe = { key: 3 }, aDe = ["stroke"], _De = ["stroke"], pDe = { key: 4 }, yDe = ["stroke"], $De = ["stroke"], wDe = { key: 5 }, fDe = ["stroke"], gDe = ["stroke"], xDe = {
  name: "PhCursor"
}, PG1 = /* @__PURE__ */ $({
  ...xDe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", tDe, [
        e("path", {
          d: "M38.2,48.5,96.4,203.7a8,8,0,0,0,15-.1l23.3-64.1a8.1,8.1,0,0,1,4.8-4.8l64.1-23.3a8,8,0,0,0,.1-15L48.5,38.2A8,8,0,0,0,38.2,48.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nDe),
        e("line", {
          x1: "136.6",
          y1: "136.6",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sDe)
      ])) : o(i) === "duotone" ? (s(), r("g", rDe, [
        iDe,
        e("path", {
          d: "M38.2,48.5,96.4,203.7a8,8,0,0,0,15-.1l23.3-64.1a8.1,8.1,0,0,1,4.8-4.8l64.1-23.3a8,8,0,0,0,.1-15L48.5,38.2A8,8,0,0,0,38.2,48.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lDe),
        e("line", {
          x1: "136.6",
          y1: "136.6",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dDe)
      ])) : o(i) === "fill" ? (s(), r("g", kDe, hDe)) : o(i) === "light" ? (s(), r("g", uDe, [
        e("path", {
          d: "M38.2,48.5,96.4,203.7a8,8,0,0,0,15-.1l23.3-64.1a8.1,8.1,0,0,1,4.8-4.8l64.1-23.3a8,8,0,0,0,.1-15L48.5,38.2A8,8,0,0,0,38.2,48.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aDe),
        e("line", {
          x1: "136.6",
          y1: "136.6",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _De)
      ])) : o(i) === "thin" ? (s(), r("g", pDe, [
        e("path", {
          d: "M38.2,48.5,96.4,203.7a8,8,0,0,0,15-.1l23.3-64.1a8.1,8.1,0,0,1,4.8-4.8l64.1-23.3a8,8,0,0,0,.1-15L48.5,38.2A8,8,0,0,0,38.2,48.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yDe),
        e("line", {
          x1: "136.6",
          y1: "136.6",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $De)
      ])) : o(i) === "regular" ? (s(), r("g", wDe, [
        e("path", {
          d: "M38.2,48.5,96.4,203.7a8,8,0,0,0,15-.1l23.3-64.1a8.1,8.1,0,0,1,4.8-4.8l64.1-23.3a8,8,0,0,0,.1-15L48.5,38.2A8,8,0,0,0,38.2,48.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fDe),
        e("line", {
          x1: "136.6",
          y1: "136.6",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gDe)
      ])) : g("", !0)
    ], 16, eDe));
  }
}), jDe = ["width", "height", "fill", "transform"], mDe = { key: 0 }, MDe = ["stroke"], vDe = ["stroke"], SDe = ["stroke"], HDe = { key: 1 }, ADe = ["stroke"], VDe = ["stroke"], zDe = ["stroke"], ZDe = { key: 2 }, CDe = /* @__PURE__ */ e("path", { d: "M184,208a8,8,0,0,1-8,8H160a40,40,0,0,1-32-16,40,40,0,0,1-32,16H80a8,8,0,0,1,0-16H96a24.1,24.1,0,0,0,24-24V136H104a8,8,0,0,1,0-16h16V80A24.1,24.1,0,0,0,96,56H80a8,8,0,0,1,0-16H96a40,40,0,0,1,32,16,40,40,0,0,1,32-16h16a8,8,0,0,1,0,16H160a24.1,24.1,0,0,0-24,24v40h16a8,8,0,0,1,0,16H136v40a24.1,24.1,0,0,0,24,24h16A8,8,0,0,1,184,208Z" }, null, -1), bDe = [
  CDe
], LDe = { key: 3 }, BDe = ["stroke"], PDe = ["stroke"], WDe = ["stroke"], NDe = { key: 4 }, FDe = ["stroke"], TDe = ["stroke"], DDe = ["stroke"], RDe = { key: 5 }, UDe = ["stroke"], qDe = ["stroke"], GDe = ["stroke"], EDe = {
  name: "PhCursorText"
}, WG1 = /* @__PURE__ */ $({
  ...EDe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", mDe, [
        e("path", {
          d: "M176,208H160a32,32,0,0,1-32-32V80a32,32,0,0,1,32-32h16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MDe),
        e("path", {
          d: "M80,208H96a32,32,0,0,0,32-32V80A32,32,0,0,0,96,48H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vDe),
        e("line", {
          x1: "104",
          y1: "128",
          x2: "152",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SDe)
      ])) : o(i) === "duotone" ? (s(), r("g", HDe, [
        e("path", {
          d: "M176,208H160a32,32,0,0,1-32-32V80a32,32,0,0,1,32-32h16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ADe),
        e("path", {
          d: "M80,208H96a32,32,0,0,0,32-32V80A32,32,0,0,0,96,48H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VDe),
        e("line", {
          x1: "104",
          y1: "128",
          x2: "152",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zDe)
      ])) : o(i) === "fill" ? (s(), r("g", ZDe, bDe)) : o(i) === "light" ? (s(), r("g", LDe, [
        e("path", {
          d: "M176,208H160a32,32,0,0,1-32-32V80a32,32,0,0,1,32-32h16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BDe),
        e("path", {
          d: "M80,208H96a32,32,0,0,0,32-32V80A32,32,0,0,0,96,48H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PDe),
        e("line", {
          x1: "104",
          y1: "128",
          x2: "152",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WDe)
      ])) : o(i) === "thin" ? (s(), r("g", NDe, [
        e("path", {
          d: "M176,208H160a32,32,0,0,1-32-32V80a32,32,0,0,1,32-32h16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FDe),
        e("path", {
          d: "M80,208H96a32,32,0,0,0,32-32V80A32,32,0,0,0,96,48H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, TDe),
        e("line", {
          x1: "104",
          y1: "128",
          x2: "152",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, DDe)
      ])) : o(i) === "regular" ? (s(), r("g", RDe, [
        e("path", {
          d: "M176,208H160a32,32,0,0,1-32-32V80a32,32,0,0,1,32-32h16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UDe),
        e("path", {
          d: "M80,208H96a32,32,0,0,0,32-32V80A32,32,0,0,0,96,48H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qDe),
        e("line", {
          x1: "104",
          y1: "128",
          x2: "152",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GDe)
      ])) : g("", !0)
    ], 16, jDe));
  }
}), ODe = ["width", "height", "fill", "transform"], IDe = { key: 0 }, KDe = ["stroke"], XDe = ["stroke"], JDe = { key: 1 }, QDe = /* @__PURE__ */ e("ellipse", {
  cx: "128",
  cy: "58",
  rx: "64",
  ry: "34",
  opacity: "0.2"
}, null, -1), YDe = ["stroke"], oRe = ["stroke"], eRe = { key: 2 }, tRe = /* @__PURE__ */ e("path", { d: "M128,16C87.6,16,56,34.4,56,58V198c0,23.6,31.6,42,72,42s72-18.4,72-42V58C200,34.4,168.4,16,128,16Zm0,208c-33,0-56-13.7-56-26V84.7c13.1,9.4,33.1,15.3,56,15.3s42.9-5.9,56-15.3V198C184,210.3,161,224,128,224Z" }, null, -1), nRe = [
  tRe
], sRe = { key: 3 }, rRe = ["stroke"], iRe = ["stroke"], lRe = { key: 4 }, dRe = ["stroke"], kRe = ["stroke"], cRe = { key: 5 }, hRe = ["stroke"], uRe = ["stroke"], aRe = {
  name: "PhCylinder"
}, NG1 = /* @__PURE__ */ $({
  ...aRe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", IDe, [
        e("ellipse", {
          cx: "128",
          cy: "58",
          rx: "64",
          ry: "34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KDe),
        e("path", {
          d: "M64,58V198c0,18.8,28.7,34,64,34s64-15.2,64-34V58",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XDe)
      ])) : o(i) === "duotone" ? (s(), r("g", JDe, [
        QDe,
        e("ellipse", {
          cx: "128",
          cy: "58",
          rx: "64",
          ry: "34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YDe),
        e("path", {
          d: "M64,58V198c0,18.8,28.7,34,64,34s64-15.2,64-34V58",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oRe)
      ])) : o(i) === "fill" ? (s(), r("g", eRe, nRe)) : o(i) === "light" ? (s(), r("g", sRe, [
        e("ellipse", {
          cx: "128",
          cy: "58",
          rx: "64",
          ry: "34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rRe),
        e("path", {
          d: "M64,58V198c0,18.8,28.7,34,64,34s64-15.2,64-34V58",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iRe)
      ])) : o(i) === "thin" ? (s(), r("g", lRe, [
        e("ellipse", {
          cx: "128",
          cy: "58",
          rx: "64",
          ry: "34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dRe),
        e("path", {
          d: "M64,58V198c0,18.8,28.7,34,64,34s64-15.2,64-34V58",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kRe)
      ])) : o(i) === "regular" ? (s(), r("g", cRe, [
        e("ellipse", {
          cx: "128",
          cy: "58",
          rx: "64",
          ry: "34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hRe),
        e("path", {
          d: "M64,58V198c0,18.8,28.7,34,64,34s64-15.2,64-34V58",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uRe)
      ])) : g("", !0)
    ], 16, ODe));
  }
}), _Re = ["width", "height", "fill", "transform"], pRe = { key: 0 }, yRe = ["stroke"], $Re = ["stroke"], wRe = ["stroke"], fRe = { key: 1 }, gRe = /* @__PURE__ */ e("ellipse", {
  cx: "128",
  cy: "80",
  rx: "88",
  ry: "48",
  opacity: "0.2"
}, null, -1), xRe = ["stroke"], jRe = ["stroke"], mRe = ["stroke"], MRe = { key: 2 }, vRe = /* @__PURE__ */ e("path", { d: "M128,24C74.2,24,32,48.6,32,80v96c0,31.4,42.2,56,96,56s96-24.6,96-56V80C224,48.6,181.8,24,128,24Zm80,104c0,9.6-7.9,19.4-21.6,26.9C170.9,163.4,150.2,168,128,168s-42.9-4.6-58.4-13.1C55.9,147.4,48,137.6,48,128V111.4C65.1,126.3,94.2,136,128,136s62.9-9.7,80-24.6Zm-21.6,74.9C170.9,211.4,150.2,216,128,216s-42.9-4.6-58.4-13.1C55.9,195.4,48,185.6,48,176V159.4C65.1,174.3,94.2,184,128,184s62.9-9.7,80-24.6V176C208,185.6,200.1,195.4,186.4,202.9Z" }, null, -1), SRe = [
  vRe
], HRe = { key: 3 }, ARe = ["stroke"], VRe = ["stroke"], zRe = ["stroke"], ZRe = { key: 4 }, CRe = ["stroke"], bRe = ["stroke"], LRe = ["stroke"], BRe = { key: 5 }, PRe = ["stroke"], WRe = ["stroke"], NRe = ["stroke"], FRe = {
  name: "PhDatabase"
}, FG1 = /* @__PURE__ */ $({
  ...FRe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", pRe, [
        e("ellipse", {
          cx: "128",
          cy: "80",
          rx: "88",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yRe),
        e("path", {
          d: "M40,80v48c0,26.5,39.4,48,88,48s88-21.5,88-48V80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $Re),
        e("path", {
          d: "M40,128v48c0,26.5,39.4,48,88,48s88-21.5,88-48V128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wRe)
      ])) : o(i) === "duotone" ? (s(), r("g", fRe, [
        gRe,
        e("ellipse", {
          cx: "128",
          cy: "80",
          rx: "88",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xRe),
        e("path", {
          d: "M40,80v48c0,26.5,39.4,48,88,48s88-21.5,88-48V80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jRe),
        e("path", {
          d: "M40,128v48c0,26.5,39.4,48,88,48s88-21.5,88-48V128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mRe)
      ])) : o(i) === "fill" ? (s(), r("g", MRe, SRe)) : o(i) === "light" ? (s(), r("g", HRe, [
        e("ellipse", {
          cx: "128",
          cy: "80",
          rx: "88",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ARe),
        e("path", {
          d: "M40,80v48c0,26.5,39.4,48,88,48s88-21.5,88-48V80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VRe),
        e("path", {
          d: "M40,128v48c0,26.5,39.4,48,88,48s88-21.5,88-48V128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zRe)
      ])) : o(i) === "thin" ? (s(), r("g", ZRe, [
        e("ellipse", {
          cx: "128",
          cy: "80",
          rx: "88",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CRe),
        e("path", {
          d: "M40,80v48c0,26.5,39.4,48,88,48s88-21.5,88-48V80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bRe),
        e("path", {
          d: "M40,128v48c0,26.5,39.4,48,88,48s88-21.5,88-48V128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LRe)
      ])) : o(i) === "regular" ? (s(), r("g", BRe, [
        e("ellipse", {
          cx: "128",
          cy: "80",
          rx: "88",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PRe),
        e("path", {
          d: "M40,80v48c0,26.5,39.4,48,88,48s88-21.5,88-48V80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WRe),
        e("path", {
          d: "M40,128v48c0,26.5,39.4,48,88,48s88-21.5,88-48V128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NRe)
      ])) : g("", !0)
    ], 16, _Re));
  }
}), TRe = ["width", "height", "fill", "transform"], DRe = { key: 0 }, RRe = ["stroke"], URe = ["stroke"], qRe = ["stroke"], GRe = ["stroke"], ERe = { key: 1 }, ORe = /* @__PURE__ */ e("path", {
  d: "M32,152V64A16,16,0,0,1,48,48H208a16,16,0,0,1,16,16v88Z",
  opacity: "0.2"
}, null, -1), IRe = ["stroke"], KRe = ["stroke"], XRe = ["stroke"], JRe = ["stroke"], QRe = { key: 2 }, YRe = /* @__PURE__ */ e("path", { d: "M208,40H48A24.1,24.1,0,0,0,24,64V176a24.1,24.1,0,0,0,24,24h72v16H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V200h72a24.1,24.1,0,0,0,24-24V64A24.1,24.1,0,0,0,208,40Zm0,144H48a8,8,0,0,1-8-8V160H216v16A8,8,0,0,1,208,184Z" }, null, -1), oUe = [
  YRe
], eUe = { key: 3 }, tUe = ["stroke"], nUe = ["stroke"], sUe = ["stroke"], rUe = ["stroke"], iUe = { key: 4 }, lUe = ["stroke"], dUe = ["stroke"], kUe = ["stroke"], cUe = ["stroke"], hUe = { key: 5 }, uUe = ["stroke"], aUe = ["stroke"], _Ue = ["stroke"], pUe = ["stroke"], yUe = {
  name: "PhDesktop"
}, TG1 = /* @__PURE__ */ $({
  ...yUe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", DRe, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "140",
          rx: "16",
          transform: "translate(256 236) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RRe),
        e("line", {
          x1: "160",
          y1: "224",
          x2: "96",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, URe),
        e("line", {
          x1: "32",
          y1: "148",
          x2: "224",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qRe),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GRe)
      ])) : o(i) === "duotone" ? (s(), r("g", ERe, [
        ORe,
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "144",
          rx: "16",
          transform: "translate(256 240) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IRe),
        e("line", {
          x1: "160",
          y1: "224",
          x2: "96",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KRe),
        e("line", {
          x1: "32",
          y1: "152",
          x2: "224",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XRe),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JRe)
      ])) : o(i) === "fill" ? (s(), r("g", QRe, oUe)) : o(i) === "light" ? (s(), r("g", eUe, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "144",
          rx: "16",
          transform: "translate(256 240) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tUe),
        e("line", {
          x1: "160",
          y1: "224",
          x2: "96",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nUe),
        e("line", {
          x1: "32",
          y1: "152",
          x2: "224",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sUe),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rUe)
      ])) : o(i) === "thin" ? (s(), r("g", iUe, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "144",
          rx: "16",
          transform: "translate(256 240) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lUe),
        e("line", {
          x1: "160",
          y1: "224",
          x2: "96",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dUe),
        e("line", {
          x1: "32",
          y1: "152",
          x2: "224",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kUe),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cUe)
      ])) : o(i) === "regular" ? (s(), r("g", hUe, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "144",
          rx: "16",
          transform: "translate(256 240) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uUe),
        e("line", {
          x1: "160",
          y1: "224",
          x2: "96",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aUe),
        e("line", {
          x1: "32",
          y1: "152",
          x2: "224",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Ue),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pUe)
      ])) : g("", !0)
    ], 16, TRe));
  }
}), $Ue = ["width", "height", "fill", "transform"], wUe = { key: 0 }, fUe = ["stroke"], gUe = ["stroke"], xUe = ["stroke"], jUe = ["stroke"], mUe = ["stroke"], MUe = ["stroke"], vUe = /* @__PURE__ */ e("circle", {
  cx: "192",
  cy: "176",
  r: "16"
}, null, -1), SUe = { key: 1 }, HUe = /* @__PURE__ */ e("rect", {
  x: "144",
  y: "40",
  width: "96",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), AUe = ["stroke"], VUe = ["stroke"], zUe = ["stroke"], ZUe = ["stroke"], CUe = ["stroke"], bUe = ["stroke"], LUe = /* @__PURE__ */ e("circle", {
  cx: "192",
  cy: "180",
  r: "12"
}, null, -1), BUe = { key: 2 }, PUe = /* @__PURE__ */ e("path", { d: "M120,80V184a8,8,0,0,1-8,8H96v16h16a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16H80V192H32A24.1,24.1,0,0,1,8,168V96A24.1,24.1,0,0,1,32,72h80A8,8,0,0,1,120,80ZM248,48V208a16,16,0,0,1-16,16H152a16,16,0,0,1-16-16V48a16,16,0,0,1,16-16h80A16,16,0,0,1,248,48ZM204,180a12,12,0,1,0-12,12A12,12,0,0,0,204,180Zm20-76a8,8,0,0,0-8-8H168a8,8,0,0,0,0,16h48A8,8,0,0,0,224,104Zm0-32a8,8,0,0,0-8-8H168a8,8,0,0,0,0,16h48A8,8,0,0,0,224,72Z" }, null, -1), WUe = [
  PUe
], NUe = { key: 3 }, FUe = ["stroke"], TUe = ["stroke"], DUe = ["stroke"], RUe = ["stroke"], UUe = ["stroke"], qUe = ["stroke"], GUe = /* @__PURE__ */ e("circle", {
  cx: "192",
  cy: "180",
  r: "10"
}, null, -1), EUe = { key: 4 }, OUe = ["stroke"], IUe = ["stroke"], KUe = ["stroke"], XUe = ["stroke"], JUe = ["stroke"], QUe = ["stroke"], YUe = /* @__PURE__ */ e("circle", {
  cx: "192",
  cy: "180",
  r: "8"
}, null, -1), oqe = { key: 5 }, eqe = ["stroke"], tqe = ["stroke"], nqe = ["stroke"], sqe = ["stroke"], rqe = ["stroke"], iqe = ["stroke"], lqe = /* @__PURE__ */ e("circle", {
  cx: "192",
  cy: "180",
  r: "12"
}, null, -1), dqe = {
  name: "PhDesktopTower"
}, DG1 = /* @__PURE__ */ $({
  ...dqe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", wUe, [
        e("path", {
          d: "M108,180H32a16,16,0,0,1-16-16V96A16,16,0,0,1,32,80h76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fUe),
        e("line", {
          x1: "108",
          y1: "216",
          x2: "68",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gUe),
        e("line", {
          x1: "204",
          y1: "76",
          x2: "180",
          y2: "76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xUe),
        e("line", {
          x1: "204",
          y1: "112",
          x2: "180",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jUe),
        e("rect", {
          x: "144",
          y: "40",
          width: "96",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mUe),
        e("line", {
          x1: "88",
          y1: "180",
          x2: "88",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MUe),
        vUe
      ])) : o(i) === "duotone" ? (s(), r("g", SUe, [
        HUe,
        e("path", {
          d: "M112,184H32a16,16,0,0,1-16-16V96A16,16,0,0,1,32,80h80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AUe),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "64",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VUe),
        e("line", {
          x1: "208",
          y1: "72",
          x2: "176",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zUe),
        e("line", {
          x1: "208",
          y1: "104",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZUe),
        e("rect", {
          x: "144",
          y: "40",
          width: "96",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CUe),
        e("line", {
          x1: "88",
          y1: "184",
          x2: "88",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bUe),
        LUe
      ])) : o(i) === "fill" ? (s(), r("g", BUe, WUe)) : o(i) === "light" ? (s(), r("g", NUe, [
        e("path", {
          d: "M112,184H32a16,16,0,0,1-16-16V96A16,16,0,0,1,32,80h80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FUe),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "64",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TUe),
        e("line", {
          x1: "208",
          y1: "72",
          x2: "176",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DUe),
        e("line", {
          x1: "208",
          y1: "104",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RUe),
        e("rect", {
          x: "144",
          y: "40",
          width: "96",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UUe),
        e("line", {
          x1: "88",
          y1: "184",
          x2: "88",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qUe),
        GUe
      ])) : o(i) === "thin" ? (s(), r("g", EUe, [
        e("path", {
          d: "M112,184H32a16,16,0,0,1-16-16V96A16,16,0,0,1,32,80h80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OUe),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "64",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, IUe),
        e("line", {
          x1: "208",
          y1: "72",
          x2: "176",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KUe),
        e("line", {
          x1: "208",
          y1: "104",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XUe),
        e("rect", {
          x: "144",
          y: "40",
          width: "96",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, JUe),
        e("line", {
          x1: "88",
          y1: "184",
          x2: "88",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QUe),
        YUe
      ])) : o(i) === "regular" ? (s(), r("g", oqe, [
        e("path", {
          d: "M112,184H32a16,16,0,0,1-16-16V96A16,16,0,0,1,32,80h80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eqe),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "64",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tqe),
        e("line", {
          x1: "208",
          y1: "72",
          x2: "176",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nqe),
        e("line", {
          x1: "208",
          y1: "104",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sqe),
        e("rect", {
          x: "144",
          y: "40",
          width: "96",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rqe),
        e("line", {
          x1: "88",
          y1: "184",
          x2: "88",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iqe),
        lqe
      ])) : g("", !0)
    ], 16, $Ue));
  }
}), kqe = ["width", "height", "fill", "transform"], cqe = { key: 0 }, hqe = ["stroke"], uqe = ["stroke"], aqe = ["stroke"], _qe = ["stroke"], pqe = ["stroke"], yqe = { key: 1 }, $qe = /* @__PURE__ */ e("circle", {
  cx: "76",
  cy: "180",
  r: "28",
  opacity: "0.2"
}, null, -1), wqe = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "180",
  r: "28",
  opacity: "0.2"
}, null, -1), fqe = /* @__PURE__ */ e("path", {
  d: "M40,120,89.3,49.6a8,8,0,0,1,13.2.1L121.3,78a8,8,0,0,0,13.4,0l18.8-28.3a8,8,0,0,1,13.2-.1L216,120Z",
  opacity: "0.2"
}, null, -1), gqe = ["stroke"], xqe = ["stroke"], jqe = ["stroke"], mqe = ["stroke"], Mqe = ["stroke"], vqe = { key: 2 }, Sqe = /* @__PURE__ */ e("path", { d: "M216,180a36,36,0,0,1-71.1,8H111.1a36,36,0,1,1,0-16h33.8a36,36,0,0,1,71.1,8Zm32-68H220.2L173.3,45a16.1,16.1,0,0,0-26.5.3L128,73.6,109.2,45.3A16.1,16.1,0,0,0,82.7,45L35.8,112H8a8,8,0,0,0,0,16H248a8,8,0,0,0,0-16Z" }, null, -1), Hqe = [
  Sqe
], Aqe = { key: 3 }, Vqe = ["stroke"], zqe = ["stroke"], Zqe = ["stroke"], Cqe = ["stroke"], bqe = ["stroke"], Lqe = { key: 4 }, Bqe = ["stroke"], Pqe = ["stroke"], Wqe = ["stroke"], Nqe = ["stroke"], Fqe = ["stroke"], Tqe = { key: 5 }, Dqe = ["stroke"], Rqe = ["stroke"], Uqe = ["stroke"], qqe = ["stroke"], Gqe = ["stroke"], Eqe = {
  name: "PhDetective"
}, RG1 = /* @__PURE__ */ $({
  ...Eqe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", cqe, [
        e("circle", {
          cx: "74",
          cy: "182",
          r: "26",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hqe),
        e("circle", {
          cx: "182",
          cy: "182",
          r: "26",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uqe),
        e("line", {
          x1: "100",
          y1: "182",
          x2: "156",
          y2: "182",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aqe),
        e("line", {
          x1: "12",
          y1: "120",
          x2: "244",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _qe),
        e("path", {
          d: "M40,120,89.3,49.6a8,8,0,0,1,13.2.1L121.3,78a8,8,0,0,0,13.4,0l18.8-28.3a8,8,0,0,1,13.2-.1L216,120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pqe)
      ])) : o(i) === "duotone" ? (s(), r("g", yqe, [
        $qe,
        wqe,
        fqe,
        e("circle", {
          cx: "76",
          cy: "180",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gqe),
        e("circle", {
          cx: "180",
          cy: "180",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xqe),
        e("line", {
          x1: "104",
          y1: "180",
          x2: "152",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jqe),
        e("line", {
          x1: "8",
          y1: "120",
          x2: "248",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mqe),
        e("path", {
          d: "M40,120,89.3,49.6a8,8,0,0,1,13.2.1L121.3,78a8,8,0,0,0,13.4,0l18.8-28.3a8,8,0,0,1,13.2-.1L216,120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mqe)
      ])) : o(i) === "fill" ? (s(), r("g", vqe, Hqe)) : o(i) === "light" ? (s(), r("g", Aqe, [
        e("circle", {
          cx: "76",
          cy: "180",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vqe),
        e("circle", {
          cx: "180",
          cy: "180",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zqe),
        e("line", {
          x1: "104",
          y1: "180",
          x2: "152",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zqe),
        e("line", {
          x1: "8",
          y1: "120",
          x2: "248",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cqe),
        e("path", {
          d: "M40,120,89.3,49.6a8,8,0,0,1,13.2.1L121.3,78a8,8,0,0,0,13.4,0l18.8-28.3a8,8,0,0,1,13.2-.1L216,120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bqe)
      ])) : o(i) === "thin" ? (s(), r("g", Lqe, [
        e("circle", {
          cx: "76",
          cy: "180",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bqe),
        e("circle", {
          cx: "180",
          cy: "180",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pqe),
        e("line", {
          x1: "104",
          y1: "180",
          x2: "152",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wqe),
        e("line", {
          x1: "8",
          y1: "120",
          x2: "248",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nqe),
        e("path", {
          d: "M40,120,89.3,49.6a8,8,0,0,1,13.2.1L121.3,78a8,8,0,0,0,13.4,0l18.8-28.3a8,8,0,0,1,13.2-.1L216,120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fqe)
      ])) : o(i) === "regular" ? (s(), r("g", Tqe, [
        e("circle", {
          cx: "76",
          cy: "180",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dqe),
        e("circle", {
          cx: "180",
          cy: "180",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rqe),
        e("line", {
          x1: "104",
          y1: "180",
          x2: "152",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uqe),
        e("line", {
          x1: "8",
          y1: "120",
          x2: "248",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qqe),
        e("path", {
          d: "M40,120,89.3,49.6a8,8,0,0,1,13.2.1L121.3,78a8,8,0,0,0,13.4,0l18.8-28.3a8,8,0,0,1,13.2-.1L216,120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gqe)
      ])) : g("", !0)
    ], 16, kqe));
  }
}), Oqe = ["width", "height", "fill", "transform"], Iqe = { key: 0 }, Kqe = ["stroke"], Xqe = ["stroke"], Jqe = ["stroke"], Qqe = { key: 1 }, Yqe = /* @__PURE__ */ e("rect", {
  x: "64",
  y: "56",
  width: "128",
  height: "144",
  opacity: "0.2"
}, null, -1), oGe = ["stroke"], eGe = ["stroke"], tGe = ["stroke"], nGe = { key: 2 }, sGe = /* @__PURE__ */ e("path", { d: "M176,16H80A24.1,24.1,0,0,0,56,40V216a24.1,24.1,0,0,0,24,24h96a24.1,24.1,0,0,0,24-24V40A24.1,24.1,0,0,0,176,16ZM80,32h96a8,8,0,0,1,8,8v8H72V40A8,8,0,0,1,80,32Zm96,192H80a8,8,0,0,1-8-8v-8H184v8A8,8,0,0,1,176,224Z" }, null, -1), rGe = [
  sGe
], iGe = { key: 3 }, lGe = ["stroke"], dGe = ["stroke"], kGe = ["stroke"], cGe = { key: 4 }, hGe = ["stroke"], uGe = ["stroke"], aGe = ["stroke"], _Ge = { key: 5 }, pGe = ["stroke"], yGe = ["stroke"], $Ge = ["stroke"], wGe = {
  name: "PhDeviceMobile"
}, UG1 = /* @__PURE__ */ $({
  ...wGe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Iqe, [
        e("rect", {
          x: "64",
          y: "24",
          width: "128",
          height: "208",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kqe),
        e("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xqe),
        e("line", {
          x1: "64",
          y1: "192",
          x2: "192",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jqe)
      ])) : o(i) === "duotone" ? (s(), r("g", Qqe, [
        Yqe,
        e("rect", {
          x: "64",
          y: "24",
          width: "128",
          height: "208",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oGe),
        e("line", {
          x1: "64",
          y1: "56",
          x2: "192",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eGe),
        e("line", {
          x1: "64",
          y1: "200",
          x2: "192",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tGe)
      ])) : o(i) === "fill" ? (s(), r("g", nGe, rGe)) : o(i) === "light" ? (s(), r("g", iGe, [
        e("rect", {
          x: "64",
          y: "24",
          width: "128",
          height: "208",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lGe),
        e("line", {
          x1: "64",
          y1: "56",
          x2: "192",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dGe),
        e("line", {
          x1: "64",
          y1: "200",
          x2: "192",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kGe)
      ])) : o(i) === "thin" ? (s(), r("g", cGe, [
        e("rect", {
          x: "64",
          y: "24",
          width: "128",
          height: "208",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hGe),
        e("line", {
          x1: "64",
          y1: "56",
          x2: "192",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uGe),
        e("line", {
          x1: "64",
          y1: "200",
          x2: "192",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aGe)
      ])) : o(i) === "regular" ? (s(), r("g", _Ge, [
        e("rect", {
          x: "64",
          y: "24",
          width: "128",
          height: "208",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pGe),
        e("line", {
          x1: "64",
          y1: "56",
          x2: "192",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yGe),
        e("line", {
          x1: "64",
          y1: "200",
          x2: "192",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Ge)
      ])) : g("", !0)
    ], 16, Oqe));
  }
}), fGe = ["width", "height", "fill", "transform"], gGe = { key: 0 }, xGe = ["stroke"], jGe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "68",
  r: "16"
}, null, -1), mGe = { key: 1 }, MGe = /* @__PURE__ */ e("rect", {
  x: "24",
  y: "64",
  width: "208",
  height: "128",
  rx: "16",
  transform: "translate(256) rotate(90)",
  opacity: "0.2"
}, null, -1), vGe = ["stroke"], SGe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "60",
  r: "12"
}, null, -1), HGe = { key: 2 }, AGe = /* @__PURE__ */ e("path", { d: "M176,16H80A24.1,24.1,0,0,0,56,40V216a24.1,24.1,0,0,0,24,24h96a24.1,24.1,0,0,0,24-24V40A24.1,24.1,0,0,0,176,16ZM128,72a12,12,0,1,1,12-12A12,12,0,0,1,128,72Z" }, null, -1), VGe = [
  AGe
], zGe = { key: 3 }, ZGe = ["stroke"], CGe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "60",
  r: "10"
}, null, -1), bGe = { key: 4 }, LGe = ["stroke"], BGe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "60",
  r: "8"
}, null, -1), PGe = { key: 5 }, WGe = ["stroke"], NGe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "60",
  r: "12"
}, null, -1), FGe = {
  name: "PhDeviceMobileCamera"
}, qG1 = /* @__PURE__ */ $({
  ...FGe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", gGe, [
        e("rect", {
          x: "24",
          y: "64",
          width: "208",
          height: "128",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xGe),
        jGe
      ])) : o(i) === "duotone" ? (s(), r("g", mGe, [
        MGe,
        e("rect", {
          x: "24",
          y: "64",
          width: "208",
          height: "128",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vGe),
        SGe
      ])) : o(i) === "fill" ? (s(), r("g", HGe, VGe)) : o(i) === "light" ? (s(), r("g", zGe, [
        e("rect", {
          x: "24",
          y: "64",
          width: "208",
          height: "128",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZGe),
        CGe
      ])) : o(i) === "thin" ? (s(), r("g", bGe, [
        e("rect", {
          x: "24",
          y: "64",
          width: "208",
          height: "128",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LGe),
        BGe
      ])) : o(i) === "regular" ? (s(), r("g", PGe, [
        e("rect", {
          x: "24",
          y: "64",
          width: "208",
          height: "128",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WGe),
        NGe
      ])) : g("", !0)
    ], 16, fGe));
  }
}), TGe = ["width", "height", "fill", "transform"], DGe = { key: 0 }, RGe = ["stroke"], UGe = ["stroke"], qGe = { key: 1 }, GGe = /* @__PURE__ */ e("rect", {
  x: "24",
  y: "64",
  width: "208",
  height: "128",
  rx: "16",
  transform: "translate(256) rotate(90)",
  opacity: "0.2"
}, null, -1), EGe = ["stroke"], OGe = ["stroke"], IGe = { key: 2 }, KGe = /* @__PURE__ */ e("path", { d: "M176,16H80A24.1,24.1,0,0,0,56,40V216a24.1,24.1,0,0,0,24,24h96a24.1,24.1,0,0,0,24-24V40A24.1,24.1,0,0,0,176,16ZM160,64H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z" }, null, -1), XGe = [
  KGe
], JGe = { key: 3 }, QGe = ["stroke"], YGe = ["stroke"], oEe = { key: 4 }, eEe = ["stroke"], tEe = ["stroke"], nEe = { key: 5 }, sEe = ["stroke"], rEe = ["stroke"], iEe = {
  name: "PhDeviceMobileSpeaker"
}, GG1 = /* @__PURE__ */ $({
  ...iEe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", DGe, [
        e("rect", {
          x: "24",
          y: "64",
          width: "208",
          height: "128",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RGe),
        e("line", {
          x1: "104",
          y1: "64",
          x2: "152",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, UGe)
      ])) : o(i) === "duotone" ? (s(), r("g", qGe, [
        GGe,
        e("rect", {
          x: "24",
          y: "64",
          width: "208",
          height: "128",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EGe),
        e("line", {
          x1: "96",
          y1: "56",
          x2: "160",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OGe)
      ])) : o(i) === "fill" ? (s(), r("g", IGe, XGe)) : o(i) === "light" ? (s(), r("g", JGe, [
        e("rect", {
          x: "24",
          y: "64",
          width: "208",
          height: "128",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QGe),
        e("line", {
          x1: "96",
          y1: "56",
          x2: "160",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YGe)
      ])) : o(i) === "thin" ? (s(), r("g", oEe, [
        e("rect", {
          x: "24",
          y: "64",
          width: "208",
          height: "128",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eEe),
        e("line", {
          x1: "96",
          y1: "56",
          x2: "160",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tEe)
      ])) : o(i) === "regular" ? (s(), r("g", nEe, [
        e("rect", {
          x: "24",
          y: "64",
          width: "208",
          height: "128",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sEe),
        e("line", {
          x1: "96",
          y1: "56",
          x2: "160",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rEe)
      ])) : g("", !0)
    ], 16, TGe));
  }
}), lEe = ["width", "height", "fill", "transform"], dEe = { key: 0 }, kEe = ["stroke"], cEe = ["stroke"], hEe = ["stroke"], uEe = { key: 1 }, aEe = /* @__PURE__ */ e("rect", {
  x: "48",
  y: "64",
  width: "160",
  height: "128",
  opacity: "0.2"
}, null, -1), _Ee = ["stroke"], pEe = ["stroke"], yEe = ["stroke"], $Ee = { key: 2 }, wEe = /* @__PURE__ */ e("path", { d: "M192,24H64A24.1,24.1,0,0,0,40,48V208a24.1,24.1,0,0,0,24,24H192a24.1,24.1,0,0,0,24-24V48A24.1,24.1,0,0,0,192,24ZM64,40H192a8,8,0,0,1,8,8v8H56V48A8,8,0,0,1,64,40ZM192,216H64a8,8,0,0,1-8-8v-8H200v8A8,8,0,0,1,192,216Z" }, null, -1), fEe = [
  wEe
], gEe = { key: 3 }, xEe = ["stroke"], jEe = ["stroke"], mEe = ["stroke"], MEe = { key: 4 }, vEe = ["stroke"], SEe = ["stroke"], HEe = ["stroke"], AEe = { key: 5 }, VEe = ["stroke"], zEe = ["stroke"], ZEe = ["stroke"], CEe = {
  name: "PhDeviceTablet"
}, EG1 = /* @__PURE__ */ $({
  ...CEe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", dEe, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kEe),
        e("line", {
          x1: "48",
          y1: "72",
          x2: "208",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cEe),
        e("line", {
          x1: "48",
          y1: "184",
          x2: "208",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hEe)
      ])) : o(i) === "duotone" ? (s(), r("g", uEe, [
        aEe,
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Ee),
        e("line", {
          x1: "48",
          y1: "64",
          x2: "208",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pEe),
        e("line", {
          x1: "48",
          y1: "192",
          x2: "208",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yEe)
      ])) : o(i) === "fill" ? (s(), r("g", $Ee, fEe)) : o(i) === "light" ? (s(), r("g", gEe, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xEe),
        e("line", {
          x1: "48",
          y1: "64",
          x2: "208",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jEe),
        e("line", {
          x1: "48",
          y1: "192",
          x2: "208",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mEe)
      ])) : o(i) === "thin" ? (s(), r("g", MEe, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vEe),
        e("line", {
          x1: "48",
          y1: "64",
          x2: "208",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SEe),
        e("line", {
          x1: "48",
          y1: "192",
          x2: "208",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HEe)
      ])) : o(i) === "regular" ? (s(), r("g", AEe, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VEe),
        e("line", {
          x1: "48",
          y1: "64",
          x2: "208",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zEe),
        e("line", {
          x1: "48",
          y1: "192",
          x2: "208",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZEe)
      ])) : g("", !0)
    ], 16, lEe));
  }
}), bEe = ["width", "height", "fill", "transform"], LEe = { key: 0 }, BEe = ["stroke"], PEe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "76",
  r: "16"
}, null, -1), WEe = { key: 1 }, NEe = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "48",
  width: "192",
  height: "160",
  rx: "16",
  transform: "translate(256) rotate(90)",
  opacity: "0.2"
}, null, -1), FEe = ["stroke"], TEe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "68",
  r: "12"
}, null, -1), DEe = { key: 2 }, REe = /* @__PURE__ */ e("path", { d: "M192,24H64A24.1,24.1,0,0,0,40,48V208a24.1,24.1,0,0,0,24,24H192a24.1,24.1,0,0,0,24-24V48A24.1,24.1,0,0,0,192,24ZM128,80a12,12,0,1,1,12-12A12,12,0,0,1,128,80Z" }, null, -1), UEe = [
  REe
], qEe = { key: 3 }, GEe = ["stroke"], EEe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "68",
  r: "10"
}, null, -1), OEe = { key: 4 }, IEe = ["stroke"], KEe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "68",
  r: "8"
}, null, -1), XEe = { key: 5 }, JEe = ["stroke"], QEe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "68",
  r: "12"
}, null, -1), YEe = {
  name: "PhDeviceTabletCamera"
}, OG1 = /* @__PURE__ */ $({
  ...YEe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", LEe, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BEe),
        PEe
      ])) : o(i) === "duotone" ? (s(), r("g", WEe, [
        NEe,
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FEe),
        TEe
      ])) : o(i) === "fill" ? (s(), r("g", DEe, UEe)) : o(i) === "light" ? (s(), r("g", qEe, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GEe),
        EEe
      ])) : o(i) === "thin" ? (s(), r("g", OEe, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, IEe),
        KEe
      ])) : o(i) === "regular" ? (s(), r("g", XEe, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JEe),
        QEe
      ])) : g("", !0)
    ], 16, bEe));
  }
}), oOe = ["width", "height", "fill", "transform"], eOe = { key: 0 }, tOe = ["stroke"], nOe = ["stroke"], sOe = { key: 1 }, rOe = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "48",
  width: "192",
  height: "160",
  rx: "16",
  transform: "translate(256) rotate(90)",
  opacity: "0.2"
}, null, -1), iOe = ["stroke"], lOe = ["stroke"], dOe = { key: 2 }, kOe = /* @__PURE__ */ e("path", { d: "M192,24H64A24.1,24.1,0,0,0,40,48V208a24.1,24.1,0,0,0,24,24H192a24.1,24.1,0,0,0,24-24V48A24.1,24.1,0,0,0,192,24ZM160,72H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z" }, null, -1), cOe = [
  kOe
], hOe = { key: 3 }, uOe = ["stroke"], aOe = ["stroke"], _Oe = { key: 4 }, pOe = ["stroke"], yOe = ["stroke"], $Oe = { key: 5 }, wOe = ["stroke"], fOe = ["stroke"], gOe = {
  name: "PhDeviceTabletSpeaker"
}, IG1 = /* @__PURE__ */ $({
  ...gOe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", eOe, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tOe),
        e("line", {
          x1: "96",
          y1: "72",
          x2: "160",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nOe)
      ])) : o(i) === "duotone" ? (s(), r("g", sOe, [
        rOe,
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iOe),
        e("line", {
          x1: "96",
          y1: "64",
          x2: "160",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lOe)
      ])) : o(i) === "fill" ? (s(), r("g", dOe, cOe)) : o(i) === "light" ? (s(), r("g", hOe, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uOe),
        e("line", {
          x1: "96",
          y1: "64",
          x2: "160",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aOe)
      ])) : o(i) === "thin" ? (s(), r("g", _Oe, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pOe),
        e("line", {
          x1: "96",
          y1: "64",
          x2: "160",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yOe)
      ])) : o(i) === "regular" ? (s(), r("g", $Oe, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wOe),
        e("line", {
          x1: "96",
          y1: "64",
          x2: "160",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fOe)
      ])) : g("", !0)
    ], 16, oOe));
  }
}), xOe = ["width", "height", "fill", "transform"], jOe = { key: 0 }, mOe = ["stroke"], MOe = { key: 1 }, vOe = /* @__PURE__ */ e("rect", {
  x: "51.6",
  y: "51.6",
  width: "152.7",
  height: "152.74",
  rx: "8",
  transform: "translate(-53 128) rotate(-45)",
  opacity: "0.2"
}, null, -1), SOe = ["stroke"], HOe = { key: 2 }, AOe = /* @__PURE__ */ e("path", { d: "M236,139.3,139.3,236a15.9,15.9,0,0,1-22.6,0L20,139.3a16.1,16.1,0,0,1,0-22.6L116.7,20a16.1,16.1,0,0,1,22.6,0L236,116.7A16.1,16.1,0,0,1,236,139.3Z" }, null, -1), VOe = [
  AOe
], zOe = { key: 3 }, ZOe = ["stroke"], COe = { key: 4 }, bOe = ["stroke"], LOe = { key: 5 }, BOe = ["stroke"], POe = {
  name: "PhDiamond"
}, KG1 = /* @__PURE__ */ $({
  ...POe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", jOe, [
        e("rect", {
          x: "51.6",
          y: "51.6",
          width: "152.7",
          height: "152.74",
          rx: "8",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mOe)
      ])) : o(i) === "duotone" ? (s(), r("g", MOe, [
        vOe,
        e("rect", {
          x: "51.6",
          y: "51.6",
          width: "152.7",
          height: "152.74",
          rx: "8",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SOe)
      ])) : o(i) === "fill" ? (s(), r("g", HOe, VOe)) : o(i) === "light" ? (s(), r("g", zOe, [
        e("rect", {
          x: "51.6",
          y: "51.6",
          width: "152.7",
          height: "152.74",
          rx: "8",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZOe)
      ])) : o(i) === "thin" ? (s(), r("g", COe, [
        e("rect", {
          x: "51.6",
          y: "51.6",
          width: "152.7",
          height: "152.74",
          rx: "8",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bOe)
      ])) : o(i) === "regular" ? (s(), r("g", LOe, [
        e("rect", {
          x: "51.6",
          y: "51.6",
          width: "152.7",
          height: "152.74",
          rx: "8",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BOe)
      ])) : g("", !0)
    ], 16, xOe));
  }
}), WOe = ["width", "height", "fill", "transform"], NOe = { key: 0 }, FOe = ["stroke"], TOe = ["stroke"], DOe = ["stroke"], ROe = ["stroke"], UOe = { key: 1 }, qOe = /* @__PURE__ */ e("rect", {
  x: "99.7",
  y: "35.7",
  width: "56.6",
  height: "56.57",
  rx: "8",
  transform: "translate(-7.8 109.3) rotate(-45)",
  opacity: "0.2"
}, null, -1), GOe = /* @__PURE__ */ e("rect", {
  x: "163.7",
  y: "99.7",
  width: "56.6",
  height: "56.57",
  rx: "8",
  transform: "translate(-34.3 173.3) rotate(-45)",
  opacity: "0.2"
}, null, -1), EOe = /* @__PURE__ */ e("rect", {
  x: "35.7",
  y: "99.7",
  width: "56.6",
  height: "56.57",
  rx: "8",
  transform: "translate(-71.8 82.7) rotate(-45)",
  opacity: "0.2"
}, null, -1), OOe = /* @__PURE__ */ e("rect", {
  x: "99.7",
  y: "163.7",
  width: "56.6",
  height: "56.57",
  rx: "8",
  transform: "translate(-98.3 146.7) rotate(-45)",
  opacity: "0.2"
}, null, -1), IOe = ["stroke"], KOe = ["stroke"], XOe = ["stroke"], JOe = ["stroke"], QOe = { key: 2 }, YOe = /* @__PURE__ */ e("path", { d: "M88,75.3a16.1,16.1,0,0,1,0-22.6L116.7,24a15.9,15.9,0,0,1,22.6,0L168,52.7a16.1,16.1,0,0,1,0,22.6L139.3,104a15.9,15.9,0,0,1-22.6,0Zm144,41.4L203.3,88a15.9,15.9,0,0,0-22.6,0L152,116.7a16.1,16.1,0,0,0,0,22.6L180.7,168a15.9,15.9,0,0,0,22.6,0L232,139.3A16.1,16.1,0,0,0,232,116.7Zm-128,0L75.3,88a15.9,15.9,0,0,0-22.6,0L24,116.7a16.1,16.1,0,0,0,0,22.6L52.7,168a15.9,15.9,0,0,0,22.6,0L104,139.3A16.1,16.1,0,0,0,104,116.7ZM139.3,152a15.9,15.9,0,0,0-22.6,0L88,180.7a16.1,16.1,0,0,0,0,22.6L116.7,232a15.9,15.9,0,0,0,22.6,0L168,203.3a16.1,16.1,0,0,0,0-22.6Z" }, null, -1), oIe = [
  YOe
], eIe = { key: 3 }, tIe = ["stroke"], nIe = ["stroke"], sIe = ["stroke"], rIe = ["stroke"], iIe = { key: 4 }, lIe = ["stroke"], dIe = ["stroke"], kIe = ["stroke"], cIe = ["stroke"], hIe = { key: 5 }, uIe = ["stroke"], aIe = ["stroke"], _Ie = ["stroke"], pIe = ["stroke"], yIe = {
  name: "PhDiamondsFour"
}, XG1 = /* @__PURE__ */ $({
  ...yIe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", NOe, [
        e("rect", {
          x: "101.1",
          y: "35.1",
          width: "53.7",
          height: "53.74",
          rx: "8",
          transform: "translate(-6.4 108.7) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FOe),
        e("rect", {
          x: "167.1",
          y: "101.1",
          width: "53.7",
          height: "53.74",
          rx: "8",
          transform: "translate(-33.7 174.7) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TOe),
        e("rect", {
          x: "35.1",
          y: "101.1",
          width: "53.7",
          height: "53.74",
          rx: "8",
          transform: "translate(-72.4 81.3) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DOe),
        e("rect", {
          x: "101.1",
          y: "167.1",
          width: "53.7",
          height: "53.74",
          rx: "8",
          transform: "translate(-99.7 147.3) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ROe)
      ])) : o(i) === "duotone" ? (s(), r("g", UOe, [
        qOe,
        GOe,
        EOe,
        OOe,
        e("rect", {
          x: "99.7",
          y: "35.7",
          width: "56.6",
          height: "56.57",
          rx: "8",
          transform: "translate(-7.8 109.3) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IOe),
        e("rect", {
          x: "163.7",
          y: "99.7",
          width: "56.6",
          height: "56.57",
          rx: "8",
          transform: "translate(-34.3 173.3) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KOe),
        e("rect", {
          x: "35.7",
          y: "99.7",
          width: "56.6",
          height: "56.57",
          rx: "8",
          transform: "translate(-71.8 82.7) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XOe),
        e("rect", {
          x: "99.7",
          y: "163.7",
          width: "56.6",
          height: "56.57",
          rx: "8",
          transform: "translate(-98.3 146.7) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JOe)
      ])) : o(i) === "fill" ? (s(), r("g", QOe, oIe)) : o(i) === "light" ? (s(), r("g", eIe, [
        e("rect", {
          x: "99.7",
          y: "35.7",
          width: "56.6",
          height: "56.57",
          rx: "8",
          transform: "translate(-7.8 109.3) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tIe),
        e("rect", {
          x: "163.7",
          y: "99.7",
          width: "56.6",
          height: "56.57",
          rx: "8",
          transform: "translate(-34.3 173.3) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nIe),
        e("rect", {
          x: "35.7",
          y: "99.7",
          width: "56.6",
          height: "56.57",
          rx: "8",
          transform: "translate(-71.8 82.7) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sIe),
        e("rect", {
          x: "99.7",
          y: "163.7",
          width: "56.6",
          height: "56.57",
          rx: "8",
          transform: "translate(-98.3 146.7) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rIe)
      ])) : o(i) === "thin" ? (s(), r("g", iIe, [
        e("rect", {
          x: "99.7",
          y: "35.7",
          width: "56.6",
          height: "56.57",
          rx: "8",
          transform: "translate(-7.8 109.3) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lIe),
        e("rect", {
          x: "163.7",
          y: "99.7",
          width: "56.6",
          height: "56.57",
          rx: "8",
          transform: "translate(-34.3 173.3) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dIe),
        e("rect", {
          x: "35.7",
          y: "99.7",
          width: "56.6",
          height: "56.57",
          rx: "8",
          transform: "translate(-71.8 82.7) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kIe),
        e("rect", {
          x: "99.7",
          y: "163.7",
          width: "56.6",
          height: "56.57",
          rx: "8",
          transform: "translate(-98.3 146.7) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cIe)
      ])) : o(i) === "regular" ? (s(), r("g", hIe, [
        e("rect", {
          x: "99.7",
          y: "35.7",
          width: "56.6",
          height: "56.57",
          rx: "8",
          transform: "translate(-7.8 109.3) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uIe),
        e("rect", {
          x: "163.7",
          y: "99.7",
          width: "56.6",
          height: "56.57",
          rx: "8",
          transform: "translate(-34.3 173.3) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aIe),
        e("rect", {
          x: "35.7",
          y: "99.7",
          width: "56.6",
          height: "56.57",
          rx: "8",
          transform: "translate(-71.8 82.7) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Ie),
        e("rect", {
          x: "99.7",
          y: "163.7",
          width: "56.6",
          height: "56.57",
          rx: "8",
          transform: "translate(-98.3 146.7) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pIe)
      ])) : g("", !0)
    ], 16, WOe));
  }
}), $Ie = ["width", "height", "fill", "transform"], wIe = { key: 0 }, fIe = ["stroke"], gIe = /* @__PURE__ */ j('<circle cx="88" cy="88" r="16"></circle><circle cx="128" cy="128" r="16"></circle><circle cx="168" cy="88" r="16"></circle><circle cx="88" cy="168" r="16"></circle><circle cx="168" cy="168" r="16"></circle>', 5), xIe = { key: 1 }, jIe = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "24",
  opacity: "0.2"
}, null, -1), mIe = ["stroke"], MIe = /* @__PURE__ */ j('<circle cx="92" cy="92" r="12"></circle><circle cx="164" cy="92" r="12"></circle><circle cx="92" cy="164" r="12"></circle><circle cx="128" cy="128" r="12"></circle><circle cx="164" cy="164" r="12"></circle>', 5), vIe = { key: 2 }, SIe = /* @__PURE__ */ e("path", { d: "M192,32H64A32.1,32.1,0,0,0,32,64V192a32.1,32.1,0,0,0,32,32H192a32.1,32.1,0,0,0,32-32V64A32.1,32.1,0,0,0,192,32ZM92,176a12,12,0,1,1,12-12A12,12,0,0,1,92,176Zm0-72a12,12,0,1,1,12-12A12,12,0,0,1,92,104Zm36,36a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm36,36a12,12,0,1,1,12-12A12,12,0,0,1,164,176Zm0-72a12,12,0,1,1,12-12A12,12,0,0,1,164,104Z" }, null, -1), HIe = [
  SIe
], AIe = { key: 3 }, VIe = ["stroke"], zIe = /* @__PURE__ */ j('<circle cx="92" cy="92" r="10"></circle><circle cx="128" cy="128" r="10"></circle><circle cx="164" cy="92" r="10"></circle><circle cx="92" cy="164" r="10"></circle><circle cx="164" cy="164" r="10"></circle>', 5), ZIe = { key: 4 }, CIe = ["stroke"], bIe = /* @__PURE__ */ j('<circle cx="92" cy="92" r="8"></circle><circle cx="128" cy="128" r="8"></circle><circle cx="164" cy="92" r="8"></circle><circle cx="92" cy="164" r="8"></circle><circle cx="164" cy="164" r="8"></circle>', 5), LIe = { key: 5 }, BIe = ["stroke"], PIe = /* @__PURE__ */ j('<circle cx="92" cy="92" r="12"></circle><circle cx="164" cy="92" r="12"></circle><circle cx="92" cy="164" r="12"></circle><circle cx="128" cy="128" r="12"></circle><circle cx="164" cy="164" r="12"></circle>', 5), WIe = {
  name: "PhDiceFive"
}, JG1 = /* @__PURE__ */ $({
  ...WIe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", wIe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fIe),
        gIe
      ])) : o(i) === "duotone" ? (s(), r("g", xIe, [
        jIe,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mIe),
        MIe
      ])) : o(i) === "fill" ? (s(), r("g", vIe, HIe)) : o(i) === "light" ? (s(), r("g", AIe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VIe),
        zIe
      ])) : o(i) === "thin" ? (s(), r("g", ZIe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CIe),
        bIe
      ])) : o(i) === "regular" ? (s(), r("g", LIe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BIe),
        PIe
      ])) : g("", !0)
    ], 16, $Ie));
  }
}), NIe = ["width", "height", "fill", "transform"], FIe = { key: 0 }, TIe = ["stroke"], DIe = /* @__PURE__ */ e("circle", {
  cx: "96",
  cy: "96",
  r: "16"
}, null, -1), RIe = /* @__PURE__ */ e("circle", {
  cx: "160",
  cy: "96",
  r: "16"
}, null, -1), UIe = /* @__PURE__ */ e("circle", {
  cx: "96",
  cy: "160",
  r: "16"
}, null, -1), qIe = /* @__PURE__ */ e("circle", {
  cx: "160",
  cy: "160",
  r: "16"
}, null, -1), GIe = { key: 1 }, EIe = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "24",
  opacity: "0.2"
}, null, -1), OIe = ["stroke"], IIe = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "100",
  r: "12"
}, null, -1), KIe = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "100",
  r: "12"
}, null, -1), XIe = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "156",
  r: "12"
}, null, -1), JIe = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "156",
  r: "12"
}, null, -1), QIe = { key: 2 }, YIe = /* @__PURE__ */ e("path", { d: "M192,32H64A32.1,32.1,0,0,0,32,64V192a32.1,32.1,0,0,0,32,32H192a32.1,32.1,0,0,0,32-32V64A32.1,32.1,0,0,0,192,32ZM100,168a12,12,0,1,1,12-12A12,12,0,0,1,100,168Zm0-56a12,12,0,1,1,12-12A12,12,0,0,1,100,112Zm56,56a12,12,0,1,1,12-12A12,12,0,0,1,156,168Zm0-56a12,12,0,1,1,12-12A12,12,0,0,1,156,112Z" }, null, -1), oKe = [
  YIe
], eKe = { key: 3 }, tKe = ["stroke"], nKe = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "100",
  r: "10"
}, null, -1), sKe = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "100",
  r: "10"
}, null, -1), rKe = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "156",
  r: "10"
}, null, -1), iKe = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "156",
  r: "10"
}, null, -1), lKe = { key: 4 }, dKe = ["stroke"], kKe = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "100",
  r: "8"
}, null, -1), cKe = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "100",
  r: "8"
}, null, -1), hKe = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "156",
  r: "8"
}, null, -1), uKe = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "156",
  r: "8"
}, null, -1), aKe = { key: 5 }, _Ke = ["stroke"], pKe = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "100",
  r: "12"
}, null, -1), yKe = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "100",
  r: "12"
}, null, -1), $Ke = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "156",
  r: "12"
}, null, -1), wKe = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "156",
  r: "12"
}, null, -1), fKe = {
  name: "PhDiceFour"
}, QG1 = /* @__PURE__ */ $({
  ...fKe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", FIe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TIe),
        DIe,
        RIe,
        UIe,
        qIe
      ])) : o(i) === "duotone" ? (s(), r("g", GIe, [
        EIe,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OIe),
        IIe,
        KIe,
        XIe,
        JIe
      ])) : o(i) === "fill" ? (s(), r("g", QIe, oKe)) : o(i) === "light" ? (s(), r("g", eKe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tKe),
        nKe,
        sKe,
        rKe,
        iKe
      ])) : o(i) === "thin" ? (s(), r("g", lKe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dKe),
        kKe,
        cKe,
        hKe,
        uKe
      ])) : o(i) === "regular" ? (s(), r("g", aKe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Ke),
        pKe,
        yKe,
        $Ke,
        wKe
      ])) : g("", !0)
    ], 16, NIe));
  }
}), gKe = ["width", "height", "fill", "transform"], xKe = { key: 0 }, jKe = ["stroke"], mKe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "16"
}, null, -1), MKe = { key: 1 }, vKe = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "24",
  opacity: "0.2"
}, null, -1), SKe = ["stroke"], HKe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), AKe = { key: 2 }, VKe = /* @__PURE__ */ e("path", { d: "M192,32H64A32.1,32.1,0,0,0,32,64V192a32.1,32.1,0,0,0,32,32H192a32.1,32.1,0,0,0,32-32V64A32.1,32.1,0,0,0,192,32ZM128,140a12,12,0,1,1,12-12A12,12,0,0,1,128,140Z" }, null, -1), zKe = [
  VKe
], ZKe = { key: 3 }, CKe = ["stroke"], bKe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "10"
}, null, -1), LKe = { key: 4 }, BKe = ["stroke"], PKe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "8"
}, null, -1), WKe = { key: 5 }, NKe = ["stroke"], FKe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), TKe = {
  name: "PhDiceOne"
}, YG1 = /* @__PURE__ */ $({
  ...TKe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xKe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jKe),
        mKe
      ])) : o(i) === "duotone" ? (s(), r("g", MKe, [
        vKe,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SKe),
        HKe
      ])) : o(i) === "fill" ? (s(), r("g", AKe, zKe)) : o(i) === "light" ? (s(), r("g", ZKe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, CKe),
        bKe
      ])) : o(i) === "thin" ? (s(), r("g", LKe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, BKe),
        PKe
      ])) : o(i) === "regular" ? (s(), r("g", WKe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NKe),
        FKe
      ])) : g("", !0)
    ], 16, gKe));
  }
}), DKe = ["width", "height", "fill", "transform"], RKe = { key: 0 }, UKe = ["stroke"], qKe = /* @__PURE__ */ j('<circle cx="96" cy="84" r="16"></circle><circle cx="160" cy="84" r="16"></circle><circle cx="96" cy="128" r="16"></circle><circle cx="160" cy="128" r="16"></circle><circle cx="96" cy="172" r="16"></circle><circle cx="160" cy="172" r="16"></circle>', 6), GKe = { key: 1 }, EKe = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "24",
  opacity: "0.2"
}, null, -1), OKe = ["stroke"], IKe = /* @__PURE__ */ j('<circle cx="92" cy="84" r="12"></circle><circle cx="164" cy="84" r="12"></circle><circle cx="92" cy="128" r="12"></circle><circle cx="164" cy="128" r="12"></circle><circle cx="92" cy="172" r="12"></circle><circle cx="164" cy="172" r="12"></circle>', 6), KKe = { key: 2 }, XKe = /* @__PURE__ */ e("path", { d: "M192,32H64A32.1,32.1,0,0,0,32,64V192a32.1,32.1,0,0,0,32,32H192a32.1,32.1,0,0,0,32-32V64A32.1,32.1,0,0,0,192,32ZM92,184a12,12,0,1,1,12-12A12,12,0,0,1,92,184Zm0-44a12,12,0,1,1,12-12A12,12,0,0,1,92,140Zm0-44a12,12,0,1,1,12-12A12,12,0,0,1,92,96Zm72,88a12,12,0,1,1,12-12A12,12,0,0,1,164,184Zm0-44a12,12,0,1,1,12-12A12,12,0,0,1,164,140Zm0-44a12,12,0,1,1,12-12A12,12,0,0,1,164,96Z" }, null, -1), JKe = [
  XKe
], QKe = { key: 3 }, YKe = ["stroke"], oXe = /* @__PURE__ */ j('<circle cx="92" cy="84" r="10"></circle><circle cx="164" cy="84" r="10"></circle><circle cx="92" cy="128" r="10"></circle><circle cx="164" cy="128" r="10"></circle><circle cx="92" cy="172" r="10"></circle><circle cx="164" cy="172" r="10"></circle>', 6), eXe = { key: 4 }, tXe = ["stroke"], nXe = /* @__PURE__ */ j('<circle cx="92" cy="84" r="8"></circle><circle cx="164" cy="84" r="8"></circle><circle cx="92" cy="128" r="8"></circle><circle cx="164" cy="128" r="8"></circle><circle cx="92" cy="172" r="8"></circle><circle cx="164" cy="172" r="8"></circle>', 6), sXe = { key: 5 }, rXe = ["stroke"], iXe = /* @__PURE__ */ j('<circle cx="92" cy="84" r="12"></circle><circle cx="164" cy="84" r="12"></circle><circle cx="92" cy="128" r="12"></circle><circle cx="164" cy="128" r="12"></circle><circle cx="92" cy="172" r="12"></circle><circle cx="164" cy="172" r="12"></circle>', 6), lXe = {
  name: "PhDiceSix"
}, oE1 = /* @__PURE__ */ $({
  ...lXe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", RKe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, UKe),
        qKe
      ])) : o(i) === "duotone" ? (s(), r("g", GKe, [
        EKe,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OKe),
        IKe
      ])) : o(i) === "fill" ? (s(), r("g", KKe, JKe)) : o(i) === "light" ? (s(), r("g", QKe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YKe),
        oXe
      ])) : o(i) === "thin" ? (s(), r("g", eXe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tXe),
        nXe
      ])) : o(i) === "regular" ? (s(), r("g", sXe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rXe),
        iXe
      ])) : g("", !0)
    ], 16, DKe));
  }
}), dXe = ["width", "height", "fill", "transform"], kXe = { key: 0 }, cXe = ["stroke"], hXe = /* @__PURE__ */ e("circle", {
  cx: "88",
  cy: "88",
  r: "16"
}, null, -1), uXe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "16"
}, null, -1), aXe = /* @__PURE__ */ e("circle", {
  cx: "168",
  cy: "168",
  r: "16"
}, null, -1), _Xe = { key: 1 }, pXe = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "24",
  opacity: "0.2"
}, null, -1), yXe = ["stroke"], $Xe = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "92",
  r: "12"
}, null, -1), wXe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), fXe = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "164",
  r: "12"
}, null, -1), gXe = { key: 2 }, xXe = /* @__PURE__ */ e("path", { d: "M192,32H64A32.1,32.1,0,0,0,32,64V192a32.1,32.1,0,0,0,32,32H192a32.1,32.1,0,0,0,32-32V64A32.1,32.1,0,0,0,192,32ZM92,104a12,12,0,1,1,12-12A12,12,0,0,1,92,104Zm36,36a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm36,36a12,12,0,1,1,12-12A12,12,0,0,1,164,176Z" }, null, -1), jXe = [
  xXe
], mXe = { key: 3 }, MXe = ["stroke"], vXe = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "92",
  r: "10"
}, null, -1), SXe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "10"
}, null, -1), HXe = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "164",
  r: "10"
}, null, -1), AXe = { key: 4 }, VXe = ["stroke"], zXe = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "92",
  r: "8"
}, null, -1), ZXe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "8"
}, null, -1), CXe = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "164",
  r: "8"
}, null, -1), bXe = { key: 5 }, LXe = ["stroke"], BXe = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "92",
  r: "12"
}, null, -1), PXe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), WXe = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "164",
  r: "12"
}, null, -1), NXe = {
  name: "PhDiceThree"
}, eE1 = /* @__PURE__ */ $({
  ...NXe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", kXe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cXe),
        hXe,
        uXe,
        aXe
      ])) : o(i) === "duotone" ? (s(), r("g", _Xe, [
        pXe,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yXe),
        $Xe,
        wXe,
        fXe
      ])) : o(i) === "fill" ? (s(), r("g", gXe, jXe)) : o(i) === "light" ? (s(), r("g", mXe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, MXe),
        vXe,
        SXe,
        HXe
      ])) : o(i) === "thin" ? (s(), r("g", AXe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VXe),
        zXe,
        ZXe,
        CXe
      ])) : o(i) === "regular" ? (s(), r("g", bXe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LXe),
        BXe,
        PXe,
        WXe
      ])) : g("", !0)
    ], 16, dXe));
  }
}), FXe = ["width", "height", "fill", "transform"], TXe = { key: 0 }, DXe = ["stroke"], RXe = /* @__PURE__ */ e("circle", {
  cx: "104",
  cy: "104",
  r: "16"
}, null, -1), UXe = /* @__PURE__ */ e("circle", {
  cx: "152",
  cy: "152",
  r: "16"
}, null, -1), qXe = { key: 1 }, GXe = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "24",
  opacity: "0.2"
}, null, -1), EXe = ["stroke"], OXe = /* @__PURE__ */ e("circle", {
  cx: "108",
  cy: "108",
  r: "12"
}, null, -1), IXe = /* @__PURE__ */ e("circle", {
  cx: "148",
  cy: "148",
  r: "12"
}, null, -1), KXe = { key: 2 }, XXe = /* @__PURE__ */ e("path", { d: "M192,32H64A32.1,32.1,0,0,0,32,64V192a32.1,32.1,0,0,0,32,32H192a32.1,32.1,0,0,0,32-32V64A32.1,32.1,0,0,0,192,32Zm-84,88a12,12,0,1,1,12-12A12,12,0,0,1,108,120Zm40,40a12,12,0,1,1,12-12A12,12,0,0,1,148,160Z" }, null, -1), JXe = [
  XXe
], QXe = { key: 3 }, YXe = ["stroke"], oJe = /* @__PURE__ */ e("circle", {
  cx: "108",
  cy: "108",
  r: "10"
}, null, -1), eJe = /* @__PURE__ */ e("circle", {
  cx: "148",
  cy: "148",
  r: "10"
}, null, -1), tJe = { key: 4 }, nJe = ["stroke"], sJe = /* @__PURE__ */ e("circle", {
  cx: "108",
  cy: "108",
  r: "8"
}, null, -1), rJe = /* @__PURE__ */ e("circle", {
  cx: "148",
  cy: "148",
  r: "8"
}, null, -1), iJe = { key: 5 }, lJe = ["stroke"], dJe = /* @__PURE__ */ e("circle", {
  cx: "108",
  cy: "108",
  r: "12"
}, null, -1), kJe = /* @__PURE__ */ e("circle", {
  cx: "148",
  cy: "148",
  r: "12"
}, null, -1), cJe = {
  name: "PhDiceTwo"
}, tE1 = /* @__PURE__ */ $({
  ...cJe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", TXe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DXe),
        RXe,
        UXe
      ])) : o(i) === "duotone" ? (s(), r("g", qXe, [
        GXe,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EXe),
        OXe,
        IXe
      ])) : o(i) === "fill" ? (s(), r("g", KXe, JXe)) : o(i) === "light" ? (s(), r("g", QXe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YXe),
        oJe,
        eJe
      ])) : o(i) === "thin" ? (s(), r("g", tJe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nJe),
        sJe,
        rJe
      ])) : o(i) === "regular" ? (s(), r("g", iJe, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lJe),
        dJe,
        kJe
      ])) : g("", !0)
    ], 16, FXe));
  }
}), hJe = ["width", "height", "fill", "transform"], uJe = { key: 0 }, aJe = ["stroke"], _Je = ["stroke"], pJe = ["stroke"], yJe = ["stroke"], $Je = { key: 1 }, wJe = /* @__PURE__ */ e("path", {
  d: "M160,128a32.1,32.1,0,1,1-9.4-22.6h0l45.3-45.3h0A96,96,0,1,0,224,128Z",
  opacity: "0.2"
}, null, -1), fJe = ["stroke"], gJe = ["stroke"], xJe = ["stroke"], jJe = ["stroke"], mJe = { key: 2 }, MJe = /* @__PURE__ */ e("path", { d: "M188.3,43.3l-.6-.5-.8-.4A102.9,102.9,0,0,0,128,24a104.1,104.1,0,1,0,60.3,19.3ZM128,152a24,24,0,1,1,24-24A24.1,24.1,0,0,1,128,152Zm88-24c0,2.5-.1,4.9-.3,7.3L168,126.9a39.8,39.8,0,0,0-11-26.4l27.8-39.7A87.9,87.9,0,0,1,216,128Z" }, null, -1), vJe = [
  MJe
], SJe = { key: 3 }, HJe = ["stroke"], AJe = ["stroke"], VJe = ["stroke"], zJe = ["stroke"], ZJe = { key: 4 }, CJe = ["stroke"], bJe = ["stroke"], LJe = ["stroke"], BJe = ["stroke"], PJe = { key: 5 }, WJe = ["stroke"], NJe = ["stroke"], FJe = ["stroke"], TJe = ["stroke"], DJe = {
  name: "PhDisc"
}, nE1 = /* @__PURE__ */ $({
  ...DJe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", uJe, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aJe),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Je),
        e("line", {
          x1: "224",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pJe),
        e("line", {
          x1: "195.9",
          y1: "60.1",
          x2: "150.6",
          y2: "105.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yJe)
      ])) : o(i) === "duotone" ? (s(), r("g", $Je, [
        wJe,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fJe),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gJe),
        e("line", {
          x1: "224",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xJe),
        e("line", {
          x1: "195.9",
          y1: "60.1",
          x2: "150.6",
          y2: "105.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jJe)
      ])) : o(i) === "fill" ? (s(), r("g", mJe, vJe)) : o(i) === "light" ? (s(), r("g", SJe, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HJe),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, AJe),
        e("line", {
          x1: "224",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VJe),
        e("line", {
          x1: "195.9",
          y1: "60.1",
          x2: "150.6",
          y2: "105.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zJe)
      ])) : o(i) === "thin" ? (s(), r("g", ZJe, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CJe),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bJe),
        e("line", {
          x1: "224",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LJe),
        e("line", {
          x1: "195.9",
          y1: "60.1",
          x2: "150.6",
          y2: "105.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, BJe)
      ])) : o(i) === "regular" ? (s(), r("g", PJe, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WJe),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NJe),
        e("line", {
          x1: "224",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FJe),
        e("line", {
          x1: "195.9",
          y1: "60.1",
          x2: "150.6",
          y2: "105.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TJe)
      ])) : g("", !0)
    ], 16, hJe));
  }
}), RJe = ["width", "height", "fill", "transform"], UJe = { key: 0 }, qJe = /* @__PURE__ */ e("circle", {
  cx: "96",
  cy: "132",
  r: "16"
}, null, -1), GJe = /* @__PURE__ */ e("circle", {
  cx: "160",
  cy: "132",
  r: "16"
}, null, -1), EJe = ["stroke"], OJe = ["stroke"], IJe = ["stroke"], KJe = ["stroke"], XJe = { key: 1 }, JJe = /* @__PURE__ */ e("path", {
  d: "M101,182.1l-12.1,24a7.8,7.8,0,0,1-9,4.2c-24.5-6-45.7-16.4-61.1-29.8a8.1,8.1,0,0,1-2.4-8.4L50.3,58.9A7.7,7.7,0,0,1,55,53.8a176.4,176.4,0,0,1,29.6-9.2A8.1,8.1,0,0,1,94,49.9l7.9,23.9h0a190.1,190.1,0,0,1,52.2,0h0L162,49.9a8.1,8.1,0,0,1,9.4-5.3A176.4,176.4,0,0,1,201,53.8a7.7,7.7,0,0,1,4.7,5.1l33.9,113.2a8.1,8.1,0,0,1-2.4,8.4c-15.4,13.4-36.6,23.8-61.1,29.8a7.8,7.8,0,0,1-9-4.2l-12.1-24a195,195,0,0,1-27,1.9,195,195,0,0,1-27-1.9Z",
  opacity: "0.2"
}, null, -1), QJe = /* @__PURE__ */ e("circle", {
  cx: "96",
  cy: "144",
  r: "12"
}, null, -1), YJe = /* @__PURE__ */ e("circle", {
  cx: "160",
  cy: "144",
  r: "12"
}, null, -1), oQe = ["stroke"], eQe = ["stroke"], tQe = ["stroke"], nQe = ["stroke"], sQe = { key: 2 }, rQe = /* @__PURE__ */ e("path", { d: "M247.3,169.8l-34-113.2a15.6,15.6,0,0,0-9.2-10.2h-.6l.6-.2A192.4,192.4,0,0,0,169.6,36a8,8,0,0,0-9.4,6.3,7.9,7.9,0,0,0,6.2,9.4c4.5.9,8.9,2,13.2,3.2A8,8,0,0,1,176,70h-.8A185.4,185.4,0,0,0,128,64a181.8,181.8,0,0,0-46.1,5.8,8,8,0,0,1-5.6-14.9h.1c4.3-1.2,8.7-2.3,13.2-3.2a8,8,0,0,0,6.3-9.4A8.1,8.1,0,0,0,86.5,36,191.2,191.2,0,0,0,51.9,46.4a15.6,15.6,0,0,0-9.2,10.2L8.7,169.8a16,16,0,0,0,4.9,16.7,34.7,34.7,0,0,0,2.9,2.5h.1c16.2,13.2,37.5,23.3,61.5,29.1a6.3,6.3,0,0,0,1.9.3,8,8,0,0,0,1.9-15.8,160.3,160.3,0,0,1-31.3-11.1h0a8,8,0,0,1,8.6-13.2c19,8.4,42.9,13.7,68.8,13.7s49.8-5.3,68.8-13.7a8,8,0,0,1,8.6,13.2h0a160.3,160.3,0,0,1-31.3,11.1,8,8,0,0,0,1.9,15.8,6.3,6.3,0,0,0,1.9-.3c24-5.8,45.3-15.9,61.5-29.1h.1a34.7,34.7,0,0,0,2.9-2.5A16,16,0,0,0,247.3,169.8ZM96,156a12,12,0,1,1,12-12A12,12,0,0,1,96,156Zm64,0a12,12,0,1,1,12-12A12,12,0,0,1,160,156Z" }, null, -1), iQe = [
  rQe
], lQe = { key: 3 }, dQe = /* @__PURE__ */ e("circle", {
  cx: "96",
  cy: "144",
  r: "10"
}, null, -1), kQe = /* @__PURE__ */ e("circle", {
  cx: "160",
  cy: "144",
  r: "10"
}, null, -1), cQe = ["stroke"], hQe = ["stroke"], uQe = ["stroke"], aQe = ["stroke"], _Qe = { key: 4 }, pQe = /* @__PURE__ */ e("circle", {
  cx: "96",
  cy: "144",
  r: "8"
}, null, -1), yQe = /* @__PURE__ */ e("circle", {
  cx: "160",
  cy: "144",
  r: "8"
}, null, -1), $Qe = ["stroke"], wQe = ["stroke"], fQe = ["stroke"], gQe = ["stroke"], xQe = { key: 5 }, jQe = /* @__PURE__ */ e("circle", {
  cx: "96",
  cy: "144",
  r: "12"
}, null, -1), mQe = /* @__PURE__ */ e("circle", {
  cx: "160",
  cy: "144",
  r: "12"
}, null, -1), MQe = ["stroke"], vQe = ["stroke"], SQe = ["stroke"], HQe = ["stroke"], AQe = /* @__PURE__ */ e("circle", {
  cx: "96",
  cy: "144",
  r: "12"
}, null, -1), VQe = /* @__PURE__ */ e("circle", {
  cx: "160",
  cy: "144",
  r: "12"
}, null, -1), zQe = ["stroke"], ZQe = ["stroke"], CQe = ["stroke"], bQe = ["stroke"], LQe = {
  name: "PhDiscordLogo"
}, sE1 = /* @__PURE__ */ $({
  ...LQe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", UJe, [
        qJe,
        GJe,
        e("path", {
          d: "M151.3,174.6l15.8,31.5a7.8,7.8,0,0,0,9,4.2c24.5-6,45.7-16.4,61.1-29.8a8.1,8.1,0,0,0,2.4-8.4L205.7,58.9a7.7,7.7,0,0,0-4.7-5.1,176.4,176.4,0,0,0-29.6-9.2,8.1,8.1,0,0,0-9.4,5.3L151.5,81.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, EJe),
        e("path", {
          d: "M104.7,174.6,88.9,206.1a7.8,7.8,0,0,1-9,4.2c-24.5-6-45.7-16.4-61.1-29.8a8.1,8.1,0,0,1-2.4-8.4L50.3,58.9A7.7,7.7,0,0,1,55,53.8a176.4,176.4,0,0,1,29.6-9.2A8.1,8.1,0,0,1,94,49.9l10.5,31.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OJe),
        e("path", {
          d: "M181.1,168c-15.2,5.1-33.5,8-53.1,8s-37.9-2.9-53.1-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IJe),
        e("path", {
          d: "M176,86.4A173.7,173.7,0,0,0,128,80a173.7,173.7,0,0,0-48,6.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KJe)
      ])) : o(i) === "duotone" ? (s(), r("g", XJe, [
        JJe,
        QJe,
        YJe,
        e("path", {
          d: "M74.4,80A174.9,174.9,0,0,1,128,72a174.9,174.9,0,0,1,53.6,8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oQe),
        e("path", {
          d: "M181.6,176a174.9,174.9,0,0,1-53.6,8,174.9,174.9,0,0,1-53.6-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eQe),
        e("path", {
          d: "M155,182.1l12.1,24a7.8,7.8,0,0,0,9,4.2c24.5-6,45.7-16.4,61.1-29.8a8.1,8.1,0,0,0,2.4-8.4L205.7,58.9a7.7,7.7,0,0,0-4.7-5.1,176.4,176.4,0,0,0-29.6-9.2,8.1,8.1,0,0,0-9.4,5.3l-7.9,23.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tQe),
        e("path", {
          d: "M101,182.1l-12.1,24a7.8,7.8,0,0,1-9,4.2c-24.5-6-45.7-16.4-61.1-29.8a8.1,8.1,0,0,1-2.4-8.4L50.3,58.9A7.7,7.7,0,0,1,55,53.8a176.4,176.4,0,0,1,29.6-9.2A8.1,8.1,0,0,1,94,49.9l7.9,23.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nQe)
      ])) : o(i) === "fill" ? (s(), r("g", sQe, iQe)) : o(i) === "light" ? (s(), r("g", lQe, [
        dQe,
        kQe,
        e("path", {
          d: "M74.4,80A174.9,174.9,0,0,1,128,72a174.9,174.9,0,0,1,53.6,8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cQe),
        e("path", {
          d: "M181.6,176a174.9,174.9,0,0,1-53.6,8,174.9,174.9,0,0,1-53.6-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hQe),
        e("path", {
          d: "M155,182.1l12.1,24a7.8,7.8,0,0,0,9,4.2c24.5-6,45.7-16.4,61.1-29.8a8.1,8.1,0,0,0,2.4-8.4L205.7,58.9a7.7,7.7,0,0,0-4.7-5.1,176.4,176.4,0,0,0-29.6-9.2,8.1,8.1,0,0,0-9.4,5.3l-7.9,23.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uQe),
        e("path", {
          d: "M101,182.1l-12.1,24a7.8,7.8,0,0,1-9,4.2c-24.5-6-45.7-16.4-61.1-29.8a8.1,8.1,0,0,1-2.4-8.4L50.3,58.9A7.7,7.7,0,0,1,55,53.8a176.4,176.4,0,0,1,29.6-9.2A8.1,8.1,0,0,1,94,49.9l7.9,23.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aQe)
      ])) : o(i) === "thin" ? (s(), r("g", _Qe, [
        pQe,
        yQe,
        e("path", {
          d: "M74.4,80A174.9,174.9,0,0,1,128,72a174.9,174.9,0,0,1,53.6,8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $Qe),
        e("path", {
          d: "M181.6,176a174.9,174.9,0,0,1-53.6,8,174.9,174.9,0,0,1-53.6-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wQe),
        e("path", {
          d: "M155,182.1l12.1,24a7.8,7.8,0,0,0,9,4.2c24.5-6,45.7-16.4,61.1-29.8a8.1,8.1,0,0,0,2.4-8.4L205.7,58.9a7.7,7.7,0,0,0-4.7-5.1,176.4,176.4,0,0,0-29.6-9.2,8.1,8.1,0,0,0-9.4,5.3l-7.9,23.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fQe),
        e("path", {
          d: "M101,182.1l-12.1,24a7.8,7.8,0,0,1-9,4.2c-24.5-6-45.7-16.4-61.1-29.8a8.1,8.1,0,0,1-2.4-8.4L50.3,58.9A7.7,7.7,0,0,1,55,53.8a176.4,176.4,0,0,1,29.6-9.2A8.1,8.1,0,0,1,94,49.9l7.9,23.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gQe)
      ])) : o(i) === "regular" ? (s(), r("g", xQe, [
        jQe,
        mQe,
        e("path", {
          d: "M74.4,80A174.9,174.9,0,0,1,128,72a174.9,174.9,0,0,1,53.6,8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MQe),
        e("path", {
          d: "M181.6,176a174.9,174.9,0,0,1-53.6,8,174.9,174.9,0,0,1-53.6-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vQe),
        e("path", {
          d: "M155,182.1l12.1,24a7.8,7.8,0,0,0,9,4.2c24.5-6,45.7-16.4,61.1-29.8a8.1,8.1,0,0,0,2.4-8.4L205.7,58.9a7.7,7.7,0,0,0-4.7-5.1,176.4,176.4,0,0,0-29.6-9.2,8.1,8.1,0,0,0-9.4,5.3l-7.9,23.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SQe),
        e("path", {
          d: "M101,182.1l-12.1,24a7.8,7.8,0,0,1-9,4.2c-24.5-6-45.7-16.4-61.1-29.8a8.1,8.1,0,0,1-2.4-8.4L50.3,58.9A7.7,7.7,0,0,1,55,53.8a176.4,176.4,0,0,1,29.6-9.2A8.1,8.1,0,0,1,94,49.9l7.9,23.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HQe),
        AQe,
        VQe,
        e("path", {
          d: "M74.4,80A174.9,174.9,0,0,1,128,72a174.9,174.9,0,0,1,53.6,8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zQe),
        e("path", {
          d: "M181.6,176a174.9,174.9,0,0,1-53.6,8,174.9,174.9,0,0,1-53.6-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZQe),
        e("path", {
          d: "M155,182.1l12.1,24a7.8,7.8,0,0,0,9,4.2c24.5-6,45.7-16.4,61.1-29.8a8.1,8.1,0,0,0,2.4-8.4L205.7,58.9a7.7,7.7,0,0,0-4.7-5.1,176.4,176.4,0,0,0-29.6-9.2,8.1,8.1,0,0,0-9.4,5.3l-7.9,23.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CQe),
        e("path", {
          d: "M101,182.1l-12.1,24a7.8,7.8,0,0,1-9,4.2c-24.5-6-45.7-16.4-61.1-29.8a8.1,8.1,0,0,1-2.4-8.4L50.3,58.9A7.7,7.7,0,0,1,55,53.8a176.4,176.4,0,0,1,29.6-9.2A8.1,8.1,0,0,1,94,49.9l7.9,23.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bQe)
      ])) : g("", !0)
    ], 16, RJe));
  }
}), BQe = ["width", "height", "fill", "transform"], PQe = { key: 0 }, WQe = ["stroke"], NQe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "64",
  r: "20"
}, null, -1), FQe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "192",
  r: "20"
}, null, -1), TQe = { key: 1 }, DQe = ["stroke"], RQe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "64",
  r: "16"
}, null, -1), UQe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "192",
  r: "16"
}, null, -1), qQe = { key: 2 }, GQe = /* @__PURE__ */ e("path", { d: "M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM128,80a16,16,0,1,0-16-16A16,16,0,0,0,128,80Zm0,96a16,16,0,1,0,16,16A16,16,0,0,0,128,176Z" }, null, -1), EQe = [
  GQe
], OQe = { key: 3 }, IQe = ["stroke"], KQe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "64",
  r: "14"
}, null, -1), XQe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "192",
  r: "14"
}, null, -1), JQe = { key: 4 }, QQe = ["stroke"], YQe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "64",
  r: "12"
}, null, -1), oYe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "192",
  r: "12"
}, null, -1), eYe = { key: 5 }, tYe = ["stroke"], nYe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "64",
  r: "16"
}, null, -1), sYe = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "192",
  r: "16"
}, null, -1), rYe = {
  name: "PhDivide"
}, rE1 = /* @__PURE__ */ $({
  ...rYe,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", PQe, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WQe),
        NQe,
        FQe
      ])) : o(i) === "duotone" ? (s(), r("g", TQe, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DQe),
        RQe,
        UQe
      ])) : o(i) === "fill" ? (s(), r("g", qQe, EQe)) : o(i) === "light" ? (s(), r("g", OQe, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IQe),
        KQe,
        XQe
      ])) : o(i) === "thin" ? (s(), r("g", JQe, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QQe),
        YQe,
        oYe
      ])) : o(i) === "regular" ? (s(), r("g", eYe, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tYe),
        nYe,
        sYe
      ])) : g("", !0)
    ], 16, BQe));
  }
}), iYe = ["width", "height", "fill", "transform"], lYe = { key: 0 }, dYe = ["stroke"], kYe = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "136",
  r: "16"
}, null, -1), cYe = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "136",
  r: "16"
}, null, -1), hYe = ["stroke"], uYe = ["stroke"], aYe = ["stroke"], _Ye = ["stroke"], pYe = ["stroke"], yYe = { key: 1 }, $Ye = /* @__PURE__ */ e("path", {
  d: "M208,119.3V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V119.3L104,48h48Z",
  opacity: "0.2"
}, null, -1), wYe = ["stroke"], fYe = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "140",
  r: "12"
}, null, -1), gYe = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "140",
  r: "12"
}, null, -1), xYe = ["stroke"], jYe = ["stroke"], mYe = ["stroke"], MYe = ["stroke"], vYe = ["stroke"], SYe = { key: 2 }, HYe = /* @__PURE__ */ e("path", { d: "M104,140a12,12,0,1,1-12-12A12,12,0,0,1,104,140Zm60-12a12,12,0,1,0,12,12A12,12,0,0,0,164,128Zm68.7,16a16.1,16.1,0,0,1-6.7,1.4,15.6,15.6,0,0,1-10-3.6V184a40,40,0,0,1-40,40H80a40,40,0,0,1-40-40V141.8a15.6,15.6,0,0,1-10,3.6,16.1,16.1,0,0,1-6.7-1.4,15.8,15.8,0,0,1-9.1-17.6L30.6,38.9A16.1,16.1,0,0,1,50.2,26.3L105,40h46l54.8-13.7a16.1,16.1,0,0,1,19.6,12.6l16.4,87.5A15.8,15.8,0,0,1,232.7,144ZM200,184V122L148.1,56H107.9L56,122v62a24.1,24.1,0,0,0,24,24h40V195.3l-13.7-13.6a8.1,8.1,0,0,1,11.4-11.4L128,180.7l10.3-10.4a8.1,8.1,0,0,1,11.4,11.4L136,195.3V208h40A24.1,24.1,0,0,0,200,184Z" }, null, -1), AYe = [
  HYe
], VYe = { key: 3 }, zYe = ["stroke"], ZYe = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "140",
  r: "10"
}, null, -1), CYe = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "140",
  r: "10"
}, null, -1), bYe = ["stroke"], LYe = ["stroke"], BYe = ["stroke"], PYe = ["stroke"], WYe = ["stroke"], NYe = { key: 4 }, FYe = ["stroke"], TYe = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "140",
  r: "8"
}, null, -1), DYe = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "140",
  r: "8"
}, null, -1), RYe = ["stroke"], UYe = ["stroke"], qYe = ["stroke"], GYe = ["stroke"], EYe = ["stroke"], OYe = { key: 5 }, IYe = ["stroke"], KYe = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "140",
  r: "12"
}, null, -1), XYe = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "140",
  r: "12"
}, null, -1), JYe = ["stroke"], QYe = ["stroke"], YYe = ["stroke"], oot = ["stroke"], eot = ["stroke"], tot = {
  name: "PhDog"
}, iE1 = /* @__PURE__ */ $({
  ...tot,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", lYe, [
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dYe),
        kYe,
        cYe,
        e("polyline", {
          points: "144 176 128 192 112 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hYe),
        e("path", {
          d: "M152,48l55.8-13.9a8,8,0,0,1,9.8,6.2L234,127.9c1.5,8.2-9,13-14.2,6.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uYe),
        e("path", {
          d: "M104,48,48.2,34.1a8,8,0,0,0-9.8,6.2L22,127.9c-1.5,8.2,9,13,14.2,6.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aYe),
        e("line", {
          x1: "104",
          y1: "48",
          x2: "152",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Ye),
        e("path", {
          d: "M208,119.3V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V119.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pYe)
      ])) : o(i) === "duotone" ? (s(), r("g", yYe, [
        $Ye,
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wYe),
        fYe,
        gYe,
        e("polyline", {
          points: "144 176 128 192 112 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xYe),
        e("path", {
          d: "M152,48l55.8-13.9a8,8,0,0,1,9.8,6.2L234,127.9c1.5,8.2-9,13-14.2,6.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jYe),
        e("path", {
          d: "M104,48,48.2,34.1a8,8,0,0,0-9.8,6.2L22,127.9c-1.5,8.2,9,13,14.2,6.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mYe),
        e("line", {
          x1: "104",
          y1: "48",
          x2: "152",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MYe),
        e("path", {
          d: "M208,119.3V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V119.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vYe)
      ])) : o(i) === "fill" ? (s(), r("g", SYe, AYe)) : o(i) === "light" ? (s(), r("g", VYe, [
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zYe),
        ZYe,
        CYe,
        e("polyline", {
          points: "144 176 128 192 112 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bYe),
        e("path", {
          d: "M152,48l55.8-13.9a8,8,0,0,1,9.8,6.2L234,127.9c1.5,8.2-9,13-14.2,6.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LYe),
        e("path", {
          d: "M104,48,48.2,34.1a8,8,0,0,0-9.8,6.2L22,127.9c-1.5,8.2,9,13,14.2,6.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BYe),
        e("line", {
          x1: "104",
          y1: "48",
          x2: "152",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PYe),
        e("path", {
          d: "M208,119.3V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V119.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WYe)
      ])) : o(i) === "thin" ? (s(), r("g", NYe, [
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FYe),
        TYe,
        DYe,
        e("polyline", {
          points: "144 176 128 192 112 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RYe),
        e("path", {
          d: "M152,48l55.8-13.9a8,8,0,0,1,9.8,6.2L234,127.9c1.5,8.2-9,13-14.2,6.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, UYe),
        e("path", {
          d: "M104,48,48.2,34.1a8,8,0,0,0-9.8,6.2L22,127.9c-1.5,8.2,9,13,14.2,6.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qYe),
        e("line", {
          x1: "104",
          y1: "48",
          x2: "152",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GYe),
        e("path", {
          d: "M208,119.3V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V119.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, EYe)
      ])) : o(i) === "regular" ? (s(), r("g", OYe, [
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IYe),
        KYe,
        XYe,
        e("polyline", {
          points: "144 176 128 192 112 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JYe),
        e("path", {
          d: "M152,48l55.8-13.9a8,8,0,0,1,9.8,6.2L234,127.9c1.5,8.2-9,13-14.2,6.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QYe),
        e("path", {
          d: "M104,48,48.2,34.1a8,8,0,0,0-9.8,6.2L22,127.9c-1.5,8.2,9,13,14.2,6.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YYe),
        e("line", {
          x1: "104",
          y1: "48",
          x2: "152",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oot),
        e("path", {
          d: "M208,119.3V184a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V119.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eot)
      ])) : g("", !0)
    ], 16, iYe));
  }
}), not = ["width", "height", "fill", "transform"], sot = { key: 0 }, rot = ["stroke"], iot = ["stroke"], lot = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "128",
  r: "16"
}, null, -1), dot = { key: 1 }, kot = /* @__PURE__ */ e("path", {
  d: "M56,224V40a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8V224Z",
  opacity: "0.2"
}, null, -1), cot = ["stroke"], hot = ["stroke"], uot = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "128",
  r: "12"
}, null, -1), aot = { key: 2 }, _ot = /* @__PURE__ */ e("path", { d: "M232,216H208V40a16,16,0,0,0-16-16H64A16,16,0,0,0,48,40V216H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm-68-76a12,12,0,1,1,12-12A12,12,0,0,1,164,140Z" }, null, -1), pot = [
  _ot
], yot = { key: 3 }, $ot = ["stroke"], wot = ["stroke"], fot = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "128",
  r: "10"
}, null, -1), got = { key: 4 }, xot = ["stroke"], jot = ["stroke"], mot = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "128",
  r: "8"
}, null, -1), Mot = { key: 5 }, vot = ["stroke"], Sot = ["stroke"], Hot = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "128",
  r: "12"
}, null, -1), Aot = {
  name: "PhDoor"
}, lE1 = /* @__PURE__ */ $({
  ...Aot,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", sot, [
        e("line", {
          x1: "24",
          y1: "224",
          x2: "232",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rot),
        e("path", {
          d: "M56,224V40a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iot),
        lot
      ])) : o(i) === "duotone" ? (s(), r("g", dot, [
        kot,
        e("line", {
          x1: "24",
          y1: "224",
          x2: "232",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cot),
        e("path", {
          d: "M56,224V40a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hot),
        uot
      ])) : o(i) === "fill" ? (s(), r("g", aot, pot)) : o(i) === "light" ? (s(), r("g", yot, [
        e("line", {
          x1: "24",
          y1: "224",
          x2: "232",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $ot),
        e("path", {
          d: "M56,224V40a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wot),
        fot
      ])) : o(i) === "thin" ? (s(), r("g", got, [
        e("line", {
          x1: "24",
          y1: "224",
          x2: "232",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xot),
        e("path", {
          d: "M56,224V40a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jot),
        mot
      ])) : o(i) === "regular" ? (s(), r("g", Mot, [
        e("line", {
          x1: "24",
          y1: "224",
          x2: "232",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vot),
        e("path", {
          d: "M56,224V40a8,8,0,0,1,8-8H192a8,8,0,0,1,8,8V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sot),
        Hot
      ])) : g("", !0)
    ], 16, not));
  }
}), Vot = ["width", "height", "fill", "transform"], zot = { key: 0 }, Zot = /* @__PURE__ */ j('<circle cx="60" cy="60" r="16"></circle><circle cx="128" cy="60" r="16"></circle><circle cx="196" cy="60" r="16"></circle><circle cx="60" cy="128" r="16"></circle><circle cx="128" cy="128" r="16"></circle><circle cx="196" cy="128" r="16"></circle><circle cx="60" cy="196" r="16"></circle><circle cx="128" cy="196" r="16"></circle><circle cx="196" cy="196" r="16"></circle>', 9), Cot = [
  Zot
], bot = { key: 1 }, Lot = /* @__PURE__ */ j('<circle cx="60" cy="60" r="12"></circle><circle cx="128" cy="60" r="12"></circle><circle cx="196" cy="60" r="12"></circle><circle cx="60" cy="128" r="12"></circle><circle cx="128" cy="128" r="12"></circle><circle cx="196" cy="128" r="12"></circle><circle cx="60" cy="196" r="12"></circle><circle cx="128" cy="196" r="12"></circle><circle cx="196" cy="196" r="12"></circle>', 9), Bot = [
  Lot
], Pot = { key: 2 }, Wot = /* @__PURE__ */ e("path", { d: "M60,48A12,12,0,1,0,72,60,12,12,0,0,0,60,48Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,128,48Zm68,24a12,12,0,1,0-12-12A12,12,0,0,0,196,72ZM60,184a12,12,0,1,0,12,12A12,12,0,0,0,60,184Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,128,184Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,196,184ZM60,116a12,12,0,1,0,12,12A12,12,0,0,0,60,116Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,128,116Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,196,116Z" }, null, -1), Not = [
  Wot
], Fot = { key: 3 }, Tot = /* @__PURE__ */ j('<circle cx="60" cy="60" r="10"></circle><circle cx="128" cy="60" r="10"></circle><circle cx="196" cy="60" r="10"></circle><circle cx="60" cy="128" r="10"></circle><circle cx="128" cy="128" r="10"></circle><circle cx="196" cy="128" r="10"></circle><circle cx="60" cy="196" r="10"></circle><circle cx="128" cy="196" r="10"></circle><circle cx="196" cy="196" r="10"></circle>', 9), Dot = [
  Tot
], Rot = { key: 4 }, Uot = /* @__PURE__ */ j('<circle cx="60" cy="60" r="8"></circle><circle cx="128" cy="60" r="8"></circle><circle cx="196" cy="60" r="8"></circle><circle cx="60" cy="128" r="8"></circle><circle cx="128" cy="128" r="8"></circle><circle cx="196" cy="128" r="8"></circle><circle cx="60" cy="196" r="8"></circle><circle cx="128" cy="196" r="8"></circle><circle cx="196" cy="196" r="8"></circle>', 9), qot = [
  Uot
], Got = { key: 5 }, Eot = /* @__PURE__ */ j('<circle cx="60" cy="60" r="12"></circle><circle cx="128" cy="60" r="12"></circle><circle cx="196" cy="60" r="12"></circle><circle cx="60" cy="128" r="12"></circle><circle cx="128" cy="128" r="12"></circle><circle cx="196" cy="128" r="12"></circle><circle cx="60" cy="196" r="12"></circle><circle cx="128" cy="196" r="12"></circle><circle cx="196" cy="196" r="12"></circle>', 9), Oot = [
  Eot
], Iot = {
  name: "PhDotsNine"
}, dE1 = /* @__PURE__ */ $({
  ...Iot,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", zot, Cot)) : o(i) === "duotone" ? (s(), r("g", bot, Bot)) : o(i) === "fill" ? (s(), r("g", Pot, Not)) : o(i) === "light" ? (s(), r("g", Fot, Dot)) : o(i) === "thin" ? (s(), r("g", Rot, qot)) : o(i) === "regular" ? (s(), r("g", Got, Oot)) : g("", !0)
    ], 16, Vot));
  }
}), Kot = ["width", "height", "fill", "transform"], Xot = { key: 0 }, Jot = /* @__PURE__ */ j('<circle cx="60" cy="92" r="16"></circle><circle cx="128" cy="92" r="16"></circle><circle cx="196" cy="92" r="16"></circle><circle cx="60" cy="164" r="16"></circle><circle cx="128" cy="164" r="16"></circle><circle cx="196" cy="164" r="16"></circle>', 6), Qot = [
  Jot
], Yot = { key: 1 }, oet = /* @__PURE__ */ j('<circle cx="60" cy="92" r="12"></circle><circle cx="128" cy="92" r="12"></circle><circle cx="196" cy="92" r="12"></circle><circle cx="60" cy="164" r="12"></circle><circle cx="128" cy="164" r="12"></circle><circle cx="196" cy="164" r="12"></circle>', 6), eet = [
  oet
], tet = { key: 2 }, net = /* @__PURE__ */ e("path", { d: "M72,92A12,12,0,1,1,60,80,12,12,0,0,1,72,92Zm56-12a12,12,0,1,0,12,12A12,12,0,0,0,128,80Zm68,24a12,12,0,1,0-12-12A12,12,0,0,0,196,104ZM60,152a12,12,0,1,0,12,12A12,12,0,0,0,60,152Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,128,152Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,196,152Z" }, null, -1), set = [
  net
], ret = { key: 3 }, iet = /* @__PURE__ */ j('<circle cx="60" cy="92" r="10"></circle><circle cx="128" cy="92" r="10"></circle><circle cx="196" cy="92" r="10"></circle><circle cx="60" cy="164" r="10"></circle><circle cx="128" cy="164" r="10"></circle><circle cx="196" cy="164" r="10"></circle>', 6), det = [
  iet
], ket = { key: 4 }, cet = /* @__PURE__ */ j('<circle cx="60" cy="92" r="8"></circle><circle cx="128" cy="92" r="8"></circle><circle cx="196" cy="92" r="8"></circle><circle cx="60" cy="164" r="8"></circle><circle cx="128" cy="164" r="8"></circle><circle cx="196" cy="164" r="8"></circle>', 6), het = [
  cet
], uet = { key: 5 }, aet = /* @__PURE__ */ j('<circle cx="60" cy="92" r="12"></circle><circle cx="128" cy="92" r="12"></circle><circle cx="196" cy="92" r="12"></circle><circle cx="60" cy="164" r="12"></circle><circle cx="128" cy="164" r="12"></circle><circle cx="196" cy="164" r="12"></circle>', 6), _et = [
  aet
], pet = {
  name: "PhDotsSix"
}, kE1 = /* @__PURE__ */ $({
  ...pet,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Xot, Qot)) : o(i) === "duotone" ? (s(), r("g", Yot, eet)) : o(i) === "fill" ? (s(), r("g", tet, set)) : o(i) === "light" ? (s(), r("g", ret, det)) : o(i) === "thin" ? (s(), r("g", ket, het)) : o(i) === "regular" ? (s(), r("g", uet, _et)) : g("", !0)
    ], 16, Kot));
  }
}), yet = ["width", "height", "fill", "transform"], $et = { key: 0 }, wet = /* @__PURE__ */ j('<circle cx="92" cy="60" r="16"></circle><circle cx="164" cy="60" r="16"></circle><circle cx="92" cy="128" r="16"></circle><circle cx="164" cy="128" r="16"></circle><circle cx="92" cy="196" r="16"></circle><circle cx="164" cy="196" r="16"></circle>', 6), fet = [
  wet
], get = { key: 1 }, xet = /* @__PURE__ */ j('<circle cx="92" cy="60" r="12"></circle><circle cx="164" cy="60" r="12"></circle><circle cx="92" cy="128" r="12"></circle><circle cx="164" cy="128" r="12"></circle><circle cx="92" cy="196" r="12"></circle><circle cx="164" cy="196" r="12"></circle>', 6), jet = [
  xet
], met = { key: 2 }, Met = /* @__PURE__ */ e("path", { d: "M104,60A12,12,0,1,1,92,48,12,12,0,0,1,104,60Zm60,12a12,12,0,1,0-12-12A12,12,0,0,0,164,72ZM92,116a12,12,0,1,0,12,12A12,12,0,0,0,92,116Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,116ZM92,184a12,12,0,1,0,12,12A12,12,0,0,0,92,184Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,184Z" }, null, -1), vet = [
  Met
], Set = { key: 3 }, Het = /* @__PURE__ */ j('<circle cx="92" cy="60" r="10"></circle><circle cx="164" cy="60" r="10"></circle><circle cx="92" cy="128" r="10"></circle><circle cx="164" cy="128" r="10"></circle><circle cx="92" cy="196" r="10"></circle><circle cx="164" cy="196" r="10"></circle>', 6), Aet = [
  Het
], Vet = { key: 4 }, zet = /* @__PURE__ */ j('<circle cx="92" cy="60" r="8"></circle><circle cx="164" cy="60" r="8"></circle><circle cx="92" cy="128" r="8"></circle><circle cx="164" cy="128" r="8"></circle><circle cx="92" cy="196" r="8"></circle><circle cx="164" cy="196" r="8"></circle>', 6), Zet = [
  zet
], Cet = { key: 5 }, bet = /* @__PURE__ */ j('<circle cx="92" cy="60" r="12"></circle><circle cx="164" cy="60" r="12"></circle><circle cx="92" cy="128" r="12"></circle><circle cx="164" cy="128" r="12"></circle><circle cx="92" cy="196" r="12"></circle><circle cx="164" cy="196" r="12"></circle>', 6), Let = [
  bet
], Bet = {
  name: "PhDotsSixVertical"
}, cE1 = /* @__PURE__ */ $({
  ...Bet,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $et, fet)) : o(i) === "duotone" ? (s(), r("g", get, jet)) : o(i) === "fill" ? (s(), r("g", met, vet)) : o(i) === "light" ? (s(), r("g", Set, Aet)) : o(i) === "thin" ? (s(), r("g", Vet, Zet)) : o(i) === "regular" ? (s(), r("g", Cet, Let)) : g("", !0)
    ], 16, yet));
  }
}), Pet = ["width", "height", "fill", "transform"], Wet = { key: 0 }, Net = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "16"
}, null, -1), Fet = /* @__PURE__ */ e("circle", {
  cx: "64",
  cy: "128",
  r: "16"
}, null, -1), Tet = /* @__PURE__ */ e("circle", {
  cx: "192",
  cy: "128",
  r: "16"
}, null, -1), Det = [
  Net,
  Fet,
  Tet
], Ret = { key: 1 }, Uet = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), qet = /* @__PURE__ */ e("circle", {
  cx: "192",
  cy: "128",
  r: "12"
}, null, -1), Get = /* @__PURE__ */ e("circle", {
  cx: "64",
  cy: "128",
  r: "12"
}, null, -1), Eet = [
  Uet,
  qet,
  Get
], Oet = { key: 2 }, Iet = /* @__PURE__ */ e("path", { d: "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm52-12a12,12,0,1,0,12,12A12,12,0,0,0,192,116ZM64,116a12,12,0,1,0,12,12A12,12,0,0,0,64,116Z" }, null, -1), Ket = [
  Iet
], Xet = { key: 3 }, Jet = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "10"
}, null, -1), Qet = /* @__PURE__ */ e("circle", {
  cx: "64",
  cy: "128",
  r: "10"
}, null, -1), Yet = /* @__PURE__ */ e("circle", {
  cx: "192",
  cy: "128",
  r: "10"
}, null, -1), ott = [
  Jet,
  Qet,
  Yet
], ett = { key: 4 }, ttt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "8"
}, null, -1), ntt = /* @__PURE__ */ e("circle", {
  cx: "64",
  cy: "128",
  r: "8"
}, null, -1), stt = /* @__PURE__ */ e("circle", {
  cx: "192",
  cy: "128",
  r: "8"
}, null, -1), rtt = [
  ttt,
  ntt,
  stt
], itt = { key: 5 }, ltt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), dtt = /* @__PURE__ */ e("circle", {
  cx: "192",
  cy: "128",
  r: "12"
}, null, -1), ktt = /* @__PURE__ */ e("circle", {
  cx: "64",
  cy: "128",
  r: "12"
}, null, -1), ctt = [
  ltt,
  dtt,
  ktt
], htt = {
  name: "PhDotsThree"
}, hE1 = /* @__PURE__ */ $({
  ...htt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Wet, Det)) : o(i) === "duotone" ? (s(), r("g", Ret, Eet)) : o(i) === "fill" ? (s(), r("g", Oet, Ket)) : o(i) === "light" ? (s(), r("g", Xet, ott)) : o(i) === "thin" ? (s(), r("g", ett, rtt)) : o(i) === "regular" ? (s(), r("g", itt, ctt)) : g("", !0)
    ], 16, Pet));
  }
}), utt = ["width", "height", "fill", "transform"], att = { key: 0 }, _tt = ["stroke"], ptt = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "128",
  r: "16"
}, null, -1), ytt = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "128",
  r: "16"
}, null, -1), $tt = { key: 1 }, wtt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), ftt = ["stroke"], gtt = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "128",
  r: "12"
}, null, -1), xtt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), jtt = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "128",
  r: "12"
}, null, -1), mtt = { key: 2 }, Mtt = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24ZM80,140a12,12,0,1,1,12-12A12,12,0,0,1,80,140Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,128,140Zm48,0a12,12,0,1,1,12-12A12,12,0,0,1,176,140Z" }, null, -1), vtt = [
  Mtt
], Stt = { key: 3 }, Htt = ["stroke"], Att = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "10"
}, null, -1), Vtt = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "128",
  r: "10"
}, null, -1), ztt = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "128",
  r: "10"
}, null, -1), Ztt = { key: 4 }, Ctt = ["stroke"], btt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "8"
}, null, -1), Ltt = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "128",
  r: "8"
}, null, -1), Btt = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "128",
  r: "8"
}, null, -1), Ptt = { key: 5 }, Wtt = ["stroke"], Ntt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), Ftt = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "128",
  r: "12"
}, null, -1), Ttt = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "128",
  r: "12"
}, null, -1), Dtt = {
  name: "PhDotsThreeCircle"
}, uE1 = /* @__PURE__ */ $({
  ...Dtt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", att, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _tt),
        ptt,
        ytt
      ])) : o(i) === "duotone" ? (s(), r("g", $tt, [
        wtt,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, ftt),
        gtt,
        xtt,
        jtt
      ])) : o(i) === "fill" ? (s(), r("g", mtt, vtt)) : o(i) === "light" ? (s(), r("g", Stt, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Htt),
        Att,
        Vtt,
        ztt
      ])) : o(i) === "thin" ? (s(), r("g", Ztt, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ctt),
        btt,
        Ltt,
        Btt
      ])) : o(i) === "regular" ? (s(), r("g", Ptt, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Wtt),
        Ntt,
        Ftt,
        Ttt
      ])) : g("", !0)
    ], 16, utt));
  }
}), Rtt = ["width", "height", "fill", "transform"], Utt = { key: 0 }, qtt = ["stroke"], Gtt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "100",
  r: "16"
}, null, -1), Ett = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "156",
  r: "16"
}, null, -1), Ott = { key: 1 }, Itt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), Ktt = ["stroke"], Xtt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), Jtt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "80",
  r: "12"
}, null, -1), Qtt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "176",
  r: "12"
}, null, -1), Ytt = { key: 2 }, ont = /* @__PURE__ */ e("path", { d: "M232,128A104,104,0,1,0,128,232,104.2,104.2,0,0,0,232,128ZM116,80a12,12,0,1,1,12,12A12,12,0,0,1,116,80Zm0,48a12,12,0,1,1,12,12A12,12,0,0,1,116,128Zm0,48a12,12,0,1,1,12,12A12,12,0,0,1,116,176Z" }, null, -1), ent = [
  ont
], tnt = { key: 3 }, nnt = ["stroke"], snt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "80",
  r: "10"
}, null, -1), rnt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "10"
}, null, -1), int = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "176",
  r: "10"
}, null, -1), lnt = { key: 4 }, dnt = ["stroke"], knt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "80",
  r: "8"
}, null, -1), cnt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "8"
}, null, -1), hnt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "176",
  r: "8"
}, null, -1), unt = { key: 5 }, ant = ["stroke"], _nt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), pnt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "80",
  r: "12"
}, null, -1), ynt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "176",
  r: "12"
}, null, -1), $nt = {
  name: "PhDotsThreeCircleVertical"
}, aE1 = /* @__PURE__ */ $({
  ...$nt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Utt, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qtt),
        Gtt,
        Ett
      ])) : o(i) === "duotone" ? (s(), r("g", Ott, [
        Itt,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Ktt),
        Xtt,
        Jtt,
        Qtt
      ])) : o(i) === "fill" ? (s(), r("g", Ytt, ent)) : o(i) === "light" ? (s(), r("g", tnt, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nnt),
        snt,
        rnt,
        int
      ])) : o(i) === "thin" ? (s(), r("g", lnt, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dnt),
        knt,
        cnt,
        hnt
      ])) : o(i) === "regular" ? (s(), r("g", unt, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, ant),
        _nt,
        pnt,
        ynt
      ])) : g("", !0)
    ], 16, Rtt));
  }
}), wnt = ["width", "height", "fill", "transform"], fnt = { key: 0 }, gnt = ["stroke"], xnt = ["stroke"], jnt = ["stroke"], mnt = { key: 1 }, Mnt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "24",
  opacity: "0.1"
}, null, -1), vnt = /* @__PURE__ */ e("circle", {
  cx: "48",
  cy: "128",
  r: "24",
  opacity: "0.1"
}, null, -1), Snt = /* @__PURE__ */ e("circle", {
  cx: "208",
  cy: "128",
  r: "24",
  opacity: "0.1"
}, null, -1), Hnt = ["stroke"], Ant = ["stroke"], Vnt = ["stroke"], znt = { key: 2 }, Znt = /* @__PURE__ */ e("path", { d: "M156,128a28,28,0,1,1-28-28A28.1,28.1,0,0,1,156,128ZM48,100a28,28,0,1,0,28,28A28.1,28.1,0,0,0,48,100Zm160,0a28,28,0,1,0,28,28A28.1,28.1,0,0,0,208,100Z" }, null, -1), Cnt = [
  Znt
], bnt = { key: 3 }, Lnt = ["stroke"], Bnt = ["stroke"], Pnt = ["stroke"], Wnt = { key: 4 }, Nnt = ["stroke"], Fnt = ["stroke"], Tnt = ["stroke"], Dnt = { key: 5 }, Rnt = ["stroke"], Unt = ["stroke"], qnt = ["stroke"], Gnt = {
  name: "PhDotsThreeOutline"
}, _E1 = /* @__PURE__ */ $({
  ...Gnt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", fnt, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gnt),
        e("circle", {
          cx: "208",
          cy: "128",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xnt),
        e("circle", {
          cx: "48",
          cy: "128",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jnt)
      ])) : o(i) === "duotone" ? (s(), r("g", mnt, [
        Mnt,
        vnt,
        Snt,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Hnt),
        e("circle", {
          cx: "48",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Ant),
        e("circle", {
          cx: "208",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Vnt)
      ])) : o(i) === "fill" ? (s(), r("g", znt, Cnt)) : o(i) === "light" ? (s(), r("g", bnt, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lnt),
        e("circle", {
          cx: "48",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bnt),
        e("circle", {
          cx: "208",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pnt)
      ])) : o(i) === "thin" ? (s(), r("g", Wnt, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nnt),
        e("circle", {
          cx: "48",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fnt),
        e("circle", {
          cx: "208",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Tnt)
      ])) : o(i) === "regular" ? (s(), r("g", Dnt, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Rnt),
        e("circle", {
          cx: "48",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Unt),
        e("circle", {
          cx: "208",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, qnt)
      ])) : g("", !0)
    ], 16, wnt));
  }
}), Ent = ["width", "height", "fill", "transform"], Ont = { key: 0 }, Int = ["stroke"], Knt = ["stroke"], Xnt = ["stroke"], Jnt = { key: 1 }, Qnt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "24",
  opacity: "0.1"
}, null, -1), Ynt = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "48",
  r: "24",
  opacity: "0.1"
}, null, -1), ost = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "208",
  r: "24",
  opacity: "0.1"
}, null, -1), est = ["stroke"], tst = ["stroke"], nst = ["stroke"], sst = { key: 2 }, rst = /* @__PURE__ */ e("path", { d: "M156,128a28,28,0,1,1-28-28A28.1,28.1,0,0,1,156,128ZM128,76a28,28,0,1,0-28-28A28.1,28.1,0,0,0,128,76Zm0,104a28,28,0,1,0,28,28A28.1,28.1,0,0,0,128,180Z" }, null, -1), ist = [
  rst
], lst = { key: 3 }, dst = ["stroke"], kst = ["stroke"], cst = ["stroke"], hst = { key: 4 }, ust = ["stroke"], ast = ["stroke"], _st = ["stroke"], pst = { key: 5 }, yst = ["stroke"], $st = ["stroke"], wst = ["stroke"], fst = {
  name: "PhDotsThreeOutlineVertical"
}, pE1 = /* @__PURE__ */ $({
  ...fst,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ont, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Int),
        e("circle", {
          cx: "128",
          cy: "48",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Knt),
        e("circle", {
          cx: "128",
          cy: "208",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xnt)
      ])) : o(i) === "duotone" ? (s(), r("g", Jnt, [
        Qnt,
        Ynt,
        ost,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, est),
        e("circle", {
          cx: "128",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, tst),
        e("circle", {
          cx: "128",
          cy: "208",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, nst)
      ])) : o(i) === "fill" ? (s(), r("g", sst, ist)) : o(i) === "light" ? (s(), r("g", lst, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dst),
        e("circle", {
          cx: "128",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kst),
        e("circle", {
          cx: "128",
          cy: "208",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cst)
      ])) : o(i) === "thin" ? (s(), r("g", hst, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ust),
        e("circle", {
          cx: "128",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ast),
        e("circle", {
          cx: "128",
          cy: "208",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _st)
      ])) : o(i) === "regular" ? (s(), r("g", pst, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, yst),
        e("circle", {
          cx: "128",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, $st),
        e("circle", {
          cx: "128",
          cy: "208",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, wst)
      ])) : g("", !0)
    ], 16, Ent));
  }
}), gst = ["width", "height", "fill", "transform"], xst = { key: 0 }, jst = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "64",
  r: "16"
}, null, -1), mst = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "16"
}, null, -1), Mst = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "192",
  r: "16"
}, null, -1), vst = [
  jst,
  mst,
  Mst
], Sst = { key: 1 }, Hst = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), Ast = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "64",
  r: "12"
}, null, -1), Vst = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "192",
  r: "12"
}, null, -1), zst = [
  Hst,
  Ast,
  Vst
], Zst = { key: 2 }, Cst = /* @__PURE__ */ e("path", { d: "M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128ZM128,76a12,12,0,1,0-12-12A12,12,0,0,0,128,76Zm0,104a12,12,0,1,0,12,12A12,12,0,0,0,128,180Z" }, null, -1), bst = [
  Cst
], Lst = { key: 3 }, Bst = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "64",
  r: "10"
}, null, -1), Pst = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "10"
}, null, -1), Wst = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "192",
  r: "10"
}, null, -1), Nst = [
  Bst,
  Pst,
  Wst
], Fst = { key: 4 }, Tst = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "64",
  r: "8"
}, null, -1), Dst = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "8"
}, null, -1), Rst = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "192",
  r: "8"
}, null, -1), Ust = [
  Tst,
  Dst,
  Rst
], qst = { key: 5 }, Gst = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "12"
}, null, -1), Est = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "64",
  r: "12"
}, null, -1), Ost = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "192",
  r: "12"
}, null, -1), Ist = [
  Gst,
  Est,
  Ost
], Kst = {
  name: "PhDotsThreeVertical"
}, yE1 = /* @__PURE__ */ $({
  ...Kst,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xst, vst)) : o(i) === "duotone" ? (s(), r("g", Sst, zst)) : o(i) === "fill" ? (s(), r("g", Zst, bst)) : o(i) === "light" ? (s(), r("g", Lst, Nst)) : o(i) === "thin" ? (s(), r("g", Fst, Ust)) : o(i) === "regular" ? (s(), r("g", qst, Ist)) : g("", !0)
    ], 16, gst));
  }
}), Xst = ["width", "height", "fill", "transform"], Jst = { key: 0 }, Qst = ["stroke"], Yst = ["stroke"], ort = ["stroke"], ert = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "168",
  r: "16"
}, null, -1), trt = { key: 1 }, nrt = /* @__PURE__ */ e("rect", {
  x: "24",
  y: "128",
  width: "208",
  height: "80",
  rx: "8",
  opacity: "0.2"
}, null, -1), srt = ["stroke"], rrt = ["stroke"], irt = ["stroke"], lrt = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "168",
  r: "12"
}, null, -1), drt = { key: 2 }, krt = /* @__PURE__ */ e("path", { d: "M74.3,85.7A8.1,8.1,0,0,1,85.7,74.3L120,108.7V24a8,8,0,0,1,16,0v84.7l34.3-34.4a8.1,8.1,0,0,1,11.4,11.4l-48,48a8.2,8.2,0,0,1-11.4,0ZM240,136v64a16,16,0,0,1-16,16H32a16,16,0,0,1-16-16V136a16,16,0,0,1,16-16H84.4a3.6,3.6,0,0,1,2.8,1.2L111,145a24.1,24.1,0,0,0,34,0l23.8-23.8a3.6,3.6,0,0,1,2.8-1.2H224A16,16,0,0,1,240,136Zm-40,32a12,12,0,1,0-12,12A12,12,0,0,0,200,168Z" }, null, -1), crt = [
  krt
], hrt = { key: 3 }, urt = ["stroke"], art = ["stroke"], _rt = ["stroke"], prt = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "168",
  r: "10"
}, null, -1), yrt = { key: 4 }, $rt = ["stroke"], wrt = ["stroke"], frt = ["stroke"], grt = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "168",
  r: "8"
}, null, -1), xrt = { key: 5 }, jrt = ["stroke"], mrt = ["stroke"], Mrt = ["stroke"], vrt = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "168",
  r: "12"
}, null, -1), Srt = {
  name: "PhDownload"
}, $E1 = /* @__PURE__ */ $({
  ...Srt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Jst, [
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qst),
        e("polyline", {
          points: "80 80 128 128 176 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Yst),
        e("path", {
          d: "M184.6,128H224a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H71.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ort),
        ert
      ])) : o(i) === "duotone" ? (s(), r("g", trt, [
        nrt,
        e("path", {
          d: "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, srt),
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rrt),
        e("polyline", {
          points: "80 80 128 128 176 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, irt),
        lrt
      ])) : o(i) === "fill" ? (s(), r("g", drt, crt)) : o(i) === "light" ? (s(), r("g", hrt, [
        e("path", {
          d: "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, urt),
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, art),
        e("polyline", {
          points: "80 80 128 128 176 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _rt),
        prt
      ])) : o(i) === "thin" ? (s(), r("g", yrt, [
        e("path", {
          d: "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $rt),
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wrt),
        e("polyline", {
          points: "80 80 128 128 176 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, frt),
        grt
      ])) : o(i) === "regular" ? (s(), r("g", xrt, [
        e("path", {
          d: "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jrt),
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mrt),
        e("polyline", {
          points: "80 80 128 128 176 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mrt),
        vrt
      ])) : g("", !0)
    ], 16, Xst));
  }
}), Hrt = ["width", "height", "fill", "transform"], Art = { key: 0 }, Vrt = ["stroke"], zrt = ["stroke"], Zrt = ["stroke"], Crt = { key: 1 }, brt = ["stroke"], Lrt = ["stroke"], Brt = ["stroke"], Prt = { key: 2 }, Wrt = /* @__PURE__ */ e("path", { d: "M80.3,115.7a8.2,8.2,0,0,1-1.7-8.7,8,8,0,0,1,7.4-5h34V40a8,8,0,0,1,16,0v62h34a8,8,0,0,1,7.4,5,8.2,8.2,0,0,1-1.7,8.7l-42,42a8.2,8.2,0,0,1-11.4,0ZM216,144a8,8,0,0,0-8,8v56H48V152a8,8,0,0,0-16,0v56a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V152A8,8,0,0,0,216,144Z" }, null, -1), Nrt = [
  Wrt
], Frt = { key: 3 }, Trt = ["stroke"], Drt = ["stroke"], Rrt = ["stroke"], Urt = { key: 4 }, qrt = ["stroke"], Grt = ["stroke"], Ert = ["stroke"], Ort = { key: 5 }, Irt = ["stroke"], Krt = ["stroke"], Xrt = ["stroke"], Jrt = {
  name: "PhDownloadSimple"
}, wE1 = /* @__PURE__ */ $({
  ...Jrt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Art, [
        e("polyline", {
          points: "86 110 128 152 170 110",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vrt),
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zrt),
        e("path", {
          d: "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zrt)
      ])) : o(i) === "duotone" ? (s(), r("g", Crt, [
        e("polyline", {
          points: "86 110 128 152 170 110",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, brt),
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lrt),
        e("path", {
          d: "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Brt)
      ])) : o(i) === "fill" ? (s(), r("g", Prt, Nrt)) : o(i) === "light" ? (s(), r("g", Frt, [
        e("polyline", {
          points: "86 110 128 152 170 110",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Trt),
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Drt),
        e("path", {
          d: "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rrt)
      ])) : o(i) === "thin" ? (s(), r("g", Urt, [
        e("polyline", {
          points: "86 110 128 152 170 110",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qrt),
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Grt),
        e("path", {
          d: "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ert)
      ])) : o(i) === "regular" ? (s(), r("g", Ort, [
        e("polyline", {
          points: "86 110 128 152 170 110",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Irt),
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Krt),
        e("path", {
          d: "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xrt)
      ])) : g("", !0)
    ], 16, Hrt));
  }
}), Qrt = ["width", "height", "fill", "transform"], Yrt = { key: 0 }, oit = ["stroke"], eit = ["stroke"], tit = ["stroke"], nit = ["stroke"], sit = { key: 1 }, rit = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), iit = ["stroke"], lit = ["stroke"], dit = ["stroke"], kit = ["stroke"], cit = { key: 2 }, hit = /* @__PURE__ */ e("path", { d: "M93.3,36.9a4,4,0,0,1,.8-7.2,103.7,103.7,0,0,1,88.6,9.9,4,4,0,0,1,1.1,5.9,156.1,156.1,0,0,1-41.9,37A169,169,0,0,0,93.3,36.9ZM127.6,90a154.2,154.2,0,0,0-56-46.9,4.3,4.3,0,0,0-4.1.3A105.1,105.1,0,0,0,29.2,95.5a4,4,0,0,0,3,5.1A151.1,151.1,0,0,0,64,104,150.6,150.6,0,0,0,127.6,90Zm103.8,26.7a104,104,0,0,0-29.2-61.5,4.1,4.1,0,0,0-6,.3,168.3,168.3,0,0,1-45.7,40.4,171.5,171.5,0,0,1,13.6,29.9A167.3,167.3,0,0,1,208,120a171.5,171.5,0,0,1,19,1.1A4,4,0,0,0,231.4,116.7Zm-62.9,24.5a169,169,0,0,1,4.4,38.5,168.1,168.1,0,0,1-4.1,36.8,4,4,0,0,0,5.7,4.5,104.1,104.1,0,0,0,56.6-79.2,4,4,0,0,0-3.5-4.5A141.3,141.3,0,0,0,208,136,151.2,151.2,0,0,0,168.5,141.2Zm-19.7-10.4a142.6,142.6,0,0,0-12.4-27.2A167.2,167.2,0,0,1,64,120a167.3,167.3,0,0,1-34.9-3.7,4,4,0,0,0-4.8,3.6q-.3,4-.3,8.1a103.7,103.7,0,0,0,33,75.9,3.9,3.9,0,0,0,6.1-.9A168.8,168.8,0,0,1,148.8,130.8ZM75.7,213.2a4,4,0,0,0,1.5,5.5A102.9,102.9,0,0,0,128,232a98.3,98.3,0,0,0,18.1-1.6,3.8,3.8,0,0,0,3-2.6,151,151,0,0,0,7.8-48.1,154.2,154.2,0,0,0-3.7-33.5A153.2,153.2,0,0,0,75.7,213.2Z" }, null, -1), uit = [
  hit
], ait = { key: 3 }, _it = ["stroke"], pit = ["stroke"], yit = ["stroke"], $it = ["stroke"], wit = { key: 4 }, fit = ["stroke"], git = ["stroke"], xit = ["stroke"], jit = ["stroke"], mit = { key: 5 }, Mit = ["stroke"], vit = ["stroke"], Sit = ["stroke"], Hit = ["stroke"], Ait = {
  name: "PhDribbbleLogo"
}, fE1 = /* @__PURE__ */ $({
  ...Ait,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Yrt, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oit),
        e("path", {
          d: "M71,205.3A160.1,160.1,0,0,1,208,128c5.4,0,10.7.3,16,.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eit),
        e("path", {
          d: "M188,53.1A159.8,159.8,0,0,1,64,112a165.2,165.2,0,0,1-30.1-2.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tit),
        e("path", {
          d: "M85.9,41.7a160.5,160.5,0,0,1,74.3,176.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nit)
      ])) : o(i) === "duotone" ? (s(), r("g", sit, [
        rit,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iit),
        e("path", {
          d: "M71,205.3A160.1,160.1,0,0,1,208,128c5.4,0,10.7.3,16,.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lit),
        e("path", {
          d: "M188,53.1A159.8,159.8,0,0,1,64,112a165.2,165.2,0,0,1-30.1-2.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dit),
        e("path", {
          d: "M85.9,41.7a160.5,160.5,0,0,1,74.3,176.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kit)
      ])) : o(i) === "fill" ? (s(), r("g", cit, uit)) : o(i) === "light" ? (s(), r("g", ait, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _it),
        e("path", {
          d: "M71,205.3A160.1,160.1,0,0,1,208,128c5.4,0,10.7.3,16,.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pit),
        e("path", {
          d: "M188,53.1A159.8,159.8,0,0,1,64,112a165.2,165.2,0,0,1-30.1-2.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yit),
        e("path", {
          d: "M85.9,41.7a160.5,160.5,0,0,1,74.3,176.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $it)
      ])) : o(i) === "thin" ? (s(), r("g", wit, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fit),
        e("path", {
          d: "M71,205.3A160.1,160.1,0,0,1,208,128c5.4,0,10.7.3,16,.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, git),
        e("path", {
          d: "M188,53.1A159.8,159.8,0,0,1,64,112a165.2,165.2,0,0,1-30.1-2.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xit),
        e("path", {
          d: "M85.9,41.7a160.5,160.5,0,0,1,74.3,176.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jit)
      ])) : o(i) === "regular" ? (s(), r("g", mit, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mit),
        e("path", {
          d: "M71,205.3A160.1,160.1,0,0,1,208,128c5.4,0,10.7.3,16,.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vit),
        e("path", {
          d: "M188,53.1A159.8,159.8,0,0,1,64,112a165.2,165.2,0,0,1-30.1-2.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sit),
        e("path", {
          d: "M85.9,41.7a160.5,160.5,0,0,1,74.3,176.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hit)
      ])) : g("", !0)
    ], 16, Qrt));
  }
}), Vit = ["width", "height", "fill", "transform"], zit = { key: 0 }, Zit = ["stroke"], Cit = ["stroke"], bit = { key: 1 }, Lit = /* @__PURE__ */ e("path", {
  d: "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
  opacity: "0.2"
}, null, -1), Bit = ["stroke"], Pit = ["stroke"], Wit = { key: 2 }, Nit = /* @__PURE__ */ e("path", { d: "M174,47.8A259.4,259.4,0,0,0,132.6,9.4a8.1,8.1,0,0,0-9.2,0A259.4,259.4,0,0,0,82,47.8C54.5,79.3,40,112.6,40,144a88,88,0,0,0,176,0C216,112.6,201.5,79.3,174,47.8Zm9.2,105.6a55.8,55.8,0,0,1-45.8,45.7h-1.3a8,8,0,0,1-1.3-15.9,39.7,39.7,0,0,0,32.6-32.6,8,8,0,0,1,9.3-6.5A7.9,7.9,0,0,1,183.2,153.4Z" }, null, -1), Fit = [
  Nit
], Tit = { key: 3 }, Dit = ["stroke"], Rit = ["stroke"], Uit = { key: 4 }, qit = ["stroke"], Git = ["stroke"], Eit = { key: 5 }, Oit = ["stroke"], Iit = ["stroke"], Kit = {
  name: "PhDrop"
}, gE1 = /* @__PURE__ */ $({
  ...Kit,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", zit, [
        e("path", {
          d: "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zit),
        e("path", {
          d: "M163.1,152A35.8,35.8,0,0,1,136,179.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cit)
      ])) : o(i) === "duotone" ? (s(), r("g", bit, [
        Lit,
        e("path", {
          d: "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bit),
        e("path", {
          d: "M136.1,191.2a47.9,47.9,0,0,0,39.2-39.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pit)
      ])) : o(i) === "fill" ? (s(), r("g", Wit, Fit)) : o(i) === "light" ? (s(), r("g", Tit, [
        e("path", {
          d: "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dit),
        e("path", {
          d: "M136.1,191.2a47.9,47.9,0,0,0,39.2-39.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rit)
      ])) : o(i) === "thin" ? (s(), r("g", Uit, [
        e("path", {
          d: "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qit),
        e("path", {
          d: "M136.1,191.2a47.9,47.9,0,0,0,39.2-39.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Git)
      ])) : o(i) === "regular" ? (s(), r("g", Eit, [
        e("path", {
          d: "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Oit),
        e("path", {
          d: "M136.1,191.2a47.9,47.9,0,0,0,39.2-39.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Iit)
      ])) : g("", !0)
    ], 16, Vit));
  }
}), Xit = ["width", "height", "fill", "transform"], Jit = { key: 0 }, Qit = ["stroke"], Yit = ["stroke"], o1t = ["stroke"], e1t = ["stroke"], t1t = ["stroke"], n1t = { key: 1 }, s1t = /* @__PURE__ */ e("path", {
  d: "M128,224a80,80,0,0,0,80-80c0-72-80-128-80-128Z",
  opacity: "0.2"
}, null, -1), r1t = ["stroke"], i1t = ["stroke"], l1t = { key: 2 }, d1t = /* @__PURE__ */ e("path", { d: "M174,47.8A259.4,259.4,0,0,0,132.6,9.4a8.1,8.1,0,0,0-9.2,0A259.4,259.4,0,0,0,82,47.8C54.5,79.3,40,112.6,40,144a88,88,0,0,0,176,0C216,112.6,201.5,79.3,174,47.8ZM56,144c0-57.2,55.5-105,72-118V216A72.1,72.1,0,0,1,56,144Z" }, null, -1), k1t = [
  d1t
], c1t = { key: 3 }, h1t = ["stroke"], u1t = ["stroke"], a1t = ["stroke"], _1t = ["stroke"], p1t = ["stroke"], y1t = ["stroke"], $1t = ["stroke"], w1t = { key: 4 }, f1t = ["stroke"], g1t = ["stroke"], x1t = ["stroke"], j1t = ["stroke"], m1t = ["stroke"], M1t = ["stroke"], v1t = ["stroke"], S1t = { key: 5 }, H1t = ["stroke"], A1t = ["stroke"], V1t = ["stroke"], z1t = ["stroke"], Z1t = ["stroke"], C1t = ["stroke"], b1t = ["stroke"], L1t = {
  name: "PhDropHalf"
}, xE1 = /* @__PURE__ */ $({
  ...L1t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Jit, [
        e("path", {
          d: "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qit),
        e("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Yit),
        e("line", {
          x1: "128",
          y1: "132",
          x2: "207.3",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, o1t),
        e("line", {
          x1: "128",
          y1: "92",
          x2: "194.7",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, e1t),
        e("line", {
          x1: "128",
          y1: "172",
          x2: "203",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, t1t)
      ])) : o(i) === "duotone" ? (s(), r("g", n1t, [
        s1t,
        e("path", {
          d: "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r1t),
        e("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, i1t)
      ])) : o(i) === "fill" ? (s(), r("g", l1t, k1t)) : o(i) === "light" ? (s(), r("g", c1t, [
        e("path", {
          d: "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, h1t),
        e("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u1t),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "206.7",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, a1t),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "196.6",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _1t),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "206.4",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, p1t),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "192",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, y1t),
        e("line", {
          x1: "128",
          y1: "64",
          x2: "177",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $1t)
      ])) : o(i) === "thin" ? (s(), r("g", w1t, [
        e("path", {
          d: "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, f1t),
        e("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, g1t),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "206.7",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, x1t),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "196.6",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, j1t),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "206.4",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, m1t),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "192",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, M1t),
        e("line", {
          x1: "128",
          y1: "64",
          x2: "177",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, v1t)
      ])) : o(i) === "regular" ? (s(), r("g", S1t, [
        e("path", {
          d: "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H1t),
        e("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A1t),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "206.7",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, V1t),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "196.6",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, z1t),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "206.4",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z1t),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "192",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C1t),
        e("line", {
          x1: "128",
          y1: "64",
          x2: "177",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b1t)
      ])) : g("", !0)
    ], 16, Xit));
  }
}), B1t = ["width", "height", "fill", "transform"], P1t = { key: 0 }, W1t = ["stroke"], N1t = ["stroke"], F1t = ["stroke"], T1t = { key: 1 }, D1t = /* @__PURE__ */ e("path", {
  d: "M49.3,128A105.7,105.7,0,0,0,48,144a80,80,0,0,0,160,0,105.7,105.7,0,0,0-1.3-16H49.3Z",
  opacity: "0.2"
}, null, -1), R1t = ["stroke"], U1t = ["stroke"], q1t = { key: 2 }, G1t = /* @__PURE__ */ e("path", { d: "M174,47.8A259.4,259.4,0,0,0,132.6,9.4a8.1,8.1,0,0,0-9.2,0A259.4,259.4,0,0,0,82,47.8C54.5,79.3,40,112.6,40,144a88,88,0,0,0,176,0C216,112.6,201.5,79.3,174,47.8ZM128,26c14.2,11.1,56.9,47.8,68.8,94H59.2C71.1,73.8,113.8,37.1,128,26Z" }, null, -1), E1t = [
  G1t
], O1t = { key: 3 }, I1t = ["stroke"], K1t = ["stroke"], X1t = ["stroke"], J1t = ["stroke"], Q1t = { key: 4 }, Y1t = ["stroke"], olt = ["stroke"], elt = ["stroke"], tlt = ["stroke"], nlt = { key: 5 }, slt = ["stroke"], rlt = ["stroke"], ilt = ["stroke"], llt = ["stroke"], dlt = {
  name: "PhDropHalfBottom"
}, jE1 = /* @__PURE__ */ $({
  ...dlt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", P1t, [
        e("path", {
          d: "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, W1t),
        e("line", {
          x1: "56.5",
          y1: "180",
          x2: "199.5",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, N1t),
        e("line", {
          x1: "48.1",
          y1: "140",
          x2: "207.9",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, F1t)
      ])) : o(i) === "duotone" ? (s(), r("g", T1t, [
        D1t,
        e("path", {
          d: "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R1t),
        e("line", {
          x1: "49.3",
          y1: "128",
          x2: "206.7",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U1t)
      ])) : o(i) === "fill" ? (s(), r("g", q1t, E1t)) : o(i) === "light" ? (s(), r("g", O1t, [
        e("path", {
          d: "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, I1t),
        e("line", {
          x1: "49.3",
          y1: "128",
          x2: "206.7",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, K1t),
        e("line", {
          x1: "49.6",
          y1: "160",
          x2: "206.4",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, X1t),
        e("line", {
          x1: "64",
          y1: "192",
          x2: "192",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, J1t)
      ])) : o(i) === "thin" ? (s(), r("g", Q1t, [
        e("path", {
          d: "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Y1t),
        e("line", {
          x1: "49.3",
          y1: "128",
          x2: "206.7",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, olt),
        e("line", {
          x1: "49.6",
          y1: "160",
          x2: "206.4",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, elt),
        e("line", {
          x1: "64",
          y1: "192",
          x2: "192",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tlt)
      ])) : o(i) === "regular" ? (s(), r("g", nlt, [
        e("path", {
          d: "M208,144c0-72-80-128-80-128S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, slt),
        e("line", {
          x1: "49.3",
          y1: "128",
          x2: "206.7",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rlt),
        e("line", {
          x1: "49.6",
          y1: "160",
          x2: "206.4",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ilt),
        e("line", {
          x1: "64",
          y1: "192",
          x2: "192",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, llt)
      ])) : g("", !0)
    ], 16, B1t));
  }
}), klt = ["width", "height", "fill", "transform"], clt = { key: 0 }, hlt = ["stroke"], ult = ["stroke"], alt = { key: 1 }, _lt = /* @__PURE__ */ e("path", {
  d: "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84a80,80,0,0,1,160,0C208,144,209,169,161.9,216Z",
  opacity: "0.2"
}, null, -1), plt = ["stroke"], ylt = ["stroke"], $lt = { key: 2 }, wlt = /* @__PURE__ */ e("path", { d: "M188,152a28,28,0,0,1-56,0c0-15.7,9.3-23.7,16.8-30.1S160,111.9,160,104a32,32,0,0,0-64,0,8,8,0,0,1-16,0,48,48,0,0,1,96,0c0,15.7-9.3,23.7-16.8,30.1S148,144.1,148,152a12,12,0,0,0,24,0,8,8,0,0,1,16,0ZM128,16a88.1,88.1,0,0,0-88,88c0,33.5,12.5,45.5,22.5,55.2,7.8,7.5,13.5,13,13.5,28.8a52,52,0,0,0,92.1,33.1,8.1,8.1,0,0,0-1.1-11.3,7.9,7.9,0,0,0-11.2,1.1A36,36,0,0,1,92,188c0-22.6-9.8-32-18.4-40.4S56,130.7,56,104a72,72,0,0,1,144,0,8,8,0,0,0,16,0A88.1,88.1,0,0,0,128,16Z" }, null, -1), flt = [
  wlt
], glt = { key: 3 }, xlt = ["stroke"], jlt = ["stroke"], mlt = { key: 4 }, Mlt = ["stroke"], vlt = ["stroke"], Slt = { key: 5 }, Hlt = ["stroke"], Alt = ["stroke"], Vlt = {
  name: "PhEar"
}, mE1 = /* @__PURE__ */ $({
  ...Vlt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", clt, [
        e("path", {
          d: "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84a80,80,0,0,1,160,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hlt),
        e("path", {
          d: "M178.3,160a20,20,0,0,1-38.3-8c0-24,28-24,28-48a40,40,0,0,0-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ult)
      ])) : o(i) === "duotone" ? (s(), r("g", alt, [
        _lt,
        e("path", {
          d: "M180,152a20,20,0,0,1-40,0c0-24,28-24,28-48a40,40,0,0,0-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, plt),
        e("path", {
          d: "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84a80,80,0,0,1,160,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ylt)
      ])) : o(i) === "fill" ? (s(), r("g", $lt, flt)) : o(i) === "light" ? (s(), r("g", glt, [
        e("path", {
          d: "M180,152a20,20,0,0,1-40,0c0-24,28-24,28-48a40,40,0,0,0-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xlt),
        e("path", {
          d: "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84a80,80,0,0,1,160,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jlt)
      ])) : o(i) === "thin" ? (s(), r("g", mlt, [
        e("path", {
          d: "M180,152a20,20,0,0,1-40,0c0-24,28-24,28-48a40,40,0,0,0-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Mlt),
        e("path", {
          d: "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84a80,80,0,0,1,160,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vlt)
      ])) : o(i) === "regular" ? (s(), r("g", Slt, [
        e("path", {
          d: "M180,152a20,20,0,0,1-40,0c0-24,28-24,28-48a40,40,0,0,0-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hlt),
        e("path", {
          d: "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84a80,80,0,0,1,160,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Alt)
      ])) : g("", !0)
    ], 16, klt));
  }
}), zlt = ["width", "height", "fill", "transform"], Zlt = { key: 0 }, Clt = ["stroke"], blt = ["stroke"], Llt = ["stroke"], Blt = ["stroke"], Plt = ["stroke"], Wlt = ["stroke"], Nlt = { key: 1 }, Flt = /* @__PURE__ */ e("path", {
  d: "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84a80,80,0,0,1,160,0C208,144,209,169,161.9,216Z",
  opacity: "0.2"
}, null, -1), Tlt = ["stroke"], Dlt = ["stroke"], Rlt = ["stroke"], Ult = ["stroke"], qlt = ["stroke"], Glt = ["stroke"], Elt = { key: 2 }, Olt = /* @__PURE__ */ e("path", { d: "M213.9,210.6a7.9,7.9,0,0,1-.5,11.3A8.2,8.2,0,0,1,208,224a8,8,0,0,1-5.9-2.6l-37.9-41.7a29.7,29.7,0,0,1-4.2.3,28.1,28.1,0,0,1-28-28,31.1,31.1,0,0,1,.7-6.9L96,104.7a8,8,0,0,1-16-.7,50.4,50.4,0,0,1,2.2-14.5L64.5,70A71.4,71.4,0,0,0,56,104c0,26.7,8.5,34.9,17.6,43.6S92,165.4,92,188a36,36,0,0,0,63.8,22.9,7.9,7.9,0,0,1,11.2-1.1,8.1,8.1,0,0,1,1.1,11.3A52,52,0,0,1,76,188c0-15.8-5.7-21.3-13.5-28.8C52.5,149.5,40,137.5,40,104A87.8,87.8,0,0,1,53.2,57.6L42.1,45.4A8,8,0,0,1,53.9,34.6L69.2,51.5h.1l28,30.8h0l75.4,83h0ZM91.1,42.2A72,72,0,0,1,200,104a8,8,0,0,0,16,0A88,88,0,0,0,82.9,28.4a8,8,0,0,0-2.8,11A8.1,8.1,0,0,0,91.1,42.2Zm67.2,83.2a7.7,7.7,0,0,0,4.8,1.6,8,8,0,0,0,6.4-3.2A31.6,31.6,0,0,0,176,104a48,48,0,0,0-48-48,48.6,48.6,0,0,0-15.6,2.6,8,8,0,0,0,5.2,15.1A32.9,32.9,0,0,1,128,72a32.1,32.1,0,0,1,32,32,16,16,0,0,1-3.3,10.2A7.9,7.9,0,0,0,158.3,125.4Z" }, null, -1), Ilt = [
  Olt
], Klt = { key: 3 }, Xlt = ["stroke"], Jlt = ["stroke"], Qlt = ["stroke"], Ylt = ["stroke"], o2t = ["stroke"], e2t = ["stroke"], t2t = { key: 4 }, n2t = ["stroke"], s2t = ["stroke"], r2t = ["stroke"], i2t = ["stroke"], l2t = ["stroke"], d2t = ["stroke"], k2t = { key: 5 }, c2t = ["stroke"], h2t = ["stroke"], u2t = ["stroke"], a2t = ["stroke"], _2t = ["stroke"], p2t = ["stroke"], y2t = {
  name: "PhEarSlash"
}, ME1 = /* @__PURE__ */ $({
  ...y2t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Zlt, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Clt),
        e("path", {
          d: "M91.4,87.8A39.5,39.5,0,0,0,88,104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, blt),
        e("path", {
          d: "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84A79.9,79.9,0,0,1,63.3,56.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Llt),
        e("path", {
          d: "M166.9,170.8A20.1,20.1,0,0,1,140,152a25.5,25.5,0,0,1,1.6-9.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Blt),
        e("path", {
          d: "M94.3,31.4A80.1,80.1,0,0,1,208,104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Plt),
        e("path", {
          d: "M167,111.4a27.6,27.6,0,0,0,1-7.4,40,40,0,0,0-40-40l-3.9.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wlt)
      ])) : o(i) === "duotone" ? (s(), r("g", Nlt, [
        Flt,
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tlt),
        e("path", {
          d: "M91.4,87.8A39.5,39.5,0,0,0,88,104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dlt),
        e("path", {
          d: "M87,35.3A80,80,0,0,1,208,104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rlt),
        e("path", {
          d: "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84A79.9,79.9,0,0,1,63.3,56.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ult),
        e("path", {
          d: "M163.1,119a24,24,0,0,0,4.9-15,39.9,39.9,0,0,0-53-37.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qlt),
        e("path", {
          d: "M166.9,170.8A20.1,20.1,0,0,1,140,152a25.5,25.5,0,0,1,1.6-9.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Glt)
      ])) : o(i) === "fill" ? (s(), r("g", Elt, Ilt)) : o(i) === "light" ? (s(), r("g", Klt, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xlt),
        e("path", {
          d: "M91.4,87.8A39.5,39.5,0,0,0,88,104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jlt),
        e("path", {
          d: "M87,35.3A80,80,0,0,1,208,104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qlt),
        e("path", {
          d: "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84A79.9,79.9,0,0,1,63.3,56.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ylt),
        e("path", {
          d: "M163.1,119a24,24,0,0,0,4.9-15,39.9,39.9,0,0,0-53-37.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, o2t),
        e("path", {
          d: "M166.9,170.8A20.1,20.1,0,0,1,140,152a25.5,25.5,0,0,1,1.6-9.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, e2t)
      ])) : o(i) === "thin" ? (s(), r("g", t2t, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, n2t),
        e("path", {
          d: "M91.4,87.8A39.5,39.5,0,0,0,88,104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, s2t),
        e("path", {
          d: "M87,35.3A80,80,0,0,1,208,104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, r2t),
        e("path", {
          d: "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84A79.9,79.9,0,0,1,63.3,56.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, i2t),
        e("path", {
          d: "M163.1,119a24,24,0,0,0,4.9-15,39.9,39.9,0,0,0-53-37.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, l2t),
        e("path", {
          d: "M166.9,170.8A20.1,20.1,0,0,1,140,152a25.5,25.5,0,0,1,1.6-9.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, d2t)
      ])) : o(i) === "regular" ? (s(), r("g", k2t, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c2t),
        e("path", {
          d: "M91.4,87.8A39.5,39.5,0,0,0,88,104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h2t),
        e("path", {
          d: "M87,35.3A80,80,0,0,1,208,104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u2t),
        e("path", {
          d: "M161.9,216A44,44,0,0,1,84,188c0-41.5-36-28-36-84A79.9,79.9,0,0,1,63.3,56.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a2t),
        e("path", {
          d: "M163.1,119a24,24,0,0,0,4.9-15,39.9,39.9,0,0,0-53-37.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _2t),
        e("path", {
          d: "M166.9,170.8A20.1,20.1,0,0,1,140,152a25.5,25.5,0,0,1,1.6-9.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p2t)
      ])) : g("", !0)
    ], 16, zlt));
  }
}), $2t = ["width", "height", "fill", "transform"], w2t = { key: 0 }, f2t = ["stroke"], g2t = { key: 1 }, x2t = /* @__PURE__ */ e("path", {
  d: "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
  opacity: "0.2"
}, null, -1), j2t = ["stroke"], m2t = { key: 2 }, M2t = /* @__PURE__ */ e("path", { d: "M216,152a88,88,0,0,1-176,0c0-30.8,10.7-64.5,29.3-92.4S109.5,16,128,16s40.5,16.3,58.7,43.6S216,121.2,216,152Z" }, null, -1), v2t = [
  M2t
], S2t = { key: 3 }, H2t = ["stroke"], A2t = { key: 4 }, V2t = ["stroke"], z2t = { key: 5 }, Z2t = ["stroke"], C2t = {
  name: "PhEgg"
}, vE1 = /* @__PURE__ */ $({
  ...C2t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", w2t, [
        e("path", {
          d: "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f2t)
      ])) : o(i) === "duotone" ? (s(), r("g", g2t, [
        x2t,
        e("path", {
          d: "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j2t)
      ])) : o(i) === "fill" ? (s(), r("g", m2t, v2t)) : o(i) === "light" ? (s(), r("g", S2t, [
        e("path", {
          d: "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, H2t)
      ])) : o(i) === "thin" ? (s(), r("g", A2t, [
        e("path", {
          d: "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, V2t)
      ])) : o(i) === "regular" ? (s(), r("g", z2t, [
        e("path", {
          d: "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z2t)
      ])) : g("", !0)
    ], 16, $2t));
  }
}), b2t = ["width", "height", "fill", "transform"], L2t = { key: 0 }, B2t = ["stroke"], P2t = ["stroke"], W2t = { key: 1 }, N2t = /* @__PURE__ */ e("path", {
  d: "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
  opacity: "0.2"
}, null, -1), F2t = ["stroke"], T2t = ["stroke"], D2t = { key: 2 }, R2t = /* @__PURE__ */ e("path", { d: "M186.7,59.6l-.7-1.1a4.1,4.1,0,0,0-6.3-.4L143.5,98.4l18,7a8.1,8.1,0,0,1,5,9l-7.2,37.1a8.1,8.1,0,0,1-7.9,6.5h-1.5a8.4,8.4,0,0,1-6.3-9.7l5.9-30.3-22.6-8.7a8.3,8.3,0,0,1-4.9-5.6,8.1,8.1,0,0,1,1.8-7.2l46.6-51.9a4,4,0,0,0-.1-5.5c-14.1-14.7-29-23-42.3-23-18.5,0-40.5,16.3-58.7,43.6s-28,57.6-29.2,86.8C38,197,77.6,240.1,128.2,240A88.1,88.1,0,0,0,216,152C216,121.2,205.3,87.5,186.7,59.6Z" }, null, -1), U2t = [
  R2t
], q2t = { key: 3 }, G2t = ["stroke"], E2t = ["stroke"], O2t = { key: 4 }, I2t = ["stroke"], K2t = ["stroke"], X2t = { key: 5 }, J2t = ["stroke"], Q2t = ["stroke"], Y2t = {
  name: "PhEggCrack"
}, SE1 = /* @__PURE__ */ $({
  ...Y2t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", L2t, [
        e("path", {
          d: "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, B2t),
        e("polyline", {
          points: "151.4 150 158.6 112.9 129.8 101.7 172.7 53.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, P2t)
      ])) : o(i) === "duotone" ? (s(), r("g", W2t, [
        N2t,
        e("path", {
          d: "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F2t),
        e("polyline", {
          points: "151.4 150 158.6 112.9 129.8 101.7 172.7 53.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T2t)
      ])) : o(i) === "fill" ? (s(), r("g", D2t, U2t)) : o(i) === "light" ? (s(), r("g", q2t, [
        e("path", {
          d: "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, G2t),
        e("polyline", {
          points: "151.4 150 158.6 112.9 129.8 101.7 172.7 53.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, E2t)
      ])) : o(i) === "thin" ? (s(), r("g", O2t, [
        e("path", {
          d: "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, I2t),
        e("polyline", {
          points: "151.4 150 158.6 112.9 129.8 101.7 172.7 53.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, K2t)
      ])) : o(i) === "regular" ? (s(), r("g", X2t, [
        e("path", {
          d: "M208,152a80,80,0,0,1-160,0C48,88,96,24,128,24S208,88,208,152Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J2t),
        e("polyline", {
          points: "151.4 150 158.6 112.9 129.8 101.7 172.7 53.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q2t)
      ])) : g("", !0)
    ], 16, b2t));
  }
}), o0t = ["width", "height", "fill", "transform"], e0t = { key: 0 }, t0t = ["stroke"], n0t = ["stroke"], s0t = { key: 1 }, r0t = /* @__PURE__ */ e("path", {
  d: "M122.1,38.4,44.4,122.6A8,8,0,0,0,50.3,136H205.7a8,8,0,0,0,5.9-13.4L133.9,38.4A7.9,7.9,0,0,0,122.1,38.4Z",
  opacity: "0.2"
}, null, -1), i0t = /* @__PURE__ */ e("rect", {
  x: "108",
  y: "100",
  width: "40",
  height: "176",
  rx: "8",
  transform: "translate(-60 316) rotate(-90)",
  opacity: "0.2"
}, null, -1), l0t = ["stroke"], d0t = ["stroke"], k0t = { key: 2 }, c0t = /* @__PURE__ */ e("path", { d: "M35.6,134.4a15.8,15.8,0,0,1,2.9-17.3l77.7-84.2h0a16.2,16.2,0,0,1,23.6,0l77.7,84.2A16,16,0,0,1,205.7,144H50.3A15.9,15.9,0,0,1,35.6,134.4ZM208,160H48a16,16,0,0,0-16,16v24a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V176A16,16,0,0,0,208,160Z" }, null, -1), h0t = [
  c0t
], u0t = { key: 3 }, a0t = ["stroke"], _0t = ["stroke"], p0t = { key: 4 }, y0t = ["stroke"], $0t = ["stroke"], w0t = { key: 5 }, f0t = ["stroke"], g0t = ["stroke"], x0t = {
  name: "PhEject"
}, HE1 = /* @__PURE__ */ $({
  ...x0t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", e0t, [
        e("path", {
          d: "M122.1,38.4,45,118.5A8,8,0,0,0,50.8,132H205.2a8,8,0,0,0,5.8-13.5L133.9,38.4A7.9,7.9,0,0,0,122.1,38.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, t0t),
        e("rect", {
          x: "108",
          y: "100",
          width: "40",
          height: "176",
          rx: "8",
          transform: "translate(-60 316) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, n0t)
      ])) : o(i) === "duotone" ? (s(), r("g", s0t, [
        r0t,
        i0t,
        e("path", {
          d: "M122.1,38.4,44.4,122.6A8,8,0,0,0,50.3,136H205.7a8,8,0,0,0,5.9-13.4L133.9,38.4A7.9,7.9,0,0,0,122.1,38.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l0t),
        e("rect", {
          x: "108",
          y: "100",
          width: "40",
          height: "176",
          rx: "8",
          transform: "translate(-60 316) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, d0t)
      ])) : o(i) === "fill" ? (s(), r("g", k0t, h0t)) : o(i) === "light" ? (s(), r("g", u0t, [
        e("path", {
          d: "M122.1,38.4,44.4,122.6A8,8,0,0,0,50.3,136H205.7a8,8,0,0,0,5.9-13.4L133.9,38.4A7.9,7.9,0,0,0,122.1,38.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, a0t),
        e("rect", {
          x: "108",
          y: "100",
          width: "40",
          height: "176",
          rx: "8",
          transform: "translate(-60 316) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _0t)
      ])) : o(i) === "thin" ? (s(), r("g", p0t, [
        e("path", {
          d: "M122.1,38.4,44.4,122.6A8,8,0,0,0,50.3,136H205.7a8,8,0,0,0,5.9-13.4L133.9,38.4A7.9,7.9,0,0,0,122.1,38.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, y0t),
        e("rect", {
          x: "108",
          y: "100",
          width: "40",
          height: "176",
          rx: "8",
          transform: "translate(-60 316) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $0t)
      ])) : o(i) === "regular" ? (s(), r("g", w0t, [
        e("path", {
          d: "M122.1,38.4,44.4,122.6A8,8,0,0,0,50.3,136H205.7a8,8,0,0,0,5.9-13.4L133.9,38.4A7.9,7.9,0,0,0,122.1,38.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f0t),
        e("rect", {
          x: "108",
          y: "100",
          width: "40",
          height: "176",
          rx: "8",
          transform: "translate(-60 316) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g0t)
      ])) : g("", !0)
    ], 16, o0t));
  }
}), j0t = ["width", "height", "fill", "transform"], m0t = { key: 0 }, M0t = ["stroke"], v0t = ["stroke"], S0t = { key: 1 }, H0t = /* @__PURE__ */ e("path", {
  d: "M121.8,39.6,34.6,147a8,8,0,0,0,6.2,13H215.2a8,8,0,0,0,6.2-13L134.2,39.6A8,8,0,0,0,121.8,39.6Z",
  opacity: "0.2"
}, null, -1), A0t = ["stroke"], V0t = ["stroke"], z0t = { key: 2 }, Z0t = /* @__PURE__ */ e("path", { d: "M26.4,158.9a15.9,15.9,0,0,1,2-17L115.6,34.6a16,16,0,0,1,24.8,0l87.2,107.3A16,16,0,0,1,215.2,168H40.8A15.8,15.8,0,0,1,26.4,158.9ZM224,200H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16Z" }, null, -1), C0t = [
  Z0t
], b0t = { key: 3 }, L0t = ["stroke"], B0t = ["stroke"], P0t = { key: 4 }, W0t = ["stroke"], N0t = ["stroke"], F0t = { key: 5 }, T0t = ["stroke"], D0t = ["stroke"], R0t = {
  name: "PhEjectSimple"
}, AE1 = /* @__PURE__ */ $({
  ...R0t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", m0t, [
        e("path", {
          d: "M121.8,39.6,34.6,147a8,8,0,0,0,6.2,13H215.2a8,8,0,0,0,6.2-13L134.2,39.6A8,8,0,0,0,121.8,39.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, M0t),
        e("line", {
          x1: "224",
          y1: "208",
          x2: "32",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, v0t)
      ])) : o(i) === "duotone" ? (s(), r("g", S0t, [
        H0t,
        e("path", {
          d: "M121.8,39.6,34.6,147a8,8,0,0,0,6.2,13H215.2a8,8,0,0,0,6.2-13L134.2,39.6A8,8,0,0,0,121.8,39.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A0t),
        e("line", {
          x1: "224",
          y1: "208",
          x2: "32",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, V0t)
      ])) : o(i) === "fill" ? (s(), r("g", z0t, C0t)) : o(i) === "light" ? (s(), r("g", b0t, [
        e("path", {
          d: "M121.8,39.6,34.6,147a8,8,0,0,0,6.2,13H215.2a8,8,0,0,0,6.2-13L134.2,39.6A8,8,0,0,0,121.8,39.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, L0t),
        e("line", {
          x1: "224",
          y1: "208",
          x2: "32",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, B0t)
      ])) : o(i) === "thin" ? (s(), r("g", P0t, [
        e("path", {
          d: "M121.8,39.6,34.6,147a8,8,0,0,0,6.2,13H215.2a8,8,0,0,0,6.2-13L134.2,39.6A8,8,0,0,0,121.8,39.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, W0t),
        e("line", {
          x1: "224",
          y1: "208",
          x2: "32",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, N0t)
      ])) : o(i) === "regular" ? (s(), r("g", F0t, [
        e("path", {
          d: "M121.8,39.6,34.6,147a8,8,0,0,0,6.2,13H215.2a8,8,0,0,0,6.2-13L134.2,39.6A8,8,0,0,0,121.8,39.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T0t),
        e("line", {
          x1: "224",
          y1: "208",
          x2: "32",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D0t)
      ])) : g("", !0)
    ], 16, j0t));
  }
}), U0t = ["width", "height", "fill", "transform"], q0t = { key: 0 }, G0t = ["stroke"], E0t = ["stroke"], O0t = ["stroke"], I0t = ["stroke"], K0t = { key: 1 }, X0t = /* @__PURE__ */ e("polygon", {
  points: "224 56 128 144 32 56 224 56",
  opacity: "0.2"
}, null, -1), J0t = ["stroke"], Q0t = ["stroke"], Y0t = ["stroke"], o8t = ["stroke"], e8t = { key: 2 }, t8t = /* @__PURE__ */ e("path", { d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM98.7,128,40,181.8V74.2Zm11.8,10.9,12.1,11a8,8,0,0,0,10.8,0l12.1-11L203.4,192H52.6ZM157.3,128,216,74.2V181.8Z" }, null, -1), n8t = [
  t8t
], s8t = { key: 3 }, r8t = ["stroke"], i8t = ["stroke"], l8t = ["stroke"], d8t = ["stroke"], k8t = { key: 4 }, c8t = ["stroke"], h8t = ["stroke"], u8t = ["stroke"], a8t = ["stroke"], _8t = { key: 5 }, p8t = ["stroke"], y8t = ["stroke"], $8t = ["stroke"], w8t = ["stroke"], f8t = {
  name: "PhEnvelope"
}, VE1 = /* @__PURE__ */ $({
  ...f8t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", q0t, [
        e("polyline", {
          points: "224 56 128 144 32 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, G0t),
        e("path", {
          d: "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56a0,0,0,0,1,0,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, E0t),
        e("line", {
          x1: "110.5",
          y1: "128",
          x2: "34.5",
          y2: "197.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, O0t),
        e("line", {
          x1: "221.5",
          y1: "197.7",
          x2: "145.5",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, I0t)
      ])) : o(i) === "duotone" ? (s(), r("g", K0t, [
        X0t,
        e("polyline", {
          points: "224 56 128 144 32 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J0t),
        e("path", {
          d: "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q0t),
        e("line", {
          x1: "110.5",
          y1: "128",
          x2: "34.5",
          y2: "197.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y0t),
        e("line", {
          x1: "221.5",
          y1: "197.7",
          x2: "145.5",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o8t)
      ])) : o(i) === "fill" ? (s(), r("g", e8t, n8t)) : o(i) === "light" ? (s(), r("g", s8t, [
        e("polyline", {
          points: "224 56 128 144 32 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, r8t),
        e("path", {
          d: "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, i8t),
        e("line", {
          x1: "110.5",
          y1: "128",
          x2: "34.5",
          y2: "197.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, l8t),
        e("line", {
          x1: "221.5",
          y1: "197.7",
          x2: "145.5",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, d8t)
      ])) : o(i) === "thin" ? (s(), r("g", k8t, [
        e("polyline", {
          points: "224 56 128 144 32 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, c8t),
        e("path", {
          d: "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, h8t),
        e("line", {
          x1: "110.5",
          y1: "128",
          x2: "34.5",
          y2: "197.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, u8t),
        e("line", {
          x1: "221.5",
          y1: "197.7",
          x2: "145.5",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, a8t)
      ])) : o(i) === "regular" ? (s(), r("g", _8t, [
        e("polyline", {
          points: "224 56 128 144 32 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p8t),
        e("path", {
          d: "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y8t),
        e("line", {
          x1: "110.5",
          y1: "128",
          x2: "34.5",
          y2: "197.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $8t),
        e("line", {
          x1: "221.5",
          y1: "197.7",
          x2: "145.5",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w8t)
      ])) : g("", !0)
    ], 16, U0t));
  }
}), g8t = ["width", "height", "fill", "transform"], x8t = { key: 0 }, j8t = ["stroke"], m8t = ["stroke"], M8t = ["stroke"], v8t = ["stroke"], S8t = { key: 1 }, H8t = /* @__PURE__ */ e("polygon", {
  points: "224 96 145.5 152 110.5 152 32 96 128 32 224 96",
  opacity: "0.2"
}, null, -1), A8t = ["stroke"], V8t = ["stroke"], z8t = ["stroke"], Z8t = ["stroke"], C8t = { key: 2 }, b8t = /* @__PURE__ */ e("path", { d: "M228.4,89.3l-96-64a8.2,8.2,0,0,0-8.8,0l-96,64A7.9,7.9,0,0,0,24,96V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V96A7.9,7.9,0,0,0,228.4,89.3ZM96.7,152,40,192V111.5Zm16.4,8h29.8l56.6,40H56.5Zm46.2-8L216,111.5V192Z" }, null, -1), L8t = [
  b8t
], B8t = { key: 3 }, P8t = ["stroke"], W8t = ["stroke"], N8t = ["stroke"], F8t = ["stroke"], T8t = { key: 4 }, D8t = ["stroke"], R8t = ["stroke"], U8t = ["stroke"], q8t = ["stroke"], G8t = { key: 5 }, E8t = ["stroke"], O8t = ["stroke"], I8t = ["stroke"], K8t = ["stroke"], X8t = {
  name: "PhEnvelopeOpen"
}, zE1 = /* @__PURE__ */ $({
  ...X8t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", x8t, [
        e("path", {
          d: "M224,96V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V96l96-64Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, j8t),
        e("line", {
          x1: "110.5",
          y1: "152",
          x2: "34.5",
          y2: "205.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, m8t),
        e("line", {
          x1: "221.5",
          y1: "205.7",
          x2: "145.5",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, M8t),
        e("polyline", {
          points: "224 96 145.5 152 110.5 152 32 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, v8t)
      ])) : o(i) === "duotone" ? (s(), r("g", S8t, [
        H8t,
        e("path", {
          d: "M32,96V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V96L128,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A8t),
        e("line", {
          x1: "110.5",
          y1: "152",
          x2: "34.5",
          y2: "205.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, V8t),
        e("line", {
          x1: "221.5",
          y1: "205.7",
          x2: "145.5",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, z8t),
        e("polyline", {
          points: "224 96 145.5 152 110.5 152 32 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z8t)
      ])) : o(i) === "fill" ? (s(), r("g", C8t, L8t)) : o(i) === "light" ? (s(), r("g", B8t, [
        e("path", {
          d: "M224,96V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V96l96-64Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, P8t),
        e("line", {
          x1: "110.5",
          y1: "152",
          x2: "34.5",
          y2: "205.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, W8t),
        e("line", {
          x1: "221.5",
          y1: "205.7",
          x2: "145.5",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, N8t),
        e("polyline", {
          points: "224 96 145.5 152 110.5 152 32 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, F8t)
      ])) : o(i) === "thin" ? (s(), r("g", T8t, [
        e("path", {
          d: "M224,96V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V96l96-64Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, D8t),
        e("line", {
          x1: "110.5",
          y1: "152",
          x2: "34.5",
          y2: "205.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, R8t),
        e("line", {
          x1: "221.5",
          y1: "205.7",
          x2: "145.5",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, U8t),
        e("polyline", {
          points: "224 96 145.5 152 110.5 152 32 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, q8t)
      ])) : o(i) === "regular" ? (s(), r("g", G8t, [
        e("path", {
          d: "M32,96V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V96L128,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E8t),
        e("line", {
          x1: "110.5",
          y1: "152",
          x2: "34.5",
          y2: "205.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O8t),
        e("line", {
          x1: "221.5",
          y1: "205.7",
          x2: "145.5",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I8t),
        e("polyline", {
          points: "224 96 145.5 152 110.5 152 32 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K8t)
      ])) : g("", !0)
    ], 16, g8t));
  }
}), J8t = ["width", "height", "fill", "transform"], Q8t = { key: 0 }, Y8t = ["stroke"], odt = ["stroke"], edt = { key: 1 }, tdt = /* @__PURE__ */ e("polygon", {
  points: "224 56 128 144 32 56 224 56",
  opacity: "0.2"
}, null, -1), ndt = ["stroke"], sdt = ["stroke"], rdt = { key: 2 }, idt = /* @__PURE__ */ e("path", { d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48Zm-8,144H40V74.2l82.6,75.7a8,8,0,0,0,10.8,0L216,74.2V192Z" }, null, -1), ldt = [
  idt
], ddt = { key: 3 }, kdt = ["stroke"], cdt = ["stroke"], hdt = { key: 4 }, udt = ["stroke"], adt = ["stroke"], _dt = { key: 5 }, pdt = ["stroke"], ydt = ["stroke"], $dt = {
  name: "PhEnvelopeSimple"
}, ZE1 = /* @__PURE__ */ $({
  ...$dt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Q8t, [
        e("path", {
          d: "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Y8t),
        e("polyline", {
          points: "224 56 128 144 32 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, odt)
      ])) : o(i) === "duotone" ? (s(), r("g", edt, [
        tdt,
        e("path", {
          d: "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ndt),
        e("polyline", {
          points: "224 56 128 144 32 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sdt)
      ])) : o(i) === "fill" ? (s(), r("g", rdt, ldt)) : o(i) === "light" ? (s(), r("g", ddt, [
        e("path", {
          d: "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kdt),
        e("polyline", {
          points: "224 56 128 144 32 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cdt)
      ])) : o(i) === "thin" ? (s(), r("g", hdt, [
        e("path", {
          d: "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, udt),
        e("polyline", {
          points: "224 56 128 144 32 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, adt)
      ])) : o(i) === "regular" ? (s(), r("g", _dt, [
        e("path", {
          d: "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pdt),
        e("polyline", {
          points: "224 56 128 144 32 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ydt)
      ])) : g("", !0)
    ], 16, J8t));
  }
}), wdt = ["width", "height", "fill", "transform"], fdt = { key: 0 }, gdt = ["stroke"], xdt = ["stroke"], jdt = { key: 1 }, mdt = /* @__PURE__ */ e("polygon", {
  points: "224 96 145.5 152 110.5 152 32 96 128 32 224 96",
  opacity: "0.2"
}, null, -1), Mdt = ["stroke"], vdt = ["stroke"], Sdt = { key: 2 }, Hdt = /* @__PURE__ */ e("path", { d: "M228.4,89.3l-96-64a8.2,8.2,0,0,0-8.8,0l-96,64A7.9,7.9,0,0,0,24,96V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V96A7.9,7.9,0,0,0,228.4,89.3ZM40,200V111.5l65.9,47a7.9,7.9,0,0,0,4.6,1.5h35a7.9,7.9,0,0,0,4.6-1.5l65.9-47V200Z" }, null, -1), Adt = [
  Hdt
], Vdt = { key: 3 }, zdt = ["stroke"], Zdt = ["stroke"], Cdt = { key: 4 }, bdt = ["stroke"], Ldt = ["stroke"], Bdt = { key: 5 }, Pdt = ["stroke"], Wdt = ["stroke"], Ndt = {
  name: "PhEnvelopeSimpleOpen"
}, CE1 = /* @__PURE__ */ $({
  ...Ndt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", fdt, [
        e("path", {
          d: "M224,96V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V96l96-64Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gdt),
        e("polyline", {
          points: "224 96 145.5 152 110.5 152 32 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xdt)
      ])) : o(i) === "duotone" ? (s(), r("g", jdt, [
        mdt,
        e("path", {
          d: "M32,96V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V96L128,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mdt),
        e("polyline", {
          points: "224 96 145.5 152 110.5 152 32 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vdt)
      ])) : o(i) === "fill" ? (s(), r("g", Sdt, Adt)) : o(i) === "light" ? (s(), r("g", Vdt, [
        e("path", {
          d: "M32,96V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V96L128,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zdt),
        e("polyline", {
          points: "224 96 145.5 152 110.5 152 32 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zdt)
      ])) : o(i) === "thin" ? (s(), r("g", Cdt, [
        e("path", {
          d: "M32,96V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V96L128,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bdt),
        e("polyline", {
          points: "224 96 145.5 152 110.5 152 32 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ldt)
      ])) : o(i) === "regular" ? (s(), r("g", Bdt, [
        e("path", {
          d: "M32,96V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V96L128,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pdt),
        e("polyline", {
          points: "224 96 145.5 152 110.5 152 32 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wdt)
      ])) : g("", !0)
    ], 16, wdt));
  }
}), Fdt = ["width", "height", "fill", "transform"], Tdt = { key: 0 }, Ddt = ["stroke"], Rdt = ["stroke"], Udt = ["stroke"], qdt = ["stroke"], Gdt = ["stroke"], Edt = ["stroke"], Odt = ["stroke"], Idt = ["stroke"], Kdt = ["stroke"], Xdt = { key: 1 }, Jdt = ["stroke"], Qdt = ["stroke"], Ydt = ["stroke"], okt = ["stroke"], ekt = ["stroke"], tkt = ["stroke"], nkt = ["stroke"], skt = ["stroke"], rkt = ["stroke"], ikt = ["stroke"], lkt = ["stroke"], dkt = ["stroke"], kkt = { key: 2 }, ckt = /* @__PURE__ */ e("path", { d: "M84,96a8,8,0,0,1-8,8H36a8,8,0,0,1,0-16H76A8,8,0,0,1,84,96Zm-8,24H36a8,8,0,0,0,0,16H76a8,8,0,0,0,0-16Zm0,32H36a8,8,0,0,0,0,16H76a8,8,0,0,0,0-16Zm0,32H36a8,8,0,0,0,0,16H76a8,8,0,0,0,0-16Zm72-64H108a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Zm0,32H108a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Zm0,32H108a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Zm72-96H180a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16ZM180,72h40a8,8,0,0,0,0-16H180a8,8,0,0,0,0,16Zm40,48H180a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Zm0,32H180a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Zm0,32H180a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Z" }, null, -1), hkt = [
  ckt
], ukt = { key: 3 }, akt = ["stroke"], _kt = ["stroke"], pkt = ["stroke"], ykt = ["stroke"], $kt = ["stroke"], wkt = ["stroke"], fkt = ["stroke"], gkt = ["stroke"], xkt = ["stroke"], jkt = ["stroke"], mkt = ["stroke"], Mkt = ["stroke"], vkt = { key: 4 }, Skt = ["stroke"], Hkt = ["stroke"], Akt = ["stroke"], Vkt = ["stroke"], zkt = ["stroke"], Zkt = ["stroke"], Ckt = ["stroke"], bkt = ["stroke"], Lkt = ["stroke"], Bkt = ["stroke"], Pkt = ["stroke"], Wkt = ["stroke"], Nkt = { key: 5 }, Fkt = ["stroke"], Tkt = ["stroke"], Dkt = ["stroke"], Rkt = ["stroke"], Ukt = ["stroke"], qkt = ["stroke"], Gkt = ["stroke"], Ekt = ["stroke"], Okt = ["stroke"], Ikt = ["stroke"], Kkt = ["stroke"], Xkt = ["stroke"], Jkt = {
  name: "PhEqualizer"
}, bE1 = /* @__PURE__ */ $({
  ...Jkt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Tdt, [
        e("line", {
          x1: "36",
          y1: "108",
          x2: "72",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ddt),
        e("line", {
          x1: "36",
          y1: "148",
          x2: "72",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rdt),
        e("line", {
          x1: "36",
          y1: "192",
          x2: "72",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Udt),
        e("line", {
          x1: "110",
          y1: "148",
          x2: "146",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qdt),
        e("line", {
          x1: "110",
          y1: "192",
          x2: "146",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gdt),
        e("line", {
          x1: "184",
          y1: "68",
          x2: "220",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Edt),
        e("line", {
          x1: "184",
          y1: "108",
          x2: "220",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Odt),
        e("line", {
          x1: "184",
          y1: "148",
          x2: "220",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Idt),
        e("line", {
          x1: "184",
          y1: "188",
          x2: "220",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kdt)
      ])) : o(i) === "duotone" ? (s(), r("g", Xdt, [
        e("line", {
          x1: "36",
          y1: "96",
          x2: "76",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jdt),
        e("line", {
          x1: "36",
          y1: "128",
          x2: "76",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qdt),
        e("line", {
          x1: "36",
          y1: "160",
          x2: "76",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ydt),
        e("line", {
          x1: "36",
          y1: "192",
          x2: "76",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, okt),
        e("line", {
          x1: "108",
          y1: "128",
          x2: "148",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ekt),
        e("line", {
          x1: "108",
          y1: "160",
          x2: "148",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tkt),
        e("line", {
          x1: "108",
          y1: "192",
          x2: "148",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nkt),
        e("line", {
          x1: "180",
          y1: "96",
          x2: "220",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, skt),
        e("line", {
          x1: "180",
          y1: "64",
          x2: "220",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rkt),
        e("line", {
          x1: "180",
          y1: "128",
          x2: "220",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ikt),
        e("line", {
          x1: "180",
          y1: "160",
          x2: "220",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lkt),
        e("line", {
          x1: "180",
          y1: "192",
          x2: "220",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dkt)
      ])) : o(i) === "fill" ? (s(), r("g", kkt, hkt)) : o(i) === "light" ? (s(), r("g", ukt, [
        e("line", {
          x1: "36",
          y1: "96",
          x2: "76",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, akt),
        e("line", {
          x1: "36",
          y1: "128",
          x2: "76",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _kt),
        e("line", {
          x1: "36",
          y1: "160",
          x2: "76",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pkt),
        e("line", {
          x1: "36",
          y1: "192",
          x2: "76",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ykt),
        e("line", {
          x1: "108",
          y1: "128",
          x2: "148",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $kt),
        e("line", {
          x1: "108",
          y1: "160",
          x2: "148",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wkt),
        e("line", {
          x1: "108",
          y1: "192",
          x2: "148",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fkt),
        e("line", {
          x1: "180",
          y1: "96",
          x2: "220",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gkt),
        e("line", {
          x1: "180",
          y1: "64",
          x2: "220",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xkt),
        e("line", {
          x1: "180",
          y1: "128",
          x2: "220",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jkt),
        e("line", {
          x1: "180",
          y1: "160",
          x2: "220",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mkt),
        e("line", {
          x1: "180",
          y1: "192",
          x2: "220",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mkt)
      ])) : o(i) === "thin" ? (s(), r("g", vkt, [
        e("line", {
          x1: "36",
          y1: "96",
          x2: "76",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Skt),
        e("line", {
          x1: "36",
          y1: "128",
          x2: "76",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hkt),
        e("line", {
          x1: "36",
          y1: "160",
          x2: "76",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Akt),
        e("line", {
          x1: "36",
          y1: "192",
          x2: "76",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vkt),
        e("line", {
          x1: "108",
          y1: "128",
          x2: "148",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zkt),
        e("line", {
          x1: "108",
          y1: "160",
          x2: "148",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zkt),
        e("line", {
          x1: "108",
          y1: "192",
          x2: "148",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ckt),
        e("line", {
          x1: "180",
          y1: "96",
          x2: "220",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bkt),
        e("line", {
          x1: "180",
          y1: "64",
          x2: "220",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lkt),
        e("line", {
          x1: "180",
          y1: "128",
          x2: "220",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bkt),
        e("line", {
          x1: "180",
          y1: "160",
          x2: "220",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pkt),
        e("line", {
          x1: "180",
          y1: "192",
          x2: "220",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wkt)
      ])) : o(i) === "regular" ? (s(), r("g", Nkt, [
        e("line", {
          x1: "36",
          y1: "96",
          x2: "76",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fkt),
        e("line", {
          x1: "36",
          y1: "128",
          x2: "76",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tkt),
        e("line", {
          x1: "36",
          y1: "160",
          x2: "76",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dkt),
        e("line", {
          x1: "36",
          y1: "192",
          x2: "76",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rkt),
        e("line", {
          x1: "108",
          y1: "128",
          x2: "148",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ukt),
        e("line", {
          x1: "108",
          y1: "160",
          x2: "148",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qkt),
        e("line", {
          x1: "108",
          y1: "192",
          x2: "148",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gkt),
        e("line", {
          x1: "180",
          y1: "96",
          x2: "220",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ekt),
        e("line", {
          x1: "180",
          y1: "64",
          x2: "220",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Okt),
        e("line", {
          x1: "180",
          y1: "128",
          x2: "220",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ikt),
        e("line", {
          x1: "180",
          y1: "160",
          x2: "220",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kkt),
        e("line", {
          x1: "180",
          y1: "192",
          x2: "220",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xkt)
      ])) : g("", !0)
    ], 16, Fdt));
  }
}), Qkt = ["width", "height", "fill", "transform"], Ykt = { key: 0 }, oct = ["stroke"], ect = ["stroke"], tct = { key: 1 }, nct = ["stroke"], sct = ["stroke"], rct = { key: 2 }, ict = /* @__PURE__ */ e("path", { d: "M216,152H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1), lct = /* @__PURE__ */ e("path", { d: "M40,104H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z" }, null, -1), dct = [
  ict,
  lct
], kct = { key: 3 }, cct = ["stroke"], hct = ["stroke"], uct = { key: 4 }, act = ["stroke"], _ct = ["stroke"], pct = { key: 5 }, yct = ["stroke"], $ct = ["stroke"], wct = {
  name: "PhEquals"
}, LE1 = /* @__PURE__ */ $({
  ...wct,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ykt, [
        e("line", {
          x1: "40",
          y1: "160",
          x2: "216",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oct),
        e("line", {
          x1: "40",
          y1: "96",
          x2: "216",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ect)
      ])) : o(i) === "duotone" ? (s(), r("g", tct, [
        e("line", {
          x1: "40",
          y1: "160",
          x2: "216",
          y2: "160",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nct),
        e("line", {
          x1: "40",
          y1: "96",
          x2: "216",
          y2: "96",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sct)
      ])) : o(i) === "fill" ? (s(), r("g", rct, dct)) : o(i) === "light" ? (s(), r("g", kct, [
        e("line", {
          x1: "40",
          y1: "160",
          x2: "216",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cct),
        e("line", {
          x1: "40",
          y1: "96",
          x2: "216",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hct)
      ])) : o(i) === "thin" ? (s(), r("g", uct, [
        e("line", {
          x1: "40",
          y1: "160",
          x2: "216",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, act),
        e("line", {
          x1: "40",
          y1: "96",
          x2: "216",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _ct)
      ])) : o(i) === "regular" ? (s(), r("g", pct, [
        e("line", {
          x1: "40",
          y1: "160",
          x2: "216",
          y2: "160",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yct),
        e("line", {
          x1: "40",
          y1: "96",
          x2: "216",
          y2: "96",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $ct)
      ])) : g("", !0)
    ], 16, Qkt));
  }
}), fct = ["width", "height", "fill", "transform"], gct = { key: 0 }, xct = ["stroke"], jct = ["stroke"], mct = { key: 1 }, Mct = /* @__PURE__ */ e("path", {
  d: "M111,215.8H72.1L35,178.7a15.9,15.9,0,0,1,0-22.6L91.5,99.5l67.9,67.9Z",
  opacity: "0.2"
}, null, -1), vct = ["stroke"], Sct = ["stroke"], Hct = { key: 2 }, Act = /* @__PURE__ */ e("path", { d: "M216,207.8H130.3l34.8-34.7h0l56.6-56.6a24.1,24.1,0,0,0,0-33.9L176.4,37.3a24,24,0,0,0-33.9,0L85.9,93.9h0L29.3,150.5a24,24,0,0,0,0,33.9l37.1,37.1a7.9,7.9,0,0,0,5.7,2.3H216a8,8,0,0,0,0-16ZM153.8,48.6a8.1,8.1,0,0,1,11.3,0l45.2,45.3a7.9,7.9,0,0,1,0,11.3l-50.9,50.9L102.9,99.5Z" }, null, -1), Vct = [
  Act
], zct = { key: 3 }, Zct = ["stroke"], Cct = ["stroke"], bct = { key: 4 }, Lct = ["stroke"], Bct = ["stroke"], Pct = { key: 5 }, Wct = ["stroke"], Nct = ["stroke"], Fct = {
  name: "PhEraser"
}, BE1 = /* @__PURE__ */ $({
  ...Fct,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", gct, [
        e("line", {
          x1: "91.5",
          y1: "99.5",
          x2: "159.4",
          y2: "167.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xct),
        e("path", {
          d: "M216,215.8H72.1L35,178.7a15.9,15.9,0,0,1,0-22.6L148.1,43a15.9,15.9,0,0,1,22.6,0L216,88.2a16.2,16.2,0,0,1,0,22.7L111,215.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jct)
      ])) : o(i) === "duotone" ? (s(), r("g", mct, [
        Mct,
        e("line", {
          x1: "91.5",
          y1: "99.5",
          x2: "159.4",
          y2: "167.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vct),
        e("path", {
          d: "M216,215.8H72.1L35,178.7a15.9,15.9,0,0,1,0-22.6L148.1,43a15.9,15.9,0,0,1,22.6,0L216,88.2a16.2,16.2,0,0,1,0,22.7L111,215.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sct)
      ])) : o(i) === "fill" ? (s(), r("g", Hct, Vct)) : o(i) === "light" ? (s(), r("g", zct, [
        e("line", {
          x1: "91.5",
          y1: "99.5",
          x2: "159.4",
          y2: "167.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zct),
        e("path", {
          d: "M216,215.8H72.1L35,178.7a15.9,15.9,0,0,1,0-22.6L148.1,43a15.9,15.9,0,0,1,22.6,0L216,88.2a16.2,16.2,0,0,1,0,22.7L111,215.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cct)
      ])) : o(i) === "thin" ? (s(), r("g", bct, [
        e("line", {
          x1: "91.5",
          y1: "99.5",
          x2: "159.4",
          y2: "167.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lct),
        e("path", {
          d: "M216,215.8H72.1L35,178.7a15.9,15.9,0,0,1,0-22.6L148.1,43a15.9,15.9,0,0,1,22.6,0L216,88.2a16.2,16.2,0,0,1,0,22.7L111,215.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bct)
      ])) : o(i) === "regular" ? (s(), r("g", Pct, [
        e("line", {
          x1: "91.5",
          y1: "99.5",
          x2: "159.4",
          y2: "167.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wct),
        e("path", {
          d: "M216,215.8H72.1L35,178.7a15.9,15.9,0,0,1,0-22.6L148.1,43a15.9,15.9,0,0,1,22.6,0L216,88.2a16.2,16.2,0,0,1,0,22.7L111,215.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nct)
      ])) : g("", !0)
    ], 16, fct));
  }
}), Tct = ["width", "height", "fill", "transform"], Dct = { key: 0 }, Rct = ["stroke"], Uct = ["stroke"], qct = ["stroke"], Gct = ["stroke"], Ect = ["stroke"], Oct = { key: 1 }, Ict = /* @__PURE__ */ e("path", {
  d: "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
  opacity: "0.2"
}, null, -1), Kct = ["stroke"], Xct = ["stroke"], Jct = ["stroke"], Qct = ["stroke"], Yct = ["stroke"], oht = { key: 2 }, eht = /* @__PURE__ */ e("path", { d: "M100,113.9,111.1,136H88.9ZM232,56V216a7.9,7.9,0,0,1-3.8,6.8,8,8,0,0,1-7.8.4L192,208.9l-28.4,14.3a8.5,8.5,0,0,1-7.2,0L128,208.9,99.6,223.2a8.3,8.3,0,0,1-7.2,0L64,208.9,35.6,223.2a8,8,0,0,1-7.8-.4A7.9,7.9,0,0,1,24,216V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56ZM139.2,156.4l-32-64a8.1,8.1,0,0,0-14.4,0l-32,64a8,8,0,0,0,14.4,7.2L80.9,152h38.2l5.7,11.6A8.1,8.1,0,0,0,132,168a9.4,9.4,0,0,0,3.6-.8A8.2,8.2,0,0,0,139.2,156.4ZM204,128a8,8,0,0,0-8-8H184V108a8,8,0,0,0-16,0v12H156a8,8,0,0,0,0,16h12v12a8,8,0,0,0,16,0V136h12A8,8,0,0,0,204,128Z" }, null, -1), tht = [
  eht
], nht = { key: 3 }, sht = ["stroke"], rht = ["stroke"], iht = ["stroke"], lht = ["stroke"], dht = ["stroke"], kht = { key: 4 }, cht = ["stroke"], hht = ["stroke"], uht = ["stroke"], aht = ["stroke"], _ht = ["stroke"], pht = { key: 5 }, yht = ["stroke"], $ht = ["stroke"], wht = ["stroke"], fht = ["stroke"], ght = ["stroke"], xht = {
  name: "PhExam"
}, PE1 = /* @__PURE__ */ $({
  ...xht,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Dct, [
        e("path", {
          d: "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rct),
        e("polyline", {
          points: "68 160 100 96 132 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Uct),
        e("line", {
          x1: "76",
          y1: "144",
          x2: "124",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qct),
        e("line", {
          x1: "156",
          y1: "128",
          x2: "188",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gct),
        e("line", {
          x1: "172",
          y1: "112",
          x2: "172",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ect)
      ])) : o(i) === "duotone" ? (s(), r("g", Oct, [
        Ict,
        e("path", {
          d: "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kct),
        e("polyline", {
          points: "72 160 104 96 136 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xct),
        e("line", {
          x1: "80",
          y1: "144",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jct),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qct),
        e("line", {
          x1: "172",
          y1: "108",
          x2: "172",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yct)
      ])) : o(i) === "fill" ? (s(), r("g", oht, tht)) : o(i) === "light" ? (s(), r("g", nht, [
        e("path", {
          d: "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sht),
        e("polyline", {
          points: "72 160 104 96 136 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rht),
        e("line", {
          x1: "80",
          y1: "144",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iht),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lht),
        e("line", {
          x1: "172",
          y1: "108",
          x2: "172",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dht)
      ])) : o(i) === "thin" ? (s(), r("g", kht, [
        e("path", {
          d: "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cht),
        e("polyline", {
          points: "72 160 104 96 136 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hht),
        e("line", {
          x1: "80",
          y1: "144",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uht),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aht),
        e("line", {
          x1: "172",
          y1: "108",
          x2: "172",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _ht)
      ])) : o(i) === "regular" ? (s(), r("g", pht, [
        e("path", {
          d: "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yht),
        e("polyline", {
          points: "72 160 104 96 136 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $ht),
        e("line", {
          x1: "80",
          y1: "144",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wht),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fht),
        e("line", {
          x1: "172",
          y1: "108",
          x2: "172",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ght)
      ])) : g("", !0)
    ], 16, Tct));
  }
}), jht = ["width", "height", "fill", "transform"], mht = { key: 0 }, Mht = ["stroke"], vht = ["stroke"], Sht = ["stroke"], Hht = { key: 1 }, Aht = /* @__PURE__ */ e("rect", {
  x: "48",
  y: "96",
  width: "160",
  height: "120",
  opacity: "0.2"
}, null, -1), Vht = ["stroke"], zht = ["stroke"], Zht = ["stroke"], Cht = { key: 2 }, bht = /* @__PURE__ */ e("path", { d: "M136,88H120V35.3L91.7,63.6A8,8,0,0,1,80.3,52.3l42-42a8.1,8.1,0,0,1,11.4,0l42,42a8,8,0,0,1,0,11.3,8,8,0,0,1-11.4,0L136,35.3Zm64,0H136v40a8,8,0,0,1-16,0V88H56a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V104A16,16,0,0,0,200,88Z" }, null, -1), Lht = [
  bht
], Bht = { key: 3 }, Pht = ["stroke"], Wht = ["stroke"], Nht = ["stroke"], Fht = { key: 4 }, Tht = ["stroke"], Dht = ["stroke"], Rht = ["stroke"], Uht = { key: 5 }, qht = ["stroke"], Ght = ["stroke"], Eht = ["stroke"], Oht = {
  name: "PhExport"
}, WE1 = /* @__PURE__ */ $({
  ...Oht,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", mht, [
        e("polyline", {
          points: "86 58 128 16 170 58",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mht),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vht),
        e("path", {
          d: "M176,100h24a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V108a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Sht)
      ])) : o(i) === "duotone" ? (s(), r("g", Hht, [
        Aht,
        e("polyline", {
          points: "86 58 128 16 170 58",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vht),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zht),
        e("path", {
          d: "M176,96h24a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zht)
      ])) : o(i) === "fill" ? (s(), r("g", Cht, Lht)) : o(i) === "light" ? (s(), r("g", Bht, [
        e("polyline", {
          points: "86 58 128 16 170 58",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pht),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wht),
        e("path", {
          d: "M176,96h24a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Nht)
      ])) : o(i) === "thin" ? (s(), r("g", Fht, [
        e("polyline", {
          points: "86 58 128 16 170 58",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Tht),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Dht),
        e("path", {
          d: "M176,96h24a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Rht)
      ])) : o(i) === "regular" ? (s(), r("g", Uht, [
        e("polyline", {
          points: "86 58 128 16 170 58",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qht),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ght),
        e("path", {
          d: "M176,96h24a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Eht)
      ])) : g("", !0)
    ], 16, jht));
  }
}), Iht = ["width", "height", "fill", "transform"], Kht = { key: 0 }, Xht = ["stroke"], Jht = ["stroke"], Qht = { key: 1 }, Yht = /* @__PURE__ */ e("path", {
  d: "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Zm0,112a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z",
  opacity: "0.2"
}, null, -1), o6t = ["stroke"], e6t = ["stroke"], t6t = { key: 2 }, n6t = /* @__PURE__ */ e("path", { d: "M247.3,124.8c-.3-.8-8.8-19.6-27.6-38.5C194.6,61.3,162.9,48,128,48S61.4,61.3,36.3,86.3C17.5,105.2,9,124,8.7,124.8a7.9,7.9,0,0,0,0,6.4c.3.8,8.8,19.6,27.6,38.5C61.4,194.7,93.1,208,128,208s66.6-13.3,91.7-38.3c18.8-18.9,27.3-37.7,27.6-38.5A7.9,7.9,0,0,0,247.3,124.8ZM128,92a36,36,0,1,1-36,36A36,36,0,0,1,128,92Z" }, null, -1), s6t = [
  n6t
], r6t = { key: 3 }, i6t = ["stroke"], l6t = ["stroke"], d6t = { key: 4 }, k6t = ["stroke"], c6t = ["stroke"], h6t = { key: 5 }, u6t = ["stroke"], a6t = ["stroke"], _6t = {
  name: "PhEye"
}, NE1 = /* @__PURE__ */ $({
  ..._6t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Kht, [
        e("path", {
          d: "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xht),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jht)
      ])) : o(i) === "duotone" ? (s(), r("g", Qht, [
        Yht,
        e("path", {
          d: "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o6t),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e6t)
      ])) : o(i) === "fill" ? (s(), r("g", t6t, s6t)) : o(i) === "light" ? (s(), r("g", r6t, [
        e("path", {
          d: "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, i6t),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, l6t)
      ])) : o(i) === "thin" ? (s(), r("g", d6t, [
        e("path", {
          d: "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, k6t),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, c6t)
      ])) : o(i) === "regular" ? (s(), r("g", h6t, [
        e("path", {
          d: "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u6t),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a6t)
      ])) : g("", !0)
    ], 16, Iht));
  }
}), p6t = ["width", "height", "fill", "transform"], y6t = { key: 0 }, $6t = ["stroke"], w6t = ["stroke"], f6t = ["stroke"], g6t = ["stroke"], x6t = ["stroke"], j6t = { key: 1 }, m6t = ["stroke"], M6t = ["stroke"], v6t = ["stroke"], S6t = ["stroke"], H6t = ["stroke"], A6t = { key: 2 }, V6t = /* @__PURE__ */ e("path", { d: "M211.5,129.2a145.8,145.8,0,0,0,18.7-19.3A7.9,7.9,0,0,0,229,98.7a7.9,7.9,0,0,0-11.2,1.1,128.7,128.7,0,0,1-21.3,21h-.2c-16.5,12.8-39,23.1-68.3,23.1a109.7,109.7,0,0,1-68.4-23.1h-.1a128.7,128.7,0,0,1-21.3-21A7.9,7.9,0,0,0,27,98.7a7.9,7.9,0,0,0-1.2,11.2,145.8,145.8,0,0,0,18.7,19.3L25,163a8,8,0,0,0,6.9,12,8.2,8.2,0,0,0,6.9-4l18.5-32.1a122.1,122.1,0,0,0,35.3,16.3l-5.9,33a8.1,8.1,0,0,0,6.5,9.3h1.4a8,8,0,0,0,7.9-6.6l5.7-32.4A139.8,139.8,0,0,0,128,160a137.3,137.3,0,0,0,19.7-1.4l5.7,32.4a8,8,0,0,0,7.9,6.6h1.4a8.1,8.1,0,0,0,6.5-9.3l-5.8-32.9A122.9,122.9,0,0,0,198.6,139L217,170.8a8,8,0,0,0,7,4,7.6,7.6,0,0,0,4-1.1,8,8,0,0,0,2.9-10.9Z" }, null, -1), z6t = [
  V6t
], Z6t = { key: 3 }, C6t = ["stroke"], b6t = ["stroke"], L6t = ["stroke"], B6t = ["stroke"], P6t = ["stroke"], W6t = { key: 4 }, N6t = ["stroke"], F6t = ["stroke"], T6t = ["stroke"], D6t = ["stroke"], R6t = ["stroke"], U6t = { key: 5 }, q6t = ["stroke"], G6t = ["stroke"], E6t = ["stroke"], O6t = ["stroke"], I6t = ["stroke"], K6t = {
  name: "PhEyeClosed"
}, FE1 = /* @__PURE__ */ $({
  ...K6t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", y6t, [
        e("line", {
          x1: "201.1",
          y1: "127.3",
          x2: "224",
          y2: "166.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $6t),
        e("line", {
          x1: "154.2",
          y1: "149.3",
          x2: "161.3",
          y2: "189.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, w6t),
        e("line", {
          x1: "101.7",
          y1: "149.2",
          x2: "94.6",
          y2: "189.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f6t),
        e("line", {
          x1: "54.8",
          y1: "127.3",
          x2: "31.9",
          y2: "167",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g6t),
        e("path", {
          d: "M32,104.9C48.8,125.7,79.6,152,128,152s79.2-26.3,96-47.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, x6t)
      ])) : o(i) === "duotone" ? (s(), r("g", j6t, [
        e("line", {
          x1: "201.1",
          y1: "127.3",
          x2: "224",
          y2: "166.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m6t),
        e("line", {
          x1: "154.2",
          y1: "149.3",
          x2: "161.3",
          y2: "189.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M6t),
        e("line", {
          x1: "101.7",
          y1: "149.2",
          x2: "94.6",
          y2: "189.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v6t),
        e("line", {
          x1: "54.8",
          y1: "127.3",
          x2: "31.9",
          y2: "167",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S6t),
        e("path", {
          d: "M32,104.9C48.8,125.7,79.6,152,128,152s79.2-26.3,96-47.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H6t)
      ])) : o(i) === "fill" ? (s(), r("g", A6t, z6t)) : o(i) === "light" ? (s(), r("g", Z6t, [
        e("line", {
          x1: "201.1",
          y1: "127.3",
          x2: "224",
          y2: "166.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, C6t),
        e("line", {
          x1: "154.2",
          y1: "149.3",
          x2: "161.3",
          y2: "189.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b6t),
        e("line", {
          x1: "101.7",
          y1: "149.2",
          x2: "94.6",
          y2: "189.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, L6t),
        e("line", {
          x1: "54.8",
          y1: "127.3",
          x2: "31.9",
          y2: "167",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, B6t),
        e("path", {
          d: "M32,104.9C48.8,125.7,79.6,152,128,152s79.2-26.3,96-47.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, P6t)
      ])) : o(i) === "thin" ? (s(), r("g", W6t, [
        e("line", {
          x1: "201.1",
          y1: "127.3",
          x2: "224",
          y2: "166.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, N6t),
        e("line", {
          x1: "154.2",
          y1: "149.3",
          x2: "161.3",
          y2: "189.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, F6t),
        e("line", {
          x1: "101.7",
          y1: "149.2",
          x2: "94.6",
          y2: "189.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, T6t),
        e("line", {
          x1: "54.8",
          y1: "127.3",
          x2: "31.9",
          y2: "167",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, D6t),
        e("path", {
          d: "M32,104.9C48.8,125.7,79.6,152,128,152s79.2-26.3,96-47.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, R6t)
      ])) : o(i) === "regular" ? (s(), r("g", U6t, [
        e("line", {
          x1: "201.1",
          y1: "127.3",
          x2: "224",
          y2: "166.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q6t),
        e("line", {
          x1: "154.2",
          y1: "149.3",
          x2: "161.3",
          y2: "189.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G6t),
        e("line", {
          x1: "101.7",
          y1: "149.2",
          x2: "94.6",
          y2: "189.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E6t),
        e("line", {
          x1: "54.8",
          y1: "127.3",
          x2: "31.9",
          y2: "167",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O6t),
        e("path", {
          d: "M32,104.9C48.8,125.7,79.6,152,128,152s79.2-26.3,96-47.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I6t)
      ])) : g("", !0)
    ], 16, p6t));
  }
}), X6t = ["width", "height", "fill", "transform"], J6t = { key: 0 }, Q6t = ["stroke"], Y6t = ["stroke"], out = ["stroke"], eut = { key: 1 }, tut = /* @__PURE__ */ e("path", {
  d: "M128,56C48,56,16,128,16,128s32,72,112,72,112-72,112-72S208,56,128,56Zm0,112a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z",
  opacity: "0.2"
}, null, -1), nut = ["stroke"], sut = ["stroke"], rut = ["stroke"], iut = ["stroke"], lut = ["stroke"], dut = { key: 2 }, kut = /* @__PURE__ */ e("path", { d: "M247.3,124.8c-.3-.8-8.8-19.6-27.6-38.5C194.6,61.3,162.9,48,128,48a132.4,132.4,0,0,0-22,1.8,8.1,8.1,0,0,0-4.6,13.3L202.7,174.5a8,8,0,0,0,5.9,2.6,8.6,8.6,0,0,0,5.4-2c22.8-20.5,32.9-42.9,33.3-43.8A8.2,8.2,0,0,0,247.3,124.8Z" }, null, -1), cut = /* @__PURE__ */ e("path", { d: "M53.9,34.6A8,8,0,0,0,42.1,45.4L61.3,66.5C25,88.8,9.4,123.2,8.7,124.8a8.2,8.2,0,0,0,0,6.5c.3.7,8.8,19.5,27.6,38.4C61.4,194.7,93.1,208,128,208a126.9,126.9,0,0,0,52.1-10.8l22,24.2A8,8,0,0,0,208,224a8.2,8.2,0,0,0,5.4-2.1,7.9,7.9,0,0,0,.5-11.3ZM128,164a36,36,0,0,1-29.5-56.6l47.2,51.9A35.4,35.4,0,0,1,128,164Z" }, null, -1), hut = [
  kut,
  cut
], uut = { key: 3 }, aut = ["stroke"], _ut = ["stroke"], put = ["stroke"], yut = ["stroke"], $ut = ["stroke"], wut = { key: 4 }, fut = ["stroke"], gut = ["stroke"], xut = ["stroke"], jut = ["stroke"], mut = ["stroke"], Mut = { key: 5 }, vut = ["stroke"], Sut = ["stroke"], Hut = ["stroke"], Aut = ["stroke"], Vut = ["stroke"], zut = {
  name: "PhEyeSlash"
}, TE1 = /* @__PURE__ */ $({
  ...zut,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", J6t, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Q6t),
        e("path", {
          d: "M74,68.6C33.2,89.2,16,128,16,128s32,72,112,72a117.9,117.9,0,0,0,54-12.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Y6t),
        e("path", {
          d: "M214.4,163.6C232.1,145.7,240,128,240,128S208,56,128,56c-3.8,0-7.4.2-11,.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, out)
      ])) : o(i) === "duotone" ? (s(), r("g", eut, [
        tut,
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nut),
        e("path", {
          d: "M154.9,157.6A39.6,39.6,0,0,1,128,168a40,40,0,0,1-26.9-69.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sut),
        e("path", {
          d: "M74,68.6C33.2,89.2,16,128,16,128s32,72,112,72a117.9,117.9,0,0,0,54-12.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rut),
        e("path", {
          d: "M208.6,169.1C230.4,149.6,240,128,240,128S208,56,128,56a123.9,123.9,0,0,0-20.7,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iut),
        e("path", {
          d: "M135.5,88.7a39.9,39.9,0,0,1,32.3,35.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lut)
      ])) : o(i) === "fill" ? (s(), r("g", dut, hut)) : o(i) === "light" ? (s(), r("g", uut, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aut),
        e("path", {
          d: "M154.9,157.6A39.6,39.6,0,0,1,128,168a40,40,0,0,1-26.9-69.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _ut),
        e("path", {
          d: "M74,68.6C33.2,89.2,16,128,16,128s32,72,112,72a117.9,117.9,0,0,0,54-12.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, put),
        e("path", {
          d: "M208.6,169.1C230.4,149.6,240,128,240,128S208,56,128,56a123.9,123.9,0,0,0-20.7,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yut),
        e("path", {
          d: "M135.5,88.7a39.9,39.9,0,0,1,32.3,35.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $ut)
      ])) : o(i) === "thin" ? (s(), r("g", wut, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fut),
        e("path", {
          d: "M154.9,157.6A39.6,39.6,0,0,1,128,168a40,40,0,0,1-26.9-69.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gut),
        e("path", {
          d: "M74,68.6C33.2,89.2,16,128,16,128s32,72,112,72a117.9,117.9,0,0,0,54-12.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xut),
        e("path", {
          d: "M208.6,169.1C230.4,149.6,240,128,240,128S208,56,128,56a123.9,123.9,0,0,0-20.7,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jut),
        e("path", {
          d: "M135.5,88.7a39.9,39.9,0,0,1,32.3,35.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mut)
      ])) : o(i) === "regular" ? (s(), r("g", Mut, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vut),
        e("path", {
          d: "M154.9,157.6A39.6,39.6,0,0,1,128,168a40,40,0,0,1-26.9-69.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sut),
        e("path", {
          d: "M74,68.6C33.2,89.2,16,128,16,128s32,72,112,72a117.9,117.9,0,0,0,54-12.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hut),
        e("path", {
          d: "M208.6,169.1C230.4,149.6,240,128,240,128S208,56,128,56a123.9,123.9,0,0,0-20.7,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Aut),
        e("path", {
          d: "M135.5,88.7a39.9,39.9,0,0,1,32.3,35.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vut)
      ])) : g("", !0)
    ], 16, X6t));
  }
}), Zut = ["width", "height", "fill", "transform"], Cut = { key: 0 }, but = ["stroke"], Lut = ["stroke"], But = { key: 1 }, Put = /* @__PURE__ */ e("path", {
  d: "M179.8,115.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-7,7a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l7-7a16.1,16.1,0,0,1,22.6,0l4.9,4.9,27.6-27.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
  opacity: "0.2"
}, null, -1), Wut = ["stroke"], Nut = ["stroke"], Fut = { key: 2 }, Tut = /* @__PURE__ */ e("path", { d: "M224,67.5a35.5,35.5,0,0,0-11.3-25.7c-14-13.2-36.7-12.7-50.6,1.2L140.2,64.9a24.1,24.1,0,0,0-33.2.8l-7,7a16.1,16.1,0,0,0,0,22.6l2.1,2.1L51.7,147.7a40.3,40.3,0,0,0-11,35.8l-9.8,22.4a13.6,13.6,0,0,0,2.9,15.2,15.8,15.8,0,0,0,11.3,4.7,16.3,16.3,0,0,0,6.4-1.3l21-9.2a40.3,40.3,0,0,0,35.8-11l50.3-50.4,2.1,2.1a15.9,15.9,0,0,0,22.6,0l7-7a24.1,24.1,0,0,0,.8-33.2l22.4-22.3A36.2,36.2,0,0,0,224,67.5ZM97,193a24.3,24.3,0,0,1-23.2,6.2,8,8,0,0,0-5.3.4L47,209l9.4-21.5a8,8,0,0,0,.4-5.3A24.3,24.3,0,0,1,63,159l50.4-50.3,33.9,33.9Z" }, null, -1), Dut = [
  Tut
], Rut = { key: 3 }, Uut = ["stroke"], qut = ["stroke"], Gut = { key: 4 }, Eut = ["stroke"], Out = ["stroke"], Iut = { key: 5 }, Kut = ["stroke"], Xut = ["stroke"], Jut = {
  name: "PhEyedropper"
}, DE1 = /* @__PURE__ */ $({
  ...Jut,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Cut, [
        e("path", {
          d: "M158.6,142.6l-56,56a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8a31.7,31.7,0,0,1,8.3-30.9l56-56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, but),
        e("path", {
          d: "M187.8,107.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-15,15a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l15-15a16.1,16.1,0,0,1,22.6,0l4.9,4.9,19.6-19.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lut)
      ])) : o(i) === "duotone" ? (s(), r("g", But, [
        Put,
        e("path", {
          d: "M179.8,115.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-7,7a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l7-7a16.1,16.1,0,0,1,22.6,0l4.9,4.9,27.6-27.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wut),
        e("path", {
          d: "M158.6,142.6l-56,56a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8a31.7,31.7,0,0,1,8.3-30.9l56-56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nut)
      ])) : o(i) === "fill" ? (s(), r("g", Fut, Dut)) : o(i) === "light" ? (s(), r("g", Rut, [
        e("path", {
          d: "M179.8,115.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-7,7a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l7-7a16.1,16.1,0,0,1,22.6,0l4.9,4.9,27.6-27.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Uut),
        e("path", {
          d: "M158.6,142.6l-56,56a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8a31.7,31.7,0,0,1,8.3-30.9l56-56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qut)
      ])) : o(i) === "thin" ? (s(), r("g", Gut, [
        e("path", {
          d: "M179.8,115.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-7,7a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l7-7a16.1,16.1,0,0,1,22.6,0l4.9,4.9,27.6-27.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Eut),
        e("path", {
          d: "M158.6,142.6l-56,56a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8a31.7,31.7,0,0,1,8.3-30.9l56-56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Out)
      ])) : o(i) === "regular" ? (s(), r("g", Iut, [
        e("path", {
          d: "M179.8,115.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-7,7a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l7-7a16.1,16.1,0,0,1,22.6,0l4.9,4.9,27.6-27.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kut),
        e("path", {
          d: "M158.6,142.6l-56,56a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8a31.7,31.7,0,0,1,8.3-30.9l56-56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xut)
      ])) : g("", !0)
    ], 16, Zut));
  }
}), Qut = ["width", "height", "fill", "transform"], Yut = { key: 0 }, o4t = ["stroke"], e4t = ["stroke"], t4t = ["stroke"], n4t = { key: 1 }, s4t = /* @__PURE__ */ e("path", {
  d: "M141.3,160l-38.7,38.6a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8A31.9,31.9,0,0,1,52.3,160Z",
  opacity: "0.2"
}, null, -1), r4t = ["stroke"], i4t = ["stroke"], l4t = ["stroke"], d4t = { key: 2 }, k4t = /* @__PURE__ */ e("path", { d: "M224,67.5a35.5,35.5,0,0,0-11.3-25.7c-14-13.2-36.7-12.7-50.6,1.2L140.2,64.9a24.1,24.1,0,0,0-33.2.8l-7,7a16.1,16.1,0,0,0,0,22.6l2.1,2.1L51.7,147.7a40.3,40.3,0,0,0-11,35.8l-9.8,22.4a13.6,13.6,0,0,0,2.9,15.2,15.8,15.8,0,0,0,11.3,4.7,16.3,16.3,0,0,0,6.4-1.3l21-9.2a40.3,40.3,0,0,0,35.8-11l50.3-50.4,2.1,2.1a15.9,15.9,0,0,0,22.6,0l7-7a24.1,24.1,0,0,0,.8-33.2l22.4-22.3A36.2,36.2,0,0,0,224,67.5ZM137.9,152H70.1l43.3-43.3,33.9,33.9Zm64.2-69.9-28,28a8.1,8.1,0,0,0,0,11.4l4.9,4.8a8.1,8.1,0,0,1,0,11.4l-7,7L111.3,84l7-7a8,8,0,0,1,11.4,0l4.8,4.9a8.1,8.1,0,0,0,11.4,0l27.5-27.6c7.9-7.8,20.6-8.2,28.3-.8A19.7,19.7,0,0,1,208,67.7,19.4,19.4,0,0,1,202.1,82.1Z" }, null, -1), c4t = [
  k4t
], h4t = { key: 3 }, u4t = ["stroke"], a4t = ["stroke"], _4t = ["stroke"], p4t = { key: 4 }, y4t = ["stroke"], $4t = ["stroke"], w4t = ["stroke"], f4t = { key: 5 }, g4t = ["stroke"], x4t = ["stroke"], j4t = ["stroke"], m4t = {
  name: "PhEyedropperSample"
}, RE1 = /* @__PURE__ */ $({
  ...m4t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Yut, [
        e("path", {
          d: "M179.8,115.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-7,7a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l7-7a16.1,16.1,0,0,1,22.6,0l4.9,4.9,27.6-27.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, o4t),
        e("path", {
          d: "M158.6,142.6l-56,56a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8a31.7,31.7,0,0,1,8.3-30.9l56-56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, e4t),
        e("line", {
          x1: "52.3",
          y1: "160",
          x2: "141.3",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, t4t)
      ])) : o(i) === "duotone" ? (s(), r("g", n4t, [
        s4t,
        e("path", {
          d: "M179.8,115.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-7,7a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l7-7a16.1,16.1,0,0,1,22.6,0l4.9,4.9,27.6-27.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r4t),
        e("path", {
          d: "M158.6,142.6l-56,56a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8a31.7,31.7,0,0,1,8.3-30.9l56-56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, i4t),
        e("line", {
          x1: "52.3",
          y1: "160",
          x2: "141.3",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l4t)
      ])) : o(i) === "fill" ? (s(), r("g", d4t, c4t)) : o(i) === "light" ? (s(), r("g", h4t, [
        e("path", {
          d: "M179.8,115.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-7,7a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l7-7a16.1,16.1,0,0,1,22.6,0l4.9,4.9,27.6-27.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u4t),
        e("path", {
          d: "M158.6,142.6l-56,56a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8a31.7,31.7,0,0,1,8.3-30.9l56-56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, a4t),
        e("line", {
          x1: "52.3",
          y1: "160",
          x2: "141.3",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _4t)
      ])) : o(i) === "thin" ? (s(), r("g", p4t, [
        e("path", {
          d: "M179.8,115.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-7,7a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l7-7a16.1,16.1,0,0,1,22.6,0l4.9,4.9,27.6-27.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, y4t),
        e("path", {
          d: "M158.6,142.6l-56,56a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8a31.7,31.7,0,0,1,8.3-30.9l56-56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $4t),
        e("line", {
          x1: "52.3",
          y1: "160",
          x2: "141.3",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, w4t)
      ])) : o(i) === "regular" ? (s(), r("g", f4t, [
        e("path", {
          d: "M179.8,115.8l4.9,4.9a16.1,16.1,0,0,1,0,22.6l-7,7a8,8,0,0,1-11.4,0L105.7,89.7a8,8,0,0,1,0-11.4l7-7a16.1,16.1,0,0,1,22.6,0l4.9,4.9,27.6-27.6c10.8-10.8,28.4-11.4,39.4-.9a28,28,0,0,1,.6,40.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g4t),
        e("path", {
          d: "M158.6,142.6l-56,56a31.7,31.7,0,0,1-30.9,8.3L48.3,217.1a8,8,0,0,1-8.8-1.6h0a5.7,5.7,0,0,1-1.2-6.4l10.8-24.8a31.7,31.7,0,0,1,8.3-30.9l56-56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, x4t),
        e("line", {
          x1: "52.3",
          y1: "160",
          x2: "141.3",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j4t)
      ])) : g("", !0)
    ], 16, Qut));
  }
}), M4t = ["width", "height", "fill", "transform"], v4t = { key: 0 }, S4t = ["stroke"], H4t = ["stroke"], A4t = ["stroke"], V4t = ["stroke"], z4t = ["stroke"], Z4t = { key: 1 }, C4t = /* @__PURE__ */ e("circle", {
  cx: "68",
  cy: "164",
  r: "36",
  opacity: "0.2"
}, null, -1), b4t = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "164",
  r: "36",
  opacity: "0.2"
}, null, -1), L4t = ["stroke"], B4t = ["stroke"], P4t = ["stroke"], W4t = ["stroke"], N4t = ["stroke"], F4t = { key: 2 }, T4t = /* @__PURE__ */ e("path", { d: "M232,72v92a44,44,0,0,1-87.8,4H111.8A44,44,0,0,1,24,164V72A32.1,32.1,0,0,1,56,40a8,8,0,0,1,0,16A16,16,0,0,0,40,72v58.1A43.9,43.9,0,0,1,110.3,152h35.4A43.9,43.9,0,0,1,216,130.1V72a16,16,0,0,0-16-16,8,8,0,0,1,0-16A32.1,32.1,0,0,1,232,72Z" }, null, -1), D4t = [
  T4t
], R4t = { key: 3 }, U4t = ["stroke"], q4t = ["stroke"], G4t = ["stroke"], E4t = ["stroke"], O4t = ["stroke"], I4t = { key: 4 }, K4t = ["stroke"], X4t = ["stroke"], J4t = ["stroke"], Q4t = ["stroke"], Y4t = ["stroke"], oat = { key: 5 }, eat = ["stroke"], tat = ["stroke"], nat = ["stroke"], sat = ["stroke"], rat = ["stroke"], iat = {
  name: "PhEyeglasses"
}, UE1 = /* @__PURE__ */ $({
  ...iat,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", v4t, [
        e("circle", {
          cx: "68",
          cy: "164",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, S4t),
        e("circle", {
          cx: "188",
          cy: "164",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, H4t),
        e("line", {
          x1: "104",
          y1: "160",
          x2: "152",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, A4t),
        e("path", {
          d: "M32,164V72A23.9,23.9,0,0,1,56,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, V4t),
        e("path", {
          d: "M200,48a23.9,23.9,0,0,1,24,24v92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, z4t)
      ])) : o(i) === "duotone" ? (s(), r("g", Z4t, [
        C4t,
        b4t,
        e("circle", {
          cx: "68",
          cy: "164",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L4t),
        e("circle", {
          cx: "188",
          cy: "164",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B4t),
        e("line", {
          x1: "104",
          y1: "160",
          x2: "152",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P4t),
        e("path", {
          d: "M32,164V72A23.9,23.9,0,0,1,56,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W4t),
        e("path", {
          d: "M200,48a23.9,23.9,0,0,1,24,24v92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N4t)
      ])) : o(i) === "fill" ? (s(), r("g", F4t, D4t)) : o(i) === "light" ? (s(), r("g", R4t, [
        e("circle", {
          cx: "68",
          cy: "164",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, U4t),
        e("circle", {
          cx: "188",
          cy: "164",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, q4t),
        e("line", {
          x1: "104",
          y1: "160",
          x2: "152",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, G4t),
        e("path", {
          d: "M32,164V72A23.9,23.9,0,0,1,56,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, E4t),
        e("path", {
          d: "M200,48a23.9,23.9,0,0,1,24,24v92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, O4t)
      ])) : o(i) === "thin" ? (s(), r("g", I4t, [
        e("circle", {
          cx: "68",
          cy: "164",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, K4t),
        e("circle", {
          cx: "188",
          cy: "164",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, X4t),
        e("line", {
          x1: "104",
          y1: "160",
          x2: "152",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, J4t),
        e("path", {
          d: "M32,164V72A23.9,23.9,0,0,1,56,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Q4t),
        e("path", {
          d: "M200,48a23.9,23.9,0,0,1,24,24v92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Y4t)
      ])) : o(i) === "regular" ? (s(), r("g", oat, [
        e("circle", {
          cx: "68",
          cy: "164",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eat),
        e("circle", {
          cx: "188",
          cy: "164",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tat),
        e("line", {
          x1: "104",
          y1: "160",
          x2: "152",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nat),
        e("path", {
          d: "M32,164V72A23.9,23.9,0,0,1,56,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sat),
        e("path", {
          d: "M200,48a23.9,23.9,0,0,1,24,24v92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rat)
      ])) : g("", !0)
    ], 16, M4t));
  }
}), lat = ["width", "height", "fill", "transform"], dat = { key: 0 }, kat = ["stroke"], cat = ["stroke"], hat = ["stroke"], uat = ["stroke"], aat = ["stroke"], _at = { key: 1 }, pat = /* @__PURE__ */ e("path", {
  d: "M216,136c0,51.5-74.4,69.2-86.4,71.7a8.6,8.6,0,0,1-3.2,0C114.4,205.2,40,187.5,40,136V77.6a7.9,7.9,0,0,1,5.3-7.5l80-29.1a8.3,8.3,0,0,1,5.4,0l80,29.1a7.9,7.9,0,0,1,5.3,7.5Z",
  opacity: "0.2"
}, null, -1), yat = ["stroke"], $at = ["stroke"], wat = ["stroke"], fat = ["stroke"], gat = ["stroke"], xat = { key: 2 }, jat = /* @__PURE__ */ e("path", { d: "M224,72h-1a16,16,0,0,0-9.5-9.4l-80-29.1a16,16,0,0,0-11,0l-80,29.1A16,16,0,0,0,33,72H32A32.1,32.1,0,0,0,0,104v24a32.1,32.1,0,0,0,32,32h5.2c6.6,14.4,19.3,27,37.6,37.2,21.1,11.7,43.6,17,49.9,18.3l3.3.3,3.3-.3c6.3-1.3,28.8-6.6,49.9-18.3,18.3-10.2,31-22.8,37.6-37.2H224a32.1,32.1,0,0,0,32-32V104A32.1,32.1,0,0,0,224,72ZM32,144a16,16,0,0,1-16-16V104A16,16,0,0,1,32,88v48a52.9,52.9,0,0,0,.6,8Zm136,8H88a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Zm0-32H88a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Zm72,8a16,16,0,0,1-16,16h-.6a52.9,52.9,0,0,0,.6-8V88a16,16,0,0,1,16,16Z" }, null, -1), mat = [
  jat
], Mat = { key: 3 }, vat = ["stroke"], Sat = ["stroke"], Hat = ["stroke"], Aat = ["stroke"], Vat = ["stroke"], zat = { key: 4 }, Zat = ["stroke"], Cat = ["stroke"], bat = ["stroke"], Lat = ["stroke"], Bat = ["stroke"], Pat = { key: 5 }, Wat = ["stroke"], Nat = ["stroke"], Fat = ["stroke"], Tat = ["stroke"], Dat = ["stroke"], Rat = {
  name: "PhFaceMask"
}, qE1 = /* @__PURE__ */ $({
  ...Rat,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", dat, [
        e("path", {
          d: "M208,136c0,51-66.2,68.8-78.2,71.6a7.3,7.3,0,0,1-3.6,0C114.2,204.8,48,187,48,136V77.4A7.9,7.9,0,0,1,53,70l72-28.8a7.8,7.8,0,0,1,6,0L203,70a7.9,7.9,0,0,1,5,7.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kat),
        e("line", {
          x1: "88",
          y1: "108",
          x2: "168",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cat),
        e("line", {
          x1: "88",
          y1: "144",
          x2: "168",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hat),
        e("path", {
          d: "M205.4,152H220a23.9,23.9,0,0,0,24-24V104a23.9,23.9,0,0,0-24-24H208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uat),
        e("path", {
          d: "M50.6,152H36a23.9,23.9,0,0,1-24-24V104A23.9,23.9,0,0,1,36,80H48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aat)
      ])) : o(i) === "duotone" ? (s(), r("g", _at, [
        pat,
        e("path", {
          d: "M216,136c0,51.5-74.4,69.2-86.4,71.7a8.6,8.6,0,0,1-3.2,0C114.4,205.2,40,187.5,40,136V77.6a7.9,7.9,0,0,1,5.3-7.5l80-29.1a8.3,8.3,0,0,1,5.4,0l80,29.1a7.9,7.9,0,0,1,5.3,7.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yat),
        e("line", {
          x1: "88",
          y1: "112",
          x2: "168",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $at),
        e("line", {
          x1: "88",
          y1: "144",
          x2: "168",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wat),
        e("path", {
          d: "M213.4,152H224a23.9,23.9,0,0,0,24-24V104a23.9,23.9,0,0,0-24-24h-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fat),
        e("path", {
          d: "M42.6,152H32A23.9,23.9,0,0,1,8,128V104A23.9,23.9,0,0,1,32,80h8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gat)
      ])) : o(i) === "fill" ? (s(), r("g", xat, mat)) : o(i) === "light" ? (s(), r("g", Mat, [
        e("path", {
          d: "M216,136c0,51.5-74.4,69.2-86.4,71.7a8.6,8.6,0,0,1-3.2,0C114.4,205.2,40,187.5,40,136V77.6a7.9,7.9,0,0,1,5.3-7.5l80-29.1a8.3,8.3,0,0,1,5.4,0l80,29.1a7.9,7.9,0,0,1,5.3,7.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vat),
        e("line", {
          x1: "88",
          y1: "112",
          x2: "168",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Sat),
        e("line", {
          x1: "88",
          y1: "144",
          x2: "168",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hat),
        e("path", {
          d: "M213.4,152H224a23.9,23.9,0,0,0,24-24V104a23.9,23.9,0,0,0-24-24h-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Aat),
        e("path", {
          d: "M42.6,152H32A23.9,23.9,0,0,1,8,128V104A23.9,23.9,0,0,1,32,80h8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vat)
      ])) : o(i) === "thin" ? (s(), r("g", zat, [
        e("path", {
          d: "M216,136c0,51.5-74.4,69.2-86.4,71.7a8.6,8.6,0,0,1-3.2,0C114.4,205.2,40,187.5,40,136V77.6a7.9,7.9,0,0,1,5.3-7.5l80-29.1a8.3,8.3,0,0,1,5.4,0l80,29.1a7.9,7.9,0,0,1,5.3,7.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zat),
        e("line", {
          x1: "88",
          y1: "112",
          x2: "168",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cat),
        e("line", {
          x1: "88",
          y1: "144",
          x2: "168",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bat),
        e("path", {
          d: "M213.4,152H224a23.9,23.9,0,0,0,24-24V104a23.9,23.9,0,0,0-24-24h-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lat),
        e("path", {
          d: "M42.6,152H32A23.9,23.9,0,0,1,8,128V104A23.9,23.9,0,0,1,32,80h8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bat)
      ])) : o(i) === "regular" ? (s(), r("g", Pat, [
        e("path", {
          d: "M216,136c0,51.5-74.4,69.2-86.4,71.7a8.6,8.6,0,0,1-3.2,0C114.4,205.2,40,187.5,40,136V77.6a7.9,7.9,0,0,1,5.3-7.5l80-29.1a8.3,8.3,0,0,1,5.4,0l80,29.1a7.9,7.9,0,0,1,5.3,7.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wat),
        e("line", {
          x1: "88",
          y1: "112",
          x2: "168",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nat),
        e("line", {
          x1: "88",
          y1: "144",
          x2: "168",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fat),
        e("path", {
          d: "M213.4,152H224a23.9,23.9,0,0,0,24-24V104a23.9,23.9,0,0,0-24-24h-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tat),
        e("path", {
          d: "M42.6,152H32A23.9,23.9,0,0,1,8,128V104A23.9,23.9,0,0,1,32,80h8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dat)
      ])) : g("", !0)
    ], 16, lat));
  }
}), Uat = ["width", "height", "fill", "transform"], qat = { key: 0 }, Gat = ["stroke"], Eat = ["stroke"], Oat = ["stroke"], Iat = { key: 1 }, Kat = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), Xat = ["stroke"], Jat = ["stroke"], Qat = ["stroke"], Yat = { key: 2 }, o_t = /* @__PURE__ */ e("path", { d: "M232,128a104.3,104.3,0,0,1-91.5,103.3,4.1,4.1,0,0,1-4.5-4V152h24a8,8,0,0,0,8-8.5,8.2,8.2,0,0,0-8.3-7.5H136V112a16,16,0,0,1,16-16h16a8,8,0,0,0,8-8.5,8.2,8.2,0,0,0-8.3-7.5H152a32,32,0,0,0-32,32v24H96a8,8,0,0,0-8,8.5,8.2,8.2,0,0,0,8.3,7.5H120v75.3a4,4,0,0,1-4.4,4C62.8,224.9,22,179,24.1,124.1A104,104,0,0,1,232,128Z" }, null, -1), e_t = [
  o_t
], t_t = { key: 3 }, n_t = ["stroke"], s_t = ["stroke"], r_t = ["stroke"], i_t = { key: 4 }, l_t = ["stroke"], d_t = ["stroke"], k_t = ["stroke"], c_t = { key: 5 }, h_t = ["stroke"], u_t = ["stroke"], a_t = ["stroke"], __t = {
  name: "PhFacebookLogo"
}, GE1 = /* @__PURE__ */ $({
  ...__t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", qat, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gat),
        e("path", {
          d: "M168,88H152a23.9,23.9,0,0,0-24,24V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Eat),
        e("line", {
          x1: "96",
          y1: "144",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Oat)
      ])) : o(i) === "duotone" ? (s(), r("g", Iat, [
        Kat,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xat),
        e("path", {
          d: "M168,88H152a23.9,23.9,0,0,0-24,24V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jat),
        e("line", {
          x1: "96",
          y1: "144",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qat)
      ])) : o(i) === "fill" ? (s(), r("g", Yat, e_t)) : o(i) === "light" ? (s(), r("g", t_t, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, n_t),
        e("path", {
          d: "M168,88H152a23.9,23.9,0,0,0-24,24V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, s_t),
        e("line", {
          x1: "96",
          y1: "144",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, r_t)
      ])) : o(i) === "thin" ? (s(), r("g", i_t, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, l_t),
        e("path", {
          d: "M168,88H152a23.9,23.9,0,0,0-24,24V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, d_t),
        e("line", {
          x1: "96",
          y1: "144",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, k_t)
      ])) : o(i) === "regular" ? (s(), r("g", c_t, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h_t),
        e("path", {
          d: "M168,88H152a23.9,23.9,0,0,0-24,24V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u_t),
        e("line", {
          x1: "96",
          y1: "144",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a_t)
      ])) : g("", !0)
    ], 16, Uat));
  }
}), p_t = ["width", "height", "fill", "transform"], y_t = { key: 0 }, $_t = ["stroke"], w_t = ["stroke"], f_t = ["stroke"], g_t = ["stroke"], x_t = ["stroke"], j_t = { key: 1 }, m_t = /* @__PURE__ */ e("polygon", {
  points: "216 216 216 136 168 136 104 88 104 136 40 88 40 216 216 216",
  opacity: "0.2"
}, null, -1), M_t = ["stroke"], v_t = ["stroke"], S_t = ["stroke"], H_t = ["stroke"], A_t = ["stroke"], V_t = { key: 2 }, z_t = /* @__PURE__ */ e("path", { d: "M240,208H224V136h0v-.5a.8.8,0,0,0-.1-.4h0l-15-105.2A16,16,0,0,0,193.1,16H174.9a16,16,0,0,0-15.8,13.7l-11.6,81L108.8,81.6A8,8,0,0,0,96,88v32L44.8,81.6A8,8,0,0,0,32,88V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM100,184H72a8,8,0,0,1,0-16h28a8,8,0,0,1,0,16Zm84,0H156a8,8,0,0,1,0-16h28a8,8,0,0,1,0,16Zm-13.3-56-8.6-6.4L174.9,32h18.2l13.7,96Z" }, null, -1), Z_t = [
  z_t
], C_t = { key: 3 }, b_t = ["stroke"], L_t = ["stroke"], B_t = ["stroke"], P_t = ["stroke"], W_t = ["stroke"], N_t = { key: 4 }, F_t = ["stroke"], T_t = ["stroke"], D_t = ["stroke"], R_t = ["stroke"], U_t = ["stroke"], q_t = { key: 5 }, G_t = ["stroke"], E_t = ["stroke"], O_t = ["stroke"], I_t = ["stroke"], K_t = ["stroke"], X_t = {
  name: "PhFactory"
}, EE1 = /* @__PURE__ */ $({
  ...X_t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", y_t, [
        e("line", {
          x1: "80",
          y1: "176",
          x2: "108",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $_t),
        e("line", {
          x1: "148",
          y1: "176",
          x2: "176",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, w_t),
        e("polyline", {
          points: "216 216 216 136 168 136 104 88 104 136 40 88 40 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f_t),
        e("line", {
          x1: "16",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g_t),
        e("path", {
          d: "M216,136,201,30.9a8,8,0,0,0-7.9-6.9H174.9a8,8,0,0,0-7.9,6.9l-13.5,94.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, x_t)
      ])) : o(i) === "duotone" ? (s(), r("g", j_t, [
        m_t,
        e("line", {
          x1: "80",
          y1: "176",
          x2: "108",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M_t),
        e("line", {
          x1: "148",
          y1: "176",
          x2: "176",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v_t),
        e("polyline", {
          points: "216 216 216 136 168 136 104 88 104 136 40 88 40 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S_t),
        e("line", {
          x1: "16",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H_t),
        e("path", {
          d: "M216,136,201,30.9a8,8,0,0,0-7.9-6.9H174.9a8,8,0,0,0-7.9,6.9l-13.5,94.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A_t)
      ])) : o(i) === "fill" ? (s(), r("g", V_t, Z_t)) : o(i) === "light" ? (s(), r("g", C_t, [
        e("line", {
          x1: "80",
          y1: "176",
          x2: "108",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b_t),
        e("line", {
          x1: "148",
          y1: "176",
          x2: "176",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, L_t),
        e("polyline", {
          points: "216 216 216 136 168 136 104 88 104 136 40 88 40 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, B_t),
        e("line", {
          x1: "16",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, P_t),
        e("path", {
          d: "M216,136,201,30.9a8,8,0,0,0-7.9-6.9H174.9a8,8,0,0,0-7.9,6.9l-13.5,94.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, W_t)
      ])) : o(i) === "thin" ? (s(), r("g", N_t, [
        e("line", {
          x1: "80",
          y1: "176",
          x2: "108",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, F_t),
        e("line", {
          x1: "148",
          y1: "176",
          x2: "176",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, T_t),
        e("polyline", {
          points: "216 216 216 136 168 136 104 88 104 136 40 88 40 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, D_t),
        e("line", {
          x1: "16",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, R_t),
        e("path", {
          d: "M216,136,201,30.9a8,8,0,0,0-7.9-6.9H174.9a8,8,0,0,0-7.9,6.9l-13.5,94.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, U_t)
      ])) : o(i) === "regular" ? (s(), r("g", q_t, [
        e("line", {
          x1: "80",
          y1: "176",
          x2: "108",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G_t),
        e("line", {
          x1: "148",
          y1: "176",
          x2: "176",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E_t),
        e("polyline", {
          points: "216 216 216 136 168 136 104 88 104 136 40 88 40 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O_t),
        e("line", {
          x1: "16",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I_t),
        e("path", {
          d: "M216,136,201,30.9a8,8,0,0,0-7.9-6.9H174.9a8,8,0,0,0-7.9,6.9l-13.5,94.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K_t)
      ])) : g("", !0)
    ], 16, p_t));
  }
}), J_t = ["width", "height", "fill", "transform"], Q_t = { key: 0 }, Y_t = ["stroke"], opt = ["stroke"], ept = ["stroke"], tpt = ["stroke"], npt = ["stroke"], spt = ["stroke"], rpt = ["stroke"], ipt = ["stroke"], lpt = ["stroke"], dpt = { key: 1 }, kpt = ["stroke"], cpt = ["stroke"], hpt = ["stroke"], upt = ["stroke"], apt = ["stroke"], _pt = ["stroke"], ppt = ["stroke"], ypt = ["stroke"], $pt = ["stroke"], wpt = { key: 2 }, fpt = /* @__PURE__ */ j('<path d="M128,112a8,8,0,0,0-8,8v96a8,8,0,0,0,16,0V120A8,8,0,0,0,128,112Z"></path><path d="M200,192a8,8,0,0,0-8,8v16a8,8,0,0,0,16,0V200A8,8,0,0,0,200,192Z"></path><path d="M224,160H208V40a8,8,0,0,0-16,0V160H176a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z"></path><path d="M56,160a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0V168A8,8,0,0,0,56,160Z"></path><path d="M80,128H64V40a8,8,0,0,0-16,0v88H32a8,8,0,0,0,0,16H80a8,8,0,0,0,0-16Z"></path><path d="M152,80H136V40a8,8,0,0,0-16,0V80H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z"></path>', 6), gpt = [
  fpt
], xpt = { key: 3 }, jpt = ["stroke"], mpt = ["stroke"], Mpt = ["stroke"], vpt = ["stroke"], Spt = ["stroke"], Hpt = ["stroke"], Apt = ["stroke"], Vpt = ["stroke"], zpt = ["stroke"], Zpt = { key: 4 }, Cpt = ["stroke"], bpt = ["stroke"], Lpt = ["stroke"], Bpt = ["stroke"], Ppt = ["stroke"], Wpt = ["stroke"], Npt = ["stroke"], Fpt = ["stroke"], Tpt = ["stroke"], Dpt = { key: 5 }, Rpt = ["stroke"], Upt = ["stroke"], qpt = ["stroke"], Gpt = ["stroke"], Ept = ["stroke"], Opt = ["stroke"], Ipt = ["stroke"], Kpt = ["stroke"], Xpt = ["stroke"], Jpt = {
  name: "PhFaders"
}, OE1 = /* @__PURE__ */ $({
  ...Jpt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Q_t, [
        e("line", {
          x1: "128",
          y1: "124",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Y_t),
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, opt),
        e("line", {
          x1: "200",
          y1: "204",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ept),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tpt),
        e("line", {
          x1: "224",
          y1: "164",
          x2: "176",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, npt),
        e("line", {
          x1: "56",
          y1: "172",
          x2: "56",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, spt),
        e("line", {
          x1: "56",
          y1: "40",
          x2: "56",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rpt),
        e("line", {
          x1: "32",
          y1: "132",
          x2: "80",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ipt),
        e("line", {
          x1: "152",
          y1: "84",
          x2: "104",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lpt)
      ])) : o(i) === "duotone" ? (s(), r("g", dpt, [
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kpt),
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cpt),
        e("line", {
          x1: "200",
          y1: "200",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hpt),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, upt),
        e("line", {
          x1: "224",
          y1: "168",
          x2: "176",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, apt),
        e("line", {
          x1: "56",
          y1: "168",
          x2: "56",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _pt),
        e("line", {
          x1: "56",
          y1: "40",
          x2: "56",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ppt),
        e("line", {
          x1: "32",
          y1: "136",
          x2: "80",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ypt),
        e("line", {
          x1: "152",
          y1: "88",
          x2: "104",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $pt)
      ])) : o(i) === "fill" ? (s(), r("g", wpt, gpt)) : o(i) === "light" ? (s(), r("g", xpt, [
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jpt),
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mpt),
        e("line", {
          x1: "200",
          y1: "200",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mpt),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vpt),
        e("line", {
          x1: "224",
          y1: "168",
          x2: "176",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Spt),
        e("line", {
          x1: "56",
          y1: "168",
          x2: "56",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hpt),
        e("line", {
          x1: "56",
          y1: "40",
          x2: "56",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Apt),
        e("line", {
          x1: "32",
          y1: "136",
          x2: "80",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vpt),
        e("line", {
          x1: "152",
          y1: "88",
          x2: "104",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zpt)
      ])) : o(i) === "thin" ? (s(), r("g", Zpt, [
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cpt),
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bpt),
        e("line", {
          x1: "200",
          y1: "200",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lpt),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bpt),
        e("line", {
          x1: "224",
          y1: "168",
          x2: "176",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ppt),
        e("line", {
          x1: "56",
          y1: "168",
          x2: "56",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wpt),
        e("line", {
          x1: "56",
          y1: "40",
          x2: "56",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Npt),
        e("line", {
          x1: "32",
          y1: "136",
          x2: "80",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fpt),
        e("line", {
          x1: "152",
          y1: "88",
          x2: "104",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Tpt)
      ])) : o(i) === "regular" ? (s(), r("g", Dpt, [
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rpt),
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Upt),
        e("line", {
          x1: "200",
          y1: "200",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qpt),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gpt),
        e("line", {
          x1: "224",
          y1: "168",
          x2: "176",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ept),
        e("line", {
          x1: "56",
          y1: "168",
          x2: "56",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Opt),
        e("line", {
          x1: "56",
          y1: "40",
          x2: "56",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ipt),
        e("line", {
          x1: "32",
          y1: "136",
          x2: "80",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kpt),
        e("line", {
          x1: "152",
          y1: "88",
          x2: "104",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xpt)
      ])) : g("", !0)
    ], 16, J_t));
  }
}), Qpt = ["width", "height", "fill", "transform"], Ypt = { key: 0 }, o3t = ["stroke"], e3t = ["stroke"], t3t = ["stroke"], n3t = ["stroke"], s3t = ["stroke"], r3t = ["stroke"], i3t = { key: 1 }, l3t = ["stroke"], d3t = ["stroke"], k3t = ["stroke"], c3t = ["stroke"], h3t = ["stroke"], u3t = ["stroke"], a3t = { key: 2 }, _3t = /* @__PURE__ */ e("path", { d: "M136,164H40a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z" }, null, -1), p3t = /* @__PURE__ */ e("path", { d: "M216,164H176V148a8,8,0,0,0-16,0v48a8,8,0,0,0,16,0V180h40a8,8,0,0,0,0-16Z" }, null, -1), y3t = /* @__PURE__ */ e("path", { d: "M40,92H72a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z" }, null, -1), $3t = /* @__PURE__ */ e("path", { d: "M104,116a8,8,0,0,0,8-8V92H216a8,8,0,0,0,0-16H112V60a8,8,0,0,0-16,0v48A8,8,0,0,0,104,116Z" }, null, -1), w3t = [
  _3t,
  p3t,
  y3t,
  $3t
], f3t = { key: 3 }, g3t = ["stroke"], x3t = ["stroke"], j3t = ["stroke"], m3t = ["stroke"], M3t = ["stroke"], v3t = ["stroke"], S3t = { key: 4 }, H3t = ["stroke"], A3t = ["stroke"], V3t = ["stroke"], z3t = ["stroke"], Z3t = ["stroke"], C3t = ["stroke"], b3t = { key: 5 }, L3t = ["stroke"], B3t = ["stroke"], P3t = ["stroke"], W3t = ["stroke"], N3t = ["stroke"], F3t = ["stroke"], T3t = {
  name: "PhFadersHorizontal"
}, IE1 = /* @__PURE__ */ $({
  ...T3t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ypt, [
        e("line", {
          x1: "132",
          y1: "172",
          x2: "40",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, o3t),
        e("line", {
          x1: "216",
          y1: "172",
          x2: "172",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, e3t),
        e("line", {
          x1: "68",
          y1: "84",
          x2: "40",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, t3t),
        e("line", {
          x1: "216",
          y1: "84",
          x2: "108",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, n3t),
        e("line", {
          x1: "108",
          y1: "60",
          x2: "108",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, s3t),
        e("line", {
          x1: "172",
          y1: "196",
          x2: "172",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, r3t)
      ])) : o(i) === "duotone" ? (s(), r("g", i3t, [
        e("line", {
          x1: "136",
          y1: "172",
          x2: "40",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l3t),
        e("line", {
          x1: "216",
          y1: "172",
          x2: "168",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, d3t),
        e("line", {
          x1: "72",
          y1: "84",
          x2: "40",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k3t),
        e("line", {
          x1: "216",
          y1: "84",
          x2: "104",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c3t),
        e("line", {
          x1: "104",
          y1: "60",
          x2: "104",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h3t),
        e("line", {
          x1: "168",
          y1: "196",
          x2: "168",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u3t)
      ])) : o(i) === "fill" ? (s(), r("g", a3t, w3t)) : o(i) === "light" ? (s(), r("g", f3t, [
        e("line", {
          x1: "136",
          y1: "172",
          x2: "40",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, g3t),
        e("line", {
          x1: "216",
          y1: "172",
          x2: "168",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, x3t),
        e("line", {
          x1: "72",
          y1: "84",
          x2: "40",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, j3t),
        e("line", {
          x1: "216",
          y1: "84",
          x2: "104",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, m3t),
        e("line", {
          x1: "104",
          y1: "60",
          x2: "104",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, M3t),
        e("line", {
          x1: "168",
          y1: "196",
          x2: "168",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, v3t)
      ])) : o(i) === "thin" ? (s(), r("g", S3t, [
        e("line", {
          x1: "136",
          y1: "172",
          x2: "40",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, H3t),
        e("line", {
          x1: "216",
          y1: "172",
          x2: "168",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, A3t),
        e("line", {
          x1: "72",
          y1: "84",
          x2: "40",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, V3t),
        e("line", {
          x1: "216",
          y1: "84",
          x2: "104",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, z3t),
        e("line", {
          x1: "104",
          y1: "60",
          x2: "104",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Z3t),
        e("line", {
          x1: "168",
          y1: "196",
          x2: "168",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, C3t)
      ])) : o(i) === "regular" ? (s(), r("g", b3t, [
        e("line", {
          x1: "136",
          y1: "172",
          x2: "40",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L3t),
        e("line", {
          x1: "216",
          y1: "172",
          x2: "168",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B3t),
        e("line", {
          x1: "72",
          y1: "84",
          x2: "40",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P3t),
        e("line", {
          x1: "216",
          y1: "84",
          x2: "104",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W3t),
        e("line", {
          x1: "104",
          y1: "60",
          x2: "104",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N3t),
        e("line", {
          x1: "168",
          y1: "196",
          x2: "168",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F3t)
      ])) : g("", !0)
    ], 16, Qpt));
  }
}), D3t = ["width", "height", "fill", "transform"], R3t = { key: 0 }, U3t = ["stroke"], q3t = ["stroke"], G3t = { key: 1 }, E3t = /* @__PURE__ */ e("path", {
  d: "M241.5,121.3,152.3,63.9A8,8,0,0,0,140,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,241.5,121.3Z",
  opacity: "0.2"
}, null, -1), O3t = /* @__PURE__ */ e("path", {
  d: "M129.5,121.3,40.3,63.9A8,8,0,0,0,28,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,129.5,121.3Z",
  opacity: "0.2"
}, null, -1), I3t = ["stroke"], K3t = ["stroke"], X3t = { key: 2 }, J3t = /* @__PURE__ */ e("path", { d: "M253.2,128a16,16,0,0,1-7.3,13.5l-89.2,57.3A16,16,0,0,1,132,185.3V142.7L44.7,198.8A16,16,0,0,1,20,185.3V70.7A16,16,0,0,1,44.7,57.2L132,113.3V70.7a16,16,0,0,1,24.7-13.5l89.2,57.3A16,16,0,0,1,253.2,128Z" }, null, -1), Q3t = [
  J3t
], Y3t = { key: 3 }, oyt = ["stroke"], eyt = ["stroke"], tyt = { key: 4 }, nyt = ["stroke"], syt = ["stroke"], ryt = { key: 5 }, iyt = ["stroke"], lyt = ["stroke"], dyt = {
  name: "PhFastForward"
}, KE1 = /* @__PURE__ */ $({
  ...dyt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", R3t, [
        e("path", {
          d: "M237.5,121.3,148.3,63.9A8,8,0,0,0,136,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,237.5,121.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, U3t),
        e("path", {
          d: "M129.5,121.3,40.3,63.9A8,8,0,0,0,28,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,129.5,121.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, q3t)
      ])) : o(i) === "duotone" ? (s(), r("g", G3t, [
        E3t,
        O3t,
        e("path", {
          d: "M241.5,121.3,152.3,63.9A8,8,0,0,0,140,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,241.5,121.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I3t),
        e("path", {
          d: "M129.5,121.3,40.3,63.9A8,8,0,0,0,28,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,129.5,121.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K3t)
      ])) : o(i) === "fill" ? (s(), r("g", X3t, Q3t)) : o(i) === "light" ? (s(), r("g", Y3t, [
        e("path", {
          d: "M241.5,121.3,152.3,63.9A8,8,0,0,0,140,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,241.5,121.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oyt),
        e("path", {
          d: "M129.5,121.3,40.3,63.9A8,8,0,0,0,28,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,129.5,121.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eyt)
      ])) : o(i) === "thin" ? (s(), r("g", tyt, [
        e("path", {
          d: "M241.5,121.3,152.3,63.9A8,8,0,0,0,140,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,241.5,121.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nyt),
        e("path", {
          d: "M129.5,121.3,40.3,63.9A8,8,0,0,0,28,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,129.5,121.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, syt)
      ])) : o(i) === "regular" ? (s(), r("g", ryt, [
        e("path", {
          d: "M241.5,121.3,152.3,63.9A8,8,0,0,0,140,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,241.5,121.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iyt),
        e("path", {
          d: "M129.5,121.3,40.3,63.9A8,8,0,0,0,28,70.7V185.3a8,8,0,0,0,12.3,6.8l89.2-57.4A7.9,7.9,0,0,0,129.5,121.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lyt)
      ])) : g("", !0)
    ], 16, D3t));
  }
}), kyt = ["width", "height", "fill", "transform"], cyt = { key: 0 }, hyt = ["stroke"], uyt = ["stroke"], ayt = ["stroke"], _yt = { key: 1 }, pyt = /* @__PURE__ */ e("path", {
  d: "M128,32a96,96,0,1,0,96,96A96,96,0,0,0,128,32ZM80,160V96l48,32Zm64,0V96l48,32Z",
  opacity: "0.2"
}, null, -1), yyt = ["stroke"], $yt = ["stroke"], wyt = ["stroke"], fyt = { key: 2 }, gyt = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm56.6,110.6-40,28A8.6,8.6,0,0,1,140,164a8,8,0,0,1-8-8V128a8.2,8.2,0,0,1-3.4,6.6l-40,28A8.6,8.6,0,0,1,84,164a8,8,0,0,1-8-8V100a8.1,8.1,0,0,1,4.3-7.1,8,8,0,0,1,8.3.5l40,28A8.2,8.2,0,0,1,132,128V100a8.1,8.1,0,0,1,4.3-7.1,8,8,0,0,1,8.3.5l40,28a8.1,8.1,0,0,1,0,13.2Z" }, null, -1), xyt = [
  gyt
], jyt = { key: 3 }, myt = ["stroke"], Myt = ["stroke"], vyt = ["stroke"], Syt = { key: 4 }, Hyt = ["stroke"], Ayt = ["stroke"], Vyt = ["stroke"], zyt = { key: 5 }, Zyt = ["stroke"], Cyt = ["stroke"], byt = ["stroke"], Lyt = {
  name: "PhFastForwardCircle"
}, XE1 = /* @__PURE__ */ $({
  ...Lyt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", cyt, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hyt),
        e("polygon", {
          points: "88 156 124 128 88 100 88 156",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uyt),
        e("polygon", {
          points: "144 156 180 128 144 100 144 156",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ayt)
      ])) : o(i) === "duotone" ? (s(), r("g", _yt, [
        pyt,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yyt),
        e("polygon", {
          points: "80 160 128 128 80 96 80 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $yt),
        e("polygon", {
          points: "144 160 192 128 144 96 144 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wyt)
      ])) : o(i) === "fill" ? (s(), r("g", fyt, xyt)) : o(i) === "light" ? (s(), r("g", jyt, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, myt),
        e("polygon", {
          points: "84 160 132 128 84 96 84 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Myt),
        e("polygon", {
          points: "140 160 188 128 140 96 140 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vyt)
      ])) : o(i) === "thin" ? (s(), r("g", Syt, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hyt),
        e("polygon", {
          points: "84 160 132 128 84 96 84 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ayt),
        e("polygon", {
          points: "140 160 188 128 140 96 140 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vyt)
      ])) : o(i) === "regular" ? (s(), r("g", zyt, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zyt),
        e("polygon", {
          points: "80 160 128 128 80 96 80 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cyt),
        e("polygon", {
          points: "144 160 192 128 144 96 144 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, byt)
      ])) : g("", !0)
    ], 16, kyt));
  }
}), Byt = ["width", "height", "fill", "transform"], Pyt = { key: 0 }, Wyt = ["stroke"], Nyt = ["stroke"], Fyt = ["stroke"], Tyt = ["stroke"], Dyt = ["stroke"], Ryt = { key: 1 }, Uyt = /* @__PURE__ */ e("circle", {
  cx: "162",
  cy: "128",
  r: "34",
  opacity: "0.2"
}, null, -1), qyt = /* @__PURE__ */ e("path", {
  d: "M128,94V26H94a34,34,0,0,0,0,68Z",
  opacity: "0.2"
}, null, -1), Gyt = /* @__PURE__ */ e("path", {
  d: "M128,162v34a34,34,0,1,1-34-34Z",
  opacity: "0.2"
}, null, -1), Eyt = ["stroke"], Oyt = ["stroke"], Iyt = ["stroke"], Kyt = ["stroke"], Xyt = ["stroke"], Jyt = { key: 2 }, Qyt = /* @__PURE__ */ e("path", { d: "M186.6,94A42,42,0,0,0,162,18H94A42,42,0,0,0,69.4,94a41.9,41.9,0,0,0,0,68A42,42,0,1,0,136,196V160.9A42,42,0,1,0,186.6,94ZM188,60a26.1,26.1,0,0,1-26,26H136V34h26A26.1,26.1,0,0,1,188,60Zm-26,94a26,26,0,0,1,0-52h0a26,26,0,0,1,0,52Z" }, null, -1), Yyt = [
  Qyt
], o5t = { key: 3 }, e5t = ["stroke"], t5t = ["stroke"], n5t = ["stroke"], s5t = ["stroke"], r5t = ["stroke"], i5t = { key: 4 }, l5t = ["stroke"], d5t = ["stroke"], k5t = ["stroke"], c5t = ["stroke"], h5t = ["stroke"], u5t = { key: 5 }, a5t = ["stroke"], _5t = ["stroke"], p5t = ["stroke"], y5t = ["stroke"], $5t = ["stroke"], w5t = {
  name: "PhFigmaLogo"
}, JE1 = /* @__PURE__ */ $({
  ...w5t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Pyt, [
        e("circle", {
          cx: "162",
          cy: "128",
          r: "34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wyt),
        e("path", {
          d: "M128,94V26H94a34,34,0,0,0,0,68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nyt),
        e("path", {
          d: "M128,162V94H94a34,34,0,0,0,0,68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fyt),
        e("path", {
          d: "M128,94V26h34a34,34,0,0,1,0,68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Tyt),
        e("path", {
          d: "M128,162v34a34,34,0,1,1-34-34Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Dyt)
      ])) : o(i) === "duotone" ? (s(), r("g", Ryt, [
        Uyt,
        qyt,
        Gyt,
        e("circle", {
          cx: "162",
          cy: "128",
          r: "34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Eyt),
        e("path", {
          d: "M128,94V26H94a34,34,0,0,0,0,68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Oyt),
        e("path", {
          d: "M128,162V94H94a34,34,0,0,0,0,68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Iyt),
        e("path", {
          d: "M128,94V26h34a34,34,0,0,1,0,68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kyt),
        e("path", {
          d: "M128,162v34a34,34,0,1,1-34-34Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xyt)
      ])) : o(i) === "fill" ? (s(), r("g", Jyt, Yyt)) : o(i) === "light" ? (s(), r("g", o5t, [
        e("circle", {
          cx: "162",
          cy: "128",
          r: "34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, e5t),
        e("path", {
          d: "M128,94V26H94a34,34,0,0,0,0,68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, t5t),
        e("path", {
          d: "M128,162V94H94a34,34,0,0,0,0,68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, n5t),
        e("path", {
          d: "M128,94V26h34a34,34,0,0,1,0,68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, s5t),
        e("path", {
          d: "M128,162v34a34,34,0,1,1-34-34Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, r5t)
      ])) : o(i) === "thin" ? (s(), r("g", i5t, [
        e("circle", {
          cx: "162",
          cy: "128",
          r: "34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, l5t),
        e("path", {
          d: "M128,94V26H94a34,34,0,0,0,0,68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, d5t),
        e("path", {
          d: "M128,162V94H94a34,34,0,0,0,0,68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, k5t),
        e("path", {
          d: "M128,94V26h34a34,34,0,0,1,0,68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, c5t),
        e("path", {
          d: "M128,162v34a34,34,0,1,1-34-34Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, h5t)
      ])) : o(i) === "regular" ? (s(), r("g", u5t, [
        e("circle", {
          cx: "162",
          cy: "128",
          r: "34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a5t),
        e("path", {
          d: "M128,94V26H94a34,34,0,0,0,0,68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _5t),
        e("path", {
          d: "M128,162V94H94a34,34,0,0,0,0,68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p5t),
        e("path", {
          d: "M128,94V26h34a34,34,0,0,1,0,68Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y5t),
        e("path", {
          d: "M128,162v34a34,34,0,1,1-34-34Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $5t)
      ])) : g("", !0)
    ], 16, Byt));
  }
}), f5t = ["width", "height", "fill", "transform"], g5t = { key: 0 }, x5t = ["stroke"], j5t = ["stroke"], m5t = { key: 1 }, M5t = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), v5t = ["stroke"], S5t = ["stroke"], H5t = { key: 2 }, A5t = /* @__PURE__ */ e("path", { d: "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3ZM152,88V44l44,44Z" }, null, -1), V5t = [
  A5t
], z5t = { key: 3 }, Z5t = ["stroke"], C5t = ["stroke"], b5t = { key: 4 }, L5t = ["stroke"], B5t = ["stroke"], P5t = { key: 5 }, W5t = ["stroke"], N5t = ["stroke"], F5t = {
  name: "PhFile"
}, QE1 = /* @__PURE__ */ $({
  ...F5t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", g5t, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, x5t),
        e("polyline", {
          points: "148 32 148 92 208 92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, j5t)
      ])) : o(i) === "duotone" ? (s(), r("g", m5t, [
        M5t,
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v5t),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S5t)
      ])) : o(i) === "fill" ? (s(), r("g", H5t, V5t)) : o(i) === "light" ? (s(), r("g", z5t, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Z5t),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, C5t)
      ])) : o(i) === "thin" ? (s(), r("g", b5t, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, L5t),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, B5t)
      ])) : o(i) === "regular" ? (s(), r("g", P5t, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W5t),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N5t)
      ])) : g("", !0)
    ], 16, f5t));
  }
}), T5t = ["width", "height", "fill", "transform"], D5t = { key: 0 }, R5t = ["stroke"], U5t = ["stroke"], q5t = ["stroke"], G5t = ["stroke"], E5t = { key: 1 }, O5t = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), I5t = ["stroke"], K5t = ["stroke"], X5t = ["stroke"], J5t = ["stroke"], Q5t = { key: 2 }, Y5t = /* @__PURE__ */ e("path", { d: "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3Zm-52,79.4-28,28a8.2,8.2,0,0,1-11.4,0l-28-28a8.1,8.1,0,0,1,11.4-11.4L120,164.7V120a8,8,0,0,1,16,0v44.7l14.3-14.4a8.1,8.1,0,0,1,11.4,11.4ZM152,88V44l44,44Z" }, null, -1), o7t = [
  Y5t
], e7t = { key: 3 }, t7t = ["stroke"], n7t = ["stroke"], s7t = ["stroke"], r7t = ["stroke"], i7t = { key: 4 }, l7t = ["stroke"], d7t = ["stroke"], k7t = ["stroke"], c7t = ["stroke"], h7t = { key: 5 }, u7t = ["stroke"], a7t = ["stroke"], _7t = ["stroke"], p7t = ["stroke"], y7t = {
  name: "PhFileArrowDown"
}, YE1 = /* @__PURE__ */ $({
  ...y7t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", D5t, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, R5t),
        e("polyline", {
          points: "148 32 148 92 208 92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, U5t),
        e("polyline", {
          points: "100 156 128 184 156 156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, q5t),
        e("line", {
          x1: "128",
          y1: "124",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, G5t)
      ])) : o(i) === "duotone" ? (s(), r("g", E5t, [
        O5t,
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I5t),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K5t),
        e("polyline", {
          points: "100 156 128 184 156 156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X5t),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J5t)
      ])) : o(i) === "fill" ? (s(), r("g", Q5t, o7t)) : o(i) === "light" ? (s(), r("g", e7t, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, t7t),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, n7t),
        e("polyline", {
          points: "100 156 128 184 156 156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, s7t),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, r7t)
      ])) : o(i) === "thin" ? (s(), r("g", i7t, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, l7t),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, d7t),
        e("polyline", {
          points: "100 156 128 184 156 156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, k7t),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, c7t)
      ])) : o(i) === "regular" ? (s(), r("g", h7t, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u7t),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a7t),
        e("polyline", {
          points: "100 156 128 184 156 156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _7t),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p7t)
      ])) : g("", !0)
    ], 16, T5t));
  }
}), $7t = ["width", "height", "fill", "transform"], w7t = { key: 0 }, f7t = ["stroke"], g7t = ["stroke"], x7t = ["stroke"], j7t = ["stroke"], m7t = { key: 1 }, M7t = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), v7t = ["stroke"], S7t = ["stroke"], H7t = ["stroke"], A7t = ["stroke"], V7t = { key: 2 }, z7t = /* @__PURE__ */ e("path", { d: "M213.6,82.3l-55.9-56-.3-.2-.3-.3-.3-.2-.3-.2c-.1-.1-.2-.1-.2-.2l-.5-.3h-.2l-.5-.3H155l-.7-.3H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A7.8,7.8,0,0,0,213.6,82.3Zm-51.9,71.4a8.1,8.1,0,0,1-11.4,0L136,139.3V184a8,8,0,0,1-16,0V139.3l-14.3,14.4a8.1,8.1,0,0,1-11.4-11.4l28-28h.1l.5-.5.3-.2.4-.3.3-.2.3-.2h.4l.3-.2h.4l.4-.2h4.6l.4.2h.4l.3.2h.4l.3.2.3.2.4.3.3.2.5.5h.1l28,28A8.1,8.1,0,0,1,161.7,153.7ZM152,88V43.3L196.7,88Z" }, null, -1), Z7t = [
  z7t
], C7t = { key: 3 }, b7t = ["stroke"], L7t = ["stroke"], B7t = ["stroke"], P7t = ["stroke"], W7t = { key: 4 }, N7t = ["stroke"], F7t = ["stroke"], T7t = ["stroke"], D7t = ["stroke"], R7t = { key: 5 }, U7t = ["stroke"], q7t = ["stroke"], G7t = ["stroke"], E7t = ["stroke"], O7t = {
  name: "PhFileArrowUp"
}, oO1 = /* @__PURE__ */ $({
  ...O7t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", w7t, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f7t),
        e("polyline", {
          points: "148 32 148 92 208 92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g7t),
        e("polyline", {
          points: "100 152 128 124 156 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, x7t),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, j7t)
      ])) : o(i) === "duotone" ? (s(), r("g", m7t, [
        M7t,
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v7t),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S7t),
        e("polyline", {
          points: "100 148 128 120 156 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H7t),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A7t)
      ])) : o(i) === "fill" ? (s(), r("g", V7t, Z7t)) : o(i) === "light" ? (s(), r("g", C7t, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b7t),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, L7t),
        e("polyline", {
          points: "100 148 128 120 156 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, B7t),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, P7t)
      ])) : o(i) === "thin" ? (s(), r("g", W7t, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, N7t),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, F7t),
        e("polyline", {
          points: "100 148 128 120 156 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, T7t),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, D7t)
      ])) : o(i) === "regular" ? (s(), r("g", R7t, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U7t),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q7t),
        e("polyline", {
          points: "100 148 128 120 156 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G7t),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E7t)
      ])) : g("", !0)
    ], 16, $7t));
  }
}), I7t = ["width", "height", "fill", "transform"], K7t = { key: 0 }, X7t = ["stroke"], J7t = ["stroke"], Q7t = ["stroke"], Y7t = ["stroke"], o9t = { key: 1 }, e9t = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), t9t = ["stroke"], n9t = ["stroke"], s9t = /* @__PURE__ */ e("polygon", {
  points: "48 204 48 172 72 172 96 152 96 224 72 204 48 204",
  opacity: "0.2"
}, null, -1), r9t = ["stroke"], i9t = ["stroke"], l9t = { key: 2 }, d9t = /* @__PURE__ */ e("path", { d: "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V216H168a8,8,0,0,0,0,16h32a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3ZM160,80V51.3L188.7,80Zm-56,72v72a7.9,7.9,0,0,1-4.6,7.2,6.8,6.8,0,0,1-3.4.8,7.5,7.5,0,0,1-5.1-1.9L69.1,212H48a8,8,0,0,1-8-8V172a8,8,0,0,1,8-8H69.1l21.8-18.1a7.8,7.8,0,0,1,8.5-1.1A7.9,7.9,0,0,1,104,152Zm44,36a39.8,39.8,0,0,1-15,31.2,7.9,7.9,0,0,1-5,1.8,7.8,7.8,0,0,1-6.2-3,8.1,8.1,0,0,1,1.2-11.3,23.9,23.9,0,0,0,0-37.4,8,8,0,0,1,10-12.5A39.8,39.8,0,0,1,148,188Z" }, null, -1), k9t = [
  d9t
], c9t = { key: 3 }, h9t = ["stroke"], u9t = ["stroke"], a9t = ["stroke"], _9t = ["stroke"], p9t = { key: 4 }, y9t = ["stroke"], $9t = ["stroke"], w9t = ["stroke"], f9t = ["stroke"], g9t = { key: 5 }, x9t = ["stroke"], j9t = ["stroke"], m9t = ["stroke"], M9t = ["stroke"], v9t = {
  name: "PhFileAudio"
}, eO1 = /* @__PURE__ */ $({
  ...v9t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", K7t, [
        e("polyline", {
          points: "148 32 148 92 208 92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X7t),
        e("path", {
          d: "M180,224h20a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, J7t),
        e("polygon", {
          points: "48 204 48 164 72 164 96 144 96 224 72 204 48 204",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Q7t),
        e("path", {
          d: "M136,163a32,32,0,0,1,0,50",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Y7t)
      ])) : o(i) === "duotone" ? (s(), r("g", o9t, [
        e9t,
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t9t),
        e("path", {
          d: "M168,224h32a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n9t),
        s9t,
        e("polygon", {
          points: "48 204 48 172 72 172 96 152 96 224 72 204 48 204",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r9t),
        e("path", {
          d: "M128,163a32,32,0,0,1,0,50",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, i9t)
      ])) : o(i) === "fill" ? (s(), r("g", l9t, k9t)) : o(i) === "light" ? (s(), r("g", c9t, [
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, h9t),
        e("path", {
          d: "M168,224h32a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u9t),
        e("polygon", {
          points: "48 204 48 172 72 172 96 152 96 224 72 204 48 204",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, a9t),
        e("path", {
          d: "M128,163a32,32,0,0,1,0,50",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _9t)
      ])) : o(i) === "thin" ? (s(), r("g", p9t, [
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, y9t),
        e("path", {
          d: "M168,224h32a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $9t),
        e("polygon", {
          points: "48 204 48 172 72 172 96 152 96 224 72 204 48 204",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, w9t),
        e("path", {
          d: "M128,163a32,32,0,0,1,0,50",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, f9t)
      ])) : o(i) === "regular" ? (s(), r("g", g9t, [
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, x9t),
        e("path", {
          d: "M168,224h32a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j9t),
        e("polygon", {
          points: "48 204 48 172 72 172 96 152 96 224 72 204 48 204",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m9t),
        e("path", {
          d: "M128,163a32,32,0,0,1,0,50",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M9t)
      ])) : g("", !0)
    ], 16, I7t));
  }
}), S9t = ["width", "height", "fill", "transform"], H9t = { key: 0 }, A9t = ["stroke"], V9t = ["stroke"], z9t = ["stroke"], Z9t = { key: 1 }, C9t = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), b9t = ["stroke"], L9t = ["stroke"], B9t = ["stroke"], P9t = { key: 2 }, W9t = /* @__PURE__ */ e("path", { d: "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V216H176a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3ZM160,51.3,188.7,80H160ZM160,180a52,52,0,0,1-52,52H60a36,36,0,0,1-9.2-70.8A65.3,65.3,0,0,0,48,180a8,8,0,0,0,16,0,47.4,47.4,0,0,1,4.4-20h0A48,48,0,0,1,160,180Z" }, null, -1), N9t = [
  W9t
], F9t = { key: 3 }, T9t = ["stroke"], D9t = ["stroke"], R9t = ["stroke"], U9t = { key: 4 }, q9t = ["stroke"], G9t = ["stroke"], E9t = ["stroke"], O9t = { key: 5 }, I9t = ["stroke"], K9t = ["stroke"], X9t = ["stroke"], J9t = {
  name: "PhFileCloud"
}, tO1 = /* @__PURE__ */ $({
  ...J9t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", H9t, [
        e("polyline", {
          points: "148 32 148 92 208 92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, A9t),
        e("path", {
          d: "M180,224h20a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, V9t),
        e("path", {
          d: "M65.7,168H60a28,28,0,0,0,0,56h48a44,44,0,1,0-44-44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, z9t)
      ])) : o(i) === "duotone" ? (s(), r("g", Z9t, [
        C9t,
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b9t),
        e("path", {
          d: "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L9t),
        e("path", {
          d: "M65.7,168H60a28,28,0,0,0,0,56h48a44,44,0,1,0-44-44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B9t)
      ])) : o(i) === "fill" ? (s(), r("g", P9t, N9t)) : o(i) === "light" ? (s(), r("g", F9t, [
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, T9t),
        e("path", {
          d: "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, D9t),
        e("path", {
          d: "M65.7,168H60a28,28,0,0,0,0,56h48a44,44,0,1,0-44-44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, R9t)
      ])) : o(i) === "thin" ? (s(), r("g", U9t, [
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, q9t),
        e("path", {
          d: "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, G9t),
        e("path", {
          d: "M65.7,168H60a28,28,0,0,0,0,56h48a44,44,0,1,0-44-44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, E9t)
      ])) : o(i) === "regular" ? (s(), r("g", O9t, [
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I9t),
        e("path", {
          d: "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K9t),
        e("path", {
          d: "M65.7,168H60a28,28,0,0,0,0,56h48a44,44,0,1,0-44-44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X9t)
      ])) : g("", !0)
    ], 16, S9t));
  }
}), Q9t = ["width", "height", "fill", "transform"], Y9t = { key: 0 }, o$t = ["stroke"], e$t = ["stroke"], t$t = ["stroke"], n$t = ["stroke"], s$t = { key: 1 }, r$t = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), i$t = ["stroke"], l$t = ["stroke"], d$t = ["stroke"], k$t = ["stroke"], c$t = { key: 2 }, h$t = /* @__PURE__ */ e("path", { d: "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3Zm-104,88a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0l-24-24a8.1,8.1,0,0,1,0-11.4l24-24a8.1,8.1,0,0,1,11.4,11.4L91.3,152Zm72-12.6-24,24a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L164.7,152l-18.4-18.3a8.1,8.1,0,0,1,11.4-11.4l24,24A8.1,8.1,0,0,1,181.7,157.7ZM152,88V44l44,44Z" }, null, -1), u$t = [
  h$t
], a$t = { key: 3 }, _$t = ["stroke"], p$t = ["stroke"], y$t = ["stroke"], $$t = ["stroke"], w$t = { key: 4 }, f$t = ["stroke"], g$t = ["stroke"], x$t = ["stroke"], j$t = ["stroke"], m$t = { key: 5 }, M$t = ["stroke"], v$t = ["stroke"], S$t = ["stroke"], H$t = ["stroke"], A$t = {
  name: "PhFileCode"
}, nO1 = /* @__PURE__ */ $({
  ...A$t,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Y9t, [
        e("polyline", {
          points: "148 132 172 156 148 180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, o$t),
        e("polyline", {
          points: "108 132 84 156 108 180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, e$t),
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, t$t),
        e("polyline", {
          points: "148 32 148 92 208 92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, n$t)
      ])) : o(i) === "duotone" ? (s(), r("g", s$t, [
        r$t,
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, i$t),
        e("polyline", {
          points: "148 128 172 152 148 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l$t),
        e("polyline", {
          points: "108 128 84 152 108 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, d$t),
        e("path", {
          d: "M200,224a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k$t)
      ])) : o(i) === "fill" ? (s(), r("g", c$t, u$t)) : o(i) === "light" ? (s(), r("g", a$t, [
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _$t),
        e("polyline", {
          points: "148 128 172 152 148 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, p$t),
        e("polyline", {
          points: "108 128 84 152 108 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, y$t),
        e("path", {
          d: "M200,224a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $$t)
      ])) : o(i) === "thin" ? (s(), r("g", w$t, [
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, f$t),
        e("polyline", {
          points: "148 128 172 152 148 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, g$t),
        e("polyline", {
          points: "108 128 84 152 108 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, x$t),
        e("path", {
          d: "M200,224a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, j$t)
      ])) : o(i) === "regular" ? (s(), r("g", m$t, [
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M$t),
        e("polyline", {
          points: "148 128 172 152 148 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v$t),
        e("polyline", {
          points: "108 128 84 152 108 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S$t),
        e("path", {
          d: "M200,224a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H$t)
      ])) : g("", !0)
    ], 16, Q9t));
  }
}), V$t = ["width", "height", "fill", "transform"], z$t = { key: 0 }, Z$t = ["stroke"], C$t = ["stroke"], b$t = ["stroke"], L$t = ["stroke"], B$t = ["stroke"], P$t = { key: 1 }, W$t = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), N$t = ["stroke"], F$t = ["stroke"], T$t = ["stroke"], D$t = ["stroke"], R$t = ["stroke"], U$t = { key: 2 }, q$t = /* @__PURE__ */ e("path", { d: "M129.7,183.8c-3.1-.8-8.6-2.3-9.7-3.6V180c0-3.3,2.4-5,7-5a18.4,18.4,0,0,1,10,3.2h-.1A8.3,8.3,0,0,0,142,180a8,8,0,0,0,8-8,7.6,7.6,0,0,0-2.9-6.1h0A33.4,33.4,0,0,0,127,159c-13.5,0-23,8.6-23,21s13,17,21.6,19.3c3.4.9,7,1.8,9.2,3.1s1.2,1,1.2,1.6,0,5-9,5a18.4,18.4,0,0,1-10-3.2h.1A8.3,8.3,0,0,0,112,204a8,8,0,0,0-8,8,7.6,7.6,0,0,0,2.9,6.1h0A33.4,33.4,0,0,0,127,225c15.7,0,25-7.9,25-21S138,186,129.7,183.8Zm7.2-5.7h0Zm-19.8,27.8h0ZM52,192c0,8.8,6.3,16,14,16a12.9,12.9,0,0,0,8.6-3.4,7.9,7.9,0,0,1,11.3.6,8,8,0,0,1-.5,11.3A29.3,29.3,0,0,1,66,224c-16.5,0-30-14.4-30-32s13.5-32,30-32a29.3,29.3,0,0,1,19.4,7.5,8,8,0,0,1,.5,11.3,7.9,7.9,0,0,1-11.3.6A12.9,12.9,0,0,0,66,176C58.3,176,52,183.2,52,192Zm141.7-8.2c-3.1-.8-8.6-2.3-9.7-3.6V180c0-3.3,2.4-5,7-5a18.4,18.4,0,0,1,10,3.2h-.1A8.3,8.3,0,0,0,206,180a8,8,0,0,0,8-8,7.6,7.6,0,0,0-2.9-6.1h0A33.4,33.4,0,0,0,191,159c-13.5,0-23,8.6-23,21s13,17,21.6,19.3c3.4.9,7,1.8,9.2,3.1s1.2,1,1.2,1.6,0,5-9,5a18.4,18.4,0,0,1-10-3.2h.1A8.3,8.3,0,0,0,176,204a8,8,0,0,0-8,8,7.6,7.6,0,0,0,2.9,6.1h0A33.4,33.4,0,0,0,191,225c15.7,0,25-7.9,25-21S202,186,193.7,183.8Zm7.2-5.7h0Zm-19.8,27.8h0Zm20.5-27.2Zm-64,0Zm76.1-96.4-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V88A8.1,8.1,0,0,0,213.7,82.3ZM152,88V44l44,44Z" }, null, -1), G$t = [
  q$t
], E$t = { key: 3 }, O$t = ["stroke"], I$t = ["stroke"], K$t = ["stroke"], X$t = ["stroke"], J$t = ["stroke"], Q$t = { key: 4 }, Y$t = ["stroke"], owt = ["stroke"], ewt = ["stroke"], twt = ["stroke"], nwt = ["stroke"], swt = { key: 5 }, rwt = ["stroke"], iwt = ["stroke"], lwt = ["stroke"], dwt = ["stroke"], kwt = ["stroke"], cwt = {
  name: "PhFileCss"
}, sO1 = /* @__PURE__ */ $({
  ...cwt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", z$t, [
        e("polyline", {
          points: "148 36 148 100 212 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Z$t),
        e("path", {
          d: "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, C$t),
        e("path", {
          d: "M180,214.4a23.7,23.7,0,0,0,15,5.6c9,0,17-3.4,17-14.6,0-17.9-32-10-32-26.8,0-9,6-14.6,15-14.6a23.7,23.7,0,0,1,15,5.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, b$t),
        e("path", {
          d: "M116,214.4a23.7,23.7,0,0,0,15,5.6c9,0,17-3.4,17-14.6,0-17.9-32-10-32-26.8,0-9,6-14.6,15-14.6a23.7,23.7,0,0,1,15,5.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, L$t),
        e("path", {
          d: "M84,215.6A24.2,24.2,0,0,1,70,220c-14.4,0-26-12.5-26-28s11.6-28,26-28a24.2,24.2,0,0,1,14,4.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, B$t)
      ])) : o(i) === "duotone" ? (s(), r("g", P$t, [
        W$t,
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N$t),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F$t),
        e("path", {
          d: "M80,210.5A21,21,0,0,1,66,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T$t),
        e("path", {
          d: "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D$t),
        e("path", {
          d: "M176,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R$t)
      ])) : o(i) === "fill" ? (s(), r("g", U$t, G$t)) : o(i) === "light" ? (s(), r("g", E$t, [
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, O$t),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, I$t),
        e("path", {
          d: "M80,210.5A21,21,0,0,1,66,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, K$t),
        e("path", {
          d: "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, X$t),
        e("path", {
          d: "M176,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, J$t)
      ])) : o(i) === "thin" ? (s(), r("g", Q$t, [
        e("path", {
          d: "M80,210.5A21,21,0,0,1,66,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Y$t),
        e("path", {
          d: "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, owt),
        e("path", {
          d: "M176,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ewt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, twt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nwt)
      ])) : o(i) === "regular" ? (s(), r("g", swt, [
        e("path", {
          d: "M80,210.5A21,21,0,0,1,66,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rwt),
        e("path", {
          d: "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iwt),
        e("path", {
          d: "M176,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lwt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dwt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kwt)
      ])) : g("", !0)
    ], 16, V$t));
  }
}), hwt = ["width", "height", "fill", "transform"], uwt = { key: 0 }, awt = ["stroke"], _wt = ["stroke"], pwt = ["stroke"], ywt = ["stroke"], $wt = ["stroke"], wwt = { key: 1 }, fwt = ["stroke"], gwt = ["stroke"], xwt = ["stroke"], jwt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), mwt = ["stroke"], Mwt = ["stroke"], vwt = { key: 2 }, Swt = /* @__PURE__ */ e("path", { d: "M219.4,171.1l-20,48a8,8,0,0,1-14.8,0l-20-48a8,8,0,1,1,14.8-6.2L192,195.2l12.6-30.3a8,8,0,1,1,14.8,6.2ZM66,176a12.9,12.9,0,0,1,8.6,3.4,7.9,7.9,0,0,0,11.3-.6,8,8,0,0,0-.5-11.3A29.3,29.3,0,0,0,66,160c-16.5,0-30,14.4-30,32s13.5,32,30,32a29.3,29.3,0,0,0,19.4-7.5,8,8,0,0,0,.5-11.3,7.9,7.9,0,0,0-11.3-.6A12.9,12.9,0,0,1,66,208c-7.7,0-14-7.2-14-16S58.3,176,66,176Zm63.7,7.8c-3.1-.8-8.6-2.3-9.7-3.6V180c0-3.3,2.4-5,7-5a18.4,18.4,0,0,1,10,3.2h-.1A8.3,8.3,0,0,0,142,180a8,8,0,0,0,8-8,7.6,7.6,0,0,0-2.9-6.1h0A33.4,33.4,0,0,0,127,159c-13.5,0-23,8.6-23,21s13,17,21.6,19.3c3.4.9,7,1.8,9.2,3.1s1.2,1,1.2,1.6,0,5-9,5a18.4,18.4,0,0,1-10-3.2h.1A8.3,8.3,0,0,0,112,204a8,8,0,0,0-8,8,7.6,7.6,0,0,0,2.9,6.1h0A33.4,33.4,0,0,0,127,225c15.7,0,25-7.9,25-21S138,186,129.7,183.8ZM40,128V40A16,16,0,0,1,56,24h96a8.1,8.1,0,0,1,5.7,2.3l56,56A8.1,8.1,0,0,1,216,88v40a8,8,0,0,1-8,8H48A8,8,0,0,1,40,128ZM152,88h44L152,44Z" }, null, -1), Hwt = [
  Swt
], Awt = { key: 3 }, Vwt = ["stroke"], zwt = ["stroke"], Zwt = ["stroke"], Cwt = ["stroke"], bwt = ["stroke"], Lwt = { key: 4 }, Bwt = ["stroke"], Pwt = ["stroke"], Wwt = ["stroke"], Nwt = ["stroke"], Fwt = ["stroke"], Twt = { key: 5 }, Dwt = ["stroke"], Rwt = ["stroke"], Uwt = ["stroke"], qwt = ["stroke"], Gwt = ["stroke"], Ewt = {
  name: "PhFileCsv"
}, rO1 = /* @__PURE__ */ $({
  ...Ewt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", uwt, [
        e("polyline", {
          points: "176 164 198 220 220 164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, awt),
        e("polyline", {
          points: "148 36 148 100 212 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _wt),
        e("path", {
          d: "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pwt),
        e("path", {
          d: "M112,214.4a23.7,23.7,0,0,0,15,5.6c9,0,17-3.4,17-14.6,0-17.9-32-10-32-26.8,0-9,6-14.6,15-14.6a23.7,23.7,0,0,1,15,5.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ywt),
        e("path", {
          d: "M76,215.6A24.2,24.2,0,0,1,62,220c-14.4,0-26-12.5-26-28s11.6-28,26-28a24.2,24.2,0,0,1,14,4.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $wt)
      ])) : o(i) === "duotone" ? (s(), r("g", wwt, [
        e("polyline", {
          points: "172 168 192 216 212 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fwt),
        e("path", {
          d: "M80,210.5A21,21,0,0,1,66,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gwt),
        e("path", {
          d: "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xwt),
        jwt,
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mwt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mwt)
      ])) : o(i) === "fill" ? (s(), r("g", vwt, Hwt)) : o(i) === "light" ? (s(), r("g", Awt, [
        e("polyline", {
          points: "172 168 192 216 212 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vwt),
        e("path", {
          d: "M80,210.5A21,21,0,0,1,66,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zwt),
        e("path", {
          d: "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zwt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cwt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bwt)
      ])) : o(i) === "thin" ? (s(), r("g", Lwt, [
        e("polyline", {
          points: "172 168 192 216 212 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bwt),
        e("path", {
          d: "M80,210.5A21,21,0,0,1,66,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pwt),
        e("path", {
          d: "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wwt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nwt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fwt)
      ])) : o(i) === "regular" ? (s(), r("g", Twt, [
        e("polyline", {
          points: "172 168 192 216 212 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dwt),
        e("path", {
          d: "M80,210.5A21,21,0,0,1,66,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rwt),
        e("path", {
          d: "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uwt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qwt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gwt)
      ])) : g("", !0)
    ], 16, hwt));
  }
}), Owt = ["width", "height", "fill", "transform"], Iwt = { key: 0 }, Kwt = ["stroke"], Xwt = ["stroke"], Jwt = ["stroke"], Qwt = ["stroke"], Ywt = ["stroke"], oft = { key: 1 }, eft = ["stroke"], tft = ["stroke"], nft = ["stroke"], sft = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), rft = ["stroke"], ift = ["stroke"], lft = { key: 2 }, dft = /* @__PURE__ */ e("path", { d: "M58,160H44a8,8,0,0,0-8,8v48a8,8,0,0,0,8,8H58a32,32,0,0,0,0-64Zm0,48H52V176h6a16,16,0,0,1,0,32Zm72-48c-16.5,0-30,14.4-30,32s13.5,32,30,32,30-14.4,30-32S146.5,160,130,160Zm0,48c-7.7,0-14-7.2-14-16s6.3-16,14-16,14,7.2,14,16S137.7,208,130,208Zm87.9-2.8a8,8,0,0,1-.5,11.3A29.3,29.3,0,0,1,198,224c-16.5,0-30-14.4-30-32s13.5-32,30-32a29.3,29.3,0,0,1,19.4,7.5,8,8,0,0,1,.5,11.3,7.9,7.9,0,0,1-11.3.6A12.9,12.9,0,0,0,198,176c-7.7,0-14,7.2-14,16s6.3,16,14,16a12.9,12.9,0,0,0,8.6-3.4A7.9,7.9,0,0,1,217.9,205.2ZM48,136H208a8,8,0,0,0,8-8V88a8.1,8.1,0,0,0-2.3-5.7l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88A8,8,0,0,0,48,136ZM152,44l44,44H152Z" }, null, -1), kft = [
  dft
], cft = { key: 3 }, hft = ["stroke"], uft = ["stroke"], aft = ["stroke"], _ft = ["stroke"], pft = ["stroke"], yft = { key: 4 }, $ft = ["stroke"], wft = ["stroke"], fft = ["stroke"], gft = ["stroke"], xft = ["stroke"], jft = { key: 5 }, mft = ["stroke"], Mft = ["stroke"], vft = ["stroke"], Sft = ["stroke"], Hft = ["stroke"], Aft = {
  name: "PhFileDoc"
}, iO1 = /* @__PURE__ */ $({
  ...Aft,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Iwt, [
        e("polyline", {
          points: "148 36 148 100 212 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kwt),
        e("path", {
          d: "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xwt),
        e("path", {
          d: "M28,220V164H44a28,28,0,0,1,0,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jwt),
        e("path", {
          d: "M228,215.6a24.2,24.2,0,0,1-14,4.4c-14.4,0-26-12.5-26-28s11.6-28,26-28a24.2,24.2,0,0,1,14,4.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qwt),
        e("ellipse", {
          cx: "130",
          cy: "192",
          rx: "26",
          ry: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ywt)
      ])) : o(i) === "duotone" ? (s(), r("g", oft, [
        e("path", {
          d: "M58,216a24,24,0,0,0,0-48H44v48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eft),
        e("ellipse", {
          cx: "130",
          cy: "192",
          rx: "22",
          ry: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tft),
        e("path", {
          d: "M212,210.5a21,21,0,0,1-14,5.5c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nft),
        sft,
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rft),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ift)
      ])) : o(i) === "fill" ? (s(), r("g", lft, kft)) : o(i) === "light" ? (s(), r("g", cft, [
        e("path", {
          d: "M58,216a24,24,0,0,0,0-48H44v48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hft),
        e("ellipse", {
          cx: "130",
          cy: "192",
          rx: "22",
          ry: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uft),
        e("path", {
          d: "M212,210.5a21,21,0,0,1-14,5.5c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aft),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _ft),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pft)
      ])) : o(i) === "thin" ? (s(), r("g", yft, [
        e("path", {
          d: "M58,216a24,24,0,0,0,0-48H44v48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $ft),
        e("ellipse", {
          cx: "130",
          cy: "192",
          rx: "22",
          ry: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wft),
        e("path", {
          d: "M212,210.5a21,21,0,0,1-14,5.5c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fft),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gft),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xft)
      ])) : o(i) === "regular" ? (s(), r("g", jft, [
        e("path", {
          d: "M58,216a24,24,0,0,0,0-48H44v48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mft),
        e("ellipse", {
          cx: "130",
          cy: "192",
          rx: "22",
          ry: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mft),
        e("path", {
          d: "M212,210.5a21,21,0,0,1-14,5.5c-12.2,0-22-10.7-22-24s9.8-24,22-24a21,21,0,0,1,14,5.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vft),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sft),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hft)
      ])) : g("", !0)
    ], 16, Owt));
  }
}), Vft = ["width", "height", "fill", "transform"], zft = { key: 0 }, Zft = ["stroke"], Cft = ["stroke"], bft = ["stroke"], Lft = ["stroke"], Bft = ["stroke"], Pft = ["stroke"], Wft = ["stroke"], Nft = { key: 1 }, Fft = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), Tft = ["stroke"], Dft = ["stroke"], Rft = ["stroke"], Uft = ["stroke"], qft = ["stroke"], Gft = ["stroke"], Eft = ["stroke"], Oft = { key: 2 }, Ift = /* @__PURE__ */ e("path", { d: "M80,224a8,8,0,0,1-8,8H56a16,16,0,0,1-16-16V184a8,8,0,0,1,16,0v32H72A8,8,0,0,1,80,224ZM80,24H56A16,16,0,0,0,40,40V64a8,8,0,0,0,16,0V40H80a8,8,0,0,0,0-16ZM216,88a7.8,7.8,0,0,0-2.4-5.7l-55.9-56h-.2l-.4-.4h-.2l-.4-.3c-.1-.1-.2-.1-.2-.2l-.5-.3h-.2l-.5-.3H155l-.7-.3H120a8,8,0,0,0,0,16h24V88a8,8,0,0,0,8,8h48v40a8,8,0,0,0,16,0V88Zm-8,80a8,8,0,0,0-8,8v40h-8a8,8,0,0,0,0,16h8a16,16,0,0,0,16-16V176A8,8,0,0,0,208,168ZM48,152a8,8,0,0,0,8-8V104a8,8,0,0,0-16,0v40A8,8,0,0,0,48,152Zm104,64H112a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Z" }, null, -1), Kft = [
  Ift
], Xft = { key: 3 }, Jft = ["stroke"], Qft = ["stroke"], Yft = ["stroke"], ogt = ["stroke"], egt = ["stroke"], tgt = ["stroke"], ngt = ["stroke"], sgt = { key: 4 }, rgt = ["stroke"], igt = ["stroke"], lgt = ["stroke"], dgt = ["stroke"], kgt = ["stroke"], cgt = ["stroke"], hgt = ["stroke"], ugt = { key: 5 }, agt = ["stroke"], _gt = ["stroke"], pgt = ["stroke"], ygt = ["stroke"], $gt = ["stroke"], wgt = ["stroke"], fgt = ["stroke"], ggt = {
  name: "PhFileDotted"
}, lO1 = /* @__PURE__ */ $({
  ...ggt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", zft, [
        e("polyline", {
          points: "148 32 148 92 208 92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zft),
        e("path", {
          d: "M72,224H56a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cft),
        e("polyline", {
          points: "120 32 152 32 208 88 208 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bft),
        e("path", {
          d: "M48,64V40a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lft),
        e("path", {
          d: "M208,176v40a8,8,0,0,1-8,8h-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bft),
        e("line", {
          x1: "48",
          y1: "104",
          x2: "48",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pft),
        e("line", {
          x1: "112",
          y1: "224",
          x2: "152",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wft)
      ])) : o(i) === "duotone" ? (s(), r("g", Nft, [
        Fft,
        e("path", {
          d: "M72,224H56a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tft),
        e("polyline", {
          points: "120 32 152 32 208 88 208 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dft),
        e("path", {
          d: "M48,64V40a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rft),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uft),
        e("path", {
          d: "M208,176v40a8,8,0,0,1-8,8h-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qft),
        e("line", {
          x1: "48",
          y1: "104",
          x2: "48",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gft),
        e("line", {
          x1: "112",
          y1: "224",
          x2: "152",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Eft)
      ])) : o(i) === "fill" ? (s(), r("g", Oft, Kft)) : o(i) === "light" ? (s(), r("g", Xft, [
        e("path", {
          d: "M72,224H56a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jft),
        e("polyline", {
          points: "120 32 152 32 208 88 208 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qft),
        e("path", {
          d: "M48,64V40a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Yft),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ogt),
        e("path", {
          d: "M208,176v40a8,8,0,0,1-8,8h-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, egt),
        e("line", {
          x1: "48",
          y1: "104",
          x2: "48",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tgt),
        e("line", {
          x1: "112",
          y1: "224",
          x2: "152",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ngt)
      ])) : o(i) === "thin" ? (s(), r("g", sgt, [
        e("path", {
          d: "M72,224H56a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rgt),
        e("polyline", {
          points: "120 32 152 32 208 88 208 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, igt),
        e("path", {
          d: "M48,64V40a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lgt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dgt),
        e("path", {
          d: "M208,176v40a8,8,0,0,1-8,8h-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kgt),
        e("line", {
          x1: "48",
          y1: "104",
          x2: "48",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cgt),
        e("line", {
          x1: "112",
          y1: "224",
          x2: "152",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hgt)
      ])) : o(i) === "regular" ? (s(), r("g", ugt, [
        e("path", {
          d: "M72,224H56a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, agt),
        e("polyline", {
          points: "120 32 152 32 208 88 208 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _gt),
        e("path", {
          d: "M48,64V40a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pgt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ygt),
        e("path", {
          d: "M208,176v40a8,8,0,0,1-8,8h-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $gt),
        e("line", {
          x1: "48",
          y1: "104",
          x2: "48",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wgt),
        e("line", {
          x1: "112",
          y1: "224",
          x2: "152",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fgt)
      ])) : g("", !0)
    ], 16, Vft));
  }
}), xgt = ["width", "height", "fill", "transform"], jgt = { key: 0 }, mgt = ["stroke"], Mgt = ["stroke"], vgt = ["stroke"], Sgt = ["stroke"], Hgt = ["stroke"], Agt = ["stroke"], Vgt = ["stroke"], zgt = ["stroke"], Zgt = ["stroke"], Cgt = { key: 1 }, bgt = ["stroke"], Lgt = ["stroke"], Bgt = ["stroke"], Pgt = ["stroke"], Wgt = ["stroke"], Ngt = ["stroke"], Fgt = ["stroke"], Tgt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), Dgt = ["stroke"], Rgt = ["stroke"], Ugt = { key: 2 }, qgt = /* @__PURE__ */ j('<path d="M120,168H88a8,8,0,0,0,0,16h8v32a8,8,0,0,0,16,0V184h8a8,8,0,0,0,0-16Z"></path><path d="M64,168a8,8,0,0,0-8,8v12H44V176a8,8,0,0,0-16,0v40a8,8,0,0,0,16,0V204H56v12a8,8,0,0,0,16,0V176A8,8,0,0,0,64,168Z"></path><path d="M236,208H220V176a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8h24a8,8,0,0,0,0-16Z"></path><path d="M186.4,168.4a7.8,7.8,0,0,0-8.9,3L164,190.2l-13.5-18.8A8,8,0,0,0,136,176v40a8,8,0,0,0,16,0V201l5.5,7.6a7.9,7.9,0,0,0,13,0L176,201v15a8,8,0,0,0,16,0V176A7.8,7.8,0,0,0,186.4,168.4Z"></path><path d="M48,136H208a8,8,0,0,0,8-8V88a8.1,8.1,0,0,0-2.3-5.7l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88A8,8,0,0,0,48,136ZM152,44l44,44H152Z"></path>', 5), Ggt = [
  qgt
], Egt = { key: 3 }, Ogt = ["stroke"], Igt = ["stroke"], Kgt = ["stroke"], Xgt = ["stroke"], Jgt = ["stroke"], Qgt = ["stroke"], Ygt = ["stroke"], oxt = ["stroke"], ext = ["stroke"], txt = { key: 4 }, nxt = ["stroke"], sxt = ["stroke"], rxt = ["stroke"], ixt = ["stroke"], lxt = ["stroke"], dxt = ["stroke"], kxt = ["stroke"], cxt = ["stroke"], hxt = ["stroke"], uxt = { key: 5 }, axt = ["stroke"], _xt = ["stroke"], pxt = ["stroke"], yxt = ["stroke"], $xt = ["stroke"], wxt = ["stroke"], fxt = ["stroke"], gxt = ["stroke"], xxt = ["stroke"], jxt = {
  name: "PhFileHtml"
}, dO1 = /* @__PURE__ */ $({
  ...jxt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", jgt, [
        e("line", {
          x1: "140",
          y1: "164",
          x2: "60",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mgt),
        e("line", {
          x1: "100",
          y1: "220",
          x2: "100",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mgt),
        e("line", {
          x1: "20",
          y1: "164",
          x2: "20",
          y2: "220",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vgt),
        e("line", {
          x1: "60",
          y1: "164",
          x2: "60",
          y2: "220",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Sgt),
        e("line", {
          x1: "20",
          y1: "192",
          x2: "60",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hgt),
        e("polyline", {
          points: "220 164 220 220 244 220",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Agt),
        e("polyline", {
          points: "140 220 140 164 164 196 188 164 188 220",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vgt),
        e("polyline", {
          points: "148 36 148 100 212 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zgt),
        e("path", {
          d: "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zgt)
      ])) : o(i) === "duotone" ? (s(), r("g", Cgt, [
        e("line", {
          x1: "120",
          y1: "176",
          x2: "88",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bgt),
        e("line", {
          x1: "104",
          y1: "216",
          x2: "104",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lgt),
        e("line", {
          x1: "36",
          y1: "176",
          x2: "36",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bgt),
        e("line", {
          x1: "64",
          y1: "176",
          x2: "64",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pgt),
        e("line", {
          x1: "36",
          y1: "196",
          x2: "64",
          y2: "196",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wgt),
        e("polyline", {
          points: "212 176 212 216 236 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ngt),
        e("polyline", {
          points: "144 216 144 176 164 204 184 176 184 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fgt),
        Tgt,
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dgt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rgt)
      ])) : o(i) === "fill" ? (s(), r("g", Ugt, Ggt)) : o(i) === "light" ? (s(), r("g", Egt, [
        e("line", {
          x1: "120",
          y1: "176",
          x2: "88",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ogt),
        e("line", {
          x1: "104",
          y1: "216",
          x2: "104",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Igt),
        e("line", {
          x1: "36",
          y1: "176",
          x2: "36",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kgt),
        e("line", {
          x1: "64",
          y1: "176",
          x2: "64",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xgt),
        e("line", {
          x1: "36",
          y1: "196",
          x2: "64",
          y2: "196",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jgt),
        e("polyline", {
          points: "212 176 212 216 236 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qgt),
        e("polyline", {
          points: "144 216 144 176 164 204 184 176 184 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ygt),
        e("path", {
          d: "M48,136V40a8,8,0,0,1,8-8h96l56,56v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oxt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ext)
      ])) : o(i) === "thin" ? (s(), r("g", txt, [
        e("line", {
          x1: "120",
          y1: "176",
          x2: "88",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nxt),
        e("line", {
          x1: "104",
          y1: "216",
          x2: "104",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sxt),
        e("line", {
          x1: "36",
          y1: "176",
          x2: "36",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rxt),
        e("line", {
          x1: "64",
          y1: "176",
          x2: "64",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ixt),
        e("line", {
          x1: "36",
          y1: "196",
          x2: "64",
          y2: "196",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lxt),
        e("polyline", {
          points: "212 176 212 216 236 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dxt),
        e("polyline", {
          points: "144 216 144 176 164 204 184 176 184 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kxt),
        e("path", {
          d: "M48,136V40a8,8,0,0,1,8-8h96l56,56v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cxt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hxt)
      ])) : o(i) === "regular" ? (s(), r("g", uxt, [
        e("line", {
          x1: "120",
          y1: "176",
          x2: "88",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, axt),
        e("line", {
          x1: "104",
          y1: "216",
          x2: "104",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _xt),
        e("line", {
          x1: "36",
          y1: "176",
          x2: "36",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pxt),
        e("line", {
          x1: "64",
          y1: "176",
          x2: "64",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yxt),
        e("line", {
          x1: "36",
          y1: "196",
          x2: "64",
          y2: "196",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $xt),
        e("polyline", {
          points: "212 176 212 216 236 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wxt),
        e("polyline", {
          points: "144 216 144 176 164 204 184 176 184 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fxt),
        e("path", {
          d: "M48,136V40a8,8,0,0,1,8-8h96l56,56v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gxt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xxt)
      ])) : g("", !0)
    ], 16, xgt));
  }
}), mxt = ["width", "height", "fill", "transform"], Mxt = { key: 0 }, vxt = ["stroke"], Sxt = ["stroke"], Hxt = ["stroke"], Axt = { key: 1 }, Vxt = /* @__PURE__ */ e("path", {
  d: "M152,224l-44.7-67a3.9,3.9,0,0,0-6.6,0L79.8,188.4a4,4,0,0,1-6.7-.1l-9.7-15.1a4.1,4.1,0,0,0-6.8,0L24,224Z",
  opacity: "0.2"
}, null, -1), zxt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), Zxt = ["stroke"], Cxt = ["stroke"], bxt = ["stroke"], Lxt = { key: 2 }, Bxt = /* @__PURE__ */ e("path", { d: "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v96a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V216h-8a8,8,0,0,0,0,16h8a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3ZM160,80V51.3L188.7,80Zm-1.3,139.6a8.3,8.3,0,0,1,.4,8.2A8,8,0,0,1,152,232H24a8,8,0,0,1-7-4.2,7.9,7.9,0,0,1,.3-8.1l32.6-50.8a12,12,0,0,1,20.2,0l6.4,10L94,152.6a12,12,0,0,1,20,0Z" }, null, -1), Pxt = [
  Bxt
], Wxt = { key: 3 }, Nxt = ["stroke"], Fxt = ["stroke"], Txt = ["stroke"], Dxt = { key: 4 }, Rxt = ["stroke"], Uxt = ["stroke"], qxt = ["stroke"], Gxt = { key: 5 }, Ext = ["stroke"], Oxt = ["stroke"], Ixt = ["stroke"], Kxt = {
  name: "PhFileImage"
}, kO1 = /* @__PURE__ */ $({
  ...Kxt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Mxt, [
        e("path", {
          d: "M152,224l-44.7-67a3.9,3.9,0,0,0-6.6,0L79.8,188.4a4,4,0,0,1-6.7-.1l-9.7-15.1a4.1,4.1,0,0,0-6.8,0L24,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vxt),
        e("polyline", {
          points: "148 32 148 92 208 92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Sxt),
        e("path", {
          d: "M196,224h4a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hxt)
      ])) : o(i) === "duotone" ? (s(), r("g", Axt, [
        Vxt,
        zxt,
        e("path", {
          d: "M152,224l-44.7-67a3.9,3.9,0,0,0-6.6,0L79.8,188.4a4,4,0,0,1-6.7-.1l-9.7-15.1a4.1,4.1,0,0,0-6.8,0L24,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zxt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cxt),
        e("path", {
          d: "M192,224h8a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bxt)
      ])) : o(i) === "fill" ? (s(), r("g", Lxt, Pxt)) : o(i) === "light" ? (s(), r("g", Wxt, [
        e("path", {
          d: "M152,224l-44.7-67a3.9,3.9,0,0,0-6.6,0L79.8,188.4a4,4,0,0,1-6.7-.1l-9.7-15.1a4.1,4.1,0,0,0-6.8,0L24,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Nxt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fxt),
        e("path", {
          d: "M192,224h8a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Txt)
      ])) : o(i) === "thin" ? (s(), r("g", Dxt, [
        e("path", {
          d: "M152,224l-44.7-67a3.9,3.9,0,0,0-6.6,0L79.8,188.4a4,4,0,0,1-6.7-.1l-9.7-15.1a4.1,4.1,0,0,0-6.8,0L24,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Rxt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Uxt),
        e("path", {
          d: "M192,224h8a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qxt)
      ])) : o(i) === "regular" ? (s(), r("g", Gxt, [
        e("path", {
          d: "M152,224l-44.7-67a3.9,3.9,0,0,0-6.6,0L79.8,188.4a4,4,0,0,1-6.7-.1l-9.7-15.1a4.1,4.1,0,0,0-6.8,0L24,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ext),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Oxt),
        e("path", {
          d: "M192,224h8a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ixt)
      ])) : g("", !0)
    ], 16, mxt));
  }
}), Xxt = ["width", "height", "fill", "transform"], Jxt = { key: 0 }, Qxt = ["stroke"], Yxt = ["stroke"], ojt = ["stroke"], ejt = ["stroke"], tjt = ["stroke"], njt = { key: 1 }, sjt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), rjt = ["stroke"], ijt = ["stroke"], ljt = ["stroke"], djt = ["stroke"], kjt = ["stroke"], cjt = { key: 2 }, hjt = /* @__PURE__ */ e("path", { d: "M120,160H104a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0v-8h8a24,24,0,0,0,0-48Zm0,32h-8V176h8a8,8,0,0,1,0,16ZM80,168v32a24,24,0,0,1-48,0,8,8,0,0,1,16,0,8,8,0,0,0,16,0V168a8,8,0,0,1,16,0Zm128,26v11.8a7.5,7.5,0,0,1-1.3,4.3A29.4,29.4,0,0,1,182,224c-16.5,0-30-14.4-30-32s13.5-32,30-32a28.4,28.4,0,0,1,16.6,5.4,8,8,0,0,1-9.2,13A12.6,12.6,0,0,0,182,176c-7.7,0-14,7.2-14,16s6.3,16,14,16a13.3,13.3,0,0,0,10-4.8V202h-4a8,8,0,0,1,0-16h12A8,8,0,0,1,208,194Zm5.7-111.7-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V88A8.1,8.1,0,0,0,213.7,82.3ZM152,88V44l44,44Z" }, null, -1), ujt = [
  hjt
], ajt = { key: 3 }, _jt = ["stroke"], pjt = ["stroke"], yjt = ["stroke"], $jt = ["stroke"], wjt = ["stroke"], fjt = { key: 4 }, gjt = ["stroke"], xjt = ["stroke"], jjt = ["stroke"], mjt = ["stroke"], Mjt = ["stroke"], vjt = { key: 5 }, Sjt = ["stroke"], Hjt = ["stroke"], Ajt = ["stroke"], Vjt = ["stroke"], zjt = ["stroke"], Zjt = {
  name: "PhFileJpg"
}, cO1 = /* @__PURE__ */ $({
  ...Zjt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Jxt, [
        e("polyline", {
          points: "148 36 148 100 212 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qxt),
        e("path", {
          d: "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Yxt),
        e("path", {
          d: "M100,204h16a20,20,0,0,0,0-40H100v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ojt),
        e("path", {
          d: "M60,164v36a20,20,0,0,1-40,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ejt),
        e("path", {
          d: "M212,198.9h8v8c-4.6,7.9-12.7,13.1-22,13.1-14.4,0-26-12.5-26-28s11.6-28,26-28a24.2,24.2,0,0,1,14,4.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tjt)
      ])) : o(i) === "duotone" ? (s(), r("g", njt, [
        sjt,
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rjt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ijt),
        e("path", {
          d: "M104,200h16a16,16,0,0,0,0-32H104v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ljt),
        e("path", {
          d: "M72,168v32a16,16,0,0,1-32,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, djt),
        e("path", {
          d: "M188,194h12v11.8A21.5,21.5,0,0,1,182,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a20.3,20.3,0,0,1,12,3.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kjt)
      ])) : o(i) === "fill" ? (s(), r("g", cjt, ujt)) : o(i) === "light" ? (s(), r("g", ajt, [
        e("path", {
          d: "M104,200h16a16,16,0,0,0,0-32H104v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _jt),
        e("path", {
          d: "M72,168v32a16,16,0,0,1-32,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pjt),
        e("path", {
          d: "M188,194h12v11.8A21.5,21.5,0,0,1,182,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a20.3,20.3,0,0,1,12,3.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yjt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $jt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wjt)
      ])) : o(i) === "thin" ? (s(), r("g", fjt, [
        e("path", {
          d: "M104,200h16a16,16,0,0,0,0-32H104v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gjt),
        e("path", {
          d: "M72,168v32a16,16,0,0,1-32,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xjt),
        e("path", {
          d: "M188,194h12v11.8A21.5,21.5,0,0,1,182,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a20.3,20.3,0,0,1,12,3.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jjt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mjt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Mjt)
      ])) : o(i) === "regular" ? (s(), r("g", vjt, [
        e("path", {
          d: "M104,200h16a16,16,0,0,0,0-32H104v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sjt),
        e("path", {
          d: "M72,168v32a16,16,0,0,1-32,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hjt),
        e("path", {
          d: "M188,194h12v11.8A21.5,21.5,0,0,1,182,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a20.3,20.3,0,0,1,12,3.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ajt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vjt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zjt)
      ])) : g("", !0)
    ], 16, Xxt));
  }
}), Cjt = ["width", "height", "fill", "transform"], bjt = { key: 0 }, Ljt = ["stroke"], Bjt = ["stroke"], Pjt = ["stroke"], Wjt = ["stroke"], Njt = { key: 1 }, Fjt = ["stroke"], Tjt = ["stroke"], Djt = ["stroke"], Rjt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), Ujt = ["stroke"], qjt = { key: 2 }, Gjt = /* @__PURE__ */ e("path", { d: "M144,204c0,13.1-9.3,21-25,21a33.4,33.4,0,0,1-20.1-6.8h0A7.6,7.6,0,0,1,96,212a8,8,0,0,1,8-8,8.3,8.3,0,0,1,5.1,1.8H109a18.4,18.4,0,0,0,10,3.2c9,0,9-3,9-5s0-.9-1.2-1.6-5.8-2.2-9.2-3.1C109,197,96,193.5,96,180s9.5-21,23-21a33.4,33.4,0,0,1,20.1,6.8h0A7.6,7.6,0,0,1,142,172a8,8,0,0,1-8,8,8.3,8.3,0,0,1-5.1-1.8h.1a18.4,18.4,0,0,0-10-3.2c-4.6,0-7,1.7-7,5v.2c1.1,1.3,6.6,2.8,9.7,3.6C130,186,144,189.7,144,204ZM72,160a8,8,0,0,0-8,8v32a8,8,0,0,1-16,0,8,8,0,0,0-16,0,24,24,0,0,0,48,0V168A8,8,0,0,0,72,160ZM216,88V216a16,16,0,0,1-16,16H176a8,8,0,0,1-8-8V144a8,8,0,0,0-8-8H48a8,8,0,0,1-8-8V40A16,16,0,0,1,56,24h96a8.1,8.1,0,0,1,5.7,2.3l56,56A8.1,8.1,0,0,1,216,88Zm-20,0L152,44V88Z" }, null, -1), Ejt = [
  Gjt
], Ojt = { key: 3 }, Ijt = ["stroke"], Kjt = ["stroke"], Xjt = ["stroke"], Jjt = ["stroke"], Qjt = { key: 4 }, Yjt = ["stroke"], omt = ["stroke"], emt = ["stroke"], tmt = ["stroke"], nmt = { key: 5 }, smt = ["stroke"], rmt = ["stroke"], imt = ["stroke"], lmt = ["stroke"], dmt = {
  name: "PhFileJs"
}, hO1 = /* @__PURE__ */ $({
  ...dmt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", bjt, [
        e("polyline", {
          points: "148 36 148 100 212 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ljt),
        e("path", {
          d: "M180,220h24a8,8,0,0,0,8-8V92L156,36H52a8,8,0,0,0-8,8v80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bjt),
        e("path", {
          d: "M108,214.4a23.7,23.7,0,0,0,15,5.6c9,0,17-3.4,17-14.6,0-17.9-32-10-32-26.8,0-9,6-14.6,15-14.6a23.7,23.7,0,0,1,15,5.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pjt),
        e("path", {
          d: "M68,164v36a20,20,0,0,1-40,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wjt)
      ])) : o(i) === "duotone" ? (s(), r("g", Njt, [
        e("path", {
          d: "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fjt),
        e("path", {
          d: "M72,168v32a16,16,0,0,1-32,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tjt),
        e("path", {
          d: "M104,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Djt),
        Rjt,
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ujt)
      ])) : o(i) === "fill" ? (s(), r("g", qjt, Ejt)) : o(i) === "light" ? (s(), r("g", Ojt, [
        e("path", {
          d: "M72,168v32a16,16,0,0,1-32,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ijt),
        e("path", {
          d: "M104,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kjt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xjt),
        e("path", {
          d: "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8V144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jjt)
      ])) : o(i) === "thin" ? (s(), r("g", Qjt, [
        e("path", {
          d: "M72,168v32a16,16,0,0,1-32,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Yjt),
        e("path", {
          d: "M104,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, omt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, emt),
        e("path", {
          d: "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8V144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tmt)
      ])) : o(i) === "regular" ? (s(), r("g", nmt, [
        e("path", {
          d: "M72,168v32a16,16,0,0,1-32,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, smt),
        e("path", {
          d: "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rmt),
        e("path", {
          d: "M104,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, imt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lmt)
      ])) : g("", !0)
    ], 16, Cjt));
  }
}), kmt = ["width", "height", "fill", "transform"], cmt = { key: 0 }, hmt = ["stroke"], umt = ["stroke"], amt = ["stroke"], _mt = ["stroke"], pmt = ["stroke"], ymt = ["stroke"], $mt = { key: 1 }, wmt = ["stroke"], fmt = ["stroke"], gmt = ["stroke"], xmt = ["stroke"], jmt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), mmt = ["stroke"], Mmt = ["stroke"], vmt = { key: 2 }, Smt = /* @__PURE__ */ e("path", { d: "M80,168v32a24,24,0,0,1-48,0,8,8,0,0,1,16,0,8,8,0,0,0,16,0V168a8,8,0,0,1,16,0Zm41.7,15.8c-3.1-.8-8.6-2.3-9.7-3.6V180c0-3.3,2.4-5,7-5a18.4,18.4,0,0,1,10,3.2h-.1A8.3,8.3,0,0,0,134,180a8,8,0,0,0,8-8,7.6,7.6,0,0,0-2.9-6.1h0A33.4,33.4,0,0,0,119,159c-13.5,0-23,8.6-23,21s13,17,21.6,19.3c3.4.9,7,1.8,9.2,3.1s1.2,1,1.2,1.6,0,5-9,5a18.4,18.4,0,0,1-10-3.2h.1A8.3,8.3,0,0,0,104,204a8,8,0,0,0-8,8,7.6,7.6,0,0,0,2.9,6.1h0A33.4,33.4,0,0,0,119,225c15.7,0,25-7.9,25-21S130,186,121.7,183.8Zm83.1-22.2a8,8,0,0,0-11.2,1.6L182,178.7l-11.6-15.5a8,8,0,0,0-12.8,9.6L172,192l-14.4,19.2a8,8,0,0,0,1.6,11.2A7.7,7.7,0,0,0,164,224a8,8,0,0,0,6.4-3.2L182,205.3l11.6,15.5A8,8,0,0,0,200,224a7.7,7.7,0,0,0,4.8-1.6,8,8,0,0,0,1.6-11.2L192,192l14.4-19.2A8,8,0,0,0,204.8,161.6ZM216,88v40a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40A16,16,0,0,1,56,24h96a8.1,8.1,0,0,1,5.7,2.3l56,56A8.1,8.1,0,0,1,216,88Zm-20,0L152,44V88Z" }, null, -1), Hmt = [
  Smt
], Amt = { key: 3 }, Vmt = ["stroke"], zmt = ["stroke"], Zmt = ["stroke"], Cmt = ["stroke"], bmt = ["stroke"], Lmt = ["stroke"], Bmt = { key: 4 }, Pmt = ["stroke"], Wmt = ["stroke"], Nmt = ["stroke"], Fmt = ["stroke"], Tmt = ["stroke"], Dmt = ["stroke"], Rmt = { key: 5 }, Umt = ["stroke"], qmt = ["stroke"], Gmt = ["stroke"], Emt = ["stroke"], Omt = ["stroke"], Imt = ["stroke"], Kmt = {
  name: "PhFileJsx"
}, uO1 = /* @__PURE__ */ $({
  ...Kmt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", cmt, [
        e("line", {
          x1: "172",
          y1: "164",
          x2: "212",
          y2: "220",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hmt),
        e("line", {
          x1: "212",
          y1: "164",
          x2: "172",
          y2: "220",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, umt),
        e("polyline", {
          points: "148 36 148 100 212 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, amt),
        e("path", {
          d: "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _mt),
        e("path", {
          d: "M100,214.4a23.7,23.7,0,0,0,15,5.6c9,0,17-3.4,17-14.6,0-17.9-32-10-32-26.8,0-9,6-14.6,15-14.6a23.7,23.7,0,0,1,15,5.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pmt),
        e("path", {
          d: "M60,164v36a20,20,0,0,1-40,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ymt)
      ])) : o(i) === "duotone" ? (s(), r("g", $mt, [
        e("line", {
          x1: "164",
          y1: "168",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wmt),
        e("line", {
          x1: "200",
          y1: "168",
          x2: "164",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fmt),
        e("path", {
          d: "M72,168v32a16,16,0,0,1-32,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gmt),
        e("path", {
          d: "M104,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xmt),
        jmt,
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mmt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mmt)
      ])) : o(i) === "fill" ? (s(), r("g", vmt, Hmt)) : o(i) === "light" ? (s(), r("g", Amt, [
        e("line", {
          x1: "164",
          y1: "168",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vmt),
        e("line", {
          x1: "200",
          y1: "168",
          x2: "164",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zmt),
        e("path", {
          d: "M72,168v32a16,16,0,0,1-32,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zmt),
        e("path", {
          d: "M104,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cmt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bmt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lmt)
      ])) : o(i) === "thin" ? (s(), r("g", Bmt, [
        e("line", {
          x1: "164",
          y1: "168",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pmt),
        e("line", {
          x1: "200",
          y1: "168",
          x2: "164",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wmt),
        e("path", {
          d: "M72,168v32a16,16,0,0,1-32,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nmt),
        e("path", {
          d: "M104,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fmt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Tmt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Dmt)
      ])) : o(i) === "regular" ? (s(), r("g", Rmt, [
        e("line", {
          x1: "164",
          y1: "168",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Umt),
        e("line", {
          x1: "200",
          y1: "168",
          x2: "164",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qmt),
        e("path", {
          d: "M72,168v32a16,16,0,0,1-32,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gmt),
        e("path", {
          d: "M104,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Emt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Omt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Imt)
      ])) : g("", !0)
    ], 16, kmt));
  }
}), Xmt = ["width", "height", "fill", "transform"], Jmt = { key: 0 }, Qmt = ["stroke"], Ymt = ["stroke"], oMt = ["stroke"], eMt = ["stroke"], tMt = { key: 1 }, nMt = /* @__PURE__ */ e("rect", {
  x: "56",
  y: "180",
  width: "72",
  height: "44",
  opacity: "0.2"
}, null, -1), sMt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), rMt = ["stroke"], iMt = ["stroke"], lMt = ["stroke"], dMt = ["stroke"], kMt = { key: 2 }, cMt = /* @__PURE__ */ e("path", { d: "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V216H168a8,8,0,0,0,0,16h32a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3ZM160,51.3,188.7,80H160ZM128,172h-8v-4a28,28,0,0,0-56,0v4H56a8,8,0,0,0-8,8v44a8,8,0,0,0,8,8h72a8,8,0,0,0,8-8V180A8,8,0,0,0,128,172Zm-24,0H80v-4a12,12,0,0,1,24,0Z" }, null, -1), hMt = [
  cMt
], uMt = { key: 3 }, aMt = ["stroke"], _Mt = ["stroke"], pMt = ["stroke"], yMt = ["stroke"], $Mt = { key: 4 }, wMt = ["stroke"], fMt = ["stroke"], gMt = ["stroke"], xMt = ["stroke"], jMt = { key: 5 }, mMt = ["stroke"], MMt = ["stroke"], vMt = ["stroke"], SMt = ["stroke"], HMt = {
  name: "PhFileLock"
}, aO1 = /* @__PURE__ */ $({
  ...HMt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Jmt, [
        e("polyline", {
          points: "148 32 148 92 208 92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qmt),
        e("path", {
          d: "M172,224h28a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ymt),
        e("rect", {
          x: "56",
          y: "184",
          width: "72",
          height: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oMt),
        e("path", {
          d: "M72,184V168a20,20,0,0,1,40,0v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eMt)
      ])) : o(i) === "duotone" ? (s(), r("g", tMt, [
        nMt,
        sMt,
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rMt),
        e("path", {
          d: "M168,224h32a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iMt),
        e("rect", {
          x: "56",
          y: "180",
          width: "72",
          height: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lMt),
        e("path", {
          d: "M72,180V168a20,20,0,0,1,40,0v12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dMt)
      ])) : o(i) === "fill" ? (s(), r("g", kMt, hMt)) : o(i) === "light" ? (s(), r("g", uMt, [
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aMt),
        e("path", {
          d: "M168,224h32a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _Mt),
        e("rect", {
          x: "56",
          y: "180",
          width: "72",
          height: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pMt),
        e("path", {
          d: "M72,180V168a20,20,0,0,1,40,0v12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yMt)
      ])) : o(i) === "thin" ? (s(), r("g", $Mt, [
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wMt),
        e("path", {
          d: "M168,224h32a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fMt),
        e("rect", {
          x: "56",
          y: "180",
          width: "72",
          height: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gMt),
        e("path", {
          d: "M72,180V168a20,20,0,0,1,40,0v12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xMt)
      ])) : o(i) === "regular" ? (s(), r("g", jMt, [
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mMt),
        e("path", {
          d: "M168,224h32a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MMt),
        e("rect", {
          x: "56",
          y: "180",
          width: "72",
          height: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vMt),
        e("path", {
          d: "M72,180V168a20,20,0,0,1,40,0v12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SMt)
      ])) : g("", !0)
    ], 16, Xmt));
  }
}), AMt = ["width", "height", "fill", "transform"], VMt = { key: 0 }, zMt = ["stroke"], ZMt = ["stroke"], CMt = ["stroke"], bMt = { key: 1 }, LMt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), BMt = ["stroke"], PMt = ["stroke"], WMt = ["stroke"], NMt = { key: 2 }, FMt = /* @__PURE__ */ e("path", { d: "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3ZM152,160H104a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm0-72V43.3L196.7,88Z" }, null, -1), TMt = [
  FMt
], DMt = { key: 3 }, RMt = ["stroke"], UMt = ["stroke"], qMt = ["stroke"], GMt = { key: 4 }, EMt = ["stroke"], OMt = ["stroke"], IMt = ["stroke"], KMt = { key: 5 }, XMt = ["stroke"], JMt = ["stroke"], QMt = ["stroke"], YMt = {
  name: "PhFileMinus"
}, _O1 = /* @__PURE__ */ $({
  ...YMt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", VMt, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zMt),
        e("polyline", {
          points: "148 32 148 92 208 92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZMt),
        e("line", {
          x1: "104",
          y1: "152",
          x2: "152",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CMt)
      ])) : o(i) === "duotone" ? (s(), r("g", bMt, [
        LMt,
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BMt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PMt),
        e("line", {
          x1: "104",
          y1: "152",
          x2: "152",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WMt)
      ])) : o(i) === "fill" ? (s(), r("g", NMt, TMt)) : o(i) === "light" ? (s(), r("g", DMt, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RMt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UMt),
        e("line", {
          x1: "104",
          y1: "152",
          x2: "152",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qMt)
      ])) : o(i) === "thin" ? (s(), r("g", GMt, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, EMt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OMt),
        e("line", {
          x1: "104",
          y1: "152",
          x2: "152",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, IMt)
      ])) : o(i) === "regular" ? (s(), r("g", KMt, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XMt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JMt),
        e("line", {
          x1: "104",
          y1: "152",
          x2: "152",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QMt)
      ])) : g("", !0)
    ], 16, AMt));
  }
}), ovt = ["width", "height", "fill", "transform"], evt = { key: 0 }, tvt = ["stroke"], nvt = ["stroke"], svt = ["stroke"], rvt = ["stroke"], ivt = ["stroke"], lvt = ["stroke"], dvt = { key: 1 }, kvt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), cvt = ["stroke"], hvt = ["stroke"], uvt = ["stroke"], avt = ["stroke"], _vt = ["stroke"], pvt = ["stroke"], yvt = { key: 2 }, $vt = /* @__PURE__ */ e("path", { d: "M64,160H48a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0v-8h8a24,24,0,0,0,0-48Zm0,32H56V176h8a8,8,0,0,1,0,16Zm132-16v12h16a8,8,0,0,1,0,16H196v12a8,8,0,0,1-16,0V168a8,8,0,0,1,8-8h28a8,8,0,0,1,0,16Zm-68-16H114a8,8,0,0,0-8,8v48a8,8,0,0,0,8,8h14a32,32,0,0,0,0-64Zm0,48h-6V176h6a16,16,0,0,1,0,32ZM48,136H208a8,8,0,0,0,8-8V88a8.1,8.1,0,0,0-2.3-5.7l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88A8,8,0,0,0,48,136ZM152,44l44,44H152Z" }, null, -1), wvt = [
  $vt
], fvt = { key: 3 }, gvt = ["stroke"], xvt = ["stroke"], jvt = ["stroke"], mvt = ["stroke"], Mvt = ["stroke"], vvt = ["stroke"], Svt = { key: 4 }, Hvt = ["stroke"], Avt = ["stroke"], Vvt = ["stroke"], zvt = ["stroke"], Zvt = ["stroke"], Cvt = ["stroke"], bvt = { key: 5 }, Lvt = ["stroke"], Bvt = ["stroke"], Pvt = ["stroke"], Wvt = ["stroke"], Nvt = ["stroke"], Fvt = ["stroke"], Tvt = {
  name: "PhFilePdf"
}, pO1 = /* @__PURE__ */ $({
  ...Tvt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", evt, [
        e("polyline", {
          points: "228 164 196 164 196 220",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tvt),
        e("line", {
          x1: "224",
          y1: "196",
          x2: "196",
          y2: "196",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nvt),
        e("polyline", {
          points: "148 36 148 100 212 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, svt),
        e("path", {
          d: "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rvt),
        e("path", {
          d: "M112,220V164h16a28,28,0,0,1,0,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ivt),
        e("path", {
          d: "M36,204H52a20,20,0,0,0,0-40H36v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lvt)
      ])) : o(i) === "duotone" ? (s(), r("g", dvt, [
        kvt,
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cvt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hvt),
        e("path", {
          d: "M48,200H64a16,16,0,0,0,0-32H48v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uvt),
        e("polyline", {
          points: "216 168 188 168 188 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, avt),
        e("line", {
          x1: "212",
          y1: "196",
          x2: "188",
          y2: "196",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _vt),
        e("path", {
          d: "M128,216a24,24,0,0,0,0-48H114v48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pvt)
      ])) : o(i) === "fill" ? (s(), r("g", yvt, wvt)) : o(i) === "light" ? (s(), r("g", fvt, [
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gvt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xvt),
        e("path", {
          d: "M48,200H64a16,16,0,0,0,0-32H48v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jvt),
        e("polyline", {
          points: "216 168 188 168 188 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mvt),
        e("line", {
          x1: "212",
          y1: "196",
          x2: "188",
          y2: "196",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mvt),
        e("path", {
          d: "M128,216a24,24,0,0,0,0-48H114v48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vvt)
      ])) : o(i) === "thin" ? (s(), r("g", Svt, [
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hvt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Avt),
        e("path", {
          d: "M48,200H64a16,16,0,0,0,0-32H48v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vvt),
        e("polyline", {
          points: "216 168 188 168 188 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zvt),
        e("line", {
          x1: "212",
          y1: "196",
          x2: "188",
          y2: "196",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zvt),
        e("path", {
          d: "M128,216a24,24,0,0,0,0-48H114v48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cvt)
      ])) : o(i) === "regular" ? (s(), r("g", bvt, [
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lvt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bvt),
        e("path", {
          d: "M48,200H64a16,16,0,0,0,0-32H48v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pvt),
        e("polyline", {
          points: "216 168 188 168 188 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wvt),
        e("line", {
          x1: "212",
          y1: "196",
          x2: "188",
          y2: "196",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nvt),
        e("path", {
          d: "M128,216a24,24,0,0,0,0-48H114v48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fvt)
      ])) : g("", !0)
    ], 16, ovt));
  }
}), Dvt = ["width", "height", "fill", "transform"], Rvt = { key: 0 }, Uvt = ["stroke"], qvt = ["stroke"], Gvt = ["stroke"], Evt = ["stroke"], Ovt = { key: 1 }, Ivt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), Kvt = ["stroke"], Xvt = ["stroke"], Jvt = ["stroke"], Qvt = ["stroke"], Yvt = { key: 2 }, oSt = /* @__PURE__ */ e("path", { d: "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3ZM152,160H136v16a8,8,0,0,1-16,0V160H104a8,8,0,0,1,0-16h16V128a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Zm0-72V43.3L196.7,88Z" }, null, -1), eSt = [
  oSt
], tSt = { key: 3 }, nSt = ["stroke"], sSt = ["stroke"], rSt = ["stroke"], iSt = ["stroke"], lSt = { key: 4 }, dSt = ["stroke"], kSt = ["stroke"], cSt = ["stroke"], hSt = ["stroke"], uSt = { key: 5 }, aSt = ["stroke"], _St = ["stroke"], pSt = ["stroke"], ySt = ["stroke"], $St = {
  name: "PhFilePlus"
}, yO1 = /* @__PURE__ */ $({
  ...$St,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Rvt, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Uvt),
        e("polyline", {
          points: "148 32 148 92 208 92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qvt),
        e("line", {
          x1: "104",
          y1: "152",
          x2: "152",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gvt),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Evt)
      ])) : o(i) === "duotone" ? (s(), r("g", Ovt, [
        Ivt,
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kvt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xvt),
        e("line", {
          x1: "104",
          y1: "152",
          x2: "152",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jvt),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qvt)
      ])) : o(i) === "fill" ? (s(), r("g", Yvt, eSt)) : o(i) === "light" ? (s(), r("g", tSt, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nSt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sSt),
        e("line", {
          x1: "104",
          y1: "152",
          x2: "152",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rSt),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iSt)
      ])) : o(i) === "thin" ? (s(), r("g", lSt, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dSt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kSt),
        e("line", {
          x1: "104",
          y1: "152",
          x2: "152",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cSt),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hSt)
      ])) : o(i) === "regular" ? (s(), r("g", uSt, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aSt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _St),
        e("line", {
          x1: "104",
          y1: "152",
          x2: "152",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pSt),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ySt)
      ])) : g("", !0)
    ], 16, Dvt));
  }
}), wSt = ["width", "height", "fill", "transform"], fSt = { key: 0 }, gSt = ["stroke"], xSt = ["stroke"], jSt = ["stroke"], mSt = ["stroke"], MSt = ["stroke"], vSt = { key: 1 }, SSt = ["stroke"], HSt = ["stroke"], ASt = ["stroke"], VSt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), zSt = ["stroke"], ZSt = ["stroke"], CSt = { key: 2 }, bSt = /* @__PURE__ */ e("path", { d: "M60,160H44a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0v-8h8a24,24,0,0,0,0-48Zm0,32H52V176h8a8,8,0,0,1,0,16Zm92-24v48a8,8,0,0,1-5.5,7.6,7.3,7.3,0,0,1-2.5.4,7.8,7.8,0,0,1-6.4-3.2L116,192v24a8,8,0,0,1-16,0V168a8,8,0,0,1,5.5-7.6,7.9,7.9,0,0,1,8.9,2.8L136,192V168a8,8,0,0,1,16,0Zm72,37.8a7.5,7.5,0,0,1-1.3,4.3A29.4,29.4,0,0,1,198,224c-16.5,0-30-14.4-30-32s13.5-32,30-32a28.4,28.4,0,0,1,16.6,5.4,8,8,0,0,1-9.2,13A12.6,12.6,0,0,0,198,176c-7.7,0-14,7.2-14,16s6.3,16,14,16a13.3,13.3,0,0,0,10-4.8V202h-4a8,8,0,0,1,0-16h12a8,8,0,0,1,8,8ZM48,136H208a8,8,0,0,0,8-8V88a8.1,8.1,0,0,0-2.3-5.7l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88A8,8,0,0,0,48,136ZM152,44l44,44H152Z" }, null, -1), LSt = [
  bSt
], BSt = { key: 3 }, PSt = ["stroke"], WSt = ["stroke"], NSt = ["stroke"], FSt = ["stroke"], TSt = ["stroke"], DSt = { key: 4 }, RSt = ["stroke"], USt = ["stroke"], qSt = ["stroke"], GSt = ["stroke"], ESt = ["stroke"], OSt = { key: 5 }, ISt = ["stroke"], KSt = ["stroke"], XSt = ["stroke"], JSt = ["stroke"], QSt = ["stroke"], YSt = {
  name: "PhFilePng"
}, $O1 = /* @__PURE__ */ $({
  ...YSt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", fSt, [
        e("polyline", {
          points: "108 220 108 164 148 220 148 164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gSt),
        e("polyline", {
          points: "148 36 148 100 212 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xSt),
        e("path", {
          d: "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jSt),
        e("path", {
          d: "M36,204H52a20,20,0,0,0,0-40H36v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mSt),
        e("path", {
          d: "M220,198.9h8v8c-4.6,7.9-12.7,13.1-22,13.1-14.4,0-26-12.5-26-28s11.6-28,26-28a24.2,24.2,0,0,1,14,4.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MSt)
      ])) : o(i) === "duotone" ? (s(), r("g", vSt, [
        e("path", {
          d: "M44,200H60a16,16,0,0,0,0-32H44v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SSt),
        e("polyline", {
          points: "108 216 108 168 144 216 144 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HSt),
        e("path", {
          d: "M204,194h12v11.8A21.5,21.5,0,0,1,198,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a20.3,20.3,0,0,1,12,3.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ASt),
        VSt,
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zSt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZSt)
      ])) : o(i) === "fill" ? (s(), r("g", CSt, LSt)) : o(i) === "light" ? (s(), r("g", BSt, [
        e("path", {
          d: "M44,200H60a16,16,0,0,0,0-32H44v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PSt),
        e("polyline", {
          points: "108 216 108 168 144 216 144 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WSt),
        e("path", {
          d: "M204,194h12v11.8A21.5,21.5,0,0,1,198,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a20.3,20.3,0,0,1,12,3.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, NSt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FSt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TSt)
      ])) : o(i) === "thin" ? (s(), r("g", DSt, [
        e("path", {
          d: "M44,200H60a16,16,0,0,0,0-32H44v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RSt),
        e("polyline", {
          points: "108 216 108 168 144 216 144 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, USt),
        e("path", {
          d: "M204,194h12v11.8A21.5,21.5,0,0,1,198,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a20.3,20.3,0,0,1,12,3.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qSt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GSt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ESt)
      ])) : o(i) === "regular" ? (s(), r("g", OSt, [
        e("path", {
          d: "M44,200H60a16,16,0,0,0,0-32H44v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ISt),
        e("polyline", {
          points: "108 216 108 168 144 216 144 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KSt),
        e("path", {
          d: "M204,194h12v11.8A21.5,21.5,0,0,1,198,216c-12.2,0-22-10.7-22-24s9.8-24,22-24a20.3,20.3,0,0,1,12,3.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XSt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JSt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QSt)
      ])) : g("", !0)
    ], 16, wSt));
  }
}), oHt = ["width", "height", "fill", "transform"], eHt = { key: 0 }, tHt = ["stroke"], nHt = ["stroke"], sHt = ["stroke"], rHt = ["stroke"], iHt = ["stroke"], lHt = ["stroke"], dHt = { key: 1 }, kHt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), cHt = ["stroke"], hHt = ["stroke"], uHt = ["stroke"], aHt = ["stroke"], _Ht = ["stroke"], pHt = ["stroke"], yHt = { key: 2 }, $Ht = /* @__PURE__ */ e("path", { d: "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V88A8.1,8.1,0,0,0,213.7,82.3ZM152,88V44l44,44ZM64,160H48a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0v-8h8a24,24,0,0,0,0-48Zm0,32H56V176h8a8,8,0,0,1,0,16Zm64-32H112a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0v-8h8a24,24,0,0,0,0-48Zm0,32h-8V176h8a8,8,0,0,1,0,16Zm88-24a8,8,0,0,1-8,8H198v40a8,8,0,0,1-16,0V176H172a8,8,0,0,1,0-16h36A8,8,0,0,1,216,168Z" }, null, -1), wHt = [
  $Ht
], fHt = { key: 3 }, gHt = ["stroke"], xHt = ["stroke"], jHt = ["stroke"], mHt = ["stroke"], MHt = ["stroke"], vHt = ["stroke"], SHt = { key: 4 }, HHt = ["stroke"], AHt = ["stroke"], VHt = ["stroke"], zHt = ["stroke"], ZHt = ["stroke"], CHt = ["stroke"], bHt = { key: 5 }, LHt = ["stroke"], BHt = ["stroke"], PHt = ["stroke"], WHt = ["stroke"], NHt = ["stroke"], FHt = ["stroke"], THt = {
  name: "PhFilePpt"
}, wO1 = /* @__PURE__ */ $({
  ...THt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", eHt, [
        e("polyline", {
          points: "148 36 148 100 212 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tHt),
        e("path", {
          d: "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nHt),
        e("path", {
          d: "M44,204H60a20,20,0,0,0,0-40H44v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sHt),
        e("path", {
          d: "M116,204h16a20,20,0,0,0,0-40H116v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rHt),
        e("line", {
          x1: "200",
          y1: "220",
          x2: "200",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iHt),
        e("line", {
          x1: "220",
          y1: "164",
          x2: "180",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lHt)
      ])) : o(i) === "duotone" ? (s(), r("g", dHt, [
        kHt,
        e("path", {
          d: "M48,200H64a16,16,0,0,0,0-32H48v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cHt),
        e("path", {
          d: "M112,200h16a16,16,0,0,0,0-32H112v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hHt),
        e("line", {
          x1: "208",
          y1: "168",
          x2: "172",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uHt),
        e("line", {
          x1: "190",
          y1: "216",
          x2: "190",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aHt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Ht),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pHt)
      ])) : o(i) === "fill" ? (s(), r("g", yHt, wHt)) : o(i) === "light" ? (s(), r("g", fHt, [
        e("path", {
          d: "M48,200H64a16,16,0,0,0,0-32H48v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gHt),
        e("path", {
          d: "M112,200h16a16,16,0,0,0,0-32H112v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xHt),
        e("line", {
          x1: "208",
          y1: "168",
          x2: "172",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jHt),
        e("line", {
          x1: "190",
          y1: "216",
          x2: "190",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mHt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, MHt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vHt)
      ])) : o(i) === "thin" ? (s(), r("g", SHt, [
        e("path", {
          d: "M48,200H64a16,16,0,0,0,0-32H48v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HHt),
        e("path", {
          d: "M112,200h16a16,16,0,0,0,0-32H112v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, AHt),
        e("line", {
          x1: "208",
          y1: "168",
          x2: "172",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VHt),
        e("line", {
          x1: "190",
          y1: "216",
          x2: "190",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zHt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZHt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CHt)
      ])) : o(i) === "regular" ? (s(), r("g", bHt, [
        e("path", {
          d: "M48,200H64a16,16,0,0,0,0-32H48v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LHt),
        e("path", {
          d: "M112,200h16a16,16,0,0,0,0-32H112v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BHt),
        e("line", {
          x1: "208",
          y1: "168",
          x2: "172",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PHt),
        e("line", {
          x1: "190",
          y1: "216",
          x2: "190",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WHt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NHt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FHt)
      ])) : g("", !0)
    ], 16, oHt));
  }
}), DHt = ["width", "height", "fill", "transform"], RHt = { key: 0 }, UHt = ["stroke"], qHt = ["stroke"], GHt = ["stroke"], EHt = ["stroke"], OHt = ["stroke"], IHt = { key: 1 }, KHt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), XHt = ["stroke"], JHt = ["stroke"], QHt = ["stroke"], YHt = ["stroke"], oAt = ["stroke"], eAt = { key: 2 }, tAt = /* @__PURE__ */ e("path", { d: "M80.1,201.8A24,24,0,0,0,64,160H48a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0v-8h9l8.3,12.4A7.9,7.9,0,0,0,80,224a7.8,7.8,0,0,0,4.4-1.3,8,8,0,0,0,2.2-11.1ZM64,192H56V176h8a8,8,0,0,1,0,16Zm88,12c0,13.1-9.3,21-25,21a33.4,33.4,0,0,1-20.1-6.8h0A7.6,7.6,0,0,1,104,212a8,8,0,0,1,8-8,8.3,8.3,0,0,1,5.1,1.8H117a18.4,18.4,0,0,0,10,3.2c9,0,9-3,9-5s0-.9-1.2-1.6-5.8-2.2-9.2-3.1C117,197,104,193.5,104,180s9.5-21,23-21a33.4,33.4,0,0,1,20.1,6.8h0A7.6,7.6,0,0,1,150,172a8,8,0,0,1-8,8,8.3,8.3,0,0,1-5.1-1.8h.1a18.4,18.4,0,0,0-10-3.2c-4.6,0-7,1.7-7,5v.2c1.1,1.3,6.6,2.8,9.7,3.6C138,186,152,189.7,152,204ZM213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,8,8H168a8,8,0,0,1,8,8v80a8,8,0,0,0,8,8h16a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3ZM152,88V44l44,44Z" }, null, -1), nAt = [
  tAt
], sAt = { key: 3 }, rAt = ["stroke"], iAt = ["stroke"], lAt = ["stroke"], dAt = ["stroke"], kAt = ["stroke"], cAt = { key: 4 }, hAt = ["stroke"], uAt = ["stroke"], aAt = ["stroke"], _At = ["stroke"], pAt = ["stroke"], yAt = { key: 5 }, $At = ["stroke"], wAt = ["stroke"], fAt = ["stroke"], gAt = ["stroke"], xAt = ["stroke"], jAt = {
  name: "PhFileRs"
}, fO1 = /* @__PURE__ */ $({
  ...jAt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", RHt, [
        e("polyline", {
          points: "148 36 148 100 212 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, UHt),
        e("path", {
          d: "M180,220h24a8,8,0,0,0,8-8V92L156,36H52a8,8,0,0,0-8,8v80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qHt),
        e("path", {
          d: "M108,214.4a23.7,23.7,0,0,0,15,5.6c9,0,17-3.4,17-14.6,0-17.9-32-10-32-26.8,0-9,6-14.6,15-14.6a23.7,23.7,0,0,1,15,5.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GHt),
        e("path", {
          d: "M36,204H52a20,20,0,0,0,0-40H36v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, EHt),
        e("line", {
          x1: "60.5",
          y1: "202.1",
          x2: "72",
          y2: "220",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OHt)
      ])) : o(i) === "duotone" ? (s(), r("g", IHt, [
        KHt,
        e("path", {
          d: "M48,200H64a16,16,0,0,0,0-32H48v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XHt),
        e("line", {
          x1: "68.8",
          y1: "199.3",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JHt),
        e("path", {
          d: "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QHt),
        e("path", {
          d: "M184,224h16a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YHt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oAt)
      ])) : o(i) === "fill" ? (s(), r("g", eAt, nAt)) : o(i) === "light" ? (s(), r("g", sAt, [
        e("path", {
          d: "M48,200H64a16,16,0,0,0,0-32H48v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rAt),
        e("line", {
          x1: "68.8",
          y1: "199.3",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iAt),
        e("path", {
          d: "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lAt),
        e("path", {
          d: "M184,224h16a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dAt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kAt)
      ])) : o(i) === "thin" ? (s(), r("g", cAt, [
        e("path", {
          d: "M48,200H64a16,16,0,0,0,0-32H48v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hAt),
        e("line", {
          x1: "68.8",
          y1: "199.3",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uAt),
        e("path", {
          d: "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aAt),
        e("path", {
          d: "M184,224h16a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _At),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pAt)
      ])) : o(i) === "regular" ? (s(), r("g", yAt, [
        e("path", {
          d: "M48,200H64a16,16,0,0,0,0-32H48v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $At),
        e("line", {
          x1: "68.8",
          y1: "199.3",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wAt),
        e("path", {
          d: "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fAt),
        e("path", {
          d: "M184,224h16a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gAt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xAt)
      ])) : g("", !0)
    ], 16, DHt));
  }
}), mAt = ["width", "height", "fill", "transform"], MAt = { key: 0 }, vAt = ["stroke"], SAt = ["stroke"], HAt = ["stroke"], AAt = ["stroke"], VAt = { key: 1 }, zAt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), ZAt = ["stroke"], CAt = ["stroke"], bAt = ["stroke"], LAt = ["stroke"], BAt = { key: 2 }, PAt = /* @__PURE__ */ e("path", { d: "M213.6,82.3l-55.9-56-.3-.2-.3-.3-.3-.2-.3-.2c-.1-.1-.2-.1-.2-.2l-.5-.3h-.2l-.5-.3H155l-.7-.3H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A7.8,7.8,0,0,0,213.6,82.3ZM165.4,189.5a8,8,0,0,1-5.6,2.3,8.3,8.3,0,0,1-5.7-2.3l-10.9-11A36.8,36.8,0,0,1,124,184a36,36,0,1,1,36-36,35.8,35.8,0,0,1-5.5,19.2l10.9,10.9A8,8,0,0,1,165.4,189.5ZM152,88V43.3L196.7,88Z" }, null, -1), WAt = /* @__PURE__ */ e("path", { d: "M124,128a19.9,19.9,0,0,0-14.1,5.9,19.8,19.8,0,0,0,0,28.2,19.9,19.9,0,0,0,28.2,0,19.8,19.8,0,0,0,0-28.2A19.9,19.9,0,0,0,124,128Z" }, null, -1), NAt = [
  PAt,
  WAt
], FAt = { key: 3 }, TAt = ["stroke"], DAt = ["stroke"], RAt = ["stroke"], UAt = ["stroke"], qAt = { key: 4 }, GAt = ["stroke"], EAt = ["stroke"], OAt = ["stroke"], IAt = ["stroke"], KAt = { key: 5 }, XAt = ["stroke"], JAt = ["stroke"], QAt = ["stroke"], YAt = ["stroke"], oVt = {
  name: "PhFileSearch"
}, gO1 = /* @__PURE__ */ $({
  ...oVt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", MAt, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vAt),
        e("polyline", {
          points: "148 32 148 92 208 92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SAt),
        e("circle", {
          cx: "124",
          cy: "148",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HAt),
        e("line", {
          x1: "141",
          y1: "165",
          x2: "159.8",
          y2: "183.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, AAt)
      ])) : o(i) === "duotone" ? (s(), r("g", VAt, [
        zAt,
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZAt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CAt),
        e("line", {
          x1: "143.8",
          y1: "167.8",
          x2: "159.8",
          y2: "183.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bAt),
        e("circle", {
          cx: "124",
          cy: "148",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LAt)
      ])) : o(i) === "fill" ? (s(), r("g", BAt, NAt)) : o(i) === "light" ? (s(), r("g", FAt, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TAt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DAt),
        e("line", {
          x1: "143.8",
          y1: "167.8",
          x2: "159.8",
          y2: "183.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RAt),
        e("circle", {
          cx: "124",
          cy: "148",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UAt)
      ])) : o(i) === "thin" ? (s(), r("g", qAt, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GAt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, EAt),
        e("line", {
          x1: "143.8",
          y1: "167.8",
          x2: "159.8",
          y2: "183.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OAt),
        e("circle", {
          cx: "124",
          cy: "148",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, IAt)
      ])) : o(i) === "regular" ? (s(), r("g", KAt, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XAt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JAt),
        e("line", {
          x1: "143.8",
          y1: "167.8",
          x2: "159.8",
          y2: "183.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QAt),
        e("circle", {
          cx: "124",
          cy: "148",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YAt)
      ])) : g("", !0)
    ], 16, mAt));
  }
}), eVt = ["width", "height", "fill", "transform"], tVt = { key: 0 }, nVt = ["stroke"], sVt = ["stroke"], rVt = ["stroke"], iVt = ["stroke"], lVt = { key: 1 }, dVt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), kVt = ["stroke"], cVt = ["stroke"], hVt = ["stroke"], uVt = ["stroke"], aVt = { key: 2 }, _Vt = /* @__PURE__ */ e("path", { d: "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3ZM160,176H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm-8-56V44l44,44Z" }, null, -1), pVt = [
  _Vt
], yVt = { key: 3 }, $Vt = ["stroke"], wVt = ["stroke"], fVt = ["stroke"], gVt = ["stroke"], xVt = { key: 4 }, jVt = ["stroke"], mVt = ["stroke"], MVt = ["stroke"], vVt = ["stroke"], SVt = { key: 5 }, HVt = ["stroke"], AVt = ["stroke"], VVt = ["stroke"], zVt = ["stroke"], ZVt = {
  name: "PhFileText"
}, xO1 = /* @__PURE__ */ $({
  ...ZVt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", tVt, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nVt),
        e("polyline", {
          points: "148 32 148 92 208 92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sVt),
        e("line", {
          x1: "96",
          y1: "132",
          x2: "160",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rVt),
        e("line", {
          x1: "96",
          y1: "172",
          x2: "160",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iVt)
      ])) : o(i) === "duotone" ? (s(), r("g", lVt, [
        dVt,
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kVt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cVt),
        e("line", {
          x1: "96",
          y1: "136",
          x2: "160",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hVt),
        e("line", {
          x1: "96",
          y1: "168",
          x2: "160",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uVt)
      ])) : o(i) === "fill" ? (s(), r("g", aVt, pVt)) : o(i) === "light" ? (s(), r("g", yVt, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $Vt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wVt),
        e("line", {
          x1: "96",
          y1: "136",
          x2: "160",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fVt),
        e("line", {
          x1: "96",
          y1: "168",
          x2: "160",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gVt)
      ])) : o(i) === "thin" ? (s(), r("g", xVt, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jVt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mVt),
        e("line", {
          x1: "96",
          y1: "136",
          x2: "160",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MVt),
        e("line", {
          x1: "96",
          y1: "168",
          x2: "160",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vVt)
      ])) : o(i) === "regular" ? (s(), r("g", SVt, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HVt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AVt),
        e("line", {
          x1: "96",
          y1: "136",
          x2: "160",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VVt),
        e("line", {
          x1: "96",
          y1: "168",
          x2: "160",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zVt)
      ])) : g("", !0)
    ], 16, eVt));
  }
}), CVt = ["width", "height", "fill", "transform"], bVt = { key: 0 }, LVt = ["stroke"], BVt = ["stroke"], PVt = ["stroke"], WVt = ["stroke"], NVt = ["stroke"], FVt = { key: 1 }, TVt = ["stroke"], DVt = ["stroke"], RVt = ["stroke"], UVt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), qVt = ["stroke"], GVt = ["stroke"], EVt = { key: 2 }, OVt = /* @__PURE__ */ e("path", { d: "M92,168a8,8,0,0,1-8,8H74v40a8,8,0,0,1-16,0V176H48a8,8,0,0,1,0-16H84A8,8,0,0,1,92,168Zm37.7,15.8c-3.1-.8-8.6-2.3-9.7-3.6V180c0-3.3,2.4-5,7-5a18.4,18.4,0,0,1,10,3.2h-.1A8.3,8.3,0,0,0,142,180a8,8,0,0,0,8-8,7.6,7.6,0,0,0-2.9-6.1h0A33.4,33.4,0,0,0,127,159c-13.5,0-23,8.6-23,21s13,17,21.6,19.3c3.4.9,7,1.8,9.2,3.1s1.2,1,1.2,1.6,0,5-9,5a18.4,18.4,0,0,1-10-3.2h.1A8.3,8.3,0,0,0,112,204a8,8,0,0,0-8,8,7.6,7.6,0,0,0,2.9,6.1h0A33.4,33.4,0,0,0,127,225c15.7,0,25-7.9,25-21S138,186,129.7,183.8ZM216,88V216a16,16,0,0,1-16,16H184a8,8,0,0,1-8-8V144a8,8,0,0,0-8-8H48a8,8,0,0,1-8-8V40A16,16,0,0,1,56,24h96a8.1,8.1,0,0,1,5.7,2.3l56,56A8.1,8.1,0,0,1,216,88Zm-20,0L152,44V88Z" }, null, -1), IVt = [
  OVt
], KVt = { key: 3 }, XVt = ["stroke"], JVt = ["stroke"], QVt = ["stroke"], YVt = ["stroke"], ozt = ["stroke"], ezt = { key: 4 }, tzt = ["stroke"], nzt = ["stroke"], szt = ["stroke"], rzt = ["stroke"], izt = ["stroke"], lzt = { key: 5 }, dzt = ["stroke"], kzt = ["stroke"], czt = ["stroke"], hzt = ["stroke"], uzt = ["stroke"], azt = {
  name: "PhFileTs"
}, jO1 = /* @__PURE__ */ $({
  ...azt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", bVt, [
        e("polyline", {
          points: "148 36 148 100 212 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LVt),
        e("path", {
          d: "M180,220h24a8,8,0,0,0,8-8V92L156,36H52a8,8,0,0,0-8,8v80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BVt),
        e("line", {
          x1: "56",
          y1: "220",
          x2: "56",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PVt),
        e("line", {
          x1: "76",
          y1: "164",
          x2: "36",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WVt),
        e("path", {
          d: "M108,214.4a23.7,23.7,0,0,0,15,5.6c9,0,17-3.4,17-14.6,0-17.9-32-10-32-26.8,0-9,6-14.6,15-14.6a23.7,23.7,0,0,1,15,5.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NVt)
      ])) : o(i) === "duotone" ? (s(), r("g", FVt, [
        e("line", {
          x1: "84",
          y1: "168",
          x2: "48",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TVt),
        e("line", {
          x1: "66",
          y1: "216",
          x2: "66",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DVt),
        e("path", {
          d: "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RVt),
        UVt,
        e("path", {
          d: "M184,224h16a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qVt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GVt)
      ])) : o(i) === "fill" ? (s(), r("g", EVt, IVt)) : o(i) === "light" ? (s(), r("g", KVt, [
        e("line", {
          x1: "84",
          y1: "168",
          x2: "48",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XVt),
        e("line", {
          x1: "66",
          y1: "216",
          x2: "66",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JVt),
        e("path", {
          d: "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QVt),
        e("path", {
          d: "M184,224h16a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YVt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ozt)
      ])) : o(i) === "thin" ? (s(), r("g", ezt, [
        e("line", {
          x1: "84",
          y1: "168",
          x2: "48",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tzt),
        e("line", {
          x1: "66",
          y1: "216",
          x2: "66",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nzt),
        e("path", {
          d: "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, szt),
        e("path", {
          d: "M184,224h16a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rzt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, izt)
      ])) : o(i) === "regular" ? (s(), r("g", lzt, [
        e("line", {
          x1: "84",
          y1: "168",
          x2: "48",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dzt),
        e("line", {
          x1: "66",
          y1: "216",
          x2: "66",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kzt),
        e("path", {
          d: "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, czt),
        e("path", {
          d: "M184,224h16a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hzt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uzt)
      ])) : g("", !0)
    ], 16, CVt));
  }
}), _zt = ["width", "height", "fill", "transform"], pzt = { key: 0 }, yzt = ["stroke"], $zt = ["stroke"], wzt = ["stroke"], fzt = ["stroke"], gzt = ["stroke"], xzt = ["stroke"], jzt = ["stroke"], mzt = { key: 1 }, Mzt = ["stroke"], vzt = ["stroke"], Szt = ["stroke"], Hzt = ["stroke"], Azt = ["stroke"], Vzt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), zzt = ["stroke"], Zzt = ["stroke"], Czt = { key: 2 }, bzt = /* @__PURE__ */ e("path", { d: "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V88A8.1,8.1,0,0,0,213.7,82.3ZM152,88V44l44,44ZM92,168a8,8,0,0,1-8,8H74v40a8,8,0,0,1-16,0V176H48a8,8,0,0,1,0-16H84A8,8,0,0,1,92,168Zm122.4,4.8L200,192l14.4,19.2a8,8,0,0,1-1.6,11.2A7.7,7.7,0,0,1,208,224a8,8,0,0,1-6.4-3.2L190,205.3l-11.6,15.5A8,8,0,0,1,172,224a7.7,7.7,0,0,1-4.8-1.6,8.1,8.1,0,0,1-1.6-11.2L180,192l-14.4-19.2a8.1,8.1,0,0,1,1.6-11.2,8,8,0,0,1,11.2,1.6L190,178.7l11.6-15.5a8,8,0,1,1,12.8,9.6ZM152,204c0,13.1-9.3,21-25,21a33.4,33.4,0,0,1-20.1-6.8h0A7.6,7.6,0,0,1,104,212a8,8,0,0,1,8-8,8.3,8.3,0,0,1,5.1,1.8H117a18.4,18.4,0,0,0,10,3.2c9,0,9-3,9-5s0-.9-1.2-1.6-5.8-2.2-9.2-3.1C117,197,104,193.5,104,180s9.5-21,23-21a33.4,33.4,0,0,1,20.1,6.8h0A7.6,7.6,0,0,1,150,172a8,8,0,0,1-8,8,8.3,8.3,0,0,1-5.1-1.8h.1a18.4,18.4,0,0,0-10-3.2c-4.6,0-7,1.7-7,5v.2c1.1,1.3,6.6,2.8,9.7,3.6C138,186,152,189.7,152,204Z" }, null, -1), Lzt = [
  bzt
], Bzt = { key: 3 }, Pzt = ["stroke"], Wzt = ["stroke"], Nzt = ["stroke"], Fzt = ["stroke"], Tzt = ["stroke"], Dzt = ["stroke"], Rzt = ["stroke"], Uzt = { key: 4 }, qzt = ["stroke"], Gzt = ["stroke"], Ezt = ["stroke"], Ozt = ["stroke"], Izt = ["stroke"], Kzt = ["stroke"], Xzt = ["stroke"], Jzt = { key: 5 }, Qzt = ["stroke"], Yzt = ["stroke"], oZt = ["stroke"], eZt = ["stroke"], tZt = ["stroke"], nZt = ["stroke"], sZt = ["stroke"], rZt = {
  name: "PhFileTsx"
}, mO1 = /* @__PURE__ */ $({
  ...rZt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", pzt, [
        e("line", {
          x1: "172",
          y1: "164",
          x2: "212",
          y2: "220",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yzt),
        e("line", {
          x1: "212",
          y1: "164",
          x2: "172",
          y2: "220",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $zt),
        e("polyline", {
          points: "148 36 148 100 212 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wzt),
        e("path", {
          d: "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fzt),
        e("line", {
          x1: "56",
          y1: "220",
          x2: "56",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gzt),
        e("line", {
          x1: "76",
          y1: "164",
          x2: "36",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xzt),
        e("path", {
          d: "M108,214.4a23.7,23.7,0,0,0,15,5.6c9,0,17-3.4,17-14.6,0-17.9-32-10-32-26.8,0-9,6-14.6,15-14.6a23.7,23.7,0,0,1,15,5.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jzt)
      ])) : o(i) === "duotone" ? (s(), r("g", mzt, [
        e("line", {
          x1: "172",
          y1: "168",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mzt),
        e("line", {
          x1: "208",
          y1: "168",
          x2: "172",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vzt),
        e("line", {
          x1: "84",
          y1: "168",
          x2: "48",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Szt),
        e("line", {
          x1: "66",
          y1: "216",
          x2: "66",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hzt),
        e("path", {
          d: "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Azt),
        Vzt,
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zzt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zzt)
      ])) : o(i) === "fill" ? (s(), r("g", Czt, Lzt)) : o(i) === "light" ? (s(), r("g", Bzt, [
        e("line", {
          x1: "172",
          y1: "168",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pzt),
        e("line", {
          x1: "208",
          y1: "168",
          x2: "172",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wzt),
        e("line", {
          x1: "84",
          y1: "168",
          x2: "48",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Nzt),
        e("line", {
          x1: "66",
          y1: "216",
          x2: "66",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fzt),
        e("path", {
          d: "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Tzt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dzt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rzt)
      ])) : o(i) === "thin" ? (s(), r("g", Uzt, [
        e("line", {
          x1: "172",
          y1: "168",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qzt),
        e("line", {
          x1: "208",
          y1: "168",
          x2: "172",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gzt),
        e("line", {
          x1: "84",
          y1: "168",
          x2: "48",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ezt),
        e("line", {
          x1: "66",
          y1: "216",
          x2: "66",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ozt),
        e("path", {
          d: "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Izt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kzt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xzt)
      ])) : o(i) === "regular" ? (s(), r("g", Jzt, [
        e("line", {
          x1: "172",
          y1: "168",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qzt),
        e("line", {
          x1: "208",
          y1: "168",
          x2: "172",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yzt),
        e("line", {
          x1: "84",
          y1: "168",
          x2: "48",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oZt),
        e("line", {
          x1: "66",
          y1: "216",
          x2: "66",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eZt),
        e("path", {
          d: "M112,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tZt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nZt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sZt)
      ])) : g("", !0)
    ], 16, _zt));
  }
}), iZt = ["width", "height", "fill", "transform"], lZt = { key: 0 }, dZt = ["stroke"], kZt = ["stroke"], cZt = ["stroke"], hZt = ["stroke"], uZt = { key: 1 }, aZt = /* @__PURE__ */ e("path", {
  d: "M144,164v49.2L112,196v12a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V168a8,8,0,0,1,8-8h56a8,8,0,0,1,8,8v12Z",
  opacity: "0.2"
}, null, -1), _Zt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), pZt = ["stroke"], yZt = ["stroke"], $Zt = ["stroke"], wZt = ["stroke"], fZt = { key: 2 }, gZt = /* @__PURE__ */ e("path", { d: "M152,164v49.2a8.1,8.1,0,0,1-4.5,7.2,8.5,8.5,0,0,1-3.5.8,7.9,7.9,0,0,1-4.9-1.7l-19.1-15V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V168a16,16,0,0,1,16-16h56a16,16,0,0,1,16,16v4l19.2-14.4A8,8,0,0,1,152,164Zm64-76V216a16,16,0,0,1-16,16H168a8,8,0,0,1,0-16h32V96H152a8,8,0,0,1-8-8V40H56v80a8,8,0,0,1-16,0V40A16,16,0,0,1,56,24h96a8.1,8.1,0,0,1,5.7,2.3l56,56A8.1,8.1,0,0,1,216,88Zm-27.3-8L160,51.3V80Z" }, null, -1), xZt = [
  gZt
], jZt = { key: 3 }, mZt = ["stroke"], MZt = ["stroke"], vZt = ["stroke"], SZt = ["stroke"], HZt = { key: 4 }, AZt = ["stroke"], VZt = ["stroke"], zZt = ["stroke"], ZZt = ["stroke"], CZt = { key: 5 }, bZt = ["stroke"], LZt = ["stroke"], BZt = ["stroke"], PZt = ["stroke"], WZt = {
  name: "PhFileVideo"
}, MO1 = /* @__PURE__ */ $({
  ...WZt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", lZt, [
        e("polyline", {
          points: "148 32 148 92 208 92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dZt),
        e("path", {
          d: "M188,224h12a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kZt),
        e("rect", {
          x: "40",
          y: "160",
          width: "72",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cZt),
        e("polyline", {
          points: "112 176 148 164 148 213.2 112 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hZt)
      ])) : o(i) === "duotone" ? (s(), r("g", uZt, [
        aZt,
        _Zt,
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pZt),
        e("path", {
          d: "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yZt),
        e("rect", {
          x: "40",
          y: "160",
          width: "72",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Zt),
        e("polyline", {
          points: "112 180 144 164 144 213.2 112 196",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wZt)
      ])) : o(i) === "fill" ? (s(), r("g", fZt, xZt)) : o(i) === "light" ? (s(), r("g", jZt, [
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mZt),
        e("path", {
          d: "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, MZt),
        e("rect", {
          x: "40",
          y: "160",
          width: "72",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vZt),
        e("polyline", {
          points: "112 180 144 164 144 213.2 112 196",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, SZt)
      ])) : o(i) === "thin" ? (s(), r("g", HZt, [
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, AZt),
        e("path", {
          d: "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VZt),
        e("rect", {
          x: "40",
          y: "160",
          width: "72",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zZt),
        e("polyline", {
          points: "112 180 144 164 144 213.2 112 196",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZZt)
      ])) : o(i) === "regular" ? (s(), r("g", CZt, [
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bZt),
        e("path", {
          d: "M176,224h24a8,8,0,0,0,8-8V88L152,32H56a8,8,0,0,0-8,8v88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LZt),
        e("rect", {
          x: "40",
          y: "160",
          width: "72",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BZt),
        e("polyline", {
          points: "112 180 144 164 144 213.2 112 196",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PZt)
      ])) : g("", !0)
    ], 16, iZt));
  }
}), NZt = ["width", "height", "fill", "transform"], FZt = { key: 0 }, TZt = ["stroke"], DZt = ["stroke"], RZt = ["stroke"], UZt = ["stroke"], qZt = ["stroke"], GZt = ["stroke"], EZt = { key: 1 }, OZt = ["stroke"], IZt = ["stroke"], KZt = ["stroke"], XZt = ["stroke"], JZt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), QZt = ["stroke"], YZt = ["stroke"], oCt = { key: 2 }, eCt = /* @__PURE__ */ e("path", { d: "M188,176v8h16a8,8,0,0,1,0,16H188v8h20a8,8,0,0,1,0,16H180a8,8,0,0,1-8-8V168a8,8,0,0,1,8-8h28a8,8,0,0,1,0,16ZM87.1,160.6a8,8,0,0,0-10.5,4.3L64,195.2,51.4,164.9a8,8,0,0,0-14.8,6.2l20,48a8,8,0,0,0,14.8,0l20-48A8,8,0,0,0,87.1,160.6ZM148,160a8,8,0,0,0-8,8v30a10,10,0,0,1-20,0V168a8,8,0,0,0-16,0v30a26,26,0,0,0,52,0V168A8,8,0,0,0,148,160Zm68-72v40a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40A16,16,0,0,1,56,24h96a8.1,8.1,0,0,1,5.7,2.3l56,56A8.1,8.1,0,0,1,216,88Zm-20,0L152,44V88Z" }, null, -1), tCt = [
  eCt
], nCt = { key: 3 }, sCt = ["stroke"], rCt = ["stroke"], iCt = ["stroke"], lCt = ["stroke"], dCt = ["stroke"], kCt = ["stroke"], cCt = { key: 4 }, hCt = ["stroke"], uCt = ["stroke"], aCt = ["stroke"], _Ct = ["stroke"], pCt = ["stroke"], yCt = ["stroke"], $Ct = { key: 5 }, wCt = ["stroke"], fCt = ["stroke"], gCt = ["stroke"], xCt = ["stroke"], jCt = ["stroke"], mCt = ["stroke"], MCt = {
  name: "PhFileVue"
}, vO1 = /* @__PURE__ */ $({
  ...MCt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", FZt, [
        e("polyline", {
          points: "220 220 188 220 188 164 220 164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TZt),
        e("line", {
          x1: "216",
          y1: "192",
          x2: "188",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DZt),
        e("polyline", {
          points: "32 164 54 220 76 164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RZt),
        e("polyline", {
          points: "148 36 148 100 212 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, UZt),
        e("path", {
          d: "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qZt),
        e("path", {
          d: "M108,164v36a20,20,0,0,0,40,0V164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GZt)
      ])) : o(i) === "duotone" ? (s(), r("g", EZt, [
        e("line", {
          x1: "204",
          y1: "192",
          x2: "180",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OZt),
        e("polyline", {
          points: "208 216 180 216 180 168 208 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IZt),
        e("polyline", {
          points: "44 168 64 216 84 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KZt),
        e("path", {
          d: "M112,168v30a18,18,0,0,0,36,0V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XZt),
        JZt,
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QZt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YZt)
      ])) : o(i) === "fill" ? (s(), r("g", oCt, tCt)) : o(i) === "light" ? (s(), r("g", nCt, [
        e("line", {
          x1: "204",
          y1: "192",
          x2: "180",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sCt),
        e("polyline", {
          points: "208 216 180 216 180 168 208 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rCt),
        e("polyline", {
          points: "44 168 64 216 84 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iCt),
        e("path", {
          d: "M112,168v30a18,18,0,0,0,36,0V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lCt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dCt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kCt)
      ])) : o(i) === "thin" ? (s(), r("g", cCt, [
        e("line", {
          x1: "204",
          y1: "192",
          x2: "180",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hCt),
        e("polyline", {
          points: "208 216 180 216 180 168 208 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uCt),
        e("polyline", {
          points: "44 168 64 216 84 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aCt),
        e("path", {
          d: "M112,168v30a18,18,0,0,0,36,0V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _Ct),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pCt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yCt)
      ])) : o(i) === "regular" ? (s(), r("g", $Ct, [
        e("line", {
          x1: "204",
          y1: "192",
          x2: "180",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wCt),
        e("polyline", {
          points: "208 216 180 216 180 168 208 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fCt),
        e("polyline", {
          points: "44 168 64 216 84 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gCt),
        e("path", {
          d: "M112,168v30a18,18,0,0,0,36,0V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xCt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jCt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mCt)
      ])) : g("", !0)
    ], 16, NZt));
  }
}), vCt = ["width", "height", "fill", "transform"], SCt = { key: 0 }, HCt = ["stroke"], ACt = ["stroke"], VCt = ["stroke"], zCt = ["stroke"], ZCt = { key: 1 }, CCt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), bCt = ["stroke"], LCt = ["stroke"], BCt = ["stroke"], PCt = ["stroke"], WCt = { key: 2 }, NCt = /* @__PURE__ */ e("path", { d: "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3Zm-56,88a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0L128,163.3l-18.3,18.4a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L116.7,152,98.3,133.7a8.1,8.1,0,0,1,11.4-11.4L128,140.7l18.3-18.4a8.1,8.1,0,0,1,11.4,11.4L139.3,152ZM152,88V44l44,44Z" }, null, -1), FCt = [
  NCt
], TCt = { key: 3 }, DCt = ["stroke"], RCt = ["stroke"], UCt = ["stroke"], qCt = ["stroke"], GCt = { key: 4 }, ECt = ["stroke"], OCt = ["stroke"], ICt = ["stroke"], KCt = ["stroke"], XCt = { key: 5 }, JCt = ["stroke"], QCt = ["stroke"], YCt = ["stroke"], obt = ["stroke"], ebt = {
  name: "PhFileX"
}, SO1 = /* @__PURE__ */ $({
  ...ebt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", SCt, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HCt),
        e("polyline", {
          points: "148 32 148 92 208 92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ACt),
        e("line", {
          x1: "104",
          y1: "128",
          x2: "152",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VCt),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "104",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zCt)
      ])) : o(i) === "duotone" ? (s(), r("g", ZCt, [
        CCt,
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bCt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LCt),
        e("line", {
          x1: "104",
          y1: "128",
          x2: "152",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BCt),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "104",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PCt)
      ])) : o(i) === "fill" ? (s(), r("g", WCt, FCt)) : o(i) === "light" ? (s(), r("g", TCt, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DCt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RCt),
        e("line", {
          x1: "104",
          y1: "128",
          x2: "152",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UCt),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "104",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qCt)
      ])) : o(i) === "thin" ? (s(), r("g", GCt, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ECt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OCt),
        e("line", {
          x1: "104",
          y1: "128",
          x2: "152",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ICt),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "104",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KCt)
      ])) : o(i) === "regular" ? (s(), r("g", XCt, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JCt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QCt),
        e("line", {
          x1: "104",
          y1: "128",
          x2: "152",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YCt),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "104",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, obt)
      ])) : g("", !0)
    ], 16, vCt));
  }
}), tbt = ["width", "height", "fill", "transform"], nbt = { key: 0 }, sbt = ["stroke"], rbt = ["stroke"], ibt = ["stroke"], lbt = ["stroke"], dbt = ["stroke"], kbt = ["stroke"], cbt = { key: 1 }, hbt = ["stroke"], ubt = ["stroke"], abt = ["stroke"], _bt = ["stroke"], pbt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), ybt = ["stroke"], $bt = ["stroke"], wbt = { key: 2 }, fbt = /* @__PURE__ */ e("path", { d: "M94.4,172.8,80,192l14.4,19.2a8,8,0,0,1-1.6,11.2A7.7,7.7,0,0,1,88,224a8,8,0,0,1-6.4-3.2L70,205.3,58.4,220.8A8,8,0,0,1,52,224a7.7,7.7,0,0,1-4.8-1.6,8,8,0,0,1-1.6-11.2L60,192,45.6,172.8a8,8,0,1,1,12.8-9.6L70,178.7l11.6-15.5a8,8,0,0,1,12.8,9.6ZM148,208H128V168a8,8,0,0,0-16,0v48a8,8,0,0,0,8,8h28a8,8,0,0,0,0-16Zm45.7-24.2c-3.1-.8-8.6-2.3-9.7-3.6V180c0-3.3,2.4-5,7-5a18.4,18.4,0,0,1,10,3.2h-.1A8.3,8.3,0,0,0,206,180a8,8,0,0,0,8-8,7.6,7.6,0,0,0-2.9-6.1h0A33.4,33.4,0,0,0,191,159c-13.5,0-23,8.6-23,21s13,17,21.6,19.3c3.4.9,7,1.8,9.2,3.1s1.2,1,1.2,1.6,0,5-9,5a18.4,18.4,0,0,1-10-3.2h.1A8.3,8.3,0,0,0,176,204a8,8,0,0,0-8,8,7.6,7.6,0,0,0,2.9,6.1h0A33.4,33.4,0,0,0,191,225c15.7,0,25-7.9,25-21S202,186,193.7,183.8ZM216,88v40a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40A16,16,0,0,1,56,24h96a8.1,8.1,0,0,1,5.7,2.3l56,56A8.1,8.1,0,0,1,216,88Zm-20,0L152,44V88Z" }, null, -1), gbt = [
  fbt
], xbt = { key: 3 }, jbt = ["stroke"], mbt = ["stroke"], Mbt = ["stroke"], vbt = ["stroke"], Sbt = ["stroke"], Hbt = ["stroke"], Abt = { key: 4 }, Vbt = ["stroke"], zbt = ["stroke"], Zbt = ["stroke"], Cbt = ["stroke"], bbt = ["stroke"], Lbt = ["stroke"], Bbt = { key: 5 }, Pbt = ["stroke"], Wbt = ["stroke"], Nbt = ["stroke"], Fbt = ["stroke"], Tbt = ["stroke"], Dbt = ["stroke"], Rbt = {
  name: "PhFileXls"
}, HO1 = /* @__PURE__ */ $({
  ...Rbt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", nbt, [
        e("line", {
          x1: "44",
          y1: "164",
          x2: "84",
          y2: "220",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sbt),
        e("line", {
          x1: "84",
          y1: "164",
          x2: "44",
          y2: "220",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rbt),
        e("polyline", {
          points: "120 164 120 220 148 220",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ibt),
        e("polyline", {
          points: "148 36 148 100 212 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lbt),
        e("path", {
          d: "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dbt),
        e("path", {
          d: "M180,214.4a23.7,23.7,0,0,0,15,5.6c9,0,17-3.4,17-14.6,0-17.9-32-10-32-26.8,0-9,6-14.6,15-14.6a23.7,23.7,0,0,1,15,5.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kbt)
      ])) : o(i) === "duotone" ? (s(), r("g", cbt, [
        e("polyline", {
          points: "120 168 120 216 148 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hbt),
        e("line", {
          x1: "52",
          y1: "168",
          x2: "88",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ubt),
        e("line", {
          x1: "88",
          y1: "168",
          x2: "52",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, abt),
        e("path", {
          d: "M176,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _bt),
        pbt,
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ybt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $bt)
      ])) : o(i) === "fill" ? (s(), r("g", wbt, gbt)) : o(i) === "light" ? (s(), r("g", xbt, [
        e("polyline", {
          points: "120 168 120 216 148 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jbt),
        e("line", {
          x1: "52",
          y1: "168",
          x2: "88",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mbt),
        e("line", {
          x1: "88",
          y1: "168",
          x2: "52",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mbt),
        e("path", {
          d: "M176,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vbt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Sbt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hbt)
      ])) : o(i) === "thin" ? (s(), r("g", Abt, [
        e("polyline", {
          points: "120 168 120 216 148 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vbt),
        e("line", {
          x1: "52",
          y1: "168",
          x2: "88",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zbt),
        e("line", {
          x1: "88",
          y1: "168",
          x2: "52",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zbt),
        e("path", {
          d: "M176,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cbt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bbt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lbt)
      ])) : o(i) === "regular" ? (s(), r("g", Bbt, [
        e("polyline", {
          points: "120 168 120 216 148 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pbt),
        e("line", {
          x1: "52",
          y1: "168",
          x2: "88",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wbt),
        e("line", {
          x1: "88",
          y1: "168",
          x2: "52",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nbt),
        e("path", {
          d: "M176,212a25.2,25.2,0,0,0,15,5c9,0,17-3,17-13,0-16-32-9-32-24,0-8,6-13,15-13a25.2,25.2,0,0,1,15,5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fbt),
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tbt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dbt)
      ])) : g("", !0)
    ], 16, tbt));
  }
}), Ubt = ["width", "height", "fill", "transform"], qbt = { key: 0 }, Gbt = ["stroke"], Ebt = ["stroke"], Obt = ["stroke"], Ibt = ["stroke"], Kbt = ["stroke"], Xbt = { key: 1 }, Jbt = /* @__PURE__ */ e("polygon", {
  points: "152 32 152 88 208 88 152 32",
  opacity: "0.2"
}, null, -1), Qbt = ["stroke"], Ybt = ["stroke"], oLt = ["stroke"], eLt = ["stroke"], tLt = ["stroke"], nLt = { key: 2 }, sLt = /* @__PURE__ */ e("path", { d: "M184,160H168a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0v-8h8a24,24,0,0,0,0-48Zm0,32h-8V176h8a8,8,0,0,1,0,16ZM96,216a8,8,0,0,1-8,8H56a8,8,0,0,1-7.1-4.2,8.3,8.3,0,0,1,.4-8.2L73.1,176H56a8,8,0,0,1,0-16H88a8,8,0,0,1,7.1,4.2,8.3,8.3,0,0,1-.4,8.2L70.9,208H88A8,8,0,0,1,96,216Zm40-48v48a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Zm77.7-85.7-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V88A8.1,8.1,0,0,0,213.7,82.3ZM152,88V44l44,44Z" }, null, -1), rLt = [
  sLt
], iLt = { key: 3 }, lLt = ["stroke"], dLt = ["stroke"], kLt = ["stroke"], cLt = ["stroke"], hLt = ["stroke"], uLt = { key: 4 }, aLt = ["stroke"], _Lt = ["stroke"], pLt = ["stroke"], yLt = ["stroke"], $Lt = ["stroke"], wLt = { key: 5 }, fLt = ["stroke"], gLt = ["stroke"], xLt = ["stroke"], jLt = ["stroke"], mLt = ["stroke"], MLt = {
  name: "PhFileZip"
}, AO1 = /* @__PURE__ */ $({
  ...MLt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", qbt, [
        e("polyline", {
          points: "148 36 148 100 212 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gbt),
        e("path", {
          d: "M44,124V44a8,8,0,0,1,8-8H156l56,56v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ebt),
        e("path", {
          d: "M176,204h16a20,20,0,0,0,0-40H176v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Obt),
        e("line", {
          x1: "128",
          y1: "164",
          x2: "128",
          y2: "220",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ibt),
        e("polyline", {
          points: "44 164 84 164 44 220 84 220",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kbt)
      ])) : o(i) === "duotone" ? (s(), r("g", Xbt, [
        Jbt,
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qbt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ybt),
        e("path", {
          d: "M168,200h16a16,16,0,0,0,0-32H168v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oLt),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eLt),
        e("polyline", {
          points: "56 168 88 168 56 216 88 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tLt)
      ])) : o(i) === "fill" ? (s(), r("g", nLt, rLt)) : o(i) === "light" ? (s(), r("g", iLt, [
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lLt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dLt),
        e("path", {
          d: "M168,200h16a16,16,0,0,0,0-32H168v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kLt),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cLt),
        e("polyline", {
          points: "56 168 88 168 56 216 88 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hLt)
      ])) : o(i) === "thin" ? (s(), r("g", uLt, [
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aLt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _Lt),
        e("path", {
          d: "M168,200h16a16,16,0,0,0,0-32H168v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pLt),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yLt),
        e("polyline", {
          points: "56 168 88 168 56 216 88 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $Lt)
      ])) : o(i) === "regular" ? (s(), r("g", wLt, [
        e("path", {
          d: "M48,128V40a8,8,0,0,1,8-8h96l56,56v40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fLt),
        e("polyline", {
          points: "152 32 152 88 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gLt),
        e("path", {
          d: "M168,200h16a16,16,0,0,0,0-32H168v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xLt),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jLt),
        e("polyline", {
          points: "56 168 88 168 56 216 88 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mLt)
      ])) : g("", !0)
    ], 16, Ubt));
  }
}), vLt = ["width", "height", "fill", "transform"], SLt = { key: 0 }, HLt = ["stroke"], ALt = ["stroke"], VLt = ["stroke"], zLt = ["stroke"], ZLt = { key: 1 }, CLt = /* @__PURE__ */ e("path", {
  d: "M176,192h24a8,8,0,0,0,8-8V72L168,32H88a8,8,0,0,0-8,8V64h56l40,40Z",
  opacity: "0.2"
}, null, -1), bLt = ["stroke"], LLt = ["stroke"], BLt = ["stroke"], PLt = ["stroke"], WLt = { key: 2 }, NLt = /* @__PURE__ */ e("path", { d: "M213.7,66.3l-40-40A8.1,8.1,0,0,0,168,24H88A16,16,0,0,0,72,40V56H56A16,16,0,0,0,40,72V216a16,16,0,0,0,16,16H168a16,16,0,0,0,16-16V200h16a16,16,0,0,0,16-16V72A8.1,8.1,0,0,0,213.7,66.3ZM136,192H88a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm0-32H88a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Zm64,24H184V104a8.1,8.1,0,0,0-2.3-5.7l-40-40A8.1,8.1,0,0,0,136,56H88V40h76.7L200,75.3Z" }, null, -1), FLt = [
  NLt
], TLt = { key: 3 }, DLt = ["stroke"], RLt = ["stroke"], ULt = ["stroke"], qLt = ["stroke"], GLt = { key: 4 }, ELt = ["stroke"], OLt = ["stroke"], ILt = ["stroke"], KLt = ["stroke"], XLt = { key: 5 }, JLt = ["stroke"], QLt = ["stroke"], YLt = ["stroke"], oBt = ["stroke"], eBt = {
  name: "PhFiles"
}, VO1 = /* @__PURE__ */ $({
  ...eBt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", SLt, [
        e("path", {
          d: "M164,224H56a8,8,0,0,1-8-8V76a8,8,0,0,1,8-8h76l40,40V216A8,8,0,0,1,164,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HLt),
        e("path", {
          d: "M84,68V36a8,8,0,0,1,8-8h80l40,40V176a8,8,0,0,1-8,8H172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ALt),
        e("line", {
          x1: "88",
          y1: "144",
          x2: "132",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VLt),
        e("line", {
          x1: "88",
          y1: "184",
          x2: "132",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zLt)
      ])) : o(i) === "duotone" ? (s(), r("g", ZLt, [
        CLt,
        e("path", {
          d: "M168,224H56a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h80l40,40V216A8,8,0,0,1,168,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bLt),
        e("path", {
          d: "M80,64V40a8,8,0,0,1,8-8h80l40,40V184a8,8,0,0,1-8,8H176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LLt),
        e("line", {
          x1: "88",
          y1: "152",
          x2: "136",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BLt),
        e("line", {
          x1: "88",
          y1: "184",
          x2: "136",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PLt)
      ])) : o(i) === "fill" ? (s(), r("g", WLt, FLt)) : o(i) === "light" ? (s(), r("g", TLt, [
        e("path", {
          d: "M168,224H56a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h80l40,40V216A8,8,0,0,1,168,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DLt),
        e("path", {
          d: "M80,64V40a8,8,0,0,1,8-8h80l40,40V184a8,8,0,0,1-8,8H176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RLt),
        e("line", {
          x1: "88",
          y1: "152",
          x2: "136",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ULt),
        e("line", {
          x1: "88",
          y1: "184",
          x2: "136",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qLt)
      ])) : o(i) === "thin" ? (s(), r("g", GLt, [
        e("path", {
          d: "M168,224H56a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h80l40,40V216A8,8,0,0,1,168,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ELt),
        e("path", {
          d: "M80,64V40a8,8,0,0,1,8-8h80l40,40V184a8,8,0,0,1-8,8H176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OLt),
        e("line", {
          x1: "88",
          y1: "152",
          x2: "136",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ILt),
        e("line", {
          x1: "88",
          y1: "184",
          x2: "136",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KLt)
      ])) : o(i) === "regular" ? (s(), r("g", XLt, [
        e("path", {
          d: "M168,224H56a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h80l40,40V216A8,8,0,0,1,168,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JLt),
        e("path", {
          d: "M80,64V40a8,8,0,0,1,8-8h80l40,40V184a8,8,0,0,1-8,8H176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QLt),
        e("line", {
          x1: "88",
          y1: "152",
          x2: "136",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YLt),
        e("line", {
          x1: "88",
          y1: "184",
          x2: "136",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oBt)
      ])) : g("", !0)
    ], 16, vLt));
  }
}), tBt = ["width", "height", "fill", "transform"], nBt = { key: 0 }, sBt = ["stroke"], rBt = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "80",
  r: "16"
}, null, -1), iBt = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "176",
  r: "16"
}, null, -1), lBt = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "128",
  r: "16"
}, null, -1), dBt = { key: 1 }, kBt = /* @__PURE__ */ e("rect", {
  x: "48",
  y: "32",
  width: "160",
  height: "192",
  rx: "8",
  opacity: "0.2"
}, null, -1), cBt = ["stroke"], hBt = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "80",
  r: "12"
}, null, -1), uBt = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "176",
  r: "12"
}, null, -1), aBt = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "128",
  r: "12"
}, null, -1), _Bt = { key: 2 }, pBt = /* @__PURE__ */ e("path", { d: "M200,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24ZM76,188a12,12,0,1,1,12-12A12,12,0,0,1,76,188Zm0-48a12,12,0,1,1,12-12A12,12,0,0,1,76,140Zm0-48A12,12,0,1,1,88,80,12,12,0,0,1,76,92Z" }, null, -1), yBt = [
  pBt
], $Bt = { key: 3 }, wBt = ["stroke"], fBt = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "80",
  r: "10"
}, null, -1), gBt = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "176",
  r: "10"
}, null, -1), xBt = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "128",
  r: "10"
}, null, -1), jBt = { key: 4 }, mBt = ["stroke"], MBt = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "80",
  r: "8"
}, null, -1), vBt = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "176",
  r: "8"
}, null, -1), SBt = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "128",
  r: "8"
}, null, -1), HBt = { key: 5 }, ABt = ["stroke"], VBt = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "76",
  r: "12"
}, null, -1), zBt = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "180",
  r: "12"
}, null, -1), ZBt = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "128",
  r: "12"
}, null, -1), CBt = {
  name: "PhFilmScript"
}, zO1 = /* @__PURE__ */ $({
  ...CBt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", nBt, [
        e("rect", {
          x: "48",
          y: "32",
          width: "160",
          height: "192",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sBt),
        rBt,
        iBt,
        lBt
      ])) : o(i) === "duotone" ? (s(), r("g", dBt, [
        kBt,
        e("rect", {
          x: "48",
          y: "32",
          width: "160",
          height: "192",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cBt),
        hBt,
        uBt,
        aBt
      ])) : o(i) === "fill" ? (s(), r("g", _Bt, yBt)) : o(i) === "light" ? (s(), r("g", $Bt, [
        e("rect", {
          x: "48",
          y: "32",
          width: "160",
          height: "192",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wBt),
        fBt,
        gBt,
        xBt
      ])) : o(i) === "thin" ? (s(), r("g", jBt, [
        e("rect", {
          x: "48",
          y: "32",
          width: "160",
          height: "192",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mBt),
        MBt,
        vBt,
        SBt
      ])) : o(i) === "regular" ? (s(), r("g", HBt, [
        e("rect", {
          x: "48",
          y: "32",
          width: "160",
          height: "192",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ABt),
        VBt,
        zBt,
        ZBt
      ])) : g("", !0)
    ], 16, tBt));
  }
}), bBt = ["width", "height", "fill", "transform"], LBt = { key: 0 }, BBt = ["stroke"], PBt = ["stroke"], WBt = ["stroke"], NBt = ["stroke"], FBt = { key: 1 }, TBt = /* @__PURE__ */ e("path", {
  d: "M210,66.4l-8.3-30.9a7.9,7.9,0,0,0-9.8-5.6L130.1,46.4l49,28.3Z",
  opacity: "0.2"
}, null, -1), DBt = /* @__PURE__ */ e("path", {
  d: "M109.5,93.4,60.6,65.1,37.4,71.3a8,8,0,0,0-5.7,9.8L40,112Z",
  opacity: "0.2"
}, null, -1), RBt = ["stroke"], UBt = ["stroke"], qBt = ["stroke"], GBt = ["stroke"], EBt = { key: 2 }, OBt = /* @__PURE__ */ e("path", { d: "M216,104H100.8L212.1,74.2a7.9,7.9,0,0,0,4.8-3.8,7.5,7.5,0,0,0,.8-6l-8.3-30.9a15.8,15.8,0,0,0-19.5-11.3L35.3,63.6A15.9,15.9,0,0,0,24,83.2l8,29.9V200a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V112A8,8,0,0,0,216,104ZM169.3,69.1,99.7,87.7l-29.3-17,69.5-18.6ZM208,200H48V120H208v80Z" }, null, -1), IBt = [
  OBt
], KBt = { key: 3 }, XBt = ["stroke"], JBt = ["stroke"], QBt = ["stroke"], YBt = ["stroke"], oPt = { key: 4 }, ePt = ["stroke"], tPt = ["stroke"], nPt = ["stroke"], sPt = ["stroke"], rPt = { key: 5 }, iPt = ["stroke"], lPt = ["stroke"], dPt = ["stroke"], kPt = ["stroke"], cPt = {
  name: "PhFilmSlate"
}, ZO1 = /* @__PURE__ */ $({
  ...cPt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", LBt, [
        e("path", {
          d: "M40,112H216a0,0,0,0,1,0,0v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V112A0,0,0,0,1,40,112Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BBt),
        e("path", {
          d: "M40,112,210,66.4l-8.3-30.9a7.9,7.9,0,0,0-9.8-5.6L37.4,71.3a8,8,0,0,0-5.7,9.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PBt),
        e("line", {
          x1: "130.1",
          y1: "46.4",
          x2: "179.1",
          y2: "74.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WBt),
        e("line", {
          x1: "60.6",
          y1: "65.1",
          x2: "109.5",
          y2: "93.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NBt)
      ])) : o(i) === "duotone" ? (s(), r("g", FBt, [
        TBt,
        DBt,
        e("path", {
          d: "M40,112H216a0,0,0,0,1,0,0v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V112A0,0,0,0,1,40,112Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RBt),
        e("path", {
          d: "M40,112,210,66.4l-8.3-30.9a7.9,7.9,0,0,0-9.8-5.6L37.4,71.3a8,8,0,0,0-5.7,9.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UBt),
        e("line", {
          x1: "130.1",
          y1: "46.4",
          x2: "179.1",
          y2: "74.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qBt),
        e("line", {
          x1: "60.6",
          y1: "65.1",
          x2: "109.5",
          y2: "93.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GBt)
      ])) : o(i) === "fill" ? (s(), r("g", EBt, IBt)) : o(i) === "light" ? (s(), r("g", KBt, [
        e("path", {
          d: "M40,112H216a0,0,0,0,1,0,0v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V112A0,0,0,0,1,40,112Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XBt),
        e("path", {
          d: "M40,112,210,66.4l-8.3-30.9a7.9,7.9,0,0,0-9.8-5.6L37.4,71.3a8,8,0,0,0-5.7,9.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JBt),
        e("line", {
          x1: "130.1",
          y1: "46.4",
          x2: "179.1",
          y2: "74.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QBt),
        e("line", {
          x1: "60.6",
          y1: "65.1",
          x2: "109.5",
          y2: "93.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YBt)
      ])) : o(i) === "thin" ? (s(), r("g", oPt, [
        e("path", {
          d: "M40,112H216a0,0,0,0,1,0,0v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V112A0,0,0,0,1,40,112Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ePt),
        e("path", {
          d: "M40,112,210,66.4l-8.3-30.9a7.9,7.9,0,0,0-9.8-5.6L37.4,71.3a8,8,0,0,0-5.7,9.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tPt),
        e("line", {
          x1: "130.1",
          y1: "46.4",
          x2: "179.1",
          y2: "74.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nPt),
        e("line", {
          x1: "60.6",
          y1: "65.1",
          x2: "109.5",
          y2: "93.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sPt)
      ])) : o(i) === "regular" ? (s(), r("g", rPt, [
        e("path", {
          d: "M40,112H216a0,0,0,0,1,0,0v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V112A0,0,0,0,1,40,112Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iPt),
        e("path", {
          d: "M40,112,210,66.4l-8.3-30.9a7.9,7.9,0,0,0-9.8-5.6L37.4,71.3a8,8,0,0,0-5.7,9.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lPt),
        e("line", {
          x1: "130.1",
          y1: "46.4",
          x2: "179.1",
          y2: "74.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dPt),
        e("line", {
          x1: "60.6",
          y1: "65.1",
          x2: "109.5",
          y2: "93.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kPt)
      ])) : g("", !0)
    ], 16, bBt));
  }
}), hPt = ["width", "height", "fill", "transform"], uPt = { key: 0 }, aPt = ["stroke"], _Pt = ["stroke"], pPt = ["stroke"], yPt = ["stroke"], $Pt = ["stroke"], wPt = ["stroke"], fPt = ["stroke"], gPt = ["stroke"], xPt = { key: 1 }, jPt = /* @__PURE__ */ e("path", {
  d: "M32,176H224v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8Z",
  opacity: "0.2"
}, null, -1), mPt = /* @__PURE__ */ e("path", {
  d: "M224,80H32V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8Z",
  opacity: "0.2"
}, null, -1), MPt = ["stroke"], vPt = ["stroke"], SPt = ["stroke"], HPt = ["stroke"], APt = ["stroke"], VPt = ["stroke"], zPt = ["stroke"], ZPt = ["stroke"], CPt = { key: 2 }, bPt = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM184,56h32V72H184Zm-48,0h32V72H136ZM88,56h32V72H88ZM72,200H40V184H72ZM72,72H40V56H72ZM88,200V185.3h32V200Zm48,0V185.3h32V200Zm80,0H184V185.3h9.2V184H216v16Z" }, null, -1), LPt = [
  bPt
], BPt = { key: 3 }, PPt = ["stroke"], WPt = ["stroke"], NPt = ["stroke"], FPt = ["stroke"], TPt = ["stroke"], DPt = ["stroke"], RPt = ["stroke"], UPt = ["stroke"], qPt = { key: 4 }, GPt = ["stroke"], EPt = ["stroke"], OPt = ["stroke"], IPt = ["stroke"], KPt = ["stroke"], XPt = ["stroke"], JPt = ["stroke"], QPt = ["stroke"], YPt = { key: 5 }, oWt = ["stroke"], eWt = ["stroke"], tWt = ["stroke"], nWt = ["stroke"], sWt = ["stroke"], rWt = ["stroke"], iWt = ["stroke"], lWt = ["stroke"], dWt = {
  name: "PhFilmStrip"
}, CO1 = /* @__PURE__ */ $({
  ...dWt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", uPt, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aPt),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Pt),
        e("line", {
          x1: "32",
          y1: "88",
          x2: "224",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pPt),
        e("line", {
          x1: "32",
          y1: "168",
          x2: "224",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yPt),
        e("line", {
          x1: "80",
          y1: "48",
          x2: "80",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $Pt),
        e("line", {
          x1: "176",
          y1: "48",
          x2: "176",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wPt),
        e("line", {
          x1: "80",
          y1: "168",
          x2: "80",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fPt),
        e("line", {
          x1: "176",
          y1: "168",
          x2: "176",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gPt)
      ])) : o(i) === "duotone" ? (s(), r("g", xPt, [
        jPt,
        mPt,
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MPt),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vPt),
        e("line", {
          x1: "32",
          y1: "80",
          x2: "224",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SPt),
        e("line", {
          x1: "32",
          y1: "176",
          x2: "224",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HPt),
        e("line", {
          x1: "80",
          y1: "48",
          x2: "80",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, APt),
        e("line", {
          x1: "176",
          y1: "48",
          x2: "176",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VPt),
        e("line", {
          x1: "80",
          y1: "176",
          x2: "80",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zPt),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "176",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZPt)
      ])) : o(i) === "fill" ? (s(), r("g", CPt, LPt)) : o(i) === "light" ? (s(), r("g", BPt, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PPt),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WPt),
        e("line", {
          x1: "32",
          y1: "80",
          x2: "224",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, NPt),
        e("line", {
          x1: "32",
          y1: "176",
          x2: "224",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FPt),
        e("line", {
          x1: "80",
          y1: "48",
          x2: "80",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TPt),
        e("line", {
          x1: "176",
          y1: "48",
          x2: "176",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DPt),
        e("line", {
          x1: "80",
          y1: "176",
          x2: "80",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RPt),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "176",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UPt)
      ])) : o(i) === "thin" ? (s(), r("g", qPt, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GPt),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, EPt),
        e("line", {
          x1: "32",
          y1: "80",
          x2: "224",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OPt),
        e("line", {
          x1: "32",
          y1: "176",
          x2: "224",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, IPt),
        e("line", {
          x1: "80",
          y1: "48",
          x2: "80",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KPt),
        e("line", {
          x1: "176",
          y1: "48",
          x2: "176",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XPt),
        e("line", {
          x1: "80",
          y1: "176",
          x2: "80",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, JPt),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "176",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QPt)
      ])) : o(i) === "regular" ? (s(), r("g", YPt, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oWt),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eWt),
        e("line", {
          x1: "32",
          y1: "80",
          x2: "224",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tWt),
        e("line", {
          x1: "32",
          y1: "176",
          x2: "224",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nWt),
        e("line", {
          x1: "80",
          y1: "48",
          x2: "80",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sWt),
        e("line", {
          x1: "176",
          y1: "48",
          x2: "176",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rWt),
        e("line", {
          x1: "80",
          y1: "176",
          x2: "80",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iWt),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "176",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lWt)
      ])) : g("", !0)
    ], 16, hPt));
  }
}), kWt = ["width", "height", "fill", "transform"], cWt = { key: 0 }, hWt = ["stroke"], uWt = ["stroke"], aWt = ["stroke"], _Wt = ["stroke"], pWt = ["stroke"], yWt = ["stroke"], $Wt = { key: 1 }, wWt = ["stroke"], fWt = ["stroke"], gWt = ["stroke"], xWt = ["stroke"], jWt = ["stroke"], mWt = ["stroke"], MWt = ["stroke"], vWt = { key: 2 }, SWt = /* @__PURE__ */ j('<path d="M128,24A104.2,104.2,0,0,0,24,128a88,88,0,0,1-5,29.3,8.1,8.1,0,0,0,4.9,10.3,8.2,8.2,0,0,0,2.6.4,8.1,8.1,0,0,0,7.6-5.3A104.5,104.5,0,0,0,40,128a88,88,0,0,1,176,0,283.6,283.6,0,0,1-5.3,54.5,8.1,8.1,0,0,0,6.3,9.4h1.6a7.9,7.9,0,0,0,7.8-6.4A299.9,299.9,0,0,0,232,128,104.1,104.1,0,0,0,128,24Z"></path><path d="M93,84.3A8,8,0,0,0,83,71.8,71.6,71.6,0,0,0,56,128a118.7,118.7,0,0,1-12.5,53.4,8.1,8.1,0,0,0,3.6,10.7,7.8,7.8,0,0,0,3.6.8,8.1,8.1,0,0,0,7.2-4.4A136.1,136.1,0,0,0,72,128,55.9,55.9,0,0,1,93,84.3Z"></path><path d="M128,120a8,8,0,0,0-8,8,183.3,183.3,0,0,1-23,89.1,8.1,8.1,0,0,0,3.2,10.9,7.5,7.5,0,0,0,3.8,1,8,8,0,0,0,7-4.1A199.8,199.8,0,0,0,136,128,8,8,0,0,0,128,120Z"></path><path d="M128,88a40.1,40.1,0,0,0-40,40,8,8,0,0,0,16,0,24,24,0,0,1,48,0,214.3,214.3,0,0,1-20.5,92,8,8,0,0,0,3.8,10.7,8.3,8.3,0,0,0,3.4.7,8.1,8.1,0,0,0,7.3-4.6A230,230,0,0,0,168,128,40.1,40.1,0,0,0,128,88Z"></path><path d="M94.4,152.2a7.9,7.9,0,0,0-9.4,6.2,154.8,154.8,0,0,1-17.2,45.5,8,8,0,0,0,2.9,10.9,8.3,8.3,0,0,0,4,1.1,8.2,8.2,0,0,0,6.9-4,163.2,163.2,0,0,0,19-50.3A7.9,7.9,0,0,0,94.4,152.2Z"></path><path d="M128,56a68,68,0,0,0-9,.6,8,8,0,1,0,2,15.8c2.3-.2,4.7-.4,7-.4a56,56,0,0,1,56,56,245.7,245.7,0,0,1-1.9,31,7.9,7.9,0,0,0,6.9,8.9h1a8.1,8.1,0,0,0,8-7,279.7,279.7,0,0,0,2-33A72.1,72.1,0,0,0,128,56Z"></path><path d="M185.9,184.3a7.9,7.9,0,0,0-9.7,5.7c-1.5,5.7-3.2,11.4-5,17a7.9,7.9,0,0,0,5,10.1,7.8,7.8,0,0,0,2.6.4,7.9,7.9,0,0,0,7.5-5.4c2-6,3.8-12,5.4-18.1A8,8,0,0,0,185.9,184.3Z"></path>', 7), HWt = [
  SWt
], AWt = { key: 3 }, VWt = ["stroke"], zWt = ["stroke"], ZWt = ["stroke"], CWt = ["stroke"], bWt = ["stroke"], LWt = ["stroke"], BWt = ["stroke"], PWt = { key: 4 }, WWt = ["stroke"], NWt = ["stroke"], FWt = ["stroke"], TWt = ["stroke"], DWt = ["stroke"], RWt = ["stroke"], UWt = ["stroke"], qWt = { key: 5 }, GWt = ["stroke"], EWt = ["stroke"], OWt = ["stroke"], IWt = ["stroke"], KWt = ["stroke"], XWt = ["stroke"], JWt = ["stroke"], QWt = {
  name: "PhFingerprint"
}, bO1 = /* @__PURE__ */ $({
  ...QWt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", cWt, [
        e("path", {
          d: "M108,128a20,20,0,0,1,40,0,210.5,210.5,0,0,1-25,99.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hWt),
        e("path", {
          d: "M128,68a60,60,0,0,1,60,60c0,8.1-.4,16.1-1.1,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uWt),
        e("path", {
          d: "M51.3,192.2A130.4,130.4,0,0,0,68,128,59.7,59.7,0,0,1,88,83.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aWt),
        e("path", {
          d: "M103.3,168A168.7,168.7,0,0,1,83,217.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Wt),
        e("path", {
          d: "M179.8,192a233.4,233.4,0,0,1-8.4,26.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pWt),
        e("path", {
          d: "M22.3,160A91.7,91.7,0,0,0,28,128h0a100,100,0,0,1,200,0h0a293.3,293.3,0,0,1-7,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yWt)
      ])) : o(i) === "duotone" ? (s(), r("g", $Wt, [
        e("path", {
          d: "M50.7,184.9A127.4,127.4,0,0,0,64,128,64.2,64.2,0,0,1,88,78",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wWt),
        e("path", {
          d: "M128,128a191.2,191.2,0,0,1-24,93",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fWt),
        e("path", {
          d: "M96,128a32,32,0,0,1,64,0,222.3,222.3,0,0,1-21.3,95.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gWt),
        e("path", {
          d: "M218.6,184a294.6,294.6,0,0,0,5.4-56,96,96,0,0,0-192,0,94.4,94.4,0,0,1-5.5,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xWt),
        e("path", {
          d: "M92.8,160a161.9,161.9,0,0,1-18.1,47.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jWt),
        e("path", {
          d: "M120,64.5a70.1,70.1,0,0,1,8-.5,64,64,0,0,1,64,64,260.6,260.6,0,0,1-2,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mWt),
        e("path", {
          d: "M183.9,192c-1.5,5.9-3.2,11.8-5.1,17.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MWt)
      ])) : o(i) === "fill" ? (s(), r("g", vWt, HWt)) : o(i) === "light" ? (s(), r("g", AWt, [
        e("path", {
          d: "M50.7,184.9A127.4,127.4,0,0,0,64,128,64.2,64.2,0,0,1,88,78",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VWt),
        e("path", {
          d: "M128,128a191.2,191.2,0,0,1-24,93",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zWt),
        e("path", {
          d: "M96,128a32,32,0,0,1,64,0,222.3,222.3,0,0,1-21.3,95.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZWt),
        e("path", {
          d: "M218.6,184a294.6,294.6,0,0,0,5.4-56,96,96,0,0,0-192,0,94.4,94.4,0,0,1-5.5,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, CWt),
        e("path", {
          d: "M92.8,160a161.9,161.9,0,0,1-18.1,47.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bWt),
        e("path", {
          d: "M120,64.5a70.1,70.1,0,0,1,8-.5,64,64,0,0,1,64,64,260.6,260.6,0,0,1-2,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LWt),
        e("path", {
          d: "M183.9,192c-1.5,5.9-3.2,11.8-5.1,17.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BWt)
      ])) : o(i) === "thin" ? (s(), r("g", PWt, [
        e("path", {
          d: "M50.7,184.9A127.4,127.4,0,0,0,64,128,64.2,64.2,0,0,1,88,78",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WWt),
        e("path", {
          d: "M128,128a191.2,191.2,0,0,1-24,93",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, NWt),
        e("path", {
          d: "M96,128a32,32,0,0,1,64,0,222.3,222.3,0,0,1-21.3,95.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FWt),
        e("path", {
          d: "M218.6,184a294.6,294.6,0,0,0,5.4-56,96,96,0,0,0-192,0,94.4,94.4,0,0,1-5.5,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, TWt),
        e("path", {
          d: "M92.8,160a161.9,161.9,0,0,1-18.1,47.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, DWt),
        e("path", {
          d: "M120,64.5a70.1,70.1,0,0,1,8-.5,64,64,0,0,1,64,64,260.6,260.6,0,0,1-2,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RWt),
        e("path", {
          d: "M183.9,192c-1.5,5.9-3.2,11.8-5.1,17.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, UWt)
      ])) : o(i) === "regular" ? (s(), r("g", qWt, [
        e("path", {
          d: "M50.7,184.9A127.4,127.4,0,0,0,64,128,64.2,64.2,0,0,1,88,78",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GWt),
        e("path", {
          d: "M128,128a191.2,191.2,0,0,1-24,93",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EWt),
        e("path", {
          d: "M96,128a32,32,0,0,1,64,0,222.3,222.3,0,0,1-21.3,95.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OWt),
        e("path", {
          d: "M218.6,184a294.6,294.6,0,0,0,5.4-56,96,96,0,0,0-192,0,94.4,94.4,0,0,1-5.5,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IWt),
        e("path", {
          d: "M92.8,160a161.9,161.9,0,0,1-18.1,47.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KWt),
        e("path", {
          d: "M120,64.5a70.1,70.1,0,0,1,8-.5,64,64,0,0,1,64,64,260.6,260.6,0,0,1-2,32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XWt),
        e("path", {
          d: "M183.9,192c-1.5,5.9-3.2,11.8-5.1,17.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JWt)
      ])) : g("", !0)
    ], 16, kWt));
  }
}), YWt = ["width", "height", "fill", "transform"], oNt = { key: 0 }, eNt = ["stroke"], tNt = ["stroke"], nNt = ["stroke"], sNt = ["stroke"], rNt = ["stroke"], iNt = ["stroke"], lNt = { key: 1 }, dNt = ["stroke"], kNt = ["stroke"], cNt = ["stroke"], hNt = ["stroke"], uNt = ["stroke"], aNt = ["stroke"], _Nt = { key: 2 }, pNt = /* @__PURE__ */ j('<path d="M176,120a8,8,0,0,0-8,8,229.3,229.3,0,0,1-17.4,88.2,8,8,0,0,0,7.4,11,7.9,7.9,0,0,0,7.4-5A246.5,246.5,0,0,0,184,128,8,8,0,0,0,176,120Z"></path><path d="M128,88a40.4,40.4,0,0,1,29.8,13.3,8,8,0,0,0,11.3.7,8,8,0,0,0,.6-11.3A56,56,0,0,0,72,128a136.4,136.4,0,0,1-17,65.9,8,8,0,0,0,3.1,10.8,8.1,8.1,0,0,0,3.9,1,7.9,7.9,0,0,0,7-4.1A152.2,152.2,0,0,0,88,128,40.1,40.1,0,0,1,128,88Z"></path><path d="M69.3,62.4A8,8,0,1,0,58.6,50.5,104.2,104.2,0,0,0,24,128a87.6,87.6,0,0,1-8,36.7,8.1,8.1,0,0,0,3.9,10.6,8.3,8.3,0,0,0,3.4.7,7.8,7.8,0,0,0,7.2-4.7A102.4,102.4,0,0,0,40,128,88.3,88.3,0,0,1,69.3,62.4Z"></path><path d="M128,24a104.5,104.5,0,0,0-34.7,5.9,8.1,8.1,0,0,0-4.9,10.2A8,8,0,0,0,98.6,45,88.1,88.1,0,0,1,216,128a281.8,281.8,0,0,1-7,62.2,8.2,8.2,0,0,0,6.1,9.6l1.8.2a7.9,7.9,0,0,0,7.7-6.2A296.3,296.3,0,0,0,232,128,104.2,104.2,0,0,0,128,24Z"></path><path d="M113.9,200.7a8.1,8.1,0,0,0-10.6,4c-1.9,4.2-4.1,8.4-6.3,12.4a8.1,8.1,0,0,0,3.1,10.9,7.8,7.8,0,0,0,3.9,1,8.1,8.1,0,0,0,7-4.1c2.4-4.4,4.7-9,6.8-13.6A8,8,0,0,0,113.9,200.7Z"></path><path d="M128,120a8,8,0,0,0-8,8,186.5,186.5,0,0,1-5.8,46,8,8,0,0,0,5.7,9.8l2,.2a8.1,8.1,0,0,0,7.8-6,199.8,199.8,0,0,0,6.3-50A8,8,0,0,0,128,120Z"></path>', 6), yNt = [
  pNt
], $Nt = { key: 3 }, wNt = ["stroke"], fNt = ["stroke"], gNt = ["stroke"], xNt = ["stroke"], jNt = ["stroke"], mNt = ["stroke"], MNt = { key: 4 }, vNt = ["stroke"], SNt = ["stroke"], HNt = ["stroke"], ANt = ["stroke"], VNt = ["stroke"], zNt = ["stroke"], ZNt = { key: 5 }, CNt = ["stroke"], bNt = ["stroke"], LNt = ["stroke"], BNt = ["stroke"], PNt = ["stroke"], WNt = ["stroke"], NNt = {
  name: "PhFingerprintSimple"
}, LO1 = /* @__PURE__ */ $({
  ...NNt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", oNt, [
        e("path", {
          d: "M176,128a240.3,240.3,0,0,1-17.9,91.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eNt),
        e("path", {
          d: "M163.8,96A48,48,0,0,0,80,128a142.6,142.6,0,0,1-18,69.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tNt),
        e("path", {
          d: "M96,37.5A94.4,94.4,0,0,1,128,32a96,96,0,0,1,96,96,293.3,293.3,0,0,1-7.1,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nNt),
        e("path", {
          d: "M23.3,168A95.5,95.5,0,0,0,32,128,95.4,95.4,0,0,1,64,56.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sNt),
        e("path", {
          d: "M110.6,208c-2.1,4.4-4.3,8.8-6.6,13",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rNt),
        e("path", {
          d: "M128,128a189.6,189.6,0,0,1-6.1,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iNt)
      ])) : o(i) === "duotone" ? (s(), r("g", lNt, [
        e("path", {
          d: "M176,128a238.5,238.5,0,0,1-18,91.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dNt),
        e("path", {
          d: "M163.8,96A48,48,0,0,0,80,128a142.6,142.6,0,0,1-18,69.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kNt),
        e("path", {
          d: "M96,37.5A94.4,94.4,0,0,1,128,32a96,96,0,0,1,96,96,287.3,287.3,0,0,1-7.2,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cNt),
        e("path", {
          d: "M23.3,168A95.5,95.5,0,0,0,32,128,95.4,95.4,0,0,1,64,56.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hNt),
        e("path", {
          d: "M110.6,208c-2.1,4.4-4.3,8.8-6.6,13",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uNt),
        e("path", {
          d: "M128,128a189.6,189.6,0,0,1-6.1,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aNt)
      ])) : o(i) === "fill" ? (s(), r("g", _Nt, yNt)) : o(i) === "light" ? (s(), r("g", $Nt, [
        e("path", {
          d: "M176,128a240.3,240.3,0,0,1-17.9,91.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wNt),
        e("path", {
          d: "M163.8,96A48,48,0,0,0,80,128a142.6,142.6,0,0,1-18,69.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fNt),
        e("path", {
          d: "M96,37.5A94.4,94.4,0,0,1,128,32a96,96,0,0,1,96,96,293.3,293.3,0,0,1-7.1,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gNt),
        e("path", {
          d: "M23.3,168A95.5,95.5,0,0,0,32,128,95.7,95.7,0,0,1,64,56.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xNt),
        e("path", {
          d: "M110.6,208c-2.1,4.4-4.2,8.8-6.6,13",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jNt),
        e("path", {
          d: "M128,128a189.6,189.6,0,0,1-6.1,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mNt)
      ])) : o(i) === "thin" ? (s(), r("g", MNt, [
        e("path", {
          d: "M176,128a240.3,240.3,0,0,1-17.9,91.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vNt),
        e("path", {
          d: "M163.8,96A48,48,0,0,0,80,128a142.6,142.6,0,0,1-18,69.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SNt),
        e("path", {
          d: "M96,37.5A94.4,94.4,0,0,1,128,32a96,96,0,0,1,96,96,293.3,293.3,0,0,1-7.1,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HNt),
        e("path", {
          d: "M23.3,168A95.5,95.5,0,0,0,32,128,95.7,95.7,0,0,1,64,56.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ANt),
        e("path", {
          d: "M110.6,208c-2,4.4-4.2,8.8-6.6,13",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VNt),
        e("path", {
          d: "M128,128a189.6,189.6,0,0,1-6.1,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zNt)
      ])) : o(i) === "regular" ? (s(), r("g", ZNt, [
        e("path", {
          d: "M176,128a240.3,240.3,0,0,1-17.9,91.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CNt),
        e("path", {
          d: "M163.8,96A48,48,0,0,0,80,128a142.6,142.6,0,0,1-18,69.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bNt),
        e("path", {
          d: "M96,37.5A94.4,94.4,0,0,1,128,32a96,96,0,0,1,96,96,293.3,293.3,0,0,1-7.1,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LNt),
        e("path", {
          d: "M23.3,168A95.5,95.5,0,0,0,32,128,95.7,95.7,0,0,1,64,56.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BNt),
        e("path", {
          d: "M110.6,208c-2,4.4-4.2,8.8-6.6,13",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PNt),
        e("path", {
          d: "M128,128a189.6,189.6,0,0,1-6.1,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WNt)
      ])) : g("", !0)
    ], 16, YWt));
  }
}), FNt = ["width", "height", "fill", "transform"], TNt = { key: 0 }, DNt = ["stroke"], RNt = ["stroke"], UNt = /* @__PURE__ */ e("circle", {
  cx: "96",
  cy: "140",
  r: "16"
}, null, -1), qNt = /* @__PURE__ */ e("circle", {
  cx: "160",
  cy: "140",
  r: "16"
}, null, -1), GNt = { key: 1 }, ENt = /* @__PURE__ */ e("path", {
  d: "M208,40a23.9,23.9,0,0,0-24,24H72a24,24,0,0,0-48,0v80a64.1,64.1,0,0,0,64,64h80a64.1,64.1,0,0,0,64-64V64A23.9,23.9,0,0,0,208,40Zm-8,104a32,32,0,0,1-32,32H88a32,32,0,0,1-32-32v-8a32,32,0,0,1,32-32h80a32,32,0,0,1,32,32Z",
  opacity: "0.2"
}, null, -1), ONt = ["stroke"], INt = ["stroke"], KNt = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "140",
  r: "12"
}, null, -1), XNt = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "140",
  r: "12"
}, null, -1), JNt = { key: 2 }, QNt = /* @__PURE__ */ e("path", { d: "M176,140a12,12,0,1,1-12-12A12,12,0,0,1,176,140ZM92,128a12,12,0,1,0,12,12A12,12,0,0,0,92,128ZM240,64v80a72.1,72.1,0,0,1-72,72H88a72.1,72.1,0,0,1-72-72V64a32,32,0,0,1,63-8h98a32,32,0,0,1,63,8Zm-40,72a32,32,0,0,0-32-32H88a32,32,0,0,0-32,32v8a32,32,0,0,0,32,32h80a32,32,0,0,0,32-32Z" }, null, -1), YNt = [
  QNt
], oFt = { key: 3 }, eFt = ["stroke"], tFt = ["stroke"], nFt = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "140",
  r: "10"
}, null, -1), sFt = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "140",
  r: "10"
}, null, -1), rFt = { key: 4 }, iFt = ["stroke"], lFt = ["stroke"], dFt = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "140",
  r: "8"
}, null, -1), kFt = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "140",
  r: "8"
}, null, -1), cFt = { key: 5 }, hFt = ["stroke"], uFt = ["stroke"], aFt = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "140",
  r: "12"
}, null, -1), _Ft = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "140",
  r: "12"
}, null, -1), pFt = {
  name: "PhFinnTheHuman"
}, BO1 = /* @__PURE__ */ $({
  ...pFt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", TNt, [
        e("rect", {
          x: "56",
          y: "100",
          width: "144",
          height: "80",
          rx: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DNt),
        e("path", {
          d: "M20,64a24,24,0,0,1,48,0H188a24,24,0,0,1,48,0v88a64.1,64.1,0,0,1-64,64H84a64.1,64.1,0,0,1-64-64Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RNt),
        UNt,
        qNt
      ])) : o(i) === "duotone" ? (s(), r("g", GNt, [
        ENt,
        e("rect", {
          x: "56",
          y: "104",
          width: "144",
          height: "72",
          rx: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ONt),
        e("path", {
          d: "M24,64a24,24,0,0,1,48,0H184a24,24,0,0,1,48,0v80a64.1,64.1,0,0,1-64,64H88a64.1,64.1,0,0,1-64-64Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, INt),
        KNt,
        XNt
      ])) : o(i) === "fill" ? (s(), r("g", JNt, YNt)) : o(i) === "light" ? (s(), r("g", oFt, [
        e("rect", {
          x: "56",
          y: "104",
          width: "144",
          height: "72",
          rx: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eFt),
        e("path", {
          d: "M24,64a24,24,0,0,1,48,0H184a24,24,0,0,1,48,0v80a64.1,64.1,0,0,1-64,64H88a64.1,64.1,0,0,1-64-64Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tFt),
        nFt,
        sFt
      ])) : o(i) === "thin" ? (s(), r("g", rFt, [
        e("rect", {
          x: "56",
          y: "104",
          width: "144",
          height: "72",
          rx: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iFt),
        e("path", {
          d: "M24,64a24,24,0,0,1,48,0H184a24,24,0,0,1,48,0v80a64.1,64.1,0,0,1-64,64H88a64.1,64.1,0,0,1-64-64Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lFt),
        dFt,
        kFt
      ])) : o(i) === "regular" ? (s(), r("g", cFt, [
        e("rect", {
          x: "56",
          y: "104",
          width: "144",
          height: "72",
          rx: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hFt),
        e("path", {
          d: "M24,64a24,24,0,0,1,48,0H184a24,24,0,0,1,48,0v80a64.1,64.1,0,0,1-64,64H88a64.1,64.1,0,0,1-64-64Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uFt),
        aFt,
        _Ft
      ])) : g("", !0)
    ], 16, FNt));
  }
}), yFt = ["width", "height", "fill", "transform"], $Ft = { key: 0 }, wFt = ["stroke"], fFt = ["stroke"], gFt = { key: 1 }, xFt = /* @__PURE__ */ e("path", {
  d: "M72,65.4C56.6,88.6,44,115.2,44,140a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L112,92,72,65.4Z",
  opacity: "0.2"
}, null, -1), jFt = ["stroke"], mFt = ["stroke"], MFt = { key: 2 }, vFt = /* @__PURE__ */ e("path", { d: "M197.1,66.6c-13-20.8-29.9-38.7-44.6-53.4a8,8,0,0,0-7-2.2,7.9,7.9,0,0,0-5.9,4.4L108.7,80.2,76.5,58.7a8.1,8.1,0,0,0-6-1.2,8,8,0,0,0-5.1,3.4C45.9,90.3,36,116.9,36,140a92,92,0,0,0,184,0C220,115.1,212.5,91.1,197.1,66.6Zm-9.8,82.6a59.6,59.6,0,0,1-50.1,50.1H136a8,8,0,0,1-1.2-15.9,44.4,44.4,0,0,0,36.7-36.7,8,8,0,1,1,15.8,2.4Z" }, null, -1), SFt = [
  vFt
], HFt = { key: 3 }, AFt = ["stroke"], VFt = ["stroke"], zFt = { key: 4 }, ZFt = ["stroke"], CFt = ["stroke"], bFt = { key: 5 }, LFt = ["stroke"], BFt = ["stroke"], PFt = {
  name: "PhFire"
}, PO1 = /* @__PURE__ */ $({
  ...PFt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $Ft, [
        e("path", {
          d: "M171.8,144A44.1,44.1,0,0,1,136,183.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wFt),
        e("path", {
          d: "M72,65.4C56.6,88.6,44,115.2,44,140a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L112,92,72,65.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fFt)
      ])) : o(i) === "duotone" ? (s(), r("g", gFt, [
        xFt,
        e("path", {
          d: "M179.4,148A52.2,52.2,0,0,1,136,191.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jFt),
        e("path", {
          d: "M72,65.4C56.6,88.6,44,115.2,44,140a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L112,92,72,65.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mFt)
      ])) : o(i) === "fill" ? (s(), r("g", MFt, SFt)) : o(i) === "light" ? (s(), r("g", HFt, [
        e("path", {
          d: "M179.4,148A52.2,52.2,0,0,1,136,191.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, AFt),
        e("path", {
          d: "M72,65.4C56.6,88.6,44,115.2,44,140a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L112,92,72,65.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VFt)
      ])) : o(i) === "thin" ? (s(), r("g", zFt, [
        e("path", {
          d: "M179.4,148A52.2,52.2,0,0,1,136,191.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZFt),
        e("path", {
          d: "M72,65.4C56.6,88.6,44,115.2,44,140a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L112,92,72,65.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CFt)
      ])) : o(i) === "regular" ? (s(), r("g", bFt, [
        e("path", {
          d: "M179.4,148A52.2,52.2,0,0,1,136,191.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LFt),
        e("path", {
          d: "M72,65.4C56.6,88.6,44,115.2,44,140a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L112,92,72,65.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BFt)
      ])) : g("", !0)
    ], 16, yFt));
  }
}), WFt = ["width", "height", "fill", "transform"], NFt = { key: 0 }, FFt = ["stroke"], TFt = { key: 1 }, DFt = /* @__PURE__ */ e("path", {
  d: "M71.9,65.4c-15.4,23.2-28,49.8-28,74.6a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L111.9,92l-40-26.6Z",
  opacity: "0.2"
}, null, -1), RFt = ["stroke"], UFt = { key: 2 }, qFt = /* @__PURE__ */ e("path", { d: "M219.9,140a92,92,0,0,1-184,0c0-23.1,9.9-49.7,29.4-79.1a8,8,0,0,1,5-3.4,8.2,8.2,0,0,1,6.1,1.2l32.2,21.5,30.9-64.8a7.9,7.9,0,0,1,5.8-4.4,8.1,8.1,0,0,1,7.1,2.2c14.7,14.7,31.5,32.6,44.6,53.4C212.4,91.1,219.9,115.1,219.9,140Z" }, null, -1), GFt = [
  qFt
], EFt = { key: 3 }, OFt = ["stroke"], IFt = { key: 4 }, KFt = ["stroke"], XFt = { key: 5 }, JFt = ["stroke"], QFt = {
  name: "PhFireSimple"
}, WO1 = /* @__PURE__ */ $({
  ...QFt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", NFt, [
        e("path", {
          d: "M71.9,65.4c-15.4,23.2-28,49.8-28,74.6a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L111.9,92l-40-26.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FFt)
      ])) : o(i) === "duotone" ? (s(), r("g", TFt, [
        DFt,
        e("path", {
          d: "M71.9,65.4c-15.4,23.2-28,49.8-28,74.6a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L111.9,92l-40-26.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RFt)
      ])) : o(i) === "fill" ? (s(), r("g", UFt, GFt)) : o(i) === "light" ? (s(), r("g", EFt, [
        e("path", {
          d: "M71.9,65.4c-15.4,23.2-28,49.8-28,74.6a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L111.9,92l-40-26.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OFt)
      ])) : o(i) === "thin" ? (s(), r("g", IFt, [
        e("path", {
          d: "M71.9,65.4c-15.4,23.2-28,49.8-28,74.6a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L111.9,92l-40-26.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KFt)
      ])) : o(i) === "regular" ? (s(), r("g", XFt, [
        e("path", {
          d: "M71.9,65.4c-15.4,23.2-28,49.8-28,74.6a84,84,0,0,0,168,0c0-52-36-92-65.2-121.1h0L111.9,92l-40-26.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JFt)
      ])) : g("", !0)
    ], 16, WFt));
  }
}), YFt = ["width", "height", "fill", "transform"], oTt = { key: 0 }, eTt = ["stroke"], tTt = { key: 1 }, nTt = /* @__PURE__ */ e("path", {
  d: "M96,160H40a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8V96h56a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H160v56a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V160Z",
  opacity: "0.2"
}, null, -1), sTt = ["stroke"], rTt = { key: 2 }, iTt = /* @__PURE__ */ e("path", { d: "M232,104v48a16,16,0,0,1-16,16H168v48a16,16,0,0,1-16,16H104a16,16,0,0,1-16-16V168H40a16,16,0,0,1-16-16V104A16,16,0,0,1,40,88H88V40a16,16,0,0,1,16-16h48a16,16,0,0,1,16,16V88h48A16,16,0,0,1,232,104Z" }, null, -1), lTt = [
  iTt
], dTt = { key: 3 }, kTt = ["stroke"], cTt = { key: 4 }, hTt = ["stroke"], uTt = { key: 5 }, aTt = ["stroke"], _Tt = {
  name: "PhFirstAid"
}, NO1 = /* @__PURE__ */ $({
  ..._Tt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", oTt, [
        e("path", {
          d: "M96,160H40a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8V96h56a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H160v56a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V160Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eTt)
      ])) : o(i) === "duotone" ? (s(), r("g", tTt, [
        nTt,
        e("path", {
          d: "M96,160H40a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8V96h56a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H160v56a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V160Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sTt)
      ])) : o(i) === "fill" ? (s(), r("g", rTt, lTt)) : o(i) === "light" ? (s(), r("g", dTt, [
        e("path", {
          d: "M96,160H40a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8V96h56a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H160v56a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V160Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kTt)
      ])) : o(i) === "thin" ? (s(), r("g", cTt, [
        e("path", {
          d: "M96,160H40a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8V96h56a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H160v56a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V160Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hTt)
      ])) : o(i) === "regular" ? (s(), r("g", uTt, [
        e("path", {
          d: "M96,160H40a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8V96h56a8,8,0,0,1,8,8v48a8,8,0,0,1-8,8H160v56a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V160Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aTt)
      ])) : g("", !0)
    ], 16, YFt));
  }
}), pTt = ["width", "height", "fill", "transform"], yTt = { key: 0 }, $Tt = ["stroke"], wTt = ["stroke"], fTt = ["stroke"], gTt = ["stroke"], xTt = { key: 1 }, jTt = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "72",
  width: "192",
  height: "144",
  rx: "8",
  opacity: "0.2"
}, null, -1), mTt = ["stroke"], MTt = ["stroke"], vTt = ["stroke"], STt = ["stroke"], HTt = { key: 2 }, ATt = /* @__PURE__ */ e("path", { d: "M216,64H176V56a24.1,24.1,0,0,0-24-24H104A24.1,24.1,0,0,0,80,56v8H40A16,16,0,0,0,24,80V208a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64ZM96,56a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm60,96H136v20a8,8,0,0,1-16,0V152H100a8,8,0,0,1,0-16h20V116a8,8,0,0,1,16,0v20h20a8,8,0,0,1,0,16Z" }, null, -1), VTt = [
  ATt
], zTt = { key: 3 }, ZTt = ["stroke"], CTt = ["stroke"], bTt = ["stroke"], LTt = ["stroke"], BTt = { key: 4 }, PTt = ["stroke"], WTt = ["stroke"], NTt = ["stroke"], FTt = ["stroke"], TTt = { key: 5 }, DTt = ["stroke"], RTt = ["stroke"], UTt = ["stroke"], qTt = ["stroke"], GTt = {
  name: "PhFirstAidKit"
}, FO1 = /* @__PURE__ */ $({
  ...GTt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", yTt, [
        e("line", {
          x1: "128",
          y1: "116",
          x2: "128",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $Tt),
        e("line", {
          x1: "156",
          y1: "144",
          x2: "100",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wTt),
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fTt),
        e("path", {
          d: "M168,72V52a16,16,0,0,0-16-16H104A16,16,0,0,0,88,52V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gTt)
      ])) : o(i) === "duotone" ? (s(), r("g", xTt, [
        jTt,
        e("line", {
          x1: "128",
          y1: "116",
          x2: "128",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mTt),
        e("line", {
          x1: "156",
          y1: "144",
          x2: "100",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MTt),
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vTt),
        e("path", {
          d: "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, STt)
      ])) : o(i) === "fill" ? (s(), r("g", HTt, VTt)) : o(i) === "light" ? (s(), r("g", zTt, [
        e("line", {
          x1: "128",
          y1: "116",
          x2: "128",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZTt),
        e("line", {
          x1: "156",
          y1: "144",
          x2: "100",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, CTt),
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bTt),
        e("path", {
          d: "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LTt)
      ])) : o(i) === "thin" ? (s(), r("g", BTt, [
        e("line", {
          x1: "128",
          y1: "116",
          x2: "128",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PTt),
        e("line", {
          x1: "156",
          y1: "144",
          x2: "100",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WTt),
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, NTt),
        e("path", {
          d: "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FTt)
      ])) : o(i) === "regular" ? (s(), r("g", TTt, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DTt),
        e("path", {
          d: "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RTt),
        e("line", {
          x1: "128",
          y1: "116",
          x2: "128",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UTt),
        e("line", {
          x1: "156",
          y1: "144",
          x2: "100",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qTt)
      ])) : g("", !0)
    ], 16, pTt));
  }
}), ETt = ["width", "height", "fill", "transform"], OTt = { key: 0 }, ITt = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "76",
  r: "16"
}, null, -1), KTt = ["stroke"], XTt = ["stroke"], JTt = { key: 1 }, QTt = /* @__PURE__ */ e("path", {
  d: "M88.1,69.7c-14.8,17.9-25,44.4-25.9,83.5h0L8,176l56,16,16,56,22.8-54.2h0c39-.9,65.6-11.1,83.5-25.9H184a48,48,0,0,1-48-48A48,48,0,0,1,88,72,17.7,17.7,0,0,1,88.1,69.7Z",
  opacity: "0.2"
}, null, -1), YTt = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "76",
  r: "12"
}, null, -1), oDt = ["stroke"], eDt = ["stroke"], tDt = { key: 2 }, nDt = /* @__PURE__ */ e("path", { d: "M168,76a12,12,0,1,1-12-12A12,12,0,0,1,168,76Zm37.7,83.5c-20.4,25.9-53.2,40.1-97.5,42.1L87.4,251.1A8.1,8.1,0,0,1,80,256h-.5a7.9,7.9,0,0,1-7.2-5.8L57.5,198.5,5.8,183.7a8,8,0,0,1-.9-15.1l49.5-20.8c2-44.3,16.1-77.1,42.1-97.5,41.1-32.4,99.4-23,116.3-19.3A15.9,15.9,0,0,1,225,43.2C228.7,60.1,238.1,118.4,205.7,159.5Zm3.7-112.9c-15.2-3.2-67.4-11.8-103,16.3A74.1,74.1,0,0,0,96,72.7,40.1,40.1,0,0,0,136,112a8,8,0,0,1,8,8,40.1,40.1,0,0,0,39.3,40,80,80,0,0,0,9.8-10.4C221.2,114,212.6,61.8,209.4,46.6Z" }, null, -1), sDt = [
  nDt
], rDt = { key: 3 }, iDt = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "76",
  r: "10"
}, null, -1), lDt = ["stroke"], dDt = ["stroke"], kDt = { key: 4 }, cDt = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "76",
  r: "8"
}, null, -1), hDt = ["stroke"], uDt = ["stroke"], aDt = { key: 5 }, _Dt = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "76",
  r: "12"
}, null, -1), pDt = ["stroke"], yDt = ["stroke"], $Dt = {
  name: "PhFish"
}, TO1 = /* @__PURE__ */ $({
  ...$Dt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", OTt, [
        ITt,
        e("path", {
          d: "M186.3,167.9H184a48,48,0,0,1-48-48A48,48,0,0,1,88,72a17.7,17.7,0,0,1,.1-2.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KTt),
        e("path", {
          d: "M62.2,153.2,12,176l52,16,16,52,22.8-50.2h0c138.4-3.3,120-122.9,114.4-148.9a8.2,8.2,0,0,0-6.1-6.1c-26-5.6-145.6-24-148.9,114.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XTt)
      ])) : o(i) === "duotone" ? (s(), r("g", JTt, [
        QTt,
        YTt,
        e("path", {
          d: "M186.3,167.9H184a48,48,0,0,1-48-48A48,48,0,0,1,88,72a17.7,17.7,0,0,1,.1-2.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oDt),
        e("path", {
          d: "M62.2,153.2,8,176l56,16,16,56,22.8-54.2h0c138.4-3.3,120-122.9,114.4-148.9a8.2,8.2,0,0,0-6.1-6.1c-26-5.6-145.6-24-148.9,114.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eDt)
      ])) : o(i) === "fill" ? (s(), r("g", tDt, sDt)) : o(i) === "light" ? (s(), r("g", rDt, [
        iDt,
        e("path", {
          d: "M186.3,167.9H184a48,48,0,0,1-48-48A48,48,0,0,1,88,72a17.7,17.7,0,0,1,.1-2.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lDt),
        e("path", {
          d: "M62.2,153.2,8,176l56,16,16,56,22.8-54.2h0c138.4-3.3,120-122.9,114.4-148.9a8.2,8.2,0,0,0-6.1-6.1c-26-5.6-145.6-24-148.9,114.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dDt)
      ])) : o(i) === "thin" ? (s(), r("g", kDt, [
        cDt,
        e("path", {
          d: "M186.3,167.9H184a48,48,0,0,1-48-48A48,48,0,0,1,88,72a17.7,17.7,0,0,1,.1-2.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hDt),
        e("path", {
          d: "M62.2,153.2,8,176l56,16,16,56,22.8-54.2h0c138.4-3.3,120-122.9,114.4-148.9a8.2,8.2,0,0,0-6.1-6.1c-26-5.6-145.6-24-148.9,114.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uDt)
      ])) : o(i) === "regular" ? (s(), r("g", aDt, [
        _Dt,
        e("path", {
          d: "M186.3,167.9H184a48,48,0,0,1-48-48A48,48,0,0,1,88,72a17.7,17.7,0,0,1,.1-2.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pDt),
        e("path", {
          d: "M62.2,153.2,8,176l56,16,16,56,22.8-54.2h0c138.4-3.3,120-122.9,114.4-148.9a8.2,8.2,0,0,0-6.1-6.1c-26-5.6-145.6-24-148.9,114.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yDt)
      ])) : g("", !0)
    ], 16, ETt));
  }
}), wDt = ["width", "height", "fill", "transform"], fDt = { key: 0 }, gDt = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "76",
  r: "16"
}, null, -1), xDt = ["stroke"], jDt = ["stroke"], mDt = { key: 1 }, MDt = /* @__PURE__ */ e("path", {
  d: "M104,54.6C75.9,75.2,55.7,115.4,64,192h0c76.6,8.3,116.8-11.9,137.4-40h-.1A96,96,0,0,1,104,54.6Z",
  opacity: "0.2"
}, null, -1), vDt = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "76",
  r: "12"
}, null, -1), SDt = ["stroke"], HDt = ["stroke"], ADt = { key: 2 }, VDt = /* @__PURE__ */ e("path", { d: "M168,76a12,12,0,1,1-12-12A12,12,0,0,1,168,76Zm30.2,92c-26.5,26.4-68.4,37.4-125.1,32.9,1.6,11.8,3.8,24.3,6.7,37.4a7.9,7.9,0,0,1-6.1,9.5L72,248a8,8,0,0,1-7.8-6.3c-3.3-14.9-5.7-29.1-7.4-42.5-13.4-1.7-27.6-4.2-42.5-7.4a8,8,0,0,1,3.4-15.7c13.1,2.9,25.6,5.2,37.4,6.8C50.6,126.2,61.6,84.3,88,57.8c41-41,105.8-30.9,124.7-26.8A15.9,15.9,0,0,1,225,43.3C229.1,62.2,239.2,127,198.2,168ZM209.4,46.7c-15-3.3-62.3-10.9-97.3,12.1a87.9,87.9,0,0,0,85.1,85.1C220.2,108.9,212.6,61.6,209.4,46.7Z" }, null, -1), zDt = [
  VDt
], ZDt = { key: 3 }, CDt = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "76",
  r: "10"
}, null, -1), bDt = ["stroke"], LDt = ["stroke"], BDt = { key: 4 }, PDt = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "76",
  r: "8"
}, null, -1), WDt = ["stroke"], NDt = ["stroke"], FDt = { key: 5 }, TDt = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "76",
  r: "12"
}, null, -1), DDt = ["stroke"], RDt = ["stroke"], UDt = {
  name: "PhFishSimple"
}, DO1 = /* @__PURE__ */ $({
  ...UDt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", fDt, [
        gDt,
        e("path", {
          d: "M16,184C247.8,234.7,223.8,75.5,217.2,45a8.2,8.2,0,0,0-6.2-6.2C180.5,32.2,21.3,8.2,72,240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xDt),
        e("path", {
          d: "M201.3,152A96,96,0,0,1,104,54.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jDt)
      ])) : o(i) === "duotone" ? (s(), r("g", mDt, [
        MDt,
        vDt,
        e("path", {
          d: "M16,184C247.8,234.7,223.8,75.5,217.2,45a8.2,8.2,0,0,0-6.2-6.2C180.5,32.2,21.3,8.2,72,240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SDt),
        e("path", {
          d: "M201.3,152A96,96,0,0,1,104,54.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HDt)
      ])) : o(i) === "fill" ? (s(), r("g", ADt, zDt)) : o(i) === "light" ? (s(), r("g", ZDt, [
        CDt,
        e("path", {
          d: "M16,184C247.8,234.7,223.8,75.5,217.2,45a8.2,8.2,0,0,0-6.2-6.2C180.5,32.2,21.3,8.2,72,240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bDt),
        e("path", {
          d: "M201.3,152A96,96,0,0,1,104,54.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LDt)
      ])) : o(i) === "thin" ? (s(), r("g", BDt, [
        PDt,
        e("path", {
          d: "M16,184C247.8,234.7,223.8,75.5,217.2,45a8.2,8.2,0,0,0-6.2-6.2C180.5,32.2,21.3,8.2,72,240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WDt),
        e("path", {
          d: "M201.3,152A96,96,0,0,1,104,54.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, NDt)
      ])) : o(i) === "regular" ? (s(), r("g", FDt, [
        TDt,
        e("path", {
          d: "M16,184C247.8,234.7,223.8,75.5,217.2,45a8.2,8.2,0,0,0-6.2-6.2C180.5,32.2,21.3,8.2,72,240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DDt),
        e("path", {
          d: "M201.3,152A96,96,0,0,1,104,54.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RDt)
      ])) : g("", !0)
    ], 16, wDt));
  }
}), qDt = ["width", "height", "fill", "transform"], GDt = { key: 0 }, EDt = ["stroke"], ODt = ["stroke"], IDt = { key: 1 }, KDt = /* @__PURE__ */ e("path", {
  d: "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48Z",
  opacity: "0.2"
}, null, -1), XDt = ["stroke"], JDt = ["stroke"], QDt = { key: 2 }, YDt = /* @__PURE__ */ e("path", { d: "M219.6,40.8a8.2,8.2,0,0,0-8.4.8c-28.3,21.2-52.3,11-80-.9s-60.3-25.9-96,.9h-.1l-.4.3-.2.2-.3.3-.3.3-.2.3-.3.3c0,.1-.1.2-.2.3l-.2.4c0,.1-.1.2-.1.3a.8.8,0,0,0-.2.4c-.1.1-.1.2-.2.4s-.1.2-.1.3-.1.3-.1.4-.1.2-.1.3-.1.3-.1.4V47c0,.1-.1.3-.1.4V216a8,8,0,0,0,16,0V172.1c26.9-18.1,50.1-8.2,76.8,3.3,16.3,6.9,33.8,14.4,52.6,14.4,13.8,0,28.3-4,43.4-15.4A8.1,8.1,0,0,0,224,168V48A8.2,8.2,0,0,0,219.6,40.8Z" }, null, -1), oRt = [
  YDt
], eRt = { key: 3 }, tRt = ["stroke"], nRt = ["stroke"], sRt = { key: 4 }, rRt = ["stroke"], iRt = ["stroke"], lRt = { key: 5 }, dRt = ["stroke"], kRt = ["stroke"], cRt = {
  name: "PhFlag"
}, RO1 = /* @__PURE__ */ $({
  ...cRt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", GDt, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "40",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, EDt),
        e("path", {
          d: "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ODt)
      ])) : o(i) === "duotone" ? (s(), r("g", IDt, [
        KDt,
        e("line", {
          x1: "40",
          y1: "216",
          x2: "40",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XDt),
        e("path", {
          d: "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JDt)
      ])) : o(i) === "fill" ? (s(), r("g", QDt, oRt)) : o(i) === "light" ? (s(), r("g", eRt, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "40",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tRt),
        e("path", {
          d: "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nRt)
      ])) : o(i) === "thin" ? (s(), r("g", sRt, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "40",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rRt),
        e("path", {
          d: "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iRt)
      ])) : o(i) === "regular" ? (s(), r("g", lRt, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "40",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dRt),
        e("path", {
          d: "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kRt)
      ])) : g("", !0)
    ], 16, qDt));
  }
}), hRt = ["width", "height", "fill", "transform"], uRt = { key: 0 }, aRt = ["stroke"], _Rt = { key: 1 }, pRt = /* @__PURE__ */ e("polygon", {
  points: "40 48 40 48 224 48 176 108 224 168 40 168 40 48",
  opacity: "0.2"
}, null, -1), yRt = ["stroke"], $Rt = { key: 2 }, wRt = /* @__PURE__ */ e("path", { d: "M230.2,163a8,8,0,0,1-6.2,13H48v40a8,8,0,0,1-16,0V48a8,8,0,0,1,8-8H224a8,8,0,0,1,6.2,13l-44,55Z" }, null, -1), fRt = [
  wRt
], gRt = { key: 3 }, xRt = ["stroke"], jRt = { key: 4 }, mRt = ["stroke"], MRt = { key: 5 }, vRt = ["stroke"], SRt = {
  name: "PhFlagBanner"
}, UO1 = /* @__PURE__ */ $({
  ...SRt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", uRt, [
        e("polyline", {
          points: "40 216 40 48 40 48 224 48 176 108 224 168 40 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aRt)
      ])) : o(i) === "duotone" ? (s(), r("g", _Rt, [
        pRt,
        e("polyline", {
          points: "40 216 40 48 40 48 224 48 176 108 224 168 40 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yRt)
      ])) : o(i) === "fill" ? (s(), r("g", $Rt, fRt)) : o(i) === "light" ? (s(), r("g", gRt, [
        e("polyline", {
          points: "40 216 40 48 40 48 224 48 176 108 224 168 40 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xRt)
      ])) : o(i) === "thin" ? (s(), r("g", jRt, [
        e("polyline", {
          points: "40 216 40 48 40 48 224 48 176 108 224 168 40 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mRt)
      ])) : o(i) === "regular" ? (s(), r("g", MRt, [
        e("polyline", {
          points: "40 216 40 48 40 48 224 48 176 108 224 168 40 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vRt)
      ])) : g("", !0)
    ], 16, hRt));
  }
}), HRt = ["width", "height", "fill", "transform"], ARt = { key: 0 }, VRt = ["stroke"], zRt = ["stroke"], ZRt = ["stroke"], CRt = ["stroke"], bRt = ["stroke"], LRt = { key: 1 }, BRt = /* @__PURE__ */ j('<g opacity="0.2"><path d="M40,106.1c21.4-16,41-16,60-10.6V37.4C81,32,61.4,32,40,48Z"></path></g><g opacity="0.2"><path d="M156,58.6C175,64,194.6,64,216,48v58.1c-21.4,16.1-41,16-60,10.7Z"></path></g><g opacity="0.2"><path d="M156,116.8c-18.9-5.4-37.1-15.9-56-21.3v61.9c18.9,5.3,37.1,15.9,56,21.2Z"></path></g>', 3), PRt = ["stroke"], WRt = ["stroke"], NRt = ["stroke"], FRt = ["stroke"], TRt = ["stroke"], DRt = { key: 2 }, RRt = /* @__PURE__ */ e("path", { d: "M219.6,40.8a8.2,8.2,0,0,0-8.4.8c-28.3,21.2-52.3,11-80-.9s-60.3-25.9-96,.9A8,8,0,0,0,32,48h0V216a8,8,0,0,0,16,0V172.1c26.9-18.1,50.1-8.2,76.8,3.3,16.3,6.9,33.8,14.4,52.6,14.4,13.8,0,28.3-4,43.4-15.4A8.1,8.1,0,0,0,224,168V48A8.2,8.2,0,0,0,219.6,40.8ZM156,170.3V116.8c-18.9-5.4-37.1-15.9-56-21.3v53.6c-16.3-4.2-33.6-4.8-52,4.5V100.8c18.3-10.6,35.4-10,52-5.3V45.7a243.3,243.3,0,0,1,24.8,9.7c10,4.2,20.4,8.7,31.2,11.5v49.9c16.6,4.7,33.7,5.3,52-5.3v52.4C189.7,176.2,173.1,175.6,156,170.3Z" }, null, -1), URt = [
  RRt
], qRt = { key: 3 }, GRt = ["stroke"], ERt = ["stroke"], ORt = ["stroke"], IRt = ["stroke"], KRt = ["stroke"], XRt = { key: 4 }, JRt = ["stroke"], QRt = ["stroke"], YRt = ["stroke"], oUt = ["stroke"], eUt = ["stroke"], tUt = { key: 5 }, nUt = ["stroke"], sUt = ["stroke"], rUt = ["stroke"], iUt = ["stroke"], lUt = ["stroke"], dUt = {
  name: "PhFlagCheckered"
}, qO1 = /* @__PURE__ */ $({
  ...dUt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ARt, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "40",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VRt),
        e("path", {
          d: "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zRt),
        e("path", {
          d: "M216,106.1c-64,48-112-48-176,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZRt),
        e("line", {
          x1: "100",
          y1: "37.4",
          x2: "100",
          y2: "157.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CRt),
        e("line", {
          x1: "156",
          y1: "58.6",
          x2: "156",
          y2: "178.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bRt)
      ])) : o(i) === "duotone" ? (s(), r("g", LRt, [
        BRt,
        e("line", {
          x1: "40",
          y1: "216",
          x2: "40",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PRt),
        e("path", {
          d: "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WRt),
        e("path", {
          d: "M216,106.1c-64,48-112-48-176,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NRt),
        e("line", {
          x1: "100",
          y1: "37.4",
          x2: "100",
          y2: "157.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FRt),
        e("line", {
          x1: "156",
          y1: "58.6",
          x2: "156",
          y2: "178.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TRt)
      ])) : o(i) === "fill" ? (s(), r("g", DRt, URt)) : o(i) === "light" ? (s(), r("g", qRt, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "40",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GRt),
        e("path", {
          d: "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ERt),
        e("path", {
          d: "M216,106.1c-64,48-112-48-176,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ORt),
        e("line", {
          x1: "100",
          y1: "37.4",
          x2: "100",
          y2: "157.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IRt),
        e("line", {
          x1: "156",
          y1: "58.6",
          x2: "156",
          y2: "178.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KRt)
      ])) : o(i) === "thin" ? (s(), r("g", XRt, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "40",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, JRt),
        e("path", {
          d: "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QRt),
        e("path", {
          d: "M216,106.1c-64,48-112-48-176,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YRt),
        e("line", {
          x1: "100",
          y1: "37.4",
          x2: "100",
          y2: "157.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oUt),
        e("line", {
          x1: "156",
          y1: "58.6",
          x2: "156",
          y2: "178.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eUt)
      ])) : o(i) === "regular" ? (s(), r("g", tUt, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "40",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nUt),
        e("path", {
          d: "M40,168c64-48,112,48,176,0V48C152,96,104,0,40,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sUt),
        e("path", {
          d: "M216,106.1c-64,48-112-48-176,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rUt),
        e("line", {
          x1: "100",
          y1: "37.4",
          x2: "100",
          y2: "157.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iUt),
        e("line", {
          x1: "156",
          y1: "58.6",
          x2: "156",
          y2: "178.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lUt)
      ])) : g("", !0)
    ], 16, HRt));
  }
}), kUt = ["width", "height", "fill", "transform"], cUt = { key: 0 }, hUt = ["stroke"], uUt = ["stroke"], aUt = { key: 1 }, _Ut = /* @__PURE__ */ e("path", {
  d: "M128,24S48,72,48,144a79.9,79.9,0,0,0,77.9,79.9A39.9,39.9,0,0,1,88,184c0-40,40-64,40-64s40,24,40,64a39.9,39.9,0,0,1-37.9,39.9A79.9,79.9,0,0,0,208,144C208,72,128,24,128,24Z",
  opacity: "0.2"
}, null, -1), pUt = ["stroke"], yUt = ["stroke"], $Ut = { key: 2 }, wUt = /* @__PURE__ */ e("path", { d: "M173.8,51.5a221.5,221.5,0,0,0-41.7-34.4,8,8,0,0,0-8.2,0A221.5,221.5,0,0,0,82.2,51.5C54.6,80.5,40,112.5,40,144a88,88,0,0,0,176,0C216,112.5,201.4,80.5,173.8,51.5ZM96,184c0-27.7,22.5-47.3,32-54.3,9.5,7,32,26.6,32,54.3a32,32,0,0,1-64,0Z" }, null, -1), fUt = [
  wUt
], gUt = { key: 3 }, xUt = ["stroke"], jUt = ["stroke"], mUt = { key: 4 }, MUt = ["stroke"], vUt = ["stroke"], SUt = { key: 5 }, HUt = ["stroke"], AUt = ["stroke"], VUt = {
  name: "PhFlame"
}, GO1 = /* @__PURE__ */ $({
  ...VUt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", cUt, [
        e("path", {
          d: "M208,144c0-72-80-120-80-120S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hUt),
        e("path", {
          d: "M88,184a40,40,0,0,0,80,0c0-40-40-64-40-64S88,144,88,184Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uUt)
      ])) : o(i) === "duotone" ? (s(), r("g", aUt, [
        _Ut,
        e("path", {
          d: "M208,144c0-72-80-120-80-120S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pUt),
        e("path", {
          d: "M88,184a40,40,0,0,0,80,0c0-40-40-64-40-64S88,144,88,184Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yUt)
      ])) : o(i) === "fill" ? (s(), r("g", $Ut, fUt)) : o(i) === "light" ? (s(), r("g", gUt, [
        e("path", {
          d: "M208,144c0-72-80-120-80-120S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xUt),
        e("path", {
          d: "M88,184a40,40,0,0,0,80,0c0-40-40-64-40-64S88,144,88,184Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jUt)
      ])) : o(i) === "thin" ? (s(), r("g", mUt, [
        e("path", {
          d: "M208,144c0-72-80-120-80-120S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MUt),
        e("path", {
          d: "M88,184a40,40,0,0,0,80,0c0-40-40-64-40-64S88,144,88,184Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vUt)
      ])) : o(i) === "regular" ? (s(), r("g", SUt, [
        e("path", {
          d: "M208,144c0-72-80-120-80-120S48,72,48,144a80,80,0,0,0,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HUt),
        e("path", {
          d: "M88,184a40,40,0,0,0,80,0c0-40-40-64-40-64S88,144,88,184Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AUt)
      ])) : g("", !0)
    ], 16, kUt));
  }
}), zUt = ["width", "height", "fill", "transform"], ZUt = { key: 0 }, CUt = ["stroke"], bUt = ["stroke"], LUt = ["stroke"], BUt = { key: 1 }, PUt = /* @__PURE__ */ e("path", {
  d: "M192,77.3a8.1,8.1,0,0,1-1.6,4.8l-20.8,27.8a8.1,8.1,0,0,0-1.6,4.8V224a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8V114.7a8.1,8.1,0,0,0-1.6-4.8L65.6,82.1A8.1,8.1,0,0,1,64,77.3V64H192Z",
  opacity: "0.2"
}, null, -1), WUt = ["stroke"], NUt = ["stroke"], FUt = ["stroke"], TUt = { key: 2 }, DUt = /* @__PURE__ */ e("path", { d: "M184,16H72A16,16,0,0,0,56,32V77.3a15.6,15.6,0,0,0,3.2,9.6L80,114.7V224a16,16,0,0,0,16,16h64a16,16,0,0,0,16-16V114.7l20.8-27.8a15.6,15.6,0,0,0,3.2-9.6V32A16,16,0,0,0,184,16ZM136,152a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0ZM72,56V32H184V56Z" }, null, -1), RUt = [
  DUt
], UUt = { key: 3 }, qUt = ["stroke"], GUt = ["stroke"], EUt = ["stroke"], OUt = { key: 4 }, IUt = ["stroke"], KUt = ["stroke"], XUt = ["stroke"], JUt = { key: 5 }, QUt = ["stroke"], YUt = ["stroke"], oqt = ["stroke"], eqt = {
  name: "PhFlashlight"
}, EO1 = /* @__PURE__ */ $({
  ...eqt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ZUt, [
        e("path", {
          d: "M72,24H184a8,8,0,0,1,8,8V77.3a8.1,8.1,0,0,1-1.6,4.8l-20.8,27.8a8.1,8.1,0,0,0-1.6,4.8V224a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8V114.7a8.1,8.1,0,0,0-1.6-4.8L65.6,82.1A8.1,8.1,0,0,1,64,77.3V32A8,8,0,0,1,72,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CUt),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bUt),
        e("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LUt)
      ])) : o(i) === "duotone" ? (s(), r("g", BUt, [
        PUt,
        e("path", {
          d: "M72,24H184a8,8,0,0,1,8,8V77.3a8.1,8.1,0,0,1-1.6,4.8l-20.8,27.8a8.1,8.1,0,0,0-1.6,4.8V224a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8V114.7a8.1,8.1,0,0,0-1.6-4.8L65.6,82.1A8.1,8.1,0,0,1,64,77.3V32A8,8,0,0,1,72,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WUt),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NUt),
        e("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FUt)
      ])) : o(i) === "fill" ? (s(), r("g", TUt, RUt)) : o(i) === "light" ? (s(), r("g", UUt, [
        e("path", {
          d: "M72,24H184a8,8,0,0,1,8,8V77.3a8.1,8.1,0,0,1-1.6,4.8l-20.8,27.8a8.1,8.1,0,0,0-1.6,4.8V224a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8V114.7a8.1,8.1,0,0,0-1.6-4.8L65.6,82.1A8.1,8.1,0,0,1,64,77.3V32A8,8,0,0,1,72,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qUt),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GUt),
        e("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, EUt)
      ])) : o(i) === "thin" ? (s(), r("g", OUt, [
        e("path", {
          d: "M72,24H184a8,8,0,0,1,8,8V77.3a8.1,8.1,0,0,1-1.6,4.8l-20.8,27.8a8.1,8.1,0,0,0-1.6,4.8V224a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8V114.7a8.1,8.1,0,0,0-1.6-4.8L65.6,82.1A8.1,8.1,0,0,1,64,77.3V32A8,8,0,0,1,72,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, IUt),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KUt),
        e("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XUt)
      ])) : o(i) === "regular" ? (s(), r("g", JUt, [
        e("path", {
          d: "M72,24H184a8,8,0,0,1,8,8V77.3a8.1,8.1,0,0,1-1.6,4.8l-20.8,27.8a8.1,8.1,0,0,0-1.6,4.8V224a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8V114.7a8.1,8.1,0,0,0-1.6-4.8L65.6,82.1A8.1,8.1,0,0,1,64,77.3V32A8,8,0,0,1,72,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QUt),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YUt),
        e("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oqt)
      ])) : g("", !0)
    ], 16, zUt));
  }
}), tqt = ["width", "height", "fill", "transform"], nqt = { key: 0 }, sqt = ["stroke"], rqt = ["stroke"], iqt = ["stroke"], lqt = { key: 1 }, dqt = ["stroke"], kqt = ["stroke"], cqt = ["stroke"], hqt = /* @__PURE__ */ e("path", {
  d: "M62.6,165,39.3,203.9A8,8,0,0,0,46.1,216H209.9a8,8,0,0,0,6.8-12.1l-20.8-34.8h0c-11.4,9.7-32.2,16.8-67.9-1.1-33.3-16.6-53.6-11.7-65.4-3Z",
  opacity: "0.2"
}, null, -1), uqt = { key: 2 }, aqt = /* @__PURE__ */ e("path", { d: "M223.6,199.8,160,93.8V40h8a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16h8V93.8L55.8,160.7c0,.1-.1.2-.1.3L32.4,199.8A16,16,0,0,0,46.1,224H209.9a16,16,0,0,0,13.7-24.2ZM109.7,102a15.9,15.9,0,0,0,2.3-8.2V40h32V93.8a15.9,15.9,0,0,0,2.3,8.2l38.8,64.8c-13.1,7.1-31.4,5.1-53.5-6-14.3-7.1-32.7-13.5-50.3-11.4Z" }, null, -1), _qt = [
  aqt
], pqt = { key: 3 }, yqt = ["stroke"], $qt = ["stroke"], wqt = ["stroke"], fqt = { key: 4 }, gqt = ["stroke"], xqt = ["stroke"], jqt = ["stroke"], mqt = { key: 5 }, Mqt = ["stroke"], vqt = ["stroke"], Sqt = ["stroke"], Hqt = {
  name: "PhFlask"
}, OO1 = /* @__PURE__ */ $({
  ...Hqt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", nqt, [
        e("path", {
          d: "M104,32V93.8a8.4,8.4,0,0,1-1.1,4.1l-63.6,106A8,8,0,0,0,46.1,216H209.9a8,8,0,0,0,6.8-12.1l-63.6-106a8.4,8.4,0,0,1-1.1-4.1V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sqt),
        e("line", {
          x1: "88",
          y1: "32",
          x2: "168",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rqt),
        e("path", {
          d: "M62.6,165c11.8-8.7,32.1-13.6,65.4,3,35.7,17.9,56.5,10.8,67.9,1.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iqt)
      ])) : o(i) === "duotone" ? (s(), r("g", lqt, [
        e("path", {
          d: "M104,32V93.8a8.4,8.4,0,0,1-1.1,4.1l-63.6,106A8,8,0,0,0,46.1,216H209.9a8,8,0,0,0,6.8-12.1l-63.6-106a8.4,8.4,0,0,1-1.1-4.1V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dqt),
        e("line", {
          x1: "88",
          y1: "32",
          x2: "168",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kqt),
        e("path", {
          d: "M62.6,165c11.8-8.7,32.1-13.6,65.4,3,35.7,17.9,56.5,10.8,67.9,1.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cqt),
        hqt
      ])) : o(i) === "fill" ? (s(), r("g", uqt, _qt)) : o(i) === "light" ? (s(), r("g", pqt, [
        e("path", {
          d: "M104,32V93.8a8.4,8.4,0,0,1-1.1,4.1l-63.6,106A8,8,0,0,0,46.1,216H209.9a8,8,0,0,0,6.8-12.1l-63.6-106a8.4,8.4,0,0,1-1.1-4.1V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yqt),
        e("line", {
          x1: "88",
          y1: "32",
          x2: "168",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $qt),
        e("path", {
          d: "M62.6,165c11.8-8.7,32.1-13.6,65.4,3,35.7,17.9,56.5,10.8,67.9,1.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wqt)
      ])) : o(i) === "thin" ? (s(), r("g", fqt, [
        e("path", {
          d: "M104,32V93.8a8.4,8.4,0,0,1-1.1,4.1l-63.6,106A8,8,0,0,0,46.1,216H209.9a8,8,0,0,0,6.8-12.1l-63.6-106a8.4,8.4,0,0,1-1.1-4.1V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gqt),
        e("line", {
          x1: "88",
          y1: "32",
          x2: "168",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xqt),
        e("path", {
          d: "M62.6,165c11.8-8.7,32.1-13.6,65.4,3,35.7,17.9,56.5,10.8,67.9,1.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jqt)
      ])) : o(i) === "regular" ? (s(), r("g", mqt, [
        e("path", {
          d: "M104,32V93.8a8.4,8.4,0,0,1-1.1,4.1l-63.6,106A8,8,0,0,0,46.1,216H209.9a8,8,0,0,0,6.8-12.1l-63.6-106a8.4,8.4,0,0,1-1.1-4.1V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mqt),
        e("line", {
          x1: "88",
          y1: "32",
          x2: "168",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vqt),
        e("path", {
          d: "M62.6,165c11.8-8.7,32.1-13.6,65.4,3,35.7,17.9,56.5,10.8,67.9,1.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sqt)
      ])) : g("", !0)
    ], 16, tqt));
  }
}), Aqt = ["width", "height", "fill", "transform"], Vqt = { key: 0 }, zqt = ["stroke"], Zqt = ["stroke"], Cqt = ["stroke"], bqt = { key: 1 }, Lqt = /* @__PURE__ */ e("path", {
  d: "M80,216V152a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64h32a8,8,0,0,0,8-8V91.3a7.9,7.9,0,0,0-2.3-5.6L170.3,42.3a7.9,7.9,0,0,0-5.6-2.3H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8Z",
  opacity: "0.2"
}, null, -1), Bqt = ["stroke"], Pqt = ["stroke"], Wqt = ["stroke"], Nqt = { key: 2 }, Fqt = /* @__PURE__ */ e("path", { d: "M219.3,80,176,36.7A15.9,15.9,0,0,0,164.7,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V91.3A15.9,15.9,0,0,0,219.3,80ZM208,91.3V208H184V152a16,16,0,0,0-16-16H88a16,16,0,0,0-16,16v56H48V48H164.7L208,91.3ZM160,72a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h56A8,8,0,0,1,160,72Z" }, null, -1), Tqt = [
  Fqt
], Dqt = { key: 3 }, Rqt = ["stroke"], Uqt = ["stroke"], qqt = ["stroke"], Gqt = { key: 4 }, Eqt = ["stroke"], Oqt = ["stroke"], Iqt = ["stroke"], Kqt = { key: 5 }, Xqt = ["stroke"], Jqt = ["stroke"], Qqt = ["stroke"], Yqt = {
  name: "PhFloppyDisk"
}, IO1 = /* @__PURE__ */ $({
  ...Yqt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Vqt, [
        e("path", {
          d: "M216,91.3V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H164.7a7.9,7.9,0,0,1,5.6,2.3l43.4,43.4A7.9,7.9,0,0,1,216,91.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zqt),
        e("path", {
          d: "M80,216V152a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zqt),
        e("line", {
          x1: "152",
          y1: "80",
          x2: "96",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cqt)
      ])) : o(i) === "duotone" ? (s(), r("g", bqt, [
        Lqt,
        e("path", {
          d: "M216,91.3V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H164.7a7.9,7.9,0,0,1,5.6,2.3l43.4,43.4A7.9,7.9,0,0,1,216,91.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bqt),
        e("path", {
          d: "M80,216V152a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pqt),
        e("line", {
          x1: "152",
          y1: "72",
          x2: "96",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wqt)
      ])) : o(i) === "fill" ? (s(), r("g", Nqt, Tqt)) : o(i) === "light" ? (s(), r("g", Dqt, [
        e("path", {
          d: "M216,91.3V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H164.7a7.9,7.9,0,0,1,5.6,2.3l43.4,43.4A7.9,7.9,0,0,1,216,91.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rqt),
        e("path", {
          d: "M80,216V152a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Uqt),
        e("line", {
          x1: "152",
          y1: "72",
          x2: "96",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qqt)
      ])) : o(i) === "thin" ? (s(), r("g", Gqt, [
        e("path", {
          d: "M216,91.3V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H164.7a7.9,7.9,0,0,1,5.6,2.3l43.4,43.4A7.9,7.9,0,0,1,216,91.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Eqt),
        e("path", {
          d: "M80,216V152a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Oqt),
        e("line", {
          x1: "152",
          y1: "72",
          x2: "96",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Iqt)
      ])) : o(i) === "regular" ? (s(), r("g", Kqt, [
        e("path", {
          d: "M216,91.3V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H164.7a7.9,7.9,0,0,1,5.6,2.3l43.4,43.4A7.9,7.9,0,0,1,216,91.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xqt),
        e("path", {
          d: "M80,216V152a8,8,0,0,1,8-8h80a8,8,0,0,1,8,8v64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jqt),
        e("line", {
          x1: "152",
          y1: "72",
          x2: "96",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qqt)
      ])) : g("", !0)
    ], 16, Aqt));
  }
}), oGt = ["width", "height", "fill", "transform"], eGt = { key: 0 }, tGt = ["stroke"], nGt = ["stroke"], sGt = ["stroke"], rGt = { key: 1 }, iGt = /* @__PURE__ */ e("path", {
  d: "M208,40H91.3a7.9,7.9,0,0,0-5.6,2.3L42.3,85.7A7.9,7.9,0,0,0,40,91.3V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48A8,8,0,0,0,208,40ZM128,176a28,28,0,1,1,28-28A28,28,0,0,1,128,176Z",
  opacity: "0.2"
}, null, -1), lGt = ["stroke"], dGt = ["stroke"], kGt = ["stroke"], cGt = { key: 2 }, hGt = /* @__PURE__ */ e("path", { d: "M208,32H172a4,4,0,0,0-4,4V80a8,8,0,0,1-8,8H96.3A8.2,8.2,0,0,1,88,80.5,8,8,0,0,1,96,72h56V36a4,4,0,0,0-4-4H91.3A15.9,15.9,0,0,0,80,36.7L36.7,80A15.9,15.9,0,0,0,32,91.3V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM128,176a28,28,0,1,1,28-28A28.1,28.1,0,0,1,128,176Z" }, null, -1), uGt = [
  hGt
], aGt = { key: 3 }, _Gt = ["stroke"], pGt = ["stroke"], yGt = ["stroke"], $Gt = { key: 4 }, wGt = ["stroke"], fGt = ["stroke"], gGt = ["stroke"], xGt = { key: 5 }, jGt = ["stroke"], mGt = ["stroke"], MGt = ["stroke"], vGt = {
  name: "PhFloppyDiskBack"
}, KO1 = /* @__PURE__ */ $({
  ...vGt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", eGt, [
        e("path", {
          d: "M40,91.3V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H91.3a7.9,7.9,0,0,0-5.6,2.3L42.3,85.7A7.9,7.9,0,0,0,40,91.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tGt),
        e("circle", {
          cx: "128",
          cy: "148",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nGt),
        e("polyline", {
          points: "104 80 160 80 160 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sGt)
      ])) : o(i) === "duotone" ? (s(), r("g", rGt, [
        iGt,
        e("path", {
          d: "M40,91.3V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H91.3a7.9,7.9,0,0,0-5.6,2.3L42.3,85.7A7.9,7.9,0,0,0,40,91.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lGt),
        e("circle", {
          cx: "128",
          cy: "148",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dGt),
        e("polyline", {
          points: "96 80 160 80 160 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kGt)
      ])) : o(i) === "fill" ? (s(), r("g", cGt, uGt)) : o(i) === "light" ? (s(), r("g", aGt, [
        e("path", {
          d: "M40,91.3V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H91.3a7.9,7.9,0,0,0-5.6,2.3L42.3,85.7A7.9,7.9,0,0,0,40,91.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _Gt),
        e("circle", {
          cx: "128",
          cy: "148",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pGt),
        e("polyline", {
          points: "96 80 160 80 160 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yGt)
      ])) : o(i) === "thin" ? (s(), r("g", $Gt, [
        e("path", {
          d: "M40,91.3V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H91.3a7.9,7.9,0,0,0-5.6,2.3L42.3,85.7A7.9,7.9,0,0,0,40,91.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wGt),
        e("circle", {
          cx: "128",
          cy: "148",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fGt),
        e("polyline", {
          points: "96 80 160 80 160 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gGt)
      ])) : o(i) === "regular" ? (s(), r("g", xGt, [
        e("path", {
          d: "M40,91.3V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H91.3a7.9,7.9,0,0,0-5.6,2.3L42.3,85.7A7.9,7.9,0,0,0,40,91.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jGt),
        e("circle", {
          cx: "128",
          cy: "148",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mGt),
        e("polyline", {
          points: "96 80 160 80 160 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MGt)
      ])) : g("", !0)
    ], 16, oGt));
  }
}), SGt = ["width", "height", "fill", "transform"], HGt = { key: 0 }, AGt = ["stroke"], VGt = ["stroke"], zGt = ["stroke"], ZGt = { key: 1 }, CGt = /* @__PURE__ */ e("circle", {
  cx: "44",
  cy: "176",
  r: "28",
  opacity: "0.2"
}, null, -1), bGt = ["stroke"], LGt = ["stroke"], BGt = ["stroke"], PGt = { key: 2 }, WGt = /* @__PURE__ */ e("path", { d: "M245.7,85.7l-40,40a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L220.7,88H176a40,40,0,0,0-40,40,56,56,0,0,1-56,56h-.9a36,36,0,1,1,0-16H80a40,40,0,0,0,40-40,56,56,0,0,1,56-56h44.7L194.3,45.7a8.1,8.1,0,0,1,11.4-11.4l40,40A8.1,8.1,0,0,1,245.7,85.7Z" }, null, -1), NGt = [
  WGt
], FGt = { key: 3 }, TGt = ["stroke"], DGt = ["stroke"], RGt = ["stroke"], UGt = { key: 4 }, qGt = ["stroke"], GGt = ["stroke"], EGt = ["stroke"], OGt = { key: 5 }, IGt = ["stroke"], KGt = ["stroke"], XGt = ["stroke"], JGt = {
  name: "PhFlowArrow"
}, XO1 = /* @__PURE__ */ $({
  ...JGt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", HGt, [
        e("circle", {
          cx: "44",
          cy: "176",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, AGt),
        e("polyline", {
          points: "200 40 240 80 200 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VGt),
        e("path", {
          d: "M72,176h8a48,48,0,0,0,48-48h0a48,48,0,0,1,48-48h64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zGt)
      ])) : o(i) === "duotone" ? (s(), r("g", ZGt, [
        CGt,
        e("circle", {
          cx: "44",
          cy: "176",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bGt),
        e("polyline", {
          points: "200 40 240 80 200 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LGt),
        e("path", {
          d: "M72,176h8a48,48,0,0,0,48-48h0a48,48,0,0,1,48-48h64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BGt)
      ])) : o(i) === "fill" ? (s(), r("g", PGt, NGt)) : o(i) === "light" ? (s(), r("g", FGt, [
        e("circle", {
          cx: "44",
          cy: "176",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TGt),
        e("polyline", {
          points: "200 40 240 80 200 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DGt),
        e("path", {
          d: "M72,176h8a48,48,0,0,0,48-48h0a48,48,0,0,1,48-48h64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RGt)
      ])) : o(i) === "thin" ? (s(), r("g", UGt, [
        e("circle", {
          cx: "44",
          cy: "176",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qGt),
        e("polyline", {
          points: "200 40 240 80 200 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GGt),
        e("path", {
          d: "M72,176h8a48,48,0,0,0,48-48h0a48,48,0,0,1,48-48h64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, EGt)
      ])) : o(i) === "regular" ? (s(), r("g", OGt, [
        e("circle", {
          cx: "44",
          cy: "176",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IGt),
        e("polyline", {
          points: "200 40 240 80 200 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KGt),
        e("path", {
          d: "M72,176h8a48,48,0,0,0,48-48h0a48,48,0,0,1,48-48h64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XGt)
      ])) : g("", !0)
    ], 16, SGt));
  }
}), QGt = ["width", "height", "fill", "transform"], YGt = { key: 0 }, oEt = ["stroke"], eEt = ["stroke"], tEt = ["stroke"], nEt = ["stroke"], sEt = ["stroke"], rEt = ["stroke"], iEt = ["stroke"], lEt = { key: 1 }, dEt = /* @__PURE__ */ j('<path d="M115,103.2a28,28,0,0,1,26,0h0c7.3-15.4,15-34.6,15-47.2a28,28,0,0,0-56,0c0,12.6,7.7,31.8,15,47.2Z" opacity="0.2"></path><path d="M100,126.8a27.8,27.8,0,0,1,3.8-12.8,26.5,26.5,0,0,1,9.2-9.6h0C103.3,90.3,90.5,74,79.6,67.8a28,28,0,0,0-28,48.4c10.9,6.3,31.4,9.3,48.4,10.6Z" opacity="0.2"></path><path d="M113,151.6a26.5,26.5,0,0,1-9.2-9.6,27.8,27.8,0,0,1-3.8-12.8h0c-17,1.3-37.5,4.3-48.4,10.6a28,28,0,1,0,28,48.4c10.9-6.2,23.7-22.5,33.4-36.6Z" opacity="0.2"></path><path d="M141,152.8a28,28,0,0,1-26,0h0c-7.3,15.4-15,34.6-15,47.2a28,28,0,0,0,56,0c0-12.6-7.7-31.8-15-47.2Z" opacity="0.2"></path><path d="M156,129.2a27.8,27.8,0,0,1-3.8,12.8,26.5,26.5,0,0,1-9.2,9.6h0c9.7,14.1,22.5,30.4,33.4,36.6a28,28,0,0,0,28-48.4c-10.9-6.3-31.4-9.3-48.4-10.6Z" opacity="0.2"></path><path d="M143,104.4a26.5,26.5,0,0,1,9.2,9.6,27.8,27.8,0,0,1,3.8,12.8h0c17-1.3,37.5-4.3,48.4-10.6a28,28,0,0,0-28-48.4C165.5,74,152.7,90.3,143,104.4Z" opacity="0.2"></path>', 6), kEt = ["stroke"], cEt = ["stroke"], hEt = ["stroke"], uEt = ["stroke"], aEt = ["stroke"], _Et = ["stroke"], pEt = ["stroke"], yEt = { key: 2 }, $Et = /* @__PURE__ */ e("path", { d: "M208.4,132.8a56.9,56.9,0,0,0-11.5-4.8,56.9,56.9,0,0,0,11.5-4.8,36,36,0,0,0-36-62.4,58.7,58.7,0,0,0-9.9,7.5A58.6,58.6,0,0,0,164,56a36,36,0,0,0-72,0,58.6,58.6,0,0,0,1.5,12.3,58.7,58.7,0,0,0-9.9-7.5,36,36,0,0,0-36,62.4A56.9,56.9,0,0,0,59.1,128a56.9,56.9,0,0,0-11.5,4.8,36,36,0,0,0,36,62.4,58.7,58.7,0,0,0,9.9-7.5A58.6,58.6,0,0,0,92,200a36,36,0,0,0,72,0,58.6,58.6,0,0,0-1.5-12.3,58.7,58.7,0,0,0,9.9,7.5,36,36,0,0,0,36-62.4ZM128,152a24,24,0,1,1,24-24A24.1,24.1,0,0,1,128,152Z" }, null, -1), wEt = [
  $Et
], fEt = { key: 3 }, gEt = ["stroke"], xEt = ["stroke"], jEt = ["stroke"], mEt = ["stroke"], MEt = ["stroke"], vEt = ["stroke"], SEt = ["stroke"], HEt = { key: 4 }, AEt = ["stroke"], VEt = ["stroke"], zEt = ["stroke"], ZEt = ["stroke"], CEt = ["stroke"], bEt = ["stroke"], LEt = ["stroke"], BEt = { key: 5 }, PEt = ["stroke"], WEt = ["stroke"], NEt = ["stroke"], FEt = ["stroke"], TEt = ["stroke"], DEt = ["stroke"], REt = ["stroke"], UEt = {
  name: "PhFlower"
}, JO1 = /* @__PURE__ */ $({
  ...UEt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", YGt, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oEt),
        e("path", {
          d: "M115,103.2c-7.3-15.4-15-34.6-15-47.2a28,28,0,0,1,56,0c0,12.6-7.7,31.8-15,47.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eEt),
        e("path", {
          d: "M100,126.8c-17-1.3-37.5-4.3-48.4-10.6a28,28,0,0,1,28-48.4C90.5,74,103.3,90.3,113,104.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tEt),
        e("path", {
          d: "M113,151.6c-9.7,14.1-22.5,30.4-33.4,36.6a28,28,0,1,1-28-48.4c10.9-6.3,31.4-9.3,48.4-10.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nEt),
        e("path", {
          d: "M141,152.8c7.3,15.4,15,34.6,15,47.2a28,28,0,0,1-56,0c0-12.6,7.7-31.8,15-47.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sEt),
        e("path", {
          d: "M156,129.2c17,1.3,37.5,4.3,48.4,10.6a28,28,0,0,1-28,48.4c-10.9-6.2-23.7-22.5-33.4-36.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rEt),
        e("path", {
          d: "M143,104.4c9.7-14.1,22.5-30.4,33.4-36.6a28,28,0,0,1,28,48.4c-10.9,6.3-31.4,9.3-48.4,10.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iEt)
      ])) : o(i) === "duotone" ? (s(), r("g", lEt, [
        dEt,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kEt),
        e("path", {
          d: "M115,103.2c-7.3-15.4-15-34.6-15-47.2a28,28,0,0,1,56,0c0,12.6-7.7,31.8-15,47.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cEt),
        e("path", {
          d: "M100,126.8c-17-1.3-37.5-4.3-48.4-10.6a28,28,0,0,1,28-48.4C90.5,74,103.3,90.3,113,104.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hEt),
        e("path", {
          d: "M113,151.6c-9.7,14.1-22.5,30.4-33.4,36.6a28,28,0,1,1-28-48.4c10.9-6.3,31.4-9.3,48.4-10.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uEt),
        e("path", {
          d: "M141,152.8c7.3,15.4,15,34.6,15,47.2a28,28,0,0,1-56,0c0-12.6,7.7-31.8,15-47.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aEt),
        e("path", {
          d: "M156,129.2c17,1.3,37.5,4.3,48.4,10.6a28,28,0,0,1-28,48.4c-10.9-6.2-23.7-22.5-33.4-36.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Et),
        e("path", {
          d: "M143,104.4c9.7-14.1,22.5-30.4,33.4-36.6a28,28,0,0,1,28,48.4c-10.9,6.3-31.4,9.3-48.4,10.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pEt)
      ])) : o(i) === "fill" ? (s(), r("g", yEt, wEt)) : o(i) === "light" ? (s(), r("g", fEt, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gEt),
        e("path", {
          d: "M115,103.2c-7.3-15.4-15-34.6-15-47.2a28,28,0,0,1,56,0c0,12.6-7.7,31.8-15,47.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xEt),
        e("path", {
          d: "M100,126.8c-17-1.3-37.5-4.3-48.4-10.6a28,28,0,0,1,28-48.4C90.5,74,103.3,90.3,113,104.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jEt),
        e("path", {
          d: "M113,151.6c-9.7,14.1-22.5,30.4-33.4,36.6a28,28,0,1,1-28-48.4c10.9-6.3,31.4-9.3,48.4-10.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mEt),
        e("path", {
          d: "M141,152.8c7.3,15.4,15,34.6,15,47.2a28,28,0,0,1-56,0c0-12.6,7.7-31.8,15-47.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, MEt),
        e("path", {
          d: "M156,129.2c17,1.3,37.5,4.3,48.4,10.6a28,28,0,0,1-28,48.4c-10.9-6.2-23.7-22.5-33.4-36.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vEt),
        e("path", {
          d: "M143,104.4c9.7-14.1,22.5-30.4,33.4-36.6a28,28,0,0,1,28,48.4c-10.9,6.3-31.4,9.3-48.4,10.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, SEt)
      ])) : o(i) === "thin" ? (s(), r("g", HEt, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, AEt),
        e("path", {
          d: "M115,103.2c-7.3-15.4-15-34.6-15-47.2a28,28,0,0,1,56,0c0,12.6-7.7,31.8-15,47.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VEt),
        e("path", {
          d: "M100,126.8c-17-1.3-37.5-4.3-48.4-10.6a28,28,0,0,1,28-48.4C90.5,74,103.3,90.3,113,104.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zEt),
        e("path", {
          d: "M113,151.6c-9.7,14.1-22.5,30.4-33.4,36.6a28,28,0,1,1-28-48.4c10.9-6.3,31.4-9.3,48.4-10.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZEt),
        e("path", {
          d: "M141,152.8c7.3,15.4,15,34.6,15,47.2a28,28,0,0,1-56,0c0-12.6,7.7-31.8,15-47.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CEt),
        e("path", {
          d: "M156,129.2c17,1.3,37.5,4.3,48.4,10.6a28,28,0,0,1-28,48.4c-10.9-6.2-23.7-22.5-33.4-36.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bEt),
        e("path", {
          d: "M143,104.4c9.7-14.1,22.5-30.4,33.4-36.6a28,28,0,0,1,28,48.4c-10.9,6.3-31.4,9.3-48.4,10.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LEt)
      ])) : o(i) === "regular" ? (s(), r("g", BEt, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PEt),
        e("path", {
          d: "M115,103.2c-7.3-15.4-15-34.6-15-47.2a28,28,0,0,1,56,0c0,12.6-7.7,31.8-15,47.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WEt),
        e("path", {
          d: "M100,126.8c-17-1.3-37.5-4.3-48.4-10.6a28,28,0,0,1,28-48.4C90.5,74,103.3,90.3,113,104.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NEt),
        e("path", {
          d: "M113,151.6c-9.7,14.1-22.5,30.4-33.4,36.6a28,28,0,1,1-28-48.4c10.9-6.3,31.4-9.3,48.4-10.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FEt),
        e("path", {
          d: "M141,152.8c7.3,15.4,15,34.6,15,47.2a28,28,0,0,1-56,0c0-12.6,7.7-31.8,15-47.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TEt),
        e("path", {
          d: "M156,129.2c17,1.3,37.5,4.3,48.4,10.6a28,28,0,0,1-28,48.4c-10.9-6.2-23.7-22.5-33.4-36.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DEt),
        e("path", {
          d: "M143,104.4c9.7-14.1,22.5-30.4,33.4-36.6a28,28,0,0,1,28,48.4c-10.9,6.3-31.4,9.3-48.4,10.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, REt)
      ])) : g("", !0)
    ], 16, QGt));
  }
}), qEt = ["width", "height", "fill", "transform"], GEt = { key: 0 }, EEt = ["stroke"], OEt = ["stroke"], IEt = ["stroke"], KEt = ["stroke"], XEt = ["stroke"], JEt = { key: 1 }, QEt = /* @__PURE__ */ e("path", {
  d: "M128,200s-40-21.8-40-80a106,106,0,0,1,6.1-36.6h0A77.5,77.5,0,0,0,62.8,68.3a7.9,7.9,0,0,0-9.3,5.3c-2.9,8.7-6.3,26,.4,48.2h0c-16.4-3.8-29.2-2.1-36.5-.2a7.9,7.9,0,0,0-5.7,9.8c3.1,11.3,13,33.3,43.4,50.8S112,200,128,200",
  opacity: "0.2"
}, null, -1), YEt = /* @__PURE__ */ e("path", {
  d: "M128,200s40-21.8,40-80a106,106,0,0,0-6.1-36.6h0a77.5,77.5,0,0,1,31.3-15.1,7.9,7.9,0,0,1,9.3,5.3c2.9,8.7,6.3,26-.4,48.2h0c16.4-3.8,29.2-2.1,36.5-.2a7.9,7.9,0,0,1,5.7,9.8c-3.1,11.3-13,33.3-43.4,50.8S144,200,128,200",
  opacity: "0.2"
}, null, -1), oOt = ["stroke"], eOt = ["stroke"], tOt = ["stroke"], nOt = ["stroke"], sOt = ["stroke"], rOt = { key: 2 }, iOt = /* @__PURE__ */ e("path", { d: "M250.5,121.3a15.9,15.9,0,0,0-9.9-7.5,77.1,77.1,0,0,0-27.9-1.8,86.7,86.7,0,0,0-2.6-40.9,15.9,15.9,0,0,0-18.5-10.7,82.3,82.3,0,0,0-26.2,10.8,94.4,94.4,0,0,0-27.8-34.4,15.9,15.9,0,0,0-19.2,0A94.4,94.4,0,0,0,90.6,71.2,82.3,82.3,0,0,0,64.4,60.4,15.9,15.9,0,0,0,45.9,71.1,86.7,86.7,0,0,0,43.3,112a77.1,77.1,0,0,0-27.9,1.8A15.9,15.9,0,0,0,4,133.6c3.5,12.6,14.3,36.7,47.1,55.6S112.5,208,127.9,208h.2c15.4,0,44.2,0,76.8-18.8s43.6-43,47.1-55.6A16,16,0,0,0,250.5,121.3ZM128,49.6c9.6,7.2,32,28.4,32,70.4s-22.4,63.2-32,70.4h0c-9.6-7.2-32-28.4-32-70.4S118.4,56.8,128,49.6ZM19.3,129.3c6.2-1.6,15.9-2.8,28.4-.6a117.1,117.1,0,0,0,9.7,20.9,137.9,137.9,0,0,0,33.2,38.6,123.4,123.4,0,0,1-31.5-12.9C31.3,159.2,22.3,139.5,19.3,129.3Zm177.6,46a123.4,123.4,0,0,1-31.5,12.9,137.9,137.9,0,0,0,33.2-38.6,117.1,117.1,0,0,0,9.7-20.9,68.8,68.8,0,0,1,28.3.5C233.7,139.5,224.7,159.2,196.9,175.3Z" }, null, -1), lOt = [
  iOt
], dOt = { key: 3 }, kOt = ["stroke"], cOt = ["stroke"], hOt = ["stroke"], uOt = ["stroke"], aOt = ["stroke"], _Ot = { key: 4 }, pOt = ["stroke"], yOt = ["stroke"], $Ot = ["stroke"], wOt = ["stroke"], fOt = ["stroke"], gOt = { key: 5 }, xOt = ["stroke"], jOt = ["stroke"], mOt = ["stroke"], MOt = ["stroke"], vOt = ["stroke"], SOt = {
  name: "PhFlowerLotus"
}, QO1 = /* @__PURE__ */ $({
  ...SOt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", GEt, [
        e("path", {
          d: "M128,200s40-21.8,40-80c0-45.6-24.6-68.8-35.2-76.8a8.1,8.1,0,0,0-9.6,0C112.6,51.2,88,74.4,88,120,88,178.2,128,200,128,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, EEt),
        e("path", {
          d: "M128,200c12-2.6,44.3-20.8,63.7-54.4s14.6-60.3,10.8-72a7.8,7.8,0,0,0-9.2-5.3,77.1,77.1,0,0,0-31.4,15.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OEt),
        e("path", {
          d: "M94.1,83.4A77.1,77.1,0,0,0,62.7,68.3a7.8,7.8,0,0,0-9.2,5.3c-3.8,11.7-8.6,38.5,10.8,72S116,197.4,128,200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IEt),
        e("path", {
          d: "M128,200c16,0,41.8-.2,72.3-17.8s40.3-39.5,43.4-50.8a7.9,7.9,0,0,0-5.7-9.8c-7.3-1.9-19.8-3.6-35.8.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KEt),
        e("path", {
          d: "M53.8,121.7c-16-3.7-28.5-2-35.8-.1a7.9,7.9,0,0,0-5.7,9.8c3.1,11.3,13,33.3,43.4,50.8S112,200,128,200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XEt)
      ])) : o(i) === "duotone" ? (s(), r("g", JEt, [
        QEt,
        YEt,
        e("path", {
          d: "M128,200c16,0,42.5-.2,72.9-17.8s40.3-39.5,43.4-50.8a7.9,7.9,0,0,0-5.7-9.8c-7.3-1.9-20.1-3.6-36.5.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oOt),
        e("path", {
          d: "M53.9,121.8c-16.4-3.8-29.2-2.1-36.5-.2a7.9,7.9,0,0,0-5.7,9.8c3.1,11.3,13,33.3,43.4,50.8S112,200,128,200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eOt),
        e("path", {
          d: "M128,200s40-21.8,40-80c0-45.6-24.6-68.8-35.2-76.8a8.1,8.1,0,0,0-9.6,0C112.6,51.2,88,74.4,88,120,88,178.2,128,200,128,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tOt),
        e("path", {
          d: "M128,200c12-2.6,44.3-20.8,63.7-54.4s14.6-60.3,10.8-72a7.8,7.8,0,0,0-9.2-5.3,77.1,77.1,0,0,0-31.4,15.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nOt),
        e("path", {
          d: "M94.1,83.4A77.1,77.1,0,0,0,62.7,68.3a7.8,7.8,0,0,0-9.2,5.3c-3.8,11.7-8.6,38.5,10.8,72S116,197.4,128,200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sOt)
      ])) : o(i) === "fill" ? (s(), r("g", rOt, lOt)) : o(i) === "light" ? (s(), r("g", dOt, [
        e("path", {
          d: "M128,200c16,0,42.5-.2,72.9-17.8s40.3-39.5,43.4-50.8a7.9,7.9,0,0,0-5.7-9.8c-7.3-1.9-20.1-3.6-36.5.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kOt),
        e("path", {
          d: "M53.9,121.8c-16.4-3.8-29.2-2.1-36.5-.2a7.9,7.9,0,0,0-5.7,9.8c3.1,11.3,13,33.3,43.4,50.8S112,200,128,200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cOt),
        e("path", {
          d: "M128,200s40-21.8,40-80c0-45.6-24.6-68.8-35.2-76.8a8.1,8.1,0,0,0-9.6,0C112.6,51.2,88,74.4,88,120,88,178.2,128,200,128,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hOt),
        e("path", {
          d: "M128,200c12-2.6,44.3-20.8,63.7-54.4s14.6-60.3,10.8-72a7.8,7.8,0,0,0-9.2-5.3,77.1,77.1,0,0,0-31.4,15.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uOt),
        e("path", {
          d: "M94.1,83.4A77.1,77.1,0,0,0,62.7,68.3a7.8,7.8,0,0,0-9.2,5.3c-3.8,11.7-8.6,38.5,10.8,72S116,197.4,128,200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aOt)
      ])) : o(i) === "thin" ? (s(), r("g", _Ot, [
        e("path", {
          d: "M128,200c16,0,42.5-.2,72.9-17.8s40.3-39.5,43.4-50.8a7.9,7.9,0,0,0-5.7-9.8c-7.3-1.9-20.1-3.6-36.5.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pOt),
        e("path", {
          d: "M53.9,121.8c-16.4-3.8-29.2-2.1-36.5-.2a7.9,7.9,0,0,0-5.7,9.8c3.1,11.3,13,33.3,43.4,50.8S112,200,128,200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yOt),
        e("path", {
          d: "M128,200s40-21.8,40-80c0-45.6-24.6-68.8-35.2-76.8a8.1,8.1,0,0,0-9.6,0C112.6,51.2,88,74.4,88,120,88,178.2,128,200,128,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $Ot),
        e("path", {
          d: "M128,200c12-2.6,44.3-20.8,63.7-54.4s14.6-60.3,10.8-72a7.8,7.8,0,0,0-9.2-5.3,77.1,77.1,0,0,0-31.4,15.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wOt),
        e("path", {
          d: "M94.1,83.4A77.1,77.1,0,0,0,62.7,68.3a7.8,7.8,0,0,0-9.2,5.3c-3.8,11.7-8.6,38.5,10.8,72S116,197.4,128,200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fOt)
      ])) : o(i) === "regular" ? (s(), r("g", gOt, [
        e("path", {
          d: "M128,200c16,0,42.5-.2,72.9-17.8s40.3-39.5,43.4-50.8a7.9,7.9,0,0,0-5.7-9.8c-7.3-1.9-20.1-3.6-36.5.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xOt),
        e("path", {
          d: "M53.9,121.8c-16.4-3.8-29.2-2.1-36.5-.2a7.9,7.9,0,0,0-5.7,9.8c3.1,11.3,13,33.3,43.4,50.8S112,200,128,200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jOt),
        e("path", {
          d: "M128,200s40-21.8,40-80c0-45.6-24.6-68.8-35.2-76.8a8.1,8.1,0,0,0-9.6,0C112.6,51.2,88,74.4,88,120,88,178.2,128,200,128,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mOt),
        e("path", {
          d: "M128,200c12-2.6,44.3-20.8,63.7-54.4s14.6-60.3,10.8-72a7.8,7.8,0,0,0-9.2-5.3,77.1,77.1,0,0,0-31.4,15.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MOt),
        e("path", {
          d: "M94.1,83.4A77.1,77.1,0,0,0,62.7,68.3a7.8,7.8,0,0,0-9.2,5.3c-3.8,11.7-8.6,38.5,10.8,72S116,197.4,128,200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vOt)
      ])) : g("", !0)
    ], 16, qEt));
  }
}), HOt = ["width", "height", "fill", "transform"], AOt = { key: 0 }, VOt = ["stroke"], zOt = ["stroke"], ZOt = ["stroke"], COt = ["stroke"], bOt = ["stroke"], LOt = ["stroke"], BOt = { key: 1 }, POt = /* @__PURE__ */ e("path", {
  d: "M177,68.8h0A56.7,56.7,0,0,1,184,96v3.9a15.8,15.8,0,0,1-12.4,15.5A191.4,191.4,0,0,1,128,120a191.4,191.4,0,0,1-43.6-4.6A15.8,15.8,0,0,1,72,99.9V96.8a56.8,56.8,0,0,1,7.4-28h0C41.9,76.5,16,93,16,112c0,26.5,50.1,48,112,48s112-21.5,112-48C240,93,214.3,76.6,177,68.8Z",
  opacity: "0.2"
}, null, -1), WOt = ["stroke"], NOt = ["stroke"], FOt = ["stroke"], TOt = ["stroke"], DOt = ["stroke"], ROt = { key: 2 }, UOt = /* @__PURE__ */ e("path", { d: "M180.6,211a8.1,8.1,0,0,1-6.6,9.2h-1.3a8.1,8.1,0,0,1-7.9-6.7l-3.9-23.5a8,8,0,0,1,15.8-2.7ZM128,184a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V192A8,8,0,0,0,128,184Zm-39.5-3.1a7.9,7.9,0,0,0-9.2,6.5L75.4,211a8.1,8.1,0,0,0,6.6,9.2h1.3a8.1,8.1,0,0,0,7.9-6.7l3.9-23.5A8,8,0,0,0,88.5,180.9ZM248,112c0,16.2-13.4,30.9-37.7,41.3C188.2,162.8,159,168,128,168s-60.2-5.2-82.3-14.7C21.4,142.9,8,128.2,8,112c0-8.4,3.7-20.8,21.2-32.5,11.3-7.6,26.9-13.8,45.2-17.9A63.6,63.6,0,0,1,173,50.5a64.7,64.7,0,0,1,9.1,11.2C223.4,71.1,248,89.7,248,112ZM80,96.8v3.1a7.8,7.8,0,0,0,6.1,7.7A189.1,189.1,0,0,0,128,112a189.1,189.1,0,0,0,41.9-4.4,7.8,7.8,0,0,0,6.1-7.7V96a47.5,47.5,0,0,0-6.1-23.4h0a51.7,51.7,0,0,0-8.2-10.7A47.4,47.4,0,0,0,127.4,48C101.2,48.3,80,70.2,80,96.8Z" }, null, -1), qOt = [
  UOt
], GOt = { key: 3 }, EOt = ["stroke"], OOt = ["stroke"], IOt = ["stroke"], KOt = ["stroke"], XOt = ["stroke"], JOt = { key: 4 }, QOt = ["stroke"], YOt = ["stroke"], oIt = ["stroke"], eIt = ["stroke"], tIt = ["stroke"], nIt = { key: 5 }, sIt = ["stroke"], rIt = ["stroke"], iIt = ["stroke"], lIt = ["stroke"], dIt = ["stroke"], kIt = {
  name: "PhFlyingSaucer"
}, YO1 = /* @__PURE__ */ $({
  ...kIt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", AOt, [
        e("path", {
          d: "M177,68.8c37.3,7.8,63,24.2,63,43.2,0,26.5-50.1,48-112,48S16,138.5,16,112c0-19,25.9-35.5,63.4-43.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VOt),
        e("path", {
          d: "M177,68.8c37.3,7.8,63,24.2,63,43.2,0,26.5-50.1,48-112,48S16,138.5,16,112c0-19,25.9-35.5,63.4-43.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zOt),
        e("path", {
          d: "M72,99.9a15.8,15.8,0,0,0,12.4,15.5A191.4,191.4,0,0,0,128,120a191.4,191.4,0,0,0,43.6-4.6A15.8,15.8,0,0,0,184,99.9V96a56,56,0,0,0-56.7-56C96.5,40.4,72,66.1,72,96.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZOt),
        e("line", {
          x1: "170.2",
          y1: "197",
          x2: "172.7",
          y2: "212.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, COt),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bOt),
        e("line", {
          x1: "85.8",
          y1: "197",
          x2: "83.3",
          y2: "212.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LOt)
      ])) : o(i) === "duotone" ? (s(), r("g", BOt, [
        POt,
        e("line", {
          x1: "168.8",
          y1: "188.7",
          x2: "172.7",
          y2: "212.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WOt),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NOt),
        e("line", {
          x1: "87.2",
          y1: "188.7",
          x2: "83.3",
          y2: "212.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FOt),
        e("path", {
          d: "M177,68.8c37.3,7.8,63,24.2,63,43.2,0,26.5-50.1,48-112,48S16,138.5,16,112c0-19,25.9-35.5,63.4-43.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TOt),
        e("path", {
          d: "M72,99.9a15.8,15.8,0,0,0,12.4,15.5A191.4,191.4,0,0,0,128,120a191.4,191.4,0,0,0,43.6-4.6A15.8,15.8,0,0,0,184,99.9V96a56,56,0,0,0-56.7-56C96.5,40.4,72,66.1,72,96.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DOt)
      ])) : o(i) === "fill" ? (s(), r("g", ROt, qOt)) : o(i) === "light" ? (s(), r("g", GOt, [
        e("line", {
          x1: "168.8",
          y1: "188.7",
          x2: "172.7",
          y2: "212.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, EOt),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OOt),
        e("line", {
          x1: "87.2",
          y1: "188.7",
          x2: "83.3",
          y2: "212.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IOt),
        e("path", {
          d: "M177,68.8c37.3,7.8,63,24.2,63,43.2,0,26.5-50.1,48-112,48S16,138.5,16,112c0-19,25.9-35.5,63.4-43.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KOt),
        e("path", {
          d: "M72,99.9a15.8,15.8,0,0,0,12.4,15.5A191.4,191.4,0,0,0,128,120a191.4,191.4,0,0,0,43.6-4.6A15.8,15.8,0,0,0,184,99.9V96a56,56,0,0,0-56.7-56C96.5,40.4,72,66.1,72,96.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XOt)
      ])) : o(i) === "thin" ? (s(), r("g", JOt, [
        e("line", {
          x1: "168.8",
          y1: "188.7",
          x2: "172.7",
          y2: "212.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QOt),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YOt),
        e("line", {
          x1: "87.2",
          y1: "188.7",
          x2: "83.3",
          y2: "212.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oIt),
        e("path", {
          d: "M177,68.8c37.3,7.8,63,24.2,63,43.2,0,26.5-50.1,48-112,48S16,138.5,16,112c0-19,25.9-35.5,63.4-43.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eIt),
        e("path", {
          d: "M72,99.9a15.8,15.8,0,0,0,12.4,15.5A191.4,191.4,0,0,0,128,120a191.4,191.4,0,0,0,43.6-4.6A15.8,15.8,0,0,0,184,99.9V96a56,56,0,0,0-56.7-56C96.5,40.4,72,66.1,72,96.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tIt)
      ])) : o(i) === "regular" ? (s(), r("g", nIt, [
        e("line", {
          x1: "168.8",
          y1: "188.7",
          x2: "172.7",
          y2: "212.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sIt),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rIt),
        e("line", {
          x1: "87.2",
          y1: "188.7",
          x2: "83.3",
          y2: "212.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iIt),
        e("path", {
          d: "M177,68.8c37.3,7.8,63,24.2,63,43.2,0,26.5-50.1,48-112,48S16,138.5,16,112c0-19,25.9-35.5,63.4-43.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lIt),
        e("path", {
          d: "M72,99.9a15.8,15.8,0,0,0,12.4,15.5A191.4,191.4,0,0,0,128,120a191.4,191.4,0,0,0,43.6-4.6A15.8,15.8,0,0,0,184,99.9V96a56,56,0,0,0-56.7-56C96.5,40.4,72,66.1,72,96.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dIt)
      ])) : g("", !0)
    ], 16, HOt));
  }
}), cIt = ["width", "height", "fill", "transform"], hIt = { key: 0 }, uIt = ["stroke"], aIt = ["stroke"], _It = { key: 1 }, pIt = /* @__PURE__ */ e("path", {
  d: "M98.3,50.3,128,80H32V56a8,8,0,0,1,8-8H92.7A7.9,7.9,0,0,1,98.3,50.3Z",
  opacity: "0.2"
}, null, -1), yIt = ["stroke"], $It = ["stroke"], wIt = { key: 2 }, fIt = /* @__PURE__ */ e("path", { d: "M216,72H131.3L104,44.7A16.1,16.1,0,0,0,92.7,40H40A16,16,0,0,0,24,56V200.6A15.4,15.4,0,0,0,39.4,216H216.9A15.2,15.2,0,0,0,232,200.9V88A16,16,0,0,0,216,72ZM40,56H92.7l16,16H40Z" }, null, -1), gIt = [
  fIt
], xIt = { key: 3 }, jIt = ["stroke"], mIt = ["stroke"], MIt = { key: 4 }, vIt = ["stroke"], SIt = ["stroke"], HIt = { key: 5 }, AIt = ["stroke"], VIt = ["stroke"], zIt = {
  name: "PhFolder"
}, oI1 = /* @__PURE__ */ $({
  ...zIt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", hIt, [
        e("path", {
          d: "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uIt),
        e("path", {
          d: "M98.4,46.7,128,80H32V52a8,8,0,0,1,8-8H92.4A8,8,0,0,1,98.4,46.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aIt)
      ])) : o(i) === "duotone" ? (s(), r("g", _It, [
        pIt,
        e("path", {
          d: "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yIt),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $It)
      ])) : o(i) === "fill" ? (s(), r("g", wIt, gIt)) : o(i) === "light" ? (s(), r("g", xIt, [
        e("path", {
          d: "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jIt),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mIt)
      ])) : o(i) === "thin" ? (s(), r("g", MIt, [
        e("path", {
          d: "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vIt),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SIt)
      ])) : o(i) === "regular" ? (s(), r("g", HIt, [
        e("path", {
          d: "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AIt),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VIt)
      ])) : g("", !0)
    ], 16, cIt));
  }
}), ZIt = ["width", "height", "fill", "transform"], CIt = { key: 0 }, bIt = ["stroke"], LIt = ["stroke"], BIt = ["stroke"], PIt = ["stroke"], WIt = ["stroke"], NIt = ["stroke"], FIt = { key: 1 }, TIt = /* @__PURE__ */ e("path", {
  d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80Z",
  opacity: "0.2"
}, null, -1), DIt = ["stroke"], RIt = ["stroke"], UIt = ["stroke"], qIt = ["stroke"], GIt = ["stroke"], EIt = ["stroke"], OIt = { key: 2 }, IIt = /* @__PURE__ */ e("path", { d: "M96,208a8,8,0,0,1-8,8H39.4A15.4,15.4,0,0,1,24,200.6V192a8,8,0,0,1,16,0v8H88A8,8,0,0,1,96,208Zm64-8H128a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm64-56a8,8,0,0,0-8,8v48H200a8,8,0,0,0,0,16h16.9A15.2,15.2,0,0,0,232,200.9V152A8,8,0,0,0,224,144Zm-8-72H168a8,8,0,0,0,0,16h48v24a8,8,0,0,0,16,0V88A16,16,0,0,0,216,72ZM32,88h96a8,8,0,0,0,7.4-4.9,8.4,8.4,0,0,0-1.7-8.8L104,44.7A15.9,15.9,0,0,0,92.7,40H40A16,16,0,0,0,24,56V80A8,8,0,0,0,32,88Zm0,72a8,8,0,0,0,8-8V120a8,8,0,0,0-16,0v32A8,8,0,0,0,32,160Z" }, null, -1), KIt = [
  IIt
], XIt = { key: 3 }, JIt = ["stroke"], QIt = ["stroke"], YIt = ["stroke"], oKt = ["stroke"], eKt = ["stroke"], tKt = ["stroke"], nKt = { key: 4 }, sKt = ["stroke"], rKt = ["stroke"], iKt = ["stroke"], lKt = ["stroke"], dKt = ["stroke"], kKt = ["stroke"], cKt = { key: 5 }, hKt = ["stroke"], uKt = ["stroke"], aKt = ["stroke"], _Kt = ["stroke"], pKt = ["stroke"], yKt = ["stroke"], $Kt = {
  name: "PhFolderDotted"
}, eI1 = /* @__PURE__ */ $({
  ...$Kt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", CIt, [
        e("path", {
          d: "M88,208H39.4a7.4,7.4,0,0,1-7.4-7.4V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bIt),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LIt),
        e("path", {
          d: "M224,152v48.9a7.1,7.1,0,0,1-7.1,7.1H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BIt),
        e("path", {
          d: "M168,80h48a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PIt),
        e("line", {
          x1: "32",
          y1: "120",
          x2: "32",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WIt),
        e("path", {
          d: "M98.4,46.7,128,80H32V52a8,8,0,0,1,8-8H92.4A8,8,0,0,1,98.4,46.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NIt)
      ])) : o(i) === "duotone" ? (s(), r("g", FIt, [
        TIt,
        e("path", {
          d: "M88,208H39.4a7.4,7.4,0,0,1-7.4-7.4V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DIt),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RIt),
        e("path", {
          d: "M224,152v48.9a7.1,7.1,0,0,1-7.1,7.1H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UIt),
        e("path", {
          d: "M168,80h48a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qIt),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GIt),
        e("line", {
          x1: "32",
          y1: "120",
          x2: "32",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EIt)
      ])) : o(i) === "fill" ? (s(), r("g", OIt, KIt)) : o(i) === "light" ? (s(), r("g", XIt, [
        e("path", {
          d: "M88,208H39.4a7.4,7.4,0,0,1-7.4-7.4V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JIt),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QIt),
        e("path", {
          d: "M224,152v48.9a7.1,7.1,0,0,1-7.1,7.1H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YIt),
        e("path", {
          d: "M168,80h48a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oKt),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eKt),
        e("line", {
          x1: "32",
          y1: "120",
          x2: "32",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tKt)
      ])) : o(i) === "thin" ? (s(), r("g", nKt, [
        e("path", {
          d: "M88,208H39.4a7.4,7.4,0,0,1-7.4-7.4V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sKt),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rKt),
        e("path", {
          d: "M224,152v48.9a7.1,7.1,0,0,1-7.1,7.1H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iKt),
        e("path", {
          d: "M168,80h48a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lKt),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dKt),
        e("line", {
          x1: "32",
          y1: "120",
          x2: "32",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kKt)
      ])) : o(i) === "regular" ? (s(), r("g", cKt, [
        e("path", {
          d: "M88,208H39.4a7.4,7.4,0,0,1-7.4-7.4V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hKt),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uKt),
        e("path", {
          d: "M224,152v48.9a7.1,7.1,0,0,1-7.1,7.1H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aKt),
        e("path", {
          d: "M168,80h48a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Kt),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pKt),
        e("line", {
          x1: "32",
          y1: "120",
          x2: "32",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yKt)
      ])) : g("", !0)
    ], 16, ZIt));
  }
}), wKt = ["width", "height", "fill", "transform"], fKt = { key: 0 }, gKt = ["stroke"], xKt = ["stroke"], jKt = ["stroke"], mKt = ["stroke"], MKt = { key: 1 }, vKt = /* @__PURE__ */ e("path", {
  d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80Z",
  opacity: "0.2"
}, null, -1), SKt = /* @__PURE__ */ e("rect", {
  x: "152",
  y: "164",
  width: "72",
  height: "44",
  opacity: "0.2"
}, null, -1), HKt = ["stroke"], AKt = ["stroke"], VKt = ["stroke"], zKt = ["stroke"], ZKt = { key: 2 }, CKt = /* @__PURE__ */ e("path", { d: "M224,156h-8v-4a28,28,0,0,0-56,0v4h-8a8,8,0,0,0-8,8v44a8,8,0,0,0,8,8h72a8,8,0,0,0,8-8V164A8,8,0,0,0,224,156Zm-48-4a12,12,0,0,1,24,0v4H176Zm40-80H131.3L104,44.7A15.9,15.9,0,0,0,92.7,40H40A16,16,0,0,0,24,56V200.6A15.4,15.4,0,0,0,39.4,216h73.2a8,8,0,1,0,0-16H40V88H216v16a8,8,0,0,0,16,0V88A16,16,0,0,0,216,72ZM92.7,56l16,16H40V56Z" }, null, -1), bKt = [
  CKt
], LKt = { key: 3 }, BKt = ["stroke"], PKt = ["stroke"], WKt = ["stroke"], NKt = ["stroke"], FKt = { key: 4 }, TKt = ["stroke"], DKt = ["stroke"], RKt = ["stroke"], UKt = ["stroke"], qKt = { key: 5 }, GKt = ["stroke"], EKt = ["stroke"], OKt = ["stroke"], IKt = ["stroke"], KKt = {
  name: "PhFolderLock"
}, tI1 = /* @__PURE__ */ $({
  ...KKt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", fKt, [
        e("rect", {
          x: "152",
          y: "164",
          width: "72",
          height: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gKt),
        e("path", {
          d: "M104.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xKt),
        e("path", {
          d: "M168,164V148a20,20,0,0,1,40,0v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jKt),
        e("path", {
          d: "M98.4,46.7,128,80H32V52a8,8,0,0,1,8-8H92.4A8,8,0,0,1,98.4,46.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mKt)
      ])) : o(i) === "duotone" ? (s(), r("g", MKt, [
        vKt,
        SKt,
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HKt),
        e("rect", {
          x: "152",
          y: "164",
          width: "72",
          height: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AKt),
        e("path", {
          d: "M112.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VKt),
        e("path", {
          d: "M168,164V152a20,20,0,0,1,40,0v12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zKt)
      ])) : o(i) === "fill" ? (s(), r("g", ZKt, bKt)) : o(i) === "light" ? (s(), r("g", LKt, [
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BKt),
        e("rect", {
          x: "152",
          y: "164",
          width: "72",
          height: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PKt),
        e("path", {
          d: "M112.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WKt),
        e("path", {
          d: "M168,164V152a20,20,0,0,1,40,0v12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, NKt)
      ])) : o(i) === "thin" ? (s(), r("g", FKt, [
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, TKt),
        e("rect", {
          x: "152",
          y: "164",
          width: "72",
          height: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, DKt),
        e("path", {
          d: "M112.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RKt),
        e("path", {
          d: "M168,164V152a20,20,0,0,1,40,0v12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, UKt)
      ])) : o(i) === "regular" ? (s(), r("g", qKt, [
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GKt),
        e("rect", {
          x: "152",
          y: "164",
          width: "72",
          height: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EKt),
        e("path", {
          d: "M112.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OKt),
        e("path", {
          d: "M168,164V152a20,20,0,0,1,40,0v12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IKt)
      ])) : g("", !0)
    ], 16, wKt));
  }
}), XKt = ["width", "height", "fill", "transform"], JKt = { key: 0 }, QKt = ["stroke"], YKt = ["stroke"], oXt = ["stroke"], eXt = { key: 1 }, tXt = /* @__PURE__ */ e("path", {
  d: "M98.3,50.3,128,80H32V56a8,8,0,0,1,8-8H92.7A7.9,7.9,0,0,1,98.3,50.3Z",
  opacity: "0.2"
}, null, -1), nXt = ["stroke"], sXt = ["stroke"], rXt = ["stroke"], iXt = { key: 2 }, lXt = /* @__PURE__ */ e("path", { d: "M216,72H131.3L104,44.7A16.1,16.1,0,0,0,92.7,40H40A16,16,0,0,0,24,56V200.6A15.4,15.4,0,0,0,39.4,216H216.9A15.2,15.2,0,0,0,232,200.9V88A16,16,0,0,0,216,72ZM40,56H92.7l16,16H40Zm112,96H104a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Z" }, null, -1), dXt = [
  lXt
], kXt = { key: 3 }, cXt = ["stroke"], hXt = ["stroke"], uXt = ["stroke"], aXt = { key: 4 }, _Xt = ["stroke"], pXt = ["stroke"], yXt = ["stroke"], $Xt = { key: 5 }, wXt = ["stroke"], fXt = ["stroke"], gXt = ["stroke"], xXt = {
  name: "PhFolderMinus"
}, nI1 = /* @__PURE__ */ $({
  ...xXt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", JKt, [
        e("path", {
          d: "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, QKt),
        e("path", {
          d: "M32,80V52a8,8,0,0,1,8-8H92.4a8,8,0,0,1,6,2.7L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, YKt),
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oXt)
      ])) : o(i) === "duotone" ? (s(), r("g", eXt, [
        tXt,
        e("path", {
          d: "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nXt),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sXt),
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rXt)
      ])) : o(i) === "fill" ? (s(), r("g", iXt, dXt)) : o(i) === "light" ? (s(), r("g", kXt, [
        e("path", {
          d: "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cXt),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hXt),
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uXt)
      ])) : o(i) === "thin" ? (s(), r("g", aXt, [
        e("path", {
          d: "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _Xt),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pXt),
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yXt)
      ])) : o(i) === "regular" ? (s(), r("g", $Xt, [
        e("path", {
          d: "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wXt),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fXt),
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gXt)
      ])) : g("", !0)
    ], 16, XKt));
  }
}), jXt = ["width", "height", "fill", "transform"], mXt = { key: 0 }, MXt = ["stroke"], vXt = ["stroke"], SXt = { key: 1 }, HXt = /* @__PURE__ */ e("path", {
  d: "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
  opacity: "0.2"
}, null, -1), AXt = ["stroke"], VXt = ["stroke"], zXt = { key: 2 }, ZXt = /* @__PURE__ */ e("path", { d: "M216,72H130.7L102.9,51.2A15.6,15.6,0,0,0,93.3,48H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V88A16,16,0,0,0,216,72ZM40,64H93.3l21.4,16L93.3,96H40Z" }, null, -1), CXt = [
  ZXt
], bXt = { key: 3 }, LXt = ["stroke"], BXt = ["stroke"], PXt = { key: 4 }, WXt = ["stroke"], NXt = ["stroke"], FXt = { key: 5 }, TXt = ["stroke"], DXt = ["stroke"], RXt = {
  name: "PhFolderNotch"
}, sI1 = /* @__PURE__ */ $({
  ...RXt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", mXt, [
        e("path", {
          d: "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MXt),
        e("path", {
          d: "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vXt)
      ])) : o(i) === "duotone" ? (s(), r("g", SXt, [
        HXt,
        e("path", {
          d: "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AXt),
        e("path", {
          d: "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VXt)
      ])) : o(i) === "fill" ? (s(), r("g", zXt, CXt)) : o(i) === "light" ? (s(), r("g", bXt, [
        e("path", {
          d: "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LXt),
        e("path", {
          d: "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BXt)
      ])) : o(i) === "thin" ? (s(), r("g", PXt, [
        e("path", {
          d: "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WXt),
        e("path", {
          d: "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, NXt)
      ])) : o(i) === "regular" ? (s(), r("g", FXt, [
        e("path", {
          d: "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TXt),
        e("path", {
          d: "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DXt)
      ])) : g("", !0)
    ], 16, jXt));
  }
}), UXt = ["width", "height", "fill", "transform"], qXt = { key: 0 }, GXt = ["stroke"], EXt = ["stroke"], OXt = ["stroke"], IXt = { key: 1 }, KXt = /* @__PURE__ */ e("path", {
  d: "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
  opacity: "0.2"
}, null, -1), XXt = ["stroke"], JXt = ["stroke"], QXt = ["stroke"], YXt = { key: 2 }, oJt = /* @__PURE__ */ e("path", { d: "M216,72H130.7L102.9,51.2A15.6,15.6,0,0,0,93.3,48H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V88A16,16,0,0,0,216,72ZM40,96V64H93.3l21.4,16L93.3,96Zm112,60H104a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Z" }, null, -1), eJt = [
  oJt
], tJt = { key: 3 }, nJt = ["stroke"], sJt = ["stroke"], rJt = ["stroke"], iJt = { key: 4 }, lJt = ["stroke"], dJt = ["stroke"], kJt = ["stroke"], cJt = { key: 5 }, hJt = ["stroke"], uJt = ["stroke"], aJt = ["stroke"], _Jt = {
  name: "PhFolderNotchMinus"
}, rI1 = /* @__PURE__ */ $({
  ..._Jt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", qXt, [
        e("path", {
          d: "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GXt),
        e("path", {
          d: "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, EXt),
        e("line", {
          x1: "104",
          y1: "148",
          x2: "152",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OXt)
      ])) : o(i) === "duotone" ? (s(), r("g", IXt, [
        KXt,
        e("path", {
          d: "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XXt),
        e("path", {
          d: "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JXt),
        e("line", {
          x1: "104",
          y1: "148",
          x2: "152",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QXt)
      ])) : o(i) === "fill" ? (s(), r("g", YXt, eJt)) : o(i) === "light" ? (s(), r("g", tJt, [
        e("path", {
          d: "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nJt),
        e("path", {
          d: "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sJt),
        e("line", {
          x1: "104",
          y1: "148",
          x2: "152",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rJt)
      ])) : o(i) === "thin" ? (s(), r("g", iJt, [
        e("path", {
          d: "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lJt),
        e("path", {
          d: "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dJt),
        e("line", {
          x1: "104",
          y1: "148",
          x2: "152",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kJt)
      ])) : o(i) === "regular" ? (s(), r("g", cJt, [
        e("path", {
          d: "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hJt),
        e("path", {
          d: "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uJt),
        e("line", {
          x1: "104",
          y1: "148",
          x2: "152",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aJt)
      ])) : g("", !0)
    ], 16, UXt));
  }
}), pJt = ["width", "height", "fill", "transform"], yJt = { key: 0 }, $Jt = ["stroke"], wJt = ["stroke"], fJt = { key: 1 }, gJt = /* @__PURE__ */ e("path", {
  d: "M69.4,128h48.2a8.4,8.4,0,0,0,4.4-1.3l20-13.4a8.4,8.4,0,0,1,4.4-1.3H208V88a8,8,0,0,0-8-8H130.7a8.1,8.1,0,0,1-4.8-1.6L98.1,57.6A8.1,8.1,0,0,0,93.3,56H40a8,8,0,0,0-8,8V208l30-75A7.9,7.9,0,0,1,69.4,128Z",
  opacity: "0.2"
}, null, -1), xJt = ["stroke"], jJt = ["stroke"], mJt = { key: 2 }, MJt = /* @__PURE__ */ e("path", { d: "M241.9,110.6a16.2,16.2,0,0,0-13-6.6H216V88a16,16,0,0,0-16-16H130.7L102.9,51.2A15.6,15.6,0,0,0,93.3,48H40A16,16,0,0,0,24,64V208h0a8.2,8.2,0,0,0,1.4,4.5A7.9,7.9,0,0,0,32,216H208a8,8,0,0,0,7.6-5.5l28.5-85.4A16.3,16.3,0,0,0,241.9,110.6ZM93.3,64l27.8,20.8a15.6,15.6,0,0,0,9.6,3.2H200v16H146.4a16,16,0,0,0-8.9,2.7L117.6,120H69.4a15.7,15.7,0,0,0-14.8,10.1L40,166.5V64Z" }, null, -1), vJt = [
  MJt
], SJt = { key: 3 }, HJt = ["stroke"], AJt = ["stroke"], VJt = { key: 4 }, zJt = ["stroke"], ZJt = ["stroke"], CJt = { key: 5 }, bJt = ["stroke"], LJt = ["stroke"], BJt = {
  name: "PhFolderNotchOpen"
}, iI1 = /* @__PURE__ */ $({
  ...BJt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", yJt, [
        e("path", {
          d: "M32,208V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $Jt),
        e("path", {
          d: "M32,208l29.9-71.1a8.1,8.1,0,0,1,7.4-4.9h48.3a8.4,8.4,0,0,0,4.4-1.3l20-13.4a8.4,8.4,0,0,1,4.4-1.3h82.3a8,8,0,0,1,7.6,10.6L208,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wJt)
      ])) : o(i) === "duotone" ? (s(), r("g", fJt, [
        gJt,
        e("path", {
          d: "M32,208V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xJt),
        e("path", {
          d: "M32,208l30-75a7.9,7.9,0,0,1,7.4-5h48.2a8.4,8.4,0,0,0,4.4-1.3l20-13.4a8.4,8.4,0,0,1,4.4-1.3h82.5a8,8,0,0,1,7.6,10.5L208,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jJt)
      ])) : o(i) === "fill" ? (s(), r("g", mJt, vJt)) : o(i) === "light" ? (s(), r("g", SJt, [
        e("path", {
          d: "M32,208V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HJt),
        e("path", {
          d: "M32,208l30-75a7.9,7.9,0,0,1,7.4-5h48.2a8.4,8.4,0,0,0,4.4-1.3l20-13.4a8.4,8.4,0,0,1,4.4-1.3h82.5a8,8,0,0,1,7.6,10.5L208,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, AJt)
      ])) : o(i) === "thin" ? (s(), r("g", VJt, [
        e("path", {
          d: "M32,208V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zJt),
        e("path", {
          d: "M32,208l30-75a7.9,7.9,0,0,1,7.4-5h48.2a8.4,8.4,0,0,0,4.4-1.3l20-13.4a8.4,8.4,0,0,1,4.4-1.3h82.5a8,8,0,0,1,7.6,10.5L208,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZJt)
      ])) : o(i) === "regular" ? (s(), r("g", CJt, [
        e("path", {
          d: "M32,208V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bJt),
        e("path", {
          d: "M32,208l30-75a7.9,7.9,0,0,1,7.4-5h48.2a8.4,8.4,0,0,0,4.4-1.3l20-13.4a8.4,8.4,0,0,1,4.4-1.3h82.5a8,8,0,0,1,7.6,10.5L208,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LJt)
      ])) : g("", !0)
    ], 16, pJt));
  }
}), PJt = ["width", "height", "fill", "transform"], WJt = { key: 0 }, NJt = ["stroke"], FJt = ["stroke"], TJt = ["stroke"], DJt = ["stroke"], RJt = { key: 1 }, UJt = /* @__PURE__ */ e("path", {
  d: "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
  opacity: "0.2"
}, null, -1), qJt = ["stroke"], GJt = ["stroke"], EJt = ["stroke"], OJt = ["stroke"], IJt = { key: 2 }, KJt = /* @__PURE__ */ e("path", { d: "M216,72H130.7L102.9,51.2A15.6,15.6,0,0,0,93.3,48H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V88A16,16,0,0,0,216,72ZM40,96V64H93.3l21.4,16L93.3,96Zm112,60H136v16a8,8,0,0,1-16,0V156H104a8,8,0,0,1,0-16h16V124a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Z" }, null, -1), XJt = [
  KJt
], JJt = { key: 3 }, QJt = ["stroke"], YJt = ["stroke"], oQt = ["stroke"], eQt = ["stroke"], tQt = { key: 4 }, nQt = ["stroke"], sQt = ["stroke"], rQt = ["stroke"], iQt = ["stroke"], lQt = { key: 5 }, dQt = ["stroke"], kQt = ["stroke"], cQt = ["stroke"], hQt = ["stroke"], uQt = {
  name: "PhFolderNotchPlus"
}, lI1 = /* @__PURE__ */ $({
  ...uQt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", WJt, [
        e("path", {
          d: "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NJt),
        e("path", {
          d: "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FJt),
        e("line", {
          x1: "104",
          y1: "148",
          x2: "152",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TJt),
        e("line", {
          x1: "128",
          y1: "124",
          x2: "128",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DJt)
      ])) : o(i) === "duotone" ? (s(), r("g", RJt, [
        UJt,
        e("path", {
          d: "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qJt),
        e("path", {
          d: "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GJt),
        e("line", {
          x1: "104",
          y1: "148",
          x2: "152",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EJt),
        e("line", {
          x1: "128",
          y1: "124",
          x2: "128",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OJt)
      ])) : o(i) === "fill" ? (s(), r("g", IJt, XJt)) : o(i) === "light" ? (s(), r("g", JJt, [
        e("path", {
          d: "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QJt),
        e("path", {
          d: "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YJt),
        e("line", {
          x1: "104",
          y1: "148",
          x2: "152",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oQt),
        e("line", {
          x1: "128",
          y1: "124",
          x2: "128",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eQt)
      ])) : o(i) === "thin" ? (s(), r("g", tQt, [
        e("path", {
          d: "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nQt),
        e("path", {
          d: "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sQt),
        e("line", {
          x1: "104",
          y1: "148",
          x2: "152",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rQt),
        e("line", {
          x1: "128",
          y1: "124",
          x2: "128",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iQt)
      ])) : o(i) === "regular" ? (s(), r("g", lQt, [
        e("path", {
          d: "M128,80h88a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dQt),
        e("path", {
          d: "M93.3,104H32V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80,98.1,102.4A8.1,8.1,0,0,1,93.3,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kQt),
        e("line", {
          x1: "104",
          y1: "148",
          x2: "152",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cQt),
        e("line", {
          x1: "128",
          y1: "124",
          x2: "128",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hQt)
      ])) : g("", !0)
    ], 16, PJt));
  }
}), aQt = ["width", "height", "fill", "transform"], _Qt = { key: 0 }, pQt = ["stroke"], yQt = ["stroke"], $Qt = { key: 1 }, wQt = /* @__PURE__ */ e("path", {
  d: "M32,208l30.2-90.5a8,8,0,0,1,7.6-5.5H208V88a8,8,0,0,0-8-8H130.7a8.1,8.1,0,0,1-4.8-1.6L98.1,57.6A8.1,8.1,0,0,0,93.3,56H40a8,8,0,0,0-8,8Z",
  opacity: "0.2"
}, null, -1), fQt = ["stroke"], gQt = ["stroke"], xQt = { key: 2 }, jQt = /* @__PURE__ */ e("path", { d: "M241.9,110.6a16.2,16.2,0,0,0-13-6.6H216V88a16,16,0,0,0-16-16H130.7L102.9,51.2A15.6,15.6,0,0,0,93.3,48H40A16,16,0,0,0,24,64V208h0a7.9,7.9,0,0,0,8,8H208a8,8,0,0,0,7.6-5.5l28.5-85.4A16.3,16.3,0,0,0,241.9,110.6ZM93.3,64l27.8,20.8a15.6,15.6,0,0,0,9.6,3.2H200v16H69.8a16,16,0,0,0-15.2,10.9L40,158.7V64Z" }, null, -1), mQt = [
  jQt
], MQt = { key: 3 }, vQt = ["stroke"], SQt = ["stroke"], HQt = { key: 4 }, AQt = ["stroke"], VQt = ["stroke"], zQt = { key: 5 }, ZQt = ["stroke"], CQt = ["stroke"], bQt = {
  name: "PhFolderOpen"
}, dI1 = /* @__PURE__ */ $({
  ...bQt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", _Qt, [
        e("path", {
          d: "M32,208V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pQt),
        e("path", {
          d: "M32,208l30.1-86.6a8.2,8.2,0,0,1,7.6-5.4h159a8,8,0,0,1,7.6,10.6L208,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yQt)
      ])) : o(i) === "duotone" ? (s(), r("g", $Qt, [
        wQt,
        e("path", {
          d: "M32,208V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fQt),
        e("path", {
          d: "M32,208l30.2-90.5a8,8,0,0,1,7.6-5.5H228.9a8,8,0,0,1,7.6,10.5L208,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gQt)
      ])) : o(i) === "fill" ? (s(), r("g", xQt, mQt)) : o(i) === "light" ? (s(), r("g", MQt, [
        e("path", {
          d: "M32,208V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vQt),
        e("path", {
          d: "M32,208l30.2-90.5a8,8,0,0,1,7.6-5.5H228.9a8,8,0,0,1,7.6,10.5L208,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, SQt)
      ])) : o(i) === "thin" ? (s(), r("g", HQt, [
        e("path", {
          d: "M32,208V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, AQt),
        e("path", {
          d: "M32,208l30.2-90.5a8,8,0,0,1,7.6-5.5H228.9a8,8,0,0,1,7.6,10.5L208,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VQt)
      ])) : o(i) === "regular" ? (s(), r("g", zQt, [
        e("path", {
          d: "M32,208V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H200a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZQt),
        e("path", {
          d: "M32,208l30.2-90.5a8,8,0,0,1,7.6-5.5H228.9a8,8,0,0,1,7.6,10.5L208,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CQt)
      ])) : g("", !0)
    ], 16, aQt));
  }
}), LQt = ["width", "height", "fill", "transform"], BQt = { key: 0 }, PQt = ["stroke"], WQt = ["stroke"], NQt = ["stroke"], FQt = ["stroke"], TQt = { key: 1 }, DQt = /* @__PURE__ */ e("path", {
  d: "M98.3,50.3,128,80H32V56a8,8,0,0,1,8-8H92.7A7.9,7.9,0,0,1,98.3,50.3Z",
  opacity: "0.2"
}, null, -1), RQt = ["stroke"], UQt = ["stroke"], qQt = ["stroke"], GQt = ["stroke"], EQt = { key: 2 }, OQt = /* @__PURE__ */ e("path", { d: "M216,72H131.3L104,44.7A16.1,16.1,0,0,0,92.7,40H40A16,16,0,0,0,24,56V200.6A15.4,15.4,0,0,0,39.4,216H216.9A15.2,15.2,0,0,0,232,200.9V88A16,16,0,0,0,216,72ZM40,56H92.7l16,16H40Zm112,96H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Z" }, null, -1), IQt = [
  OQt
], KQt = { key: 3 }, XQt = ["stroke"], JQt = ["stroke"], QQt = ["stroke"], YQt = ["stroke"], oYt = { key: 4 }, eYt = ["stroke"], tYt = ["stroke"], nYt = ["stroke"], sYt = ["stroke"], rYt = { key: 5 }, iYt = ["stroke"], lYt = ["stroke"], dYt = ["stroke"], kYt = ["stroke"], cYt = {
  name: "PhFolderPlus"
}, kI1 = /* @__PURE__ */ $({
  ...cYt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", BQt, [
        e("path", {
          d: "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PQt),
        e("path", {
          d: "M32,80V52a8,8,0,0,1,8-8H92.4a8,8,0,0,1,6,2.7L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WQt),
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NQt),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FQt)
      ])) : o(i) === "duotone" ? (s(), r("g", TQt, [
        DQt,
        e("path", {
          d: "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RQt),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UQt),
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qQt),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GQt)
      ])) : o(i) === "fill" ? (s(), r("g", EQt, IQt)) : o(i) === "light" ? (s(), r("g", KQt, [
        e("path", {
          d: "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XQt),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JQt),
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QQt),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YQt)
      ])) : o(i) === "thin" ? (s(), r("g", oYt, [
        e("path", {
          d: "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eYt),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tYt),
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nYt),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sYt)
      ])) : o(i) === "regular" ? (s(), r("g", rYt, [
        e("path", {
          d: "M216.9,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8V200.9A7.1,7.1,0,0,1,216.9,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iYt),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lYt),
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dYt),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kYt)
      ])) : g("", !0)
    ], 16, LQt));
  }
}), hYt = ["width", "height", "fill", "transform"], uYt = { key: 0 }, aYt = ["stroke"], _Yt = { key: 1 }, pYt = /* @__PURE__ */ e("path", {
  d: "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
  opacity: "0.2"
}, null, -1), yYt = ["stroke"], $Yt = { key: 2 }, wYt = /* @__PURE__ */ e("path", { d: "M216,72H130.7L102.9,51.2A15.6,15.6,0,0,0,93.3,48H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16H216.9A15.2,15.2,0,0,0,232,200.9V88A16,16,0,0,0,216,72Z" }, null, -1), fYt = [
  wYt
], gYt = { key: 3 }, xYt = ["stroke"], jYt = { key: 4 }, mYt = ["stroke"], MYt = { key: 5 }, vYt = ["stroke"], SYt = {
  name: "PhFolderSimple"
}, cI1 = /* @__PURE__ */ $({
  ...SYt,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", uYt, [
        e("path", {
          d: "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aYt)
      ])) : o(i) === "duotone" ? (s(), r("g", _Yt, [
        pYt,
        e("path", {
          d: "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yYt)
      ])) : o(i) === "fill" ? (s(), r("g", $Yt, fYt)) : o(i) === "light" ? (s(), r("g", gYt, [
        e("path", {
          d: "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xYt)
      ])) : o(i) === "thin" ? (s(), r("g", jYt, [
        e("path", {
          d: "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mYt)
      ])) : o(i) === "regular" ? (s(), r("g", MYt, [
        e("path", {
          d: "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vYt)
      ])) : g("", !0)
    ], 16, hYt));
  }
}), HYt = ["width", "height", "fill", "transform"], AYt = { key: 0 }, VYt = ["stroke"], zYt = ["stroke"], ZYt = ["stroke"], CYt = ["stroke"], bYt = ["stroke"], LYt = ["stroke"], BYt = { key: 1 }, PYt = /* @__PURE__ */ e("path", {
  d: "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
  opacity: "0.2"
}, null, -1), WYt = ["stroke"], NYt = ["stroke"], FYt = ["stroke"], TYt = ["stroke"], DYt = ["stroke"], RYt = ["stroke"], UYt = { key: 2 }, qYt = /* @__PURE__ */ e("path", { d: "M24,80V64A16,16,0,0,1,40,48H93.3a15.6,15.6,0,0,1,9.6,3.2l29.9,22.4A8,8,0,0,1,128,88a7.7,7.7,0,0,1-4.8-1.6L93.3,64H40V80a8,8,0,0,1-16,0ZM88,200H40v-8a8,8,0,0,0-16,0v8.6A15.4,15.4,0,0,0,39.4,216H88a8,8,0,0,0,0-16Zm72,0H128a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm64-56a8,8,0,0,0-8,8v48H200a8,8,0,0,0,0,16h16.9A15.2,15.2,0,0,0,232,200.9V152A8,8,0,0,0,224,144Zm-8-72H168a8,8,0,0,0,0,16h48v24a8,8,0,0,0,16,0V88A16,16,0,0,0,216,72ZM32,160a8,8,0,0,0,8-8V120a8,8,0,0,0-16,0v32A8,8,0,0,0,32,160Z" }, null, -1), GYt = [
  qYt
], EYt = { key: 3 }, OYt = ["stroke"], IYt = ["stroke"], KYt = ["stroke"], XYt = ["stroke"], JYt = ["stroke"], QYt = ["stroke"], YYt = { key: 4 }, oon = ["stroke"], eon = ["stroke"], ton = ["stroke"], non = ["stroke"], son = ["stroke"], ron = ["stroke"], ion = { key: 5 }, lon = ["stroke"], don = ["stroke"], kon = ["stroke"], con = ["stroke"], hon = ["stroke"], uon = ["stroke"], aon = {
  name: "PhFolderSimpleDotted"
}, hI1 = /* @__PURE__ */ $({
  ...aon,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", AYt, [
        e("path", {
          d: "M32,80V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VYt),
        e("path", {
          d: "M88,208H39.4a7.4,7.4,0,0,1-7.4-7.4V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zYt),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZYt),
        e("path", {
          d: "M224,152v48.9a7.1,7.1,0,0,1-7.1,7.1H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CYt),
        e("path", {
          d: "M168,80h48a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bYt),
        e("line", {
          x1: "32",
          y1: "120",
          x2: "32",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LYt)
      ])) : o(i) === "duotone" ? (s(), r("g", BYt, [
        PYt,
        e("path", {
          d: "M32,80V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WYt),
        e("path", {
          d: "M88,208H39.4a7.4,7.4,0,0,1-7.4-7.4V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NYt),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FYt),
        e("path", {
          d: "M224,152v48.9a7.1,7.1,0,0,1-7.1,7.1H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TYt),
        e("path", {
          d: "M168,80h48a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DYt),
        e("line", {
          x1: "32",
          y1: "120",
          x2: "32",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RYt)
      ])) : o(i) === "fill" ? (s(), r("g", UYt, GYt)) : o(i) === "light" ? (s(), r("g", EYt, [
        e("path", {
          d: "M32,80V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OYt),
        e("path", {
          d: "M88,208H39.4a7.4,7.4,0,0,1-7.4-7.4V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IYt),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KYt),
        e("path", {
          d: "M224,152v48.9a7.1,7.1,0,0,1-7.1,7.1H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XYt),
        e("path", {
          d: "M168,80h48a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JYt),
        e("line", {
          x1: "32",
          y1: "120",
          x2: "32",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QYt)
      ])) : o(i) === "thin" ? (s(), r("g", YYt, [
        e("path", {
          d: "M32,80V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oon),
        e("path", {
          d: "M88,208H39.4a7.4,7.4,0,0,1-7.4-7.4V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eon),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ton),
        e("path", {
          d: "M224,152v48.9a7.1,7.1,0,0,1-7.1,7.1H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, non),
        e("path", {
          d: "M168,80h48a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, son),
        e("line", {
          x1: "32",
          y1: "120",
          x2: "32",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ron)
      ])) : o(i) === "regular" ? (s(), r("g", ion, [
        e("path", {
          d: "M32,80V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lon),
        e("path", {
          d: "M88,208H39.4a7.4,7.4,0,0,1-7.4-7.4V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, don),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kon),
        e("path", {
          d: "M224,152v48.9a7.1,7.1,0,0,1-7.1,7.1H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, con),
        e("path", {
          d: "M168,80h48a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hon),
        e("line", {
          x1: "32",
          y1: "120",
          x2: "32",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uon)
      ])) : g("", !0)
    ], 16, HYt));
  }
}), _on = ["width", "height", "fill", "transform"], pon = { key: 0 }, yon = ["stroke"], $on = ["stroke"], won = ["stroke"], fon = { key: 1 }, gon = ["stroke"], xon = /* @__PURE__ */ e("rect", {
  x: "152",
  y: "164",
  width: "72",
  height: "44",
  opacity: "0.2"
}, null, -1), jon = ["stroke"], mon = ["stroke"], Mon = { key: 2 }, von = /* @__PURE__ */ e("path", { d: "M232,88v16a8,8,0,0,1-16,0V88H130.7a15.6,15.6,0,0,1-9.6-3.2L93.3,64H40V200h72a8,8,0,0,1,0,16H40a16,16,0,0,1-16-16V64A16,16,0,0,1,40,48H93.3a15.6,15.6,0,0,1,9.6,3.2L130.7,72H216A16,16,0,0,1,232,88Zm0,76v44a8,8,0,0,1-8,8H152a8,8,0,0,1-8-8V164a8,8,0,0,1,8-8h8v-4a28,28,0,0,1,56,0v4h8A8,8,0,0,1,232,164Zm-32-12a12,12,0,0,0-24,0v4h24Z" }, null, -1), Son = [
  von
], Hon = { key: 3 }, Aon = ["stroke"], Von = ["stroke"], zon = ["stroke"], Zon = { key: 4 }, Con = ["stroke"], bon = ["stroke"], Lon = ["stroke"], Bon = { key: 5 }, Pon = ["stroke"], Won = ["stroke"], Non = ["stroke"], Fon = {
  name: "PhFolderSimpleLock"
}, uI1 = /* @__PURE__ */ $({
  ...Fon,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", pon, [
        e("path", {
          d: "M104,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yon),
        e("rect", {
          x: "152",
          y: "164",
          width: "72",
          height: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $on),
        e("path", {
          d: "M168,164V148a20,20,0,0,1,40,0v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, won)
      ])) : o(i) === "duotone" ? (s(), r("g", fon, [
        e("path", {
          d: "M112,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gon),
        xon,
        e("rect", {
          x: "152",
          y: "164",
          width: "72",
          height: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jon),
        e("path", {
          d: "M168,164V152a20,20,0,0,1,40,0v12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mon)
      ])) : o(i) === "fill" ? (s(), r("g", Mon, Son)) : o(i) === "light" ? (s(), r("g", Hon, [
        e("path", {
          d: "M112,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Aon),
        e("rect", {
          x: "152",
          y: "164",
          width: "72",
          height: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Von),
        e("path", {
          d: "M168,164V152a20,20,0,0,1,40,0v12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zon)
      ])) : o(i) === "thin" ? (s(), r("g", Zon, [
        e("path", {
          d: "M112,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Con),
        e("rect", {
          x: "152",
          y: "164",
          width: "72",
          height: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bon),
        e("path", {
          d: "M168,164V152a20,20,0,0,1,40,0v12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lon)
      ])) : o(i) === "regular" ? (s(), r("g", Bon, [
        e("path", {
          d: "M112,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pon),
        e("rect", {
          x: "152",
          y: "164",
          width: "72",
          height: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Won),
        e("path", {
          d: "M168,164V152a20,20,0,0,1,40,0v12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Non)
      ])) : g("", !0)
    ], 16, _on));
  }
}), Ton = ["width", "height", "fill", "transform"], Don = { key: 0 }, Ron = ["stroke"], Uon = ["stroke"], qon = { key: 1 }, Gon = /* @__PURE__ */ e("path", {
  d: "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
  opacity: "0.2"
}, null, -1), Eon = ["stroke"], Oon = ["stroke"], Ion = { key: 2 }, Kon = /* @__PURE__ */ e("path", { d: "M216,72H130.7L102.9,51.2A15.6,15.6,0,0,0,93.3,48H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16H216.9A15.2,15.2,0,0,0,232,200.9V88A16,16,0,0,0,216,72Zm-64,80H104a8,8,0,0,1,0-16h48a8,8,0,0,1,0,16Z" }, null, -1), Xon = [
  Kon
], Jon = { key: 3 }, Qon = ["stroke"], Yon = ["stroke"], oen = { key: 4 }, een = ["stroke"], ten = ["stroke"], nen = { key: 5 }, sen = ["stroke"], ren = ["stroke"], ien = {
  name: "PhFolderSimpleMinus"
}, aI1 = /* @__PURE__ */ $({
  ...ien,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Don, [
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ron),
        e("path", {
          d: "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Uon)
      ])) : o(i) === "duotone" ? (s(), r("g", qon, [
        Gon,
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Eon),
        e("path", {
          d: "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Oon)
      ])) : o(i) === "fill" ? (s(), r("g", Ion, Xon)) : o(i) === "light" ? (s(), r("g", Jon, [
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qon),
        e("path", {
          d: "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Yon)
      ])) : o(i) === "thin" ? (s(), r("g", oen, [
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, een),
        e("path", {
          d: "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ten)
      ])) : o(i) === "regular" ? (s(), r("g", nen, [
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sen),
        e("path", {
          d: "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ren)
      ])) : g("", !0)
    ], 16, Ton));
  }
}), len = ["width", "height", "fill", "transform"], den = { key: 0 }, ken = ["stroke"], cen = ["stroke"], hen = ["stroke"], uen = { key: 1 }, aen = /* @__PURE__ */ e("path", {
  d: "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
  opacity: "0.2"
}, null, -1), _en = ["stroke"], pen = ["stroke"], yen = ["stroke"], $en = { key: 2 }, wen = /* @__PURE__ */ e("path", { d: "M216,72H130.7L102.9,51.2A15.6,15.6,0,0,0,93.3,48H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16H216.9A15.2,15.2,0,0,0,232,200.9V88A16,16,0,0,0,216,72Zm-64,80H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16Z" }, null, -1), fen = [
  wen
], gen = { key: 3 }, xen = ["stroke"], jen = ["stroke"], men = ["stroke"], Men = { key: 4 }, ven = ["stroke"], Sen = ["stroke"], Hen = ["stroke"], Aen = { key: 5 }, Ven = ["stroke"], zen = ["stroke"], Zen = ["stroke"], Cen = {
  name: "PhFolderSimplePlus"
}, _I1 = /* @__PURE__ */ $({
  ...Cen,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", den, [
        e("path", {
          d: "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ken),
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cen),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hen)
      ])) : o(i) === "duotone" ? (s(), r("g", uen, [
        aen,
        e("path", {
          d: "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _en),
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pen),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yen)
      ])) : o(i) === "fill" ? (s(), r("g", $en, fen)) : o(i) === "light" ? (s(), r("g", gen, [
        e("path", {
          d: "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xen),
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jen),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, men)
      ])) : o(i) === "thin" ? (s(), r("g", Men, [
        e("path", {
          d: "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ven),
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Sen),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hen)
      ])) : o(i) === "regular" ? (s(), r("g", Aen, [
        e("path", {
          d: "M224,88V200.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216A8,8,0,0,1,224,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ven),
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zen),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zen)
      ])) : g("", !0)
    ], 16, len));
  }
}), ben = ["width", "height", "fill", "transform"], Len = { key: 0 }, Ben = ["stroke"], Pen = ["stroke"], Wen = { key: 1 }, Nen = /* @__PURE__ */ e("polygon", {
  points: "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
  opacity: "0.2"
}, null, -1), Fen = ["stroke"], Ten = ["stroke"], Den = { key: 2 }, Ren = /* @__PURE__ */ e("path", { d: "M40,64V200h80a8,8,0,0,1,0,16H40a16,16,0,0,1-16-16V64A16,16,0,0,1,40,48H93.3a15.6,15.6,0,0,1,9.6,3.2L130.7,72H216a16,16,0,0,1,16,16v32a8,8,0,0,1-16,0V88H130.7a15.6,15.6,0,0,1-9.6-3.2L93.3,64Zm203.6,95.2a8.1,8.1,0,0,0-7-5.6l-29.8-2.3-11.5-26.5a8,8,0,0,0-14.6,0l-11.5,26.5-29.8,2.3a8.1,8.1,0,0,0-4.5,14.2l22.5,18.6-6.8,27.7a7.9,7.9,0,0,0,3,8.3,8,8,0,0,0,8.8.5L188,207.8l25.6,15.1a8.7,8.7,0,0,0,4.1,1.1,7.4,7.4,0,0,0,4.7-1.6,7.9,7.9,0,0,0,3-8.3l-6.8-27.7,22.5-18.6A8,8,0,0,0,243.6,159.2Z" }, null, -1), Uen = [
  Ren
], qen = { key: 3 }, Gen = ["stroke"], Een = ["stroke"], Oen = { key: 4 }, Ien = ["stroke"], Ken = ["stroke"], Xen = { key: 5 }, Jen = ["stroke"], Qen = ["stroke"], Yen = {
  name: "PhFolderSimpleStar"
}, pI1 = /* @__PURE__ */ $({
  ...Yen,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Len, [
        e("path", {
          d: "M112,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ben),
        e("polygon", {
          points: "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pen)
      ])) : o(i) === "duotone" ? (s(), r("g", Wen, [
        Nen,
        e("path", {
          d: "M120,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fen),
        e("polygon", {
          points: "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ten)
      ])) : o(i) === "fill" ? (s(), r("g", Den, Uen)) : o(i) === "light" ? (s(), r("g", qen, [
        e("path", {
          d: "M120,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gen),
        e("polygon", {
          points: "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Een)
      ])) : o(i) === "thin" ? (s(), r("g", Oen, [
        e("path", {
          d: "M120,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ien),
        e("polygon", {
          points: "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ken)
      ])) : o(i) === "regular" ? (s(), r("g", Xen, [
        e("path", {
          d: "M120,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jen),
        e("polygon", {
          points: "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qen)
      ])) : g("", !0)
    ], 16, ben));
  }
}), otn = ["width", "height", "fill", "transform"], etn = { key: 0 }, ttn = ["stroke"], ntn = ["stroke"], stn = ["stroke"], rtn = { key: 1 }, itn = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "172",
  r: "24",
  opacity: "0.2"
}, null, -1), ltn = ["stroke"], dtn = ["stroke"], ktn = ["stroke"], ctn = { key: 2 }, htn = /* @__PURE__ */ e("path", { d: "M226.7,218a8,8,0,0,1-7.7,10H157a8,8,0,0,1-7.7-10,40.2,40.2,0,0,1,16.3-23.2,32,32,0,1,1,44.8,0A40.2,40.2,0,0,1,226.7,218ZM216,72H130.7L102.9,51.2A15.6,15.6,0,0,0,93.3,48H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16h80a8,8,0,0,0,0-16H40V64H93.3l27.8,20.8a15.6,15.6,0,0,0,9.6,3.2H216v32a8,8,0,0,0,16,0V88A16,16,0,0,0,216,72Z" }, null, -1), utn = [
  htn
], atn = { key: 3 }, _tn = ["stroke"], ptn = ["stroke"], ytn = ["stroke"], $tn = { key: 4 }, wtn = ["stroke"], ftn = ["stroke"], gtn = ["stroke"], xtn = { key: 5 }, jtn = ["stroke"], mtn = ["stroke"], Mtn = ["stroke"], vtn = {
  name: "PhFolderSimpleUser"
}, yI1 = /* @__PURE__ */ $({
  ...vtn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", etn, [
        e("circle", {
          cx: "188",
          cy: "172",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ttn),
        e("path", {
          d: "M157,220a32,32,0,0,1,62,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ntn),
        e("path", {
          d: "M112,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, stn)
      ])) : o(i) === "duotone" ? (s(), r("g", rtn, [
        itn,
        e("circle", {
          cx: "188",
          cy: "172",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ltn),
        e("path", {
          d: "M157,220a32,32,0,0,1,62,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dtn),
        e("path", {
          d: "M120,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ktn)
      ])) : o(i) === "fill" ? (s(), r("g", ctn, utn)) : o(i) === "light" ? (s(), r("g", atn, [
        e("circle", {
          cx: "188",
          cy: "172",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _tn),
        e("path", {
          d: "M157,220a32,32,0,0,1,62,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ptn),
        e("path", {
          d: "M120,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ytn)
      ])) : o(i) === "thin" ? (s(), r("g", $tn, [
        e("circle", {
          cx: "188",
          cy: "172",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wtn),
        e("path", {
          d: "M157,220a32,32,0,0,1,62,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ftn),
        e("path", {
          d: "M120,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gtn)
      ])) : o(i) === "regular" ? (s(), r("g", xtn, [
        e("circle", {
          cx: "188",
          cy: "172",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jtn),
        e("path", {
          d: "M157,220a32,32,0,0,1,62,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mtn),
        e("path", {
          d: "M120,208H40a8,8,0,0,1-8-8V64a8,8,0,0,1,8-8H93.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H216a8,8,0,0,1,8,8v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mtn)
      ])) : g("", !0)
    ], 16, otn));
  }
}), Stn = ["width", "height", "fill", "transform"], Htn = { key: 0 }, Atn = ["stroke"], Vtn = ["stroke"], ztn = ["stroke"], Ztn = { key: 1 }, Ctn = /* @__PURE__ */ e("polygon", {
  points: "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
  opacity: "0.2"
}, null, -1), btn = ["stroke"], Ltn = ["stroke"], Btn = ["stroke"], Ptn = { key: 2 }, Wtn = /* @__PURE__ */ e("path", { d: "M120.6,200H40V88H216v32a8,8,0,0,0,16,0V88a16,16,0,0,0-16-16H131.3L104,44.7A15.9,15.9,0,0,0,92.7,40H40A16,16,0,0,0,24,56V200.6A15.4,15.4,0,0,0,39.4,216h81.2a8,8,0,1,0,0-16ZM92.7,56l16,16H40V56ZM241.1,167.8l-22.5,18.6,6.8,27.7a7.9,7.9,0,0,1-3,8.3,7.4,7.4,0,0,1-4.7,1.6,8.7,8.7,0,0,1-4.1-1.1L188,207.8l-25.6,15.1a8,8,0,0,1-8.8-.5,7.9,7.9,0,0,1-3-8.3l6.8-27.7-22.5-18.6a8.1,8.1,0,0,1,4.5-14.2l29.8-2.3,11.5-26.5a8,8,0,0,1,14.6,0l11.5,26.5,29.8,2.3a8.1,8.1,0,0,1,4.5,14.2Z" }, null, -1), Ntn = [
  Wtn
], Ftn = { key: 3 }, Ttn = ["stroke"], Dtn = ["stroke"], Rtn = ["stroke"], Utn = { key: 4 }, qtn = ["stroke"], Gtn = ["stroke"], Etn = ["stroke"], Otn = { key: 5 }, Itn = ["stroke"], Ktn = ["stroke"], Xtn = ["stroke"], Jtn = {
  name: "PhFolderStar"
}, $I1 = /* @__PURE__ */ $({
  ...Jtn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Htn, [
        e("path", {
          d: "M98.4,46.7,128,80H32V52a8,8,0,0,1,8-8H92.4A8,8,0,0,1,98.4,46.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Atn),
        e("path", {
          d: "M112.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vtn),
        e("polygon", {
          points: "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ztn)
      ])) : o(i) === "duotone" ? (s(), r("g", Ztn, [
        Ctn,
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, btn),
        e("path", {
          d: "M120.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ltn),
        e("polygon", {
          points: "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Btn)
      ])) : o(i) === "fill" ? (s(), r("g", Ptn, Ntn)) : o(i) === "light" ? (s(), r("g", Ftn, [
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ttn),
        e("path", {
          d: "M120.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dtn),
        e("polygon", {
          points: "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rtn)
      ])) : o(i) === "thin" ? (s(), r("g", Utn, [
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qtn),
        e("path", {
          d: "M120.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gtn),
        e("polygon", {
          points: "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Etn)
      ])) : o(i) === "regular" ? (s(), r("g", Otn, [
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Itn),
        e("path", {
          d: "M120.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ktn),
        e("polygon", {
          points: "188 198.5 217.7 216 209.6 183.4 236 161.6 201.3 158.9 188 128 174.7 158.9 140 161.6 166.4 183.4 158.3 216 188 198.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xtn)
      ])) : g("", !0)
    ], 16, Stn));
  }
}), Qtn = ["width", "height", "fill", "transform"], Ytn = { key: 0 }, onn = ["stroke"], enn = ["stroke"], tnn = ["stroke"], nnn = ["stroke"], snn = ["stroke"], rnn = { key: 1 }, inn = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "172",
  r: "24",
  opacity: "0.2"
}, null, -1), lnn = ["stroke"], dnn = ["stroke"], knn = ["stroke"], cnn = ["stroke"], hnn = { key: 2 }, unn = /* @__PURE__ */ e("path", { d: "M226.7,218a8,8,0,0,1-7.7,10H157a8,8,0,0,1-7.7-10,40.2,40.2,0,0,1,16.3-23.2,32,32,0,1,1,44.8,0A40.2,40.2,0,0,1,226.7,218ZM232,88v32a8,8,0,0,1-16,0V88H40V200h80.6a8,8,0,1,1,0,16H39.4A15.4,15.4,0,0,1,24,200.6V56A16,16,0,0,1,40,40H92.7A15.9,15.9,0,0,1,104,44.7L131.3,72H216A16,16,0,0,1,232,88ZM40,56V72h68.7l-16-16Z" }, null, -1), ann = [
  unn
], _nn = { key: 3 }, pnn = ["stroke"], ynn = ["stroke"], $nn = ["stroke"], wnn = ["stroke"], fnn = { key: 4 }, gnn = ["stroke"], xnn = ["stroke"], jnn = ["stroke"], mnn = ["stroke"], Mnn = { key: 5 }, vnn = ["stroke"], Snn = ["stroke"], Hnn = ["stroke"], Ann = ["stroke"], Vnn = {
  name: "PhFolderUser"
}, wI1 = /* @__PURE__ */ $({
  ...Vnn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ytn, [
        e("circle", {
          cx: "188",
          cy: "172",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, onn),
        e("path", {
          d: "M157,220a32,32,0,0,1,62,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, enn),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tnn),
        e("path", {
          d: "M112.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nnn),
        e("path", {
          d: "M98.4,46.7,128,80H32V52a8,8,0,0,1,8-8H92.4A8,8,0,0,1,98.4,46.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, snn)
      ])) : o(i) === "duotone" ? (s(), r("g", rnn, [
        inn,
        e("circle", {
          cx: "188",
          cy: "172",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lnn),
        e("path", {
          d: "M157,220a32,32,0,0,1,62,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dnn),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, knn),
        e("path", {
          d: "M120.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cnn)
      ])) : o(i) === "fill" ? (s(), r("g", hnn, ann)) : o(i) === "light" ? (s(), r("g", _nn, [
        e("circle", {
          cx: "188",
          cy: "172",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pnn),
        e("path", {
          d: "M157,220a32,32,0,0,1,62,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ynn),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $nn),
        e("path", {
          d: "M120.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wnn)
      ])) : o(i) === "thin" ? (s(), r("g", fnn, [
        e("circle", {
          cx: "188",
          cy: "172",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gnn),
        e("path", {
          d: "M157,220a32,32,0,0,1,62,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xnn),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jnn),
        e("path", {
          d: "M120.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mnn)
      ])) : o(i) === "regular" ? (s(), r("g", Mnn, [
        e("circle", {
          cx: "188",
          cy: "172",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vnn),
        e("path", {
          d: "M157,220a32,32,0,0,1,62,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Snn),
        e("path", {
          d: "M32,80V56a8,8,0,0,1,8-8H92.7a7.9,7.9,0,0,1,5.6,2.3L128,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hnn),
        e("path", {
          d: "M120.6,208H39.4a7.4,7.4,0,0,1-7.4-7.4V80H216a8,8,0,0,1,8,8v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ann)
      ])) : g("", !0)
    ], 16, Qtn));
  }
}), znn = ["width", "height", "fill", "transform"], Znn = { key: 0 }, Cnn = ["stroke"], bnn = ["stroke"], Lnn = { key: 1 }, Bnn = /* @__PURE__ */ e("path", {
  d: "M224,72H154.7a8.1,8.1,0,0,1-4.8-1.6L122.1,49.6a8.1,8.1,0,0,0-4.8-1.6H72a8,8,0,0,0-8,8V80H85.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H192a8,8,0,0,1,8,8v64h24.9a7.1,7.1,0,0,0,7.1-7.1V80A8,8,0,0,0,224,72Z",
  opacity: "0.2"
}, null, -1), Pnn = ["stroke"], Wnn = ["stroke"], Nnn = { key: 2 }, Fnn = /* @__PURE__ */ e("path", { d: "M224,64H154.7L126.9,43.2a15.6,15.6,0,0,0-9.6-3.2H72A16,16,0,0,0,56,56V72H40A16,16,0,0,0,24,88V200a16,16,0,0,0,16,16H192.9A15.2,15.2,0,0,0,208,200.9V184h16.9A15.2,15.2,0,0,0,240,168.9V80A16,16,0,0,0,224,64Zm0,104H208V112a16,16,0,0,0-16-16H122.7L94.9,75.2A15.6,15.6,0,0,0,85.3,72H72V56h45.3l27.8,20.8a15.6,15.6,0,0,0,9.6,3.2H224Z" }, null, -1), Tnn = [
  Fnn
], Dnn = { key: 3 }, Rnn = ["stroke"], Unn = ["stroke"], qnn = { key: 4 }, Gnn = ["stroke"], Enn = ["stroke"], Onn = { key: 5 }, Inn = ["stroke"], Knn = ["stroke"], Xnn = ["stroke"], Jnn = {
  name: "PhFolders"
}, fI1 = /* @__PURE__ */ $({
  ...Jnn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Znn, [
        e("path", {
          d: "M196,116v88.9a7.1,7.1,0,0,1-7.1,7.1H36a8,8,0,0,1-8-8V92a8,8,0,0,1,8-8H81.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H188A8,8,0,0,1,196,116Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cnn),
        e("path", {
          d: "M68,84V52a8,8,0,0,1,8-8h45.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H228a8,8,0,0,1,8,8v88.9a7.1,7.1,0,0,1-7.1,7.1H196",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bnn)
      ])) : o(i) === "duotone" ? (s(), r("g", Lnn, [
        Bnn,
        e("path", {
          d: "M200,112v88.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H85.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H192A8,8,0,0,1,200,112Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pnn),
        e("path", {
          d: "M64,80V56a8,8,0,0,1,8-8h45.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H224a8,8,0,0,1,8,8v88.9a7.1,7.1,0,0,1-7.1,7.1H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wnn)
      ])) : o(i) === "fill" ? (s(), r("g", Nnn, Tnn)) : o(i) === "light" ? (s(), r("g", Dnn, [
        e("path", {
          d: "M200,112v88.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H85.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H192A8,8,0,0,1,200,112Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rnn),
        e("path", {
          d: "M64,80V56a8,8,0,0,1,8-8h45.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H224a8,8,0,0,1,8,8v88.9a7.1,7.1,0,0,1-7.1,7.1H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Unn)
      ])) : o(i) === "thin" ? (s(), r("g", qnn, [
        e("path", {
          d: "M200,112v88.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H85.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H192A8,8,0,0,1,200,112Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gnn),
        e("path", {
          d: "M64,80V56a8,8,0,0,1,8-8h45.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H224a8,8,0,0,1,8,8v88.9a7.1,7.1,0,0,1-7.1,7.1H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Enn)
      ])) : o(i) === "regular" ? (s(), r("g", Onn, [
        e("path", {
          d: "M200,112v88.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H85.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H192A8,8,0,0,1,200,112Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Inn),
        e("path", {
          d: "M200,112v88.9a7.1,7.1,0,0,1-7.1,7.1H40a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8H85.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H192A8,8,0,0,1,200,112Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Knn),
        e("path", {
          d: "M64,80V56a8,8,0,0,1,8-8h45.3a8.1,8.1,0,0,1,4.8,1.6l27.8,20.8a8.1,8.1,0,0,0,4.8,1.6H224a8,8,0,0,1,8,8v88.9a7.1,7.1,0,0,1-7.1,7.1H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xnn)
      ])) : g("", !0)
    ], 16, znn));
  }
}), Qnn = ["width", "height", "fill", "transform"], Ynn = { key: 0 }, osn = ["stroke"], esn = ["stroke"], tsn = ["stroke"], nsn = ["stroke"], ssn = ["stroke"], rsn = ["stroke"], isn = { key: 1 }, lsn = ["stroke"], dsn = ["stroke"], ksn = ["stroke"], csn = ["stroke"], hsn = ["stroke"], usn = ["stroke"], asn = /* @__PURE__ */ e("path", {
  d: "M36.2,148.2C39,123,48.2,94.7,71.4,71.4S123,39,148.2,36.2h0l71.6,71.6h0c-2.8,25.2-12,53.5-35.2,76.8S133,217,107.8,219.8Z",
  opacity: "0.2"
}, null, -1), _sn = { key: 2 }, psn = /* @__PURE__ */ e("path", { d: "M226,56.3A32.3,32.3,0,0,0,199.7,30c-31.4-5.3-90.4-7.7-133.9,35.8S24.7,168.3,30,199.7A32.3,32.3,0,0,0,56.3,226a206.3,206.3,0,0,0,33.3,2.8c31.1,0,69.8-7.7,100.6-38.6C233.7,146.7,231.3,87.7,226,56.3ZM59,210.2A15.9,15.9,0,0,1,45.8,197a178.7,178.7,0,0,1-2.7-30.6l46.5,46.5A179.5,179.5,0,0,1,59,210.2ZM165.7,101.7l-15.1,15,9,9a8,8,0,0,1,0,11.3,8.3,8.3,0,0,1-5.7,2.3,8,8,0,0,1-5.6-2.3l-9-9L128,139.3l9,9a8,8,0,0,1,0,11.3,7.8,7.8,0,0,1-5.7,2.3,7.6,7.6,0,0,1-5.6-2.3l-9-9-15,15.1a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4l15.1-15-9-9A8,8,0,0,1,107.7,119l9,9L128,116.7l-9-9a8,8,0,0,1,11.3-11.3l9,9,15-15.1a8.1,8.1,0,0,1,11.4,11.4Zm.7-58.6A179.5,179.5,0,0,1,197,45.8,15.9,15.9,0,0,1,210.2,59a178.7,178.7,0,0,1,2.7,30.6Z" }, null, -1), ysn = [
  psn
], $sn = { key: 3 }, wsn = ["stroke"], fsn = ["stroke"], gsn = ["stroke"], xsn = ["stroke"], jsn = ["stroke"], msn = ["stroke"], Msn = { key: 4 }, vsn = ["stroke"], Ssn = ["stroke"], Hsn = ["stroke"], Asn = ["stroke"], Vsn = ["stroke"], zsn = ["stroke"], Zsn = { key: 5 }, Csn = ["stroke"], bsn = ["stroke"], Lsn = ["stroke"], Bsn = ["stroke"], Psn = ["stroke"], Wsn = ["stroke"], Nsn = {
  name: "PhFootball"
}, gI1 = /* @__PURE__ */ $({
  ...Nsn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ynn, [
        e("path", {
          d: "M184.6,184.6c-41.6,41.5-99.2,38.2-127,33.5a24,24,0,0,1-19.7-19.7c-4.7-27.8-8-85.4,33.5-127s99.2-38.2,127-33.5a24,24,0,0,1,19.7,19.7C222.8,85.4,226.1,143,184.6,184.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, osn),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "96",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, esn),
        e("line", {
          x1: "124.7",
          y1: "102.1",
          x2: "153.9",
          y2: "131.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tsn),
        e("line", {
          x1: "102.1",
          y1: "124.7",
          x2: "131.3",
          y2: "153.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nsn),
        e("line", {
          x1: "148.2",
          y1: "36.2",
          x2: "219.8",
          y2: "107.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ssn),
        e("line", {
          x1: "36.2",
          y1: "148.2",
          x2: "107.8",
          y2: "219.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rsn)
      ])) : o(i) === "duotone" ? (s(), r("g", isn, [
        e("path", {
          d: "M184.6,184.6c-41.6,41.5-99.2,38.2-127,33.5a24,24,0,0,1-19.7-19.7c-4.7-27.8-8-85.4,33.5-127s99.2-38.2,127-33.5a24,24,0,0,1,19.7,19.7C222.8,85.4,226.1,143,184.6,184.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lsn),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "96",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dsn),
        e("line", {
          x1: "124.7",
          y1: "102.1",
          x2: "153.9",
          y2: "131.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ksn),
        e("line", {
          x1: "102.1",
          y1: "124.7",
          x2: "131.3",
          y2: "153.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, csn),
        e("line", {
          x1: "148.2",
          y1: "36.2",
          x2: "219.8",
          y2: "107.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hsn),
        e("line", {
          x1: "36.2",
          y1: "148.2",
          x2: "107.8",
          y2: "219.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, usn),
        asn
      ])) : o(i) === "fill" ? (s(), r("g", _sn, ysn)) : o(i) === "light" ? (s(), r("g", $sn, [
        e("path", {
          d: "M184.6,184.6c-41.6,41.5-99.2,38.2-127,33.5a24,24,0,0,1-19.7-19.7c-4.7-27.8-8-85.4,33.5-127s99.2-38.2,127-33.5a24,24,0,0,1,19.7,19.7C222.8,85.4,226.1,143,184.6,184.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wsn),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "96",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fsn),
        e("line", {
          x1: "124.7",
          y1: "102.1",
          x2: "153.9",
          y2: "131.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gsn),
        e("line", {
          x1: "102.1",
          y1: "124.7",
          x2: "131.3",
          y2: "153.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xsn),
        e("line", {
          x1: "148.2",
          y1: "36.2",
          x2: "219.8",
          y2: "107.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jsn),
        e("line", {
          x1: "36.2",
          y1: "148.2",
          x2: "107.8",
          y2: "219.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, msn)
      ])) : o(i) === "thin" ? (s(), r("g", Msn, [
        e("path", {
          d: "M184.6,184.6c-41.6,41.5-99.2,38.2-127,33.5a24,24,0,0,1-19.7-19.7c-4.7-27.8-8-85.4,33.5-127s99.2-38.2,127-33.5a24,24,0,0,1,19.7,19.7C222.8,85.4,226.1,143,184.6,184.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vsn),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "96",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ssn),
        e("line", {
          x1: "124.7",
          y1: "102.1",
          x2: "153.9",
          y2: "131.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hsn),
        e("line", {
          x1: "102.1",
          y1: "124.7",
          x2: "131.3",
          y2: "153.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Asn),
        e("line", {
          x1: "148.2",
          y1: "36.2",
          x2: "219.8",
          y2: "107.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vsn),
        e("line", {
          x1: "36.2",
          y1: "148.2",
          x2: "107.8",
          y2: "219.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zsn)
      ])) : o(i) === "regular" ? (s(), r("g", Zsn, [
        e("path", {
          d: "M184.6,184.6c-41.6,41.5-99.2,38.2-127,33.5a24,24,0,0,1-19.7-19.7c-4.7-27.8-8-85.4,33.5-127s99.2-38.2,127-33.5a24,24,0,0,1,19.7,19.7C222.8,85.4,226.1,143,184.6,184.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Csn),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "96",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bsn),
        e("line", {
          x1: "124.7",
          y1: "102.1",
          x2: "153.9",
          y2: "131.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lsn),
        e("line", {
          x1: "102.1",
          y1: "124.7",
          x2: "131.3",
          y2: "153.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bsn),
        e("line", {
          x1: "148.2",
          y1: "36.2",
          x2: "219.8",
          y2: "107.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Psn),
        e("line", {
          x1: "36.2",
          y1: "148.2",
          x2: "107.8",
          y2: "219.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wsn)
      ])) : g("", !0)
    ], 16, Qnn));
  }
}), Fsn = ["width", "height", "fill", "transform"], Tsn = { key: 0 }, Dsn = ["stroke"], Rsn = ["stroke"], Usn = ["stroke"], qsn = ["stroke"], Gsn = { key: 1 }, Esn = /* @__PURE__ */ e("path", {
  d: "M204,160H148S160,48,204,32",
  opacity: "0.2"
}, null, -1), Osn = ["stroke"], Isn = ["stroke"], Ksn = ["stroke"], Xsn = ["stroke"], Jsn = { key: 2 }, Qsn = /* @__PURE__ */ e("path", { d: "M212,32V224a8,8,0,0,1-16,0V168H148a8.2,8.2,0,0,1-6-2.7,8.1,8.1,0,0,1-2-6.2,412.8,412.8,0,0,1,11.8-59.3c12-42.4,28.7-67.8,49.5-75.3A7.9,7.9,0,0,1,212,32ZM127.9,78.7l-8-48a8,8,0,1,0-15.8,2.6L110.6,72H92V32a8,8,0,0,0-16,0V72H57.4l6.5-38.7a8,8,0,1,0-15.8-2.6l-8,48h0A4.9,4.9,0,0,0,40,80a44.1,44.1,0,0,0,36,43.3V224a8,8,0,0,0,16,0V123.3A44.1,44.1,0,0,0,128,80a4.9,4.9,0,0,0-.1-1.2Z" }, null, -1), Ysn = [
  Qsn
], orn = { key: 3 }, ern = ["stroke"], trn = ["stroke"], nrn = ["stroke"], srn = ["stroke"], rrn = { key: 4 }, irn = ["stroke"], lrn = ["stroke"], drn = ["stroke"], krn = ["stroke"], crn = { key: 5 }, hrn = ["stroke"], urn = ["stroke"], arn = ["stroke"], _rn = ["stroke"], prn = {
  name: "PhForkKnife"
}, xI1 = /* @__PURE__ */ $({
  ...prn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Tsn, [
        e("line", {
          x1: "84",
          y1: "32",
          x2: "84",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Dsn),
        e("line", {
          x1: "84",
          y1: "116",
          x2: "84",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rsn),
        e("path", {
          d: "M120,32V80a36,36,0,0,1-72,0V32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Usn),
        e("path", {
          d: "M204,160H148S160,48,204,32V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qsn)
      ])) : o(i) === "duotone" ? (s(), r("g", Gsn, [
        Esn,
        e("line", {
          x1: "84",
          y1: "32",
          x2: "84",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Osn),
        e("line", {
          x1: "84",
          y1: "116",
          x2: "84",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Isn),
        e("path", {
          d: "M112,32l8,48a36,36,0,0,1-72,0l8-48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ksn),
        e("path", {
          d: "M204,160H148S160,48,204,32V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xsn)
      ])) : o(i) === "fill" ? (s(), r("g", Jsn, Ysn)) : o(i) === "light" ? (s(), r("g", orn, [
        e("line", {
          x1: "84",
          y1: "32",
          x2: "84",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ern),
        e("line", {
          x1: "84",
          y1: "116",
          x2: "84",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, trn),
        e("path", {
          d: "M112,32l8,48a36,36,0,0,1-72,0l8-48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nrn),
        e("path", {
          d: "M204,160H148S160,48,204,32V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, srn)
      ])) : o(i) === "thin" ? (s(), r("g", rrn, [
        e("line", {
          x1: "84",
          y1: "32",
          x2: "84",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, irn),
        e("line", {
          x1: "84",
          y1: "116",
          x2: "84",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lrn),
        e("path", {
          d: "M112,32l8,48a36,36,0,0,1-72,0l8-48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, drn),
        e("path", {
          d: "M204,160H148S160,48,204,32V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, krn)
      ])) : o(i) === "regular" ? (s(), r("g", crn, [
        e("line", {
          x1: "84",
          y1: "32",
          x2: "84",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hrn),
        e("line", {
          x1: "84",
          y1: "116",
          x2: "84",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, urn),
        e("path", {
          d: "M112,32l8,48a36,36,0,0,1-72,0l8-48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, arn),
        e("path", {
          d: "M204,160H148S160,48,204,32V224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _rn)
      ])) : g("", !0)
    ], 16, Fsn));
  }
}), yrn = ["width", "height", "fill", "transform"], $rn = { key: 0 }, wrn = ["stroke"], frn = ["stroke"], grn = ["stroke"], xrn = { key: 1 }, jrn = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "48",
  width: "192",
  height: "160",
  rx: "8",
  opacity: "0.2"
}, null, -1), mrn = ["stroke"], Mrn = ["stroke"], vrn = ["stroke"], Srn = { key: 2 }, Hrn = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM88,192H56a8,8,0,0,1-8-8V152a8,8,0,0,1,16,0v24H88a8,8,0,0,1,0,16Zm120-88a8,8,0,0,1-16,0V80H168a8,8,0,0,1,0-16h32a8,8,0,0,1,8,8Z" }, null, -1), Arn = [
  Hrn
], Vrn = { key: 3 }, zrn = ["stroke"], Zrn = ["stroke"], Crn = ["stroke"], brn = { key: 4 }, Lrn = ["stroke"], Brn = ["stroke"], Prn = ["stroke"], Wrn = { key: 5 }, Nrn = ["stroke"], Frn = ["stroke"], Trn = ["stroke"], Drn = {
  name: "PhFrameCorners"
}, jI1 = /* @__PURE__ */ $({
  ...Drn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $rn, [
        e("polyline", {
          points: "152 88 184 88 184 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wrn),
        e("polyline", {
          points: "104 168 72 168 72 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, frn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, grn)
      ])) : o(i) === "duotone" ? (s(), r("g", xrn, [
        jrn,
        e("polyline", {
          points: "160 80 192 80 192 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mrn),
        e("polyline", {
          points: "96 176 64 176 64 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mrn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vrn)
      ])) : o(i) === "fill" ? (s(), r("g", Srn, Arn)) : o(i) === "light" ? (s(), r("g", Vrn, [
        e("polyline", {
          points: "160 80 192 80 192 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zrn),
        e("polyline", {
          points: "96 176 64 176 64 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zrn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Crn)
      ])) : o(i) === "thin" ? (s(), r("g", brn, [
        e("polyline", {
          points: "160 80 192 80 192 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lrn),
        e("polyline", {
          points: "96 176 64 176 64 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Brn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Prn)
      ])) : o(i) === "regular" ? (s(), r("g", Wrn, [
        e("polyline", {
          points: "160 80 192 80 192 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nrn),
        e("polyline", {
          points: "96 176 64 176 64 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Frn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Trn)
      ])) : g("", !0)
    ], 16, yrn));
  }
}), Rrn = ["width", "height", "fill", "transform"], Urn = { key: 0 }, qrn = ["stroke"], Grn = { key: 1 }, Ern = /* @__PURE__ */ e("polygon", {
  points: "56 100 56 168 128 236 128 168 200 168 56 32 200 32 200 100 56 100",
  opacity: "0.2"
}, null, -1), Orn = ["stroke"], Irn = { key: 2 }, Krn = /* @__PURE__ */ e("path", { d: "M208,100V32a8,8,0,0,0-8-8H56a8,8,0,0,0-5.5,13.8L107.9,92H56a8,8,0,0,0-8,8v68a7.9,7.9,0,0,0,2.5,5.8l72,68A8.2,8.2,0,0,0,128,244a7.4,7.4,0,0,0,3.2-.7A7.9,7.9,0,0,0,136,236V176h64a8,8,0,0,0,5.5-13.8L148.1,108H200A8,8,0,0,0,208,100Z" }, null, -1), Xrn = [
  Krn
], Jrn = { key: 3 }, Qrn = ["stroke"], Yrn = { key: 4 }, oin = ["stroke"], ein = { key: 5 }, tin = ["stroke"], nin = {
  name: "PhFramerLogo"
}, mI1 = /* @__PURE__ */ $({
  ...nin,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Urn, [
        e("polygon", {
          points: "56 100 56 168 128 236 128 168 200 168 56 32 200 32 200 100 56 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qrn)
      ])) : o(i) === "duotone" ? (s(), r("g", Grn, [
        Ern,
        e("polygon", {
          points: "56 100 56 168 128 236 128 168 200 168 56 32 200 32 200 100 56 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Orn)
      ])) : o(i) === "fill" ? (s(), r("g", Irn, Xrn)) : o(i) === "light" ? (s(), r("g", Jrn, [
        e("polygon", {
          points: "56 100 56 168 128 236 128 168 200 168 56 32 200 32 200 100 56 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qrn)
      ])) : o(i) === "thin" ? (s(), r("g", Yrn, [
        e("polygon", {
          points: "56 100 56 168 128 236 128 168 200 168 56 32 200 32 200 100 56 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oin)
      ])) : o(i) === "regular" ? (s(), r("g", ein, [
        e("polygon", {
          points: "56 100 56 168 128 236 128 168 200 168 56 32 200 32 200 100 56 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tin)
      ])) : g("", !0)
    ], 16, Rrn));
  }
}), sin = ["width", "height", "fill", "transform"], rin = { key: 0 }, iin = ["stroke"], lin = ["stroke"], din = { key: 1 }, kin = ["stroke"], cin = ["stroke"], hin = { key: 2 }, uin = /* @__PURE__ */ e("path", { d: "M208,40a8,8,0,0,1-8,8H170.7a24,24,0,0,0-23.6,19.7L137.6,120H184a8,8,0,0,1,0,16H134.7l-10.1,55.2A39.9,39.9,0,0,1,85.3,224H56a8,8,0,0,1,0-16H85.3a24,24,0,0,0,23.6-19.7l9.5-52.3H72a8,8,0,0,1,0-16h49.3l10.1-55.2A39.9,39.9,0,0,1,170.7,32H200A8,8,0,0,1,208,40Z" }, null, -1), ain = [
  uin
], _in = { key: 3 }, pin = ["stroke"], yin = ["stroke"], $in = { key: 4 }, win = ["stroke"], fin = ["stroke"], gin = { key: 5 }, xin = ["stroke"], jin = ["stroke"], min = {
  name: "PhFunction"
}, MI1 = /* @__PURE__ */ $({
  ...min,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", rin, [
        e("line", {
          x1: "72",
          y1: "128",
          x2: "184",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iin),
        e("path", {
          d: "M56,216H85.3a32.1,32.1,0,0,0,31.5-26.3L139.2,66.3A32.1,32.1,0,0,1,170.7,40H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lin)
      ])) : o(i) === "duotone" ? (s(), r("g", din, [
        e("line", {
          x1: "72",
          y1: "128",
          x2: "184",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kin),
        e("path", {
          d: "M56,216H85.3a32.1,32.1,0,0,0,31.5-26.3L139.2,66.3A32.1,32.1,0,0,1,170.7,40H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cin)
      ])) : o(i) === "fill" ? (s(), r("g", hin, ain)) : o(i) === "light" ? (s(), r("g", _in, [
        e("line", {
          x1: "72",
          y1: "128",
          x2: "184",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pin),
        e("path", {
          d: "M56,216H85.3a32.1,32.1,0,0,0,31.5-26.3L139.2,66.3A32.1,32.1,0,0,1,170.7,40H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yin)
      ])) : o(i) === "thin" ? (s(), r("g", $in, [
        e("line", {
          x1: "72",
          y1: "128",
          x2: "184",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, win),
        e("path", {
          d: "M56,216H85.3a32.1,32.1,0,0,0,31.5-26.3L139.2,66.3A32.1,32.1,0,0,1,170.7,40H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fin)
      ])) : o(i) === "regular" ? (s(), r("g", gin, [
        e("line", {
          x1: "72",
          y1: "128",
          x2: "184",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xin),
        e("path", {
          d: "M56,216H85.3a32.1,32.1,0,0,0,31.5-26.3L139.2,66.3A32.1,32.1,0,0,1,170.7,40H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jin)
      ])) : g("", !0)
    ], 16, sin));
  }
}), Min = ["width", "height", "fill", "transform"], vin = { key: 0 }, Sin = ["stroke"], Hin = { key: 1 }, Ain = /* @__PURE__ */ e("path", {
  d: "M42.1,48H213.9a8,8,0,0,1,5.9,13.4l-65.7,72.3a7.8,7.8,0,0,0-2.1,5.4v56.6a7.9,7.9,0,0,1-3.6,6.7l-32,21.3a8,8,0,0,1-12.4-6.6v-78a7.8,7.8,0,0,0-2.1-5.4L36.2,61.4A8,8,0,0,1,42.1,48Z",
  opacity: "0.2"
}, null, -1), Vin = ["stroke"], zin = { key: 2 }, Zin = /* @__PURE__ */ e("path", { d: "M228.5,49.5A15.9,15.9,0,0,0,213.9,40H42.1A16.1,16.1,0,0,0,30.2,66.8L96,139.1v78a15.9,15.9,0,0,0,8.5,14.1,16.4,16.4,0,0,0,7.5,1.9,16,16,0,0,0,8.9-2.7l32-21.4a15.9,15.9,0,0,0,7.1-13.3V139.1l65.8-72.3A15.9,15.9,0,0,0,228.5,49.5Z" }, null, -1), Cin = [
  Zin
], bin = { key: 3 }, Lin = ["stroke"], Bin = { key: 4 }, Pin = ["stroke"], Win = { key: 5 }, Nin = ["stroke"], Fin = {
  name: "PhFunnel"
}, vI1 = /* @__PURE__ */ $({
  ...Fin,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", vin, [
        e("path", {
          d: "M42.1,48H213.9a8,8,0,0,1,5.9,13.4l-65.7,72.3a7.8,7.8,0,0,0-2.1,5.4v56.6a7.9,7.9,0,0,1-3.6,6.7l-32,21.3a8,8,0,0,1-12.4-6.6v-78a7.8,7.8,0,0,0-2.1-5.4L36.2,61.4A8,8,0,0,1,42.1,48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Sin)
      ])) : o(i) === "duotone" ? (s(), r("g", Hin, [
        Ain,
        e("path", {
          d: "M42.1,48H213.9a8,8,0,0,1,5.9,13.4l-65.7,72.3a7.8,7.8,0,0,0-2.1,5.4v56.6a7.9,7.9,0,0,1-3.6,6.7l-32,21.3a8,8,0,0,1-12.4-6.6v-78a7.8,7.8,0,0,0-2.1-5.4L36.2,61.4A8,8,0,0,1,42.1,48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vin)
      ])) : o(i) === "fill" ? (s(), r("g", zin, Cin)) : o(i) === "light" ? (s(), r("g", bin, [
        e("path", {
          d: "M42.1,48H213.9a8,8,0,0,1,5.9,13.4l-65.7,72.3a7.8,7.8,0,0,0-2.1,5.4v56.6a7.9,7.9,0,0,1-3.6,6.7l-32,21.3a8,8,0,0,1-12.4-6.6v-78a7.8,7.8,0,0,0-2.1-5.4L36.2,61.4A8,8,0,0,1,42.1,48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lin)
      ])) : o(i) === "thin" ? (s(), r("g", Bin, [
        e("path", {
          d: "M42.1,48H213.9a8,8,0,0,1,5.9,13.4l-65.7,72.3a7.8,7.8,0,0,0-2.1,5.4v56.6a7.9,7.9,0,0,1-3.6,6.7l-32,21.3a8,8,0,0,1-12.4-6.6v-78a7.8,7.8,0,0,0-2.1-5.4L36.2,61.4A8,8,0,0,1,42.1,48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pin)
      ])) : o(i) === "regular" ? (s(), r("g", Win, [
        e("path", {
          d: "M42.1,48H213.9a8,8,0,0,1,5.9,13.4l-65.7,72.3a7.8,7.8,0,0,0-2.1,5.4v56.6a7.9,7.9,0,0,1-3.6,6.7l-32,21.3a8,8,0,0,1-12.4-6.6v-78a7.8,7.8,0,0,0-2.1-5.4L36.2,61.4A8,8,0,0,1,42.1,48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nin)
      ])) : g("", !0)
    ], 16, Min));
  }
}), Tin = ["width", "height", "fill", "transform"], Din = { key: 0 }, Rin = ["stroke"], Uin = ["stroke"], qin = ["stroke"], Gin = { key: 1 }, Ein = ["stroke"], Oin = ["stroke"], Iin = ["stroke"], Kin = { key: 2 }, Xin = /* @__PURE__ */ e("path", { d: "M192,120H64a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Z" }, null, -1), Jin = /* @__PURE__ */ e("path", { d: "M232,72H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Z" }, null, -1), Qin = /* @__PURE__ */ e("path", { d: "M152,168H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z" }, null, -1), Yin = [
  Xin,
  Jin,
  Qin
], o1n = { key: 3 }, e1n = ["stroke"], t1n = ["stroke"], n1n = ["stroke"], s1n = { key: 4 }, r1n = ["stroke"], i1n = ["stroke"], l1n = ["stroke"], d1n = { key: 5 }, k1n = ["stroke"], c1n = ["stroke"], h1n = ["stroke"], u1n = {
  name: "PhFunnelSimple"
}, SI1 = /* @__PURE__ */ $({
  ...u1n,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Din, [
        e("line", {
          x1: "64",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rin),
        e("line", {
          x1: "24",
          y1: "80",
          x2: "232",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Uin),
        e("line", {
          x1: "104",
          y1: "176",
          x2: "152",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qin)
      ])) : o(i) === "duotone" ? (s(), r("g", Gin, [
        e("line", {
          x1: "64",
          y1: "128",
          x2: "192",
          y2: "128",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ein),
        e("line", {
          x1: "24",
          y1: "80",
          x2: "232",
          y2: "80",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Oin),
        e("line", {
          x1: "104",
          y1: "176",
          x2: "152",
          y2: "176",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Iin)
      ])) : o(i) === "fill" ? (s(), r("g", Kin, Yin)) : o(i) === "light" ? (s(), r("g", o1n, [
        e("line", {
          x1: "64",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, e1n),
        e("line", {
          x1: "24",
          y1: "80",
          x2: "232",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, t1n),
        e("line", {
          x1: "104",
          y1: "176",
          x2: "152",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, n1n)
      ])) : o(i) === "thin" ? (s(), r("g", s1n, [
        e("line", {
          x1: "64",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, r1n),
        e("line", {
          x1: "24",
          y1: "80",
          x2: "232",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, i1n),
        e("line", {
          x1: "104",
          y1: "176",
          x2: "152",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, l1n)
      ])) : o(i) === "regular" ? (s(), r("g", d1n, [
        e("line", {
          x1: "64",
          y1: "128",
          x2: "192",
          y2: "128",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k1n),
        e("line", {
          x1: "24",
          y1: "80",
          x2: "232",
          y2: "80",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c1n),
        e("line", {
          x1: "104",
          y1: "176",
          x2: "152",
          y2: "176",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h1n)
      ])) : g("", !0)
    ], 16, Tin));
  }
}), a1n = ["width", "height", "fill", "transform"], _1n = { key: 0 }, p1n = ["stroke"], y1n = ["stroke"], $1n = ["stroke"], w1n = ["stroke"], f1n = ["stroke"], g1n = { key: 1 }, x1n = /* @__PURE__ */ e("path", {
  d: "M149,159.8h23a52,52,0,0,0,52-52,45,45,0,0,0-.8-9h0l16.4,84.4a28,28,0,0,1-47.4,24.7h0l-43.2-48Z",
  opacity: "0.2"
}, null, -1), j1n = ["stroke"], m1n = ["stroke"], M1n = ["stroke"], v1n = ["stroke"], S1n = ["stroke"], H1n = { key: 2 }, A1n = /* @__PURE__ */ e("path", { d: "M247.5,181.7h-.1L231.1,97.2c0-.1,0-.1-.1-.2a60,60,0,0,0-59-49.3h0L84,48A59.9,59.9,0,0,0,24.9,97.6v.2L8.6,181.6h0a35.9,35.9,0,0,0,29.2,41.7,31.8,31.8,0,0,0,6.2.6,36.4,36.4,0,0,0,25.5-10.5l.4-.5,40.7-45,34.9-.2L186.1,213l.5.5A36,36,0,0,0,212,224a33.6,33.6,0,0,0,6.3-.6A36.1,36.1,0,0,0,247.5,181.7ZM104,116H96v8a8,8,0,0,1-16,0v-8H72a8,8,0,0,1,0-16h8V92a8,8,0,0,1,16,0v8h8a8,8,0,0,1,0,16Zm40-8a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H152A8,8,0,0,1,144,108Zm71.5,99.7a20.1,20.1,0,0,1-17.5-5.4l-31.1-34.5H172a60,60,0,0,0,51-28.3l8.7,45.2A20,20,0,0,1,215.5,207.7Z" }, null, -1), V1n = [
  A1n
], z1n = { key: 3 }, Z1n = ["stroke"], C1n = ["stroke"], b1n = ["stroke"], L1n = ["stroke"], B1n = ["stroke"], P1n = { key: 4 }, W1n = ["stroke"], N1n = ["stroke"], F1n = ["stroke"], T1n = ["stroke"], D1n = ["stroke"], R1n = { key: 5 }, U1n = ["stroke"], q1n = ["stroke"], G1n = ["stroke"], E1n = ["stroke"], O1n = ["stroke"], I1n = {
  name: "PhGameController"
}, HI1 = /* @__PURE__ */ $({
  ...I1n,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", _1n, [
        e("line", {
          x1: "152",
          y1: "108",
          x2: "184",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, p1n),
        e("line", {
          x1: "72",
          y1: "108",
          x2: "104",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, y1n),
        e("line", {
          x1: "88",
          y1: "92",
          x2: "88",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $1n),
        e("path", {
          d: "M172,55.7,84,56A52.1,52.1,0,0,0,32.8,99h0L16.4,183.1a28,28,0,0,0,47.4,24.7h0L107,160l65-.3a52,52,0,1,0,0-104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, w1n),
        e("path", {
          d: "M223.2,98.7l16.4,84.4a28,28,0,0,1-47.4,24.7h0l-43.2-48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f1n)
      ])) : o(i) === "duotone" ? (s(), r("g", g1n, [
        x1n,
        e("line", {
          x1: "152",
          y1: "108",
          x2: "184",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j1n),
        e("line", {
          x1: "72",
          y1: "108",
          x2: "104",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m1n),
        e("line", {
          x1: "88",
          y1: "92",
          x2: "88",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M1n),
        e("path", {
          d: "M172,55.7,84,56A52.1,52.1,0,0,0,32.8,99h0L16.4,183.1a28,28,0,0,0,47.4,24.7h0L107,160l65-.3a52,52,0,1,0,0-104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v1n),
        e("path", {
          d: "M223.2,98.7l16.4,84.4a28,28,0,0,1-47.4,24.7h0l-43.2-48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S1n)
      ])) : o(i) === "fill" ? (s(), r("g", H1n, V1n)) : o(i) === "light" ? (s(), r("g", z1n, [
        e("line", {
          x1: "152",
          y1: "108",
          x2: "184",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Z1n),
        e("line", {
          x1: "72",
          y1: "108",
          x2: "104",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, C1n),
        e("line", {
          x1: "88",
          y1: "92",
          x2: "88",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b1n),
        e("path", {
          d: "M172,55.7,84,56A52.1,52.1,0,0,0,32.8,99h0L16.4,183.1a28,28,0,0,0,47.4,24.7h0L107,160l65-.3a52,52,0,1,0,0-104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, L1n),
        e("path", {
          d: "M223.2,98.7l16.4,84.4a28,28,0,0,1-47.4,24.7h0l-43.2-48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, B1n)
      ])) : o(i) === "thin" ? (s(), r("g", P1n, [
        e("line", {
          x1: "152",
          y1: "108",
          x2: "184",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, W1n),
        e("line", {
          x1: "72",
          y1: "108",
          x2: "104",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, N1n),
        e("line", {
          x1: "88",
          y1: "92",
          x2: "88",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, F1n),
        e("path", {
          d: "M172,55.7,84,56A52.1,52.1,0,0,0,32.8,99h0L16.4,183.1a28,28,0,0,0,47.4,24.7h0L107,160l65-.3a52,52,0,1,0,0-104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, T1n),
        e("path", {
          d: "M223.2,98.7l16.4,84.4a28,28,0,0,1-47.4,24.7h0l-43.2-48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, D1n)
      ])) : o(i) === "regular" ? (s(), r("g", R1n, [
        e("line", {
          x1: "152",
          y1: "108",
          x2: "184",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U1n),
        e("line", {
          x1: "72",
          y1: "108",
          x2: "104",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q1n),
        e("line", {
          x1: "88",
          y1: "92",
          x2: "88",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G1n),
        e("path", {
          d: "M172,55.7,84,56A52.1,52.1,0,0,0,32.8,99h0L16.4,183.1a28,28,0,0,0,47.4,24.7h0L107,160l65-.3a52,52,0,1,0,0-104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E1n),
        e("path", {
          d: "M223.2,98.7l16.4,84.4a28,28,0,0,1-47.4,24.7h0l-43.2-48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O1n)
      ])) : g("", !0)
    ], 16, a1n));
  }
}), K1n = ["width", "height", "fill", "transform"], X1n = { key: 0 }, J1n = ["stroke"], Q1n = ["stroke"], Y1n = ["stroke"], oln = ["stroke"], eln = { key: 1 }, tln = /* @__PURE__ */ e("path", {
  d: "M56,216V56A16,16,0,0,1,72,40h80a16,16,0,0,1,16,16V216",
  opacity: "0.2"
}, null, -1), nln = ["stroke"], sln = ["stroke"], rln = ["stroke"], iln = ["stroke"], lln = { key: 2 }, dln = /* @__PURE__ */ e("path", { d: "M241,69.7,221.7,50.3a8.1,8.1,0,0,0-11.4,11.4L229.7,81a7.9,7.9,0,0,1,2.3,5.6V168a8,8,0,0,1-16,0V128a24.1,24.1,0,0,0-24-24H176V56a24.1,24.1,0,0,0-24-24H72A24.1,24.1,0,0,0,48,56V208H32a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16H176V120h16a8,8,0,0,1,8,8v40a24,24,0,0,0,48,0V86.6A23.8,23.8,0,0,0,241,69.7ZM144,120H80a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z" }, null, -1), kln = [
  dln
], cln = { key: 3 }, hln = ["stroke"], uln = ["stroke"], aln = ["stroke"], _ln = ["stroke"], pln = { key: 4 }, yln = ["stroke"], $ln = ["stroke"], wln = ["stroke"], fln = ["stroke"], gln = { key: 5 }, xln = ["stroke"], jln = ["stroke"], mln = ["stroke"], Mln = ["stroke"], vln = {
  name: "PhGasPump"
}, AI1 = /* @__PURE__ */ $({
  ...vln,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", X1n, [
        e("path", {
          d: "M56,216V56A16,16,0,0,1,72,40h80a16,16,0,0,1,16,16V216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, J1n),
        e("line", {
          x1: "32",
          y1: "216",
          x2: "192",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Q1n),
        e("path", {
          d: "M168,112h24a16,16,0,0,1,16,16v40a16,16,0,0,0,16,16h4a16,16,0,0,0,16-16V86.6a16.1,16.1,0,0,0-4.7-11.3L220,56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Y1n),
        e("line", {
          x1: "128",
          y1: "112",
          x2: "96",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oln)
      ])) : o(i) === "duotone" ? (s(), r("g", eln, [
        tln,
        e("path", {
          d: "M56,216V56A16,16,0,0,1,72,40h80a16,16,0,0,1,16,16V216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nln),
        e("line", {
          x1: "32",
          y1: "216",
          x2: "192",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sln),
        e("path", {
          d: "M168,112h24a16,16,0,0,1,16,16v40a16,16,0,0,0,16,16h0a16,16,0,0,0,16-16V86.6a16.1,16.1,0,0,0-4.7-11.3L216,56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rln),
        e("line", {
          x1: "136",
          y1: "112",
          x2: "88",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iln)
      ])) : o(i) === "fill" ? (s(), r("g", lln, kln)) : o(i) === "light" ? (s(), r("g", cln, [
        e("path", {
          d: "M56,216V56A16,16,0,0,1,72,40h80a16,16,0,0,1,16,16V216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hln),
        e("line", {
          x1: "32",
          y1: "216",
          x2: "192",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uln),
        e("path", {
          d: "M168,112h24a16,16,0,0,1,16,16v40a16,16,0,0,0,16,16h0a16,16,0,0,0,16-16V86.6a16.1,16.1,0,0,0-4.7-11.3L216,56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aln),
        e("line", {
          x1: "136",
          y1: "112",
          x2: "88",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _ln)
      ])) : o(i) === "thin" ? (s(), r("g", pln, [
        e("path", {
          d: "M56,216V56A16,16,0,0,1,72,40h80a16,16,0,0,1,16,16V216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yln),
        e("line", {
          x1: "32",
          y1: "216",
          x2: "192",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $ln),
        e("path", {
          d: "M168,112h24a16,16,0,0,1,16,16v40a16,16,0,0,0,16,16h0a16,16,0,0,0,16-16V86.6a16.1,16.1,0,0,0-4.7-11.3L216,56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wln),
        e("line", {
          x1: "136",
          y1: "112",
          x2: "88",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fln)
      ])) : o(i) === "regular" ? (s(), r("g", gln, [
        e("path", {
          d: "M56,216V56A16,16,0,0,1,72,40h80a16,16,0,0,1,16,16V216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xln),
        e("line", {
          x1: "32",
          y1: "216",
          x2: "192",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jln),
        e("path", {
          d: "M168,112h24a16,16,0,0,1,16,16v40a16,16,0,0,0,16,16h0a16,16,0,0,0,16-16V86.6a16.1,16.1,0,0,0-4.7-11.3L216,56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mln),
        e("line", {
          x1: "136",
          y1: "112",
          x2: "88",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mln)
      ])) : g("", !0)
    ], 16, K1n));
  }
}), Sln = ["width", "height", "fill", "transform"], Hln = { key: 0 }, Aln = ["stroke"], Vln = ["stroke"], zln = ["stroke"], Zln = ["stroke"], Cln = ["stroke"], bln = { key: 1 }, Lln = /* @__PURE__ */ e("path", {
  d: "M24,184V161.1C24,103.6,70.2,56.2,127.6,56A104,104,0,0,1,232,160v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,184Z",
  opacity: "0.2"
}, null, -1), Bln = ["stroke"], Pln = ["stroke"], Wln = ["stroke"], Nln = ["stroke"], Fln = ["stroke"], Tln = { key: 2 }, Dln = /* @__PURE__ */ e("path", { d: "M240,160v24a16,16,0,0,1-16,16H115.5a4,4,0,0,1-3.2-6.4L178,108a8.2,8.2,0,0,0-1.1-11.3A7.9,7.9,0,0,0,165.5,98L88.4,198.4a3.8,3.8,0,0,1-3.1,1.6H32a16,16,0,0,1-16-16V161.1a116.1,116.1,0,0,1,2.2-22.2L40.9,145l2.1.2a8,8,0,0,0,7.8-6.2,8.1,8.1,0,0,0-6-9.6l-22.4-6C37,82,74.9,51.5,120,48.3V71.7a8.2,8.2,0,0,0,7.5,8.3,8,8,0,0,0,8.5-8V48.3a111.5,111.5,0,0,1,71.1,32.4,112.7,112.7,0,0,1,26.8,42.6l-22.7,6.1a8.1,8.1,0,0,0-6,9.6,8,8,0,0,0,7.8,6.2l2.1-.2,22.9-6.2A114.5,114.5,0,0,1,240,160Z" }, null, -1), Rln = [
  Dln
], Uln = { key: 3 }, qln = ["stroke"], Gln = ["stroke"], Eln = ["stroke"], Oln = ["stroke"], Iln = ["stroke"], Kln = { key: 4 }, Xln = ["stroke"], Jln = ["stroke"], Qln = ["stroke"], Yln = ["stroke"], o2n = ["stroke"], e2n = { key: 5 }, t2n = ["stroke"], n2n = ["stroke"], s2n = ["stroke"], r2n = ["stroke"], i2n = ["stroke"], l2n = {
  name: "PhGauge"
}, VI1 = /* @__PURE__ */ $({
  ...l2n,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Hln, [
        e("path", {
          d: "M24,184V161.1C24,103.6,70.2,56.2,127.6,56A104,104,0,0,1,232,160v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,184Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Aln),
        e("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vln),
        e("line", {
          x1: "27.5",
          y1: "133.1",
          x2: "58.5",
          y2: "141.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zln),
        e("line", {
          x1: "228.5",
          y1: "133.1",
          x2: "197.5",
          y2: "141.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zln),
        e("line", {
          x1: "103.4",
          y1: "192",
          x2: "171.8",
          y2: "102.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cln)
      ])) : o(i) === "duotone" ? (s(), r("g", bln, [
        Lln,
        e("path", {
          d: "M24,184V161.1C24,103.6,70.2,56.2,127.6,56A104,104,0,0,1,232,160v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,184Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bln),
        e("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pln),
        e("line", {
          x1: "27.5",
          y1: "133.1",
          x2: "58.5",
          y2: "141.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wln),
        e("line", {
          x1: "228.5",
          y1: "133.1",
          x2: "197.5",
          y2: "141.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nln),
        e("line", {
          x1: "103.4",
          y1: "192",
          x2: "171.8",
          y2: "102.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fln)
      ])) : o(i) === "fill" ? (s(), r("g", Tln, Rln)) : o(i) === "light" ? (s(), r("g", Uln, [
        e("path", {
          d: "M24,184V161.1C24,103.6,70.2,56.2,127.6,56A104,104,0,0,1,232,160v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,184Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qln),
        e("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gln),
        e("line", {
          x1: "27.5",
          y1: "133.1",
          x2: "58.5",
          y2: "141.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Eln),
        e("line", {
          x1: "228.5",
          y1: "133.1",
          x2: "197.5",
          y2: "141.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Oln),
        e("line", {
          x1: "103.4",
          y1: "192",
          x2: "171.8",
          y2: "102.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Iln)
      ])) : o(i) === "thin" ? (s(), r("g", Kln, [
        e("path", {
          d: "M24,184V161.1C24,103.6,70.2,56.2,127.6,56A104,104,0,0,1,232,160v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,184Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xln),
        e("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jln),
        e("line", {
          x1: "27.5",
          y1: "133.1",
          x2: "58.5",
          y2: "141.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qln),
        e("line", {
          x1: "228.5",
          y1: "133.1",
          x2: "197.5",
          y2: "141.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Yln),
        e("line", {
          x1: "103.4",
          y1: "192",
          x2: "171.8",
          y2: "102.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, o2n)
      ])) : o(i) === "regular" ? (s(), r("g", e2n, [
        e("path", {
          d: "M24,184V161.1C24,103.6,70.2,56.2,127.6,56A104,104,0,0,1,232,160v24a8,8,0,0,1-8,8H32A8,8,0,0,1,24,184Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t2n),
        e("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n2n),
        e("line", {
          x1: "27.5",
          y1: "133.1",
          x2: "58.5",
          y2: "141.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s2n),
        e("line", {
          x1: "228.5",
          y1: "133.1",
          x2: "197.5",
          y2: "141.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r2n),
        e("line", {
          x1: "103.4",
          y1: "192",
          x2: "171.8",
          y2: "102.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, i2n)
      ])) : g("", !0)
    ], 16, Sln));
  }
}), d2n = ["width", "height", "fill", "transform"], k2n = { key: 0 }, c2n = ["stroke"], h2n = ["stroke"], u2n = { key: 1 }, a2n = /* @__PURE__ */ e("path", {
  d: "M211.8,133.1c.3-3.4,0-10.2,0-10.2l16.6-22.1a103.2,103.2,0,0,0-10.2-24.6l-27.3-3.9q-3.5-3.7-7.2-7.2l-3.9-27.3a102.2,102.2,0,0,0-24.6-10.2L133.1,44.2a57.9,57.9,0,0,0-10.2,0L100.8,27.6A103.2,103.2,0,0,0,76.2,37.8L72.3,65.1q-3.7,3.5-7.2,7.2L37.8,76.2a102.2,102.2,0,0,0-10.2,24.6l16.6,22.1c-.2,3.4,0,10.2,0,10.2L27.6,155.2a103.2,103.2,0,0,0,10.2,24.6l27.3,3.9q3.5,3.8,7.2,7.2l3.9,27.3a102.2,102.2,0,0,0,24.6,10.2l22.1-16.6a57.9,57.9,0,0,0,10.2,0l22.1,16.6a103.2,103.2,0,0,0,24.6-10.2l3.9-27.3c2.5-2.3,7.2-7.2,7.2-7.2l27.3-3.9a102.2,102.2,0,0,0,10.2-24.6ZM128,176a48,48,0,1,1,48-48A48,48,0,0,1,128,176Z",
  opacity: "0.2"
}, null, -1), _2n = ["stroke"], p2n = ["stroke"], y2n = { key: 2 }, $2n = /* @__PURE__ */ e("path", { d: "M234.8,150.4l-14.9-19.8c.1-1.8,0-3.7,0-5.1l14.9-19.9a7.8,7.8,0,0,0,1.3-6.9,114.8,114.8,0,0,0-10.9-26.4,8.2,8.2,0,0,0-5.8-4l-24.5-3.5-3.7-3.7-3.5-24.5a8.4,8.4,0,0,0-3.9-5.8,117.5,117.5,0,0,0-26.5-10.9,7.8,7.8,0,0,0-6.9,1.3L130.6,36h-5.2L105.6,21.2a7.8,7.8,0,0,0-6.9-1.3A114.8,114.8,0,0,0,72.3,30.8a8.2,8.2,0,0,0-4,5.8L64.8,61.1l-3.7,3.7L36.6,68.3a8.2,8.2,0,0,0-5.8,4A114.8,114.8,0,0,0,19.9,98.7a7.8,7.8,0,0,0,1.3,6.9l14.9,19.8v5.1L21.2,150.4a7.8,7.8,0,0,0-1.3,6.9,114.8,114.8,0,0,0,10.9,26.4,8.2,8.2,0,0,0,5.8,4l24.5,3.5,3.7,3.7,3.5,24.5a8.2,8.2,0,0,0,4,5.8,114.8,114.8,0,0,0,26.4,10.9,7.6,7.6,0,0,0,2.1.3,7.7,7.7,0,0,0,4.8-1.6L125.4,220h5.2l19.8,14.8a7.8,7.8,0,0,0,6.9,1.3,113,113,0,0,0,26.4-10.9,8.2,8.2,0,0,0,4-5.8l3.5-24.6c1.2-1.2,2.6-2.5,3.6-3.6l24.6-3.5a8.2,8.2,0,0,0,5.8-4,114.8,114.8,0,0,0,10.9-26.4A7.8,7.8,0,0,0,234.8,150.4ZM128,172a44,44,0,1,1,44-44A44,44,0,0,1,128,172Z" }, null, -1), w2n = [
  $2n
], f2n = { key: 3 }, g2n = ["stroke"], x2n = ["stroke"], j2n = { key: 4 }, m2n = ["stroke"], M2n = ["stroke"], v2n = { key: 5 }, S2n = ["stroke"], H2n = ["stroke"], A2n = {
  name: "PhGear"
}, zI1 = /* @__PURE__ */ $({
  ...A2n,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", k2n, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, c2n),
        e("path", {
          d: "M183.7,65.1q3.8,3.5,7.2,7.2l27.3,3.9a103.2,103.2,0,0,1,10.2,24.6l-16.6,22.1s.3,6.8,0,10.2l16.6,22.1a102.2,102.2,0,0,1-10.2,24.6l-27.3,3.9s-4.7,4.9-7.2,7.2l-3.9,27.3a103.2,103.2,0,0,1-24.6,10.2l-22.1-16.6a57.9,57.9,0,0,1-10.2,0l-22.1,16.6a102.2,102.2,0,0,1-24.6-10.2l-3.9-27.3q-3.7-3.5-7.2-7.2l-27.3-3.9a103.2,103.2,0,0,1-10.2-24.6l16.6-22.1s-.2-6.8,0-10.2L27.6,100.8A102.2,102.2,0,0,1,37.8,76.2l27.3-3.9q3.5-3.7,7.2-7.2l3.9-27.3a103.2,103.2,0,0,1,24.6-10.2l22.1,16.6a57.9,57.9,0,0,1,10.2,0l22.1-16.6a102.2,102.2,0,0,1,24.6,10.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, h2n)
      ])) : o(i) === "duotone" ? (s(), r("g", u2n, [
        a2n,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _2n),
        e("path", {
          d: "M183.7,65.1q3.8,3.5,7.2,7.2l27.3,3.9a103.2,103.2,0,0,1,10.2,24.6l-16.6,22.1s.3,6.8,0,10.2l16.6,22.1a102.2,102.2,0,0,1-10.2,24.6l-27.3,3.9s-4.7,4.9-7.2,7.2l-3.9,27.3a103.2,103.2,0,0,1-24.6,10.2l-22.1-16.6a57.9,57.9,0,0,1-10.2,0l-22.1,16.6a102.2,102.2,0,0,1-24.6-10.2l-3.9-27.3q-3.7-3.5-7.2-7.2l-27.3-3.9a103.2,103.2,0,0,1-10.2-24.6l16.6-22.1s-.2-6.8,0-10.2L27.6,100.8A102.2,102.2,0,0,1,37.8,76.2l27.3-3.9q3.5-3.7,7.2-7.2l3.9-27.3a103.2,103.2,0,0,1,24.6-10.2l22.1,16.6a57.9,57.9,0,0,1,10.2,0l22.1-16.6a102.2,102.2,0,0,1,24.6,10.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p2n)
      ])) : o(i) === "fill" ? (s(), r("g", y2n, w2n)) : o(i) === "light" ? (s(), r("g", f2n, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, g2n),
        e("path", {
          d: "M183.7,65.1q3.8,3.5,7.2,7.2l27.3,3.9a103.2,103.2,0,0,1,10.2,24.6l-16.6,22.1s.3,6.8,0,10.2l16.6,22.1a102.2,102.2,0,0,1-10.2,24.6l-27.3,3.9s-4.7,4.9-7.2,7.2l-3.9,27.3a103.2,103.2,0,0,1-24.6,10.2l-22.1-16.6a57.9,57.9,0,0,1-10.2,0l-22.1,16.6a102.2,102.2,0,0,1-24.6-10.2l-3.9-27.3q-3.7-3.5-7.2-7.2l-27.3-3.9a103.2,103.2,0,0,1-10.2-24.6l16.6-22.1s-.3-6.8,0-10.2L27.6,100.8A102.2,102.2,0,0,1,37.8,76.2l27.3-3.9q3.5-3.7,7.2-7.2l3.9-27.3a103.2,103.2,0,0,1,24.6-10.2l22.1,16.6a57.9,57.9,0,0,1,10.2,0l22.1-16.6a102.2,102.2,0,0,1,24.6,10.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, x2n)
      ])) : o(i) === "thin" ? (s(), r("g", j2n, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, m2n),
        e("path", {
          d: "M183.7,65.1q3.8,3.5,7.2,7.2l27.3,3.9a103.2,103.2,0,0,1,10.2,24.6l-16.6,22.1s.3,6.8,0,10.2l16.6,22.1a102.2,102.2,0,0,1-10.2,24.6l-27.3,3.9s-4.7,4.9-7.2,7.2l-3.9,27.3a103.2,103.2,0,0,1-24.6,10.2l-22.1-16.6a57.9,57.9,0,0,1-10.2,0l-22.1,16.6a102.2,102.2,0,0,1-24.6-10.2l-3.9-27.3q-3.7-3.5-7.2-7.2l-27.3-3.9a103.2,103.2,0,0,1-10.2-24.6l16.6-22.1s-.3-6.8,0-10.2L27.6,100.8A102.2,102.2,0,0,1,37.8,76.2l27.3-3.9q3.5-3.7,7.2-7.2l3.9-27.3a103.2,103.2,0,0,1,24.6-10.2l22.1,16.6a57.9,57.9,0,0,1,10.2,0l22.1-16.6a102.2,102.2,0,0,1,24.6,10.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, M2n)
      ])) : o(i) === "regular" ? (s(), r("g", v2n, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S2n),
        e("path", {
          d: "M183.7,65.1q3.8,3.5,7.2,7.2l27.3,3.9a103.2,103.2,0,0,1,10.2,24.6l-16.6,22.1s.3,6.8,0,10.2l16.6,22.1a102.2,102.2,0,0,1-10.2,24.6l-27.3,3.9s-4.7,4.9-7.2,7.2l-3.9,27.3a103.2,103.2,0,0,1-24.6,10.2l-22.1-16.6a57.9,57.9,0,0,1-10.2,0l-22.1,16.6a102.2,102.2,0,0,1-24.6-10.2l-3.9-27.3q-3.7-3.5-7.2-7.2l-27.3-3.9a103.2,103.2,0,0,1-10.2-24.6l16.6-22.1s-.3-6.8,0-10.2L27.6,100.8A102.2,102.2,0,0,1,37.8,76.2l27.3-3.9q3.5-3.7,7.2-7.2l3.9-27.3a103.2,103.2,0,0,1,24.6-10.2l22.1,16.6a57.9,57.9,0,0,1,10.2,0l22.1-16.6a102.2,102.2,0,0,1,24.6,10.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H2n)
      ])) : g("", !0)
    ], 16, d2n));
  }
}), V2n = ["width", "height", "fill", "transform"], z2n = { key: 0 }, Z2n = ["stroke"], C2n = ["stroke"], b2n = { key: 1 }, L2n = /* @__PURE__ */ e("path", {
  d: "M229.6,106,203.7,91.6a73.6,73.6,0,0,0-6.3-10.9l.5-29.7a102.6,102.6,0,0,0-38.2-22L134.3,44.2a88.3,88.3,0,0,0-12.6,0L96.2,28.9A104,104,0,0,0,58.1,51l.5,29.7a73.6,73.6,0,0,0-6.3,10.9L26.3,106a103.6,103.6,0,0,0,.1,44l25.9,14.4a80.1,80.1,0,0,0,6.3,11L58.1,205a102.6,102.6,0,0,0,38.2,22l25.4-15.2a88.3,88.3,0,0,0,12.6,0l25.5,15.3A104,104,0,0,0,197.9,205l-.5-29.7a73.6,73.6,0,0,0,6.3-10.9l26-14.4A102,102,0,0,0,229.6,106ZM128,176a48,48,0,1,1,48-48A48,48,0,0,1,128,176Z",
  opacity: "0.2"
}, null, -1), B2n = ["stroke"], P2n = ["stroke"], W2n = { key: 2 }, N2n = /* @__PURE__ */ e("path", { d: "M237.5,104.3a8,8,0,0,0-4-5.3L209.7,85.8q-1.9-3.9-4.2-7.5l.4-27.2a8.3,8.3,0,0,0-2.6-6.1,112,112,0,0,0-41.1-23.7,8.1,8.1,0,0,0-6.6.8l-23.3,14c-2.9-.1-5.7-.1-8.6,0l-23.3-14a8.1,8.1,0,0,0-6.6-.8A111.1,111.1,0,0,0,52.7,45.1a7.9,7.9,0,0,0-2.6,6l.5,27.2c-1.6,2.4-3,4.9-4.4,7.5L22.5,99a7.7,7.7,0,0,0-4,5.3,111.4,111.4,0,0,0,0,47.4,8,8,0,0,0,4,5.3l23.8,13.2a69.3,69.3,0,0,0,4.3,7.5l-.5,27.2a8.3,8.3,0,0,0,2.6,6.1,112.9,112.9,0,0,0,41.1,23.7,8.1,8.1,0,0,0,6.6-.8l23.3-14h8.6l23.4,14a7.3,7.3,0,0,0,4.1,1.2,10,10,0,0,0,2.4-.4,111.1,111.1,0,0,0,41.1-23.8,7.9,7.9,0,0,0,2.6-6l-.4-27.2c1.5-2.4,2.9-4.9,4.3-7.5L233.6,157a7.9,7.9,0,0,0,3.9-5.3A111.4,111.4,0,0,0,237.5,104.3ZM172,128a44,44,0,1,1-44-44A44,44,0,0,1,172,128Z" }, null, -1), F2n = [
  N2n
], T2n = { key: 3 }, D2n = ["stroke"], R2n = ["stroke"], U2n = { key: 4 }, q2n = ["stroke"], G2n = ["stroke"], E2n = { key: 5 }, O2n = ["stroke"], I2n = ["stroke"], K2n = {
  name: "PhGearSix"
}, ZI1 = /* @__PURE__ */ $({
  ...K2n,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", z2n, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Z2n),
        e("path", {
          d: "M197.4,80.7a73.6,73.6,0,0,1,6.3,10.9L229.6,106a102,102,0,0,1,.1,44l-26,14.4a73.6,73.6,0,0,1-6.3,10.9l.5,29.7a104,104,0,0,1-38.1,22.1l-25.5-15.3a88.3,88.3,0,0,1-12.6,0L96.3,227a102.6,102.6,0,0,1-38.2-22l.5-29.6a80.1,80.1,0,0,1-6.3-11L26.4,150a102,102,0,0,1-.1-44l26-14.4a73.6,73.6,0,0,1,6.3-10.9L58.1,51A104,104,0,0,1,96.2,28.9l25.5,15.3a88.3,88.3,0,0,1,12.6,0L159.7,29a102.6,102.6,0,0,1,38.2,22Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, C2n)
      ])) : o(i) === "duotone" ? (s(), r("g", b2n, [
        L2n,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B2n),
        e("path", {
          d: "M197.4,80.7a73.6,73.6,0,0,1,6.3,10.9L229.6,106a102,102,0,0,1,.1,44l-26,14.4a73.6,73.6,0,0,1-6.3,10.9l.5,29.7a104,104,0,0,1-38.1,22.1l-25.5-15.3a88.3,88.3,0,0,1-12.6,0L96.3,227a102.6,102.6,0,0,1-38.2-22l.5-29.6a80.1,80.1,0,0,1-6.3-11L26.4,150a103.6,103.6,0,0,1-.1-44l26-14.4a73.6,73.6,0,0,1,6.3-10.9L58.1,51A104,104,0,0,1,96.2,28.9l25.5,15.3a88.3,88.3,0,0,1,12.6,0L159.7,29a102.6,102.6,0,0,1,38.2,22Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P2n)
      ])) : o(i) === "fill" ? (s(), r("g", W2n, F2n)) : o(i) === "light" ? (s(), r("g", T2n, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, D2n),
        e("path", {
          d: "M197.4,80.7a73.6,73.6,0,0,1,6.3,10.9L229.6,106a102,102,0,0,1,.1,44l-26,14.4a73.6,73.6,0,0,1-6.3,10.9l.5,29.7a104,104,0,0,1-38.1,22.1l-25.5-15.3a88.3,88.3,0,0,1-12.6,0L96.3,227a102.6,102.6,0,0,1-38.2-22l.5-29.6a80.1,80.1,0,0,1-6.3-11L26.4,150a102,102,0,0,1-.1-44l26-14.4a73.6,73.6,0,0,1,6.3-10.9L58.1,51A104,104,0,0,1,96.2,28.9l25.5,15.3a88.3,88.3,0,0,1,12.6,0L159.7,29a102.6,102.6,0,0,1,38.2,22Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, R2n)
      ])) : o(i) === "thin" ? (s(), r("g", U2n, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, q2n),
        e("path", {
          d: "M197.4,80.7a73.6,73.6,0,0,1,6.3,10.9L229.6,106a102,102,0,0,1,.1,44l-26,14.4a73.6,73.6,0,0,1-6.3,10.9l.5,29.7a104,104,0,0,1-38.1,22.1l-25.5-15.3a88.3,88.3,0,0,1-12.6,0L96.3,227a102.6,102.6,0,0,1-38.2-22l.5-29.6a80.1,80.1,0,0,1-6.3-11L26.4,150a102,102,0,0,1-.1-44l26-14.4a73.6,73.6,0,0,1,6.3-10.9L58.1,51A104,104,0,0,1,96.2,28.9l25.5,15.3a88.3,88.3,0,0,1,12.6,0L159.7,29a102.6,102.6,0,0,1,38.2,22Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, G2n)
      ])) : o(i) === "regular" ? (s(), r("g", E2n, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O2n),
        e("path", {
          d: "M197.4,80.7a73.6,73.6,0,0,1,6.3,10.9L229.6,106a102,102,0,0,1,.1,44l-26,14.4a73.6,73.6,0,0,1-6.3,10.9l.5,29.7a104,104,0,0,1-38.1,22.1l-25.5-15.3a88.3,88.3,0,0,1-12.6,0L96.3,227a102.6,102.6,0,0,1-38.2-22l.5-29.6a80.1,80.1,0,0,1-6.3-11L26.4,150a102,102,0,0,1-.1-44l26-14.4a73.6,73.6,0,0,1,6.3-10.9L58.1,51A104,104,0,0,1,96.2,28.9l25.5,15.3a88.3,88.3,0,0,1,12.6,0L159.7,29a102.6,102.6,0,0,1,38.2,22Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I2n)
      ])) : g("", !0)
    ], 16, V2n));
  }
}), X2n = ["width", "height", "fill", "transform"], J2n = { key: 0 }, Q2n = ["stroke"], Y2n = ["stroke"], o0n = ["stroke"], e0n = { key: 1 }, t0n = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "96",
  r: "72",
  opacity: "0.2"
}, null, -1), n0n = ["stroke"], s0n = ["stroke"], r0n = ["stroke"], i0n = { key: 2 }, l0n = /* @__PURE__ */ e("path", { d: "M208,96a80,80,0,1,0-88,79.6V200H88a8,8,0,0,0,0,16h32v24a8,8,0,0,0,16,0V216h32a8,8,0,0,0,0-16H136V175.6A80.1,80.1,0,0,0,208,96ZM64,96a64,64,0,1,1,64,64A64.1,64.1,0,0,1,64,96Z" }, null, -1), d0n = [
  l0n
], k0n = { key: 3 }, c0n = ["stroke"], h0n = ["stroke"], u0n = ["stroke"], a0n = { key: 4 }, _0n = ["stroke"], p0n = ["stroke"], y0n = ["stroke"], $0n = { key: 5 }, w0n = ["stroke"], f0n = ["stroke"], g0n = ["stroke"], x0n = {
  name: "PhGenderFemale"
}, CI1 = /* @__PURE__ */ $({
  ...x0n,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", J2n, [
        e("circle", {
          cx: "128",
          cy: "96",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Q2n),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Y2n),
        e("line", {
          x1: "88",
          y1: "208",
          x2: "168",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, o0n)
      ])) : o(i) === "duotone" ? (s(), r("g", e0n, [
        t0n,
        e("circle", {
          cx: "128",
          cy: "96",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n0n),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s0n),
        e("line", {
          x1: "88",
          y1: "208",
          x2: "168",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r0n)
      ])) : o(i) === "fill" ? (s(), r("g", i0n, d0n)) : o(i) === "light" ? (s(), r("g", k0n, [
        e("circle", {
          cx: "128",
          cy: "96",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, c0n),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, h0n),
        e("line", {
          x1: "88",
          y1: "208",
          x2: "168",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u0n)
      ])) : o(i) === "thin" ? (s(), r("g", a0n, [
        e("circle", {
          cx: "128",
          cy: "96",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _0n),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, p0n),
        e("line", {
          x1: "88",
          y1: "208",
          x2: "168",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, y0n)
      ])) : o(i) === "regular" ? (s(), r("g", $0n, [
        e("circle", {
          cx: "128",
          cy: "96",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w0n),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f0n),
        e("line", {
          x1: "88",
          y1: "208",
          x2: "168",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g0n)
      ])) : g("", !0)
    ], 16, X2n));
  }
}), j0n = ["width", "height", "fill", "transform"], m0n = { key: 0 }, M0n = ["stroke"], v0n = ["stroke"], S0n = ["stroke"], H0n = ["stroke"], A0n = ["stroke"], V0n = { key: 1 }, z0n = /* @__PURE__ */ e("circle", {
  cx: "120",
  cy: "108",
  r: "60",
  opacity: "0.2"
}, null, -1), Z0n = ["stroke"], C0n = ["stroke"], b0n = ["stroke"], L0n = ["stroke"], B0n = ["stroke"], P0n = { key: 2 }, W0n = /* @__PURE__ */ e("path", { d: "M208,16H168a8,8,0,0,0,0,16h20.7L164.3,56.4A68,68,0,1,0,112,175.5V196H88a8,8,0,0,0,0,16h24v20a8,8,0,0,0,16,0V212h24a8,8,0,0,0,0-16H128V175.5A67.9,67.9,0,0,0,175.1,68.2L200,43.3V64a8,8,0,0,0,16,0V24A8,8,0,0,0,208,16ZM120,160a52,52,0,1,1,52-52A52,52,0,0,1,120,160Z" }, null, -1), N0n = [
  W0n
], F0n = { key: 3 }, T0n = ["stroke"], D0n = ["stroke"], R0n = ["stroke"], U0n = ["stroke"], q0n = ["stroke"], G0n = { key: 4 }, E0n = ["stroke"], O0n = ["stroke"], I0n = ["stroke"], K0n = ["stroke"], X0n = ["stroke"], J0n = { key: 5 }, Q0n = ["stroke"], Y0n = ["stroke"], o8n = ["stroke"], e8n = ["stroke"], t8n = ["stroke"], n8n = {
  name: "PhGenderIntersex"
}, bI1 = /* @__PURE__ */ $({
  ...n8n,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", m0n, [
        e("circle", {
          cx: "120",
          cy: "108",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, M0n),
        e("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, v0n),
        e("line", {
          x1: "88",
          y1: "204",
          x2: "152",
          y2: "204",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, S0n),
        e("polyline", {
          points: "172 24 208 24 208 60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, H0n),
        e("line", {
          x1: "164.4",
          y1: "67.6",
          x2: "208",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, A0n)
      ])) : o(i) === "duotone" ? (s(), r("g", V0n, [
        z0n,
        e("circle", {
          cx: "120",
          cy: "108",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z0n),
        e("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C0n),
        e("line", {
          x1: "88",
          y1: "204",
          x2: "152",
          y2: "204",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b0n),
        e("polyline", {
          points: "168 24 208 24 208 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L0n),
        e("line", {
          x1: "164.4",
          y1: "67.6",
          x2: "208",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B0n)
      ])) : o(i) === "fill" ? (s(), r("g", P0n, N0n)) : o(i) === "light" ? (s(), r("g", F0n, [
        e("circle", {
          cx: "120",
          cy: "108",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, T0n),
        e("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, D0n),
        e("line", {
          x1: "88",
          y1: "204",
          x2: "152",
          y2: "204",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, R0n),
        e("polyline", {
          points: "168 24 208 24 208 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, U0n),
        e("line", {
          x1: "164.4",
          y1: "67.6",
          x2: "208",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, q0n)
      ])) : o(i) === "thin" ? (s(), r("g", G0n, [
        e("circle", {
          cx: "120",
          cy: "108",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, E0n),
        e("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, O0n),
        e("line", {
          x1: "88",
          y1: "204",
          x2: "152",
          y2: "204",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, I0n),
        e("polyline", {
          points: "168 24 208 24 208 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, K0n),
        e("line", {
          x1: "164.4",
          y1: "67.6",
          x2: "208",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, X0n)
      ])) : o(i) === "regular" ? (s(), r("g", J0n, [
        e("circle", {
          cx: "120",
          cy: "108",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q0n),
        e("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y0n),
        e("line", {
          x1: "88",
          y1: "204",
          x2: "152",
          y2: "204",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o8n),
        e("polyline", {
          points: "168 24 208 24 208 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e8n),
        e("line", {
          x1: "164.4",
          y1: "67.6",
          x2: "208",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t8n)
      ])) : g("", !0)
    ], 16, j0n));
  }
}), s8n = ["width", "height", "fill", "transform"], r8n = { key: 0 }, i8n = ["stroke"], l8n = ["stroke"], d8n = ["stroke"], k8n = { key: 1 }, c8n = /* @__PURE__ */ e("circle", {
  cx: "104",
  cy: "152",
  r: "72",
  opacity: "0.2"
}, null, -1), h8n = ["stroke"], u8n = ["stroke"], a8n = ["stroke"], _8n = { key: 2 }, p8n = /* @__PURE__ */ e("path", { d: "M216,32H168a8,8,0,0,0,0,16h28.7L154.6,90.1a80,80,0,1,0,11.3,11.3L208,59.3V88a8,8,0,0,0,16,0V40A8,8,0,0,0,216,32ZM149.3,197.3a64,64,0,1,1,0-90.6A64.3,64.3,0,0,1,149.3,197.3Z" }, null, -1), y8n = [
  p8n
], $8n = { key: 3 }, w8n = ["stroke"], f8n = ["stroke"], g8n = ["stroke"], x8n = { key: 4 }, j8n = ["stroke"], m8n = ["stroke"], M8n = ["stroke"], v8n = { key: 5 }, S8n = ["stroke"], H8n = ["stroke"], A8n = ["stroke"], V8n = {
  name: "PhGenderMale"
}, LI1 = /* @__PURE__ */ $({
  ...V8n,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", r8n, [
        e("circle", {
          cx: "104",
          cy: "152",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, i8n),
        e("line", {
          x1: "154.9",
          y1: "101.1",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, l8n),
        e("polyline", {
          points: "168 40 216 40 216 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, d8n)
      ])) : o(i) === "duotone" ? (s(), r("g", k8n, [
        c8n,
        e("circle", {
          cx: "104",
          cy: "152",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h8n),
        e("line", {
          x1: "154.9",
          y1: "101.1",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u8n),
        e("polyline", {
          points: "168 40 216 40 216 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a8n)
      ])) : o(i) === "fill" ? (s(), r("g", _8n, y8n)) : o(i) === "light" ? (s(), r("g", $8n, [
        e("circle", {
          cx: "104",
          cy: "152",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, w8n),
        e("line", {
          x1: "154.9",
          y1: "101.1",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, f8n),
        e("polyline", {
          points: "168 40 216 40 216 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, g8n)
      ])) : o(i) === "thin" ? (s(), r("g", x8n, [
        e("circle", {
          cx: "104",
          cy: "152",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, j8n),
        e("line", {
          x1: "154.9",
          y1: "101.1",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, m8n),
        e("polyline", {
          points: "168 40 216 40 216 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, M8n)
      ])) : o(i) === "regular" ? (s(), r("g", v8n, [
        e("circle", {
          cx: "104",
          cy: "152",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S8n),
        e("line", {
          x1: "154.9",
          y1: "101.1",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H8n),
        e("polyline", {
          points: "168 40 216 40 216 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A8n)
      ])) : g("", !0)
    ], 16, s8n));
  }
}), z8n = ["width", "height", "fill", "transform"], Z8n = { key: 0 }, C8n = ["stroke"], b8n = ["stroke"], L8n = { key: 1 }, B8n = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "104",
  r: "72",
  opacity: "0.2"
}, null, -1), P8n = ["stroke"], W8n = ["stroke"], N8n = { key: 2 }, F8n = /* @__PURE__ */ e("path", { d: "M208,104a80,80,0,1,0-88,79.6V232a8,8,0,0,0,16,0V183.6A80.1,80.1,0,0,0,208,104Zm-80,64a64,64,0,1,1,64-64A64.1,64.1,0,0,1,128,168Z" }, null, -1), T8n = [
  F8n
], D8n = { key: 3 }, R8n = ["stroke"], U8n = ["stroke"], q8n = { key: 4 }, G8n = ["stroke"], E8n = ["stroke"], O8n = { key: 5 }, I8n = ["stroke"], K8n = ["stroke"], X8n = {
  name: "PhGenderNeuter"
}, BI1 = /* @__PURE__ */ $({
  ...X8n,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Z8n, [
        e("circle", {
          cx: "128",
          cy: "104",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, C8n),
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, b8n)
      ])) : o(i) === "duotone" ? (s(), r("g", L8n, [
        B8n,
        e("circle", {
          cx: "128",
          cy: "104",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P8n),
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W8n)
      ])) : o(i) === "fill" ? (s(), r("g", N8n, T8n)) : o(i) === "light" ? (s(), r("g", D8n, [
        e("circle", {
          cx: "128",
          cy: "104",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, R8n),
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, U8n)
      ])) : o(i) === "thin" ? (s(), r("g", q8n, [
        e("circle", {
          cx: "128",
          cy: "104",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, G8n),
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, E8n)
      ])) : o(i) === "regular" ? (s(), r("g", O8n, [
        e("circle", {
          cx: "128",
          cy: "104",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I8n),
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K8n)
      ])) : g("", !0)
    ], 16, z8n));
  }
}), J8n = ["width", "height", "fill", "transform"], Q8n = { key: 0 }, Y8n = ["stroke"], odn = ["stroke"], edn = ["stroke"], tdn = ["stroke"], ndn = { key: 1 }, sdn = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "164",
  r: "68",
  opacity: "0.2"
}, null, -1), rdn = ["stroke"], idn = ["stroke"], ldn = ["stroke"], ddn = ["stroke"], kdn = { key: 2 }, cdn = /* @__PURE__ */ e("path", { d: "M136,88.4V59l23.3,15.6a7.2,7.2,0,0,0,4.4,1.4,8,8,0,0,0,4.5-14.6L142.3,44l25.9-17.4a8,8,0,1,0-8.9-13.2L128,34.4l-31.3-21a8,8,0,1,0-8.9,13.2L113.7,44,87.8,61.4A8,8,0,0,0,92.3,76a7.2,7.2,0,0,0,4.4-1.4L120,59V88.4a76,76,0,1,0,16,0ZM128,224a60,60,0,1,1,60-60A60,60,0,0,1,128,224Z" }, null, -1), hdn = [
  cdn
], udn = { key: 3 }, adn = ["stroke"], _dn = ["stroke"], pdn = ["stroke"], ydn = ["stroke"], $dn = { key: 4 }, wdn = ["stroke"], fdn = ["stroke"], gdn = ["stroke"], xdn = ["stroke"], jdn = { key: 5 }, mdn = ["stroke"], Mdn = ["stroke"], vdn = ["stroke"], Sdn = ["stroke"], Hdn = {
  name: "PhGenderNonbinary"
}, PI1 = /* @__PURE__ */ $({
  ...Hdn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Q8n, [
        e("circle", {
          cx: "128",
          cy: "164",
          r: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Y8n),
        e("line", {
          x1: "163.7",
          y1: "64",
          x2: "92.3",
          y2: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, odn),
        e("line", {
          x1: "92.3",
          y1: "64",
          x2: "163.7",
          y2: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, edn),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "42",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tdn)
      ])) : o(i) === "duotone" ? (s(), r("g", ndn, [
        sdn,
        e("circle", {
          cx: "128",
          cy: "164",
          r: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rdn),
        e("line", {
          x1: "163.7",
          y1: "68",
          x2: "92.3",
          y2: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, idn),
        e("line", {
          x1: "92.3",
          y1: "68",
          x2: "163.7",
          y2: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ldn),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ddn)
      ])) : o(i) === "fill" ? (s(), r("g", kdn, hdn)) : o(i) === "light" ? (s(), r("g", udn, [
        e("circle", {
          cx: "128",
          cy: "164",
          r: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, adn),
        e("line", {
          x1: "163.7",
          y1: "68",
          x2: "92.3",
          y2: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _dn),
        e("line", {
          x1: "92.3",
          y1: "68",
          x2: "163.7",
          y2: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pdn),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ydn)
      ])) : o(i) === "thin" ? (s(), r("g", $dn, [
        e("circle", {
          cx: "128",
          cy: "164",
          r: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wdn),
        e("line", {
          x1: "163.7",
          y1: "68",
          x2: "92.3",
          y2: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fdn),
        e("line", {
          x1: "92.3",
          y1: "68",
          x2: "163.7",
          y2: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gdn),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xdn)
      ])) : o(i) === "regular" ? (s(), r("g", jdn, [
        e("circle", {
          cx: "128",
          cy: "164",
          r: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mdn),
        e("line", {
          x1: "163.7",
          y1: "68",
          x2: "92.3",
          y2: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mdn),
        e("line", {
          x1: "92.3",
          y1: "68",
          x2: "163.7",
          y2: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vdn),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sdn)
      ])) : g("", !0)
    ], 16, J8n));
  }
}), Adn = ["width", "height", "fill", "transform"], Vdn = { key: 0 }, zdn = ["stroke"], Zdn = ["stroke"], Cdn = ["stroke"], bdn = ["stroke"], Ldn = { key: 1 }, Bdn = /* @__PURE__ */ e("circle", {
  cx: "96",
  cy: "160",
  r: "64",
  opacity: "0.2"
}, null, -1), Pdn = ["stroke"], Wdn = ["stroke"], Ndn = ["stroke"], Fdn = ["stroke"], Tdn = { key: 2 }, Ddn = /* @__PURE__ */ e("path", { d: "M216,32H168a8,8,0,0,0,0,16h28.7L168,76.7,149.7,58.3a8.1,8.1,0,0,0-11.4,11.4L156.7,88l-15.8,15.8a72.2,72.2,0,1,0,11.3,11.3L168,99.3l18.3,18.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4L179.3,88,208,59.3V88a8,8,0,0,0,16,0V40A8,8,0,0,0,216,32ZM135.6,199.6a56.1,56.1,0,0,1-79.2,0,56,56,0,0,1,79.2-79.2,56,56,0,0,1,0,79.2Z" }, null, -1), Rdn = [
  Ddn
], Udn = { key: 3 }, qdn = ["stroke"], Gdn = ["stroke"], Edn = ["stroke"], Odn = ["stroke"], Idn = { key: 4 }, Kdn = ["stroke"], Xdn = ["stroke"], Jdn = ["stroke"], Qdn = ["stroke"], Ydn = { key: 5 }, okn = ["stroke"], ekn = ["stroke"], tkn = ["stroke"], nkn = ["stroke"], skn = {
  name: "PhGenderTransgender"
}, WI1 = /* @__PURE__ */ $({
  ...skn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Vdn, [
        e("circle", {
          cx: "96",
          cy: "160",
          r: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zdn),
        e("line", {
          x1: "141.3",
          y1: "114.7",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zdn),
        e("polyline", {
          points: "172 40 216 40 216 84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cdn),
        e("line", {
          x1: "144",
          y1: "64",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bdn)
      ])) : o(i) === "duotone" ? (s(), r("g", Ldn, [
        Bdn,
        e("circle", {
          cx: "96",
          cy: "160",
          r: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pdn),
        e("line", {
          x1: "141.3",
          y1: "114.7",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wdn),
        e("polyline", {
          points: "168 40 216 40 216 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ndn),
        e("line", {
          x1: "144",
          y1: "64",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fdn)
      ])) : o(i) === "fill" ? (s(), r("g", Tdn, Rdn)) : o(i) === "light" ? (s(), r("g", Udn, [
        e("circle", {
          cx: "96",
          cy: "160",
          r: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qdn),
        e("line", {
          x1: "141.3",
          y1: "114.7",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gdn),
        e("polyline", {
          points: "168 40 216 40 216 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Edn),
        e("line", {
          x1: "144",
          y1: "64",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Odn)
      ])) : o(i) === "thin" ? (s(), r("g", Idn, [
        e("circle", {
          cx: "96",
          cy: "160",
          r: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kdn),
        e("line", {
          x1: "141.3",
          y1: "114.7",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xdn),
        e("polyline", {
          points: "168 40 216 40 216 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jdn),
        e("line", {
          x1: "144",
          y1: "64",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qdn)
      ])) : o(i) === "regular" ? (s(), r("g", Ydn, [
        e("circle", {
          cx: "96",
          cy: "160",
          r: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, okn),
        e("line", {
          x1: "141.3",
          y1: "114.7",
          x2: "216",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ekn),
        e("polyline", {
          points: "168 40 216 40 216 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tkn),
        e("line", {
          x1: "144",
          y1: "64",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nkn)
      ])) : g("", !0)
    ], 16, Adn));
  }
}), rkn = ["width", "height", "fill", "transform"], ikn = { key: 0 }, lkn = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "116",
  r: "16"
}, null, -1), dkn = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "116",
  r: "16"
}, null, -1), kkn = ["stroke"], ckn = { key: 1 }, hkn = /* @__PURE__ */ e("path", {
  d: "M216,216l-29.3-24-29.4,24L128,192,98.7,216,69.3,192,40,216V120a88,88,0,0,1,176,0Z",
  opacity: "0.2"
}, null, -1), ukn = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "116",
  r: "12"
}, null, -1), akn = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "116",
  r: "12"
}, null, -1), _kn = ["stroke"], pkn = { key: 2 }, ykn = /* @__PURE__ */ e("path", { d: "M128,24a96.2,96.2,0,0,0-96,96v96a8.1,8.1,0,0,0,13.1,6.2l24.2-19.9,24.3,19.9a8,8,0,0,0,10.1,0L128,202.3l24.3,19.9a8,8,0,0,0,10.1,0l24.3-19.9,24.2,19.9a7.9,7.9,0,0,0,8.5,1A7.9,7.9,0,0,0,224,216V120A96.2,96.2,0,0,0,128,24ZM100,128a12,12,0,1,1,12-12A12,12,0,0,1,100,128Zm56,0a12,12,0,1,1,12-12A12,12,0,0,1,156,128Z" }, null, -1), $kn = [
  ykn
], wkn = { key: 3 }, fkn = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "116",
  r: "10"
}, null, -1), gkn = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "116",
  r: "10"
}, null, -1), xkn = ["stroke"], jkn = { key: 4 }, mkn = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "116",
  r: "8"
}, null, -1), Mkn = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "116",
  r: "8"
}, null, -1), vkn = ["stroke"], Skn = { key: 5 }, Hkn = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "116",
  r: "12"
}, null, -1), Akn = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "116",
  r: "12"
}, null, -1), Vkn = ["stroke"], zkn = {
  name: "PhGhost"
}, NI1 = /* @__PURE__ */ $({
  ...zkn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ikn, [
        lkn,
        dkn,
        e("path", {
          d: "M216,216l-29.3-24-29.4,24L128,192,98.7,216,69.3,192,40,216V120a88,88,0,0,1,176,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kkn)
      ])) : o(i) === "duotone" ? (s(), r("g", ckn, [
        hkn,
        ukn,
        akn,
        e("path", {
          d: "M216,216l-29.3-24-29.4,24L128,192,98.7,216,69.3,192,40,216V120a88,88,0,0,1,176,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _kn)
      ])) : o(i) === "fill" ? (s(), r("g", pkn, $kn)) : o(i) === "light" ? (s(), r("g", wkn, [
        fkn,
        gkn,
        e("path", {
          d: "M216,216l-29.3-24-29.4,24L128,192,98.7,216,69.3,192,40,216V120a88,88,0,0,1,176,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xkn)
      ])) : o(i) === "thin" ? (s(), r("g", jkn, [
        mkn,
        Mkn,
        e("path", {
          d: "M216,216l-29.3-24-29.4,24L128,192,98.7,216,69.3,192,40,216V120a88,88,0,0,1,176,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vkn)
      ])) : o(i) === "regular" ? (s(), r("g", Skn, [
        Hkn,
        Akn,
        e("path", {
          d: "M216,216l-29.3-24-29.4,24L128,192,98.7,216,69.3,192,40,216V120a88,88,0,0,1,176,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vkn)
      ])) : g("", !0)
    ], 16, rkn));
  }
}), Zkn = ["width", "height", "fill", "transform"], Ckn = { key: 0 }, bkn = ["stroke"], Lkn = ["stroke"], Bkn = ["stroke"], Pkn = ["stroke"], Wkn = { key: 1 }, Nkn = ["stroke"], Fkn = ["stroke"], Tkn = ["stroke"], Dkn = ["stroke"], Rkn = { key: 2 }, Ukn = /* @__PURE__ */ e("path", { d: "M136,64a8,8,0,0,0-8,8V184a8,8,0,0,0,16,0V72A8,8,0,0,0,136,64Z" }, null, -1), qkn = /* @__PURE__ */ e("path", { d: "M228,64H180a8,8,0,0,0-8,8V184a8,8,0,0,0,16,0V136h28a8,8,0,0,0,0-16H188V80h40a8,8,0,0,0,0-16Z" }, null, -1), Gkn = /* @__PURE__ */ e("path", { d: "M96,120H72a8,8,0,0,0,0,16H88v16a24,24,0,0,1-48,0V104a24,24,0,0,1,47.2-6,8,8,0,0,0,15.5-4A40,40,0,0,0,24,104v48a40,40,0,0,0,80,0V128A8,8,0,0,0,96,120Z" }, null, -1), Ekn = [
  Ukn,
  qkn,
  Gkn
], Okn = { key: 3 }, Ikn = ["stroke"], Kkn = ["stroke"], Xkn = ["stroke"], Jkn = ["stroke"], Qkn = { key: 4 }, Ykn = ["stroke"], ocn = ["stroke"], ecn = ["stroke"], tcn = ["stroke"], ncn = { key: 5 }, scn = ["stroke"], rcn = ["stroke"], icn = ["stroke"], lcn = ["stroke"], dcn = {
  name: "PhGif"
}, FI1 = /* @__PURE__ */ $({
  ...dcn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ckn, [
        e("line", {
          x1: "136",
          y1: "72",
          x2: "136",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bkn),
        e("polyline", {
          points: "228 72 180 72 180 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lkn),
        e("line", {
          x1: "216",
          y1: "128",
          x2: "180",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bkn),
        e("path", {
          d: "M72,132H96v20a32,32,0,0,1-64,0V104a32,32,0,0,1,63-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pkn)
      ])) : o(i) === "duotone" ? (s(), r("g", Wkn, [
        e("line", {
          x1: "136",
          y1: "72",
          x2: "136",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nkn),
        e("polyline", {
          points: "228 72 180 72 180 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fkn),
        e("line", {
          x1: "216",
          y1: "128",
          x2: "180",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tkn),
        e("path", {
          d: "M72,128H96v24a32,32,0,0,1-64,0V104a32,32,0,0,1,63-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dkn)
      ])) : o(i) === "fill" ? (s(), r("g", Rkn, Ekn)) : o(i) === "light" ? (s(), r("g", Okn, [
        e("line", {
          x1: "136",
          y1: "72",
          x2: "136",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ikn),
        e("polyline", {
          points: "228 72 180 72 180 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kkn),
        e("line", {
          x1: "216",
          y1: "128",
          x2: "180",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xkn),
        e("path", {
          d: "M72,128H96v24a32,32,0,0,1-64,0V104a32,32,0,0,1,63-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jkn)
      ])) : o(i) === "thin" ? (s(), r("g", Qkn, [
        e("line", {
          x1: "136",
          y1: "72",
          x2: "136",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ykn),
        e("polyline", {
          points: "228 72 180 72 180 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ocn),
        e("line", {
          x1: "216",
          y1: "128",
          x2: "180",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ecn),
        e("path", {
          d: "M72,128H96v24a32,32,0,0,1-64,0V104a32,32,0,0,1,63-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tcn)
      ])) : o(i) === "regular" ? (s(), r("g", ncn, [
        e("line", {
          x1: "136",
          y1: "72",
          x2: "136",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, scn),
        e("polyline", {
          points: "228 72 180 72 180 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rcn),
        e("line", {
          x1: "216",
          y1: "128",
          x2: "180",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, icn),
        e("path", {
          d: "M72,128H96v24a32,32,0,0,1-64,0V104a32,32,0,0,1,63-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lcn)
      ])) : g("", !0)
    ], 16, Zkn));
  }
}), kcn = ["width", "height", "fill", "transform"], ccn = { key: 0 }, hcn = ["stroke"], ucn = ["stroke"], acn = ["stroke"], _cn = ["stroke"], pcn = ["stroke"], ycn = { key: 1 }, $cn = ["stroke"], wcn = ["stroke"], fcn = ["stroke"], gcn = ["stroke"], xcn = ["stroke"], jcn = /* @__PURE__ */ e("path", {
  d: "M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128Z",
  opacity: "0.2"
}, null, -1), mcn = { key: 2 }, Mcn = /* @__PURE__ */ e("path", { d: "M216,72H181a32,32,0,0,0-47.3-42.9,29.2,29.2,0,0,0-5.7,8.2,29.2,29.2,0,0,0-5.7-8.2A32,32,0,0,0,75,72H40A16,16,0,0,0,24,88v32a16,16,0,0,0,16,16v64a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V136a16,16,0,0,0,16-16V88A16,16,0,0,0,216,72ZM145,40.4A16,16,0,1,1,167.6,63c-4.9,5-19.2,7.7-31.3,8.7C137.3,59.6,140,45.3,145,40.4Zm-56.6,0a16.1,16.1,0,0,1,22.6,0c5,4.9,7.7,19.2,8.7,31.3-12.1-1-26.4-3.7-31.3-8.7A16.1,16.1,0,0,1,88.4,40.4ZM216,120H136v72a8,8,0,0,1-16,0V120H40V88h80v32h16V88h80v32Z" }, null, -1), vcn = [
  Mcn
], Scn = { key: 3 }, Hcn = ["stroke"], Acn = ["stroke"], Vcn = ["stroke"], zcn = ["stroke"], Zcn = ["stroke"], Ccn = { key: 4 }, bcn = ["stroke"], Lcn = ["stroke"], Bcn = ["stroke"], Pcn = ["stroke"], Wcn = ["stroke"], Ncn = { key: 5 }, Fcn = ["stroke"], Tcn = ["stroke"], Dcn = ["stroke"], Rcn = ["stroke"], Ucn = ["stroke"], qcn = {
  name: "PhGift"
}, TI1 = /* @__PURE__ */ $({
  ...qcn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ccn, [
        e("rect", {
          x: "32",
          y: "80",
          width: "192",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hcn),
        e("path", {
          d: "M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ucn),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, acn),
        e("path", {
          d: "M173.3,68.7C161.9,80,128,80,128,80s0-33.9,11.3-45.3a24,24,0,0,1,34,34Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _cn),
        e("path", {
          d: "M82.7,68.7C94.1,80,128,80,128,80s0-33.9-11.3-45.3a24,24,0,0,0-34,34Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pcn)
      ])) : o(i) === "duotone" ? (s(), r("g", ycn, [
        e("rect", {
          x: "32",
          y: "80",
          width: "192",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $cn),
        e("path", {
          d: "M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wcn),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fcn),
        e("path", {
          d: "M173.3,68.7C161.9,80,128,80,128,80s0-33.9,11.3-45.3a24,24,0,0,1,34,34Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gcn),
        e("path", {
          d: "M82.7,68.7C94.1,80,128,80,128,80s0-33.9-11.3-45.3a24,24,0,0,0-34,34Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xcn),
        jcn
      ])) : o(i) === "fill" ? (s(), r("g", mcn, vcn)) : o(i) === "light" ? (s(), r("g", Scn, [
        e("rect", {
          x: "32",
          y: "80",
          width: "192",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hcn),
        e("path", {
          d: "M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Acn),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vcn),
        e("path", {
          d: "M173.3,68.7C161.9,80,128,80,128,80s0-33.9,11.3-45.3a24,24,0,0,1,34,34Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zcn),
        e("path", {
          d: "M82.7,68.7C94.1,80,128,80,128,80s0-33.9-11.3-45.3a24,24,0,0,0-34,34Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zcn)
      ])) : o(i) === "thin" ? (s(), r("g", Ccn, [
        e("rect", {
          x: "32",
          y: "80",
          width: "192",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bcn),
        e("path", {
          d: "M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lcn),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bcn),
        e("path", {
          d: "M173.3,68.7C161.9,80,128,80,128,80s0-33.9,11.3-45.3a24,24,0,0,1,34,34Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pcn),
        e("path", {
          d: "M82.7,68.7C94.1,80,128,80,128,80s0-33.9-11.3-45.3a24,24,0,0,0-34,34Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wcn)
      ])) : o(i) === "regular" ? (s(), r("g", Ncn, [
        e("rect", {
          x: "32",
          y: "80",
          width: "192",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fcn),
        e("path", {
          d: "M208,128v72a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tcn),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dcn),
        e("path", {
          d: "M173.3,68.7C161.9,80,128,80,128,80s0-33.9,11.3-45.3a24,24,0,0,1,34,34Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rcn),
        e("path", {
          d: "M82.7,68.7C94.1,80,128,80,128,80s0-33.9-11.3-45.3a24,24,0,0,0-34,34Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ucn)
      ])) : g("", !0)
    ], 16, kcn));
  }
}), Gcn = ["width", "height", "fill", "transform"], Ecn = { key: 0 }, Ocn = ["stroke"], Icn = ["stroke"], Kcn = ["stroke"], Xcn = ["stroke"], Jcn = ["stroke"], Qcn = { key: 1 }, Ycn = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "68",
  r: "28",
  opacity: "0.2"
}, null, -1), ohn = ["stroke"], ehn = ["stroke"], thn = ["stroke"], nhn = ["stroke"], shn = ["stroke"], rhn = { key: 2 }, ihn = /* @__PURE__ */ e("path", { d: "M224,68a36,36,0,1,0-44,35.1v.9a16,16,0,0,1-16,16H92a32.2,32.2,0,0,0-16,4.3V103.1a36,36,0,1,0-16,0v49.8a36,36,0,1,0,16,0V152a16,16,0,0,1,16-16h72a32.1,32.1,0,0,0,32-32v-.9A36.1,36.1,0,0,0,224,68ZM48,68A20,20,0,1,1,68,88,20.1,20.1,0,0,1,48,68ZM88,188a20,20,0,1,1-20-20A20.1,20.1,0,0,1,88,188Z" }, null, -1), lhn = [
  ihn
], dhn = { key: 3 }, khn = ["stroke"], chn = ["stroke"], hhn = ["stroke"], uhn = ["stroke"], ahn = ["stroke"], _hn = { key: 4 }, phn = ["stroke"], yhn = ["stroke"], $hn = ["stroke"], whn = ["stroke"], fhn = ["stroke"], ghn = { key: 5 }, xhn = ["stroke"], jhn = ["stroke"], mhn = ["stroke"], Mhn = ["stroke"], vhn = ["stroke"], Shn = {
  name: "PhGitBranch"
}, DI1 = /* @__PURE__ */ $({
  ...Shn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ecn, [
        e("path", {
          d: "M68,160v-8a23.9,23.9,0,0,1,24-24h72a23.9,23.9,0,0,0,24-24V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ocn),
        e("line", {
          x1: "68",
          y1: "96",
          x2: "68",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Icn),
        e("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kcn),
        e("circle", {
          cx: "188",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xcn),
        e("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jcn)
      ])) : o(i) === "duotone" ? (s(), r("g", Qcn, [
        Ycn,
        e("path", {
          d: "M68,160v-8a23.9,23.9,0,0,1,24-24h72a24,24,0,0,0,24-24V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ohn),
        e("line", {
          x1: "68",
          y1: "96",
          x2: "68",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ehn),
        e("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, thn),
        e("circle", {
          cx: "188",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nhn),
        e("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, shn)
      ])) : o(i) === "fill" ? (s(), r("g", rhn, lhn)) : o(i) === "light" ? (s(), r("g", dhn, [
        e("path", {
          d: "M68,160v-8a23.9,23.9,0,0,1,24-24h72a23.9,23.9,0,0,0,24-24V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, khn),
        e("line", {
          x1: "68",
          y1: "96",
          x2: "68",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, chn),
        e("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hhn),
        e("circle", {
          cx: "188",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uhn),
        e("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ahn)
      ])) : o(i) === "thin" ? (s(), r("g", _hn, [
        e("path", {
          d: "M68,160v-8a23.9,23.9,0,0,1,24-24h72a23.9,23.9,0,0,0,24-24V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, phn),
        e("line", {
          x1: "68",
          y1: "96",
          x2: "68",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yhn),
        e("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $hn),
        e("circle", {
          cx: "188",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, whn),
        e("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fhn)
      ])) : o(i) === "regular" ? (s(), r("g", ghn, [
        e("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xhn),
        e("circle", {
          cx: "188",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jhn),
        e("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mhn),
        e("path", {
          d: "M68,160v-8a23.9,23.9,0,0,1,24-24h72a23.9,23.9,0,0,0,24-24V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mhn),
        e("line", {
          x1: "68",
          y1: "96",
          x2: "68",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vhn)
      ])) : g("", !0)
    ], 16, Gcn));
  }
}), Hhn = ["width", "height", "fill", "transform"], Ahn = { key: 0 }, Vhn = ["stroke"], zhn = ["stroke"], Zhn = ["stroke"], Chn = { key: 1 }, bhn = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "52",
  opacity: "0.2"
}, null, -1), Lhn = ["stroke"], Bhn = ["stroke"], Phn = ["stroke"], Whn = { key: 2 }, Nhn = /* @__PURE__ */ e("path", { d: "M248,120H187.5a60,60,0,0,0-118.9,0H8a8,8,0,0,0,0,16H68.6a60,60,0,0,0,118.9,0H248a8,8,0,0,0,0-16Z" }, null, -1), Fhn = [
  Nhn
], Thn = { key: 3 }, Dhn = ["stroke"], Rhn = ["stroke"], Uhn = ["stroke"], qhn = { key: 4 }, Ghn = ["stroke"], Ehn = ["stroke"], Ohn = ["stroke"], Ihn = { key: 5 }, Khn = ["stroke"], Xhn = ["stroke"], Jhn = ["stroke"], Qhn = {
  name: "PhGitCommit"
}, RI1 = /* @__PURE__ */ $({
  ...Qhn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ahn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "52",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vhn),
        e("line", {
          x1: "12",
          y1: "128",
          x2: "76",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zhn),
        e("line", {
          x1: "180",
          y1: "128",
          x2: "244",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zhn)
      ])) : o(i) === "duotone" ? (s(), r("g", Chn, [
        bhn,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "52",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lhn),
        e("line", {
          x1: "8",
          y1: "128",
          x2: "76",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bhn),
        e("line", {
          x1: "180",
          y1: "128",
          x2: "248",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Phn)
      ])) : o(i) === "fill" ? (s(), r("g", Whn, Fhn)) : o(i) === "light" ? (s(), r("g", Thn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "52",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dhn),
        e("line", {
          x1: "8",
          y1: "128",
          x2: "76",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rhn),
        e("line", {
          x1: "180",
          y1: "128",
          x2: "248",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Uhn)
      ])) : o(i) === "thin" ? (s(), r("g", qhn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "52",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ghn),
        e("line", {
          x1: "8",
          y1: "128",
          x2: "76",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ehn),
        e("line", {
          x1: "180",
          y1: "128",
          x2: "248",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ohn)
      ])) : o(i) === "regular" ? (s(), r("g", Ihn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "52",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Khn),
        e("line", {
          x1: "8",
          y1: "128",
          x2: "76",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xhn),
        e("line", {
          x1: "180",
          y1: "128",
          x2: "248",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jhn)
      ])) : g("", !0)
    ], 16, Hhn));
  }
}), Yhn = ["width", "height", "fill", "transform"], o6n = { key: 0 }, e6n = ["stroke"], t6n = ["stroke"], n6n = ["stroke"], s6n = ["stroke"], r6n = ["stroke"], i6n = ["stroke"], l6n = { key: 1 }, d6n = /* @__PURE__ */ e("circle", {
  cx: "196",
  cy: "188",
  r: "28",
  opacity: "0.2"
}, null, -1), k6n = /* @__PURE__ */ e("circle", {
  cx: "60",
  cy: "68",
  r: "28",
  opacity: "0.2"
}, null, -1), c6n = ["stroke"], h6n = ["stroke"], u6n = ["stroke"], a6n = ["stroke"], _6n = ["stroke"], p6n = ["stroke"], y6n = { key: 2 }, $6n = /* @__PURE__ */ e("path", { d: "M232,188a36,36,0,1,1-44-35.1v-33a40,40,0,0,0-11.7-28.3L152,67.3V88a8,8,0,0,1-16,0V48a8,8,0,0,1,8-8h40a8,8,0,0,1,0,16H163.3l24.3,24.3A55.5,55.5,0,0,1,204,119.9v33A36.1,36.1,0,0,1,232,188ZM112,160a8,8,0,0,0-8,8v20.7L79.7,164.4A40,40,0,0,1,68,136.1v-33a36,36,0,1,0-16,0v33a55.5,55.5,0,0,0,16.4,39.6L92.7,200H72a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V168A8,8,0,0,0,112,160Z" }, null, -1), w6n = [
  $6n
], f6n = { key: 3 }, g6n = ["stroke"], x6n = ["stroke"], j6n = ["stroke"], m6n = ["stroke"], M6n = ["stroke"], v6n = ["stroke"], S6n = { key: 4 }, H6n = ["stroke"], A6n = ["stroke"], V6n = ["stroke"], z6n = ["stroke"], Z6n = ["stroke"], C6n = ["stroke"], b6n = { key: 5 }, L6n = ["stroke"], B6n = ["stroke"], P6n = ["stroke"], W6n = ["stroke"], N6n = ["stroke"], F6n = ["stroke"], T6n = {
  name: "PhGitDiff"
}, UI1 = /* @__PURE__ */ $({
  ...T6n,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", o6n, [
        e("circle", {
          cx: "196",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, e6n),
        e("path", {
          d: "M196,160V119.9a48.2,48.2,0,0,0-14.1-34L144,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, t6n),
        e("polyline", {
          points: "144 88 144 48 184 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, n6n),
        e("circle", {
          cx: "60",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, s6n),
        e("path", {
          d: "M60,96v40.1a48.2,48.2,0,0,0,14.1,34L112,208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, r6n),
        e("polyline", {
          points: "112 168 112 208 72 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, i6n)
      ])) : o(i) === "duotone" ? (s(), r("g", l6n, [
        d6n,
        k6n,
        e("circle", {
          cx: "196",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c6n),
        e("path", {
          d: "M196,160V119.9a48.2,48.2,0,0,0-14.1-34L144,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h6n),
        e("polyline", {
          points: "144 88 144 48 184 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u6n),
        e("circle", {
          cx: "60",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a6n),
        e("path", {
          d: "M60,96v40.1a48.2,48.2,0,0,0,14.1,34L112,208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _6n),
        e("polyline", {
          points: "112 168 112 208 72 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p6n)
      ])) : o(i) === "fill" ? (s(), r("g", y6n, w6n)) : o(i) === "light" ? (s(), r("g", f6n, [
        e("circle", {
          cx: "196",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, g6n),
        e("path", {
          d: "M196,160V119.9a48.2,48.2,0,0,0-14.1-34L144,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, x6n),
        e("polyline", {
          points: "144 88 144 48 184 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, j6n),
        e("circle", {
          cx: "60",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, m6n),
        e("path", {
          d: "M60,96v40.1a48.2,48.2,0,0,0,14.1,34L112,208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, M6n),
        e("polyline", {
          points: "112 168 112 208 72 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, v6n)
      ])) : o(i) === "thin" ? (s(), r("g", S6n, [
        e("circle", {
          cx: "196",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, H6n),
        e("path", {
          d: "M196,160V119.9a48.2,48.2,0,0,0-14.1-34L144,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, A6n),
        e("polyline", {
          points: "144 88 144 48 184 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, V6n),
        e("circle", {
          cx: "60",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, z6n),
        e("path", {
          d: "M60,96v40.1a48.2,48.2,0,0,0,14.1,34L112,208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Z6n),
        e("polyline", {
          points: "112 168 112 208 72 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, C6n)
      ])) : o(i) === "regular" ? (s(), r("g", b6n, [
        e("circle", {
          cx: "196",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L6n),
        e("path", {
          d: "M196,160V119.9a48.2,48.2,0,0,0-14.1-34L144,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B6n),
        e("polyline", {
          points: "144 88 144 48 184 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P6n),
        e("circle", {
          cx: "60",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W6n),
        e("path", {
          d: "M60,96v40.1a48.2,48.2,0,0,0,14.1,34L112,208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N6n),
        e("polyline", {
          points: "112 168 112 208 72 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F6n)
      ])) : g("", !0)
    ], 16, Yhn));
  }
}), D6n = ["width", "height", "fill", "transform"], R6n = { key: 0 }, U6n = ["stroke"], q6n = ["stroke"], G6n = ["stroke"], E6n = ["stroke"], O6n = ["stroke"], I6n = { key: 1 }, K6n = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "68",
  r: "28",
  opacity: "0.2"
}, null, -1), X6n = /* @__PURE__ */ e("circle", {
  cx: "68",
  cy: "68",
  r: "28",
  opacity: "0.2"
}, null, -1), J6n = ["stroke"], Q6n = ["stroke"], Y6n = ["stroke"], oun = ["stroke"], eun = ["stroke"], tun = { key: 2 }, nun = /* @__PURE__ */ e("path", { d: "M224,68a36,36,0,1,0-44,35.1v.9a16,16,0,0,1-16,16H92a16,16,0,0,1-16-16v-.9a36,36,0,1,0-16,0v.9a32.1,32.1,0,0,0,32,32h28v16.9a36,36,0,1,0,16,0V136h28a32.1,32.1,0,0,0,32-32v-.9A36.1,36.1,0,0,0,224,68ZM148,188a20,20,0,1,1-20-20A20.1,20.1,0,0,1,148,188Z" }, null, -1), sun = [
  nun
], run = { key: 3 }, iun = ["stroke"], lun = ["stroke"], dun = ["stroke"], kun = ["stroke"], cun = ["stroke"], hun = { key: 4 }, uun = ["stroke"], aun = ["stroke"], _un = ["stroke"], pun = ["stroke"], yun = ["stroke"], $un = { key: 5 }, wun = ["stroke"], fun = ["stroke"], gun = ["stroke"], xun = ["stroke"], jun = ["stroke"], mun = {
  name: "PhGitFork"
}, qI1 = /* @__PURE__ */ $({
  ...mun,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", R6n, [
        e("circle", {
          cx: "128",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, U6n),
        e("circle", {
          cx: "188",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, q6n),
        e("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, G6n),
        e("path", {
          d: "M68,96v8a23.9,23.9,0,0,0,24,24h72a23.9,23.9,0,0,0,24-24V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, E6n),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, O6n)
      ])) : o(i) === "duotone" ? (s(), r("g", I6n, [
        K6n,
        X6n,
        e("circle", {
          cx: "128",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J6n),
        e("circle", {
          cx: "188",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q6n),
        e("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y6n),
        e("path", {
          d: "M68,96v8a23.9,23.9,0,0,0,24,24h72a23.9,23.9,0,0,0,24-24V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oun),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eun)
      ])) : o(i) === "fill" ? (s(), r("g", tun, sun)) : o(i) === "light" ? (s(), r("g", run, [
        e("circle", {
          cx: "128",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iun),
        e("circle", {
          cx: "188",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lun),
        e("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dun),
        e("path", {
          d: "M68,96v8a23.9,23.9,0,0,0,24,24h72a23.9,23.9,0,0,0,24-24V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kun),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cun)
      ])) : o(i) === "thin" ? (s(), r("g", hun, [
        e("circle", {
          cx: "128",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uun),
        e("circle", {
          cx: "188",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aun),
        e("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _un),
        e("path", {
          d: "M68,96v8a23.9,23.9,0,0,0,24,24h72a23.9,23.9,0,0,0,24-24V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pun),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yun)
      ])) : o(i) === "regular" ? (s(), r("g", $un, [
        e("circle", {
          cx: "128",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wun),
        e("circle", {
          cx: "188",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fun),
        e("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gun),
        e("path", {
          d: "M68,96v8a23.9,23.9,0,0,0,24,24h72a23.9,23.9,0,0,0,24-24V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xun),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jun)
      ])) : g("", !0)
    ], 16, D6n));
  }
}), Mun = ["width", "height", "fill", "transform"], vun = { key: 0 }, Sun = ["stroke"], Hun = ["stroke"], Aun = ["stroke"], Vun = ["stroke"], zun = { key: 1 }, Zun = /* @__PURE__ */ e("circle", {
  cx: "68",
  cy: "68",
  r: "28",
  opacity: "0.2"
}, null, -1), Cun = ["stroke"], bun = ["stroke"], Lun = ["stroke"], Bun = ["stroke"], Pun = { key: 2 }, Wun = /* @__PURE__ */ e("path", { d: "M188,104a36.1,36.1,0,0,0-35.8,32H130.5a40,40,0,0,1-30.8-14.4L82.5,100.9A35.9,35.9,0,1,0,60,103.1v49.8a36,36,0,1,0,16,0V118.1l11.5,13.7a55.4,55.4,0,0,0,43,20.2h23.6A36,36,0,1,0,188,104ZM88,188a20,20,0,1,1-20-20A20.1,20.1,0,0,1,88,188Zm100-28a20,20,0,1,1,20-20A20.1,20.1,0,0,1,188,160Z" }, null, -1), Nun = [
  Wun
], Fun = { key: 3 }, Tun = ["stroke"], Dun = ["stroke"], Run = ["stroke"], Uun = ["stroke"], qun = { key: 4 }, Gun = ["stroke"], Eun = ["stroke"], Oun = ["stroke"], Iun = ["stroke"], Kun = { key: 5 }, Xun = ["stroke"], Jun = ["stroke"], Qun = ["stroke"], Yun = ["stroke"], o4n = {
  name: "PhGitMerge"
}, GI1 = /* @__PURE__ */ $({
  ...o4n,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", vun, [
        e("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Sun),
        e("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hun),
        e("circle", {
          cx: "188",
          cy: "140",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Aun),
        e("path", {
          d: "M160,144H130.5a47.8,47.8,0,0,1-36.9-17.3L68,96v64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vun)
      ])) : o(i) === "duotone" ? (s(), r("g", zun, [
        Zun,
        e("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cun),
        e("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bun),
        e("circle", {
          cx: "188",
          cy: "140",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lun),
        e("path", {
          d: "M160,144H130.5a47.8,47.8,0,0,1-36.9-17.3L68,96v64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bun)
      ])) : o(i) === "fill" ? (s(), r("g", Pun, Nun)) : o(i) === "light" ? (s(), r("g", Fun, [
        e("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Tun),
        e("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dun),
        e("circle", {
          cx: "188",
          cy: "140",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Run),
        e("path", {
          d: "M160,144H130.5a47.8,47.8,0,0,1-36.9-17.3L68,96v64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Uun)
      ])) : o(i) === "thin" ? (s(), r("g", qun, [
        e("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gun),
        e("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Eun),
        e("circle", {
          cx: "188",
          cy: "140",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Oun),
        e("path", {
          d: "M160,144H130.5a47.8,47.8,0,0,1-36.9-17.3L68,96v64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Iun)
      ])) : o(i) === "regular" ? (s(), r("g", Kun, [
        e("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xun),
        e("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jun),
        e("circle", {
          cx: "188",
          cy: "140",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qun),
        e("path", {
          d: "M160,144H130.5a47.8,47.8,0,0,1-36.9-17.3L68,96v64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yun)
      ])) : g("", !0)
    ], 16, Mun));
  }
}), e4n = ["width", "height", "fill", "transform"], t4n = { key: 0 }, n4n = ["stroke"], s4n = ["stroke"], r4n = ["stroke"], i4n = ["stroke"], l4n = ["stroke"], d4n = ["stroke"], k4n = { key: 1 }, c4n = /* @__PURE__ */ e("circle", {
  cx: "68",
  cy: "68",
  r: "28",
  opacity: "0.2"
}, null, -1), h4n = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "188",
  r: "28",
  opacity: "0.2"
}, null, -1), u4n = ["stroke"], a4n = ["stroke"], _4n = ["stroke"], p4n = ["stroke"], y4n = ["stroke"], $4n = ["stroke"], w4n = { key: 2 }, f4n = /* @__PURE__ */ e("path", { d: "M104,68a36,36,0,1,0-44,35.1v49.8a36,36,0,1,0,16,0V103.1A36.1,36.1,0,0,0,104,68ZM88,188a20,20,0,1,1-20-20A20.1,20.1,0,0,1,88,188Zm136,0a36,36,0,1,1-44-35.1v-33a40,40,0,0,0-11.7-28.3L144,67.3V88a8,8,0,0,1-16,0V48a8,8,0,0,1,8-8h40a8,8,0,0,1,0,16H155.3l24.3,24.3A55.5,55.5,0,0,1,196,119.9v33A36.1,36.1,0,0,1,224,188Z" }, null, -1), g4n = [
  f4n
], x4n = { key: 3 }, j4n = ["stroke"], m4n = ["stroke"], M4n = ["stroke"], v4n = ["stroke"], S4n = ["stroke"], H4n = ["stroke"], A4n = { key: 4 }, V4n = ["stroke"], z4n = ["stroke"], Z4n = ["stroke"], C4n = ["stroke"], b4n = ["stroke"], L4n = ["stroke"], B4n = { key: 5 }, P4n = ["stroke"], W4n = ["stroke"], N4n = ["stroke"], F4n = ["stroke"], T4n = ["stroke"], D4n = ["stroke"], R4n = {
  name: "PhGitPullRequest"
}, EI1 = /* @__PURE__ */ $({
  ...R4n,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", t4n, [
        e("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, n4n),
        e("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, s4n),
        e("line", {
          x1: "68",
          y1: "96",
          x2: "68",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, r4n),
        e("circle", {
          cx: "188",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, i4n),
        e("path", {
          d: "M188,160V119.9a48.2,48.2,0,0,0-14.1-34L136,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, l4n),
        e("polyline", {
          points: "136 88 136 48 176 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, d4n)
      ])) : o(i) === "duotone" ? (s(), r("g", k4n, [
        c4n,
        h4n,
        e("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u4n),
        e("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a4n),
        e("circle", {
          cx: "188",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _4n),
        e("line", {
          x1: "68",
          y1: "96",
          x2: "68",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p4n),
        e("path", {
          d: "M188,160V119.9a48.2,48.2,0,0,0-14.1-34L136,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y4n),
        e("polyline", {
          points: "136 88 136 48 176 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $4n)
      ])) : o(i) === "fill" ? (s(), r("g", w4n, g4n)) : o(i) === "light" ? (s(), r("g", x4n, [
        e("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, j4n),
        e("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, m4n),
        e("line", {
          x1: "68",
          y1: "96",
          x2: "68",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, M4n),
        e("circle", {
          cx: "188",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, v4n),
        e("path", {
          d: "M188,160V119.9a48.2,48.2,0,0,0-14.1-34L136,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, S4n),
        e("polyline", {
          points: "136 88 136 48 176 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, H4n)
      ])) : o(i) === "thin" ? (s(), r("g", A4n, [
        e("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, V4n),
        e("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, z4n),
        e("line", {
          x1: "68",
          y1: "96",
          x2: "68",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Z4n),
        e("circle", {
          cx: "188",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, C4n),
        e("path", {
          d: "M188,160V119.9a48.2,48.2,0,0,0-14.1-34L136,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, b4n),
        e("polyline", {
          points: "136 88 136 48 176 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, L4n)
      ])) : o(i) === "regular" ? (s(), r("g", B4n, [
        e("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P4n),
        e("circle", {
          cx: "68",
          cy: "68",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W4n),
        e("line", {
          x1: "68",
          y1: "96",
          x2: "68",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N4n),
        e("circle", {
          cx: "188",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F4n),
        e("path", {
          d: "M188,160V119.9a48.2,48.2,0,0,0-14.1-34L136,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T4n),
        e("polyline", {
          points: "136 88 136 48 176 48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D4n)
      ])) : g("", !0)
    ], 16, e4n));
  }
}), U4n = ["width", "height", "fill", "transform"], q4n = { key: 0 }, G4n = ["stroke"], E4n = ["stroke"], O4n = ["stroke"], I4n = ["stroke"], K4n = ["stroke"], X4n = { key: 1 }, J4n = /* @__PURE__ */ e("path", {
  d: "M111.8,64A52,52,0,0,0,68,40a52,52,0,0,0-3.5,44.7A49.3,49.3,0,0,0,56,112v8a48,48,0,0,0,48,48h48a48,48,0,0,0,48-48v-8a49.3,49.3,0,0,0-8.5-27.3A52,52,0,0,0,188,40a52,52,0,0,0-43.8,24Z",
  opacity: "0.2"
}, null, -1), Q4n = ["stroke"], Y4n = ["stroke"], oan = ["stroke"], ean = ["stroke"], tan = ["stroke"], nan = { key: 2 }, san = /* @__PURE__ */ e("path", { d: "M224,224a8,8,0,0,1-8,8,32.1,32.1,0,0,1-32-32v-8a16,16,0,0,0-16-16H156v40a16,16,0,0,0,16,16,8,8,0,0,1,0,16,32.1,32.1,0,0,1-32-32V176H116v40a32.1,32.1,0,0,1-32,32,8,8,0,0,1,0-16,16,16,0,0,0,16-16V176H88a16,16,0,0,0-16,16v8a32.1,32.1,0,0,1-32,32,8,8,0,0,1,0-16,16,16,0,0,0,16-16v-8a32.1,32.1,0,0,1,14.8-27A55.8,55.8,0,0,1,48,120v-8a58,58,0,0,1,7.7-28.3A59.9,59.9,0,0,1,61.1,36,7.8,7.8,0,0,1,68,32a59.7,59.7,0,0,1,48,24h24a59.7,59.7,0,0,1,48-24,7.8,7.8,0,0,1,6.9,4,59.9,59.9,0,0,1,5.4,47.7A58,58,0,0,1,208,112v8a55.8,55.8,0,0,1-22.8,45A32.1,32.1,0,0,1,200,192v8a16,16,0,0,0,16,16A8,8,0,0,1,224,224Z" }, null, -1), ran = [
  san
], ian = { key: 3 }, lan = ["stroke"], dan = ["stroke"], kan = ["stroke"], can = ["stroke"], han = ["stroke"], uan = { key: 4 }, aan = ["stroke"], _an = ["stroke"], pan = ["stroke"], yan = ["stroke"], $an = ["stroke"], wan = { key: 5 }, fan = ["stroke"], gan = ["stroke"], xan = ["stroke"], jan = ["stroke"], man = ["stroke"], Man = {
  name: "PhGithubLogo"
}, OI1 = /* @__PURE__ */ $({
  ...Man,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", q4n, [
        e("path", {
          d: "M84,240a23.9,23.9,0,0,0,24-24V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, G4n),
        e("path", {
          d: "M172,240a23.9,23.9,0,0,1-24-24V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, E4n),
        e("path", {
          d: "M152,168h16a23.9,23.9,0,0,1,24,24v8a23.9,23.9,0,0,0,24,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, O4n),
        e("path", {
          d: "M104,168H88a23.9,23.9,0,0,0-24,24v8a23.9,23.9,0,0,1-24,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, I4n),
        e("path", {
          d: "M111.8,64A52,52,0,0,0,68,40a52,52,0,0,0-3.5,44.7A49.3,49.3,0,0,0,56,112v8a48,48,0,0,0,48,48h48a48,48,0,0,0,48-48v-8a49.3,49.3,0,0,0-8.5-27.3A52,52,0,0,0,188,40a52,52,0,0,0-43.8,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, K4n)
      ])) : o(i) === "duotone" ? (s(), r("g", X4n, [
        J4n,
        e("path", {
          d: "M84,240a23.9,23.9,0,0,0,24-24V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q4n),
        e("path", {
          d: "M172,240a23.9,23.9,0,0,1-24-24V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y4n),
        e("path", {
          d: "M152,168h16a23.9,23.9,0,0,1,24,24v8a23.9,23.9,0,0,0,24,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oan),
        e("path", {
          d: "M104,168H88a23.9,23.9,0,0,0-24,24v8a23.9,23.9,0,0,1-24,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ean),
        e("path", {
          d: "M111.8,64A52,52,0,0,0,68,40a52,52,0,0,0-3.5,44.7A49.3,49.3,0,0,0,56,112v8a48,48,0,0,0,48,48h48a48,48,0,0,0,48-48v-8a49.3,49.3,0,0,0-8.5-27.3A52,52,0,0,0,188,40a52,52,0,0,0-43.8,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tan)
      ])) : o(i) === "fill" ? (s(), r("g", nan, ran)) : o(i) === "light" ? (s(), r("g", ian, [
        e("path", {
          d: "M84,240a23.9,23.9,0,0,0,24-24V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lan),
        e("path", {
          d: "M172,240a23.9,23.9,0,0,1-24-24V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dan),
        e("path", {
          d: "M152,168h16a23.9,23.9,0,0,1,24,24v8a23.9,23.9,0,0,0,24,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kan),
        e("path", {
          d: "M104,168H88a23.9,23.9,0,0,0-24,24v8a23.9,23.9,0,0,1-24,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, can),
        e("path", {
          d: "M111.8,64A52,52,0,0,0,68,40a52,52,0,0,0-3.5,44.7A49.3,49.3,0,0,0,56,112v8a48,48,0,0,0,48,48h48a48,48,0,0,0,48-48v-8a49.3,49.3,0,0,0-8.5-27.3A52,52,0,0,0,188,40a52,52,0,0,0-43.8,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, han)
      ])) : o(i) === "thin" ? (s(), r("g", uan, [
        e("path", {
          d: "M84,240a23.9,23.9,0,0,0,24-24V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aan),
        e("path", {
          d: "M172,240a23.9,23.9,0,0,1-24-24V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _an),
        e("path", {
          d: "M152,168h16a23.9,23.9,0,0,1,24,24v8a23.9,23.9,0,0,0,24,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pan),
        e("path", {
          d: "M104,168H88a23.9,23.9,0,0,0-24,24v8a23.9,23.9,0,0,1-24,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yan),
        e("path", {
          d: "M111.8,64A52,52,0,0,0,68,40a52,52,0,0,0-3.5,44.7A49.3,49.3,0,0,0,56,112v8a48,48,0,0,0,48,48h48a48,48,0,0,0,48-48v-8a49.3,49.3,0,0,0-8.5-27.3A52,52,0,0,0,188,40a52,52,0,0,0-43.8,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $an)
      ])) : o(i) === "regular" ? (s(), r("g", wan, [
        e("path", {
          d: "M84,240a23.9,23.9,0,0,0,24-24V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fan),
        e("path", {
          d: "M172,240a23.9,23.9,0,0,1-24-24V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gan),
        e("path", {
          d: "M152,168h16a23.9,23.9,0,0,1,24,24v8a23.9,23.9,0,0,0,24,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xan),
        e("path", {
          d: "M104,168H88a23.9,23.9,0,0,0-24,24v8a23.9,23.9,0,0,1-24,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jan),
        e("path", {
          d: "M111.8,64A52,52,0,0,0,68,40a52,52,0,0,0-3.5,44.7A49.3,49.3,0,0,0,56,112v8a48,48,0,0,0,48,48h48a48,48,0,0,0,48-48v-8a49.3,49.3,0,0,0-8.5-27.3A52,52,0,0,0,188,40a52,52,0,0,0-43.8,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, man)
      ])) : g("", !0)
    ], 16, U4n));
  }
}), van = ["width", "height", "fill", "transform"], San = { key: 0 }, Han = ["stroke"], Aan = ["stroke"], Van = ["stroke"], zan = { key: 1 }, Zan = /* @__PURE__ */ e("path", {
  d: "M127.3,230.2,83,112h90L128.7,230.2h0a3.3,3.3,0,0,1-1.4,0Z",
  opacity: "0.2"
}, null, -1), Can = /* @__PURE__ */ e("path", {
  d: "M219.2,112l-16-59.9a4,4,0,0,0-7.6-.4L173,112Z",
  opacity: "0.2"
}, null, -1), ban = /* @__PURE__ */ e("path", {
  d: "M36.8,112l16-59.9a4,4,0,0,1,7.6-.4L83,112H36.8Z",
  opacity: "0.2"
}, null, -1), Lan = ["stroke"], Ban = ["stroke"], Pan = ["stroke"], Wan = { key: 2 }, Nan = /* @__PURE__ */ e("path", { d: "M238.3,152.5,211,50a12,12,0,0,0-22.9-1.1L167.5,104h-79L67.9,48.9A12,12,0,0,0,45,50L17.7,152.5a16.1,16.1,0,0,0,6.4,17.3l94.8,65.6a15.5,15.5,0,0,0,7.1,2.7h4a15.5,15.5,0,0,0,7.1-2.7l94.8-65.6A16.1,16.1,0,0,0,238.3,152.5ZM33.2,156.6,42.9,120H77.5l34,90.9Zm111.3,54.3,34-90.9h34.6l9.7,36.6Z" }, null, -1), Fan = [
  Nan
], Tan = { key: 3 }, Dan = ["stroke"], Ran = ["stroke"], Uan = ["stroke"], qan = { key: 4 }, Gan = ["stroke"], Ean = ["stroke"], Oan = ["stroke"], Ian = { key: 5 }, Kan = ["stroke"], Xan = ["stroke"], Jan = ["stroke"], Qan = {
  name: "PhGitlabLogo"
}, II1 = /* @__PURE__ */ $({
  ...Qan,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", San, [
        e("path", {
          d: "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Han),
        e("line", {
          x1: "128.7",
          y1: "230.2",
          x2: "173",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Aan),
        e("polyline", {
          points: "83 112 83 112 127.3 230.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Van)
      ])) : o(i) === "duotone" ? (s(), r("g", zan, [
        Zan,
        Can,
        ban,
        e("path", {
          d: "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lan),
        e("polyline", {
          points: "128.7 230.2 173 112 219.2 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ban),
        e("polyline", {
          points: "36.8 112 83 112 83 112 127.3 230.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pan)
      ])) : o(i) === "fill" ? (s(), r("g", Wan, Fan)) : o(i) === "light" ? (s(), r("g", Tan, [
        e("path", {
          d: "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dan),
        e("polyline", {
          points: "128.7 230.2 173 112 219.2 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ran),
        e("polyline", {
          points: "36.8 112 83 112 83 112 127.3 230.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Uan)
      ])) : o(i) === "thin" ? (s(), r("g", qan, [
        e("path", {
          d: "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gan),
        e("polyline", {
          points: "128.7 230.2 173 112 219.2 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ean),
        e("polyline", {
          points: "36.8 112 83 112 83 112 127.3 230.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Oan)
      ])) : o(i) === "regular" ? (s(), r("g", Ian, [
        e("path", {
          d: "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kan),
        e("polyline", {
          points: "128.7 230.2 173 112 219.2 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xan),
        e("polyline", {
          points: "36.8 112 83 112 83 112 127.3 230.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jan)
      ])) : g("", !0)
    ], 16, van));
  }
}), Yan = ["width", "height", "fill", "transform"], o_n = { key: 0 }, e_n = ["stroke"], t_n = { key: 1 }, n_n = /* @__PURE__ */ e("path", {
  d: "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
  opacity: "0.2"
}, null, -1), s_n = ["stroke"], r_n = { key: 2 }, i_n = /* @__PURE__ */ e("path", { d: "M231.9,169.8l-94.8,65.6a15.7,15.7,0,0,1-18.2,0L24.1,169.8a16.1,16.1,0,0,1-6.4-17.3L45,50a12,12,0,0,1,22.9-1.1L88.5,104h79l20.6-55.1A12,12,0,0,1,211,50l27.3,102.5A16.1,16.1,0,0,1,231.9,169.8Z" }, null, -1), l_n = [
  i_n
], d_n = { key: 3 }, k_n = ["stroke"], c_n = { key: 4 }, h_n = ["stroke"], u_n = { key: 5 }, a_n = ["stroke"], __n = {
  name: "PhGitlabLogoSimple"
}, KI1 = /* @__PURE__ */ $({
  ...__n,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", o_n, [
        e("path", {
          d: "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, e_n)
      ])) : o(i) === "duotone" ? (s(), r("g", t_n, [
        n_n,
        e("path", {
          d: "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s_n)
      ])) : o(i) === "fill" ? (s(), r("g", r_n, l_n)) : o(i) === "light" ? (s(), r("g", d_n, [
        e("path", {
          d: "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, k_n)
      ])) : o(i) === "thin" ? (s(), r("g", c_n, [
        e("path", {
          d: "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, h_n)
      ])) : o(i) === "regular" ? (s(), r("g", u_n, [
        e("path", {
          d: "M83,112h90l22.6-60.3a4,4,0,0,1,7.6.4l27.4,102.5a8.2,8.2,0,0,1-3.2,8.6l-94.8,65.6a8.1,8.1,0,0,1-9.2,0L28.6,163.2a8.2,8.2,0,0,1-3.2-8.6L52.8,52.1a4,4,0,0,1,7.6-.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a_n)
      ])) : g("", !0)
    ], 16, Yan));
  }
}), p_n = ["width", "height", "fill", "transform"], y_n = { key: 0 }, $_n = ["stroke"], w_n = ["stroke"], f_n = ["stroke"], g_n = ["stroke"], x_n = { key: 1 }, j_n = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), m_n = ["stroke"], M_n = ["stroke"], v_n = ["stroke"], S_n = ["stroke"], H_n = { key: 2 }, A_n = /* @__PURE__ */ e("path", { d: "M225.9,163.2l.3-1a103.7,103.7,0,0,0,0-68.4l-.3-1A104.2,104.2,0,0,0,128,24h0A104.2,104.2,0,0,0,30.1,92.8l-.3,1a103.7,103.7,0,0,0,0,68.4l.3,1A104.4,104.4,0,0,0,128,232h0A104.2,104.2,0,0,0,225.9,163.2ZM128,45.6A108.6,108.6,0,0,1,153.5,88h-51A108.6,108.6,0,0,1,128,45.6ZM102.5,168h51A108.6,108.6,0,0,1,128,210.4,108.6,108.6,0,0,1,102.5,168Zm-4.2-16a126.4,126.4,0,0,1,0-48h59.4a126.4,126.4,0,0,1,0,48ZM174,104h38.7a88.9,88.9,0,0,1,0,48H174a145,145,0,0,0,0-48Zm32.4-16h-36a128.7,128.7,0,0,0-24.1-46.1A88.6,88.6,0,0,1,206.4,88ZM146.3,214.1A128.7,128.7,0,0,0,170.4,168h36A88.6,88.6,0,0,1,146.3,214.1Z" }, null, -1), V_n = [
  A_n
], z_n = { key: 3 }, Z_n = ["stroke"], C_n = ["stroke"], b_n = ["stroke"], L_n = ["stroke"], B_n = { key: 4 }, P_n = ["stroke"], W_n = ["stroke"], N_n = ["stroke"], F_n = ["stroke"], T_n = { key: 5 }, D_n = ["stroke"], R_n = ["stroke"], U_n = ["stroke"], q_n = ["stroke"], G_n = {
  name: "PhGlobe"
}, XI1 = /* @__PURE__ */ $({
  ...G_n,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", y_n, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $_n),
        e("line", {
          x1: "37.5",
          y1: "96",
          x2: "218.5",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, w_n),
        e("line", {
          x1: "37.5",
          y1: "160",
          x2: "218.5",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f_n),
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "40",
          ry: "93.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g_n)
      ])) : o(i) === "duotone" ? (s(), r("g", x_n, [
        j_n,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, m_n),
        e("line", {
          x1: "37.5",
          y1: "96",
          x2: "218.5",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M_n),
        e("line", {
          x1: "37.5",
          y1: "160",
          x2: "218.5",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v_n),
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "40",
          ry: "93.4",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, S_n)
      ])) : o(i) === "fill" ? (s(), r("g", H_n, V_n)) : o(i) === "light" ? (s(), r("g", z_n, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Z_n),
        e("line", {
          x1: "37.5",
          y1: "96",
          x2: "218.5",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, C_n),
        e("line", {
          x1: "37.5",
          y1: "160",
          x2: "218.5",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b_n),
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "40",
          ry: "93.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, L_n)
      ])) : o(i) === "thin" ? (s(), r("g", B_n, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, P_n),
        e("line", {
          x1: "37.5",
          y1: "96",
          x2: "218.5",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, W_n),
        e("line", {
          x1: "37.5",
          y1: "160",
          x2: "218.5",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, N_n),
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "40",
          ry: "93.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, F_n)
      ])) : o(i) === "regular" ? (s(), r("g", T_n, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, D_n),
        e("line", {
          x1: "37.5",
          y1: "96",
          x2: "218.5",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R_n),
        e("line", {
          x1: "37.5",
          y1: "160",
          x2: "218.5",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U_n),
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "40",
          ry: "93.4",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, q_n)
      ])) : g("", !0)
    ], 16, p_n));
  }
}), E_n = ["width", "height", "fill", "transform"], O_n = { key: 0 }, I_n = ["stroke"], K_n = ["stroke"], X_n = ["stroke"], J_n = { key: 1 }, Q_n = /* @__PURE__ */ e("path", {
  d: "M187.1,203.7l-10.8-10.8a8.2,8.2,0,0,0-3.6-2.1l-21.5-5.6a8,8,0,0,1-5.8-8.9l2.3-16.2a8.2,8.2,0,0,1,4.9-6.2L183,141.2a8,8,0,0,1,8.5,1.5l24.9,22.8h.1a97,97,0,0,1-29.2,38.1Z",
  opacity: "0.2"
}, null, -1), Y_n = /* @__PURE__ */ e("path", {
  d: "M49.6,183.4A96,96,0,0,1,182.7,49.1h0l1.1,24.3a8.1,8.1,0,0,1-1.9,5.6l-22.2,25.6a7.8,7.8,0,0,1-4.9,2.7l-31.5,4.3a8.6,8.6,0,0,1-5.8-1.5L97.9,95.9a8.1,8.1,0,0,0-11.5,2.2L66.6,129.2a7.7,7.7,0,0,0-1.3,4.2l-.2,36.1a8,8,0,0,1-3.8,6.8l-11.7,7.1Z",
  opacity: "0.2"
}, null, -1), opn = ["stroke"], epn = ["stroke"], tpn = ["stroke"], npn = { key: 2 }, spn = /* @__PURE__ */ e("path", { d: "M223.5,169.2a6.1,6.1,0,0,0,.5-1.2A104,104,0,0,0,187.8,42.9l-1.2-.7A103,103,0,0,0,128,24,104,104,0,0,0,42.6,187.3v.2a10.5,10.5,0,0,0,.8,1.1,104,104,0,0,0,147.8,21.9l1.4-1.1A105.3,105.3,0,0,0,223.5,169.2Zm-162,16.4,3.9-2.4a15.8,15.8,0,0,0,7.7-13.6l.2-33.8a8.3,8.3,0,0,1,1.3-4.3l14-22a8,8,0,0,1,11.4-2.2l12.8,9.3a16.5,16.5,0,0,0,11.6,2.9l31.4-4.3a15.8,15.8,0,0,0,10-5.4l22.1-25.6A15.4,15.4,0,0,0,191.8,73l-.2-5.8A87.7,87.7,0,0,1,216,128a86.4,86.4,0,0,1-3.2,23.4l-15.9-14.6a16.1,16.1,0,0,0-16.9-3l-30.5,12.7a16.1,16.1,0,0,0-9.7,12.4l-2.4,16.2A16.2,16.2,0,0,0,149.2,193l21.5,5.6,4,4a88,88,0,0,1-113.2-17Z" }, null, -1), rpn = [
  spn
], ipn = { key: 3 }, lpn = ["stroke"], dpn = ["stroke"], kpn = ["stroke"], cpn = { key: 4 }, hpn = ["stroke"], upn = ["stroke"], apn = ["stroke"], _pn = { key: 5 }, ppn = ["stroke"], ypn = ["stroke"], $pn = ["stroke"], wpn = {
  name: "PhGlobeHemisphereEast"
}, JI1 = /* @__PURE__ */ $({
  ...wpn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", O_n, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, I_n),
        e("path", {
          d: "M49.6,183.4l12.1-7.3a8.4,8.4,0,0,0,3.8-6.1l3.7-37a7.3,7.3,0,0,1,1.2-3.5L90.1,98.6A8,8,0,0,1,102,96.8l15.4,12.9a7.8,7.8,0,0,0,6.2,1.8l31.2-4.2a7.8,7.8,0,0,0,4.9-2.7L181.9,79a8.1,8.1,0,0,0,1.9-5.6l-1.1-24.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, K_n),
        e("path", {
          d: "M187.1,203.7l-10.8-10.8a8.2,8.2,0,0,0-3.6-2.1l-21.5-5.6a8,8,0,0,1-5.8-8.9l2.3-16.2a8.2,8.2,0,0,1,4.9-6.2L183,141.2a8,8,0,0,1,8.5,1.5l24.9,22.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X_n)
      ])) : o(i) === "duotone" ? (s(), r("g", J_n, [
        Q_n,
        Y_n,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, opn),
        e("path", {
          d: "M49.6,183.4l11.7-7.1a8,8,0,0,0,3.8-6.8l.2-36.1a7.7,7.7,0,0,1,1.3-4.2L86.4,98.1a8.1,8.1,0,0,1,11.5-2.2l19.6,14.2a8.6,8.6,0,0,0,5.8,1.5l31.5-4.3a7.8,7.8,0,0,0,4.9-2.7L181.9,79a8.1,8.1,0,0,0,1.9-5.6l-1.1-24.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, epn),
        e("path", {
          d: "M187.1,203.7l-10.8-10.8a8.2,8.2,0,0,0-3.6-2.1l-21.5-5.6a8,8,0,0,1-5.8-8.9l2.3-16.2a8.2,8.2,0,0,1,4.9-6.2L183,141.2a8,8,0,0,1,8.5,1.5l24.9,22.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tpn)
      ])) : o(i) === "fill" ? (s(), r("g", npn, rpn)) : o(i) === "light" ? (s(), r("g", ipn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lpn),
        e("path", {
          d: "M49.6,183.4l11.7-7.1a8,8,0,0,0,3.8-6.8l.2-36.1a7.7,7.7,0,0,1,1.3-4.2L86.4,98.1a8.1,8.1,0,0,1,11.5-2.2l19.6,14.2a8.6,8.6,0,0,0,5.8,1.5l31.5-4.3a7.8,7.8,0,0,0,4.9-2.7L181.9,79a8.1,8.1,0,0,0,1.9-5.6l-1.1-24.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dpn),
        e("path", {
          d: "M187.1,203.7l-10.8-10.8a8.2,8.2,0,0,0-3.6-2.1l-21.5-5.6a8,8,0,0,1-5.8-8.9l2.3-16.2a8.2,8.2,0,0,1,4.9-6.2L183,141.2a8,8,0,0,1,8.5,1.5l24.9,22.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kpn)
      ])) : o(i) === "thin" ? (s(), r("g", cpn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hpn),
        e("path", {
          d: "M49.6,183.4l11.7-7.1a8,8,0,0,0,3.8-6.8l.2-36.1a7.7,7.7,0,0,1,1.3-4.2L86.4,98.1a8.1,8.1,0,0,1,11.5-2.2l19.6,14.2a8.6,8.6,0,0,0,5.8,1.5l31.5-4.3a7.8,7.8,0,0,0,4.9-2.7L181.9,79a8.1,8.1,0,0,0,1.9-5.6l-1.1-24.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, upn),
        e("path", {
          d: "M187.1,203.7l-10.8-10.8a8.2,8.2,0,0,0-3.6-2.1l-21.5-5.6a8,8,0,0,1-5.8-8.9l2.3-16.2a8.2,8.2,0,0,1,4.9-6.2L183,141.2a8,8,0,0,1,8.5,1.5l24.9,22.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, apn)
      ])) : o(i) === "regular" ? (s(), r("g", _pn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ppn),
        e("path", {
          d: "M49.6,183.4l11.7-7.1a8,8,0,0,0,3.8-6.8l.2-36.1a7.7,7.7,0,0,1,1.3-4.2L86.4,98.1a8.1,8.1,0,0,1,11.5-2.2l19.6,14.2a8.6,8.6,0,0,0,5.8,1.5l31.5-4.3a7.8,7.8,0,0,0,4.9-2.7L181.9,79a8.1,8.1,0,0,0,1.9-5.6l-1.1-24.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ypn),
        e("path", {
          d: "M187.1,203.7l-10.8-10.8a8.2,8.2,0,0,0-3.6-2.1l-21.5-5.6a8,8,0,0,1-5.8-8.9l2.3-16.2a8.2,8.2,0,0,1,4.9-6.2L183,141.2a8,8,0,0,1,8.5,1.5l24.9,22.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $pn)
      ])) : g("", !0)
    ], 16, E_n));
  }
}), fpn = ["width", "height", "fill", "transform"], gpn = { key: 0 }, xpn = ["stroke"], jpn = ["stroke"], mpn = ["stroke"], Mpn = ["stroke"], vpn = { key: 1 }, Spn = /* @__PURE__ */ e("path", {
  d: "M130.2,224a96.3,96.3,0,0,0,84-53.6h0L159.9,137a7.2,7.2,0,0,0-3.1-1.1l-22.9-3.1a7.8,7.8,0,0,0-8.3,4.7l-13.7,30.7a8,8,0,0,0,1.4,8.7l18.8,20.3a8.2,8.2,0,0,1,2,7L130.2,224Z",
  opacity: "0.2"
}, null, -1), Hpn = /* @__PURE__ */ e("path", {
  d: "M65,55.6,56,76.8a8,8,0,0,0-.1,5.9l11.5,30.6a7.9,7.9,0,0,0,5.8,5.1l5.4,1.1,8.3-19.7a8.1,8.1,0,0,1,7.4-4.9h21.4a8.6,8.6,0,0,0,3.8-1l12.3-6.8a7.2,7.2,0,0,0,1.5-1.1l26.9-24.3a8.1,8.1,0,0,0,1.6-9.8l-9.3-16.8h0A98.5,98.5,0,0,0,128,32,95.4,95.4,0,0,0,65,55.6Z",
  opacity: "0.2"
}, null, -1), Apn = ["stroke"], Vpn = ["stroke"], zpn = ["stroke"], Zpn = ["stroke"], Cpn = { key: 2 }, bpn = /* @__PURE__ */ e("path", { d: "M221.6,173.3A102.9,102.9,0,0,0,232,128,104.2,104.2,0,0,0,154.8,27.5h-.5A103.8,103.8,0,0,0,60.4,49l-1.3,1.2A103.9,103.9,0,0,0,128,232h2.4A104.3,104.3,0,0,0,221,174.6h0ZM216,128a89.3,89.3,0,0,1-5.5,30.7l-46.4-28.5a16,16,0,0,0-6.3-2.3l-22.8-3a16.1,16.1,0,0,0-15.3,6.8h-8.6l-3.8-7.9a16.2,16.2,0,0,0-11-8.7l-6.6-1.4,2.5-5.9a8.1,8.1,0,0,1,7.4-4.9h16.1a16.1,16.1,0,0,0,7.7-2l12.2-6.8a16.1,16.1,0,0,0,3-2.1l26.9-24.4A15.7,15.7,0,0,0,170,50.7,88,88,0,0,1,216,128ZM40,128a87.1,87.1,0,0,1,9.5-39.7l10.4,27.9a16.1,16.1,0,0,0,11.6,10l5.5,1.2h.1l12,2.6a7.8,7.8,0,0,1,5.5,4.3l2.1,4.4a16.1,16.1,0,0,0,14.4,9h1.2l-7.7,17.2a15.9,15.9,0,0,0,2.8,17.4l16.1,17.4a8.3,8.3,0,0,1,2,6.9l-1.8,9.3A88.1,88.1,0,0,1,40,128Z" }, null, -1), Lpn = [
  bpn
], Bpn = { key: 3 }, Ppn = ["stroke"], Wpn = ["stroke"], Npn = ["stroke"], Fpn = ["stroke"], Tpn = { key: 4 }, Dpn = ["stroke"], Rpn = ["stroke"], Upn = ["stroke"], qpn = ["stroke"], Gpn = { key: 5 }, Epn = ["stroke"], Opn = ["stroke"], Ipn = ["stroke"], Kpn = ["stroke"], Xpn = {
  name: "PhGlobeHemisphereWest"
}, QI1 = /* @__PURE__ */ $({
  ...Xpn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", gpn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xpn),
        e("path", {
          d: "M214.2,170.4,159.9,137a7.2,7.2,0,0,0-3.1-1.1l-22.9-3.1a7.8,7.8,0,0,0-8.3,4.7l-13.7,30.7a8,8,0,0,0,1.4,8.7l18.8,20.3a8.2,8.2,0,0,1,2,7L130.2,224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jpn),
        e("path", {
          d: "M65,55.6,56,76.8a8,8,0,0,0-.1,5.9l11.5,30.6a7.9,7.9,0,0,0,5.8,5.1L94.6,123a7.8,7.8,0,0,1,5.5,4.3l3.8,7.9a8.2,8.2,0,0,0,7.2,4.5h13.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mpn),
        e("path", {
          d: "M152.5,35.1l9.3,16.8a8.1,8.1,0,0,1-1.6,9.8L133.3,86a7.2,7.2,0,0,1-1.5,1.1l-12.3,6.8a8.6,8.6,0,0,1-3.8,1H94.3a8.1,8.1,0,0,0-7.4,4.9l-8.3,19.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mpn)
      ])) : o(i) === "duotone" ? (s(), r("g", vpn, [
        Spn,
        Hpn,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Apn),
        e("path", {
          d: "M214.2,170.4,159.9,137a7.2,7.2,0,0,0-3.1-1.1l-22.9-3.1a7.8,7.8,0,0,0-8.3,4.7l-13.7,30.7a8,8,0,0,0,1.4,8.7l18.8,20.3a8.2,8.2,0,0,1,2,7L130.2,224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vpn),
        e("path", {
          d: "M65,55.6,56,76.8a8,8,0,0,0-.1,5.9l11.5,30.6a7.9,7.9,0,0,0,5.8,5.1L94.6,123a7.8,7.8,0,0,1,5.5,4.3l3.8,7.9a8.2,8.2,0,0,0,7.2,4.5h13.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zpn),
        e("path", {
          d: "M152.5,35.1l9.3,16.8a8.1,8.1,0,0,1-1.6,9.8L133.3,86a7.2,7.2,0,0,1-1.5,1.1l-12.3,6.8a8.6,8.6,0,0,1-3.8,1H94.3a8.1,8.1,0,0,0-7.4,4.9l-8.3,19.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zpn)
      ])) : o(i) === "fill" ? (s(), r("g", Cpn, Lpn)) : o(i) === "light" ? (s(), r("g", Bpn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ppn),
        e("path", {
          d: "M214.2,170.4,159.9,137a7.2,7.2,0,0,0-3.1-1.1l-22.9-3.1a7.8,7.8,0,0,0-8.3,4.7l-13.7,30.7a8,8,0,0,0,1.4,8.7l18.8,20.3a8.2,8.2,0,0,1,2,7L130.2,224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wpn),
        e("path", {
          d: "M65,55.6,56,76.8a8,8,0,0,0-.1,5.9l11.5,30.6a7.9,7.9,0,0,0,5.8,5.1L94.6,123a7.8,7.8,0,0,1,5.5,4.3l3.8,7.9a8.2,8.2,0,0,0,7.2,4.5h13.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Npn),
        e("path", {
          d: "M152.5,35.1l9.3,16.8a8.1,8.1,0,0,1-1.6,9.8L133.3,86a7.2,7.2,0,0,1-1.5,1.1l-12.3,6.8a8.6,8.6,0,0,1-3.8,1H94.3a8.1,8.1,0,0,0-7.4,4.9l-8.3,19.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fpn)
      ])) : o(i) === "thin" ? (s(), r("g", Tpn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Dpn),
        e("path", {
          d: "M214.2,170.4,159.9,137a7.2,7.2,0,0,0-3.1-1.1l-22.9-3.1a7.8,7.8,0,0,0-8.3,4.7l-13.7,30.7a8,8,0,0,0,1.4,8.7l18.8,20.3a8.2,8.2,0,0,1,2,7L130.2,224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Rpn),
        e("path", {
          d: "M65,55.6,56,76.8a8,8,0,0,0-.1,5.9l11.5,30.6a7.9,7.9,0,0,0,5.8,5.1L94.6,123a7.8,7.8,0,0,1,5.5,4.3l3.8,7.9a8.2,8.2,0,0,0,7.2,4.5h13.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Upn),
        e("path", {
          d: "M152.5,35.1l9.3,16.8a8.1,8.1,0,0,1-1.6,9.8L133.3,86a7.2,7.2,0,0,1-1.5,1.1l-12.3,6.8a8.6,8.6,0,0,1-3.8,1H94.3a8.1,8.1,0,0,0-7.4,4.9l-8.3,19.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qpn)
      ])) : o(i) === "regular" ? (s(), r("g", Gpn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Epn),
        e("path", {
          d: "M214.2,170.4,159.9,137a7.2,7.2,0,0,0-3.1-1.1l-22.9-3.1a7.8,7.8,0,0,0-8.3,4.7l-13.7,30.7a8,8,0,0,0,1.4,8.7l18.8,20.3a8.2,8.2,0,0,1,2,7L130.2,224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Opn),
        e("path", {
          d: "M65,55.6,56,76.8a8,8,0,0,0-.1,5.9l11.5,30.6a7.9,7.9,0,0,0,5.8,5.1L94.6,123a7.8,7.8,0,0,1,5.5,4.3l3.8,7.9a8.2,8.2,0,0,0,7.2,4.5h13.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ipn),
        e("path", {
          d: "M152.5,35.1l9.3,16.8a8.1,8.1,0,0,1-1.6,9.8L133.3,86a7.2,7.2,0,0,1-1.5,1.1l-12.3,6.8a8.6,8.6,0,0,1-3.8,1H94.3a8.1,8.1,0,0,0-7.4,4.9l-8.3,19.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kpn)
      ])) : g("", !0)
    ], 16, fpn));
  }
}), Jpn = ["width", "height", "fill", "transform"], Qpn = { key: 0 }, Ypn = ["stroke"], o3n = ["stroke"], e3n = ["stroke"], t3n = { key: 1 }, n3n = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), s3n = ["stroke"], r3n = ["stroke"], i3n = ["stroke"], l3n = { key: 2 }, d3n = /* @__PURE__ */ e("path", { d: "M232,128A104.1,104.1,0,0,0,128,24h0a104,104,0,0,0,0,208h0A104.1,104.1,0,0,0,232,128Zm-16.4-8H175.8c-1.6-29.6-12-57-29.5-78.1A88.2,88.2,0,0,1,215.6,120ZM96.3,136h63.4c-1.8,28.8-13.3,55.7-31.7,74.4C109.6,191.7,98.1,164.8,96.3,136Zm0-16c1.8-28.8,13.3-55.7,31.7-74.4,18.4,18.7,29.9,45.6,31.7,74.4Zm50,94.1c17.5-21.1,27.9-48.5,29.5-78.1h39.8A88.2,88.2,0,0,1,146.3,214.1Z" }, null, -1), k3n = [
  d3n
], c3n = { key: 3 }, h3n = ["stroke"], u3n = ["stroke"], a3n = ["stroke"], _3n = { key: 4 }, p3n = ["stroke"], y3n = ["stroke"], $3n = ["stroke"], w3n = { key: 5 }, f3n = ["stroke"], g3n = ["stroke"], x3n = ["stroke"], j3n = {
  name: "PhGlobeSimple"
}, YI1 = /* @__PURE__ */ $({
  ...j3n,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Qpn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ypn),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, o3n),
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "40",
          ry: "93.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, e3n)
      ])) : o(i) === "duotone" ? (s(), r("g", t3n, [
        n3n,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, s3n),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r3n),
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "40",
          ry: "93.4",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, i3n)
      ])) : o(i) === "fill" ? (s(), r("g", l3n, k3n)) : o(i) === "light" ? (s(), r("g", c3n, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, h3n),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u3n),
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "40",
          ry: "93.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, a3n)
      ])) : o(i) === "thin" ? (s(), r("g", _3n, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, p3n),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, y3n),
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "40",
          ry: "93.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $3n)
      ])) : o(i) === "regular" ? (s(), r("g", w3n, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, f3n),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g3n),
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "40",
          ry: "93.4",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, x3n)
      ])) : g("", !0)
    ], 16, Jpn));
  }
}), m3n = ["width", "height", "fill", "transform"], M3n = { key: 0 }, v3n = ["stroke"], S3n = ["stroke"], H3n = ["stroke"], A3n = ["stroke"], V3n = { key: 1 }, z3n = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "96",
  r: "72",
  opacity: "0.2"
}, null, -1), Z3n = ["stroke"], C3n = ["stroke"], b3n = ["stroke"], L3n = ["stroke"], B3n = { key: 2 }, P3n = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "96",
  r: "80"
}, null, -1), W3n = /* @__PURE__ */ e("path", { d: "M207.2,175.2a8,8,0,0,0-11.3-11.3A96,96,0,0,1,60.1,28.1,8,8,0,1,0,48.8,16.8,112,112,0,0,0,120,207.7V224H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V207.7A111.6,111.6,0,0,0,207.2,175.2Z" }, null, -1), N3n = [
  P3n,
  W3n
], F3n = { key: 3 }, T3n = ["stroke"], D3n = ["stroke"], R3n = ["stroke"], U3n = ["stroke"], q3n = { key: 4 }, G3n = ["stroke"], E3n = ["stroke"], O3n = ["stroke"], I3n = ["stroke"], K3n = { key: 5 }, X3n = ["stroke"], J3n = ["stroke"], Q3n = ["stroke"], Y3n = ["stroke"], oyn = {
  name: "PhGlobeStand"
}, oK1 = /* @__PURE__ */ $({
  ...oyn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", M3n, [
        e("circle", {
          cx: "128",
          cy: "96",
          r: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, v3n),
        e("path", {
          d: "M201.5,169.5a103.9,103.9,0,0,1-147-147",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, S3n),
        e("line", {
          x1: "96",
          y1: "236",
          x2: "160",
          y2: "236",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, H3n),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "236",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, A3n)
      ])) : o(i) === "duotone" ? (s(), r("g", V3n, [
        z3n,
        e("circle", {
          cx: "128",
          cy: "96",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z3n),
        e("path", {
          d: "M201.5,169.5a103.9,103.9,0,0,1-147-147",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C3n),
        e("line", {
          x1: "96",
          y1: "232",
          x2: "160",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b3n),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L3n)
      ])) : o(i) === "fill" ? (s(), r("g", B3n, N3n)) : o(i) === "light" ? (s(), r("g", F3n, [
        e("circle", {
          cx: "128",
          cy: "96",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, T3n),
        e("path", {
          d: "M201.5,169.5a103.9,103.9,0,0,1-147-147",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, D3n),
        e("line", {
          x1: "96",
          y1: "232",
          x2: "160",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, R3n),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, U3n)
      ])) : o(i) === "thin" ? (s(), r("g", q3n, [
        e("circle", {
          cx: "128",
          cy: "96",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, G3n),
        e("path", {
          d: "M201.5,169.5a103.9,103.9,0,0,1-147-147",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, E3n),
        e("line", {
          x1: "96",
          y1: "232",
          x2: "160",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, O3n),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, I3n)
      ])) : o(i) === "regular" ? (s(), r("g", K3n, [
        e("circle", {
          cx: "128",
          cy: "96",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X3n),
        e("path", {
          d: "M201.5,169.5a103.9,103.9,0,0,1-147-147",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J3n),
        e("line", {
          x1: "96",
          y1: "232",
          x2: "160",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q3n),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y3n)
      ])) : g("", !0)
    ], 16, m3n));
  }
}), eyn = ["width", "height", "fill", "transform"], tyn = { key: 0 }, nyn = ["stroke"], syn = ["stroke"], ryn = ["stroke"], iyn = ["stroke"], lyn = ["stroke"], dyn = { key: 1 }, kyn = ["stroke"], cyn = ["stroke"], hyn = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "36",
  opacity: "0.2"
}, null, -1), uyn = ["stroke"], ayn = ["stroke"], _yn = ["stroke"], pyn = { key: 2 }, yyn = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm0,16a88.1,88.1,0,0,1,76.2,44H128a44,44,0,0,0-41.2,28.6L62.1,69.8A87.6,87.6,0,0,1,128,40ZM40,128A87.7,87.7,0,0,1,51.8,84l38.1,66,.2.3a44,44,0,0,0,45.2,21.1l-24.8,42.9A88.3,88.3,0,0,1,40,128Zm88,88,38.1-66c.1-.1.1-.3.2-.4a43.8,43.8,0,0,0-4.4-49.6h49.5a86.5,86.5,0,0,1,4.6,28A88.1,88.1,0,0,1,128,216Z" }, null, -1), $yn = [
  yyn
], wyn = { key: 3 }, fyn = ["stroke"], gyn = ["stroke"], xyn = ["stroke"], jyn = ["stroke"], myn = ["stroke"], Myn = { key: 4 }, vyn = ["stroke"], Syn = ["stroke"], Hyn = ["stroke"], Ayn = ["stroke"], Vyn = ["stroke"], zyn = { key: 5 }, Zyn = ["stroke"], Cyn = ["stroke"], byn = ["stroke"], Lyn = ["stroke"], Byn = ["stroke"], Pyn = {
  name: "PhGoogleChromeLogo"
}, eK1 = /* @__PURE__ */ $({
  ...Pyn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", tyn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nyn),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, syn),
        e("line", {
          x1: "128",
          y1: "92",
          x2: "217",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ryn),
        e("line", {
          x1: "96.8",
          y1: "146",
          x2: "52.3",
          y2: "68.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iyn),
        e("line", {
          x1: "159.2",
          y1: "146",
          x2: "114.7",
          y2: "223.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lyn)
      ])) : o(i) === "duotone" ? (s(), r("g", dyn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kyn),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cyn),
        hyn,
        e("line", {
          x1: "128",
          y1: "92",
          x2: "217",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uyn),
        e("line", {
          x1: "96.8",
          y1: "146",
          x2: "52.3",
          y2: "68.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ayn),
        e("line", {
          x1: "159.2",
          y1: "146",
          x2: "114.7",
          y2: "223.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _yn)
      ])) : o(i) === "fill" ? (s(), r("g", pyn, $yn)) : o(i) === "light" ? (s(), r("g", wyn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fyn),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gyn),
        e("line", {
          x1: "128",
          y1: "92",
          x2: "217",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xyn),
        e("line", {
          x1: "96.8",
          y1: "146",
          x2: "52.3",
          y2: "68.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jyn),
        e("line", {
          x1: "159.2",
          y1: "146",
          x2: "114.7",
          y2: "223.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, myn)
      ])) : o(i) === "thin" ? (s(), r("g", Myn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vyn),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Syn),
        e("line", {
          x1: "128",
          y1: "92",
          x2: "217",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hyn),
        e("line", {
          x1: "96.8",
          y1: "146",
          x2: "52.3",
          y2: "68.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ayn),
        e("line", {
          x1: "159.2",
          y1: "146",
          x2: "114.7",
          y2: "223.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vyn)
      ])) : o(i) === "regular" ? (s(), r("g", zyn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zyn),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cyn),
        e("line", {
          x1: "128",
          y1: "92",
          x2: "217",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, byn),
        e("line", {
          x1: "96.8",
          y1: "146",
          x2: "52.3",
          y2: "68.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lyn),
        e("line", {
          x1: "159.2",
          y1: "146",
          x2: "114.7",
          y2: "223.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Byn)
      ])) : g("", !0)
    ], 16, eyn));
  }
}), Wyn = ["width", "height", "fill", "transform"], Nyn = { key: 0 }, Fyn = ["stroke"], Tyn = { key: 1 }, Dyn = ["stroke"], Ryn = { key: 2 }, Uyn = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm0,184A80,80,0,1,1,184.6,71.4a8,8,0,0,1,0,11.3,7.9,7.9,0,0,1-11.3,0A64.1,64.1,0,1,0,191.5,136H128a8,8,0,0,1,0-16h72a8,8,0,0,1,8,8A80.1,80.1,0,0,1,128,208Z" }, null, -1), qyn = [
  Uyn
], Gyn = { key: 3 }, Eyn = ["stroke"], Oyn = { key: 4 }, Iyn = ["stroke"], Kyn = { key: 5 }, Xyn = ["stroke"], Jyn = {
  name: "PhGoogleLogo"
}, tK1 = /* @__PURE__ */ $({
  ...Jyn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Nyn, [
        e("path", {
          d: "M128,128h88a88.1,88.1,0,1,1-25.8-62.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fyn)
      ])) : o(i) === "duotone" ? (s(), r("g", Tyn, [
        e("path", {
          d: "M128,128h88a88.1,88.1,0,1,1-25.8-62.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dyn)
      ])) : o(i) === "fill" ? (s(), r("g", Ryn, qyn)) : o(i) === "light" ? (s(), r("g", Gyn, [
        e("path", {
          d: "M128,128h88a88.1,88.1,0,1,1-25.8-62.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Eyn)
      ])) : o(i) === "thin" ? (s(), r("g", Oyn, [
        e("path", {
          d: "M128,128h88a88.1,88.1,0,1,1-25.8-62.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Iyn)
      ])) : o(i) === "regular" ? (s(), r("g", Kyn, [
        e("path", {
          d: "M128,128h88a88.1,88.1,0,1,1-25.8-62.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xyn)
      ])) : g("", !0)
    ], 16, Wyn));
  }
}), Qyn = ["width", "height", "fill", "transform"], Yyn = { key: 0 }, o5n = ["stroke"], e5n = ["stroke"], t5n = ["stroke"], n5n = ["stroke"], s5n = { key: 1 }, r5n = /* @__PURE__ */ e("path", {
  d: "M132,132V24a60,60,0,0,1,36,108Z",
  opacity: "0.2"
}, null, -1), i5n = /* @__PURE__ */ e("path", {
  d: "M124,124V232A60,60,0,0,1,88,124Z",
  opacity: "0.2"
}, null, -1), l5n = ["stroke"], d5n = ["stroke"], k5n = ["stroke"], c5n = ["stroke"], h5n = { key: 2 }, u5n = /* @__PURE__ */ e("path", { d: "M232,124H187a67.4,67.4,0,0,0,13-40,68.1,68.1,0,0,0-68-68,8,8,0,0,0-8,8V69A67.4,67.4,0,0,0,84,56a68.1,68.1,0,0,0-68,68,8,8,0,0,0,8,8H69a67.4,67.4,0,0,0-13,40,68.1,68.1,0,0,0,68,68,8,8,0,0,0,8-8V187a67.4,67.4,0,0,0,40,13,68.1,68.1,0,0,0,68-68A8,8,0,0,0,232,124ZM84,72a51.5,51.5,0,0,1,40,18.8V116H32.6A52.1,52.1,0,0,1,84,72Zm88,112a51.5,51.5,0,0,1-40-18.8V140h91.4A52.1,52.1,0,0,1,172,184Z" }, null, -1), a5n = [
  u5n
], _5n = { key: 3 }, p5n = ["stroke"], y5n = ["stroke"], $5n = ["stroke"], w5n = ["stroke"], f5n = { key: 4 }, g5n = ["stroke"], x5n = ["stroke"], j5n = ["stroke"], m5n = ["stroke"], M5n = { key: 5 }, v5n = ["stroke"], S5n = ["stroke"], H5n = ["stroke"], A5n = ["stroke"], V5n = {
  name: "PhGooglePhotosLogo"
}, nK1 = /* @__PURE__ */ $({
  ...V5n,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Yyn, [
        e("path", {
          d: "M132,132V24a60,60,0,0,1,36,108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, o5n),
        e("path", {
          d: "M132,124H24A60,60,0,0,1,132,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, e5n),
        e("path", {
          d: "M124,124V232A60,60,0,0,1,88,124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, t5n),
        e("path", {
          d: "M124,132H232a60,60,0,0,1-108,36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, n5n)
      ])) : o(i) === "duotone" ? (s(), r("g", s5n, [
        r5n,
        i5n,
        e("path", {
          d: "M132,132V24a60,60,0,0,1,36,108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l5n),
        e("path", {
          d: "M132,124H24A60,60,0,0,1,132,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, d5n),
        e("path", {
          d: "M124,124V232A60,60,0,0,1,88,124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k5n),
        e("path", {
          d: "M124,132H232a60,60,0,0,1-108,36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c5n)
      ])) : o(i) === "fill" ? (s(), r("g", h5n, a5n)) : o(i) === "light" ? (s(), r("g", _5n, [
        e("path", {
          d: "M132,132V24a60,60,0,0,1,36,108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, p5n),
        e("path", {
          d: "M132,124H24A60,60,0,0,1,132,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, y5n),
        e("path", {
          d: "M124,124V232A60,60,0,0,1,88,124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $5n),
        e("path", {
          d: "M124,132H232a60,60,0,0,1-108,36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, w5n)
      ])) : o(i) === "thin" ? (s(), r("g", f5n, [
        e("path", {
          d: "M132,132V24a60,60,0,0,1,36,108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, g5n),
        e("path", {
          d: "M132,124H24A60,60,0,0,1,132,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, x5n),
        e("path", {
          d: "M124,124V232A60,60,0,0,1,88,124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, j5n),
        e("path", {
          d: "M124,132H232a60,60,0,0,1-108,36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, m5n)
      ])) : o(i) === "regular" ? (s(), r("g", M5n, [
        e("path", {
          d: "M132,132V24a60,60,0,0,1,36,108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v5n),
        e("path", {
          d: "M132,124H24A60,60,0,0,1,132,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S5n),
        e("path", {
          d: "M124,124V232A60,60,0,0,1,88,124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H5n),
        e("path", {
          d: "M124,132H232a60,60,0,0,1-108,36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A5n)
      ])) : g("", !0)
    ], 16, Qyn));
  }
}), z5n = ["width", "height", "fill", "transform"], Z5n = { key: 0 }, C5n = ["stroke"], b5n = ["stroke"], L5n = ["stroke"], B5n = { key: 1 }, P5n = /* @__PURE__ */ e("path", {
  d: "M42.2,26.2a8.1,8.1,0,0,0-2.4,5.7V224.1a8.1,8.1,0,0,0,2.4,5.7h0L144,128,42.2,26.2Z",
  opacity: "0.2"
}, null, -1), W5n = ["stroke"], N5n = ["stroke"], F5n = ["stroke"], T5n = { key: 2 }, D5n = /* @__PURE__ */ e("path", { d: "M223.6,114.2,55.9,18.1a16.2,16.2,0,0,0-16.2.1,15.8,15.8,0,0,0-7.9,13.7V224.1a16,16,0,0,0,16,15.9,16.9,16.9,0,0,0,8.1-2.1l167.7-96.1a15.7,15.7,0,0,0,0-27.6ZM144,139.3l18.9,18.9L74.7,208.6Zm-69.3-92,88.2,50.5L144,116.7ZM177.2,149.9,155.3,128l21.9-21.9L215.6,128Z" }, null, -1), R5n = [
  D5n
], U5n = { key: 3 }, q5n = ["stroke"], G5n = ["stroke"], E5n = ["stroke"], O5n = { key: 4 }, I5n = ["stroke"], K5n = ["stroke"], X5n = ["stroke"], J5n = { key: 5 }, Q5n = ["stroke"], Y5n = ["stroke"], o7n = ["stroke"], e7n = {
  name: "PhGooglePlayLogo"
}, sK1 = /* @__PURE__ */ $({
  ...e7n,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Z5n, [
        e("path", {
          d: "M39.8,224.1a8,8,0,0,0,12.1,6.8l167.8-96.1a7.7,7.7,0,0,0,0-13.6L51.9,25.1a8,8,0,0,0-12.1,6.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, C5n),
        e("line", {
          x1: "42.2",
          y1: "26.2",
          x2: "175.9",
          y2: "159.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, b5n),
        e("line", {
          x1: "42.2",
          y1: "229.8",
          x2: "175.9",
          y2: "96.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, L5n)
      ])) : o(i) === "duotone" ? (s(), r("g", B5n, [
        P5n,
        e("path", {
          d: "M39.8,224.1a8,8,0,0,0,12.1,6.8l167.8-96.1a7.7,7.7,0,0,0,0-13.6L51.9,25.1a8,8,0,0,0-12.1,6.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W5n),
        e("line", {
          x1: "42.2",
          y1: "26.2",
          x2: "175.9",
          y2: "159.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N5n),
        e("line", {
          x1: "42.2",
          y1: "229.8",
          x2: "175.9",
          y2: "96.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F5n)
      ])) : o(i) === "fill" ? (s(), r("g", T5n, R5n)) : o(i) === "light" ? (s(), r("g", U5n, [
        e("path", {
          d: "M39.8,224.1a8,8,0,0,0,12.1,6.8l167.8-96.1a7.7,7.7,0,0,0,0-13.6L51.9,25.1a8,8,0,0,0-12.1,6.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, q5n),
        e("line", {
          x1: "42.2",
          y1: "26.2",
          x2: "175.9",
          y2: "159.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, G5n),
        e("line", {
          x1: "42.2",
          y1: "229.8",
          x2: "175.9",
          y2: "96.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, E5n)
      ])) : o(i) === "thin" ? (s(), r("g", O5n, [
        e("path", {
          d: "M39.8,224.1a8,8,0,0,0,12.1,6.8l167.8-96.1a7.7,7.7,0,0,0,0-13.6L51.9,25.1a8,8,0,0,0-12.1,6.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, I5n),
        e("line", {
          x1: "42.2",
          y1: "26.2",
          x2: "175.9",
          y2: "159.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, K5n),
        e("line", {
          x1: "42.2",
          y1: "229.8",
          x2: "175.9",
          y2: "96.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, X5n)
      ])) : o(i) === "regular" ? (s(), r("g", J5n, [
        e("path", {
          d: "M39.8,224.1a8,8,0,0,0,12.1,6.8l167.8-96.1a7.7,7.7,0,0,0,0-13.6L51.9,25.1a8,8,0,0,0-12.1,6.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q5n),
        e("line", {
          x1: "42.2",
          y1: "26.2",
          x2: "175.9",
          y2: "159.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y5n),
        e("line", {
          x1: "42.2",
          y1: "229.8",
          x2: "175.9",
          y2: "96.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o7n)
      ])) : g("", !0)
    ], 16, z5n));
  }
}), t7n = ["width", "height", "fill", "transform"], n7n = { key: 0 }, s7n = ["stroke"], r7n = ["stroke"], i7n = ["stroke"], l7n = ["stroke"], d7n = ["stroke"], k7n = ["stroke"], c7n = ["stroke"], h7n = ["stroke"], u7n = ["stroke"], a7n = { key: 1 }, _7n = ["stroke"], p7n = ["stroke"], y7n = ["stroke"], $7n = ["stroke"], w7n = ["stroke"], f7n = ["stroke"], g7n = ["stroke"], x7n = ["stroke"], j7n = ["stroke"], m7n = { key: 2 }, M7n = /* @__PURE__ */ e("path", { d: "M136,24V48a8,8,0,0,1-16,0V24a8,8,0,0,1,16,0Zm40,36a8,8,0,0,0-8,8V92a8,8,0,0,0,16,0V68A8,8,0,0,0,176,60ZM128,200a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V208A8,8,0,0,0,128,200Zm0-128a8,8,0,0,0-8,8v96a8,8,0,0,0,16,0V80A8,8,0,0,0,128,72ZM80,60a8,8,0,0,0-8,8v64a8,8,0,0,0,16,0V68A8,8,0,0,0,80,60Zm96,56a8,8,0,0,0-8,8v64a8,8,0,0,0,16,0V124A8,8,0,0,0,176,116ZM32,108a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V116A8,8,0,0,0,32,108Zm48,48a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V164A8,8,0,0,0,80,156Zm144-48a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V116A8,8,0,0,0,224,108Z" }, null, -1), v7n = [
  M7n
], S7n = { key: 3 }, H7n = ["stroke"], A7n = ["stroke"], V7n = ["stroke"], z7n = ["stroke"], Z7n = ["stroke"], C7n = ["stroke"], b7n = ["stroke"], L7n = ["stroke"], B7n = ["stroke"], P7n = { key: 4 }, W7n = ["stroke"], N7n = ["stroke"], F7n = ["stroke"], T7n = ["stroke"], D7n = ["stroke"], R7n = ["stroke"], U7n = ["stroke"], q7n = ["stroke"], G7n = ["stroke"], E7n = { key: 5 }, O7n = ["stroke"], I7n = ["stroke"], K7n = ["stroke"], X7n = ["stroke"], J7n = ["stroke"], Q7n = ["stroke"], Y7n = ["stroke"], o9n = ["stroke"], e9n = ["stroke"], t9n = {
  name: "PhGooglePodcastsLogo"
}, rK1 = /* @__PURE__ */ $({
  ...t9n,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", n7n, [
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, s7n),
        e("line", {
          x1: "176",
          y1: "68",
          x2: "176",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, r7n),
        e("line", {
          x1: "128",
          y1: "208",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, i7n),
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, l7n),
        e("line", {
          x1: "80",
          y1: "68",
          x2: "80",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, d7n),
        e("line", {
          x1: "176",
          y1: "132",
          x2: "176",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, k7n),
        e("line", {
          x1: "32",
          y1: "116",
          x2: "32",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, c7n),
        e("line", {
          x1: "80",
          y1: "164",
          x2: "80",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, h7n),
        e("line", {
          x1: "224",
          y1: "116",
          x2: "224",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, u7n)
      ])) : o(i) === "duotone" ? (s(), r("g", a7n, [
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _7n),
        e("line", {
          x1: "176",
          y1: "68",
          x2: "176",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p7n),
        e("line", {
          x1: "128",
          y1: "208",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y7n),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $7n),
        e("line", {
          x1: "80",
          y1: "68",
          x2: "80",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w7n),
        e("line", {
          x1: "176",
          y1: "124",
          x2: "176",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f7n),
        e("line", {
          x1: "32",
          y1: "116",
          x2: "32",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g7n),
        e("line", {
          x1: "80",
          y1: "164",
          x2: "80",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, x7n),
        e("line", {
          x1: "224",
          y1: "116",
          x2: "224",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j7n)
      ])) : o(i) === "fill" ? (s(), r("g", m7n, v7n)) : o(i) === "light" ? (s(), r("g", S7n, [
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, H7n),
        e("line", {
          x1: "176",
          y1: "68",
          x2: "176",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, A7n),
        e("line", {
          x1: "128",
          y1: "208",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, V7n),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, z7n),
        e("line", {
          x1: "80",
          y1: "68",
          x2: "80",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Z7n),
        e("line", {
          x1: "176",
          y1: "124",
          x2: "176",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, C7n),
        e("line", {
          x1: "32",
          y1: "116",
          x2: "32",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b7n),
        e("line", {
          x1: "80",
          y1: "164",
          x2: "80",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, L7n),
        e("line", {
          x1: "224",
          y1: "116",
          x2: "224",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, B7n)
      ])) : o(i) === "thin" ? (s(), r("g", P7n, [
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, W7n),
        e("line", {
          x1: "176",
          y1: "68",
          x2: "176",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, N7n),
        e("line", {
          x1: "128",
          y1: "208",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, F7n),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, T7n),
        e("line", {
          x1: "80",
          y1: "68",
          x2: "80",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, D7n),
        e("line", {
          x1: "176",
          y1: "124",
          x2: "176",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, R7n),
        e("line", {
          x1: "32",
          y1: "116",
          x2: "32",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, U7n),
        e("line", {
          x1: "80",
          y1: "164",
          x2: "80",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, q7n),
        e("line", {
          x1: "224",
          y1: "116",
          x2: "224",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, G7n)
      ])) : o(i) === "regular" ? (s(), r("g", E7n, [
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O7n),
        e("line", {
          x1: "176",
          y1: "68",
          x2: "176",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I7n),
        e("line", {
          x1: "128",
          y1: "208",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K7n),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X7n),
        e("line", {
          x1: "80",
          y1: "68",
          x2: "80",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J7n),
        e("line", {
          x1: "176",
          y1: "124",
          x2: "176",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q7n),
        e("line", {
          x1: "32",
          y1: "116",
          x2: "32",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y7n),
        e("line", {
          x1: "80",
          y1: "164",
          x2: "80",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o9n),
        e("line", {
          x1: "224",
          y1: "116",
          x2: "224",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e9n)
      ])) : g("", !0)
    ], 16, t7n));
  }
}), n9n = ["width", "height", "fill", "transform"], s9n = { key: 0 }, r9n = ["stroke"], i9n = ["stroke"], l9n = ["stroke"], d9n = ["stroke"], k9n = ["stroke"], c9n = ["stroke"], h9n = ["stroke"], u9n = ["stroke"], a9n = ["stroke"], _9n = ["stroke"], p9n = { key: 1 }, y9n = ["stroke"], $9n = ["stroke"], w9n = ["stroke"], f9n = ["stroke"], g9n = ["stroke"], x9n = ["stroke"], j9n = ["stroke"], m9n = ["stroke"], M9n = ["stroke"], v9n = ["stroke"], S9n = { key: 2 }, H9n = /* @__PURE__ */ e("path", { d: "M24,104a8,8,0,0,1,8-8h80a8,8,0,0,1,0,16H32A8,8,0,0,1,24,104Zm200-8H144a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16ZM84,144a8,8,0,0,0-8-8H32a8,8,0,0,0,0,16H76A8,8,0,0,0,84,144Zm140-8H180a8,8,0,0,0,0,16h44a8,8,0,0,0,0-16ZM96,144a8,8,0,0,0,8,8h48a8,8,0,0,0,0-16H104A8,8,0,0,0,96,144ZM56,176H32a8,8,0,0,0,0,16H56a8,8,0,0,0,0-16Zm56,0H88a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16Zm56,0H144a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16Zm56,0H200a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16ZM32,72H224a8,8,0,0,0,0-16H32a8,8,0,0,0,0,16Z" }, null, -1), A9n = [
  H9n
], V9n = { key: 3 }, z9n = ["stroke"], Z9n = ["stroke"], C9n = ["stroke"], b9n = ["stroke"], L9n = ["stroke"], B9n = ["stroke"], P9n = ["stroke"], W9n = ["stroke"], N9n = ["stroke"], F9n = ["stroke"], T9n = { key: 4 }, D9n = ["stroke"], R9n = ["stroke"], U9n = ["stroke"], q9n = ["stroke"], G9n = ["stroke"], E9n = ["stroke"], O9n = ["stroke"], I9n = ["stroke"], K9n = ["stroke"], X9n = ["stroke"], J9n = { key: 5 }, Q9n = ["stroke"], Y9n = ["stroke"], o$n = ["stroke"], e$n = ["stroke"], t$n = ["stroke"], n$n = ["stroke"], s$n = ["stroke"], r$n = ["stroke"], i$n = ["stroke"], l$n = ["stroke"], d$n = {
  name: "PhGradient"
}, iK1 = /* @__PURE__ */ $({
  ...d$n,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", s9n, [
        e("line", {
          x1: "32",
          y1: "108",
          x2: "108",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, r9n),
        e("line", {
          x1: "148",
          y1: "108",
          x2: "224",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, i9n),
        e("line", {
          x1: "32",
          y1: "148",
          x2: "68",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, l9n),
        e("line", {
          x1: "188",
          y1: "148",
          x2: "224",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, d9n),
        e("line", {
          x1: "108",
          y1: "148",
          x2: "148",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, k9n),
        e("line", {
          x1: "32",
          y1: "188",
          x2: "52",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, c9n),
        e("line", {
          x1: "92",
          y1: "188",
          x2: "108",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, h9n),
        e("line", {
          x1: "148",
          y1: "188",
          x2: "164",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, u9n),
        e("line", {
          x1: "204",
          y1: "188",
          x2: "224",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, a9n),
        e("line", {
          x1: "32",
          y1: "68",
          x2: "224",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _9n)
      ])) : o(i) === "duotone" ? (s(), r("g", p9n, [
        e("line", {
          x1: "32",
          y1: "104",
          x2: "112",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y9n),
        e("line", {
          x1: "144",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $9n),
        e("line", {
          x1: "32",
          y1: "144",
          x2: "76",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w9n),
        e("line", {
          x1: "180",
          y1: "144",
          x2: "224",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f9n),
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g9n),
        e("line", {
          x1: "32",
          y1: "184",
          x2: "56",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, x9n),
        e("line", {
          x1: "88",
          y1: "184",
          x2: "112",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j9n),
        e("line", {
          x1: "144",
          y1: "184",
          x2: "168",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m9n),
        e("line", {
          x1: "200",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M9n),
        e("line", {
          x1: "32",
          y1: "64",
          x2: "224",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v9n)
      ])) : o(i) === "fill" ? (s(), r("g", S9n, A9n)) : o(i) === "light" ? (s(), r("g", V9n, [
        e("line", {
          x1: "32",
          y1: "104",
          x2: "112",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, z9n),
        e("line", {
          x1: "144",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Z9n),
        e("line", {
          x1: "32",
          y1: "144",
          x2: "76",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, C9n),
        e("line", {
          x1: "180",
          y1: "144",
          x2: "224",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b9n),
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, L9n),
        e("line", {
          x1: "32",
          y1: "184",
          x2: "56",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, B9n),
        e("line", {
          x1: "88",
          y1: "184",
          x2: "112",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, P9n),
        e("line", {
          x1: "144",
          y1: "184",
          x2: "168",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, W9n),
        e("line", {
          x1: "200",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, N9n),
        e("line", {
          x1: "32",
          y1: "64",
          x2: "224",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, F9n)
      ])) : o(i) === "thin" ? (s(), r("g", T9n, [
        e("line", {
          x1: "32",
          y1: "104",
          x2: "112",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, D9n),
        e("line", {
          x1: "144",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, R9n),
        e("line", {
          x1: "32",
          y1: "144",
          x2: "76",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, U9n),
        e("line", {
          x1: "180",
          y1: "144",
          x2: "224",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, q9n),
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, G9n),
        e("line", {
          x1: "32",
          y1: "184",
          x2: "56",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, E9n),
        e("line", {
          x1: "88",
          y1: "184",
          x2: "112",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, O9n),
        e("line", {
          x1: "144",
          y1: "184",
          x2: "168",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, I9n),
        e("line", {
          x1: "200",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, K9n),
        e("line", {
          x1: "32",
          y1: "64",
          x2: "224",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, X9n)
      ])) : o(i) === "regular" ? (s(), r("g", J9n, [
        e("line", {
          x1: "32",
          y1: "104",
          x2: "112",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q9n),
        e("line", {
          x1: "144",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y9n),
        e("line", {
          x1: "32",
          y1: "144",
          x2: "76",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o$n),
        e("line", {
          x1: "180",
          y1: "144",
          x2: "224",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e$n),
        e("line", {
          x1: "104",
          y1: "144",
          x2: "152",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t$n),
        e("line", {
          x1: "32",
          y1: "184",
          x2: "56",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n$n),
        e("line", {
          x1: "88",
          y1: "184",
          x2: "112",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s$n),
        e("line", {
          x1: "144",
          y1: "184",
          x2: "168",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r$n),
        e("line", {
          x1: "200",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, i$n),
        e("line", {
          x1: "32",
          y1: "64",
          x2: "224",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l$n)
      ])) : g("", !0)
    ], 16, n9n));
  }
}), k$n = ["width", "height", "fill", "transform"], c$n = { key: 0 }, h$n = ["stroke"], u$n = ["stroke"], a$n = ["stroke"], _$n = { key: 1 }, p$n = /* @__PURE__ */ e("path", {
  d: "M36,110.9v54.6a7.8,7.8,0,0,0,1.6,4.7c6.7,9,35.1,41.8,90.4,41.8s83.7-32.8,90.4-41.8a7.8,7.8,0,0,0,1.6-4.7V110.9L128,160Z",
  opacity: "0.2"
}, null, -1), y$n = ["stroke"], $$n = ["stroke"], w$n = ["stroke"], f$n = { key: 2 }, g$n = /* @__PURE__ */ e("path", { d: "M180,209.6a119.4,119.4,0,0,0,16-8.5V240a8,8,0,0,1-16,0ZM120.9,92.2a8.2,8.2,0,0,0,3.3,10.9L171,128l17-9.1-56.2-30A8.2,8.2,0,0,0,120.9,92.2Zm130.9-3.3-120-64a8.5,8.5,0,0,0-7.6,0l-120,64a8.1,8.1,0,0,0,0,14.2L28,115.7v49.8a15.5,15.5,0,0,0,3.2,9.5c7.9,10.6,38.3,45,96.8,45a128.7,128.7,0,0,0,52-10.5V132.8l-9-4.8-43,22.9-88.2-47h0L25,96,128,41.1,231,96l-14.8,7.9h0l-28.2,15,3.8,2a8.4,8.4,0,0,1,3.2,3.3,7.5,7.5,0,0,1,1,3.8v73.1A111.8,111.8,0,0,0,224.8,175a15.5,15.5,0,0,0,3.2-9.5V115.7l23.8-12.6a8.1,8.1,0,0,0,0-14.2Z" }, null, -1), x$n = [
  g$n
], j$n = { key: 3 }, m$n = ["stroke"], M$n = ["stroke"], v$n = ["stroke"], S$n = { key: 4 }, H$n = ["stroke"], A$n = ["stroke"], V$n = ["stroke"], z$n = { key: 5 }, Z$n = ["stroke"], C$n = ["stroke"], b$n = ["stroke"], L$n = {
  name: "PhGraduationCap"
}, lK1 = /* @__PURE__ */ $({
  ...L$n,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", c$n, [
        e("polygon", {
          points: "12 96 128 32 244 96 128 160 12 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, h$n),
        e("polyline", {
          points: "186 240 186 128 128 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, u$n),
        e("path", {
          d: "M224,107v58.2a7.8,7.8,0,0,1-1.9,5.1c-7.7,9.1-39,41.7-94.1,41.7s-86.4-32.6-94.1-41.7a7.8,7.8,0,0,1-1.9-5.1V107",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, a$n)
      ])) : o(i) === "duotone" ? (s(), r("g", _$n, [
        p$n,
        e("polygon", {
          points: "8 96 128 32 248 96 128 160 8 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y$n),
        e("polyline", {
          points: "188 240 188 128 128 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $$n),
        e("path", {
          d: "M220,110.9v54.6a7.8,7.8,0,0,1-1.6,4.7c-6.7,9-35.1,41.8-90.4,41.8s-83.7-32.8-90.4-41.8a7.8,7.8,0,0,1-1.6-4.7V110.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w$n)
      ])) : o(i) === "fill" ? (s(), r("g", f$n, x$n)) : o(i) === "light" ? (s(), r("g", j$n, [
        e("polygon", {
          points: "8 96 128 32 248 96 128 160 8 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, m$n),
        e("polyline", {
          points: "188 240 188 128 128 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, M$n),
        e("path", {
          d: "M220,110.9v54.6a7.8,7.8,0,0,1-1.6,4.7c-6.7,9-35.1,41.8-90.4,41.8s-83.7-32.8-90.4-41.8a7.8,7.8,0,0,1-1.6-4.7V110.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, v$n)
      ])) : o(i) === "thin" ? (s(), r("g", S$n, [
        e("polygon", {
          points: "8 96 128 32 248 96 128 160 8 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, H$n),
        e("polyline", {
          points: "188 240 188 128 128 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, A$n),
        e("path", {
          d: "M220,110.9v54.6a7.8,7.8,0,0,1-1.6,4.7c-6.7,9-35.1,41.8-90.4,41.8s-83.7-32.8-90.4-41.8a7.8,7.8,0,0,1-1.6-4.7V110.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, V$n)
      ])) : o(i) === "regular" ? (s(), r("g", z$n, [
        e("polygon", {
          points: "8 96 128 32 248 96 128 160 8 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z$n),
        e("polyline", {
          points: "188 240 188 128 128 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C$n),
        e("path", {
          d: "M220,110.9v54.6a7.8,7.8,0,0,1-1.6,4.7c-6.7,9-35.1,41.8-90.4,41.8s-83.7-32.8-90.4-41.8a7.8,7.8,0,0,1-1.6-4.7V110.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b$n)
      ])) : g("", !0)
    ], 16, k$n));
  }
}), B$n = ["width", "height", "fill", "transform"], P$n = { key: 0 }, W$n = ["stroke"], N$n = ["stroke"], F$n = ["stroke"], T$n = ["stroke"], D$n = ["stroke"], R$n = ["stroke"], U$n = ["stroke"], q$n = ["stroke"], G$n = ["stroke"], E$n = { key: 1 }, O$n = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "24",
  opacity: "0.2"
}, null, -1), I$n = ["stroke"], K$n = ["stroke"], X$n = ["stroke"], J$n = ["stroke"], Q$n = ["stroke"], Y$n = ["stroke"], own = ["stroke"], ewn = ["stroke"], twn = ["stroke"], nwn = { key: 2 }, swn = /* @__PURE__ */ e("path", { d: "M200,152a31.7,31.7,0,0,0-19.5,6.7l-23.1-18A31.7,31.7,0,0,0,160,128a16.2,16.2,0,0,0-.1-2.2l13.3-4.4A31.9,31.9,0,1,0,168,104a16.2,16.2,0,0,0,.1,2.2l-13.3,4.4A31.9,31.9,0,0,0,128,96a45.5,45.5,0,0,0-5.3.4L115.9,81A31.7,31.7,0,0,0,128,56,32,32,0,1,0,96,88a45.5,45.5,0,0,0,5.3-.4l6.8,15.4A31.7,31.7,0,0,0,96,128a32.4,32.4,0,0,0,3.5,14.6L73.8,165.4A32,32,0,1,0,88,192a32.4,32.4,0,0,0-3.5-14.6l25.7-22.8a31.9,31.9,0,0,0,37.3-1.3l23.1,18A31.7,31.7,0,0,0,168,184a32,32,0,1,0,32-32Zm0-64a16,16,0,1,1-16,16A16,16,0,0,1,200,88ZM80,56A16,16,0,1,1,96,72,16,16,0,0,1,80,56ZM56,208a16,16,0,1,1,16-16A16,16,0,0,1,56,208Zm144-8a16,16,0,1,1,16-16A16,16,0,0,1,200,200Z" }, null, -1), rwn = [
  swn
], iwn = { key: 3 }, lwn = ["stroke"], dwn = ["stroke"], kwn = ["stroke"], cwn = ["stroke"], hwn = ["stroke"], uwn = ["stroke"], awn = ["stroke"], _wn = ["stroke"], pwn = ["stroke"], ywn = { key: 4 }, $wn = ["stroke"], wwn = ["stroke"], fwn = ["stroke"], gwn = ["stroke"], xwn = ["stroke"], jwn = ["stroke"], mwn = ["stroke"], Mwn = ["stroke"], vwn = ["stroke"], Swn = { key: 5 }, Hwn = ["stroke"], Awn = ["stroke"], Vwn = ["stroke"], zwn = ["stroke"], Zwn = ["stroke"], Cwn = ["stroke"], bwn = ["stroke"], Lwn = ["stroke"], Bwn = ["stroke"], Pwn = {
  name: "PhGraph"
}, dK1 = /* @__PURE__ */ $({
  ...Pwn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", P$n, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, W$n),
        e("circle", {
          cx: "96",
          cy: "56",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, N$n),
        e("circle", {
          cx: "200",
          cy: "100",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, F$n),
        e("circle", {
          cx: "200",
          cy: "188",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, T$n),
        e("circle", {
          cx: "56",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, D$n),
        e("line", {
          x1: "118.3",
          y1: "106.1",
          x2: "105.7",
          y2: "77.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, R$n),
        e("line", {
          x1: "110.1",
          y1: "143.9",
          x2: "73.9",
          y2: "176.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, U$n),
        e("line", {
          x1: "181.6",
          y1: "172.6",
          x2: "146.4",
          y2: "143.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, q$n),
        e("line", {
          x1: "177.6",
          y1: "108.7",
          x2: "150.4",
          y2: "119.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, G$n)
      ])) : o(i) === "duotone" ? (s(), r("g", E$n, [
        O$n,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I$n),
        e("circle", {
          cx: "96",
          cy: "56",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K$n),
        e("circle", {
          cx: "200",
          cy: "104",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X$n),
        e("circle", {
          cx: "200",
          cy: "184",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J$n),
        e("circle", {
          cx: "56",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q$n),
        e("line", {
          x1: "118.3",
          y1: "106.1",
          x2: "105.7",
          y2: "77.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y$n),
        e("line", {
          x1: "177.2",
          y1: "111.6",
          x2: "150.8",
          y2: "120.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, own),
        e("line", {
          x1: "181.1",
          y1: "169.3",
          x2: "146.9",
          y2: "142.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ewn),
        e("line", {
          x1: "110.1",
          y1: "143.9",
          x2: "73.9",
          y2: "176.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, twn)
      ])) : o(i) === "fill" ? (s(), r("g", nwn, rwn)) : o(i) === "light" ? (s(), r("g", iwn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lwn),
        e("circle", {
          cx: "96",
          cy: "56",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dwn),
        e("circle", {
          cx: "200",
          cy: "104",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kwn),
        e("circle", {
          cx: "200",
          cy: "184",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cwn),
        e("circle", {
          cx: "56",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hwn),
        e("line", {
          x1: "118.3",
          y1: "106.1",
          x2: "105.7",
          y2: "77.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uwn),
        e("line", {
          x1: "177.2",
          y1: "111.6",
          x2: "150.8",
          y2: "120.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, awn),
        e("line", {
          x1: "181.1",
          y1: "169.3",
          x2: "146.9",
          y2: "142.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _wn),
        e("line", {
          x1: "110.1",
          y1: "143.9",
          x2: "73.9",
          y2: "176.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pwn)
      ])) : o(i) === "thin" ? (s(), r("g", ywn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $wn),
        e("circle", {
          cx: "96",
          cy: "56",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wwn),
        e("circle", {
          cx: "200",
          cy: "104",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fwn),
        e("circle", {
          cx: "200",
          cy: "184",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gwn),
        e("circle", {
          cx: "56",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xwn),
        e("line", {
          x1: "118.3",
          y1: "106.1",
          x2: "105.7",
          y2: "77.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jwn),
        e("line", {
          x1: "177.2",
          y1: "111.6",
          x2: "150.8",
          y2: "120.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mwn),
        e("line", {
          x1: "181.1",
          y1: "169.3",
          x2: "146.9",
          y2: "142.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Mwn),
        e("line", {
          x1: "110.1",
          y1: "143.9",
          x2: "73.9",
          y2: "176.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vwn)
      ])) : o(i) === "regular" ? (s(), r("g", Swn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hwn),
        e("circle", {
          cx: "96",
          cy: "56",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Awn),
        e("circle", {
          cx: "200",
          cy: "104",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vwn),
        e("circle", {
          cx: "200",
          cy: "184",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zwn),
        e("circle", {
          cx: "56",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zwn),
        e("line", {
          x1: "118.3",
          y1: "106.1",
          x2: "105.7",
          y2: "77.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cwn),
        e("line", {
          x1: "177.2",
          y1: "111.6",
          x2: "150.8",
          y2: "120.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bwn),
        e("line", {
          x1: "181.1",
          y1: "169.3",
          x2: "146.9",
          y2: "142.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lwn),
        e("line", {
          x1: "110.1",
          y1: "143.9",
          x2: "73.9",
          y2: "176.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bwn)
      ])) : g("", !0)
    ], 16, B$n));
  }
}), Wwn = ["width", "height", "fill", "transform"], Nwn = { key: 0 }, Fwn = ["stroke"], Twn = ["stroke"], Dwn = ["stroke"], Rwn = { key: 1 }, Uwn = /* @__PURE__ */ e("path", {
  d: "M128,128H44V52a8,8,0,0,1,8-8h76Z",
  opacity: "0.2"
}, null, -1), qwn = ["stroke"], Gwn = ["stroke"], Ewn = ["stroke"], Own = { key: 2 }, Iwn = /* @__PURE__ */ e("path", { d: "M204,36H52A16,16,0,0,0,36,52V204a16,16,0,0,0,16,16H204a16,16,0,0,0,16-16V52A16,16,0,0,0,204,36Zm0,92H128V52h76ZM52,128h76v76H52Z" }, null, -1), Kwn = [
  Iwn
], Xwn = { key: 3 }, Jwn = ["stroke"], Qwn = ["stroke"], Ywn = ["stroke"], ofn = { key: 4 }, efn = ["stroke"], tfn = ["stroke"], nfn = ["stroke"], sfn = { key: 5 }, rfn = ["stroke"], ifn = ["stroke"], lfn = ["stroke"], dfn = {
  name: "PhGridFour"
}, kK1 = /* @__PURE__ */ $({
  ...dfn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Nwn, [
        e("rect", {
          x: "44",
          y: "44",
          width: "168",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fwn),
        e("line", {
          x1: "128",
          y1: "44",
          x2: "128",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Twn),
        e("line", {
          x1: "212",
          y1: "128",
          x2: "44",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Dwn)
      ])) : o(i) === "duotone" ? (s(), r("g", Rwn, [
        Uwn,
        e("rect", {
          x: "44",
          y: "44",
          width: "168",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qwn),
        e("line", {
          x1: "128",
          y1: "44",
          x2: "128",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gwn),
        e("line", {
          x1: "212",
          y1: "128",
          x2: "44",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ewn)
      ])) : o(i) === "fill" ? (s(), r("g", Own, Kwn)) : o(i) === "light" ? (s(), r("g", Xwn, [
        e("rect", {
          x: "44",
          y: "44",
          width: "168",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jwn),
        e("line", {
          x1: "128",
          y1: "44",
          x2: "128",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qwn),
        e("line", {
          x1: "212",
          y1: "128",
          x2: "44",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ywn)
      ])) : o(i) === "thin" ? (s(), r("g", ofn, [
        e("rect", {
          x: "44",
          y: "44",
          width: "168",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, efn),
        e("line", {
          x1: "128",
          y1: "44",
          x2: "128",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tfn),
        e("line", {
          x1: "212",
          y1: "128",
          x2: "44",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nfn)
      ])) : o(i) === "regular" ? (s(), r("g", sfn, [
        e("rect", {
          x: "44",
          y: "44",
          width: "168",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rfn),
        e("line", {
          x1: "128",
          y1: "44",
          x2: "128",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ifn),
        e("line", {
          x1: "212",
          y1: "128",
          x2: "44",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lfn)
      ])) : g("", !0)
    ], 16, Wwn));
  }
}), kfn = ["width", "height", "fill", "transform"], cfn = { key: 0 }, hfn = ["stroke"], ufn = ["stroke"], afn = ["stroke"], _fn = ["stroke"], pfn = { key: 1 }, yfn = /* @__PURE__ */ e("path", {
  d: "M48.8,96A8,8,0,0,1,41,86.3C47.4,55.5,83.9,32,128,32s80.6,23.5,87,54.3a8,8,0,0,1-7.8,9.7Z",
  opacity: "0.2"
}, null, -1), $fn = /* @__PURE__ */ e("path", {
  d: "M68,160l40,16,40-16,40,16,20-8v16a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V168Z",
  opacity: "0.2"
}, null, -1), wfn = ["stroke"], ffn = ["stroke"], gfn = ["stroke"], xfn = ["stroke"], jfn = { key: 2 }, mfn = /* @__PURE__ */ e("path", { d: "M36.4,98.1a16.3,16.3,0,0,1-3.2-13.5C40.5,49.5,80.4,24,128,24s87.5,25.5,94.8,60.6A16,16,0,0,1,207.2,104H48.8A16.2,16.2,0,0,1,36.4,98.1ZM225,152.6l-20.1,8h0L188,167.4l-37-14.8a7.8,7.8,0,0,0-6,0l-37,14.8L71,152.6a7.8,7.8,0,0,0-6,0l-20.1,8h0l-19.9,8A8,8,0,0,0,28,184a8,8,0,0,0,3-.6l9-3.6V184a40,40,0,0,0,40,40h96a40,40,0,0,0,40-40V173.4l15-6a8,8,0,0,0-6-14.8Zm7-32.6H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Z" }, null, -1), Mfn = [
  mfn
], vfn = { key: 3 }, Sfn = ["stroke"], Hfn = ["stroke"], Afn = ["stroke"], Vfn = ["stroke"], zfn = { key: 4 }, Zfn = ["stroke"], Cfn = ["stroke"], bfn = ["stroke"], Lfn = ["stroke"], Bfn = { key: 5 }, Pfn = ["stroke"], Wfn = ["stroke"], Nfn = ["stroke"], Ffn = ["stroke"], Tfn = {
  name: "PhHamburger"
}, cK1 = /* @__PURE__ */ $({
  ...Tfn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", cfn, [
        e("path", {
          d: "M48,112a80,80,0,0,1,160,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hfn),
        e("path", {
          d: "M208,160v24a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ufn),
        e("polyline", {
          points: "28 168 68 152 108 168 148 152 188 168 228 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, afn),
        e("line", {
          x1: "24",
          y1: "112",
          x2: "232",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _fn)
      ])) : o(i) === "duotone" ? (s(), r("g", pfn, [
        yfn,
        $fn,
        e("path", {
          d: "M48.8,96A8,8,0,0,1,41,86.3C47.4,55.5,83.9,32,128,32s80.6,23.5,87,54.3a8,8,0,0,1-7.8,9.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wfn),
        e("path", {
          d: "M208,168v16a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ffn),
        e("polyline", {
          points: "28 176 68 160 108 176 148 160 188 176 228 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gfn),
        e("line", {
          x1: "24",
          y1: "128",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xfn)
      ])) : o(i) === "fill" ? (s(), r("g", jfn, Mfn)) : o(i) === "light" ? (s(), r("g", vfn, [
        e("path", {
          d: "M48.8,96A8,8,0,0,1,41,86.3C47.4,55.5,83.9,32,128,32s80.6,23.5,87,54.3a8,8,0,0,1-7.8,9.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Sfn),
        e("path", {
          d: "M208,168v16a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hfn),
        e("polyline", {
          points: "28 176 68 160 108 176 148 160 188 176 228 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Afn),
        e("line", {
          x1: "24",
          y1: "128",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vfn)
      ])) : o(i) === "thin" ? (s(), r("g", zfn, [
        e("path", {
          d: "M48.8,96A8,8,0,0,1,41,86.3C47.4,55.5,83.9,32,128,32s80.6,23.5,87,54.3a8,8,0,0,1-7.8,9.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zfn),
        e("path", {
          d: "M208,168v16a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cfn),
        e("polyline", {
          points: "28 176 68 160 108 176 148 160 188 176 228 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bfn),
        e("line", {
          x1: "24",
          y1: "128",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lfn)
      ])) : o(i) === "regular" ? (s(), r("g", Bfn, [
        e("path", {
          d: "M48.8,96A8,8,0,0,1,41,86.3C47.4,55.5,83.9,32,128,32s80.6,23.5,87,54.3a8,8,0,0,1-7.8,9.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pfn),
        e("path", {
          d: "M208,168v16a32,32,0,0,1-32,32H80a32,32,0,0,1-32-32V168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wfn),
        e("polyline", {
          points: "28 176 68 160 108 176 148 160 188 176 228 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nfn),
        e("line", {
          x1: "24",
          y1: "128",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ffn)
      ])) : g("", !0)
    ], 16, kfn));
  }
}), Dfn = ["width", "height", "fill", "transform"], Rfn = { key: 0 }, Ufn = ["stroke"], qfn = ["stroke"], Gfn = { key: 1 }, Efn = /* @__PURE__ */ e("path", {
  d: "M128,52V36a20,20,0,0,1,40,0V68a20,20,0,0,1,40,0v84a80,80,0,0,1-80,80c-44.2,0-64-24-96.6-92.7a20,20,0,0,1,34.7-20l21.9,38V52a20,20,0,0,1,40,0Z",
  opacity: "0.2"
}, null, -1), Ofn = ["stroke"], Ifn = ["stroke"], Kfn = { key: 2 }, Xfn = /* @__PURE__ */ e("path", { d: "M188,40a28.2,28.2,0,0,0-12,2.7V36a28,28,0,0,0-54.6-8.6A27.8,27.8,0,0,0,108,24,28.1,28.1,0,0,0,80,52v75.4l-7-12.1A28,28,0,0,0,24.3,143c32.5,68.4,54.1,97,103.7,97a88.1,88.1,0,0,0,88-88V68A28.1,28.1,0,0,0,188,40Zm12,112a72.1,72.1,0,0,1-72,72c-20.2,0-34.2-5.5-47-18.2S56.3,173,38.7,135.9l-.3-.6a11.6,11.6,0,0,1-1.2-9.1,11.8,11.8,0,0,1,5.6-7.3,12,12,0,0,1,9.1-1.2,11.6,11.6,0,0,1,7.2,5.6l22,38a8.1,8.1,0,0,0,9,3.7,7.9,7.9,0,0,0,5.9-7.7V52a12,12,0,0,1,24,0v68a8,8,0,0,0,16,0V36a12,12,0,0,1,24,0v84a8,8,0,0,0,16,0V68a12,12,0,0,1,24,0Z" }, null, -1), Jfn = [
  Xfn
], Qfn = { key: 3 }, Yfn = ["stroke"], ogn = ["stroke"], egn = { key: 4 }, tgn = ["stroke"], ngn = ["stroke"], sgn = { key: 5 }, rgn = ["stroke"], ign = ["stroke"], lgn = {
  name: "PhHand"
}, hK1 = /* @__PURE__ */ $({
  ...lgn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Rfn, [
        e("path", {
          d: "M168,120V68a20,20,0,0,1,40,0v84a80,80,0,0,1-80,80c-44.2,0-64-24-96.6-92.7a20,20,0,0,1,34.7-20l21.9,38V52a20,20,0,0,1,40,0v68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ufn),
        e("path", {
          d: "M168,68V36a20,20,0,0,0-40,0V52",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qfn)
      ])) : o(i) === "duotone" ? (s(), r("g", Gfn, [
        Efn,
        e("path", {
          d: "M168,120V68a20,20,0,0,1,40,0v84a80,80,0,0,1-80,80c-44.2,0-64-24-96.6-92.7a20,20,0,0,1,34.7-20l21.9,38V52a20,20,0,0,1,40,0v68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ofn),
        e("path", {
          d: "M168,68V36a20,20,0,0,0-40,0V52",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ifn)
      ])) : o(i) === "fill" ? (s(), r("g", Kfn, Jfn)) : o(i) === "light" ? (s(), r("g", Qfn, [
        e("path", {
          d: "M168,120V68a20,20,0,0,1,40,0v84a80,80,0,0,1-80,80c-44.2,0-64-24-96.6-92.7a20,20,0,0,1,34.7-20l21.9,38V52a20,20,0,0,1,40,0v68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Yfn),
        e("path", {
          d: "M168,68V36a20,20,0,0,0-40,0V52",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ogn)
      ])) : o(i) === "thin" ? (s(), r("g", egn, [
        e("path", {
          d: "M168,120V68a20,20,0,0,1,40,0v84a80,80,0,0,1-80,80c-44.2,0-64-24-96.6-92.7a20,20,0,0,1,34.7-20l21.9,38V52a20,20,0,0,1,40,0v68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tgn),
        e("path", {
          d: "M168,68V36a20,20,0,0,0-40,0V52",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ngn)
      ])) : o(i) === "regular" ? (s(), r("g", sgn, [
        e("path", {
          d: "M168,120V68a20,20,0,0,1,40,0v84a80,80,0,0,1-80,80c-44.2,0-64-24-96.6-92.7a20,20,0,0,1,34.7-20l21.9,38V52a20,20,0,0,1,40,0v68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rgn),
        e("path", {
          d: "M168,68V36a20,20,0,0,0-40,0V52",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ign)
      ])) : g("", !0)
    ], 16, Dfn));
  }
}), dgn = ["width", "height", "fill", "transform"], kgn = { key: 0 }, cgn = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "184",
  r: "16"
}, null, -1), hgn = ["stroke"], ugn = ["stroke"], agn = ["stroke"], _gn = ["stroke"], pgn = { key: 1 }, ygn = /* @__PURE__ */ e("path", {
  d: "M188,92a20.1,20.1,0,0,0-20,20V52a20,20,0,0,0-40,0V36a20,20,0,0,0-40,0V68a20,20,0,0,0-40,0v84a80,80,0,0,0,160,0V112A20.1,20.1,0,0,0,188,92Zm-14.6,80.4c-5.7,8.8-20.8,27.6-45.4,27.6s-39.7-18.8-45.4-27.6a8.2,8.2,0,0,1,0-8.8c5.7-8.8,20.8-27.6,45.4-27.6s39.7,18.8,45.4,27.6A8.2,8.2,0,0,1,173.4,172.4Z",
  opacity: "0.2"
}, null, -1), $gn = ["stroke"], wgn = ["stroke"], fgn = ["stroke"], ggn = ["stroke"], xgn = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "168",
  r: "12"
}, null, -1), jgn = { key: 2 }, mgn = /* @__PURE__ */ e("path", { d: "M188,84a28.2,28.2,0,0,0-12,2.7V52a28.1,28.1,0,0,0-28-28,27.8,27.8,0,0,0-13.4,3.4A28,28,0,0,0,80,36v6.7A28,28,0,0,0,40,68v84a88,88,0,0,0,176,0V112A28.1,28.1,0,0,0,188,84Zm12,68a72,72,0,0,1-144,0V68a12,12,0,0,1,24,0v44a8,8,0,0,0,16,0V36a12,12,0,0,1,24,0v68a8,8,0,0,0,16,0V52a12,12,0,0,1,24,0v64a8,8,0,0,0,16,0v-4a12,12,0,0,1,24,0Zm-72-16c-26.7,0-43,20.6-48.8,29.4a12.1,12.1,0,0,0,0,13.2C85,187.4,101.3,208,128,208s43-20.6,48.8-29.4a12.1,12.1,0,0,0,0-13.2C171,156.6,154.7,136,128,136Zm0,52a16,16,0,1,1,16-16A16,16,0,0,1,128,188Z" }, null, -1), Mgn = [
  mgn
], vgn = { key: 3 }, Sgn = ["stroke"], Hgn = ["stroke"], Agn = ["stroke"], Vgn = ["stroke"], zgn = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "168",
  r: "10"
}, null, -1), Zgn = { key: 4 }, Cgn = ["stroke"], bgn = ["stroke"], Lgn = ["stroke"], Bgn = ["stroke"], Pgn = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "168",
  r: "8"
}, null, -1), Wgn = { key: 5 }, Ngn = ["stroke"], Fgn = ["stroke"], Tgn = ["stroke"], Dgn = ["stroke"], Rgn = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "168",
  r: "12"
}, null, -1), Ugn = {
  name: "PhHandEye"
}, uK1 = /* @__PURE__ */ $({
  ...Ugn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", kgn, [
        cgn,
        e("path", {
          d: "M88,68V36a20,20,0,0,1,40,0v68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hgn),
        e("path", {
          d: "M168,168s-8-28-40-28-40,28-40,28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ugn),
        e("path", {
          d: "M128,52a20,20,0,0,1,40,0v60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, agn),
        e("path", {
          d: "M168,116v-4a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _gn)
      ])) : o(i) === "duotone" ? (s(), r("g", pgn, [
        ygn,
        e("path", {
          d: "M88,68V36a20,20,0,0,1,40,0v68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $gn),
        e("path", {
          d: "M82.6,163.6a8.2,8.2,0,0,0,0,8.8c5.7,8.8,20.8,27.6,45.4,27.6s39.7-18.8,45.4-27.6a8.2,8.2,0,0,0,0-8.8c-5.7-8.8-20.8-27.6-45.4-27.6S88.3,154.8,82.6,163.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wgn),
        e("path", {
          d: "M128,52a20,20,0,0,1,40,0v60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fgn),
        e("path", {
          d: "M168,116v-4a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ggn),
        xgn
      ])) : o(i) === "fill" ? (s(), r("g", jgn, Mgn)) : o(i) === "light" ? (s(), r("g", vgn, [
        e("path", {
          d: "M88,68V36a20,20,0,0,1,40,0v68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Sgn),
        e("path", {
          d: "M82.6,163.6a8.2,8.2,0,0,0,0,8.8c5.7,8.8,20.8,27.6,45.4,27.6s39.7-18.8,45.4-27.6a8.2,8.2,0,0,0,0-8.8c-5.7-8.8-20.8-27.6-45.4-27.6S88.3,154.8,82.6,163.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hgn),
        e("path", {
          d: "M128,52a20,20,0,0,1,40,0v60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Agn),
        e("path", {
          d: "M168,116v-4a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vgn),
        zgn
      ])) : o(i) === "thin" ? (s(), r("g", Zgn, [
        e("path", {
          d: "M88,68V36a20,20,0,0,1,40,0v68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cgn),
        e("path", {
          d: "M82.6,163.6a8.2,8.2,0,0,0,0,8.8c5.7,8.8,20.8,27.6,45.4,27.6s39.7-18.8,45.4-27.6a8.2,8.2,0,0,0,0-8.8c-5.7-8.8-20.8-27.6-45.4-27.6S88.3,154.8,82.6,163.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bgn),
        e("path", {
          d: "M128,52a20,20,0,0,1,40,0v60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lgn),
        e("path", {
          d: "M168,116v-4a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bgn),
        Pgn
      ])) : o(i) === "regular" ? (s(), r("g", Wgn, [
        e("path", {
          d: "M88,68V36a20,20,0,0,1,40,0v68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ngn),
        e("path", {
          d: "M82.6,163.6a8.2,8.2,0,0,0,0,8.8c5.7,8.8,20.8,27.6,45.4,27.6s39.7-18.8,45.4-27.6a8.2,8.2,0,0,0,0-8.8c-5.7-8.8-20.8-27.6-45.4-27.6S88.3,154.8,82.6,163.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fgn),
        e("path", {
          d: "M128,52a20,20,0,0,1,40,0v60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tgn),
        e("path", {
          d: "M168,116v-4a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dgn),
        Rgn
      ])) : g("", !0)
    ], 16, dgn));
  }
}), qgn = ["width", "height", "fill", "transform"], Ggn = { key: 0 }, Egn = ["stroke"], Ogn = ["stroke"], Ign = ["stroke"], Kgn = { key: 1 }, Xgn = /* @__PURE__ */ e("path", {
  d: "M128,64a24,24,0,0,1,48,0V88h24a23.9,23.9,0,0,1,24,24v16a96,96,0,0,1-192,0V88a24,24,0,0,1,48,0V64a24,24,0,0,1,48,0",
  opacity: "0.2"
}, null, -1), Jgn = ["stroke"], Qgn = ["stroke"], Ygn = ["stroke"], oxn = { key: 2 }, exn = /* @__PURE__ */ e("path", { d: "M200,80H184V64a32,32,0,0,0-56-21.1A31.8,31.8,0,0,0,104,32,32.1,32.1,0,0,0,72.2,60.4,32,32,0,0,0,24,88v40a104,104,0,0,0,208,0V112A32.1,32.1,0,0,0,200,80ZM152,48a16,16,0,0,1,16,16V80H136V64A16,16,0,0,1,152,48ZM88,64a16,16,0,0,1,32,0v40a16,16,0,0,1-32,0ZM40,88a16,16,0,0,1,32,0v16a16,16,0,0,1-32,0Zm88,128a88,88,0,0,1-87.9-84.2A32,32,0,0,0,80,125.1a31.9,31.9,0,0,0,44.6,3.4,32.3,32.3,0,0,0,11.8,11.4A47.7,47.7,0,0,0,120,176a8,8,0,0,0,16,0,32.1,32.1,0,0,1,32-32,8,8,0,0,0,0-16H152a16,16,0,0,1-16-16V96h64a16,16,0,0,1,16,16v16A88.1,88.1,0,0,1,128,216Z" }, null, -1), txn = [
  exn
], nxn = { key: 3 }, sxn = ["stroke"], rxn = ["stroke"], ixn = ["stroke"], lxn = { key: 4 }, dxn = ["stroke"], kxn = ["stroke"], cxn = ["stroke"], hxn = { key: 5 }, uxn = ["stroke"], axn = ["stroke"], _xn = ["stroke"], pxn = {
  name: "PhHandFist"
}, aK1 = /* @__PURE__ */ $({
  ...pxn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ggn, [
        e("path", {
          d: "M128,104a24,24,0,0,1-48,0V64a24,24,0,0,1,48,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Egn),
        e("path", {
          d: "M128,64a24,24,0,0,1,48,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ogn),
        e("path", {
          d: "M128,176a40,40,0,0,1,40-40H152a23.9,23.9,0,0,1-24-24V96a8,8,0,0,1,8-8h64a23.9,23.9,0,0,1,24,24v16a96,96,0,0,1-192,0V88a24,24,0,0,1,48,0v16a24,24,0,0,1-48,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ign)
      ])) : o(i) === "duotone" ? (s(), r("g", Kgn, [
        Xgn,
        e("path", {
          d: "M128,104a24,24,0,0,1-48,0V64a24,24,0,0,1,48,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jgn),
        e("path", {
          d: "M128,64a24,24,0,0,1,48,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qgn),
        e("path", {
          d: "M128,176a40,40,0,0,1,40-40H152a23.9,23.9,0,0,1-24-24V96a8,8,0,0,1,8-8h64a23.9,23.9,0,0,1,24,24v16a96,96,0,0,1-192,0V88a24,24,0,0,1,48,0v16a24,24,0,0,1-48,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ygn)
      ])) : o(i) === "fill" ? (s(), r("g", oxn, txn)) : o(i) === "light" ? (s(), r("g", nxn, [
        e("path", {
          d: "M128,104a24,24,0,0,1-48,0V64a24,24,0,0,1,48,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sxn),
        e("path", {
          d: "M128,64a24,24,0,0,1,48,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rxn),
        e("path", {
          d: "M128,176a40,40,0,0,1,40-40H152a23.9,23.9,0,0,1-24-24V96a8,8,0,0,1,8-8h64a23.9,23.9,0,0,1,24,24v16a96,96,0,0,1-192,0V88a24,24,0,0,1,48,0v16a24,24,0,0,1-48,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ixn)
      ])) : o(i) === "thin" ? (s(), r("g", lxn, [
        e("path", {
          d: "M128,104a24,24,0,0,1-48,0V64a24,24,0,0,1,48,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dxn),
        e("path", {
          d: "M128,64a24,24,0,0,1,48,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kxn),
        e("path", {
          d: "M128,176a40,40,0,0,1,40-40H152a23.9,23.9,0,0,1-24-24V96a8,8,0,0,1,8-8h64a23.9,23.9,0,0,1,24,24v16a96,96,0,0,1-192,0V88a24,24,0,0,1,48,0v16a24,24,0,0,1-48,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cxn)
      ])) : o(i) === "regular" ? (s(), r("g", hxn, [
        e("path", {
          d: "M128,104a24,24,0,0,1-48,0V64a24,24,0,0,1,48,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uxn),
        e("path", {
          d: "M128,64a24,24,0,0,1,48,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, axn),
        e("path", {
          d: "M128,176a40,40,0,0,1,40-40H152a23.9,23.9,0,0,1-24-24V96a8,8,0,0,1,8-8h64a23.9,23.9,0,0,1,24,24v16a96,96,0,0,1-192,0V88a24,24,0,0,1,48,0v16a24,24,0,0,1-48,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _xn)
      ])) : g("", !0)
    ], 16, qgn));
  }
}), yxn = ["width", "height", "fill", "transform"], $xn = { key: 0 }, wxn = ["stroke"], fxn = ["stroke"], gxn = ["stroke"], xxn = { key: 1 }, jxn = /* @__PURE__ */ e("path", {
  d: "M88,116H68a20.1,20.1,0,0,0-20,20v16a80,80,0,0,0,160,0V108a20,20,0,0,0-40,0V92a20,20,0,0,0-40,0,20,20,0,0,0-40,0Z",
  opacity: "0.2"
}, null, -1), mxn = ["stroke"], Mxn = ["stroke"], vxn = ["stroke"], Sxn = { key: 2 }, Hxn = /* @__PURE__ */ e("path", { d: "M188,80a27.8,27.8,0,0,0-13.4,3.4,28,28,0,0,0-46.6-11A28,28,0,0,0,80,92v16H68a28.1,28.1,0,0,0-28,28v16a88,88,0,0,0,176,0V108A28.1,28.1,0,0,0,188,80Zm12,72a72,72,0,0,1-144,0V136a12,12,0,0,1,12-12H80v24a8,8,0,0,0,16,0V92a12,12,0,0,1,24,0v32a8,8,0,0,0,16,0V92a12,12,0,0,1,24,0v32a8,8,0,0,0,16,0V108a12,12,0,0,1,24,0Z" }, null, -1), Axn = [
  Hxn
], Vxn = { key: 3 }, zxn = ["stroke"], Zxn = ["stroke"], Cxn = ["stroke"], bxn = { key: 4 }, Lxn = ["stroke"], Bxn = ["stroke"], Pxn = ["stroke"], Wxn = { key: 5 }, Nxn = ["stroke"], Fxn = ["stroke"], Txn = ["stroke"], Dxn = {
  name: "PhHandGrabbing"
}, _K1 = /* @__PURE__ */ $({
  ...Dxn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $xn, [
        e("path", {
          d: "M128,92a20,20,0,0,0-40,0v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wxn),
        e("path", {
          d: "M168,108V92a20,20,0,0,0-40,0v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fxn),
        e("path", {
          d: "M88,148V116H68a20.1,20.1,0,0,0-20,20v16a80,80,0,0,0,160,0V108a20,20,0,0,0-40,0v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gxn)
      ])) : o(i) === "duotone" ? (s(), r("g", xxn, [
        jxn,
        e("path", {
          d: "M128,92a20,20,0,0,0-40,0v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mxn),
        e("path", {
          d: "M168,108V92a20,20,0,0,0-40,0v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mxn),
        e("path", {
          d: "M88,148V116H68a20.1,20.1,0,0,0-20,20v16a80,80,0,0,0,160,0V108a20,20,0,0,0-40,0v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vxn)
      ])) : o(i) === "fill" ? (s(), r("g", Sxn, Axn)) : o(i) === "light" ? (s(), r("g", Vxn, [
        e("path", {
          d: "M128,92a20,20,0,0,0-40,0v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zxn),
        e("path", {
          d: "M168,108V92a20,20,0,0,0-40,0v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zxn),
        e("path", {
          d: "M88,148V116H68a20.1,20.1,0,0,0-20,20v16a80,80,0,0,0,160,0V108a20,20,0,0,0-40,0v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cxn)
      ])) : o(i) === "thin" ? (s(), r("g", bxn, [
        e("path", {
          d: "M128,92a20,20,0,0,0-40,0v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lxn),
        e("path", {
          d: "M168,108V92a20,20,0,0,0-40,0v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bxn),
        e("path", {
          d: "M88,148V116H68a20.1,20.1,0,0,0-20,20v16a80,80,0,0,0,160,0V108a20,20,0,0,0-40,0v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pxn)
      ])) : o(i) === "regular" ? (s(), r("g", Wxn, [
        e("path", {
          d: "M128,92a20,20,0,0,0-40,0v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nxn),
        e("path", {
          d: "M168,108V92a20,20,0,0,0-40,0v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fxn),
        e("path", {
          d: "M88,148V116H68a20.1,20.1,0,0,0-20,20v16a80,80,0,0,0,160,0V108a20,20,0,0,0-40,0v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Txn)
      ])) : g("", !0)
    ], 16, yxn));
  }
}), Rxn = ["width", "height", "fill", "transform"], Uxn = { key: 0 }, qxn = ["stroke"], Gxn = ["stroke"], Exn = ["stroke"], Oxn = { key: 1 }, Ixn = /* @__PURE__ */ e("path", {
  d: "M168,112a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0V36a20,20,0,0,1,40,0V52a20,20,0,0,1,40,0Z",
  opacity: "0.2"
}, null, -1), Kxn = ["stroke"], Xxn = ["stroke"], Jxn = ["stroke"], Qxn = { key: 2 }, Yxn = /* @__PURE__ */ e("path", { d: "M188,84a28.2,28.2,0,0,0-12,2.7V52a28.1,28.1,0,0,0-28-28,27.8,27.8,0,0,0-13.4,3.4A28,28,0,0,0,80,36v6.7A28,28,0,0,0,40,68v84a88,88,0,0,0,176,0V112A28.1,28.1,0,0,0,188,84Zm12,68a72,72,0,0,1-144,0V68a12,12,0,0,1,24,0v44a8,8,0,0,0,16,0V36a12,12,0,0,1,24,0v68a8,8,0,0,0,16,0V52a12,12,0,0,1,24,0v72.7A48,48,0,0,0,120,172a8,8,0,0,0,16,0,32.1,32.1,0,0,1,32-32,8,8,0,0,0,8-8V112a12,12,0,0,1,24,0Z" }, null, -1), ojn = [
  Yxn
], ejn = { key: 3 }, tjn = ["stroke"], njn = ["stroke"], sjn = ["stroke"], rjn = { key: 4 }, ijn = ["stroke"], ljn = ["stroke"], djn = ["stroke"], kjn = { key: 5 }, cjn = ["stroke"], hjn = ["stroke"], ujn = ["stroke"], ajn = {
  name: "PhHandPalm"
}, pK1 = /* @__PURE__ */ $({
  ...ajn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Uxn, [
        e("path", {
          d: "M128,52a20,20,0,0,1,40,0v60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qxn),
        e("path", {
          d: "M88,68V36a20,20,0,0,1,40,0v68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gxn),
        e("path", {
          d: "M128,172a40,40,0,0,1,40-40V112a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Exn)
      ])) : o(i) === "duotone" ? (s(), r("g", Oxn, [
        Ixn,
        e("path", {
          d: "M128,52a20,20,0,0,1,40,0v60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kxn),
        e("path", {
          d: "M88,68V36a20,20,0,0,1,40,0v68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xxn),
        e("path", {
          d: "M128,172a40,40,0,0,1,40-40V112a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jxn)
      ])) : o(i) === "fill" ? (s(), r("g", Qxn, ojn)) : o(i) === "light" ? (s(), r("g", ejn, [
        e("path", {
          d: "M128,52a20,20,0,0,1,40,0v60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tjn),
        e("path", {
          d: "M88,68V36a20,20,0,0,1,40,0v68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, njn),
        e("path", {
          d: "M128,172a40,40,0,0,1,40-40V112a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sjn)
      ])) : o(i) === "thin" ? (s(), r("g", rjn, [
        e("path", {
          d: "M128,52a20,20,0,0,1,40,0v60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ijn),
        e("path", {
          d: "M88,68V36a20,20,0,0,1,40,0v68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ljn),
        e("path", {
          d: "M128,172a40,40,0,0,1,40-40V112a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, djn)
      ])) : o(i) === "regular" ? (s(), r("g", kjn, [
        e("path", {
          d: "M128,52a20,20,0,0,1,40,0v60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cjn),
        e("path", {
          d: "M88,68V36a20,20,0,0,1,40,0v68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hjn),
        e("path", {
          d: "M128,172a40,40,0,0,1,40-40V112a20,20,0,0,1,40,0v40a80,80,0,0,1-160,0V68a20,20,0,0,1,40,0v44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ujn)
      ])) : g("", !0)
    ], 16, Rxn));
  }
}), _jn = ["width", "height", "fill", "transform"], pjn = { key: 0 }, yjn = ["stroke"], $jn = { key: 1 }, wjn = /* @__PURE__ */ e("path", {
  d: "M168,112V100a20,20,0,0,0-40,0V36a20,20,0,0,0-40,0V157.3l-21.9-38a20,20,0,0,0-34.7,20C64,208,83.8,232,128,232a80,80,0,0,0,80-80V112a20,20,0,0,0-40,0Z",
  opacity: "0.2"
}, null, -1), fjn = ["stroke"], gjn = { key: 2 }, xjn = /* @__PURE__ */ e("path", { d: "M188,84a27.6,27.6,0,0,0-14.6,4.1A28.1,28.1,0,0,0,136,74.7V36a28,28,0,0,0-56,0v91.4l-7-12.1A28,28,0,0,0,24.3,143c32.5,68.4,54.1,97,103.7,97a88.1,88.1,0,0,0,88-88V112A28.1,28.1,0,0,0,188,84Zm12,68a72.1,72.1,0,0,1-72,72c-20.2,0-34.2-5.5-47-18.2S56.3,173,38.7,135.9l-.3-.6a11.6,11.6,0,0,1-1.2-9.1,11.8,11.8,0,0,1,5.6-7.3,12,12,0,0,1,9.1-1.2,11.6,11.6,0,0,1,7.2,5.6l22,38a8.1,8.1,0,0,0,9,3.7,7.9,7.9,0,0,0,5.9-7.7V36a12,12,0,0,1,24,0v68a8,8,0,0,0,16,0v-4a12,12,0,0,1,24,0v12a8,8,0,0,0,16,0,12,12,0,0,1,24,0Z" }, null, -1), jjn = [
  xjn
], mjn = { key: 3 }, Mjn = ["stroke"], vjn = { key: 4 }, Sjn = ["stroke"], Hjn = { key: 5 }, Ajn = ["stroke"], Vjn = {
  name: "PhHandPointing"
}, yK1 = /* @__PURE__ */ $({
  ...Vjn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", pjn, [
        e("path", {
          d: "M168,112V100a20,20,0,0,0-40,0V36a20,20,0,0,0-40,0V157.3l-21.9-38a20,20,0,0,0-34.7,20C64,208,83.8,232,128,232a80,80,0,0,0,80-80V112a20,20,0,0,0-40,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yjn)
      ])) : o(i) === "duotone" ? (s(), r("g", $jn, [
        wjn,
        e("path", {
          d: "M168,112V100a20,20,0,0,0-40,0V36a20,20,0,0,0-40,0V157.3l-21.9-38a20,20,0,0,0-34.7,20C64,208,83.8,232,128,232a80,80,0,0,0,80-80V112a20,20,0,0,0-40,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fjn)
      ])) : o(i) === "fill" ? (s(), r("g", gjn, jjn)) : o(i) === "light" ? (s(), r("g", mjn, [
        e("path", {
          d: "M168,112V100a20,20,0,0,0-40,0V36a20,20,0,0,0-40,0V157.3l-21.9-38a20,20,0,0,0-34.7,20C64,208,83.8,232,128,232a80,80,0,0,0,80-80V112a20,20,0,0,0-40,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mjn)
      ])) : o(i) === "thin" ? (s(), r("g", vjn, [
        e("path", {
          d: "M168,112V100a20,20,0,0,0-40,0V36a20,20,0,0,0-40,0V157.3l-21.9-38a20,20,0,0,0-34.7,20C64,208,83.8,232,128,232a80,80,0,0,0,80-80V112a20,20,0,0,0-40,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Sjn)
      ])) : o(i) === "regular" ? (s(), r("g", Hjn, [
        e("path", {
          d: "M168,112V100a20,20,0,0,0-40,0V36a20,20,0,0,0-40,0V157.3l-21.9-38a20,20,0,0,0-34.7,20C64,208,83.8,232,128,232a80,80,0,0,0,80-80V112a20,20,0,0,0-40,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ajn)
      ])) : g("", !0)
    ], 16, _jn));
  }
}), zjn = ["width", "height", "fill", "transform"], Zjn = { key: 0 }, Cjn = ["stroke"], bjn = ["stroke"], Ljn = ["stroke"], Bjn = ["stroke"], Pjn = { key: 1 }, Wjn = /* @__PURE__ */ e("path", {
  d: "M80,104h96a32,32,0,0,1,32,32v80a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V136A32,32,0,0,1,80,104Z",
  opacity: "0.2"
}, null, -1), Njn = ["stroke"], Fjn = ["stroke"], Tjn = ["stroke"], Djn = ["stroke"], Rjn = { key: 2 }, Ujn = /* @__PURE__ */ e("path", { d: "M184,96.8V88a32.1,32.1,0,0,0-32-32H136V32h32a8,8,0,0,1,8,8,8,8,0,0,0,16,0,24.1,24.1,0,0,0-24-24H104a8,8,0,0,0,0,16h16V56H104A32.1,32.1,0,0,0,72,88v8.8A40.1,40.1,0,0,0,40,136v80a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V136A40.1,40.1,0,0,0,184,96.8ZM104,72h48a16,16,0,0,1,16,16v8H88V88A16,16,0,0,1,104,72Z" }, null, -1), qjn = [
  Ujn
], Gjn = { key: 3 }, Ejn = ["stroke"], Ojn = ["stroke"], Ijn = ["stroke"], Kjn = ["stroke"], Xjn = { key: 4 }, Jjn = ["stroke"], Qjn = ["stroke"], Yjn = ["stroke"], omn = ["stroke"], emn = { key: 5 }, tmn = ["stroke"], nmn = ["stroke"], smn = ["stroke"], rmn = ["stroke"], imn = {
  name: "PhHandSoap"
}, $K1 = /* @__PURE__ */ $({
  ...imn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Zjn, [
        e("path", {
          d: "M80,108h96a32,32,0,0,1,32,32v76a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V140A32,32,0,0,1,80,108Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cjn),
        e("path", {
          d: "M80,108V92a23.9,23.9,0,0,1,24-24h48a23.9,23.9,0,0,1,24,24v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bjn),
        e("path", {
          d: "M184,40a16,16,0,0,0-16-16H104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ljn),
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bjn)
      ])) : o(i) === "duotone" ? (s(), r("g", Pjn, [
        Wjn,
        e("path", {
          d: "M80,104h96a32,32,0,0,1,32,32v80a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V136A32,32,0,0,1,80,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Njn),
        e("path", {
          d: "M80,104V88a23.9,23.9,0,0,1,24-24h48a23.9,23.9,0,0,1,24,24v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fjn),
        e("path", {
          d: "M184,40a16,16,0,0,0-16-16H104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tjn),
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Djn)
      ])) : o(i) === "fill" ? (s(), r("g", Rjn, qjn)) : o(i) === "light" ? (s(), r("g", Gjn, [
        e("path", {
          d: "M80,104h96a32,32,0,0,1,32,32v80a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V136A32,32,0,0,1,80,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ejn),
        e("path", {
          d: "M80,104V88a23.9,23.9,0,0,1,24-24h48a23.9,23.9,0,0,1,24,24v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ojn),
        e("path", {
          d: "M184,40a16,16,0,0,0-16-16H104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ijn),
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kjn)
      ])) : o(i) === "thin" ? (s(), r("g", Xjn, [
        e("path", {
          d: "M80,104h96a32,32,0,0,1,32,32v80a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V136A32,32,0,0,1,80,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jjn),
        e("path", {
          d: "M80,104V88a23.9,23.9,0,0,1,24-24h48a23.9,23.9,0,0,1,24,24v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qjn),
        e("path", {
          d: "M184,40a16,16,0,0,0-16-16H104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Yjn),
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, omn)
      ])) : o(i) === "regular" ? (s(), r("g", emn, [
        e("path", {
          d: "M80,104h96a32,32,0,0,1,32,32v80a8,8,0,0,1-8,8H56a8,8,0,0,1-8-8V136A32,32,0,0,1,80,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tmn),
        e("path", {
          d: "M80,104V88a23.9,23.9,0,0,1,24-24h48a23.9,23.9,0,0,1,24,24v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nmn),
        e("path", {
          d: "M184,40a16,16,0,0,0-16-16H104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, smn),
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rmn)
      ])) : g("", !0)
    ], 16, zjn));
  }
}), lmn = ["width", "height", "fill", "transform"], dmn = { key: 0 }, kmn = ["stroke"], cmn = ["stroke"], hmn = ["stroke"], umn = ["stroke"], amn = ["stroke"], _mn = { key: 1 }, pmn = /* @__PURE__ */ e("path", {
  d: "M158.6,93.3a20,20,0,0,1,34.7-20l20,34.7A80,80,0,0,1,74.7,188l-42-72.8a20,20,0,0,1,34.7-20l-16-27.7A20,20,0,0,1,86,47.5l8,13.9a20,20,0,0,1,34.6-20Z",
  opacity: "0.2"
}, null, -1), ymn = ["stroke"], $mn = ["stroke"], wmn = ["stroke"], fmn = ["stroke"], gmn = ["stroke"], xmn = { key: 2 }, jmn = /* @__PURE__ */ e("path", { d: "M220.2,104l-20-34.7a28.1,28.1,0,0,0-47.3-1.9l-17.3-30A28.1,28.1,0,0,0,97.3,27.1a29.4,29.4,0,0,0-9.9,9.6,27.9,27.9,0,0,0-11.5-6.2,27.1,27.1,0,0,0-21.2,2.8A27.9,27.9,0,0,0,44.4,71.5l3.4,5.8A28.5,28.5,0,0,0,36,81a28.1,28.1,0,0,0-10.2,38.2l42,72.8a88,88,0,1,0,152.4-88Zm-6.7,62.6A71.2,71.2,0,0,1,180,210.3,72.1,72.1,0,0,1,81.6,184l-42-72.8a12,12,0,0,1,20.8-12l22,38.1a8,8,0,1,0,13.9-8l-22-38.1h0l-16-27.7a12,12,0,0,1-1.2-9.1,11.8,11.8,0,0,1,5.6-7.3,12,12,0,0,1,9.1-1.2,12.5,12.5,0,0,1,7.3,5.6L87,65.4h.1l26,45a7.7,7.7,0,0,0,6.9,4,7.3,7.3,0,0,0,4-1.1,8,8,0,0,0,2.9-10.9l-26-45h0a12,12,0,1,1,20.8-12l30,51.9h0l6.3,11a48.1,48.1,0,0,0-10.9,61,8,8,0,0,0,13.8-8,32,32,0,0,1,11.7-43.7,8.1,8.1,0,0,0,3.8-4.9,8.4,8.4,0,0,0-.8-6l-10-17.4a12,12,0,0,1,13.5-17.5,11.8,11.8,0,0,1,7.2,5.5l20,34.7A70.9,70.9,0,0,1,213.5,166.6Zm-125.8,78a8.2,8.2,0,0,1-6.6,3.4,8.6,8.6,0,0,1-4.6-1.4A117.9,117.9,0,0,1,41.1,208a8,8,0,1,1,13.8-8,102.6,102.6,0,0,0,30.8,33.4A8.1,8.1,0,0,1,87.7,244.6ZM168,31a8,8,0,0,1,8-8h0a60.2,60.2,0,0,1,52,30,7.9,7.9,0,0,1-3,10.9,7.1,7.1,0,0,1-4,1.1,8,8,0,0,1-6.9-4A44,44,0,0,0,176,39,8,8,0,0,1,168,31Z" }, null, -1), mmn = [
  jmn
], Mmn = { key: 3 }, vmn = ["stroke"], Smn = ["stroke"], Hmn = ["stroke"], Amn = ["stroke"], Vmn = ["stroke"], zmn = { key: 4 }, Zmn = ["stroke"], Cmn = ["stroke"], bmn = ["stroke"], Lmn = ["stroke"], Bmn = ["stroke"], Pmn = { key: 5 }, Wmn = ["stroke"], Nmn = ["stroke"], Fmn = ["stroke"], Tmn = ["stroke"], Dmn = ["stroke"], Rmn = {
  name: "PhHandWaving"
}, wK1 = /* @__PURE__ */ $({
  ...Rmn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", dmn, [
        e("path", {
          d: "M94,61.4a20,20,0,0,1,34.6-20l30,51.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kmn),
        e("path", {
          d: "M67.4,95.2l-16-27.7A20,20,0,0,1,86,47.5l34,58.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cmn),
        e("path", {
          d: "M154,165.3a39.9,39.9,0,0,1,14.6-54.6l-10-17.4a20,20,0,0,1,34.7-20l20,34.7A80,80,0,0,1,74.7,188l-42-72.8a20,20,0,0,1,34.7-20l22,38.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hmn),
        e("path", {
          d: "M176,23a60.1,60.1,0,0,1,52,30",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, umn),
        e("path", {
          d: "M66.9,240a121.1,121.1,0,0,1-26.8-32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, amn)
      ])) : o(i) === "duotone" ? (s(), r("g", _mn, [
        pmn,
        e("path", {
          d: "M94,61.4a20,20,0,0,1,34.6-20l30,51.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ymn),
        e("path", {
          d: "M67.4,95.2l-16-27.7A20,20,0,0,1,86,47.5l34,58.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $mn),
        e("path", {
          d: "M154,165.3a39.9,39.9,0,0,1,14.6-54.6l-10-17.4a20,20,0,0,1,34.7-20l20,34.7A80,80,0,0,1,74.7,188l-42-72.8a20,20,0,0,1,34.7-20l22,38.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wmn),
        e("path", {
          d: "M81.1,240A110.3,110.3,0,0,1,48,204",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fmn),
        e("path", {
          d: "M176,31a51.7,51.7,0,0,1,45,26",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gmn)
      ])) : o(i) === "fill" ? (s(), r("g", xmn, mmn)) : o(i) === "light" ? (s(), r("g", Mmn, [
        e("path", {
          d: "M94,61.4a20,20,0,0,1,34.6-20l30,51.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vmn),
        e("path", {
          d: "M67.4,95.2l-16-27.7A20,20,0,0,1,86,47.5l34,58.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Smn),
        e("path", {
          d: "M154,165.3a39.9,39.9,0,0,1,14.6-54.6l-10-17.4a20,20,0,0,1,34.7-20l20,34.7A80,80,0,0,1,74.7,188l-42-72.8a20,20,0,0,1,34.7-20l22,38.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hmn),
        e("path", {
          d: "M81.1,240A110.3,110.3,0,0,1,48,204",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Amn),
        e("path", {
          d: "M176,31a51.7,51.7,0,0,1,45,26",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vmn)
      ])) : o(i) === "thin" ? (s(), r("g", zmn, [
        e("path", {
          d: "M94,61.4a20,20,0,0,1,34.6-20l30,51.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zmn),
        e("path", {
          d: "M67.4,95.2l-16-27.7A20,20,0,0,1,86,47.5l34,58.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cmn),
        e("path", {
          d: "M154,165.3a39.9,39.9,0,0,1,14.6-54.6l-10-17.4a20,20,0,0,1,34.7-20l20,34.7A80,80,0,0,1,74.7,188l-42-72.8a20,20,0,0,1,34.7-20l22,38.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bmn),
        e("path", {
          d: "M81.1,240A110.3,110.3,0,0,1,48,204",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lmn),
        e("path", {
          d: "M176,31a51.7,51.7,0,0,1,45,26",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bmn)
      ])) : o(i) === "regular" ? (s(), r("g", Pmn, [
        e("path", {
          d: "M94,61.4a20,20,0,0,1,34.6-20l30,51.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wmn),
        e("path", {
          d: "M67.4,95.2l-16-27.7A20,20,0,0,1,86,47.5l34,58.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nmn),
        e("path", {
          d: "M154,165.3a39.9,39.9,0,0,1,14.6-54.6l-10-17.4a20,20,0,0,1,34.7-20l20,34.7A80,80,0,0,1,74.7,188l-42-72.8a20,20,0,0,1,34.7-20l22,38.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fmn),
        e("path", {
          d: "M81.1,240A110.3,110.3,0,0,1,48,204",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tmn),
        e("path", {
          d: "M176,31a51.7,51.7,0,0,1,45,26",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dmn)
      ])) : g("", !0)
    ], 16, lmn));
  }
}), Umn = ["width", "height", "fill", "transform"], qmn = { key: 0 }, Gmn = ["stroke"], Emn = ["stroke"], Omn = { key: 1 }, Imn = /* @__PURE__ */ e("path", {
  d: "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
  opacity: "0.2"
}, null, -1), Kmn = ["stroke"], Xmn = ["stroke"], Jmn = { key: 2 }, Qmn = /* @__PURE__ */ e("path", { d: "M239,206.2l-14.3-128A15.9,15.9,0,0,0,208.8,64H175.3a48,48,0,0,0-94.6,0H47.2A15.9,15.9,0,0,0,31.3,78.2L17,206.2a16.2,16.2,0,0,0,4,12.5A15.9,15.9,0,0,0,32.9,224H223.1a15.9,15.9,0,0,0,11.9-5.3A16.2,16.2,0,0,0,239,206.2ZM96,104a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Zm1-40a32,32,0,0,1,62,0Zm79,40a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z" }, null, -1), Ymn = [
  Qmn
], oMn = { key: 3 }, eMn = ["stroke"], tMn = ["stroke"], nMn = { key: 4 }, sMn = ["stroke"], rMn = ["stroke"], iMn = { key: 5 }, lMn = ["stroke"], dMn = ["stroke"], kMn = {
  name: "PhHandbag"
}, fK1 = /* @__PURE__ */ $({
  ...kMn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", qmn, [
        e("path", {
          d: "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gmn),
        e("path", {
          d: "M88,104V72a40,40,0,0,1,80,0v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Emn)
      ])) : o(i) === "duotone" ? (s(), r("g", Omn, [
        Imn,
        e("path", {
          d: "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kmn),
        e("path", {
          d: "M88,104V72a40,40,0,0,1,80,0v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xmn)
      ])) : o(i) === "fill" ? (s(), r("g", Jmn, Ymn)) : o(i) === "light" ? (s(), r("g", oMn, [
        e("path", {
          d: "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eMn),
        e("path", {
          d: "M88,104V72a40,40,0,0,1,80,0v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tMn)
      ])) : o(i) === "thin" ? (s(), r("g", nMn, [
        e("path", {
          d: "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sMn),
        e("path", {
          d: "M88,104V72a40,40,0,0,1,80,0v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rMn)
      ])) : o(i) === "regular" ? (s(), r("g", iMn, [
        e("path", {
          d: "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lMn),
        e("path", {
          d: "M88,104V72a40,40,0,0,1,80,0v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dMn)
      ])) : g("", !0)
    ], 16, Umn));
  }
}), cMn = ["width", "height", "fill", "transform"], hMn = { key: 0 }, uMn = ["stroke"], aMn = ["stroke"], _Mn = { key: 1 }, pMn = /* @__PURE__ */ e("path", {
  d: "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
  opacity: "0.2"
}, null, -1), yMn = ["stroke"], $Mn = ["stroke"], wMn = { key: 2 }, fMn = /* @__PURE__ */ e("path", { d: "M239,206.2l-14.3-128A15.9,15.9,0,0,0,208.8,64H175.3a48,48,0,0,0-94.6,0H47.2A15.9,15.9,0,0,0,31.3,78.2L17,206.2a16.2,16.2,0,0,0,4,12.5A15.9,15.9,0,0,0,32.9,224H223.1a15.9,15.9,0,0,0,11.9-5.3A16.2,16.2,0,0,0,239,206.2ZM128,40a32.1,32.1,0,0,1,31,24H97A32.1,32.1,0,0,1,128,40Z" }, null, -1), gMn = [
  fMn
], xMn = { key: 3 }, jMn = ["stroke"], mMn = ["stroke"], MMn = { key: 4 }, vMn = ["stroke"], SMn = ["stroke"], HMn = { key: 5 }, AMn = ["stroke"], VMn = ["stroke"], zMn = {
  name: "PhHandbagSimple"
}, gK1 = /* @__PURE__ */ $({
  ...zMn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", hMn, [
        e("path", {
          d: "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uMn),
        e("path", {
          d: "M88,72a40,40,0,0,1,80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aMn)
      ])) : o(i) === "duotone" ? (s(), r("g", _Mn, [
        pMn,
        e("path", {
          d: "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yMn),
        e("path", {
          d: "M88,72a40,40,0,0,1,80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Mn)
      ])) : o(i) === "fill" ? (s(), r("g", wMn, gMn)) : o(i) === "light" ? (s(), r("g", xMn, [
        e("path", {
          d: "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jMn),
        e("path", {
          d: "M88,72a40,40,0,0,1,80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mMn)
      ])) : o(i) === "thin" ? (s(), r("g", MMn, [
        e("path", {
          d: "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vMn),
        e("path", {
          d: "M88,72a40,40,0,0,1,80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SMn)
      ])) : o(i) === "regular" ? (s(), r("g", HMn, [
        e("path", {
          d: "M208.8,72H47.2a8.1,8.1,0,0,0-8,7.1L25,207.1a8,8,0,0,0,7.9,8.9H223.1a8,8,0,0,0,7.9-8.9l-14.2-128A8.1,8.1,0,0,0,208.8,72Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AMn),
        e("path", {
          d: "M88,72a40,40,0,0,1,80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VMn)
      ])) : g("", !0)
    ], 16, cMn));
  }
}), ZMn = ["width", "height", "fill", "transform"], CMn = { key: 0 }, bMn = ["stroke"], LMn = ["stroke"], BMn = ["stroke"], PMn = ["stroke"], WMn = ["stroke"], NMn = ["stroke"], FMn = { key: 1 }, TMn = /* @__PURE__ */ e("path", {
  d: "M77,93.5,69,79.7a17.6,17.6,0,0,0-9.1-7.8h0l-2.4-4.1a18,18,0,1,1,31.2-18L99,67.7h0A18,18,0,0,0,77,93.5",
  opacity: "0.2"
}, null, -1), DMn = /* @__PURE__ */ e("path", {
  d: "M156.2,94.7a18,18,0,0,0-22,25.8l-26-45A17.9,17.9,0,0,0,99,67.7h0l-2.3-4a18,18,0,1,1,31.2-18l28.3,49Z",
  opacity: "0.2"
}, null, -1), RMn = /* @__PURE__ */ e("path", {
  d: "M153.9,90.7a18,18,0,1,1,31.2-18l17,29.4A72.1,72.1,0,0,1,188,191.5h0a71.5,71.5,0,0,0-5.7-59.5l-17-29.5a18.2,18.2,0,0,0-9.1-7.8h0Z",
  opacity: "0.2"
}, null, -1), UMn = ["stroke"], qMn = ["stroke"], GMn = ["stroke"], EMn = ["stroke"], OMn = ["stroke"], IMn = ["stroke"], KMn = ["stroke"], XMn = ["stroke"], JMn = ["stroke"], QMn = { key: 2 }, YMn = /* @__PURE__ */ e("path", { d: "M205.5,100.1l-17-29.4a21.9,21.9,0,0,0-30-8.1A21.5,21.5,0,0,0,148.9,74L131.3,43.7a21.9,21.9,0,0,0-30-8.1A21.5,21.5,0,0,0,91.7,47a22.1,22.1,0,0,0-29.6-7.3A21.9,21.9,0,0,0,51.9,53.1a20.9,20.9,0,0,0-.4,9.6,26.5,26.5,0,0,0-11.1,3.4,26.1,26.1,0,0,0-9.5,35.6l2,3.4a24.3,24.3,0,0,0-9.7,3.3,26,26,0,0,0-9.5,35.5l37,64.1a80,80,0,0,0,146.6-19.3l.3-1.3A76.5,76.5,0,0,0,205.5,100.1Zm-23.7,84.5A63.3,63.3,0,0,1,152,223.4,64,64,0,0,1,64.6,200l-37-64.1a10,10,0,0,1,11.2-14.7,10.3,10.3,0,0,1,6.1,4.7h0l24,41.6a8.2,8.2,0,0,0,6.9,4,8,8,0,0,0,6.9-12l-38-65.8a10,10,0,0,1,17.4-10l38,65.8a8,8,0,1,0,13.8-8l-30-52h0a10.1,10.1,0,0,1,3.7-13.7,10,10,0,0,1,13.6,3.7l42,72.8a8.2,8.2,0,0,0,7,4,8.6,8.6,0,0,0,4-1.1,8,8,0,0,0,2.9-10.9l-16-27.8h0a9.9,9.9,0,0,1-1-7.5,9.6,9.6,0,0,1,4.7-6.1,9.4,9.4,0,0,1,7.5-1,9.8,9.8,0,0,1,6.1,4.6l17,29.5A63.5,63.5,0,0,1,181.8,184.6ZM165,24.7l4.1-15.5a8,8,0,1,1,15.5,4.1l-4.2,15.5a7.9,7.9,0,0,1-7.7,5.9l-2.1-.2A8,8,0,0,1,165,24.7Zm26.3,9.2,9.2-13.1a8.1,8.1,0,0,1,11.2-2A8,8,0,0,1,213.6,30l-9.2,13.1A7.9,7.9,0,0,1,193.3,45,8,8,0,0,1,191.3,33.9Zm43.9,21.6-13.1,9.2a8.6,8.6,0,0,1-4.6,1.4,8,8,0,0,1-4.6-14.5L226,42.4a8,8,0,0,1,11.2,1.9A8.1,8.1,0,0,1,235.2,55.5Z" }, null, -1), ovn = [
  YMn
], evn = { key: 3 }, tvn = ["stroke"], nvn = ["stroke"], svn = ["stroke"], rvn = ["stroke"], ivn = ["stroke"], lvn = ["stroke"], dvn = ["stroke"], kvn = ["stroke"], cvn = ["stroke"], hvn = { key: 4 }, uvn = ["stroke"], avn = ["stroke"], _vn = ["stroke"], pvn = ["stroke"], yvn = ["stroke"], $vn = ["stroke"], wvn = ["stroke"], fvn = ["stroke"], gvn = ["stroke"], xvn = { key: 5 }, jvn = ["stroke"], mvn = ["stroke"], Mvn = ["stroke"], vvn = ["stroke"], Svn = ["stroke"], Hvn = ["stroke"], Avn = ["stroke"], Vvn = ["stroke"], zvn = ["stroke"], Zvn = {
  name: "PhHandsClapping"
}, xK1 = /* @__PURE__ */ $({
  ...Zvn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", CMn, [
        e("path", {
          d: "M112,114.4l-26-45a20,20,0,0,1,34.6-20l40,69.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bMn),
        e("path", {
          d: "M85.4,148.3l-42-72.8A20,20,0,0,1,78,55.5l42,72.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LMn),
        e("path", {
          d: "M168.6,132.5l-18-31.2a20,20,0,0,1,34.7-20l20,34.7A80,80,0,0,1,66.7,196l-42-72.8a20,20,0,0,1,34.7-20l22,38.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BMn),
        e("line", {
          x1: "156",
          y1: "12",
          x2: "156",
          y2: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PMn),
        e("line", {
          x1: "204",
          y1: "24.9",
          x2: "196",
          y2: "38.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WMn),
        e("line", {
          x1: "239.1",
          y1: "60",
          x2: "225.3",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NMn)
      ])) : o(i) === "duotone" ? (s(), r("g", FMn, [
        TMn,
        DMn,
        RMn,
        e("path", {
          d: "M51.8,121.9a18,18,0,1,0-31.2,18l37,64.1a72,72,0,0,0,124.7-72l-17-29.5a18,18,0,0,0-31.1,18",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UMn),
        e("path", {
          d: "M107,145.5,69,79.7a18,18,0,1,0-31.2,18l38,65.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qMn),
        e("path", {
          d: "M150.2,148.3l-42-72.8A18,18,0,1,0,77,93.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GMn),
        e("path", {
          d: "M99,67.7,88.7,49.8a18,18,0,1,0-31.2,18l2.4,4.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EMn),
        e("path", {
          d: "M188,191.5a72.1,72.1,0,0,0,14.1-89.4l-17-29.4a18,18,0,1,0-31.2,18",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OMn),
        e("path", {
          d: "M156.2,94.7l-28.3-49a18,18,0,1,0-31.2,18",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IMn),
        e("line", {
          x1: "176.8",
          y1: "11.3",
          x2: "172.7",
          y2: "26.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KMn),
        e("line", {
          x1: "207.1",
          y1: "25.4",
          x2: "197.9",
          y2: "38.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XMn),
        e("line", {
          x1: "230.6",
          y1: "48.9",
          x2: "217.5",
          y2: "58.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JMn)
      ])) : o(i) === "fill" ? (s(), r("g", QMn, ovn)) : o(i) === "light" ? (s(), r("g", evn, [
        e("path", {
          d: "M51.8,121.9a18,18,0,1,0-31.2,18l37,64.1a72,72,0,0,0,124.7-72l-17-29.5a18,18,0,0,0-31.1,18",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tvn),
        e("path", {
          d: "M107,145.5,69,79.7a18,18,0,1,0-31.2,18l38,65.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nvn),
        e("path", {
          d: "M150.2,148.3l-42-72.8A18,18,0,1,0,77,93.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, svn),
        e("path", {
          d: "M99,67.7,88.7,49.8a18,18,0,1,0-31.2,18l2.4,4.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rvn),
        e("path", {
          d: "M188,191.5a72.1,72.1,0,0,0,14.1-89.4l-17-29.4a18,18,0,1,0-31.2,18",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ivn),
        e("path", {
          d: "M156.2,94.7l-28.3-49a18,18,0,1,0-31.2,18",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lvn),
        e("line", {
          x1: "176.8",
          y1: "11.3",
          x2: "172.7",
          y2: "26.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dvn),
        e("line", {
          x1: "207.1",
          y1: "25.4",
          x2: "197.9",
          y2: "38.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kvn),
        e("line", {
          x1: "230.6",
          y1: "48.9",
          x2: "217.5",
          y2: "58.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cvn)
      ])) : o(i) === "thin" ? (s(), r("g", hvn, [
        e("path", {
          d: "M51.8,121.9a18,18,0,1,0-31.2,18l37,64.1a72,72,0,0,0,124.7-72l-17-29.5a18,18,0,0,0-31.1,18",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uvn),
        e("path", {
          d: "M107,145.5,69,79.7a18,18,0,1,0-31.2,18l38,65.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, avn),
        e("path", {
          d: "M150.2,148.3l-42-72.8A18,18,0,1,0,77,93.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _vn),
        e("path", {
          d: "M99,67.7,88.7,49.8a18,18,0,1,0-31.2,18l2.4,4.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pvn),
        e("path", {
          d: "M188,191.5a72.1,72.1,0,0,0,14.1-89.4l-17-29.4a18,18,0,1,0-31.2,18",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yvn),
        e("path", {
          d: "M156.2,94.7l-28.3-49a18,18,0,1,0-31.2,18",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $vn),
        e("line", {
          x1: "176.8",
          y1: "11.3",
          x2: "172.7",
          y2: "26.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wvn),
        e("line", {
          x1: "207.1",
          y1: "25.4",
          x2: "197.9",
          y2: "38.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fvn),
        e("line", {
          x1: "230.6",
          y1: "48.9",
          x2: "217.5",
          y2: "58.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gvn)
      ])) : o(i) === "regular" ? (s(), r("g", xvn, [
        e("path", {
          d: "M51.8,121.9a18,18,0,1,0-31.2,18l37,64.1a72,72,0,0,0,124.7-72l-17-29.5a18,18,0,0,0-31.1,18",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jvn),
        e("path", {
          d: "M107,145.5,69,79.7a18,18,0,1,0-31.2,18l38,65.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mvn),
        e("path", {
          d: "M150.2,148.3l-42-72.8A18,18,0,1,0,77,93.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mvn),
        e("path", {
          d: "M99,67.7,88.7,49.8a18,18,0,1,0-31.2,18l2.4,4.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vvn),
        e("path", {
          d: "M188,191.5a72.1,72.1,0,0,0,14.1-89.4l-17-29.4a18,18,0,1,0-31.2,18",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Svn),
        e("path", {
          d: "M156.2,94.7l-28.3-49a18,18,0,1,0-31.2,18",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hvn),
        e("line", {
          x1: "176.8",
          y1: "11.3",
          x2: "172.7",
          y2: "26.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Avn),
        e("line", {
          x1: "207.1",
          y1: "25.4",
          x2: "197.9",
          y2: "38.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vvn),
        e("line", {
          x1: "230.6",
          y1: "48.9",
          x2: "217.5",
          y2: "58.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zvn)
      ])) : g("", !0)
    ], 16, ZMn));
  }
}), Cvn = ["width", "height", "fill", "transform"], bvn = { key: 0 }, Lvn = ["stroke"], Bvn = ["stroke"], Pvn = ["stroke"], Wvn = ["stroke"], Nvn = ["stroke"], Fvn = ["stroke"], Tvn = { key: 1 }, Dvn = /* @__PURE__ */ e("path", {
  d: "M200,152.9l-36.8,36.8a8.5,8.5,0,0,1-7.6,2.1l-58-14.5a8,8,0,0,1-2.9-1.5L40,133.1,72.6,71.8l51.3-15a8,8,0,0,1,5.5.4L164,72.9H143.3a7.9,7.9,0,0,0-5.6,2.3L98.5,114.3a8.1,8.1,0,0,0,.9,12.1l5.4,4.1a32.1,32.1,0,0,0,38.4,0l12.8-9.6Z",
  opacity: "0.2"
}, null, -1), Rvn = ["stroke"], Uvn = ["stroke"], qvn = ["stroke"], Gvn = ["stroke"], Evn = ["stroke"], Ovn = ["stroke"], Ivn = { key: 2 }, Kvn = /* @__PURE__ */ e("path", { d: "M119.8,214.8a8.1,8.1,0,0,1-7.8,6.1,6.3,6.3,0,0,1-1.9-.3l-30.2-7.5a15.7,15.7,0,0,1-6.6-3.5L50.8,190a7.9,7.9,0,1,1,10.4-12l22.6,19.6,30.1,7.5A8.1,8.1,0,0,1,119.8,214.8Zm132.6-95.2a15.8,15.8,0,0,1-8.1,9.3L221,140.6l-14.9,17.5h-.2c0,.1-.1.1-.1.2h-.1l-36.8,36.8a16.5,16.5,0,0,1-11.4,4.7,15.8,15.8,0,0,1-3.8-.5L95.7,185a15.2,15.2,0,0,1-6-2.9l-54-42.2-24-12a16.3,16.3,0,0,1-8.1-9.4,16,16,0,0,1,1.1-12.3L29.3,59.1a16.1,16.1,0,0,1,21.3-7L73,63.3l48.7-14.2a16.6,16.6,0,0,1,11,.8l33,15h16.4l23.3-11.7a16,16,0,0,1,21.3,6.9l24.6,47.1A16.2,16.2,0,0,1,252.4,119.6Zm-64.7,34.2-31.6-23-8.1,6.1a40.2,40.2,0,0,1-48,0l-5.4-4.1a15.9,15.9,0,0,1-1.7-24.1L132,69.5l1.8-1.5-7.7-3.5L77.4,78.7,50.2,130.9l49.4,38.6L157.5,184Zm18.7-20.7L179.2,80.9H143.3L104.2,120l5.4,4.1a24.3,24.3,0,0,0,28.8,0l12.8-9.6a8,8,0,0,1,9.5-.1l38,27.6Z" }, null, -1), Xvn = [
  Kvn
], Jvn = { key: 3 }, Qvn = ["stroke"], Yvn = ["stroke"], oSn = ["stroke"], eSn = ["stroke"], tSn = ["stroke"], nSn = ["stroke"], sSn = { key: 4 }, rSn = ["stroke"], iSn = ["stroke"], lSn = ["stroke"], dSn = ["stroke"], kSn = ["stroke"], cSn = ["stroke"], hSn = { key: 5 }, uSn = ["stroke"], aSn = ["stroke"], _Sn = ["stroke"], pSn = ["stroke"], ySn = ["stroke"], $Sn = ["stroke"], wSn = {
  name: "PhHandshake"
}, jK1 = /* @__PURE__ */ $({
  ...wSn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", bvn, [
        e("path", {
          d: "M236.7,121.8,212,134.1,180,72.9l25-12.5a7.9,7.9,0,0,1,10.6,3.4l24.6,47.1A8,8,0,0,1,236.7,121.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lvn),
        e("path", {
          d: "M44,133.1,19.3,120.7a7.9,7.9,0,0,1-3.5-10.8L40.4,62.8A8,8,0,0,1,51,59.3L76,71.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bvn),
        e("path", {
          d: "M212,134.1l-12,18.8-36.8,36.8a8.5,8.5,0,0,1-7.6,2.1l-58-14.5a8,8,0,0,1-2.9-1.5L44,133.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pvn),
        e("path", {
          d: "M200,152.9l-44-32-12.8,9.6a32.1,32.1,0,0,1-38.4,0l-5.4-4.1a8.1,8.1,0,0,1-.9-12.1l39.2-39.1a7.9,7.9,0,0,1,5.6-2.3H180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wvn),
        e("path", {
          d: "M76.6,71.8l47.3-15a8,8,0,0,1,5.5.4L164,72.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nvn),
        e("path", {
          d: "M108,220.9l-30.1-7.6a7.4,7.4,0,0,1-3.3-1.7L52,192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fvn)
      ])) : o(i) === "duotone" ? (s(), r("g", Tvn, [
        Dvn,
        e("path", {
          d: "M240.7,121.8,216,134.1,184,72.9l25-12.5a7.9,7.9,0,0,1,10.6,3.4l24.6,47.1A8,8,0,0,1,240.7,121.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rvn),
        e("path", {
          d: "M40,133.1,15.3,120.7a7.9,7.9,0,0,1-3.5-10.8L36.4,62.8A8,8,0,0,1,47,59.3L72,71.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uvn),
        e("path", {
          d: "M216,134.1l-16,18.8-36.8,36.8a8.5,8.5,0,0,1-7.6,2.1l-58-14.5a8,8,0,0,1-2.9-1.5L40,133.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qvn),
        e("path", {
          d: "M200,152.9l-44-32-12.8,9.6a32.1,32.1,0,0,1-38.4,0l-5.4-4.1a8.1,8.1,0,0,1-.9-12.1l39.2-39.1a7.9,7.9,0,0,1,5.6-2.3H184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gvn),
        e("path", {
          d: "M72.6,71.8l51.3-15a8,8,0,0,1,5.5.4L164,72.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Evn),
        e("path", {
          d: "M112,212.9l-30.1-7.6a7.4,7.4,0,0,1-3.3-1.7L56,184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ovn)
      ])) : o(i) === "fill" ? (s(), r("g", Ivn, Xvn)) : o(i) === "light" ? (s(), r("g", Jvn, [
        e("path", {
          d: "M240.7,121.8,216,134.1,184,72.9l25-12.5a7.9,7.9,0,0,1,10.6,3.4l24.6,47.1A8,8,0,0,1,240.7,121.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qvn),
        e("path", {
          d: "M40,133.1,15.3,120.7a7.9,7.9,0,0,1-3.5-10.8L36.4,62.8A8,8,0,0,1,47,59.3L72,71.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Yvn),
        e("path", {
          d: "M216,134.1l-16,18.8-36.8,36.8a8.5,8.5,0,0,1-7.6,2.1l-58-14.5a8,8,0,0,1-2.9-1.5L40,133.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oSn),
        e("path", {
          d: "M200,152.9l-44-32-12.8,9.6a32.1,32.1,0,0,1-38.4,0l-5.4-4.1a8.1,8.1,0,0,1-.9-12.1l39.2-39.1a7.9,7.9,0,0,1,5.6-2.3H184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eSn),
        e("path", {
          d: "M72.6,71.8l51.3-15a8,8,0,0,1,5.5.4L164,72.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tSn),
        e("path", {
          d: "M112,212.9l-30.1-7.6a7.4,7.4,0,0,1-3.3-1.7L56,184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nSn)
      ])) : o(i) === "thin" ? (s(), r("g", sSn, [
        e("path", {
          d: "M240.7,121.8,216,134.1,184,72.9l25-12.5a7.9,7.9,0,0,1,10.6,3.4l24.6,47.1A8,8,0,0,1,240.7,121.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rSn),
        e("path", {
          d: "M40,133.1,15.3,120.7a7.9,7.9,0,0,1-3.5-10.8L36.4,62.8A8,8,0,0,1,47,59.3L72,71.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iSn),
        e("path", {
          d: "M216,134.1l-16,18.8-36.8,36.8a8.5,8.5,0,0,1-7.6,2.1l-58-14.5a8,8,0,0,1-2.9-1.5L40,133.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lSn),
        e("path", {
          d: "M200,152.9l-44-32-12.8,9.6a32.1,32.1,0,0,1-38.4,0l-5.4-4.1a8.1,8.1,0,0,1-.9-12.1l39.2-39.1a7.9,7.9,0,0,1,5.6-2.3H184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dSn),
        e("path", {
          d: "M72.6,71.8l51.3-15a8,8,0,0,1,5.5.4L164,72.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kSn),
        e("path", {
          d: "M112,212.9l-30.1-7.6a7.4,7.4,0,0,1-3.3-1.7L56,184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cSn)
      ])) : o(i) === "regular" ? (s(), r("g", hSn, [
        e("path", {
          d: "M240.7,121.8,216,134.1,184,72.9l25-12.5a7.9,7.9,0,0,1,10.6,3.4l24.6,47.1A8,8,0,0,1,240.7,121.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uSn),
        e("path", {
          d: "M40,133.1,15.3,120.7a7.9,7.9,0,0,1-3.5-10.8L36.4,62.8A8,8,0,0,1,47,59.3L72,71.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aSn),
        e("path", {
          d: "M216,134.1l-16,18.8-36.8,36.8a8.5,8.5,0,0,1-7.6,2.1l-58-14.5a8,8,0,0,1-2.9-1.5L40,133.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Sn),
        e("path", {
          d: "M200,152.9l-44-32-12.8,9.6a32.1,32.1,0,0,1-38.4,0l-5.4-4.1a8.1,8.1,0,0,1-.9-12.1l39.2-39.1a7.9,7.9,0,0,1,5.6-2.3H184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pSn),
        e("path", {
          d: "M72.6,71.8l51.3-15a8,8,0,0,1,5.5.4L164,72.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ySn),
        e("path", {
          d: "M112,212.9l-30.1-7.6a7.4,7.4,0,0,1-3.3-1.7L56,184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Sn)
      ])) : g("", !0)
    ], 16, Cvn));
  }
}), fSn = ["width", "height", "fill", "transform"], gSn = { key: 0 }, xSn = ["stroke"], jSn = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "128",
  r: "16"
}, null, -1), mSn = { key: 1 }, MSn = /* @__PURE__ */ e("rect", {
  x: "24",
  y: "72",
  width: "208",
  height: "112",
  rx: "8",
  opacity: "0.2"
}, null, -1), vSn = ["stroke"], SSn = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "128",
  r: "12"
}, null, -1), HSn = { key: 2 }, ASn = /* @__PURE__ */ e("path", { d: "M224,64H32A16,16,0,0,0,16,80v96a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V80A16,16,0,0,0,224,64Zm-36,76a12,12,0,1,1,12-12A12,12,0,0,1,188,140Z" }, null, -1), VSn = [
  ASn
], zSn = { key: 3 }, ZSn = ["stroke"], CSn = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "128",
  r: "10"
}, null, -1), bSn = { key: 4 }, LSn = ["stroke"], BSn = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "128",
  r: "8"
}, null, -1), PSn = { key: 5 }, WSn = ["stroke"], NSn = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "128",
  r: "12"
}, null, -1), FSn = {
  name: "PhHardDrive"
}, mK1 = /* @__PURE__ */ $({
  ...FSn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", gSn, [
        e("rect", {
          x: "24",
          y: "72",
          width: "208",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xSn),
        jSn
      ])) : o(i) === "duotone" ? (s(), r("g", mSn, [
        MSn,
        e("rect", {
          x: "24",
          y: "72",
          width: "208",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vSn),
        SSn
      ])) : o(i) === "fill" ? (s(), r("g", HSn, VSn)) : o(i) === "light" ? (s(), r("g", zSn, [
        e("rect", {
          x: "24",
          y: "72",
          width: "208",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZSn),
        CSn
      ])) : o(i) === "thin" ? (s(), r("g", bSn, [
        e("rect", {
          x: "24",
          y: "72",
          width: "208",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LSn),
        BSn
      ])) : o(i) === "regular" ? (s(), r("g", PSn, [
        e("rect", {
          x: "24",
          y: "72",
          width: "208",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WSn),
        NSn
      ])) : g("", !0)
    ], 16, fSn));
  }
}), TSn = ["width", "height", "fill", "transform"], DSn = { key: 0 }, RSn = ["stroke"], USn = ["stroke"], qSn = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "88",
  r: "16"
}, null, -1), GSn = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "168",
  r: "16"
}, null, -1), ESn = { key: 1 }, OSn = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "144",
  width: "176",
  height: "64",
  rx: "8",
  opacity: "0.2"
}, null, -1), ISn = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "48",
  width: "176",
  height: "64",
  rx: "8",
  opacity: "0.2"
}, null, -1), KSn = ["stroke"], XSn = ["stroke"], JSn = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "80",
  r: "12"
}, null, -1), QSn = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "176",
  r: "12"
}, null, -1), YSn = { key: 2 }, oHn = /* @__PURE__ */ e("path", { d: "M208,40H48A16,16,0,0,0,32,56v48a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V56A16,16,0,0,0,208,40ZM180,92a12,12,0,1,1,12-12A12,12,0,0,1,180,92Z" }, null, -1), eHn = /* @__PURE__ */ e("path", { d: "M208,136H48a16,16,0,0,0-16,16v48a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V152A16,16,0,0,0,208,136Zm-28,52a12,12,0,1,1,12-12A12,12,0,0,1,180,188Z" }, null, -1), tHn = [
  oHn,
  eHn
], nHn = { key: 3 }, sHn = ["stroke"], rHn = ["stroke"], iHn = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "80",
  r: "10"
}, null, -1), lHn = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "176",
  r: "10"
}, null, -1), dHn = { key: 4 }, kHn = ["stroke"], cHn = ["stroke"], hHn = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "176",
  r: "8"
}, null, -1), uHn = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "80",
  r: "8"
}, null, -1), aHn = { key: 5 }, _Hn = ["stroke"], pHn = ["stroke"], yHn = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "80",
  r: "12"
}, null, -1), $Hn = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "176",
  r: "12"
}, null, -1), wHn = {
  name: "PhHardDrives"
}, MK1 = /* @__PURE__ */ $({
  ...wHn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", DSn, [
        e("rect", {
          x: "40",
          y: "48",
          width: "176",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RSn),
        e("line", {
          x1: "216",
          y1: "128",
          x2: "40",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, USn),
        qSn,
        GSn
      ])) : o(i) === "duotone" ? (s(), r("g", ESn, [
        OSn,
        ISn,
        e("rect", {
          x: "40",
          y: "144",
          width: "176",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KSn),
        e("rect", {
          x: "40",
          y: "48",
          width: "176",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XSn),
        JSn,
        QSn
      ])) : o(i) === "fill" ? (s(), r("g", YSn, tHn)) : o(i) === "light" ? (s(), r("g", nHn, [
        e("rect", {
          x: "40",
          y: "144",
          width: "176",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sHn),
        e("rect", {
          x: "40",
          y: "48",
          width: "176",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rHn),
        iHn,
        lHn
      ])) : o(i) === "thin" ? (s(), r("g", dHn, [
        e("rect", {
          x: "40",
          y: "144",
          width: "176",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kHn),
        e("rect", {
          x: "40",
          y: "48",
          width: "176",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cHn),
        hHn,
        uHn
      ])) : o(i) === "regular" ? (s(), r("g", aHn, [
        e("rect", {
          x: "40",
          y: "144",
          width: "176",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Hn),
        e("rect", {
          x: "40",
          y: "48",
          width: "176",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pHn),
        yHn,
        $Hn
      ])) : g("", !0)
    ], 16, TSn));
  }
}), fHn = ["width", "height", "fill", "transform"], gHn = { key: 0 }, xHn = ["stroke"], jHn = ["stroke"], mHn = ["stroke"], MHn = ["stroke"], vHn = { key: 1 }, SHn = ["stroke"], HHn = ["stroke"], AHn = ["stroke"], VHn = ["stroke"], zHn = { key: 2 }, ZHn = /* @__PURE__ */ e("path", { d: "M224,88H175.4l8.5-46.6a8,8,0,0,0-15.8-2.8l-9,49.4H111.4l8.5-46.6a8,8,0,1,0-15.8-2.8L95.1,88H43.6a8,8,0,1,0,0,16H92.2l-8.7,48H32a8,8,0,0,0,0,16H80.6l-8.5,46.6a8,8,0,0,0,6.5,9.3H80a8,8,0,0,0,7.9-6.6l9-49.4h47.7l-8.5,46.6a8,8,0,0,0,6.5,9.3H144a8,8,0,0,0,7.9-6.6l9-49.4h51.5a8,8,0,0,0,0-16H163.8l8.7-48H224a8,8,0,0,0,0-16Zm-76.5,64H99.8l8.7-48h47.7Z" }, null, -1), CHn = [
  ZHn
], bHn = { key: 3 }, LHn = ["stroke"], BHn = ["stroke"], PHn = ["stroke"], WHn = ["stroke"], NHn = { key: 4 }, FHn = ["stroke"], THn = ["stroke"], DHn = ["stroke"], RHn = ["stroke"], UHn = { key: 5 }, qHn = ["stroke"], GHn = ["stroke"], EHn = ["stroke"], OHn = ["stroke"], IHn = {
  name: "PhHash"
}, vK1 = /* @__PURE__ */ $({
  ...IHn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", gHn, [
        e("line", {
          x1: "43.6",
          y1: "96",
          x2: "224",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xHn),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jHn),
        e("line", {
          x1: "112",
          y1: "40",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mHn),
        e("line", {
          x1: "32",
          y1: "160",
          x2: "212.4",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MHn)
      ])) : o(i) === "duotone" ? (s(), r("g", vHn, [
        e("line", {
          x1: "43.6",
          y1: "96",
          x2: "224",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SHn),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HHn),
        e("line", {
          x1: "112",
          y1: "40",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AHn),
        e("line", {
          x1: "32",
          y1: "160",
          x2: "212.4",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VHn)
      ])) : o(i) === "fill" ? (s(), r("g", zHn, CHn)) : o(i) === "light" ? (s(), r("g", bHn, [
        e("line", {
          x1: "43.6",
          y1: "96",
          x2: "224",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LHn),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BHn),
        e("line", {
          x1: "112",
          y1: "40",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PHn),
        e("line", {
          x1: "32",
          y1: "160",
          x2: "212.4",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WHn)
      ])) : o(i) === "thin" ? (s(), r("g", NHn, [
        e("line", {
          x1: "43.6",
          y1: "96",
          x2: "224",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FHn),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, THn),
        e("line", {
          x1: "112",
          y1: "40",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, DHn),
        e("line", {
          x1: "32",
          y1: "160",
          x2: "212.4",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RHn)
      ])) : o(i) === "regular" ? (s(), r("g", UHn, [
        e("line", {
          x1: "43.6",
          y1: "96",
          x2: "224",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qHn),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GHn),
        e("line", {
          x1: "112",
          y1: "40",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EHn),
        e("line", {
          x1: "32",
          y1: "160",
          x2: "212.4",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OHn)
      ])) : g("", !0)
    ], 16, fHn));
  }
}), KHn = ["width", "height", "fill", "transform"], XHn = { key: 0 }, JHn = ["stroke"], QHn = ["stroke"], YHn = ["stroke"], oAn = ["stroke"], eAn = { key: 1 }, tAn = ["stroke"], nAn = ["stroke"], sAn = ["stroke"], rAn = ["stroke"], iAn = { key: 2 }, lAn = /* @__PURE__ */ e("path", { d: "M216,152H168V104h48a8,8,0,0,0,0-16H168V40a8,8,0,0,0-16,0V88H104V40a8,8,0,0,0-16,0V88H40a8,8,0,0,0,0,16H88v48H40a8,8,0,0,0,0,16H88v48a8,8,0,0,0,16,0V168h48v48a8,8,0,0,0,16,0V168h48a8,8,0,0,0,0-16Zm-112,0V104h48v48Z" }, null, -1), dAn = [
  lAn
], kAn = { key: 3 }, cAn = ["stroke"], hAn = ["stroke"], uAn = ["stroke"], aAn = ["stroke"], _An = { key: 4 }, pAn = ["stroke"], yAn = ["stroke"], $An = ["stroke"], wAn = ["stroke"], fAn = { key: 5 }, gAn = ["stroke"], xAn = ["stroke"], jAn = ["stroke"], mAn = ["stroke"], MAn = {
  name: "PhHashStraight"
}, SK1 = /* @__PURE__ */ $({
  ...MAn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", XHn, [
        e("line", {
          x1: "40",
          y1: "96",
          x2: "216",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, JHn),
        e("line", {
          x1: "40",
          y1: "160",
          x2: "216",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, QHn),
        e("line", {
          x1: "160",
          y1: "40",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, YHn),
        e("line", {
          x1: "96",
          y1: "40",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oAn)
      ])) : o(i) === "duotone" ? (s(), r("g", eAn, [
        e("line", {
          x1: "40",
          y1: "96",
          x2: "216",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tAn),
        e("line", {
          x1: "40",
          y1: "160",
          x2: "216",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nAn),
        e("line", {
          x1: "160",
          y1: "40",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sAn),
        e("line", {
          x1: "96",
          y1: "40",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rAn)
      ])) : o(i) === "fill" ? (s(), r("g", iAn, dAn)) : o(i) === "light" ? (s(), r("g", kAn, [
        e("line", {
          x1: "40",
          y1: "96",
          x2: "216",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cAn),
        e("line", {
          x1: "40",
          y1: "160",
          x2: "216",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hAn),
        e("line", {
          x1: "160",
          y1: "40",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uAn),
        e("line", {
          x1: "96",
          y1: "40",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aAn)
      ])) : o(i) === "thin" ? (s(), r("g", _An, [
        e("line", {
          x1: "40",
          y1: "96",
          x2: "216",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pAn),
        e("line", {
          x1: "40",
          y1: "160",
          x2: "216",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yAn),
        e("line", {
          x1: "160",
          y1: "40",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $An),
        e("line", {
          x1: "96",
          y1: "40",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wAn)
      ])) : o(i) === "regular" ? (s(), r("g", fAn, [
        e("line", {
          x1: "40",
          y1: "96",
          x2: "216",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gAn),
        e("line", {
          x1: "40",
          y1: "160",
          x2: "216",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xAn),
        e("line", {
          x1: "160",
          y1: "40",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jAn),
        e("line", {
          x1: "96",
          y1: "40",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mAn)
      ])) : g("", !0)
    ], 16, KHn));
  }
}), vAn = ["width", "height", "fill", "transform"], SAn = { key: 0 }, HAn = ["stroke"], AAn = ["stroke"], VAn = ["stroke"], zAn = ["stroke"], ZAn = { key: 1 }, CAn = /* @__PURE__ */ e("path", {
  d: "M88,200a72,72,0,0,1-72-72.5C16.3,87.8,49.2,56,88.9,56H128a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8Z",
  opacity: "0.2"
}, null, -1), bAn = ["stroke"], LAn = ["stroke"], BAn = ["stroke"], PAn = ["stroke"], WAn = ["stroke"], NAn = { key: 2 }, FAn = /* @__PURE__ */ e("path", { d: "M160,80a8,8,0,0,1,8-8h72a8,8,0,0,1,0,16H168A8,8,0,0,1,160,80Zm80,88H168a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0-64H168a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0,32H168a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16ZM128,48H88.9C44.6,48,8.3,83.6,8,127.4A79.9,79.9,0,0,0,88,208h40a16,16,0,0,0,16-16V64A16,16,0,0,0,128,48Z" }, null, -1), TAn = [
  FAn
], DAn = { key: 3 }, RAn = ["stroke"], UAn = ["stroke"], qAn = ["stroke"], GAn = ["stroke"], EAn = ["stroke"], OAn = { key: 4 }, IAn = ["stroke"], KAn = ["stroke"], XAn = ["stroke"], JAn = ["stroke"], QAn = ["stroke"], YAn = { key: 5 }, oVn = ["stroke"], eVn = ["stroke"], tVn = ["stroke"], nVn = ["stroke"], sVn = ["stroke"], rVn = {
  name: "PhHeadlights"
}, HK1 = /* @__PURE__ */ $({
  ...rVn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", SAn, [
        e("line", {
          x1: "176",
          y1: "80",
          x2: "240",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HAn),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "240",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, AAn),
        e("line", {
          x1: "176",
          y1: "128",
          x2: "240",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VAn),
        e("path", {
          d: "M88,200a72,72,0,0,1-72-72.5C16.3,87.8,49.2,56,88.9,56H128a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zAn)
      ])) : o(i) === "duotone" ? (s(), r("g", ZAn, [
        CAn,
        e("line", {
          x1: "168",
          y1: "80",
          x2: "240",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bAn),
        e("line", {
          x1: "168",
          y1: "176",
          x2: "240",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LAn),
        e("line", {
          x1: "168",
          y1: "112",
          x2: "240",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BAn),
        e("line", {
          x1: "168",
          y1: "144",
          x2: "240",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PAn),
        e("path", {
          d: "M88,200a72,72,0,0,1-72-72.5C16.3,87.8,49.2,56,88.9,56H128a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WAn)
      ])) : o(i) === "fill" ? (s(), r("g", NAn, TAn)) : o(i) === "light" ? (s(), r("g", DAn, [
        e("line", {
          x1: "168",
          y1: "80",
          x2: "240",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RAn),
        e("line", {
          x1: "168",
          y1: "176",
          x2: "240",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UAn),
        e("line", {
          x1: "168",
          y1: "112",
          x2: "240",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qAn),
        e("line", {
          x1: "168",
          y1: "144",
          x2: "240",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GAn),
        e("path", {
          d: "M88,200a72,72,0,0,1-72-72.5C16.3,87.8,49.2,56,88.9,56H128a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, EAn)
      ])) : o(i) === "thin" ? (s(), r("g", OAn, [
        e("line", {
          x1: "168",
          y1: "80",
          x2: "240",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, IAn),
        e("line", {
          x1: "168",
          y1: "176",
          x2: "240",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KAn),
        e("line", {
          x1: "168",
          y1: "112",
          x2: "240",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XAn),
        e("line", {
          x1: "168",
          y1: "144",
          x2: "240",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, JAn),
        e("path", {
          d: "M88,200a72,72,0,0,1-72-72.5C16.3,87.8,49.2,56,88.9,56H128a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QAn)
      ])) : o(i) === "regular" ? (s(), r("g", YAn, [
        e("line", {
          x1: "168",
          y1: "80",
          x2: "240",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oVn),
        e("line", {
          x1: "168",
          y1: "176",
          x2: "240",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eVn),
        e("line", {
          x1: "168",
          y1: "112",
          x2: "240",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tVn),
        e("line", {
          x1: "168",
          y1: "144",
          x2: "240",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nVn),
        e("path", {
          d: "M88,200a72,72,0,0,1-72-72.5C16.3,87.8,49.2,56,88.9,56H128a8,8,0,0,1,8,8V192a8,8,0,0,1-8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sVn)
      ])) : g("", !0)
    ], 16, vAn));
  }
}), iVn = ["width", "height", "fill", "transform"], lVn = { key: 0 }, dVn = ["stroke"], kVn = { key: 1 }, cVn = /* @__PURE__ */ e("path", {
  d: "M32,136v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V152a16,16,0,0,0-16-16Z",
  opacity: "0.2"
}, null, -1), hVn = /* @__PURE__ */ e("path", {
  d: "M225.5,136h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16Z",
  opacity: "0.2"
}, null, -1), uVn = ["stroke"], aVn = { key: 2 }, _Vn = /* @__PURE__ */ e("path", { d: "M202.7,62.2A103.1,103.1,0,0,0,129.5,32h-.8A104,104,0,0,0,24,136v56a24.1,24.1,0,0,0,24,24H64a24.1,24.1,0,0,0,24-24V152a24.1,24.1,0,0,0-24-24H40.4a87.8,87.8,0,0,1,88.3-80h.1a88,88,0,0,1,88.3,80H193.5a24,24,0,0,0-24,24v40a24,24,0,0,0,24,24h16a24.1,24.1,0,0,0,24-24V136A103.5,103.5,0,0,0,202.7,62.2Z" }, null, -1), pVn = [
  _Vn
], yVn = { key: 3 }, $Vn = ["stroke"], wVn = { key: 4 }, fVn = ["stroke"], gVn = { key: 5 }, xVn = ["stroke"], jVn = {
  name: "PhHeadphones"
}, AK1 = /* @__PURE__ */ $({
  ...jVn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", lVn, [
        e("path", {
          d: "M225.5,136h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V136a96,96,0,0,0-96.8-96A96,96,0,0,0,32,136v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V152a16,16,0,0,0-16-16H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dVn)
      ])) : o(i) === "duotone" ? (s(), r("g", kVn, [
        cVn,
        hVn,
        e("path", {
          d: "M225.5,136h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V136a96,96,0,0,0-96.8-96A96,96,0,0,0,32,136v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V152a16,16,0,0,0-16-16H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uVn)
      ])) : o(i) === "fill" ? (s(), r("g", aVn, pVn)) : o(i) === "light" ? (s(), r("g", yVn, [
        e("path", {
          d: "M225.5,136h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V136a96,96,0,0,0-96.8-96A96,96,0,0,0,32,136v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V152a16,16,0,0,0-16-16H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $Vn)
      ])) : o(i) === "thin" ? (s(), r("g", wVn, [
        e("path", {
          d: "M225.5,136h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V136a96,96,0,0,0-96.8-96A96,96,0,0,0,32,136v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V152a16,16,0,0,0-16-16H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fVn)
      ])) : o(i) === "regular" ? (s(), r("g", gVn, [
        e("path", {
          d: "M225.5,136h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V136a96,96,0,0,0-96.8-96A96,96,0,0,0,32,136v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V152a16,16,0,0,0-16-16H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xVn)
      ])) : g("", !0)
    ], 16, iVn));
  }
}), mVn = ["width", "height", "fill", "transform"], MVn = { key: 0 }, vVn = ["stroke"], SVn = ["stroke"], HVn = { key: 1 }, AVn = /* @__PURE__ */ e("path", {
  d: "M32,128v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16Z",
  opacity: "0.2"
}, null, -1), VVn = /* @__PURE__ */ e("path", {
  d: "M225.5,128h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16Z",
  opacity: "0.2"
}, null, -1), zVn = ["stroke"], ZVn = ["stroke"], CVn = { key: 2 }, bVn = /* @__PURE__ */ e("path", { d: "M233.5,128v80a40.1,40.1,0,0,1-40,40H136a8,8,0,0,1,0-16h57.5a24.1,24.1,0,0,0,24-24v-1.4a23.6,23.6,0,0,1-8,1.4h-16a24,24,0,0,1-24-24V144a24,24,0,0,1,24-24h23.6a88,88,0,0,0-88.3-80h-.1a87.8,87.8,0,0,0-88.3,80H64a24.1,24.1,0,0,1,24,24v40a24.1,24.1,0,0,1-24,24H48a24.1,24.1,0,0,1-24-24V128A104,104,0,0,1,128.7,24h.8a104.1,104.1,0,0,1,104,104Z" }, null, -1), LVn = [
  bVn
], BVn = { key: 3 }, PVn = ["stroke"], WVn = ["stroke"], NVn = { key: 4 }, FVn = ["stroke"], TVn = ["stroke"], DVn = { key: 5 }, RVn = ["stroke"], UVn = ["stroke"], qVn = {
  name: "PhHeadset"
}, VK1 = /* @__PURE__ */ $({
  ...qVn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", MVn, [
        e("path", {
          d: "M225.5,128h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V128a96,96,0,0,0-96.8-96A96,96,0,0,0,32,128v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vVn),
        e("path", {
          d: "M225.5,184v24a32,32,0,0,1-32,32H136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SVn)
      ])) : o(i) === "duotone" ? (s(), r("g", HVn, [
        AVn,
        VVn,
        e("path", {
          d: "M225.5,128h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V128a96,96,0,0,0-96.8-96A96,96,0,0,0,32,128v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zVn),
        e("path", {
          d: "M225.5,184v24a32,32,0,0,1-32,32H136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZVn)
      ])) : o(i) === "fill" ? (s(), r("g", CVn, LVn)) : o(i) === "light" ? (s(), r("g", BVn, [
        e("path", {
          d: "M225.5,128h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V128a96,96,0,0,0-96.8-96A96,96,0,0,0,32,128v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PVn),
        e("path", {
          d: "M225.5,184v24a32,32,0,0,1-32,32H136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WVn)
      ])) : o(i) === "thin" ? (s(), r("g", NVn, [
        e("path", {
          d: "M225.5,128h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V128a96,96,0,0,0-96.8-96A96,96,0,0,0,32,128v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FVn),
        e("path", {
          d: "M225.5,184v24a32,32,0,0,1-32,32H136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, TVn)
      ])) : o(i) === "regular" ? (s(), r("g", DVn, [
        e("path", {
          d: "M225.5,128h-32a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16h16a16,16,0,0,0,16-16V128a96,96,0,0,0-96.8-96A96,96,0,0,0,32,128v56a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V144a16,16,0,0,0-16-16H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RVn),
        e("path", {
          d: "M225.5,184v24a32,32,0,0,1-32,32H136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UVn)
      ])) : g("", !0)
    ], 16, mVn));
  }
}), GVn = ["width", "height", "fill", "transform"], EVn = { key: 0 }, OVn = ["stroke"], IVn = { key: 1 }, KVn = /* @__PURE__ */ e("path", {
  d: "M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z",
  opacity: "0.2"
}, null, -1), XVn = ["stroke"], JVn = { key: 2 }, QVn = /* @__PURE__ */ e("path", { d: "M176,32a60,60,0,0,0-48,24A60,60,0,0,0,20,92c0,71.9,99.9,128.6,104.1,131a7.8,7.8,0,0,0,3.9,1,7.6,7.6,0,0,0,3.9-1,314.3,314.3,0,0,0,51.5-37.6C218.3,154,236,122.6,236,92A60,60,0,0,0,176,32Z" }, null, -1), YVn = [
  QVn
], ozn = { key: 3 }, ezn = ["stroke"], tzn = { key: 4 }, nzn = ["stroke"], szn = { key: 5 }, rzn = ["stroke"], izn = {
  name: "PhHeart"
}, zK1 = /* @__PURE__ */ $({
  ...izn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", EVn, [
        e("path", {
          d: "M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OVn)
      ])) : o(i) === "duotone" ? (s(), r("g", IVn, [
        KVn,
        e("path", {
          d: "M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XVn)
      ])) : o(i) === "fill" ? (s(), r("g", JVn, YVn)) : o(i) === "light" ? (s(), r("g", ozn, [
        e("path", {
          d: "M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ezn)
      ])) : o(i) === "thin" ? (s(), r("g", tzn, [
        e("path", {
          d: "M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nzn)
      ])) : o(i) === "regular" ? (s(), r("g", szn, [
        e("path", {
          d: "M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rzn)
      ])) : g("", !0)
    ], 16, GVn));
  }
}), lzn = ["width", "height", "fill", "transform"], dzn = { key: 0 }, kzn = ["stroke"], czn = { key: 1 }, hzn = /* @__PURE__ */ e("path", {
  d: "M139.2,55.2A52,52,0,0,1,228,92c0,68-100,124-100,124S28,160,28,92a52,52,0,0,1,98.3-23.8Z",
  opacity: "0.2"
}, null, -1), uzn = ["stroke"], azn = { key: 2 }, _zn = /* @__PURE__ */ e("path", { d: "M236,92c0,30.6-17.7,62-52.6,93.4A314.3,314.3,0,0,1,131.9,223a8.1,8.1,0,0,1-7.8,0C119.8,220.6,20,163.9,20,92a60,60,0,0,1,92.3-50.6,4,4,0,0,1,.6,6.2l-18,18a8,8,0,0,0,0,11.3l34.4,34.3-15,15.1a7.9,7.9,0,0,0,0,11.3,8,8,0,0,0,5.6,2.3,8.3,8.3,0,0,0,5.7-2.3l20.7-20.7a8,8,0,0,0,0-11.3L111.9,71.2l21.7-21.6h0A59.3,59.3,0,0,1,176,32,60,60,0,0,1,236,92Z" }, null, -1), pzn = [
  _zn
], yzn = { key: 3 }, $zn = ["stroke"], wzn = { key: 4 }, fzn = ["stroke"], gzn = { key: 5 }, xzn = ["stroke"], jzn = {
  name: "PhHeartBreak"
}, ZK1 = /* @__PURE__ */ $({
  ...jzn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", dzn, [
        e("path", {
          d: "M126.3,68.2A52,52,0,0,0,28,92c0,68,100,124,100,124S228,160,228,92a52,52,0,0,0-88.8-36.8l-32,32,32,32-16,16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kzn)
      ])) : o(i) === "duotone" ? (s(), r("g", czn, [
        hzn,
        e("path", {
          d: "M126.3,68.2A52,52,0,0,0,28,92c0,68,100,124,100,124S228,160,228,92a52,52,0,0,0-88.8-36.8l-32,32,32,32-16,16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uzn)
      ])) : o(i) === "fill" ? (s(), r("g", azn, pzn)) : o(i) === "light" ? (s(), r("g", yzn, [
        e("path", {
          d: "M126.3,68.2A52,52,0,0,0,28,92c0,68,100,124,100,124S228,160,228,92a52,52,0,0,0-88.8-36.8l-32,32,32,32-16,16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $zn)
      ])) : o(i) === "thin" ? (s(), r("g", wzn, [
        e("path", {
          d: "M126.3,68.2A52,52,0,0,0,28,92c0,68,100,124,100,124S228,160,228,92a52,52,0,0,0-88.8-36.8l-32,32,32,32-16,16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fzn)
      ])) : o(i) === "regular" ? (s(), r("g", gzn, [
        e("path", {
          d: "M126.3,68.2A52,52,0,0,0,28,92c0,68,100,124,100,124S228,160,228,92a52,52,0,0,0-88.8-36.8l-32,32,32,32-16,16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xzn)
      ])) : g("", !0)
    ], 16, lzn));
  }
}), mzn = ["width", "height", "fill", "transform"], Mzn = { key: 0 }, vzn = ["stroke"], Szn = { key: 1 }, Hzn = /* @__PURE__ */ e("path", {
  d: "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
  opacity: "0.2"
}, null, -1), Azn = ["stroke"], Vzn = { key: 2 }, zzn = /* @__PURE__ */ e("path", { d: "M224.6,51.9a59.5,59.5,0,0,0-43-19.9,60.5,60.5,0,0,0-44,17.6L128,59.1l-7.5-7.4C97.2,28.3,59.2,26.3,35.9,47.4a59.9,59.9,0,0,0-2.3,87l83.1,83.1a15.9,15.9,0,0,0,22.6,0l81-81C243.7,113.2,245.6,75.2,224.6,51.9Z" }, null, -1), Zzn = [
  zzn
], Czn = { key: 3 }, bzn = ["stroke"], Lzn = { key: 4 }, Bzn = ["stroke"], Pzn = { key: 5 }, Wzn = ["stroke"], Nzn = {
  name: "PhHeartStraight"
}, CK1 = /* @__PURE__ */ $({
  ...Nzn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Mzn, [
        e("path", {
          d: "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vzn)
      ])) : o(i) === "duotone" ? (s(), r("g", Szn, [
        Hzn,
        e("path", {
          d: "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Azn)
      ])) : o(i) === "fill" ? (s(), r("g", Vzn, Zzn)) : o(i) === "light" ? (s(), r("g", Czn, [
        e("path", {
          d: "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bzn)
      ])) : o(i) === "thin" ? (s(), r("g", Lzn, [
        e("path", {
          d: "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bzn)
      ])) : o(i) === "regular" ? (s(), r("g", Pzn, [
        e("path", {
          d: "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wzn)
      ])) : g("", !0)
    ], 16, mzn));
  }
}), Fzn = ["width", "height", "fill", "transform"], Tzn = { key: 0 }, Dzn = ["stroke"], Rzn = ["stroke"], Uzn = { key: 1 }, qzn = /* @__PURE__ */ e("path", {
  d: "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
  opacity: "0.2"
}, null, -1), Gzn = ["stroke"], Ezn = ["stroke"], Ozn = ["stroke"], Izn = { key: 2 }, Kzn = /* @__PURE__ */ e("path", { d: "M239.2,95a64.3,64.3,0,0,1-18.9,41.5l-81,81a15.9,15.9,0,0,1-22.6,0L33.6,134.4a59.9,59.9,0,0,1,2.3-87A57.7,57.7,0,0,1,79,32.8a64.4,64.4,0,0,1,33.8,12.3,4,4,0,0,1,.5,6.1L94.9,69.6a8,8,0,0,0,0,11.3l34.4,34.3-15,15.1a7.9,7.9,0,0,0,0,11.3,8,8,0,0,0,5.6,2.3,8.3,8.3,0,0,0,5.7-2.3l20.7-20.7a8,8,0,0,0,0-11.3L111.9,75.2l21.7-21.6h0l4-4a59.9,59.9,0,0,1,87,2.3A57.7,57.7,0,0,1,239.2,95Z" }, null, -1), Xzn = [
  Kzn
], Jzn = { key: 3 }, Qzn = ["stroke"], Yzn = ["stroke"], oZn = { key: 4 }, eZn = ["stroke"], tZn = ["stroke"], nZn = { key: 5 }, sZn = ["stroke"], rZn = ["stroke"], iZn = {
  name: "PhHeartStraightBreak"
}, bK1 = /* @__PURE__ */ $({
  ...iZn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Tzn, [
        e("path", {
          d: "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Dzn),
        e("polyline", {
          points: "128 70.5 112 88 144 120 128 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rzn)
      ])) : o(i) === "duotone" ? (s(), r("g", Uzn, [
        qzn,
        e("path", {
          d: "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gzn),
        e("path", {
          d: "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ezn),
        e("polyline", {
          points: "128 70.5 112 88 144 120 128 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ozn)
      ])) : o(i) === "fill" ? (s(), r("g", Izn, Xzn)) : o(i) === "light" ? (s(), r("g", Jzn, [
        e("path", {
          d: "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qzn),
        e("polyline", {
          points: "128 70.5 112 88 144 120 128 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Yzn)
      ])) : o(i) === "thin" ? (s(), r("g", oZn, [
        e("path", {
          d: "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eZn),
        e("polyline", {
          points: "128 70.5 112 88 144 120 128 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tZn)
      ])) : o(i) === "regular" ? (s(), r("g", nZn, [
        e("path", {
          d: "M133.7,211.9l81-81c19.9-20,22.8-52.7,4-73.6a52,52,0,0,0-75.5-2.1L128,70.5,114.9,57.3c-20-19.9-52.7-22.8-73.6-4a52,52,0,0,0-2.1,75.5l83.1,83.1A8.1,8.1,0,0,0,133.7,211.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sZn),
        e("polyline", {
          points: "128 70.5 112 88 144 120 128 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rZn)
      ])) : g("", !0)
    ], 16, Fzn));
  }
}), lZn = ["width", "height", "fill", "transform"], dZn = { key: 0 }, kZn = ["stroke"], cZn = ["stroke"], hZn = { key: 1 }, uZn = /* @__PURE__ */ e("path", {
  d: "M128,216S28,160,28,92A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92C228,160,128,216,128,216Z",
  opacity: "0.2"
}, null, -1), aZn = ["stroke"], _Zn = ["stroke"], pZn = { key: 2 }, yZn = /* @__PURE__ */ e("path", { d: "M236,92c0,30.6-17.7,62-52.6,93.4A314.3,314.3,0,0,1,131.9,223a8.1,8.1,0,0,1-7.8,0c-3.2-1.8-60.4-34.3-88.6-80.9a4,4,0,0,1,3.4-6.1H72a7.9,7.9,0,0,0,6.7-3.6l9.3-14,25.3,38a8.1,8.1,0,0,0,9.2,3.2,8.8,8.8,0,0,0,4.3-3.3L140.3,136h19.4a8.2,8.2,0,0,0,8.3-7.5,8,8,0,0,0-8-8.5H136a7.9,7.9,0,0,0-6.7,3.6l-9.3,14-25.3-38a8.1,8.1,0,0,0-9.2-3.2,8.8,8.8,0,0,0-4.3,3.3L67.7,120H27.8a4,4,0,0,1-3.8-2.8A86.2,86.2,0,0,1,20,92,60,60,0,0,1,128,56,60,60,0,0,1,236,92Z" }, null, -1), $Zn = [
  yZn
], wZn = { key: 3 }, fZn = ["stroke"], gZn = ["stroke"], xZn = { key: 4 }, jZn = ["stroke"], mZn = ["stroke"], MZn = { key: 5 }, vZn = ["stroke"], SZn = ["stroke"], HZn = {
  name: "PhHeartbeat"
}, LK1 = /* @__PURE__ */ $({
  ...HZn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", dZn, [
        e("polyline", {
          points: "32 128 72 128 88 104 120 152 136 128 160 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kZn),
        e("path", {
          d: "M28.1,88.2A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92c0,68-100,124-100,124s-33.7-18.9-62-48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cZn)
      ])) : o(i) === "duotone" ? (s(), r("g", hZn, [
        uZn,
        e("polyline", {
          points: "32 128 72 128 88 104 120 152 136 128 160 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aZn),
        e("path", {
          d: "M28.1,96c-.1-1.3-.1-2.7-.1-4A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92c0,68-100,124-100,124s-39.9-22.4-69.3-56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Zn)
      ])) : o(i) === "fill" ? (s(), r("g", pZn, $Zn)) : o(i) === "light" ? (s(), r("g", wZn, [
        e("polyline", {
          points: "32 128 72 128 88 104 120 152 136 128 160 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fZn),
        e("path", {
          d: "M28.1,96c-.1-1.3-.1-2.7-.1-4A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92c0,68-100,124-100,124s-39.9-22.4-69.3-56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gZn)
      ])) : o(i) === "thin" ? (s(), r("g", xZn, [
        e("polyline", {
          points: "32 128 72 128 88 104 120 152 136 128 160 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jZn),
        e("path", {
          d: "M28.1,96c-.1-1.3-.1-2.7-.1-4A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92c0,68-100,124-100,124s-39.9-22.4-69.3-56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mZn)
      ])) : o(i) === "regular" ? (s(), r("g", MZn, [
        e("polyline", {
          points: "32 128 72 128 88 104 120 152 136 128 160 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vZn),
        e("path", {
          d: "M28.1,96c-.1-1.3-.1-2.7-.1-4A52,52,0,0,1,128,72h0A52,52,0,0,1,228,92c0,68-100,124-100,124s-39.9-22.4-69.3-56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SZn)
      ])) : g("", !0)
    ], 16, lZn));
  }
}), AZn = ["width", "height", "fill", "transform"], VZn = { key: 0 }, zZn = ["stroke"], ZZn = { key: 1 }, CZn = /* @__PURE__ */ e("path", {
  d: "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
  opacity: "0.2"
}, null, -1), bZn = ["stroke"], LZn = { key: 2 }, BZn = /* @__PURE__ */ e("path", { d: "M219.9,66.7l-84-47.4a15.9,15.9,0,0,0-15.8,0l-84,47.4a16.2,16.2,0,0,0-8.1,14v94.6a16.2,16.2,0,0,0,8.1,14l84,47.4a15.9,15.9,0,0,0,15.8,0l84-47.4a16.2,16.2,0,0,0,8.1-14V80.7A16.2,16.2,0,0,0,219.9,66.7Z" }, null, -1), PZn = [
  BZn
], WZn = { key: 3 }, NZn = ["stroke"], FZn = { key: 4 }, TZn = ["stroke"], DZn = { key: 5 }, RZn = ["stroke"], UZn = {
  name: "PhHexagon"
}, BK1 = /* @__PURE__ */ $({
  ...UZn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", VZn, [
        e("path", {
          d: "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zZn)
      ])) : o(i) === "duotone" ? (s(), r("g", ZZn, [
        CZn,
        e("path", {
          d: "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bZn)
      ])) : o(i) === "fill" ? (s(), r("g", LZn, PZn)) : o(i) === "light" ? (s(), r("g", WZn, [
        e("path", {
          d: "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, NZn)
      ])) : o(i) === "thin" ? (s(), r("g", FZn, [
        e("path", {
          d: "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, TZn)
      ])) : o(i) === "regular" ? (s(), r("g", DZn, [
        e("path", {
          d: "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RZn)
      ])) : g("", !0)
    ], 16, AZn));
  }
}), qZn = ["width", "height", "fill", "transform"], GZn = { key: 0 }, EZn = ["stroke"], OZn = ["stroke"], IZn = ["stroke"], KZn = { key: 1 }, XZn = /* @__PURE__ */ e("path", {
  d: "M195.9,60.1A96,96,0,1,0,88,215.3V152a8,8,0,0,1,8-8h8V96l48-24v72h8a8,8,0,0,1,8,8v63.3A96,96,0,0,0,195.9,60.1Z",
  opacity: "0.2"
}, null, -1), JZn = ["stroke"], QZn = ["stroke"], YZn = ["stroke"], oCn = { key: 2 }, eCn = /* @__PURE__ */ e("path", { d: "M201.5,54.5a103.8,103.8,0,0,0-147,0,103.8,103.8,0,0,0,0,147,103.8,103.8,0,0,0,147,0,103.8,103.8,0,0,0,0-147ZM96,210V152h64v58a88.3,88.3,0,0,1-64,0Zm94.2-19.8A86.8,86.8,0,0,1,176,201.8V152a16,16,0,0,0-16-16V72a7.9,7.9,0,0,0-3.8-6.8,8,8,0,0,0-7.8-.4l-48,24A8.2,8.2,0,0,0,96,96v40a16,16,0,0,0-16,16v49.8A88.7,88.7,0,0,1,40,128a88,88,0,1,1,150.2,62.2Z" }, null, -1), tCn = [
  eCn
], nCn = { key: 3 }, sCn = ["stroke"], rCn = ["stroke"], iCn = ["stroke"], lCn = { key: 4 }, dCn = ["stroke"], kCn = ["stroke"], cCn = ["stroke"], hCn = { key: 5 }, uCn = ["stroke"], aCn = ["stroke"], _Cn = ["stroke"], pCn = {
  name: "PhHighlighterCircle"
}, PK1 = /* @__PURE__ */ $({
  ...pCn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", GZn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, EZn),
        e("polyline", {
          points: "104 148 104 104 152 80 152 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OZn),
        e("path", {
          d: "M168,215.3V156a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v59.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IZn)
      ])) : o(i) === "duotone" ? (s(), r("g", KZn, [
        XZn,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JZn),
        e("polyline", {
          points: "104 144 104 96 152 72 152 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QZn),
        e("path", {
          d: "M168,215.3V152a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v63.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YZn)
      ])) : o(i) === "fill" ? (s(), r("g", oCn, tCn)) : o(i) === "light" ? (s(), r("g", nCn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sCn),
        e("polyline", {
          points: "104 144 104 96 152 72 152 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rCn),
        e("path", {
          d: "M168,215.3V152a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v63.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iCn)
      ])) : o(i) === "thin" ? (s(), r("g", lCn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dCn),
        e("polyline", {
          points: "104 144 104 96 152 72 152 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kCn),
        e("path", {
          d: "M168,215.3V152a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v63.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cCn)
      ])) : o(i) === "regular" ? (s(), r("g", hCn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uCn),
        e("polyline", {
          points: "104 144 104 96 152 72 152 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aCn),
        e("path", {
          d: "M168,215.3V152a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v63.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Cn)
      ])) : g("", !0)
    ], 16, qZn));
  }
}), yCn = ["width", "height", "fill", "transform"], $Cn = { key: 0 }, wCn = ["stroke"], fCn = ["stroke"], gCn = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "104",
  r: "16"
}, null, -1), xCn = { key: 1 }, jCn = /* @__PURE__ */ e("path", {
  d: "M92.8,217.3a95.2,95.2,0,0,0,37.1,6.7c51.5-1,93.4-43.1,94.1-94.6A96,96,0,0,0,128,32h-8V64L16,128l13.8,19.1a23.9,23.9,0,0,0,23.5,9.6c17.5-2.9,48.1-4.7,74.7,11.3h0Z",
  opacity: "0.2"
}, null, -1), mCn = ["stroke"], MCn = ["stroke"], vCn = /* @__PURE__ */ e("circle", {
  cx: "124",
  cy: "100",
  r: "12"
}, null, -1), SCn = { key: 2 }, HCn = /* @__PURE__ */ e("path", { d: "M202.1,55A103.2,103.2,0,0,0,128,24h-8a8,8,0,0,0-8,8V59.5L11.8,121.2a8,8,0,0,0-3.6,5.2,7.8,7.8,0,0,0,1.3,6.3l13.8,19.1a31.6,31.6,0,0,0,31.3,12.8c13.7-2.3,38.6-4.2,61.6,6.2L90,207.4a91.1,91.1,0,0,1-20.7-13.8,8,8,0,0,0-11.3.6,8,8,0,0,0,.7,11.3A103.5,103.5,0,0,0,128,232h2.1a104,104,0,0,0,72-177ZM124,112a12,12,0,1,1,12-12A12,12,0,0,1,124,112Z" }, null, -1), ACn = [
  HCn
], VCn = { key: 3 }, zCn = ["stroke"], ZCn = ["stroke"], CCn = /* @__PURE__ */ e("circle", {
  cx: "124",
  cy: "100",
  r: "10"
}, null, -1), bCn = { key: 4 }, LCn = ["stroke"], BCn = ["stroke"], PCn = /* @__PURE__ */ e("circle", {
  cx: "124",
  cy: "100",
  r: "8"
}, null, -1), WCn = { key: 5 }, NCn = ["stroke"], FCn = ["stroke"], TCn = /* @__PURE__ */ e("circle", {
  cx: "124",
  cy: "100",
  r: "12"
}, null, -1), DCn = {
  name: "PhHorse"
}, WK1 = /* @__PURE__ */ $({
  ...DCn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $Cn, [
        e("path", {
          d: "M176,120a48,48,0,0,1-48,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wCn),
        e("path", {
          d: "M64,199.6A95.6,95.6,0,0,0,129.9,224c51.5-1,93.4-43.1,94.1-94.6A96,96,0,0,0,128,32h-8V64L16,128l13.8,19.1a23.9,23.9,0,0,0,23.5,9.6c17.5-2.9,48.1-4.7,74.7,11.3h0L92.8,217.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fCn),
        gCn
      ])) : o(i) === "duotone" ? (s(), r("g", xCn, [
        jCn,
        e("path", {
          d: "M176,120a48,48,0,0,1-48,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mCn),
        e("path", {
          d: "M64,199.6A95.6,95.6,0,0,0,129.9,224c51.5-1,93.4-43.1,94.1-94.6A96,96,0,0,0,128,32h-8V64L16,128l13.8,19.1a23.9,23.9,0,0,0,23.5,9.6c17.5-2.9,48.1-4.7,74.7,11.3h0L92.8,217.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MCn),
        vCn
      ])) : o(i) === "fill" ? (s(), r("g", SCn, ACn)) : o(i) === "light" ? (s(), r("g", VCn, [
        e("path", {
          d: "M176,120a48,48,0,0,1-48,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zCn),
        e("path", {
          d: "M64,199.6A95.6,95.6,0,0,0,129.9,224c51.5-1,93.4-43.1,94.1-94.6A96,96,0,0,0,128,32h-8V64L16,128l13.8,19.1a23.9,23.9,0,0,0,23.5,9.6c17.5-2.9,48.1-4.7,74.7,11.3h0L92.8,217.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZCn),
        CCn
      ])) : o(i) === "thin" ? (s(), r("g", bCn, [
        e("path", {
          d: "M176,120a48,48,0,0,1-48,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LCn),
        e("path", {
          d: "M64,199.6A95.6,95.6,0,0,0,129.9,224c51.5-1,93.4-43.1,94.1-94.6A96,96,0,0,0,128,32h-8V64L16,128l13.8,19.1a23.9,23.9,0,0,0,23.5,9.6c17.5-2.9,48.1-4.7,74.7,11.3h0L92.8,217.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, BCn),
        PCn
      ])) : o(i) === "regular" ? (s(), r("g", WCn, [
        e("path", {
          d: "M176,120a48,48,0,0,1-48,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NCn),
        e("path", {
          d: "M64,199.6A95.6,95.6,0,0,0,129.9,224c51.5-1,93.4-43.1,94.1-94.6A96,96,0,0,0,128,32h-8V64L16,128l13.8,19.1a23.9,23.9,0,0,0,23.5,9.6c17.5-2.9,48.1-4.7,74.7,11.3h0L92.8,217.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FCn),
        TCn
      ])) : g("", !0)
    ], 16, yCn));
  }
}), RCn = ["width", "height", "fill", "transform"], UCn = { key: 0 }, qCn = ["stroke"], GCn = ["stroke"], ECn = { key: 1 }, OCn = /* @__PURE__ */ e("path", {
  d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
  opacity: "0.2"
}, null, -1), ICn = /* @__PURE__ */ e("path", {
  d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
  opacity: "0.2"
}, null, -1), KCn = ["stroke"], XCn = ["stroke"], JCn = { key: 2 }, QCn = /* @__PURE__ */ e("path", { d: "M200,75.6V40a16,16,0,0,0-16-16H72A16,16,0,0,0,56,40V76a16.1,16.1,0,0,0,6.4,12.8L114.7,128,62.4,167.2A16.1,16.1,0,0,0,56,180v36a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V180.4a16.1,16.1,0,0,0-6.4-12.8L141.3,128l52.3-39.6A16.1,16.1,0,0,0,200,75.6Z" }, null, -1), YCn = [
  QCn
], obn = { key: 3 }, ebn = ["stroke"], tbn = ["stroke"], nbn = { key: 4 }, sbn = ["stroke"], rbn = ["stroke"], ibn = { key: 5 }, lbn = ["stroke"], dbn = ["stroke"], kbn = {
  name: "PhHourglass"
}, NK1 = /* @__PURE__ */ $({
  ...kbn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", UCn, [
        e("path", {
          d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qCn),
        e("path", {
          d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GCn)
      ])) : o(i) === "duotone" ? (s(), r("g", ECn, [
        OCn,
        ICn,
        e("path", {
          d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KCn),
        e("path", {
          d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XCn)
      ])) : o(i) === "fill" ? (s(), r("g", JCn, YCn)) : o(i) === "light" ? (s(), r("g", obn, [
        e("path", {
          d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ebn),
        e("path", {
          d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tbn)
      ])) : o(i) === "thin" ? (s(), r("g", nbn, [
        e("path", {
          d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sbn),
        e("path", {
          d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rbn)
      ])) : o(i) === "regular" ? (s(), r("g", ibn, [
        e("path", {
          d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lbn),
        e("path", {
          d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dbn)
      ])) : g("", !0)
    ], 16, RCn));
  }
}), cbn = ["width", "height", "fill", "transform"], hbn = { key: 0 }, ubn = ["stroke"], abn = ["stroke"], _bn = ["stroke"], pbn = { key: 1 }, ybn = /* @__PURE__ */ e("path", {
  d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V64H192V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
  opacity: "0.2"
}, null, -1), $bn = ["stroke"], wbn = ["stroke"], fbn = ["stroke"], gbn = { key: 2 }, xbn = /* @__PURE__ */ e("path", { d: "M200,75.6V40a16,16,0,0,0-16-16H72A16,16,0,0,0,56,40V76a16.1,16.1,0,0,0,6.4,12.8L114.7,128,62.4,167.2A16.1,16.1,0,0,0,56,180v36a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V180.4a16.1,16.1,0,0,0-6.4-12.8L141.3,128l52.3-39.6A16.1,16.1,0,0,0,200,75.6ZM184,40V64H72V40Zm0,176H72V180l56-42,56,42.4Z" }, null, -1), jbn = [
  xbn
], mbn = { key: 3 }, Mbn = ["stroke"], vbn = ["stroke"], Sbn = ["stroke"], Hbn = { key: 4 }, Abn = ["stroke"], Vbn = ["stroke"], zbn = ["stroke"], Zbn = { key: 5 }, Cbn = ["stroke"], bbn = ["stroke"], Lbn = ["stroke"], Bbn = {
  name: "PhHourglassHigh"
}, FK1 = /* @__PURE__ */ $({
  ...Bbn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", hbn, [
        e("path", {
          d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ubn),
        e("path", {
          d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, abn),
        e("line", {
          x1: "64",
          y1: "72",
          x2: "192",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _bn)
      ])) : o(i) === "duotone" ? (s(), r("g", pbn, [
        ybn,
        e("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $bn),
        e("path", {
          d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wbn),
        e("path", {
          d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fbn)
      ])) : o(i) === "fill" ? (s(), r("g", gbn, jbn)) : o(i) === "light" ? (s(), r("g", mbn, [
        e("path", {
          d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mbn),
        e("path", {
          d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vbn),
        e("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Sbn)
      ])) : o(i) === "thin" ? (s(), r("g", Hbn, [
        e("path", {
          d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Abn),
        e("path", {
          d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vbn),
        e("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zbn)
      ])) : o(i) === "regular" ? (s(), r("g", Zbn, [
        e("path", {
          d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cbn),
        e("path", {
          d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bbn),
        e("line", {
          x1: "64",
          y1: "64",
          x2: "192",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lbn)
      ])) : g("", !0)
    ], 16, cbn));
  }
}), Pbn = ["width", "height", "fill", "transform"], Wbn = { key: 0 }, Nbn = ["stroke"], Fbn = ["stroke"], Tbn = ["stroke"], Dbn = { key: 1 }, Rbn = /* @__PURE__ */ e("path", {
  d: "M64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4Z",
  opacity: "0.2"
}, null, -1), Ubn = ["stroke"], qbn = ["stroke"], Gbn = ["stroke"], Ebn = { key: 2 }, Obn = /* @__PURE__ */ e("path", { d: "M200,75.6V40a16,16,0,0,0-16-16H72A16,16,0,0,0,56,40V76a16.1,16.1,0,0,0,6.4,12.8L114.7,128,62.4,167.2a15.6,15.6,0,0,0-6.3,11.9,2.8,2.8,0,0,0-.1.9v36a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V180.4a2.8,2.8,0,0,0-.1-.9,15.6,15.6,0,0,0-6.3-11.9L141.3,128l52.3-39.6A16.1,16.1,0,0,0,200,75.6ZM82.6,172.1,128,138l45.3,34.3ZM184,75.6,128,118,72,76V40H184Z" }, null, -1), Ibn = [
  Obn
], Kbn = { key: 3 }, Xbn = ["stroke"], Jbn = ["stroke"], Qbn = ["stroke"], Ybn = { key: 4 }, oLn = ["stroke"], eLn = ["stroke"], tLn = ["stroke"], nLn = { key: 5 }, sLn = ["stroke"], rLn = ["stroke"], iLn = ["stroke"], lLn = {
  name: "PhHourglassLow"
}, TK1 = /* @__PURE__ */ $({
  ...lLn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Wbn, [
        e("path", {
          d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nbn),
        e("path", {
          d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fbn),
        e("line", {
          x1: "192",
          y1: "180.4",
          x2: "64",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Tbn)
      ])) : o(i) === "duotone" ? (s(), r("g", Dbn, [
        Rbn,
        e("path", {
          d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ubn),
        e("path", {
          d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qbn),
        e("line", {
          x1: "192",
          y1: "180.4",
          x2: "64",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gbn)
      ])) : o(i) === "fill" ? (s(), r("g", Ebn, Ibn)) : o(i) === "light" ? (s(), r("g", Kbn, [
        e("path", {
          d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xbn),
        e("path", {
          d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jbn),
        e("line", {
          x1: "192",
          y1: "180.4",
          x2: "64",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qbn)
      ])) : o(i) === "thin" ? (s(), r("g", Ybn, [
        e("path", {
          d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oLn),
        e("path", {
          d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eLn),
        e("line", {
          x1: "192",
          y1: "180.4",
          x2: "64",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tLn)
      ])) : o(i) === "regular" ? (s(), r("g", nLn, [
        e("path", {
          d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sLn),
        e("path", {
          d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rLn),
        e("line", {
          x1: "192",
          y1: "180.4",
          x2: "64",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iLn)
      ])) : g("", !0)
    ], 16, Pbn));
  }
}), dLn = ["width", "height", "fill", "transform"], kLn = { key: 0 }, cLn = ["stroke"], hLn = ["stroke"], uLn = ["stroke"], aLn = ["stroke"], _Ln = { key: 1 }, pLn = /* @__PURE__ */ e("polygon", {
  points: "128 128 180.9 88 74.7 88 128 128",
  opacity: "0.2"
}, null, -1), yLn = ["stroke"], $Ln = ["stroke"], wLn = ["stroke"], fLn = ["stroke"], gLn = { key: 2 }, xLn = /* @__PURE__ */ e("path", { d: "M193.6,88.4A16.1,16.1,0,0,0,200,75.6V40a16,16,0,0,0-16-16H72A16,16,0,0,0,56,40V76a16.1,16.1,0,0,0,6.4,12.8l18.1,13.6h0L114.7,128,62.4,167.2A16.1,16.1,0,0,0,56,180v36a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V180.4a16.1,16.1,0,0,0-6.4-12.8L141.3,128,164,110.8ZM72,40H184V75.6L178.2,80H77.3L72,76ZM184,180.4V216H72V180l48-36v24a8,8,0,0,0,16,0V144.1Z" }, null, -1), jLn = [
  xLn
], mLn = { key: 3 }, MLn = ["stroke"], vLn = ["stroke"], SLn = ["stroke"], HLn = ["stroke"], ALn = { key: 4 }, VLn = ["stroke"], zLn = ["stroke"], ZLn = ["stroke"], CLn = ["stroke"], bLn = { key: 5 }, LLn = ["stroke"], BLn = ["stroke"], PLn = ["stroke"], WLn = ["stroke"], NLn = {
  name: "PhHourglassMedium"
}, DK1 = /* @__PURE__ */ $({
  ...NLn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", kLn, [
        e("line", {
          x1: "69.3",
          y1: "84",
          x2: "186.2",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cLn),
        e("path", {
          d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hLn),
        e("path", {
          d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uLn),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aLn)
      ])) : o(i) === "duotone" ? (s(), r("g", _Ln, [
        pLn,
        e("path", {
          d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yLn),
        e("path", {
          d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Ln),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wLn),
        e("line", {
          x1: "74.7",
          y1: "88",
          x2: "180.9",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fLn)
      ])) : o(i) === "fill" ? (s(), r("g", gLn, jLn)) : o(i) === "light" ? (s(), r("g", mLn, [
        e("line", {
          x1: "74.7",
          y1: "88",
          x2: "180.9",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, MLn),
        e("path", {
          d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vLn),
        e("path", {
          d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, SLn),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HLn)
      ])) : o(i) === "thin" ? (s(), r("g", ALn, [
        e("line", {
          x1: "74.7",
          y1: "88",
          x2: "180.9",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VLn),
        e("path", {
          d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zLn),
        e("path", {
          d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZLn),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CLn)
      ])) : o(i) === "regular" ? (s(), r("g", bLn, [
        e("path", {
          d: "M128,128,67.2,82.4A8.1,8.1,0,0,1,64,76V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8V75.6a8.1,8.1,0,0,1-3.2,6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LLn),
        e("path", {
          d: "M128,128,67.2,173.6A8.1,8.1,0,0,0,64,180v36a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V180.4a8.1,8.1,0,0,0-3.2-6.4L128,128h0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BLn),
        e("line", {
          x1: "74.7",
          y1: "88",
          x2: "180.9",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PLn),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WLn)
      ])) : g("", !0)
    ], 16, dLn));
  }
}), FLn = ["width", "height", "fill", "transform"], TLn = { key: 0 }, DLn = ["stroke"], RLn = ["stroke"], ULn = { key: 1 }, qLn = /* @__PURE__ */ e("path", {
  d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L53.7,202.3A8,8,0,0,0,59.3,216H196.7a8,8,0,0,0,5.6-13.7L53.7,53.7A8,8,0,0,1,59.3,40Z",
  opacity: "0.2"
}, null, -1), GLn = ["stroke"], ELn = ["stroke"], OLn = { key: 2 }, ILn = /* @__PURE__ */ e("path", { d: "M139.3,128,208,59.3A16,16,0,0,0,196.7,32H59.3A16,16,0,0,0,48,59.3L116.7,128,48,196.7A16,16,0,0,0,59.3,224H196.7A16,16,0,0,0,208,196.7Z" }, null, -1), KLn = [
  ILn
], XLn = { key: 3 }, JLn = ["stroke"], QLn = ["stroke"], YLn = { key: 4 }, oBn = ["stroke"], eBn = ["stroke"], tBn = { key: 5 }, nBn = ["stroke"], sBn = ["stroke"], rBn = {
  name: "PhHourglassSimple"
}, RK1 = /* @__PURE__ */ $({
  ...rBn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", TLn, [
        e("path", {
          d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DLn),
        e("path", {
          d: "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RLn)
      ])) : o(i) === "duotone" ? (s(), r("g", ULn, [
        qLn,
        e("path", {
          d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GLn),
        e("path", {
          d: "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ELn)
      ])) : o(i) === "fill" ? (s(), r("g", OLn, KLn)) : o(i) === "light" ? (s(), r("g", XLn, [
        e("path", {
          d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JLn),
        e("path", {
          d: "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QLn)
      ])) : o(i) === "thin" ? (s(), r("g", YLn, [
        e("path", {
          d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oBn),
        e("path", {
          d: "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eBn)
      ])) : o(i) === "regular" ? (s(), r("g", tBn, [
        e("path", {
          d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nBn),
        e("path", {
          d: "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sBn)
      ])) : g("", !0)
    ], 16, FLn));
  }
}), iBn = ["width", "height", "fill", "transform"], lBn = { key: 0 }, dBn = ["stroke"], kBn = ["stroke"], cBn = ["stroke"], hBn = { key: 1 }, uBn = /* @__PURE__ */ e("polygon", {
  points: "128 128 184 72 72 72 128 128",
  opacity: "0.2"
}, null, -1), aBn = ["stroke"], _Bn = ["stroke"], pBn = ["stroke"], yBn = { key: 2 }, $Bn = /* @__PURE__ */ e("path", { d: "M139.3,128l50.4-50.3h0L208,59.3A16,16,0,0,0,196.7,32H59.3A16,16,0,0,0,48,59.3L116.7,128,48,196.7A16,16,0,0,0,59.3,224H196.7A16,16,0,0,0,208,196.7Zm57.4-80-16,16H75.3l-16-16ZM59.3,208,128,139.3,196.7,208Z" }, null, -1), wBn = [
  $Bn
], fBn = { key: 3 }, gBn = ["stroke"], xBn = ["stroke"], jBn = ["stroke"], mBn = { key: 4 }, MBn = ["stroke"], vBn = ["stroke"], SBn = ["stroke"], HBn = { key: 5 }, ABn = ["stroke"], VBn = ["stroke"], zBn = ["stroke"], ZBn = {
  name: "PhHourglassSimpleHigh"
}, UK1 = /* @__PURE__ */ $({
  ...ZBn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", lBn, [
        e("path", {
          d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dBn),
        e("path", {
          d: "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kBn),
        e("line", {
          x1: "80",
          y1: "80",
          x2: "176",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cBn)
      ])) : o(i) === "duotone" ? (s(), r("g", hBn, [
        uBn,
        e("path", {
          d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aBn),
        e("path", {
          d: "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Bn),
        e("line", {
          x1: "72",
          y1: "72",
          x2: "184",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pBn)
      ])) : o(i) === "fill" ? (s(), r("g", yBn, wBn)) : o(i) === "light" ? (s(), r("g", fBn, [
        e("path", {
          d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gBn),
        e("path", {
          d: "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xBn),
        e("line", {
          x1: "72",
          y1: "72",
          x2: "184",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jBn)
      ])) : o(i) === "thin" ? (s(), r("g", mBn, [
        e("path", {
          d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MBn),
        e("path", {
          d: "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vBn),
        e("line", {
          x1: "72",
          y1: "72",
          x2: "184",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SBn)
      ])) : o(i) === "regular" ? (s(), r("g", HBn, [
        e("path", {
          d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ABn),
        e("path", {
          d: "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VBn),
        e("line", {
          x1: "72",
          y1: "72",
          x2: "184",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zBn)
      ])) : g("", !0)
    ], 16, iBn));
  }
}), CBn = ["width", "height", "fill", "transform"], bBn = { key: 0 }, LBn = ["stroke"], BBn = ["stroke"], PBn = ["stroke"], WBn = { key: 1 }, NBn = /* @__PURE__ */ e("path", {
  d: "M53.7,202.3A8,8,0,0,0,59.3,216H196.7a8,8,0,0,0,5.6-13.7L176,176H80Z",
  opacity: "0.2"
}, null, -1), FBn = ["stroke"], TBn = ["stroke"], DBn = ["stroke"], RBn = { key: 2 }, UBn = /* @__PURE__ */ e("path", { d: "M139.3,128,208,59.3A16,16,0,0,0,196.7,32H59.3A16,16,0,0,0,48,59.3L116.7,128,48,196.7A16,16,0,0,0,59.3,224H196.7A16,16,0,0,0,208,196.7Zm-80-80H196.7L128,116.7ZM128,139.3,156.7,168H99.3Z" }, null, -1), qBn = [
  UBn
], GBn = { key: 3 }, EBn = ["stroke"], OBn = ["stroke"], IBn = ["stroke"], KBn = { key: 4 }, XBn = ["stroke"], JBn = ["stroke"], QBn = ["stroke"], YBn = { key: 5 }, oPn = ["stroke"], ePn = ["stroke"], tPn = ["stroke"], nPn = {
  name: "PhHourglassSimpleLow"
}, qK1 = /* @__PURE__ */ $({
  ...nPn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", bBn, [
        e("path", {
          d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LBn),
        e("path", {
          d: "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BBn),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "80",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PBn)
      ])) : o(i) === "duotone" ? (s(), r("g", WBn, [
        NBn,
        e("path", {
          d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FBn),
        e("path", {
          d: "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TBn),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "80",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DBn)
      ])) : o(i) === "fill" ? (s(), r("g", RBn, qBn)) : o(i) === "light" ? (s(), r("g", GBn, [
        e("path", {
          d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, EBn),
        e("path", {
          d: "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OBn),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "80",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IBn)
      ])) : o(i) === "thin" ? (s(), r("g", KBn, [
        e("path", {
          d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XBn),
        e("path", {
          d: "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, JBn),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "80",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QBn)
      ])) : o(i) === "regular" ? (s(), r("g", YBn, [
        e("path", {
          d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oPn),
        e("path", {
          d: "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ePn),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "80",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tPn)
      ])) : g("", !0)
    ], 16, CBn));
  }
}), sPn = ["width", "height", "fill", "transform"], rPn = { key: 0 }, iPn = ["stroke"], lPn = ["stroke"], dPn = ["stroke"], kPn = ["stroke"], cPn = { key: 1 }, hPn = /* @__PURE__ */ e("polygon", {
  points: "128 128 176 80 80 80 128 128",
  opacity: "0.2"
}, null, -1), uPn = ["stroke"], aPn = ["stroke"], _Pn = ["stroke"], pPn = ["stroke"], yPn = { key: 2 }, $Pn = /* @__PURE__ */ e("path", { d: "M139.3,128l34.4-34.3h0L208,59.3A16,16,0,0,0,196.7,32H59.3A16,16,0,0,0,48,59.3L116.7,128,48,196.7A16,16,0,0,0,59.3,224H196.7A16,16,0,0,0,208,196.7Zm57.4-80-24,24H83.3l-24-24ZM59.3,208,120,147.3V168a8,8,0,0,0,16,0V147.3L196.7,208Z" }, null, -1), wPn = [
  $Pn
], fPn = { key: 3 }, gPn = ["stroke"], xPn = ["stroke"], jPn = ["stroke"], mPn = ["stroke"], MPn = { key: 4 }, vPn = ["stroke"], SPn = ["stroke"], HPn = ["stroke"], APn = ["stroke"], VPn = { key: 5 }, zPn = ["stroke"], ZPn = ["stroke"], CPn = ["stroke"], bPn = ["stroke"], LPn = {
  name: "PhHourglassSimpleMedium"
}, GK1 = /* @__PURE__ */ $({
  ...LPn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", rPn, [
        e("path", {
          d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iPn),
        e("path", {
          d: "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lPn),
        e("line", {
          x1: "176",
          y1: "80",
          x2: "80",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dPn),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kPn)
      ])) : o(i) === "duotone" ? (s(), r("g", cPn, [
        hPn,
        e("path", {
          d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uPn),
        e("path", {
          d: "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aPn),
        e("line", {
          x1: "176",
          y1: "80",
          x2: "80",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Pn),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pPn)
      ])) : o(i) === "fill" ? (s(), r("g", yPn, wPn)) : o(i) === "light" ? (s(), r("g", fPn, [
        e("path", {
          d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gPn),
        e("path", {
          d: "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xPn),
        e("line", {
          x1: "176",
          y1: "80",
          x2: "80",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jPn),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mPn)
      ])) : o(i) === "thin" ? (s(), r("g", MPn, [
        e("path", {
          d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vPn),
        e("path", {
          d: "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SPn),
        e("line", {
          x1: "176",
          y1: "80",
          x2: "80",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HPn),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, APn)
      ])) : o(i) === "regular" ? (s(), r("g", VPn, [
        e("path", {
          d: "M59.3,40H196.7a8,8,0,0,1,5.6,13.7L128,128,53.7,53.7A8,8,0,0,1,59.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zPn),
        e("path", {
          d: "M59.3,216H196.7a8,8,0,0,0,5.6-13.7L128,128,53.7,202.3A8,8,0,0,0,59.3,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZPn),
        e("line", {
          x1: "176",
          y1: "80",
          x2: "80",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CPn),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bPn)
      ])) : g("", !0)
    ], 16, sPn));
  }
}), BPn = ["width", "height", "fill", "transform"], PPn = { key: 0 }, WPn = ["stroke"], NPn = { key: 1 }, FPn = /* @__PURE__ */ e("path", {
  d: "M152,208V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v48a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V115.5a8.3,8.3,0,0,1,2.6-5.9l80-72.7a8,8,0,0,1,10.8,0l80,72.7a8.3,8.3,0,0,1,2.6,5.9V208a8,8,0,0,1-8,8H160A8,8,0,0,1,152,208Z",
  opacity: "0.2"
}, null, -1), TPn = ["stroke"], DPn = { key: 2 }, RPn = /* @__PURE__ */ e("path", { d: "M218.8,103.7,138.8,31a16,16,0,0,0-21.6,0l-80,72.7A16,16,0,0,0,32,115.5v92.1a16.4,16.4,0,0,0,4,11A15.9,15.9,0,0,0,48,224H96a8,8,0,0,0,8-8V168a8,8,0,0,1,8-8h32a8,8,0,0,1,8,8v48a8,8,0,0,0,8,8h48a15.6,15.6,0,0,0,7.6-1.9A16.1,16.1,0,0,0,224,208V115.5A16,16,0,0,0,218.8,103.7Z" }, null, -1), UPn = [
  RPn
], qPn = { key: 3 }, GPn = ["stroke"], EPn = { key: 4 }, OPn = ["stroke"], IPn = { key: 5 }, KPn = ["stroke"], XPn = {
  name: "PhHouse"
}, EK1 = /* @__PURE__ */ $({
  ...XPn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", PPn, [
        e("path", {
          d: "M152,208V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v48a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V115.5a8.3,8.3,0,0,1,2.6-5.9l80-72.7a8,8,0,0,1,10.8,0l80,72.7a8.3,8.3,0,0,1,2.6,5.9V208a8,8,0,0,1-8,8H160A8,8,0,0,1,152,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WPn)
      ])) : o(i) === "duotone" ? (s(), r("g", NPn, [
        FPn,
        e("path", {
          d: "M152,208V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v48a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V115.5a8.3,8.3,0,0,1,2.6-5.9l80-72.7a8,8,0,0,1,10.8,0l80,72.7a8.3,8.3,0,0,1,2.6,5.9V208a8,8,0,0,1-8,8H160A8,8,0,0,1,152,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TPn)
      ])) : o(i) === "fill" ? (s(), r("g", DPn, UPn)) : o(i) === "light" ? (s(), r("g", qPn, [
        e("path", {
          d: "M152,208V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v48a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V115.5a8.3,8.3,0,0,1,2.6-5.9l80-72.7a8,8,0,0,1,10.8,0l80,72.7a8.3,8.3,0,0,1,2.6,5.9V208a8,8,0,0,1-8,8H160A8,8,0,0,1,152,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GPn)
      ])) : o(i) === "thin" ? (s(), r("g", EPn, [
        e("path", {
          d: "M152,208V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v48a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V115.5a8.3,8.3,0,0,1,2.6-5.9l80-72.7a8,8,0,0,1,10.8,0l80,72.7a8.3,8.3,0,0,1,2.6,5.9V208a8,8,0,0,1-8,8H160A8,8,0,0,1,152,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OPn)
      ])) : o(i) === "regular" ? (s(), r("g", IPn, [
        e("path", {
          d: "M152,208V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v48a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V115.5a8.3,8.3,0,0,1,2.6-5.9l80-72.7a8,8,0,0,1,10.8,0l80,72.7a8.3,8.3,0,0,1,2.6,5.9V208a8,8,0,0,1-8,8H160A8,8,0,0,1,152,208Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KPn)
      ])) : g("", !0)
    ], 16, BPn));
  }
}), JPn = ["width", "height", "fill", "transform"], QPn = { key: 0 }, YPn = ["stroke"], oWn = ["stroke"], eWn = ["stroke"], tWn = { key: 1 }, nWn = /* @__PURE__ */ e("path", {
  d: "M152,216V152H104v64H40V115.5a7.9,7.9,0,0,1,2.6-5.9l80-72.7a7.9,7.9,0,0,1,10.7,0l80.1,72.7a8.3,8.3,0,0,1,2.6,5.9V216Z",
  opacity: "0.2"
}, null, -1), sWn = ["stroke"], rWn = ["stroke"], iWn = ["stroke"], lWn = { key: 2 }, dWn = /* @__PURE__ */ e("path", { d: "M240,208H224V115.5a15.7,15.7,0,0,0-5.3-11.8L138.7,31a15.9,15.9,0,0,0-21.5,0l-80,72.7A16,16,0,0,0,32,115.5V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Zm-88,0H104V160a8,8,0,0,1,8-8h32a8,8,0,0,1,8,8Z" }, null, -1), kWn = [
  dWn
], cWn = { key: 3 }, hWn = ["stroke"], uWn = ["stroke"], aWn = ["stroke"], _Wn = { key: 4 }, pWn = ["stroke"], yWn = ["stroke"], $Wn = ["stroke"], wWn = { key: 5 }, fWn = ["stroke"], gWn = ["stroke"], xWn = ["stroke"], jWn = {
  name: "PhHouseLine"
}, OK1 = /* @__PURE__ */ $({
  ...jWn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", QPn, [
        e("path", {
          d: "M216,216V115.5a8.3,8.3,0,0,0-2.6-5.9l-80-72.7a8,8,0,0,0-10.8,0l-80,72.7a7.9,7.9,0,0,0-2.6,5.9V216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, YPn),
        e("line", {
          x1: "16",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oWn),
        e("path", {
          d: "M152,216V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eWn)
      ])) : o(i) === "duotone" ? (s(), r("g", tWn, [
        nWn,
        e("path", {
          d: "M216,216V115.5a8.3,8.3,0,0,0-2.6-5.9L133.3,36.9a7.9,7.9,0,0,0-10.7,0l-80,72.7a7.9,7.9,0,0,0-2.6,5.9V216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sWn),
        e("line", {
          x1: "16",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rWn),
        e("path", {
          d: "M152,216V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iWn)
      ])) : o(i) === "fill" ? (s(), r("g", lWn, kWn)) : o(i) === "light" ? (s(), r("g", cWn, [
        e("path", {
          d: "M216,216V115.5a8.3,8.3,0,0,0-2.6-5.9l-80-72.7a8,8,0,0,0-10.8,0l-80,72.7a7.9,7.9,0,0,0-2.6,5.9V216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hWn),
        e("line", {
          x1: "16",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uWn),
        e("path", {
          d: "M152,216V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aWn)
      ])) : o(i) === "thin" ? (s(), r("g", _Wn, [
        e("path", {
          d: "M216,216V115.5a8.3,8.3,0,0,0-2.6-5.9l-80-72.7a8,8,0,0,0-10.8,0l-80,72.7a7.9,7.9,0,0,0-2.6,5.9V216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pWn),
        e("line", {
          x1: "16",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yWn),
        e("path", {
          d: "M152,216V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $Wn)
      ])) : o(i) === "regular" ? (s(), r("g", wWn, [
        e("path", {
          d: "M216,216V115.5a8.3,8.3,0,0,0-2.6-5.9l-80-72.7a8,8,0,0,0-10.8,0l-80,72.7a8.3,8.3,0,0,0-2.6,5.9V216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fWn),
        e("line", {
          x1: "16",
          y1: "216",
          x2: "240",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gWn),
        e("path", {
          d: "M152,216V160a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xWn)
      ])) : g("", !0)
    ], 16, JPn));
  }
}), mWn = ["width", "height", "fill", "transform"], MWn = { key: 0 }, vWn = ["stroke"], SWn = { key: 1 }, HWn = /* @__PURE__ */ e("path", {
  d: "M213.4,109.6l-80-72.7a8,8,0,0,0-10.8,0l-80,72.7a8.3,8.3,0,0,0-2.6,5.9V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V115.5A8.3,8.3,0,0,0,213.4,109.6Z",
  opacity: "0.2"
}, null, -1), AWn = ["stroke"], VWn = { key: 2 }, zWn = /* @__PURE__ */ e("path", { d: "M218.8,103.7h0L138.8,31a16,16,0,0,0-21.6,0l-80,72.7A16,16,0,0,0,32,115.5V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V115.5A16,16,0,0,0,218.8,103.7Z" }, null, -1), ZWn = [
  zWn
], CWn = { key: 3 }, bWn = ["stroke"], LWn = { key: 4 }, BWn = ["stroke"], PWn = { key: 5 }, WWn = ["stroke"], NWn = {
  name: "PhHouseSimple"
}, IK1 = /* @__PURE__ */ $({
  ...NWn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", MWn, [
        e("path", {
          d: "M213.4,109.6l-80-72.7a8,8,0,0,0-10.8,0l-80,72.7a8.3,8.3,0,0,0-2.6,5.9V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V115.5A8.3,8.3,0,0,0,213.4,109.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vWn)
      ])) : o(i) === "duotone" ? (s(), r("g", SWn, [
        HWn,
        e("path", {
          d: "M213.4,109.6l-80-72.7a8,8,0,0,0-10.8,0l-80,72.7a8.3,8.3,0,0,0-2.6,5.9V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V115.5A8.3,8.3,0,0,0,213.4,109.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AWn)
      ])) : o(i) === "fill" ? (s(), r("g", VWn, ZWn)) : o(i) === "light" ? (s(), r("g", CWn, [
        e("path", {
          d: "M213.4,109.6l-80-72.7a8,8,0,0,0-10.8,0l-80,72.7a8.3,8.3,0,0,0-2.6,5.9V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V115.5A8.3,8.3,0,0,0,213.4,109.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bWn)
      ])) : o(i) === "thin" ? (s(), r("g", LWn, [
        e("path", {
          d: "M213.4,109.6l-80-72.7a8,8,0,0,0-10.8,0l-80,72.7a8.3,8.3,0,0,0-2.6,5.9V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V115.5A8.3,8.3,0,0,0,213.4,109.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, BWn)
      ])) : o(i) === "regular" ? (s(), r("g", PWn, [
        e("path", {
          d: "M213.4,109.6l-80-72.7a8,8,0,0,0-10.8,0l-80,72.7a8.3,8.3,0,0,0-2.6,5.9V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V115.5A8.3,8.3,0,0,0,213.4,109.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WWn)
      ])) : g("", !0)
    ], 16, mWn));
  }
}), FWn = ["width", "height", "fill", "transform"], TWn = { key: 0 }, DWn = ["stroke"], RWn = ["stroke"], UWn = ["stroke"], qWn = ["stroke"], GWn = { key: 1 }, EWn = /* @__PURE__ */ e("path", {
  d: "M200,32H56a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V40A8,8,0,0,0,200,32ZM128,168a32,32,0,1,1,32-32A32,32,0,0,1,128,168Z",
  opacity: "0.2"
}, null, -1), OWn = ["stroke"], IWn = ["stroke"], KWn = ["stroke"], XWn = ["stroke"], JWn = { key: 2 }, QWn = /* @__PURE__ */ e("path", { d: "M200,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24ZM96,48h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm84.8,150.4a8.1,8.1,0,0,1-11.2-1.6,52,52,0,0,0-83.2,0A8,8,0,0,1,80,200a7.7,7.7,0,0,1-4.8-1.6,8,8,0,0,1-1.6-11.2A67.8,67.8,0,0,1,101,165.5a40,40,0,1,1,54,0,67.8,67.8,0,0,1,27.4,21.7A8,8,0,0,1,180.8,198.4ZM152,136a24,24,0,1,1-24-24A24.1,24.1,0,0,1,152,136Z" }, null, -1), YWn = [
  QWn
], oNn = { key: 3 }, eNn = ["stroke"], tNn = ["stroke"], nNn = ["stroke"], sNn = ["stroke"], rNn = { key: 4 }, iNn = ["stroke"], lNn = ["stroke"], dNn = ["stroke"], kNn = ["stroke"], cNn = { key: 5 }, hNn = ["stroke"], uNn = ["stroke"], aNn = ["stroke"], _Nn = ["stroke"], pNn = {
  name: "PhIdentificationBadge"
}, KK1 = /* @__PURE__ */ $({
  ...pNn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", TWn, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DWn),
        e("line", {
          x1: "96",
          y1: "68",
          x2: "160",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RWn),
        e("circle", {
          cx: "128",
          cy: "136",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, UWn),
        e("path", {
          d: "M84,187.2a60,60,0,0,1,88,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qWn)
      ])) : o(i) === "duotone" ? (s(), r("g", GWn, [
        EWn,
        e("circle", {
          cx: "128",
          cy: "136",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OWn),
        e("path", {
          d: "M80,192a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IWn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KWn),
        e("line", {
          x1: "96",
          y1: "64",
          x2: "160",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XWn)
      ])) : o(i) === "fill" ? (s(), r("g", JWn, YWn)) : o(i) === "light" ? (s(), r("g", oNn, [
        e("circle", {
          cx: "128",
          cy: "136",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eNn),
        e("path", {
          d: "M80,192a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tNn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nNn),
        e("line", {
          x1: "96",
          y1: "64",
          x2: "160",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sNn)
      ])) : o(i) === "thin" ? (s(), r("g", rNn, [
        e("circle", {
          cx: "128",
          cy: "136",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iNn),
        e("path", {
          d: "M80,192a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lNn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dNn),
        e("line", {
          x1: "96",
          y1: "64",
          x2: "160",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kNn)
      ])) : o(i) === "regular" ? (s(), r("g", cNn, [
        e("circle", {
          cx: "128",
          cy: "136",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hNn),
        e("path", {
          d: "M80,192a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uNn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aNn),
        e("line", {
          x1: "96",
          y1: "64",
          x2: "160",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Nn)
      ])) : g("", !0)
    ], 16, FWn));
  }
}), yNn = ["width", "height", "fill", "transform"], $Nn = { key: 0 }, wNn = ["stroke"], fNn = ["stroke"], gNn = ["stroke"], xNn = ["stroke"], jNn = ["stroke"], mNn = { key: 1 }, MNn = /* @__PURE__ */ e("path", {
  d: "M216,48H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V56A8,8,0,0,0,216,48ZM92.1,144a24,24,0,1,1,24-24A23.9,23.9,0,0,1,92.1,144Z",
  opacity: "0.2"
}, null, -1), vNn = ["stroke"], SNn = ["stroke"], HNn = ["stroke"], ANn = ["stroke"], VNn = ["stroke"], zNn = { key: 2 }, ZNn = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM125.1,175.7a8,8,0,0,1-9.8-5.7,24,24,0,0,0-46.4,0,8.1,8.1,0,0,1-7.8,6l-2-.3a7.9,7.9,0,0,1-5.7-9.7,40.2,40.2,0,0,1,16.3-23.2,32,32,0,1,1,44.8,0A40.2,40.2,0,0,1,130.8,166,7.9,7.9,0,0,1,125.1,175.7ZM192,152H152a8,8,0,0,1,0-16h40a8,8,0,0,1,0,16Zm0-32H152a8,8,0,0,1,0-16h40a8,8,0,0,1,0,16Z" }, null, -1), CNn = /* @__PURE__ */ e("circle", {
  cx: "92.1",
  cy: "120",
  r: "16"
}, null, -1), bNn = [
  ZNn,
  CNn
], LNn = { key: 3 }, BNn = ["stroke"], PNn = ["stroke"], WNn = ["stroke"], NNn = ["stroke"], FNn = ["stroke"], TNn = { key: 4 }, DNn = ["stroke"], RNn = ["stroke"], UNn = ["stroke"], qNn = ["stroke"], GNn = ["stroke"], ENn = { key: 5 }, ONn = ["stroke"], INn = ["stroke"], KNn = ["stroke"], XNn = ["stroke"], JNn = ["stroke"], QNn = {
  name: "PhIdentificationCard"
}, XK1 = /* @__PURE__ */ $({
  ...QNn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $Nn, [
        e("line", {
          x1: "152",
          y1: "108",
          x2: "184",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wNn),
        e("line", {
          x1: "152",
          y1: "148",
          x2: "184",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fNn),
        e("circle", {
          cx: "94.1",
          cy: "116",
          r: "22",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gNn),
        e("path", {
          d: "M72.1,164a22,22,0,0,1,44,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xNn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jNn)
      ])) : o(i) === "duotone" ? (s(), r("g", mNn, [
        MNn,
        e("line", {
          x1: "152",
          y1: "112",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vNn),
        e("line", {
          x1: "152",
          y1: "144",
          x2: "192",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SNn),
        e("circle", {
          cx: "92.1",
          cy: "120",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HNn),
        e("path", {
          d: "M61.1,168a32,32,0,0,1,62,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ANn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VNn)
      ])) : o(i) === "fill" ? (s(), r("g", zNn, bNn)) : o(i) === "light" ? (s(), r("g", LNn, [
        e("line", {
          x1: "152",
          y1: "112",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BNn),
        e("line", {
          x1: "152",
          y1: "144",
          x2: "192",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PNn),
        e("circle", {
          cx: "92.1",
          cy: "120",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WNn),
        e("path", {
          d: "M61.1,168a32,32,0,0,1,62,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, NNn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FNn)
      ])) : o(i) === "thin" ? (s(), r("g", TNn, [
        e("line", {
          x1: "152",
          y1: "112",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, DNn),
        e("line", {
          x1: "152",
          y1: "144",
          x2: "192",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RNn),
        e("circle", {
          cx: "92.1",
          cy: "120",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, UNn),
        e("path", {
          d: "M61.1,168a32,32,0,0,1,62,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qNn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GNn)
      ])) : o(i) === "regular" ? (s(), r("g", ENn, [
        e("line", {
          x1: "152",
          y1: "112",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ONn),
        e("line", {
          x1: "152",
          y1: "144",
          x2: "192",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, INn),
        e("circle", {
          cx: "92.1",
          cy: "120",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KNn),
        e("path", {
          d: "M61.1,168a32,32,0,0,1,62,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XNn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JNn)
      ])) : g("", !0)
    ], 16, yNn));
  }
}), YNn = ["width", "height", "fill", "transform"], oFn = { key: 0 }, eFn = ["stroke"], tFn = ["stroke"], nFn = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "100",
  r: "16"
}, null, -1), sFn = { key: 1 }, rFn = /* @__PURE__ */ e("path", {
  d: "M32,168l50.3-50.3a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,0,11.4,0l20.6-20.6a8,8,0,0,1,11.4,0L224,184V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8Z",
  opacity: "0.2"
}, null, -1), iFn = ["stroke"], lFn = ["stroke"], dFn = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "100",
  r: "12"
}, null, -1), kFn = { key: 2 }, cFn = /* @__PURE__ */ e("path", { d: "M168,100h0a12,12,0,0,1-12,12,12,12,0,0,1-12-12,12,12,0,0,1,24,0Zm64-44V184h0v16a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V168h0V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56ZM216,164.7V56H40v92.7L76.7,112a16.1,16.1,0,0,1,22.6,0L144,156.7,164.7,136a16.1,16.1,0,0,1,22.6,0Z" }, null, -1), hFn = [
  cFn
], uFn = { key: 3 }, aFn = ["stroke"], _Fn = ["stroke"], pFn = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "100",
  r: "10"
}, null, -1), yFn = { key: 4 }, $Fn = ["stroke"], wFn = ["stroke"], fFn = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "100",
  r: "8"
}, null, -1), gFn = { key: 5 }, xFn = ["stroke"], jFn = ["stroke"], mFn = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "100",
  r: "12"
}, null, -1), MFn = {
  name: "PhImage"
}, JK1 = /* @__PURE__ */ $({
  ...MFn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", oFn, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eFn),
        e("path", {
          d: "M32,168l50.3-50.3a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,0,11.4,0l20.6-20.6a8,8,0,0,1,11.4,0L224,184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tFn),
        nFn
      ])) : o(i) === "duotone" ? (s(), r("g", sFn, [
        rFn,
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iFn),
        e("path", {
          d: "M32,168l50.3-50.3a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,0,11.4,0l20.6-20.6a8,8,0,0,1,11.4,0L224,184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lFn),
        dFn
      ])) : o(i) === "fill" ? (s(), r("g", kFn, hFn)) : o(i) === "light" ? (s(), r("g", uFn, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aFn),
        e("path", {
          d: "M32,168l50.3-50.3a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,0,11.4,0l20.6-20.6a8,8,0,0,1,11.4,0L224,184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _Fn),
        pFn
      ])) : o(i) === "thin" ? (s(), r("g", yFn, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $Fn),
        e("path", {
          d: "M32,168l50.3-50.3a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,0,11.4,0l20.6-20.6a8,8,0,0,1,11.4,0L224,184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wFn),
        fFn
      ])) : o(i) === "regular" ? (s(), r("g", gFn, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xFn),
        e("path", {
          d: "M32,168l50.3-50.3a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,0,11.4,0l20.6-20.6a8,8,0,0,1,11.4,0L224,184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jFn),
        mFn
      ])) : g("", !0)
    ], 16, YNn));
  }
}), vFn = ["width", "height", "fill", "transform"], SFn = { key: 0 }, HFn = ["stroke"], AFn = ["stroke"], VFn = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "92",
  r: "16"
}, null, -1), zFn = { key: 1 }, ZFn = /* @__PURE__ */ e("path", {
  d: "M40,176V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V160h0l-42.3-42.3a8,8,0,0,0-11.4,0l-44.6,44.6a8,8,0,0,1-11.4,0L85.7,141.7a8,8,0,0,0-11.4,0Z",
  opacity: "0.2"
}, null, -1), CFn = ["stroke"], bFn = ["stroke"], LFn = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "92",
  r: "12"
}, null, -1), BFn = { key: 2 }, PFn = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "92",
  r: "12"
}, null, -1), WFn = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V176h0v32a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm-28.7,80a16.1,16.1,0,0,0-22.6,0L112,156.7,91.3,136a16.1,16.1,0,0,0-22.6,0L48,156.7V48H208v92.7Z" }, null, -1), NFn = [
  PFn,
  WFn
], FFn = { key: 3 }, TFn = ["stroke"], DFn = ["stroke"], RFn = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "92",
  r: "10"
}, null, -1), UFn = { key: 4 }, qFn = ["stroke"], GFn = ["stroke"], EFn = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "92",
  r: "8"
}, null, -1), OFn = { key: 5 }, IFn = ["stroke"], KFn = ["stroke"], XFn = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "92",
  r: "12"
}, null, -1), JFn = {
  name: "PhImageSquare"
}, QK1 = /* @__PURE__ */ $({
  ...JFn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", SFn, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HFn),
        e("path", {
          d: "M216,160l-42.3-42.3a8,8,0,0,0-11.4,0l-44.6,44.6a8,8,0,0,1-11.4,0L85.7,141.7a8,8,0,0,0-11.4,0L40,176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, AFn),
        VFn
      ])) : o(i) === "duotone" ? (s(), r("g", zFn, [
        ZFn,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CFn),
        e("path", {
          d: "M216,160l-42.3-42.3a8,8,0,0,0-11.4,0l-44.6,44.6a8,8,0,0,1-11.4,0L85.7,141.7a8,8,0,0,0-11.4,0L40,176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bFn),
        LFn
      ])) : o(i) === "fill" ? (s(), r("g", BFn, NFn)) : o(i) === "light" ? (s(), r("g", FFn, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TFn),
        e("path", {
          d: "M216,160l-42.3-42.3a8,8,0,0,0-11.4,0l-44.6,44.6a8,8,0,0,1-11.4,0L85.7,141.7a8,8,0,0,0-11.4,0L40,176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DFn),
        RFn
      ])) : o(i) === "thin" ? (s(), r("g", UFn, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qFn),
        e("path", {
          d: "M216,160l-42.3-42.3a8,8,0,0,0-11.4,0l-44.6,44.6a8,8,0,0,1-11.4,0L85.7,141.7a8,8,0,0,0-11.4,0L40,176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GFn),
        EFn
      ])) : o(i) === "regular" ? (s(), r("g", OFn, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IFn),
        e("path", {
          d: "M216,160l-42.3-42.3a8,8,0,0,0-11.4,0l-44.6,44.6a8,8,0,0,1-11.4,0L85.7,141.7a8,8,0,0,0-11.4,0L40,176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KFn),
        XFn
      ])) : g("", !0)
    ], 16, vFn));
  }
}), QFn = ["width", "height", "fill", "transform"], YFn = { key: 0 }, oTn = ["stroke"], eTn = { key: 1 }, tTn = ["stroke"], nTn = { key: 2 }, sTn = /* @__PURE__ */ e("path", { d: "M248,128a56,56,0,0,1-95.6,39.6l-.3-.4-60-67.6A39.5,39.5,0,0,0,64,88a40,40,0,1,0,0,80,39.5,39.5,0,0,0,28.1-11.6l8.5-9.6a8,8,0,0,1,12,10.6l-8.7,9.8-.3.4a56,56,0,0,1-79.2,0A56,56,0,0,1,64,72a55.5,55.5,0,0,1,39.6,16.4l.3.4,60,67.6A39.5,39.5,0,0,0,192,168a40,40,0,1,0,0-80,39.5,39.5,0,0,0-28.1,11.6l-8.5,9.6a8,8,0,0,1-12-10.6l8.7-9.8.3-.4A56,56,0,0,1,248,128Z" }, null, -1), rTn = [
  sTn
], iTn = { key: 3 }, lTn = ["stroke"], dTn = { key: 4 }, kTn = ["stroke"], cTn = { key: 5 }, hTn = ["stroke"], uTn = {
  name: "PhInfinity"
}, YK1 = /* @__PURE__ */ $({
  ...uTn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", YFn, [
        e("path", {
          d: "M101.3,158.2l-3.4,3.7a47.9,47.9,0,1,1,0-67.8l60.2,67.8a47.9,47.9,0,1,0,0-67.8l-3.4,3.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oTn)
      ])) : o(i) === "duotone" ? (s(), r("g", eTn, [
        e("path", {
          d: "M106.6,152.1l-8.7,9.8a47.9,47.9,0,1,1,0-67.8l60.2,67.8a47.9,47.9,0,1,0,0-67.8l-8.7,9.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tTn)
      ])) : o(i) === "fill" ? (s(), r("g", nTn, rTn)) : o(i) === "light" ? (s(), r("g", iTn, [
        e("path", {
          d: "M106.6,152.1l-8.7,9.8a47.9,47.9,0,1,1,0-67.8l60.2,67.8a47.9,47.9,0,1,0,0-67.8l-8.7,9.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lTn)
      ])) : o(i) === "thin" ? (s(), r("g", dTn, [
        e("path", {
          d: "M106.6,152.1l-8.7,9.8a47.9,47.9,0,1,1,0-67.8l60.2,67.8a47.9,47.9,0,1,0,0-67.8l-8.7,9.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kTn)
      ])) : o(i) === "regular" ? (s(), r("g", cTn, [
        e("path", {
          d: "M106.6,152.1l-8.7,9.8a47.9,47.9,0,1,1,0-67.8l60.2,67.8a47.9,47.9,0,1,0,0-67.8l-8.7,9.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hTn)
      ])) : g("", !0)
    ], 16, QFn));
  }
}), aTn = ["width", "height", "fill", "transform"], _Tn = { key: 0 }, pTn = ["stroke"], yTn = ["stroke"], $Tn = /* @__PURE__ */ e("circle", {
  cx: "126",
  cy: "84",
  r: "16"
}, null, -1), wTn = { key: 1 }, fTn = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), gTn = ["stroke"], xTn = ["stroke"], jTn = /* @__PURE__ */ e("circle", {
  cx: "126",
  cy: "84",
  r: "12"
}, null, -1), mTn = { key: 2 }, MTn = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm-2,48a12,12,0,1,1-12,12A12,12,0,0,1,126,72Zm10,112h-8a8,8,0,0,1-8-8V128a8,8,0,0,1,0-16h8a8,8,0,0,1,8,8v48a8,8,0,0,1,0,16Z" }, null, -1), vTn = [
  MTn
], STn = { key: 3 }, HTn = ["stroke"], ATn = ["stroke"], VTn = /* @__PURE__ */ e("circle", {
  cx: "126",
  cy: "84",
  r: "10"
}, null, -1), zTn = { key: 4 }, ZTn = ["stroke"], CTn = ["stroke"], bTn = /* @__PURE__ */ e("circle", {
  cx: "126",
  cy: "84",
  r: "8"
}, null, -1), LTn = { key: 5 }, BTn = ["stroke"], PTn = ["stroke"], WTn = /* @__PURE__ */ e("circle", {
  cx: "126",
  cy: "84",
  r: "12"
}, null, -1), NTn = {
  name: "PhInfo"
}, oX1 = /* @__PURE__ */ $({
  ...NTn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", _Tn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pTn),
        e("polyline", {
          points: "120 124 128 124 128 176 136 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yTn),
        $Tn
      ])) : o(i) === "duotone" ? (s(), r("g", wTn, [
        fTn,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gTn),
        e("polyline", {
          points: "120 120 128 120 128 176 136 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xTn),
        jTn
      ])) : o(i) === "fill" ? (s(), r("g", mTn, vTn)) : o(i) === "light" ? (s(), r("g", STn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HTn),
        e("polyline", {
          points: "120 120 128 120 128 176 136 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ATn),
        VTn
      ])) : o(i) === "thin" ? (s(), r("g", zTn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZTn),
        e("polyline", {
          points: "120 120 128 120 128 176 136 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CTn),
        bTn
      ])) : o(i) === "regular" ? (s(), r("g", LTn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BTn),
        e("polyline", {
          points: "120 120 128 120 128 176 136 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PTn),
        WTn
      ])) : g("", !0)
    ], 16, aTn));
  }
}), FTn = ["width", "height", "fill", "transform"], TTn = { key: 0 }, DTn = ["stroke"], RTn = ["stroke"], UTn = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "76",
  r: "16"
}, null, -1), qTn = { key: 1 }, GTn = /* @__PURE__ */ e("path", {
  d: "M172,36H84A48,48,0,0,0,36,84v88a48,48,0,0,0,48,48h88a48,48,0,0,0,48-48V84A48,48,0,0,0,172,36ZM128,168a40,40,0,1,1,40-40A40,40,0,0,1,128,168Z",
  opacity: "0.2"
}, null, -1), ETn = ["stroke"], OTn = ["stroke"], ITn = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "76",
  r: "12"
}, null, -1), KTn = { key: 2 }, XTn = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "32"
}, null, -1), JTn = /* @__PURE__ */ e("path", { d: "M172,28H84A56,56,0,0,0,28,84v88a56,56,0,0,0,56,56h88a56,56,0,0,0,56-56V84A56,56,0,0,0,172,28ZM128,176a48,48,0,1,1,48-48A48,48,0,0,1,128,176Zm52-88a12,12,0,1,1,12-12A12,12,0,0,1,180,88Z" }, null, -1), QTn = [
  XTn,
  JTn
], YTn = { key: 3 }, oDn = ["stroke"], eDn = ["stroke"], tDn = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "76",
  r: "10"
}, null, -1), nDn = { key: 4 }, sDn = ["stroke"], rDn = ["stroke"], iDn = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "76",
  r: "8"
}, null, -1), lDn = { key: 5 }, dDn = ["stroke"], kDn = ["stroke"], cDn = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "76",
  r: "12"
}, null, -1), hDn = {
  name: "PhInstagramLogo"
}, eX1 = /* @__PURE__ */ $({
  ...hDn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", TTn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DTn),
        e("rect", {
          x: "32",
          y: "32",
          width: "192",
          height: "192",
          rx: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RTn),
        UTn
      ])) : o(i) === "duotone" ? (s(), r("g", qTn, [
        GTn,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, ETn),
        e("rect", {
          x: "36",
          y: "36",
          width: "184",
          height: "184",
          rx: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OTn),
        ITn
      ])) : o(i) === "fill" ? (s(), r("g", KTn, QTn)) : o(i) === "light" ? (s(), r("g", YTn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oDn),
        e("rect", {
          x: "36",
          y: "36",
          width: "184",
          height: "184",
          rx: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eDn),
        tDn
      ])) : o(i) === "thin" ? (s(), r("g", nDn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sDn),
        e("rect", {
          x: "36",
          y: "36",
          width: "184",
          height: "184",
          rx: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rDn),
        iDn
      ])) : o(i) === "regular" ? (s(), r("g", lDn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, dDn),
        e("rect", {
          x: "36",
          y: "36",
          width: "184",
          height: "184",
          rx: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kDn),
        cDn
      ])) : g("", !0)
    ], 16, FTn));
  }
}), uDn = ["width", "height", "fill", "transform"], aDn = { key: 0 }, _Dn = ["stroke"], pDn = ["stroke"], yDn = ["stroke"], $Dn = { key: 1 }, wDn = /* @__PURE__ */ e("path", {
  d: "M88,160c0,2.5.5,4.8.7,7.3,2.5.2,4.8.7,7.3.7a72,72,0,0,0,72-72c0-2.5-.5-4.8-.7-7.3-2.5-.2-4.8-.7-7.3-.7A72,72,0,0,0,88,160Z",
  opacity: "0.2"
}, null, -1), fDn = ["stroke"], gDn = ["stroke"], xDn = { key: 2 }, jDn = /* @__PURE__ */ e("path", { d: "M174.6,81.4a80,80,0,1,0-93.2,93.2,80,80,0,1,0,93.2-93.2ZM32,96A64,64,0,0,1,158,80.1,79.9,79.9,0,0,0,80.1,158,64.2,64.2,0,0,1,32,96ZM160,224a64.2,64.2,0,0,1-62-48.1A79.9,79.9,0,0,0,175.9,98,64,64,0,0,1,160,224Z" }, null, -1), mDn = [
  jDn
], MDn = { key: 3 }, vDn = ["stroke"], SDn = ["stroke"], HDn = ["stroke"], ADn = ["stroke"], VDn = { key: 4 }, zDn = ["stroke"], ZDn = ["stroke"], CDn = ["stroke"], bDn = ["stroke"], LDn = { key: 5 }, BDn = ["stroke"], PDn = ["stroke"], WDn = ["stroke"], NDn = ["stroke"], FDn = {
  name: "PhIntersect"
}, tX1 = /* @__PURE__ */ $({
  ...FDn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", aDn, [
        e("circle", {
          cx: "96",
          cy: "96",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Dn),
        e("circle", {
          cx: "160",
          cy: "160",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pDn),
        e("line", {
          x1: "109.1",
          y1: "109.1",
          x2: "146.9",
          y2: "146.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yDn)
      ])) : o(i) === "duotone" ? (s(), r("g", $Dn, [
        wDn,
        e("circle", {
          cx: "96",
          cy: "96",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fDn),
        e("circle", {
          cx: "160",
          cy: "160",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gDn)
      ])) : o(i) === "fill" ? (s(), r("g", xDn, mDn)) : o(i) === "light" ? (s(), r("g", MDn, [
        e("circle", {
          cx: "96",
          cy: "96",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vDn),
        e("circle", {
          cx: "160",
          cy: "160",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, SDn),
        e("line", {
          x1: "122.5",
          y1: "98.5",
          x2: "157.5",
          y2: "133.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HDn),
        e("line", {
          x1: "98.5",
          y1: "122.5",
          x2: "133.5",
          y2: "157.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ADn)
      ])) : o(i) === "thin" ? (s(), r("g", VDn, [
        e("circle", {
          cx: "96",
          cy: "96",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zDn),
        e("circle", {
          cx: "160",
          cy: "160",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZDn),
        e("line", {
          x1: "122.5",
          y1: "98.5",
          x2: "157.5",
          y2: "133.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CDn),
        e("line", {
          x1: "98.5",
          y1: "122.5",
          x2: "133.5",
          y2: "157.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bDn)
      ])) : o(i) === "regular" ? (s(), r("g", LDn, [
        e("circle", {
          cx: "96",
          cy: "96",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BDn),
        e("circle", {
          cx: "160",
          cy: "160",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PDn),
        e("line", {
          x1: "122.5",
          y1: "98.5",
          x2: "157.5",
          y2: "133.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WDn),
        e("line", {
          x1: "98.5",
          y1: "122.5",
          x2: "133.5",
          y2: "157.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NDn)
      ])) : g("", !0)
    ], 16, uDn));
  }
}), TDn = ["width", "height", "fill", "transform"], DDn = { key: 0 }, RDn = ["stroke"], UDn = ["stroke"], qDn = ["stroke"], GDn = ["stroke"], EDn = ["stroke"], ODn = ["stroke"], IDn = ["stroke"], KDn = { key: 1 }, XDn = /* @__PURE__ */ e("path", {
  d: "M220,176v32a8,8,0,0,1-8,8H188a8,8,0,0,1-8-8V176Z",
  opacity: "0.2"
}, null, -1), JDn = /* @__PURE__ */ e("path", {
  d: "M76,176v32a8,8,0,0,1-8,8H44a8,8,0,0,1-8-8V176Z",
  opacity: "0.2"
}, null, -1), QDn = /* @__PURE__ */ e("path", {
  d: "M36,96l7-49.1A8,8,0,0,1,50.9,40H205.1a8,8,0,0,1,7.9,6.9L220,96Z",
  opacity: "0.2"
}, null, -1), YDn = ["stroke"], oRn = ["stroke"], eRn = ["stroke"], tRn = ["stroke"], nRn = ["stroke"], sRn = ["stroke"], rRn = /* @__PURE__ */ e("circle", {
  cx: "72",
  cy: "132",
  r: "12"
}, null, -1), iRn = /* @__PURE__ */ e("circle", {
  cx: "184",
  cy: "132",
  r: "12"
}, null, -1), lRn = { key: 2 }, dRn = /* @__PURE__ */ e("path", { d: "M239.7,88H226.9l-6-42.3A16,16,0,0,0,205.1,32H50.9A16,16,0,0,0,35.1,45.7L29.1,88H16.3A8.2,8.2,0,0,0,8,95.5a8,8,0,0,0,8,8.5H28V208a16,16,0,0,0,16,16H68a16,16,0,0,0,16-16V184h16a4,4,0,0,0,4-4V128.3a8.2,8.2,0,0,1,7.5-8.3,8,8,0,0,1,8.5,8v52a4,4,0,0,0,4,4h8a4,4,0,0,0,4-4V128.3a8.2,8.2,0,0,1,7.5-8.3,8,8,0,0,1,8.5,8v52a4,4,0,0,0,4,4h16v24a16,16,0,0,0,16,16h24a16,16,0,0,0,16-16V104h12a8,8,0,0,0,8-8.5A8.2,8.2,0,0,0,239.7,88ZM72,144a12,12,0,1,1,12-12A12,12,0,0,1,72,144Zm112,0a12,12,0,1,1,12-12A12,12,0,0,1,184,144Z" }, null, -1), kRn = [
  dRn
], cRn = { key: 3 }, hRn = ["stroke"], uRn = ["stroke"], aRn = ["stroke"], _Rn = ["stroke"], pRn = ["stroke"], yRn = ["stroke"], $Rn = /* @__PURE__ */ e("circle", {
  cx: "184",
  cy: "132",
  r: "10"
}, null, -1), wRn = /* @__PURE__ */ e("circle", {
  cx: "72",
  cy: "132",
  r: "10"
}, null, -1), fRn = { key: 4 }, gRn = ["stroke"], xRn = ["stroke"], jRn = ["stroke"], mRn = ["stroke"], MRn = ["stroke"], vRn = ["stroke"], SRn = /* @__PURE__ */ e("circle", {
  cx: "72",
  cy: "132",
  r: "8"
}, null, -1), HRn = /* @__PURE__ */ e("circle", {
  cx: "184",
  cy: "132",
  r: "8"
}, null, -1), ARn = { key: 5 }, VRn = ["stroke"], zRn = ["stroke"], ZRn = ["stroke"], CRn = ["stroke"], bRn = ["stroke"], LRn = ["stroke"], BRn = /* @__PURE__ */ e("circle", {
  cx: "72",
  cy: "132",
  r: "12"
}, null, -1), PRn = /* @__PURE__ */ e("circle", {
  cx: "184",
  cy: "132",
  r: "12"
}, null, -1), WRn = {
  name: "PhJeep"
}, nX1 = /* @__PURE__ */ $({
  ...WRn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", DDn, [
        e("path", {
          d: "M220,176v32a8,8,0,0,1-8,8H188a8,8,0,0,1-8-8V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RDn),
        e("path", {
          d: "M76,176v32a8,8,0,0,1-8,8H44a8,8,0,0,1-8-8V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, UDn),
        e("line", {
          x1: "16",
          y1: "96",
          x2: "240",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qDn),
        e("line", {
          x1: "128",
          y1: "136",
          x2: "128",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GDn),
        e("line", {
          x1: "168",
          y1: "136",
          x2: "168",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, EDn),
        e("line", {
          x1: "88",
          y1: "136",
          x2: "88",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ODn),
        e("path", {
          d: "M220,176H36V96l7-49.1A8,8,0,0,1,50.9,40H205.1a8,8,0,0,1,7.9,6.9L220,96Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IDn)
      ])) : o(i) === "duotone" ? (s(), r("g", KDn, [
        XDn,
        JDn,
        QDn,
        e("path", {
          d: "M220,176v32a8,8,0,0,1-8,8H188a8,8,0,0,1-8-8V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YDn),
        e("path", {
          d: "M76,176v32a8,8,0,0,1-8,8H44a8,8,0,0,1-8-8V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oRn),
        e("line", {
          x1: "16",
          y1: "96",
          x2: "240",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eRn),
        e("line", {
          x1: "144",
          y1: "128",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tRn),
        e("line", {
          x1: "112",
          y1: "128",
          x2: "112",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nRn),
        e("path", {
          d: "M220,176H36V96l7-49.1A8,8,0,0,1,50.9,40H205.1a8,8,0,0,1,7.9,6.9L220,96Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sRn),
        rRn,
        iRn
      ])) : o(i) === "fill" ? (s(), r("g", lRn, kRn)) : o(i) === "light" ? (s(), r("g", cRn, [
        e("path", {
          d: "M220,176v32a8,8,0,0,1-8,8H188a8,8,0,0,1-8-8V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hRn),
        e("path", {
          d: "M76,176v32a8,8,0,0,1-8,8H44a8,8,0,0,1-8-8V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uRn),
        e("line", {
          x1: "16",
          y1: "96",
          x2: "240",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aRn),
        e("line", {
          x1: "144",
          y1: "128",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _Rn),
        e("line", {
          x1: "112",
          y1: "128",
          x2: "112",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pRn),
        e("path", {
          d: "M220,176H36V96l7-49.1A8,8,0,0,1,50.9,40H205.1a8,8,0,0,1,7.9,6.9L220,96Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yRn),
        $Rn,
        wRn
      ])) : o(i) === "thin" ? (s(), r("g", fRn, [
        e("path", {
          d: "M220,176v32a8,8,0,0,1-8,8H188a8,8,0,0,1-8-8V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gRn),
        e("path", {
          d: "M76,176v32a8,8,0,0,1-8,8H44a8,8,0,0,1-8-8V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xRn),
        e("line", {
          x1: "16",
          y1: "96",
          x2: "240",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jRn),
        e("line", {
          x1: "144",
          y1: "128",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mRn),
        e("line", {
          x1: "112",
          y1: "128",
          x2: "112",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MRn),
        e("path", {
          d: "M220,176H36V96l7-49.1A8,8,0,0,1,50.9,40H205.1a8,8,0,0,1,7.9,6.9L220,96Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vRn),
        SRn,
        HRn
      ])) : o(i) === "regular" ? (s(), r("g", ARn, [
        e("path", {
          d: "M220,176v32a8,8,0,0,1-8,8H188a8,8,0,0,1-8-8V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VRn),
        e("path", {
          d: "M76,176v32a8,8,0,0,1-8,8H44a8,8,0,0,1-8-8V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zRn),
        e("line", {
          x1: "16",
          y1: "96",
          x2: "240",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZRn),
        e("line", {
          x1: "144",
          y1: "128",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CRn),
        e("line", {
          x1: "112",
          y1: "128",
          x2: "112",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bRn),
        e("path", {
          d: "M220,176H36V96l7-49.1A8,8,0,0,1,50.9,40H205.1a8,8,0,0,1,7.9,6.9L220,96Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LRn),
        BRn,
        PRn
      ])) : g("", !0)
    ], 16, TDn));
  }
}), NRn = ["width", "height", "fill", "transform"], FRn = { key: 0 }, TRn = ["stroke"], DRn = ["stroke"], RRn = ["stroke"], URn = ["stroke"], qRn = ["stroke"], GRn = { key: 1 }, ERn = /* @__PURE__ */ e("rect", {
  x: "160",
  y: "56",
  width: "56",
  height: "64",
  opacity: "0.2"
}, null, -1), ORn = /* @__PURE__ */ e("path", {
  d: "M96,120H40v88a8,8,0,0,0,8,8H88a8,8,0,0,0,8-8Z",
  opacity: "0.2"
}, null, -1), IRn = ["stroke"], KRn = ["stroke"], XRn = ["stroke"], JRn = ["stroke"], QRn = ["stroke"], YRn = { key: 2 }, oUn = /* @__PURE__ */ e("path", { d: "M216,48H40a8,8,0,0,0-8,8V208a16,16,0,0,0,16,16H88a16,16,0,0,0,16-16V160h48v16a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V56A8,8,0,0,0,216,48ZM88,64v56H48V64Zm16,80V64h48v80Zm64,32V120h40v56Z" }, null, -1), eUn = [
  oUn
], tUn = { key: 3 }, nUn = ["stroke"], sUn = ["stroke"], rUn = ["stroke"], iUn = ["stroke"], lUn = ["stroke"], dUn = { key: 4 }, kUn = ["stroke"], cUn = ["stroke"], hUn = ["stroke"], uUn = ["stroke"], aUn = ["stroke"], _Un = { key: 5 }, pUn = ["stroke"], yUn = ["stroke"], $Un = ["stroke"], wUn = ["stroke"], fUn = ["stroke"], gUn = {
  name: "PhKanban"
}, sX1 = /* @__PURE__ */ $({
  ...gUn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", FRn, [
        e("path", {
          d: "M40,56H216V176a8,8,0,0,1-8,8H168a8,8,0,0,1-8-8V152H96v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TRn),
        e("line", {
          x1: "96",
          y1: "120",
          x2: "40",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DRn),
        e("line", {
          x1: "96",
          y1: "56",
          x2: "96",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RRn),
        e("line", {
          x1: "160",
          y1: "120",
          x2: "216",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, URn),
        e("line", {
          x1: "160",
          y1: "56",
          x2: "160",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qRn)
      ])) : o(i) === "duotone" ? (s(), r("g", GRn, [
        ERn,
        ORn,
        e("path", {
          d: "M40,56H216V176a8,8,0,0,1-8,8H168a8,8,0,0,1-8-8V152H96v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IRn),
        e("line", {
          x1: "96",
          y1: "120",
          x2: "40",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KRn),
        e("line", {
          x1: "96",
          y1: "56",
          x2: "96",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XRn),
        e("line", {
          x1: "160",
          y1: "120",
          x2: "216",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JRn),
        e("line", {
          x1: "160",
          y1: "56",
          x2: "160",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QRn)
      ])) : o(i) === "fill" ? (s(), r("g", YRn, eUn)) : o(i) === "light" ? (s(), r("g", tUn, [
        e("path", {
          d: "M40,56H216V176a8,8,0,0,1-8,8H168a8,8,0,0,1-8-8V152H96v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nUn),
        e("line", {
          x1: "96",
          y1: "120",
          x2: "40",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sUn),
        e("line", {
          x1: "96",
          y1: "56",
          x2: "96",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rUn),
        e("line", {
          x1: "160",
          y1: "120",
          x2: "216",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iUn),
        e("line", {
          x1: "160",
          y1: "56",
          x2: "160",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lUn)
      ])) : o(i) === "thin" ? (s(), r("g", dUn, [
        e("path", {
          d: "M40,56H216V176a8,8,0,0,1-8,8H168a8,8,0,0,1-8-8V152H96v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kUn),
        e("line", {
          x1: "96",
          y1: "120",
          x2: "40",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cUn),
        e("line", {
          x1: "96",
          y1: "56",
          x2: "96",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hUn),
        e("line", {
          x1: "160",
          y1: "120",
          x2: "216",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uUn),
        e("line", {
          x1: "160",
          y1: "56",
          x2: "160",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aUn)
      ])) : o(i) === "regular" ? (s(), r("g", _Un, [
        e("path", {
          d: "M40,56H216V176a8,8,0,0,1-8,8H168a8,8,0,0,1-8-8V152H96v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pUn),
        e("line", {
          x1: "96",
          y1: "120",
          x2: "40",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yUn),
        e("line", {
          x1: "96",
          y1: "56",
          x2: "96",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Un),
        e("line", {
          x1: "160",
          y1: "120",
          x2: "216",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wUn),
        e("line", {
          x1: "160",
          y1: "56",
          x2: "160",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fUn)
      ])) : g("", !0)
    ], 16, NRn));
  }
}), xUn = ["width", "height", "fill", "transform"], jUn = { key: 0 }, mUn = ["stroke"], MUn = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "76",
  r: "16"
}, null, -1), vUn = { key: 1 }, SUn = /* @__PURE__ */ e("path", {
  d: "M93.2,122.8A70.3,70.3,0,0,1,88,96a72,72,0,1,1,72,72,70.3,70.3,0,0,1-26.8-5.2h0L120,176H96v24H72v24H32V184l61.2-61.2Z",
  opacity: "0.2"
}, null, -1), HUn = ["stroke"], AUn = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "76",
  r: "12"
}, null, -1), VUn = { key: 2 }, zUn = /* @__PURE__ */ e("path", { d: "M160,16A80.1,80.1,0,0,0,83.9,120.8L26.3,178.3A8.1,8.1,0,0,0,24,184v40a8,8,0,0,0,8,8H72a8,8,0,0,0,8-8V208H96a8,8,0,0,0,8-8V184h16a8.1,8.1,0,0,0,5.7-2.3l9.5-9.6A80,80,0,1,0,160,16Zm20,76a16,16,0,1,1,16-16A16,16,0,0,1,180,92Z" }, null, -1), ZUn = [
  zUn
], CUn = { key: 3 }, bUn = ["stroke"], LUn = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "76",
  r: "10"
}, null, -1), BUn = { key: 4 }, PUn = ["stroke"], WUn = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "76",
  r: "8"
}, null, -1), NUn = { key: 5 }, FUn = ["stroke"], TUn = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "76",
  r: "12"
}, null, -1), DUn = {
  name: "PhKey"
}, rX1 = /* @__PURE__ */ $({
  ...DUn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", jUn, [
        e("path", {
          d: "M93.2,122.8A70.3,70.3,0,0,1,88,96a72,72,0,1,1,72,72,70.3,70.3,0,0,1-26.8-5.2h0L120,176H96v24H72v24H32V184l61.2-61.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mUn),
        MUn
      ])) : o(i) === "duotone" ? (s(), r("g", vUn, [
        SUn,
        e("path", {
          d: "M93.2,122.8A70.3,70.3,0,0,1,88,96a72,72,0,1,1,72,72,70.3,70.3,0,0,1-26.8-5.2h0L120,176H96v24H72v24H32V184l61.2-61.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HUn),
        AUn
      ])) : o(i) === "fill" ? (s(), r("g", VUn, ZUn)) : o(i) === "light" ? (s(), r("g", CUn, [
        e("path", {
          d: "M93.2,122.8A70.3,70.3,0,0,1,88,96a72,72,0,1,1,72,72,70.3,70.3,0,0,1-26.8-5.2h0L120,176H96v24H72v24H32V184l61.2-61.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bUn),
        LUn
      ])) : o(i) === "thin" ? (s(), r("g", BUn, [
        e("path", {
          d: "M93.2,122.8A70.3,70.3,0,0,1,88,96a72,72,0,1,1,72,72,70.3,70.3,0,0,1-26.8-5.2h0L120,176H96v24H72v24H32V184l61.2-61.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PUn),
        WUn
      ])) : o(i) === "regular" ? (s(), r("g", NUn, [
        e("path", {
          d: "M93.2,122.8A70.3,70.3,0,0,1,88,96a72,72,0,1,1,72,72,70.3,70.3,0,0,1-26.8-5.2h0L120,176H96v24H72v24H32V184l61.2-61.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FUn),
        TUn
      ])) : g("", !0)
    ], 16, xUn));
  }
}), RUn = ["width", "height", "fill", "transform"], UUn = { key: 0 }, qUn = ["stroke"], GUn = ["stroke"], EUn = ["stroke"], OUn = { key: 1 }, IUn = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "48",
  width: "192",
  height: "160",
  rx: "8",
  opacity: "0.2"
}, null, -1), KUn = ["stroke"], XUn = ["stroke"], JUn = ["stroke"], QUn = { key: 2 }, YUn = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm-32,96a8,8,0,0,1-8,8H99.3l10.4,10.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0l-24-24a8.1,8.1,0,0,1,0-11.4l24-24a8.1,8.1,0,0,1,11.4,11.4L99.3,128H168V104a8,8,0,0,1,16,0Z" }, null, -1), oqn = [
  YUn
], eqn = { key: 3 }, tqn = ["stroke"], nqn = ["stroke"], sqn = ["stroke"], rqn = { key: 4 }, iqn = ["stroke"], lqn = ["stroke"], dqn = ["stroke"], kqn = { key: 5 }, cqn = ["stroke"], hqn = ["stroke"], uqn = ["stroke"], aqn = {
  name: "PhKeyReturn"
}, iX1 = /* @__PURE__ */ $({
  ...aqn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", UUn, [
        e("polyline", {
          points: "176 104 176 136 80 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qUn),
        e("polyline", {
          points: "104 112 80 136 104 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GUn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, EUn)
      ])) : o(i) === "duotone" ? (s(), r("g", OUn, [
        IUn,
        e("polyline", {
          points: "176 104 176 136 80 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KUn),
        e("polyline", {
          points: "104 112 80 136 104 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XUn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JUn)
      ])) : o(i) === "fill" ? (s(), r("g", QUn, oqn)) : o(i) === "light" ? (s(), r("g", eqn, [
        e("polyline", {
          points: "176 104 176 136 80 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tqn),
        e("polyline", {
          points: "104 112 80 136 104 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nqn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sqn)
      ])) : o(i) === "thin" ? (s(), r("g", rqn, [
        e("polyline", {
          points: "176 104 176 136 80 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iqn),
        e("polyline", {
          points: "104 112 80 136 104 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lqn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dqn)
      ])) : o(i) === "regular" ? (s(), r("g", kqn, [
        e("polyline", {
          points: "176 104 176 136 80 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cqn),
        e("polyline", {
          points: "104 112 80 136 104 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hqn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uqn)
      ])) : g("", !0)
    ], 16, RUn));
  }
}), _qn = ["width", "height", "fill", "transform"], pqn = { key: 0 }, yqn = ["stroke"], $qn = ["stroke"], wqn = ["stroke"], fqn = ["stroke"], gqn = ["stroke"], xqn = ["stroke"], jqn = { key: 1 }, mqn = /* @__PURE__ */ e("rect", {
  x: "24",
  y: "56",
  width: "208",
  height: "144",
  rx: "8.5",
  opacity: "0.2"
}, null, -1), Mqn = ["stroke"], vqn = ["stroke"], Sqn = ["stroke"], Hqn = ["stroke"], Aqn = ["stroke"], Vqn = ["stroke"], zqn = { key: 2 }, Zqn = /* @__PURE__ */ e("path", { d: "M223.5,47.5H32.5a17,17,0,0,0-17,17v127a17,17,0,0,0,17,17h191a17,17,0,0,0,17-17V64.5A17,17,0,0,0,223.5,47.5ZM64,168H56a8,8,0,0,1,0-16h8a8,8,0,0,1,0,16Zm96,0H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm40,0h-8a8,8,0,0,1,0-16h8a8,8,0,0,1,0,16Zm0-32H56a8,8,0,0,1,0-16H200a8,8,0,0,1,0,16Zm0-32H56a8,8,0,0,1,0-16H200a8,8,0,0,1,0,16Z" }, null, -1), Cqn = [
  Zqn
], bqn = { key: 3 }, Lqn = ["stroke"], Bqn = ["stroke"], Pqn = ["stroke"], Wqn = ["stroke"], Nqn = ["stroke"], Fqn = ["stroke"], Tqn = { key: 4 }, Dqn = ["stroke"], Rqn = ["stroke"], Uqn = ["stroke"], qqn = ["stroke"], Gqn = ["stroke"], Eqn = ["stroke"], Oqn = { key: 5 }, Iqn = ["stroke"], Kqn = ["stroke"], Xqn = ["stroke"], Jqn = ["stroke"], Qqn = ["stroke"], Yqn = ["stroke"], oGn = {
  name: "PhKeyboard"
}, lX1 = /* @__PURE__ */ $({
  ...oGn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", pqn, [
        e("rect", {
          x: "24",
          y: "56",
          width: "208",
          height: "144",
          rx: "8.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yqn),
        e("line", {
          x1: "64",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $qn),
        e("line", {
          x1: "64",
          y1: "92",
          x2: "192",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wqn),
        e("line", {
          x1: "64",
          y1: "164",
          x2: "72",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fqn),
        e("line", {
          x1: "108",
          y1: "164",
          x2: "148",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gqn),
        e("line", {
          x1: "184",
          y1: "164",
          x2: "192",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xqn)
      ])) : o(i) === "duotone" ? (s(), r("g", jqn, [
        mqn,
        e("rect", {
          x: "24",
          y: "56",
          width: "208",
          height: "144",
          rx: "8.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16.97"
        }, null, 8, Mqn),
        e("line", {
          x1: "56",
          y1: "128",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vqn),
        e("line", {
          x1: "56",
          y1: "96",
          x2: "200",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sqn),
        e("line", {
          x1: "56",
          y1: "160",
          x2: "64",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hqn),
        e("line", {
          x1: "96",
          y1: "160",
          x2: "160",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Aqn),
        e("line", {
          x1: "192",
          y1: "160",
          x2: "200",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vqn)
      ])) : o(i) === "fill" ? (s(), r("g", zqn, Cqn)) : o(i) === "light" ? (s(), r("g", bqn, [
        e("rect", {
          x: "24",
          y: "56",
          width: "208",
          height: "144",
          rx: "8.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lqn),
        e("line", {
          x1: "56",
          y1: "128",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bqn),
        e("line", {
          x1: "56",
          y1: "96",
          x2: "200",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pqn),
        e("line", {
          x1: "56",
          y1: "160",
          x2: "64",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wqn),
        e("line", {
          x1: "96",
          y1: "160",
          x2: "160",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Nqn),
        e("line", {
          x1: "192",
          y1: "160",
          x2: "200",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fqn)
      ])) : o(i) === "thin" ? (s(), r("g", Tqn, [
        e("rect", {
          x: "24",
          y: "56",
          width: "208",
          height: "144",
          rx: "8.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Dqn),
        e("line", {
          x1: "56",
          y1: "128",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Rqn),
        e("line", {
          x1: "56",
          y1: "96",
          x2: "200",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Uqn),
        e("line", {
          x1: "56",
          y1: "160",
          x2: "64",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qqn),
        e("line", {
          x1: "96",
          y1: "160",
          x2: "160",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gqn),
        e("line", {
          x1: "192",
          y1: "160",
          x2: "200",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Eqn)
      ])) : o(i) === "regular" ? (s(), r("g", Oqn, [
        e("rect", {
          x: "24",
          y: "56",
          width: "208",
          height: "144",
          rx: "8.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16.97"
        }, null, 8, Iqn),
        e("line", {
          x1: "56",
          y1: "128",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kqn),
        e("line", {
          x1: "56",
          y1: "96",
          x2: "200",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xqn),
        e("line", {
          x1: "56",
          y1: "160",
          x2: "64",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jqn),
        e("line", {
          x1: "96",
          y1: "160",
          x2: "160",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qqn),
        e("line", {
          x1: "192",
          y1: "160",
          x2: "200",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yqn)
      ])) : g("", !0)
    ], 16, _qn));
  }
}), eGn = ["width", "height", "fill", "transform"], tGn = { key: 0 }, nGn = ["stroke"], sGn = ["stroke"], rGn = { key: 1 }, iGn = /* @__PURE__ */ e("path", {
  d: "M141.4,132.6a28,28,0,1,0-26.8,0l-13.8,32.2a8,8,0,0,0,7.3,11.2h39.8a8,8,0,0,0,7.3-11.2Z",
  opacity: "0.2"
}, null, -1), lGn = ["stroke"], dGn = ["stroke"], kGn = { key: 2 }, cGn = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm18.4-81.8,12.5,29.1a12,12,0,0,1-11,16.7H108.1a12,12,0,0,1-11-16.7l12.5-29.1a32,32,0,0,1-2.9-50.1,32.4,32.4,0,0,1,25-7.9,32,32,0,0,1,14.7,58Z" }, null, -1), hGn = [
  cGn
], uGn = { key: 3 }, aGn = ["stroke"], _Gn = ["stroke"], pGn = { key: 4 }, yGn = ["stroke"], $Gn = ["stroke"], wGn = { key: 5 }, fGn = ["stroke"], gGn = ["stroke"], xGn = {
  name: "PhKeyhole"
}, dX1 = /* @__PURE__ */ $({
  ...xGn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", tGn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nGn),
        e("path", {
          d: "M146.6,129A28,28,0,1,0,100,108a28.5,28.5,0,0,0,9.4,21L98.9,165.8a8,8,0,0,0,7.7,10.2h42.8a8,8,0,0,0,7.7-10.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sGn)
      ])) : o(i) === "duotone" ? (s(), r("g", rGn, [
        iGn,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lGn),
        e("path", {
          d: "M141.4,132.6a28,28,0,1,0-26.8,0l-13.8,32.2a8,8,0,0,0,7.3,11.2h39.8a8,8,0,0,0,7.3-11.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dGn)
      ])) : o(i) === "fill" ? (s(), r("g", kGn, hGn)) : o(i) === "light" ? (s(), r("g", uGn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aGn),
        e("path", {
          d: "M141.4,132.6a28,28,0,1,0-26.8,0l-13.8,32.2a8,8,0,0,0,7.3,11.2h39.8a8,8,0,0,0,7.3-11.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _Gn)
      ])) : o(i) === "thin" ? (s(), r("g", pGn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yGn),
        e("path", {
          d: "M141.4,132.6a28,28,0,1,0-26.8,0l-13.8,32.2a8,8,0,0,0,7.3,11.2h39.8a8,8,0,0,0,7.3-11.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $Gn)
      ])) : o(i) === "regular" ? (s(), r("g", wGn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fGn),
        e("path", {
          d: "M141.4,132.6a28,28,0,1,0-26.8,0l-13.8,32.2a8,8,0,0,0,7.3,11.2h39.8a8,8,0,0,0,7.3-11.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gGn)
      ])) : g("", !0)
    ], 16, eGn));
  }
}), jGn = ["width", "height", "fill", "transform"], mGn = { key: 0 }, MGn = ["stroke"], vGn = { key: 1 }, SGn = /* @__PURE__ */ e("path", {
  d: "M146.5,90.5l51.4-52.6a19.9,19.9,0,0,1,28.2,28.2l-50.3,53.7Z",
  opacity: "0.2"
}, null, -1), HGn = ["stroke"], AGn = { key: 2 }, VGn = /* @__PURE__ */ e("path", { d: "M231.8,32.2a28.1,28.1,0,0,0-39.7.1L18.3,210.4a8,8,0,0,0,3.9,13.4,154.1,154.1,0,0,0,35,4c33.4,0,66.8-10.9,98.3-32.2a232,232,0,0,0,50.9-46.8,8.1,8.1,0,0,0-.7-10.5l-18.8-18.7,45-47.9A28,28,0,0,0,231.8,32.2ZM189.2,144.5a227,227,0,0,1-43.1,38.2c-34.5,23.2-70,32.6-105.8,28.1L146.6,101.9l23.3,23.3c.1.1.2.3.4.4h.1Z" }, null, -1), zGn = [
  VGn
], ZGn = { key: 3 }, CGn = ["stroke"], bGn = { key: 4 }, LGn = ["stroke"], BGn = { key: 5 }, PGn = ["stroke"], WGn = {
  name: "PhKnife"
}, kX1 = /* @__PURE__ */ $({
  ...WGn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", mGn, [
        e("path", {
          d: "M146.5,90.5,200,144s-72,96-176,72L197.9,37.9a19.9,19.9,0,0,1,28.2,28.2l-50.3,53.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MGn)
      ])) : o(i) === "duotone" ? (s(), r("g", vGn, [
        SGn,
        e("path", {
          d: "M146.5,90.5,200,144s-72,96-176,72L197.9,37.9a19.9,19.9,0,0,1,28.2,28.2l-50.3,53.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HGn)
      ])) : o(i) === "fill" ? (s(), r("g", AGn, zGn)) : o(i) === "light" ? (s(), r("g", ZGn, [
        e("path", {
          d: "M146.5,90.5,200,144s-72,96-176,72L197.9,37.9a19.9,19.9,0,0,1,28.2,28.2l-50.3,53.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, CGn)
      ])) : o(i) === "thin" ? (s(), r("g", bGn, [
        e("path", {
          d: "M146.5,90.5,200,144s-72,96-176,72L197.9,37.9a19.9,19.9,0,0,1,28.2,28.2l-50.3,53.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LGn)
      ])) : o(i) === "regular" ? (s(), r("g", BGn, [
        e("path", {
          d: "M146.5,90.5,200,144s-72,96-176,72L197.9,37.9a19.9,19.9,0,0,1,28.2,28.2l-50.3,53.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PGn)
      ])) : g("", !0)
    ], 16, jGn));
  }
}), NGn = ["width", "height", "fill", "transform"], FGn = { key: 0 }, TGn = ["stroke"], DGn = ["stroke"], RGn = ["stroke"], UGn = ["stroke"], qGn = ["stroke"], GGn = ["stroke"], EGn = ["stroke"], OGn = ["stroke"], IGn = { key: 1 }, KGn = ["stroke"], XGn = ["stroke"], JGn = ["stroke"], QGn = ["stroke"], YGn = ["stroke"], oEn = ["stroke"], eEn = ["stroke"], tEn = ["stroke"], nEn = { key: 2 }, sEn = /* @__PURE__ */ e("path", { d: "M215.5,213.3,164.5,73l9.1-25H184a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16h4.6L32.5,213.3a7.9,7.9,0,0,0,4.8,10.2,8.6,8.6,0,0,0,2.7.5,7.9,7.9,0,0,0,7.5-5.3L57.2,192h47l-7.7,21.3a7.9,7.9,0,0,0,4.8,10.2,8.6,8.6,0,0,0,2.7.5,7.9,7.9,0,0,0,7.5-5.3L130,168h52l18.5,50.7A7.9,7.9,0,0,0,208,224a8.6,8.6,0,0,0,2.7-.5A7.9,7.9,0,0,0,215.5,213.3Zm-88-85.3h-47L92.1,96h47Zm29.1-80-8.1,22.3h0L144.9,80H98l11.6-32ZM63.1,176l11.6-32h47L110,176Zm72.7-24L156,96.4,176.2,152Z" }, null, -1), rEn = [
  sEn
], iEn = { key: 3 }, lEn = ["stroke"], dEn = ["stroke"], kEn = ["stroke"], cEn = ["stroke"], hEn = ["stroke"], uEn = ["stroke"], aEn = ["stroke"], _En = ["stroke"], pEn = { key: 4 }, yEn = ["stroke"], $En = ["stroke"], wEn = ["stroke"], fEn = ["stroke"], gEn = ["stroke"], xEn = ["stroke"], jEn = ["stroke"], mEn = ["stroke"], MEn = { key: 5 }, vEn = ["stroke"], SEn = ["stroke"], HEn = ["stroke"], AEn = ["stroke"], VEn = ["stroke"], zEn = ["stroke"], ZEn = ["stroke"], CEn = ["stroke"], bEn = {
  name: "PhLadder"
}, cX1 = /* @__PURE__ */ $({
  ...bEn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", FGn, [
        e("line", {
          x1: "184",
          y1: "40",
          x2: "88",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TGn),
        e("line", {
          x1: "104",
          y1: "40",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DGn),
        e("line", {
          x1: "104",
          y1: "216",
          x2: "168",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RGn),
        e("line", {
          x1: "69.1",
          y1: "136",
          x2: "133.1",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, UGn),
        e("line", {
          x1: "86.5",
          y1: "88",
          x2: "150.5",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qGn),
        e("line", {
          x1: "51.6",
          y1: "184",
          x2: "115.6",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GGn),
        e("line", {
          x1: "156",
          y1: "73",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, EGn),
        e("line", {
          x1: "124.4",
          y1: "160",
          x2: "187.6",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OGn)
      ])) : o(i) === "duotone" ? (s(), r("g", IGn, [
        e("line", {
          x1: "184",
          y1: "40",
          x2: "88",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KGn),
        e("line", {
          x1: "104",
          y1: "40",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XGn),
        e("line", {
          x1: "104",
          y1: "216",
          x2: "168",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JGn),
        e("line", {
          x1: "69.1",
          y1: "136",
          x2: "133.1",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QGn),
        e("line", {
          x1: "86.5",
          y1: "88",
          x2: "150.5",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YGn),
        e("line", {
          x1: "51.6",
          y1: "184",
          x2: "115.6",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oEn),
        e("line", {
          x1: "156",
          y1: "73",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eEn),
        e("line", {
          x1: "124.4",
          y1: "160",
          x2: "187.6",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tEn)
      ])) : o(i) === "fill" ? (s(), r("g", nEn, rEn)) : o(i) === "light" ? (s(), r("g", iEn, [
        e("line", {
          x1: "184",
          y1: "40",
          x2: "88",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lEn),
        e("line", {
          x1: "104",
          y1: "40",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dEn),
        e("line", {
          x1: "104",
          y1: "216",
          x2: "168",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kEn),
        e("line", {
          x1: "69.1",
          y1: "136",
          x2: "133.1",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cEn),
        e("line", {
          x1: "86.5",
          y1: "88",
          x2: "150.5",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hEn),
        e("line", {
          x1: "51.6",
          y1: "184",
          x2: "115.6",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uEn),
        e("line", {
          x1: "156",
          y1: "73",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aEn),
        e("line", {
          x1: "124.4",
          y1: "160",
          x2: "187.6",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _En)
      ])) : o(i) === "thin" ? (s(), r("g", pEn, [
        e("line", {
          x1: "184",
          y1: "40",
          x2: "88",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yEn),
        e("line", {
          x1: "104",
          y1: "40",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $En),
        e("line", {
          x1: "104",
          y1: "216",
          x2: "168",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wEn),
        e("line", {
          x1: "69.1",
          y1: "136",
          x2: "133.1",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fEn),
        e("line", {
          x1: "86.5",
          y1: "88",
          x2: "150.5",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gEn),
        e("line", {
          x1: "51.6",
          y1: "184",
          x2: "115.6",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xEn),
        e("line", {
          x1: "156",
          y1: "73",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jEn),
        e("line", {
          x1: "124.4",
          y1: "160",
          x2: "187.6",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mEn)
      ])) : o(i) === "regular" ? (s(), r("g", MEn, [
        e("line", {
          x1: "184",
          y1: "40",
          x2: "88",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vEn),
        e("line", {
          x1: "104",
          y1: "40",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SEn),
        e("line", {
          x1: "104",
          y1: "216",
          x2: "168",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HEn),
        e("line", {
          x1: "69.1",
          y1: "136",
          x2: "133.1",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AEn),
        e("line", {
          x1: "86.5",
          y1: "88",
          x2: "150.5",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VEn),
        e("line", {
          x1: "51.6",
          y1: "184",
          x2: "115.6",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zEn),
        e("line", {
          x1: "156",
          y1: "73",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZEn),
        e("line", {
          x1: "124.4",
          y1: "160",
          x2: "187.6",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CEn)
      ])) : g("", !0)
    ], 16, NGn));
  }
}), LEn = ["width", "height", "fill", "transform"], BEn = { key: 0 }, PEn = ["stroke"], WEn = ["stroke"], NEn = ["stroke"], FEn = ["stroke"], TEn = ["stroke"], DEn = { key: 1 }, REn = ["stroke"], UEn = ["stroke"], qEn = ["stroke"], GEn = ["stroke"], EEn = ["stroke"], OEn = { key: 2 }, IEn = /* @__PURE__ */ e("path", { d: "M192,24a8,8,0,0,0-8,8V64H72V32a8,8,0,0,0-16,0V224a8,8,0,0,0,16,0V192H184v32a8,8,0,0,0,16,0V32A8,8,0,0,0,192,24Zm-8,56v40H72V80ZM72,176V136H184v40Z" }, null, -1), KEn = [
  IEn
], XEn = { key: 3 }, JEn = ["stroke"], QEn = ["stroke"], YEn = ["stroke"], oOn = ["stroke"], eOn = ["stroke"], tOn = { key: 4 }, nOn = ["stroke"], sOn = ["stroke"], rOn = ["stroke"], iOn = ["stroke"], lOn = ["stroke"], dOn = { key: 5 }, kOn = ["stroke"], cOn = ["stroke"], hOn = ["stroke"], uOn = ["stroke"], aOn = ["stroke"], _On = {
  name: "PhLadderSimple"
}, hX1 = /* @__PURE__ */ $({
  ..._On,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", BEn, [
        e("line", {
          x1: "64",
          y1: "32",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PEn),
        e("line", {
          x1: "192",
          y1: "32",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WEn),
        e("line", {
          x1: "64",
          y1: "72",
          x2: "192",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NEn),
        e("line", {
          x1: "64",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FEn),
        e("line", {
          x1: "64",
          y1: "184",
          x2: "192",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TEn)
      ])) : o(i) === "duotone" ? (s(), r("g", DEn, [
        e("line", {
          x1: "64",
          y1: "32",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, REn),
        e("line", {
          x1: "192",
          y1: "32",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UEn),
        e("line", {
          x1: "64",
          y1: "72",
          x2: "192",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qEn),
        e("line", {
          x1: "64",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GEn),
        e("line", {
          x1: "64",
          y1: "184",
          x2: "192",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EEn)
      ])) : o(i) === "fill" ? (s(), r("g", OEn, KEn)) : o(i) === "light" ? (s(), r("g", XEn, [
        e("line", {
          x1: "64",
          y1: "32",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JEn),
        e("line", {
          x1: "192",
          y1: "32",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QEn),
        e("line", {
          x1: "64",
          y1: "72",
          x2: "192",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YEn),
        e("line", {
          x1: "64",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oOn),
        e("line", {
          x1: "64",
          y1: "184",
          x2: "192",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eOn)
      ])) : o(i) === "thin" ? (s(), r("g", tOn, [
        e("line", {
          x1: "64",
          y1: "32",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nOn),
        e("line", {
          x1: "192",
          y1: "32",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sOn),
        e("line", {
          x1: "64",
          y1: "72",
          x2: "192",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rOn),
        e("line", {
          x1: "64",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iOn),
        e("line", {
          x1: "64",
          y1: "184",
          x2: "192",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lOn)
      ])) : o(i) === "regular" ? (s(), r("g", dOn, [
        e("line", {
          x1: "64",
          y1: "32",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kOn),
        e("line", {
          x1: "192",
          y1: "32",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cOn),
        e("line", {
          x1: "64",
          y1: "72",
          x2: "192",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hOn),
        e("line", {
          x1: "64",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uOn),
        e("line", {
          x1: "64",
          y1: "184",
          x2: "192",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aOn)
      ])) : g("", !0)
    ], 16, LEn));
  }
}), pOn = ["width", "height", "fill", "transform"], yOn = { key: 0 }, $On = ["stroke"], wOn = ["stroke"], fOn = ["stroke"], gOn = ["stroke"], xOn = { key: 1 }, jOn = /* @__PURE__ */ e("path", {
  d: "M69.3,40H186.7a8.1,8.1,0,0,1,7.4,4.8l41.1,96a8,8,0,0,1-7.3,11.2H28.1a8,8,0,0,1-7.3-11.2l41.1-96A8.1,8.1,0,0,1,69.3,40Z",
  opacity: "0.2"
}, null, -1), mOn = ["stroke"], MOn = ["stroke"], vOn = ["stroke"], SOn = ["stroke"], HOn = { key: 2 }, AOn = /* @__PURE__ */ e("path", { d: "M241.2,152.8a15.8,15.8,0,0,1-13.3,7.2H208v32a8,8,0,0,1-16,0V160H136v48h24a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16h24V160H28.1a16.1,16.1,0,0,1-14.7-22.3l41.2-96A15.9,15.9,0,0,1,69.3,32H186.7a15.9,15.9,0,0,1,14.7,9.7l41.2,96A15.9,15.9,0,0,1,241.2,152.8Z" }, null, -1), VOn = [
  AOn
], zOn = { key: 3 }, ZOn = ["stroke"], COn = ["stroke"], bOn = ["stroke"], LOn = ["stroke"], BOn = { key: 4 }, POn = ["stroke"], WOn = ["stroke"], NOn = ["stroke"], FOn = ["stroke"], TOn = { key: 5 }, DOn = ["stroke"], ROn = ["stroke"], UOn = ["stroke"], qOn = ["stroke"], GOn = {
  name: "PhLamp"
}, uX1 = /* @__PURE__ */ $({
  ...GOn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", yOn, [
        e("path", {
          d: "M69.3,40H186.7a8.1,8.1,0,0,1,7.4,4.8l41.1,96a8,8,0,0,1-7.3,11.2H28.1a8,8,0,0,1-7.3-11.2l41.1-96A8.1,8.1,0,0,1,69.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $On),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wOn),
        e("line", {
          x1: "96",
          y1: "216",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fOn),
        e("line", {
          x1: "200",
          y1: "152",
          x2: "200",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gOn)
      ])) : o(i) === "duotone" ? (s(), r("g", xOn, [
        jOn,
        e("path", {
          d: "M69.3,40H186.7a8.1,8.1,0,0,1,7.4,4.8l41.1,96a8,8,0,0,1-7.3,11.2H28.1a8,8,0,0,1-7.3-11.2l41.1-96A8.1,8.1,0,0,1,69.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mOn),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MOn),
        e("line", {
          x1: "96",
          y1: "216",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vOn),
        e("line", {
          x1: "200",
          y1: "152",
          x2: "200",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SOn)
      ])) : o(i) === "fill" ? (s(), r("g", HOn, VOn)) : o(i) === "light" ? (s(), r("g", zOn, [
        e("path", {
          d: "M69.3,40H186.7a8.1,8.1,0,0,1,7.4,4.8l41.1,96a8,8,0,0,1-7.3,11.2H28.1a8,8,0,0,1-7.3-11.2l41.1-96A8.1,8.1,0,0,1,69.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZOn),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, COn),
        e("line", {
          x1: "96",
          y1: "216",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bOn),
        e("line", {
          x1: "200",
          y1: "152",
          x2: "200",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LOn)
      ])) : o(i) === "thin" ? (s(), r("g", BOn, [
        e("path", {
          d: "M69.3,40H186.7a8.1,8.1,0,0,1,7.4,4.8l41.1,96a8,8,0,0,1-7.3,11.2H28.1a8,8,0,0,1-7.3-11.2l41.1-96A8.1,8.1,0,0,1,69.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, POn),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WOn),
        e("line", {
          x1: "96",
          y1: "216",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, NOn),
        e("line", {
          x1: "200",
          y1: "152",
          x2: "200",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FOn)
      ])) : o(i) === "regular" ? (s(), r("g", TOn, [
        e("path", {
          d: "M69.3,40H186.7a8.1,8.1,0,0,1,7.4,4.8l41.1,96a8,8,0,0,1-7.3,11.2H28.1a8,8,0,0,1-7.3-11.2l41.1-96A8.1,8.1,0,0,1,69.3,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DOn),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ROn),
        e("line", {
          x1: "96",
          y1: "216",
          x2: "160",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UOn),
        e("line", {
          x1: "200",
          y1: "152",
          x2: "200",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qOn)
      ])) : g("", !0)
    ], 16, pOn));
  }
}), EOn = ["width", "height", "fill", "transform"], OOn = { key: 0 }, IOn = ["stroke"], KOn = ["stroke"], XOn = ["stroke"], JOn = { key: 1 }, QOn = /* @__PURE__ */ e("path", {
  d: "M40,176V72A16,16,0,0,1,56,56H200a16,16,0,0,1,16,16V176Z",
  opacity: "0.2"
}, null, -1), YOn = ["stroke"], oIn = ["stroke"], eIn = ["stroke"], tIn = { key: 2 }, nIn = /* @__PURE__ */ e("path", { d: "M232,168h-8V72a24.1,24.1,0,0,0-24-24H56A24.1,24.1,0,0,0,32,72v96H24a8,8,0,0,0-8,8v16a24.1,24.1,0,0,0,24,24H216a24.1,24.1,0,0,0,24-24V176A8,8,0,0,0,232,168ZM112,72h32a8,8,0,0,1,0,16H112a8,8,0,0,1,0-16ZM224,192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8v-8H224Z" }, null, -1), sIn = [
  nIn
], rIn = { key: 3 }, iIn = ["stroke"], lIn = ["stroke"], dIn = ["stroke"], kIn = { key: 4 }, cIn = ["stroke"], hIn = ["stroke"], uIn = ["stroke"], aIn = { key: 5 }, _In = ["stroke"], pIn = ["stroke"], yIn = ["stroke"], $In = {
  name: "PhLaptop"
}, aX1 = /* @__PURE__ */ $({
  ...$In,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", OOn, [
        e("path", {
          d: "M40,168V72A16,16,0,0,1,56,56H200a16,16,0,0,1,16,16v96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IOn),
        e("path", {
          d: "M24,168H232a0,0,0,0,1,0,0v24a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V168a0,0,0,0,1,0,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KOn),
        e("line", {
          x1: "144",
          y1: "96",
          x2: "112",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XOn)
      ])) : o(i) === "duotone" ? (s(), r("g", JOn, [
        QOn,
        e("path", {
          d: "M40,176V72A16,16,0,0,1,56,56H200a16,16,0,0,1,16,16V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YOn),
        e("path", {
          d: "M24,176H232a0,0,0,0,1,0,0v16a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V176A0,0,0,0,1,24,176Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oIn),
        e("line", {
          x1: "144",
          y1: "88",
          x2: "112",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eIn)
      ])) : o(i) === "fill" ? (s(), r("g", tIn, sIn)) : o(i) === "light" ? (s(), r("g", rIn, [
        e("path", {
          d: "M40,176V72A16,16,0,0,1,56,56H200a16,16,0,0,1,16,16V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iIn),
        e("path", {
          d: "M24,176H232a0,0,0,0,1,0,0v16a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V176A0,0,0,0,1,24,176Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lIn),
        e("line", {
          x1: "144",
          y1: "88",
          x2: "112",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dIn)
      ])) : o(i) === "thin" ? (s(), r("g", kIn, [
        e("path", {
          d: "M40,176V72A16,16,0,0,1,56,56H200a16,16,0,0,1,16,16V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cIn),
        e("path", {
          d: "M24,176H232a0,0,0,0,1,0,0v16a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V176A0,0,0,0,1,24,176Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hIn),
        e("line", {
          x1: "144",
          y1: "88",
          x2: "112",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uIn)
      ])) : o(i) === "regular" ? (s(), r("g", aIn, [
        e("path", {
          d: "M40,176V72A16,16,0,0,1,56,56H200a16,16,0,0,1,16,16V176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _In),
        e("path", {
          d: "M24,176H232a0,0,0,0,1,0,0v16a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V176A0,0,0,0,1,24,176Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pIn),
        e("line", {
          x1: "144",
          y1: "88",
          x2: "112",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yIn)
      ])) : g("", !0)
    ], 16, EOn));
  }
}), wIn = ["width", "height", "fill", "transform"], fIn = { key: 0 }, gIn = ["stroke"], xIn = ["stroke"], jIn = ["stroke"], mIn = { key: 1 }, MIn = /* @__PURE__ */ e("path", {
  d: "M104,208V104H32v96a8,8,0,0,0,8,8H96",
  opacity: "0.2"
}, null, -1), vIn = ["stroke"], SIn = ["stroke"], HIn = ["stroke"], AIn = { key: 2 }, VIn = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM40,56H216V96H40ZM216,200H112V112H216v88Z" }, null, -1), zIn = [
  VIn
], ZIn = { key: 3 }, CIn = ["stroke"], bIn = ["stroke"], LIn = ["stroke"], BIn = { key: 4 }, PIn = ["stroke"], WIn = ["stroke"], NIn = ["stroke"], FIn = { key: 5 }, TIn = ["stroke"], DIn = ["stroke"], RIn = ["stroke"], UIn = {
  name: "PhLayout"
}, _X1 = /* @__PURE__ */ $({
  ...UIn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", fIn, [
        e("line", {
          x1: "104",
          y1: "104",
          x2: "104",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gIn),
        e("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xIn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jIn)
      ])) : o(i) === "duotone" ? (s(), r("g", mIn, [
        MIn,
        e("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vIn),
        e("line", {
          x1: "104",
          y1: "104",
          x2: "104",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SIn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HIn)
      ])) : o(i) === "fill" ? (s(), r("g", AIn, zIn)) : o(i) === "light" ? (s(), r("g", ZIn, [
        e("line", {
          x1: "104",
          y1: "104",
          x2: "104",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, CIn),
        e("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bIn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LIn)
      ])) : o(i) === "thin" ? (s(), r("g", BIn, [
        e("line", {
          x1: "104",
          y1: "104",
          x2: "104",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PIn),
        e("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WIn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, NIn)
      ])) : o(i) === "regular" ? (s(), r("g", FIn, [
        e("line", {
          x1: "104",
          y1: "104",
          x2: "104",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TIn),
        e("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DIn),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RIn)
      ])) : g("", !0)
    ], 16, wIn));
  }
}), qIn = ["width", "height", "fill", "transform"], GIn = { key: 0 }, EIn = ["stroke"], OIn = ["stroke"], IIn = { key: 1 }, KIn = /* @__PURE__ */ e("path", {
  d: "M64,192C16,112,80,32,216,40,224,176,144,240,64,192Z",
  opacity: "0.2"
}, null, -1), XIn = ["stroke"], JIn = ["stroke"], QIn = { key: 2 }, YIn = /* @__PURE__ */ e("path", { d: "M224,39.5a8.1,8.1,0,0,0-7.5-7.5C140.2,27.5,79.1,50.5,53,93.6a87.3,87.3,0,0,0-12.8,49.1c.6,15.9,5.2,32.1,13.8,48L154.3,90.3a8.1,8.1,0,0,1,11.4,11.4L65.3,202c15.9,8.6,32.1,13.2,48,13.8h3.3A87,87,0,0,0,162.4,203C205.5,176.9,228.5,115.8,224,39.5Z" }, null, -1), oKn = /* @__PURE__ */ e("path", { d: "M57.1,196.1c-1.1-1.8-2.1-3.6-3.1-5.4L34.3,210.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L65.3,202l-5.4-3.1A9.3,9.3,0,0,1,57.1,196.1Z" }, null, -1), eKn = [
  YIn,
  oKn
], tKn = { key: 3 }, nKn = ["stroke"], sKn = ["stroke"], rKn = { key: 4 }, iKn = ["stroke"], lKn = ["stroke"], dKn = { key: 5 }, kKn = ["stroke"], cKn = ["stroke"], hKn = {
  name: "PhLeaf"
}, pX1 = /* @__PURE__ */ $({
  ...hKn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", GIn, [
        e("line", {
          x1: "160",
          y1: "96",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, EIn),
        e("path", {
          d: "M64,192C16,112,80,32,216,40,224,176,144,240,64,192Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OIn)
      ])) : o(i) === "duotone" ? (s(), r("g", IIn, [
        KIn,
        e("line", {
          x1: "160",
          y1: "96",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XIn),
        e("path", {
          d: "M64,192C16,112,80,32,216,40,224,176,144,240,64,192Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JIn)
      ])) : o(i) === "fill" ? (s(), r("g", QIn, eKn)) : o(i) === "light" ? (s(), r("g", tKn, [
        e("line", {
          x1: "160",
          y1: "96",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nKn),
        e("path", {
          d: "M64,192C16,112,80,32,216,40,224,176,144,240,64,192Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sKn)
      ])) : o(i) === "thin" ? (s(), r("g", rKn, [
        e("line", {
          x1: "160",
          y1: "96",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iKn),
        e("path", {
          d: "M64,192C16,112,80,32,216,40,224,176,144,240,64,192Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lKn)
      ])) : o(i) === "regular" ? (s(), r("g", dKn, [
        e("line", {
          x1: "160",
          y1: "96",
          x2: "40",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kKn),
        e("path", {
          d: "M64,192C16,112,80,32,216,40,224,176,144,240,64,192Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cKn)
      ])) : g("", !0)
    ], 16, qIn));
  }
}), uKn = ["width", "height", "fill", "transform"], aKn = { key: 0 }, _Kn = ["stroke"], pKn = ["stroke"], yKn = ["stroke"], $Kn = ["stroke"], wKn = ["stroke"], fKn = ["stroke"], gKn = { key: 1 }, xKn = /* @__PURE__ */ e("path", {
  d: "M195.9,60.1a96,96,0,0,1,0,135.8l-39.6-39.6a40.1,40.1,0,0,0,0-56.6Z",
  opacity: "0.2"
}, null, -1), jKn = /* @__PURE__ */ e("path", {
  d: "M60.1,195.9a96,96,0,0,1,0-135.8L99.7,99.7a40.1,40.1,0,0,0,0,56.6Z",
  opacity: "0.2"
}, null, -1), mKn = ["stroke"], MKn = ["stroke"], vKn = ["stroke"], SKn = ["stroke"], HKn = ["stroke"], AKn = ["stroke"], VKn = { key: 2 }, zKn = /* @__PURE__ */ e("path", { d: "M202.2,200.8a103.8,103.8,0,0,0,0-145.6,2.3,2.3,0,0,0-.7-.7,2.3,2.3,0,0,0-.7-.7,103.8,103.8,0,0,0-145.6,0,2.3,2.3,0,0,0-.7.7,2.3,2.3,0,0,0-.7.7,103.8,103.8,0,0,0,0,145.6l.7.7a2.3,2.3,0,0,0,.7.7,103.8,103.8,0,0,0,145.6,0,2.3,2.3,0,0,0,.7-.7A2.3,2.3,0,0,0,202.2,200.8ZM96,128a32,32,0,1,1,32,32A32.1,32.1,0,0,1,96,128Zm88.3-67.6L155.8,88.9a47.9,47.9,0,0,0-55.6,0L71.7,60.4a87.9,87.9,0,0,1,112.6,0ZM71.7,195.6l28.5-28.5a47.9,47.9,0,0,0,55.6,0l28.5,28.5a87.9,87.9,0,0,1-112.6,0Z" }, null, -1), ZKn = [
  zKn
], CKn = { key: 3 }, bKn = ["stroke"], LKn = ["stroke"], BKn = ["stroke"], PKn = ["stroke"], WKn = ["stroke"], NKn = ["stroke"], FKn = { key: 4 }, TKn = ["stroke"], DKn = ["stroke"], RKn = ["stroke"], UKn = ["stroke"], qKn = ["stroke"], GKn = ["stroke"], EKn = { key: 5 }, OKn = ["stroke"], IKn = ["stroke"], KKn = ["stroke"], XKn = ["stroke"], JKn = ["stroke"], QKn = ["stroke"], YKn = {
  name: "PhLifebuoy"
}, yX1 = /* @__PURE__ */ $({
  ...YKn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", aKn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Kn),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pKn),
        e("line", {
          x1: "99.7",
          y1: "99.7",
          x2: "60.1",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yKn),
        e("line", {
          x1: "156.3",
          y1: "99.7",
          x2: "195.9",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $Kn),
        e("line", {
          x1: "156.3",
          y1: "156.3",
          x2: "195.9",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wKn),
        e("line", {
          x1: "99.7",
          y1: "156.3",
          x2: "60.1",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fKn)
      ])) : o(i) === "duotone" ? (s(), r("g", gKn, [
        xKn,
        jKn,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mKn),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MKn),
        e("line", {
          x1: "99.7",
          y1: "99.7",
          x2: "60.1",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vKn),
        e("line", {
          x1: "156.3",
          y1: "99.7",
          x2: "195.9",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SKn),
        e("line", {
          x1: "156.3",
          y1: "156.3",
          x2: "195.9",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HKn),
        e("line", {
          x1: "99.7",
          y1: "156.3",
          x2: "60.1",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AKn)
      ])) : o(i) === "fill" ? (s(), r("g", VKn, ZKn)) : o(i) === "light" ? (s(), r("g", CKn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bKn),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LKn),
        e("line", {
          x1: "99.7",
          y1: "99.7",
          x2: "60.1",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BKn),
        e("line", {
          x1: "156.3",
          y1: "99.7",
          x2: "195.9",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PKn),
        e("line", {
          x1: "156.3",
          y1: "156.3",
          x2: "195.9",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WKn),
        e("line", {
          x1: "99.7",
          y1: "156.3",
          x2: "60.1",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, NKn)
      ])) : o(i) === "thin" ? (s(), r("g", FKn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, TKn),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, DKn),
        e("line", {
          x1: "99.7",
          y1: "99.7",
          x2: "60.1",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RKn),
        e("line", {
          x1: "156.3",
          y1: "99.7",
          x2: "195.9",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, UKn),
        e("line", {
          x1: "156.3",
          y1: "156.3",
          x2: "195.9",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qKn),
        e("line", {
          x1: "99.7",
          y1: "156.3",
          x2: "60.1",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GKn)
      ])) : o(i) === "regular" ? (s(), r("g", EKn, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OKn),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IKn),
        e("line", {
          x1: "99.7",
          y1: "99.7",
          x2: "60.1",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KKn),
        e("line", {
          x1: "156.3",
          y1: "99.7",
          x2: "195.9",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XKn),
        e("line", {
          x1: "156.3",
          y1: "156.3",
          x2: "195.9",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JKn),
        e("line", {
          x1: "99.7",
          y1: "156.3",
          x2: "60.1",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QKn)
      ])) : g("", !0)
    ], 16, uKn));
  }
}), oXn = ["width", "height", "fill", "transform"], eXn = { key: 0 }, tXn = ["stroke"], nXn = ["stroke"], sXn = ["stroke"], rXn = { key: 1 }, iXn = /* @__PURE__ */ e("path", {
  d: "M78.7,167A79.5,79.5,0,0,1,48,104.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,51.3,142.9A24.2,24.2,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6A24.4,24.4,0,0,0,78.7,167Z",
  opacity: "0.2"
}, null, -1), lXn = ["stroke"], dXn = ["stroke"], kXn = ["stroke"], cXn = { key: 2 }, hXn = /* @__PURE__ */ e("path", { d: "M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.7,87.7,0,0,1-33.6,69.2A16.1,16.1,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16.2,16.2,0,0,0-6.2-12.7A87.8,87.8,0,0,1,40,104.5C39.7,56.8,78.3,17.1,125.9,16A87.9,87.9,0,0,1,216,104Zm-32.8-9.4a55.8,55.8,0,0,0-45.8-45.7,8,8,0,1,0-2.6,15.8,39.7,39.7,0,0,1,32.6,32.6,8,8,0,0,0,7.9,6.6h1.4A7.9,7.9,0,0,0,183.2,94.6Z" }, null, -1), uXn = [
  hXn
], aXn = { key: 3 }, _Xn = ["stroke"], pXn = ["stroke"], yXn = ["stroke"], $Xn = { key: 4 }, wXn = ["stroke"], fXn = ["stroke"], gXn = ["stroke"], xXn = { key: 5 }, jXn = ["stroke"], mXn = ["stroke"], MXn = ["stroke"], vXn = {
  name: "PhLightbulb"
}, $X1 = /* @__PURE__ */ $({
  ...vXn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", eXn, [
        e("line", {
          x1: "88",
          y1: "232",
          x2: "168",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tXn),
        e("path", {
          d: "M80,168a79.8,79.8,0,0,1-32-63.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,49.7,144.1A20,20,0,0,0,168,184h0a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-.2A19.6,19.6,0,0,0,80,168Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nXn),
        e("path", {
          d: "M163.1,96A35.8,35.8,0,0,0,136,68.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sXn)
      ])) : o(i) === "duotone" ? (s(), r("g", rXn, [
        iXn,
        e("line", {
          x1: "88",
          y1: "232",
          x2: "168",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lXn),
        e("path", {
          d: "M78.7,167A79.5,79.5,0,0,1,48,104.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,51.3,142.9A24.2,24.2,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6A24.4,24.4,0,0,0,78.7,167Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dXn),
        e("path", {
          d: "M136.1,56.8a47.9,47.9,0,0,1,39.2,39.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kXn)
      ])) : o(i) === "fill" ? (s(), r("g", cXn, uXn)) : o(i) === "light" ? (s(), r("g", aXn, [
        e("line", {
          x1: "88",
          y1: "232",
          x2: "168",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _Xn),
        e("path", {
          d: "M78.7,167A79.5,79.5,0,0,1,48,104.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,51.3,142.9A24.2,24.2,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6A24.4,24.4,0,0,0,78.7,167Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pXn),
        e("path", {
          d: "M136.1,56.8a47.9,47.9,0,0,1,39.2,39.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yXn)
      ])) : o(i) === "thin" ? (s(), r("g", $Xn, [
        e("line", {
          x1: "88",
          y1: "232",
          x2: "168",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wXn),
        e("path", {
          d: "M78.7,167A79.5,79.5,0,0,1,48,104.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,51.3,142.9A24.2,24.2,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6A24.4,24.4,0,0,0,78.7,167Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fXn),
        e("path", {
          d: "M136.1,56.8a47.9,47.9,0,0,1,39.2,39.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gXn)
      ])) : o(i) === "regular" ? (s(), r("g", xXn, [
        e("line", {
          x1: "88",
          y1: "232",
          x2: "168",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jXn),
        e("path", {
          d: "M78.7,167A79.5,79.5,0,0,1,48,104.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,51.3,142.9A24.2,24.2,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6A24.4,24.4,0,0,0,78.7,167Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mXn),
        e("path", {
          d: "M136.1,56.8a47.9,47.9,0,0,1,39.2,39.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MXn)
      ])) : g("", !0)
    ], 16, oXn));
  }
}), SXn = ["width", "height", "fill", "transform"], HXn = { key: 0 }, AXn = ["stroke"], VXn = ["stroke"], zXn = ["stroke"], ZXn = ["stroke"], CXn = { key: 1 }, bXn = /* @__PURE__ */ e("path", {
  d: "M78.7,167A79.5,79.5,0,0,1,48,104.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,51.3,142.9A24.2,24.2,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6A24.4,24.4,0,0,0,78.7,167Z",
  opacity: "0.2"
}, null, -1), LXn = ["stroke"], BXn = ["stroke"], PXn = ["stroke"], WXn = ["stroke"], NXn = { key: 2 }, FXn = /* @__PURE__ */ e("path", { d: "M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.7,87.7,0,0,1-33.6,69.2A16.1,16.1,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16.2,16.2,0,0,0-6.2-12.7A87.8,87.8,0,0,1,40,104.5C39.7,56.8,78.3,17.1,125.9,16A87.9,87.9,0,0,1,216,104Zm-50.3,2.3a8.1,8.1,0,0,0-11.4,0L128,132.7l-26.3-26.4a8.1,8.1,0,0,0-11.4,11.4L120,147.3V184a8,8,0,0,0,16,0V147.3l29.7-29.6A8.1,8.1,0,0,0,165.7,106.3Z" }, null, -1), TXn = [
  FXn
], DXn = { key: 3 }, RXn = ["stroke"], UXn = ["stroke"], qXn = ["stroke"], GXn = ["stroke"], EXn = { key: 4 }, OXn = ["stroke"], IXn = ["stroke"], KXn = ["stroke"], XXn = ["stroke"], JXn = { key: 5 }, QXn = ["stroke"], YXn = ["stroke"], oJn = ["stroke"], eJn = ["stroke"], tJn = {
  name: "PhLightbulbFilament"
}, wX1 = /* @__PURE__ */ $({
  ...tJn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", HXn, [
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, AXn),
        e("polyline", {
          points: "96 112 128 144 160 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VXn),
        e("line", {
          x1: "88",
          y1: "232",
          x2: "168",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zXn),
        e("path", {
          d: "M80,168a79.8,79.8,0,0,1-32-63.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,49.7,144.1A20,20,0,0,0,168,184h0a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-.2A19.6,19.6,0,0,0,80,168Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZXn)
      ])) : o(i) === "duotone" ? (s(), r("g", CXn, [
        bXn,
        e("line", {
          x1: "88",
          y1: "232",
          x2: "168",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LXn),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BXn),
        e("polyline", {
          points: "96 112 128 144 160 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PXn),
        e("path", {
          d: "M78.7,167A79.5,79.5,0,0,1,48,104.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,51.3,142.9A24.2,24.2,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6A24.4,24.4,0,0,0,78.7,167Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WXn)
      ])) : o(i) === "fill" ? (s(), r("g", NXn, TXn)) : o(i) === "light" ? (s(), r("g", DXn, [
        e("line", {
          x1: "88",
          y1: "232",
          x2: "168",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RXn),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UXn),
        e("polyline", {
          points: "96 112 128 144 160 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qXn),
        e("path", {
          d: "M78.7,167A79.5,79.5,0,0,1,48,104.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,51.3,142.9A24.2,24.2,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6A24.4,24.4,0,0,0,78.7,167Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GXn)
      ])) : o(i) === "thin" ? (s(), r("g", EXn, [
        e("line", {
          x1: "88",
          y1: "232",
          x2: "168",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OXn),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, IXn),
        e("polyline", {
          points: "96 112 128 144 160 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KXn),
        e("path", {
          d: "M78.7,167A79.5,79.5,0,0,1,48,104.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,51.3,142.9A24.2,24.2,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6A24.4,24.4,0,0,0,78.7,167Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XXn)
      ])) : o(i) === "regular" ? (s(), r("g", JXn, [
        e("line", {
          x1: "88",
          y1: "232",
          x2: "168",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QXn),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YXn),
        e("polyline", {
          points: "96 112 128 144 160 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oJn),
        e("path", {
          d: "M78.7,167A79.5,79.5,0,0,1,48,104.5C47.8,61.1,82.7,25,126.1,24a80,80,0,0,1,51.3,142.9A24.2,24.2,0,0,0,168,186v6a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8v-6A24.4,24.4,0,0,0,78.7,167Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eJn)
      ])) : g("", !0)
    ], 16, SXn));
  }
}), nJn = ["width", "height", "fill", "transform"], sJn = { key: 0 }, rJn = ["stroke"], iJn = { key: 1 }, lJn = /* @__PURE__ */ e("polygon", {
  points: "96 240 112 160 48 136 160 16 144 96 208 120 96 240",
  opacity: "0.2"
}, null, -1), dJn = ["stroke"], kJn = { key: 2 }, cJn = /* @__PURE__ */ e("path", { d: "M215.8,118.2a8,8,0,0,0-5-5.7L153.2,90.9l14.6-73.3a8.1,8.1,0,0,0-4.1-8.7,7.9,7.9,0,0,0-9.5,1.6l-112,120a7.9,7.9,0,0,0-2,7.3,8.2,8.2,0,0,0,5,5.7l57.6,21.6L88.2,238.4a8.1,8.1,0,0,0,4.1,8.7,8.4,8.4,0,0,0,3.7.9,7.9,7.9,0,0,0,5.8-2.5l112-120A7.9,7.9,0,0,0,215.8,118.2Z" }, null, -1), hJn = [
  cJn
], uJn = { key: 3 }, aJn = ["stroke"], _Jn = { key: 4 }, pJn = ["stroke"], yJn = { key: 5 }, $Jn = ["stroke"], wJn = {
  name: "PhLightning"
}, fX1 = /* @__PURE__ */ $({
  ...wJn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", sJn, [
        e("polygon", {
          points: "96 240 112 160 48 136 160 16 144 96 208 120 96 240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rJn)
      ])) : o(i) === "duotone" ? (s(), r("g", iJn, [
        lJn,
        e("polygon", {
          points: "96 240 112 160 48 136 160 16 144 96 208 120 96 240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dJn)
      ])) : o(i) === "fill" ? (s(), r("g", kJn, hJn)) : o(i) === "light" ? (s(), r("g", uJn, [
        e("polygon", {
          points: "96 240 112 160 48 136 160 16 144 96 208 120 96 240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aJn)
      ])) : o(i) === "thin" ? (s(), r("g", _Jn, [
        e("polygon", {
          points: "96 240 112 160 48 136 160 16 144 96 208 120 96 240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pJn)
      ])) : o(i) === "regular" ? (s(), r("g", yJn, [
        e("polygon", {
          points: "96 240 112 160 48 136 160 16 144 96 208 120 96 240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Jn)
      ])) : g("", !0)
    ], 16, nJn));
  }
}), fJn = ["width", "height", "fill", "transform"], gJn = { key: 0 }, xJn = ["stroke"], jJn = ["stroke"], mJn = ["stroke"], MJn = { key: 1 }, vJn = /* @__PURE__ */ e("polygon", {
  points: "96 240 112 160 48 136 160 16 144 96 208 120 96 240",
  opacity: "0.2"
}, null, -1), SJn = ["stroke"], HJn = ["stroke"], AJn = ["stroke"], VJn = { key: 2 }, zJn = /* @__PURE__ */ e("path", { d: "M53.9,34.6A8,8,0,0,0,42.1,45.4L81.3,88.5l-39.1,42a7.9,7.9,0,0,0-2,7.3,8.2,8.2,0,0,0,5,5.7l57.6,21.6L88.2,238.4a8.1,8.1,0,0,0,4.1,8.7,8.4,8.4,0,0,0,3.7.9,7.7,7.7,0,0,0,5.8-2.6l61.9-66.2,38.4,42.2A8,8,0,0,0,208,224a8.2,8.2,0,0,0,5.4-2.1,7.9,7.9,0,0,0,.5-11.3Z" }, null, -1), ZJn = /* @__PURE__ */ e("path", { d: "M179.8,149.3a8,8,0,0,0,5.8,2.6h.1a7.7,7.7,0,0,0,5.8-2.6l22.3-23.9a7.9,7.9,0,0,0-3-12.9L153.2,90.9l14.6-73.4a8,8,0,0,0-13.6-7L108.3,59.7a7.9,7.9,0,0,0-.1,10.8Z" }, null, -1), CJn = [
  zJn,
  ZJn
], bJn = { key: 3 }, LJn = ["stroke"], BJn = ["stroke"], PJn = ["stroke"], WJn = { key: 4 }, NJn = ["stroke"], FJn = ["stroke"], TJn = ["stroke"], DJn = { key: 5 }, RJn = ["stroke"], UJn = ["stroke"], qJn = ["stroke"], GJn = {
  name: "PhLightningSlash"
}, gX1 = /* @__PURE__ */ $({
  ...GJn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", gJn, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xJn),
        e("polyline", {
          points: "163.8 167.4 96 240 112 160 48 136 92.2 88.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jJn),
        e("polyline", {
          points: "119.6 59.3 160 16 144 96 208 120 191.2 138",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mJn)
      ])) : o(i) === "duotone" ? (s(), r("g", MJn, [
        vJn,
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SJn),
        e("polyline", {
          points: "163.8 167.4 96 240 112 160 48 136 92.2 88.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HJn),
        e("polyline", {
          points: "114.1 65.1 160 16 144 96 208 120 185.7 143.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AJn)
      ])) : o(i) === "fill" ? (s(), r("g", VJn, CJn)) : o(i) === "light" ? (s(), r("g", bJn, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LJn),
        e("polyline", {
          points: "163.8 167.4 96 240 112 160 48 136 92.2 88.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BJn),
        e("polyline", {
          points: "114.1 65.1 160 16 144 96 208 120 185.7 143.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PJn)
      ])) : o(i) === "thin" ? (s(), r("g", WJn, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, NJn),
        e("polyline", {
          points: "163.8 167.4 96 240 112 160 48 136 92.2 88.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FJn),
        e("polyline", {
          points: "114.1 65.1 160 16 144 96 208 120 185.7 143.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, TJn)
      ])) : o(i) === "regular" ? (s(), r("g", DJn, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RJn),
        e("polyline", {
          points: "163.8 167.4 96 240 112 160 48 136 92.2 88.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UJn),
        e("polyline", {
          points: "114.1 65.1 160 16 144 96 208 120 185.7 143.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qJn)
      ])) : g("", !0)
    ], 16, fJn));
  }
}), EJn = ["width", "height", "fill", "transform"], OJn = { key: 0 }, IJn = ["stroke"], KJn = ["stroke"], XJn = ["stroke"], JJn = { key: 1 }, QJn = /* @__PURE__ */ e("circle", {
  cx: "64",
  cy: "192",
  r: "24",
  opacity: "0.2"
}, null, -1), YJn = /* @__PURE__ */ e("circle", {
  cx: "192",
  cy: "64",
  r: "24",
  opacity: "0.2"
}, null, -1), oQn = ["stroke"], eQn = ["stroke"], tQn = ["stroke"], nQn = { key: 2 }, sQn = /* @__PURE__ */ e("path", { d: "M214.6,86.6A31.6,31.6,0,0,1,192,96a32.7,32.7,0,0,1-16.3-4.4L91.6,175.7a32,32,0,0,1-5,38.9,31.9,31.9,0,0,1-45.2,0,31.9,31.9,0,0,1,0-45.2h0a32,32,0,0,1,38.9-5l84.1-84.1a32,32,0,1,1,50.2,6.3Z" }, null, -1), rQn = [
  sQn
], iQn = { key: 3 }, lQn = ["stroke"], dQn = ["stroke"], kQn = ["stroke"], cQn = { key: 4 }, hQn = ["stroke"], uQn = ["stroke"], aQn = ["stroke"], _Qn = { key: 5 }, pQn = ["stroke"], yQn = ["stroke"], $Qn = ["stroke"], wQn = {
  name: "PhLineSegment"
}, xX1 = /* @__PURE__ */ $({
  ...wQn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", OJn, [
        e("circle", {
          cx: "64",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IJn),
        e("circle", {
          cx: "192",
          cy: "64",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KJn),
        e("line", {
          x1: "175",
          y1: "81",
          x2: "81",
          y2: "175",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XJn)
      ])) : o(i) === "duotone" ? (s(), r("g", JJn, [
        QJn,
        YJn,
        e("circle", {
          cx: "64",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oQn),
        e("circle", {
          cx: "192",
          cy: "64",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eQn),
        e("line", {
          x1: "175",
          y1: "81",
          x2: "81",
          y2: "175",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tQn)
      ])) : o(i) === "fill" ? (s(), r("g", nQn, rQn)) : o(i) === "light" ? (s(), r("g", iQn, [
        e("circle", {
          cx: "64",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lQn),
        e("circle", {
          cx: "192",
          cy: "64",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dQn),
        e("line", {
          x1: "175",
          y1: "81",
          x2: "81",
          y2: "175",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kQn)
      ])) : o(i) === "thin" ? (s(), r("g", cQn, [
        e("circle", {
          cx: "64",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hQn),
        e("circle", {
          cx: "192",
          cy: "64",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uQn),
        e("line", {
          x1: "175",
          y1: "81",
          x2: "81",
          y2: "175",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aQn)
      ])) : o(i) === "regular" ? (s(), r("g", _Qn, [
        e("circle", {
          cx: "64",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pQn),
        e("circle", {
          cx: "192",
          cy: "64",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yQn),
        e("line", {
          x1: "175",
          y1: "81",
          x2: "81",
          y2: "175",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Qn)
      ])) : g("", !0)
    ], 16, EJn));
  }
}), fQn = ["width", "height", "fill", "transform"], gQn = { key: 0 }, xQn = ["stroke"], jQn = ["stroke"], mQn = ["stroke"], MQn = ["stroke"], vQn = ["stroke"], SQn = ["stroke"], HQn = ["stroke"], AQn = { key: 1 }, VQn = /* @__PURE__ */ e("circle", {
  cx: "40",
  cy: "200",
  r: "24",
  opacity: "0.2"
}, null, -1), zQn = /* @__PURE__ */ e("circle", {
  cx: "96",
  cy: "96",
  r: "24",
  opacity: "0.2"
}, null, -1), ZQn = /* @__PURE__ */ e("circle", {
  cx: "160",
  cy: "160",
  r: "24",
  opacity: "0.2"
}, null, -1), CQn = /* @__PURE__ */ e("circle", {
  cx: "216",
  cy: "56",
  r: "24",
  opacity: "0.2"
}, null, -1), bQn = ["stroke"], LQn = ["stroke"], BQn = ["stroke"], PQn = ["stroke"], WQn = ["stroke"], NQn = ["stroke"], FQn = ["stroke"], TQn = { key: 2 }, DQn = /* @__PURE__ */ e("path", { d: "M238.6,78.6A31.6,31.6,0,0,1,216,88a32.2,32.2,0,0,1-7.6-.9l-26.7,49.4.9.9a31.9,31.9,0,0,1,0,45.2,31.9,31.9,0,0,1-45.2,0,32,32,0,0,1-5-38.9l-20.1-20.1A32.7,32.7,0,0,1,96,128a32.2,32.2,0,0,1-7.6-.9L61.7,176.5l.9.9a31.9,31.9,0,0,1,0,45.2,31.9,31.9,0,0,1-45.2,0,31.9,31.9,0,0,1,0-45.2h0a32.1,32.1,0,0,1,30.2-8.5l26.7-49.4-.9-.9a31.9,31.9,0,0,1,0-45.2h0a32,32,0,0,1,50.2,38.9l20.1,20.1a32.4,32.4,0,0,1,23.9-3.5l26.7-49.4-.9-.9a31.9,31.9,0,0,1,0-45.2h0a32,32,0,0,1,45.2,45.2Z" }, null, -1), RQn = [
  DQn
], UQn = { key: 3 }, qQn = ["stroke"], GQn = ["stroke"], EQn = ["stroke"], OQn = ["stroke"], IQn = ["stroke"], KQn = ["stroke"], XQn = ["stroke"], JQn = { key: 4 }, QQn = ["stroke"], YQn = ["stroke"], oYn = ["stroke"], eYn = ["stroke"], tYn = ["stroke"], nYn = ["stroke"], sYn = ["stroke"], rYn = { key: 5 }, iYn = ["stroke"], lYn = ["stroke"], dYn = ["stroke"], kYn = ["stroke"], cYn = ["stroke"], hYn = ["stroke"], uYn = ["stroke"], aYn = {
  name: "PhLineSegments"
}, jX1 = /* @__PURE__ */ $({
  ...aYn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", gQn, [
        e("circle", {
          cx: "40",
          cy: "200",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xQn),
        e("circle", {
          cx: "96",
          cy: "96",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jQn),
        e("circle", {
          cx: "160",
          cy: "160",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mQn),
        e("circle", {
          cx: "216",
          cy: "56",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MQn),
        e("line", {
          x1: "84.6",
          y1: "117.1",
          x2: "51.4",
          y2: "178.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vQn),
        e("line", {
          x1: "143",
          y1: "143",
          x2: "113",
          y2: "113",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SQn),
        e("line", {
          x1: "204.6",
          y1: "77.1",
          x2: "171.4",
          y2: "138.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HQn)
      ])) : o(i) === "duotone" ? (s(), r("g", AQn, [
        VQn,
        zQn,
        ZQn,
        CQn,
        e("circle", {
          cx: "40",
          cy: "200",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bQn),
        e("circle", {
          cx: "96",
          cy: "96",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LQn),
        e("circle", {
          cx: "160",
          cy: "160",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BQn),
        e("circle", {
          cx: "216",
          cy: "56",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PQn),
        e("line", {
          x1: "84.6",
          y1: "117.1",
          x2: "51.4",
          y2: "178.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WQn),
        e("line", {
          x1: "143",
          y1: "143",
          x2: "113",
          y2: "113",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NQn),
        e("line", {
          x1: "204.6",
          y1: "77.1",
          x2: "171.4",
          y2: "138.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FQn)
      ])) : o(i) === "fill" ? (s(), r("g", TQn, RQn)) : o(i) === "light" ? (s(), r("g", UQn, [
        e("circle", {
          cx: "40",
          cy: "200",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qQn),
        e("circle", {
          cx: "96",
          cy: "96",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GQn),
        e("circle", {
          cx: "160",
          cy: "160",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, EQn),
        e("circle", {
          cx: "216",
          cy: "56",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OQn),
        e("line", {
          x1: "84.6",
          y1: "117.1",
          x2: "51.4",
          y2: "178.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IQn),
        e("line", {
          x1: "143",
          y1: "143",
          x2: "113",
          y2: "113",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KQn),
        e("line", {
          x1: "204.6",
          y1: "77.1",
          x2: "171.4",
          y2: "138.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XQn)
      ])) : o(i) === "thin" ? (s(), r("g", JQn, [
        e("circle", {
          cx: "40",
          cy: "200",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QQn),
        e("circle", {
          cx: "96",
          cy: "96",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YQn),
        e("circle", {
          cx: "160",
          cy: "160",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oYn),
        e("circle", {
          cx: "216",
          cy: "56",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eYn),
        e("line", {
          x1: "84.6",
          y1: "117.1",
          x2: "51.4",
          y2: "178.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tYn),
        e("line", {
          x1: "143",
          y1: "143",
          x2: "113",
          y2: "113",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nYn),
        e("line", {
          x1: "204.6",
          y1: "77.1",
          x2: "171.4",
          y2: "138.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sYn)
      ])) : o(i) === "regular" ? (s(), r("g", rYn, [
        e("circle", {
          cx: "40",
          cy: "200",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iYn),
        e("circle", {
          cx: "96",
          cy: "96",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lYn),
        e("circle", {
          cx: "160",
          cy: "160",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dYn),
        e("circle", {
          cx: "216",
          cy: "56",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kYn),
        e("line", {
          x1: "84.6",
          y1: "117.1",
          x2: "51.4",
          y2: "178.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cYn),
        e("line", {
          x1: "143",
          y1: "143",
          x2: "113",
          y2: "113",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hYn),
        e("line", {
          x1: "204.6",
          y1: "77.1",
          x2: "171.4",
          y2: "138.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uYn)
      ])) : g("", !0)
    ], 16, fQn));
  }
}), _Yn = ["width", "height", "fill", "transform"], pYn = { key: 0 }, yYn = ["stroke"], $Yn = ["stroke"], wYn = { key: 1 }, fYn = ["stroke"], gYn = ["stroke"], xYn = { key: 2 }, jYn = /* @__PURE__ */ e("path", { d: "M210,46a51.8,51.8,0,0,0-73.5,0L116.7,65.8A8,8,0,0,0,128,77.1l19.8-19.8a36.1,36.1,0,0,1,50.9,0,35.9,35.9,0,0,1,0,50.9l-28.3,28.3a36.1,36.1,0,0,1-50.9,0,8,8,0,1,0-11.3,11.3,52,52,0,0,0,73.5,0L210,119.5A51.8,51.8,0,0,0,210,46Z" }, null, -1), mYn = /* @__PURE__ */ e("path", { d: "M128,178.9l-19.8,19.8a36,36,0,0,1-50.9-50.9l28.3-28.3a36.1,36.1,0,0,1,50.9,0,8,8,0,0,0,11.3-11.3,52,52,0,0,0-73.5,0L46,136.5A52,52,0,1,0,119.5,210l19.8-19.8A8,8,0,0,0,128,178.9Z" }, null, -1), MYn = [
  jYn,
  mYn
], vYn = { key: 3 }, SYn = ["stroke"], HYn = ["stroke"], AYn = { key: 4 }, VYn = ["stroke"], zYn = ["stroke"], ZYn = { key: 5 }, CYn = ["stroke"], bYn = ["stroke"], LYn = {
  name: "PhLink"
}, mX1 = /* @__PURE__ */ $({
  ...LYn,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", pYn, [
        e("path", {
          d: "M132.5,61.3l9.6-9.7a44.1,44.1,0,0,1,62.3,62.3l-30.3,30.2a43.9,43.9,0,0,1-62.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yYn),
        e("path", {
          d: "M123.5,194.7l-9.6,9.7a44.1,44.1,0,0,1-62.3-62.3l30.3-30.2a43.9,43.9,0,0,1,62.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $Yn)
      ])) : o(i) === "duotone" ? (s(), r("g", wYn, [
        e("path", {
          d: "M122.3,71.4l19.8-19.8a44.1,44.1,0,0,1,62.3,62.3l-28.3,28.2a43.9,43.9,0,0,1-62.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fYn),
        e("path", {
          d: "M133.7,184.6l-19.8,19.8a44.1,44.1,0,0,1-62.3-62.3l28.3-28.2a43.9,43.9,0,0,1,62.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gYn)
      ])) : o(i) === "fill" ? (s(), r("g", xYn, MYn)) : o(i) === "light" ? (s(), r("g", vYn, [
        e("path", {
          d: "M122.3,71.4l19.8-19.8a44.1,44.1,0,0,1,62.3,62.3l-28.3,28.2a43.9,43.9,0,0,1-62.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, SYn),
        e("path", {
          d: "M133.7,184.6l-19.8,19.8a44.1,44.1,0,0,1-62.3-62.3l28.3-28.2a43.9,43.9,0,0,1,62.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HYn)
      ])) : o(i) === "thin" ? (s(), r("g", AYn, [
        e("path", {
          d: "M122.3,71.4l19.8-19.8a44.1,44.1,0,0,1,62.3,62.3l-28.3,28.2a43.9,43.9,0,0,1-62.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VYn),
        e("path", {
          d: "M133.7,184.6l-19.8,19.8a44.1,44.1,0,0,1-62.3-62.3l28.3-28.2a43.9,43.9,0,0,1,62.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zYn)
      ])) : o(i) === "regular" ? (s(), r("g", ZYn, [
        e("path", {
          d: "M122.3,71.4l19.8-19.8a44.1,44.1,0,0,1,62.3,62.3l-28.3,28.2a43.9,43.9,0,0,1-62.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CYn),
        e("path", {
          d: "M133.7,184.6l-19.8,19.8a44.1,44.1,0,0,1-62.3-62.3l28.3-28.2a43.9,43.9,0,0,1,62.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bYn)
      ])) : g("", !0)
    ], 16, _Yn));
  }
}), BYn = ["width", "height", "fill", "transform"], PYn = { key: 0 }, WYn = ["stroke"], NYn = ["stroke"], FYn = ["stroke"], TYn = ["stroke"], DYn = ["stroke"], RYn = ["stroke"], UYn = { key: 1 }, qYn = ["stroke"], GYn = ["stroke"], EYn = ["stroke"], OYn = ["stroke"], IYn = ["stroke"], KYn = ["stroke"], XYn = { key: 2 }, JYn = /* @__PURE__ */ e("path", { d: "M88,72V48a8,8,0,0,1,16,0V72a8,8,0,0,1-16,0Zm72,104a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V184A8,8,0,0,0,160,176ZM48,104H72a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16Zm160,48H184a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16Zm-86.1,27.3-11.3,11.3a32,32,0,0,1-45.2-45.2l11.3-11.3a8.1,8.1,0,0,0,0-11.4,8,8,0,0,0-11.3,0L54.1,134.1a47.9,47.9,0,1,0,67.8,67.8l11.4-11.3a8,8,0,0,0,0-11.3A8.1,8.1,0,0,0,121.9,179.3ZM190.6,65.4a31.9,31.9,0,0,1,0,45.2l-11.3,11.3a8.1,8.1,0,0,0,0,11.4,8.3,8.3,0,0,0,5.7,2.3,8,8,0,0,0,5.6-2.3l11.3-11.4a47.9,47.9,0,0,0-67.8-67.8L122.7,65.4a8,8,0,0,0,0,11.3,8.1,8.1,0,0,0,11.4,0l11.3-11.3A31.9,31.9,0,0,1,190.6,65.4Z" }, null, -1), QYn = [
  JYn
], YYn = { key: 3 }, oos = ["stroke"], eos = ["stroke"], tos = ["stroke"], nos = ["stroke"], sos = ["stroke"], ros = ["stroke"], ios = { key: 4 }, los = ["stroke"], dos = ["stroke"], kos = ["stroke"], cos = ["stroke"], hos = ["stroke"], uos = ["stroke"], aos = { key: 5 }, _os = ["stroke"], pos = ["stroke"], yos = ["stroke"], $os = ["stroke"], wos = ["stroke"], fos = ["stroke"], gos = {
  name: "PhLinkBreak"
}, MX1 = /* @__PURE__ */ $({
  ...gos,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", PYn, [
        e("line", {
          x1: "96",
          y1: "68",
          x2: "96",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WYn),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "160",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NYn),
        e("line", {
          x1: "68",
          y1: "96",
          x2: "48",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FYn),
        e("line", {
          x1: "208",
          y1: "160",
          x2: "188",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TYn),
        e("path", {
          d: "M67,132.4l-7.3,7.3a40,40,0,0,0,56.6,56.6l7.3-7.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DYn),
        e("path", {
          d: "M189,123.6l7.3-7.3a40,40,0,0,0-56.6-56.6L132.4,67",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RYn)
      ])) : o(i) === "duotone" ? (s(), r("g", UYn, [
        e("line", {
          x1: "96",
          y1: "72",
          x2: "96",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qYn),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "160",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GYn),
        e("line", {
          x1: "72",
          y1: "96",
          x2: "48",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EYn),
        e("line", {
          x1: "208",
          y1: "160",
          x2: "184",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OYn),
        e("path", {
          d: "M71,128.4,59.7,139.7a40,40,0,0,0,56.6,56.6L127.6,185",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IYn),
        e("path", {
          d: "M185,127.6l11.3-11.3a40,40,0,0,0-56.6-56.6L128.4,71",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KYn)
      ])) : o(i) === "fill" ? (s(), r("g", XYn, QYn)) : o(i) === "light" ? (s(), r("g", YYn, [
        e("line", {
          x1: "96",
          y1: "72",
          x2: "96",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oos),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "160",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eos),
        e("line", {
          x1: "72",
          y1: "96",
          x2: "48",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tos),
        e("line", {
          x1: "208",
          y1: "160",
          x2: "184",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nos),
        e("path", {
          d: "M71,128.4,59.7,139.7a40,40,0,0,0,56.6,56.6L127.6,185",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sos),
        e("path", {
          d: "M185,127.6l11.3-11.3a40,40,0,0,0-56.6-56.6L128.4,71",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ros)
      ])) : o(i) === "thin" ? (s(), r("g", ios, [
        e("line", {
          x1: "96",
          y1: "72",
          x2: "96",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, los),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "160",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dos),
        e("line", {
          x1: "72",
          y1: "96",
          x2: "48",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kos),
        e("line", {
          x1: "208",
          y1: "160",
          x2: "184",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cos),
        e("path", {
          d: "M71,128.4,59.7,139.7a40,40,0,0,0,56.6,56.6L127.6,185",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hos),
        e("path", {
          d: "M185,127.6l11.3-11.3a40,40,0,0,0-56.6-56.6L128.4,71",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uos)
      ])) : o(i) === "regular" ? (s(), r("g", aos, [
        e("line", {
          x1: "96",
          y1: "72",
          x2: "96",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _os),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "160",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pos),
        e("line", {
          x1: "72",
          y1: "96",
          x2: "48",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yos),
        e("line", {
          x1: "208",
          y1: "160",
          x2: "184",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $os),
        e("path", {
          d: "M71,128.4,59.7,139.7a40,40,0,0,0,56.6,56.6L127.6,185",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wos),
        e("path", {
          d: "M185,127.6l11.3-11.3a40,40,0,0,0-56.6-56.6L128.4,71",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fos)
      ])) : g("", !0)
    ], 16, BYn));
  }
}), xos = ["width", "height", "fill", "transform"], jos = { key: 0 }, mos = ["stroke"], Mos = ["stroke"], vos = ["stroke"], Sos = { key: 1 }, Hos = ["stroke"], Aos = ["stroke"], Vos = ["stroke"], zos = { key: 2 }, Zos = /* @__PURE__ */ e("path", { d: "M156.3,88.4,88.4,156.3a8,8,0,0,0,0,11.3,8.1,8.1,0,0,0,11.3,0l67.9-67.9a8,8,0,0,0-11.3-11.3Z" }, null, -1), Cos = /* @__PURE__ */ e("path", { d: "M139.3,173.3,111,201.5a39.7,39.7,0,0,1-56.5,0,40,40,0,0,1,0-56.5l28.2-28.3a8,8,0,0,0-11.3-11.3L43.1,133.7a56,56,0,0,0,79.2,79.2l28.3-28.3a8,8,0,0,0,0-11.3A7.9,7.9,0,0,0,139.3,173.3Z" }, null, -1), bos = /* @__PURE__ */ e("path", { d: "M212.9,43.1a56,56,0,0,0-79.2,0L105.4,71.4a8,8,0,0,0,11.3,11.3L145,54.5a39.7,39.7,0,0,1,56.5,0,40,40,0,0,1,0,56.5l-28.2,28.3a7.9,7.9,0,0,0,0,11.3,7.7,7.7,0,0,0,5.6,2.4,8,8,0,0,0,5.7-2.4l28.3-28.3A56.1,56.1,0,0,0,212.9,43.1Z" }, null, -1), Los = [
  Zos,
  Cos,
  bos
], Bos = { key: 3 }, Pos = ["stroke"], Wos = ["stroke"], Nos = ["stroke"], Fos = { key: 4 }, Tos = ["stroke"], Dos = ["stroke"], Ros = ["stroke"], Uos = { key: 5 }, qos = ["stroke"], Gos = ["stroke"], Eos = ["stroke"], Oos = {
  name: "PhLinkSimple"
}, vX1 = /* @__PURE__ */ $({
  ...Oos,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", jos, [
        e("line", {
          x1: "94.1",
          y1: "161.9",
          x2: "161.9",
          y2: "94",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mos),
        e("path", {
          d: "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mos),
        e("path", {
          d: "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vos)
      ])) : o(i) === "duotone" ? (s(), r("g", Sos, [
        e("line", {
          x1: "94.1",
          y1: "161.9",
          x2: "161.9",
          y2: "94",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hos),
        e("path", {
          d: "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Aos),
        e("path", {
          d: "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vos)
      ])) : o(i) === "fill" ? (s(), r("g", zos, Los)) : o(i) === "light" ? (s(), r("g", Bos, [
        e("line", {
          x1: "94.1",
          y1: "161.9",
          x2: "161.9",
          y2: "94",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pos),
        e("path", {
          d: "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wos),
        e("path", {
          d: "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Nos)
      ])) : o(i) === "thin" ? (s(), r("g", Fos, [
        e("line", {
          x1: "94.1",
          y1: "161.9",
          x2: "161.9",
          y2: "94",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Tos),
        e("path", {
          d: "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Dos),
        e("path", {
          d: "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ros)
      ])) : o(i) === "regular" ? (s(), r("g", Uos, [
        e("line", {
          x1: "94.1",
          y1: "161.9",
          x2: "161.9",
          y2: "94",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qos),
        e("path", {
          d: "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gos),
        e("path", {
          d: "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Eos)
      ])) : g("", !0)
    ], 16, xos));
  }
}), Ios = ["width", "height", "fill", "transform"], Kos = { key: 0 }, Xos = ["stroke"], Jos = ["stroke"], Qos = { key: 1 }, Yos = ["stroke"], oes = ["stroke"], ees = { key: 2 }, tes = /* @__PURE__ */ e("path", { d: "M139.3,173.3,111,201.5a39.7,39.7,0,0,1-56.5,0,40,40,0,0,1,0-56.5l28.2-28.3a8,8,0,0,0-11.3-11.3L43.1,133.7a56,56,0,0,0,79.2,79.2l28.3-28.3a8,8,0,0,0,0-11.3A7.9,7.9,0,0,0,139.3,173.3Z" }, null, -1), nes = /* @__PURE__ */ e("path", { d: "M212.9,43.1a56,56,0,0,0-79.2,0L105.4,71.4a8,8,0,0,0,11.3,11.3L145,54.5a39.7,39.7,0,0,1,56.5,0,40,40,0,0,1,0,56.5l-28.2,28.3a7.9,7.9,0,0,0,0,11.3,7.7,7.7,0,0,0,5.6,2.4,8,8,0,0,0,5.7-2.4l28.3-28.3A56.1,56.1,0,0,0,212.9,43.1Z" }, null, -1), ses = [
  tes,
  nes
], res = { key: 3 }, ies = ["stroke"], les = ["stroke"], des = { key: 4 }, kes = ["stroke"], ces = ["stroke"], hes = { key: 5 }, ues = ["stroke"], aes = ["stroke"], _es = ["stroke"], pes = ["stroke"], yes = {
  name: "PhLinkSimpleBreak"
}, SX1 = /* @__PURE__ */ $({
  ...yes,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Kos, [
        e("path", {
          d: "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xos),
        e("path", {
          d: "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jos)
      ])) : o(i) === "duotone" ? (s(), r("g", Qos, [
        e("path", {
          d: "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yos),
        e("path", {
          d: "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oes)
      ])) : o(i) === "fill" ? (s(), r("g", ees, ses)) : o(i) === "light" ? (s(), r("g", res, [
        e("path", {
          d: "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ies),
        e("path", {
          d: "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, les)
      ])) : o(i) === "thin" ? (s(), r("g", des, [
        e("path", {
          d: "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kes),
        e("path", {
          d: "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ces)
      ])) : o(i) === "regular" ? (s(), r("g", hes, [
        e("path", {
          d: "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ues),
        e("path", {
          d: "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aes),
        e("path", {
          d: "M145,178.9l-28.3,28.3a48,48,0,0,1-67.9-67.9L77.1,111",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _es),
        e("path", {
          d: "M178.9,145l28.3-28.3a48,48,0,0,0-67.9-67.9L111,77.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pes)
      ])) : g("", !0)
    ], 16, Ios));
  }
}), $es = ["width", "height", "fill", "transform"], wes = { key: 0 }, fes = ["stroke"], ges = ["stroke"], xes = ["stroke"], jes = { key: 1 }, mes = ["stroke"], Mes = ["stroke"], ves = ["stroke"], Ses = { key: 2 }, Hes = /* @__PURE__ */ e("path", { d: "M72,128a8,8,0,0,0,8,8h96a8,8,0,0,0,0-16H80A8,8,0,0,0,72,128Z" }, null, -1), Aes = /* @__PURE__ */ e("path", { d: "M104,168H64a40,40,0,0,1,0-80h40a8,8,0,0,0,0-16H64a56,56,0,0,0,0,112h40a8,8,0,0,0,0-16Z" }, null, -1), Ves = /* @__PURE__ */ e("path", { d: "M192,72H152a8,8,0,0,0,0,16h40a40,40,0,0,1,0,80H152a8,8,0,0,0,0,16h40a56,56,0,0,0,0-112Z" }, null, -1), zes = [
  Hes,
  Aes,
  Ves
], Zes = { key: 3 }, Ces = ["stroke"], bes = ["stroke"], Les = ["stroke"], Bes = { key: 4 }, Pes = ["stroke"], Wes = ["stroke"], Nes = ["stroke"], Fes = { key: 5 }, Tes = ["stroke"], Des = ["stroke"], Res = ["stroke"], Ues = {
  name: "PhLinkSimpleHorizontal"
}, HX1 = /* @__PURE__ */ $({
  ...Ues,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", wes, [
        e("line", {
          x1: "80",
          y1: "128",
          x2: "176",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fes),
        e("path", {
          d: "M104,176H64a48,48,0,0,1,0-96h40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ges),
        e("path", {
          d: "M152,176h40a48,48,0,0,0,0-96H152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xes)
      ])) : o(i) === "duotone" ? (s(), r("g", jes, [
        e("line", {
          x1: "80",
          y1: "128",
          x2: "176",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mes),
        e("path", {
          d: "M104,176H64a48,48,0,0,1,0-96h40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mes),
        e("path", {
          d: "M152,176h40a48,48,0,0,0,0-96H152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ves)
      ])) : o(i) === "fill" ? (s(), r("g", Ses, zes)) : o(i) === "light" ? (s(), r("g", Zes, [
        e("line", {
          x1: "80",
          y1: "128",
          x2: "176",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ces),
        e("path", {
          d: "M104,176H64a48,48,0,0,1,0-96h40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bes),
        e("path", {
          d: "M152,176h40a48,48,0,0,0,0-96H152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Les)
      ])) : o(i) === "thin" ? (s(), r("g", Bes, [
        e("line", {
          x1: "80",
          y1: "128",
          x2: "176",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pes),
        e("path", {
          d: "M104,176H64a48,48,0,0,1,0-96h40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wes),
        e("path", {
          d: "M152,176h40a48,48,0,0,0,0-96H152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nes)
      ])) : o(i) === "regular" ? (s(), r("g", Fes, [
        e("line", {
          x1: "80",
          y1: "128",
          x2: "176",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tes),
        e("path", {
          d: "M104,176H64a48,48,0,0,1,0-96h40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Des),
        e("path", {
          d: "M152,176h40a48,48,0,0,0,0-96H152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Res)
      ])) : g("", !0)
    ], 16, $es));
  }
}), qes = ["width", "height", "fill", "transform"], Ges = { key: 0 }, Ees = ["stroke"], Oes = ["stroke"], Ies = { key: 1 }, Kes = ["stroke"], Xes = ["stroke"], Jes = { key: 2 }, Qes = /* @__PURE__ */ e("path", { d: "M104,168H64a40,40,0,0,1,0-80h40a8,8,0,0,0,0-16H64a56,56,0,0,0,0,112h40a8,8,0,0,0,0-16Z" }, null, -1), Yes = /* @__PURE__ */ e("path", { d: "M192,72H152a8,8,0,0,0,0,16h40a40,40,0,0,1,0,80H152a8,8,0,0,0,0,16h40a56,56,0,0,0,0-112Z" }, null, -1), ots = [
  Qes,
  Yes
], ets = { key: 3 }, tts = ["stroke"], nts = ["stroke"], sts = { key: 4 }, rts = ["stroke"], its = ["stroke"], lts = { key: 5 }, dts = ["stroke"], kts = ["stroke"], cts = {
  name: "PhLinkSimpleHorizontalBreak"
}, AX1 = /* @__PURE__ */ $({
  ...cts,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ges, [
        e("path", {
          d: "M104,176H64a48,48,0,0,1,0-96h40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ees),
        e("path", {
          d: "M152,176h40a48,48,0,0,0,0-96H152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Oes)
      ])) : o(i) === "duotone" ? (s(), r("g", Ies, [
        e("path", {
          d: "M104,176H64a48,48,0,0,1,0-96h40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kes),
        e("path", {
          d: "M152,176h40a48,48,0,0,0,0-96H152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xes)
      ])) : o(i) === "fill" ? (s(), r("g", Jes, ots)) : o(i) === "light" ? (s(), r("g", ets, [
        e("path", {
          d: "M104,176H64a48,48,0,0,1,0-96h40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tts),
        e("path", {
          d: "M152,176h40a48,48,0,0,0,0-96H152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nts)
      ])) : o(i) === "thin" ? (s(), r("g", sts, [
        e("path", {
          d: "M104,176H64a48,48,0,0,1,0-96h40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rts),
        e("path", {
          d: "M152,176h40a48,48,0,0,0,0-96H152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, its)
      ])) : o(i) === "regular" ? (s(), r("g", lts, [
        e("path", {
          d: "M104,176H64a48,48,0,0,1,0-96h40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dts),
        e("path", {
          d: "M152,176h40a48,48,0,0,0,0-96H152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kts)
      ])) : g("", !0)
    ], 16, qes));
  }
}), hts = ["width", "height", "fill", "transform"], uts = { key: 0 }, ats = ["stroke"], _ts = ["stroke"], pts = ["stroke"], yts = ["stroke"], $ts = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "80",
  r: "16"
}, null, -1), wts = { key: 1 }, fts = /* @__PURE__ */ e("rect", {
  x: "36",
  y: "36",
  width: "184",
  height: "184",
  rx: "8",
  opacity: "0.2"
}, null, -1), gts = ["stroke"], xts = ["stroke"], jts = ["stroke"], mts = ["stroke"], Mts = /* @__PURE__ */ e("circle", {
  cx: "88",
  cy: "80",
  r: "12"
}, null, -1), vts = { key: 2 }, Sts = /* @__PURE__ */ e("path", { d: "M212,28H44A16,16,0,0,0,28,44V212a16,16,0,0,0,16,16H212a16,16,0,0,0,16-16V44A16,16,0,0,0,212,28ZM96,176a8,8,0,0,1-16,0V112a8,8,0,0,1,16,0ZM88,92a12,12,0,1,1,12-12A12,12,0,0,1,88,92Zm96,84a8,8,0,0,1-16,0V140a20,20,0,0,0-40,0v36a8,8,0,0,1-16,0V112a8,8,0,0,1,15.8-1.8A36,36,0,0,1,184,140Z" }, null, -1), Hts = [
  Sts
], Ats = { key: 3 }, Vts = ["stroke"], zts = ["stroke"], Zts = ["stroke"], Cts = ["stroke"], bts = /* @__PURE__ */ e("circle", {
  cx: "88",
  cy: "80",
  r: "10"
}, null, -1), Lts = { key: 4 }, Bts = ["stroke"], Pts = ["stroke"], Wts = ["stroke"], Nts = ["stroke"], Fts = /* @__PURE__ */ e("circle", {
  cx: "88",
  cy: "80",
  r: "8"
}, null, -1), Tts = { key: 5 }, Dts = ["stroke"], Rts = ["stroke"], Uts = ["stroke"], qts = ["stroke"], Gts = /* @__PURE__ */ e("circle", {
  cx: "88",
  cy: "80",
  r: "12"
}, null, -1), Ets = {
  name: "PhLinkedinLogo"
}, VX1 = /* @__PURE__ */ $({
  ...Ets,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", uts, [
        e("rect", {
          x: "36",
          y: "36",
          width: "184",
          height: "184",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ats),
        e("line", {
          x1: "124",
          y1: "120",
          x2: "124",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _ts),
        e("line", {
          x1: "84",
          y1: "120",
          x2: "84",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pts),
        e("path", {
          d: "M124,148a28,28,0,0,1,56,0v28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yts),
        $ts
      ])) : o(i) === "duotone" ? (s(), r("g", wts, [
        fts,
        e("rect", {
          x: "36",
          y: "36",
          width: "184",
          height: "184",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gts),
        e("line", {
          x1: "120",
          y1: "112",
          x2: "120",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xts),
        e("line", {
          x1: "88",
          y1: "112",
          x2: "88",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jts),
        e("path", {
          d: "M120,140a28,28,0,0,1,56,0v36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mts),
        Mts
      ])) : o(i) === "fill" ? (s(), r("g", vts, Hts)) : o(i) === "light" ? (s(), r("g", Ats, [
        e("rect", {
          x: "36",
          y: "36",
          width: "184",
          height: "184",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vts),
        e("line", {
          x1: "120",
          y1: "112",
          x2: "120",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zts),
        e("line", {
          x1: "88",
          y1: "112",
          x2: "88",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zts),
        e("path", {
          d: "M120,140a28,28,0,0,1,56,0v36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cts),
        bts
      ])) : o(i) === "thin" ? (s(), r("g", Lts, [
        e("rect", {
          x: "36",
          y: "36",
          width: "184",
          height: "184",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bts),
        e("line", {
          x1: "120",
          y1: "112",
          x2: "120",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pts),
        e("line", {
          x1: "88",
          y1: "112",
          x2: "88",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wts),
        e("path", {
          d: "M120,140a28,28,0,0,1,56,0v36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nts),
        Fts
      ])) : o(i) === "regular" ? (s(), r("g", Tts, [
        e("rect", {
          x: "36",
          y: "36",
          width: "184",
          height: "184",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dts),
        e("line", {
          x1: "120",
          y1: "112",
          x2: "120",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rts),
        e("line", {
          x1: "88",
          y1: "112",
          x2: "88",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uts),
        e("path", {
          d: "M120,140a28,28,0,0,1,56,0v36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qts),
        Gts
      ])) : g("", !0)
    ], 16, hts));
  }
}), Ots = ["width", "height", "fill", "transform"], Its = { key: 0 }, Kts = /* @__PURE__ */ e("circle", {
  cx: "104",
  cy: "112",
  r: "16"
}, null, -1), Xts = /* @__PURE__ */ e("circle", {
  cx: "152",
  cy: "112",
  r: "16"
}, null, -1), Jts = ["stroke"], Qts = ["stroke"], Yts = ["stroke"], ons = { key: 1 }, ens = /* @__PURE__ */ e("path", {
  d: "M169.6,216a48.1,48.1,0,0,0-83.2,0H32S64,160,64,96a64,64,0,0,1,128,0c0,64,32,120,32,120Z",
  opacity: "0.2"
}, null, -1), tns = ["stroke"], nns = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "108",
  r: "12"
}, null, -1), sns = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "108",
  r: "12"
}, null, -1), rns = ["stroke"], ins = ["stroke"], lns = { key: 2 }, dns = /* @__PURE__ */ e("path", { d: "M161.2,217.7a4,4,0,0,1-3.3,6.3H98.1a4,4,0,0,1-3.3-6.3,40,40,0,0,1,66.4,0Zm68.6,3.8a8.2,8.2,0,0,1-6,2.5H184.6a4.1,4.1,0,0,1-3.8-2.7,56,56,0,0,0-105.6,0,4.1,4.1,0,0,1-3.8,2.7H32.2a8,8,0,0,1-6-2.5,7.9,7.9,0,0,1-1.1-9.5c.3-.5,30.9-55,30.9-116a72.1,72.1,0,0,1,72.5-72c39.6.3,71.4,32.9,71.5,72.5.2,60.8,30.6,115,30.9,115.5A7.9,7.9,0,0,1,229.8,221.5ZM88,108a12,12,0,1,0,12-12A12,12,0,0,0,88,108Zm79.2,32.4a8.2,8.2,0,0,0-10.8-3.6L128,151.1,99.6,136.8a8,8,0,1,0-7.2,14.4l32,16a8.5,8.5,0,0,0,7.2,0l32-16A8.2,8.2,0,0,0,167.2,140.4ZM168,108a12,12,0,1,0-12,12A12,12,0,0,0,168,108Z" }, null, -1), kns = [
  dns
], cns = { key: 3 }, hns = ["stroke"], uns = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "108",
  r: "10"
}, null, -1), ans = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "108",
  r: "10"
}, null, -1), _ns = ["stroke"], pns = ["stroke"], yns = { key: 4 }, $ns = ["stroke"], wns = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "108",
  r: "8"
}, null, -1), fns = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "108",
  r: "8"
}, null, -1), gns = ["stroke"], xns = ["stroke"], jns = { key: 5 }, mns = ["stroke"], Mns = /* @__PURE__ */ e("circle", {
  cx: "100",
  cy: "108",
  r: "12"
}, null, -1), vns = /* @__PURE__ */ e("circle", {
  cx: "156",
  cy: "108",
  r: "12"
}, null, -1), Sns = ["stroke"], Hns = ["stroke"], Ans = {
  name: "PhLinuxLogo"
}, zX1 = /* @__PURE__ */ $({
  ...Ans,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Its, [
        Kts,
        Xts,
        e("polyline", {
          points: "156 152 128 164 100 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jts),
        e("path", {
          d: "M101.5,212a47.9,47.9,0,0,1,53,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qts),
        e("path", {
          d: "M36.2,212S60,160,60,104a68,68,0,0,1,136,0c0,56,23.8,108,23.8,108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Yts)
      ])) : o(i) === "duotone" ? (s(), r("g", ons, [
        ens,
        e("path", {
          d: "M32,216S64,160,64,96a64,64,0,0,1,128,0c0,64,32,120,32,120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tns),
        nns,
        sns,
        e("polyline", {
          points: "160 144 128 160 96 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rns),
        e("path", {
          d: "M86.4,216a48.1,48.1,0,0,1,83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ins)
      ])) : o(i) === "fill" ? (s(), r("g", lns, kns)) : o(i) === "light" ? (s(), r("g", cns, [
        e("path", {
          d: "M32,216S64,160,64,96a64,64,0,0,1,128,0c0,64,32,120,32,120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hns),
        uns,
        ans,
        e("polyline", {
          points: "160 144 128 160 96 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _ns),
        e("path", {
          d: "M86.4,216a48.1,48.1,0,0,1,83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pns)
      ])) : o(i) === "thin" ? (s(), r("g", yns, [
        e("path", {
          d: "M32,216S64,160,64,96a64,64,0,0,1,128,0c0,64,32,120,32,120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $ns),
        wns,
        fns,
        e("polyline", {
          points: "160 144 128 160 96 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gns),
        e("path", {
          d: "M86.4,216a48.1,48.1,0,0,1,83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xns)
      ])) : o(i) === "regular" ? (s(), r("g", jns, [
        e("path", {
          d: "M32,216S64,160,64,96a64,64,0,0,1,128,0c0,64,32,120,32,120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mns),
        Mns,
        vns,
        e("polyline", {
          points: "160 144 128 160 96 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sns),
        e("path", {
          d: "M86.4,216a48.1,48.1,0,0,1,83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hns)
      ])) : g("", !0)
    ], 16, Ots));
  }
}), Vns = ["width", "height", "fill", "transform"], zns = { key: 0 }, Zns = ["stroke"], Cns = ["stroke"], bns = ["stroke"], Lns = { key: 1 }, Bns = ["stroke"], Pns = ["stroke"], Wns = ["stroke"], Nns = { key: 2 }, Fns = /* @__PURE__ */ e("path", { d: "M216,120H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1), Tns = /* @__PURE__ */ e("path", { d: "M40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z" }, null, -1), Dns = /* @__PURE__ */ e("path", { d: "M216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1), Rns = [
  Fns,
  Tns,
  Dns
], Uns = { key: 3 }, qns = ["stroke"], Gns = ["stroke"], Ens = ["stroke"], Ons = { key: 4 }, Ins = ["stroke"], Kns = ["stroke"], Xns = ["stroke"], Jns = { key: 5 }, Qns = ["stroke"], Yns = ["stroke"], oss = ["stroke"], ess = {
  name: "PhList"
}, ZX1 = /* @__PURE__ */ $({
  ...ess,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", zns, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zns),
        e("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cns),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bns)
      ])) : o(i) === "duotone" ? (s(), r("g", Lns, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bns),
        e("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pns),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "216",
          y2: "192",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wns)
      ])) : o(i) === "fill" ? (s(), r("g", Nns, Rns)) : o(i) === "light" ? (s(), r("g", Uns, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qns),
        e("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gns),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ens)
      ])) : o(i) === "thin" ? (s(), r("g", Ons, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ins),
        e("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kns),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xns)
      ])) : o(i) === "regular" ? (s(), r("g", Jns, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qns),
        e("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yns),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "216",
          y2: "192",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oss)
      ])) : g("", !0)
    ], 16, Vns));
  }
}), tss = ["width", "height", "fill", "transform"], nss = { key: 0 }, sss = ["stroke"], rss = ["stroke"], iss = ["stroke"], lss = /* @__PURE__ */ e("circle", {
  cx: "44",
  cy: "128",
  r: "16"
}, null, -1), dss = /* @__PURE__ */ e("circle", {
  cx: "44",
  cy: "64",
  r: "16"
}, null, -1), kss = /* @__PURE__ */ e("circle", {
  cx: "44",
  cy: "192",
  r: "16"
}, null, -1), css = { key: 1 }, hss = ["stroke"], uss = ["stroke"], ass = ["stroke"], _ss = /* @__PURE__ */ e("circle", {
  cx: "44",
  cy: "64",
  r: "12"
}, null, -1), pss = /* @__PURE__ */ e("circle", {
  cx: "44",
  cy: "128",
  r: "12"
}, null, -1), yss = /* @__PURE__ */ e("circle", {
  cx: "44",
  cy: "192",
  r: "12"
}, null, -1), $ss = { key: 2 }, wss = /* @__PURE__ */ e("path", { d: "M80,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H88A8,8,0,0,1,80,64Zm136,56H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,64H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM44,116a12,12,0,1,0,12,12A12,12,0,0,0,44,116Zm0-64A12,12,0,1,0,56,64,12,12,0,0,0,44,52Zm0,128a12,12,0,1,0,12,12A12,12,0,0,0,44,180Z" }, null, -1), fss = [
  wss
], gss = { key: 3 }, xss = ["stroke"], jss = ["stroke"], mss = ["stroke"], Mss = /* @__PURE__ */ e("circle", {
  cx: "44",
  cy: "64",
  r: "10"
}, null, -1), vss = /* @__PURE__ */ e("circle", {
  cx: "44",
  cy: "192",
  r: "10"
}, null, -1), Sss = /* @__PURE__ */ e("circle", {
  cx: "44",
  cy: "128",
  r: "10"
}, null, -1), Hss = { key: 4 }, Ass = ["stroke"], Vss = ["stroke"], zss = ["stroke"], Zss = /* @__PURE__ */ e("circle", {
  cx: "44",
  cy: "128",
  r: "8"
}, null, -1), Css = /* @__PURE__ */ e("circle", {
  cx: "44",
  cy: "64",
  r: "8"
}, null, -1), bss = /* @__PURE__ */ e("circle", {
  cx: "44",
  cy: "192",
  r: "8"
}, null, -1), Lss = { key: 5 }, Bss = ["stroke"], Pss = ["stroke"], Wss = ["stroke"], Nss = /* @__PURE__ */ e("circle", {
  cx: "44",
  cy: "64",
  r: "12"
}, null, -1), Fss = /* @__PURE__ */ e("circle", {
  cx: "44",
  cy: "128",
  r: "12"
}, null, -1), Tss = /* @__PURE__ */ e("circle", {
  cx: "44",
  cy: "192",
  r: "12"
}, null, -1), Dss = {
  name: "PhListBullets"
}, CX1 = /* @__PURE__ */ $({
  ...Dss,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", nss, [
        e("line", {
          x1: "88",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sss),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rss),
        e("line", {
          x1: "88",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iss),
        lss,
        dss,
        kss
      ])) : o(i) === "duotone" ? (s(), r("g", css, [
        e("line", {
          x1: "88",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hss),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uss),
        e("line", {
          x1: "88",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ass),
        _ss,
        pss,
        yss
      ])) : o(i) === "fill" ? (s(), r("g", $ss, fss)) : o(i) === "light" ? (s(), r("g", gss, [
        e("line", {
          x1: "88",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xss),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jss),
        e("line", {
          x1: "88",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mss),
        Mss,
        vss,
        Sss
      ])) : o(i) === "thin" ? (s(), r("g", Hss, [
        e("line", {
          x1: "88",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ass),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vss),
        e("line", {
          x1: "88",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zss),
        Zss,
        Css,
        bss
      ])) : o(i) === "regular" ? (s(), r("g", Lss, [
        e("line", {
          x1: "88",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bss),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pss),
        e("line", {
          x1: "88",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wss),
        Nss,
        Fss,
        Tss
      ])) : g("", !0)
    ], 16, tss));
  }
}), Rss = ["width", "height", "fill", "transform"], Uss = { key: 0 }, qss = ["stroke"], Gss = ["stroke"], Ess = ["stroke"], Oss = ["stroke"], Iss = ["stroke"], Kss = ["stroke"], Xss = { key: 1 }, Jss = ["stroke"], Qss = ["stroke"], Yss = ["stroke"], ors = ["stroke"], ers = ["stroke"], trs = ["stroke"], nrs = { key: 2 }, srs = /* @__PURE__ */ e("path", { d: "M224,128a8,8,0,0,1-8,8H128a8,8,0,0,1,0-16h88A8,8,0,0,1,224,128ZM128,72h88a8,8,0,0,0,0-16H128a8,8,0,0,0,0,16Zm88,112H128a8,8,0,0,0,0,16h88a8,8,0,0,0,0-16ZM86.6,42.1l-29.3,27-11.9-11A8,8,0,0,0,34.6,69.9l17.3,16A8,8,0,0,0,57.3,88a8.2,8.2,0,0,0,5.5-2.1l34.6-32A8,8,0,1,0,86.6,42.1Zm0,64-29.3,27-11.9-11a8,8,0,1,0-10.8,11.8l17.3,16a8,8,0,0,0,5.4,2.1,8.2,8.2,0,0,0,5.5-2.1l34.6-32a8,8,0,1,0-10.8-11.8Zm0,64-29.3,27-11.9-11a8,8,0,1,0-10.8,11.8l17.3,16a8,8,0,0,0,5.4,2.1,8.2,8.2,0,0,0,5.5-2.1l34.6-32a8,8,0,0,0-10.8-11.8Z" }, null, -1), rrs = [
  srs
], irs = { key: 3 }, lrs = ["stroke"], drs = ["stroke"], krs = ["stroke"], crs = ["stroke"], hrs = ["stroke"], urs = ["stroke"], ars = { key: 4 }, _rs = ["stroke"], prs = ["stroke"], yrs = ["stroke"], $rs = ["stroke"], wrs = ["stroke"], frs = ["stroke"], grs = { key: 5 }, xrs = ["stroke"], jrs = ["stroke"], mrs = ["stroke"], Mrs = ["stroke"], vrs = ["stroke"], Srs = ["stroke"], Hrs = {
  name: "PhListChecks"
}, bX1 = /* @__PURE__ */ $({
  ...Hrs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Uss, [
        e("line", {
          x1: "136",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qss),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gss),
        e("line", {
          x1: "136",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ess),
        e("polyline", {
          points: "92 48 57.3 80 40 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Oss),
        e("polyline", {
          points: "92 112 57.3 144 40 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Iss),
        e("polyline", {
          points: "92 176 57.3 208 40 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kss)
      ])) : o(i) === "duotone" ? (s(), r("g", Xss, [
        e("line", {
          x1: "128",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jss),
        e("line", {
          x1: "128",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qss),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yss),
        e("polyline", {
          points: "92 48 57.3 80 40 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ors),
        e("polyline", {
          points: "92 112 57.3 144 40 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ers),
        e("polyline", {
          points: "92 176 57.3 208 40 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, trs)
      ])) : o(i) === "fill" ? (s(), r("g", nrs, rrs)) : o(i) === "light" ? (s(), r("g", irs, [
        e("line", {
          x1: "128",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lrs),
        e("line", {
          x1: "128",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, drs),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, krs),
        e("polyline", {
          points: "92 48 57.3 80 40 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, crs),
        e("polyline", {
          points: "92 112 57.3 144 40 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hrs),
        e("polyline", {
          points: "92 176 57.3 208 40 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, urs)
      ])) : o(i) === "thin" ? (s(), r("g", ars, [
        e("line", {
          x1: "128",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _rs),
        e("line", {
          x1: "128",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, prs),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yrs),
        e("polyline", {
          points: "92 48 57.3 80 40 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $rs),
        e("polyline", {
          points: "92 112 57.3 144 40 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wrs),
        e("polyline", {
          points: "92 176 57.3 208 40 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, frs)
      ])) : o(i) === "regular" ? (s(), r("g", grs, [
        e("line", {
          x1: "128",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xrs),
        e("line", {
          x1: "128",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jrs),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mrs),
        e("polyline", {
          points: "92 48 57.3 80 40 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mrs),
        e("polyline", {
          points: "92 112 57.3 144 40 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vrs),
        e("polyline", {
          points: "92 176 57.3 208 40 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Srs)
      ])) : g("", !0)
    ], 16, Rss));
  }
}), Ars = ["width", "height", "fill", "transform"], Vrs = { key: 0 }, zrs = ["stroke"], Zrs = ["stroke"], Crs = ["stroke"], brs = ["stroke"], Lrs = ["stroke"], Brs = ["stroke"], Prs = { key: 1 }, Wrs = ["stroke"], Nrs = ["stroke"], Frs = ["stroke"], Trs = ["stroke"], Drs = ["stroke"], Rrs = ["stroke"], Urs = { key: 2 }, qrs = /* @__PURE__ */ e("path", { d: "M88,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H96A8,8,0,0,1,88,64Zm128,56H96a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,64H96a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM56,56H40a8,8,0,0,0,0,16H56a8,8,0,0,0,0-16Zm0,64H40a8,8,0,0,0,0,16H56a8,8,0,0,0,0-16Zm0,64H40a8,8,0,0,0,0,16H56a8,8,0,0,0,0-16Z" }, null, -1), Grs = [
  qrs
], Ers = { key: 3 }, Ors = ["stroke"], Irs = ["stroke"], Krs = ["stroke"], Xrs = ["stroke"], Jrs = ["stroke"], Qrs = ["stroke"], Yrs = { key: 4 }, ois = ["stroke"], eis = ["stroke"], tis = ["stroke"], nis = ["stroke"], sis = ["stroke"], ris = ["stroke"], iis = { key: 5 }, lis = ["stroke"], dis = ["stroke"], kis = ["stroke"], cis = ["stroke"], his = ["stroke"], uis = ["stroke"], ais = {
  name: "PhListDashes"
}, LX1 = /* @__PURE__ */ $({
  ...ais,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Vrs, [
        e("line", {
          x1: "96",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zrs),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zrs),
        e("line", {
          x1: "96",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Crs),
        e("line", {
          x1: "40",
          y1: "64",
          x2: "56",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, brs),
        e("line", {
          x1: "40",
          y1: "128",
          x2: "56",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lrs),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "56",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Brs)
      ])) : o(i) === "duotone" ? (s(), r("g", Prs, [
        e("line", {
          x1: "96",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wrs),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nrs),
        e("line", {
          x1: "96",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Frs),
        e("line", {
          x1: "40",
          y1: "64",
          x2: "56",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Trs),
        e("line", {
          x1: "40",
          y1: "128",
          x2: "56",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Drs),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "56",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rrs)
      ])) : o(i) === "fill" ? (s(), r("g", Urs, Grs)) : o(i) === "light" ? (s(), r("g", Ers, [
        e("line", {
          x1: "96",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ors),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Irs),
        e("line", {
          x1: "96",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Krs),
        e("line", {
          x1: "40",
          y1: "64",
          x2: "56",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xrs),
        e("line", {
          x1: "40",
          y1: "128",
          x2: "56",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jrs),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "56",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qrs)
      ])) : o(i) === "thin" ? (s(), r("g", Yrs, [
        e("line", {
          x1: "96",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ois),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eis),
        e("line", {
          x1: "96",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tis),
        e("line", {
          x1: "40",
          y1: "64",
          x2: "56",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nis),
        e("line", {
          x1: "40",
          y1: "128",
          x2: "56",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sis),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "56",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ris)
      ])) : o(i) === "regular" ? (s(), r("g", iis, [
        e("line", {
          x1: "96",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lis),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dis),
        e("line", {
          x1: "96",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kis),
        e("line", {
          x1: "40",
          y1: "64",
          x2: "56",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cis),
        e("line", {
          x1: "40",
          y1: "128",
          x2: "56",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, his),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "56",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uis)
      ])) : g("", !0)
    ], 16, Ars));
  }
}), _is = ["width", "height", "fill", "transform"], pis = { key: 0 }, yis = ["stroke"], $is = ["stroke"], wis = ["stroke"], fis = ["stroke"], gis = ["stroke"], xis = { key: 1 }, jis = ["stroke"], mis = ["stroke"], Mis = ["stroke"], vis = ["stroke"], Sis = ["stroke"], His = { key: 2 }, Ais = /* @__PURE__ */ e("path", { d: "M224,128a8,8,0,0,1-8,8H104a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM104,72H216a8,8,0,0,0,0-16H104a8,8,0,0,0,0,16ZM216,184H104a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM43.6,67.2,48,64.9V108a8,8,0,0,0,16,0V52a7.9,7.9,0,0,0-3.8-6.8,8,8,0,0,0-7.8-.4l-16,8a8,8,0,1,0,7.2,14.4ZM72.2,170.3A21.5,21.5,0,0,0,76,158a22,22,0,0,0-42.3-8.6,8,8,0,0,0,14.8,6.3A5.8,5.8,0,0,1,54,152a6,6,0,0,1,6,6,5.7,5.7,0,0,1-.9,3.2l-25.5,34A8,8,0,0,0,40,208H68a8,8,0,0,0,0-16H56l16-21.4Z" }, null, -1), Vis = [
  Ais
], zis = { key: 3 }, Zis = ["stroke"], Cis = ["stroke"], bis = ["stroke"], Lis = ["stroke"], Bis = ["stroke"], Pis = { key: 4 }, Wis = ["stroke"], Nis = ["stroke"], Fis = ["stroke"], Tis = ["stroke"], Dis = ["stroke"], Ris = { key: 5 }, Uis = ["stroke"], qis = ["stroke"], Gis = ["stroke"], Eis = ["stroke"], Ois = ["stroke"], Iis = {
  name: "PhListNumbers"
}, BX1 = /* @__PURE__ */ $({
  ...Iis,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", pis, [
        e("line", {
          x1: "108",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yis),
        e("line", {
          x1: "108",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $is),
        e("line", {
          x1: "108",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wis),
        e("polyline", {
          points: "40 60 56 52 56 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fis),
        e("path", {
          d: "M41.1,152.6a14,14,0,1,1,24.5,13.2L40,200H68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gis)
      ])) : o(i) === "duotone" ? (s(), r("g", xis, [
        e("line", {
          x1: "104",
          y1: "128",
          x2: "216",
          y2: "128",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jis),
        e("line", {
          x1: "104",
          y1: "64",
          x2: "216",
          y2: "64",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mis),
        e("line", {
          x1: "104",
          y1: "192",
          x2: "216",
          y2: "192",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mis),
        e("polyline", {
          points: "40 60 56 52 56 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vis),
        e("path", {
          d: "M41.1,152.6a14,14,0,1,1,24.5,13.2L40,200H68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sis)
      ])) : o(i) === "fill" ? (s(), r("g", His, Vis)) : o(i) === "light" ? (s(), r("g", zis, [
        e("line", {
          x1: "104",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zis),
        e("line", {
          x1: "104",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cis),
        e("line", {
          x1: "104",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bis),
        e("polyline", {
          points: "40 60 56 52 56 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lis),
        e("path", {
          d: "M41.1,152.6a14,14,0,1,1,24.5,13.2L40,200H68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bis)
      ])) : o(i) === "thin" ? (s(), r("g", Pis, [
        e("line", {
          x1: "104",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wis),
        e("line", {
          x1: "104",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nis),
        e("line", {
          x1: "104",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fis),
        e("polyline", {
          points: "40 60 56 52 56 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Tis),
        e("path", {
          d: "M41.1,152.6a14,14,0,1,1,24.5,13.2L40,200H68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Dis)
      ])) : o(i) === "regular" ? (s(), r("g", Ris, [
        e("line", {
          x1: "104",
          y1: "128",
          x2: "216",
          y2: "128",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uis),
        e("line", {
          x1: "104",
          y1: "64",
          x2: "216",
          y2: "64",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qis),
        e("line", {
          x1: "104",
          y1: "192",
          x2: "216",
          y2: "192",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gis),
        e("polyline", {
          points: "40 60 56 52 56 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Eis),
        e("path", {
          d: "M41.1,152.6a14,14,0,1,1,24.5,13.2L40,200H68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ois)
      ])) : g("", !0)
    ], 16, _is));
  }
}), Kis = ["width", "height", "fill", "transform"], Xis = { key: 0 }, Jis = ["stroke"], Qis = ["stroke"], Yis = ["stroke"], o1s = ["stroke"], e1s = ["stroke"], t1s = { key: 1 }, n1s = ["stroke"], s1s = ["stroke"], r1s = ["stroke"], i1s = ["stroke"], l1s = ["stroke"], d1s = { key: 2 }, k1s = /* @__PURE__ */ e("path", { d: "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm8,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm104,48H40a8,8,0,0,0,0,16H144a8,8,0,0,0,0-16Zm88,0H216V168a8,8,0,0,0-16,0v16H184a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V200h16a8,8,0,0,0,0-16Z" }, null, -1), c1s = [
  k1s
], h1s = { key: 3 }, u1s = ["stroke"], a1s = ["stroke"], _1s = ["stroke"], p1s = ["stroke"], y1s = ["stroke"], $1s = { key: 4 }, w1s = ["stroke"], f1s = ["stroke"], g1s = ["stroke"], x1s = ["stroke"], j1s = ["stroke"], m1s = { key: 5 }, M1s = ["stroke"], v1s = ["stroke"], S1s = ["stroke"], H1s = ["stroke"], A1s = ["stroke"], V1s = {
  name: "PhListPlus"
}, PX1 = /* @__PURE__ */ $({
  ...V1s,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Xis, [
        e("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jis),
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qis),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "144",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Yis),
        e("line", {
          x1: "184",
          y1: "192",
          x2: "232",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, o1s),
        e("line", {
          x1: "208",
          y1: "168",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, e1s)
      ])) : o(i) === "duotone" ? (s(), r("g", t1s, [
        e("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n1s),
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s1s),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "144",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r1s),
        e("line", {
          x1: "184",
          y1: "192",
          x2: "232",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, i1s),
        e("line", {
          x1: "208",
          y1: "168",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l1s)
      ])) : o(i) === "fill" ? (s(), r("g", d1s, c1s)) : o(i) === "light" ? (s(), r("g", h1s, [
        e("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u1s),
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, a1s),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "144",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _1s),
        e("line", {
          x1: "184",
          y1: "192",
          x2: "232",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, p1s),
        e("line", {
          x1: "208",
          y1: "168",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, y1s)
      ])) : o(i) === "thin" ? (s(), r("g", $1s, [
        e("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, w1s),
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, f1s),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "144",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, g1s),
        e("line", {
          x1: "184",
          y1: "192",
          x2: "232",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, x1s),
        e("line", {
          x1: "208",
          y1: "168",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, j1s)
      ])) : o(i) === "regular" ? (s(), r("g", m1s, [
        e("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M1s),
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v1s),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "144",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S1s),
        e("line", {
          x1: "184",
          y1: "192",
          x2: "232",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H1s),
        e("line", {
          x1: "208",
          y1: "168",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A1s)
      ])) : g("", !0)
    ], 16, Kis));
  }
}), z1s = ["width", "height", "fill", "transform"], Z1s = { key: 0 }, C1s = ["stroke"], b1s = ["stroke"], L1s = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "152",
  r: "16"
}, null, -1), B1s = { key: 1 }, P1s = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "88",
  width: "176",
  height: "128",
  rx: "8",
  opacity: "0.2"
}, null, -1), W1s = ["stroke"], N1s = ["stroke"], F1s = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "152",
  r: "12"
}, null, -1), T1s = { key: 2 }, D1s = /* @__PURE__ */ e("path", { d: "M208,80H172V52a44,44,0,0,0-88,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Zm-80,84a12,12,0,1,1,12-12A12,12,0,0,1,128,164Zm28-84H100V52a28,28,0,0,1,56,0Z" }, null, -1), R1s = [
  D1s
], U1s = { key: 3 }, q1s = ["stroke"], G1s = ["stroke"], E1s = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "152",
  r: "10"
}, null, -1), O1s = { key: 4 }, I1s = ["stroke"], K1s = ["stroke"], X1s = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "152",
  r: "8"
}, null, -1), J1s = { key: 5 }, Q1s = ["stroke"], Y1s = ["stroke"], ols = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "152",
  r: "12"
}, null, -1), els = {
  name: "PhLock"
}, WX1 = /* @__PURE__ */ $({
  ...els,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Z1s, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, C1s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, b1s),
        L1s
      ])) : o(i) === "duotone" ? (s(), r("g", B1s, [
        P1s,
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W1s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N1s),
        F1s
      ])) : o(i) === "fill" ? (s(), r("g", T1s, R1s)) : o(i) === "light" ? (s(), r("g", U1s, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, q1s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, G1s),
        E1s
      ])) : o(i) === "thin" ? (s(), r("g", O1s, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, I1s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, K1s),
        X1s
      ])) : o(i) === "regular" ? (s(), r("g", J1s, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q1s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y1s),
        ols
      ])) : g("", !0)
    ], 16, z1s));
  }
}), tls = ["width", "height", "fill", "transform"], nls = { key: 0 }, sls = ["stroke"], rls = ["stroke"], ils = ["stroke"], lls = ["stroke"], dls = { key: 1 }, kls = /* @__PURE__ */ e("path", {
  d: "M208,88H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V96A8,8,0,0,0,208,88Zm-80,72a20,20,0,1,1,20-20A20,20,0,0,1,128,160Z",
  opacity: "0.2"
}, null, -1), cls = ["stroke"], hls = ["stroke"], uls = ["stroke"], als = ["stroke"], _ls = { key: 2 }, pls = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "140",
  r: "12"
}, null, -1), yls = /* @__PURE__ */ e("path", { d: "M208,80H172V52a44,44,0,0,0-88,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Zm-72,86.8V184a8,8,0,0,1-16,0V166.8a28,28,0,1,1,16,0ZM156,80H100V52a28,28,0,0,1,56,0Z" }, null, -1), $ls = [
  pls,
  yls
], wls = { key: 3 }, fls = ["stroke"], gls = ["stroke"], xls = ["stroke"], jls = ["stroke"], mls = { key: 4 }, Mls = ["stroke"], vls = ["stroke"], Sls = ["stroke"], Hls = ["stroke"], Als = { key: 5 }, Vls = ["stroke"], zls = ["stroke"], Zls = ["stroke"], Cls = ["stroke"], bls = {
  name: "PhLockKey"
}, NX1 = /* @__PURE__ */ $({
  ...bls,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", nls, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sls),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rls),
        e("circle", {
          cx: "128",
          cy: "144",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ils),
        e("line", {
          x1: "128",
          y1: "164",
          x2: "128",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lls)
      ])) : o(i) === "duotone" ? (s(), r("g", dls, [
        kls,
        e("circle", {
          cx: "128",
          cy: "140",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cls),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hls),
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uls),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, als)
      ])) : o(i) === "fill" ? (s(), r("g", _ls, $ls)) : o(i) === "light" ? (s(), r("g", wls, [
        e("circle", {
          cx: "128",
          cy: "140",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fls),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gls),
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xls),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jls)
      ])) : o(i) === "thin" ? (s(), r("g", mls, [
        e("circle", {
          cx: "128",
          cy: "140",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Mls),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vls),
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Sls),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hls)
      ])) : o(i) === "regular" ? (s(), r("g", Als, [
        e("circle", {
          cx: "128",
          cy: "140",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vls),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zls),
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zls),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cls)
      ])) : g("", !0)
    ], 16, tls));
  }
}), Lls = ["width", "height", "fill", "transform"], Bls = { key: 0 }, Pls = ["stroke"], Wls = ["stroke"], Nls = ["stroke"], Fls = ["stroke"], Tls = { key: 1 }, Dls = /* @__PURE__ */ e("path", {
  d: "M208,88H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V96A8,8,0,0,0,208,88Zm-80,72a20,20,0,1,1,20-20A20,20,0,0,1,128,160Z",
  opacity: "0.2"
}, null, -1), Rls = ["stroke"], Uls = ["stroke"], qls = ["stroke"], Gls = ["stroke"], Els = { key: 2 }, Ols = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "140",
  r: "12"
}, null, -1), Ils = /* @__PURE__ */ e("path", { d: "M208,80H100V52a28,28,0,0,1,56,0,8,8,0,0,0,16,0,44,44,0,0,0-88,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Zm-72,86.8V184a8,8,0,0,1-16,0V166.8a28,28,0,1,1,16,0Z" }, null, -1), Kls = [
  Ols,
  Ils
], Xls = { key: 3 }, Jls = ["stroke"], Qls = ["stroke"], Yls = ["stroke"], o2s = ["stroke"], e2s = { key: 4 }, t2s = ["stroke"], n2s = ["stroke"], s2s = ["stroke"], r2s = ["stroke"], i2s = { key: 5 }, l2s = ["stroke"], d2s = ["stroke"], k2s = ["stroke"], c2s = ["stroke"], h2s = {
  name: "PhLockKeyOpen"
}, FX1 = /* @__PURE__ */ $({
  ...h2s,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Bls, [
        e("circle", {
          cx: "128",
          cy: "144",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pls),
        e("line", {
          x1: "128",
          y1: "164",
          x2: "128",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wls),
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nls),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,71.8-4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fls)
      ])) : o(i) === "duotone" ? (s(), r("g", Tls, [
        Dls,
        e("circle", {
          cx: "128",
          cy: "140",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rls),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uls),
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qls),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gls)
      ])) : o(i) === "fill" ? (s(), r("g", Els, Kls)) : o(i) === "light" ? (s(), r("g", Xls, [
        e("circle", {
          cx: "128",
          cy: "140",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jls),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qls),
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Yls),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, o2s)
      ])) : o(i) === "thin" ? (s(), r("g", e2s, [
        e("circle", {
          cx: "128",
          cy: "140",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, t2s),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, n2s),
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, s2s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, r2s)
      ])) : o(i) === "regular" ? (s(), r("g", i2s, [
        e("circle", {
          cx: "128",
          cy: "140",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l2s),
        e("line", {
          x1: "128",
          y1: "160",
          x2: "128",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, d2s),
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k2s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c2s)
      ])) : g("", !0)
    ], 16, Lls));
  }
}), u2s = ["width", "height", "fill", "transform"], a2s = { key: 0 }, _2s = ["stroke"], p2s = ["stroke"], y2s = ["stroke"], $2s = ["stroke"], w2s = { key: 1 }, f2s = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "88",
  width: "176",
  height: "128",
  rx: "8",
  opacity: "0.2"
}, null, -1), g2s = ["stroke"], x2s = ["stroke"], j2s = ["stroke"], m2s = ["stroke"], M2s = ["stroke"], v2s = { key: 2 }, S2s = /* @__PURE__ */ e("path", { d: "M208,80H172V52a44,44,0,0,0-88,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM100,52a28,28,0,0,1,56,0V80H100Zm84,140H72a8,8,0,0,1,0-16H184a8,8,0,0,1,0,16Zm0-32H72a8,8,0,0,1,0-16H184a8,8,0,0,1,0,16Zm0-32H72a8,8,0,0,1,0-16H184a8,8,0,0,1,0,16Z" }, null, -1), H2s = [
  S2s
], A2s = { key: 3 }, V2s = ["stroke"], z2s = ["stroke"], Z2s = ["stroke"], C2s = ["stroke"], b2s = ["stroke"], L2s = { key: 4 }, B2s = ["stroke"], P2s = ["stroke"], W2s = ["stroke"], N2s = ["stroke"], F2s = ["stroke"], T2s = { key: 5 }, D2s = ["stroke"], R2s = ["stroke"], U2s = ["stroke"], q2s = ["stroke"], G2s = ["stroke"], E2s = {
  name: "PhLockLaminated"
}, TX1 = /* @__PURE__ */ $({
  ...E2s,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", a2s, [
        e("line", {
          x1: "40",
          y1: "132",
          x2: "216",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _2s),
        e("line", {
          x1: "40",
          y1: "172",
          x2: "216",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, p2s),
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, y2s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $2s)
      ])) : o(i) === "duotone" ? (s(), r("g", w2s, [
        f2s,
        e("line", {
          x1: "40",
          y1: "120",
          x2: "216",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g2s),
        e("line", {
          x1: "40",
          y1: "152",
          x2: "216",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, x2s),
        e("line", {
          x1: "40",
          y1: "184",
          x2: "216",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j2s),
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m2s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M2s)
      ])) : o(i) === "fill" ? (s(), r("g", v2s, H2s)) : o(i) === "light" ? (s(), r("g", A2s, [
        e("line", {
          x1: "40",
          y1: "120",
          x2: "216",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, V2s),
        e("line", {
          x1: "40",
          y1: "152",
          x2: "216",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, z2s),
        e("line", {
          x1: "40",
          y1: "184",
          x2: "216",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Z2s),
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, C2s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b2s)
      ])) : o(i) === "thin" ? (s(), r("g", L2s, [
        e("line", {
          x1: "40",
          y1: "120",
          x2: "216",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, B2s),
        e("line", {
          x1: "40",
          y1: "152",
          x2: "216",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, P2s),
        e("line", {
          x1: "40",
          y1: "184",
          x2: "216",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, W2s),
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, N2s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, F2s)
      ])) : o(i) === "regular" ? (s(), r("g", T2s, [
        e("line", {
          x1: "40",
          y1: "120",
          x2: "216",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D2s),
        e("line", {
          x1: "40",
          y1: "152",
          x2: "216",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R2s),
        e("line", {
          x1: "40",
          y1: "184",
          x2: "216",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U2s),
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q2s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G2s)
      ])) : g("", !0)
    ], 16, u2s));
  }
}), O2s = ["width", "height", "fill", "transform"], I2s = { key: 0 }, K2s = ["stroke"], X2s = ["stroke"], J2s = ["stroke"], Q2s = ["stroke"], Y2s = { key: 1 }, o0s = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "88",
  width: "176",
  height: "128",
  rx: "8",
  opacity: "0.2"
}, null, -1), e0s = ["stroke"], t0s = ["stroke"], n0s = ["stroke"], s0s = ["stroke"], r0s = ["stroke"], i0s = { key: 2 }, l0s = /* @__PURE__ */ e("path", { d: "M208,80H100V52a28,28,0,0,1,56,0,8,8,0,0,0,16,0,44,44,0,0,0-88,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM184,192H72a8,8,0,0,1,0-16H184a8,8,0,0,1,0,16Zm0-32H72a8,8,0,0,1,0-16H184a8,8,0,0,1,0,16Zm0-32H72a8,8,0,0,1,0-16H184a8,8,0,0,1,0,16Z" }, null, -1), d0s = [
  l0s
], k0s = { key: 3 }, c0s = ["stroke"], h0s = ["stroke"], u0s = ["stroke"], a0s = ["stroke"], _0s = ["stroke"], p0s = { key: 4 }, y0s = ["stroke"], $0s = ["stroke"], w0s = ["stroke"], f0s = ["stroke"], g0s = ["stroke"], x0s = { key: 5 }, j0s = ["stroke"], m0s = ["stroke"], M0s = ["stroke"], v0s = ["stroke"], S0s = ["stroke"], H0s = {
  name: "PhLockLaminatedOpen"
}, DX1 = /* @__PURE__ */ $({
  ...H0s,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", I2s, [
        e("line", {
          x1: "40",
          y1: "132",
          x2: "216",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, K2s),
        e("line", {
          x1: "40",
          y1: "172",
          x2: "216",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X2s),
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, J2s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,71.8-4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Q2s)
      ])) : o(i) === "duotone" ? (s(), r("g", Y2s, [
        o0s,
        e("line", {
          x1: "40",
          y1: "120",
          x2: "216",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e0s),
        e("line", {
          x1: "40",
          y1: "152",
          x2: "216",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t0s),
        e("line", {
          x1: "40",
          y1: "184",
          x2: "216",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n0s),
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s0s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r0s)
      ])) : o(i) === "fill" ? (s(), r("g", i0s, d0s)) : o(i) === "light" ? (s(), r("g", k0s, [
        e("line", {
          x1: "40",
          y1: "120",
          x2: "216",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, c0s),
        e("line", {
          x1: "40",
          y1: "152",
          x2: "216",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, h0s),
        e("line", {
          x1: "40",
          y1: "184",
          x2: "216",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u0s),
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, a0s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _0s)
      ])) : o(i) === "thin" ? (s(), r("g", p0s, [
        e("line", {
          x1: "40",
          y1: "120",
          x2: "216",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, y0s),
        e("line", {
          x1: "40",
          y1: "152",
          x2: "216",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $0s),
        e("line", {
          x1: "40",
          y1: "184",
          x2: "216",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, w0s),
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, f0s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, g0s)
      ])) : o(i) === "regular" ? (s(), r("g", x0s, [
        e("line", {
          x1: "40",
          y1: "120",
          x2: "216",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j0s),
        e("line", {
          x1: "40",
          y1: "152",
          x2: "216",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m0s),
        e("line", {
          x1: "40",
          y1: "184",
          x2: "216",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M0s),
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v0s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S0s)
      ])) : g("", !0)
    ], 16, O2s));
  }
}), A0s = ["width", "height", "fill", "transform"], V0s = { key: 0 }, z0s = ["stroke"], Z0s = ["stroke"], C0s = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "152",
  r: "16"
}, null, -1), b0s = { key: 1 }, L0s = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "88",
  width: "176",
  height: "128",
  rx: "8",
  opacity: "0.2"
}, null, -1), B0s = ["stroke"], P0s = ["stroke"], W0s = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "152",
  r: "12"
}, null, -1), N0s = { key: 2 }, F0s = /* @__PURE__ */ e("path", { d: "M208,80H100V52a28,28,0,0,1,56,0,8,8,0,0,0,16,0,44,44,0,0,0-88,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Zm-80,84a12,12,0,1,1,12-12A12,12,0,0,1,128,164Z" }, null, -1), T0s = [
  F0s
], D0s = { key: 3 }, R0s = ["stroke"], U0s = ["stroke"], q0s = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "152",
  r: "10"
}, null, -1), G0s = { key: 4 }, E0s = ["stroke"], O0s = ["stroke"], I0s = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "152",
  r: "8"
}, null, -1), K0s = { key: 5 }, X0s = ["stroke"], J0s = ["stroke"], Q0s = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "152",
  r: "12"
}, null, -1), Y0s = {
  name: "PhLockOpen"
}, RX1 = /* @__PURE__ */ $({
  ...Y0s,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", V0s, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, z0s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,71.8-4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Z0s),
        C0s
      ])) : o(i) === "duotone" ? (s(), r("g", b0s, [
        L0s,
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B0s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P0s),
        W0s
      ])) : o(i) === "fill" ? (s(), r("g", N0s, T0s)) : o(i) === "light" ? (s(), r("g", D0s, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, R0s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, U0s),
        q0s
      ])) : o(i) === "thin" ? (s(), r("g", G0s, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, E0s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, O0s),
        I0s
      ])) : o(i) === "regular" ? (s(), r("g", K0s, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X0s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J0s),
        Q0s
      ])) : g("", !0)
    ], 16, A0s));
  }
}), o8s = ["width", "height", "fill", "transform"], e8s = { key: 0 }, t8s = ["stroke"], n8s = ["stroke"], s8s = { key: 1 }, r8s = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "88",
  width: "176",
  height: "128",
  rx: "8",
  opacity: "0.2"
}, null, -1), i8s = ["stroke"], l8s = ["stroke"], d8s = { key: 2 }, k8s = /* @__PURE__ */ e("path", { d: "M208,80H172V52a44,44,0,0,0-88,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM100,52a28,28,0,0,1,56,0V80H100Z" }, null, -1), c8s = [
  k8s
], h8s = { key: 3 }, u8s = ["stroke"], a8s = ["stroke"], _8s = { key: 4 }, p8s = ["stroke"], y8s = ["stroke"], $8s = { key: 5 }, w8s = ["stroke"], f8s = ["stroke"], g8s = {
  name: "PhLockSimple"
}, UX1 = /* @__PURE__ */ $({
  ...g8s,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", e8s, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, t8s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, n8s)
      ])) : o(i) === "duotone" ? (s(), r("g", s8s, [
        r8s,
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, i8s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l8s)
      ])) : o(i) === "fill" ? (s(), r("g", d8s, c8s)) : o(i) === "light" ? (s(), r("g", h8s, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u8s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, a8s)
      ])) : o(i) === "thin" ? (s(), r("g", _8s, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, p8s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, y8s)
      ])) : o(i) === "regular" ? (s(), r("g", $8s, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w8s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f8s)
      ])) : g("", !0)
    ], 16, o8s));
  }
}), x8s = ["width", "height", "fill", "transform"], j8s = { key: 0 }, m8s = ["stroke"], M8s = ["stroke"], v8s = { key: 1 }, S8s = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "88",
  width: "176",
  height: "128",
  rx: "8",
  opacity: "0.2"
}, null, -1), H8s = ["stroke"], A8s = ["stroke"], V8s = { key: 2 }, z8s = /* @__PURE__ */ e("path", { d: "M208,80H100V52a28,28,0,0,1,56,0,8,8,0,0,0,16,0,44,44,0,0,0-88,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Z" }, null, -1), Z8s = [
  z8s
], C8s = { key: 3 }, b8s = ["stroke"], L8s = ["stroke"], B8s = { key: 4 }, P8s = ["stroke"], W8s = ["stroke"], N8s = { key: 5 }, F8s = ["stroke"], T8s = ["stroke"], D8s = {
  name: "PhLockSimpleOpen"
}, qX1 = /* @__PURE__ */ $({
  ...D8s,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", j8s, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, m8s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,71.8-4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, M8s)
      ])) : o(i) === "duotone" ? (s(), r("g", v8s, [
        S8s,
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H8s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A8s)
      ])) : o(i) === "fill" ? (s(), r("g", V8s, Z8s)) : o(i) === "light" ? (s(), r("g", C8s, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b8s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, L8s)
      ])) : o(i) === "thin" ? (s(), r("g", B8s, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, P8s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, W8s)
      ])) : o(i) === "regular" ? (s(), r("g", N8s, [
        e("rect", {
          x: "40",
          y: "88",
          width: "176",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F8s),
        e("path", {
          d: "M92,88V52a36,36,0,0,1,72,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T8s)
      ])) : g("", !0)
    ], 16, x8s));
  }
}), R8s = ["width", "height", "fill", "transform"], U8s = { key: 0 }, q8s = ["stroke"], G8s = ["stroke"], E8s = ["stroke"], O8s = ["stroke"], I8s = ["stroke"], K8s = ["stroke"], X8s = ["stroke"], J8s = ["stroke"], Q8s = { key: 1 }, Y8s = /* @__PURE__ */ e("path", {
  d: "M69.7,218.3a8,8,0,0,1-11.4,0L37.7,197.7a8,8,0,0,1,0-11.4L144,80l32,32Z",
  opacity: "0.2"
}, null, -1), ods = ["stroke"], eds = ["stroke"], tds = ["stroke"], nds = ["stroke"], sds = ["stroke"], rds = ["stroke"], ids = ["stroke"], lds = ["stroke"], dds = { key: 2 }, kds = /* @__PURE__ */ e("path", { d: "M248,152a8,8,0,0,1-8,8H224v16a8,8,0,0,1-16,0V160H192a8,8,0,0,1,0-16h16V128a8,8,0,0,1,16,0v16h16A8,8,0,0,1,248,152ZM64,68H76V80a8,8,0,0,0,16,0V68h12a8,8,0,0,0,0-16H92V40a8,8,0,0,0-16,0V52H64a8,8,0,0,0,0,16ZM184,192h-8v-8a8,8,0,0,0-16,0v8h-8a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0v-8h8a8,8,0,0,0,0-16Zm-2.3-74.3L75.3,224a15.9,15.9,0,0,1-22.6,0L32,203.3a15.9,15.9,0,0,1,0-22.6L180.7,32a16.1,16.1,0,0,1,22.6,0L224,52.7a15.9,15.9,0,0,1,0,22.6l-42.3,42.4ZM155.3,80,176,100.7,212.7,64h0L192,43.3Z" }, null, -1), cds = [
  kds
], hds = { key: 3 }, uds = ["stroke"], ads = ["stroke"], _ds = ["stroke"], pds = ["stroke"], yds = ["stroke"], $ds = ["stroke"], wds = ["stroke"], fds = ["stroke"], gds = { key: 4 }, xds = ["stroke"], jds = ["stroke"], mds = ["stroke"], Mds = ["stroke"], vds = ["stroke"], Sds = ["stroke"], Hds = ["stroke"], Ads = ["stroke"], Vds = { key: 5 }, zds = ["stroke"], Zds = ["stroke"], Cds = ["stroke"], bds = ["stroke"], Lds = ["stroke"], Bds = ["stroke"], Pds = ["stroke"], Wds = ["stroke"], Nds = {
  name: "PhMagicWand"
}, GX1 = /* @__PURE__ */ $({
  ...Nds,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", U8s, [
        e("line", {
          x1: "220",
          y1: "128",
          x2: "220",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, q8s),
        e("line", {
          x1: "196",
          y1: "152",
          x2: "244",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, G8s),
        e("line", {
          x1: "80",
          y1: "36",
          x2: "80",
          y2: "76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, E8s),
        e("line", {
          x1: "60",
          y1: "56",
          x2: "100",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, O8s),
        e("line", {
          x1: "164",
          y1: "188",
          x2: "164",
          y2: "220",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, I8s),
        e("line", {
          x1: "148",
          y1: "204",
          x2: "180",
          y2: "204",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, K8s),
        e("rect", {
          x: "14.9",
          y: "105.4",
          width: "226.3",
          height: "45.25",
          rx: "8",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X8s),
        e("line", {
          x1: "144",
          y1: "80",
          x2: "176",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, J8s)
      ])) : o(i) === "duotone" ? (s(), r("g", Q8s, [
        Y8s,
        e("line", {
          x1: "216",
          y1: "128",
          x2: "216",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ods),
        e("line", {
          x1: "192",
          y1: "152",
          x2: "240",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eds),
        e("line", {
          x1: "84",
          y1: "40",
          x2: "84",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tds),
        e("line", {
          x1: "64",
          y1: "60",
          x2: "104",
          y2: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nds),
        e("line", {
          x1: "168",
          y1: "184",
          x2: "168",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sds),
        e("line", {
          x1: "152",
          y1: "200",
          x2: "184",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rds),
        e("rect", {
          x: "14.9",
          y: "105.4",
          width: "226.3",
          height: "45.25",
          rx: "8",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ids),
        e("line", {
          x1: "144",
          y1: "80",
          x2: "176",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lds)
      ])) : o(i) === "fill" ? (s(), r("g", dds, cds)) : o(i) === "light" ? (s(), r("g", hds, [
        e("line", {
          x1: "216",
          y1: "128",
          x2: "216",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uds),
        e("line", {
          x1: "192",
          y1: "152",
          x2: "240",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ads),
        e("line", {
          x1: "84",
          y1: "40",
          x2: "84",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _ds),
        e("line", {
          x1: "64",
          y1: "60",
          x2: "104",
          y2: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pds),
        e("line", {
          x1: "168",
          y1: "184",
          x2: "168",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yds),
        e("line", {
          x1: "152",
          y1: "200",
          x2: "184",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $ds),
        e("rect", {
          x: "14.9",
          y: "105.4",
          width: "226.3",
          height: "45.25",
          rx: "8",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wds),
        e("line", {
          x1: "144",
          y1: "80",
          x2: "176",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fds)
      ])) : o(i) === "thin" ? (s(), r("g", gds, [
        e("line", {
          x1: "216",
          y1: "128",
          x2: "216",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xds),
        e("line", {
          x1: "192",
          y1: "152",
          x2: "240",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jds),
        e("line", {
          x1: "84",
          y1: "40",
          x2: "84",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mds),
        e("line", {
          x1: "64",
          y1: "60",
          x2: "104",
          y2: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Mds),
        e("line", {
          x1: "168",
          y1: "184",
          x2: "168",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vds),
        e("line", {
          x1: "152",
          y1: "200",
          x2: "184",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Sds),
        e("rect", {
          x: "14.9",
          y: "105.4",
          width: "226.3",
          height: "45.25",
          rx: "8",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hds),
        e("line", {
          x1: "144",
          y1: "80",
          x2: "176",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ads)
      ])) : o(i) === "regular" ? (s(), r("g", Vds, [
        e("line", {
          x1: "216",
          y1: "128",
          x2: "216",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zds),
        e("line", {
          x1: "192",
          y1: "152",
          x2: "240",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zds),
        e("line", {
          x1: "84",
          y1: "40",
          x2: "84",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cds),
        e("line", {
          x1: "64",
          y1: "60",
          x2: "104",
          y2: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bds),
        e("line", {
          x1: "168",
          y1: "184",
          x2: "168",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lds),
        e("line", {
          x1: "152",
          y1: "200",
          x2: "184",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bds),
        e("rect", {
          x: "14.9",
          y: "105.4",
          width: "226.3",
          height: "45.25",
          rx: "8",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pds),
        e("line", {
          x1: "144",
          y1: "80",
          x2: "176",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wds)
      ])) : g("", !0)
    ], 16, R8s));
  }
}), Fds = ["width", "height", "fill", "transform"], Tds = { key: 0 }, Dds = ["stroke"], Rds = ["stroke"], Uds = ["stroke"], qds = { key: 1 }, Gds = /* @__PURE__ */ e("path", {
  d: "M126.8,162.4l39.8,39.8-32.9,32.3a8.1,8.1,0,0,1-11.3-.1L93.7,205.7a8.1,8.1,0,0,1,.1-11.4Z",
  opacity: "0.2"
}, null, -1), Eds = /* @__PURE__ */ e("path", {
  d: "M93.7,129.4,54,89.6,21.6,122.3a8,8,0,0,0,0,11.3l28.7,28.7a8.1,8.1,0,0,0,11.4-.1Z",
  opacity: "0.2"
}, null, -1), Ods = ["stroke"], Ids = ["stroke"], Kds = ["stroke"], Xds = { key: 2 }, Jds = /* @__PURE__ */ e("path", { d: "M207,50.2A87.7,87.7,0,0,0,144.6,24h-.3A87.3,87.3,0,0,0,82,49.8L48.3,83.9h0L15.9,116.7a16.1,16.1,0,0,0,.1,22.6l28.6,28.6a15.6,15.6,0,0,0,11.3,4.7H56a15.8,15.8,0,0,0,11.4-4.8l32-32.8h0L133,100.7a16.1,16.1,0,0,1,22.4-.2,15.7,15.7,0,0,1,4.7,11.2,17,17,0,0,1-4.9,12l-34.1,33h0L88.3,188.6a15.9,15.9,0,0,0-.2,22.8l28.6,28.7a16.3,16.3,0,0,0,22.6.1l32.9-32.4h0l33.6-32.9C240.2,140.5,240.8,84.6,207,50.2ZM55.9,156.6,27.3,128,54,100.9l28.5,28.5Zm72.2,72.1L99.4,200.1l27.3-26.5,28.5,28.5Z" }, null, -1), Qds = [
  Jds
], Yds = { key: 3 }, oks = ["stroke"], eks = ["stroke"], tks = ["stroke"], nks = { key: 4 }, sks = ["stroke"], rks = ["stroke"], iks = ["stroke"], lks = { key: 5 }, dks = ["stroke"], kks = ["stroke"], cks = ["stroke"], hks = {
  name: "PhMagnet"
}, EX1 = /* @__PURE__ */ $({
  ...hks,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Tds, [
        e("path", {
          d: "M127.3,95a24.1,24.1,0,0,1,33.6-.3c9.7,9.3,9.5,25.1-.1,34.7l-67,64.9a8.1,8.1,0,0,0-.1,11.4l28.7,28.7a8.1,8.1,0,0,0,11.3.1l66.4-65.2c31.2-31.2,32.1-82,1.2-113.4a80,80,0,0,0-113.6-.5L21.6,122.3a8,8,0,0,0,0,11.3l28.7,28.7a8.1,8.1,0,0,0,11.4-.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Dds),
        e("line", {
          x1: "126.8",
          y1: "162.4",
          x2: "166.6",
          y2: "202.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rds),
        e("line", {
          x1: "54",
          y1: "89.6",
          x2: "93.7",
          y2: "129.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Uds)
      ])) : o(i) === "duotone" ? (s(), r("g", qds, [
        Gds,
        Eds,
        e("path", {
          d: "M127.3,95a24.1,24.1,0,0,1,33.6-.3c9.7,9.3,9.5,25.1-.1,34.7l-67,64.9a8.1,8.1,0,0,0-.1,11.4l28.7,28.7a8.1,8.1,0,0,0,11.3.1l66.4-65.2c31.2-31.2,32.1-82,1.2-113.4a80,80,0,0,0-113.6-.5L21.6,122.3a8,8,0,0,0,0,11.3l28.7,28.7a8.1,8.1,0,0,0,11.4-.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ods),
        e("line", {
          x1: "126.8",
          y1: "162.4",
          x2: "166.6",
          y2: "202.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ids),
        e("line", {
          x1: "54",
          y1: "89.6",
          x2: "93.7",
          y2: "129.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kds)
      ])) : o(i) === "fill" ? (s(), r("g", Xds, Qds)) : o(i) === "light" ? (s(), r("g", Yds, [
        e("path", {
          d: "M127.3,95a24.1,24.1,0,0,1,33.6-.3c9.7,9.3,9.5,25.1-.1,34.7l-67,64.9a8.1,8.1,0,0,0-.1,11.4l28.7,28.7a8.1,8.1,0,0,0,11.3.1l66.4-65.2c31.2-31.2,32.1-82,1.2-113.4a80,80,0,0,0-113.6-.5L21.6,122.3a8,8,0,0,0,0,11.3l28.7,28.7a8.1,8.1,0,0,0,11.4-.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oks),
        e("line", {
          x1: "126.8",
          y1: "162.4",
          x2: "166.6",
          y2: "202.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eks),
        e("line", {
          x1: "54",
          y1: "89.6",
          x2: "93.7",
          y2: "129.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tks)
      ])) : o(i) === "thin" ? (s(), r("g", nks, [
        e("path", {
          d: "M127.3,95a24.1,24.1,0,0,1,33.6-.3c9.7,9.3,9.5,25.1-.1,34.7l-67,64.9a8.1,8.1,0,0,0-.1,11.4l28.7,28.7a8.1,8.1,0,0,0,11.3.1l66.4-65.2c31.2-31.2,32.1-82,1.2-113.4a80,80,0,0,0-113.6-.5L21.6,122.3a8,8,0,0,0,0,11.3l28.7,28.7a8.1,8.1,0,0,0,11.4-.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sks),
        e("line", {
          x1: "126.8",
          y1: "162.4",
          x2: "166.6",
          y2: "202.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rks),
        e("line", {
          x1: "54",
          y1: "89.6",
          x2: "93.7",
          y2: "129.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iks)
      ])) : o(i) === "regular" ? (s(), r("g", lks, [
        e("path", {
          d: "M127.3,95a24.1,24.1,0,0,1,33.6-.3c9.7,9.3,9.5,25.1-.1,34.7l-67,64.9a8.1,8.1,0,0,0-.1,11.4l28.7,28.7a8.1,8.1,0,0,0,11.3.1l66.4-65.2c31.2-31.2,32.1-82,1.2-113.4a80,80,0,0,0-113.6-.5L21.6,122.3a8,8,0,0,0,0,11.3l28.7,28.7a8.1,8.1,0,0,0,11.4-.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dks),
        e("line", {
          x1: "126.8",
          y1: "162.4",
          x2: "166.6",
          y2: "202.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kks),
        e("line", {
          x1: "54",
          y1: "89.6",
          x2: "93.7",
          y2: "129.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cks)
      ])) : g("", !0)
    ], 16, Fds));
  }
}), uks = ["width", "height", "fill", "transform"], aks = { key: 0 }, _ks = ["stroke"], pks = ["stroke"], yks = ["stroke"], $ks = { key: 1 }, wks = /* @__PURE__ */ e("path", {
  d: "M48,56a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8V96H48Z",
  opacity: "0.2"
}, null, -1), fks = /* @__PURE__ */ e("path", {
  d: "M152,56a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8V96H152Z",
  opacity: "0.2"
}, null, -1), gks = ["stroke"], xks = ["stroke"], jks = ["stroke"], mks = { key: 2 }, Mks = /* @__PURE__ */ e("path", { d: "M200,40H160a16,16,0,0,0-16,16v88a16,16,0,0,1-32,0V56A16,16,0,0,0,96,40H56A16,16,0,0,0,40,56v88a87.9,87.9,0,0,0,88,88h.7c48.1-.4,87.3-40.3,87.3-89V56A16,16,0,0,0,200,40Zm0,16V96H160V56ZM96,56V96H56V56Z" }, null, -1), vks = [
  Mks
], Sks = { key: 3 }, Hks = ["stroke"], Aks = ["stroke"], Vks = ["stroke"], zks = { key: 4 }, Zks = ["stroke"], Cks = ["stroke"], bks = ["stroke"], Lks = { key: 5 }, Bks = ["stroke"], Pks = ["stroke"], Wks = ["stroke"], Nks = {
  name: "PhMagnetStraight"
}, OX1 = /* @__PURE__ */ $({
  ...Nks,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", aks, [
        e("line", {
          x1: "48",
          y1: "96",
          x2: "104",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _ks),
        e("line", {
          x1: "152",
          y1: "96",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pks),
        e("path", {
          d: "M104,144a24,24,0,0,0,48,0V56a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8v87c0,44.1-35.3,80.7-79.4,81A80,80,0,0,1,48,144V56a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yks)
      ])) : o(i) === "duotone" ? (s(), r("g", $ks, [
        wks,
        fks,
        e("line", {
          x1: "48",
          y1: "96",
          x2: "104",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gks),
        e("line", {
          x1: "152",
          y1: "96",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xks),
        e("path", {
          d: "M104,144a24,24,0,0,0,48,0V56a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8v87c0,44.1-35.3,80.7-79.4,81A80,80,0,0,1,48,144V56a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jks)
      ])) : o(i) === "fill" ? (s(), r("g", mks, vks)) : o(i) === "light" ? (s(), r("g", Sks, [
        e("line", {
          x1: "48",
          y1: "96",
          x2: "104",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hks),
        e("line", {
          x1: "152",
          y1: "96",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Aks),
        e("path", {
          d: "M104,144a24,24,0,0,0,48,0V56a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8v87c0,44.1-35.3,80.7-79.4,81A80,80,0,0,1,48,144V56a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vks)
      ])) : o(i) === "thin" ? (s(), r("g", zks, [
        e("line", {
          x1: "48",
          y1: "96",
          x2: "104",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zks),
        e("line", {
          x1: "152",
          y1: "96",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cks),
        e("path", {
          d: "M104,144a24,24,0,0,0,48,0V56a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8v87c0,44.1-35.3,80.7-79.4,81A80,80,0,0,1,48,144V56a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bks)
      ])) : o(i) === "regular" ? (s(), r("g", Lks, [
        e("line", {
          x1: "48",
          y1: "96",
          x2: "104",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bks),
        e("line", {
          x1: "152",
          y1: "96",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pks),
        e("path", {
          d: "M104,144a24,24,0,0,0,48,0V56a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8v87c0,44.1-35.3,80.7-79.4,81A80,80,0,0,1,48,144V56a8,8,0,0,1,8-8H96a8,8,0,0,1,8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wks)
      ])) : g("", !0)
    ], 16, uks));
  }
}), Fks = ["width", "height", "fill", "transform"], Tks = { key: 0 }, Dks = ["stroke"], Rks = ["stroke"], Uks = { key: 1 }, qks = /* @__PURE__ */ e("circle", {
  cx: "116",
  cy: "116",
  r: "84",
  opacity: "0.2"
}, null, -1), Gks = ["stroke"], Eks = ["stroke"], Oks = { key: 2 }, Iks = /* @__PURE__ */ e("path", { d: "M176,116a60,60,0,1,1-60-60A60,60,0,0,1,176,116Zm53.6,113.7A8,8,0,0,1,224,232a8.3,8.3,0,0,1-5.7-2.3l-43.2-43.3a92.2,92.2,0,1,1,11.3-11.3l43.2,43.2A8,8,0,0,1,229.6,229.7ZM116,192a76,76,0,1,0-76-76A76.1,76.1,0,0,0,116,192Z" }, null, -1), Kks = [
  Iks
], Xks = { key: 3 }, Jks = ["stroke"], Qks = ["stroke"], Yks = { key: 4 }, ocs = ["stroke"], ecs = ["stroke"], tcs = { key: 5 }, ncs = ["stroke"], scs = ["stroke"], rcs = {
  name: "PhMagnifyingGlass"
}, IX1 = /* @__PURE__ */ $({
  ...rcs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Tks, [
        e("circle", {
          cx: "116",
          cy: "116",
          r: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Dks),
        e("line", {
          x1: "175.4",
          y1: "175.4",
          x2: "224",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rks)
      ])) : o(i) === "duotone" ? (s(), r("g", Uks, [
        qks,
        e("circle", {
          cx: "116",
          cy: "116",
          r: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gks),
        e("line", {
          x1: "175.4",
          y1: "175.4",
          x2: "224",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Eks)
      ])) : o(i) === "fill" ? (s(), r("g", Oks, Kks)) : o(i) === "light" ? (s(), r("g", Xks, [
        e("circle", {
          cx: "116",
          cy: "116",
          r: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jks),
        e("line", {
          x1: "175.4",
          y1: "175.4",
          x2: "224",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qks)
      ])) : o(i) === "thin" ? (s(), r("g", Yks, [
        e("circle", {
          cx: "116",
          cy: "116",
          r: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ocs),
        e("line", {
          x1: "175.4",
          y1: "175.4",
          x2: "224",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ecs)
      ])) : o(i) === "regular" ? (s(), r("g", tcs, [
        e("circle", {
          cx: "116",
          cy: "116",
          r: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ncs),
        e("line", {
          x1: "175.4",
          y1: "175.4",
          x2: "224",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, scs)
      ])) : g("", !0)
    ], 16, Fks));
  }
}), ics = ["width", "height", "fill", "transform"], lcs = { key: 0 }, dcs = ["stroke"], kcs = ["stroke"], ccs = ["stroke"], hcs = { key: 1 }, ucs = /* @__PURE__ */ e("circle", {
  cx: "116",
  cy: "116",
  r: "84",
  opacity: "0.2"
}, null, -1), acs = ["stroke"], _cs = ["stroke"], pcs = ["stroke"], ycs = { key: 2 }, $cs = /* @__PURE__ */ e("path", { d: "M229.6,218.3l-43.2-43.2a92.2,92.2,0,1,0-11.3,11.3l43.2,43.3A8.3,8.3,0,0,0,224,232a8,8,0,0,0,5.6-13.7ZM148,124H84a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z" }, null, -1), wcs = [
  $cs
], fcs = { key: 3 }, gcs = ["stroke"], xcs = ["stroke"], jcs = ["stroke"], mcs = { key: 4 }, Mcs = ["stroke"], vcs = ["stroke"], Scs = ["stroke"], Hcs = { key: 5 }, Acs = ["stroke"], Vcs = ["stroke"], zcs = ["stroke"], Zcs = {
  name: "PhMagnifyingGlassMinus"
}, KX1 = /* @__PURE__ */ $({
  ...Zcs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", lcs, [
        e("line", {
          x1: "84",
          y1: "116",
          x2: "148",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dcs),
        e("circle", {
          cx: "116",
          cy: "116",
          r: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kcs),
        e("line", {
          x1: "175.4",
          y1: "175.4",
          x2: "224",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ccs)
      ])) : o(i) === "duotone" ? (s(), r("g", hcs, [
        ucs,
        e("line", {
          x1: "84",
          y1: "116",
          x2: "148",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, acs),
        e("circle", {
          cx: "116",
          cy: "116",
          r: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _cs),
        e("line", {
          x1: "175.4",
          y1: "175.4",
          x2: "224",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pcs)
      ])) : o(i) === "fill" ? (s(), r("g", ycs, wcs)) : o(i) === "light" ? (s(), r("g", fcs, [
        e("line", {
          x1: "84",
          y1: "116",
          x2: "148",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gcs),
        e("circle", {
          cx: "116",
          cy: "116",
          r: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xcs),
        e("line", {
          x1: "175.4",
          y1: "175.4",
          x2: "224",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jcs)
      ])) : o(i) === "thin" ? (s(), r("g", mcs, [
        e("line", {
          x1: "84",
          y1: "116",
          x2: "148",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Mcs),
        e("circle", {
          cx: "116",
          cy: "116",
          r: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vcs),
        e("line", {
          x1: "175.4",
          y1: "175.4",
          x2: "224",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Scs)
      ])) : o(i) === "regular" ? (s(), r("g", Hcs, [
        e("line", {
          x1: "84",
          y1: "116",
          x2: "148",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Acs),
        e("circle", {
          cx: "116",
          cy: "116",
          r: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vcs),
        e("line", {
          x1: "175.4",
          y1: "175.4",
          x2: "224",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zcs)
      ])) : g("", !0)
    ], 16, ics));
  }
}), Ccs = ["width", "height", "fill", "transform"], bcs = { key: 0 }, Lcs = ["stroke"], Bcs = ["stroke"], Pcs = ["stroke"], Wcs = ["stroke"], Ncs = { key: 1 }, Fcs = /* @__PURE__ */ e("circle", {
  cx: "116",
  cy: "116",
  r: "84",
  opacity: "0.2"
}, null, -1), Tcs = ["stroke"], Dcs = ["stroke"], Rcs = ["stroke"], Ucs = ["stroke"], qcs = { key: 2 }, Gcs = /* @__PURE__ */ e("path", { d: "M229.6,218.3l-43.2-43.2a92.2,92.2,0,1,0-11.3,11.3l43.2,43.3A8.3,8.3,0,0,0,224,232a8,8,0,0,0,5.6-13.7ZM148,124H124v24a8,8,0,0,1-16,0V124H84a8,8,0,0,1,0-16h24V84a8,8,0,0,1,16,0v24h24a8,8,0,0,1,0,16Z" }, null, -1), Ecs = [
  Gcs
], Ocs = { key: 3 }, Ics = ["stroke"], Kcs = ["stroke"], Xcs = ["stroke"], Jcs = ["stroke"], Qcs = { key: 4 }, Ycs = ["stroke"], ohs = ["stroke"], ehs = ["stroke"], ths = ["stroke"], nhs = { key: 5 }, shs = ["stroke"], rhs = ["stroke"], ihs = ["stroke"], lhs = ["stroke"], dhs = {
  name: "PhMagnifyingGlassPlus"
}, XX1 = /* @__PURE__ */ $({
  ...dhs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", bcs, [
        e("line", {
          x1: "84",
          y1: "116",
          x2: "148",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lcs),
        e("line", {
          x1: "116",
          y1: "84",
          x2: "116",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bcs),
        e("circle", {
          cx: "116",
          cy: "116",
          r: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pcs),
        e("line", {
          x1: "175.4",
          y1: "175.4",
          x2: "224",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wcs)
      ])) : o(i) === "duotone" ? (s(), r("g", Ncs, [
        Fcs,
        e("line", {
          x1: "84",
          y1: "116",
          x2: "148",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tcs),
        e("line", {
          x1: "116",
          y1: "84",
          x2: "116",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dcs),
        e("circle", {
          cx: "116",
          cy: "116",
          r: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rcs),
        e("line", {
          x1: "175.4",
          y1: "175.4",
          x2: "224",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ucs)
      ])) : o(i) === "fill" ? (s(), r("g", qcs, Ecs)) : o(i) === "light" ? (s(), r("g", Ocs, [
        e("line", {
          x1: "84",
          y1: "116",
          x2: "148",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ics),
        e("line", {
          x1: "116",
          y1: "84",
          x2: "116",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kcs),
        e("circle", {
          cx: "116",
          cy: "116",
          r: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xcs),
        e("line", {
          x1: "175.4",
          y1: "175.4",
          x2: "224",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jcs)
      ])) : o(i) === "thin" ? (s(), r("g", Qcs, [
        e("line", {
          x1: "84",
          y1: "116",
          x2: "148",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ycs),
        e("line", {
          x1: "116",
          y1: "84",
          x2: "116",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ohs),
        e("circle", {
          cx: "116",
          cy: "116",
          r: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ehs),
        e("line", {
          x1: "175.4",
          y1: "175.4",
          x2: "224",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ths)
      ])) : o(i) === "regular" ? (s(), r("g", nhs, [
        e("line", {
          x1: "84",
          y1: "116",
          x2: "148",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, shs),
        e("line", {
          x1: "116",
          y1: "84",
          x2: "116",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rhs),
        e("circle", {
          cx: "116",
          cy: "116",
          r: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ihs),
        e("line", {
          x1: "175.4",
          y1: "175.4",
          x2: "224",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lhs)
      ])) : g("", !0)
    ], 16, Ccs));
  }
}), khs = ["width", "height", "fill", "transform"], chs = { key: 0 }, hhs = ["stroke"], uhs = ["stroke"], ahs = { key: 1 }, _hs = /* @__PURE__ */ e("path", {
  d: "M128,24a80,80,0,0,0-80,80c0,72,80,128,80,128s80-56,80-128A80,80,0,0,0,128,24Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,128,136Z",
  opacity: "0.2"
}, null, -1), phs = ["stroke"], yhs = ["stroke"], $hs = { key: 2 }, whs = /* @__PURE__ */ e("path", { d: "M128,16a88.1,88.1,0,0,0-88,88c0,75.3,80,132.2,83.4,134.6a8.3,8.3,0,0,0,9.2,0C136,236.2,216,179.3,216,104A88.1,88.1,0,0,0,128,16Zm0,56a32,32,0,1,1-32,32A32,32,0,0,1,128,72Z" }, null, -1), fhs = [
  whs
], ghs = { key: 3 }, xhs = ["stroke"], jhs = ["stroke"], mhs = { key: 4 }, Mhs = ["stroke"], vhs = ["stroke"], Shs = { key: 5 }, Hhs = ["stroke"], Ahs = ["stroke"], Vhs = {
  name: "PhMapPin"
}, JX1 = /* @__PURE__ */ $({
  ...Vhs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", chs, [
        e("circle", {
          cx: "128",
          cy: "104",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hhs),
        e("path", {
          d: "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uhs)
      ])) : o(i) === "duotone" ? (s(), r("g", ahs, [
        _hs,
        e("circle", {
          cx: "128",
          cy: "104",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, phs),
        e("path", {
          d: "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yhs)
      ])) : o(i) === "fill" ? (s(), r("g", $hs, fhs)) : o(i) === "light" ? (s(), r("g", ghs, [
        e("circle", {
          cx: "128",
          cy: "104",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xhs),
        e("path", {
          d: "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jhs)
      ])) : o(i) === "thin" ? (s(), r("g", mhs, [
        e("circle", {
          cx: "128",
          cy: "104",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Mhs),
        e("path", {
          d: "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vhs)
      ])) : o(i) === "regular" ? (s(), r("g", Shs, [
        e("circle", {
          cx: "128",
          cy: "104",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hhs),
        e("path", {
          d: "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ahs)
      ])) : g("", !0)
    ], 16, khs));
  }
}), zhs = ["width", "height", "fill", "transform"], Zhs = { key: 0 }, Chs = ["stroke"], bhs = ["stroke"], Lhs = ["stroke"], Bhs = { key: 1 }, Phs = /* @__PURE__ */ e("path", {
  d: "M128,24a80,80,0,0,0-80,80c0,72,80,128,80,128s80-56,80-128A80,80,0,0,0,128,24Zm0,112a32,32,0,1,1,32-32A32,32,0,0,1,128,136Z",
  opacity: "0.2"
}, null, -1), Whs = ["stroke"], Nhs = ["stroke"], Fhs = ["stroke"], Ths = { key: 2 }, Dhs = /* @__PURE__ */ e("path", { d: "M200,224H150.5A253.6,253.6,0,0,0,174,200.2c27.5-31.5,42-64.8,42-96.2a88,88,0,0,0-176,0c0,31.4,14.5,64.7,42,96.2A253.6,253.6,0,0,0,105.5,224H56a8,8,0,0,0,0,16H200a8,8,0,0,0,0-16ZM128,72a32,32,0,1,1-32,32A32,32,0,0,1,128,72Z" }, null, -1), Rhs = [
  Dhs
], Uhs = { key: 3 }, qhs = ["stroke"], Ghs = ["stroke"], Ehs = ["stroke"], Ohs = { key: 4 }, Ihs = ["stroke"], Khs = ["stroke"], Xhs = ["stroke"], Jhs = { key: 5 }, Qhs = ["stroke"], Yhs = ["stroke"], o6s = ["stroke"], e6s = {
  name: "PhMapPinLine"
}, QX1 = /* @__PURE__ */ $({
  ...e6s,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Zhs, [
        e("line", {
          x1: "56",
          y1: "232",
          x2: "200",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Chs),
        e("circle", {
          cx: "128",
          cy: "104",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bhs),
        e("path", {
          d: "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lhs)
      ])) : o(i) === "duotone" ? (s(), r("g", Bhs, [
        Phs,
        e("line", {
          x1: "56",
          y1: "232",
          x2: "200",
          y2: "232",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Whs),
        e("circle", {
          cx: "128",
          cy: "104",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nhs),
        e("path", {
          d: "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fhs)
      ])) : o(i) === "fill" ? (s(), r("g", Ths, Rhs)) : o(i) === "light" ? (s(), r("g", Uhs, [
        e("line", {
          x1: "56",
          y1: "232",
          x2: "200",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qhs),
        e("circle", {
          cx: "128",
          cy: "104",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ghs),
        e("path", {
          d: "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ehs)
      ])) : o(i) === "thin" ? (s(), r("g", Ohs, [
        e("line", {
          x1: "56",
          y1: "232",
          x2: "200",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ihs),
        e("circle", {
          cx: "128",
          cy: "104",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Khs),
        e("path", {
          d: "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xhs)
      ])) : o(i) === "regular" ? (s(), r("g", Jhs, [
        e("line", {
          x1: "56",
          y1: "232",
          x2: "200",
          y2: "232",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qhs),
        e("circle", {
          cx: "128",
          cy: "104",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yhs),
        e("path", {
          d: "M208,104c0,72-80,128-80,128S48,176,48,104a80,80,0,0,1,160,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o6s)
      ])) : g("", !0)
    ], 16, zhs));
  }
}), t6s = ["width", "height", "fill", "transform"], n6s = { key: 0 }, s6s = ["stroke"], r6s = ["stroke"], i6s = ["stroke"], l6s = { key: 1 }, d6s = /* @__PURE__ */ e("polygon", {
  points: "160 216 96 184 96 40 160 72 160 216",
  opacity: "0.2"
}, null, -1), k6s = ["stroke"], c6s = ["stroke"], h6s = ["stroke"], u6s = { key: 2 }, a6s = /* @__PURE__ */ e("path", { d: "M228.9,49.7a8,8,0,0,0-6.8-1.5L160.9,63.5,99.6,32.8h-.1l-.8-.3h-.2l-.7-.2h-.3l-.7-.2H94.1l-64,16A8,8,0,0,0,24,56V200a7.8,7.8,0,0,0,3.1,6.3A7.9,7.9,0,0,0,32,208l1.9-.2,61.2-15.3,61.3,30.7h.1l.7.3h.1l.8.3h3.8l64-16A8,8,0,0,0,232,200V56A7.8,7.8,0,0,0,228.9,49.7ZM152,203.1l-48-24V52.9l48,24Z" }, null, -1), _6s = [
  a6s
], p6s = { key: 3 }, y6s = ["stroke"], $6s = ["stroke"], w6s = ["stroke"], f6s = { key: 4 }, g6s = ["stroke"], x6s = ["stroke"], j6s = ["stroke"], m6s = { key: 5 }, M6s = ["stroke"], v6s = ["stroke"], S6s = ["stroke"], H6s = {
  name: "PhMapTrifold"
}, YX1 = /* @__PURE__ */ $({
  ...H6s,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", n6s, [
        e("polyline", {
          points: "96 184 32 200 32 56 96 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, s6s),
        e("polygon", {
          points: "160 216 96 184 96 40 160 72 160 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, r6s),
        e("polyline", {
          points: "160 72 224 56 224 200 160 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, i6s)
      ])) : o(i) === "duotone" ? (s(), r("g", l6s, [
        d6s,
        e("polyline", {
          points: "96 184 32 200 32 56 96 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k6s),
        e("polygon", {
          points: "160 216 96 184 96 40 160 72 160 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c6s),
        e("polyline", {
          points: "160 72 224 56 224 200 160 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h6s)
      ])) : o(i) === "fill" ? (s(), r("g", u6s, _6s)) : o(i) === "light" ? (s(), r("g", p6s, [
        e("polyline", {
          points: "96 184 32 200 32 56 96 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, y6s),
        e("polygon", {
          points: "160 216 96 184 96 40 160 72 160 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $6s),
        e("polyline", {
          points: "160 72 224 56 224 200 160 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, w6s)
      ])) : o(i) === "thin" ? (s(), r("g", f6s, [
        e("polyline", {
          points: "96 184 32 200 32 56 96 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, g6s),
        e("polygon", {
          points: "160 216 96 184 96 40 160 72 160 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, x6s),
        e("polyline", {
          points: "160 72 224 56 224 200 160 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, j6s)
      ])) : o(i) === "regular" ? (s(), r("g", m6s, [
        e("polyline", {
          points: "96 184 32 200 32 56 96 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M6s),
        e("polygon", {
          points: "160 216 96 184 96 40 160 72 160 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v6s),
        e("polyline", {
          points: "160 72 224 56 224 200 160 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S6s)
      ])) : g("", !0)
    ], 16, t6s));
  }
}), A6s = ["width", "height", "fill", "transform"], V6s = { key: 0 }, z6s = ["stroke"], Z6s = ["stroke"], C6s = ["stroke"], b6s = ["stroke"], L6s = { key: 1 }, B6s = /* @__PURE__ */ e("path", {
  d: "M176,211.2a96,96,0,1,0-96,0h0V176a8,8,0,0,1,8-8h8V144a8,8,0,0,1,8-8h4.2l12-57.6c1.7-8.5,13.9-8.5,15.6,0l12,57.6H152a8,8,0,0,1,8,8v24h8a8,8,0,0,1,8,8v35.2Z",
  opacity: "0.2"
}, null, -1), P6s = ["stroke"], W6s = ["stroke"], N6s = ["stroke"], F6s = ["stroke"], T6s = { key: 2 }, D6s = /* @__PURE__ */ e("path", { d: "M201.5,54.5a103.8,103.8,0,0,0-147,0,103.8,103.8,0,0,0,0,147,103.8,103.8,0,0,0,147,0,103.8,103.8,0,0,0,0-147ZM88,206.4V176h80v30.4A88.8,88.8,0,0,1,88,206.4ZM104,136h48v24H104Zm86.2,54.2c-2,2-4.1,3.9-6.2,5.7V176a16,16,0,0,0-16-16V136a16,16,0,0,0-13.7-15.8L143.6,73.3a16,16,0,0,0-31.2,0l-10.7,46.9A16,16,0,0,0,88,136v24a16,16,0,0,0-16,16v19.9c-2.1-1.8-4.2-3.7-6.2-5.7a88,88,0,1,1,124.4,0Z" }, null, -1), R6s = [
  D6s
], U6s = { key: 3 }, q6s = ["stroke"], G6s = ["stroke"], E6s = ["stroke"], O6s = ["stroke"], I6s = { key: 4 }, K6s = ["stroke"], X6s = ["stroke"], J6s = ["stroke"], Q6s = ["stroke"], Y6s = { key: 5 }, ous = ["stroke"], eus = ["stroke"], tus = ["stroke"], nus = ["stroke"], sus = {
  name: "PhMarkerCircle"
}, oJ1 = /* @__PURE__ */ $({
  ...sus,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", V6s, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, z6s),
        e("path", {
          d: "M176,211.2V176a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v35.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Z6s),
        e("path", {
          d: "M96,168V136a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, C6s),
        e("path", {
          d: "M147.8,128,135.7,84.4a8,8,0,0,0-15.4,0L108.2,128Z",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, b6s)
      ])) : o(i) === "duotone" ? (s(), r("g", L6s, [
        B6s,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P6s),
        e("path", {
          d: "M176,211.2V176a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v35.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W6s),
        e("path", {
          d: "M96,168V144a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N6s),
        e("path", {
          d: "M147.8,136l-12-57.6c-1.7-8.5-13.9-8.5-15.6,0l-12,57.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F6s)
      ])) : o(i) === "fill" ? (s(), r("g", T6s, R6s)) : o(i) === "light" ? (s(), r("g", U6s, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, q6s),
        e("path", {
          d: "M176,211.2V176a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v35.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, G6s),
        e("path", {
          d: "M96,168V144a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, E6s),
        e("path", {
          d: "M147.8,136l-12-57.6c-1.7-8.5-13.9-8.5-15.6,0l-12,57.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, O6s)
      ])) : o(i) === "thin" ? (s(), r("g", I6s, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, K6s),
        e("path", {
          d: "M176,211.2V176a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v35.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, X6s),
        e("path", {
          d: "M96,168V144a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, J6s),
        e("path", {
          d: "M147.8,136l-12-57.6c-1.7-8.5-13.9-8.5-15.6,0l-12,57.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Q6s)
      ])) : o(i) === "regular" ? (s(), r("g", Y6s, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ous),
        e("path", {
          d: "M176,211.2V176a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v35.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eus),
        e("path", {
          d: "M96,168V144a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tus),
        e("path", {
          d: "M147.8,136l-12-57.6c-1.7-8.5-13.9-8.5-15.6,0l-12,57.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nus)
      ])) : g("", !0)
    ], 16, A6s));
  }
}), rus = ["width", "height", "fill", "transform"], ius = { key: 0 }, lus = ["stroke"], dus = ["stroke"], kus = ["stroke"], cus = ["stroke"], hus = { key: 1 }, uus = /* @__PURE__ */ e("polygon", {
  points: "56 72 200 72 128 144 56 72",
  opacity: "0.2"
}, null, -1), aus = ["stroke"], _us = ["stroke"], pus = ["stroke"], yus = ["stroke"], $us = { key: 2 }, wus = /* @__PURE__ */ e("path", { d: "M237.7,45.7a8.4,8.4,0,0,0,1.7-8.8A8,8,0,0,0,232,32H24a8,8,0,0,0-7.4,4.9,8.4,8.4,0,0,0,1.7,8.8L120,147.3V208H88a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16H136V147.3Zm-25,2.3-16,16H59.3l-16-16Z" }, null, -1), fus = [
  wus
], gus = { key: 3 }, xus = ["stroke"], jus = ["stroke"], mus = ["stroke"], Mus = ["stroke"], vus = { key: 4 }, Sus = ["stroke"], Hus = ["stroke"], Aus = ["stroke"], Vus = ["stroke"], zus = { key: 5 }, Zus = ["stroke"], Cus = ["stroke"], bus = ["stroke"], Lus = ["stroke"], Bus = {
  name: "PhMartini"
}, eJ1 = /* @__PURE__ */ $({
  ...Bus,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ius, [
        e("polygon", {
          points: "24 40 232 40 128 144 24 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lus),
        e("line", {
          x1: "128",
          y1: "144",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dus),
        e("line", {
          x1: "88",
          y1: "216",
          x2: "168",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kus),
        e("line", {
          x1: "60",
          y1: "76",
          x2: "196",
          y2: "76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cus)
      ])) : o(i) === "duotone" ? (s(), r("g", hus, [
        uus,
        e("polygon", {
          points: "24 40 232 40 128 144 24 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aus),
        e("line", {
          x1: "128",
          y1: "144",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _us),
        e("line", {
          x1: "88",
          y1: "216",
          x2: "168",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pus),
        e("line", {
          x1: "56",
          y1: "72",
          x2: "200",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yus)
      ])) : o(i) === "fill" ? (s(), r("g", $us, fus)) : o(i) === "light" ? (s(), r("g", gus, [
        e("polygon", {
          points: "24 40 232 40 128 144 24 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xus),
        e("line", {
          x1: "128",
          y1: "144",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jus),
        e("line", {
          x1: "88",
          y1: "216",
          x2: "168",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mus),
        e("line", {
          x1: "56",
          y1: "72",
          x2: "200",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mus)
      ])) : o(i) === "thin" ? (s(), r("g", vus, [
        e("polygon", {
          points: "24 40 232 40 128 144 24 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Sus),
        e("line", {
          x1: "128",
          y1: "144",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hus),
        e("line", {
          x1: "88",
          y1: "216",
          x2: "168",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Aus),
        e("line", {
          x1: "56",
          y1: "72",
          x2: "200",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vus)
      ])) : o(i) === "regular" ? (s(), r("g", zus, [
        e("polygon", {
          points: "24 40 232 40 128 144 24 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zus),
        e("line", {
          x1: "128",
          y1: "144",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cus),
        e("line", {
          x1: "88",
          y1: "216",
          x2: "168",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bus),
        e("line", {
          x1: "56",
          y1: "72",
          x2: "200",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lus)
      ])) : g("", !0)
    ], 16, rus));
  }
}), Pus = ["width", "height", "fill", "transform"], Wus = { key: 0 }, Nus = ["stroke"], Fus = ["stroke"], Tus = ["stroke"], Dus = ["stroke"], Rus = { key: 1 }, Uus = /* @__PURE__ */ e("path", {
  d: "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
  opacity: "0.2"
}, null, -1), qus = ["stroke"], Gus = ["stroke"], Eus = ["stroke"], Ous = ["stroke"], Ius = { key: 2 }, Kus = /* @__PURE__ */ e("path", { d: "M217,35.1a15.9,15.9,0,0,0-14.8-1.7C188.2,38.9,159.8,48,128,48S67.8,38.9,53.8,33.4A16,16,0,0,0,32,48.3V104c0,35.8,9.7,69.5,27.2,95s42.6,41,68.8,41,50.7-14.5,68.8-41S224,139.8,224,104V48.3A15.9,15.9,0,0,0,217,35.1ZM80.1,133.3a8,8,0,0,1-11.3.7,8,8,0,0,1-.6-11.3,31.8,31.8,0,0,1,47.6,0,8,8,0,0,1-.6,11.3,8.1,8.1,0,0,1-5.3,2,8,8,0,0,1-6-2.7,16,16,0,0,0-23.8,0ZM159,182.7a56.3,56.3,0,0,1-62,0,8.1,8.1,0,0,1-2.2-11.1,8,8,0,0,1,11.1-2.3,39.8,39.8,0,0,0,44.2,0,8,8,0,0,1,11.1,2.3A8.1,8.1,0,0,1,159,182.7ZM187.2,134a8.1,8.1,0,0,1-5.3,2,8,8,0,0,1-6-2.7,16,16,0,0,0-23.8,0,8,8,0,0,1-11.3.7,8,8,0,0,1-.6-11.3,31.8,31.8,0,0,1,47.6,0A8,8,0,0,1,187.2,134Z" }, null, -1), Xus = [
  Kus
], Jus = { key: 3 }, Qus = ["stroke"], Yus = ["stroke"], o4s = ["stroke"], e4s = ["stroke"], t4s = { key: 4 }, n4s = ["stroke"], s4s = ["stroke"], r4s = ["stroke"], i4s = ["stroke"], l4s = { key: 5 }, d4s = ["stroke"], k4s = ["stroke"], c4s = ["stroke"], h4s = ["stroke"], u4s = {
  name: "PhMaskHappy"
}, tJ1 = /* @__PURE__ */ $({
  ...u4s,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Wus, [
        e("path", {
          d: "M146.1,128a24,24,0,0,1,35.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nus),
        e("path", {
          d: "M74.1,128a24,24,0,0,1,35.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fus),
        e("path", {
          d: "M154.5,176a47.9,47.9,0,0,1-53,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Tus),
        e("path", {
          d: "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Dus)
      ])) : o(i) === "duotone" ? (s(), r("g", Rus, [
        Uus,
        e("path", {
          d: "M146.1,128a24,24,0,0,1,35.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qus),
        e("path", {
          d: "M74.1,128a24,24,0,0,1,35.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gus),
        e("path", {
          d: "M154.5,176a47.9,47.9,0,0,1-53,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Eus),
        e("path", {
          d: "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ous)
      ])) : o(i) === "fill" ? (s(), r("g", Ius, Xus)) : o(i) === "light" ? (s(), r("g", Jus, [
        e("path", {
          d: "M146.1,128a24,24,0,0,1,35.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qus),
        e("path", {
          d: "M74.1,128a24,24,0,0,1,35.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Yus),
        e("path", {
          d: "M154.5,176a47.9,47.9,0,0,1-53,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, o4s),
        e("path", {
          d: "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, e4s)
      ])) : o(i) === "thin" ? (s(), r("g", t4s, [
        e("path", {
          d: "M146.1,128a24,24,0,0,1,35.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, n4s),
        e("path", {
          d: "M74.1,128a24,24,0,0,1,35.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, s4s),
        e("path", {
          d: "M154.5,176a47.9,47.9,0,0,1-53,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, r4s),
        e("path", {
          d: "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, i4s)
      ])) : o(i) === "regular" ? (s(), r("g", l4s, [
        e("path", {
          d: "M146.1,128a24,24,0,0,1,35.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, d4s),
        e("path", {
          d: "M74.1,128a24,24,0,0,1,35.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k4s),
        e("path", {
          d: "M154.5,176a47.9,47.9,0,0,1-53,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c4s),
        e("path", {
          d: "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h4s)
      ])) : g("", !0)
    ], 16, Pus));
  }
}), a4s = ["width", "height", "fill", "transform"], _4s = { key: 0 }, p4s = ["stroke"], y4s = ["stroke"], $4s = ["stroke"], w4s = ["stroke"], f4s = { key: 1 }, g4s = /* @__PURE__ */ e("path", {
  d: "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
  opacity: "0.2"
}, null, -1), x4s = ["stroke"], j4s = ["stroke"], m4s = ["stroke"], M4s = ["stroke"], v4s = { key: 2 }, S4s = /* @__PURE__ */ e("path", { d: "M217,35.1a15.9,15.9,0,0,0-14.8-1.7C188.2,38.9,159.8,48,128,48S67.8,38.9,53.8,33.4A16,16,0,0,0,32,48.3V104c0,35.8,9.7,69.5,27.2,95s42.6,41,68.8,41,50.7-14.5,68.8-41S224,139.8,224,104V48.3A15.9,15.9,0,0,0,217,35.1ZM68.2,125.3a8,8,0,0,1,.6-11.3,8,8,0,0,1,11.3.7,16,16,0,0,0,23.8,0,8,8,0,0,1,11.3-.7,8,8,0,0,1,.6,11.3,31.8,31.8,0,0,1-47.6,0Zm93,63.1a8.1,8.1,0,0,1-11.1,2.3,39.8,39.8,0,0,0-44.2,0,8,8,0,0,1-11.1-2.3A8.1,8.1,0,0,1,97,177.3a56.3,56.3,0,0,1,62,0A8.1,8.1,0,0,1,161.2,188.4Zm26.6-63.1a31.8,31.8,0,0,1-47.6,0,8,8,0,0,1,.6-11.3,8,8,0,0,1,11.3.7,16,16,0,0,0,23.8,0,8,8,0,0,1,11.3-.7A8,8,0,0,1,187.8,125.3Z" }, null, -1), H4s = [
  S4s
], A4s = { key: 3 }, V4s = ["stroke"], z4s = ["stroke"], Z4s = ["stroke"], C4s = ["stroke"], b4s = { key: 4 }, L4s = ["stroke"], B4s = ["stroke"], P4s = ["stroke"], W4s = ["stroke"], N4s = { key: 5 }, F4s = ["stroke"], T4s = ["stroke"], D4s = ["stroke"], R4s = ["stroke"], U4s = {
  name: "PhMaskSad"
}, nJ1 = /* @__PURE__ */ $({
  ...U4s,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", _4s, [
        e("path", {
          d: "M146.1,120a24,24,0,0,0,35.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, p4s),
        e("path", {
          d: "M74.1,120a24,24,0,0,0,35.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, y4s),
        e("path", {
          d: "M154.5,184a47.9,47.9,0,0,0-53,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $4s),
        e("path", {
          d: "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, w4s)
      ])) : o(i) === "duotone" ? (s(), r("g", f4s, [
        g4s,
        e("path", {
          d: "M146.1,120a24,24,0,0,0,35.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, x4s),
        e("path", {
          d: "M74.1,120a24,24,0,0,0,35.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j4s),
        e("path", {
          d: "M154.5,184a47.9,47.9,0,0,0-53,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m4s),
        e("path", {
          d: "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M4s)
      ])) : o(i) === "fill" ? (s(), r("g", v4s, H4s)) : o(i) === "light" ? (s(), r("g", A4s, [
        e("path", {
          d: "M146.1,120a24,24,0,0,0,35.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, V4s),
        e("path", {
          d: "M74.1,120a24,24,0,0,0,35.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, z4s),
        e("path", {
          d: "M154.5,184a47.9,47.9,0,0,0-53,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Z4s),
        e("path", {
          d: "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, C4s)
      ])) : o(i) === "thin" ? (s(), r("g", b4s, [
        e("path", {
          d: "M146.1,120a24,24,0,0,0,35.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, L4s),
        e("path", {
          d: "M74.1,120a24,24,0,0,0,35.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, B4s),
        e("path", {
          d: "M154.5,184a47.9,47.9,0,0,0-53,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, P4s),
        e("path", {
          d: "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, W4s)
      ])) : o(i) === "regular" ? (s(), r("g", N4s, [
        e("path", {
          d: "M146.1,120a24,24,0,0,0,35.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F4s),
        e("path", {
          d: "M74.1,120a24,24,0,0,0,35.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T4s),
        e("path", {
          d: "M154.5,184a47.9,47.9,0,0,0-53,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D4s),
        e("path", {
          d: "M216,48.3a7.9,7.9,0,0,0-10.9-7.4C190,46.7,160.9,56,128,56S66,46.7,50.9,40.9A7.9,7.9,0,0,0,40,48.3V104c0,70.7,39.4,128,88,128s88-57.3,88-128Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R4s)
      ])) : g("", !0)
    ], 16, a4s));
  }
}), q4s = ["width", "height", "fill", "transform"], G4s = { key: 0 }, E4s = ["stroke"], O4s = ["stroke"], I4s = ["stroke"], K4s = ["stroke"], X4s = ["stroke"], J4s = ["stroke"], Q4s = ["stroke"], Y4s = { key: 1 }, oas = ["stroke"], eas = ["stroke"], tas = ["stroke"], nas = ["stroke"], sas = ["stroke"], ras = ["stroke"], ias = ["stroke"], las = { key: 2 }, das = /* @__PURE__ */ j('<path d="M104,176H80V152a8,8,0,0,0-16,0v24H40a8,8,0,0,0,0,16H64v24a8,8,0,0,0,16,0V192h24a8,8,0,0,0,0-16Z"></path><path d="M104,64H40a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z"></path><path d="M152,176.1h64a8,8,0,0,0,0-16H152a8,8,0,0,0,0,16Z"></path><path d="M216,191.9H152a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z"></path><path d="M154.3,101.7a8.2,8.2,0,0,0,11.4,0L184,83.3l18.3,18.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4L195.3,72l18.4-18.3a8.1,8.1,0,0,0-11.4-11.4L184,60.7,165.7,42.3a8.1,8.1,0,0,0-11.4,11.4L172.7,72,154.3,90.3A8.1,8.1,0,0,0,154.3,101.7Z"></path>', 5), kas = [
  das
], cas = { key: 3 }, has = ["stroke"], uas = ["stroke"], aas = ["stroke"], _as = ["stroke"], pas = ["stroke"], yas = ["stroke"], $as = ["stroke"], was = { key: 4 }, fas = ["stroke"], gas = ["stroke"], xas = ["stroke"], jas = ["stroke"], mas = ["stroke"], Mas = ["stroke"], vas = ["stroke"], Sas = { key: 5 }, Has = ["stroke"], Aas = ["stroke"], Vas = ["stroke"], zas = ["stroke"], Zas = ["stroke"], Cas = ["stroke"], bas = ["stroke"], Las = {
  name: "PhMathOperations"
}, sJ1 = /* @__PURE__ */ $({
  ...Las,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", G4s, [
        e("line", {
          x1: "40",
          y1: "184",
          x2: "104",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, E4s),
        e("line", {
          x1: "72",
          y1: "152",
          x2: "72",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, O4s),
        e("line", {
          x1: "104",
          y1: "72",
          x2: "40",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, I4s),
        e("line", {
          x1: "216",
          y1: "164.1",
          x2: "152",
          y2: "164.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, K4s),
        e("line", {
          x1: "216",
          y1: "203.9",
          x2: "152",
          y2: "203.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X4s),
        e("line", {
          x1: "208",
          y1: "48",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, J4s),
        e("line", {
          x1: "208",
          y1: "96",
          x2: "160",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Q4s)
      ])) : o(i) === "duotone" ? (s(), r("g", Y4s, [
        e("line", {
          x1: "40",
          y1: "184",
          x2: "104",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oas),
        e("line", {
          x1: "72",
          y1: "152",
          x2: "72",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eas),
        e("line", {
          x1: "104",
          y1: "72",
          x2: "40",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tas),
        e("line", {
          x1: "216",
          y1: "168.1",
          x2: "152",
          y2: "168.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nas),
        e("line", {
          x1: "216",
          y1: "199.9",
          x2: "152",
          y2: "199.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sas),
        e("line", {
          x1: "208",
          y1: "48",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ras),
        e("line", {
          x1: "208",
          y1: "96",
          x2: "160",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ias)
      ])) : o(i) === "fill" ? (s(), r("g", las, kas)) : o(i) === "light" ? (s(), r("g", cas, [
        e("line", {
          x1: "40",
          y1: "184",
          x2: "104",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, has),
        e("line", {
          x1: "72",
          y1: "152",
          x2: "72",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uas),
        e("line", {
          x1: "104",
          y1: "72",
          x2: "40",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aas),
        e("line", {
          x1: "216",
          y1: "168.1",
          x2: "152",
          y2: "168.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _as),
        e("line", {
          x1: "216",
          y1: "199.9",
          x2: "152",
          y2: "199.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pas),
        e("line", {
          x1: "208",
          y1: "48",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yas),
        e("line", {
          x1: "208",
          y1: "96",
          x2: "160",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $as)
      ])) : o(i) === "thin" ? (s(), r("g", was, [
        e("line", {
          x1: "40",
          y1: "184",
          x2: "104",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fas),
        e("line", {
          x1: "72",
          y1: "152",
          x2: "72",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gas),
        e("line", {
          x1: "104",
          y1: "72",
          x2: "40",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xas),
        e("line", {
          x1: "216",
          y1: "168.1",
          x2: "152",
          y2: "168.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jas),
        e("line", {
          x1: "216",
          y1: "199.9",
          x2: "152",
          y2: "199.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mas),
        e("line", {
          x1: "208",
          y1: "48",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Mas),
        e("line", {
          x1: "208",
          y1: "96",
          x2: "160",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vas)
      ])) : o(i) === "regular" ? (s(), r("g", Sas, [
        e("line", {
          x1: "40",
          y1: "184",
          x2: "104",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Has),
        e("line", {
          x1: "72",
          y1: "152",
          x2: "72",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Aas),
        e("line", {
          x1: "104",
          y1: "72",
          x2: "40",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vas),
        e("line", {
          x1: "216",
          y1: "168.1",
          x2: "152",
          y2: "168.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zas),
        e("line", {
          x1: "216",
          y1: "199.9",
          x2: "152",
          y2: "199.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zas),
        e("line", {
          x1: "208",
          y1: "48",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cas),
        e("line", {
          x1: "208",
          y1: "96",
          x2: "160",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bas)
      ])) : g("", !0)
    ], 16, q4s));
  }
}), Bas = ["width", "height", "fill", "transform"], Pas = { key: 0 }, Was = ["stroke"], Nas = ["stroke"], Fas = ["stroke"], Tas = { key: 1 }, Das = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "96",
  r: "48",
  opacity: "0.2"
}, null, -1), Ras = ["stroke"], Uas = ["stroke"], qas = ["stroke"], Gas = { key: 2 }, Eas = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "96",
  r: "56"
}, null, -1), Oas = /* @__PURE__ */ e("path", { d: "M128,8A87.9,87.9,0,0,0,72,163.8V240a7.9,7.9,0,0,0,3.8,6.8,8,8,0,0,0,7.8.4L128,224.9l44.4,22.3a9.4,9.4,0,0,0,3.6.8,8,8,0,0,0,8-8V163.8A87.9,87.9,0,0,0,128,8Zm0,160a72,72,0,1,1,72-72A72.1,72.1,0,0,1,128,168Z" }, null, -1), Ias = [
  Eas,
  Oas
], Kas = { key: 3 }, Xas = ["stroke"], Jas = ["stroke"], Qas = ["stroke"], Yas = { key: 4 }, o_s = ["stroke"], e_s = ["stroke"], t_s = ["stroke"], n_s = { key: 5 }, s_s = ["stroke"], r_s = ["stroke"], i_s = ["stroke"], l_s = {
  name: "PhMedal"
}, rJ1 = /* @__PURE__ */ $({
  ...l_s,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Pas, [
        e("circle", {
          cx: "128",
          cy: "96",
          r: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Was),
        e("circle", {
          cx: "128",
          cy: "96",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nas),
        e("polyline", {
          points: "176 160 176 240 128 216 80 240 80 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fas)
      ])) : o(i) === "duotone" ? (s(), r("g", Tas, [
        Das,
        e("circle", {
          cx: "128",
          cy: "96",
          r: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ras),
        e("circle", {
          cx: "128",
          cy: "96",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uas),
        e("polyline", {
          points: "176 160 176 240 128 216 80 240 80 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qas)
      ])) : o(i) === "fill" ? (s(), r("g", Gas, Ias)) : o(i) === "light" ? (s(), r("g", Kas, [
        e("circle", {
          cx: "128",
          cy: "96",
          r: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xas),
        e("circle", {
          cx: "128",
          cy: "96",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jas),
        e("polyline", {
          points: "176 160 176 240 128 216 80 240 80 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qas)
      ])) : o(i) === "thin" ? (s(), r("g", Yas, [
        e("circle", {
          cx: "128",
          cy: "96",
          r: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, o_s),
        e("circle", {
          cx: "128",
          cy: "96",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, e_s),
        e("polyline", {
          points: "176 160 176 240 128 216 80 240 80 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, t_s)
      ])) : o(i) === "regular" ? (s(), r("g", n_s, [
        e("circle", {
          cx: "128",
          cy: "96",
          r: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s_s),
        e("circle", {
          cx: "128",
          cy: "96",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r_s),
        e("polyline", {
          points: "176 160 176 240 128 216 80 240 80 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, i_s)
      ])) : g("", !0)
    ], 16, Bas));
  }
}), d_s = ["width", "height", "fill", "transform"], k_s = { key: 0 }, c_s = ["stroke"], h_s = ["stroke"], u_s = ["stroke"], a_s = { key: 1 }, __s = /* @__PURE__ */ e("ellipse", {
  cx: "72",
  cy: "128",
  rx: "56",
  ry: "60",
  opacity: "0.2"
}, null, -1), p_s = /* @__PURE__ */ e("ellipse", {
  cx: "184",
  cy: "128",
  rx: "24",
  ry: "56",
  opacity: "0.2"
}, null, -1), y_s = ["stroke"], $_s = ["stroke"], w_s = ["stroke"], f_s = { key: 2 }, g_s = /* @__PURE__ */ e("path", { d: "M136,128c0,37.5-28.7,68-64,68S8,165.5,8,128,36.7,60,72,60,136,90.5,136,128Zm48-64c-5.7,0-16.4,2.8-24.3,21.3-5,11.5-7.7,26.7-7.7,42.7s2.7,31.2,7.7,42.7c7.9,18.5,18.6,21.3,24.3,21.3s16.4-2.8,24.3-21.3c5-11.5,7.7-26.7,7.7-42.7s-2.7-31.2-7.7-42.7C200.4,66.8,189.7,64,184,64Zm56,0a8,8,0,0,0-8,8V184a8,8,0,0,0,16,0V72A8,8,0,0,0,240,64Z" }, null, -1), x_s = [
  g_s
], j_s = { key: 3 }, m_s = ["stroke"], M_s = ["stroke"], v_s = ["stroke"], S_s = { key: 4 }, H_s = ["stroke"], A_s = ["stroke"], V_s = ["stroke"], z_s = { key: 5 }, Z_s = ["stroke"], C_s = ["stroke"], b_s = ["stroke"], L_s = {
  name: "PhMediumLogo"
}, iJ1 = /* @__PURE__ */ $({
  ...L_s,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", k_s, [
        e("ellipse", {
          cx: "70",
          cy: "128",
          rx: "54",
          ry: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, c_s),
        e("ellipse", {
          cx: "182",
          cy: "128",
          rx: "22",
          ry: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, h_s),
        e("line", {
          x1: "240",
          y1: "72",
          x2: "240",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, u_s)
      ])) : o(i) === "duotone" ? (s(), r("g", a_s, [
        __s,
        p_s,
        e("ellipse", {
          cx: "72",
          cy: "128",
          rx: "56",
          ry: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y_s),
        e("ellipse", {
          cx: "184",
          cy: "128",
          rx: "24",
          ry: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $_s),
        e("line", {
          x1: "240",
          y1: "72",
          x2: "240",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w_s)
      ])) : o(i) === "fill" ? (s(), r("g", f_s, x_s)) : o(i) === "light" ? (s(), r("g", j_s, [
        e("ellipse", {
          cx: "72",
          cy: "128",
          rx: "56",
          ry: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, m_s),
        e("ellipse", {
          cx: "184",
          cy: "128",
          rx: "24",
          ry: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, M_s),
        e("line", {
          x1: "240",
          y1: "72",
          x2: "240",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, v_s)
      ])) : o(i) === "thin" ? (s(), r("g", S_s, [
        e("ellipse", {
          cx: "72",
          cy: "128",
          rx: "56",
          ry: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, H_s),
        e("ellipse", {
          cx: "184",
          cy: "128",
          rx: "24",
          ry: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, A_s),
        e("line", {
          x1: "240",
          y1: "72",
          x2: "240",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, V_s)
      ])) : o(i) === "regular" ? (s(), r("g", z_s, [
        e("ellipse", {
          cx: "72",
          cy: "128",
          rx: "56",
          ry: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z_s),
        e("ellipse", {
          cx: "184",
          cy: "128",
          rx: "24",
          ry: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C_s),
        e("line", {
          x1: "240",
          y1: "72",
          x2: "240",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b_s)
      ])) : g("", !0)
    ], 16, d_s));
  }
}), B_s = ["width", "height", "fill", "transform"], P_s = { key: 0 }, W_s = ["stroke"], N_s = ["stroke"], F_s = { key: 1 }, T_s = /* @__PURE__ */ e("path", {
  d: "M152,160h40a40,40,0,0,0,0-80H152Z",
  opacity: "0.2"
}, null, -1), D_s = ["stroke"], R_s = ["stroke"], U_s = { key: 2 }, q_s = /* @__PURE__ */ e("path", { d: "M240,120a48,48,0,0,0-48-48H152c-.5,0-52.4-.7-101.7-42.1a15.9,15.9,0,0,0-17.1-2.2A15.7,15.7,0,0,0,24,42.2V197.8a15.7,15.7,0,0,0,9.2,14.5,16.4,16.4,0,0,0,6.8,1.5,15.9,15.9,0,0,0,10.3-3.7c37.9-31.8,77.2-39.6,93.7-41.5v35.1a15.9,15.9,0,0,0,7.1,13.3l11,7.4a16.8,16.8,0,0,0,14.7,1.6,15.9,15.9,0,0,0,9.7-11.1l11.9-47.3A48.2,48.2,0,0,0,240,120Zm-69,91-11-7.3V168h21.8Zm21-59H160V88h32a32,32,0,0,1,0,64Z" }, null, -1), G_s = [
  q_s
], E_s = { key: 3 }, O_s = ["stroke"], I_s = ["stroke"], K_s = { key: 4 }, X_s = ["stroke"], J_s = ["stroke"], Q_s = { key: 5 }, Y_s = ["stroke"], ops = ["stroke"], eps = {
  name: "PhMegaphone"
}, lJ1 = /* @__PURE__ */ $({
  ...eps,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", P_s, [
        e("path", {
          d: "M144,79.5V203.1a7.9,7.9,0,0,0,4.4,7.1l18.7,9.3a7.9,7.9,0,0,0,11.3-5.2L192,160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, W_s),
        e("path", {
          d: "M192,160a40,40,0,0,0,0-80H152S97.5,80,45.1,36.1A8,8,0,0,0,32,42.2V197.8a8,8,0,0,0,13.1,6.1C97.5,160,152,160,152,160Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, N_s)
      ])) : o(i) === "duotone" ? (s(), r("g", F_s, [
        T_s,
        e("path", {
          d: "M152,80V203.7a7.9,7.9,0,0,0,3.6,6.7l11,7.3a8,8,0,0,0,12.2-4.7L192,160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D_s),
        e("path", {
          d: "M192,160a40,40,0,0,0,0-80H152S97.5,80,45.1,36.1A8,8,0,0,0,32,42.2V197.8a8,8,0,0,0,13.1,6.1C97.5,160,152,160,152,160Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R_s)
      ])) : o(i) === "fill" ? (s(), r("g", U_s, G_s)) : o(i) === "light" ? (s(), r("g", E_s, [
        e("path", {
          d: "M152,80V203.7a7.9,7.9,0,0,0,3.6,6.7l11,7.3a8,8,0,0,0,12.2-4.7L192,160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, O_s),
        e("path", {
          d: "M192,160a40,40,0,0,0,0-80H152S97.5,80,45.1,36.1A8,8,0,0,0,32,42.2V197.8a8,8,0,0,0,13.1,6.1C97.5,160,152,160,152,160Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, I_s)
      ])) : o(i) === "thin" ? (s(), r("g", K_s, [
        e("path", {
          d: "M152,80V203.7a7.9,7.9,0,0,0,3.6,6.7l11,7.3a8,8,0,0,0,12.2-4.7L192,160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, X_s),
        e("path", {
          d: "M192,160a40,40,0,0,0,0-80H152S97.5,80,45.1,36.1A8,8,0,0,0,32,42.2V197.8a8,8,0,0,0,13.1,6.1C97.5,160,152,160,152,160Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, J_s)
      ])) : o(i) === "regular" ? (s(), r("g", Q_s, [
        e("path", {
          d: "M152,80V203.7a7.9,7.9,0,0,0,3.6,6.7l11,7.3a8,8,0,0,0,12.2-4.7L192,160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y_s),
        e("path", {
          d: "M192,160a40,40,0,0,0,0-80H152S97.5,80,45.1,36.1A8,8,0,0,0,32,42.2V197.8a8,8,0,0,0,13.1,6.1C97.5,160,152,160,152,160Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ops)
      ])) : g("", !0)
    ], 16, B_s));
  }
}), tps = ["width", "height", "fill", "transform"], nps = { key: 0 }, sps = ["stroke"], rps = ["stroke"], ips = { key: 1 }, lps = /* @__PURE__ */ e("path", {
  d: "M42.2,43A8,8,0,0,0,32,50.7V189.3A8,8,0,0,0,42.2,197L136,169.7V70.3Z",
  opacity: "0.2"
}, null, -1), dps = ["stroke"], kps = ["stroke"], cps = { key: 2 }, hps = /* @__PURE__ */ e("path", { d: "M220.5,86.6,138.4,62.7h-.1L44.5,35.3a15.8,15.8,0,0,0-14.1,2.6A15.7,15.7,0,0,0,24,50.7V189.3a16,16,0,0,0,15.9,16,17.6,17.6,0,0,0,4.6-.6L128,180.3V192a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V161.7l28.5-8.3A16.1,16.1,0,0,0,232,138V102A16.1,16.1,0,0,0,220.5,86.6ZM176,192H144V175.7l32-9.4Zm40-54-34.4,10h0L144,159V81l72,21Z" }, null, -1), ups = [
  hps
], aps = { key: 3 }, _ps = ["stroke"], pps = ["stroke"], yps = { key: 4 }, $ps = ["stroke"], wps = ["stroke"], fps = { key: 5 }, gps = ["stroke"], xps = ["stroke"], jps = {
  name: "PhMegaphoneSimple"
}, dJ1 = /* @__PURE__ */ $({
  ...jps,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", nps, [
        e("path", {
          d: "M32,50.7V189.3A8,8,0,0,0,42.2,197l176-51.3A8,8,0,0,0,224,138V102a8,8,0,0,0-5.8-7.7L42.2,43A8,8,0,0,0,32,50.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sps),
        e("path", {
          d: "M184,155.7V192a8,8,0,0,1-8,8H144a8,8,0,0,1-8-8V70.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rps)
      ])) : o(i) === "duotone" ? (s(), r("g", ips, [
        lps,
        e("path", {
          d: "M32,50.7V189.3A8,8,0,0,0,42.2,197l176-51.3A8,8,0,0,0,224,138V102a8,8,0,0,0-5.8-7.7L42.2,43A8,8,0,0,0,32,50.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dps),
        e("path", {
          d: "M184,155.7V192a8,8,0,0,1-8,8H144a8,8,0,0,1-8-8V70.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kps)
      ])) : o(i) === "fill" ? (s(), r("g", cps, ups)) : o(i) === "light" ? (s(), r("g", aps, [
        e("path", {
          d: "M32,50.7V189.3A8,8,0,0,0,42.2,197l176-51.3A8,8,0,0,0,224,138V102a8,8,0,0,0-5.8-7.7L42.2,43A8,8,0,0,0,32,50.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _ps),
        e("path", {
          d: "M184,155.7V192a8,8,0,0,1-8,8H144a8,8,0,0,1-8-8V70.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pps)
      ])) : o(i) === "thin" ? (s(), r("g", yps, [
        e("path", {
          d: "M32,50.7V189.3A8,8,0,0,0,42.2,197l176-51.3A8,8,0,0,0,224,138V102a8,8,0,0,0-5.8-7.7L42.2,43A8,8,0,0,0,32,50.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $ps),
        e("path", {
          d: "M184,155.7V192a8,8,0,0,1-8,8H144a8,8,0,0,1-8-8V70.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wps)
      ])) : o(i) === "regular" ? (s(), r("g", fps, [
        e("path", {
          d: "M32,50.7V189.3A8,8,0,0,0,42.2,197l176-51.3A8,8,0,0,0,224,138V102a8,8,0,0,0-5.8-7.7L42.2,43A8,8,0,0,0,32,50.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gps),
        e("path", {
          d: "M184,155.7V192a8,8,0,0,1-8,8H144a8,8,0,0,1-8-8V70.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xps)
      ])) : g("", !0)
    ], 16, tps));
  }
}), mps = ["width", "height", "fill", "transform"], Mps = { key: 0 }, vps = ["stroke"], Sps = ["stroke"], Hps = { key: 1 }, Aps = /* @__PURE__ */ e("path", {
  d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
  opacity: "0.2"
}, null, -1), Vps = ["stroke"], zps = ["stroke"], Zps = { key: 2 }, Cps = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,0,0,36.8,178l-8.5,30A15.9,15.9,0,0,0,48,227.7l30-8.5A104,104,0,1,0,128,24Zm53.7,93.7-32,32a8.2,8.2,0,0,1-11.4,0L112,123.3,85.7,149.7a8.1,8.1,0,0,1-11.4-11.4l32-32a8.1,8.1,0,0,1,11.4,0L144,132.7l26.3-26.4a8.1,8.1,0,0,1,11.4,11.4Z" }, null, -1), bps = [
  Cps
], Lps = { key: 3 }, Bps = ["stroke"], Pps = ["stroke"], Wps = { key: 4 }, Nps = ["stroke"], Fps = ["stroke"], Tps = { key: 5 }, Dps = ["stroke"], Rps = ["stroke"], Ups = {
  name: "PhMessengerLogo"
}, kJ1 = /* @__PURE__ */ $({
  ...Ups,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Mps, [
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vps),
        e("polyline", {
          points: "80 144 112 112 144 144 176 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Sps)
      ])) : o(i) === "duotone" ? (s(), r("g", Hps, [
        Aps,
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vps),
        e("polyline", {
          points: "80 144 112 112 144 144 176 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zps)
      ])) : o(i) === "fill" ? (s(), r("g", Zps, bps)) : o(i) === "light" ? (s(), r("g", Lps, [
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bps),
        e("polyline", {
          points: "80 144 112 112 144 144 176 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pps)
      ])) : o(i) === "thin" ? (s(), r("g", Wps, [
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nps),
        e("polyline", {
          points: "80 144 112 112 144 144 176 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fps)
      ])) : o(i) === "regular" ? (s(), r("g", Tps, [
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dps),
        e("polyline", {
          points: "80 144 112 112 144 144 176 112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rps)
      ])) : g("", !0)
    ], 16, mps));
  }
}), qps = ["width", "height", "fill", "transform"], Gps = { key: 0 }, Eps = ["stroke"], Ops = ["stroke"], Ips = ["stroke"], Kps = { key: 1 }, Xps = /* @__PURE__ */ e("rect", {
  x: "88",
  y: "24",
  width: "80",
  height: "144",
  rx: "40",
  opacity: "0.2"
}, null, -1), Jps = ["stroke"], Qps = ["stroke"], Yps = ["stroke"], o3s = { key: 2 }, e3s = /* @__PURE__ */ e("path", { d: "M128,176a48,48,0,0,0,48-48V64a48,48,0,0,0-96,0v64A48,48,0,0,0,128,176Z" }, null, -1), t3s = /* @__PURE__ */ e("path", { d: "M200.4,128.1a8,8,0,0,0-8.8,7,64,64,0,0,1-127.2,0,8,8,0,0,0-8.8-7,7.9,7.9,0,0,0-7.1,8.8A79.7,79.7,0,0,0,120,207.3V232a8,8,0,0,0,16,0V207.3a79.7,79.7,0,0,0,71.5-70.4A7.9,7.9,0,0,0,200.4,128.1Z" }, null, -1), n3s = [
  e3s,
  t3s
], s3s = { key: 3 }, r3s = ["stroke"], i3s = ["stroke"], l3s = ["stroke"], d3s = { key: 4 }, k3s = ["stroke"], c3s = ["stroke"], h3s = ["stroke"], u3s = { key: 5 }, a3s = ["stroke"], _3s = ["stroke"], p3s = ["stroke"], y3s = {
  name: "PhMicrophone"
}, cJ1 = /* @__PURE__ */ $({
  ...y3s,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Gps, [
        e("rect", {
          x: "88",
          y: "24",
          width: "80",
          height: "136",
          rx: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Eps),
        e("path", {
          d: "M208,120a80,80,0,0,1-160,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ops),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ips)
      ])) : o(i) === "duotone" ? (s(), r("g", Kps, [
        Xps,
        e("rect", {
          x: "88",
          y: "24",
          width: "80",
          height: "144",
          rx: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jps),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qps),
        e("path", {
          d: "M199.6,136a72.1,72.1,0,0,1-143.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yps)
      ])) : o(i) === "fill" ? (s(), r("g", o3s, n3s)) : o(i) === "light" ? (s(), r("g", s3s, [
        e("rect", {
          x: "88",
          y: "24",
          width: "80",
          height: "144",
          rx: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, r3s),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, i3s),
        e("path", {
          d: "M199.6,136a72.1,72.1,0,0,1-143.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, l3s)
      ])) : o(i) === "thin" ? (s(), r("g", d3s, [
        e("rect", {
          x: "88",
          y: "24",
          width: "80",
          height: "144",
          rx: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, k3s),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, c3s),
        e("path", {
          d: "M199.6,136a72.1,72.1,0,0,1-143.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, h3s)
      ])) : o(i) === "regular" ? (s(), r("g", u3s, [
        e("rect", {
          x: "88",
          y: "24",
          width: "80",
          height: "144",
          rx: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a3s),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _3s),
        e("path", {
          d: "M199.6,136a72.1,72.1,0,0,1-143.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p3s)
      ])) : g("", !0)
    ], 16, qps));
  }
}), $3s = ["width", "height", "fill", "transform"], w3s = { key: 0 }, f3s = ["stroke"], g3s = ["stroke"], x3s = ["stroke"], j3s = ["stroke"], m3s = ["stroke"], M3s = ["stroke"], v3s = { key: 1 }, S3s = /* @__PURE__ */ e("rect", {
  x: "88",
  y: "24",
  width: "80",
  height: "144",
  rx: "40",
  opacity: "0.2"
}, null, -1), H3s = ["stroke"], A3s = ["stroke"], V3s = ["stroke"], z3s = ["stroke"], Z3s = ["stroke"], C3s = ["stroke"], b3s = { key: 2 }, L3s = /* @__PURE__ */ e("path", { d: "M213.9,210.6l-160-176A8,8,0,0,0,42.1,45.4L80,87.1V128a48,48,0,0,0,73.9,40.4l10.9,12A64,64,0,0,1,64.4,135.1a8,8,0,1,0-15.9,1.8A79.9,79.9,0,0,0,120,207.6V232a8,8,0,0,0,16,0V207.6a79.2,79.2,0,0,0,39.6-15.3l26.5,29.1A8,8,0,0,0,208,224a8.2,8.2,0,0,0,5.4-2.1A7.9,7.9,0,0,0,213.9,210.6Z" }, null, -1), B3s = /* @__PURE__ */ e("path", { d: "M162.1,129.8a7.9,7.9,0,0,0,5.9,2.6,7.4,7.4,0,0,0,2.9-.5,8,8,0,0,0,5.1-7.5V64a48,48,0,0,0-48-48A47.5,47.5,0,0,0,87.2,38.8a8,8,0,0,0,.8,9.6Z" }, null, -1), P3s = /* @__PURE__ */ e("path", { d: "M192.2,161.7a9.3,9.3,0,0,0,2.9.5,7.8,7.8,0,0,0,7.4-5.1,78.7,78.7,0,0,0,5-20.2,8,8,0,1,0-15.9-1.8,60.1,60.1,0,0,1-4,16.2A8.1,8.1,0,0,0,192.2,161.7Z" }, null, -1), W3s = [
  L3s,
  B3s,
  P3s
], N3s = { key: 3 }, F3s = ["stroke"], T3s = ["stroke"], D3s = ["stroke"], R3s = ["stroke"], U3s = ["stroke"], q3s = ["stroke"], G3s = { key: 4 }, E3s = ["stroke"], O3s = ["stroke"], I3s = ["stroke"], K3s = ["stroke"], X3s = ["stroke"], J3s = ["stroke"], Q3s = { key: 5 }, Y3s = ["stroke"], oys = ["stroke"], eys = ["stroke"], tys = ["stroke"], nys = ["stroke"], sys = ["stroke"], rys = {
  name: "PhMicrophoneSlash"
}, hJ1 = /* @__PURE__ */ $({
  ...rys,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", w3s, [
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f3s),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g3s),
        e("path", {
          d: "M150.7,153a40.4,40.4,0,0,1-22.7,7h0a40,40,0,0,1-40-40V84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, x3s),
        e("path", {
          d: "M98.9,36.5A39.9,39.9,0,0,1,128,24h0a40,40,0,0,1,40,40v48.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, j3s),
        e("path", {
          d: "M177.7,182.7A80,80,0,0,1,48,120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, m3s),
        e("path", {
          d: "M208,120a79.5,79.5,0,0,1-5.9,30.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, M3s)
      ])) : o(i) === "duotone" ? (s(), r("g", v3s, [
        S3s,
        e("path", {
          d: "M176.4,181.3A72,72,0,0,1,56.4,136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H3s),
        e("path", {
          d: "M154.9,157.6A39.6,39.6,0,0,1,128,168h0a40,40,0,0,1-40-40V84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A3s),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, V3s),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, z3s),
        e("path", {
          d: "M94,43a39.8,39.8,0,0,1,34-19h0a40,40,0,0,1,40,40v60.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z3s),
        e("path", {
          d: "M199.6,136a72.4,72.4,0,0,1-4.5,18.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C3s)
      ])) : o(i) === "fill" ? (s(), r("g", b3s, W3s)) : o(i) === "light" ? (s(), r("g", N3s, [
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, F3s),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, T3s),
        e("path", {
          d: "M154.9,157.6A39.6,39.6,0,0,1,128,168h0a40,40,0,0,1-40-40V84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, D3s),
        e("path", {
          d: "M176.4,181.3A72,72,0,0,1,56.4,136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, R3s),
        e("path", {
          d: "M199.6,136a72.4,72.4,0,0,1-6.2,22.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, U3s),
        e("path", {
          d: "M94,43a39.8,39.8,0,0,1,34-19h0a40,40,0,0,1,40,40v60.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, q3s)
      ])) : o(i) === "thin" ? (s(), r("g", G3s, [
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, E3s),
        e("path", {
          d: "M176.4,181.3A72,72,0,0,1,56.4,136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, O3s),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, I3s),
        e("path", {
          d: "M154.9,157.6A39.6,39.6,0,0,1,128,168h0a40,40,0,0,1-40-40V84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, K3s),
        e("path", {
          d: "M94,43a39.8,39.8,0,0,1,34-19h0a40,40,0,0,1,40,40v60.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, X3s),
        e("path", {
          d: "M199.6,136a72.4,72.4,0,0,1-4.5,18.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, J3s)
      ])) : o(i) === "regular" ? (s(), r("g", Q3s, [
        e("path", {
          d: "M176.4,181.3A72,72,0,0,1,56.4,136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y3s),
        e("path", {
          d: "M154.9,157.6A39.6,39.6,0,0,1,128,168h0a40,40,0,0,1-40-40V84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oys),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eys),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tys),
        e("path", {
          d: "M94,43a39.8,39.8,0,0,1,34-19h0a40,40,0,0,1,40,40v60.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nys),
        e("path", {
          d: "M199.6,136a72.4,72.4,0,0,1-4.5,18.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sys)
      ])) : g("", !0)
    ], 16, $3s));
  }
}), iys = ["width", "height", "fill", "transform"], lys = { key: 0 }, dys = ["stroke"], kys = ["stroke"], cys = ["stroke"], hys = { key: 1 }, uys = /* @__PURE__ */ e("path", {
  d: "M158.1,151.2a63.9,63.9,0,0,1-53.3-53.3h0L28.1,202.5a7.9,7.9,0,0,0,.8,10.4l14.2,14.2a7.9,7.9,0,0,0,10.4.8l104.6-76.7Z",
  opacity: "0.2"
}, null, -1), ays = ["stroke"], _ys = ["stroke"], pys = ["stroke"], yys = ["stroke"], $ys = { key: 2 }, wys = /* @__PURE__ */ e("path", { d: "M96,88a65.1,65.1,0,0,0,.4,7.7l-74.8,102a16,16,0,0,0,1.6,20.8l14.3,14.3a16,16,0,0,0,20.8,1.6l102-74.8a65.1,65.1,0,0,0,7.7.4,71.9,71.9,0,0,0,41.1-12.9,4,4,0,0,0,.5-6.1L115,46.4a4,4,0,0,0-6.1.5A71.9,71.9,0,0,0,96,88Zm17.7,65.7-20,20a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4l20-20a8.1,8.1,0,0,1,11.4,11.4ZM239.9,84a72,72,0,0,1-12.8,45.1,4,4,0,0,1-6.1.5L126.4,35a4,4,0,0,1,.5-6.1A72,72,0,0,1,239.9,84Z" }, null, -1), fys = [
  wys
], gys = { key: 3 }, xys = ["stroke"], jys = ["stroke"], mys = ["stroke"], Mys = ["stroke"], vys = { key: 4 }, Sys = ["stroke"], Hys = ["stroke"], Ays = ["stroke"], Vys = ["stroke"], zys = { key: 5 }, Zys = ["stroke"], Cys = ["stroke"], bys = ["stroke"], Lys = ["stroke"], Bys = {
  name: "PhMicrophoneStage"
}, uJ1 = /* @__PURE__ */ $({
  ...Bys,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", lys, [
        e("circle", {
          cx: "168",
          cy: "88",
          r: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dys),
        e("line", {
          x1: "213.3",
          y1: "133.3",
          x2: "122.7",
          y2: "42.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kys),
        e("path", {
          d: "M104.8,97.9,28.1,202.5a7.9,7.9,0,0,0,.8,10.4l14.2,14.2a7.9,7.9,0,0,0,10.4.8l104.6-76.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cys)
      ])) : o(i) === "duotone" ? (s(), r("g", hys, [
        uys,
        e("circle", {
          cx: "168",
          cy: "88",
          r: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ays),
        e("line", {
          x1: "213.3",
          y1: "133.3",
          x2: "122.7",
          y2: "42.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _ys),
        e("line", {
          x1: "100",
          y1: "156",
          x2: "88",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pys),
        e("path", {
          d: "M104.8,97.9,28.1,202.5a7.9,7.9,0,0,0,.8,10.4l14.2,14.2a7.9,7.9,0,0,0,10.4.8l104.6-76.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yys)
      ])) : o(i) === "fill" ? (s(), r("g", $ys, fys)) : o(i) === "light" ? (s(), r("g", gys, [
        e("circle", {
          cx: "168",
          cy: "88",
          r: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xys),
        e("line", {
          x1: "213.3",
          y1: "133.3",
          x2: "122.7",
          y2: "42.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jys),
        e("line", {
          x1: "100",
          y1: "156",
          x2: "88",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mys),
        e("path", {
          d: "M104.8,97.9,28.1,202.5a7.9,7.9,0,0,0,.8,10.4l14.2,14.2a7.9,7.9,0,0,0,10.4.8l104.6-76.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mys)
      ])) : o(i) === "thin" ? (s(), r("g", vys, [
        e("circle", {
          cx: "168",
          cy: "88",
          r: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Sys),
        e("line", {
          x1: "213.3",
          y1: "133.3",
          x2: "122.7",
          y2: "42.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hys),
        e("line", {
          x1: "100",
          y1: "156",
          x2: "88",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ays),
        e("path", {
          d: "M104.8,97.9,28.1,202.5a7.9,7.9,0,0,0,.8,10.4l14.2,14.2a7.9,7.9,0,0,0,10.4.8l104.6-76.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vys)
      ])) : o(i) === "regular" ? (s(), r("g", zys, [
        e("circle", {
          cx: "168",
          cy: "88",
          r: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zys),
        e("line", {
          x1: "213.3",
          y1: "133.3",
          x2: "122.7",
          y2: "42.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cys),
        e("line", {
          x1: "100",
          y1: "156",
          x2: "88",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bys),
        e("path", {
          d: "M104.8,97.9,28.1,202.5a7.9,7.9,0,0,0,.8,10.4l14.2,14.2a7.9,7.9,0,0,0,10.4.8l104.6-76.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lys)
      ])) : g("", !0)
    ], 16, iys));
  }
}), Pys = ["width", "height", "fill", "transform"], Wys = { key: 0 }, Nys = ["stroke"], Fys = ["stroke"], Tys = ["stroke"], Dys = ["stroke"], Rys = ["stroke"], Uys = ["stroke"], qys = ["stroke"], Gys = ["stroke"], Eys = { key: 1 }, Oys = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "72",
  width: "120",
  height: "112",
  rx: "8",
  opacity: "0.2"
}, null, -1), Iys = ["stroke"], Kys = ["stroke"], Xys = ["stroke"], Jys = ["stroke"], Qys = ["stroke"], Yys = ["stroke"], o5s = ["stroke"], e5s = ["stroke"], t5s = { key: 2 }, n5s = /* @__PURE__ */ e("path", { d: "M200,24H72A16,16,0,0,0,56,40V64H40A16,16,0,0,0,24,80v96a16,16,0,0,0,16,16H56v24a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24ZM69.2,158.4a8,8,0,0,1-1.6-11.2L82,128,67.6,108.8a8,8,0,1,1,12.8-9.6L92,114.7l11.6-15.5a8,8,0,0,1,12.8,9.6L102,128l14.4,19.2a8,8,0,0,1-1.6,11.2A7.7,7.7,0,0,1,110,160a8,8,0,0,1-6.4-3.2L92,141.3,80.4,156.8A8,8,0,0,1,74,160,7.7,7.7,0,0,1,69.2,158.4ZM128,216H72V192h56Zm0-152H72V40h56Zm72,152H144V192a16,16,0,0,0,16-16v-8h40Zm0-64H160V104h40Zm0-64H160V80a16,16,0,0,0-16-16V40h56Z" }, null, -1), s5s = [
  n5s
], r5s = { key: 3 }, i5s = ["stroke"], l5s = ["stroke"], d5s = ["stroke"], k5s = ["stroke"], c5s = ["stroke"], h5s = ["stroke"], u5s = ["stroke"], a5s = ["stroke"], _5s = { key: 4 }, p5s = ["stroke"], y5s = ["stroke"], $5s = ["stroke"], w5s = ["stroke"], f5s = ["stroke"], g5s = ["stroke"], x5s = ["stroke"], j5s = ["stroke"], m5s = { key: 5 }, M5s = ["stroke"], v5s = ["stroke"], S5s = ["stroke"], H5s = ["stroke"], A5s = ["stroke"], V5s = ["stroke"], z5s = ["stroke"], Z5s = ["stroke"], C5s = {
  name: "PhMicrosoftExcelLogo"
}, aJ1 = /* @__PURE__ */ $({
  ...C5s,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Wys, [
        e("line", {
          x1: "160",
          y1: "96",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nys),
        e("line", {
          x1: "160",
          y1: "160",
          x2: "208",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fys),
        e("path", {
          d: "M64,68V40a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Tys),
        e("line", {
          x1: "136",
          y1: "188",
          x2: "136",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Dys),
        e("line", {
          x1: "136",
          y1: "32",
          x2: "136",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rys),
        e("rect", {
          x: "32",
          y: "68",
          width: "128",
          height: "120",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Uys),
        e("line", {
          x1: "78",
          y1: "104",
          x2: "114",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qys),
        e("line", {
          x1: "114",
          y1: "104",
          x2: "78",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gys)
      ])) : o(i) === "duotone" ? (s(), r("g", Eys, [
        Oys,
        e("line", {
          x1: "152",
          y1: "96",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Iys),
        e("line", {
          x1: "152",
          y1: "160",
          x2: "208",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kys),
        e("path", {
          d: "M64,72V40a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xys),
        e("line", {
          x1: "136",
          y1: "184",
          x2: "136",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jys),
        e("line", {
          x1: "136",
          y1: "32",
          x2: "136",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qys),
        e("rect", {
          x: "32",
          y: "72",
          width: "120",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yys),
        e("line", {
          x1: "74",
          y1: "104",
          x2: "110",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o5s),
        e("line", {
          x1: "110",
          y1: "104",
          x2: "74",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e5s)
      ])) : o(i) === "fill" ? (s(), r("g", t5s, s5s)) : o(i) === "light" ? (s(), r("g", r5s, [
        e("line", {
          x1: "152",
          y1: "96",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, i5s),
        e("line", {
          x1: "152",
          y1: "160",
          x2: "208",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, l5s),
        e("path", {
          d: "M64,72V40a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, d5s),
        e("line", {
          x1: "136",
          y1: "184",
          x2: "136",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, k5s),
        e("line", {
          x1: "136",
          y1: "32",
          x2: "136",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, c5s),
        e("rect", {
          x: "32",
          y: "72",
          width: "120",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, h5s),
        e("line", {
          x1: "74",
          y1: "104",
          x2: "110",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u5s),
        e("line", {
          x1: "110",
          y1: "104",
          x2: "74",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, a5s)
      ])) : o(i) === "thin" ? (s(), r("g", _5s, [
        e("line", {
          x1: "152",
          y1: "96",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, p5s),
        e("line", {
          x1: "152",
          y1: "160",
          x2: "208",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, y5s),
        e("path", {
          d: "M64,72V40a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $5s),
        e("line", {
          x1: "136",
          y1: "184",
          x2: "136",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, w5s),
        e("line", {
          x1: "136",
          y1: "32",
          x2: "136",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, f5s),
        e("rect", {
          x: "32",
          y: "72",
          width: "120",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, g5s),
        e("line", {
          x1: "74",
          y1: "104",
          x2: "110",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, x5s),
        e("line", {
          x1: "110",
          y1: "104",
          x2: "74",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, j5s)
      ])) : o(i) === "regular" ? (s(), r("g", m5s, [
        e("line", {
          x1: "152",
          y1: "96",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M5s),
        e("line", {
          x1: "152",
          y1: "160",
          x2: "208",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v5s),
        e("path", {
          d: "M64,72V40a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S5s),
        e("line", {
          x1: "136",
          y1: "184",
          x2: "136",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H5s),
        e("line", {
          x1: "136",
          y1: "32",
          x2: "136",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A5s),
        e("rect", {
          x: "32",
          y: "72",
          width: "120",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, V5s),
        e("line", {
          x1: "74",
          y1: "104",
          x2: "110",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, z5s),
        e("line", {
          x1: "110",
          y1: "104",
          x2: "74",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z5s)
      ])) : g("", !0)
    ], 16, Pys));
  }
}), b5s = ["width", "height", "fill", "transform"], L5s = { key: 0 }, B5s = ["stroke"], P5s = ["stroke"], W5s = ["stroke"], N5s = ["stroke"], F5s = { key: 1 }, T5s = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "72",
  width: "120",
  height: "112",
  rx: "8",
  opacity: "0.2"
}, null, -1), D5s = ["stroke"], R5s = ["stroke"], U5s = ["stroke"], q5s = ["stroke"], G5s = ["stroke"], E5s = ["stroke"], O5s = { key: 2 }, I5s = /* @__PURE__ */ e("path", { d: "M102,120a8,8,0,0,0-8-8H86v16h8A8,8,0,0,0,102,120Z" }, null, -1), K5s = /* @__PURE__ */ e("path", { d: "M136,24A104.5,104.5,0,0,0,54,64H40A16,16,0,0,0,24,80v96a16,16,0,0,0,16,16H54A104,104,0,1,0,136,24ZM70,152V104a8,8,0,0,1,8-8H94a24,24,0,0,1,0,48H86v8a8,8,0,0,1-16,0Zm58,63.6A88.7,88.7,0,0,1,75.6,192H128ZM128,64H75.6A88.7,88.7,0,0,1,128,40.4Zm16-23.6A88,88,0,0,1,223.6,120H160V80a16,16,0,0,0-16-16Zm0,175.2V192a16,16,0,0,0,16-16V136h63.6A88,88,0,0,1,144,215.6Z" }, null, -1), X5s = [
  I5s,
  K5s
], J5s = { key: 3 }, Q5s = ["stroke"], Y5s = ["stroke"], o7s = ["stroke"], e7s = ["stroke"], t7s = ["stroke"], n7s = ["stroke"], s7s = { key: 4 }, r7s = ["stroke"], i7s = ["stroke"], l7s = ["stroke"], d7s = ["stroke"], k7s = ["stroke"], c7s = ["stroke"], h7s = { key: 5 }, u7s = ["stroke"], a7s = ["stroke"], _7s = ["stroke"], p7s = ["stroke"], y7s = ["stroke"], $7s = ["stroke"], w7s = {
  name: "PhMicrosoftPowerpointLogo"
}, _J1 = /* @__PURE__ */ $({
  ...w7s,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", L5s, [
        e("line", {
          x1: "160",
          y1: "128",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, B5s),
        e("rect", {
          x: "32",
          y: "68",
          width: "128",
          height: "120",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, P5s),
        e("path", {
          d: "M82,136H98a16,16,0,0,0,0-32H82v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, W5s),
        e("path", {
          d: "M61.1,68a96,96,0,1,1,0,120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, N5s)
      ])) : o(i) === "duotone" ? (s(), r("g", F5s, [
        T5s,
        e("line", {
          x1: "136",
          y1: "184",
          x2: "136",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D5s),
        e("line", {
          x1: "136",
          y1: "32",
          x2: "136",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R5s),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U5s),
        e("rect", {
          x: "32",
          y: "72",
          width: "120",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q5s),
        e("path", {
          d: "M78,136H94a16,16,0,0,0,0-32H78v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G5s),
        e("path", {
          d: "M58,72a96,96,0,1,1,0,112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E5s)
      ])) : o(i) === "fill" ? (s(), r("g", O5s, X5s)) : o(i) === "light" ? (s(), r("g", J5s, [
        e("line", {
          x1: "136",
          y1: "184",
          x2: "136",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Q5s),
        e("line", {
          x1: "136",
          y1: "32",
          x2: "136",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Y5s),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, o7s),
        e("rect", {
          x: "32",
          y: "72",
          width: "120",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, e7s),
        e("path", {
          d: "M78,136H94a16,16,0,0,0,0-32H78v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, t7s),
        e("path", {
          d: "M58,72a96,96,0,1,1,0,112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, n7s)
      ])) : o(i) === "thin" ? (s(), r("g", s7s, [
        e("line", {
          x1: "136",
          y1: "184",
          x2: "136",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, r7s),
        e("line", {
          x1: "136",
          y1: "32",
          x2: "136",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, i7s),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, l7s),
        e("rect", {
          x: "32",
          y: "72",
          width: "120",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, d7s),
        e("path", {
          d: "M78,136H94a16,16,0,0,0,0-32H78v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, k7s),
        e("path", {
          d: "M58,72a96,96,0,1,1,0,112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, c7s)
      ])) : o(i) === "regular" ? (s(), r("g", h7s, [
        e("line", {
          x1: "136",
          y1: "184",
          x2: "136",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u7s),
        e("line", {
          x1: "136",
          y1: "32",
          x2: "136",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a7s),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "232",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _7s),
        e("rect", {
          x: "32",
          y: "72",
          width: "120",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p7s),
        e("path", {
          d: "M78,136H94a16,16,0,0,0,0-32H78v48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y7s),
        e("path", {
          d: "M58,72a96,96,0,1,1,0,112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $7s)
      ])) : g("", !0)
    ], 16, b5s));
  }
}), f7s = ["width", "height", "fill", "transform"], g7s = { key: 0 }, x7s = ["stroke"], j7s = ["stroke"], m7s = ["stroke"], M7s = ["stroke"], v7s = ["stroke"], S7s = { key: 1 }, H7s = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "72",
  width: "120",
  height: "112",
  rx: "8",
  opacity: "0.2"
}, null, -1), A7s = ["stroke"], V7s = ["stroke"], z7s = ["stroke"], Z7s = ["stroke"], C7s = ["stroke"], b7s = ["stroke"], L7s = ["stroke"], B7s = { key: 2 }, P7s = /* @__PURE__ */ e("path", { d: "M219.3,80h-4.5A33.5,33.5,0,0,0,220,62a34,34,0,0,0-51.4-29.2A40,40,0,0,0,96,56a42.6,42.6,0,0,0,.8,8H40A16,16,0,0,0,24,80v96a16,16,0,0,0,16,16H76.7a64,64,0,0,0,118.7-.2A40,40,0,0,0,232,152V92.7A12.7,12.7,0,0,0,219.3,80ZM136,32a24.1,24.1,0,0,1,24,24,24.3,24.3,0,0,1-4.1,13.4A15.9,15.9,0,0,0,144,64H113.4a24.5,24.5,0,0,1-1.4-8A24.1,24.1,0,0,1,136,32ZM84,152V112H74a8,8,0,0,1,0-16h36a8,8,0,0,1,0,16H100v40a8,8,0,0,1-16,0Zm100,16a48,48,0,0,1-48,48,48.5,48.5,0,0,1-41.6-24H144a16,16,0,0,0,16-16V96h24Zm2-88a18,18,0,0,1-14-6.7A39.2,39.2,0,0,0,176,56a37.7,37.7,0,0,0-.9-8.3A17.7,17.7,0,0,1,186,44a18,18,0,0,1,0,36Zm30,72a24,24,0,0,1-16.4,22.7,49.2,49.2,0,0,0,.4-6.7V96h16Z" }, null, -1), W7s = [
  P7s
], N7s = { key: 3 }, F7s = ["stroke"], T7s = ["stroke"], D7s = ["stroke"], R7s = ["stroke"], U7s = ["stroke"], q7s = ["stroke"], G7s = ["stroke"], E7s = { key: 4 }, O7s = ["stroke"], I7s = ["stroke"], K7s = ["stroke"], X7s = ["stroke"], J7s = ["stroke"], Q7s = ["stroke"], Y7s = ["stroke"], o9s = { key: 5 }, e9s = ["stroke"], t9s = ["stroke"], n9s = ["stroke"], s9s = ["stroke"], r9s = ["stroke"], i9s = ["stroke"], l9s = ["stroke"], d9s = {
  name: "PhMicrosoftTeamsLogo"
}, pJ1 = /* @__PURE__ */ $({
  ...d9s,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", g7s, [
        e("rect", {
          x: "32",
          y: "68",
          width: "128",
          height: "120",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, x7s),
        e("line", {
          x1: "114",
          y1: "104",
          x2: "78",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, j7s),
        e("line", {
          x1: "96",
          y1: "152",
          x2: "96",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, m7s),
        e("path", {
          d: "M160,88h60v80a56,56,0,0,1-56,56h0a55.9,55.9,0,0,1-52.3-36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, M7s),
        e("path", {
          d: "M134.3,68A32,32,0,1,1,164,88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, v7s)
      ])) : o(i) === "duotone" ? (s(), r("g", S7s, [
        H7s,
        e("rect", {
          x: "32",
          y: "72",
          width: "120",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A7s),
        e("path", {
          d: "M152,88h32a8,8,0,0,1,8,8v72a56,56,0,0,1-56,56h0a56.1,56.1,0,0,1-53.7-40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, V7s),
        e("line", {
          x1: "110",
          y1: "104",
          x2: "74",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, z7s),
        e("line", {
          x1: "92",
          y1: "152",
          x2: "92",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z7s),
        e("path", {
          d: "M108.3,72A32,32,0,1,1,152,83.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C7s),
        e("path", {
          d: "M166.1,45.2a26,26,0,1,1-3.4,28.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b7s),
        e("path", {
          d: "M192,88h27.3a4.7,4.7,0,0,1,4.7,4.7V152a32,32,0,0,1-32,32h-2.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L7s)
      ])) : o(i) === "fill" ? (s(), r("g", B7s, W7s)) : o(i) === "light" ? (s(), r("g", N7s, [
        e("rect", {
          x: "32",
          y: "72",
          width: "120",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, F7s),
        e("path", {
          d: "M152,88h32a8,8,0,0,1,8,8v72a56,56,0,0,1-56,56h0a56.1,56.1,0,0,1-53.7-40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, T7s),
        e("line", {
          x1: "110",
          y1: "104",
          x2: "74",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, D7s),
        e("line", {
          x1: "92",
          y1: "152",
          x2: "92",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, R7s),
        e("path", {
          d: "M108.3,72A32,32,0,1,1,152,83.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, U7s),
        e("path", {
          d: "M166.1,45.2a26,26,0,1,1-3.4,28.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, q7s),
        e("path", {
          d: "M192,88h27.3a4.7,4.7,0,0,1,4.7,4.7V152a32,32,0,0,1-32,32h-2.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, G7s)
      ])) : o(i) === "thin" ? (s(), r("g", E7s, [
        e("rect", {
          x: "32",
          y: "72",
          width: "120",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, O7s),
        e("path", {
          d: "M152,88h32a8,8,0,0,1,8,8v72a56,56,0,0,1-56,56h0a56.1,56.1,0,0,1-53.7-40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, I7s),
        e("line", {
          x1: "110",
          y1: "104",
          x2: "74",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, K7s),
        e("line", {
          x1: "92",
          y1: "152",
          x2: "92",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, X7s),
        e("path", {
          d: "M108.3,72A32,32,0,1,1,152,83.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, J7s),
        e("path", {
          d: "M166.1,45.2a26,26,0,1,1-3.4,28.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Q7s),
        e("path", {
          d: "M192,88h27.3a4.7,4.7,0,0,1,4.7,4.7V152a32,32,0,0,1-32,32h-2.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Y7s)
      ])) : o(i) === "regular" ? (s(), r("g", o9s, [
        e("rect", {
          x: "32",
          y: "72",
          width: "120",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e9s),
        e("path", {
          d: "M152,88h32a8,8,0,0,1,8,8v72a56,56,0,0,1-56,56h0a56.1,56.1,0,0,1-53.7-40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t9s),
        e("line", {
          x1: "110",
          y1: "104",
          x2: "74",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n9s),
        e("line", {
          x1: "92",
          y1: "152",
          x2: "92",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s9s),
        e("path", {
          d: "M108.3,72A32,32,0,1,1,152,83.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r9s),
        e("path", {
          d: "M166.1,45.2a26,26,0,1,1-3.4,28.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, i9s),
        e("path", {
          d: "M192,88h27.3a4.7,4.7,0,0,1,4.7,4.7V152a32,32,0,0,1-32,32h-2.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l9s)
      ])) : g("", !0)
    ], 16, f7s));
  }
}), k9s = ["width", "height", "fill", "transform"], c9s = { key: 0 }, h9s = ["stroke"], u9s = ["stroke"], a9s = ["stroke"], _9s = ["stroke"], p9s = ["stroke"], y9s = { key: 1 }, $9s = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "72",
  width: "120",
  height: "112",
  rx: "8",
  opacity: "0.2"
}, null, -1), w9s = ["stroke"], f9s = ["stroke"], g9s = ["stroke"], x9s = ["stroke"], j9s = ["stroke"], m9s = { key: 2 }, M9s = /* @__PURE__ */ e("path", { d: "M200,24H72A16,16,0,0,0,56,40V64H40A16,16,0,0,0,24,80v96a16,16,0,0,0,16,16H56v24a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24ZM68.2,153.9l-12-48a8,8,0,0,1,15.6-3.8l6.3,25.4,6.6-14.7a8,8,0,0,1,14.6,0l6.6,14.7,6.3-25.4a8,8,0,1,1,15.6,3.8l-12,48a8.1,8.1,0,0,1-7.1,6.1H108a7.9,7.9,0,0,1-7.3-4.8L92,135.7l-8.7,19.5a8,8,0,0,1-8,4.8A8.1,8.1,0,0,1,68.2,153.9ZM200,216H72V192h72a16,16,0,0,0,16-16v-8h40Zm0-64H160V104h40Zm0-64H160V80a16,16,0,0,0-16-16H72V40H200Z" }, null, -1), v9s = [
  M9s
], S9s = { key: 3 }, H9s = ["stroke"], A9s = ["stroke"], V9s = ["stroke"], z9s = ["stroke"], Z9s = ["stroke"], C9s = { key: 4 }, b9s = ["stroke"], L9s = ["stroke"], B9s = ["stroke"], P9s = ["stroke"], W9s = ["stroke"], N9s = { key: 5 }, F9s = ["stroke"], T9s = ["stroke"], D9s = ["stroke"], R9s = ["stroke"], U9s = ["stroke"], q9s = {
  name: "PhMicrosoftWordLogo"
}, yJ1 = /* @__PURE__ */ $({
  ...q9s,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", c9s, [
        e("line", {
          x1: "160",
          y1: "96",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, h9s),
        e("line", {
          x1: "160",
          y1: "160",
          x2: "208",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, u9s),
        e("path", {
          d: "M64,68V40a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, a9s),
        e("polyline", {
          points: "68 104 80 152 96 116 112 152 124 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _9s),
        e("rect", {
          x: "32",
          y: "68",
          width: "128",
          height: "120",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, p9s)
      ])) : o(i) === "duotone" ? (s(), r("g", y9s, [
        $9s,
        e("line", {
          x1: "152",
          y1: "96",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w9s),
        e("line", {
          x1: "152",
          y1: "160",
          x2: "208",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f9s),
        e("path", {
          d: "M64,72V40a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g9s),
        e("polyline", {
          points: "64 104 76 152 92 116 108 152 120 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, x9s),
        e("rect", {
          x: "32",
          y: "72",
          width: "120",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j9s)
      ])) : o(i) === "fill" ? (s(), r("g", m9s, v9s)) : o(i) === "light" ? (s(), r("g", S9s, [
        e("line", {
          x1: "152",
          y1: "96",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, H9s),
        e("line", {
          x1: "152",
          y1: "160",
          x2: "208",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, A9s),
        e("path", {
          d: "M64,72V40a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, V9s),
        e("polyline", {
          points: "64 104 76 152 92 116 108 152 120 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, z9s),
        e("rect", {
          x: "32",
          y: "72",
          width: "120",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Z9s)
      ])) : o(i) === "thin" ? (s(), r("g", C9s, [
        e("line", {
          x1: "152",
          y1: "96",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, b9s),
        e("line", {
          x1: "152",
          y1: "160",
          x2: "208",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, L9s),
        e("path", {
          d: "M64,72V40a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, B9s),
        e("polyline", {
          points: "64 104 76 152 92 116 108 152 120 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, P9s),
        e("rect", {
          x: "32",
          y: "72",
          width: "120",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, W9s)
      ])) : o(i) === "regular" ? (s(), r("g", N9s, [
        e("line", {
          x1: "152",
          y1: "96",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F9s),
        e("line", {
          x1: "152",
          y1: "160",
          x2: "208",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T9s),
        e("path", {
          d: "M64,72V40a8,8,0,0,1,8-8H200a8,8,0,0,1,8,8V216a8,8,0,0,1-8,8H72a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D9s),
        e("polyline", {
          points: "64 104 76 152 92 116 108 152 120 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R9s),
        e("rect", {
          x: "32",
          y: "72",
          width: "120",
          height: "112",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U9s)
      ])) : g("", !0)
    ], 16, k9s));
  }
}), G9s = ["width", "height", "fill", "transform"], E9s = { key: 0 }, O9s = ["stroke"], I9s = { key: 1 }, K9s = ["stroke"], X9s = { key: 2 }, J9s = /* @__PURE__ */ e("path", { d: "M216,136H40a8,8,0,0,1,0-16H216a8,8,0,0,1,0,16Z" }, null, -1), Q9s = [
  J9s
], Y9s = { key: 3 }, o$s = ["stroke"], e$s = { key: 4 }, t$s = ["stroke"], n$s = { key: 5 }, s$s = ["stroke"], r$s = {
  name: "PhMinus"
}, $J1 = /* @__PURE__ */ $({
  ...r$s,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", E9s, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, O9s)
      ])) : o(i) === "duotone" ? (s(), r("g", I9s, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K9s)
      ])) : o(i) === "fill" ? (s(), r("g", X9s, Q9s)) : o(i) === "light" ? (s(), r("g", Y9s, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, o$s)
      ])) : o(i) === "thin" ? (s(), r("g", e$s, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, t$s)
      ])) : o(i) === "regular" ? (s(), r("g", n$s, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s$s)
      ])) : g("", !0)
    ], 16, G9s));
  }
}), i$s = ["width", "height", "fill", "transform"], l$s = { key: 0 }, d$s = ["stroke"], k$s = ["stroke"], c$s = { key: 1 }, h$s = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), u$s = ["stroke"], a$s = ["stroke"], _$s = { key: 2 }, p$s = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm40,112H88a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Z" }, null, -1), y$s = [
  p$s
], $$s = { key: 3 }, w$s = ["stroke"], f$s = ["stroke"], g$s = { key: 4 }, x$s = ["stroke"], j$s = ["stroke"], m$s = { key: 5 }, M$s = ["stroke"], v$s = ["stroke"], S$s = {
  name: "PhMinusCircle"
}, wJ1 = /* @__PURE__ */ $({
  ...S$s,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", l$s, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, d$s),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, k$s)
      ])) : o(i) === "duotone" ? (s(), r("g", c$s, [
        h$s,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, u$s),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a$s)
      ])) : o(i) === "fill" ? (s(), r("g", _$s, y$s)) : o(i) === "light" ? (s(), r("g", $$s, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, w$s),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, f$s)
      ])) : o(i) === "thin" ? (s(), r("g", g$s, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, x$s),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, j$s)
      ])) : o(i) === "regular" ? (s(), r("g", m$s, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, M$s),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v$s)
      ])) : g("", !0)
    ], 16, i$s));
  }
}), H$s = ["width", "height", "fill", "transform"], A$s = { key: 0 }, V$s = ["stroke"], z$s = ["stroke"], Z$s = ["stroke"], C$s = ["stroke"], b$s = ["stroke"], L$s = ["stroke"], B$s = { key: 1 }, P$s = ["stroke"], W$s = /* @__PURE__ */ j('<circle cx="128" cy="128" r="32" opacity="0.2"></circle><path d="M232,64H176l64,56V72A8,8,0,0,0,232,64Z" opacity="0.2"></path><path d="M232,192a8,8,0,0,0,8-8V136l-64,56Z" opacity="0.2"></path><path d="M16,72v48L80,64H24A8,8,0,0,0,16,72Z" opacity="0.2"></path><path d="M16,184a8,8,0,0,0,8,8H80L16,136Z" opacity="0.2"></path>', 5), N$s = ["stroke"], F$s = ["stroke"], T$s = ["stroke"], D$s = ["stroke"], R$s = ["stroke"], U$s = { key: 2 }, q$s = /* @__PURE__ */ e("path", { d: "M232,56H24A16,16,0,0,0,8,72V184a16,16,0,0,0,16,16H232a16,16,0,0,0,16-16V72A16,16,0,0,0,232,56ZM75,184,24,140.3V115.7L75,72H181l51,43.7v24.6L181,184Zm93-56a40,40,0,1,1-40-40A40,40,0,0,1,168,128Z" }, null, -1), G$s = [
  q$s
], E$s = { key: 3 }, O$s = ["stroke"], I$s = ["stroke"], K$s = ["stroke"], X$s = ["stroke"], J$s = ["stroke"], Q$s = ["stroke"], Y$s = { key: 4 }, ows = ["stroke"], ews = ["stroke"], tws = ["stroke"], nws = ["stroke"], sws = ["stroke"], rws = ["stroke"], iws = { key: 5 }, lws = ["stroke"], dws = ["stroke"], kws = ["stroke"], cws = ["stroke"], hws = ["stroke"], uws = ["stroke"], aws = {
  name: "PhMoney"
}, fJ1 = /* @__PURE__ */ $({
  ...aws,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", A$s, [
        e("rect", {
          x: "16",
          y: "64",
          width: "224",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, V$s),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, z$s),
        e("line", {
          x1: "168",
          y1: "64",
          x2: "240",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Z$s),
        e("line", {
          x1: "168",
          y1: "192",
          x2: "240",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, C$s),
        e("line", {
          x1: "88",
          y1: "64",
          x2: "16",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, b$s),
        e("line", {
          x1: "88",
          y1: "192",
          x2: "16",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, L$s)
      ])) : o(i) === "duotone" ? (s(), r("g", B$s, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P$s),
        W$s,
        e("rect", {
          x: "16",
          y: "64",
          width: "224",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N$s),
        e("line", {
          x1: "176",
          y1: "64",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F$s),
        e("line", {
          x1: "176",
          y1: "192",
          x2: "240",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T$s),
        e("line", {
          x1: "80",
          y1: "64",
          x2: "16",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D$s),
        e("line", {
          x1: "80",
          y1: "192",
          x2: "16",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R$s)
      ])) : o(i) === "fill" ? (s(), r("g", U$s, G$s)) : o(i) === "light" ? (s(), r("g", E$s, [
        e("rect", {
          x: "16",
          y: "64",
          width: "224",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, O$s),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, I$s),
        e("line", {
          x1: "176",
          y1: "64",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, K$s),
        e("line", {
          x1: "176",
          y1: "192",
          x2: "240",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, X$s),
        e("line", {
          x1: "80",
          y1: "64",
          x2: "16",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, J$s),
        e("line", {
          x1: "80",
          y1: "192",
          x2: "16",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Q$s)
      ])) : o(i) === "thin" ? (s(), r("g", Y$s, [
        e("rect", {
          x: "16",
          y: "64",
          width: "224",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ows),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ews),
        e("line", {
          x1: "176",
          y1: "64",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tws),
        e("line", {
          x1: "176",
          y1: "192",
          x2: "240",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nws),
        e("line", {
          x1: "80",
          y1: "64",
          x2: "16",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sws),
        e("line", {
          x1: "80",
          y1: "192",
          x2: "16",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rws)
      ])) : o(i) === "regular" ? (s(), r("g", iws, [
        e("rect", {
          x: "16",
          y: "64",
          width: "224",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lws),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dws),
        e("line", {
          x1: "176",
          y1: "64",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kws),
        e("line", {
          x1: "176",
          y1: "192",
          x2: "240",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cws),
        e("line", {
          x1: "80",
          y1: "64",
          x2: "16",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hws),
        e("line", {
          x1: "80",
          y1: "192",
          x2: "16",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uws)
      ])) : g("", !0)
    ], 16, H$s));
  }
}), _ws = ["width", "height", "fill", "transform"], pws = { key: 0 }, yws = ["stroke"], $ws = ["stroke"], wws = { key: 1 }, fws = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "48",
  width: "192",
  height: "144",
  rx: "16",
  transform: "translate(256 240) rotate(180)",
  opacity: "0.2"
}, null, -1), gws = ["stroke"], xws = ["stroke"], jws = { key: 2 }, mws = /* @__PURE__ */ e("rect", {
  x: "24",
  y: "40",
  width: "208",
  height: "160",
  rx: "24"
}, null, -1), Mws = /* @__PURE__ */ e("path", { d: "M160,216H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z" }, null, -1), vws = [
  mws,
  Mws
], Sws = { key: 3 }, Hws = ["stroke"], Aws = ["stroke"], Vws = { key: 4 }, zws = ["stroke"], Zws = ["stroke"], Cws = { key: 5 }, bws = ["stroke"], Lws = ["stroke"], Bws = {
  name: "PhMonitor"
}, gJ1 = /* @__PURE__ */ $({
  ...Bws,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", pws, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "144",
          rx: "16",
          transform: "translate(256 240) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yws),
        e("line", {
          x1: "160",
          y1: "228",
          x2: "96",
          y2: "228",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $ws)
      ])) : o(i) === "duotone" ? (s(), r("g", wws, [
        fws,
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "144",
          rx: "16",
          transform: "translate(256 240) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gws),
        e("line", {
          x1: "160",
          y1: "224",
          x2: "96",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xws)
      ])) : o(i) === "fill" ? (s(), r("g", jws, vws)) : o(i) === "light" ? (s(), r("g", Sws, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "144",
          rx: "16",
          transform: "translate(256 240) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hws),
        e("line", {
          x1: "160",
          y1: "224",
          x2: "96",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Aws)
      ])) : o(i) === "thin" ? (s(), r("g", Vws, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "144",
          rx: "16",
          transform: "translate(256 240) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zws),
        e("line", {
          x1: "160",
          y1: "224",
          x2: "96",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zws)
      ])) : o(i) === "regular" ? (s(), r("g", Cws, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "144",
          rx: "16",
          transform: "translate(256 240) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bws),
        e("line", {
          x1: "160",
          y1: "224",
          x2: "96",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lws)
      ])) : g("", !0)
    ], 16, _ws));
  }
}), Pws = ["width", "height", "fill", "transform"], Wws = { key: 0 }, Nws = ["stroke"], Fws = ["stroke"], Tws = ["stroke"], Dws = { key: 1 }, Rws = /* @__PURE__ */ e("path", {
  d: "M208,48H48A16,16,0,0,0,32,64V176a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V64A16,16,0,0,0,208,48ZM112,152V88l48,32Z",
  opacity: "0.2"
}, null, -1), Uws = ["stroke"], qws = ["stroke"], Gws = ["stroke"], Ews = { key: 2 }, Ows = /* @__PURE__ */ e("path", { d: "M168,224a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,224ZM232,64V176a24.1,24.1,0,0,1-24,24H48a24.1,24.1,0,0,1-24-24V64A24.1,24.1,0,0,1,48,40H208A24.1,24.1,0,0,1,232,64Zm-68,56a7.9,7.9,0,0,0-3.7-6.7l-44-28a7.9,7.9,0,0,0-8.1-.3,8,8,0,0,0-4.2,7v56a8,8,0,0,0,4.2,7,7.7,7.7,0,0,0,8.1-.3l44-28A7.9,7.9,0,0,0,164,120Z" }, null, -1), Iws = [
  Ows
], Kws = { key: 3 }, Xws = ["stroke"], Jws = ["stroke"], Qws = ["stroke"], Yws = { key: 4 }, ofs = ["stroke"], efs = ["stroke"], tfs = ["stroke"], nfs = { key: 5 }, sfs = ["stroke"], rfs = ["stroke"], ifs = ["stroke"], lfs = {
  name: "PhMonitorPlay"
}, xJ1 = /* @__PURE__ */ $({
  ...lfs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Wws, [
        e("polygon", {
          points: "156 120 116 92 116 148 156 120",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nws),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "144",
          rx: "16",
          transform: "translate(256 240) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fws),
        e("line", {
          x1: "160",
          y1: "228",
          x2: "96",
          y2: "228",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Tws)
      ])) : o(i) === "duotone" ? (s(), r("g", Dws, [
        Rws,
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "144",
          rx: "16",
          transform: "translate(256 240) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uws),
        e("line", {
          x1: "160",
          y1: "224",
          x2: "96",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qws),
        e("polygon", {
          points: "160 120 112 88 112 152 160 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gws)
      ])) : o(i) === "fill" ? (s(), r("g", Ews, Iws)) : o(i) === "light" ? (s(), r("g", Kws, [
        e("polygon", {
          points: "160 120 112 88 112 152 160 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xws),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "144",
          rx: "16",
          transform: "translate(256 240) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jws),
        e("line", {
          x1: "160",
          y1: "224",
          x2: "96",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qws)
      ])) : o(i) === "thin" ? (s(), r("g", Yws, [
        e("polygon", {
          points: "160 120 112 88 112 152 160 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ofs),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "144",
          rx: "16",
          transform: "translate(256 240) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, efs),
        e("line", {
          x1: "160",
          y1: "224",
          x2: "96",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tfs)
      ])) : o(i) === "regular" ? (s(), r("g", nfs, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "144",
          rx: "16",
          transform: "translate(256 240) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sfs),
        e("line", {
          x1: "160",
          y1: "224",
          x2: "96",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rfs),
        e("polygon", {
          points: "160 120 112 88 112 152 160 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ifs)
      ])) : g("", !0)
    ], 16, Pws));
  }
}), dfs = ["width", "height", "fill", "transform"], kfs = { key: 0 }, cfs = ["stroke"], hfs = { key: 1 }, ufs = /* @__PURE__ */ e("path", {
  d: "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
  opacity: "0.2"
}, null, -1), afs = ["stroke"], _fs = { key: 2 }, pfs = /* @__PURE__ */ e("path", { d: "M224.3,150.3a8.1,8.1,0,0,0-7.8-5.7l-2.2.4A84,84,0,0,1,111,41.6a5.7,5.7,0,0,0,.3-1.8A7.9,7.9,0,0,0,101,31.7,100,100,0,1,0,224.3,154.9,7.2,7.2,0,0,0,224.3,150.3Z" }, null, -1), yfs = [
  pfs
], $fs = { key: 3 }, wfs = ["stroke"], ffs = { key: 4 }, gfs = ["stroke"], xfs = { key: 5 }, jfs = ["stroke"], mfs = {
  name: "PhMoon"
}, jJ1 = /* @__PURE__ */ $({
  ...mfs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", kfs, [
        e("path", {
          d: "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cfs)
      ])) : o(i) === "duotone" ? (s(), r("g", hfs, [
        ufs,
        e("path", {
          d: "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, afs)
      ])) : o(i) === "fill" ? (s(), r("g", _fs, yfs)) : o(i) === "light" ? (s(), r("g", $fs, [
        e("path", {
          d: "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wfs)
      ])) : o(i) === "thin" ? (s(), r("g", ffs, [
        e("path", {
          d: "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gfs)
      ])) : o(i) === "regular" ? (s(), r("g", xfs, [
        e("path", {
          d: "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jfs)
      ])) : g("", !0)
    ], 16, dfs));
  }
}), Mfs = ["width", "height", "fill", "transform"], vfs = { key: 0 }, Sfs = ["stroke"], Hfs = ["stroke"], Afs = ["stroke"], Vfs = ["stroke"], zfs = ["stroke"], Zfs = { key: 1 }, Cfs = /* @__PURE__ */ e("path", {
  d: "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
  opacity: "0.2"
}, null, -1), bfs = ["stroke"], Lfs = ["stroke"], Bfs = ["stroke"], Pfs = ["stroke"], Wfs = ["stroke"], Nfs = { key: 2 }, Ffs = /* @__PURE__ */ e("path", { d: "M240,80H224V64a8,8,0,0,0-16,0V80H192a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V96h16a8,8,0,0,0,0-16Z" }, null, -1), Tfs = /* @__PURE__ */ e("path", { d: "M152,48h8v8a8,8,0,0,0,16,0V48h8a8,8,0,0,0,0-16h-8V24a8,8,0,0,0-16,0v8h-8a8,8,0,0,0,0,16Z" }, null, -1), Dfs = /* @__PURE__ */ e("path", { d: "M216.5,144.6l-2.2.4A84,84,0,0,1,111,41.6a5.7,5.7,0,0,0,.3-1.8,8,8,0,0,0-5-7.9,7.8,7.8,0,0,0-5.2-.2A100,100,0,1,0,224.3,154.9a7.9,7.9,0,0,0,0-4.8A8.2,8.2,0,0,0,216.5,144.6Z" }, null, -1), Rfs = [
  Ffs,
  Tfs,
  Dfs
], Ufs = { key: 3 }, qfs = ["stroke"], Gfs = ["stroke"], Efs = ["stroke"], Ofs = ["stroke"], Ifs = ["stroke"], Kfs = { key: 4 }, Xfs = ["stroke"], Jfs = ["stroke"], Qfs = ["stroke"], Yfs = ["stroke"], ogs = ["stroke"], egs = { key: 5 }, tgs = ["stroke"], ngs = ["stroke"], sgs = ["stroke"], rgs = ["stroke"], igs = ["stroke"], lgs = {
  name: "PhMoonStars"
}, mJ1 = /* @__PURE__ */ $({
  ...lgs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", vfs, [
        e("line", {
          x1: "216",
          y1: "112",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Sfs),
        e("line", {
          x1: "240",
          y1: "88",
          x2: "192",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hfs),
        e("line", {
          x1: "168",
          y1: "24",
          x2: "168",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Afs),
        e("line", {
          x1: "184",
          y1: "40",
          x2: "152",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vfs),
        e("path", {
          d: "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zfs)
      ])) : o(i) === "duotone" ? (s(), r("g", Zfs, [
        Cfs,
        e("line", {
          x1: "216",
          y1: "112",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bfs),
        e("line", {
          x1: "240",
          y1: "88",
          x2: "192",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lfs),
        e("line", {
          x1: "168",
          y1: "24",
          x2: "168",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bfs),
        e("line", {
          x1: "184",
          y1: "40",
          x2: "152",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pfs),
        e("path", {
          d: "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wfs)
      ])) : o(i) === "fill" ? (s(), r("g", Nfs, Rfs)) : o(i) === "light" ? (s(), r("g", Ufs, [
        e("line", {
          x1: "216",
          y1: "112",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qfs),
        e("line", {
          x1: "240",
          y1: "88",
          x2: "192",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gfs),
        e("line", {
          x1: "168",
          y1: "24",
          x2: "168",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Efs),
        e("line", {
          x1: "184",
          y1: "40",
          x2: "152",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ofs),
        e("path", {
          d: "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ifs)
      ])) : o(i) === "thin" ? (s(), r("g", Kfs, [
        e("line", {
          x1: "216",
          y1: "112",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xfs),
        e("line", {
          x1: "240",
          y1: "88",
          x2: "192",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jfs),
        e("line", {
          x1: "168",
          y1: "24",
          x2: "168",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qfs),
        e("line", {
          x1: "184",
          y1: "40",
          x2: "152",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Yfs),
        e("path", {
          d: "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ogs)
      ])) : o(i) === "regular" ? (s(), r("g", egs, [
        e("line", {
          x1: "216",
          y1: "112",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tgs),
        e("line", {
          x1: "240",
          y1: "88",
          x2: "192",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ngs),
        e("line", {
          x1: "168",
          y1: "24",
          x2: "168",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sgs),
        e("line", {
          x1: "184",
          y1: "40",
          x2: "152",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rgs),
        e("path", {
          d: "M216.7,152.6A91.9,91.9,0,0,1,103.4,39.3h0A92,92,0,1,0,216.7,152.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, igs)
      ])) : g("", !0)
    ], 16, Mfs));
  }
}), dgs = ["width", "height", "fill", "transform"], kgs = { key: 0 }, cgs = ["stroke"], hgs = ["stroke"], ugs = ["stroke"], ags = ["stroke"], _gs = { key: 1 }, pgs = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "52",
  r: "20",
  opacity: "0.2"
}, null, -1), ygs = /* @__PURE__ */ e("path", {
  d: "M144.1,159.4l33-55.8a8.1,8.1,0,0,1,13.8,0L248,200H168Z",
  opacity: "0.2"
}, null, -1), $gs = /* @__PURE__ */ e("path", {
  d: "M50.4,128h75.2L94.9,75.7a8.1,8.1,0,0,0-13.8,0Z",
  opacity: "0.2"
}, null, -1), wgs = ["stroke"], fgs = ["stroke"], ggs = ["stroke"], xgs = ["stroke"], jgs = { key: 2 }, mgs = /* @__PURE__ */ e("path", { d: "M140,52a24,24,0,1,1,24,24A24.1,24.1,0,0,1,140,52ZM255,204a8.1,8.1,0,0,1-7,4H8a7.8,7.8,0,0,1-6.9-4,7.9,7.9,0,0,1,0-8.1L74.2,71.7a16,16,0,0,1,27.6,0l42.3,71.9,26.1-44.1a16.1,16.1,0,0,1,27.6,0l57.1,96.4A8.3,8.3,0,0,1,255,204ZM64.3,120h47.4L88,79.8Z" }, null, -1), Mgs = [
  mgs
], vgs = { key: 3 }, Sgs = ["stroke"], Hgs = ["stroke"], Ags = ["stroke"], Vgs = ["stroke"], zgs = { key: 4 }, Zgs = ["stroke"], Cgs = ["stroke"], bgs = ["stroke"], Lgs = ["stroke"], Bgs = { key: 5 }, Pgs = ["stroke"], Wgs = ["stroke"], Ngs = ["stroke"], Fgs = ["stroke"], Tgs = {
  name: "PhMountains"
}, MJ1 = /* @__PURE__ */ $({
  ...Tgs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", kgs, [
        e("circle", {
          cx: "164",
          cy: "52",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cgs),
        e("path", {
          d: "M12,200,85.1,75.7a8.1,8.1,0,0,1,13.8,0L172,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hgs),
        e("line", {
          x1: "54.4",
          y1: "128",
          x2: "129.6",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ugs),
        e("path", {
          d: "M172,200h67.3l-52.4-88.4a8.1,8.1,0,0,0-13.8,0l-26.6,45",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ags)
      ])) : o(i) === "duotone" ? (s(), r("g", _gs, [
        pgs,
        ygs,
        $gs,
        e("circle", {
          cx: "164",
          cy: "52",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wgs),
        e("path", {
          d: "M8,200,81.1,75.7a8.1,8.1,0,0,1,13.8,0L168,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fgs),
        e("line", {
          x1: "50.4",
          y1: "128",
          x2: "125.6",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ggs),
        e("path", {
          d: "M144.1,159.4l33-55.8a8.1,8.1,0,0,1,13.8,0L248,200H168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xgs)
      ])) : o(i) === "fill" ? (s(), r("g", jgs, Mgs)) : o(i) === "light" ? (s(), r("g", vgs, [
        e("circle", {
          cx: "164",
          cy: "52",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Sgs),
        e("path", {
          d: "M8,200,81.1,75.7a8.1,8.1,0,0,1,13.8,0L168,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hgs),
        e("line", {
          x1: "50.4",
          y1: "128",
          x2: "125.6",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ags),
        e("path", {
          d: "M144.1,159.4l33-55.8a8.1,8.1,0,0,1,13.8,0L248,200H168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vgs)
      ])) : o(i) === "thin" ? (s(), r("g", zgs, [
        e("circle", {
          cx: "164",
          cy: "52",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zgs),
        e("path", {
          d: "M8,200,81.1,75.7a8.1,8.1,0,0,1,13.8,0L168,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cgs),
        e("line", {
          x1: "50.4",
          y1: "128",
          x2: "125.6",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bgs),
        e("path", {
          d: "M144.1,159.4l33-55.8a8.1,8.1,0,0,1,13.8,0L248,200H168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lgs)
      ])) : o(i) === "regular" ? (s(), r("g", Bgs, [
        e("circle", {
          cx: "164",
          cy: "52",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pgs),
        e("path", {
          d: "M8,200,81.1,75.7a8.1,8.1,0,0,1,13.8,0L168,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wgs),
        e("line", {
          x1: "50.4",
          y1: "128",
          x2: "125.6",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ngs),
        e("path", {
          d: "M144.1,159.4l33-55.8a8.1,8.1,0,0,1,13.8,0L248,200H168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fgs)
      ])) : g("", !0)
    ], 16, dgs));
  }
}), Dgs = ["width", "height", "fill", "transform"], Rgs = { key: 0 }, Ugs = ["stroke"], qgs = ["stroke"], Ggs = ["stroke"], Egs = { key: 1 }, Ogs = /* @__PURE__ */ e("path", {
  d: "M128,32H108A56,56,0,0,0,52,88v24h76Z",
  opacity: "0.2"
}, null, -1), Igs = ["stroke"], Kgs = ["stroke"], Xgs = ["stroke"], Jgs = { key: 2 }, Qgs = /* @__PURE__ */ e("path", { d: "M148,24H108A64.1,64.1,0,0,0,44,88v80a64.1,64.1,0,0,0,64,64h40a64.1,64.1,0,0,0,64-64V88A64.1,64.1,0,0,0,148,24Zm48,64v16H136V40h12A48,48,0,0,1,196,88ZM108,40h12v64H60V88A48,48,0,0,1,108,40Z" }, null, -1), Ygs = [
  Qgs
], oxs = { key: 3 }, exs = ["stroke"], txs = ["stroke"], nxs = ["stroke"], sxs = { key: 4 }, rxs = ["stroke"], ixs = ["stroke"], lxs = ["stroke"], dxs = { key: 5 }, kxs = ["stroke"], cxs = ["stroke"], hxs = ["stroke"], uxs = {
  name: "PhMouse"
}, vJ1 = /* @__PURE__ */ $({
  ...uxs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Rgs, [
        e("rect", {
          x: "52",
          y: "32",
          width: "152",
          height: "192",
          rx: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ugs),
        e("line", {
          x1: "52",
          y1: "112",
          x2: "204",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qgs),
        e("line", {
          x1: "128",
          y1: "112",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ggs)
      ])) : o(i) === "duotone" ? (s(), r("g", Egs, [
        Ogs,
        e("rect", {
          x: "52",
          y: "32",
          width: "152",
          height: "192",
          rx: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Igs),
        e("line", {
          x1: "52",
          y1: "112",
          x2: "204",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kgs),
        e("line", {
          x1: "128",
          y1: "112",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xgs)
      ])) : o(i) === "fill" ? (s(), r("g", Jgs, Ygs)) : o(i) === "light" ? (s(), r("g", oxs, [
        e("rect", {
          x: "52",
          y: "32",
          width: "152",
          height: "192",
          rx: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, exs),
        e("line", {
          x1: "52",
          y1: "112",
          x2: "204",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, txs),
        e("line", {
          x1: "128",
          y1: "112",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nxs)
      ])) : o(i) === "thin" ? (s(), r("g", sxs, [
        e("rect", {
          x: "52",
          y: "32",
          width: "152",
          height: "192",
          rx: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rxs),
        e("line", {
          x1: "52",
          y1: "112",
          x2: "204",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ixs),
        e("line", {
          x1: "128",
          y1: "112",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lxs)
      ])) : o(i) === "regular" ? (s(), r("g", dxs, [
        e("rect", {
          x: "52",
          y: "32",
          width: "152",
          height: "192",
          rx: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kxs),
        e("line", {
          x1: "52",
          y1: "112",
          x2: "204",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cxs),
        e("line", {
          x1: "128",
          y1: "112",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hxs)
      ])) : g("", !0)
    ], 16, Dgs));
  }
}), axs = ["width", "height", "fill", "transform"], _xs = { key: 0 }, pxs = ["stroke"], yxs = ["stroke"], $xs = { key: 1 }, wxs = /* @__PURE__ */ e("rect", {
  x: "52",
  y: "32",
  width: "152",
  height: "192",
  rx: "56",
  opacity: "0.2"
}, null, -1), fxs = ["stroke"], gxs = ["stroke"], xxs = { key: 2 }, jxs = /* @__PURE__ */ e("path", { d: "M148,24H108A64.1,64.1,0,0,0,44,88v80a64.1,64.1,0,0,0,64,64h40a64.1,64.1,0,0,0,64-64V88A64.1,64.1,0,0,0,148,24Zm-12,88a8,8,0,0,1-16,0V64a8,8,0,0,1,16,0Z" }, null, -1), mxs = [
  jxs
], Mxs = { key: 3 }, vxs = ["stroke"], Sxs = ["stroke"], Hxs = { key: 4 }, Axs = ["stroke"], Vxs = ["stroke"], zxs = { key: 5 }, Zxs = ["stroke"], Cxs = ["stroke"], bxs = {
  name: "PhMouseSimple"
}, SJ1 = /* @__PURE__ */ $({
  ...bxs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", _xs, [
        e("rect", {
          x: "52",
          y: "32",
          width: "152",
          height: "192",
          rx: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pxs),
        e("line", {
          x1: "128",
          y1: "116",
          x2: "128",
          y2: "76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yxs)
      ])) : o(i) === "duotone" ? (s(), r("g", $xs, [
        wxs,
        e("rect", {
          x: "52",
          y: "32",
          width: "152",
          height: "192",
          rx: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fxs),
        e("line", {
          x1: "128",
          y1: "112",
          x2: "128",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gxs)
      ])) : o(i) === "fill" ? (s(), r("g", xxs, mxs)) : o(i) === "light" ? (s(), r("g", Mxs, [
        e("rect", {
          x: "52",
          y: "32",
          width: "152",
          height: "192",
          rx: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vxs),
        e("line", {
          x1: "128",
          y1: "112",
          x2: "128",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Sxs)
      ])) : o(i) === "thin" ? (s(), r("g", Hxs, [
        e("rect", {
          x: "52",
          y: "32",
          width: "152",
          height: "192",
          rx: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Axs),
        e("line", {
          x1: "128",
          y1: "112",
          x2: "128",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vxs)
      ])) : o(i) === "regular" ? (s(), r("g", zxs, [
        e("rect", {
          x: "52",
          y: "32",
          width: "152",
          height: "192",
          rx: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zxs),
        e("line", {
          x1: "128",
          y1: "112",
          x2: "128",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cxs)
      ])) : g("", !0)
    ], 16, axs));
  }
}), Lxs = ["width", "height", "fill", "transform"], Bxs = { key: 0 }, Pxs = ["stroke"], Wxs = ["stroke"], Nxs = { key: 1 }, Fxs = /* @__PURE__ */ e("circle", {
  cx: "88",
  cy: "184",
  r: "40",
  opacity: "0.2"
}, null, -1), Txs = ["stroke"], Dxs = ["stroke"], Rxs = { key: 2 }, Uxs = /* @__PURE__ */ e("path", { d: "M210.3,56.3l-80-24a8.2,8.2,0,0,0-7.1,1.3A8.1,8.1,0,0,0,120,40V148.3A47.4,47.4,0,0,0,88,136a48,48,0,1,0,48,48V98.8l69.7,20.9a8.2,8.2,0,0,0,7.1-1.3A8.1,8.1,0,0,0,216,112V64A8.1,8.1,0,0,0,210.3,56.3Z" }, null, -1), qxs = [
  Uxs
], Gxs = { key: 3 }, Exs = ["stroke"], Oxs = ["stroke"], Ixs = { key: 4 }, Kxs = ["stroke"], Xxs = ["stroke"], Jxs = { key: 5 }, Qxs = ["stroke"], Yxs = ["stroke"], ojs = {
  name: "PhMusicNote"
}, HJ1 = /* @__PURE__ */ $({
  ...ojs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Bxs, [
        e("circle", {
          cx: "88",
          cy: "184",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pxs),
        e("polyline", {
          points: "128 184 128 40 208 64 208 112 128 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wxs)
      ])) : o(i) === "duotone" ? (s(), r("g", Nxs, [
        Fxs,
        e("circle", {
          cx: "88",
          cy: "184",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Txs),
        e("polyline", {
          points: "128 184 128 40 208 64 208 112 128 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dxs)
      ])) : o(i) === "fill" ? (s(), r("g", Rxs, qxs)) : o(i) === "light" ? (s(), r("g", Gxs, [
        e("circle", {
          cx: "88",
          cy: "184",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Exs),
        e("polyline", {
          points: "128 184 128 40 208 64 208 112 128 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Oxs)
      ])) : o(i) === "thin" ? (s(), r("g", Ixs, [
        e("circle", {
          cx: "88",
          cy: "184",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kxs),
        e("polyline", {
          points: "128 184 128 40 208 64 208 112 128 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xxs)
      ])) : o(i) === "regular" ? (s(), r("g", Jxs, [
        e("circle", {
          cx: "88",
          cy: "184",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qxs),
        e("polyline", {
          points: "128 184 128 40 208 64 208 112 128 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yxs)
      ])) : g("", !0)
    ], 16, Lxs));
  }
}), ejs = ["width", "height", "fill", "transform"], tjs = { key: 0 }, njs = ["stroke"], sjs = ["stroke"], rjs = { key: 1 }, ijs = /* @__PURE__ */ e("circle", {
  cx: "88",
  cy: "184",
  r: "40",
  opacity: "0.2"
}, null, -1), ljs = ["stroke"], djs = ["stroke"], kjs = { key: 2 }, cjs = /* @__PURE__ */ e("path", { d: "M210.3,56.3l-80-24a8.2,8.2,0,0,0-7.1,1.3A8.1,8.1,0,0,0,120,40V148.3A47.4,47.4,0,0,0,88,136a48,48,0,1,0,48,48V50.8l69.7,20.9a8,8,0,1,0,4.6-15.4Z" }, null, -1), hjs = [
  cjs
], ujs = { key: 3 }, ajs = ["stroke"], _js = ["stroke"], pjs = { key: 4 }, yjs = ["stroke"], $js = ["stroke"], wjs = { key: 5 }, fjs = ["stroke"], gjs = ["stroke"], xjs = {
  name: "PhMusicNoteSimple"
}, AJ1 = /* @__PURE__ */ $({
  ...xjs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", tjs, [
        e("circle", {
          cx: "88",
          cy: "184",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, njs),
        e("polyline", {
          points: "128 184 128 40 208 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sjs)
      ])) : o(i) === "duotone" ? (s(), r("g", rjs, [
        ijs,
        e("circle", {
          cx: "88",
          cy: "184",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ljs),
        e("polyline", {
          points: "128 184 128 40 208 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, djs)
      ])) : o(i) === "fill" ? (s(), r("g", kjs, hjs)) : o(i) === "light" ? (s(), r("g", ujs, [
        e("circle", {
          cx: "88",
          cy: "184",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ajs),
        e("polyline", {
          points: "128 184 128 40 208 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _js)
      ])) : o(i) === "thin" ? (s(), r("g", pjs, [
        e("circle", {
          cx: "88",
          cy: "184",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yjs),
        e("polyline", {
          points: "128 184 128 40 208 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $js)
      ])) : o(i) === "regular" ? (s(), r("g", wjs, [
        e("circle", {
          cx: "88",
          cy: "184",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fjs),
        e("polyline", {
          points: "128 184 128 40 208 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gjs)
      ])) : g("", !0)
    ], 16, ejs));
  }
}), jjs = ["width", "height", "fill", "transform"], mjs = { key: 0 }, Mjs = ["stroke"], vjs = ["stroke"], Sjs = ["stroke"], Hjs = ["stroke"], Ajs = { key: 1 }, Vjs = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "172",
  r: "28",
  opacity: "0.2"
}, null, -1), zjs = /* @__PURE__ */ e("circle", {
  cx: "52",
  cy: "204",
  r: "28",
  opacity: "0.2"
}, null, -1), Zjs = ["stroke"], Cjs = ["stroke"], bjs = ["stroke"], Ljs = ["stroke"], Bjs = { key: 2 }, Pjs = /* @__PURE__ */ e("path", { d: "M212.9,25.7a8,8,0,0,0-6.8-1.5l-128,32A8,8,0,0,0,72,64V174.1A36,36,0,1,0,88,204V110.2l112-28v59.9A36,36,0,1,0,216,172V32A7.8,7.8,0,0,0,212.9,25.7Z" }, null, -1), Wjs = [
  Pjs
], Njs = { key: 3 }, Fjs = ["stroke"], Tjs = ["stroke"], Djs = ["stroke"], Rjs = ["stroke"], Ujs = { key: 4 }, qjs = ["stroke"], Gjs = ["stroke"], Ejs = ["stroke"], Ojs = ["stroke"], Ijs = { key: 5 }, Kjs = ["stroke"], Xjs = ["stroke"], Jjs = ["stroke"], Qjs = ["stroke"], Yjs = {
  name: "PhMusicNotes"
}, VJ1 = /* @__PURE__ */ $({
  ...Yjs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", mjs, [
        e("circle", {
          cx: "180",
          cy: "172",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mjs),
        e("circle", {
          cx: "52",
          cy: "204",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vjs),
        e("line", {
          x1: "208",
          y1: "80",
          x2: "80",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Sjs),
        e("polyline", {
          points: "80 204 80 64 208 32 208 172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hjs)
      ])) : o(i) === "duotone" ? (s(), r("g", Ajs, [
        Vjs,
        zjs,
        e("circle", {
          cx: "180",
          cy: "172",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zjs),
        e("circle", {
          cx: "52",
          cy: "204",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cjs),
        e("line", {
          x1: "208",
          y1: "80",
          x2: "80",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bjs),
        e("polyline", {
          points: "80 204 80 64 208 32 208 172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ljs)
      ])) : o(i) === "fill" ? (s(), r("g", Bjs, Wjs)) : o(i) === "light" ? (s(), r("g", Njs, [
        e("circle", {
          cx: "180",
          cy: "172",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fjs),
        e("circle", {
          cx: "52",
          cy: "204",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Tjs),
        e("line", {
          x1: "208",
          y1: "80",
          x2: "80",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Djs),
        e("polyline", {
          points: "80 204 80 64 208 32 208 172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rjs)
      ])) : o(i) === "thin" ? (s(), r("g", Ujs, [
        e("circle", {
          cx: "180",
          cy: "172",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qjs),
        e("circle", {
          cx: "52",
          cy: "204",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gjs),
        e("line", {
          x1: "208",
          y1: "80",
          x2: "80",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ejs),
        e("polyline", {
          points: "80 204 80 64 208 32 208 172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ojs)
      ])) : o(i) === "regular" ? (s(), r("g", Ijs, [
        e("circle", {
          cx: "180",
          cy: "172",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kjs),
        e("circle", {
          cx: "52",
          cy: "204",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xjs),
        e("line", {
          x1: "208",
          y1: "80",
          x2: "80",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jjs),
        e("polyline", {
          points: "80 204 80 64 208 32 208 172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qjs)
      ])) : g("", !0)
    ], 16, jjs));
  }
}), oms = ["width", "height", "fill", "transform"], ems = { key: 0 }, tms = ["stroke"], nms = ["stroke"], sms = ["stroke"], rms = ["stroke"], ims = ["stroke"], lms = ["stroke"], dms = ["stroke"], kms = { key: 1 }, cms = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "172",
  r: "28",
  opacity: "0.2"
}, null, -1), hms = /* @__PURE__ */ e("circle", {
  cx: "52",
  cy: "204",
  r: "28",
  opacity: "0.2"
}, null, -1), ums = ["stroke"], ams = ["stroke"], _ms = ["stroke"], pms = ["stroke"], yms = ["stroke"], $ms = ["stroke"], wms = ["stroke"], fms = { key: 2 }, gms = /* @__PURE__ */ e("path", { d: "M232,56a8,8,0,0,1-8,8H208V80a8,8,0,0,1-16,0V64H176a8,8,0,0,1,0-16h16V32a8,8,0,0,1,16,0V48h16A8,8,0,0,1,232,56Zm-24,55.2a8,8,0,0,0-8,8v22.9a35.3,35.3,0,0,0-20-6.1,36,36,0,1,0,36,36V119.2A8,8,0,0,0,208,111.2ZM162.4,99.5a7.9,7.9,0,0,0,4.4-5.2,8.3,8.3,0,0,0-2-7.7,9,9,0,0,0-2.6-1.7A32.3,32.3,0,0,1,144,56a37.1,37.1,0,0,1,.3-4.7,7.9,7.9,0,0,0-2-6.9,8.1,8.1,0,0,0-7.8-2.3L78.1,56.2A8,8,0,0,0,72,64V174.1A35.3,35.3,0,0,0,52,168a36,36,0,1,0,36,36V118.2L160.8,100Z" }, null, -1), xms = [
  gms
], jms = { key: 3 }, mms = ["stroke"], Mms = ["stroke"], vms = ["stroke"], Sms = ["stroke"], Hms = ["stroke"], Ams = ["stroke"], Vms = ["stroke"], zms = { key: 4 }, Zms = ["stroke"], Cms = ["stroke"], bms = ["stroke"], Lms = ["stroke"], Bms = ["stroke"], Pms = ["stroke"], Wms = ["stroke"], Nms = { key: 5 }, Fms = ["stroke"], Tms = ["stroke"], Dms = ["stroke"], Rms = ["stroke"], Ums = ["stroke"], qms = ["stroke"], Gms = ["stroke"], Ems = {
  name: "PhMusicNotesPlus"
}, zJ1 = /* @__PURE__ */ $({
  ...Ems,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ems, [
        e("line", {
          x1: "200",
          y1: "32",
          x2: "200",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tms),
        e("line", {
          x1: "224",
          y1: "56",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nms),
        e("circle", {
          cx: "180",
          cy: "172",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sms),
        e("circle", {
          cx: "52",
          cy: "204",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rms),
        e("polyline", {
          points: "80 204 80 64 128.2 52",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ims),
        e("line", {
          x1: "148",
          y1: "95",
          x2: "80",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lms),
        e("line", {
          x1: "208",
          y1: "127.3",
          x2: "208",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dms)
      ])) : o(i) === "duotone" ? (s(), r("g", kms, [
        cms,
        hms,
        e("line", {
          x1: "200",
          y1: "32",
          x2: "200",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ums),
        e("line", {
          x1: "224",
          y1: "56",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ams),
        e("circle", {
          cx: "180",
          cy: "172",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _ms),
        e("circle", {
          cx: "52",
          cy: "204",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pms),
        e("line", {
          x1: "208",
          y1: "119.2",
          x2: "208",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yms),
        e("polyline", {
          points: "80 204 80 64 136.5 49.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $ms),
        e("line", {
          x1: "159.1",
          y1: "92.2",
          x2: "80",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wms)
      ])) : o(i) === "fill" ? (s(), r("g", fms, xms)) : o(i) === "light" ? (s(), r("g", jms, [
        e("line", {
          x1: "200",
          y1: "32",
          x2: "200",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mms),
        e("line", {
          x1: "224",
          y1: "56",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mms),
        e("circle", {
          cx: "180",
          cy: "172",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vms),
        e("circle", {
          cx: "52",
          cy: "204",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Sms),
        e("line", {
          x1: "208",
          y1: "119.2",
          x2: "208",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hms),
        e("polyline", {
          points: "80 204 80 64 136.5 49.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ams),
        e("line", {
          x1: "159.1",
          y1: "92.2",
          x2: "80",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vms)
      ])) : o(i) === "thin" ? (s(), r("g", zms, [
        e("line", {
          x1: "200",
          y1: "32",
          x2: "200",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zms),
        e("line", {
          x1: "224",
          y1: "56",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cms),
        e("circle", {
          cx: "180",
          cy: "172",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bms),
        e("circle", {
          cx: "52",
          cy: "204",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lms),
        e("line", {
          x1: "208",
          y1: "119.2",
          x2: "208",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bms),
        e("polyline", {
          points: "80 204 80 64 136.5 49.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pms),
        e("line", {
          x1: "159.1",
          y1: "92.2",
          x2: "80",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wms)
      ])) : o(i) === "regular" ? (s(), r("g", Nms, [
        e("line", {
          x1: "200",
          y1: "32",
          x2: "200",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fms),
        e("line", {
          x1: "224",
          y1: "56",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tms),
        e("circle", {
          cx: "180",
          cy: "172",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dms),
        e("circle", {
          cx: "52",
          cy: "204",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rms),
        e("line", {
          x1: "208",
          y1: "119.2",
          x2: "208",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ums),
        e("polyline", {
          points: "80 204 80 64 136.5 49.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qms),
        e("line", {
          x1: "159.1",
          y1: "92.2",
          x2: "80",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gms)
      ])) : g("", !0)
    ], 16, oms));
  }
}), Oms = ["width", "height", "fill", "transform"], Ims = { key: 0 }, Kms = ["stroke"], Xms = ["stroke"], Jms = ["stroke"], Qms = { key: 1 }, Yms = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "172",
  r: "28",
  opacity: "0.2"
}, null, -1), oMs = /* @__PURE__ */ e("circle", {
  cx: "52",
  cy: "204",
  r: "28",
  opacity: "0.2"
}, null, -1), eMs = ["stroke"], tMs = ["stroke"], nMs = ["stroke"], sMs = { key: 2 }, rMs = /* @__PURE__ */ e("path", { d: "M212.9,25.7a7.9,7.9,0,0,0-6.8-1.5l-128,32A8,8,0,0,0,72,64V174.1A35.3,35.3,0,0,0,52,168a36,36,0,1,0,36,36V70.2l112-28v99.9a35.3,35.3,0,0,0-20-6.1,36,36,0,1,0,36,36V32A7.8,7.8,0,0,0,212.9,25.7Z" }, null, -1), iMs = [
  rMs
], lMs = { key: 3 }, dMs = ["stroke"], kMs = ["stroke"], cMs = ["stroke"], hMs = { key: 4 }, uMs = ["stroke"], aMs = ["stroke"], _Ms = ["stroke"], pMs = { key: 5 }, yMs = ["stroke"], $Ms = ["stroke"], wMs = ["stroke"], fMs = {
  name: "PhMusicNotesSimple"
}, ZJ1 = /* @__PURE__ */ $({
  ...fMs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ims, [
        e("circle", {
          cx: "180",
          cy: "172",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kms),
        e("circle", {
          cx: "52",
          cy: "204",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xms),
        e("polyline", {
          points: "80 204 80 64 208 32 208 172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jms)
      ])) : o(i) === "duotone" ? (s(), r("g", Qms, [
        Yms,
        oMs,
        e("circle", {
          cx: "180",
          cy: "172",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eMs),
        e("circle", {
          cx: "52",
          cy: "204",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tMs),
        e("polyline", {
          points: "80 204 80 64 208 32 208 172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nMs)
      ])) : o(i) === "fill" ? (s(), r("g", sMs, iMs)) : o(i) === "light" ? (s(), r("g", lMs, [
        e("circle", {
          cx: "180",
          cy: "172",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dMs),
        e("circle", {
          cx: "52",
          cy: "204",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kMs),
        e("polyline", {
          points: "80 204 80 64 208 32 208 172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cMs)
      ])) : o(i) === "thin" ? (s(), r("g", hMs, [
        e("circle", {
          cx: "180",
          cy: "172",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uMs),
        e("circle", {
          cx: "52",
          cy: "204",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aMs),
        e("polyline", {
          points: "80 204 80 64 208 32 208 172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _Ms)
      ])) : o(i) === "regular" ? (s(), r("g", pMs, [
        e("circle", {
          cx: "180",
          cy: "172",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yMs),
        e("circle", {
          cx: "52",
          cy: "204",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Ms),
        e("polyline", {
          points: "80 204 80 64 208 32 208 172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wMs)
      ])) : g("", !0)
    ], 16, Oms));
  }
}), gMs = ["width", "height", "fill", "transform"], xMs = { key: 0 }, jMs = ["stroke"], mMs = { key: 1 }, MMs = /* @__PURE__ */ e("path", {
  d: "M37.4,47.6,96,216.9c2.5,7.3,12.9,7.1,15.2-.3L134.8,140a7.5,7.5,0,0,1,5.3-5.2l76.5-23.6c7.4-2.3,7.6-12.7.3-15.2L47.6,37.4A8,8,0,0,0,37.4,47.6Z",
  opacity: "0.2"
}, null, -1), vMs = ["stroke"], SMs = { key: 2 }, HMs = /* @__PURE__ */ e("path", { d: "M219.5,88.4,50.2,29.8A16,16,0,0,0,29.8,50.2L88.4,219.5a15.8,15.8,0,0,0,15.1,10.8h.3a15.6,15.6,0,0,0,15-11.2l23.6-76.6L219,118.8a15.8,15.8,0,0,0,11.3-15A15.9,15.9,0,0,0,219.5,88.4Z" }, null, -1), AMs = [
  HMs
], VMs = { key: 3 }, zMs = ["stroke"], ZMs = { key: 4 }, CMs = ["stroke"], bMs = { key: 5 }, LMs = ["stroke"], BMs = {
  name: "PhNavigationArrow"
}, CJ1 = /* @__PURE__ */ $({
  ...BMs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xMs, [
        e("path", {
          d: "M37.4,47.6,96,216.9c2.5,7.3,12.9,7.1,15.2-.3L134.8,140a7.5,7.5,0,0,1,5.3-5.2l76.5-23.6c7.4-2.3,7.6-12.7.3-15.2L47.6,37.4A8,8,0,0,0,37.4,47.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jMs)
      ])) : o(i) === "duotone" ? (s(), r("g", mMs, [
        MMs,
        e("path", {
          d: "M37.4,47.6,96,216.9c2.5,7.3,12.9,7.1,15.2-.3L134.8,140a7.5,7.5,0,0,1,5.3-5.2l76.5-23.6c7.4-2.3,7.6-12.7.3-15.2L47.6,37.4A8,8,0,0,0,37.4,47.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vMs)
      ])) : o(i) === "fill" ? (s(), r("g", SMs, AMs)) : o(i) === "light" ? (s(), r("g", VMs, [
        e("path", {
          d: "M37.4,47.6,96,216.9c2.5,7.3,12.9,7.1,15.2-.3L134.8,140a7.5,7.5,0,0,1,5.3-5.2l76.5-23.6c7.4-2.3,7.6-12.7.3-15.2L47.6,37.4A8,8,0,0,0,37.4,47.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zMs)
      ])) : o(i) === "thin" ? (s(), r("g", ZMs, [
        e("path", {
          d: "M37.4,47.6,96,216.9c2.5,7.3,12.9,7.1,15.2-.3L134.8,140a7.5,7.5,0,0,1,5.3-5.2l76.5-23.6c7.4-2.3,7.6-12.7.3-15.2L47.6,37.4A8,8,0,0,0,37.4,47.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CMs)
      ])) : o(i) === "regular" ? (s(), r("g", bMs, [
        e("path", {
          d: "M37.4,47.6,96,216.9c2.5,7.3,12.9,7.1,15.2-.3L134.8,140a7.5,7.5,0,0,1,5.3-5.2l76.5-23.6c7.4-2.3,7.6-12.7.3-15.2L47.6,37.4A8,8,0,0,0,37.4,47.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LMs)
      ])) : g("", !0)
    ], 16, gMs));
  }
}), PMs = ["width", "height", "fill", "transform"], WMs = { key: 0 }, NMs = ["stroke"], FMs = { key: 1 }, TMs = /* @__PURE__ */ e("path", {
  d: "M182.6,118.6l24-24a32,32,0,0,0-45.2-45.2l-24,24C128,128,40,216,40,216S128,128,182.6,118.6Z",
  opacity: "0.3"
}, null, -1), DMs = ["stroke"], RMs = ["stroke"], UMs = { key: 2 }, qMs = /* @__PURE__ */ e("path", { d: "M212.3,43.7a40.1,40.1,0,0,0-56.6,0l-24,24a8.1,8.1,0,0,0-2.2,4.3C120.7,123.3,36,208.7,34.4,210.3h-.1a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0h0c.8-.9,86.8-86.4,138.3-95.2a8.1,8.1,0,0,0,4.3-2.2l24-24a40.1,40.1,0,0,0,0-56.6Zm-22.6,34-16,16a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4l16-16a8.1,8.1,0,0,1,11.4,11.4Z" }, null, -1), GMs = [
  qMs
], EMs = { key: 3 }, OMs = ["stroke"], IMs = ["stroke"], KMs = { key: 4 }, XMs = ["stroke"], JMs = ["stroke"], QMs = { key: 5 }, YMs = ["stroke"], ovs = ["stroke"], evs = {
  name: "PhNeedle"
}, bJ1 = /* @__PURE__ */ $({
  ...evs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", WMs, [
        e("path", {
          d: "M182.6,118.6l24-24a32,32,0,0,0-45.2-45.2l-24,24C128,128,40,216,40,216S128,128,182.6,118.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NMs)
      ])) : o(i) === "duotone" ? (s(), r("g", FMs, [
        TMs,
        e("line", {
          x1: "184",
          y1: "72",
          x2: "168",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DMs),
        e("path", {
          d: "M182.6,118.6l24-24a32,32,0,0,0-45.2-45.2l-24,24C128,128,40,216,40,216S128,128,182.6,118.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RMs)
      ])) : o(i) === "fill" ? (s(), r("g", UMs, GMs)) : o(i) === "light" ? (s(), r("g", EMs, [
        e("line", {
          x1: "184",
          y1: "72",
          x2: "168",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OMs),
        e("path", {
          d: "M182.6,118.6l24-24a32,32,0,0,0-45.2-45.2l-24,24C128,128,40,216,40,216S128,128,182.6,118.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IMs)
      ])) : o(i) === "thin" ? (s(), r("g", KMs, [
        e("line", {
          x1: "184",
          y1: "72",
          x2: "168",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XMs),
        e("path", {
          d: "M182.6,118.6l24-24a32,32,0,0,0-45.2-45.2l-24,24C128,128,40,216,40,216S128,128,182.6,118.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, JMs)
      ])) : o(i) === "regular" ? (s(), r("g", QMs, [
        e("line", {
          x1: "184",
          y1: "72",
          x2: "168",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YMs),
        e("path", {
          d: "M182.6,118.6l24-24a32,32,0,0,0-45.2-45.2l-24,24C128,128,40,216,40,216S128,128,182.6,118.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ovs)
      ])) : g("", !0)
    ], 16, PMs));
  }
}), tvs = ["width", "height", "fill", "transform"], nvs = { key: 0 }, svs = ["stroke"], rvs = ["stroke"], ivs = ["stroke"], lvs = ["stroke"], dvs = { key: 1 }, kvs = /* @__PURE__ */ e("path", {
  d: "M32,200a16,16,0,0,0,16-16V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a16,16,0,0,1-16,16Z",
  opacity: "0.2"
}, null, -1), cvs = ["stroke"], hvs = ["stroke"], uvs = ["stroke"], avs = ["stroke"], _vs = { key: 2 }, pvs = /* @__PURE__ */ e("path", { d: "M216,48H56A16,16,0,0,0,40,64V184a8,8,0,0,1-16,0V88A8,8,0,0,0,8,88v96H8A24,24,0,0,0,32,208H208a24.1,24.1,0,0,0,24-24V64A16,16,0,0,0,216,48ZM176,152H96a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Z" }, null, -1), yvs = [
  pvs
], $vs = { key: 3 }, wvs = ["stroke"], fvs = ["stroke"], gvs = ["stroke"], xvs = ["stroke"], jvs = { key: 4 }, mvs = ["stroke"], Mvs = ["stroke"], vvs = ["stroke"], Svs = ["stroke"], Hvs = { key: 5 }, Avs = ["stroke"], Vvs = ["stroke"], zvs = ["stroke"], Zvs = ["stroke"], Cvs = {
  name: "PhNewspaper"
}, LJ1 = /* @__PURE__ */ $({
  ...Cvs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", nvs, [
        e("path", {
          d: "M16,88v92a20.1,20.1,0,0,0,20,20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, svs),
        e("line", {
          x1: "104",
          y1: "108",
          x2: "176",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rvs),
        e("line", {
          x1: "104",
          y1: "148",
          x2: "176",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ivs),
        e("path", {
          d: "M56,180V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a16,16,0,0,1-16,16H36A20.1,20.1,0,0,0,56,180Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lvs)
      ])) : o(i) === "duotone" ? (s(), r("g", dvs, [
        kvs,
        e("line", {
          x1: "96",
          y1: "112",
          x2: "176",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cvs),
        e("line", {
          x1: "96",
          y1: "144",
          x2: "176",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hvs),
        e("path", {
          d: "M32,200a16,16,0,0,0,16-16V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a16,16,0,0,1-16,16Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uvs),
        e("path", {
          d: "M32,200a16,16,0,0,1-16-16h0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, avs)
      ])) : o(i) === "fill" ? (s(), r("g", _vs, yvs)) : o(i) === "light" ? (s(), r("g", $vs, [
        e("line", {
          x1: "96",
          y1: "112",
          x2: "176",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wvs),
        e("line", {
          x1: "96",
          y1: "144",
          x2: "176",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fvs),
        e("path", {
          d: "M32,200a16,16,0,0,0,16-16V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a16,16,0,0,1-16,16Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gvs),
        e("path", {
          d: "M32,200a16,16,0,0,1-16-16h0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xvs)
      ])) : o(i) === "thin" ? (s(), r("g", jvs, [
        e("line", {
          x1: "96",
          y1: "112",
          x2: "176",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mvs),
        e("line", {
          x1: "96",
          y1: "144",
          x2: "176",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Mvs),
        e("path", {
          d: "M32,200a16,16,0,0,0,16-16V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a16,16,0,0,1-16,16Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vvs),
        e("path", {
          d: "M32,200a16,16,0,0,1-16-16h0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Svs)
      ])) : o(i) === "regular" ? (s(), r("g", Hvs, [
        e("line", {
          x1: "96",
          y1: "112",
          x2: "176",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Avs),
        e("line", {
          x1: "96",
          y1: "144",
          x2: "176",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vvs),
        e("path", {
          d: "M32,200a16,16,0,0,0,16-16V64a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V184a16,16,0,0,1-16,16Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zvs),
        e("path", {
          d: "M32,200a16,16,0,0,1-16-16h0V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zvs)
      ])) : g("", !0)
    ], 16, tvs));
  }
}), bvs = ["width", "height", "fill", "transform"], Lvs = { key: 0 }, Bvs = ["stroke"], Pvs = ["stroke"], Wvs = ["stroke"], Nvs = ["stroke"], Fvs = { key: 1 }, Tvs = /* @__PURE__ */ e("path", {
  d: "M216,48H40a8,8,0,0,0-8,8V216l32-16,32,16,32-16,32,16,32-16,32,16V56A8,8,0,0,0,216,48ZM112,160H64V96h48Z",
  opacity: "0.2"
}, null, -1), Dvs = ["stroke"], Rvs = ["stroke"], Uvs = ["stroke"], qvs = ["stroke"], Gvs = { key: 2 }, Evs = /* @__PURE__ */ e("path", { d: "M72,104h32v48H72ZM232,56V216a7.9,7.9,0,0,1-3.8,6.8,8,8,0,0,1-7.8.4L192,208.9l-28.4,14.3a8.5,8.5,0,0,1-7.2,0L128,208.9,99.6,223.2a8.3,8.3,0,0,1-7.2,0L64,208.9,35.6,223.2a8,8,0,0,1-7.8-.4A7.9,7.9,0,0,1,24,216V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56ZM120,96a8,8,0,0,0-8-8H64a8,8,0,0,0-8,8v64a8,8,0,0,0,8,8h48a8,8,0,0,0,8-8Zm80,48a8,8,0,0,0-8-8H144a8,8,0,0,0,0,16h48A8,8,0,0,0,200,144Zm0-32a8,8,0,0,0-8-8H144a8,8,0,0,0,0,16h48A8,8,0,0,0,200,112Z" }, null, -1), Ovs = [
  Evs
], Ivs = { key: 3 }, Kvs = ["stroke"], Xvs = ["stroke"], Jvs = ["stroke"], Qvs = ["stroke"], Yvs = { key: 4 }, oSs = ["stroke"], eSs = ["stroke"], tSs = ["stroke"], nSs = ["stroke"], sSs = { key: 5 }, rSs = ["stroke"], iSs = ["stroke"], lSs = ["stroke"], dSs = ["stroke"], kSs = {
  name: "PhNewspaperClipping"
}, BJ1 = /* @__PURE__ */ $({
  ...kSs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Lvs, [
        e("path", {
          d: "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bvs),
        e("line", {
          x1: "148",
          y1: "108",
          x2: "184",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pvs),
        e("line", {
          x1: "148",
          y1: "148",
          x2: "184",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wvs),
        e("rect", {
          x: "72",
          y: "96",
          width: "40",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nvs)
      ])) : o(i) === "duotone" ? (s(), r("g", Fvs, [
        Tvs,
        e("path", {
          d: "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dvs),
        e("line", {
          x1: "144",
          y1: "112",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rvs),
        e("line", {
          x1: "144",
          y1: "144",
          x2: "192",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uvs),
        e("rect", {
          x: "64",
          y: "96",
          width: "48",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qvs)
      ])) : o(i) === "fill" ? (s(), r("g", Gvs, Ovs)) : o(i) === "light" ? (s(), r("g", Ivs, [
        e("path", {
          d: "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kvs),
        e("line", {
          x1: "144",
          y1: "112",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xvs),
        e("line", {
          x1: "144",
          y1: "144",
          x2: "192",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jvs),
        e("rect", {
          x: "64",
          y: "96",
          width: "48",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qvs)
      ])) : o(i) === "thin" ? (s(), r("g", Yvs, [
        e("path", {
          d: "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oSs),
        e("line", {
          x1: "144",
          y1: "112",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eSs),
        e("line", {
          x1: "144",
          y1: "144",
          x2: "192",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tSs),
        e("rect", {
          x: "64",
          y: "96",
          width: "48",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nSs)
      ])) : o(i) === "regular" ? (s(), r("g", sSs, [
        e("path", {
          d: "M32,216V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V216l-32-16-32,16-32-16L96,216,64,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rSs),
        e("line", {
          x1: "144",
          y1: "112",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iSs),
        e("line", {
          x1: "144",
          y1: "144",
          x2: "192",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lSs),
        e("rect", {
          x: "64",
          y: "96",
          width: "48",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dSs)
      ])) : g("", !0)
    ], 16, bvs));
  }
}), cSs = ["width", "height", "fill", "transform"], hSs = { key: 0 }, uSs = ["stroke"], aSs = ["stroke"], _Ss = ["stroke"], pSs = ["stroke"], ySs = { key: 1 }, $Ss = /* @__PURE__ */ e("polygon", {
  points: "216 160 160 160 160 216 216 160",
  opacity: "0.2"
}, null, -1), wSs = ["stroke"], fSs = ["stroke"], gSs = ["stroke"], xSs = ["stroke"], jSs = ["stroke"], mSs = { key: 2 }, MSs = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H156.7a15.9,15.9,0,0,0,11.3-4.7L219.3,168a15.9,15.9,0,0,0,4.7-11.3V48A16,16,0,0,0,208,32ZM96,88h64a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16Zm32,80H96a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16ZM96,136a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm64,68.7V160h44.7Z" }, null, -1), vSs = [
  MSs
], SSs = { key: 3 }, HSs = ["stroke"], ASs = ["stroke"], VSs = ["stroke"], zSs = ["stroke"], ZSs = ["stroke"], CSs = { key: 4 }, bSs = ["stroke"], LSs = ["stroke"], BSs = ["stroke"], PSs = ["stroke"], WSs = ["stroke"], NSs = { key: 5 }, FSs = ["stroke"], TSs = ["stroke"], DSs = ["stroke"], RSs = ["stroke"], USs = ["stroke"], qSs = {
  name: "PhNote"
}, PJ1 = /* @__PURE__ */ $({
  ...qSs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", hSs, [
        e("line", {
          x1: "96",
          y1: "108",
          x2: "160",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uSs),
        e("line", {
          x1: "96",
          y1: "148",
          x2: "116",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aSs),
        e("path", {
          d: "M156.7,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.7a7.9,7.9,0,0,1-2.3,5.6l-51.4,51.4A7.9,7.9,0,0,1,156.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Ss),
        e("polyline", {
          points: "215.3 156 156 156 156 215.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pSs)
      ])) : o(i) === "duotone" ? (s(), r("g", ySs, [
        $Ss,
        e("line", {
          x1: "96",
          y1: "96",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wSs),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fSs),
        e("line", {
          x1: "96",
          y1: "160",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gSs),
        e("path", {
          d: "M156.7,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.7a7.9,7.9,0,0,1-2.3,5.6l-51.4,51.4A7.9,7.9,0,0,1,156.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xSs),
        e("polyline", {
          points: "215.3 160 160 160 160 215.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jSs)
      ])) : o(i) === "fill" ? (s(), r("g", mSs, vSs)) : o(i) === "light" ? (s(), r("g", SSs, [
        e("line", {
          x1: "96",
          y1: "96",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HSs),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ASs),
        e("line", {
          x1: "96",
          y1: "160",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VSs),
        e("path", {
          d: "M156.7,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.7a7.9,7.9,0,0,1-2.3,5.6l-51.4,51.4A7.9,7.9,0,0,1,156.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zSs),
        e("polyline", {
          points: "215.3 160 160 160 160 215.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZSs)
      ])) : o(i) === "thin" ? (s(), r("g", CSs, [
        e("line", {
          x1: "96",
          y1: "96",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bSs),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LSs),
        e("line", {
          x1: "96",
          y1: "160",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, BSs),
        e("path", {
          d: "M156.7,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.7a7.9,7.9,0,0,1-2.3,5.6l-51.4,51.4A7.9,7.9,0,0,1,156.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PSs),
        e("polyline", {
          points: "215.3 160 160 160 160 215.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WSs)
      ])) : o(i) === "regular" ? (s(), r("g", NSs, [
        e("line", {
          x1: "96",
          y1: "96",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FSs),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TSs),
        e("line", {
          x1: "96",
          y1: "160",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DSs),
        e("path", {
          d: "M156.7,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.7a7.9,7.9,0,0,1-2.3,5.6l-51.4,51.4A7.9,7.9,0,0,1,156.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RSs),
        e("polyline", {
          points: "215.3 160 160 160 160 215.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, USs)
      ])) : g("", !0)
    ], 16, cSs));
  }
}), GSs = ["width", "height", "fill", "transform"], ESs = { key: 0 }, OSs = ["stroke"], ISs = ["stroke"], KSs = { key: 1 }, XSs = /* @__PURE__ */ e("polygon", {
  points: "216 160 160 160 160 216 216 160",
  opacity: "0.2"
}, null, -1), JSs = ["stroke"], QSs = ["stroke"], YSs = { key: 2 }, oHs = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H156.7a15.9,15.9,0,0,0,11.3-4.7L219.3,168a15.9,15.9,0,0,0,4.7-11.3V48A16,16,0,0,0,208,32ZM160,204.7V160h44.7Z" }, null, -1), eHs = [
  oHs
], tHs = { key: 3 }, nHs = ["stroke"], sHs = ["stroke"], rHs = { key: 4 }, iHs = ["stroke"], lHs = ["stroke"], dHs = { key: 5 }, kHs = ["stroke"], cHs = ["stroke"], hHs = {
  name: "PhNoteBlank"
}, WJ1 = /* @__PURE__ */ $({
  ...hHs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ESs, [
        e("path", {
          d: "M156.7,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.7a7.9,7.9,0,0,1-2.3,5.6l-51.4,51.4A7.9,7.9,0,0,1,156.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OSs),
        e("polyline", {
          points: "215.3 156 156 156 156 215.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ISs)
      ])) : o(i) === "duotone" ? (s(), r("g", KSs, [
        XSs,
        e("path", {
          d: "M156.7,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.7a7.9,7.9,0,0,1-2.3,5.6l-51.4,51.4A7.9,7.9,0,0,1,156.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JSs),
        e("polyline", {
          points: "215.3 160 160 160 160 215.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QSs)
      ])) : o(i) === "fill" ? (s(), r("g", YSs, eHs)) : o(i) === "light" ? (s(), r("g", tHs, [
        e("path", {
          d: "M156.7,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.7a7.9,7.9,0,0,1-2.3,5.6l-51.4,51.4A7.9,7.9,0,0,1,156.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nHs),
        e("polyline", {
          points: "215.3 160 160 160 160 215.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sHs)
      ])) : o(i) === "thin" ? (s(), r("g", rHs, [
        e("path", {
          d: "M156.7,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.7a7.9,7.9,0,0,1-2.3,5.6l-51.4,51.4A7.9,7.9,0,0,1,156.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iHs),
        e("polyline", {
          points: "215.3 160 160 160 160 215.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lHs)
      ])) : o(i) === "regular" ? (s(), r("g", dHs, [
        e("path", {
          d: "M156.7,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.7a7.9,7.9,0,0,1-2.3,5.6l-51.4,51.4A7.9,7.9,0,0,1,156.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kHs),
        e("polyline", {
          points: "215.3 160 160 160 160 215.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cHs)
      ])) : g("", !0)
    ], 16, GSs));
  }
}), uHs = ["width", "height", "fill", "transform"], aHs = { key: 0 }, _Hs = ["stroke"], pHs = ["stroke"], yHs = ["stroke"], $Hs = { key: 1 }, wHs = /* @__PURE__ */ e("polygon", {
  points: "128 160 96 160 96 128 168 56 200 88 128 160",
  opacity: "0.2"
}, null, -1), fHs = ["stroke"], gHs = ["stroke"], xHs = ["stroke"], jHs = { key: 2 }, mHs = /* @__PURE__ */ e("path", { d: "M224,120v88a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32h88a8,8,0,0,1,0,16H48V208H208V120a8,8,0,0,1,16,0Zm5.7-50.3-96,96A8.1,8.1,0,0,1,128,168H96a8,8,0,0,1-8-8V128a8.1,8.1,0,0,1,2.3-5.7l96-96a8.1,8.1,0,0,1,11.4,0l32,32A8.1,8.1,0,0,1,229.7,69.7Zm-17-5.7L192,43.3,179.3,56,200,76.7Z" }, null, -1), MHs = [
  mHs
], vHs = { key: 3 }, SHs = ["stroke"], HHs = ["stroke"], AHs = ["stroke"], VHs = { key: 4 }, zHs = ["stroke"], ZHs = ["stroke"], CHs = ["stroke"], bHs = { key: 5 }, LHs = ["stroke"], BHs = ["stroke"], PHs = ["stroke"], WHs = {
  name: "PhNotePencil"
}, NJ1 = /* @__PURE__ */ $({
  ...WHs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", aHs, [
        e("polygon", {
          points: "128 160 96 160 96 128 192 32 224 64 128 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Hs),
        e("line", {
          x1: "164",
          y1: "60",
          x2: "196",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pHs),
        e("path", {
          d: "M216,128.6V208a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h79.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yHs)
      ])) : o(i) === "duotone" ? (s(), r("g", $Hs, [
        wHs,
        e("polygon", {
          points: "128 160 96 160 96 128 192 32 224 64 128 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fHs),
        e("line", {
          x1: "168",
          y1: "56",
          x2: "200",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gHs),
        e("path", {
          d: "M216,120v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xHs)
      ])) : o(i) === "fill" ? (s(), r("g", jHs, MHs)) : o(i) === "light" ? (s(), r("g", vHs, [
        e("polygon", {
          points: "128 160 96 160 96 128 192 32 224 64 128 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, SHs),
        e("line", {
          x1: "168",
          y1: "56",
          x2: "200",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HHs),
        e("path", {
          d: "M216,120v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, AHs)
      ])) : o(i) === "thin" ? (s(), r("g", VHs, [
        e("polygon", {
          points: "128 160 96 160 96 128 192 32 224 64 128 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zHs),
        e("line", {
          x1: "168",
          y1: "56",
          x2: "200",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZHs),
        e("path", {
          d: "M216,120v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CHs)
      ])) : o(i) === "regular" ? (s(), r("g", bHs, [
        e("polygon", {
          points: "128 160 96 160 96 128 192 32 224 64 128 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LHs),
        e("line", {
          x1: "168",
          y1: "56",
          x2: "200",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BHs),
        e("path", {
          d: "M216,120v88a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PHs)
      ])) : g("", !0)
    ], 16, uHs));
  }
}), NHs = ["width", "height", "fill", "transform"], FHs = { key: 0 }, THs = ["stroke"], DHs = ["stroke"], RHs = ["stroke"], UHs = ["stroke"], qHs = { key: 1 }, GHs = /* @__PURE__ */ e("path", {
  d: "M80,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H80Z",
  opacity: "0.2"
}, null, -1), EHs = ["stroke"], OHs = ["stroke"], IHs = ["stroke"], KHs = ["stroke"], XHs = { key: 2 }, JHs = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM80,208H48V48H80Zm96-56H112a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H112a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z" }, null, -1), QHs = [
  JHs
], YHs = { key: 3 }, oAs = ["stroke"], eAs = ["stroke"], tAs = ["stroke"], nAs = ["stroke"], sAs = { key: 4 }, rAs = ["stroke"], iAs = ["stroke"], lAs = ["stroke"], dAs = ["stroke"], kAs = { key: 5 }, cAs = ["stroke"], hAs = ["stroke"], uAs = ["stroke"], aAs = ["stroke"], _As = {
  name: "PhNotebook"
}, FJ1 = /* @__PURE__ */ $({
  ..._As,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", FHs, [
        e("line", {
          x1: "120",
          y1: "108",
          x2: "176",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, THs),
        e("line", {
          x1: "120",
          y1: "148",
          x2: "176",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DHs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RHs),
        e("line", {
          x1: "80",
          y1: "40",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, UHs)
      ])) : o(i) === "duotone" ? (s(), r("g", qHs, [
        GHs,
        e("line", {
          x1: "112",
          y1: "112",
          x2: "176",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EHs),
        e("line", {
          x1: "112",
          y1: "144",
          x2: "176",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OHs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IHs),
        e("line", {
          x1: "80",
          y1: "40",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KHs)
      ])) : o(i) === "fill" ? (s(), r("g", XHs, QHs)) : o(i) === "light" ? (s(), r("g", YHs, [
        e("line", {
          x1: "112",
          y1: "112",
          x2: "176",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oAs),
        e("line", {
          x1: "112",
          y1: "144",
          x2: "176",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eAs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tAs),
        e("line", {
          x1: "80",
          y1: "40",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nAs)
      ])) : o(i) === "thin" ? (s(), r("g", sAs, [
        e("line", {
          x1: "112",
          y1: "112",
          x2: "176",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rAs),
        e("line", {
          x1: "112",
          y1: "144",
          x2: "176",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iAs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lAs),
        e("line", {
          x1: "80",
          y1: "40",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dAs)
      ])) : o(i) === "regular" ? (s(), r("g", kAs, [
        e("line", {
          x1: "112",
          y1: "112",
          x2: "176",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cAs),
        e("line", {
          x1: "112",
          y1: "144",
          x2: "176",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hAs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uAs),
        e("line", {
          x1: "80",
          y1: "40",
          x2: "80",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aAs)
      ])) : g("", !0)
    ], 16, NHs));
  }
}), pAs = ["width", "height", "fill", "transform"], yAs = { key: 0 }, $As = ["stroke"], wAs = ["stroke"], fAs = ["stroke"], gAs = ["stroke"], xAs = ["stroke"], jAs = ["stroke"], mAs = { key: 1 }, MAs = /* @__PURE__ */ e("path", {
  d: "M56,40H200a8,8,0,0,1,8,8V200a24,24,0,0,1-24,24H72a24,24,0,0,1-24-24V48A8,8,0,0,1,56,40Z",
  opacity: "0.2"
}, null, -1), vAs = ["stroke"], SAs = ["stroke"], HAs = ["stroke"], AAs = ["stroke"], VAs = ["stroke"], zAs = ["stroke"], ZAs = { key: 2 }, CAs = /* @__PURE__ */ e("path", { d: "M200,32H184V24a8,8,0,0,0-16,0v8H136V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H56A16,16,0,0,0,40,48V200a32,32,0,0,0,32,32H184a32,32,0,0,0,32-32V48A16,16,0,0,0,200,32ZM160,168H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Zm0-32H96a8,8,0,0,1,0-16h64a8,8,0,0,1,0,16Z" }, null, -1), bAs = [
  CAs
], LAs = { key: 3 }, BAs = ["stroke"], PAs = ["stroke"], WAs = ["stroke"], NAs = ["stroke"], FAs = ["stroke"], TAs = ["stroke"], DAs = { key: 4 }, RAs = ["stroke"], UAs = ["stroke"], qAs = ["stroke"], GAs = ["stroke"], EAs = ["stroke"], OAs = ["stroke"], IAs = { key: 5 }, KAs = ["stroke"], XAs = ["stroke"], JAs = ["stroke"], QAs = ["stroke"], YAs = ["stroke"], oVs = ["stroke"], eVs = {
  name: "PhNotepad"
}, TJ1 = /* @__PURE__ */ $({
  ...eVs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", yAs, [
        e("line", {
          x1: "96",
          y1: "124",
          x2: "160",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $As),
        e("line", {
          x1: "96",
          y1: "164",
          x2: "160",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wAs),
        e("path", {
          d: "M56,40H200a8,8,0,0,1,8,8V200a24,24,0,0,1-24,24H72a24,24,0,0,1-24-24V48A8,8,0,0,1,56,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fAs),
        e("line", {
          x1: "84",
          y1: "24",
          x2: "84",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gAs),
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xAs),
        e("line", {
          x1: "172",
          y1: "24",
          x2: "172",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jAs)
      ])) : o(i) === "duotone" ? (s(), r("g", mAs, [
        MAs,
        e("line", {
          x1: "96",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vAs),
        e("line", {
          x1: "96",
          y1: "160",
          x2: "160",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SAs),
        e("path", {
          d: "M56,40H200a8,8,0,0,1,8,8V200a24,24,0,0,1-24,24H72a24,24,0,0,1-24-24V48A8,8,0,0,1,56,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HAs),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AAs),
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VAs),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zAs)
      ])) : o(i) === "fill" ? (s(), r("g", ZAs, bAs)) : o(i) === "light" ? (s(), r("g", LAs, [
        e("line", {
          x1: "96",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BAs),
        e("line", {
          x1: "96",
          y1: "160",
          x2: "160",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PAs),
        e("path", {
          d: "M56,40H200a8,8,0,0,1,8,8V200a24,24,0,0,1-24,24H72a24,24,0,0,1-24-24V48A8,8,0,0,1,56,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WAs),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, NAs),
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FAs),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TAs)
      ])) : o(i) === "thin" ? (s(), r("g", DAs, [
        e("line", {
          x1: "96",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RAs),
        e("line", {
          x1: "96",
          y1: "160",
          x2: "160",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, UAs),
        e("path", {
          d: "M56,40H200a8,8,0,0,1,8,8V200a24,24,0,0,1-24,24H72a24,24,0,0,1-24-24V48A8,8,0,0,1,56,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qAs),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GAs),
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, EAs),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OAs)
      ])) : o(i) === "regular" ? (s(), r("g", IAs, [
        e("line", {
          x1: "96",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KAs),
        e("line", {
          x1: "96",
          y1: "160",
          x2: "160",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XAs),
        e("path", {
          d: "M56,40H200a8,8,0,0,1,8,8V200a24,24,0,0,1-24,24H72a24,24,0,0,1-24-24V48A8,8,0,0,1,56,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JAs),
        e("line", {
          x1: "80",
          y1: "24",
          x2: "80",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QAs),
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YAs),
        e("line", {
          x1: "176",
          y1: "24",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oVs)
      ])) : g("", !0)
    ], 16, pAs));
  }
}), tVs = ["width", "height", "fill", "transform"], nVs = { key: 0 }, sVs = ["stroke"], rVs = ["stroke"], iVs = { key: 1 }, lVs = /* @__PURE__ */ e("circle", {
  cx: "196",
  cy: "60",
  r: "28",
  opacity: "0.2"
}, null, -1), dVs = ["stroke"], kVs = ["stroke"], cVs = { key: 2 }, hVs = /* @__PURE__ */ e("path", { d: "M216,128v80a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V56A16,16,0,0,1,48,40h80a8,8,0,0,1,0,16H48V208H200V128a8,8,0,0,1,16,0ZM196,24a36,36,0,1,0,36,36A36,36,0,0,0,196,24Z" }, null, -1), uVs = [
  hVs
], aVs = { key: 3 }, _Vs = ["stroke"], pVs = ["stroke"], yVs = { key: 4 }, $Vs = ["stroke"], wVs = ["stroke"], fVs = { key: 5 }, gVs = ["stroke"], xVs = ["stroke"], jVs = {
  name: "PhNotification"
}, DJ1 = /* @__PURE__ */ $({
  ...jVs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", nVs, [
        e("path", {
          d: "M208,128v80a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sVs),
        e("circle", {
          cx: "196",
          cy: "60",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rVs)
      ])) : o(i) === "duotone" ? (s(), r("g", iVs, [
        lVs,
        e("path", {
          d: "M208,128v80a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dVs),
        e("circle", {
          cx: "196",
          cy: "60",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kVs)
      ])) : o(i) === "fill" ? (s(), r("g", cVs, uVs)) : o(i) === "light" ? (s(), r("g", aVs, [
        e("path", {
          d: "M208,128v80a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _Vs),
        e("circle", {
          cx: "196",
          cy: "60",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pVs)
      ])) : o(i) === "thin" ? (s(), r("g", yVs, [
        e("path", {
          d: "M208,128v80a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $Vs),
        e("circle", {
          cx: "196",
          cy: "60",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wVs)
      ])) : o(i) === "regular" ? (s(), r("g", fVs, [
        e("path", {
          d: "M208,128v80a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8h80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gVs),
        e("circle", {
          cx: "196",
          cy: "60",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xVs)
      ])) : g("", !0)
    ], 16, tVs));
  }
}), mVs = ["width", "height", "fill", "transform"], MVs = { key: 0 }, vVs = ["stroke"], SVs = ["stroke"], HVs = ["stroke"], AVs = { key: 1 }, VVs = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), zVs = ["stroke"], ZVs = ["stroke"], CVs = ["stroke"], bVs = { key: 2 }, LVs = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm24,150a33.9,33.9,0,1,1-48-48,26.6,26.6,0,0,1,3.1-2.6l-.3-.2a29.9,29.9,0,0,1,0-42.4c11.3-11.3,31.1-11.3,42.4,0a29.9,29.9,0,0,1,0,42.4l-.3.2A26.6,26.6,0,0,1,152,126a33.8,33.8,0,0,1,0,48Z" }, null, -1), BVs = /* @__PURE__ */ e("path", { d: "M137.9,111.9a14,14,0,1,0-19.8,0A14.3,14.3,0,0,0,137.9,111.9Z" }, null, -1), PVs = /* @__PURE__ */ e("path", { d: "M128,132a18,18,0,0,0-12.7,30.7,18.4,18.4,0,0,0,25.4,0A18,18,0,0,0,128,132Z" }, null, -1), WVs = [
  LVs,
  BVs,
  PVs
], NVs = { key: 3 }, FVs = ["stroke"], TVs = ["stroke"], DVs = ["stroke"], RVs = { key: 4 }, UVs = ["stroke"], qVs = ["stroke"], GVs = ["stroke"], EVs = { key: 5 }, OVs = ["stroke"], IVs = ["stroke"], KVs = ["stroke"], XVs = {
  name: "PhNumberCircleEight"
}, RJ1 = /* @__PURE__ */ $({
  ...XVs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", MVs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vVs),
        e("path", {
          d: "M150,102a21.9,21.9,0,1,1-6.4-15.6A22.3,22.3,0,0,1,150,102Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SVs),
        e("path", {
          d: "M154,150a25.9,25.9,0,1,1-7.6-18.4A25.9,25.9,0,0,1,154,150Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HVs)
      ])) : o(i) === "duotone" ? (s(), r("g", AVs, [
        VVs,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, zVs),
        e("path", {
          d: "M150,102a21.9,21.9,0,1,1-6.4-15.6A22.3,22.3,0,0,1,150,102Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZVs),
        e("path", {
          d: "M154,150a25.9,25.9,0,1,1-7.6-18.4A25.9,25.9,0,0,1,154,150Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CVs)
      ])) : o(i) === "fill" ? (s(), r("g", bVs, WVs)) : o(i) === "light" ? (s(), r("g", NVs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FVs),
        e("path", {
          d: "M150,102a21.9,21.9,0,1,1-6.4-15.6A22.3,22.3,0,0,1,150,102Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TVs),
        e("path", {
          d: "M154,150a25.9,25.9,0,1,1-7.6-18.4A25.9,25.9,0,0,1,154,150Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DVs)
      ])) : o(i) === "thin" ? (s(), r("g", RVs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, UVs),
        e("path", {
          d: "M150,102a21.9,21.9,0,1,1-6.4-15.6A22.3,22.3,0,0,1,150,102Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qVs),
        e("path", {
          d: "M154,150a25.9,25.9,0,1,1-7.6-18.4A25.9,25.9,0,0,1,154,150Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GVs)
      ])) : o(i) === "regular" ? (s(), r("g", EVs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, OVs),
        e("path", {
          d: "M150,102a21.9,21.9,0,1,1-6.4-15.6A22.3,22.3,0,0,1,150,102Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IVs),
        e("path", {
          d: "M154,150a25.9,25.9,0,1,1-7.6-18.4A25.9,25.9,0,0,1,154,150Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KVs)
      ])) : g("", !0)
    ], 16, mVs));
  }
}), JVs = ["width", "height", "fill", "transform"], QVs = { key: 0 }, YVs = ["stroke"], ozs = ["stroke"], ezs = { key: 1 }, tzs = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), nzs = ["stroke"], szs = ["stroke"], rzs = { key: 2 }, izs = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm-4.1,92a36,36,0,1,1-25.5,61.5,8,8,0,1,1,11.2-11.4,20.1,20.1,0,0,0,14.3,5.9,19.9,19.9,0,0,0,14.2-5.9,19.8,19.8,0,0,0,0-28.2,19.9,19.9,0,0,0-14.2-5.9,20.1,20.1,0,0,0-14.3,5.9,8,8,0,0,1-13.5-7l7.8-48.2a8,8,0,0,1,7.9-6.7H152a8,8,0,0,1,0,16H118.6l-4.1,25.2A37.3,37.3,0,0,1,123.9,116Z" }, null, -1), lzs = [
  izs
], dzs = { key: 3 }, kzs = ["stroke"], czs = ["stroke"], hzs = { key: 4 }, uzs = ["stroke"], azs = ["stroke"], _zs = { key: 5 }, pzs = ["stroke"], yzs = ["stroke"], $zs = {
  name: "PhNumberCircleFive"
}, UJ1 = /* @__PURE__ */ $({
  ...$zs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", QVs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, YVs),
        e("path", {
          d: "M152,84H111.8L104,132.2a28,28,0,1,1,0,39.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ozs)
      ])) : o(i) === "duotone" ? (s(), r("g", ezs, [
        tzs,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, nzs),
        e("path", {
          d: "M152,84H111.8L104,132.2a28,28,0,1,1,0,39.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, szs)
      ])) : o(i) === "fill" ? (s(), r("g", rzs, lzs)) : o(i) === "light" ? (s(), r("g", dzs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kzs),
        e("path", {
          d: "M152,84H111.8L104,132.2a28,28,0,1,1,0,39.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, czs)
      ])) : o(i) === "thin" ? (s(), r("g", hzs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uzs),
        e("path", {
          d: "M152,84H111.8L104,132.2a28,28,0,1,1,0,39.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, azs)
      ])) : o(i) === "regular" ? (s(), r("g", _zs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, pzs),
        e("path", {
          d: "M152,84H111.8L104,132.2a28,28,0,1,1,0,39.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yzs)
      ])) : g("", !0)
    ], 16, JVs));
  }
}), wzs = ["width", "height", "fill", "transform"], fzs = { key: 0 }, gzs = ["stroke"], xzs = ["stroke"], jzs = ["stroke"], mzs = { key: 1 }, Mzs = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), vzs = ["stroke"], Szs = ["stroke"], Hzs = ["stroke"], Azs = { key: 2 }, Vzs = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm28,152a8,8,0,0,1-16,0V152H100a8,8,0,0,1-6.5-3.4,7.9,7.9,0,0,1-1-7.3l24-68a8,8,0,0,1,15,5.4L111.3,136H140V112a8,8,0,0,1,16,0Z" }, null, -1), zzs = [
  Vzs
], Zzs = { key: 3 }, Czs = ["stroke"], bzs = ["stroke"], Lzs = ["stroke"], Bzs = { key: 4 }, Pzs = ["stroke"], Wzs = ["stroke"], Nzs = ["stroke"], Fzs = { key: 5 }, Tzs = ["stroke"], Dzs = ["stroke"], Rzs = ["stroke"], Uzs = {
  name: "PhNumberCircleFour"
}, qJ1 = /* @__PURE__ */ $({
  ...Uzs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", fzs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gzs),
        e("polyline", {
          points: "124 76 100 144 148 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xzs),
        e("line", {
          x1: "148",
          y1: "112",
          x2: "148",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jzs)
      ])) : o(i) === "duotone" ? (s(), r("g", mzs, [
        Mzs,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, vzs),
        e("polyline", {
          points: "124 76 100 144 148 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Szs),
        e("line", {
          x1: "148",
          y1: "112",
          x2: "148",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hzs)
      ])) : o(i) === "fill" ? (s(), r("g", Azs, zzs)) : o(i) === "light" ? (s(), r("g", Zzs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Czs),
        e("polyline", {
          points: "124 76 100 144 148 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bzs),
        e("line", {
          x1: "148",
          y1: "112",
          x2: "148",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lzs)
      ])) : o(i) === "thin" ? (s(), r("g", Bzs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pzs),
        e("polyline", {
          points: "124 76 100 144 148 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wzs),
        e("line", {
          x1: "148",
          y1: "112",
          x2: "148",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nzs)
      ])) : o(i) === "regular" ? (s(), r("g", Fzs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Tzs),
        e("polyline", {
          points: "124 76 100 144 148 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dzs),
        e("line", {
          x1: "148",
          y1: "112",
          x2: "148",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rzs)
      ])) : g("", !0)
    ], 16, wzs));
  }
}), qzs = ["width", "height", "fill", "transform"], Gzs = { key: 0 }, Ezs = ["stroke"], Ozs = ["stroke"], Izs = ["stroke"], Kzs = { key: 1 }, Xzs = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), Jzs = ["stroke"], Qzs = ["stroke"], Yzs = ["stroke"], oZs = { key: 2 }, eZs = /* @__PURE__ */ e("path", { d: "M148,112a20,20,0,1,1-20-20A20.1,20.1,0,0,1,148,112Zm84,16A104,104,0,1,1,128,24,104.2,104.2,0,0,1,232,128Zm-68-16a36,36,0,1,0-36,36h1.8l-16.7,27.9a8.1,8.1,0,0,0,2.8,11A8.7,8.7,0,0,0,120,188a8.1,8.1,0,0,0,6.9-3.9l32.2-54,.3-.5A36,36,0,0,0,164,112Z" }, null, -1), tZs = [
  eZs
], nZs = { key: 3 }, sZs = ["stroke"], rZs = ["stroke"], iZs = ["stroke"], lZs = { key: 4 }, dZs = ["stroke"], kZs = ["stroke"], cZs = ["stroke"], hZs = { key: 5 }, uZs = ["stroke"], aZs = ["stroke"], _Zs = ["stroke"], pZs = {
  name: "PhNumberCircleNine"
}, GJ1 = /* @__PURE__ */ $({
  ...pZs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Gzs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ezs),
        e("line", {
          x1: "152.2",
          y1: "126",
          x2: "120",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ozs),
        e("circle", {
          cx: "128",
          cy: "112",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Izs)
      ])) : o(i) === "duotone" ? (s(), r("g", Kzs, [
        Xzs,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Jzs),
        e("line", {
          x1: "152.2",
          y1: "126",
          x2: "120",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qzs),
        e("circle", {
          cx: "128",
          cy: "112",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yzs)
      ])) : o(i) === "fill" ? (s(), r("g", oZs, tZs)) : o(i) === "light" ? (s(), r("g", nZs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sZs),
        e("line", {
          x1: "152.2",
          y1: "126",
          x2: "120",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rZs),
        e("circle", {
          cx: "128",
          cy: "112",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iZs)
      ])) : o(i) === "thin" ? (s(), r("g", lZs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dZs),
        e("line", {
          x1: "152.2",
          y1: "126",
          x2: "120",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kZs),
        e("circle", {
          cx: "128",
          cy: "112",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cZs)
      ])) : o(i) === "regular" ? (s(), r("g", hZs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, uZs),
        e("line", {
          x1: "152.2",
          y1: "126",
          x2: "120",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aZs),
        e("circle", {
          cx: "128",
          cy: "112",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Zs)
      ])) : g("", !0)
    ], 16, qzs));
  }
}), yZs = ["width", "height", "fill", "transform"], $Zs = { key: 0 }, wZs = ["stroke"], fZs = ["stroke"], gZs = { key: 1 }, xZs = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), jZs = ["stroke"], mZs = ["stroke"], MZs = { key: 2 }, vZs = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm12,152a8,8,0,0,1-16,0V98.9l-11.6,7.8a8,8,0,0,1-8.8-13.4l24-16a8.3,8.3,0,0,1,8.2-.4A8,8,0,0,1,140,84Z" }, null, -1), SZs = [
  vZs
], HZs = { key: 3 }, AZs = ["stroke"], VZs = ["stroke"], zZs = { key: 4 }, ZZs = ["stroke"], CZs = ["stroke"], bZs = { key: 5 }, LZs = ["stroke"], BZs = ["stroke"], PZs = {
  name: "PhNumberCircleOne"
}, EJ1 = /* @__PURE__ */ $({
  ...PZs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $Zs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wZs),
        e("polyline", {
          points: "108 100 132 84 132 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fZs)
      ])) : o(i) === "duotone" ? (s(), r("g", gZs, [
        xZs,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, jZs),
        e("polyline", {
          points: "108 100 132 84 132 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mZs)
      ])) : o(i) === "fill" ? (s(), r("g", MZs, SZs)) : o(i) === "light" ? (s(), r("g", HZs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, AZs),
        e("polyline", {
          points: "108 100 132 84 132 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VZs)
      ])) : o(i) === "thin" ? (s(), r("g", zZs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZZs),
        e("polyline", {
          points: "108 100 132 84 132 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CZs)
      ])) : o(i) === "regular" ? (s(), r("g", bZs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, LZs),
        e("polyline", {
          points: "108 100 132 84 132 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BZs)
      ])) : g("", !0)
    ], 16, yZs));
  }
}), WZs = ["width", "height", "fill", "transform"], NZs = { key: 0 }, FZs = ["stroke"], TZs = ["stroke"], DZs = { key: 1 }, RZs = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), UZs = ["stroke"], qZs = ["stroke"], GZs = { key: 2 }, EZs = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm31.6,62.5-32,96A7.9,7.9,0,0,1,120,188a7.3,7.3,0,0,1-2.5-.4,8,8,0,0,1-5.1-10.1L140.9,92H104a8,8,0,0,1,0-16h48a7.9,7.9,0,0,1,6.5,3.3A8.1,8.1,0,0,1,159.6,86.5Z" }, null, -1), OZs = [
  EZs
], IZs = { key: 3 }, KZs = ["stroke"], XZs = ["stroke"], JZs = { key: 4 }, QZs = ["stroke"], YZs = ["stroke"], oCs = { key: 5 }, eCs = ["stroke"], tCs = ["stroke"], nCs = {
  name: "PhNumberCircleSeven"
}, OJ1 = /* @__PURE__ */ $({
  ...nCs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", NZs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FZs),
        e("polyline", {
          points: "104 84 152 84 120 180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TZs)
      ])) : o(i) === "duotone" ? (s(), r("g", DZs, [
        RZs,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, UZs),
        e("polyline", {
          points: "104 84 152 84 120 180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qZs)
      ])) : o(i) === "fill" ? (s(), r("g", GZs, OZs)) : o(i) === "light" ? (s(), r("g", IZs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KZs),
        e("polyline", {
          points: "104 84 152 84 120 180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XZs)
      ])) : o(i) === "thin" ? (s(), r("g", JZs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QZs),
        e("polyline", {
          points: "104 84 152 84 120 180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YZs)
      ])) : o(i) === "regular" ? (s(), r("g", oCs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, eCs),
        e("polyline", {
          points: "104 84 152 84 120 180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tCs)
      ])) : g("", !0)
    ], 16, WZs));
  }
}), sCs = ["width", "height", "fill", "transform"], rCs = { key: 0 }, iCs = ["stroke"], lCs = ["stroke"], dCs = ["stroke"], kCs = { key: 1 }, cCs = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), hCs = ["stroke"], uCs = ["stroke"], aCs = ["stroke"], _Cs = { key: 2 }, pCs = /* @__PURE__ */ e("path", { d: "M148,144a20,20,0,1,1-20-20A20.1,20.1,0,0,1,148,144Zm84-16A104,104,0,1,1,128,24,104.2,104.2,0,0,1,232,128Zm-68,16a36,36,0,0,0-36-36h-1.8l16.7-27.9a8,8,0,1,0-13.8-8.2l-32.2,54-.3.6A36,36,0,1,0,164,144Z" }, null, -1), yCs = [
  pCs
], $Cs = { key: 3 }, wCs = ["stroke"], fCs = ["stroke"], gCs = ["stroke"], xCs = { key: 4 }, jCs = ["stroke"], mCs = ["stroke"], MCs = ["stroke"], vCs = { key: 5 }, SCs = ["stroke"], HCs = ["stroke"], ACs = ["stroke"], VCs = {
  name: "PhNumberCircleSix"
}, IJ1 = /* @__PURE__ */ $({
  ...VCs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", rCs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iCs),
        e("line", {
          x1: "103.8",
          y1: "130",
          x2: "136",
          y2: "76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lCs),
        e("circle", {
          cx: "128",
          cy: "144",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dCs)
      ])) : o(i) === "duotone" ? (s(), r("g", kCs, [
        cCs,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, hCs),
        e("line", {
          x1: "103.8",
          y1: "130",
          x2: "136",
          y2: "76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uCs),
        e("circle", {
          cx: "128",
          cy: "144",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aCs)
      ])) : o(i) === "fill" ? (s(), r("g", _Cs, yCs)) : o(i) === "light" ? (s(), r("g", $Cs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wCs),
        e("line", {
          x1: "103.8",
          y1: "130",
          x2: "136",
          y2: "76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fCs),
        e("circle", {
          cx: "128",
          cy: "144",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gCs)
      ])) : o(i) === "thin" ? (s(), r("g", xCs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jCs),
        e("line", {
          x1: "103.8",
          y1: "130",
          x2: "136",
          y2: "76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mCs),
        e("circle", {
          cx: "128",
          cy: "144",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MCs)
      ])) : o(i) === "regular" ? (s(), r("g", vCs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, SCs),
        e("line", {
          x1: "103.8",
          y1: "130",
          x2: "136",
          y2: "76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HCs),
        e("circle", {
          cx: "128",
          cy: "144",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ACs)
      ])) : g("", !0)
    ], 16, sCs));
  }
}), zCs = ["width", "height", "fill", "transform"], ZCs = { key: 0 }, CCs = ["stroke"], bCs = ["stroke"], LCs = { key: 1 }, BCs = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), PCs = ["stroke"], WCs = ["stroke"], NCs = { key: 2 }, FCs = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm21.5,153.5a36.2,36.2,0,0,1-51,0,8.1,8.1,0,0,1,11.4-11.4A19.9,19.9,0,1,0,124,132a8.1,8.1,0,0,1-7.1-4.3,8,8,0,0,1,.5-8.3L136.6,92H104a8,8,0,0,1,0-16h48a8.1,8.1,0,0,1,7.1,4.3,8,8,0,0,1-.5,8.3l-21.1,30a37.9,37.9,0,0,1,12,7.9,36.2,36.2,0,0,1,0,51Z" }, null, -1), TCs = [
  FCs
], DCs = { key: 3 }, RCs = ["stroke"], UCs = ["stroke"], qCs = { key: 4 }, GCs = ["stroke"], ECs = ["stroke"], OCs = { key: 5 }, ICs = ["stroke"], KCs = ["stroke"], XCs = {
  name: "PhNumberCircleThree"
}, KJ1 = /* @__PURE__ */ $({
  ...XCs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ZCs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CCs),
        e("path", {
          d: "M104,84h48l-28,40a28,28,0,1,1-19.8,47.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bCs)
      ])) : o(i) === "duotone" ? (s(), r("g", LCs, [
        BCs,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, PCs),
        e("path", {
          d: "M104,84h48l-28,40a28,28,0,1,1-19.8,47.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WCs)
      ])) : o(i) === "fill" ? (s(), r("g", NCs, TCs)) : o(i) === "light" ? (s(), r("g", DCs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RCs),
        e("path", {
          d: "M104,84h48l-28,40a28,28,0,1,1-19.8,47.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UCs)
      ])) : o(i) === "thin" ? (s(), r("g", qCs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GCs),
        e("path", {
          d: "M104,84h48l-28,40a28,28,0,1,1-19.8,47.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ECs)
      ])) : o(i) === "regular" ? (s(), r("g", OCs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, ICs),
        e("path", {
          d: "M104,84h48l-28,40a28,28,0,1,1-19.8,47.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KCs)
      ])) : g("", !0)
    ], 16, zCs));
  }
}), JCs = ["width", "height", "fill", "transform"], QCs = { key: 0 }, YCs = ["stroke"], obs = ["stroke"], ebs = { key: 1 }, tbs = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), nbs = ["stroke"], sbs = ["stroke"], rbs = { key: 2 }, ibs = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm24,144a8,8,0,0,1,0,16H104a7.3,7.3,0,0,1-2.5-.4A8,8,0,0,1,96,176a7.5,7.5,0,0,1,1.7-4.9l43.7-58.3A16,16,0,0,0,128,88a15.9,15.9,0,0,0-14.7,9.8,8,8,0,0,1-14.8-6.3,32,32,0,1,1,56,30.4l-.2.3L120,168Z" }, null, -1), lbs = [
  ibs
], dbs = { key: 3 }, kbs = ["stroke"], cbs = ["stroke"], hbs = { key: 4 }, ubs = ["stroke"], abs = ["stroke"], _bs = { key: 5 }, pbs = ["stroke"], ybs = ["stroke"], $bs = {
  name: "PhNumberCircleTwo"
}, XJ1 = /* @__PURE__ */ $({
  ...$bs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", QCs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, YCs),
        e("path", {
          d: "M105.9,94.7A24,24,0,0,1,152,104a23.6,23.6,0,0,1-4.1,13.4h0L104,176h48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, obs)
      ])) : o(i) === "duotone" ? (s(), r("g", ebs, [
        tbs,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, nbs),
        e("path", {
          d: "M105.9,94.7A24,24,0,0,1,152,104a23.6,23.6,0,0,1-4.1,13.4h0L104,176h48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sbs)
      ])) : o(i) === "fill" ? (s(), r("g", rbs, lbs)) : o(i) === "light" ? (s(), r("g", dbs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kbs),
        e("path", {
          d: "M105.9,94.7A24,24,0,0,1,152,104a23.6,23.6,0,0,1-4.1,13.4h0L104,176h48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cbs)
      ])) : o(i) === "thin" ? (s(), r("g", hbs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ubs),
        e("path", {
          d: "M105.9,94.7A24,24,0,0,1,152,104a23.6,23.6,0,0,1-4.1,13.4h0L104,176h48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, abs)
      ])) : o(i) === "regular" ? (s(), r("g", _bs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, pbs),
        e("path", {
          d: "M105.9,94.7A24,24,0,0,1,152,104a23.6,23.6,0,0,1-4.1,13.4h0L104,176h48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ybs)
      ])) : g("", !0)
    ], 16, JCs));
  }
}), wbs = ["width", "height", "fill", "transform"], fbs = { key: 0 }, gbs = ["stroke"], xbs = ["stroke"], jbs = { key: 1 }, mbs = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), Mbs = ["stroke"], vbs = ["stroke"], Sbs = { key: 2 }, Hbs = /* @__PURE__ */ e("ellipse", {
  cx: "128",
  cy: "128",
  rx: "24",
  ry: "40"
}, null, -1), Abs = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm0,160c-27.6,0-40-28.1-40-56s12.4-56,40-56,40,28.1,40,56S155.6,184,128,184Z" }, null, -1), Vbs = [
  Hbs,
  Abs
], zbs = { key: 3 }, Zbs = ["stroke"], Cbs = ["stroke"], bbs = { key: 4 }, Lbs = ["stroke"], Bbs = ["stroke"], Pbs = { key: 5 }, Wbs = ["stroke"], Nbs = ["stroke"], Fbs = {
  name: "PhNumberCircleZero"
}, JJ1 = /* @__PURE__ */ $({
  ...Fbs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", fbs, [
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "32",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gbs),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xbs)
      ])) : o(i) === "duotone" ? (s(), r("g", jbs, [
        mbs,
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "32",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mbs),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, vbs)
      ])) : o(i) === "fill" ? (s(), r("g", Sbs, Vbs)) : o(i) === "light" ? (s(), r("g", zbs, [
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "32",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zbs),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cbs)
      ])) : o(i) === "thin" ? (s(), r("g", bbs, [
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "32",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lbs),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bbs)
      ])) : o(i) === "regular" ? (s(), r("g", Pbs, [
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "32",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wbs),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Nbs)
      ])) : g("", !0)
    ], 16, wbs));
  }
}), Tbs = ["width", "height", "fill", "transform"], Dbs = { key: 0 }, Rbs = ["stroke"], Ubs = ["stroke"], qbs = { key: 1 }, Gbs = ["stroke"], Ebs = ["stroke"], Obs = { key: 2 }, Ibs = /* @__PURE__ */ e("path", { d: "M175.9,130a68.8,68.8,0,0,0-16.4-11.4,59.4,59.4,0,0,0,9.9-7.4,53.6,53.6,0,0,0,0-79.1,61.3,61.3,0,0,0-82.8,0,53.6,53.6,0,0,0,0,79.1,59.4,59.4,0,0,0,9.9,7.4A68.8,68.8,0,0,0,80.1,130a61.9,61.9,0,0,0,0,91.3,70.7,70.7,0,0,0,95.8,0,61.9,61.9,0,0,0,0-91.3ZM97.6,99.5a37.5,37.5,0,0,1,0-55.7,45.1,45.1,0,0,1,60.8,0,37.5,37.5,0,0,1,0,55.7,45.1,45.1,0,0,1-60.8,0ZM165,209.7a55,55,0,0,1-74,0,46,46,0,0,1,0-68,54.7,54.7,0,0,1,74,0,46,46,0,0,1,0,68Z" }, null, -1), Kbs = [
  Ibs
], Xbs = { key: 3 }, Jbs = ["stroke"], Qbs = ["stroke"], Ybs = { key: 4 }, oLs = ["stroke"], eLs = ["stroke"], tLs = { key: 5 }, nLs = ["stroke"], sLs = ["stroke"], rLs = {
  name: "PhNumberEight"
}, QJ1 = /* @__PURE__ */ $({
  ...rLs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Dbs, [
        e("path", {
          d: "M178.8,71.7a46.3,46.3,0,0,1-14.9,33.7,53.3,53.3,0,0,1-71.8,0,45.6,45.6,0,0,1,0-67.4,53,53,0,0,1,71.8,0A46,46,0,0,1,178.8,71.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rbs),
        e("path", {
          d: "M188,175.7a54.4,54.4,0,0,1-17.6,39.8,62.7,62.7,0,0,1-84.8,0,53.9,53.9,0,0,1,0-79.7,62.7,62.7,0,0,1,84.8,0A54.4,54.4,0,0,1,188,175.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ubs)
      ])) : o(i) === "duotone" ? (s(), r("g", qbs, [
        e("path", {
          d: "M178.8,71.7a46.3,46.3,0,0,1-14.9,33.7,53.3,53.3,0,0,1-71.8,0,45.6,45.6,0,0,1,0-67.4,53,53,0,0,1,71.8,0A46,46,0,0,1,178.8,71.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gbs),
        e("path", {
          d: "M188,175.7a54.4,54.4,0,0,1-17.6,39.8,62.7,62.7,0,0,1-84.8,0,53.9,53.9,0,0,1,0-79.7,62.7,62.7,0,0,1,84.8,0A54.4,54.4,0,0,1,188,175.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ebs)
      ])) : o(i) === "fill" ? (s(), r("g", Obs, Kbs)) : o(i) === "light" ? (s(), r("g", Xbs, [
        e("path", {
          d: "M178.8,71.7a46.3,46.3,0,0,1-14.9,33.7,53.3,53.3,0,0,1-71.8,0,45.6,45.6,0,0,1,0-67.4,53,53,0,0,1,71.8,0A46,46,0,0,1,178.8,71.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jbs),
        e("path", {
          d: "M188,175.7a54.4,54.4,0,0,1-17.6,39.8,62.7,62.7,0,0,1-84.8,0,53.9,53.9,0,0,1,0-79.7,62.7,62.7,0,0,1,84.8,0A54.4,54.4,0,0,1,188,175.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qbs)
      ])) : o(i) === "thin" ? (s(), r("g", Ybs, [
        e("path", {
          d: "M178.8,71.7a46.3,46.3,0,0,1-14.9,33.7,53.3,53.3,0,0,1-71.8,0,45.6,45.6,0,0,1,0-67.4,53,53,0,0,1,71.8,0A46,46,0,0,1,178.8,71.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oLs),
        e("path", {
          d: "M188,175.7a54.4,54.4,0,0,1-17.6,39.8,62.7,62.7,0,0,1-84.8,0,53.9,53.9,0,0,1,0-79.7,62.7,62.7,0,0,1,84.8,0A54.4,54.4,0,0,1,188,175.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eLs)
      ])) : o(i) === "regular" ? (s(), r("g", tLs, [
        e("path", {
          d: "M178.8,71.7a46.3,46.3,0,0,1-14.9,33.7,53.3,53.3,0,0,1-71.8,0,45.6,45.6,0,0,1,0-67.4,53,53,0,0,1,71.8,0A46,46,0,0,1,178.8,71.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nLs),
        e("path", {
          d: "M188,175.7a54.4,54.4,0,0,1-17.6,39.8,62.7,62.7,0,0,1-84.8,0,53.9,53.9,0,0,1,0-79.7,62.7,62.7,0,0,1,84.8,0A54.4,54.4,0,0,1,188,175.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sLs)
      ])) : g("", !0)
    ], 16, Tbs));
  }
}), iLs = ["width", "height", "fill", "transform"], lLs = { key: 0 }, dLs = ["stroke"], kLs = { key: 1 }, cLs = ["stroke"], hLs = { key: 2 }, uLs = /* @__PURE__ */ e("path", { d: "M165.2,122.7a64,64,0,0,1,0,90.6,64.5,64.5,0,0,1-90.8,0,8,8,0,1,1,11.2-11.4,48.4,48.4,0,0,0,68.3,0A48,48,0,0,0,119.8,120a48.3,48.3,0,0,0-34.2,14.1,8,8,0,0,1-13.5-7L87.8,30.7A7.9,7.9,0,0,1,95.7,24H176a8,8,0,0,1,0,16H102.5L91,110.8a63,63,0,0,1,28.8-6.8A64.4,64.4,0,0,1,165.2,122.7Z" }, null, -1), aLs = [
  uLs
], _Ls = { key: 3 }, pLs = ["stroke"], yLs = { key: 4 }, $Ls = ["stroke"], wLs = { key: 5 }, fLs = ["stroke"], gLs = {
  name: "PhNumberFive"
}, YJ1 = /* @__PURE__ */ $({
  ...gLs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", lLs, [
        e("path", {
          d: "M176,32H95.7L80,128.4a56.4,56.4,0,0,1,79.5,0,55.8,55.8,0,0,1,0,79.2,56.4,56.4,0,0,1-79.5,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dLs)
      ])) : o(i) === "duotone" ? (s(), r("g", kLs, [
        e("path", {
          d: "M176,32H95.7L80,128.4a56.4,56.4,0,0,1,79.5,0,55.8,55.8,0,0,1,0,79.2,56.4,56.4,0,0,1-79.5,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cLs)
      ])) : o(i) === "fill" ? (s(), r("g", hLs, aLs)) : o(i) === "light" ? (s(), r("g", _Ls, [
        e("path", {
          d: "M176,32H95.7L80,128.4a56.4,56.4,0,0,1,79.5,0,55.8,55.8,0,0,1,0,79.2,56.4,56.4,0,0,1-79.5,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pLs)
      ])) : o(i) === "thin" ? (s(), r("g", yLs, [
        e("path", {
          d: "M176,32H95.7L80,128.4a56.4,56.4,0,0,1,79.5,0,55.8,55.8,0,0,1,0,79.2,56.4,56.4,0,0,1-79.5,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $Ls)
      ])) : o(i) === "regular" ? (s(), r("g", wLs, [
        e("path", {
          d: "M176,32H95.7L80,128.4a56.4,56.4,0,0,1,79.5,0,55.8,55.8,0,0,1,0,79.2,56.4,56.4,0,0,1-79.5,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fLs)
      ])) : g("", !0)
    ], 16, iLs));
  }
}), xLs = ["width", "height", "fill", "transform"], jLs = { key: 0 }, mLs = ["stroke"], MLs = ["stroke"], vLs = { key: 1 }, SLs = ["stroke"], HLs = ["stroke"], ALs = { key: 2 }, VLs = /* @__PURE__ */ e("path", { d: "M180,96V224a8,8,0,0,1-16,0V168H76a8,8,0,0,1-6.5-3.4,7.9,7.9,0,0,1-1-7.3l48-136a8,8,0,0,1,15,5.4L87.3,152H164V96a8,8,0,0,1,16,0Z" }, null, -1), zLs = [
  VLs
], ZLs = { key: 3 }, CLs = ["stroke"], bLs = ["stroke"], LLs = { key: 4 }, BLs = ["stroke"], PLs = ["stroke"], WLs = { key: 5 }, NLs = ["stroke"], FLs = ["stroke"], TLs = {
  name: "PhNumberFour"
}, oQ1 = /* @__PURE__ */ $({
  ...TLs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", jLs, [
        e("polyline", {
          points: "124 24 76 160 172 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mLs),
        e("line", {
          x1: "172",
          y1: "96",
          x2: "172",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MLs)
      ])) : o(i) === "duotone" ? (s(), r("g", vLs, [
        e("polyline", {
          points: "124 24 76 160 172 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SLs),
        e("line", {
          x1: "172",
          y1: "96",
          x2: "172",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HLs)
      ])) : o(i) === "fill" ? (s(), r("g", ALs, zLs)) : o(i) === "light" ? (s(), r("g", ZLs, [
        e("polyline", {
          points: "124 24 76 160 172 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, CLs),
        e("line", {
          x1: "172",
          y1: "96",
          x2: "172",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bLs)
      ])) : o(i) === "thin" ? (s(), r("g", LLs, [
        e("polyline", {
          points: "124 24 76 160 172 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, BLs),
        e("line", {
          x1: "172",
          y1: "96",
          x2: "172",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PLs)
      ])) : o(i) === "regular" ? (s(), r("g", WLs, [
        e("polyline", {
          points: "124 24 76 160 172 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NLs),
        e("line", {
          x1: "172",
          y1: "96",
          x2: "172",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FLs)
      ])) : g("", !0)
    ], 16, xLs));
  }
}), DLs = ["width", "height", "fill", "transform"], RLs = { key: 0 }, ULs = ["stroke"], qLs = ["stroke"], GLs = { key: 1 }, ELs = ["stroke"], OLs = ["stroke"], ILs = { key: 2 }, KLs = /* @__PURE__ */ e("path", { d: "M192,88a64,64,0,1,0-64,64,65.1,65.1,0,0,0,19.4-3l-42.5,70.9a8,8,0,0,0,2.7,11,8.7,8.7,0,0,0,4.1,1.1,8,8,0,0,0,6.9-3.9l64.7-108A63.5,63.5,0,0,0,192,88ZM80,88a48,48,0,1,1,48,48A48,48,0,0,1,80,88Z" }, null, -1), XLs = [
  KLs
], JLs = { key: 3 }, QLs = ["stroke"], YLs = ["stroke"], oBs = { key: 4 }, eBs = ["stroke"], tBs = ["stroke"], nBs = { key: 5 }, sBs = ["stroke"], rBs = ["stroke"], iBs = {
  name: "PhNumberNine"
}, eQ1 = /* @__PURE__ */ $({
  ...iBs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", RLs, [
        e("line", {
          x1: "176.5",
          y1: "116",
          x2: "111.7",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ULs),
        e("circle", {
          cx: "128",
          cy: "88",
          r: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qLs)
      ])) : o(i) === "duotone" ? (s(), r("g", GLs, [
        e("line", {
          x1: "176.5",
          y1: "116",
          x2: "111.7",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ELs),
        e("circle", {
          cx: "128",
          cy: "88",
          r: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OLs)
      ])) : o(i) === "fill" ? (s(), r("g", ILs, XLs)) : o(i) === "light" ? (s(), r("g", JLs, [
        e("line", {
          x1: "176.5",
          y1: "116",
          x2: "111.7",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QLs),
        e("circle", {
          cx: "128",
          cy: "88",
          r: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YLs)
      ])) : o(i) === "thin" ? (s(), r("g", oBs, [
        e("line", {
          x1: "176.5",
          y1: "116",
          x2: "111.7",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eBs),
        e("circle", {
          cx: "128",
          cy: "88",
          r: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tBs)
      ])) : o(i) === "regular" ? (s(), r("g", nBs, [
        e("line", {
          x1: "176.5",
          y1: "116",
          x2: "111.8",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sBs),
        e("circle", {
          cx: "128",
          cy: "88",
          r: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rBs)
      ])) : g("", !0)
    ], 16, DLs));
  }
}), lBs = ["width", "height", "fill", "transform"], dBs = { key: 0 }, kBs = ["stroke"], cBs = { key: 1 }, hBs = ["stroke"], uBs = { key: 2 }, aBs = /* @__PURE__ */ e("path", { d: "M132,232a8,8,0,0,1-8-8V47L88.4,70.6a8,8,0,0,1-11.1-2.2,8.1,8.1,0,0,1,2.3-11.1l48-32a8.3,8.3,0,0,1,8.2-.4A8,8,0,0,1,140,32V224A8,8,0,0,1,132,232Z" }, null, -1), _Bs = [
  aBs
], pBs = { key: 3 }, yBs = ["stroke"], $Bs = { key: 4 }, wBs = ["stroke"], fBs = { key: 5 }, gBs = ["stroke"], xBs = {
  name: "PhNumberOne"
}, tQ1 = /* @__PURE__ */ $({
  ...xBs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", dBs, [
        e("polyline", {
          points: "84 64 132 32 132 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kBs)
      ])) : o(i) === "duotone" ? (s(), r("g", cBs, [
        e("polyline", {
          points: "84 64 132 32 132 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hBs)
      ])) : o(i) === "fill" ? (s(), r("g", uBs, _Bs)) : o(i) === "light" ? (s(), r("g", pBs, [
        e("polyline", {
          points: "84 64 132 32 132 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yBs)
      ])) : o(i) === "thin" ? (s(), r("g", $Bs, [
        e("polyline", {
          points: "84 64 132 32 132 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wBs)
      ])) : o(i) === "regular" ? (s(), r("g", fBs, [
        e("polyline", {
          points: "84 64 132 32 132 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gBs)
      ])) : g("", !0)
    ], 16, lBs));
  }
}), jBs = ["width", "height", "fill", "transform"], mBs = { key: 0 }, MBs = ["stroke"], vBs = { key: 1 }, SBs = ["stroke"], HBs = { key: 2 }, ABs = /* @__PURE__ */ e("path", { d: "M112,240a7.3,7.3,0,0,1-2.5-.4,8,8,0,0,1-5.1-10.1L164.9,48H80a8,8,0,0,1,0-16h96a7.9,7.9,0,0,1,6.5,3.3,8.1,8.1,0,0,1,1.1,7.2l-64,192A7.9,7.9,0,0,1,112,240Z" }, null, -1), VBs = [
  ABs
], zBs = { key: 3 }, ZBs = ["stroke"], CBs = { key: 4 }, bBs = ["stroke"], LBs = { key: 5 }, BBs = ["stroke"], PBs = {
  name: "PhNumberSeven"
}, nQ1 = /* @__PURE__ */ $({
  ...PBs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", mBs, [
        e("polyline", {
          points: "80 40 176 40 112 232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MBs)
      ])) : o(i) === "duotone" ? (s(), r("g", vBs, [
        e("polyline", {
          points: "80 40 176 40 112 232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SBs)
      ])) : o(i) === "fill" ? (s(), r("g", HBs, VBs)) : o(i) === "light" ? (s(), r("g", zBs, [
        e("polyline", {
          points: "80 40 176 40 112 232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZBs)
      ])) : o(i) === "thin" ? (s(), r("g", CBs, [
        e("polyline", {
          points: "80 40 176 40 112 232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bBs)
      ])) : o(i) === "regular" ? (s(), r("g", LBs, [
        e("polyline", {
          points: "80 40 176 40 112 232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BBs)
      ])) : g("", !0)
    ], 16, jBs));
  }
}), WBs = ["width", "height", "fill", "transform"], NBs = { key: 0 }, FBs = ["stroke"], TBs = ["stroke"], DBs = { key: 1 }, RBs = ["stroke"], UBs = ["stroke"], qBs = { key: 2 }, GBs = /* @__PURE__ */ e("path", { d: "M128,104a66.3,66.3,0,0,0-19.5,3l42.4-70.9a8,8,0,0,0-13.8-8.2l-64.5,108-.2.5A63,63,0,0,0,64,168a64,64,0,1,0,64-64Zm0,112a48.1,48.1,0,0,1-41.2-72.7l.2-.3a48,48,0,1,1,41,73Z" }, null, -1), EBs = [
  GBs
], OBs = { key: 3 }, IBs = ["stroke"], KBs = ["stroke"], XBs = { key: 4 }, JBs = ["stroke"], QBs = ["stroke"], YBs = { key: 5 }, oPs = ["stroke"], ePs = ["stroke"], tPs = {
  name: "PhNumberSix"
}, sQ1 = /* @__PURE__ */ $({
  ...tPs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", NBs, [
        e("line", {
          x1: "79.5",
          y1: "140",
          x2: "144",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FBs),
        e("circle", {
          cx: "128",
          cy: "168",
          r: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TBs)
      ])) : o(i) === "duotone" ? (s(), r("g", DBs, [
        e("line", {
          x1: "79.5",
          y1: "140",
          x2: "144",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RBs),
        e("circle", {
          cx: "128",
          cy: "168",
          r: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UBs)
      ])) : o(i) === "fill" ? (s(), r("g", qBs, EBs)) : o(i) === "light" ? (s(), r("g", OBs, [
        e("line", {
          x1: "79.5",
          y1: "140",
          x2: "144",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IBs),
        e("circle", {
          cx: "128",
          cy: "168",
          r: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KBs)
      ])) : o(i) === "thin" ? (s(), r("g", XBs, [
        e("line", {
          x1: "79.5",
          y1: "140",
          x2: "144",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, JBs),
        e("circle", {
          cx: "128",
          cy: "168",
          r: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QBs)
      ])) : o(i) === "regular" ? (s(), r("g", YBs, [
        e("line", {
          x1: "79.5",
          y1: "140",
          x2: "144",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oPs),
        e("circle", {
          cx: "128",
          cy: "168",
          r: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ePs)
      ])) : g("", !0)
    ], 16, WBs));
  }
}), nPs = ["width", "height", "fill", "transform"], sPs = { key: 0 }, rPs = ["stroke"], iPs = ["stroke"], lPs = ["stroke"], dPs = { key: 1 }, kPs = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), cPs = ["stroke"], hPs = ["stroke"], uPs = ["stroke"], aPs = { key: 2 }, _Ps = /* @__PURE__ */ e("path", { d: "M137.9,111.9a14,14,0,1,0-19.8,0A14.3,14.3,0,0,0,137.9,111.9Z" }, null, -1), pPs = /* @__PURE__ */ e("path", { d: "M128,132a18,18,0,0,0-12.7,30.7,18.4,18.4,0,0,0,25.4,0A18,18,0,0,0,128,132Z" }, null, -1), yPs = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM152,174a33.9,33.9,0,1,1-48-48,26.6,26.6,0,0,1,3.1-2.6l-.3-.2a29.9,29.9,0,0,1,0-42.4c11.3-11.3,31.1-11.3,42.4,0a29.9,29.9,0,0,1,0,42.4l-.3.2A26.6,26.6,0,0,1,152,126a33.8,33.8,0,0,1,0,48Z" }, null, -1), $Ps = [
  _Ps,
  pPs,
  yPs
], wPs = { key: 3 }, fPs = ["stroke"], gPs = ["stroke"], xPs = ["stroke"], jPs = { key: 4 }, mPs = ["stroke"], MPs = ["stroke"], vPs = ["stroke"], SPs = { key: 5 }, HPs = ["stroke"], APs = ["stroke"], VPs = ["stroke"], zPs = {
  name: "PhNumberSquareEight"
}, rQ1 = /* @__PURE__ */ $({
  ...zPs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", sPs, [
        e("path", {
          d: "M150,102a21.9,21.9,0,1,1-6.4-15.6A22.3,22.3,0,0,1,150,102Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rPs),
        e("path", {
          d: "M154,150a25.9,25.9,0,1,1-7.6-18.4A25.9,25.9,0,0,1,154,150Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iPs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lPs)
      ])) : o(i) === "duotone" ? (s(), r("g", dPs, [
        kPs,
        e("path", {
          d: "M150,102a21.9,21.9,0,1,1-6.4-15.6A22.3,22.3,0,0,1,150,102Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cPs),
        e("path", {
          d: "M154,150a25.9,25.9,0,1,1-7.6-18.4A25.9,25.9,0,0,1,154,150Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hPs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uPs)
      ])) : o(i) === "fill" ? (s(), r("g", aPs, $Ps)) : o(i) === "light" ? (s(), r("g", wPs, [
        e("path", {
          d: "M150,102a21.9,21.9,0,1,1-6.4-15.6A22.3,22.3,0,0,1,150,102Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fPs),
        e("path", {
          d: "M154,150a25.9,25.9,0,1,1-7.6-18.4A25.9,25.9,0,0,1,154,150Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gPs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xPs)
      ])) : o(i) === "thin" ? (s(), r("g", jPs, [
        e("path", {
          d: "M150,102a21.9,21.9,0,1,1-6.4-15.6A22.3,22.3,0,0,1,150,102Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mPs),
        e("path", {
          d: "M154,150a25.9,25.9,0,1,1-7.6-18.4A25.9,25.9,0,0,1,154,150Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MPs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vPs)
      ])) : o(i) === "regular" ? (s(), r("g", SPs, [
        e("path", {
          d: "M150,102a21.9,21.9,0,1,1-6.4-15.6A22.3,22.3,0,0,1,150,102Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HPs),
        e("path", {
          d: "M154,150a25.9,25.9,0,1,1-7.6-18.4A25.9,25.9,0,0,1,154,150Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, APs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VPs)
      ])) : g("", !0)
    ], 16, nPs));
  }
}), ZPs = ["width", "height", "fill", "transform"], CPs = { key: 0 }, bPs = ["stroke"], LPs = ["stroke"], BPs = { key: 1 }, PPs = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), WPs = ["stroke"], NPs = ["stroke"], FPs = { key: 2 }, TPs = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm-84.1,80a36,36,0,1,1-25.5,61.5,8,8,0,1,1,11.2-11.4,20.1,20.1,0,0,0,14.3,5.9,19.9,19.9,0,0,0,14.2-5.9,19.8,19.8,0,0,0,0-28.2,19.9,19.9,0,0,0-14.2-5.9,20.1,20.1,0,0,0-14.3,5.9,8,8,0,0,1-13.5-7l7.8-48.2a8,8,0,0,1,7.9-6.7H152a8,8,0,0,1,0,16H118.6l-4.1,25.2A37.3,37.3,0,0,1,123.9,112Z" }, null, -1), DPs = [
  TPs
], RPs = { key: 3 }, UPs = ["stroke"], qPs = ["stroke"], GPs = { key: 4 }, EPs = ["stroke"], OPs = ["stroke"], IPs = { key: 5 }, KPs = ["stroke"], XPs = ["stroke"], JPs = {
  name: "PhNumberSquareFive"
}, iQ1 = /* @__PURE__ */ $({
  ...JPs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", CPs, [
        e("path", {
          d: "M152,80H111.8L104,128.2a28,28,0,1,1,0,39.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bPs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LPs)
      ])) : o(i) === "duotone" ? (s(), r("g", BPs, [
        PPs,
        e("path", {
          d: "M152,80H111.8L104,128.2a28,28,0,1,1,0,39.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WPs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NPs)
      ])) : o(i) === "fill" ? (s(), r("g", FPs, DPs)) : o(i) === "light" ? (s(), r("g", RPs, [
        e("path", {
          d: "M152,80H111.8L104,128.2a28,28,0,1,1,0,39.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UPs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qPs)
      ])) : o(i) === "thin" ? (s(), r("g", GPs, [
        e("path", {
          d: "M152,80H111.8L104,128.2a28,28,0,1,1,0,39.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, EPs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OPs)
      ])) : o(i) === "regular" ? (s(), r("g", IPs, [
        e("path", {
          d: "M152,80H111.8L104,128.2a28,28,0,1,1,0,39.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KPs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XPs)
      ])) : g("", !0)
    ], 16, ZPs));
  }
}), QPs = ["width", "height", "fill", "transform"], YPs = { key: 0 }, oWs = ["stroke"], eWs = ["stroke"], tWs = ["stroke"], nWs = { key: 1 }, sWs = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), rWs = ["stroke"], iWs = ["stroke"], lWs = ["stroke"], dWs = { key: 2 }, kWs = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM156,176a8,8,0,0,1-16,0V152H100a8,8,0,0,1-6.5-3.4,7.9,7.9,0,0,1-1-7.3l24-68a8,8,0,0,1,15,5.4L111.3,136H140V112a8,8,0,0,1,16,0Z" }, null, -1), cWs = [
  kWs
], hWs = { key: 3 }, uWs = ["stroke"], aWs = ["stroke"], _Ws = ["stroke"], pWs = { key: 4 }, yWs = ["stroke"], $Ws = ["stroke"], wWs = ["stroke"], fWs = { key: 5 }, gWs = ["stroke"], xWs = ["stroke"], jWs = ["stroke"], mWs = {
  name: "PhNumberSquareFour"
}, lQ1 = /* @__PURE__ */ $({
  ...mWs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", YPs, [
        e("polyline", {
          points: "124 76 100 144 148 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oWs),
        e("line", {
          x1: "148",
          y1: "112",
          x2: "148",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eWs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tWs)
      ])) : o(i) === "duotone" ? (s(), r("g", nWs, [
        sWs,
        e("polyline", {
          points: "124 76 100 144 148 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rWs),
        e("line", {
          x1: "148",
          y1: "112",
          x2: "148",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iWs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lWs)
      ])) : o(i) === "fill" ? (s(), r("g", dWs, cWs)) : o(i) === "light" ? (s(), r("g", hWs, [
        e("polyline", {
          points: "124 76 100 144 148 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uWs),
        e("line", {
          x1: "148",
          y1: "112",
          x2: "148",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aWs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _Ws)
      ])) : o(i) === "thin" ? (s(), r("g", pWs, [
        e("polyline", {
          points: "124 76 100 144 148 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yWs),
        e("line", {
          x1: "148",
          y1: "112",
          x2: "148",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $Ws),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wWs)
      ])) : o(i) === "regular" ? (s(), r("g", fWs, [
        e("polyline", {
          points: "124 76 100 144 148 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gWs),
        e("line", {
          x1: "148",
          y1: "112",
          x2: "148",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xWs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jWs)
      ])) : g("", !0)
    ], 16, QPs));
  }
}), MWs = ["width", "height", "fill", "transform"], vWs = { key: 0 }, SWs = ["stroke"], HWs = ["stroke"], AWs = ["stroke"], VWs = { key: 1 }, zWs = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), ZWs = ["stroke"], CWs = ["stroke"], bWs = ["stroke"], LWs = { key: 2 }, BWs = /* @__PURE__ */ e("path", { d: "M148,112a20,20,0,1,1-20-20A20.1,20.1,0,0,1,148,112Zm76-64V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48Zm-60,64a36,36,0,1,0-36,36h1.8l-16.7,27.9a8.1,8.1,0,0,0,2.8,11A8.7,8.7,0,0,0,120,188a8.1,8.1,0,0,0,6.9-3.9l32.2-54,.3-.5A36,36,0,0,0,164,112Z" }, null, -1), PWs = [
  BWs
], WWs = { key: 3 }, NWs = ["stroke"], FWs = ["stroke"], TWs = ["stroke"], DWs = { key: 4 }, RWs = ["stroke"], UWs = ["stroke"], qWs = ["stroke"], GWs = { key: 5 }, EWs = ["stroke"], OWs = ["stroke"], IWs = ["stroke"], KWs = {
  name: "PhNumberSquareNine"
}, dQ1 = /* @__PURE__ */ $({
  ...KWs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", vWs, [
        e("line", {
          x1: "152.2",
          y1: "126",
          x2: "120",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SWs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HWs),
        e("circle", {
          cx: "128",
          cy: "112",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, AWs)
      ])) : o(i) === "duotone" ? (s(), r("g", VWs, [
        zWs,
        e("line", {
          x1: "152.2",
          y1: "126",
          x2: "120",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZWs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CWs),
        e("circle", {
          cx: "128",
          cy: "112",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bWs)
      ])) : o(i) === "fill" ? (s(), r("g", LWs, PWs)) : o(i) === "light" ? (s(), r("g", WWs, [
        e("line", {
          x1: "152.2",
          y1: "126",
          x2: "120",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, NWs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FWs),
        e("circle", {
          cx: "128",
          cy: "112",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TWs)
      ])) : o(i) === "thin" ? (s(), r("g", DWs, [
        e("line", {
          x1: "152.2",
          y1: "126",
          x2: "120",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RWs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, UWs),
        e("circle", {
          cx: "128",
          cy: "112",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qWs)
      ])) : o(i) === "regular" ? (s(), r("g", GWs, [
        e("line", {
          x1: "152.2",
          y1: "126",
          x2: "120",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EWs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OWs),
        e("circle", {
          cx: "128",
          cy: "112",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IWs)
      ])) : g("", !0)
    ], 16, MWs));
  }
}), XWs = ["width", "height", "fill", "transform"], JWs = { key: 0 }, QWs = ["stroke"], YWs = ["stroke"], oNs = { key: 1 }, eNs = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), tNs = ["stroke"], nNs = ["stroke"], sNs = { key: 2 }, rNs = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM140,176a8,8,0,0,1-16,0V99l-11.6,7.6a7.8,7.8,0,0,1-11-2.2,8,8,0,0,1,2.2-11.1l24-16A8,8,0,0,1,140,84Z" }, null, -1), iNs = [
  rNs
], lNs = { key: 3 }, dNs = ["stroke"], kNs = ["stroke"], cNs = { key: 4 }, hNs = ["stroke"], uNs = ["stroke"], aNs = { key: 5 }, _Ns = ["stroke"], pNs = ["stroke"], yNs = {
  name: "PhNumberSquareOne"
}, kQ1 = /* @__PURE__ */ $({
  ...yNs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", JWs, [
        e("polyline", {
          points: "108 100 132 84 132 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, QWs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, YWs)
      ])) : o(i) === "duotone" ? (s(), r("g", oNs, [
        eNs,
        e("polyline", {
          points: "108 100 132 84 132 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tNs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nNs)
      ])) : o(i) === "fill" ? (s(), r("g", sNs, iNs)) : o(i) === "light" ? (s(), r("g", lNs, [
        e("polyline", {
          points: "108 100 132 84 132 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dNs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kNs)
      ])) : o(i) === "thin" ? (s(), r("g", cNs, [
        e("polyline", {
          points: "108 100 132 84 132 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hNs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uNs)
      ])) : o(i) === "regular" ? (s(), r("g", aNs, [
        e("polyline", {
          points: "108 100 132 84 132 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Ns),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pNs)
      ])) : g("", !0)
    ], 16, XWs));
  }
}), $Ns = ["width", "height", "fill", "transform"], wNs = { key: 0 }, fNs = ["stroke"], gNs = ["stroke"], xNs = { key: 1 }, jNs = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), mNs = ["stroke"], MNs = ["stroke"], vNs = { key: 2 }, SNs = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM159.6,86.5l-32,96A7.9,7.9,0,0,1,120,188a7.3,7.3,0,0,1-2.5-.4,8,8,0,0,1-5.1-10.1L140.9,92H104a8,8,0,0,1,0-16h48a7.9,7.9,0,0,1,6.5,3.3A8.1,8.1,0,0,1,159.6,86.5Z" }, null, -1), HNs = [
  SNs
], ANs = { key: 3 }, VNs = ["stroke"], zNs = ["stroke"], ZNs = { key: 4 }, CNs = ["stroke"], bNs = ["stroke"], LNs = { key: 5 }, BNs = ["stroke"], PNs = ["stroke"], WNs = {
  name: "PhNumberSquareSeven"
}, cQ1 = /* @__PURE__ */ $({
  ...WNs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", wNs, [
        e("polyline", {
          points: "104 84 152 84 120 180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fNs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gNs)
      ])) : o(i) === "duotone" ? (s(), r("g", xNs, [
        jNs,
        e("polyline", {
          points: "104 84 152 84 120 180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mNs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MNs)
      ])) : o(i) === "fill" ? (s(), r("g", vNs, HNs)) : o(i) === "light" ? (s(), r("g", ANs, [
        e("polyline", {
          points: "104 84 152 84 120 180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VNs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zNs)
      ])) : o(i) === "thin" ? (s(), r("g", ZNs, [
        e("polyline", {
          points: "104 84 152 84 120 180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CNs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bNs)
      ])) : o(i) === "regular" ? (s(), r("g", LNs, [
        e("polyline", {
          points: "104 84 152 84 120 180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BNs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PNs)
      ])) : g("", !0)
    ], 16, $Ns));
  }
}), NNs = ["width", "height", "fill", "transform"], FNs = { key: 0 }, TNs = ["stroke"], DNs = ["stroke"], RNs = ["stroke"], UNs = { key: 1 }, qNs = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), GNs = ["stroke"], ENs = ["stroke"], ONs = ["stroke"], INs = { key: 2 }, KNs = /* @__PURE__ */ e("path", { d: "M148,148a20,20,0,1,1-20-20A20.1,20.1,0,0,1,148,148ZM224,48V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM164,148a36,36,0,0,0-36-36h-1.8l16.7-27.9a8,8,0,1,0-13.8-8.2l-32.2,54-.2.3A36,36,0,1,0,164,148Z" }, null, -1), XNs = [
  KNs
], JNs = { key: 3 }, QNs = ["stroke"], YNs = ["stroke"], oFs = ["stroke"], eFs = { key: 4 }, tFs = ["stroke"], nFs = ["stroke"], sFs = ["stroke"], rFs = { key: 5 }, iFs = ["stroke"], lFs = ["stroke"], dFs = ["stroke"], kFs = {
  name: "PhNumberSquareSix"
}, hQ1 = /* @__PURE__ */ $({
  ...kFs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", FNs, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TNs),
        e("line", {
          x1: "103.8",
          y1: "134",
          x2: "136",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DNs),
        e("circle", {
          cx: "128",
          cy: "148",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RNs)
      ])) : o(i) === "duotone" ? (s(), r("g", UNs, [
        qNs,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GNs),
        e("line", {
          x1: "103.8",
          y1: "134",
          x2: "136",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ENs),
        e("circle", {
          cx: "128",
          cy: "148",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ONs)
      ])) : o(i) === "fill" ? (s(), r("g", INs, XNs)) : o(i) === "light" ? (s(), r("g", JNs, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QNs),
        e("line", {
          x1: "103.8",
          y1: "134",
          x2: "136",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YNs),
        e("circle", {
          cx: "128",
          cy: "148",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oFs)
      ])) : o(i) === "thin" ? (s(), r("g", eFs, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tFs),
        e("line", {
          x1: "103.8",
          y1: "134",
          x2: "136",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nFs),
        e("circle", {
          cx: "128",
          cy: "148",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sFs)
      ])) : o(i) === "regular" ? (s(), r("g", rFs, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iFs),
        e("line", {
          x1: "103.8",
          y1: "134",
          x2: "136",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lFs),
        e("circle", {
          cx: "128",
          cy: "148",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dFs)
      ])) : g("", !0)
    ], 16, NNs));
  }
}), cFs = ["width", "height", "fill", "transform"], hFs = { key: 0 }, uFs = ["stroke"], aFs = ["stroke"], _Fs = { key: 1 }, pFs = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), yFs = ["stroke"], $Fs = ["stroke"], wFs = { key: 2 }, fFs = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM149.5,177.5a36.2,36.2,0,0,1-51,0,8.1,8.1,0,0,1,11.4-11.4A19.9,19.9,0,1,0,124,132a8.1,8.1,0,0,1-7.1-4.3,8,8,0,0,1,.5-8.3L136.6,92H104a8,8,0,0,1,0-16h48a8.1,8.1,0,0,1,7.1,4.3,7.8,7.8,0,0,1-.6,8.3l-21,30a37.9,37.9,0,0,1,12,7.9,36.2,36.2,0,0,1,0,51Z" }, null, -1), gFs = [
  fFs
], xFs = { key: 3 }, jFs = ["stroke"], mFs = ["stroke"], MFs = { key: 4 }, vFs = ["stroke"], SFs = ["stroke"], HFs = { key: 5 }, AFs = ["stroke"], VFs = ["stroke"], zFs = {
  name: "PhNumberSquareThree"
}, uQ1 = /* @__PURE__ */ $({
  ...zFs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", hFs, [
        e("path", {
          d: "M104,84h48l-28,40a28,28,0,1,1-19.8,47.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uFs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aFs)
      ])) : o(i) === "duotone" ? (s(), r("g", _Fs, [
        pFs,
        e("path", {
          d: "M104,84h48l-28,40a28,28,0,1,1-19.8,47.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yFs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Fs)
      ])) : o(i) === "fill" ? (s(), r("g", wFs, gFs)) : o(i) === "light" ? (s(), r("g", xFs, [
        e("path", {
          d: "M104,84h48l-28,40a28,28,0,1,1-19.8,47.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jFs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mFs)
      ])) : o(i) === "thin" ? (s(), r("g", MFs, [
        e("path", {
          d: "M104,84h48l-28,40a28,28,0,1,1-19.8,47.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vFs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SFs)
      ])) : o(i) === "regular" ? (s(), r("g", HFs, [
        e("path", {
          d: "M104,84h48l-28,40a28,28,0,1,1-19.8,47.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AFs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VFs)
      ])) : g("", !0)
    ], 16, cFs));
  }
}), ZFs = ["width", "height", "fill", "transform"], CFs = { key: 0 }, bFs = ["stroke"], LFs = ["stroke"], BFs = { key: 1 }, PFs = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), WFs = ["stroke"], NFs = ["stroke"], FFs = { key: 2 }, TFs = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM152,168a8,8,0,0,1,0,16H104a7.3,7.3,0,0,1-2.5-.4A8,8,0,0,1,96,176a7.5,7.5,0,0,1,1.7-4.9l43.7-58.3A16,16,0,0,0,128,88a15.9,15.9,0,0,0-14.7,9.8,8.1,8.1,0,0,1-10.5,4.2,8,8,0,0,1-4.3-10.5,32,32,0,1,1,56,30.4l-.2.3L120,168Z" }, null, -1), DFs = [
  TFs
], RFs = { key: 3 }, UFs = ["stroke"], qFs = ["stroke"], GFs = { key: 4 }, EFs = ["stroke"], OFs = ["stroke"], IFs = { key: 5 }, KFs = ["stroke"], XFs = ["stroke"], JFs = {
  name: "PhNumberSquareTwo"
}, aQ1 = /* @__PURE__ */ $({
  ...JFs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", CFs, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bFs),
        e("path", {
          d: "M105.9,94.7A24,24,0,0,1,152,104a23.6,23.6,0,0,1-4.1,13.4h0L104,176h48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LFs)
      ])) : o(i) === "duotone" ? (s(), r("g", BFs, [
        PFs,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WFs),
        e("path", {
          d: "M105.9,94.7A24,24,0,0,1,152,104a23.6,23.6,0,0,1-4.1,13.4h0L104,176h48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NFs)
      ])) : o(i) === "fill" ? (s(), r("g", FFs, DFs)) : o(i) === "light" ? (s(), r("g", RFs, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UFs),
        e("path", {
          d: "M105.9,94.7A24,24,0,0,1,152,104a23.6,23.6,0,0,1-4.1,13.4h0L104,176h48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qFs)
      ])) : o(i) === "thin" ? (s(), r("g", GFs, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, EFs),
        e("path", {
          d: "M105.9,94.7A24,24,0,0,1,152,104a23.6,23.6,0,0,1-4.1,13.4h0L104,176h48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OFs)
      ])) : o(i) === "regular" ? (s(), r("g", IFs, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KFs),
        e("path", {
          d: "M105.9,94.7A24,24,0,0,1,152,104a23.6,23.6,0,0,1-4.1,13.4h0L104,176h48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XFs)
      ])) : g("", !0)
    ], 16, ZFs));
  }
}), QFs = ["width", "height", "fill", "transform"], YFs = { key: 0 }, oTs = ["stroke"], eTs = ["stroke"], tTs = { key: 1 }, nTs = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), sTs = ["stroke"], rTs = ["stroke"], iTs = { key: 2 }, lTs = /* @__PURE__ */ e("ellipse", {
  cx: "128",
  cy: "128",
  rx: "24",
  ry: "40"
}, null, -1), dTs = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM128,184c-27.6,0-40-28.1-40-56s12.4-56,40-56,40,28.1,40,56S155.6,184,128,184Z" }, null, -1), kTs = [
  lTs,
  dTs
], cTs = { key: 3 }, hTs = ["stroke"], uTs = ["stroke"], aTs = { key: 4 }, _Ts = ["stroke"], pTs = ["stroke"], yTs = { key: 5 }, $Ts = ["stroke"], wTs = ["stroke"], fTs = {
  name: "PhNumberSquareZero"
}, _Q1 = /* @__PURE__ */ $({
  ...fTs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", YFs, [
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "32",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oTs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eTs)
      ])) : o(i) === "duotone" ? (s(), r("g", tTs, [
        nTs,
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "32",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sTs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rTs)
      ])) : o(i) === "fill" ? (s(), r("g", iTs, kTs)) : o(i) === "light" ? (s(), r("g", cTs, [
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "32",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hTs),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uTs)
      ])) : o(i) === "thin" ? (s(), r("g", aTs, [
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "32",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _Ts),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pTs)
      ])) : o(i) === "regular" ? (s(), r("g", yTs, [
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "32",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Ts),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wTs)
      ])) : g("", !0)
    ], 16, QFs));
  }
}), gTs = ["width", "height", "fill", "transform"], xTs = { key: 0 }, jTs = ["stroke"], mTs = { key: 1 }, MTs = ["stroke"], vTs = { key: 2 }, STs = /* @__PURE__ */ e("path", { d: "M184,168A64,64,0,0,1,74.8,213.3a8,8,0,0,1,11.3-11.4A47.9,47.9,0,1,0,120,120a8.1,8.1,0,0,1-7.1-4.3,7.8,7.8,0,0,1,.6-8.3L160.6,40H80a8,8,0,0,1,0-16h96a8.1,8.1,0,0,1,7.1,4.3,7.8,7.8,0,0,1-.6,8.3l-48.2,69A64.1,64.1,0,0,1,184,168Z" }, null, -1), HTs = [
  STs
], ATs = { key: 3 }, VTs = ["stroke"], zTs = { key: 4 }, ZTs = ["stroke"], CTs = { key: 5 }, bTs = ["stroke"], LTs = {
  name: "PhNumberThree"
}, pQ1 = /* @__PURE__ */ $({
  ...LTs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xTs, [
        e("path", {
          d: "M80,32h96l-56,80a56,56,0,1,1-39.6,95.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jTs)
      ])) : o(i) === "duotone" ? (s(), r("g", mTs, [
        e("path", {
          d: "M80,32h96l-56,80a56,56,0,1,1-39.6,95.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MTs)
      ])) : o(i) === "fill" ? (s(), r("g", vTs, HTs)) : o(i) === "light" ? (s(), r("g", ATs, [
        e("path", {
          d: "M80,32h96l-56,80a56,56,0,1,1-39.6,95.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VTs)
      ])) : o(i) === "thin" ? (s(), r("g", zTs, [
        e("path", {
          d: "M80,32h96l-56,80a56,56,0,1,1-39.6,95.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZTs)
      ])) : o(i) === "regular" ? (s(), r("g", CTs, [
        e("path", {
          d: "M80,32h96l-56,80a56,56,0,1,1-39.6,95.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bTs)
      ])) : g("", !0)
    ], 16, gTs));
  }
}), BTs = ["width", "height", "fill", "transform"], PTs = { key: 0 }, WTs = ["stroke"], NTs = { key: 1 }, FTs = ["stroke"], TTs = { key: 2 }, DTs = /* @__PURE__ */ e("path", { d: "M184,224a8,8,0,0,1-8,8H80a7.3,7.3,0,0,1-2.5-.4A8,8,0,0,1,72,224a8,8,0,0,1,1.7-5l87.6-116.8A40,40,0,1,0,91.1,64.4a8,8,0,1,1-14.7-6.2,56,56,0,1,1,98,53.1c0,.1-.1.2-.2.3L96,216h80A8,8,0,0,1,184,224Z" }, null, -1), RTs = [
  DTs
], UTs = { key: 3 }, qTs = ["stroke"], GTs = { key: 4 }, ETs = ["stroke"], OTs = { key: 5 }, ITs = ["stroke"], KTs = {
  name: "PhNumberTwo"
}, yQ1 = /* @__PURE__ */ $({
  ...KTs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", PTs, [
        e("path", {
          d: "M83.8,61.3A48,48,0,0,1,176,80a47.4,47.4,0,0,1-8.2,26.8h0L80,224h96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WTs)
      ])) : o(i) === "duotone" ? (s(), r("g", NTs, [
        e("path", {
          d: "M83.8,61.3A48,48,0,0,1,176,80a47.4,47.4,0,0,1-8.2,26.8h0L80,224h96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FTs)
      ])) : o(i) === "fill" ? (s(), r("g", TTs, RTs)) : o(i) === "light" ? (s(), r("g", UTs, [
        e("path", {
          d: "M83.8,61.3A48,48,0,0,1,176,80a47.4,47.4,0,0,1-8.2,26.8h0L80,224h96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qTs)
      ])) : o(i) === "thin" ? (s(), r("g", GTs, [
        e("path", {
          d: "M83.8,61.3A48,48,0,0,1,176,80a47.4,47.4,0,0,1-8.2,26.8h0L80,224h96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ETs)
      ])) : o(i) === "regular" ? (s(), r("g", OTs, [
        e("path", {
          d: "M83.8,61.3A48,48,0,0,1,176,80a47.4,47.4,0,0,1-8.2,26.8h0L80,224h96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ITs)
      ])) : g("", !0)
    ], 16, BTs));
  }
}), XTs = ["width", "height", "fill", "transform"], JTs = { key: 0 }, QTs = ["stroke"], YTs = { key: 1 }, oDs = ["stroke"], eDs = { key: 2 }, tDs = /* @__PURE__ */ e("path", { d: "M128,240c-25.8,0-47-12.6-61.4-36.4C54.6,183.8,48,157,48,128s6.6-55.9,18.6-75.6C81,28.6,102.2,16,128,16s47,12.6,61.4,36.4C201.4,72.1,208,99,208,128s-6.6,55.8-18.6,75.6C175,227.4,153.8,240,128,240Zm0-208c-44.2,0-64,48.2-64,96s19.8,96,64,96,64-48.2,64-96S172.2,32,128,32Z" }, null, -1), nDs = [
  tDs
], sDs = { key: 3 }, rDs = ["stroke"], iDs = { key: 4 }, lDs = ["stroke"], dDs = { key: 5 }, kDs = ["stroke"], cDs = {
  name: "PhNumberZero"
}, $Q1 = /* @__PURE__ */ $({
  ...cDs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", JTs, [
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "72",
          ry: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, QTs)
      ])) : o(i) === "duotone" ? (s(), r("g", YTs, [
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "72",
          ry: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oDs)
      ])) : o(i) === "fill" ? (s(), r("g", eDs, nDs)) : o(i) === "light" ? (s(), r("g", sDs, [
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "72",
          ry: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rDs)
      ])) : o(i) === "thin" ? (s(), r("g", iDs, [
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "72",
          ry: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lDs)
      ])) : o(i) === "regular" ? (s(), r("g", dDs, [
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "72",
          ry: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kDs)
      ])) : g("", !0)
    ], 16, XTs));
  }
}), hDs = ["width", "height", "fill", "transform"], uDs = { key: 0 }, aDs = ["stroke"], _Ds = ["stroke"], pDs = { key: 1 }, yDs = /* @__PURE__ */ e("path", {
  d: "M215.9,73.7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5a8.1,8.1,0,0,0,4.1-7V80.7A8.1,8.1,0,0,0,215.9,73.7ZM128,164a36,36,0,1,1,36-36A36,36,0,0,1,128,164Z",
  opacity: "0.2"
}, null, -1), $Ds = ["stroke"], wDs = ["stroke"], fDs = { key: 2 }, gDs = /* @__PURE__ */ e("path", { d: "M219.9,66.7l-84-47.4a15.9,15.9,0,0,0-15.8,0l-84,47.4a16.2,16.2,0,0,0-8.1,14v94.6a16.2,16.2,0,0,0,8.1,14l84,47.4a15.9,15.9,0,0,0,15.8,0l84-47.4a16.2,16.2,0,0,0,8.1-14V80.7A16.2,16.2,0,0,0,219.9,66.7ZM128,164a36,36,0,1,1,36-36A36,36,0,0,1,128,164Z" }, null, -1), xDs = [
  gDs
], jDs = { key: 3 }, mDs = ["stroke"], MDs = ["stroke"], vDs = { key: 4 }, SDs = ["stroke"], HDs = ["stroke"], ADs = { key: 5 }, VDs = ["stroke"], zDs = ["stroke"], ZDs = {
  name: "PhNut"
}, wQ1 = /* @__PURE__ */ $({
  ...ZDs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", uDs, [
        e("path", {
          d: "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aDs),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Ds)
      ])) : o(i) === "duotone" ? (s(), r("g", pDs, [
        yDs,
        e("path", {
          d: "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Ds),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wDs)
      ])) : o(i) === "fill" ? (s(), r("g", fDs, xDs)) : o(i) === "light" ? (s(), r("g", jDs, [
        e("path", {
          d: "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mDs),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, MDs)
      ])) : o(i) === "thin" ? (s(), r("g", vDs, [
        e("path", {
          d: "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SDs),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HDs)
      ])) : o(i) === "regular" ? (s(), r("g", ADs, [
        e("path", {
          d: "M220,175.3V80.7a8.1,8.1,0,0,0-4.1-7l-84-47.5a7.8,7.8,0,0,0-7.8,0l-84,47.5a8.1,8.1,0,0,0-4.1,7v94.6a8.1,8.1,0,0,0,4.1,7l84,47.5a7.8,7.8,0,0,0,7.8,0l84-47.5A8.1,8.1,0,0,0,220,175.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VDs),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zDs)
      ])) : g("", !0)
    ], 16, hDs));
  }
}), CDs = ["width", "height", "fill", "transform"], bDs = { key: 0 }, LDs = /* @__PURE__ */ e("circle", {
  cx: "168",
  cy: "148",
  r: "16"
}, null, -1), BDs = ["stroke"], PDs = ["stroke"], WDs = ["stroke"], NDs = ["stroke"], FDs = { key: 1 }, TDs = /* @__PURE__ */ e("path", {
  d: "M95.9,217.3a79.7,79.7,0,0,0,32,6.7V112l-32,17.1h0v88.2Z",
  opacity: "0.2"
}, null, -1), DDs = /* @__PURE__ */ e("circle", {
  cx: "171.9",
  cy: "148",
  r: "12"
}, null, -1), RDs = ["stroke"], UDs = ["stroke"], qDs = ["stroke"], GDs = ["stroke"], EDs = { key: 2 }, ODs = /* @__PURE__ */ e("path", { d: "M183.9,148a12,12,0,1,1-12-12A12,12,0,0,1,183.9,148Zm29.4,17.3A87.7,87.7,0,0,1,127.9,232a86.7,86.7,0,0,1-34.6-7.1l-1.2-.5a88.4,88.4,0,0,1-51.5-69.3h0a99.9,99.9,0,0,1-.7-11A87.3,87.3,0,0,1,54,96.3,36,36,0,0,1,70,28a8.5,8.5,0,0,1,3.5.8L187.7,83.9A20,20,0,0,0,186,44a8,8,0,0,1,0-16,36,36,0,0,1,0,72,8.5,8.5,0,0,1-3.5-.8L126.3,72A72.1,72.1,0,0,0,56,141.3L92.1,122h0l32.1-17.1a8,8,0,0,1,11.7,7.1V215.5a71.7,71.7,0,0,0,61.9-54.1,8,8,0,0,1,15.5,3.9Zm-93.4-40-16,8.6v78a71.5,71.5,0,0,0,16,3.6ZM64.4,83.2a87.4,87.4,0,0,1,37.1-23.1l-33.2-16a20,20,0,0,0-3.9,39.1ZM87.9,203.8V142.4L57.4,158.7A72.1,72.1,0,0,0,87.9,203.8Z" }, null, -1), IDs = [
  ODs
], KDs = { key: 3 }, XDs = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "148",
  r: "10"
}, null, -1), JDs = ["stroke"], QDs = ["stroke"], YDs = ["stroke"], oRs = ["stroke"], eRs = { key: 4 }, tRs = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "148",
  r: "8"
}, null, -1), nRs = ["stroke"], sRs = ["stroke"], rRs = ["stroke"], iRs = ["stroke"], lRs = { key: 5 }, dRs = /* @__PURE__ */ e("circle", {
  cx: "171.9",
  cy: "148",
  r: "12"
}, null, -1), kRs = ["stroke"], cRs = ["stroke"], hRs = ["stroke"], uRs = ["stroke"], aRs = {
  name: "PhNyTimesLogo"
}, fQ1 = /* @__PURE__ */ $({
  ...aRs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", bDs, [
        LDs,
        e("path", {
          d: "M205.6,163.4A80,80,0,1,1,127.9,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BDs),
        e("path", {
          d: "M67.2,91.9A28,28,0,0,1,70,36L186,92a28,28,0,0,0,0-56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PDs),
        e("polyline", {
          points: "48.6 154.3 127.9 112 127.9 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WDs),
        e("line", {
          x1: "91.9",
          y1: "131.2",
          x2: "91.9",
          y2: "215.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NDs)
      ])) : o(i) === "duotone" ? (s(), r("g", FDs, [
        TDs,
        DDs,
        e("path", {
          d: "M205.6,163.4A80,80,0,1,1,127.9,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RDs),
        e("path", {
          d: "M67.2,91.9A28,28,0,0,1,70,36L186,92a28,28,0,0,0,0-56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UDs),
        e("polyline", {
          points: "48.6 154.3 127.9 112 127.9 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qDs),
        e("line", {
          x1: "95.9",
          y1: "129.1",
          x2: "95.9",
          y2: "217.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GDs)
      ])) : o(i) === "fill" ? (s(), r("g", EDs, IDs)) : o(i) === "light" ? (s(), r("g", KDs, [
        XDs,
        e("path", {
          d: "M205.6,163.4A80,80,0,1,1,127.9,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JDs),
        e("path", {
          d: "M67.2,91.9A28,28,0,0,1,70,36L186,92a28,28,0,0,0,0-56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QDs),
        e("polyline", {
          points: "48.6 154.3 127.9 112 127.9 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YDs),
        e("line", {
          x1: "95.9",
          y1: "129.1",
          x2: "95.9",
          y2: "217.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oRs)
      ])) : o(i) === "thin" ? (s(), r("g", eRs, [
        tRs,
        e("path", {
          d: "M205.6,163.4A80,80,0,1,1,127.9,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nRs),
        e("path", {
          d: "M67.2,91.9A28,28,0,0,1,70,36L186,92a28,28,0,0,0,0-56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sRs),
        e("polyline", {
          points: "48.6 154.3 127.9 112 127.9 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rRs),
        e("line", {
          x1: "95.9",
          y1: "129.1",
          x2: "95.9",
          y2: "217.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iRs)
      ])) : o(i) === "regular" ? (s(), r("g", lRs, [
        dRs,
        e("path", {
          d: "M205.6,163.4A80,80,0,1,1,127.9,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kRs),
        e("path", {
          d: "M67.2,91.9A28,28,0,0,1,70,36L186,92a28,28,0,0,0,0-56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cRs),
        e("polyline", {
          points: "48.6 154.3 127.9 112 127.9 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hRs),
        e("line", {
          x1: "95.9",
          y1: "129.1",
          x2: "95.9",
          y2: "217.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uRs)
      ])) : g("", !0)
    ], 16, CDs));
  }
}), _Rs = ["width", "height", "fill", "transform"], pRs = { key: 0 }, yRs = ["stroke"], $Rs = { key: 1 }, wRs = /* @__PURE__ */ e("path", {
  d: "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
  opacity: "0.2"
}, null, -1), fRs = ["stroke"], gRs = { key: 2 }, xRs = /* @__PURE__ */ e("path", { d: "M227.3,80.2,175.8,28.7A16.1,16.1,0,0,0,164.5,24h-73a16.1,16.1,0,0,0-11.3,4.7L28.7,80.2A16.1,16.1,0,0,0,24,91.5v73a16.1,16.1,0,0,0,4.7,11.3l51.5,51.5A16.1,16.1,0,0,0,91.5,232h73a16.1,16.1,0,0,0,11.3-4.7l51.5-51.5a16.1,16.1,0,0,0,4.7-11.3v-73A16.1,16.1,0,0,0,227.3,80.2Z" }, null, -1), jRs = [
  xRs
], mRs = { key: 3 }, MRs = ["stroke"], vRs = { key: 4 }, SRs = ["stroke"], HRs = { key: 5 }, ARs = ["stroke"], VRs = {
  name: "PhOctagon"
}, gQ1 = /* @__PURE__ */ $({
  ...VRs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", pRs, [
        e("path", {
          d: "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yRs)
      ])) : o(i) === "duotone" ? (s(), r("g", $Rs, [
        wRs,
        e("path", {
          d: "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, fRs)
      ])) : o(i) === "fill" ? (s(), r("g", gRs, jRs)) : o(i) === "light" ? (s(), r("g", mRs, [
        e("path", {
          d: "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, MRs)
      ])) : o(i) === "thin" ? (s(), r("g", vRs, [
        e("path", {
          d: "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SRs)
      ])) : o(i) === "regular" ? (s(), r("g", HRs, [
        e("path", {
          d: "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, ARs)
      ])) : g("", !0)
    ], 16, _Rs));
  }
}), zRs = ["width", "height", "fill", "transform"], ZRs = { key: 0 }, CRs = ["stroke"], bRs = ["stroke"], LRs = { key: 1 }, BRs = ["stroke"], PRs = ["stroke"], WRs = { key: 2 }, NRs = /* @__PURE__ */ e("path", { d: "M232,184a8,8,0,0,1-8,8H161a16.2,16.2,0,0,1-14.4-8.8L95.1,80H32a8,8,0,0,1,0-16H95.1a16,16,0,0,1,14.3,8.8L161,176h63A8,8,0,0,1,232,184ZM152,80h72a8,8,0,0,0,0-16H152a8,8,0,0,0,0,16Z" }, null, -1), FRs = [
  NRs
], TRs = { key: 3 }, DRs = ["stroke"], RRs = ["stroke"], URs = { key: 4 }, qRs = ["stroke"], GRs = ["stroke"], ERs = { key: 5 }, ORs = ["stroke"], IRs = ["stroke"], KRs = {
  name: "PhOption"
}, xQ1 = /* @__PURE__ */ $({
  ...KRs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ZRs, [
        e("path", {
          d: "M32,72H95.1a7.9,7.9,0,0,1,7.1,4.4l51.6,103.2A7.9,7.9,0,0,0,161,184h63",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CRs),
        e("line", {
          x1: "156",
          y1: "72",
          x2: "224",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bRs)
      ])) : o(i) === "duotone" ? (s(), r("g", LRs, [
        e("path", {
          d: "M32,72H95.1a7.9,7.9,0,0,1,7.1,4.4l51.6,103.2A7.9,7.9,0,0,0,161,184h63",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BRs),
        e("line", {
          x1: "152",
          y1: "72",
          x2: "224",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PRs)
      ])) : o(i) === "fill" ? (s(), r("g", WRs, FRs)) : o(i) === "light" ? (s(), r("g", TRs, [
        e("path", {
          d: "M32,72H95.1a7.9,7.9,0,0,1,7.1,4.4l51.6,103.2A7.9,7.9,0,0,0,161,184h63",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DRs),
        e("line", {
          x1: "152",
          y1: "72",
          x2: "224",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RRs)
      ])) : o(i) === "thin" ? (s(), r("g", URs, [
        e("path", {
          d: "M32,72H95.1a7.9,7.9,0,0,1,7.1,4.4l51.6,103.2A7.9,7.9,0,0,0,161,184h63",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qRs),
        e("line", {
          x1: "152",
          y1: "72",
          x2: "224",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GRs)
      ])) : o(i) === "regular" ? (s(), r("g", ERs, [
        e("path", {
          d: "M32,72H95.1a7.9,7.9,0,0,1,7.1,4.4l51.6,103.2A7.9,7.9,0,0,0,161,184h63",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ORs),
        e("line", {
          x1: "152",
          y1: "72",
          x2: "224",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IRs)
      ])) : g("", !0)
    ], 16, zRs));
  }
}), XRs = ["width", "height", "fill", "transform"], JRs = { key: 0 }, QRs = ["stroke"], YRs = ["stroke"], oUs = ["stroke"], eUs = ["stroke"], tUs = { key: 1 }, nUs = /* @__PURE__ */ e("path", {
  d: "M33.1,74.6A8.1,8.1,0,0,0,32,78.7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.6,7.6,0,0,0,3.9,1h0l.9-106.8L33.1,74.6Z",
  opacity: "0.2"
}, null, -1), sUs = ["stroke"], rUs = ["stroke"], iUs = ["stroke"], lUs = ["stroke"], dUs = { key: 2 }, kUs = /* @__PURE__ */ e("path", { d: "M229.9,70.8h0a.1.1,0,0,1-.1-.1,16.2,16.2,0,0,0-6-5.9l-88-49.5a16,16,0,0,0-15.6,0l-88,49.5a16.2,16.2,0,0,0-6,5.9.1.1,0,0,1-.1.1v.2A15,15,0,0,0,24,78.7v98.6a16.1,16.1,0,0,0,8.2,14l88,49.5a16.5,16.5,0,0,0,7.2,2h1.4a15.7,15.7,0,0,0,7-2l88-49.5a16.1,16.1,0,0,0,8.2-14V78.7A15.6,15.6,0,0,0,229.9,70.8ZM128,29.2,207.7,74,177.1,91.4,96.4,46.9Zm.9,89.6L48.4,74,80,56.2l80.8,44.5Zm7.2,103.5.8-89.6L169,114.4v38.1a8,8,0,0,0,16,0V105.3l31-17.6v89.6Z" }, null, -1), cUs = [
  kUs
], hUs = { key: 3 }, uUs = ["stroke"], aUs = ["stroke"], _Us = ["stroke"], pUs = ["stroke"], yUs = { key: 4 }, $Us = ["stroke"], wUs = ["stroke"], fUs = ["stroke"], gUs = ["stroke"], xUs = { key: 5 }, jUs = ["stroke"], mUs = ["stroke"], MUs = ["stroke"], vUs = ["stroke"], SUs = {
  name: "PhPackage"
}, jQ1 = /* @__PURE__ */ $({
  ...SUs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", JRs, [
        e("path", {
          d: "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, QRs),
        e("polyline", {
          points: "177 152.5 177 100.5 80 47",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, YRs),
        e("polyline", {
          points: "222.9 74.6 128.9 128 33.1 74.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oUs),
        e("line", {
          x1: "128.9",
          y1: "128",
          x2: "128",
          y2: "234.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eUs)
      ])) : o(i) === "duotone" ? (s(), r("g", tUs, [
        nUs,
        e("path", {
          d: "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sUs),
        e("polyline", {
          points: "177 152.5 177 100.5 80 47",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rUs),
        e("polyline", {
          points: "222.9 74.6 128.9 128 33.1 74.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iUs),
        e("line", {
          x1: "128.9",
          y1: "128",
          x2: "128",
          y2: "234.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lUs)
      ])) : o(i) === "fill" ? (s(), r("g", dUs, cUs)) : o(i) === "light" ? (s(), r("g", hUs, [
        e("path", {
          d: "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uUs),
        e("polyline", {
          points: "177 152.5 177 100.5 80 47",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aUs),
        e("polyline", {
          points: "222.9 74.6 128.9 128 33.1 74.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _Us),
        e("line", {
          x1: "128.9",
          y1: "128",
          x2: "128",
          y2: "234.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pUs)
      ])) : o(i) === "thin" ? (s(), r("g", yUs, [
        e("path", {
          d: "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $Us),
        e("polyline", {
          points: "177 152.5 177 100.5 80 47",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wUs),
        e("polyline", {
          points: "222.9 74.6 128.9 128 33.1 74.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fUs),
        e("line", {
          x1: "128.9",
          y1: "128",
          x2: "128",
          y2: "234.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gUs)
      ])) : o(i) === "regular" ? (s(), r("g", xUs, [
        e("path", {
          d: "M224,177.3V78.7a8.1,8.1,0,0,0-4.1-7l-88-49.5a7.8,7.8,0,0,0-7.8,0l-88,49.5a8.1,8.1,0,0,0-4.1,7v98.6a8.1,8.1,0,0,0,4.1,7l88,49.5a7.8,7.8,0,0,0,7.8,0l88-49.5A8.1,8.1,0,0,0,224,177.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jUs),
        e("polyline", {
          points: "177 152.5 177 100.5 80 47",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mUs),
        e("polyline", {
          points: "222.9 74.6 128.9 128 33.1 74.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MUs),
        e("line", {
          x1: "128.9",
          y1: "128",
          x2: "128",
          y2: "234.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vUs)
      ])) : g("", !0)
    ], 16, XRs));
  }
}), HUs = ["width", "height", "fill", "transform"], AUs = { key: 0 }, VUs = ["stroke"], zUs = ["stroke"], ZUs = ["stroke"], CUs = { key: 1 }, bUs = /* @__PURE__ */ e("path", {
  d: "M133,90.6A85.4,85.4,0,0,1,165.4,123C192.7,99.1,225,63.9,225,31,192.1,31,156.9,63.3,133,90.6Z",
  opacity: "0.2"
}, null, -1), LUs = ["stroke"], BUs = ["stroke"], PUs = ["stroke"], WUs = { key: 2 }, NUs = /* @__PURE__ */ e("path", { d: "M225,23c-21.3,0-45.3,11.8-71.1,34.9-18.1,16.2-33.6,34.7-44.3,48.7A60.1,60.1,0,0,0,32,164c0,31.2-16.2,45.1-17,45.8a7.7,7.7,0,0,0-2.5,8.8A7.8,7.8,0,0,0,20,224H92a60.1,60.1,0,0,0,57.4-77.6c14-10.7,32.5-26.2,48.7-44.3C221.2,76.3,233,52.3,233,31A8,8,0,0,0,225,23ZM124.4,113.6c2.9-3.7,6.3-7.9,10.2-12.5a75.4,75.4,0,0,1,20.3,20.3c-4.6,3.9-8.8,7.3-12.5,10.2A59.4,59.4,0,0,0,124.4,113.6Zm42.6-2.9A93.1,93.1,0,0,0,145.3,89c19.6-21.2,46-44.4,70.8-49.1C211.4,64.7,188.2,91.1,167,110.7Z" }, null, -1), FUs = [
  NUs
], TUs = { key: 3 }, DUs = ["stroke"], RUs = ["stroke"], UUs = ["stroke"], qUs = { key: 4 }, GUs = ["stroke"], EUs = ["stroke"], OUs = ["stroke"], IUs = { key: 5 }, KUs = ["stroke"], XUs = ["stroke"], JUs = ["stroke"], QUs = {
  name: "PhPaintBrush"
}, mQ1 = /* @__PURE__ */ $({
  ...QUs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", AUs, [
        e("path", {
          d: "M20,216H92a52,52,0,1,0-52-52C40,200,20,216,20,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VUs),
        e("path", {
          d: "M112.4,116.2C131.6,90.3,180.4,31,225,31c0,44.6-59.3,93.4-85.2,112.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zUs),
        e("path", {
          d: "M138.4,84.6a90.8,90.8,0,0,1,33,33",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZUs)
      ])) : o(i) === "duotone" ? (s(), r("g", CUs, [
        bUs,
        e("path", {
          d: "M20,216H92a52,52,0,1,0-52-52C40,200,20,216,20,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LUs),
        e("path", {
          d: "M112.4,116.2C131.6,90.3,180.4,31,225,31c0,44.6-59.3,93.4-85.2,112.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BUs),
        e("path", {
          d: "M133,90.6A85.4,85.4,0,0,1,165.4,123",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PUs)
      ])) : o(i) === "fill" ? (s(), r("g", WUs, FUs)) : o(i) === "light" ? (s(), r("g", TUs, [
        e("path", {
          d: "M20,216H92a52,52,0,1,0-52-52C40,200,20,216,20,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DUs),
        e("path", {
          d: "M112.4,116.2C131.6,90.3,180.4,31,225,31c0,44.6-59.3,93.4-85.2,112.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RUs),
        e("path", {
          d: "M133,90.6A85.4,85.4,0,0,1,165.4,123",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UUs)
      ])) : o(i) === "thin" ? (s(), r("g", qUs, [
        e("path", {
          d: "M20,216H92a52,52,0,1,0-52-52C40,200,20,216,20,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GUs),
        e("path", {
          d: "M112.4,116.2C131.6,90.3,180.4,31,225,31c0,44.6-59.3,93.4-85.2,112.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, EUs),
        e("path", {
          d: "M133,90.6A85.4,85.4,0,0,1,165.4,123",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OUs)
      ])) : o(i) === "regular" ? (s(), r("g", IUs, [
        e("path", {
          d: "M20,216H92a52,52,0,1,0-52-52C40,200,20,216,20,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KUs),
        e("path", {
          d: "M112.4,116.2C131.6,90.3,180.4,31,225,31c0,44.6-59.3,93.4-85.2,112.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XUs),
        e("path", {
          d: "M133,90.6A85.4,85.4,0,0,1,165.4,123",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JUs)
      ])) : g("", !0)
    ], 16, HUs));
  }
}), YUs = ["width", "height", "fill", "transform"], oqs = { key: 0 }, eqs = ["stroke"], tqs = ["stroke"], nqs = ["stroke"], sqs = { key: 1 }, rqs = /* @__PURE__ */ e("path", {
  d: "M40,112H216v24a16,16,0,0,1-16,16H153.2a8,8,0,0,0-7.9,9.1L152,208a24,24,0,0,1-48,0l6.7-46.9a8,8,0,0,0-7.9-9.1H56a16,16,0,0,1-16-16Z",
  opacity: "0.2"
}, null, -1), iqs = ["stroke"], lqs = ["stroke"], dqs = ["stroke"], kqs = { key: 2 }, cqs = /* @__PURE__ */ e("path", { d: "M216,24H72A40,40,0,0,0,32,64v72a24.1,24.1,0,0,0,24,24h46.8l-6.7,46.9A3.7,3.7,0,0,0,96,208a32,32,0,0,0,64,0,3.7,3.7,0,0,0-.1-1.1L153.2,160H200a24.1,24.1,0,0,0,24-24V32A8,8,0,0,0,216,24ZM72,40H176V80a8,8,0,0,0,16,0V40h16v64H48V64A24.1,24.1,0,0,1,72,40Z" }, null, -1), hqs = [
  cqs
], uqs = { key: 3 }, aqs = ["stroke"], _qs = ["stroke"], pqs = ["stroke"], yqs = { key: 4 }, $qs = ["stroke"], wqs = ["stroke"], fqs = ["stroke"], gqs = { key: 5 }, xqs = ["stroke"], jqs = ["stroke"], mqs = ["stroke"], Mqs = {
  name: "PhPaintBrushBroad"
}, MQ1 = /* @__PURE__ */ $({
  ...Mqs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", oqs, [
        e("line", {
          x1: "40",
          y1: "112",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eqs),
        e("line", {
          x1: "176",
          y1: "32",
          x2: "176",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tqs),
        e("path", {
          d: "M156.6,152H200a16,16,0,0,0,16-16V32H72A32,32,0,0,0,40,64v72a16,16,0,0,0,16,16H99.4a8,8,0,0,1,8,8.6L104,208a24,24,0,0,0,48,0l-3.4-47.4A8,8,0,0,1,156.6,152Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nqs)
      ])) : o(i) === "duotone" ? (s(), r("g", sqs, [
        rqs,
        e("line", {
          x1: "40",
          y1: "112",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iqs),
        e("path", {
          d: "M102.8,152H56a16,16,0,0,1-16-16V64A32,32,0,0,1,72,32H216V136a16,16,0,0,1-16,16H153.2a8,8,0,0,0-7.9,9.1L152,208a24,24,0,0,1-48,0l6.7-46.9A8,8,0,0,0,102.8,152Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lqs),
        e("line", {
          x1: "184",
          y1: "32",
          x2: "184",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dqs)
      ])) : o(i) === "fill" ? (s(), r("g", kqs, hqs)) : o(i) === "light" ? (s(), r("g", uqs, [
        e("line", {
          x1: "40",
          y1: "112",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aqs),
        e("path", {
          d: "M102.8,152H56a16,16,0,0,1-16-16V64A32,32,0,0,1,72,32H216V136a16,16,0,0,1-16,16H153.2a8,8,0,0,0-7.9,9.1L152,208a24,24,0,0,1-48,0l6.7-46.9A8,8,0,0,0,102.8,152Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _qs),
        e("line", {
          x1: "184",
          y1: "32",
          x2: "184",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pqs)
      ])) : o(i) === "thin" ? (s(), r("g", yqs, [
        e("line", {
          x1: "40",
          y1: "112",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $qs),
        e("path", {
          d: "M102.8,152H56a16,16,0,0,1-16-16V64A32,32,0,0,1,72,32H216V136a16,16,0,0,1-16,16H153.2a8,8,0,0,0-7.9,9.1L152,208a24,24,0,0,1-48,0l6.7-46.9A8,8,0,0,0,102.8,152Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wqs),
        e("line", {
          x1: "184",
          y1: "32",
          x2: "184",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fqs)
      ])) : o(i) === "regular" ? (s(), r("g", gqs, [
        e("line", {
          x1: "40",
          y1: "112",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xqs),
        e("path", {
          d: "M102.8,152H56a16,16,0,0,1-16-16V64A32,32,0,0,1,72,32H216V136a16,16,0,0,1-16,16H153.2a8,8,0,0,0-7.9,9.1L152,208a24,24,0,0,1-48,0l6.7-46.9A8,8,0,0,0,102.8,152Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jqs),
        e("line", {
          x1: "184",
          y1: "32",
          x2: "184",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mqs)
      ])) : g("", !0)
    ], 16, YUs));
  }
}), vqs = ["width", "height", "fill", "transform"], Sqs = { key: 0 }, Hqs = ["stroke"], Aqs = ["stroke"], Vqs = ["stroke"], zqs = ["stroke"], Zqs = { key: 1 }, Cqs = /* @__PURE__ */ e("path", {
  d: "M92.7,83.3a16.1,16.1,0,0,1,22.6,0l9.2,9.2a8,8,0,0,0,11.6-.3L191,31a24,24,0,0,1,34,34l-61.2,54.9a8,8,0,0,0-.3,11.6l9.2,9.2a16.1,16.1,0,0,1,0,22.6L152,184,72,104Z",
  opacity: "0.2"
}, null, -1), bqs = ["stroke"], Lqs = ["stroke"], Bqs = ["stroke"], Pqs = ["stroke"], Wqs = { key: 2 }, Nqs = /* @__PURE__ */ e("path", { d: "M230.6,25.4a31.9,31.9,0,0,0-45.2,0l-.3.3L130.2,86.9,121,77.7a23.9,23.9,0,0,0-34,0L10.3,154.3a8.1,8.1,0,0,0,0,11.4l80,80a8.2,8.2,0,0,0,11.4,0L178.3,169a23.9,23.9,0,0,0,0-34l-9.2-9.2,61.2-54.9.3-.3A31.9,31.9,0,0,0,230.6,25.4ZM96,228.7,81.9,214.6,107.4,189a8,8,0,0,0-11.3-11.3L70.6,203.3,53.9,186.6,79.4,161a8,8,0,0,0-11.3-11.3L42.6,175.3,27.3,160,72,115.3,140.7,184Z" }, null, -1), Fqs = [
  Nqs
], Tqs = { key: 3 }, Dqs = ["stroke"], Rqs = ["stroke"], Uqs = ["stroke"], qqs = ["stroke"], Gqs = { key: 4 }, Eqs = ["stroke"], Oqs = ["stroke"], Iqs = ["stroke"], Kqs = ["stroke"], Xqs = { key: 5 }, Jqs = ["stroke"], Qqs = ["stroke"], Yqs = ["stroke"], oGs = ["stroke"], eGs = {
  name: "PhPaintBrushHousehold"
}, vQ1 = /* @__PURE__ */ $({
  ...eGs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Sqs, [
        e("line", {
          x1: "72",
          y1: "104",
          x2: "152",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hqs),
        e("line", {
          x1: "96",
          y1: "188",
          x2: "70.6",
          y2: "214.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Aqs),
        e("line", {
          x1: "68",
          y1: "160",
          x2: "42.6",
          y2: "186.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vqs),
        e("path", {
          d: "M136.1,92.2,191,31a24,24,0,0,1,34,34l-61.2,54.9a8,8,0,0,0-.3,11.6l9.2,9.2a16.1,16.1,0,0,1,0,22.6L96,240,16,160,92.7,83.3a16.1,16.1,0,0,1,22.6,0l9.2,9.2A8,8,0,0,0,136.1,92.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zqs)
      ])) : o(i) === "duotone" ? (s(), r("g", Zqs, [
        Cqs,
        e("line", {
          x1: "72",
          y1: "104",
          x2: "152",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bqs),
        e("line", {
          x1: "101.8",
          y1: "183.4",
          x2: "70.6",
          y2: "214.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lqs),
        e("line", {
          x1: "73.8",
          y1: "155.4",
          x2: "42.6",
          y2: "186.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bqs),
        e("path", {
          d: "M136.1,92.2,191,31a24,24,0,0,1,34,34l-61.2,54.9a8,8,0,0,0-.3,11.6l9.2,9.2a16.1,16.1,0,0,1,0,22.6L96,240,16,160,92.7,83.3a16.1,16.1,0,0,1,22.6,0l9.2,9.2A8,8,0,0,0,136.1,92.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pqs)
      ])) : o(i) === "fill" ? (s(), r("g", Wqs, Fqs)) : o(i) === "light" ? (s(), r("g", Tqs, [
        e("line", {
          x1: "72",
          y1: "104",
          x2: "152",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dqs),
        e("line", {
          x1: "101.8",
          y1: "183.4",
          x2: "70.6",
          y2: "214.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rqs),
        e("line", {
          x1: "73.8",
          y1: "155.4",
          x2: "42.6",
          y2: "186.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Uqs),
        e("path", {
          d: "M136.1,92.2,191,31a24,24,0,0,1,34,34l-61.2,54.9a8,8,0,0,0-.3,11.6l9.2,9.2a16.1,16.1,0,0,1,0,22.6L96,240,16,160,92.7,83.3a16.1,16.1,0,0,1,22.6,0l9.2,9.2A8,8,0,0,0,136.1,92.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qqs)
      ])) : o(i) === "thin" ? (s(), r("g", Gqs, [
        e("line", {
          x1: "72",
          y1: "104",
          x2: "152",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Eqs),
        e("line", {
          x1: "101.8",
          y1: "183.4",
          x2: "70.6",
          y2: "214.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Oqs),
        e("line", {
          x1: "73.8",
          y1: "155.4",
          x2: "42.6",
          y2: "186.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Iqs),
        e("path", {
          d: "M136.1,92.2,191,31a24,24,0,0,1,34,34l-61.2,54.9a8,8,0,0,0-.3,11.6l9.2,9.2a16.1,16.1,0,0,1,0,22.6L96,240,16,160,92.7,83.3a16.1,16.1,0,0,1,22.6,0l9.2,9.2A8,8,0,0,0,136.1,92.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kqs)
      ])) : o(i) === "regular" ? (s(), r("g", Xqs, [
        e("line", {
          x1: "72",
          y1: "104",
          x2: "152",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jqs),
        e("line", {
          x1: "101.8",
          y1: "183.4",
          x2: "70.6",
          y2: "214.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qqs),
        e("line", {
          x1: "73.8",
          y1: "155.4",
          x2: "42.6",
          y2: "186.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yqs),
        e("path", {
          d: "M136.1,92.2,191,31a24,24,0,0,1,34,34l-61.2,54.9a8,8,0,0,0-.3,11.6l9.2,9.2a16.1,16.1,0,0,1,0,22.6L96,240,16,160,92.7,83.3a16.1,16.1,0,0,1,22.6,0l9.2,9.2A8,8,0,0,0,136.1,92.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oGs)
      ])) : g("", !0)
    ], 16, vqs));
  }
}), tGs = ["width", "height", "fill", "transform"], nGs = { key: 0 }, sGs = ["stroke"], rGs = ["stroke"], iGs = ["stroke"], lGs = ["stroke"], dGs = { key: 1 }, kGs = /* @__PURE__ */ e("circle", {
  cx: "124",
  cy: "116",
  r: "20",
  opacity: "0.2"
}, null, -1), cGs = /* @__PURE__ */ e("path", {
  d: "M208,204c0-20,20-40,20-40s20,20,20,40a20,20,0,0,1-40,0Z",
  opacity: "0.2"
}, null, -1), hGs = ["stroke"], uGs = ["stroke"], aGs = ["stroke"], _Gs = ["stroke"], pGs = { key: 2 }, yGs = /* @__PURE__ */ e("path", { d: "M256,204a28,28,0,0,1-56,0c0-23,21.4-44.7,22.3-45.7a8.2,8.2,0,0,1,11.4,0C234.6,159.3,256,181,256,204ZM132.5,124.5a12,12,0,0,0,0-17,12.1,12.1,0,0,0-17,0,12,12,0,0,0,17,17Zm98.5-1a8.2,8.2,0,0,0-2.4-5.7L121.1,10.3a8,8,0,0,0-11.3,0L69.7,50.4l41,41a28,28,0,1,1-11.3,11.3l-41-41L13.7,106.5a24,24,0,0,0,0,34l84.8,84.8a24.1,24.1,0,0,0,34,0l96.1-96.2A8,8,0,0,0,231,123.5ZM43.5,24.2A8,8,0,0,0,32.2,35.5L58.4,61.7,69.7,50.4Z" }, null, -1), $Gs = [
  yGs
], wGs = { key: 3 }, fGs = ["stroke"], gGs = ["stroke"], xGs = ["stroke"], jGs = ["stroke"], mGs = { key: 4 }, MGs = ["stroke"], vGs = ["stroke"], SGs = ["stroke"], HGs = ["stroke"], AGs = { key: 5 }, VGs = ["stroke"], zGs = ["stroke"], ZGs = ["stroke"], CGs = ["stroke"], bGs = {
  name: "PhPaintBucket"
}, SQ1 = /* @__PURE__ */ $({
  ...bGs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", nGs, [
        e("path", {
          d: "M223,123.5l-96.2,96.2a16.1,16.1,0,0,1-22.6,0L19.3,134.8a16.1,16.1,0,0,1,0-22.6L115.5,16Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sGs),
        e("circle", {
          cx: "124",
          cy: "116",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rGs),
        e("path", {
          d: "M204,216c0-20,20-40,20-40s20,20,20,40a20,20,0,0,1-40,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iGs),
        e("line", {
          x1: "107",
          y1: "99",
          x2: "37.9",
          y2: "29.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lGs)
      ])) : o(i) === "duotone" ? (s(), r("g", dGs, [
        kGs,
        cGs,
        e("path", {
          d: "M223,123.5l-96.2,96.2a16.1,16.1,0,0,1-22.6,0L19.3,134.8a16.1,16.1,0,0,1,0-22.6L115.5,16Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hGs),
        e("circle", {
          cx: "124",
          cy: "116",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uGs),
        e("path", {
          d: "M208,204c0-20,20-40,20-40s20,20,20,40a20,20,0,0,1-40,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aGs),
        e("line", {
          x1: "109.9",
          y1: "101.9",
          x2: "37.9",
          y2: "29.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Gs)
      ])) : o(i) === "fill" ? (s(), r("g", pGs, $Gs)) : o(i) === "light" ? (s(), r("g", wGs, [
        e("path", {
          d: "M223,123.5l-96.2,96.2a16.1,16.1,0,0,1-22.6,0L19.3,134.8a16.1,16.1,0,0,1,0-22.6L115.5,16Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fGs),
        e("circle", {
          cx: "124",
          cy: "116",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gGs),
        e("path", {
          d: "M208,204c0-20,20-40,20-40s20,20,20,40a20,20,0,0,1-40,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xGs),
        e("line", {
          x1: "109.9",
          y1: "101.9",
          x2: "37.9",
          y2: "29.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jGs)
      ])) : o(i) === "thin" ? (s(), r("g", mGs, [
        e("path", {
          d: "M223,123.5l-96.2,96.2a16.1,16.1,0,0,1-22.6,0L19.3,134.8a16.1,16.1,0,0,1,0-22.6L115.5,16Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MGs),
        e("circle", {
          cx: "124",
          cy: "116",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vGs),
        e("path", {
          d: "M208,204c0-20,20-40,20-40s20,20,20,40a20,20,0,0,1-40,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SGs),
        e("line", {
          x1: "109.9",
          y1: "101.9",
          x2: "37.9",
          y2: "29.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HGs)
      ])) : o(i) === "regular" ? (s(), r("g", AGs, [
        e("path", {
          d: "M223,123.5l-96.2,96.2a16.1,16.1,0,0,1-22.6,0L19.3,134.8a16.1,16.1,0,0,1,0-22.6L115.5,16Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VGs),
        e("circle", {
          cx: "124",
          cy: "116",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zGs),
        e("path", {
          d: "M208,204c0-20,20-40,20-40s20,20,20,40a20,20,0,0,1-40,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZGs),
        e("line", {
          x1: "109.9",
          y1: "101.9",
          x2: "37.9",
          y2: "29.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CGs)
      ])) : g("", !0)
    ], 16, tGs));
  }
}), LGs = ["width", "height", "fill", "transform"], BGs = { key: 0 }, PGs = ["stroke"], WGs = ["stroke"], NGs = ["stroke"], FGs = { key: 1 }, TGs = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "56",
  width: "168",
  height: "80",
  rx: "8",
  opacity: "0.2"
}, null, -1), DGs = ["stroke"], RGs = ["stroke"], UGs = ["stroke"], qGs = { key: 2 }, GGs = /* @__PURE__ */ e("path", { d: "M248,104v50a16.2,16.2,0,0,1-11.6,15.4L136,198v34a8,8,0,0,1-16,0V198a16.2,16.2,0,0,1,11.6-15.4L232,154V104H216v24a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V104H16a8,8,0,0,1,0-16H32V64A16,16,0,0,1,48,48H200a16,16,0,0,1,16,16V88h16A16,16,0,0,1,248,104Z" }, null, -1), EGs = [
  GGs
], OGs = { key: 3 }, IGs = ["stroke"], KGs = ["stroke"], XGs = ["stroke"], JGs = { key: 4 }, QGs = ["stroke"], YGs = ["stroke"], oEs = ["stroke"], eEs = { key: 5 }, tEs = ["stroke"], nEs = ["stroke"], sEs = ["stroke"], rEs = {
  name: "PhPaintRoller"
}, HQ1 = /* @__PURE__ */ $({
  ...rEs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", BGs, [
        e("rect", {
          x: "44",
          y: "56",
          width: "160",
          height: "80",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PGs),
        e("path", {
          d: "M204,96h28a8,8,0,0,1,8,8v50a8.1,8.1,0,0,1-5.8,7.7L133.8,190.3A8.1,8.1,0,0,0,128,198v34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WGs),
        e("line", {
          x1: "44",
          y1: "96",
          x2: "16",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NGs)
      ])) : o(i) === "duotone" ? (s(), r("g", FGs, [
        TGs,
        e("rect", {
          x: "40",
          y: "56",
          width: "168",
          height: "80",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DGs),
        e("path", {
          d: "M208,96h24a8,8,0,0,1,8,8v50a8.1,8.1,0,0,1-5.8,7.7L133.8,190.3A8.1,8.1,0,0,0,128,198v34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RGs),
        e("line", {
          x1: "40",
          y1: "96",
          x2: "16",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UGs)
      ])) : o(i) === "fill" ? (s(), r("g", qGs, EGs)) : o(i) === "light" ? (s(), r("g", OGs, [
        e("rect", {
          x: "40",
          y: "56",
          width: "168",
          height: "80",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IGs),
        e("path", {
          d: "M208,96h24a8,8,0,0,1,8,8v50a8.1,8.1,0,0,1-5.8,7.7L133.8,190.3A8.1,8.1,0,0,0,128,198v34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KGs),
        e("line", {
          x1: "40",
          y1: "96",
          x2: "16",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XGs)
      ])) : o(i) === "thin" ? (s(), r("g", JGs, [
        e("rect", {
          x: "40",
          y: "56",
          width: "168",
          height: "80",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QGs),
        e("path", {
          d: "M208,96h24a8,8,0,0,1,8,8v50a8.1,8.1,0,0,1-5.8,7.7L133.8,190.3A8.1,8.1,0,0,0,128,198v34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YGs),
        e("line", {
          x1: "40",
          y1: "96",
          x2: "16",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oEs)
      ])) : o(i) === "regular" ? (s(), r("g", eEs, [
        e("rect", {
          x: "40",
          y: "56",
          width: "168",
          height: "80",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tEs),
        e("path", {
          d: "M208,96h24a8,8,0,0,1,8,8v50a8.1,8.1,0,0,1-5.8,7.7L133.8,190.3A8.1,8.1,0,0,0,128,198v34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nEs),
        e("line", {
          x1: "40",
          y1: "96",
          x2: "16",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sEs)
      ])) : g("", !0)
    ], 16, LGs));
  }
}), iEs = ["width", "height", "fill", "transform"], lEs = { key: 0 }, dEs = ["stroke"], kEs = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "76",
  r: "16"
}, null, -1), cEs = /* @__PURE__ */ e("circle", {
  cx: "83",
  cy: "102",
  r: "16"
}, null, -1), hEs = /* @__PURE__ */ e("circle", {
  cx: "83",
  cy: "154",
  r: "16"
}, null, -1), uEs = /* @__PURE__ */ e("circle", {
  cx: "173",
  cy: "102",
  r: "16"
}, null, -1), aEs = { key: 1 }, _Es = /* @__PURE__ */ e("path", {
  d: "M221.6,149.4a96.2,96.2,0,0,0,2.4-22.2c-.4-52.9-44.2-95.7-97-95.2A96,96,0,0,0,96,218.5a23.9,23.9,0,0,0,32-22.6V192a23.9,23.9,0,0,1,24-24h46.2A24,24,0,0,0,221.6,149.4Z",
  opacity: "0.2"
}, null, -1), pEs = ["stroke"], yEs = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "76",
  r: "12"
}, null, -1), $Es = /* @__PURE__ */ e("circle", {
  cx: "83",
  cy: "102",
  r: "12"
}, null, -1), wEs = /* @__PURE__ */ e("circle", {
  cx: "83",
  cy: "154",
  r: "12"
}, null, -1), fEs = /* @__PURE__ */ e("circle", {
  cx: "173",
  cy: "102",
  r: "12"
}, null, -1), gEs = { key: 2 }, xEs = /* @__PURE__ */ e("path", { d: "M200.8,53.9A103.4,103.4,0,0,0,128,24h-1.1A104,104,0,0,0,93.4,226.1,32,32,0,0,0,136,195.9V192a16,16,0,0,1,16-16h46.2a31.7,31.7,0,0,0,31.2-24.9,101.5,101.5,0,0,0,2.6-24A102.9,102.9,0,0,0,200.8,53.9ZM89,164.4A12,12,0,1,1,93.4,148,12,12,0,0,1,89,164.4ZM93.4,108A12,12,0,1,1,89,91.6,12.1,12.1,0,0,1,93.4,108ZM128,88a12,12,0,1,1,12-12A12,12,0,0,1,128,88Zm51,24.4A12,12,0,1,1,183.4,96,12.1,12.1,0,0,1,179,112.4Z" }, null, -1), jEs = [
  xEs
], mEs = { key: 3 }, MEs = ["stroke"], vEs = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "76",
  r: "10"
}, null, -1), SEs = /* @__PURE__ */ e("circle", {
  cx: "83",
  cy: "102",
  r: "10"
}, null, -1), HEs = /* @__PURE__ */ e("circle", {
  cx: "83",
  cy: "154",
  r: "10"
}, null, -1), AEs = /* @__PURE__ */ e("circle", {
  cx: "173",
  cy: "102",
  r: "10"
}, null, -1), VEs = { key: 4 }, zEs = ["stroke"], ZEs = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "76",
  r: "8"
}, null, -1), CEs = /* @__PURE__ */ e("circle", {
  cx: "83",
  cy: "102",
  r: "8"
}, null, -1), bEs = /* @__PURE__ */ e("circle", {
  cx: "83",
  cy: "154",
  r: "8"
}, null, -1), LEs = /* @__PURE__ */ e("circle", {
  cx: "173",
  cy: "102",
  r: "8"
}, null, -1), BEs = { key: 5 }, PEs = ["stroke"], WEs = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "76",
  r: "12"
}, null, -1), NEs = /* @__PURE__ */ e("circle", {
  cx: "83",
  cy: "102",
  r: "12"
}, null, -1), FEs = /* @__PURE__ */ e("circle", {
  cx: "83",
  cy: "154",
  r: "12"
}, null, -1), TEs = /* @__PURE__ */ e("circle", {
  cx: "173",
  cy: "102",
  r: "12"
}, null, -1), DEs = {
  name: "PhPalette"
}, AQ1 = /* @__PURE__ */ $({
  ...DEs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", lEs, [
        e("path", {
          d: "M221.6,149.4a96.2,96.2,0,0,0,2.4-22.2c-.4-52.9-44.2-95.7-97-95.2A96,96,0,0,0,96,218.5a23.9,23.9,0,0,0,32-22.6V192a23.9,23.9,0,0,1,24-24h46.2A24,24,0,0,0,221.6,149.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dEs),
        kEs,
        cEs,
        hEs,
        uEs
      ])) : o(i) === "duotone" ? (s(), r("g", aEs, [
        _Es,
        e("path", {
          d: "M221.6,149.4a96.2,96.2,0,0,0,2.4-22.2c-.4-52.9-44.2-95.7-97-95.2A96,96,0,0,0,96,218.5a23.9,23.9,0,0,0,32-22.6V192a23.9,23.9,0,0,1,24-24h46.2A24,24,0,0,0,221.6,149.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pEs),
        yEs,
        $Es,
        wEs,
        fEs
      ])) : o(i) === "fill" ? (s(), r("g", gEs, jEs)) : o(i) === "light" ? (s(), r("g", mEs, [
        e("path", {
          d: "M221.6,149.4a96.2,96.2,0,0,0,2.4-22.2c-.4-52.9-44.2-95.7-97-95.2A96,96,0,0,0,96,218.5a23.9,23.9,0,0,0,32-22.6V192a23.9,23.9,0,0,1,24-24h46.2A24,24,0,0,0,221.6,149.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, MEs),
        vEs,
        SEs,
        HEs,
        AEs
      ])) : o(i) === "thin" ? (s(), r("g", VEs, [
        e("path", {
          d: "M221.6,149.4a96.2,96.2,0,0,0,2.4-22.2c-.4-52.9-44.2-95.7-97-95.2A96,96,0,0,0,96,218.5a23.9,23.9,0,0,0,32-22.6V192a23.9,23.9,0,0,1,24-24h46.2A24,24,0,0,0,221.6,149.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zEs),
        ZEs,
        CEs,
        bEs,
        LEs
      ])) : o(i) === "regular" ? (s(), r("g", BEs, [
        e("path", {
          d: "M221.6,149.4a96.2,96.2,0,0,0,2.4-22.2c-.4-52.9-44.2-95.7-97-95.2A96,96,0,0,0,96,218.5a23.9,23.9,0,0,0,32-22.6V192a23.9,23.9,0,0,1,24-24h46.2A24,24,0,0,0,221.6,149.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PEs),
        WEs,
        NEs,
        FEs,
        TEs
      ])) : g("", !0)
    ], 16, iEs));
  }
}), REs = ["width", "height", "fill", "transform"], UEs = { key: 0 }, qEs = ["stroke"], GEs = ["stroke"], EEs = { key: 1 }, OEs = /* @__PURE__ */ e("path", {
  d: "M120.9,36.5,26.3,205.4A8,8,0,0,0,36,216.8L125.2,185a7.2,7.2,0,0,1,5.4,0l89.2,31.8a8,8,0,0,0,9.7-11.4L134.9,36.5A8,8,0,0,0,120.9,36.5Z",
  opacity: "0.2"
}, null, -1), IEs = ["stroke"], KEs = ["stroke"], XEs = { key: 2 }, JEs = /* @__PURE__ */ e("path", { d: "M236.4,201.5,141.8,32.6a16,16,0,0,0-27.9,0L19.3,201.5a15.7,15.7,0,0,0,1.8,18.1,15.9,15.9,0,0,0,17.6,4.8l78.5-28.1a4.1,4.1,0,0,0,2.7-3.8V120.3a8.2,8.2,0,0,1,7.4-8.3,8,8,0,0,1,8.6,8v72.5a4,4,0,0,0,2.6,3.8l78.6,28.1a17,17,0,0,0,5.4.9,16,16,0,0,0,13.9-23.8Z" }, null, -1), QEs = [
  JEs
], YEs = { key: 3 }, oOs = ["stroke"], eOs = ["stroke"], tOs = { key: 4 }, nOs = ["stroke"], sOs = ["stroke"], rOs = { key: 5 }, iOs = ["stroke"], lOs = ["stroke"], dOs = {
  name: "PhPaperPlane"
}, VQ1 = /* @__PURE__ */ $({
  ...dOs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", UEs, [
        e("path", {
          d: "M120.9,36.5,26.3,205.4A8,8,0,0,0,36,216.8L125.2,185a7.2,7.2,0,0,1,5.4,0l89.2,31.8a8,8,0,0,0,9.7-11.4L134.9,36.5A8,8,0,0,0,120.9,36.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qEs),
        e("line", {
          x1: "127.9",
          y1: "184",
          x2: "127.9",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GEs)
      ])) : o(i) === "duotone" ? (s(), r("g", EEs, [
        OEs,
        e("path", {
          d: "M120.9,36.5,26.3,205.4A8,8,0,0,0,36,216.8L125.2,185a7.2,7.2,0,0,1,5.4,0l89.2,31.8a8,8,0,0,0,9.7-11.4L134.9,36.5A8,8,0,0,0,120.9,36.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IEs),
        e("line", {
          x1: "127.9",
          y1: "184",
          x2: "127.9",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KEs)
      ])) : o(i) === "fill" ? (s(), r("g", XEs, QEs)) : o(i) === "light" ? (s(), r("g", YEs, [
        e("path", {
          d: "M120.9,36.5,26.3,205.4A8,8,0,0,0,36,216.8L125.2,185a7.2,7.2,0,0,1,5.4,0l89.2,31.8a8,8,0,0,0,9.7-11.4L134.9,36.5A8,8,0,0,0,120.9,36.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oOs),
        e("line", {
          x1: "127.9",
          y1: "184",
          x2: "127.9",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eOs)
      ])) : o(i) === "thin" ? (s(), r("g", tOs, [
        e("path", {
          d: "M120.9,36.5,26.3,205.4A8,8,0,0,0,36,216.8L125.2,185a7.2,7.2,0,0,1,5.4,0l89.2,31.8a8,8,0,0,0,9.7-11.4L134.9,36.5A8,8,0,0,0,120.9,36.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nOs),
        e("line", {
          x1: "127.9",
          y1: "184",
          x2: "127.9",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sOs)
      ])) : o(i) === "regular" ? (s(), r("g", rOs, [
        e("path", {
          d: "M120.9,36.5,26.3,205.4A8,8,0,0,0,36,216.8L125.2,185a7.2,7.2,0,0,1,5.4,0l89.2,31.8a8,8,0,0,0,9.7-11.4L134.9,36.5A8,8,0,0,0,120.9,36.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iOs),
        e("line", {
          x1: "127.9",
          y1: "184",
          x2: "127.9",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lOs)
      ])) : g("", !0)
    ], 16, REs));
  }
}), kOs = ["width", "height", "fill", "transform"], cOs = { key: 0 }, hOs = ["stroke"], uOs = ["stroke"], aOs = { key: 1 }, _Os = /* @__PURE__ */ e("path", {
  d: "M219.5,121,50.6,26.4a8,8,0,0,0-11.4,9.7L71,125.3a7.2,7.2,0,0,1,0,5.4L39.2,219.9a8,8,0,0,0,11.4,9.7L219.5,135A8,8,0,0,0,219.5,121Z",
  opacity: "0.2"
}, null, -1), pOs = ["stroke"], yOs = ["stroke"], $Os = { key: 2 }, wOs = /* @__PURE__ */ e("path", { d: "M223.4,114,54.9,19.7a16.3,16.3,0,0,0-18.2,1.2,15.9,15.9,0,0,0-5.1,17.9l28.1,78.5a4.1,4.1,0,0,0,3.8,2.7h72.2a8.2,8.2,0,0,1,8.3,7.5,8,8,0,0,1-8,8.5H63.5a4.1,4.1,0,0,0-3.8,2.7L31.6,217.2a16.1,16.1,0,0,0,15.1,21.4,16.5,16.5,0,0,0,7.8-2L223.4,142a16.1,16.1,0,0,0,0-28Z" }, null, -1), fOs = [
  wOs
], gOs = { key: 3 }, xOs = ["stroke"], jOs = ["stroke"], mOs = { key: 4 }, MOs = ["stroke"], vOs = ["stroke"], SOs = { key: 5 }, HOs = ["stroke"], AOs = ["stroke"], VOs = {
  name: "PhPaperPlaneRight"
}, zQ1 = /* @__PURE__ */ $({
  ...VOs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", cOs, [
        e("path", {
          d: "M219.5,121,50.6,26.4a8,8,0,0,0-11.4,9.7L71,125.3a7.2,7.2,0,0,1,0,5.4L39.2,219.9a8,8,0,0,0,11.4,9.7L219.5,135A8,8,0,0,0,219.5,121Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hOs),
        e("line", {
          x1: "72",
          y1: "128",
          x2: "136",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uOs)
      ])) : o(i) === "duotone" ? (s(), r("g", aOs, [
        _Os,
        e("path", {
          d: "M219.5,121,50.6,26.4a8,8,0,0,0-11.4,9.7L71,125.3a7.2,7.2,0,0,1,0,5.4L39.2,219.9a8,8,0,0,0,11.4,9.7L219.5,135A8,8,0,0,0,219.5,121Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pOs),
        e("line", {
          x1: "72",
          y1: "128",
          x2: "136",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yOs)
      ])) : o(i) === "fill" ? (s(), r("g", $Os, fOs)) : o(i) === "light" ? (s(), r("g", gOs, [
        e("path", {
          d: "M219.5,121,50.6,26.4a8,8,0,0,0-11.4,9.7L71,125.3a7.2,7.2,0,0,1,0,5.4L39.2,219.9a8,8,0,0,0,11.4,9.7L219.5,135A8,8,0,0,0,219.5,121Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xOs),
        e("line", {
          x1: "72",
          y1: "128",
          x2: "136",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jOs)
      ])) : o(i) === "thin" ? (s(), r("g", mOs, [
        e("path", {
          d: "M219.5,121,50.6,26.4a8,8,0,0,0-11.4,9.7L71,125.3a7.2,7.2,0,0,1,0,5.4L39.2,219.9a8,8,0,0,0,11.4,9.7L219.5,135A8,8,0,0,0,219.5,121Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MOs),
        e("line", {
          x1: "72",
          y1: "128",
          x2: "136",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vOs)
      ])) : o(i) === "regular" ? (s(), r("g", SOs, [
        e("path", {
          d: "M219.5,121,50.6,26.4a8,8,0,0,0-11.4,9.7L71,125.3a7.2,7.2,0,0,1,0,5.4L39.2,219.9a8,8,0,0,0,11.4,9.7L219.5,135A8,8,0,0,0,219.5,121Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HOs),
        e("line", {
          x1: "72",
          y1: "128",
          x2: "136",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AOs)
      ])) : g("", !0)
    ], 16, kOs));
  }
}), zOs = ["width", "height", "fill", "transform"], ZOs = { key: 0 }, COs = ["stroke"], bOs = ["stroke"], LOs = { key: 1 }, BOs = /* @__PURE__ */ e("path", {
  d: "M210.3,35.9,23.9,88.4a8,8,0,0,0-1.2,15l85.6,40.5a7.8,7.8,0,0,1,3.8,3.8l40.5,85.6a8,8,0,0,0,15-1.2L220.1,45.7A7.9,7.9,0,0,0,210.3,35.9Z",
  opacity: "0.2"
}, null, -1), POs = ["stroke"], WOs = ["stroke"], NOs = { key: 2 }, FOs = /* @__PURE__ */ e("path", { d: "M227.7,48.3,175.3,234.2a15.9,15.9,0,0,1-14.1,11.6h-1.4a16,16,0,0,1-14.4-9.1l-35.7-75.4a4.1,4.1,0,0,1,.8-4.6l51.3-51.3a8,8,0,1,0-11.3-11.3L99.2,145.5a4.1,4.1,0,0,1-4.6.8l-75-35.5a16.6,16.6,0,0,1-9.5-15.6A15.9,15.9,0,0,1,21.8,80.7L208.1,28.2a16,16,0,0,1,17.7,6.5A16.7,16.7,0,0,1,227.7,48.3Z" }, null, -1), TOs = [
  FOs
], DOs = { key: 3 }, ROs = ["stroke"], UOs = ["stroke"], qOs = { key: 4 }, GOs = ["stroke"], EOs = ["stroke"], OOs = { key: 5 }, IOs = ["stroke"], KOs = ["stroke"], XOs = {
  name: "PhPaperPlaneTilt"
}, ZQ1 = /* @__PURE__ */ $({
  ...XOs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ZOs, [
        e("path", {
          d: "M210.3,35.9,23.9,88.4a8,8,0,0,0-1.2,15l85.6,40.5a7.8,7.8,0,0,1,3.8,3.8l40.5,85.6a8,8,0,0,0,15-1.2L220.1,45.7A7.9,7.9,0,0,0,210.3,35.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, COs),
        e("line", {
          x1: "110.9",
          y1: "145.1",
          x2: "156.1",
          y2: "99.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bOs)
      ])) : o(i) === "duotone" ? (s(), r("g", LOs, [
        BOs,
        e("path", {
          d: "M210.3,35.9,23.9,88.4a8,8,0,0,0-1.2,15l85.6,40.5a7.8,7.8,0,0,1,3.8,3.8l40.5,85.6a8,8,0,0,0,15-1.2L220.1,45.7A7.9,7.9,0,0,0,210.3,35.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, POs),
        e("line", {
          x1: "110.9",
          y1: "145.1",
          x2: "156.1",
          y2: "99.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WOs)
      ])) : o(i) === "fill" ? (s(), r("g", NOs, TOs)) : o(i) === "light" ? (s(), r("g", DOs, [
        e("path", {
          d: "M210.3,35.9,23.9,88.4a8,8,0,0,0-1.2,15l85.6,40.5a7.8,7.8,0,0,1,3.8,3.8l40.5,85.6a8,8,0,0,0,15-1.2L220.1,45.7A7.9,7.9,0,0,0,210.3,35.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ROs),
        e("line", {
          x1: "110.9",
          y1: "145.1",
          x2: "156.1",
          y2: "99.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UOs)
      ])) : o(i) === "thin" ? (s(), r("g", qOs, [
        e("path", {
          d: "M210.3,35.9,23.9,88.4a8,8,0,0,0-1.2,15l85.6,40.5a7.8,7.8,0,0,1,3.8,3.8l40.5,85.6a8,8,0,0,0,15-1.2L220.1,45.7A7.9,7.9,0,0,0,210.3,35.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GOs),
        e("line", {
          x1: "110.9",
          y1: "145.1",
          x2: "156.1",
          y2: "99.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, EOs)
      ])) : o(i) === "regular" ? (s(), r("g", OOs, [
        e("path", {
          d: "M210.3,35.9,23.9,88.4a8,8,0,0,0-1.2,15l85.6,40.5a7.8,7.8,0,0,1,3.8,3.8l40.5,85.6a8,8,0,0,0,15-1.2L220.1,45.7A7.9,7.9,0,0,0,210.3,35.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IOs),
        e("line", {
          x1: "110.9",
          y1: "145.1",
          x2: "156.1",
          y2: "99.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KOs)
      ])) : g("", !0)
    ], 16, zOs));
  }
}), JOs = ["width", "height", "fill", "transform"], QOs = { key: 0 }, YOs = ["stroke"], oIs = { key: 1 }, eIs = ["stroke"], tIs = { key: 2 }, nIs = /* @__PURE__ */ e("path", { d: "M209.7,122.3a8.1,8.1,0,0,1-.1,11.4l-82,81.9a56,56,0,0,1-79.2-79.2L147.7,35.8a40,40,0,1,1,56.6,56.5L105,192.9A23.8,23.8,0,0,1,88,200a24,24,0,0,1-17-41l83.3-84.6a8,8,0,1,1,11.4,11.2L82.4,170.3A8,8,0,0,0,80,176a8.1,8.1,0,0,0,13.7,5.7L192.9,81A23.8,23.8,0,0,0,200,64a24,24,0,0,0-41-17L59.8,147.7a40,40,0,1,0,56.5,56.6l82-82A8.1,8.1,0,0,1,209.7,122.3Z" }, null, -1), sIs = [
  nIs
], rIs = { key: 3 }, iIs = ["stroke"], lIs = { key: 4 }, dIs = ["stroke"], kIs = { key: 5 }, cIs = ["stroke"], hIs = {
  name: "PhPaperclip"
}, CQ1 = /* @__PURE__ */ $({
  ...hIs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", QOs, [
        e("path", {
          d: "M96,176l95.8-92.2a28,28,0,0,0-39.6-39.6L54.1,142.1a47.9,47.9,0,0,0,67.8,67.8L204,128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, YOs)
      ])) : o(i) === "duotone" ? (s(), r("g", oIs, [
        e("path", {
          d: "M160,80,76.7,164.7a16,16,0,0,0,22.6,22.6L198.6,86.6a32,32,0,0,0-45.2-45.2L54.1,142.1a47.9,47.9,0,0,0,67.8,67.8L204,128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eIs)
      ])) : o(i) === "fill" ? (s(), r("g", tIs, sIs)) : o(i) === "light" ? (s(), r("g", rIs, [
        e("path", {
          d: "M160,80,76.7,164.7a16,16,0,0,0,22.6,22.6L198.6,86.6a32,32,0,0,0-45.2-45.2L54.1,142.1a47.9,47.9,0,0,0,67.8,67.8L204,128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iIs)
      ])) : o(i) === "thin" ? (s(), r("g", lIs, [
        e("path", {
          d: "M160,80,76.7,164.7a16,16,0,0,0,22.6,22.6L198.6,86.6a32,32,0,0,0-45.2-45.2L54.1,142.1a47.9,47.9,0,0,0,67.8,67.8L204,128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dIs)
      ])) : o(i) === "regular" ? (s(), r("g", kIs, [
        e("path", {
          d: "M160,80,76.7,164.7a16,16,0,0,0,22.6,22.6L198.6,86.6a32,32,0,0,0-45.2-45.2L54.1,142.1a47.9,47.9,0,0,0,67.8,67.8L204,128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cIs)
      ])) : g("", !0)
    ], 16, JOs));
  }
}), uIs = ["width", "height", "fill", "transform"], aIs = { key: 0 }, _Is = ["stroke"], pIs = { key: 1 }, yIs = ["stroke"], $Is = { key: 2 }, wIs = /* @__PURE__ */ e("path", { d: "M192,184H46c-21.6,0-39.2-17.9-39.2-40S24.4,104,46,104H190a24,24,0,0,1,0,48H78a8,8,0,0,1,0-16H190a8,8,0,0,0,0-16H46c-12.8,0-23.2,10.8-23.2,24S33.2,168,46,168H192a40,40,0,0,0,0-80H80a8,8,0,0,1,0-16H192a56,56,0,0,1,0,112Z" }, null, -1), fIs = [
  wIs
], gIs = { key: 3 }, xIs = ["stroke"], jIs = { key: 4 }, mIs = ["stroke"], MIs = { key: 5 }, vIs = ["stroke"], SIs = {
  name: "PhPaperclipHorizontal"
}, bQ1 = /* @__PURE__ */ $({
  ...SIs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", aIs, [
        e("path", {
          d: "M184,120H48a28,28,0,0,0,0,56H188a48,48,0,0,0,0-96H76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Is)
      ])) : o(i) === "duotone" ? (s(), r("g", pIs, [
        e("path", {
          d: "M78,144H190a16,16,0,0,0,0-32H46c-17.2,0-31.2,14.3-31.2,32s14,32,31.2,32H192a48,48,0,0,0,0-96H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yIs)
      ])) : o(i) === "fill" ? (s(), r("g", $Is, fIs)) : o(i) === "light" ? (s(), r("g", gIs, [
        e("path", {
          d: "M78,144H190a16,16,0,0,0,0-32H46c-17.2,0-31.2,14.3-31.2,32s14,32,31.2,32H192a48,48,0,0,0,0-96H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xIs)
      ])) : o(i) === "thin" ? (s(), r("g", jIs, [
        e("path", {
          d: "M78,144H190a16,16,0,0,0,0-32H46c-17.2,0-31.2,14.3-31.2,32s14,32,31.2,32H192a48,48,0,0,0,0-96H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mIs)
      ])) : o(i) === "regular" ? (s(), r("g", MIs, [
        e("path", {
          d: "M78,144H190a16,16,0,0,0,0-32H46c-17.2,0-31.2,14.3-31.2,32s14,32,31.2,32H192a48,48,0,0,0,0-96H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vIs)
      ])) : g("", !0)
    ], 16, uIs));
  }
}), HIs = ["width", "height", "fill", "transform"], AIs = { key: 0 }, VIs = ["stroke"], zIs = ["stroke"], ZIs = ["stroke"], CIs = ["stroke"], bIs = ["stroke"], LIs = { key: 1 }, BIs = /* @__PURE__ */ e("path", {
  d: "M128,24a96,96,0,0,0-96,96H88C88,48,128,24,128,24Z",
  opacity: "0.2"
}, null, -1), PIs = /* @__PURE__ */ e("path", {
  d: "M128,24s40,24,40,96h56A96,96,0,0,0,128,24Z",
  opacity: "0.2"
}, null, -1), WIs = ["stroke"], NIs = ["stroke"], FIs = ["stroke"], TIs = ["stroke"], DIs = ["stroke"], RIs = { key: 2 }, UIs = /* @__PURE__ */ e("path", { d: "M232,120A104.2,104.2,0,0,0,128,16h0A104.2,104.2,0,0,0,24,120a8.2,8.2,0,0,0,3.2,6.4h0L120,196v20h-8a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16h-8V196l92.8-69.6h0A8.2,8.2,0,0,0,232,120Zm-16.4-8H175.8c-1.5-37.9-13.9-62.4-25.1-77A88.1,88.1,0,0,1,215.6,112Zm-61.2,16L128,175.5,101.6,128Zm-71.1,0,19.5,35.1L56,128Zm89.4,0H200l-46.8,35.1ZM105.3,35C94.1,49.6,81.7,74.1,80.2,112H40.4A88.1,88.1,0,0,1,105.3,35Z" }, null, -1), qIs = [
  UIs
], GIs = { key: 3 }, EIs = ["stroke"], OIs = ["stroke"], IIs = ["stroke"], KIs = ["stroke"], XIs = ["stroke"], JIs = { key: 4 }, QIs = ["stroke"], YIs = ["stroke"], oKs = ["stroke"], eKs = ["stroke"], tKs = ["stroke"], nKs = { key: 5 }, sKs = ["stroke"], rKs = ["stroke"], iKs = ["stroke"], lKs = ["stroke"], dKs = ["stroke"], kKs = {
  name: "PhParachute"
}, LQ1 = /* @__PURE__ */ $({
  ...kKs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", AIs, [
        e("path", {
          d: "M224,120a96,96,0,0,0-192,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VIs),
        e("polyline", {
          points: "224 120 128 192 32 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zIs),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZIs),
        e("line", {
          x1: "112",
          y1: "224",
          x2: "144",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CIs),
        e("path", {
          d: "M88,120c0-72,40-96,40-96s40,24,40,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bIs)
      ])) : o(i) === "duotone" ? (s(), r("g", LIs, [
        BIs,
        PIs,
        e("path", {
          d: "M224,120a96,96,0,0,0-192,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WIs),
        e("polyline", {
          points: "224 120 128 192 32 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NIs),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FIs),
        e("line", {
          x1: "112",
          y1: "224",
          x2: "144",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TIs),
        e("path", {
          d: "M128,192,88,120c0-72,40-96,40-96s40,24,40,96Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DIs)
      ])) : o(i) === "fill" ? (s(), r("g", RIs, qIs)) : o(i) === "light" ? (s(), r("g", GIs, [
        e("path", {
          d: "M224,120a96,96,0,0,0-192,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, EIs),
        e("polyline", {
          points: "224 120 128 192 32 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OIs),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IIs),
        e("line", {
          x1: "112",
          y1: "224",
          x2: "144",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KIs),
        e("path", {
          d: "M128,192,88,120c0-72,40-96,40-96s40,24,40,96Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XIs)
      ])) : o(i) === "thin" ? (s(), r("g", JIs, [
        e("path", {
          d: "M224,120a96,96,0,0,0-192,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QIs),
        e("polyline", {
          points: "224 120 128 192 32 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YIs),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oKs),
        e("line", {
          x1: "112",
          y1: "224",
          x2: "144",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eKs),
        e("path", {
          d: "M128,192,88,120c0-72,40-96,40-96s40,24,40,96Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tKs)
      ])) : o(i) === "regular" ? (s(), r("g", nKs, [
        e("path", {
          d: "M224,120a96,96,0,0,0-192,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sKs),
        e("polyline", {
          points: "224 120 128 192 32 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rKs),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iKs),
        e("line", {
          x1: "112",
          y1: "224",
          x2: "144",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lKs),
        e("path", {
          d: "M128,192,88,120c0-72,40-96,40-96s40,24,40,96Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dKs)
      ])) : g("", !0)
    ], 16, HIs));
  }
}), cKs = ["width", "height", "fill", "transform"], hKs = { key: 0 }, uKs = ["stroke"], aKs = ["stroke"], _Ks = ["stroke"], pKs = ["stroke"], yKs = ["stroke"], $Ks = ["stroke"], wKs = ["stroke"], fKs = ["stroke"], gKs = ["stroke"], xKs = ["stroke"], jKs = ["stroke"], mKs = { key: 1 }, MKs = ["stroke"], vKs = ["stroke"], SKs = ["stroke"], HKs = ["stroke"], AKs = ["stroke"], VKs = ["stroke"], zKs = ["stroke"], ZKs = ["stroke"], CKs = ["stroke"], bKs = ["stroke"], LKs = ["stroke"], BKs = { key: 2 }, PKs = /* @__PURE__ */ e("path", { d: "M48,56V200a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0Zm84,54.5L112,117V96a8,8,0,0,0-16,0v21l-20-6.5a7.8,7.8,0,0,0-10,5.1,7.9,7.9,0,0,0,5.1,10.1l20,6.5-12.4,17a8,8,0,0,0,1.8,11.2,8.1,8.1,0,0,0,11.2-1.8l12.3-17,12.3,17a8.1,8.1,0,0,0,11.2,1.8,8,8,0,0,0,1.8-11.2l-12.4-17,20-6.5a7.9,7.9,0,0,0,5.1-10.1A7.8,7.8,0,0,0,132,110.5Zm106,5.1a7.8,7.8,0,0,0-10-5.1L208,117V96a8,8,0,0,0-16,0v21l-20-6.5a7.8,7.8,0,0,0-10,5.1,7.9,7.9,0,0,0,5.1,10.1l20,6.5-12.4,17a8,8,0,0,0,1.8,11.2,8.1,8.1,0,0,0,11.2-1.8l12.3-17,12.3,17a8.1,8.1,0,0,0,11.2,1.8,8,8,0,0,0,1.8-11.2l-12.4-17,20-6.5A7.9,7.9,0,0,0,238,115.6Z" }, null, -1), WKs = [
  PKs
], NKs = { key: 3 }, FKs = ["stroke"], TKs = ["stroke"], DKs = ["stroke"], RKs = ["stroke"], UKs = ["stroke"], qKs = ["stroke"], GKs = ["stroke"], EKs = ["stroke"], OKs = ["stroke"], IKs = ["stroke"], KKs = ["stroke"], XKs = { key: 4 }, JKs = ["stroke"], QKs = ["stroke"], YKs = ["stroke"], oXs = ["stroke"], eXs = ["stroke"], tXs = ["stroke"], nXs = ["stroke"], sXs = ["stroke"], rXs = ["stroke"], iXs = ["stroke"], lXs = ["stroke"], dXs = { key: 5 }, kXs = ["stroke"], cXs = ["stroke"], hXs = ["stroke"], uXs = ["stroke"], aXs = ["stroke"], _Xs = ["stroke"], pXs = ["stroke"], yXs = ["stroke"], $Xs = ["stroke"], wXs = ["stroke"], fXs = ["stroke"], gXs = {
  name: "PhPassword"
}, BQ1 = /* @__PURE__ */ $({
  ...gXs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", hKs, [
        e("line", {
          x1: "36",
          y1: "56",
          x2: "36",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uKs),
        e("line", {
          x1: "104",
          y1: "96",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aKs),
        e("line", {
          x1: "73.6",
          y1: "118.1",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Ks),
        e("line", {
          x1: "85.2",
          y1: "153.9",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pKs),
        e("line", {
          x1: "122.8",
          y1: "153.9",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yKs),
        e("line", {
          x1: "134.4",
          y1: "118.1",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $Ks),
        e("line", {
          x1: "200",
          y1: "96",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wKs),
        e("line", {
          x1: "169.6",
          y1: "118.1",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fKs),
        e("line", {
          x1: "181.2",
          y1: "153.9",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gKs),
        e("line", {
          x1: "218.8",
          y1: "153.9",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xKs),
        e("line", {
          x1: "230.4",
          y1: "118.1",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jKs)
      ])) : o(i) === "duotone" ? (s(), r("g", mKs, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MKs),
        e("line", {
          x1: "104",
          y1: "96",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vKs),
        e("line", {
          x1: "73.6",
          y1: "118.1",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SKs),
        e("line", {
          x1: "85.2",
          y1: "153.9",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HKs),
        e("line", {
          x1: "122.8",
          y1: "153.9",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AKs),
        e("line", {
          x1: "134.4",
          y1: "118.1",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VKs),
        e("line", {
          x1: "200",
          y1: "96",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zKs),
        e("line", {
          x1: "169.6",
          y1: "118.1",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZKs),
        e("line", {
          x1: "181.2",
          y1: "153.9",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CKs),
        e("line", {
          x1: "218.8",
          y1: "153.9",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bKs),
        e("line", {
          x1: "230.4",
          y1: "118.1",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LKs)
      ])) : o(i) === "fill" ? (s(), r("g", BKs, WKs)) : o(i) === "light" ? (s(), r("g", NKs, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FKs),
        e("line", {
          x1: "104",
          y1: "96",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TKs),
        e("line", {
          x1: "73.6",
          y1: "118.1",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DKs),
        e("line", {
          x1: "85.2",
          y1: "153.9",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RKs),
        e("line", {
          x1: "122.8",
          y1: "153.9",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UKs),
        e("line", {
          x1: "134.4",
          y1: "118.1",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qKs),
        e("line", {
          x1: "200",
          y1: "96",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GKs),
        e("line", {
          x1: "169.6",
          y1: "118.1",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, EKs),
        e("line", {
          x1: "181.2",
          y1: "153.9",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OKs),
        e("line", {
          x1: "218.8",
          y1: "153.9",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IKs),
        e("line", {
          x1: "230.4",
          y1: "118.1",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KKs)
      ])) : o(i) === "thin" ? (s(), r("g", XKs, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, JKs),
        e("line", {
          x1: "104",
          y1: "96",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QKs),
        e("line", {
          x1: "73.6",
          y1: "118.1",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YKs),
        e("line", {
          x1: "85.2",
          y1: "153.9",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oXs),
        e("line", {
          x1: "122.8",
          y1: "153.9",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eXs),
        e("line", {
          x1: "134.4",
          y1: "118.1",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tXs),
        e("line", {
          x1: "200",
          y1: "96",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nXs),
        e("line", {
          x1: "169.6",
          y1: "118.1",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sXs),
        e("line", {
          x1: "181.2",
          y1: "153.9",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rXs),
        e("line", {
          x1: "218.8",
          y1: "153.9",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iXs),
        e("line", {
          x1: "230.4",
          y1: "118.1",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lXs)
      ])) : o(i) === "regular" ? (s(), r("g", dXs, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kXs),
        e("line", {
          x1: "104",
          y1: "96",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cXs),
        e("line", {
          x1: "73.6",
          y1: "118.1",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hXs),
        e("line", {
          x1: "85.2",
          y1: "153.9",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uXs),
        e("line", {
          x1: "122.8",
          y1: "153.9",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aXs),
        e("line", {
          x1: "134.4",
          y1: "118.1",
          x2: "104",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Xs),
        e("line", {
          x1: "200",
          y1: "96",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pXs),
        e("line", {
          x1: "169.6",
          y1: "118.1",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yXs),
        e("line", {
          x1: "181.2",
          y1: "153.9",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Xs),
        e("line", {
          x1: "218.8",
          y1: "153.9",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wXs),
        e("line", {
          x1: "230.4",
          y1: "118.1",
          x2: "200",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fXs)
      ])) : g("", !0)
    ], 16, cKs));
  }
}), xXs = ["width", "height", "fill", "transform"], jXs = { key: 0 }, mXs = ["stroke"], MXs = ["stroke"], vXs = { key: 1 }, SXs = /* @__PURE__ */ e("circle", {
  cx: "200",
  cy: "200",
  r: "24",
  opacity: "0.2"
}, null, -1), HXs = ["stroke"], AXs = ["stroke"], VXs = { key: 2 }, zXs = /* @__PURE__ */ e("path", { d: "M200,168a32.1,32.1,0,0,0-31,24H72a32,32,0,0,1,0-64h96a40,40,0,0,0,0-80H72a8,8,0,0,0,0,16h96a24,24,0,0,1,0,48H72a48,48,0,0,0,0,96h97a32,32,0,1,0,31-40Z" }, null, -1), ZXs = [
  zXs
], CXs = { key: 3 }, bXs = ["stroke"], LXs = ["stroke"], BXs = { key: 4 }, PXs = ["stroke"], WXs = ["stroke"], NXs = { key: 5 }, FXs = ["stroke"], TXs = ["stroke"], DXs = {
  name: "PhPath"
}, PQ1 = /* @__PURE__ */ $({
  ...DXs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", jXs, [
        e("circle", {
          cx: "200",
          cy: "200",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mXs),
        e("path", {
          d: "M72,56h96a32,32,0,0,1,0,64H72a40,40,0,0,0,0,80H176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MXs)
      ])) : o(i) === "duotone" ? (s(), r("g", vXs, [
        SXs,
        e("circle", {
          cx: "200",
          cy: "200",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HXs),
        e("path", {
          d: "M72,56h96a32,32,0,0,1,0,64H72a40,40,0,0,0,0,80H176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AXs)
      ])) : o(i) === "fill" ? (s(), r("g", VXs, ZXs)) : o(i) === "light" ? (s(), r("g", CXs, [
        e("circle", {
          cx: "200",
          cy: "200",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bXs),
        e("path", {
          d: "M72,56h96a32,32,0,0,1,0,64H72a40,40,0,0,0,0,80H176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LXs)
      ])) : o(i) === "thin" ? (s(), r("g", BXs, [
        e("circle", {
          cx: "200",
          cy: "200",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PXs),
        e("path", {
          d: "M72,56h96a32,32,0,0,1,0,64H72a40,40,0,0,0,0,80H176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WXs)
      ])) : o(i) === "regular" ? (s(), r("g", NXs, [
        e("circle", {
          cx: "200",
          cy: "200",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FXs),
        e("path", {
          d: "M72,56h96a32,32,0,0,1,0,64H72a40,40,0,0,0,0,80H176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TXs)
      ])) : g("", !0)
    ], 16, xXs));
  }
}), RXs = ["width", "height", "fill", "transform"], UXs = { key: 0 }, qXs = ["stroke"], GXs = ["stroke"], EXs = { key: 1 }, OXs = /* @__PURE__ */ e("rect", {
  x: "156",
  y: "40",
  width: "52",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), IXs = /* @__PURE__ */ e("rect", {
  x: "48",
  y: "40",
  width: "52",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), KXs = ["stroke"], XXs = ["stroke"], JXs = { key: 2 }, QXs = /* @__PURE__ */ e("path", { d: "M216,48V208a16,16,0,0,1-16,16H164a16,16,0,0,1-16-16V48a16,16,0,0,1,16-16h36A16,16,0,0,1,216,48ZM92,32H56A16,16,0,0,0,40,48V208a16,16,0,0,0,16,16H92a16,16,0,0,0,16-16V48A16,16,0,0,0,92,32Z" }, null, -1), YXs = [
  QXs
], oJs = { key: 3 }, eJs = ["stroke"], tJs = ["stroke"], nJs = { key: 4 }, sJs = ["stroke"], rJs = ["stroke"], iJs = { key: 5 }, lJs = ["stroke"], dJs = ["stroke"], kJs = {
  name: "PhPause"
}, WQ1 = /* @__PURE__ */ $({
  ...kJs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", UXs, [
        e("rect", {
          x: "156",
          y: "40",
          width: "52",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qXs),
        e("rect", {
          x: "48",
          y: "40",
          width: "52",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GXs)
      ])) : o(i) === "duotone" ? (s(), r("g", EXs, [
        OXs,
        IXs,
        e("rect", {
          x: "156",
          y: "40",
          width: "52",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KXs),
        e("rect", {
          x: "48",
          y: "40",
          width: "52",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XXs)
      ])) : o(i) === "fill" ? (s(), r("g", JXs, YXs)) : o(i) === "light" ? (s(), r("g", oJs, [
        e("rect", {
          x: "156",
          y: "40",
          width: "52",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eJs),
        e("rect", {
          x: "48",
          y: "40",
          width: "52",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tJs)
      ])) : o(i) === "thin" ? (s(), r("g", nJs, [
        e("rect", {
          x: "156",
          y: "40",
          width: "52",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sJs),
        e("rect", {
          x: "48",
          y: "40",
          width: "52",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rJs)
      ])) : o(i) === "regular" ? (s(), r("g", iJs, [
        e("rect", {
          x: "156",
          y: "40",
          width: "52",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lJs),
        e("rect", {
          x: "48",
          y: "40",
          width: "52",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dJs)
      ])) : g("", !0)
    ], 16, RXs));
  }
}), cJs = ["width", "height", "fill", "transform"], hJs = { key: 0 }, uJs = ["stroke"], aJs = ["stroke"], _Js = ["stroke"], pJs = { key: 1 }, yJs = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), $Js = ["stroke"], wJs = ["stroke"], fJs = ["stroke"], gJs = { key: 2 }, xJs = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24ZM112,160a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0Z" }, null, -1), jJs = [
  xJs
], mJs = { key: 3 }, MJs = ["stroke"], vJs = ["stroke"], SJs = ["stroke"], HJs = { key: 4 }, AJs = ["stroke"], VJs = ["stroke"], zJs = ["stroke"], ZJs = { key: 5 }, CJs = ["stroke"], bJs = ["stroke"], LJs = ["stroke"], BJs = {
  name: "PhPauseCircle"
}, NQ1 = /* @__PURE__ */ $({
  ...BJs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", hJs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uJs),
        e("line", {
          x1: "104",
          y1: "96",
          x2: "104",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aJs),
        e("line", {
          x1: "152",
          y1: "96",
          x2: "152",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Js)
      ])) : o(i) === "duotone" ? (s(), r("g", pJs, [
        yJs,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, $Js),
        e("line", {
          x1: "104",
          y1: "96",
          x2: "104",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wJs),
        e("line", {
          x1: "152",
          y1: "96",
          x2: "152",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fJs)
      ])) : o(i) === "fill" ? (s(), r("g", gJs, jJs)) : o(i) === "light" ? (s(), r("g", mJs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, MJs),
        e("line", {
          x1: "104",
          y1: "96",
          x2: "104",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vJs),
        e("line", {
          x1: "152",
          y1: "96",
          x2: "152",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, SJs)
      ])) : o(i) === "thin" ? (s(), r("g", HJs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, AJs),
        e("line", {
          x1: "104",
          y1: "96",
          x2: "104",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VJs),
        e("line", {
          x1: "152",
          y1: "96",
          x2: "152",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zJs)
      ])) : o(i) === "regular" ? (s(), r("g", ZJs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, CJs),
        e("line", {
          x1: "104",
          y1: "96",
          x2: "104",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bJs),
        e("line", {
          x1: "152",
          y1: "96",
          x2: "152",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LJs)
      ])) : g("", !0)
    ], 16, cJs));
  }
}), PJs = ["width", "height", "fill", "transform"], WJs = { key: 0 }, NJs = ["stroke"], FJs = /* @__PURE__ */ e("circle", {
  cx: "208",
  cy: "104",
  r: "24"
}, null, -1), TJs = /* @__PURE__ */ e("circle", {
  cx: "48",
  cy: "104",
  r: "24"
}, null, -1), DJs = /* @__PURE__ */ e("circle", {
  cx: "96",
  cy: "56",
  r: "24"
}, null, -1), RJs = /* @__PURE__ */ e("circle", {
  cx: "160",
  cy: "56",
  r: "24"
}, null, -1), UJs = { key: 1 }, qJs = /* @__PURE__ */ j('<circle cx="212" cy="108" r="20" opacity="0.2"></circle><circle cx="44" cy="108" r="20" opacity="0.2"></circle><circle cx="92" cy="60" r="20" opacity="0.2"></circle><circle cx="164" cy="60" r="20" opacity="0.2"></circle><path d="M183.2,155.9a43.6,43.6,0,0,1-20.6-26h0a36,36,0,0,0-69.2,0h0a43.6,43.6,0,0,1-20.6,26A32,32,0,0,0,88,216a32.4,32.4,0,0,0,12.5-2.5,71.8,71.8,0,0,1,55,0A32.4,32.4,0,0,0,168,216a32,32,0,0,0,15.2-60.1Z" opacity="0.2"></path>', 5), GJs = ["stroke"], EJs = ["stroke"], OJs = ["stroke"], IJs = ["stroke"], KJs = ["stroke"], XJs = { key: 2 }, JJs = /* @__PURE__ */ e("path", { d: "M240,108a28,28,0,1,1-28-28A28.1,28.1,0,0,1,240,108ZM72,108a28,28,0,1,0-28,28A28.1,28.1,0,0,0,72,108ZM92,88A28,28,0,1,0,64,60,28.1,28.1,0,0,0,92,88Zm72,0a28,28,0,1,0-28-28A28.1,28.1,0,0,0,164,88Zm23.1,60.8a35.3,35.3,0,0,1-16.9-21.1,43.9,43.9,0,0,0-84.4,0A35.5,35.5,0,0,1,69,148.8,40,40,0,0,0,88,224a40.5,40.5,0,0,0,15.5-3.1,64.2,64.2,0,0,1,48.9-.1A39.6,39.6,0,0,0,168,224a40,40,0,0,0,19.1-75.2Z" }, null, -1), QJs = [
  JJs
], YJs = { key: 3 }, oQs = ["stroke"], eQs = ["stroke"], tQs = ["stroke"], nQs = ["stroke"], sQs = ["stroke"], rQs = { key: 4 }, iQs = ["stroke"], lQs = ["stroke"], dQs = ["stroke"], kQs = ["stroke"], cQs = ["stroke"], hQs = { key: 5 }, uQs = ["stroke"], aQs = ["stroke"], _Qs = ["stroke"], pQs = ["stroke"], yQs = ["stroke"], $Qs = {
  name: "PhPawPrint"
}, FQ1 = /* @__PURE__ */ $({
  ...$Qs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", WJs, [
        e("path", {
          d: "M183.2,155.9a43.6,43.6,0,0,1-20.6-26h0a36,36,0,0,0-69.2,0h0a43.6,43.6,0,0,1-20.6,26A32,32,0,0,0,88,216a32.4,32.4,0,0,0,12.5-2.5,71.8,71.8,0,0,1,55,0A32.4,32.4,0,0,0,168,216a32,32,0,0,0,15.2-60.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NJs),
        FJs,
        TJs,
        DJs,
        RJs
      ])) : o(i) === "duotone" ? (s(), r("g", UJs, [
        qJs,
        e("circle", {
          cx: "212",
          cy: "108",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GJs),
        e("circle", {
          cx: "44",
          cy: "108",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EJs),
        e("circle", {
          cx: "92",
          cy: "60",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OJs),
        e("circle", {
          cx: "164",
          cy: "60",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IJs),
        e("path", {
          d: "M183.2,155.9a43.6,43.6,0,0,1-20.6-26h0a36,36,0,0,0-69.2,0h0a43.6,43.6,0,0,1-20.6,26A32,32,0,0,0,88,216a32.4,32.4,0,0,0,12.5-2.5,71.8,71.8,0,0,1,55,0A32.4,32.4,0,0,0,168,216a32,32,0,0,0,15.2-60.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KJs)
      ])) : o(i) === "fill" ? (s(), r("g", XJs, QJs)) : o(i) === "light" ? (s(), r("g", YJs, [
        e("circle", {
          cx: "212",
          cy: "108",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oQs),
        e("circle", {
          cx: "44",
          cy: "108",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eQs),
        e("circle", {
          cx: "92",
          cy: "60",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tQs),
        e("circle", {
          cx: "164",
          cy: "60",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nQs),
        e("path", {
          d: "M183.2,155.9a43.6,43.6,0,0,1-20.6-26h0a36,36,0,0,0-69.2,0h0a43.6,43.6,0,0,1-20.6,26A32,32,0,0,0,88,216a32.4,32.4,0,0,0,12.5-2.5,71.8,71.8,0,0,1,55,0A32.4,32.4,0,0,0,168,216a32,32,0,0,0,15.2-60.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sQs)
      ])) : o(i) === "thin" ? (s(), r("g", rQs, [
        e("circle", {
          cx: "212",
          cy: "108",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iQs),
        e("circle", {
          cx: "44",
          cy: "108",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lQs),
        e("circle", {
          cx: "92",
          cy: "60",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dQs),
        e("circle", {
          cx: "164",
          cy: "60",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kQs),
        e("path", {
          d: "M183.2,155.9a43.6,43.6,0,0,1-20.6-26h0a36,36,0,0,0-69.2,0h0a43.6,43.6,0,0,1-20.6,26A32,32,0,0,0,88,216a32.4,32.4,0,0,0,12.5-2.5,71.8,71.8,0,0,1,55,0A32.4,32.4,0,0,0,168,216a32,32,0,0,0,15.2-60.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cQs)
      ])) : o(i) === "regular" ? (s(), r("g", hQs, [
        e("circle", {
          cx: "212",
          cy: "108",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uQs),
        e("circle", {
          cx: "44",
          cy: "108",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aQs),
        e("circle", {
          cx: "92",
          cy: "60",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Qs),
        e("circle", {
          cx: "164",
          cy: "60",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pQs),
        e("path", {
          d: "M183.2,155.9a43.6,43.6,0,0,1-20.6-26h0a36,36,0,0,0-69.2,0h0a43.6,43.6,0,0,1-20.6,26A32,32,0,0,0,88,216a32.4,32.4,0,0,0,12.5-2.5,71.8,71.8,0,0,1,55,0A32.4,32.4,0,0,0,168,216a32,32,0,0,0,15.2-60.1Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yQs)
      ])) : g("", !0)
    ], 16, PJs));
  }
}), wQs = ["width", "height", "fill", "transform"], fQs = { key: 0 }, gQs = ["stroke"], xQs = ["stroke"], jQs = ["stroke"], mQs = ["stroke"], MQs = ["stroke"], vQs = { key: 1 }, SQs = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), HQs = ["stroke"], AQs = ["stroke"], VQs = ["stroke"], zQs = ["stroke"], ZQs = ["stroke"], CQs = { key: 2 }, bQs = /* @__PURE__ */ e("path", { d: "M213.6,186.9A102.9,102.9,0,0,0,232,128a104,104,0,0,0-208,0,102.9,102.9,0,0,0,18.4,58.9l.4.8.4.4a103.9,103.9,0,0,0,169.6,0l.4-.4A3,3,0,0,0,213.6,186.9ZM216,128a87.5,87.5,0,0,1-11.6,43.7L136,123.8V40.4A88.1,88.1,0,0,1,216,128ZM120,40.4v83.4L51.6,171.7A88,88,0,0,1,120,40.4ZM60.8,184.8,120,143.4v72.2A87.9,87.9,0,0,1,60.8,184.8ZM136,215.6V143.4l59.2,41.4A87.9,87.9,0,0,1,136,215.6Z" }, null, -1), LQs = [
  bQs
], BQs = { key: 3 }, PQs = ["stroke"], WQs = ["stroke"], NQs = ["stroke"], FQs = ["stroke"], TQs = ["stroke"], DQs = { key: 4 }, RQs = ["stroke"], UQs = ["stroke"], qQs = ["stroke"], GQs = ["stroke"], EQs = ["stroke"], OQs = { key: 5 }, IQs = ["stroke"], KQs = ["stroke"], XQs = ["stroke"], JQs = ["stroke"], QQs = ["stroke"], YQs = {
  name: "PhPeace"
}, TQ1 = /* @__PURE__ */ $({
  ...YQs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", fQs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gQs),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xQs),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "206.6",
          y2: "183.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jQs),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "49.4",
          y2: "183.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mQs),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MQs)
      ])) : o(i) === "duotone" ? (s(), r("g", vQs, [
        SQs,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HQs),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AQs),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "206.6",
          y2: "183.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VQs),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "49.4",
          y2: "183.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zQs),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZQs)
      ])) : o(i) === "fill" ? (s(), r("g", CQs, LQs)) : o(i) === "light" ? (s(), r("g", BQs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PQs),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WQs),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "206.6",
          y2: "183.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, NQs),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "49.4",
          y2: "183.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FQs),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TQs)
      ])) : o(i) === "thin" ? (s(), r("g", DQs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RQs),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, UQs),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "206.6",
          y2: "183.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qQs),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "49.4",
          y2: "183.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GQs),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, EQs)
      ])) : o(i) === "regular" ? (s(), r("g", OQs, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IQs),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KQs),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "206.6",
          y2: "183.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XQs),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "49.4",
          y2: "183.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JQs),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QQs)
      ])) : g("", !0)
    ], 16, wQs));
  }
}), oYs = ["width", "height", "fill", "transform"], eYs = { key: 0 }, tYs = ["stroke"], nYs = ["stroke"], sYs = ["stroke"], rYs = ["stroke"], iYs = { key: 1 }, lYs = /* @__PURE__ */ e("path", {
  d: "M192,120,136,64l26.3-26.3a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
  opacity: "0.2"
}, null, -1), dYs = ["stroke"], kYs = ["stroke"], cYs = ["stroke"], hYs = ["stroke"], uYs = { key: 2 }, aYs = /* @__PURE__ */ e("path", { d: "M228.7,88A15.9,15.9,0,0,0,224,76.7L179.3,32a16.1,16.1,0,0,0-22.6,0L36.7,152a16,16,0,0,0-3.6,5.4l-.3.8a17,17,0,0,0-.8,5.1V208a16,16,0,0,0,16,16H92.7a14.4,14.4,0,0,0,5.1-.9l.8-.2a16,16,0,0,0,5.4-3.6l83.7-83.7,3.4,13.9-36.8,36.8a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0l40-40a8.5,8.5,0,0,0,2.1-7.6l-6.9-27.6L224,99.3A15.9,15.9,0,0,0,228.7,88ZM192,108.7,147.3,64,168,43.3,212.7,88Z" }, null, -1), _Ys = [
  aYs
], pYs = { key: 3 }, yYs = ["stroke"], $Ys = ["stroke"], wYs = ["stroke"], fYs = ["stroke"], gYs = { key: 4 }, xYs = ["stroke"], jYs = ["stroke"], mYs = ["stroke"], MYs = ["stroke"], vYs = { key: 5 }, SYs = ["stroke"], HYs = ["stroke"], AYs = ["stroke"], VYs = ["stroke"], zYs = {
  name: "PhPen"
}, DQ1 = /* @__PURE__ */ $({
  ...zYs,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", eYs, [
        e("path", {
          d: "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tYs),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nYs),
        e("polyline", {
          points: "164 200 204 160 192 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sYs),
        e("line", {
          x1: "44",
          y1: "156",
          x2: "100",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rYs)
      ])) : o(i) === "duotone" ? (s(), r("g", iYs, [
        lYs,
        e("path", {
          d: "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dYs),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kYs),
        e("polyline", {
          points: "160 192 200 152 192 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cYs),
        e("line", {
          x1: "40.5",
          y1: "160.5",
          x2: "95.5",
          y2: "215.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hYs)
      ])) : o(i) === "fill" ? (s(), r("g", uYs, _Ys)) : o(i) === "light" ? (s(), r("g", pYs, [
        e("path", {
          d: "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yYs),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $Ys),
        e("polyline", {
          points: "160 192 200 152 192 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wYs),
        e("line", {
          x1: "40.5",
          y1: "160.5",
          x2: "95.5",
          y2: "215.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fYs)
      ])) : o(i) === "thin" ? (s(), r("g", gYs, [
        e("path", {
          d: "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xYs),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jYs),
        e("polyline", {
          points: "160 192 200 152 192 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mYs),
        e("line", {
          x1: "40.5",
          y1: "160.5",
          x2: "95.5",
          y2: "215.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MYs)
      ])) : o(i) === "regular" ? (s(), r("g", vYs, [
        e("path", {
          d: "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SYs),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HYs),
        e("polyline", {
          points: "160 192 200 152 192 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AYs),
        e("line", {
          x1: "40.5",
          y1: "160.5",
          x2: "95.5",
          y2: "215.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VYs)
      ])) : g("", !0)
    ], 16, oYs));
  }
}), ZYs = ["width", "height", "fill", "transform"], CYs = { key: 0 }, bYs = ["stroke"], LYs = ["stroke"], BYs = ["stroke"], PYs = ["stroke"], WYs = { key: 1 }, NYs = /* @__PURE__ */ e("path", {
  d: "M120,56,60.3,78.4a8.1,8.1,0,0,0-5.1,6.2L32,224l139.5-23.2a7.9,7.9,0,0,0,6.1-5.1L200,136Zm-4,104a20,20,0,1,1,20-20A20.1,20.1,0,0,1,116,160Z",
  opacity: "0.2"
}, null, -1), FYs = ["stroke"], TYs = ["stroke"], DYs = ["stroke"], RYs = ["stroke"], UYs = { key: 2 }, qYs = /* @__PURE__ */ e("path", { d: "M232,92.7,163.3,24a16.1,16.1,0,0,0-22.6,0L115.6,49.1,57.5,70.9A15.9,15.9,0,0,0,47.4,83.2L26.6,207.8a4,4,0,0,0,6.8,3.5l55-55.1A31.7,31.7,0,0,1,84,140a32,32,0,1,1,32,32,31.7,31.7,0,0,1-16.2-4.4l-55.1,55a4,4,0,0,0,3.5,6.8l124.6-20.7a16.2,16.2,0,0,0,12.3-10.2l21.8-58.1L232,115.3a15.9,15.9,0,0,0,0-22.6Zm-32,32L131.3,56,152,35.3,220.7,104Z" }, null, -1), GYs = /* @__PURE__ */ e("circle", {
  cx: "116",
  cy: "140",
  r: "16"
}, null, -1), EYs = [
  qYs,
  GYs
], OYs = { key: 3 }, IYs = ["stroke"], KYs = ["stroke"], XYs = ["stroke"], JYs = ["stroke"], QYs = { key: 4 }, YYs = ["stroke"], oor = ["stroke"], eor = ["stroke"], tor = ["stroke"], nor = { key: 5 }, sor = ["stroke"], ror = ["stroke"], ior = ["stroke"], lor = ["stroke"], dor = {
  name: "PhPenNib"
}, RQ1 = /* @__PURE__ */ $({
  ...dor,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", CYs, [
        e("circle", {
          cx: "116",
          cy: "140",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bYs),
        e("path", {
          d: "M32,224l139.5-23.2a7.9,7.9,0,0,0,6.1-5.1L200,136,120,56,60.3,78.4a8.1,8.1,0,0,0-5.1,6.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LYs),
        e("path", {
          d: "M200,136l26.3-26.3a8,8,0,0,0,0-11.4L157.7,29.7a8,8,0,0,0-11.4,0L120,56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BYs),
        e("line", {
          x1: "32",
          y1: "224",
          x2: "99",
          y2: "157",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PYs)
      ])) : o(i) === "duotone" ? (s(), r("g", WYs, [
        NYs,
        e("circle", {
          cx: "116",
          cy: "140",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FYs),
        e("line", {
          x1: "32",
          y1: "224",
          x2: "101.9",
          y2: "154.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TYs),
        e("path", {
          d: "M32,224l139.5-23.2a7.9,7.9,0,0,0,6.1-5.1L200,136,120,56,60.3,78.4a8.1,8.1,0,0,0-5.1,6.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DYs),
        e("path", {
          d: "M200,136l26.3-26.3a8,8,0,0,0,0-11.4L157.7,29.7a8,8,0,0,0-11.4,0L120,56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RYs)
      ])) : o(i) === "fill" ? (s(), r("g", UYs, EYs)) : o(i) === "light" ? (s(), r("g", OYs, [
        e("circle", {
          cx: "116",
          cy: "140",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IYs),
        e("line", {
          x1: "32",
          y1: "224",
          x2: "101.9",
          y2: "154.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KYs),
        e("path", {
          d: "M32,224l139.5-23.2a7.9,7.9,0,0,0,6.1-5.1L200,136,120,56,60.3,78.4a8.1,8.1,0,0,0-5.1,6.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XYs),
        e("path", {
          d: "M200,136l26.3-26.3a8,8,0,0,0,0-11.4L157.7,29.7a8,8,0,0,0-11.4,0L120,56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JYs)
      ])) : o(i) === "thin" ? (s(), r("g", QYs, [
        e("circle", {
          cx: "116",
          cy: "140",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YYs),
        e("line", {
          x1: "32",
          y1: "224",
          x2: "101.9",
          y2: "154.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oor),
        e("path", {
          d: "M32,224l139.5-23.2a7.9,7.9,0,0,0,6.1-5.1L200,136,120,56,60.3,78.4a8.1,8.1,0,0,0-5.1,6.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eor),
        e("path", {
          d: "M200,136l26.3-26.3a8,8,0,0,0,0-11.4L157.7,29.7a8,8,0,0,0-11.4,0L120,56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tor)
      ])) : o(i) === "regular" ? (s(), r("g", nor, [
        e("circle", {
          cx: "116",
          cy: "140",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sor),
        e("line", {
          x1: "32",
          y1: "224",
          x2: "101.9",
          y2: "154.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ror),
        e("path", {
          d: "M32,224l139.5-23.2a7.9,7.9,0,0,0,6.1-5.1L200,136,120,56,60.3,78.4a8.1,8.1,0,0,0-5.1,6.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ior),
        e("path", {
          d: "M200,136l26.3-26.3a8,8,0,0,0,0-11.4L157.7,29.7a8,8,0,0,0-11.4,0L120,56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lor)
      ])) : g("", !0)
    ], 16, ZYs));
  }
}), kor = ["width", "height", "fill", "transform"], cor = { key: 0 }, hor = ["stroke"], uor = ["stroke"], aor = ["stroke"], _or = ["stroke"], por = { key: 1 }, yor = /* @__PURE__ */ e("path", {
  d: "M211.4,127.4,184,72H72L44.6,127.4a8.2,8.2,0,0,0,.7,8.3L128,248l82.7-112.3A8.2,8.2,0,0,0,211.4,127.4ZM128,152a20,20,0,1,1,20-20A20.1,20.1,0,0,1,128,152Z",
  opacity: "0.2"
}, null, -1), $or = ["stroke"], wor = ["stroke"], gor = ["stroke"], xor = ["stroke"], jor = { key: 2 }, mor = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "132",
  r: "16"
}, null, -1), Mor = /* @__PURE__ */ e("path", { d: "M218.6,123.9,192,70.1V32a16,16,0,0,0-16-16H80A16,16,0,0,0,64,32V70.1L37.4,123.9a16.1,16.1,0,0,0,1.5,16.6l73.9,100.3a4,4,0,0,0,7.2-2.4V163a32,32,0,1,1,16,0v75.4a4,4,0,0,0,7.2,2.4l73.9-100.3A16.1,16.1,0,0,0,218.6,123.9ZM176,64H80V32h96Z" }, null, -1), vor = [
  mor,
  Mor
], Sor = { key: 3 }, Hor = ["stroke"], Aor = ["stroke"], Vor = ["stroke"], zor = ["stroke"], Zor = { key: 4 }, Cor = ["stroke"], bor = ["stroke"], Lor = ["stroke"], Bor = ["stroke"], Por = { key: 5 }, Wor = ["stroke"], Nor = ["stroke"], For = ["stroke"], Tor = ["stroke"], Dor = {
  name: "PhPenNibStraight"
}, UQ1 = /* @__PURE__ */ $({
  ...Dor,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", cor, [
        e("line", {
          x1: "128",
          y1: "156",
          x2: "128",
          y2: "244",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hor),
        e("circle", {
          cx: "128",
          cy: "132",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uor),
        e("path", {
          d: "M72,72V32a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aor),
        e("polygon", {
          points: "72 72 42.5 131.8 128 244 213.5 131.8 184 72 72 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _or)
      ])) : o(i) === "duotone" ? (s(), r("g", por, [
        yor,
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "248",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $or),
        e("circle", {
          cx: "128",
          cy: "132",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wor),
        e("path", {
          d: "M72,72V32a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gor),
        e("path", {
          d: "M72,72,44.6,127.4a8.2,8.2,0,0,0,.7,8.3L128,248l82.7-112.3a8.2,8.2,0,0,0,.7-8.3L184,72Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xor)
      ])) : o(i) === "fill" ? (s(), r("g", jor, vor)) : o(i) === "light" ? (s(), r("g", Sor, [
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "248",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hor),
        e("circle", {
          cx: "128",
          cy: "132",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Aor),
        e("path", {
          d: "M72,72V32a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vor),
        e("path", {
          d: "M72,72,44.6,127.4a8.2,8.2,0,0,0,.7,8.3L128,248l82.7-112.3a8.2,8.2,0,0,0,.7-8.3L184,72Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zor)
      ])) : o(i) === "thin" ? (s(), r("g", Zor, [
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "248",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cor),
        e("circle", {
          cx: "128",
          cy: "132",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bor),
        e("path", {
          d: "M72,72V32a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lor),
        e("path", {
          d: "M72,72,44.6,127.4a8.2,8.2,0,0,0,.7,8.3L128,248l82.7-112.3a8.2,8.2,0,0,0,.7-8.3L184,72Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bor)
      ])) : o(i) === "regular" ? (s(), r("g", Por, [
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "248",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wor),
        e("circle", {
          cx: "128",
          cy: "132",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nor),
        e("path", {
          d: "M72,72V32a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, For),
        e("path", {
          d: "M72,72,44.6,127.4a8.2,8.2,0,0,0,.7,8.3L128,248l82.7-112.3a8.2,8.2,0,0,0,.7-8.3L184,72Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tor)
      ])) : g("", !0)
    ], 16, kor));
  }
}), Ror = ["width", "height", "fill", "transform"], Uor = { key: 0 }, qor = ["stroke"], Gor = ["stroke"], Eor = ["stroke"], Oor = ["stroke"], Ior = { key: 1 }, Kor = /* @__PURE__ */ e("path", {
  d: "M192,120,136,64l26.3-26.3a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
  opacity: "0.2"
}, null, -1), Xor = ["stroke"], Jor = ["stroke"], Qor = ["stroke"], Yor = ["stroke"], oer = { key: 2 }, eer = /* @__PURE__ */ e("path", { d: "M224,76.7,179.3,32a15.9,15.9,0,0,0-22.6,0L130.3,58.3h0L36.7,152A15.9,15.9,0,0,0,32,163.3V208a16,16,0,0,0,16,16H92.7a15.9,15.9,0,0,0,11.3-4.7l120-120A16.1,16.1,0,0,0,224,76.7ZM51.3,160,144,67.3,160.7,84,68,176.7ZM48,179.3,76.7,208H48Zm48,25.4L79.3,188,172,95.3,188.7,112Z" }, null, -1), ter = [
  eer
], ner = { key: 3 }, ser = ["stroke"], rer = ["stroke"], ier = ["stroke"], ler = ["stroke"], der = { key: 4 }, ker = ["stroke"], cer = ["stroke"], her = ["stroke"], uer = ["stroke"], aer = { key: 5 }, _er = ["stroke"], per = ["stroke"], yer = ["stroke"], $er = ["stroke"], wer = {
  name: "PhPencil"
}, qQ1 = /* @__PURE__ */ $({
  ...wer,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Uor, [
        e("line", {
          x1: "44",
          y1: "156",
          x2: "100",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qor),
        e("path", {
          d: "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gor),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Eor),
        e("line", {
          x1: "164",
          y1: "92",
          x2: "72",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Oor)
      ])) : o(i) === "duotone" ? (s(), r("g", Ior, [
        Kor,
        e("path", {
          d: "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xor),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jor),
        e("line", {
          x1: "164",
          y1: "92",
          x2: "68",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qor),
        e("line", {
          x1: "95.5",
          y1: "215.5",
          x2: "40.5",
          y2: "160.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yor)
      ])) : o(i) === "fill" ? (s(), r("g", oer, ter)) : o(i) === "light" ? (s(), r("g", ner, [
        e("path", {
          d: "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ser),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rer),
        e("line", {
          x1: "164",
          y1: "92",
          x2: "68",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ier),
        e("line", {
          x1: "95.5",
          y1: "215.5",
          x2: "40.5",
          y2: "160.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ler)
      ])) : o(i) === "thin" ? (s(), r("g", der, [
        e("path", {
          d: "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ker),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cer),
        e("line", {
          x1: "164",
          y1: "92",
          x2: "68",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, her),
        e("line", {
          x1: "95.5",
          y1: "215.5",
          x2: "40.5",
          y2: "160.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uer)
      ])) : o(i) === "regular" ? (s(), r("g", aer, [
        e("path", {
          d: "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _er),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, per),
        e("line", {
          x1: "164",
          y1: "92",
          x2: "68",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yer),
        e("line", {
          x1: "95.5",
          y1: "215.5",
          x2: "40.5",
          y2: "160.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $er)
      ])) : g("", !0)
    ], 16, Ror));
  }
}), fer = ["width", "height", "fill", "transform"], ger = { key: 0 }, xer = ["stroke"], jer = ["stroke"], mer = ["stroke"], Mer = ["stroke"], ver = ["stroke"], Ser = { key: 1 }, Her = /* @__PURE__ */ e("path", {
  d: "M80,211.2a96,96,0,1,1,96,0h0V176L128,72,80,176v35.2Z",
  opacity: "0.2"
}, null, -1), Aer = ["stroke"], Ver = ["stroke"], zer = ["stroke"], Zer = ["stroke"], Cer = ["stroke"], ber = { key: 2 }, Ler = /* @__PURE__ */ e("path", { d: "M201.5,54.5a103.8,103.8,0,0,0-147,0,103.8,103.8,0,0,0,0,147,103.8,103.8,0,0,0,147,0,103.8,103.8,0,0,0,0-147ZM128,170.9a31.9,31.9,0,0,0-32.3-9.8L111,128h34l15.3,33.1a31.9,31.9,0,0,0-32.3,9.8Zm40,35.5a89,89,0,0,1-32,9.2V192a16,16,0,0,1,32,0Zm22.2-16.2c-2,2-4.1,3.9-6.2,5.7V176a9.8,9.8,0,0,0-.7-3.4l-48-104h-.1a4.1,4.1,0,0,0-.5-.9c0-.1,0-.1-.1-.2l-.5-.7H134a4.6,4.6,0,0,0-.7-.7h-.2l-.7-.6h-.2l-.8-.5h-.1l-.9-.3h-.3l-.9-.2h-2.4l-1,.2h-.2l-.8.3h-.2l-.9.4h-.1l-.7.6h-.2l-.7.7h-.1l-.5.7-.2.2a4.1,4.1,0,0,1-.5.9l-22.1,48h0L72.7,172.6A9.8,9.8,0,0,0,72,176v19.9c-2.1-1.8-4.2-3.7-6.2-5.7a88,88,0,1,1,124.4,0Z" }, null, -1), Ber = [
  Ler
], Per = { key: 3 }, Wer = ["stroke"], Ner = ["stroke"], Fer = ["stroke"], Ter = ["stroke"], Der = ["stroke"], Rer = { key: 4 }, Uer = ["stroke"], qer = ["stroke"], Ger = ["stroke"], Eer = ["stroke"], Oer = ["stroke"], Ier = { key: 5 }, Ker = ["stroke"], Xer = ["stroke"], Jer = ["stroke"], Qer = ["stroke"], Yer = ["stroke"], otr = {
  name: "PhPencilCircle"
}, GQ1 = /* @__PURE__ */ $({
  ...otr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ger, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xer),
        e("polyline", {
          points: "176 211.2 176 176 128 72 80 176 80 211.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jer),
        e("path", {
          d: "M128,200a24,24,0,0,1,48,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mer),
        e("path", {
          d: "M128,224V200a24,24,0,0,0-48,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mer),
        e("line", {
          x1: "98.5",
          y1: "136",
          x2: "157.5",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ver)
      ])) : o(i) === "duotone" ? (s(), r("g", Ser, [
        Her,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Aer),
        e("polyline", {
          points: "176 211.2 176 176 128 72 80 176 80 211.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ver),
        e("path", {
          d: "M128,192a24,24,0,0,1,48,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zer),
        e("path", {
          d: "M128,224V192a24,24,0,0,0-48,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zer),
        e("line", {
          x1: "102.2",
          y1: "128",
          x2: "153.8",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cer)
      ])) : o(i) === "fill" ? (s(), r("g", ber, Ber)) : o(i) === "light" ? (s(), r("g", Per, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wer),
        e("polyline", {
          points: "176 211.2 176 176 128 72 80 176 80 211.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ner),
        e("path", {
          d: "M128,192a24,24,0,0,1,48,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fer),
        e("path", {
          d: "M128,224V192a24,24,0,0,0-48,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ter),
        e("line", {
          x1: "102.2",
          y1: "128",
          x2: "153.8",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Der)
      ])) : o(i) === "thin" ? (s(), r("g", Rer, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Uer),
        e("polyline", {
          points: "176 211.2 176 176 128 72 80 176 80 211.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qer),
        e("path", {
          d: "M128,192a24,24,0,0,1,48,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ger),
        e("path", {
          d: "M128,224V192a24,24,0,0,0-48,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Eer),
        e("line", {
          x1: "102.2",
          y1: "128",
          x2: "153.8",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Oer)
      ])) : o(i) === "regular" ? (s(), r("g", Ier, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ker),
        e("polyline", {
          points: "176 211.2 176 176 128 72 80 176 80 211.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xer),
        e("path", {
          d: "M128,192a24,24,0,0,1,48,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jer),
        e("path", {
          d: "M128,224V192a24,24,0,0,0-48,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qer),
        e("line", {
          x1: "102.2",
          y1: "128",
          x2: "153.8",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yer)
      ])) : g("", !0)
    ], 16, fer));
  }
}), etr = ["width", "height", "fill", "transform"], ttr = { key: 0 }, ntr = ["stroke"], str = ["stroke"], rtr = ["stroke"], itr = ["stroke"], ltr = ["stroke"], dtr = { key: 1 }, ktr = /* @__PURE__ */ e("path", {
  d: "M192,120,136,64l26.3-26.3a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
  opacity: "0.2"
}, null, -1), ctr = ["stroke"], htr = ["stroke"], utr = ["stroke"], atr = ["stroke"], _tr = { key: 2 }, ptr = /* @__PURE__ */ e("path", { d: "M224,76.7,179.3,32a15.9,15.9,0,0,0-22.6,0L36.7,152a15.4,15.4,0,0,0-3.6,5.5l-.2.5a16,16,0,0,0-.9,5.3V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.3L224,99.3A16.1,16.1,0,0,0,224,76.7Zm-80-9.4L160.7,84,68,176.7,51.3,160ZM48,208V179.3L76.7,208Zm48-3.3L79.3,188,172,95.3,188.7,112Z" }, null, -1), ytr = [
  ptr
], $tr = { key: 3 }, wtr = ["stroke"], ftr = ["stroke"], gtr = ["stroke"], xtr = ["stroke"], jtr = { key: 4 }, mtr = ["stroke"], Mtr = ["stroke"], vtr = ["stroke"], Str = ["stroke"], Htr = { key: 5 }, Atr = ["stroke"], Vtr = ["stroke"], ztr = ["stroke"], Ztr = ["stroke"], Ctr = {
  name: "PhPencilLine"
}, EQ1 = /* @__PURE__ */ $({
  ...Ctr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ttr, [
        e("path", {
          d: "M96,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ntr),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, str),
        e("line", {
          x1: "44",
          y1: "156",
          x2: "104",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rtr),
        e("line", {
          x1: "216",
          y1: "216",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, itr),
        e("line", {
          x1: "164",
          y1: "92",
          x2: "72",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ltr)
      ])) : o(i) === "duotone" ? (s(), r("g", dtr, [
        ktr,
        e("path", {
          d: "M96,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ctr),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, htr),
        e("polyline", {
          points: "216 216 96 216 40.5 160.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, utr),
        e("line", {
          x1: "164",
          y1: "92",
          x2: "68",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, atr)
      ])) : o(i) === "fill" ? (s(), r("g", _tr, ytr)) : o(i) === "light" ? (s(), r("g", $tr, [
        e("path", {
          d: "M96,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wtr),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ftr),
        e("polyline", {
          points: "216 216 96 216 40.5 160.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gtr),
        e("line", {
          x1: "164",
          y1: "92",
          x2: "68",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xtr)
      ])) : o(i) === "thin" ? (s(), r("g", jtr, [
        e("path", {
          d: "M96,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mtr),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Mtr),
        e("polyline", {
          points: "216 216 96 216 40.5 160.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vtr),
        e("line", {
          x1: "164",
          y1: "92",
          x2: "68",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Str)
      ])) : o(i) === "regular" ? (s(), r("g", Htr, [
        e("path", {
          d: "M96,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Atr),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vtr),
        e("polyline", {
          points: "216 216 96 216 40.5 160.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ztr),
        e("line", {
          x1: "164",
          y1: "92",
          x2: "68",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ztr)
      ])) : g("", !0)
    ], 16, etr));
  }
}), btr = ["width", "height", "fill", "transform"], Ltr = { key: 0 }, Btr = ["stroke"], Ptr = ["stroke"], Wtr = { key: 1 }, Ntr = /* @__PURE__ */ e("path", {
  d: "M136,64l56,56,26.3-26.3a8,8,0,0,0,0-11.4L173.7,37.7a8,8,0,0,0-11.4,0Z",
  opacity: "0.2"
}, null, -1), Ftr = ["stroke"], Ttr = ["stroke"], Dtr = { key: 2 }, Rtr = /* @__PURE__ */ e("path", { d: "M224,76.7,179.7,32.3a16.6,16.6,0,0,0-11.3-5A16,16,0,0,0,156.7,32L130.3,58.3h0L36.7,152A15.9,15.9,0,0,0,32,163.3V208a16,16,0,0,0,16,16H92.7a16.1,16.1,0,0,0,11.3-4.7l120-120A16.1,16.1,0,0,0,224,76.7Zm-32,32L147.3,64,168,43.3,212.7,88Z" }, null, -1), Utr = [
  Rtr
], qtr = { key: 3 }, Gtr = ["stroke"], Etr = ["stroke"], Otr = { key: 4 }, Itr = ["stroke"], Ktr = ["stroke"], Xtr = { key: 5 }, Jtr = ["stroke"], Qtr = ["stroke"], Ytr = {
  name: "PhPencilSimple"
}, OQ1 = /* @__PURE__ */ $({
  ...Ytr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ltr, [
        e("path", {
          d: "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Btr),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ptr)
      ])) : o(i) === "duotone" ? (s(), r("g", Wtr, [
        Ntr,
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ftr),
        e("path", {
          d: "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ttr)
      ])) : o(i) === "fill" ? (s(), r("g", Dtr, Utr)) : o(i) === "light" ? (s(), r("g", qtr, [
        e("path", {
          d: "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gtr),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Etr)
      ])) : o(i) === "thin" ? (s(), r("g", Otr, [
        e("path", {
          d: "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Itr),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ktr)
      ])) : o(i) === "regular" ? (s(), r("g", Xtr, [
        e("path", {
          d: "M92.7,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4l-120,120A7.9,7.9,0,0,1,92.7,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jtr),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qtr)
      ])) : g("", !0)
    ], 16, btr));
  }
}), onr = ["width", "height", "fill", "transform"], enr = { key: 0 }, tnr = ["stroke"], nnr = ["stroke"], snr = ["stroke"], rnr = { key: 1 }, inr = /* @__PURE__ */ e("path", {
  d: "M192,120,136,64l26.3-26.3a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
  opacity: "0.2"
}, null, -1), lnr = ["stroke"], dnr = ["stroke"], knr = ["stroke"], cnr = { key: 2 }, hnr = /* @__PURE__ */ e("path", { d: "M216,208H115.3l82.4-82.3h0L224,99.3a15.9,15.9,0,0,0,0-22.6L179.3,32a16.1,16.1,0,0,0-22.6,0L36.7,152A15.9,15.9,0,0,0,32,163.3V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16ZM48,163.3l96-96L188.7,112l-96,96H48Z" }, null, -1), unr = [
  hnr
], anr = { key: 3 }, _nr = ["stroke"], pnr = ["stroke"], ynr = ["stroke"], $nr = { key: 4 }, wnr = ["stroke"], fnr = ["stroke"], gnr = ["stroke"], xnr = { key: 5 }, jnr = ["stroke"], mnr = ["stroke"], Mnr = ["stroke"], vnr = {
  name: "PhPencilSimpleLine"
}, IQ1 = /* @__PURE__ */ $({
  ...vnr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", enr, [
        e("path", {
          d: "M96,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tnr),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nnr),
        e("line", {
          x1: "216",
          y1: "216",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, snr)
      ])) : o(i) === "duotone" ? (s(), r("g", rnr, [
        inr,
        e("path", {
          d: "M96,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lnr),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dnr),
        e("line", {
          x1: "216",
          y1: "216",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, knr)
      ])) : o(i) === "fill" ? (s(), r("g", cnr, unr)) : o(i) === "light" ? (s(), r("g", anr, [
        e("path", {
          d: "M96,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _nr),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pnr),
        e("line", {
          x1: "216",
          y1: "216",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ynr)
      ])) : o(i) === "thin" ? (s(), r("g", $nr, [
        e("path", {
          d: "M96,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wnr),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fnr),
        e("line", {
          x1: "216",
          y1: "216",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gnr)
      ])) : o(i) === "regular" ? (s(), r("g", xnr, [
        e("path", {
          d: "M96,216H48a8,8,0,0,1-8-8V163.3a7.9,7.9,0,0,1,2.3-5.6l120-120a8,8,0,0,1,11.4,0l44.6,44.6a8,8,0,0,1,0,11.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jnr),
        e("line", {
          x1: "216",
          y1: "216",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mnr),
        e("line", {
          x1: "136",
          y1: "64",
          x2: "192",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mnr)
      ])) : g("", !0)
    ], 16, onr));
  }
}), Snr = ["width", "height", "fill", "transform"], Hnr = { key: 0 }, Anr = ["stroke"], Vnr = ["stroke"], znr = ["stroke"], Znr = { key: 1 }, Cnr = /* @__PURE__ */ e("circle", {
  cx: "76",
  cy: "76",
  r: "28",
  opacity: "0.2"
}, null, -1), bnr = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "180",
  r: "28",
  opacity: "0.2"
}, null, -1), Lnr = ["stroke"], Bnr = ["stroke"], Pnr = ["stroke"], Wnr = { key: 2 }, Nnr = /* @__PURE__ */ e("path", { d: "M205.7,61.7l-144,144a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4l144-144a8.1,8.1,0,0,1,11.4,11.4ZM50.5,101.5a36.2,36.2,0,0,1,0-51,36.2,36.2,0,0,1,51,0,36.1,36.1,0,0,1-51,51ZM56,76a19.7,19.7,0,0,0,5.9,14.1,19.9,19.9,0,0,0,28.2,0,19.8,19.8,0,0,0,0-28.2h0a19.8,19.8,0,0,0-28.2,0A19.7,19.7,0,0,0,56,76ZM216,180a36,36,0,1,1-61.5-25.5,36.2,36.2,0,0,1,51,0A35.9,35.9,0,0,1,216,180Zm-16,0a19.7,19.7,0,0,0-5.9-14.1,19.8,19.8,0,0,0-28.2,0A19.9,19.9,0,1,0,200,180Z" }, null, -1), Fnr = [
  Nnr
], Tnr = { key: 3 }, Dnr = ["stroke"], Rnr = ["stroke"], Unr = ["stroke"], qnr = { key: 4 }, Gnr = ["stroke"], Enr = ["stroke"], Onr = ["stroke"], Inr = { key: 5 }, Knr = ["stroke"], Xnr = ["stroke"], Jnr = ["stroke"], Qnr = {
  name: "PhPercent"
}, KQ1 = /* @__PURE__ */ $({
  ...Qnr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Hnr, [
        e("line", {
          x1: "200",
          y1: "56",
          x2: "56",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Anr),
        e("circle", {
          cx: "76",
          cy: "76",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vnr),
        e("circle", {
          cx: "180",
          cy: "180",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, znr)
      ])) : o(i) === "duotone" ? (s(), r("g", Znr, [
        Cnr,
        bnr,
        e("line", {
          x1: "200",
          y1: "56",
          x2: "56",
          y2: "200",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lnr),
        e("circle", {
          cx: "76",
          cy: "76",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Bnr),
        e("circle", {
          cx: "180",
          cy: "180",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Pnr)
      ])) : o(i) === "fill" ? (s(), r("g", Wnr, Fnr)) : o(i) === "light" ? (s(), r("g", Tnr, [
        e("line", {
          x1: "200",
          y1: "56",
          x2: "56",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dnr),
        e("circle", {
          cx: "76",
          cy: "76",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rnr),
        e("circle", {
          cx: "180",
          cy: "180",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Unr)
      ])) : o(i) === "thin" ? (s(), r("g", qnr, [
        e("line", {
          x1: "200",
          y1: "56",
          x2: "56",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gnr),
        e("circle", {
          cx: "76",
          cy: "76",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Enr),
        e("circle", {
          cx: "180",
          cy: "180",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Onr)
      ])) : o(i) === "regular" ? (s(), r("g", Inr, [
        e("line", {
          x1: "200",
          y1: "56",
          x2: "56",
          y2: "200",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Knr),
        e("circle", {
          cx: "76",
          cy: "76",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Xnr),
        e("circle", {
          cx: "180",
          cy: "180",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Jnr)
      ])) : g("", !0)
    ], 16, Snr));
  }
}), Ynr = ["width", "height", "fill", "transform"], osr = { key: 0 }, esr = ["stroke"], tsr = ["stroke"], nsr = { key: 1 }, ssr = /* @__PURE__ */ e("circle", {
  cx: "127.9",
  cy: "44",
  r: "28",
  opacity: "0.2"
}, null, -1), rsr = /* @__PURE__ */ e("path", {
  d: "M153.9,134.7l34.8,27a12,12,0,0,0,16.9-16.9L166,93.9A19.9,19.9,0,0,0,151.9,88h-48a20.3,20.3,0,0,0-14.2,5.9L50.1,144.8a12,12,0,0,0,17,16.9l34.8-27L74.1,222.3a12,12,0,0,0,21.8,10.2l32-50.4h0l32,50.4a12,12,0,1,0,21.7-10.2Z",
  opacity: "0.2"
}, null, -1), isr = ["stroke"], lsr = ["stroke"], dsr = { key: 2 }, ksr = /* @__PURE__ */ e("circle", {
  cx: "127.9",
  cy: "44",
  r: "36"
}, null, -1), csr = /* @__PURE__ */ e("path", { d: "M211.7,139.5,172.3,88.9l-.6-.7A27.8,27.8,0,0,0,151.9,80h-48a27.8,27.8,0,0,0-19.8,8.2l-.7.7L44.1,139.5a20,20,0,0,0,28.3,28.3l14.1-11L66.6,219.5a20.2,20.2,0,0,0-.4,14.7,19.9,19.9,0,0,0,10.4,11.3,19.6,19.6,0,0,0,15.2.7,20.2,20.2,0,0,0,11.1-9.8l25-39.4,25,39.4a20.4,20.4,0,0,0,11,9.8,20.9,20.9,0,0,0,6.9,1.2,19.1,19.1,0,0,0,8.4-1.9,20.2,20.2,0,0,0,10.4-11.3,19.7,19.7,0,0,0-.5-14.7l-19.8-62.7,14.1,11a20,20,0,0,0,27.9-.4,19.7,19.7,0,0,0,5.8-14.1A19.9,19.9,0,0,0,211.7,139.5Z" }, null, -1), hsr = [
  ksr,
  csr
], usr = { key: 3 }, asr = ["stroke"], _sr = ["stroke"], psr = { key: 4 }, ysr = ["stroke"], $sr = ["stroke"], wsr = { key: 5 }, fsr = ["stroke"], gsr = ["stroke"], xsr = {
  name: "PhPerson"
}, XQ1 = /* @__PURE__ */ $({
  ...xsr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", osr, [
        e("circle", {
          cx: "127.9",
          cy: "44",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, esr),
        e("path", {
          d: "M153.9,134.7l34.8,27a12,12,0,0,0,16.9-16.9L166,93.9A19.9,19.9,0,0,0,151.9,88h-48a20.3,20.3,0,0,0-14.2,5.9L50.1,144.8a12,12,0,0,0,17,16.9l34.8-27L74.1,222.3a12,12,0,0,0,21.8,10.2l32-50.4h0l32,50.4a12,12,0,1,0,21.7-10.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tsr)
      ])) : o(i) === "duotone" ? (s(), r("g", nsr, [
        ssr,
        rsr,
        e("circle", {
          cx: "127.9",
          cy: "44",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, isr),
        e("path", {
          d: "M153.9,134.7l34.8,27a12,12,0,0,0,16.9-16.9L166,93.9A19.9,19.9,0,0,0,151.9,88h-48a20.3,20.3,0,0,0-14.2,5.9L50.1,144.8a12,12,0,0,0,17,16.9l34.8-27L74.1,222.3a12,12,0,0,0,21.8,10.2l32-50.4h0l32,50.4a12,12,0,1,0,21.7-10.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lsr)
      ])) : o(i) === "fill" ? (s(), r("g", dsr, hsr)) : o(i) === "light" ? (s(), r("g", usr, [
        e("circle", {
          cx: "127.9",
          cy: "44",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, asr),
        e("path", {
          d: "M153.9,134.7l34.8,27a12,12,0,0,0,16.9-16.9L166,93.9A19.9,19.9,0,0,0,151.9,88h-48a20.3,20.3,0,0,0-14.2,5.9L50.1,144.8a12,12,0,0,0,17,16.9l34.8-27L74.1,222.3a12,12,0,0,0,21.8,10.2l32-50.4h0l32,50.4a12,12,0,1,0,21.7-10.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _sr)
      ])) : o(i) === "thin" ? (s(), r("g", psr, [
        e("circle", {
          cx: "127.9",
          cy: "44",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ysr),
        e("path", {
          d: "M153.9,134.7l34.8,27a12,12,0,0,0,16.9-16.9L166,93.9A19.9,19.9,0,0,0,151.9,88h-48a20.3,20.3,0,0,0-14.2,5.9L50.1,144.8a12,12,0,0,0,17,16.9l34.8-27L74.1,222.3a12,12,0,0,0,21.8,10.2l32-50.4h0l32,50.4a12,12,0,1,0,21.7-10.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $sr)
      ])) : o(i) === "regular" ? (s(), r("g", wsr, [
        e("circle", {
          cx: "127.9",
          cy: "44",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fsr),
        e("path", {
          d: "M153.9,134.7l34.8,27a12,12,0,0,0,16.9-16.9L166,93.9A19.9,19.9,0,0,0,151.9,88h-48a20.3,20.3,0,0,0-14.2,5.9L50.1,144.8a12,12,0,0,0,17,16.9l34.8-27L74.1,222.3a12,12,0,0,0,21.8,10.2l32-50.4h0l32,50.4a12,12,0,1,0,21.7-10.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gsr)
      ])) : g("", !0)
    ], 16, Ynr));
  }
}), jsr = ["width", "height", "fill", "transform"], msr = { key: 0 }, Msr = ["stroke"], vsr = ["stroke"], Ssr = ["stroke"], Hsr = ["stroke"], Asr = { key: 1 }, Vsr = /* @__PURE__ */ e("circle", {
  cx: "127.9",
  cy: "48",
  r: "24",
  opacity: "0.2"
}, null, -1), zsr = ["stroke"], Zsr = ["stroke"], Csr = ["stroke"], bsr = ["stroke"], Lsr = { key: 2 }, Bsr = /* @__PURE__ */ e("path", { d: "M95.9,48a32,32,0,1,1,32,32A32,32,0,0,1,95.9,48Zm132.2,73.1C226.4,120.1,185.6,96,128,96S29.6,120.1,27.9,121.1a8,8,0,0,0,8.2,13.8c.4-.3,34.9-20.6,83.9-22.7V149L58,218.7a8,8,0,0,0,12,10.6L128,164l58,65.3a8,8,0,0,0,6,2.7,8.1,8.1,0,0,0,5.3-2,8,8,0,0,0,.7-11.3L136,149V112.2c48.8,2.1,83.5,22.4,83.9,22.7A8.7,8.7,0,0,0,224,136a8,8,0,0,0,4.1-14.9Z" }, null, -1), Psr = [
  Bsr
], Wsr = { key: 3 }, Nsr = ["stroke"], Fsr = ["stroke"], Tsr = ["stroke"], Dsr = ["stroke"], Rsr = { key: 4 }, Usr = ["stroke"], qsr = ["stroke"], Gsr = ["stroke"], Esr = ["stroke"], Osr = { key: 5 }, Isr = ["stroke"], Ksr = ["stroke"], Xsr = ["stroke"], Jsr = ["stroke"], Qsr = {
  name: "PhPersonSimple"
}, JQ1 = /* @__PURE__ */ $({
  ...Qsr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", msr, [
        e("circle", {
          cx: "127.9",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Msr),
        e("line", {
          x1: "128",
          y1: "108",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vsr),
        e("polyline", {
          points: "64 224 128 152 192 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ssr),
        e("path", {
          d: "M32,132s40-24,96-24,96,24,96,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hsr)
      ])) : o(i) === "duotone" ? (s(), r("g", Asr, [
        Vsr,
        e("circle", {
          cx: "127.9",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zsr),
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zsr),
        e("polyline", {
          points: "64 224 128 152 192 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Csr),
        e("path", {
          d: "M32,128s40-24,96-24,96,24,96,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bsr)
      ])) : o(i) === "fill" ? (s(), r("g", Lsr, Psr)) : o(i) === "light" ? (s(), r("g", Wsr, [
        e("circle", {
          cx: "127.9",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Nsr),
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fsr),
        e("polyline", {
          points: "64 224 128 152 192 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Tsr),
        e("path", {
          d: "M32,128s40-24,96-24,96,24,96,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dsr)
      ])) : o(i) === "thin" ? (s(), r("g", Rsr, [
        e("circle", {
          cx: "127.9",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Usr),
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qsr),
        e("polyline", {
          points: "64 224 128 152 192 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gsr),
        e("path", {
          d: "M32,128s40-24,96-24,96,24,96,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Esr)
      ])) : o(i) === "regular" ? (s(), r("g", Osr, [
        e("circle", {
          cx: "127.9",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Isr),
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ksr),
        e("polyline", {
          points: "64 224 128 152 192 224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xsr),
        e("path", {
          d: "M32,128s40-24,96-24,96,24,96,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jsr)
      ])) : g("", !0)
    ], 16, jsr));
  }
}), Ysr = ["width", "height", "fill", "transform"], orr = { key: 0 }, err = ["stroke"], trr = ["stroke"], nrr = ["stroke"], srr = ["stroke"], rrr = { key: 1 }, irr = /* @__PURE__ */ e("circle", {
  cx: "152",
  cy: "56",
  r: "24",
  opacity: "0.2"
}, null, -1), lrr = ["stroke"], drr = ["stroke"], krr = ["stroke"], crr = ["stroke"], hrr = { key: 2 }, urr = /* @__PURE__ */ e("path", { d: "M120,56a32,32,0,1,1,32,32A32.1,32.1,0,0,1,120,56Zm104,77.6a8,8,0,0,0-8-8,7.8,7.8,0,0,0-3.7.9h.1c-.1,0-6.5,3.1-18.2,1.9s-29.5-6.4-53.3-25.1c-15-11.7-38.3-24.6-64.4-19.6C60.7,86.7,51.6,94.8,50.6,95.7a7.9,7.9,0,0,0-.5,11.3,8,8,0,0,0,11.3.5c1.1-1,25.8-22.4,64.6,4.6a147.9,147.9,0,0,1-21.9,44.4h0l-2.4,3.1c-18.9,24.2-42.1,35-68.9,32.3a8,8,0,1,0-1.6,16c3.3.3,6.4.4,9.5.4,32.6,0,56.6-17.4,73.2-38.3,19.4,5.2,54.1,20.2,54.1,61.9a8,8,0,0,0,16,0c0-24.7-10.1-45.4-29.2-59.9-10.4-7.9-22-12.8-31.2-15.8a164.5,164.5,0,0,0,16-34.1c25.8,17.9,46.2,22.3,60,22.3s19.5-3.5,20.1-3.9h0A7.8,7.8,0,0,0,224,133.6Z" }, null, -1), arr = [
  urr
], _rr = { key: 3 }, prr = ["stroke"], yrr = ["stroke"], $rr = ["stroke"], wrr = ["stroke"], frr = { key: 4 }, grr = ["stroke"], xrr = ["stroke"], jrr = ["stroke"], mrr = ["stroke"], Mrr = { key: 5 }, vrr = ["stroke"], Srr = ["stroke"], Hrr = ["stroke"], Arr = ["stroke"], Vrr = {
  name: "PhPersonSimpleRun"
}, QQ1 = /* @__PURE__ */ $({
  ...Vrr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", orr, [
        e("circle", {
          cx: "152",
          cy: "56",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, err),
        e("path", {
          d: "M48,109.6s32-29.6,80,8c50.5,39.4,80,24,80,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, trr),
        e("path", {
          d: "M110.6,161.2C128.5,165,176,180,176,232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nrr),
        e("path", {
          d: "M131.7,120.4C121.8,149.4,91.8,206,32,200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, srr)
      ])) : o(i) === "duotone" ? (s(), r("g", rrr, [
        irr,
        e("circle", {
          cx: "152",
          cy: "56",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lrr),
        e("path", {
          d: "M56,101.6s32-29.6,80,8c50.5,39.4,80,24,80,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, drr),
        e("path", {
          d: "M135.1,108.8C130.7,129.2,101.6,207,32,200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, krr),
        e("path", {
          d: "M110.6,161.2C128.5,165,176,180,176,232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, crr)
      ])) : o(i) === "fill" ? (s(), r("g", hrr, arr)) : o(i) === "light" ? (s(), r("g", _rr, [
        e("circle", {
          cx: "152",
          cy: "56",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, prr),
        e("path", {
          d: "M56,101.6s32-29.6,80,8c50.5,39.4,80,24,80,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yrr),
        e("path", {
          d: "M135.1,108.8C130.7,129.2,101.6,207,32,200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $rr),
        e("path", {
          d: "M110.6,161.2C128.5,165,176,180,176,232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wrr)
      ])) : o(i) === "thin" ? (s(), r("g", frr, [
        e("circle", {
          cx: "152",
          cy: "56",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, grr),
        e("path", {
          d: "M56,101.6s32-29.6,80,8c50.5,39.4,80,24,80,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xrr),
        e("path", {
          d: "M135.1,108.8C130.7,129.2,101.6,207,32,200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jrr),
        e("path", {
          d: "M110.6,161.2C128.5,165,176,180,176,232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mrr)
      ])) : o(i) === "regular" ? (s(), r("g", Mrr, [
        e("circle", {
          cx: "152",
          cy: "56",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vrr),
        e("path", {
          d: "M56,101.6s32-29.6,80,8c50.5,39.4,80,24,80,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Srr),
        e("path", {
          d: "M135.1,108.8C130.7,129.2,101.6,207,32,200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hrr),
        e("path", {
          d: "M110.6,161.2C128.5,165,176,180,176,232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Arr)
      ])) : g("", !0)
    ], 16, Ysr));
  }
}), zrr = ["width", "height", "fill", "transform"], Zrr = { key: 0 }, Crr = ["stroke"], brr = ["stroke"], Lrr = ["stroke"], Brr = ["stroke"], Prr = { key: 1 }, Wrr = /* @__PURE__ */ e("circle", {
  cx: "152",
  cy: "48",
  r: "24",
  opacity: "0.2"
}, null, -1), Nrr = ["stroke"], Frr = ["stroke"], Trr = ["stroke"], Drr = ["stroke"], Rrr = { key: 2 }, Urr = /* @__PURE__ */ e("path", { d: "M120,48a32,32,0,1,1,32,32A32.1,32.1,0,0,1,120,48Zm88,88c-28.5,0-41.7-14.1-55.6-29.1-3.5-3.8-7.2-7.7-11-11.2-37.2-34.4-96.5,24.1-99.1,26.6a8.1,8.1,0,1,0,11.4,11.4,157.3,157.3,0,0,1,30.5-23.2c14.3-8.2,26.3-11.1,35.7-8.8l-17.7,40.7h0L64.7,228.8a7.9,7.9,0,0,0,4.1,10.5,7.1,7.1,0,0,0,3.2.7,7.9,7.9,0,0,0,7.3-4.8l33.6-77.3L144,180.1V232a8,8,0,0,0,16,0V176a7.8,7.8,0,0,0-3.4-6.5l-37.1-26.6,14.1-32.5,7.1,7.4C154.9,133,172.5,152,208,152a8,8,0,0,0,0-16Z" }, null, -1), qrr = [
  Urr
], Grr = { key: 3 }, Err = ["stroke"], Orr = ["stroke"], Irr = ["stroke"], Krr = ["stroke"], Xrr = { key: 4 }, Jrr = ["stroke"], Qrr = ["stroke"], Yrr = ["stroke"], oir = ["stroke"], eir = { key: 5 }, tir = ["stroke"], nir = ["stroke"], sir = ["stroke"], rir = ["stroke"], iir = {
  name: "PhPersonSimpleWalk"
}, YQ1 = /* @__PURE__ */ $({
  ...iir,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Zrr, [
        e("circle", {
          cx: "152",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Crr),
        e("path", {
          d: "M44,132s56-56,88-26.4c17.9,16.5,32,42.4,72,42.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, brr),
        e("polyline", {
          points: "152 232 152 176 109.5 145.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lrr),
        e("line", {
          x1: "128.3",
          y1: "102.6",
          x2: "72",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Brr)
      ])) : o(i) === "duotone" ? (s(), r("g", Prr, [
        Wrr,
        e("circle", {
          cx: "152",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nrr),
        e("path", {
          d: "M48,128s56-56,88-26.4c17.9,16.5,32,42.4,72,42.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Frr),
        e("line", {
          x1: "130.5",
          y1: "97.4",
          x2: "72",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Trr),
        e("polyline", {
          points: "152 232 152 176 109.5 145.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Drr)
      ])) : o(i) === "fill" ? (s(), r("g", Rrr, qrr)) : o(i) === "light" ? (s(), r("g", Grr, [
        e("circle", {
          cx: "152",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Err),
        e("path", {
          d: "M48,128s56-56,88-26.4c17.9,16.5,32,42.4,72,42.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Orr),
        e("line", {
          x1: "130.5",
          y1: "97.4",
          x2: "72",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Irr),
        e("polyline", {
          points: "152 232 152 176 109.5 145.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Krr)
      ])) : o(i) === "thin" ? (s(), r("g", Xrr, [
        e("circle", {
          cx: "152",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jrr),
        e("path", {
          d: "M48,128s56-56,88-26.4c17.9,16.5,32,42.4,72,42.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qrr),
        e("line", {
          x1: "130.5",
          y1: "97.4",
          x2: "72",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Yrr),
        e("polyline", {
          points: "152 232 152 176 109.5 145.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oir)
      ])) : o(i) === "regular" ? (s(), r("g", eir, [
        e("circle", {
          cx: "152",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tir),
        e("path", {
          d: "M48,128s56-56,88-26.4c17.9,16.5,32,42.4,72,42.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nir),
        e("line", {
          x1: "130.5",
          y1: "97.4",
          x2: "72",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sir),
        e("polyline", {
          points: "152 232 152 176 109.5 145.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rir)
      ])) : g("", !0)
    ], 16, zrr));
  }
}), lir = ["width", "height", "fill", "transform"], dir = { key: 0 }, kir = ["stroke"], cir = ["stroke"], hir = { key: 1 }, uir = /* @__PURE__ */ e("path", {
  d: "M206.6,214.3l-160-29.1a8,8,0,0,1-6.6-7.9V78.7a8,8,0,0,1,6.6-7.9l160-29.1a8,8,0,0,1,9.4,7.9V206.4A8,8,0,0,1,206.6,214.3Z",
  opacity: "0.2"
}, null, -1), air = ["stroke"], _ir = ["stroke"], pir = { key: 2 }, yir = /* @__PURE__ */ e("path", { d: "M32,120v16H16a8,8,0,0,1,0-16Zm0,57.3a16,16,0,0,0,13.1,15.8l160,29.1h0l2.9.2a16.5,16.5,0,0,0,10.3-3.7,16.1,16.1,0,0,0,5.7-12.3V136H32ZM240,120H224v16h16a8,8,0,0,0,0-16ZM224,49.6a16.1,16.1,0,0,0-5.7-12.3,16.6,16.6,0,0,0-13.2-3.5L45.1,62.9A16,16,0,0,0,32,78.7V120H224Z" }, null, -1), $ir = [
  yir
], wir = { key: 3 }, fir = ["stroke"], gir = ["stroke"], xir = { key: 4 }, jir = ["stroke"], mir = ["stroke"], Mir = { key: 5 }, vir = ["stroke"], Sir = ["stroke"], Hir = {
  name: "PhPerspective"
}, oY1 = /* @__PURE__ */ $({
  ...Hir,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", dir, [
        e("path", {
          d: "M206.6,214.3l-160-29.1a8,8,0,0,1-6.6-7.9V78.7a8,8,0,0,1,6.6-7.9l160-29.1a8,8,0,0,1,9.4,7.9V206.4A8,8,0,0,1,206.6,214.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kir),
        e("line", {
          x1: "16",
          y1: "128",
          x2: "240",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cir)
      ])) : o(i) === "duotone" ? (s(), r("g", hir, [
        uir,
        e("path", {
          d: "M206.6,214.3l-160-29.1a8,8,0,0,1-6.6-7.9V78.7a8,8,0,0,1,6.6-7.9l160-29.1a8,8,0,0,1,9.4,7.9V206.4A8,8,0,0,1,206.6,214.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, air),
        e("line", {
          x1: "16",
          y1: "128",
          x2: "240",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _ir)
      ])) : o(i) === "fill" ? (s(), r("g", pir, $ir)) : o(i) === "light" ? (s(), r("g", wir, [
        e("path", {
          d: "M206.6,214.3l-160-29.1a8,8,0,0,1-6.6-7.9V78.7a8,8,0,0,1,6.6-7.9l160-29.1a8,8,0,0,1,9.4,7.9V206.4A8,8,0,0,1,206.6,214.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fir),
        e("line", {
          x1: "16",
          y1: "128",
          x2: "240",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gir)
      ])) : o(i) === "thin" ? (s(), r("g", xir, [
        e("path", {
          d: "M206.6,214.3l-160-29.1a8,8,0,0,1-6.6-7.9V78.7a8,8,0,0,1,6.6-7.9l160-29.1a8,8,0,0,1,9.4,7.9V206.4A8,8,0,0,1,206.6,214.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jir),
        e("line", {
          x1: "16",
          y1: "128",
          x2: "240",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mir)
      ])) : o(i) === "regular" ? (s(), r("g", Mir, [
        e("path", {
          d: "M206.6,214.3l-160-29.1a8,8,0,0,1-6.6-7.9V78.7a8,8,0,0,1,6.6-7.9l160-29.1a8,8,0,0,1,9.4,7.9V206.4A8,8,0,0,1,206.6,214.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vir),
        e("line", {
          x1: "16",
          y1: "128",
          x2: "240",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sir)
      ])) : g("", !0)
    ], 16, lir));
  }
}), Air = ["width", "height", "fill", "transform"], Vir = { key: 0 }, zir = ["stroke"], Zir = { key: 1 }, Cir = /* @__PURE__ */ e("path", {
  d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
  opacity: "0.2"
}, null, -1), bir = ["stroke"], Lir = { key: 2 }, Bir = /* @__PURE__ */ e("path", { d: "M222,158.4l-46.9-20a15.6,15.6,0,0,0-15.1,1.3l-25.1,16.7a76.5,76.5,0,0,1-35.2-35h0L116.3,96a15.9,15.9,0,0,0,1.4-15.1L97.6,34a16.3,16.3,0,0,0-16.7-9.6A56.2,56.2,0,0,0,32,80c0,79.4,64.6,144,144,144a56.2,56.2,0,0,0,55.6-48.9A16.3,16.3,0,0,0,222,158.4Z" }, null, -1), Pir = [
  Bir
], Wir = { key: 3 }, Nir = ["stroke"], Fir = { key: 4 }, Tir = ["stroke"], Dir = { key: 5 }, Rir = ["stroke"], Uir = {
  name: "PhPhone"
}, eY1 = /* @__PURE__ */ $({
  ...Uir,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Vir, [
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zir)
      ])) : o(i) === "duotone" ? (s(), r("g", Zir, [
        Cir,
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bir)
      ])) : o(i) === "fill" ? (s(), r("g", Lir, Pir)) : o(i) === "light" ? (s(), r("g", Wir, [
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Nir)
      ])) : o(i) === "thin" ? (s(), r("g", Fir, [
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Tir)
      ])) : o(i) === "regular" ? (s(), r("g", Dir, [
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rir)
      ])) : g("", !0)
    ], 16, Air));
  }
}), qir = ["width", "height", "fill", "transform"], Gir = { key: 0 }, Eir = ["stroke"], Oir = ["stroke"], Iir = ["stroke"], Kir = { key: 1 }, Xir = /* @__PURE__ */ e("path", {
  d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
  opacity: "0.2"
}, null, -1), Jir = ["stroke"], Qir = ["stroke"], Yir = ["stroke"], o1r = { key: 2 }, e1r = /* @__PURE__ */ e("path", { d: "M222,158.4l-46.9-20a15.6,15.6,0,0,0-15.1,1.3l-25.1,16.7a76.5,76.5,0,0,1-35.2-35h0L116.3,96a15.9,15.9,0,0,0,1.4-15.1L97.6,34a16.3,16.3,0,0,0-16.7-9.6A56.2,56.2,0,0,0,32,80c0,79.4,64.6,144,144,144a56.2,56.2,0,0,0,55.6-48.9A16.3,16.3,0,0,0,222,158.4Z" }, null, -1), t1r = /* @__PURE__ */ e("path", { d: "M157.4,47.7a72.6,72.6,0,0,1,50.9,50.9,8,8,0,0,0,7.7,6,7.6,7.6,0,0,0,2.1-.3,7.9,7.9,0,0,0,5.6-9.8,88,88,0,0,0-62.2-62.2,8,8,0,1,0-4.1,15.4Z" }, null, -1), n1r = /* @__PURE__ */ e("path", { d: "M149.1,78.6a40.4,40.4,0,0,1,28.3,28.3,7.9,7.9,0,0,0,7.7,6,6.4,6.4,0,0,0,2-.3,7.9,7.9,0,0,0,5.7-9.8,55.8,55.8,0,0,0-39.6-39.6,8,8,0,1,0-4.1,15.4Z" }, null, -1), s1r = [
  e1r,
  t1r,
  n1r
], r1r = { key: 3 }, i1r = ["stroke"], l1r = ["stroke"], d1r = ["stroke"], k1r = { key: 4 }, c1r = ["stroke"], h1r = ["stroke"], u1r = ["stroke"], a1r = { key: 5 }, _1r = ["stroke"], p1r = ["stroke"], y1r = ["stroke"], $1r = {
  name: "PhPhoneCall"
}, tY1 = /* @__PURE__ */ $({
  ...$1r,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Gir, [
        e("path", {
          d: "M159.4,40A80.1,80.1,0,0,1,216,96.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Eir),
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Oir),
        e("path", {
          d: "M149.2,78A44.1,44.1,0,0,1,178,106.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Iir)
      ])) : o(i) === "duotone" ? (s(), r("g", Kir, [
        Xir,
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jir),
        e("path", {
          d: "M159.4,40A80.1,80.1,0,0,1,216,96.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qir),
        e("path", {
          d: "M151.1,70.9a47.9,47.9,0,0,1,34,34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yir)
      ])) : o(i) === "fill" ? (s(), r("g", o1r, s1r)) : o(i) === "light" ? (s(), r("g", r1r, [
        e("path", {
          d: "M159.4,40A80.1,80.1,0,0,1,216,96.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, i1r),
        e("path", {
          d: "M151.1,70.9a47.9,47.9,0,0,1,34,34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, l1r),
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, d1r)
      ])) : o(i) === "thin" ? (s(), r("g", k1r, [
        e("path", {
          d: "M159.4,40A80.1,80.1,0,0,1,216,96.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, c1r),
        e("path", {
          d: "M151.1,70.9a47.9,47.9,0,0,1,34,34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, h1r),
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, u1r)
      ])) : o(i) === "regular" ? (s(), r("g", a1r, [
        e("path", {
          d: "M159.4,40A80.1,80.1,0,0,1,216,96.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _1r),
        e("path", {
          d: "M151.1,70.9a47.9,47.9,0,0,1,34,34",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p1r),
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y1r)
      ])) : g("", !0)
    ], 16, qir));
  }
}), w1r = ["width", "height", "fill", "transform"], f1r = { key: 0 }, g1r = ["stroke"], x1r = ["stroke"], j1r = { key: 1 }, m1r = /* @__PURE__ */ e("path", {
  d: "M155.4,101.3a83.9,83.9,0,0,0-55.1.1,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,161.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,192.4,0,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-47.3-18.9a8.2,8.2,0,0,1-4.9-5.8l-6.2-29.7A7.9,7.9,0,0,0,155.4,101.3Z",
  opacity: "0.2"
}, null, -1), M1r = ["stroke"], v1r = ["stroke"], S1r = { key: 2 }, H1r = /* @__PURE__ */ e("path", { d: "M229.8,90.2C173.7,34,82.3,34,26.2,90.2a56.1,56.1,0,0,0-4.7,73.9,16.2,16.2,0,0,0,12.6,6.1,17.1,17.1,0,0,0,5.9-1.1l47.4-19a16,16,0,0,0,9.7-11.7l5.9-29.5a76.3,76.3,0,0,1,49.7-.1h0l6.2,29.7a15.9,15.9,0,0,0,9.7,11.6l47.4,19a16.1,16.1,0,0,0,18.5-5A56.1,56.1,0,0,0,229.8,90.2Z" }, null, -1), A1r = /* @__PURE__ */ e("path", { d: "M216,192H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1), V1r = [
  H1r,
  A1r
], z1r = { key: 3 }, Z1r = ["stroke"], C1r = ["stroke"], b1r = { key: 4 }, L1r = ["stroke"], B1r = ["stroke"], P1r = { key: 5 }, W1r = ["stroke"], N1r = ["stroke"], F1r = {
  name: "PhPhoneDisconnect"
}, nY1 = /* @__PURE__ */ $({
  ...F1r,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", f1r, [
        e("path", {
          d: "M155.4,101.3a83.9,83.9,0,0,0-55.1.1,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,161.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,192.4,0,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-47.3-18.9a8.2,8.2,0,0,1-4.9-5.8l-6.2-29.7A7.9,7.9,0,0,0,155.4,101.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g1r),
        e("line", {
          x1: "40",
          y1: "200",
          x2: "216",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, x1r)
      ])) : o(i) === "duotone" ? (s(), r("g", j1r, [
        m1r,
        e("path", {
          d: "M155.4,101.3a83.9,83.9,0,0,0-55.1.1,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,161.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,192.4,0,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-47.3-18.9a8.2,8.2,0,0,1-4.9-5.8l-6.2-29.7A7.9,7.9,0,0,0,155.4,101.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M1r),
        e("line", {
          x1: "40",
          y1: "200",
          x2: "216",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v1r)
      ])) : o(i) === "fill" ? (s(), r("g", S1r, V1r)) : o(i) === "light" ? (s(), r("g", z1r, [
        e("path", {
          d: "M155.4,101.3a83.9,83.9,0,0,0-55.1.1,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,161.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,192.4,0,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-47.3-18.9a8.2,8.2,0,0,1-4.9-5.8l-6.2-29.7A7.9,7.9,0,0,0,155.4,101.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Z1r),
        e("line", {
          x1: "40",
          y1: "200",
          x2: "216",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, C1r)
      ])) : o(i) === "thin" ? (s(), r("g", b1r, [
        e("path", {
          d: "M155.4,101.3a83.9,83.9,0,0,0-55.1.1,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,161.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,192.4,0,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-47.3-18.9a8.2,8.2,0,0,1-4.9-5.8l-6.2-29.7A7.9,7.9,0,0,0,155.4,101.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, L1r),
        e("line", {
          x1: "40",
          y1: "200",
          x2: "216",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, B1r)
      ])) : o(i) === "regular" ? (s(), r("g", P1r, [
        e("path", {
          d: "M155.4,101.3a83.9,83.9,0,0,0-55.1.1,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,161.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,192.4,0,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-47.3-18.9a8.2,8.2,0,0,1-4.9-5.8l-6.2-29.7A7.9,7.9,0,0,0,155.4,101.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W1r),
        e("line", {
          x1: "40",
          y1: "200",
          x2: "216",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N1r)
      ])) : g("", !0)
    ], 16, w1r));
  }
}), T1r = ["width", "height", "fill", "transform"], D1r = { key: 0 }, R1r = ["stroke"], U1r = ["stroke"], q1r = ["stroke"], G1r = { key: 1 }, E1r = /* @__PURE__ */ e("path", {
  d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
  opacity: "0.2"
}, null, -1), O1r = ["stroke"], I1r = ["stroke"], K1r = ["stroke"], X1r = { key: 2 }, J1r = /* @__PURE__ */ e("path", { d: "M222,158.4l-46.9-20a15.6,15.6,0,0,0-15.1,1.3l-25.1,16.7a76.5,76.5,0,0,1-35.2-35h0L116.3,96a15.9,15.9,0,0,0,1.4-15.1L97.6,34a16.3,16.3,0,0,0-16.7-9.6A56.2,56.2,0,0,0,32,80c0,79.4,64.6,144,144,144a56.2,56.2,0,0,0,55.6-48.9A16.3,16.3,0,0,0,222,158.4Z" }, null, -1), Q1r = /* @__PURE__ */ e("path", { d: "M152.1,97.1a.9.9,0,0,0,.1.5v.3a.8.8,0,0,1,.1.4l.2.4c0,.1.1.2.1.4l.2.3c0,.1.1.2.1.4l.2.3.3.3.2.3a.8.8,0,0,0,.2.4c.1.1.3.2.4.4a.3.3,0,0,1,.1.2h.2l.4.4.4.2.3.3.3.2.3.2h.4l.3.2h.4l.4.2H200a8,8,0,0,0,0-16H179.3l34.4-34.3a8.1,8.1,0,0,0-11.4-11.4L168,76.7V56a8,8,0,0,0-16,0V96.8A.4.4,0,0,1,152.1,97.1Z" }, null, -1), Y1r = [
  J1r,
  Q1r
], olr = { key: 3 }, elr = ["stroke"], tlr = ["stroke"], nlr = ["stroke"], slr = { key: 4 }, rlr = ["stroke"], ilr = ["stroke"], llr = ["stroke"], dlr = { key: 5 }, klr = ["stroke"], clr = ["stroke"], hlr = ["stroke"], ulr = {
  name: "PhPhoneIncoming"
}, sY1 = /* @__PURE__ */ $({
  ...ulr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", D1r, [
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, R1r),
        e("polyline", {
          points: "160 56 160 96 200 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, U1r),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, q1r)
      ])) : o(i) === "duotone" ? (s(), r("g", G1r, [
        E1r,
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O1r),
        e("polyline", {
          points: "160 56 160 96 200 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I1r),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K1r)
      ])) : o(i) === "fill" ? (s(), r("g", X1r, Y1r)) : o(i) === "light" ? (s(), r("g", olr, [
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, elr),
        e("polyline", {
          points: "160 56 160 96 200 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tlr),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nlr)
      ])) : o(i) === "thin" ? (s(), r("g", slr, [
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rlr),
        e("polyline", {
          points: "160 56 160 96 200 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ilr),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, llr)
      ])) : o(i) === "regular" ? (s(), r("g", dlr, [
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, klr),
        e("polyline", {
          points: "160 56 160 96 200 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, clr),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hlr)
      ])) : g("", !0)
    ], 16, T1r));
  }
}), alr = ["width", "height", "fill", "transform"], _lr = { key: 0 }, plr = ["stroke"], ylr = ["stroke"], $lr = ["stroke"], wlr = { key: 1 }, flr = /* @__PURE__ */ e("path", {
  d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
  opacity: "0.2"
}, null, -1), glr = ["stroke"], xlr = ["stroke"], jlr = ["stroke"], mlr = { key: 2 }, Mlr = /* @__PURE__ */ e("path", { d: "M231.6,175.1A56.2,56.2,0,0,1,176,224C96.6,224,32,159.4,32,80A56.2,56.2,0,0,1,80.9,24.4,16.3,16.3,0,0,1,97.6,34l20.1,46.9A15.9,15.9,0,0,1,116.3,96L99.7,121.4h0a76.5,76.5,0,0,0,35.2,35L160,139.7a15.6,15.6,0,0,1,15.1-1.3l46.9,20A16.3,16.3,0,0,1,231.6,175.1ZM160,104a8.5,8.5,0,0,0,5.7-2.3L200,67.3V88a8,8,0,0,0,16,0V48a8,8,0,0,0-8-8H168a8,8,0,0,0,0,16h20.7L154.3,90.3a8.1,8.1,0,0,0,0,11.4A8.5,8.5,0,0,0,160,104Z" }, null, -1), vlr = [
  Mlr
], Slr = { key: 3 }, Hlr = ["stroke"], Alr = ["stroke"], Vlr = ["stroke"], zlr = { key: 4 }, Zlr = ["stroke"], Clr = ["stroke"], blr = ["stroke"], Llr = { key: 5 }, Blr = ["stroke"], Plr = ["stroke"], Wlr = ["stroke"], Nlr = {
  name: "PhPhoneOutgoing"
}, rY1 = /* @__PURE__ */ $({
  ...Nlr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", _lr, [
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, plr),
        e("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ylr),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $lr)
      ])) : o(i) === "duotone" ? (s(), r("g", wlr, [
        flr,
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, glr),
        e("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xlr),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jlr)
      ])) : o(i) === "fill" ? (s(), r("g", mlr, vlr)) : o(i) === "light" ? (s(), r("g", Slr, [
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hlr),
        e("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Alr),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vlr)
      ])) : o(i) === "thin" ? (s(), r("g", zlr, [
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zlr),
        e("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Clr),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, blr)
      ])) : o(i) === "regular" ? (s(), r("g", Llr, [
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Blr),
        e("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Plr),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wlr)
      ])) : g("", !0)
    ], 16, alr));
  }
}), Flr = ["width", "height", "fill", "transform"], Tlr = { key: 0 }, Dlr = ["stroke"], Rlr = ["stroke"], Ulr = ["stroke"], qlr = { key: 1 }, Glr = /* @__PURE__ */ e("path", {
  d: "M155.4,117.3a83.9,83.9,0,0,0-55.1.1,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,177.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,192.4,0,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-47.3-18.9a8.2,8.2,0,0,1-4.9-5.8l-6.2-29.7A7.9,7.9,0,0,0,155.4,117.3Z",
  opacity: "0.2"
}, null, -1), Elr = ["stroke"], Olr = ["stroke"], Ilr = ["stroke"], Klr = { key: 2 }, Xlr = /* @__PURE__ */ e("path", { d: "M120.9,108.3h-.1L89.8,74h-.1L53.9,34.6A8,8,0,0,0,42.1,45.4L70,76.1a143.9,143.9,0,0,0-43.8,30.1,56.1,56.1,0,0,0-4.7,73.9,16.2,16.2,0,0,0,12.6,6.1,17.1,17.1,0,0,0,5.9-1.1l47.4-19a16,16,0,0,0,9.7-11.7l5.9-29.5a72.1,72.1,0,0,1,9.1-2.5l90,99A8,8,0,0,0,208,224a8.2,8.2,0,0,0,5.4-2.1,7.9,7.9,0,0,0,.5-11.3Z" }, null, -1), Jlr = /* @__PURE__ */ e("path", { d: "M229.8,106.2a144.4,144.4,0,0,0-109.7-42,8,8,0,0,0-5.5,13.4L209,181.4a7.2,7.2,0,0,0,2.9,2l4.1,1.7a17.1,17.1,0,0,0,5.9,1.1,16.2,16.2,0,0,0,12.6-6.1A56.1,56.1,0,0,0,229.8,106.2Z" }, null, -1), Qlr = [
  Xlr,
  Jlr
], Ylr = { key: 3 }, o2r = ["stroke"], e2r = ["stroke"], t2r = ["stroke"], n2r = { key: 4 }, s2r = ["stroke"], r2r = ["stroke"], i2r = ["stroke"], l2r = { key: 5 }, d2r = ["stroke"], k2r = ["stroke"], c2r = ["stroke"], h2r = {
  name: "PhPhoneSlash"
}, iY1 = /* @__PURE__ */ $({
  ...h2r,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Tlr, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Dlr),
        e("path", {
          d: "M115,113.7a83.3,83.3,0,0,0-14.7,3.7,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,177.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,52-32.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rlr),
        e("path", {
          d: "M131.2,72a136,136,0,0,1,93,39.8,48,48,0,0,1,4,63.3,5.8,5.8,0,0,1-1.8,1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ulr)
      ])) : o(i) === "duotone" ? (s(), r("g", qlr, [
        Glr,
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Elr),
        e("path", {
          d: "M115,113.7a83.3,83.3,0,0,0-14.7,3.7,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,177.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,52-32.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Olr),
        e("path", {
          d: "M120.5,72.2a136.1,136.1,0,0,1,103.7,39.6,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-4-1.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ilr)
      ])) : o(i) === "fill" ? (s(), r("g", Klr, Qlr)) : o(i) === "light" ? (s(), r("g", Ylr, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, o2r),
        e("path", {
          d: "M115,113.7a83.3,83.3,0,0,0-14.7,3.7,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,177.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,52-32.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, e2r),
        e("path", {
          d: "M120.5,72.2a136.1,136.1,0,0,1,103.7,39.6,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-4-1.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, t2r)
      ])) : o(i) === "thin" ? (s(), r("g", n2r, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, s2r),
        e("path", {
          d: "M115,113.7a83.3,83.3,0,0,0-14.7,3.7,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,177.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,52-32.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, r2r),
        e("path", {
          d: "M120.5,72.2a136.1,136.1,0,0,1,103.7,39.6,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-4-1.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, i2r)
      ])) : o(i) === "regular" ? (s(), r("g", l2r, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, d2r),
        e("path", {
          d: "M115,113.7a83.3,83.3,0,0,0-14.7,3.7,8,8,0,0,0-5.2,5.9l-5.8,29.5a8.2,8.2,0,0,1-4.9,5.9L37.1,177.6a7.9,7.9,0,0,1-9.3-2.5,48,48,0,0,1,4-63.3,136.1,136.1,0,0,1,52-32.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k2r),
        e("path", {
          d: "M120.5,72.2a136.1,136.1,0,0,1,103.7,39.6,48,48,0,0,1,4,63.3,7.9,7.9,0,0,1-9.3,2.5l-4-1.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c2r)
      ])) : g("", !0)
    ], 16, Flr));
  }
}), u2r = ["width", "height", "fill", "transform"], a2r = { key: 0 }, _2r = ["stroke"], p2r = ["stroke"], y2r = ["stroke"], $2r = { key: 1 }, w2r = /* @__PURE__ */ e("path", {
  d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
  opacity: "0.2"
}, null, -1), f2r = ["stroke"], g2r = ["stroke"], x2r = ["stroke"], j2r = { key: 2 }, m2r = /* @__PURE__ */ e("path", { d: "M222,158.4l-46.9-20a15.6,15.6,0,0,0-15.1,1.3l-25.1,16.7a76.5,76.5,0,0,1-35.2-35h0L116.3,96a15.9,15.9,0,0,0,1.4-15.1L97.6,34a16.3,16.3,0,0,0-16.7-9.6A56.2,56.2,0,0,0,32,80c0,79.4,64.6,144,144,144a56.2,56.2,0,0,0,55.6-48.9A16.3,16.3,0,0,0,222,158.4Z" }, null, -1), M2r = /* @__PURE__ */ e("path", { d: "M154.3,101.7a8.2,8.2,0,0,0,11.4,0L184,83.3l18.3,18.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4L195.3,72l18.4-18.3a8.1,8.1,0,0,0-11.4-11.4L184,60.7,165.7,42.3a8.1,8.1,0,0,0-11.4,11.4L172.7,72,154.3,90.3A8.1,8.1,0,0,0,154.3,101.7Z" }, null, -1), v2r = [
  m2r,
  M2r
], S2r = { key: 3 }, H2r = ["stroke"], A2r = ["stroke"], V2r = ["stroke"], z2r = { key: 4 }, Z2r = ["stroke"], C2r = ["stroke"], b2r = ["stroke"], L2r = { key: 5 }, B2r = ["stroke"], P2r = ["stroke"], W2r = ["stroke"], N2r = {
  name: "PhPhoneX"
}, lY1 = /* @__PURE__ */ $({
  ...N2r,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", a2r, [
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _2r),
        e("line", {
          x1: "160",
          y1: "48",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, p2r),
        e("line", {
          x1: "208",
          y1: "48",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, y2r)
      ])) : o(i) === "duotone" ? (s(), r("g", $2r, [
        w2r,
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f2r),
        e("line", {
          x1: "160",
          y1: "48",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g2r),
        e("line", {
          x1: "208",
          y1: "48",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, x2r)
      ])) : o(i) === "fill" ? (s(), r("g", j2r, v2r)) : o(i) === "light" ? (s(), r("g", S2r, [
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, H2r),
        e("line", {
          x1: "160",
          y1: "48",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, A2r),
        e("line", {
          x1: "208",
          y1: "48",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, V2r)
      ])) : o(i) === "thin" ? (s(), r("g", z2r, [
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Z2r),
        e("line", {
          x1: "160",
          y1: "48",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, C2r),
        e("line", {
          x1: "208",
          y1: "48",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, b2r)
      ])) : o(i) === "regular" ? (s(), r("g", L2r, [
        e("path", {
          d: "M92.5,124.8a83.6,83.6,0,0,0,39,38.9,8,8,0,0,0,7.9-.6l25-16.7a7.9,7.9,0,0,1,7.6-.7l46.8,20.1a7.9,7.9,0,0,1,4.8,8.3A48,48,0,0,1,176,216,136,136,0,0,1,40,80,48,48,0,0,1,81.9,32.4a7.9,7.9,0,0,1,8.3,4.8l20.1,46.9a8,8,0,0,1-.6,7.5L93,117A8,8,0,0,0,92.5,124.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B2r),
        e("line", {
          x1: "160",
          y1: "48",
          x2: "208",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P2r),
        e("line", {
          x1: "208",
          y1: "48",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W2r)
      ])) : g("", !0)
    ], 16, u2r));
  }
}), F2r = ["width", "height", "fill", "transform"], T2r = { key: 0 }, D2r = ["stroke"], R2r = ["stroke"], U2r = ["stroke"], q2r = ["stroke"], G2r = { key: 1 }, E2r = /* @__PURE__ */ e("polygon", {
  points: "68 32 68 164 134 164 68 32",
  opacity: "0.2"
}, null, -1), O2r = ["stroke"], I2r = ["stroke"], K2r = ["stroke"], X2r = ["stroke"], J2r = /* @__PURE__ */ e("path", {
  d: "M134,164h8a66,66,0,0,0,0-132h-8Z",
  opacity: "0.2"
}, null, -1), Q2r = { key: 2 }, Y2r = /* @__PURE__ */ e("path", { d: "M142,24H68a8,8,0,0,0-8,8V164a74.1,74.1,0,0,0,74,74,8,8,0,0,0,8-8V172a74,74,0,0,0,0-148ZM126,221.5A58.1,58.1,0,0,1,76.6,172H126Zm0-91.4L80.9,40H126ZM142,156V40a58,58,0,0,1,0,116Z" }, null, -1), o0r = [
  Y2r
], e0r = { key: 3 }, t0r = ["stroke"], n0r = ["stroke"], s0r = ["stroke"], r0r = ["stroke"], i0r = { key: 4 }, l0r = ["stroke"], d0r = ["stroke"], k0r = ["stroke"], c0r = ["stroke"], h0r = { key: 5 }, u0r = ["stroke"], a0r = ["stroke"], _0r = ["stroke"], p0r = ["stroke"], y0r = {
  name: "PhPhosphorLogo"
}, dY1 = /* @__PURE__ */ $({
  ...y0r,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", T2r, [
        e("line", {
          x1: "68",
          y1: "32",
          x2: "134",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, D2r),
        e("rect", {
          x: "68",
          y: "32",
          width: "66",
          height: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, R2r),
        e("path", {
          d: "M134,164v66a65.9,65.9,0,0,1-66-66",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, U2r),
        e("path", {
          d: "M134,164h8a66,66,0,0,0,0-132h-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, q2r)
      ])) : o(i) === "duotone" ? (s(), r("g", G2r, [
        E2r,
        e("line", {
          x1: "68",
          y1: "32",
          x2: "134",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O2r),
        e("rect", {
          x: "68",
          y: "32",
          width: "66",
          height: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I2r),
        e("path", {
          d: "M134,164v66a65.9,65.9,0,0,1-66-66",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K2r),
        e("path", {
          d: "M134,164h8a66,66,0,0,0,0-132h-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X2r),
        J2r
      ])) : o(i) === "fill" ? (s(), r("g", Q2r, o0r)) : o(i) === "light" ? (s(), r("g", e0r, [
        e("line", {
          x1: "68",
          y1: "32",
          x2: "134",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, t0r),
        e("rect", {
          x: "68",
          y: "32",
          width: "66",
          height: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, n0r),
        e("path", {
          d: "M134,164v66a65.9,65.9,0,0,1-66-66",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, s0r),
        e("path", {
          d: "M134,164h8a66,66,0,0,0,0-132h-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, r0r)
      ])) : o(i) === "thin" ? (s(), r("g", i0r, [
        e("line", {
          x1: "68",
          y1: "32",
          x2: "134",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, l0r),
        e("rect", {
          x: "68",
          y: "32",
          width: "66",
          height: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, d0r),
        e("path", {
          d: "M134,164v66a65.9,65.9,0,0,1-66-66",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, k0r),
        e("path", {
          d: "M134,164h8a66,66,0,0,0,0-132h-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, c0r)
      ])) : o(i) === "regular" ? (s(), r("g", h0r, [
        e("line", {
          x1: "68",
          y1: "32",
          x2: "134",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u0r),
        e("rect", {
          x: "68",
          y: "32",
          width: "66",
          height: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a0r),
        e("path", {
          d: "M134,164v66a65.9,65.9,0,0,1-66-66",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _0r),
        e("path", {
          d: "M134,164h8a66,66,0,0,0,0-132h-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p0r)
      ])) : g("", !0)
    ], 16, F2r));
  }
}), $0r = ["width", "height", "fill", "transform"], w0r = { key: 0 }, f0r = ["stroke"], g0r = ["stroke"], x0r = ["stroke"], j0r = ["stroke"], m0r = ["stroke"], M0r = { key: 1 }, v0r = ["stroke"], S0r = ["stroke"], H0r = ["stroke"], A0r = ["stroke"], V0r = ["stroke"], z0r = /* @__PURE__ */ e("rect", {
  x: "144",
  y: "40",
  width: "40",
  height: "104",
  opacity: "0.2"
}, null, -1), Z0r = /* @__PURE__ */ e("rect", {
  x: "72",
  y: "40",
  width: "40",
  height: "104",
  opacity: "0.2"
}, null, -1), C0r = { key: 2 }, b0r = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM108,152a8,8,0,0,0,8-8V48h24v96a8,8,0,0,0,8,8h8v56H100V152ZM48,48H68v96a8,8,0,0,0,8,8h8v56H48ZM208,208H172V152h8a8,8,0,0,0,8-8V48h20V208Z" }, null, -1), L0r = [
  b0r
], B0r = { key: 3 }, P0r = ["stroke"], W0r = ["stroke"], N0r = ["stroke"], F0r = ["stroke"], T0r = ["stroke"], D0r = { key: 4 }, R0r = ["stroke"], U0r = ["stroke"], q0r = ["stroke"], G0r = ["stroke"], E0r = ["stroke"], O0r = { key: 5 }, I0r = ["stroke"], K0r = ["stroke"], X0r = ["stroke"], J0r = ["stroke"], Q0r = ["stroke"], Y0r = {
  name: "PhPianoKeys"
}, kY1 = /* @__PURE__ */ $({
  ...Y0r,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", w0r, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f0r),
        e("line", {
          x1: "100",
          y1: "216",
          x2: "100",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g0r),
        e("line", {
          x1: "156",
          y1: "216",
          x2: "156",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, x0r),
        e("polyline", {
          points: "176 40 176 144 128 144 128 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, j0r),
        e("polyline", {
          points: "128 40 128 144 80 144 80 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, m0r)
      ])) : o(i) === "duotone" ? (s(), r("g", M0r, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v0r),
        e("line", {
          x1: "92",
          y1: "216",
          x2: "92",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S0r),
        e("line", {
          x1: "164",
          y1: "216",
          x2: "164",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H0r),
        e("polyline", {
          points: "184 40 184 144 144 144 144 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A0r),
        e("polyline", {
          points: "112 40 112 144 72 144 72 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, V0r),
        z0r,
        Z0r
      ])) : o(i) === "fill" ? (s(), r("g", C0r, L0r)) : o(i) === "light" ? (s(), r("g", B0r, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, P0r),
        e("line", {
          x1: "92",
          y1: "216",
          x2: "92",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, W0r),
        e("line", {
          x1: "164",
          y1: "216",
          x2: "164",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, N0r),
        e("polyline", {
          points: "184 40 184 144 144 144 144 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, F0r),
        e("polyline", {
          points: "112 40 112 144 72 144 72 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, T0r)
      ])) : o(i) === "thin" ? (s(), r("g", D0r, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, R0r),
        e("line", {
          x1: "92",
          y1: "216",
          x2: "92",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, U0r),
        e("line", {
          x1: "164",
          y1: "216",
          x2: "164",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, q0r),
        e("polyline", {
          points: "184 40 184 144 144 144 144 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, G0r),
        e("polyline", {
          points: "112 40 112 144 72 144 72 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, E0r)
      ])) : o(i) === "regular" ? (s(), r("g", O0r, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I0r),
        e("line", {
          x1: "92",
          y1: "216",
          x2: "92",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K0r),
        e("line", {
          x1: "164",
          y1: "216",
          x2: "164",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X0r),
        e("polyline", {
          points: "184 40 184 144 144 144 144 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J0r),
        e("polyline", {
          points: "112 40 112 144 72 144 72 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q0r)
      ])) : g("", !0)
    ], 16, $0r));
  }
}), o8r = ["width", "height", "fill", "transform"], e8r = { key: 0 }, t8r = ["stroke"], n8r = ["stroke"], s8r = { key: 1 }, r8r = /* @__PURE__ */ e("path", {
  d: "M216,56H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8h96V136a8,8,0,0,1,8-8h80V64A8,8,0,0,0,216,56Z",
  opacity: "0.2"
}, null, -1), i8r = ["stroke"], l8r = ["stroke"], d8r = { key: 2 }, k8r = /* @__PURE__ */ e("path", { d: "M216,48H40A16,16,0,0,0,24,64V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V64A16,16,0,0,0,216,48ZM40,64H216v56H144a16,16,0,0,0-16,16v56H40Z" }, null, -1), c8r = [
  k8r
], h8r = { key: 3 }, u8r = ["stroke"], a8r = ["stroke"], _8r = { key: 4 }, p8r = ["stroke"], y8r = ["stroke"], $8r = { key: 5 }, w8r = ["stroke"], f8r = ["stroke"], g8r = {
  name: "PhPictureInPicture"
}, cY1 = /* @__PURE__ */ $({
  ...g8r,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", e8r, [
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, t8r),
        e("path", {
          d: "M136,200V136a8,8,0,0,1,8-8h80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, n8r)
      ])) : o(i) === "duotone" ? (s(), r("g", s8r, [
        r8r,
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, i8r),
        e("path", {
          d: "M136,200V136a8,8,0,0,1,8-8h80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l8r)
      ])) : o(i) === "fill" ? (s(), r("g", d8r, c8r)) : o(i) === "light" ? (s(), r("g", h8r, [
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u8r),
        e("path", {
          d: "M136,200V136a8,8,0,0,1,8-8h80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, a8r)
      ])) : o(i) === "thin" ? (s(), r("g", _8r, [
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, p8r),
        e("path", {
          d: "M136,200V136a8,8,0,0,1,8-8h80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, y8r)
      ])) : o(i) === "regular" ? (s(), r("g", $8r, [
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w8r),
        e("path", {
          d: "M136,200V136a8,8,0,0,1,8-8h80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f8r)
      ])) : g("", !0)
    ], 16, o8r));
  }
}), x8r = ["width", "height", "fill", "transform"], j8r = { key: 0 }, m8r = ["stroke"], M8r = ["stroke"], v8r = ["stroke"], S8r = { key: 1 }, H8r = /* @__PURE__ */ e("path", {
  d: "M112,208a45.2,45.2,0,0,1-64,0h0a45.2,45.2,0,0,1,0-64L96,96l64,64Z",
  opacity: "0.2"
}, null, -1), A8r = ["stroke"], V8r = ["stroke"], z8r = ["stroke"], Z8r = { key: 2 }, C8r = /* @__PURE__ */ e("path", { d: "M213.7,42.3a53.4,53.4,0,0,0-75.4,0l-96,96a53.3,53.3,0,0,0,75.4,75.4l96-96A53.5,53.5,0,0,0,213.7,42.3Zm-11.4,64L160,148.7,107.3,96l42.4-42.3a36.9,36.9,0,0,1,52.6,0A37.1,37.1,0,0,1,202.3,106.3ZM190.2,82.9a7.9,7.9,0,0,1-.2,11.3l-24.4,23.6a7.9,7.9,0,0,1-11.3-.2,7.9,7.9,0,0,1,.2-11.3l24.4-23.6A8,8,0,0,1,190.2,82.9Z" }, null, -1), b8r = [
  C8r
], L8r = { key: 3 }, B8r = ["stroke"], P8r = ["stroke"], W8r = ["stroke"], N8r = { key: 4 }, F8r = ["stroke"], T8r = ["stroke"], D8r = ["stroke"], R8r = { key: 5 }, U8r = ["stroke"], q8r = ["stroke"], G8r = ["stroke"], E8r = {
  name: "PhPill"
}, hY1 = /* @__PURE__ */ $({
  ...E8r,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", j8r, [
        e("rect", {
          x: "14.9",
          y: "82.7",
          width: "226.3",
          height: "90.51",
          rx: "45.3",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, m8r),
        e("line", {
          x1: "96",
          y1: "96",
          x2: "160",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, M8r),
        e("line", {
          x1: "160.1",
          y1: "104.1",
          x2: "176.5",
          y2: "88.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, v8r)
      ])) : o(i) === "duotone" ? (s(), r("g", S8r, [
        H8r,
        e("rect", {
          x: "14.9",
          y: "82.7",
          width: "226.3",
          height: "90.51",
          rx: "45.3",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A8r),
        e("line", {
          x1: "96",
          y1: "96",
          x2: "160",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, V8r),
        e("line", {
          x1: "160.1",
          y1: "112.1",
          x2: "184.5",
          y2: "88.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, z8r)
      ])) : o(i) === "fill" ? (s(), r("g", Z8r, b8r)) : o(i) === "light" ? (s(), r("g", L8r, [
        e("rect", {
          x: "14.9",
          y: "82.7",
          width: "226.3",
          height: "90.51",
          rx: "45.3",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, B8r),
        e("line", {
          x1: "96",
          y1: "96",
          x2: "160",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, P8r),
        e("line", {
          x1: "160.1",
          y1: "112.1",
          x2: "184.5",
          y2: "88.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, W8r)
      ])) : o(i) === "thin" ? (s(), r("g", N8r, [
        e("rect", {
          x: "14.9",
          y: "82.7",
          width: "226.3",
          height: "90.51",
          rx: "45.3",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, F8r),
        e("line", {
          x1: "96",
          y1: "96",
          x2: "160",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, T8r),
        e("line", {
          x1: "160.1",
          y1: "112.1",
          x2: "184.5",
          y2: "88.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, D8r)
      ])) : o(i) === "regular" ? (s(), r("g", R8r, [
        e("rect", {
          x: "14.9",
          y: "82.7",
          width: "226.3",
          height: "90.51",
          rx: "45.3",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U8r),
        e("line", {
          x1: "96",
          y1: "96",
          x2: "160",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q8r),
        e("line", {
          x1: "160.1",
          y1: "112.1",
          x2: "184.5",
          y2: "88.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G8r)
      ])) : g("", !0)
    ], 16, x8r));
  }
}), O8r = ["width", "height", "fill", "transform"], I8r = { key: 0 }, K8r = ["stroke"], X8r = ["stroke"], J8r = { key: 1 }, Q8r = ["stroke"], Y8r = ["stroke"], odr = { key: 2 }, edr = /* @__PURE__ */ e("path", { d: "M232,131.2c-1.7,54.5-45.8,98.9-100.3,100.7a103.7,103.7,0,0,1-28.6-2.9,4.1,4.1,0,0,1-2.9-4.9l8.9-35.4A50.5,50.5,0,0,0,136,196c37,0,66.7-33.5,63.8-73.4-2.6-35.9-32-64.6-68-66.5A72,72,0,0,0,56,128a73.3,73.3,0,0,0,5.2,27,8,8,0,0,0,14.9-6A55.5,55.5,0,0,1,72,128.9a56,56,0,1,1,112-.9c0,28.7-21.5,52-48,52-10.5,0-17.8-3.7-22.8-8l14.6-58.1a8,8,0,1,0-15.6-3.8L85.4,217.5a4,4,0,0,1-5.7,2.6A104,104,0,1,1,232,131.2Z" }, null, -1), tdr = [
  edr
], ndr = { key: 3 }, sdr = ["stroke"], rdr = ["stroke"], idr = { key: 4 }, ldr = ["stroke"], ddr = ["stroke"], kdr = { key: 5 }, cdr = ["stroke"], hdr = ["stroke"], udr = {
  name: "PhPinterestLogo"
}, uY1 = /* @__PURE__ */ $({
  ...udr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", I8r, [
        e("line", {
          x1: "120",
          y1: "88",
          x2: "88",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, K8r),
        e("path", {
          d: "M61.5,156.6A80,80,0,1,1,208,112c0,44.2-32,72-64,72s-41.6-21.1-41.6-21.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X8r)
      ])) : o(i) === "duotone" ? (s(), r("g", J8r, [
        e("line", {
          x1: "120",
          y1: "88",
          x2: "88",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q8r),
        e("path", {
          d: "M61.5,156.6A80,80,0,1,1,208,112c0,44.2-32,72-64,72s-41.6-21.1-41.6-21.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y8r)
      ])) : o(i) === "fill" ? (s(), r("g", odr, tdr)) : o(i) === "light" ? (s(), r("g", ndr, [
        e("line", {
          x1: "120",
          y1: "88",
          x2: "88",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sdr),
        e("path", {
          d: "M61.5,156.6A80,80,0,1,1,208,112c0,44.2-32,72-64,72s-41.6-21.1-41.6-21.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rdr)
      ])) : o(i) === "thin" ? (s(), r("g", idr, [
        e("line", {
          x1: "120",
          y1: "88",
          x2: "88",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ldr),
        e("path", {
          d: "M61.5,156.6A80,80,0,1,1,208,112c0,44.2-32,72-64,72s-41.6-21.1-41.6-21.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ddr)
      ])) : o(i) === "regular" ? (s(), r("g", kdr, [
        e("line", {
          x1: "120",
          y1: "88",
          x2: "88",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cdr),
        e("path", {
          d: "M61.5,156.6A80,80,0,1,1,208,112c0,44.2-32,72-64,72s-41.6-21.1-41.6-21.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hdr)
      ])) : g("", !0)
    ], 16, O8r));
  }
}), adr = ["width", "height", "fill", "transform"], _dr = { key: 0 }, pdr = ["stroke"], ydr = ["stroke"], $dr = ["stroke"], wdr = ["stroke"], fdr = ["stroke"], gdr = { key: 1 }, xdr = /* @__PURE__ */ e("path", {
  d: "M27.1,145.3a52,52,0,0,1,97.7-35.6Z",
  opacity: "0.2"
}, null, -1), jdr = /* @__PURE__ */ e("path", {
  d: "M212.9,94.7a52,52,0,0,1-97.7,35.6Z",
  opacity: "0.2"
}, null, -1), mdr = ["stroke"], Mdr = ["stroke"], vdr = ["stroke"], Sdr = ["stroke"], Hdr = ["stroke"], Adr = { key: 2 }, Vdr = /* @__PURE__ */ e("path", { d: "M229.7,218.3l-48.4-48.4,3.3-1a59.6,59.6,0,0,0,33.9-31.1,60.4,60.4,0,0,0,2-45.9,8.4,8.4,0,0,0-4.2-4.5,7.6,7.6,0,0,0-6.1-.2l-44.4,16.1,1-2A60,60,0,0,0,91.9,19.5a8.4,8.4,0,0,0-4.5,4.2,7.6,7.6,0,0,0-.2,6.1l16.1,44.4-2-1a60,60,0,0,0-81.8,74.9,8.4,8.4,0,0,0,4.2,4.5,7.7,7.7,0,0,0,3.4.7,6.5,6.5,0,0,0,2.7-.5l44.4-16.1-1,2a60,60,0,0,0,54.3,85.4,61.2,61.2,0,0,0,20.6-3.6,8.4,8.4,0,0,0,4.5-4.2,7.6,7.6,0,0,0,.2-6.1l-16.1-44.4,2,1a59.6,59.6,0,0,0,22.4,5.6l57.2,57.3a8.2,8.2,0,0,0,11.4,0A8.1,8.1,0,0,0,229.7,218.3ZM131.1,36a44.2,44.2,0,0,1,3.7,77.9L105.2,32.5A43.8,43.8,0,0,1,131.1,36ZM108.9,204a44.2,44.2,0,0,1-3.7-77.9l29.6,81.4A43.8,43.8,0,0,1,108.9,204Z" }, null, -1), zdr = [
  Vdr
], Zdr = { key: 3 }, Cdr = ["stroke"], bdr = ["stroke"], Ldr = ["stroke"], Bdr = ["stroke"], Pdr = ["stroke"], Wdr = { key: 4 }, Ndr = ["stroke"], Fdr = ["stroke"], Tdr = ["stroke"], Ddr = ["stroke"], Rdr = ["stroke"], Udr = { key: 5 }, qdr = ["stroke"], Gdr = ["stroke"], Edr = ["stroke"], Odr = ["stroke"], Idr = ["stroke"], Kdr = {
  name: "PhPinwheel"
}, aY1 = /* @__PURE__ */ $({
  ...Kdr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", _dr, [
        e("path", {
          d: "M94.7,27.1a52,52,0,0,1,35.6,97.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pdr),
        e("path", {
          d: "M27.1,145.3a52,52,0,0,1,97.7-35.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ydr),
        e("path", {
          d: "M145.3,212.9a52,52,0,0,1-35.6-97.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $dr),
        e("path", {
          d: "M212.9,94.7a52,52,0,0,1-97.7,35.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wdr),
        e("line", {
          x1: "164.5",
          y1: "164.5",
          x2: "224",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fdr)
      ])) : o(i) === "duotone" ? (s(), r("g", gdr, [
        xdr,
        jdr,
        e("path", {
          d: "M94.7,27.1a52,52,0,0,1,35.6,97.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mdr),
        e("path", {
          d: "M27.1,145.3a52,52,0,0,1,97.7-35.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mdr),
        e("path", {
          d: "M145.3,212.9a52,52,0,0,1-35.6-97.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vdr),
        e("path", {
          d: "M212.9,94.7a52,52,0,0,1-97.7,35.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sdr),
        e("line", {
          x1: "164.5",
          y1: "164.5",
          x2: "224",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hdr)
      ])) : o(i) === "fill" ? (s(), r("g", Adr, zdr)) : o(i) === "light" ? (s(), r("g", Zdr, [
        e("path", {
          d: "M94.7,27.1a52,52,0,0,1,35.6,97.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cdr),
        e("path", {
          d: "M27.1,145.3a52,52,0,0,1,97.7-35.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bdr),
        e("path", {
          d: "M145.3,212.9a52,52,0,0,1-35.6-97.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ldr),
        e("path", {
          d: "M212.9,94.7a52,52,0,0,1-97.7,35.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bdr),
        e("line", {
          x1: "164.5",
          y1: "164.5",
          x2: "224",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pdr)
      ])) : o(i) === "thin" ? (s(), r("g", Wdr, [
        e("path", {
          d: "M94.7,27.1a52,52,0,0,1,35.6,97.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ndr),
        e("path", {
          d: "M27.1,145.3a52,52,0,0,1,97.7-35.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fdr),
        e("path", {
          d: "M145.3,212.9a52,52,0,0,1-35.6-97.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Tdr),
        e("path", {
          d: "M212.9,94.7a52,52,0,0,1-97.7,35.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ddr),
        e("line", {
          x1: "164.5",
          y1: "164.5",
          x2: "224",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Rdr)
      ])) : o(i) === "regular" ? (s(), r("g", Udr, [
        e("path", {
          d: "M94.7,27.1a52,52,0,0,1,35.6,97.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qdr),
        e("path", {
          d: "M27.1,145.3a52,52,0,0,1,97.7-35.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gdr),
        e("path", {
          d: "M145.3,212.9a52,52,0,0,1-35.6-97.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Edr),
        e("path", {
          d: "M212.9,94.7a52,52,0,0,1-97.7,35.6Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Odr),
        e("line", {
          x1: "164.5",
          y1: "164.5",
          x2: "224",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Idr)
      ])) : g("", !0)
    ], 16, adr));
  }
}), Xdr = ["width", "height", "fill", "transform"], Jdr = { key: 0 }, Qdr = ["stroke"], Ydr = ["stroke"], okr = ["stroke"], ekr = ["stroke"], tkr = { key: 1 }, nkr = /* @__PURE__ */ e("path", {
  d: "M144,156a28,28,0,0,1,49.1-18.4l26.2-41a144.1,144.1,0,0,0-182.6,0l21.2,33.3A28,28,0,1,1,84,168H82.1l39.2,61.5a7.9,7.9,0,0,0,13.4,0l29.6-46.5A28,28,0,0,1,144,156Z",
  opacity: "0.2"
}, null, -1), skr = ["stroke"], rkr = ["stroke"], ikr = ["stroke"], lkr = ["stroke"], dkr = { key: 2 }, kkr = /* @__PURE__ */ e("path", { d: "M239.3,80a16,16,0,0,0-4.2-21.6,183.9,183.9,0,0,0-214.2,0A16,16,0,0,0,16.7,80h0l97.8,153.7a16,16,0,0,0,27,0l58.4-91.8h.1ZM23.4,75.7ZM128,225.1l-32.5-51A36,36,0,0,0,84,104a35.6,35.6,0,0,0-26,11.1L47.4,98.5a135.8,135.8,0,0,1,161.2,0l-17.3,27.1a36,36,0,0,0-38.6,60.8Z" }, null, -1), ckr = [
  kkr
], hkr = { key: 3 }, ukr = ["stroke"], akr = ["stroke"], _kr = ["stroke"], pkr = ["stroke"], ykr = { key: 4 }, $kr = ["stroke"], wkr = ["stroke"], fkr = ["stroke"], gkr = ["stroke"], xkr = { key: 5 }, jkr = ["stroke"], mkr = ["stroke"], Mkr = ["stroke"], vkr = ["stroke"], Skr = {
  name: "PhPizza"
}, _Y1 = /* @__PURE__ */ $({
  ...Skr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Jdr, [
        e("path", {
          d: "M23.4,75.7a7.9,7.9,0,0,1,2.2-10.8,175.8,175.8,0,0,1,204.8,0,7.9,7.9,0,0,1,2.2,10.8L134.7,229.4a7.9,7.9,0,0,1-13.4,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qdr),
        e("path", {
          d: "M41.1,103.4a135.9,135.9,0,0,1,173.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ydr),
        e("path", {
          d: "M159.4,190.7a28,28,0,1,1,29.1-45.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, okr),
        e("path", {
          d: "M59.7,132.7A28,28,0,0,1,108,152a28.1,28.1,0,0,1-19.1,26.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ekr)
      ])) : o(i) === "duotone" ? (s(), r("g", tkr, [
        nkr,
        e("path", {
          d: "M23.4,75.7a7.9,7.9,0,0,1,2.2-10.8,175.8,175.8,0,0,1,204.8,0,7.9,7.9,0,0,1,2.2,10.8L134.7,229.4a7.9,7.9,0,0,1-13.4,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, skr),
        e("path", {
          d: "M36.7,96.6a144.1,144.1,0,0,1,182.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rkr),
        e("path", {
          d: "M164.3,182.9a28,28,0,1,1,28.8-45.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ikr),
        e("path", {
          d: "M57.9,129.8A28,28,0,1,1,84,168H82.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lkr)
      ])) : o(i) === "fill" ? (s(), r("g", dkr, ckr)) : o(i) === "light" ? (s(), r("g", hkr, [
        e("path", {
          d: "M23.4,75.7a7.9,7.9,0,0,1,2.2-10.8,175.8,175.8,0,0,1,204.8,0,7.9,7.9,0,0,1,2.2,10.8L134.7,229.4a7.9,7.9,0,0,1-13.4,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ukr),
        e("path", {
          d: "M36.7,96.6a144.1,144.1,0,0,1,182.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, akr),
        e("path", {
          d: "M164.3,182.9a28,28,0,1,1,28.8-45.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _kr),
        e("path", {
          d: "M57.9,129.8A28,28,0,1,1,84,168H82.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pkr)
      ])) : o(i) === "thin" ? (s(), r("g", ykr, [
        e("path", {
          d: "M23.4,75.7a7.9,7.9,0,0,1,2.2-10.8,175.8,175.8,0,0,1,204.8,0,7.9,7.9,0,0,1,2.2,10.8L134.7,229.4a7.9,7.9,0,0,1-13.4,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $kr),
        e("path", {
          d: "M36.7,96.6a144.1,144.1,0,0,1,182.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wkr),
        e("path", {
          d: "M164.3,182.9a28,28,0,1,1,28.8-45.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fkr),
        e("path", {
          d: "M57.9,129.8A28,28,0,1,1,84,168H82.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gkr)
      ])) : o(i) === "regular" ? (s(), r("g", xkr, [
        e("path", {
          d: "M23.4,75.7a7.9,7.9,0,0,1,2.2-10.8,175.8,175.8,0,0,1,204.8,0,7.9,7.9,0,0,1,2.2,10.8L134.7,229.4a7.9,7.9,0,0,1-13.4,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jkr),
        e("path", {
          d: "M36.7,96.6a144.1,144.1,0,0,1,182.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mkr),
        e("path", {
          d: "M164.3,182.9a28,28,0,1,1,28.8-45.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mkr),
        e("path", {
          d: "M57.9,129.8A28,28,0,1,1,84,168H82.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vkr)
      ])) : g("", !0)
    ], 16, Xdr));
  }
}), Hkr = ["width", "height", "fill", "transform"], Akr = { key: 0 }, Vkr = ["stroke"], zkr = ["stroke"], Zkr = { key: 1 }, Ckr = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), bkr = ["stroke"], Lkr = ["stroke"], Bkr = ["stroke"], Pkr = { key: 2 }, Wkr = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM187.3,187.3a7.7,7.7,0,0,1-5.6,2.4,8,8,0,0,1-5.7-2.4L68.7,80A8,8,0,1,1,80,68.7L187.3,176A8,8,0,0,1,187.3,187.3Z" }, null, -1), Nkr = [
  Wkr
], Fkr = { key: 3 }, Tkr = ["stroke"], Dkr = ["stroke"], Rkr = { key: 4 }, Ukr = ["stroke"], qkr = ["stroke"], Gkr = { key: 5 }, Ekr = ["stroke"], Okr = ["stroke"], Ikr = {
  name: "PhPlaceholder"
}, pY1 = /* @__PURE__ */ $({
  ...Ikr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Akr, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vkr),
        e("line", {
          x1: "42.3",
          y1: "42.3",
          x2: "213.7",
          y2: "213.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zkr)
      ])) : o(i) === "duotone" ? (s(), r("g", Zkr, [
        Ckr,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bkr),
        e("line", {
          x1: "42.3",
          y1: "42.3",
          x2: "213.7",
          y2: "213.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lkr),
        e("line", {
          x1: "42.3",
          y1: "42.3",
          x2: "213.7",
          y2: "213.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bkr)
      ])) : o(i) === "fill" ? (s(), r("g", Pkr, Nkr)) : o(i) === "light" ? (s(), r("g", Fkr, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Tkr),
        e("line", {
          x1: "42.3",
          y1: "42.3",
          x2: "213.7",
          y2: "213.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dkr)
      ])) : o(i) === "thin" ? (s(), r("g", Rkr, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ukr),
        e("line", {
          x1: "42.3",
          y1: "42.3",
          x2: "213.7",
          y2: "213.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qkr)
      ])) : o(i) === "regular" ? (s(), r("g", Gkr, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ekr),
        e("line", {
          x1: "42.3",
          y1: "42.3",
          x2: "213.7",
          y2: "213.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Okr)
      ])) : g("", !0)
    ], 16, Hkr));
  }
}), Kkr = ["width", "height", "fill", "transform"], Xkr = { key: 0 }, Jkr = ["stroke"], Qkr = ["stroke"], Ykr = { key: 1 }, ocr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "88",
  opacity: "0.2"
}, null, -1), ecr = ["stroke"], tcr = ["stroke"], ncr = { key: 2 }, scr = /* @__PURE__ */ e("path", { d: "M223.3,116a117.3,117.3,0,0,1,.7,12A96,96,0,0,1,70,204.5c24.6-6.2,53.5-18.5,82-34.9S205.6,134.2,223.3,116Zm22.5-56c-5.5-9.5-20.3-18.4-59.8-8.5A96,96,0,0,0,32,128a117.3,117.3,0,0,0,.7,12C4.4,169.2,4.8,186.5,10.2,196c3.7,6.4,11.9,12.8,29.8,12.8a121.7,121.7,0,0,0,25.5-3.2l4.5-1.1a105,105,0,0,1-14.2-13.3c-18.7,3.3-29.3,1-31.7-3.2-1.5-2.6-.7-7.5,2.3-13.4A85.7,85.7,0,0,1,37.1,159a95.2,95.2,0,0,0,18.7,32.2l6.2-1.3c24-5.3,53.1-17.5,82-34.2s54-35.8,70.6-53.9a62,62,0,0,0,4.3-4.8,95.2,95.2,0,0,0-18.7-32.2,83.9,83.9,0,0,1,19-1.5c6.6.4,11.2,2.1,12.7,4.7,2.4,4.2-.9,14.5-13,29a107.3,107.3,0,0,1,4.4,19l3.1-3.3C251.7,85.2,250.9,68.9,245.8,60Z" }, null, -1), rcr = [
  scr
], icr = { key: 3 }, lcr = ["stroke"], dcr = ["stroke"], kcr = { key: 4 }, ccr = ["stroke"], hcr = ["stroke"], ucr = { key: 5 }, acr = ["stroke"], _cr = ["stroke"], pcr = {
  name: "PhPlanet"
}, yY1 = /* @__PURE__ */ $({
  ...pcr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Xkr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jkr),
        e("path", {
          d: "M179.5,61.6c30.1-8.9,52.9-8.8,59.4,2.4,11,19.1-29.7,63.3-90.9,98.6S28.2,211.1,17.1,192c-6.4-11.2,4.9-31,27.7-52.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qkr)
      ])) : o(i) === "duotone" ? (s(), r("g", Ykr, [
        ocr,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ecr),
        e("path", {
          d: "M184.2,60.3c27.7-7.6,48.5-6.9,54.7,3.7,11,19.1-29.7,63.3-90.9,98.6S28.2,211.1,17.1,192c-6.1-10.6,3.7-29,24.1-49.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tcr)
      ])) : o(i) === "fill" ? (s(), r("g", ncr, rcr)) : o(i) === "light" ? (s(), r("g", icr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lcr),
        e("path", {
          d: "M184.2,60.3c27.7-7.6,48.5-6.9,54.7,3.7,11,19.1-29.7,63.3-90.9,98.6S28.2,211.1,17.1,192c-6.1-10.6,3.7-29,24.1-49.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dcr)
      ])) : o(i) === "thin" ? (s(), r("g", kcr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ccr),
        e("path", {
          d: "M184.2,60.3c27.7-7.6,48.5-6.9,54.7,3.7,11,19.1-29.7,63.3-90.9,98.6S28.2,211.1,17.1,192c-6.1-10.6,3.7-29,24.1-49.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hcr)
      ])) : o(i) === "regular" ? (s(), r("g", ucr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, acr),
        e("path", {
          d: "M184.2,60.3c27.7-7.6,48.5-6.9,54.7,3.7,11,19.1-29.7,63.3-90.9,98.6S28.2,211.1,17.1,192c-6.1-10.6,3.7-29,24.1-49.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _cr)
      ])) : g("", !0)
    ], 16, Kkr));
  }
}), ycr = ["width", "height", "fill", "transform"], $cr = { key: 0 }, wcr = ["stroke"], fcr = { key: 1 }, gcr = /* @__PURE__ */ e("path", {
  d: "M228.1,121.2,84.2,33.2A8,8,0,0,0,72,40V216a8,8,0,0,0,12.2,6.8l143.9-88A7.9,7.9,0,0,0,228.1,121.2Z",
  opacity: "0.2"
}, null, -1), xcr = ["stroke"], jcr = { key: 2 }, mcr = /* @__PURE__ */ e("path", { d: "M232.3,114.3,88.3,26.4a15.5,15.5,0,0,0-16.1-.3A15.8,15.8,0,0,0,64,40V216a15.8,15.8,0,0,0,8.2,13.9,15.5,15.5,0,0,0,16.1-.3l144-87.9a16,16,0,0,0,0-27.4Z" }, null, -1), Mcr = [
  mcr
], vcr = { key: 3 }, Scr = ["stroke"], Hcr = { key: 4 }, Acr = ["stroke"], Vcr = { key: 5 }, zcr = ["stroke"], Zcr = {
  name: "PhPlay"
}, $Y1 = /* @__PURE__ */ $({
  ...Zcr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $cr, [
        e("path", {
          d: "M228.1,121.2,84.2,33.2A8,8,0,0,0,72,40V216a8,8,0,0,0,12.2,6.8l143.9-88A7.9,7.9,0,0,0,228.1,121.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wcr)
      ])) : o(i) === "duotone" ? (s(), r("g", fcr, [
        gcr,
        e("path", {
          d: "M228.1,121.2,84.2,33.2A8,8,0,0,0,72,40V216a8,8,0,0,0,12.2,6.8l143.9-88A7.9,7.9,0,0,0,228.1,121.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xcr)
      ])) : o(i) === "fill" ? (s(), r("g", jcr, Mcr)) : o(i) === "light" ? (s(), r("g", vcr, [
        e("path", {
          d: "M228.1,121.2,84.2,33.2A8,8,0,0,0,72,40V216a8,8,0,0,0,12.2,6.8l143.9-88A7.9,7.9,0,0,0,228.1,121.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Scr)
      ])) : o(i) === "thin" ? (s(), r("g", Hcr, [
        e("path", {
          d: "M228.1,121.2,84.2,33.2A8,8,0,0,0,72,40V216a8,8,0,0,0,12.2,6.8l143.9-88A7.9,7.9,0,0,0,228.1,121.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Acr)
      ])) : o(i) === "regular" ? (s(), r("g", Vcr, [
        e("path", {
          d: "M228.1,121.2,84.2,33.2A8,8,0,0,0,72,40V216a8,8,0,0,0,12.2,6.8l143.9-88A7.9,7.9,0,0,0,228.1,121.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zcr)
      ])) : g("", !0)
    ], 16, ycr));
  }
}), Ccr = ["width", "height", "fill", "transform"], bcr = { key: 0 }, Lcr = ["stroke"], Bcr = ["stroke"], Pcr = { key: 1 }, Wcr = /* @__PURE__ */ e("path", {
  d: "M128,32a96,96,0,1,0,96,96A96,96,0,0,0,128,32ZM112,160V96l48,32Z",
  opacity: "0.2"
}, null, -1), Ncr = ["stroke"], Fcr = ["stroke"], Tcr = { key: 2 }, Dcr = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm36.4,110.7-48,32A8.7,8.7,0,0,1,112,168a8.5,8.5,0,0,1-3.8-.9A8,8,0,0,1,104,160V96a8,8,0,0,1,4.2-7.1,8.3,8.3,0,0,1,8.2.4l48,32a8,8,0,0,1,0,13.4Z" }, null, -1), Rcr = [
  Dcr
], Ucr = { key: 3 }, qcr = ["stroke"], Gcr = ["stroke"], Ecr = { key: 4 }, Ocr = ["stroke"], Icr = ["stroke"], Kcr = { key: 5 }, Xcr = ["stroke"], Jcr = ["stroke"], Qcr = {
  name: "PhPlayCircle"
}, wY1 = /* @__PURE__ */ $({
  ...Qcr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", bcr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lcr),
        e("polygon", {
          points: "156 128 116 100 116 156 156 128",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bcr)
      ])) : o(i) === "duotone" ? (s(), r("g", Pcr, [
        Wcr,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Ncr),
        e("polygon", {
          points: "160 128 112 96 112 160 160 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fcr)
      ])) : o(i) === "fill" ? (s(), r("g", Tcr, Rcr)) : o(i) === "light" ? (s(), r("g", Ucr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qcr),
        e("polygon", {
          points: "160 128 112 96 112 160 160 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gcr)
      ])) : o(i) === "thin" ? (s(), r("g", Ecr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ocr),
        e("polygon", {
          points: "160 128 112 96 112 160 160 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Icr)
      ])) : o(i) === "regular" ? (s(), r("g", Kcr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Xcr),
        e("polygon", {
          points: "160 128 112 96 112 160 160 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jcr)
      ])) : g("", !0)
    ], 16, Ccr));
  }
}), Ycr = ["width", "height", "fill", "transform"], ohr = { key: 0 }, ehr = ["stroke"], thr = ["stroke"], nhr = ["stroke"], shr = ["stroke"], rhr = ["stroke"], ihr = { key: 1 }, lhr = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "192",
  r: "24",
  opacity: "0.2"
}, null, -1), dhr = ["stroke"], khr = ["stroke"], chr = ["stroke"], hhr = ["stroke"], uhr = ["stroke"], ahr = { key: 2 }, _hr = /* @__PURE__ */ e("path", { d: "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm8,72H160a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm72,48H40a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm130.3-67.7-40-12a8.2,8.2,0,0,0-7.1,1.3A8.1,8.1,0,0,0,192,112v52.3A32,32,0,1,0,208,192V122.8l29.7,8.9a8,8,0,1,0,4.6-15.4Z" }, null, -1), phr = [
  _hr
], yhr = { key: 3 }, $hr = ["stroke"], whr = ["stroke"], fhr = ["stroke"], ghr = ["stroke"], xhr = ["stroke"], jhr = { key: 4 }, mhr = ["stroke"], Mhr = ["stroke"], vhr = ["stroke"], Shr = ["stroke"], Hhr = ["stroke"], Ahr = { key: 5 }, Vhr = ["stroke"], zhr = ["stroke"], Zhr = ["stroke"], Chr = ["stroke"], bhr = ["stroke"], Lhr = {
  name: "PhPlaylist"
}, fY1 = /* @__PURE__ */ $({
  ...Lhr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ohr, [
        e("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ehr),
        e("line", {
          x1: "40",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, thr),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "112",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nhr),
        e("circle", {
          cx: "176",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, shr),
        e("polyline", {
          points: "200 192 200 112 240 124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rhr)
      ])) : o(i) === "duotone" ? (s(), r("g", ihr, [
        lhr,
        e("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dhr),
        e("line", {
          x1: "40",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, khr),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "112",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, chr),
        e("circle", {
          cx: "176",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hhr),
        e("polyline", {
          points: "200 192 200 112 240 124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uhr)
      ])) : o(i) === "fill" ? (s(), r("g", ahr, phr)) : o(i) === "light" ? (s(), r("g", yhr, [
        e("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $hr),
        e("line", {
          x1: "40",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, whr),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "112",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fhr),
        e("circle", {
          cx: "176",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ghr),
        e("polyline", {
          points: "200 192 200 112 240 124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xhr)
      ])) : o(i) === "thin" ? (s(), r("g", jhr, [
        e("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mhr),
        e("line", {
          x1: "40",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Mhr),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "112",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vhr),
        e("circle", {
          cx: "176",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Shr),
        e("polyline", {
          points: "200 192 200 112 240 124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hhr)
      ])) : o(i) === "regular" ? (s(), r("g", Ahr, [
        e("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vhr),
        e("line", {
          x1: "40",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zhr),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "112",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zhr),
        e("circle", {
          cx: "176",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Chr),
        e("polyline", {
          points: "200 192 200 112 240 124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bhr)
      ])) : g("", !0)
    ], 16, Ycr));
  }
}), Bhr = ["width", "height", "fill", "transform"], Phr = { key: 0 }, Whr = ["stroke"], Nhr = ["stroke"], Fhr = ["stroke"], Thr = ["stroke"], Dhr = ["stroke"], Rhr = { key: 1 }, Uhr = /* @__PURE__ */ e("path", {
  d: "M212,132l-57.4,57.4a31.9,31.9,0,0,1-45.2,0L66.6,146.6a31.9,31.9,0,0,1,0-45.2L124,44Z",
  opacity: "0.2"
}, null, -1), qhr = ["stroke"], Ghr = ["stroke"], Ehr = ["stroke"], Ohr = ["stroke"], Ihr = ["stroke"], Khr = { key: 2 }, Xhr = /* @__PURE__ */ e("path", { d: "M237.7,77.7,203.3,112l26.4,26.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0l-6.3-6.4L160.3,195a40.1,40.1,0,0,1-56.6,0L88,179.3,37.7,229.7a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L76.7,168,61,152.3a40.1,40.1,0,0,1,0-56.6L112.7,44l-6.4-6.3a8.1,8.1,0,0,1,11.4-11.4L144,52.7l34.3-34.4a8.1,8.1,0,0,1,11.4,11.4L155.3,64,192,100.7l34.3-34.4a8.1,8.1,0,0,1,11.4,11.4Z" }, null, -1), Jhr = [
  Xhr
], Qhr = { key: 3 }, Yhr = ["stroke"], o6r = ["stroke"], e6r = ["stroke"], t6r = ["stroke"], n6r = ["stroke"], s6r = { key: 4 }, r6r = ["stroke"], i6r = ["stroke"], l6r = ["stroke"], d6r = ["stroke"], k6r = ["stroke"], c6r = { key: 5 }, h6r = ["stroke"], u6r = ["stroke"], a6r = ["stroke"], _6r = ["stroke"], p6r = ["stroke"], y6r = {
  name: "PhPlug"
}, gY1 = /* @__PURE__ */ $({
  ...y6r,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Phr, [
        e("path", {
          d: "M212,132l-57.4,57.4a31.9,31.9,0,0,1-45.2,0L66.6,146.6a31.9,31.9,0,0,1,0-45.2L124,44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Whr),
        e("line", {
          x1: "88",
          y1: "168",
          x2: "32",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nhr),
        e("line", {
          x1: "144",
          y1: "64",
          x2: "184",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fhr),
        e("line", {
          x1: "232",
          y1: "72",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Thr),
        e("line", {
          x1: "224",
          y1: "144",
          x2: "112",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Dhr)
      ])) : o(i) === "duotone" ? (s(), r("g", Rhr, [
        Uhr,
        e("path", {
          d: "M212,132l-57.4,57.4a31.9,31.9,0,0,1-45.2,0L66.6,146.6a31.9,31.9,0,0,1,0-45.2L124,44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qhr),
        e("line", {
          x1: "88",
          y1: "168",
          x2: "32",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ghr),
        e("line", {
          x1: "144",
          y1: "64",
          x2: "184",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ehr),
        e("line", {
          x1: "232",
          y1: "72",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ohr),
        e("line", {
          x1: "224",
          y1: "144",
          x2: "112",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ihr)
      ])) : o(i) === "fill" ? (s(), r("g", Khr, Jhr)) : o(i) === "light" ? (s(), r("g", Qhr, [
        e("path", {
          d: "M212,132l-57.4,57.4a31.9,31.9,0,0,1-45.2,0L66.6,146.6a31.9,31.9,0,0,1,0-45.2L124,44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Yhr),
        e("line", {
          x1: "88",
          y1: "168",
          x2: "32",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, o6r),
        e("line", {
          x1: "144",
          y1: "64",
          x2: "184",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, e6r),
        e("line", {
          x1: "232",
          y1: "72",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, t6r),
        e("line", {
          x1: "224",
          y1: "144",
          x2: "112",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, n6r)
      ])) : o(i) === "thin" ? (s(), r("g", s6r, [
        e("path", {
          d: "M212,132l-57.4,57.4a31.9,31.9,0,0,1-45.2,0L66.6,146.6a31.9,31.9,0,0,1,0-45.2L124,44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, r6r),
        e("line", {
          x1: "88",
          y1: "168",
          x2: "32",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, i6r),
        e("line", {
          x1: "144",
          y1: "64",
          x2: "184",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, l6r),
        e("line", {
          x1: "232",
          y1: "72",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, d6r),
        e("line", {
          x1: "224",
          y1: "144",
          x2: "112",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, k6r)
      ])) : o(i) === "regular" ? (s(), r("g", c6r, [
        e("path", {
          d: "M212,132l-57.4,57.4a31.9,31.9,0,0,1-45.2,0L66.6,146.6a31.9,31.9,0,0,1,0-45.2L124,44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h6r),
        e("line", {
          x1: "88",
          y1: "168",
          x2: "32",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u6r),
        e("line", {
          x1: "144",
          y1: "64",
          x2: "184",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a6r),
        e("line", {
          x1: "232",
          y1: "72",
          x2: "192",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _6r),
        e("line", {
          x1: "224",
          y1: "144",
          x2: "112",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p6r)
      ])) : g("", !0)
    ], 16, Bhr));
  }
}), $6r = ["width", "height", "fill", "transform"], w6r = { key: 0 }, f6r = ["stroke"], g6r = ["stroke"], x6r = ["stroke"], j6r = ["stroke"], m6r = /* @__PURE__ */ e("line", {
  x1: "140",
  y1: "148",
  x2: "120",
  y2: "168",
  fill: "#231f20"
}, null, -1), M6r = ["stroke"], v6r = /* @__PURE__ */ e("line", {
  x1: "108",
  y1: "116",
  x2: "88",
  y2: "136",
  fill: "#231f20"
}, null, -1), S6r = ["stroke"], H6r = ["stroke"], A6r = ["stroke"], V6r = { key: 1 }, z6r = /* @__PURE__ */ e("path", {
  d: "M132,180l-31,31a24,24,0,0,1-34,0L45,189a24,24,0,0,1,0-34l31-31Z",
  opacity: "0.2"
}, null, -1), Z6r = /* @__PURE__ */ e("path", {
  d: "M180,132l31-31a24,24,0,0,0,0-34L189,45a24,24,0,0,0-34,0L124,76Z",
  opacity: "0.2"
}, null, -1), C6r = ["stroke"], b6r = ["stroke"], L6r = ["stroke"], B6r = ["stroke"], P6r = /* @__PURE__ */ e("line", {
  x1: "144",
  y1: "144",
  x2: "120",
  y2: "168",
  fill: "#231f20"
}, null, -1), W6r = ["stroke"], N6r = /* @__PURE__ */ e("line", {
  x1: "112",
  y1: "112",
  x2: "88",
  y2: "136",
  fill: "#231f20"
}, null, -1), F6r = ["stroke"], T6r = ["stroke"], D6r = ["stroke"], R6r = { key: 2 }, U6r = /* @__PURE__ */ e("path", { d: "M237.7,29.7,211.3,56l5.4,5.4a31.9,31.9,0,0,1,0,45.2L191.3,132l2.4,2.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0l-8-8h0l-56-56h0l-8-8a8.1,8.1,0,0,1,11.4-11.4l2.3,2.4,25.4-25.4a31.9,31.9,0,0,1,45.2,0l5.4,5.4,26.3-26.4a8.1,8.1,0,0,1,11.4,11.4ZM138.3,138.3,120,156.7,99.3,136l18.4-18.3a8.1,8.1,0,0,0-11.4-11.4L88,124.7l-6.3-6.4h0l-8-8a8.1,8.1,0,0,0-11.4,11.4l2.4,2.3L39.3,149.4a31.9,31.9,0,0,0,0,45.2l5.4,5.4L18.3,226.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L56,211.3l5.4,5.4a31.9,31.9,0,0,0,45.2,0L132,191.3l2.3,2.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4l-8-8h0l-6.4-6.3,18.4-18.3a8.1,8.1,0,0,0-11.4-11.4Z" }, null, -1), q6r = [
  U6r
], G6r = { key: 3 }, E6r = ["stroke"], O6r = ["stroke"], I6r = ["stroke"], K6r = ["stroke"], X6r = /* @__PURE__ */ e("line", {
  x1: "144",
  y1: "144",
  x2: "120",
  y2: "168",
  fill: "#231f20"
}, null, -1), J6r = ["stroke"], Q6r = /* @__PURE__ */ e("line", {
  x1: "112",
  y1: "112",
  x2: "88",
  y2: "136",
  fill: "#231f20"
}, null, -1), Y6r = ["stroke"], our = ["stroke"], eur = ["stroke"], tur = { key: 4 }, nur = ["stroke"], sur = ["stroke"], rur = ["stroke"], iur = ["stroke"], lur = /* @__PURE__ */ e("line", {
  x1: "144",
  y1: "144",
  x2: "120",
  y2: "168",
  fill: "#231f20"
}, null, -1), dur = ["stroke"], kur = /* @__PURE__ */ e("line", {
  x1: "112",
  y1: "112",
  x2: "88",
  y2: "136",
  fill: "#231f20"
}, null, -1), cur = ["stroke"], hur = ["stroke"], uur = ["stroke"], aur = { key: 5 }, _ur = ["stroke"], pur = ["stroke"], yur = ["stroke"], $ur = ["stroke"], wur = /* @__PURE__ */ e("line", {
  x1: "144",
  y1: "144",
  x2: "120",
  y2: "168",
  fill: "#231f20"
}, null, -1), fur = ["stroke"], gur = /* @__PURE__ */ e("line", {
  x1: "112",
  y1: "112",
  x2: "88",
  y2: "136",
  fill: "#231f20"
}, null, -1), xur = ["stroke"], jur = ["stroke"], mur = ["stroke"], Mur = {
  name: "PhPlugs"
}, xY1 = /* @__PURE__ */ $({
  ...Mur,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", w6r, [
        e("path", {
          d: "M132,180l-31,31a24,24,0,0,1-34,0L45,189a24,24,0,0,1,0-34l31-31",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f6r),
        e("line", {
          x1: "56",
          y1: "200",
          x2: "24",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g6r),
        e("line", {
          x1: "232",
          y1: "24",
          x2: "200",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, x6r),
        e("line", {
          x1: "140",
          y1: "148",
          x2: "120",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, j6r),
        m6r,
        e("line", {
          x1: "108",
          y1: "116",
          x2: "88",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, M6r),
        v6r,
        e("path", {
          d: "M180,132l31-31a24,24,0,0,0,0-34L189,45a24,24,0,0,0-34,0L124,76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, S6r),
        e("line", {
          x1: "116",
          y1: "68",
          x2: "188",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, H6r),
        e("line", {
          x1: "68",
          y1: "116",
          x2: "140",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, A6r)
      ])) : o(i) === "duotone" ? (s(), r("g", V6r, [
        z6r,
        Z6r,
        e("path", {
          d: "M132,180l-31,31a24,24,0,0,1-34,0L45,189a24,24,0,0,1,0-34l31-31",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C6r),
        e("line", {
          x1: "56",
          y1: "200",
          x2: "24",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b6r),
        e("line", {
          x1: "232",
          y1: "24",
          x2: "200",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L6r),
        e("line", {
          x1: "144",
          y1: "144",
          x2: "120",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B6r),
        P6r,
        e("line", {
          x1: "112",
          y1: "112",
          x2: "88",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W6r),
        N6r,
        e("path", {
          d: "M180,132l31-31a24,24,0,0,0,0-34L189,45a24,24,0,0,0-34,0L124,76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F6r),
        e("line", {
          x1: "116",
          y1: "68",
          x2: "188",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T6r),
        e("line", {
          x1: "68",
          y1: "116",
          x2: "140",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D6r)
      ])) : o(i) === "fill" ? (s(), r("g", R6r, q6r)) : o(i) === "light" ? (s(), r("g", G6r, [
        e("path", {
          d: "M132,180l-31,31a24,24,0,0,1-34,0L45,189a24,24,0,0,1,0-34l31-31",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, E6r),
        e("line", {
          x1: "56",
          y1: "200",
          x2: "24",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, O6r),
        e("line", {
          x1: "232",
          y1: "24",
          x2: "200",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, I6r),
        e("line", {
          x1: "144",
          y1: "144",
          x2: "120",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, K6r),
        X6r,
        e("line", {
          x1: "112",
          y1: "112",
          x2: "88",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, J6r),
        Q6r,
        e("path", {
          d: "M180,132l31-31a24,24,0,0,0,0-34L189,45a24,24,0,0,0-34,0L124,76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Y6r),
        e("line", {
          x1: "116",
          y1: "68",
          x2: "188",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, our),
        e("line", {
          x1: "68",
          y1: "116",
          x2: "140",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eur)
      ])) : o(i) === "thin" ? (s(), r("g", tur, [
        e("path", {
          d: "M132,180l-31,31a24,24,0,0,1-34,0L45,189a24,24,0,0,1,0-34l31-31",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nur),
        e("line", {
          x1: "56",
          y1: "200",
          x2: "24",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sur),
        e("line", {
          x1: "232",
          y1: "24",
          x2: "200",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rur),
        e("line", {
          x1: "144",
          y1: "144",
          x2: "120",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iur),
        lur,
        e("line", {
          x1: "112",
          y1: "112",
          x2: "88",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dur),
        kur,
        e("path", {
          d: "M180,132l31-31a24,24,0,0,0,0-34L189,45a24,24,0,0,0-34,0L124,76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cur),
        e("line", {
          x1: "116",
          y1: "68",
          x2: "188",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hur),
        e("line", {
          x1: "68",
          y1: "116",
          x2: "140",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uur)
      ])) : o(i) === "regular" ? (s(), r("g", aur, [
        e("path", {
          d: "M132,180l-31,31a24,24,0,0,1-34,0L45,189a24,24,0,0,1,0-34l31-31",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _ur),
        e("line", {
          x1: "56",
          y1: "200",
          x2: "24",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pur),
        e("line", {
          x1: "232",
          y1: "24",
          x2: "200",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yur),
        e("line", {
          x1: "144",
          y1: "144",
          x2: "120",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $ur),
        wur,
        e("line", {
          x1: "112",
          y1: "112",
          x2: "88",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fur),
        gur,
        e("path", {
          d: "M180,132l31-31a24,24,0,0,0,0-34L189,45a24,24,0,0,0-34,0L124,76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xur),
        e("line", {
          x1: "116",
          y1: "68",
          x2: "188",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jur),
        e("line", {
          x1: "68",
          y1: "116",
          x2: "140",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mur)
      ])) : g("", !0)
    ], 16, $6r));
  }
}), vur = ["width", "height", "fill", "transform"], Sur = { key: 0 }, Hur = ["stroke"], Aur = ["stroke"], Vur = ["stroke"], zur = ["stroke"], Zur = ["stroke"], Cur = ["stroke"], bur = ["stroke"], Lur = ["stroke"], Bur = { key: 1 }, Pur = /* @__PURE__ */ e("g", { opacity: "0.2" }, [
  /* @__PURE__ */ e("rect", {
    x: "60.1",
    y: "88.4",
    width: "135.8",
    height: "79.2",
    rx: "24",
    transform: "translate(-53 128) rotate(-45)"
  }),
  /* @__PURE__ */ e("rect", {
    x: "60.1",
    y: "88.4",
    width: "135.8",
    height: "79.2",
    rx: "24",
    transform: "translate(-53 128) rotate(-45)"
  })
], -1), Wur = ["stroke"], Nur = ["stroke"], Fur = ["stroke"], Tur = ["stroke"], Dur = ["stroke"], Rur = ["stroke"], Uur = ["stroke"], qur = ["stroke"], Gur = { key: 2 }, Eur = /* @__PURE__ */ e("path", { d: "M237.7,18.3a8.1,8.1,0,0,0-11.4,0L176,68.7l-5.4-5.4a31.9,31.9,0,0,0-45.2,0L100,88.7l-2.3-2.4A8.1,8.1,0,0,0,86.3,97.7l2.4,2.3L63.3,125.4a31.9,31.9,0,0,0,0,45.2l5.4,5.4L18.3,226.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L80,187.3l5.4,5.4a32.1,32.1,0,0,0,45.2,0L156,167.3l2.3,2.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4l-2.4-2.3,25.4-25.4a31.9,31.9,0,0,0,0-45.2L187.3,80l50.4-50.3A8.1,8.1,0,0,0,237.7,18.3Zm-56.3,101L156,144.7,111.3,100l25.4-25.4a15.9,15.9,0,0,1,22.6,0l22.1,22.1a15.9,15.9,0,0,1,0,22.6Zm50.2,43.2A7.9,7.9,0,0,1,224,168a7.3,7.3,0,0,1-2.5-.4l-24-8a8,8,0,1,1,5-15.2l24,8A8,8,0,0,1,231.6,162.5ZM24.4,93.5a8,8,0,0,1,10.1-5.1l24,8A8,8,0,0,1,56,112a7.3,7.3,0,0,1-2.5-.4l-24-8A8,8,0,0,1,24.4,93.5Zm64-59a8,8,0,0,1,15.2-5l8,24a8,8,0,0,1-5.1,10.1,7.3,7.3,0,0,1-2.5.4,7.9,7.9,0,0,1-7.6-5.5Zm79.2,187a8,8,0,0,1-5.1,10.1,7.3,7.3,0,0,1-2.5.4,7.9,7.9,0,0,1-7.6-5.5l-8-24a8,8,0,1,1,15.2-5Z" }, null, -1), Our = [
  Eur
], Iur = { key: 3 }, Kur = ["stroke"], Xur = ["stroke"], Jur = ["stroke"], Qur = ["stroke"], Yur = ["stroke"], o4r = ["stroke"], e4r = ["stroke"], t4r = ["stroke"], n4r = { key: 4 }, s4r = ["stroke"], r4r = ["stroke"], i4r = ["stroke"], l4r = ["stroke"], d4r = ["stroke"], k4r = ["stroke"], c4r = ["stroke"], h4r = ["stroke"], u4r = { key: 5 }, a4r = ["stroke"], _4r = ["stroke"], p4r = ["stroke"], y4r = ["stroke"], $4r = ["stroke"], w4r = ["stroke"], f4r = ["stroke"], g4r = ["stroke"], x4r = {
  name: "PhPlugsConnected"
}, jY1 = /* @__PURE__ */ $({
  ...x4r,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Sur, [
        e("line", {
          x1: "80",
          y1: "176",
          x2: "28",
          y2: "228",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hur),
        e("line", {
          x1: "228",
          y1: "28",
          x2: "176",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Aur),
        e("rect", {
          x: "60.1",
          y: "88.4",
          width: "135.8",
          height: "79.2",
          rx: "24",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vur),
        e("line", {
          x1: "92",
          y1: "92",
          x2: "164",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zur),
        e("line", {
          x1: "156",
          y1: "212",
          x2: "161.3",
          y2: "228",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zur),
        e("line", {
          x1: "94.7",
          y1: "28",
          x2: "100",
          y2: "44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cur),
        e("line", {
          x1: "212",
          y1: "156",
          x2: "228",
          y2: "161.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bur),
        e("line", {
          x1: "28",
          y1: "94.7",
          x2: "44",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lur)
      ])) : o(i) === "duotone" ? (s(), r("g", Bur, [
        Pur,
        e("line", {
          x1: "80",
          y1: "176",
          x2: "24",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wur),
        e("line", {
          x1: "232",
          y1: "24",
          x2: "176",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nur),
        e("rect", {
          x: "60.1",
          y: "88.4",
          width: "135.8",
          height: "79.2",
          rx: "24",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fur),
        e("line", {
          x1: "92",
          y1: "92",
          x2: "164",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tur),
        e("line", {
          x1: "224",
          y1: "160",
          x2: "200",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dur),
        e("line", {
          x1: "56",
          y1: "104",
          x2: "32",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rur),
        e("line", {
          x1: "96",
          y1: "32",
          x2: "104",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uur),
        e("line", {
          x1: "152",
          y1: "200",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qur)
      ])) : o(i) === "fill" ? (s(), r("g", Gur, Our)) : o(i) === "light" ? (s(), r("g", Iur, [
        e("line", {
          x1: "80",
          y1: "176",
          x2: "24",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kur),
        e("line", {
          x1: "232",
          y1: "24",
          x2: "176",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xur),
        e("rect", {
          x: "60.1",
          y: "88.4",
          width: "135.8",
          height: "79.2",
          rx: "24",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jur),
        e("line", {
          x1: "92",
          y1: "92",
          x2: "164",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qur),
        e("line", {
          x1: "224",
          y1: "160",
          x2: "200",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Yur),
        e("line", {
          x1: "56",
          y1: "104",
          x2: "32",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, o4r),
        e("line", {
          x1: "96",
          y1: "32",
          x2: "104",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, e4r),
        e("line", {
          x1: "152",
          y1: "200",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, t4r)
      ])) : o(i) === "thin" ? (s(), r("g", n4r, [
        e("line", {
          x1: "80",
          y1: "176",
          x2: "24",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, s4r),
        e("line", {
          x1: "232",
          y1: "24",
          x2: "176",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, r4r),
        e("rect", {
          x: "60.1",
          y: "88.4",
          width: "135.8",
          height: "79.2",
          rx: "24",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, i4r),
        e("line", {
          x1: "92",
          y1: "92",
          x2: "164",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, l4r),
        e("line", {
          x1: "224",
          y1: "160",
          x2: "200",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, d4r),
        e("line", {
          x1: "56",
          y1: "104",
          x2: "32",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, k4r),
        e("line", {
          x1: "96",
          y1: "32",
          x2: "104",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, c4r),
        e("line", {
          x1: "152",
          y1: "200",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, h4r)
      ])) : o(i) === "regular" ? (s(), r("g", u4r, [
        e("line", {
          x1: "80",
          y1: "176",
          x2: "24",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a4r),
        e("line", {
          x1: "232",
          y1: "24",
          x2: "176",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _4r),
        e("rect", {
          x: "60.1",
          y: "88.4",
          width: "135.8",
          height: "79.2",
          rx: "24",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p4r),
        e("line", {
          x1: "92",
          y1: "92",
          x2: "164",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y4r),
        e("line", {
          x1: "224",
          y1: "160",
          x2: "200",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $4r),
        e("line", {
          x1: "56",
          y1: "104",
          x2: "32",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w4r),
        e("line", {
          x1: "96",
          y1: "32",
          x2: "104",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f4r),
        e("line", {
          x1: "152",
          y1: "200",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g4r)
      ])) : g("", !0)
    ], 16, vur));
  }
}), j4r = ["width", "height", "fill", "transform"], m4r = { key: 0 }, M4r = ["stroke"], v4r = ["stroke"], S4r = { key: 1 }, H4r = ["stroke"], A4r = ["stroke"], V4r = { key: 2 }, z4r = /* @__PURE__ */ e("path", { d: "M216,120H136V40a8,8,0,0,0-16,0v80H40a8,8,0,0,0,0,16h80v80a8,8,0,0,0,16,0V136h80a8,8,0,0,0,0-16Z" }, null, -1), Z4r = [
  z4r
], C4r = { key: 3 }, b4r = ["stroke"], L4r = ["stroke"], B4r = { key: 4 }, P4r = ["stroke"], W4r = ["stroke"], N4r = { key: 5 }, F4r = ["stroke"], T4r = ["stroke"], D4r = {
  name: "PhPlus"
}, mY1 = /* @__PURE__ */ $({
  ...D4r,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", m4r, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, M4r),
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, v4r)
      ])) : o(i) === "duotone" ? (s(), r("g", S4r, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H4r),
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A4r)
      ])) : o(i) === "fill" ? (s(), r("g", V4r, Z4r)) : o(i) === "light" ? (s(), r("g", C4r, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b4r),
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, L4r)
      ])) : o(i) === "thin" ? (s(), r("g", B4r, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, P4r),
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, W4r)
      ])) : o(i) === "regular" ? (s(), r("g", N4r, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F4r),
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T4r)
      ])) : g("", !0)
    ], 16, j4r));
  }
}), R4r = ["width", "height", "fill", "transform"], U4r = { key: 0 }, q4r = ["stroke"], G4r = ["stroke"], E4r = ["stroke"], O4r = { key: 1 }, I4r = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), K4r = ["stroke"], X4r = ["stroke"], J4r = ["stroke"], Q4r = { key: 2 }, Y4r = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm40,112H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32a8,8,0,0,1,0,16Z" }, null, -1), oar = [
  Y4r
], ear = { key: 3 }, tar = ["stroke"], nar = ["stroke"], sar = ["stroke"], rar = { key: 4 }, iar = ["stroke"], lar = ["stroke"], dar = ["stroke"], kar = { key: 5 }, car = ["stroke"], har = ["stroke"], uar = ["stroke"], aar = {
  name: "PhPlusCircle"
}, MY1 = /* @__PURE__ */ $({
  ...aar,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", U4r, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, q4r),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, G4r),
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, E4r)
      ])) : o(i) === "duotone" ? (s(), r("g", O4r, [
        I4r,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, K4r),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X4r),
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J4r)
      ])) : o(i) === "fill" ? (s(), r("g", Q4r, oar)) : o(i) === "light" ? (s(), r("g", ear, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tar),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nar),
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sar)
      ])) : o(i) === "thin" ? (s(), r("g", rar, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iar),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lar),
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dar)
      ])) : o(i) === "regular" ? (s(), r("g", kar, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, car),
        e("line", {
          x1: "88",
          y1: "128",
          x2: "168",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, har),
        e("line", {
          x1: "128",
          y1: "88",
          x2: "128",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uar)
      ])) : g("", !0)
    ], 16, R4r));
  }
}), _ar = ["width", "height", "fill", "transform"], par = { key: 0 }, yar = ["stroke"], $ar = ["stroke"], war = ["stroke"], far = ["stroke"], gar = { key: 1 }, xar = ["stroke"], jar = ["stroke"], mar = ["stroke"], Mar = ["stroke"], Sar = { key: 2 }, Har = /* @__PURE__ */ e("path", { d: "M205.7,50.3a8.1,8.1,0,0,0-11.4,0l-144,144a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0l144-144A8.1,8.1,0,0,0,205.7,50.3Z" }, null, -1), Aar = /* @__PURE__ */ e("path", { d: "M64,112a8,8,0,0,0,16,0V80h32a8,8,0,0,0,0-16H80V32a8,8,0,0,0-16,0V64H32a8,8,0,0,0,0,16H64Z" }, null, -1), Var = /* @__PURE__ */ e("path", { d: "M224,176H144a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Z" }, null, -1), zar = [
  Har,
  Aar,
  Var
], Zar = { key: 3 }, Car = ["stroke"], bar = ["stroke"], Lar = ["stroke"], Bar = ["stroke"], Par = { key: 4 }, War = ["stroke"], Nar = ["stroke"], Far = ["stroke"], Tar = ["stroke"], Dar = { key: 5 }, Rar = ["stroke"], Uar = ["stroke"], qar = ["stroke"], Gar = ["stroke"], Ear = {
  name: "PhPlusMinus"
}, vY1 = /* @__PURE__ */ $({
  ...Ear,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", par, [
        e("line", {
          x1: "200",
          y1: "56",
          x2: "56",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yar),
        e("line", {
          x1: "32",
          y1: "72",
          x2: "112",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $ar),
        e("line", {
          x1: "72",
          y1: "32",
          x2: "72",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, war),
        e("line", {
          x1: "144",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, far)
      ])) : o(i) === "duotone" ? (s(), r("g", gar, [
        e("line", {
          x1: "200",
          y1: "56",
          x2: "56",
          y2: "200",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xar),
        e("line", {
          x1: "32",
          y1: "72",
          x2: "112",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jar),
        e("line", {
          x1: "72",
          y1: "32",
          x2: "72",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mar),
        e("line", {
          x1: "144",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mar)
      ])) : o(i) === "fill" ? (s(), r("g", Sar, zar)) : o(i) === "light" ? (s(), r("g", Zar, [
        e("line", {
          x1: "200",
          y1: "56",
          x2: "56",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Car),
        e("line", {
          x1: "32",
          y1: "72",
          x2: "112",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bar),
        e("line", {
          x1: "72",
          y1: "32",
          x2: "72",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lar),
        e("line", {
          x1: "144",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bar)
      ])) : o(i) === "thin" ? (s(), r("g", Par, [
        e("line", {
          x1: "200",
          y1: "56",
          x2: "56",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, War),
        e("line", {
          x1: "32",
          y1: "72",
          x2: "112",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nar),
        e("line", {
          x1: "72",
          y1: "32",
          x2: "72",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Far),
        e("line", {
          x1: "144",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Tar)
      ])) : o(i) === "regular" ? (s(), r("g", Dar, [
        e("line", {
          x1: "200",
          y1: "56",
          x2: "56",
          y2: "200",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rar),
        e("line", {
          x1: "32",
          y1: "72",
          x2: "112",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uar),
        e("line", {
          x1: "72",
          y1: "32",
          x2: "72",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qar),
        e("line", {
          x1: "144",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gar)
      ])) : g("", !0)
    ], 16, _ar));
  }
}), Oar = ["width", "height", "fill", "transform"], Iar = { key: 0 }, Kar = ["stroke"], Xar = ["stroke"], Jar = ["stroke"], Qar = ["stroke"], Yar = ["stroke"], o_r = ["stroke"], e_r = ["stroke"], t_r = ["stroke"], n_r = ["stroke"], s_r = ["stroke"], r_r = { key: 1 }, i_r = /* @__PURE__ */ e("path", {
  d: "M128,32a96,96,0,1,0,96,96A96,96,0,0,0,128,32Zm0,152a56,56,0,1,1,56-56A56,56,0,0,1,128,184Z",
  opacity: "0.2"
}, null, -1), l_r = ["stroke"], d_r = ["stroke"], k_r = ["stroke"], c_r = ["stroke"], h_r = ["stroke"], u_r = ["stroke"], a_r = ["stroke"], __r = ["stroke"], p_r = ["stroke"], y_r = ["stroke"], $_r = { key: 2 }, w_r = /* @__PURE__ */ e("path", { d: "M202.2,200.8a103.8,103.8,0,0,0,0-145.6,2.3,2.3,0,0,0-.7-.7,2.3,2.3,0,0,0-.7-.7,103.8,103.8,0,0,0-145.6,0,2.3,2.3,0,0,0-.7.7,2.3,2.3,0,0,0-.7.7,103.8,103.8,0,0,0,0,145.6l.7.7a2.3,2.3,0,0,0,.7.7,103.8,103.8,0,0,0,145.6,0,2.3,2.3,0,0,0,.7-.7A2.3,2.3,0,0,0,202.2,200.8ZM40.4,136H64.5a63.6,63.6,0,0,0,13,31.2L60.4,184.3A87.5,87.5,0,0,1,40.4,136Zm20-64.3L77.5,88.8a63.6,63.6,0,0,0-13,31.2H40.4A87.5,87.5,0,0,1,60.4,71.7ZM215.6,120H191.5a63.6,63.6,0,0,0-13-31.2l17.1-17.1A87.5,87.5,0,0,1,215.6,120ZM167.2,77.5a63.6,63.6,0,0,0-31.2-13V40.4a87.5,87.5,0,0,1,48.3,20ZM120,64.5a63.6,63.6,0,0,0-31.2,13L71.7,60.4a87.5,87.5,0,0,1,48.3-20Zm-31.2,114a63.6,63.6,0,0,0,31.2,13v24.1a87.5,87.5,0,0,1-48.3-20Zm47.2,13a63.6,63.6,0,0,0,31.2-13l17.1,17.1a87.5,87.5,0,0,1-48.3,20Zm42.5-24.3a63.6,63.6,0,0,0,13-31.2h24.1a87.5,87.5,0,0,1-20,48.3Z" }, null, -1), f_r = [
  w_r
], g_r = { key: 3 }, x_r = ["stroke"], j_r = ["stroke"], m_r = ["stroke"], M_r = ["stroke"], v_r = ["stroke"], S_r = ["stroke"], H_r = ["stroke"], A_r = ["stroke"], V_r = ["stroke"], z_r = ["stroke"], Z_r = { key: 4 }, C_r = ["stroke"], b_r = ["stroke"], L_r = ["stroke"], B_r = ["stroke"], P_r = ["stroke"], W_r = ["stroke"], N_r = ["stroke"], F_r = ["stroke"], T_r = ["stroke"], D_r = ["stroke"], R_r = { key: 5 }, U_r = ["stroke"], q_r = ["stroke"], G_r = ["stroke"], E_r = ["stroke"], O_r = ["stroke"], I_r = ["stroke"], K_r = ["stroke"], X_r = ["stroke"], J_r = ["stroke"], Q_r = ["stroke"], Y_r = {
  name: "PhPokerChip"
}, SY1 = /* @__PURE__ */ $({
  ...Y_r,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Iar, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kar),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xar),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jar),
        e("line", {
          x1: "94.1",
          y1: "94.1",
          x2: "60.1",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qar),
        e("line", {
          x1: "80",
          y1: "128",
          x2: "32",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Yar),
        e("line", {
          x1: "94.1",
          y1: "161.9",
          x2: "60.1",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, o_r),
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, e_r),
        e("line", {
          x1: "161.9",
          y1: "161.9",
          x2: "195.9",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, t_r),
        e("line", {
          x1: "176",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, n_r),
        e("line", {
          x1: "161.9",
          y1: "94.1",
          x2: "195.9",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, s_r)
      ])) : o(i) === "duotone" ? (s(), r("g", r_r, [
        i_r,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l_r),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, d_r),
        e("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k_r),
        e("line", {
          x1: "88.4",
          y1: "88.4",
          x2: "60.1",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c_r),
        e("line", {
          x1: "72",
          y1: "128",
          x2: "32",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h_r),
        e("line", {
          x1: "88.4",
          y1: "167.6",
          x2: "60.1",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u_r),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a_r),
        e("line", {
          x1: "167.6",
          y1: "167.6",
          x2: "195.9",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, __r),
        e("line", {
          x1: "184",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p_r),
        e("line", {
          x1: "167.6",
          y1: "88.4",
          x2: "195.9",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y_r)
      ])) : o(i) === "fill" ? (s(), r("g", $_r, f_r)) : o(i) === "light" ? (s(), r("g", g_r, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, x_r),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, j_r),
        e("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, m_r),
        e("line", {
          x1: "88.4",
          y1: "88.4",
          x2: "60.1",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, M_r),
        e("line", {
          x1: "72",
          y1: "128",
          x2: "32",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, v_r),
        e("line", {
          x1: "88.4",
          y1: "167.6",
          x2: "60.1",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, S_r),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, H_r),
        e("line", {
          x1: "167.6",
          y1: "167.6",
          x2: "195.9",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, A_r),
        e("line", {
          x1: "184",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, V_r),
        e("line", {
          x1: "167.6",
          y1: "88.4",
          x2: "195.9",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, z_r)
      ])) : o(i) === "thin" ? (s(), r("g", Z_r, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, C_r),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, b_r),
        e("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, L_r),
        e("line", {
          x1: "88.4",
          y1: "88.4",
          x2: "60.1",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, B_r),
        e("line", {
          x1: "72",
          y1: "128",
          x2: "32",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, P_r),
        e("line", {
          x1: "88.4",
          y1: "167.6",
          x2: "60.1",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, W_r),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, N_r),
        e("line", {
          x1: "167.6",
          y1: "167.6",
          x2: "195.9",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, F_r),
        e("line", {
          x1: "184",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, T_r),
        e("line", {
          x1: "167.6",
          y1: "88.4",
          x2: "195.9",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, D_r)
      ])) : o(i) === "regular" ? (s(), r("g", R_r, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U_r),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q_r),
        e("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G_r),
        e("line", {
          x1: "88.4",
          y1: "88.4",
          x2: "60.1",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E_r),
        e("line", {
          x1: "72",
          y1: "128",
          x2: "32",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O_r),
        e("line", {
          x1: "88.4",
          y1: "167.6",
          x2: "60.1",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I_r),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K_r),
        e("line", {
          x1: "167.6",
          y1: "167.6",
          x2: "195.9",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X_r),
        e("line", {
          x1: "184",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J_r),
        e("line", {
          x1: "167.6",
          y1: "88.4",
          x2: "195.9",
          y2: "60.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q_r)
      ])) : g("", !0)
    ], 16, Oar));
  }
}), opr = ["width", "height", "fill", "transform"], epr = { key: 0 }, tpr = ["stroke"], npr = ["stroke"], spr = ["stroke"], rpr = ["stroke"], ipr = ["stroke"], lpr = { key: 1 }, dpr = /* @__PURE__ */ e("path", {
  d: "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184Z",
  opacity: "0.2"
}, null, -1), kpr = /* @__PURE__ */ e("path", {
  d: "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184Z",
  opacity: "0.2"
}, null, -1), cpr = /* @__PURE__ */ e("path", {
  d: "M224,120,194.3,68a7.9,7.9,0,0,0-6.9-4H68.6a7.9,7.9,0,0,0-6.9,4L32,120Z",
  opacity: "0.2"
}, null, -1), hpr = ["stroke"], upr = ["stroke"], apr = ["stroke"], _pr = ["stroke"], ppr = ["stroke"], ypr = ["stroke"], $pr = ["stroke"], wpr = { key: 2 }, fpr = /* @__PURE__ */ e("path", { d: "M96,32a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,32Zm152,88a8,8,0,0,1-8,8h-8v80a16,16,0,0,1-16,16H192a16,16,0,0,1-16-16V192H80v16a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V128H16a8,8,0,0,1,0-16H27.4L54.8,64.1A15.9,15.9,0,0,1,68.6,56H187.4a15.9,15.9,0,0,1,13.8,8.1L228.6,112H240A8,8,0,0,1,248,120ZM88,152a8,8,0,0,0-8-8H64a8,8,0,0,0,0,16H80A8,8,0,0,0,88,152Zm112,0a8,8,0,0,0-8-8H176a8,8,0,0,0,0,16h16A8,8,0,0,0,200,152Z" }, null, -1), gpr = [
  fpr
], xpr = { key: 3 }, jpr = ["stroke"], mpr = ["stroke"], Mpr = ["stroke"], vpr = ["stroke"], Spr = ["stroke"], Hpr = ["stroke"], Apr = ["stroke"], Vpr = { key: 4 }, zpr = ["stroke"], Zpr = ["stroke"], Cpr = ["stroke"], bpr = ["stroke"], Lpr = ["stroke"], Bpr = ["stroke"], Ppr = ["stroke"], Wpr = { key: 5 }, Npr = ["stroke"], Fpr = ["stroke"], Tpr = ["stroke"], Dpr = ["stroke"], Rpr = ["stroke"], Upr = ["stroke"], qpr = ["stroke"], Gpr = {
  name: "PhPoliceCar"
}, HY1 = /* @__PURE__ */ $({
  ...Gpr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", epr, [
        e("line", {
          x1: "12",
          y1: "124",
          x2: "244",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tpr),
        e("path", {
          d: "M228,124,194.4,71.7a8.1,8.1,0,0,0-6.8-3.7H68.4a8.1,8.1,0,0,0-6.8,3.7L28,124v48H228Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, npr),
        e("line", {
          x1: "104",
          y1: "28",
          x2: "152",
          y2: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, spr),
        e("path", {
          d: "M228,172v32a8,8,0,0,1-8,8H196a8,8,0,0,1-8-8V172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rpr),
        e("path", {
          d: "M68,172v32a8,8,0,0,1-8,8H36a8,8,0,0,1-8-8V172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ipr)
      ])) : o(i) === "duotone" ? (s(), r("g", lpr, [
        dpr,
        kpr,
        cpr,
        e("line", {
          x1: "16",
          y1: "120",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hpr),
        e("path", {
          d: "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, upr),
        e("path", {
          d: "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, apr),
        e("line", {
          x1: "64",
          y1: "152",
          x2: "80",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _pr),
        e("line", {
          x1: "176",
          y1: "152",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ppr),
        e("path", {
          d: "M224,120,194.3,68a7.9,7.9,0,0,0-6.9-4H68.6a7.9,7.9,0,0,0-6.9,4L32,120v64H224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ypr),
        e("line", {
          x1: "104",
          y1: "32",
          x2: "152",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $pr)
      ])) : o(i) === "fill" ? (s(), r("g", wpr, gpr)) : o(i) === "light" ? (s(), r("g", xpr, [
        e("line", {
          x1: "16",
          y1: "120",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jpr),
        e("path", {
          d: "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mpr),
        e("path", {
          d: "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mpr),
        e("line", {
          x1: "64",
          y1: "152",
          x2: "80",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vpr),
        e("line", {
          x1: "176",
          y1: "152",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Spr),
        e("path", {
          d: "M224,120,194.3,68a7.9,7.9,0,0,0-6.9-4H68.6a7.9,7.9,0,0,0-6.9,4L32,120v64H224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hpr),
        e("line", {
          x1: "104",
          y1: "32",
          x2: "152",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Apr)
      ])) : o(i) === "thin" ? (s(), r("g", Vpr, [
        e("line", {
          x1: "16",
          y1: "120",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zpr),
        e("path", {
          d: "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zpr),
        e("path", {
          d: "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cpr),
        e("line", {
          x1: "64",
          y1: "152",
          x2: "80",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bpr),
        e("line", {
          x1: "176",
          y1: "152",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lpr),
        e("path", {
          d: "M224,120,194.3,68a7.9,7.9,0,0,0-6.9-4H68.6a7.9,7.9,0,0,0-6.9,4L32,120v64H224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bpr),
        e("line", {
          x1: "104",
          y1: "32",
          x2: "152",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ppr)
      ])) : o(i) === "regular" ? (s(), r("g", Wpr, [
        e("line", {
          x1: "16",
          y1: "120",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Npr),
        e("path", {
          d: "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fpr),
        e("path", {
          d: "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tpr),
        e("line", {
          x1: "64",
          y1: "152",
          x2: "80",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dpr),
        e("line", {
          x1: "176",
          y1: "152",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rpr),
        e("path", {
          d: "M224,120,194.3,68a7.9,7.9,0,0,0-6.9-4H68.6a7.9,7.9,0,0,0-6.9,4L32,120v64H224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Upr),
        e("line", {
          x1: "104",
          y1: "32",
          x2: "152",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qpr)
      ])) : g("", !0)
    ], 16, opr));
  }
}), Epr = ["width", "height", "fill", "transform"], Opr = { key: 0 }, Ipr = ["stroke"], Kpr = ["stroke"], Xpr = ["stroke"], Jpr = ["stroke"], Qpr = ["stroke"], Ypr = ["stroke"], o3r = ["stroke"], e3r = ["stroke"], t3r = { key: 1 }, n3r = /* @__PURE__ */ e("circle", {
  cx: "120",
  cy: "48",
  r: "24",
  opacity: "0.2"
}, null, -1), s3r = /* @__PURE__ */ e("circle", {
  cx: "40",
  cy: "120",
  r: "24",
  opacity: "0.2"
}, null, -1), r3r = /* @__PURE__ */ e("circle", {
  cx: "160",
  cy: "208",
  r: "24",
  opacity: "0.2"
}, null, -1), i3r = /* @__PURE__ */ e("circle", {
  cx: "208",
  cy: "72",
  r: "24",
  opacity: "0.2"
}, null, -1), l3r = ["stroke"], d3r = ["stroke"], k3r = ["stroke"], c3r = ["stroke"], h3r = ["stroke"], u3r = ["stroke"], a3r = ["stroke"], _3r = ["stroke"], p3r = { key: 2 }, y3r = /* @__PURE__ */ e("path", { d: "M230.6,49.4a31.9,31.9,0,0,0-45.2,0h0a30.2,30.2,0,0,0-5.2,6.7L152,48.4a32,32,0,0,0-54.6-23h0a32,32,0,0,0-5.8,37.4L57.7,93.3a32,32,0,0,0-40.3,4.1h0a31.9,31.9,0,0,0,0,45.2A31.6,31.6,0,0,0,40,152a32.1,32.1,0,0,0,20.3-7.2l70,51.3a32,32,0,0,0,7.1,34.5,31.9,31.9,0,0,0,45.2,0,31.9,31.9,0,0,0,0-45.2,43.3,43.3,0,0,0-4.7-4l27.3-77.5H208a31.6,31.6,0,0,0,22.6-9.4A31.9,31.9,0,0,0,230.6,49.4ZM162.8,176.1a32.4,32.4,0,0,0-23.1,7.1l-70-51.3a32.4,32.4,0,0,0-1.3-26.7l33.9-30.5A32.4,32.4,0,0,0,120,80a31.6,31.6,0,0,0,22.6-9.4,30.2,30.2,0,0,0,5.2-6.7L176,71.6a31.6,31.6,0,0,0,9.4,23,43.3,43.3,0,0,0,4.7,4Z" }, null, -1), $3r = [
  y3r
], w3r = { key: 3 }, f3r = ["stroke"], g3r = ["stroke"], x3r = ["stroke"], j3r = ["stroke"], m3r = ["stroke"], M3r = ["stroke"], v3r = ["stroke"], S3r = ["stroke"], H3r = { key: 4 }, A3r = ["stroke"], V3r = ["stroke"], z3r = ["stroke"], Z3r = ["stroke"], C3r = ["stroke"], b3r = ["stroke"], L3r = ["stroke"], B3r = ["stroke"], P3r = { key: 5 }, W3r = ["stroke"], N3r = ["stroke"], F3r = ["stroke"], T3r = ["stroke"], D3r = ["stroke"], R3r = ["stroke"], U3r = ["stroke"], q3r = ["stroke"], G3r = {
  name: "PhPolygon"
}, AY1 = /* @__PURE__ */ $({
  ...G3r,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Opr, [
        e("circle", {
          cx: "120",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ipr),
        e("circle", {
          cx: "40",
          cy: "120",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kpr),
        e("circle", {
          cx: "160",
          cy: "208",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xpr),
        e("circle", {
          cx: "208",
          cy: "72",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jpr),
        e("line", {
          x1: "184.8",
          y1: "65.7",
          x2: "143.2",
          y2: "54.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qpr),
        e("line", {
          x1: "102.2",
          y1: "64.1",
          x2: "57.8",
          y2: "103.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ypr),
        e("line", {
          x1: "59.4",
          y1: "134.2",
          x2: "140.6",
          y2: "193.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, o3r),
        e("line", {
          x1: "168",
          y1: "185.4",
          x2: "200",
          y2: "94.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, e3r)
      ])) : o(i) === "duotone" ? (s(), r("g", t3r, [
        n3r,
        s3r,
        r3r,
        i3r,
        e("circle", {
          cx: "120",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l3r),
        e("circle", {
          cx: "40",
          cy: "120",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, d3r),
        e("circle", {
          cx: "160",
          cy: "208",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k3r),
        e("circle", {
          cx: "208",
          cy: "72",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c3r),
        e("line", {
          x1: "184.8",
          y1: "65.7",
          x2: "143.2",
          y2: "54.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h3r),
        e("line", {
          x1: "102.2",
          y1: "64.1",
          x2: "57.8",
          y2: "103.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u3r),
        e("line", {
          x1: "59.4",
          y1: "134.2",
          x2: "140.6",
          y2: "193.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a3r),
        e("line", {
          x1: "168",
          y1: "185.4",
          x2: "200",
          y2: "94.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _3r)
      ])) : o(i) === "fill" ? (s(), r("g", p3r, $3r)) : o(i) === "light" ? (s(), r("g", w3r, [
        e("circle", {
          cx: "120",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, f3r),
        e("circle", {
          cx: "40",
          cy: "120",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, g3r),
        e("circle", {
          cx: "160",
          cy: "208",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, x3r),
        e("circle", {
          cx: "208",
          cy: "72",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, j3r),
        e("line", {
          x1: "184.8",
          y1: "65.7",
          x2: "143.2",
          y2: "54.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, m3r),
        e("line", {
          x1: "102.2",
          y1: "64.1",
          x2: "57.8",
          y2: "103.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, M3r),
        e("line", {
          x1: "59.4",
          y1: "134.2",
          x2: "140.6",
          y2: "193.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, v3r),
        e("line", {
          x1: "168",
          y1: "185.4",
          x2: "200",
          y2: "94.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, S3r)
      ])) : o(i) === "thin" ? (s(), r("g", H3r, [
        e("circle", {
          cx: "120",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, A3r),
        e("circle", {
          cx: "40",
          cy: "120",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, V3r),
        e("circle", {
          cx: "160",
          cy: "208",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, z3r),
        e("circle", {
          cx: "208",
          cy: "72",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Z3r),
        e("line", {
          x1: "184.8",
          y1: "65.7",
          x2: "143.2",
          y2: "54.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, C3r),
        e("line", {
          x1: "102.2",
          y1: "64.1",
          x2: "57.8",
          y2: "103.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, b3r),
        e("line", {
          x1: "59.4",
          y1: "134.2",
          x2: "140.6",
          y2: "193.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, L3r),
        e("line", {
          x1: "168",
          y1: "185.4",
          x2: "200",
          y2: "94.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, B3r)
      ])) : o(i) === "regular" ? (s(), r("g", P3r, [
        e("circle", {
          cx: "120",
          cy: "48",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W3r),
        e("circle", {
          cx: "40",
          cy: "120",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N3r),
        e("circle", {
          cx: "160",
          cy: "208",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F3r),
        e("circle", {
          cx: "208",
          cy: "72",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T3r),
        e("line", {
          x1: "184.8",
          y1: "65.7",
          x2: "143.2",
          y2: "54.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D3r),
        e("line", {
          x1: "102.2",
          y1: "64.1",
          x2: "57.8",
          y2: "103.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R3r),
        e("line", {
          x1: "59.4",
          y1: "134.2",
          x2: "140.6",
          y2: "193.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U3r),
        e("line", {
          x1: "168",
          y1: "185.4",
          x2: "200",
          y2: "94.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q3r)
      ])) : g("", !0)
    ], 16, Epr));
  }
}), E3r = ["width", "height", "fill", "transform"], O3r = { key: 0 }, I3r = ["stroke"], K3r = ["stroke"], X3r = ["stroke"], J3r = ["stroke"], Q3r = { key: 1 }, Y3r = /* @__PURE__ */ e("path", {
  d: "M104,216,88,96,45.1,83.7a8.1,8.1,0,0,0-10,9.6L62.5,209.8a8.1,8.1,0,0,0,7.8,6.2Z",
  opacity: "0.2"
}, null, -1), oyr = /* @__PURE__ */ e("path", {
  d: "M185.7,216a8.1,8.1,0,0,0,7.8-6.2L220.9,93.3a8.1,8.1,0,0,0-10-9.6L168,96,152,216Z",
  opacity: "0.2"
}, null, -1), eyr = ["stroke"], tyr = ["stroke"], nyr = ["stroke"], syr = ["stroke"], ryr = { key: 2 }, iyr = /* @__PURE__ */ e("path", { d: "M224.1,79.9l-.3-.4A43.9,43.9,0,0,0,168,41.7a44,44,0,0,0-80,0A43.9,43.9,0,0,0,32.2,79.5l-.3.4a15.7,15.7,0,0,0-4.6,15.2L54.8,211.7A15.9,15.9,0,0,0,70.3,224H185.7a15.9,15.9,0,0,0,15.5-12.3L228.7,95.1A15.7,15.7,0,0,0,224.1,79.9ZM76,56a27.4,27.4,0,0,1,13.1,3.3,8.4,8.4,0,0,0,7.1.2,8.2,8.2,0,0,0,4.5-5.6,28,28,0,0,1,54.6,0,8.2,8.2,0,0,0,4.5,5.6,8.4,8.4,0,0,0,7.1-.2A27.4,27.4,0,0,1,180,56a28,28,0,0,1,27,20.5L168.4,87.6,133.9,73.8a15.1,15.1,0,0,0-11.8,0L87.6,87.6,49,76.5A28,28,0,0,1,76,56ZM42.9,91.4h0l37.9,10.9L94.9,208H70.3ZM185.7,208H161.1l14.1-105.7,37.9-10.9h0Z" }, null, -1), lyr = [
  iyr
], dyr = { key: 3 }, kyr = ["stroke"], cyr = ["stroke"], hyr = ["stroke"], uyr = ["stroke"], ayr = { key: 4 }, _yr = ["stroke"], pyr = ["stroke"], yyr = ["stroke"], $yr = ["stroke"], wyr = { key: 5 }, fyr = ["stroke"], gyr = ["stroke"], xyr = ["stroke"], jyr = ["stroke"], myr = {
  name: "PhPopcorn"
}, VY1 = /* @__PURE__ */ $({
  ...myr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", O3r, [
        e("path", {
          d: "M35.1,93.3,62.5,209.8a8.1,8.1,0,0,0,7.8,6.2H185.7a8.1,8.1,0,0,0,7.8-6.2L220.9,93.3a8.1,8.1,0,0,0-10-9.6L168,96,131,81.2a7.8,7.8,0,0,0-6,0L88,96,45.1,83.7A8.1,8.1,0,0,0,35.1,93.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, I3r),
        e("line", {
          x1: "88",
          y1: "96",
          x2: "104",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, K3r),
        e("line", {
          x1: "168",
          y1: "96",
          x2: "152",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X3r),
        e("path", {
          d: "M216,84a36,36,0,0,0-52.9-31.8,35.9,35.9,0,0,0-70.2,0A36,36,0,0,0,40,84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, J3r)
      ])) : o(i) === "duotone" ? (s(), r("g", Q3r, [
        Y3r,
        oyr,
        e("path", {
          d: "M35.1,93.3,62.5,209.8a8.1,8.1,0,0,0,7.8,6.2H185.7a8.1,8.1,0,0,0,7.8-6.2L220.9,93.3a8.1,8.1,0,0,0-10-9.6L168,96,131,81.2a7.8,7.8,0,0,0-6,0L88,96,45.1,83.7A8.1,8.1,0,0,0,35.1,93.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eyr),
        e("line", {
          x1: "88",
          y1: "96",
          x2: "104",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tyr),
        e("line", {
          x1: "168",
          y1: "96",
          x2: "152",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nyr),
        e("path", {
          d: "M216,84a36,36,0,0,0-52.9-31.8,35.9,35.9,0,0,0-70.2,0A36,36,0,0,0,40,84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, syr)
      ])) : o(i) === "fill" ? (s(), r("g", ryr, lyr)) : o(i) === "light" ? (s(), r("g", dyr, [
        e("path", {
          d: "M35.1,93.3,62.5,209.8a8.1,8.1,0,0,0,7.8,6.2H185.7a8.1,8.1,0,0,0,7.8-6.2L220.9,93.3a8.1,8.1,0,0,0-10-9.6L168,96,131,81.2a7.8,7.8,0,0,0-6,0L88,96,45.1,83.7A8.1,8.1,0,0,0,35.1,93.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kyr),
        e("line", {
          x1: "88",
          y1: "96",
          x2: "104",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cyr),
        e("line", {
          x1: "168",
          y1: "96",
          x2: "152",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hyr),
        e("path", {
          d: "M216,84a36,36,0,0,0-52.9-31.8,35.9,35.9,0,0,0-70.2,0A36,36,0,0,0,40,84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uyr)
      ])) : o(i) === "thin" ? (s(), r("g", ayr, [
        e("path", {
          d: "M35.1,93.3,62.5,209.8a8.1,8.1,0,0,0,7.8,6.2H185.7a8.1,8.1,0,0,0,7.8-6.2L220.9,93.3a8.1,8.1,0,0,0-10-9.6L168,96,131,81.2a7.8,7.8,0,0,0-6,0L88,96,45.1,83.7A8.1,8.1,0,0,0,35.1,93.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _yr),
        e("line", {
          x1: "88",
          y1: "96",
          x2: "104",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pyr),
        e("line", {
          x1: "168",
          y1: "96",
          x2: "152",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yyr),
        e("path", {
          d: "M216,84a36,36,0,0,0-52.9-31.8,35.9,35.9,0,0,0-70.2,0A36,36,0,0,0,40,84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $yr)
      ])) : o(i) === "regular" ? (s(), r("g", wyr, [
        e("path", {
          d: "M35.1,93.3,62.5,209.8a8.1,8.1,0,0,0,7.8,6.2H185.7a8.1,8.1,0,0,0,7.8-6.2L220.9,93.3a8.1,8.1,0,0,0-10-9.6L168,96,131,81.2a7.8,7.8,0,0,0-6,0L88,96,45.1,83.7A8.1,8.1,0,0,0,35.1,93.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fyr),
        e("line", {
          x1: "88",
          y1: "96",
          x2: "104",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gyr),
        e("line", {
          x1: "168",
          y1: "96",
          x2: "152",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xyr),
        e("path", {
          d: "M216,84a36,36,0,0,0-52.9-31.8,35.9,35.9,0,0,0-70.2,0A36,36,0,0,0,40,84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jyr)
      ])) : g("", !0)
    ], 16, E3r));
  }
}), Myr = ["width", "height", "fill", "transform"], vyr = { key: 0 }, Syr = ["stroke"], Hyr = ["stroke"], Ayr = { key: 1 }, Vyr = ["stroke"], zyr = ["stroke"], Zyr = { key: 2 }, Cyr = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm-8,32a8,8,0,0,1,16,0v60a8,8,0,0,1-16,0Zm8,152A80,80,0,0,1,83.5,61.5a8,8,0,0,1,8.9,13.3,64.1,64.1,0,1,0,71.1,0,8.1,8.1,0,0,1-2.2-11.1,8,8,0,0,1,11.1-2.2A80,80,0,0,1,128,208Z" }, null, -1), byr = [
  Cyr
], Lyr = { key: 3 }, Byr = ["stroke"], Pyr = ["stroke"], Wyr = { key: 4 }, Nyr = ["stroke"], Fyr = ["stroke"], Tyr = { key: 5 }, Dyr = ["stroke"], Ryr = ["stroke"], Uyr = {
  name: "PhPower"
}, zY1 = /* @__PURE__ */ $({
  ...Uyr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", vyr, [
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Syr),
        e("path", {
          d: "M176,54.2a88,88,0,1,1-96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hyr)
      ])) : o(i) === "duotone" ? (s(), r("g", Ayr, [
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vyr),
        e("path", {
          d: "M176,54.2a88,88,0,1,1-96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zyr)
      ])) : o(i) === "fill" ? (s(), r("g", Zyr, byr)) : o(i) === "light" ? (s(), r("g", Lyr, [
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Byr),
        e("path", {
          d: "M176,54.2a88,88,0,1,1-96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pyr)
      ])) : o(i) === "thin" ? (s(), r("g", Wyr, [
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nyr),
        e("path", {
          d: "M176,54.2a88,88,0,1,1-96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fyr)
      ])) : o(i) === "regular" ? (s(), r("g", Tyr, [
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dyr),
        e("path", {
          d: "M176,54.2a88,88,0,1,1-96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ryr)
      ])) : g("", !0)
    ], 16, Myr));
  }
}), qyr = ["width", "height", "fill", "transform"], Gyr = { key: 0 }, Eyr = ["stroke"], Oyr = ["stroke"], Iyr = ["stroke"], Kyr = { key: 1 }, Xyr = ["stroke"], Jyr = /* @__PURE__ */ e("path", {
  d: "M72,128h48a44,44,0,0,0,0-88H72Z",
  opacity: "0.2"
}, null, -1), Qyr = ["stroke"], Yyr = ["stroke"], o5r = { key: 2 }, e5r = /* @__PURE__ */ e("path", { d: "M183.3,188l22.4-22.3a8.1,8.1,0,0,0-11.4-11.4L172,176.7,130.3,135A52,52,0,0,0,120,32H72a8,8,0,0,0-8,8V192a8,8,0,0,0,16,0V136h28.7l52,52-22.4,22.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L172,199.3l22.3,22.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4ZM80,48h40a36,36,0,0,1,0,72H80Z" }, null, -1), t5r = [
  e5r
], n5r = { key: 3 }, s5r = ["stroke"], r5r = ["stroke"], i5r = ["stroke"], l5r = { key: 4 }, d5r = ["stroke"], k5r = ["stroke"], c5r = ["stroke"], h5r = { key: 5 }, u5r = ["stroke"], a5r = ["stroke"], _5r = ["stroke"], p5r = {
  name: "PhPrescription"
}, ZY1 = /* @__PURE__ */ $({
  ...p5r,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Gyr, [
        e("path", {
          d: "M72,128h48a44,44,0,0,0,0-88H72V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Eyr),
        e("line", {
          x1: "112",
          y1: "128",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Oyr),
        e("line", {
          x1: "200",
          y1: "160",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Iyr)
      ])) : o(i) === "duotone" ? (s(), r("g", Kyr, [
        e("path", {
          d: "M72,128h48a44,44,0,0,0,0-88H72V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xyr),
        Jyr,
        e("line", {
          x1: "112",
          y1: "128",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qyr),
        e("line", {
          x1: "200",
          y1: "160",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yyr)
      ])) : o(i) === "fill" ? (s(), r("g", o5r, t5r)) : o(i) === "light" ? (s(), r("g", n5r, [
        e("path", {
          d: "M72,128h48a44,44,0,0,0,0-88H72V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, s5r),
        e("line", {
          x1: "112",
          y1: "128",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, r5r),
        e("line", {
          x1: "200",
          y1: "160",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, i5r)
      ])) : o(i) === "thin" ? (s(), r("g", l5r, [
        e("path", {
          d: "M72,128h48a44,44,0,0,0,0-88H72V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, d5r),
        e("line", {
          x1: "112",
          y1: "128",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, k5r),
        e("line", {
          x1: "200",
          y1: "160",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, c5r)
      ])) : o(i) === "regular" ? (s(), r("g", h5r, [
        e("path", {
          d: "M72,128h48a44,44,0,0,0,0-88H72V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u5r),
        e("line", {
          x1: "112",
          y1: "128",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a5r),
        e("line", {
          x1: "200",
          y1: "160",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _5r)
      ])) : g("", !0)
    ], 16, qyr));
  }
}), y5r = ["width", "height", "fill", "transform"], $5r = { key: 0 }, w5r = ["stroke"], f5r = ["stroke"], g5r = ["stroke"], x5r = ["stroke"], j5r = { key: 1 }, m5r = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "48",
  width: "192",
  height: "136",
  rx: "8",
  opacity: "0.2"
}, null, -1), M5r = ["stroke"], v5r = ["stroke"], S5r = ["stroke"], H5r = ["stroke"], A5r = { key: 2 }, V5r = /* @__PURE__ */ e("path", { d: "M216,40H136V24a8,8,0,0,0-16,0V40H40A16,16,0,0,0,24,56V176a16,16,0,0,0,16,16H79.4L57.8,219A8,8,0,0,0,64,232a7.8,7.8,0,0,0,6.2-3l29.6-37h56.4l29.6,37a7.8,7.8,0,0,0,6.2,3,8,8,0,0,0,6.2-13l-21.6-27H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Z" }, null, -1), z5r = [
  V5r
], Z5r = { key: 3 }, C5r = ["stroke"], b5r = ["stroke"], L5r = ["stroke"], B5r = ["stroke"], P5r = { key: 4 }, W5r = ["stroke"], N5r = ["stroke"], F5r = ["stroke"], T5r = ["stroke"], D5r = { key: 5 }, R5r = ["stroke"], U5r = ["stroke"], q5r = ["stroke"], G5r = ["stroke"], E5r = {
  name: "PhPresentation"
}, CY1 = /* @__PURE__ */ $({
  ...E5r,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $5r, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "136",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, w5r),
        e("line", {
          x1: "160",
          y1: "184",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f5r),
        e("line", {
          x1: "96",
          y1: "184",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g5r),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, x5r)
      ])) : o(i) === "duotone" ? (s(), r("g", j5r, [
        m5r,
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "136",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M5r),
        e("line", {
          x1: "160",
          y1: "184",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v5r),
        e("line", {
          x1: "96",
          y1: "184",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S5r),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H5r)
      ])) : o(i) === "fill" ? (s(), r("g", A5r, z5r)) : o(i) === "light" ? (s(), r("g", Z5r, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "136",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, C5r),
        e("line", {
          x1: "160",
          y1: "184",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b5r),
        e("line", {
          x1: "96",
          y1: "184",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, L5r),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, B5r)
      ])) : o(i) === "thin" ? (s(), r("g", P5r, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "136",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, W5r),
        e("line", {
          x1: "160",
          y1: "184",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, N5r),
        e("line", {
          x1: "96",
          y1: "184",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, F5r),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, T5r)
      ])) : o(i) === "regular" ? (s(), r("g", D5r, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "136",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R5r),
        e("line", {
          x1: "160",
          y1: "184",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U5r),
        e("line", {
          x1: "96",
          y1: "184",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q5r),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G5r)
      ])) : g("", !0)
    ], 16, y5r));
  }
}), O5r = ["width", "height", "fill", "transform"], I5r = { key: 0 }, K5r = ["stroke"], X5r = ["stroke"], J5r = ["stroke"], Q5r = ["stroke"], Y5r = ["stroke"], o7r = ["stroke"], e7r = ["stroke"], t7r = { key: 1 }, n7r = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "48",
  width: "192",
  height: "136",
  rx: "8",
  opacity: "0.2"
}, null, -1), s7r = ["stroke"], r7r = ["stroke"], i7r = ["stroke"], l7r = ["stroke"], d7r = ["stroke"], k7r = ["stroke"], c7r = ["stroke"], h7r = { key: 2 }, u7r = /* @__PURE__ */ e("path", { d: "M216,40H136V24a8,8,0,0,0-16,0V40H40A16,16,0,0,0,24,56V176a16,16,0,0,0,16,16H79.4L57.8,219A8,8,0,0,0,64,232a7.8,7.8,0,0,0,6.2-3l29.6-37h56.4l29.6,37a7.8,7.8,0,0,0,6.2,3,8,8,0,0,0,6.2-13l-21.6-27H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM104,144a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z" }, null, -1), a7r = [
  u7r
], _7r = { key: 3 }, p7r = ["stroke"], y7r = ["stroke"], $7r = ["stroke"], w7r = ["stroke"], f7r = ["stroke"], g7r = ["stroke"], x7r = ["stroke"], j7r = { key: 4 }, m7r = ["stroke"], M7r = ["stroke"], v7r = ["stroke"], S7r = ["stroke"], H7r = ["stroke"], A7r = ["stroke"], V7r = ["stroke"], z7r = { key: 5 }, Z7r = ["stroke"], C7r = ["stroke"], b7r = ["stroke"], L7r = ["stroke"], B7r = ["stroke"], P7r = ["stroke"], W7r = ["stroke"], N7r = {
  name: "PhPresentationChart"
}, bY1 = /* @__PURE__ */ $({
  ...N7r,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", I5r, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "136",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, K5r),
        e("line", {
          x1: "160",
          y1: "184",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X5r),
        e("line", {
          x1: "96",
          y1: "184",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, J5r),
        e("line", {
          x1: "92",
          y1: "120",
          x2: "92",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Q5r),
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Y5r),
        e("line", {
          x1: "164",
          y1: "88",
          x2: "164",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, o7r),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, e7r)
      ])) : o(i) === "duotone" ? (s(), r("g", t7r, [
        n7r,
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "136",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s7r),
        e("line", {
          x1: "160",
          y1: "184",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r7r),
        e("line", {
          x1: "96",
          y1: "184",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, i7r),
        e("line", {
          x1: "96",
          y1: "120",
          x2: "96",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l7r),
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, d7r),
        e("line", {
          x1: "160",
          y1: "88",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k7r),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c7r)
      ])) : o(i) === "fill" ? (s(), r("g", h7r, a7r)) : o(i) === "light" ? (s(), r("g", _7r, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "136",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, p7r),
        e("line", {
          x1: "160",
          y1: "184",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, y7r),
        e("line", {
          x1: "96",
          y1: "184",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $7r),
        e("line", {
          x1: "96",
          y1: "120",
          x2: "96",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, w7r),
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, f7r),
        e("line", {
          x1: "160",
          y1: "88",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, g7r),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, x7r)
      ])) : o(i) === "thin" ? (s(), r("g", j7r, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "136",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, m7r),
        e("line", {
          x1: "160",
          y1: "184",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, M7r),
        e("line", {
          x1: "96",
          y1: "184",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, v7r),
        e("line", {
          x1: "96",
          y1: "120",
          x2: "96",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, S7r),
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, H7r),
        e("line", {
          x1: "160",
          y1: "88",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, A7r),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, V7r)
      ])) : o(i) === "regular" ? (s(), r("g", z7r, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "136",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z7r),
        e("line", {
          x1: "160",
          y1: "184",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C7r),
        e("line", {
          x1: "96",
          y1: "184",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b7r),
        e("line", {
          x1: "96",
          y1: "120",
          x2: "96",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L7r),
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B7r),
        e("line", {
          x1: "160",
          y1: "88",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P7r),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W7r)
      ])) : g("", !0)
    ], 16, O5r));
  }
}), F7r = ["width", "height", "fill", "transform"], T7r = { key: 0 }, D7r = ["stroke"], R7r = ["stroke"], U7r = ["stroke"], q7r = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "116",
  r: "16"
}, null, -1), G7r = { key: 1 }, E7r = /* @__PURE__ */ e("path", {
  d: "M210.7,80H45.3C35.8,80,28,87.2,28,96v80H64V152H192v24h36V96C228,87.2,220.2,80,210.7,80Z",
  opacity: "0.2"
}, null, -1), O7r = ["stroke"], I7r = ["stroke"], K7r = ["stroke"], X7r = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "116",
  r: "12"
}, null, -1), J7r = { key: 2 }, Q7r = /* @__PURE__ */ e("path", { d: "M210.7,72H200V40a8,8,0,0,0-8-8H64a8,8,0,0,0-8,8V72H45.3C31.4,72,20,82.8,20,96v80a8,8,0,0,0,8,8H56v36a8,8,0,0,0,8,8H192a8,8,0,0,0,8-8V184h28a8,8,0,0,0,8-8V96C236,82.8,224.6,72,210.7,72ZM72,48H184V72H72ZM184,212H72V160H184Zm4-84a12,12,0,1,1,12-12A12,12,0,0,1,188,128Z" }, null, -1), Y7r = [
  Q7r
], o9r = { key: 3 }, e9r = ["stroke"], t9r = ["stroke"], n9r = ["stroke"], s9r = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "116",
  r: "10"
}, null, -1), r9r = { key: 4 }, i9r = ["stroke"], l9r = ["stroke"], d9r = ["stroke"], k9r = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "116",
  r: "8"
}, null, -1), c9r = { key: 5 }, h9r = ["stroke"], u9r = ["stroke"], a9r = ["stroke"], _9r = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "116",
  r: "12"
}, null, -1), p9r = {
  name: "PhPrinter"
}, LY1 = /* @__PURE__ */ $({
  ...p9r,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", T7r, [
        e("rect", {
          x: "64",
          y: "40",
          width: "128",
          height: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, D7r),
        e("rect", {
          x: "64",
          y: "156",
          width: "128",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, R7r),
        e("path", {
          d: "M64,176H28V96c0-8.8,7.8-16,17.3-16H210.7c9.5,0,17.3,7.2,17.3,16v80H192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, U7r),
        q7r
      ])) : o(i) === "duotone" ? (s(), r("g", G7r, [
        E7r,
        e("rect", {
          x: "64",
          y: "40",
          width: "128",
          height: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O7r),
        e("rect", {
          x: "64",
          y: "152",
          width: "128",
          height: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I7r),
        e("path", {
          d: "M64,176H28V96c0-8.8,7.8-16,17.3-16H210.7c9.5,0,17.3,7.2,17.3,16v80H192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K7r),
        X7r
      ])) : o(i) === "fill" ? (s(), r("g", J7r, Y7r)) : o(i) === "light" ? (s(), r("g", o9r, [
        e("polyline", {
          points: "64 80 64 40 192 40 192 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, e9r),
        e("rect", {
          x: "64",
          y: "152",
          width: "128",
          height: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, t9r),
        e("path", {
          d: "M64,176H28V96c0-8.8,7.8-16,17.3-16H210.7c9.5,0,17.3,7.2,17.3,16v80H192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, n9r),
        s9r
      ])) : o(i) === "thin" ? (s(), r("g", r9r, [
        e("polyline", {
          points: "64 80 64 40 192 40 192 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, i9r),
        e("rect", {
          x: "64",
          y: "152",
          width: "128",
          height: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, l9r),
        e("path", {
          d: "M64,176H28V96c0-8.8,7.8-16,17.3-16H210.7c9.5,0,17.3,7.2,17.3,16v80H192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, d9r),
        k9r
      ])) : o(i) === "regular" ? (s(), r("g", c9r, [
        e("polyline", {
          points: "64 80 64 40 192 40 192 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h9r),
        e("rect", {
          x: "64",
          y: "152",
          width: "128",
          height: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u9r),
        e("path", {
          d: "M64,176H28V96c0-8.8,7.8-16,17.3-16H210.7c9.5,0,17.3,7.2,17.3,16v80H192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a9r),
        _9r
      ])) : g("", !0)
    ], 16, F7r));
  }
}), y9r = ["width", "height", "fill", "transform"], $9r = { key: 0 }, w9r = ["stroke"], f9r = ["stroke"], g9r = { key: 1 }, x9r = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), j9r = ["stroke"], m9r = ["stroke"], M9r = { key: 2 }, v9r = /* @__PURE__ */ e("path", { d: "M200,128a71.3,71.3,0,0,1-15.8,44.9L83.1,71.8A71.3,71.3,0,0,1,128,56,72.1,72.1,0,0,1,200,128ZM56,128a72.1,72.1,0,0,0,72,72,71.3,71.3,0,0,0,44.9-15.8L71.8,83.1A71.3,71.3,0,0,0,56,128Zm180,0A108,108,0,1,1,128,20,108.1,108.1,0,0,1,236,128Zm-20,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z" }, null, -1), S9r = [
  v9r
], H9r = { key: 3 }, A9r = ["stroke"], V9r = ["stroke"], z9r = { key: 4 }, Z9r = ["stroke"], C9r = ["stroke"], b9r = { key: 5 }, L9r = ["stroke"], B9r = ["stroke"], P9r = {
  name: "PhProhibit"
}, BY1 = /* @__PURE__ */ $({
  ...P9r,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $9r, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, w9r),
        e("line", {
          x1: "60.1",
          y1: "60.1",
          x2: "195.9",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f9r)
      ])) : o(i) === "duotone" ? (s(), r("g", g9r, [
        x9r,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, j9r),
        e("line", {
          x1: "60.1",
          y1: "60.1",
          x2: "195.9",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m9r)
      ])) : o(i) === "fill" ? (s(), r("g", M9r, S9r)) : o(i) === "light" ? (s(), r("g", H9r, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, A9r),
        e("line", {
          x1: "60.1",
          y1: "60.1",
          x2: "195.9",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, V9r)
      ])) : o(i) === "thin" ? (s(), r("g", z9r, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Z9r),
        e("line", {
          x1: "60.1",
          y1: "60.1",
          x2: "195.9",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, C9r)
      ])) : o(i) === "regular" ? (s(), r("g", b9r, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, L9r),
        e("line", {
          x1: "60.1",
          y1: "60.1",
          x2: "195.9",
          y2: "195.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B9r)
      ])) : g("", !0)
    ], 16, y9r));
  }
}), W9r = ["width", "height", "fill", "transform"], N9r = { key: 0 }, F9r = ["stroke"], T9r = ["stroke"], D9r = { key: 1 }, R9r = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), U9r = ["stroke"], q9r = ["stroke"], G9r = { key: 2 }, E9r = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm22.6,137.9L94.1,105.4a8,8,0,0,1,11.3-11.3l56.5,56.5a8,8,0,0,1-11.3,11.3Z" }, null, -1), O9r = [
  E9r
], I9r = { key: 3 }, K9r = ["stroke"], X9r = ["stroke"], J9r = { key: 4 }, Q9r = ["stroke"], Y9r = ["stroke"], o$r = { key: 5 }, e$r = ["stroke"], t$r = ["stroke"], n$r = {
  name: "PhProhibitInset"
}, PY1 = /* @__PURE__ */ $({
  ...n$r,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", N9r, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, F9r),
        e("line", {
          x1: "99.7",
          y1: "99.7",
          x2: "156.3",
          y2: "156.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, T9r)
      ])) : o(i) === "duotone" ? (s(), r("g", D9r, [
        R9r,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, U9r),
        e("line", {
          x1: "99.7",
          y1: "99.7",
          x2: "156.3",
          y2: "156.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q9r)
      ])) : o(i) === "fill" ? (s(), r("g", G9r, O9r)) : o(i) === "light" ? (s(), r("g", I9r, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, K9r),
        e("line", {
          x1: "99.7",
          y1: "99.7",
          x2: "156.3",
          y2: "156.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, X9r)
      ])) : o(i) === "thin" ? (s(), r("g", J9r, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Q9r),
        e("line", {
          x1: "99.7",
          y1: "99.7",
          x2: "156.3",
          y2: "156.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Y9r)
      ])) : o(i) === "regular" ? (s(), r("g", o$r, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, e$r),
        e("line", {
          x1: "99.7",
          y1: "99.7",
          x2: "156.3",
          y2: "156.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t$r)
      ])) : g("", !0)
    ], 16, W9r));
  }
}), s$r = ["width", "height", "fill", "transform"], r$r = { key: 0 }, i$r = ["stroke"], l$r = ["stroke"], d$r = ["stroke"], k$r = ["stroke"], c$r = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "232",
  r: "24"
}, null, -1), h$r = ["stroke"], u$r = { key: 1 }, a$r = /* @__PURE__ */ e("rect", {
  x: "48",
  y: "72",
  width: "160",
  height: "112",
  opacity: "0.2"
}, null, -1), _$r = ["stroke"], p$r = ["stroke"], y$r = ["stroke"], $$r = ["stroke"], w$r = ["stroke"], f$r = ["stroke"], g$r = { key: 2 }, x$r = /* @__PURE__ */ e("path", { d: "M232,64V48a16,16,0,0,0-16-16H40A16,16,0,0,0,24,48V64A16,16,0,0,0,40,80v96H32a8,8,0,0,0,0,16h88v17.4a24,24,0,1,0,16,0V192h88a8,8,0,0,0,0-16h-8V80A16,16,0,0,0,232,64ZM128,240a8,8,0,1,1,8-8A8,8,0,0,1,128,240ZM40,48H216V64H40Z" }, null, -1), j$r = [
  x$r
], m$r = { key: 3 }, M$r = ["stroke"], v$r = ["stroke"], S$r = ["stroke"], H$r = ["stroke"], A$r = ["stroke"], V$r = ["stroke"], z$r = { key: 4 }, Z$r = ["stroke"], C$r = ["stroke"], b$r = ["stroke"], L$r = ["stroke"], B$r = ["stroke"], P$r = ["stroke"], W$r = { key: 5 }, N$r = ["stroke"], F$r = ["stroke"], T$r = ["stroke"], D$r = ["stroke"], R$r = ["stroke"], U$r = ["stroke"], q$r = {
  name: "PhProjectorScreen"
}, WY1 = /* @__PURE__ */ $({
  ...q$r,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", r$r, [
        e("line", {
          x1: "48",
          y1: "176",
          x2: "48",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, i$r),
        e("line", {
          x1: "208",
          y1: "80",
          x2: "208",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, l$r),
        e("rect", {
          x: "32",
          y: "40",
          width: "192",
          height: "40",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, d$r),
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, k$r),
        c$r,
        e("line", {
          x1: "32",
          y1: "176",
          x2: "224",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, h$r)
      ])) : o(i) === "duotone" ? (s(), r("g", u$r, [
        a$r,
        e("line", {
          x1: "48",
          y1: "184",
          x2: "48",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _$r),
        e("line", {
          x1: "208",
          y1: "72",
          x2: "208",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p$r),
        e("rect", {
          x: "32",
          y: "40",
          width: "192",
          height: "32",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y$r),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $$r),
        e("circle", {
          cx: "128",
          cy: "232",
          r: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w$r),
        e("line", {
          x1: "32",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f$r)
      ])) : o(i) === "fill" ? (s(), r("g", g$r, j$r)) : o(i) === "light" ? (s(), r("g", m$r, [
        e("line", {
          x1: "48",
          y1: "184",
          x2: "48",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, M$r),
        e("line", {
          x1: "208",
          y1: "72",
          x2: "208",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, v$r),
        e("rect", {
          x: "32",
          y: "40",
          width: "192",
          height: "32",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, S$r),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, H$r),
        e("circle", {
          cx: "128",
          cy: "232",
          r: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, A$r),
        e("line", {
          x1: "32",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, V$r)
      ])) : o(i) === "thin" ? (s(), r("g", z$r, [
        e("line", {
          x1: "48",
          y1: "184",
          x2: "48",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Z$r),
        e("line", {
          x1: "208",
          y1: "72",
          x2: "208",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, C$r),
        e("rect", {
          x: "32",
          y: "40",
          width: "192",
          height: "32",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, b$r),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, L$r),
        e("circle", {
          cx: "128",
          cy: "232",
          r: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, B$r),
        e("line", {
          x1: "32",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, P$r)
      ])) : o(i) === "regular" ? (s(), r("g", W$r, [
        e("line", {
          x1: "48",
          y1: "184",
          x2: "48",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N$r),
        e("line", {
          x1: "208",
          y1: "72",
          x2: "208",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F$r),
        e("rect", {
          x: "32",
          y: "40",
          width: "192",
          height: "32",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T$r),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D$r),
        e("circle", {
          cx: "128",
          cy: "232",
          r: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R$r),
        e("line", {
          x1: "32",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U$r)
      ])) : g("", !0)
    ], 16, s$r));
  }
}), G$r = ["width", "height", "fill", "transform"], E$r = { key: 0 }, O$r = ["stroke"], I$r = ["stroke"], K$r = ["stroke"], X$r = ["stroke"], J$r = ["stroke"], Q$r = ["stroke"], Y$r = ["stroke"], owr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "232",
  r: "24"
}, null, -1), ewr = ["stroke"], twr = { key: 1 }, nwr = /* @__PURE__ */ e("rect", {
  x: "48",
  y: "72",
  width: "160",
  height: "112",
  opacity: "0.2"
}, null, -1), swr = ["stroke"], rwr = ["stroke"], iwr = ["stroke"], lwr = ["stroke"], dwr = ["stroke"], kwr = ["stroke"], cwr = ["stroke"], hwr = ["stroke"], uwr = ["stroke"], awr = { key: 2 }, _wr = /* @__PURE__ */ e("path", { d: "M232,64V48a16,16,0,0,0-16-16H40A16,16,0,0,0,24,48V64A16,16,0,0,0,40,80v96H32a8,8,0,0,0,0,16h88v17.4a24,24,0,1,0,16,0V192h88a8,8,0,0,0,0-16h-8V80A16,16,0,0,0,232,64ZM104,144a8,8,0,0,1-16,0V128a8,8,0,0,1,16,0Zm24,96a8,8,0,1,1,8-8A8,8,0,0,1,128,240Zm8-96a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V112a8,8,0,0,1,16,0ZM40,64V48H216V64H40Z" }, null, -1), pwr = [
  _wr
], ywr = { key: 3 }, $wr = ["stroke"], wwr = ["stroke"], fwr = ["stroke"], gwr = ["stroke"], xwr = ["stroke"], jwr = ["stroke"], mwr = ["stroke"], Mwr = ["stroke"], vwr = ["stroke"], Swr = { key: 4 }, Hwr = ["stroke"], Awr = ["stroke"], Vwr = ["stroke"], zwr = ["stroke"], Zwr = ["stroke"], Cwr = ["stroke"], bwr = ["stroke"], Lwr = ["stroke"], Bwr = ["stroke"], Pwr = { key: 5 }, Wwr = ["stroke"], Nwr = ["stroke"], Fwr = ["stroke"], Twr = ["stroke"], Dwr = ["stroke"], Rwr = ["stroke"], Uwr = ["stroke"], qwr = ["stroke"], Gwr = ["stroke"], Ewr = {
  name: "PhProjectorScreenChart"
}, NY1 = /* @__PURE__ */ $({
  ...Ewr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", E$r, [
        e("line", {
          x1: "92",
          y1: "128",
          x2: "92",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, O$r),
        e("line", {
          x1: "128",
          y1: "124",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, I$r),
        e("line", {
          x1: "164",
          y1: "120",
          x2: "164",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, K$r),
        e("line", {
          x1: "48",
          y1: "176",
          x2: "48",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X$r),
        e("line", {
          x1: "208",
          y1: "80",
          x2: "208",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, J$r),
        e("rect", {
          x: "32",
          y: "40",
          width: "192",
          height: "40",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Q$r),
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Y$r),
        owr,
        e("line", {
          x1: "32",
          y1: "176",
          x2: "224",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ewr)
      ])) : o(i) === "duotone" ? (s(), r("g", twr, [
        nwr,
        e("line", {
          x1: "48",
          y1: "184",
          x2: "48",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, swr),
        e("line", {
          x1: "208",
          y1: "72",
          x2: "208",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rwr),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "96",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iwr),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lwr),
        e("line", {
          x1: "160",
          y1: "112",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dwr),
        e("rect", {
          x: "32",
          y: "40",
          width: "192",
          height: "32",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kwr),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cwr),
        e("circle", {
          cx: "128",
          cy: "232",
          r: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hwr),
        e("line", {
          x1: "32",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uwr)
      ])) : o(i) === "fill" ? (s(), r("g", awr, pwr)) : o(i) === "light" ? (s(), r("g", ywr, [
        e("line", {
          x1: "48",
          y1: "184",
          x2: "48",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $wr),
        e("line", {
          x1: "208",
          y1: "72",
          x2: "208",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wwr),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "96",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fwr),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gwr),
        e("line", {
          x1: "160",
          y1: "112",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xwr),
        e("rect", {
          x: "32",
          y: "40",
          width: "192",
          height: "32",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jwr),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mwr),
        e("circle", {
          cx: "128",
          cy: "232",
          r: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mwr),
        e("line", {
          x1: "32",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vwr)
      ])) : o(i) === "thin" ? (s(), r("g", Swr, [
        e("line", {
          x1: "48",
          y1: "184",
          x2: "48",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hwr),
        e("line", {
          x1: "208",
          y1: "72",
          x2: "208",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Awr),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "96",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vwr),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zwr),
        e("line", {
          x1: "160",
          y1: "112",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zwr),
        e("rect", {
          x: "32",
          y: "40",
          width: "192",
          height: "32",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cwr),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bwr),
        e("circle", {
          cx: "128",
          cy: "232",
          r: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lwr),
        e("line", {
          x1: "32",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bwr)
      ])) : o(i) === "regular" ? (s(), r("g", Pwr, [
        e("line", {
          x1: "48",
          y1: "184",
          x2: "48",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wwr),
        e("line", {
          x1: "208",
          y1: "72",
          x2: "208",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nwr),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "96",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fwr),
        e("line", {
          x1: "128",
          y1: "120",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Twr),
        e("line", {
          x1: "160",
          y1: "112",
          x2: "160",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dwr),
        e("rect", {
          x: "32",
          y: "40",
          width: "192",
          height: "32",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rwr),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uwr),
        e("circle", {
          cx: "128",
          cy: "232",
          r: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qwr),
        e("line", {
          x1: "32",
          y1: "184",
          x2: "224",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gwr)
      ])) : g("", !0)
    ], 16, G$r));
  }
}), Owr = ["width", "height", "fill", "transform"], Iwr = { key: 0 }, Kwr = ["stroke"], Xwr = ["stroke"], Jwr = { key: 1 }, Qwr = /* @__PURE__ */ e("path", {
  d: "M154.3,29.7,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c8.4-11.1,21.6-34.1,10.1-57l62.3-62.3a8,8,0,0,0,0-11.4L165.7,29.7A8,8,0,0,0,154.3,29.7Z",
  opacity: "0.2"
}, null, -1), Ywr = ["stroke"], ofr = ["stroke"], efr = { key: 2 }, tfr = /* @__PURE__ */ e("path", { d: "M232,107.3l-58.5,58.5c4.5,12.7,6.4,33.9-13.2,60a16.3,16.3,0,0,1-11.7,6.4h-1.1a16.1,16.1,0,0,1-11.3-4.7L88,179.3,53.7,213.7a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L76.7,168,28.3,119.6a15.9,15.9,0,0,1,1.3-23.8C55,75.3,79.3,79.4,90,82.7L148.7,24h0a16.1,16.1,0,0,1,22.6,0L232,84.7a15.9,15.9,0,0,1,0,22.6Z" }, null, -1), nfr = [
  tfr
], sfr = { key: 3 }, rfr = ["stroke"], ifr = ["stroke"], lfr = { key: 4 }, dfr = ["stroke"], kfr = ["stroke"], cfr = { key: 5 }, hfr = ["stroke"], ufr = ["stroke"], afr = {
  name: "PhPushPin"
}, FY1 = /* @__PURE__ */ $({
  ...afr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Iwr, [
        e("line", {
          x1: "88",
          y1: "168",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kwr),
        e("path", {
          d: "M154.3,29.7,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c8.4-11.1,21.6-34.1,10.1-57l62.3-62.3a8,8,0,0,0,0-11.4L165.7,29.7A8,8,0,0,0,154.3,29.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xwr)
      ])) : o(i) === "duotone" ? (s(), r("g", Jwr, [
        Qwr,
        e("line", {
          x1: "88",
          y1: "168",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ywr),
        e("path", {
          d: "M154.3,29.7,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c8.4-11.1,21.6-34.1,10.1-57l62.3-62.3a8,8,0,0,0,0-11.4L165.7,29.7A8,8,0,0,0,154.3,29.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ofr)
      ])) : o(i) === "fill" ? (s(), r("g", efr, nfr)) : o(i) === "light" ? (s(), r("g", sfr, [
        e("line", {
          x1: "88",
          y1: "168",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rfr),
        e("path", {
          d: "M154.3,29.7,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c8.4-11.1,21.6-34.1,10.1-57l62.3-62.3a8,8,0,0,0,0-11.4L165.7,29.7A8,8,0,0,0,154.3,29.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ifr)
      ])) : o(i) === "thin" ? (s(), r("g", lfr, [
        e("line", {
          x1: "88",
          y1: "168",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dfr),
        e("path", {
          d: "M154.3,29.7,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c8.4-11.1,21.6-34.1,10.1-57l62.3-62.3a8,8,0,0,0,0-11.4L165.7,29.7A8,8,0,0,0,154.3,29.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kfr)
      ])) : o(i) === "regular" ? (s(), r("g", cfr, [
        e("line", {
          x1: "88",
          y1: "168",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hfr),
        e("path", {
          d: "M154.3,29.7,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c8.4-11.1,21.6-34.1,10.1-57l62.3-62.3a8,8,0,0,0,0-11.4L165.7,29.7A8,8,0,0,0,154.3,29.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ufr)
      ])) : g("", !0)
    ], 16, Owr));
  }
}), _fr = ["width", "height", "fill", "transform"], pfr = { key: 0 }, yfr = ["stroke"], $fr = ["stroke"], wfr = ["stroke"], ffr = ["stroke"], gfr = ["stroke"], xfr = { key: 1 }, jfr = /* @__PURE__ */ e("polygon", {
  points: "56 176 80 40 176 40 200 176 56 176",
  opacity: "0.2"
}, null, -1), mfr = ["stroke"], Mfr = ["stroke"], vfr = ["stroke"], Sfr = ["stroke"], Hfr = ["stroke"], Afr = { key: 2 }, Vfr = /* @__PURE__ */ e("path", { d: "M224,176a8,8,0,0,1-8,8H136v56a8,8,0,0,1-16,0V184H40a8,8,0,0,1,0-16h9.3L70.5,48H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16h-6.5l21.2,120H216A8,8,0,0,1,224,176Z" }, null, -1), zfr = [
  Vfr
], Zfr = { key: 3 }, Cfr = ["stroke"], bfr = ["stroke"], Lfr = ["stroke"], Bfr = ["stroke"], Pfr = ["stroke"], Wfr = { key: 4 }, Nfr = ["stroke"], Ffr = ["stroke"], Tfr = ["stroke"], Dfr = ["stroke"], Rfr = ["stroke"], Ufr = { key: 5 }, qfr = ["stroke"], Gfr = ["stroke"], Efr = ["stroke"], Ofr = ["stroke"], Ifr = ["stroke"], Kfr = {
  name: "PhPushPinSimple"
}, TY1 = /* @__PURE__ */ $({
  ...Kfr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", pfr, [
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yfr),
        e("line", {
          x1: "64",
          y1: "40",
          x2: "192",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $fr),
        e("line", {
          x1: "40",
          y1: "176",
          x2: "216",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wfr),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ffr),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "200",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gfr)
      ])) : o(i) === "duotone" ? (s(), r("g", xfr, [
        jfr,
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mfr),
        e("line", {
          x1: "64",
          y1: "40",
          x2: "192",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mfr),
        e("line", {
          x1: "40",
          y1: "176",
          x2: "216",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vfr),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sfr),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "200",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hfr)
      ])) : o(i) === "fill" ? (s(), r("g", Afr, zfr)) : o(i) === "light" ? (s(), r("g", Zfr, [
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cfr),
        e("line", {
          x1: "64",
          y1: "40",
          x2: "192",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bfr),
        e("line", {
          x1: "40",
          y1: "176",
          x2: "216",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lfr),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bfr),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "200",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pfr)
      ])) : o(i) === "thin" ? (s(), r("g", Wfr, [
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nfr),
        e("line", {
          x1: "64",
          y1: "40",
          x2: "192",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ffr),
        e("line", {
          x1: "40",
          y1: "176",
          x2: "216",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Tfr),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Dfr),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "200",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Rfr)
      ])) : o(i) === "regular" ? (s(), r("g", Ufr, [
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qfr),
        e("line", {
          x1: "64",
          y1: "40",
          x2: "192",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gfr),
        e("line", {
          x1: "40",
          y1: "176",
          x2: "216",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Efr),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "80",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ofr),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "200",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ifr)
      ])) : g("", !0)
    ], 16, _fr));
  }
}), Xfr = ["width", "height", "fill", "transform"], Jfr = { key: 0 }, Qfr = ["stroke"], Yfr = ["stroke"], ogr = ["stroke"], egr = ["stroke"], tgr = ["stroke"], ngr = ["stroke"], sgr = { key: 1 }, rgr = /* @__PURE__ */ e("polygon", {
  points: "56 176 80 40 176 40 200 176 56 176",
  opacity: "0.2"
}, null, -1), igr = ["stroke"], lgr = ["stroke"], dgr = ["stroke"], kgr = ["stroke"], cgr = ["stroke"], hgr = ["stroke"], ugr = { key: 2 }, agr = /* @__PURE__ */ e("path", { d: "M213.4,221.9A8.2,8.2,0,0,1,208,224a8,8,0,0,1-5.9-2.6l-34-37.4H136v56a8,8,0,0,1-16,0V184H40a8,8,0,0,1,0-16h9.3L66.2,72,42.1,45.4A8,8,0,0,1,53.9,34.6l75.2,82.8,48.5,53.2h0l36.3,40A7.9,7.9,0,0,1,213.4,221.9Zm-22.9-60.8a7.9,7.9,0,0,0,5.9,2.6,8.5,8.5,0,0,0,3.5-.8,8.1,8.1,0,0,0,4.4-8.6L185.5,48H192a8,8,0,0,0,0-16H91.2A8,8,0,0,0,86,34a9.4,9.4,0,0,0-1,1,8.3,8.3,0,0,0-1.7,4.5,1.1,1.1,0,0,0,0,.8,7.9,7.9,0,0,0,2,5.1Z" }, null, -1), _gr = [
  agr
], pgr = { key: 3 }, ygr = ["stroke"], $gr = ["stroke"], wgr = ["stroke"], fgr = ["stroke"], ggr = ["stroke"], xgr = ["stroke"], jgr = { key: 4 }, mgr = ["stroke"], Mgr = ["stroke"], vgr = ["stroke"], Sgr = ["stroke"], Hgr = ["stroke"], Agr = ["stroke"], Vgr = { key: 5 }, zgr = ["stroke"], Zgr = ["stroke"], Cgr = ["stroke"], bgr = ["stroke"], Lgr = ["stroke"], Bgr = ["stroke"], Pgr = {
  name: "PhPushPinSimpleSlash"
}, DY1 = /* @__PURE__ */ $({
  ...Pgr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Jfr, [
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qfr),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Yfr),
        e("line", {
          x1: "171.6",
          y1: "176",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ogr),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "74.8",
          y2: "69.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, egr),
        e("line", {
          x1: "102.1",
          y1: "40",
          x2: "192",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tgr),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "193.8",
          y2: "140.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ngr)
      ])) : o(i) === "duotone" ? (s(), r("g", sgr, [
        rgr,
        e("line", {
          x1: "91.2",
          y1: "40",
          x2: "192",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, igr),
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lgr),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dgr),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "196.4",
          y2: "155.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kgr),
        e("line", {
          x1: "171.6",
          y1: "176",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cgr),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "74.8",
          y2: "69.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hgr)
      ])) : o(i) === "fill" ? (s(), r("g", ugr, _gr)) : o(i) === "light" ? (s(), r("g", pgr, [
        e("line", {
          x1: "91.2",
          y1: "40",
          x2: "192",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ygr),
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $gr),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wgr),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "196.4",
          y2: "155.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fgr),
        e("line", {
          x1: "171.6",
          y1: "176",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ggr),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "74.8",
          y2: "69.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xgr)
      ])) : o(i) === "thin" ? (s(), r("g", jgr, [
        e("line", {
          x1: "91.2",
          y1: "40",
          x2: "192",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mgr),
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Mgr),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vgr),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "196.4",
          y2: "155.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Sgr),
        e("line", {
          x1: "171.6",
          y1: "176",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hgr),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "74.8",
          y2: "69.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Agr)
      ])) : o(i) === "regular" ? (s(), r("g", Vgr, [
        e("line", {
          x1: "91.2",
          y1: "40",
          x2: "192",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zgr),
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zgr),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cgr),
        e("line", {
          x1: "176",
          y1: "40",
          x2: "196.4",
          y2: "155.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bgr),
        e("line", {
          x1: "171.6",
          y1: "176",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lgr),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "74.8",
          y2: "69.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bgr)
      ])) : g("", !0)
    ], 16, Xfr));
  }
}), Wgr = ["width", "height", "fill", "transform"], Ngr = { key: 0 }, Fgr = ["stroke"], Tgr = ["stroke"], Dgr = ["stroke"], Rgr = ["stroke"], Ugr = { key: 1 }, qgr = /* @__PURE__ */ e("path", {
  d: "M154.3,29.7,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c8.4-11.1,21.6-34.1,10.1-57l62.3-62.3a8,8,0,0,0,0-11.4L165.7,29.7A8,8,0,0,0,154.3,29.7Z",
  opacity: "0.2"
}, null, -1), Ggr = ["stroke"], Egr = ["stroke"], Ogr = ["stroke"], Igr = ["stroke"], Kgr = { key: 2 }, Xgr = /* @__PURE__ */ e("path", { d: "M213.9,210.6a7.9,7.9,0,0,1-.5,11.3A8.2,8.2,0,0,1,208,224a8,8,0,0,1-5.9-2.6l-26.4-29.1c-2.5,14.2-9.9,26.2-15.4,33.5a16.3,16.3,0,0,1-11.7,6.4h-1.1a16.1,16.1,0,0,1-11.3-4.7L88,179.3,53.7,213.7a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L76.7,168,28.3,119.6a15.9,15.9,0,0,1,1.3-23.8C45.8,82.8,61.5,79.7,73.5,80L42.1,45.4A8,8,0,0,1,53.9,34.6ZM232,84.7,171.3,24a16.1,16.1,0,0,0-22.6,0l-38,38a8,8,0,0,0-.3,11L179,148.4a8.1,8.1,0,0,0,5.7,2.7h.2a8,8,0,0,0,5.7-2.4L232,107.3a15.9,15.9,0,0,0,0-22.6Z" }, null, -1), Jgr = [
  Xgr
], Qgr = { key: 3 }, Ygr = ["stroke"], oxr = ["stroke"], exr = ["stroke"], txr = ["stroke"], nxr = { key: 4 }, sxr = ["stroke"], rxr = ["stroke"], ixr = ["stroke"], lxr = ["stroke"], dxr = { key: 5 }, kxr = ["stroke"], cxr = ["stroke"], hxr = ["stroke"], uxr = ["stroke"], axr = {
  name: "PhPushPinSlash"
}, RY1 = /* @__PURE__ */ $({
  ...axr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ngr, [
        e("line", {
          x1: "88",
          y1: "168",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fgr),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Tgr),
        e("path", {
          d: "M93.7,90.3,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c7.6-10.1,19.1-29.9,12.7-50.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Dgr),
        e("path", {
          d: "M190.6,137.4l35.7-35.7a8,8,0,0,0,0-11.4L165.7,29.7a8,8,0,0,0-11.4,0L122,62",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rgr)
      ])) : o(i) === "duotone" ? (s(), r("g", Ugr, [
        qgr,
        e("line", {
          x1: "88",
          y1: "168",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ggr),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Egr),
        e("path", {
          d: "M93.7,90.3,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c7.6-10.1,19.1-29.9,12.7-50.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ogr),
        e("path", {
          d: "M184.9,143.1l41.4-41.4a8,8,0,0,0,0-11.4L165.7,29.7a8,8,0,0,0-11.4,0L116.4,67.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Igr)
      ])) : o(i) === "fill" ? (s(), r("g", Kgr, Jgr)) : o(i) === "light" ? (s(), r("g", Qgr, [
        e("line", {
          x1: "88",
          y1: "168",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ygr),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oxr),
        e("path", {
          d: "M93.7,90.3,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c7.6-10.1,19.1-29.9,12.7-50.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, exr),
        e("path", {
          d: "M184.9,143.1l41.4-41.4a8,8,0,0,0,0-11.4L165.7,29.7a8,8,0,0,0-11.4,0L116.4,67.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, txr)
      ])) : o(i) === "thin" ? (s(), r("g", nxr, [
        e("line", {
          x1: "88",
          y1: "168",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sxr),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rxr),
        e("path", {
          d: "M93.7,90.3,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c7.6-10.1,19.1-29.9,12.7-50.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ixr),
        e("path", {
          d: "M184.9,143.1l41.4-41.4a8,8,0,0,0,0-11.4L165.7,29.7a8,8,0,0,0-11.4,0L116.4,67.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lxr)
      ])) : o(i) === "regular" ? (s(), r("g", dxr, [
        e("line", {
          x1: "88",
          y1: "168",
          x2: "48",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kxr),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cxr),
        e("path", {
          d: "M93.7,90.3,92,92S64.3,78.1,34.6,102.1A8,8,0,0,0,34,114L141.8,221.8a8,8,0,0,0,12.1-.8c7.6-10.1,19.1-29.9,12.7-50.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hxr),
        e("path", {
          d: "M184.9,143.1l41.4-41.4a8,8,0,0,0,0-11.4L165.7,29.7a8,8,0,0,0-11.4,0L116.4,67.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uxr)
      ])) : g("", !0)
    ], 16, Wgr));
  }
}), _xr = ["width", "height", "fill", "transform"], pxr = { key: 0 }, yxr = ["stroke"], $xr = { key: 1 }, wxr = /* @__PURE__ */ e("path", {
  d: "M64,216a8,8,0,0,1-8-8V165.3a27.6,27.6,0,0,1-14.1,2.6A28,28,0,1,1,56,114.7V72a8,8,0,0,1,8-8h46.7a27.6,27.6,0,0,1-2.6-14.1A28,28,0,1,1,161.3,64H208a8,8,0,0,1,8,8v42.7a27.6,27.6,0,0,0-14.1-2.6A28,28,0,1,0,216,165.3V208a8,8,0,0,1-8,8Z",
  opacity: "0.2"
}, null, -1), fxr = ["stroke"], gxr = { key: 2 }, xxr = /* @__PURE__ */ e("path", { d: "M165.8,224H208a16,16,0,0,0,16-16V170.3a7.9,7.9,0,0,0-3.6-6.6,7.7,7.7,0,0,0-7.5-.7,24.3,24.3,0,0,1-8.9,1.7c-13.2,0-24-11.1-24-24.7s10.8-24.7,24-24.7a24.3,24.3,0,0,1,8.9,1.7,7.7,7.7,0,0,0,7.5-.7,7.9,7.9,0,0,0,3.6-6.6V72a16,16,0,0,0-16-16H171.8c.1-1.3.2-2.7.2-4a36,36,0,0,0-72,0c0,1.3.1,2.7.2,4H64A16,16,0,0,0,48,72v32.2l-4-.2a36,36,0,0,0,0,72l4-.2V208a16,16,0,0,0,16,16h42.2" }, null, -1), jxr = [
  xxr
], mxr = { key: 3 }, Mxr = ["stroke"], vxr = { key: 4 }, Sxr = ["stroke"], Hxr = { key: 5 }, Axr = ["stroke"], Vxr = {
  name: "PhPuzzlePiece"
}, UY1 = /* @__PURE__ */ $({
  ...Vxr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", pxr, [
        e("path", {
          d: "M64,216a8,8,0,0,1-8-8V165.3a27.6,27.6,0,0,1-14.1,2.6A28,28,0,1,1,56,114.7V72a8,8,0,0,1,8-8h46.7a27.6,27.6,0,0,1-2.6-14.1A28,28,0,1,1,161.3,64H208a8,8,0,0,1,8,8v42.7a27.6,27.6,0,0,0-14.1-2.6A28,28,0,1,0,216,165.3V208a8,8,0,0,1-8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yxr)
      ])) : o(i) === "duotone" ? (s(), r("g", $xr, [
        wxr,
        e("path", {
          d: "M64,216a8,8,0,0,1-8-8V165.3a27.6,27.6,0,0,1-14.1,2.6A28,28,0,1,1,56,114.7V72a8,8,0,0,1,8-8h46.7a27.6,27.6,0,0,1-2.6-14.1A28,28,0,1,1,161.3,64H208a8,8,0,0,1,8,8v42.7a27.6,27.6,0,0,0-14.1-2.6A28,28,0,1,0,216,165.3V208a8,8,0,0,1-8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fxr)
      ])) : o(i) === "fill" ? (s(), r("g", gxr, jxr)) : o(i) === "light" ? (s(), r("g", mxr, [
        e("path", {
          d: "M64,216a8,8,0,0,1-8-8V165.3a27.6,27.6,0,0,1-14.1,2.6A28,28,0,1,1,56,114.7V72a8,8,0,0,1,8-8h46.7a27.6,27.6,0,0,1-2.6-14.1A28,28,0,1,1,161.3,64H208a8,8,0,0,1,8,8v42.7a27.6,27.6,0,0,0-14.1-2.6A28,28,0,1,0,216,165.3V208a8,8,0,0,1-8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mxr)
      ])) : o(i) === "thin" ? (s(), r("g", vxr, [
        e("path", {
          d: "M64,216a8,8,0,0,1-8-8V165.3a27.6,27.6,0,0,1-14.1,2.6A28,28,0,1,1,56,114.7V72a8,8,0,0,1,8-8h46.7a27.6,27.6,0,0,1-2.6-14.1A28,28,0,1,1,161.3,64H208a8,8,0,0,1,8,8v42.7a27.6,27.6,0,0,0-14.1-2.6A28,28,0,1,0,216,165.3V208a8,8,0,0,1-8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Sxr)
      ])) : o(i) === "regular" ? (s(), r("g", Hxr, [
        e("path", {
          d: "M64,216a8,8,0,0,1-8-8V165.3a27.6,27.6,0,0,1-14.1,2.6A28,28,0,1,1,56,114.7V72a8,8,0,0,1,8-8h46.7a27.6,27.6,0,0,1-2.6-14.1A28,28,0,1,1,161.3,64H208a8,8,0,0,1,8,8v42.7a27.6,27.6,0,0,0-14.1-2.6A28,28,0,1,0,216,165.3V208a8,8,0,0,1-8,8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Axr)
      ])) : g("", !0)
    ], 16, _xr));
  }
}), zxr = ["width", "height", "fill", "transform"], Zxr = { key: 0 }, Cxr = ["stroke"], bxr = ["stroke"], Lxr = ["stroke"], Bxr = ["stroke"], Pxr = ["stroke"], Wxr = ["stroke"], Nxr = { key: 1 }, Fxr = /* @__PURE__ */ e("rect", {
  x: "48",
  y: "48",
  width: "64",
  height: "64",
  rx: "8",
  opacity: "0.2"
}, null, -1), Txr = /* @__PURE__ */ e("rect", {
  x: "48",
  y: "144",
  width: "64",
  height: "64",
  rx: "8",
  opacity: "0.2"
}, null, -1), Dxr = /* @__PURE__ */ e("rect", {
  x: "144",
  y: "48",
  width: "64",
  height: "64",
  rx: "8",
  opacity: "0.2"
}, null, -1), Rxr = ["stroke"], Uxr = ["stroke"], qxr = ["stroke"], Gxr = ["stroke"], Exr = ["stroke"], Oxr = ["stroke"], Ixr = ["stroke"], Kxr = { key: 2 }, Xxr = /* @__PURE__ */ j('<rect x="40" y="40" width="80" height="80" rx="16"></rect><rect x="40" y="136" width="80" height="80" rx="16"></rect><rect x="136" y="40" width="80" height="80" rx="16"></rect><path d="M144,184a8,8,0,0,0,8-8V144a8,8,0,0,0-16,0v32A8,8,0,0,0,144,184Z"></path><path d="M208,152H184v-8a8,8,0,0,0-16,0v56H144a8,8,0,0,0,0,16h32a8,8,0,0,0,8-8V168h24a8,8,0,0,0,0-16Z"></path><path d="M208,184a8,8,0,0,0-8,8v16a8,8,0,0,0,16,0V192A8,8,0,0,0,208,184Z"></path>', 6), Jxr = [
  Xxr
], Qxr = { key: 3 }, Yxr = ["stroke"], ojr = ["stroke"], ejr = ["stroke"], tjr = ["stroke"], njr = ["stroke"], sjr = ["stroke"], rjr = ["stroke"], ijr = { key: 4 }, ljr = ["stroke"], djr = ["stroke"], kjr = ["stroke"], cjr = ["stroke"], hjr = ["stroke"], ujr = ["stroke"], ajr = ["stroke"], _jr = { key: 5 }, pjr = ["stroke"], yjr = ["stroke"], $jr = ["stroke"], wjr = ["stroke"], fjr = ["stroke"], gjr = ["stroke"], xjr = ["stroke"], jjr = {
  name: "PhQrCode"
}, qY1 = /* @__PURE__ */ $({
  ...jjr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Zxr, [
        e("rect", {
          x: "48",
          y: "48",
          width: "60",
          height: "60",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cxr),
        e("rect", {
          x: "48",
          y: "148",
          width: "60",
          height: "60",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bxr),
        e("rect", {
          x: "148",
          y: "48",
          width: "60",
          height: "60",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lxr),
        e("line", {
          x1: "148",
          y1: "148",
          x2: "148",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bxr),
        e("polyline", {
          points: "148 208 184 208 184 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pxr),
        e("line", {
          x1: "184",
          y1: "164",
          x2: "208",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wxr)
      ])) : o(i) === "duotone" ? (s(), r("g", Nxr, [
        Fxr,
        Txr,
        Dxr,
        e("rect", {
          x: "48",
          y: "48",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rxr),
        e("rect", {
          x: "48",
          y: "144",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uxr),
        e("rect", {
          x: "144",
          y: "48",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qxr),
        e("line", {
          x1: "144",
          y1: "144",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gxr),
        e("polyline", {
          points: "144 208 176 208 176 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Exr),
        e("line", {
          x1: "176",
          y1: "160",
          x2: "208",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Oxr),
        e("line", {
          x1: "208",
          y1: "192",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ixr)
      ])) : o(i) === "fill" ? (s(), r("g", Kxr, Jxr)) : o(i) === "light" ? (s(), r("g", Qxr, [
        e("rect", {
          x: "48",
          y: "48",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Yxr),
        e("rect", {
          x: "48",
          y: "144",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ojr),
        e("rect", {
          x: "144",
          y: "48",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ejr),
        e("line", {
          x1: "144",
          y1: "144",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tjr),
        e("polyline", {
          points: "144 208 176 208 176 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, njr),
        e("line", {
          x1: "176",
          y1: "160",
          x2: "208",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sjr),
        e("line", {
          x1: "208",
          y1: "192",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rjr)
      ])) : o(i) === "thin" ? (s(), r("g", ijr, [
        e("rect", {
          x: "48",
          y: "48",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ljr),
        e("rect", {
          x: "48",
          y: "144",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, djr),
        e("rect", {
          x: "144",
          y: "48",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kjr),
        e("line", {
          x1: "144",
          y1: "144",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cjr),
        e("polyline", {
          points: "144 208 176 208 176 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hjr),
        e("line", {
          x1: "176",
          y1: "160",
          x2: "208",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ujr),
        e("line", {
          x1: "208",
          y1: "192",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ajr)
      ])) : o(i) === "regular" ? (s(), r("g", _jr, [
        e("rect", {
          x: "48",
          y: "48",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pjr),
        e("rect", {
          x: "48",
          y: "144",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yjr),
        e("rect", {
          x: "144",
          y: "48",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $jr),
        e("line", {
          x1: "144",
          y1: "144",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wjr),
        e("polyline", {
          points: "144 208 176 208 176 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fjr),
        e("line", {
          x1: "176",
          y1: "160",
          x2: "208",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gjr),
        e("line", {
          x1: "208",
          y1: "192",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xjr)
      ])) : g("", !0)
    ], 16, zxr));
  }
}), mjr = ["width", "height", "fill", "transform"], Mjr = { key: 0 }, vjr = ["stroke"], Sjr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "176",
  r: "16"
}, null, -1), Hjr = ["stroke"], Ajr = { key: 1 }, Vjr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), zjr = ["stroke"], Zjr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "12"
}, null, -1), Cjr = ["stroke"], bjr = { key: 2 }, Ljr = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm0,168a12,12,0,1,1,12-12A12,12,0,0,1,128,192Zm8-48.9v.9a8,8,0,0,1-16,0v-8a8,8,0,0,1,8-8,20,20,0,1,0-20-20,8,8,0,0,1-16,0,36,36,0,1,1,44,35.1Z" }, null, -1), Bjr = [
  Ljr
], Pjr = { key: 3 }, Wjr = ["stroke"], Njr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "10"
}, null, -1), Fjr = ["stroke"], Tjr = { key: 4 }, Djr = ["stroke"], Rjr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "8"
}, null, -1), Ujr = ["stroke"], qjr = { key: 5 }, Gjr = ["stroke"], Ejr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "12"
}, null, -1), Ojr = ["stroke"], Ijr = {
  name: "PhQuestion"
}, GY1 = /* @__PURE__ */ $({
  ...Ijr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Mjr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vjr),
        Sjr,
        e("path", {
          d: "M128,136a28,28,0,1,0-28-28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hjr)
      ])) : o(i) === "duotone" ? (s(), r("g", Ajr, [
        Vjr,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zjr),
        Zjr,
        e("path", {
          d: "M128,144v-8a28,28,0,1,0-28-28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cjr)
      ])) : o(i) === "fill" ? (s(), r("g", bjr, Bjr)) : o(i) === "light" ? (s(), r("g", Pjr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wjr),
        Njr,
        e("path", {
          d: "M128,144v-8a28,28,0,1,0-28-28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fjr)
      ])) : o(i) === "thin" ? (s(), r("g", Tjr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Djr),
        Rjr,
        e("path", {
          d: "M128,144v-8a28,28,0,1,0-28-28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ujr)
      ])) : o(i) === "regular" ? (s(), r("g", qjr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gjr),
        Ejr,
        e("path", {
          d: "M128,144v-8a28,28,0,1,0-28-28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ojr)
      ])) : g("", !0)
    ], 16, mjr));
  }
}), Kjr = ["width", "height", "fill", "transform"], Xjr = { key: 0 }, Jjr = ["stroke"], Qjr = ["stroke"], Yjr = ["stroke"], omr = ["stroke"], emr = { key: 1 }, tmr = /* @__PURE__ */ e("polygon", {
  points: "240 160 176 200 176 120 240 160",
  opacity: "0.2"
}, null, -1), nmr = ["stroke"], smr = ["stroke"], rmr = ["stroke"], imr = ["stroke"], lmr = { key: 2 }, dmr = /* @__PURE__ */ e("path", { d: "M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm104,56H40a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm0,64H40a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm108.2-30.8-64-40A8,8,0,0,0,168,120v80a8.1,8.1,0,0,0,4.1,7,8,8,0,0,0,8.1-.2l64-40a8,8,0,0,0,0-13.6Z" }, null, -1), kmr = [
  dmr
], cmr = { key: 3 }, hmr = ["stroke"], umr = ["stroke"], amr = ["stroke"], _mr = ["stroke"], pmr = { key: 4 }, ymr = ["stroke"], $mr = ["stroke"], wmr = ["stroke"], fmr = ["stroke"], gmr = { key: 5 }, xmr = ["stroke"], jmr = ["stroke"], mmr = ["stroke"], Mmr = ["stroke"], vmr = {
  name: "PhQueue"
}, EY1 = /* @__PURE__ */ $({
  ...vmr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Xjr, [
        e("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jjr),
        e("line", {
          x1: "40",
          y1: "128",
          x2: "136",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qjr),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "136",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Yjr),
        e("polygon", {
          points: "240 160 176 200 176 120 240 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, omr)
      ])) : o(i) === "duotone" ? (s(), r("g", emr, [
        tmr,
        e("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nmr),
        e("line", {
          x1: "40",
          y1: "128",
          x2: "136",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, smr),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "136",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rmr),
        e("polygon", {
          points: "240 160 176 200 176 120 240 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, imr)
      ])) : o(i) === "fill" ? (s(), r("g", lmr, kmr)) : o(i) === "light" ? (s(), r("g", cmr, [
        e("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hmr),
        e("line", {
          x1: "40",
          y1: "128",
          x2: "136",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, umr),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "136",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, amr),
        e("polygon", {
          points: "240 160 176 200 176 120 240 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _mr)
      ])) : o(i) === "thin" ? (s(), r("g", pmr, [
        e("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ymr),
        e("line", {
          x1: "40",
          y1: "128",
          x2: "136",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $mr),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "136",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wmr),
        e("polygon", {
          points: "240 160 176 200 176 120 240 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fmr)
      ])) : o(i) === "regular" ? (s(), r("g", gmr, [
        e("line", {
          x1: "40",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xmr),
        e("line", {
          x1: "40",
          y1: "128",
          x2: "136",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jmr),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "136",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mmr),
        e("polygon", {
          points: "240 160 176 200 176 120 240 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mmr)
      ])) : g("", !0)
    ], 16, Kjr));
  }
}), Smr = ["width", "height", "fill", "transform"], Hmr = { key: 0 }, Amr = ["stroke"], Vmr = ["stroke"], zmr = { key: 1 }, Zmr = /* @__PURE__ */ e("path", {
  d: "M108,144H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8Z",
  opacity: "0.2"
}, null, -1), Cmr = /* @__PURE__ */ e("path", {
  d: "M224,144H156a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8Z",
  opacity: "0.2"
}, null, -1), bmr = ["stroke"], Lmr = ["stroke"], Bmr = { key: 2 }, Pmr = /* @__PURE__ */ e("path", { d: "M116,72v88a48,48,0,0,1-48,48,8,8,0,0,1,0-16,32.1,32.1,0,0,0,32-32v-8H40a16,16,0,0,1-16-16V72A16,16,0,0,1,40,56h60A16,16,0,0,1,116,72ZM216,56H156a16,16,0,0,0-16,16v64a16,16,0,0,0,16,16h60v8a32.1,32.1,0,0,1-32,32,8,8,0,0,0,0,16,48,48,0,0,0,48-48V72A16,16,0,0,0,216,56Z" }, null, -1), Wmr = [
  Pmr
], Nmr = { key: 3 }, Fmr = ["stroke"], Tmr = ["stroke"], Dmr = { key: 4 }, Rmr = ["stroke"], Umr = ["stroke"], qmr = { key: 5 }, Gmr = ["stroke"], Emr = ["stroke"], Omr = {
  name: "PhQuotes"
}, OY1 = /* @__PURE__ */ $({
  ...Omr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Hmr, [
        e("path", {
          d: "M108,144H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Amr),
        e("path", {
          d: "M224,144H156a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vmr)
      ])) : o(i) === "duotone" ? (s(), r("g", zmr, [
        Zmr,
        Cmr,
        e("path", {
          d: "M108,144H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bmr),
        e("path", {
          d: "M224,144H156a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lmr)
      ])) : o(i) === "fill" ? (s(), r("g", Bmr, Wmr)) : o(i) === "light" ? (s(), r("g", Nmr, [
        e("path", {
          d: "M108,144H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fmr),
        e("path", {
          d: "M224,144H156a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Tmr)
      ])) : o(i) === "thin" ? (s(), r("g", Dmr, [
        e("path", {
          d: "M108,144H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Rmr),
        e("path", {
          d: "M224,144H156a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Umr)
      ])) : o(i) === "regular" ? (s(), r("g", qmr, [
        e("path", {
          d: "M108,144H40a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gmr),
        e("path", {
          d: "M224,144H156a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h60a8,8,0,0,1,8,8v88a40,40,0,0,1-40,40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Emr)
      ])) : g("", !0)
    ], 16, Smr));
  }
}), Imr = ["width", "height", "fill", "transform"], Kmr = { key: 0 }, Xmr = ["stroke"], Jmr = { key: 1 }, Qmr = ["stroke"], Ymr = { key: 2 }, oMr = /* @__PURE__ */ e("path", { d: "M72,208a8.1,8.1,0,0,1-7.5-5.2l-48-128a8,8,0,1,1,15-5.6L72,177.2l40.5-108A8.1,8.1,0,0,1,120,64H232a8,8,0,0,1,8,8V96a8,8,0,0,1-16,0V80H125.5l-46,122.8A8.1,8.1,0,0,1,72,208Z" }, null, -1), eMr = [
  oMr
], tMr = { key: 3 }, nMr = ["stroke"], sMr = { key: 4 }, rMr = ["stroke"], iMr = { key: 5 }, lMr = ["stroke"], dMr = {
  name: "PhRadical"
}, IY1 = /* @__PURE__ */ $({
  ...dMr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Kmr, [
        e("polyline", {
          points: "232 96 232 72 120 72 72 200 24 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xmr)
      ])) : o(i) === "duotone" ? (s(), r("g", Jmr, [
        e("polyline", {
          points: "232 96 232 72 120 72 72 200 24 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qmr)
      ])) : o(i) === "fill" ? (s(), r("g", Ymr, eMr)) : o(i) === "light" ? (s(), r("g", tMr, [
        e("polyline", {
          points: "232 96 232 72 120 72 72 200 24 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nMr)
      ])) : o(i) === "thin" ? (s(), r("g", sMr, [
        e("polyline", {
          points: "232 96 232 72 120 72 72 200 24 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rMr)
      ])) : o(i) === "regular" ? (s(), r("g", iMr, [
        e("polyline", {
          points: "232 96 232 72 120 72 72 200 24 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lMr)
      ])) : g("", !0)
    ], 16, Imr));
  }
}), kMr = ["width", "height", "fill", "transform"], cMr = { key: 0 }, hMr = ["stroke"], uMr = ["stroke"], aMr = ["stroke"], _Mr = ["stroke"], pMr = ["stroke"], yMr = { key: 1 }, $Mr = /* @__PURE__ */ e("path", {
  d: "M216,80H32V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V88A8,8,0,0,0,216,80Zm-56,96a32,32,0,1,1,32-32A32,32,0,0,1,160,176Z",
  opacity: "0.2"
}, null, -1), wMr = ["stroke"], fMr = ["stroke"], gMr = ["stroke"], xMr = ["stroke"], jMr = ["stroke"], mMr = ["stroke"], MMr = { key: 2 }, vMr = /* @__PURE__ */ e("path", { d: "M216,72H86.5L194.3,39.7a8,8,0,1,0-4.6-15.4l-160,48h0l-.7.3h-.1l-.5.3H28a6.8,6.8,0,0,0-2.1,1.7.1.1,0,0,1-.1.1c-.1.1-.1.2-.2.4l-.2.2a.3.3,0,0,0-.1.2,6.7,6.7,0,0,0-1,2.3c-.1.1-.1.2-.1.4h-.1a2,2,0,0,1-.1.7h0V80h0V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V88A16,16,0,0,0,216,72ZM96,184H56a8,8,0,0,1,0-16H96a8,8,0,0,1,0,16Zm0-32H56a8,8,0,0,1,0-16H96a8,8,0,0,1,0,16Zm0-32H56a8,8,0,0,1,0-16H96a8,8,0,0,1,0,16Zm72,52a28,28,0,1,1,28-28A28.1,28.1,0,0,1,168,172Z" }, null, -1), SMr = [
  vMr
], HMr = { key: 3 }, AMr = ["stroke"], VMr = ["stroke"], zMr = ["stroke"], ZMr = ["stroke"], CMr = ["stroke"], bMr = ["stroke"], LMr = { key: 4 }, BMr = ["stroke"], PMr = ["stroke"], WMr = ["stroke"], NMr = ["stroke"], FMr = ["stroke"], TMr = ["stroke"], DMr = { key: 5 }, RMr = ["stroke"], UMr = ["stroke"], qMr = ["stroke"], GMr = ["stroke"], EMr = ["stroke"], OMr = ["stroke"], IMr = {
  name: "PhRadio"
}, KY1 = /* @__PURE__ */ $({
  ...IMr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", cMr, [
        e("path", {
          d: "M32,80H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V80A0,0,0,0,1,32,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hMr),
        e("line", {
          x1: "32",
          y1: "80",
          x2: "192",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uMr),
        e("circle", {
          cx: "160",
          cy: "144",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aMr),
        e("line", {
          x1: "72",
          y1: "124",
          x2: "96",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Mr),
        e("line", {
          x1: "72",
          y1: "164",
          x2: "96",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pMr)
      ])) : o(i) === "duotone" ? (s(), r("g", yMr, [
        $Mr,
        e("path", {
          d: "M32,80H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V80A0,0,0,0,1,32,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wMr),
        e("line", {
          x1: "32",
          y1: "80",
          x2: "192",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fMr),
        e("circle", {
          cx: "160",
          cy: "144",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gMr),
        e("line", {
          x1: "64",
          y1: "112",
          x2: "96",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xMr),
        e("line", {
          x1: "64",
          y1: "144",
          x2: "96",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jMr),
        e("line", {
          x1: "64",
          y1: "176",
          x2: "96",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mMr)
      ])) : o(i) === "fill" ? (s(), r("g", MMr, SMr)) : o(i) === "light" ? (s(), r("g", HMr, [
        e("path", {
          d: "M32,80H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V80A0,0,0,0,1,32,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, AMr),
        e("line", {
          x1: "32",
          y1: "80",
          x2: "192",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VMr),
        e("circle", {
          cx: "160",
          cy: "144",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zMr),
        e("line", {
          x1: "64",
          y1: "112",
          x2: "96",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZMr),
        e("line", {
          x1: "64",
          y1: "144",
          x2: "96",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, CMr),
        e("line", {
          x1: "64",
          y1: "176",
          x2: "96",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bMr)
      ])) : o(i) === "thin" ? (s(), r("g", LMr, [
        e("path", {
          d: "M32,80H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V80A0,0,0,0,1,32,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, BMr),
        e("line", {
          x1: "32",
          y1: "80",
          x2: "192",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PMr),
        e("circle", {
          cx: "160",
          cy: "144",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WMr),
        e("line", {
          x1: "64",
          y1: "112",
          x2: "96",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, NMr),
        e("line", {
          x1: "64",
          y1: "144",
          x2: "96",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FMr),
        e("line", {
          x1: "64",
          y1: "176",
          x2: "96",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, TMr)
      ])) : o(i) === "regular" ? (s(), r("g", DMr, [
        e("path", {
          d: "M32,80H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V80A0,0,0,0,1,32,80Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RMr),
        e("line", {
          x1: "32",
          y1: "80",
          x2: "192",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UMr),
        e("circle", {
          cx: "160",
          cy: "144",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qMr),
        e("line", {
          x1: "64",
          y1: "112",
          x2: "96",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GMr),
        e("line", {
          x1: "64",
          y1: "144",
          x2: "96",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EMr),
        e("line", {
          x1: "64",
          y1: "176",
          x2: "96",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OMr)
      ])) : g("", !0)
    ], 16, kMr));
  }
}), KMr = ["width", "height", "fill", "transform"], XMr = { key: 0 }, JMr = ["stroke"], QMr = ["stroke"], YMr = { key: 1 }, ovr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "56",
  opacity: "0.2"
}, null, -1), evr = ["stroke"], tvr = ["stroke"], nvr = { key: 2 }, svr = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm64-88a64,64,0,1,1-64-64A64.1,64.1,0,0,1,192,128Z" }, null, -1), rvr = [
  svr
], ivr = { key: 3 }, lvr = ["stroke"], dvr = ["stroke"], kvr = { key: 4 }, cvr = ["stroke"], hvr = ["stroke"], uvr = { key: 5 }, avr = ["stroke"], _vr = ["stroke"], pvr = {
  name: "PhRadioButton"
}, XY1 = /* @__PURE__ */ $({
  ...pvr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", XMr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, JMr),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "52",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, QMr)
      ])) : o(i) === "duotone" ? (s(), r("g", YMr, [
        ovr,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, evr),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tvr)
      ])) : o(i) === "fill" ? (s(), r("g", nvr, rvr)) : o(i) === "light" ? (s(), r("g", ivr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lvr),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dvr)
      ])) : o(i) === "thin" ? (s(), r("g", kvr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cvr),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hvr)
      ])) : o(i) === "regular" ? (s(), r("g", uvr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, avr),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _vr)
      ])) : g("", !0)
    ], 16, KMr));
  }
}), yvr = ["width", "height", "fill", "transform"], $vr = { key: 0 }, wvr = ["stroke"], fvr = ["stroke"], gvr = ["stroke"], xvr = { key: 1 }, jvr = ["stroke"], mvr = ["stroke"], Mvr = ["stroke"], vvr = { key: 2 }, Svr = /* @__PURE__ */ e("path", { d: "M184,168v16a8,8,0,0,1-16,0V168a40,40,0,0,0-80,0v16a8,8,0,0,1-16,0V168a56,56,0,0,1,112,0ZM128,80a88.1,88.1,0,0,0-88,88v16a8,8,0,0,0,16,0V168a72,72,0,0,1,144,0v16a8,8,0,0,0,16,0V168A88.1,88.1,0,0,0,128,80Zm0-32A120.1,120.1,0,0,0,8,168v16a8,8,0,0,0,16,0V168a104,104,0,0,1,208,0v16a8,8,0,0,0,16,0V168A120.1,120.1,0,0,0,128,48Z" }, null, -1), Hvr = [
  Svr
], Avr = { key: 3 }, Vvr = ["stroke"], zvr = ["stroke"], Zvr = ["stroke"], Cvr = { key: 4 }, bvr = ["stroke"], Lvr = ["stroke"], Bvr = ["stroke"], Pvr = { key: 5 }, Wvr = ["stroke"], Nvr = ["stroke"], Fvr = ["stroke"], Tvr = {
  name: "PhRainbow"
}, JY1 = /* @__PURE__ */ $({
  ...Tvr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $vr, [
        e("path", {
          d: "M12,180v-8a116,116,0,0,1,232,0v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wvr),
        e("path", {
          d: "M152,180v-4a24,24,0,0,0-48,0v4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fvr),
        e("path", {
          d: "M200,180v-4a72,72,0,0,0-144,0v4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gvr)
      ])) : o(i) === "duotone" ? (s(), r("g", xvr, [
        e("path", {
          d: "M176,184V168a48,48,0,0,0-96,0v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jvr),
        e("path", {
          d: "M208,184V168a80,80,0,0,0-160,0v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mvr),
        e("path", {
          d: "M240,184V168a112,112,0,0,0-224,0v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mvr)
      ])) : o(i) === "fill" ? (s(), r("g", vvr, Hvr)) : o(i) === "light" ? (s(), r("g", Avr, [
        e("path", {
          d: "M176,184V168a48,48,0,0,0-96,0v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vvr),
        e("path", {
          d: "M208,184V168a80,80,0,0,0-160,0v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zvr),
        e("path", {
          d: "M240,184V168a112,112,0,0,0-224,0v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zvr)
      ])) : o(i) === "thin" ? (s(), r("g", Cvr, [
        e("path", {
          d: "M176,184V168a48,48,0,0,0-96,0v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bvr),
        e("path", {
          d: "M208,184V168a80,80,0,0,0-160,0v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lvr),
        e("path", {
          d: "M240,184V168a112,112,0,0,0-224,0v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bvr)
      ])) : o(i) === "regular" ? (s(), r("g", Pvr, [
        e("path", {
          d: "M176,184V168a48,48,0,0,0-96,0v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wvr),
        e("path", {
          d: "M208,184V168a80,80,0,0,0-160,0v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nvr),
        e("path", {
          d: "M240,184V168a112,112,0,0,0-224,0v16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fvr)
      ])) : g("", !0)
    ], 16, yvr));
  }
}), Dvr = ["width", "height", "fill", "transform"], Rvr = { key: 0 }, Uvr = ["stroke"], qvr = ["stroke"], Gvr = ["stroke"], Evr = ["stroke"], Ovr = { key: 1 }, Ivr = /* @__PURE__ */ e("path", {
  d: "M152,200c-13.3,0-24-11.1-24-24.9s10.7-24.9,24-24.9a21.6,21.6,0,0,1,8.8,1.8h0A40,40,0,1,1,200,200Z",
  opacity: "0.2"
}, null, -1), Kvr = ["stroke"], Xvr = ["stroke"], Jvr = ["stroke"], Qvr = ["stroke"], Yvr = { key: 2 }, oSr = /* @__PURE__ */ e("path", { d: "M248,160a48,48,0,0,1-48,48H152c-17.6,0-32-14.8-32-32.9s14.4-32.9,32-32.9l3.3.2A48,48,0,0,1,248,160ZM112,72a87.3,87.3,0,0,1,61.3,24.9,8,8,0,1,0,11.2-11.5A104,104,0,0,0,8,160v16a8,8,0,0,0,16,0V160A88.1,88.1,0,0,1,112,72Zm0,32a56,56,0,0,1,33.1,10.8,8,8,0,1,0,9.5-12.8A70.9,70.9,0,0,0,112,88a72.1,72.1,0,0,0-72,72v16a8,8,0,0,0,16,0V160A56,56,0,0,1,112,104Zm15.2,26.7a7.9,7.9,0,0,0-5.9-9.6A42.2,42.2,0,0,0,112,120a40,40,0,0,0-40,40v16a8,8,0,0,0,16,0V160a24.1,24.1,0,0,1,24-24,26,26,0,0,1,5.6.6A7.9,7.9,0,0,0,127.2,130.7Z" }, null, -1), eSr = [
  oSr
], tSr = { key: 3 }, nSr = ["stroke"], sSr = ["stroke"], rSr = ["stroke"], iSr = ["stroke"], lSr = { key: 4 }, dSr = ["stroke"], kSr = ["stroke"], cSr = ["stroke"], hSr = ["stroke"], uSr = { key: 5 }, aSr = ["stroke"], _Sr = ["stroke"], pSr = ["stroke"], ySr = ["stroke"], $Sr = {
  name: "PhRainbowCloud"
}, QY1 = /* @__PURE__ */ $({
  ...$Sr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Rvr, [
        e("path", {
          d: "M156,200c-13.3,0-24-11.1-24-24.9s10.7-24.9,24-24.9a21.6,21.6,0,0,1,8.8,1.8h0A40,40,0,1,1,204,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Uvr),
        e("path", {
          d: "M92,176V160a20.1,20.1,0,0,1,7.7-15.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qvr),
        e("path", {
          d: "M52,176V160a60,60,0,0,1,90.8-51.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gvr),
        e("path", {
          d: "M12,176V160A100,100,0,0,1,177.6,84.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Evr)
      ])) : o(i) === "duotone" ? (s(), r("g", Ovr, [
        Ivr,
        e("path", {
          d: "M152,200c-13.3,0-24-11.1-24-24.9s10.7-24.9,24-24.9a21.6,21.6,0,0,1,8.8,1.8h0A40,40,0,1,1,200,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kvr),
        e("path", {
          d: "M16,176V160A96,96,0,0,1,178.9,91.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xvr),
        e("path", {
          d: "M48,176V160a64,64,0,0,1,101.9-51.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jvr),
        e("path", {
          d: "M80,176V160a32,32,0,0,1,32-32,30,30,0,0,1,7.4.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qvr)
      ])) : o(i) === "fill" ? (s(), r("g", Yvr, eSr)) : o(i) === "light" ? (s(), r("g", tSr, [
        e("path", {
          d: "M152,200c-13.3,0-24-11.1-24-24.9s10.7-24.9,24-24.9a21.6,21.6,0,0,1,8.8,1.8h0A40,40,0,1,1,200,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nSr),
        e("path", {
          d: "M16,176V160A96,96,0,0,1,178.9,91.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sSr),
        e("path", {
          d: "M48,176V160a64,64,0,0,1,101.9-51.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rSr),
        e("path", {
          d: "M80,176V160a32,32,0,0,1,32-32,30,30,0,0,1,7.4.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iSr)
      ])) : o(i) === "thin" ? (s(), r("g", lSr, [
        e("path", {
          d: "M152,200c-13.3,0-24-11.1-24-24.9s10.7-24.9,24-24.9a21.6,21.6,0,0,1,8.8,1.8h0A40,40,0,1,1,200,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dSr),
        e("path", {
          d: "M16,176V160A96,96,0,0,1,178.9,91.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kSr),
        e("path", {
          d: "M48,176V160a64,64,0,0,1,101.9-51.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cSr),
        e("path", {
          d: "M80,176V160a32,32,0,0,1,32-32,30,30,0,0,1,7.4.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hSr)
      ])) : o(i) === "regular" ? (s(), r("g", uSr, [
        e("path", {
          d: "M152,200c-13.3,0-24-11.1-24-24.9s10.7-24.9,24-24.9a21.6,21.6,0,0,1,8.8,1.8h0A40,40,0,1,1,200,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aSr),
        e("path", {
          d: "M16,176V160A96,96,0,0,1,178.9,91.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Sr),
        e("path", {
          d: "M48,176V160a64,64,0,0,1,101.9-51.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pSr),
        e("path", {
          d: "M80,176V160a32,32,0,0,1,32-32,30,30,0,0,1,7.4.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ySr)
      ])) : g("", !0)
    ], 16, Dvr));
  }
}), wSr = ["width", "height", "fill", "transform"], fSr = { key: 0 }, gSr = ["stroke"], xSr = ["stroke"], jSr = ["stroke"], mSr = { key: 1 }, MSr = /* @__PURE__ */ e("path", {
  d: "M32,208V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V208l-32-16-32,16-32-16L96,208,64,192Z",
  opacity: "0.2"
}, null, -1), vSr = ["stroke"], SSr = ["stroke"], HSr = ["stroke"], ASr = { key: 2 }, VSr = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V208a7.9,7.9,0,0,0,3.8,6.8,8,8,0,0,0,7.8.4L64,200.9l28.4,14.3a8.3,8.3,0,0,0,7.2,0L128,200.9l28.4,14.3a8.5,8.5,0,0,0,7.2,0L192,200.9l28.4,14.3a8,8,0,0,0,7.8-.4A7.9,7.9,0,0,0,232,208V56A16,16,0,0,0,216,40ZM180,144H76a8,8,0,0,1,0-16H180a8,8,0,0,1,0,16Zm0-32H76a8,8,0,0,1,0-16H180a8,8,0,0,1,0,16Z" }, null, -1), zSr = [
  VSr
], ZSr = { key: 3 }, CSr = ["stroke"], bSr = ["stroke"], LSr = ["stroke"], BSr = { key: 4 }, PSr = ["stroke"], WSr = ["stroke"], NSr = ["stroke"], FSr = { key: 5 }, TSr = ["stroke"], DSr = ["stroke"], RSr = ["stroke"], USr = {
  name: "PhReceipt"
}, YY1 = /* @__PURE__ */ $({
  ...USr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", fSr, [
        e("line", {
          x1: "76",
          y1: "100",
          x2: "180",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gSr),
        e("line", {
          x1: "76",
          y1: "140",
          x2: "180",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xSr),
        e("path", {
          d: "M32,208V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V208l-32-16-32,16-32-16L96,208,64,192Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jSr)
      ])) : o(i) === "duotone" ? (s(), r("g", mSr, [
        MSr,
        e("line", {
          x1: "76",
          y1: "104",
          x2: "180",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vSr),
        e("line", {
          x1: "76",
          y1: "136",
          x2: "180",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SSr),
        e("path", {
          d: "M32,208V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V208l-32-16-32,16-32-16L96,208,64,192Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HSr)
      ])) : o(i) === "fill" ? (s(), r("g", ASr, zSr)) : o(i) === "light" ? (s(), r("g", ZSr, [
        e("line", {
          x1: "76",
          y1: "104",
          x2: "180",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, CSr),
        e("line", {
          x1: "76",
          y1: "136",
          x2: "180",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bSr),
        e("path", {
          d: "M32,208V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V208l-32-16-32,16-32-16L96,208,64,192Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LSr)
      ])) : o(i) === "thin" ? (s(), r("g", BSr, [
        e("line", {
          x1: "76",
          y1: "104",
          x2: "180",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PSr),
        e("line", {
          x1: "76",
          y1: "136",
          x2: "180",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WSr),
        e("path", {
          d: "M32,208V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V208l-32-16-32,16-32-16L96,208,64,192Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, NSr)
      ])) : o(i) === "regular" ? (s(), r("g", FSr, [
        e("line", {
          x1: "76",
          y1: "104",
          x2: "180",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TSr),
        e("line", {
          x1: "76",
          y1: "136",
          x2: "180",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DSr),
        e("path", {
          d: "M32,208V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V208l-32-16-32,16-32-16L96,208,64,192Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RSr)
      ])) : g("", !0)
    ], 16, wSr));
  }
}), qSr = ["width", "height", "fill", "transform"], GSr = { key: 0 }, ESr = ["stroke"], OSr = ["stroke"], ISr = { key: 1 }, KSr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "64",
  opacity: "0.2"
}, null, -1), XSr = ["stroke"], JSr = ["stroke"], QSr = { key: 2 }, YSr = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z" }, null, -1), oHr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "72"
}, null, -1), eHr = [
  YSr,
  oHr
], tHr = { key: 3 }, nHr = ["stroke"], sHr = ["stroke"], rHr = { key: 4 }, iHr = ["stroke"], lHr = ["stroke"], dHr = { key: 5 }, kHr = ["stroke"], cHr = ["stroke"], hHr = {
  name: "PhRecord"
}, ool = /* @__PURE__ */ $({
  ...hHr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", GSr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ESr),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OSr)
      ])) : o(i) === "duotone" ? (s(), r("g", ISr, [
        KSr,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, XSr),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "64",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, JSr)
      ])) : o(i) === "fill" ? (s(), r("g", QSr, eHr)) : o(i) === "light" ? (s(), r("g", tHr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nHr),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sHr)
      ])) : o(i) === "thin" ? (s(), r("g", rHr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iHr),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lHr)
      ])) : o(i) === "regular" ? (s(), r("g", dHr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, kHr),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "64",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, cHr)
      ])) : g("", !0)
    ], 16, qSr));
  }
}), uHr = ["width", "height", "fill", "transform"], aHr = { key: 0 }, _Hr = ["stroke"], pHr = { key: 1 }, yHr = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "48",
  width: "192",
  height: "160",
  rx: "8",
  opacity: "0.2"
}, null, -1), $Hr = ["stroke"], wHr = { key: 2 }, fHr = /* @__PURE__ */ e("rect", {
  x: "24",
  y: "40",
  width: "208",
  height: "176",
  rx: "16"
}, null, -1), gHr = [
  fHr
], xHr = { key: 3 }, jHr = ["stroke"], mHr = { key: 4 }, MHr = ["stroke"], vHr = { key: 5 }, SHr = ["stroke"], HHr = {
  name: "PhRectangle"
}, eol = /* @__PURE__ */ $({
  ...HHr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", aHr, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Hr)
      ])) : o(i) === "duotone" ? (s(), r("g", pHr, [
        yHr,
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Hr)
      ])) : o(i) === "fill" ? (s(), r("g", wHr, gHr)) : o(i) === "light" ? (s(), r("g", xHr, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jHr)
      ])) : o(i) === "thin" ? (s(), r("g", mHr, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MHr)
      ])) : o(i) === "regular" ? (s(), r("g", vHr, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SHr)
      ])) : g("", !0)
    ], 16, uHr));
  }
}), AHr = ["width", "height", "fill", "transform"], VHr = { key: 0 }, zHr = ["stroke"], ZHr = ["stroke"], CHr = ["stroke"], bHr = ["stroke"], LHr = ["stroke"], BHr = ["stroke"], PHr = { key: 1 }, WHr = ["stroke"], NHr = ["stroke"], FHr = ["stroke"], THr = ["stroke"], DHr = ["stroke"], RHr = ["stroke"], UHr = { key: 2 }, qHr = /* @__PURE__ */ e("path", { d: "M236.8,204A23.9,23.9,0,0,1,216,216H160v16a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-24-24.1A7.9,7.9,0,0,1,120,208a8.1,8.1,0,0,1,2.3-5.7l24-24a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,160,184v16h56a7.9,7.9,0,0,0,6.9-4,7.8,7.8,0,0,0,0-8l-24-41.4a8,8,0,0,1,13.9-8L236.7,180A23.7,23.7,0,0,1,236.8,204ZM88,200H40a7.9,7.9,0,0,1-6.9-4,7.8,7.8,0,0,1,0-8l28-48.3,13.9,8a8,8,0,0,0,4,1.1,7.8,7.8,0,0,0,4.8-1.7,8,8,0,0,0,2.9-8.4l-8.8-32.8a8.1,8.1,0,0,0-3.7-4.8,7.7,7.7,0,0,0-6.1-.8L35.3,109a8,8,0,0,0-5.8,6.7,7.9,7.9,0,0,0,3.9,8l13.8,8L19.3,180A23.9,23.9,0,0,0,40,216H88a8,8,0,0,0,0-16ZM128,32a7.8,7.8,0,0,1,6.9,4l28,48.3-13.8,8a7.9,7.9,0,0,0,1.9,14.6l32.8,8.8,2,.3a8.1,8.1,0,0,0,7.8-5.9l8.8-32.8a8.1,8.1,0,0,0-2.9-8.5,8,8,0,0,0-8.9-.5l-13.9,8L148.8,28a24,24,0,0,0-41.6,0L83.3,69.4a8,8,0,1,0,13.8,8l24-41.4A7.8,7.8,0,0,1,128,32Z" }, null, -1), GHr = [
  qHr
], EHr = { key: 3 }, OHr = ["stroke"], IHr = ["stroke"], KHr = ["stroke"], XHr = ["stroke"], JHr = ["stroke"], QHr = ["stroke"], YHr = { key: 4 }, oAr = ["stroke"], eAr = ["stroke"], tAr = ["stroke"], nAr = ["stroke"], sAr = ["stroke"], rAr = ["stroke"], iAr = { key: 5 }, lAr = ["stroke"], dAr = ["stroke"], kAr = ["stroke"], cAr = ["stroke"], hAr = ["stroke"], uAr = ["stroke"], aAr = {
  name: "PhRecycle"
}, tol = /* @__PURE__ */ $({
  ...aAr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", VHr, [
        e("polyline", {
          points: "152 232 128 208 152 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zHr),
        e("polyline", {
          points: "194.6 75.2 185.8 108 153.1 99.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZHr),
        e("polyline", {
          points: "79 140.8 70.2 108 37.4 116.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CHr),
        e("path", {
          d: "M128,208h88a16,16,0,0,0,13.8-24l-19.9-34.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bHr),
        e("path", {
          d: "M185.8,108l-44-76a15.9,15.9,0,0,0-27.6,0l-20,34.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LHr),
        e("path", {
          d: "M70.2,108l-44,76A16,16,0,0,0,40,208H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BHr)
      ])) : o(i) === "duotone" ? (s(), r("g", PHr, [
        e("polyline", {
          points: "152 232 128 208 152 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WHr),
        e("polyline", {
          points: "194.6 75.2 185.8 108 153.1 99.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NHr),
        e("polyline", {
          points: "79 140.8 70.2 108 37.4 116.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FHr),
        e("path", {
          d: "M128,208h88a16,16,0,0,0,13.8-24l-23.9-41.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, THr),
        e("path", {
          d: "M70.2,108l-44,76A16,16,0,0,0,40,208H88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DHr),
        e("path", {
          d: "M185.8,108l-44-76a15.9,15.9,0,0,0-27.6,0l-24,41.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RHr)
      ])) : o(i) === "fill" ? (s(), r("g", UHr, GHr)) : o(i) === "light" ? (s(), r("g", EHr, [
        e("polyline", {
          points: "152 232 128 208 152 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OHr),
        e("polyline", {
          points: "194.6 75.2 185.8 108 153.1 99.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IHr),
        e("polyline", {
          points: "79 140.8 70.2 108 37.4 116.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KHr),
        e("path", {
          d: "M128,208h88a16,16,0,0,0,13.8-24l-23.9-41.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XHr),
        e("path", {
          d: "M70.2,108l-44,76A16,16,0,0,0,40,208H88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JHr),
        e("path", {
          d: "M185.8,108l-44-76a15.9,15.9,0,0,0-27.6,0l-24,41.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QHr)
      ])) : o(i) === "thin" ? (s(), r("g", YHr, [
        e("polyline", {
          points: "152 232 128 208 152 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oAr),
        e("polyline", {
          points: "194.6 75.2 185.8 108 153.1 99.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eAr),
        e("polyline", {
          points: "79 140.8 70.2 108 37.4 116.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tAr),
        e("path", {
          d: "M128,208h88a16,16,0,0,0,13.8-24l-23.9-41.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nAr),
        e("path", {
          d: "M70.2,108l-44,76A16,16,0,0,0,40,208H88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sAr),
        e("path", {
          d: "M185.8,108l-44-76a15.9,15.9,0,0,0-27.6,0l-24,41.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rAr)
      ])) : o(i) === "regular" ? (s(), r("g", iAr, [
        e("polyline", {
          points: "152 232 128 208 152 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lAr),
        e("polyline", {
          points: "194.6 75.2 185.8 108 153.1 99.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dAr),
        e("polyline", {
          points: "79 140.8 70.2 108 37.4 116.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kAr),
        e("path", {
          d: "M128,208h88a16,16,0,0,0,13.8-24l-23.9-41.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cAr),
        e("path", {
          d: "M70.2,108l-44,76A16,16,0,0,0,40,208H88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hAr),
        e("path", {
          d: "M185.8,108l-44-76a15.9,15.9,0,0,0-27.6,0l-24,41.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uAr)
      ])) : g("", !0)
    ], 16, AHr));
  }
}), _Ar = ["width", "height", "fill", "transform"], pAr = { key: 0 }, yAr = ["stroke"], $Ar = ["stroke"], wAr = ["stroke"], fAr = ["stroke"], gAr = /* @__PURE__ */ e("circle", {
  cx: "88",
  cy: "128",
  r: "20"
}, null, -1), xAr = /* @__PURE__ */ e("circle", {
  cx: "168",
  cy: "128",
  r: "20"
}, null, -1), jAr = { key: 1 }, mAr = /* @__PURE__ */ e("path", {
  d: "M240,104a24,24,0,0,0-43.4-14.1h0C178.3,78.7,154.3,72,128,72S77.7,78.7,59.4,89.9h0a24,24,0,1,0-31.6,34.8h0A50.7,50.7,0,0,0,24,144c0,39.8,46.6,72,104,72s104-32.2,104-72a50.7,50.7,0,0,0-3.8-19.3h0A24,24,0,0,0,240,104Z",
  opacity: "0.2"
}, null, -1), MAr = ["stroke"], vAr = ["stroke"], SAr = ["stroke"], HAr = ["stroke"], AAr = /* @__PURE__ */ e("circle", {
  cx: "88",
  cy: "132",
  r: "16"
}, null, -1), VAr = /* @__PURE__ */ e("circle", {
  cx: "168",
  cy: "132",
  r: "16"
}, null, -1), zAr = { key: 2 }, ZAr = /* @__PURE__ */ e("path", { d: "M248,104a32,32,0,0,0-52.9-24.2c-16.8-8.9-36.8-14.3-57.7-15.5l5.2-31.2,21.8,3.4a24.2,24.2,0,1,0,2.5-15.8l-29.7-4.6a8,8,0,0,0-9.1,6.6l-6.9,41.5c-21.8.9-42.8,6.3-60.3,15.6a32,32,0,0,0-42.6,47.7A61.4,61.4,0,0,0,16,144c0,21.9,12,42.4,33.9,57.5S98.6,224,128,224s57.1-8,78.1-22.5S240,165.9,240,144a60.1,60.1,0,0,0-2.3-16.4A32.4,32.4,0,0,0,248,104ZM72,132a16,16,0,1,1,16,16A16,16,0,0,1,72,132Zm92.7,51.1a80.1,80.1,0,0,1-73.4,0,8,8,0,0,1,7.3-14.2,64.2,64.2,0,0,0,58.8,0,8,8,0,0,1,7.3,14.2ZM168,148a16,16,0,1,1,16-16A16,16,0,0,1,168,148Z" }, null, -1), CAr = [
  ZAr
], bAr = { key: 3 }, LAr = ["stroke"], BAr = ["stroke"], PAr = ["stroke"], WAr = ["stroke"], NAr = /* @__PURE__ */ e("circle", {
  cx: "88",
  cy: "132",
  r: "14"
}, null, -1), FAr = /* @__PURE__ */ e("circle", {
  cx: "168",
  cy: "132",
  r: "14"
}, null, -1), TAr = { key: 4 }, DAr = ["stroke"], RAr = ["stroke"], UAr = ["stroke"], qAr = ["stroke"], GAr = /* @__PURE__ */ e("circle", {
  cx: "88",
  cy: "132",
  r: "12"
}, null, -1), EAr = /* @__PURE__ */ e("circle", {
  cx: "168",
  cy: "132",
  r: "12"
}, null, -1), OAr = { key: 5 }, IAr = ["stroke"], KAr = ["stroke"], XAr = ["stroke"], JAr = ["stroke"], QAr = /* @__PURE__ */ e("circle", {
  cx: "88",
  cy: "132",
  r: "16"
}, null, -1), YAr = /* @__PURE__ */ e("circle", {
  cx: "168",
  cy: "132",
  r: "16"
}, null, -1), oVr = {
  name: "PhRedditLogo"
}, nol = /* @__PURE__ */ $({
  ...oVr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", pAr, [
        e("circle", {
          cx: "188",
          cy: "32",
          r: "12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yAr),
        e("path", {
          d: "M161,172a71.9,71.9,0,0,1-66,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $Ar),
        e("path", {
          d: "M59.4,89.9C77.7,78.7,101.7,72,128,72s50.3,6.7,68.6,17.9h0a24,24,0,1,1,31.6,34.8h0A50.7,50.7,0,0,1,232,144c0,39.8-46.6,72-104,72S24,183.8,24,144a50.7,50.7,0,0,1,3.8-19.3h0A24,24,0,1,1,59.4,89.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wAr),
        e("polyline", {
          points: "128 72 136 24 176.1 30.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fAr),
        gAr,
        xAr
      ])) : o(i) === "duotone" ? (s(), r("g", jAr, [
        mAr,
        e("circle", {
          cx: "188",
          cy: "32",
          r: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MAr),
        e("path", {
          d: "M161,176a71.9,71.9,0,0,1-66,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vAr),
        e("polyline", {
          points: "128 72 136 24 172.2 29.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SAr),
        e("path", {
          d: "M59.4,89.9C77.7,78.7,101.7,72,128,72s50.3,6.7,68.6,17.9h0a24,24,0,1,1,31.6,34.8h0A50.7,50.7,0,0,1,232,144c0,39.8-46.6,72-104,72S24,183.8,24,144a50.7,50.7,0,0,1,3.8-19.3h0A24,24,0,1,1,59.4,89.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HAr),
        AAr,
        VAr
      ])) : o(i) === "fill" ? (s(), r("g", zAr, CAr)) : o(i) === "light" ? (s(), r("g", bAr, [
        e("circle", {
          cx: "188",
          cy: "32",
          r: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LAr),
        e("path", {
          d: "M161,176a71.9,71.9,0,0,1-66,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BAr),
        e("polyline", {
          points: "128 72 136 24 172.2 29.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PAr),
        e("path", {
          d: "M59.4,89.9C77.7,78.7,101.7,72,128,72s50.3,6.7,68.6,17.9h0a24,24,0,1,1,31.6,34.8h0A50.7,50.7,0,0,1,232,144c0,39.8-46.6,72-104,72S24,183.8,24,144a50.7,50.7,0,0,1,3.8-19.3h0A24,24,0,1,1,59.4,89.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WAr),
        NAr,
        FAr
      ])) : o(i) === "thin" ? (s(), r("g", TAr, [
        e("circle", {
          cx: "188",
          cy: "32",
          r: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, DAr),
        e("path", {
          d: "M161,176a71.9,71.9,0,0,1-66,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RAr),
        e("polyline", {
          points: "128 72 136 24 172.2 29.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, UAr),
        e("path", {
          d: "M59.4,89.9C77.7,78.7,101.7,72,128,72s50.3,6.7,68.6,17.9h0a24,24,0,1,1,31.6,34.8h0A50.7,50.7,0,0,1,232,144c0,39.8-46.6,72-104,72S24,183.8,24,144a50.7,50.7,0,0,1,3.8-19.3h0A24,24,0,1,1,59.4,89.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qAr),
        GAr,
        EAr
      ])) : o(i) === "regular" ? (s(), r("g", OAr, [
        e("circle", {
          cx: "188",
          cy: "32",
          r: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IAr),
        e("path", {
          d: "M161,176a71.9,71.9,0,0,1-66,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KAr),
        e("polyline", {
          points: "128 72 136 24 172.2 29.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XAr),
        e("path", {
          d: "M59.4,89.9C77.7,78.7,101.7,72,128,72s50.3,6.7,68.6,17.9h0a24,24,0,1,1,31.6,34.8h0A50.7,50.7,0,0,1,232,144c0,39.8-46.6,72-104,72S24,183.8,24,144a50.7,50.7,0,0,1,3.8-19.3h0A24,24,0,1,1,59.4,89.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JAr),
        QAr,
        YAr
      ])) : g("", !0)
    ], 16, _Ar));
  }
}), eVr = ["width", "height", "fill", "transform"], tVr = { key: 0 }, nVr = ["stroke"], sVr = ["stroke"], rVr = ["stroke"], iVr = ["stroke"], lVr = { key: 1 }, dVr = ["stroke"], kVr = ["stroke"], cVr = ["stroke"], hVr = ["stroke"], uVr = { key: 2 }, aVr = /* @__PURE__ */ e("path", { d: "M24,128A72.1,72.1,0,0,1,96,56h96V40a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l24,24a8.1,8.1,0,0,1,0,11.4l-24,24A8.3,8.3,0,0,1,200,96a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,192,88V72H96a56,56,0,0,0-56,56,8,8,0,0,1-16,0Zm200-8a8,8,0,0,0-8,8,56,56,0,0,1-56,56H64V168a8,8,0,0,0-4.9-7.4,8.4,8.4,0,0,0-8.8,1.7l-24,24a8.1,8.1,0,0,0,0,11.4l24,24A8.3,8.3,0,0,0,56,224a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,64,216V200h96a72.1,72.1,0,0,0,72-72A8,8,0,0,0,224,120Z" }, null, -1), _Vr = [
  aVr
], pVr = { key: 3 }, yVr = ["stroke"], $Vr = ["stroke"], wVr = ["stroke"], fVr = ["stroke"], gVr = { key: 4 }, xVr = ["stroke"], jVr = ["stroke"], mVr = ["stroke"], MVr = ["stroke"], vVr = { key: 5 }, SVr = ["stroke"], HVr = ["stroke"], AVr = ["stroke"], VVr = ["stroke"], zVr = {
  name: "PhRepeat"
}, sol = /* @__PURE__ */ $({
  ...zVr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", tVr, [
        e("polyline", {
          points: "200 88 224 64 200 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nVr),
        e("path", {
          d: "M32,128A64.1,64.1,0,0,1,96,64H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sVr),
        e("polyline", {
          points: "56 168 32 192 56 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rVr),
        e("path", {
          d: "M224,128a64.1,64.1,0,0,1-64,64H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iVr)
      ])) : o(i) === "duotone" ? (s(), r("g", lVr, [
        e("polyline", {
          points: "200 88 224 64 200 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dVr),
        e("path", {
          d: "M32,128A64.1,64.1,0,0,1,96,64H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kVr),
        e("polyline", {
          points: "56 168 32 192 56 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cVr),
        e("path", {
          d: "M224,128a64.1,64.1,0,0,1-64,64H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hVr)
      ])) : o(i) === "fill" ? (s(), r("g", uVr, _Vr)) : o(i) === "light" ? (s(), r("g", pVr, [
        e("polyline", {
          points: "200 88 224 64 200 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yVr),
        e("path", {
          d: "M32,128A64.1,64.1,0,0,1,96,64H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $Vr),
        e("polyline", {
          points: "56 168 32 192 56 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wVr),
        e("path", {
          d: "M224,128a64.1,64.1,0,0,1-64,64H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fVr)
      ])) : o(i) === "thin" ? (s(), r("g", gVr, [
        e("polyline", {
          points: "200 88 224 64 200 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xVr),
        e("path", {
          d: "M32,128A64.1,64.1,0,0,1,96,64H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jVr),
        e("polyline", {
          points: "56 168 32 192 56 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mVr),
        e("path", {
          d: "M224,128a64.1,64.1,0,0,1-64,64H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MVr)
      ])) : o(i) === "regular" ? (s(), r("g", vVr, [
        e("polyline", {
          points: "200 88 224 64 200 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SVr),
        e("path", {
          d: "M32,128A64.1,64.1,0,0,1,96,64H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HVr),
        e("polyline", {
          points: "56 168 32 192 56 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AVr),
        e("path", {
          d: "M224,128a64.1,64.1,0,0,1-64,64H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VVr)
      ])) : g("", !0)
    ], 16, eVr));
  }
}), ZVr = ["width", "height", "fill", "transform"], CVr = { key: 0 }, bVr = ["stroke"], LVr = ["stroke"], BVr = ["stroke"], PVr = ["stroke"], WVr = ["stroke"], NVr = { key: 1 }, FVr = ["stroke"], TVr = ["stroke"], DVr = ["stroke"], RVr = ["stroke"], UVr = ["stroke"], qVr = { key: 2 }, GVr = /* @__PURE__ */ e("path", { d: "M24,128A72.1,72.1,0,0,1,96,56h96V40a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l24,24a8.1,8.1,0,0,1,0,11.4l-24,24A8.3,8.3,0,0,1,200,96a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,192,88V72H96a56,56,0,0,0-56,56,8,8,0,0,1-16,0Zm200-8a8,8,0,0,0-8,8,56,56,0,0,1-56,56H64V168a8,8,0,0,0-4.9-7.4,8.4,8.4,0,0,0-8.8,1.7l-24,24a8.1,8.1,0,0,0,0,11.4l24,24A8.3,8.3,0,0,0,56,224a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,64,216V200h96a72.1,72.1,0,0,0,72-72A8,8,0,0,0,224,120Zm-92,40a8,8,0,0,0,8-8V104a7.9,7.9,0,0,0-3.8-6.8,8,8,0,0,0-7.8-.4l-16,8a8.2,8.2,0,0,0-3.6,10.8,8.1,8.1,0,0,0,10.8,3.5l4.4-2.2V152A8,8,0,0,0,132,160Z" }, null, -1), EVr = [
  GVr
], OVr = { key: 3 }, IVr = ["stroke"], KVr = ["stroke"], XVr = ["stroke"], JVr = ["stroke"], QVr = ["stroke"], YVr = { key: 4 }, ozr = ["stroke"], ezr = ["stroke"], tzr = ["stroke"], nzr = ["stroke"], szr = ["stroke"], rzr = { key: 5 }, izr = ["stroke"], lzr = ["stroke"], dzr = ["stroke"], kzr = ["stroke"], czr = ["stroke"], hzr = {
  name: "PhRepeatOnce"
}, rol = /* @__PURE__ */ $({
  ...hzr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", CVr, [
        e("polyline", {
          points: "200 88 224 64 200 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bVr),
        e("path", {
          d: "M32,128A64.1,64.1,0,0,1,96,64H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LVr),
        e("polyline", {
          points: "56 168 32 192 56 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BVr),
        e("path", {
          d: "M224,128a64.1,64.1,0,0,1-64,64H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PVr),
        e("polyline", {
          points: "116 112 132 104 132 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WVr)
      ])) : o(i) === "duotone" ? (s(), r("g", NVr, [
        e("polyline", {
          points: "200 88 224 64 200 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FVr),
        e("path", {
          d: "M32,128A64.1,64.1,0,0,1,96,64H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TVr),
        e("polyline", {
          points: "56 168 32 192 56 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DVr),
        e("path", {
          d: "M224,128a64.1,64.1,0,0,1-64,64H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RVr),
        e("polyline", {
          points: "116 112 132 104 132 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UVr)
      ])) : o(i) === "fill" ? (s(), r("g", qVr, EVr)) : o(i) === "light" ? (s(), r("g", OVr, [
        e("polyline", {
          points: "200 88 224 64 200 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IVr),
        e("path", {
          d: "M32,128A64.1,64.1,0,0,1,96,64H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KVr),
        e("polyline", {
          points: "56 168 32 192 56 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XVr),
        e("path", {
          d: "M224,128a64.1,64.1,0,0,1-64,64H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JVr),
        e("polyline", {
          points: "116 112 132 104 132 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QVr)
      ])) : o(i) === "thin" ? (s(), r("g", YVr, [
        e("polyline", {
          points: "200 88 224 64 200 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ozr),
        e("path", {
          d: "M32,128A64.1,64.1,0,0,1,96,64H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ezr),
        e("polyline", {
          points: "56 168 32 192 56 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tzr),
        e("path", {
          d: "M224,128a64.1,64.1,0,0,1-64,64H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nzr),
        e("polyline", {
          points: "116 112 132 104 132 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, szr)
      ])) : o(i) === "regular" ? (s(), r("g", rzr, [
        e("polyline", {
          points: "200 88 224 64 200 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, izr),
        e("path", {
          d: "M32,128A64.1,64.1,0,0,1,96,64H224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lzr),
        e("polyline", {
          points: "56 168 32 192 56 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dzr),
        e("path", {
          d: "M224,128a64.1,64.1,0,0,1-64,64H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kzr),
        e("polyline", {
          points: "116 112 132 104 132 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, czr)
      ])) : g("", !0)
    ], 16, ZVr));
  }
}), uzr = ["width", "height", "fill", "transform"], azr = { key: 0 }, _zr = ["stroke"], pzr = ["stroke"], yzr = { key: 1 }, $zr = /* @__PURE__ */ e("path", {
  d: "M14.5,121.3l89.2-57.4A8,8,0,0,1,116,70.7V185.3a8,8,0,0,1-12.3,6.8L14.5,134.7A7.9,7.9,0,0,1,14.5,121.3Z",
  opacity: "0.2"
}, null, -1), wzr = /* @__PURE__ */ e("path", {
  d: "M126.5,121.3l89.2-57.4A8,8,0,0,1,228,70.7V185.3a8,8,0,0,1-12.3,6.8l-89.2-57.4A7.9,7.9,0,0,1,126.5,121.3Z",
  opacity: "0.2"
}, null, -1), fzr = ["stroke"], gzr = ["stroke"], xzr = { key: 2 }, jzr = /* @__PURE__ */ e("path", { d: "M10.1,114.5,99.3,57.2A16,16,0,0,1,124,70.7v42.6l87.3-56.1A16,16,0,0,1,236,70.7V185.3a16.1,16.1,0,0,1-8.3,14.1,16.5,16.5,0,0,1-16.4-.6L124,142.7v42.6a16.1,16.1,0,0,1-8.3,14.1,16.5,16.5,0,0,1-16.4-.6L10.1,141.5a16.1,16.1,0,0,1,0-27Z" }, null, -1), mzr = [
  jzr
], Mzr = { key: 3 }, vzr = ["stroke"], Szr = ["stroke"], Hzr = { key: 4 }, Azr = ["stroke"], Vzr = ["stroke"], zzr = { key: 5 }, Zzr = ["stroke"], Czr = ["stroke"], bzr = {
  name: "PhRewind"
}, iol = /* @__PURE__ */ $({
  ...bzr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", azr, [
        e("path", {
          d: "M18.5,121.3l89.2-57.4A8,8,0,0,1,120,70.7V185.3a8,8,0,0,1-12.3,6.8L18.5,134.7A7.9,7.9,0,0,1,18.5,121.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _zr),
        e("path", {
          d: "M126.5,121.3l89.2-57.4A8,8,0,0,1,228,70.7V185.3a8,8,0,0,1-12.3,6.8l-89.2-57.4A7.9,7.9,0,0,1,126.5,121.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pzr)
      ])) : o(i) === "duotone" ? (s(), r("g", yzr, [
        $zr,
        wzr,
        e("path", {
          d: "M14.5,121.3l89.2-57.4A8,8,0,0,1,116,70.7V185.3a8,8,0,0,1-12.3,6.8L14.5,134.7A7.9,7.9,0,0,1,14.5,121.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fzr),
        e("path", {
          d: "M126.5,121.3l89.2-57.4A8,8,0,0,1,228,70.7V185.3a8,8,0,0,1-12.3,6.8l-89.2-57.4A7.9,7.9,0,0,1,126.5,121.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gzr)
      ])) : o(i) === "fill" ? (s(), r("g", xzr, mzr)) : o(i) === "light" ? (s(), r("g", Mzr, [
        e("path", {
          d: "M14.5,121.3l89.2-57.4A8,8,0,0,1,116,70.7V185.3a8,8,0,0,1-12.3,6.8L14.5,134.7A7.9,7.9,0,0,1,14.5,121.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vzr),
        e("path", {
          d: "M126.5,121.3l89.2-57.4A8,8,0,0,1,228,70.7V185.3a8,8,0,0,1-12.3,6.8l-89.2-57.4A7.9,7.9,0,0,1,126.5,121.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Szr)
      ])) : o(i) === "thin" ? (s(), r("g", Hzr, [
        e("path", {
          d: "M14.5,121.3l89.2-57.4A8,8,0,0,1,116,70.7V185.3a8,8,0,0,1-12.3,6.8L14.5,134.7A7.9,7.9,0,0,1,14.5,121.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Azr),
        e("path", {
          d: "M126.5,121.3l89.2-57.4A8,8,0,0,1,228,70.7V185.3a8,8,0,0,1-12.3,6.8l-89.2-57.4A7.9,7.9,0,0,1,126.5,121.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vzr)
      ])) : o(i) === "regular" ? (s(), r("g", zzr, [
        e("path", {
          d: "M14.5,121.3l89.2-57.4A8,8,0,0,1,116,70.7V185.3a8,8,0,0,1-12.3,6.8L14.5,134.7A7.9,7.9,0,0,1,14.5,121.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zzr),
        e("path", {
          d: "M126.5,121.3l89.2-57.4A8,8,0,0,1,228,70.7V185.3a8,8,0,0,1-12.3,6.8l-89.2-57.4A7.9,7.9,0,0,1,126.5,121.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Czr)
      ])) : g("", !0)
    ], 16, uzr));
  }
}), Lzr = ["width", "height", "fill", "transform"], Bzr = { key: 0 }, Pzr = ["stroke"], Wzr = ["stroke"], Nzr = ["stroke"], Fzr = { key: 1 }, Tzr = /* @__PURE__ */ e("path", {
  d: "M128,32a96,96,0,1,0,96,96A96,96,0,0,0,128,32ZM112,160,64,128l48-32Zm64,0-48-32,48-32Z",
  opacity: "0.2"
}, null, -1), Dzr = ["stroke"], Rzr = ["stroke"], Uzr = ["stroke"], qzr = { key: 2 }, Gzr = /* @__PURE__ */ e("path", { d: "M24,128A104,104,0,1,0,128,24,104.2,104.2,0,0,0,24,128Zm44,0a8.2,8.2,0,0,1,3.4-6.6l40-28a8,8,0,0,1,8.3-.5A8.1,8.1,0,0,1,124,100v28a8.2,8.2,0,0,1,3.4-6.6l40-28a8,8,0,0,1,8.3-.5A8.1,8.1,0,0,1,180,100v56a8,8,0,0,1-8,8,8.6,8.6,0,0,1-4.6-1.4l-40-28A8.2,8.2,0,0,1,124,128v28a8,8,0,0,1-8,8,8.6,8.6,0,0,1-4.6-1.4l-40-28A8.2,8.2,0,0,1,68,128Z" }, null, -1), Ezr = [
  Gzr
], Ozr = { key: 3 }, Izr = ["stroke"], Kzr = ["stroke"], Xzr = ["stroke"], Jzr = { key: 4 }, Qzr = ["stroke"], Yzr = ["stroke"], oZr = ["stroke"], eZr = { key: 5 }, tZr = ["stroke"], nZr = ["stroke"], sZr = ["stroke"], rZr = {
  name: "PhRewindCircle"
}, lol = /* @__PURE__ */ $({
  ...rZr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Bzr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pzr),
        e("polygon", {
          points: "168 156 132 128 168 100 168 156",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wzr),
        e("polygon", {
          points: "112 156 76 128 112 100 112 156",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nzr)
      ])) : o(i) === "duotone" ? (s(), r("g", Fzr, [
        Tzr,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dzr),
        e("polygon", {
          points: "176 160 128 128 176 96 176 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rzr),
        e("polygon", {
          points: "112 160 64 128 112 96 112 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uzr)
      ])) : o(i) === "fill" ? (s(), r("g", qzr, Ezr)) : o(i) === "light" ? (s(), r("g", Ozr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Izr),
        e("polygon", {
          points: "172 160 124 128 172 96 172 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kzr),
        e("polygon", {
          points: "116 160 68 128 116 96 116 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xzr)
      ])) : o(i) === "thin" ? (s(), r("g", Jzr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qzr),
        e("polygon", {
          points: "172 160 124 128 172 96 172 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Yzr),
        e("polygon", {
          points: "116 160 68 128 116 96 116 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oZr)
      ])) : o(i) === "regular" ? (s(), r("g", eZr, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tZr),
        e("polygon", {
          points: "176 160 128 128 176 96 176 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nZr),
        e("polygon", {
          points: "112 160 64 128 112 96 112 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sZr)
      ])) : g("", !0)
    ], 16, Lzr));
  }
}), iZr = ["width", "height", "fill", "transform"], lZr = { key: 0 }, dZr = ["stroke"], kZr = ["stroke"], cZr = ["stroke"], hZr = ["stroke"], uZr = ["stroke"], aZr = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "104",
  r: "16"
}, null, -1), _Zr = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "104",
  r: "16"
}, null, -1), pZr = { key: 1 }, yZr = /* @__PURE__ */ e("path", {
  d: "M200,56H56A23.9,23.9,0,0,0,32,80V192a23.9,23.9,0,0,0,24,24H200a23.9,23.9,0,0,0,24-24V80A23.9,23.9,0,0,0,200,56ZM164,184H92a20,20,0,0,1,0-40h72a20,20,0,0,1,0,40Z",
  opacity: "0.2"
}, null, -1), $Zr = ["stroke"], wZr = ["stroke"], fZr = ["stroke"], gZr = ["stroke"], xZr = ["stroke"], jZr = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "108",
  r: "12"
}, null, -1), mZr = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "108",
  r: "12"
}, null, -1), MZr = { key: 2 }, vZr = /* @__PURE__ */ e("path", { d: "M200,48H136V16a8,8,0,0,0-16,0V48H56A32.1,32.1,0,0,0,24,80V192a32.1,32.1,0,0,0,32,32H200a32.1,32.1,0,0,0,32-32V80A32.1,32.1,0,0,0,200,48ZM72,108a12,12,0,1,1,12,12A12,12,0,0,1,72,108Zm28,76H92a16,16,0,0,1,0-32h8Zm40,0H116V152h24Zm24,0h-8V152h8a16,16,0,0,1,0,32Zm8-64a12,12,0,1,1,12-12A12,12,0,0,1,172,120Z" }, null, -1), SZr = [
  vZr
], HZr = { key: 3 }, AZr = ["stroke"], VZr = ["stroke"], zZr = ["stroke"], ZZr = ["stroke"], CZr = ["stroke"], bZr = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "108",
  r: "10"
}, null, -1), LZr = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "108",
  r: "10"
}, null, -1), BZr = { key: 4 }, PZr = ["stroke"], WZr = ["stroke"], NZr = ["stroke"], FZr = ["stroke"], TZr = ["stroke"], DZr = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "108",
  r: "8"
}, null, -1), RZr = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "108",
  r: "8"
}, null, -1), UZr = { key: 5 }, qZr = ["stroke"], GZr = ["stroke"], EZr = ["stroke"], OZr = ["stroke"], IZr = ["stroke"], KZr = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "108",
  r: "12"
}, null, -1), XZr = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "108",
  r: "12"
}, null, -1), JZr = {
  name: "PhRobot"
}, dol = /* @__PURE__ */ $({
  ...JZr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", lZr, [
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "160",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dZr),
        e("rect", {
          x: "68",
          y: "144",
          width: "120",
          height: "36",
          rx: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kZr),
        e("line", {
          x1: "108",
          y1: "144",
          x2: "108",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cZr),
        e("line", {
          x1: "148",
          y1: "144",
          x2: "148",
          y2: "180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hZr),
        e("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uZr),
        aZr,
        _Zr
      ])) : o(i) === "duotone" ? (s(), r("g", pZr, [
        yZr,
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "160",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Zr),
        e("rect", {
          x: "72",
          y: "144",
          width: "112",
          height: "40",
          rx: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wZr),
        e("line", {
          x1: "148",
          y1: "144",
          x2: "148",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fZr),
        e("line", {
          x1: "108",
          y1: "144",
          x2: "108",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gZr),
        e("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xZr),
        jZr,
        mZr
      ])) : o(i) === "fill" ? (s(), r("g", MZr, SZr)) : o(i) === "light" ? (s(), r("g", HZr, [
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "160",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, AZr),
        e("rect", {
          x: "72",
          y: "144",
          width: "112",
          height: "40",
          rx: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VZr),
        e("line", {
          x1: "148",
          y1: "144",
          x2: "148",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zZr),
        e("line", {
          x1: "108",
          y1: "144",
          x2: "108",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZZr),
        e("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, CZr),
        bZr,
        LZr
      ])) : o(i) === "thin" ? (s(), r("g", BZr, [
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "160",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PZr),
        e("rect", {
          x: "72",
          y: "144",
          width: "112",
          height: "40",
          rx: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WZr),
        e("line", {
          x1: "148",
          y1: "144",
          x2: "148",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, NZr),
        e("line", {
          x1: "108",
          y1: "144",
          x2: "108",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FZr),
        e("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, TZr),
        DZr,
        RZr
      ])) : o(i) === "regular" ? (s(), r("g", UZr, [
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "160",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qZr),
        e("rect", {
          x: "72",
          y: "144",
          width: "112",
          height: "40",
          rx: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GZr),
        e("line", {
          x1: "148",
          y1: "144",
          x2: "148",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EZr),
        e("line", {
          x1: "108",
          y1: "144",
          x2: "108",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OZr),
        e("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IZr),
        KZr,
        XZr
      ])) : g("", !0)
    ], 16, iZr));
  }
}), QZr = ["width", "height", "fill", "transform"], YZr = { key: 0 }, oCr = ["stroke"], eCr = ["stroke"], tCr = ["stroke"], nCr = ["stroke"], sCr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "96",
  r: "16"
}, null, -1), rCr = { key: 1 }, iCr = /* @__PURE__ */ e("path", {
  d: "M73.9,111.4h0L42.5,149a7.6,7.6,0,0,0-1.6,6.8l12.3,55.7A8,8,0,0,0,66,216l30-24C78.4,161.4,72.7,134.5,73.9,111.4Z",
  opacity: "0.2"
}, null, -1), lCr = /* @__PURE__ */ e("path", {
  d: "M181.5,110.7h0l31.4,37.7a7.6,7.6,0,0,1,1.6,6.8l-12.3,55.6a8,8,0,0,1-12.8,4.6l-30-24C177,160.7,182.7,133.8,181.5,110.7Z",
  opacity: "0.2"
}, null, -1), dCr = ["stroke"], kCr = ["stroke"], cCr = ["stroke"], hCr = ["stroke"], uCr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "96",
  r: "12"
}, null, -1), aCr = { key: 2 }, _Cr = /* @__PURE__ */ e("path", { d: "M144,216H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Z" }, null, -1), pCr = /* @__PURE__ */ e("path", { d: "M219.6,143.9l-30.2-36.3a125.4,125.4,0,0,0-8-34.9c-11.6-30.2-32.1-50-43.4-59.1a15.9,15.9,0,0,0-20-.1c-11.4,9.1-32.2,28.9-43.9,59.1A121.5,121.5,0,0,0,66,108.3L36.4,143.9A16.1,16.1,0,0,0,33,157.6l12.4,55.6a15.9,15.9,0,0,0,10.3,11.6,17,17,0,0,0,5.4.9,16,16,0,0,0,9.9-3.5L98.8,200h58.4L185,222.2a16,16,0,0,0,9.9,3.5,17,17,0,0,0,5.4-.9,15.9,15.9,0,0,0,10.3-11.6L223,157.6A16.1,16.1,0,0,0,219.6,143.9ZM61,209.7,48.7,154.1l17.9-21.5q3.5,28.1,19.1,57.4ZM128,108a12,12,0,1,1,12-12A12,12,0,0,1,128,108Zm67,101.7-24.8-19.8c10.4-19.7,16.6-39,18.8-57.8l18.3,22Z" }, null, -1), yCr = [
  _Cr,
  pCr
], $Cr = { key: 3 }, wCr = ["stroke"], fCr = ["stroke"], gCr = ["stroke"], xCr = ["stroke"], jCr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "96",
  r: "10"
}, null, -1), mCr = { key: 4 }, MCr = ["stroke"], vCr = ["stroke"], SCr = ["stroke"], HCr = ["stroke"], ACr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "96",
  r: "8"
}, null, -1), VCr = { key: 5 }, zCr = ["stroke"], ZCr = ["stroke"], CCr = ["stroke"], bCr = ["stroke"], LCr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "96",
  r: "12"
}, null, -1), BCr = {
  name: "PhRocket"
}, kol = /* @__PURE__ */ $({
  ...BCr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", YZr, [
        e("line", {
          x1: "144",
          y1: "228",
          x2: "112",
          y2: "228",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oCr),
        e("path", {
          d: "M123,19.8C104,35,40.5,95.8,96,192h64c54.4-96.2-8.2-156.9-27-172.2A7.8,7.8,0,0,0,123,19.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eCr),
        e("path", {
          d: "M73.9,111.4,42.5,149a7.6,7.6,0,0,0-1.6,6.8l12.3,55.7A8,8,0,0,0,66,216l30-24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tCr),
        e("path", {
          d: "M181.5,110.6l32,38.4a7.6,7.6,0,0,1,1.6,6.8l-12.3,55.7A8,8,0,0,1,190,216l-30-24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nCr),
        sCr
      ])) : o(i) === "duotone" ? (s(), r("g", rCr, [
        iCr,
        lCr,
        e("line", {
          x1: "144",
          y1: "224",
          x2: "112",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dCr),
        e("path", {
          d: "M123,19.8C104,35,40.5,95.8,96,192h64c54.4-96.2-8.2-156.9-27-172.2A7.8,7.8,0,0,0,123,19.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kCr),
        e("path", {
          d: "M73.9,111.4,42.5,149a7.6,7.6,0,0,0-1.6,6.8l12.3,55.7A8,8,0,0,0,66,216l30-24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cCr),
        e("path", {
          d: "M181.5,110.6l32,38.4a7.6,7.6,0,0,1,1.6,6.8l-12.3,55.7A8,8,0,0,1,190,216l-30-24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hCr),
        uCr
      ])) : o(i) === "fill" ? (s(), r("g", aCr, yCr)) : o(i) === "light" ? (s(), r("g", $Cr, [
        e("line", {
          x1: "144",
          y1: "224",
          x2: "112",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wCr),
        e("path", {
          d: "M123,19.8C104,35,40.5,95.8,96,192h64c54.4-96.2-8.2-156.9-27-172.2A7.8,7.8,0,0,0,123,19.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fCr),
        e("path", {
          d: "M73.9,111.4,42.5,149a7.6,7.6,0,0,0-1.6,6.8l12.3,55.7A8,8,0,0,0,66,216l30-24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gCr),
        e("path", {
          d: "M181.5,110.6l32,38.4a7.6,7.6,0,0,1,1.6,6.8l-12.3,55.7A8,8,0,0,1,190,216l-30-24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xCr),
        jCr
      ])) : o(i) === "thin" ? (s(), r("g", mCr, [
        e("line", {
          x1: "144",
          y1: "224",
          x2: "112",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MCr),
        e("path", {
          d: "M123,19.8C104,35,40.5,95.8,96,192h64c54.4-96.2-8.2-156.9-27-172.2A7.8,7.8,0,0,0,123,19.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vCr),
        e("path", {
          d: "M73.9,111.4,42.5,149a7.6,7.6,0,0,0-1.6,6.8l12.3,55.7A8,8,0,0,0,66,216l30-24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SCr),
        e("path", {
          d: "M181.5,110.6l32,38.4a7.6,7.6,0,0,1,1.6,6.8l-12.3,55.7A8,8,0,0,1,190,216l-30-24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HCr),
        ACr
      ])) : o(i) === "regular" ? (s(), r("g", VCr, [
        e("line", {
          x1: "144",
          y1: "224",
          x2: "112",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zCr),
        e("path", {
          d: "M123,19.8C104,35,40.5,95.8,96,192h64c54.4-96.2-8.2-156.9-27-172.2A7.8,7.8,0,0,0,123,19.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZCr),
        e("path", {
          d: "M73.9,111.4,42.5,149a7.6,7.6,0,0,0-1.6,6.8l12.3,55.7A8,8,0,0,0,66,216l30-24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CCr),
        e("path", {
          d: "M181.5,110.6l32,38.4a7.6,7.6,0,0,1,1.6,6.8l-12.3,55.7A8,8,0,0,1,190,216l-30-24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bCr),
        LCr
      ])) : g("", !0)
    ], 16, QZr));
  }
}), PCr = ["width", "height", "fill", "transform"], WCr = { key: 0 }, NCr = ["stroke"], FCr = ["stroke"], TCr = ["stroke"], DCr = ["stroke"], RCr = { key: 1 }, UCr = /* @__PURE__ */ e("path", {
  d: "M94.1,184.6c-11.4,33.9-56.6,33.9-56.6,33.9s0-45.2,33.9-56.6Z",
  opacity: "0.2"
}, null, -1), qCr = /* @__PURE__ */ e("path", {
  d: "M184.6,116.7v64.6a8,8,0,0,1-2.4,5.6l-32.3,32.4a8,8,0,0,1-13.5-4.1L128,173.3Z",
  opacity: "0.2"
}, null, -1), GCr = /* @__PURE__ */ e("path", {
  d: "M139.3,71.4H74.7a8,8,0,0,0-5.6,2.4L36.7,106.1a8,8,0,0,0,4.1,13.5L82.7,128Z",
  opacity: "0.2"
}, null, -1), ECr = ["stroke"], OCr = ["stroke"], ICr = ["stroke"], KCr = ["stroke"], XCr = { key: 2 }, JCr = /* @__PURE__ */ e("path", { d: "M96.6,177a7.9,7.9,0,0,0-10.1,5c-6.6,19.7-27.9,25.8-40.2,27.7,1.9-12.3,8-33.6,27.7-40.2a8,8,0,1,0-5.1-15.1c-16.4,5.4-28.4,18.4-34.8,37.5a91.8,91.8,0,0,0-4.6,26.6,8,8,0,0,0,8,8,91.8,91.8,0,0,0,26.6-4.6c19.1-6.4,32.1-18.4,37.5-34.8A7.9,7.9,0,0,0,96.6,177Z" }, null, -1), QCr = /* @__PURE__ */ e("path", { d: "M227.6,41.8a15.7,15.7,0,0,0-13.4-13.4c-11.3-1.7-40.6-2.5-69.2,26.1l-9,8.9H74.7a16.2,16.2,0,0,0-11.3,4.7L31.1,100.5a15.9,15.9,0,0,0-4,15.9,16,16,0,0,0,12.2,11.1l39.5,7.9,41.8,41.8,7.9,39.5a16,16,0,0,0,11.1,12.2,14.7,14.7,0,0,0,4.6.7,15.6,15.6,0,0,0,11.3-4.7l32.4-32.3a16.2,16.2,0,0,0,4.7-11.3V120l8.9-9C230.1,82.4,229.3,53.1,227.6,41.8ZM74.7,79.4H120L80.1,119.3l-37.7-7.5ZM176.6,181.3l-32.4,32.3-7.5-37.7L176.6,136Z" }, null, -1), YCr = [
  JCr,
  QCr
], obr = { key: 3 }, ebr = ["stroke"], tbr = ["stroke"], nbr = ["stroke"], sbr = ["stroke"], rbr = { key: 4 }, ibr = ["stroke"], lbr = ["stroke"], dbr = ["stroke"], kbr = ["stroke"], cbr = { key: 5 }, hbr = ["stroke"], ubr = ["stroke"], abr = ["stroke"], _br = ["stroke"], pbr = {
  name: "PhRocketLaunch"
}, col = /* @__PURE__ */ $({
  ...pbr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", WCr, [
        e("path", {
          d: "M195.9,105.4,128,173.3,82.7,128l67.9-67.9C176.3,34.4,202,34.7,213,36.3a7.8,7.8,0,0,1,6.7,6.7C221.3,54,221.6,79.7,195.9,105.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NCr),
        e("path", {
          d: "M184.6,116.7v64.6a8,8,0,0,1-2.4,5.6l-32.3,32.4a8,8,0,0,1-13.5-4.1L128,173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FCr),
        e("path", {
          d: "M139.3,71.4H74.7a8,8,0,0,0-5.6,2.4L36.7,106.1a8,8,0,0,0,4.1,13.5L82.7,128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TCr),
        e("path", {
          d: "M90.6,192.4c-15.1,26.1-53.1,26.1-53.1,26.1s0-38,26.1-53.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DCr)
      ])) : o(i) === "duotone" ? (s(), r("g", RCr, [
        UCr,
        qCr,
        GCr,
        e("path", {
          d: "M94.1,184.6c-11.4,33.9-56.6,33.9-56.6,33.9s0-45.2,33.9-56.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ECr),
        e("path", {
          d: "M195.9,105.4,128,173.3,82.7,128l67.9-67.9C176.3,34.4,202,34.7,213,36.3a7.8,7.8,0,0,1,6.7,6.7C221.3,54,221.6,79.7,195.9,105.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OCr),
        e("path", {
          d: "M184.6,116.7v64.6a8,8,0,0,1-2.4,5.6l-32.3,32.4a8,8,0,0,1-13.5-4.1L128,173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ICr),
        e("path", {
          d: "M139.3,71.4H74.7a8,8,0,0,0-5.6,2.4L36.7,106.1a8,8,0,0,0,4.1,13.5L82.7,128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KCr)
      ])) : o(i) === "fill" ? (s(), r("g", XCr, YCr)) : o(i) === "light" ? (s(), r("g", obr, [
        e("path", {
          d: "M94.1,184.6c-11.4,33.9-56.6,33.9-56.6,33.9s0-45.2,33.9-56.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ebr),
        e("path", {
          d: "M195.9,105.4,128,173.3,82.7,128l67.9-67.9C176.3,34.4,202,34.7,213,36.3a7.8,7.8,0,0,1,6.7,6.7C221.3,54,221.6,79.7,195.9,105.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tbr),
        e("path", {
          d: "M184.6,116.7v64.6a8,8,0,0,1-2.4,5.6l-32.3,32.4a8,8,0,0,1-13.5-4.1L128,173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nbr),
        e("path", {
          d: "M139.3,71.4H74.7a8,8,0,0,0-5.6,2.4L36.7,106.1a8,8,0,0,0,4.1,13.5L82.7,128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sbr)
      ])) : o(i) === "thin" ? (s(), r("g", rbr, [
        e("path", {
          d: "M94.1,184.6c-11.4,33.9-56.6,33.9-56.6,33.9s0-45.2,33.9-56.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ibr),
        e("path", {
          d: "M195.9,105.4,128,173.3,82.7,128l67.9-67.9C176.3,34.4,202,34.7,213,36.3a7.8,7.8,0,0,1,6.7,6.7C221.3,54,221.6,79.7,195.9,105.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lbr),
        e("path", {
          d: "M184.6,116.7v64.6a8,8,0,0,1-2.4,5.6l-32.3,32.4a8,8,0,0,1-13.5-4.1L128,173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dbr),
        e("path", {
          d: "M139.3,71.4H74.7a8,8,0,0,0-5.6,2.4L36.7,106.1a8,8,0,0,0,4.1,13.5L82.7,128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kbr)
      ])) : o(i) === "regular" ? (s(), r("g", cbr, [
        e("path", {
          d: "M94.1,184.6c-11.4,33.9-56.6,33.9-56.6,33.9s0-45.2,33.9-56.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hbr),
        e("path", {
          d: "M195.9,105.4,128,173.3,82.7,128l67.9-67.9C176.3,34.4,202,34.7,213,36.3a7.8,7.8,0,0,1,6.7,6.7C221.3,54,221.6,79.7,195.9,105.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ubr),
        e("path", {
          d: "M184.6,116.7v64.6a8,8,0,0,1-2.4,5.6l-32.3,32.4a8,8,0,0,1-13.5-4.1L128,173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, abr),
        e("path", {
          d: "M139.3,71.4H74.7a8,8,0,0,0-5.6,2.4L36.7,106.1a8,8,0,0,0,4.1,13.5L82.7,128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _br)
      ])) : g("", !0)
    ], 16, PCr));
  }
}), ybr = ["width", "height", "fill", "transform"], $br = { key: 0 }, wbr = ["stroke"], fbr = ["stroke"], gbr = { key: 1 }, xbr = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "144",
  width: "176",
  height: "56",
  rx: "8",
  opacity: "0.2"
}, null, -1), jbr = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "56",
  width: "176",
  height: "56",
  rx: "8",
  opacity: "0.2"
}, null, -1), mbr = ["stroke"], Mbr = ["stroke"], vbr = { key: 2 }, Sbr = /* @__PURE__ */ e("path", { d: "M224,152v40a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V152a16,16,0,0,1,16-16H208A16,16,0,0,1,224,152ZM208,48H48A16,16,0,0,0,32,64v40a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V64A16,16,0,0,0,208,48Z" }, null, -1), Hbr = [
  Sbr
], Abr = { key: 3 }, Vbr = ["stroke"], zbr = ["stroke"], Zbr = { key: 4 }, Cbr = ["stroke"], bbr = ["stroke"], Lbr = { key: 5 }, Bbr = ["stroke"], Pbr = ["stroke"], Wbr = {
  name: "PhRows"
}, hol = /* @__PURE__ */ $({
  ...Wbr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $br, [
        e("rect", {
          x: "40",
          y: "144",
          width: "176",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wbr),
        e("rect", {
          x: "40",
          y: "56",
          width: "176",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fbr)
      ])) : o(i) === "duotone" ? (s(), r("g", gbr, [
        xbr,
        jbr,
        e("rect", {
          x: "40",
          y: "144",
          width: "176",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mbr),
        e("rect", {
          x: "40",
          y: "56",
          width: "176",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mbr)
      ])) : o(i) === "fill" ? (s(), r("g", vbr, Hbr)) : o(i) === "light" ? (s(), r("g", Abr, [
        e("rect", {
          x: "40",
          y: "144",
          width: "176",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vbr),
        e("rect", {
          x: "40",
          y: "56",
          width: "176",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zbr)
      ])) : o(i) === "thin" ? (s(), r("g", Zbr, [
        e("rect", {
          x: "40",
          y: "144",
          width: "176",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cbr),
        e("rect", {
          x: "40",
          y: "56",
          width: "176",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bbr)
      ])) : o(i) === "regular" ? (s(), r("g", Lbr, [
        e("rect", {
          x: "40",
          y: "144",
          width: "176",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bbr),
        e("rect", {
          x: "40",
          y: "56",
          width: "176",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pbr)
      ])) : g("", !0)
    ], 16, ybr));
  }
}), Nbr = ["width", "height", "fill", "transform"], Fbr = { key: 0 }, Tbr = ["stroke"], Dbr = ["stroke"], Rbr = ["stroke"], Ubr = /* @__PURE__ */ e("circle", {
  cx: "52",
  cy: "204",
  r: "16"
}, null, -1), qbr = { key: 1 }, Gbr = ["stroke"], Ebr = ["stroke"], Obr = ["stroke"], Ibr = /* @__PURE__ */ e("circle", {
  cx: "52",
  cy: "204",
  r: "12"
}, null, -1), Kbr = { key: 2 }, Xbr = /* @__PURE__ */ e("path", { d: "M98.9,157.1A71.6,71.6,0,0,1,120,208a8,8,0,0,1-16,0,56,56,0,0,0-56-56,8,8,0,0,1,0-16A71.6,71.6,0,0,1,98.9,157.1ZM48,88a8,8,0,0,0,0,16,102.9,102.9,0,0,1,73.5,30.5A102.9,102.9,0,0,1,152,208a8,8,0,0,0,16,0,119.2,119.2,0,0,0-35.2-84.9A119.3,119.3,0,0,0,48,88Zm118.8,1.2A166.9,166.9,0,0,0,48,40a8,8,0,0,0,0,16,151.1,151.1,0,0,1,107.5,44.5A151.1,151.1,0,0,1,200,208a8,8,0,0,0,16,0A166.9,166.9,0,0,0,166.8,89.2ZM52,192a12,12,0,1,0,12,12A12,12,0,0,0,52,192Z" }, null, -1), Jbr = [
  Xbr
], Qbr = { key: 3 }, Ybr = ["stroke"], oLr = ["stroke"], eLr = ["stroke"], tLr = /* @__PURE__ */ e("circle", {
  cx: "52",
  cy: "204",
  r: "10"
}, null, -1), nLr = { key: 4 }, sLr = ["stroke"], rLr = ["stroke"], iLr = ["stroke"], lLr = /* @__PURE__ */ e("circle", {
  cx: "52",
  cy: "204",
  r: "8"
}, null, -1), dLr = { key: 5 }, kLr = ["stroke"], cLr = ["stroke"], hLr = ["stroke"], uLr = /* @__PURE__ */ e("circle", {
  cx: "52",
  cy: "204",
  r: "12"
}, null, -1), aLr = {
  name: "PhRss"
}, uol = /* @__PURE__ */ $({
  ...aLr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Fbr, [
        e("path", {
          d: "M48,144a64,64,0,0,1,64,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Tbr),
        e("path", {
          d: "M48,96A112,112,0,0,1,160,208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Dbr),
        e("path", {
          d: "M48,48A159.1,159.1,0,0,1,161.1,94.9,159.1,159.1,0,0,1,208,208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rbr),
        Ubr
      ])) : o(i) === "duotone" ? (s(), r("g", qbr, [
        e("path", {
          d: "M48,144a64,64,0,0,1,64,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gbr),
        e("path", {
          d: "M48,96A112,112,0,0,1,160,208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ebr),
        e("path", {
          d: "M48,48A159.1,159.1,0,0,1,161.1,94.9,159.1,159.1,0,0,1,208,208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Obr),
        Ibr
      ])) : o(i) === "fill" ? (s(), r("g", Kbr, Jbr)) : o(i) === "light" ? (s(), r("g", Qbr, [
        e("path", {
          d: "M48,144a64,64,0,0,1,64,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ybr),
        e("path", {
          d: "M48,96A112,112,0,0,1,160,208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oLr),
        e("path", {
          d: "M48,48A159.1,159.1,0,0,1,161.1,94.9,159.1,159.1,0,0,1,208,208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eLr),
        tLr
      ])) : o(i) === "thin" ? (s(), r("g", nLr, [
        e("path", {
          d: "M48,144a64,64,0,0,1,64,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sLr),
        e("path", {
          d: "M48,96A112,112,0,0,1,160,208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rLr),
        e("path", {
          d: "M48,48A159.1,159.1,0,0,1,161.1,94.9,159.1,159.1,0,0,1,208,208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iLr),
        lLr
      ])) : o(i) === "regular" ? (s(), r("g", dLr, [
        e("path", {
          d: "M48,144a63.8,63.8,0,0,1,64,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kLr),
        e("path", {
          d: "M48,96A112,112,0,0,1,160,208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cLr),
        e("path", {
          d: "M48,48A159.1,159.1,0,0,1,161.1,94.9,159.1,159.1,0,0,1,208,208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hLr),
        uLr
      ])) : g("", !0)
    ], 16, Nbr));
  }
}), _Lr = ["width", "height", "fill", "transform"], pLr = { key: 0 }, yLr = ["stroke"], $Lr = ["stroke"], wLr = /* @__PURE__ */ e("circle", {
  cx: "56",
  cy: "200",
  r: "16"
}, null, -1), fLr = { key: 1 }, gLr = ["stroke"], xLr = ["stroke"], jLr = /* @__PURE__ */ e("circle", {
  cx: "56",
  cy: "200",
  r: "12"
}, null, -1), mLr = { key: 2 }, MLr = /* @__PURE__ */ e("path", { d: "M216,200a8,8,0,0,1-16,0c0-79.4-64.6-144-144-144a8,8,0,0,1,0-16C144.2,40,216,111.8,216,200ZM56,112a8,8,0,0,0,0,16,72.1,72.1,0,0,1,72,72,8,8,0,0,0,16,0A88.1,88.1,0,0,0,56,112Zm0,76a12,12,0,1,0,12,12A12,12,0,0,0,56,188Z" }, null, -1), vLr = [
  MLr
], SLr = { key: 3 }, HLr = ["stroke"], ALr = ["stroke"], VLr = /* @__PURE__ */ e("circle", {
  cx: "56",
  cy: "200",
  r: "10"
}, null, -1), zLr = { key: 4 }, ZLr = ["stroke"], CLr = ["stroke"], bLr = /* @__PURE__ */ e("circle", {
  cx: "56",
  cy: "200",
  r: "8"
}, null, -1), LLr = { key: 5 }, BLr = ["stroke"], PLr = ["stroke"], WLr = /* @__PURE__ */ e("circle", {
  cx: "56",
  cy: "200",
  r: "12"
}, null, -1), NLr = {
  name: "PhRssSimple"
}, aol = /* @__PURE__ */ $({
  ...NLr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", pLr, [
        e("path", {
          d: "M56,48A152.1,152.1,0,0,1,208,200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yLr),
        e("path", {
          d: "M56,120a80,80,0,0,1,80,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $Lr),
        wLr
      ])) : o(i) === "duotone" ? (s(), r("g", fLr, [
        e("path", {
          d: "M56,48A152.1,152.1,0,0,1,208,200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gLr),
        e("path", {
          d: "M56,120a80,80,0,0,1,80,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xLr),
        jLr
      ])) : o(i) === "fill" ? (s(), r("g", mLr, vLr)) : o(i) === "light" ? (s(), r("g", SLr, [
        e("path", {
          d: "M56,48A152.1,152.1,0,0,1,208,200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HLr),
        e("path", {
          d: "M56,120a80,80,0,0,1,80,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ALr),
        VLr
      ])) : o(i) === "thin" ? (s(), r("g", zLr, [
        e("path", {
          d: "M56,48A152.1,152.1,0,0,1,208,200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZLr),
        e("path", {
          d: "M56,120a80,80,0,0,1,80,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CLr),
        bLr
      ])) : o(i) === "regular" ? (s(), r("g", LLr, [
        e("path", {
          d: "M56,48A152.1,152.1,0,0,1,208,200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BLr),
        e("path", {
          d: "M56,120a80,80,0,0,1,80,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PLr),
        WLr
      ])) : g("", !0)
    ], 16, _Lr));
  }
}), FLr = ["width", "height", "fill", "transform"], TLr = { key: 0 }, DLr = ["stroke"], RLr = ["stroke"], ULr = ["stroke"], qLr = ["stroke"], GLr = ["stroke"], ELr = ["stroke"], OLr = ["stroke"], ILr = ["stroke"], KLr = ["stroke"], XLr = ["stroke"], JLr = { key: 1 }, QLr = /* @__PURE__ */ e("path", {
  d: "M56,48V208H200V48Zm72,120-24-40,24-40,24,40Z",
  opacity: "0.2"
}, null, -1), YLr = ["stroke"], oBr = ["stroke"], eBr = ["stroke"], tBr = ["stroke"], nBr = ["stroke"], sBr = ["stroke"], rBr = ["stroke"], iBr = ["stroke"], lBr = ["stroke"], dBr = ["stroke"], kBr = { key: 2 }, cBr = /* @__PURE__ */ e("path", { d: "M200,16a8,8,0,0,0-8,8V40H160V24a8,8,0,0,0-16,0V40H112V24a8,8,0,0,0-16,0V40H64V24a8,8,0,0,0-16,0V232a8,8,0,0,0,16,0V216H96v16a8,8,0,0,0,16,0V216h32v16a8,8,0,0,0,16,0V216h32v16a8,8,0,0,0,16,0V24A8,8,0,0,0,200,16ZM64,56H192V200H64Zm57.1,116.1-24-40a8,8,0,0,1,0-8.2l24-40a8.1,8.1,0,0,1,13.8,0l24,40a8,8,0,0,1,0,8.2l-24,40a8.1,8.1,0,0,1-13.8,0Z" }, null, -1), hBr = [
  cBr
], uBr = { key: 3 }, aBr = ["stroke"], _Br = ["stroke"], pBr = ["stroke"], yBr = ["stroke"], $Br = ["stroke"], wBr = ["stroke"], fBr = ["stroke"], gBr = ["stroke"], xBr = ["stroke"], jBr = ["stroke"], mBr = { key: 4 }, MBr = ["stroke"], vBr = ["stroke"], SBr = ["stroke"], HBr = ["stroke"], ABr = ["stroke"], VBr = ["stroke"], zBr = ["stroke"], ZBr = ["stroke"], CBr = ["stroke"], bBr = ["stroke"], LBr = { key: 5 }, BBr = ["stroke"], PBr = ["stroke"], WBr = ["stroke"], NBr = ["stroke"], FBr = ["stroke"], TBr = ["stroke"], DBr = ["stroke"], RBr = ["stroke"], UBr = ["stroke"], qBr = ["stroke"], GBr = {
  name: "PhRug"
}, _ol = /* @__PURE__ */ $({
  ...GBr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", TLr, [
        e("rect", {
          x: "56",
          y: "48",
          width: "144",
          height: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DLr),
        e("line", {
          x1: "56",
          y1: "48",
          x2: "56",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RLr),
        e("line", {
          x1: "104",
          y1: "48",
          x2: "104",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ULr),
        e("line", {
          x1: "200",
          y1: "48",
          x2: "200",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qLr),
        e("line", {
          x1: "56",
          y1: "232",
          x2: "56",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GLr),
        e("line", {
          x1: "104",
          y1: "232",
          x2: "104",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ELr),
        e("line", {
          x1: "152",
          y1: "48",
          x2: "152",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OLr),
        e("line", {
          x1: "152",
          y1: "232",
          x2: "152",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ILr),
        e("line", {
          x1: "200",
          y1: "232",
          x2: "200",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KLr),
        e("polygon", {
          points: "128 88 104 128 128 168 152 128 128 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XLr)
      ])) : o(i) === "duotone" ? (s(), r("g", JLr, [
        QLr,
        e("rect", {
          x: "56",
          y: "48",
          width: "144",
          height: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YLr),
        e("line", {
          x1: "56",
          y1: "48",
          x2: "56",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oBr),
        e("line", {
          x1: "104",
          y1: "48",
          x2: "104",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eBr),
        e("line", {
          x1: "200",
          y1: "48",
          x2: "200",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tBr),
        e("line", {
          x1: "56",
          y1: "232",
          x2: "56",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nBr),
        e("line", {
          x1: "104",
          y1: "232",
          x2: "104",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sBr),
        e("line", {
          x1: "152",
          y1: "48",
          x2: "152",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rBr),
        e("line", {
          x1: "152",
          y1: "232",
          x2: "152",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iBr),
        e("line", {
          x1: "200",
          y1: "232",
          x2: "200",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lBr),
        e("polygon", {
          points: "128 88 104 128 128 168 152 128 128 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dBr)
      ])) : o(i) === "fill" ? (s(), r("g", kBr, hBr)) : o(i) === "light" ? (s(), r("g", uBr, [
        e("rect", {
          x: "56",
          y: "48",
          width: "144",
          height: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aBr),
        e("line", {
          x1: "56",
          y1: "48",
          x2: "56",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _Br),
        e("line", {
          x1: "104",
          y1: "48",
          x2: "104",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pBr),
        e("line", {
          x1: "200",
          y1: "48",
          x2: "200",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yBr),
        e("line", {
          x1: "56",
          y1: "232",
          x2: "56",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $Br),
        e("line", {
          x1: "104",
          y1: "232",
          x2: "104",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wBr),
        e("line", {
          x1: "152",
          y1: "48",
          x2: "152",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fBr),
        e("line", {
          x1: "152",
          y1: "232",
          x2: "152",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gBr),
        e("line", {
          x1: "200",
          y1: "232",
          x2: "200",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xBr),
        e("polygon", {
          points: "128 88 104 128 128 168 152 128 128 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jBr)
      ])) : o(i) === "thin" ? (s(), r("g", mBr, [
        e("rect", {
          x: "56",
          y: "48",
          width: "144",
          height: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MBr),
        e("line", {
          x1: "56",
          y1: "48",
          x2: "56",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vBr),
        e("line", {
          x1: "104",
          y1: "48",
          x2: "104",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SBr),
        e("line", {
          x1: "200",
          y1: "48",
          x2: "200",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HBr),
        e("line", {
          x1: "56",
          y1: "232",
          x2: "56",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ABr),
        e("line", {
          x1: "104",
          y1: "232",
          x2: "104",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VBr),
        e("line", {
          x1: "152",
          y1: "48",
          x2: "152",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zBr),
        e("line", {
          x1: "152",
          y1: "232",
          x2: "152",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZBr),
        e("line", {
          x1: "200",
          y1: "232",
          x2: "200",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CBr),
        e("polygon", {
          points: "128 88 104 128 128 168 152 128 128 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bBr)
      ])) : o(i) === "regular" ? (s(), r("g", LBr, [
        e("rect", {
          x: "56",
          y: "48",
          width: "144",
          height: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BBr),
        e("line", {
          x1: "56",
          y1: "48",
          x2: "56",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PBr),
        e("line", {
          x1: "104",
          y1: "48",
          x2: "104",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WBr),
        e("line", {
          x1: "200",
          y1: "48",
          x2: "200",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NBr),
        e("line", {
          x1: "56",
          y1: "232",
          x2: "56",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FBr),
        e("line", {
          x1: "104",
          y1: "232",
          x2: "104",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TBr),
        e("line", {
          x1: "152",
          y1: "48",
          x2: "152",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DBr),
        e("line", {
          x1: "152",
          y1: "232",
          x2: "152",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RBr),
        e("line", {
          x1: "200",
          y1: "232",
          x2: "200",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UBr),
        e("polygon", {
          points: "128 88 104 128 128 168 152 128 128 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qBr)
      ])) : g("", !0)
    ], 16, FLr));
  }
}), EBr = ["width", "height", "fill", "transform"], OBr = { key: 0 }, IBr = ["stroke"], KBr = ["stroke"], XBr = ["stroke"], JBr = ["stroke"], QBr = { key: 1 }, YBr = /* @__PURE__ */ e("rect", {
  x: "26.2",
  y: "82.7",
  width: "203.6",
  height: "90.51",
  rx: "8",
  transform: "translate(-53 128) rotate(-45)",
  opacity: "0.2"
}, null, -1), oPr = ["stroke"], ePr = ["stroke"], tPr = ["stroke"], nPr = ["stroke"], sPr = { key: 2 }, rPr = /* @__PURE__ */ e("path", { d: "M236.7,88.4a16.6,16.6,0,0,1-5,11.3L99.3,232a15.9,15.9,0,0,1-22.6,0L24,179.3a15.9,15.9,0,0,1,0-22.6l21.9-21.9a4,4,0,0,1,5.6,0l34.8,34.9A8.5,8.5,0,0,0,92,172a8,8,0,0,0,6.1-2.8,8.3,8.3,0,0,0-.6-11.1L62.8,123.5a4,4,0,0,1,0-5.6L81.9,98.8a4,4,0,0,1,5.6,0l34.8,34.9A8.5,8.5,0,0,0,128,136a8,8,0,0,0,6.1-2.8,8.3,8.3,0,0,0-.6-11.1L98.8,87.5a4,4,0,0,1,0-5.6l19.1-19.1a4,4,0,0,1,5.6,0l34.8,34.9A8.5,8.5,0,0,0,164,100a8,8,0,0,0,6.1-2.8,8.3,8.3,0,0,0-.6-11.1L134.8,51.5a4,4,0,0,1,0-5.6L156.7,24a16.1,16.1,0,0,1,22.6,0L232,76.7A16,16,0,0,1,236.7,88.4Z" }, null, -1), iPr = [
  rPr
], lPr = { key: 3 }, dPr = ["stroke"], kPr = ["stroke"], cPr = ["stroke"], hPr = ["stroke"], uPr = { key: 4 }, aPr = ["stroke"], _Pr = ["stroke"], pPr = ["stroke"], yPr = ["stroke"], $Pr = { key: 5 }, wPr = ["stroke"], fPr = ["stroke"], gPr = ["stroke"], xPr = ["stroke"], jPr = {
  name: "PhRuler"
}, pol = /* @__PURE__ */ $({
  ...jPr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", OBr, [
        e("rect", {
          x: "26.2",
          y: "82.7",
          width: "203.6",
          height: "90.51",
          rx: "8",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IBr),
        e("line", {
          x1: "132",
          y1: "60",
          x2: "164",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KBr),
        e("line", {
          x1: "96",
          y1: "96",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XBr),
        e("line", {
          x1: "60",
          y1: "132",
          x2: "92",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, JBr)
      ])) : o(i) === "duotone" ? (s(), r("g", QBr, [
        YBr,
        e("rect", {
          x: "26.2",
          y: "82.7",
          width: "203.6",
          height: "90.51",
          rx: "8",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oPr),
        e("line", {
          x1: "132",
          y1: "60",
          x2: "164",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ePr),
        e("line", {
          x1: "96",
          y1: "96",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tPr),
        e("line", {
          x1: "60",
          y1: "132",
          x2: "92",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nPr)
      ])) : o(i) === "fill" ? (s(), r("g", sPr, iPr)) : o(i) === "light" ? (s(), r("g", lPr, [
        e("rect", {
          x: "26.2",
          y: "82.7",
          width: "203.6",
          height: "90.51",
          rx: "8",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dPr),
        e("line", {
          x1: "132",
          y1: "60",
          x2: "164",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kPr),
        e("line", {
          x1: "96",
          y1: "96",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cPr),
        e("line", {
          x1: "60",
          y1: "132",
          x2: "92",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hPr)
      ])) : o(i) === "thin" ? (s(), r("g", uPr, [
        e("rect", {
          x: "26.2",
          y: "82.7",
          width: "203.6",
          height: "90.51",
          rx: "8",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aPr),
        e("line", {
          x1: "132",
          y1: "60",
          x2: "164",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _Pr),
        e("line", {
          x1: "96",
          y1: "96",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pPr),
        e("line", {
          x1: "60",
          y1: "132",
          x2: "92",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yPr)
      ])) : o(i) === "regular" ? (s(), r("g", $Pr, [
        e("rect", {
          x: "26.2",
          y: "82.7",
          width: "203.6",
          height: "90.51",
          rx: "8",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wPr),
        e("line", {
          x1: "132",
          y1: "60",
          x2: "164",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fPr),
        e("line", {
          x1: "96",
          y1: "96",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gPr),
        e("line", {
          x1: "60",
          y1: "132",
          x2: "92",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xPr)
      ])) : g("", !0)
    ], 16, EBr));
  }
}), mPr = ["width", "height", "fill", "transform"], MPr = { key: 0 }, vPr = ["stroke"], SPr = ["stroke"], HPr = ["stroke"], APr = ["stroke"], VPr = ["stroke"], zPr = { key: 1 }, ZPr = /* @__PURE__ */ e("path", {
  d: "M24,168c0,17.7,20,24,32,24s32-6.3,32-24L56,88Z",
  opacity: "0.2"
}, null, -1), CPr = /* @__PURE__ */ e("path", {
  d: "M168,136c0,17.7,20,24,32,24s32-6.3,32-24L200,56Z",
  opacity: "0.2"
}, null, -1), bPr = ["stroke"], LPr = ["stroke"], BPr = ["stroke"], PPr = ["stroke"], WPr = ["stroke"], NPr = { key: 2 }, FPr = /* @__PURE__ */ e("path", { d: "M239.4,133l-32-80h0l-.5-.9h0l-.6-.8c-.1-.1-.1-.1-.1-.2l-.8-.8a.1.1,0,0,1-.1-.1l-.7-.5-.2-.2-.9-.5h-.2l-.8-.3h-.2l-1-.2h-3L136,62V40a8,8,0,0,0-16,0V65.6L54.3,80.2h-.7l-1,.4h-.2l-.8.4a.1.1,0,0,1-.1.1l-.9.7a.1.1,0,0,1-.1.1l-.6.7h-.1a2.4,2.4,0,0,0-.6.9l-.2.2-.4.9h-.1L16.6,165a8,8,0,0,0-.6,3c0,23.3,24.5,32,40,32s40-8.7,40-32a8,8,0,0,0-.6-3L66.9,93.8,120,82V208H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16H136V78.4l50.9-11.3L160.6,133a8,8,0,0,0-.6,3c0,23.3,24.5,32,40,32s40-8.7,40-32A8,8,0,0,0,239.4,133ZM32.6,168,56,109.5,79.4,168Zm144-32L200,77.5,223.4,136Z" }, null, -1), TPr = [
  FPr
], DPr = { key: 3 }, RPr = ["stroke"], UPr = ["stroke"], qPr = ["stroke"], GPr = ["stroke"], EPr = ["stroke"], OPr = { key: 4 }, IPr = ["stroke"], KPr = ["stroke"], XPr = ["stroke"], JPr = ["stroke"], QPr = ["stroke"], YPr = { key: 5 }, oWr = ["stroke"], eWr = ["stroke"], tWr = ["stroke"], nWr = ["stroke"], sWr = ["stroke"], rWr = {
  name: "PhScales"
}, yol = /* @__PURE__ */ $({
  ...rWr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", MPr, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vPr),
        e("line", {
          x1: "104",
          y1: "216",
          x2: "152",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SPr),
        e("line", {
          x1: "56",
          y1: "88",
          x2: "200",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HPr),
        e("path", {
          d: "M24,168c0,17.7,20,24,32,24s32-6.3,32-24L56,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, APr),
        e("path", {
          d: "M168,136c0,17.7,20,24,32,24s32-6.3,32-24L200,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VPr)
      ])) : o(i) === "duotone" ? (s(), r("g", zPr, [
        ZPr,
        CPr,
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bPr),
        e("line", {
          x1: "104",
          y1: "216",
          x2: "152",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LPr),
        e("line", {
          x1: "56",
          y1: "88",
          x2: "200",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BPr),
        e("path", {
          d: "M24,168c0,17.7,20,24,32,24s32-6.3,32-24L56,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PPr),
        e("path", {
          d: "M168,136c0,17.7,20,24,32,24s32-6.3,32-24L200,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WPr)
      ])) : o(i) === "fill" ? (s(), r("g", NPr, TPr)) : o(i) === "light" ? (s(), r("g", DPr, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RPr),
        e("line", {
          x1: "104",
          y1: "216",
          x2: "152",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UPr),
        e("line", {
          x1: "56",
          y1: "88",
          x2: "200",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qPr),
        e("path", {
          d: "M24,168c0,17.7,20,24,32,24s32-6.3,32-24L56,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GPr),
        e("path", {
          d: "M168,136c0,17.7,20,24,32,24s32-6.3,32-24L200,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, EPr)
      ])) : o(i) === "thin" ? (s(), r("g", OPr, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, IPr),
        e("line", {
          x1: "104",
          y1: "216",
          x2: "152",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KPr),
        e("line", {
          x1: "56",
          y1: "88",
          x2: "200",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XPr),
        e("path", {
          d: "M24,168c0,17.7,20,24,32,24s32-6.3,32-24L56,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, JPr),
        e("path", {
          d: "M168,136c0,17.7,20,24,32,24s32-6.3,32-24L200,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QPr)
      ])) : o(i) === "regular" ? (s(), r("g", YPr, [
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oWr),
        e("line", {
          x1: "104",
          y1: "216",
          x2: "152",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eWr),
        e("line", {
          x1: "56",
          y1: "88",
          x2: "200",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tWr),
        e("path", {
          d: "M24,168c0,17.7,20,24,32,24s32-6.3,32-24L56,88Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nWr),
        e("path", {
          d: "M168,136c0,17.7,20,24,32,24s32-6.3,32-24L200,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sWr)
      ])) : g("", !0)
    ], 16, mPr));
  }
}), iWr = ["width", "height", "fill", "transform"], lWr = { key: 0 }, dWr = ["stroke"], kWr = ["stroke"], cWr = ["stroke"], hWr = ["stroke"], uWr = ["stroke"], aWr = { key: 1 }, _Wr = /* @__PURE__ */ e("rect", {
  x: "80",
  y: "80",
  width: "96",
  height: "96",
  rx: "8",
  opacity: "0.2"
}, null, -1), pWr = ["stroke"], yWr = ["stroke"], $Wr = ["stroke"], wWr = ["stroke"], fWr = ["stroke"], gWr = { key: 2 }, xWr = /* @__PURE__ */ e("path", { d: "M224,40V80a8,8,0,0,1-16,0V48H176a8,8,0,0,1,0-16h40A8,8,0,0,1,224,40ZM80,208H48V176a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H80a8,8,0,0,0,0-16Zm136-40a8,8,0,0,0-8,8v32H176a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V176A8,8,0,0,0,216,168ZM40,88a8,8,0,0,0,8-8V48H80a8,8,0,0,0,0-16H40a8,8,0,0,0-8,8V80A8,8,0,0,0,40,88Zm144,80V88a16,16,0,0,0-16-16H88A16,16,0,0,0,72,88v80a16,16,0,0,0,16,16h80A16,16,0,0,0,184,168Z" }, null, -1), jWr = [
  xWr
], mWr = { key: 3 }, MWr = ["stroke"], vWr = ["stroke"], SWr = ["stroke"], HWr = ["stroke"], AWr = ["stroke"], VWr = { key: 4 }, zWr = ["stroke"], ZWr = ["stroke"], CWr = ["stroke"], bWr = ["stroke"], LWr = ["stroke"], BWr = { key: 5 }, PWr = ["stroke"], WWr = ["stroke"], NWr = ["stroke"], FWr = ["stroke"], TWr = ["stroke"], DWr = {
  name: "PhScan"
}, $ol = /* @__PURE__ */ $({
  ...DWr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", lWr, [
        e("polyline", {
          points: "176 40 216 40 216 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dWr),
        e("polyline", {
          points: "80 216 40 216 40 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kWr),
        e("polyline", {
          points: "216 176 216 216 176 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cWr),
        e("polyline", {
          points: "40 80 40 40 80 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hWr),
        e("rect", {
          x: "84",
          y: "84",
          width: "88",
          height: "88",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uWr)
      ])) : o(i) === "duotone" ? (s(), r("g", aWr, [
        _Wr,
        e("polyline", {
          points: "176 40 216 40 216 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pWr),
        e("polyline", {
          points: "80 216 40 216 40 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yWr),
        e("polyline", {
          points: "216 176 216 216 176 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Wr),
        e("polyline", {
          points: "40 80 40 40 80 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wWr),
        e("rect", {
          x: "80",
          y: "80",
          width: "96",
          height: "96",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fWr)
      ])) : o(i) === "fill" ? (s(), r("g", gWr, jWr)) : o(i) === "light" ? (s(), r("g", mWr, [
        e("polyline", {
          points: "176 40 216 40 216 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, MWr),
        e("polyline", {
          points: "80 216 40 216 40 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vWr),
        e("polyline", {
          points: "216 176 216 216 176 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, SWr),
        e("polyline", {
          points: "40 80 40 40 80 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HWr),
        e("rect", {
          x: "80",
          y: "80",
          width: "96",
          height: "96",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, AWr)
      ])) : o(i) === "thin" ? (s(), r("g", VWr, [
        e("polyline", {
          points: "176 40 216 40 216 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zWr),
        e("polyline", {
          points: "80 216 40 216 40 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZWr),
        e("polyline", {
          points: "216 176 216 216 176 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CWr),
        e("polyline", {
          points: "40 80 40 40 80 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bWr),
        e("rect", {
          x: "80",
          y: "80",
          width: "96",
          height: "96",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LWr)
      ])) : o(i) === "regular" ? (s(), r("g", BWr, [
        e("polyline", {
          points: "176 40 216 40 216 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PWr),
        e("polyline", {
          points: "80 216 40 216 40 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WWr),
        e("polyline", {
          points: "216 176 216 216 176 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NWr),
        e("polyline", {
          points: "40 80 40 40 80 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FWr),
        e("rect", {
          x: "80",
          y: "80",
          width: "96",
          height: "96",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TWr)
      ])) : g("", !0)
    ], 16, iWr));
  }
}), RWr = ["width", "height", "fill", "transform"], UWr = { key: 0 }, qWr = ["stroke"], GWr = ["stroke"], EWr = ["stroke"], OWr = ["stroke"], IWr = ["stroke"], KWr = { key: 1 }, XWr = /* @__PURE__ */ e("circle", {
  cx: "60",
  cy: "76",
  r: "28",
  opacity: "0.2"
}, null, -1), JWr = /* @__PURE__ */ e("circle", {
  cx: "60",
  cy: "180",
  r: "28",
  opacity: "0.2"
}, null, -1), QWr = ["stroke"], YWr = ["stroke"], oNr = ["stroke"], eNr = ["stroke"], tNr = ["stroke"], nNr = { key: 2 }, sNr = /* @__PURE__ */ e("path", { d: "M157.7,113.1a8,8,0,0,1,2.1-11.1l67.7-46.3a8,8,0,0,1,11.1,2.1,7.9,7.9,0,0,1-2.1,11.1l-67.6,46.3a7.8,7.8,0,0,1-4.6,1.4A8,8,0,0,1,157.7,113.1Zm80.9,85.1a7.9,7.9,0,0,1-6.6,3.5,8.2,8.2,0,0,1-4.5-1.4L136,137.7,93.5,166.8A36.4,36.4,0,0,1,96,180a36.1,36.1,0,1,1-11.6-26.4L121.8,128,84.4,102.4A35.5,35.5,0,0,1,60,112,36,36,0,1,1,93.5,89.2l143,97.9A7.9,7.9,0,0,1,238.6,198.2ZM80,180a19.7,19.7,0,0,0-5.9-14.1,19.8,19.8,0,0,0-28.2,0,19.8,19.8,0,0,0,0,28.2,19.9,19.9,0,0,0,28.2,0A19.7,19.7,0,0,0,80,180ZM74.1,90.1a19.8,19.8,0,0,0,0-28.2,19.8,19.8,0,0,0-28.2,0,19.8,19.8,0,0,0,0,28.2A19.9,19.9,0,0,0,74.1,90.1Z" }, null, -1), rNr = [
  sNr
], iNr = { key: 3 }, lNr = ["stroke"], dNr = ["stroke"], kNr = ["stroke"], cNr = ["stroke"], hNr = ["stroke"], uNr = { key: 4 }, aNr = ["stroke"], _Nr = ["stroke"], pNr = ["stroke"], yNr = ["stroke"], $Nr = ["stroke"], wNr = { key: 5 }, fNr = ["stroke"], gNr = ["stroke"], xNr = ["stroke"], jNr = ["stroke"], mNr = ["stroke"], MNr = {
  name: "PhScissors"
}, wol = /* @__PURE__ */ $({
  ...MNr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", UWr, [
        e("circle", {
          cx: "60",
          cy: "76",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qWr),
        e("circle", {
          cx: "60",
          cy: "180",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GWr),
        e("line", {
          x1: "136",
          y1: "128",
          x2: "83.1",
          y2: "164.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, EWr),
        e("line", {
          x1: "232",
          y1: "193.7",
          x2: "83.1",
          y2: "91.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OWr),
        e("line", {
          x1: "232",
          y1: "62.3",
          x2: "171.4",
          y2: "103.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IWr)
      ])) : o(i) === "duotone" ? (s(), r("g", KWr, [
        XWr,
        JWr,
        e("circle", {
          cx: "60",
          cy: "76",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QWr),
        e("circle", {
          cx: "60",
          cy: "180",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YWr),
        e("line", {
          x1: "136",
          y1: "128",
          x2: "83.1",
          y2: "164.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oNr),
        e("line", {
          x1: "232",
          y1: "62.3",
          x2: "164.3",
          y2: "108.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eNr),
        e("line", {
          x1: "232",
          y1: "193.7",
          x2: "83.1",
          y2: "91.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tNr)
      ])) : o(i) === "fill" ? (s(), r("g", nNr, rNr)) : o(i) === "light" ? (s(), r("g", iNr, [
        e("circle", {
          cx: "60",
          cy: "76",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lNr),
        e("circle", {
          cx: "60",
          cy: "180",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dNr),
        e("line", {
          x1: "136",
          y1: "128",
          x2: "83.1",
          y2: "164.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kNr),
        e("line", {
          x1: "232",
          y1: "62.3",
          x2: "164.3",
          y2: "108.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cNr),
        e("line", {
          x1: "232",
          y1: "193.7",
          x2: "83.1",
          y2: "91.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hNr)
      ])) : o(i) === "thin" ? (s(), r("g", uNr, [
        e("circle", {
          cx: "60",
          cy: "76",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aNr),
        e("circle", {
          cx: "60",
          cy: "180",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _Nr),
        e("line", {
          x1: "136",
          y1: "128",
          x2: "83.1",
          y2: "164.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pNr),
        e("line", {
          x1: "232",
          y1: "62.3",
          x2: "164.3",
          y2: "108.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yNr),
        e("line", {
          x1: "232",
          y1: "193.7",
          x2: "83.1",
          y2: "91.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $Nr)
      ])) : o(i) === "regular" ? (s(), r("g", wNr, [
        e("circle", {
          cx: "60",
          cy: "76",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fNr),
        e("circle", {
          cx: "60",
          cy: "180",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gNr),
        e("line", {
          x1: "136",
          y1: "128",
          x2: "83.1",
          y2: "164.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xNr),
        e("line", {
          x1: "232",
          y1: "62.3",
          x2: "164.3",
          y2: "108.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jNr),
        e("line", {
          x1: "232",
          y1: "193.7",
          x2: "83.1",
          y2: "91.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mNr)
      ])) : g("", !0)
    ], 16, RWr));
  }
}), vNr = ["width", "height", "fill", "transform"], SNr = { key: 0 }, HNr = ["stroke"], ANr = ["stroke"], VNr = ["stroke"], zNr = ["stroke"], ZNr = { key: 1 }, CNr = /* @__PURE__ */ e("path", {
  d: "M216,48H40a8,8,0,0,0-8,8V192a16,16,0,0,1,16,16H216a8,8,0,0,0,8-8V56A8,8,0,0,0,216,48Z",
  opacity: "0.2"
}, null, -1), bNr = ["stroke"], LNr = ["stroke"], BNr = ["stroke"], PNr = ["stroke"], WNr = { key: 2 }, NNr = /* @__PURE__ */ e("path", { d: "M32,184a8,8,0,0,0,0,16,8,8,0,0,1,8,8,8,8,0,0,0,16,0A24.1,24.1,0,0,0,32,184Z" }, null, -1), FNr = /* @__PURE__ */ e("path", { d: "M32,152a8,8,0,0,0,0,16,40,40,0,0,1,40,40,8,8,0,0,0,16,0A56,56,0,0,0,32,152Z" }, null, -1), TNr = /* @__PURE__ */ e("path", { d: "M32,120a8,8,0,0,0,0,16,72.1,72.1,0,0,1,72,72,8,8,0,0,0,16,0A88.1,88.1,0,0,0,32,120Z" }, null, -1), DNr = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V96a8,8,0,0,0,8,8A104.2,104.2,0,0,1,136,208a8,8,0,0,0,8,8h72a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Z" }, null, -1), RNr = [
  NNr,
  FNr,
  TNr,
  DNr
], UNr = { key: 3 }, qNr = ["stroke"], GNr = ["stroke"], ENr = ["stroke"], ONr = ["stroke"], INr = { key: 4 }, KNr = ["stroke"], XNr = ["stroke"], JNr = ["stroke"], QNr = ["stroke"], YNr = { key: 5 }, oFr = ["stroke"], eFr = ["stroke"], tFr = ["stroke"], nFr = ["stroke"], sFr = {
  name: "PhScreencast"
}, fol = /* @__PURE__ */ $({
  ...sFr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", SNr, [
        e("path", {
          d: "M36,68V60a8,8,0,0,1,8-8H212a8,8,0,0,1,8,8V196a8,8,0,0,1-8,8H172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HNr),
        e("path", {
          d: "M36,188a16,16,0,0,1,16,16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ANr),
        e("path", {
          d: "M36,148a56,56,0,0,1,56,56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VNr),
        e("path", {
          d: "M36,108a96,96,0,0,1,96,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zNr)
      ])) : o(i) === "duotone" ? (s(), r("g", ZNr, [
        CNr,
        e("path", {
          d: "M32,96V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bNr),
        e("path", {
          d: "M32,192a16,16,0,0,1,16,16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LNr),
        e("path", {
          d: "M32,160a48,48,0,0,1,48,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BNr),
        e("path", {
          d: "M32,128a80,80,0,0,1,80,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PNr)
      ])) : o(i) === "fill" ? (s(), r("g", WNr, RNr)) : o(i) === "light" ? (s(), r("g", UNr, [
        e("path", {
          d: "M32,96V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qNr),
        e("path", {
          d: "M32,192a16,16,0,0,1,16,16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GNr),
        e("path", {
          d: "M32,160a48,48,0,0,1,48,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ENr),
        e("path", {
          d: "M32,128a80,80,0,0,1,80,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ONr)
      ])) : o(i) === "thin" ? (s(), r("g", INr, [
        e("path", {
          d: "M32,96V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KNr),
        e("path", {
          d: "M32,192a16,16,0,0,1,16,16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XNr),
        e("path", {
          d: "M32,160a48,48,0,0,1,48,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, JNr),
        e("path", {
          d: "M32,128a80,80,0,0,1,80,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QNr)
      ])) : o(i) === "regular" ? (s(), r("g", YNr, [
        e("path", {
          d: "M32,96V56a8,8,0,0,1,8-8H216a8,8,0,0,1,8,8V200a8,8,0,0,1-8,8H144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oFr),
        e("path", {
          d: "M32,192a16,16,0,0,1,16,16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eFr),
        e("path", {
          d: "M32,160a48,48,0,0,1,48,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tFr),
        e("path", {
          d: "M32,128a80,80,0,0,1,80,80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nFr)
      ])) : g("", !0)
    ], 16, vNr));
  }
}), rFr = ["width", "height", "fill", "transform"], iFr = { key: 0 }, lFr = ["stroke"], dFr = { key: 1 }, kFr = ["stroke"], cFr = { key: 2 }, hFr = /* @__PURE__ */ e("path", { d: "M246.1,154.9c-1.2-1.5-22.9-27.1-59.8-41.4-2.1-17.8-8.9-34-19.6-46.6C151.7,49.3,130,40,104,40,52.5,40,18.9,86.2,17.5,88.1a8,8,0,0,0,13,9.4C30.8,97,60.8,56,104,56c21.2,0,38.6,7.4,50.5,21.3a68,68,0,0,1,14.7,30.8A134.2,134.2,0,0,0,136,104c-26.1,0-47.9,6.8-63.3,19.7C59.2,135.1,51.4,151,51.4,167.2a47.4,47.4,0,0,0,13.9,34.1c9.6,9.6,23,14.7,38.7,14.7,25.2,0,46.7-10,62.1-28.8,12.2-15,19.6-35.1,20.8-56a146.3,146.3,0,0,1,47,33.9,8,8,0,1,0,12.2-10.2ZM104,200c-25.3,0-36.6-16.4-36.6-32.8,0-22.7,21.5-47.2,68.6-47.2a117.3,117.3,0,0,1,35,5.3v.3C171,162.6,148,200,104,200Z" }, null, -1), uFr = [
  hFr
], aFr = { key: 3 }, _Fr = ["stroke"], pFr = { key: 4 }, yFr = ["stroke"], $Fr = { key: 5 }, wFr = ["stroke"], fFr = {
  name: "PhScribbleLoop"
}, gol = /* @__PURE__ */ $({
  ...fFr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", iFr, [
        e("path", {
          d: "M24,92.8S56,48,104,48c104,0,96,160,0,160-64,0-64-96,32-96,64,0,104,48,104,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lFr)
      ])) : o(i) === "duotone" ? (s(), r("g", dFr, [
        e("path", {
          d: "M24,92.8S56,48,104,48c104,0,96,160,0,160-64,0-64-96,32-96,64,0,104,48,104,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kFr)
      ])) : o(i) === "fill" ? (s(), r("g", cFr, uFr)) : o(i) === "light" ? (s(), r("g", aFr, [
        e("path", {
          d: "M24,92.8S56,48,104,48c104,0,96,160,0,160-64,0-64-96,32-96,64,0,104,48,104,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _Fr)
      ])) : o(i) === "thin" ? (s(), r("g", pFr, [
        e("path", {
          d: "M24,92.8S56,48,104,48c104,0,96,160,0,160-64,0-64-96,32-96,64,0,104,48,104,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yFr)
      ])) : o(i) === "regular" ? (s(), r("g", $Fr, [
        e("path", {
          d: "M24,92.8S56,48,104,48c104,0,96,160,0,160-64,0-64-96,32-96,64,0,104,48,104,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wFr)
      ])) : g("", !0)
    ], 16, rFr));
  }
}), gFr = ["width", "height", "fill", "transform"], xFr = { key: 0 }, jFr = ["stroke"], mFr = ["stroke"], MFr = ["stroke"], vFr = ["stroke"], SFr = { key: 1 }, HFr = /* @__PURE__ */ e("path", {
  d: "M88,216a24,24,0,0,0,17.9-40h112A24,24,0,0,1,200,216Z",
  opacity: "0.2"
}, null, -1), AFr = ["stroke"], VFr = ["stroke"], zFr = ["stroke"], ZFr = ["stroke"], CFr = { key: 2 }, bFr = /* @__PURE__ */ e("path", { d: "M223.8,170.7a7.8,7.8,0,0,0-5.9-2.7H208V64a32.1,32.1,0,0,0-32-32H40A32.1,32.1,0,0,0,8,64a31.5,31.5,0,0,0,8.2,21.3,7.9,7.9,0,0,0,11.2.7,8,8,0,0,0,.7-11.3A16,16,0,1,1,56,64V192a32.1,32.1,0,0,0,32,32H200a32.1,32.1,0,0,0,32-32A31.5,31.5,0,0,0,223.8,170.7ZM104,96h64a8,8,0,0,1,0,16H104a8,8,0,0,1,0-16Zm-8,40a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H104A8,8,0,0,1,96,136Zm104,72H115.7a32.2,32.2,0,0,0,4.3-16,30.8,30.8,0,0,0-1-8h94.9A16.1,16.1,0,0,1,200,208Z" }, null, -1), LFr = [
  bFr
], BFr = { key: 3 }, PFr = ["stroke"], WFr = ["stroke"], NFr = ["stroke"], FFr = ["stroke"], TFr = { key: 4 }, DFr = ["stroke"], RFr = ["stroke"], UFr = ["stroke"], qFr = ["stroke"], GFr = { key: 5 }, EFr = ["stroke"], OFr = ["stroke"], IFr = ["stroke"], KFr = ["stroke"], XFr = {
  name: "PhScroll"
}, xol = /* @__PURE__ */ $({
  ...XFr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xFr, [
        e("path", {
          d: "M200,176V64a23.9,23.9,0,0,0-24-24H40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jFr),
        e("line", {
          x1: "104",
          y1: "100",
          x2: "168",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mFr),
        e("line", {
          x1: "104",
          y1: "140",
          x2: "168",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MFr),
        e("path", {
          d: "M22.1,80A24,24,0,1,1,64,64V192a24,24,0,1,0,41.9-16h112A24,24,0,0,1,200,216H88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vFr)
      ])) : o(i) === "duotone" ? (s(), r("g", SFr, [
        HFr,
        e("path", {
          d: "M200,176V64a23.9,23.9,0,0,0-24-24H40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AFr),
        e("line", {
          x1: "104",
          y1: "104",
          x2: "168",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VFr),
        e("line", {
          x1: "104",
          y1: "136",
          x2: "168",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zFr),
        e("path", {
          d: "M22.1,80A24,24,0,1,1,64,64V192a24,24,0,1,0,41.9-16h112A24,24,0,0,1,200,216H88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZFr)
      ])) : o(i) === "fill" ? (s(), r("g", CFr, LFr)) : o(i) === "light" ? (s(), r("g", BFr, [
        e("path", {
          d: "M200,176V64a23.9,23.9,0,0,0-24-24H40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PFr),
        e("line", {
          x1: "104",
          y1: "104",
          x2: "168",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WFr),
        e("line", {
          x1: "104",
          y1: "136",
          x2: "168",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, NFr),
        e("path", {
          d: "M22.1,80A24,24,0,1,1,64,64V192a24,24,0,1,0,41.9-16h112A24,24,0,0,1,200,216H88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FFr)
      ])) : o(i) === "thin" ? (s(), r("g", TFr, [
        e("path", {
          d: "M200,176V64a23.9,23.9,0,0,0-24-24H40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, DFr),
        e("line", {
          x1: "104",
          y1: "104",
          x2: "168",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RFr),
        e("line", {
          x1: "104",
          y1: "136",
          x2: "168",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, UFr),
        e("path", {
          d: "M22.1,80A24,24,0,1,1,64,64V192a24,24,0,1,0,41.9-16h112A24,24,0,0,1,200,216H88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qFr)
      ])) : o(i) === "regular" ? (s(), r("g", GFr, [
        e("path", {
          d: "M200,176V64a23.9,23.9,0,0,0-24-24H40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EFr),
        e("line", {
          x1: "104",
          y1: "104",
          x2: "168",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OFr),
        e("line", {
          x1: "104",
          y1: "136",
          x2: "168",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IFr),
        e("path", {
          d: "M22.1,80A24,24,0,1,1,64,64V192a24,24,0,1,0,41.9-16h112A24,24,0,0,1,200,216H88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KFr)
      ])) : g("", !0)
    ], 16, gFr));
  }
}), JFr = ["width", "height", "fill", "transform"], QFr = { key: 0 }, YFr = ["stroke"], oTr = ["stroke"], eTr = ["stroke"], tTr = ["stroke"], nTr = ["stroke"], sTr = ["stroke"], rTr = ["stroke"], iTr = ["stroke"], lTr = { key: 1 }, dTr = ["stroke"], kTr = ["stroke"], cTr = ["stroke"], hTr = ["stroke"], uTr = ["stroke"], aTr = ["stroke"], _Tr = ["stroke"], pTr = ["stroke"], yTr = { key: 2 }, $Tr = /* @__PURE__ */ e("path", { d: "M152,40a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h32A8,8,0,0,1,152,40Zm-8,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104Zm0,72a8,8,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V184A8,8,0,0,0,216,176ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM72,32H48A16,16,0,0,0,32,48V72a8,8,0,0,0,16,0V48H72a8,8,0,0,0,0-16Z" }, null, -1), wTr = [
  $Tr
], fTr = { key: 3 }, gTr = ["stroke"], xTr = ["stroke"], jTr = ["stroke"], mTr = ["stroke"], MTr = ["stroke"], vTr = ["stroke"], STr = ["stroke"], HTr = ["stroke"], ATr = { key: 4 }, VTr = ["stroke"], zTr = ["stroke"], ZTr = ["stroke"], CTr = ["stroke"], bTr = ["stroke"], LTr = ["stroke"], BTr = ["stroke"], PTr = ["stroke"], WTr = { key: 5 }, NTr = ["stroke"], FTr = ["stroke"], TTr = ["stroke"], DTr = ["stroke"], RTr = ["stroke"], UTr = ["stroke"], qTr = ["stroke"], GTr = ["stroke"], ETr = {
  name: "PhSelection"
}, jol = /* @__PURE__ */ $({
  ...ETr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", QFr, [
        e("line", {
          x1: "144",
          y1: "40",
          x2: "112",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, YFr),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oTr),
        e("path", {
          d: "M184,40h24a8,8,0,0,1,8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eTr),
        e("line", {
          x1: "216",
          y1: "144",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tTr),
        e("path", {
          d: "M184,216h24a8,8,0,0,0,8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nTr),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sTr),
        e("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rTr),
        e("path", {
          d: "M72,40H48a8,8,0,0,0-8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iTr)
      ])) : o(i) === "duotone" ? (s(), r("g", lTr, [
        e("line", {
          x1: "144",
          y1: "40",
          x2: "112",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dTr),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kTr),
        e("path", {
          d: "M184,40h24a8,8,0,0,1,8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cTr),
        e("line", {
          x1: "216",
          y1: "144",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hTr),
        e("path", {
          d: "M184,216h24a8,8,0,0,0,8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uTr),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aTr),
        e("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Tr),
        e("path", {
          d: "M72,40H48a8,8,0,0,0-8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pTr)
      ])) : o(i) === "fill" ? (s(), r("g", yTr, wTr)) : o(i) === "light" ? (s(), r("g", fTr, [
        e("line", {
          x1: "144",
          y1: "40",
          x2: "112",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gTr),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xTr),
        e("path", {
          d: "M184,40h24a8,8,0,0,1,8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jTr),
        e("line", {
          x1: "216",
          y1: "144",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mTr),
        e("path", {
          d: "M184,216h24a8,8,0,0,0,8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, MTr),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vTr),
        e("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, STr),
        e("path", {
          d: "M72,40H48a8,8,0,0,0-8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HTr)
      ])) : o(i) === "thin" ? (s(), r("g", ATr, [
        e("line", {
          x1: "144",
          y1: "40",
          x2: "112",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VTr),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zTr),
        e("path", {
          d: "M184,40h24a8,8,0,0,1,8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZTr),
        e("line", {
          x1: "216",
          y1: "144",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CTr),
        e("path", {
          d: "M184,216h24a8,8,0,0,0,8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bTr),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LTr),
        e("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, BTr),
        e("path", {
          d: "M72,40H48a8,8,0,0,0-8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PTr)
      ])) : o(i) === "regular" ? (s(), r("g", WTr, [
        e("line", {
          x1: "144",
          y1: "40",
          x2: "112",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NTr),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FTr),
        e("path", {
          d: "M184,40h24a8,8,0,0,1,8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TTr),
        e("line", {
          x1: "216",
          y1: "144",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DTr),
        e("path", {
          d: "M184,216h24a8,8,0,0,0,8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RTr),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UTr),
        e("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qTr),
        e("path", {
          d: "M72,40H48a8,8,0,0,0-8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GTr)
      ])) : g("", !0)
    ], 16, JFr));
  }
}), OTr = ["width", "height", "fill", "transform"], ITr = { key: 0 }, KTr = ["stroke"], XTr = ["stroke"], JTr = ["stroke"], QTr = ["stroke"], YTr = ["stroke"], oDr = ["stroke"], eDr = ["stroke"], tDr = ["stroke"], nDr = ["stroke"], sDr = { key: 1 }, rDr = /* @__PURE__ */ e("rect", {
  x: "80",
  y: "80",
  width: "96",
  height: "96",
  opacity: "0.2"
}, null, -1), iDr = ["stroke"], lDr = ["stroke"], dDr = ["stroke"], kDr = ["stroke"], cDr = ["stroke"], hDr = ["stroke"], uDr = ["stroke"], aDr = ["stroke"], _Dr = ["stroke"], pDr = { key: 2 }, yDr = /* @__PURE__ */ e("path", { d: "M104,40a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104Zm0,72a8,8,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V184A8,8,0,0,0,216,176ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM40,80a8,8,0,0,0,8-8V48H72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,48V72A8,8,0,0,0,40,80ZM176,184H80a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8v96A8,8,0,0,1,176,184Z" }, null, -1), $Dr = [
  yDr
], wDr = { key: 3 }, fDr = ["stroke"], gDr = ["stroke"], xDr = ["stroke"], jDr = ["stroke"], mDr = ["stroke"], MDr = ["stroke"], vDr = ["stroke"], SDr = ["stroke"], HDr = ["stroke"], ADr = { key: 4 }, VDr = ["stroke"], zDr = ["stroke"], ZDr = ["stroke"], CDr = ["stroke"], bDr = ["stroke"], LDr = ["stroke"], BDr = ["stroke"], PDr = ["stroke"], WDr = ["stroke"], NDr = { key: 5 }, FDr = ["stroke"], TDr = ["stroke"], DDr = ["stroke"], RDr = ["stroke"], UDr = ["stroke"], qDr = ["stroke"], GDr = ["stroke"], EDr = ["stroke"], ODr = ["stroke"], IDr = {
  name: "PhSelectionAll"
}, mol = /* @__PURE__ */ $({
  ...IDr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ITr, [
        e("line", {
          x1: "144",
          y1: "40",
          x2: "112",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KTr),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XTr),
        e("path", {
          d: "M184,40h24a8,8,0,0,1,8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, JTr),
        e("line", {
          x1: "216",
          y1: "144",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, QTr),
        e("path", {
          d: "M184,216h24a8,8,0,0,0,8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, YTr),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oDr),
        e("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eDr),
        e("path", {
          d: "M72,40H48a8,8,0,0,0-8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tDr),
        e("rect", {
          x: "80",
          y: "80",
          width: "96",
          height: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nDr)
      ])) : o(i) === "duotone" ? (s(), r("g", sDr, [
        rDr,
        e("line", {
          x1: "144",
          y1: "40",
          x2: "112",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iDr),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lDr),
        e("path", {
          d: "M184,40h24a8,8,0,0,1,8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dDr),
        e("line", {
          x1: "216",
          y1: "144",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kDr),
        e("path", {
          d: "M184,216h24a8,8,0,0,0,8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cDr),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hDr),
        e("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uDr),
        e("path", {
          d: "M72,40H48a8,8,0,0,0-8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aDr),
        e("rect", {
          x: "80",
          y: "80",
          width: "96",
          height: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Dr)
      ])) : o(i) === "fill" ? (s(), r("g", pDr, $Dr)) : o(i) === "light" ? (s(), r("g", wDr, [
        e("line", {
          x1: "144",
          y1: "40",
          x2: "112",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fDr),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gDr),
        e("path", {
          d: "M184,40h24a8,8,0,0,1,8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xDr),
        e("line", {
          x1: "216",
          y1: "144",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jDr),
        e("path", {
          d: "M184,216h24a8,8,0,0,0,8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mDr),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, MDr),
        e("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vDr),
        e("path", {
          d: "M72,40H48a8,8,0,0,0-8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, SDr),
        e("rect", {
          x: "80",
          y: "80",
          width: "96",
          height: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HDr)
      ])) : o(i) === "thin" ? (s(), r("g", ADr, [
        e("line", {
          x1: "144",
          y1: "40",
          x2: "112",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VDr),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zDr),
        e("path", {
          d: "M184,40h24a8,8,0,0,1,8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZDr),
        e("line", {
          x1: "216",
          y1: "144",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CDr),
        e("path", {
          d: "M184,216h24a8,8,0,0,0,8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bDr),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LDr),
        e("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, BDr),
        e("path", {
          d: "M72,40H48a8,8,0,0,0-8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PDr),
        e("rect", {
          x: "80",
          y: "80",
          width: "96",
          height: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WDr)
      ])) : o(i) === "regular" ? (s(), r("g", NDr, [
        e("line", {
          x1: "144",
          y1: "40",
          x2: "112",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FDr),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TDr),
        e("path", {
          d: "M184,40h24a8,8,0,0,1,8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DDr),
        e("line", {
          x1: "216",
          y1: "144",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RDr),
        e("path", {
          d: "M184,216h24a8,8,0,0,0,8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UDr),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qDr),
        e("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GDr),
        e("path", {
          d: "M72,40H48a8,8,0,0,0-8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EDr),
        e("rect", {
          x: "80",
          y: "80",
          width: "96",
          height: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ODr)
      ])) : g("", !0)
    ], 16, OTr));
  }
}), KDr = ["width", "height", "fill", "transform"], XDr = { key: 0 }, JDr = ["stroke"], QDr = ["stroke"], YDr = ["stroke"], oRr = ["stroke"], eRr = ["stroke"], tRr = ["stroke"], nRr = { key: 1 }, sRr = ["stroke"], rRr = ["stroke"], iRr = ["stroke"], lRr = ["stroke"], dRr = ["stroke"], kRr = ["stroke"], cRr = /* @__PURE__ */ e("path", {
  d: "M208,40H96a8,8,0,0,0-8,8V88h72a8,8,0,0,1,8,8v72h40a8,8,0,0,0,8-8V48A8,8,0,0,0,208,40Z",
  opacity: "0.2"
}, null, -1), hRr = { key: 2 }, uRr = /* @__PURE__ */ e("path", { d: "M80,56V48A16,16,0,0,1,96,32h8a8,8,0,0,1,0,16H96v8a8,8,0,0,1-16,0Zm64-8h16a8,8,0,0,0,0-16H144a8,8,0,0,0,0,16Zm64-16h-8a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,56a8,8,0,0,0-8,8v16a8,8,0,0,0,16,0V96A8,8,0,0,0,216,88Zm-40,8V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V96A16,16,0,0,1,48,80H160A16,16,0,0,1,176,96Zm-16,0H48V208H160Zm56,48a8,8,0,0,0-8,8v8h-8a8,8,0,0,0,0,16h8a16,16,0,0,0,16-16v-8A8,8,0,0,0,216,144Z" }, null, -1), aRr = [
  uRr
], _Rr = { key: 3 }, pRr = ["stroke"], yRr = ["stroke"], $Rr = ["stroke"], wRr = ["stroke"], fRr = ["stroke"], gRr = ["stroke"], xRr = { key: 4 }, jRr = ["stroke"], mRr = ["stroke"], MRr = ["stroke"], vRr = ["stroke"], SRr = ["stroke"], HRr = ["stroke"], ARr = { key: 5 }, VRr = ["stroke"], zRr = ["stroke"], ZRr = ["stroke"], CRr = ["stroke"], bRr = ["stroke"], LRr = ["stroke"], BRr = {
  name: "PhSelectionBackground"
}, Mol = /* @__PURE__ */ $({
  ...BRr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", XDr, [
        e("rect", {
          x: "40",
          y: "92",
          width: "124",
          height: "124",
          rx: "7.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, JDr),
        e("line", {
          x1: "160",
          y1: "40",
          x2: "144",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, QDr),
        e("path", {
          d: "M200,40h8a8,8,0,0,1,8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, YDr),
        e("line", {
          x1: "216",
          y1: "112",
          x2: "216",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oRr),
        e("path", {
          d: "M200,168h8a8,8,0,0,0,8-8v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eRr),
        e("path", {
          d: "M104,40H96a8,8,0,0,0-8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tRr)
      ])) : o(i) === "duotone" ? (s(), r("g", nRr, [
        e("rect", {
          x: "40",
          y: "88",
          width: "128",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sRr),
        e("line", {
          x1: "160",
          y1: "40",
          x2: "144",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rRr),
        e("path", {
          d: "M200,40h8a8,8,0,0,1,8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iRr),
        e("line", {
          x1: "216",
          y1: "112",
          x2: "216",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lRr),
        e("path", {
          d: "M200,168h8a8,8,0,0,0,8-8v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dRr),
        e("path", {
          d: "M104,40H96a8,8,0,0,0-8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kRr),
        cRr
      ])) : o(i) === "fill" ? (s(), r("g", hRr, aRr)) : o(i) === "light" ? (s(), r("g", _Rr, [
        e("rect", {
          x: "40",
          y: "88",
          width: "128",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pRr),
        e("line", {
          x1: "160",
          y1: "40",
          x2: "144",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yRr),
        e("path", {
          d: "M200,40h8a8,8,0,0,1,8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $Rr),
        e("line", {
          x1: "216",
          y1: "112",
          x2: "216",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wRr),
        e("path", {
          d: "M200,168h8a8,8,0,0,0,8-8v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fRr),
        e("path", {
          d: "M104,40H96a8,8,0,0,0-8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gRr)
      ])) : o(i) === "thin" ? (s(), r("g", xRr, [
        e("rect", {
          x: "40",
          y: "88",
          width: "128",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jRr),
        e("line", {
          x1: "160",
          y1: "40",
          x2: "144",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mRr),
        e("path", {
          d: "M200,40h8a8,8,0,0,1,8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MRr),
        e("line", {
          x1: "216",
          y1: "112",
          x2: "216",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vRr),
        e("path", {
          d: "M200,168h8a8,8,0,0,0,8-8v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SRr),
        e("path", {
          d: "M104,40H96a8,8,0,0,0-8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HRr)
      ])) : o(i) === "regular" ? (s(), r("g", ARr, [
        e("rect", {
          x: "40",
          y: "88",
          width: "128",
          height: "128",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VRr),
        e("line", {
          x1: "160",
          y1: "40",
          x2: "144",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zRr),
        e("path", {
          d: "M200,40h8a8,8,0,0,1,8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZRr),
        e("line", {
          x1: "216",
          y1: "112",
          x2: "216",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CRr),
        e("path", {
          d: "M200,168h8a8,8,0,0,0,8-8v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bRr),
        e("path", {
          d: "M104,40H96a8,8,0,0,0-8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LRr)
      ])) : g("", !0)
    ], 16, KDr));
  }
}), PRr = ["width", "height", "fill", "transform"], WRr = { key: 0 }, NRr = ["stroke"], FRr = ["stroke"], TRr = ["stroke"], DRr = ["stroke"], RRr = ["stroke"], URr = ["stroke"], qRr = ["stroke"], GRr = ["stroke"], ERr = ["stroke"], ORr = { key: 1 }, IRr = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "88",
  width: "128",
  height: "128",
  rx: "8",
  opacity: "0.2"
}, null, -1), KRr = ["stroke"], XRr = ["stroke"], JRr = ["stroke"], QRr = ["stroke"], YRr = ["stroke"], oUr = ["stroke"], eUr = ["stroke"], tUr = ["stroke"], nUr = ["stroke"], sUr = { key: 2 }, rUr = /* @__PURE__ */ e("path", { d: "M64,216a8,8,0,0,1-8,8H48a16,16,0,0,1-16-16v-8a8,8,0,0,1,16,0v8h8A8,8,0,0,1,64,216Zm48-8H96a8,8,0,0,0,0,16h16a8,8,0,0,0,0-16ZM40,168a8,8,0,0,0,8-8V144a8,8,0,0,0-16,0v16A8,8,0,0,0,40,168Zm128,24a8,8,0,0,0-8,8v8h-8a8,8,0,0,0,0,16h8a16,16,0,0,0,16-16v-8A8,8,0,0,0,168,192Zm0-80a8,8,0,0,0,8-8V96a16,16,0,0,0-16-16h-8a8,8,0,0,0,0,16h8v8A8,8,0,0,0,168,112ZM56,80H48A16,16,0,0,0,32,96v8a8,8,0,0,0,16,0V96h8a8,8,0,0,0,0-16ZM208,32H96A16,16,0,0,0,80,48V88a8,8,0,0,0,8,8h24a8,8,0,0,0,0-16H96V48H208V160H176V144a8,8,0,0,0-16,0v24a8,8,0,0,0,8,8h40a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Z" }, null, -1), iUr = [
  rUr
], lUr = { key: 3 }, dUr = ["stroke"], kUr = ["stroke"], cUr = ["stroke"], hUr = ["stroke"], uUr = ["stroke"], aUr = ["stroke"], _Ur = ["stroke"], pUr = ["stroke"], yUr = ["stroke"], $Ur = { key: 4 }, wUr = ["stroke"], fUr = ["stroke"], gUr = ["stroke"], xUr = ["stroke"], jUr = ["stroke"], mUr = ["stroke"], MUr = ["stroke"], vUr = ["stroke"], SUr = ["stroke"], HUr = { key: 5 }, AUr = ["stroke"], VUr = ["stroke"], zUr = ["stroke"], ZUr = ["stroke"], CUr = ["stroke"], bUr = ["stroke"], LUr = ["stroke"], BUr = ["stroke"], PUr = ["stroke"], WUr = {
  name: "PhSelectionForeground"
}, vol = /* @__PURE__ */ $({
  ...WUr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", WRr, [
        e("path", {
          d: "M56,216H48a8,8,0,0,1-8-8v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NRr),
        e("line", {
          x1: "112",
          y1: "88",
          x2: "92",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FRr),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TRr),
        e("line", {
          x1: "168",
          y1: "164",
          x2: "168",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DRr),
        e("line", {
          x1: "40",
          y1: "160",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RRr),
        e("path", {
          d: "M152,216h8a8,8,0,0,0,8-8v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, URr),
        e("path", {
          d: "M152,88h8a8,8,0,0,1,8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qRr),
        e("path", {
          d: "M56,88H48a8,8,0,0,0-8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GRr),
        e("path", {
          d: "M169.5,164h38.7a7.8,7.8,0,0,0,7.8-7.8V47.8a7.8,7.8,0,0,0-7.8-7.8H99.8A7.8,7.8,0,0,0,92,47.8V86.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ERr)
      ])) : o(i) === "duotone" ? (s(), r("g", ORr, [
        IRr,
        e("path", {
          d: "M56,216H48a8,8,0,0,1-8-8v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KRr),
        e("line", {
          x1: "112",
          y1: "88",
          x2: "88",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XRr),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JRr),
        e("line", {
          x1: "168",
          y1: "168",
          x2: "168",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QRr),
        e("line", {
          x1: "40",
          y1: "160",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YRr),
        e("path", {
          d: "M152,216h8a8,8,0,0,0,8-8v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oUr),
        e("path", {
          d: "M152,88h8a8,8,0,0,1,8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eUr),
        e("path", {
          d: "M56,88H48a8,8,0,0,0-8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tUr),
        e("path", {
          d: "M168,168h40a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nUr)
      ])) : o(i) === "fill" ? (s(), r("g", sUr, iUr)) : o(i) === "light" ? (s(), r("g", lUr, [
        e("path", {
          d: "M56,216H48a8,8,0,0,1-8-8v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dUr),
        e("line", {
          x1: "112",
          y1: "88",
          x2: "88",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kUr),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cUr),
        e("line", {
          x1: "168",
          y1: "168",
          x2: "168",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hUr),
        e("line", {
          x1: "40",
          y1: "160",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uUr),
        e("path", {
          d: "M152,216h8a8,8,0,0,0,8-8v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aUr),
        e("path", {
          d: "M152,88h8a8,8,0,0,1,8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _Ur),
        e("path", {
          d: "M56,88H48a8,8,0,0,0-8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pUr),
        e("path", {
          d: "M168,168h40a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yUr)
      ])) : o(i) === "thin" ? (s(), r("g", $Ur, [
        e("path", {
          d: "M56,216H48a8,8,0,0,1-8-8v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wUr),
        e("line", {
          x1: "112",
          y1: "88",
          x2: "88",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fUr),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gUr),
        e("line", {
          x1: "168",
          y1: "168",
          x2: "168",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xUr),
        e("line", {
          x1: "40",
          y1: "160",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jUr),
        e("path", {
          d: "M152,216h8a8,8,0,0,0,8-8v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mUr),
        e("path", {
          d: "M152,88h8a8,8,0,0,1,8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MUr),
        e("path", {
          d: "M56,88H48a8,8,0,0,0-8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vUr),
        e("path", {
          d: "M168,168h40a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SUr)
      ])) : o(i) === "regular" ? (s(), r("g", HUr, [
        e("path", {
          d: "M56,216H48a8,8,0,0,1-8-8v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AUr),
        e("line", {
          x1: "112",
          y1: "88",
          x2: "88",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VUr),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "96",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zUr),
        e("line", {
          x1: "168",
          y1: "168",
          x2: "168",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZUr),
        e("line", {
          x1: "40",
          y1: "160",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CUr),
        e("path", {
          d: "M152,216h8a8,8,0,0,0,8-8v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bUr),
        e("path", {
          d: "M152,88h8a8,8,0,0,1,8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LUr),
        e("path", {
          d: "M56,88H48a8,8,0,0,0-8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BUr),
        e("path", {
          d: "M168,168h40a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PUr)
      ])) : g("", !0)
    ], 16, PRr));
  }
}), NUr = ["width", "height", "fill", "transform"], FUr = { key: 0 }, TUr = ["stroke"], DUr = ["stroke"], RUr = ["stroke"], UUr = ["stroke"], qUr = ["stroke"], GUr = { key: 1 }, EUr = /* @__PURE__ */ e("path", {
  d: "M42.3,42.3,213.7,213.7h0A8.4,8.4,0,0,0,216,208V48a8,8,0,0,0-8-8H48a8.4,8.4,0,0,0-5.7,2.3Z",
  opacity: "0.2"
}, null, -1), OUr = ["stroke"], IUr = ["stroke"], KUr = ["stroke"], XUr = ["stroke"], JUr = ["stroke"], QUr = { key: 2 }, YUr = /* @__PURE__ */ e("path", { d: "M152,216a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h32A8,8,0,0,1,152,216ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM224,48a16,16,0,0,0-16-16H48a16.4,16.4,0,0,0-10.7,4.1l-.6.6-.6.6A16.4,16.4,0,0,0,32,48V72a8,8,0,0,0,16,0V59.3L196.7,208H184a8,8,0,0,0,0,16h24a16.4,16.4,0,0,0,10.7-4.1l.6-.6.6-.6A16.4,16.4,0,0,0,224,208Z" }, null, -1), oqr = [
  YUr
], eqr = { key: 3 }, tqr = ["stroke"], nqr = ["stroke"], sqr = ["stroke"], rqr = ["stroke"], iqr = ["stroke"], lqr = { key: 4 }, dqr = ["stroke"], kqr = ["stroke"], cqr = ["stroke"], hqr = ["stroke"], uqr = ["stroke"], aqr = { key: 5 }, _qr = ["stroke"], pqr = ["stroke"], yqr = ["stroke"], $qr = ["stroke"], wqr = ["stroke"], fqr = {
  name: "PhSelectionInverse"
}, Sol = /* @__PURE__ */ $({
  ...fqr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", FUr, [
        e("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TUr),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DUr),
        e("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RUr),
        e("path", {
          d: "M184,216h24a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, UUr),
        e("line", {
          x1: "42.3",
          y1: "42.3",
          x2: "213.7",
          y2: "213.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qUr)
      ])) : o(i) === "duotone" ? (s(), r("g", GUr, [
        EUr,
        e("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OUr),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IUr),
        e("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KUr),
        e("path", {
          d: "M184,216h24a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XUr),
        e("line", {
          x1: "42.3",
          y1: "42.3",
          x2: "213.7",
          y2: "213.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JUr)
      ])) : o(i) === "fill" ? (s(), r("g", QUr, oqr)) : o(i) === "light" ? (s(), r("g", eqr, [
        e("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tqr),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nqr),
        e("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sqr),
        e("path", {
          d: "M184,216h24a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rqr),
        e("line", {
          x1: "42.3",
          y1: "42.3",
          x2: "213.7",
          y2: "213.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iqr)
      ])) : o(i) === "thin" ? (s(), r("g", lqr, [
        e("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dqr),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kqr),
        e("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cqr),
        e("path", {
          d: "M184,216h24a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hqr),
        e("line", {
          x1: "42.3",
          y1: "42.3",
          x2: "213.7",
          y2: "213.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uqr)
      ])) : o(i) === "regular" ? (s(), r("g", aqr, [
        e("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _qr),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pqr),
        e("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yqr),
        e("path", {
          d: "M184,216h24a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $qr),
        e("line", {
          x1: "42.3",
          y1: "42.3",
          x2: "213.7",
          y2: "213.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wqr)
      ])) : g("", !0)
    ], 16, NUr));
  }
}), gqr = ["width", "height", "fill", "transform"], xqr = { key: 0 }, jqr = ["stroke"], mqr = ["stroke"], Mqr = ["stroke"], vqr = ["stroke"], Sqr = ["stroke"], Hqr = ["stroke"], Aqr = ["stroke"], Vqr = ["stroke"], zqr = ["stroke"], Zqr = { key: 1 }, Cqr = ["stroke"], bqr = ["stroke"], Lqr = ["stroke"], Bqr = ["stroke"], Pqr = ["stroke"], Wqr = ["stroke"], Nqr = ["stroke"], Fqr = ["stroke"], Tqr = ["stroke"], Dqr = { key: 2 }, Rqr = /* @__PURE__ */ e("path", { d: "M148,48a8,8,0,0,1-8,8H116a8,8,0,0,1,0-16h24A8,8,0,0,1,148,48Zm-8,152H116a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16ZM180,56h20V76a8,8,0,0,0,16,0V56a16,16,0,0,0-16-16H180a8,8,0,0,0,0,16Zm28,52a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V116A8,8,0,0,0,208,108ZM48,148a8,8,0,0,0,8-8V116a8,8,0,0,0-16,0v24A8,8,0,0,0,48,148Zm28,52H56V180a8,8,0,0,0-16,0v20a16,16,0,0,0,16,16H76a8,8,0,0,0,0-16ZM76,40H56A16,16,0,0,0,40,56V76a8,8,0,0,0,16,0V56H76a8,8,0,0,0,0-16ZM236,200H216V180a8,8,0,0,0-16,0v20H180a8,8,0,0,0,0,16h20v20a8,8,0,0,0,16,0V216h20a8,8,0,0,0,0-16Z" }, null, -1), Uqr = [
  Rqr
], qqr = { key: 3 }, Gqr = ["stroke"], Eqr = ["stroke"], Oqr = ["stroke"], Iqr = ["stroke"], Kqr = ["stroke"], Xqr = ["stroke"], Jqr = ["stroke"], Qqr = ["stroke"], Yqr = ["stroke"], oGr = { key: 4 }, eGr = ["stroke"], tGr = ["stroke"], nGr = ["stroke"], sGr = ["stroke"], rGr = ["stroke"], iGr = ["stroke"], lGr = ["stroke"], dGr = ["stroke"], kGr = ["stroke"], cGr = { key: 5 }, hGr = ["stroke"], uGr = ["stroke"], aGr = ["stroke"], _Gr = ["stroke"], pGr = ["stroke"], yGr = ["stroke"], $Gr = ["stroke"], wGr = ["stroke"], fGr = ["stroke"], gGr = {
  name: "PhSelectionPlus"
}, Hol = /* @__PURE__ */ $({
  ...gGr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xqr, [
        e("line", {
          x1: "140",
          y1: "48",
          x2: "116",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jqr),
        e("line", {
          x1: "116",
          y1: "208",
          x2: "140",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mqr),
        e("path", {
          d: "M180,48h20a8,8,0,0,1,8,8V76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mqr),
        e("line", {
          x1: "208",
          y1: "140",
          x2: "208",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vqr),
        e("line", {
          x1: "48",
          y1: "116",
          x2: "48",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Sqr),
        e("path", {
          d: "M76,208H56a8,8,0,0,1-8-8V180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hqr),
        e("path", {
          d: "M76,48H56a8,8,0,0,0-8,8V76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Aqr),
        e("line", {
          x1: "208",
          y1: "180",
          x2: "208",
          y2: "236",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vqr),
        e("line", {
          x1: "236",
          y1: "208",
          x2: "180",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zqr)
      ])) : o(i) === "duotone" ? (s(), r("g", Zqr, [
        e("line", {
          x1: "140",
          y1: "48",
          x2: "116",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cqr),
        e("line", {
          x1: "116",
          y1: "208",
          x2: "140",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bqr),
        e("path", {
          d: "M180,48h20a8,8,0,0,1,8,8V76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lqr),
        e("line", {
          x1: "208",
          y1: "140",
          x2: "208",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bqr),
        e("line", {
          x1: "48",
          y1: "116",
          x2: "48",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pqr),
        e("path", {
          d: "M76,208H56a8,8,0,0,1-8-8V180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wqr),
        e("path", {
          d: "M76,48H56a8,8,0,0,0-8,8V76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nqr),
        e("line", {
          x1: "208",
          y1: "180",
          x2: "208",
          y2: "236",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fqr),
        e("line", {
          x1: "236",
          y1: "208",
          x2: "180",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tqr)
      ])) : o(i) === "fill" ? (s(), r("g", Dqr, Uqr)) : o(i) === "light" ? (s(), r("g", qqr, [
        e("line", {
          x1: "140",
          y1: "48",
          x2: "116",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gqr),
        e("line", {
          x1: "116",
          y1: "208",
          x2: "140",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Eqr),
        e("path", {
          d: "M180,48h20a8,8,0,0,1,8,8V76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Oqr),
        e("line", {
          x1: "208",
          y1: "140",
          x2: "208",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Iqr),
        e("line", {
          x1: "48",
          y1: "116",
          x2: "48",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kqr),
        e("path", {
          d: "M76,208H56a8,8,0,0,1-8-8V180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xqr),
        e("path", {
          d: "M76,48H56a8,8,0,0,0-8,8V76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jqr),
        e("line", {
          x1: "208",
          y1: "180",
          x2: "208",
          y2: "236",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qqr),
        e("line", {
          x1: "236",
          y1: "208",
          x2: "180",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Yqr)
      ])) : o(i) === "thin" ? (s(), r("g", oGr, [
        e("line", {
          x1: "140",
          y1: "48",
          x2: "116",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eGr),
        e("line", {
          x1: "116",
          y1: "208",
          x2: "140",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tGr),
        e("path", {
          d: "M180,48h20a8,8,0,0,1,8,8V76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nGr),
        e("line", {
          x1: "208",
          y1: "140",
          x2: "208",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sGr),
        e("line", {
          x1: "48",
          y1: "116",
          x2: "48",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rGr),
        e("path", {
          d: "M76,208H56a8,8,0,0,1-8-8V180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iGr),
        e("path", {
          d: "M76,48H56a8,8,0,0,0-8,8V76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lGr),
        e("line", {
          x1: "208",
          y1: "180",
          x2: "208",
          y2: "236",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dGr),
        e("line", {
          x1: "236",
          y1: "208",
          x2: "180",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kGr)
      ])) : o(i) === "regular" ? (s(), r("g", cGr, [
        e("line", {
          x1: "140",
          y1: "48",
          x2: "116",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hGr),
        e("line", {
          x1: "116",
          y1: "208",
          x2: "140",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uGr),
        e("path", {
          d: "M180,48h20a8,8,0,0,1,8,8V76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aGr),
        e("line", {
          x1: "208",
          y1: "140",
          x2: "208",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Gr),
        e("line", {
          x1: "48",
          y1: "116",
          x2: "48",
          y2: "140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pGr),
        e("path", {
          d: "M76,208H56a8,8,0,0,1-8-8V180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yGr),
        e("path", {
          d: "M76,48H56a8,8,0,0,0-8,8V76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Gr),
        e("line", {
          x1: "208",
          y1: "180",
          x2: "208",
          y2: "236",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wGr),
        e("line", {
          x1: "236",
          y1: "208",
          x2: "180",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fGr)
      ])) : g("", !0)
    ], 16, gqr));
  }
}), xGr = ["width", "height", "fill", "transform"], jGr = { key: 0 }, mGr = ["stroke"], MGr = ["stroke"], vGr = ["stroke"], SGr = ["stroke"], HGr = ["stroke"], AGr = ["stroke"], VGr = ["stroke"], zGr = { key: 1 }, ZGr = ["stroke"], CGr = ["stroke"], bGr = ["stroke"], LGr = ["stroke"], BGr = ["stroke"], PGr = ["stroke"], WGr = ["stroke"], NGr = { key: 2 }, FGr = /* @__PURE__ */ e("path", { d: "M104,40a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM53.9,34.6A8,8,0,0,0,42.1,45.4l160,176A8,8,0,0,0,208,224a8.2,8.2,0,0,0,5.4-2.1,7.9,7.9,0,0,0,.5-11.3Z" }, null, -1), TGr = [
  FGr
], DGr = { key: 3 }, RGr = ["stroke"], UGr = ["stroke"], qGr = ["stroke"], GGr = ["stroke"], EGr = ["stroke"], OGr = ["stroke"], IGr = ["stroke"], KGr = { key: 4 }, XGr = ["stroke"], JGr = ["stroke"], QGr = ["stroke"], YGr = ["stroke"], oEr = ["stroke"], eEr = ["stroke"], tEr = ["stroke"], nEr = { key: 5 }, sEr = ["stroke"], rEr = ["stroke"], iEr = ["stroke"], lEr = ["stroke"], dEr = ["stroke"], kEr = ["stroke"], cEr = ["stroke"], hEr = {
  name: "PhSelectionSlash"
}, Aol = /* @__PURE__ */ $({
  ...hEr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", jGr, [
        e("line", {
          x1: "144",
          y1: "40",
          x2: "112",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mGr),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MGr),
        e("path", {
          d: "M184,40h24a8,8,0,0,1,8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vGr),
        e("line", {
          x1: "216",
          y1: "144",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SGr),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HGr),
        e("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, AGr),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VGr)
      ])) : o(i) === "duotone" ? (s(), r("g", zGr, [
        e("line", {
          x1: "144",
          y1: "40",
          x2: "112",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZGr),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CGr),
        e("path", {
          d: "M184,40h24a8,8,0,0,1,8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bGr),
        e("line", {
          x1: "216",
          y1: "144",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LGr),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BGr),
        e("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PGr),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WGr)
      ])) : o(i) === "fill" ? (s(), r("g", NGr, TGr)) : o(i) === "light" ? (s(), r("g", DGr, [
        e("line", {
          x1: "144",
          y1: "40",
          x2: "112",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RGr),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UGr),
        e("path", {
          d: "M184,40h24a8,8,0,0,1,8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qGr),
        e("line", {
          x1: "216",
          y1: "144",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GGr),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, EGr),
        e("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OGr),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IGr)
      ])) : o(i) === "thin" ? (s(), r("g", KGr, [
        e("line", {
          x1: "144",
          y1: "40",
          x2: "112",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XGr),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, JGr),
        e("path", {
          d: "M184,40h24a8,8,0,0,1,8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QGr),
        e("line", {
          x1: "216",
          y1: "144",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YGr),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oEr),
        e("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eEr),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tEr)
      ])) : o(i) === "regular" ? (s(), r("g", nEr, [
        e("line", {
          x1: "144",
          y1: "40",
          x2: "112",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sEr),
        e("line", {
          x1: "112",
          y1: "216",
          x2: "144",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rEr),
        e("path", {
          d: "M184,40h24a8,8,0,0,1,8,8V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iEr),
        e("line", {
          x1: "216",
          y1: "144",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lEr),
        e("line", {
          x1: "40",
          y1: "112",
          x2: "40",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dEr),
        e("path", {
          d: "M72,216H48a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kEr),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cEr)
      ])) : g("", !0)
    ], 16, xGr));
  }
}), uEr = ["width", "height", "fill", "transform"], aEr = { key: 0 }, _Er = ["stroke"], pEr = ["stroke"], yEr = ["stroke"], $Er = { key: 1 }, wEr = ["stroke"], fEr = ["stroke"], gEr = ["stroke"], xEr = { key: 2 }, jEr = /* @__PURE__ */ e("path", { d: "M229.7,109.7l-48,48A8.3,8.3,0,0,1,176,160a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,168,152V112a87.9,87.9,0,0,0-85.2,66,8.1,8.1,0,0,1-7.8,6l-2-.3a8,8,0,0,1-5.7-9.7A103.9,103.9,0,0,1,168,96V56a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7l48,48A8.1,8.1,0,0,1,229.7,109.7ZM192,208H40V88a8,8,0,0,0-16,0V208a16,16,0,0,0,16,16H192a8,8,0,0,0,0-16Z" }, null, -1), mEr = [
  jEr
], MEr = { key: 3 }, vEr = ["stroke"], SEr = ["stroke"], HEr = ["stroke"], AEr = { key: 4 }, VEr = ["stroke"], zEr = ["stroke"], ZEr = ["stroke"], CEr = { key: 5 }, bEr = ["stroke"], LEr = ["stroke"], BEr = ["stroke"], PEr = {
  name: "PhShare"
}, Vol = /* @__PURE__ */ $({
  ...PEr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", aEr, [
        e("polyline", {
          points: "176 152 224 104 176 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Er),
        e("path", {
          d: "M192,216H40a8,8,0,0,1-8-8V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pEr),
        e("path", {
          d: "M75,176a96.1,96.1,0,0,1,93-72h56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yEr)
      ])) : o(i) === "duotone" ? (s(), r("g", $Er, [
        e("polyline", {
          points: "176 152 224 104 176 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wEr),
        e("path", {
          d: "M192,216H40a8,8,0,0,1-8-8V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fEr),
        e("path", {
          d: "M75,176a96.1,96.1,0,0,1,93-72h56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gEr)
      ])) : o(i) === "fill" ? (s(), r("g", xEr, mEr)) : o(i) === "light" ? (s(), r("g", MEr, [
        e("polyline", {
          points: "176 152 224 104 176 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vEr),
        e("path", {
          d: "M192,216H40a8,8,0,0,1-8-8V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, SEr),
        e("path", {
          d: "M75,176a96.1,96.1,0,0,1,93-72h56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HEr)
      ])) : o(i) === "thin" ? (s(), r("g", AEr, [
        e("polyline", {
          points: "176 152 224 104 176 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VEr),
        e("path", {
          d: "M192,216H40a8,8,0,0,1-8-8V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zEr),
        e("path", {
          d: "M75,176a96.1,96.1,0,0,1,93-72h56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZEr)
      ])) : o(i) === "regular" ? (s(), r("g", CEr, [
        e("polyline", {
          points: "176 152 224 104 176 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bEr),
        e("path", {
          d: "M192,216H40a8,8,0,0,1-8-8V88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LEr),
        e("path", {
          d: "M75,176a96.1,96.1,0,0,1,93-72h56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BEr)
      ])) : g("", !0)
    ], 16, uEr));
  }
}), WEr = ["width", "height", "fill", "transform"], NEr = { key: 0 }, FEr = ["stroke"], TEr = ["stroke"], DEr = ["stroke"], REr = ["stroke"], UEr = ["stroke"], qEr = { key: 1 }, GEr = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "200",
  r: "32",
  opacity: "0.2"
}, null, -1), EEr = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "56",
  r: "32",
  opacity: "0.2"
}, null, -1), OEr = ["stroke"], IEr = ["stroke"], KEr = ["stroke"], XEr = ["stroke"], JEr = ["stroke"], QEr = { key: 2 }, YEr = /* @__PURE__ */ e("path", { d: "M176,160a39.7,39.7,0,0,0-28.6,12.1l-46.1-29.6a40.3,40.3,0,0,0,0-29l46.1-29.6A40,40,0,1,0,136,56a41,41,0,0,0,2.7,14.5L92.6,100.1a40,40,0,1,0,0,55.8l46.1,29.6A41,41,0,0,0,136,200a40,40,0,1,0,40-40Z" }, null, -1), oOr = [
  YEr
], eOr = { key: 3 }, tOr = ["stroke"], nOr = ["stroke"], sOr = ["stroke"], rOr = ["stroke"], iOr = ["stroke"], lOr = { key: 4 }, dOr = ["stroke"], kOr = ["stroke"], cOr = ["stroke"], hOr = ["stroke"], uOr = ["stroke"], aOr = { key: 5 }, _Or = ["stroke"], pOr = ["stroke"], yOr = ["stroke"], $Or = ["stroke"], wOr = ["stroke"], fOr = {
  name: "PhShareNetwork"
}, zol = /* @__PURE__ */ $({
  ...fOr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", NEr, [
        e("circle", {
          cx: "64",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FEr),
        e("circle", {
          cx: "176",
          cy: "200",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TEr),
        e("circle", {
          cx: "176",
          cy: "56",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DEr),
        e("line", {
          x1: "149.1",
          y1: "73.3",
          x2: "90.9",
          y2: "110.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, REr),
        e("line", {
          x1: "90.9",
          y1: "145.3",
          x2: "149.1",
          y2: "182.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, UEr)
      ])) : o(i) === "duotone" ? (s(), r("g", qEr, [
        GEr,
        EEr,
        e("circle", {
          cx: "64",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OEr),
        e("circle", {
          cx: "176",
          cy: "200",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IEr),
        e("circle", {
          cx: "176",
          cy: "56",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KEr),
        e("line", {
          x1: "149.1",
          y1: "73.3",
          x2: "90.9",
          y2: "110.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XEr),
        e("line", {
          x1: "90.9",
          y1: "145.3",
          x2: "149.1",
          y2: "182.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JEr)
      ])) : o(i) === "fill" ? (s(), r("g", QEr, oOr)) : o(i) === "light" ? (s(), r("g", eOr, [
        e("circle", {
          cx: "64",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tOr),
        e("circle", {
          cx: "176",
          cy: "200",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nOr),
        e("circle", {
          cx: "176",
          cy: "56",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sOr),
        e("line", {
          x1: "149.1",
          y1: "73.3",
          x2: "90.9",
          y2: "110.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rOr),
        e("line", {
          x1: "90.9",
          y1: "145.3",
          x2: "149.1",
          y2: "182.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iOr)
      ])) : o(i) === "thin" ? (s(), r("g", lOr, [
        e("circle", {
          cx: "64",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dOr),
        e("circle", {
          cx: "176",
          cy: "200",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kOr),
        e("circle", {
          cx: "176",
          cy: "56",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cOr),
        e("line", {
          x1: "149.1",
          y1: "73.3",
          x2: "90.9",
          y2: "110.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hOr),
        e("line", {
          x1: "90.9",
          y1: "145.3",
          x2: "149.1",
          y2: "182.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uOr)
      ])) : o(i) === "regular" ? (s(), r("g", aOr, [
        e("circle", {
          cx: "64",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Or),
        e("circle", {
          cx: "176",
          cy: "200",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pOr),
        e("circle", {
          cx: "176",
          cy: "56",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yOr),
        e("line", {
          x1: "149.1",
          y1: "73.3",
          x2: "90.9",
          y2: "110.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Or),
        e("line", {
          x1: "90.9",
          y1: "145.3",
          x2: "149.1",
          y2: "182.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wOr)
      ])) : g("", !0)
    ], 16, WEr));
  }
}), gOr = ["width", "height", "fill", "transform"], xOr = { key: 0 }, jOr = ["stroke"], mOr = { key: 1 }, MOr = /* @__PURE__ */ e("path", {
  d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
  opacity: "0.2"
}, null, -1), vOr = ["stroke"], SOr = { key: 2 }, HOr = /* @__PURE__ */ e("path", { d: "M208,40H48A16,16,0,0,0,32,56v58.7c0,89.4,75.8,119.1,91,124.1a16,16,0,0,0,10,0c15.2-5,91-34.7,91-124.1V56A16,16,0,0,0,208,40Z" }, null, -1), AOr = [
  HOr
], VOr = { key: 3 }, zOr = ["stroke"], ZOr = { key: 4 }, COr = ["stroke"], bOr = { key: 5 }, LOr = ["stroke"], BOr = {
  name: "PhShield"
}, Zol = /* @__PURE__ */ $({
  ...BOr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xOr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jOr)
      ])) : o(i) === "duotone" ? (s(), r("g", mOr, [
        MOr,
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vOr)
      ])) : o(i) === "fill" ? (s(), r("g", SOr, AOr)) : o(i) === "light" ? (s(), r("g", VOr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zOr)
      ])) : o(i) === "thin" ? (s(), r("g", ZOr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, COr)
      ])) : o(i) === "regular" ? (s(), r("g", bOr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LOr)
      ])) : g("", !0)
    ], 16, gOr));
  }
}), POr = ["width", "height", "fill", "transform"], WOr = { key: 0 }, NOr = ["stroke"], FOr = ["stroke"], TOr = { key: 1 }, DOr = /* @__PURE__ */ e("path", {
  d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
  opacity: "0.2"
}, null, -1), ROr = ["stroke"], UOr = ["stroke"], qOr = { key: 2 }, GOr = /* @__PURE__ */ e("path", { d: "M208,40H48A16,16,0,0,0,32,56v58.7c0,89.4,75.8,119.1,91,124.1a16,16,0,0,0,10,0c15.2-5,91-34.7,91-124.1V56A16,16,0,0,0,208,40Zm-30.5,69.8-58.6,56a8.1,8.1,0,0,1-5.6,2.2,7.9,7.9,0,0,1-5.5-2.2l-29.3-28a8,8,0,1,1,11-11.6l23.8,22.7,53.2-50.7a8,8,0,0,1,11,11.6Z" }, null, -1), EOr = [
  GOr
], OOr = { key: 3 }, IOr = ["stroke"], KOr = ["stroke"], XOr = { key: 4 }, JOr = ["stroke"], QOr = ["stroke"], YOr = { key: 5 }, oIr = ["stroke"], eIr = ["stroke"], tIr = {
  name: "PhShieldCheck"
}, Col = /* @__PURE__ */ $({
  ...tIr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", WOr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NOr),
        e("polyline", {
          points: "172 104 113.3 160 84 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FOr)
      ])) : o(i) === "duotone" ? (s(), r("g", TOr, [
        DOr,
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ROr),
        e("polyline", {
          points: "172 104 113.3 160 84 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UOr)
      ])) : o(i) === "fill" ? (s(), r("g", qOr, EOr)) : o(i) === "light" ? (s(), r("g", OOr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IOr),
        e("polyline", {
          points: "172 104 113.3 160 84 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KOr)
      ])) : o(i) === "thin" ? (s(), r("g", XOr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, JOr),
        e("polyline", {
          points: "172 104 113.3 160 84 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QOr)
      ])) : o(i) === "regular" ? (s(), r("g", YOr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oIr),
        e("polyline", {
          points: "172 104 113.3 160 84 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eIr)
      ])) : g("", !0)
    ], 16, POr));
  }
}), nIr = ["width", "height", "fill", "transform"], sIr = { key: 0 }, rIr = ["stroke"], iIr = ["stroke"], lIr = ["stroke"], dIr = { key: 1 }, kIr = /* @__PURE__ */ e("path", {
  d: "M48,48h80a0,0,0,0,1,0,0v80a0,0,0,0,1,0,0H40a0,0,0,0,1,0,0V56A8,8,0,0,1,48,48Z",
  opacity: "0.2"
}, null, -1), cIr = /* @__PURE__ */ e("path", {
  d: "M215.4,128c-7.1,73.7-71.5,98.8-84.9,103.2a7.7,7.7,0,0,1-2.5.4h0V128Z",
  opacity: "0.2"
}, null, -1), hIr = ["stroke"], uIr = ["stroke"], aIr = ["stroke"], _Ir = { key: 2 }, pIr = /* @__PURE__ */ e("path", { d: "M208,40H48A16,16,0,0,0,32,56v58.7c0,89.4,75.8,119.1,91,124.1a16,16,0,0,0,10,0c15.2-5,91-34.7,91-124.1V56A16,16,0,0,0,208,40ZM128,223.6C115.3,219.4,55.7,196,48.7,128H128V56h80v58.7a114.9,114.9,0,0,1-.7,13.3H128v95.6Z" }, null, -1), yIr = [
  pIr
], $Ir = { key: 3 }, wIr = ["stroke"], fIr = ["stroke"], gIr = ["stroke"], xIr = { key: 4 }, jIr = ["stroke"], mIr = ["stroke"], MIr = ["stroke"], vIr = { key: 5 }, SIr = ["stroke"], HIr = ["stroke"], AIr = ["stroke"], VIr = {
  name: "PhShieldCheckered"
}, bol = /* @__PURE__ */ $({
  ...VIr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", sIr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rIr),
        e("line", {
          x1: "40.6",
          y1: "128",
          x2: "215.4",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iIr),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "231.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lIr)
      ])) : o(i) === "duotone" ? (s(), r("g", dIr, [
        kIr,
        cIr,
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hIr),
        e("line", {
          x1: "40.6",
          y1: "128",
          x2: "215.4",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uIr),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "231.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aIr)
      ])) : o(i) === "fill" ? (s(), r("g", _Ir, yIr)) : o(i) === "light" ? (s(), r("g", $Ir, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wIr),
        e("line", {
          x1: "40.6",
          y1: "128",
          x2: "215.4",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fIr),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "231.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gIr)
      ])) : o(i) === "thin" ? (s(), r("g", xIr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jIr),
        e("line", {
          x1: "40.6",
          y1: "128",
          x2: "215.4",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mIr),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "231.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MIr)
      ])) : o(i) === "regular" ? (s(), r("g", vIr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SIr),
        e("line", {
          x1: "40.6",
          y1: "128",
          x2: "215.4",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HIr),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "128",
          y2: "231.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AIr)
      ])) : g("", !0)
    ], 16, nIr));
  }
}), zIr = ["width", "height", "fill", "transform"], ZIr = { key: 0 }, CIr = ["stroke"], bIr = ["stroke"], LIr = { key: 1 }, BIr = /* @__PURE__ */ e("path", {
  d: "M202.4,172.1c-21.4,40.2-61.6,55.7-71.9,59.1a7.2,7.2,0,0,1-5,0c-10.3-3.4-50.5-18.9-71.9-59.1h0L128,120l74.4,52.1Z",
  opacity: "0.2"
}, null, -1), PIr = ["stroke"], WIr = ["stroke"], NIr = { key: 2 }, FIr = /* @__PURE__ */ e("path", { d: "M208,40H48A16,16,0,0,0,32,56v58.7c0,89.4,75.8,119.1,91,124.1a14.3,14.3,0,0,0,10,0c15.2-5,91-34.7,91-124.1V56A16,16,0,0,0,208,40ZM48,56H208v58.7a115.1,115.1,0,0,1-8.8,45.4l-66.6-46.7a8.1,8.1,0,0,0-9.2,0L56.8,160.1A115.1,115.1,0,0,1,48,114.7Z" }, null, -1), TIr = [
  FIr
], DIr = { key: 3 }, RIr = ["stroke"], UIr = ["stroke"], qIr = { key: 4 }, GIr = ["stroke"], EIr = ["stroke"], OIr = { key: 5 }, IIr = ["stroke"], KIr = ["stroke"], XIr = {
  name: "PhShieldChevron"
}, Lol = /* @__PURE__ */ $({
  ...XIr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ZIr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CIr),
        e("polyline", {
          points: "202.4 172.1 128 120 53.6 172.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bIr)
      ])) : o(i) === "duotone" ? (s(), r("g", LIr, [
        BIr,
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PIr),
        e("polyline", {
          points: "202.4 172.1 128 120 53.6 172.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WIr)
      ])) : o(i) === "fill" ? (s(), r("g", NIr, TIr)) : o(i) === "light" ? (s(), r("g", DIr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RIr),
        e("polyline", {
          points: "202.4 172.1 128 120 53.6 172.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UIr)
      ])) : o(i) === "thin" ? (s(), r("g", qIr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GIr),
        e("polyline", {
          points: "202.4 172.1 128 120 53.6 172.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, EIr)
      ])) : o(i) === "regular" ? (s(), r("g", OIr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IIr),
        e("polyline", {
          points: "202.4 172.1 128 120 53.6 172.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KIr)
      ])) : g("", !0)
    ], 16, zIr));
  }
}), JIr = ["width", "height", "fill", "transform"], QIr = { key: 0 }, YIr = ["stroke"], oKr = ["stroke"], eKr = ["stroke"], tKr = { key: 1 }, nKr = /* @__PURE__ */ e("path", {
  d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
  opacity: "0.2"
}, null, -1), sKr = ["stroke"], rKr = ["stroke"], iKr = ["stroke"], lKr = { key: 2 }, dKr = /* @__PURE__ */ e("path", { d: "M208,40H48A16,16,0,0,0,32,56v58.7c0,89.4,75.8,119.1,91,124.1a16,16,0,0,0,10,0c15.2-5,91-34.7,91-124.1V56A16,16,0,0,0,208,40Zm-48,96H136v24a8,8,0,0,1-16,0V136H96a8,8,0,0,1,0-16h24V96a8,8,0,0,1,16,0v24h24a8,8,0,0,1,0,16Z" }, null, -1), kKr = [
  dKr
], cKr = { key: 3 }, hKr = ["stroke"], uKr = ["stroke"], aKr = ["stroke"], _Kr = { key: 4 }, pKr = ["stroke"], yKr = ["stroke"], $Kr = ["stroke"], wKr = { key: 5 }, fKr = ["stroke"], gKr = ["stroke"], xKr = ["stroke"], jKr = {
  name: "PhShieldPlus"
}, Bol = /* @__PURE__ */ $({
  ...jKr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", QIr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, YIr),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oKr),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eKr)
      ])) : o(i) === "duotone" ? (s(), r("g", tKr, [
        nKr,
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sKr),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rKr),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iKr)
      ])) : o(i) === "fill" ? (s(), r("g", lKr, kKr)) : o(i) === "light" ? (s(), r("g", cKr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hKr),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uKr),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aKr)
      ])) : o(i) === "thin" ? (s(), r("g", _Kr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pKr),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yKr),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $Kr)
      ])) : o(i) === "regular" ? (s(), r("g", wKr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fKr),
        e("line", {
          x1: "96",
          y1: "128",
          x2: "160",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gKr),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xKr)
      ])) : g("", !0)
    ], 16, JIr));
  }
}), mKr = ["width", "height", "fill", "transform"], MKr = { key: 0 }, vKr = ["stroke"], SKr = ["stroke"], HKr = ["stroke"], AKr = { key: 1 }, VKr = /* @__PURE__ */ e("path", {
  d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
  opacity: "0.2"
}, null, -1), zKr = ["stroke"], ZKr = ["stroke"], CKr = ["stroke"], bKr = { key: 2 }, LKr = /* @__PURE__ */ e("path", { d: "M227.9,237.9a8.2,8.2,0,0,1-5.4,2.1,8,8,0,0,1-5.9-2.6l-29.2-32.1A146.4,146.4,0,0,1,133,238.8a14.3,14.3,0,0,1-10,0c-15.2-5-91-34.7-91-124.1V56a15.9,15.9,0,0,1,7.5-13.5L27.6,29.4a7.9,7.9,0,0,1,.5-11.3,8,8,0,0,1,11.3.5l21.8,24h0L193.5,188.1h0l34.9,38.4A8,8,0,0,1,227.9,237.9Zm-28.3-66.8a7.9,7.9,0,0,0,5.9,2.6h1.3a7.9,7.9,0,0,0,6-4.6c7.4-16.3,11.2-34.6,11.2-54.3V56a16,16,0,0,0-16-16H98.5a8.1,8.1,0,0,0-7.3,4.8,8,8,0,0,0,1.4,8.6Z" }, null, -1), BKr = [
  LKr
], PKr = { key: 3 }, WKr = ["stroke"], NKr = ["stroke"], FKr = ["stroke"], TKr = { key: 4 }, DKr = ["stroke"], RKr = ["stroke"], UKr = ["stroke"], qKr = { key: 5 }, GKr = ["stroke"], EKr = ["stroke"], OKr = ["stroke"], IKr = {
  name: "PhShieldSlash"
}, Pol = /* @__PURE__ */ $({
  ...IKr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", MKr, [
        e("line", {
          x1: "33.5",
          y1: "24",
          x2: "222.5",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vKr),
        e("path", {
          d: "M187.5,193.5c-21.5,24.6-48.8,35-57,37.7a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7V56a8,8,0,0,1,8-8h7.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SKr),
        e("path", {
          d: "M109.4,48H208a8,8,0,0,1,8,8v58.7a126.2,126.2,0,0,1-7.1,42.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HKr)
      ])) : o(i) === "duotone" ? (s(), r("g", AKr, [
        VKr,
        e("line", {
          x1: "33.5",
          y1: "24",
          x2: "222.5",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zKr),
        e("path", {
          d: "M187.5,193.5c-21.5,24.6-48.8,35-57,37.7a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7V56a8,8,0,0,1,8-8h7.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZKr),
        e("path", {
          d: "M98.5,48H208a8,8,0,0,1,8,8v58.7c0,20.1-4.1,36.9-10.5,51",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CKr)
      ])) : o(i) === "fill" ? (s(), r("g", bKr, BKr)) : o(i) === "light" ? (s(), r("g", PKr, [
        e("line", {
          x1: "33.5",
          y1: "24",
          x2: "222.5",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WKr),
        e("path", {
          d: "M187.5,193.5c-21.5,24.6-48.8,35-57,37.7a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7V56a8,8,0,0,1,8-8h7.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, NKr),
        e("path", {
          d: "M98.5,48H208a8,8,0,0,1,8,8v58.7c0,20.1-4.1,36.9-10.5,51",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FKr)
      ])) : o(i) === "thin" ? (s(), r("g", TKr, [
        e("line", {
          x1: "33.5",
          y1: "24",
          x2: "222.5",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, DKr),
        e("path", {
          d: "M187.5,193.5c-21.5,24.6-48.8,35-57,37.7a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7V56a8,8,0,0,1,8-8h7.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RKr),
        e("path", {
          d: "M98.5,48H208a8,8,0,0,1,8,8v58.7c0,20.1-4.1,36.9-10.5,51",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, UKr)
      ])) : o(i) === "regular" ? (s(), r("g", qKr, [
        e("line", {
          x1: "33.5",
          y1: "24",
          x2: "222.5",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GKr),
        e("path", {
          d: "M187.5,193.5c-21.5,24.6-48.8,35-57,37.7a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7V56a8,8,0,0,1,8-8h7.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EKr),
        e("path", {
          d: "M98.5,48H208a8,8,0,0,1,8,8v58.7c0,20.1-4.1,36.9-10.5,51",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OKr)
      ])) : g("", !0)
    ], 16, mKr));
  }
}), KKr = ["width", "height", "fill", "transform"], XKr = { key: 0 }, JKr = ["stroke"], QKr = ["stroke"], YKr = ["stroke"], oXr = ["stroke"], eXr = ["stroke"], tXr = ["stroke"], nXr = { key: 1 }, sXr = /* @__PURE__ */ e("path", {
  d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
  opacity: "0.2"
}, null, -1), rXr = ["stroke"], iXr = ["stroke"], lXr = ["stroke"], dXr = ["stroke"], kXr = ["stroke"], cXr = ["stroke"], hXr = { key: 2 }, uXr = /* @__PURE__ */ e("path", { d: "M208,40H48A16,16,0,0,0,32,56v58.7c0,89.4,75.8,119.1,91,124.1a14.3,14.3,0,0,0,10,0c15.2-5,91-34.7,91-124.1V56A16,16,0,0,0,208,40Zm-39.5,91.2-27.6,9L158,163.7a7.9,7.9,0,0,1-1.8,11.1,7.6,7.6,0,0,1-4.7,1.6,8.2,8.2,0,0,1-6.5-3.3l-17-23.5-17,23.5a8.2,8.2,0,0,1-6.5,3.3,7.6,7.6,0,0,1-4.7-1.6A7.9,7.9,0,0,1,98,163.7l17.1-23.5-27.6-9a8,8,0,0,1-5.2-10A8.1,8.1,0,0,1,92.4,116l27.6,9V96a8,8,0,0,1,16,0v29l27.6-9a8.1,8.1,0,0,1,10.1,5.2A8,8,0,0,1,168.5,131.2Z" }, null, -1), aXr = [
  uXr
], _Xr = { key: 3 }, pXr = ["stroke"], yXr = ["stroke"], $Xr = ["stroke"], wXr = ["stroke"], fXr = ["stroke"], gXr = ["stroke"], xXr = { key: 4 }, jXr = ["stroke"], mXr = ["stroke"], MXr = ["stroke"], vXr = ["stroke"], SXr = ["stroke"], HXr = ["stroke"], AXr = { key: 5 }, VXr = ["stroke"], zXr = ["stroke"], ZXr = ["stroke"], CXr = ["stroke"], bXr = ["stroke"], LXr = ["stroke"], BXr = {
  name: "PhShieldStar"
}, Wol = /* @__PURE__ */ $({
  ...BXr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", XKr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, JKr),
        e("line", {
          x1: "128",
          y1: "92",
          x2: "128",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, QKr),
        e("line", {
          x1: "90",
          y1: "119.6",
          x2: "128",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, YKr),
        e("line", {
          x1: "104.5",
          y1: "164.4",
          x2: "128",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oXr),
        e("line", {
          x1: "151.5",
          y1: "164.4",
          x2: "128",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eXr),
        e("line", {
          x1: "166",
          y1: "119.6",
          x2: "128",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tXr)
      ])) : o(i) === "duotone" ? (s(), r("g", nXr, [
        sXr,
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rXr),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iXr),
        e("line", {
          x1: "90",
          y1: "123.6",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lXr),
        e("line", {
          x1: "104.5",
          y1: "168.4",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dXr),
        e("line", {
          x1: "151.5",
          y1: "168.4",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kXr),
        e("line", {
          x1: "166",
          y1: "123.6",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cXr)
      ])) : o(i) === "fill" ? (s(), r("g", hXr, aXr)) : o(i) === "light" ? (s(), r("g", _Xr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pXr),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yXr),
        e("line", {
          x1: "90",
          y1: "123.6",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $Xr),
        e("line", {
          x1: "104.5",
          y1: "168.4",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wXr),
        e("line", {
          x1: "151.5",
          y1: "168.4",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fXr),
        e("line", {
          x1: "166",
          y1: "123.6",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gXr)
      ])) : o(i) === "thin" ? (s(), r("g", xXr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jXr),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mXr),
        e("line", {
          x1: "90",
          y1: "123.6",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MXr),
        e("line", {
          x1: "104.5",
          y1: "168.4",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vXr),
        e("line", {
          x1: "151.5",
          y1: "168.4",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SXr),
        e("line", {
          x1: "166",
          y1: "123.6",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HXr)
      ])) : o(i) === "regular" ? (s(), r("g", AXr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VXr),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zXr),
        e("line", {
          x1: "90",
          y1: "123.6",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZXr),
        e("line", {
          x1: "104.5",
          y1: "168.4",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CXr),
        e("line", {
          x1: "151.5",
          y1: "168.4",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bXr),
        e("line", {
          x1: "166",
          y1: "123.6",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LXr)
      ])) : g("", !0)
    ], 16, KKr));
  }
}), PXr = ["width", "height", "fill", "transform"], WXr = { key: 0 }, NXr = ["stroke"], FXr = ["stroke"], TXr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "172",
  r: "16"
}, null, -1), DXr = { key: 1 }, RXr = /* @__PURE__ */ e("path", {
  d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
  opacity: "0.2"
}, null, -1), UXr = ["stroke"], qXr = ["stroke"], GXr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "172",
  r: "12"
}, null, -1), EXr = { key: 2 }, OXr = /* @__PURE__ */ e("path", { d: "M208,40H48A16,16,0,0,0,32,56v58.7c0,89.4,75.8,119.1,91,124.1a14.3,14.3,0,0,0,10,0c15.2-5,91-34.7,91-124.1V56A16,16,0,0,0,208,40ZM120,96a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm8,88a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z" }, null, -1), IXr = [
  OXr
], KXr = { key: 3 }, XXr = ["stroke"], JXr = ["stroke"], QXr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "172",
  r: "10"
}, null, -1), YXr = { key: 4 }, oJr = ["stroke"], eJr = ["stroke"], tJr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "172",
  r: "8"
}, null, -1), nJr = { key: 5 }, sJr = ["stroke"], rJr = ["stroke"], iJr = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "172",
  r: "12"
}, null, -1), lJr = {
  name: "PhShieldWarning"
}, Nol = /* @__PURE__ */ $({
  ...lJr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", WXr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NXr),
        e("line", {
          x1: "128",
          y1: "92",
          x2: "128",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FXr),
        TXr
      ])) : o(i) === "duotone" ? (s(), r("g", DXr, [
        RXr,
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UXr),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qXr),
        GXr
      ])) : o(i) === "fill" ? (s(), r("g", EXr, IXr)) : o(i) === "light" ? (s(), r("g", KXr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XXr),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JXr),
        QXr
      ])) : o(i) === "thin" ? (s(), r("g", YXr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oJr),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eJr),
        tJr
      ])) : o(i) === "regular" ? (s(), r("g", nJr, [
        e("path", {
          d: "M40,114.7V56a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8v58.7c0,84-71.3,111.8-85.5,116.5a7.2,7.2,0,0,1-5,0C111.3,226.5,40,198.7,40,114.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sJr),
        e("line", {
          x1: "128",
          y1: "96",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rJr),
        iJr
      ])) : g("", !0)
    ], 16, PXr));
  }
}), dJr = ["width", "height", "fill", "transform"], kJr = { key: 0 }, cJr = ["stroke"], hJr = ["stroke"], uJr = { key: 1 }, aJr = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "48",
  width: "192",
  height: "160",
  rx: "8",
  opacity: "0.2"
}, null, -1), _Jr = ["stroke"], pJr = ["stroke"], yJr = { key: 2 }, $Jr = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm-88,96A48,48,0,0,1,80,88a8,8,0,0,1,16,0,32,32,0,0,0,64,0,8,8,0,0,1,16,0A48,48,0,0,1,128,136Z" }, null, -1), wJr = [
  $Jr
], fJr = { key: 3 }, gJr = ["stroke"], xJr = ["stroke"], jJr = { key: 4 }, mJr = ["stroke"], MJr = ["stroke"], vJr = { key: 5 }, SJr = ["stroke"], HJr = ["stroke"], AJr = {
  name: "PhShoppingBag"
}, Fol = /* @__PURE__ */ $({
  ...AJr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", kJr, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cJr),
        e("path", {
          d: "M168,88a40,40,0,0,1-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hJr)
      ])) : o(i) === "duotone" ? (s(), r("g", uJr, [
        aJr,
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Jr),
        e("path", {
          d: "M168,88a40,40,0,0,1-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pJr)
      ])) : o(i) === "fill" ? (s(), r("g", yJr, wJr)) : o(i) === "light" ? (s(), r("g", fJr, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gJr),
        e("path", {
          d: "M168,88a40,40,0,0,1-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xJr)
      ])) : o(i) === "thin" ? (s(), r("g", jJr, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mJr),
        e("path", {
          d: "M168,88a40,40,0,0,1-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MJr)
      ])) : o(i) === "regular" ? (s(), r("g", vJr, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SJr),
        e("path", {
          d: "M168,88a40,40,0,0,1-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HJr)
      ])) : g("", !0)
    ], 16, dJr));
  }
}), VJr = ["width", "height", "fill", "transform"], zJr = { key: 0 }, ZJr = ["stroke"], CJr = ["stroke"], bJr = ["stroke"], LJr = { key: 1 }, BJr = /* @__PURE__ */ e("path", {
  d: "M32,80H224V56a8,8,0,0,0-8-8H40a8,8,0,0,0-8,8Z",
  opacity: "0.2"
}, null, -1), PJr = ["stroke"], WJr = ["stroke"], NJr = ["stroke"], FJr = { key: 2 }, TJr = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM128,160a48,48,0,0,1-48-48,8,8,0,0,1,16,0,32,32,0,0,0,64,0,8,8,0,0,1,16,0A48,48,0,0,1,128,160ZM40,72V56H216V72Z" }, null, -1), DJr = [
  TJr
], RJr = { key: 3 }, UJr = ["stroke"], qJr = ["stroke"], GJr = ["stroke"], EJr = { key: 4 }, OJr = ["stroke"], IJr = ["stroke"], KJr = ["stroke"], XJr = { key: 5 }, JJr = ["stroke"], QJr = ["stroke"], YJr = ["stroke"], oQr = {
  name: "PhShoppingBagOpen"
}, Tol = /* @__PURE__ */ $({
  ...oQr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", zJr, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZJr),
        e("line", {
          x1: "32",
          y1: "88",
          x2: "224",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CJr),
        e("path", {
          d: "M168,124a40,40,0,0,1-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bJr)
      ])) : o(i) === "duotone" ? (s(), r("g", LJr, [
        BJr,
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PJr),
        e("line", {
          x1: "32",
          y1: "80",
          x2: "224",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WJr),
        e("path", {
          d: "M168,112a40,40,0,0,1-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NJr)
      ])) : o(i) === "fill" ? (s(), r("g", FJr, DJr)) : o(i) === "light" ? (s(), r("g", RJr, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UJr),
        e("line", {
          x1: "32",
          y1: "80",
          x2: "224",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qJr),
        e("path", {
          d: "M168,112a40,40,0,0,1-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GJr)
      ])) : o(i) === "thin" ? (s(), r("g", EJr, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OJr),
        e("line", {
          x1: "32",
          y1: "80",
          x2: "224",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, IJr),
        e("path", {
          d: "M168,112a40,40,0,0,1-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KJr)
      ])) : o(i) === "regular" ? (s(), r("g", XJr, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JJr),
        e("line", {
          x1: "32",
          y1: "80",
          x2: "224",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QJr),
        e("path", {
          d: "M168,112a40,40,0,0,1-80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YJr)
      ])) : g("", !0)
    ], 16, VJr));
  }
}), eQr = ["width", "height", "fill", "transform"], tQr = { key: 0 }, nQr = ["stroke"], sQr = ["stroke"], rQr = ["stroke"], iQr = ["stroke"], lQr = { key: 1 }, dQr = /* @__PURE__ */ e("path", {
  d: "M62.5,144H188.1a15.9,15.9,0,0,0,15.7-13.1L216,64H48Z",
  opacity: "0.2"
}, null, -1), kQr = ["stroke"], cQr = ["stroke"], hQr = ["stroke"], uQr = ["stroke"], aQr = { key: 2 }, _Qr = /* @__PURE__ */ e("path", { d: "M223.9,65.4l-12.2,66.9A24,24,0,0,1,188.1,152H72.1l4.4,24H184a24,24,0,1,1-24,24,23.6,23.6,0,0,1,1.4-8H102.6a23.6,23.6,0,0,1,1.4,8,24,24,0,1,1-42.2-15.6L34.1,32H16a8,8,0,0,1,0-16H34.1A16,16,0,0,1,49.8,29.1L54.7,56H216a7.9,7.9,0,0,1,6.1,2.9A7.7,7.7,0,0,1,223.9,65.4Z" }, null, -1), pQr = [
  _Qr
], yQr = { key: 3 }, $Qr = ["stroke"], wQr = ["stroke"], fQr = ["stroke"], gQr = ["stroke"], xQr = { key: 4 }, jQr = ["stroke"], mQr = ["stroke"], MQr = ["stroke"], vQr = ["stroke"], SQr = { key: 5 }, HQr = ["stroke"], AQr = ["stroke"], VQr = ["stroke"], zQr = ["stroke"], ZQr = {
  name: "PhShoppingCart"
}, Dol = /* @__PURE__ */ $({
  ...ZQr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", tQr, [
        e("path", {
          d: "M184,184H69.8L41.9,30.6A8,8,0,0,0,34.1,24H16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nQr),
        e("circle", {
          cx: "80",
          cy: "204",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sQr),
        e("circle", {
          cx: "184",
          cy: "204",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rQr),
        e("path", {
          d: "M62.5,144H188.1a15.9,15.9,0,0,0,15.7-13.1L216,64H48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iQr)
      ])) : o(i) === "duotone" ? (s(), r("g", lQr, [
        dQr,
        e("path", {
          d: "M184,184H69.8L41.9,30.6A8,8,0,0,0,34.1,24H16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kQr),
        e("circle", {
          cx: "80",
          cy: "204",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cQr),
        e("circle", {
          cx: "184",
          cy: "204",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hQr),
        e("path", {
          d: "M62.5,144H188.1a15.9,15.9,0,0,0,15.7-13.1L216,64H48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uQr)
      ])) : o(i) === "fill" ? (s(), r("g", aQr, pQr)) : o(i) === "light" ? (s(), r("g", yQr, [
        e("path", {
          d: "M184,184H69.8L41.9,30.6A8,8,0,0,0,34.1,24H16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $Qr),
        e("circle", {
          cx: "80",
          cy: "204",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wQr),
        e("circle", {
          cx: "184",
          cy: "204",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fQr),
        e("path", {
          d: "M62.5,144H188.1a15.9,15.9,0,0,0,15.7-13.1L216,64H48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gQr)
      ])) : o(i) === "thin" ? (s(), r("g", xQr, [
        e("path", {
          d: "M184,184H69.8L41.9,30.6A8,8,0,0,0,34.1,24H16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jQr),
        e("circle", {
          cx: "80",
          cy: "204",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mQr),
        e("circle", {
          cx: "184",
          cy: "204",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MQr),
        e("path", {
          d: "M62.5,144H188.1a15.9,15.9,0,0,0,15.7-13.1L216,64H48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vQr)
      ])) : o(i) === "regular" ? (s(), r("g", SQr, [
        e("path", {
          d: "M184,184H69.8L41.9,30.6A8,8,0,0,0,34.1,24H16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HQr),
        e("circle", {
          cx: "80",
          cy: "204",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AQr),
        e("circle", {
          cx: "184",
          cy: "204",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VQr),
        e("path", {
          d: "M62.5,144H188.1a15.9,15.9,0,0,0,15.7-13.1L216,64H48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zQr)
      ])) : g("", !0)
    ], 16, eQr));
  }
}), CQr = ["width", "height", "fill", "transform"], bQr = { key: 0 }, LQr = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "216",
  r: "20"
}, null, -1), BQr = /* @__PURE__ */ e("circle", {
  cx: "184",
  cy: "216",
  r: "20"
}, null, -1), PQr = ["stroke"], WQr = { key: 1 }, NQr = /* @__PURE__ */ e("path", {
  d: "M42.3,72H221.7l-26.4,92.4A15.9,15.9,0,0,1,179.9,176H84.1a15.9,15.9,0,0,1-15.4-11.6Z",
  opacity: "0.2"
}, null, -1), FQr = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "216",
  r: "16"
}, null, -1), TQr = /* @__PURE__ */ e("circle", {
  cx: "184",
  cy: "216",
  r: "16"
}, null, -1), DQr = ["stroke"], RQr = { key: 2 }, UQr = /* @__PURE__ */ e("path", { d: "M96,216a16,16,0,1,1-16-16A16,16,0,0,1,96,216Zm88-16a16,16,0,1,0,16,16A16,16,0,0,0,184,200ZM228.1,67.2a8.1,8.1,0,0,0-6.4-3.2H48.3L40.2,35.6A16.1,16.1,0,0,0,24.8,24H8A8,8,0,0,0,8,40H24.8l9.8,34.1v.2L61,166.6A24.1,24.1,0,0,0,84.1,184h95.8A24.1,24.1,0,0,0,203,166.6l26.4-92.4A8,8,0,0,0,228.1,67.2Z" }, null, -1), qQr = [
  UQr
], GQr = { key: 3 }, EQr = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "216",
  r: "14"
}, null, -1), OQr = /* @__PURE__ */ e("circle", {
  cx: "184",
  cy: "216",
  r: "14"
}, null, -1), IQr = ["stroke"], KQr = { key: 4 }, XQr = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "216",
  r: "12"
}, null, -1), JQr = /* @__PURE__ */ e("circle", {
  cx: "184",
  cy: "216",
  r: "12"
}, null, -1), QQr = ["stroke"], YQr = { key: 5 }, oYr = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "216",
  r: "16"
}, null, -1), eYr = /* @__PURE__ */ e("circle", {
  cx: "184",
  cy: "216",
  r: "16"
}, null, -1), tYr = ["stroke"], nYr = {
  name: "PhShoppingCartSimple"
}, Rol = /* @__PURE__ */ $({
  ...nYr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", bQr, [
        LQr,
        BQr,
        e("path", {
          d: "M42.3,72H221.7l-24.1,84.4A16,16,0,0,1,182.2,168H81.8a16,16,0,0,1-15.4-11.6L32.5,37.8A8,8,0,0,0,24.8,32H12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PQr)
      ])) : o(i) === "duotone" ? (s(), r("g", WQr, [
        NQr,
        FQr,
        TQr,
        e("path", {
          d: "M42.3,72H221.7l-26.4,92.4A15.9,15.9,0,0,1,179.9,176H84.1a15.9,15.9,0,0,1-15.4-11.6L32.5,37.8A8,8,0,0,0,24.8,32H8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DQr)
      ])) : o(i) === "fill" ? (s(), r("g", RQr, qQr)) : o(i) === "light" ? (s(), r("g", GQr, [
        EQr,
        OQr,
        e("path", {
          d: "M42.3,72H221.7l-26.4,92.4A15.9,15.9,0,0,1,179.9,176H84.1a15.9,15.9,0,0,1-15.4-11.6L32.5,37.8A8,8,0,0,0,24.8,32H8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IQr)
      ])) : o(i) === "thin" ? (s(), r("g", KQr, [
        XQr,
        JQr,
        e("path", {
          d: "M42.3,72H221.7l-26.4,92.4A15.9,15.9,0,0,1,179.9,176H84.1a15.9,15.9,0,0,1-15.4-11.6L32.5,37.8A8,8,0,0,0,24.8,32H8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QQr)
      ])) : o(i) === "regular" ? (s(), r("g", YQr, [
        oYr,
        eYr,
        e("path", {
          d: "M42.3,72H221.7l-26.4,92.4A15.9,15.9,0,0,1,179.9,176H84.1a15.9,15.9,0,0,1-15.4-11.6L32.5,37.8A8,8,0,0,0,24.8,32H8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tYr)
      ])) : g("", !0)
    ], 16, CQr));
  }
}), sYr = ["width", "height", "fill", "transform"], rYr = { key: 0 }, iYr = /* @__PURE__ */ e("circle", {
  cx: "60",
  cy: "228",
  r: "16"
}, null, -1), lYr = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "196",
  r: "16"
}, null, -1), dYr = /* @__PURE__ */ e("circle", {
  cx: "28",
  cy: "196",
  r: "16"
}, null, -1), kYr = /* @__PURE__ */ e("circle", {
  cx: "60",
  cy: "164",
  r: "16"
}, null, -1), cYr = ["stroke"], hYr = { key: 1 }, uYr = /* @__PURE__ */ j('<path d="M184,72,55.3,93.4A8,8,0,0,0,51,107l98,98a8,8,0,0,0,13.6-4.3Z" opacity="0.2"></path><circle cx="60" cy="228" r="12"></circle><circle cx="88" cy="200" r="12"></circle><circle cx="28" cy="196" r="12"></circle><circle cx="56" cy="168" r="12"></circle>', 5), aYr = ["stroke"], _Yr = { key: 2 }, pYr = /* @__PURE__ */ e("path", { d: "M72,228a12,12,0,1,1-12-12A12,12,0,0,1,72,228Zm16-40a12,12,0,1,0,12,12A12,12,0,0,0,88,188Zm-60-4a12,12,0,1,0,12,12A12,12,0,0,0,28,184Zm40-16a12,12,0,1,0-12,12A12,12,0,0,0,68,168ZM248,32H219.3A15.9,15.9,0,0,0,208,36.7L180.2,64.5,54,85.6A15.7,15.7,0,0,0,41.4,96.5a16,16,0,0,0,3.9,16.1l98.1,98.1a16,16,0,0,0,11.2,4.7,16.2,16.2,0,0,0,4.9-.8A15.7,15.7,0,0,0,170.4,202L191.5,75.8h0L219.3,48H248a8,8,0,0,0,0-16Z" }, null, -1), yYr = [
  pYr
], $Yr = { key: 3 }, wYr = /* @__PURE__ */ e("circle", {
  cx: "60",
  cy: "228",
  r: "10"
}, null, -1), fYr = /* @__PURE__ */ e("circle", {
  cx: "88",
  cy: "200",
  r: "10"
}, null, -1), gYr = /* @__PURE__ */ e("circle", {
  cx: "28",
  cy: "196",
  r: "10"
}, null, -1), xYr = /* @__PURE__ */ e("circle", {
  cx: "56",
  cy: "168",
  r: "10"
}, null, -1), jYr = ["stroke"], mYr = { key: 4 }, MYr = /* @__PURE__ */ e("circle", {
  cx: "60",
  cy: "228",
  r: "8"
}, null, -1), vYr = /* @__PURE__ */ e("circle", {
  cx: "88",
  cy: "200",
  r: "8"
}, null, -1), SYr = /* @__PURE__ */ e("circle", {
  cx: "28",
  cy: "196",
  r: "8"
}, null, -1), HYr = /* @__PURE__ */ e("circle", {
  cx: "56",
  cy: "168",
  r: "8"
}, null, -1), AYr = ["stroke"], VYr = { key: 5 }, zYr = /* @__PURE__ */ e("circle", {
  cx: "60",
  cy: "228",
  r: "12"
}, null, -1), ZYr = /* @__PURE__ */ e("circle", {
  cx: "88",
  cy: "200",
  r: "12"
}, null, -1), CYr = /* @__PURE__ */ e("circle", {
  cx: "28",
  cy: "196",
  r: "12"
}, null, -1), bYr = /* @__PURE__ */ e("circle", {
  cx: "56",
  cy: "168",
  r: "12"
}, null, -1), LYr = ["stroke"], BYr = {
  name: "PhShower"
}, Uol = /* @__PURE__ */ $({
  ...BYr,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", rYr, [
        iYr,
        lYr,
        dYr,
        kYr,
        e("path", {
          d: "M244,40H219.3a7.9,7.9,0,0,0-5.6,2.3L184,72,64.4,86.1a8,8,0,0,0-4.7,13.6l96.6,96.6a8,8,0,0,0,13.6-4.7L184,72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cYr)
      ])) : o(i) === "duotone" ? (s(), r("g", hYr, [
        uYr,
        e("path", {
          d: "M248,40H219.3a7.9,7.9,0,0,0-5.6,2.3L184,72,55.3,93.4A8,8,0,0,0,51,107l98,98a8,8,0,0,0,13.6-4.3L184,72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aYr)
      ])) : o(i) === "fill" ? (s(), r("g", _Yr, yYr)) : o(i) === "light" ? (s(), r("g", $Yr, [
        wYr,
        fYr,
        gYr,
        xYr,
        e("path", {
          d: "M248,40H219.3a7.9,7.9,0,0,0-5.6,2.3L184,72,55.3,93.4A8,8,0,0,0,51,107l98,98a8,8,0,0,0,13.6-4.3L184,72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jYr)
      ])) : o(i) === "thin" ? (s(), r("g", mYr, [
        MYr,
        vYr,
        SYr,
        HYr,
        e("path", {
          d: "M248,40H219.3a7.9,7.9,0,0,0-5.6,2.3L184,72,55.3,93.4A8,8,0,0,0,51,107l98,98a8,8,0,0,0,13.6-4.3L184,72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, AYr)
      ])) : o(i) === "regular" ? (s(), r("g", VYr, [
        zYr,
        ZYr,
        CYr,
        bYr,
        e("path", {
          d: "M248,40H219.3a7.9,7.9,0,0,0-5.6,2.3L184,72,55.3,93.4A8,8,0,0,0,51,107l98,98a8,8,0,0,0,13.6-4.3L184,72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LYr)
      ])) : g("", !0)
    ], 16, sYr));
  }
}), PYr = ["width", "height", "fill", "transform"], WYr = { key: 0 }, NYr = ["stroke"], FYr = ["stroke"], TYr = ["stroke"], DYr = ["stroke"], RYr = ["stroke"], UYr = { key: 1 }, qYr = ["stroke"], GYr = ["stroke"], EYr = ["stroke"], OYr = ["stroke"], IYr = ["stroke"], KYr = { key: 2 }, XYr = /* @__PURE__ */ e("path", { d: "M237.7,178.3a8.1,8.1,0,0,1,0,11.4l-24,24A8.3,8.3,0,0,1,208,216a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,200,208V192a72.2,72.2,0,0,1-57.7-30.2l-41.7-58.3A56.1,56.1,0,0,0,55.1,80H32a8,8,0,0,1,0-16H55.1a72.2,72.2,0,0,1,58.6,30.2l41.7,58.3A55.9,55.9,0,0,0,200,176V160a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7ZM143,107a8,8,0,0,0,11.2-1.9l1.2-1.6A55.9,55.9,0,0,1,200,80V96a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l24-24a8.1,8.1,0,0,0,0-11.4l-24-24a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,200,48V64a72.2,72.2,0,0,0-57.7,30.2l-1.1,1.6A8,8,0,0,0,143,107Zm-30,42a8,8,0,0,0-11.2,1.9l-1.2,1.6A56.1,56.1,0,0,1,55.1,176H32a8,8,0,0,0,0,16H55.1a72.2,72.2,0,0,0,58.6-30.2l1.1-1.6A8,8,0,0,0,113,149Z" }, null, -1), JYr = [
  XYr
], QYr = { key: 3 }, YYr = ["stroke"], ooi = ["stroke"], eoi = ["stroke"], toi = ["stroke"], noi = ["stroke"], soi = { key: 4 }, roi = ["stroke"], ioi = ["stroke"], loi = ["stroke"], doi = ["stroke"], koi = ["stroke"], coi = { key: 5 }, hoi = ["stroke"], uoi = ["stroke"], aoi = ["stroke"], _oi = ["stroke"], poi = ["stroke"], yoi = {
  name: "PhShuffle"
}, qol = /* @__PURE__ */ $({
  ...yoi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", WYr, [
        e("path", {
          d: "M32,72H55.1a64,64,0,0,1,52,26.8l41.8,58.4a64,64,0,0,0,52,26.8H232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NYr),
        e("polyline", {
          points: "208 48 232 72 208 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FYr),
        e("polyline", {
          points: "208 160 232 184 208 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TYr),
        e("path", {
          d: "M152.8,93.9A63.7,63.7,0,0,1,200.9,72H232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DYr),
        e("path", {
          d: "M32,184H55.1a63.7,63.7,0,0,0,48.1-21.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RYr)
      ])) : o(i) === "duotone" ? (s(), r("g", UYr, [
        e("path", {
          d: "M32,72H55.1a64,64,0,0,1,52,26.8l41.8,58.4a64,64,0,0,0,52,26.8H232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qYr),
        e("polyline", {
          points: "208 48 232 72 208 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GYr),
        e("polyline", {
          points: "208 160 232 184 208 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EYr),
        e("path", {
          d: "M147.7,100.5l1.2-1.7a64,64,0,0,1,52-26.8H232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OYr),
        e("path", {
          d: "M32,184H55.1a64,64,0,0,0,52-26.8l1.2-1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IYr)
      ])) : o(i) === "fill" ? (s(), r("g", KYr, JYr)) : o(i) === "light" ? (s(), r("g", QYr, [
        e("path", {
          d: "M32,72H55.1a64,64,0,0,1,52,26.8l41.8,58.4a64,64,0,0,0,52,26.8H232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YYr),
        e("polyline", {
          points: "208 48 232 72 208 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ooi),
        e("polyline", {
          points: "208 160 232 184 208 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eoi),
        e("path", {
          d: "M147.7,100.5l1.2-1.7a64,64,0,0,1,52-26.8H232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, toi),
        e("path", {
          d: "M32,184H55.1a64,64,0,0,0,52-26.8l1.2-1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, noi)
      ])) : o(i) === "thin" ? (s(), r("g", soi, [
        e("path", {
          d: "M32,72H55.1a64,64,0,0,1,52,26.8l41.8,58.4a64,64,0,0,0,52,26.8H232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, roi),
        e("polyline", {
          points: "208 48 232 72 208 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ioi),
        e("polyline", {
          points: "208 160 232 184 208 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, loi),
        e("path", {
          d: "M147.7,100.5l1.2-1.7a64,64,0,0,1,52-26.8H232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, doi),
        e("path", {
          d: "M32,184H55.1a64,64,0,0,0,52-26.8l1.2-1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, koi)
      ])) : o(i) === "regular" ? (s(), r("g", coi, [
        e("path", {
          d: "M32,72H55.1a64,64,0,0,1,52,26.8l41.8,58.4a64,64,0,0,0,52,26.8H232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hoi),
        e("polyline", {
          points: "208 48 232 72 208 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uoi),
        e("polyline", {
          points: "208 160 232 184 208 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aoi),
        e("path", {
          d: "M147.7,100.5l1.2-1.7a64,64,0,0,1,52-26.8H232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _oi),
        e("path", {
          d: "M32,184H55.1a64,64,0,0,0,52-26.8l1.2-1.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, poi)
      ])) : g("", !0)
    ], 16, PYr));
  }
}), $oi = ["width", "height", "fill", "transform"], woi = { key: 0 }, foi = ["stroke"], goi = ["stroke"], xoi = ["stroke"], joi = ["stroke"], moi = ["stroke"], Moi = { key: 1 }, voi = ["stroke"], Soi = ["stroke"], Hoi = ["stroke"], Aoi = ["stroke"], Voi = ["stroke"], zoi = { key: 2 }, Zoi = /* @__PURE__ */ e("path", { d: "M237.7,178.3a8.1,8.1,0,0,1,0,11.4l-24,24A8.3,8.3,0,0,1,208,216a8.5,8.5,0,0,1-3.1-.6A8,8,0,0,1,200,208V192H172.1a16.1,16.1,0,0,1-13-6.7L83.9,80H32a8,8,0,0,1,0-16H83.9a16.1,16.1,0,0,1,13,6.7L172.1,176H200V160a8,8,0,0,1,4.9-7.4,8.4,8.4,0,0,1,8.8,1.7ZM143,107a8,8,0,0,0,11.2-1.9L172.1,80H200V96a8,8,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l24-24a8.1,8.1,0,0,0,0-11.4l-24-24a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,200,48V64H172.1a16.1,16.1,0,0,0-13,6.7L141.2,95.8A8,8,0,0,0,143,107Zm-30,42a8,8,0,0,0-11.2,1.9L83.9,176H32a8,8,0,0,0,0,16H83.9a16.1,16.1,0,0,0,13-6.7l17.9-25.1A8,8,0,0,0,113,149Z" }, null, -1), Coi = [
  Zoi
], boi = { key: 3 }, Loi = ["stroke"], Boi = ["stroke"], Poi = ["stroke"], Woi = ["stroke"], Noi = ["stroke"], Foi = { key: 4 }, Toi = ["stroke"], Doi = ["stroke"], Roi = ["stroke"], Uoi = ["stroke"], qoi = ["stroke"], Goi = { key: 5 }, Eoi = ["stroke"], Ooi = ["stroke"], Ioi = ["stroke"], Koi = ["stroke"], Xoi = ["stroke"], Joi = {
  name: "PhShuffleAngular"
}, Gol = /* @__PURE__ */ $({
  ...Joi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", woi, [
        e("path", {
          d: "M32,72H83.9a7.8,7.8,0,0,1,6.5,3.4l75.2,105.2a7.8,7.8,0,0,0,6.5,3.4H232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, foi),
        e("polyline", {
          points: "208 48 232 72 208 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, goi),
        e("polyline", {
          points: "208 160 232 184 208 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xoi),
        e("path", {
          d: "M32,184H83.9a7.8,7.8,0,0,0,6.5-3.4l13-18.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, joi),
        e("path", {
          d: "M152.6,93.6l13-18.2a7.8,7.8,0,0,1,6.5-3.4H232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, moi)
      ])) : o(i) === "duotone" ? (s(), r("g", Moi, [
        e("path", {
          d: "M32,72H83.9a7.8,7.8,0,0,1,6.5,3.4l75.2,105.2a7.8,7.8,0,0,0,6.5,3.4H232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, voi),
        e("polyline", {
          points: "208 48 232 72 208 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Soi),
        e("polyline", {
          points: "208 160 232 184 208 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hoi),
        e("path", {
          d: "M147.7,100.5l17.9-25.1a7.8,7.8,0,0,1,6.5-3.4H232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Aoi),
        e("path", {
          d: "M32,184H83.9a7.8,7.8,0,0,0,6.5-3.4l17.9-25.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Voi)
      ])) : o(i) === "fill" ? (s(), r("g", zoi, Coi)) : o(i) === "light" ? (s(), r("g", boi, [
        e("path", {
          d: "M32,72H83.9a7.8,7.8,0,0,1,6.5,3.4l75.2,105.2a7.8,7.8,0,0,0,6.5,3.4H232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Loi),
        e("polyline", {
          points: "208 48 232 72 208 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Boi),
        e("polyline", {
          points: "208 160 232 184 208 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Poi),
        e("path", {
          d: "M147.7,100.5l17.9-25.1a7.8,7.8,0,0,1,6.5-3.4H232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Woi),
        e("path", {
          d: "M32,184H83.9a7.8,7.8,0,0,0,6.5-3.4l17.9-25.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Noi)
      ])) : o(i) === "thin" ? (s(), r("g", Foi, [
        e("path", {
          d: "M32,72H83.9a7.8,7.8,0,0,1,6.5,3.4l75.2,105.2a7.8,7.8,0,0,0,6.5,3.4H232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Toi),
        e("polyline", {
          points: "208 48 232 72 208 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Doi),
        e("polyline", {
          points: "208 160 232 184 208 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Roi),
        e("path", {
          d: "M147.7,100.5l17.9-25.1a7.8,7.8,0,0,1,6.5-3.4H232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Uoi),
        e("path", {
          d: "M32,184H83.9a7.8,7.8,0,0,0,6.5-3.4l17.9-25.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qoi)
      ])) : o(i) === "regular" ? (s(), r("g", Goi, [
        e("path", {
          d: "M32,72H83.9a7.8,7.8,0,0,1,6.5,3.4l75.2,105.2a7.8,7.8,0,0,0,6.5,3.4H232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Eoi),
        e("polyline", {
          points: "208 48 232 72 208 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ooi),
        e("polyline", {
          points: "208 160 232 184 208 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ioi),
        e("path", {
          d: "M147.7,100.5l17.9-25.1a7.8,7.8,0,0,1,6.5-3.4H232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Koi),
        e("path", {
          d: "M32,184H83.9a7.8,7.8,0,0,0,6.5-3.4l17.9-25.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xoi)
      ])) : g("", !0)
    ], 16, $oi));
  }
}), Qoi = ["width", "height", "fill", "transform"], Yoi = { key: 0 }, oei = ["stroke"], eei = ["stroke"], tei = ["stroke"], nei = ["stroke"], sei = ["stroke"], rei = { key: 1 }, iei = ["stroke"], lei = ["stroke"], dei = ["stroke"], kei = ["stroke"], cei = ["stroke"], hei = { key: 2 }, uei = /* @__PURE__ */ e("path", { d: "M216,48V88a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3L188,79.3,156.3,111a8,8,0,0,1-5.7,2.4A7.7,7.7,0,0,1,145,111a7.9,7.9,0,0,1,0-11.3L176.7,68,162.3,53.7a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,168,40h40A8,8,0,0,1,216,48Zm-4.9,112.6a8.4,8.4,0,0,0-8.8,1.7L188,176.7,53.7,42.3A8.1,8.1,0,0,0,42.3,53.7L176.7,188l-14.4,14.3a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,168,216h40a8,8,0,0,0,8-8V168A8,8,0,0,0,211.1,160.6ZM99.7,145,42.3,202.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L111,156.3A8,8,0,0,0,99.7,145Z" }, null, -1), aei = [
  uei
], _ei = { key: 3 }, pei = ["stroke"], yei = ["stroke"], $ei = ["stroke"], wei = ["stroke"], fei = ["stroke"], gei = { key: 4 }, xei = ["stroke"], jei = ["stroke"], mei = ["stroke"], Mei = ["stroke"], vei = ["stroke"], Sei = { key: 5 }, Hei = ["stroke"], Aei = ["stroke"], Vei = ["stroke"], zei = ["stroke"], Zei = ["stroke"], Cei = {
  name: "PhShuffleSimple"
}, Eol = /* @__PURE__ */ $({
  ...Cei,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Yoi, [
        e("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oei),
        e("polyline", {
          points: "208 168 208 208 168 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eei),
        e("line", {
          x1: "48",
          y1: "48",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tei),
        e("line", {
          x1: "156.3",
          y1: "99.7",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nei),
        e("line", {
          x1: "48",
          y1: "208",
          x2: "99.7",
          y2: "156.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sei)
      ])) : o(i) === "duotone" ? (s(), r("g", rei, [
        e("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iei),
        e("polyline", {
          points: "208 168 208 208 168 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lei),
        e("line", {
          x1: "48",
          y1: "48",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dei),
        e("line", {
          x1: "150.6",
          y1: "105.4",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kei),
        e("line", {
          x1: "48",
          y1: "208",
          x2: "105.4",
          y2: "150.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cei)
      ])) : o(i) === "fill" ? (s(), r("g", hei, aei)) : o(i) === "light" ? (s(), r("g", _ei, [
        e("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pei),
        e("polyline", {
          points: "208 168 208 208 168 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yei),
        e("line", {
          x1: "48",
          y1: "48",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $ei),
        e("line", {
          x1: "150.6",
          y1: "105.4",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wei),
        e("line", {
          x1: "48",
          y1: "208",
          x2: "105.4",
          y2: "150.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fei)
      ])) : o(i) === "thin" ? (s(), r("g", gei, [
        e("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xei),
        e("polyline", {
          points: "208 168 208 208 168 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jei),
        e("line", {
          x1: "48",
          y1: "48",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mei),
        e("line", {
          x1: "150.6",
          y1: "105.4",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Mei),
        e("line", {
          x1: "48",
          y1: "208",
          x2: "105.4",
          y2: "150.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vei)
      ])) : o(i) === "regular" ? (s(), r("g", Sei, [
        e("polyline", {
          points: "168 48 208 48 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hei),
        e("polyline", {
          points: "208 168 208 208 168 208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Aei),
        e("line", {
          x1: "48",
          y1: "48",
          x2: "208",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vei),
        e("line", {
          x1: "150.6",
          y1: "105.4",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zei),
        e("line", {
          x1: "48",
          y1: "208",
          x2: "105.4",
          y2: "150.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zei)
      ])) : g("", !0)
    ], 16, Qoi));
  }
}), bei = ["width", "height", "fill", "transform"], Lei = { key: 0 }, Bei = ["stroke"], Pei = ["stroke"], Wei = ["stroke"], Nei = ["stroke"], Fei = { key: 1 }, Tei = /* @__PURE__ */ e("path", {
  d: "M40,208a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H88V208Z",
  opacity: "0.2"
}, null, -1), Dei = ["stroke"], Rei = ["stroke"], Uei = ["stroke"], qei = ["stroke"], Gei = ["stroke"], Eei = { key: 2 }, Oei = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM64,152H48a8,8,0,0,1,0-16H64a8,8,0,0,1,0,16Zm0-32H48a8,8,0,0,1,0-16H64a8,8,0,0,1,0,16Zm0-32H48a8,8,0,0,1,0-16H64a8,8,0,0,1,0,16ZM216,200H88V56H216V200Z" }, null, -1), Iei = [
  Oei
], Kei = { key: 3 }, Xei = ["stroke"], Jei = ["stroke"], Qei = ["stroke"], Yei = ["stroke"], oti = ["stroke"], eti = { key: 4 }, tti = ["stroke"], nti = ["stroke"], sti = ["stroke"], rti = ["stroke"], iti = ["stroke"], lti = { key: 5 }, dti = ["stroke"], kti = ["stroke"], cti = ["stroke"], hti = ["stroke"], uti = ["stroke"], ati = {
  name: "PhSidebar"
}, Ool = /* @__PURE__ */ $({
  ...ati,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Lei, [
        e("line", {
          x1: "88",
          y1: "48",
          x2: "88",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bei),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pei),
        e("line", {
          x1: "32",
          y1: "88",
          x2: "88",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wei),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "88",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nei)
      ])) : o(i) === "duotone" ? (s(), r("g", Fei, [
        Tei,
        e("line", {
          x1: "88",
          y1: "48",
          x2: "88",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dei),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rei),
        e("line", {
          x1: "32",
          y1: "80",
          x2: "56",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uei),
        e("line", {
          x1: "32",
          y1: "112",
          x2: "56",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qei),
        e("line", {
          x1: "32",
          y1: "144",
          x2: "56",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gei)
      ])) : o(i) === "fill" ? (s(), r("g", Eei, Iei)) : o(i) === "light" ? (s(), r("g", Kei, [
        e("line", {
          x1: "88",
          y1: "48",
          x2: "88",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xei),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jei),
        e("line", {
          x1: "32",
          y1: "80",
          x2: "56",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qei),
        e("line", {
          x1: "32",
          y1: "112",
          x2: "56",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Yei),
        e("line", {
          x1: "32",
          y1: "144",
          x2: "56",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oti)
      ])) : o(i) === "thin" ? (s(), r("g", eti, [
        e("line", {
          x1: "88",
          y1: "48",
          x2: "88",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tti),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nti),
        e("line", {
          x1: "32",
          y1: "80",
          x2: "56",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sti),
        e("line", {
          x1: "32",
          y1: "112",
          x2: "56",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rti),
        e("line", {
          x1: "32",
          y1: "144",
          x2: "56",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iti)
      ])) : o(i) === "regular" ? (s(), r("g", lti, [
        e("line", {
          x1: "88",
          y1: "48",
          x2: "88",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dti),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kti),
        e("line", {
          x1: "32",
          y1: "80",
          x2: "56",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cti),
        e("line", {
          x1: "32",
          y1: "112",
          x2: "56",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hti),
        e("line", {
          x1: "32",
          y1: "144",
          x2: "56",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uti)
      ])) : g("", !0)
    ], 16, bei));
  }
}), _ti = ["width", "height", "fill", "transform"], pti = { key: 0 }, yti = ["stroke"], $ti = ["stroke"], wti = { key: 1 }, fti = /* @__PURE__ */ e("path", {
  d: "M40,208a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8H88V208Z",
  opacity: "0.2"
}, null, -1), gti = ["stroke"], xti = ["stroke"], jti = { key: 2 }, mti = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H88V56H216V200Z" }, null, -1), Mti = [
  mti
], vti = { key: 3 }, Sti = ["stroke"], Hti = ["stroke"], Ati = { key: 4 }, Vti = ["stroke"], zti = ["stroke"], Zti = { key: 5 }, Cti = ["stroke"], bti = ["stroke"], Lti = {
  name: "PhSidebarSimple"
}, Iol = /* @__PURE__ */ $({
  ...Lti,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", pti, [
        e("line", {
          x1: "88",
          y1: "48",
          x2: "88",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yti),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $ti)
      ])) : o(i) === "duotone" ? (s(), r("g", wti, [
        fti,
        e("line", {
          x1: "88",
          y1: "48",
          x2: "88",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gti),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xti)
      ])) : o(i) === "fill" ? (s(), r("g", jti, Mti)) : o(i) === "light" ? (s(), r("g", vti, [
        e("line", {
          x1: "88",
          y1: "48",
          x2: "88",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Sti),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hti)
      ])) : o(i) === "thin" ? (s(), r("g", Ati, [
        e("line", {
          x1: "88",
          y1: "48",
          x2: "88",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vti),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zti)
      ])) : o(i) === "regular" ? (s(), r("g", Zti, [
        e("line", {
          x1: "88",
          y1: "48",
          x2: "88",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cti),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bti)
      ])) : g("", !0)
    ], 16, _ti));
  }
}), Bti = ["width", "height", "fill", "transform"], Pti = { key: 0 }, Wti = ["stroke"], Nti = ["stroke"], Fti = ["stroke"], Tti = { key: 1 }, Dti = ["stroke"], Rti = ["stroke"], Uti = ["stroke"], qti = { key: 2 }, Gti = /* @__PURE__ */ e("path", { d: "M141.7,133.7l-42,42A8.3,8.3,0,0,1,94,178a7.7,7.7,0,0,1-3-.6,8,8,0,0,1-5-7.4V136H24a8,8,0,0,1,0-16H86V86a8,8,0,0,1,5-7.4,8.2,8.2,0,0,1,8.7,1.7l42,42A8.1,8.1,0,0,1,141.7,133.7ZM192,32H136a8,8,0,0,0,0,16h56V208H136a8,8,0,0,0,0,16h56a16,16,0,0,0,16-16V48A16,16,0,0,0,192,32Z" }, null, -1), Eti = [
  Gti
], Oti = { key: 3 }, Iti = ["stroke"], Kti = ["stroke"], Xti = ["stroke"], Jti = { key: 4 }, Qti = ["stroke"], Yti = ["stroke"], oni = ["stroke"], eni = { key: 5 }, tni = ["stroke"], nni = ["stroke"], sni = ["stroke"], rni = {
  name: "PhSignIn"
}, Kol = /* @__PURE__ */ $({
  ...rni,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Pti, [
        e("polyline", {
          points: "94 170 136 128 94 86",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wti),
        e("line", {
          x1: "24",
          y1: "128",
          x2: "136",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nti),
        e("path", {
          d: "M136,40h56a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fti)
      ])) : o(i) === "duotone" ? (s(), r("g", Tti, [
        e("polyline", {
          points: "94 170 136 128 94 86",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dti),
        e("line", {
          x1: "24",
          y1: "128",
          x2: "136",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rti),
        e("path", {
          d: "M136,40h56a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uti)
      ])) : o(i) === "fill" ? (s(), r("g", qti, Eti)) : o(i) === "light" ? (s(), r("g", Oti, [
        e("polyline", {
          points: "94 170 136 128 94 86",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Iti),
        e("line", {
          x1: "24",
          y1: "128",
          x2: "136",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kti),
        e("path", {
          d: "M136,40h56a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xti)
      ])) : o(i) === "thin" ? (s(), r("g", Jti, [
        e("polyline", {
          points: "94 170 136 128 94 86",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qti),
        e("line", {
          x1: "24",
          y1: "128",
          x2: "136",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Yti),
        e("path", {
          d: "M136,40h56a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oni)
      ])) : o(i) === "regular" ? (s(), r("g", eni, [
        e("polyline", {
          points: "94 170 136 128 94 86",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tni),
        e("line", {
          x1: "24",
          y1: "128",
          x2: "136",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nni),
        e("path", {
          d: "M136,40h56a8,8,0,0,1,8,8V208a8,8,0,0,1-8,8H136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sni)
      ])) : g("", !0)
    ], 16, Bti));
  }
}), ini = ["width", "height", "fill", "transform"], lni = { key: 0 }, dni = ["stroke"], kni = ["stroke"], cni = ["stroke"], hni = { key: 1 }, uni = ["stroke"], ani = ["stroke"], _ni = ["stroke"], pni = { key: 2 }, yni = /* @__PURE__ */ e("path", { d: "M221.7,133.7l-42,42A8.3,8.3,0,0,1,174,178a7.7,7.7,0,0,1-3-.6,8,8,0,0,1-5-7.4V136H104a8,8,0,0,1,0-16h62V86a8,8,0,0,1,5-7.4,8.2,8.2,0,0,1,8.7,1.7l42,42A8.1,8.1,0,0,1,221.7,133.7ZM104,208H48V48h56a8,8,0,0,0,0-16H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16h56a8,8,0,0,0,0-16Z" }, null, -1), $ni = [
  yni
], wni = { key: 3 }, fni = ["stroke"], gni = ["stroke"], xni = ["stroke"], jni = { key: 4 }, mni = ["stroke"], Mni = ["stroke"], vni = ["stroke"], Sni = { key: 5 }, Hni = ["stroke"], Ani = ["stroke"], Vni = ["stroke"], zni = {
  name: "PhSignOut"
}, Xol = /* @__PURE__ */ $({
  ...zni,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", lni, [
        e("polyline", {
          points: "174 86 216 128 174 170",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dni),
        e("line", {
          x1: "104",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kni),
        e("path", {
          d: "M104,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cni)
      ])) : o(i) === "duotone" ? (s(), r("g", hni, [
        e("polyline", {
          points: "174 86 216 128 174 170",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uni),
        e("line", {
          x1: "104",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ani),
        e("path", {
          d: "M104,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _ni)
      ])) : o(i) === "fill" ? (s(), r("g", pni, $ni)) : o(i) === "light" ? (s(), r("g", wni, [
        e("polyline", {
          points: "174 86 216 128 174 170",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fni),
        e("line", {
          x1: "104",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gni),
        e("path", {
          d: "M104,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xni)
      ])) : o(i) === "thin" ? (s(), r("g", jni, [
        e("polyline", {
          points: "174 86 216 128 174 170",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mni),
        e("line", {
          x1: "104",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Mni),
        e("path", {
          d: "M104,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vni)
      ])) : o(i) === "regular" ? (s(), r("g", Sni, [
        e("polyline", {
          points: "174 86 216 128 174 170",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hni),
        e("line", {
          x1: "104",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ani),
        e("path", {
          d: "M104,216H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8h56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vni)
      ])) : g("", !0)
    ], 16, ini));
  }
}), Zni = ["width", "height", "fill", "transform"], Cni = { key: 0 }, bni = ["stroke"], Lni = ["stroke"], Bni = ["stroke"], Pni = { key: 1 }, Wni = ["stroke"], Nni = /* @__PURE__ */ e("path", {
  d: "M204,152H40a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H204l36,40Z",
  opacity: "0.2"
}, null, -1), Fni = ["stroke"], Tni = ["stroke"], Dni = { key: 2 }, Rni = /* @__PURE__ */ e("path", { d: "M245.9,117.4l-36,40A8.1,8.1,0,0,1,204,160H136v64a8,8,0,0,1-16,0V160H40a16,16,0,0,1-16-16V80A16,16,0,0,1,40,64h80V32a8,8,0,0,1,16,0V64h68a8.1,8.1,0,0,1,5.9,2.6l36,40A8,8,0,0,1,245.9,117.4Z" }, null, -1), Uni = [
  Rni
], qni = { key: 3 }, Gni = ["stroke"], Eni = ["stroke"], Oni = ["stroke"], Ini = { key: 4 }, Kni = ["stroke"], Xni = ["stroke"], Jni = ["stroke"], Qni = { key: 5 }, Yni = ["stroke"], osi = ["stroke"], esi = ["stroke"], tsi = {
  name: "PhSignpost"
}, Jol = /* @__PURE__ */ $({
  ...tsi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Cni, [
        e("path", {
          d: "M204,152H40a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H204l36,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bni),
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lni),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bni)
      ])) : o(i) === "duotone" ? (s(), r("g", Pni, [
        e("path", {
          d: "M204,152H40a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H204l36,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wni),
        Nni,
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fni),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tni)
      ])) : o(i) === "fill" ? (s(), r("g", Dni, Uni)) : o(i) === "light" ? (s(), r("g", qni, [
        e("path", {
          d: "M204,152H40a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H204l36,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gni),
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Eni),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Oni)
      ])) : o(i) === "thin" ? (s(), r("g", Ini, [
        e("path", {
          d: "M204,152H40a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H204l36,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kni),
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xni),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jni)
      ])) : o(i) === "regular" ? (s(), r("g", Qni, [
        e("path", {
          d: "M204,152H40a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8H204l36,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yni),
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, osi),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, esi)
      ])) : g("", !0)
    ], 16, Zni));
  }
}), nsi = ["width", "height", "fill", "transform"], ssi = { key: 0 }, rsi = ["stroke"], isi = ["stroke"], lsi = ["stroke"], dsi = { key: 1 }, ksi = /* @__PURE__ */ e("rect", {
  x: "80",
  y: "120",
  width: "96",
  height: "72",
  opacity: "0.2"
}, null, -1), csi = ["stroke"], hsi = ["stroke"], usi = ["stroke"], asi = ["stroke"], _si = { key: 2 }, psi = /* @__PURE__ */ e("path", { d: "M213.7,82.3l-56-56A8.1,8.1,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8.1,8.1,0,0,0,213.7,82.3ZM200,216H56V40h92.7L200,91.3V216Z" }, null, -1), ysi = /* @__PURE__ */ e("path", { d: "M176,112H80a8,8,0,0,0-8,8v72a8,8,0,0,0,8,8h96a8,8,0,0,0,8-8V120A8,8,0,0,0,176,112Zm-56,64a8,8,0,0,1-16,0V136a8,8,0,0,1,16,0Zm32,0a8,8,0,0,1-16,0V136a8,8,0,0,1,16,0Z" }, null, -1), $si = [
  psi,
  ysi
], wsi = { key: 3 }, fsi = ["stroke"], gsi = ["stroke"], xsi = ["stroke"], jsi = ["stroke"], msi = { key: 4 }, Msi = ["stroke"], vsi = ["stroke"], Ssi = ["stroke"], Hsi = ["stroke"], Asi = { key: 5 }, Vsi = ["stroke"], zsi = ["stroke"], Zsi = ["stroke"], Csi = ["stroke"], bsi = {
  name: "PhSimCard"
}, Qol = /* @__PURE__ */ $({
  ...bsi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ssi, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rsi),
        e("rect", {
          x: "88",
          y: "124",
          width: "80",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, isi),
        e("line", {
          x1: "128",
          y1: "164",
          x2: "128",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lsi)
      ])) : o(i) === "duotone" ? (s(), r("g", dsi, [
        ksi,
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, csi),
        e("rect", {
          x: "80",
          y: "120",
          width: "96",
          height: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hsi),
        e("line", {
          x1: "112",
          y1: "152",
          x2: "112",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, usi),
        e("line", {
          x1: "144",
          y1: "152",
          x2: "144",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, asi)
      ])) : o(i) === "fill" ? (s(), r("g", _si, $si)) : o(i) === "light" ? (s(), r("g", wsi, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fsi),
        e("rect", {
          x: "80",
          y: "120",
          width: "96",
          height: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gsi),
        e("line", {
          x1: "112",
          y1: "152",
          x2: "112",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xsi),
        e("line", {
          x1: "144",
          y1: "152",
          x2: "144",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jsi)
      ])) : o(i) === "thin" ? (s(), r("g", msi, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Msi),
        e("rect", {
          x: "80",
          y: "120",
          width: "96",
          height: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vsi),
        e("line", {
          x1: "112",
          y1: "152",
          x2: "112",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ssi),
        e("line", {
          x1: "144",
          y1: "152",
          x2: "144",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hsi)
      ])) : o(i) === "regular" ? (s(), r("g", Asi, [
        e("path", {
          d: "M200,224H56a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h96l56,56V216A8,8,0,0,1,200,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vsi),
        e("rect", {
          x: "80",
          y: "120",
          width: "96",
          height: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zsi),
        e("line", {
          x1: "112",
          y1: "152",
          x2: "112",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zsi),
        e("line", {
          x1: "144",
          y1: "152",
          x2: "144",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Csi)
      ])) : g("", !0)
    ], 16, nsi));
  }
}), Lsi = ["width", "height", "fill", "transform"], Bsi = { key: 0 }, Psi = ["stroke"], Wsi = ["stroke"], Nsi = ["stroke"], Fsi = { key: 1 }, Tsi = /* @__PURE__ */ e("polygon", {
  points: "184 40 128 40 78.9 104 128 224 240 104 184 40",
  opacity: "0.2"
}, null, -1), Dsi = ["stroke"], Rsi = ["stroke"], Usi = ["stroke"], qsi = { key: 2 }, Gsi = /* @__PURE__ */ e("path", { d: "M246,98.7l-56-64a8,8,0,0,0-6-2.7H72a8,8,0,0,0-6,2.7l-56,64a8.1,8.1,0,0,0,.2,10.8l112,120a8,8,0,0,0,11.6,0l112-120A8.1,8.1,0,0,0,246,98.7ZM222.4,96H181L144.2,48h36.2ZM73.5,112l30.6,74.6L34.4,112Zm109,0h39.1l-69.7,74.6ZM75.6,48h36.2L75,96H33.6Z" }, null, -1), Esi = [
  Gsi
], Osi = { key: 3 }, Isi = ["stroke"], Ksi = ["stroke"], Xsi = ["stroke"], Jsi = { key: 4 }, Qsi = ["stroke"], Ysi = ["stroke"], ori = ["stroke"], eri = { key: 5 }, tri = ["stroke"], nri = ["stroke"], sri = ["stroke"], rri = {
  name: "PhSketchLogo"
}, Yol = /* @__PURE__ */ $({
  ...rri,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Bsi, [
        e("polygon", {
          points: "72 40 184 40 240 104 128 224 16 104 72 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Psi),
        e("polygon", {
          points: "177.1 104 128 224 78.9 104 128 40 177.1 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wsi),
        e("line", {
          x1: "16",
          y1: "104",
          x2: "240",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nsi)
      ])) : o(i) === "duotone" ? (s(), r("g", Fsi, [
        Tsi,
        e("polygon", {
          points: "72 40 184 40 240 104 128 224 16 104 72 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dsi),
        e("polygon", {
          points: "177.1 104 128 224 78.9 104 128 40 177.1 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rsi),
        e("line", {
          x1: "16",
          y1: "104",
          x2: "240",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Usi)
      ])) : o(i) === "fill" ? (s(), r("g", qsi, Esi)) : o(i) === "light" ? (s(), r("g", Osi, [
        e("polygon", {
          points: "72 40 184 40 240 104 128 224 16 104 72 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Isi),
        e("polygon", {
          points: "177.1 104 128 224 78.9 104 128 40 177.1 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ksi),
        e("line", {
          x1: "16",
          y1: "104",
          x2: "240",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xsi)
      ])) : o(i) === "thin" ? (s(), r("g", Jsi, [
        e("polygon", {
          points: "72 40 184 40 240 104 128 224 16 104 72 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qsi),
        e("polygon", {
          points: "177.1 104 128 224 78.9 104 128 40 177.1 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ysi),
        e("line", {
          x1: "16",
          y1: "104",
          x2: "240",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ori)
      ])) : o(i) === "regular" ? (s(), r("g", eri, [
        e("polygon", {
          points: "72 40 184 40 240 104 128 224 16 104 72 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tri),
        e("polygon", {
          points: "177.1 104 128 224 78.9 104 128 40 177.1 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nri),
        e("line", {
          x1: "16",
          y1: "104",
          x2: "240",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sri)
      ])) : g("", !0)
    ], 16, Lsi));
  }
}), iri = ["width", "height", "fill", "transform"], lri = { key: 0 }, dri = ["stroke"], kri = ["stroke"], cri = { key: 1 }, hri = /* @__PURE__ */ e("path", {
  d: "M67.2,121.2,187.8,47.4A8,8,0,0,1,200,54.3V201.7a8,8,0,0,1-12.2,6.9L67.2,134.8A8,8,0,0,1,67.2,121.2Z",
  opacity: "0.2"
}, null, -1), uri = ["stroke"], ari = ["stroke"], _ri = { key: 2 }, pri = /* @__PURE__ */ e("path", { d: "M56,32a8,8,0,0,1,8,8v73.7L183.7,40.6A16,16,0,0,1,208,54.3V201.7a15.9,15.9,0,0,1-8.2,14,15.4,15.4,0,0,1-7.8,2,16.2,16.2,0,0,1-8.3-2.3L64,142.3V216a8,8,0,0,1-16,0V40A8,8,0,0,1,56,32Z" }, null, -1), yri = [
  pri
], $ri = { key: 3 }, wri = ["stroke"], fri = ["stroke"], gri = { key: 4 }, xri = ["stroke"], jri = ["stroke"], mri = { key: 5 }, Mri = ["stroke"], vri = ["stroke"], Sri = {
  name: "PhSkipBack"
}, oel = /* @__PURE__ */ $({
  ...Sri,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", lri, [
        e("path", {
          d: "M67.2,121.2,187.8,47.4A8,8,0,0,1,200,54.3V201.7a8,8,0,0,1-12.2,6.9L67.2,134.8A8,8,0,0,1,67.2,121.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dri),
        e("line", {
          x1: "56",
          y1: "40",
          x2: "56",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kri)
      ])) : o(i) === "duotone" ? (s(), r("g", cri, [
        hri,
        e("path", {
          d: "M67.2,121.2,187.8,47.4A8,8,0,0,1,200,54.3V201.7a8,8,0,0,1-12.2,6.9L67.2,134.8A8,8,0,0,1,67.2,121.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uri),
        e("line", {
          x1: "56",
          y1: "40",
          x2: "56",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ari)
      ])) : o(i) === "fill" ? (s(), r("g", _ri, yri)) : o(i) === "light" ? (s(), r("g", $ri, [
        e("path", {
          d: "M67.2,121.2,187.8,47.4A8,8,0,0,1,200,54.3V201.7a8,8,0,0,1-12.2,6.9L67.2,134.8A8,8,0,0,1,67.2,121.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wri),
        e("line", {
          x1: "56",
          y1: "40",
          x2: "56",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fri)
      ])) : o(i) === "thin" ? (s(), r("g", gri, [
        e("path", {
          d: "M67.2,121.2,187.8,47.4A8,8,0,0,1,200,54.3V201.7a8,8,0,0,1-12.2,6.9L67.2,134.8A8,8,0,0,1,67.2,121.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xri),
        e("line", {
          x1: "56",
          y1: "40",
          x2: "56",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jri)
      ])) : o(i) === "regular" ? (s(), r("g", mri, [
        e("path", {
          d: "M67.2,121.2,187.8,47.4A8,8,0,0,1,200,54.3V201.7a8,8,0,0,1-12.2,6.9L67.2,134.8A8,8,0,0,1,67.2,121.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mri),
        e("line", {
          x1: "56",
          y1: "40",
          x2: "56",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vri)
      ])) : g("", !0)
    ], 16, iri));
  }
}), Hri = ["width", "height", "fill", "transform"], Ari = { key: 0 }, Vri = ["stroke"], zri = ["stroke"], Zri = ["stroke"], Cri = { key: 1 }, bri = /* @__PURE__ */ e("path", {
  d: "M128,32a96,96,0,1,0,96,96A96,96,0,0,0,128,32Zm28,128-48-32,48-32Z",
  opacity: "0.2"
}, null, -1), Lri = ["stroke"], Bri = ["stroke"], Pri = ["stroke"], Wri = { key: 2 }, Nri = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm36,136a8,8,0,0,1-4.2,7.1,8.5,8.5,0,0,1-3.8.9,8.7,8.7,0,0,1-4.4-1.3L108,137.6V160a8,8,0,0,1-16,0V96a8,8,0,0,1,16,0v22.4l43.6-29.1a8.3,8.3,0,0,1,8.2-.4A8,8,0,0,1,164,96Z" }, null, -1), Fri = [
  Nri
], Tri = { key: 3 }, Dri = ["stroke"], Rri = ["stroke"], Uri = ["stroke"], qri = { key: 4 }, Gri = ["stroke"], Eri = ["stroke"], Ori = ["stroke"], Iri = { key: 5 }, Kri = ["stroke"], Xri = ["stroke"], Jri = ["stroke"], Qri = {
  name: "PhSkipBackCircle"
}, eel = /* @__PURE__ */ $({
  ...Qri,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ari, [
        e("polygon", {
          points: "156 156 120 128 156 100 156 156",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vri),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zri),
        e("line", {
          x1: "100",
          y1: "100",
          x2: "100",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zri)
      ])) : o(i) === "duotone" ? (s(), r("g", Cri, [
        bri,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Lri),
        e("polygon", {
          points: "108 128 156 96 156 160 108 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bri),
        e("line", {
          x1: "100",
          y1: "96",
          x2: "100",
          y2: "160",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pri)
      ])) : o(i) === "fill" ? (s(), r("g", Wri, Fri)) : o(i) === "light" ? (s(), r("g", Tri, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dri),
        e("polygon", {
          points: "108 128 156 96 156 160 108 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rri),
        e("line", {
          x1: "100",
          y1: "96",
          x2: "100",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Uri)
      ])) : o(i) === "thin" ? (s(), r("g", qri, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gri),
        e("polygon", {
          points: "108 128 156 96 156 160 108 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Eri),
        e("line", {
          x1: "100",
          y1: "96",
          x2: "100",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ori)
      ])) : o(i) === "regular" ? (s(), r("g", Iri, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Kri),
        e("polygon", {
          points: "108 128 156 96 156 160 108 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xri),
        e("line", {
          x1: "100",
          y1: "96",
          x2: "100",
          y2: "160",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jri)
      ])) : g("", !0)
    ], 16, Hri));
  }
}), Yri = ["width", "height", "fill", "transform"], oii = { key: 0 }, eii = ["stroke"], tii = ["stroke"], nii = { key: 1 }, sii = /* @__PURE__ */ e("path", {
  d: "M188.8,121.2,68.2,47.4A8,8,0,0,0,56,54.3V201.7a8,8,0,0,0,12.2,6.9l120.6-73.8A8,8,0,0,0,188.8,121.2Z",
  opacity: "0.2"
}, null, -1), rii = ["stroke"], iii = ["stroke"], lii = { key: 2 }, dii = /* @__PURE__ */ e("path", { d: "M208,40V216a8,8,0,0,1-16,0V142.3L72.3,215.4a16.2,16.2,0,0,1-8.3,2.3,15.4,15.4,0,0,1-7.8-2,15.9,15.9,0,0,1-8.2-14V54.3A16,16,0,0,1,72.3,40.6L192,113.7V40a8,8,0,0,1,16,0Z" }, null, -1), kii = [
  dii
], cii = { key: 3 }, hii = ["stroke"], uii = ["stroke"], aii = { key: 4 }, _ii = ["stroke"], pii = ["stroke"], yii = { key: 5 }, $ii = ["stroke"], wii = ["stroke"], fii = {
  name: "PhSkipForward"
}, tel = /* @__PURE__ */ $({
  ...fii,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", oii, [
        e("path", {
          d: "M188.8,121.2,68.2,47.4A8,8,0,0,0,56,54.3V201.7a8,8,0,0,0,12.2,6.9l120.6-73.8A8,8,0,0,0,188.8,121.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eii),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tii)
      ])) : o(i) === "duotone" ? (s(), r("g", nii, [
        sii,
        e("path", {
          d: "M188.8,121.2,68.2,47.4A8,8,0,0,0,56,54.3V201.7a8,8,0,0,0,12.2,6.9l120.6-73.8A8,8,0,0,0,188.8,121.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rii),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iii)
      ])) : o(i) === "fill" ? (s(), r("g", lii, kii)) : o(i) === "light" ? (s(), r("g", cii, [
        e("path", {
          d: "M188.8,121.2,68.2,47.4A8,8,0,0,0,56,54.3V201.7a8,8,0,0,0,12.2,6.9l120.6-73.8A8,8,0,0,0,188.8,121.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hii),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uii)
      ])) : o(i) === "thin" ? (s(), r("g", aii, [
        e("path", {
          d: "M188.8,121.2,68.2,47.4A8,8,0,0,0,56,54.3V201.7a8,8,0,0,0,12.2,6.9l120.6-73.8A8,8,0,0,0,188.8,121.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _ii),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pii)
      ])) : o(i) === "regular" ? (s(), r("g", yii, [
        e("path", {
          d: "M188.8,121.2,68.2,47.4A8,8,0,0,0,56,54.3V201.7a8,8,0,0,0,12.2,6.9l120.6-73.8A8,8,0,0,0,188.8,121.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $ii),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wii)
      ])) : g("", !0)
    ], 16, Yri));
  }
}), gii = ["width", "height", "fill", "transform"], xii = { key: 0 }, jii = ["stroke"], mii = ["stroke"], Mii = ["stroke"], vii = { key: 1 }, Sii = /* @__PURE__ */ e("path", {
  d: "M128,32a96,96,0,1,0,96,96A96,96,0,0,0,128,32ZM100,160V96l48,32Z",
  opacity: "0.2"
}, null, -1), Hii = ["stroke"], Aii = ["stroke"], Vii = ["stroke"], zii = { key: 2 }, Zii = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm36,136a8,8,0,0,1-16,0V137.6l-43.6,29.1A8.7,8.7,0,0,1,100,168a8.5,8.5,0,0,1-3.8-.9A8,8,0,0,1,92,160V96a8,8,0,0,1,4.2-7.1,8.3,8.3,0,0,1,8.2.4L148,118.4V96a8,8,0,0,1,16,0Z" }, null, -1), Cii = [
  Zii
], bii = { key: 3 }, Lii = ["stroke"], Bii = ["stroke"], Pii = ["stroke"], Wii = { key: 4 }, Nii = ["stroke"], Fii = ["stroke"], Tii = ["stroke"], Dii = { key: 5 }, Rii = ["stroke"], Uii = ["stroke"], qii = ["stroke"], Gii = {
  name: "PhSkipForwardCircle"
}, nel = /* @__PURE__ */ $({
  ...Gii,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xii, [
        e("polygon", {
          points: "100 156 136 128 100 100 100 156",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jii),
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mii),
        e("line", {
          x1: "156",
          y1: "100",
          x2: "156",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mii)
      ])) : o(i) === "duotone" ? (s(), r("g", vii, [
        Sii,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Hii),
        e("polygon", {
          points: "148 128 100 96 100 160 148 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Aii),
        e("line", {
          x1: "156",
          y1: "96",
          x2: "156",
          y2: "160",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vii)
      ])) : o(i) === "fill" ? (s(), r("g", zii, Cii)) : o(i) === "light" ? (s(), r("g", bii, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lii),
        e("line", {
          x1: "156",
          y1: "96",
          x2: "156",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bii),
        e("polygon", {
          points: "148 128 100 96 100 160 148 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pii)
      ])) : o(i) === "thin" ? (s(), r("g", Wii, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nii),
        e("line", {
          x1: "156",
          y1: "96",
          x2: "156",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fii),
        e("polygon", {
          points: "148 128 100 96 100 160 148 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Tii)
      ])) : o(i) === "regular" ? (s(), r("g", Dii, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Rii),
        e("polygon", {
          points: "148 128 100 96 100 160 148 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uii),
        e("line", {
          x1: "156",
          y1: "96",
          x2: "156",
          y2: "160",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qii)
      ])) : g("", !0)
    ], 16, gii));
  }
}), Eii = ["width", "height", "fill", "transform"], Oii = { key: 0 }, Iii = ["stroke"], Kii = ["stroke"], Xii = ["stroke"], Jii = ["stroke"], Qii = ["stroke"], Yii = { key: 1 }, o1i = /* @__PURE__ */ e("path", {
  d: "M128,24A92,92,0,0,0,80,194.5V216a8,8,0,0,0,8,8h80a8,8,0,0,0,8-8V194.5A92,92,0,0,0,128,24ZM92,152a20,20,0,1,1,20-20A20.1,20.1,0,0,1,92,152Zm72,0a20,20,0,1,1,20-20A20.1,20.1,0,0,1,164,152Z",
  opacity: "0.2"
}, null, -1), e1i = ["stroke"], t1i = ["stroke"], n1i = ["stroke"], s1i = ["stroke"], r1i = ["stroke"], i1i = { key: 2 }, l1i = /* @__PURE__ */ e("path", { d: "M124.1,16.1c-51.6,1.9-93.7,43.6-96,95.3A99.4,99.4,0,0,0,72,198.9V216a16,16,0,0,0,16,16h8a4,4,0,0,0,4-4V204.3a8.2,8.2,0,0,1,7.5-8.3,8,8,0,0,1,8.5,8v24a4,4,0,0,0,4,4h16a4,4,0,0,0,4-4V204.3a8.2,8.2,0,0,1,7.5-8.3,8,8,0,0,1,8.5,8v24a4,4,0,0,0,4,4h8a16,16,0,0,0,16-16V198.9A100,100,0,0,0,124.1,16.1ZM92,152a20,20,0,1,1,20-20A20.1,20.1,0,0,1,92,152Zm72,0a20,20,0,1,1,20-20A20.1,20.1,0,0,1,164,152Z" }, null, -1), d1i = [
  l1i
], k1i = { key: 3 }, c1i = ["stroke"], h1i = ["stroke"], u1i = ["stroke"], a1i = ["stroke"], _1i = ["stroke"], p1i = { key: 4 }, y1i = ["stroke"], $1i = ["stroke"], w1i = ["stroke"], f1i = ["stroke"], g1i = ["stroke"], x1i = { key: 5 }, j1i = ["stroke"], m1i = ["stroke"], M1i = ["stroke"], v1i = ["stroke"], S1i = ["stroke"], H1i = {
  name: "PhSkull"
}, sel = /* @__PURE__ */ $({
  ...H1i,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Oii, [
        e("circle", {
          cx: "92",
          cy: "132",
          r: "12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Iii),
        e("circle", {
          cx: "164",
          cy: "132",
          r: "12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kii),
        e("line", {
          x1: "108",
          y1: "224",
          x2: "108",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xii),
        e("line", {
          x1: "148",
          y1: "224",
          x2: "148",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jii),
        e("path", {
          d: "M180,224H76a8,8,0,0,1-8-8V185.7a92,92,0,0,1-32-69.5C35.9,66.1,76.6,24.7,126.7,24A92,92,0,0,1,188,185.7V216A8,8,0,0,1,180,224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qii)
      ])) : o(i) === "duotone" ? (s(), r("g", Yii, [
        o1i,
        e("circle", {
          cx: "92",
          cy: "132",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e1i),
        e("circle", {
          cx: "164",
          cy: "132",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t1i),
        e("path", {
          d: "M80,194.5a92,92,0,1,1,96,0V216a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n1i),
        e("line", {
          x1: "112",
          y1: "224",
          x2: "112",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s1i),
        e("line", {
          x1: "144",
          y1: "224",
          x2: "144",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r1i)
      ])) : o(i) === "fill" ? (s(), r("g", i1i, d1i)) : o(i) === "light" ? (s(), r("g", k1i, [
        e("circle", {
          cx: "92",
          cy: "132",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, c1i),
        e("circle", {
          cx: "164",
          cy: "132",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, h1i),
        e("path", {
          d: "M80,194.5a92,92,0,1,1,96,0V216a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u1i),
        e("line", {
          x1: "112",
          y1: "224",
          x2: "112",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, a1i),
        e("line", {
          x1: "144",
          y1: "224",
          x2: "144",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _1i)
      ])) : o(i) === "thin" ? (s(), r("g", p1i, [
        e("circle", {
          cx: "92",
          cy: "132",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, y1i),
        e("circle", {
          cx: "164",
          cy: "132",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $1i),
        e("path", {
          d: "M80,194.5a92,92,0,1,1,96,0V216a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, w1i),
        e("line", {
          x1: "112",
          y1: "224",
          x2: "112",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, f1i),
        e("line", {
          x1: "144",
          y1: "224",
          x2: "144",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, g1i)
      ])) : o(i) === "regular" ? (s(), r("g", x1i, [
        e("circle", {
          cx: "92",
          cy: "132",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j1i),
        e("circle", {
          cx: "164",
          cy: "132",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m1i),
        e("path", {
          d: "M80,194.5a92,92,0,1,1,96,0V216a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M1i),
        e("line", {
          x1: "112",
          y1: "224",
          x2: "112",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v1i),
        e("line", {
          x1: "144",
          y1: "224",
          x2: "144",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S1i)
      ])) : g("", !0)
    ], 16, Eii));
  }
}), A1i = ["width", "height", "fill", "transform"], V1i = { key: 0 }, z1i = ["stroke"], Z1i = ["stroke"], C1i = ["stroke"], b1i = ["stroke"], L1i = ["stroke"], B1i = ["stroke"], P1i = ["stroke"], W1i = ["stroke"], N1i = { key: 1 }, F1i = /* @__PURE__ */ e("path", {
  d: "M176,104h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V128a24,24,0,0,1,24-24Z",
  transform: "translate(24 328) rotate(-90)",
  opacity: "0.2"
}, null, -1), T1i = /* @__PURE__ */ e("path", {
  d: "M128,176h24a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24Z",
  opacity: "0.2"
}, null, -1), D1i = /* @__PURE__ */ e("path", {
  d: "M80,56h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V80A24,24,0,0,1,80,56Z",
  transform: "translate(184 24) rotate(90)",
  opacity: "0.2"
}, null, -1), R1i = /* @__PURE__ */ e("path", {
  d: "M128,80H104A23.9,23.9,0,0,1,80,56h0a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24Z",
  opacity: "0.2"
}, null, -1), U1i = ["stroke"], q1i = ["stroke"], G1i = ["stroke"], E1i = ["stroke"], O1i = ["stroke"], I1i = ["stroke"], K1i = ["stroke"], X1i = ["stroke"], J1i = { key: 2 }, Q1i = /* @__PURE__ */ e("path", { d: "M221.1,128A32,32,0,0,0,200,72a32.2,32.2,0,0,0-16,4.3V56a32,32,0,0,0-56-21.1A32,32,0,0,0,72,56a32.2,32.2,0,0,0,4.3,16H56a32,32,0,0,0-21.1,56A32,32,0,0,0,56,184a32.2,32.2,0,0,0,16-4.3V200a32,32,0,0,0,56,21.1A32,32,0,0,0,184,200a32.2,32.2,0,0,0-4.3-16H200a32,32,0,0,0,21.1-56ZM88,56a16,16,0,0,1,32,0V72H104A16,16,0,0,1,88,56ZM40,104A16,16,0,0,1,56,88h48a16,16,0,0,1,16,16v16H56A16,16,0,0,1,40,104Zm128,96a16,16,0,0,1-32,0V184h16A16,16,0,0,1,168,200Zm32-32H152a16,16,0,0,1-16-16V136h64a16,16,0,0,1,0,32Z" }, null, -1), Y1i = [
  Q1i
], oli = { key: 3 }, eli = ["stroke"], tli = ["stroke"], nli = ["stroke"], sli = ["stroke"], rli = ["stroke"], ili = ["stroke"], lli = ["stroke"], dli = ["stroke"], kli = { key: 4 }, cli = ["stroke"], hli = ["stroke"], uli = ["stroke"], ali = ["stroke"], _li = ["stroke"], pli = ["stroke"], yli = ["stroke"], $li = ["stroke"], wli = { key: 5 }, fli = ["stroke"], gli = ["stroke"], xli = ["stroke"], jli = ["stroke"], mli = ["stroke"], Mli = ["stroke"], vli = ["stroke"], Sli = ["stroke"], Hli = {
  name: "PhSlackLogo"
}, rel = /* @__PURE__ */ $({
  ...Hli,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", V1i, [
        e("path", {
          d: "M80,56h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V80A24,24,0,0,1,80,56Z",
          transform: "translate(184 24) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, z1i),
        e("path", {
          d: "M128,80H104A23.9,23.9,0,0,1,80,56h0a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Z1i),
        e("path", {
          d: "M152,32h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V56A24,24,0,0,1,152,32Z",
          transform: "translate(304 160) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, C1i),
        e("path", {
          d: "M176,128V104a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, b1i),
        e("path", {
          d: "M176,104h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V128a24,24,0,0,1,24-24Z",
          transform: "translate(24 328) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, L1i),
        e("path", {
          d: "M128,176h24a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, B1i),
        e("path", {
          d: "M104,128h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V152A24,24,0,0,1,104,128Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, P1i),
        e("path", {
          d: "M80,128v24a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24h0a23.9,23.9,0,0,1,24-24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, W1i)
      ])) : o(i) === "duotone" ? (s(), r("g", N1i, [
        F1i,
        T1i,
        D1i,
        R1i,
        e("path", {
          d: "M80,56h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V80A24,24,0,0,1,80,56Z",
          transform: "translate(184 24) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U1i),
        e("path", {
          d: "M128,80H104A23.9,23.9,0,0,1,80,56h0a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q1i),
        e("path", {
          d: "M152,32h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V56A24,24,0,0,1,152,32Z",
          transform: "translate(304 160) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G1i),
        e("path", {
          d: "M176,128V104a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E1i),
        e("path", {
          d: "M176,104h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V128a24,24,0,0,1,24-24Z",
          transform: "translate(24 328) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O1i),
        e("path", {
          d: "M128,176h24a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I1i),
        e("path", {
          d: "M104,128h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V152A24,24,0,0,1,104,128Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K1i),
        e("path", {
          d: "M80,128v24a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24h0a23.9,23.9,0,0,1,24-24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X1i)
      ])) : o(i) === "fill" ? (s(), r("g", J1i, Y1i)) : o(i) === "light" ? (s(), r("g", oli, [
        e("path", {
          d: "M80,56h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V80A24,24,0,0,1,80,56Z",
          transform: "translate(184 24) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eli),
        e("path", {
          d: "M128,80H104A23.9,23.9,0,0,1,80,56h0a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tli),
        e("path", {
          d: "M152,32h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V56a24,24,0,0,1,24-24Z",
          transform: "translate(304 160) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nli),
        e("path", {
          d: "M176,128V104a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sli),
        e("path", {
          d: "M176,104h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V128A24,24,0,0,1,176,104Z",
          transform: "translate(24 328) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rli),
        e("path", {
          d: "M128,176h24a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ili),
        e("path", {
          d: "M104,128h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V152A24,24,0,0,1,104,128Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lli),
        e("path", {
          d: "M80,128v24a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24h0a23.9,23.9,0,0,1,24-24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dli)
      ])) : o(i) === "thin" ? (s(), r("g", kli, [
        e("path", {
          d: "M80,56h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V80A24,24,0,0,1,80,56Z",
          transform: "translate(184 24) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cli),
        e("path", {
          d: "M128,80H104A23.9,23.9,0,0,1,80,56h0a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hli),
        e("path", {
          d: "M152,32h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V56A24,24,0,0,1,152,32Z",
          transform: "translate(304 160) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uli),
        e("path", {
          d: "M176,128V104a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ali),
        e("path", {
          d: "M176,104h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V128a24,24,0,0,1,24-24Z",
          transform: "translate(24 328) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _li),
        e("path", {
          d: "M128,176h24a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pli),
        e("path", {
          d: "M104,128h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V152a24,24,0,0,1,24-24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yli),
        e("path", {
          d: "M80,128v24a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24h0a23.9,23.9,0,0,1,24-24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $li)
      ])) : o(i) === "regular" ? (s(), r("g", wli, [
        e("path", {
          d: "M80,56h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V80A24,24,0,0,1,80,56Z",
          transform: "translate(184 24) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fli),
        e("path", {
          d: "M128,80H104A23.9,23.9,0,0,1,80,56h0a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gli),
        e("path", {
          d: "M152,32h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V56a24,24,0,0,1,24-24Z",
          transform: "translate(304 160) rotate(180)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xli),
        e("path", {
          d: "M176,128V104a23.9,23.9,0,0,1,24-24h0a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jli),
        e("path", {
          d: "M176,104h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V128a24,24,0,0,1,24-24Z",
          transform: "translate(24 328) rotate(-90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mli),
        e("path", {
          d: "M128,176h24a23.9,23.9,0,0,1,24,24h0a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mli),
        e("path", {
          d: "M104,128h24a0,0,0,0,1,0,0v72a24,24,0,0,1-24,24h0a24,24,0,0,1-24-24V152a24,24,0,0,1,24-24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vli),
        e("path", {
          d: "M80,128v24a23.9,23.9,0,0,1-24,24h0a23.9,23.9,0,0,1-24-24h0a23.9,23.9,0,0,1,24-24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sli)
      ])) : g("", !0)
    ], 16, A1i));
  }
}), Ali = ["width", "height", "fill", "transform"], Vli = { key: 0 }, zli = ["stroke"], Zli = ["stroke"], Cli = ["stroke"], bli = ["stroke"], Lli = ["stroke"], Bli = ["stroke"], Pli = ["stroke"], Wli = ["stroke"], Nli = ["stroke"], Fli = { key: 1 }, Tli = /* @__PURE__ */ e("circle", {
  cx: "56",
  cy: "136",
  r: "20",
  opacity: "0.2"
}, null, -1), Dli = ["stroke"], Rli = ["stroke"], Uli = ["stroke"], qli = ["stroke"], Gli = ["stroke"], Eli = ["stroke"], Oli = ["stroke"], Ili = ["stroke"], Kli = ["stroke"], Xli = { key: 2 }, Jli = /* @__PURE__ */ e("path", { d: "M136,65.4V40a8,8,0,0,0-16,0V65.4a24,24,0,0,0,0,45.2V216a8,8,0,0,0,16,0V110.6a24,24,0,0,0,0-45.2Z" }, null, -1), Qli = /* @__PURE__ */ e("path", { d: "M224,168a24,24,0,0,0-16-22.6V40a8,8,0,0,0-16,0V145.4a24,24,0,0,0,0,45.2V216a8,8,0,0,0,16,0V190.6A24,24,0,0,0,224,168Z" }, null, -1), Yli = /* @__PURE__ */ e("path", { d: "M64,113.4V40a8,8,0,0,0-16,0v73.4a24,24,0,0,0,0,45.2V216a8,8,0,0,0,16,0V158.6a24,24,0,0,0,0-45.2Z" }, null, -1), o2i = [
  Jli,
  Qli,
  Yli
], e2i = { key: 3 }, t2i = ["stroke"], n2i = ["stroke"], s2i = ["stroke"], r2i = ["stroke"], i2i = ["stroke"], l2i = ["stroke"], d2i = ["stroke"], k2i = ["stroke"], c2i = ["stroke"], h2i = { key: 4 }, u2i = ["stroke"], a2i = ["stroke"], _2i = ["stroke"], p2i = ["stroke"], y2i = ["stroke"], $2i = ["stroke"], w2i = ["stroke"], f2i = ["stroke"], g2i = ["stroke"], x2i = { key: 5 }, j2i = ["stroke"], m2i = ["stroke"], M2i = ["stroke"], v2i = ["stroke"], S2i = ["stroke"], H2i = ["stroke"], A2i = ["stroke"], V2i = ["stroke"], z2i = ["stroke"], Z2i = {
  name: "PhSliders"
}, iel = /* @__PURE__ */ $({
  ...Z2i,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Vli, [
        e("line", {
          x1: "128",
          y1: "108",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zli),
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zli),
        e("circle", {
          cx: "128",
          cy: "88",
          r: "20",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cli),
        e("line", {
          x1: "200",
          y1: "188",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bli),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lli),
        e("circle", {
          cx: "200",
          cy: "168",
          r: "20",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bli),
        e("line", {
          x1: "56",
          y1: "156",
          x2: "56",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pli),
        e("line", {
          x1: "56",
          y1: "40",
          x2: "56",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wli),
        e("circle", {
          cx: "56",
          cy: "136",
          r: "20",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nli)
      ])) : o(i) === "duotone" ? (s(), r("g", Fli, [
        Tli,
        e("line", {
          x1: "128",
          y1: "108",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dli),
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rli),
        e("circle", {
          cx: "128",
          cy: "88",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uli),
        e("line", {
          x1: "200",
          y1: "188",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qli),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gli),
        e("circle", {
          cx: "200",
          cy: "168",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Eli),
        e("line", {
          x1: "56",
          y1: "156",
          x2: "56",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Oli),
        e("line", {
          x1: "56",
          y1: "40",
          x2: "56",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ili),
        e("circle", {
          cx: "56",
          cy: "136",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kli)
      ])) : o(i) === "fill" ? (s(), r("g", Xli, o2i)) : o(i) === "light" ? (s(), r("g", e2i, [
        e("line", {
          x1: "128",
          y1: "108",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, t2i),
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, n2i),
        e("circle", {
          cx: "128",
          cy: "88",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, s2i),
        e("line", {
          x1: "200",
          y1: "188",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, r2i),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, i2i),
        e("circle", {
          cx: "200",
          cy: "168",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, l2i),
        e("line", {
          x1: "56",
          y1: "156",
          x2: "56",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, d2i),
        e("line", {
          x1: "56",
          y1: "40",
          x2: "56",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, k2i),
        e("circle", {
          cx: "56",
          cy: "136",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, c2i)
      ])) : o(i) === "thin" ? (s(), r("g", h2i, [
        e("line", {
          x1: "128",
          y1: "108",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, u2i),
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, a2i),
        e("circle", {
          cx: "128",
          cy: "88",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _2i),
        e("line", {
          x1: "200",
          y1: "188",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, p2i),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, y2i),
        e("circle", {
          cx: "200",
          cy: "168",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $2i),
        e("line", {
          x1: "56",
          y1: "156",
          x2: "56",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, w2i),
        e("line", {
          x1: "56",
          y1: "40",
          x2: "56",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, f2i),
        e("circle", {
          cx: "56",
          cy: "136",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, g2i)
      ])) : o(i) === "regular" ? (s(), r("g", x2i, [
        e("line", {
          x1: "128",
          y1: "108",
          x2: "128",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j2i),
        e("line", {
          x1: "128",
          y1: "40",
          x2: "128",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m2i),
        e("circle", {
          cx: "128",
          cy: "88",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M2i),
        e("line", {
          x1: "200",
          y1: "188",
          x2: "200",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v2i),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S2i),
        e("circle", {
          cx: "200",
          cy: "168",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H2i),
        e("line", {
          x1: "56",
          y1: "156",
          x2: "56",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A2i),
        e("line", {
          x1: "56",
          y1: "40",
          x2: "56",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, V2i),
        e("circle", {
          cx: "56",
          cy: "136",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, z2i)
      ])) : g("", !0)
    ], 16, Ali));
  }
}), C2i = ["width", "height", "fill", "transform"], b2i = { key: 0 }, L2i = ["stroke"], B2i = ["stroke"], P2i = ["stroke"], W2i = ["stroke"], N2i = ["stroke"], F2i = ["stroke"], T2i = { key: 1 }, D2i = /* @__PURE__ */ e("circle", {
  cx: "104",
  cy: "84",
  r: "20",
  opacity: "0.2"
}, null, -1), R2i = ["stroke"], U2i = ["stroke"], q2i = ["stroke"], G2i = ["stroke"], E2i = ["stroke"], O2i = ["stroke"], I2i = { key: 2 }, K2i = /* @__PURE__ */ e("path", { d: "M216,164H194.8a28,28,0,0,0-53.6,0H40a8,8,0,0,0,0,16H141.2a28,28,0,0,0,53.6,0H216a8,8,0,0,0,0-16Z" }, null, -1), X2i = /* @__PURE__ */ e("path", { d: "M40,92H77.2a28,28,0,0,0,53.6,0H216a8,8,0,0,0,0-16H130.8a28,28,0,0,0-53.6,0H40a8,8,0,0,0,0,16Z" }, null, -1), J2i = [
  K2i,
  X2i
], Q2i = { key: 3 }, Y2i = ["stroke"], o0i = ["stroke"], e0i = ["stroke"], t0i = ["stroke"], n0i = ["stroke"], s0i = ["stroke"], r0i = { key: 4 }, i0i = ["stroke"], l0i = ["stroke"], d0i = ["stroke"], k0i = ["stroke"], c0i = ["stroke"], h0i = ["stroke"], u0i = { key: 5 }, a0i = ["stroke"], _0i = ["stroke"], p0i = ["stroke"], y0i = ["stroke"], $0i = ["stroke"], w0i = ["stroke"], f0i = {
  name: "PhSlidersHorizontal"
}, lel = /* @__PURE__ */ $({
  ...f0i,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", b2i, [
        e("line", {
          x1: "148",
          y1: "172",
          x2: "40",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, L2i),
        e("line", {
          x1: "216",
          y1: "172",
          x2: "188",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, B2i),
        e("circle", {
          cx: "168",
          cy: "172",
          r: "20",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, P2i),
        e("line", {
          x1: "84",
          y1: "84",
          x2: "40",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, W2i),
        e("line", {
          x1: "216",
          y1: "84",
          x2: "124",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, N2i),
        e("circle", {
          cx: "104",
          cy: "84",
          r: "20",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, F2i)
      ])) : o(i) === "duotone" ? (s(), r("g", T2i, [
        D2i,
        e("line", {
          x1: "148",
          y1: "172",
          x2: "40",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R2i),
        e("line", {
          x1: "216",
          y1: "172",
          x2: "188",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U2i),
        e("circle", {
          cx: "168",
          cy: "172",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q2i),
        e("line", {
          x1: "84",
          y1: "84",
          x2: "40",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G2i),
        e("line", {
          x1: "216",
          y1: "84",
          x2: "124",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E2i),
        e("circle", {
          cx: "104",
          cy: "84",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O2i)
      ])) : o(i) === "fill" ? (s(), r("g", I2i, J2i)) : o(i) === "light" ? (s(), r("g", Q2i, [
        e("line", {
          x1: "148",
          y1: "172",
          x2: "40",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Y2i),
        e("line", {
          x1: "216",
          y1: "172",
          x2: "188",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, o0i),
        e("circle", {
          cx: "168",
          cy: "172",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, e0i),
        e("line", {
          x1: "84",
          y1: "84",
          x2: "40",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, t0i),
        e("line", {
          x1: "216",
          y1: "84",
          x2: "124",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, n0i),
        e("circle", {
          cx: "104",
          cy: "84",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, s0i)
      ])) : o(i) === "thin" ? (s(), r("g", r0i, [
        e("line", {
          x1: "148",
          y1: "172",
          x2: "40",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, i0i),
        e("line", {
          x1: "216",
          y1: "172",
          x2: "188",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, l0i),
        e("circle", {
          cx: "168",
          cy: "172",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, d0i),
        e("line", {
          x1: "84",
          y1: "84",
          x2: "40",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, k0i),
        e("line", {
          x1: "216",
          y1: "84",
          x2: "124",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, c0i),
        e("circle", {
          cx: "104",
          cy: "84",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, h0i)
      ])) : o(i) === "regular" ? (s(), r("g", u0i, [
        e("line", {
          x1: "148",
          y1: "172",
          x2: "40",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a0i),
        e("line", {
          x1: "216",
          y1: "172",
          x2: "188",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _0i),
        e("circle", {
          cx: "168",
          cy: "172",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p0i),
        e("line", {
          x1: "84",
          y1: "84",
          x2: "40",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y0i),
        e("line", {
          x1: "216",
          y1: "84",
          x2: "124",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $0i),
        e("circle", {
          cx: "104",
          cy: "84",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w0i)
      ])) : g("", !0)
    ], 16, C2i));
  }
}), g0i = ["width", "height", "fill", "transform"], x0i = { key: 0 }, j0i = ["stroke"], m0i = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "16"
}, null, -1), M0i = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "16"
}, null, -1), v0i = ["stroke"], S0i = { key: 1 }, H0i = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), A0i = ["stroke"], V0i = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "12"
}, null, -1), z0i = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "12"
}, null, -1), Z0i = ["stroke"], C0i = { key: 2 }, b0i = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm36,72a12,12,0,1,1-12,12A12,12,0,0,1,164,96ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm84.5,60a56,56,0,0,1-97,0,8,8,0,1,1,13.8-8,40.1,40.1,0,0,0,69.4,0,8,8,0,0,1,13.8,8Z" }, null, -1), L0i = [
  b0i
], B0i = { key: 3 }, P0i = ["stroke"], W0i = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "10"
}, null, -1), N0i = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "10"
}, null, -1), F0i = ["stroke"], T0i = { key: 4 }, D0i = ["stroke"], R0i = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "8"
}, null, -1), U0i = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "8"
}, null, -1), q0i = ["stroke"], G0i = { key: 5 }, E0i = ["stroke"], O0i = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "12"
}, null, -1), I0i = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "12"
}, null, -1), K0i = ["stroke"], X0i = {
  name: "PhSmiley"
}, del = /* @__PURE__ */ $({
  ...X0i,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", x0i, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, j0i),
        m0i,
        M0i,
        e("path", {
          d: "M169.6,152a48.1,48.1,0,0,1-83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, v0i)
      ])) : o(i) === "duotone" ? (s(), r("g", S0i, [
        H0i,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, A0i),
        V0i,
        z0i,
        e("path", {
          d: "M169.6,152a48.1,48.1,0,0,1-83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z0i)
      ])) : o(i) === "fill" ? (s(), r("g", C0i, L0i)) : o(i) === "light" ? (s(), r("g", B0i, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, P0i),
        W0i,
        N0i,
        e("path", {
          d: "M169.6,152a48.1,48.1,0,0,1-83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, F0i)
      ])) : o(i) === "thin" ? (s(), r("g", T0i, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, D0i),
        R0i,
        U0i,
        e("path", {
          d: "M169.6,152a48.1,48.1,0,0,1-83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, q0i)
      ])) : o(i) === "regular" ? (s(), r("g", G0i, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E0i),
        O0i,
        I0i,
        e("path", {
          d: "M169.6,152a48.1,48.1,0,0,1-83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K0i)
      ])) : g("", !0)
    ], 16, g0i));
  }
}), J0i = ["width", "height", "fill", "transform"], Q0i = { key: 0 }, Y0i = ["stroke"], o8i = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "16"
}, null, -1), e8i = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "16"
}, null, -1), t8i = { key: 1 }, n8i = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), s8i = ["stroke"], r8i = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "12"
}, null, -1), i8i = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "12"
}, null, -1), l8i = { key: 2 }, d8i = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24ZM92,120a12,12,0,1,1,12-12A12,12,0,0,1,92,120Zm72,0a12,12,0,1,1,12-12A12,12,0,0,1,164,120Z" }, null, -1), k8i = [
  d8i
], c8i = { key: 3 }, h8i = ["stroke"], u8i = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "10"
}, null, -1), a8i = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "10"
}, null, -1), _8i = { key: 4 }, p8i = ["stroke"], y8i = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "8"
}, null, -1), $8i = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "8"
}, null, -1), w8i = { key: 5 }, f8i = ["stroke"], g8i = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "12"
}, null, -1), x8i = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "12"
}, null, -1), j8i = {
  name: "PhSmileyBlank"
}, kel = /* @__PURE__ */ $({
  ...j8i,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Q0i, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Y0i),
        o8i,
        e8i
      ])) : o(i) === "duotone" ? (s(), r("g", t8i, [
        n8i,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, s8i),
        r8i,
        i8i
      ])) : o(i) === "fill" ? (s(), r("g", l8i, k8i)) : o(i) === "light" ? (s(), r("g", c8i, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, h8i),
        u8i,
        a8i
      ])) : o(i) === "thin" ? (s(), r("g", _8i, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, p8i),
        y8i,
        $8i
      ])) : o(i) === "regular" ? (s(), r("g", w8i, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, f8i),
        g8i,
        x8i
      ])) : g("", !0)
    ], 16, J0i));
  }
}), m8i = ["width", "height", "fill", "transform"], M8i = { key: 0 }, v8i = ["stroke"], S8i = ["stroke"], H8i = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "16"
}, null, -1), A8i = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "16"
}, null, -1), V8i = { key: 1 }, z8i = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), Z8i = ["stroke"], C8i = ["stroke"], b8i = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "12"
}, null, -1), L8i = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "12"
}, null, -1), B8i = { key: 2 }, P8i = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm76,72H88a8,8,0,0,1,0-16h80a8,8,0,0,1,0,16Zm-4-48a12,12,0,1,1,12-12A12,12,0,0,1,164,120Z" }, null, -1), W8i = [
  P8i
], N8i = { key: 3 }, F8i = ["stroke"], T8i = ["stroke"], D8i = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "10"
}, null, -1), R8i = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "10"
}, null, -1), U8i = { key: 4 }, q8i = ["stroke"], G8i = ["stroke"], E8i = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "8"
}, null, -1), O8i = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "8"
}, null, -1), I8i = { key: 5 }, K8i = ["stroke"], X8i = ["stroke"], J8i = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "12"
}, null, -1), Q8i = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "12"
}, null, -1), Y8i = {
  name: "PhSmileyMeh"
}, cel = /* @__PURE__ */ $({
  ...Y8i,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", M8i, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, v8i),
        e("line", {
          x1: "88",
          y1: "160",
          x2: "168",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, S8i),
        H8i,
        A8i
      ])) : o(i) === "duotone" ? (s(), r("g", V8i, [
        z8i,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Z8i),
        e("line", {
          x1: "88",
          y1: "160",
          x2: "168",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C8i),
        b8i,
        L8i
      ])) : o(i) === "fill" ? (s(), r("g", B8i, W8i)) : o(i) === "light" ? (s(), r("g", N8i, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, F8i),
        e("line", {
          x1: "88",
          y1: "160",
          x2: "168",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, T8i),
        D8i,
        R8i
      ])) : o(i) === "thin" ? (s(), r("g", U8i, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, q8i),
        e("line", {
          x1: "88",
          y1: "160",
          x2: "168",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, G8i),
        E8i,
        O8i
      ])) : o(i) === "regular" ? (s(), r("g", I8i, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, K8i),
        e("line", {
          x1: "88",
          y1: "160",
          x2: "168",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X8i),
        J8i,
        Q8i
      ])) : g("", !0)
    ], 16, m8i));
  }
}), odi = ["width", "height", "fill", "transform"], edi = { key: 0 }, tdi = ["stroke"], ndi = ["stroke"], sdi = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "16"
}, null, -1), rdi = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "16"
}, null, -1), idi = { key: 1 }, ldi = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), ddi = ["stroke"], kdi = ["stroke"], cdi = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "12"
}, null, -1), hdi = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "12"
}, null, -1), udi = { key: 2 }, adi = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm36,72a12,12,0,1,1-12,12A12,12,0,0,1,164,96ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm89,82.2a7.9,7.9,0,0,1-5,1.8,7.8,7.8,0,0,1-6.2-3L160,164.8,150.2,177a7.9,7.9,0,0,1-12.4,0L128,164.8,118.2,177a7.9,7.9,0,0,1-12.4,0L96,164.8,86.2,177a8,8,0,0,1-12.4-10l16-20a7.9,7.9,0,0,1,12.4,0l9.8,12.2,9.8-12.2a7.9,7.9,0,0,1,12.4,0l9.8,12.2,9.8-12.2a7.9,7.9,0,0,1,12.4,0l16,20A7.9,7.9,0,0,1,181,178.2Z" }, null, -1), _di = [
  adi
], pdi = { key: 3 }, ydi = ["stroke"], $di = ["stroke"], wdi = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "10"
}, null, -1), fdi = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "10"
}, null, -1), gdi = { key: 4 }, xdi = ["stroke"], jdi = ["stroke"], mdi = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "8"
}, null, -1), Mdi = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "8"
}, null, -1), vdi = { key: 5 }, Sdi = ["stroke"], Hdi = ["stroke"], Adi = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "12"
}, null, -1), Vdi = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "12"
}, null, -1), zdi = {
  name: "PhSmileyNervous"
}, hel = /* @__PURE__ */ $({
  ...zdi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", edi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tdi),
        e("polyline", {
          points: "85.8 164.8 96 152 112 172 128 152 144 172 160 152 170.2 164.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ndi),
        sdi,
        rdi
      ])) : o(i) === "duotone" ? (s(), r("g", idi, [
        ldi,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, ddi),
        e("polyline", {
          points: "80 172 96 152 112 172 128 152 144 172 160 152 176 172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kdi),
        cdi,
        hdi
      ])) : o(i) === "fill" ? (s(), r("g", udi, _di)) : o(i) === "light" ? (s(), r("g", pdi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ydi),
        e("polyline", {
          points: "80 172 96 152 112 172 128 152 144 172 160 152 176 172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $di),
        wdi,
        fdi
      ])) : o(i) === "thin" ? (s(), r("g", gdi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xdi),
        e("polyline", {
          points: "80 172 96 152 112 172 128 152 144 172 160 152 176 172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jdi),
        mdi,
        Mdi
      ])) : o(i) === "regular" ? (s(), r("g", vdi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Sdi),
        e("polyline", {
          points: "80 172 96 152 112 172 128 152 144 172 160 152 176 172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hdi),
        Adi,
        Vdi
      ])) : g("", !0)
    ], 16, odi));
  }
}), Zdi = ["width", "height", "fill", "transform"], Cdi = { key: 0 }, bdi = ["stroke"], Ldi = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "16"
}, null, -1), Bdi = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "16"
}, null, -1), Pdi = ["stroke"], Wdi = { key: 1 }, Ndi = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), Fdi = ["stroke"], Tdi = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "12"
}, null, -1), Ddi = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "12"
}, null, -1), Rdi = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "12"
}, null, -1), Udi = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "12"
}, null, -1), qdi = ["stroke"], Gdi = { key: 2 }, Edi = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm36,72a12,12,0,1,1-12,12A12,12,0,0,1,164,96ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm81.6,86.9a7.6,7.6,0,0,1-4,1.1,7.7,7.7,0,0,1-6.9-4,40.1,40.1,0,0,0-69.4,0,8,8,0,1,1-13.8-8,56,56,0,0,1,97,0A8,8,0,0,1,173.6,182.9Z" }, null, -1), Odi = [
  Edi
], Idi = { key: 3 }, Kdi = ["stroke"], Xdi = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "10"
}, null, -1), Jdi = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "10"
}, null, -1), Qdi = ["stroke"], Ydi = { key: 4 }, oki = ["stroke"], eki = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "8"
}, null, -1), tki = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "8"
}, null, -1), nki = ["stroke"], ski = { key: 5 }, rki = ["stroke"], iki = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "12"
}, null, -1), lki = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "12"
}, null, -1), dki = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "12"
}, null, -1), kki = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "12"
}, null, -1), cki = ["stroke"], hki = {
  name: "PhSmileySad"
}, uel = /* @__PURE__ */ $({
  ...hki,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Cdi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bdi),
        Ldi,
        Bdi,
        e("path", {
          d: "M165.3,169.8a48,48,0,0,0-74.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pdi)
      ])) : o(i) === "duotone" ? (s(), r("g", Wdi, [
        Ndi,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Fdi),
        Tdi,
        Ddi,
        Rdi,
        Udi,
        e("path", {
          d: "M169.6,176a48.1,48.1,0,0,0-83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qdi)
      ])) : o(i) === "fill" ? (s(), r("g", Gdi, Odi)) : o(i) === "light" ? (s(), r("g", Idi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kdi),
        Xdi,
        Jdi,
        e("path", {
          d: "M169.6,176a48.1,48.1,0,0,0-83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qdi)
      ])) : o(i) === "thin" ? (s(), r("g", Ydi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oki),
        eki,
        tki,
        e("path", {
          d: "M169.6,176a48.1,48.1,0,0,0-83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nki)
      ])) : o(i) === "regular" ? (s(), r("g", ski, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, rki),
        iki,
        lki,
        dki,
        kki,
        e("path", {
          d: "M169.6,176a48.1,48.1,0,0,0-83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cki)
      ])) : g("", !0)
    ], 16, Zdi));
  }
}), uki = ["width", "height", "fill", "transform"], aki = { key: 0 }, _ki = ["stroke"], pki = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "16"
}, null, -1), yki = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "16"
}, null, -1), $ki = ["stroke"], wki = { key: 1 }, fki = /* @__PURE__ */ e("path", {
  d: "M156.2,219.8A97.2,97.2,0,0,1,128,224a96,96,0,1,1,96-96,97.2,97.2,0,0,1-4.2,28.2Z",
  opacity: "0.2"
}, null, -1), gki = ["stroke"], xki = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "12"
}, null, -1), jki = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "12"
}, null, -1), mki = ["stroke"], Mki = { key: 2 }, vki = /* @__PURE__ */ e("path", { d: "M128,24a104,104,0,0,0,0,208,102.2,102.2,0,0,0,30.6-4.6,6.7,6.7,0,0,0,3.3-2l63.5-63.5a7.2,7.2,0,0,0,2-3.3A102.2,102.2,0,0,0,232,128,104.2,104.2,0,0,0,128,24Zm36,72a12,12,0,1,1-12,12A12,12,0,0,1,164,96ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm84.5,60a56,56,0,0,1-97,0,8,8,0,1,1,13.8-8,40.1,40.1,0,0,0,69.4,0,8,8,0,0,1,13.8,8Z" }, null, -1), Ski = [
  vki
], Hki = { key: 3 }, Aki = ["stroke"], Vki = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "10"
}, null, -1), zki = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "10"
}, null, -1), Zki = ["stroke"], Cki = { key: 4 }, bki = ["stroke"], Lki = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "8"
}, null, -1), Bki = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "8"
}, null, -1), Pki = ["stroke"], Wki = { key: 5 }, Nki = ["stroke"], Fki = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "12"
}, null, -1), Tki = /* @__PURE__ */ e("circle", {
  cx: "164",
  cy: "108",
  r: "12"
}, null, -1), Dki = ["stroke"], Rki = {
  name: "PhSmileySticker"
}, ael = /* @__PURE__ */ $({
  ...Rki,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", aki, [
        e("path", {
          d: "M156.2,219.8A97.2,97.2,0,0,1,128,224a96,96,0,1,1,96-96,97.2,97.2,0,0,1-4.2,28.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _ki),
        pki,
        yki,
        e("path", {
          d: "M169.6,152a48.1,48.1,0,0,1-83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $ki)
      ])) : o(i) === "duotone" ? (s(), r("g", wki, [
        fki,
        e("path", {
          d: "M156.2,219.8A97.2,97.2,0,0,1,128,224a96,96,0,1,1,96-96,97.2,97.2,0,0,1-4.2,28.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gki),
        xki,
        jki,
        e("path", {
          d: "M169.6,152a48.1,48.1,0,0,1-83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mki)
      ])) : o(i) === "fill" ? (s(), r("g", Mki, Ski)) : o(i) === "light" ? (s(), r("g", Hki, [
        e("path", {
          d: "M156.2,219.8A97.2,97.2,0,0,1,128,224a96,96,0,1,1,96-96,97.2,97.2,0,0,1-4.2,28.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Aki),
        Vki,
        zki,
        e("path", {
          d: "M169.6,152a48.1,48.1,0,0,1-83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zki)
      ])) : o(i) === "thin" ? (s(), r("g", Cki, [
        e("path", {
          d: "M156.2,219.8A97.2,97.2,0,0,1,128,224a96,96,0,1,1,96-96,97.2,97.2,0,0,1-4.2,28.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bki),
        Lki,
        Bki,
        e("path", {
          d: "M169.6,152a48.1,48.1,0,0,1-83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pki)
      ])) : o(i) === "regular" ? (s(), r("g", Wki, [
        e("path", {
          d: "M156.2,219.8A97.2,97.2,0,0,1,128,224a96,96,0,1,1,96-96,97.2,97.2,0,0,1-4.2,28.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nki),
        Fki,
        Tki,
        e("path", {
          d: "M169.6,152a48.1,48.1,0,0,1-83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dki)
      ])) : g("", !0)
    ], 16, uki));
  }
}), Uki = ["width", "height", "fill", "transform"], qki = { key: 0 }, Gki = ["stroke"], Eki = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "16"
}, null, -1), Oki = ["stroke"], Iki = ["stroke"], Kki = { key: 1 }, Xki = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), Jki = ["stroke"], Qki = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "12"
}, null, -1), Yki = ["stroke"], oci = ["stroke"], eci = { key: 2 }, tci = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24ZM92,96a12,12,0,1,1-12,12A12,12,0,0,1,92,96Zm84.5,60a56,56,0,0,1-97,0,8,8,0,1,1,13.8-8,40.1,40.1,0,0,0,69.4,0,8,8,0,0,1,13.8,8Zm3.5-40H148a8,8,0,0,1,0-16h32a8,8,0,0,1,0,16Z" }, null, -1), nci = [
  tci
], sci = { key: 3 }, rci = ["stroke"], ici = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "10"
}, null, -1), lci = ["stroke"], dci = ["stroke"], kci = { key: 4 }, cci = ["stroke"], hci = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "8"
}, null, -1), uci = ["stroke"], aci = ["stroke"], _ci = { key: 5 }, pci = ["stroke"], yci = /* @__PURE__ */ e("circle", {
  cx: "92",
  cy: "108",
  r: "12"
}, null, -1), $ci = ["stroke"], wci = ["stroke"], fci = {
  name: "PhSmileyWink"
}, _el = /* @__PURE__ */ $({
  ...fci,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", qki, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gki),
        Eki,
        e("line", {
          x1: "152",
          y1: "108",
          x2: "176",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Oki),
        e("path", {
          d: "M169.6,152a48.1,48.1,0,0,1-83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Iki)
      ])) : o(i) === "duotone" ? (s(), r("g", Kki, [
        Xki,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jki),
        Qki,
        e("line", {
          x1: "152",
          y1: "108",
          x2: "176",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yki),
        e("path", {
          d: "M169.6,152a48.1,48.1,0,0,1-83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oci)
      ])) : o(i) === "fill" ? (s(), r("g", eci, nci)) : o(i) === "light" ? (s(), r("g", sci, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rci),
        ici,
        e("line", {
          x1: "152",
          y1: "108",
          x2: "176",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lci),
        e("path", {
          d: "M169.6,152a48.1,48.1,0,0,1-83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dci)
      ])) : o(i) === "thin" ? (s(), r("g", kci, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cci),
        hci,
        e("line", {
          x1: "152",
          y1: "108",
          x2: "176",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uci),
        e("path", {
          d: "M169.6,152a48.1,48.1,0,0,1-83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aci)
      ])) : o(i) === "regular" ? (s(), r("g", _ci, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pci),
        yci,
        e("line", {
          x1: "152",
          y1: "108",
          x2: "176",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $ci),
        e("path", {
          d: "M169.6,152a48.1,48.1,0,0,1-83.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wci)
      ])) : g("", !0)
    ], 16, Uki));
  }
}), gci = ["width", "height", "fill", "transform"], xci = { key: 0 }, jci = ["stroke"], mci = ["stroke"], Mci = ["stroke"], vci = ["stroke"], Sci = ["stroke"], Hci = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "16"
}, null, -1), Aci = { key: 1 }, Vci = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), zci = ["stroke"], Zci = ["stroke"], Cci = ["stroke"], bci = ["stroke"], Lci = ["stroke"], Bci = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "12"
}, null, -1), Pci = { key: 2 }, Wci = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm-18.3,98.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0L88,123.3,77.7,133.7a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L76.7,112,66.3,101.7A8.1,8.1,0,0,1,77.7,90.3L88,100.7,98.3,90.3a8.1,8.1,0,0,1,11.4,11.4L99.3,112ZM128,192a12,12,0,1,1,12-12A12,12,0,0,1,128,192Zm61.7-69.7a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0L168,123.3l-10.3,10.4a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L156.7,112l-10.4-10.3a8.1,8.1,0,0,1,11.4-11.4L168,100.7l10.3-10.4a8.1,8.1,0,0,1,11.4,11.4L179.3,112Z" }, null, -1), Nci = [
  Wci
], Fci = { key: 3 }, Tci = ["stroke"], Dci = ["stroke"], Rci = ["stroke"], Uci = ["stroke"], qci = ["stroke"], Gci = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "10"
}, null, -1), Eci = { key: 4 }, Oci = ["stroke"], Ici = ["stroke"], Kci = ["stroke"], Xci = ["stroke"], Jci = ["stroke"], Qci = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "8"
}, null, -1), Yci = { key: 5 }, ohi = ["stroke"], ehi = ["stroke"], thi = ["stroke"], nhi = ["stroke"], shi = ["stroke"], rhi = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "12"
}, null, -1), ihi = {
  name: "PhSmileyXEyes"
}, pel = /* @__PURE__ */ $({
  ...ihi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xci, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jci),
        e("line", {
          x1: "180",
          y1: "96",
          x2: "148",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mci),
        e("line", {
          x1: "180",
          y1: "128",
          x2: "148",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mci),
        e("line", {
          x1: "108",
          y1: "96",
          x2: "76",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vci),
        e("line", {
          x1: "108",
          y1: "128",
          x2: "76",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Sci),
        Hci
      ])) : o(i) === "duotone" ? (s(), r("g", Aci, [
        Vci,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, zci),
        e("line", {
          x1: "184",
          y1: "96",
          x2: "152",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zci),
        e("line", {
          x1: "184",
          y1: "128",
          x2: "152",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cci),
        e("line", {
          x1: "104",
          y1: "96",
          x2: "72",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bci),
        e("line", {
          x1: "104",
          y1: "128",
          x2: "72",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lci),
        Bci
      ])) : o(i) === "fill" ? (s(), r("g", Pci, Nci)) : o(i) === "light" ? (s(), r("g", Fci, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Tci),
        e("line", {
          x1: "184",
          y1: "96",
          x2: "152",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dci),
        e("line", {
          x1: "184",
          y1: "128",
          x2: "152",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rci),
        e("line", {
          x1: "104",
          y1: "96",
          x2: "72",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Uci),
        e("line", {
          x1: "104",
          y1: "128",
          x2: "72",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qci),
        Gci
      ])) : o(i) === "thin" ? (s(), r("g", Eci, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Oci),
        e("line", {
          x1: "184",
          y1: "96",
          x2: "152",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ici),
        e("line", {
          x1: "184",
          y1: "128",
          x2: "152",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kci),
        e("line", {
          x1: "104",
          y1: "96",
          x2: "72",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xci),
        e("line", {
          x1: "104",
          y1: "128",
          x2: "72",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jci),
        Qci
      ])) : o(i) === "regular" ? (s(), r("g", Yci, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, ohi),
        e("line", {
          x1: "184",
          y1: "96",
          x2: "152",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ehi),
        e("line", {
          x1: "184",
          y1: "128",
          x2: "152",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, thi),
        e("line", {
          x1: "104",
          y1: "96",
          x2: "72",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nhi),
        e("line", {
          x1: "104",
          y1: "128",
          x2: "72",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, shi),
        rhi
      ])) : g("", !0)
    ], 16, gci));
  }
}), lhi = ["width", "height", "fill", "transform"], dhi = { key: 0 }, khi = ["stroke"], chi = ["stroke"], hhi = ["stroke"], uhi = { key: 1 }, ahi = /* @__PURE__ */ e("path", {
  d: "M18.5,188.7S72,163.9,72,80a56,56,0,0,1,112,0c0,83.9,53.5,108.7,53.5,108.7-9.3,8.7-29,3.4-40.2,9.5s-17,25.6-29.5,28.8S141,216,128,216s-27.7,14.1-39.8,11-18.5-22.7-29.5-28.8S27.8,197.4,18.5,188.7Z",
  opacity: "0.2"
}, null, -1), _hi = ["stroke"], phi = ["stroke"], yhi = ["stroke"], $hi = { key: 2 }, whi = /* @__PURE__ */ e("path", { d: "M243,194.5c-7.2,6.7-17.5,7.4-26.6,8-5.7.4-11.7.8-15.2,2.7s-6.8,6.7-10.2,11.3c-5.4,7.4-11.5,15.8-21.2,18.3s-18.6-1.9-26.8-5.7c-5.3-2.5-10.8-5.1-15-5.1s-9.7,2.6-15,5.1-13.7,6.4-21.2,6.4a27.7,27.7,0,0,1-5.6-.7c-9.7-2.5-15.8-10.9-21.2-18.3-3.4-4.6-6.8-9.4-10.2-11.3s-9.5-2.3-15.2-2.7c-9.1-.6-19.4-1.3-26.6-8a8,8,0,0,1,2.1-13.1c.3-.1,12.5-6,24.5-21.3a105.5,105.5,0,0,0,17.3-32.7l-19.9-8a8,8,0,1,1,6-14.8l18,7.2A160.5,160.5,0,0,0,64,80a64,64,0,0,1,128,0,160.5,160.5,0,0,0,3,31.8l18-7.2a8,8,0,0,1,6,14.8l-19.9,8a105.5,105.5,0,0,0,17.3,32.7c12.1,15.3,24.3,21.3,24.5,21.3a8,8,0,0,1,2.1,13.1Z" }, null, -1), fhi = [
  whi
], ghi = { key: 3 }, xhi = ["stroke"], jhi = ["stroke"], mhi = ["stroke"], Mhi = { key: 4 }, vhi = ["stroke"], Shi = ["stroke"], Hhi = ["stroke"], Ahi = { key: 5 }, Vhi = ["stroke"], zhi = ["stroke"], Zhi = ["stroke"], Chi = {
  name: "PhSnapchatLogo"
}, yel = /* @__PURE__ */ $({
  ...Chi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", dhi, [
        e("path", {
          d: "M18.5,188.7S72,163.9,72,80a56,56,0,0,1,112,0c0,83.9,53.5,108.7,53.5,108.7-9.3,8.7-29,3.4-40.2,9.5s-17,25.6-29.5,28.8S141,216,128,216s-27.7,14.1-39.8,11-18.5-22.7-29.5-28.8S27.8,197.4,18.5,188.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, khi),
        e("line", {
          x1: "189.3",
          y1: "122.7",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, chi),
        e("line", {
          x1: "66.7",
          y1: "122.7",
          x2: "40",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hhi)
      ])) : o(i) === "duotone" ? (s(), r("g", uhi, [
        ahi,
        e("path", {
          d: "M18.5,188.7S72,163.9,72,80a56,56,0,0,1,112,0c0,83.9,53.5,108.7,53.5,108.7-9.3,8.7-29,3.4-40.2,9.5s-17,25.6-29.5,28.8S141,216,128,216s-27.7,14.1-39.8,11-18.5-22.7-29.5-28.8S27.8,197.4,18.5,188.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _hi),
        e("line", {
          x1: "189.3",
          y1: "122.7",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, phi),
        e("line", {
          x1: "66.7",
          y1: "122.7",
          x2: "40",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yhi)
      ])) : o(i) === "fill" ? (s(), r("g", $hi, fhi)) : o(i) === "light" ? (s(), r("g", ghi, [
        e("path", {
          d: "M18.5,188.7S72,163.9,72,80a56,56,0,0,1,112,0c0,83.9,53.5,108.7,53.5,108.7-9.3,8.7-29,3.4-40.2,9.5s-17,25.6-29.5,28.8S141,216,128,216s-27.7,14.1-39.8,11-18.5-22.7-29.5-28.8S27.8,197.4,18.5,188.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xhi),
        e("line", {
          x1: "189.3",
          y1: "122.7",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jhi),
        e("line", {
          x1: "66.7",
          y1: "122.7",
          x2: "40",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mhi)
      ])) : o(i) === "thin" ? (s(), r("g", Mhi, [
        e("path", {
          d: "M18.5,188.7S72,163.9,72,80a56,56,0,0,1,112,0c0,83.9,53.5,108.7,53.5,108.7-9.3,8.7-29,3.4-40.2,9.5s-17,25.6-29.5,28.8S141,216,128,216s-27.7,14.1-39.8,11-18.5-22.7-29.5-28.8S27.8,197.4,18.5,188.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vhi),
        e("line", {
          x1: "189.3",
          y1: "122.7",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Shi),
        e("line", {
          x1: "66.7",
          y1: "122.7",
          x2: "40",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hhi)
      ])) : o(i) === "regular" ? (s(), r("g", Ahi, [
        e("path", {
          d: "M18.5,188.7S72,163.9,72,80a56,56,0,0,1,112,0c0,83.9,53.5,108.7,53.5,108.7-9.3,8.7-29,3.4-40.2,9.5s-17,25.6-29.5,28.8S141,216,128,216s-27.7,14.1-39.8,11-18.5-22.7-29.5-28.8S27.8,197.4,18.5,188.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vhi),
        e("line", {
          x1: "189.3",
          y1: "122.7",
          x2: "216",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zhi),
        e("line", {
          x1: "66.7",
          y1: "122.7",
          x2: "40",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zhi)
      ])) : g("", !0)
    ], 16, lhi));
  }
}), bhi = ["width", "height", "fill", "transform"], Lhi = { key: 0 }, Bhi = ["stroke"], Phi = ["stroke"], Whi = ["stroke"], Nhi = ["stroke"], Fhi = ["stroke"], Thi = ["stroke"], Dhi = ["stroke"], Rhi = ["stroke"], Uhi = ["stroke"], qhi = { key: 1 }, Ghi = ["stroke"], Ehi = ["stroke"], Ohi = ["stroke"], Ihi = ["stroke"], Khi = ["stroke"], Xhi = ["stroke"], Jhi = ["stroke"], Qhi = ["stroke"], Yhi = ["stroke"], o6i = { key: 2 }, e6i = /* @__PURE__ */ e("path", { d: "M223.9,149.1a7.9,7.9,0,0,1-5.6,9.8l-25.1,6.8,6.7,25a7.9,7.9,0,0,1-5.6,9.8l-2.1.3a8,8,0,0,1-7.7-5.9l-7.9-29.6L136,141.9v46.8l21.7,21.6a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0L128,203.3l-18.3,18.4a8.1,8.1,0,0,1-11.4-11.4L120,188.7V141.9L79.4,165.3l-7.9,29.6a8,8,0,0,1-7.7,5.9l-2.1-.3a7.9,7.9,0,0,1-5.6-9.8l6.7-25-25.1-6.8a8,8,0,1,1,4.2-15.4l29.5,7.9L112,128,71.4,104.6l-29.5,7.9a7.6,7.6,0,0,1-2.1.3,8,8,0,0,1-2.1-15.7l25.1-6.8-6.7-25a8,8,0,0,1,15.4-4.2l7.9,29.6L120,114.1V67.3L98.3,45.7a8.1,8.1,0,0,1,11.4-11.4L128,52.7l18.3-18.4a8.1,8.1,0,0,1,11.4,11.4L136,67.3v46.8l40.6-23.4,7.9-29.6a8,8,0,1,1,15.4,4.2l-6.7,25,25.1,6.8a8,8,0,0,1-2.1,15.7l-2.1-.3-29.5-7.9L144,128l40.6,23.4,29.5-7.9A7.9,7.9,0,0,1,223.9,149.1Z" }, null, -1), t6i = [
  e6i
], n6i = { key: 3 }, s6i = ["stroke"], r6i = ["stroke"], i6i = ["stroke"], l6i = ["stroke"], d6i = ["stroke"], k6i = ["stroke"], c6i = ["stroke"], h6i = ["stroke"], u6i = ["stroke"], a6i = { key: 4 }, _6i = ["stroke"], p6i = ["stroke"], y6i = ["stroke"], $6i = ["stroke"], w6i = ["stroke"], f6i = ["stroke"], g6i = ["stroke"], x6i = ["stroke"], j6i = ["stroke"], m6i = { key: 5 }, M6i = ["stroke"], v6i = ["stroke"], S6i = ["stroke"], H6i = ["stroke"], A6i = ["stroke"], V6i = ["stroke"], z6i = ["stroke"], Z6i = ["stroke"], C6i = ["stroke"], b6i = {
  name: "PhSnowflake"
}, $el = /* @__PURE__ */ $({
  ...b6i,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Lhi, [
        e("line", {
          x1: "128",
          y1: "64",
          x2: "128",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bhi),
        e("polyline", {
          points: "104 40 128 64 152 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Phi),
        e("polyline", {
          points: "104 216 128 192 152 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Whi),
        e("line", {
          x1: "72.6",
          y1: "96",
          x2: "183.4",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nhi),
        e("polyline", {
          points: "39.8 104.8 72.6 96 63.8 63.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fhi),
        e("polyline", {
          points: "192.2 192.8 183.4 160 216.2 151.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Thi),
        e("line", {
          x1: "72.6",
          y1: "160",
          x2: "183.4",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Dhi),
        e("polyline", {
          points: "63.8 192.8 72.6 160 39.8 151.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rhi),
        e("polyline", {
          points: "216.2 104.8 183.4 96 192.2 63.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Uhi)
      ])) : o(i) === "duotone" ? (s(), r("g", qhi, [
        e("line", {
          x1: "128",
          y1: "64",
          x2: "128",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ghi),
        e("polyline", {
          points: "104 40 128 64 152 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ehi),
        e("polyline", {
          points: "104 216 128 192 152 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ohi),
        e("line", {
          x1: "72.6",
          y1: "96",
          x2: "183.4",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ihi),
        e("polyline", {
          points: "39.8 104.8 72.6 96 63.8 63.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Khi),
        e("polyline", {
          points: "192.2 192.8 183.4 160 216.2 151.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xhi),
        e("line", {
          x1: "72.6",
          y1: "160",
          x2: "183.4",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jhi),
        e("polyline", {
          points: "63.8 192.8 72.6 160 39.8 151.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qhi),
        e("polyline", {
          points: "216.2 104.8 183.4 96 192.2 63.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yhi)
      ])) : o(i) === "fill" ? (s(), r("g", o6i, t6i)) : o(i) === "light" ? (s(), r("g", n6i, [
        e("line", {
          x1: "128",
          y1: "64",
          x2: "128",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, s6i),
        e("polyline", {
          points: "104 40 128 64 152 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, r6i),
        e("polyline", {
          points: "104 216 128 192 152 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, i6i),
        e("line", {
          x1: "72.6",
          y1: "96",
          x2: "183.4",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, l6i),
        e("polyline", {
          points: "39.8 104.8 72.6 96 63.8 63.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, d6i),
        e("polyline", {
          points: "192.2 192.8 183.4 160 216.2 151.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, k6i),
        e("line", {
          x1: "72.6",
          y1: "160",
          x2: "183.4",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, c6i),
        e("polyline", {
          points: "63.8 192.8 72.6 160 39.8 151.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, h6i),
        e("polyline", {
          points: "216.2 104.8 183.4 96 192.2 63.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u6i)
      ])) : o(i) === "thin" ? (s(), r("g", a6i, [
        e("line", {
          x1: "128",
          y1: "64",
          x2: "128",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _6i),
        e("polyline", {
          points: "104 40 128 64 152 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, p6i),
        e("polyline", {
          points: "104 216 128 192 152 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, y6i),
        e("line", {
          x1: "72.6",
          y1: "96",
          x2: "183.4",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $6i),
        e("polyline", {
          points: "39.8 104.8 72.6 96 63.8 63.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, w6i),
        e("polyline", {
          points: "192.2 192.8 183.4 160 216.2 151.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, f6i),
        e("line", {
          x1: "72.6",
          y1: "160",
          x2: "183.4",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, g6i),
        e("polyline", {
          points: "63.8 192.8 72.6 160 39.8 151.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, x6i),
        e("polyline", {
          points: "216.2 104.8 183.4 96 192.2 63.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, j6i)
      ])) : o(i) === "regular" ? (s(), r("g", m6i, [
        e("line", {
          x1: "128",
          y1: "64",
          x2: "128",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M6i),
        e("polyline", {
          points: "104 40 128 64 152 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v6i),
        e("polyline", {
          points: "104 216 128 192 152 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S6i),
        e("line", {
          x1: "72.6",
          y1: "96",
          x2: "183.4",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H6i),
        e("polyline", {
          points: "39.8 104.8 72.6 96 63.8 63.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A6i),
        e("polyline", {
          points: "192.2 192.8 183.4 160 216.2 151.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, V6i),
        e("line", {
          x1: "72.6",
          y1: "160",
          x2: "183.4",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, z6i),
        e("polyline", {
          points: "63.8 192.8 72.6 160 39.8 151.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z6i),
        e("polyline", {
          points: "216.2 104.8 183.4 96 192.2 63.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C6i)
      ])) : g("", !0)
    ], 16, bhi));
  }
}), L6i = ["width", "height", "fill", "transform"], B6i = { key: 0 }, P6i = ["stroke"], W6i = ["stroke"], N6i = ["stroke"], F6i = ["stroke"], T6i = ["stroke"], D6i = ["stroke"], R6i = ["stroke"], U6i = { key: 1 }, q6i = /* @__PURE__ */ j('<polygon points="128 86 88.1 115 103.3 162 152.7 162 167.9 115 128 86" opacity="0.2"></polygon><path d="M93,38.6a96.1,96.1,0,0,1,70,0h0L128,64,93,38.6Z" opacity="0.2"></path><path d="M32.1,133.7a98.4,98.4,0,0,1,4.6-35.4A95.5,95.5,0,0,1,53.8,67.1h0l13.3,41.1-35,25.5Z" opacity="0.2"></path><path d="M103.8,220.9a95.9,95.9,0,0,1-32.2-15.2,97,97,0,0,1-24.5-25.9H90.4l13.4,41.1Z" opacity="0.2"></path><path d="M208.9,179.8a97,97,0,0,1-24.5,25.9,95.9,95.9,0,0,1-32.2,15.2h0l13.4-41.1Z" opacity="0.2"></path><path d="M202.2,67.1a95.5,95.5,0,0,1,17.1,31.2,98.4,98.4,0,0,1,4.6,35.4h0l-35-25.5,13.3-41.1Z" opacity="0.2"></path>', 6), G6i = ["stroke"], E6i = ["stroke"], O6i = ["stroke"], I6i = ["stroke"], K6i = ["stroke"], X6i = ["stroke"], J6i = ["stroke"], Q6i = ["stroke"], Y6i = ["stroke"], oui = ["stroke"], eui = ["stroke"], tui = ["stroke"], nui = { key: 2 }, sui = /* @__PURE__ */ e("path", { d: "M231.8,134.8a4.8,4.8,0,0,0,0-1.2c.1-1.9.2-3.7.2-5.6a103.2,103.2,0,0,0-23-65.1,5.5,5.5,0,0,0-1.4-1.7,103.9,103.9,0,0,0-41.1-29.8l-1.1-.4a103.4,103.4,0,0,0-74.8,0l-1.1.4A103.9,103.9,0,0,0,48.4,61.2,5.5,5.5,0,0,0,47,62.9,103.2,103.2,0,0,0,24,128c0,1.9.1,3.7.2,5.6a4.8,4.8,0,0,0,0,1.2,104.2,104.2,0,0,0,15.7,48.4,9.9,9.9,0,0,0,1.1,1.7,104.3,104.3,0,0,0,60.3,43.6h.3a104.2,104.2,0,0,0,52.8,0h.3A104.3,104.3,0,0,0,215,184.9a9.9,9.9,0,0,0,1.1-1.7A104.2,104.2,0,0,0,231.8,134.8ZM68.5,117.1l13.2,4.3,12.7,39.2-8.1,11.2H51.7a86.2,86.2,0,0,1-11.2-34.3Zm119,0,28,20.4a86.2,86.2,0,0,1-11.2,34.3H169.7l-8.1-11.2,12.7-39.2ZM193.2,69l-10.7,32.9-13.2,4.3L136,81.9V68.1l28-20.4A87,87,0,0,1,193.2,69ZM92,47.7l28,20.4V81.9L86.7,106.2l-13.2-4.3L62.8,69A87,87,0,0,1,92,47.7Zm18,166.4L99.3,181.2l8.1-11.2h41.2l8.1,11.2L146,214.1a86.2,86.2,0,0,1-36,0Z" }, null, -1), rui = [
  sui
], iui = { key: 3 }, lui = ["stroke"], dui = ["stroke"], kui = ["stroke"], cui = ["stroke"], hui = ["stroke"], uui = ["stroke"], aui = ["stroke"], _ui = ["stroke"], pui = ["stroke"], yui = ["stroke"], $ui = ["stroke"], wui = ["stroke"], fui = { key: 4 }, gui = ["stroke"], xui = ["stroke"], jui = ["stroke"], mui = ["stroke"], Mui = ["stroke"], vui = ["stroke"], Sui = ["stroke"], Hui = ["stroke"], Aui = ["stroke"], Vui = ["stroke"], zui = ["stroke"], Zui = ["stroke"], Cui = { key: 5 }, bui = ["stroke"], Lui = ["stroke"], Bui = ["stroke"], Pui = ["stroke"], Wui = ["stroke"], Nui = ["stroke"], Fui = ["stroke"], Tui = ["stroke"], Dui = ["stroke"], Rui = ["stroke"], Uui = ["stroke"], qui = ["stroke"], Gui = {
  name: "PhSoccerBall"
}, wel = /* @__PURE__ */ $({
  ...Gui,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", B6i, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, P6i),
        e("polygon", {
          points: "128 74 76.7 111.3 96.3 171.7 159.7 171.7 179.3 111.3 128 74",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, W6i),
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "74",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, N6i),
        e("line", {
          x1: "36.7",
          y1: "98.3",
          x2: "76.7",
          y2: "111.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, F6i),
        e("line", {
          x1: "71.6",
          y1: "205.7",
          x2: "96.3",
          y2: "171.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, T6i),
        e("line", {
          x1: "184.4",
          y1: "205.7",
          x2: "159.7",
          y2: "171.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, D6i),
        e("line", {
          x1: "219.3",
          y1: "98.3",
          x2: "179.3",
          y2: "111.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, R6i)
      ])) : o(i) === "duotone" ? (s(), r("g", U6i, [
        q6i,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G6i),
        e("polygon", {
          points: "128 86 88.1 115 103.3 162 152.7 162 167.9 115 128 86",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E6i),
        e("line", {
          x1: "128",
          y1: "64",
          x2: "128",
          y2: "86",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O6i),
        e("polyline", {
          points: "163 38.6 128 64 93 38.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I6i),
        e("line", {
          x1: "67.1",
          y1: "108.2",
          x2: "88.1",
          y2: "115",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K6i),
        e("polyline", {
          points: "53.8 67.1 67.1 108.2 32.1 133.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X6i),
        e("line", {
          x1: "90.4",
          y1: "179.8",
          x2: "103.3",
          y2: "162",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J6i),
        e("polyline", {
          points: "47.1 179.8 90.4 179.8 103.8 220.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q6i),
        e("line", {
          x1: "165.6",
          y1: "179.8",
          x2: "152.7",
          y2: "162",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y6i),
        e("polyline", {
          points: "152.2 220.9 165.6 179.8 208.9 179.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oui),
        e("line", {
          x1: "188.9",
          y1: "108.2",
          x2: "167.9",
          y2: "115",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eui),
        e("polyline", {
          points: "223.9 133.7 188.9 108.2 202.2 67.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tui)
      ])) : o(i) === "fill" ? (s(), r("g", nui, rui)) : o(i) === "light" ? (s(), r("g", iui, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lui),
        e("polygon", {
          points: "128 86 88.1 115 103.3 162 152.7 162 167.9 115 128 86",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dui),
        e("line", {
          x1: "128",
          y1: "64",
          x2: "128",
          y2: "86",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kui),
        e("polyline", {
          points: "163 38.6 128 64 93 38.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cui),
        e("line", {
          x1: "67.1",
          y1: "108.2",
          x2: "88.1",
          y2: "115",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hui),
        e("polyline", {
          points: "53.8 67.1 67.1 108.2 32.1 133.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uui),
        e("line", {
          x1: "90.4",
          y1: "179.8",
          x2: "103.3",
          y2: "162",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aui),
        e("polyline", {
          points: "47.1 179.8 90.4 179.8 103.8 220.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _ui),
        e("line", {
          x1: "165.6",
          y1: "179.8",
          x2: "152.7",
          y2: "162",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pui),
        e("polyline", {
          points: "152.2 220.9 165.6 179.8 208.9 179.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yui),
        e("line", {
          x1: "188.9",
          y1: "108.2",
          x2: "167.9",
          y2: "115",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $ui),
        e("polyline", {
          points: "223.9 133.7 188.9 108.2 202.2 67.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wui)
      ])) : o(i) === "thin" ? (s(), r("g", fui, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gui),
        e("polygon", {
          points: "128 86 88.1 115 103.3 162 152.7 162 167.9 115 128 86",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xui),
        e("line", {
          x1: "128",
          y1: "64",
          x2: "128",
          y2: "86",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jui),
        e("polyline", {
          points: "163 38.6 128 64 93 38.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mui),
        e("line", {
          x1: "67.1",
          y1: "108.2",
          x2: "88.1",
          y2: "115",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Mui),
        e("polyline", {
          points: "53.8 67.1 67.1 108.2 32.1 133.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vui),
        e("line", {
          x1: "90.4",
          y1: "179.8",
          x2: "103.3",
          y2: "162",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Sui),
        e("polyline", {
          points: "47.1 179.8 90.4 179.8 103.8 220.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hui),
        e("line", {
          x1: "165.6",
          y1: "179.8",
          x2: "152.7",
          y2: "162",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Aui),
        e("polyline", {
          points: "152.2 220.9 165.6 179.8 208.9 179.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vui),
        e("line", {
          x1: "188.9",
          y1: "108.2",
          x2: "167.9",
          y2: "115",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zui),
        e("polyline", {
          points: "223.9 133.7 188.9 108.2 202.2 67.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zui)
      ])) : o(i) === "regular" ? (s(), r("g", Cui, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bui),
        e("polygon", {
          points: "128 86 88.1 115 103.3 162 152.7 162 167.9 115 128 86",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lui),
        e("line", {
          x1: "128",
          y1: "64",
          x2: "128",
          y2: "86",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bui),
        e("polyline", {
          points: "163 38.6 128 64 93 38.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pui),
        e("line", {
          x1: "67.1",
          y1: "108.2",
          x2: "88.1",
          y2: "115",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wui),
        e("polyline", {
          points: "53.8 67.1 67.1 108.2 32.1 133.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nui),
        e("line", {
          x1: "90.4",
          y1: "179.8",
          x2: "103.3",
          y2: "162",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fui),
        e("polyline", {
          points: "47.1 179.8 90.4 179.8 103.8 220.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tui),
        e("line", {
          x1: "165.6",
          y1: "179.8",
          x2: "152.7",
          y2: "162",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dui),
        e("polyline", {
          points: "152.2 220.9 165.6 179.8 208.9 179.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rui),
        e("line", {
          x1: "188.9",
          y1: "108.2",
          x2: "167.9",
          y2: "115",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uui),
        e("polyline", {
          points: "223.9 133.7 188.9 108.2 202.2 67.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qui)
      ])) : g("", !0)
    ], 16, L6i));
  }
}), Eui = ["width", "height", "fill", "transform"], Oui = { key: 0 }, Iui = ["stroke"], Kui = ["stroke"], Xui = ["stroke"], Jui = ["stroke"], Qui = ["stroke"], Yui = { key: 1 }, o4i = ["stroke"], e4i = ["stroke"], t4i = ["stroke"], n4i = ["stroke"], s4i = ["stroke"], r4i = { key: 2 }, i4i = /* @__PURE__ */ e("path", { d: "M229.7,173.7l-40,40a8.2,8.2,0,0,1-11.4,0l-40-40a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,144,160h32V112a8,8,0,0,1,16,0v48h32a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,229.7,173.7ZM120,120H48a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16ZM48,72H184a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16Zm56,112H48a8,8,0,0,0,0,16h56a8,8,0,0,0,0-16Z" }, null, -1), l4i = [
  i4i
], d4i = { key: 3 }, k4i = ["stroke"], c4i = ["stroke"], h4i = ["stroke"], u4i = ["stroke"], a4i = ["stroke"], _4i = { key: 4 }, p4i = ["stroke"], y4i = ["stroke"], $4i = ["stroke"], w4i = ["stroke"], f4i = ["stroke"], g4i = { key: 5 }, x4i = ["stroke"], j4i = ["stroke"], m4i = ["stroke"], M4i = ["stroke"], v4i = ["stroke"], S4i = {
  name: "PhSortAscending"
}, fel = /* @__PURE__ */ $({
  ...S4i,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Oui, [
        e("polyline", {
          points: "144 168 184 208 224 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Iui),
        e("line", {
          x1: "184",
          y1: "112",
          x2: "184",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kui),
        e("line", {
          x1: "48",
          y1: "128",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xui),
        e("line", {
          x1: "48",
          y1: "64",
          x2: "184",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jui),
        e("line", {
          x1: "48",
          y1: "192",
          x2: "104",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qui)
      ])) : o(i) === "duotone" ? (s(), r("g", Yui, [
        e("polyline", {
          points: "144 168 184 208 224 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o4i),
        e("line", {
          x1: "184",
          y1: "112",
          x2: "184",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e4i),
        e("line", {
          x1: "48",
          y1: "128",
          x2: "120",
          y2: "128",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t4i),
        e("line", {
          x1: "48",
          y1: "64",
          x2: "184",
          y2: "64",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n4i),
        e("line", {
          x1: "48",
          y1: "192",
          x2: "104",
          y2: "192",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s4i)
      ])) : o(i) === "fill" ? (s(), r("g", r4i, l4i)) : o(i) === "light" ? (s(), r("g", d4i, [
        e("polyline", {
          points: "144 168 184 208 224 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, k4i),
        e("line", {
          x1: "184",
          y1: "112",
          x2: "184",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, c4i),
        e("line", {
          x1: "48",
          y1: "128",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, h4i),
        e("line", {
          x1: "48",
          y1: "64",
          x2: "184",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u4i),
        e("line", {
          x1: "48",
          y1: "192",
          x2: "104",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, a4i)
      ])) : o(i) === "thin" ? (s(), r("g", _4i, [
        e("polyline", {
          points: "144 168 184 208 224 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, p4i),
        e("line", {
          x1: "184",
          y1: "112",
          x2: "184",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, y4i),
        e("line", {
          x1: "48",
          y1: "128",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $4i),
        e("line", {
          x1: "48",
          y1: "64",
          x2: "184",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, w4i),
        e("line", {
          x1: "48",
          y1: "192",
          x2: "104",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, f4i)
      ])) : o(i) === "regular" ? (s(), r("g", g4i, [
        e("polyline", {
          points: "144 168 184 208 224 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, x4i),
        e("line", {
          x1: "184",
          y1: "112",
          x2: "184",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j4i),
        e("line", {
          x1: "48",
          y1: "128",
          x2: "120",
          y2: "128",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m4i),
        e("line", {
          x1: "48",
          y1: "64",
          x2: "184",
          y2: "64",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M4i),
        e("line", {
          x1: "48",
          y1: "192",
          x2: "104",
          y2: "192",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v4i)
      ])) : g("", !0)
    ], 16, Eui));
  }
}), H4i = ["width", "height", "fill", "transform"], A4i = { key: 0 }, V4i = ["stroke"], z4i = ["stroke"], Z4i = ["stroke"], C4i = ["stroke"], b4i = ["stroke"], L4i = { key: 1 }, B4i = ["stroke"], P4i = ["stroke"], W4i = ["stroke"], N4i = ["stroke"], F4i = ["stroke"], T4i = { key: 2 }, D4i = /* @__PURE__ */ e("path", { d: "M231.4,91a8,8,0,0,1-7.4,5H192v48a8,8,0,0,1-16,0V96H144a8.1,8.1,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8l40-40a8.1,8.1,0,0,1,11.4,0l40,40A8.2,8.2,0,0,1,231.4,91ZM48,136h72a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16Zm0-64h56a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16ZM184,184H48a8,8,0,0,0,0,16H184a8,8,0,0,0,0-16Z" }, null, -1), R4i = [
  D4i
], U4i = { key: 3 }, q4i = ["stroke"], G4i = ["stroke"], E4i = ["stroke"], O4i = ["stroke"], I4i = ["stroke"], K4i = { key: 4 }, X4i = ["stroke"], J4i = ["stroke"], Q4i = ["stroke"], Y4i = ["stroke"], oai = ["stroke"], eai = { key: 5 }, tai = ["stroke"], nai = ["stroke"], sai = ["stroke"], rai = ["stroke"], iai = ["stroke"], lai = {
  name: "PhSortDescending"
}, gel = /* @__PURE__ */ $({
  ...lai,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", A4i, [
        e("polyline", {
          points: "144 88 184 48 224 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, V4i),
        e("line", {
          x1: "184",
          y1: "144",
          x2: "184",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, z4i),
        e("line", {
          x1: "48",
          y1: "128",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Z4i),
        e("line", {
          x1: "48",
          y1: "64",
          x2: "104",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, C4i),
        e("line", {
          x1: "48",
          y1: "192",
          x2: "184",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, b4i)
      ])) : o(i) === "duotone" ? (s(), r("g", L4i, [
        e("polyline", {
          points: "144 88 184 48 224 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B4i),
        e("line", {
          x1: "184",
          y1: "144",
          x2: "184",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P4i),
        e("line", {
          x1: "48",
          y1: "128",
          x2: "120",
          y2: "128",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W4i),
        e("line", {
          x1: "48",
          y1: "64",
          x2: "104",
          y2: "64",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N4i),
        e("line", {
          x1: "48",
          y1: "192",
          x2: "184",
          y2: "192",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F4i)
      ])) : o(i) === "fill" ? (s(), r("g", T4i, R4i)) : o(i) === "light" ? (s(), r("g", U4i, [
        e("polyline", {
          points: "144 88 184 48 224 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, q4i),
        e("line", {
          x1: "184",
          y1: "144",
          x2: "184",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, G4i),
        e("line", {
          x1: "48",
          y1: "128",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, E4i),
        e("line", {
          x1: "48",
          y1: "64",
          x2: "104",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, O4i),
        e("line", {
          x1: "48",
          y1: "192",
          x2: "184",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, I4i)
      ])) : o(i) === "thin" ? (s(), r("g", K4i, [
        e("polyline", {
          points: "144 88 184 48 224 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, X4i),
        e("line", {
          x1: "184",
          y1: "144",
          x2: "184",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, J4i),
        e("line", {
          x1: "48",
          y1: "128",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Q4i),
        e("line", {
          x1: "48",
          y1: "64",
          x2: "104",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Y4i),
        e("line", {
          x1: "48",
          y1: "192",
          x2: "184",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oai)
      ])) : o(i) === "regular" ? (s(), r("g", eai, [
        e("polyline", {
          points: "144 88 184 48 224 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tai),
        e("line", {
          x1: "184",
          y1: "144",
          x2: "184",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nai),
        e("line", {
          x1: "48",
          y1: "128",
          x2: "120",
          y2: "128",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sai),
        e("line", {
          x1: "48",
          y1: "64",
          x2: "104",
          y2: "64",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rai),
        e("line", {
          x1: "48",
          y1: "192",
          x2: "184",
          y2: "192",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iai)
      ])) : g("", !0)
    ], 16, H4i));
  }
}), dai = ["width", "height", "fill", "transform"], kai = { key: 0 }, cai = ["stroke"], hai = { key: 1 }, uai = /* @__PURE__ */ e("path", {
  d: "M128,24S228,88,228,140a52,52,0,0,1-85.4,39.9L160,232H96l17.4-52.1A52,52,0,0,1,28,140C28,88,128,24,128,24Z",
  opacity: "0.2"
}, null, -1), aai = ["stroke"], _ai = { key: 2 }, pai = /* @__PURE__ */ e("path", { d: "M232,140a56,56,0,0,1-56,56,55.2,55.2,0,0,1-25.9-6.4L162,225.5a7.8,7.8,0,0,1-1.1,7.2,7.9,7.9,0,0,1-6.4,3.3h-53a7.9,7.9,0,0,1-6.4-3.3,7.8,7.8,0,0,1-1.1-7.2l11.9-35.9A55.2,55.2,0,0,1,80,196a56,56,0,0,1-56-56C24,86.4,121.7,23.3,125.8,20.6a4.3,4.3,0,0,1,4.4,0C134.3,23.3,232,86.4,232,140Z" }, null, -1), yai = [
  pai
], $ai = { key: 3 }, wai = ["stroke"], fai = { key: 4 }, gai = ["stroke"], xai = { key: 5 }, jai = ["stroke"], mai = {
  name: "PhSpade"
}, xel = /* @__PURE__ */ $({
  ...mai,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", kai, [
        e("path", {
          d: "M160,232H96l8.7-46.2A52.1,52.1,0,0,1,28,140C28,88,128,24,128,24S228,88,228,140a52.1,52.1,0,0,1-76.7,45.8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cai)
      ])) : o(i) === "duotone" ? (s(), r("g", hai, [
        uai,
        e("path", {
          d: "M128,24S228,88,228,140a52,52,0,0,1-85.4,39.9L160,232H96l17.4-52.1A52,52,0,0,1,28,140C28,88,128,24,128,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aai)
      ])) : o(i) === "fill" ? (s(), r("g", _ai, yai)) : o(i) === "light" ? (s(), r("g", $ai, [
        e("path", {
          d: "M128,24S228,88,228,140a52,52,0,0,1-85.4,39.9L160,232H96l17.4-52.1A52,52,0,0,1,28,140C28,88,128,24,128,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wai)
      ])) : o(i) === "thin" ? (s(), r("g", fai, [
        e("path", {
          d: "M128,24S228,88,228,140a52,52,0,0,1-85.4,39.9L160,232H96l17.4-52.1A52,52,0,0,1,28,140C28,88,128,24,128,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gai)
      ])) : o(i) === "regular" ? (s(), r("g", xai, [
        e("path", {
          d: "M128,24S228,88,228,140a52,52,0,0,1-85.4,39.9L160,232H96l17.4-52.1A52,52,0,0,1,28,140C28,88,128,24,128,24Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jai)
      ])) : g("", !0)
    ], 16, dai));
  }
}), Mai = ["width", "height", "fill", "transform"], vai = { key: 0 }, Sai = ["stroke"], Hai = ["stroke"], Aai = ["stroke"], Vai = ["stroke"], zai = ["stroke"], Zai = { key: 1 }, Cai = /* @__PURE__ */ e("path", {
  d: "M138.7,175.5l-19.2,52.1a8,8,0,0,1-15,0L85.3,175.5a8.1,8.1,0,0,0-4.8-4.8L28.4,151.5a8,8,0,0,1,0-15l52.1-19.2a8.1,8.1,0,0,0,4.8-4.8l19.2-52.1a8,8,0,0,1,15,0l19.2,52.1a8.1,8.1,0,0,0,4.8,4.8l52.1,19.2a8,8,0,0,1,0,15l-52.1,19.2A8.1,8.1,0,0,0,138.7,175.5Z",
  opacity: "0.2"
}, null, -1), bai = ["stroke"], Lai = ["stroke"], Bai = ["stroke"], Pai = ["stroke"], Wai = ["stroke"], Nai = { key: 2 }, Fai = /* @__PURE__ */ e("path", { d: "M208.9,144a15.8,15.8,0,0,1-10.5,15l-52.2,19.2L127,230.4a16,16,0,0,1-30,0L77.8,178.2,25.6,159a16,16,0,0,1,0-30l52.2-19.2L97,57.6a16,16,0,0,1,30,0l19.2,52.2L198.4,129A15.8,15.8,0,0,1,208.9,144ZM152,48h16V64a8,8,0,0,0,16,0V48h16a8,8,0,0,0,0-16H184V16a8,8,0,0,0-16,0V32H152a8,8,0,0,0,0,16Zm88,32h-8V72a8,8,0,0,0-16,0v8h-8a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0V96h8a8,8,0,0,0,0-16Z" }, null, -1), Tai = [
  Fai
], Dai = { key: 3 }, Rai = ["stroke"], Uai = ["stroke"], qai = ["stroke"], Gai = ["stroke"], Eai = ["stroke"], Oai = { key: 4 }, Iai = ["stroke"], Kai = ["stroke"], Xai = ["stroke"], Jai = ["stroke"], Qai = ["stroke"], Yai = { key: 5 }, o_i = ["stroke"], e_i = ["stroke"], t_i = ["stroke"], n_i = ["stroke"], s_i = ["stroke"], r_i = {
  name: "PhSparkle"
}, jel = /* @__PURE__ */ $({
  ...r_i,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", vai, [
        e("path", {
          d: "M138.7,175.5l-19.2,52.1a8,8,0,0,1-15,0L85.3,175.5a8.1,8.1,0,0,0-4.8-4.8L28.4,151.5a8,8,0,0,1,0-15l52.1-19.2a8.1,8.1,0,0,0,4.8-4.8l19.2-52.1a8,8,0,0,1,15,0l19.2,52.1a8.1,8.1,0,0,0,4.8,4.8l52.1,19.2a8,8,0,0,1,0,15l-52.1,19.2A8.1,8.1,0,0,0,138.7,175.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Sai),
        e("line", {
          x1: "176",
          y1: "16",
          x2: "176",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hai),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "152",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Aai),
        e("line", {
          x1: "224",
          y1: "72",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vai),
        e("line", {
          x1: "240",
          y1: "88",
          x2: "208",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zai)
      ])) : o(i) === "duotone" ? (s(), r("g", Zai, [
        Cai,
        e("path", {
          d: "M138.7,175.5l-19.2,52.1a8,8,0,0,1-15,0L85.3,175.5a8.1,8.1,0,0,0-4.8-4.8L28.4,151.5a8,8,0,0,1,0-15l52.1-19.2a8.1,8.1,0,0,0,4.8-4.8l19.2-52.1a8,8,0,0,1,15,0l19.2,52.1a8.1,8.1,0,0,0,4.8,4.8l52.1,19.2a8,8,0,0,1,0,15l-52.1,19.2A8.1,8.1,0,0,0,138.7,175.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bai),
        e("line", {
          x1: "176",
          y1: "16",
          x2: "176",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lai),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "152",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bai),
        e("line", {
          x1: "224",
          y1: "72",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pai),
        e("line", {
          x1: "240",
          y1: "88",
          x2: "208",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wai)
      ])) : o(i) === "fill" ? (s(), r("g", Nai, Tai)) : o(i) === "light" ? (s(), r("g", Dai, [
        e("path", {
          d: "M138.7,175.5l-19.2,52.1a8,8,0,0,1-15,0L85.3,175.5a8.1,8.1,0,0,0-4.8-4.8L28.4,151.5a8,8,0,0,1,0-15l52.1-19.2a8.1,8.1,0,0,0,4.8-4.8l19.2-52.1a8,8,0,0,1,15,0l19.2,52.1a8.1,8.1,0,0,0,4.8,4.8l52.1,19.2a8,8,0,0,1,0,15l-52.1,19.2A8.1,8.1,0,0,0,138.7,175.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rai),
        e("line", {
          x1: "176",
          y1: "16",
          x2: "176",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Uai),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "152",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qai),
        e("line", {
          x1: "224",
          y1: "72",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gai),
        e("line", {
          x1: "240",
          y1: "88",
          x2: "208",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Eai)
      ])) : o(i) === "thin" ? (s(), r("g", Oai, [
        e("path", {
          d: "M138.7,175.5l-19.2,52.1a8,8,0,0,1-15,0L85.3,175.5a8.1,8.1,0,0,0-4.8-4.8L28.4,151.5a8,8,0,0,1,0-15l52.1-19.2a8.1,8.1,0,0,0,4.8-4.8l19.2-52.1a8,8,0,0,1,15,0l19.2,52.1a8.1,8.1,0,0,0,4.8,4.8l52.1,19.2a8,8,0,0,1,0,15l-52.1,19.2A8.1,8.1,0,0,0,138.7,175.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Iai),
        e("line", {
          x1: "176",
          y1: "16",
          x2: "176",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kai),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "152",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xai),
        e("line", {
          x1: "224",
          y1: "72",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jai),
        e("line", {
          x1: "240",
          y1: "88",
          x2: "208",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qai)
      ])) : o(i) === "regular" ? (s(), r("g", Yai, [
        e("path", {
          d: "M138.7,175.5l-19.2,52.1a8,8,0,0,1-15,0L85.3,175.5a8.1,8.1,0,0,0-4.8-4.8L28.4,151.5a8,8,0,0,1,0-15l52.1-19.2a8.1,8.1,0,0,0,4.8-4.8l19.2-52.1a8,8,0,0,1,15,0l19.2,52.1a8.1,8.1,0,0,0,4.8,4.8l52.1,19.2a8,8,0,0,1,0,15l-52.1,19.2A8.1,8.1,0,0,0,138.7,175.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o_i),
        e("line", {
          x1: "176",
          y1: "16",
          x2: "176",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e_i),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "152",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t_i),
        e("line", {
          x1: "224",
          y1: "72",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n_i),
        e("line", {
          x1: "240",
          y1: "88",
          x2: "208",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s_i)
      ])) : g("", !0)
    ], 16, Mai));
  }
}), i_i = ["width", "height", "fill", "transform"], l_i = { key: 0 }, d_i = ["stroke"], k_i = ["stroke"], c_i = ["stroke"], h_i = ["stroke"], u_i = { key: 1 }, a_i = /* @__PURE__ */ e("path", {
  d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80Z",
  opacity: "0.2"
}, null, -1), __i = ["stroke"], p_i = ["stroke"], y_i = ["stroke"], $_i = ["stroke"], w_i = { key: 2 }, f_i = /* @__PURE__ */ e("path", { d: "M224.6,71.4a8,8,0,1,0-11.3,11.4,64.1,64.1,0,0,1,0,90.5,7.9,7.9,0,0,0,0,11.3,8,8,0,0,0,5.6,2.3,8.3,8.3,0,0,0,5.7-2.3,80.2,80.2,0,0,0,0-113.2Z" }, null, -1), g_i = /* @__PURE__ */ e("path", { d: "M155.5,24.8a8,8,0,0,0-8.4.9L77.3,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.3l69.8,54.3A8.1,8.1,0,0,0,152,232a8.5,8.5,0,0,0,3.5-.8A7.8,7.8,0,0,0,160,224V32A8.1,8.1,0,0,0,155.5,24.8ZM32,96H72v64H32Z" }, null, -1), x_i = /* @__PURE__ */ e("path", { d: "M185,99.7a7.9,7.9,0,0,0,0,11.3,24.1,24.1,0,0,1,0,34,7.9,7.9,0,0,0,0,11.3,7.6,7.6,0,0,0,5.6,2.3,7.8,7.8,0,0,0,5.7-2.3,40.1,40.1,0,0,0,0-56.6A8,8,0,0,0,185,99.7Z" }, null, -1), j_i = [
  f_i,
  g_i,
  x_i
], m_i = { key: 3 }, M_i = ["stroke"], v_i = ["stroke"], S_i = ["stroke"], H_i = ["stroke"], A_i = { key: 4 }, V_i = ["stroke"], z_i = ["stroke"], Z_i = ["stroke"], C_i = ["stroke"], b_i = { key: 5 }, L_i = ["stroke"], B_i = ["stroke"], P_i = ["stroke"], W_i = ["stroke"], N_i = {
  name: "PhSpeakerHigh"
}, mel = /* @__PURE__ */ $({
  ...N_i,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", l_i, [
        e("path", {
          d: "M218.9,77.1a71.9,71.9,0,0,1,0,101.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, d_i),
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, k_i),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, c_i),
        e("path", {
          d: "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, h_i)
      ])) : o(i) === "duotone" ? (s(), r("g", u_i, [
        a_i,
        e("path", {
          d: "M218.9,77.1a71.9,71.9,0,0,1,0,101.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, __i),
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p_i),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y_i),
        e("path", {
          d: "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $_i)
      ])) : o(i) === "fill" ? (s(), r("g", w_i, j_i)) : o(i) === "light" ? (s(), r("g", m_i, [
        e("path", {
          d: "M218.9,77.1a71.9,71.9,0,0,1,0,101.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, M_i),
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, v_i),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, S_i),
        e("path", {
          d: "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, H_i)
      ])) : o(i) === "thin" ? (s(), r("g", A_i, [
        e("path", {
          d: "M218.9,77.1a71.9,71.9,0,0,1,0,101.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, V_i),
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, z_i),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Z_i),
        e("path", {
          d: "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, C_i)
      ])) : o(i) === "regular" ? (s(), r("g", b_i, [
        e("path", {
          d: "M218.9,77.1a71.9,71.9,0,0,1,0,101.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L_i),
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B_i),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P_i),
        e("path", {
          d: "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W_i)
      ])) : g("", !0)
    ], 16, i_i));
  }
}), F_i = ["width", "height", "fill", "transform"], T_i = { key: 0 }, D_i = ["stroke"], R_i = ["stroke"], U_i = ["stroke"], q_i = { key: 1 }, G_i = /* @__PURE__ */ e("path", {
  d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80Z",
  opacity: "0.2"
}, null, -1), E_i = ["stroke"], O_i = ["stroke"], I_i = ["stroke"], K_i = { key: 2 }, X_i = /* @__PURE__ */ e("path", { d: "M155.5,24.8a8,8,0,0,0-8.4.9L77.3,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.3l69.8,54.3A8.1,8.1,0,0,0,152,232a8.5,8.5,0,0,0,3.5-.8A8,8,0,0,0,160,224V32A8.1,8.1,0,0,0,155.5,24.8ZM32,96H72v64H32Z" }, null, -1), J_i = /* @__PURE__ */ e("path", { d: "M196.3,99.7a8,8,0,0,0-11.3,0,7.9,7.9,0,0,0,0,11.3,24.1,24.1,0,0,1,0,34,7.9,7.9,0,0,0,0,11.3,7.6,7.6,0,0,0,5.6,2.3,7.8,7.8,0,0,0,5.7-2.3,40.1,40.1,0,0,0,0-56.6Z" }, null, -1), Q_i = [
  X_i,
  J_i
], Y_i = { key: 3 }, opi = ["stroke"], epi = ["stroke"], tpi = ["stroke"], npi = { key: 4 }, spi = ["stroke"], rpi = ["stroke"], ipi = ["stroke"], lpi = { key: 5 }, dpi = ["stroke"], kpi = ["stroke"], cpi = ["stroke"], hpi = {
  name: "PhSpeakerLow"
}, Mel = /* @__PURE__ */ $({
  ...hpi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", T_i, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, D_i),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, R_i),
        e("path", {
          d: "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, U_i)
      ])) : o(i) === "duotone" ? (s(), r("g", q_i, [
        G_i,
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E_i),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O_i),
        e("path", {
          d: "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I_i)
      ])) : o(i) === "fill" ? (s(), r("g", K_i, Q_i)) : o(i) === "light" ? (s(), r("g", Y_i, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, opi),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, epi),
        e("path", {
          d: "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tpi)
      ])) : o(i) === "thin" ? (s(), r("g", npi, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, spi),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rpi),
        e("path", {
          d: "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ipi)
      ])) : o(i) === "regular" ? (s(), r("g", lpi, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dpi),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kpi),
        e("path", {
          d: "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cpi)
      ])) : g("", !0)
    ], 16, F_i));
  }
}), upi = ["width", "height", "fill", "transform"], api = { key: 0 }, _pi = ["stroke"], ppi = ["stroke"], ypi = { key: 1 }, $pi = /* @__PURE__ */ e("path", {
  d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80Z",
  opacity: "0.2"
}, null, -1), wpi = ["stroke"], fpi = ["stroke"], gpi = { key: 2 }, xpi = /* @__PURE__ */ e("path", { d: "M155.5,24.8a8,8,0,0,0-8.4.9L77.3,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.3l69.8,54.3A8.1,8.1,0,0,0,152,232a8.5,8.5,0,0,0,3.5-.8A8,8,0,0,0,160,224V32A8,8,0,0,0,155.5,24.8ZM32,96H72v64H32Z" }, null, -1), jpi = [
  xpi
], mpi = { key: 3 }, Mpi = ["stroke"], vpi = ["stroke"], Spi = { key: 4 }, Hpi = ["stroke"], Api = ["stroke"], Vpi = { key: 5 }, zpi = ["stroke"], Zpi = ["stroke"], Cpi = {
  name: "PhSpeakerNone"
}, vel = /* @__PURE__ */ $({
  ...Cpi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", api, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _pi),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ppi)
      ])) : o(i) === "duotone" ? (s(), r("g", ypi, [
        $pi,
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wpi),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fpi)
      ])) : o(i) === "fill" ? (s(), r("g", gpi, jpi)) : o(i) === "light" ? (s(), r("g", mpi, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mpi),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vpi)
      ])) : o(i) === "thin" ? (s(), r("g", Spi, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hpi),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Api)
      ])) : o(i) === "regular" ? (s(), r("g", Vpi, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zpi),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zpi)
      ])) : g("", !0)
    ], 16, upi));
  }
}), bpi = ["width", "height", "fill", "transform"], Lpi = { key: 0 }, Bpi = ["stroke"], Ppi = ["stroke"], Wpi = ["stroke"], Npi = { key: 1 }, Fpi = /* @__PURE__ */ e("path", {
  d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
  opacity: "0.2"
}, null, -1), Tpi = ["stroke"], Dpi = ["stroke"], Rpi = ["stroke"], Upi = { key: 2 }, qpi = /* @__PURE__ */ e("path", { d: "M155.5,24.8a8,8,0,0,0-8.4.9L77.2,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.2l69.9,54.3A7.9,7.9,0,0,0,152,232a8.5,8.5,0,0,0,3.5-.8A8,8,0,0,0,160,224V32A8,8,0,0,0,155.5,24.8Z" }, null, -1), Gpi = /* @__PURE__ */ e("path", { d: "M192,96a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0V104A8,8,0,0,0,192,96Z" }, null, -1), Epi = /* @__PURE__ */ e("path", { d: "M224,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,224,80Z" }, null, -1), Opi = [
  qpi,
  Gpi,
  Epi
], Ipi = { key: 3 }, Kpi = ["stroke"], Xpi = ["stroke"], Jpi = ["stroke"], Qpi = { key: 4 }, Ypi = ["stroke"], o3i = ["stroke"], e3i = ["stroke"], t3i = { key: 5 }, n3i = ["stroke"], s3i = ["stroke"], r3i = ["stroke"], i3i = {
  name: "PhSpeakerSimpleHigh"
}, Sel = /* @__PURE__ */ $({
  ...i3i,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Lpi, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bpi),
        e("line", {
          x1: "192",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ppi),
        e("line", {
          x1: "228",
          y1: "88",
          x2: "228",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wpi)
      ])) : o(i) === "duotone" ? (s(), r("g", Npi, [
        Fpi,
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tpi),
        e("line", {
          x1: "192",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dpi),
        e("line", {
          x1: "224",
          y1: "88",
          x2: "224",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rpi)
      ])) : o(i) === "fill" ? (s(), r("g", Upi, Opi)) : o(i) === "light" ? (s(), r("g", Ipi, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kpi),
        e("line", {
          x1: "192",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xpi),
        e("line", {
          x1: "224",
          y1: "88",
          x2: "224",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jpi)
      ])) : o(i) === "thin" ? (s(), r("g", Qpi, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ypi),
        e("line", {
          x1: "192",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, o3i),
        e("line", {
          x1: "224",
          y1: "88",
          x2: "224",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, e3i)
      ])) : o(i) === "regular" ? (s(), r("g", t3i, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n3i),
        e("line", {
          x1: "192",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s3i),
        e("line", {
          x1: "224",
          y1: "88",
          x2: "224",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r3i)
      ])) : g("", !0)
    ], 16, bpi));
  }
}), l3i = ["width", "height", "fill", "transform"], d3i = { key: 0 }, k3i = ["stroke"], c3i = ["stroke"], h3i = { key: 1 }, u3i = /* @__PURE__ */ e("path", {
  d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
  opacity: "0.2"
}, null, -1), a3i = ["stroke"], _3i = ["stroke"], p3i = { key: 2 }, y3i = /* @__PURE__ */ e("path", { d: "M155.5,24.8a8,8,0,0,0-8.4.9L77.2,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.2l69.9,54.3A7.9,7.9,0,0,0,152,232a8.5,8.5,0,0,0,3.5-.8A8,8,0,0,0,160,224V32A8,8,0,0,0,155.5,24.8Z" }, null, -1), $3i = /* @__PURE__ */ e("path", { d: "M192,96a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0V104A8,8,0,0,0,192,96Z" }, null, -1), w3i = [
  y3i,
  $3i
], f3i = { key: 3 }, g3i = ["stroke"], x3i = ["stroke"], j3i = { key: 4 }, m3i = ["stroke"], M3i = ["stroke"], v3i = { key: 5 }, S3i = ["stroke"], H3i = ["stroke"], A3i = {
  name: "PhSpeakerSimpleLow"
}, Hel = /* @__PURE__ */ $({
  ...A3i,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", d3i, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, k3i),
        e("line", {
          x1: "192",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, c3i)
      ])) : o(i) === "duotone" ? (s(), r("g", h3i, [
        u3i,
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a3i),
        e("line", {
          x1: "192",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _3i)
      ])) : o(i) === "fill" ? (s(), r("g", p3i, w3i)) : o(i) === "light" ? (s(), r("g", f3i, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, g3i),
        e("line", {
          x1: "192",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, x3i)
      ])) : o(i) === "thin" ? (s(), r("g", j3i, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, m3i),
        e("line", {
          x1: "192",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, M3i)
      ])) : o(i) === "regular" ? (s(), r("g", v3i, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S3i),
        e("line", {
          x1: "192",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H3i)
      ])) : g("", !0)
    ], 16, l3i));
  }
}), V3i = ["width", "height", "fill", "transform"], z3i = { key: 0 }, Z3i = ["stroke"], C3i = { key: 1 }, b3i = /* @__PURE__ */ e("path", {
  d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
  opacity: "0.2"
}, null, -1), L3i = ["stroke"], B3i = { key: 2 }, P3i = /* @__PURE__ */ e("path", { d: "M155.5,24.8a8,8,0,0,0-8.4.9L77.2,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.2l69.9,54.3A7.9,7.9,0,0,0,152,232a8.5,8.5,0,0,0,3.5-.8A8,8,0,0,0,160,224V32A8,8,0,0,0,155.5,24.8Z" }, null, -1), W3i = [
  P3i
], N3i = { key: 3 }, F3i = ["stroke"], T3i = { key: 4 }, D3i = ["stroke"], R3i = { key: 5 }, U3i = ["stroke"], q3i = {
  name: "PhSpeakerSimpleNone"
}, Ael = /* @__PURE__ */ $({
  ...q3i,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", z3i, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Z3i)
      ])) : o(i) === "duotone" ? (s(), r("g", C3i, [
        b3i,
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L3i)
      ])) : o(i) === "fill" ? (s(), r("g", B3i, W3i)) : o(i) === "light" ? (s(), r("g", N3i, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, F3i)
      ])) : o(i) === "thin" ? (s(), r("g", T3i, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, D3i)
      ])) : o(i) === "regular" ? (s(), r("g", R3i, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U3i)
      ])) : g("", !0)
    ], 16, V3i));
  }
}), G3i = ["width", "height", "fill", "transform"], E3i = { key: 0 }, O3i = ["stroke"], I3i = ["stroke"], K3i = ["stroke"], X3i = ["stroke"], J3i = ["stroke"], Q3i = { key: 1 }, Y3i = /* @__PURE__ */ e("path", {
  d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
  opacity: "0.2"
}, null, -1), oyi = ["stroke"], eyi = ["stroke"], tyi = ["stroke"], nyi = ["stroke"], syi = ["stroke"], ryi = { key: 2 }, iyi = /* @__PURE__ */ e("path", { d: "M192,160a8,8,0,0,0,8-8V104a8,8,0,0,0-16,0v48A8,8,0,0,0,192,160Z" }, null, -1), lyi = /* @__PURE__ */ e("path", { d: "M224,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,224,80Z" }, null, -1), dyi = /* @__PURE__ */ e("path", { d: "M53.9,34.6A8,8,0,0,0,42.1,45.4L73.6,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.3l69.8,54.3A8.1,8.1,0,0,0,152,232a8.5,8.5,0,0,0,3.5-.8A8,8,0,0,0,160,224V175.1l42.1,46.3A8,8,0,0,0,208,224a8.2,8.2,0,0,0,5.4-2.1,7.9,7.9,0,0,0,.5-11.3Z" }, null, -1), kyi = /* @__PURE__ */ e("path", { d: "M146.1,112.2a7.9,7.9,0,0,0,5.9,2.6,7.4,7.4,0,0,0,2.9-.5,8,8,0,0,0,5.1-7.5V32a8,8,0,0,0-12.9-6.3l-39.9,31a8.1,8.1,0,0,0-1,11.7Z" }, null, -1), cyi = [
  iyi,
  lyi,
  dyi,
  kyi
], hyi = { key: 3 }, uyi = ["stroke"], ayi = ["stroke"], _yi = ["stroke"], pyi = ["stroke"], yyi = ["stroke"], $yi = { key: 4 }, wyi = ["stroke"], fyi = ["stroke"], gyi = ["stroke"], xyi = ["stroke"], jyi = ["stroke"], myi = { key: 5 }, Myi = ["stroke"], vyi = ["stroke"], Syi = ["stroke"], Hyi = ["stroke"], Ayi = ["stroke"], Vyi = {
  name: "PhSpeakerSimpleSlash"
}, Vel = /* @__PURE__ */ $({
  ...Vyi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", E3i, [
        e("line", {
          x1: "228",
          y1: "88",
          x2: "228",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, O3i),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, I3i),
        e("path", {
          d: "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H91.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, K3i),
        e("polyline", {
          points: "118.5 58.1 152 32 152 94.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X3i),
        e("line", {
          x1: "192",
          y1: "104",
          x2: "192",
          y2: "138.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, J3i)
      ])) : o(i) === "duotone" ? (s(), r("g", Q3i, [
        Y3i,
        e("line", {
          x1: "192",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oyi),
        e("line", {
          x1: "224",
          y1: "88",
          x2: "224",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eyi),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tyi),
        e("polyline", {
          points: "112.2 63 152 32 152 106.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nyi),
        e("path", {
          d: "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H91.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, syi)
      ])) : o(i) === "fill" ? (s(), r("g", ryi, cyi)) : o(i) === "light" ? (s(), r("g", hyi, [
        e("line", {
          x1: "192",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uyi),
        e("line", {
          x1: "224",
          y1: "88",
          x2: "224",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ayi),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _yi),
        e("polyline", {
          points: "112.2 63 152 32 152 106.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pyi),
        e("path", {
          d: "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H91.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yyi)
      ])) : o(i) === "thin" ? (s(), r("g", $yi, [
        e("line", {
          x1: "192",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wyi),
        e("line", {
          x1: "224",
          y1: "88",
          x2: "224",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fyi),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gyi),
        e("polyline", {
          points: "112.2 63 152 32 152 106.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xyi),
        e("path", {
          d: "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H91.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jyi)
      ])) : o(i) === "regular" ? (s(), r("g", myi, [
        e("line", {
          x1: "192",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Myi),
        e("line", {
          x1: "224",
          y1: "88",
          x2: "224",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vyi),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Syi),
        e("polyline", {
          points: "112.2 63 152 32 152 106.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hyi),
        e("path", {
          d: "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H91.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ayi)
      ])) : g("", !0)
    ], 16, G3i));
  }
}), zyi = ["width", "height", "fill", "transform"], Zyi = { key: 0 }, Cyi = ["stroke"], byi = ["stroke"], Lyi = ["stroke"], Byi = { key: 1 }, Pyi = /* @__PURE__ */ e("path", {
  d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
  opacity: "0.2"
}, null, -1), Wyi = ["stroke"], Nyi = ["stroke"], Fyi = ["stroke"], Tyi = { key: 2 }, Dyi = /* @__PURE__ */ e("path", { d: "M155.5,24.8a8,8,0,0,0-8.4.9L77.2,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.2l69.9,54.3A7.9,7.9,0,0,0,152,232a8.5,8.5,0,0,0,3.5-.8A8,8,0,0,0,160,224V32A8,8,0,0,0,155.5,24.8Z" }, null, -1), Ryi = /* @__PURE__ */ e("path", { d: "M227.3,128l18.4-18.3a8.1,8.1,0,0,0-11.4-11.4L216,116.7,197.7,98.3a8.1,8.1,0,0,0-11.4,11.4L204.7,128l-18.4,18.3a8.1,8.1,0,0,0,0,11.4A8.3,8.3,0,0,0,192,160a8.5,8.5,0,0,0,5.7-2.3L216,139.3l18.3,18.4A8.3,8.3,0,0,0,240,160a8.5,8.5,0,0,0,5.7-2.3,8.1,8.1,0,0,0,0-11.4Z" }, null, -1), Uyi = [
  Dyi,
  Ryi
], qyi = { key: 3 }, Gyi = ["stroke"], Eyi = ["stroke"], Oyi = ["stroke"], Iyi = { key: 4 }, Kyi = ["stroke"], Xyi = ["stroke"], Jyi = ["stroke"], Qyi = { key: 5 }, Yyi = ["stroke"], o5i = ["stroke"], e5i = ["stroke"], t5i = {
  name: "PhSpeakerSimpleX"
}, zel = /* @__PURE__ */ $({
  ...t5i,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Zyi, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cyi),
        e("line", {
          x1: "240",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, byi),
        e("line", {
          x1: "240",
          y1: "152",
          x2: "192",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lyi)
      ])) : o(i) === "duotone" ? (s(), r("g", Byi, [
        Pyi,
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wyi),
        e("line", {
          x1: "240",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nyi),
        e("line", {
          x1: "240",
          y1: "152",
          x2: "192",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fyi)
      ])) : o(i) === "fill" ? (s(), r("g", Tyi, Uyi)) : o(i) === "light" ? (s(), r("g", qyi, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gyi),
        e("line", {
          x1: "240",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Eyi),
        e("line", {
          x1: "240",
          y1: "152",
          x2: "192",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Oyi)
      ])) : o(i) === "thin" ? (s(), r("g", Iyi, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kyi),
        e("line", {
          x1: "240",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xyi),
        e("line", {
          x1: "240",
          y1: "152",
          x2: "192",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jyi)
      ])) : o(i) === "regular" ? (s(), r("g", Qyi, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yyi),
        e("line", {
          x1: "240",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o5i),
        e("line", {
          x1: "240",
          y1: "152",
          x2: "192",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e5i)
      ])) : g("", !0)
    ], 16, zyi));
  }
}), n5i = ["width", "height", "fill", "transform"], s5i = { key: 0 }, r5i = ["stroke"], i5i = ["stroke"], l5i = ["stroke"], d5i = ["stroke"], k5i = ["stroke"], c5i = ["stroke"], h5i = { key: 1 }, u5i = /* @__PURE__ */ e("path", {
  d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80Z",
  opacity: "0.2"
}, null, -1), a5i = ["stroke"], _5i = ["stroke"], p5i = ["stroke"], y5i = ["stroke"], $5i = ["stroke"], w5i = ["stroke"], f5i = { key: 2 }, g5i = /* @__PURE__ */ e("path", { d: "M53.9,34.6A8,8,0,0,0,42.1,45.4L73.6,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.3l69.8,54.3h0A7.9,7.9,0,0,0,152,232a8.5,8.5,0,0,0,3.5-.8A8,8,0,0,0,160,224V175.1l42.1,46.3A8,8,0,0,0,208,224a8.2,8.2,0,0,0,5.4-2.1,7.9,7.9,0,0,0,.5-11.3ZM72,160H32V96H72Z" }, null, -1), x5i = /* @__PURE__ */ e("path", { d: "M146.1,112.2a7.9,7.9,0,0,0,5.9,2.6,7.4,7.4,0,0,0,2.9-.5,8,8,0,0,0,5.1-7.5V32a8,8,0,0,0-12.9-6.3l-39.9,31a8.2,8.2,0,0,0-3,5.6,8.1,8.1,0,0,0,2,6.1Z" }, null, -1), j5i = /* @__PURE__ */ e("path", { d: "M224.5,71.4a8,8,0,0,0-11.3,0,8.1,8.1,0,0,0,0,11.4,63.9,63.9,0,0,1,0,90.5,8,8,0,0,0,0,11.3,8.3,8.3,0,0,0,5.7,2.3,8,8,0,0,0,5.6-2.3,79.9,79.9,0,0,0,0-113.2Z" }, null, -1), m5i = /* @__PURE__ */ e("path", { d: "M192,128a23.8,23.8,0,0,1-7.1,17,8,8,0,0,0,5.7,13.6,7.8,7.8,0,0,0,5.7-2.3,40.1,40.1,0,0,0,0-56.6,8.1,8.1,0,0,0-11.4,0,8,8,0,0,0,0,11.3A23.8,23.8,0,0,1,192,128Z" }, null, -1), M5i = [
  g5i,
  x5i,
  j5i,
  m5i
], v5i = { key: 3 }, S5i = ["stroke"], H5i = ["stroke"], A5i = ["stroke"], V5i = ["stroke"], z5i = ["stroke"], Z5i = ["stroke"], C5i = { key: 4 }, b5i = ["stroke"], L5i = ["stroke"], B5i = ["stroke"], P5i = ["stroke"], W5i = ["stroke"], N5i = ["stroke"], F5i = { key: 5 }, T5i = ["stroke"], D5i = ["stroke"], R5i = ["stroke"], U5i = ["stroke"], q5i = ["stroke"], G5i = ["stroke"], E5i = {
  name: "PhSpeakerSlash"
}, Zel = /* @__PURE__ */ $({
  ...E5i,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", s5i, [
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, r5i),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, i5i),
        e("path", {
          d: "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l6.8-5.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, l5i),
        e("polyline", {
          points: "118.5 58.1 152 32 152 94.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, d5i),
        e("path", {
          d: "M190.6,105.4a31.9,31.9,0,0,1,5.5,37.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, k5i),
        e("path", {
          d: "M218.9,77.1a71.9,71.9,0,0,1,4.7,96.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, c5i)
      ])) : o(i) === "duotone" ? (s(), r("g", h5i, [
        u5i,
        e("path", {
          d: "M218.9,77.1a71.9,71.9,0,0,1,0,101.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a5i),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _5i),
        e("path", {
          d: "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p5i),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y5i),
        e("path", {
          d: "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l6.8-5.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $5i),
        e("polyline", {
          points: "112.2 63 152 32 152 106.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w5i)
      ])) : o(i) === "fill" ? (s(), r("g", f5i, M5i)) : o(i) === "light" ? (s(), r("g", v5i, [
        e("path", {
          d: "M218.9,77.1a71.9,71.9,0,0,1,0,101.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, S5i),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, H5i),
        e("path", {
          d: "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, A5i),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, V5i),
        e("path", {
          d: "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l6.8-5.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, z5i),
        e("polyline", {
          points: "112.2 63 152 32 152 106.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Z5i)
      ])) : o(i) === "thin" ? (s(), r("g", C5i, [
        e("path", {
          d: "M218.9,77.1a71.9,71.9,0,0,1,0,101.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, b5i),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, L5i),
        e("path", {
          d: "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, B5i),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, P5i),
        e("path", {
          d: "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l6.8-5.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, W5i),
        e("polyline", {
          points: "112.2 63 152 32 152 106.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, N5i)
      ])) : o(i) === "regular" ? (s(), r("g", F5i, [
        e("path", {
          d: "M218.9,77.1a71.9,71.9,0,0,1,0,101.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T5i),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D5i),
        e("path", {
          d: "M190.6,105.4a31.9,31.9,0,0,1,0,45.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R5i),
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U5i),
        e("path", {
          d: "M152,154.4V224L80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l6.8-5.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q5i),
        e("polyline", {
          points: "112.2 63 152 32 152 106.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G5i)
      ])) : g("", !0)
    ], 16, n5i));
  }
}), O5i = ["width", "height", "fill", "transform"], I5i = { key: 0 }, K5i = ["stroke"], X5i = ["stroke"], J5i = ["stroke"], Q5i = ["stroke"], Y5i = { key: 1 }, o7i = /* @__PURE__ */ e("path", {
  d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80Z",
  opacity: "0.2"
}, null, -1), e7i = ["stroke"], t7i = ["stroke"], n7i = ["stroke"], s7i = ["stroke"], r7i = { key: 2 }, i7i = /* @__PURE__ */ e("path", { d: "M155.5,24.8a8,8,0,0,0-8.4.9L77.3,80H32A16,16,0,0,0,16,96v64a16,16,0,0,0,16,16H77.3l69.8,54.3A8.1,8.1,0,0,0,152,232a8.5,8.5,0,0,0,3.5-.8A8,8,0,0,0,160,224V32A8,8,0,0,0,155.5,24.8ZM32,96H72v64H32Z" }, null, -1), l7i = /* @__PURE__ */ e("path", { d: "M227.3,128l18.4-18.3a8.1,8.1,0,0,0-11.4-11.4L216,116.7,197.7,98.3a8.1,8.1,0,0,0-11.4,11.4L204.7,128l-18.4,18.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L216,139.3l18.3,18.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4Z" }, null, -1), d7i = [
  i7i,
  l7i
], k7i = { key: 3 }, c7i = ["stroke"], h7i = ["stroke"], u7i = ["stroke"], a7i = ["stroke"], _7i = { key: 4 }, p7i = ["stroke"], y7i = ["stroke"], $7i = ["stroke"], w7i = ["stroke"], f7i = { key: 5 }, g7i = ["stroke"], x7i = ["stroke"], j7i = ["stroke"], m7i = ["stroke"], M7i = {
  name: "PhSpeakerX"
}, Cel = /* @__PURE__ */ $({
  ...M7i,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", I5i, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, K5i),
        e("line", {
          x1: "240",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X5i),
        e("line", {
          x1: "240",
          y1: "152",
          x2: "192",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, J5i),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Q5i)
      ])) : o(i) === "duotone" ? (s(), r("g", Y5i, [
        o7i,
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e7i),
        e("line", {
          x1: "240",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t7i),
        e("line", {
          x1: "240",
          y1: "152",
          x2: "192",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n7i),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s7i)
      ])) : o(i) === "fill" ? (s(), r("g", r7i, d7i)) : o(i) === "light" ? (s(), r("g", k7i, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, c7i),
        e("line", {
          x1: "240",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, h7i),
        e("line", {
          x1: "240",
          y1: "152",
          x2: "192",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u7i),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, a7i)
      ])) : o(i) === "thin" ? (s(), r("g", _7i, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, p7i),
        e("line", {
          x1: "240",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, y7i),
        e("line", {
          x1: "240",
          y1: "152",
          x2: "192",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $7i),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, w7i)
      ])) : o(i) === "regular" ? (s(), r("g", f7i, [
        e("path", {
          d: "M80,168H32a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8H80l72-56V224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g7i),
        e("line", {
          x1: "240",
          y1: "104",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, x7i),
        e("line", {
          x1: "240",
          y1: "152",
          x2: "192",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j7i),
        e("line", {
          x1: "80",
          y1: "88",
          x2: "80",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m7i)
      ])) : g("", !0)
    ], 16, O5i));
  }
}), v7i = ["width", "height", "fill", "transform"], S7i = { key: 0 }, H7i = ["stroke"], A7i = ["stroke"], V7i = ["stroke"], z7i = ["stroke"], Z7i = ["stroke"], C7i = ["stroke"], b7i = ["stroke"], L7i = ["stroke"], B7i = { key: 1 }, P7i = ["stroke"], W7i = ["stroke"], N7i = ["stroke"], F7i = ["stroke"], T7i = ["stroke"], D7i = ["stroke"], R7i = ["stroke"], U7i = ["stroke"], q7i = { key: 2 }, G7i = /* @__PURE__ */ e("path", { d: "M136,32V64a8,8,0,0,1-16,0V32a8,8,0,0,1,16,0Zm37.3,58.7a7.8,7.8,0,0,0,5.6-2.3l22.6-22.6a8,8,0,1,0-11.3-11.3L167.6,77.1a8,8,0,0,0,0,11.3A7.8,7.8,0,0,0,173.3,90.7ZM224,120H192a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm-45.1,47.6a8,8,0,0,0-11.3,11.3l22.6,22.6a8,8,0,0,0,5.7,2.4,7.7,7.7,0,0,0,5.6-2.4,7.9,7.9,0,0,0,0-11.3ZM128,184a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V192A8,8,0,0,0,128,184ZM77.1,167.6,54.5,190.2a7.9,7.9,0,0,0,0,11.3,7.7,7.7,0,0,0,5.6,2.4,8,8,0,0,0,5.7-2.4l22.6-22.6a8,8,0,0,0-11.3-11.3ZM72,128a8,8,0,0,0-8-8H32a8,8,0,0,0,0,16H64A8,8,0,0,0,72,128ZM65.8,54.5A8,8,0,0,0,54.5,65.8L77.1,88.4a8.1,8.1,0,0,0,11.3,0,8,8,0,0,0,0-11.3Z" }, null, -1), E7i = [
  G7i
], O7i = { key: 3 }, I7i = ["stroke"], K7i = ["stroke"], X7i = ["stroke"], J7i = ["stroke"], Q7i = ["stroke"], Y7i = ["stroke"], o9i = ["stroke"], e9i = ["stroke"], t9i = { key: 4 }, n9i = ["stroke"], s9i = ["stroke"], r9i = ["stroke"], i9i = ["stroke"], l9i = ["stroke"], d9i = ["stroke"], k9i = ["stroke"], c9i = ["stroke"], h9i = { key: 5 }, u9i = ["stroke"], a9i = ["stroke"], _9i = ["stroke"], p9i = ["stroke"], y9i = ["stroke"], $9i = ["stroke"], w9i = ["stroke"], f9i = ["stroke"], g9i = {
  name: "PhSpinner"
}, bel = /* @__PURE__ */ $({
  ...g9i,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", S7i, [
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, H7i),
        e("line", {
          x1: "195.9",
          y1: "60.1",
          x2: "173.3",
          y2: "82.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, A7i),
        e("line", {
          x1: "224",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, V7i),
        e("line", {
          x1: "195.9",
          y1: "195.9",
          x2: "173.3",
          y2: "173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, z7i),
        e("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Z7i),
        e("line", {
          x1: "60.1",
          y1: "195.9",
          x2: "82.7",
          y2: "173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, C7i),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "64",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, b7i),
        e("line", {
          x1: "60.1",
          y1: "60.1",
          x2: "82.7",
          y2: "82.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, L7i)
      ])) : o(i) === "duotone" ? (s(), r("g", B7i, [
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P7i),
        e("line", {
          x1: "195.9",
          y1: "60.1",
          x2: "173.3",
          y2: "82.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W7i),
        e("line", {
          x1: "224",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N7i),
        e("line", {
          x1: "195.9",
          y1: "195.9",
          x2: "173.3",
          y2: "173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F7i),
        e("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T7i),
        e("line", {
          x1: "60.1",
          y1: "195.9",
          x2: "82.7",
          y2: "173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D7i),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "64",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R7i),
        e("line", {
          x1: "60.1",
          y1: "60.1",
          x2: "82.7",
          y2: "82.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U7i)
      ])) : o(i) === "fill" ? (s(), r("g", q7i, E7i)) : o(i) === "light" ? (s(), r("g", O7i, [
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, I7i),
        e("line", {
          x1: "195.9",
          y1: "60.1",
          x2: "173.3",
          y2: "82.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, K7i),
        e("line", {
          x1: "224",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, X7i),
        e("line", {
          x1: "195.9",
          y1: "195.9",
          x2: "173.3",
          y2: "173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, J7i),
        e("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Q7i),
        e("line", {
          x1: "60.1",
          y1: "195.9",
          x2: "82.7",
          y2: "173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Y7i),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "64",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, o9i),
        e("line", {
          x1: "60.1",
          y1: "60.1",
          x2: "82.7",
          y2: "82.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, e9i)
      ])) : o(i) === "thin" ? (s(), r("g", t9i, [
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, n9i),
        e("line", {
          x1: "195.9",
          y1: "60.1",
          x2: "173.3",
          y2: "82.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, s9i),
        e("line", {
          x1: "224",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, r9i),
        e("line", {
          x1: "195.9",
          y1: "195.9",
          x2: "173.3",
          y2: "173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, i9i),
        e("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, l9i),
        e("line", {
          x1: "60.1",
          y1: "195.9",
          x2: "82.7",
          y2: "173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, d9i),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "64",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, k9i),
        e("line", {
          x1: "60.1",
          y1: "60.1",
          x2: "82.7",
          y2: "82.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, c9i)
      ])) : o(i) === "regular" ? (s(), r("g", h9i, [
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u9i),
        e("line", {
          x1: "195.9",
          y1: "60.1",
          x2: "173.3",
          y2: "82.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a9i),
        e("line", {
          x1: "224",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _9i),
        e("line", {
          x1: "195.9",
          y1: "195.9",
          x2: "173.3",
          y2: "173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p9i),
        e("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y9i),
        e("line", {
          x1: "60.1",
          y1: "195.9",
          x2: "82.7",
          y2: "173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $9i),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "64",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w9i),
        e("line", {
          x1: "60.1",
          y1: "60.1",
          x2: "82.7",
          y2: "82.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f9i)
      ])) : g("", !0)
    ], 16, v7i));
  }
}), x9i = ["width", "height", "fill", "transform"], j9i = { key: 0 }, m9i = ["stroke"], M9i = ["stroke"], v9i = ["stroke"], S9i = ["stroke"], H9i = ["stroke"], A9i = ["stroke"], V9i = ["stroke"], z9i = { key: 1 }, Z9i = ["stroke"], C9i = ["stroke"], b9i = ["stroke"], L9i = ["stroke"], B9i = ["stroke"], P9i = ["stroke"], W9i = ["stroke"], N9i = { key: 2 }, F9i = /* @__PURE__ */ e("path", { d: "M136,32V64a8,8,0,0,1-16,0V32a8,8,0,0,1,16,0Zm88,88H192a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm-45.1,47.6a8,8,0,0,0-11.3,11.3l22.6,22.6a8,8,0,0,0,5.7,2.4,7.7,7.7,0,0,0,5.6-2.4,7.9,7.9,0,0,0,0-11.3ZM128,184a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V192A8,8,0,0,0,128,184ZM77.1,167.6,54.5,190.2a7.9,7.9,0,0,0,0,11.3,7.7,7.7,0,0,0,5.6,2.4,8,8,0,0,0,5.7-2.4l22.6-22.6a8,8,0,0,0-11.3-11.3ZM72,128a8,8,0,0,0-8-8H32a8,8,0,0,0,0,16H64A8,8,0,0,0,72,128ZM65.8,54.5A8,8,0,0,0,54.5,65.8L77.1,88.4a8.1,8.1,0,0,0,11.3,0,8,8,0,0,0,0-11.3Z" }, null, -1), T9i = [
  F9i
], D9i = { key: 3 }, R9i = ["stroke"], U9i = ["stroke"], q9i = ["stroke"], G9i = ["stroke"], E9i = ["stroke"], O9i = ["stroke"], I9i = ["stroke"], K9i = { key: 4 }, X9i = ["stroke"], J9i = ["stroke"], Q9i = ["stroke"], Y9i = ["stroke"], o$i = ["stroke"], e$i = ["stroke"], t$i = ["stroke"], n$i = { key: 5 }, s$i = ["stroke"], r$i = ["stroke"], i$i = ["stroke"], l$i = ["stroke"], d$i = ["stroke"], k$i = ["stroke"], c$i = ["stroke"], h$i = {
  name: "PhSpinnerGap"
}, Lel = /* @__PURE__ */ $({
  ...h$i,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", j9i, [
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, m9i),
        e("line", {
          x1: "224",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, M9i),
        e("line", {
          x1: "195.9",
          y1: "195.9",
          x2: "173.3",
          y2: "173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, v9i),
        e("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, S9i),
        e("line", {
          x1: "60.1",
          y1: "195.9",
          x2: "82.7",
          y2: "173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, H9i),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "64",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, A9i),
        e("line", {
          x1: "60.1",
          y1: "60.1",
          x2: "82.7",
          y2: "82.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, V9i)
      ])) : o(i) === "duotone" ? (s(), r("g", z9i, [
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z9i),
        e("line", {
          x1: "224",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C9i),
        e("line", {
          x1: "195.9",
          y1: "195.9",
          x2: "173.3",
          y2: "173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b9i),
        e("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L9i),
        e("line", {
          x1: "60.1",
          y1: "195.9",
          x2: "82.7",
          y2: "173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B9i),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "64",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P9i),
        e("line", {
          x1: "60.1",
          y1: "60.1",
          x2: "82.7",
          y2: "82.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W9i)
      ])) : o(i) === "fill" ? (s(), r("g", N9i, T9i)) : o(i) === "light" ? (s(), r("g", D9i, [
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, R9i),
        e("line", {
          x1: "224",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, U9i),
        e("line", {
          x1: "195.9",
          y1: "195.9",
          x2: "173.3",
          y2: "173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, q9i),
        e("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, G9i),
        e("line", {
          x1: "60.1",
          y1: "195.9",
          x2: "82.7",
          y2: "173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, E9i),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "64",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, O9i),
        e("line", {
          x1: "60.1",
          y1: "60.1",
          x2: "82.7",
          y2: "82.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, I9i)
      ])) : o(i) === "thin" ? (s(), r("g", K9i, [
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, X9i),
        e("line", {
          x1: "224",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, J9i),
        e("line", {
          x1: "195.9",
          y1: "195.9",
          x2: "173.3",
          y2: "173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Q9i),
        e("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Y9i),
        e("line", {
          x1: "60.1",
          y1: "195.9",
          x2: "82.7",
          y2: "173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, o$i),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "64",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, e$i),
        e("line", {
          x1: "60.1",
          y1: "60.1",
          x2: "82.7",
          y2: "82.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, t$i)
      ])) : o(i) === "regular" ? (s(), r("g", n$i, [
        e("line", {
          x1: "128",
          y1: "32",
          x2: "128",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, s$i),
        e("line", {
          x1: "224",
          y1: "128",
          x2: "192",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r$i),
        e("line", {
          x1: "195.9",
          y1: "195.9",
          x2: "173.3",
          y2: "173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, i$i),
        e("line", {
          x1: "128",
          y1: "224",
          x2: "128",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l$i),
        e("line", {
          x1: "60.1",
          y1: "195.9",
          x2: "82.7",
          y2: "173.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, d$i),
        e("line", {
          x1: "32",
          y1: "128",
          x2: "64",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k$i),
        e("line", {
          x1: "60.1",
          y1: "60.1",
          x2: "82.7",
          y2: "82.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c$i)
      ])) : g("", !0)
    ], 16, x9i));
  }
}), u$i = ["width", "height", "fill", "transform"], a$i = { key: 0 }, _$i = ["stroke"], p$i = { key: 1 }, y$i = ["stroke"], $$i = { key: 2 }, w$i = /* @__PURE__ */ e("path", { d: "M248,144a8,8,0,0,1-16,0,96.2,96.2,0,0,0-96-96,88.1,88.1,0,0,0-88,88,80.1,80.1,0,0,0,80,80,72.1,72.1,0,0,0,72-72,64.1,64.1,0,0,0-64-64,56,56,0,0,0-56,56,48,48,0,0,0,48,48,40,40,0,0,0,40-40,32.1,32.1,0,0,0-32-32,24.1,24.1,0,0,0-24,24,16,16,0,0,0,16,16,8,8,0,0,0,8-8,8,8,0,0,1,0-16,16,16,0,0,1,16,16,24.1,24.1,0,0,1-24,24,32.1,32.1,0,0,1-32-32,40,40,0,0,1,40-40,48,48,0,0,1,48,48,56,56,0,0,1-56,56,64.1,64.1,0,0,1-64-64,72.1,72.1,0,0,1,72-72,80.1,80.1,0,0,1,80,80,88.1,88.1,0,0,1-88,88,96.2,96.2,0,0,1-96-96A104.2,104.2,0,0,1,136,32,112.1,112.1,0,0,1,248,144Z" }, null, -1), f$i = [
  w$i
], g$i = { key: 3 }, x$i = ["stroke"], j$i = { key: 4 }, m$i = ["stroke"], M$i = { key: 5 }, v$i = ["stroke"], S$i = {
  name: "PhSpiral"
}, Bel = /* @__PURE__ */ $({
  ...S$i,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", a$i, [
        e("path", {
          d: "M124,136a8,8,0,0,1-8-8,16,16,0,0,1,16-16,25.9,25.9,0,0,1,26,26,36,36,0,0,1-36,36,46,46,0,0,1-46-46,56,56,0,0,1,56-56,65.9,65.9,0,0,1,66,66,76,76,0,0,1-76,76,86,86,0,0,1-86-86,96,96,0,0,1,96-96A106.1,106.1,0,0,1,238,138",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _$i)
      ])) : o(i) === "duotone" ? (s(), r("g", p$i, [
        e("path", {
          d: "M136,136a8,8,0,0,1,8,8,16,16,0,0,1-16,16,23.9,23.9,0,0,1-24-24,32,32,0,0,1,32-32,40,40,0,0,1,40,40,48,48,0,0,1-48,48,56,56,0,0,1-56-56,64.1,64.1,0,0,1,64-64,72,72,0,0,1,72,72,80,80,0,0,1-80,80,88,88,0,0,1-88-88,96,96,0,0,1,96-96A104,104,0,0,1,240,144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y$i)
      ])) : o(i) === "fill" ? (s(), r("g", $$i, f$i)) : o(i) === "light" ? (s(), r("g", g$i, [
        e("path", {
          d: "M136,136a8,8,0,0,1,8,8,16,16,0,0,1-16,16,23.9,23.9,0,0,1-24-24,32,32,0,0,1,32-32,40,40,0,0,1,40,40,48,48,0,0,1-48,48,56,56,0,0,1-56-56,64.1,64.1,0,0,1,64-64,72,72,0,0,1,72,72,80,80,0,0,1-80,80,88,88,0,0,1-88-88,96,96,0,0,1,96-96A104,104,0,0,1,240,144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, x$i)
      ])) : o(i) === "thin" ? (s(), r("g", j$i, [
        e("path", {
          d: "M136,136a8,8,0,0,1,8,8,16,16,0,0,1-16,16,23.9,23.9,0,0,1-24-24,32,32,0,0,1,32-32,40,40,0,0,1,40,40,48,48,0,0,1-48,48,56,56,0,0,1-56-56,64.1,64.1,0,0,1,64-64,72,72,0,0,1,72,72,80,80,0,0,1-80,80,88,88,0,0,1-88-88,96,96,0,0,1,96-96A104,104,0,0,1,240,144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, m$i)
      ])) : o(i) === "regular" ? (s(), r("g", M$i, [
        e("path", {
          d: "M136,136a8,8,0,0,1,8,8,16,16,0,0,1-16,16,23.9,23.9,0,0,1-24-24,32,32,0,0,1,32-32,40,40,0,0,1,40,40,48,48,0,0,1-48,48,56,56,0,0,1-56-56,64.1,64.1,0,0,1,64-64,72,72,0,0,1,72,72,80,80,0,0,1-80,80,88,88,0,0,1-88-88,96,96,0,0,1,96-96A104,104,0,0,1,240,144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v$i)
      ])) : g("", !0)
    ], 16, u$i));
  }
}), H$i = ["width", "height", "fill", "transform"], A$i = { key: 0 }, V$i = ["stroke"], z$i = ["stroke"], Z$i = ["stroke"], C$i = { key: 1 }, b$i = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), L$i = ["stroke"], B$i = ["stroke"], P$i = ["stroke"], W$i = ["stroke"], N$i = { key: 2 }, F$i = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm28.6,144.7a8,8,0,0,1-10.7,3.5A39.6,39.6,0,0,0,128,168a39.1,39.1,0,0,0-18,4.3,8.6,8.6,0,0,1-3.6.8,8,8,0,0,1-3.6-15.1,55.3,55.3,0,0,1,25.2-6,56.1,56.1,0,0,1,25.1,5.9A8.1,8.1,0,0,1,156.6,168.7Zm14.8-28.3a7.9,7.9,0,0,1-10.7,3.4,72,72,0,0,0-65.4.1,8.4,8.4,0,0,1-3.7.9,7.9,7.9,0,0,1-7.1-4.4A8,8,0,0,1,88,129.6a87.9,87.9,0,0,1,79.9,0A8,8,0,0,1,171.4,140.4ZM186.2,112a7.9,7.9,0,0,1-10.7,3.4A104.3,104.3,0,0,0,128,104a103.2,103.2,0,0,0-47.6,11.5,7.7,7.7,0,0,1-3.6.9,8,8,0,0,1-3.7-15.1,120.2,120.2,0,0,1,109.7-.1A8,8,0,0,1,186.2,112Z" }, null, -1), T$i = [
  F$i
], D$i = { key: 3 }, R$i = ["stroke"], U$i = ["stroke"], q$i = ["stroke"], G$i = ["stroke"], E$i = { key: 4 }, O$i = ["stroke"], I$i = ["stroke"], K$i = ["stroke"], X$i = ["stroke"], J$i = { key: 5 }, Q$i = ["stroke"], Y$i = ["stroke"], owi = ["stroke"], ewi = ["stroke"], twi = {
  name: "PhSpotifyLogo"
}, Pel = /* @__PURE__ */ $({
  ...twi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", A$i, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, V$i),
        e("path", {
          d: "M179.1,116.3a112.1,112.1,0,0,0-102.3.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, z$i),
        e("path", {
          d: "M158.7,155.3A68.4,68.4,0,0,0,128,148a67.6,67.6,0,0,0-30.8,7.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Z$i)
      ])) : o(i) === "duotone" ? (s(), r("g", C$i, [
        b$i,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L$i),
        e("path", {
          d: "M179.1,108.3a112.1,112.1,0,0,0-102.3.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B$i),
        e("path", {
          d: "M164.3,136.7a79.9,79.9,0,0,0-72.7.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P$i),
        e("path", {
          d: "M149.5,165.1A47.3,47.3,0,0,0,128,160a48.7,48.7,0,0,0-21.6,5.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W$i)
      ])) : o(i) === "fill" ? (s(), r("g", N$i, T$i)) : o(i) === "light" ? (s(), r("g", D$i, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, R$i),
        e("path", {
          d: "M179.1,108.3a112.1,112.1,0,0,0-102.3.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, U$i),
        e("path", {
          d: "M164.3,136.7a79.9,79.9,0,0,0-72.7.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, q$i),
        e("path", {
          d: "M149.5,165.1A47.3,47.3,0,0,0,128,160a48.7,48.7,0,0,0-21.6,5.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, G$i)
      ])) : o(i) === "thin" ? (s(), r("g", E$i, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, O$i),
        e("path", {
          d: "M179.1,108.3a112.1,112.1,0,0,0-102.3.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, I$i),
        e("path", {
          d: "M164.3,136.7a79.9,79.9,0,0,0-72.7.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, K$i),
        e("path", {
          d: "M149.5,165.1A47.3,47.3,0,0,0,128,160a48.7,48.7,0,0,0-21.6,5.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, X$i)
      ])) : o(i) === "regular" ? (s(), r("g", J$i, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q$i),
        e("path", {
          d: "M179.1,108.3a112.1,112.1,0,0,0-102.3.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y$i),
        e("path", {
          d: "M164.3,136.7a79.9,79.9,0,0,0-72.7.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, owi),
        e("path", {
          d: "M149.5,165.1A47.3,47.3,0,0,0,128,160a48.7,48.7,0,0,0-21.6,5.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ewi)
      ])) : g("", !0)
    ], 16, H$i));
  }
}), nwi = ["width", "height", "fill", "transform"], swi = { key: 0 }, rwi = ["stroke"], iwi = { key: 1 }, lwi = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), dwi = ["stroke"], kwi = { key: 2 }, cwi = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "32",
  width: "192",
  height: "192",
  rx: "16"
}, null, -1), hwi = [
  cwi
], uwi = { key: 3 }, awi = ["stroke"], _wi = { key: 4 }, pwi = ["stroke"], ywi = { key: 5 }, $wi = ["stroke"], wwi = {
  name: "PhSquare"
}, Wel = /* @__PURE__ */ $({
  ...wwi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", swi, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rwi)
      ])) : o(i) === "duotone" ? (s(), r("g", iwi, [
        lwi,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dwi)
      ])) : o(i) === "fill" ? (s(), r("g", kwi, hwi)) : o(i) === "light" ? (s(), r("g", uwi, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, awi)
      ])) : o(i) === "thin" ? (s(), r("g", _wi, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pwi)
      ])) : o(i) === "regular" ? (s(), r("g", ywi, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $wi)
      ])) : g("", !0)
    ], 16, nwi));
  }
}), fwi = ["width", "height", "fill", "transform"], gwi = { key: 0 }, xwi = ["stroke"], jwi = ["stroke"], mwi = ["stroke"], Mwi = ["stroke"], vwi = ["stroke"], Swi = { key: 1 }, Hwi = /* @__PURE__ */ e("path", {
  d: "M128,44h76a8,8,0,0,1,8,8V204a8,8,0,0,1-8,8H128Z",
  opacity: "0.2"
}, null, -1), Awi = ["stroke"], Vwi = ["stroke"], zwi = { key: 2 }, Zwi = /* @__PURE__ */ e("path", { d: "M204,36H52A16,16,0,0,0,36,52V204a16,16,0,0,0,16,16H204a16,16,0,0,0,16-16V52A16,16,0,0,0,204,36ZM52,52h76V204H52Z" }, null, -1), Cwi = [
  Zwi
], bwi = { key: 3 }, Lwi = ["stroke"], Bwi = ["stroke"], Pwi = ["stroke"], Wwi = ["stroke"], Nwi = ["stroke"], Fwi = ["stroke"], Twi = { key: 4 }, Dwi = ["stroke"], Rwi = ["stroke"], Uwi = ["stroke"], qwi = ["stroke"], Gwi = ["stroke"], Ewi = ["stroke"], Owi = { key: 5 }, Iwi = ["stroke"], Kwi = ["stroke"], Xwi = ["stroke"], Jwi = ["stroke"], Qwi = ["stroke"], Ywi = ["stroke"], ofi = {
  name: "PhSquareHalf"
}, Nel = /* @__PURE__ */ $({
  ...ofi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", gwi, [
        e("rect", {
          x: "44",
          y: "44",
          width: "168",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xwi),
        e("line", {
          x1: "128",
          y1: "44",
          x2: "128",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jwi),
        e("line", {
          x1: "128",
          y1: "84",
          x2: "212",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mwi),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "212",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mwi),
        e("line", {
          x1: "128",
          y1: "172",
          x2: "212",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vwi)
      ])) : o(i) === "duotone" ? (s(), r("g", Swi, [
        Hwi,
        e("rect", {
          x: "44",
          y: "44",
          width: "168",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Awi),
        e("line", {
          x1: "128",
          y1: "44",
          x2: "128",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vwi)
      ])) : o(i) === "fill" ? (s(), r("g", zwi, Cwi)) : o(i) === "light" ? (s(), r("g", bwi, [
        e("rect", {
          x: "44",
          y: "44",
          width: "168",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lwi),
        e("line", {
          x1: "128",
          y1: "44",
          x2: "128",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bwi),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pwi),
        e("line", {
          x1: "128",
          y1: "112",
          x2: "212",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wwi),
        e("line", {
          x1: "128",
          y1: "144",
          x2: "212",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Nwi),
        e("line", {
          x1: "128",
          y1: "176",
          x2: "212",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fwi)
      ])) : o(i) === "thin" ? (s(), r("g", Twi, [
        e("rect", {
          x: "44",
          y: "44",
          width: "168",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Dwi),
        e("line", {
          x1: "128",
          y1: "44",
          x2: "128",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Rwi),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Uwi),
        e("line", {
          x1: "128",
          y1: "112",
          x2: "212",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qwi),
        e("line", {
          x1: "128",
          y1: "144",
          x2: "212",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gwi),
        e("line", {
          x1: "128",
          y1: "176",
          x2: "212",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ewi)
      ])) : o(i) === "regular" ? (s(), r("g", Owi, [
        e("rect", {
          x: "44",
          y: "44",
          width: "168",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Iwi),
        e("line", {
          x1: "128",
          y1: "44",
          x2: "128",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kwi),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xwi),
        e("line", {
          x1: "128",
          y1: "112",
          x2: "212",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jwi),
        e("line", {
          x1: "128",
          y1: "144",
          x2: "212",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qwi),
        e("line", {
          x1: "128",
          y1: "176",
          x2: "212",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ywi)
      ])) : g("", !0)
    ], 16, fwi));
  }
}), efi = ["width", "height", "fill", "transform"], tfi = { key: 0 }, nfi = ["stroke"], sfi = ["stroke"], rfi = ["stroke"], ifi = ["stroke"], lfi = ["stroke"], dfi = { key: 1 }, kfi = /* @__PURE__ */ e("path", {
  d: "M44,128H212v76a8,8,0,0,1-8,8H52a8,8,0,0,1-8-8Z",
  opacity: "0.2"
}, null, -1), cfi = ["stroke"], hfi = ["stroke"], ufi = { key: 2 }, afi = /* @__PURE__ */ e("path", { d: "M204,36H52A16,16,0,0,0,36,52V204a16,16,0,0,0,16,16H204a16,16,0,0,0,16-16V52A16,16,0,0,0,204,36Zm0,16v76H52V52Z" }, null, -1), _fi = [
  afi
], pfi = { key: 3 }, yfi = ["stroke"], $fi = ["stroke"], wfi = ["stroke"], ffi = ["stroke"], gfi = ["stroke"], xfi = ["stroke"], jfi = { key: 4 }, mfi = ["stroke"], Mfi = ["stroke"], vfi = ["stroke"], Sfi = ["stroke"], Hfi = ["stroke"], Afi = ["stroke"], Vfi = { key: 5 }, zfi = ["stroke"], Zfi = ["stroke"], Cfi = ["stroke"], bfi = ["stroke"], Lfi = ["stroke"], Bfi = ["stroke"], Pfi = {
  name: "PhSquareHalfBottom"
}, Fel = /* @__PURE__ */ $({
  ...Pfi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", tfi, [
        e("rect", {
          x: "44",
          y: "44",
          width: "168",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nfi),
        e("line", {
          x1: "44",
          y1: "128",
          x2: "212",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sfi),
        e("line", {
          x1: "84",
          y1: "128",
          x2: "84",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rfi),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ifi),
        e("line", {
          x1: "172",
          y1: "128",
          x2: "172",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lfi)
      ])) : o(i) === "duotone" ? (s(), r("g", dfi, [
        kfi,
        e("rect", {
          x: "44",
          y: "44",
          width: "168",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cfi),
        e("line", {
          x1: "44",
          y1: "128",
          x2: "212",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hfi)
      ])) : o(i) === "fill" ? (s(), r("g", ufi, _fi)) : o(i) === "light" ? (s(), r("g", pfi, [
        e("rect", {
          x: "44",
          y: "44",
          width: "168",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yfi),
        e("line", {
          x1: "44",
          y1: "128",
          x2: "212",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $fi),
        e("line", {
          x1: "80",
          y1: "128",
          x2: "80",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wfi),
        e("line", {
          x1: "112",
          y1: "128",
          x2: "112",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ffi),
        e("line", {
          x1: "144",
          y1: "128",
          x2: "144",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gfi),
        e("line", {
          x1: "176",
          y1: "128",
          x2: "176",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xfi)
      ])) : o(i) === "thin" ? (s(), r("g", jfi, [
        e("rect", {
          x: "44",
          y: "44",
          width: "168",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mfi),
        e("line", {
          x1: "44",
          y1: "128",
          x2: "212",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Mfi),
        e("line", {
          x1: "80",
          y1: "128",
          x2: "80",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vfi),
        e("line", {
          x1: "112",
          y1: "128",
          x2: "112",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Sfi),
        e("line", {
          x1: "144",
          y1: "128",
          x2: "144",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hfi),
        e("line", {
          x1: "176",
          y1: "128",
          x2: "176",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Afi)
      ])) : o(i) === "regular" ? (s(), r("g", Vfi, [
        e("rect", {
          x: "44",
          y: "44",
          width: "168",
          height: "168",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zfi),
        e("line", {
          x1: "44",
          y1: "128",
          x2: "212",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zfi),
        e("line", {
          x1: "80",
          y1: "128",
          x2: "80",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cfi),
        e("line", {
          x1: "112",
          y1: "128",
          x2: "112",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bfi),
        e("line", {
          x1: "144",
          y1: "128",
          x2: "144",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lfi),
        e("line", {
          x1: "176",
          y1: "128",
          x2: "176",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bfi)
      ])) : g("", !0)
    ], 16, efi));
  }
}), Wfi = ["width", "height", "fill", "transform"], Nfi = { key: 0 }, Ffi = ["stroke"], Tfi = ["stroke"], Dfi = { key: 1 }, Rfi = /* @__PURE__ */ e("rect", {
  x: "96",
  y: "96",
  width: "64",
  height: "64",
  opacity: "0.2"
}, null, -1), Ufi = ["stroke"], qfi = ["stroke"], Gfi = { key: 2 }, Efi = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208ZM168,96v64a8,8,0,0,1-8,8H96a8,8,0,0,1-8-8V96a8,8,0,0,1,8-8h64A8,8,0,0,1,168,96Z" }, null, -1), Ofi = [
  Efi
], Ifi = { key: 3 }, Kfi = ["stroke"], Xfi = ["stroke"], Jfi = { key: 4 }, Qfi = ["stroke"], Yfi = ["stroke"], ogi = { key: 5 }, egi = ["stroke"], tgi = ["stroke"], ngi = {
  name: "PhSquareLogo"
}, Tel = /* @__PURE__ */ $({
  ...ngi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Nfi, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ffi),
        e("rect", {
          x: "96",
          y: "96",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Tfi)
      ])) : o(i) === "duotone" ? (s(), r("g", Dfi, [
        Rfi,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ufi),
        e("rect", {
          x: "96",
          y: "96",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qfi)
      ])) : o(i) === "fill" ? (s(), r("g", Gfi, Ofi)) : o(i) === "light" ? (s(), r("g", Ifi, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kfi),
        e("rect", {
          x: "96",
          y: "96",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xfi)
      ])) : o(i) === "thin" ? (s(), r("g", Jfi, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qfi),
        e("rect", {
          x: "96",
          y: "96",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Yfi)
      ])) : o(i) === "regular" ? (s(), r("g", ogi, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, egi),
        e("rect", {
          x: "96",
          y: "96",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tgi)
      ])) : g("", !0)
    ], 16, Wfi));
  }
}), sgi = ["width", "height", "fill", "transform"], rgi = { key: 0 }, igi = ["stroke"], lgi = ["stroke"], dgi = ["stroke"], kgi = ["stroke"], cgi = { key: 1 }, hgi = /* @__PURE__ */ e("rect", {
  x: "48",
  y: "48",
  width: "64",
  height: "64",
  opacity: "0.2"
}, null, -1), ugi = /* @__PURE__ */ e("rect", {
  x: "144",
  y: "48",
  width: "64",
  height: "64",
  opacity: "0.2"
}, null, -1), agi = /* @__PURE__ */ e("rect", {
  x: "48",
  y: "144",
  width: "64",
  height: "64",
  opacity: "0.2"
}, null, -1), _gi = /* @__PURE__ */ e("rect", {
  x: "144",
  y: "144",
  width: "64",
  height: "64",
  opacity: "0.2"
}, null, -1), pgi = ["stroke"], ygi = ["stroke"], $gi = ["stroke"], wgi = ["stroke"], fgi = { key: 2 }, ggi = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "80",
  height: "80",
  rx: "8"
}, null, -1), xgi = /* @__PURE__ */ e("rect", {
  x: "136",
  y: "40",
  width: "80",
  height: "80",
  rx: "8"
}, null, -1), jgi = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "136",
  width: "80",
  height: "80",
  rx: "8"
}, null, -1), mgi = /* @__PURE__ */ e("rect", {
  x: "136",
  y: "136",
  width: "80",
  height: "80",
  rx: "8"
}, null, -1), Mgi = [
  ggi,
  xgi,
  jgi,
  mgi
], vgi = { key: 3 }, Sgi = ["stroke"], Hgi = ["stroke"], Agi = ["stroke"], Vgi = ["stroke"], zgi = { key: 4 }, Zgi = ["stroke"], Cgi = ["stroke"], bgi = ["stroke"], Lgi = ["stroke"], Bgi = { key: 5 }, Pgi = ["stroke"], Wgi = ["stroke"], Ngi = ["stroke"], Fgi = ["stroke"], Tgi = {
  name: "PhSquaresFour"
}, Del = /* @__PURE__ */ $({
  ...Tgi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", rgi, [
        e("rect", {
          x: "48",
          y: "48",
          width: "60",
          height: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, igi),
        e("rect", {
          x: "148",
          y: "48",
          width: "60",
          height: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lgi),
        e("rect", {
          x: "48",
          y: "148",
          width: "60",
          height: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dgi),
        e("rect", {
          x: "148",
          y: "148",
          width: "60",
          height: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kgi)
      ])) : o(i) === "duotone" ? (s(), r("g", cgi, [
        hgi,
        ugi,
        agi,
        _gi,
        e("rect", {
          x: "144",
          y: "144",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pgi),
        e("rect", {
          x: "48",
          y: "48",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ygi),
        e("rect", {
          x: "144",
          y: "48",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $gi),
        e("rect", {
          x: "48",
          y: "144",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wgi)
      ])) : o(i) === "fill" ? (s(), r("g", fgi, Mgi)) : o(i) === "light" ? (s(), r("g", vgi, [
        e("rect", {
          x: "48",
          y: "48",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Sgi),
        e("rect", {
          x: "144",
          y: "48",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hgi),
        e("rect", {
          x: "48",
          y: "144",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Agi),
        e("rect", {
          x: "144",
          y: "144",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vgi)
      ])) : o(i) === "thin" ? (s(), r("g", zgi, [
        e("rect", {
          x: "48",
          y: "48",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zgi),
        e("rect", {
          x: "144",
          y: "48",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cgi),
        e("rect", {
          x: "48",
          y: "144",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bgi),
        e("rect", {
          x: "144",
          y: "144",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lgi)
      ])) : o(i) === "regular" ? (s(), r("g", Bgi, [
        e("rect", {
          x: "48",
          y: "48",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pgi),
        e("rect", {
          x: "144",
          y: "48",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wgi),
        e("rect", {
          x: "48",
          y: "144",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ngi),
        e("rect", {
          x: "144",
          y: "144",
          width: "64",
          height: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fgi)
      ])) : g("", !0)
    ], 16, sgi));
  }
}), Dgi = ["width", "height", "fill", "transform"], Rgi = { key: 0 }, Ugi = ["stroke"], qgi = ["stroke"], Ggi = ["stroke"], Egi = { key: 1 }, Ogi = /* @__PURE__ */ e("polygon", {
  points: "32 80 128 136 224 80 128 24 32 80",
  opacity: "0.2"
}, null, -1), Igi = ["stroke"], Kgi = ["stroke"], Xgi = ["stroke"], Jgi = { key: 2 }, Qgi = /* @__PURE__ */ e("path", { d: "M220,169.1l-92,53.6L36,169.1a8,8,0,0,0-8,13.8l96,56a7.8,7.8,0,0,0,8,0l96-56a8,8,0,1,0-8-13.8Z" }, null, -1), Ygi = /* @__PURE__ */ e("path", { d: "M220,121.1l-92,53.6L36,121.1a8,8,0,0,0-8,13.8l96,56a7.8,7.8,0,0,0,8,0l96-56a8,8,0,1,0-8-13.8Z" }, null, -1), oxi = /* @__PURE__ */ e("path", { d: "M28,86.9l96,56a7.8,7.8,0,0,0,8,0l96-56a8,8,0,0,0,0-13.8l-96-56a7.7,7.7,0,0,0-8,0l-96,56a8,8,0,0,0,0,13.8Z" }, null, -1), exi = [
  Qgi,
  Ygi,
  oxi
], txi = { key: 3 }, nxi = ["stroke"], sxi = ["stroke"], rxi = ["stroke"], ixi = { key: 4 }, lxi = ["stroke"], dxi = ["stroke"], kxi = ["stroke"], cxi = { key: 5 }, hxi = ["stroke"], uxi = ["stroke"], axi = ["stroke"], _xi = {
  name: "PhStack"
}, Rel = /* @__PURE__ */ $({
  ..._xi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Rgi, [
        e("polyline", {
          points: "32 176 128 232 224 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ugi),
        e("polyline", {
          points: "32 128 128 184 224 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qgi),
        e("polygon", {
          points: "32 80 128 136 224 80 128 24 32 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ggi)
      ])) : o(i) === "duotone" ? (s(), r("g", Egi, [
        Ogi,
        e("polyline", {
          points: "32 176 128 232 224 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Igi),
        e("polyline", {
          points: "32 128 128 184 224 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kgi),
        e("polygon", {
          points: "32 80 128 136 224 80 128 24 32 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xgi)
      ])) : o(i) === "fill" ? (s(), r("g", Jgi, exi)) : o(i) === "light" ? (s(), r("g", txi, [
        e("polyline", {
          points: "32 176 128 232 224 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nxi),
        e("polyline", {
          points: "32 128 128 184 224 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sxi),
        e("polygon", {
          points: "32 80 128 136 224 80 128 24 32 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rxi)
      ])) : o(i) === "thin" ? (s(), r("g", ixi, [
        e("polyline", {
          points: "32 176 128 232 224 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lxi),
        e("polyline", {
          points: "32 128 128 184 224 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dxi),
        e("polygon", {
          points: "32 80 128 136 224 80 128 24 32 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kxi)
      ])) : o(i) === "regular" ? (s(), r("g", cxi, [
        e("polyline", {
          points: "32 176 128 232 224 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hxi),
        e("polyline", {
          points: "32 128 128 184 224 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uxi),
        e("polygon", {
          points: "32 80 128 136 224 80 128 24 32 80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, axi)
      ])) : g("", !0)
    ], 16, Dgi));
  }
}), pxi = ["width", "height", "fill", "transform"], yxi = { key: 0 }, $xi = ["stroke"], wxi = ["stroke"], fxi = ["stroke"], gxi = ["stroke"], xxi = { key: 1 }, jxi = ["stroke"], mxi = ["stroke"], Mxi = ["stroke"], vxi = ["stroke"], Sxi = ["stroke"], Hxi = { key: 2 }, Axi = /* @__PURE__ */ e("path", { d: "M216,152v64a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152a8,8,0,0,1,16,0v56H200V152a8,8,0,0,1,16,0ZM88,184h80a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Zm4.9-53.1,77.3,20.7a6.4,6.4,0,0,0,2,.3,8,8,0,0,0,2.1-15.7L97,115.5a8,8,0,1,0-4.1,15.4Zm18.4-50,69.3,40a7.3,7.3,0,0,0,4,1.1,7.7,7.7,0,0,0,6.9-4,7.9,7.9,0,0,0-2.9-10.9l-69.3-40a8,8,0,0,0-8,13.8ZM198.7,94a8,8,0,0,0,5.6,2.3A8.3,8.3,0,0,0,210,94a8,8,0,0,0,0-11.3L153.4,26.1a8,8,0,0,0-11.3,11.3Z" }, null, -1), Vxi = [
  Axi
], zxi = { key: 3 }, Zxi = ["stroke"], Cxi = ["stroke"], bxi = ["stroke"], Lxi = ["stroke"], Bxi = ["stroke"], Pxi = { key: 4 }, Wxi = ["stroke"], Nxi = ["stroke"], Fxi = ["stroke"], Txi = ["stroke"], Dxi = ["stroke"], Rxi = { key: 5 }, Uxi = ["stroke"], qxi = ["stroke"], Gxi = ["stroke"], Exi = ["stroke"], Oxi = ["stroke"], Ixi = {
  name: "PhStackOverflowLogo"
}, Uel = /* @__PURE__ */ $({
  ...Ixi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", yxi, [
        e("polyline", {
          points: "48 152 48 216 208 216 208 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $xi),
        e("line", {
          x1: "88",
          y1: "172",
          x2: "168",
          y2: "172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wxi),
        e("line", {
          x1: "100.3",
          y1: "102.2",
          x2: "175.5",
          y2: "129.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fxi),
        e("line", {
          x1: "135.7",
          y1: "40.9",
          x2: "197",
          y2: "92.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gxi)
      ])) : o(i) === "duotone" ? (s(), r("g", xxi, [
        e("polyline", {
          points: "48 152 48 216 208 216 208 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jxi),
        e("line", {
          x1: "88",
          y1: "176",
          x2: "168",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mxi),
        e("line", {
          x1: "95",
          y1: "123.2",
          x2: "172.2",
          y2: "143.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mxi),
        e("line", {
          x1: "115.3",
          y1: "74",
          x2: "184.6",
          y2: "114",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vxi),
        e("line", {
          x1: "147.8",
          y1: "31.8",
          x2: "204.3",
          y2: "88.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sxi)
      ])) : o(i) === "fill" ? (s(), r("g", Hxi, Vxi)) : o(i) === "light" ? (s(), r("g", zxi, [
        e("polyline", {
          points: "48 152 48 216 208 216 208 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zxi),
        e("line", {
          x1: "88",
          y1: "176",
          x2: "168",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cxi),
        e("line", {
          x1: "95",
          y1: "123.2",
          x2: "172.2",
          y2: "143.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bxi),
        e("line", {
          x1: "115.3",
          y1: "74",
          x2: "184.6",
          y2: "114",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lxi),
        e("line", {
          x1: "147.8",
          y1: "31.8",
          x2: "204.3",
          y2: "88.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bxi)
      ])) : o(i) === "thin" ? (s(), r("g", Pxi, [
        e("polyline", {
          points: "48 152 48 216 208 216 208 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wxi),
        e("line", {
          x1: "88",
          y1: "176",
          x2: "168",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nxi),
        e("line", {
          x1: "95",
          y1: "123.2",
          x2: "172.2",
          y2: "143.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fxi),
        e("line", {
          x1: "115.3",
          y1: "74",
          x2: "184.6",
          y2: "114",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Txi),
        e("line", {
          x1: "147.8",
          y1: "31.8",
          x2: "204.3",
          y2: "88.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Dxi)
      ])) : o(i) === "regular" ? (s(), r("g", Rxi, [
        e("polyline", {
          points: "48 152 48 216 208 216 208 152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uxi),
        e("line", {
          x1: "88",
          y1: "176",
          x2: "168",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qxi),
        e("line", {
          x1: "95",
          y1: "123.2",
          x2: "172.2",
          y2: "143.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gxi),
        e("line", {
          x1: "115.3",
          y1: "74",
          x2: "184.6",
          y2: "114",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Exi),
        e("line", {
          x1: "147.8",
          y1: "31.8",
          x2: "204.3",
          y2: "88.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Oxi)
      ])) : g("", !0)
    ], 16, pxi));
  }
}), Kxi = ["width", "height", "fill", "transform"], Xxi = { key: 0 }, Jxi = ["stroke"], Qxi = ["stroke"], Yxi = { key: 1 }, oji = /* @__PURE__ */ e("polygon", {
  points: "16 104 128 168 240 104 128 40 16 104",
  opacity: "0.2"
}, null, -1), eji = ["stroke"], tji = ["stroke"], nji = { key: 2 }, sji = /* @__PURE__ */ e("path", { d: "M12,110.9l112,64a7.8,7.8,0,0,0,8,0l112-64a8,8,0,0,0,0-13.8l-112-64a7.7,7.7,0,0,0-8,0L12,97.1a8,8,0,0,0,0,13.8Z" }, null, -1), rji = /* @__PURE__ */ e("path", { d: "M236,137.1,128,198.8,20,137.1a8,8,0,0,0-8,13.8l112,64a7.8,7.8,0,0,0,8,0l112-64a8,8,0,1,0-8-13.8Z" }, null, -1), iji = [
  sji,
  rji
], lji = { key: 3 }, dji = ["stroke"], kji = ["stroke"], cji = { key: 4 }, hji = ["stroke"], uji = ["stroke"], aji = { key: 5 }, _ji = ["stroke"], pji = ["stroke"], yji = {
  name: "PhStackSimple"
}, qel = /* @__PURE__ */ $({
  ...yji,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Xxi, [
        e("polygon", {
          points: "16 100 128 164 240 100 128 36 16 100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jxi),
        e("polyline", {
          points: "16 148 128 212 240 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qxi)
      ])) : o(i) === "duotone" ? (s(), r("g", Yxi, [
        oji,
        e("polygon", {
          points: "16 104 128 168 240 104 128 40 16 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eji),
        e("polyline", {
          points: "16 144 128 208 240 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tji)
      ])) : o(i) === "fill" ? (s(), r("g", nji, iji)) : o(i) === "light" ? (s(), r("g", lji, [
        e("polygon", {
          points: "16 104 128 168 240 104 128 40 16 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dji),
        e("polyline", {
          points: "16 144 128 208 240 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kji)
      ])) : o(i) === "thin" ? (s(), r("g", cji, [
        e("polygon", {
          points: "16 104 128 168 240 104 128 40 16 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hji),
        e("polyline", {
          points: "16 144 128 208 240 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uji)
      ])) : o(i) === "regular" ? (s(), r("g", aji, [
        e("polygon", {
          points: "16 104 128 168 240 104 128 40 16 104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _ji),
        e("polyline", {
          points: "16 144 128 208 240 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pji)
      ])) : g("", !0)
    ], 16, Kxi));
  }
}), $ji = ["width", "height", "fill", "transform"], wji = { key: 0 }, fji = ["stroke"], gji = ["stroke"], xji = ["stroke"], jji = { key: 1 }, mji = /* @__PURE__ */ e("path", {
  d: "M112,136,94.2,53a24,24,0,0,1,23.5-29h20.6a24,24,0,0,1,23.5,29L144,136Z",
  opacity: "0.2"
}, null, -1), Mji = ["stroke"], vji = ["stroke"], Sji = ["stroke"], Hji = { key: 2 }, Aji = /* @__PURE__ */ e("path", { d: "M224,224a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,224Zm0-80v40a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V144a16,16,0,0,1,16-16h54.1L86.4,54.7A32,32,0,0,1,117.7,16h20.6a32,32,0,0,1,31.3,38.7L153.9,128H208A16,16,0,0,1,224,144Z" }, null, -1), Vji = [
  Aji
], zji = { key: 3 }, Zji = ["stroke"], Cji = ["stroke"], bji = ["stroke"], Lji = { key: 4 }, Bji = ["stroke"], Pji = ["stroke"], Wji = ["stroke"], Nji = { key: 5 }, Fji = ["stroke"], Tji = ["stroke"], Dji = ["stroke"], Rji = {
  name: "PhStamp"
}, Gel = /* @__PURE__ */ $({
  ...Rji,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", wji, [
        e("line", {
          x1: "40",
          y1: "224",
          x2: "216",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fji),
        e("path", {
          d: "M112,136,94.2,53a24,24,0,0,1,23.5-29h20.6a24,24,0,0,1,23.5,29L144,136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gji),
        e("rect", {
          x: "40",
          y: "136",
          width: "176",
          height: "48",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xji)
      ])) : o(i) === "duotone" ? (s(), r("g", jji, [
        mji,
        e("line", {
          x1: "40",
          y1: "224",
          x2: "216",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mji),
        e("path", {
          d: "M112,136,94.2,53a24,24,0,0,1,23.5-29h20.6a24,24,0,0,1,23.5,29L144,136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vji),
        e("rect", {
          x: "40",
          y: "136",
          width: "176",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sji)
      ])) : o(i) === "fill" ? (s(), r("g", Hji, Vji)) : o(i) === "light" ? (s(), r("g", zji, [
        e("line", {
          x1: "40",
          y1: "224",
          x2: "216",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zji),
        e("path", {
          d: "M112,136,94.2,53a24,24,0,0,1,23.5-29h20.6a24,24,0,0,1,23.5,29L144,136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cji),
        e("rect", {
          x: "40",
          y: "136",
          width: "176",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bji)
      ])) : o(i) === "thin" ? (s(), r("g", Lji, [
        e("line", {
          x1: "40",
          y1: "224",
          x2: "216",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bji),
        e("path", {
          d: "M112,136,94.2,53a24,24,0,0,1,23.5-29h20.6a24,24,0,0,1,23.5,29L144,136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pji),
        e("rect", {
          x: "40",
          y: "136",
          width: "176",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wji)
      ])) : o(i) === "regular" ? (s(), r("g", Nji, [
        e("line", {
          x1: "40",
          y1: "224",
          x2: "216",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fji),
        e("path", {
          d: "M112,136,94.2,53a24,24,0,0,1,23.5-29h20.6a24,24,0,0,1,23.5,29L144,136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tji),
        e("rect", {
          x: "40",
          y: "136",
          width: "176",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dji)
      ])) : g("", !0)
    ], 16, $ji));
  }
}), Uji = ["width", "height", "fill", "transform"], qji = { key: 0 }, Gji = ["stroke"], Eji = { key: 1 }, Oji = /* @__PURE__ */ e("path", {
  d: "M132.4,190.7l50.4,32c6.5,4.1,14.5-2,12.6-9.5l-14.6-57.4a8.7,8.7,0,0,1,2.9-8.8l45.2-37.7c5.9-4.9,2.9-14.8-4.8-15.3l-59-3.8a8.3,8.3,0,0,1-7.3-5.4l-22-55.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7A8.2,8.2,0,0,1,132.4,190.7Z",
  opacity: "0.2"
}, null, -1), Iji = ["stroke"], Kji = { key: 2 }, Xji = /* @__PURE__ */ e("path", { d: "M239.2,97.4A16.4,16.4,0,0,0,224.6,86l-59.4-4.1-22-55.5A16.4,16.4,0,0,0,128,16h0a16.4,16.4,0,0,0-15.2,10.4L90.4,82.2,31.4,86A16.5,16.5,0,0,0,16.8,97.4,16.8,16.8,0,0,0,22,115.5l45.4,38.4L53.9,207a18.5,18.5,0,0,0,7,19.6,18,18,0,0,0,20.1.6l46.9-29.7h.2l50.5,31.9a16.1,16.1,0,0,0,8.7,2.6,16.5,16.5,0,0,0,15.8-20.8l-14.3-58.1L234,115.5A16.8,16.8,0,0,0,239.2,97.4Z" }, null, -1), Jji = [
  Xji
], Qji = { key: 3 }, Yji = ["stroke"], omi = { key: 4 }, emi = ["stroke"], tmi = { key: 5 }, nmi = ["stroke"], smi = {
  name: "PhStar"
}, Eel = /* @__PURE__ */ $({
  ...smi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", qji, [
        e("path", {
          d: "M132.4,190.7l50.4,32c6.5,4.1,14.5-2,12.6-9.5l-14.6-57.4a8.7,8.7,0,0,1,2.9-8.8l45.2-37.7c5.9-4.9,2.9-14.8-4.8-15.3l-59-3.8a8.3,8.3,0,0,1-7.3-5.4l-22-55.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7A8.2,8.2,0,0,1,132.4,190.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gji)
      ])) : o(i) === "duotone" ? (s(), r("g", Eji, [
        Oji,
        e("path", {
          d: "M132.4,190.7l50.4,32c6.5,4.1,14.5-2,12.6-9.5l-14.6-57.4a8.7,8.7,0,0,1,2.9-8.8l45.2-37.7c5.9-4.9,2.9-14.8-4.8-15.3l-59-3.8a8.3,8.3,0,0,1-7.3-5.4l-22-55.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7A8.2,8.2,0,0,1,132.4,190.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Iji)
      ])) : o(i) === "fill" ? (s(), r("g", Kji, Jji)) : o(i) === "light" ? (s(), r("g", Qji, [
        e("path", {
          d: "M132.4,190.7l50.4,32c6.5,4.1,14.5-2,12.6-9.5l-14.6-57.4a8.7,8.7,0,0,1,2.9-8.8l45.2-37.7c5.9-4.9,2.9-14.8-4.8-15.3l-59-3.8a8.3,8.3,0,0,1-7.3-5.4l-22-55.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7A8.2,8.2,0,0,1,132.4,190.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Yji)
      ])) : o(i) === "thin" ? (s(), r("g", omi, [
        e("path", {
          d: "M132.4,190.7l50.4,32c6.5,4.1,14.5-2,12.6-9.5l-14.6-57.4a8.7,8.7,0,0,1,2.9-8.8l45.2-37.7c5.9-4.9,2.9-14.8-4.8-15.3l-59-3.8a8.3,8.3,0,0,1-7.3-5.4l-22-55.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7A8.2,8.2,0,0,1,132.4,190.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, emi)
      ])) : o(i) === "regular" ? (s(), r("g", tmi, [
        e("path", {
          d: "M132.4,190.7l50.4,32c6.5,4.1,14.5-2,12.6-9.5l-14.6-57.4a8.7,8.7,0,0,1,2.9-8.8l45.2-37.7c5.9-4.9,2.9-14.8-4.8-15.3l-59-3.8a8.3,8.3,0,0,1-7.3-5.4l-22-55.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7A8.2,8.2,0,0,1,132.4,190.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nmi)
      ])) : g("", !0)
    ], 16, Uji));
  }
}), rmi = ["width", "height", "fill", "transform"], imi = { key: 0 }, lmi = ["stroke"], dmi = { key: 1 }, kmi = /* @__PURE__ */ e("path", {
  d: "M158.7,163.5l-23.2,63.8a8,8,0,0,1-15,0L97.3,163.5a8.1,8.1,0,0,0-4.8-4.8L28.7,135.5a8,8,0,0,1,0-15L92.5,97.3a8.1,8.1,0,0,0,4.8-4.8l23.2-63.8a8,8,0,0,1,15,0l23.2,63.8a8.1,8.1,0,0,0,4.8,4.8l63.8,23.2a8,8,0,0,1,0,15l-63.8,23.2A8.1,8.1,0,0,0,158.7,163.5Z",
  opacity: "0.2"
}, null, -1), cmi = ["stroke"], hmi = { key: 2 }, umi = /* @__PURE__ */ e("path", { d: "M240.6,128a15.8,15.8,0,0,1-10.5,15l-63.9,23.2L143,230.1a16,16,0,0,1-30,0L89.8,166.2,25.9,143a16,16,0,0,1,0-30L89.8,89.8,113,25.9a16,16,0,0,1,30,0l23.2,63.9L230.1,113A15.8,15.8,0,0,1,240.6,128Z" }, null, -1), ami = [
  umi
], _mi = { key: 3 }, pmi = ["stroke"], ymi = { key: 4 }, $mi = ["stroke"], wmi = { key: 5 }, fmi = ["stroke"], gmi = {
  name: "PhStarFour"
}, Oel = /* @__PURE__ */ $({
  ...gmi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", imi, [
        e("path", {
          d: "M158.7,163.5l-23.2,63.8a8,8,0,0,1-15,0L97.3,163.5a8.1,8.1,0,0,0-4.8-4.8L28.7,135.5a8,8,0,0,1,0-15L92.5,97.3a8.1,8.1,0,0,0,4.8-4.8l23.2-63.8a8,8,0,0,1,15,0l23.2,63.8a8.1,8.1,0,0,0,4.8,4.8l63.8,23.2a8,8,0,0,1,0,15l-63.8,23.2A8.1,8.1,0,0,0,158.7,163.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lmi)
      ])) : o(i) === "duotone" ? (s(), r("g", dmi, [
        kmi,
        e("path", {
          d: "M158.7,163.5l-23.2,63.8a8,8,0,0,1-15,0L97.3,163.5a8.1,8.1,0,0,0-4.8-4.8L28.7,135.5a8,8,0,0,1,0-15L92.5,97.3a8.1,8.1,0,0,0,4.8-4.8l23.2-63.8a8,8,0,0,1,15,0l23.2,63.8a8.1,8.1,0,0,0,4.8,4.8l63.8,23.2a8,8,0,0,1,0,15l-63.8,23.2A8.1,8.1,0,0,0,158.7,163.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cmi)
      ])) : o(i) === "fill" ? (s(), r("g", hmi, ami)) : o(i) === "light" ? (s(), r("g", _mi, [
        e("path", {
          d: "M158.7,163.5l-23.2,63.8a8,8,0,0,1-15,0L97.3,163.5a8.1,8.1,0,0,0-4.8-4.8L28.7,135.5a8,8,0,0,1,0-15L92.5,97.3a8.1,8.1,0,0,0,4.8-4.8l23.2-63.8a8,8,0,0,1,15,0l23.2,63.8a8.1,8.1,0,0,0,4.8,4.8l63.8,23.2a8,8,0,0,1,0,15l-63.8,23.2A8.1,8.1,0,0,0,158.7,163.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pmi)
      ])) : o(i) === "thin" ? (s(), r("g", ymi, [
        e("path", {
          d: "M158.7,163.5l-23.2,63.8a8,8,0,0,1-15,0L97.3,163.5a8.1,8.1,0,0,0-4.8-4.8L28.7,135.5a8,8,0,0,1,0-15L92.5,97.3a8.1,8.1,0,0,0,4.8-4.8l23.2-63.8a8,8,0,0,1,15,0l23.2,63.8a8.1,8.1,0,0,0,4.8,4.8l63.8,23.2a8,8,0,0,1,0,15l-63.8,23.2A8.1,8.1,0,0,0,158.7,163.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $mi)
      ])) : o(i) === "regular" ? (s(), r("g", wmi, [
        e("path", {
          d: "M158.7,163.5l-23.2,63.8a8,8,0,0,1-15,0L97.3,163.5a8.1,8.1,0,0,0-4.8-4.8L28.7,135.5a8,8,0,0,1,0-15L92.5,97.3a8.1,8.1,0,0,0,4.8-4.8l23.2-63.8a8,8,0,0,1,15,0l23.2,63.8a8.1,8.1,0,0,0,4.8,4.8l63.8,23.2a8,8,0,0,1,0,15l-63.8,23.2A8.1,8.1,0,0,0,158.7,163.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fmi)
      ])) : g("", !0)
    ], 16, rmi));
  }
}), xmi = ["width", "height", "fill", "transform"], jmi = { key: 0 }, mmi = ["stroke"], Mmi = ["stroke"], vmi = ["stroke"], Smi = ["stroke"], Hmi = ["stroke"], Ami = { key: 1 }, Vmi = /* @__PURE__ */ e("path", {
  d: "M128,189.4a8.7,8.7,0,0,0-4.4,1.3L76.7,220.4c-7.7,4.9-17.3-2.4-15-11.4l13.5-53.2a8.7,8.7,0,0,0-2.9-8.8L27.1,109.3c-5.9-4.9-2.9-14.8,4.8-15.3l59-3.8a8.3,8.3,0,0,0,7.3-5.4l22-55.4A8.3,8.3,0,0,1,128,24h0Z",
  opacity: "0.2"
}, null, -1), zmi = ["stroke"], Zmi = ["stroke"], Cmi = { key: 2 }, bmi = /* @__PURE__ */ e("path", { d: "M239.2,97.4A16.4,16.4,0,0,0,224.6,86l-59-3.8a.5.5,0,0,1-.4-.3l-22-55.5a16.3,16.3,0,0,0-30.4,0l-22,55.5a.5.5,0,0,1-.4.3L31.4,86A16.4,16.4,0,0,0,16.8,97.4,16.8,16.8,0,0,0,22,115.5l45.2,37.6a.8.8,0,0,1,.2.8L53.9,207a18.6,18.6,0,0,0,7,19.6,18,18,0,0,0,20.1.6l46.9-29.7h.2l50.5,31.9a16.1,16.1,0,0,0,8.7,2.6,16.8,16.8,0,0,0,9.5-3.1,16.6,16.6,0,0,0,6.3-17.7l-14.5-57.3a.8.8,0,0,1,.2-.8L234,115.5A16.8,16.8,0,0,0,239.2,97.4Zm-15.4,5.8-45.3,37.6a16.8,16.8,0,0,0-5.4,17l14.5,57.3c.1.4.1.5,0,.6a.7.7,0,0,1-.3.3h-.2L136.7,184a16,16,0,0,0-8.7-2.5V32c.1,0,.2,0,.3.3l22.1,55.5a16.4,16.4,0,0,0,14.1,10.4l59.1,3.8c.1,0,.2,0,.3.4S223.9,103.1,223.8,103.2Z" }, null, -1), Lmi = [
  bmi
], Bmi = { key: 3 }, Pmi = ["stroke"], Wmi = ["stroke"], Nmi = ["stroke"], Fmi = ["stroke"], Tmi = ["stroke"], Dmi = { key: 4 }, Rmi = ["stroke"], Umi = ["stroke"], qmi = ["stroke"], Gmi = ["stroke"], Emi = ["stroke"], Omi = { key: 5 }, Imi = ["stroke"], Kmi = ["stroke"], Xmi = ["stroke"], Jmi = ["stroke"], Qmi = ["stroke"], Ymi = {
  name: "PhStarHalf"
}, Iel = /* @__PURE__ */ $({
  ...Ymi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", jmi, [
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "189.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mmi),
        e("path", {
          d: "M220.2,116.6l8.7-7.3c5.9-4.9,2.9-14.8-4.8-15.3l-11.5-.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mmi),
        e("path", {
          d: "M173,216.5l9.8,6.2c6.5,4.1,14.5-2,12.6-9.5l-2.8-10.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vmi),
        e("path", {
          d: "M182,160.5l-1.2-4.7a8.7,8.7,0,0,1,2.9-8.8l3.4-2.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Smi),
        e("path", {
          d: "M169.6,90.5l-4.5-.3a8.3,8.3,0,0,1-7.3-5.4L152.7,72,135.8,29.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7a8.2,8.2,0,0,1,8.8,0l4.3,2.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hmi)
      ])) : o(i) === "duotone" ? (s(), r("g", Ami, [
        Vmi,
        e("path", {
          d: "M132.4,190.7l50.4,32c6.5,4.1,14.5-2,12.6-9.5l-14.6-57.4a8.7,8.7,0,0,1,2.9-8.8l45.2-37.7c5.9-4.9,2.9-14.8-4.8-15.3l-59-3.8a8.3,8.3,0,0,1-7.3-5.4l-22-55.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7A8.2,8.2,0,0,1,132.4,190.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zmi),
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "189.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zmi)
      ])) : o(i) === "fill" ? (s(), r("g", Cmi, Lmi)) : o(i) === "light" ? (s(), r("g", Bmi, [
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "189.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pmi),
        e("path", {
          d: "M220.2,116.6l8.7-7.3c5.9-4.9,2.9-14.8-4.8-15.3l-11.5-.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wmi),
        e("path", {
          d: "M184.1,168.9l-3.3-13.1a8.7,8.7,0,0,1,2.9-8.8l10-8.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Nmi),
        e("path", {
          d: "M178.2,91l-13.1-.8a8.3,8.3,0,0,1-7.3-5.4L152.7,72,135.8,29.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7a8.2,8.2,0,0,1,8.8,0l11.5,7.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fmi),
        e("path", {
          d: "M173,216.5l9.8,6.2c6.5,4.1,14.5-2,12.6-9.5l-2.8-10.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Tmi)
      ])) : o(i) === "thin" ? (s(), r("g", Dmi, [
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "189.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Rmi),
        e("path", {
          d: "M220.2,116.6l8.7-7.3c5.9-4.9,2.9-14.8-4.8-15.3l-11.5-.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Umi),
        e("path", {
          d: "M184.1,168.9l-3.3-13.1a8.7,8.7,0,0,1,2.9-8.8l10-8.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qmi),
        e("path", {
          d: "M178.2,91l-13.1-.8a8.3,8.3,0,0,1-7.3-5.4L152.7,72,135.8,29.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7a8.2,8.2,0,0,1,8.8,0l11.5,7.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gmi),
        e("path", {
          d: "M173,216.5l9.8,6.2c6.5,4.1,14.5-2,12.6-9.5l-2.8-10.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Emi)
      ])) : o(i) === "regular" ? (s(), r("g", Omi, [
        e("line", {
          x1: "128",
          y1: "24",
          x2: "128",
          y2: "189.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Imi),
        e("path", {
          d: "M220.2,116.6l8.7-7.3c5.9-4.9,2.9-14.8-4.8-15.3l-11.5-.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kmi),
        e("path", {
          d: "M184.1,168.9l-3.3-13.1a8.7,8.7,0,0,1,2.9-8.8l10-8.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xmi),
        e("path", {
          d: "M178.2,91l-13.1-.8a8.3,8.3,0,0,1-7.3-5.4L152.7,72,135.8,29.4a8.3,8.3,0,0,0-15.6,0l-22,55.4a8.3,8.3,0,0,1-7.3,5.4L31.9,94c-7.7.5-10.7,10.4-4.8,15.3L72.3,147a8.7,8.7,0,0,1,2.9,8.8L61.7,209c-2.3,9,7.3,16.3,15,11.4l46.9-29.7a8.2,8.2,0,0,1,8.8,0l11.5,7.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jmi),
        e("path", {
          d: "M173,216.5l9.8,6.2c6.5,4.1,14.5-2,12.6-9.5l-2.8-10.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qmi)
      ])) : g("", !0)
    ], 16, xmi));
  }
}), oMi = ["width", "height", "fill", "transform"], eMi = { key: 0 }, tMi = ["stroke"], nMi = ["stroke"], sMi = { key: 1 }, rMi = /* @__PURE__ */ e("path", {
  d: "M136,216V184a48,48,0,0,1,48-48h32C208,160,160,208,136,216Z",
  opacity: "0.2"
}, null, -1), iMi = ["stroke"], lMi = ["stroke"], dMi = { key: 2 }, kMi = /* @__PURE__ */ e("path", { d: "M168,32H88A56,56,0,0,0,32,88v80a56,56,0,0,0,56,56h48a6.9,6.9,0,0,0,2.5-.4c26.3-8.8,76.3-58.8,85.1-85.1a6.9,6.9,0,0,0,.4-2.5V88A56,56,0,0,0,168,32ZM136,207.4V176a40,40,0,0,1,40-40h31.4C198.2,157.6,157.6,198.2,136,207.4Z" }, null, -1), cMi = [
  kMi
], hMi = { key: 3 }, uMi = ["stroke"], aMi = ["stroke"], _Mi = { key: 4 }, pMi = ["stroke"], yMi = ["stroke"], $Mi = { key: 5 }, wMi = ["stroke"], fMi = ["stroke"], gMi = {
  name: "PhSticker"
}, Kel = /* @__PURE__ */ $({
  ...gMi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", eMi, [
        e("path", {
          d: "M136,216H88a48,48,0,0,1-48-48V88A48,48,0,0,1,88,40h80a48,48,0,0,1,48,48v48C208,160,160,208,136,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tMi),
        e("path", {
          d: "M136,216V184a48,48,0,0,1,48-48h32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nMi)
      ])) : o(i) === "duotone" ? (s(), r("g", sMi, [
        rMi,
        e("path", {
          d: "M136,216H88a48,48,0,0,1-48-48V88A48,48,0,0,1,88,40h80a48,48,0,0,1,48,48v48C208,160,160,208,136,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iMi),
        e("path", {
          d: "M136,216V184a48,48,0,0,1,48-48h32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lMi)
      ])) : o(i) === "fill" ? (s(), r("g", dMi, cMi)) : o(i) === "light" ? (s(), r("g", hMi, [
        e("path", {
          d: "M136,216H88a48,48,0,0,1-48-48V88A48,48,0,0,1,88,40h80a48,48,0,0,1,48,48v48C208,160,160,208,136,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uMi),
        e("path", {
          d: "M136,216V184a48,48,0,0,1,48-48h32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aMi)
      ])) : o(i) === "thin" ? (s(), r("g", _Mi, [
        e("path", {
          d: "M136,216H88a48,48,0,0,1-48-48V88A48,48,0,0,1,88,40h80a48,48,0,0,1,48,48v48C208,160,160,208,136,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pMi),
        e("path", {
          d: "M136,216V184a48,48,0,0,1,48-48h32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yMi)
      ])) : o(i) === "regular" ? (s(), r("g", $Mi, [
        e("path", {
          d: "M136,216H88a48,48,0,0,1-48-48V88A48,48,0,0,1,88,40h80a48,48,0,0,1,48,48v48C208,160,160,208,136,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wMi),
        e("path", {
          d: "M136,216V184a48,48,0,0,1,48-48h32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fMi)
      ])) : g("", !0)
    ], 16, oMi));
  }
}), xMi = ["width", "height", "fill", "transform"], jMi = { key: 0 }, mMi = ["stroke"], MMi = { key: 1 }, vMi = /* @__PURE__ */ e("rect", {
  x: "52",
  y: "52",
  width: "152",
  height: "152",
  rx: "6.9",
  opacity: "0.2"
}, null, -1), SMi = ["stroke"], HMi = { key: 2 }, AMi = /* @__PURE__ */ e("rect", {
  x: "44",
  y: "44",
  width: "168",
  height: "168",
  rx: "14.9"
}, null, -1), VMi = [
  AMi
], zMi = { key: 3 }, ZMi = ["stroke"], CMi = { key: 4 }, bMi = ["stroke"], LMi = { key: 5 }, BMi = ["stroke"], PMi = {
  name: "PhStop"
}, Xel = /* @__PURE__ */ $({
  ...PMi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", jMi, [
        e("rect", {
          x: "52",
          y: "52",
          width: "152",
          height: "152",
          rx: "6.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mMi)
      ])) : o(i) === "duotone" ? (s(), r("g", MMi, [
        vMi,
        e("rect", {
          x: "52",
          y: "52",
          width: "152",
          height: "152",
          rx: "6.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SMi)
      ])) : o(i) === "fill" ? (s(), r("g", HMi, VMi)) : o(i) === "light" ? (s(), r("g", zMi, [
        e("rect", {
          x: "52",
          y: "52",
          width: "152",
          height: "152",
          rx: "6.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZMi)
      ])) : o(i) === "thin" ? (s(), r("g", CMi, [
        e("rect", {
          x: "52",
          y: "52",
          width: "152",
          height: "152",
          rx: "6.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bMi)
      ])) : o(i) === "regular" ? (s(), r("g", LMi, [
        e("rect", {
          x: "52",
          y: "52",
          width: "152",
          height: "152",
          rx: "6.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BMi)
      ])) : g("", !0)
    ], 16, xMi));
  }
}), WMi = ["width", "height", "fill", "transform"], NMi = { key: 0 }, FMi = ["stroke"], TMi = ["stroke"], DMi = { key: 1 }, RMi = /* @__PURE__ */ e("path", {
  d: "M128,32a96,96,0,1,0,96,96A96,96,0,0,0,128,32Zm24,120H104V104h48Z",
  opacity: "0.2"
}, null, -1), UMi = ["stroke"], qMi = ["stroke"], GMi = { key: 2 }, EMi = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm32,128a8,8,0,0,1-8,8H104a8,8,0,0,1-8-8V104a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8Z" }, null, -1), OMi = [
  EMi
], IMi = { key: 3 }, KMi = ["stroke"], XMi = ["stroke"], JMi = { key: 4 }, QMi = ["stroke"], YMi = ["stroke"], ovi = { key: 5 }, evi = ["stroke"], tvi = ["stroke"], nvi = {
  name: "PhStopCircle"
}, Jel = /* @__PURE__ */ $({
  ...nvi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", NMi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FMi),
        e("rect", {
          x: "108",
          y: "108",
          width: "40",
          height: "40",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TMi)
      ])) : o(i) === "duotone" ? (s(), r("g", DMi, [
        RMi,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, UMi),
        e("rect", {
          x: "104",
          y: "104",
          width: "48",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qMi)
      ])) : o(i) === "fill" ? (s(), r("g", GMi, OMi)) : o(i) === "light" ? (s(), r("g", IMi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KMi),
        e("rect", {
          x: "104",
          y: "104",
          width: "48",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XMi)
      ])) : o(i) === "thin" ? (s(), r("g", JMi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QMi),
        e("rect", {
          x: "104",
          y: "104",
          width: "48",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YMi)
      ])) : o(i) === "regular" ? (s(), r("g", ovi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, evi),
        e("rect", {
          x: "104",
          y: "104",
          width: "48",
          height: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tvi)
      ])) : g("", !0)
    ], 16, WMi));
  }
}), svi = ["width", "height", "fill", "transform"], rvi = { key: 0 }, ivi = ["stroke"], lvi = ["stroke"], dvi = ["stroke"], kvi = ["stroke"], cvi = ["stroke"], hvi = { key: 1 }, uvi = /* @__PURE__ */ e("path", {
  d: "M96,96v16a32,32,0,0,1-64,0V96",
  opacity: "0.2"
}, null, -1), avi = /* @__PURE__ */ e("path", {
  d: "M224,96v16a32,32,0,0,1-64,0V96",
  opacity: "0.2"
}, null, -1), _vi = ["stroke"], pvi = ["stroke"], yvi = ["stroke"], $vi = ["stroke"], wvi = ["stroke"], fvi = { key: 2 }, gvi = /* @__PURE__ */ e("path", { d: "M232,95.8v-.4a4.3,4.3,0,0,1-.1-.5v-.3c-.1-.2-.1-.4-.2-.6v-.2L217.4,43.6A16.2,16.2,0,0,0,202,32H54A16.2,16.2,0,0,0,38.6,43.6L24.3,93.8V94c-.1.2-.1.4-.2.6v.3a4.3,4.3,0,0,1-.1.5V112a40,40,0,0,0,16,32v64a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V144a40,40,0,0,0,16-32V95.8ZM40,104H88v8a24,24,0,0,1-35.1,21.3,8.7,8.7,0,0,0-1.8-1.1A23.9,23.9,0,0,1,40,112Zm112,8a24,24,0,0,1-48,0v-8h48Zm52.9,20.2a8.7,8.7,0,0,0-1.8,1.1A24,24,0,0,1,168,112v-8h48v8A23.9,23.9,0,0,1,204.9,132.2Z" }, null, -1), xvi = [
  gvi
], jvi = { key: 3 }, mvi = ["stroke"], Mvi = ["stroke"], vvi = ["stroke"], Svi = ["stroke"], Hvi = ["stroke"], Avi = { key: 4 }, Vvi = ["stroke"], zvi = ["stroke"], Zvi = ["stroke"], Cvi = ["stroke"], bvi = ["stroke"], Lvi = { key: 5 }, Bvi = ["stroke"], Pvi = ["stroke"], Wvi = ["stroke"], Nvi = ["stroke"], Fvi = ["stroke"], Tvi = {
  name: "PhStorefront"
}, Qel = /* @__PURE__ */ $({
  ...Tvi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", rvi, [
        e("path", {
          d: "M48,139.6V208a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V139.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ivi),
        e("path", {
          d: "M54,40H202a8.1,8.1,0,0,1,7.7,5.8L224,96H32L46.3,45.8A8.1,8.1,0,0,1,54,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lvi),
        e("path", {
          d: "M96,96v16a32,32,0,0,1-64,0V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dvi),
        e("path", {
          d: "M160,96v16a32,32,0,0,1-64,0V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kvi),
        e("path", {
          d: "M224,96v16a32,32,0,0,1-64,0V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cvi)
      ])) : o(i) === "duotone" ? (s(), r("g", hvi, [
        uvi,
        avi,
        e("path", {
          d: "M48,139.6V208a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V139.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _vi),
        e("path", {
          d: "M54,40H202a8.1,8.1,0,0,1,7.7,5.8L224,96H32L46.3,45.8A8.1,8.1,0,0,1,54,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pvi),
        e("path", {
          d: "M96,96v16a32,32,0,0,1-64,0V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yvi),
        e("path", {
          d: "M160,96v16a32,32,0,0,1-64,0V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $vi),
        e("path", {
          d: "M224,96v16a32,32,0,0,1-64,0V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wvi)
      ])) : o(i) === "fill" ? (s(), r("g", fvi, xvi)) : o(i) === "light" ? (s(), r("g", jvi, [
        e("path", {
          d: "M48,139.6V208a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V139.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mvi),
        e("path", {
          d: "M54,40H202a8.1,8.1,0,0,1,7.7,5.8L224,96H32L46.3,45.8A8.1,8.1,0,0,1,54,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mvi),
        e("path", {
          d: "M96,96v16a32,32,0,0,1-64,0V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vvi),
        e("path", {
          d: "M160,96v16a32,32,0,0,1-64,0V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Svi),
        e("path", {
          d: "M224,96v16a32,32,0,0,1-64,0V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hvi)
      ])) : o(i) === "thin" ? (s(), r("g", Avi, [
        e("path", {
          d: "M48,139.6V208a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V139.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vvi),
        e("path", {
          d: "M54,40H202a8.1,8.1,0,0,1,7.7,5.8L224,96H32L46.3,45.8A8.1,8.1,0,0,1,54,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zvi),
        e("path", {
          d: "M96,96v16a32,32,0,0,1-64,0V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zvi),
        e("path", {
          d: "M160,96v16a32,32,0,0,1-64,0V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cvi),
        e("path", {
          d: "M224,96v16a32,32,0,0,1-64,0V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bvi)
      ])) : o(i) === "regular" ? (s(), r("g", Lvi, [
        e("path", {
          d: "M48,139.6V208a8,8,0,0,0,8,8H200a8,8,0,0,0,8-8V139.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bvi),
        e("path", {
          d: "M54,40H202a8.1,8.1,0,0,1,7.7,5.8L224,96H32L46.3,45.8A8.1,8.1,0,0,1,54,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pvi),
        e("path", {
          d: "M96,96v16a32,32,0,0,1-64,0V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wvi),
        e("path", {
          d: "M160,96v16a32,32,0,0,1-64,0V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nvi),
        e("path", {
          d: "M224,96v16a32,32,0,0,1-64,0V96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fvi)
      ])) : g("", !0)
    ], 16, svi));
  }
}), Dvi = ["width", "height", "fill", "transform"], Rvi = { key: 0 }, Uvi = ["stroke"], qvi = ["stroke"], Gvi = ["stroke"], Evi = ["stroke"], Ovi = ["stroke"], Ivi = ["stroke"], Kvi = ["stroke"], Xvi = { key: 1 }, Jvi = /* @__PURE__ */ e("circle", {
  cx: "68",
  cy: "188",
  r: "28",
  opacity: "0.2"
}, null, -1), Qvi = ["stroke"], Yvi = ["stroke"], oSi = ["stroke"], eSi = ["stroke"], tSi = ["stroke"], nSi = ["stroke"], sSi = ["stroke"], rSi = { key: 2 }, iSi = /* @__PURE__ */ e("path", { d: "M104,188a36,36,0,1,1-36-36A36,36,0,0,1,104,188ZM34.3,117.7a8.2,8.2,0,0,0,11.4,0L60,103.3l14.3,14.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4L71.3,92,85.7,77.7A8.1,8.1,0,0,0,74.3,66.3L60,80.7,45.7,66.3A8.1,8.1,0,0,0,34.3,77.7L48.7,92,34.3,106.3A8.1,8.1,0,0,0,34.3,117.7Zm173,70.3,14.4-14.3a8.1,8.1,0,0,0-11.4-11.4L196,176.7l-14.3-14.4a8.1,8.1,0,0,0-11.4,11.4L184.7,188l-14.4,14.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L196,199.3l14.3,14.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4ZM157.7,50.3,155.3,48H176a8,8,0,0,0,0-16H136a8,8,0,0,0-8,8V80a8,8,0,0,0,16,0V59.3l2.3,2.4c18,17.9,17.9,35.4,14.8,46.9-4.7,16.7-19.4,31.7-35,35.6a8.1,8.1,0,0,0-5.9,9.7A8,8,0,0,0,128,160l1.9-.2c21.3-5.3,40.4-24.6,46.6-47S175.9,68.6,157.7,50.3Z" }, null, -1), lSi = [
  iSi
], dSi = { key: 3 }, kSi = ["stroke"], cSi = ["stroke"], hSi = ["stroke"], uSi = ["stroke"], aSi = ["stroke"], _Si = ["stroke"], pSi = ["stroke"], ySi = { key: 4 }, $Si = ["stroke"], wSi = ["stroke"], fSi = ["stroke"], gSi = ["stroke"], xSi = ["stroke"], jSi = ["stroke"], mSi = ["stroke"], MSi = { key: 5 }, vSi = ["stroke"], SSi = ["stroke"], HSi = ["stroke"], ASi = ["stroke"], VSi = ["stroke"], zSi = ["stroke"], ZSi = ["stroke"], CSi = {
  name: "PhStrategy"
}, Yel = /* @__PURE__ */ $({
  ...CSi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Rvi, [
        e("circle", {
          cx: "72",
          cy: "184",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Uvi),
        e("line", {
          x1: "40",
          y1: "76",
          x2: "80",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qvi),
        e("line", {
          x1: "80",
          y1: "76",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gvi),
        e("line", {
          x1: "176",
          y1: "172",
          x2: "216",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Evi),
        e("line", {
          x1: "216",
          y1: "172",
          x2: "176",
          y2: "212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ovi),
        e("polyline", {
          points: "140 84 140 44 180 44",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ivi),
        e("path", {
          d: "M140,44l12,12c38.3,38.3,10.5,84-20,94.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Kvi)
      ])) : o(i) === "duotone" ? (s(), r("g", Xvi, [
        Jvi,
        e("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qvi),
        e("line", {
          x1: "40",
          y1: "72",
          x2: "80",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yvi),
        e("line", {
          x1: "80",
          y1: "72",
          x2: "40",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oSi),
        e("line", {
          x1: "176",
          y1: "168",
          x2: "216",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eSi),
        e("line", {
          x1: "216",
          y1: "168",
          x2: "176",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tSi),
        e("polyline", {
          points: "136 80 136 40 176 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nSi),
        e("path", {
          d: "M136,40l16,16c40,40,8,88-24,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sSi)
      ])) : o(i) === "fill" ? (s(), r("g", rSi, lSi)) : o(i) === "light" ? (s(), r("g", dSi, [
        e("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kSi),
        e("line", {
          x1: "40",
          y1: "72",
          x2: "80",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cSi),
        e("line", {
          x1: "80",
          y1: "72",
          x2: "40",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hSi),
        e("line", {
          x1: "176",
          y1: "168",
          x2: "216",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uSi),
        e("line", {
          x1: "216",
          y1: "168",
          x2: "176",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aSi),
        e("polyline", {
          points: "136 80 136 40 176 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _Si),
        e("path", {
          d: "M136,40l16,16c40,40,8,88-24,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pSi)
      ])) : o(i) === "thin" ? (s(), r("g", ySi, [
        e("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $Si),
        e("line", {
          x1: "40",
          y1: "72",
          x2: "80",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wSi),
        e("line", {
          x1: "80",
          y1: "72",
          x2: "40",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fSi),
        e("line", {
          x1: "176",
          y1: "168",
          x2: "216",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gSi),
        e("line", {
          x1: "216",
          y1: "168",
          x2: "176",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xSi),
        e("polyline", {
          points: "136 80 136 40 176 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jSi),
        e("path", {
          d: "M136,40l16,16c40,40,8,88-24,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mSi)
      ])) : o(i) === "regular" ? (s(), r("g", MSi, [
        e("circle", {
          cx: "68",
          cy: "188",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vSi),
        e("line", {
          x1: "40",
          y1: "72",
          x2: "80",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SSi),
        e("line", {
          x1: "80",
          y1: "72",
          x2: "40",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HSi),
        e("line", {
          x1: "176",
          y1: "168",
          x2: "216",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ASi),
        e("line", {
          x1: "216",
          y1: "168",
          x2: "176",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VSi),
        e("polyline", {
          points: "136 80 136 40 176 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zSi),
        e("path", {
          d: "M136,40l16,16c40,40,8,88-24,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZSi)
      ])) : g("", !0)
    ], 16, Dvi));
  }
}), bSi = ["width", "height", "fill", "transform"], LSi = { key: 0 }, BSi = ["stroke"], PSi = ["stroke"], WSi = { key: 1 }, NSi = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), FSi = ["stroke"], TSi = ["stroke"], DSi = { key: 2 }, RSi = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM128,184c-24.7,0-44.1-14.1-44.1-32a8,8,0,0,1,16,0c0,7.6,11.6,16,28.1,16,13.3,0,28.1-6.6,28.1-16s-12.2-13.4-30.8-18.2c-8.7-2.2-17.7-4.5-24.8-8.2-9.7-5.2-14.6-12.4-14.6-21.6,0-18.2,18.1-32,42.1-32,17.2,0,31.9,7.2,38.5,18.7a8,8,0,0,1-3,10.9,7.9,7.9,0,0,1-10.9-3C148.9,92.2,139.3,88,128,88c-14.6,0-26.1,7-26.1,16,0,6.8,10.8,10.1,27.3,14.3,19.1,4.9,42.9,11,42.9,33.7C172.1,169.9,152.7,184,128,184Z" }, null, -1), USi = [
  RSi
], qSi = { key: 3 }, GSi = ["stroke"], ESi = ["stroke"], OSi = { key: 4 }, ISi = ["stroke"], KSi = ["stroke"], XSi = { key: 5 }, JSi = ["stroke"], QSi = ["stroke"], YSi = {
  name: "PhStripeLogo"
}, otl = /* @__PURE__ */ $({
  ...YSi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", LSi, [
        e("path", {
          d: "M91.9,152c0,13.3,16.2,24,36.1,24s36.1-10.7,36.1-24c0-32-70.2-20-70.2-48,0-13.3,14.2-24,34.1-24,14.9,0,26.6,6,31.5,14.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BSi),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PSi)
      ])) : o(i) === "duotone" ? (s(), r("g", WSi, [
        NSi,
        e("path", {
          d: "M91.9,152c0,13.3,16.2,24,36.1,24s36.1-10.7,36.1-24c0-32-70.2-20-70.2-48,0-13.3,14.2-24,34.1-24,14.9,0,26.6,6,31.5,14.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FSi),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TSi)
      ])) : o(i) === "fill" ? (s(), r("g", DSi, USi)) : o(i) === "light" ? (s(), r("g", qSi, [
        e("path", {
          d: "M91.9,152c0,13.3,16.2,24,36.1,24s36.1-10.7,36.1-24c0-32-70.2-20-70.2-48,0-13.3,14.2-24,34.1-24,14.9,0,26.6,6,31.5,14.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GSi),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ESi)
      ])) : o(i) === "thin" ? (s(), r("g", OSi, [
        e("path", {
          d: "M91.9,152c0,13.3,16.2,24,36.1,24s36.1-10.7,36.1-24c0-32-70.2-20-70.2-48,0-13.3,14.2-24,34.1-24,14.9,0,26.6,6,31.5,14.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ISi),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KSi)
      ])) : o(i) === "regular" ? (s(), r("g", XSi, [
        e("path", {
          d: "M91.9,152c0,13.3,16.2,24,36.1,24s36.1-10.7,36.1-24c0-32-70.2-20-70.2-48,0-13.3,14.2-24,34.1-24,14.9,0,26.6,6,31.5,14.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JSi),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QSi)
      ])) : g("", !0)
    ], 16, bSi));
  }
}), oHi = ["width", "height", "fill", "transform"], eHi = { key: 0 }, tHi = ["stroke"], nHi = ["stroke"], sHi = ["stroke"], rHi = ["stroke"], iHi = { key: 1 }, lHi = /* @__PURE__ */ e("polygon", {
  points: "224 64 128 96 32 64 128 32 224 64",
  opacity: "0.2"
}, null, -1), dHi = ["stroke"], kHi = ["stroke"], cHi = ["stroke"], hHi = ["stroke"], uHi = { key: 2 }, aHi = /* @__PURE__ */ e("path", { d: "M226.5,56.4l-96-32a8.5,8.5,0,0,0-5,0l-95.9,32h-.2l-1,.5h-.1l-1,.6c0,.1-.1.1-.2.2l-.8.7h0l-.7.8c0,.1-.1.1-.1.2l-.6.9c0,.1,0,.1-.1.2l-.4.9h0l-.3,1.1v.3A3.7,3.7,0,0,0,24,64v80a8,8,0,0,0,16,0V75.1L73.6,86.3A63.2,63.2,0,0,0,64,120a64,64,0,0,0,30,54.2,96.1,96.1,0,0,0-46.5,37.4,8.1,8.1,0,0,0,2.4,11.1,7.9,7.9,0,0,0,11-2.3,80,80,0,0,1,134.2,0,8,8,0,0,0,6.7,3.6,7.5,7.5,0,0,0,4.3-1.3,8.1,8.1,0,0,0,2.4-11.1A96.1,96.1,0,0,0,162,174.2,64,64,0,0,0,192,120a63.2,63.2,0,0,0-9.6-33.7l44.1-14.7a8,8,0,0,0,0-15.2ZM128,168a48,48,0,0,1-48-48,48.6,48.6,0,0,1,9.3-28.5l36.2,12.1a8,8,0,0,0,5,0l36.2-12.1A48.6,48.6,0,0,1,176,120,48,48,0,0,1,128,168Z" }, null, -1), _Hi = [
  aHi
], pHi = { key: 3 }, yHi = ["stroke"], $Hi = ["stroke"], wHi = ["stroke"], fHi = ["stroke"], gHi = { key: 4 }, xHi = ["stroke"], jHi = ["stroke"], mHi = ["stroke"], MHi = ["stroke"], vHi = { key: 5 }, SHi = ["stroke"], HHi = ["stroke"], AHi = ["stroke"], VHi = ["stroke"], zHi = {
  name: "PhStudent"
}, etl = /* @__PURE__ */ $({
  ...zHi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", eHi, [
        e("line", {
          x1: "32",
          y1: "64",
          x2: "32",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tHi),
        e("path", {
          d: "M54.2,216a88.1,88.1,0,0,1,147.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nHi),
        e("polygon", {
          points: "224 64 128 96 32 64 128 32 224 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sHi),
        e("path", {
          d: "M169.3,82.2a56,56,0,1,1-82.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rHi)
      ])) : o(i) === "duotone" ? (s(), r("g", iHi, [
        lHi,
        e("line", {
          x1: "32",
          y1: "64",
          x2: "32",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dHi),
        e("path", {
          d: "M54.2,216a88.1,88.1,0,0,1,147.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kHi),
        e("polygon", {
          points: "224 64 128 96 32 64 128 32 224 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cHi),
        e("path", {
          d: "M169.3,82.2a56,56,0,1,1-82.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hHi)
      ])) : o(i) === "fill" ? (s(), r("g", uHi, _Hi)) : o(i) === "light" ? (s(), r("g", pHi, [
        e("line", {
          x1: "32",
          y1: "64",
          x2: "32",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yHi),
        e("path", {
          d: "M54.2,216a88.1,88.1,0,0,1,147.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $Hi),
        e("polygon", {
          points: "224 64 128 96 32 64 128 32 224 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wHi),
        e("path", {
          d: "M169.3,82.2a56,56,0,1,1-82.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fHi)
      ])) : o(i) === "thin" ? (s(), r("g", gHi, [
        e("line", {
          x1: "32",
          y1: "64",
          x2: "32",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xHi),
        e("path", {
          d: "M54.2,216a88.1,88.1,0,0,1,147.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jHi),
        e("polygon", {
          points: "224 64 128 96 32 64 128 32 224 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mHi),
        e("path", {
          d: "M169.3,82.2a56,56,0,1,1-82.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MHi)
      ])) : o(i) === "regular" ? (s(), r("g", vHi, [
        e("line", {
          x1: "32",
          y1: "64",
          x2: "32",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SHi),
        e("path", {
          d: "M54.2,216a88.1,88.1,0,0,1,147.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HHi),
        e("polygon", {
          points: "224 64 128 96 32 64 128 32 224 64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AHi),
        e("path", {
          d: "M169.3,82.2a56,56,0,1,1-82.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VHi)
      ])) : g("", !0)
    ], 16, oHi));
  }
}), ZHi = ["width", "height", "fill", "transform"], CHi = { key: 0 }, bHi = ["stroke"], LHi = ["stroke"], BHi = { key: 1 }, PHi = /* @__PURE__ */ e("path", {
  d: "M88,72V216H40a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8Z",
  opacity: "0.2"
}, null, -1), WHi = /* @__PURE__ */ e("path", {
  d: "M168,72V216h48a8,8,0,0,0,8-8V80a8,8,0,0,0-8-8Z",
  opacity: "0.2"
}, null, -1), NHi = ["stroke"], FHi = ["stroke"], THi = { key: 2 }, DHi = /* @__PURE__ */ e("path", { d: "M216,64H176V56a24.1,24.1,0,0,0-24-24H104A24.1,24.1,0,0,0,80,56v8H40A16,16,0,0,0,24,80V208a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64ZM96,80h64V208H96Zm0-24a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Z" }, null, -1), RHi = [
  DHi
], UHi = { key: 3 }, qHi = ["stroke"], GHi = ["stroke"], EHi = { key: 4 }, OHi = ["stroke"], IHi = ["stroke"], KHi = { key: 5 }, XHi = ["stroke"], JHi = ["stroke"], QHi = {
  name: "PhSuitcase"
}, ttl = /* @__PURE__ */ $({
  ...QHi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", CHi, [
        e("rect", {
          x: "32",
          y: "68",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bHi),
        e("path", {
          d: "M168,212V48a16,16,0,0,0-16-16H104A16,16,0,0,0,88,48V212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LHi)
      ])) : o(i) === "duotone" ? (s(), r("g", BHi, [
        PHi,
        WHi,
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NHi),
        e("path", {
          d: "M168,216V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FHi)
      ])) : o(i) === "fill" ? (s(), r("g", THi, RHi)) : o(i) === "light" ? (s(), r("g", UHi, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qHi),
        e("path", {
          d: "M168,216V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GHi)
      ])) : o(i) === "thin" ? (s(), r("g", EHi, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OHi),
        e("path", {
          d: "M168,216V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, IHi)
      ])) : o(i) === "regular" ? (s(), r("g", KHi, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XHi),
        e("path", {
          d: "M168,216V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JHi)
      ])) : g("", !0)
    ], 16, ZHi));
  }
}), YHi = ["width", "height", "fill", "transform"], oAi = { key: 0 }, eAi = ["stroke"], tAi = ["stroke"], nAi = ["stroke"], sAi = { key: 1 }, rAi = /* @__PURE__ */ e("path", {
  d: "M224,160v48a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V160",
  opacity: "0.2"
}, null, -1), iAi = ["stroke"], lAi = ["stroke"], dAi = ["stroke"], kAi = { key: 2 }, cAi = /* @__PURE__ */ e("path", { d: "M216,64H176V56a24.1,24.1,0,0,0-24-24H104A24.1,24.1,0,0,0,80,56v8H40A16,16,0,0,0,24,80V208a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64ZM96,56a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96ZM216,80v72H40V80Z" }, null, -1), hAi = [
  cAi
], uAi = { key: 3 }, aAi = ["stroke"], _Ai = ["stroke"], pAi = ["stroke"], yAi = { key: 4 }, $Ai = ["stroke"], wAi = ["stroke"], fAi = ["stroke"], gAi = { key: 5 }, xAi = ["stroke"], jAi = ["stroke"], mAi = ["stroke"], MAi = {
  name: "PhSuitcaseSimple"
}, ntl = /* @__PURE__ */ $({
  ...MAi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", oAi, [
        e("rect", {
          x: "32",
          y: "68",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eAi),
        e("path", {
          d: "M168,68V48a16,16,0,0,0-16-16H104A16,16,0,0,0,88,48V68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tAi),
        e("line", {
          x1: "32",
          y1: "160",
          x2: "224",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nAi)
      ])) : o(i) === "duotone" ? (s(), r("g", sAi, [
        rAi,
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iAi),
        e("path", {
          d: "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lAi),
        e("line", {
          x1: "32",
          y1: "160",
          x2: "224",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dAi)
      ])) : o(i) === "fill" ? (s(), r("g", kAi, hAi)) : o(i) === "light" ? (s(), r("g", uAi, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aAi),
        e("path", {
          d: "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _Ai),
        e("line", {
          x1: "32",
          y1: "160",
          x2: "224",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pAi)
      ])) : o(i) === "thin" ? (s(), r("g", yAi, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $Ai),
        e("path", {
          d: "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wAi),
        e("line", {
          x1: "32",
          y1: "160",
          x2: "224",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fAi)
      ])) : o(i) === "regular" ? (s(), r("g", gAi, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "144",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xAi),
        e("path", {
          d: "M168,72V56a16,16,0,0,0-16-16H104A16,16,0,0,0,88,56V72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jAi),
        e("line", {
          x1: "32",
          y1: "160",
          x2: "224",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mAi)
      ])) : g("", !0)
    ], 16, YHi));
  }
}), vAi = ["width", "height", "fill", "transform"], SAi = { key: 0 }, HAi = ["stroke"], AAi = ["stroke"], VAi = ["stroke"], zAi = ["stroke"], ZAi = ["stroke"], CAi = ["stroke"], bAi = ["stroke"], LAi = ["stroke"], BAi = ["stroke"], PAi = { key: 1 }, WAi = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "60",
  opacity: "0.2"
}, null, -1), NAi = ["stroke"], FAi = ["stroke"], TAi = ["stroke"], DAi = ["stroke"], RAi = ["stroke"], UAi = ["stroke"], qAi = ["stroke"], GAi = ["stroke"], EAi = ["stroke"], OAi = { key: 2 }, IAi = /* @__PURE__ */ j('<circle cx="128" cy="128" r="68"></circle><path d="M128,44a8,8,0,0,0,8-8V16a8,8,0,0,0-16,0V36A8,8,0,0,0,128,44Z"></path><path d="M57.3,68.6a8.1,8.1,0,0,0,11.3,0,8,8,0,0,0,0-11.3L54.5,43.1A8.1,8.1,0,1,0,43.1,54.5Z"></path><path d="M44,128a8,8,0,0,0-8-8H16a8,8,0,0,0,0,16H36A8,8,0,0,0,44,128Z"></path><path d="M57.3,187.4,43.1,201.5a8.1,8.1,0,0,0,0,11.4,8.5,8.5,0,0,0,5.7,2.3,8.3,8.3,0,0,0,5.7-2.3l14.1-14.2a8,8,0,0,0-11.3-11.3Z"></path><path d="M128,212a8,8,0,0,0-8,8v20a8,8,0,0,0,16,0V220A8,8,0,0,0,128,212Z"></path><path d="M198.7,187.4a8,8,0,0,0-11.3,11.3l14.1,14.2a8.3,8.3,0,0,0,5.7,2.3,8.5,8.5,0,0,0,5.7-2.3,8.1,8.1,0,0,0,0-11.4Z"></path><path d="M240,120H220a8,8,0,0,0,0,16h20a8,8,0,0,0,0-16Z"></path><path d="M193.1,70.9a7.8,7.8,0,0,0,5.6-2.3l14.2-14.1a8.1,8.1,0,0,0-11.4-11.4L187.4,57.3a8,8,0,0,0,0,11.3A7.8,7.8,0,0,0,193.1,70.9Z"></path>', 9), KAi = [
  IAi
], XAi = { key: 3 }, JAi = ["stroke"], QAi = ["stroke"], YAi = ["stroke"], oVi = ["stroke"], eVi = ["stroke"], tVi = ["stroke"], nVi = ["stroke"], sVi = ["stroke"], rVi = ["stroke"], iVi = { key: 4 }, lVi = ["stroke"], dVi = ["stroke"], kVi = ["stroke"], cVi = ["stroke"], hVi = ["stroke"], uVi = ["stroke"], aVi = ["stroke"], _Vi = ["stroke"], pVi = ["stroke"], yVi = { key: 5 }, $Vi = ["stroke"], wVi = ["stroke"], fVi = ["stroke"], gVi = ["stroke"], xVi = ["stroke"], jVi = ["stroke"], mVi = ["stroke"], MVi = ["stroke"], vVi = ["stroke"], SVi = {
  name: "PhSun"
}, stl = /* @__PURE__ */ $({
  ...SVi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", SAi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HAi),
        e("line", {
          x1: "128",
          y1: "28",
          x2: "128",
          y2: "12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, AAi),
        e("line", {
          x1: "198.7",
          y1: "57.3",
          x2: "210",
          y2: "46",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VAi),
        e("line", {
          x1: "228",
          y1: "128",
          x2: "244",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zAi),
        e("line", {
          x1: "198.7",
          y1: "198.7",
          x2: "210",
          y2: "210",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZAi),
        e("line", {
          x1: "128",
          y1: "228",
          x2: "128",
          y2: "244",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CAi),
        e("line", {
          x1: "57.3",
          y1: "198.7",
          x2: "46",
          y2: "210",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bAi),
        e("line", {
          x1: "28",
          y1: "128",
          x2: "12",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LAi),
        e("line", {
          x1: "57.3",
          y1: "57.3",
          x2: "46",
          y2: "46",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BAi)
      ])) : o(i) === "duotone" ? (s(), r("g", PAi, [
        WAi,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NAi),
        e("line", {
          x1: "128",
          y1: "36",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FAi),
        e("line", {
          x1: "62.9",
          y1: "62.9",
          x2: "48.8",
          y2: "48.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TAi),
        e("line", {
          x1: "36",
          y1: "128",
          x2: "16",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DAi),
        e("line", {
          x1: "62.9",
          y1: "193.1",
          x2: "48.8",
          y2: "207.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RAi),
        e("line", {
          x1: "128",
          y1: "220",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UAi),
        e("line", {
          x1: "193.1",
          y1: "193.1",
          x2: "207.2",
          y2: "207.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qAi),
        e("line", {
          x1: "220",
          y1: "128",
          x2: "240",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GAi),
        e("line", {
          x1: "193.1",
          y1: "62.9",
          x2: "207.2",
          y2: "48.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EAi)
      ])) : o(i) === "fill" ? (s(), r("g", OAi, KAi)) : o(i) === "light" ? (s(), r("g", XAi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JAi),
        e("line", {
          x1: "128",
          y1: "36",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QAi),
        e("line", {
          x1: "62.9",
          y1: "62.9",
          x2: "48.8",
          y2: "48.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YAi),
        e("line", {
          x1: "36",
          y1: "128",
          x2: "16",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oVi),
        e("line", {
          x1: "62.9",
          y1: "193.1",
          x2: "48.8",
          y2: "207.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eVi),
        e("line", {
          x1: "128",
          y1: "220",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tVi),
        e("line", {
          x1: "193.1",
          y1: "193.1",
          x2: "207.2",
          y2: "207.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nVi),
        e("line", {
          x1: "220",
          y1: "128",
          x2: "240",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sVi),
        e("line", {
          x1: "193.1",
          y1: "62.9",
          x2: "207.2",
          y2: "48.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rVi)
      ])) : o(i) === "thin" ? (s(), r("g", iVi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lVi),
        e("line", {
          x1: "128",
          y1: "36",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dVi),
        e("line", {
          x1: "62.9",
          y1: "62.9",
          x2: "48.8",
          y2: "48.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kVi),
        e("line", {
          x1: "36",
          y1: "128",
          x2: "16",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cVi),
        e("line", {
          x1: "62.9",
          y1: "193.1",
          x2: "48.8",
          y2: "207.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hVi),
        e("line", {
          x1: "128",
          y1: "220",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uVi),
        e("line", {
          x1: "193.1",
          y1: "193.1",
          x2: "207.2",
          y2: "207.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aVi),
        e("line", {
          x1: "220",
          y1: "128",
          x2: "240",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _Vi),
        e("line", {
          x1: "193.1",
          y1: "62.9",
          x2: "207.2",
          y2: "48.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pVi)
      ])) : o(i) === "regular" ? (s(), r("g", yVi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Vi),
        e("line", {
          x1: "128",
          y1: "36",
          x2: "128",
          y2: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wVi),
        e("line", {
          x1: "62.9",
          y1: "62.9",
          x2: "48.8",
          y2: "48.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fVi),
        e("line", {
          x1: "36",
          y1: "128",
          x2: "16",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gVi),
        e("line", {
          x1: "62.9",
          y1: "193.1",
          x2: "48.8",
          y2: "207.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xVi),
        e("line", {
          x1: "128",
          y1: "220",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jVi),
        e("line", {
          x1: "193.1",
          y1: "193.1",
          x2: "207.2",
          y2: "207.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mVi),
        e("line", {
          x1: "220",
          y1: "128",
          x2: "240",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MVi),
        e("line", {
          x1: "193.1",
          y1: "62.9",
          x2: "207.2",
          y2: "48.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vVi)
      ])) : g("", !0)
    ], 16, vAi));
  }
}), HVi = ["width", "height", "fill", "transform"], AVi = { key: 0 }, VVi = ["stroke"], zVi = ["stroke"], ZVi = ["stroke"], CVi = ["stroke"], bVi = ["stroke"], LVi = ["stroke"], BVi = ["stroke"], PVi = ["stroke"], WVi = ["stroke"], NVi = { key: 1 }, FVi = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "60",
  opacity: "0.2"
}, null, -1), TVi = ["stroke"], DVi = ["stroke"], RVi = ["stroke"], UVi = ["stroke"], qVi = ["stroke"], GVi = ["stroke"], EVi = ["stroke"], OVi = ["stroke"], IVi = ["stroke"], KVi = { key: 2 }, XVi = /* @__PURE__ */ j('<circle cx="128" cy="128" r="68"></circle><path d="M128,44a8,8,0,0,0,8-8V28a8,8,0,0,0-16,0v8A8,8,0,0,0,128,44Z"></path><path d="M57.3,68.6a8.1,8.1,0,0,0,11.3,0,8,8,0,0,0,0-11.3l-5.7-5.7A8,8,0,0,0,51.6,62.9Z"></path><path d="M36,120H28a8,8,0,0,0,0,16h8a8,8,0,0,0,0-16Z"></path><path d="M57.3,187.4l-5.7,5.7a8,8,0,0,0,0,11.3,8.3,8.3,0,0,0,5.7,2.3,8,8,0,0,0,5.6-2.3l5.7-5.7a8,8,0,0,0-11.3-11.3Z"></path><path d="M128,212a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-8A8,8,0,0,0,128,212Z"></path><path d="M198.7,187.4a8,8,0,0,0-11.3,11.3l5.7,5.7a8,8,0,0,0,5.6,2.3,8.3,8.3,0,0,0,5.7-2.3,8,8,0,0,0,0-11.3Z"></path><path d="M228,120h-8a8,8,0,0,0,0,16h8a8,8,0,0,0,0-16Z"></path><path d="M193.1,70.9a7.8,7.8,0,0,0,5.6-2.3l5.7-5.7a8,8,0,1,0-11.3-11.3l-5.7,5.7a8,8,0,0,0,0,11.3A7.8,7.8,0,0,0,193.1,70.9Z"></path>', 9), JVi = [
  XVi
], QVi = { key: 3 }, YVi = ["stroke"], ozi = ["stroke"], ezi = ["stroke"], tzi = ["stroke"], nzi = ["stroke"], szi = ["stroke"], rzi = ["stroke"], izi = ["stroke"], lzi = ["stroke"], dzi = { key: 4 }, kzi = ["stroke"], czi = ["stroke"], hzi = ["stroke"], uzi = ["stroke"], azi = ["stroke"], _zi = ["stroke"], pzi = ["stroke"], yzi = ["stroke"], $zi = ["stroke"], wzi = { key: 5 }, fzi = ["stroke"], gzi = ["stroke"], xzi = ["stroke"], jzi = ["stroke"], mzi = ["stroke"], Mzi = ["stroke"], vzi = ["stroke"], Szi = ["stroke"], Hzi = ["stroke"], Azi = {
  name: "PhSunDim"
}, rtl = /* @__PURE__ */ $({
  ...Azi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", AVi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VVi),
        e("line", {
          x1: "128",
          y1: "28",
          x2: "128",
          y2: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zVi),
        e("line", {
          x1: "198.7",
          y1: "57.3",
          x2: "204.4",
          y2: "51.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZVi),
        e("line", {
          x1: "228",
          y1: "128",
          x2: "236",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CVi),
        e("line", {
          x1: "198.7",
          y1: "198.7",
          x2: "204.4",
          y2: "204.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bVi),
        e("line", {
          x1: "128",
          y1: "228",
          x2: "128",
          y2: "236",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LVi),
        e("line", {
          x1: "57.3",
          y1: "198.7",
          x2: "51.6",
          y2: "204.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BVi),
        e("line", {
          x1: "28",
          y1: "128",
          x2: "20",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PVi),
        e("line", {
          x1: "57.3",
          y1: "57.3",
          x2: "51.6",
          y2: "51.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WVi)
      ])) : o(i) === "duotone" ? (s(), r("g", NVi, [
        FVi,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TVi),
        e("line", {
          x1: "128",
          y1: "36",
          x2: "128",
          y2: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DVi),
        e("line", {
          x1: "62.9",
          y1: "62.9",
          x2: "57.3",
          y2: "57.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RVi),
        e("line", {
          x1: "36",
          y1: "128",
          x2: "28",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UVi),
        e("line", {
          x1: "62.9",
          y1: "193.1",
          x2: "57.3",
          y2: "198.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qVi),
        e("line", {
          x1: "128",
          y1: "220",
          x2: "128",
          y2: "228",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GVi),
        e("line", {
          x1: "193.1",
          y1: "193.1",
          x2: "198.7",
          y2: "198.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EVi),
        e("line", {
          x1: "220",
          y1: "128",
          x2: "228",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OVi),
        e("line", {
          x1: "193.1",
          y1: "62.9",
          x2: "198.7",
          y2: "57.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IVi)
      ])) : o(i) === "fill" ? (s(), r("g", KVi, JVi)) : o(i) === "light" ? (s(), r("g", QVi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YVi),
        e("line", {
          x1: "128",
          y1: "36",
          x2: "128",
          y2: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ozi),
        e("line", {
          x1: "62.9",
          y1: "62.9",
          x2: "57.3",
          y2: "57.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ezi),
        e("line", {
          x1: "36",
          y1: "128",
          x2: "28",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tzi),
        e("line", {
          x1: "62.9",
          y1: "193.1",
          x2: "57.3",
          y2: "198.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nzi),
        e("line", {
          x1: "128",
          y1: "220",
          x2: "128",
          y2: "228",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, szi),
        e("line", {
          x1: "193.1",
          y1: "193.1",
          x2: "198.7",
          y2: "198.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rzi),
        e("line", {
          x1: "220",
          y1: "128",
          x2: "228",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, izi),
        e("line", {
          x1: "193.1",
          y1: "62.9",
          x2: "198.7",
          y2: "57.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lzi)
      ])) : o(i) === "thin" ? (s(), r("g", dzi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kzi),
        e("line", {
          x1: "128",
          y1: "36",
          x2: "128",
          y2: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, czi),
        e("line", {
          x1: "62.9",
          y1: "62.9",
          x2: "57.3",
          y2: "57.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hzi),
        e("line", {
          x1: "36",
          y1: "128",
          x2: "28",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uzi),
        e("line", {
          x1: "62.9",
          y1: "193.1",
          x2: "57.3",
          y2: "198.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, azi),
        e("line", {
          x1: "128",
          y1: "220",
          x2: "128",
          y2: "228",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _zi),
        e("line", {
          x1: "193.1",
          y1: "193.1",
          x2: "198.7",
          y2: "198.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pzi),
        e("line", {
          x1: "220",
          y1: "128",
          x2: "228",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yzi),
        e("line", {
          x1: "193.1",
          y1: "62.9",
          x2: "198.7",
          y2: "57.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $zi)
      ])) : o(i) === "regular" ? (s(), r("g", wzi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fzi),
        e("line", {
          x1: "128",
          y1: "36",
          x2: "128",
          y2: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gzi),
        e("line", {
          x1: "62.9",
          y1: "62.9",
          x2: "57.3",
          y2: "57.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xzi),
        e("line", {
          x1: "36",
          y1: "128",
          x2: "28",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jzi),
        e("line", {
          x1: "62.9",
          y1: "193.1",
          x2: "57.3",
          y2: "198.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mzi),
        e("line", {
          x1: "128",
          y1: "220",
          x2: "128",
          y2: "228",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mzi),
        e("line", {
          x1: "193.1",
          y1: "193.1",
          x2: "198.7",
          y2: "198.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vzi),
        e("line", {
          x1: "220",
          y1: "128",
          x2: "228",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Szi),
        e("line", {
          x1: "193.1",
          y1: "62.9",
          x2: "198.7",
          y2: "57.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hzi)
      ])) : g("", !0)
    ], 16, HVi));
  }
}), Vzi = ["width", "height", "fill", "transform"], zzi = { key: 0 }, Zzi = ["stroke"], Czi = ["stroke"], bzi = ["stroke"], Lzi = ["stroke"], Bzi = ["stroke"], Pzi = ["stroke"], Wzi = ["stroke"], Nzi = { key: 1 }, Fzi = /* @__PURE__ */ e("path", {
  d: "M70.2,160a60,60,0,1,1,115.6,0Z",
  opacity: "0.2"
}, null, -1), Tzi = ["stroke"], Dzi = ["stroke"], Rzi = ["stroke"], Uzi = ["stroke"], qzi = ["stroke"], Gzi = ["stroke"], Ezi = ["stroke"], Ozi = { key: 2 }, Izi = /* @__PURE__ */ e("path", { d: "M77.7,43.6a8.1,8.1,0,0,1,4.4-10.5,7.9,7.9,0,0,1,10.4,4.4l7.7,18.4a8.1,8.1,0,0,1-4.3,10.5,8.5,8.5,0,0,1-3.1.6,8.2,8.2,0,0,1-7.4-4.9ZM21.5,108.5l18.4,7.7a8.5,8.5,0,0,0,3.1.6,8,8,0,0,0,3.1-15.4L27.6,93.7a8.1,8.1,0,0,0-10.5,4.4A7.9,7.9,0,0,0,21.5,108.5ZM213,116.8a8.5,8.5,0,0,0,3.1-.6l18.4-7.7a7.9,7.9,0,0,0,4.4-10.4,8.1,8.1,0,0,0-10.5-4.4l-18.5,7.7a8,8,0,0,0,3.1,15.4ZM160.1,66.4a8.5,8.5,0,0,0,3.1.6,8.2,8.2,0,0,0,7.4-4.9l7.7-18.5a8.1,8.1,0,0,0-4.4-10.5,7.9,7.9,0,0,0-10.4,4.4l-7.7,18.4A8.1,8.1,0,0,0,160.1,66.4ZM240,152H195.5a70.1,70.1,0,0,0,.5-8,68,68,0,0,0-136,0,70.1,70.1,0,0,0,.5,8H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16Zm-32,40H48a8,8,0,0,0,0,16H208a8,8,0,0,0,0-16Z" }, null, -1), Kzi = [
  Izi
], Xzi = { key: 3 }, Jzi = ["stroke"], Qzi = ["stroke"], Yzi = ["stroke"], oZi = ["stroke"], eZi = ["stroke"], tZi = ["stroke"], nZi = ["stroke"], sZi = { key: 4 }, rZi = ["stroke"], iZi = ["stroke"], lZi = ["stroke"], dZi = ["stroke"], kZi = ["stroke"], cZi = ["stroke"], hZi = ["stroke"], uZi = { key: 5 }, aZi = ["stroke"], _Zi = ["stroke"], pZi = ["stroke"], yZi = ["stroke"], $Zi = ["stroke"], wZi = ["stroke"], fZi = ["stroke"], gZi = {
  name: "PhSunHorizon"
}, itl = /* @__PURE__ */ $({
  ...gZi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", zzi, [
        e("line", {
          x1: "92.8",
          y1: "59",
          x2: "85.1",
          y2: "40.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zzi),
        e("line", {
          x1: "43",
          y1: "108.8",
          x2: "24.5",
          y2: "101.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Czi),
        e("line", {
          x1: "213",
          y1: "108.8",
          x2: "231.5",
          y2: "101.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bzi),
        e("line", {
          x1: "163.2",
          y1: "59",
          x2: "170.9",
          y2: "40.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Lzi),
        e("line", {
          x1: "240",
          y1: "160",
          x2: "16",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bzi),
        e("line", {
          x1: "208",
          y1: "200",
          x2: "48",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pzi),
        e("path", {
          d: "M77.4,160A53.2,53.2,0,0,1,76,148a52,52,0,0,1,104,0,53.2,53.2,0,0,1-1.4,12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wzi)
      ])) : o(i) === "duotone" ? (s(), r("g", Nzi, [
        Fzi,
        e("line", {
          x1: "92.8",
          y1: "59",
          x2: "85.1",
          y2: "40.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tzi),
        e("line", {
          x1: "43",
          y1: "108.8",
          x2: "24.5",
          y2: "101.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dzi),
        e("line", {
          x1: "213",
          y1: "108.8",
          x2: "231.5",
          y2: "101.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rzi),
        e("line", {
          x1: "163.2",
          y1: "59",
          x2: "170.9",
          y2: "40.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uzi),
        e("line", {
          x1: "240",
          y1: "160",
          x2: "16",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qzi),
        e("line", {
          x1: "208",
          y1: "200",
          x2: "48",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gzi),
        e("path", {
          d: "M70.2,160a60,60,0,1,1,115.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ezi)
      ])) : o(i) === "fill" ? (s(), r("g", Ozi, Kzi)) : o(i) === "light" ? (s(), r("g", Xzi, [
        e("line", {
          x1: "92.8",
          y1: "59",
          x2: "85.1",
          y2: "40.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jzi),
        e("line", {
          x1: "43",
          y1: "108.8",
          x2: "24.5",
          y2: "101.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qzi),
        e("line", {
          x1: "213",
          y1: "108.8",
          x2: "231.5",
          y2: "101.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Yzi),
        e("line", {
          x1: "163.2",
          y1: "59",
          x2: "170.9",
          y2: "40.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oZi),
        e("line", {
          x1: "240",
          y1: "160",
          x2: "16",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eZi),
        e("line", {
          x1: "208",
          y1: "200",
          x2: "48",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tZi),
        e("path", {
          d: "M70.2,160a60,60,0,1,1,115.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nZi)
      ])) : o(i) === "thin" ? (s(), r("g", sZi, [
        e("line", {
          x1: "92.8",
          y1: "59",
          x2: "85.1",
          y2: "40.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rZi),
        e("line", {
          x1: "43",
          y1: "108.8",
          x2: "24.5",
          y2: "101.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iZi),
        e("line", {
          x1: "213",
          y1: "108.8",
          x2: "231.5",
          y2: "101.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lZi),
        e("line", {
          x1: "163.2",
          y1: "59",
          x2: "170.9",
          y2: "40.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dZi),
        e("line", {
          x1: "240",
          y1: "160",
          x2: "16",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kZi),
        e("line", {
          x1: "208",
          y1: "200",
          x2: "48",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cZi),
        e("path", {
          d: "M70.2,160a60,60,0,1,1,115.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hZi)
      ])) : o(i) === "regular" ? (s(), r("g", uZi, [
        e("line", {
          x1: "92.8",
          y1: "59",
          x2: "85.1",
          y2: "40.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aZi),
        e("line", {
          x1: "43",
          y1: "108.8",
          x2: "24.5",
          y2: "101.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Zi),
        e("line", {
          x1: "213",
          y1: "108.8",
          x2: "231.5",
          y2: "101.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pZi),
        e("line", {
          x1: "163.2",
          y1: "59",
          x2: "170.9",
          y2: "40.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yZi),
        e("line", {
          x1: "240",
          y1: "160",
          x2: "16",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Zi),
        e("line", {
          x1: "208",
          y1: "200",
          x2: "48",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wZi),
        e("path", {
          d: "M70.2,160a60,60,0,1,1,115.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fZi)
      ])) : g("", !0)
    ], 16, Vzi));
  }
}), xZi = ["width", "height", "fill", "transform"], jZi = { key: 0 }, mZi = ["stroke"], MZi = ["stroke"], vZi = ["stroke"], SZi = ["stroke"], HZi = ["stroke"], AZi = { key: 1 }, VZi = /* @__PURE__ */ e("path", {
  d: "M104,140v24a36,36,0,0,1-72,0V140Z",
  opacity: "0.2"
}, null, -1), zZi = /* @__PURE__ */ e("path", {
  d: "M224,140v24a36,36,0,0,1-72,0V140Z",
  opacity: "0.2"
}, null, -1), ZZi = ["stroke"], CZi = ["stroke"], bZi = ["stroke"], LZi = ["stroke"], BZi = ["stroke"], PZi = { key: 2 }, WZi = /* @__PURE__ */ e("path", { d: "M200,40a8,8,0,0,0,0,16,16,16,0,0,1,16,16v60H40V72A16,16,0,0,1,56,56a8,8,0,0,0,0-16A32.1,32.1,0,0,0,24,72v92a44,44,0,0,0,88,0V148h32v16a44,44,0,0,0,88,0V72A32.1,32.1,0,0,0,200,40ZM85,177a7.7,7.7,0,0,1-5.6,2.4,8,8,0,0,1-5.7-2.4L58.3,161.7a8.1,8.1,0,0,1,11.4-11.4L85,165.7A7.9,7.9,0,0,1,85,177Zm120,0a7.7,7.7,0,0,1-5.6,2.4,8,8,0,0,1-5.7-2.4l-15.4-15.3a8.1,8.1,0,0,1,11.4-11.4L205,165.7A7.9,7.9,0,0,1,205,177Z" }, null, -1), NZi = [
  WZi
], FZi = { key: 3 }, TZi = ["stroke"], DZi = ["stroke"], RZi = ["stroke"], UZi = ["stroke"], qZi = ["stroke"], GZi = { key: 4 }, EZi = ["stroke"], OZi = ["stroke"], IZi = ["stroke"], KZi = ["stroke"], XZi = ["stroke"], JZi = { key: 5 }, QZi = ["stroke"], YZi = ["stroke"], oCi = ["stroke"], eCi = ["stroke"], tCi = ["stroke"], nCi = {
  name: "PhSunglasses"
}, ltl = /* @__PURE__ */ $({
  ...nCi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", jZi, [
        e("path", {
          d: "M104,140v24a36,36,0,0,1-72,0V140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mZi),
        e("path", {
          d: "M224,140v24a36,36,0,0,1-72,0V140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MZi),
        e("path", {
          d: "M200,48a23.9,23.9,0,0,1,24,24v68H32V72A23.9,23.9,0,0,1,56,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vZi),
        e("line", {
          x1: "44",
          y1: "140",
          x2: "93.5",
          y2: "189.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SZi),
        e("line", {
          x1: "164",
          y1: "140",
          x2: "213.5",
          y2: "189.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HZi)
      ])) : o(i) === "duotone" ? (s(), r("g", AZi, [
        VZi,
        zZi,
        e("path", {
          d: "M104,140v24a36,36,0,0,1-72,0V140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZZi),
        e("path", {
          d: "M224,140v24a36,36,0,0,1-72,0V140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CZi),
        e("path", {
          d: "M200,48a23.9,23.9,0,0,1,24,24v68H32V72A23.9,23.9,0,0,1,56,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bZi),
        e("line", {
          x1: "168",
          y1: "140",
          x2: "215.4",
          y2: "187.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LZi),
        e("line", {
          x1: "48",
          y1: "140",
          x2: "95.4",
          y2: "187.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BZi)
      ])) : o(i) === "fill" ? (s(), r("g", PZi, NZi)) : o(i) === "light" ? (s(), r("g", FZi, [
        e("path", {
          d: "M104,140v24a36,36,0,0,1-72,0V140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TZi),
        e("path", {
          d: "M224,140v24a36,36,0,0,1-72,0V140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DZi),
        e("path", {
          d: "M200,48a23.9,23.9,0,0,1,24,24v68H32V72A23.9,23.9,0,0,1,56,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RZi),
        e("line", {
          x1: "168",
          y1: "140",
          x2: "215.4",
          y2: "187.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UZi),
        e("line", {
          x1: "48",
          y1: "140",
          x2: "95.4",
          y2: "187.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qZi)
      ])) : o(i) === "thin" ? (s(), r("g", GZi, [
        e("path", {
          d: "M104,140v24a36,36,0,0,1-72,0V140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, EZi),
        e("path", {
          d: "M224,140v24a36,36,0,0,1-72,0V140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OZi),
        e("path", {
          d: "M200,48a23.9,23.9,0,0,1,24,24v68H32V72A23.9,23.9,0,0,1,56,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, IZi),
        e("line", {
          x1: "168",
          y1: "140",
          x2: "215.4",
          y2: "187.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KZi),
        e("line", {
          x1: "48",
          y1: "140",
          x2: "95.4",
          y2: "187.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XZi)
      ])) : o(i) === "regular" ? (s(), r("g", JZi, [
        e("path", {
          d: "M104,140v24a36,36,0,0,1-72,0V140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QZi),
        e("path", {
          d: "M224,140v24a36,36,0,0,1-72,0V140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YZi),
        e("path", {
          d: "M200,48a23.9,23.9,0,0,1,24,24v68H32V72A23.9,23.9,0,0,1,56,48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oCi),
        e("line", {
          x1: "168",
          y1: "140",
          x2: "215.4",
          y2: "187.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eCi),
        e("line", {
          x1: "48",
          y1: "140",
          x2: "95.4",
          y2: "187.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tCi)
      ])) : g("", !0)
    ], 16, xZi));
  }
}), sCi = ["width", "height", "fill", "transform"], rCi = { key: 0 }, iCi = ["stroke"], lCi = ["stroke"], dCi = ["stroke"], kCi = ["stroke"], cCi = { key: 1 }, hCi = /* @__PURE__ */ e("path", {
  d: "M208,40H96a8,8,0,0,0-8,8V96H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8V160h40a8,8,0,0,0,8-8V48A8,8,0,0,0,208,40Z",
  opacity: "0.2"
}, null, -1), uCi = ["stroke"], aCi = ["stroke"], _Ci = ["stroke"], pCi = ["stroke"], yCi = { key: 2 }, $Ci = /* @__PURE__ */ e("path", { d: "M224,48V152a16,16,0,0,1-16,16H112v16a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3l-24-24a8.1,8.1,0,0,1,0-11.4l24-24a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,112,136v16h96V48H96v8a8,8,0,0,1-16,0V48A16,16,0,0,1,96,32H208A16,16,0,0,1,224,48ZM168,192a8,8,0,0,0-8,8v8H48V104h96v16a8.1,8.1,0,0,0,4.9,7.4,8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l24-24a8.1,8.1,0,0,0,0-11.4l-24-24a8.2,8.2,0,0,0-8.8-1.7A8,8,0,0,0,144,72V88H48a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-8A8,8,0,0,0,168,192Z" }, null, -1), wCi = [
  $Ci
], fCi = { key: 3 }, gCi = ["stroke"], xCi = ["stroke"], jCi = ["stroke"], mCi = ["stroke"], MCi = { key: 4 }, vCi = ["stroke"], SCi = ["stroke"], HCi = ["stroke"], ACi = ["stroke"], VCi = { key: 5 }, zCi = ["stroke"], ZCi = ["stroke"], CCi = ["stroke"], bCi = ["stroke"], LCi = {
  name: "PhSwap"
}, dtl = /* @__PURE__ */ $({
  ...LCi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", rCi, [
        e("path", {
          d: "M80,160H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iCi),
        e("polyline", {
          points: "104 136 80 160 104 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lCi),
        e("path", {
          d: "M176,96H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dCi),
        e("polyline", {
          points: "152 120 176 96 152 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kCi)
      ])) : o(i) === "duotone" ? (s(), r("g", cCi, [
        hCi,
        e("path", {
          d: "M80,160H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uCi),
        e("polyline", {
          points: "104 136 80 160 104 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aCi),
        e("path", {
          d: "M176,96H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Ci),
        e("polyline", {
          points: "152 120 176 96 152 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pCi)
      ])) : o(i) === "fill" ? (s(), r("g", yCi, wCi)) : o(i) === "light" ? (s(), r("g", fCi, [
        e("path", {
          d: "M80,160H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gCi),
        e("polyline", {
          points: "104 136 80 160 104 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xCi),
        e("path", {
          d: "M176,96H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jCi),
        e("polyline", {
          points: "152 120 176 96 152 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mCi)
      ])) : o(i) === "thin" ? (s(), r("g", MCi, [
        e("path", {
          d: "M80,160H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vCi),
        e("polyline", {
          points: "104 136 80 160 104 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SCi),
        e("path", {
          d: "M176,96H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HCi),
        e("polyline", {
          points: "152 120 176 96 152 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ACi)
      ])) : o(i) === "regular" ? (s(), r("g", VCi, [
        e("path", {
          d: "M80,160H208a8,8,0,0,0,8-8V48a8,8,0,0,0-8-8H96a8,8,0,0,0-8,8v8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zCi),
        e("polyline", {
          points: "104 136 80 160 104 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZCi),
        e("path", {
          d: "M176,96H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H160a8,8,0,0,0,8-8v-8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CCi),
        e("polyline", {
          points: "152 120 176 96 152 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bCi)
      ])) : g("", !0)
    ], 16, sCi));
  }
}), BCi = ["width", "height", "fill", "transform"], PCi = { key: 0 }, WCi = ["stroke"], NCi = ["stroke"], FCi = ["stroke"], TCi = ["stroke"], DCi = { key: 1 }, RCi = /* @__PURE__ */ e("path", {
  d: "M36.7,173,60.9,35.9a7.9,7.9,0,0,1,9.2-6.5l55.2,9.7a8.1,8.1,0,0,1,6.5,9.3L107.5,186.3a36.1,36.1,0,0,1-41.1,29.3C46.5,212.4,33.2,192.9,36.7,173Z",
  opacity: "0.2"
}, null, -1), UCi = ["stroke"], qCi = ["stroke"], GCi = ["stroke"], ECi = /* @__PURE__ */ e("circle", {
  cx: "72",
  cy: "180",
  r: "12"
}, null, -1), OCi = { key: 2 }, ICi = /* @__PURE__ */ e("path", { d: "M228.2,153,209,100.3a16,16,0,0,0-20.5-9.5l-59.9,21.8,11-62.8a16,16,0,0,0-2.6-12,16.2,16.2,0,0,0-10.3-6.6L71.5,21.5A16.1,16.1,0,0,0,53,34.5L28.8,171.7a45,45,0,0,0,7.7,33.9,43.4,43.4,0,0,0,28.7,17.9,51.6,51.6,0,0,0,6.7.5H212a16,16,0,0,0,16-16V164.3A15.7,15.7,0,0,0,228.2,153ZM72,192a12,12,0,1,1,12-12A12,12,0,0,1,72,192Zm140,16H123.7L212,175.9Zm-98.5-13.3a41,41,0,0,0,1.8-7.1l10.1-56.8,68.6-25,19.1,52.6Z" }, null, -1), KCi = [
  ICi
], XCi = { key: 3 }, JCi = ["stroke"], QCi = ["stroke"], YCi = ["stroke"], obi = /* @__PURE__ */ e("circle", {
  cx: "72",
  cy: "180",
  r: "10"
}, null, -1), ebi = { key: 4 }, tbi = ["stroke"], nbi = ["stroke"], sbi = ["stroke"], rbi = /* @__PURE__ */ e("circle", {
  cx: "72",
  cy: "180",
  r: "8"
}, null, -1), ibi = { key: 5 }, lbi = ["stroke"], dbi = ["stroke"], kbi = ["stroke"], cbi = /* @__PURE__ */ e("circle", {
  cx: "72",
  cy: "180",
  r: "12"
}, null, -1), hbi = {
  name: "PhSwatches"
}, ktl = /* @__PURE__ */ $({
  ...hbi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", PCi, [
        e("path", {
          d: "M36.7,173,60.9,35.9a7.9,7.9,0,0,1,9.2-6.5l55.2,9.7a8.1,8.1,0,0,1,6.5,9.3L107.5,186.3a36.1,36.1,0,0,1-41.1,29.3C46.5,212.4,33.2,192.9,36.7,173Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WCi),
        e("path", {
          d: "M118.3,124.8l72.9-26.5a8,8,0,0,1,10.3,4.8l19.2,52.6a8,8,0,0,1-4.8,10.2L84.3,213.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NCi),
        e("path", {
          d: "M220,162.5V208a8,8,0,0,1-8,8H72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FCi),
        e("line", {
          x1: "72",
          y1: "180",
          x2: "74.1",
          y2: "168.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TCi)
      ])) : o(i) === "duotone" ? (s(), r("g", DCi, [
        RCi,
        e("path", {
          d: "M36.7,173,60.9,35.9a7.9,7.9,0,0,1,9.2-6.5l55.2,9.7a8.1,8.1,0,0,1,6.5,9.3L107.5,186.3a36.1,36.1,0,0,1-41.1,29.3C46.5,212.4,33.2,192.9,36.7,173Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UCi),
        e("path", {
          d: "M118.3,124.8l72.9-26.5a8,8,0,0,1,10.3,4.8l19.2,52.6a8,8,0,0,1-4.8,10.2L84.3,213.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qCi),
        e("path", {
          d: "M220,162.5V208a8,8,0,0,1-8,8H72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GCi),
        ECi
      ])) : o(i) === "fill" ? (s(), r("g", OCi, KCi)) : o(i) === "light" ? (s(), r("g", XCi, [
        e("path", {
          d: "M36.7,173,60.9,35.9a7.9,7.9,0,0,1,9.2-6.5l55.2,9.7a8.1,8.1,0,0,1,6.5,9.3L107.5,186.3a36.1,36.1,0,0,1-41.1,29.3C46.5,212.4,33.2,192.9,36.7,173Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JCi),
        e("path", {
          d: "M118.3,124.8l72.9-26.5a8,8,0,0,1,10.3,4.8l19.2,52.6a8,8,0,0,1-4.8,10.2L84.3,213.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QCi),
        e("path", {
          d: "M220,162.5V208a8,8,0,0,1-8,8H72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YCi),
        obi
      ])) : o(i) === "thin" ? (s(), r("g", ebi, [
        e("path", {
          d: "M36.7,173,60.9,35.9a7.9,7.9,0,0,1,9.2-6.5l55.2,9.7a8.1,8.1,0,0,1,6.5,9.3L107.5,186.3a36.1,36.1,0,0,1-41.1,29.3C46.5,212.4,33.2,192.9,36.7,173Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tbi),
        e("path", {
          d: "M118.3,124.8l72.9-26.5a8,8,0,0,1,10.3,4.8l19.2,52.6a8,8,0,0,1-4.8,10.2L84.3,213.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nbi),
        e("path", {
          d: "M220,162.5V208a8,8,0,0,1-8,8H72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sbi),
        rbi
      ])) : o(i) === "regular" ? (s(), r("g", ibi, [
        e("path", {
          d: "M36.7,173,60.9,35.9a7.9,7.9,0,0,1,9.2-6.5l55.2,9.7a8.1,8.1,0,0,1,6.5,9.3L107.5,186.3a36.1,36.1,0,0,1-41.1,29.3C46.5,212.4,33.2,192.9,36.7,173Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lbi),
        e("path", {
          d: "M118.3,124.8l72.9-26.5a8,8,0,0,1,10.3,4.8l19.2,52.6a8,8,0,0,1-4.8,10.2L84.3,213.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dbi),
        e("path", {
          d: "M220,162.5V208a8,8,0,0,1-8,8H72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kbi),
        cbi
      ])) : g("", !0)
    ], 16, BCi));
  }
}), ubi = ["width", "height", "fill", "transform"], abi = { key: 0 }, _bi = ["stroke"], pbi = ["stroke"], ybi = ["stroke"], $bi = { key: 1 }, wbi = /* @__PURE__ */ e("path", {
  d: "M82.1,197.5,52.2,227.4a8,8,0,0,1-11.3,0L28.6,215.1a8,8,0,0,1,0-11.3l29.9-29.9a8,8,0,0,0,0-11.4L37.7,141.7a8,8,0,0,1,0-11.4l12.6-12.6a8,8,0,0,1,11.4,0l76.6,76.6a8,8,0,0,1,0,11.4l-12.6,12.6a8,8,0,0,1-11.4,0L93.5,197.5A8,8,0,0,0,82.1,197.5Z",
  opacity: "0.2"
}, null, -1), fbi = ["stroke"], gbi = ["stroke"], xbi = ["stroke"], jbi = { key: 2 }, mbi = /* @__PURE__ */ e("path", { d: "M221.7,34.3A8.1,8.1,0,0,0,216,32h0l-63.8.2a8.1,8.1,0,0,0-6.2,2.9L75.6,120.3,67.3,112a16.1,16.1,0,0,0-22.6,0L32,124.7a15.9,15.9,0,0,0,0,22.6l20.9,20.9-30,29.9a16.2,16.2,0,0,0,0,22.7l12.3,12.3a16.3,16.3,0,0,0,22.7,0l29.9-30L108.7,224a16.1,16.1,0,0,0,22.6,0L144,211.3a15.9,15.9,0,0,0,0-22.6l-8.3-8.3L220.9,110a8.1,8.1,0,0,0,2.9-6.2L224,40A8.1,8.1,0,0,0,221.7,34.3ZM207.8,100l-83.5,69-13-13,54.4-54.3a8.1,8.1,0,0,0-11.4-11.4L100,144.7l-13-13,69-83.5,52-.2Z" }, null, -1), Mbi = [
  mbi
], vbi = { key: 3 }, Sbi = ["stroke"], Hbi = ["stroke"], Abi = ["stroke"], Vbi = { key: 4 }, zbi = ["stroke"], Zbi = ["stroke"], Cbi = ["stroke"], bbi = { key: 5 }, Lbi = ["stroke"], Bbi = ["stroke"], Pbi = ["stroke"], Wbi = {
  name: "PhSword"
}, ctl = /* @__PURE__ */ $({
  ...Wbi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", abi, [
        e("polyline", {
          points: "72.2 128.2 152.2 40.2 216 40 215.8 103.8 127.8 183.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _bi),
        e("line", {
          x1: "100",
          y1: "156",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pbi),
        e("path", {
          d: "M82.1,205.5,60.2,227.4a8,8,0,0,1-11.3,0L28.6,207.1a8,8,0,0,1,0-11.3l21.9-21.9a8,8,0,0,0,0-11.4L33.7,145.7a8,8,0,0,1,0-11.4l16.6-16.6a8,8,0,0,1,11.4,0l76.6,76.6a8,8,0,0,1,0,11.4l-16.6,16.6a8,8,0,0,1-11.4,0L93.5,205.5A8,8,0,0,0,82.1,205.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ybi)
      ])) : o(i) === "duotone" ? (s(), r("g", $bi, [
        wbi,
        e("polyline", {
          points: "76.2 132.2 152.2 40.2 216 40 215.8 103.8 123.8 179.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fbi),
        e("line", {
          x1: "100",
          y1: "156",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gbi),
        e("path", {
          d: "M82.1,197.5,52.2,227.4a8,8,0,0,1-11.3,0L28.6,215.1a8,8,0,0,1,0-11.3l29.9-29.9a8,8,0,0,0,0-11.4L37.7,141.7a8,8,0,0,1,0-11.4l12.6-12.6a8,8,0,0,1,11.4,0l76.6,76.6a8,8,0,0,1,0,11.4l-12.6,12.6a8,8,0,0,1-11.4,0L93.5,197.5A8,8,0,0,0,82.1,197.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xbi)
      ])) : o(i) === "fill" ? (s(), r("g", jbi, Mbi)) : o(i) === "light" ? (s(), r("g", vbi, [
        e("polyline", {
          points: "76.2 132.2 152.2 40.2 216 40 215.8 103.8 123.8 179.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Sbi),
        e("line", {
          x1: "100",
          y1: "156",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hbi),
        e("path", {
          d: "M82.1,197.5,52.2,227.4a8,8,0,0,1-11.3,0L28.6,215.1a8,8,0,0,1,0-11.3l29.9-29.9a8,8,0,0,0,0-11.4L37.7,141.7a8,8,0,0,1,0-11.4l12.6-12.6a8,8,0,0,1,11.4,0l76.6,76.6a8,8,0,0,1,0,11.4l-12.6,12.6a8,8,0,0,1-11.4,0L93.5,197.5A8,8,0,0,0,82.1,197.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Abi)
      ])) : o(i) === "thin" ? (s(), r("g", Vbi, [
        e("polyline", {
          points: "76.2 132.2 152.2 40.2 216 40 215.8 103.8 123.8 179.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zbi),
        e("line", {
          x1: "100",
          y1: "156",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zbi),
        e("path", {
          d: "M82.1,197.5,52.2,227.4a8,8,0,0,1-11.3,0L28.6,215.1a8,8,0,0,1,0-11.3l29.9-29.9a8,8,0,0,0,0-11.4L37.7,141.7a8,8,0,0,1,0-11.4l12.6-12.6a8,8,0,0,1,11.4,0l76.6,76.6a8,8,0,0,1,0,11.4l-12.6,12.6a8,8,0,0,1-11.4,0L93.5,197.5A8,8,0,0,0,82.1,197.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cbi)
      ])) : o(i) === "regular" ? (s(), r("g", bbi, [
        e("polyline", {
          points: "76.2 132.2 152.2 40.2 216 40 215.8 103.8 123.8 179.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lbi),
        e("line", {
          x1: "100",
          y1: "156",
          x2: "160",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bbi),
        e("path", {
          d: "M82.1,197.5,52.2,227.4a8,8,0,0,1-11.3,0L28.6,215.1a8,8,0,0,1,0-11.3l29.9-29.9a8,8,0,0,0,0-11.4L37.7,141.7a8,8,0,0,1,0-11.4l12.6-12.6a8,8,0,0,1,11.4,0l76.6,76.6a8,8,0,0,1,0,11.4l-12.6,12.6a8,8,0,0,1-11.4,0L93.5,197.5A8,8,0,0,0,82.1,197.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pbi)
      ])) : g("", !0)
    ], 16, ubi));
  }
}), Nbi = ["width", "height", "fill", "transform"], Fbi = { key: 0 }, Tbi = ["stroke"], Dbi = ["stroke"], Rbi = ["stroke"], Ubi = ["stroke"], qbi = ["stroke"], Gbi = ["stroke"], Ebi = ["stroke"], Obi = { key: 1 }, Ibi = /* @__PURE__ */ e("path", {
  d: "M140,60,50.3,149.7a7.9,7.9,0,0,0-2.3,5.6V208h52.7a7.9,7.9,0,0,0,5.6-2.3L196,116Z",
  opacity: "0.2"
}, null, -1), Kbi = ["stroke"], Xbi = ["stroke"], Jbi = ["stroke"], Qbi = ["stroke"], Ybi = ["stroke"], oLi = ["stroke"], eLi = ["stroke"], tLi = { key: 2 }, nLi = /* @__PURE__ */ e("path", { d: "M237.7,77.7a8.2,8.2,0,0,1-11.4,0L208,59.3,179.3,88l34.4,34.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0l-6.3-6.4-84,84a16.1,16.1,0,0,1-11.3,4.7H51.3L29.7,237.7a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L40,204.7V155.3A16.1,16.1,0,0,1,44.7,144l11.2-11.2a4,4,0,0,1,5.6,0l28.8,28.9a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4L72.8,121.5a4,4,0,0,1,0-5.6L91.9,96.8a4,4,0,0,1,5.6,0l28.8,28.9a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4L108.8,85.5a4,4,0,0,1,0-5.6L128.7,60l-6.1-6.1a8.3,8.3,0,0,1-.4-11.4,8.1,8.1,0,0,1,11.5-.2L168,76.7,196.7,48,178.6,29.9a8.3,8.3,0,0,1-.4-11.4,8.1,8.1,0,0,1,11.5-.2l48,48A8.1,8.1,0,0,1,237.7,77.7Z" }, null, -1), sLi = [
  nLi
], rLi = { key: 3 }, iLi = ["stroke"], lLi = ["stroke"], dLi = ["stroke"], kLi = ["stroke"], cLi = ["stroke"], hLi = ["stroke"], uLi = ["stroke"], aLi = { key: 4 }, _Li = ["stroke"], pLi = ["stroke"], yLi = ["stroke"], $Li = ["stroke"], wLi = ["stroke"], fLi = ["stroke"], gLi = ["stroke"], xLi = { key: 5 }, jLi = ["stroke"], mLi = ["stroke"], MLi = ["stroke"], vLi = ["stroke"], SLi = ["stroke"], HLi = ["stroke"], ALi = ["stroke"], VLi = {
  name: "PhSyringe"
}, htl = /* @__PURE__ */ $({
  ...VLi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Fbi, [
        e("line", {
          x1: "184",
          y1: "24",
          x2: "232",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Tbi),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "208",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Dbi),
        e("path", {
          d: "M140,60,50.3,149.7a7.9,7.9,0,0,0-2.3,5.6V208h52.7a7.9,7.9,0,0,0,5.6-2.3L196,116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Rbi),
        e("line", {
          x1: "102",
          y1: "98",
          x2: "128",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ubi),
        e("line", {
          x1: "74",
          y1: "126",
          x2: "100",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qbi),
        e("line", {
          x1: "168",
          y1: "88",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gbi),
        e("line", {
          x1: "48",
          y1: "208",
          x2: "24",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ebi)
      ])) : o(i) === "duotone" ? (s(), r("g", Obi, [
        Ibi,
        e("line", {
          x1: "184",
          y1: "24",
          x2: "232",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kbi),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "208",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xbi),
        e("path", {
          d: "M140,60,50.3,149.7a7.9,7.9,0,0,0-2.3,5.6V208h52.7a7.9,7.9,0,0,0,5.6-2.3L196,116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jbi),
        e("line", {
          x1: "102",
          y1: "98",
          x2: "128",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qbi),
        e("line", {
          x1: "74",
          y1: "126",
          x2: "100",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ybi),
        e("line", {
          x1: "168",
          y1: "88",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oLi),
        e("line", {
          x1: "48",
          y1: "208",
          x2: "24",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eLi)
      ])) : o(i) === "fill" ? (s(), r("g", tLi, sLi)) : o(i) === "light" ? (s(), r("g", rLi, [
        e("line", {
          x1: "184",
          y1: "24",
          x2: "232",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iLi),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "208",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lLi),
        e("path", {
          d: "M140,60,50.3,149.7a7.9,7.9,0,0,0-2.3,5.6V208h52.7a7.9,7.9,0,0,0,5.6-2.3L196,116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dLi),
        e("line", {
          x1: "102",
          y1: "98",
          x2: "128",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kLi),
        e("line", {
          x1: "74",
          y1: "126",
          x2: "100",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cLi),
        e("line", {
          x1: "168",
          y1: "88",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hLi),
        e("line", {
          x1: "48",
          y1: "208",
          x2: "24",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uLi)
      ])) : o(i) === "thin" ? (s(), r("g", aLi, [
        e("line", {
          x1: "184",
          y1: "24",
          x2: "232",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _Li),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "208",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pLi),
        e("path", {
          d: "M140,60,50.3,149.7a7.9,7.9,0,0,0-2.3,5.6V208h52.7a7.9,7.9,0,0,0,5.6-2.3L196,116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yLi),
        e("line", {
          x1: "102",
          y1: "98",
          x2: "128",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $Li),
        e("line", {
          x1: "74",
          y1: "126",
          x2: "100",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wLi),
        e("line", {
          x1: "168",
          y1: "88",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fLi),
        e("line", {
          x1: "48",
          y1: "208",
          x2: "24",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gLi)
      ])) : o(i) === "regular" ? (s(), r("g", xLi, [
        e("line", {
          x1: "184",
          y1: "24",
          x2: "232",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jLi),
        e("line", {
          x1: "128",
          y1: "48",
          x2: "208",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mLi),
        e("path", {
          d: "M140,60,50.3,149.7a7.9,7.9,0,0,0-2.3,5.6V208h52.7a7.9,7.9,0,0,0,5.6-2.3L196,116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MLi),
        e("line", {
          x1: "102",
          y1: "98",
          x2: "128",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vLi),
        e("line", {
          x1: "74",
          y1: "126",
          x2: "100",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SLi),
        e("line", {
          x1: "168",
          y1: "88",
          x2: "208",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HLi),
        e("line", {
          x1: "48",
          y1: "208",
          x2: "24",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ALi)
      ])) : g("", !0)
    ], 16, Nbi));
  }
}), zLi = ["width", "height", "fill", "transform"], ZLi = { key: 0 }, CLi = ["stroke"], bLi = ["stroke"], LLi = ["stroke"], BLi = { key: 1 }, PLi = ["stroke"], WLi = ["stroke"], NLi = /* @__PURE__ */ e("path", {
  d: "M192,120h27.1a7.9,7.9,0,0,0,7.1-4.4l18.4-36.8a8.1,8.1,0,0,0-3.2-10.6L192,40Z",
  opacity: "0.2"
}, null, -1), FLi = /* @__PURE__ */ e("path", {
  d: "M64,120H36.9a7.9,7.9,0,0,1-7.1-4.4L11.4,78.8a8.1,8.1,0,0,1,3.2-10.6L64,40Z",
  opacity: "0.2"
}, null, -1), TLi = ["stroke"], DLi = { key: 2 }, RLi = /* @__PURE__ */ e("path", { d: "M245.4,61.3,196,33.1h0a8,8,0,0,0-4-1.1H160a8,8,0,0,0-8,8,24,24,0,0,1-48,0,8,8,0,0,0-8-8H64a8,8,0,0,0-4,1.1h0L10.6,61.3a15.9,15.9,0,0,0-6.4,21l18.4,36.9A16,16,0,0,0,36.9,128H56v80a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V128h19.1a16,16,0,0,0,14.3-8.8l18.4-36.9A15.9,15.9,0,0,0,245.4,61.3ZM36.9,112,18.5,75.2,56,53.8V112Zm182.2,0H200V53.8l37.5,21.4Z" }, null, -1), ULi = [
  RLi
], qLi = { key: 3 }, GLi = ["stroke"], ELi = ["stroke"], OLi = ["stroke"], ILi = { key: 4 }, KLi = ["stroke"], XLi = ["stroke"], JLi = ["stroke"], QLi = { key: 5 }, YLi = ["stroke"], oBi = ["stroke"], eBi = ["stroke"], tBi = {
  name: "PhTShirt"
}, utl = /* @__PURE__ */ $({
  ...tBi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ZLi, [
        e("path", {
          d: "M192,120h26.7a8.1,8.1,0,0,0,7.4-4.9l15.3-36.8a8.1,8.1,0,0,0-3.2-9.9L192,40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CLi),
        e("path", {
          d: "M64,120H37.3a8.1,8.1,0,0,1-7.4-4.9L14.6,78.3a8.1,8.1,0,0,1,3.2-9.9L64,40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bLi),
        e("path", {
          d: "M160,40a32,32,0,0,1-64,0H64V208a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LLi)
      ])) : o(i) === "duotone" ? (s(), r("g", BLi, [
        e("path", {
          d: "M192,120h27.1a7.9,7.9,0,0,0,7.1-4.4l18.4-36.8a8.1,8.1,0,0,0-3.2-10.6L192,40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PLi),
        e("path", {
          d: "M64,120H36.9a7.9,7.9,0,0,1-7.1-4.4L11.4,78.8a8.1,8.1,0,0,1,3.2-10.6L64,40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WLi),
        NLi,
        FLi,
        e("path", {
          d: "M160,40a32,32,0,0,1-64,0H64V208a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TLi)
      ])) : o(i) === "fill" ? (s(), r("g", DLi, ULi)) : o(i) === "light" ? (s(), r("g", qLi, [
        e("path", {
          d: "M192,120h27.1a7.9,7.9,0,0,0,7.1-4.4l18.4-36.8a8.1,8.1,0,0,0-3.2-10.6L192,40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GLi),
        e("path", {
          d: "M64,120H36.9a7.9,7.9,0,0,1-7.1-4.4L11.4,78.8a8.1,8.1,0,0,1,3.2-10.6L64,40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ELi),
        e("path", {
          d: "M160,40a32,32,0,0,1-64,0H64V208a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OLi)
      ])) : o(i) === "thin" ? (s(), r("g", ILi, [
        e("path", {
          d: "M192,120h27.1a7.9,7.9,0,0,0,7.1-4.4l18.4-36.8a8.1,8.1,0,0,0-3.2-10.6L192,40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KLi),
        e("path", {
          d: "M64,120H36.9a7.9,7.9,0,0,1-7.1-4.4L11.4,78.8a8.1,8.1,0,0,1,3.2-10.6L64,40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XLi),
        e("path", {
          d: "M160,40a32,32,0,0,1-64,0H64V208a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, JLi)
      ])) : o(i) === "regular" ? (s(), r("g", QLi, [
        e("path", {
          d: "M192,120h27.1a7.9,7.9,0,0,0,7.1-4.4l18.4-36.8a8.1,8.1,0,0,0-3.2-10.6L192,40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YLi),
        e("path", {
          d: "M64,120H36.9a7.9,7.9,0,0,1-7.1-4.4L11.4,78.8a8.1,8.1,0,0,1,3.2-10.6L64,40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oBi),
        e("path", {
          d: "M160,40a32,32,0,0,1-64,0H64V208a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eBi)
      ])) : g("", !0)
    ], 16, zLi));
  }
}), nBi = ["width", "height", "fill", "transform"], sBi = { key: 0 }, rBi = ["stroke"], iBi = ["stroke"], lBi = ["stroke"], dBi = ["stroke"], kBi = { key: 1 }, cBi = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "104",
  width: "56",
  height: "96",
  opacity: "0.2"
}, null, -1), hBi = ["stroke"], uBi = ["stroke"], aBi = ["stroke"], _Bi = ["stroke"], pBi = { key: 2 }, yBi = /* @__PURE__ */ e("path", { d: "M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM40,112H80v32H40Zm56,0H216v32H96ZM40,160H80v32H40Zm176,32H96V160H216v32Z" }, null, -1), $Bi = [
  yBi
], wBi = { key: 3 }, fBi = ["stroke"], gBi = ["stroke"], xBi = ["stroke"], jBi = ["stroke"], mBi = { key: 4 }, MBi = ["stroke"], vBi = ["stroke"], SBi = ["stroke"], HBi = ["stroke"], ABi = { key: 5 }, VBi = ["stroke"], zBi = ["stroke"], ZBi = ["stroke"], CBi = ["stroke"], bBi = {
  name: "PhTable"
}, atl = /* @__PURE__ */ $({
  ...bBi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", sBi, [
        e("path", {
          d: "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rBi),
        e("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iBi),
        e("line", {
          x1: "32",
          y1: "152",
          x2: "224",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lBi),
        e("line", {
          x1: "88",
          y1: "104",
          x2: "88",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dBi)
      ])) : o(i) === "duotone" ? (s(), r("g", kBi, [
        cBi,
        e("path", {
          d: "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hBi),
        e("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uBi),
        e("line", {
          x1: "32",
          y1: "152",
          x2: "224",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aBi),
        e("line", {
          x1: "88",
          y1: "104",
          x2: "88",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Bi)
      ])) : o(i) === "fill" ? (s(), r("g", pBi, $Bi)) : o(i) === "light" ? (s(), r("g", wBi, [
        e("path", {
          d: "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fBi),
        e("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gBi),
        e("line", {
          x1: "32",
          y1: "152",
          x2: "224",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xBi),
        e("line", {
          x1: "88",
          y1: "104",
          x2: "88",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jBi)
      ])) : o(i) === "thin" ? (s(), r("g", mBi, [
        e("path", {
          d: "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MBi),
        e("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vBi),
        e("line", {
          x1: "32",
          y1: "152",
          x2: "224",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SBi),
        e("line", {
          x1: "88",
          y1: "104",
          x2: "88",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HBi)
      ])) : o(i) === "regular" ? (s(), r("g", ABi, [
        e("path", {
          d: "M32,56H224a0,0,0,0,1,0,0V192a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V56A0,0,0,0,1,32,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VBi),
        e("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zBi),
        e("line", {
          x1: "32",
          y1: "152",
          x2: "224",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZBi),
        e("line", {
          x1: "88",
          y1: "104",
          x2: "88",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CBi)
      ])) : g("", !0)
    ], 16, nBi));
  }
}), LBi = ["width", "height", "fill", "transform"], BBi = { key: 0 }, PBi = ["stroke"], WBi = ["stroke"], NBi = ["stroke"], FBi = ["stroke"], TBi = { key: 1 }, DBi = /* @__PURE__ */ e("path", {
  d: "M8,168,30.3,93.7A8,8,0,0,1,38,88h84a8,8,0,0,1,7.7,5.7L152,168Z",
  opacity: "0.2"
}, null, -1), RBi = ["stroke"], UBi = ["stroke"], qBi = ["stroke"], GBi = ["stroke"], EBi = { key: 2 }, OBi = /* @__PURE__ */ e("path", { d: "M256,168a8,8,0,0,1-8,8H8a8,8,0,0,1-8-8,8.5,8.5,0,0,1,.3-2.3H.4L22.6,91.4A16,16,0,0,1,38,80h84a16,16,0,0,1,15.4,11.4L158,160h31.2L170,96H160a8,8,0,0,1,0-16h10a16,16,0,0,1,15.4,11.4L206,160h31.2L218,96H208a8,8,0,0,1,0-16h10a16,16,0,0,1,15.4,11.4l22.2,74.2h.1A8.5,8.5,0,0,1,256,168Z" }, null, -1), IBi = [
  OBi
], KBi = { key: 3 }, XBi = ["stroke"], JBi = ["stroke"], QBi = ["stroke"], YBi = ["stroke"], oPi = { key: 4 }, ePi = ["stroke"], tPi = ["stroke"], nPi = ["stroke"], sPi = ["stroke"], rPi = { key: 5 }, iPi = ["stroke"], lPi = ["stroke"], dPi = ["stroke"], kPi = ["stroke"], cPi = {
  name: "PhTabs"
}, _tl = /* @__PURE__ */ $({
  ...cPi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", BBi, [
        e("path", {
          d: "M12,168,34.3,93.7A8,8,0,0,1,42,88h60a8,8,0,0,1,7.7,5.7L132,168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PBi),
        e("path", {
          d: "M148,88h10a8,8,0,0,1,7.7,5.7L188,168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WBi),
        e("path", {
          d: "M204,88h10a8,8,0,0,1,7.7,5.7L244,168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NBi),
        e("line", {
          x1: "12",
          y1: "168",
          x2: "244",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FBi)
      ])) : o(i) === "duotone" ? (s(), r("g", TBi, [
        DBi,
        e("path", {
          d: "M8,168,30.3,93.7A8,8,0,0,1,38,88h84a8,8,0,0,1,7.7,5.7L152,168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RBi),
        e("path", {
          d: "M160,88h10a8,8,0,0,1,7.7,5.7L200,168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UBi),
        e("path", {
          d: "M208,88h10a8,8,0,0,1,7.7,5.7L248,168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qBi),
        e("line", {
          x1: "8",
          y1: "168",
          x2: "248",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GBi)
      ])) : o(i) === "fill" ? (s(), r("g", EBi, IBi)) : o(i) === "light" ? (s(), r("g", KBi, [
        e("path", {
          d: "M8,168,30.3,93.7A8,8,0,0,1,38,88h84a8,8,0,0,1,7.7,5.7L152,168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XBi),
        e("path", {
          d: "M160,88h10a8,8,0,0,1,7.7,5.7L200,168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JBi),
        e("path", {
          d: "M208,88h10a8,8,0,0,1,7.7,5.7L248,168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QBi),
        e("line", {
          x1: "8",
          y1: "168",
          x2: "248",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YBi)
      ])) : o(i) === "thin" ? (s(), r("g", oPi, [
        e("path", {
          d: "M8,168,30.3,93.7A8,8,0,0,1,38,88h84a8,8,0,0,1,7.7,5.7L152,168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ePi),
        e("path", {
          d: "M160,88h10a8,8,0,0,1,7.7,5.7L200,168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tPi),
        e("path", {
          d: "M208,88h10a8,8,0,0,1,7.7,5.7L248,168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nPi),
        e("line", {
          x1: "8",
          y1: "168",
          x2: "248",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sPi)
      ])) : o(i) === "regular" ? (s(), r("g", rPi, [
        e("path", {
          d: "M8,168,30.3,93.7A8,8,0,0,1,38,88h84a8,8,0,0,1,7.7,5.7L152,168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iPi),
        e("path", {
          d: "M160,88h10a8,8,0,0,1,7.7,5.7L200,168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lPi),
        e("path", {
          d: "M208,88h10a8,8,0,0,1,7.7,5.7L248,168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dPi),
        e("line", {
          x1: "8",
          y1: "168",
          x2: "248",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kPi)
      ])) : g("", !0)
    ], 16, LBi));
  }
}), hPi = ["width", "height", "fill", "transform"], uPi = { key: 0 }, aPi = ["stroke"], _Pi = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "84",
  r: "16"
}, null, -1), pPi = { key: 1 }, yPi = /* @__PURE__ */ e("path", {
  d: "M122.7,25.9,42,42,25.9,122.7a8,8,0,0,0,2.2,7.2L132.5,234.3a7.9,7.9,0,0,0,11.3,0l90.5-90.5a7.9,7.9,0,0,0,0-11.3L129.9,28.1A8,8,0,0,0,122.7,25.9Z",
  opacity: "0.2"
}, null, -1), $Pi = ["stroke"], wPi = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "84",
  r: "12"
}, null, -1), fPi = { key: 2 }, gPi = /* @__PURE__ */ e("path", { d: "M240,126.9,135.5,22.4A15.9,15.9,0,0,0,121.1,18L40.4,34.2a7.9,7.9,0,0,0-6.2,6.2L18,121.1a15.9,15.9,0,0,0,4.4,14.4L126.9,240a15.9,15.9,0,0,0,22.6,0L240,149.5a15.9,15.9,0,0,0,0-22.6ZM84,96A12,12,0,1,1,96,84,12,12,0,0,1,84,96Z" }, null, -1), xPi = [
  gPi
], jPi = { key: 3 }, mPi = ["stroke"], MPi = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "84",
  r: "10"
}, null, -1), vPi = { key: 4 }, SPi = ["stroke"], HPi = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "84",
  r: "8"
}, null, -1), APi = { key: 5 }, VPi = ["stroke"], zPi = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "84",
  r: "12"
}, null, -1), ZPi = {
  name: "PhTag"
}, ptl = /* @__PURE__ */ $({
  ...ZPi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", uPi, [
        e("path", {
          d: "M122.7,25.9,42,42,25.9,122.7a8,8,0,0,0,2.2,7.2L132.5,234.3a7.9,7.9,0,0,0,11.3,0l90.5-90.5a7.9,7.9,0,0,0,0-11.3L129.9,28.1A8,8,0,0,0,122.7,25.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aPi),
        _Pi
      ])) : o(i) === "duotone" ? (s(), r("g", pPi, [
        yPi,
        e("path", {
          d: "M122.7,25.9,42,42,25.9,122.7a8,8,0,0,0,2.2,7.2L132.5,234.3a7.9,7.9,0,0,0,11.3,0l90.5-90.5a7.9,7.9,0,0,0,0-11.3L129.9,28.1A8,8,0,0,0,122.7,25.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Pi),
        wPi
      ])) : o(i) === "fill" ? (s(), r("g", fPi, xPi)) : o(i) === "light" ? (s(), r("g", jPi, [
        e("path", {
          d: "M122.7,25.9,42,42,25.9,122.7a8,8,0,0,0,2.2,7.2L132.5,234.3a7.9,7.9,0,0,0,11.3,0l90.5-90.5a7.9,7.9,0,0,0,0-11.3L129.9,28.1A8,8,0,0,0,122.7,25.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mPi),
        MPi
      ])) : o(i) === "thin" ? (s(), r("g", vPi, [
        e("path", {
          d: "M122.7,25.9,42,42,25.9,122.7a8,8,0,0,0,2.2,7.2L132.5,234.3a7.9,7.9,0,0,0,11.3,0l90.5-90.5a7.9,7.9,0,0,0,0-11.3L129.9,28.1A8,8,0,0,0,122.7,25.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SPi),
        HPi
      ])) : o(i) === "regular" ? (s(), r("g", APi, [
        e("path", {
          d: "M122.7,25.9,42,42,25.9,122.7a8,8,0,0,0,2.2,7.2L132.5,234.3a7.9,7.9,0,0,0,11.3,0l90.5-90.5a7.9,7.9,0,0,0,0-11.3L129.9,28.1A8,8,0,0,0,122.7,25.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VPi),
        zPi
      ])) : g("", !0)
    ], 16, hPi));
  }
}), CPi = ["width", "height", "fill", "transform"], bPi = { key: 0 }, LPi = ["stroke"], BPi = { key: 1 }, PPi = /* @__PURE__ */ e("path", {
  d: "M186.4,196.4l42.6-64a7.8,7.8,0,0,0,0-8.8l-42.6-64a7.9,7.9,0,0,0-6.7-3.6H24l45,67.6a7.8,7.8,0,0,1,0,8.8L24,200H179.7A7.9,7.9,0,0,0,186.4,196.4Z",
  opacity: "0.2"
}, null, -1), WPi = ["stroke"], NPi = { key: 2 }, FPi = /* @__PURE__ */ e("path", { d: "M235.7,136.9l-42.7,64h0a15.9,15.9,0,0,1-13.3,7.1H24a7.8,7.8,0,0,1-7-4.2,8,8,0,0,1,.3-8.2L62.4,128,17.3,60.4a8,8,0,0,1-.3-8.2A7.8,7.8,0,0,1,24,48H179.7A15.9,15.9,0,0,1,193,55.1l42.7,64A16,16,0,0,1,235.7,136.9Z" }, null, -1), TPi = [
  FPi
], DPi = { key: 3 }, RPi = ["stroke"], UPi = { key: 4 }, qPi = ["stroke"], GPi = { key: 5 }, EPi = ["stroke"], OPi = {
  name: "PhTagChevron"
}, ytl = /* @__PURE__ */ $({
  ...OPi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", bPi, [
        e("path", {
          d: "M186.4,196.4l42.6-64a7.8,7.8,0,0,0,0-8.8l-42.6-64a7.9,7.9,0,0,0-6.7-3.6H24l45,67.6a7.8,7.8,0,0,1,0,8.8L24,200H179.7A7.9,7.9,0,0,0,186.4,196.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LPi)
      ])) : o(i) === "duotone" ? (s(), r("g", BPi, [
        PPi,
        e("path", {
          d: "M186.4,196.4l42.6-64a7.8,7.8,0,0,0,0-8.8l-42.6-64a7.9,7.9,0,0,0-6.7-3.6H24l45,67.6a7.8,7.8,0,0,1,0,8.8L24,200H179.7A7.9,7.9,0,0,0,186.4,196.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WPi)
      ])) : o(i) === "fill" ? (s(), r("g", NPi, TPi)) : o(i) === "light" ? (s(), r("g", DPi, [
        e("path", {
          d: "M186.4,196.4l42.6-64a7.8,7.8,0,0,0,0-8.8l-42.6-64a7.9,7.9,0,0,0-6.7-3.6H24l45,67.6a7.8,7.8,0,0,1,0,8.8L24,200H179.7A7.9,7.9,0,0,0,186.4,196.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RPi)
      ])) : o(i) === "thin" ? (s(), r("g", UPi, [
        e("path", {
          d: "M186.4,196.4l42.6-64a7.8,7.8,0,0,0,0-8.8l-42.6-64a7.9,7.9,0,0,0-6.7-3.6H24l45,67.6a7.8,7.8,0,0,1,0,8.8L24,200H179.7A7.9,7.9,0,0,0,186.4,196.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qPi)
      ])) : o(i) === "regular" ? (s(), r("g", GPi, [
        e("path", {
          d: "M186.4,196.4l42.6-64a7.8,7.8,0,0,0,0-8.8l-42.6-64a7.9,7.9,0,0,0-6.7-3.6H24l45,67.6a7.8,7.8,0,0,1,0,8.8L24,200H179.7A7.9,7.9,0,0,0,186.4,196.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EPi)
      ])) : g("", !0)
    ], 16, CPi));
  }
}), IPi = ["width", "height", "fill", "transform"], KPi = { key: 0 }, XPi = ["stroke"], JPi = { key: 1 }, QPi = /* @__PURE__ */ e("path", {
  d: "M194.4,196.4,240,128,194.4,59.6a7.9,7.9,0,0,0-6.7-3.6H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H187.7A7.9,7.9,0,0,0,194.4,196.4Z",
  opacity: "0.2"
}, null, -1), YPi = ["stroke"], oWi = { key: 2 }, eWi = /* @__PURE__ */ e("path", { d: "M246.7,123.6,201,55.1A15.9,15.9,0,0,0,187.7,48H40A16,16,0,0,0,24,64V192a16,16,0,0,0,16,16H187.7a15.9,15.9,0,0,0,13.3-7.1h0l45.7-68.5A8.2,8.2,0,0,0,246.7,123.6Z" }, null, -1), tWi = [
  eWi
], nWi = { key: 3 }, sWi = ["stroke"], rWi = { key: 4 }, iWi = ["stroke"], lWi = { key: 5 }, dWi = ["stroke"], kWi = {
  name: "PhTagSimple"
}, $tl = /* @__PURE__ */ $({
  ...kWi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", KPi, [
        e("path", {
          d: "M194.4,196.4,240,128,194.4,59.6a7.9,7.9,0,0,0-6.7-3.6H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H187.7A7.9,7.9,0,0,0,194.4,196.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XPi)
      ])) : o(i) === "duotone" ? (s(), r("g", JPi, [
        QPi,
        e("path", {
          d: "M194.4,196.4,240,128,194.4,59.6a7.9,7.9,0,0,0-6.7-3.6H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H187.7A7.9,7.9,0,0,0,194.4,196.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YPi)
      ])) : o(i) === "fill" ? (s(), r("g", oWi, tWi)) : o(i) === "light" ? (s(), r("g", nWi, [
        e("path", {
          d: "M194.4,196.4,240,128,194.4,59.6a7.9,7.9,0,0,0-6.7-3.6H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H187.7A7.9,7.9,0,0,0,194.4,196.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sWi)
      ])) : o(i) === "thin" ? (s(), r("g", rWi, [
        e("path", {
          d: "M194.4,196.4,240,128,194.4,59.6a7.9,7.9,0,0,0-6.7-3.6H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H187.7A7.9,7.9,0,0,0,194.4,196.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iWi)
      ])) : o(i) === "regular" ? (s(), r("g", lWi, [
        e("path", {
          d: "M194.4,196.4,240,128,194.4,59.6a7.9,7.9,0,0,0-6.7-3.6H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H187.7A7.9,7.9,0,0,0,194.4,196.4Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dWi)
      ])) : g("", !0)
    ], 16, IPi));
  }
}), cWi = ["width", "height", "fill", "transform"], hWi = { key: 0 }, uWi = ["stroke"], aWi = ["stroke"], _Wi = ["stroke"], pWi = { key: 1 }, yWi = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "48",
  opacity: "0.2"
}, null, -1), $Wi = ["stroke"], wWi = ["stroke"], fWi = ["stroke"], gWi = { key: 2 }, xWi = /* @__PURE__ */ e("path", { d: "M211.2,79.4a8,8,0,0,0-3.8,10.7,88,88,0,1,1-23.1-29.7L161.5,83.2a56,56,0,0,0-73.1,84.4h0a56,56,0,0,0,95.5-42.8,7.9,7.9,0,0,0-8.4-7.5,8,8,0,0,0-7.6,8.4,40,40,0,0,1-62,35.7l24-24,37.7-37.7h0l62.1-62a8.1,8.1,0,0,0-11.4-11.4L195.7,49A104,104,0,0,0,54.5,54.5a103.8,103.8,0,0,0,0,147,103.8,103.8,0,0,0,147,0A104,104,0,0,0,221.9,83.2,8,8,0,0,0,211.2,79.4Z" }, null, -1), jWi = [
  xWi
], mWi = { key: 3 }, MWi = ["stroke"], vWi = ["stroke"], SWi = ["stroke"], HWi = { key: 4 }, AWi = ["stroke"], VWi = ["stroke"], zWi = ["stroke"], ZWi = { key: 5 }, CWi = ["stroke"], bWi = ["stroke"], LWi = ["stroke"], BWi = {
  name: "PhTarget"
}, wtl = /* @__PURE__ */ $({
  ...BWi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", hWi, [
        e("line", {
          x1: "128",
          y1: "128",
          x2: "224",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uWi),
        e("path", {
          d: "M161.9,94.1a47.9,47.9,0,1,0,0,67.8,47.1,47.1,0,0,0,13.2-24.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aWi),
        e("path", {
          d: "M195.9,60.1A96.1,96.1,0,1,0,218,94.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Wi)
      ])) : o(i) === "duotone" ? (s(), r("g", pWi, [
        yWi,
        e("line", {
          x1: "128",
          y1: "128",
          x2: "224",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Wi),
        e("path", {
          d: "M195.9,60.1a96.2,96.2,0,1,0,18.7,26.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wWi),
        e("path", {
          d: "M161.9,94.1a47.9,47.9,0,1,0,14,31.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fWi)
      ])) : o(i) === "fill" ? (s(), r("g", gWi, jWi)) : o(i) === "light" ? (s(), r("g", mWi, [
        e("line", {
          x1: "128",
          y1: "128",
          x2: "224",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, MWi),
        e("path", {
          d: "M195.9,60.1a96.2,96.2,0,1,0,18.7,26.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vWi),
        e("path", {
          d: "M161.9,94.1a47.9,47.9,0,1,0,14,31.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, SWi)
      ])) : o(i) === "thin" ? (s(), r("g", HWi, [
        e("line", {
          x1: "128",
          y1: "128",
          x2: "224",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, AWi),
        e("path", {
          d: "M195.9,60.1a96.2,96.2,0,1,0,18.7,26.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VWi),
        e("path", {
          d: "M161.9,94.1a47.9,47.9,0,1,0,14,31.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zWi)
      ])) : o(i) === "regular" ? (s(), r("g", ZWi, [
        e("line", {
          x1: "128",
          y1: "128",
          x2: "224",
          y2: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CWi),
        e("path", {
          d: "M195.9,60.1a96.2,96.2,0,1,0,18.7,26.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bWi),
        e("path", {
          d: "M161.9,94.1a47.9,47.9,0,1,0,14,31.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LWi)
      ])) : g("", !0)
    ], 16, cWi));
  }
}), PWi = ["width", "height", "fill", "transform"], WWi = { key: 0 }, NWi = ["stroke"], FWi = ["stroke"], TWi = ["stroke"], DWi = ["stroke"], RWi = ["stroke"], UWi = { key: 1 }, qWi = /* @__PURE__ */ e("path", {
  d: "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184Z",
  opacity: "0.2"
}, null, -1), GWi = /* @__PURE__ */ e("path", {
  d: "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184Z",
  opacity: "0.2"
}, null, -1), EWi = /* @__PURE__ */ e("path", {
  d: "M224,120,194.3,68a7.9,7.9,0,0,0-6.9-4H68.6a7.9,7.9,0,0,0-6.9,4L32,120Z",
  opacity: "0.2"
}, null, -1), OWi = ["stroke"], IWi = ["stroke"], KWi = ["stroke"], XWi = ["stroke"], JWi = ["stroke"], QWi = ["stroke"], YWi = ["stroke"], oNi = { key: 2 }, eNi = /* @__PURE__ */ e("path", { d: "M240,112H228.6L201.2,64.1A15.9,15.9,0,0,0,187.4,56h-22l-12-29.9A15.7,15.7,0,0,0,138.6,16H117.4a15.7,15.7,0,0,0-14.8,10.1L90.6,56h-22a15.9,15.9,0,0,0-13.8,8.1L27.4,112H16a8,8,0,0,0,0,16h8v80a16,16,0,0,0,16,16H64a16,16,0,0,0,16-16V192h96v16a16,16,0,0,0,16,16h24a16,16,0,0,0,16-16V128h8a8,8,0,0,0,0-16ZM117.4,32h21.2l9.6,24H107.8ZM80,160H64a8,8,0,0,1,0-16H80a8,8,0,0,1,0,16Zm112,0H176a8,8,0,0,1,0-16h16a8,8,0,0,1,0,16Z" }, null, -1), tNi = [
  eNi
], nNi = { key: 3 }, sNi = ["stroke"], rNi = ["stroke"], iNi = ["stroke"], lNi = ["stroke"], dNi = ["stroke"], kNi = ["stroke"], cNi = ["stroke"], hNi = { key: 4 }, uNi = ["stroke"], aNi = ["stroke"], _Ni = ["stroke"], pNi = ["stroke"], yNi = ["stroke"], $Ni = ["stroke"], wNi = ["stroke"], fNi = { key: 5 }, gNi = ["stroke"], xNi = ["stroke"], jNi = ["stroke"], mNi = ["stroke"], MNi = ["stroke"], vNi = ["stroke"], SNi = ["stroke"], HNi = {
  name: "PhTaxi"
}, ftl = /* @__PURE__ */ $({
  ...HNi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", WWi, [
        e("path", {
          d: "M160,68,146,33a7.9,7.9,0,0,0-7.4-5H117.4a7.9,7.9,0,0,0-7.4,5L96,68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NWi),
        e("line", {
          x1: "12",
          y1: "124",
          x2: "244",
          y2: "124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FWi),
        e("path", {
          d: "M228,172v32a8,8,0,0,1-8,8H196a8,8,0,0,1-8-8V172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TWi),
        e("path", {
          d: "M68,172v32a8,8,0,0,1-8,8H36a8,8,0,0,1-8-8V172",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DWi),
        e("path", {
          d: "M228,124,194.4,71.7a8.1,8.1,0,0,0-6.8-3.7H68.4a8.1,8.1,0,0,0-6.8,3.7L28,124v48H228Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RWi)
      ])) : o(i) === "duotone" ? (s(), r("g", UWi, [
        qWi,
        GWi,
        EWi,
        e("path", {
          d: "M160,64,146,29a7.9,7.9,0,0,0-7.4-5H117.4a7.9,7.9,0,0,0-7.4,5L96,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OWi),
        e("line", {
          x1: "16",
          y1: "120",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IWi),
        e("path", {
          d: "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KWi),
        e("path", {
          d: "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XWi),
        e("line", {
          x1: "64",
          y1: "152",
          x2: "80",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JWi),
        e("line", {
          x1: "176",
          y1: "152",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QWi),
        e("path", {
          d: "M224,120,194.3,68a7.9,7.9,0,0,0-6.9-4H68.6a7.9,7.9,0,0,0-6.9,4L32,120v64H224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YWi)
      ])) : o(i) === "fill" ? (s(), r("g", oNi, tNi)) : o(i) === "light" ? (s(), r("g", nNi, [
        e("path", {
          d: "M160,64,146,29a7.9,7.9,0,0,0-7.4-5H117.4a7.9,7.9,0,0,0-7.4,5L96,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sNi),
        e("line", {
          x1: "16",
          y1: "120",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rNi),
        e("path", {
          d: "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iNi),
        e("path", {
          d: "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lNi),
        e("line", {
          x1: "64",
          y1: "152",
          x2: "80",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dNi),
        e("line", {
          x1: "176",
          y1: "152",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kNi),
        e("path", {
          d: "M224,120,194.3,68a7.9,7.9,0,0,0-6.9-4H68.6a7.9,7.9,0,0,0-6.9,4L32,120v64H224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cNi)
      ])) : o(i) === "thin" ? (s(), r("g", hNi, [
        e("path", {
          d: "M160,64,146,29a7.9,7.9,0,0,0-7.4-5H117.4a7.9,7.9,0,0,0-7.4,5L96,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uNi),
        e("line", {
          x1: "16",
          y1: "120",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aNi),
        e("path", {
          d: "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _Ni),
        e("path", {
          d: "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pNi),
        e("line", {
          x1: "64",
          y1: "152",
          x2: "80",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yNi),
        e("line", {
          x1: "176",
          y1: "152",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $Ni),
        e("path", {
          d: "M224,120,194.3,68a7.9,7.9,0,0,0-6.9-4H68.6a7.9,7.9,0,0,0-6.9,4L32,120v64H224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wNi)
      ])) : o(i) === "regular" ? (s(), r("g", fNi, [
        e("line", {
          x1: "16",
          y1: "120",
          x2: "240",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gNi),
        e("path", {
          d: "M224,184v24a8,8,0,0,1-8,8H192a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xNi),
        e("path", {
          d: "M72,184v24a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jNi),
        e("line", {
          x1: "64",
          y1: "152",
          x2: "80",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mNi),
        e("line", {
          x1: "176",
          y1: "152",
          x2: "192",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MNi),
        e("path", {
          d: "M224,120,194.3,68a7.9,7.9,0,0,0-6.9-4H68.6a7.9,7.9,0,0,0-6.9,4L32,120v64H224Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vNi),
        e("path", {
          d: "M160,64,146,29a7.9,7.9,0,0,0-7.4-5H117.4a7.9,7.9,0,0,0-7.4,5L96,64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SNi)
      ])) : g("", !0)
    ], 16, PWi));
  }
}), ANi = ["width", "height", "fill", "transform"], VNi = { key: 0 }, zNi = ["stroke"], ZNi = ["stroke"], CNi = ["stroke"], bNi = { key: 1 }, LNi = /* @__PURE__ */ e("path", {
  d: "M88,134.9,224.1,36.6h0a7.8,7.8,0,0,0-6.2-.2L33.3,108.9c-7.4,2.9-6.4,13.7,1.4,15.3Z",
  opacity: "0.2"
}, null, -1), BNi = /* @__PURE__ */ e("path", {
  d: "M132.9,174.4l-31.2,31.2A8,8,0,0,1,88,200V134.9Z",
  opacity: "0.2"
}, null, -1), PNi = ["stroke"], WNi = ["stroke"], NNi = ["stroke"], FNi = { key: 2 }, TNi = /* @__PURE__ */ e("path", { d: "M231.3,31.7A16.1,16.1,0,0,0,215,29L30.4,101.5a15.8,15.8,0,0,0-10.1,16.3,16,16,0,0,0,12.8,14.3L80,141.4V200a16,16,0,0,0,9.9,14.8A16.6,16.6,0,0,0,96,216a15.8,15.8,0,0,0,11.3-4.7l26-25.9L172.6,220a16,16,0,0,0,10.5,4,14.2,14.2,0,0,0,5-.8,15.9,15.9,0,0,0,10.7-11.6L236.4,47.4A16,16,0,0,0,231.3,31.7ZM183.2,208l-82.4-72.5L219.5,49.8Z" }, null, -1), DNi = [
  TNi
], RNi = { key: 3 }, UNi = ["stroke"], qNi = ["stroke"], GNi = ["stroke"], ENi = { key: 4 }, ONi = ["stroke"], INi = ["stroke"], KNi = ["stroke"], XNi = { key: 5 }, JNi = ["stroke"], QNi = ["stroke"], YNi = ["stroke"], oFi = {
  name: "PhTelegramLogo"
}, gtl = /* @__PURE__ */ $({
  ...oFi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", VNi, [
        e("path", {
          d: "M88,134.9,177.9,214a8,8,0,0,0,13.1-4.2L228.6,45.6a8,8,0,0,0-10.7-9.2L33.3,108.9c-7.4,2.9-6.4,13.7,1.4,15.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zNi),
        e("line", {
          x1: "88",
          y1: "134.9",
          x2: "224.1",
          y2: "36.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZNi),
        e("path", {
          d: "M132.9,174.4l-31.2,31.2A8,8,0,0,1,88,200V134.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CNi)
      ])) : o(i) === "duotone" ? (s(), r("g", bNi, [
        LNi,
        BNi,
        e("path", {
          d: "M88,134.9,177.9,214a8,8,0,0,0,13.1-4.2L228.6,45.6a8,8,0,0,0-10.7-9.2L33.3,108.9c-7.4,2.9-6.4,13.7,1.4,15.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PNi),
        e("line", {
          x1: "88",
          y1: "134.9",
          x2: "224.1",
          y2: "36.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WNi),
        e("path", {
          d: "M132.9,174.4l-31.2,31.2A8,8,0,0,1,88,200V134.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NNi)
      ])) : o(i) === "fill" ? (s(), r("g", FNi, DNi)) : o(i) === "light" ? (s(), r("g", RNi, [
        e("path", {
          d: "M88,134.9,177.9,214a8,8,0,0,0,13.1-4.2L228.6,45.6a8,8,0,0,0-10.7-9.2L33.3,108.9c-7.4,2.9-6.4,13.7,1.4,15.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UNi),
        e("line", {
          x1: "88",
          y1: "134.9",
          x2: "224.1",
          y2: "36.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qNi),
        e("path", {
          d: "M132.9,174.4l-31.2,31.2A8,8,0,0,1,88,200V134.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GNi)
      ])) : o(i) === "thin" ? (s(), r("g", ENi, [
        e("path", {
          d: "M88,134.9,177.9,214a8,8,0,0,0,13.1-4.2L228.6,45.6a8,8,0,0,0-10.7-9.2L33.3,108.9c-7.4,2.9-6.4,13.7,1.4,15.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ONi),
        e("line", {
          x1: "88",
          y1: "134.9",
          x2: "224.1",
          y2: "36.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, INi),
        e("path", {
          d: "M132.9,174.4l-31.2,31.2A8,8,0,0,1,88,200V134.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KNi)
      ])) : o(i) === "regular" ? (s(), r("g", XNi, [
        e("path", {
          d: "M88,134.9,177.9,214a8,8,0,0,0,13.1-4.2L228.6,45.6a8,8,0,0,0-10.7-9.2L33.3,108.9c-7.4,2.9-6.4,13.7,1.4,15.3Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JNi),
        e("line", {
          x1: "88",
          y1: "134.9",
          x2: "224.1",
          y2: "36.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QNi),
        e("path", {
          d: "M132.9,174.4l-31.2,31.2A8,8,0,0,1,88,200V134.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YNi)
      ])) : g("", !0)
    ], 16, ANi));
  }
}), eFi = ["width", "height", "fill", "transform"], tFi = { key: 0 }, nFi = ["stroke"], sFi = ["stroke"], rFi = /* @__PURE__ */ e("circle", {
  cx: "184",
  cy: "116",
  r: "16"
}, null, -1), iFi = /* @__PURE__ */ e("circle", {
  cx: "184",
  cy: "164",
  r: "16"
}, null, -1), lFi = ["stroke"], dFi = { key: 1 }, kFi = /* @__PURE__ */ e("path", {
  d: "M152,208V72H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8Z",
  opacity: "0.2"
}, null, -1), cFi = ["stroke"], hFi = ["stroke"], uFi = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "116",
  r: "12"
}, null, -1), aFi = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "164",
  r: "12"
}, null, -1), _Fi = ["stroke"], pFi = { key: 2 }, yFi = /* @__PURE__ */ e("path", { d: "M216,64H147.3l34.4-34.3a8.1,8.1,0,0,0-11.4-11.4L128,60.7,85.7,18.3A8.1,8.1,0,0,0,74.3,29.7L108.7,64H40A16,16,0,0,0,24,80V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64Zm0,136H160V80h56V200Zm-16-84a12,12,0,1,1-12-12A12,12,0,0,1,200,116Zm0,48a12,12,0,1,1-12-12A12,12,0,0,1,200,164Z" }, null, -1), $Fi = [
  yFi
], wFi = { key: 3 }, fFi = ["stroke"], gFi = ["stroke"], xFi = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "116",
  r: "10"
}, null, -1), jFi = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "164",
  r: "10"
}, null, -1), mFi = ["stroke"], MFi = { key: 4 }, vFi = ["stroke"], SFi = ["stroke"], HFi = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "116",
  r: "8"
}, null, -1), AFi = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "164",
  r: "8"
}, null, -1), VFi = ["stroke"], zFi = { key: 5 }, ZFi = ["stroke"], CFi = ["stroke"], bFi = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "116",
  r: "12"
}, null, -1), LFi = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "164",
  r: "12"
}, null, -1), BFi = ["stroke"], PFi = {
  name: "PhTelevision"
}, xtl = /* @__PURE__ */ $({
  ...PFi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", tFi, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "136",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nFi),
        e("polyline", {
          points: "80 24 128 72 176 24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sFi),
        rFi,
        iFi,
        e("line", {
          x1: "140",
          y1: "208",
          x2: "140",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lFi)
      ])) : o(i) === "duotone" ? (s(), r("g", dFi, [
        kFi,
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "136",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cFi),
        e("polyline", {
          points: "80 24 128 72 176 24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hFi),
        uFi,
        aFi,
        e("line", {
          x1: "152",
          y1: "208",
          x2: "152",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Fi)
      ])) : o(i) === "fill" ? (s(), r("g", pFi, $Fi)) : o(i) === "light" ? (s(), r("g", wFi, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "136",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fFi),
        e("polyline", {
          points: "80 24 128 72 176 24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gFi),
        xFi,
        jFi,
        e("line", {
          x1: "152",
          y1: "208",
          x2: "152",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mFi)
      ])) : o(i) === "thin" ? (s(), r("g", MFi, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "136",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vFi),
        e("polyline", {
          points: "80 24 128 72 176 24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SFi),
        HFi,
        AFi,
        e("line", {
          x1: "152",
          y1: "208",
          x2: "152",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VFi)
      ])) : o(i) === "regular" ? (s(), r("g", zFi, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "136",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZFi),
        e("polyline", {
          points: "80 24 128 72 176 24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CFi),
        bFi,
        LFi,
        e("line", {
          x1: "152",
          y1: "208",
          x2: "152",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BFi)
      ])) : g("", !0)
    ], 16, eFi));
  }
}), WFi = ["width", "height", "fill", "transform"], NFi = { key: 0 }, FFi = ["stroke"], TFi = ["stroke"], DFi = { key: 1 }, RFi = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "72",
  width: "192",
  height: "136",
  rx: "8",
  opacity: "0.2"
}, null, -1), UFi = ["stroke"], qFi = ["stroke"], GFi = { key: 2 }, EFi = /* @__PURE__ */ e("path", { d: "M232,80V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V80A16,16,0,0,1,40,64h68.7L74.3,29.7A8.1,8.1,0,0,1,85.7,18.3L128,60.7l42.3-42.4a8.1,8.1,0,0,1,11.4,11.4L147.3,64H216A16,16,0,0,1,232,80Z" }, null, -1), OFi = [
  EFi
], IFi = { key: 3 }, KFi = ["stroke"], XFi = ["stroke"], JFi = { key: 4 }, QFi = ["stroke"], YFi = ["stroke"], oTi = { key: 5 }, eTi = ["stroke"], tTi = ["stroke"], nTi = {
  name: "PhTelevisionSimple"
}, jtl = /* @__PURE__ */ $({
  ...nTi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", NFi, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "136",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FFi),
        e("polyline", {
          points: "80 24 128 72 176 24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TFi)
      ])) : o(i) === "duotone" ? (s(), r("g", DFi, [
        RFi,
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "136",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UFi),
        e("polyline", {
          points: "80 24 128 72 176 24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qFi)
      ])) : o(i) === "fill" ? (s(), r("g", GFi, OFi)) : o(i) === "light" ? (s(), r("g", IFi, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "136",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KFi),
        e("polyline", {
          points: "80 24 128 72 176 24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XFi)
      ])) : o(i) === "thin" ? (s(), r("g", JFi, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "136",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QFi),
        e("polyline", {
          points: "80 24 128 72 176 24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YFi)
      ])) : o(i) === "regular" ? (s(), r("g", oTi, [
        e("rect", {
          x: "32",
          y: "72",
          width: "192",
          height: "136",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eTi),
        e("polyline", {
          points: "80 24 128 72 176 24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tTi)
      ])) : g("", !0)
    ], 16, WFi));
  }
}), sTi = ["width", "height", "fill", "transform"], rTi = { key: 0 }, iTi = ["stroke"], lTi = ["stroke"], dTi = ["stroke"], kTi = { key: 1 }, cTi = /* @__PURE__ */ e("path", {
  d: "M32,128a95.9,95.9,0,0,1,95.8-96h0A95.9,95.9,0,0,1,32,127.8Z",
  opacity: "0.2"
}, null, -1), hTi = /* @__PURE__ */ e("path", {
  d: "M128.2,224.2a95.9,95.9,0,0,1,95.8-96h0A95.9,95.9,0,0,1,128.2,224Z",
  opacity: "0.2"
}, null, -1), uTi = ["stroke"], aTi = ["stroke"], _Ti = ["stroke"], pTi = { key: 2 }, yTi = /* @__PURE__ */ e("path", { d: "M224,136h3.3a4,4,0,0,1,3.9,4.5,104.2,104.2,0,0,1-94.8,91.1A88,88,0,0,1,224,136Zm-73.5,14.5A102.9,102.9,0,0,1,224,120h3.1a4,4,0,0,0,4.1-4.4,104.1,104.1,0,0,0-90.9-90.9,4,4,0,0,0-4.4,4.1,103.7,103.7,0,0,1-30.4,76.7A102.9,102.9,0,0,1,32,136H28.9a4,4,0,0,0-4.1,4.4,104.1,104.1,0,0,0,90.9,90.9,4,4,0,0,0,4.4-4.1A103.7,103.7,0,0,1,150.5,150.5ZM94.2,94.2a87.6,87.6,0,0,0,25.7-65.7,4,4,0,0,0-4.5-3.7,104,104,0,0,0-90.6,90.6,4,4,0,0,0,3.8,4.5A87.8,87.8,0,0,0,94.2,94.2Z" }, null, -1), $Ti = [
  yTi
], wTi = { key: 3 }, fTi = ["stroke"], gTi = ["stroke"], xTi = ["stroke"], jTi = { key: 4 }, mTi = ["stroke"], MTi = ["stroke"], vTi = ["stroke"], STi = { key: 5 }, HTi = ["stroke"], ATi = ["stroke"], VTi = ["stroke"], zTi = {
  name: "PhTennisBall"
}, mtl = /* @__PURE__ */ $({
  ...zTi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", rTi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iTi),
        e("path", {
          d: "M127.8,32A95.9,95.9,0,0,1,32,127.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lTi),
        e("path", {
          d: "M224,128.2A95.9,95.9,0,0,0,128.2,224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dTi)
      ])) : o(i) === "duotone" ? (s(), r("g", kTi, [
        cTi,
        hTi,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uTi),
        e("path", {
          d: "M127.8,32A95.9,95.9,0,0,1,32,127.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aTi),
        e("path", {
          d: "M224,128.2A95.9,95.9,0,0,0,128.2,224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Ti)
      ])) : o(i) === "fill" ? (s(), r("g", pTi, $Ti)) : o(i) === "light" ? (s(), r("g", wTi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fTi),
        e("path", {
          d: "M127.8,32A95.9,95.9,0,0,1,32,127.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gTi),
        e("path", {
          d: "M224,128.2A95.9,95.9,0,0,0,128.2,224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xTi)
      ])) : o(i) === "thin" ? (s(), r("g", jTi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mTi),
        e("path", {
          d: "M127.8,32A95.9,95.9,0,0,1,32,127.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MTi),
        e("path", {
          d: "M224,128.2A95.9,95.9,0,0,0,128.2,224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vTi)
      ])) : o(i) === "regular" ? (s(), r("g", STi, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HTi),
        e("path", {
          d: "M127.8,32A95.9,95.9,0,0,1,32,127.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ATi),
        e("path", {
          d: "M224,128.2A95.9,95.9,0,0,0,128.2,224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VTi)
      ])) : g("", !0)
    ], 16, sTi));
  }
}), ZTi = ["width", "height", "fill", "transform"], CTi = { key: 0 }, bTi = ["stroke"], LTi = ["stroke"], BTi = { key: 1 }, PTi = ["stroke"], WTi = ["stroke"], NTi = { key: 2 }, FTi = /* @__PURE__ */ e("path", { d: "M120,128a8,8,0,0,0-2.7-6l-72-64A8,8,0,1,0,34.7,70L100,128,34.7,186A8,8,0,0,0,40,200a8.1,8.1,0,0,0,5.3-2l72-64A8,8,0,0,0,120,128Z" }, null, -1), TTi = /* @__PURE__ */ e("path", { d: "M216,184H120a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z" }, null, -1), DTi = [
  FTi,
  TTi
], RTi = { key: 3 }, UTi = ["stroke"], qTi = ["stroke"], GTi = { key: 4 }, ETi = ["stroke"], OTi = ["stroke"], ITi = { key: 5 }, KTi = ["stroke"], XTi = ["stroke"], JTi = {
  name: "PhTerminal"
}, Mtl = /* @__PURE__ */ $({
  ...JTi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", CTi, [
        e("polyline", {
          points: "40 64 112 128 40 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bTi),
        e("line", {
          x1: "120",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LTi)
      ])) : o(i) === "duotone" ? (s(), r("g", BTi, [
        e("polyline", {
          points: "40 64 112 128 40 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PTi),
        e("line", {
          x1: "120",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WTi)
      ])) : o(i) === "fill" ? (s(), r("g", NTi, DTi)) : o(i) === "light" ? (s(), r("g", RTi, [
        e("polyline", {
          points: "40 64 112 128 40 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UTi),
        e("line", {
          x1: "120",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qTi)
      ])) : o(i) === "thin" ? (s(), r("g", GTi, [
        e("polyline", {
          points: "40 64 112 128 40 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ETi),
        e("line", {
          x1: "120",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OTi)
      ])) : o(i) === "regular" ? (s(), r("g", ITi, [
        e("polyline", {
          points: "40 64 112 128 40 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KTi),
        e("line", {
          x1: "120",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XTi)
      ])) : g("", !0)
    ], 16, ZTi));
  }
}), QTi = ["width", "height", "fill", "transform"], YTi = { key: 0 }, oDi = ["stroke"], eDi = ["stroke"], tDi = ["stroke"], nDi = { key: 1 }, sDi = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "48",
  width: "192",
  height: "160",
  rx: "8.5",
  opacity: "0.2"
}, null, -1), rDi = ["stroke"], iDi = ["stroke"], lDi = ["stroke"], dDi = { key: 2 }, kDi = /* @__PURE__ */ e("path", { d: "M215.5,39.5H40.5a17,17,0,0,0-17,17v143a17,17,0,0,0,17,17h175a17,17,0,0,0,17-17V56.5A17,17,0,0,0,215.5,39.5ZM121,134.2l-40,32a7.9,7.9,0,0,1-5,1.8,7.8,7.8,0,0,1-6.2-3A7.9,7.9,0,0,1,71,153.8L103.2,128,71,102.2A8,8,0,1,1,81,89.8l40,32a7.9,7.9,0,0,1,0,12.4ZM180,168H140a8,8,0,0,1,0-16h40a8,8,0,0,1,0,16Z" }, null, -1), cDi = [
  kDi
], hDi = { key: 3 }, uDi = ["stroke"], aDi = ["stroke"], _Di = ["stroke"], pDi = { key: 4 }, yDi = ["stroke"], $Di = ["stroke"], wDi = ["stroke"], fDi = { key: 5 }, gDi = ["stroke"], xDi = ["stroke"], jDi = ["stroke"], mDi = {
  name: "PhTerminalWindow"
}, vtl = /* @__PURE__ */ $({
  ...mDi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", YTi, [
        e("polyline", {
          points: "80 96 120 128 80 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oDi),
        e("line", {
          x1: "144",
          y1: "160",
          x2: "176",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eDi),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tDi)
      ])) : o(i) === "duotone" ? (s(), r("g", nDi, [
        sDi,
        e("polyline", {
          points: "80 96 120 128 80 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rDi),
        e("line", {
          x1: "136",
          y1: "160",
          x2: "176",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iDi),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16.97"
        }, null, 8, lDi)
      ])) : o(i) === "fill" ? (s(), r("g", dDi, cDi)) : o(i) === "light" ? (s(), r("g", hDi, [
        e("polyline", {
          points: "80 96 120 128 80 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uDi),
        e("line", {
          x1: "136",
          y1: "160",
          x2: "176",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aDi),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _Di)
      ])) : o(i) === "thin" ? (s(), r("g", pDi, [
        e("polyline", {
          points: "80 96 120 128 80 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yDi),
        e("line", {
          x1: "136",
          y1: "160",
          x2: "176",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $Di),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wDi)
      ])) : o(i) === "regular" ? (s(), r("g", fDi, [
        e("polyline", {
          points: "80 96 120 128 80 160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gDi),
        e("line", {
          x1: "136",
          y1: "160",
          x2: "176",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xDi),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16.97"
        }, null, 8, jDi)
      ])) : g("", !0)
    ], 16, QTi));
  }
}), MDi = ["width", "height", "fill", "transform"], vDi = { key: 0 }, SDi = ["stroke"], HDi = ["stroke"], ADi = { key: 1 }, VDi = /* @__PURE__ */ e("path", {
  d: "M68,136s20-16,52,0,52,0,52,0L94,214a36.7,36.7,0,0,1-52,0h0a36.7,36.7,0,0,1,0-52Z",
  opacity: "0.2"
}, null, -1), zDi = ["stroke"], ZDi = ["stroke"], CDi = { key: 2 }, bDi = /* @__PURE__ */ e("path", { d: "M237.7,86.3l-60-60a8.1,8.1,0,0,0-11.4,0L62.4,130.3h0l-26.1,26a44.8,44.8,0,0,0,63.4,63.4l77.9-78h0L212.3,107l22.2-7.4a8.2,8.2,0,0,0,5.3-5.8A8.3,8.3,0,0,0,237.7,86.3Zm-32.2,6.1a9.4,9.4,0,0,0-3.2,1.9l-35.6,35.6c-2.1,1.6-17.9,11.6-43.1-1.1-11-5.5-20.8-7.6-29.2-7.9L172,43.3l45.2,45.2Z" }, null, -1), LDi = [
  bDi
], BDi = { key: 3 }, PDi = ["stroke"], WDi = ["stroke"], NDi = { key: 4 }, FDi = ["stroke"], TDi = ["stroke"], DDi = { key: 5 }, RDi = ["stroke"], UDi = ["stroke"], qDi = {
  name: "PhTestTube"
}, Stl = /* @__PURE__ */ $({
  ...qDi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", vDi, [
        e("path", {
          d: "M208,100,94,214a36.7,36.7,0,0,1-52,0h0a36.7,36.7,0,0,1,0-52L172,32l60,60Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SDi),
        e("path", {
          d: "M68,136s20-16,52,0,52,0,52,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HDi)
      ])) : o(i) === "duotone" ? (s(), r("g", ADi, [
        VDi,
        e("path", {
          d: "M208,100,94,214a36.7,36.7,0,0,1-52,0h0a36.7,36.7,0,0,1,0-52L172,32l60,60Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zDi),
        e("path", {
          d: "M68,136s20-16,52,0,52,0,52,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZDi)
      ])) : o(i) === "fill" ? (s(), r("g", CDi, LDi)) : o(i) === "light" ? (s(), r("g", BDi, [
        e("path", {
          d: "M208,100,94,214a36.7,36.7,0,0,1-52,0h0a36.7,36.7,0,0,1,0-52L172,32l60,60Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PDi),
        e("path", {
          d: "M68,136s20-16,52,0,52,0,52,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WDi)
      ])) : o(i) === "thin" ? (s(), r("g", NDi, [
        e("path", {
          d: "M208,100,94,214a36.7,36.7,0,0,1-52,0h0a36.7,36.7,0,0,1,0-52L172,32l60,60Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FDi),
        e("path", {
          d: "M68,136s20-16,52,0,52,0,52,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, TDi)
      ])) : o(i) === "regular" ? (s(), r("g", DDi, [
        e("path", {
          d: "M208,100,94,214a36.7,36.7,0,0,1-52,0h0a36.7,36.7,0,0,1,0-52L172,32l60,60Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RDi),
        e("path", {
          d: "M68,136s20-16,52,0,52,0,52,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UDi)
      ])) : g("", !0)
    ], 16, MDi));
  }
}), GDi = ["width", "height", "fill", "transform"], EDi = { key: 0 }, ODi = ["stroke"], IDi = ["stroke"], KDi = ["stroke"], XDi = ["stroke"], JDi = { key: 1 }, QDi = ["stroke"], YDi = ["stroke"], oRi = ["stroke"], eRi = ["stroke"], tRi = { key: 2 }, nRi = /* @__PURE__ */ e("path", { d: "M137.9,148.2h0L87.1,52.3a8,8,0,0,0-14.2,0L22.1,148.2h0L.9,188.3a8.1,8.1,0,0,0,3.4,10.8,8.1,8.1,0,0,0,10.8-3.4L34,160h92l18.9,35.7A7.9,7.9,0,0,0,152,200a8,8,0,0,0,7.1-11.7ZM42.5,144,80,73.1,117.5,144ZM208,94.9a42,42,0,0,0-29.6,11.8,8,8,0,1,0,11.2,11.4,26,26,0,0,1,18.4-7.2c13.2,0,24,9,24,20v7.2a43,43,0,0,0-24-7.2c-22.1,0-40,16.1-40,36s17.9,36,40,36a42.9,42.9,0,0,0,24.7-7.7A7.9,7.9,0,0,0,240,200a8,8,0,0,0,8-8V130.9C248,111,230.1,94.9,208,94.9Zm0,92c-13.2,0-24-9-24-20s10.8-20,24-20,24,9,24,20S221.2,186.9,208,186.9Z" }, null, -1), sRi = [
  nRi
], rRi = { key: 3 }, iRi = ["stroke"], lRi = ["stroke"], dRi = ["stroke"], kRi = ["stroke"], cRi = { key: 4 }, hRi = ["stroke"], uRi = ["stroke"], aRi = ["stroke"], _Ri = ["stroke"], pRi = { key: 5 }, yRi = ["stroke"], $Ri = ["stroke"], wRi = ["stroke"], fRi = ["stroke"], gRi = {
  name: "PhTextAa"
}, Htl = /* @__PURE__ */ $({
  ...gRi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", EDi, [
        e("polyline", {
          points: "140 192 76 56 12 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ODi),
        e("line", {
          x1: "121.2",
          y1: "152",
          x2: "30.8",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IDi),
        e("ellipse", {
          cx: "204",
          cy: "167",
          rx: "32",
          ry: "27",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KDi),
        e("path", {
          d: "M184,109a35.1,35.1,0,0,1,20-6.1c17.7,0,32,12.5,32,28V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XDi)
      ])) : o(i) === "duotone" ? (s(), r("g", JDi, [
        e("polyline", {
          points: "152 192 80 56 8 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QDi),
        e("ellipse", {
          cx: "208",
          cy: "166.9",
          rx: "32",
          ry: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YDi),
        e("path", {
          d: "M184,112.4a34.1,34.1,0,0,1,24-9.5c17.7,0,32,12.5,32,28V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oRi),
        e("line", {
          x1: "130.8",
          y1: "152",
          x2: "29.2",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eRi)
      ])) : o(i) === "fill" ? (s(), r("g", tRi, sRi)) : o(i) === "light" ? (s(), r("g", rRi, [
        e("polyline", {
          points: "152 192 80 56 8 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iRi),
        e("ellipse", {
          cx: "208",
          cy: "166.9",
          rx: "32",
          ry: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lRi),
        e("path", {
          d: "M184,112.4a34.1,34.1,0,0,1,24-9.5c17.7,0,32,12.5,32,28V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dRi),
        e("line", {
          x1: "130.8",
          y1: "152",
          x2: "29.2",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kRi)
      ])) : o(i) === "thin" ? (s(), r("g", cRi, [
        e("polyline", {
          points: "152 192 80 56 8 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hRi),
        e("ellipse", {
          cx: "208",
          cy: "166.9",
          rx: "32",
          ry: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uRi),
        e("path", {
          d: "M184,112.4a34.1,34.1,0,0,1,24-9.5c17.7,0,32,12.5,32,28V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aRi),
        e("line", {
          x1: "130.8",
          y1: "152",
          x2: "29.2",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _Ri)
      ])) : o(i) === "regular" ? (s(), r("g", pRi, [
        e("polyline", {
          points: "152 192 80 56 8 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yRi),
        e("ellipse", {
          cx: "208",
          cy: "166.9",
          rx: "32",
          ry: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Ri),
        e("path", {
          d: "M184,112.4a34.1,34.1,0,0,1,24-9.5c17.7,0,32,12.5,32,28V192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wRi),
        e("line", {
          x1: "130.8",
          y1: "152",
          x2: "29.2",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fRi)
      ])) : g("", !0)
    ], 16, GDi));
  }
}), xRi = ["width", "height", "fill", "transform"], jRi = { key: 0 }, mRi = ["stroke"], MRi = ["stroke"], vRi = ["stroke"], SRi = ["stroke"], HRi = { key: 1 }, ARi = ["stroke"], VRi = ["stroke"], zRi = ["stroke"], ZRi = ["stroke"], CRi = { key: 2 }, bRi = /* @__PURE__ */ e("path", { d: "M40,76H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z" }, null, -1), LRi = /* @__PURE__ */ e("path", { d: "M64,100a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Z" }, null, -1), BRi = /* @__PURE__ */ e("path", { d: "M216,140H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1), PRi = /* @__PURE__ */ e("path", { d: "M192,180H64a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Z" }, null, -1), WRi = [
  bRi,
  LRi,
  BRi,
  PRi
], NRi = { key: 3 }, FRi = ["stroke"], TRi = ["stroke"], DRi = ["stroke"], RRi = ["stroke"], URi = { key: 4 }, qRi = ["stroke"], GRi = ["stroke"], ERi = ["stroke"], ORi = ["stroke"], IRi = { key: 5 }, KRi = ["stroke"], XRi = ["stroke"], JRi = ["stroke"], QRi = ["stroke"], YRi = {
  name: "PhTextAlignCenter"
}, Atl = /* @__PURE__ */ $({
  ...YRi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", jRi, [
        e("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mRi),
        e("line", {
          x1: "64",
          y1: "108",
          x2: "192",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MRi),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vRi),
        e("line", {
          x1: "64",
          y1: "188",
          x2: "192",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SRi)
      ])) : o(i) === "duotone" ? (s(), r("g", HRi, [
        e("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ARi),
        e("line", {
          x1: "64",
          y1: "108",
          x2: "192",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VRi),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zRi),
        e("line", {
          x1: "64",
          y1: "188",
          x2: "192",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZRi)
      ])) : o(i) === "fill" ? (s(), r("g", CRi, WRi)) : o(i) === "light" ? (s(), r("g", NRi, [
        e("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FRi),
        e("line", {
          x1: "64",
          y1: "108",
          x2: "192",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TRi),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DRi),
        e("line", {
          x1: "64",
          y1: "188",
          x2: "192",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RRi)
      ])) : o(i) === "thin" ? (s(), r("g", URi, [
        e("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qRi),
        e("line", {
          x1: "64",
          y1: "108",
          x2: "192",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GRi),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ERi),
        e("line", {
          x1: "64",
          y1: "188",
          x2: "192",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ORi)
      ])) : o(i) === "regular" ? (s(), r("g", IRi, [
        e("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KRi),
        e("line", {
          x1: "64",
          y1: "108",
          x2: "192",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XRi),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JRi),
        e("line", {
          x1: "64",
          y1: "188",
          x2: "192",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QRi)
      ])) : g("", !0)
    ], 16, xRi));
  }
}), oUi = ["width", "height", "fill", "transform"], eUi = { key: 0 }, tUi = ["stroke"], nUi = ["stroke"], sUi = ["stroke"], rUi = ["stroke"], iUi = { key: 1 }, lUi = ["stroke"], dUi = ["stroke"], kUi = ["stroke"], cUi = ["stroke"], hUi = { key: 2 }, uUi = /* @__PURE__ */ e("path", { d: "M40,76H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z" }, null, -1), aUi = /* @__PURE__ */ e("path", { d: "M216,100H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1), _Ui = /* @__PURE__ */ e("path", { d: "M216,140H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1), pUi = /* @__PURE__ */ e("path", { d: "M216,180H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1), yUi = [
  uUi,
  aUi,
  _Ui,
  pUi
], $Ui = { key: 3 }, wUi = ["stroke"], fUi = ["stroke"], gUi = ["stroke"], xUi = ["stroke"], jUi = { key: 4 }, mUi = ["stroke"], MUi = ["stroke"], vUi = ["stroke"], SUi = ["stroke"], HUi = { key: 5 }, AUi = ["stroke"], VUi = ["stroke"], zUi = ["stroke"], ZUi = ["stroke"], CUi = {
  name: "PhTextAlignJustify"
}, Vtl = /* @__PURE__ */ $({
  ...CUi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", eUi, [
        e("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tUi),
        e("line", {
          x1: "40",
          y1: "108",
          x2: "216",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nUi),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sUi),
        e("line", {
          x1: "40",
          y1: "188",
          x2: "216",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rUi)
      ])) : o(i) === "duotone" ? (s(), r("g", iUi, [
        e("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lUi),
        e("line", {
          x1: "40",
          y1: "108",
          x2: "216",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dUi),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kUi),
        e("line", {
          x1: "40",
          y1: "188",
          x2: "216",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cUi)
      ])) : o(i) === "fill" ? (s(), r("g", hUi, yUi)) : o(i) === "light" ? (s(), r("g", $Ui, [
        e("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wUi),
        e("line", {
          x1: "40",
          y1: "108",
          x2: "216",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fUi),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gUi),
        e("line", {
          x1: "40",
          y1: "188",
          x2: "216",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xUi)
      ])) : o(i) === "thin" ? (s(), r("g", jUi, [
        e("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mUi),
        e("line", {
          x1: "40",
          y1: "108",
          x2: "216",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MUi),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vUi),
        e("line", {
          x1: "40",
          y1: "188",
          x2: "216",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SUi)
      ])) : o(i) === "regular" ? (s(), r("g", HUi, [
        e("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AUi),
        e("line", {
          x1: "40",
          y1: "108",
          x2: "216",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VUi),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zUi),
        e("line", {
          x1: "40",
          y1: "188",
          x2: "216",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZUi)
      ])) : g("", !0)
    ], 16, oUi));
  }
}), bUi = ["width", "height", "fill", "transform"], LUi = { key: 0 }, BUi = ["stroke"], PUi = ["stroke"], WUi = ["stroke"], NUi = ["stroke"], FUi = { key: 1 }, TUi = ["stroke"], DUi = ["stroke"], RUi = ["stroke"], UUi = ["stroke"], qUi = { key: 2 }, GUi = /* @__PURE__ */ e("path", { d: "M40,76H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z" }, null, -1), EUi = /* @__PURE__ */ e("path", { d: "M40,116H168a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z" }, null, -1), OUi = /* @__PURE__ */ e("path", { d: "M216,140H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1), IUi = /* @__PURE__ */ e("path", { d: "M168,180H40a8,8,0,0,0,0,16H168a8,8,0,0,0,0-16Z" }, null, -1), KUi = [
  GUi,
  EUi,
  OUi,
  IUi
], XUi = { key: 3 }, JUi = ["stroke"], QUi = ["stroke"], YUi = ["stroke"], oqi = ["stroke"], eqi = { key: 4 }, tqi = ["stroke"], nqi = ["stroke"], sqi = ["stroke"], rqi = ["stroke"], iqi = { key: 5 }, lqi = ["stroke"], dqi = ["stroke"], kqi = ["stroke"], cqi = ["stroke"], hqi = {
  name: "PhTextAlignLeft"
}, ztl = /* @__PURE__ */ $({
  ...hqi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", LUi, [
        e("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BUi),
        e("line", {
          x1: "40",
          y1: "108",
          x2: "168",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PUi),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WUi),
        e("line", {
          x1: "40",
          y1: "188",
          x2: "168",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NUi)
      ])) : o(i) === "duotone" ? (s(), r("g", FUi, [
        e("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TUi),
        e("line", {
          x1: "40",
          y1: "108",
          x2: "168",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DUi),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RUi),
        e("line", {
          x1: "40",
          y1: "188",
          x2: "168",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UUi)
      ])) : o(i) === "fill" ? (s(), r("g", qUi, KUi)) : o(i) === "light" ? (s(), r("g", XUi, [
        e("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JUi),
        e("line", {
          x1: "40",
          y1: "108",
          x2: "168",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QUi),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YUi),
        e("line", {
          x1: "40",
          y1: "188",
          x2: "168",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oqi)
      ])) : o(i) === "thin" ? (s(), r("g", eqi, [
        e("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tqi),
        e("line", {
          x1: "40",
          y1: "108",
          x2: "168",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nqi),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sqi),
        e("line", {
          x1: "40",
          y1: "188",
          x2: "168",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rqi)
      ])) : o(i) === "regular" ? (s(), r("g", iqi, [
        e("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lqi),
        e("line", {
          x1: "40",
          y1: "108",
          x2: "168",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dqi),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kqi),
        e("line", {
          x1: "40",
          y1: "188",
          x2: "168",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cqi)
      ])) : g("", !0)
    ], 16, bUi));
  }
}), uqi = ["width", "height", "fill", "transform"], aqi = { key: 0 }, _qi = ["stroke"], pqi = ["stroke"], yqi = ["stroke"], $qi = ["stroke"], wqi = { key: 1 }, fqi = ["stroke"], gqi = ["stroke"], xqi = ["stroke"], jqi = ["stroke"], mqi = { key: 2 }, Mqi = /* @__PURE__ */ e("path", { d: "M40,76H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z" }, null, -1), vqi = /* @__PURE__ */ e("path", { d: "M216,100H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1), Sqi = /* @__PURE__ */ e("path", { d: "M216,140H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1), Hqi = /* @__PURE__ */ e("path", { d: "M216,180H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z" }, null, -1), Aqi = [
  Mqi,
  vqi,
  Sqi,
  Hqi
], Vqi = { key: 3 }, zqi = ["stroke"], Zqi = ["stroke"], Cqi = ["stroke"], bqi = ["stroke"], Lqi = { key: 4 }, Bqi = ["stroke"], Pqi = ["stroke"], Wqi = ["stroke"], Nqi = ["stroke"], Fqi = { key: 5 }, Tqi = ["stroke"], Dqi = ["stroke"], Rqi = ["stroke"], Uqi = ["stroke"], qqi = {
  name: "PhTextAlignRight"
}, Ztl = /* @__PURE__ */ $({
  ...qqi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", aqi, [
        e("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _qi),
        e("line", {
          x1: "88",
          y1: "108",
          x2: "216",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pqi),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yqi),
        e("line", {
          x1: "88",
          y1: "188",
          x2: "216",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $qi)
      ])) : o(i) === "duotone" ? (s(), r("g", wqi, [
        e("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fqi),
        e("line", {
          x1: "88",
          y1: "108",
          x2: "216",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gqi),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xqi),
        e("line", {
          x1: "88",
          y1: "188",
          x2: "216",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jqi)
      ])) : o(i) === "fill" ? (s(), r("g", mqi, Aqi)) : o(i) === "light" ? (s(), r("g", Vqi, [
        e("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zqi),
        e("line", {
          x1: "88",
          y1: "108",
          x2: "216",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zqi),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cqi),
        e("line", {
          x1: "88",
          y1: "188",
          x2: "216",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bqi)
      ])) : o(i) === "thin" ? (s(), r("g", Lqi, [
        e("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bqi),
        e("line", {
          x1: "88",
          y1: "108",
          x2: "216",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pqi),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wqi),
        e("line", {
          x1: "88",
          y1: "188",
          x2: "216",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Nqi)
      ])) : o(i) === "regular" ? (s(), r("g", Fqi, [
        e("line", {
          x1: "40",
          y1: "68",
          x2: "216",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tqi),
        e("line", {
          x1: "88",
          y1: "108",
          x2: "216",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dqi),
        e("line", {
          x1: "40",
          y1: "148",
          x2: "216",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rqi),
        e("line", {
          x1: "88",
          y1: "188",
          x2: "216",
          y2: "188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uqi)
      ])) : g("", !0)
    ], 16, uqi));
  }
}), Gqi = ["width", "height", "fill", "transform"], Eqi = { key: 0 }, Oqi = ["stroke"], Iqi = { key: 1 }, Kqi = ["stroke"], Xqi = { key: 2 }, Jqi = /* @__PURE__ */ e("path", { d: "M170.5,115.7A44,44,0,0,0,140,40H64a7.9,7.9,0,0,0-8,8V200a8,8,0,0,0,8,8h88a48,48,0,0,0,18.5-92.3ZM72,56h68a28,28,0,0,1,0,56H72Zm80,136H72V128h80a32,32,0,0,1,0,64Z" }, null, -1), Qqi = [
  Jqi
], Yqi = { key: 3 }, oGi = ["stroke"], eGi = { key: 4 }, tGi = ["stroke"], nGi = { key: 5 }, sGi = ["stroke"], rGi = {
  name: "PhTextBolder"
}, Ctl = /* @__PURE__ */ $({
  ...rGi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Eqi, [
        e("path", {
          d: "M64,120h88a40,40,0,0,1,0,80H64V48h76a36,36,0,0,1,0,72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Oqi)
      ])) : o(i) === "duotone" ? (s(), r("g", Iqi, [
        e("path", {
          d: "M64,120h88a40,40,0,0,1,0,80H64V48h76a36,36,0,0,1,0,72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kqi)
      ])) : o(i) === "fill" ? (s(), r("g", Xqi, Qqi)) : o(i) === "light" ? (s(), r("g", Yqi, [
        e("path", {
          d: "M64,120h88a40,40,0,0,1,0,80H64V48h76a36,36,0,0,1,0,72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oGi)
      ])) : o(i) === "thin" ? (s(), r("g", eGi, [
        e("path", {
          d: "M64,120h88a40,40,0,0,1,0,80H64V48h76a36,36,0,0,1,0,72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tGi)
      ])) : o(i) === "regular" ? (s(), r("g", nGi, [
        e("path", {
          d: "M64,120h88a40,40,0,0,1,0,80H64V48h76a36,36,0,0,1,0,72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sGi)
      ])) : g("", !0)
    ], 16, Gqi));
  }
}), iGi = ["width", "height", "fill", "transform"], lGi = { key: 0 }, dGi = ["stroke"], kGi = ["stroke"], cGi = ["stroke"], hGi = { key: 1 }, uGi = ["stroke"], aGi = ["stroke"], _Gi = ["stroke"], pGi = { key: 2 }, yGi = /* @__PURE__ */ e("path", { d: "M208,56V200a8,8,0,0,1-16,0V136H64v64a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v64H192V56a8,8,0,0,1,16,0Z" }, null, -1), $Gi = [
  yGi
], wGi = { key: 3 }, fGi = ["stroke"], gGi = ["stroke"], xGi = ["stroke"], jGi = { key: 4 }, mGi = ["stroke"], MGi = ["stroke"], vGi = ["stroke"], SGi = { key: 5 }, HGi = ["stroke"], AGi = ["stroke"], VGi = ["stroke"], zGi = {
  name: "PhTextH"
}, btl = /* @__PURE__ */ $({
  ...zGi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", lGi, [
        e("line", {
          x1: "56",
          y1: "56",
          x2: "56",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dGi),
        e("line", {
          x1: "200",
          y1: "128",
          x2: "56",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kGi),
        e("line", {
          x1: "200",
          y1: "56",
          x2: "200",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cGi)
      ])) : o(i) === "duotone" ? (s(), r("g", hGi, [
        e("line", {
          x1: "56",
          y1: "56",
          x2: "56",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uGi),
        e("line", {
          x1: "200",
          y1: "128",
          x2: "56",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aGi),
        e("line", {
          x1: "200",
          y1: "56",
          x2: "200",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Gi)
      ])) : o(i) === "fill" ? (s(), r("g", pGi, $Gi)) : o(i) === "light" ? (s(), r("g", wGi, [
        e("line", {
          x1: "56",
          y1: "56",
          x2: "56",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fGi),
        e("line", {
          x1: "200",
          y1: "128",
          x2: "56",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gGi),
        e("line", {
          x1: "200",
          y1: "56",
          x2: "200",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xGi)
      ])) : o(i) === "thin" ? (s(), r("g", jGi, [
        e("line", {
          x1: "56",
          y1: "56",
          x2: "56",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mGi),
        e("line", {
          x1: "200",
          y1: "128",
          x2: "56",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MGi),
        e("line", {
          x1: "200",
          y1: "56",
          x2: "200",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vGi)
      ])) : o(i) === "regular" ? (s(), r("g", SGi, [
        e("line", {
          x1: "56",
          y1: "56",
          x2: "56",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HGi),
        e("line", {
          x1: "200",
          y1: "128",
          x2: "56",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AGi),
        e("line", {
          x1: "200",
          y1: "56",
          x2: "200",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VGi)
      ])) : g("", !0)
    ], 16, iGi));
  }
}), ZGi = ["width", "height", "fill", "transform"], CGi = { key: 0 }, bGi = ["stroke"], LGi = ["stroke"], BGi = ["stroke"], PGi = ["stroke"], WGi = { key: 1 }, NGi = ["stroke"], FGi = ["stroke"], TGi = ["stroke"], DGi = ["stroke"], RGi = { key: 2 }, UGi = /* @__PURE__ */ e("path", { d: "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0Zm59.9,84a37.3,37.3,0,0,0-9.4,1.2l4.1-25.2H240a8,8,0,0,0,0-16H199.8a8,8,0,0,0-7.9,6.7l-7.8,48.2a8,8,0,0,0,13.5,7,20.1,20.1,0,0,1,14.3-5.9,19.9,19.9,0,0,1,14.2,5.9,19.8,19.8,0,0,1,0,28.2,19.9,19.9,0,0,1-14.2,5.9,20.1,20.1,0,0,1-14.3-5.9,8,8,0,1,0-11.2,11.4A36.1,36.1,0,1,0,211.9,140Z" }, null, -1), qGi = [
  UGi
], GGi = { key: 3 }, EGi = ["stroke"], OGi = ["stroke"], IGi = ["stroke"], KGi = ["stroke"], XGi = { key: 4 }, JGi = ["stroke"], QGi = ["stroke"], YGi = ["stroke"], oEi = ["stroke"], eEi = { key: 5 }, tEi = ["stroke"], nEi = ["stroke"], sEi = ["stroke"], rEi = ["stroke"], iEi = {
  name: "PhTextHFive"
}, Ltl = /* @__PURE__ */ $({
  ...iEi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", CGi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bGi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LGi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BGi),
        e("path", {
          d: "M240,108H199.8L192,156.2a28,28,0,1,1,0,39.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PGi)
      ])) : o(i) === "duotone" ? (s(), r("g", WGi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NGi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FGi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TGi),
        e("path", {
          d: "M240,108H199.8L192,156.2a28,28,0,1,1,0,39.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DGi)
      ])) : o(i) === "fill" ? (s(), r("g", RGi, qGi)) : o(i) === "light" ? (s(), r("g", GGi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, EGi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OGi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IGi),
        e("path", {
          d: "M240,108H199.8L192,156.2a28,28,0,1,1,0,39.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KGi)
      ])) : o(i) === "thin" ? (s(), r("g", XGi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, JGi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QGi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YGi),
        e("path", {
          d: "M240,108H199.8L192,156.2a28,28,0,1,1,0,39.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oEi)
      ])) : o(i) === "regular" ? (s(), r("g", eEi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tEi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nEi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sEi),
        e("path", {
          d: "M240,108H199.8L192,156.2a28,28,0,1,1,0,39.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rEi)
      ])) : g("", !0)
    ], 16, ZGi));
  }
}), lEi = ["width", "height", "fill", "transform"], dEi = { key: 0 }, kEi = ["stroke"], cEi = ["stroke"], hEi = ["stroke"], uEi = ["stroke"], aEi = ["stroke"], _Ei = { key: 1 }, pEi = ["stroke"], yEi = ["stroke"], $Ei = ["stroke"], wEi = ["stroke"], fEi = ["stroke"], gEi = { key: 2 }, xEi = /* @__PURE__ */ e("path", { d: "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0Zm84,72a8,8,0,0,0-8,8v24H199.3l20.2-57.3a8,8,0,0,0-15-5.4l-24,68a7.9,7.9,0,0,0,1,7.3A8,8,0,0,0,188,176h40v24a8,8,0,0,0,16,0V136A8,8,0,0,0,236,128Z" }, null, -1), jEi = [
  xEi
], mEi = { key: 3 }, MEi = ["stroke"], vEi = ["stroke"], SEi = ["stroke"], HEi = ["stroke"], AEi = ["stroke"], VEi = { key: 4 }, zEi = ["stroke"], ZEi = ["stroke"], CEi = ["stroke"], bEi = ["stroke"], LEi = ["stroke"], BEi = { key: 5 }, PEi = ["stroke"], WEi = ["stroke"], NEi = ["stroke"], FEi = ["stroke"], TEi = ["stroke"], DEi = {
  name: "PhTextHFour"
}, Btl = /* @__PURE__ */ $({
  ...DEi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", dEi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kEi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cEi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hEi),
        e("polyline", {
          points: "212 100 188 168 236 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uEi),
        e("line", {
          x1: "236",
          y1: "136",
          x2: "236",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aEi)
      ])) : o(i) === "duotone" ? (s(), r("g", _Ei, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pEi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yEi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $Ei),
        e("polyline", {
          points: "212 100 188 168 236 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wEi),
        e("line", {
          x1: "236",
          y1: "136",
          x2: "236",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fEi)
      ])) : o(i) === "fill" ? (s(), r("g", gEi, jEi)) : o(i) === "light" ? (s(), r("g", mEi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, MEi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vEi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, SEi),
        e("polyline", {
          points: "212 100 188 168 236 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HEi),
        e("line", {
          x1: "236",
          y1: "136",
          x2: "236",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, AEi)
      ])) : o(i) === "thin" ? (s(), r("g", VEi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zEi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZEi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CEi),
        e("polyline", {
          points: "212 100 188 168 236 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bEi),
        e("line", {
          x1: "236",
          y1: "136",
          x2: "236",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LEi)
      ])) : o(i) === "regular" ? (s(), r("g", BEi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PEi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WEi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NEi),
        e("polyline", {
          points: "212 100 188 168 236 168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FEi),
        e("line", {
          x1: "236",
          y1: "136",
          x2: "236",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TEi)
      ])) : g("", !0)
    ], 16, lEi));
  }
}), REi = ["width", "height", "fill", "transform"], UEi = { key: 0 }, qEi = ["stroke"], GEi = ["stroke"], EEi = ["stroke"], OEi = ["stroke"], IEi = { key: 1 }, KEi = ["stroke"], XEi = ["stroke"], JEi = ["stroke"], QEi = ["stroke"], YEi = { key: 2 }, oOi = /* @__PURE__ */ e("path", { d: "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0Zm71.8,44.9a8.3,8.3,0,0,0-8.2.4l-24,16a8,8,0,0,0,8.8,13.4l11.6-7.8V200a8,8,0,0,0,16,0V108A8,8,0,0,0,223.8,100.9Z" }, null, -1), eOi = [
  oOi
], tOi = { key: 3 }, nOi = ["stroke"], sOi = ["stroke"], rOi = ["stroke"], iOi = ["stroke"], lOi = { key: 4 }, dOi = ["stroke"], kOi = ["stroke"], cOi = ["stroke"], hOi = ["stroke"], uOi = { key: 5 }, aOi = ["stroke"], _Oi = ["stroke"], pOi = ["stroke"], yOi = ["stroke"], $Oi = {
  name: "PhTextHOne"
}, Ptl = /* @__PURE__ */ $({
  ...$Oi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", UEi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qEi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GEi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, EEi),
        e("polyline", {
          points: "196 124 220 108 220 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, OEi)
      ])) : o(i) === "duotone" ? (s(), r("g", IEi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KEi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XEi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JEi),
        e("polyline", {
          points: "196 124 220 108 220 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QEi)
      ])) : o(i) === "fill" ? (s(), r("g", YEi, eOi)) : o(i) === "light" ? (s(), r("g", tOi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nOi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sOi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rOi),
        e("polyline", {
          points: "196 124 220 108 220 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, iOi)
      ])) : o(i) === "thin" ? (s(), r("g", lOi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dOi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kOi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cOi),
        e("polyline", {
          points: "196 124 220 108 220 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hOi)
      ])) : o(i) === "regular" ? (s(), r("g", uOi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aOi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Oi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pOi),
        e("polyline", {
          points: "196 124 220 108 220 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yOi)
      ])) : g("", !0)
    ], 16, REi));
  }
}), wOi = ["width", "height", "fill", "transform"], fOi = { key: 0 }, gOi = ["stroke"], xOi = ["stroke"], jOi = ["stroke"], mOi = ["stroke"], MOi = ["stroke"], vOi = { key: 1 }, SOi = ["stroke"], HOi = ["stroke"], AOi = ["stroke"], VOi = ["stroke"], zOi = ["stroke"], ZOi = { key: 2 }, COi = /* @__PURE__ */ e("path", { d: "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0ZM252,168a36,36,0,1,1-67.4-17.5l.3-.6,32.2-54a8,8,0,0,1,13.8,8.2L214.2,132H216A36,36,0,0,1,252,168Zm-16,0a20,20,0,1,0-20,20A20.1,20.1,0,0,0,236,168Z" }, null, -1), bOi = [
  COi
], LOi = { key: 3 }, BOi = ["stroke"], POi = ["stroke"], WOi = ["stroke"], NOi = ["stroke"], FOi = ["stroke"], TOi = { key: 4 }, DOi = ["stroke"], ROi = ["stroke"], UOi = ["stroke"], qOi = ["stroke"], GOi = ["stroke"], EOi = { key: 5 }, OOi = ["stroke"], IOi = ["stroke"], KOi = ["stroke"], XOi = ["stroke"], JOi = ["stroke"], QOi = {
  name: "PhTextHSix"
}, Wtl = /* @__PURE__ */ $({
  ...QOi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", fOi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gOi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xOi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jOi),
        e("line", {
          x1: "191.8",
          y1: "154",
          x2: "224",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mOi),
        e("circle", {
          cx: "216",
          cy: "168",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MOi)
      ])) : o(i) === "duotone" ? (s(), r("g", vOi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SOi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HOi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AOi),
        e("line", {
          x1: "191.8",
          y1: "154",
          x2: "224",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VOi),
        e("circle", {
          cx: "216",
          cy: "168",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zOi)
      ])) : o(i) === "fill" ? (s(), r("g", ZOi, bOi)) : o(i) === "light" ? (s(), r("g", LOi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BOi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, POi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WOi),
        e("line", {
          x1: "191.8",
          y1: "154",
          x2: "224",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, NOi),
        e("circle", {
          cx: "216",
          cy: "168",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FOi)
      ])) : o(i) === "thin" ? (s(), r("g", TOi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, DOi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ROi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, UOi),
        e("line", {
          x1: "191.8",
          y1: "154",
          x2: "224",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qOi),
        e("circle", {
          cx: "216",
          cy: "168",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GOi)
      ])) : o(i) === "regular" ? (s(), r("g", EOi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OOi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IOi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KOi),
        e("line", {
          x1: "191.8",
          y1: "154",
          x2: "224",
          y2: "100",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XOi),
        e("circle", {
          cx: "216",
          cy: "168",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JOi)
      ])) : g("", !0)
    ], 16, wOi));
  }
}), YOi = ["width", "height", "fill", "transform"], oIi = { key: 0 }, eIi = ["stroke"], tIi = ["stroke"], nIi = ["stroke"], sIi = ["stroke"], rIi = { key: 1 }, iIi = ["stroke"], lIi = ["stroke"], dIi = ["stroke"], kIi = ["stroke"], cIi = { key: 2 }, hIi = /* @__PURE__ */ e("path", { d: "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0Zm85.5,94.5a37.9,37.9,0,0,0-12-7.9l21.1-30a8,8,0,0,0,.5-8.3A8.1,8.1,0,0,0,240,100H192a8,8,0,0,0,0,16h32.6l-19.2,27.4a8,8,0,0,0-.5,8.3A8.1,8.1,0,0,0,212,156a20,20,0,1,1-14.1,34.1,8.1,8.1,0,0,0-11.4,11.4,36.1,36.1,0,0,0,51-51Z" }, null, -1), uIi = [
  hIi
], aIi = { key: 3 }, _Ii = ["stroke"], pIi = ["stroke"], yIi = ["stroke"], $Ii = ["stroke"], wIi = { key: 4 }, fIi = ["stroke"], gIi = ["stroke"], xIi = ["stroke"], jIi = ["stroke"], mIi = { key: 5 }, MIi = ["stroke"], vIi = ["stroke"], SIi = ["stroke"], HIi = ["stroke"], AIi = {
  name: "PhTextHThree"
}, Ntl = /* @__PURE__ */ $({
  ...AIi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", oIi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eIi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tIi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nIi),
        e("path", {
          d: "M192,108h48l-28,40a28,28,0,1,1-19.8,47.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sIi)
      ])) : o(i) === "duotone" ? (s(), r("g", rIi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iIi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lIi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dIi),
        e("path", {
          d: "M192,108h48l-28,40a28,28,0,1,1-19.8,47.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kIi)
      ])) : o(i) === "fill" ? (s(), r("g", cIi, uIi)) : o(i) === "light" ? (s(), r("g", aIi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _Ii),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pIi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yIi),
        e("path", {
          d: "M192,108h48l-28,40a28,28,0,1,1-19.8,47.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $Ii)
      ])) : o(i) === "thin" ? (s(), r("g", wIi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fIi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gIi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xIi),
        e("path", {
          d: "M192,108h48l-28,40a28,28,0,1,1-19.8,47.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jIi)
      ])) : o(i) === "regular" ? (s(), r("g", mIi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MIi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vIi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SIi),
        e("path", {
          d: "M192,108h48l-28,40a28,28,0,1,1-19.8,47.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HIi)
      ])) : g("", !0)
    ], 16, YOi));
  }
}), VIi = ["width", "height", "fill", "transform"], zIi = { key: 0 }, ZIi = ["stroke"], CIi = ["stroke"], bIi = ["stroke"], LIi = ["stroke"], BIi = { key: 1 }, PIi = ["stroke"], WIi = ["stroke"], NIi = ["stroke"], FIi = ["stroke"], TIi = { key: 2 }, DIi = /* @__PURE__ */ e("path", { d: "M152,56V176a8,8,0,0,1-16,0V124H48v52a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0v52h88V56a8,8,0,0,1,16,0Zm88,136H208l34.3-45.8.2-.3A31.8,31.8,0,0,0,248,128a32,32,0,0,0-61.5-12.5,8,8,0,0,0,14.8,6.3A15.9,15.9,0,0,1,216,112a16,16,0,0,1,13.4,24.8l-43.7,58.3A7.5,7.5,0,0,0,184,200a8,8,0,0,0,5.5,7.6,7.3,7.3,0,0,0,2.5.4h48a8,8,0,0,0,0-16Z" }, null, -1), RIi = [
  DIi
], UIi = { key: 3 }, qIi = ["stroke"], GIi = ["stroke"], EIi = ["stroke"], OIi = ["stroke"], IIi = { key: 4 }, KIi = ["stroke"], XIi = ["stroke"], JIi = ["stroke"], QIi = ["stroke"], YIi = { key: 5 }, oKi = ["stroke"], eKi = ["stroke"], tKi = ["stroke"], nKi = ["stroke"], sKi = {
  name: "PhTextHTwo"
}, Ftl = /* @__PURE__ */ $({
  ...sKi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", zIi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZIi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CIi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bIi),
        e("path", {
          d: "M193.9,118.7A24,24,0,0,1,240,128a23.6,23.6,0,0,1-4.1,13.4h0L192,200h48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LIi)
      ])) : o(i) === "duotone" ? (s(), r("g", BIi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PIi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WIi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NIi),
        e("path", {
          d: "M193.9,118.7A24,24,0,0,1,240,128a23.6,23.6,0,0,1-4.1,13.4h0L192,200h48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FIi)
      ])) : o(i) === "fill" ? (s(), r("g", TIi, RIi)) : o(i) === "light" ? (s(), r("g", UIi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qIi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GIi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, EIi),
        e("path", {
          d: "M193.9,118.7A24,24,0,0,1,240,128a23.6,23.6,0,0,1-4.1,13.4h0L192,200h48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OIi)
      ])) : o(i) === "thin" ? (s(), r("g", IIi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KIi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XIi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, JIi),
        e("path", {
          d: "M193.9,118.7A24,24,0,0,1,240,128a23.6,23.6,0,0,1-4.1,13.4h0L192,200h48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QIi)
      ])) : o(i) === "regular" ? (s(), r("g", YIi, [
        e("line", {
          x1: "40",
          y1: "56",
          x2: "40",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oKi),
        e("line", {
          x1: "144",
          y1: "116",
          x2: "40",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eKi),
        e("line", {
          x1: "144",
          y1: "56",
          x2: "144",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tKi),
        e("path", {
          d: "M193.9,118.7A24,24,0,0,1,240,128a23.6,23.6,0,0,1-4.1,13.4h0L192,200h48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nKi)
      ])) : g("", !0)
    ], 16, VIi));
  }
}), rKi = ["width", "height", "fill", "transform"], iKi = { key: 0 }, lKi = ["stroke"], dKi = ["stroke"], kKi = ["stroke"], cKi = ["stroke"], hKi = { key: 1 }, uKi = ["stroke"], aKi = ["stroke"], _Ki = ["stroke"], pKi = ["stroke"], yKi = { key: 2 }, $Ki = /* @__PURE__ */ e("path", { d: "M224,128a8,8,0,0,1-8,8H120a8,8,0,0,1,0-16h96A8,8,0,0,1,224,128ZM120,72h96a8,8,0,0,0,0-16H120a8,8,0,0,0,0,16Zm96,112H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM36.9,143.4a8.5,8.5,0,0,0,3.1.6,8.3,8.3,0,0,0,5.7-2.3l40-40a8.1,8.1,0,0,0,0-11.4l-40-40a8.4,8.4,0,0,0-8.8-1.7A8,8,0,0,0,32,56v80A8,8,0,0,0,36.9,143.4Z" }, null, -1), wKi = [
  $Ki
], fKi = { key: 3 }, gKi = ["stroke"], xKi = ["stroke"], jKi = ["stroke"], mKi = ["stroke"], MKi = { key: 4 }, vKi = ["stroke"], SKi = ["stroke"], HKi = ["stroke"], AKi = ["stroke"], VKi = { key: 5 }, zKi = ["stroke"], ZKi = ["stroke"], CKi = ["stroke"], bKi = ["stroke"], LKi = {
  name: "PhTextIndent"
}, Ttl = /* @__PURE__ */ $({
  ...LKi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", iKi, [
        e("line", {
          x1: "120",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lKi),
        e("line", {
          x1: "120",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dKi),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kKi),
        e("polyline", {
          points: "40 56 80 96 40 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cKi)
      ])) : o(i) === "duotone" ? (s(), r("g", hKi, [
        e("line", {
          x1: "112",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uKi),
        e("line", {
          x1: "112",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aKi),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Ki),
        e("polyline", {
          points: "40 56 80 96 40 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pKi)
      ])) : o(i) === "fill" ? (s(), r("g", yKi, wKi)) : o(i) === "light" ? (s(), r("g", fKi, [
        e("line", {
          x1: "112",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gKi),
        e("line", {
          x1: "112",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xKi),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jKi),
        e("polyline", {
          points: "40 56 80 96 40 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mKi)
      ])) : o(i) === "thin" ? (s(), r("g", MKi, [
        e("line", {
          x1: "112",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vKi),
        e("line", {
          x1: "112",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SKi),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HKi),
        e("polyline", {
          points: "40 56 80 96 40 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, AKi)
      ])) : o(i) === "regular" ? (s(), r("g", VKi, [
        e("line", {
          x1: "112",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zKi),
        e("line", {
          x1: "112",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZKi),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CKi),
        e("polyline", {
          points: "40 56 80 96 40 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bKi)
      ])) : g("", !0)
    ], 16, rKi));
  }
}), BKi = ["width", "height", "fill", "transform"], PKi = { key: 0 }, WKi = ["stroke"], NKi = ["stroke"], FKi = ["stroke"], TKi = { key: 1 }, DKi = ["stroke"], RKi = ["stroke"], UKi = ["stroke"], qKi = { key: 2 }, GKi = /* @__PURE__ */ e("path", { d: "M200,56a8,8,0,0,1-8,8H157.8L115.1,192H144a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16H98.2L140.9,64H112a8,8,0,0,1,0-16h80A8,8,0,0,1,200,56Z" }, null, -1), EKi = [
  GKi
], OKi = { key: 3 }, IKi = ["stroke"], KKi = ["stroke"], XKi = ["stroke"], JKi = { key: 4 }, QKi = ["stroke"], YKi = ["stroke"], oXi = ["stroke"], eXi = { key: 5 }, tXi = ["stroke"], nXi = ["stroke"], sXi = ["stroke"], rXi = {
  name: "PhTextItalic"
}, Dtl = /* @__PURE__ */ $({
  ...rXi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", PKi, [
        e("line", {
          x1: "152",
          y1: "56",
          x2: "104",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WKi),
        e("line", {
          x1: "64",
          y1: "200",
          x2: "144",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NKi),
        e("line", {
          x1: "112",
          y1: "56",
          x2: "192",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FKi)
      ])) : o(i) === "duotone" ? (s(), r("g", TKi, [
        e("line", {
          x1: "152",
          y1: "56",
          x2: "104",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DKi),
        e("line", {
          x1: "64",
          y1: "200",
          x2: "144",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RKi),
        e("line", {
          x1: "112",
          y1: "56",
          x2: "192",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UKi)
      ])) : o(i) === "fill" ? (s(), r("g", qKi, EKi)) : o(i) === "light" ? (s(), r("g", OKi, [
        e("line", {
          x1: "152",
          y1: "56",
          x2: "104",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IKi),
        e("line", {
          x1: "64",
          y1: "200",
          x2: "144",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KKi),
        e("line", {
          x1: "112",
          y1: "56",
          x2: "192",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XKi)
      ])) : o(i) === "thin" ? (s(), r("g", JKi, [
        e("line", {
          x1: "152",
          y1: "56",
          x2: "104",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QKi),
        e("line", {
          x1: "64",
          y1: "200",
          x2: "144",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YKi),
        e("line", {
          x1: "112",
          y1: "56",
          x2: "192",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oXi)
      ])) : o(i) === "regular" ? (s(), r("g", eXi, [
        e("line", {
          x1: "152",
          y1: "56",
          x2: "104",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tXi),
        e("line", {
          x1: "64",
          y1: "200",
          x2: "144",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nXi),
        e("line", {
          x1: "112",
          y1: "56",
          x2: "192",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sXi)
      ])) : g("", !0)
    ], 16, BKi));
  }
}), iXi = ["width", "height", "fill", "transform"], lXi = { key: 0 }, dXi = ["stroke"], kXi = ["stroke"], cXi = ["stroke"], hXi = ["stroke"], uXi = { key: 1 }, aXi = ["stroke"], _Xi = ["stroke"], pXi = ["stroke"], yXi = ["stroke"], $Xi = { key: 2 }, wXi = /* @__PURE__ */ e("path", { d: "M224,128a8,8,0,0,1-8,8H120a8,8,0,0,1,0-16h96A8,8,0,0,1,224,128ZM120,72h96a8,8,0,0,0,0-16H120a8,8,0,0,0,0,16Zm96,112H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM72,144a8.5,8.5,0,0,0,3.1-.6A8,8,0,0,0,80,136V56a8,8,0,0,0-4.9-7.4,8.4,8.4,0,0,0-8.8,1.7l-40,40a8.1,8.1,0,0,0,0,11.4l40,40A8.3,8.3,0,0,0,72,144Z" }, null, -1), fXi = [
  wXi
], gXi = { key: 3 }, xXi = ["stroke"], jXi = ["stroke"], mXi = ["stroke"], MXi = ["stroke"], vXi = { key: 4 }, SXi = ["stroke"], HXi = ["stroke"], AXi = ["stroke"], VXi = ["stroke"], zXi = { key: 5 }, ZXi = ["stroke"], CXi = ["stroke"], bXi = ["stroke"], LXi = ["stroke"], BXi = {
  name: "PhTextOutdent"
}, Rtl = /* @__PURE__ */ $({
  ...BXi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", lXi, [
        e("line", {
          x1: "120",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dXi),
        e("line", {
          x1: "120",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kXi),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cXi),
        e("polyline", {
          points: "72 56 32 96 72 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hXi)
      ])) : o(i) === "duotone" ? (s(), r("g", uXi, [
        e("line", {
          x1: "112",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aXi),
        e("line", {
          x1: "112",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Xi),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pXi),
        e("polyline", {
          points: "72 56 32 96 72 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yXi)
      ])) : o(i) === "fill" ? (s(), r("g", $Xi, fXi)) : o(i) === "light" ? (s(), r("g", gXi, [
        e("line", {
          x1: "112",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xXi),
        e("line", {
          x1: "112",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jXi),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mXi),
        e("polyline", {
          points: "72 56 32 96 72 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, MXi)
      ])) : o(i) === "thin" ? (s(), r("g", vXi, [
        e("line", {
          x1: "112",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SXi),
        e("line", {
          x1: "112",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, HXi),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, AXi),
        e("polyline", {
          points: "72 56 32 96 72 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VXi)
      ])) : o(i) === "regular" ? (s(), r("g", zXi, [
        e("line", {
          x1: "112",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZXi),
        e("line", {
          x1: "112",
          y1: "64",
          x2: "216",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CXi),
        e("line", {
          x1: "40",
          y1: "192",
          x2: "216",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bXi),
        e("polyline", {
          points: "72 56 32 96 72 136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LXi)
      ])) : g("", !0)
    ], 16, iXi));
  }
}), PXi = ["width", "height", "fill", "transform"], WXi = { key: 0 }, NXi = ["stroke"], FXi = ["stroke"], TXi = ["stroke"], DXi = { key: 1 }, RXi = ["stroke"], UXi = ["stroke"], qXi = ["stroke"], GXi = { key: 2 }, EXi = /* @__PURE__ */ e("path", { d: "M224,128a8,8,0,0,1-8,8H175.9c9.2,7.1,16.1,17.2,16.1,32s-7,25.7-19.8,34.8S144.6,216,128,216s-32.3-4.7-44.2-13.2S64,181.3,64,168a8,8,0,0,1,16,0c0,17.3,22,32,48,32s48-14.7,48-32c0-14.9-10.5-23.6-38.8-32H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM76.3,104a6.9,6.9,0,0,0,2.5-.4,8,8,0,0,0,5.1-10.1,19.2,19.2,0,0,1-.8-5.5c0-18.2,19.3-32,44.9-32,19.5,0,36.1,8.3,42.3,21A8.1,8.1,0,0,0,181,80.7,7.9,7.9,0,0,0,184.7,70c-9-18.5-30.7-30-56.7-30C93.3,40,67.1,60.6,67.1,88a36,36,0,0,0,1.6,10.5A8,8,0,0,0,76.3,104Z" }, null, -1), OXi = [
  EXi
], IXi = { key: 3 }, KXi = ["stroke"], XXi = ["stroke"], JXi = ["stroke"], QXi = { key: 4 }, YXi = ["stroke"], oJi = ["stroke"], eJi = ["stroke"], tJi = { key: 5 }, nJi = ["stroke"], sJi = ["stroke"], rJi = ["stroke"], iJi = {
  name: "PhTextStrikethrough"
}, Utl = /* @__PURE__ */ $({
  ...iJi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", WXi, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NXi),
        e("path", {
          d: "M75.1,88c0-22.1,22-40,52.9-40,23.8,0,42.3,10.6,49.5,25.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FXi),
        e("path", {
          d: "M72,168c0,22.1,25.1,40,56,40s56-17.9,56-40c0-23.8-21.6-33-45.6-40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TXi)
      ])) : o(i) === "duotone" ? (s(), r("g", DXi, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RXi),
        e("path", {
          d: "M76.3,96a25.3,25.3,0,0,1-1.2-8c0-22.1,22-40,52.9-40,23.8,0,42.3,10.6,49.5,25.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UXi),
        e("path", {
          d: "M72,168c0,22.1,25.1,40,56,40s56-17.9,56-40c0-23.8-21.6-33-45.6-40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qXi)
      ])) : o(i) === "fill" ? (s(), r("g", GXi, OXi)) : o(i) === "light" ? (s(), r("g", IXi, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KXi),
        e("path", {
          d: "M76.3,96a25.3,25.3,0,0,1-1.2-8c0-22.1,22-40,52.9-40,23.8,0,42.3,10.6,49.5,25.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XXi),
        e("path", {
          d: "M72,168c0,22.1,25.1,40,56,40s56-17.9,56-40c0-23.8-21.6-33-45.6-40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JXi)
      ])) : o(i) === "thin" ? (s(), r("g", QXi, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YXi),
        e("path", {
          d: "M76.3,96a25.3,25.3,0,0,1-1.2-8c0-22.1,22-40,52.9-40,23.8,0,42.3,10.6,49.5,25.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oJi),
        e("path", {
          d: "M72,168c0,22.1,25.1,40,56,40s56-17.9,56-40c0-23.8-21.6-33-45.6-40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eJi)
      ])) : o(i) === "regular" ? (s(), r("g", tJi, [
        e("line", {
          x1: "40",
          y1: "128",
          x2: "216",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nJi),
        e("path", {
          d: "M76.3,96a25.3,25.3,0,0,1-1.2-8c0-22.1,22-40,52.9-40,23.8,0,42.3,10.6,49.5,25.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sJi),
        e("path", {
          d: "M72,168c0,22.1,25.1,40,56,40s56-17.9,56-40c0-23.8-21.6-33-45.6-40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rJi)
      ])) : g("", !0)
    ], 16, PXi));
  }
}), lJi = ["width", "height", "fill", "transform"], dJi = { key: 0 }, kJi = ["stroke"], cJi = ["stroke"], hJi = ["stroke"], uJi = { key: 1 }, aJi = ["stroke"], _Ji = ["stroke"], pJi = ["stroke"], yJi = { key: 2 }, $Ji = /* @__PURE__ */ e("path", { d: "M208,48H48a8,8,0,0,0-8,8V88a8,8,0,0,0,16,0V64h64V192H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V64h64V88a8,8,0,0,0,16,0V56A8,8,0,0,0,208,48Z" }, null, -1), wJi = [
  $Ji
], fJi = { key: 3 }, gJi = ["stroke"], xJi = ["stroke"], jJi = ["stroke"], mJi = { key: 4 }, MJi = ["stroke"], vJi = ["stroke"], SJi = ["stroke"], HJi = { key: 5 }, AJi = ["stroke"], VJi = ["stroke"], zJi = ["stroke"], ZJi = {
  name: "PhTextT"
}, qtl = /* @__PURE__ */ $({
  ...ZJi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", dJi, [
        e("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, kJi),
        e("polyline", {
          points: "48 88 48 56 208 56 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cJi),
        e("line", {
          x1: "96",
          y1: "200",
          x2: "160",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hJi)
      ])) : o(i) === "duotone" ? (s(), r("g", uJi, [
        e("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aJi),
        e("polyline", {
          points: "48 88 48 56 208 56 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _Ji),
        e("line", {
          x1: "96",
          y1: "200",
          x2: "160",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pJi)
      ])) : o(i) === "fill" ? (s(), r("g", yJi, wJi)) : o(i) === "light" ? (s(), r("g", fJi, [
        e("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gJi),
        e("polyline", {
          points: "48 88 48 56 208 56 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xJi),
        e("line", {
          x1: "96",
          y1: "200",
          x2: "160",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jJi)
      ])) : o(i) === "thin" ? (s(), r("g", mJi, [
        e("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MJi),
        e("polyline", {
          points: "48 88 48 56 208 56 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vJi),
        e("line", {
          x1: "96",
          y1: "200",
          x2: "160",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SJi)
      ])) : o(i) === "regular" ? (s(), r("g", HJi, [
        e("line", {
          x1: "128",
          y1: "56",
          x2: "128",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AJi),
        e("polyline", {
          points: "48 88 48 56 208 56 208 88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VJi),
        e("line", {
          x1: "96",
          y1: "200",
          x2: "160",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zJi)
      ])) : g("", !0)
    ], 16, lJi));
  }
}), CJi = ["width", "height", "fill", "transform"], bJi = { key: 0 }, LJi = ["stroke"], BJi = ["stroke"], PJi = { key: 1 }, WJi = ["stroke"], NJi = ["stroke"], FJi = { key: 2 }, TJi = /* @__PURE__ */ e("path", { d: "M224,216a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,216Zm-96-24a72.1,72.1,0,0,0,72-72V56a8,8,0,0,0-16,0v64a56,56,0,0,1-112,0V56a8,8,0,0,0-16,0v64A72.1,72.1,0,0,0,128,192Z" }, null, -1), DJi = [
  TJi
], RJi = { key: 3 }, UJi = ["stroke"], qJi = ["stroke"], GJi = { key: 4 }, EJi = ["stroke"], OJi = ["stroke"], IJi = { key: 5 }, KJi = ["stroke"], XJi = ["stroke"], JJi = {
  name: "PhTextUnderline"
}, Gtl = /* @__PURE__ */ $({
  ...JJi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", bJi, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LJi),
        e("path", {
          d: "M64,56v60a64,64,0,0,0,128,0V56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BJi)
      ])) : o(i) === "duotone" ? (s(), r("g", PJi, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WJi),
        e("path", {
          d: "M64,56v64a64,64,0,0,0,128,0V56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NJi)
      ])) : o(i) === "fill" ? (s(), r("g", FJi, DJi)) : o(i) === "light" ? (s(), r("g", RJi, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, UJi),
        e("path", {
          d: "M64,56v64a64,64,0,0,0,128,0V56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qJi)
      ])) : o(i) === "thin" ? (s(), r("g", GJi, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, EJi),
        e("path", {
          d: "M64,56v64a64,64,0,0,0,128,0V56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OJi)
      ])) : o(i) === "regular" ? (s(), r("g", IJi, [
        e("line", {
          x1: "40",
          y1: "216",
          x2: "216",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KJi),
        e("path", {
          d: "M64,56v64a64,64,0,0,0,128,0V56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XJi)
      ])) : g("", !0)
    ], 16, CJi));
  }
}), QJi = ["width", "height", "fill", "transform"], YJi = { key: 0 }, oQi = ["stroke"], eQi = ["stroke"], tQi = ["stroke"], nQi = ["stroke"], sQi = ["stroke"], rQi = { key: 1 }, iQi = /* @__PURE__ */ e("rect", {
  x: "16",
  y: "72",
  width: "224",
  height: "112",
  rx: "8",
  opacity: "0.2"
}, null, -1), lQi = ["stroke"], dQi = ["stroke"], kQi = ["stroke"], cQi = ["stroke"], hQi = ["stroke"], uQi = { key: 2 }, aQi = /* @__PURE__ */ e("path", { d: "M248,80v96a16,16,0,0,1-16,16H144a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8h88A16,16,0,0,1,248,80ZM120,48V208a8,8,0,0,1-16,0V192H24A16,16,0,0,1,8,176V80A16,16,0,0,1,24,64h80V48a8,8,0,0,1,16,0ZM86,112a8,8,0,0,0-8-8H50a8,8,0,0,0,0,16h6v28a8,8,0,0,0,16,0V120h6A8,8,0,0,0,86,112Z" }, null, -1), _Qi = [
  aQi
], pQi = { key: 3 }, yQi = ["stroke"], $Qi = ["stroke"], wQi = ["stroke"], fQi = ["stroke"], gQi = ["stroke"], xQi = { key: 4 }, jQi = ["stroke"], mQi = ["stroke"], MQi = ["stroke"], vQi = ["stroke"], SQi = ["stroke"], HQi = { key: 5 }, AQi = ["stroke"], VQi = ["stroke"], zQi = ["stroke"], ZQi = ["stroke"], CQi = ["stroke"], bQi = {
  name: "PhTextbox"
}, Etl = /* @__PURE__ */ $({
  ...bQi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", YJi, [
        e("line", {
          x1: "112",
          y1: "48",
          x2: "112",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oQi),
        e("path", {
          d: "M152,72h80a8,8,0,0,1,8,8v96a8,8,0,0,1-8,8H152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eQi),
        e("path", {
          d: "M112,184H24a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tQi),
        e("line", {
          x1: "50",
          y1: "112",
          x2: "78",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nQi),
        e("line", {
          x1: "64",
          y1: "112",
          x2: "64",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sQi)
      ])) : o(i) === "duotone" ? (s(), r("g", rQi, [
        iQi,
        e("line", {
          x1: "112",
          y1: "48",
          x2: "112",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lQi),
        e("path", {
          d: "M144,72h88a8,8,0,0,1,8,8v96a8,8,0,0,1-8,8H144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dQi),
        e("path", {
          d: "M112,184H24a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kQi),
        e("line", {
          x1: "50",
          y1: "112",
          x2: "78",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cQi),
        e("line", {
          x1: "64",
          y1: "112",
          x2: "64",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hQi)
      ])) : o(i) === "fill" ? (s(), r("g", uQi, _Qi)) : o(i) === "light" ? (s(), r("g", pQi, [
        e("line", {
          x1: "112",
          y1: "48",
          x2: "112",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yQi),
        e("path", {
          d: "M144,72h88a8,8,0,0,1,8,8v96a8,8,0,0,1-8,8H144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $Qi),
        e("path", {
          d: "M112,184H24a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wQi),
        e("line", {
          x1: "50",
          y1: "112",
          x2: "78",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fQi),
        e("line", {
          x1: "64",
          y1: "112",
          x2: "64",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gQi)
      ])) : o(i) === "thin" ? (s(), r("g", xQi, [
        e("line", {
          x1: "112",
          y1: "48",
          x2: "112",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jQi),
        e("path", {
          d: "M144,72h88a8,8,0,0,1,8,8v96a8,8,0,0,1-8,8H144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mQi),
        e("path", {
          d: "M112,184H24a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MQi),
        e("line", {
          x1: "50",
          y1: "112",
          x2: "78",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vQi),
        e("line", {
          x1: "64",
          y1: "112",
          x2: "64",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SQi)
      ])) : o(i) === "regular" ? (s(), r("g", HQi, [
        e("line", {
          x1: "112",
          y1: "48",
          x2: "112",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AQi),
        e("path", {
          d: "M144,72h88a8,8,0,0,1,8,8v96a8,8,0,0,1-8,8H144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VQi),
        e("path", {
          d: "M112,184H24a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zQi),
        e("line", {
          x1: "50",
          y1: "112",
          x2: "78",
          y2: "112",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZQi),
        e("line", {
          x1: "64",
          y1: "112",
          x2: "64",
          y2: "148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CQi)
      ])) : g("", !0)
    ], 16, QJi));
  }
}), LQi = ["width", "height", "fill", "transform"], BQi = { key: 0 }, PQi = ["stroke"], WQi = ["stroke"], NQi = ["stroke"], FQi = ["stroke"], TQi = { key: 1 }, DQi = ["stroke"], RQi = ["stroke"], UQi = ["stroke"], qQi = /* @__PURE__ */ e("path", {
  d: "M152,147h0V48a32,32,0,0,0-64,0v99h0a52,52,0,1,0,64,0Zm-32,61a20,20,0,1,1,20-20A20.1,20.1,0,0,1,120,208Z",
  opacity: "0.2"
}, null, -1), GQi = ["stroke"], EQi = { key: 2 }, OQi = /* @__PURE__ */ e("path", { d: "M212,52a28,28,0,1,0,28,28A28.1,28.1,0,0,0,212,52Zm0,40a12,12,0,1,1,12-12A12,12,0,0,1,212,92Zm-52,51.3V48a40,40,0,0,0-80,0v95.3A59.4,59.4,0,0,0,60,188a60,60,0,0,0,120,0A59.4,59.4,0,0,0,160,143.3ZM120,24a24.1,24.1,0,0,1,24,24V80H96V48A24.1,24.1,0,0,1,120,24Z" }, null, -1), IQi = [
  OQi
], KQi = { key: 3 }, XQi = ["stroke"], JQi = ["stroke"], QQi = ["stroke"], YQi = ["stroke"], oYi = { key: 4 }, eYi = ["stroke"], tYi = ["stroke"], nYi = ["stroke"], sYi = ["stroke"], rYi = { key: 5 }, iYi = ["stroke"], lYi = ["stroke"], dYi = ["stroke"], kYi = ["stroke"], cYi = {
  name: "PhThermometer"
}, Otl = /* @__PURE__ */ $({
  ...cYi,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", BQi, [
        e("circle", {
          cx: "216",
          cy: "80",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, PQi),
        e("circle", {
          cx: "108",
          cy: "188",
          r: "12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, WQi),
        e("line", {
          x1: "108",
          y1: "168",
          x2: "108",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, NQi),
        e("path", {
          d: "M68,154.8V56a40,40,0,0,1,80,0v98.8h0a52,52,0,1,1-80,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FQi)
      ])) : o(i) === "duotone" ? (s(), r("g", TQi, [
        e("circle", {
          cx: "212",
          cy: "80",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, DQi),
        e("path", {
          d: "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RQi),
        e("circle", {
          cx: "120",
          cy: "188",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UQi),
        qQi,
        e("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GQi)
      ])) : o(i) === "fill" ? (s(), r("g", EQi, IQi)) : o(i) === "light" ? (s(), r("g", KQi, [
        e("circle", {
          cx: "212",
          cy: "80",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XQi),
        e("path", {
          d: "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JQi),
        e("circle", {
          cx: "120",
          cy: "188",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QQi),
        e("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YQi)
      ])) : o(i) === "thin" ? (s(), r("g", oYi, [
        e("circle", {
          cx: "212",
          cy: "80",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eYi),
        e("path", {
          d: "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tYi),
        e("circle", {
          cx: "120",
          cy: "188",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nYi),
        e("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sYi)
      ])) : o(i) === "regular" ? (s(), r("g", rYi, [
        e("circle", {
          cx: "212",
          cy: "80",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iYi),
        e("path", {
          d: "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lYi),
        e("circle", {
          cx: "120",
          cy: "188",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dYi),
        e("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kYi)
      ])) : g("", !0)
    ], 16, LQi));
  }
}), hYi = ["width", "height", "fill", "transform"], uYi = { key: 0 }, aYi = ["stroke"], _Yi = ["stroke"], pYi = ["stroke"], yYi = ["stroke"], $Yi = ["stroke"], wYi = ["stroke"], fYi = ["stroke"], gYi = ["stroke"], xYi = { key: 1 }, jYi = ["stroke"], mYi = ["stroke"], MYi = ["stroke"], vYi = ["stroke"], SYi = ["stroke"], HYi = ["stroke"], AYi = ["stroke"], VYi = ["stroke"], zYi = /* @__PURE__ */ e("path", {
  d: "M152,147h0V48a32,32,0,0,0-64,0v99h0a52,52,0,1,0,64,0Zm-32,61a20,20,0,1,1,20-20A20.1,20.1,0,0,1,120,208Z",
  opacity: "0.2"
}, null, -1), ZYi = { key: 2 }, CYi = /* @__PURE__ */ e("path", { d: "M244.9,77.7l-20,6.5,12.4,17a8,8,0,0,1-1.8,11.2,8.1,8.1,0,0,1-11.2-1.8L212,93.6l-12.3,17a8.1,8.1,0,0,1-11.2,1.8,8,8,0,0,1-1.8-11.2l12.4-17-20-6.5A7.9,7.9,0,0,1,174,67.6a7.8,7.8,0,0,1,10-5.1L204,69V48a8,8,0,0,1,16,0V69l20-6.5a7.8,7.8,0,0,1,10,5.1A7.9,7.9,0,0,1,244.9,77.7ZM180,188a60,60,0,0,1-120,0,59.4,59.4,0,0,1,20-44.7V48a40,40,0,0,1,80,0v95.3A59.4,59.4,0,0,1,180,188ZM96,48v56h48V48a24,24,0,0,0-48,0Z" }, null, -1), bYi = [
  CYi
], LYi = { key: 3 }, BYi = ["stroke"], PYi = ["stroke"], WYi = ["stroke"], NYi = ["stroke"], FYi = ["stroke"], TYi = ["stroke"], DYi = ["stroke"], RYi = ["stroke"], UYi = { key: 4 }, qYi = ["stroke"], GYi = ["stroke"], EYi = ["stroke"], OYi = ["stroke"], IYi = ["stroke"], KYi = ["stroke"], XYi = ["stroke"], JYi = ["stroke"], QYi = { key: 5 }, YYi = ["stroke"], oo1 = ["stroke"], eo1 = ["stroke"], to1 = ["stroke"], no1 = ["stroke"], so1 = ["stroke"], ro1 = ["stroke"], io1 = ["stroke"], lo1 = {
  name: "PhThermometerCold"
}, Itl = /* @__PURE__ */ $({
  ...lo1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", uYi, [
        e("circle", {
          cx: "108",
          cy: "188",
          r: "12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aYi),
        e("line", {
          x1: "108",
          y1: "176",
          x2: "108",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Yi),
        e("line", {
          x1: "212",
          y1: "48",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pYi),
        e("line", {
          x1: "181.6",
          y1: "70.1",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yYi),
        e("line", {
          x1: "193.2",
          y1: "105.9",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $Yi),
        e("line", {
          x1: "230.8",
          y1: "105.9",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wYi),
        e("line", {
          x1: "242.4",
          y1: "70.1",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fYi),
        e("path", {
          d: "M68,154.8V56a40,40,0,0,1,80,0v98.8h0a52,52,0,1,1-80,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gYi)
      ])) : o(i) === "duotone" ? (s(), r("g", xYi, [
        e("line", {
          x1: "212",
          y1: "48",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jYi),
        e("line", {
          x1: "181.6",
          y1: "70.1",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mYi),
        e("line", {
          x1: "193.2",
          y1: "105.9",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MYi),
        e("line", {
          x1: "230.8",
          y1: "105.9",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vYi),
        e("line", {
          x1: "242.4",
          y1: "70.1",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SYi),
        e("circle", {
          cx: "120",
          cy: "188",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HYi),
        e("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AYi),
        e("path", {
          d: "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VYi),
        zYi
      ])) : o(i) === "fill" ? (s(), r("g", ZYi, bYi)) : o(i) === "light" ? (s(), r("g", LYi, [
        e("circle", {
          cx: "120",
          cy: "188",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, BYi),
        e("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, PYi),
        e("line", {
          x1: "212",
          y1: "48",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, WYi),
        e("line", {
          x1: "181.6",
          y1: "70.1",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, NYi),
        e("line", {
          x1: "193.2",
          y1: "105.9",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FYi),
        e("line", {
          x1: "230.8",
          y1: "105.9",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TYi),
        e("line", {
          x1: "242.4",
          y1: "70.1",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DYi),
        e("path", {
          d: "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RYi)
      ])) : o(i) === "thin" ? (s(), r("g", UYi, [
        e("circle", {
          cx: "120",
          cy: "188",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qYi),
        e("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GYi),
        e("line", {
          x1: "212",
          y1: "48",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, EYi),
        e("line", {
          x1: "181.6",
          y1: "70.1",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OYi),
        e("line", {
          x1: "193.2",
          y1: "105.9",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, IYi),
        e("line", {
          x1: "230.8",
          y1: "105.9",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KYi),
        e("line", {
          x1: "242.4",
          y1: "70.1",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XYi),
        e("path", {
          d: "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, JYi)
      ])) : o(i) === "regular" ? (s(), r("g", QYi, [
        e("circle", {
          cx: "120",
          cy: "188",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YYi),
        e("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oo1),
        e("line", {
          x1: "212",
          y1: "48",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eo1),
        e("line", {
          x1: "181.6",
          y1: "70.1",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, to1),
        e("line", {
          x1: "193.2",
          y1: "105.9",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, no1),
        e("line", {
          x1: "230.8",
          y1: "105.9",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, so1),
        e("line", {
          x1: "242.4",
          y1: "70.1",
          x2: "212",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ro1),
        e("path", {
          d: "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, io1)
      ])) : g("", !0)
    ], 16, hYi));
  }
}), do1 = ["width", "height", "fill", "transform"], ko1 = { key: 0 }, co1 = ["stroke"], ho1 = ["stroke"], uo1 = ["stroke"], ao1 = ["stroke"], _o1 = ["stroke"], po1 = { key: 1 }, yo1 = ["stroke"], $o1 = ["stroke"], wo1 = ["stroke"], fo1 = ["stroke"], go1 = ["stroke"], xo1 = /* @__PURE__ */ e("path", {
  d: "M152,147h0V48a32,32,0,0,0-64,0v99h0a52,52,0,1,0,64,0Zm-32,61a20,20,0,1,1,20-20A20.1,20.1,0,0,1,120,208Z",
  opacity: "0.2"
}, null, -1), jo1 = { key: 2 }, mo1 = /* @__PURE__ */ e("path", { d: "M160,143.3V48a40,40,0,0,0-80,0v95.3A59.4,59.4,0,0,0,60,188a60,60,0,0,0,120,0A59.4,59.4,0,0,0,160,143.3ZM120,24a24.1,24.1,0,0,1,24,24v8H96V48A24.1,24.1,0,0,1,120,24Zm58.1,61.7a8,8,0,0,1,0-11.4,28,28,0,0,1,19.8-8.2,28.4,28.4,0,0,1,19.8,8.2,11.9,11.9,0,0,0,16.9,0,8,8,0,0,1,11.3,11.4,28,28,0,0,1-19.8,8.2,28.4,28.4,0,0,1-19.8-8.2,11.9,11.9,0,0,0-16.9,0A8,8,0,0,1,178.1,85.7Zm67.8,28.6a8,8,0,0,1,0,11.4,28,28,0,0,1-19.8,8.2,28.4,28.4,0,0,1-19.8-8.2,11.9,11.9,0,0,0-16.9,0,8,8,0,0,1-11.3-11.4,28,28,0,0,1,19.8-8.2,28.4,28.4,0,0,1,19.8,8.2,11.9,11.9,0,0,0,16.9,0A8,8,0,0,1,245.9,114.3Z" }, null, -1), Mo1 = [
  mo1
], vo1 = { key: 3 }, So1 = ["stroke"], Ho1 = ["stroke"], Ao1 = ["stroke"], Vo1 = ["stroke"], zo1 = ["stroke"], Zo1 = { key: 4 }, Co1 = ["stroke"], bo1 = ["stroke"], Lo1 = ["stroke"], Bo1 = ["stroke"], Po1 = ["stroke"], Wo1 = { key: 5 }, No1 = ["stroke"], Fo1 = ["stroke"], To1 = ["stroke"], Do1 = ["stroke"], Ro1 = ["stroke"], Uo1 = {
  name: "PhThermometerHot"
}, Ktl = /* @__PURE__ */ $({
  ...Uo1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ko1, [
        e("circle", {
          cx: "108",
          cy: "188",
          r: "12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, co1),
        e("line", {
          x1: "108",
          y1: "176",
          x2: "108",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ho1),
        e("path", {
          d: "M240.3,80A20,20,0,0,1,212,80a20,20,0,0,0-28.3,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, uo1),
        e("path", {
          d: "M240.3,120a20,20,0,0,1-28.3,0,20,20,0,0,0-28.3,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ao1),
        e("path", {
          d: "M68,154.8V56a40,40,0,0,1,80,0v98.8h0a52,52,0,1,1-80,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _o1)
      ])) : o(i) === "duotone" ? (s(), r("g", po1, [
        e("circle", {
          cx: "120",
          cy: "188",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yo1),
        e("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $o1),
        e("path", {
          d: "M240.3,80A20,20,0,0,1,212,80a20,20,0,0,0-28.3,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wo1),
        e("path", {
          d: "M240.3,120a20,20,0,0,1-28.3,0,20,20,0,0,0-28.3,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fo1),
        e("path", {
          d: "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, go1),
        xo1
      ])) : o(i) === "fill" ? (s(), r("g", jo1, Mo1)) : o(i) === "light" ? (s(), r("g", vo1, [
        e("circle", {
          cx: "120",
          cy: "188",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, So1),
        e("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ho1),
        e("path", {
          d: "M240.3,80A20,20,0,0,1,212,80a20,20,0,0,0-28.3,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ao1),
        e("path", {
          d: "M240.3,120a20,20,0,0,1-28.3,0,20,20,0,0,0-28.3,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vo1),
        e("path", {
          d: "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zo1)
      ])) : o(i) === "thin" ? (s(), r("g", Zo1, [
        e("circle", {
          cx: "120",
          cy: "188",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Co1),
        e("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bo1),
        e("path", {
          d: "M240.3,80A20,20,0,0,1,212,80a20,20,0,0,0-28.3,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lo1),
        e("path", {
          d: "M240.3,120a20,20,0,0,1-28.3,0,20,20,0,0,0-28.3,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bo1),
        e("path", {
          d: "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Po1)
      ])) : o(i) === "regular" ? (s(), r("g", Wo1, [
        e("circle", {
          cx: "120",
          cy: "188",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, No1),
        e("line", {
          x1: "120",
          y1: "168",
          x2: "120",
          y2: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fo1),
        e("path", {
          d: "M240.3,80A20,20,0,0,1,212,80a20,20,0,0,0-28.3,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, To1),
        e("path", {
          d: "M240.3,120a20,20,0,0,1-28.3,0,20,20,0,0,0-28.3,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Do1),
        e("path", {
          d: "M88,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ro1)
      ])) : g("", !0)
    ], 16, do1));
  }
}), qo1 = ["width", "height", "fill", "transform"], Go1 = { key: 0 }, Eo1 = ["stroke"], Oo1 = ["stroke"], Io1 = ["stroke"], Ko1 = { key: 1 }, Xo1 = /* @__PURE__ */ e("path", {
  d: "M160,147h0V48a32,32,0,0,0-64,0v99h0a52,52,0,1,0,64,0Zm-32,61a20,20,0,1,1,20-20A20.1,20.1,0,0,1,128,208Z",
  opacity: "0.2"
}, null, -1), Jo1 = ["stroke"], Qo1 = ["stroke"], Yo1 = ["stroke"], oe1 = { key: 2 }, ee1 = /* @__PURE__ */ e("path", { d: "M168,143.3V48a40,40,0,0,0-80,0v95.3A59.4,59.4,0,0,0,68,188a60,60,0,0,0,120,0A59.4,59.4,0,0,0,168,143.3ZM128,24a24.1,24.1,0,0,1,24,24V80H104V48A24.1,24.1,0,0,1,128,24Z" }, null, -1), te1 = [
  ee1
], ne1 = { key: 3 }, se1 = ["stroke"], re1 = ["stroke"], ie1 = ["stroke"], le1 = { key: 4 }, de1 = ["stroke"], ke1 = ["stroke"], ce1 = ["stroke"], he1 = { key: 5 }, ue1 = ["stroke"], ae1 = ["stroke"], _e1 = ["stroke"], pe1 = {
  name: "PhThermometerSimple"
}, Xtl = /* @__PURE__ */ $({
  ...pe1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Go1, [
        e("circle", {
          cx: "128",
          cy: "188",
          r: "12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Eo1),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "92",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Oo1),
        e("path", {
          d: "M88,154.8V56a40,40,0,0,1,80,0v98.8h0a52,52,0,1,1-80,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Io1)
      ])) : o(i) === "duotone" ? (s(), r("g", Ko1, [
        Xo1,
        e("path", {
          d: "M96,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jo1),
        e("circle", {
          cx: "128",
          cy: "188",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qo1),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yo1)
      ])) : o(i) === "fill" ? (s(), r("g", oe1, te1)) : o(i) === "light" ? (s(), r("g", ne1, [
        e("path", {
          d: "M96,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, se1),
        e("circle", {
          cx: "128",
          cy: "188",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, re1),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ie1)
      ])) : o(i) === "thin" ? (s(), r("g", le1, [
        e("path", {
          d: "M96,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, de1),
        e("circle", {
          cx: "128",
          cy: "188",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ke1),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ce1)
      ])) : o(i) === "regular" ? (s(), r("g", he1, [
        e("path", {
          d: "M96,147V48a32,32,0,0,1,64,0v99h0a52,52,0,1,1-64,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ue1),
        e("circle", {
          cx: "128",
          cy: "188",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ae1),
        e("line", {
          x1: "128",
          y1: "168",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _e1)
      ])) : g("", !0)
    ], 16, qo1));
  }
}), ye1 = ["width", "height", "fill", "transform"], $e1 = { key: 0 }, we1 = ["stroke"], fe1 = ["stroke"], ge1 = { key: 1 }, xe1 = /* @__PURE__ */ e("path", {
  d: "M32,48H80a0,0,0,0,1,0,0V152a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8Z",
  opacity: "0.2"
}, null, -1), je1 = ["stroke"], me1 = ["stroke"], Me1 = { key: 2 }, ve1 = /* @__PURE__ */ e("path", { d: "M237.7,157l-12-96a24.1,24.1,0,0,0-23.8-21H32A16,16,0,0,0,16,56v88a16,16,0,0,0,16,16H75l37.8,75.6A8.2,8.2,0,0,0,120,240a40.1,40.1,0,0,0,40-40V184h53.9a23.9,23.9,0,0,0,23.8-27ZM72,144H32V56H72Z" }, null, -1), Se1 = [
  ve1
], He1 = { key: 3 }, Ae1 = ["stroke"], Ve1 = ["stroke"], ze1 = { key: 4 }, Ze1 = ["stroke"], Ce1 = ["stroke"], be1 = { key: 5 }, Le1 = ["stroke"], Be1 = ["stroke"], Pe1 = {
  name: "PhThumbsDown"
}, Jtl = /* @__PURE__ */ $({
  ...Pe1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $e1, [
        e("path", {
          d: "M32,48H80a0,0,0,0,1,0,0V152a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, we1),
        e("path", {
          d: "M80,152l40,80a32,32,0,0,0,32-32V176h61.9a15.9,15.9,0,0,0,15.8-18l-12-96a16,16,0,0,0-15.8-14H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fe1)
      ])) : o(i) === "duotone" ? (s(), r("g", ge1, [
        xe1,
        e("path", {
          d: "M32,48H80a0,0,0,0,1,0,0V152a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, je1),
        e("path", {
          d: "M80,152l40,80a32,32,0,0,0,32-32V176h61.9a15.9,15.9,0,0,0,15.8-18l-12-96a16,16,0,0,0-15.8-14H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, me1)
      ])) : o(i) === "fill" ? (s(), r("g", Me1, Se1)) : o(i) === "light" ? (s(), r("g", He1, [
        e("path", {
          d: "M32,48H80a0,0,0,0,1,0,0V152a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V56A8,8,0,0,1,32,48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ae1),
        e("path", {
          d: "M80,152l40,80a32,32,0,0,0,32-32V176h61.9a15.9,15.9,0,0,0,15.8-18l-12-96a16,16,0,0,0-15.8-14H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ve1)
      ])) : o(i) === "thin" ? (s(), r("g", ze1, [
        e("path", {
          d: "M32,48H80a0,0,0,0,1,0,0V152a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V56A8,8,0,0,1,32,48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ze1),
        e("path", {
          d: "M80,152l40,80a32,32,0,0,0,32-32V176h61.9a15.9,15.9,0,0,0,15.8-18l-12-96a16,16,0,0,0-15.8-14H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ce1)
      ])) : o(i) === "regular" ? (s(), r("g", be1, [
        e("path", {
          d: "M32,48H80a0,0,0,0,1,0,0V152a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V56a8,8,0,0,1,8-8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Le1),
        e("path", {
          d: "M80,152l40,80a32,32,0,0,0,32-32V176h61.9a15.9,15.9,0,0,0,15.8-18l-12-96a16,16,0,0,0-15.8-14H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Be1)
      ])) : g("", !0)
    ], 16, ye1));
  }
}), We1 = ["width", "height", "fill", "transform"], Ne1 = { key: 0 }, Fe1 = ["stroke"], Te1 = ["stroke"], De1 = { key: 1 }, Re1 = /* @__PURE__ */ e("path", {
  d: "M32,104H80a0,0,0,0,1,0,0V208a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V112A8,8,0,0,1,32,104Z",
  opacity: "0.2"
}, null, -1), Ue1 = ["stroke"], qe1 = ["stroke"], Ge1 = { key: 2 }, Ee1 = /* @__PURE__ */ e("path", { d: "M231.9,80.1a24.4,24.4,0,0,0-18-8.1H160V56a40.1,40.1,0,0,0-40-40,8.2,8.2,0,0,0-7.2,4.4L75,96H32a16,16,0,0,0-16,16v88a16,16,0,0,0,16,16H201.9a24.1,24.1,0,0,0,23.8-21l12-96A24.5,24.5,0,0,0,231.9,80.1ZM32,112H72v88H32Z" }, null, -1), Oe1 = [
  Ee1
], Ie1 = { key: 3 }, Ke1 = ["stroke"], Xe1 = ["stroke"], Je1 = { key: 4 }, Qe1 = ["stroke"], Ye1 = ["stroke"], ot1 = { key: 5 }, et1 = ["stroke"], tt1 = ["stroke"], nt1 = {
  name: "PhThumbsUp"
}, Qtl = /* @__PURE__ */ $({
  ...nt1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ne1, [
        e("path", {
          d: "M32,104H80a0,0,0,0,1,0,0V208a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V112A8,8,0,0,1,32,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fe1),
        e("path", {
          d: "M80,104l40-80a32,32,0,0,1,32,32V80h61.9a15.9,15.9,0,0,1,15.8,18l-12,96a16,16,0,0,1-15.8,14H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Te1)
      ])) : o(i) === "duotone" ? (s(), r("g", De1, [
        Re1,
        e("path", {
          d: "M32,104H80a0,0,0,0,1,0,0V208a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V112A8,8,0,0,1,32,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ue1),
        e("path", {
          d: "M80,104l40-80a32,32,0,0,1,32,32V80h61.9a15.9,15.9,0,0,1,15.8,18l-12,96a16,16,0,0,1-15.8,14H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qe1)
      ])) : o(i) === "fill" ? (s(), r("g", Ge1, Oe1)) : o(i) === "light" ? (s(), r("g", Ie1, [
        e("path", {
          d: "M32,104H80a0,0,0,0,1,0,0V208a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V112A8,8,0,0,1,32,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ke1),
        e("path", {
          d: "M80,104l40-80a32,32,0,0,1,32,32V80h61.9a15.9,15.9,0,0,1,15.8,18l-12,96a16,16,0,0,1-15.8,14H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xe1)
      ])) : o(i) === "thin" ? (s(), r("g", Je1, [
        e("path", {
          d: "M32,104H80a0,0,0,0,1,0,0V208a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V112A8,8,0,0,1,32,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qe1),
        e("path", {
          d: "M80,104l40-80a32,32,0,0,1,32,32V80h61.9a15.9,15.9,0,0,1,15.8,18l-12,96a16,16,0,0,1-15.8,14H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ye1)
      ])) : o(i) === "regular" ? (s(), r("g", ot1, [
        e("path", {
          d: "M32,104H80a0,0,0,0,1,0,0V208a0,0,0,0,1,0,0H32a8,8,0,0,1-8-8V112A8,8,0,0,1,32,104Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, et1),
        e("path", {
          d: "M80,104l40-80a32,32,0,0,1,32,32V80h61.9a15.9,15.9,0,0,1,15.8,18l-12,96a16,16,0,0,1-15.8,14H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tt1)
      ])) : g("", !0)
    ], 16, We1));
  }
}), st1 = ["width", "height", "fill", "transform"], rt1 = { key: 0 }, it1 = ["stroke"], lt1 = ["stroke"], dt1 = { key: 1 }, kt1 = /* @__PURE__ */ e("path", {
  d: "M96,56H224a8,8,0,0,1,8,8V88.8a7.9,7.9,0,0,1-6.4,7.8,32.1,32.1,0,0,0,0,62.8,7.9,7.9,0,0,1,6.4,7.8V192a8,8,0,0,1-8,8H96Z",
  opacity: "0.2"
}, null, -1), ct1 = ["stroke"], ht1 = ["stroke"], ut1 = { key: 2 }, at1 = /* @__PURE__ */ e("path", { d: "M227.2,104.5A16.1,16.1,0,0,0,240,88.8V64a16,16,0,0,0-16-16H32A16,16,0,0,0,16,64V88.8a16.1,16.1,0,0,0,12.8,15.7,24,24,0,0,1,0,47A16.1,16.1,0,0,0,16,167.2V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V167.2a16.1,16.1,0,0,0-12.8-15.7,24,24,0,0,1,0-47ZM32,167.2a40,40,0,0,0,0-78.4V64H88V192H32Z" }, null, -1), _t1 = [
  at1
], pt1 = { key: 3 }, yt1 = ["stroke"], $t1 = ["stroke"], wt1 = { key: 4 }, ft1 = ["stroke"], gt1 = ["stroke"], xt1 = { key: 5 }, jt1 = ["stroke"], mt1 = ["stroke"], Mt1 = {
  name: "PhTicket"
}, Ytl = /* @__PURE__ */ $({
  ...Mt1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", rt1, [
        e("line", {
          x1: "96",
          y1: "56",
          x2: "96",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, it1),
        e("path", {
          d: "M24,167.2a7.9,7.9,0,0,1,6.4-7.8,32.1,32.1,0,0,0,0-62.8A7.9,7.9,0,0,1,24,88.8V64a8,8,0,0,1,8-8H224a8,8,0,0,1,8,8V88.8a7.9,7.9,0,0,1-6.4,7.8,32.1,32.1,0,0,0,0,62.8,7.9,7.9,0,0,1,6.4,7.8V192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lt1)
      ])) : o(i) === "duotone" ? (s(), r("g", dt1, [
        kt1,
        e("line", {
          x1: "96",
          y1: "56",
          x2: "96",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ct1),
        e("path", {
          d: "M24,167.2a7.9,7.9,0,0,1,6.4-7.8,32.1,32.1,0,0,0,0-62.8A7.9,7.9,0,0,1,24,88.8V64a8,8,0,0,1,8-8H224a8,8,0,0,1,8,8V88.8a7.9,7.9,0,0,1-6.4,7.8,32.1,32.1,0,0,0,0,62.8,7.9,7.9,0,0,1,6.4,7.8V192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ht1)
      ])) : o(i) === "fill" ? (s(), r("g", ut1, _t1)) : o(i) === "light" ? (s(), r("g", pt1, [
        e("line", {
          x1: "96",
          y1: "56",
          x2: "96",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yt1),
        e("path", {
          d: "M24,167.2a7.9,7.9,0,0,1,6.4-7.8,32.1,32.1,0,0,0,0-62.8A7.9,7.9,0,0,1,24,88.8V64a8,8,0,0,1,8-8H224a8,8,0,0,1,8,8V88.8a7.9,7.9,0,0,1-6.4,7.8,32.1,32.1,0,0,0,0,62.8,7.9,7.9,0,0,1,6.4,7.8V192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $t1)
      ])) : o(i) === "thin" ? (s(), r("g", wt1, [
        e("line", {
          x1: "96",
          y1: "56",
          x2: "96",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ft1),
        e("path", {
          d: "M24,167.2a7.9,7.9,0,0,1,6.4-7.8,32.1,32.1,0,0,0,0-62.8A7.9,7.9,0,0,1,24,88.8V64a8,8,0,0,1,8-8H224a8,8,0,0,1,8,8V88.8a7.9,7.9,0,0,1-6.4,7.8,32.1,32.1,0,0,0,0,62.8,7.9,7.9,0,0,1,6.4,7.8V192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gt1)
      ])) : o(i) === "regular" ? (s(), r("g", xt1, [
        e("line", {
          x1: "96",
          y1: "56",
          x2: "96",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jt1),
        e("path", {
          d: "M24,167.2a7.9,7.9,0,0,1,6.4-7.8,32.1,32.1,0,0,0,0-62.8A7.9,7.9,0,0,1,24,88.8V64a8,8,0,0,1,8-8H224a8,8,0,0,1,8,8V88.8a7.9,7.9,0,0,1-6.4,7.8,32.1,32.1,0,0,0,0,62.8,7.9,7.9,0,0,1,6.4,7.8V192a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mt1)
      ])) : g("", !0)
    ], 16, st1));
  }
}), vt1 = ["width", "height", "fill", "transform"], St1 = { key: 0 }, Ht1 = ["stroke"], At1 = { key: 1 }, Vt1 = /* @__PURE__ */ e("path", {
  d: "M168,106a95.9,95.9,0,0,0,56,18V84a56,56,0,0,1-56-56H128V156a28,28,0,1,1-40-25.3V89.1A68,68,0,1,0,168,156Z",
  opacity: "0.2"
}, null, -1), zt1 = ["stroke"], Zt1 = { key: 2 }, Ct1 = /* @__PURE__ */ e("path", { d: "M232,84v40a8,8,0,0,1-8,8,103.2,103.2,0,0,1-48-11.7V156A76,76,0,1,1,86.6,81.2a8,8,0,0,1,6.5,1.7A7.8,7.8,0,0,1,96,89.1v41.6a7.9,7.9,0,0,1-4.6,7.2A20,20,0,1,0,120,156V28a8,8,0,0,1,8-8h40a8,8,0,0,1,8,8,48,48,0,0,0,48,48A8,8,0,0,1,232,84Z" }, null, -1), bt1 = [
  Ct1
], Lt1 = { key: 3 }, Bt1 = ["stroke"], Pt1 = { key: 4 }, Wt1 = ["stroke"], Nt1 = { key: 5 }, Ft1 = ["stroke"], Tt1 = {
  name: "PhTiktokLogo"
}, onl = /* @__PURE__ */ $({
  ...Tt1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", St1, [
        e("path", {
          d: "M168,106a95.9,95.9,0,0,0,56,18V84a56,56,0,0,1-56-56H128V156a28,28,0,1,1-40-25.3V89.1A68,68,0,1,0,168,156Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ht1)
      ])) : o(i) === "duotone" ? (s(), r("g", At1, [
        Vt1,
        e("path", {
          d: "M168,106a95.9,95.9,0,0,0,56,18V84a56,56,0,0,1-56-56H128V156a28,28,0,1,1-40-25.3V89.1A68,68,0,1,0,168,156Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zt1)
      ])) : o(i) === "fill" ? (s(), r("g", Zt1, bt1)) : o(i) === "light" ? (s(), r("g", Lt1, [
        e("path", {
          d: "M168,106a95.9,95.9,0,0,0,56,18V84a56,56,0,0,1-56-56H128V156a28,28,0,1,1-40-25.3V89.1A68,68,0,1,0,168,156Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Bt1)
      ])) : o(i) === "thin" ? (s(), r("g", Pt1, [
        e("path", {
          d: "M168,106a95.9,95.9,0,0,0,56,18V84a56,56,0,0,1-56-56H128V156a28,28,0,1,1-40-25.3V89.1A68,68,0,1,0,168,156Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wt1)
      ])) : o(i) === "regular" ? (s(), r("g", Nt1, [
        e("path", {
          d: "M168,106a95.9,95.9,0,0,0,56,18V84a56,56,0,0,1-56-56H128V156a28,28,0,1,1-40-25.3V89.1A68,68,0,1,0,168,156Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ft1)
      ])) : g("", !0)
    ], 16, vt1));
  }
}), Dt1 = ["width", "height", "fill", "transform"], Rt1 = { key: 0 }, Ut1 = ["stroke"], qt1 = ["stroke"], Gt1 = ["stroke"], Et1 = { key: 1 }, Ot1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "88",
  opacity: "0.2"
}, null, -1), It1 = ["stroke"], Kt1 = ["stroke"], Xt1 = ["stroke"], Jt1 = { key: 2 }, Qt1 = /* @__PURE__ */ e("path", { d: "M104,16h48a8,8,0,0,0,0-16H104a8,8,0,0,0,0,16Z" }, null, -1), Yt1 = /* @__PURE__ */ e("path", { d: "M128,32a96,96,0,1,0,96,96A96.2,96.2,0,0,0,128,32Zm45.3,62.1-39.6,39.6a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4l39.6-39.6a8.1,8.1,0,1,1,11.4,11.4Z" }, null, -1), on1 = [
  Qt1,
  Yt1
], en1 = { key: 3 }, tn1 = ["stroke"], nn1 = ["stroke"], sn1 = ["stroke"], rn1 = { key: 4 }, in1 = ["stroke"], ln1 = ["stroke"], dn1 = ["stroke"], kn1 = { key: 5 }, cn1 = ["stroke"], hn1 = ["stroke"], un1 = ["stroke"], an1 = {
  name: "PhTimer"
}, enl = /* @__PURE__ */ $({
  ...an1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Rt1, [
        e("circle", {
          cx: "128",
          cy: "140",
          r: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ut1),
        e("line", {
          x1: "128",
          y1: "140",
          x2: "161.9",
          y2: "106.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qt1),
        e("line", {
          x1: "104",
          y1: "12",
          x2: "152",
          y2: "12",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gt1)
      ])) : o(i) === "duotone" ? (s(), r("g", Et1, [
        Ot1,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, It1),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "167.6",
          y2: "88.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kt1),
        e("line", {
          x1: "104",
          y1: "8",
          x2: "152",
          y2: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xt1)
      ])) : o(i) === "fill" ? (s(), r("g", Jt1, on1)) : o(i) === "light" ? (s(), r("g", en1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tn1),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "167.6",
          y2: "88.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nn1),
        e("line", {
          x1: "104",
          y1: "8",
          x2: "152",
          y2: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sn1)
      ])) : o(i) === "thin" ? (s(), r("g", rn1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, in1),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "167.6",
          y2: "88.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ln1),
        e("line", {
          x1: "104",
          y1: "8",
          x2: "152",
          y2: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dn1)
      ])) : o(i) === "regular" ? (s(), r("g", kn1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "88",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, cn1),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "167.6",
          y2: "88.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hn1),
        e("line", {
          x1: "104",
          y1: "8",
          x2: "152",
          y2: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, un1)
      ])) : g("", !0)
    ], 16, Dt1));
  }
}), _n1 = ["width", "height", "fill", "transform"], pn1 = { key: 0 }, yn1 = ["stroke"], $n1 = ["stroke"], wn1 = { key: 1 }, fn1 = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "128",
  r: "32",
  opacity: "0.2"
}, null, -1), gn1 = ["stroke"], xn1 = ["stroke"], jn1 = { key: 2 }, mn1 = /* @__PURE__ */ e("path", { d: "M176,56H80a72,72,0,0,0,0,144h96a72,72,0,0,0,0-144ZM80,168a40,40,0,1,1,40-40A40,40,0,0,1,80,168Z" }, null, -1), Mn1 = [
  mn1
], vn1 = { key: 3 }, Sn1 = ["stroke"], Hn1 = ["stroke"], An1 = { key: 4 }, Vn1 = ["stroke"], zn1 = ["stroke"], Zn1 = { key: 5 }, Cn1 = ["stroke"], bn1 = ["stroke"], Ln1 = {
  name: "PhToggleLeft"
}, tnl = /* @__PURE__ */ $({
  ...Ln1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", pn1, [
        e("rect", {
          x: "16",
          y: "64",
          width: "224",
          height: "128",
          rx: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yn1),
        e("circle", {
          cx: "80",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $n1)
      ])) : o(i) === "duotone" ? (s(), r("g", wn1, [
        fn1,
        e("rect", {
          x: "16",
          y: "64",
          width: "224",
          height: "128",
          rx: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gn1),
        e("circle", {
          cx: "80",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xn1)
      ])) : o(i) === "fill" ? (s(), r("g", jn1, Mn1)) : o(i) === "light" ? (s(), r("g", vn1, [
        e("rect", {
          x: "16",
          y: "64",
          width: "224",
          height: "128",
          rx: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Sn1),
        e("circle", {
          cx: "80",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Hn1)
      ])) : o(i) === "thin" ? (s(), r("g", An1, [
        e("rect", {
          x: "16",
          y: "64",
          width: "224",
          height: "128",
          rx: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vn1),
        e("circle", {
          cx: "80",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zn1)
      ])) : o(i) === "regular" ? (s(), r("g", Zn1, [
        e("rect", {
          x: "16",
          y: "64",
          width: "224",
          height: "128",
          rx: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cn1),
        e("circle", {
          cx: "80",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bn1)
      ])) : g("", !0)
    ], 16, _n1));
  }
}), Bn1 = ["width", "height", "fill", "transform"], Pn1 = { key: 0 }, Wn1 = ["stroke"], Nn1 = ["stroke"], Fn1 = { key: 1 }, Tn1 = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "128",
  r: "32",
  opacity: "0.2"
}, null, -1), Dn1 = ["stroke"], Rn1 = ["stroke"], Un1 = { key: 2 }, qn1 = /* @__PURE__ */ e("path", { d: "M176,56H80a72,72,0,0,0,0,144h96a72,72,0,0,0,0-144Zm0,112a40,40,0,1,1,40-40A40,40,0,0,1,176,168Z" }, null, -1), Gn1 = [
  qn1
], En1 = { key: 3 }, On1 = ["stroke"], In1 = ["stroke"], Kn1 = { key: 4 }, Xn1 = ["stroke"], Jn1 = ["stroke"], Qn1 = { key: 5 }, Yn1 = ["stroke"], os1 = ["stroke"], es1 = {
  name: "PhToggleRight"
}, nnl = /* @__PURE__ */ $({
  ...es1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Pn1, [
        e("rect", {
          x: "16",
          y: "64",
          width: "224",
          height: "128",
          rx: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wn1),
        e("circle", {
          cx: "176",
          cy: "128",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Nn1)
      ])) : o(i) === "duotone" ? (s(), r("g", Fn1, [
        Tn1,
        e("rect", {
          x: "16",
          y: "64",
          width: "224",
          height: "128",
          rx: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dn1),
        e("circle", {
          cx: "176",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rn1)
      ])) : o(i) === "fill" ? (s(), r("g", Un1, Gn1)) : o(i) === "light" ? (s(), r("g", En1, [
        e("rect", {
          x: "16",
          y: "64",
          width: "224",
          height: "128",
          rx: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, On1),
        e("circle", {
          cx: "176",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, In1)
      ])) : o(i) === "thin" ? (s(), r("g", Kn1, [
        e("rect", {
          x: "16",
          y: "64",
          width: "224",
          height: "128",
          rx: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xn1),
        e("circle", {
          cx: "176",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jn1)
      ])) : o(i) === "regular" ? (s(), r("g", Qn1, [
        e("rect", {
          x: "16",
          y: "64",
          width: "224",
          height: "128",
          rx: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yn1),
        e("circle", {
          cx: "176",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, os1)
      ])) : g("", !0)
    ], 16, Bn1));
  }
}), ts1 = ["width", "height", "fill", "transform"], ns1 = { key: 0 }, ss1 = ["stroke"], rs1 = ["stroke"], is1 = ["stroke"], ls1 = ["stroke"], ds1 = { key: 1 }, ks1 = /* @__PURE__ */ e("path", {
  d: "M64,112V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8v72Z",
  opacity: "0.2"
}, null, -1), cs1 = /* @__PURE__ */ e("path", {
  d: "M93.6,193l-4.3,29.9a8,8,0,0,0,7.9,9.1h61.6a8,8,0,0,0,7.9-9.1L162.4,193h0a88,88,0,0,1-68.8,0Z",
  opacity: "0.2"
}, null, -1), hs1 = ["stroke"], us1 = ["stroke"], as1 = ["stroke"], _s1 = ["stroke"], ps1 = { key: 2 }, ys1 = /* @__PURE__ */ e("path", { d: "M224,112.1a8,8,0,0,0-8-8.1H40a8,8,0,0,0-8,8.1,96,96,0,0,0,52.8,85.6l-3.4,23.7a16.2,16.2,0,0,0,1.7,10.1A16,16,0,0,0,97.2,240h61.2a16.9,16.9,0,0,0,9.8-3,16.2,16.2,0,0,0,6.4-15.3l-3.4-24A96,96,0,0,0,224,112.1ZM97.2,224l2.9-20.1a97,97,0,0,0,55.8,0l2.9,20.1ZM60,88H196a4,4,0,0,0,4-4V40a16,16,0,0,0-16-16H72A16,16,0,0,0,56,40V84A4,4,0,0,0,60,88ZM88,48h15.7a8.2,8.2,0,0,1,8.3,7.5,8,8,0,0,1-8,8.5H88.3A8.2,8.2,0,0,1,80,56.5,8,8,0,0,1,88,48Z" }, null, -1), $s1 = [
  ys1
], ws1 = { key: 3 }, fs1 = ["stroke"], gs1 = ["stroke"], xs1 = ["stroke"], js1 = ["stroke"], ms1 = { key: 4 }, Ms1 = ["stroke"], vs1 = ["stroke"], Ss1 = ["stroke"], Hs1 = ["stroke"], As1 = { key: 5 }, Vs1 = ["stroke"], zs1 = ["stroke"], Zs1 = ["stroke"], Cs1 = ["stroke"], bs1 = {
  name: "PhToilet"
}, snl = /* @__PURE__ */ $({
  ...bs1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ns1, [
        e("path", {
          d: "M64,108V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8v68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ss1),
        e("line", {
          x1: "100",
          y1: "68",
          x2: "116",
          y2: "68",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rs1),
        e("path", {
          d: "M216,108a88,88,0,0,1-176,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, is1),
        e("path", {
          d: "M94.1,189.2l-4.8,33.7a8,8,0,0,0,7.9,9.1h61.6a8,8,0,0,0,7.9-9.1l-4.8-33.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ls1)
      ])) : o(i) === "duotone" ? (s(), r("g", ds1, [
        ks1,
        cs1,
        e("path", {
          d: "M64,112V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8v72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hs1),
        e("line", {
          x1: "96",
          y1: "64",
          x2: "112",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, us1),
        e("path", {
          d: "M216,112a88,88,0,0,1-176,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, as1),
        e("path", {
          d: "M93.6,193l-4.3,29.9a8,8,0,0,0,7.9,9.1h61.6a8,8,0,0,0,7.9-9.1L162.4,193",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _s1)
      ])) : o(i) === "fill" ? (s(), r("g", ps1, $s1)) : o(i) === "light" ? (s(), r("g", ws1, [
        e("path", {
          d: "M64,112V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8v72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fs1),
        e("line", {
          x1: "96",
          y1: "64",
          x2: "112",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gs1),
        e("path", {
          d: "M216,112a88,88,0,0,1-176,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xs1),
        e("path", {
          d: "M93.6,193l-4.3,29.9a8,8,0,0,0,7.9,9.1h61.6a8,8,0,0,0,7.9-9.1L162.4,193",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, js1)
      ])) : o(i) === "thin" ? (s(), r("g", ms1, [
        e("path", {
          d: "M64,112V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8v72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ms1),
        e("line", {
          x1: "96",
          y1: "64",
          x2: "112",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, vs1),
        e("path", {
          d: "M216,112a88,88,0,0,1-176,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ss1),
        e("path", {
          d: "M93.6,193l-4.3,29.9a8,8,0,0,0,7.9,9.1h61.6a8,8,0,0,0,7.9-9.1L162.4,193",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hs1)
      ])) : o(i) === "regular" ? (s(), r("g", As1, [
        e("path", {
          d: "M64,112V40a8,8,0,0,1,8-8H184a8,8,0,0,1,8,8v72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vs1),
        e("line", {
          x1: "96",
          y1: "64",
          x2: "112",
          y2: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zs1),
        e("path", {
          d: "M216,112a88,88,0,0,1-176,0Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zs1),
        e("path", {
          d: "M93.6,193l-4.3,29.9a8,8,0,0,0,7.9,9.1h61.6a8,8,0,0,0,7.9-9.1L162.4,193",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cs1)
      ])) : g("", !0)
    ], 16, ts1));
  }
}), Ls1 = ["width", "height", "fill", "transform"], Bs1 = { key: 0 }, Ps1 = /* @__PURE__ */ e("circle", {
  cx: "64",
  cy: "120",
  r: "16"
}, null, -1), Ws1 = ["stroke"], Ns1 = ["stroke"], Fs1 = ["stroke"], Ts1 = ["stroke"], Ds1 = ["stroke"], Rs1 = { key: 1 }, Us1 = /* @__PURE__ */ e("ellipse", {
  cx: "64",
  cy: "120",
  rx: "40",
  ry: "80",
  opacity: "0.2"
}, null, -1), qs1 = /* @__PURE__ */ e("circle", {
  cx: "64",
  cy: "120",
  r: "12"
}, null, -1), Gs1 = ["stroke"], Es1 = ["stroke"], Os1 = ["stroke"], Is1 = ["stroke"], Ks1 = ["stroke"], Xs1 = { key: 2 }, Js1 = /* @__PURE__ */ e("path", { d: "M184,120a8,8,0,0,1-8,8H160a8,8,0,0,1,0-16h16A8,8,0,0,1,184,120Zm56,0v88a16,16,0,0,1-16,16H112a16,16,0,0,1-16-16V186.3C87.4,200.4,76.2,208,64,208c-13.9,0-26.5-9.9-35.4-27.9C20.5,163.9,16,142.6,16,120s4.5-43.9,12.6-60.1C37.5,41.9,50.1,32,64,32H192c13.9,0,26.5,9.9,35.4,27.9C235.5,76.1,240,97.4,240,120ZM76,120a12,12,0,1,0-12,12A12,12,0,0,0,76,120Zm148,8H208a8,8,0,0,1,0-16h15.8c-2-38.1-17.6-64-31.8-64H92.1a65,65,0,0,1,7.3,11.9c7.2,14.2,11.5,32.5,12.4,52.1H128a8,8,0,0,1,0,16H112v80H224Z" }, null, -1), Qs1 = [
  Js1
], Ys1 = { key: 3 }, or1 = /* @__PURE__ */ e("circle", {
  cx: "64",
  cy: "120",
  r: "10"
}, null, -1), er1 = ["stroke"], tr1 = ["stroke"], nr1 = ["stroke"], sr1 = ["stroke"], rr1 = ["stroke"], ir1 = { key: 4 }, lr1 = /* @__PURE__ */ e("circle", {
  cx: "64",
  cy: "120",
  r: "8"
}, null, -1), dr1 = ["stroke"], kr1 = ["stroke"], cr1 = ["stroke"], hr1 = ["stroke"], ur1 = ["stroke"], ar1 = { key: 5 }, _r1 = /* @__PURE__ */ e("circle", {
  cx: "64",
  cy: "120",
  r: "12"
}, null, -1), pr1 = ["stroke"], yr1 = ["stroke"], $r1 = ["stroke"], wr1 = ["stroke"], fr1 = ["stroke"], gr1 = {
  name: "PhToiletPaper"
}, rnl = /* @__PURE__ */ $({
  ...gr1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Bs1, [
        Ps1,
        e("ellipse", {
          cx: "64",
          cy: "120",
          rx: "40",
          ry: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ws1),
        e("path", {
          d: "M104,120v88a8,8,0,0,0,8,8H224a8,8,0,0,0,8-8V120c0-44.2-17.9-80-40-80H64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ns1),
        e("line", {
          x1: "104",
          y1: "120",
          x2: "124",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fs1),
        e("line", {
          x1: "164",
          y1: "120",
          x2: "172",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ts1),
        e("line", {
          x1: "212",
          y1: "120",
          x2: "232",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ds1)
      ])) : o(i) === "duotone" ? (s(), r("g", Rs1, [
        Us1,
        qs1,
        e("ellipse", {
          cx: "64",
          cy: "120",
          rx: "40",
          ry: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gs1),
        e("path", {
          d: "M104,120v88a8,8,0,0,0,8,8H224a8,8,0,0,0,8-8V120c0-44.2-17.9-80-40-80H64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Es1),
        e("line", {
          x1: "104",
          y1: "120",
          x2: "128",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Os1),
        e("line", {
          x1: "160",
          y1: "120",
          x2: "176",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Is1),
        e("line", {
          x1: "208",
          y1: "120",
          x2: "232",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ks1)
      ])) : o(i) === "fill" ? (s(), r("g", Xs1, Qs1)) : o(i) === "light" ? (s(), r("g", Ys1, [
        or1,
        e("ellipse", {
          cx: "64",
          cy: "120",
          rx: "40",
          ry: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, er1),
        e("path", {
          d: "M104,120v88a8,8,0,0,0,8,8H224a8,8,0,0,0,8-8V120c0-44.2-17.9-80-40-80H64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tr1),
        e("line", {
          x1: "104",
          y1: "120",
          x2: "128",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nr1),
        e("line", {
          x1: "160",
          y1: "120",
          x2: "176",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sr1),
        e("line", {
          x1: "208",
          y1: "120",
          x2: "232",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rr1)
      ])) : o(i) === "thin" ? (s(), r("g", ir1, [
        lr1,
        e("ellipse", {
          cx: "64",
          cy: "120",
          rx: "40",
          ry: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dr1),
        e("path", {
          d: "M104,120v88a8,8,0,0,0,8,8H224a8,8,0,0,0,8-8V120c0-44.2-17.9-80-40-80H64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kr1),
        e("line", {
          x1: "104",
          y1: "120",
          x2: "128",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cr1),
        e("line", {
          x1: "160",
          y1: "120",
          x2: "176",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hr1),
        e("line", {
          x1: "208",
          y1: "120",
          x2: "232",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ur1)
      ])) : o(i) === "regular" ? (s(), r("g", ar1, [
        _r1,
        e("ellipse", {
          cx: "64",
          cy: "120",
          rx: "40",
          ry: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pr1),
        e("path", {
          d: "M104,120v88a8,8,0,0,0,8,8H224a8,8,0,0,0,8-8V120c0-44.2-17.9-80-40-80H64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yr1),
        e("line", {
          x1: "104",
          y1: "120",
          x2: "128",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $r1),
        e("line", {
          x1: "160",
          y1: "120",
          x2: "176",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wr1),
        e("line", {
          x1: "208",
          y1: "120",
          x2: "232",
          y2: "120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fr1)
      ])) : g("", !0)
    ], 16, Ls1));
  }
}), xr1 = ["width", "height", "fill", "transform"], jr1 = { key: 0 }, mr1 = ["stroke"], Mr1 = ["stroke"], vr1 = { key: 1 }, Sr1 = /* @__PURE__ */ e("path", {
  d: "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
  opacity: "0.2"
}, null, -1), Hr1 = ["stroke"], Ar1 = ["stroke"], Vr1 = { key: 2 }, zr1 = /* @__PURE__ */ e("path", { d: "M235,69.3A15.9,15.9,0,0,0,223.1,64H175.3a48,48,0,0,0-94.6,0H32.9A15.9,15.9,0,0,0,21,69.3a16.2,16.2,0,0,0-4,12.5l14.3,128A15.9,15.9,0,0,0,47.2,224H208.8a15.9,15.9,0,0,0,15.9-14.2L239,81.8A16.2,16.2,0,0,0,235,69.3ZM96,104a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Zm1-40a32,32,0,0,1,62,0Zm79,40a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z" }, null, -1), Zr1 = [
  zr1
], Cr1 = { key: 3 }, br1 = ["stroke"], Lr1 = ["stroke"], Br1 = { key: 4 }, Pr1 = ["stroke"], Wr1 = ["stroke"], Nr1 = { key: 5 }, Fr1 = ["stroke"], Tr1 = ["stroke"], Dr1 = {
  name: "PhTote"
}, inl = /* @__PURE__ */ $({
  ...Dr1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", jr1, [
        e("path", {
          d: "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mr1),
        e("path", {
          d: "M88,104V72a40,40,0,0,1,80,0v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mr1)
      ])) : o(i) === "duotone" ? (s(), r("g", vr1, [
        Sr1,
        e("path", {
          d: "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hr1),
        e("path", {
          d: "M88,104V72a40,40,0,0,1,80,0v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ar1)
      ])) : o(i) === "fill" ? (s(), r("g", Vr1, Zr1)) : o(i) === "light" ? (s(), r("g", Cr1, [
        e("path", {
          d: "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, br1),
        e("path", {
          d: "M88,104V72a40,40,0,0,1,80,0v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lr1)
      ])) : o(i) === "thin" ? (s(), r("g", Br1, [
        e("path", {
          d: "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pr1),
        e("path", {
          d: "M88,104V72a40,40,0,0,1,80,0v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wr1)
      ])) : o(i) === "regular" ? (s(), r("g", Nr1, [
        e("path", {
          d: "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fr1),
        e("path", {
          d: "M88,104V72a40,40,0,0,1,80,0v32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tr1)
      ])) : g("", !0)
    ], 16, xr1));
  }
}), Rr1 = ["width", "height", "fill", "transform"], Ur1 = { key: 0 }, qr1 = ["stroke"], Gr1 = ["stroke"], Er1 = { key: 1 }, Or1 = /* @__PURE__ */ e("path", {
  d: "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
  opacity: "0.2"
}, null, -1), Ir1 = ["stroke"], Kr1 = ["stroke"], Xr1 = { key: 2 }, Jr1 = /* @__PURE__ */ e("path", { d: "M235,69.3A15.9,15.9,0,0,0,223.1,64H175.3a48,48,0,0,0-94.6,0H32.9A15.9,15.9,0,0,0,21,69.3a16.2,16.2,0,0,0-4,12.5l14.3,128A15.9,15.9,0,0,0,47.2,224H208.8a15.9,15.9,0,0,0,15.9-14.2L239,81.8A16.2,16.2,0,0,0,235,69.3ZM128,40a32.1,32.1,0,0,1,31,24H97A32.1,32.1,0,0,1,128,40Z" }, null, -1), Qr1 = [
  Jr1
], Yr1 = { key: 3 }, oi1 = ["stroke"], ei1 = ["stroke"], ti1 = { key: 4 }, ni1 = ["stroke"], si1 = ["stroke"], ri1 = { key: 5 }, ii1 = ["stroke"], li1 = ["stroke"], di1 = {
  name: "PhToteSimple"
}, lnl = /* @__PURE__ */ $({
  ...di1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Ur1, [
        e("path", {
          d: "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qr1),
        e("path", {
          d: "M88,72a40,40,0,0,1,80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gr1)
      ])) : o(i) === "duotone" ? (s(), r("g", Er1, [
        Or1,
        e("path", {
          d: "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ir1),
        e("path", {
          d: "M88,72a40,40,0,0,1,80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kr1)
      ])) : o(i) === "fill" ? (s(), r("g", Xr1, Qr1)) : o(i) === "light" ? (s(), r("g", Yr1, [
        e("path", {
          d: "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oi1),
        e("path", {
          d: "M88,72a40,40,0,0,1,80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ei1)
      ])) : o(i) === "thin" ? (s(), r("g", ti1, [
        e("path", {
          d: "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ni1),
        e("path", {
          d: "M88,72a40,40,0,0,1,80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, si1)
      ])) : o(i) === "regular" ? (s(), r("g", ri1, [
        e("path", {
          d: "M208.8,216H47.2a8.1,8.1,0,0,1-8-7.1L25,80.9A8,8,0,0,1,32.9,72H223.1a8,8,0,0,1,7.9,8.9l-14.2,128A8.1,8.1,0,0,1,208.8,216Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ii1),
        e("path", {
          d: "M88,72a40,40,0,0,1,80,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, li1)
      ])) : g("", !0)
    ], 16, Rr1));
  }
}), ki1 = ["width", "height", "fill", "transform"], ci1 = { key: 0 }, hi1 = ["stroke"], ui1 = ["stroke"], ai1 = ["stroke"], _i1 = { key: 1 }, pi1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), yi1 = ["stroke"], $i1 = ["stroke"], wi1 = ["stroke"], fi1 = { key: 2 }, gi1 = /* @__PURE__ */ e("path", { d: "M128,56a72,72,0,1,0,72,72A72.1,72.1,0,0,0,128,56Zm28.5,110.6A8.2,8.2,0,0,1,152,168a8,8,0,0,1-6.6-3.5L131.3,144H116v16a8,8,0,0,1-16,0V96a8,8,0,0,1,8-8h24a28,28,0,0,1,15.5,51.3l11.1,16.2A7.9,7.9,0,0,1,156.5,166.6ZM144,116a12,12,0,0,1-12,12H116V104h16A12,12,0,0,1,144,116ZM128,20A108,108,0,1,0,236,128,108.1,108.1,0,0,0,128,20Zm0,196a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Z" }, null, -1), xi1 = [
  gi1
], ji1 = { key: 3 }, mi1 = ["stroke"], Mi1 = ["stroke"], vi1 = ["stroke"], Si1 = { key: 4 }, Hi1 = ["stroke"], Ai1 = ["stroke"], Vi1 = ["stroke"], zi1 = { key: 5 }, Zi1 = ["stroke"], Ci1 = ["stroke"], bi1 = ["stroke"], Li1 = {
  name: "PhTrademarkRegistered"
}, dnl = /* @__PURE__ */ $({
  ...Li1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ci1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hi1),
        e("path", {
          d: "M104,136h32a24,24,0,0,0,0-48H104v80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ui1),
        e("line", {
          x1: "137.6",
          y1: "135.9",
          x2: "160",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ai1)
      ])) : o(i) === "duotone" ? (s(), r("g", _i1, [
        pi1,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yi1),
        e("path", {
          d: "M104,136h32a24,24,0,0,0,0-48H104v80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $i1),
        e("line", {
          x1: "137.6",
          y1: "135.9",
          x2: "160",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wi1)
      ])) : o(i) === "fill" ? (s(), r("g", fi1, xi1)) : o(i) === "light" ? (s(), r("g", ji1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mi1),
        e("path", {
          d: "M104,136h32a24,24,0,0,0,0-48H104v80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mi1),
        e("line", {
          x1: "137.6",
          y1: "135.9",
          x2: "160",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vi1)
      ])) : o(i) === "thin" ? (s(), r("g", Si1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Hi1),
        e("path", {
          d: "M104,136h32a24,24,0,0,0,0-48H104v80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ai1),
        e("line", {
          x1: "137.6",
          y1: "135.9",
          x2: "160",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vi1)
      ])) : o(i) === "regular" ? (s(), r("g", zi1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zi1),
        e("path", {
          d: "M104,136h32a24,24,0,0,0,0-48H104v80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ci1),
        e("line", {
          x1: "137.6",
          y1: "135.9",
          x2: "160",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bi1)
      ])) : g("", !0)
    ], 16, ki1));
  }
}), Bi1 = ["width", "height", "fill", "transform"], Pi1 = { key: 0 }, Wi1 = ["stroke"], Ni1 = ["stroke"], Fi1 = ["stroke"], Ti1 = ["stroke"], Di1 = { key: 1 }, Ri1 = /* @__PURE__ */ e("polygon", {
  points: "67.5 160 188.5 160 166.3 96 89.7 96 67.5 160",
  opacity: "0.2"
}, null, -1), Ui1 = ["stroke"], qi1 = ["stroke"], Gi1 = ["stroke"], Ei1 = ["stroke"], Oi1 = { key: 2 }, Ii1 = /* @__PURE__ */ e("path", { d: "M232,208H213.7L153.4,34.7A16,16,0,0,0,138.3,24H117.7a16,16,0,0,0-15.1,10.7L42.3,208H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16ZM95.4,104h65.2l16.7,48H78.7Z" }, null, -1), Ki1 = [
  Ii1
], Xi1 = { key: 3 }, Ji1 = ["stroke"], Qi1 = ["stroke"], Yi1 = ["stroke"], o11 = ["stroke"], e11 = { key: 4 }, t11 = ["stroke"], n11 = ["stroke"], s11 = ["stroke"], r11 = ["stroke"], i11 = { key: 5 }, l11 = ["stroke"], d11 = ["stroke"], k11 = ["stroke"], c11 = ["stroke"], h11 = {
  name: "PhTrafficCone"
}, knl = /* @__PURE__ */ $({
  ...h11,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Pi1, [
        e("path", {
          d: "M48,216,110.1,37.4a8.2,8.2,0,0,1,7.6-5.4h20.6a8.2,8.2,0,0,1,7.6,5.4L208,216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wi1),
        e("line", {
          x1: "232",
          y1: "216",
          x2: "24",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ni1),
        e("line", {
          x1: "166.3",
          y1: "96",
          x2: "89.7",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Fi1),
        e("line", {
          x1: "188.5",
          y1: "160",
          x2: "67.5",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ti1)
      ])) : o(i) === "duotone" ? (s(), r("g", Di1, [
        Ri1,
        e("path", {
          d: "M48,216,110.1,37.4a8.2,8.2,0,0,1,7.6-5.4h20.6a8.2,8.2,0,0,1,7.6,5.4L208,216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ui1),
        e("line", {
          x1: "232",
          y1: "216",
          x2: "24",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qi1),
        e("line", {
          x1: "166.3",
          y1: "96",
          x2: "89.7",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gi1),
        e("line", {
          x1: "188.5",
          y1: "160",
          x2: "67.5",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ei1)
      ])) : o(i) === "fill" ? (s(), r("g", Oi1, Ki1)) : o(i) === "light" ? (s(), r("g", Xi1, [
        e("path", {
          d: "M48,216,110.1,37.4a8.2,8.2,0,0,1,7.6-5.4h20.6a8.2,8.2,0,0,1,7.6,5.4L208,216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ji1),
        e("line", {
          x1: "232",
          y1: "216",
          x2: "24",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qi1),
        e("line", {
          x1: "166.3",
          y1: "96",
          x2: "89.7",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Yi1),
        e("line", {
          x1: "188.5",
          y1: "160",
          x2: "67.5",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, o11)
      ])) : o(i) === "thin" ? (s(), r("g", e11, [
        e("path", {
          d: "M48,216,110.1,37.4a8.2,8.2,0,0,1,7.6-5.4h20.6a8.2,8.2,0,0,1,7.6,5.4L208,216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, t11),
        e("line", {
          x1: "232",
          y1: "216",
          x2: "24",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, n11),
        e("line", {
          x1: "166.3",
          y1: "96",
          x2: "89.7",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, s11),
        e("line", {
          x1: "188.5",
          y1: "160",
          x2: "67.5",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, r11)
      ])) : o(i) === "regular" ? (s(), r("g", i11, [
        e("path", {
          d: "M48,216,110.1,37.4a8.2,8.2,0,0,1,7.6-5.4h20.6a8.2,8.2,0,0,1,7.6,5.4L208,216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l11),
        e("line", {
          x1: "232",
          y1: "216",
          x2: "24",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, d11),
        e("line", {
          x1: "166.3",
          y1: "96",
          x2: "89.7",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k11),
        e("line", {
          x1: "188.5",
          y1: "160",
          x2: "67.5",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c11)
      ])) : g("", !0)
    ], 16, Bi1));
  }
}), u11 = ["width", "height", "fill", "transform"], a11 = { key: 0 }, _11 = ["stroke"], p11 = ["stroke"], y11 = ["stroke"], $11 = { key: 1 }, w11 = /* @__PURE__ */ e("rect", {
  x: "46",
  y: "46",
  width: "164",
  height: "164.05",
  rx: "8",
  transform: "translate(-53 128) rotate(-45)",
  opacity: "0.2"
}, null, -1), f11 = ["stroke"], g11 = ["stroke"], x11 = ["stroke"], j11 = { key: 2 }, m11 = /* @__PURE__ */ e("path", { d: "M244,116.7,139.3,12a15.9,15.9,0,0,0-22.6,0L12,116.7a16.1,16.1,0,0,0,0,22.6L116.7,244a15.9,15.9,0,0,0,22.6,0L244,139.3A16.1,16.1,0,0,0,244,116.7ZM176,120v.8a.4.4,0,0,0-.1.3.9.9,0,0,1-.1.5.8.8,0,0,1-.1.4v.3l-.2.4c0,.1-.1.2-.1.4l-.2.3v.4l-.2.3c-.1.1-.2.2-.2.3l-.3.4-.2.3-.5.5h0l-24,24a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L148.7,128H112a16,16,0,0,0-16,16v8a8,8,0,0,1-16,0v-8a32.1,32.1,0,0,1,32-32h36.7l-10.4-10.3a8.1,8.1,0,0,1,11.4-11.4l24,24h0l.5.5.2.3.3.4c0,.1.1.2.2.3l.2.3v.4l.2.3c0,.2.1.3.1.4l.2.4v.3a.8.8,0,0,1,.1.4.9.9,0,0,1,.1.5.4.4,0,0,0,.1.3v.8Z" }, null, -1), M11 = [
  m11
], v11 = { key: 3 }, S11 = ["stroke"], H11 = ["stroke"], A11 = ["stroke"], V11 = { key: 4 }, z11 = ["stroke"], Z11 = ["stroke"], C11 = ["stroke"], b11 = { key: 5 }, L11 = ["stroke"], B11 = ["stroke"], P11 = ["stroke"], W11 = {
  name: "PhTrafficSign"
}, cnl = /* @__PURE__ */ $({
  ...W11,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", a11, [
        e("polyline", {
          points: "144 144 168 120 144 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _11),
        e("rect", {
          x: "46",
          y: "46",
          width: "164",
          height: "164.05",
          rx: "8",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, p11),
        e("path", {
          d: "M88,148v-4a23.9,23.9,0,0,1,24-24h56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, y11)
      ])) : o(i) === "duotone" ? (s(), r("g", $11, [
        w11,
        e("polyline", {
          points: "144 144 168 120 144 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f11),
        e("rect", {
          x: "46",
          y: "46",
          width: "164",
          height: "164.05",
          rx: "8",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g11),
        e("path", {
          d: "M88,152v-8a23.9,23.9,0,0,1,24-24h56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, x11)
      ])) : o(i) === "fill" ? (s(), r("g", j11, M11)) : o(i) === "light" ? (s(), r("g", v11, [
        e("polyline", {
          points: "144 144 168 120 144 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, S11),
        e("rect", {
          x: "46",
          y: "46",
          width: "164",
          height: "164.05",
          rx: "8",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, H11),
        e("path", {
          d: "M88,152v-8a23.9,23.9,0,0,1,24-24h56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, A11)
      ])) : o(i) === "thin" ? (s(), r("g", V11, [
        e("polyline", {
          points: "144 144 168 120 144 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, z11),
        e("rect", {
          x: "46",
          y: "46",
          width: "164",
          height: "164.05",
          rx: "8",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Z11),
        e("path", {
          d: "M88,152v-8a23.9,23.9,0,0,1,24-24h56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, C11)
      ])) : o(i) === "regular" ? (s(), r("g", b11, [
        e("polyline", {
          points: "144 144 168 120 144 96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L11),
        e("rect", {
          x: "46",
          y: "46",
          width: "164",
          height: "164.05",
          rx: "8",
          transform: "translate(-53 128) rotate(-45)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B11),
        e("path", {
          d: "M88,152v-8a23.9,23.9,0,0,1,24-24h56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P11)
      ])) : g("", !0)
    ], 16, u11));
  }
}), N11 = ["width", "height", "fill", "transform"], F11 = { key: 0 }, T11 = ["stroke"], D11 = ["stroke"], R11 = ["stroke"], U11 = ["stroke"], q11 = ["stroke"], G11 = ["stroke"], E11 = ["stroke"], O11 = { key: 1 }, I11 = /* @__PURE__ */ e("path", {
  d: "M184,32H72a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V40A8,8,0,0,0,184,32ZM128,192a24,24,0,1,1,24-24A23.9,23.9,0,0,1,128,192Zm0-80a24,24,0,1,1,24-24A23.9,23.9,0,0,1,128,112Z",
  opacity: "0.2"
}, null, -1), K11 = ["stroke"], X11 = ["stroke"], J11 = ["stroke"], Q11 = ["stroke"], Y11 = ["stroke"], ol1 = ["stroke"], el1 = ["stroke"], tl1 = { key: 2 }, nl1 = /* @__PURE__ */ e("path", { d: "M216,144H200V80h16a8,8,0,0,0,0-16H200V40a16,16,0,0,0-16-16H72A16,16,0,0,0,56,40V64H40a8,8,0,0,0,0,16H56v64H40a8,8,0,0,0,0,16H56v56a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V160h16a8,8,0,0,0,0-16Zm-88-28a28,28,0,1,1,28-28A28.1,28.1,0,0,1,128,116Zm0,24a28,28,0,1,1-28,28A28.1,28.1,0,0,1,128,140Z" }, null, -1), sl1 = [
  nl1
], rl1 = { key: 3 }, il1 = ["stroke"], ll1 = ["stroke"], dl1 = ["stroke"], kl1 = ["stroke"], cl1 = ["stroke"], hl1 = ["stroke"], ul1 = ["stroke"], al1 = { key: 4 }, _l1 = ["stroke"], pl1 = ["stroke"], yl1 = ["stroke"], $l1 = ["stroke"], wl1 = ["stroke"], fl1 = ["stroke"], gl1 = ["stroke"], xl1 = { key: 5 }, jl1 = ["stroke"], ml1 = ["stroke"], Ml1 = ["stroke"], vl1 = ["stroke"], Sl1 = ["stroke"], Hl1 = ["stroke"], Al1 = ["stroke"], Vl1 = {
  name: "PhTrafficSignal"
}, hnl = /* @__PURE__ */ $({
  ...Vl1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", F11, [
        e("rect", {
          x: "64",
          y: "32",
          width: "128",
          height: "192",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, T11),
        e("line", {
          x1: "192",
          y1: "72",
          x2: "216",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, D11),
        e("line", {
          x1: "192",
          y1: "152",
          x2: "216",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, R11),
        e("line", {
          x1: "40",
          y1: "72",
          x2: "64",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, U11),
        e("line", {
          x1: "40",
          y1: "152",
          x2: "64",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, q11),
        e("circle", {
          cx: "128",
          cy: "88",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, G11),
        e("circle", {
          cx: "128",
          cy: "168",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, E11)
      ])) : o(i) === "duotone" ? (s(), r("g", O11, [
        I11,
        e("rect", {
          x: "64",
          y: "32",
          width: "128",
          height: "192",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K11),
        e("circle", {
          cx: "128",
          cy: "88",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X11),
        e("circle", {
          cx: "128",
          cy: "168",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J11),
        e("line", {
          x1: "192",
          y1: "72",
          x2: "216",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q11),
        e("line", {
          x1: "192",
          y1: "152",
          x2: "216",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y11),
        e("line", {
          x1: "40",
          y1: "72",
          x2: "64",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ol1),
        e("line", {
          x1: "40",
          y1: "152",
          x2: "64",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, el1)
      ])) : o(i) === "fill" ? (s(), r("g", tl1, sl1)) : o(i) === "light" ? (s(), r("g", rl1, [
        e("rect", {
          x: "64",
          y: "32",
          width: "128",
          height: "192",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, il1),
        e("circle", {
          cx: "128",
          cy: "88",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ll1),
        e("circle", {
          cx: "128",
          cy: "168",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dl1),
        e("line", {
          x1: "192",
          y1: "72",
          x2: "216",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kl1),
        e("line", {
          x1: "192",
          y1: "152",
          x2: "216",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cl1),
        e("line", {
          x1: "40",
          y1: "72",
          x2: "64",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hl1),
        e("line", {
          x1: "40",
          y1: "152",
          x2: "64",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ul1)
      ])) : o(i) === "thin" ? (s(), r("g", al1, [
        e("rect", {
          x: "64",
          y: "32",
          width: "128",
          height: "192",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _l1),
        e("circle", {
          cx: "128",
          cy: "88",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pl1),
        e("circle", {
          cx: "128",
          cy: "168",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yl1),
        e("line", {
          x1: "192",
          y1: "72",
          x2: "216",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $l1),
        e("line", {
          x1: "192",
          y1: "152",
          x2: "216",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wl1),
        e("line", {
          x1: "40",
          y1: "72",
          x2: "64",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fl1),
        e("line", {
          x1: "40",
          y1: "152",
          x2: "64",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gl1)
      ])) : o(i) === "regular" ? (s(), r("g", xl1, [
        e("rect", {
          x: "64",
          y: "32",
          width: "128",
          height: "192",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jl1),
        e("circle", {
          cx: "128",
          cy: "88",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ml1),
        e("circle", {
          cx: "128",
          cy: "168",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ml1),
        e("line", {
          x1: "192",
          y1: "72",
          x2: "216",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vl1),
        e("line", {
          x1: "192",
          y1: "152",
          x2: "216",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sl1),
        e("line", {
          x1: "40",
          y1: "72",
          x2: "64",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hl1),
        e("line", {
          x1: "40",
          y1: "152",
          x2: "64",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Al1)
      ])) : g("", !0)
    ], 16, N11));
  }
}), zl1 = ["width", "height", "fill", "transform"], Zl1 = { key: 0 }, Cl1 = ["stroke"], bl1 = ["stroke"], Ll1 = ["stroke"], Bl1 = ["stroke"], Pl1 = ["stroke"], Wl1 = ["stroke"], Nl1 = /* @__PURE__ */ e("circle", {
  cx: "88",
  cy: "168",
  r: "16"
}, null, -1), Fl1 = /* @__PURE__ */ e("circle", {
  cx: "168",
  cy: "168",
  r: "16"
}, null, -1), Tl1 = { key: 1 }, Dl1 = /* @__PURE__ */ e("rect", {
  x: "44",
  y: "72",
  width: "168",
  height: "56",
  opacity: "0.2"
}, null, -1), Rl1 = ["stroke"], Ul1 = ["stroke"], ql1 = ["stroke"], Gl1 = ["stroke"], El1 = ["stroke"], Ol1 = ["stroke"], Il1 = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "172",
  r: "12"
}, null, -1), Kl1 = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "172",
  r: "12"
}, null, -1), Xl1 = { key: 2 }, Jl1 = /* @__PURE__ */ e("path", { d: "M188,24H68A32.1,32.1,0,0,0,36,56V184a32.1,32.1,0,0,0,32,32H80L65.6,235.2a8,8,0,0,0,1.6,11.2A7.7,7.7,0,0,0,72,248a8,8,0,0,0,6.4-3.2L100,216h56l21.6,28.8A8,8,0,0,0,184,248a7.7,7.7,0,0,0,4.8-1.6,8,8,0,0,0,1.6-11.2L176,216h12a32.1,32.1,0,0,0,32-32V56A32.1,32.1,0,0,0,188,24ZM84,184a12,12,0,1,1,12-12A12,12,0,0,1,84,184Zm36-64H52V80h68Zm52,64a12,12,0,1,1,12-12A12,12,0,0,1,172,184Zm32-64H136V80h68Z" }, null, -1), Ql1 = [
  Jl1
], Yl1 = { key: 3 }, o21 = ["stroke"], e21 = ["stroke"], t21 = ["stroke"], n21 = ["stroke"], s21 = ["stroke"], r21 = ["stroke"], i21 = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "172",
  r: "10"
}, null, -1), l21 = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "172",
  r: "10"
}, null, -1), d21 = { key: 4 }, k21 = ["stroke"], c21 = ["stroke"], h21 = ["stroke"], u21 = ["stroke"], a21 = ["stroke"], _21 = ["stroke"], p21 = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "172",
  r: "8"
}, null, -1), y21 = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "172",
  r: "8"
}, null, -1), $21 = { key: 5 }, w21 = ["stroke"], f21 = ["stroke"], g21 = ["stroke"], x21 = ["stroke"], j21 = ["stroke"], m21 = ["stroke"], M21 = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "172",
  r: "12"
}, null, -1), v21 = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "172",
  r: "12"
}, null, -1), S21 = {
  name: "PhTrain"
}, unl = /* @__PURE__ */ $({
  ...S21,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Zl1, [
        e("line", {
          x1: "44",
          y1: "128",
          x2: "212",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cl1),
        e("line", {
          x1: "44",
          y1: "72",
          x2: "212",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bl1),
        e("line", {
          x1: "96",
          y1: "208",
          x2: "72",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ll1),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "184",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bl1),
        e("rect", {
          x: "44",
          y: "32",
          width: "168",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pl1),
        e("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wl1),
        Nl1,
        Fl1
      ])) : o(i) === "duotone" ? (s(), r("g", Tl1, [
        Dl1,
        e("line", {
          x1: "44",
          y1: "128",
          x2: "212",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rl1),
        e("line", {
          x1: "44",
          y1: "72",
          x2: "212",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ul1),
        e("line", {
          x1: "96",
          y1: "208",
          x2: "72",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ql1),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "184",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gl1),
        e("rect", {
          x: "44",
          y: "32",
          width: "168",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, El1),
        e("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ol1),
        Il1,
        Kl1
      ])) : o(i) === "fill" ? (s(), r("g", Xl1, Ql1)) : o(i) === "light" ? (s(), r("g", Yl1, [
        e("line", {
          x1: "44",
          y1: "128",
          x2: "212",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, o21),
        e("line", {
          x1: "44",
          y1: "72",
          x2: "212",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, e21),
        e("line", {
          x1: "96",
          y1: "208",
          x2: "72",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, t21),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "184",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, n21),
        e("rect", {
          x: "44",
          y: "32",
          width: "168",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, s21),
        e("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, r21),
        i21,
        l21
      ])) : o(i) === "thin" ? (s(), r("g", d21, [
        e("line", {
          x1: "44",
          y1: "128",
          x2: "212",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, k21),
        e("line", {
          x1: "44",
          y1: "72",
          x2: "212",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, c21),
        e("line", {
          x1: "96",
          y1: "208",
          x2: "72",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, h21),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "184",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, u21),
        e("rect", {
          x: "44",
          y: "32",
          width: "168",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, a21),
        e("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _21),
        p21,
        y21
      ])) : o(i) === "regular" ? (s(), r("g", $21, [
        e("line", {
          x1: "44",
          y1: "128",
          x2: "212",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w21),
        e("line", {
          x1: "44",
          y1: "72",
          x2: "212",
          y2: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f21),
        e("line", {
          x1: "96",
          y1: "208",
          x2: "72",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g21),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "184",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, x21),
        e("rect", {
          x: "44",
          y: "32",
          width: "168",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j21),
        e("line", {
          x1: "128",
          y1: "72",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, m21),
        M21,
        v21
      ])) : g("", !0)
    ], 16, zl1));
  }
}), H21 = ["width", "height", "fill", "transform"], A21 = { key: 0 }, V21 = ["stroke"], z21 = ["stroke"], Z21 = ["stroke"], C21 = ["stroke"], b21 = ["stroke"], L21 = ["stroke"], B21 = { key: 1 }, P21 = /* @__PURE__ */ e("path", {
  d: "M40,120l88,16,88-16-22.4,82.1a7.9,7.9,0,0,1-7.7,5.9H70.1a7.9,7.9,0,0,1-7.7-5.9Z",
  opacity: "0.2"
}, null, -1), W21 = ["stroke"], N21 = ["stroke"], F21 = ["stroke"], T21 = ["stroke"], D21 = ["stroke"], R21 = ["stroke"], U21 = { key: 2 }, q21 = /* @__PURE__ */ e("path", { d: "M160,80H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Z" }, null, -1), G21 = /* @__PURE__ */ e("path", { d: "M224,119.9a2.2,2.2,0,0,0-.1-.8v-.5c-.1-.2-.1-.4-.2-.6h0l-22.4-82A15.9,15.9,0,0,0,185.9,24H70.1A15.9,15.9,0,0,0,54.7,35.8l-22.4,82h0c-.1.2-.1.4-.2.6v.5a2.2,2.2,0,0,0-.1.8v.2a2.8,2.8,0,0,0,.1.9h0a2.9,2.9,0,0,0,.2.9h0l22.4,82.1A15.9,15.9,0,0,0,70.1,216H80L65.6,235.2a8,8,0,0,0,1.6,11.2A7.7,7.7,0,0,0,72,248a8,8,0,0,0,6.4-3.2L100,216h56l21.6,28.8A8,8,0,0,0,184,248a7.7,7.7,0,0,0,4.8-1.6,8,8,0,0,0,1.6-11.2L176,216h9.9a15.9,15.9,0,0,0,15.4-11.8l22.4-82.1h0a2.9,2.9,0,0,0,.2-.9h0a2.8,2.8,0,0,0,.1-.9ZM136,192a8,8,0,0,1-16,0V152a8,8,0,0,1,16,0Zm-8-64.1L50,113.7,70.1,40H185.9L206,113.7Z" }, null, -1), E21 = [
  q21,
  G21
], O21 = { key: 3 }, I21 = ["stroke"], K21 = ["stroke"], X21 = ["stroke"], J21 = ["stroke"], Q21 = ["stroke"], Y21 = ["stroke"], o01 = { key: 4 }, e01 = ["stroke"], t01 = ["stroke"], n01 = ["stroke"], s01 = ["stroke"], r01 = ["stroke"], i01 = ["stroke"], l01 = { key: 5 }, d01 = ["stroke"], k01 = ["stroke"], c01 = ["stroke"], h01 = ["stroke"], u01 = ["stroke"], a01 = ["stroke"], _01 = {
  name: "PhTrainRegional"
}, anl = /* @__PURE__ */ $({
  ..._01,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", A21, [
        e("path", {
          d: "M70.1,32H185.9a7.9,7.9,0,0,1,7.7,5.9L216,120l-22.4,82.1a7.9,7.9,0,0,1-7.7,5.9H70.1a7.9,7.9,0,0,1-7.7-5.9L40,120,62.4,37.9A7.9,7.9,0,0,1,70.1,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, V21),
        e("line", {
          x1: "128",
          y1: "208",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, z21),
        e("polyline", {
          points: "40 120 128 136 216 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Z21),
        e("line", {
          x1: "96",
          y1: "88",
          x2: "160",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, C21),
        e("line", {
          x1: "96",
          y1: "208",
          x2: "72",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, b21),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "184",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, L21)
      ])) : o(i) === "duotone" ? (s(), r("g", B21, [
        P21,
        e("path", {
          d: "M70.1,32H185.9a7.9,7.9,0,0,1,7.7,5.9L216,120l-22.4,82.1a7.9,7.9,0,0,1-7.7,5.9H70.1a7.9,7.9,0,0,1-7.7-5.9L40,120,62.4,37.9A7.9,7.9,0,0,1,70.1,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W21),
        e("line", {
          x1: "128",
          y1: "208",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N21),
        e("polyline", {
          points: "40 120 128 136 216 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F21),
        e("line", {
          x1: "96",
          y1: "88",
          x2: "160",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T21),
        e("line", {
          x1: "96",
          y1: "208",
          x2: "72",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D21),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "184",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R21)
      ])) : o(i) === "fill" ? (s(), r("g", U21, E21)) : o(i) === "light" ? (s(), r("g", O21, [
        e("path", {
          d: "M70.1,32H185.9a7.9,7.9,0,0,1,7.7,5.9L216,120l-22.4,82.1a7.9,7.9,0,0,1-7.7,5.9H70.1a7.9,7.9,0,0,1-7.7-5.9L40,120,62.4,37.9A7.9,7.9,0,0,1,70.1,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, I21),
        e("line", {
          x1: "128",
          y1: "208",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, K21),
        e("polyline", {
          points: "40 120 128 136 216 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, X21),
        e("line", {
          x1: "96",
          y1: "88",
          x2: "160",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, J21),
        e("line", {
          x1: "96",
          y1: "208",
          x2: "72",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Q21),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "184",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Y21)
      ])) : o(i) === "thin" ? (s(), r("g", o01, [
        e("path", {
          d: "M70.1,32H185.9a7.9,7.9,0,0,1,7.7,5.9L216,120l-22.4,82.1a7.9,7.9,0,0,1-7.7,5.9H70.1a7.9,7.9,0,0,1-7.7-5.9L40,120,62.4,37.9A7.9,7.9,0,0,1,70.1,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, e01),
        e("line", {
          x1: "128",
          y1: "208",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, t01),
        e("polyline", {
          points: "40 120 128 136 216 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, n01),
        e("line", {
          x1: "96",
          y1: "88",
          x2: "160",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, s01),
        e("line", {
          x1: "96",
          y1: "208",
          x2: "72",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, r01),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "184",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, i01)
      ])) : o(i) === "regular" ? (s(), r("g", l01, [
        e("path", {
          d: "M70.1,32H185.9a7.9,7.9,0,0,1,7.7,5.9L216,120l-22.4,82.1a7.9,7.9,0,0,1-7.7,5.9H70.1a7.9,7.9,0,0,1-7.7-5.9L40,120,62.4,37.9A7.9,7.9,0,0,1,70.1,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, d01),
        e("line", {
          x1: "128",
          y1: "208",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k01),
        e("polyline", {
          points: "40 120 128 136 216 120",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c01),
        e("line", {
          x1: "96",
          y1: "88",
          x2: "160",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h01),
        e("line", {
          x1: "96",
          y1: "208",
          x2: "72",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u01),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "184",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a01)
      ])) : g("", !0)
    ], 16, H21));
  }
}), p01 = ["width", "height", "fill", "transform"], y01 = { key: 0 }, $01 = ["stroke"], w01 = ["stroke"], f01 = ["stroke"], g01 = ["stroke"], x01 = /* @__PURE__ */ e("circle", {
  cx: "88",
  cy: "168",
  r: "16"
}, null, -1), j01 = /* @__PURE__ */ e("circle", {
  cx: "168",
  cy: "168",
  r: "16"
}, null, -1), m01 = { key: 1 }, M01 = /* @__PURE__ */ e("path", {
  d: "M212,56a23.9,23.9,0,0,0-24-24H68A23.9,23.9,0,0,0,44,56v72H212Z",
  opacity: "0.2"
}, null, -1), v01 = ["stroke"], S01 = ["stroke"], H01 = ["stroke"], A01 = ["stroke"], V01 = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "172",
  r: "12"
}, null, -1), z01 = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "172",
  r: "12"
}, null, -1), Z01 = { key: 2 }, C01 = /* @__PURE__ */ e("path", { d: "M188,24H68A32.1,32.1,0,0,0,36,56V184a32.1,32.1,0,0,0,32,32H80L65.6,235.2a8,8,0,0,0,1.6,11.2A7.7,7.7,0,0,0,72,248a8,8,0,0,0,6.4-3.2L100,216h56l21.6,28.8A8,8,0,0,0,184,248a7.7,7.7,0,0,0,4.8-1.6,8,8,0,0,0,1.6-11.2L176,216h12a32.1,32.1,0,0,0,32-32V56A32.1,32.1,0,0,0,188,24Zm0,176H68a16,16,0,0,1-16-16V136H204v48A16,16,0,0,1,188,200Z" }, null, -1), b01 = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "172",
  r: "12"
}, null, -1), L01 = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "172",
  r: "12"
}, null, -1), B01 = [
  C01,
  b01,
  L01
], P01 = { key: 3 }, W01 = ["stroke"], N01 = ["stroke"], F01 = ["stroke"], T01 = ["stroke"], D01 = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "172",
  r: "10"
}, null, -1), R01 = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "172",
  r: "10"
}, null, -1), U01 = { key: 4 }, q01 = ["stroke"], G01 = ["stroke"], E01 = ["stroke"], O01 = ["stroke"], I01 = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "172",
  r: "8"
}, null, -1), K01 = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "172",
  r: "8"
}, null, -1), X01 = { key: 5 }, J01 = ["stroke"], Q01 = ["stroke"], Y01 = ["stroke"], o81 = ["stroke"], e81 = /* @__PURE__ */ e("circle", {
  cx: "84",
  cy: "172",
  r: "12"
}, null, -1), t81 = /* @__PURE__ */ e("circle", {
  cx: "172",
  cy: "172",
  r: "12"
}, null, -1), n81 = {
  name: "PhTrainSimple"
}, _nl = /* @__PURE__ */ $({
  ...n81,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", y01, [
        e("line", {
          x1: "44",
          y1: "128",
          x2: "212",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $01),
        e("line", {
          x1: "96",
          y1: "208",
          x2: "72",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, w01),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "184",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f01),
        e("rect", {
          x: "44",
          y: "32",
          width: "168",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g01),
        x01,
        j01
      ])) : o(i) === "duotone" ? (s(), r("g", m01, [
        M01,
        e("line", {
          x1: "44",
          y1: "128",
          x2: "212",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v01),
        e("line", {
          x1: "96",
          y1: "208",
          x2: "72",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S01),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "184",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H01),
        e("rect", {
          x: "44",
          y: "32",
          width: "168",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A01),
        V01,
        z01
      ])) : o(i) === "fill" ? (s(), r("g", Z01, B01)) : o(i) === "light" ? (s(), r("g", P01, [
        e("line", {
          x1: "44",
          y1: "128",
          x2: "212",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, W01),
        e("line", {
          x1: "96",
          y1: "208",
          x2: "72",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, N01),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "184",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, F01),
        e("rect", {
          x: "44",
          y: "32",
          width: "168",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, T01),
        D01,
        R01
      ])) : o(i) === "thin" ? (s(), r("g", U01, [
        e("line", {
          x1: "44",
          y1: "128",
          x2: "212",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, q01),
        e("line", {
          x1: "96",
          y1: "208",
          x2: "72",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, G01),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "184",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, E01),
        e("rect", {
          x: "44",
          y: "32",
          width: "168",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, O01),
        I01,
        K01
      ])) : o(i) === "regular" ? (s(), r("g", X01, [
        e("line", {
          x1: "44",
          y1: "128",
          x2: "212",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J01),
        e("line", {
          x1: "96",
          y1: "208",
          x2: "72",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q01),
        e("line", {
          x1: "160",
          y1: "208",
          x2: "184",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y01),
        e("rect", {
          x: "44",
          y: "32",
          width: "168",
          height: "176",
          rx: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o81),
        e81,
        t81
      ])) : g("", !0)
    ], 16, p01));
  }
}), s81 = ["width", "height", "fill", "transform"], r81 = { key: 0 }, i81 = ["stroke"], l81 = ["stroke"], d81 = ["stroke"], k81 = ["stroke"], c81 = ["stroke"], h81 = ["stroke"], u81 = { key: 1 }, a81 = ["stroke"], _81 = ["stroke"], p81 = ["stroke"], y81 = ["stroke"], $81 = ["stroke"], w81 = ["stroke"], f81 = { key: 2 }, g81 = /* @__PURE__ */ e("path", { d: "M239.1,212.4l-56-112A7.9,7.9,0,0,0,176,96a8,8,0,0,0-7.2,4.4l-21.7,43.4A87.4,87.4,0,0,1,100,126.9,104.1,104.1,0,0,0,127.7,64H152a8,8,0,0,0,0-16H96V32a8,8,0,0,0-16,0V48H24a8,8,0,0,0,0,16h87.6A87.5,87.5,0,0,1,88,116.3a87.1,87.1,0,0,1-19-31,8,8,0,0,0-10.2-4.8,7.9,7.9,0,0,0-4.9,10.2A103.8,103.8,0,0,0,76,126.9,87.1,87.1,0,0,1,24,144a8,8,0,0,0,0,16,103.8,103.8,0,0,0,64-22.1,103.6,103.6,0,0,0,51.4,21.3l-26.6,53.2a8,8,0,1,0,14.3,7.2L140.9,192H211l13.8,27.6A8,8,0,0,0,232,224a9.4,9.4,0,0,0,3.6-.8A8.1,8.1,0,0,0,239.1,212.4ZM148.9,176,176,121.9,203,176Z" }, null, -1), x81 = [
  g81
], j81 = { key: 3 }, m81 = ["stroke"], M81 = ["stroke"], v81 = ["stroke"], S81 = ["stroke"], H81 = ["stroke"], A81 = ["stroke"], V81 = { key: 4 }, z81 = ["stroke"], Z81 = ["stroke"], C81 = ["stroke"], b81 = ["stroke"], L81 = ["stroke"], B81 = ["stroke"], P81 = { key: 5 }, W81 = ["stroke"], N81 = ["stroke"], F81 = ["stroke"], T81 = ["stroke"], D81 = ["stroke"], R81 = ["stroke"], U81 = {
  name: "PhTranslate"
}, pnl = /* @__PURE__ */ $({
  ...U81,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", r81, [
        e("polyline", {
          points: "232 216 176 104 120 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, i81),
        e("line", {
          x1: "136",
          y1: "184",
          x2: "216",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, l81),
        e("line", {
          x1: "88",
          y1: "32",
          x2: "88",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, d81),
        e("line", {
          x1: "24",
          y1: "56",
          x2: "152",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, k81),
        e("path", {
          d: "M120,56a96,96,0,0,1-96,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, c81),
        e("path", {
          d: "M64.7,96A96.1,96.1,0,0,0,152,152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, h81)
      ])) : o(i) === "duotone" ? (s(), r("g", u81, [
        e("polyline", {
          points: "232 216 176 104 120 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a81),
        e("line", {
          x1: "136",
          y1: "184",
          x2: "216",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _81),
        e("line", {
          x1: "88",
          y1: "32",
          x2: "88",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p81),
        e("line", {
          x1: "24",
          y1: "56",
          x2: "152",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y81),
        e("path", {
          d: "M120,56a96,96,0,0,1-96,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $81),
        e("path", {
          d: "M61.4,88A96.1,96.1,0,0,0,152,152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, w81)
      ])) : o(i) === "fill" ? (s(), r("g", f81, x81)) : o(i) === "light" ? (s(), r("g", j81, [
        e("polyline", {
          points: "232 216 176 104 120 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, m81),
        e("line", {
          x1: "136",
          y1: "184",
          x2: "216",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, M81),
        e("line", {
          x1: "88",
          y1: "32",
          x2: "88",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, v81),
        e("line", {
          x1: "24",
          y1: "56",
          x2: "152",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, S81),
        e("path", {
          d: "M120,56a96,96,0,0,1-96,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, H81),
        e("path", {
          d: "M61.5,88A95.9,95.9,0,0,0,152,152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, A81)
      ])) : o(i) === "thin" ? (s(), r("g", V81, [
        e("polyline", {
          points: "232 216 176 104 120 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, z81),
        e("line", {
          x1: "136",
          y1: "184",
          x2: "216",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Z81),
        e("line", {
          x1: "88",
          y1: "32",
          x2: "88",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, C81),
        e("line", {
          x1: "24",
          y1: "56",
          x2: "152",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, b81),
        e("path", {
          d: "M120,56a96,96,0,0,1-96,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, L81),
        e("path", {
          d: "M61.5,88A96,96,0,0,0,152,152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, B81)
      ])) : o(i) === "regular" ? (s(), r("g", P81, [
        e("polyline", {
          points: "232 216 176 104 120 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W81),
        e("line", {
          x1: "136",
          y1: "184",
          x2: "216",
          y2: "184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N81),
        e("line", {
          x1: "88",
          y1: "32",
          x2: "88",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, F81),
        e("line", {
          x1: "24",
          y1: "56",
          x2: "152",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, T81),
        e("path", {
          d: "M120,56a96,96,0,0,1-96,96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, D81),
        e("path", {
          d: "M61.5,88A96,96,0,0,0,152,152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, R81)
      ])) : g("", !0)
    ], 16, s81));
  }
}), q81 = ["width", "height", "fill", "transform"], G81 = { key: 0 }, E81 = ["stroke"], O81 = ["stroke"], I81 = ["stroke"], K81 = ["stroke"], X81 = ["stroke"], J81 = { key: 1 }, Q81 = /* @__PURE__ */ e("path", {
  d: "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56Z",
  opacity: "0.2"
}, null, -1), Y81 = ["stroke"], od1 = ["stroke"], ed1 = ["stroke"], td1 = ["stroke"], nd1 = ["stroke"], sd1 = { key: 2 }, rd1 = /* @__PURE__ */ e("path", { d: "M216,48H176V40a24.1,24.1,0,0,0-24-24H104A24.1,24.1,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM112,168a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm0-120H96V40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8Z" }, null, -1), id1 = [
  rd1
], ld1 = { key: 3 }, dd1 = ["stroke"], kd1 = ["stroke"], cd1 = ["stroke"], hd1 = ["stroke"], ud1 = ["stroke"], ad1 = { key: 4 }, _d1 = ["stroke"], pd1 = ["stroke"], yd1 = ["stroke"], $d1 = ["stroke"], wd1 = ["stroke"], fd1 = { key: 5 }, gd1 = ["stroke"], xd1 = ["stroke"], jd1 = ["stroke"], md1 = ["stroke"], Md1 = ["stroke"], vd1 = {
  name: "PhTrash"
}, ynl = /* @__PURE__ */ $({
  ...vd1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", G81, [
        e("line", {
          x1: "216",
          y1: "60",
          x2: "40",
          y2: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, E81),
        e("line", {
          x1: "104",
          y1: "104",
          x2: "104",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, O81),
        e("line", {
          x1: "152",
          y1: "104",
          x2: "152",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, I81),
        e("path", {
          d: "M200,60V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, K81),
        e("path", {
          d: "M168,60V36a16,16,0,0,0-16-16H104A16,16,0,0,0,88,36V60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X81)
      ])) : o(i) === "duotone" ? (s(), r("g", J81, [
        Q81,
        e("line", {
          x1: "216",
          y1: "56",
          x2: "40",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y81),
        e("line", {
          x1: "104",
          y1: "104",
          x2: "104",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, od1),
        e("line", {
          x1: "152",
          y1: "104",
          x2: "152",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ed1),
        e("path", {
          d: "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, td1),
        e("path", {
          d: "M168,56V40a16,16,0,0,0-16-16H104A16,16,0,0,0,88,40V56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nd1)
      ])) : o(i) === "fill" ? (s(), r("g", sd1, id1)) : o(i) === "light" ? (s(), r("g", ld1, [
        e("line", {
          x1: "216",
          y1: "56",
          x2: "40",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dd1),
        e("line", {
          x1: "104",
          y1: "104",
          x2: "104",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kd1),
        e("line", {
          x1: "152",
          y1: "104",
          x2: "152",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cd1),
        e("path", {
          d: "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hd1),
        e("path", {
          d: "M168,56V40a16,16,0,0,0-16-16H104A16,16,0,0,0,88,40V56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ud1)
      ])) : o(i) === "thin" ? (s(), r("g", ad1, [
        e("line", {
          x1: "216",
          y1: "56",
          x2: "40",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _d1),
        e("line", {
          x1: "104",
          y1: "104",
          x2: "104",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, pd1),
        e("line", {
          x1: "152",
          y1: "104",
          x2: "152",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yd1),
        e("path", {
          d: "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $d1),
        e("path", {
          d: "M168,56V40a16,16,0,0,0-16-16H104A16,16,0,0,0,88,40V56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wd1)
      ])) : o(i) === "regular" ? (s(), r("g", fd1, [
        e("line", {
          x1: "216",
          y1: "56",
          x2: "40",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gd1),
        e("line", {
          x1: "104",
          y1: "104",
          x2: "104",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xd1),
        e("line", {
          x1: "152",
          y1: "104",
          x2: "152",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jd1),
        e("path", {
          d: "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, md1),
        e("path", {
          d: "M168,56V40a16,16,0,0,0-16-16H104A16,16,0,0,0,88,40V56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Md1)
      ])) : g("", !0)
    ], 16, q81));
  }
}), Sd1 = ["width", "height", "fill", "transform"], Hd1 = { key: 0 }, Ad1 = ["stroke"], Vd1 = ["stroke"], zd1 = ["stroke"], Zd1 = { key: 1 }, Cd1 = /* @__PURE__ */ e("path", {
  d: "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56Z",
  opacity: "0.2"
}, null, -1), bd1 = ["stroke"], Ld1 = ["stroke"], Bd1 = ["stroke"], Pd1 = { key: 2 }, Wd1 = /* @__PURE__ */ e("path", { d: "M224,56a8,8,0,0,1-8,8h-8V208a16,16,0,0,1-16,16H64a16,16,0,0,1-16-16V64H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,56ZM88,32h80a8,8,0,0,0,0-16H88a8,8,0,0,0,0,16Z" }, null, -1), Nd1 = [
  Wd1
], Fd1 = { key: 3 }, Td1 = ["stroke"], Dd1 = ["stroke"], Rd1 = ["stroke"], Ud1 = { key: 4 }, qd1 = ["stroke"], Gd1 = ["stroke"], Ed1 = ["stroke"], Od1 = { key: 5 }, Id1 = ["stroke"], Kd1 = ["stroke"], Xd1 = ["stroke"], Jd1 = {
  name: "PhTrashSimple"
}, $nl = /* @__PURE__ */ $({
  ...Jd1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Hd1, [
        e("line", {
          x1: "216",
          y1: "60",
          x2: "40",
          y2: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ad1),
        e("line", {
          x1: "88",
          y1: "20",
          x2: "168",
          y2: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vd1),
        e("path", {
          d: "M200,60V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zd1)
      ])) : o(i) === "duotone" ? (s(), r("g", Zd1, [
        Cd1,
        e("line", {
          x1: "216",
          y1: "56",
          x2: "40",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bd1),
        e("line", {
          x1: "88",
          y1: "24",
          x2: "168",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ld1),
        e("path", {
          d: "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bd1)
      ])) : o(i) === "fill" ? (s(), r("g", Pd1, Nd1)) : o(i) === "light" ? (s(), r("g", Fd1, [
        e("line", {
          x1: "216",
          y1: "56",
          x2: "40",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Td1),
        e("line", {
          x1: "88",
          y1: "24",
          x2: "168",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dd1),
        e("path", {
          d: "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rd1)
      ])) : o(i) === "thin" ? (s(), r("g", Ud1, [
        e("line", {
          x1: "216",
          y1: "56",
          x2: "40",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qd1),
        e("line", {
          x1: "88",
          y1: "24",
          x2: "168",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gd1),
        e("path", {
          d: "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ed1)
      ])) : o(i) === "regular" ? (s(), r("g", Od1, [
        e("line", {
          x1: "216",
          y1: "56",
          x2: "40",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Id1),
        e("line", {
          x1: "88",
          y1: "24",
          x2: "168",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kd1),
        e("path", {
          d: "M200,56V208a8,8,0,0,1-8,8H64a8,8,0,0,1-8-8V56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xd1)
      ])) : g("", !0)
    ], 16, Sd1));
  }
}), Qd1 = ["width", "height", "fill", "transform"], Yd1 = { key: 0 }, ok1 = ["stroke"], ek1 = ["stroke"], tk1 = { key: 1 }, nk1 = /* @__PURE__ */ e("path", {
  d: "M76.7,160a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216V48a8,8,0,0,0-8-8H48a8,8,0,0,0-8,8V160Z",
  opacity: "0.2"
}, null, -1), sk1 = ["stroke"], rk1 = ["stroke"], ik1 = { key: 2 }, lk1 = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V159.9h0V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V168H76.7L96,187.3a15.9,15.9,0,0,0,11.3,4.7h41.4a15.9,15.9,0,0,0,11.3-4.7L179.3,168H208v40Z" }, null, -1), dk1 = [
  lk1
], kk1 = { key: 3 }, ck1 = ["stroke"], hk1 = ["stroke"], uk1 = { key: 4 }, ak1 = ["stroke"], _k1 = ["stroke"], pk1 = { key: 5 }, yk1 = ["stroke"], $k1 = ["stroke"], wk1 = {
  name: "PhTray"
}, wnl = /* @__PURE__ */ $({
  ...wk1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Yd1, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ok1),
        e("path", {
          d: "M40,156H76.7a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ek1)
      ])) : o(i) === "duotone" ? (s(), r("g", tk1, [
        nk1,
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sk1),
        e("path", {
          d: "M40,160H76.7a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rk1)
      ])) : o(i) === "fill" ? (s(), r("g", ik1, dk1)) : o(i) === "light" ? (s(), r("g", kk1, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ck1),
        e("path", {
          d: "M40,160H76.7a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hk1)
      ])) : o(i) === "thin" ? (s(), r("g", uk1, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ak1),
        e("path", {
          d: "M40,160H76.7a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _k1)
      ])) : o(i) === "regular" ? (s(), r("g", pk1, [
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yk1),
        e("path", {
          d: "M40,160H76.7a7.9,7.9,0,0,1,5.6,2.3l19.4,19.4a7.9,7.9,0,0,0,5.6,2.3h41.4a7.9,7.9,0,0,0,5.6-2.3l19.4-19.4a7.9,7.9,0,0,1,5.6-2.3H216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $k1)
      ])) : g("", !0)
    ], 16, Qd1));
  }
}), fk1 = ["width", "height", "fill", "transform"], gk1 = { key: 0 }, xk1 = ["stroke"], jk1 = ["stroke"], mk1 = ["stroke"], Mk1 = ["stroke"], vk1 = { key: 1 }, Sk1 = /* @__PURE__ */ e("path", {
  d: "M132.5,181.2A64,64,0,1,0,194.7,69.9a8.6,8.6,0,0,1-4-4.2,68,68,0,0,0-125.4,0,8.6,8.6,0,0,1-4,4.2,64,64,0,1,0,62.2,111.3A8.2,8.2,0,0,1,132.5,181.2Z",
  opacity: "0.2"
}, null, -1), Hk1 = ["stroke"], Ak1 = ["stroke"], Vk1 = ["stroke"], zk1 = ["stroke"], Zk1 = { key: 2 }, Ck1 = /* @__PURE__ */ e("path", { d: "M128,187.9h0a91.6,91.6,0,0,1-8,4.6V232a8,8,0,0,0,16,0V192.5a91.6,91.6,0,0,1-8-4.6Z" }, null, -1), bk1 = /* @__PURE__ */ e("path", { d: "M198.1,62.6a76,76,0,0,0-140.2,0A72.3,72.3,0,0,0,16,127.8C15.9,166.6,47.4,199,86.1,200a71.9,71.9,0,0,0,33.9-7.5V156.9L76.4,135.2a8,8,0,1,1,7.2-14.4L120,139.1V88a8,8,0,0,1,16,0v27.1l36.4-18.3a8,8,0,0,1,7.2,14.4L136,132.9v59.6a72,72,0,0,0,32,7.5h1.9c38.7-1,70.2-33.4,70.1-72.2A72.3,72.3,0,0,0,198.1,62.6Z" }, null, -1), Lk1 = [
  Ck1,
  bk1
], Bk1 = { key: 3 }, Pk1 = ["stroke"], Wk1 = ["stroke"], Nk1 = ["stroke"], Fk1 = ["stroke"], Tk1 = { key: 4 }, Dk1 = ["stroke"], Rk1 = ["stroke"], Uk1 = ["stroke"], qk1 = ["stroke"], Gk1 = { key: 5 }, Ek1 = ["stroke"], Ok1 = ["stroke"], Ik1 = ["stroke"], Kk1 = ["stroke"], Xk1 = {
  name: "PhTree"
}, fnl = /* @__PURE__ */ $({
  ...Xk1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", gk1, [
        e("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xk1),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "80",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jk1),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mk1),
        e("path", {
          d: "M132.5,181.2A64,64,0,1,0,194.7,69.9a8.6,8.6,0,0,1-4-4.2,68,68,0,0,0-125.4,0,8.6,8.6,0,0,1-4,4.2,64,64,0,1,0,62.2,111.3A8.2,8.2,0,0,1,132.5,181.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mk1)
      ])) : o(i) === "duotone" ? (s(), r("g", vk1, [
        Sk1,
        e("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hk1),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "80",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ak1),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vk1),
        e("path", {
          d: "M132.5,181.2A64,64,0,1,0,194.7,69.9a8.6,8.6,0,0,1-4-4.2,68,68,0,0,0-125.4,0,8.6,8.6,0,0,1-4,4.2,64,64,0,1,0,62.2,111.3A8.2,8.2,0,0,1,132.5,181.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zk1)
      ])) : o(i) === "fill" ? (s(), r("g", Zk1, Lk1)) : o(i) === "light" ? (s(), r("g", Bk1, [
        e("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Pk1),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "80",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wk1),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Nk1),
        e("path", {
          d: "M132.5,181.2A64,64,0,1,0,194.7,69.9a8.6,8.6,0,0,1-4-4.2,68,68,0,0,0-125.4,0,8.6,8.6,0,0,1-4,4.2,64,64,0,1,0,62.2,111.3A8.2,8.2,0,0,1,132.5,181.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fk1)
      ])) : o(i) === "thin" ? (s(), r("g", Tk1, [
        e("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Dk1),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "80",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Rk1),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Uk1),
        e("path", {
          d: "M132.5,181.2A64,64,0,1,0,194.7,69.9a8.6,8.6,0,0,1-4-4.2,68,68,0,0,0-125.4,0,8.6,8.6,0,0,1-4,4.2,64,64,0,1,0,62.2,111.3A8.2,8.2,0,0,1,132.5,181.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qk1)
      ])) : o(i) === "regular" ? (s(), r("g", Gk1, [
        e("line", {
          x1: "128",
          y1: "232",
          x2: "128",
          y2: "88",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ek1),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "80",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ok1),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ik1),
        e("path", {
          d: "M132.5,181.2A64,64,0,1,0,194.7,69.9a8.6,8.6,0,0,1-4-4.2,68,68,0,0,0-125.4,0,8.6,8.6,0,0,1-4,4.2,64,64,0,1,0,62.2,111.3A8.2,8.2,0,0,1,132.5,181.2Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kk1)
      ])) : g("", !0)
    ], 16, fk1));
  }
}), Jk1 = ["width", "height", "fill", "transform"], Qk1 = { key: 0 }, Yk1 = ["stroke"], oc1 = ["stroke"], ec1 = { key: 1 }, tc1 = /* @__PURE__ */ e("polygon", {
  points: "128 16 48 120 88 120 32 192 224 192 168 120 208 120 128 16",
  opacity: "0.2"
}, null, -1), nc1 = ["stroke"], sc1 = ["stroke"], rc1 = { key: 2 }, ic1 = /* @__PURE__ */ e("path", { d: "M231.2,195.5A8,8,0,0,1,224,200H136v40a8,8,0,0,1-16,0V200H32a8,8,0,0,1-6.3-12.9L71.6,128H48a8,8,0,0,1-6.3-12.9l80-104a8,8,0,0,1,12.6,0l80,104A8,8,0,0,1,208,128H184.4l45.9,59.1A8,8,0,0,1,231.2,195.5Z" }, null, -1), lc1 = [
  ic1
], dc1 = { key: 3 }, kc1 = ["stroke"], cc1 = ["stroke"], hc1 = { key: 4 }, uc1 = ["stroke"], ac1 = ["stroke"], _c1 = { key: 5 }, pc1 = ["stroke"], yc1 = ["stroke"], $c1 = {
  name: "PhTreeEvergreen"
}, gnl = /* @__PURE__ */ $({
  ...$c1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Qk1, [
        e("polygon", {
          points: "128 16 48 120 88 120 32 192 224 192 168 120 208 120 128 16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Yk1),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, oc1)
      ])) : o(i) === "duotone" ? (s(), r("g", ec1, [
        tc1,
        e("polygon", {
          points: "128 16 48 120 88 120 32 192 224 192 168 120 208 120 128 16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nc1),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sc1)
      ])) : o(i) === "fill" ? (s(), r("g", rc1, lc1)) : o(i) === "light" ? (s(), r("g", dc1, [
        e("polygon", {
          points: "128 16 48 120 88 120 32 192 224 192 168 120 208 120 128 16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kc1),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cc1)
      ])) : o(i) === "thin" ? (s(), r("g", hc1, [
        e("polygon", {
          points: "128 16 48 120 88 120 32 192 224 192 168 120 208 120 128 16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uc1),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ac1)
      ])) : o(i) === "regular" ? (s(), r("g", _c1, [
        e("polygon", {
          points: "128 16 48 120 88 120 32 192 224 192 168 120 208 120 128 16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pc1),
        e("line", {
          x1: "128",
          y1: "192",
          x2: "128",
          y2: "240",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yc1)
      ])) : g("", !0)
    ], 16, Jk1));
  }
}), wc1 = ["width", "height", "fill", "transform"], fc1 = { key: 0 }, gc1 = ["stroke"], xc1 = ["stroke"], jc1 = ["stroke"], mc1 = ["stroke"], Mc1 = ["stroke"], vc1 = { key: 1 }, Sc1 = /* @__PURE__ */ e("rect", {
  x: "24",
  y: "100",
  width: "56",
  height: "56",
  rx: "8",
  opacity: "0.2"
}, null, -1), Hc1 = /* @__PURE__ */ e("rect", {
  x: "160",
  y: "40",
  width: "64",
  height: "64",
  rx: "8",
  opacity: "0.2"
}, null, -1), Ac1 = /* @__PURE__ */ e("rect", {
  x: "160",
  y: "152",
  width: "64",
  height: "64",
  rx: "8",
  opacity: "0.2"
}, null, -1), Vc1 = ["stroke"], zc1 = ["stroke"], Zc1 = ["stroke"], Cc1 = ["stroke"], bc1 = ["stroke"], Lc1 = { key: 2 }, Bc1 = /* @__PURE__ */ e("path", { d: "M156,92V80H144a16,16,0,0,0-16,16v64a16,16,0,0,0,16,16h12V164a16,16,0,0,1,16-16h40a16,16,0,0,1,16,16v40a16,16,0,0,1-16,16H172a16,16,0,0,1-16-16V192H144a32.1,32.1,0,0,1-32-32V136H84v8a16,16,0,0,1-16,16H36a16,16,0,0,1-16-16V112A16,16,0,0,1,36,96H68a16,16,0,0,1,16,16v8h28V96a32.1,32.1,0,0,1,32-32h12V52a16,16,0,0,1,16-16h40a16,16,0,0,1,16,16V92a16,16,0,0,1-16,16H172A16,16,0,0,1,156,92Z" }, null, -1), Pc1 = [
  Bc1
], Wc1 = { key: 3 }, Nc1 = ["stroke"], Fc1 = ["stroke"], Tc1 = ["stroke"], Dc1 = ["stroke"], Rc1 = ["stroke"], Uc1 = { key: 4 }, qc1 = ["stroke"], Gc1 = ["stroke"], Ec1 = ["stroke"], Oc1 = ["stroke"], Ic1 = ["stroke"], Kc1 = { key: 5 }, Xc1 = ["stroke"], Jc1 = ["stroke"], Qc1 = ["stroke"], Yc1 = ["stroke"], oh1 = ["stroke"], eh1 = {
  name: "PhTreeStructure"
}, xnl = /* @__PURE__ */ $({
  ...eh1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", fc1, [
        e("rect", {
          x: "24",
          y: "100",
          width: "56",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gc1),
        e("rect", {
          x: "160",
          y: "40",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xc1),
        e("rect", {
          x: "160",
          y: "152",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jc1),
        e("line", {
          x1: "80",
          y1: "128",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mc1),
        e("path", {
          d: "M160,184H144a23.9,23.9,0,0,1-24-24V96a23.9,23.9,0,0,1,24-24h16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mc1)
      ])) : o(i) === "duotone" ? (s(), r("g", vc1, [
        Sc1,
        Hc1,
        Ac1,
        e("rect", {
          x: "24",
          y: "100",
          width: "56",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vc1),
        e("rect", {
          x: "160",
          y: "40",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zc1),
        e("rect", {
          x: "160",
          y: "152",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zc1),
        e("line", {
          x1: "80",
          y1: "128",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cc1),
        e("path", {
          d: "M160,184H144a23.9,23.9,0,0,1-24-24V96a23.9,23.9,0,0,1,24-24h16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bc1)
      ])) : o(i) === "fill" ? (s(), r("g", Lc1, Pc1)) : o(i) === "light" ? (s(), r("g", Wc1, [
        e("rect", {
          x: "24",
          y: "100",
          width: "56",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Nc1),
        e("rect", {
          x: "160",
          y: "40",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fc1),
        e("rect", {
          x: "160",
          y: "152",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Tc1),
        e("line", {
          x1: "80",
          y1: "128",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dc1),
        e("path", {
          d: "M160,184H144a23.9,23.9,0,0,1-24-24V96a23.9,23.9,0,0,1,24-24h16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rc1)
      ])) : o(i) === "thin" ? (s(), r("g", Uc1, [
        e("rect", {
          x: "24",
          y: "100",
          width: "56",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qc1),
        e("rect", {
          x: "160",
          y: "40",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gc1),
        e("rect", {
          x: "160",
          y: "152",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ec1),
        e("line", {
          x1: "80",
          y1: "128",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Oc1),
        e("path", {
          d: "M160,184H144a23.9,23.9,0,0,1-24-24V96a23.9,23.9,0,0,1,24-24h16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ic1)
      ])) : o(i) === "regular" ? (s(), r("g", Kc1, [
        e("rect", {
          x: "24",
          y: "100",
          width: "56",
          height: "56",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xc1),
        e("rect", {
          x: "160",
          y: "40",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jc1),
        e("rect", {
          x: "160",
          y: "152",
          width: "64",
          height: "64",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qc1),
        e("line", {
          x1: "80",
          y1: "128",
          x2: "120",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yc1),
        e("path", {
          d: "M160,184H144a23.9,23.9,0,0,1-24-24V96a23.9,23.9,0,0,1,24-24h16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oh1)
      ])) : g("", !0)
    ], 16, wc1));
  }
}), th1 = ["width", "height", "fill", "transform"], nh1 = { key: 0 }, sh1 = ["stroke"], rh1 = ["stroke"], ih1 = { key: 1 }, lh1 = ["stroke"], dh1 = ["stroke"], kh1 = { key: 2 }, ch1 = /* @__PURE__ */ e("path", { d: "M240,136v64a8,8,0,0,1-8,8H168a8.1,8.1,0,0,1-7.4-4.9,8.4,8.4,0,0,1,1.7-8.8L188.7,168,136,115.3l-34.3,34.4a8.1,8.1,0,0,1-11.4,0l-72-72A8.1,8.1,0,0,1,29.7,66.3L96,132.7l34.3-34.4a8.1,8.1,0,0,1,11.4,0L200,156.7l26.3-26.4a8.4,8.4,0,0,1,8.8-1.7A8,8,0,0,1,240,136Z" }, null, -1), hh1 = [
  ch1
], uh1 = { key: 3 }, ah1 = ["stroke"], _h1 = ["stroke"], ph1 = { key: 4 }, yh1 = ["stroke"], $h1 = ["stroke"], wh1 = { key: 5 }, fh1 = ["stroke"], gh1 = ["stroke"], xh1 = {
  name: "PhTrendDown"
}, jnl = /* @__PURE__ */ $({
  ...xh1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", nh1, [
        e("polyline", {
          points: "232 200 136 104 96 144 24 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sh1),
        e("polyline", {
          points: "232 136 232 200 168 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rh1)
      ])) : o(i) === "duotone" ? (s(), r("g", ih1, [
        e("polyline", {
          points: "232 200 136 104 96 144 24 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lh1),
        e("polyline", {
          points: "232 136 232 200 168 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dh1)
      ])) : o(i) === "fill" ? (s(), r("g", kh1, hh1)) : o(i) === "light" ? (s(), r("g", uh1, [
        e("polyline", {
          points: "232 200 136 104 96 144 24 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ah1),
        e("polyline", {
          points: "232 136 232 200 168 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _h1)
      ])) : o(i) === "thin" ? (s(), r("g", ph1, [
        e("polyline", {
          points: "232 200 136 104 96 144 24 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, yh1),
        e("polyline", {
          points: "232 136 232 200 168 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $h1)
      ])) : o(i) === "regular" ? (s(), r("g", wh1, [
        e("polyline", {
          points: "232 200 136 104 96 144 24 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fh1),
        e("polyline", {
          points: "232 136 232 200 168 200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gh1)
      ])) : g("", !0)
    ], 16, th1));
  }
}), jh1 = ["width", "height", "fill", "transform"], mh1 = { key: 0 }, Mh1 = ["stroke"], vh1 = ["stroke"], Sh1 = { key: 1 }, Hh1 = ["stroke"], Ah1 = ["stroke"], Vh1 = { key: 2 }, zh1 = /* @__PURE__ */ e("path", { d: "M240,56v64a8,8,0,0,1-4.9,7.4,8.5,8.5,0,0,1-3.1.6,8.3,8.3,0,0,1-5.7-2.3L200,99.3l-58.3,58.4a8.1,8.1,0,0,1-11.4,0L96,123.3,29.7,189.7A8.3,8.3,0,0,1,24,192a8.5,8.5,0,0,1-5.7-2.3,8.1,8.1,0,0,1,0-11.4l72-72a8.1,8.1,0,0,1,11.4,0L136,140.7,188.7,88,162.3,61.7a8.4,8.4,0,0,1-1.7-8.8A8.1,8.1,0,0,1,168,48h64A8,8,0,0,1,240,56Z" }, null, -1), Zh1 = [
  zh1
], Ch1 = { key: 3 }, bh1 = ["stroke"], Lh1 = ["stroke"], Bh1 = { key: 4 }, Ph1 = ["stroke"], Wh1 = ["stroke"], Nh1 = { key: 5 }, Fh1 = ["stroke"], Th1 = ["stroke"], Dh1 = {
  name: "PhTrendUp"
}, mnl = /* @__PURE__ */ $({
  ...Dh1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", mh1, [
        e("polyline", {
          points: "232 56 136 152 96 112 24 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mh1),
        e("polyline", {
          points: "232 120 232 56 168 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vh1)
      ])) : o(i) === "duotone" ? (s(), r("g", Sh1, [
        e("polyline", {
          points: "232 56 136 152 96 112 24 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hh1),
        e("polyline", {
          points: "232 120 232 56 168 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ah1)
      ])) : o(i) === "fill" ? (s(), r("g", Vh1, Zh1)) : o(i) === "light" ? (s(), r("g", Ch1, [
        e("polyline", {
          points: "232 56 136 152 96 112 24 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bh1),
        e("polyline", {
          points: "232 120 232 56 168 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Lh1)
      ])) : o(i) === "thin" ? (s(), r("g", Bh1, [
        e("polyline", {
          points: "232 56 136 152 96 112 24 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ph1),
        e("polyline", {
          points: "232 120 232 56 168 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wh1)
      ])) : o(i) === "regular" ? (s(), r("g", Nh1, [
        e("polyline", {
          points: "232 56 136 152 96 112 24 184",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fh1),
        e("polyline", {
          points: "232 120 232 56 168 56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Th1)
      ])) : g("", !0)
    ], 16, jh1));
  }
}), Rh1 = ["width", "height", "fill", "transform"], Uh1 = { key: 0 }, qh1 = ["stroke"], Gh1 = { key: 1 }, Eh1 = /* @__PURE__ */ e("path", {
  d: "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
  opacity: "0.2"
}, null, -1), Oh1 = ["stroke"], Ih1 = { key: 2 }, Kh1 = /* @__PURE__ */ e("path", { d: "M236.7,188,148.8,36a24,24,0,0,0-41.6,0h0L19.3,188A23.9,23.9,0,0,0,40,224H216a23.9,23.9,0,0,0,20.7-36Z" }, null, -1), Xh1 = [
  Kh1
], Jh1 = { key: 3 }, Qh1 = ["stroke"], Yh1 = { key: 4 }, o61 = ["stroke"], e61 = { key: 5 }, t61 = ["stroke"], n61 = {
  name: "PhTriangle"
}, Mnl = /* @__PURE__ */ $({
  ...n61,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Uh1, [
        e("path", {
          d: "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qh1)
      ])) : o(i) === "duotone" ? (s(), r("g", Gh1, [
        Eh1,
        e("path", {
          d: "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Oh1)
      ])) : o(i) === "fill" ? (s(), r("g", Ih1, Xh1)) : o(i) === "light" ? (s(), r("g", Jh1, [
        e("path", {
          d: "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qh1)
      ])) : o(i) === "thin" ? (s(), r("g", Yh1, [
        e("path", {
          d: "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, o61)
      ])) : o(i) === "regular" ? (s(), r("g", e61, [
        e("path", {
          d: "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t61)
      ])) : g("", !0)
    ], 16, Rh1));
  }
}), s61 = ["width", "height", "fill", "transform"], r61 = { key: 0 }, i61 = ["stroke"], l61 = ["stroke"], d61 = ["stroke"], k61 = ["stroke"], c61 = ["stroke"], h61 = { key: 1 }, u61 = /* @__PURE__ */ e("path", {
  d: "M56,56v55.1c0,39.7,31.8,72.6,71.5,72.9A72,72,0,0,0,200,112V56a8,8,0,0,0-8-8H64A8,8,0,0,0,56,56Z",
  opacity: "0.2"
}, null, -1), a61 = ["stroke"], _61 = ["stroke"], p61 = ["stroke"], y61 = ["stroke"], $61 = ["stroke"], w61 = { key: 2 }, f61 = /* @__PURE__ */ e("path", { d: "M232,64H208V56a16,16,0,0,0-16-16H64A16,16,0,0,0,48,56v8H23.9a16,16,0,0,0-16,16V96a40,40,0,0,0,40,40h4c9.7,29.9,36.2,52.3,68.1,55.6V216H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16H136V191.6A79.7,79.7,0,0,0,204.3,136H208a40,40,0,0,0,40-40V80A16,16,0,0,0,232,64ZM47.9,120a24,24,0,0,1-24-24V80H48v31.1a86.9,86.9,0,0,0,.5,8.9ZM232,96a24.1,24.1,0,0,1-24,24h-.4a70.3,70.3,0,0,0,.4-8V80h24Z" }, null, -1), g61 = [
  f61
], x61 = { key: 3 }, j61 = ["stroke"], m61 = ["stroke"], M61 = ["stroke"], v61 = ["stroke"], S61 = ["stroke"], H61 = { key: 4 }, A61 = ["stroke"], V61 = ["stroke"], z61 = ["stroke"], Z61 = ["stroke"], C61 = ["stroke"], b61 = { key: 5 }, L61 = ["stroke"], B61 = ["stroke"], P61 = ["stroke"], W61 = ["stroke"], N61 = ["stroke"], F61 = {
  name: "PhTrophy"
}, vnl = /* @__PURE__ */ $({
  ...F61,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", r61, [
        e("path", {
          d: "M56,56v55.1c0,39.7,31.8,72.6,71.5,72.9A72,72,0,0,0,200,112V56a8,8,0,0,0-8-8H64A8,8,0,0,0,56,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, i61),
        e("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, l61),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, d61),
        e("path", {
          d: "M198.2,128H208a32,32,0,0,0,32-32V80a8,8,0,0,0-8-8H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, k61),
        e("path", {
          d: "M58,128H47.9a32,32,0,0,1-32-32V80a8,8,0,0,1,8-8h32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, c61)
      ])) : o(i) === "duotone" ? (s(), r("g", h61, [
        u61,
        e("path", {
          d: "M56,56v55.1c0,39.7,31.8,72.6,71.5,72.9A72,72,0,0,0,200,112V56a8,8,0,0,0-8-8H64A8,8,0,0,0,56,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a61),
        e("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _61),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p61),
        e("path", {
          d: "M198.2,128H208a32,32,0,0,0,32-32V80a8,8,0,0,0-8-8H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, y61),
        e("path", {
          d: "M58,128H47.9a32,32,0,0,1-32-32V80a8,8,0,0,1,8-8h32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $61)
      ])) : o(i) === "fill" ? (s(), r("g", w61, g61)) : o(i) === "light" ? (s(), r("g", x61, [
        e("path", {
          d: "M56,56v55.1c0,39.7,31.8,72.6,71.5,72.9A72,72,0,0,0,200,112V56a8,8,0,0,0-8-8H64A8,8,0,0,0,56,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, j61),
        e("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, m61),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, M61),
        e("path", {
          d: "M198.2,128H208a32,32,0,0,0,32-32V80a8,8,0,0,0-8-8H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, v61),
        e("path", {
          d: "M58,128H47.9a32,32,0,0,1-32-32V80a8,8,0,0,1,8-8h32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, S61)
      ])) : o(i) === "thin" ? (s(), r("g", H61, [
        e("path", {
          d: "M56,56v55.1c0,39.7,31.8,72.6,71.5,72.9A72,72,0,0,0,200,112V56a8,8,0,0,0-8-8H64A8,8,0,0,0,56,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, A61),
        e("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, V61),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, z61),
        e("path", {
          d: "M198.2,128H208a32,32,0,0,0,32-32V80a8,8,0,0,0-8-8H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Z61),
        e("path", {
          d: "M58,128H47.9a32,32,0,0,1-32-32V80a8,8,0,0,1,8-8h32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, C61)
      ])) : o(i) === "regular" ? (s(), r("g", b61, [
        e("path", {
          d: "M56,56v55.1c0,39.7,31.8,72.6,71.5,72.9A72,72,0,0,0,200,112V56a8,8,0,0,0-8-8H64A8,8,0,0,0,56,56Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L61),
        e("line", {
          x1: "96",
          y1: "224",
          x2: "160",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B61),
        e("line", {
          x1: "128",
          y1: "184",
          x2: "128",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P61),
        e("path", {
          d: "M198.2,128H208a32,32,0,0,0,32-32V80a8,8,0,0,0-8-8H200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W61),
        e("path", {
          d: "M58,128H47.9a32,32,0,0,1-32-32V80a8,8,0,0,1,8-8h32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, N61)
      ])) : g("", !0)
    ], 16, s61));
  }
}), T61 = ["width", "height", "fill", "transform"], D61 = { key: 0 }, R61 = ["stroke"], U61 = ["stroke"], q61 = ["stroke"], G61 = ["stroke"], E61 = ["stroke"], O61 = ["stroke"], I61 = ["stroke"], K61 = { key: 1 }, X61 = /* @__PURE__ */ e("path", {
  d: "M176,144H16v40a8,8,0,0,0,8,8H44a24,24,0,0,1,48,0h72a24,24,0,0,1,12-20.8Z",
  opacity: "0.2"
}, null, -1), J61 = /* @__PURE__ */ e("path", {
  d: "M212,192a24,24,0,0,0-36-20.8V120h64v64a8,8,0,0,1-8,8H212",
  opacity: "0.2"
}, null, -1), Q61 = ["stroke"], Y61 = ["stroke"], ou1 = ["stroke"], eu1 = ["stroke"], tu1 = ["stroke"], nu1 = ["stroke"], su1 = ["stroke"], ru1 = { key: 2 }, iu1 = /* @__PURE__ */ e("path", { d: "M248,119.9v-.2a1.7,1.7,0,0,0-.1-.7v-.3c0-.2-.1-.4-.1-.6v-.2l-.2-.8h-.1l-14-34.8A15.7,15.7,0,0,0,218.6,72H184V64a8,8,0,0,0-8-8H24A16,16,0,0,0,8,72V184a16,16,0,0,0,16,16H37a32,32,0,0,0,62,0h58a32,32,0,0,0,62,0h13a16,16,0,0,0,16-16V120ZM184,88h34.6l9.6,24H184ZM24,72H168v64H24ZM68,208a16,16,0,1,1,16-16A16,16,0,0,1,68,208Zm120,0a16,16,0,1,1,16-16A16,16,0,0,1,188,208Z" }, null, -1), lu1 = [
  iu1
], du1 = { key: 3 }, ku1 = ["stroke"], cu1 = ["stroke"], hu1 = ["stroke"], uu1 = ["stroke"], au1 = ["stroke"], _u1 = ["stroke"], pu1 = ["stroke"], yu1 = { key: 4 }, $u1 = ["stroke"], wu1 = ["stroke"], fu1 = ["stroke"], gu1 = ["stroke"], xu1 = ["stroke"], ju1 = ["stroke"], mu1 = ["stroke"], Mu1 = { key: 5 }, vu1 = ["stroke"], Su1 = ["stroke"], Hu1 = ["stroke"], Au1 = ["stroke"], Vu1 = ["stroke"], zu1 = ["stroke"], Zu1 = ["stroke"], Cu1 = {
  name: "PhTruck"
}, Snl = /* @__PURE__ */ $({
  ...Cu1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", D61, [
        e("path", {
          d: "M176,80h42.6a7.9,7.9,0,0,1,7.4,5l14,35",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, R61),
        e("line", {
          x1: "16",
          y1: "144",
          x2: "176",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, U61),
        e("circle", {
          cx: "180",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, q61),
        e("circle", {
          cx: "76",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, G61),
        e("line", {
          x1: "156",
          y1: "192",
          x2: "100",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, E61),
        e("path", {
          d: "M52,192H24a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H176V168.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, O61),
        e("path", {
          d: "M176,120h64v64a8,8,0,0,1-8,8H204",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, I61)
      ])) : o(i) === "duotone" ? (s(), r("g", K61, [
        X61,
        J61,
        e("path", {
          d: "M176,80h42.6a7.9,7.9,0,0,1,7.4,5l14,35",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q61),
        e("line", {
          x1: "16",
          y1: "144",
          x2: "176",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y61),
        e("circle", {
          cx: "188",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, ou1),
        e("circle", {
          cx: "68",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, eu1),
        e("line", {
          x1: "164",
          y1: "192",
          x2: "92",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tu1),
        e("path", {
          d: "M44,192H24a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H176V171.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nu1),
        e("path", {
          d: "M176,120h64v64a8,8,0,0,1-8,8H212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, su1)
      ])) : o(i) === "fill" ? (s(), r("g", ru1, lu1)) : o(i) === "light" ? (s(), r("g", du1, [
        e("path", {
          d: "M176,80h42.6a7.9,7.9,0,0,1,7.4,5l14,35",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ku1),
        e("line", {
          x1: "16",
          y1: "144",
          x2: "176",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cu1),
        e("circle", {
          cx: "188",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hu1),
        e("circle", {
          cx: "68",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uu1),
        e("line", {
          x1: "164",
          y1: "192",
          x2: "92",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, au1),
        e("path", {
          d: "M44,192H24a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H176V171.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _u1),
        e("path", {
          d: "M176,120h64v64a8,8,0,0,1-8,8H212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pu1)
      ])) : o(i) === "thin" ? (s(), r("g", yu1, [
        e("path", {
          d: "M176,80h42.6a7.9,7.9,0,0,1,7.4,5l14,35",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $u1),
        e("line", {
          x1: "16",
          y1: "144",
          x2: "176",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wu1),
        e("circle", {
          cx: "188",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fu1),
        e("circle", {
          cx: "68",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gu1),
        e("line", {
          x1: "164",
          y1: "192",
          x2: "92",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xu1),
        e("path", {
          d: "M44,192H24a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H176V171.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ju1),
        e("path", {
          d: "M176,120h64v64a8,8,0,0,1-8,8H212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mu1)
      ])) : o(i) === "regular" ? (s(), r("g", Mu1, [
        e("path", {
          d: "M176,80h42.6a7.9,7.9,0,0,1,7.4,5l14,35",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vu1),
        e("line", {
          x1: "16",
          y1: "144",
          x2: "176",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Su1),
        e("circle", {
          cx: "188",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Hu1),
        e("circle", {
          cx: "68",
          cy: "192",
          r: "24",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Au1),
        e("line", {
          x1: "164",
          y1: "192",
          x2: "92",
          y2: "192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vu1),
        e("path", {
          d: "M44,192H24a8,8,0,0,1-8-8V72a8,8,0,0,1,8-8H176V171.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zu1),
        e("path", {
          d: "M176,120h64v64a8,8,0,0,1-8,8H212",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zu1)
      ])) : g("", !0)
    ], 16, T61));
  }
}), bu1 = ["width", "height", "fill", "transform"], Lu1 = { key: 0 }, Bu1 = ["stroke"], Pu1 = ["stroke"], Wu1 = ["stroke"], Nu1 = { key: 1 }, Fu1 = /* @__PURE__ */ e("path", {
  d: "M165.1,200H122.9a7.8,7.8,0,0,0-5.1,1.9L72,240V200H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.3a8.1,8.1,0,0,1-2.9,6.1l-42.9,35.7A7.8,7.8,0,0,1,165.1,200Z",
  opacity: "0.2"
}, null, -1), Tu1 = ["stroke"], Du1 = ["stroke"], Ru1 = ["stroke"], Uu1 = { key: 2 }, qu1 = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V192a16,16,0,0,0,16,16H64v32a7.9,7.9,0,0,0,4.6,7.2,6.8,6.8,0,0,0,3.4.8,7.5,7.5,0,0,0,5.1-1.9L122.9,208h42.2a15.8,15.8,0,0,0,10.2-3.7l42.9-35.8a15.7,15.7,0,0,0,5.8-12.2V48A16,16,0,0,0,208,32ZM128,136a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Zm48,0a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z" }, null, -1), Gu1 = [
  qu1
], Eu1 = { key: 3 }, Ou1 = ["stroke"], Iu1 = ["stroke"], Ku1 = ["stroke"], Xu1 = { key: 4 }, Ju1 = ["stroke"], Qu1 = ["stroke"], Yu1 = ["stroke"], o41 = { key: 5 }, e41 = ["stroke"], t41 = ["stroke"], n41 = ["stroke"], s41 = {
  name: "PhTwitchLogo"
}, Hnl = /* @__PURE__ */ $({
  ...s41,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Lu1, [
        e("path", {
          d: "M165.1,200H122.9a7.8,7.8,0,0,0-5.1,1.9L72,240V200H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.3a8.1,8.1,0,0,1-2.9,6.1l-42.9,35.7A7.8,7.8,0,0,1,165.1,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Bu1),
        e("line", {
          x1: "168",
          y1: "88",
          x2: "168",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Pu1),
        e("line", {
          x1: "120",
          y1: "88",
          x2: "120",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Wu1)
      ])) : o(i) === "duotone" ? (s(), r("g", Nu1, [
        Fu1,
        e("path", {
          d: "M165.1,200H122.9a7.8,7.8,0,0,0-5.1,1.9L72,240V200H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.3a8.1,8.1,0,0,1-2.9,6.1l-42.9,35.7A7.8,7.8,0,0,1,165.1,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tu1),
        e("line", {
          x1: "168",
          y1: "88",
          x2: "168",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Du1),
        e("line", {
          x1: "120",
          y1: "88",
          x2: "120",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ru1)
      ])) : o(i) === "fill" ? (s(), r("g", Uu1, Gu1)) : o(i) === "light" ? (s(), r("g", Eu1, [
        e("path", {
          d: "M165.1,200H122.9a7.8,7.8,0,0,0-5.1,1.9L72,240V200H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.3a8.1,8.1,0,0,1-2.9,6.1l-42.9,35.7A7.8,7.8,0,0,1,165.1,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ou1),
        e("line", {
          x1: "168",
          y1: "88",
          x2: "168",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Iu1),
        e("line", {
          x1: "120",
          y1: "88",
          x2: "120",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ku1)
      ])) : o(i) === "thin" ? (s(), r("g", Xu1, [
        e("path", {
          d: "M165.1,200H122.9a7.8,7.8,0,0,0-5.1,1.9L72,240V200H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.3a8.1,8.1,0,0,1-2.9,6.1l-42.9,35.7A7.8,7.8,0,0,1,165.1,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ju1),
        e("line", {
          x1: "168",
          y1: "88",
          x2: "168",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qu1),
        e("line", {
          x1: "120",
          y1: "88",
          x2: "120",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Yu1)
      ])) : o(i) === "regular" ? (s(), r("g", o41, [
        e("path", {
          d: "M165.1,200H122.9a7.8,7.8,0,0,0-5.1,1.9L72,240V200H48a8,8,0,0,1-8-8V48a8,8,0,0,1,8-8H208a8,8,0,0,1,8,8V156.3a8.1,8.1,0,0,1-2.9,6.1l-42.9,35.7A7.8,7.8,0,0,1,165.1,200Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, e41),
        e("line", {
          x1: "168",
          y1: "88",
          x2: "168",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, t41),
        e("line", {
          x1: "120",
          y1: "88",
          x2: "120",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, n41)
      ])) : g("", !0)
    ], 16, bu1));
  }
}), r41 = ["width", "height", "fill", "transform"], i41 = { key: 0 }, l41 = ["stroke"], d41 = { key: 1 }, k41 = /* @__PURE__ */ e("path", {
  d: "M128,88c0-22,18.5-40.3,40.5-40a40,40,0,0,1,36.2,24H240l-32.3,32.3A127.9,127.9,0,0,1,80,224c-32,0-40-12-40-12s32-12,48-36c0,0-64-32-48-120,0,0,40,40,88,48Z",
  opacity: "0.2"
}, null, -1), c41 = ["stroke"], h41 = { key: 2 }, u41 = /* @__PURE__ */ e("path", { d: "M245.7,77.7l-30.2,30.1C209.5,177.7,150.5,232,80,232c-14.5,0-26.5-2.3-35.6-6.8-7.3-3.7-10.3-7.6-11.1-8.8a8,8,0,0,1,3.9-11.9c.2-.1,23.8-9.1,39.1-26.4a108.6,108.6,0,0,1-24.7-24.4c-13.7-18.6-28.2-50.9-19.5-99.1a8.1,8.1,0,0,1,5.5-6.2,8,8,0,0,1,8.1,1.9c.3.4,33.6,33.2,74.3,43.8V88a48.3,48.3,0,0,1,48.6-48,48.2,48.2,0,0,1,41,24H240a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,245.7,77.7Z" }, null, -1), a41 = [
  u41
], _41 = { key: 3 }, p41 = ["stroke"], y41 = { key: 4 }, $41 = ["stroke"], w41 = { key: 5 }, f41 = ["stroke"], g41 = {
  name: "PhTwitterLogo"
}, Anl = /* @__PURE__ */ $({
  ...g41,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", i41, [
        e("path", {
          d: "M128,88c0-22,18.5-40.3,40.5-40a40,40,0,0,1,36.2,24H240l-32.3,32.3A127.9,127.9,0,0,1,80,224c-32,0-40-12-40-12s32-12,48-36c0,0-64-32-48-120,0,0,40,40,88,48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, l41)
      ])) : o(i) === "duotone" ? (s(), r("g", d41, [
        k41,
        e("path", {
          d: "M128,88c0-22,18.5-40.3,40.5-40a40,40,0,0,1,36.2,24H240l-32.3,32.3A127.9,127.9,0,0,1,80,224c-32,0-40-12-40-12s32-12,48-36c0,0-64-32-48-120,0,0,40,40,88,48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c41)
      ])) : o(i) === "fill" ? (s(), r("g", h41, a41)) : o(i) === "light" ? (s(), r("g", _41, [
        e("path", {
          d: "M128,88c0-22,18.5-40.3,40.5-40a40,40,0,0,1,36.2,24H240l-32.3,32.3A127.9,127.9,0,0,1,80,224c-32,0-40-12-40-12s32-12,48-36c0,0-64-32-48-120,0,0,40,40,88,48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, p41)
      ])) : o(i) === "thin" ? (s(), r("g", y41, [
        e("path", {
          d: "M128,88c0-22,18.5-40.3,40.5-40a40,40,0,0,1,36.2,24H240l-32.3,32.3A127.9,127.9,0,0,1,80,224c-32,0-40-12-40-12s32-12,48-36c0,0-64-32-48-120,0,0,40,40,88,48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $41)
      ])) : o(i) === "regular" ? (s(), r("g", w41, [
        e("path", {
          d: "M128,88c0-22,18.5-40.3,40.5-40a40,40,0,0,1,36.2,24H240l-32.3,32.3A127.9,127.9,0,0,1,80,224c-32,0-40-12-40-12s32-12,48-36c0,0-64-32-48-120,0,0,40,40,88,48Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, f41)
      ])) : g("", !0)
    ], 16, r41));
  }
}), x41 = ["width", "height", "fill", "transform"], j41 = { key: 0 }, m41 = ["stroke"], M41 = ["stroke"], v41 = ["stroke"], S41 = { key: 1 }, H41 = /* @__PURE__ */ e("path", {
  d: "M128,32a103.9,103.9,0,0,1,103.6,95.3,7.9,7.9,0,0,1-7.9,8.7H168c0-72-40-104-40-104",
  opacity: "0.2"
}, null, -1), A41 = /* @__PURE__ */ e("path", {
  d: "M128,32A103.9,103.9,0,0,0,24.4,127.3a7.9,7.9,0,0,0,7.9,8.7H88c0-72,40-104,40-104",
  opacity: "0.2"
}, null, -1), V41 = ["stroke"], z41 = ["stroke"], Z41 = ["stroke"], C41 = { key: 2 }, b41 = /* @__PURE__ */ e("path", { d: "M239.6,126.6A112.1,112.1,0,0,0,128,24h0A112.1,112.1,0,0,0,16.4,126.6a15.7,15.7,0,0,0,4.2,12.2A15.9,15.9,0,0,0,32.3,144H120v56a32,32,0,0,0,64,0,8,8,0,0,0-16,0,16,16,0,0,1-32,0V144h87.7a15.9,15.9,0,0,0,11.7-5.2A15.7,15.7,0,0,0,239.6,126.6ZM32.3,128a95.9,95.9,0,0,1,75.9-85.9c-11.7,16-26.4,44-28,85.9Zm143.5,0c-1.6-41.9-16.3-69.9-28-85.9A95.9,95.9,0,0,1,223.7,128Z" }, null, -1), L41 = [
  b41
], B41 = { key: 3 }, P41 = ["stroke"], W41 = ["stroke"], N41 = ["stroke"], F41 = { key: 4 }, T41 = ["stroke"], D41 = ["stroke"], R41 = ["stroke"], U41 = { key: 5 }, q41 = ["stroke"], G41 = ["stroke"], E41 = ["stroke"], O41 = {
  name: "PhUmbrella"
}, Vnl = /* @__PURE__ */ $({
  ...O41,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", j41, [
        e("path", {
          d: "M176,200a24,24,0,0,1-48,0V136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, m41),
        e("path", {
          d: "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, M41),
        e("path", {
          d: "M88,136c0-72,40-104,40-104s40,32,40,104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, v41)
      ])) : o(i) === "duotone" ? (s(), r("g", S41, [
        H41,
        A41,
        e("path", {
          d: "M176,200a24,24,0,0,1-48,0V136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, V41),
        e("path", {
          d: "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, z41),
        e("path", {
          d: "M88,136c0-72,40-104,40-104s40,32,40,104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z41)
      ])) : o(i) === "fill" ? (s(), r("g", C41, L41)) : o(i) === "light" ? (s(), r("g", B41, [
        e("path", {
          d: "M176,200a24,24,0,0,1-48,0V136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, P41),
        e("path", {
          d: "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, W41),
        e("path", {
          d: "M88,136c0-72,40-104,40-104s40,32,40,104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, N41)
      ])) : o(i) === "thin" ? (s(), r("g", F41, [
        e("path", {
          d: "M176,200a24,24,0,0,1-48,0V136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, T41),
        e("path", {
          d: "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, D41),
        e("path", {
          d: "M88,136c0-72,40-104,40-104s40,32,40,104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, R41)
      ])) : o(i) === "regular" ? (s(), r("g", U41, [
        e("path", {
          d: "M176,200a24,24,0,0,1-48,0V136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q41),
        e("path", {
          d: "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G41),
        e("path", {
          d: "M88,136c0-72,40-104,40-104s40,32,40,104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E41)
      ])) : g("", !0)
    ], 16, x41));
  }
}), I41 = ["width", "height", "fill", "transform"], K41 = { key: 0 }, X41 = ["stroke"], J41 = ["stroke"], Q41 = { key: 1 }, Y41 = /* @__PURE__ */ e("path", {
  d: "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
  opacity: "0.2"
}, null, -1), oa1 = ["stroke"], ea1 = ["stroke"], ta1 = { key: 2 }, na1 = /* @__PURE__ */ e("path", { d: "M235.4,138.8a15.9,15.9,0,0,1-11.7,5.2H136v56a16,16,0,0,0,32,0,8,8,0,0,1,16,0,32,32,0,0,1-64,0V144H32.3a15.9,15.9,0,0,1-11.7-5.2,15.7,15.7,0,0,1-4.2-12.2A111.9,111.9,0,0,1,204,53.8a110.9,110.9,0,0,1,35.6,72.8A15.7,15.7,0,0,1,235.4,138.8Z" }, null, -1), sa1 = [
  na1
], ra1 = { key: 3 }, ia1 = ["stroke"], la1 = ["stroke"], da1 = { key: 4 }, ka1 = ["stroke"], ca1 = ["stroke"], ha1 = { key: 5 }, ua1 = ["stroke"], aa1 = ["stroke"], _a1 = {
  name: "PhUmbrellaSimple"
}, znl = /* @__PURE__ */ $({
  ..._a1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", K41, [
        e("path", {
          d: "M176,200a24,24,0,0,1-48,0V136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X41),
        e("path", {
          d: "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, J41)
      ])) : o(i) === "duotone" ? (s(), r("g", Q41, [
        Y41,
        e("path", {
          d: "M176,200a24,24,0,0,1-48,0V136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oa1),
        e("path", {
          d: "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ea1)
      ])) : o(i) === "fill" ? (s(), r("g", ta1, sa1)) : o(i) === "light" ? (s(), r("g", ra1, [
        e("path", {
          d: "M176,200a24,24,0,0,1-48,0V136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ia1),
        e("path", {
          d: "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, la1)
      ])) : o(i) === "thin" ? (s(), r("g", da1, [
        e("path", {
          d: "M176,200a24,24,0,0,1-48,0V136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ka1),
        e("path", {
          d: "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ca1)
      ])) : o(i) === "regular" ? (s(), r("g", ha1, [
        e("path", {
          d: "M176,200a24,24,0,0,1-48,0V136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ua1),
        e("path", {
          d: "M32.3,136a7.9,7.9,0,0,1-7.9-8.7,104,104,0,0,1,207.2,0,7.9,7.9,0,0,1-7.9,8.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aa1)
      ])) : g("", !0)
    ], 16, I41));
  }
}), pa1 = ["width", "height", "fill", "transform"], ya1 = { key: 0 }, $a1 = ["stroke"], wa1 = ["stroke"], fa1 = ["stroke"], ga1 = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "168",
  r: "16"
}, null, -1), xa1 = { key: 1 }, ja1 = /* @__PURE__ */ e("rect", {
  x: "24",
  y: "128",
  width: "208",
  height: "80",
  rx: "8",
  opacity: "0.2"
}, null, -1), ma1 = ["stroke"], Ma1 = ["stroke"], va1 = ["stroke"], Sa1 = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "168",
  r: "12"
}, null, -1), Ha1 = { key: 2 }, Aa1 = /* @__PURE__ */ e("path", { d: "M74.3,77.7a8.1,8.1,0,0,1,0-11.4l48-48a8.1,8.1,0,0,1,11.4,0l48,48a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0L136,43.3V128a8,8,0,0,1-16,0V43.3L85.7,77.7A8.1,8.1,0,0,1,74.3,77.7ZM240,136v64a16,16,0,0,1-16,16H32a16,16,0,0,1-16-16V136a16,16,0,0,1,16-16h68a4,4,0,0,1,4,4v3.5c0,13.4,11,24.8,24.5,24.5A24,24,0,0,0,152,128v-4a4,4,0,0,1,4-4h68A16,16,0,0,1,240,136Zm-40,32a12,12,0,1,0-12,12A12,12,0,0,0,200,168Z" }, null, -1), Va1 = [
  Aa1
], za1 = { key: 3 }, Za1 = ["stroke"], Ca1 = ["stroke"], ba1 = ["stroke"], La1 = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "168",
  r: "10"
}, null, -1), Ba1 = { key: 4 }, Pa1 = ["stroke"], Wa1 = ["stroke"], Na1 = ["stroke"], Fa1 = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "168",
  r: "8"
}, null, -1), Ta1 = { key: 5 }, Da1 = ["stroke"], Ra1 = ["stroke"], Ua1 = ["stroke"], qa1 = /* @__PURE__ */ e("circle", {
  cx: "188",
  cy: "168",
  r: "12"
}, null, -1), Ga1 = {
  name: "PhUpload"
}, Znl = /* @__PURE__ */ $({
  ...Ga1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ya1, [
        e("path", {
          d: "M172,128h52a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $a1),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wa1),
        e("polyline", {
          points: "80 72 128 24 176 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fa1),
        ga1
      ])) : o(i) === "duotone" ? (s(), r("g", xa1, [
        ja1,
        e("path", {
          d: "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ma1),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ma1),
        e("polyline", {
          points: "80 72 128 24 176 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, va1),
        Sa1
      ])) : o(i) === "fill" ? (s(), r("g", Ha1, Va1)) : o(i) === "light" ? (s(), r("g", za1, [
        e("path", {
          d: "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Za1),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ca1),
        e("polyline", {
          points: "80 72 128 24 176 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ba1),
        La1
      ])) : o(i) === "thin" ? (s(), r("g", Ba1, [
        e("path", {
          d: "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pa1),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wa1),
        e("polyline", {
          points: "80 72 128 24 176 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Na1),
        Fa1
      ])) : o(i) === "regular" ? (s(), r("g", Ta1, [
        e("path", {
          d: "M176,128h48a8,8,0,0,1,8,8v64a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V136a8,8,0,0,1,8-8H80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Da1),
        e("line", {
          x1: "128",
          y1: "128",
          x2: "128",
          y2: "24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ra1),
        e("polyline", {
          points: "80 72 128 24 176 72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ua1),
        qa1
      ])) : g("", !0)
    ], 16, pa1));
  }
}), Ea1 = ["width", "height", "fill", "transform"], Oa1 = { key: 0 }, Ia1 = ["stroke"], Ka1 = ["stroke"], Xa1 = ["stroke"], Ja1 = { key: 1 }, Qa1 = ["stroke"], Ya1 = ["stroke"], o_1 = ["stroke"], e_1 = { key: 2 }, t_1 = /* @__PURE__ */ e("path", { d: "M78.6,85a8.2,8.2,0,0,1,1.7-8.7l42-42a8.1,8.1,0,0,1,11.4,0l42,42a8.2,8.2,0,0,1,1.7,8.7,8,8,0,0,1-7.4,5H136v62a8,8,0,0,1-16,0V90H86A8,8,0,0,1,78.6,85ZM216,144a8,8,0,0,0-8,8v56H48V152a8,8,0,0,0-16,0v56a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V152A8,8,0,0,0,216,144Z" }, null, -1), n_1 = [
  t_1
], s_1 = { key: 3 }, r_1 = ["stroke"], i_1 = ["stroke"], l_1 = ["stroke"], d_1 = { key: 4 }, k_1 = ["stroke"], c_1 = ["stroke"], h_1 = ["stroke"], u_1 = { key: 5 }, a_1 = ["stroke"], __1 = ["stroke"], p_1 = ["stroke"], y_1 = {
  name: "PhUploadSimple"
}, Cnl = /* @__PURE__ */ $({
  ...y_1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Oa1, [
        e("polyline", {
          points: "86 82 128 40 170 82",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ia1),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ka1),
        e("path", {
          d: "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xa1)
      ])) : o(i) === "duotone" ? (s(), r("g", Ja1, [
        e("polyline", {
          points: "86 82 128 40 170 82",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qa1),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ya1),
        e("path", {
          d: "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, o_1)
      ])) : o(i) === "fill" ? (s(), r("g", e_1, n_1)) : o(i) === "light" ? (s(), r("g", s_1, [
        e("polyline", {
          points: "86 82 128 40 170 82",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, r_1),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, i_1),
        e("path", {
          d: "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, l_1)
      ])) : o(i) === "thin" ? (s(), r("g", d_1, [
        e("polyline", {
          points: "86 82 128 40 170 82",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, k_1),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, c_1),
        e("path", {
          d: "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, h_1)
      ])) : o(i) === "regular" ? (s(), r("g", u_1, [
        e("polyline", {
          points: "86 82 128 40 170 82",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a_1),
        e("line", {
          x1: "128",
          y1: "152",
          x2: "128",
          y2: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, __1),
        e("path", {
          d: "M216,152v56a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, p_1)
      ])) : g("", !0)
    ], 16, Ea1));
  }
}), $_1 = ["width", "height", "fill", "transform"], w_1 = { key: 0 }, f_1 = ["stroke"], g_1 = ["stroke"], x_1 = { key: 1 }, j_1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "96",
  r: "64",
  opacity: "0.2"
}, null, -1), m_1 = ["stroke"], M_1 = ["stroke"], v_1 = { key: 2 }, S_1 = /* @__PURE__ */ e("path", { d: "M231.9,212a120.7,120.7,0,0,0-67.1-54.2,72,72,0,1,0-73.6,0A120.7,120.7,0,0,0,24.1,212a7.7,7.7,0,0,0,0,8,7.8,7.8,0,0,0,6.9,4H225a7.8,7.8,0,0,0,6.9-4A7.7,7.7,0,0,0,231.9,212Z" }, null, -1), H_1 = [
  S_1
], A_1 = { key: 3 }, V_1 = ["stroke"], z_1 = ["stroke"], Z_1 = { key: 4 }, C_1 = ["stroke"], b_1 = ["stroke"], L_1 = { key: 5 }, B_1 = ["stroke"], P_1 = ["stroke"], W_1 = {
  name: "PhUser"
}, bnl = /* @__PURE__ */ $({
  ...W_1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", w_1, [
        e("circle", {
          cx: "128",
          cy: "96",
          r: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f_1),
        e("path", {
          d: "M31,216a112,112,0,0,1,194,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g_1)
      ])) : o(i) === "duotone" ? (s(), r("g", x_1, [
        j_1,
        e("circle", {
          cx: "128",
          cy: "96",
          r: "64",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, m_1),
        e("path", {
          d: "M31,216a112,112,0,0,1,194,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M_1)
      ])) : o(i) === "fill" ? (s(), r("g", v_1, H_1)) : o(i) === "light" ? (s(), r("g", A_1, [
        e("circle", {
          cx: "128",
          cy: "96",
          r: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, V_1),
        e("path", {
          d: "M31,216a112,112,0,0,1,194,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, z_1)
      ])) : o(i) === "thin" ? (s(), r("g", Z_1, [
        e("circle", {
          cx: "128",
          cy: "96",
          r: "64",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, C_1),
        e("path", {
          d: "M31,216a112,112,0,0,1,194,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, b_1)
      ])) : o(i) === "regular" ? (s(), r("g", L_1, [
        e("circle", {
          cx: "128",
          cy: "96",
          r: "64",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, B_1),
        e("path", {
          d: "M31,216a112,112,0,0,1,194,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P_1)
      ])) : g("", !0)
    ], 16, $_1));
  }
}), N_1 = ["width", "height", "fill", "transform"], F_1 = { key: 0 }, T_1 = ["stroke"], D_1 = ["stroke"], R_1 = ["stroke"], U_1 = { key: 1 }, q_1 = /* @__PURE__ */ e("path", {
  d: "M128,32A96,96,0,0,0,63.8,199.4h0A72,72,0,0,1,128,160a40,40,0,1,1,40-40,40,40,0,0,1-40,40,72,72,0,0,1,64.2,39.4A96,96,0,0,0,128,32Z",
  opacity: "0.2"
}, null, -1), G_1 = ["stroke"], E_1 = ["stroke"], O_1 = ["stroke"], I_1 = { key: 2 }, K_1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "120",
  r: "44"
}, null, -1), X_1 = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm65.8,162.4a81.3,81.3,0,0,0-24.5-23,59.7,59.7,0,0,1-82.6,0,81.3,81.3,0,0,0-24.5,23,88,88,0,1,1,131.6,0Z" }, null, -1), J_1 = [
  K_1,
  X_1
], Q_1 = { key: 3 }, Y_1 = ["stroke"], op1 = ["stroke"], ep1 = ["stroke"], tp1 = { key: 4 }, np1 = ["stroke"], sp1 = ["stroke"], rp1 = ["stroke"], ip1 = { key: 5 }, lp1 = ["stroke"], dp1 = ["stroke"], kp1 = ["stroke"], cp1 = {
  name: "PhUserCircle"
}, Lnl = /* @__PURE__ */ $({
  ...cp1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", F_1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, T_1),
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, D_1),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, R_1)
      ])) : o(i) === "duotone" ? (s(), r("g", U_1, [
        q_1,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G_1),
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E_1),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O_1)
      ])) : o(i) === "fill" ? (s(), r("g", I_1, J_1)) : o(i) === "light" ? (s(), r("g", Q_1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Y_1),
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, op1),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ep1)
      ])) : o(i) === "thin" ? (s(), r("g", tp1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, np1),
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sp1),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rp1)
      ])) : o(i) === "regular" ? (s(), r("g", ip1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lp1),
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dp1),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kp1)
      ])) : g("", !0)
    ], 16, N_1));
  }
}), hp1 = ["width", "height", "fill", "transform"], up1 = { key: 0 }, ap1 = ["stroke"], _p1 = ["stroke"], pp1 = ["stroke"], yp1 = ["stroke"], $p1 = ["stroke"], wp1 = ["stroke"], fp1 = ["stroke"], gp1 = ["stroke"], xp1 = { key: 1 }, jp1 = /* @__PURE__ */ e("path", {
  d: "M205.3,71.1a15.5,15.5,0,0,1-5.3.9,16,16,0,0,1-16-16,15.5,15.5,0,0,1,.9-5.3A96,96,0,0,0,63.8,199.4h0A72,72,0,0,1,128,160a40,40,0,1,1,40-40,40,40,0,0,1-40,40,72,72,0,0,1,64.2,39.4A96,96,0,0,0,205.3,71.1Z",
  opacity: "0.2"
}, null, -1), mp1 = ["stroke"], Mp1 = ["stroke"], vp1 = ["stroke"], Sp1 = ["stroke"], Hp1 = ["stroke"], Ap1 = ["stroke"], Vp1 = ["stroke"], zp1 = ["stroke"], Zp1 = ["stroke"], Cp1 = ["stroke"], bp1 = { key: 2 }, Lp1 = /* @__PURE__ */ e("path", { d: "M128,76a44,44,0,1,1-44,44A44,44,0,0,1,128,76Zm103.2-2a8,8,0,0,1-7,4,7.6,7.6,0,0,1-4-1.1l-4.6-2.7a24,24,0,0,1-7.6,4.4V84a8,8,0,0,1-16,0V78.6a24,24,0,0,1-7.6-4.4l-4.6,2.7a7.6,7.6,0,0,1-4,1.1,8,8,0,0,1-4-14.9l4.6-2.7A21.2,21.2,0,0,1,176,56a21.2,21.2,0,0,1,.4-4.4l-4.6-2.7a7.9,7.9,0,0,1-3-10.9,8.1,8.1,0,0,1,11-2.9l4.6,2.7a24,24,0,0,1,7.6-4.4V28a8,8,0,0,1,16,0v5.4a24,24,0,0,1,7.6,4.4l4.6-2.7a8.1,8.1,0,0,1,11,2.9,7.9,7.9,0,0,1-3,10.9l-4.6,2.7A21.2,21.2,0,0,1,224,56a21.2,21.2,0,0,1-.4,4.4l4.6,2.7A7.9,7.9,0,0,1,231.2,74ZM200,64a8,8,0,1,0-8-8A8,8,0,0,0,200,64Zm22.4,44.6a8,8,0,0,0-7,8.8A94.2,94.2,0,0,1,216,128a87.6,87.6,0,0,1-22.2,58.4,81.3,81.3,0,0,0-24.5-23,59.7,59.7,0,0,1-82.6,0,81.3,81.3,0,0,0-24.5,23A88,88,0,0,1,128,40a75,75,0,0,1,8.2.4,8,8,0,1,0,1.4-16c-3.1-.3-6.4-.4-9.6-.4A104,104,0,0,0,57.8,204.7l1.3,1.2a104,104,0,0,0,137.8,0l1.3-1.2A103.7,103.7,0,0,0,232,128a101.9,101.9,0,0,0-.7-12.4A8,8,0,0,0,222.4,108.6Z" }, null, -1), Bp1 = [
  Lp1
], Pp1 = { key: 3 }, Wp1 = ["stroke"], Np1 = ["stroke"], Fp1 = ["stroke"], Tp1 = ["stroke"], Dp1 = ["stroke"], Rp1 = ["stroke"], Up1 = ["stroke"], qp1 = ["stroke"], Gp1 = ["stroke"], Ep1 = ["stroke"], Op1 = { key: 4 }, Ip1 = ["stroke"], Kp1 = ["stroke"], Xp1 = ["stroke"], Jp1 = ["stroke"], Qp1 = ["stroke"], Yp1 = ["stroke"], o31 = ["stroke"], e31 = ["stroke"], t31 = ["stroke"], n31 = ["stroke"], s31 = { key: 5 }, r31 = ["stroke"], i31 = ["stroke"], l31 = ["stroke"], d31 = ["stroke"], k31 = ["stroke"], c31 = ["stroke"], h31 = ["stroke"], u31 = ["stroke"], a31 = ["stroke"], _31 = ["stroke"], p31 = {
  name: "PhUserCircleGear"
}, Bnl = /* @__PURE__ */ $({
  ...p31,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", up1, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ap1),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _p1),
        e("line", {
          x1: "200",
          y1: "56",
          x2: "200",
          y2: "36",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pp1),
        e("line", {
          x1: "200",
          y1: "56",
          x2: "181",
          y2: "49.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yp1),
        e("line", {
          x1: "200",
          y1: "56",
          x2: "188.2",
          y2: "72.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $p1),
        e("line", {
          x1: "200",
          y1: "56",
          x2: "211.8",
          y2: "72.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wp1),
        e("line", {
          x1: "200",
          y1: "56",
          x2: "219",
          y2: "49.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fp1),
        e("path", {
          d: "M223.3,116.5A87.7,87.7,0,0,1,224,128a96,96,0,1,1-96-96,87,87,0,0,1,8.9.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gp1)
      ])) : o(i) === "duotone" ? (s(), r("g", xp1, [
        jp1,
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, mp1),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mp1),
        e("circle", {
          cx: "200",
          cy: "56",
          r: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vp1),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sp1),
        e("line", {
          x1: "186.1",
          y1: "48",
          x2: "175.8",
          y2: "42",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hp1),
        e("line", {
          x1: "186.1",
          y1: "64",
          x2: "175.8",
          y2: "70",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ap1),
        e("line", {
          x1: "200",
          y1: "72",
          x2: "200",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vp1),
        e("line", {
          x1: "213.9",
          y1: "64",
          x2: "224.2",
          y2: "70",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zp1),
        e("line", {
          x1: "213.9",
          y1: "48",
          x2: "224.2",
          y2: "42",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zp1),
        e("path", {
          d: "M223.3,116.5A87.7,87.7,0,0,1,224,128a96,96,0,1,1-96-96,87,87,0,0,1,8.9.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cp1)
      ])) : o(i) === "fill" ? (s(), r("g", bp1, Bp1)) : o(i) === "light" ? (s(), r("g", Pp1, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Wp1),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Np1),
        e("circle", {
          cx: "200",
          cy: "56",
          r: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fp1),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Tp1),
        e("line", {
          x1: "186.1",
          y1: "48",
          x2: "175.8",
          y2: "42",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dp1),
        e("line", {
          x1: "186.1",
          y1: "64",
          x2: "175.8",
          y2: "70",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rp1),
        e("line", {
          x1: "200",
          y1: "72",
          x2: "200",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Up1),
        e("line", {
          x1: "213.9",
          y1: "64",
          x2: "224.2",
          y2: "70",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qp1),
        e("line", {
          x1: "213.9",
          y1: "48",
          x2: "224.2",
          y2: "42",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gp1),
        e("path", {
          d: "M223.3,116.5A87.7,87.7,0,0,1,224,128a96,96,0,1,1-96-96,87,87,0,0,1,8.9.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ep1)
      ])) : o(i) === "thin" ? (s(), r("g", Op1, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ip1),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kp1),
        e("circle", {
          cx: "200",
          cy: "56",
          r: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xp1),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jp1),
        e("line", {
          x1: "186.1",
          y1: "48",
          x2: "175.8",
          y2: "42",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qp1),
        e("line", {
          x1: "186.1",
          y1: "64",
          x2: "175.8",
          y2: "70",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Yp1),
        e("line", {
          x1: "200",
          y1: "72",
          x2: "200",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, o31),
        e("line", {
          x1: "213.9",
          y1: "64",
          x2: "224.2",
          y2: "70",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, e31),
        e("line", {
          x1: "213.9",
          y1: "48",
          x2: "224.2",
          y2: "42",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, t31),
        e("path", {
          d: "M223.3,116.5A87.7,87.7,0,0,1,224,128a96,96,0,1,1-96-96,87,87,0,0,1,8.9.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, n31)
      ])) : o(i) === "regular" ? (s(), r("g", s31, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, r31),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, i31),
        e("circle", {
          cx: "200",
          cy: "56",
          r: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l31),
        e("line", {
          x1: "200",
          y1: "40",
          x2: "200",
          y2: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, d31),
        e("line", {
          x1: "186.1",
          y1: "48",
          x2: "175.8",
          y2: "42",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k31),
        e("line", {
          x1: "186.1",
          y1: "64",
          x2: "175.8",
          y2: "70",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c31),
        e("line", {
          x1: "200",
          y1: "72",
          x2: "200",
          y2: "84",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h31),
        e("line", {
          x1: "213.9",
          y1: "64",
          x2: "224.2",
          y2: "70",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u31),
        e("line", {
          x1: "213.9",
          y1: "48",
          x2: "224.2",
          y2: "42",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a31),
        e("path", {
          d: "M223.3,116.5A87.7,87.7,0,0,1,224,128a96,96,0,1,1-96-96,87,87,0,0,1,8.9.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _31)
      ])) : g("", !0)
    ], 16, hp1));
  }
}), y31 = ["width", "height", "fill", "transform"], $31 = { key: 0 }, w31 = ["stroke"], f31 = ["stroke"], g31 = ["stroke"], x31 = ["stroke"], j31 = { key: 1 }, m31 = /* @__PURE__ */ e("path", {
  d: "M128,32A96,96,0,0,0,63.8,199.4h0A72,72,0,0,1,128,160a40,40,0,1,1,40-40,40,40,0,0,1-40,40,72,72,0,0,1,64.2,39.4A96,96,0,0,0,128,32Z",
  opacity: "0.2"
}, null, -1), M31 = ["stroke"], v31 = ["stroke"], S31 = ["stroke"], H31 = ["stroke"], A31 = { key: 2 }, V31 = /* @__PURE__ */ e("path", { d: "M128,76a44,44,0,1,1-44,44A44,44,0,0,1,128,76Zm48-12h48a8,8,0,0,0,0-16H176a8,8,0,0,0,0,16Zm39.9,24.5A7.9,7.9,0,0,0,211,98.7a88,88,0,0,1-17.2,87.7,81.3,81.3,0,0,0-24.5-23,59.7,59.7,0,0,1-82.6,0,81.3,81.3,0,0,0-24.5,23A88,88,0,0,1,128,40a92,92,0,0,1,13.9,1.1,8,8,0,0,0,2.5-15.8A99.8,99.8,0,0,0,128,24,104,104,0,0,0,57.8,204.7l1.3,1.2a104,104,0,0,0,137.8,0l1.3-1.2A104.2,104.2,0,0,0,226.1,93.3,8,8,0,0,0,215.9,88.5Z" }, null, -1), z31 = [
  V31
], Z31 = { key: 3 }, C31 = ["stroke"], b31 = ["stroke"], L31 = ["stroke"], B31 = ["stroke"], P31 = { key: 4 }, W31 = ["stroke"], N31 = ["stroke"], F31 = ["stroke"], T31 = ["stroke"], D31 = { key: 5 }, R31 = ["stroke"], U31 = ["stroke"], q31 = ["stroke"], G31 = ["stroke"], E31 = {
  name: "PhUserCircleMinus"
}, Pnl = /* @__PURE__ */ $({
  ...E31,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $31, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, w31),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f31),
        e("line", {
          x1: "176",
          y1: "56",
          x2: "224",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g31),
        e("path", {
          d: "M218.5,96a94.4,94.4,0,0,1,5.5,32,96,96,0,1,1-96-96,93.3,93.3,0,0,1,15.1,1.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, x31)
      ])) : o(i) === "duotone" ? (s(), r("g", j31, [
        m31,
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, M31),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v31),
        e("line", {
          x1: "176",
          y1: "56",
          x2: "224",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S31),
        e("path", {
          d: "M218.5,96a94.4,94.4,0,0,1,5.5,32,96,96,0,1,1-96-96,93.3,93.3,0,0,1,15.1,1.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H31)
      ])) : o(i) === "fill" ? (s(), r("g", A31, z31)) : o(i) === "light" ? (s(), r("g", Z31, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, C31),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, b31),
        e("line", {
          x1: "176",
          y1: "56",
          x2: "224",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, L31),
        e("path", {
          d: "M218.5,96a94.4,94.4,0,0,1,5.5,32,96,96,0,1,1-96-96,93.3,93.3,0,0,1,15.1,1.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, B31)
      ])) : o(i) === "thin" ? (s(), r("g", P31, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, W31),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, N31),
        e("line", {
          x1: "176",
          y1: "56",
          x2: "224",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, F31),
        e("path", {
          d: "M218.5,96a94.4,94.4,0,0,1,5.5,32,96,96,0,1,1-96-96,93.3,93.3,0,0,1,15.1,1.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, T31)
      ])) : o(i) === "regular" ? (s(), r("g", D31, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, R31),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, U31),
        e("line", {
          x1: "176",
          y1: "56",
          x2: "224",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, q31),
        e("path", {
          d: "M218.5,96a94.4,94.4,0,0,1,5.5,32,96,96,0,1,1-96-96,93.3,93.3,0,0,1,15.1,1.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, G31)
      ])) : g("", !0)
    ], 16, y31));
  }
}), O31 = ["width", "height", "fill", "transform"], I31 = { key: 0 }, K31 = ["stroke"], X31 = ["stroke"], J31 = ["stroke"], Q31 = ["stroke"], Y31 = ["stroke"], oy1 = { key: 1 }, ey1 = /* @__PURE__ */ e("path", {
  d: "M128,32A96,96,0,0,0,63.8,199.4h0A72,72,0,0,1,128,160a40,40,0,1,1,40-40,40,40,0,0,1-40,40,72,72,0,0,1,64.2,39.4A96,96,0,0,0,128,32Z",
  opacity: "0.2"
}, null, -1), ty1 = ["stroke"], ny1 = ["stroke"], sy1 = ["stroke"], ry1 = ["stroke"], iy1 = ["stroke"], ly1 = { key: 2 }, dy1 = /* @__PURE__ */ e("path", { d: "M128,76a44,44,0,1,1-44,44A44,44,0,0,1,128,76Zm48-12h16V80a8,8,0,0,0,16,0V64h16a8,8,0,0,0,0-16H208V32a8,8,0,0,0-16,0V48H176a8,8,0,0,0,0,16Zm45.6,41a7.9,7.9,0,0,0-6.7,9.1A92,92,0,0,1,216,128a87.6,87.6,0,0,1-22.2,58.4,81.3,81.3,0,0,0-24.5-23,59.7,59.7,0,0,1-82.6,0,81.3,81.3,0,0,0-24.5,23A88,88,0,0,1,128,40a92,92,0,0,1,13.9,1.1,8,8,0,0,0,2.5-15.8A99.8,99.8,0,0,0,128,24,104,104,0,0,0,57.8,204.7l1.3,1.2a104,104,0,0,0,137.8,0l1.3-1.2A103.7,103.7,0,0,0,232,128a99.8,99.8,0,0,0-1.3-16.4A7.9,7.9,0,0,0,221.6,105Z" }, null, -1), ky1 = [
  dy1
], cy1 = { key: 3 }, hy1 = ["stroke"], uy1 = ["stroke"], ay1 = ["stroke"], _y1 = ["stroke"], py1 = ["stroke"], yy1 = { key: 4 }, $y1 = ["stroke"], wy1 = ["stroke"], fy1 = ["stroke"], gy1 = ["stroke"], xy1 = ["stroke"], jy1 = { key: 5 }, my1 = ["stroke"], My1 = ["stroke"], vy1 = ["stroke"], Sy1 = ["stroke"], Hy1 = ["stroke"], Ay1 = {
  name: "PhUserCirclePlus"
}, Wnl = /* @__PURE__ */ $({
  ...Ay1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", I31, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, K31),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, X31),
        e("line", {
          x1: "176",
          y1: "56",
          x2: "224",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, J31),
        e("line", {
          x1: "200",
          y1: "32",
          x2: "200",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Q31),
        e("path", {
          d: "M222.8,112.9A93.3,93.3,0,0,1,224,128a96,96,0,1,1-96-96,93.3,93.3,0,0,1,15.1,1.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Y31)
      ])) : o(i) === "duotone" ? (s(), r("g", oy1, [
        ey1,
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, ty1),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ny1),
        e("line", {
          x1: "176",
          y1: "56",
          x2: "224",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sy1),
        e("line", {
          x1: "200",
          y1: "32",
          x2: "200",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ry1),
        e("path", {
          d: "M222.8,112.9A93.3,93.3,0,0,1,224,128a96,96,0,1,1-96-96,93.3,93.3,0,0,1,15.1,1.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iy1)
      ])) : o(i) === "fill" ? (s(), r("g", ly1, ky1)) : o(i) === "light" ? (s(), r("g", cy1, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hy1),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uy1),
        e("line", {
          x1: "176",
          y1: "56",
          x2: "224",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ay1),
        e("line", {
          x1: "200",
          y1: "32",
          x2: "200",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _y1),
        e("path", {
          d: "M222.8,112.9A93.3,93.3,0,0,1,224,128a96,96,0,1,1-96-96,93.3,93.3,0,0,1,15.1,1.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, py1)
      ])) : o(i) === "thin" ? (s(), r("g", yy1, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $y1),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wy1),
        e("line", {
          x1: "176",
          y1: "56",
          x2: "224",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fy1),
        e("line", {
          x1: "200",
          y1: "32",
          x2: "200",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gy1),
        e("path", {
          d: "M222.8,112.9A93.3,93.3,0,0,1,224,128a96,96,0,1,1-96-96,93.3,93.3,0,0,1,15.1,1.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xy1)
      ])) : o(i) === "regular" ? (s(), r("g", jy1, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, my1),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, My1),
        e("line", {
          x1: "176",
          y1: "56",
          x2: "224",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vy1),
        e("line", {
          x1: "200",
          y1: "32",
          x2: "200",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sy1),
        e("path", {
          d: "M222.8,112.9A93.3,93.3,0,0,1,224,128a96,96,0,1,1-96-96,93.3,93.3,0,0,1,15.1,1.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hy1)
      ])) : g("", !0)
    ], 16, O31));
  }
}), Vy1 = ["width", "height", "fill", "transform"], zy1 = { key: 0 }, Zy1 = ["stroke"], Cy1 = ["stroke"], by1 = ["stroke"], Ly1 = ["stroke"], By1 = ["stroke"], Py1 = ["stroke"], Wy1 = { key: 1 }, Ny1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "112",
  r: "32",
  opacity: "0.2"
}, null, -1), Fy1 = ["stroke"], Ty1 = ["stroke"], Dy1 = ["stroke"], Ry1 = ["stroke"], Uy1 = ["stroke"], qy1 = ["stroke"], Gy1 = { key: 2 }, Ey1 = /* @__PURE__ */ e("path", { d: "M224,48V76a8,8,0,0,1-16,0V48H180a8,8,0,0,1,0-16h28A16,16,0,0,1,224,48Zm-8,124a8,8,0,0,0-8,8v28H180a8,8,0,0,0,0,16h28a16,16,0,0,0,16-16V180A8,8,0,0,0,216,172ZM76,208H48V180a8,8,0,0,0-16,0v28a16,16,0,0,0,16,16H76a8,8,0,0,0,0-16ZM40,84a8,8,0,0,0,8-8V48H76a8,8,0,0,0,0-16H48A16,16,0,0,0,32,48V76A8,8,0,0,0,40,84Zm61.1,57.5a69.1,69.1,0,0,0-33.3,30.8,7.8,7.8,0,0,0,.3,7.8,7.9,7.9,0,0,0,6.8,3.9H181.1a7.9,7.9,0,0,0,6.8-3.9,7.8,7.8,0,0,0,.3-7.8,69.1,69.1,0,0,0-33.3-30.8A39.5,39.5,0,0,0,168,112a40,40,0,0,0-80,0A39.5,39.5,0,0,0,101.1,141.5Z" }, null, -1), Oy1 = [
  Ey1
], Iy1 = { key: 3 }, Ky1 = ["stroke"], Xy1 = ["stroke"], Jy1 = ["stroke"], Qy1 = ["stroke"], Yy1 = ["stroke"], o51 = ["stroke"], e51 = { key: 4 }, t51 = ["stroke"], n51 = ["stroke"], s51 = ["stroke"], r51 = ["stroke"], i51 = ["stroke"], l51 = ["stroke"], d51 = { key: 5 }, k51 = ["stroke"], c51 = ["stroke"], h51 = ["stroke"], u51 = ["stroke"], a51 = ["stroke"], _51 = ["stroke"], p51 = {
  name: "PhUserFocus"
}, Nnl = /* @__PURE__ */ $({
  ...p51,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", zy1, [
        e("path", {
          d: "M180,40h28a8,8,0,0,1,8,8V76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zy1),
        e("path", {
          d: "M180,216h28a8,8,0,0,0,8-8V180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cy1),
        e("path", {
          d: "M76,216H48a8,8,0,0,1-8-8V180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, by1),
        e("path", {
          d: "M76,40H48a8,8,0,0,0-8,8V76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ly1),
        e("circle", {
          cx: "128",
          cy: "112",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, By1),
        e("path", {
          d: "M80,168a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Py1)
      ])) : o(i) === "duotone" ? (s(), r("g", Wy1, [
        Ny1,
        e("path", {
          d: "M180,40h28a8,8,0,0,1,8,8V76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fy1),
        e("path", {
          d: "M180,216h28a8,8,0,0,0,8-8V180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ty1),
        e("path", {
          d: "M76,216H48a8,8,0,0,1-8-8V180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dy1),
        e("path", {
          d: "M76,40H48a8,8,0,0,0-8,8V76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ry1),
        e("circle", {
          cx: "128",
          cy: "112",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Uy1),
        e("path", {
          d: "M74.9,176a60.1,60.1,0,0,1,106.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qy1)
      ])) : o(i) === "fill" ? (s(), r("g", Gy1, Oy1)) : o(i) === "light" ? (s(), r("g", Iy1, [
        e("path", {
          d: "M180,40h28a8,8,0,0,1,8,8V76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ky1),
        e("path", {
          d: "M180,216h28a8,8,0,0,0,8-8V180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xy1),
        e("path", {
          d: "M76,216H48a8,8,0,0,1-8-8V180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jy1),
        e("path", {
          d: "M76,40H48a8,8,0,0,0-8,8V76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qy1),
        e("circle", {
          cx: "128",
          cy: "112",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Yy1),
        e("path", {
          d: "M74.9,176a60.1,60.1,0,0,1,106.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, o51)
      ])) : o(i) === "thin" ? (s(), r("g", e51, [
        e("path", {
          d: "M180,40h28a8,8,0,0,1,8,8V76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, t51),
        e("path", {
          d: "M180,216h28a8,8,0,0,0,8-8V180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, n51),
        e("path", {
          d: "M76,216H48a8,8,0,0,1-8-8V180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, s51),
        e("path", {
          d: "M76,40H48a8,8,0,0,0-8,8V76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, r51),
        e("circle", {
          cx: "128",
          cy: "112",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, i51),
        e("path", {
          d: "M74.9,176a60.1,60.1,0,0,1,106.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, l51)
      ])) : o(i) === "regular" ? (s(), r("g", d51, [
        e("path", {
          d: "M180,40h28a8,8,0,0,1,8,8V76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k51),
        e("path", {
          d: "M180,216h28a8,8,0,0,0,8-8V180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c51),
        e("path", {
          d: "M76,216H48a8,8,0,0,1-8-8V180",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h51),
        e("path", {
          d: "M76,40H48a8,8,0,0,0-8,8V76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u51),
        e("circle", {
          cx: "128",
          cy: "112",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a51),
        e("path", {
          d: "M74.9,176a60.1,60.1,0,0,1,106.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _51)
      ])) : g("", !0)
    ], 16, Vy1));
  }
}), y51 = ["width", "height", "fill", "transform"], $51 = { key: 0 }, w51 = ["stroke"], f51 = ["stroke"], g51 = ["stroke"], x51 = ["stroke"], j51 = ["stroke"], m51 = ["stroke"], M51 = ["stroke"], v51 = { key: 1 }, S51 = /* @__PURE__ */ e("circle", {
  cx: "108",
  cy: "100",
  r: "60",
  opacity: "0.2"
}, null, -1), H51 = ["stroke"], A51 = ["stroke"], V51 = ["stroke"], z51 = ["stroke"], Z51 = ["stroke"], C51 = ["stroke"], b51 = ["stroke"], L51 = ["stroke"], B51 = ["stroke"], P51 = { key: 2 }, W51 = /* @__PURE__ */ e("path", { d: "M199.9,194.9a7.8,7.8,0,0,1,1.1,8.5,7.9,7.9,0,0,1-7.2,4.6H22.2a7.9,7.9,0,0,1-7.2-4.6,7.8,7.8,0,0,1,1.1-8.5,118.4,118.4,0,0,1,55.8-37.3,68,68,0,1,1,72.2,0A118.4,118.4,0,0,1,199.9,194.9ZM251.2,154a8,8,0,0,1-7,4,7.6,7.6,0,0,1-4-1.1l-4.6-2.7a24,24,0,0,1-7.6,4.4V164a8,8,0,0,1-16,0v-5.4a24,24,0,0,1-7.6-4.4l-4.6,2.7a7.6,7.6,0,0,1-4,1.1,8,8,0,0,1-4-14.9l4.6-2.7a24.4,24.4,0,0,1,0-8.8l-4.6-2.7a7.9,7.9,0,0,1-3-10.9,8.1,8.1,0,0,1,11-2.9l4.6,2.7a24,24,0,0,1,7.6-4.4V108a8,8,0,0,1,16,0v5.4a24,24,0,0,1,7.6,4.4l4.6-2.7a8.1,8.1,0,0,1,11,2.9,7.9,7.9,0,0,1-3,10.9l-4.6,2.7a24.4,24.4,0,0,1,0,8.8l4.6,2.7A7.9,7.9,0,0,1,251.2,154ZM220,144a8,8,0,1,0-8-8A8,8,0,0,0,220,144Z" }, null, -1), N51 = [
  W51
], F51 = { key: 3 }, T51 = ["stroke"], D51 = ["stroke"], R51 = ["stroke"], U51 = ["stroke"], q51 = ["stroke"], G51 = ["stroke"], E51 = ["stroke"], O51 = ["stroke"], I51 = ["stroke"], K51 = { key: 4 }, X51 = ["stroke"], J51 = ["stroke"], Q51 = ["stroke"], Y51 = ["stroke"], o71 = ["stroke"], e71 = ["stroke"], t71 = ["stroke"], n71 = ["stroke"], s71 = ["stroke"], r71 = { key: 5 }, i71 = ["stroke"], l71 = ["stroke"], d71 = ["stroke"], k71 = ["stroke"], c71 = ["stroke"], h71 = ["stroke"], u71 = ["stroke"], a71 = ["stroke"], _71 = ["stroke"], p71 = {
  name: "PhUserGear"
}, Fnl = /* @__PURE__ */ $({
  ...p71,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $51, [
        e("line", {
          x1: "224",
          y1: "136",
          x2: "224",
          y2: "116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, w51),
        e("line", {
          x1: "224",
          y1: "136",
          x2: "205",
          y2: "129.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f51),
        e("line", {
          x1: "224",
          y1: "136",
          x2: "212.2",
          y2: "152.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g51),
        e("line", {
          x1: "224",
          y1: "136",
          x2: "235.8",
          y2: "152.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, x51),
        e("line", {
          x1: "224",
          y1: "136",
          x2: "243",
          y2: "129.8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, j51),
        e("circle", {
          cx: "108",
          cy: "100",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, m51),
        e("path", {
          d: "M22.2,200a112,112,0,0,1,171.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, M51)
      ])) : o(i) === "duotone" ? (s(), r("g", v51, [
        S51,
        e("circle", {
          cx: "108",
          cy: "100",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, H51),
        e("path", {
          d: "M22.2,200a112,112,0,0,1,171.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A51),
        e("circle", {
          cx: "220",
          cy: "136",
          r: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, V51),
        e("line", {
          x1: "220",
          y1: "120",
          x2: "220",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, z51),
        e("line", {
          x1: "206.1",
          y1: "128",
          x2: "195.8",
          y2: "122",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Z51),
        e("line", {
          x1: "206.1",
          y1: "144",
          x2: "195.8",
          y2: "150",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C51),
        e("line", {
          x1: "220",
          y1: "152",
          x2: "220",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b51),
        e("line", {
          x1: "233.9",
          y1: "144",
          x2: "244.2",
          y2: "150",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, L51),
        e("line", {
          x1: "233.9",
          y1: "128",
          x2: "244.2",
          y2: "122",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B51)
      ])) : o(i) === "fill" ? (s(), r("g", P51, N51)) : o(i) === "light" ? (s(), r("g", F51, [
        e("circle", {
          cx: "108",
          cy: "100",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, T51),
        e("path", {
          d: "M22.2,200a112,112,0,0,1,171.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, D51),
        e("circle", {
          cx: "220",
          cy: "136",
          r: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, R51),
        e("line", {
          x1: "220",
          y1: "120",
          x2: "220",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, U51),
        e("line", {
          x1: "206.1",
          y1: "128",
          x2: "195.8",
          y2: "122",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, q51),
        e("line", {
          x1: "206.1",
          y1: "144",
          x2: "195.8",
          y2: "150",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, G51),
        e("line", {
          x1: "220",
          y1: "152",
          x2: "220",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, E51),
        e("line", {
          x1: "233.9",
          y1: "144",
          x2: "244.2",
          y2: "150",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, O51),
        e("line", {
          x1: "233.9",
          y1: "128",
          x2: "244.2",
          y2: "122",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, I51)
      ])) : o(i) === "thin" ? (s(), r("g", K51, [
        e("circle", {
          cx: "108",
          cy: "100",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, X51),
        e("path", {
          d: "M22.2,200a112,112,0,0,1,171.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, J51),
        e("circle", {
          cx: "220",
          cy: "136",
          r: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Q51),
        e("line", {
          x1: "220",
          y1: "120",
          x2: "220",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Y51),
        e("line", {
          x1: "206.1",
          y1: "128",
          x2: "195.8",
          y2: "122",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, o71),
        e("line", {
          x1: "206.1",
          y1: "144",
          x2: "195.8",
          y2: "150",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, e71),
        e("line", {
          x1: "220",
          y1: "152",
          x2: "220",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, t71),
        e("line", {
          x1: "233.9",
          y1: "144",
          x2: "244.2",
          y2: "150",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, n71),
        e("line", {
          x1: "233.9",
          y1: "128",
          x2: "244.2",
          y2: "122",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, s71)
      ])) : o(i) === "regular" ? (s(), r("g", r71, [
        e("circle", {
          cx: "108",
          cy: "100",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, i71),
        e("path", {
          d: "M22.2,200a112,112,0,0,1,171.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l71),
        e("circle", {
          cx: "220",
          cy: "136",
          r: "16",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, d71),
        e("line", {
          x1: "220",
          y1: "120",
          x2: "220",
          y2: "108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k71),
        e("line", {
          x1: "206.1",
          y1: "128",
          x2: "195.8",
          y2: "122",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c71),
        e("line", {
          x1: "206.1",
          y1: "144",
          x2: "195.8",
          y2: "150",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, h71),
        e("line", {
          x1: "220",
          y1: "152",
          x2: "220",
          y2: "164",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, u71),
        e("line", {
          x1: "233.9",
          y1: "144",
          x2: "244.2",
          y2: "150",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, a71),
        e("line", {
          x1: "233.9",
          y1: "128",
          x2: "244.2",
          y2: "122",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _71)
      ])) : g("", !0)
    ], 16, y51));
  }
}), y71 = ["width", "height", "fill", "transform"], $71 = { key: 0 }, w71 = ["stroke"], f71 = ["stroke"], g71 = ["stroke"], x71 = ["stroke"], j71 = ["stroke"], m71 = { key: 1 }, M71 = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "104",
  r: "40",
  opacity: "0.2"
}, null, -1), v71 = ["stroke"], S71 = ["stroke"], H71 = ["stroke"], A71 = ["stroke"], V71 = ["stroke"], z71 = { key: 2 }, Z71 = /* @__PURE__ */ e("path", { d: "M144,80a8,8,0,0,1,8-8h96a8,8,0,0,1,0,16H152A8,8,0,0,1,144,80Zm104,40H152a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm0,48H176a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16ZM109.1,142.1a48,48,0,1,0-58.2,0A72,72,0,0,0,10.3,190a8.1,8.1,0,0,0,1.4,6.9A7.8,7.8,0,0,0,18,200H142a7.8,7.8,0,0,0,6.3-3.1,8.1,8.1,0,0,0,1.4-6.9A72,72,0,0,0,109.1,142.1Z" }, null, -1), C71 = [
  Z71
], b71 = { key: 3 }, L71 = ["stroke"], B71 = ["stroke"], P71 = ["stroke"], W71 = ["stroke"], N71 = ["stroke"], F71 = { key: 4 }, T71 = ["stroke"], D71 = ["stroke"], R71 = ["stroke"], U71 = ["stroke"], q71 = ["stroke"], G71 = { key: 5 }, E71 = ["stroke"], O71 = ["stroke"], I71 = ["stroke"], K71 = ["stroke"], X71 = ["stroke"], J71 = {
  name: "PhUserList"
}, Tnl = /* @__PURE__ */ $({
  ...J71,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", $71, [
        e("circle", {
          cx: "80",
          cy: "104",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, w71),
        e("line", {
          x1: "152",
          y1: "80",
          x2: "244",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, f71),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "244",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, g71),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "244",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, x71),
        e("path", {
          d: "M18,192a64,64,0,0,1,124,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, j71)
      ])) : o(i) === "duotone" ? (s(), r("g", m71, [
        M71,
        e("circle", {
          cx: "80",
          cy: "104",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v71),
        e("line", {
          x1: "152",
          y1: "80",
          x2: "248",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S71),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "248",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, H71),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "248",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, A71),
        e("path", {
          d: "M18,192a64,64,0,0,1,124,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, V71)
      ])) : o(i) === "fill" ? (s(), r("g", z71, C71)) : o(i) === "light" ? (s(), r("g", b71, [
        e("circle", {
          cx: "80",
          cy: "104",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, L71),
        e("line", {
          x1: "152",
          y1: "80",
          x2: "248",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, B71),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "248",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, P71),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "248",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, W71),
        e("path", {
          d: "M18,192a64,64,0,0,1,124,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, N71)
      ])) : o(i) === "thin" ? (s(), r("g", F71, [
        e("circle", {
          cx: "80",
          cy: "104",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, T71),
        e("line", {
          x1: "152",
          y1: "80",
          x2: "248",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, D71),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "248",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, R71),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "248",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, U71),
        e("path", {
          d: "M18,192a64,64,0,0,1,124,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, q71)
      ])) : o(i) === "regular" ? (s(), r("g", G71, [
        e("circle", {
          cx: "80",
          cy: "104",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, E71),
        e("line", {
          x1: "152",
          y1: "80",
          x2: "248",
          y2: "80",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, O71),
        e("line", {
          x1: "152",
          y1: "128",
          x2: "248",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, I71),
        e("line", {
          x1: "176",
          y1: "176",
          x2: "248",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, K71),
        e("path", {
          d: "M18,192a64,64,0,0,1,124,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X71)
      ])) : g("", !0)
    ], 16, y71));
  }
}), Q71 = ["width", "height", "fill", "transform"], Y71 = { key: 0 }, o91 = ["stroke"], e91 = ["stroke"], t91 = ["stroke"], n91 = { key: 1 }, s91 = /* @__PURE__ */ e("circle", {
  cx: "108",
  cy: "100",
  r: "60",
  opacity: "0.2"
}, null, -1), r91 = ["stroke"], i91 = ["stroke"], l91 = ["stroke"], d91 = { key: 2 }, k91 = /* @__PURE__ */ e("path", { d: "M256,136a8,8,0,0,1-8,8H200a8,8,0,0,1,0-16h48A8,8,0,0,1,256,136ZM144.1,157.6a68,68,0,1,0-72.2,0,118.4,118.4,0,0,0-55.8,37.3,7.8,7.8,0,0,0-1.1,8.5,7.9,7.9,0,0,0,7.2,4.6H193.8a7.9,7.9,0,0,0,7.2-4.6,7.8,7.8,0,0,0-1.1-8.5A118.4,118.4,0,0,0,144.1,157.6Z" }, null, -1), c91 = [
  k91
], h91 = { key: 3 }, u91 = ["stroke"], a91 = ["stroke"], _91 = ["stroke"], p91 = { key: 4 }, y91 = ["stroke"], $91 = ["stroke"], w91 = ["stroke"], f91 = { key: 5 }, g91 = ["stroke"], x91 = ["stroke"], j91 = ["stroke"], m91 = {
  name: "PhUserMinus"
}, Dnl = /* @__PURE__ */ $({
  ...m91,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Y71, [
        e("line", {
          x1: "204",
          y1: "136",
          x2: "244",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, o91),
        e("circle", {
          cx: "108",
          cy: "100",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, e91),
        e("path", {
          d: "M22.2,200a112,112,0,0,1,171.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, t91)
      ])) : o(i) === "duotone" ? (s(), r("g", n91, [
        s91,
        e("line", {
          x1: "200",
          y1: "136",
          x2: "248",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, r91),
        e("circle", {
          cx: "108",
          cy: "100",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, i91),
        e("path", {
          d: "M22.2,200a112,112,0,0,1,171.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, l91)
      ])) : o(i) === "fill" ? (s(), r("g", d91, c91)) : o(i) === "light" ? (s(), r("g", h91, [
        e("line", {
          x1: "200",
          y1: "136",
          x2: "248",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, u91),
        e("circle", {
          cx: "108",
          cy: "100",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, a91),
        e("path", {
          d: "M22.2,200a112,112,0,0,1,171.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _91)
      ])) : o(i) === "thin" ? (s(), r("g", p91, [
        e("line", {
          x1: "200",
          y1: "136",
          x2: "248",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, y91),
        e("circle", {
          cx: "108",
          cy: "100",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $91),
        e("path", {
          d: "M22.2,200a112,112,0,0,1,171.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, w91)
      ])) : o(i) === "regular" ? (s(), r("g", f91, [
        e("line", {
          x1: "200",
          y1: "136",
          x2: "248",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, g91),
        e("circle", {
          cx: "108",
          cy: "100",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, x91),
        e("path", {
          d: "M22.2,200a112,112,0,0,1,171.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, j91)
      ])) : g("", !0)
    ], 16, Q71));
  }
}), M91 = ["width", "height", "fill", "transform"], v91 = { key: 0 }, S91 = ["stroke"], H91 = ["stroke"], A91 = ["stroke"], V91 = ["stroke"], z91 = { key: 1 }, Z91 = /* @__PURE__ */ e("circle", {
  cx: "108",
  cy: "100",
  r: "60",
  opacity: "0.2"
}, null, -1), C91 = ["stroke"], b91 = ["stroke"], L91 = ["stroke"], B91 = ["stroke"], P91 = { key: 2 }, W91 = /* @__PURE__ */ e("path", { d: "M256,136a8,8,0,0,1-8,8H232v16a8,8,0,0,1-16,0V144H200a8,8,0,0,1,0-16h16V112a8,8,0,0,1,16,0v16h16A8,8,0,0,1,256,136ZM144.1,157.6a68,68,0,1,0-72.2,0,118.4,118.4,0,0,0-55.8,37.3,7.8,7.8,0,0,0-1.1,8.5,7.9,7.9,0,0,0,7.2,4.6H193.8a7.9,7.9,0,0,0,7.2-4.6,7.8,7.8,0,0,0-1.1-8.5A118.4,118.4,0,0,0,144.1,157.6Z" }, null, -1), N91 = [
  W91
], F91 = { key: 3 }, T91 = ["stroke"], D91 = ["stroke"], R91 = ["stroke"], U91 = ["stroke"], q91 = { key: 4 }, G91 = ["stroke"], E91 = ["stroke"], O91 = ["stroke"], I91 = ["stroke"], K91 = { key: 5 }, X91 = ["stroke"], J91 = ["stroke"], Q91 = ["stroke"], Y91 = ["stroke"], o$1 = {
  name: "PhUserPlus"
}, Rnl = /* @__PURE__ */ $({
  ...o$1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", v91, [
        e("line", {
          x1: "204",
          y1: "136",
          x2: "244",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, S91),
        e("line", {
          x1: "224",
          y1: "116",
          x2: "224",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, H91),
        e("circle", {
          cx: "108",
          cy: "100",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, A91),
        e("path", {
          d: "M22.2,200a112,112,0,0,1,171.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, V91)
      ])) : o(i) === "duotone" ? (s(), r("g", z91, [
        Z91,
        e("line", {
          x1: "200",
          y1: "136",
          x2: "248",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, C91),
        e("line", {
          x1: "224",
          y1: "112",
          x2: "224",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, b91),
        e("circle", {
          cx: "108",
          cy: "100",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, L91),
        e("path", {
          d: "M22.2,200a112,112,0,0,1,171.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B91)
      ])) : o(i) === "fill" ? (s(), r("g", P91, N91)) : o(i) === "light" ? (s(), r("g", F91, [
        e("line", {
          x1: "200",
          y1: "136",
          x2: "248",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, T91),
        e("line", {
          x1: "224",
          y1: "112",
          x2: "224",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, D91),
        e("circle", {
          cx: "108",
          cy: "100",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, R91),
        e("path", {
          d: "M22.2,200a112,112,0,0,1,171.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, U91)
      ])) : o(i) === "thin" ? (s(), r("g", q91, [
        e("line", {
          x1: "200",
          y1: "136",
          x2: "248",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, G91),
        e("line", {
          x1: "224",
          y1: "112",
          x2: "224",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, E91),
        e("circle", {
          cx: "108",
          cy: "100",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, O91),
        e("path", {
          d: "M22.2,200a112,112,0,0,1,171.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, I91)
      ])) : o(i) === "regular" ? (s(), r("g", K91, [
        e("line", {
          x1: "200",
          y1: "136",
          x2: "248",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, X91),
        e("line", {
          x1: "224",
          y1: "112",
          x2: "224",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J91),
        e("circle", {
          cx: "108",
          cy: "100",
          r: "60",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Q91),
        e("path", {
          d: "M22.2,200a112,112,0,0,1,171.6,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y91)
      ])) : g("", !0)
    ], 16, M91));
  }
}), e$1 = ["width", "height", "fill", "transform"], t$1 = { key: 0 }, n$1 = ["stroke"], s$1 = ["stroke"], r$1 = ["stroke"], i$1 = { key: 1 }, l$1 = /* @__PURE__ */ e("path", {
  d: "M216,48H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H60.1A72,72,0,0,1,128,160a40,40,0,1,1,40-40,40,40,0,0,1-40,40,72,72,0,0,1,67.9,48H216a8,8,0,0,0,8-8V56A8,8,0,0,0,216,48Z",
  opacity: "0.2"
}, null, -1), d$1 = ["stroke"], k$1 = ["stroke"], c$1 = ["stroke"], h$1 = { key: 2 }, u$1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "120",
  r: "44"
}, null, -1), a$1 = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H201.3a80.2,80.2,0,0,0-32-36.5,59.9,59.9,0,0,1-82.6,0,80.2,80.2,0,0,0-32,36.5H40V56H216V200Z" }, null, -1), _$1 = [
  u$1,
  a$1
], p$1 = { key: 3 }, y$1 = ["stroke"], $$1 = ["stroke"], w$1 = ["stroke"], f$1 = { key: 4 }, g$1 = ["stroke"], x$1 = ["stroke"], j$1 = ["stroke"], m$1 = { key: 5 }, M$1 = ["stroke"], v$1 = ["stroke"], S$1 = ["stroke"], H$1 = {
  name: "PhUserRectangle"
}, Unl = /* @__PURE__ */ $({
  ...H$1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", t$1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, n$1),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, s$1),
        e("path", {
          d: "M63.5,208a72,72,0,0,1,129,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, r$1)
      ])) : o(i) === "duotone" ? (s(), r("g", i$1, [
        l$1,
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, d$1),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, k$1),
        e("path", {
          d: "M60.1,208a72,72,0,0,1,135.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, c$1)
      ])) : o(i) === "fill" ? (s(), r("g", h$1, _$1)) : o(i) === "light" ? (s(), r("g", p$1, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, y$1),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $$1),
        e("path", {
          d: "M60.1,208a72,72,0,0,1,135.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, w$1)
      ])) : o(i) === "thin" ? (s(), r("g", f$1, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, g$1),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, x$1),
        e("path", {
          d: "M60.1,208a72,72,0,0,1,135.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, j$1)
      ])) : o(i) === "regular" ? (s(), r("g", m$1, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, M$1),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, v$1),
        e("path", {
          d: "M60.1,208a72,72,0,0,1,135.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, S$1)
      ])) : g("", !0)
    ], 16, e$1));
  }
}), A$1 = ["width", "height", "fill", "transform"], V$1 = { key: 0 }, z$1 = ["stroke"], Z$1 = ["stroke"], C$1 = ["stroke"], b$1 = { key: 1 }, L$1 = /* @__PURE__ */ e("path", {
  d: "M208,40H48a8,8,0,0,0-8,8V208a8,8,0,0,0,8,8H208a8,8,0,0,0,8-8V48A8,8,0,0,0,208,40ZM57.8,216A72,72,0,0,1,128,160a40,40,0,1,1,40-40,40,40,0,0,1-40,40,72,72,0,0,1,70.2,56Z",
  opacity: "0.2"
}, null, -1), B$1 = ["stroke"], P$1 = ["stroke"], W$1 = ["stroke"], N$1 = { key: 2 }, F$1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "120",
  r: "44"
}, null, -1), T$1 = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176h-3.7a80.7,80.7,0,0,0-26-38.2,76.8,76.8,0,0,0-9-6.3,59.9,59.9,0,0,1-82.6,0,76.8,76.8,0,0,0-9,6.3,80.7,80.7,0,0,0-26,38.2H48V48H208V208Z" }, null, -1), D$1 = [
  F$1,
  T$1
], R$1 = { key: 3 }, U$1 = ["stroke"], q$1 = ["stroke"], G$1 = ["stroke"], E$1 = { key: 4 }, O$1 = ["stroke"], I$1 = ["stroke"], K$1 = ["stroke"], X$1 = { key: 5 }, J$1 = ["stroke"], Q$1 = ["stroke"], Y$1 = ["stroke"], ow1 = {
  name: "PhUserSquare"
}, qnl = /* @__PURE__ */ $({
  ...ow1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", V$1, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, z$1),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Z$1),
        e("path", {
          d: "M57.8,216a72,72,0,0,1,140.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, C$1)
      ])) : o(i) === "duotone" ? (s(), r("g", b$1, [
        L$1,
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, B$1),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, P$1),
        e("path", {
          d: "M57.8,216a72,72,0,0,1,140.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, W$1)
      ])) : o(i) === "fill" ? (s(), r("g", N$1, D$1)) : o(i) === "light" ? (s(), r("g", R$1, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, U$1),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, q$1),
        e("path", {
          d: "M57.8,216a72,72,0,0,1,140.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, G$1)
      ])) : o(i) === "thin" ? (s(), r("g", E$1, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, O$1),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, I$1),
        e("path", {
          d: "M57.8,216a72,72,0,0,1,140.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, K$1)
      ])) : o(i) === "regular" ? (s(), r("g", X$1, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, J$1),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Q$1),
        e("path", {
          d: "M57.8,216a72,72,0,0,1,140.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Y$1)
      ])) : g("", !0)
    ], 16, A$1));
  }
}), ew1 = ["width", "height", "fill", "transform"], tw1 = { key: 0 }, nw1 = ["stroke"], sw1 = ["stroke"], rw1 = ["stroke"], iw1 = ["stroke"], lw1 = ["stroke"], dw1 = ["stroke"], kw1 = { key: 1 }, cw1 = /* @__PURE__ */ e("path", {
  d: "M128,32A96,96,0,0,0,63.8,199.4h0A72,72,0,0,1,128,160a40,40,0,1,1,40-40,40,40,0,0,1-40,40,72,72,0,0,1,64.2,39.4A96,96,0,0,0,128,32Z",
  opacity: "0.2"
}, null, -1), hw1 = ["stroke"], uw1 = ["stroke"], aw1 = ["stroke"], _w1 = ["stroke"], pw1 = ["stroke"], yw1 = ["stroke"], $w1 = { key: 2 }, ww1 = /* @__PURE__ */ e("path", { d: "M253.7,133.7l-24,24a8.2,8.2,0,0,1-11.4,0l-24-24a8.4,8.4,0,0,1-1.7-8.8A8,8,0,0,1,200,120h15.6A87.9,87.9,0,0,0,54.1,80.3,8,8,0,0,1,43,82.6a7.9,7.9,0,0,1-2.4-11A104,104,0,0,1,231.7,120H248a8,8,0,0,1,7.4,4.9A8.4,8.4,0,0,1,253.7,133.7ZM213,173.4a8,8,0,0,0-11.1,2.3,86.9,86.9,0,0,1-8.1,10.8h0a81.3,81.3,0,0,0-24.5-23,59.7,59.7,0,0,1-82.6,0,81.3,81.3,0,0,0-24.5,23h0A87.6,87.6,0,0,1,40.4,136H56a8,8,0,0,0,7.4-4.9,8.4,8.4,0,0,0-1.7-8.8l-24-24a8.1,8.1,0,0,0-11.4,0l-24,24a8.4,8.4,0,0,0-1.7,8.8A8,8,0,0,0,8,136H24.3a103.7,103.7,0,0,0,34.5,69.6h0l.4.3a103.9,103.9,0,0,0,156.2-21.5A7.9,7.9,0,0,0,213,173.4ZM128,164a44,44,0,1,0-44-44A44,44,0,0,0,128,164Z" }, null, -1), fw1 = [
  ww1
], gw1 = { key: 3 }, xw1 = ["stroke"], jw1 = ["stroke"], mw1 = ["stroke"], Mw1 = ["stroke"], vw1 = ["stroke"], Sw1 = ["stroke"], Hw1 = { key: 4 }, Aw1 = ["stroke"], Vw1 = ["stroke"], zw1 = ["stroke"], Zw1 = ["stroke"], Cw1 = ["stroke"], bw1 = ["stroke"], Lw1 = { key: 5 }, Bw1 = ["stroke"], Pw1 = ["stroke"], Ww1 = ["stroke"], Nw1 = ["stroke"], Fw1 = ["stroke"], Tw1 = ["stroke"], Dw1 = {
  name: "PhUserSwitch"
}, Gnl = /* @__PURE__ */ $({
  ...Dw1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", tw1, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nw1),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sw1),
        e("polyline", {
          points: "204 132 224 152 244 132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rw1),
        e("polyline", {
          points: "12 124 32 104 52 124",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, iw1),
        e("path", {
          d: "M224,152V128A96,96,0,0,0,52,69.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, lw1),
        e("path", {
          d: "M32,104v24a96,96,0,0,0,172,58.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, dw1)
      ])) : o(i) === "duotone" ? (s(), r("g", kw1, [
        cw1,
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hw1),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uw1),
        e("polyline", {
          points: "200 128 224 152 248 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aw1),
        e("polyline", {
          points: "8 128 32 104 56 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _w1),
        e("path", {
          d: "M224,152V128A96,96,0,0,0,47.3,75.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pw1),
        e("path", {
          d: "M32,104v24a96,96,0,0,0,176.7,52.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yw1)
      ])) : o(i) === "fill" ? (s(), r("g", $w1, fw1)) : o(i) === "light" ? (s(), r("g", gw1, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, xw1),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, jw1),
        e("polyline", {
          points: "200 128 224 152 248 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mw1),
        e("polyline", {
          points: "8 128 32 104 56 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Mw1),
        e("path", {
          d: "M224,152V128A96,96,0,0,0,47.3,75.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vw1),
        e("path", {
          d: "M32,104v24a96,96,0,0,0,176.7,52.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Sw1)
      ])) : o(i) === "thin" ? (s(), r("g", Hw1, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Aw1),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Vw1),
        e("polyline", {
          points: "200 128 224 152 248 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zw1),
        e("polyline", {
          points: "8 128 32 104 56 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Zw1),
        e("path", {
          d: "M224,152V128A96,96,0,0,0,47.3,75.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Cw1),
        e("path", {
          d: "M32,104v24a96,96,0,0,0,176.7,52.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bw1)
      ])) : o(i) === "regular" ? (s(), r("g", Lw1, [
        e("circle", {
          cx: "128",
          cy: "120",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bw1),
        e("path", {
          d: "M63.8,199.4a72,72,0,0,1,128.4,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pw1),
        e("polyline", {
          points: "200 128 224 152 248 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ww1),
        e("polyline", {
          points: "8 128 32 104 56 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nw1),
        e("path", {
          d: "M224,152V128A96,96,0,0,0,47.3,75.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fw1),
        e("path", {
          d: "M32,104v24a96,96,0,0,0,176.7,52.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tw1)
      ])) : g("", !0)
    ], 16, ew1));
  }
}), Rw1 = ["width", "height", "fill", "transform"], Uw1 = { key: 0 }, qw1 = ["stroke"], Gw1 = ["stroke"], Ew1 = ["stroke"], Ow1 = ["stroke"], Iw1 = { key: 1 }, Kw1 = /* @__PURE__ */ e("circle", {
  cx: "88",
  cy: "108",
  r: "52",
  opacity: "0.2"
}, null, -1), Xw1 = ["stroke"], Jw1 = ["stroke"], Qw1 = ["stroke"], Yw1 = ["stroke"], of1 = { key: 2 }, ef1 = /* @__PURE__ */ e("path", { d: "M121.2,157.9a60,60,0,1,0-66.4,0A95.5,95.5,0,0,0,9.5,192.8a7.8,7.8,0,0,0-.6,8.3,8.1,8.1,0,0,0,7.1,4.3H160a8.1,8.1,0,0,0,7.1-4.3,7.8,7.8,0,0,0-.6-8.3A95.5,95.5,0,0,0,121.2,157.9Z" }, null, -1), tf1 = /* @__PURE__ */ e("path", { d: "M248.1,192.8a96.3,96.3,0,0,0-45.4-34.9A59.9,59.9,0,0,0,169.5,48a64,64,0,0,0-16.3,2.2,8.2,8.2,0,0,0-5.4,5.2,8,8,0,0,0,1.2,7.3,75.8,75.8,0,0,1,3.8,84.9,8.1,8.1,0,0,0,2.1,10.6q4.5,3.5,8.7,7.2l.5.5a112.6,112.6,0,0,1,25.5,34.9,7.9,7.9,0,0,0,7.2,4.6h44.7a8.1,8.1,0,0,0,7.1-4.3A8,8,0,0,0,248.1,192.8Z" }, null, -1), nf1 = [
  ef1,
  tf1
], sf1 = { key: 3 }, rf1 = ["stroke"], if1 = ["stroke"], lf1 = ["stroke"], df1 = ["stroke"], kf1 = { key: 4 }, cf1 = ["stroke"], hf1 = ["stroke"], uf1 = ["stroke"], af1 = ["stroke"], _f1 = { key: 5 }, pf1 = ["stroke"], yf1 = ["stroke"], $f1 = ["stroke"], wf1 = ["stroke"], ff1 = {
  name: "PhUsers"
}, Enl = /* @__PURE__ */ $({
  ...ff1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Uw1, [
        e("circle", {
          cx: "88",
          cy: "108",
          r: "52",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qw1),
        e("path", {
          d: "M155.4,57.9A54.5,54.5,0,0,1,169.5,56a52,52,0,0,1,0,104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gw1),
        e("path", {
          d: "M16,197.4a88,88,0,0,1,144,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ew1),
        e("path", {
          d: "M169.5,160a87.9,87.9,0,0,1,72,37.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ow1)
      ])) : o(i) === "duotone" ? (s(), r("g", Iw1, [
        Kw1,
        e("circle", {
          cx: "88",
          cy: "108",
          r: "52",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, Xw1),
        e("path", {
          d: "M155.4,57.9A54.5,54.5,0,0,1,169.5,56a52,52,0,0,1,0,104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Jw1),
        e("path", {
          d: "M16,197.4a88,88,0,0,1,144,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Qw1),
        e("path", {
          d: "M169.5,160a87.9,87.9,0,0,1,72,37.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Yw1)
      ])) : o(i) === "fill" ? (s(), r("g", of1, nf1)) : o(i) === "light" ? (s(), r("g", sf1, [
        e("circle", {
          cx: "88",
          cy: "108",
          r: "52",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rf1),
        e("path", {
          d: "M155.4,57.9A54.5,54.5,0,0,1,169.5,56a52,52,0,0,1,0,104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, if1),
        e("path", {
          d: "M16,197.4a88,88,0,0,1,144,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, lf1),
        e("path", {
          d: "M169.5,160a87.9,87.9,0,0,1,72,37.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, df1)
      ])) : o(i) === "thin" ? (s(), r("g", kf1, [
        e("circle", {
          cx: "88",
          cy: "108",
          r: "52",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, cf1),
        e("path", {
          d: "M155.4,57.9A54.5,54.5,0,0,1,169.5,56a52,52,0,0,1,0,104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, hf1),
        e("path", {
          d: "M16,197.4a88,88,0,0,1,144,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uf1),
        e("path", {
          d: "M169.5,160a87.9,87.9,0,0,1,72,37.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, af1)
      ])) : o(i) === "regular" ? (s(), r("g", _f1, [
        e("circle", {
          cx: "88",
          cy: "108",
          r: "52",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, pf1),
        e("path", {
          d: "M155.4,57.9A54.5,54.5,0,0,1,169.5,56a52,52,0,0,1,0,104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yf1),
        e("path", {
          d: "M16,197.4a88,88,0,0,1,144,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $f1),
        e("path", {
          d: "M169.5,160a87.9,87.9,0,0,1,72,37.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wf1)
      ])) : g("", !0)
    ], 16, Rw1));
  }
}), gf1 = ["width", "height", "fill", "transform"], xf1 = { key: 0 }, jf1 = ["stroke"], mf1 = ["stroke"], Mf1 = ["stroke"], vf1 = ["stroke"], Sf1 = ["stroke"], Hf1 = ["stroke"], Af1 = ["stroke"], Vf1 = ["stroke"], zf1 = { key: 1 }, Zf1 = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "168",
  r: "32",
  opacity: "0.2"
}, null, -1), Cf1 = /* @__PURE__ */ e("circle", {
  cx: "80",
  cy: "64",
  r: "32",
  opacity: "0.2"
}, null, -1), bf1 = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "168",
  r: "32",
  opacity: "0.2"
}, null, -1), Lf1 = /* @__PURE__ */ e("circle", {
  cx: "176",
  cy: "64",
  r: "32",
  opacity: "0.2"
}, null, -1), Bf1 = ["stroke"], Pf1 = ["stroke"], Wf1 = ["stroke"], Nf1 = ["stroke"], Ff1 = ["stroke"], Tf1 = ["stroke"], Df1 = ["stroke"], Rf1 = ["stroke"], Uf1 = { key: 2 }, qf1 = /* @__PURE__ */ e("path", { d: "M25.6,115.2A67.8,67.8,0,0,1,53,93.5a40,40,0,1,1,54,0,68.1,68.1,0,0,1,21,14.3,68.1,68.1,0,0,1,21-14.3,40,40,0,1,1,54,0,67.8,67.8,0,0,1,27.4,21.7,8,8,0,0,1-1.6,11.2,8.1,8.1,0,0,1-11.2-1.6,52,52,0,0,0-83.2,0h0l-.6.6h-.1l-.5.5-.3.2a.1.1,0,0,1-.1.1l-.3.2-.3.2-.5.3h-.2l-1.7.6h-3.3l-.8-.2h-.3l-.9-.4-.3-.2a4.7,4.7,0,0,1-.9-.6h-.1l-.3-.3h-.2c-.2-.2-.4-.3-.5-.5h-.1l-.6-.7a52,52,0,0,0-83.1.1A8,8,0,0,1,32,128a7.7,7.7,0,0,1-4.8-1.6A8,8,0,0,1,25.6,115.2ZM203,197.5a40,40,0,1,0-54,0,68.1,68.1,0,0,0-21,14.3,68.1,68.1,0,0,0-21-14.3,40,40,0,1,0-54,0,67.8,67.8,0,0,0-27.4,21.7A8,8,0,0,0,32,232H224a8,8,0,0,0,6.4-12.8A67.8,67.8,0,0,0,203,197.5Z" }, null, -1), Gf1 = [
  qf1
], Ef1 = { key: 3 }, Of1 = ["stroke"], If1 = ["stroke"], Kf1 = ["stroke"], Xf1 = ["stroke"], Jf1 = ["stroke"], Qf1 = ["stroke"], Yf1 = ["stroke"], og1 = ["stroke"], eg1 = { key: 4 }, tg1 = ["stroke"], ng1 = ["stroke"], sg1 = ["stroke"], rg1 = ["stroke"], ig1 = ["stroke"], lg1 = ["stroke"], dg1 = ["stroke"], kg1 = ["stroke"], cg1 = { key: 5 }, hg1 = ["stroke"], ug1 = ["stroke"], ag1 = ["stroke"], _g1 = ["stroke"], pg1 = ["stroke"], yg1 = ["stroke"], $g1 = ["stroke"], wg1 = ["stroke"], fg1 = {
  name: "PhUsersFour"
}, Onl = /* @__PURE__ */ $({
  ...fg1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xf1, [
        e("circle", {
          cx: "80",
          cy: "172",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jf1),
        e("path", {
          d: "M32,224a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mf1),
        e("circle", {
          cx: "80",
          cy: "64",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mf1),
        e("path", {
          d: "M32,116a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vf1),
        e("circle", {
          cx: "176",
          cy: "172",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Sf1),
        e("path", {
          d: "M128,224a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hf1),
        e("circle", {
          cx: "176",
          cy: "64",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Af1),
        e("path", {
          d: "M128,116a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vf1)
      ])) : o(i) === "duotone" ? (s(), r("g", zf1, [
        Zf1,
        Cf1,
        bf1,
        Lf1,
        e("circle", {
          cx: "80",
          cy: "168",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bf1),
        e("path", {
          d: "M32,224a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pf1),
        e("circle", {
          cx: "80",
          cy: "64",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wf1),
        e("path", {
          d: "M32,120a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nf1),
        e("circle", {
          cx: "176",
          cy: "168",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ff1),
        e("path", {
          d: "M128,224a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tf1),
        e("circle", {
          cx: "176",
          cy: "64",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Df1),
        e("path", {
          d: "M128,120a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rf1)
      ])) : o(i) === "fill" ? (s(), r("g", Uf1, Gf1)) : o(i) === "light" ? (s(), r("g", Ef1, [
        e("circle", {
          cx: "80",
          cy: "168",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Of1),
        e("path", {
          d: "M32,224a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, If1),
        e("circle", {
          cx: "80",
          cy: "64",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Kf1),
        e("path", {
          d: "M32,120a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Xf1),
        e("circle", {
          cx: "176",
          cy: "168",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Jf1),
        e("path", {
          d: "M128,224a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Qf1),
        e("circle", {
          cx: "176",
          cy: "64",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Yf1),
        e("path", {
          d: "M128,120a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, og1)
      ])) : o(i) === "thin" ? (s(), r("g", eg1, [
        e("circle", {
          cx: "80",
          cy: "168",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tg1),
        e("path", {
          d: "M32,224a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ng1),
        e("circle", {
          cx: "80",
          cy: "64",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sg1),
        e("path", {
          d: "M32,120a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rg1),
        e("circle", {
          cx: "176",
          cy: "168",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ig1),
        e("path", {
          d: "M128,224a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lg1),
        e("circle", {
          cx: "176",
          cy: "64",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dg1),
        e("path", {
          d: "M128,120a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, kg1)
      ])) : o(i) === "regular" ? (s(), r("g", cg1, [
        e("circle", {
          cx: "80",
          cy: "168",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hg1),
        e("path", {
          d: "M32,224a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ug1),
        e("circle", {
          cx: "80",
          cy: "64",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ag1),
        e("path", {
          d: "M32,120a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _g1),
        e("circle", {
          cx: "176",
          cy: "168",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, pg1),
        e("path", {
          d: "M128,224a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yg1),
        e("circle", {
          cx: "176",
          cy: "64",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $g1),
        e("path", {
          d: "M128,120a60,60,0,0,1,96,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wg1)
      ])) : g("", !0)
    ], 16, gf1));
  }
}), gg1 = ["width", "height", "fill", "transform"], xg1 = { key: 0 }, jg1 = ["stroke"], mg1 = ["stroke"], Mg1 = ["stroke"], vg1 = ["stroke"], Sg1 = ["stroke"], Hg1 = ["stroke"], Ag1 = { key: 1 }, Vg1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "140",
  r: "40",
  opacity: "0.2"
}, null, -1), zg1 = /* @__PURE__ */ e("circle", {
  cx: "60",
  cy: "84",
  r: "32",
  opacity: "0.2"
}, null, -1), Zg1 = /* @__PURE__ */ e("circle", {
  cx: "196",
  cy: "84",
  r: "32",
  opacity: "0.2"
}, null, -1), Cg1 = ["stroke"], bg1 = ["stroke"], Lg1 = ["stroke"], Bg1 = ["stroke"], Pg1 = ["stroke"], Wg1 = ["stroke"], Ng1 = { key: 2 }, Fg1 = /* @__PURE__ */ e("path", { d: "M64,140a7.9,7.9,0,0,1-8,8H12a8.2,8.2,0,0,1-7.2-4.4,8.2,8.2,0,0,1,.8-8.4A67.8,67.8,0,0,1,33,113.5a40,40,0,1,1,66.3-37,8.1,8.1,0,0,1-3.8,8.4,64.3,64.3,0,0,0-27.8,33.8A61.6,61.6,0,0,0,64,140Zm186.4-4.8A67.8,67.8,0,0,0,223,113.5a40,40,0,1,0-66.3-37,8.1,8.1,0,0,0,3.8,8.4,64,64,0,0,1,27.8,33.8A61.6,61.6,0,0,1,192,140a7.9,7.9,0,0,0,8,8h44a8,8,0,0,0,6.4-12.8Zm-93.2,42.9a48,48,0,1,0-58.4,0,72.1,72.1,0,0,0-35.6,34.4,7.8,7.8,0,0,0,.5,7.7,7.8,7.8,0,0,0,6.7,3.8H185.6a7.8,7.8,0,0,0,6.7-3.8,7.8,7.8,0,0,0,.5-7.7A72.1,72.1,0,0,0,157.2,178.1Z" }, null, -1), Tg1 = [
  Fg1
], Dg1 = { key: 3 }, Rg1 = ["stroke"], Ug1 = ["stroke"], qg1 = ["stroke"], Gg1 = ["stroke"], Eg1 = ["stroke"], Og1 = ["stroke"], Ig1 = { key: 4 }, Kg1 = ["stroke"], Xg1 = ["stroke"], Jg1 = ["stroke"], Qg1 = ["stroke"], Yg1 = ["stroke"], ox1 = ["stroke"], ex1 = { key: 5 }, tx1 = ["stroke"], nx1 = ["stroke"], sx1 = ["stroke"], rx1 = ["stroke"], ix1 = ["stroke"], lx1 = ["stroke"], dx1 = {
  name: "PhUsersThree"
}, Inl = /* @__PURE__ */ $({
  ...dx1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xg1, [
        e("circle", {
          cx: "128",
          cy: "140",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jg1),
        e("path", {
          d: "M70.4,216a64.1,64.1,0,0,1,115.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mg1),
        e("path", {
          d: "M204.5,116.6A60.1,60.1,0,0,1,244,140",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mg1),
        e("path", {
          d: "M167.1,70.2A32,32,0,1,1,204,115",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vg1),
        e("path", {
          d: "M52,115A32,32,0,1,1,88.9,70.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Sg1),
        e("path", {
          d: "M12,140a60.1,60.1,0,0,1,39.5-23.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hg1)
      ])) : o(i) === "duotone" ? (s(), r("g", Ag1, [
        Vg1,
        zg1,
        Zg1,
        e("circle", {
          cx: "128",
          cy: "140",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cg1),
        e("path", {
          d: "M196,116a59.8,59.8,0,0,1,48,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bg1),
        e("path", {
          d: "M12,140a59.8,59.8,0,0,1,48-24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lg1),
        e("path", {
          d: "M70.4,216a64.1,64.1,0,0,1,115.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bg1),
        e("path", {
          d: "M60,116A32,32,0,1,1,91.4,78",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pg1),
        e("path", {
          d: "M164.6,78A32,32,0,1,1,196,116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Wg1)
      ])) : o(i) === "fill" ? (s(), r("g", Ng1, Tg1)) : o(i) === "light" ? (s(), r("g", Dg1, [
        e("circle", {
          cx: "128",
          cy: "140",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rg1),
        e("path", {
          d: "M196,116a59.8,59.8,0,0,1,48,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ug1),
        e("path", {
          d: "M12,140a59.8,59.8,0,0,1,48-24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qg1),
        e("path", {
          d: "M70.4,216a64.1,64.1,0,0,1,115.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gg1),
        e("path", {
          d: "M60,116A32,32,0,1,1,91.4,78",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Eg1),
        e("path", {
          d: "M164.6,78A32,32,0,1,1,196,116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Og1)
      ])) : o(i) === "thin" ? (s(), r("g", Ig1, [
        e("circle", {
          cx: "128",
          cy: "140",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kg1),
        e("path", {
          d: "M196,116a59.8,59.8,0,0,1,48,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xg1),
        e("path", {
          d: "M12,140a59.8,59.8,0,0,1,48-24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jg1),
        e("path", {
          d: "M70.4,216a64.1,64.1,0,0,1,115.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qg1),
        e("path", {
          d: "M60,116A32,32,0,1,1,91.4,78",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Yg1),
        e("path", {
          d: "M164.6,78A32,32,0,1,1,196,116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ox1)
      ])) : o(i) === "regular" ? (s(), r("g", ex1, [
        e("circle", {
          cx: "128",
          cy: "140",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tx1),
        e("path", {
          d: "M196,116a59.8,59.8,0,0,1,48,24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nx1),
        e("path", {
          d: "M12,140a59.8,59.8,0,0,1,48-24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sx1),
        e("path", {
          d: "M70.4,216a64.1,64.1,0,0,1,115.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rx1),
        e("path", {
          d: "M60,116A32,32,0,1,1,91.4,78",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ix1),
        e("path", {
          d: "M164.6,78A32,32,0,1,1,196,116",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lx1)
      ])) : g("", !0)
    ], 16, gg1));
  }
}), kx1 = ["width", "height", "fill", "transform"], cx1 = { key: 0 }, hx1 = ["stroke"], ux1 = ["stroke"], ax1 = ["stroke"], _x1 = ["stroke"], px1 = ["stroke"], yx1 = { key: 1 }, $x1 = /* @__PURE__ */ e("path", {
  d: "M216,48H40a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V56A8,8,0,0,0,216,48ZM152,168a40,40,0,1,1,40-40A40,40,0,0,1,152,168Z",
  opacity: "0.2"
}, null, -1), wx1 = ["stroke"], fx1 = ["stroke"], gx1 = ["stroke"], xx1 = /* @__PURE__ */ e("circle", {
  cx: "152",
  cy: "128",
  r: "16"
}, null, -1), jx1 = ["stroke"], mx1 = ["stroke"], Mx1 = { key: 2 }, vx1 = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V192a16,16,0,0,0,16,16H56v16a8,8,0,0,0,16,0V208H184v16a8,8,0,0,0,16,0V208h16a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm-8,96H179.1a36,36,0,1,1,0-16H208a8,8,0,0,1,0,16Zm-44-8a20,20,0,1,1-20-20A20.1,20.1,0,0,1,164,128Z" }, null, -1), Sx1 = [
  vx1
], Hx1 = { key: 3 }, Ax1 = ["stroke"], Vx1 = ["stroke"], zx1 = ["stroke"], Zx1 = /* @__PURE__ */ e("circle", {
  cx: "152",
  cy: "128",
  r: "14"
}, null, -1), Cx1 = ["stroke"], bx1 = ["stroke"], Lx1 = { key: 4 }, Bx1 = ["stroke"], Px1 = ["stroke"], Wx1 = ["stroke"], Nx1 = /* @__PURE__ */ e("circle", {
  cx: "152",
  cy: "128",
  r: "12"
}, null, -1), Fx1 = ["stroke"], Tx1 = ["stroke"], Dx1 = { key: 5 }, Rx1 = ["stroke"], Ux1 = ["stroke"], qx1 = ["stroke"], Gx1 = /* @__PURE__ */ e("circle", {
  cx: "152",
  cy: "128",
  r: "16"
}, null, -1), Ex1 = ["stroke"], Ox1 = ["stroke"], Ix1 = {
  name: "PhVault"
}, Knl = /* @__PURE__ */ $({
  ...Ix1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", cx1, [
        e("line", {
          x1: "192",
          y1: "200",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hx1),
        e("line", {
          x1: "64",
          y1: "200",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ux1),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "152",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ax1),
        e("line", {
          x1: "180",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _x1),
        e("circle", {
          cx: "148",
          cy: "128",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, px1)
      ])) : o(i) === "duotone" ? (s(), r("g", yx1, [
        $x1,
        e("line", {
          x1: "192",
          y1: "200",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wx1),
        e("line", {
          x1: "64",
          y1: "200",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fx1),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "152",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gx1),
        xx1,
        e("line", {
          x1: "152",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jx1),
        e("circle", {
          cx: "152",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mx1)
      ])) : o(i) === "fill" ? (s(), r("g", Mx1, Sx1)) : o(i) === "light" ? (s(), r("g", Hx1, [
        e("line", {
          x1: "192",
          y1: "200",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ax1),
        e("line", {
          x1: "64",
          y1: "200",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vx1),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "152",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zx1),
        Zx1,
        e("line", {
          x1: "152",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Cx1),
        e("circle", {
          cx: "152",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, bx1)
      ])) : o(i) === "thin" ? (s(), r("g", Lx1, [
        e("line", {
          x1: "192",
          y1: "200",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bx1),
        e("line", {
          x1: "64",
          y1: "200",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Px1),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "152",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Wx1),
        Nx1,
        e("line", {
          x1: "152",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Fx1),
        e("circle", {
          cx: "152",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Tx1)
      ])) : o(i) === "regular" ? (s(), r("g", Dx1, [
        e("line", {
          x1: "192",
          y1: "200",
          x2: "192",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Rx1),
        e("line", {
          x1: "64",
          y1: "200",
          x2: "64",
          y2: "224",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ux1),
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "152",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qx1),
        Gx1,
        e("line", {
          x1: "152",
          y1: "128",
          x2: "224",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ex1),
        e("circle", {
          cx: "152",
          cy: "128",
          r: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ox1)
      ])) : g("", !0)
    ], 16, kx1));
  }
}), Kx1 = ["width", "height", "fill", "transform"], Xx1 = { key: 0 }, Jx1 = ["stroke"], Qx1 = ["stroke"], Yx1 = ["stroke"], oj1 = { key: 1 }, ej1 = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "80",
  width: "176",
  height: "96",
  rx: "16",
  transform: "translate(256) rotate(90)",
  opacity: "0.2"
}, null, -1), tj1 = ["stroke"], nj1 = ["stroke"], sj1 = ["stroke"], rj1 = ["stroke"], ij1 = ["stroke"], lj1 = { key: 2 }, dj1 = /* @__PURE__ */ j('<rect x="72" y="32" width="112" height="192" rx="24"></rect><path d="M208,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,208,80Z"></path><path d="M240,96a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0V104A8,8,0,0,0,240,96Z"></path><path d="M48,80a8,8,0,0,0-8,8v80a8,8,0,0,0,16,0V88A8,8,0,0,0,48,80Z"></path><path d="M16,96a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0V104A8,8,0,0,0,16,96Z"></path>', 5), kj1 = [
  dj1
], cj1 = { key: 3 }, hj1 = ["stroke"], uj1 = ["stroke"], aj1 = ["stroke"], _j1 = ["stroke"], pj1 = ["stroke"], yj1 = { key: 4 }, $j1 = ["stroke"], wj1 = ["stroke"], fj1 = ["stroke"], gj1 = ["stroke"], xj1 = ["stroke"], jj1 = { key: 5 }, mj1 = ["stroke"], Mj1 = ["stroke"], vj1 = ["stroke"], Sj1 = ["stroke"], Hj1 = ["stroke"], Aj1 = {
  name: "PhVibrate"
}, Xnl = /* @__PURE__ */ $({
  ...Aj1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Xx1, [
        e("rect", {
          x: "40",
          y: "76",
          width: "176",
          height: "104",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jx1),
        e("line", {
          x1: "220",
          y1: "100",
          x2: "220",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qx1),
        e("line", {
          x1: "36",
          y1: "100",
          x2: "36",
          y2: "156",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Yx1)
      ])) : o(i) === "duotone" ? (s(), r("g", oj1, [
        ej1,
        e("rect", {
          x: "40",
          y: "80",
          width: "176",
          height: "96",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tj1),
        e("line", {
          x1: "208",
          y1: "88",
          x2: "208",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nj1),
        e("line", {
          x1: "240",
          y1: "104",
          x2: "240",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sj1),
        e("line", {
          x1: "48",
          y1: "88",
          x2: "48",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rj1),
        e("line", {
          x1: "16",
          y1: "104",
          x2: "16",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ij1)
      ])) : o(i) === "fill" ? (s(), r("g", lj1, kj1)) : o(i) === "light" ? (s(), r("g", cj1, [
        e("rect", {
          x: "40",
          y: "80",
          width: "176",
          height: "96",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hj1),
        e("line", {
          x1: "208",
          y1: "88",
          x2: "208",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, uj1),
        e("line", {
          x1: "240",
          y1: "104",
          x2: "240",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, aj1),
        e("line", {
          x1: "48",
          y1: "88",
          x2: "48",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _j1),
        e("line", {
          x1: "16",
          y1: "104",
          x2: "16",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pj1)
      ])) : o(i) === "thin" ? (s(), r("g", yj1, [
        e("rect", {
          x: "40",
          y: "80",
          width: "176",
          height: "96",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $j1),
        e("line", {
          x1: "208",
          y1: "88",
          x2: "208",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wj1),
        e("line", {
          x1: "240",
          y1: "104",
          x2: "240",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fj1),
        e("line", {
          x1: "48",
          y1: "88",
          x2: "48",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gj1),
        e("line", {
          x1: "16",
          y1: "104",
          x2: "16",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xj1)
      ])) : o(i) === "regular" ? (s(), r("g", jj1, [
        e("rect", {
          x: "40",
          y: "80",
          width: "176",
          height: "96",
          rx: "16",
          transform: "translate(256) rotate(90)",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mj1),
        e("line", {
          x1: "208",
          y1: "88",
          x2: "208",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mj1),
        e("line", {
          x1: "240",
          y1: "104",
          x2: "240",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, vj1),
        e("line", {
          x1: "48",
          y1: "88",
          x2: "48",
          y2: "168",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Sj1),
        e("line", {
          x1: "16",
          y1: "104",
          x2: "16",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hj1)
      ])) : g("", !0)
    ], 16, Kx1));
  }
}), Vj1 = ["width", "height", "fill", "transform"], zj1 = { key: 0 }, Zj1 = ["stroke"], Cj1 = ["stroke"], bj1 = { key: 1 }, Lj1 = /* @__PURE__ */ e("path", {
  d: "M24,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68A8,8,0,0,1,24,60Z",
  opacity: "0.2"
}, null, -1), Bj1 = ["stroke"], Pj1 = ["stroke"], Wj1 = { key: 2 }, Nj1 = /* @__PURE__ */ e("path", { d: "M176,92v96a16,16,0,0,1-16,16H48A40,40,0,0,1,8,164V68A16,16,0,0,1,24,52H136A40,40,0,0,1,176,92Zm68-18.9a7.7,7.7,0,0,0-8,0L196,95.9a8,8,0,0,0-4,7v50.2a8,8,0,0,0,4,7l40,22.8a8.3,8.3,0,0,0,4,1.1,8,8,0,0,0,4-1.1,7.8,7.8,0,0,0,4-6.9V80A7.8,7.8,0,0,0,244,73.1Z" }, null, -1), Fj1 = [
  Nj1
], Tj1 = { key: 3 }, Dj1 = ["stroke"], Rj1 = ["stroke"], Uj1 = { key: 4 }, qj1 = ["stroke"], Gj1 = ["stroke"], Ej1 = { key: 5 }, Oj1 = ["stroke"], Ij1 = ["stroke"], Kj1 = {
  name: "PhVideoCamera"
}, Jnl = /* @__PURE__ */ $({
  ...Kj1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", zj1, [
        e("path", {
          d: "M24,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68A8,8,0,0,1,24,60Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Zj1),
        e("polyline", {
          points: "184 112 240 80 240 176 184 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Cj1)
      ])) : o(i) === "duotone" ? (s(), r("g", bj1, [
        Lj1,
        e("path", {
          d: "M24,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68A8,8,0,0,1,24,60Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bj1),
        e("polyline", {
          points: "184 112 240 80 240 176 184 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Pj1)
      ])) : o(i) === "fill" ? (s(), r("g", Wj1, Fj1)) : o(i) === "light" ? (s(), r("g", Tj1, [
        e("path", {
          d: "M24,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68A8,8,0,0,1,24,60Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dj1),
        e("polyline", {
          points: "184 112 240 80 240 176 184 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rj1)
      ])) : o(i) === "thin" ? (s(), r("g", Uj1, [
        e("path", {
          d: "M24,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68A8,8,0,0,1,24,60Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qj1),
        e("polyline", {
          points: "184 112 240 80 240 176 184 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Gj1)
      ])) : o(i) === "regular" ? (s(), r("g", Ej1, [
        e("path", {
          d: "M24,60H152a32,32,0,0,1,32,32v96a8,8,0,0,1-8,8H48a32,32,0,0,1-32-32V68A8,8,0,0,1,24,60Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Oj1),
        e("polyline", {
          points: "184 112 240 80 240 176 184 144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Ij1)
      ])) : g("", !0)
    ], 16, Vj1));
  }
}), Xj1 = ["width", "height", "fill", "transform"], Jj1 = { key: 0 }, Qj1 = ["stroke"], Yj1 = ["stroke"], om1 = ["stroke"], em1 = { key: 1 }, tm1 = /* @__PURE__ */ e("rect", {
  x: "16",
  y: "60",
  width: "168",
  height: "136",
  rx: "8",
  opacity: "0.2"
}, null, -1), nm1 = ["stroke"], sm1 = ["stroke"], rm1 = ["stroke"], im1 = ["stroke"], lm1 = { key: 2 }, dm1 = /* @__PURE__ */ e("path", { d: "M229.9,226.6a7.9,7.9,0,0,1-.5,11.3A8.2,8.2,0,0,1,224,240a8,8,0,0,1-5.9-2.6l-42.4-46.6A15.9,15.9,0,0,1,160,204H24A16,16,0,0,1,8,188V68A16,16,0,0,1,24,52H49.6L29,29.4a8,8,0,0,1,.5-11.3,7.9,7.9,0,0,1,11.3.5ZM245.5,74.2a7.9,7.9,0,0,0-9.5-1.1L196,95.9a8,8,0,0,0-4,7v50.2a8,8,0,0,0,4,7l40,22.8a8.3,8.3,0,0,0,4,1.1,7.9,7.9,0,0,0,5.8-2.5,8,8,0,0,0,2.2-5.7V80.2A8,8,0,0,0,245.5,74.2Zm-83.4,54a8,8,0,0,0,9.8,1.6,8.2,8.2,0,0,0,4.1-7.3V68a16,16,0,0,0-16-16H111.1a8.5,8.5,0,0,0-6.6,3.1,8,8,0,0,0,.5,10.3Z" }, null, -1), km1 = [
  dm1
], cm1 = { key: 3 }, hm1 = ["stroke"], um1 = ["stroke"], am1 = ["stroke"], _m1 = ["stroke"], pm1 = { key: 4 }, ym1 = ["stroke"], $m1 = ["stroke"], wm1 = ["stroke"], fm1 = ["stroke"], gm1 = { key: 5 }, xm1 = ["stroke"], jm1 = ["stroke"], mm1 = ["stroke"], Mm1 = ["stroke"], vm1 = {
  name: "PhVideoCameraSlash"
}, Qnl = /* @__PURE__ */ $({
  ...vm1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Jj1, [
        e("polygon", {
          points: "240 176 184 144 184 112 240 80 240 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Qj1),
        e("line", {
          x1: "34.9",
          y1: "24",
          x2: "224",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Yj1),
        e("path", {
          d: "M121.7,60H176a8,8,0,0,1,8,8V188a8,8,0,0,1-8,8H24a8,8,0,0,1-8-8V68a8,8,0,0,1,8-8H67.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, om1)
      ])) : o(i) === "duotone" ? (s(), r("g", em1, [
        tm1,
        e("polygon", {
          points: "240 176 184 144 184 112 240 80 240 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nm1),
        e("line", {
          x1: "34.9",
          y1: "24",
          x2: "224",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sm1),
        e("path", {
          d: "M110.9,60H176a8,8,0,0,1,8,8v76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rm1),
        e("path", {
          d: "M184,188a8,8,0,0,1-8,8H24a8,8,0,0,1-8-8V68a8,8,0,0,1,8-8H67.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, im1)
      ])) : o(i) === "fill" ? (s(), r("g", lm1, km1)) : o(i) === "light" ? (s(), r("g", cm1, [
        e("polygon", {
          points: "240 176 184 144 184 112 240 80 240 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, hm1),
        e("line", {
          x1: "34.9",
          y1: "24",
          x2: "224",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, um1),
        e("path", {
          d: "M110.9,60H176a8,8,0,0,1,8,8v76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, am1),
        e("path", {
          d: "M184,188a8,8,0,0,1-8,8H24a8,8,0,0,1-8-8V68a8,8,0,0,1,8-8H67.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, _m1)
      ])) : o(i) === "thin" ? (s(), r("g", pm1, [
        e("polygon", {
          points: "240 176 184 144 184 112 240 80 240 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ym1),
        e("line", {
          x1: "34.9",
          y1: "24",
          x2: "224",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, $m1),
        e("path", {
          d: "M110.9,60H176a8,8,0,0,1,8,8v76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, wm1),
        e("path", {
          d: "M184,188a8,8,0,0,1-8,8H24a8,8,0,0,1-8-8V68a8,8,0,0,1,8-8H67.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fm1)
      ])) : o(i) === "regular" ? (s(), r("g", gm1, [
        e("polygon", {
          points: "240 176 184 144 184 112 240 80 240 176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xm1),
        e("line", {
          x1: "34.9",
          y1: "24",
          x2: "224",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jm1),
        e("path", {
          d: "M110.9,60H176a8,8,0,0,1,8,8v76",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mm1),
        e("path", {
          d: "M184,188a8,8,0,0,1-8,8H24a8,8,0,0,1-8-8V68a8,8,0,0,1,8-8H67.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Mm1)
      ])) : g("", !0)
    ], 16, Xj1));
  }
}), Sm1 = ["width", "height", "fill", "transform"], Hm1 = { key: 0 }, Am1 = ["stroke"], Vm1 = ["stroke"], zm1 = { key: 1 }, Zm1 = /* @__PURE__ */ e("path", {
  d: "M216,48H40a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V56A8,8,0,0,0,216,48ZM128,176c-35.3,0-64-21.5-64-48s28.7-48,64-48,64,21.5,64,48S163.3,176,128,176Z",
  opacity: "0.2"
}, null, -1), Cm1 = ["stroke"], bm1 = ["stroke"], Lm1 = { key: 2 }, Bm1 = /* @__PURE__ */ e("path", { d: "M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm-16,88c0,30.9-32.2,56-72,56s-72-25.1-72-56,32.2-56,72-56S200,97.1,200,128Z" }, null, -1), Pm1 = [
  Bm1
], Wm1 = { key: 3 }, Nm1 = ["stroke"], Fm1 = ["stroke"], Tm1 = { key: 4 }, Dm1 = ["stroke"], Rm1 = ["stroke"], Um1 = { key: 5 }, qm1 = ["stroke"], Gm1 = ["stroke"], Em1 = {
  name: "PhVignette"
}, Ynl = /* @__PURE__ */ $({
  ...Em1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Hm1, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Am1),
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "56",
          ry: "40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vm1)
      ])) : o(i) === "duotone" ? (s(), r("g", zm1, [
        Zm1,
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cm1),
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "64",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bm1)
      ])) : o(i) === "fill" ? (s(), r("g", Lm1, Pm1)) : o(i) === "light" ? (s(), r("g", Wm1, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Nm1),
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "64",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fm1)
      ])) : o(i) === "thin" ? (s(), r("g", Tm1, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Dm1),
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "64",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Rm1)
      ])) : o(i) === "regular" ? (s(), r("g", Um1, [
        e("rect", {
          x: "32",
          y: "48",
          width: "192",
          height: "160",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qm1),
        e("ellipse", {
          cx: "128",
          cy: "128",
          rx: "64",
          ry: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Gm1)
      ])) : g("", !0)
    ], 16, Sm1));
  }
}), Om1 = ["width", "height", "fill", "transform"], Im1 = { key: 0 }, Km1 = ["stroke"], Xm1 = ["stroke"], Jm1 = ["stroke"], Qm1 = { key: 1 }, Ym1 = /* @__PURE__ */ e("circle", {
  cx: "56",
  cy: "128",
  r: "48",
  opacity: "0.2"
}, null, -1), oM1 = /* @__PURE__ */ e("circle", {
  cx: "200",
  cy: "128",
  r: "48",
  opacity: "0.2"
}, null, -1), eM1 = ["stroke"], tM1 = ["stroke"], nM1 = ["stroke"], sM1 = { key: 2 }, rM1 = /* @__PURE__ */ e("path", { d: "M200,72a55.9,55.9,0,0,0-39.1,96H95.1A55.9,55.9,0,1,0,56,184H200a56,56,0,0,0,0-112ZM16,128a40,40,0,1,1,40,40A40,40,0,0,1,16,128Zm184,40a40,40,0,1,1,40-40A40,40,0,0,1,200,168Z" }, null, -1), iM1 = [
  rM1
], lM1 = { key: 3 }, dM1 = ["stroke"], kM1 = ["stroke"], cM1 = ["stroke"], hM1 = { key: 4 }, uM1 = ["stroke"], aM1 = ["stroke"], _M1 = ["stroke"], pM1 = { key: 5 }, yM1 = ["stroke"], $M1 = ["stroke"], wM1 = ["stroke"], fM1 = {
  name: "PhVoicemail"
}, osl = /* @__PURE__ */ $({
  ...fM1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", Im1, [
        e("circle", {
          cx: "60",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Km1),
        e("circle", {
          cx: "196",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Xm1),
        e("line", {
          x1: "60",
          y1: "176",
          x2: "196",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Jm1)
      ])) : o(i) === "duotone" ? (s(), r("g", Qm1, [
        Ym1,
        oM1,
        e("circle", {
          cx: "56",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eM1),
        e("circle", {
          cx: "200",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tM1),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "200",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nM1)
      ])) : o(i) === "fill" ? (s(), r("g", sM1, iM1)) : o(i) === "light" ? (s(), r("g", lM1, [
        e("circle", {
          cx: "56",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dM1),
        e("circle", {
          cx: "200",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kM1),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "200",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cM1)
      ])) : o(i) === "thin" ? (s(), r("g", hM1, [
        e("circle", {
          cx: "56",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uM1),
        e("circle", {
          cx: "200",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aM1),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "200",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _M1)
      ])) : o(i) === "regular" ? (s(), r("g", pM1, [
        e("circle", {
          cx: "56",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yM1),
        e("circle", {
          cx: "200",
          cy: "128",
          r: "48",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $M1),
        e("line", {
          x1: "56",
          y1: "176",
          x2: "200",
          y2: "176",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wM1)
      ])) : g("", !0)
    ], 16, Om1));
  }
}), gM1 = ["width", "height", "fill", "transform"], xM1 = { key: 0 }, jM1 = ["stroke"], mM1 = ["stroke"], MM1 = ["stroke"], vM1 = ["stroke"], SM1 = ["stroke"], HM1 = ["stroke"], AM1 = ["stroke"], VM1 = { key: 1 }, zM1 = /* @__PURE__ */ e("path", {
  d: "M80,211.2a96.2,96.2,0,0,0,136.3-45.4h0A96,96,0,0,1,105.5,167L80,211.1Z",
  opacity: "0.2"
}, null, -1), ZM1 = /* @__PURE__ */ e("path", {
  d: "M80,211.1a96.3,96.3,0,0,1-28.9-25.5h0A96,96,0,0,1,105.5,89L128,128Z",
  opacity: "0.2"
}, null, -1), CM1 = /* @__PURE__ */ e("path", {
  d: "M80,44.9a96,96,0,0,1,36.6-12.2h0A96.1,96.1,0,0,1,173.1,128H128Z",
  opacity: "0.2"
}, null, -1), bM1 = ["stroke"], LM1 = ["stroke"], BM1 = ["stroke"], PM1 = ["stroke"], WM1 = ["stroke"], NM1 = ["stroke"], FM1 = ["stroke"], TM1 = { key: 2 }, DM1 = /* @__PURE__ */ e("path", { d: "M232,127.6A104,104,0,1,0,37.9,180c2,3.4,4.2,6.7,6.5,9.9l.5.7a103.9,103.9,0,0,0,178.2-20.7,7.2,7.2,0,0,0,.9-2,105.7,105.7,0,0,0,8-39.3v-1ZM44.5,155.9A88.2,88.2,0,0,1,77.3,56.1L94.4,85.8a104.4,104.4,0,0,0-49.9,70.1Zm32.8,44a84.2,84.2,0,0,1-18.4-17.4,88,88,0,0,1,43.5-82.9L118.8,128Zm132.4-39.3a88.2,88.2,0,0,1-93.5,3.8L132.6,136h83A89.3,89.3,0,0,1,209.7,160.6ZM181.4,120a105,105,0,0,0-35.7-78.2A87.9,87.9,0,0,1,215.6,120Z" }, null, -1), RM1 = [
  DM1
], UM1 = { key: 3 }, qM1 = ["stroke"], GM1 = ["stroke"], EM1 = ["stroke"], OM1 = ["stroke"], IM1 = ["stroke"], KM1 = ["stroke"], XM1 = ["stroke"], JM1 = { key: 4 }, QM1 = ["stroke"], YM1 = ["stroke"], ov1 = ["stroke"], ev1 = ["stroke"], tv1 = ["stroke"], nv1 = ["stroke"], sv1 = ["stroke"], rv1 = { key: 5 }, iv1 = ["stroke"], lv1 = ["stroke"], dv1 = ["stroke"], kv1 = ["stroke"], cv1 = ["stroke"], hv1 = ["stroke"], uv1 = ["stroke"], av1 = {
  name: "PhVolleyball"
}, esl = /* @__PURE__ */ $({
  ...av1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xM1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jM1),
        e("line", {
          x1: "80",
          y1: "44.9",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mM1),
        e("line", {
          x1: "80",
          y1: "211.1",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MM1),
        e("line", {
          x1: "224",
          y1: "128",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vM1),
        e("path", {
          d: "M116.6,32.7A96.1,96.1,0,0,1,173.1,128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SM1),
        e("path", {
          d: "M51.1,185.6A96,96,0,0,1,105.5,89",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, HM1),
        e("path", {
          d: "M216.3,165.8A96,96,0,0,1,105.5,167",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, AM1)
      ])) : o(i) === "duotone" ? (s(), r("g", VM1, [
        zM1,
        ZM1,
        CM1,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bM1),
        e("line", {
          x1: "80",
          y1: "44.9",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LM1),
        e("line", {
          x1: "80",
          y1: "211.1",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BM1),
        e("line", {
          x1: "224",
          y1: "128",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PM1),
        e("path", {
          d: "M116.6,32.7A96.1,96.1,0,0,1,173.1,128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WM1),
        e("path", {
          d: "M51.1,185.6A96,96,0,0,1,105.5,89",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NM1),
        e("path", {
          d: "M216.3,165.8A96,96,0,0,1,105.5,167",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FM1)
      ])) : o(i) === "fill" ? (s(), r("g", TM1, RM1)) : o(i) === "light" ? (s(), r("g", UM1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qM1),
        e("line", {
          x1: "80",
          y1: "44.9",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GM1),
        e("line", {
          x1: "80",
          y1: "211.1",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, EM1),
        e("line", {
          x1: "224",
          y1: "128",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, OM1),
        e("path", {
          d: "M116.6,32.7A96.1,96.1,0,0,1,173.1,128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, IM1),
        e("path", {
          d: "M51.1,185.6A96,96,0,0,1,105.5,89",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, KM1),
        e("path", {
          d: "M216.3,165.8A96,96,0,0,1,105.5,167",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XM1)
      ])) : o(i) === "thin" ? (s(), r("g", JM1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, QM1),
        e("line", {
          x1: "80",
          y1: "44.9",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, YM1),
        e("line", {
          x1: "80",
          y1: "211.1",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ov1),
        e("line", {
          x1: "224",
          y1: "128",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ev1),
        e("path", {
          d: "M116.6,32.7A96.1,96.1,0,0,1,173.1,128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tv1),
        e("path", {
          d: "M51.1,185.6A96,96,0,0,1,105.5,89",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nv1),
        e("path", {
          d: "M216.3,165.8A96,96,0,0,1,105.5,167",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sv1)
      ])) : o(i) === "regular" ? (s(), r("g", rv1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iv1),
        e("line", {
          x1: "80",
          y1: "44.9",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lv1),
        e("line", {
          x1: "80",
          y1: "211.1",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dv1),
        e("line", {
          x1: "224",
          y1: "128",
          x2: "128",
          y2: "128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kv1),
        e("path", {
          d: "M116.6,32.7A96.1,96.1,0,0,1,173.1,128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cv1),
        e("path", {
          d: "M51.1,185.6A96,96,0,0,1,105.5,89",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hv1),
        e("path", {
          d: "M216.3,165.8A96,96,0,0,1,105.5,167",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, uv1)
      ])) : g("", !0)
    ], 16, gM1));
  }
}), _v1 = ["width", "height", "fill", "transform"], pv1 = { key: 0 }, yv1 = ["stroke"], $v1 = ["stroke"], wv1 = ["stroke"], fv1 = ["stroke"], gv1 = ["stroke"], xv1 = ["stroke"], jv1 = ["stroke"], mv1 = { key: 1 }, Mv1 = /* @__PURE__ */ e("rect", {
  x: "32",
  y: "56",
  width: "96",
  height: "48",
  opacity: "0.2"
}, null, -1), vv1 = /* @__PURE__ */ e("rect", {
  x: "128",
  y: "152",
  width: "96",
  height: "48",
  opacity: "0.2"
}, null, -1), Sv1 = /* @__PURE__ */ e("rect", {
  x: "176",
  y: "104",
  width: "48",
  height: "48",
  opacity: "0.2"
}, null, -1), Hv1 = ["stroke"], Av1 = ["stroke"], Vv1 = ["stroke"], zv1 = ["stroke"], Zv1 = ["stroke"], Cv1 = ["stroke"], bv1 = ["stroke"], Lv1 = { key: 2 }, Bv1 = /* @__PURE__ */ j('<path d="M136,92h92a4,4,0,0,0,4-4V56a8,8,0,0,0-8-8H140a4,4,0,0,0-4,4Z"></path><path d="M184,152h44a4,4,0,0,0,4-4V112a4,4,0,0,0-4-4H184Z"></path><rect x="88" y="108" width="80" height="44"></rect><path d="M72,108H28a4,4,0,0,0-4,4v36a4,4,0,0,0,4,4H72Z"></path><path d="M136,168v36a4,4,0,0,0,4,4h84a8,8,0,0,0,8-8V172a4,4,0,0,0-4-4Z"></path><path d="M120,92V52a4,4,0,0,0-4-4H32a8,8,0,0,0-8,8V88a4,4,0,0,0,4,4Z"></path><path d="M120,168H28a4,4,0,0,0-4,4v28a8,8,0,0,0,8,8h84a4,4,0,0,0,4-4Z"></path>', 7), Pv1 = [
  Bv1
], Wv1 = { key: 3 }, Nv1 = ["stroke"], Fv1 = ["stroke"], Tv1 = ["stroke"], Dv1 = ["stroke"], Rv1 = ["stroke"], Uv1 = ["stroke"], qv1 = ["stroke"], Gv1 = { key: 4 }, Ev1 = ["stroke"], Ov1 = ["stroke"], Iv1 = ["stroke"], Kv1 = ["stroke"], Xv1 = ["stroke"], Jv1 = ["stroke"], Qv1 = ["stroke"], Yv1 = { key: 5 }, oS1 = ["stroke"], eS1 = ["stroke"], tS1 = ["stroke"], nS1 = ["stroke"], sS1 = ["stroke"], rS1 = ["stroke"], iS1 = ["stroke"], lS1 = {
  name: "PhWall"
}, tsl = /* @__PURE__ */ $({
  ...lS1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", pv1, [
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yv1),
        e("line", {
          x1: "80",
          y1: "152",
          x2: "80",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $v1),
        e("line", {
          x1: "176",
          y1: "152",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, wv1),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, fv1),
        e("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, gv1),
        e("line", {
          x1: "32",
          y1: "152",
          x2: "224",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, xv1),
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jv1)
      ])) : o(i) === "duotone" ? (s(), r("g", mv1, [
        Mv1,
        vv1,
        Sv1,
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Hv1),
        e("line", {
          x1: "80",
          y1: "152",
          x2: "80",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Av1),
        e("line", {
          x1: "176",
          y1: "152",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Vv1),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, zv1),
        e("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Zv1),
        e("line", {
          x1: "32",
          y1: "152",
          x2: "224",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Cv1),
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bv1)
      ])) : o(i) === "fill" ? (s(), r("g", Lv1, Pv1)) : o(i) === "light" ? (s(), r("g", Wv1, [
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Nv1),
        e("line", {
          x1: "80",
          y1: "152",
          x2: "80",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Fv1),
        e("line", {
          x1: "176",
          y1: "152",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Tv1),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Dv1),
        e("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rv1),
        e("line", {
          x1: "32",
          y1: "152",
          x2: "224",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Uv1),
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qv1)
      ])) : o(i) === "thin" ? (s(), r("g", Gv1, [
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ev1),
        e("line", {
          x1: "80",
          y1: "152",
          x2: "80",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Ov1),
        e("line", {
          x1: "176",
          y1: "152",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Iv1),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kv1),
        e("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xv1),
        e("line", {
          x1: "32",
          y1: "152",
          x2: "224",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jv1),
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qv1)
      ])) : o(i) === "regular" ? (s(), r("g", Yv1, [
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, oS1),
        e("line", {
          x1: "80",
          y1: "152",
          x2: "80",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eS1),
        e("line", {
          x1: "176",
          y1: "152",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tS1),
        e("line", {
          x1: "128",
          y1: "200",
          x2: "128",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nS1),
        e("line", {
          x1: "32",
          y1: "104",
          x2: "224",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sS1),
        e("line", {
          x1: "32",
          y1: "152",
          x2: "224",
          y2: "152",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rS1),
        e("rect", {
          x: "32",
          y: "56",
          width: "192",
          height: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iS1)
      ])) : g("", !0)
    ], 16, _v1));
  }
}), dS1 = ["width", "height", "fill", "transform"], kS1 = { key: 0 }, cS1 = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "144",
  r: "16"
}, null, -1), hS1 = ["stroke"], uS1 = { key: 1 }, aS1 = /* @__PURE__ */ e("path", {
  d: "M40,192a16,16,0,0,0,16,16H216a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H56A16,16,0,0,1,40,64Z",
  opacity: "0.2"
}, null, -1), _S1 = ["stroke"], pS1 = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "144",
  r: "12"
}, null, -1), yS1 = { key: 2 }, $S1 = /* @__PURE__ */ e("path", { d: "M216,72H56a8,8,0,0,1,0-16H192a8,8,0,0,0,0-16H56A24.1,24.1,0,0,0,32,64V192a24.1,24.1,0,0,0,24,24H216a16,16,0,0,0,16-16V88A16,16,0,0,0,216,72Zm-36,84a12,12,0,1,1,12-12A12,12,0,0,1,180,156Z" }, null, -1), wS1 = [
  $S1
], fS1 = { key: 3 }, gS1 = ["stroke"], xS1 = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "144",
  r: "10"
}, null, -1), jS1 = { key: 4 }, mS1 = ["stroke"], MS1 = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "144",
  r: "8"
}, null, -1), vS1 = { key: 5 }, SS1 = ["stroke"], HS1 = /* @__PURE__ */ e("circle", {
  cx: "180",
  cy: "144",
  r: "12"
}, null, -1), AS1 = {
  name: "PhWallet"
}, nsl = /* @__PURE__ */ $({
  ...AS1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", kS1, [
        cS1,
        e("path", {
          d: "M40,68V192a16,16,0,0,0,16,16H216a8,8,0,0,0,8-8V96a8,8,0,0,0-8-8H60.5A20.3,20.3,0,0,1,40,68.7,20,20,0,0,1,60,48H192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, hS1)
      ])) : o(i) === "duotone" ? (s(), r("g", uS1, [
        aS1,
        e("path", {
          d: "M40,64V192a16,16,0,0,0,16,16H216a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H56A16,16,0,0,1,40,64h0A16,16,0,0,1,56,48H192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, _S1),
        pS1
      ])) : o(i) === "fill" ? (s(), r("g", yS1, wS1)) : o(i) === "light" ? (s(), r("g", fS1, [
        e("path", {
          d: "M40,64V192a16,16,0,0,0,16,16H216a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H56A16,16,0,0,1,40,64h0A16,16,0,0,1,56,48H192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, gS1),
        xS1
      ])) : o(i) === "thin" ? (s(), r("g", jS1, [
        e("path", {
          d: "M40,64V192a16,16,0,0,0,16,16H216a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H56A16,16,0,0,1,40,64h0A16,16,0,0,1,56,48H192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mS1),
        MS1
      ])) : o(i) === "regular" ? (s(), r("g", vS1, [
        e("path", {
          d: "M40,64V192a16,16,0,0,0,16,16H216a8,8,0,0,0,8-8V88a8,8,0,0,0-8-8H56A16,16,0,0,1,40,64h0A16,16,0,0,1,56,48H192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SS1),
        HS1
      ])) : g("", !0)
    ], 16, dS1));
  }
}), VS1 = ["width", "height", "fill", "transform"], zS1 = { key: 0 }, ZS1 = ["stroke"], CS1 = ["stroke"], bS1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "176",
  r: "16"
}, null, -1), LS1 = { key: 1 }, BS1 = /* @__PURE__ */ e("path", {
  d: "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
  opacity: "0.2"
}, null, -1), PS1 = ["stroke"], WS1 = ["stroke"], NS1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "12"
}, null, -1), FS1 = { key: 2 }, TS1 = /* @__PURE__ */ e("path", { d: "M236.7,188,148.8,36a24,24,0,0,0-41.6,0h0L19.3,188A23.9,23.9,0,0,0,40,224H216a23.9,23.9,0,0,0,20.7-36ZM120,104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm8,88a12,12,0,1,1,12-12A12,12,0,0,1,128,192Z" }, null, -1), DS1 = [
  TS1
], RS1 = { key: 3 }, US1 = ["stroke"], qS1 = ["stroke"], GS1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "10"
}, null, -1), ES1 = { key: 4 }, OS1 = ["stroke"], IS1 = ["stroke"], KS1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "8"
}, null, -1), XS1 = { key: 5 }, JS1 = ["stroke"], QS1 = ["stroke"], YS1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "180",
  r: "12"
}, null, -1), oH1 = {
  name: "PhWarning"
}, ssl = /* @__PURE__ */ $({
  ...oH1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", zS1, [
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, ZS1),
        e("path", {
          d: "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CS1),
        bS1
      ])) : o(i) === "duotone" ? (s(), r("g", LS1, [
        BS1,
        e("line", {
          x1: "128",
          y1: "112",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PS1),
        e("path", {
          d: "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WS1),
        NS1
      ])) : o(i) === "fill" ? (s(), r("g", FS1, DS1)) : o(i) === "light" ? (s(), r("g", RS1, [
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, US1),
        e("path", {
          d: "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qS1),
        GS1
      ])) : o(i) === "thin" ? (s(), r("g", ES1, [
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OS1),
        e("path", {
          d: "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, IS1),
        KS1
      ])) : o(i) === "regular" ? (s(), r("g", XS1, [
        e("line", {
          x1: "128",
          y1: "104",
          x2: "128",
          y2: "144",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JS1),
        e("path", {
          d: "M114.2,40l-88,152A16,16,0,0,0,40,216H216a16,16,0,0,0,13.8-24l-88-152A15.9,15.9,0,0,0,114.2,40Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QS1),
        YS1
      ])) : g("", !0)
    ], 16, VS1));
  }
}), eH1 = ["width", "height", "fill", "transform"], tH1 = { key: 0 }, nH1 = ["stroke"], sH1 = ["stroke"], rH1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "172",
  r: "16"
}, null, -1), iH1 = { key: 1 }, lH1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), dH1 = ["stroke"], kH1 = ["stroke"], cH1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "172",
  r: "12"
}, null, -1), hH1 = { key: 2 }, uH1 = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm-8,56a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z" }, null, -1), aH1 = [
  uH1
], _H1 = { key: 3 }, pH1 = ["stroke"], yH1 = ["stroke"], $H1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "172",
  r: "10"
}, null, -1), wH1 = { key: 4 }, fH1 = ["stroke"], gH1 = ["stroke"], xH1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "172",
  r: "8"
}, null, -1), jH1 = { key: 5 }, mH1 = ["stroke"], MH1 = ["stroke"], vH1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "172",
  r: "12"
}, null, -1), SH1 = {
  name: "PhWarningCircle"
}, rsl = /* @__PURE__ */ $({
  ...SH1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", tH1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nH1),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sH1),
        rH1
      ])) : o(i) === "duotone" ? (s(), r("g", iH1, [
        lH1,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, dH1),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kH1),
        cH1
      ])) : o(i) === "fill" ? (s(), r("g", hH1, aH1)) : o(i) === "light" ? (s(), r("g", _H1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pH1),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yH1),
        $H1
      ])) : o(i) === "thin" ? (s(), r("g", wH1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, fH1),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gH1),
        xH1
      ])) : o(i) === "regular" ? (s(), r("g", jH1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, mH1),
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, MH1),
        vH1
      ])) : g("", !0)
    ], 16, eH1));
  }
}), HH1 = ["width", "height", "fill", "transform"], AH1 = { key: 0 }, VH1 = ["stroke"], zH1 = ["stroke"], ZH1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "172",
  r: "16"
}, null, -1), CH1 = { key: 1 }, bH1 = /* @__PURE__ */ e("path", {
  d: "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
  opacity: "0.2"
}, null, -1), LH1 = ["stroke"], BH1 = ["stroke"], PH1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "172",
  r: "12"
}, null, -1), WH1 = { key: 2 }, NH1 = /* @__PURE__ */ e("path", { d: "M227.3,80.2,175.8,28.7A16.1,16.1,0,0,0,164.5,24h-73a16.1,16.1,0,0,0-11.3,4.7L28.7,80.2A16.1,16.1,0,0,0,24,91.5v73a16.1,16.1,0,0,0,4.7,11.3l51.5,51.5A16.1,16.1,0,0,0,91.5,232h73a16.1,16.1,0,0,0,11.3-4.7l51.5-51.5a16.1,16.1,0,0,0,4.7-11.3v-73A16.1,16.1,0,0,0,227.3,80.2ZM120,80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm8,104a12,12,0,1,1,12-12A12,12,0,0,1,128,184Z" }, null, -1), FH1 = [
  NH1
], TH1 = { key: 3 }, DH1 = ["stroke"], RH1 = ["stroke"], UH1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "172",
  r: "10"
}, null, -1), qH1 = { key: 4 }, GH1 = ["stroke"], EH1 = ["stroke"], OH1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "172",
  r: "8"
}, null, -1), IH1 = { key: 5 }, KH1 = ["stroke"], XH1 = ["stroke"], JH1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "172",
  r: "12"
}, null, -1), QH1 = {
  name: "PhWarningOctagon"
}, isl = /* @__PURE__ */ $({
  ...QH1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", AH1, [
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "132",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, VH1),
        e("path", {
          d: "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, zH1),
        ZH1
      ])) : o(i) === "duotone" ? (s(), r("g", CH1, [
        bH1,
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LH1),
        e("path", {
          d: "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, BH1),
        PH1
      ])) : o(i) === "fill" ? (s(), r("g", WH1, FH1)) : o(i) === "light" ? (s(), r("g", TH1, [
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DH1),
        e("path", {
          d: "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RH1),
        UH1
      ])) : o(i) === "thin" ? (s(), r("g", qH1, [
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GH1),
        e("path", {
          d: "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, EH1),
        OH1
      ])) : o(i) === "regular" ? (s(), r("g", IH1, [
        e("line", {
          x1: "128",
          y1: "80",
          x2: "128",
          y2: "136",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KH1),
        e("path", {
          d: "M164.5,32h-73a7.9,7.9,0,0,0-5.6,2.3L34.3,85.9A7.9,7.9,0,0,0,32,91.5v73a7.9,7.9,0,0,0,2.3,5.6l51.6,51.6a7.9,7.9,0,0,0,5.6,2.3h73a7.9,7.9,0,0,0,5.6-2.3l51.6-51.6a7.9,7.9,0,0,0,2.3-5.6v-73a7.9,7.9,0,0,0-2.3-5.6L170.1,34.3A7.9,7.9,0,0,0,164.5,32Z",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, XH1),
        JH1
      ])) : g("", !0)
    ], 16, HH1));
  }
}), YH1 = ["width", "height", "fill", "transform"], oA1 = { key: 0 }, eA1 = ["stroke"], tA1 = ["stroke"], nA1 = ["stroke"], sA1 = ["stroke"], rA1 = { key: 1 }, iA1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "72",
  opacity: "0.2"
}, null, -1), lA1 = ["stroke"], dA1 = ["stroke"], kA1 = ["stroke"], cA1 = ["stroke"], hA1 = { key: 2 }, uA1 = /* @__PURE__ */ e("path", { d: "M175.3,63.5l-6.2-34.4A16,16,0,0,0,153.3,16H102.7A16,16,0,0,0,86.9,29.1L80.7,63.5a80,80,0,0,0,0,129l6.2,34.4A16,16,0,0,0,102.7,240h50.6a16,16,0,0,0,15.8-13.1l6.2-34.4a80,80,0,0,0,0-129ZM102.7,32h50.6l3.9,21.6a78.9,78.9,0,0,0-58.4,0Zm50.6,192H102.7l-3.9-21.6a78.9,78.9,0,0,0,58.4,0ZM168,136H128a8,8,0,0,1-8-8V88a8,8,0,0,1,16,0v32h32a8,8,0,0,1,0,16Z" }, null, -1), aA1 = [
  uA1
], _A1 = { key: 3 }, pA1 = ["stroke"], yA1 = ["stroke"], $A1 = ["stroke"], wA1 = ["stroke"], fA1 = { key: 4 }, gA1 = ["stroke"], xA1 = ["stroke"], jA1 = ["stroke"], mA1 = ["stroke"], MA1 = { key: 5 }, vA1 = ["stroke"], SA1 = ["stroke"], HA1 = ["stroke"], AA1 = ["stroke"], VA1 = {
  name: "PhWatch"
}, lsl = /* @__PURE__ */ $({
  ...VA1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", oA1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, eA1),
        e("polyline", {
          points: "128 96 128 128 160 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tA1),
        e("path", {
          d: "M88,68.1l7-45.3a8,8,0,0,1,7.9-6.8h50.2a8,8,0,0,1,7.9,6.8l7,45.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nA1),
        e("path", {
          d: "M88,187.9l7,45.3a8,8,0,0,0,7.9,6.8h50.2a8,8,0,0,0,7.9-6.8l7-45.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sA1)
      ])) : o(i) === "duotone" ? (s(), r("g", rA1, [
        iA1,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, lA1),
        e("polyline", {
          points: "128 88 128 128 168 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dA1),
        e("path", {
          d: "M88,68.1l6.8-37.5a8,8,0,0,1,7.9-6.6h50.6a8,8,0,0,1,7.9,6.6L168,68.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kA1),
        e("path", {
          d: "M88,187.9l6.8,37.5a8,8,0,0,0,7.9,6.6h50.6a8,8,0,0,0,7.9-6.6l6.8-37.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cA1)
      ])) : o(i) === "fill" ? (s(), r("g", hA1, aA1)) : o(i) === "light" ? (s(), r("g", _A1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, pA1),
        e("polyline", {
          points: "128 88 128 128 168 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yA1),
        e("path", {
          d: "M88,68.1l6.8-37.5a8,8,0,0,1,7.9-6.6h50.6a8,8,0,0,1,7.9,6.6L168,68.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $A1),
        e("path", {
          d: "M88,187.9l6.8,37.5a8,8,0,0,0,7.9,6.6h50.6a8,8,0,0,0,7.9-6.6l6.8-37.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wA1)
      ])) : o(i) === "thin" ? (s(), r("g", fA1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gA1),
        e("polyline", {
          points: "128 88 128 128 168 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xA1),
        e("path", {
          d: "M88,68.1l6.8-37.5a8,8,0,0,1,7.9-6.6h50.6a8,8,0,0,1,7.9,6.6L168,68.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jA1),
        e("path", {
          d: "M88,187.9l6.8,37.5a8,8,0,0,0,7.9,6.6h50.6a8,8,0,0,0,7.9-6.6l6.8-37.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mA1)
      ])) : o(i) === "regular" ? (s(), r("g", MA1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, vA1),
        e("polyline", {
          points: "128 88 128 128 168 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SA1),
        e("path", {
          d: "M88,68.1l6.8-37.5a8,8,0,0,1,7.9-6.6h50.6a8,8,0,0,1,7.9,6.6L168,68.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HA1),
        e("path", {
          d: "M88,187.9l6.8,37.5a8,8,0,0,0,7.9,6.6h50.6a8,8,0,0,0,7.9-6.6l6.8-37.5",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AA1)
      ])) : g("", !0)
    ], 16, YH1));
  }
}), zA1 = ["width", "height", "fill", "transform"], ZA1 = { key: 0 }, CA1 = ["stroke"], bA1 = { key: 1 }, LA1 = /* @__PURE__ */ e("polygon", {
  points: "24 128 128 64 128 192 232 128 24 128",
  opacity: "0.2"
}, null, -1), BA1 = ["stroke"], PA1 = { key: 2 }, WA1 = /* @__PURE__ */ e("path", { d: "M128,200a7.8,7.8,0,0,1-3.9-1,8.1,8.1,0,0,1-4.1-7V78.3L28.2,134.8a8,8,0,0,1-8.4-13.6l104-64A8,8,0,0,1,136,64V177.7l91.8-56.5a8,8,0,0,1,8.4,13.6l-104,64A7.9,7.9,0,0,1,128,200Z" }, null, -1), NA1 = [
  WA1
], FA1 = { key: 3 }, TA1 = ["stroke"], DA1 = { key: 4 }, RA1 = ["stroke"], UA1 = { key: 5 }, qA1 = ["stroke"], GA1 = {
  name: "PhWaveSawtooth"
}, dsl = /* @__PURE__ */ $({
  ...GA1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", ZA1, [
        e("polyline", {
          points: "24 128 128 64 128 192 232 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, CA1)
      ])) : o(i) === "duotone" ? (s(), r("g", bA1, [
        LA1,
        e("polyline", {
          points: "24 128 128 64 128 192 232 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BA1)
      ])) : o(i) === "fill" ? (s(), r("g", PA1, NA1)) : o(i) === "light" ? (s(), r("g", FA1, [
        e("polyline", {
          points: "24 128 128 64 128 192 232 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TA1)
      ])) : o(i) === "thin" ? (s(), r("g", DA1, [
        e("polyline", {
          points: "24 128 128 64 128 192 232 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, RA1)
      ])) : o(i) === "regular" ? (s(), r("g", UA1, [
        e("polyline", {
          points: "24 128 128 64 128 192 232 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qA1)
      ])) : g("", !0)
    ], 16, zA1));
  }
}), EA1 = ["width", "height", "fill", "transform"], OA1 = { key: 0 }, IA1 = ["stroke"], KA1 = { key: 1 }, XA1 = /* @__PURE__ */ e("path", {
  d: "M24,128c104-224,104,224,208,0Z",
  opacity: "0.2"
}, null, -1), JA1 = ["stroke"], QA1 = { key: 2 }, YA1 = /* @__PURE__ */ e("path", { d: "M178,200.7c-25.1,0-40.7-33.7-57.3-69.3-13-28.2-27.8-60.1-42.7-60.1s-36.3,37.6-46.7,60.1a8.1,8.1,0,1,1-14.6-6.8C38.7,77.4,58.1,55.3,78,55.3c25.1,0,40.7,33.7,57.3,69.3,13,28.2,27.8,60.1,42.7,60.1,16.4,0,36.3-37.6,46.7-60.1a8.1,8.1,0,0,1,14.6,6.8C217.3,178.6,197.9,200.7,178,200.7Z" }, null, -1), oV1 = [
  YA1
], eV1 = { key: 3 }, tV1 = ["stroke"], nV1 = { key: 4 }, sV1 = ["stroke"], rV1 = { key: 5 }, iV1 = ["stroke"], lV1 = {
  name: "PhWaveSine"
}, ksl = /* @__PURE__ */ $({
  ...lV1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", OA1, [
        e("path", {
          d: "M24,128c104-224,104,224,208,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, IA1)
      ])) : o(i) === "duotone" ? (s(), r("g", KA1, [
        XA1,
        e("path", {
          d: "M24,128c104-224,104,224,208,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JA1)
      ])) : o(i) === "fill" ? (s(), r("g", QA1, oV1)) : o(i) === "light" ? (s(), r("g", eV1, [
        e("path", {
          d: "M24,128c104-224,104,224,208,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tV1)
      ])) : o(i) === "thin" ? (s(), r("g", nV1, [
        e("path", {
          d: "M24,128c104-224,104,224,208,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sV1)
      ])) : o(i) === "regular" ? (s(), r("g", rV1, [
        e("path", {
          d: "M24,128c104-224,104,224,208,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iV1)
      ])) : g("", !0)
    ], 16, EA1));
  }
}), dV1 = ["width", "height", "fill", "transform"], kV1 = { key: 0 }, cV1 = ["stroke"], hV1 = { key: 1 }, uV1 = /* @__PURE__ */ e("polygon", {
  points: "232 128 232 184 128 184 128 72 24 72 24 128 232 128",
  opacity: "0.2"
}, null, -1), aV1 = ["stroke"], _V1 = { key: 2 }, pV1 = /* @__PURE__ */ e("path", { d: "M232,192H128a8,8,0,0,1-8-8V80H32v48a8,8,0,0,1-16,0V72a8,8,0,0,1,8-8H128a8,8,0,0,1,8,8V176h88V128a8,8,0,0,1,16,0v56A8,8,0,0,1,232,192Z" }, null, -1), yV1 = [
  pV1
], $V1 = { key: 3 }, wV1 = ["stroke"], fV1 = { key: 4 }, gV1 = ["stroke"], xV1 = { key: 5 }, jV1 = ["stroke"], mV1 = {
  name: "PhWaveSquare"
}, csl = /* @__PURE__ */ $({
  ...mV1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", kV1, [
        e("polyline", {
          points: "232 128 232 184 128 184 128 72 24 72 24 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, cV1)
      ])) : o(i) === "duotone" ? (s(), r("g", hV1, [
        uV1,
        e("polyline", {
          points: "232 128 232 184 128 184 128 72 24 72 24 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, aV1)
      ])) : o(i) === "fill" ? (s(), r("g", _V1, yV1)) : o(i) === "light" ? (s(), r("g", $V1, [
        e("polyline", {
          points: "232 128 232 184 128 184 128 72 24 72 24 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wV1)
      ])) : o(i) === "thin" ? (s(), r("g", fV1, [
        e("polyline", {
          points: "232 128 232 184 128 184 128 72 24 72 24 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, gV1)
      ])) : o(i) === "regular" ? (s(), r("g", xV1, [
        e("polyline", {
          points: "232 128 232 184 128 184 128 72 24 72 24 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jV1)
      ])) : g("", !0)
    ], 16, dV1));
  }
}), MV1 = ["width", "height", "fill", "transform"], vV1 = { key: 0 }, SV1 = ["stroke"], HV1 = { key: 1 }, AV1 = ["stroke"], VV1 = /* @__PURE__ */ e("polygon", {
  points: "24 128 76 56 180 200 232 128 24 128",
  opacity: "0.2"
}, null, -1), zV1 = { key: 2 }, ZV1 = /* @__PURE__ */ e("path", { d: "M180,208a7.9,7.9,0,0,1-6.5-3.3L76,69.7l-45.5,63a8,8,0,1,1-13-9.4l52-72a8.1,8.1,0,0,1,13,0l97.5,135,45.5-63a8,8,0,0,1,13,9.4l-52,72A7.9,7.9,0,0,1,180,208Z" }, null, -1), CV1 = [
  ZV1
], bV1 = { key: 3 }, LV1 = ["stroke"], BV1 = { key: 4 }, PV1 = ["stroke"], WV1 = { key: 5 }, NV1 = ["stroke"], FV1 = {
  name: "PhWaveTriangle"
}, hsl = /* @__PURE__ */ $({
  ...FV1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", vV1, [
        e("polyline", {
          points: "24 128 76 56 180 200 232 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, SV1)
      ])) : o(i) === "duotone" ? (s(), r("g", HV1, [
        e("polyline", {
          points: "24 128 76 56 180 200 232 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AV1),
        VV1
      ])) : o(i) === "fill" ? (s(), r("g", zV1, CV1)) : o(i) === "light" ? (s(), r("g", bV1, [
        e("polyline", {
          points: "24 128 76 56 180 200 232 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, LV1)
      ])) : o(i) === "thin" ? (s(), r("g", BV1, [
        e("polyline", {
          points: "24 128 76 56 180 200 232 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PV1)
      ])) : o(i) === "regular" ? (s(), r("g", WV1, [
        e("polyline", {
          points: "24 128 76 56 180 200 232 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, NV1)
      ])) : g("", !0)
    ], 16, MV1));
  }
}), TV1 = ["width", "height", "fill", "transform"], DV1 = { key: 0 }, RV1 = ["stroke"], UV1 = ["stroke"], qV1 = ["stroke"], GV1 = { key: 1 }, EV1 = ["stroke"], OV1 = ["stroke"], IV1 = ["stroke"], KV1 = { key: 2 }, XV1 = /* @__PURE__ */ e("path", { d: "M33.7,77A8,8,0,0,1,35,65.8,81.8,81.8,0,0,1,64.1,52.2c16.1-4,41.1-5,68.3,13.1,42.4,28.3,77.2,1.6,78.6.4A8.2,8.2,0,0,1,222.3,67,8,8,0,0,1,221,78.2a81.8,81.8,0,0,1-29.1,13.6,81,81,0,0,1-19.7,2.4c-14,0-30.8-3.7-48.6-15.5C81.2,50.4,46.4,77.1,45,78.3A8.2,8.2,0,0,1,33.7,77ZM211,121.7c-1.4,1.2-36.2,27.9-78.6-.4-27.2-18.1-52.2-17.1-68.3-13.1A81.8,81.8,0,0,0,35,121.8,8,8,0,0,0,33.7,133,8.2,8.2,0,0,0,45,134.3c1.4-1.2,36.2-27.9,78.6.4,17.8,11.8,34.6,15.5,48.6,15.5a81,81,0,0,0,19.7-2.4A81.8,81.8,0,0,0,221,134.2a8,8,0,0,0,1.3-11.2A8.2,8.2,0,0,0,211,121.7Zm0,56c-1.4,1.2-36.2,27.9-78.6-.4-27.2-18.1-52.2-17.1-68.3-13.1A81.8,81.8,0,0,0,35,177.8,8,8,0,0,0,33.7,189,8.2,8.2,0,0,0,45,190.3c1.4-1.2,36.2-27.9,78.6.4,17.8,11.8,34.6,15.5,48.6,15.5a82.6,82.6,0,0,0,48.8-16,8,8,0,0,0,1.3-11.2A8.2,8.2,0,0,0,211,177.7Z" }, null, -1), JV1 = [
  XV1
], QV1 = { key: 3 }, YV1 = ["stroke"], oz1 = ["stroke"], ez1 = ["stroke"], tz1 = { key: 4 }, nz1 = ["stroke"], sz1 = ["stroke"], rz1 = ["stroke"], iz1 = { key: 5 }, lz1 = ["stroke"], dz1 = ["stroke"], kz1 = ["stroke"], cz1 = {
  name: "PhWaves"
}, usl = /* @__PURE__ */ $({
  ...cz1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", DV1, [
        e("path", {
          d: "M40,72s40-32,88,0,88,0,88,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RV1),
        e("path", {
          d: "M40,128s40-32,88,0,88,0,88,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, UV1),
        e("path", {
          d: "M40,184s40-32,88,0,88,0,88,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qV1)
      ])) : o(i) === "duotone" ? (s(), r("g", GV1, [
        e("path", {
          d: "M40,72s40-32,88,0,88,0,88,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EV1),
        e("path", {
          d: "M40,128s40-32,88,0,88,0,88,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OV1),
        e("path", {
          d: "M40,184s40-32,88,0,88,0,88,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IV1)
      ])) : o(i) === "fill" ? (s(), r("g", KV1, JV1)) : o(i) === "light" ? (s(), r("g", QV1, [
        e("path", {
          d: "M40,72s40-32,88,0,88,0,88,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YV1),
        e("path", {
          d: "M40,128s40-32,88,0,88,0,88,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oz1),
        e("path", {
          d: "M40,184s40-32,88,0,88,0,88,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ez1)
      ])) : o(i) === "thin" ? (s(), r("g", tz1, [
        e("path", {
          d: "M40,72s40-32,88,0,88,0,88,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nz1),
        e("path", {
          d: "M40,128s40-32,88,0,88,0,88,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sz1),
        e("path", {
          d: "M40,184s40-32,88,0,88,0,88,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rz1)
      ])) : o(i) === "regular" ? (s(), r("g", iz1, [
        e("path", {
          d: "M40,72s40-32,88,0,88,0,88,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lz1),
        e("path", {
          d: "M40,128s40-32,88,0,88,0,88,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dz1),
        e("path", {
          d: "M40,184s40-32,88,0,88,0,88,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kz1)
      ])) : g("", !0)
    ], 16, TV1));
  }
}), hz1 = ["width", "height", "fill", "transform"], uz1 = { key: 0 }, az1 = ["stroke"], _z1 = ["stroke"], pz1 = ["stroke"], yz1 = ["stroke"], $z1 = { key: 1 }, wz1 = /* @__PURE__ */ e("path", {
  d: "M128,32a72,72,0,1,0,72,72A72,72,0,0,0,128,32Zm0,104a32,32,0,1,1,32-32A32,32,0,0,1,128,136Z",
  opacity: "0.2"
}, null, -1), fz1 = ["stroke"], gz1 = ["stroke"], xz1 = ["stroke"], jz1 = ["stroke"], mz1 = { key: 2 }, Mz1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "104",
  r: "32"
}, null, -1), vz1 = /* @__PURE__ */ e("path", { d: "M224,200H136V183.6a80,80,0,1,0-16,0V200H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16ZM80,104a48,48,0,1,1,48,48A48,48,0,0,1,80,104Z" }, null, -1), Sz1 = [
  Mz1,
  vz1
], Hz1 = { key: 3 }, Az1 = ["stroke"], Vz1 = ["stroke"], zz1 = ["stroke"], Zz1 = ["stroke"], Cz1 = { key: 4 }, bz1 = ["stroke"], Lz1 = ["stroke"], Bz1 = ["stroke"], Pz1 = ["stroke"], Wz1 = { key: 5 }, Nz1 = ["stroke"], Fz1 = ["stroke"], Tz1 = ["stroke"], Dz1 = ["stroke"], Rz1 = {
  name: "PhWebcam"
}, asl = /* @__PURE__ */ $({
  ...Rz1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", uz1, [
        e("circle", {
          cx: "128",
          cy: "104",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, az1),
        e("circle", {
          cx: "128",
          cy: "104",
          r: "28",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _z1),
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pz1),
        e("line", {
          x1: "32",
          y1: "208",
          x2: "224",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yz1)
      ])) : o(i) === "duotone" ? (s(), r("g", $z1, [
        wz1,
        e("circle", {
          cx: "128",
          cy: "104",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fz1),
        e("circle", {
          cx: "128",
          cy: "104",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gz1),
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xz1),
        e("line", {
          x1: "32",
          y1: "208",
          x2: "224",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jz1)
      ])) : o(i) === "fill" ? (s(), r("g", mz1, Sz1)) : o(i) === "light" ? (s(), r("g", Hz1, [
        e("circle", {
          cx: "128",
          cy: "104",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Az1),
        e("circle", {
          cx: "128",
          cy: "104",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Vz1),
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zz1),
        e("line", {
          x1: "32",
          y1: "208",
          x2: "224",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Zz1)
      ])) : o(i) === "thin" ? (s(), r("g", Cz1, [
        e("circle", {
          cx: "128",
          cy: "104",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bz1),
        e("circle", {
          cx: "128",
          cy: "104",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Lz1),
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Bz1),
        e("line", {
          x1: "32",
          y1: "208",
          x2: "224",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Pz1)
      ])) : o(i) === "regular" ? (s(), r("g", Wz1, [
        e("circle", {
          cx: "128",
          cy: "104",
          r: "72",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Nz1),
        e("circle", {
          cx: "128",
          cy: "104",
          r: "32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Fz1),
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Tz1),
        e("line", {
          x1: "32",
          y1: "208",
          x2: "224",
          y2: "208",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Dz1)
      ])) : g("", !0)
    ], 16, hz1));
  }
}), Uz1 = ["width", "height", "fill", "transform"], qz1 = { key: 0 }, Gz1 = ["stroke"], Ez1 = ["stroke"], Oz1 = { key: 1 }, Iz1 = /* @__PURE__ */ e("path", {
  d: "M128,32A96.1,96.1,0,0,0,45.4,177h0L36,210.2a7.9,7.9,0,0,0,9.8,9.8L79,210.6h0A96,96,0,1,0,128,32Zm24.1,152A79.9,79.9,0,0,1,72,103.9,28,28,0,0,1,100,76h0a6.8,6.8,0,0,1,6,3.5l11.7,20.4a8.1,8.1,0,0,1-.1,8.1l-9.4,15.7h0a48,48,0,0,0,24.1,24.1h0l15.7-9.4a8.1,8.1,0,0,1,8.1-.1L176.5,150a6.8,6.8,0,0,1,3.5,6A28.1,28.1,0,0,1,152.1,184Z",
  opacity: "0.2"
}, null, -1), Kz1 = ["stroke"], Xz1 = ["stroke"], Jz1 = { key: 2 }, Qz1 = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,0,0,36.8,178l-8.5,30A15.9,15.9,0,0,0,48,227.7l30-8.5A104,104,0,1,0,128,24Zm24.1,168H152a88.1,88.1,0,0,1-88-88.1A36,36,0,0,1,100,68a14.9,14.9,0,0,1,12.9,7.5L124.6,96a15.8,15.8,0,0,1-.2,16.1L117.3,124A41.4,41.4,0,0,0,132,138.7l11.9-7.1a15.8,15.8,0,0,1,16.1-.2l20.5,11.7A14.9,14.9,0,0,1,188,156,36,36,0,0,1,152.1,192Z" }, null, -1), Yz1 = /* @__PURE__ */ e("path", { d: "M136.5,154.7a8.1,8.1,0,0,1-7.4.4,55.4,55.4,0,0,1-28.2-28.2,8.1,8.1,0,0,1,.4-7.4l9.4-15.6L99.4,84A19.9,19.9,0,0,0,80,103.9,72,72,0,0,0,152,176h.1A19.9,19.9,0,0,0,172,156.6l-19.9-11.3Z" }, null, -1), oZ1 = [
  Qz1,
  Yz1
], eZ1 = { key: 3 }, tZ1 = ["stroke"], nZ1 = ["stroke"], sZ1 = { key: 4 }, rZ1 = ["stroke"], iZ1 = ["stroke"], lZ1 = { key: 5 }, dZ1 = ["stroke"], kZ1 = ["stroke"], cZ1 = {
  name: "PhWhatsappLogo"
}, _sl = /* @__PURE__ */ $({
  ...cZ1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", qz1, [
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Gz1),
        e("path", {
          d: "M80,103.5A23.9,23.9,0,0,1,104,80h3.5a7.9,7.9,0,0,1,6.8,3.9l7.4,12.3a7.8,7.8,0,0,1,.3,7.7l-4.7,9.6h0a36,36,0,0,0,25.2,25.2h0l9.6-4.7a7.8,7.8,0,0,1,7.7.3l12.3,7.4a7.9,7.9,0,0,1,3.9,6.8V152a23.9,23.9,0,0,1-23.5,24A71.9,71.9,0,0,1,80,103.5Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ez1)
      ])) : o(i) === "duotone" ? (s(), r("g", Oz1, [
        Iz1,
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Kz1),
        e("path", {
          d: "M152.1,184A79.9,79.9,0,0,1,72,103.9,28,28,0,0,1,100,76h0a6.8,6.8,0,0,1,6,3.5l11.7,20.4a8.1,8.1,0,0,1-.1,8.1l-9.4,15.7h0a48,48,0,0,0,24.1,24.1h0l15.7-9.4a8.1,8.1,0,0,1,8.1-.1L176.5,150a6.8,6.8,0,0,1,3.5,6h0A28.1,28.1,0,0,1,152.1,184Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Xz1)
      ])) : o(i) === "fill" ? (s(), r("g", Jz1, oZ1)) : o(i) === "light" ? (s(), r("g", eZ1, [
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, tZ1),
        e("path", {
          d: "M152.1,184A79.9,79.9,0,0,1,72,103.9,28,28,0,0,1,100,76h0a6.8,6.8,0,0,1,6,3.5l11.7,20.4a8.1,8.1,0,0,1-.1,8.1l-9.4,15.7h0a48,48,0,0,0,24.1,24.1h0l15.7-9.4a8.1,8.1,0,0,1,8.1-.1L176.5,150a6.8,6.8,0,0,1,3.5,6h0A28.1,28.1,0,0,1,152.1,184Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, nZ1)
      ])) : o(i) === "thin" ? (s(), r("g", sZ1, [
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rZ1),
        e("path", {
          d: "M152.1,184A79.9,79.9,0,0,1,72,103.9,28,28,0,0,1,100,76h0a6.8,6.8,0,0,1,6,3.5l11.7,20.4a8.1,8.1,0,0,1-.1,8.1l-9.4,15.7h0a48,48,0,0,0,24.1,24.1h0l15.7-9.4a8.1,8.1,0,0,1,8.1-.1L176.5,150a6.8,6.8,0,0,1,3.5,6h0A28.1,28.1,0,0,1,152.1,184Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, iZ1)
      ])) : o(i) === "regular" ? (s(), r("g", lZ1, [
        e("path", {
          d: "M45.4,177A95.9,95.9,0,1,1,79,210.6h0L45.8,220a7.9,7.9,0,0,1-9.8-9.8L45.4,177Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dZ1),
        e("path", {
          d: "M152.1,184A79.9,79.9,0,0,1,72,103.9,28,28,0,0,1,100,76h0a6.8,6.8,0,0,1,6,3.5l11.7,20.4a8.1,8.1,0,0,1-.1,8.1l-9.4,15.7h0a48,48,0,0,0,24.1,24.1h0l15.7-9.4a8.1,8.1,0,0,1,8.1-.1L176.5,150a6.8,6.8,0,0,1,3.5,6h0A28.1,28.1,0,0,1,152.1,184Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kZ1)
      ])) : g("", !0)
    ], 16, Uz1));
  }
}), hZ1 = ["width", "height", "fill", "transform"], uZ1 = { key: 0 }, aZ1 = ["stroke"], _Z1 = ["stroke"], pZ1 = ["stroke"], yZ1 = { key: 1 }, $Z1 = /* @__PURE__ */ e("circle", {
  cx: "95.9",
  cy: "40",
  r: "20",
  opacity: "0.2"
}, null, -1), wZ1 = ["stroke"], fZ1 = ["stroke"], gZ1 = ["stroke"], xZ1 = { key: 2 }, jZ1 = /* @__PURE__ */ e("path", { d: "M247.5,185.5a8,8,0,0,0-10.1-5.1l-17.5,5.8L191,128.4a7.9,7.9,0,0,0-7.1-4.4h-80V104h56a8,8,0,0,0,0-16h-56V62.6a24,24,0,1,0-16,0V89.8a72,72,0,1,0,87.8,74.7,8,8,0,1,0-15.9-1,56,56,0,1,1-71.9-57.2V132a8,8,0,0,0,8,8h83l29.8,59.6a8,8,0,0,0,7.2,4.4,7.3,7.3,0,0,0,2.5-.4l24-8A8,8,0,0,0,247.5,185.5Z" }, null, -1), mZ1 = [
  jZ1
], MZ1 = { key: 3 }, vZ1 = ["stroke"], SZ1 = ["stroke"], HZ1 = ["stroke"], AZ1 = { key: 4 }, VZ1 = ["stroke"], zZ1 = ["stroke"], ZZ1 = ["stroke"], CZ1 = { key: 5 }, bZ1 = ["stroke"], LZ1 = ["stroke"], BZ1 = ["stroke"], PZ1 = {
  name: "PhWheelchair"
}, psl = /* @__PURE__ */ $({
  ...PZ1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", uZ1, [
        e("circle", {
          cx: "95.9",
          cy: "40",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aZ1),
        e("polyline", {
          points: "95.9 60 95.9 136 183.9 136 215.9 200 239.9 192",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _Z1),
        e("path", {
          d: "M163.2,184.1A64,64,0,1,1,103.9,96h56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pZ1)
      ])) : o(i) === "duotone" ? (s(), r("g", yZ1, [
        $Z1,
        e("circle", {
          cx: "95.9",
          cy: "40",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wZ1),
        e("polyline", {
          points: "95.9 60 95.9 132 183.9 132 215.9 196 239.9 188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fZ1),
        e("path", {
          d: "M167.8,164a64,64,0,1,1-63.9-68h56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, gZ1)
      ])) : o(i) === "fill" ? (s(), r("g", xZ1, mZ1)) : o(i) === "light" ? (s(), r("g", MZ1, [
        e("circle", {
          cx: "95.9",
          cy: "40",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, vZ1),
        e("polyline", {
          points: "95.9 60 95.9 132 183.9 132 215.9 196 239.9 188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, SZ1),
        e("path", {
          d: "M167.8,164a64,64,0,1,1-63.9-68h56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HZ1)
      ])) : o(i) === "thin" ? (s(), r("g", AZ1, [
        e("circle", {
          cx: "95.9",
          cy: "40",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, VZ1),
        e("polyline", {
          points: "95.9 60 95.9 132 183.9 132 215.9 196 239.9 188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, zZ1),
        e("path", {
          d: "M167.8,164a64,64,0,1,1-63.9-68h56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZZ1)
      ])) : o(i) === "regular" ? (s(), r("g", CZ1, [
        e("circle", {
          cx: "95.9",
          cy: "40",
          r: "20",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bZ1),
        e("polyline", {
          points: "95.9 60 95.9 132 183.9 132 215.9 196 239.9 188",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LZ1),
        e("path", {
          d: "M167.8,164a64,64,0,1,1-63.9-68h56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, BZ1)
      ])) : g("", !0)
    ], 16, hZ1));
  }
}), WZ1 = ["width", "height", "fill", "transform"], NZ1 = { key: 0 }, FZ1 = ["stroke"], TZ1 = ["stroke"], DZ1 = ["stroke"], RZ1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "16"
}, null, -1), UZ1 = { key: 1 }, qZ1 = /* @__PURE__ */ e("path", {
  d: "M20.2,75.9C83.7,28,172.3,28,235.8,75.9A8,8,0,0,1,237,87.5L134,208.9a7.9,7.9,0,0,1-12.1-.1L19,87.6A8.1,8.1,0,0,1,20.2,75.9Z",
  opacity: "0.2"
}, null, -1), GZ1 = ["stroke"], EZ1 = { key: 2 }, OZ1 = /* @__PURE__ */ e("path", { d: "M246.9,80.5a15.6,15.6,0,0,0-6.2-10.9c-66.4-50.1-159-50.1-225.3-.1a16.1,16.1,0,0,0-6.2,11,16.6,16.6,0,0,0,3.7,12.3l103,121.3a15.9,15.9,0,0,0,24.2,0l103-121.4A16.4,16.4,0,0,0,246.9,80.5Z" }, null, -1), IZ1 = [
  OZ1
], KZ1 = { key: 3 }, XZ1 = ["stroke"], JZ1 = ["stroke"], QZ1 = ["stroke"], YZ1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "10"
}, null, -1), oC1 = { key: 4 }, eC1 = ["stroke"], tC1 = ["stroke"], nC1 = ["stroke"], sC1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "8"
}, null, -1), rC1 = { key: 5 }, iC1 = ["stroke"], lC1 = ["stroke"], dC1 = ["stroke"], kC1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "12"
}, null, -1), cC1 = {
  name: "PhWifiHigh"
}, ysl = /* @__PURE__ */ $({
  ...cC1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", NZ1, [
        e("path", {
          d: "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, FZ1),
        e("path", {
          d: "M59,132.1a98.8,98.8,0,0,1,138,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, TZ1),
        e("path", {
          d: "M25.1,98.2a146.6,146.6,0,0,1,205.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DZ1),
        RZ1
      ])) : o(i) === "duotone" ? (s(), r("g", UZ1, [
        qZ1,
        e("path", {
          d: "M20.2,75.9C83.7,28,172.3,28,235.8,75.9A8,8,0,0,1,237,87.5L134,208.9a7.9,7.9,0,0,1-12.1-.1L19,87.6A8.1,8.1,0,0,1,20.2,75.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GZ1)
      ])) : o(i) === "fill" ? (s(), r("g", EZ1, IZ1)) : o(i) === "light" ? (s(), r("g", KZ1, [
        e("path", {
          d: "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, XZ1),
        e("path", {
          d: "M59,132.1a98.8,98.8,0,0,1,138,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, JZ1),
        e("path", {
          d: "M25.1,98.2a146.6,146.6,0,0,1,205.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, QZ1),
        YZ1
      ])) : o(i) === "thin" ? (s(), r("g", oC1, [
        e("path", {
          d: "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, eC1),
        e("path", {
          d: "M59,132.1a98.8,98.8,0,0,1,138,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, tC1),
        e("path", {
          d: "M25.1,98.2a146.6,146.6,0,0,1,205.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nC1),
        sC1
      ])) : o(i) === "regular" ? (s(), r("g", rC1, [
        e("path", {
          d: "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iC1),
        e("path", {
          d: "M59,132.1a98.8,98.8,0,0,1,138,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lC1),
        e("path", {
          d: "M25.1,98.2a146.6,146.6,0,0,1,205.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dC1),
        kC1
      ])) : g("", !0)
    ], 16, WZ1));
  }
}), hC1 = ["width", "height", "fill", "transform"], uC1 = { key: 0 }, aC1 = ["stroke"], _C1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "16"
}, null, -1), pC1 = { key: 1 }, yC1 = /* @__PURE__ */ e("path", {
  d: "M71.1,148.9a87.9,87.9,0,0,1,113.8,0l-50.9,60a7.9,7.9,0,0,1-12.1-.1Z",
  opacity: "0.2"
}, null, -1), $C1 = ["stroke"], wC1 = ["stroke"], fC1 = { key: 2 }, gC1 = /* @__PURE__ */ e("path", { d: "M246.8,80.5a15.7,15.7,0,0,0-6.2-11c-66.3-50-158.9-50-225.2,0h0a16.1,16.1,0,0,0-6.2,11,16.6,16.6,0,0,0,3.7,12.3L115.8,214a16.4,16.4,0,0,0,4,3.4,15.6,15.6,0,0,0,8.2,2.3h0a15.7,15.7,0,0,0,10.9-4.4,6.8,6.8,0,0,0,1.2-1.2l103-121.4A16,16,0,0,0,246.8,80.5Zm-15.9,1.9-47.1,55.5a95.9,95.9,0,0,0-111.6,0L25.1,82.4h0c60.6-45.7,145.3-45.7,205.8,0Z" }, null, -1), xC1 = [
  gC1
], jC1 = { key: 3 }, mC1 = ["stroke"], MC1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "10"
}, null, -1), vC1 = { key: 4 }, SC1 = ["stroke"], HC1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "8"
}, null, -1), AC1 = { key: 5 }, VC1 = ["stroke"], zC1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "12"
}, null, -1), ZC1 = {
  name: "PhWifiLow"
}, $sl = /* @__PURE__ */ $({
  ...ZC1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", uC1, [
        e("path", {
          d: "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aC1),
        _C1
      ])) : o(i) === "duotone" ? (s(), r("g", pC1, [
        yC1,
        e("path", {
          d: "M20.2,75.9C83.7,28,172.3,28,235.8,75.9A8,8,0,0,1,237,87.5L134,208.9a7.9,7.9,0,0,1-12.1-.1L19,87.6A8.1,8.1,0,0,1,20.2,75.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $C1),
        e("path", {
          d: "M71.1,148.9a87.9,87.9,0,0,1,113.8,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wC1)
      ])) : o(i) === "fill" ? (s(), r("g", fC1, xC1)) : o(i) === "light" ? (s(), r("g", jC1, [
        e("path", {
          d: "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, mC1),
        MC1
      ])) : o(i) === "thin" ? (s(), r("g", vC1, [
        e("path", {
          d: "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, SC1),
        HC1
      ])) : o(i) === "regular" ? (s(), r("g", AC1, [
        e("path", {
          d: "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VC1),
        zC1
      ])) : g("", !0)
    ], 16, hC1));
  }
}), CC1 = ["width", "height", "fill", "transform"], bC1 = { key: 0 }, LC1 = ["stroke"], BC1 = ["stroke"], PC1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "16"
}, null, -1), WC1 = { key: 1 }, NC1 = /* @__PURE__ */ e("path", {
  d: "M134,208.9a7.9,7.9,0,0,1-12.1-.1L50.4,124.5a119.9,119.9,0,0,1,155.2,0Z",
  opacity: "0.2"
}, null, -1), FC1 = ["stroke"], TC1 = ["stroke"], DC1 = { key: 2 }, RC1 = /* @__PURE__ */ e("path", { d: "M240.6,69.6C174.3,19.5,81.7,19.5,15.4,69.5a16.1,16.1,0,0,0-6.2,11,16.6,16.6,0,0,0,3.7,12.3L115.8,214a16.1,16.1,0,0,0,12.2,5.7h0a16,16,0,0,0,12.1-5.6h0l103-121.4a16,16,0,0,0,3.7-12.2A15.6,15.6,0,0,0,240.6,69.6ZM25,82.3Zm179.5,31.2a131,131,0,0,0-17-10.7l-.8-.4a122.1,122.1,0,0,0-17.8-7.6l-1.5-.4A115.2,115.2,0,0,0,149,89.8l-1.6-.2a118.4,118.4,0,0,0-38.8,0l-1.6.2a126.7,126.7,0,0,0-18.4,4.5l-1.5.5a127,127,0,0,0-17.8,7.6l-.8.4a123.5,123.5,0,0,0-16.9,10.7h0L25.1,82.3c60.6-45.7,145.3-45.7,205.8.1Z" }, null, -1), UC1 = [
  RC1
], qC1 = { key: 3 }, GC1 = ["stroke"], EC1 = ["stroke"], OC1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "10"
}, null, -1), IC1 = { key: 4 }, KC1 = ["stroke"], XC1 = ["stroke"], JC1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "8"
}, null, -1), QC1 = { key: 5 }, YC1 = ["stroke"], ob1 = ["stroke"], eb1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "12"
}, null, -1), tb1 = {
  name: "PhWifiMedium"
}, wsl = /* @__PURE__ */ $({
  ...tb1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", bC1, [
        e("path", {
          d: "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, LC1),
        e("path", {
          d: "M59,132.1a98.8,98.8,0,0,1,138,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, BC1),
        PC1
      ])) : o(i) === "duotone" ? (s(), r("g", WC1, [
        NC1,
        e("path", {
          d: "M20.2,75.9C83.7,28,172.3,28,235.8,75.9A8,8,0,0,1,237,87.5L134,208.9a7.9,7.9,0,0,1-12.1-.1L19,87.6A8.1,8.1,0,0,1,20.2,75.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FC1),
        e("path", {
          d: "M50.4,124.5a119.9,119.9,0,0,1,155.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, TC1)
      ])) : o(i) === "fill" ? (s(), r("g", DC1, UC1)) : o(i) === "light" ? (s(), r("g", qC1, [
        e("path", {
          d: "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, GC1),
        e("path", {
          d: "M59,132.1a98.8,98.8,0,0,1,138,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, EC1),
        OC1
      ])) : o(i) === "thin" ? (s(), r("g", IC1, [
        e("path", {
          d: "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, KC1),
        e("path", {
          d: "M59,132.1a98.8,98.8,0,0,1,138,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, XC1),
        JC1
      ])) : o(i) === "regular" ? (s(), r("g", QC1, [
        e("path", {
          d: "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YC1),
        e("path", {
          d: "M59,132.1a98.8,98.8,0,0,1,138,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ob1),
        eb1
      ])) : g("", !0)
    ], 16, CC1));
  }
}), nb1 = ["width", "height", "fill", "transform"], sb1 = { key: 0 }, rb1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "16"
}, null, -1), ib1 = [
  rb1
], lb1 = { key: 1 }, db1 = ["stroke"], kb1 = { key: 2 }, cb1 = /* @__PURE__ */ e("path", { d: "M128,219.7a16,16,0,0,1-12.1-5.6L12.9,92.7A15.8,15.8,0,0,1,9.2,80.5a16.3,16.3,0,0,1,6.2-11c66.3-50,158.9-50,225.2,0a16.3,16.3,0,0,1,6.2,11,16,16,0,0,1-3.7,12.2l-103,121.4A16,16,0,0,1,128,219.7ZM25.1,82.3h0L128,203.6,230.9,82.4v-.2C170.4,36.6,85.7,36.6,25.1,82.3Zm-.1,0Zm-4.8-6.4Z" }, null, -1), hb1 = [
  cb1
], ub1 = { key: 3 }, ab1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "10"
}, null, -1), _b1 = [
  ab1
], pb1 = { key: 4 }, yb1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "8"
}, null, -1), $b1 = [
  yb1
], wb1 = { key: 5 }, fb1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "12"
}, null, -1), gb1 = [
  fb1
], xb1 = {
  name: "PhWifiNone"
}, fsl = /* @__PURE__ */ $({
  ...xb1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", sb1, ib1)) : o(i) === "duotone" ? (s(), r("g", lb1, [
        e("path", {
          d: "M20.2,75.9C83.7,28,172.3,28,235.8,75.9A8.1,8.1,0,0,1,237,87.5c-19,22.5-83,97.8-103,121.4a7.9,7.9,0,0,1-12,0C102,185.3,38,110,19,87.5A8.1,8.1,0,0,1,20.2,75.9Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, db1)
      ])) : o(i) === "fill" ? (s(), r("g", kb1, hb1)) : o(i) === "light" ? (s(), r("g", ub1, _b1)) : o(i) === "thin" ? (s(), r("g", pb1, $b1)) : o(i) === "regular" ? (s(), r("g", wb1, gb1)) : g("", !0)
    ], 16, nb1));
  }
}), jb1 = ["width", "height", "fill", "transform"], mb1 = { key: 0 }, Mb1 = ["stroke"], vb1 = ["stroke"], Sb1 = ["stroke"], Hb1 = ["stroke"], Ab1 = ["stroke"], Vb1 = ["stroke"], zb1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "16"
}, null, -1), Zb1 = { key: 1 }, Cb1 = /* @__PURE__ */ e("path", {
  d: "M20.2,75.9C83.7,28,172.3,28,235.8,75.9A8,8,0,0,1,237,87.5L134,208.9a7.9,7.9,0,0,1-12.1-.1L19,87.6A8.1,8.1,0,0,1,20.2,75.9Z",
  opacity: "0.2"
}, null, -1), bb1 = ["stroke"], Lb1 = ["stroke"], Bb1 = ["stroke"], Pb1 = { key: 2 }, Wb1 = /* @__PURE__ */ e("path", { d: "M53.9,34.6A8,8,0,0,0,42,45.4l4.7,5.1A182.8,182.8,0,0,0,15.3,69.6,15.6,15.6,0,0,0,9.1,80.5a16.3,16.3,0,0,0,3.8,12.3L115.8,214a15.9,15.9,0,0,0,24.3.1l26.7-31.5,35.3,38.8A8.2,8.2,0,0,0,208,224a7.8,7.8,0,0,0,5.4-2.1,8,8,0,0,0,.6-11.3Z" }, null, -1), Nb1 = /* @__PURE__ */ e("path", { d: "M246.9,80.5a15.6,15.6,0,0,0-6.2-10.9A188,188,0,0,0,92.6,35.3a8.3,8.3,0,0,0-6.1,5.4,8.2,8.2,0,0,0,1.7,7.9l93.4,102.7a8.3,8.3,0,0,0,5.9,2.6h.2a8.3,8.3,0,0,0,5.9-2.8l49.6-58.4A16.4,16.4,0,0,0,246.9,80.5Z" }, null, -1), Fb1 = [
  Wb1,
  Nb1
], Tb1 = { key: 3 }, Db1 = ["stroke"], Rb1 = ["stroke"], Ub1 = ["stroke"], qb1 = ["stroke"], Gb1 = ["stroke"], Eb1 = ["stroke"], Ob1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "10"
}, null, -1), Ib1 = { key: 4 }, Kb1 = ["stroke"], Xb1 = ["stroke"], Jb1 = ["stroke"], Qb1 = ["stroke"], Yb1 = ["stroke"], oL1 = ["stroke"], eL1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "8"
}, null, -1), tL1 = { key: 5 }, nL1 = ["stroke"], sL1 = ["stroke"], rL1 = ["stroke"], iL1 = ["stroke"], lL1 = ["stroke"], dL1 = ["stroke"], kL1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "12"
}, null, -1), cL1 = {
  name: "PhWifiSlash"
}, gsl = /* @__PURE__ */ $({
  ...cL1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", mb1, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Mb1),
        e("path", {
          d: "M25,98.2A147.2,147.2,0,0,1,72.4,66.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vb1),
        e("path", {
          d: "M59,132.1A98.3,98.3,0,0,1,108,106",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Sb1),
        e("path", {
          d: "M92.9,166.1a50.9,50.9,0,0,1,67.6-2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Hb1),
        e("path", {
          d: "M117,56.4c3.6-.3,7.3-.4,11-.4A145.6,145.6,0,0,1,230.9,98.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Ab1),
        e("path", {
          d: "M167.8,112.3A99.2,99.2,0,0,1,197,132.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, Vb1),
        zb1
      ])) : o(i) === "duotone" ? (s(), r("g", Zb1, [
        Cb1,
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bb1),
        e("path", {
          d: "M166.6,170.5,134,208.9a7.9,7.9,0,0,1-12.1-.1L19,87.6a8.1,8.1,0,0,1,1.2-11.7A177.8,177.8,0,0,1,60.1,53.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Lb1),
        e("path", {
          d: "M94.2,43.2A179.3,179.3,0,0,1,235.8,75.9,8,8,0,0,1,237,87.5l-49.5,58.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, Bb1)
      ])) : o(i) === "fill" ? (s(), r("g", Pb1, Fb1)) : o(i) === "light" ? (s(), r("g", Tb1, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Db1),
        e("path", {
          d: "M107.1,57.5A143.8,143.8,0,0,1,128,56,145.6,145.6,0,0,1,230.9,98.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Rb1),
        e("path", {
          d: "M25.1,98.2A145.7,145.7,0,0,1,72.4,66.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Ub1),
        e("path", {
          d: "M152.1,107A97.5,97.5,0,0,1,197,132.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, qb1),
        e("path", {
          d: "M59,132.1A98.3,98.3,0,0,1,108,106",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Gb1),
        e("path", {
          d: "M92.9,166.1a50.9,50.9,0,0,1,67.6-2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, Eb1),
        Ob1
      ])) : o(i) === "thin" ? (s(), r("g", Ib1, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Kb1),
        e("path", {
          d: "M107.1,57.5A143.8,143.8,0,0,1,128,56,145.6,145.6,0,0,1,230.9,98.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Xb1),
        e("path", {
          d: "M25.1,98.2A145.7,145.7,0,0,1,72.4,66.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Jb1),
        e("path", {
          d: "M152.1,107A97.5,97.5,0,0,1,197,132.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Qb1),
        e("path", {
          d: "M59,132.1A98.3,98.3,0,0,1,108,106",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, Yb1),
        e("path", {
          d: "M92.9,166.1a50.9,50.9,0,0,1,67.6-2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, oL1),
        eL1
      ])) : o(i) === "regular" ? (s(), r("g", tL1, [
        e("line", {
          x1: "48",
          y1: "40",
          x2: "208",
          y2: "216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nL1),
        e("path", {
          d: "M107.1,57.5A143.8,143.8,0,0,1,128,56,145.6,145.6,0,0,1,230.9,98.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, sL1),
        e("path", {
          d: "M25.1,98.2A145.7,145.7,0,0,1,72.4,66.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, rL1),
        e("path", {
          d: "M152.1,107A97.5,97.5,0,0,1,197,132.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iL1),
        e("path", {
          d: "M59,132.1A98.7,98.7,0,0,1,108,106",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lL1),
        e("path", {
          d: "M92.9,166.1a50.9,50.9,0,0,1,67.6-2.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dL1),
        kL1
      ])) : g("", !0)
    ], 16, jb1));
  }
}), hL1 = ["width", "height", "fill", "transform"], uL1 = { key: 0 }, aL1 = ["stroke"], _L1 = ["stroke"], pL1 = ["stroke"], yL1 = ["stroke"], $L1 = ["stroke"], wL1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "16"
}, null, -1), fL1 = { key: 1 }, gL1 = /* @__PURE__ */ e("path", {
  d: "M20.2,75.9C83.7,28,172.3,28,235.8,75.9A8,8,0,0,1,237,87.5L134,208.9a7.9,7.9,0,0,1-12.1-.1L19,87.6A8.1,8.1,0,0,1,20.2,75.9Z",
  opacity: "0.2"
}, null, -1), xL1 = ["stroke"], jL1 = ["stroke"], mL1 = ["stroke"], ML1 = { key: 2 }, vL1 = /* @__PURE__ */ e("path", { d: "M229.4,98.1a8.2,8.2,0,0,1,.6,11.1,7.8,7.8,0,0,1-6,2.8,8.3,8.3,0,0,1-5.7-2.3L200,91.3l-18.3,18.4A8.5,8.5,0,0,1,176,112a8,8,0,0,1-6.1-2.8,8.3,8.3,0,0,1,.6-11.1L188.7,80,170.6,61.9a8.3,8.3,0,0,1-.4-11.4,8.1,8.1,0,0,1,11.5-.2L200,68.7l18.3-18.4a8.1,8.1,0,0,1,11.5.2,8.3,8.3,0,0,1-.4,11.4L211.3,80Zm-26.6,18.7a3.9,3.9,0,0,0-5.6,0l-3.9,3.8a24,24,0,0,1-34.3.4,24.2,24.2,0,0,1,0-34l7.1-7-6.7-6.6c-9-9-9.9-23.6-1.5-33.2a11.4,11.4,0,0,1,1.1-1.1,2.9,2.9,0,0,0-1.5-4.8A187.4,187.4,0,0,0,15.4,69.6,15.6,15.6,0,0,0,9.2,80.5a16.6,16.6,0,0,0,3.7,12.3l103,121.3a15.9,15.9,0,0,0,24.2,0l71.5-84.2a4,4,0,0,0-.9-5.9,26.9,26.9,0,0,1-3.7-3Z" }, null, -1), SL1 = [
  vL1
], HL1 = { key: 3 }, AL1 = ["stroke"], VL1 = ["stroke"], zL1 = ["stroke"], ZL1 = ["stroke"], CL1 = ["stroke"], bL1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "10"
}, null, -1), LL1 = { key: 4 }, BL1 = ["stroke"], PL1 = ["stroke"], WL1 = ["stroke"], NL1 = ["stroke"], FL1 = ["stroke"], TL1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "8"
}, null, -1), DL1 = { key: 5 }, RL1 = ["stroke"], UL1 = ["stroke"], qL1 = ["stroke"], GL1 = ["stroke"], EL1 = ["stroke"], OL1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "200",
  r: "12"
}, null, -1), IL1 = {
  name: "PhWifiX"
}, xsl = /* @__PURE__ */ $({
  ...IL1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", uL1, [
        e("path", {
          d: "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aL1),
        e("line", {
          x1: "224",
          y1: "56",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, _L1),
        e("line", {
          x1: "224",
          y1: "104",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pL1),
        e("path", {
          d: "M25.1,98.2A145.6,145.6,0,0,1,128,56l8,.2",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yL1),
        e("path", {
          d: "M59,132.1A97.8,97.8,0,0,1,128,104c2.7,0,5.4.1,8,.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $L1),
        wL1
      ])) : o(i) === "duotone" ? (s(), r("g", fL1, [
        gL1,
        e("line", {
          x1: "224",
          y1: "56",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xL1),
        e("line", {
          x1: "224",
          y1: "104",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jL1),
        e("path", {
          d: "M202.7,127.9l-68.7,81a7.9,7.9,0,0,1-12.1-.1L19,87.6a8.1,8.1,0,0,1,1.2-11.7A178.9,178.9,0,0,1,147.7,41.1",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, mL1)
      ])) : o(i) === "fill" ? (s(), r("g", ML1, SL1)) : o(i) === "light" ? (s(), r("g", HL1, [
        e("path", {
          d: "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, AL1),
        e("line", {
          x1: "224",
          y1: "56",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VL1),
        e("line", {
          x1: "224",
          y1: "104",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, zL1),
        e("path", {
          d: "M25.1,98.2A145.6,145.6,0,0,1,128,56a141.7,141.7,0,0,1,16,.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, ZL1),
        e("path", {
          d: "M59,132.1A97.8,97.8,0,0,1,128,104a93.4,93.4,0,0,1,16,1.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, CL1),
        bL1
      ])) : o(i) === "thin" ? (s(), r("g", LL1, [
        e("path", {
          d: "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, BL1),
        e("line", {
          x1: "224",
          y1: "56",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, PL1),
        e("line", {
          x1: "224",
          y1: "104",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, WL1),
        e("path", {
          d: "M25.1,98.2A145.6,145.6,0,0,1,128,56a141.7,141.7,0,0,1,16,.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, NL1),
        e("path", {
          d: "M59,132.1A97.8,97.8,0,0,1,128,104a93.4,93.4,0,0,1,16,1.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, FL1),
        TL1
      ])) : o(i) === "regular" ? (s(), r("g", DL1, [
        e("path", {
          d: "M92.9,166.1a50.7,50.7,0,0,1,70.2,0",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, RL1),
        e("line", {
          x1: "224",
          y1: "56",
          x2: "176",
          y2: "104",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, UL1),
        e("line", {
          x1: "224",
          y1: "104",
          x2: "176",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, qL1),
        e("path", {
          d: "M25.1,98.2A145.6,145.6,0,0,1,128,56a141.7,141.7,0,0,1,16,.9",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GL1),
        e("path", {
          d: "M59,132.1A97.8,97.8,0,0,1,128,104a93.4,93.4,0,0,1,16,1.3",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EL1),
        OL1
      ])) : g("", !0)
    ], 16, hL1));
  }
}), KL1 = ["width", "height", "fill", "transform"], XL1 = { key: 0 }, JL1 = ["stroke"], QL1 = ["stroke"], YL1 = ["stroke"], oB1 = { key: 1 }, eB1 = ["stroke"], tB1 = ["stroke"], nB1 = ["stroke"], sB1 = { key: 2 }, rB1 = /* @__PURE__ */ e("path", { d: "M184,184a32,32,0,0,1-62,11.1,8,8,0,1,1,15-5.5A16,16,0,1,0,152,168H40a8,8,0,0,1,0-16H152A32.1,32.1,0,0,1,184,184Zm-64-80A32,32,0,1,0,90,60.9a8,8,0,1,0,15,5.5A16,16,0,1,1,120,88H24a8,8,0,0,0,0,16Zm88-32a32.1,32.1,0,0,0-30,20.9,8,8,0,1,0,15,5.5A16,16,0,1,1,208,120H32a8,8,0,0,0,0,16H208a32,32,0,0,0,0-64Z" }, null, -1), iB1 = [
  rB1
], lB1 = { key: 3 }, dB1 = ["stroke"], kB1 = ["stroke"], cB1 = ["stroke"], hB1 = { key: 4 }, uB1 = ["stroke"], aB1 = ["stroke"], _B1 = ["stroke"], pB1 = { key: 5 }, yB1 = ["stroke"], $B1 = ["stroke"], wB1 = ["stroke"], fB1 = {
  name: "PhWind"
}, jsl = /* @__PURE__ */ $({
  ...fB1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", XL1, [
        e("path", {
          d: "M102.1,52A24,24,0,1,1,120,92H24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, JL1),
        e("path", {
          d: "M190.1,92A24,24,0,1,1,208,132H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, QL1),
        e("path", {
          d: "M134.1,212A24,24,0,1,0,152,172H40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, YL1)
      ])) : o(i) === "duotone" ? (s(), r("g", oB1, [
        e("path", {
          d: "M129.5,192.3A24,24,0,1,0,152,160H40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, eB1),
        e("path", {
          d: "M97.5,63.7A24,24,0,1,1,120,96H24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, tB1),
        e("path", {
          d: "M185.5,95.7A24,24,0,1,1,208,128H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, nB1)
      ])) : o(i) === "fill" ? (s(), r("g", sB1, iB1)) : o(i) === "light" ? (s(), r("g", lB1, [
        e("path", {
          d: "M129.5,192.3A24,24,0,1,0,152,160H40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, dB1),
        e("path", {
          d: "M97.5,63.7A24,24,0,1,1,120,96H24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, kB1),
        e("path", {
          d: "M185.5,95.7A24,24,0,1,1,208,128H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, cB1)
      ])) : o(i) === "thin" ? (s(), r("g", hB1, [
        e("path", {
          d: "M129.5,192.3A24,24,0,1,0,152,160H40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, uB1),
        e("path", {
          d: "M97.5,63.7A24,24,0,1,1,120,96H24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, aB1),
        e("path", {
          d: "M185.5,95.7A24,24,0,1,1,208,128H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, _B1)
      ])) : o(i) === "regular" ? (s(), r("g", pB1, [
        e("path", {
          d: "M129.5,192.3A24,24,0,1,0,152,160H40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, yB1),
        e("path", {
          d: "M97.5,63.7A24,24,0,1,1,120,96H24",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, $B1),
        e("path", {
          d: "M185.5,95.7A24,24,0,1,1,208,128H32",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, wB1)
      ])) : g("", !0)
    ], 16, KL1));
  }
}), gB1 = ["width", "height", "fill", "transform"], xB1 = { key: 0 }, jB1 = ["stroke"], mB1 = ["stroke"], MB1 = ["stroke"], vB1 = ["stroke"], SB1 = { key: 1 }, HB1 = /* @__PURE__ */ e("polygon", {
  points: "216 216 136 201.5 136 201.5 136 144 216 144 216 216",
  opacity: "0.2"
}, null, -1), AB1 = /* @__PURE__ */ e("polygon", {
  points: "104 195.6 40 184 40 144 104 144 104 195.6",
  opacity: "0.2"
}, null, -1), VB1 = /* @__PURE__ */ e("polygon", {
  points: "216 40 136 54.5 136 54.5 136 112 216 112 216 40",
  opacity: "0.2"
}, null, -1), zB1 = /* @__PURE__ */ e("polygon", {
  points: "104 60.4 40 72 40 112 104 112 104 60.4",
  opacity: "0.2"
}, null, -1), ZB1 = ["stroke"], CB1 = ["stroke"], bB1 = ["stroke"], LB1 = ["stroke"], BB1 = { key: 2 }, PB1 = /* @__PURE__ */ e("path", { d: "M112,144v51.6a8.1,8.1,0,0,1-2.9,6.2,7.8,7.8,0,0,1-5.1,1.8h-1.4l-64-11.6A8,8,0,0,1,32,184V144a8,8,0,0,1,8-8h64A8,8,0,0,1,112,144Zm-2.9-89.8a8,8,0,0,0-6.5-1.7l-64,11.6A8,8,0,0,0,32,72v40a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V60.4A8.1,8.1,0,0,0,109.1,54.2ZM216,136H136a8,8,0,0,0-8,8v57.5a8,8,0,0,0,6.6,7.8l80,14.6H216a7.4,7.4,0,0,0,5.1-1.9A7.9,7.9,0,0,0,224,216V144A8,8,0,0,0,216,136Zm5.1-102.1a7.7,7.7,0,0,0-6.5-1.8l-80,14.6a8,8,0,0,0-6.6,7.8V112a8,8,0,0,0,8,8h80a8,8,0,0,0,8-8V40A7.9,7.9,0,0,0,221.1,33.9Z" }, null, -1), WB1 = [
  PB1
], NB1 = { key: 3 }, FB1 = ["stroke"], TB1 = ["stroke"], DB1 = ["stroke"], RB1 = ["stroke"], UB1 = { key: 4 }, qB1 = ["stroke"], GB1 = ["stroke"], EB1 = ["stroke"], OB1 = ["stroke"], IB1 = { key: 5 }, KB1 = ["stroke"], XB1 = ["stroke"], JB1 = ["stroke"], QB1 = ["stroke"], YB1 = {
  name: "PhWindowsLogo"
}, msl = /* @__PURE__ */ $({
  ...YB1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", xB1, [
        e("polygon", {
          points: "100 108 100 61.1 40 72 40 108 100 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, jB1),
        e("polygon", {
          points: "216 108 216 40 140 53.8 140 108 216 108",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, mB1),
        e("polygon", {
          points: "100 148 100 194.9 40 184 40 148 100 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, MB1),
        e("polygon", {
          points: "216 148 216 216 140 202.2 140 148 216 148",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, vB1)
      ])) : o(i) === "duotone" ? (s(), r("g", SB1, [
        HB1,
        AB1,
        VB1,
        zB1,
        e("polygon", {
          points: "216 216 136 201.5 136 201.5 136 144 216 144 216 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, ZB1),
        e("polygon", {
          points: "104 195.6 40 184 40 144 104 144 104 195.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, CB1),
        e("polygon", {
          points: "216 40 136 54.5 136 54.5 136 112 216 112 216 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, bB1),
        e("polygon", {
          points: "104 60.4 40 72 40 112 104 112 104 60.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, LB1)
      ])) : o(i) === "fill" ? (s(), r("g", BB1, WB1)) : o(i) === "light" ? (s(), r("g", NB1, [
        e("polygon", {
          points: "216 216 136 201.5 136 201.5 136 144 216 144 216 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, FB1),
        e("polygon", {
          points: "104 195.6 40 184 40 144 104 144 104 195.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, TB1),
        e("polygon", {
          points: "216 40 136 54.5 136 54.5 136 112 216 112 216 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DB1),
        e("polygon", {
          points: "104 60.4 40 72 40 112 104 112 104 60.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, RB1)
      ])) : o(i) === "thin" ? (s(), r("g", UB1, [
        e("polygon", {
          points: "216 216 136 201.5 136 201.5 136 144 216 144 216 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, qB1),
        e("polygon", {
          points: "104 195.6 40 184 40 144 104 144 104 195.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, GB1),
        e("polygon", {
          points: "216 40 136 54.5 136 54.5 136 112 216 112 216 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, EB1),
        e("polygon", {
          points: "104 60.4 40 72 40 112 104 112 104 60.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, OB1)
      ])) : o(i) === "regular" ? (s(), r("g", IB1, [
        e("polygon", {
          points: "216 216 136 201.5 136 201.5 136 144 216 144 216 216",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KB1),
        e("polygon", {
          points: "104 195.6 40 184 40 144 104 144 104 195.6",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, XB1),
        e("polygon", {
          points: "216 40 136 54.5 136 54.5 136 112 216 112 216 40",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, JB1),
        e("polygon", {
          points: "104 60.4 40 72 40 112 104 112 104 60.4",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QB1)
      ])) : g("", !0)
    ], 16, gB1));
  }
}), oP1 = ["width", "height", "fill", "transform"], eP1 = { key: 0 }, tP1 = ["stroke"], nP1 = ["stroke"], sP1 = ["stroke"], rP1 = ["stroke"], iP1 = { key: 1 }, lP1 = /* @__PURE__ */ e("path", {
  d: "M200.4,106.7l1.7,5.6a24.1,24.1,0,0,1-1.2,16.7,80,80,0,0,1-145.8,0,24.1,24.1,0,0,1-1.2-16.7l3.6-12h0C68.1,94.6,92.7,86.4,128,104c37.6,18.8,63.1,8.2,72.4,2.7Z",
  opacity: "0.2"
}, null, -1), dP1 = ["stroke"], kP1 = ["stroke"], cP1 = ["stroke"], hP1 = ["stroke"], uP1 = { key: 2 }, aP1 = /* @__PURE__ */ e("path", { d: "M209.7,110l-26-88.3A8,8,0,0,0,176,16H80a8,8,0,0,0-7.7,5.7L46.3,110a31.5,31.5,0,0,0,1.5,22.2A88.1,88.1,0,0,0,120,183.6V224H88a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16H136V183.6a88.1,88.1,0,0,0,72.2-51.4A31.5,31.5,0,0,0,209.7,110ZM131.6,96.8c-26.2-13-47.2-13-61.9-9.5L86,32h84l20.8,70.5C180.1,107,159.8,110.9,131.6,96.8Z" }, null, -1), _P1 = [
  aP1
], pP1 = { key: 3 }, yP1 = ["stroke"], $P1 = ["stroke"], wP1 = ["stroke"], fP1 = ["stroke"], gP1 = { key: 4 }, xP1 = ["stroke"], jP1 = ["stroke"], mP1 = ["stroke"], MP1 = ["stroke"], vP1 = { key: 5 }, SP1 = ["stroke"], HP1 = ["stroke"], AP1 = ["stroke"], VP1 = ["stroke"], zP1 = {
  name: "PhWine"
}, Msl = /* @__PURE__ */ $({
  ...zP1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", eP1, [
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, tP1),
        e("line", {
          x1: "88",
          y1: "232",
          x2: "168",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, nP1),
        e("path", {
          d: "M80,24h96l26.1,88.3a24.1,24.1,0,0,1-1.2,16.7,80,80,0,0,1-145.8,0,24.1,24.1,0,0,1-1.2-16.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, sP1),
        e("path", {
          d: "M57.5,100.3C68.1,94.6,92.7,86.4,128,104c37.6,18.8,63.1,8.2,72.4,2.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, rP1)
      ])) : o(i) === "duotone" ? (s(), r("g", iP1, [
        lP1,
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dP1),
        e("line", {
          x1: "88",
          y1: "232",
          x2: "168",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kP1),
        e("path", {
          d: "M80,24h96l26.1,88.3a24.1,24.1,0,0,1-1.2,16.7,80,80,0,0,1-145.8,0,24.1,24.1,0,0,1-1.2-16.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cP1),
        e("path", {
          d: "M57.5,100.3C68.1,94.6,92.7,86.4,128,104c37.6,18.8,63.1,8.2,72.4,2.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hP1)
      ])) : o(i) === "fill" ? (s(), r("g", uP1, _P1)) : o(i) === "light" ? (s(), r("g", pP1, [
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, yP1),
        e("line", {
          x1: "88",
          y1: "232",
          x2: "168",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, $P1),
        e("path", {
          d: "M80,24h96l26.1,88.3a24.1,24.1,0,0,1-1.2,16.7,80,80,0,0,1-145.8,0,24.1,24.1,0,0,1-1.2-16.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, wP1),
        e("path", {
          d: "M57.5,100.3C68.1,94.6,92.7,86.4,128,104c37.6,18.8,63.1,8.2,72.4,2.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, fP1)
      ])) : o(i) === "thin" ? (s(), r("g", gP1, [
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, xP1),
        e("line", {
          x1: "88",
          y1: "232",
          x2: "168",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, jP1),
        e("path", {
          d: "M80,24h96l26.1,88.3a24.1,24.1,0,0,1-1.2,16.7,80,80,0,0,1-145.8,0,24.1,24.1,0,0,1-1.2-16.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, mP1),
        e("path", {
          d: "M57.5,100.3C68.1,94.6,92.7,86.4,128,104c37.6,18.8,63.1,8.2,72.4,2.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, MP1)
      ])) : o(i) === "regular" ? (s(), r("g", vP1, [
        e("line", {
          x1: "128",
          y1: "176",
          x2: "128",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, SP1),
        e("line", {
          x1: "88",
          y1: "232",
          x2: "168",
          y2: "232",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, HP1),
        e("path", {
          d: "M80,24h96l26.1,88.3a24.1,24.1,0,0,1-1.2,16.7,80,80,0,0,1-145.8,0,24.1,24.1,0,0,1-1.2-16.7Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, AP1),
        e("path", {
          d: "M57.5,100.3C68.1,94.6,92.7,86.4,128,104c37.6,18.8,63.1,8.2,72.4,2.7",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, VP1)
      ])) : g("", !0)
    ], 16, oP1));
  }
}), ZP1 = ["width", "height", "fill", "transform"], CP1 = { key: 0 }, bP1 = ["stroke"], LP1 = { key: 1 }, BP1 = /* @__PURE__ */ e("path", {
  d: "M218.9,71a63.9,63.9,0,0,1-89.8,81h0L73,217a24,24,0,0,1-34-34l65-56.1h0a63.9,63.9,0,0,1,81-89.8L143,79l5.7,28.3L177,113Z",
  opacity: "0.2"
}, null, -1), PP1 = ["stroke"], WP1 = { key: 2 }, NP1 = /* @__PURE__ */ e("path", { d: "M210.9,146.9A72.6,72.6,0,0,1,131,162L79,222.2c-.1.2-.3.3-.4.4a31.9,31.9,0,0,1-45.2,0,31.9,31.9,0,0,1,0-45.2l.4-.4L94,125a72,72,0,0,1,94.1-95.2,7.9,7.9,0,0,1,4.7,5.8,8,8,0,0,1-2.2,7.2L151.7,81.7l3.7,18.9,18.9,3.7,38.9-38.9a8,8,0,0,1,7.2-2.2,7.9,7.9,0,0,1,5.8,4.7A71.7,71.7,0,0,1,210.9,146.9Z" }, null, -1), FP1 = [
  NP1
], TP1 = { key: 3 }, DP1 = ["stroke"], RP1 = { key: 4 }, UP1 = ["stroke"], qP1 = { key: 5 }, GP1 = ["stroke"], EP1 = {
  name: "PhWrench"
}, vsl = /* @__PURE__ */ $({
  ...EP1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", CP1, [
        e("path", {
          d: "M218.9,71a63.9,63.9,0,0,1-89.8,81h0L73,217a24,24,0,0,1-34-34l65-56.1h0a63.9,63.9,0,0,1,81-89.8L143,79l5.7,28.3L177,113Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, bP1)
      ])) : o(i) === "duotone" ? (s(), r("g", LP1, [
        BP1,
        e("path", {
          d: "M218.9,71a63.9,63.9,0,0,1-89.8,81h0L73,217a24,24,0,0,1-34-34l65-56.1h0a63.9,63.9,0,0,1,81-89.8L143,79l5.7,28.3L177,113Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PP1)
      ])) : o(i) === "fill" ? (s(), r("g", WP1, FP1)) : o(i) === "light" ? (s(), r("g", TP1, [
        e("path", {
          d: "M218.9,71a63.9,63.9,0,0,1-89.8,81h0L73,217a24,24,0,0,1-34-34l65-56.1h0a63.9,63.9,0,0,1,81-89.8L143,79l5.7,28.3L177,113Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, DP1)
      ])) : o(i) === "thin" ? (s(), r("g", RP1, [
        e("path", {
          d: "M218.9,71a63.9,63.9,0,0,1-89.8,81h0L73,217a24,24,0,0,1-34-34l65-56.1h0a63.9,63.9,0,0,1,81-89.8L143,79l5.7,28.3L177,113Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, UP1)
      ])) : o(i) === "regular" ? (s(), r("g", qP1, [
        e("path", {
          d: "M218.9,71a63.9,63.9,0,0,1-89.8,81h0L73,217a24,24,0,0,1-34-34l65-56.1h0a63.9,63.9,0,0,1,81-89.8L143,79l5.7,28.3L177,113Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, GP1)
      ])) : g("", !0)
    ], 16, ZP1));
  }
}), OP1 = ["width", "height", "fill", "transform"], IP1 = { key: 0 }, KP1 = ["stroke"], XP1 = ["stroke"], JP1 = { key: 1 }, QP1 = ["stroke"], YP1 = ["stroke"], oW1 = { key: 2 }, eW1 = /* @__PURE__ */ e("path", { d: "M139.3,128l66.4-66.3a8.1,8.1,0,0,0-11.4-11.4L128,116.7,61.7,50.3A8.1,8.1,0,0,0,50.3,61.7L116.7,128,50.3,194.3a8.1,8.1,0,0,0,0,11.4,8.2,8.2,0,0,0,11.4,0L128,139.3l66.3,66.4a8.2,8.2,0,0,0,11.4,0,8.1,8.1,0,0,0,0-11.4Z" }, null, -1), tW1 = [
  eW1
], nW1 = { key: 3 }, sW1 = ["stroke"], rW1 = ["stroke"], iW1 = { key: 4 }, lW1 = ["stroke"], dW1 = ["stroke"], kW1 = { key: 5 }, cW1 = ["stroke"], hW1 = ["stroke"], uW1 = {
  name: "PhX"
}, Ssl = /* @__PURE__ */ $({
  ...uW1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", IP1, [
        e("line", {
          x1: "200",
          y1: "56",
          x2: "56",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, KP1),
        e("line", {
          x1: "200",
          y1: "200",
          x2: "56",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, XP1)
      ])) : o(i) === "duotone" ? (s(), r("g", JP1, [
        e("line", {
          x1: "200",
          y1: "56",
          x2: "56",
          y2: "200",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, QP1),
        e("line", {
          x1: "200",
          y1: "200",
          x2: "56",
          y2: "56",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, YP1)
      ])) : o(i) === "fill" ? (s(), r("g", oW1, tW1)) : o(i) === "light" ? (s(), r("g", nW1, [
        e("line", {
          x1: "200",
          y1: "56",
          x2: "56",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, sW1),
        e("line", {
          x1: "200",
          y1: "200",
          x2: "56",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, rW1)
      ])) : o(i) === "thin" ? (s(), r("g", iW1, [
        e("line", {
          x1: "200",
          y1: "56",
          x2: "56",
          y2: "200",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, lW1),
        e("line", {
          x1: "200",
          y1: "200",
          x2: "56",
          y2: "56",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, dW1)
      ])) : o(i) === "regular" ? (s(), r("g", kW1, [
        e("line", {
          x1: "200",
          y1: "56",
          x2: "56",
          y2: "200",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, cW1),
        e("line", {
          x1: "200",
          y1: "200",
          x2: "56",
          y2: "56",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, hW1)
      ])) : g("", !0)
    ], 16, OP1));
  }
}), aW1 = ["width", "height", "fill", "transform"], _W1 = { key: 0 }, pW1 = ["stroke"], yW1 = ["stroke"], $W1 = ["stroke"], wW1 = { key: 1 }, fW1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "128",
  r: "96",
  opacity: "0.2"
}, null, -1), gW1 = ["stroke"], xW1 = ["stroke"], jW1 = ["stroke"], mW1 = { key: 2 }, MW1 = /* @__PURE__ */ e("path", { d: "M128,24A104,104,0,1,0,232,128,104.2,104.2,0,0,0,128,24Zm37.7,130.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0L128,139.3l-26.3,26.4a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L116.7,128,90.3,101.7a8.1,8.1,0,0,1,11.4-11.4L128,116.7l26.3-26.4a8.1,8.1,0,0,1,11.4,11.4L139.3,128Z" }, null, -1), vW1 = [
  MW1
], SW1 = { key: 3 }, HW1 = ["stroke"], AW1 = ["stroke"], VW1 = ["stroke"], zW1 = { key: 4 }, ZW1 = ["stroke"], CW1 = ["stroke"], bW1 = ["stroke"], LW1 = { key: 5 }, BW1 = ["stroke"], PW1 = ["stroke"], WW1 = ["stroke"], NW1 = {
  name: "PhXCircle"
}, Hsl = /* @__PURE__ */ $({
  ...NW1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", _W1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pW1),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "96",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, yW1),
        e("line", {
          x1: "160",
          y1: "160",
          x2: "96",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, $W1)
      ])) : o(i) === "duotone" ? (s(), r("g", wW1, [
        fW1,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, gW1),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "96",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xW1),
        e("line", {
          x1: "160",
          y1: "160",
          x2: "96",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, jW1)
      ])) : o(i) === "fill" ? (s(), r("g", mW1, vW1)) : o(i) === "light" ? (s(), r("g", SW1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HW1),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "96",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, AW1),
        e("line", {
          x1: "160",
          y1: "160",
          x2: "96",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VW1)
      ])) : o(i) === "thin" ? (s(), r("g", zW1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, ZW1),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "96",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CW1),
        e("line", {
          x1: "160",
          y1: "160",
          x2: "96",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, bW1)
      ])) : o(i) === "regular" ? (s(), r("g", LW1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-miterlimit": "10",
          "stroke-width": "16"
        }, null, 8, BW1),
        e("line", {
          x1: "160",
          y1: "96",
          x2: "96",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, PW1),
        e("line", {
          x1: "160",
          y1: "160",
          x2: "96",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WW1)
      ])) : g("", !0)
    ], 16, aW1));
  }
}), FW1 = ["width", "height", "fill", "transform"], TW1 = { key: 0 }, DW1 = ["stroke"], RW1 = ["stroke"], UW1 = ["stroke"], qW1 = { key: 1 }, GW1 = /* @__PURE__ */ e("rect", {
  x: "40",
  y: "40",
  width: "176",
  height: "176",
  rx: "8",
  opacity: "0.2"
}, null, -1), EW1 = ["stroke"], OW1 = ["stroke"], IW1 = ["stroke"], KW1 = { key: 2 }, XW1 = /* @__PURE__ */ e("path", { d: "M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM165.7,154.3a8.1,8.1,0,0,1,0,11.4,8.2,8.2,0,0,1-11.4,0L128,139.3l-26.3,26.4a8.2,8.2,0,0,1-11.4,0,8.1,8.1,0,0,1,0-11.4L116.7,128,90.3,101.7a8.1,8.1,0,0,1,11.4-11.4L128,116.7l26.3-26.4a8.1,8.1,0,0,1,11.4,11.4L139.3,128Z" }, null, -1), JW1 = [
  XW1
], QW1 = { key: 3 }, YW1 = ["stroke"], oN1 = ["stroke"], eN1 = ["stroke"], tN1 = { key: 4 }, nN1 = ["stroke"], sN1 = ["stroke"], rN1 = ["stroke"], iN1 = { key: 5 }, lN1 = ["stroke"], dN1 = ["stroke"], kN1 = ["stroke"], cN1 = {
  name: "PhXSquare"
}, Asl = /* @__PURE__ */ $({
  ...cN1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", TW1, [
        e("line", {
          x1: "160",
          y1: "96",
          x2: "96",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, DW1),
        e("line", {
          x1: "160",
          y1: "160",
          x2: "96",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, RW1),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, UW1)
      ])) : o(i) === "duotone" ? (s(), r("g", qW1, [
        GW1,
        e("line", {
          x1: "160",
          y1: "96",
          x2: "96",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, EW1),
        e("line", {
          x1: "160",
          y1: "160",
          x2: "96",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, OW1),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IW1)
      ])) : o(i) === "fill" ? (s(), r("g", KW1, JW1)) : o(i) === "light" ? (s(), r("g", QW1, [
        e("line", {
          x1: "160",
          y1: "96",
          x2: "96",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, YW1),
        e("line", {
          x1: "160",
          y1: "160",
          x2: "96",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oN1),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eN1)
      ])) : o(i) === "thin" ? (s(), r("g", tN1, [
        e("line", {
          x1: "160",
          y1: "96",
          x2: "96",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nN1),
        e("line", {
          x1: "160",
          y1: "160",
          x2: "96",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sN1),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, rN1)
      ])) : o(i) === "regular" ? (s(), r("g", iN1, [
        e("line", {
          x1: "160",
          y1: "96",
          x2: "96",
          y2: "160",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lN1),
        e("line", {
          x1: "160",
          y1: "160",
          x2: "96",
          y2: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, dN1),
        e("rect", {
          x: "40",
          y: "40",
          width: "176",
          height: "176",
          rx: "8",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, kN1)
      ])) : g("", !0)
    ], 16, FW1));
  }
}), hN1 = ["width", "height", "fill", "transform"], uN1 = { key: 0 }, aN1 = ["stroke"], _N1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "176",
  r: "16"
}, null, -1), pN1 = ["stroke"], yN1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "80",
  r: "16"
}, null, -1), $N1 = { key: 1 }, wN1 = /* @__PURE__ */ e("g", { opacity: "0.2" }, [
  /* @__PURE__ */ e("path", { d: "M128,224a48,48,0,0,1,0-96,48,48,0,0,0,0-96,96,96,0,0,1,0,192Z" })
], -1), fN1 = ["stroke"], gN1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "176",
  r: "12"
}, null, -1), xN1 = ["stroke"], jN1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "80",
  r: "12"
}, null, -1), mN1 = { key: 2 }, MN1 = /* @__PURE__ */ e("path", { d: "M140,80a12,12,0,1,1-12-12A12,12,0,0,1,140,80Zm92,48A104,104,0,1,1,128,24,104.2,104.2,0,0,1,232,128Zm-92,48a12,12,0,1,0-12,12A12,12,0,0,0,140,176Zm32-92a44,44,0,0,0-44-44A88,88,0,0,0,81.1,202.4,51.1,51.1,0,0,1,76,180a52,52,0,0,1,52-52A44,44,0,0,0,172,84Z" }, null, -1), vN1 = [
  MN1
], SN1 = { key: 3 }, HN1 = ["stroke"], AN1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "176",
  r: "12"
}, null, -1), VN1 = ["stroke"], zN1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "80",
  r: "10"
}, null, -1), ZN1 = { key: 4 }, CN1 = ["stroke"], bN1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "176",
  r: "8"
}, null, -1), LN1 = ["stroke"], BN1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "80",
  r: "8"
}, null, -1), PN1 = { key: 5 }, WN1 = ["stroke"], NN1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "176",
  r: "12"
}, null, -1), FN1 = ["stroke"], TN1 = /* @__PURE__ */ e("circle", {
  cx: "128",
  cy: "80",
  r: "12"
}, null, -1), DN1 = {
  name: "PhYinYang"
}, Vsl = /* @__PURE__ */ $({
  ...DN1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", uN1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, aN1),
        _N1,
        e("path", {
          d: "M128,224a48,48,0,0,1,0-96,48,48,0,0,0,0-96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, pN1),
        yN1
      ])) : o(i) === "duotone" ? (s(), r("g", $N1, [
        wN1,
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, fN1),
        gN1,
        e("path", {
          d: "M128,224a48,48,0,0,1,0-96,48,48,0,0,0,0-96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, xN1),
        jN1
      ])) : o(i) === "fill" ? (s(), r("g", mN1, vN1)) : o(i) === "light" ? (s(), r("g", SN1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, HN1),
        AN1,
        e("path", {
          d: "M128,224a48,48,0,0,1,0-96,48,48,0,0,0,0-96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, VN1),
        zN1
      ])) : o(i) === "thin" ? (s(), r("g", ZN1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, CN1),
        bN1,
        e("path", {
          d: "M128,224a48,48,0,0,1,0-96,48,48,0,0,0,0-96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, LN1),
        BN1
      ])) : o(i) === "regular" ? (s(), r("g", PN1, [
        e("circle", {
          cx: "128",
          cy: "128",
          r: "96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, WN1),
        NN1,
        e("path", {
          d: "M128,224a48,48,0,0,1,0-96,48,48,0,0,0,0-96",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, FN1),
        TN1
      ])) : g("", !0)
    ], 16, hN1));
  }
}), RN1 = ["width", "height", "fill", "transform"], UN1 = { key: 0 }, qN1 = ["stroke"], GN1 = ["stroke"], EN1 = { key: 1 }, ON1 = /* @__PURE__ */ e("path", {
  d: "M226.6,71.8A16.1,16.1,0,0,0,217,60.9c-33.5-12.8-89-12.5-89-12.5s-55.5-.3-89,12.5a16.1,16.1,0,0,0-9.6,10.9C27.1,80.8,24,98.2,24,128s3.1,47.2,5.4,56.2A16.1,16.1,0,0,0,39,195.1c33.5,12.8,89,12.5,89,12.5s55.5.3,89-12.5a16.1,16.1,0,0,0,9.6-10.9c2.3-9,5.4-26.4,5.4-56.2S228.9,80.8,226.6,71.8ZM112,160V96l48,32Z",
  opacity: "0.2"
}, null, -1), IN1 = ["stroke"], KN1 = ["stroke"], XN1 = { key: 2 }, JN1 = /* @__PURE__ */ e("path", { d: "M234.3,69.8a23.5,23.5,0,0,0-14.5-16.3C185.6,40.3,131,40.4,128,40.4s-57.6-.1-91.8,13.1A23.5,23.5,0,0,0,21.7,69.8C19.1,79.7,16,97.9,16,128s3.1,48.3,5.7,58.2a23.5,23.5,0,0,0,14.5,16.3c32.8,12.7,84.2,13.1,91.1,13.1h1.4c6.9,0,58.3-.4,91.1-13.1a23.5,23.5,0,0,0,14.5-16.3c2.6-9.9,5.7-28.1,5.7-58.2S236.9,79.7,234.3,69.8Zm-72.1,61.5-48,32a3.6,3.6,0,0,1-2.2.7,4.5,4.5,0,0,1-1.9-.5A3.9,3.9,0,0,1,108,160V96a3.9,3.9,0,0,1,2.1-3.5,4,4,0,0,1,4.1.2l48,32a3.9,3.9,0,0,1,0,6.6Z" }, null, -1), QN1 = [
  JN1
], YN1 = { key: 3 }, oF1 = ["stroke"], eF1 = ["stroke"], tF1 = { key: 4 }, nF1 = ["stroke"], sF1 = ["stroke"], rF1 = { key: 5 }, iF1 = ["stroke"], lF1 = ["stroke"], dF1 = {
  name: "PhYoutubeLogo"
}, zsl = /* @__PURE__ */ $({
  ...dF1,
  props: {
    weight: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    },
    mirrored: {
      type: Boolean
    }
  },
  setup(h) {
    const l = h, u = d("weight", "regular"), a = d("size", "1em"), _ = d("color", "currentColor"), p = d("mirrored", !1), i = k(() => {
      var n;
      return (n = l.weight) != null ? n : u;
    }), c = k(() => {
      var n;
      return (n = l.size) != null ? n : a;
    }), t = k(() => {
      var n;
      return (n = l.color) != null ? n : _;
    }), y = k(() => {
      var n;
      return ((n = l.mirrored) != null ? n : p) ? "scale(-1, 1)" : void 0;
    });
    return (n, x) => (s(), r("svg", w({
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 256 256",
      width: o(c),
      height: o(c),
      fill: o(t),
      transform: o(y)
    }, n.$attrs), [
      f(n.$slots, "default"),
      o(i) === "bold" ? (s(), r("g", UN1, [
        e("polygon", {
          points: "164 128 108 92 108 164 164 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, qN1),
        e("path", {
          d: "M24,128c0,29.8,3.1,47.2,5.4,56.2A16.1,16.1,0,0,0,39,195.1c33.5,12.8,89,12.5,89,12.5s55.5.3,89-12.5a16.1,16.1,0,0,0,9.6-10.9c2.3-9,5.4-26.4,5.4-56.2s-3.1-47.2-5.4-56.2A16.1,16.1,0,0,0,217,60.9c-33.5-12.8-89-12.5-89-12.5s-55.5-.3-89,12.5a16.1,16.1,0,0,0-9.6,10.9C27.1,80.8,24,98.2,24,128Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "24"
        }, null, 8, GN1)
      ])) : o(i) === "duotone" ? (s(), r("g", EN1, [
        ON1,
        e("polygon", {
          points: "160 128 112 96 112 160 160 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, IN1),
        e("path", {
          d: "M24,128c0,29.8,3.1,47.2,5.4,56.2A16.1,16.1,0,0,0,39,195.1c33.5,12.8,89,12.5,89,12.5s55.5.3,89-12.5a16.1,16.1,0,0,0,9.6-10.9c2.3-9,5.4-26.4,5.4-56.2s-3.1-47.2-5.4-56.2A16.1,16.1,0,0,0,217,60.9c-33.5-12.8-89-12.5-89-12.5s-55.5-.3-89,12.5a16.1,16.1,0,0,0-9.6,10.9C27.1,80.8,24,98.2,24,128Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, KN1)
      ])) : o(i) === "fill" ? (s(), r("g", XN1, QN1)) : o(i) === "light" ? (s(), r("g", YN1, [
        e("polygon", {
          points: "160 128 112 96 112 160 160 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, oF1),
        e("path", {
          d: "M24,128c0,29.8,3.1,47.2,5.4,56.2A16.1,16.1,0,0,0,39,195.1c33.5,12.8,89,12.5,89,12.5s55.5.3,89-12.5a16.1,16.1,0,0,0,9.6-10.9c2.3-9,5.4-26.4,5.4-56.2s-3.1-47.2-5.4-56.2A16.1,16.1,0,0,0,217,60.9c-33.5-12.8-89-12.5-89-12.5s-55.5-.3-89,12.5a16.1,16.1,0,0,0-9.6,10.9C27.1,80.8,24,98.2,24,128Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "12"
        }, null, 8, eF1)
      ])) : o(i) === "thin" ? (s(), r("g", tF1, [
        e("polygon", {
          points: "160 128 112 96 112 160 160 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, nF1),
        e("path", {
          d: "M24,128c0,29.8,3.1,47.2,5.4,56.2A16.1,16.1,0,0,0,39,195.1c33.5,12.8,89,12.5,89,12.5s55.5.3,89-12.5a16.1,16.1,0,0,0,9.6-10.9c2.3-9,5.4-26.4,5.4-56.2s-3.1-47.2-5.4-56.2A16.1,16.1,0,0,0,217,60.9c-33.5-12.8-89-12.5-89-12.5s-55.5-.3-89,12.5a16.1,16.1,0,0,0-9.6,10.9C27.1,80.8,24,98.2,24,128Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "8"
        }, null, 8, sF1)
      ])) : o(i) === "regular" ? (s(), r("g", rF1, [
        e("polygon", {
          points: "160 128 112 96 112 160 160 128",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, iF1),
        e("path", {
          d: "M24,128c0,29.8,3.1,47.2,5.4,56.2A16.1,16.1,0,0,0,39,195.1c33.5,12.8,89,12.5,89,12.5s55.5.3,89-12.5a16.1,16.1,0,0,0,9.6-10.9c2.3-9,5.4-26.4,5.4-56.2s-3.1-47.2-5.4-56.2A16.1,16.1,0,0,0,217,60.9c-33.5-12.8-89-12.5-89-12.5s-55.5-.3-89,12.5a16.1,16.1,0,0,0-9.6,10.9C27.1,80.8,24,98.2,24,128Z",
          fill: "none",
          stroke: o(t),
          "stroke-linecap": "round",
          "stroke-linejoin": "round",
          "stroke-width": "16"
        }, null, 8, lF1)
      ])) : g("", !0)
    ], 16, RN1));
  }
});
export {
  cF1 as PhActivity,
  hF1 as PhAddressBook,
  uF1 as PhAirplane,
  aF1 as PhAirplaneInFlight,
  _F1 as PhAirplaneLanding,
  pF1 as PhAirplaneTakeoff,
  yF1 as PhAirplaneTilt,
  $F1 as PhAirplay,
  wF1 as PhAlarm,
  fF1 as PhAlien,
  gF1 as PhAlignBottom,
  xF1 as PhAlignBottomSimple,
  jF1 as PhAlignCenterHorizontal,
  mF1 as PhAlignCenterHorizontalSimple,
  MF1 as PhAlignCenterVertical,
  vF1 as PhAlignCenterVerticalSimple,
  SF1 as PhAlignLeft,
  HF1 as PhAlignLeftSimple,
  AF1 as PhAlignRight,
  VF1 as PhAlignRightSimple,
  zF1 as PhAlignTop,
  ZF1 as PhAlignTopSimple,
  CF1 as PhAnchor,
  bF1 as PhAnchorSimple,
  LF1 as PhAndroidLogo,
  BF1 as PhAngularLogo,
  PF1 as PhAperture,
  WF1 as PhAppStoreLogo,
  NF1 as PhAppWindow,
  FF1 as PhAppleLogo,
  TF1 as PhApplePodcastsLogo,
  DF1 as PhArchive,
  RF1 as PhArchiveBox,
  UF1 as PhArchiveTray,
  qF1 as PhArmchair,
  GF1 as PhArrowArcLeft,
  EF1 as PhArrowArcRight,
  OF1 as PhArrowBendDoubleUpLeft,
  IF1 as PhArrowBendDoubleUpRight,
  KF1 as PhArrowBendDownLeft,
  XF1 as PhArrowBendDownRight,
  JF1 as PhArrowBendLeftDown,
  QF1 as PhArrowBendLeftUp,
  YF1 as PhArrowBendRightDown,
  oT1 as PhArrowBendRightUp,
  eT1 as PhArrowBendUpLeft,
  tT1 as PhArrowBendUpRight,
  nT1 as PhArrowCircleDown,
  sT1 as PhArrowCircleDownLeft,
  rT1 as PhArrowCircleDownRight,
  iT1 as PhArrowCircleLeft,
  lT1 as PhArrowCircleRight,
  dT1 as PhArrowCircleUp,
  kT1 as PhArrowCircleUpLeft,
  cT1 as PhArrowCircleUpRight,
  hT1 as PhArrowClockwise,
  uT1 as PhArrowCounterClockwise,
  aT1 as PhArrowDown,
  _T1 as PhArrowDownLeft,
  pT1 as PhArrowDownRight,
  yT1 as PhArrowElbowDownLeft,
  $T1 as PhArrowElbowDownRight,
  wT1 as PhArrowElbowLeft,
  fT1 as PhArrowElbowLeftDown,
  gT1 as PhArrowElbowLeftUp,
  xT1 as PhArrowElbowRight,
  jT1 as PhArrowElbowRightDown,
  mT1 as PhArrowElbowRightUp,
  MT1 as PhArrowElbowUpLeft,
  vT1 as PhArrowElbowUpRight,
  ST1 as PhArrowFatDown,
  HT1 as PhArrowFatLeft,
  AT1 as PhArrowFatLineDown,
  VT1 as PhArrowFatLineLeft,
  zT1 as PhArrowFatLineRight,
  ZT1 as PhArrowFatLineUp,
  CT1 as PhArrowFatLinesDown,
  bT1 as PhArrowFatLinesLeft,
  LT1 as PhArrowFatLinesRight,
  BT1 as PhArrowFatLinesUp,
  PT1 as PhArrowFatRight,
  WT1 as PhArrowFatUp,
  NT1 as PhArrowLeft,
  FT1 as PhArrowLineDown,
  TT1 as PhArrowLineDownLeft,
  DT1 as PhArrowLineDownRight,
  RT1 as PhArrowLineLeft,
  UT1 as PhArrowLineRight,
  qT1 as PhArrowLineUp,
  GT1 as PhArrowLineUpLeft,
  ET1 as PhArrowLineUpRight,
  OT1 as PhArrowRight,
  IT1 as PhArrowSquareDown,
  KT1 as PhArrowSquareDownLeft,
  XT1 as PhArrowSquareDownRight,
  JT1 as PhArrowSquareIn,
  QT1 as PhArrowSquareLeft,
  YT1 as PhArrowSquareOut,
  oD1 as PhArrowSquareRight,
  eD1 as PhArrowSquareUp,
  tD1 as PhArrowSquareUpLeft,
  nD1 as PhArrowSquareUpRight,
  sD1 as PhArrowUDownLeft,
  rD1 as PhArrowUDownRight,
  iD1 as PhArrowULeftDown,
  lD1 as PhArrowULeftUp,
  dD1 as PhArrowURightDown,
  kD1 as PhArrowURightUp,
  cD1 as PhArrowUUpLeft,
  hD1 as PhArrowUUpRight,
  uD1 as PhArrowUp,
  aD1 as PhArrowUpLeft,
  _D1 as PhArrowUpRight,
  pD1 as PhArrowsClockwise,
  yD1 as PhArrowsCounterClockwise,
  $D1 as PhArrowsDownUp,
  wD1 as PhArrowsHorizontal,
  fD1 as PhArrowsIn,
  gD1 as PhArrowsInCardinal,
  xD1 as PhArrowsInLineHorizontal,
  jD1 as PhArrowsInLineVertical,
  mD1 as PhArrowsInSimple,
  MD1 as PhArrowsLeftRight,
  vD1 as PhArrowsOut,
  SD1 as PhArrowsOutCardinal,
  HD1 as PhArrowsOutLineHorizontal,
  AD1 as PhArrowsOutLineVertical,
  VD1 as PhArrowsOutSimple,
  zD1 as PhArrowsVertical,
  ZD1 as PhArticle,
  CD1 as PhArticleMedium,
  bD1 as PhArticleNyTimes,
  LD1 as PhAsterisk,
  BD1 as PhAsteriskSimple,
  PD1 as PhAt,
  WD1 as PhAtom,
  ND1 as PhBaby,
  FD1 as PhBackpack,
  TD1 as PhBackspace,
  DD1 as PhBag,
  RD1 as PhBagSimple,
  UD1 as PhBalloon,
  qD1 as PhBandaids,
  GD1 as PhBank,
  ED1 as PhBarbell,
  OD1 as PhBarcode,
  ID1 as PhBarricade,
  KD1 as PhBaseball,
  XD1 as PhBasketball,
  JD1 as PhBathtub,
  QD1 as PhBatteryCharging,
  YD1 as PhBatteryChargingVertical,
  oR1 as PhBatteryEmpty,
  eR1 as PhBatteryFull,
  tR1 as PhBatteryHigh,
  nR1 as PhBatteryLow,
  sR1 as PhBatteryMedium,
  rR1 as PhBatteryPlus,
  iR1 as PhBatteryWarning,
  lR1 as PhBatteryWarningVertical,
  dR1 as PhBed,
  kR1 as PhBeerBottle,
  cR1 as PhBehanceLogo,
  hR1 as PhBell,
  uR1 as PhBellRinging,
  aR1 as PhBellSimple,
  _R1 as PhBellSimpleRinging,
  pR1 as PhBellSimpleSlash,
  yR1 as PhBellSimpleZ,
  $R1 as PhBellSlash,
  wR1 as PhBellZ,
  fR1 as PhBezierCurve,
  gR1 as PhBicycle,
  xR1 as PhBinoculars,
  jR1 as PhBird,
  mR1 as PhBluetooth,
  MR1 as PhBluetoothConnected,
  vR1 as PhBluetoothSlash,
  SR1 as PhBluetoothX,
  HR1 as PhBoat,
  AR1 as PhBook,
  VR1 as PhBookBookmark,
  zR1 as PhBookOpen,
  ZR1 as PhBookmark,
  CR1 as PhBookmarkSimple,
  bR1 as PhBookmarks,
  LR1 as PhBookmarksSimple,
  BR1 as PhBooks,
  PR1 as PhBoundingBox,
  WR1 as PhBracketsAngle,
  NR1 as PhBracketsCurly,
  FR1 as PhBracketsRound,
  TR1 as PhBracketsSquare,
  DR1 as PhBrain,
  RR1 as PhBrandy,
  UR1 as PhBriefcase,
  qR1 as PhBriefcaseMetal,
  GR1 as PhBroadcast,
  ER1 as PhBrowser,
  OR1 as PhBrowsers,
  IR1 as PhBug,
  KR1 as PhBugBeetle,
  XR1 as PhBugDroid,
  JR1 as PhBuildings,
  QR1 as PhBus,
  YR1 as PhButterfly,
  oU1 as PhCactus,
  eU1 as PhCake,
  tU1 as PhCalculator,
  nU1 as PhCalendar,
  sU1 as PhCalendarBlank,
  rU1 as PhCalendarCheck,
  iU1 as PhCalendarPlus,
  lU1 as PhCalendarX,
  dU1 as PhCamera,
  kU1 as PhCameraRotate,
  cU1 as PhCameraSlash,
  hU1 as PhCampfire,
  uU1 as PhCar,
  aU1 as PhCarSimple,
  _U1 as PhCardholder,
  pU1 as PhCards,
  yU1 as PhCaretCircleDoubleDown,
  $U1 as PhCaretCircleDoubleLeft,
  wU1 as PhCaretCircleDoubleRight,
  fU1 as PhCaretCircleDoubleUp,
  gU1 as PhCaretCircleDown,
  xU1 as PhCaretCircleLeft,
  jU1 as PhCaretCircleRight,
  mU1 as PhCaretCircleUp,
  MU1 as PhCaretDoubleDown,
  vU1 as PhCaretDoubleLeft,
  SU1 as PhCaretDoubleRight,
  HU1 as PhCaretDoubleUp,
  AU1 as PhCaretDown,
  VU1 as PhCaretLeft,
  zU1 as PhCaretRight,
  ZU1 as PhCaretUp,
  CU1 as PhCat,
  bU1 as PhCellSignalFull,
  LU1 as PhCellSignalHigh,
  BU1 as PhCellSignalLow,
  PU1 as PhCellSignalMedium,
  WU1 as PhCellSignalNone,
  NU1 as PhCellSignalSlash,
  FU1 as PhCellSignalX,
  TU1 as PhChalkboard,
  DU1 as PhChalkboardSimple,
  RU1 as PhChalkboardTeacher,
  UU1 as PhChartBar,
  qU1 as PhChartBarHorizontal,
  GU1 as PhChartLine,
  EU1 as PhChartLineUp,
  OU1 as PhChartPie,
  IU1 as PhChartPieSlice,
  KU1 as PhChat,
  XU1 as PhChatCentered,
  JU1 as PhChatCenteredDots,
  QU1 as PhChatCenteredText,
  YU1 as PhChatCircle,
  oq1 as PhChatCircleDots,
  eq1 as PhChatCircleText,
  tq1 as PhChatDots,
  nq1 as PhChatTeardrop,
  sq1 as PhChatTeardropDots,
  rq1 as PhChatTeardropText,
  iq1 as PhChatText,
  lq1 as PhChats,
  dq1 as PhChatsCircle,
  kq1 as PhChatsTeardrop,
  cq1 as PhCheck,
  hq1 as PhCheckCircle,
  uq1 as PhCheckSquare,
  aq1 as PhCheckSquareOffset,
  _q1 as PhChecks,
  pq1 as PhCircle,
  yq1 as PhCircleDashed,
  $q1 as PhCircleHalf,
  wq1 as PhCircleHalfTilt,
  fq1 as PhCircleNotch,
  gq1 as PhCircleWavy,
  xq1 as PhCircleWavyCheck,
  jq1 as PhCircleWavyQuestion,
  mq1 as PhCircleWavyWarning,
  Mq1 as PhCirclesFour,
  vq1 as PhCirclesThree,
  Sq1 as PhCirclesThreePlus,
  Hq1 as PhClipboard,
  Aq1 as PhClipboardText,
  Vq1 as PhClock,
  zq1 as PhClockAfternoon,
  Zq1 as PhClockClockwise,
  Cq1 as PhClockCounterClockwise,
  bq1 as PhClosedCaptioning,
  Lq1 as PhCloud,
  Bq1 as PhCloudArrowDown,
  Pq1 as PhCloudArrowUp,
  Wq1 as PhCloudCheck,
  Nq1 as PhCloudFog,
  Fq1 as PhCloudLightning,
  Tq1 as PhCloudMoon,
  Dq1 as PhCloudRain,
  Rq1 as PhCloudSlash,
  Uq1 as PhCloudSnow,
  qq1 as PhCloudSun,
  Gq1 as PhClub,
  Eq1 as PhCoatHanger,
  Oq1 as PhCode,
  Iq1 as PhCodeSimple,
  Kq1 as PhCodepenLogo,
  Xq1 as PhCodesandboxLogo,
  Jq1 as PhCoffee,
  Qq1 as PhCoin,
  Yq1 as PhCoinVertical,
  oG1 as PhCoins,
  eG1 as PhColumns,
  tG1 as PhCommand,
  nG1 as PhCompass,
  sG1 as PhComputerTower,
  rG1 as PhConfetti,
  iG1 as PhCookie,
  lG1 as PhCookingPot,
  dG1 as PhCopy,
  kG1 as PhCopySimple,
  cG1 as PhCopyleft,
  hG1 as PhCopyright,
  uG1 as PhCornersIn,
  aG1 as PhCornersOut,
  _G1 as PhCpu,
  pG1 as PhCreditCard,
  yG1 as PhCrop,
  $G1 as PhCrosshair,
  wG1 as PhCrosshairSimple,
  fG1 as PhCrown,
  gG1 as PhCrownSimple,
  xG1 as PhCube,
  jG1 as PhCurrencyBtc,
  mG1 as PhCurrencyCircleDollar,
  MG1 as PhCurrencyCny,
  vG1 as PhCurrencyDollar,
  SG1 as PhCurrencyDollarSimple,
  HG1 as PhCurrencyEth,
  AG1 as PhCurrencyEur,
  VG1 as PhCurrencyGbp,
  zG1 as PhCurrencyInr,
  ZG1 as PhCurrencyJpy,
  CG1 as PhCurrencyKrw,
  bG1 as PhCurrencyKzt,
  LG1 as PhCurrencyNgn,
  BG1 as PhCurrencyRub,
  PG1 as PhCursor,
  WG1 as PhCursorText,
  NG1 as PhCylinder,
  FG1 as PhDatabase,
  TG1 as PhDesktop,
  DG1 as PhDesktopTower,
  RG1 as PhDetective,
  UG1 as PhDeviceMobile,
  qG1 as PhDeviceMobileCamera,
  GG1 as PhDeviceMobileSpeaker,
  EG1 as PhDeviceTablet,
  OG1 as PhDeviceTabletCamera,
  IG1 as PhDeviceTabletSpeaker,
  KG1 as PhDiamond,
  XG1 as PhDiamondsFour,
  JG1 as PhDiceFive,
  QG1 as PhDiceFour,
  YG1 as PhDiceOne,
  oE1 as PhDiceSix,
  eE1 as PhDiceThree,
  tE1 as PhDiceTwo,
  nE1 as PhDisc,
  sE1 as PhDiscordLogo,
  rE1 as PhDivide,
  iE1 as PhDog,
  lE1 as PhDoor,
  dE1 as PhDotsNine,
  kE1 as PhDotsSix,
  cE1 as PhDotsSixVertical,
  hE1 as PhDotsThree,
  uE1 as PhDotsThreeCircle,
  aE1 as PhDotsThreeCircleVertical,
  _E1 as PhDotsThreeOutline,
  pE1 as PhDotsThreeOutlineVertical,
  yE1 as PhDotsThreeVertical,
  $E1 as PhDownload,
  wE1 as PhDownloadSimple,
  fE1 as PhDribbbleLogo,
  gE1 as PhDrop,
  xE1 as PhDropHalf,
  jE1 as PhDropHalfBottom,
  mE1 as PhEar,
  ME1 as PhEarSlash,
  vE1 as PhEgg,
  SE1 as PhEggCrack,
  HE1 as PhEject,
  AE1 as PhEjectSimple,
  VE1 as PhEnvelope,
  zE1 as PhEnvelopeOpen,
  ZE1 as PhEnvelopeSimple,
  CE1 as PhEnvelopeSimpleOpen,
  bE1 as PhEqualizer,
  LE1 as PhEquals,
  BE1 as PhEraser,
  PE1 as PhExam,
  WE1 as PhExport,
  NE1 as PhEye,
  FE1 as PhEyeClosed,
  TE1 as PhEyeSlash,
  DE1 as PhEyedropper,
  RE1 as PhEyedropperSample,
  UE1 as PhEyeglasses,
  qE1 as PhFaceMask,
  GE1 as PhFacebookLogo,
  EE1 as PhFactory,
  OE1 as PhFaders,
  IE1 as PhFadersHorizontal,
  KE1 as PhFastForward,
  XE1 as PhFastForwardCircle,
  JE1 as PhFigmaLogo,
  QE1 as PhFile,
  YE1 as PhFileArrowDown,
  oO1 as PhFileArrowUp,
  eO1 as PhFileAudio,
  tO1 as PhFileCloud,
  nO1 as PhFileCode,
  sO1 as PhFileCss,
  rO1 as PhFileCsv,
  iO1 as PhFileDoc,
  lO1 as PhFileDotted,
  dO1 as PhFileHtml,
  kO1 as PhFileImage,
  cO1 as PhFileJpg,
  hO1 as PhFileJs,
  uO1 as PhFileJsx,
  aO1 as PhFileLock,
  _O1 as PhFileMinus,
  pO1 as PhFilePdf,
  yO1 as PhFilePlus,
  $O1 as PhFilePng,
  wO1 as PhFilePpt,
  fO1 as PhFileRs,
  gO1 as PhFileSearch,
  xO1 as PhFileText,
  jO1 as PhFileTs,
  mO1 as PhFileTsx,
  MO1 as PhFileVideo,
  vO1 as PhFileVue,
  SO1 as PhFileX,
  HO1 as PhFileXls,
  AO1 as PhFileZip,
  VO1 as PhFiles,
  zO1 as PhFilmScript,
  ZO1 as PhFilmSlate,
  CO1 as PhFilmStrip,
  bO1 as PhFingerprint,
  LO1 as PhFingerprintSimple,
  BO1 as PhFinnTheHuman,
  PO1 as PhFire,
  WO1 as PhFireSimple,
  NO1 as PhFirstAid,
  FO1 as PhFirstAidKit,
  TO1 as PhFish,
  DO1 as PhFishSimple,
  RO1 as PhFlag,
  UO1 as PhFlagBanner,
  qO1 as PhFlagCheckered,
  GO1 as PhFlame,
  EO1 as PhFlashlight,
  OO1 as PhFlask,
  IO1 as PhFloppyDisk,
  KO1 as PhFloppyDiskBack,
  XO1 as PhFlowArrow,
  JO1 as PhFlower,
  QO1 as PhFlowerLotus,
  YO1 as PhFlyingSaucer,
  oI1 as PhFolder,
  eI1 as PhFolderDotted,
  tI1 as PhFolderLock,
  nI1 as PhFolderMinus,
  sI1 as PhFolderNotch,
  rI1 as PhFolderNotchMinus,
  iI1 as PhFolderNotchOpen,
  lI1 as PhFolderNotchPlus,
  dI1 as PhFolderOpen,
  kI1 as PhFolderPlus,
  cI1 as PhFolderSimple,
  hI1 as PhFolderSimpleDotted,
  uI1 as PhFolderSimpleLock,
  aI1 as PhFolderSimpleMinus,
  _I1 as PhFolderSimplePlus,
  pI1 as PhFolderSimpleStar,
  yI1 as PhFolderSimpleUser,
  $I1 as PhFolderStar,
  wI1 as PhFolderUser,
  fI1 as PhFolders,
  gI1 as PhFootball,
  xI1 as PhForkKnife,
  jI1 as PhFrameCorners,
  mI1 as PhFramerLogo,
  MI1 as PhFunction,
  vI1 as PhFunnel,
  SI1 as PhFunnelSimple,
  HI1 as PhGameController,
  AI1 as PhGasPump,
  VI1 as PhGauge,
  zI1 as PhGear,
  ZI1 as PhGearSix,
  CI1 as PhGenderFemale,
  bI1 as PhGenderIntersex,
  LI1 as PhGenderMale,
  BI1 as PhGenderNeuter,
  PI1 as PhGenderNonbinary,
  WI1 as PhGenderTransgender,
  NI1 as PhGhost,
  FI1 as PhGif,
  TI1 as PhGift,
  DI1 as PhGitBranch,
  RI1 as PhGitCommit,
  UI1 as PhGitDiff,
  qI1 as PhGitFork,
  GI1 as PhGitMerge,
  EI1 as PhGitPullRequest,
  OI1 as PhGithubLogo,
  II1 as PhGitlabLogo,
  KI1 as PhGitlabLogoSimple,
  XI1 as PhGlobe,
  JI1 as PhGlobeHemisphereEast,
  QI1 as PhGlobeHemisphereWest,
  YI1 as PhGlobeSimple,
  oK1 as PhGlobeStand,
  eK1 as PhGoogleChromeLogo,
  tK1 as PhGoogleLogo,
  nK1 as PhGooglePhotosLogo,
  sK1 as PhGooglePlayLogo,
  rK1 as PhGooglePodcastsLogo,
  iK1 as PhGradient,
  lK1 as PhGraduationCap,
  dK1 as PhGraph,
  kK1 as PhGridFour,
  cK1 as PhHamburger,
  hK1 as PhHand,
  uK1 as PhHandEye,
  aK1 as PhHandFist,
  _K1 as PhHandGrabbing,
  pK1 as PhHandPalm,
  yK1 as PhHandPointing,
  $K1 as PhHandSoap,
  wK1 as PhHandWaving,
  fK1 as PhHandbag,
  gK1 as PhHandbagSimple,
  xK1 as PhHandsClapping,
  jK1 as PhHandshake,
  mK1 as PhHardDrive,
  MK1 as PhHardDrives,
  vK1 as PhHash,
  SK1 as PhHashStraight,
  HK1 as PhHeadlights,
  AK1 as PhHeadphones,
  VK1 as PhHeadset,
  zK1 as PhHeart,
  ZK1 as PhHeartBreak,
  CK1 as PhHeartStraight,
  bK1 as PhHeartStraightBreak,
  LK1 as PhHeartbeat,
  BK1 as PhHexagon,
  PK1 as PhHighlighterCircle,
  WK1 as PhHorse,
  NK1 as PhHourglass,
  FK1 as PhHourglassHigh,
  TK1 as PhHourglassLow,
  DK1 as PhHourglassMedium,
  RK1 as PhHourglassSimple,
  UK1 as PhHourglassSimpleHigh,
  qK1 as PhHourglassSimpleLow,
  GK1 as PhHourglassSimpleMedium,
  EK1 as PhHouse,
  OK1 as PhHouseLine,
  IK1 as PhHouseSimple,
  KK1 as PhIdentificationBadge,
  XK1 as PhIdentificationCard,
  JK1 as PhImage,
  QK1 as PhImageSquare,
  YK1 as PhInfinity,
  oX1 as PhInfo,
  eX1 as PhInstagramLogo,
  tX1 as PhIntersect,
  nX1 as PhJeep,
  sX1 as PhKanban,
  rX1 as PhKey,
  iX1 as PhKeyReturn,
  lX1 as PhKeyboard,
  dX1 as PhKeyhole,
  kX1 as PhKnife,
  cX1 as PhLadder,
  hX1 as PhLadderSimple,
  uX1 as PhLamp,
  aX1 as PhLaptop,
  _X1 as PhLayout,
  pX1 as PhLeaf,
  yX1 as PhLifebuoy,
  $X1 as PhLightbulb,
  wX1 as PhLightbulbFilament,
  fX1 as PhLightning,
  gX1 as PhLightningSlash,
  xX1 as PhLineSegment,
  jX1 as PhLineSegments,
  mX1 as PhLink,
  MX1 as PhLinkBreak,
  vX1 as PhLinkSimple,
  SX1 as PhLinkSimpleBreak,
  HX1 as PhLinkSimpleHorizontal,
  AX1 as PhLinkSimpleHorizontalBreak,
  VX1 as PhLinkedinLogo,
  zX1 as PhLinuxLogo,
  ZX1 as PhList,
  CX1 as PhListBullets,
  bX1 as PhListChecks,
  LX1 as PhListDashes,
  BX1 as PhListNumbers,
  PX1 as PhListPlus,
  WX1 as PhLock,
  NX1 as PhLockKey,
  FX1 as PhLockKeyOpen,
  TX1 as PhLockLaminated,
  DX1 as PhLockLaminatedOpen,
  RX1 as PhLockOpen,
  UX1 as PhLockSimple,
  qX1 as PhLockSimpleOpen,
  GX1 as PhMagicWand,
  EX1 as PhMagnet,
  OX1 as PhMagnetStraight,
  IX1 as PhMagnifyingGlass,
  KX1 as PhMagnifyingGlassMinus,
  XX1 as PhMagnifyingGlassPlus,
  JX1 as PhMapPin,
  QX1 as PhMapPinLine,
  YX1 as PhMapTrifold,
  oJ1 as PhMarkerCircle,
  eJ1 as PhMartini,
  tJ1 as PhMaskHappy,
  nJ1 as PhMaskSad,
  sJ1 as PhMathOperations,
  rJ1 as PhMedal,
  iJ1 as PhMediumLogo,
  lJ1 as PhMegaphone,
  dJ1 as PhMegaphoneSimple,
  kJ1 as PhMessengerLogo,
  cJ1 as PhMicrophone,
  hJ1 as PhMicrophoneSlash,
  uJ1 as PhMicrophoneStage,
  aJ1 as PhMicrosoftExcelLogo,
  _J1 as PhMicrosoftPowerpointLogo,
  pJ1 as PhMicrosoftTeamsLogo,
  yJ1 as PhMicrosoftWordLogo,
  $J1 as PhMinus,
  wJ1 as PhMinusCircle,
  fJ1 as PhMoney,
  gJ1 as PhMonitor,
  xJ1 as PhMonitorPlay,
  jJ1 as PhMoon,
  mJ1 as PhMoonStars,
  MJ1 as PhMountains,
  vJ1 as PhMouse,
  SJ1 as PhMouseSimple,
  HJ1 as PhMusicNote,
  AJ1 as PhMusicNoteSimple,
  VJ1 as PhMusicNotes,
  zJ1 as PhMusicNotesPlus,
  ZJ1 as PhMusicNotesSimple,
  CJ1 as PhNavigationArrow,
  bJ1 as PhNeedle,
  LJ1 as PhNewspaper,
  BJ1 as PhNewspaperClipping,
  PJ1 as PhNote,
  WJ1 as PhNoteBlank,
  NJ1 as PhNotePencil,
  FJ1 as PhNotebook,
  TJ1 as PhNotepad,
  DJ1 as PhNotification,
  RJ1 as PhNumberCircleEight,
  UJ1 as PhNumberCircleFive,
  qJ1 as PhNumberCircleFour,
  GJ1 as PhNumberCircleNine,
  EJ1 as PhNumberCircleOne,
  OJ1 as PhNumberCircleSeven,
  IJ1 as PhNumberCircleSix,
  KJ1 as PhNumberCircleThree,
  XJ1 as PhNumberCircleTwo,
  JJ1 as PhNumberCircleZero,
  QJ1 as PhNumberEight,
  YJ1 as PhNumberFive,
  oQ1 as PhNumberFour,
  eQ1 as PhNumberNine,
  tQ1 as PhNumberOne,
  nQ1 as PhNumberSeven,
  sQ1 as PhNumberSix,
  rQ1 as PhNumberSquareEight,
  iQ1 as PhNumberSquareFive,
  lQ1 as PhNumberSquareFour,
  dQ1 as PhNumberSquareNine,
  kQ1 as PhNumberSquareOne,
  cQ1 as PhNumberSquareSeven,
  hQ1 as PhNumberSquareSix,
  uQ1 as PhNumberSquareThree,
  aQ1 as PhNumberSquareTwo,
  _Q1 as PhNumberSquareZero,
  pQ1 as PhNumberThree,
  yQ1 as PhNumberTwo,
  $Q1 as PhNumberZero,
  wQ1 as PhNut,
  fQ1 as PhNyTimesLogo,
  gQ1 as PhOctagon,
  xQ1 as PhOption,
  jQ1 as PhPackage,
  mQ1 as PhPaintBrush,
  MQ1 as PhPaintBrushBroad,
  vQ1 as PhPaintBrushHousehold,
  SQ1 as PhPaintBucket,
  HQ1 as PhPaintRoller,
  AQ1 as PhPalette,
  VQ1 as PhPaperPlane,
  zQ1 as PhPaperPlaneRight,
  ZQ1 as PhPaperPlaneTilt,
  CQ1 as PhPaperclip,
  bQ1 as PhPaperclipHorizontal,
  LQ1 as PhParachute,
  BQ1 as PhPassword,
  PQ1 as PhPath,
  WQ1 as PhPause,
  NQ1 as PhPauseCircle,
  FQ1 as PhPawPrint,
  TQ1 as PhPeace,
  DQ1 as PhPen,
  RQ1 as PhPenNib,
  UQ1 as PhPenNibStraight,
  qQ1 as PhPencil,
  GQ1 as PhPencilCircle,
  EQ1 as PhPencilLine,
  OQ1 as PhPencilSimple,
  IQ1 as PhPencilSimpleLine,
  KQ1 as PhPercent,
  XQ1 as PhPerson,
  JQ1 as PhPersonSimple,
  QQ1 as PhPersonSimpleRun,
  YQ1 as PhPersonSimpleWalk,
  oY1 as PhPerspective,
  eY1 as PhPhone,
  tY1 as PhPhoneCall,
  nY1 as PhPhoneDisconnect,
  sY1 as PhPhoneIncoming,
  rY1 as PhPhoneOutgoing,
  iY1 as PhPhoneSlash,
  lY1 as PhPhoneX,
  dY1 as PhPhosphorLogo,
  kY1 as PhPianoKeys,
  cY1 as PhPictureInPicture,
  hY1 as PhPill,
  uY1 as PhPinterestLogo,
  aY1 as PhPinwheel,
  _Y1 as PhPizza,
  pY1 as PhPlaceholder,
  yY1 as PhPlanet,
  $Y1 as PhPlay,
  wY1 as PhPlayCircle,
  fY1 as PhPlaylist,
  gY1 as PhPlug,
  xY1 as PhPlugs,
  jY1 as PhPlugsConnected,
  mY1 as PhPlus,
  MY1 as PhPlusCircle,
  vY1 as PhPlusMinus,
  SY1 as PhPokerChip,
  HY1 as PhPoliceCar,
  AY1 as PhPolygon,
  VY1 as PhPopcorn,
  zY1 as PhPower,
  ZY1 as PhPrescription,
  CY1 as PhPresentation,
  bY1 as PhPresentationChart,
  LY1 as PhPrinter,
  BY1 as PhProhibit,
  PY1 as PhProhibitInset,
  WY1 as PhProjectorScreen,
  NY1 as PhProjectorScreenChart,
  FY1 as PhPushPin,
  TY1 as PhPushPinSimple,
  DY1 as PhPushPinSimpleSlash,
  RY1 as PhPushPinSlash,
  UY1 as PhPuzzlePiece,
  qY1 as PhQrCode,
  GY1 as PhQuestion,
  EY1 as PhQueue,
  OY1 as PhQuotes,
  IY1 as PhRadical,
  KY1 as PhRadio,
  XY1 as PhRadioButton,
  JY1 as PhRainbow,
  QY1 as PhRainbowCloud,
  YY1 as PhReceipt,
  ool as PhRecord,
  eol as PhRectangle,
  tol as PhRecycle,
  nol as PhRedditLogo,
  sol as PhRepeat,
  rol as PhRepeatOnce,
  iol as PhRewind,
  lol as PhRewindCircle,
  dol as PhRobot,
  kol as PhRocket,
  col as PhRocketLaunch,
  hol as PhRows,
  uol as PhRss,
  aol as PhRssSimple,
  _ol as PhRug,
  pol as PhRuler,
  yol as PhScales,
  $ol as PhScan,
  wol as PhScissors,
  fol as PhScreencast,
  gol as PhScribbleLoop,
  xol as PhScroll,
  jol as PhSelection,
  mol as PhSelectionAll,
  Mol as PhSelectionBackground,
  vol as PhSelectionForeground,
  Sol as PhSelectionInverse,
  Hol as PhSelectionPlus,
  Aol as PhSelectionSlash,
  Vol as PhShare,
  zol as PhShareNetwork,
  Zol as PhShield,
  Col as PhShieldCheck,
  bol as PhShieldCheckered,
  Lol as PhShieldChevron,
  Bol as PhShieldPlus,
  Pol as PhShieldSlash,
  Wol as PhShieldStar,
  Nol as PhShieldWarning,
  Fol as PhShoppingBag,
  Tol as PhShoppingBagOpen,
  Dol as PhShoppingCart,
  Rol as PhShoppingCartSimple,
  Uol as PhShower,
  qol as PhShuffle,
  Gol as PhShuffleAngular,
  Eol as PhShuffleSimple,
  Ool as PhSidebar,
  Iol as PhSidebarSimple,
  Kol as PhSignIn,
  Xol as PhSignOut,
  Jol as PhSignpost,
  Qol as PhSimCard,
  Yol as PhSketchLogo,
  oel as PhSkipBack,
  eel as PhSkipBackCircle,
  tel as PhSkipForward,
  nel as PhSkipForwardCircle,
  sel as PhSkull,
  rel as PhSlackLogo,
  iel as PhSliders,
  lel as PhSlidersHorizontal,
  del as PhSmiley,
  kel as PhSmileyBlank,
  cel as PhSmileyMeh,
  hel as PhSmileyNervous,
  uel as PhSmileySad,
  ael as PhSmileySticker,
  _el as PhSmileyWink,
  pel as PhSmileyXEyes,
  yel as PhSnapchatLogo,
  $el as PhSnowflake,
  wel as PhSoccerBall,
  fel as PhSortAscending,
  gel as PhSortDescending,
  xel as PhSpade,
  jel as PhSparkle,
  mel as PhSpeakerHigh,
  Mel as PhSpeakerLow,
  vel as PhSpeakerNone,
  Sel as PhSpeakerSimpleHigh,
  Hel as PhSpeakerSimpleLow,
  Ael as PhSpeakerSimpleNone,
  Vel as PhSpeakerSimpleSlash,
  zel as PhSpeakerSimpleX,
  Zel as PhSpeakerSlash,
  Cel as PhSpeakerX,
  bel as PhSpinner,
  Lel as PhSpinnerGap,
  Bel as PhSpiral,
  Pel as PhSpotifyLogo,
  Wel as PhSquare,
  Nel as PhSquareHalf,
  Fel as PhSquareHalfBottom,
  Tel as PhSquareLogo,
  Del as PhSquaresFour,
  Rel as PhStack,
  Uel as PhStackOverflowLogo,
  qel as PhStackSimple,
  Gel as PhStamp,
  Eel as PhStar,
  Oel as PhStarFour,
  Iel as PhStarHalf,
  Kel as PhSticker,
  Xel as PhStop,
  Jel as PhStopCircle,
  Qel as PhStorefront,
  Yel as PhStrategy,
  otl as PhStripeLogo,
  etl as PhStudent,
  ttl as PhSuitcase,
  ntl as PhSuitcaseSimple,
  stl as PhSun,
  rtl as PhSunDim,
  itl as PhSunHorizon,
  ltl as PhSunglasses,
  dtl as PhSwap,
  ktl as PhSwatches,
  ctl as PhSword,
  htl as PhSyringe,
  utl as PhTShirt,
  atl as PhTable,
  _tl as PhTabs,
  ptl as PhTag,
  ytl as PhTagChevron,
  $tl as PhTagSimple,
  wtl as PhTarget,
  ftl as PhTaxi,
  gtl as PhTelegramLogo,
  xtl as PhTelevision,
  jtl as PhTelevisionSimple,
  mtl as PhTennisBall,
  Mtl as PhTerminal,
  vtl as PhTerminalWindow,
  Stl as PhTestTube,
  Htl as PhTextAa,
  Atl as PhTextAlignCenter,
  Vtl as PhTextAlignJustify,
  ztl as PhTextAlignLeft,
  Ztl as PhTextAlignRight,
  Ctl as PhTextBolder,
  btl as PhTextH,
  Ltl as PhTextHFive,
  Btl as PhTextHFour,
  Ptl as PhTextHOne,
  Wtl as PhTextHSix,
  Ntl as PhTextHThree,
  Ftl as PhTextHTwo,
  Ttl as PhTextIndent,
  Dtl as PhTextItalic,
  Rtl as PhTextOutdent,
  Utl as PhTextStrikethrough,
  qtl as PhTextT,
  Gtl as PhTextUnderline,
  Etl as PhTextbox,
  Otl as PhThermometer,
  Itl as PhThermometerCold,
  Ktl as PhThermometerHot,
  Xtl as PhThermometerSimple,
  Jtl as PhThumbsDown,
  Qtl as PhThumbsUp,
  Ytl as PhTicket,
  onl as PhTiktokLogo,
  enl as PhTimer,
  tnl as PhToggleLeft,
  nnl as PhToggleRight,
  snl as PhToilet,
  rnl as PhToiletPaper,
  inl as PhTote,
  lnl as PhToteSimple,
  dnl as PhTrademarkRegistered,
  knl as PhTrafficCone,
  cnl as PhTrafficSign,
  hnl as PhTrafficSignal,
  unl as PhTrain,
  anl as PhTrainRegional,
  _nl as PhTrainSimple,
  pnl as PhTranslate,
  ynl as PhTrash,
  $nl as PhTrashSimple,
  wnl as PhTray,
  fnl as PhTree,
  gnl as PhTreeEvergreen,
  xnl as PhTreeStructure,
  jnl as PhTrendDown,
  mnl as PhTrendUp,
  Mnl as PhTriangle,
  vnl as PhTrophy,
  Snl as PhTruck,
  Hnl as PhTwitchLogo,
  Anl as PhTwitterLogo,
  Vnl as PhUmbrella,
  znl as PhUmbrellaSimple,
  Znl as PhUpload,
  Cnl as PhUploadSimple,
  bnl as PhUser,
  Lnl as PhUserCircle,
  Bnl as PhUserCircleGear,
  Pnl as PhUserCircleMinus,
  Wnl as PhUserCirclePlus,
  Nnl as PhUserFocus,
  Fnl as PhUserGear,
  Tnl as PhUserList,
  Dnl as PhUserMinus,
  Rnl as PhUserPlus,
  Unl as PhUserRectangle,
  qnl as PhUserSquare,
  Gnl as PhUserSwitch,
  Enl as PhUsers,
  Onl as PhUsersFour,
  Inl as PhUsersThree,
  Knl as PhVault,
  Xnl as PhVibrate,
  Jnl as PhVideoCamera,
  Qnl as PhVideoCameraSlash,
  Ynl as PhVignette,
  osl as PhVoicemail,
  esl as PhVolleyball,
  tsl as PhWall,
  nsl as PhWallet,
  ssl as PhWarning,
  rsl as PhWarningCircle,
  isl as PhWarningOctagon,
  lsl as PhWatch,
  dsl as PhWaveSawtooth,
  ksl as PhWaveSine,
  csl as PhWaveSquare,
  hsl as PhWaveTriangle,
  usl as PhWaves,
  asl as PhWebcam,
  _sl as PhWhatsappLogo,
  psl as PhWheelchair,
  ysl as PhWifiHigh,
  $sl as PhWifiLow,
  wsl as PhWifiMedium,
  fsl as PhWifiNone,
  gsl as PhWifiSlash,
  xsl as PhWifiX,
  jsl as PhWind,
  msl as PhWindowsLogo,
  Msl as PhWine,
  vsl as PhWrench,
  Ssl as PhX,
  Hsl as PhXCircle,
  Asl as PhXSquare,
  Vsl as PhYinYang,
  zsl as PhYoutubeLogo
};
